/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core"
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  BigInt: { input: any; output: any }
  _text: { input: any; output: any }
  account_event_status: { input: any; output: any }
  account_group_enum: { input: any; output: any }
  account_state: { input: any; output: any }
  account_sub_group_enum: { input: any; output: any }
  agreement_type: { input: any; output: any }
  asset_type: { input: any; output: any }
  automation_default_record_status_enum: { input: any; output: any }
  automation_job_email_status: { input: any; output: any }
  automation_status_enum: { input: any; output: any }
  bigint: { input: any; output: any }
  bill_delivery_method: { input: any; output: any }
  bill_status: { input: any; output: any }
  billing_account_class: { input: any; output: any }
  billing_account_transaction_status: { input: any; output: any }
  billing_account_transaction_type: { input: any; output: any }
  billing_account_type: { input: any; output: any }
  billing_cycle: { input: any; output: any }
  billing_period_status: { input: any; output: any }
  bytea: { input: any; output: any }
  calculation_item_product_type: { input: any; output: any }
  calculation_item_rate_type: { input: any; output: any }
  calculation_type_enum: { input: any; output: any }
  call_trace_audit_confirmed_enum: { input: any; output: any }
  call_trace_audit_gdpr_enum: { input: any; output: any }
  cancellation_origin: { input: any; output: any }
  cancellation_type: { input: any; output: any }
  card_payment_status: { input: any; output: any }
  communication_type: { input: any; output: any }
  configuration_name: { input: any; output: any }
  contact_type: { input: any; output: any }
  created_from_type: { input: any; output: any }
  credit_check_status: { input: any; output: any }
  customer_class: { input: any; output: any }
  customer_type: { input: any; output: any }
  date: { input: any; output: any }
  datetime: { input: any; output: any }
  dcc_service_status: { input: any; output: any }
  direct_debit_status: { input: any; output: any }
  dunning_addacs_review_status: { input: any; output: any }
  dunning_automation_events_status: { input: any; output: any }
  dunning_debt_ticket_review_status: { input: any; output: any }
  dunning_job_email_status: { input: any; output: any }
  dunning_job_statistic_type: { input: any; output: any }
  dunning_legal_known_review_status: { input: any; output: any }
  dunning_legal_occupier_review_status: { input: any; output: any }
  dunning_occupier_accounts_review_status: { input: any; output: any }
  dunning_purge_status_enum: { input: any; output: any }
  dunning_standard_review_status: { input: any; output: any }
  dunning_status_enum: { input: any; output: any }
  dunning_terminating_accounts_review_status: { input: any; output: any }
  dunning_workflow_type_enum: { input: any; output: any }
  email_status_enum: { input: any; output: any }
  email_template_ext_sender: { input: any; output: any }
  energy_source_type: { input: any; output: any }
  enrolment_broker: { input: any; output: any }
  enrolment_type: { input: any; output: any }
  estimated_rate_name: { input: any; output: any }
  estimated_usage_type: { input: any; output: any }
  ev_tariff_eligibility_check_channel: { input: any; output: any }
  ev_tariff_ineligibility_reason: { input: any; output: any }
  ev_type: { input: any; output: any }
  event_type: { input: any; output: any }
  feature_name: { input: any; output: any }
  flex_market_subscription_billing_component_category: {
    input: any
    output: any
  }
  flex_market_subscription_billing_component_status: { input: any; output: any }
  flex_market_subscription_billing_component_type: { input: any; output: any }
  flex_market_subscription_billing_status: { input: any; output: any }
  frequency: { input: any; output: any }
  future_start_date_requested_status: { input: any; output: any }
  json: { input: any; output: any }
  jsonb: { input: any; output: any }
  junifer_payment_status: { input: any; output: any }
  leaving_type: { input: any; output: any }
  match_level: { input: any; output: any }
  meter_point_event_type: { input: any; output: any }
  meter_point_measurement_type: { input: any; output: any }
  meter_point_supply_status: { input: any; output: any }
  meter_point_type: { input: any; output: any }
  meter_reading_fuel: { input: any; output: any }
  meter_reading_quality: { input: any; output: any }
  meter_reading_sequence_type: { input: any; output: any }
  meter_reading_source: { input: any; output: any }
  meter_reading_status: { input: any; output: any }
  meter_reading_submission_request_status: { input: any; output: any }
  meter_reading_submission_source: { input: any; output: any }
  meter_reading_unit: { input: any; output: any }
  meter_reading_workflow_status: { input: any; output: any }
  meter_type: { input: any; output: any }
  notes_status_enum: { input: any; output: any }
  numeric: { input: any; output: any }
  occupier_status: { input: any; output: any }
  operation_type: { input: any; output: any }
  outbound_photo_request_status: { input: any; output: any }
  package: { input: any; output: any }
  payment_method_default_status: { input: any; output: any }
  payment_method_status: { input: any; output: any }
  payment_method_type: { input: any; output: any }
  payment_notification_status: { input: any; output: any }
  payment_request_type: { input: any; output: any }
  payment_review_calculation_payment_spread: { input: any; output: any }
  payment_review_datasource: { input: any; output: any }
  payment_review_record_payment_frequency: { input: any; output: any }
  payment_review_record_payment_spread: { input: any; output: any }
  payment_review_record_status: { input: any; output: any }
  payment_reviews_type_enum: { input: any; output: any }
  payment_schedule_frequency: { input: any; output: any }
  payment_schedule_status: { input: any; output: any }
  payment_status: { input: any; output: any }
  price_unit: { input: any; output: any }
  product_account_type: { input: any; output: any }
  product_type: { input: any; output: any }
  product_variant_rate_type: { input: any; output: any }
  product_variant_type: { input: any; output: any }
  property_type: { input: any; output: any }
  quote_request_type: { input: any; output: any }
  referral_status: { input: any; output: any }
  refund_status: { input: any; output: any }
  refund_type: { input: any; output: any }
  reminder_frequency: { input: any; output: any }
  reminder_type: { input: any; output: any }
  smallint: { input: any; output: any }
  squad: { input: any; output: any }
  ticket_creation_status: { input: any; output: any }
  time_at_property: { input: any; output: any }
  time_frame: { input: any; output: any }
  timestamp: { input: any; output: any }
  timestamptz: { input: any; output: any }
  title: { input: any; output: any }
  uk_profile_class: { input: any; output: any }
  uswitch_record_status: { input: any; output: any }
  uuid: { input: any; output: any }
  warm_home_discount_application_status: { input: any; output: any }
  warm_home_discount_criteria_type: { input: any; output: any }
  warrant_communication_delivery_status: { input: any; output: any }
  warrant_communication_group_status: { input: any; output: any }
  warrant_communication_type: { input: any; output: any }
  warrants_account_history_status: { input: any; output: any }
  warrants_account_state: { input: any; output: any }
  warrants_dca_tickets_status: { input: any; output: any }
  warrants_dca_type: { input: any; output: any }
  warrants_files_account_status: { input: any; output: any }
  warrants_files_dca_type: { input: any; output: any }
  warrants_files_job_status: { input: any; output: any }
  warrants_files_type: { input: any; output: any }
  warrants_job_status: { input: any; output: any }
  warrants_ticket_type: { input: any; output: any }
  warrants_visit_type: { input: any; output: any }
}

export type AccountsForAuditResponse = {
  __typename?: "AccountsForAuditResponse"
  errors?: Maybe<Array<Maybe<WhdError>>>
  successful_account_numbers?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
}

export type AddCoreGroupVulnerabilityResponse = {
  __typename?: "AddCoreGroupVulnerabilityResponse"
  errors?: Maybe<Array<Maybe<WhdError>>>
  successful_account_numbers?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
}

export type ApplyCreditResponse = {
  __typename?: "ApplyCreditResponse"
  errors?: Maybe<Array<Maybe<WhdError>>>
  successful_account_numbers?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
}

export type ArkStatusHistory = {
  __typename?: "ArkStatusHistory"
  ark_status: Scalars["String"]["output"]
  created_at: Scalars["date"]["output"]
}

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["Boolean"]["input"]>
  _gt?: InputMaybe<Scalars["Boolean"]["input"]>
  _gte?: InputMaybe<Scalars["Boolean"]["input"]>
  _in?: InputMaybe<Array<Scalars["Boolean"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["Boolean"]["input"]>
  _lte?: InputMaybe<Scalars["Boolean"]["input"]>
  _neq?: InputMaybe<Scalars["Boolean"]["input"]>
  _nin?: InputMaybe<Array<Scalars["Boolean"]["input"]>>
}

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["Boolean"]["input"]>
  _gt?: InputMaybe<Scalars["Boolean"]["input"]>
  _gte?: InputMaybe<Scalars["Boolean"]["input"]>
  _in?: InputMaybe<Array<Scalars["Boolean"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["Boolean"]["input"]>
  _lte?: InputMaybe<Scalars["Boolean"]["input"]>
  _neq?: InputMaybe<Scalars["Boolean"]["input"]>
  _nin?: InputMaybe<Array<Scalars["Boolean"]["input"]>>
}

export type ChangeOfTenancyRequestDtoInput = {
  accountId?: InputMaybe<Scalars["String"]["input"]>
  accountNumber: Scalars["String"]["input"]
  addressPostcode: Scalars["String"]["input"]
  agentEmail: Scalars["String"]["input"]
  balanceTransfer: Scalars["Boolean"]["input"]
  contacts: Array<InputMaybe<ContactDetailsDtoInput>>
  date: Scalars["String"]["input"]
  directDebitInfo?: InputMaybe<DirectDebitInfoDtoInput>
  electricityProductRef?: InputMaybe<Scalars["String"]["input"]>
  forwardingAddress?: InputMaybe<ForwardingAddressDtoInput>
  forwardingContact?: InputMaybe<ContactDetailsDtoInput>
  gasProductRef?: InputMaybe<Scalars["String"]["input"]>
  occupierDetailsNotes?: InputMaybe<Scalars["String"]["input"]>
  type: ChangeOfTenancyType
}

export type ChangeOfTenancyResponseDto = {
  __typename?: "ChangeOfTenancyResponseDto"
  contacts?: Maybe<Array<Maybe<ContactDetailsDto>>>
  occupierAccountNumber?: Maybe<Scalars["String"]["output"]>
}

export enum ChangeOfTenancyType {
  ChangeOfTenancyMoveIn = "ChangeOfTenancyMoveIn",
  ChangeOfTenancyMoveOut = "ChangeOfTenancyMoveOut",
}

export type CloseNoEvidenceResponse = {
  __typename?: "CloseNoEvidenceResponse"
  errors?: Maybe<Array<Maybe<WhdError>>>
  successful_account_numbers?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
}

export type ContactDetailsDto = {
  __typename?: "ContactDetailsDto"
  email: Scalars["String"]["output"]
  forename: Scalars["String"]["output"]
  phone1: Scalars["String"]["output"]
  phone2: Scalars["String"]["output"]
  primaryContact: Scalars["Boolean"]["output"]
  receiveEmail?: Maybe<Scalars["Boolean"]["output"]>
  surname: Scalars["String"]["output"]
  title: Scalars["String"]["output"]
}

export type ContactDetailsDtoInput = {
  email: Scalars["String"]["input"]
  forename: Scalars["String"]["input"]
  phone1: Scalars["String"]["input"]
  phone2: Scalars["String"]["input"]
  primaryContact: Scalars["Boolean"]["input"]
  receiveEmail?: InputMaybe<Scalars["Boolean"]["input"]>
  surname: Scalars["String"]["input"]
  title: Scalars["String"]["input"]
}

export type CreateAccountCreditRequest = {
  accountCreditReasonName: Scalars["String"]["input"]
  accountId: Scalars["String"]["input"]
  description?: InputMaybe<Scalars["String"]["input"]>
  grossAmountInPounds: Scalars["String"]["input"]
  reference: Scalars["String"]["input"]
  salesTaxName?: InputMaybe<Scalars["String"]["input"]>
  userCreated: Scalars["String"]["input"]
}

export type CriteriaResponse = {
  __typename?: "CriteriaResponse"
  id: Scalars["Int"]["output"]
  secondary_whd_criteria?: Maybe<Array<Maybe<SecondaryCriteria>>>
  text: Scalars["String"]["output"]
}

export type CustomerDetails = {
  __typename?: "CustomerDetails"
  address: Scalars["String"]["output"]
  postcode: Scalars["String"]["output"]
}

export type DirectDebitInfoDtoInput = {
  bankAccountName: Scalars["String"]["input"]
  bankAccountNumber: Scalars["String"]["input"]
  bankAccountSortCode: Scalars["String"]["input"]
  regularPaymentAmount: Scalars["String"]["input"]
  regularPaymentDayOfMonth: Scalars["String"]["input"]
  seasonalPaymentFl: Scalars["Boolean"]["input"]
}

/** columns and relationships of "ElecNominations" */
export type ElecNominations = {
  __typename?: "ElecNominations"
  Hour_1?: Maybe<Scalars["Float"]["output"]>
  Hour_2?: Maybe<Scalars["Float"]["output"]>
  Hour_3?: Maybe<Scalars["Float"]["output"]>
  Hour_4?: Maybe<Scalars["Float"]["output"]>
  Hour_5?: Maybe<Scalars["Float"]["output"]>
  Hour_6?: Maybe<Scalars["Float"]["output"]>
  Hour_7?: Maybe<Scalars["Float"]["output"]>
  Hour_8?: Maybe<Scalars["Float"]["output"]>
  Hour_9?: Maybe<Scalars["Float"]["output"]>
  Hour_10?: Maybe<Scalars["Float"]["output"]>
  Hour_11?: Maybe<Scalars["Float"]["output"]>
  Hour_12?: Maybe<Scalars["Float"]["output"]>
  Hour_13?: Maybe<Scalars["Float"]["output"]>
  Hour_14?: Maybe<Scalars["Float"]["output"]>
  Hour_15?: Maybe<Scalars["Float"]["output"]>
  Hour_16?: Maybe<Scalars["Float"]["output"]>
  Hour_17?: Maybe<Scalars["Float"]["output"]>
  Hour_18?: Maybe<Scalars["Float"]["output"]>
  Hour_19?: Maybe<Scalars["Float"]["output"]>
  Hour_20?: Maybe<Scalars["Float"]["output"]>
  Hour_21?: Maybe<Scalars["Float"]["output"]>
  Hour_22?: Maybe<Scalars["Float"]["output"]>
  Hour_23?: Maybe<Scalars["Float"]["output"]>
  Hour_24?: Maybe<Scalars["Float"]["output"]>
  Hour_25?: Maybe<Scalars["Float"]["output"]>
  created_at?: Maybe<Scalars["datetime"]["output"]>
  date?: Maybe<Scalars["datetime"]["output"]>
  trader?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["datetime"]["output"]>
}

/** aggregated selection of "ElecNominations" */
export type ElecNominations_Aggregate = {
  __typename?: "ElecNominations_aggregate"
  aggregate?: Maybe<ElecNominations_Aggregate_Fields>
  nodes: Array<ElecNominations>
}

/** aggregate fields of "ElecNominations" */
export type ElecNominations_Aggregate_Fields = {
  __typename?: "ElecNominations_aggregate_fields"
  avg?: Maybe<ElecNominations_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<ElecNominations_Max_Fields>
  min?: Maybe<ElecNominations_Min_Fields>
  stddev?: Maybe<ElecNominations_Stddev_Fields>
  stddev_pop?: Maybe<ElecNominations_Stddev_Pop_Fields>
  stddev_samp?: Maybe<ElecNominations_Stddev_Samp_Fields>
  sum?: Maybe<ElecNominations_Sum_Fields>
  var_pop?: Maybe<ElecNominations_Var_Pop_Fields>
  var_samp?: Maybe<ElecNominations_Var_Samp_Fields>
  variance?: Maybe<ElecNominations_Variance_Fields>
}

/** aggregate fields of "ElecNominations" */
export type ElecNominations_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<ElecNominations_Select_Column>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type ElecNominations_Avg_Fields = {
  __typename?: "ElecNominations_avg_fields"
  Hour_1?: Maybe<Scalars["Float"]["output"]>
  Hour_2?: Maybe<Scalars["Float"]["output"]>
  Hour_3?: Maybe<Scalars["Float"]["output"]>
  Hour_4?: Maybe<Scalars["Float"]["output"]>
  Hour_5?: Maybe<Scalars["Float"]["output"]>
  Hour_6?: Maybe<Scalars["Float"]["output"]>
  Hour_7?: Maybe<Scalars["Float"]["output"]>
  Hour_8?: Maybe<Scalars["Float"]["output"]>
  Hour_9?: Maybe<Scalars["Float"]["output"]>
  Hour_10?: Maybe<Scalars["Float"]["output"]>
  Hour_11?: Maybe<Scalars["Float"]["output"]>
  Hour_12?: Maybe<Scalars["Float"]["output"]>
  Hour_13?: Maybe<Scalars["Float"]["output"]>
  Hour_14?: Maybe<Scalars["Float"]["output"]>
  Hour_15?: Maybe<Scalars["Float"]["output"]>
  Hour_16?: Maybe<Scalars["Float"]["output"]>
  Hour_17?: Maybe<Scalars["Float"]["output"]>
  Hour_18?: Maybe<Scalars["Float"]["output"]>
  Hour_19?: Maybe<Scalars["Float"]["output"]>
  Hour_20?: Maybe<Scalars["Float"]["output"]>
  Hour_21?: Maybe<Scalars["Float"]["output"]>
  Hour_22?: Maybe<Scalars["Float"]["output"]>
  Hour_23?: Maybe<Scalars["Float"]["output"]>
  Hour_24?: Maybe<Scalars["Float"]["output"]>
  Hour_25?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "ElecNominations". All fields are combined with a logical 'AND'. */
export type ElecNominations_Bool_Exp = {
  Hour_1?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_2?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_3?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_4?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_5?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_6?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_7?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_8?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_9?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_10?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_11?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_12?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_13?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_14?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_15?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_16?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_17?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_18?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_19?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_20?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_21?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_22?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_23?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_24?: InputMaybe<Float_Mssql_Comparison_Exp>
  Hour_25?: InputMaybe<Float_Mssql_Comparison_Exp>
  _and?: InputMaybe<Array<ElecNominations_Bool_Exp>>
  _not?: InputMaybe<ElecNominations_Bool_Exp>
  _or?: InputMaybe<Array<ElecNominations_Bool_Exp>>
  created_at?: InputMaybe<Datetime_Mssql_Comparison_Exp>
  date?: InputMaybe<Datetime_Mssql_Comparison_Exp>
  trader?: InputMaybe<String_Mssql_Comparison_Exp>
  updated_at?: InputMaybe<Datetime_Mssql_Comparison_Exp>
}

/** upsert condition type for table "ElecNominations" */
export type ElecNominations_If_Matched = {
  match_columns?: Array<ElecNominations_Insert_Match_Column>
  update_columns?: Array<ElecNominations_Update_Column>
  where?: InputMaybe<ElecNominations_Bool_Exp>
}

/** input type for incrementing numeric columns in table "ElecNominations" */
export type ElecNominations_Inc_Input = {
  Hour_1?: InputMaybe<Scalars["Float"]["input"]>
  Hour_2?: InputMaybe<Scalars["Float"]["input"]>
  Hour_3?: InputMaybe<Scalars["Float"]["input"]>
  Hour_4?: InputMaybe<Scalars["Float"]["input"]>
  Hour_5?: InputMaybe<Scalars["Float"]["input"]>
  Hour_6?: InputMaybe<Scalars["Float"]["input"]>
  Hour_7?: InputMaybe<Scalars["Float"]["input"]>
  Hour_8?: InputMaybe<Scalars["Float"]["input"]>
  Hour_9?: InputMaybe<Scalars["Float"]["input"]>
  Hour_10?: InputMaybe<Scalars["Float"]["input"]>
  Hour_11?: InputMaybe<Scalars["Float"]["input"]>
  Hour_12?: InputMaybe<Scalars["Float"]["input"]>
  Hour_13?: InputMaybe<Scalars["Float"]["input"]>
  Hour_14?: InputMaybe<Scalars["Float"]["input"]>
  Hour_15?: InputMaybe<Scalars["Float"]["input"]>
  Hour_16?: InputMaybe<Scalars["Float"]["input"]>
  Hour_17?: InputMaybe<Scalars["Float"]["input"]>
  Hour_18?: InputMaybe<Scalars["Float"]["input"]>
  Hour_19?: InputMaybe<Scalars["Float"]["input"]>
  Hour_20?: InputMaybe<Scalars["Float"]["input"]>
  Hour_21?: InputMaybe<Scalars["Float"]["input"]>
  Hour_22?: InputMaybe<Scalars["Float"]["input"]>
  Hour_23?: InputMaybe<Scalars["Float"]["input"]>
  Hour_24?: InputMaybe<Scalars["Float"]["input"]>
  Hour_25?: InputMaybe<Scalars["Float"]["input"]>
}

/** input type for inserting data into table "ElecNominations" */
export type ElecNominations_Insert_Input = {
  Hour_1?: InputMaybe<Scalars["Float"]["input"]>
  Hour_2?: InputMaybe<Scalars["Float"]["input"]>
  Hour_3?: InputMaybe<Scalars["Float"]["input"]>
  Hour_4?: InputMaybe<Scalars["Float"]["input"]>
  Hour_5?: InputMaybe<Scalars["Float"]["input"]>
  Hour_6?: InputMaybe<Scalars["Float"]["input"]>
  Hour_7?: InputMaybe<Scalars["Float"]["input"]>
  Hour_8?: InputMaybe<Scalars["Float"]["input"]>
  Hour_9?: InputMaybe<Scalars["Float"]["input"]>
  Hour_10?: InputMaybe<Scalars["Float"]["input"]>
  Hour_11?: InputMaybe<Scalars["Float"]["input"]>
  Hour_12?: InputMaybe<Scalars["Float"]["input"]>
  Hour_13?: InputMaybe<Scalars["Float"]["input"]>
  Hour_14?: InputMaybe<Scalars["Float"]["input"]>
  Hour_15?: InputMaybe<Scalars["Float"]["input"]>
  Hour_16?: InputMaybe<Scalars["Float"]["input"]>
  Hour_17?: InputMaybe<Scalars["Float"]["input"]>
  Hour_18?: InputMaybe<Scalars["Float"]["input"]>
  Hour_19?: InputMaybe<Scalars["Float"]["input"]>
  Hour_20?: InputMaybe<Scalars["Float"]["input"]>
  Hour_21?: InputMaybe<Scalars["Float"]["input"]>
  Hour_22?: InputMaybe<Scalars["Float"]["input"]>
  Hour_23?: InputMaybe<Scalars["Float"]["input"]>
  Hour_24?: InputMaybe<Scalars["Float"]["input"]>
  Hour_25?: InputMaybe<Scalars["Float"]["input"]>
  created_at?: InputMaybe<Scalars["datetime"]["input"]>
  date?: InputMaybe<Scalars["datetime"]["input"]>
  trader?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["datetime"]["input"]>
}

/** select match_columns of table "ElecNominations" */
export enum ElecNominations_Insert_Match_Column {
  /** column name */
  Hour_1 = "Hour_1",
  /** column name */
  Hour_2 = "Hour_2",
  /** column name */
  Hour_3 = "Hour_3",
  /** column name */
  Hour_4 = "Hour_4",
  /** column name */
  Hour_5 = "Hour_5",
  /** column name */
  Hour_6 = "Hour_6",
  /** column name */
  Hour_7 = "Hour_7",
  /** column name */
  Hour_8 = "Hour_8",
  /** column name */
  Hour_9 = "Hour_9",
  /** column name */
  Hour_10 = "Hour_10",
  /** column name */
  Hour_11 = "Hour_11",
  /** column name */
  Hour_12 = "Hour_12",
  /** column name */
  Hour_13 = "Hour_13",
  /** column name */
  Hour_14 = "Hour_14",
  /** column name */
  Hour_15 = "Hour_15",
  /** column name */
  Hour_16 = "Hour_16",
  /** column name */
  Hour_17 = "Hour_17",
  /** column name */
  Hour_18 = "Hour_18",
  /** column name */
  Hour_19 = "Hour_19",
  /** column name */
  Hour_20 = "Hour_20",
  /** column name */
  Hour_21 = "Hour_21",
  /** column name */
  Hour_22 = "Hour_22",
  /** column name */
  Hour_23 = "Hour_23",
  /** column name */
  Hour_24 = "Hour_24",
  /** column name */
  Hour_25 = "Hour_25",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Date = "date",
  /** column name */
  Trader = "trader",
  /** column name */
  UpdatedAt = "updated_at",
}

/** aggregate max on columns */
export type ElecNominations_Max_Fields = {
  __typename?: "ElecNominations_max_fields"
  Hour_1?: Maybe<Scalars["Float"]["output"]>
  Hour_2?: Maybe<Scalars["Float"]["output"]>
  Hour_3?: Maybe<Scalars["Float"]["output"]>
  Hour_4?: Maybe<Scalars["Float"]["output"]>
  Hour_5?: Maybe<Scalars["Float"]["output"]>
  Hour_6?: Maybe<Scalars["Float"]["output"]>
  Hour_7?: Maybe<Scalars["Float"]["output"]>
  Hour_8?: Maybe<Scalars["Float"]["output"]>
  Hour_9?: Maybe<Scalars["Float"]["output"]>
  Hour_10?: Maybe<Scalars["Float"]["output"]>
  Hour_11?: Maybe<Scalars["Float"]["output"]>
  Hour_12?: Maybe<Scalars["Float"]["output"]>
  Hour_13?: Maybe<Scalars["Float"]["output"]>
  Hour_14?: Maybe<Scalars["Float"]["output"]>
  Hour_15?: Maybe<Scalars["Float"]["output"]>
  Hour_16?: Maybe<Scalars["Float"]["output"]>
  Hour_17?: Maybe<Scalars["Float"]["output"]>
  Hour_18?: Maybe<Scalars["Float"]["output"]>
  Hour_19?: Maybe<Scalars["Float"]["output"]>
  Hour_20?: Maybe<Scalars["Float"]["output"]>
  Hour_21?: Maybe<Scalars["Float"]["output"]>
  Hour_22?: Maybe<Scalars["Float"]["output"]>
  Hour_23?: Maybe<Scalars["Float"]["output"]>
  Hour_24?: Maybe<Scalars["Float"]["output"]>
  Hour_25?: Maybe<Scalars["Float"]["output"]>
  created_at?: Maybe<Scalars["datetime"]["output"]>
  date?: Maybe<Scalars["datetime"]["output"]>
  trader?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["datetime"]["output"]>
}

/** aggregate min on columns */
export type ElecNominations_Min_Fields = {
  __typename?: "ElecNominations_min_fields"
  Hour_1?: Maybe<Scalars["Float"]["output"]>
  Hour_2?: Maybe<Scalars["Float"]["output"]>
  Hour_3?: Maybe<Scalars["Float"]["output"]>
  Hour_4?: Maybe<Scalars["Float"]["output"]>
  Hour_5?: Maybe<Scalars["Float"]["output"]>
  Hour_6?: Maybe<Scalars["Float"]["output"]>
  Hour_7?: Maybe<Scalars["Float"]["output"]>
  Hour_8?: Maybe<Scalars["Float"]["output"]>
  Hour_9?: Maybe<Scalars["Float"]["output"]>
  Hour_10?: Maybe<Scalars["Float"]["output"]>
  Hour_11?: Maybe<Scalars["Float"]["output"]>
  Hour_12?: Maybe<Scalars["Float"]["output"]>
  Hour_13?: Maybe<Scalars["Float"]["output"]>
  Hour_14?: Maybe<Scalars["Float"]["output"]>
  Hour_15?: Maybe<Scalars["Float"]["output"]>
  Hour_16?: Maybe<Scalars["Float"]["output"]>
  Hour_17?: Maybe<Scalars["Float"]["output"]>
  Hour_18?: Maybe<Scalars["Float"]["output"]>
  Hour_19?: Maybe<Scalars["Float"]["output"]>
  Hour_20?: Maybe<Scalars["Float"]["output"]>
  Hour_21?: Maybe<Scalars["Float"]["output"]>
  Hour_22?: Maybe<Scalars["Float"]["output"]>
  Hour_23?: Maybe<Scalars["Float"]["output"]>
  Hour_24?: Maybe<Scalars["Float"]["output"]>
  Hour_25?: Maybe<Scalars["Float"]["output"]>
  created_at?: Maybe<Scalars["datetime"]["output"]>
  date?: Maybe<Scalars["datetime"]["output"]>
  trader?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["datetime"]["output"]>
}

/** response of any mutation on the table "ElecNominations" */
export type ElecNominations_Mutation_Response = {
  __typename?: "ElecNominations_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<ElecNominations>
}

/** Ordering options when selecting data from "ElecNominations". */
export type ElecNominations_Order_By = {
  Hour_1?: InputMaybe<Order_By>
  Hour_2?: InputMaybe<Order_By>
  Hour_3?: InputMaybe<Order_By>
  Hour_4?: InputMaybe<Order_By>
  Hour_5?: InputMaybe<Order_By>
  Hour_6?: InputMaybe<Order_By>
  Hour_7?: InputMaybe<Order_By>
  Hour_8?: InputMaybe<Order_By>
  Hour_9?: InputMaybe<Order_By>
  Hour_10?: InputMaybe<Order_By>
  Hour_11?: InputMaybe<Order_By>
  Hour_12?: InputMaybe<Order_By>
  Hour_13?: InputMaybe<Order_By>
  Hour_14?: InputMaybe<Order_By>
  Hour_15?: InputMaybe<Order_By>
  Hour_16?: InputMaybe<Order_By>
  Hour_17?: InputMaybe<Order_By>
  Hour_18?: InputMaybe<Order_By>
  Hour_19?: InputMaybe<Order_By>
  Hour_20?: InputMaybe<Order_By>
  Hour_21?: InputMaybe<Order_By>
  Hour_22?: InputMaybe<Order_By>
  Hour_23?: InputMaybe<Order_By>
  Hour_24?: InputMaybe<Order_By>
  Hour_25?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  date?: InputMaybe<Order_By>
  trader?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** select columns of table "ElecNominations" */
export enum ElecNominations_Select_Column {
  /** column name */
  Hour_1 = "Hour_1",
  /** column name */
  Hour_2 = "Hour_2",
  /** column name */
  Hour_3 = "Hour_3",
  /** column name */
  Hour_4 = "Hour_4",
  /** column name */
  Hour_5 = "Hour_5",
  /** column name */
  Hour_6 = "Hour_6",
  /** column name */
  Hour_7 = "Hour_7",
  /** column name */
  Hour_8 = "Hour_8",
  /** column name */
  Hour_9 = "Hour_9",
  /** column name */
  Hour_10 = "Hour_10",
  /** column name */
  Hour_11 = "Hour_11",
  /** column name */
  Hour_12 = "Hour_12",
  /** column name */
  Hour_13 = "Hour_13",
  /** column name */
  Hour_14 = "Hour_14",
  /** column name */
  Hour_15 = "Hour_15",
  /** column name */
  Hour_16 = "Hour_16",
  /** column name */
  Hour_17 = "Hour_17",
  /** column name */
  Hour_18 = "Hour_18",
  /** column name */
  Hour_19 = "Hour_19",
  /** column name */
  Hour_20 = "Hour_20",
  /** column name */
  Hour_21 = "Hour_21",
  /** column name */
  Hour_22 = "Hour_22",
  /** column name */
  Hour_23 = "Hour_23",
  /** column name */
  Hour_24 = "Hour_24",
  /** column name */
  Hour_25 = "Hour_25",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Date = "date",
  /** column name */
  Trader = "trader",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "ElecNominations" */
export type ElecNominations_Set_Input = {
  Hour_1?: InputMaybe<Scalars["Float"]["input"]>
  Hour_2?: InputMaybe<Scalars["Float"]["input"]>
  Hour_3?: InputMaybe<Scalars["Float"]["input"]>
  Hour_4?: InputMaybe<Scalars["Float"]["input"]>
  Hour_5?: InputMaybe<Scalars["Float"]["input"]>
  Hour_6?: InputMaybe<Scalars["Float"]["input"]>
  Hour_7?: InputMaybe<Scalars["Float"]["input"]>
  Hour_8?: InputMaybe<Scalars["Float"]["input"]>
  Hour_9?: InputMaybe<Scalars["Float"]["input"]>
  Hour_10?: InputMaybe<Scalars["Float"]["input"]>
  Hour_11?: InputMaybe<Scalars["Float"]["input"]>
  Hour_12?: InputMaybe<Scalars["Float"]["input"]>
  Hour_13?: InputMaybe<Scalars["Float"]["input"]>
  Hour_14?: InputMaybe<Scalars["Float"]["input"]>
  Hour_15?: InputMaybe<Scalars["Float"]["input"]>
  Hour_16?: InputMaybe<Scalars["Float"]["input"]>
  Hour_17?: InputMaybe<Scalars["Float"]["input"]>
  Hour_18?: InputMaybe<Scalars["Float"]["input"]>
  Hour_19?: InputMaybe<Scalars["Float"]["input"]>
  Hour_20?: InputMaybe<Scalars["Float"]["input"]>
  Hour_21?: InputMaybe<Scalars["Float"]["input"]>
  Hour_22?: InputMaybe<Scalars["Float"]["input"]>
  Hour_23?: InputMaybe<Scalars["Float"]["input"]>
  Hour_24?: InputMaybe<Scalars["Float"]["input"]>
  Hour_25?: InputMaybe<Scalars["Float"]["input"]>
  created_at?: InputMaybe<Scalars["datetime"]["input"]>
  date?: InputMaybe<Scalars["datetime"]["input"]>
  trader?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["datetime"]["input"]>
}

/** aggregate stddev on columns */
export type ElecNominations_Stddev_Fields = {
  __typename?: "ElecNominations_stddev_fields"
  Hour_1?: Maybe<Scalars["Float"]["output"]>
  Hour_2?: Maybe<Scalars["Float"]["output"]>
  Hour_3?: Maybe<Scalars["Float"]["output"]>
  Hour_4?: Maybe<Scalars["Float"]["output"]>
  Hour_5?: Maybe<Scalars["Float"]["output"]>
  Hour_6?: Maybe<Scalars["Float"]["output"]>
  Hour_7?: Maybe<Scalars["Float"]["output"]>
  Hour_8?: Maybe<Scalars["Float"]["output"]>
  Hour_9?: Maybe<Scalars["Float"]["output"]>
  Hour_10?: Maybe<Scalars["Float"]["output"]>
  Hour_11?: Maybe<Scalars["Float"]["output"]>
  Hour_12?: Maybe<Scalars["Float"]["output"]>
  Hour_13?: Maybe<Scalars["Float"]["output"]>
  Hour_14?: Maybe<Scalars["Float"]["output"]>
  Hour_15?: Maybe<Scalars["Float"]["output"]>
  Hour_16?: Maybe<Scalars["Float"]["output"]>
  Hour_17?: Maybe<Scalars["Float"]["output"]>
  Hour_18?: Maybe<Scalars["Float"]["output"]>
  Hour_19?: Maybe<Scalars["Float"]["output"]>
  Hour_20?: Maybe<Scalars["Float"]["output"]>
  Hour_21?: Maybe<Scalars["Float"]["output"]>
  Hour_22?: Maybe<Scalars["Float"]["output"]>
  Hour_23?: Maybe<Scalars["Float"]["output"]>
  Hour_24?: Maybe<Scalars["Float"]["output"]>
  Hour_25?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type ElecNominations_Stddev_Pop_Fields = {
  __typename?: "ElecNominations_stddev_pop_fields"
  Hour_1?: Maybe<Scalars["Float"]["output"]>
  Hour_2?: Maybe<Scalars["Float"]["output"]>
  Hour_3?: Maybe<Scalars["Float"]["output"]>
  Hour_4?: Maybe<Scalars["Float"]["output"]>
  Hour_5?: Maybe<Scalars["Float"]["output"]>
  Hour_6?: Maybe<Scalars["Float"]["output"]>
  Hour_7?: Maybe<Scalars["Float"]["output"]>
  Hour_8?: Maybe<Scalars["Float"]["output"]>
  Hour_9?: Maybe<Scalars["Float"]["output"]>
  Hour_10?: Maybe<Scalars["Float"]["output"]>
  Hour_11?: Maybe<Scalars["Float"]["output"]>
  Hour_12?: Maybe<Scalars["Float"]["output"]>
  Hour_13?: Maybe<Scalars["Float"]["output"]>
  Hour_14?: Maybe<Scalars["Float"]["output"]>
  Hour_15?: Maybe<Scalars["Float"]["output"]>
  Hour_16?: Maybe<Scalars["Float"]["output"]>
  Hour_17?: Maybe<Scalars["Float"]["output"]>
  Hour_18?: Maybe<Scalars["Float"]["output"]>
  Hour_19?: Maybe<Scalars["Float"]["output"]>
  Hour_20?: Maybe<Scalars["Float"]["output"]>
  Hour_21?: Maybe<Scalars["Float"]["output"]>
  Hour_22?: Maybe<Scalars["Float"]["output"]>
  Hour_23?: Maybe<Scalars["Float"]["output"]>
  Hour_24?: Maybe<Scalars["Float"]["output"]>
  Hour_25?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type ElecNominations_Stddev_Samp_Fields = {
  __typename?: "ElecNominations_stddev_samp_fields"
  Hour_1?: Maybe<Scalars["Float"]["output"]>
  Hour_2?: Maybe<Scalars["Float"]["output"]>
  Hour_3?: Maybe<Scalars["Float"]["output"]>
  Hour_4?: Maybe<Scalars["Float"]["output"]>
  Hour_5?: Maybe<Scalars["Float"]["output"]>
  Hour_6?: Maybe<Scalars["Float"]["output"]>
  Hour_7?: Maybe<Scalars["Float"]["output"]>
  Hour_8?: Maybe<Scalars["Float"]["output"]>
  Hour_9?: Maybe<Scalars["Float"]["output"]>
  Hour_10?: Maybe<Scalars["Float"]["output"]>
  Hour_11?: Maybe<Scalars["Float"]["output"]>
  Hour_12?: Maybe<Scalars["Float"]["output"]>
  Hour_13?: Maybe<Scalars["Float"]["output"]>
  Hour_14?: Maybe<Scalars["Float"]["output"]>
  Hour_15?: Maybe<Scalars["Float"]["output"]>
  Hour_16?: Maybe<Scalars["Float"]["output"]>
  Hour_17?: Maybe<Scalars["Float"]["output"]>
  Hour_18?: Maybe<Scalars["Float"]["output"]>
  Hour_19?: Maybe<Scalars["Float"]["output"]>
  Hour_20?: Maybe<Scalars["Float"]["output"]>
  Hour_21?: Maybe<Scalars["Float"]["output"]>
  Hour_22?: Maybe<Scalars["Float"]["output"]>
  Hour_23?: Maybe<Scalars["Float"]["output"]>
  Hour_24?: Maybe<Scalars["Float"]["output"]>
  Hour_25?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate sum on columns */
export type ElecNominations_Sum_Fields = {
  __typename?: "ElecNominations_sum_fields"
  Hour_1?: Maybe<Scalars["Float"]["output"]>
  Hour_2?: Maybe<Scalars["Float"]["output"]>
  Hour_3?: Maybe<Scalars["Float"]["output"]>
  Hour_4?: Maybe<Scalars["Float"]["output"]>
  Hour_5?: Maybe<Scalars["Float"]["output"]>
  Hour_6?: Maybe<Scalars["Float"]["output"]>
  Hour_7?: Maybe<Scalars["Float"]["output"]>
  Hour_8?: Maybe<Scalars["Float"]["output"]>
  Hour_9?: Maybe<Scalars["Float"]["output"]>
  Hour_10?: Maybe<Scalars["Float"]["output"]>
  Hour_11?: Maybe<Scalars["Float"]["output"]>
  Hour_12?: Maybe<Scalars["Float"]["output"]>
  Hour_13?: Maybe<Scalars["Float"]["output"]>
  Hour_14?: Maybe<Scalars["Float"]["output"]>
  Hour_15?: Maybe<Scalars["Float"]["output"]>
  Hour_16?: Maybe<Scalars["Float"]["output"]>
  Hour_17?: Maybe<Scalars["Float"]["output"]>
  Hour_18?: Maybe<Scalars["Float"]["output"]>
  Hour_19?: Maybe<Scalars["Float"]["output"]>
  Hour_20?: Maybe<Scalars["Float"]["output"]>
  Hour_21?: Maybe<Scalars["Float"]["output"]>
  Hour_22?: Maybe<Scalars["Float"]["output"]>
  Hour_23?: Maybe<Scalars["Float"]["output"]>
  Hour_24?: Maybe<Scalars["Float"]["output"]>
  Hour_25?: Maybe<Scalars["Float"]["output"]>
}

/** update columns of table "ElecNominations" */
export enum ElecNominations_Update_Column {
  /** column name */
  Hour_1 = "Hour_1",
  /** column name */
  Hour_2 = "Hour_2",
  /** column name */
  Hour_3 = "Hour_3",
  /** column name */
  Hour_4 = "Hour_4",
  /** column name */
  Hour_5 = "Hour_5",
  /** column name */
  Hour_6 = "Hour_6",
  /** column name */
  Hour_7 = "Hour_7",
  /** column name */
  Hour_8 = "Hour_8",
  /** column name */
  Hour_9 = "Hour_9",
  /** column name */
  Hour_10 = "Hour_10",
  /** column name */
  Hour_11 = "Hour_11",
  /** column name */
  Hour_12 = "Hour_12",
  /** column name */
  Hour_13 = "Hour_13",
  /** column name */
  Hour_14 = "Hour_14",
  /** column name */
  Hour_15 = "Hour_15",
  /** column name */
  Hour_16 = "Hour_16",
  /** column name */
  Hour_17 = "Hour_17",
  /** column name */
  Hour_18 = "Hour_18",
  /** column name */
  Hour_19 = "Hour_19",
  /** column name */
  Hour_20 = "Hour_20",
  /** column name */
  Hour_21 = "Hour_21",
  /** column name */
  Hour_22 = "Hour_22",
  /** column name */
  Hour_23 = "Hour_23",
  /** column name */
  Hour_24 = "Hour_24",
  /** column name */
  Hour_25 = "Hour_25",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Date = "date",
  /** column name */
  Trader = "trader",
  /** column name */
  UpdatedAt = "updated_at",
}

/** aggregate var_pop on columns */
export type ElecNominations_Var_Pop_Fields = {
  __typename?: "ElecNominations_var_pop_fields"
  Hour_1?: Maybe<Scalars["Float"]["output"]>
  Hour_2?: Maybe<Scalars["Float"]["output"]>
  Hour_3?: Maybe<Scalars["Float"]["output"]>
  Hour_4?: Maybe<Scalars["Float"]["output"]>
  Hour_5?: Maybe<Scalars["Float"]["output"]>
  Hour_6?: Maybe<Scalars["Float"]["output"]>
  Hour_7?: Maybe<Scalars["Float"]["output"]>
  Hour_8?: Maybe<Scalars["Float"]["output"]>
  Hour_9?: Maybe<Scalars["Float"]["output"]>
  Hour_10?: Maybe<Scalars["Float"]["output"]>
  Hour_11?: Maybe<Scalars["Float"]["output"]>
  Hour_12?: Maybe<Scalars["Float"]["output"]>
  Hour_13?: Maybe<Scalars["Float"]["output"]>
  Hour_14?: Maybe<Scalars["Float"]["output"]>
  Hour_15?: Maybe<Scalars["Float"]["output"]>
  Hour_16?: Maybe<Scalars["Float"]["output"]>
  Hour_17?: Maybe<Scalars["Float"]["output"]>
  Hour_18?: Maybe<Scalars["Float"]["output"]>
  Hour_19?: Maybe<Scalars["Float"]["output"]>
  Hour_20?: Maybe<Scalars["Float"]["output"]>
  Hour_21?: Maybe<Scalars["Float"]["output"]>
  Hour_22?: Maybe<Scalars["Float"]["output"]>
  Hour_23?: Maybe<Scalars["Float"]["output"]>
  Hour_24?: Maybe<Scalars["Float"]["output"]>
  Hour_25?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type ElecNominations_Var_Samp_Fields = {
  __typename?: "ElecNominations_var_samp_fields"
  Hour_1?: Maybe<Scalars["Float"]["output"]>
  Hour_2?: Maybe<Scalars["Float"]["output"]>
  Hour_3?: Maybe<Scalars["Float"]["output"]>
  Hour_4?: Maybe<Scalars["Float"]["output"]>
  Hour_5?: Maybe<Scalars["Float"]["output"]>
  Hour_6?: Maybe<Scalars["Float"]["output"]>
  Hour_7?: Maybe<Scalars["Float"]["output"]>
  Hour_8?: Maybe<Scalars["Float"]["output"]>
  Hour_9?: Maybe<Scalars["Float"]["output"]>
  Hour_10?: Maybe<Scalars["Float"]["output"]>
  Hour_11?: Maybe<Scalars["Float"]["output"]>
  Hour_12?: Maybe<Scalars["Float"]["output"]>
  Hour_13?: Maybe<Scalars["Float"]["output"]>
  Hour_14?: Maybe<Scalars["Float"]["output"]>
  Hour_15?: Maybe<Scalars["Float"]["output"]>
  Hour_16?: Maybe<Scalars["Float"]["output"]>
  Hour_17?: Maybe<Scalars["Float"]["output"]>
  Hour_18?: Maybe<Scalars["Float"]["output"]>
  Hour_19?: Maybe<Scalars["Float"]["output"]>
  Hour_20?: Maybe<Scalars["Float"]["output"]>
  Hour_21?: Maybe<Scalars["Float"]["output"]>
  Hour_22?: Maybe<Scalars["Float"]["output"]>
  Hour_23?: Maybe<Scalars["Float"]["output"]>
  Hour_24?: Maybe<Scalars["Float"]["output"]>
  Hour_25?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type ElecNominations_Variance_Fields = {
  __typename?: "ElecNominations_variance_fields"
  Hour_1?: Maybe<Scalars["Float"]["output"]>
  Hour_2?: Maybe<Scalars["Float"]["output"]>
  Hour_3?: Maybe<Scalars["Float"]["output"]>
  Hour_4?: Maybe<Scalars["Float"]["output"]>
  Hour_5?: Maybe<Scalars["Float"]["output"]>
  Hour_6?: Maybe<Scalars["Float"]["output"]>
  Hour_7?: Maybe<Scalars["Float"]["output"]>
  Hour_8?: Maybe<Scalars["Float"]["output"]>
  Hour_9?: Maybe<Scalars["Float"]["output"]>
  Hour_10?: Maybe<Scalars["Float"]["output"]>
  Hour_11?: Maybe<Scalars["Float"]["output"]>
  Hour_12?: Maybe<Scalars["Float"]["output"]>
  Hour_13?: Maybe<Scalars["Float"]["output"]>
  Hour_14?: Maybe<Scalars["Float"]["output"]>
  Hour_15?: Maybe<Scalars["Float"]["output"]>
  Hour_16?: Maybe<Scalars["Float"]["output"]>
  Hour_17?: Maybe<Scalars["Float"]["output"]>
  Hour_18?: Maybe<Scalars["Float"]["output"]>
  Hour_19?: Maybe<Scalars["Float"]["output"]>
  Hour_20?: Maybe<Scalars["Float"]["output"]>
  Hour_21?: Maybe<Scalars["Float"]["output"]>
  Hour_22?: Maybe<Scalars["Float"]["output"]>
  Hour_23?: Maybe<Scalars["Float"]["output"]>
  Hour_24?: Maybe<Scalars["Float"]["output"]>
  Hour_25?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "ElecTrades" */
export type ElecTrades = {
  __typename?: "ElecTrades"
  ConfirmRecievedDate?: Maybe<Scalars["datetime"]["output"]>
  ConfirmSignedBy?: Maybe<Scalars["String"]["output"]>
  ConfirmSignedDate?: Maybe<Scalars["datetime"]["output"]>
  Counterparty?: Maybe<Scalars["String"]["output"]>
  Date?: Maybe<Scalars["datetime"]["output"]>
  Invoice_Date_From?: Maybe<Scalars["datetime"]["output"]>
  Invoice_Date_To?: Maybe<Scalars["datetime"]["output"]>
  Locked: Scalars["Boolean"]["output"]
  Notes?: Maybe<Scalars["String"]["output"]>
  PercentOfBaseload?: Maybe<Scalars["Float"]["output"]>
  Period?: Maybe<Scalars["String"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Product?: Maybe<Scalars["String"]["output"]>
  Trader?: Maybe<Scalars["String"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  id: Scalars["Int"]["output"]
}

/** columns and relationships of "ElecTradesHistory" */
export type ElecTradesHistory = {
  __typename?: "ElecTradesHistory"
  ConfirmReceivedDate?: Maybe<Scalars["datetime"]["output"]>
  ConfirmSignedBy?: Maybe<Scalars["String"]["output"]>
  ConfirmSignedDate?: Maybe<Scalars["datetime"]["output"]>
  Counterparty?: Maybe<Scalars["String"]["output"]>
  Date?: Maybe<Scalars["datetime"]["output"]>
  Invoice_Date_From?: Maybe<Scalars["datetime"]["output"]>
  Invoice_Date_To?: Maybe<Scalars["datetime"]["output"]>
  Notes?: Maybe<Scalars["String"]["output"]>
  PercentOfBaseload?: Maybe<Scalars["Float"]["output"]>
  Period?: Maybe<Scalars["String"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Product?: Maybe<Scalars["String"]["output"]>
  Trader?: Maybe<Scalars["String"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  elec_trade_id: Scalars["Int"]["output"]
  id: Scalars["Int"]["output"]
}

/** aggregated selection of "ElecTradesHistory" */
export type ElecTradesHistory_Aggregate = {
  __typename?: "ElecTradesHistory_aggregate"
  aggregate?: Maybe<ElecTradesHistory_Aggregate_Fields>
  nodes: Array<ElecTradesHistory>
}

/** aggregate fields of "ElecTradesHistory" */
export type ElecTradesHistory_Aggregate_Fields = {
  __typename?: "ElecTradesHistory_aggregate_fields"
  avg?: Maybe<ElecTradesHistory_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<ElecTradesHistory_Max_Fields>
  min?: Maybe<ElecTradesHistory_Min_Fields>
  stddev?: Maybe<ElecTradesHistory_Stddev_Fields>
  stddev_pop?: Maybe<ElecTradesHistory_Stddev_Pop_Fields>
  stddev_samp?: Maybe<ElecTradesHistory_Stddev_Samp_Fields>
  sum?: Maybe<ElecTradesHistory_Sum_Fields>
  var_pop?: Maybe<ElecTradesHistory_Var_Pop_Fields>
  var_samp?: Maybe<ElecTradesHistory_Var_Samp_Fields>
  variance?: Maybe<ElecTradesHistory_Variance_Fields>
}

/** aggregate fields of "ElecTradesHistory" */
export type ElecTradesHistory_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<ElecTradesHistory_Select_Column>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type ElecTradesHistory_Avg_Fields = {
  __typename?: "ElecTradesHistory_avg_fields"
  PercentOfBaseload?: Maybe<Scalars["Float"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  elec_trade_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "ElecTradesHistory". All fields are combined with a logical 'AND'. */
export type ElecTradesHistory_Bool_Exp = {
  ConfirmReceivedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>
  ConfirmSignedBy?: InputMaybe<String_Mssql_Comparison_Exp>
  ConfirmSignedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>
  Counterparty?: InputMaybe<String_Mssql_Comparison_Exp>
  Date?: InputMaybe<Datetime_Mssql_Comparison_Exp>
  Invoice_Date_From?: InputMaybe<Datetime_Mssql_Comparison_Exp>
  Invoice_Date_To?: InputMaybe<Datetime_Mssql_Comparison_Exp>
  Notes?: InputMaybe<String_Mssql_Comparison_Exp>
  PercentOfBaseload?: InputMaybe<Float_Mssql_Comparison_Exp>
  Period?: InputMaybe<String_Mssql_Comparison_Exp>
  Price?: InputMaybe<Float_Mssql_Comparison_Exp>
  Product?: InputMaybe<String_Mssql_Comparison_Exp>
  Trader?: InputMaybe<String_Mssql_Comparison_Exp>
  Volume?: InputMaybe<Float_Mssql_Comparison_Exp>
  _and?: InputMaybe<Array<ElecTradesHistory_Bool_Exp>>
  _not?: InputMaybe<ElecTradesHistory_Bool_Exp>
  _or?: InputMaybe<Array<ElecTradesHistory_Bool_Exp>>
  elec_trade_id?: InputMaybe<Int_Mssql_Comparison_Exp>
  id?: InputMaybe<Int_Mssql_Comparison_Exp>
}

/** upsert condition type for table "ElecTradesHistory" */
export type ElecTradesHistory_If_Matched = {
  match_columns?: Array<ElecTradesHistory_Insert_Match_Column>
  update_columns?: Array<ElecTradesHistory_Update_Column>
  where?: InputMaybe<ElecTradesHistory_Bool_Exp>
}

/** input type for incrementing numeric columns in table "ElecTradesHistory" */
export type ElecTradesHistory_Inc_Input = {
  PercentOfBaseload?: InputMaybe<Scalars["Float"]["input"]>
  Price?: InputMaybe<Scalars["Float"]["input"]>
  Volume?: InputMaybe<Scalars["Float"]["input"]>
  elec_trade_id?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "ElecTradesHistory" */
export type ElecTradesHistory_Insert_Input = {
  ConfirmReceivedDate?: InputMaybe<Scalars["datetime"]["input"]>
  ConfirmSignedBy?: InputMaybe<Scalars["String"]["input"]>
  ConfirmSignedDate?: InputMaybe<Scalars["datetime"]["input"]>
  Counterparty?: InputMaybe<Scalars["String"]["input"]>
  Date?: InputMaybe<Scalars["datetime"]["input"]>
  Invoice_Date_From?: InputMaybe<Scalars["datetime"]["input"]>
  Invoice_Date_To?: InputMaybe<Scalars["datetime"]["input"]>
  Notes?: InputMaybe<Scalars["String"]["input"]>
  PercentOfBaseload?: InputMaybe<Scalars["Float"]["input"]>
  Period?: InputMaybe<Scalars["String"]["input"]>
  Price?: InputMaybe<Scalars["Float"]["input"]>
  Product?: InputMaybe<Scalars["String"]["input"]>
  Trader?: InputMaybe<Scalars["String"]["input"]>
  Volume?: InputMaybe<Scalars["Float"]["input"]>
  elec_trade_id?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** select match_columns of table "ElecTradesHistory" */
export enum ElecTradesHistory_Insert_Match_Column {
  /** column name */
  ConfirmReceivedDate = "ConfirmReceivedDate",
  /** column name */
  ConfirmSignedBy = "ConfirmSignedBy",
  /** column name */
  ConfirmSignedDate = "ConfirmSignedDate",
  /** column name */
  Counterparty = "Counterparty",
  /** column name */
  Date = "Date",
  /** column name */
  InvoiceDateFrom = "Invoice_Date_From",
  /** column name */
  InvoiceDateTo = "Invoice_Date_To",
  /** column name */
  Notes = "Notes",
  /** column name */
  PercentOfBaseload = "PercentOfBaseload",
  /** column name */
  Period = "Period",
  /** column name */
  Price = "Price",
  /** column name */
  Product = "Product",
  /** column name */
  Trader = "Trader",
  /** column name */
  Volume = "Volume",
  /** column name */
  ElecTradeId = "elec_trade_id",
  /** column name */
  Id = "id",
}

/** aggregate max on columns */
export type ElecTradesHistory_Max_Fields = {
  __typename?: "ElecTradesHistory_max_fields"
  ConfirmReceivedDate?: Maybe<Scalars["datetime"]["output"]>
  ConfirmSignedBy?: Maybe<Scalars["String"]["output"]>
  ConfirmSignedDate?: Maybe<Scalars["datetime"]["output"]>
  Counterparty?: Maybe<Scalars["String"]["output"]>
  Date?: Maybe<Scalars["datetime"]["output"]>
  Invoice_Date_From?: Maybe<Scalars["datetime"]["output"]>
  Invoice_Date_To?: Maybe<Scalars["datetime"]["output"]>
  Notes?: Maybe<Scalars["String"]["output"]>
  PercentOfBaseload?: Maybe<Scalars["Float"]["output"]>
  Period?: Maybe<Scalars["String"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Product?: Maybe<Scalars["String"]["output"]>
  Trader?: Maybe<Scalars["String"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  elec_trade_id?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
}

/** aggregate min on columns */
export type ElecTradesHistory_Min_Fields = {
  __typename?: "ElecTradesHistory_min_fields"
  ConfirmReceivedDate?: Maybe<Scalars["datetime"]["output"]>
  ConfirmSignedBy?: Maybe<Scalars["String"]["output"]>
  ConfirmSignedDate?: Maybe<Scalars["datetime"]["output"]>
  Counterparty?: Maybe<Scalars["String"]["output"]>
  Date?: Maybe<Scalars["datetime"]["output"]>
  Invoice_Date_From?: Maybe<Scalars["datetime"]["output"]>
  Invoice_Date_To?: Maybe<Scalars["datetime"]["output"]>
  Notes?: Maybe<Scalars["String"]["output"]>
  PercentOfBaseload?: Maybe<Scalars["Float"]["output"]>
  Period?: Maybe<Scalars["String"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Product?: Maybe<Scalars["String"]["output"]>
  Trader?: Maybe<Scalars["String"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  elec_trade_id?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
}

/** response of any mutation on the table "ElecTradesHistory" */
export type ElecTradesHistory_Mutation_Response = {
  __typename?: "ElecTradesHistory_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<ElecTradesHistory>
}

/** Ordering options when selecting data from "ElecTradesHistory". */
export type ElecTradesHistory_Order_By = {
  ConfirmReceivedDate?: InputMaybe<Order_By>
  ConfirmSignedBy?: InputMaybe<Order_By>
  ConfirmSignedDate?: InputMaybe<Order_By>
  Counterparty?: InputMaybe<Order_By>
  Date?: InputMaybe<Order_By>
  Invoice_Date_From?: InputMaybe<Order_By>
  Invoice_Date_To?: InputMaybe<Order_By>
  Notes?: InputMaybe<Order_By>
  PercentOfBaseload?: InputMaybe<Order_By>
  Period?: InputMaybe<Order_By>
  Price?: InputMaybe<Order_By>
  Product?: InputMaybe<Order_By>
  Trader?: InputMaybe<Order_By>
  Volume?: InputMaybe<Order_By>
  elec_trade_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** primary key columns input for table: ElecTradesHistory */
export type ElecTradesHistory_Pk_Columns_Input = {
  id: Scalars["Int"]["input"]
}

/** select columns of table "ElecTradesHistory" */
export enum ElecTradesHistory_Select_Column {
  /** column name */
  ConfirmReceivedDate = "ConfirmReceivedDate",
  /** column name */
  ConfirmSignedBy = "ConfirmSignedBy",
  /** column name */
  ConfirmSignedDate = "ConfirmSignedDate",
  /** column name */
  Counterparty = "Counterparty",
  /** column name */
  Date = "Date",
  /** column name */
  InvoiceDateFrom = "Invoice_Date_From",
  /** column name */
  InvoiceDateTo = "Invoice_Date_To",
  /** column name */
  Notes = "Notes",
  /** column name */
  PercentOfBaseload = "PercentOfBaseload",
  /** column name */
  Period = "Period",
  /** column name */
  Price = "Price",
  /** column name */
  Product = "Product",
  /** column name */
  Trader = "Trader",
  /** column name */
  Volume = "Volume",
  /** column name */
  ElecTradeId = "elec_trade_id",
  /** column name */
  Id = "id",
}

/** input type for updating data in table "ElecTradesHistory" */
export type ElecTradesHistory_Set_Input = {
  ConfirmReceivedDate?: InputMaybe<Scalars["datetime"]["input"]>
  ConfirmSignedBy?: InputMaybe<Scalars["String"]["input"]>
  ConfirmSignedDate?: InputMaybe<Scalars["datetime"]["input"]>
  Counterparty?: InputMaybe<Scalars["String"]["input"]>
  Date?: InputMaybe<Scalars["datetime"]["input"]>
  Invoice_Date_From?: InputMaybe<Scalars["datetime"]["input"]>
  Invoice_Date_To?: InputMaybe<Scalars["datetime"]["input"]>
  Notes?: InputMaybe<Scalars["String"]["input"]>
  PercentOfBaseload?: InputMaybe<Scalars["Float"]["input"]>
  Period?: InputMaybe<Scalars["String"]["input"]>
  Price?: InputMaybe<Scalars["Float"]["input"]>
  Product?: InputMaybe<Scalars["String"]["input"]>
  Trader?: InputMaybe<Scalars["String"]["input"]>
  Volume?: InputMaybe<Scalars["Float"]["input"]>
  elec_trade_id?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate stddev on columns */
export type ElecTradesHistory_Stddev_Fields = {
  __typename?: "ElecTradesHistory_stddev_fields"
  PercentOfBaseload?: Maybe<Scalars["Float"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  elec_trade_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type ElecTradesHistory_Stddev_Pop_Fields = {
  __typename?: "ElecTradesHistory_stddev_pop_fields"
  PercentOfBaseload?: Maybe<Scalars["Float"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  elec_trade_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type ElecTradesHistory_Stddev_Samp_Fields = {
  __typename?: "ElecTradesHistory_stddev_samp_fields"
  PercentOfBaseload?: Maybe<Scalars["Float"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  elec_trade_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate sum on columns */
export type ElecTradesHistory_Sum_Fields = {
  __typename?: "ElecTradesHistory_sum_fields"
  PercentOfBaseload?: Maybe<Scalars["Float"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  elec_trade_id?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
}

/** update columns of table "ElecTradesHistory" */
export enum ElecTradesHistory_Update_Column {
  /** column name */
  ConfirmReceivedDate = "ConfirmReceivedDate",
  /** column name */
  ConfirmSignedBy = "ConfirmSignedBy",
  /** column name */
  ConfirmSignedDate = "ConfirmSignedDate",
  /** column name */
  Counterparty = "Counterparty",
  /** column name */
  Date = "Date",
  /** column name */
  InvoiceDateFrom = "Invoice_Date_From",
  /** column name */
  InvoiceDateTo = "Invoice_Date_To",
  /** column name */
  Notes = "Notes",
  /** column name */
  PercentOfBaseload = "PercentOfBaseload",
  /** column name */
  Period = "Period",
  /** column name */
  Price = "Price",
  /** column name */
  Product = "Product",
  /** column name */
  Trader = "Trader",
  /** column name */
  Volume = "Volume",
  /** column name */
  ElecTradeId = "elec_trade_id",
  /** column name */
  Id = "id",
}

/** aggregate var_pop on columns */
export type ElecTradesHistory_Var_Pop_Fields = {
  __typename?: "ElecTradesHistory_var_pop_fields"
  PercentOfBaseload?: Maybe<Scalars["Float"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  elec_trade_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type ElecTradesHistory_Var_Samp_Fields = {
  __typename?: "ElecTradesHistory_var_samp_fields"
  PercentOfBaseload?: Maybe<Scalars["Float"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  elec_trade_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type ElecTradesHistory_Variance_Fields = {
  __typename?: "ElecTradesHistory_variance_fields"
  PercentOfBaseload?: Maybe<Scalars["Float"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  elec_trade_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregated selection of "ElecTrades" */
export type ElecTrades_Aggregate = {
  __typename?: "ElecTrades_aggregate"
  aggregate?: Maybe<ElecTrades_Aggregate_Fields>
  nodes: Array<ElecTrades>
}

/** aggregate fields of "ElecTrades" */
export type ElecTrades_Aggregate_Fields = {
  __typename?: "ElecTrades_aggregate_fields"
  avg?: Maybe<ElecTrades_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<ElecTrades_Max_Fields>
  min?: Maybe<ElecTrades_Min_Fields>
  stddev?: Maybe<ElecTrades_Stddev_Fields>
  stddev_pop?: Maybe<ElecTrades_Stddev_Pop_Fields>
  stddev_samp?: Maybe<ElecTrades_Stddev_Samp_Fields>
  sum?: Maybe<ElecTrades_Sum_Fields>
  var_pop?: Maybe<ElecTrades_Var_Pop_Fields>
  var_samp?: Maybe<ElecTrades_Var_Samp_Fields>
  variance?: Maybe<ElecTrades_Variance_Fields>
}

/** aggregate fields of "ElecTrades" */
export type ElecTrades_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<ElecTrades_Select_Column>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type ElecTrades_Avg_Fields = {
  __typename?: "ElecTrades_avg_fields"
  PercentOfBaseload?: Maybe<Scalars["Float"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "ElecTrades". All fields are combined with a logical 'AND'. */
export type ElecTrades_Bool_Exp = {
  ConfirmRecievedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>
  ConfirmSignedBy?: InputMaybe<String_Mssql_Comparison_Exp>
  ConfirmSignedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>
  Counterparty?: InputMaybe<String_Mssql_Comparison_Exp>
  Date?: InputMaybe<Datetime_Mssql_Comparison_Exp>
  Invoice_Date_From?: InputMaybe<Datetime_Mssql_Comparison_Exp>
  Invoice_Date_To?: InputMaybe<Datetime_Mssql_Comparison_Exp>
  Locked?: InputMaybe<Boolean_Mssql_Comparison_Exp>
  Notes?: InputMaybe<String_Mssql_Comparison_Exp>
  PercentOfBaseload?: InputMaybe<Float_Mssql_Comparison_Exp>
  Period?: InputMaybe<String_Mssql_Comparison_Exp>
  Price?: InputMaybe<Float_Mssql_Comparison_Exp>
  Product?: InputMaybe<String_Mssql_Comparison_Exp>
  Trader?: InputMaybe<String_Mssql_Comparison_Exp>
  Volume?: InputMaybe<Float_Mssql_Comparison_Exp>
  _and?: InputMaybe<Array<ElecTrades_Bool_Exp>>
  _not?: InputMaybe<ElecTrades_Bool_Exp>
  _or?: InputMaybe<Array<ElecTrades_Bool_Exp>>
  id?: InputMaybe<Int_Mssql_Comparison_Exp>
}

/** upsert condition type for table "ElecTrades" */
export type ElecTrades_If_Matched = {
  match_columns?: Array<ElecTrades_Insert_Match_Column>
  update_columns?: Array<ElecTrades_Update_Column>
  where?: InputMaybe<ElecTrades_Bool_Exp>
}

/** input type for incrementing numeric columns in table "ElecTrades" */
export type ElecTrades_Inc_Input = {
  PercentOfBaseload?: InputMaybe<Scalars["Float"]["input"]>
  Price?: InputMaybe<Scalars["Float"]["input"]>
  Volume?: InputMaybe<Scalars["Float"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "ElecTrades" */
export type ElecTrades_Insert_Input = {
  ConfirmRecievedDate?: InputMaybe<Scalars["datetime"]["input"]>
  ConfirmSignedBy?: InputMaybe<Scalars["String"]["input"]>
  ConfirmSignedDate?: InputMaybe<Scalars["datetime"]["input"]>
  Counterparty?: InputMaybe<Scalars["String"]["input"]>
  Date?: InputMaybe<Scalars["datetime"]["input"]>
  Invoice_Date_From?: InputMaybe<Scalars["datetime"]["input"]>
  Invoice_Date_To?: InputMaybe<Scalars["datetime"]["input"]>
  Locked?: InputMaybe<Scalars["Boolean"]["input"]>
  Notes?: InputMaybe<Scalars["String"]["input"]>
  PercentOfBaseload?: InputMaybe<Scalars["Float"]["input"]>
  Period?: InputMaybe<Scalars["String"]["input"]>
  Price?: InputMaybe<Scalars["Float"]["input"]>
  Product?: InputMaybe<Scalars["String"]["input"]>
  Trader?: InputMaybe<Scalars["String"]["input"]>
  Volume?: InputMaybe<Scalars["Float"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** select match_columns of table "ElecTrades" */
export enum ElecTrades_Insert_Match_Column {
  /** column name */
  ConfirmRecievedDate = "ConfirmRecievedDate",
  /** column name */
  ConfirmSignedBy = "ConfirmSignedBy",
  /** column name */
  ConfirmSignedDate = "ConfirmSignedDate",
  /** column name */
  Counterparty = "Counterparty",
  /** column name */
  Date = "Date",
  /** column name */
  InvoiceDateFrom = "Invoice_Date_From",
  /** column name */
  InvoiceDateTo = "Invoice_Date_To",
  /** column name */
  Locked = "Locked",
  /** column name */
  Notes = "Notes",
  /** column name */
  PercentOfBaseload = "PercentOfBaseload",
  /** column name */
  Period = "Period",
  /** column name */
  Price = "Price",
  /** column name */
  Product = "Product",
  /** column name */
  Trader = "Trader",
  /** column name */
  Volume = "Volume",
  /** column name */
  Id = "id",
}

/** aggregate max on columns */
export type ElecTrades_Max_Fields = {
  __typename?: "ElecTrades_max_fields"
  ConfirmRecievedDate?: Maybe<Scalars["datetime"]["output"]>
  ConfirmSignedBy?: Maybe<Scalars["String"]["output"]>
  ConfirmSignedDate?: Maybe<Scalars["datetime"]["output"]>
  Counterparty?: Maybe<Scalars["String"]["output"]>
  Date?: Maybe<Scalars["datetime"]["output"]>
  Invoice_Date_From?: Maybe<Scalars["datetime"]["output"]>
  Invoice_Date_To?: Maybe<Scalars["datetime"]["output"]>
  Notes?: Maybe<Scalars["String"]["output"]>
  PercentOfBaseload?: Maybe<Scalars["Float"]["output"]>
  Period?: Maybe<Scalars["String"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Product?: Maybe<Scalars["String"]["output"]>
  Trader?: Maybe<Scalars["String"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
}

/** aggregate min on columns */
export type ElecTrades_Min_Fields = {
  __typename?: "ElecTrades_min_fields"
  ConfirmRecievedDate?: Maybe<Scalars["datetime"]["output"]>
  ConfirmSignedBy?: Maybe<Scalars["String"]["output"]>
  ConfirmSignedDate?: Maybe<Scalars["datetime"]["output"]>
  Counterparty?: Maybe<Scalars["String"]["output"]>
  Date?: Maybe<Scalars["datetime"]["output"]>
  Invoice_Date_From?: Maybe<Scalars["datetime"]["output"]>
  Invoice_Date_To?: Maybe<Scalars["datetime"]["output"]>
  Notes?: Maybe<Scalars["String"]["output"]>
  PercentOfBaseload?: Maybe<Scalars["Float"]["output"]>
  Period?: Maybe<Scalars["String"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Product?: Maybe<Scalars["String"]["output"]>
  Trader?: Maybe<Scalars["String"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
}

/** response of any mutation on the table "ElecTrades" */
export type ElecTrades_Mutation_Response = {
  __typename?: "ElecTrades_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<ElecTrades>
}

/** Ordering options when selecting data from "ElecTrades". */
export type ElecTrades_Order_By = {
  ConfirmRecievedDate?: InputMaybe<Order_By>
  ConfirmSignedBy?: InputMaybe<Order_By>
  ConfirmSignedDate?: InputMaybe<Order_By>
  Counterparty?: InputMaybe<Order_By>
  Date?: InputMaybe<Order_By>
  Invoice_Date_From?: InputMaybe<Order_By>
  Invoice_Date_To?: InputMaybe<Order_By>
  Locked?: InputMaybe<Order_By>
  Notes?: InputMaybe<Order_By>
  PercentOfBaseload?: InputMaybe<Order_By>
  Period?: InputMaybe<Order_By>
  Price?: InputMaybe<Order_By>
  Product?: InputMaybe<Order_By>
  Trader?: InputMaybe<Order_By>
  Volume?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** primary key columns input for table: ElecTrades */
export type ElecTrades_Pk_Columns_Input = {
  id: Scalars["Int"]["input"]
}

/** select columns of table "ElecTrades" */
export enum ElecTrades_Select_Column {
  /** column name */
  ConfirmRecievedDate = "ConfirmRecievedDate",
  /** column name */
  ConfirmSignedBy = "ConfirmSignedBy",
  /** column name */
  ConfirmSignedDate = "ConfirmSignedDate",
  /** column name */
  Counterparty = "Counterparty",
  /** column name */
  Date = "Date",
  /** column name */
  InvoiceDateFrom = "Invoice_Date_From",
  /** column name */
  InvoiceDateTo = "Invoice_Date_To",
  /** column name */
  Locked = "Locked",
  /** column name */
  Notes = "Notes",
  /** column name */
  PercentOfBaseload = "PercentOfBaseload",
  /** column name */
  Period = "Period",
  /** column name */
  Price = "Price",
  /** column name */
  Product = "Product",
  /** column name */
  Trader = "Trader",
  /** column name */
  Volume = "Volume",
  /** column name */
  Id = "id",
}

/** input type for updating data in table "ElecTrades" */
export type ElecTrades_Set_Input = {
  ConfirmRecievedDate?: InputMaybe<Scalars["datetime"]["input"]>
  ConfirmSignedBy?: InputMaybe<Scalars["String"]["input"]>
  ConfirmSignedDate?: InputMaybe<Scalars["datetime"]["input"]>
  Counterparty?: InputMaybe<Scalars["String"]["input"]>
  Date?: InputMaybe<Scalars["datetime"]["input"]>
  Invoice_Date_From?: InputMaybe<Scalars["datetime"]["input"]>
  Invoice_Date_To?: InputMaybe<Scalars["datetime"]["input"]>
  Locked?: InputMaybe<Scalars["Boolean"]["input"]>
  Notes?: InputMaybe<Scalars["String"]["input"]>
  PercentOfBaseload?: InputMaybe<Scalars["Float"]["input"]>
  Period?: InputMaybe<Scalars["String"]["input"]>
  Price?: InputMaybe<Scalars["Float"]["input"]>
  Product?: InputMaybe<Scalars["String"]["input"]>
  Trader?: InputMaybe<Scalars["String"]["input"]>
  Volume?: InputMaybe<Scalars["Float"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate stddev on columns */
export type ElecTrades_Stddev_Fields = {
  __typename?: "ElecTrades_stddev_fields"
  PercentOfBaseload?: Maybe<Scalars["Float"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type ElecTrades_Stddev_Pop_Fields = {
  __typename?: "ElecTrades_stddev_pop_fields"
  PercentOfBaseload?: Maybe<Scalars["Float"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type ElecTrades_Stddev_Samp_Fields = {
  __typename?: "ElecTrades_stddev_samp_fields"
  PercentOfBaseload?: Maybe<Scalars["Float"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate sum on columns */
export type ElecTrades_Sum_Fields = {
  __typename?: "ElecTrades_sum_fields"
  PercentOfBaseload?: Maybe<Scalars["Float"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
}

/** update columns of table "ElecTrades" */
export enum ElecTrades_Update_Column {
  /** column name */
  ConfirmRecievedDate = "ConfirmRecievedDate",
  /** column name */
  ConfirmSignedBy = "ConfirmSignedBy",
  /** column name */
  ConfirmSignedDate = "ConfirmSignedDate",
  /** column name */
  Counterparty = "Counterparty",
  /** column name */
  Date = "Date",
  /** column name */
  InvoiceDateFrom = "Invoice_Date_From",
  /** column name */
  InvoiceDateTo = "Invoice_Date_To",
  /** column name */
  Locked = "Locked",
  /** column name */
  Notes = "Notes",
  /** column name */
  PercentOfBaseload = "PercentOfBaseload",
  /** column name */
  Period = "Period",
  /** column name */
  Price = "Price",
  /** column name */
  Product = "Product",
  /** column name */
  Trader = "Trader",
  /** column name */
  Volume = "Volume",
  /** column name */
  Id = "id",
}

/** aggregate var_pop on columns */
export type ElecTrades_Var_Pop_Fields = {
  __typename?: "ElecTrades_var_pop_fields"
  PercentOfBaseload?: Maybe<Scalars["Float"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type ElecTrades_Var_Samp_Fields = {
  __typename?: "ElecTrades_var_samp_fields"
  PercentOfBaseload?: Maybe<Scalars["Float"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type ElecTrades_Variance_Fields = {
  __typename?: "ElecTrades_variance_fields"
  PercentOfBaseload?: Maybe<Scalars["Float"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

export type EmailContentResponse = {
  __typename?: "EmailContentResponse"
  emailBody: Scalars["String"]["output"]
}

export type Filters = {
  changedAmountMax?: InputMaybe<Scalars["String"]["input"]>
  changedAmountMin?: InputMaybe<Scalars["String"]["input"]>
  changedPercentageMax?: InputMaybe<Scalars["String"]["input"]>
  changedPercentageMin?: InputMaybe<Scalars["String"]["input"]>
  emailStatus?: InputMaybe<Scalars["String"]["input"]>
  errorCodes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  from?: InputMaybe<Scalars["String"]["input"]>
  nextPaymentDateFrom?: InputMaybe<Scalars["String"]["input"]>
  nextPaymentDateTo?: InputMaybe<Scalars["String"]["input"]>
  notesStatus?: InputMaybe<Scalars["String"]["input"]>
  paymentReviewId?: InputMaybe<Scalars["BigInt"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  to?: InputMaybe<Scalars["String"]["input"]>
}

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["Float"]["input"]>
  _gt?: InputMaybe<Scalars["Float"]["input"]>
  _gte?: InputMaybe<Scalars["Float"]["input"]>
  _in?: InputMaybe<Array<Scalars["Float"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["Float"]["input"]>
  _lte?: InputMaybe<Scalars["Float"]["input"]>
  _neq?: InputMaybe<Scalars["Float"]["input"]>
  _nin?: InputMaybe<Array<Scalars["Float"]["input"]>>
}

export type ForwardingAddressDtoInput = {
  address1: Scalars["String"]["input"]
  address2: Scalars["String"]["input"]
  careOf: Scalars["String"]["input"]
  postcode: Scalars["String"]["input"]
}

/** columns and relationships of "GasTrades" */
export type GasTrades = {
  __typename?: "GasTrades"
  ConfirmRecieved?: Maybe<Scalars["datetime"]["output"]>
  ConfirmSignedBy?: Maybe<Scalars["String"]["output"]>
  ConfirmSignedDate?: Maybe<Scalars["datetime"]["output"]>
  CounterParty?: Maybe<Scalars["String"]["output"]>
  Date?: Maybe<Scalars["datetime"]["output"]>
  Date_From?: Maybe<Scalars["datetime"]["output"]>
  Date_To?: Maybe<Scalars["datetime"]["output"]>
  Index?: Maybe<Scalars["String"]["output"]>
  Locked: Scalars["Boolean"]["output"]
  Notes?: Maybe<Scalars["String"]["output"]>
  Period?: Maybe<Scalars["String"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Trader?: Maybe<Scalars["String"]["output"]>
  Volume?: Maybe<Scalars["Int"]["output"]>
  id: Scalars["Int"]["output"]
}

/** columns and relationships of "GasTradesHistory" */
export type GasTradesHistory = {
  __typename?: "GasTradesHistory"
  ConfirmReceived?: Maybe<Scalars["datetime"]["output"]>
  ConfirmSignedBy?: Maybe<Scalars["String"]["output"]>
  ConfirmSignedDate?: Maybe<Scalars["datetime"]["output"]>
  CounterParty?: Maybe<Scalars["String"]["output"]>
  Date?: Maybe<Scalars["datetime"]["output"]>
  Date_From?: Maybe<Scalars["datetime"]["output"]>
  Date_To?: Maybe<Scalars["datetime"]["output"]>
  Index?: Maybe<Scalars["String"]["output"]>
  Notes?: Maybe<Scalars["String"]["output"]>
  Period?: Maybe<Scalars["String"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Trader?: Maybe<Scalars["String"]["output"]>
  Volume?: Maybe<Scalars["Int"]["output"]>
  gas_trade_id: Scalars["Int"]["output"]
  id: Scalars["Int"]["output"]
}

/** aggregated selection of "GasTradesHistory" */
export type GasTradesHistory_Aggregate = {
  __typename?: "GasTradesHistory_aggregate"
  aggregate?: Maybe<GasTradesHistory_Aggregate_Fields>
  nodes: Array<GasTradesHistory>
}

/** aggregate fields of "GasTradesHistory" */
export type GasTradesHistory_Aggregate_Fields = {
  __typename?: "GasTradesHistory_aggregate_fields"
  avg?: Maybe<GasTradesHistory_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<GasTradesHistory_Max_Fields>
  min?: Maybe<GasTradesHistory_Min_Fields>
  stddev?: Maybe<GasTradesHistory_Stddev_Fields>
  stddev_pop?: Maybe<GasTradesHistory_Stddev_Pop_Fields>
  stddev_samp?: Maybe<GasTradesHistory_Stddev_Samp_Fields>
  sum?: Maybe<GasTradesHistory_Sum_Fields>
  var_pop?: Maybe<GasTradesHistory_Var_Pop_Fields>
  var_samp?: Maybe<GasTradesHistory_Var_Samp_Fields>
  variance?: Maybe<GasTradesHistory_Variance_Fields>
}

/** aggregate fields of "GasTradesHistory" */
export type GasTradesHistory_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<GasTradesHistory_Select_Column>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type GasTradesHistory_Avg_Fields = {
  __typename?: "GasTradesHistory_avg_fields"
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  gas_trade_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "GasTradesHistory". All fields are combined with a logical 'AND'. */
export type GasTradesHistory_Bool_Exp = {
  ConfirmReceived?: InputMaybe<Datetime_Mssql_Comparison_Exp>
  ConfirmSignedBy?: InputMaybe<String_Mssql_Comparison_Exp>
  ConfirmSignedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>
  CounterParty?: InputMaybe<String_Mssql_Comparison_Exp>
  Date?: InputMaybe<Datetime_Mssql_Comparison_Exp>
  Date_From?: InputMaybe<Datetime_Mssql_Comparison_Exp>
  Date_To?: InputMaybe<Datetime_Mssql_Comparison_Exp>
  Index?: InputMaybe<String_Mssql_Comparison_Exp>
  Notes?: InputMaybe<String_Mssql_Comparison_Exp>
  Period?: InputMaybe<String_Mssql_Comparison_Exp>
  Price?: InputMaybe<Float_Mssql_Comparison_Exp>
  Trader?: InputMaybe<String_Mssql_Comparison_Exp>
  Volume?: InputMaybe<Int_Mssql_Comparison_Exp>
  _and?: InputMaybe<Array<GasTradesHistory_Bool_Exp>>
  _not?: InputMaybe<GasTradesHistory_Bool_Exp>
  _or?: InputMaybe<Array<GasTradesHistory_Bool_Exp>>
  gas_trade_id?: InputMaybe<Int_Mssql_Comparison_Exp>
  id?: InputMaybe<Int_Mssql_Comparison_Exp>
}

/** upsert condition type for table "GasTradesHistory" */
export type GasTradesHistory_If_Matched = {
  match_columns?: Array<GasTradesHistory_Insert_Match_Column>
  update_columns?: Array<GasTradesHistory_Update_Column>
  where?: InputMaybe<GasTradesHistory_Bool_Exp>
}

/** input type for incrementing numeric columns in table "GasTradesHistory" */
export type GasTradesHistory_Inc_Input = {
  Price?: InputMaybe<Scalars["Float"]["input"]>
  Volume?: InputMaybe<Scalars["Int"]["input"]>
  gas_trade_id?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "GasTradesHistory" */
export type GasTradesHistory_Insert_Input = {
  ConfirmReceived?: InputMaybe<Scalars["datetime"]["input"]>
  ConfirmSignedBy?: InputMaybe<Scalars["String"]["input"]>
  ConfirmSignedDate?: InputMaybe<Scalars["datetime"]["input"]>
  CounterParty?: InputMaybe<Scalars["String"]["input"]>
  Date?: InputMaybe<Scalars["datetime"]["input"]>
  Date_From?: InputMaybe<Scalars["datetime"]["input"]>
  Date_To?: InputMaybe<Scalars["datetime"]["input"]>
  Index?: InputMaybe<Scalars["String"]["input"]>
  Notes?: InputMaybe<Scalars["String"]["input"]>
  Period?: InputMaybe<Scalars["String"]["input"]>
  Price?: InputMaybe<Scalars["Float"]["input"]>
  Trader?: InputMaybe<Scalars["String"]["input"]>
  Volume?: InputMaybe<Scalars["Int"]["input"]>
  gas_trade_id?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** select match_columns of table "GasTradesHistory" */
export enum GasTradesHistory_Insert_Match_Column {
  /** column name */
  ConfirmReceived = "ConfirmReceived",
  /** column name */
  ConfirmSignedBy = "ConfirmSignedBy",
  /** column name */
  ConfirmSignedDate = "ConfirmSignedDate",
  /** column name */
  CounterParty = "CounterParty",
  /** column name */
  Date = "Date",
  /** column name */
  DateFrom = "Date_From",
  /** column name */
  DateTo = "Date_To",
  /** column name */
  Index = "Index",
  /** column name */
  Notes = "Notes",
  /** column name */
  Period = "Period",
  /** column name */
  Price = "Price",
  /** column name */
  Trader = "Trader",
  /** column name */
  Volume = "Volume",
  /** column name */
  GasTradeId = "gas_trade_id",
  /** column name */
  Id = "id",
}

/** aggregate max on columns */
export type GasTradesHistory_Max_Fields = {
  __typename?: "GasTradesHistory_max_fields"
  ConfirmReceived?: Maybe<Scalars["datetime"]["output"]>
  ConfirmSignedBy?: Maybe<Scalars["String"]["output"]>
  ConfirmSignedDate?: Maybe<Scalars["datetime"]["output"]>
  CounterParty?: Maybe<Scalars["String"]["output"]>
  Date?: Maybe<Scalars["datetime"]["output"]>
  Date_From?: Maybe<Scalars["datetime"]["output"]>
  Date_To?: Maybe<Scalars["datetime"]["output"]>
  Index?: Maybe<Scalars["String"]["output"]>
  Notes?: Maybe<Scalars["String"]["output"]>
  Period?: Maybe<Scalars["String"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Trader?: Maybe<Scalars["String"]["output"]>
  Volume?: Maybe<Scalars["Int"]["output"]>
  gas_trade_id?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
}

/** aggregate min on columns */
export type GasTradesHistory_Min_Fields = {
  __typename?: "GasTradesHistory_min_fields"
  ConfirmReceived?: Maybe<Scalars["datetime"]["output"]>
  ConfirmSignedBy?: Maybe<Scalars["String"]["output"]>
  ConfirmSignedDate?: Maybe<Scalars["datetime"]["output"]>
  CounterParty?: Maybe<Scalars["String"]["output"]>
  Date?: Maybe<Scalars["datetime"]["output"]>
  Date_From?: Maybe<Scalars["datetime"]["output"]>
  Date_To?: Maybe<Scalars["datetime"]["output"]>
  Index?: Maybe<Scalars["String"]["output"]>
  Notes?: Maybe<Scalars["String"]["output"]>
  Period?: Maybe<Scalars["String"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Trader?: Maybe<Scalars["String"]["output"]>
  Volume?: Maybe<Scalars["Int"]["output"]>
  gas_trade_id?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
}

/** response of any mutation on the table "GasTradesHistory" */
export type GasTradesHistory_Mutation_Response = {
  __typename?: "GasTradesHistory_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<GasTradesHistory>
}

/** Ordering options when selecting data from "GasTradesHistory". */
export type GasTradesHistory_Order_By = {
  ConfirmReceived?: InputMaybe<Order_By>
  ConfirmSignedBy?: InputMaybe<Order_By>
  ConfirmSignedDate?: InputMaybe<Order_By>
  CounterParty?: InputMaybe<Order_By>
  Date?: InputMaybe<Order_By>
  Date_From?: InputMaybe<Order_By>
  Date_To?: InputMaybe<Order_By>
  Index?: InputMaybe<Order_By>
  Notes?: InputMaybe<Order_By>
  Period?: InputMaybe<Order_By>
  Price?: InputMaybe<Order_By>
  Trader?: InputMaybe<Order_By>
  Volume?: InputMaybe<Order_By>
  gas_trade_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** primary key columns input for table: GasTradesHistory */
export type GasTradesHistory_Pk_Columns_Input = {
  id: Scalars["Int"]["input"]
}

/** select columns of table "GasTradesHistory" */
export enum GasTradesHistory_Select_Column {
  /** column name */
  ConfirmReceived = "ConfirmReceived",
  /** column name */
  ConfirmSignedBy = "ConfirmSignedBy",
  /** column name */
  ConfirmSignedDate = "ConfirmSignedDate",
  /** column name */
  CounterParty = "CounterParty",
  /** column name */
  Date = "Date",
  /** column name */
  DateFrom = "Date_From",
  /** column name */
  DateTo = "Date_To",
  /** column name */
  Index = "Index",
  /** column name */
  Notes = "Notes",
  /** column name */
  Period = "Period",
  /** column name */
  Price = "Price",
  /** column name */
  Trader = "Trader",
  /** column name */
  Volume = "Volume",
  /** column name */
  GasTradeId = "gas_trade_id",
  /** column name */
  Id = "id",
}

/** input type for updating data in table "GasTradesHistory" */
export type GasTradesHistory_Set_Input = {
  ConfirmReceived?: InputMaybe<Scalars["datetime"]["input"]>
  ConfirmSignedBy?: InputMaybe<Scalars["String"]["input"]>
  ConfirmSignedDate?: InputMaybe<Scalars["datetime"]["input"]>
  CounterParty?: InputMaybe<Scalars["String"]["input"]>
  Date?: InputMaybe<Scalars["datetime"]["input"]>
  Date_From?: InputMaybe<Scalars["datetime"]["input"]>
  Date_To?: InputMaybe<Scalars["datetime"]["input"]>
  Index?: InputMaybe<Scalars["String"]["input"]>
  Notes?: InputMaybe<Scalars["String"]["input"]>
  Period?: InputMaybe<Scalars["String"]["input"]>
  Price?: InputMaybe<Scalars["Float"]["input"]>
  Trader?: InputMaybe<Scalars["String"]["input"]>
  Volume?: InputMaybe<Scalars["Int"]["input"]>
  gas_trade_id?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate stddev on columns */
export type GasTradesHistory_Stddev_Fields = {
  __typename?: "GasTradesHistory_stddev_fields"
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  gas_trade_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type GasTradesHistory_Stddev_Pop_Fields = {
  __typename?: "GasTradesHistory_stddev_pop_fields"
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  gas_trade_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type GasTradesHistory_Stddev_Samp_Fields = {
  __typename?: "GasTradesHistory_stddev_samp_fields"
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  gas_trade_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate sum on columns */
export type GasTradesHistory_Sum_Fields = {
  __typename?: "GasTradesHistory_sum_fields"
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Int"]["output"]>
  gas_trade_id?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
}

/** update columns of table "GasTradesHistory" */
export enum GasTradesHistory_Update_Column {
  /** column name */
  ConfirmReceived = "ConfirmReceived",
  /** column name */
  ConfirmSignedBy = "ConfirmSignedBy",
  /** column name */
  ConfirmSignedDate = "ConfirmSignedDate",
  /** column name */
  CounterParty = "CounterParty",
  /** column name */
  Date = "Date",
  /** column name */
  DateFrom = "Date_From",
  /** column name */
  DateTo = "Date_To",
  /** column name */
  Index = "Index",
  /** column name */
  Notes = "Notes",
  /** column name */
  Period = "Period",
  /** column name */
  Price = "Price",
  /** column name */
  Trader = "Trader",
  /** column name */
  Volume = "Volume",
  /** column name */
  GasTradeId = "gas_trade_id",
  /** column name */
  Id = "id",
}

/** aggregate var_pop on columns */
export type GasTradesHistory_Var_Pop_Fields = {
  __typename?: "GasTradesHistory_var_pop_fields"
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  gas_trade_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type GasTradesHistory_Var_Samp_Fields = {
  __typename?: "GasTradesHistory_var_samp_fields"
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  gas_trade_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type GasTradesHistory_Variance_Fields = {
  __typename?: "GasTradesHistory_variance_fields"
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  gas_trade_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregated selection of "GasTrades" */
export type GasTrades_Aggregate = {
  __typename?: "GasTrades_aggregate"
  aggregate?: Maybe<GasTrades_Aggregate_Fields>
  nodes: Array<GasTrades>
}

/** aggregate fields of "GasTrades" */
export type GasTrades_Aggregate_Fields = {
  __typename?: "GasTrades_aggregate_fields"
  avg?: Maybe<GasTrades_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<GasTrades_Max_Fields>
  min?: Maybe<GasTrades_Min_Fields>
  stddev?: Maybe<GasTrades_Stddev_Fields>
  stddev_pop?: Maybe<GasTrades_Stddev_Pop_Fields>
  stddev_samp?: Maybe<GasTrades_Stddev_Samp_Fields>
  sum?: Maybe<GasTrades_Sum_Fields>
  var_pop?: Maybe<GasTrades_Var_Pop_Fields>
  var_samp?: Maybe<GasTrades_Var_Samp_Fields>
  variance?: Maybe<GasTrades_Variance_Fields>
}

/** aggregate fields of "GasTrades" */
export type GasTrades_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<GasTrades_Select_Column>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type GasTrades_Avg_Fields = {
  __typename?: "GasTrades_avg_fields"
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "GasTrades". All fields are combined with a logical 'AND'. */
export type GasTrades_Bool_Exp = {
  ConfirmRecieved?: InputMaybe<Datetime_Mssql_Comparison_Exp>
  ConfirmSignedBy?: InputMaybe<String_Mssql_Comparison_Exp>
  ConfirmSignedDate?: InputMaybe<Datetime_Mssql_Comparison_Exp>
  CounterParty?: InputMaybe<String_Mssql_Comparison_Exp>
  Date?: InputMaybe<Datetime_Mssql_Comparison_Exp>
  Date_From?: InputMaybe<Datetime_Mssql_Comparison_Exp>
  Date_To?: InputMaybe<Datetime_Mssql_Comparison_Exp>
  Index?: InputMaybe<String_Mssql_Comparison_Exp>
  Locked?: InputMaybe<Boolean_Mssql_Comparison_Exp>
  Notes?: InputMaybe<String_Mssql_Comparison_Exp>
  Period?: InputMaybe<String_Mssql_Comparison_Exp>
  Price?: InputMaybe<Float_Mssql_Comparison_Exp>
  Trader?: InputMaybe<String_Mssql_Comparison_Exp>
  Volume?: InputMaybe<Int_Mssql_Comparison_Exp>
  _and?: InputMaybe<Array<GasTrades_Bool_Exp>>
  _not?: InputMaybe<GasTrades_Bool_Exp>
  _or?: InputMaybe<Array<GasTrades_Bool_Exp>>
  id?: InputMaybe<Int_Mssql_Comparison_Exp>
}

/** upsert condition type for table "GasTrades" */
export type GasTrades_If_Matched = {
  match_columns?: Array<GasTrades_Insert_Match_Column>
  update_columns?: Array<GasTrades_Update_Column>
  where?: InputMaybe<GasTrades_Bool_Exp>
}

/** input type for incrementing numeric columns in table "GasTrades" */
export type GasTrades_Inc_Input = {
  Price?: InputMaybe<Scalars["Float"]["input"]>
  Volume?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "GasTrades" */
export type GasTrades_Insert_Input = {
  ConfirmRecieved?: InputMaybe<Scalars["datetime"]["input"]>
  ConfirmSignedBy?: InputMaybe<Scalars["String"]["input"]>
  ConfirmSignedDate?: InputMaybe<Scalars["datetime"]["input"]>
  CounterParty?: InputMaybe<Scalars["String"]["input"]>
  Date?: InputMaybe<Scalars["datetime"]["input"]>
  Date_From?: InputMaybe<Scalars["datetime"]["input"]>
  Date_To?: InputMaybe<Scalars["datetime"]["input"]>
  Index?: InputMaybe<Scalars["String"]["input"]>
  Locked?: InputMaybe<Scalars["Boolean"]["input"]>
  Notes?: InputMaybe<Scalars["String"]["input"]>
  Period?: InputMaybe<Scalars["String"]["input"]>
  Price?: InputMaybe<Scalars["Float"]["input"]>
  Trader?: InputMaybe<Scalars["String"]["input"]>
  Volume?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** select match_columns of table "GasTrades" */
export enum GasTrades_Insert_Match_Column {
  /** column name */
  ConfirmRecieved = "ConfirmRecieved",
  /** column name */
  ConfirmSignedBy = "ConfirmSignedBy",
  /** column name */
  ConfirmSignedDate = "ConfirmSignedDate",
  /** column name */
  CounterParty = "CounterParty",
  /** column name */
  Date = "Date",
  /** column name */
  DateFrom = "Date_From",
  /** column name */
  DateTo = "Date_To",
  /** column name */
  Index = "Index",
  /** column name */
  Locked = "Locked",
  /** column name */
  Notes = "Notes",
  /** column name */
  Period = "Period",
  /** column name */
  Price = "Price",
  /** column name */
  Trader = "Trader",
  /** column name */
  Volume = "Volume",
  /** column name */
  Id = "id",
}

/** aggregate max on columns */
export type GasTrades_Max_Fields = {
  __typename?: "GasTrades_max_fields"
  ConfirmRecieved?: Maybe<Scalars["datetime"]["output"]>
  ConfirmSignedBy?: Maybe<Scalars["String"]["output"]>
  ConfirmSignedDate?: Maybe<Scalars["datetime"]["output"]>
  CounterParty?: Maybe<Scalars["String"]["output"]>
  Date?: Maybe<Scalars["datetime"]["output"]>
  Date_From?: Maybe<Scalars["datetime"]["output"]>
  Date_To?: Maybe<Scalars["datetime"]["output"]>
  Index?: Maybe<Scalars["String"]["output"]>
  Notes?: Maybe<Scalars["String"]["output"]>
  Period?: Maybe<Scalars["String"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Trader?: Maybe<Scalars["String"]["output"]>
  Volume?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
}

/** aggregate min on columns */
export type GasTrades_Min_Fields = {
  __typename?: "GasTrades_min_fields"
  ConfirmRecieved?: Maybe<Scalars["datetime"]["output"]>
  ConfirmSignedBy?: Maybe<Scalars["String"]["output"]>
  ConfirmSignedDate?: Maybe<Scalars["datetime"]["output"]>
  CounterParty?: Maybe<Scalars["String"]["output"]>
  Date?: Maybe<Scalars["datetime"]["output"]>
  Date_From?: Maybe<Scalars["datetime"]["output"]>
  Date_To?: Maybe<Scalars["datetime"]["output"]>
  Index?: Maybe<Scalars["String"]["output"]>
  Notes?: Maybe<Scalars["String"]["output"]>
  Period?: Maybe<Scalars["String"]["output"]>
  Price?: Maybe<Scalars["Float"]["output"]>
  Trader?: Maybe<Scalars["String"]["output"]>
  Volume?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
}

/** response of any mutation on the table "GasTrades" */
export type GasTrades_Mutation_Response = {
  __typename?: "GasTrades_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<GasTrades>
}

/** Ordering options when selecting data from "GasTrades". */
export type GasTrades_Order_By = {
  ConfirmRecieved?: InputMaybe<Order_By>
  ConfirmSignedBy?: InputMaybe<Order_By>
  ConfirmSignedDate?: InputMaybe<Order_By>
  CounterParty?: InputMaybe<Order_By>
  Date?: InputMaybe<Order_By>
  Date_From?: InputMaybe<Order_By>
  Date_To?: InputMaybe<Order_By>
  Index?: InputMaybe<Order_By>
  Locked?: InputMaybe<Order_By>
  Notes?: InputMaybe<Order_By>
  Period?: InputMaybe<Order_By>
  Price?: InputMaybe<Order_By>
  Trader?: InputMaybe<Order_By>
  Volume?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** primary key columns input for table: GasTrades */
export type GasTrades_Pk_Columns_Input = {
  id: Scalars["Int"]["input"]
}

/** select columns of table "GasTrades" */
export enum GasTrades_Select_Column {
  /** column name */
  ConfirmRecieved = "ConfirmRecieved",
  /** column name */
  ConfirmSignedBy = "ConfirmSignedBy",
  /** column name */
  ConfirmSignedDate = "ConfirmSignedDate",
  /** column name */
  CounterParty = "CounterParty",
  /** column name */
  Date = "Date",
  /** column name */
  DateFrom = "Date_From",
  /** column name */
  DateTo = "Date_To",
  /** column name */
  Index = "Index",
  /** column name */
  Locked = "Locked",
  /** column name */
  Notes = "Notes",
  /** column name */
  Period = "Period",
  /** column name */
  Price = "Price",
  /** column name */
  Trader = "Trader",
  /** column name */
  Volume = "Volume",
  /** column name */
  Id = "id",
}

/** input type for updating data in table "GasTrades" */
export type GasTrades_Set_Input = {
  ConfirmRecieved?: InputMaybe<Scalars["datetime"]["input"]>
  ConfirmSignedBy?: InputMaybe<Scalars["String"]["input"]>
  ConfirmSignedDate?: InputMaybe<Scalars["datetime"]["input"]>
  CounterParty?: InputMaybe<Scalars["String"]["input"]>
  Date?: InputMaybe<Scalars["datetime"]["input"]>
  Date_From?: InputMaybe<Scalars["datetime"]["input"]>
  Date_To?: InputMaybe<Scalars["datetime"]["input"]>
  Index?: InputMaybe<Scalars["String"]["input"]>
  Locked?: InputMaybe<Scalars["Boolean"]["input"]>
  Notes?: InputMaybe<Scalars["String"]["input"]>
  Period?: InputMaybe<Scalars["String"]["input"]>
  Price?: InputMaybe<Scalars["Float"]["input"]>
  Trader?: InputMaybe<Scalars["String"]["input"]>
  Volume?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate stddev on columns */
export type GasTrades_Stddev_Fields = {
  __typename?: "GasTrades_stddev_fields"
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type GasTrades_Stddev_Pop_Fields = {
  __typename?: "GasTrades_stddev_pop_fields"
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type GasTrades_Stddev_Samp_Fields = {
  __typename?: "GasTrades_stddev_samp_fields"
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate sum on columns */
export type GasTrades_Sum_Fields = {
  __typename?: "GasTrades_sum_fields"
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
}

/** update columns of table "GasTrades" */
export enum GasTrades_Update_Column {
  /** column name */
  ConfirmRecieved = "ConfirmRecieved",
  /** column name */
  ConfirmSignedBy = "ConfirmSignedBy",
  /** column name */
  ConfirmSignedDate = "ConfirmSignedDate",
  /** column name */
  CounterParty = "CounterParty",
  /** column name */
  Date = "Date",
  /** column name */
  DateFrom = "Date_From",
  /** column name */
  DateTo = "Date_To",
  /** column name */
  Index = "Index",
  /** column name */
  Locked = "Locked",
  /** column name */
  Notes = "Notes",
  /** column name */
  Period = "Period",
  /** column name */
  Price = "Price",
  /** column name */
  Trader = "Trader",
  /** column name */
  Volume = "Volume",
  /** column name */
  Id = "id",
}

/** aggregate var_pop on columns */
export type GasTrades_Var_Pop_Fields = {
  __typename?: "GasTrades_var_pop_fields"
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type GasTrades_Var_Samp_Fields = {
  __typename?: "GasTrades_var_samp_fields"
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type GasTrades_Variance_Fields = {
  __typename?: "GasTrades_variance_fields"
  Price?: Maybe<Scalars["Float"]["output"]>
  Volume?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

export type GetUploadedFilesResponse = {
  __typename?: "GetUploadedFilesResponse"
  images: Array<Maybe<Image>>
}

export type Image = {
  __typename?: "Image"
  date: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  url: Scalars["String"]["output"]
}

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["Int"]["input"]>
  _gt?: InputMaybe<Scalars["Int"]["input"]>
  _gte?: InputMaybe<Scalars["Int"]["input"]>
  _in?: InputMaybe<Array<Scalars["Int"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["Int"]["input"]>
  _lte?: InputMaybe<Scalars["Int"]["input"]>
  _neq?: InputMaybe<Scalars["Int"]["input"]>
  _nin?: InputMaybe<Array<Scalars["Int"]["input"]>>
}

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars["Int"]["input"]>>
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars["Int"]["input"]>>
  _eq?: InputMaybe<Array<Scalars["Int"]["input"]>>
  _gt?: InputMaybe<Array<Scalars["Int"]["input"]>>
  _gte?: InputMaybe<Array<Scalars["Int"]["input"]>>
  _in?: InputMaybe<Array<Array<Scalars["Int"]["input"]>>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Array<Scalars["Int"]["input"]>>
  _lte?: InputMaybe<Array<Scalars["Int"]["input"]>>
  _neq?: InputMaybe<Array<Scalars["Int"]["input"]>>
  _nin?: InputMaybe<Array<Array<Scalars["Int"]["input"]>>>
}

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["Int"]["input"]>
  _gt?: InputMaybe<Scalars["Int"]["input"]>
  _gte?: InputMaybe<Scalars["Int"]["input"]>
  _in?: InputMaybe<Array<Scalars["Int"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["Int"]["input"]>
  _lte?: InputMaybe<Scalars["Int"]["input"]>
  _neq?: InputMaybe<Scalars["Int"]["input"]>
  _nin?: InputMaybe<Array<Scalars["Int"]["input"]>>
}

export type NewAttributes = {
  agent?: InputMaybe<Scalars["String"]["input"]>
  ark_status?: InputMaybe<Scalars["String"]["input"]>
  date_of_birth?: InputMaybe<Scalars["String"]["input"]>
  family_name?: InputMaybe<Scalars["String"]["input"]>
  first_criteria_selection?: InputMaybe<Scalars["String"]["input"]>
  first_name?: InputMaybe<Scalars["String"]["input"]>
  phone_number?: InputMaybe<Scalars["String"]["input"]>
  second_criteria_selection?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
}

export type PaymentReviewRecordsDeleteByIdsRequest = {
  ids: Array<InputMaybe<Scalars["BigInt"]["input"]>>
}

export type PaymentReviewRecordsDeleteByIdsResponse = {
  __typename?: "PaymentReviewRecordsDeleteByIdsResponse"
  result?: Maybe<Scalars["String"]["output"]>
}

export type PaymentReviewRecordsDownloadFilters = {
  changed_amount_max?: InputMaybe<Scalars["String"]["input"]>
  changed_amount_min?: InputMaybe<Scalars["String"]["input"]>
  changed_percentage_max?: InputMaybe<Scalars["String"]["input"]>
  changed_percentage_min?: InputMaybe<Scalars["String"]["input"]>
  email_status?: InputMaybe<Scalars["String"]["input"]>
  error_codes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  from?: InputMaybe<Scalars["String"]["input"]>
  next_payment_date_from?: InputMaybe<Scalars["String"]["input"]>
  next_payment_date_to?: InputMaybe<Scalars["String"]["input"]>
  notes_status?: InputMaybe<Scalars["String"]["input"]>
  payment_review_id?: InputMaybe<Scalars["BigInt"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  to?: InputMaybe<Scalars["String"]["input"]>
}

export type PaymentReviewRecordsDownloadResponse = {
  __typename?: "PaymentReviewRecordsDownloadResponse"
  file_url: Scalars["String"]["output"]
}

export type PaymentReviewsOperationResponse = {
  __typename?: "PaymentReviewsOperationResponse"
  result?: Maybe<Scalars["String"]["output"]>
}

export type RejectApprovedApplicationsResponse = {
  __typename?: "RejectApprovedApplicationsResponse"
  errors?: Maybe<Array<Maybe<WhdError>>>
  success?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
}

export type RetryConfig = {
  enableDelay: Scalars["Boolean"]["input"]
  ignoreAccountBalance: Scalars["Boolean"]["input"]
  overrideIncreaseThreshold: Scalars["Boolean"]["input"]
}

export type RetryConfigWithIds = {
  enableDelay: Scalars["Boolean"]["input"]
  ids: Array<InputMaybe<Scalars["BigInt"]["input"]>>
  ignoreAccountBalance: Scalars["Boolean"]["input"]
  overrideIncreaseThreshold: Scalars["Boolean"]["input"]
}

export type SecondaryCriteria = {
  __typename?: "SecondaryCriteria"
  id: Scalars["Int"]["output"]
  text: Scalars["String"]["output"]
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["String"]["input"]>
  _gt?: InputMaybe<Scalars["String"]["input"]>
  _gte?: InputMaybe<Scalars["String"]["input"]>
  _in?: InputMaybe<Array<Scalars["String"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars["String"]["input"]>
  _lt?: InputMaybe<Scalars["String"]["input"]>
  _lte?: InputMaybe<Scalars["String"]["input"]>
  _neq?: InputMaybe<Scalars["String"]["input"]>
  _nin?: InputMaybe<Array<Scalars["String"]["input"]>>
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars["String"]["input"]>
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars["String"]["input"]>>
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars["String"]["input"]>>
  _eq?: InputMaybe<Array<Scalars["String"]["input"]>>
  _gt?: InputMaybe<Array<Scalars["String"]["input"]>>
  _gte?: InputMaybe<Array<Scalars["String"]["input"]>>
  _in?: InputMaybe<Array<Array<Scalars["String"]["input"]>>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Array<Scalars["String"]["input"]>>
  _lte?: InputMaybe<Array<Scalars["String"]["input"]>>
  _neq?: InputMaybe<Array<Scalars["String"]["input"]>>
  _nin?: InputMaybe<Array<Array<Scalars["String"]["input"]>>>
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["String"]["input"]>
  _gt?: InputMaybe<Scalars["String"]["input"]>
  _gte?: InputMaybe<Scalars["String"]["input"]>
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars["String"]["input"]>
  _in?: InputMaybe<Array<Scalars["String"]["input"]>>
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars["String"]["input"]>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars["String"]["input"]>
  _lt?: InputMaybe<Scalars["String"]["input"]>
  _lte?: InputMaybe<Scalars["String"]["input"]>
  _neq?: InputMaybe<Scalars["String"]["input"]>
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars["String"]["input"]>
  _nin?: InputMaybe<Array<Scalars["String"]["input"]>>
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars["String"]["input"]>
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars["String"]["input"]>
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars["String"]["input"]>
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars["String"]["input"]>
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars["String"]["input"]>
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars["String"]["input"]>
}

export type UpdateWarmHomeDiscountApplicationsRequest = {
  account_id?: InputMaybe<Scalars["String"]["input"]>
  account_number?: InputMaybe<Scalars["String"]["input"]>
  account_numbers: Array<InputMaybe<Scalars["String"]["input"]>>
  campaign_year?: InputMaybe<Scalars["String"]["input"]>
  new_attributes?: InputMaybe<NewAttributes>
}

export type UpdateWarmHomeDiscountApplicationsResponse = {
  __typename?: "UpdateWarmHomeDiscountApplicationsResponse"
  errors?: Maybe<Array<Maybe<WhdError>>>
  successful_account_numbers: Array<Maybe<Scalars["String"]["output"]>>
}

export type UserApplyReferralCodeInput = {
  referral_code: Scalars["String"]["input"]
}

export type UserChangePasswordInput = {
  password: Scalars["String"]["input"]
  password_confirmation: Scalars["String"]["input"]
}

export type UserCreateFromJuniferInput = {
  junifer_account_number: Scalars["String"]["input"]
  skip_email: Scalars["Boolean"]["input"]
}

export type UserResponse = {
  __typename?: "UserResponse"
  email?: Maybe<Scalars["String"]["output"]>
}

export type WhdInterface = {
  account_numbers?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  new_attributes?: InputMaybe<NewAttributes>
}

export type WhdApplicationsRequest = {
  account_numbers?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  number_of_applications?: InputMaybe<Scalars["numeric"]["input"]>
  skip_account_numbers: Array<InputMaybe<Scalars["String"]["input"]>>
  status?: InputMaybe<Scalars["String"]["input"]>
}

export type WhdApplicationsResponse = {
  __typename?: "WhdApplicationsResponse"
  account_id: Scalars["numeric"]["output"]
  agent?: Maybe<Scalars["String"]["output"]>
  application_year: Scalars["String"]["output"]
  ark_status_history?: Maybe<Array<Maybe<ArkStatusHistory>>>
  communication_preference: Scalars["String"]["output"]
  created_at: Scalars["date"]["output"]
  customer_details?: Maybe<CustomerDetails>
  date_of_birth?: Maybe<Scalars["date"]["output"]>
  email: Scalars["String"]["output"]
  family_name?: Maybe<Scalars["String"]["output"]>
  first_name?: Maybe<Scalars["String"]["output"]>
  id: Scalars["numeric"]["output"]
  junifer_account_number: Scalars["String"]["output"]
  phone_number?: Maybe<Scalars["String"]["output"]>
  primary_whd_criterion_id: Scalars["numeric"]["output"]
  primary_whd_criterion_text: Scalars["String"]["output"]
  secondary_whd_criterion_id: Scalars["numeric"]["output"]
  secondary_whd_criterion_text: Scalars["String"]["output"]
  status: Scalars["String"]["output"]
  updated_at: Scalars["date"]["output"]
  user_id: Scalars["numeric"]["output"]
}

export type WhdError = {
  __typename?: "WhdError"
  account_numbers: Array<Maybe<Scalars["String"]["output"]>>
  message?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
}

export type WhdExportAuditCandidatesResponse = {
  __typename?: "WhdExportAuditCandidatesResponse"
  signedUrl: Scalars["String"]["output"]
}

export type WhdExportDataResponse = {
  __typename?: "WhdExportDataResponse"
  signedUrl: Scalars["String"]["output"]
}

/** columns and relationships of "account_credit" */
export type Account_Credit = {
  __typename?: "account_credit"
  account_credit_reason_name: Scalars["String"]["output"]
  /** An object relationship */
  billing_account_transaction?: Maybe<Billing_Account_Transaction>
  billing_account_transaction_id?: Maybe<Scalars["bigint"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  created_user?: Maybe<Scalars["String"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  gross_amount_in_pounds: Scalars["numeric"]["output"]
  id: Scalars["bigint"]["output"]
  reference?: Maybe<Scalars["String"]["output"]>
  sales_tax_name?: Maybe<Scalars["String"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "account_credit" */
export type Account_Credit_Aggregate = {
  __typename?: "account_credit_aggregate"
  aggregate?: Maybe<Account_Credit_Aggregate_Fields>
  nodes: Array<Account_Credit>
}

/** aggregate fields of "account_credit" */
export type Account_Credit_Aggregate_Fields = {
  __typename?: "account_credit_aggregate_fields"
  avg?: Maybe<Account_Credit_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Account_Credit_Max_Fields>
  min?: Maybe<Account_Credit_Min_Fields>
  stddev?: Maybe<Account_Credit_Stddev_Fields>
  stddev_pop?: Maybe<Account_Credit_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Account_Credit_Stddev_Samp_Fields>
  sum?: Maybe<Account_Credit_Sum_Fields>
  var_pop?: Maybe<Account_Credit_Var_Pop_Fields>
  var_samp?: Maybe<Account_Credit_Var_Samp_Fields>
  variance?: Maybe<Account_Credit_Variance_Fields>
}

/** aggregate fields of "account_credit" */
export type Account_Credit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Account_Credit_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Account_Credit_Avg_Fields = {
  __typename?: "account_credit_avg_fields"
  billing_account_transaction_id?: Maybe<Scalars["Float"]["output"]>
  gross_amount_in_pounds?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "account_credit". All fields are combined with a logical 'AND'. */
export type Account_Credit_Bool_Exp = {
  _and?: InputMaybe<Array<Account_Credit_Bool_Exp>>
  _not?: InputMaybe<Account_Credit_Bool_Exp>
  _or?: InputMaybe<Array<Account_Credit_Bool_Exp>>
  account_credit_reason_name?: InputMaybe<String_Comparison_Exp>
  billing_account_transaction?: InputMaybe<Billing_Account_Transaction_Bool_Exp>
  billing_account_transaction_id?: InputMaybe<Bigint_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  created_user?: InputMaybe<String_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>
  gross_amount_in_pounds?: InputMaybe<Numeric_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  reference?: InputMaybe<String_Comparison_Exp>
  sales_tax_name?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "account_credit" */
export enum Account_Credit_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkAccountCredit = "pk_account_credit",
}

/** input type for incrementing numeric columns in table "account_credit" */
export type Account_Credit_Inc_Input = {
  billing_account_transaction_id?: InputMaybe<Scalars["bigint"]["input"]>
  gross_amount_in_pounds?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "account_credit" */
export type Account_Credit_Insert_Input = {
  account_credit_reason_name?: InputMaybe<Scalars["String"]["input"]>
  billing_account_transaction?: InputMaybe<Billing_Account_Transaction_Obj_Rel_Insert_Input>
  billing_account_transaction_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  created_user?: InputMaybe<Scalars["String"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  gross_amount_in_pounds?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  sales_tax_name?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Account_Credit_Max_Fields = {
  __typename?: "account_credit_max_fields"
  account_credit_reason_name?: Maybe<Scalars["String"]["output"]>
  billing_account_transaction_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  created_user?: Maybe<Scalars["String"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  gross_amount_in_pounds?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  sales_tax_name?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Account_Credit_Min_Fields = {
  __typename?: "account_credit_min_fields"
  account_credit_reason_name?: Maybe<Scalars["String"]["output"]>
  billing_account_transaction_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  created_user?: Maybe<Scalars["String"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  gross_amount_in_pounds?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  sales_tax_name?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "account_credit" */
export type Account_Credit_Mutation_Response = {
  __typename?: "account_credit_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Account_Credit>
}

/** on_conflict condition type for table "account_credit" */
export type Account_Credit_On_Conflict = {
  constraint: Account_Credit_Constraint
  update_columns?: Array<Account_Credit_Update_Column>
  where?: InputMaybe<Account_Credit_Bool_Exp>
}

/** Ordering options when selecting data from "account_credit". */
export type Account_Credit_Order_By = {
  account_credit_reason_name?: InputMaybe<Order_By>
  billing_account_transaction?: InputMaybe<Billing_Account_Transaction_Order_By>
  billing_account_transaction_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  created_user?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  gross_amount_in_pounds?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  reference?: InputMaybe<Order_By>
  sales_tax_name?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: account_credit */
export type Account_Credit_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "account_credit" */
export enum Account_Credit_Select_Column {
  /** column name */
  AccountCreditReasonName = "account_credit_reason_name",
  /** column name */
  BillingAccountTransactionId = "billing_account_transaction_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CreatedUser = "created_user",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  GrossAmountInPounds = "gross_amount_in_pounds",
  /** column name */
  Id = "id",
  /** column name */
  Reference = "reference",
  /** column name */
  SalesTaxName = "sales_tax_name",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "account_credit" */
export type Account_Credit_Set_Input = {
  account_credit_reason_name?: InputMaybe<Scalars["String"]["input"]>
  billing_account_transaction_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  created_user?: InputMaybe<Scalars["String"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  gross_amount_in_pounds?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  sales_tax_name?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Account_Credit_Stddev_Fields = {
  __typename?: "account_credit_stddev_fields"
  billing_account_transaction_id?: Maybe<Scalars["Float"]["output"]>
  gross_amount_in_pounds?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Account_Credit_Stddev_Pop_Fields = {
  __typename?: "account_credit_stddev_pop_fields"
  billing_account_transaction_id?: Maybe<Scalars["Float"]["output"]>
  gross_amount_in_pounds?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Account_Credit_Stddev_Samp_Fields = {
  __typename?: "account_credit_stddev_samp_fields"
  billing_account_transaction_id?: Maybe<Scalars["Float"]["output"]>
  gross_amount_in_pounds?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "account_credit" */
export type Account_Credit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Account_Credit_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Account_Credit_Stream_Cursor_Value_Input = {
  account_credit_reason_name?: InputMaybe<Scalars["String"]["input"]>
  billing_account_transaction_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  created_user?: InputMaybe<Scalars["String"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  gross_amount_in_pounds?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  sales_tax_name?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Account_Credit_Sum_Fields = {
  __typename?: "account_credit_sum_fields"
  billing_account_transaction_id?: Maybe<Scalars["bigint"]["output"]>
  gross_amount_in_pounds?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "account_credit" */
export enum Account_Credit_Update_Column {
  /** column name */
  AccountCreditReasonName = "account_credit_reason_name",
  /** column name */
  BillingAccountTransactionId = "billing_account_transaction_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CreatedUser = "created_user",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  GrossAmountInPounds = "gross_amount_in_pounds",
  /** column name */
  Id = "id",
  /** column name */
  Reference = "reference",
  /** column name */
  SalesTaxName = "sales_tax_name",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Account_Credit_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Account_Credit_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Account_Credit_Set_Input>
  /** filter the rows which have to be updated */
  where: Account_Credit_Bool_Exp
}

/** aggregate var_pop on columns */
export type Account_Credit_Var_Pop_Fields = {
  __typename?: "account_credit_var_pop_fields"
  billing_account_transaction_id?: Maybe<Scalars["Float"]["output"]>
  gross_amount_in_pounds?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Account_Credit_Var_Samp_Fields = {
  __typename?: "account_credit_var_samp_fields"
  billing_account_transaction_id?: Maybe<Scalars["Float"]["output"]>
  gross_amount_in_pounds?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Account_Credit_Variance_Fields = {
  __typename?: "account_credit_variance_fields"
  billing_account_transaction_id?: Maybe<Scalars["Float"]["output"]>
  gross_amount_in_pounds?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "account_event_status". All fields are combined with logical 'AND'. */
export type Account_Event_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["account_event_status"]["input"]>
  _gt?: InputMaybe<Scalars["account_event_status"]["input"]>
  _gte?: InputMaybe<Scalars["account_event_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["account_event_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["account_event_status"]["input"]>
  _lte?: InputMaybe<Scalars["account_event_status"]["input"]>
  _neq?: InputMaybe<Scalars["account_event_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["account_event_status"]["input"]>>
}

/** Boolean expression to compare columns of type "account_group_enum". All fields are combined with logical 'AND'. */
export type Account_Group_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["account_group_enum"]["input"]>
  _gt?: InputMaybe<Scalars["account_group_enum"]["input"]>
  _gte?: InputMaybe<Scalars["account_group_enum"]["input"]>
  _in?: InputMaybe<Array<Scalars["account_group_enum"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["account_group_enum"]["input"]>
  _lte?: InputMaybe<Scalars["account_group_enum"]["input"]>
  _neq?: InputMaybe<Scalars["account_group_enum"]["input"]>
  _nin?: InputMaybe<Array<Scalars["account_group_enum"]["input"]>>
}

/** Boolean expression to compare columns of type "account_state". All fields are combined with logical 'AND'. */
export type Account_State_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["account_state"]["input"]>
  _gt?: InputMaybe<Scalars["account_state"]["input"]>
  _gte?: InputMaybe<Scalars["account_state"]["input"]>
  _in?: InputMaybe<Array<Scalars["account_state"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["account_state"]["input"]>
  _lte?: InputMaybe<Scalars["account_state"]["input"]>
  _neq?: InputMaybe<Scalars["account_state"]["input"]>
  _nin?: InputMaybe<Array<Scalars["account_state"]["input"]>>
}

/** Boolean expression to compare columns of type "account_sub_group_enum". All fields are combined with logical 'AND'. */
export type Account_Sub_Group_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["account_sub_group_enum"]["input"]>
  _gt?: InputMaybe<Scalars["account_sub_group_enum"]["input"]>
  _gte?: InputMaybe<Scalars["account_sub_group_enum"]["input"]>
  _in?: InputMaybe<Array<Scalars["account_sub_group_enum"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["account_sub_group_enum"]["input"]>
  _lte?: InputMaybe<Scalars["account_sub_group_enum"]["input"]>
  _neq?: InputMaybe<Scalars["account_sub_group_enum"]["input"]>
  _nin?: InputMaybe<Array<Scalars["account_sub_group_enum"]["input"]>>
}

/** columns and relationships of "active_outbound_photo_request" */
export type Active_Outbound_Photo_Request = {
  __typename?: "active_outbound_photo_request"
  account_id?: Maybe<Scalars["bigint"]["output"]>
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  emails_sent_at?: Maybe<Scalars["jsonb"]["output"]>
  freshdesk_group_id?: Maybe<Scalars["bigint"]["output"]>
  freshdesk_group_name?: Maybe<Scalars["String"]["output"]>
  freshdesk_ticket_id?: Maybe<Scalars["bigint"]["output"]>
  fuel?: Maybe<Scalars["meter_reading_fuel"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_email_sent_at?: Maybe<Scalars["date"]["output"]>
  request_reason?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["outbound_photo_request_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** columns and relationships of "active_outbound_photo_request" */
export type Active_Outbound_Photo_RequestEmails_Sent_AtArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregated selection of "active_outbound_photo_request" */
export type Active_Outbound_Photo_Request_Aggregate = {
  __typename?: "active_outbound_photo_request_aggregate"
  aggregate?: Maybe<Active_Outbound_Photo_Request_Aggregate_Fields>
  nodes: Array<Active_Outbound_Photo_Request>
}

/** aggregate fields of "active_outbound_photo_request" */
export type Active_Outbound_Photo_Request_Aggregate_Fields = {
  __typename?: "active_outbound_photo_request_aggregate_fields"
  avg?: Maybe<Active_Outbound_Photo_Request_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Active_Outbound_Photo_Request_Max_Fields>
  min?: Maybe<Active_Outbound_Photo_Request_Min_Fields>
  stddev?: Maybe<Active_Outbound_Photo_Request_Stddev_Fields>
  stddev_pop?: Maybe<Active_Outbound_Photo_Request_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Active_Outbound_Photo_Request_Stddev_Samp_Fields>
  sum?: Maybe<Active_Outbound_Photo_Request_Sum_Fields>
  var_pop?: Maybe<Active_Outbound_Photo_Request_Var_Pop_Fields>
  var_samp?: Maybe<Active_Outbound_Photo_Request_Var_Samp_Fields>
  variance?: Maybe<Active_Outbound_Photo_Request_Variance_Fields>
}

/** aggregate fields of "active_outbound_photo_request" */
export type Active_Outbound_Photo_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Active_Outbound_Photo_Request_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Active_Outbound_Photo_Request_Append_Input = {
  emails_sent_at?: InputMaybe<Scalars["jsonb"]["input"]>
}

/** aggregate avg on columns */
export type Active_Outbound_Photo_Request_Avg_Fields = {
  __typename?: "active_outbound_photo_request_avg_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_group_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_ticket_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "active_outbound_photo_request". All fields are combined with a logical 'AND'. */
export type Active_Outbound_Photo_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Active_Outbound_Photo_Request_Bool_Exp>>
  _not?: InputMaybe<Active_Outbound_Photo_Request_Bool_Exp>
  _or?: InputMaybe<Array<Active_Outbound_Photo_Request_Bool_Exp>>
  account_id?: InputMaybe<Bigint_Comparison_Exp>
  account_number?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  email_message_id?: InputMaybe<Bigint_Comparison_Exp>
  emails_sent_at?: InputMaybe<Jsonb_Comparison_Exp>
  freshdesk_group_id?: InputMaybe<Bigint_Comparison_Exp>
  freshdesk_group_name?: InputMaybe<String_Comparison_Exp>
  freshdesk_ticket_id?: InputMaybe<Bigint_Comparison_Exp>
  fuel?: InputMaybe<Meter_Reading_Fuel_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  last_email_sent_at?: InputMaybe<Date_Comparison_Exp>
  request_reason?: InputMaybe<String_Comparison_Exp>
  status?: InputMaybe<Outbound_Photo_Request_Status_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Active_Outbound_Photo_Request_Delete_At_Path_Input = {
  emails_sent_at?: InputMaybe<Array<Scalars["String"]["input"]>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Active_Outbound_Photo_Request_Delete_Elem_Input = {
  emails_sent_at?: InputMaybe<Scalars["Int"]["input"]>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Active_Outbound_Photo_Request_Delete_Key_Input = {
  emails_sent_at?: InputMaybe<Scalars["String"]["input"]>
}

/** input type for incrementing numeric columns in table "active_outbound_photo_request" */
export type Active_Outbound_Photo_Request_Inc_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  freshdesk_group_id?: InputMaybe<Scalars["bigint"]["input"]>
  freshdesk_ticket_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "active_outbound_photo_request" */
export type Active_Outbound_Photo_Request_Insert_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  emails_sent_at?: InputMaybe<Scalars["jsonb"]["input"]>
  freshdesk_group_id?: InputMaybe<Scalars["bigint"]["input"]>
  freshdesk_group_name?: InputMaybe<Scalars["String"]["input"]>
  freshdesk_ticket_id?: InputMaybe<Scalars["bigint"]["input"]>
  fuel?: InputMaybe<Scalars["meter_reading_fuel"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_email_sent_at?: InputMaybe<Scalars["date"]["input"]>
  request_reason?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["outbound_photo_request_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Active_Outbound_Photo_Request_Max_Fields = {
  __typename?: "active_outbound_photo_request_max_fields"
  account_id?: Maybe<Scalars["bigint"]["output"]>
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  freshdesk_group_id?: Maybe<Scalars["bigint"]["output"]>
  freshdesk_group_name?: Maybe<Scalars["String"]["output"]>
  freshdesk_ticket_id?: Maybe<Scalars["bigint"]["output"]>
  fuel?: Maybe<Scalars["meter_reading_fuel"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_email_sent_at?: Maybe<Scalars["date"]["output"]>
  request_reason?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["outbound_photo_request_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Active_Outbound_Photo_Request_Min_Fields = {
  __typename?: "active_outbound_photo_request_min_fields"
  account_id?: Maybe<Scalars["bigint"]["output"]>
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  freshdesk_group_id?: Maybe<Scalars["bigint"]["output"]>
  freshdesk_group_name?: Maybe<Scalars["String"]["output"]>
  freshdesk_ticket_id?: Maybe<Scalars["bigint"]["output"]>
  fuel?: Maybe<Scalars["meter_reading_fuel"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_email_sent_at?: Maybe<Scalars["date"]["output"]>
  request_reason?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["outbound_photo_request_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "active_outbound_photo_request" */
export type Active_Outbound_Photo_Request_Mutation_Response = {
  __typename?: "active_outbound_photo_request_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Active_Outbound_Photo_Request>
}

/** Ordering options when selecting data from "active_outbound_photo_request". */
export type Active_Outbound_Photo_Request_Order_By = {
  account_id?: InputMaybe<Order_By>
  account_number?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  email_message_id?: InputMaybe<Order_By>
  emails_sent_at?: InputMaybe<Order_By>
  freshdesk_group_id?: InputMaybe<Order_By>
  freshdesk_group_name?: InputMaybe<Order_By>
  freshdesk_ticket_id?: InputMaybe<Order_By>
  fuel?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  last_email_sent_at?: InputMaybe<Order_By>
  request_reason?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Active_Outbound_Photo_Request_Prepend_Input = {
  emails_sent_at?: InputMaybe<Scalars["jsonb"]["input"]>
}

/** select columns of table "active_outbound_photo_request" */
export enum Active_Outbound_Photo_Request_Select_Column {
  /** column name */
  AccountId = "account_id",
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  EmailMessageId = "email_message_id",
  /** column name */
  EmailsSentAt = "emails_sent_at",
  /** column name */
  FreshdeskGroupId = "freshdesk_group_id",
  /** column name */
  FreshdeskGroupName = "freshdesk_group_name",
  /** column name */
  FreshdeskTicketId = "freshdesk_ticket_id",
  /** column name */
  Fuel = "fuel",
  /** column name */
  Id = "id",
  /** column name */
  LastEmailSentAt = "last_email_sent_at",
  /** column name */
  RequestReason = "request_reason",
  /** column name */
  Status = "status",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "active_outbound_photo_request" */
export type Active_Outbound_Photo_Request_Set_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  emails_sent_at?: InputMaybe<Scalars["jsonb"]["input"]>
  freshdesk_group_id?: InputMaybe<Scalars["bigint"]["input"]>
  freshdesk_group_name?: InputMaybe<Scalars["String"]["input"]>
  freshdesk_ticket_id?: InputMaybe<Scalars["bigint"]["input"]>
  fuel?: InputMaybe<Scalars["meter_reading_fuel"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_email_sent_at?: InputMaybe<Scalars["date"]["input"]>
  request_reason?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["outbound_photo_request_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Active_Outbound_Photo_Request_Stddev_Fields = {
  __typename?: "active_outbound_photo_request_stddev_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_group_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_ticket_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Active_Outbound_Photo_Request_Stddev_Pop_Fields = {
  __typename?: "active_outbound_photo_request_stddev_pop_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_group_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_ticket_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Active_Outbound_Photo_Request_Stddev_Samp_Fields = {
  __typename?: "active_outbound_photo_request_stddev_samp_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_group_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_ticket_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "active_outbound_photo_request" */
export type Active_Outbound_Photo_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Active_Outbound_Photo_Request_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Active_Outbound_Photo_Request_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  emails_sent_at?: InputMaybe<Scalars["jsonb"]["input"]>
  freshdesk_group_id?: InputMaybe<Scalars["bigint"]["input"]>
  freshdesk_group_name?: InputMaybe<Scalars["String"]["input"]>
  freshdesk_ticket_id?: InputMaybe<Scalars["bigint"]["input"]>
  fuel?: InputMaybe<Scalars["meter_reading_fuel"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_email_sent_at?: InputMaybe<Scalars["date"]["input"]>
  request_reason?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["outbound_photo_request_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Active_Outbound_Photo_Request_Sum_Fields = {
  __typename?: "active_outbound_photo_request_sum_fields"
  account_id?: Maybe<Scalars["bigint"]["output"]>
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  freshdesk_group_id?: Maybe<Scalars["bigint"]["output"]>
  freshdesk_ticket_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

export type Active_Outbound_Photo_Request_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Active_Outbound_Photo_Request_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Active_Outbound_Photo_Request_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Active_Outbound_Photo_Request_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Active_Outbound_Photo_Request_Delete_Key_Input>
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Active_Outbound_Photo_Request_Inc_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Active_Outbound_Photo_Request_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Active_Outbound_Photo_Request_Set_Input>
  /** filter the rows which have to be updated */
  where: Active_Outbound_Photo_Request_Bool_Exp
}

/** aggregate var_pop on columns */
export type Active_Outbound_Photo_Request_Var_Pop_Fields = {
  __typename?: "active_outbound_photo_request_var_pop_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_group_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_ticket_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Active_Outbound_Photo_Request_Var_Samp_Fields = {
  __typename?: "active_outbound_photo_request_var_samp_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_group_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_ticket_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Active_Outbound_Photo_Request_Variance_Fields = {
  __typename?: "active_outbound_photo_request_variance_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_group_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_ticket_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "address" */
export type Address = {
  __typename?: "address"
  address1?: Maybe<Scalars["String"]["output"]>
  address2?: Maybe<Scalars["String"]["output"]>
  address3?: Maybe<Scalars["String"]["output"]>
  address4?: Maybe<Scalars["String"]["output"]>
  address5?: Maybe<Scalars["String"]["output"]>
  address6?: Maybe<Scalars["String"]["output"]>
  address7?: Maybe<Scalars["String"]["output"]>
  address8?: Maybe<Scalars["String"]["output"]>
  address9?: Maybe<Scalars["String"]["output"]>
  country_code?: Maybe<Scalars["String"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  postcode?: Maybe<Scalars["String"]["output"]>
  /** An array relationship */
  properties: Array<Property>
  /** An aggregate relationship */
  properties_aggregate: Property_Aggregate
  type: Scalars["String"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "address" */
export type AddressPropertiesArgs = {
  distinct_on?: InputMaybe<Array<Property_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Property_Order_By>>
  where?: InputMaybe<Property_Bool_Exp>
}

/** columns and relationships of "address" */
export type AddressProperties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Property_Order_By>>
  where?: InputMaybe<Property_Bool_Exp>
}

/** aggregated selection of "address" */
export type Address_Aggregate = {
  __typename?: "address_aggregate"
  aggregate?: Maybe<Address_Aggregate_Fields>
  nodes: Array<Address>
}

/** aggregate fields of "address" */
export type Address_Aggregate_Fields = {
  __typename?: "address_aggregate_fields"
  avg?: Maybe<Address_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Address_Max_Fields>
  min?: Maybe<Address_Min_Fields>
  stddev?: Maybe<Address_Stddev_Fields>
  stddev_pop?: Maybe<Address_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Address_Stddev_Samp_Fields>
  sum?: Maybe<Address_Sum_Fields>
  var_pop?: Maybe<Address_Var_Pop_Fields>
  var_samp?: Maybe<Address_Var_Samp_Fields>
  variance?: Maybe<Address_Variance_Fields>
}

/** aggregate fields of "address" */
export type Address_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Address_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Address_Avg_Fields = {
  __typename?: "address_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "address". All fields are combined with a logical 'AND'. */
export type Address_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Bool_Exp>>
  _not?: InputMaybe<Address_Bool_Exp>
  _or?: InputMaybe<Array<Address_Bool_Exp>>
  address1?: InputMaybe<String_Comparison_Exp>
  address2?: InputMaybe<String_Comparison_Exp>
  address3?: InputMaybe<String_Comparison_Exp>
  address4?: InputMaybe<String_Comparison_Exp>
  address5?: InputMaybe<String_Comparison_Exp>
  address6?: InputMaybe<String_Comparison_Exp>
  address7?: InputMaybe<String_Comparison_Exp>
  address8?: InputMaybe<String_Comparison_Exp>
  address9?: InputMaybe<String_Comparison_Exp>
  country_code?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  postcode?: InputMaybe<String_Comparison_Exp>
  properties?: InputMaybe<Property_Bool_Exp>
  properties_aggregate?: InputMaybe<Property_Aggregate_Bool_Exp>
  type?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "address" */
export enum Address_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkAddress = "pk_address",
}

/** input type for incrementing numeric columns in table "address" */
export type Address_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "address" */
export type Address_Insert_Input = {
  address1?: InputMaybe<Scalars["String"]["input"]>
  address2?: InputMaybe<Scalars["String"]["input"]>
  address3?: InputMaybe<Scalars["String"]["input"]>
  address4?: InputMaybe<Scalars["String"]["input"]>
  address5?: InputMaybe<Scalars["String"]["input"]>
  address6?: InputMaybe<Scalars["String"]["input"]>
  address7?: InputMaybe<Scalars["String"]["input"]>
  address8?: InputMaybe<Scalars["String"]["input"]>
  address9?: InputMaybe<Scalars["String"]["input"]>
  country_code?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  properties?: InputMaybe<Property_Arr_Rel_Insert_Input>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Address_Max_Fields = {
  __typename?: "address_max_fields"
  address1?: Maybe<Scalars["String"]["output"]>
  address2?: Maybe<Scalars["String"]["output"]>
  address3?: Maybe<Scalars["String"]["output"]>
  address4?: Maybe<Scalars["String"]["output"]>
  address5?: Maybe<Scalars["String"]["output"]>
  address6?: Maybe<Scalars["String"]["output"]>
  address7?: Maybe<Scalars["String"]["output"]>
  address8?: Maybe<Scalars["String"]["output"]>
  address9?: Maybe<Scalars["String"]["output"]>
  country_code?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  postcode?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Address_Min_Fields = {
  __typename?: "address_min_fields"
  address1?: Maybe<Scalars["String"]["output"]>
  address2?: Maybe<Scalars["String"]["output"]>
  address3?: Maybe<Scalars["String"]["output"]>
  address4?: Maybe<Scalars["String"]["output"]>
  address5?: Maybe<Scalars["String"]["output"]>
  address6?: Maybe<Scalars["String"]["output"]>
  address7?: Maybe<Scalars["String"]["output"]>
  address8?: Maybe<Scalars["String"]["output"]>
  address9?: Maybe<Scalars["String"]["output"]>
  country_code?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  postcode?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "address" */
export type Address_Mutation_Response = {
  __typename?: "address_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Address>
}

/** input type for inserting object relation for remote table "address" */
export type Address_Obj_Rel_Insert_Input = {
  data: Address_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Address_On_Conflict>
}

/** on_conflict condition type for table "address" */
export type Address_On_Conflict = {
  constraint: Address_Constraint
  update_columns?: Array<Address_Update_Column>
  where?: InputMaybe<Address_Bool_Exp>
}

/** Ordering options when selecting data from "address". */
export type Address_Order_By = {
  address1?: InputMaybe<Order_By>
  address2?: InputMaybe<Order_By>
  address3?: InputMaybe<Order_By>
  address4?: InputMaybe<Order_By>
  address5?: InputMaybe<Order_By>
  address6?: InputMaybe<Order_By>
  address7?: InputMaybe<Order_By>
  address8?: InputMaybe<Order_By>
  address9?: InputMaybe<Order_By>
  country_code?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  postcode?: InputMaybe<Order_By>
  properties_aggregate?: InputMaybe<Property_Aggregate_Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: address */
export type Address_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "address" */
export enum Address_Select_Column {
  /** column name */
  Address1 = "address1",
  /** column name */
  Address2 = "address2",
  /** column name */
  Address3 = "address3",
  /** column name */
  Address4 = "address4",
  /** column name */
  Address5 = "address5",
  /** column name */
  Address6 = "address6",
  /** column name */
  Address7 = "address7",
  /** column name */
  Address8 = "address8",
  /** column name */
  Address9 = "address9",
  /** column name */
  CountryCode = "country_code",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  Postcode = "postcode",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "address" */
export type Address_Set_Input = {
  address1?: InputMaybe<Scalars["String"]["input"]>
  address2?: InputMaybe<Scalars["String"]["input"]>
  address3?: InputMaybe<Scalars["String"]["input"]>
  address4?: InputMaybe<Scalars["String"]["input"]>
  address5?: InputMaybe<Scalars["String"]["input"]>
  address6?: InputMaybe<Scalars["String"]["input"]>
  address7?: InputMaybe<Scalars["String"]["input"]>
  address8?: InputMaybe<Scalars["String"]["input"]>
  address9?: InputMaybe<Scalars["String"]["input"]>
  country_code?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Address_Stddev_Fields = {
  __typename?: "address_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Address_Stddev_Pop_Fields = {
  __typename?: "address_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Address_Stddev_Samp_Fields = {
  __typename?: "address_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "address" */
export type Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Address_Stream_Cursor_Value_Input = {
  address1?: InputMaybe<Scalars["String"]["input"]>
  address2?: InputMaybe<Scalars["String"]["input"]>
  address3?: InputMaybe<Scalars["String"]["input"]>
  address4?: InputMaybe<Scalars["String"]["input"]>
  address5?: InputMaybe<Scalars["String"]["input"]>
  address6?: InputMaybe<Scalars["String"]["input"]>
  address7?: InputMaybe<Scalars["String"]["input"]>
  address8?: InputMaybe<Scalars["String"]["input"]>
  address9?: InputMaybe<Scalars["String"]["input"]>
  country_code?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Address_Sum_Fields = {
  __typename?: "address_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "address" */
export enum Address_Update_Column {
  /** column name */
  Address1 = "address1",
  /** column name */
  Address2 = "address2",
  /** column name */
  Address3 = "address3",
  /** column name */
  Address4 = "address4",
  /** column name */
  Address5 = "address5",
  /** column name */
  Address6 = "address6",
  /** column name */
  Address7 = "address7",
  /** column name */
  Address8 = "address8",
  /** column name */
  Address9 = "address9",
  /** column name */
  CountryCode = "country_code",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  Postcode = "postcode",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Address_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Address_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Address_Set_Input>
  /** filter the rows which have to be updated */
  where: Address_Bool_Exp
}

/** aggregate var_pop on columns */
export type Address_Var_Pop_Fields = {
  __typename?: "address_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Address_Var_Samp_Fields = {
  __typename?: "address_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Address_Variance_Fields = {
  __typename?: "address_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "admin_passes" */
export type Admin_Passes = {
  __typename?: "admin_passes"
  admin_id?: Maybe<Scalars["String"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  id: Scalars["Int"]["output"]
  processed?: Maybe<Scalars["Boolean"]["output"]>
  token?: Maybe<Scalars["bytea"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
  /** An object relationship */
  user?: Maybe<Users>
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregated selection of "admin_passes" */
export type Admin_Passes_Aggregate = {
  __typename?: "admin_passes_aggregate"
  aggregate?: Maybe<Admin_Passes_Aggregate_Fields>
  nodes: Array<Admin_Passes>
}

export type Admin_Passes_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Admin_Passes_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Admin_Passes_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<Admin_Passes_Aggregate_Bool_Exp_Count>
}

export type Admin_Passes_Aggregate_Bool_Exp_Bool_And = {
  arguments: Admin_Passes_Select_Column_Admin_Passes_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Admin_Passes_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Admin_Passes_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Admin_Passes_Select_Column_Admin_Passes_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Admin_Passes_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Admin_Passes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Admin_Passes_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Admin_Passes_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "admin_passes" */
export type Admin_Passes_Aggregate_Fields = {
  __typename?: "admin_passes_aggregate_fields"
  avg?: Maybe<Admin_Passes_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Admin_Passes_Max_Fields>
  min?: Maybe<Admin_Passes_Min_Fields>
  stddev?: Maybe<Admin_Passes_Stddev_Fields>
  stddev_pop?: Maybe<Admin_Passes_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Admin_Passes_Stddev_Samp_Fields>
  sum?: Maybe<Admin_Passes_Sum_Fields>
  var_pop?: Maybe<Admin_Passes_Var_Pop_Fields>
  var_samp?: Maybe<Admin_Passes_Var_Samp_Fields>
  variance?: Maybe<Admin_Passes_Variance_Fields>
}

/** aggregate fields of "admin_passes" */
export type Admin_Passes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Admin_Passes_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "admin_passes" */
export type Admin_Passes_Aggregate_Order_By = {
  avg?: InputMaybe<Admin_Passes_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Admin_Passes_Max_Order_By>
  min?: InputMaybe<Admin_Passes_Min_Order_By>
  stddev?: InputMaybe<Admin_Passes_Stddev_Order_By>
  stddev_pop?: InputMaybe<Admin_Passes_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Admin_Passes_Stddev_Samp_Order_By>
  sum?: InputMaybe<Admin_Passes_Sum_Order_By>
  var_pop?: InputMaybe<Admin_Passes_Var_Pop_Order_By>
  var_samp?: InputMaybe<Admin_Passes_Var_Samp_Order_By>
  variance?: InputMaybe<Admin_Passes_Variance_Order_By>
}

/** input type for inserting array relation for remote table "admin_passes" */
export type Admin_Passes_Arr_Rel_Insert_Input = {
  data: Array<Admin_Passes_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Admin_Passes_On_Conflict>
}

/** aggregate avg on columns */
export type Admin_Passes_Avg_Fields = {
  __typename?: "admin_passes_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "admin_passes" */
export type Admin_Passes_Avg_Order_By = {
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "admin_passes". All fields are combined with a logical 'AND'. */
export type Admin_Passes_Bool_Exp = {
  _and?: InputMaybe<Array<Admin_Passes_Bool_Exp>>
  _not?: InputMaybe<Admin_Passes_Bool_Exp>
  _or?: InputMaybe<Array<Admin_Passes_Bool_Exp>>
  admin_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Int_Comparison_Exp>
  processed?: InputMaybe<Boolean_Comparison_Exp>
  token?: InputMaybe<Bytea_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  user?: InputMaybe<Users_Bool_Exp>
  user_id?: InputMaybe<Bigint_Comparison_Exp>
}

/** unique or primary key constraints on table "admin_passes" */
export enum Admin_Passes_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkAdminPasses = "pk_admin_passes",
}

/** input type for incrementing numeric columns in table "admin_passes" */
export type Admin_Passes_Inc_Input = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "admin_passes" */
export type Admin_Passes_Insert_Input = {
  admin_id?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
  processed?: InputMaybe<Scalars["Boolean"]["input"]>
  token?: InputMaybe<Scalars["bytea"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate max on columns */
export type Admin_Passes_Max_Fields = {
  __typename?: "admin_passes_max_fields"
  admin_id?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by max() on columns of table "admin_passes" */
export type Admin_Passes_Max_Order_By = {
  admin_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Admin_Passes_Min_Fields = {
  __typename?: "admin_passes_min_fields"
  admin_id?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by min() on columns of table "admin_passes" */
export type Admin_Passes_Min_Order_By = {
  admin_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** response of any mutation on the table "admin_passes" */
export type Admin_Passes_Mutation_Response = {
  __typename?: "admin_passes_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Admin_Passes>
}

/** on_conflict condition type for table "admin_passes" */
export type Admin_Passes_On_Conflict = {
  constraint: Admin_Passes_Constraint
  update_columns?: Array<Admin_Passes_Update_Column>
  where?: InputMaybe<Admin_Passes_Bool_Exp>
}

/** Ordering options when selecting data from "admin_passes". */
export type Admin_Passes_Order_By = {
  admin_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  processed?: InputMaybe<Order_By>
  token?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user?: InputMaybe<Users_Order_By>
  user_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: admin_passes */
export type Admin_Passes_Pk_Columns_Input = {
  id: Scalars["Int"]["input"]
}

/** select columns of table "admin_passes" */
export enum Admin_Passes_Select_Column {
  /** column name */
  AdminId = "admin_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  Processed = "processed",
  /** column name */
  Token = "token",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  UserId = "user_id",
}

/** select "admin_passes_aggregate_bool_exp_bool_and_arguments_columns" columns of table "admin_passes" */
export enum Admin_Passes_Select_Column_Admin_Passes_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Processed = "processed",
}

/** select "admin_passes_aggregate_bool_exp_bool_or_arguments_columns" columns of table "admin_passes" */
export enum Admin_Passes_Select_Column_Admin_Passes_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Processed = "processed",
}

/** input type for updating data in table "admin_passes" */
export type Admin_Passes_Set_Input = {
  admin_id?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
  processed?: InputMaybe<Scalars["Boolean"]["input"]>
  token?: InputMaybe<Scalars["bytea"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate stddev on columns */
export type Admin_Passes_Stddev_Fields = {
  __typename?: "admin_passes_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "admin_passes" */
export type Admin_Passes_Stddev_Order_By = {
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Admin_Passes_Stddev_Pop_Fields = {
  __typename?: "admin_passes_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "admin_passes" */
export type Admin_Passes_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Admin_Passes_Stddev_Samp_Fields = {
  __typename?: "admin_passes_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "admin_passes" */
export type Admin_Passes_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "admin_passes" */
export type Admin_Passes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Admin_Passes_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Admin_Passes_Stream_Cursor_Value_Input = {
  admin_id?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
  processed?: InputMaybe<Scalars["Boolean"]["input"]>
  token?: InputMaybe<Scalars["bytea"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate sum on columns */
export type Admin_Passes_Sum_Fields = {
  __typename?: "admin_passes_sum_fields"
  id?: Maybe<Scalars["Int"]["output"]>
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "admin_passes" */
export type Admin_Passes_Sum_Order_By = {
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** update columns of table "admin_passes" */
export enum Admin_Passes_Update_Column {
  /** column name */
  AdminId = "admin_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  Processed = "processed",
  /** column name */
  Token = "token",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  UserId = "user_id",
}

export type Admin_Passes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Admin_Passes_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Admin_Passes_Set_Input>
  /** filter the rows which have to be updated */
  where: Admin_Passes_Bool_Exp
}

/** aggregate var_pop on columns */
export type Admin_Passes_Var_Pop_Fields = {
  __typename?: "admin_passes_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "admin_passes" */
export type Admin_Passes_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Admin_Passes_Var_Samp_Fields = {
  __typename?: "admin_passes_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "admin_passes" */
export type Admin_Passes_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Admin_Passes_Variance_Fields = {
  __typename?: "admin_passes_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "admin_passes" */
export type Admin_Passes_Variance_Order_By = {
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** columns and relationships of "admin_roles" */
export type Admin_Roles = {
  __typename?: "admin_roles"
  id: Scalars["Int"]["output"]
  rolename: Scalars["String"]["output"]
  /** An object relationship */
  user?: Maybe<Users>
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregated selection of "admin_roles" */
export type Admin_Roles_Aggregate = {
  __typename?: "admin_roles_aggregate"
  aggregate?: Maybe<Admin_Roles_Aggregate_Fields>
  nodes: Array<Admin_Roles>
}

export type Admin_Roles_Aggregate_Bool_Exp = {
  count?: InputMaybe<Admin_Roles_Aggregate_Bool_Exp_Count>
}

export type Admin_Roles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Admin_Roles_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Admin_Roles_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "admin_roles" */
export type Admin_Roles_Aggregate_Fields = {
  __typename?: "admin_roles_aggregate_fields"
  avg?: Maybe<Admin_Roles_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Admin_Roles_Max_Fields>
  min?: Maybe<Admin_Roles_Min_Fields>
  stddev?: Maybe<Admin_Roles_Stddev_Fields>
  stddev_pop?: Maybe<Admin_Roles_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Admin_Roles_Stddev_Samp_Fields>
  sum?: Maybe<Admin_Roles_Sum_Fields>
  var_pop?: Maybe<Admin_Roles_Var_Pop_Fields>
  var_samp?: Maybe<Admin_Roles_Var_Samp_Fields>
  variance?: Maybe<Admin_Roles_Variance_Fields>
}

/** aggregate fields of "admin_roles" */
export type Admin_Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Admin_Roles_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "admin_roles" */
export type Admin_Roles_Aggregate_Order_By = {
  avg?: InputMaybe<Admin_Roles_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Admin_Roles_Max_Order_By>
  min?: InputMaybe<Admin_Roles_Min_Order_By>
  stddev?: InputMaybe<Admin_Roles_Stddev_Order_By>
  stddev_pop?: InputMaybe<Admin_Roles_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Admin_Roles_Stddev_Samp_Order_By>
  sum?: InputMaybe<Admin_Roles_Sum_Order_By>
  var_pop?: InputMaybe<Admin_Roles_Var_Pop_Order_By>
  var_samp?: InputMaybe<Admin_Roles_Var_Samp_Order_By>
  variance?: InputMaybe<Admin_Roles_Variance_Order_By>
}

/** input type for inserting array relation for remote table "admin_roles" */
export type Admin_Roles_Arr_Rel_Insert_Input = {
  data: Array<Admin_Roles_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Admin_Roles_On_Conflict>
}

/** aggregate avg on columns */
export type Admin_Roles_Avg_Fields = {
  __typename?: "admin_roles_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "admin_roles" */
export type Admin_Roles_Avg_Order_By = {
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "admin_roles". All fields are combined with a logical 'AND'. */
export type Admin_Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Admin_Roles_Bool_Exp>>
  _not?: InputMaybe<Admin_Roles_Bool_Exp>
  _or?: InputMaybe<Array<Admin_Roles_Bool_Exp>>
  id?: InputMaybe<Int_Comparison_Exp>
  rolename?: InputMaybe<String_Comparison_Exp>
  user?: InputMaybe<Users_Bool_Exp>
  user_id?: InputMaybe<Bigint_Comparison_Exp>
}

/** unique or primary key constraints on table "admin_roles" */
export enum Admin_Roles_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkAdminRoles = "pk_admin_roles",
}

/** input type for incrementing numeric columns in table "admin_roles" */
export type Admin_Roles_Inc_Input = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "admin_roles" */
export type Admin_Roles_Insert_Input = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  rolename?: InputMaybe<Scalars["String"]["input"]>
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate max on columns */
export type Admin_Roles_Max_Fields = {
  __typename?: "admin_roles_max_fields"
  id?: Maybe<Scalars["Int"]["output"]>
  rolename?: Maybe<Scalars["String"]["output"]>
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by max() on columns of table "admin_roles" */
export type Admin_Roles_Max_Order_By = {
  id?: InputMaybe<Order_By>
  rolename?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Admin_Roles_Min_Fields = {
  __typename?: "admin_roles_min_fields"
  id?: Maybe<Scalars["Int"]["output"]>
  rolename?: Maybe<Scalars["String"]["output"]>
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by min() on columns of table "admin_roles" */
export type Admin_Roles_Min_Order_By = {
  id?: InputMaybe<Order_By>
  rolename?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** response of any mutation on the table "admin_roles" */
export type Admin_Roles_Mutation_Response = {
  __typename?: "admin_roles_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Admin_Roles>
}

/** on_conflict condition type for table "admin_roles" */
export type Admin_Roles_On_Conflict = {
  constraint: Admin_Roles_Constraint
  update_columns?: Array<Admin_Roles_Update_Column>
  where?: InputMaybe<Admin_Roles_Bool_Exp>
}

/** Ordering options when selecting data from "admin_roles". */
export type Admin_Roles_Order_By = {
  id?: InputMaybe<Order_By>
  rolename?: InputMaybe<Order_By>
  user?: InputMaybe<Users_Order_By>
  user_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: admin_roles */
export type Admin_Roles_Pk_Columns_Input = {
  id: Scalars["Int"]["input"]
}

/** select columns of table "admin_roles" */
export enum Admin_Roles_Select_Column {
  /** column name */
  Id = "id",
  /** column name */
  Rolename = "rolename",
  /** column name */
  UserId = "user_id",
}

/** input type for updating data in table "admin_roles" */
export type Admin_Roles_Set_Input = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  rolename?: InputMaybe<Scalars["String"]["input"]>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate stddev on columns */
export type Admin_Roles_Stddev_Fields = {
  __typename?: "admin_roles_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "admin_roles" */
export type Admin_Roles_Stddev_Order_By = {
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Admin_Roles_Stddev_Pop_Fields = {
  __typename?: "admin_roles_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "admin_roles" */
export type Admin_Roles_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Admin_Roles_Stddev_Samp_Fields = {
  __typename?: "admin_roles_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "admin_roles" */
export type Admin_Roles_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "admin_roles" */
export type Admin_Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Admin_Roles_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Admin_Roles_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  rolename?: InputMaybe<Scalars["String"]["input"]>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate sum on columns */
export type Admin_Roles_Sum_Fields = {
  __typename?: "admin_roles_sum_fields"
  id?: Maybe<Scalars["Int"]["output"]>
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "admin_roles" */
export type Admin_Roles_Sum_Order_By = {
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** update columns of table "admin_roles" */
export enum Admin_Roles_Update_Column {
  /** column name */
  Id = "id",
  /** column name */
  Rolename = "rolename",
  /** column name */
  UserId = "user_id",
}

export type Admin_Roles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Admin_Roles_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Admin_Roles_Set_Input>
  /** filter the rows which have to be updated */
  where: Admin_Roles_Bool_Exp
}

/** aggregate var_pop on columns */
export type Admin_Roles_Var_Pop_Fields = {
  __typename?: "admin_roles_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "admin_roles" */
export type Admin_Roles_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Admin_Roles_Var_Samp_Fields = {
  __typename?: "admin_roles_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "admin_roles" */
export type Admin_Roles_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Admin_Roles_Variance_Fields = {
  __typename?: "admin_roles_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "admin_roles" */
export type Admin_Roles_Variance_Order_By = {
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** columns and relationships of "agreement" */
export type Agreement = {
  __typename?: "agreement"
  agreement_meterpoint_id_meter?: Maybe<Meter>
  /** An object relationship */
  agreement_renewal?: Maybe<Renewal>
  billable?: Maybe<Scalars["Boolean"]["output"]>
  cancelled?: Maybe<Scalars["Boolean"]["output"]>
  cancelled_at?: Maybe<Scalars["timestamp"]["output"]>
  contents?: Maybe<Scalars["json"]["output"]>
  contractedto?: Maybe<Scalars["timestamp"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  followedon?: Maybe<Scalars["timestamp"]["output"]>
  from_date: Scalars["timestamp"]["output"]
  id: Scalars["bigint"]["output"]
  number: Scalars["String"]["output"]
  ordered?: Maybe<Scalars["timestamp"]["output"]>
  /** An array relationship */
  product_account_rels: Array<Product_Account_Agreement_Rel>
  /** An aggregate relationship */
  product_account_rels_aggregate: Product_Account_Agreement_Rel_Aggregate
  quote_id?: Maybe<Scalars["bigint"]["output"]>
  renewal_id?: Maybe<Scalars["bigint"]["output"]>
  terminationreceived?: Maybe<Scalars["timestamp"]["output"]>
  to_date?: Maybe<Scalars["timestamp"]["output"]>
  type: Scalars["agreement_type"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "agreement" */
export type AgreementContentsArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** columns and relationships of "agreement" */
export type AgreementProduct_Account_RelsArgs = {
  distinct_on?: InputMaybe<Array<Product_Account_Agreement_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Account_Agreement_Rel_Order_By>>
  where?: InputMaybe<Product_Account_Agreement_Rel_Bool_Exp>
}

/** columns and relationships of "agreement" */
export type AgreementProduct_Account_Rels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Account_Agreement_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Account_Agreement_Rel_Order_By>>
  where?: InputMaybe<Product_Account_Agreement_Rel_Bool_Exp>
}

/** aggregated selection of "agreement" */
export type Agreement_Aggregate = {
  __typename?: "agreement_aggregate"
  aggregate?: Maybe<Agreement_Aggregate_Fields>
  nodes: Array<Agreement>
}

export type Agreement_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Agreement_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Agreement_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<Agreement_Aggregate_Bool_Exp_Count>
}

export type Agreement_Aggregate_Bool_Exp_Bool_And = {
  arguments: Agreement_Select_Column_Agreement_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Agreement_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Agreement_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Agreement_Select_Column_Agreement_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Agreement_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Agreement_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Agreement_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Agreement_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "agreement" */
export type Agreement_Aggregate_Fields = {
  __typename?: "agreement_aggregate_fields"
  avg?: Maybe<Agreement_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Agreement_Max_Fields>
  min?: Maybe<Agreement_Min_Fields>
  stddev?: Maybe<Agreement_Stddev_Fields>
  stddev_pop?: Maybe<Agreement_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Agreement_Stddev_Samp_Fields>
  sum?: Maybe<Agreement_Sum_Fields>
  var_pop?: Maybe<Agreement_Var_Pop_Fields>
  var_samp?: Maybe<Agreement_Var_Samp_Fields>
  variance?: Maybe<Agreement_Variance_Fields>
}

/** aggregate fields of "agreement" */
export type Agreement_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agreement_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "agreement" */
export type Agreement_Aggregate_Order_By = {
  avg?: InputMaybe<Agreement_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Agreement_Max_Order_By>
  min?: InputMaybe<Agreement_Min_Order_By>
  stddev?: InputMaybe<Agreement_Stddev_Order_By>
  stddev_pop?: InputMaybe<Agreement_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Agreement_Stddev_Samp_Order_By>
  sum?: InputMaybe<Agreement_Sum_Order_By>
  var_pop?: InputMaybe<Agreement_Var_Pop_Order_By>
  var_samp?: InputMaybe<Agreement_Var_Samp_Order_By>
  variance?: InputMaybe<Agreement_Variance_Order_By>
}

/** input type for inserting array relation for remote table "agreement" */
export type Agreement_Arr_Rel_Insert_Input = {
  data: Array<Agreement_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Agreement_On_Conflict>
}

/** aggregate avg on columns */
export type Agreement_Avg_Fields = {
  __typename?: "agreement_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  quote_id?: Maybe<Scalars["Float"]["output"]>
  renewal_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "agreement" */
export type Agreement_Avg_Order_By = {
  id?: InputMaybe<Order_By>
  quote_id?: InputMaybe<Order_By>
  renewal_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "agreement". All fields are combined with a logical 'AND'. */
export type Agreement_Bool_Exp = {
  _and?: InputMaybe<Array<Agreement_Bool_Exp>>
  _not?: InputMaybe<Agreement_Bool_Exp>
  _or?: InputMaybe<Array<Agreement_Bool_Exp>>
  agreement_renewal?: InputMaybe<Renewal_Bool_Exp>
  billable?: InputMaybe<Boolean_Comparison_Exp>
  cancelled?: InputMaybe<Boolean_Comparison_Exp>
  cancelled_at?: InputMaybe<Timestamp_Comparison_Exp>
  contents?: InputMaybe<Json_Comparison_Exp>
  contractedto?: InputMaybe<Timestamp_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  followedon?: InputMaybe<Timestamp_Comparison_Exp>
  from_date?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  number?: InputMaybe<String_Comparison_Exp>
  ordered?: InputMaybe<Timestamp_Comparison_Exp>
  product_account_rels?: InputMaybe<Product_Account_Agreement_Rel_Bool_Exp>
  product_account_rels_aggregate?: InputMaybe<Product_Account_Agreement_Rel_Aggregate_Bool_Exp>
  quote_id?: InputMaybe<Bigint_Comparison_Exp>
  renewal_id?: InputMaybe<Bigint_Comparison_Exp>
  terminationreceived?: InputMaybe<Timestamp_Comparison_Exp>
  to_date?: InputMaybe<Timestamp_Comparison_Exp>
  type?: InputMaybe<Agreement_Type_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "agreement" */
export enum Agreement_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkAgreements = "pk_agreements",
}

/** input type for incrementing numeric columns in table "agreement" */
export type Agreement_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  quote_id?: InputMaybe<Scalars["bigint"]["input"]>
  renewal_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "agreement" */
export type Agreement_Insert_Input = {
  agreement_renewal?: InputMaybe<Renewal_Obj_Rel_Insert_Input>
  billable?: InputMaybe<Scalars["Boolean"]["input"]>
  cancelled?: InputMaybe<Scalars["Boolean"]["input"]>
  cancelled_at?: InputMaybe<Scalars["timestamp"]["input"]>
  contents?: InputMaybe<Scalars["json"]["input"]>
  contractedto?: InputMaybe<Scalars["timestamp"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  followedon?: InputMaybe<Scalars["timestamp"]["input"]>
  from_date?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  number?: InputMaybe<Scalars["String"]["input"]>
  ordered?: InputMaybe<Scalars["timestamp"]["input"]>
  product_account_rels?: InputMaybe<Product_Account_Agreement_Rel_Arr_Rel_Insert_Input>
  quote_id?: InputMaybe<Scalars["bigint"]["input"]>
  renewal_id?: InputMaybe<Scalars["bigint"]["input"]>
  terminationreceived?: InputMaybe<Scalars["timestamp"]["input"]>
  to_date?: InputMaybe<Scalars["timestamp"]["input"]>
  type?: InputMaybe<Scalars["agreement_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Agreement_Max_Fields = {
  __typename?: "agreement_max_fields"
  cancelled_at?: Maybe<Scalars["timestamp"]["output"]>
  contractedto?: Maybe<Scalars["timestamp"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  followedon?: Maybe<Scalars["timestamp"]["output"]>
  from_date?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  number?: Maybe<Scalars["String"]["output"]>
  ordered?: Maybe<Scalars["timestamp"]["output"]>
  quote_id?: Maybe<Scalars["bigint"]["output"]>
  renewal_id?: Maybe<Scalars["bigint"]["output"]>
  terminationreceived?: Maybe<Scalars["timestamp"]["output"]>
  to_date?: Maybe<Scalars["timestamp"]["output"]>
  type?: Maybe<Scalars["agreement_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "agreement" */
export type Agreement_Max_Order_By = {
  cancelled_at?: InputMaybe<Order_By>
  contractedto?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  followedon?: InputMaybe<Order_By>
  from_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  number?: InputMaybe<Order_By>
  ordered?: InputMaybe<Order_By>
  quote_id?: InputMaybe<Order_By>
  renewal_id?: InputMaybe<Order_By>
  terminationreceived?: InputMaybe<Order_By>
  to_date?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Agreement_Min_Fields = {
  __typename?: "agreement_min_fields"
  cancelled_at?: Maybe<Scalars["timestamp"]["output"]>
  contractedto?: Maybe<Scalars["timestamp"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  followedon?: Maybe<Scalars["timestamp"]["output"]>
  from_date?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  number?: Maybe<Scalars["String"]["output"]>
  ordered?: Maybe<Scalars["timestamp"]["output"]>
  quote_id?: Maybe<Scalars["bigint"]["output"]>
  renewal_id?: Maybe<Scalars["bigint"]["output"]>
  terminationreceived?: Maybe<Scalars["timestamp"]["output"]>
  to_date?: Maybe<Scalars["timestamp"]["output"]>
  type?: Maybe<Scalars["agreement_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "agreement" */
export type Agreement_Min_Order_By = {
  cancelled_at?: InputMaybe<Order_By>
  contractedto?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  followedon?: InputMaybe<Order_By>
  from_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  number?: InputMaybe<Order_By>
  ordered?: InputMaybe<Order_By>
  quote_id?: InputMaybe<Order_By>
  renewal_id?: InputMaybe<Order_By>
  terminationreceived?: InputMaybe<Order_By>
  to_date?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "agreement" */
export type Agreement_Mutation_Response = {
  __typename?: "agreement_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Agreement>
}

/** input type for inserting object relation for remote table "agreement" */
export type Agreement_Obj_Rel_Insert_Input = {
  data: Agreement_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Agreement_On_Conflict>
}

/** on_conflict condition type for table "agreement" */
export type Agreement_On_Conflict = {
  constraint: Agreement_Constraint
  update_columns?: Array<Agreement_Update_Column>
  where?: InputMaybe<Agreement_Bool_Exp>
}

/** Ordering options when selecting data from "agreement". */
export type Agreement_Order_By = {
  agreement_renewal?: InputMaybe<Renewal_Order_By>
  billable?: InputMaybe<Order_By>
  cancelled?: InputMaybe<Order_By>
  cancelled_at?: InputMaybe<Order_By>
  contents?: InputMaybe<Order_By>
  contractedto?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  followedon?: InputMaybe<Order_By>
  from_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  number?: InputMaybe<Order_By>
  ordered?: InputMaybe<Order_By>
  product_account_rels_aggregate?: InputMaybe<Product_Account_Agreement_Rel_Aggregate_Order_By>
  quote_id?: InputMaybe<Order_By>
  renewal_id?: InputMaybe<Order_By>
  terminationreceived?: InputMaybe<Order_By>
  to_date?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: agreement */
export type Agreement_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "agreement" */
export enum Agreement_Select_Column {
  /** column name */
  Billable = "billable",
  /** column name */
  Cancelled = "cancelled",
  /** column name */
  CancelledAt = "cancelled_at",
  /** column name */
  Contents = "contents",
  /** column name */
  Contractedto = "contractedto",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Followedon = "followedon",
  /** column name */
  FromDate = "from_date",
  /** column name */
  Id = "id",
  /** column name */
  Number = "number",
  /** column name */
  Ordered = "ordered",
  /** column name */
  QuoteId = "quote_id",
  /** column name */
  RenewalId = "renewal_id",
  /** column name */
  Terminationreceived = "terminationreceived",
  /** column name */
  ToDate = "to_date",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** select "agreement_aggregate_bool_exp_bool_and_arguments_columns" columns of table "agreement" */
export enum Agreement_Select_Column_Agreement_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Billable = "billable",
  /** column name */
  Cancelled = "cancelled",
}

/** select "agreement_aggregate_bool_exp_bool_or_arguments_columns" columns of table "agreement" */
export enum Agreement_Select_Column_Agreement_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Billable = "billable",
  /** column name */
  Cancelled = "cancelled",
}

/** input type for updating data in table "agreement" */
export type Agreement_Set_Input = {
  billable?: InputMaybe<Scalars["Boolean"]["input"]>
  cancelled?: InputMaybe<Scalars["Boolean"]["input"]>
  cancelled_at?: InputMaybe<Scalars["timestamp"]["input"]>
  contents?: InputMaybe<Scalars["json"]["input"]>
  contractedto?: InputMaybe<Scalars["timestamp"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  followedon?: InputMaybe<Scalars["timestamp"]["input"]>
  from_date?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  number?: InputMaybe<Scalars["String"]["input"]>
  ordered?: InputMaybe<Scalars["timestamp"]["input"]>
  quote_id?: InputMaybe<Scalars["bigint"]["input"]>
  renewal_id?: InputMaybe<Scalars["bigint"]["input"]>
  terminationreceived?: InputMaybe<Scalars["timestamp"]["input"]>
  to_date?: InputMaybe<Scalars["timestamp"]["input"]>
  type?: InputMaybe<Scalars["agreement_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Agreement_Stddev_Fields = {
  __typename?: "agreement_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  quote_id?: Maybe<Scalars["Float"]["output"]>
  renewal_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "agreement" */
export type Agreement_Stddev_Order_By = {
  id?: InputMaybe<Order_By>
  quote_id?: InputMaybe<Order_By>
  renewal_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Agreement_Stddev_Pop_Fields = {
  __typename?: "agreement_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  quote_id?: Maybe<Scalars["Float"]["output"]>
  renewal_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "agreement" */
export type Agreement_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>
  quote_id?: InputMaybe<Order_By>
  renewal_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Agreement_Stddev_Samp_Fields = {
  __typename?: "agreement_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  quote_id?: Maybe<Scalars["Float"]["output"]>
  renewal_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "agreement" */
export type Agreement_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>
  quote_id?: InputMaybe<Order_By>
  renewal_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "agreement" */
export type Agreement_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agreement_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Agreement_Stream_Cursor_Value_Input = {
  billable?: InputMaybe<Scalars["Boolean"]["input"]>
  cancelled?: InputMaybe<Scalars["Boolean"]["input"]>
  cancelled_at?: InputMaybe<Scalars["timestamp"]["input"]>
  contents?: InputMaybe<Scalars["json"]["input"]>
  contractedto?: InputMaybe<Scalars["timestamp"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  followedon?: InputMaybe<Scalars["timestamp"]["input"]>
  from_date?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  number?: InputMaybe<Scalars["String"]["input"]>
  ordered?: InputMaybe<Scalars["timestamp"]["input"]>
  quote_id?: InputMaybe<Scalars["bigint"]["input"]>
  renewal_id?: InputMaybe<Scalars["bigint"]["input"]>
  terminationreceived?: InputMaybe<Scalars["timestamp"]["input"]>
  to_date?: InputMaybe<Scalars["timestamp"]["input"]>
  type?: InputMaybe<Scalars["agreement_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Agreement_Sum_Fields = {
  __typename?: "agreement_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  quote_id?: Maybe<Scalars["bigint"]["output"]>
  renewal_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "agreement" */
export type Agreement_Sum_Order_By = {
  id?: InputMaybe<Order_By>
  quote_id?: InputMaybe<Order_By>
  renewal_id?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "agreement_type". All fields are combined with logical 'AND'. */
export type Agreement_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["agreement_type"]["input"]>
  _gt?: InputMaybe<Scalars["agreement_type"]["input"]>
  _gte?: InputMaybe<Scalars["agreement_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["agreement_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["agreement_type"]["input"]>
  _lte?: InputMaybe<Scalars["agreement_type"]["input"]>
  _neq?: InputMaybe<Scalars["agreement_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["agreement_type"]["input"]>>
}

/** update columns of table "agreement" */
export enum Agreement_Update_Column {
  /** column name */
  Billable = "billable",
  /** column name */
  Cancelled = "cancelled",
  /** column name */
  CancelledAt = "cancelled_at",
  /** column name */
  Contents = "contents",
  /** column name */
  Contractedto = "contractedto",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Followedon = "followedon",
  /** column name */
  FromDate = "from_date",
  /** column name */
  Id = "id",
  /** column name */
  Number = "number",
  /** column name */
  Ordered = "ordered",
  /** column name */
  QuoteId = "quote_id",
  /** column name */
  RenewalId = "renewal_id",
  /** column name */
  Terminationreceived = "terminationreceived",
  /** column name */
  ToDate = "to_date",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Agreement_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Agreement_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agreement_Set_Input>
  /** filter the rows which have to be updated */
  where: Agreement_Bool_Exp
}

/** aggregate var_pop on columns */
export type Agreement_Var_Pop_Fields = {
  __typename?: "agreement_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  quote_id?: Maybe<Scalars["Float"]["output"]>
  renewal_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "agreement" */
export type Agreement_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>
  quote_id?: InputMaybe<Order_By>
  renewal_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Agreement_Var_Samp_Fields = {
  __typename?: "agreement_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  quote_id?: Maybe<Scalars["Float"]["output"]>
  renewal_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "agreement" */
export type Agreement_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>
  quote_id?: InputMaybe<Order_By>
  renewal_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Agreement_Variance_Fields = {
  __typename?: "agreement_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  quote_id?: Maybe<Scalars["Float"]["output"]>
  renewal_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "agreement" */
export type Agreement_Variance_Order_By = {
  id?: InputMaybe<Order_By>
  quote_id?: InputMaybe<Order_By>
  renewal_id?: InputMaybe<Order_By>
}

/** columns and relationships of "asset" */
export type Asset = {
  __typename?: "asset"
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  /** An object relationship */
  meter?: Maybe<Meter>
  type: Scalars["asset_type"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "asset" */
export type Asset_Aggregate = {
  __typename?: "asset_aggregate"
  aggregate?: Maybe<Asset_Aggregate_Fields>
  nodes: Array<Asset>
}

/** aggregate fields of "asset" */
export type Asset_Aggregate_Fields = {
  __typename?: "asset_aggregate_fields"
  avg?: Maybe<Asset_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Asset_Max_Fields>
  min?: Maybe<Asset_Min_Fields>
  stddev?: Maybe<Asset_Stddev_Fields>
  stddev_pop?: Maybe<Asset_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Asset_Stddev_Samp_Fields>
  sum?: Maybe<Asset_Sum_Fields>
  var_pop?: Maybe<Asset_Var_Pop_Fields>
  var_samp?: Maybe<Asset_Var_Samp_Fields>
  variance?: Maybe<Asset_Variance_Fields>
}

/** aggregate fields of "asset" */
export type Asset_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Asset_Avg_Fields = {
  __typename?: "asset_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "asset". All fields are combined with a logical 'AND'. */
export type Asset_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_Bool_Exp>>
  _not?: InputMaybe<Asset_Bool_Exp>
  _or?: InputMaybe<Array<Asset_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  meter?: InputMaybe<Meter_Bool_Exp>
  type?: InputMaybe<Asset_Type_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "asset" */
export enum Asset_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkAsset = "pk_asset",
}

/** input type for incrementing numeric columns in table "asset" */
export type Asset_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "asset" */
export type Asset_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter?: InputMaybe<Meter_Obj_Rel_Insert_Input>
  type?: InputMaybe<Scalars["asset_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Asset_Max_Fields = {
  __typename?: "asset_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  type?: Maybe<Scalars["asset_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Asset_Min_Fields = {
  __typename?: "asset_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  type?: Maybe<Scalars["asset_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "asset" */
export type Asset_Mutation_Response = {
  __typename?: "asset_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Asset>
}

/** input type for inserting object relation for remote table "asset" */
export type Asset_Obj_Rel_Insert_Input = {
  data: Asset_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_On_Conflict>
}

/** on_conflict condition type for table "asset" */
export type Asset_On_Conflict = {
  constraint: Asset_Constraint
  update_columns?: Array<Asset_Update_Column>
  where?: InputMaybe<Asset_Bool_Exp>
}

/** Ordering options when selecting data from "asset". */
export type Asset_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter?: InputMaybe<Meter_Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: asset */
export type Asset_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "asset" */
export enum Asset_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "asset" */
export type Asset_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  type?: InputMaybe<Scalars["asset_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Asset_Stddev_Fields = {
  __typename?: "asset_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Asset_Stddev_Pop_Fields = {
  __typename?: "asset_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Asset_Stddev_Samp_Fields = {
  __typename?: "asset_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "asset" */
export type Asset_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Asset_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  type?: InputMaybe<Scalars["asset_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Asset_Sum_Fields = {
  __typename?: "asset_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** Boolean expression to compare columns of type "asset_type". All fields are combined with logical 'AND'. */
export type Asset_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["asset_type"]["input"]>
  _gt?: InputMaybe<Scalars["asset_type"]["input"]>
  _gte?: InputMaybe<Scalars["asset_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["asset_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["asset_type"]["input"]>
  _lte?: InputMaybe<Scalars["asset_type"]["input"]>
  _neq?: InputMaybe<Scalars["asset_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["asset_type"]["input"]>>
}

/** update columns of table "asset" */
export enum Asset_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Asset_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Asset_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_Set_Input>
  /** filter the rows which have to be updated */
  where: Asset_Bool_Exp
}

/** aggregate var_pop on columns */
export type Asset_Var_Pop_Fields = {
  __typename?: "asset_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Asset_Var_Samp_Fields = {
  __typename?: "asset_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Asset_Variance_Fields = {
  __typename?: "asset_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "attachment" */
export type Attachment = {
  __typename?: "attachment"
  communication_id: Scalars["bigint"]["output"]
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  name: Scalars["String"]["output"]
  type: Scalars["String"]["output"]
  updated_at: Scalars["timestamp"]["output"]
  url?: Maybe<Scalars["String"]["output"]>
}

/** aggregated selection of "attachment" */
export type Attachment_Aggregate = {
  __typename?: "attachment_aggregate"
  aggregate?: Maybe<Attachment_Aggregate_Fields>
  nodes: Array<Attachment>
}

/** aggregate fields of "attachment" */
export type Attachment_Aggregate_Fields = {
  __typename?: "attachment_aggregate_fields"
  avg?: Maybe<Attachment_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Attachment_Max_Fields>
  min?: Maybe<Attachment_Min_Fields>
  stddev?: Maybe<Attachment_Stddev_Fields>
  stddev_pop?: Maybe<Attachment_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Attachment_Stddev_Samp_Fields>
  sum?: Maybe<Attachment_Sum_Fields>
  var_pop?: Maybe<Attachment_Var_Pop_Fields>
  var_samp?: Maybe<Attachment_Var_Samp_Fields>
  variance?: Maybe<Attachment_Variance_Fields>
}

/** aggregate fields of "attachment" */
export type Attachment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Attachment_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Attachment_Avg_Fields = {
  __typename?: "attachment_avg_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "attachment". All fields are combined with a logical 'AND'. */
export type Attachment_Bool_Exp = {
  _and?: InputMaybe<Array<Attachment_Bool_Exp>>
  _not?: InputMaybe<Attachment_Bool_Exp>
  _or?: InputMaybe<Array<Attachment_Bool_Exp>>
  communication_id?: InputMaybe<Bigint_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  type?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  url?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "attachment" */
export enum Attachment_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkAttachment = "pk_attachment",
  /** unique or primary key constraint on columns "name", "communication_id" */
  UniqueConstraintName = "unique_constraint_name",
}

/** input type for incrementing numeric columns in table "attachment" */
export type Attachment_Inc_Input = {
  communication_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "attachment" */
export type Attachment_Insert_Input = {
  communication_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  url?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Attachment_Max_Fields = {
  __typename?: "attachment_max_fields"
  communication_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  url?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Attachment_Min_Fields = {
  __typename?: "attachment_min_fields"
  communication_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  url?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "attachment" */
export type Attachment_Mutation_Response = {
  __typename?: "attachment_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Attachment>
}

/** on_conflict condition type for table "attachment" */
export type Attachment_On_Conflict = {
  constraint: Attachment_Constraint
  update_columns?: Array<Attachment_Update_Column>
  where?: InputMaybe<Attachment_Bool_Exp>
}

/** Ordering options when selecting data from "attachment". */
export type Attachment_Order_By = {
  communication_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  url?: InputMaybe<Order_By>
}

/** primary key columns input for table: attachment */
export type Attachment_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "attachment" */
export enum Attachment_Select_Column {
  /** column name */
  CommunicationId = "communication_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  Url = "url",
}

/** input type for updating data in table "attachment" */
export type Attachment_Set_Input = {
  communication_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  url?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Attachment_Stddev_Fields = {
  __typename?: "attachment_stddev_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Attachment_Stddev_Pop_Fields = {
  __typename?: "attachment_stddev_pop_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Attachment_Stddev_Samp_Fields = {
  __typename?: "attachment_stddev_samp_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "attachment" */
export type Attachment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Attachment_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Attachment_Stream_Cursor_Value_Input = {
  communication_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  url?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Attachment_Sum_Fields = {
  __typename?: "attachment_sum_fields"
  communication_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "attachment" */
export enum Attachment_Update_Column {
  /** column name */
  CommunicationId = "communication_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  Url = "url",
}

export type Attachment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Attachment_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Attachment_Set_Input>
  /** filter the rows which have to be updated */
  where: Attachment_Bool_Exp
}

/** aggregate var_pop on columns */
export type Attachment_Var_Pop_Fields = {
  __typename?: "attachment_var_pop_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Attachment_Var_Samp_Fields = {
  __typename?: "attachment_var_samp_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Attachment_Variance_Fields = {
  __typename?: "attachment_variance_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "automation_default_record_status_enum". All fields are combined with logical 'AND'. */
export type Automation_Default_Record_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["automation_default_record_status_enum"]["input"]>
  _gt?: InputMaybe<Scalars["automation_default_record_status_enum"]["input"]>
  _gte?: InputMaybe<Scalars["automation_default_record_status_enum"]["input"]>
  _in?: InputMaybe<
    Array<Scalars["automation_default_record_status_enum"]["input"]>
  >
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["automation_default_record_status_enum"]["input"]>
  _lte?: InputMaybe<Scalars["automation_default_record_status_enum"]["input"]>
  _neq?: InputMaybe<Scalars["automation_default_record_status_enum"]["input"]>
  _nin?: InputMaybe<
    Array<Scalars["automation_default_record_status_enum"]["input"]>
  >
}

/** Boolean expression to compare columns of type "automation_job_email_status". All fields are combined with logical 'AND'. */
export type Automation_Job_Email_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["automation_job_email_status"]["input"]>
  _gt?: InputMaybe<Scalars["automation_job_email_status"]["input"]>
  _gte?: InputMaybe<Scalars["automation_job_email_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["automation_job_email_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["automation_job_email_status"]["input"]>
  _lte?: InputMaybe<Scalars["automation_job_email_status"]["input"]>
  _neq?: InputMaybe<Scalars["automation_job_email_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["automation_job_email_status"]["input"]>>
}

/** Boolean expression to compare columns of type "automation_status_enum". All fields are combined with logical 'AND'. */
export type Automation_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["automation_status_enum"]["input"]>
  _gt?: InputMaybe<Scalars["automation_status_enum"]["input"]>
  _gte?: InputMaybe<Scalars["automation_status_enum"]["input"]>
  _in?: InputMaybe<Array<Scalars["automation_status_enum"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["automation_status_enum"]["input"]>
  _lte?: InputMaybe<Scalars["automation_status_enum"]["input"]>
  _neq?: InputMaybe<Scalars["automation_status_enum"]["input"]>
  _nin?: InputMaybe<Array<Scalars["automation_status_enum"]["input"]>>
}

/** columns and relationships of "axle_trial_eligibility" */
export type Axle_Trial_Eligibility = {
  __typename?: "axle_trial_eligibility"
  billing_account_id: Scalars["bigint"]["output"]
  created_at: Scalars["timestamp"]["output"]
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "axle_trial_eligibility" */
export type Axle_Trial_Eligibility_Aggregate = {
  __typename?: "axle_trial_eligibility_aggregate"
  aggregate?: Maybe<Axle_Trial_Eligibility_Aggregate_Fields>
  nodes: Array<Axle_Trial_Eligibility>
}

/** aggregate fields of "axle_trial_eligibility" */
export type Axle_Trial_Eligibility_Aggregate_Fields = {
  __typename?: "axle_trial_eligibility_aggregate_fields"
  avg?: Maybe<Axle_Trial_Eligibility_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Axle_Trial_Eligibility_Max_Fields>
  min?: Maybe<Axle_Trial_Eligibility_Min_Fields>
  stddev?: Maybe<Axle_Trial_Eligibility_Stddev_Fields>
  stddev_pop?: Maybe<Axle_Trial_Eligibility_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Axle_Trial_Eligibility_Stddev_Samp_Fields>
  sum?: Maybe<Axle_Trial_Eligibility_Sum_Fields>
  var_pop?: Maybe<Axle_Trial_Eligibility_Var_Pop_Fields>
  var_samp?: Maybe<Axle_Trial_Eligibility_Var_Samp_Fields>
  variance?: Maybe<Axle_Trial_Eligibility_Variance_Fields>
}

/** aggregate fields of "axle_trial_eligibility" */
export type Axle_Trial_Eligibility_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Axle_Trial_Eligibility_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Axle_Trial_Eligibility_Avg_Fields = {
  __typename?: "axle_trial_eligibility_avg_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "axle_trial_eligibility". All fields are combined with a logical 'AND'. */
export type Axle_Trial_Eligibility_Bool_Exp = {
  _and?: InputMaybe<Array<Axle_Trial_Eligibility_Bool_Exp>>
  _not?: InputMaybe<Axle_Trial_Eligibility_Bool_Exp>
  _or?: InputMaybe<Array<Axle_Trial_Eligibility_Bool_Exp>>
  billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "axle_trial_eligibility" */
export enum Axle_Trial_Eligibility_Constraint {
  /** unique or primary key constraint on columns "id" */
  AxleTrialEligibilityPkey = "axle_trial_eligibility_pkey",
}

/** input type for incrementing numeric columns in table "axle_trial_eligibility" */
export type Axle_Trial_Eligibility_Inc_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "axle_trial_eligibility" */
export type Axle_Trial_Eligibility_Insert_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Axle_Trial_Eligibility_Max_Fields = {
  __typename?: "axle_trial_eligibility_max_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Axle_Trial_Eligibility_Min_Fields = {
  __typename?: "axle_trial_eligibility_min_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "axle_trial_eligibility" */
export type Axle_Trial_Eligibility_Mutation_Response = {
  __typename?: "axle_trial_eligibility_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Axle_Trial_Eligibility>
}

/** input type for inserting object relation for remote table "axle_trial_eligibility" */
export type Axle_Trial_Eligibility_Obj_Rel_Insert_Input = {
  data: Axle_Trial_Eligibility_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Axle_Trial_Eligibility_On_Conflict>
}

/** on_conflict condition type for table "axle_trial_eligibility" */
export type Axle_Trial_Eligibility_On_Conflict = {
  constraint: Axle_Trial_Eligibility_Constraint
  update_columns?: Array<Axle_Trial_Eligibility_Update_Column>
  where?: InputMaybe<Axle_Trial_Eligibility_Bool_Exp>
}

/** Ordering options when selecting data from "axle_trial_eligibility". */
export type Axle_Trial_Eligibility_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: axle_trial_eligibility */
export type Axle_Trial_Eligibility_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "axle_trial_eligibility" */
export enum Axle_Trial_Eligibility_Select_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  Id = "id",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "axle_trial_eligibility" */
export type Axle_Trial_Eligibility_Set_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Axle_Trial_Eligibility_Stddev_Fields = {
  __typename?: "axle_trial_eligibility_stddev_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Axle_Trial_Eligibility_Stddev_Pop_Fields = {
  __typename?: "axle_trial_eligibility_stddev_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Axle_Trial_Eligibility_Stddev_Samp_Fields = {
  __typename?: "axle_trial_eligibility_stddev_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "axle_trial_eligibility" */
export type Axle_Trial_Eligibility_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Axle_Trial_Eligibility_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Axle_Trial_Eligibility_Stream_Cursor_Value_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Axle_Trial_Eligibility_Sum_Fields = {
  __typename?: "axle_trial_eligibility_sum_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "axle_trial_eligibility" */
export enum Axle_Trial_Eligibility_Update_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  Id = "id",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Axle_Trial_Eligibility_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Axle_Trial_Eligibility_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Axle_Trial_Eligibility_Set_Input>
  /** filter the rows which have to be updated */
  where: Axle_Trial_Eligibility_Bool_Exp
}

/** aggregate var_pop on columns */
export type Axle_Trial_Eligibility_Var_Pop_Fields = {
  __typename?: "axle_trial_eligibility_var_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Axle_Trial_Eligibility_Var_Samp_Fields = {
  __typename?: "axle_trial_eligibility_var_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Axle_Trial_Eligibility_Variance_Fields = {
  __typename?: "axle_trial_eligibility_variance_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["bigint"]["input"]>
  _gt?: InputMaybe<Scalars["bigint"]["input"]>
  _gte?: InputMaybe<Scalars["bigint"]["input"]>
  _in?: InputMaybe<Array<Scalars["bigint"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["bigint"]["input"]>
  _lte?: InputMaybe<Scalars["bigint"]["input"]>
  _neq?: InputMaybe<Scalars["bigint"]["input"]>
  _nin?: InputMaybe<Array<Scalars["bigint"]["input"]>>
}

/** columns and relationships of "bill" */
export type Bill = {
  __typename?: "bill"
  bill_accepted_at?: Maybe<Scalars["timestamp"]["output"]>
  bill_created_at?: Maybe<Scalars["timestamp"]["output"]>
  bill_number: Scalars["String"]["output"]
  billing_account_id: Scalars["bigint"]["output"]
  billing_account_transaction_id?: Maybe<Scalars["bigint"]["output"]>
  /** An object relationship */
  billing_period?: Maybe<Billing_Period>
  billing_period_id?: Maybe<Scalars["bigint"]["output"]>
  consolidated_bill_fl?: Maybe<Scalars["Boolean"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  currency: Scalars["String"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  dirty_fl?: Maybe<Scalars["Boolean"]["output"]>
  due_dt?: Maybe<Scalars["date"]["output"]>
  final_fl: Scalars["Boolean"]["output"]
  from_dttm?: Maybe<Scalars["timestamp"]["output"]>
  gross_amount: Scalars["numeric"]["output"]
  id: Scalars["bigint"]["output"]
  issue_dt?: Maybe<Scalars["date"]["output"]>
  net_amount: Scalars["numeric"]["output"]
  status: Scalars["bill_status"]["output"]
  superseded_fl: Scalars["Boolean"]["output"]
  to_dttm?: Maybe<Scalars["timestamp"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
  version_number?: Maybe<Scalars["Int"]["output"]>
}

/** aggregated selection of "bill" */
export type Bill_Aggregate = {
  __typename?: "bill_aggregate"
  aggregate?: Maybe<Bill_Aggregate_Fields>
  nodes: Array<Bill>
}

export type Bill_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Bill_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Bill_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<Bill_Aggregate_Bool_Exp_Count>
}

export type Bill_Aggregate_Bool_Exp_Bool_And = {
  arguments: Bill_Select_Column_Bill_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Bill_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Bill_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Bill_Select_Column_Bill_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Bill_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Bill_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Bill_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Bill_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "bill" */
export type Bill_Aggregate_Fields = {
  __typename?: "bill_aggregate_fields"
  avg?: Maybe<Bill_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Bill_Max_Fields>
  min?: Maybe<Bill_Min_Fields>
  stddev?: Maybe<Bill_Stddev_Fields>
  stddev_pop?: Maybe<Bill_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Bill_Stddev_Samp_Fields>
  sum?: Maybe<Bill_Sum_Fields>
  var_pop?: Maybe<Bill_Var_Pop_Fields>
  var_samp?: Maybe<Bill_Var_Samp_Fields>
  variance?: Maybe<Bill_Variance_Fields>
}

/** aggregate fields of "bill" */
export type Bill_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bill_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "bill" */
export type Bill_Aggregate_Order_By = {
  avg?: InputMaybe<Bill_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Bill_Max_Order_By>
  min?: InputMaybe<Bill_Min_Order_By>
  stddev?: InputMaybe<Bill_Stddev_Order_By>
  stddev_pop?: InputMaybe<Bill_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Bill_Stddev_Samp_Order_By>
  sum?: InputMaybe<Bill_Sum_Order_By>
  var_pop?: InputMaybe<Bill_Var_Pop_Order_By>
  var_samp?: InputMaybe<Bill_Var_Samp_Order_By>
  variance?: InputMaybe<Bill_Variance_Order_By>
}

/** input type for inserting array relation for remote table "bill" */
export type Bill_Arr_Rel_Insert_Input = {
  data: Array<Bill_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Bill_On_Conflict>
}

/** aggregate avg on columns */
export type Bill_Avg_Fields = {
  __typename?: "bill_avg_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  billing_account_transaction_id?: Maybe<Scalars["Float"]["output"]>
  billing_period_id?: Maybe<Scalars["Float"]["output"]>
  gross_amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  net_amount?: Maybe<Scalars["Float"]["output"]>
  version_number?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "bill" */
export type Bill_Avg_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  billing_account_transaction_id?: InputMaybe<Order_By>
  billing_period_id?: InputMaybe<Order_By>
  gross_amount?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  net_amount?: InputMaybe<Order_By>
  version_number?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "bill". All fields are combined with a logical 'AND'. */
export type Bill_Bool_Exp = {
  _and?: InputMaybe<Array<Bill_Bool_Exp>>
  _not?: InputMaybe<Bill_Bool_Exp>
  _or?: InputMaybe<Array<Bill_Bool_Exp>>
  bill_accepted_at?: InputMaybe<Timestamp_Comparison_Exp>
  bill_created_at?: InputMaybe<Timestamp_Comparison_Exp>
  bill_number?: InputMaybe<String_Comparison_Exp>
  billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  billing_account_transaction_id?: InputMaybe<Bigint_Comparison_Exp>
  billing_period?: InputMaybe<Billing_Period_Bool_Exp>
  billing_period_id?: InputMaybe<Bigint_Comparison_Exp>
  consolidated_bill_fl?: InputMaybe<Boolean_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  currency?: InputMaybe<String_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  dirty_fl?: InputMaybe<Boolean_Comparison_Exp>
  due_dt?: InputMaybe<Date_Comparison_Exp>
  final_fl?: InputMaybe<Boolean_Comparison_Exp>
  from_dttm?: InputMaybe<Timestamp_Comparison_Exp>
  gross_amount?: InputMaybe<Numeric_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  issue_dt?: InputMaybe<Date_Comparison_Exp>
  net_amount?: InputMaybe<Numeric_Comparison_Exp>
  status?: InputMaybe<Bill_Status_Comparison_Exp>
  superseded_fl?: InputMaybe<Boolean_Comparison_Exp>
  to_dttm?: InputMaybe<Timestamp_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  version_number?: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "bill" */
export enum Bill_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkBill = "pk_bill",
}

/** Boolean expression to compare columns of type "bill_delivery_method". All fields are combined with logical 'AND'. */
export type Bill_Delivery_Method_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["bill_delivery_method"]["input"]>
  _gt?: InputMaybe<Scalars["bill_delivery_method"]["input"]>
  _gte?: InputMaybe<Scalars["bill_delivery_method"]["input"]>
  _in?: InputMaybe<Array<Scalars["bill_delivery_method"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["bill_delivery_method"]["input"]>
  _lte?: InputMaybe<Scalars["bill_delivery_method"]["input"]>
  _neq?: InputMaybe<Scalars["bill_delivery_method"]["input"]>
  _nin?: InputMaybe<Array<Scalars["bill_delivery_method"]["input"]>>
}

/** input type for incrementing numeric columns in table "bill" */
export type Bill_Inc_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  billing_account_transaction_id?: InputMaybe<Scalars["bigint"]["input"]>
  billing_period_id?: InputMaybe<Scalars["bigint"]["input"]>
  gross_amount?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  net_amount?: InputMaybe<Scalars["numeric"]["input"]>
  version_number?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "bill" */
export type Bill_Insert_Input = {
  bill_accepted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  bill_created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  bill_number?: InputMaybe<Scalars["String"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  billing_account_transaction_id?: InputMaybe<Scalars["bigint"]["input"]>
  billing_period?: InputMaybe<Billing_Period_Obj_Rel_Insert_Input>
  billing_period_id?: InputMaybe<Scalars["bigint"]["input"]>
  consolidated_bill_fl?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  currency?: InputMaybe<Scalars["String"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  dirty_fl?: InputMaybe<Scalars["Boolean"]["input"]>
  due_dt?: InputMaybe<Scalars["date"]["input"]>
  final_fl?: InputMaybe<Scalars["Boolean"]["input"]>
  from_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  gross_amount?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  issue_dt?: InputMaybe<Scalars["date"]["input"]>
  net_amount?: InputMaybe<Scalars["numeric"]["input"]>
  status?: InputMaybe<Scalars["bill_status"]["input"]>
  superseded_fl?: InputMaybe<Scalars["Boolean"]["input"]>
  to_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  version_number?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate max on columns */
export type Bill_Max_Fields = {
  __typename?: "bill_max_fields"
  bill_accepted_at?: Maybe<Scalars["timestamp"]["output"]>
  bill_created_at?: Maybe<Scalars["timestamp"]["output"]>
  bill_number?: Maybe<Scalars["String"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  billing_account_transaction_id?: Maybe<Scalars["bigint"]["output"]>
  billing_period_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  currency?: Maybe<Scalars["String"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  due_dt?: Maybe<Scalars["date"]["output"]>
  from_dttm?: Maybe<Scalars["timestamp"]["output"]>
  gross_amount?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  issue_dt?: Maybe<Scalars["date"]["output"]>
  net_amount?: Maybe<Scalars["numeric"]["output"]>
  status?: Maybe<Scalars["bill_status"]["output"]>
  to_dttm?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  version_number?: Maybe<Scalars["Int"]["output"]>
}

/** order by max() on columns of table "bill" */
export type Bill_Max_Order_By = {
  bill_accepted_at?: InputMaybe<Order_By>
  bill_created_at?: InputMaybe<Order_By>
  bill_number?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  billing_account_transaction_id?: InputMaybe<Order_By>
  billing_period_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  currency?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  due_dt?: InputMaybe<Order_By>
  from_dttm?: InputMaybe<Order_By>
  gross_amount?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  issue_dt?: InputMaybe<Order_By>
  net_amount?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  to_dttm?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  version_number?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Bill_Min_Fields = {
  __typename?: "bill_min_fields"
  bill_accepted_at?: Maybe<Scalars["timestamp"]["output"]>
  bill_created_at?: Maybe<Scalars["timestamp"]["output"]>
  bill_number?: Maybe<Scalars["String"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  billing_account_transaction_id?: Maybe<Scalars["bigint"]["output"]>
  billing_period_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  currency?: Maybe<Scalars["String"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  due_dt?: Maybe<Scalars["date"]["output"]>
  from_dttm?: Maybe<Scalars["timestamp"]["output"]>
  gross_amount?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  issue_dt?: Maybe<Scalars["date"]["output"]>
  net_amount?: Maybe<Scalars["numeric"]["output"]>
  status?: Maybe<Scalars["bill_status"]["output"]>
  to_dttm?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  version_number?: Maybe<Scalars["Int"]["output"]>
}

/** order by min() on columns of table "bill" */
export type Bill_Min_Order_By = {
  bill_accepted_at?: InputMaybe<Order_By>
  bill_created_at?: InputMaybe<Order_By>
  bill_number?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  billing_account_transaction_id?: InputMaybe<Order_By>
  billing_period_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  currency?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  due_dt?: InputMaybe<Order_By>
  from_dttm?: InputMaybe<Order_By>
  gross_amount?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  issue_dt?: InputMaybe<Order_By>
  net_amount?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  to_dttm?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  version_number?: InputMaybe<Order_By>
}

/** response of any mutation on the table "bill" */
export type Bill_Mutation_Response = {
  __typename?: "bill_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Bill>
}

/** on_conflict condition type for table "bill" */
export type Bill_On_Conflict = {
  constraint: Bill_Constraint
  update_columns?: Array<Bill_Update_Column>
  where?: InputMaybe<Bill_Bool_Exp>
}

/** Ordering options when selecting data from "bill". */
export type Bill_Order_By = {
  bill_accepted_at?: InputMaybe<Order_By>
  bill_created_at?: InputMaybe<Order_By>
  bill_number?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  billing_account_transaction_id?: InputMaybe<Order_By>
  billing_period?: InputMaybe<Billing_Period_Order_By>
  billing_period_id?: InputMaybe<Order_By>
  consolidated_bill_fl?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  currency?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  dirty_fl?: InputMaybe<Order_By>
  due_dt?: InputMaybe<Order_By>
  final_fl?: InputMaybe<Order_By>
  from_dttm?: InputMaybe<Order_By>
  gross_amount?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  issue_dt?: InputMaybe<Order_By>
  net_amount?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  superseded_fl?: InputMaybe<Order_By>
  to_dttm?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  version_number?: InputMaybe<Order_By>
}

/** primary key columns input for table: bill */
export type Bill_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "bill" */
export enum Bill_Select_Column {
  /** column name */
  BillAcceptedAt = "bill_accepted_at",
  /** column name */
  BillCreatedAt = "bill_created_at",
  /** column name */
  BillNumber = "bill_number",
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  BillingAccountTransactionId = "billing_account_transaction_id",
  /** column name */
  BillingPeriodId = "billing_period_id",
  /** column name */
  ConsolidatedBillFl = "consolidated_bill_fl",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Currency = "currency",
  /** column name */
  Deleted = "deleted",
  /** column name */
  DirtyFl = "dirty_fl",
  /** column name */
  DueDt = "due_dt",
  /** column name */
  FinalFl = "final_fl",
  /** column name */
  FromDttm = "from_dttm",
  /** column name */
  GrossAmount = "gross_amount",
  /** column name */
  Id = "id",
  /** column name */
  IssueDt = "issue_dt",
  /** column name */
  NetAmount = "net_amount",
  /** column name */
  Status = "status",
  /** column name */
  SupersededFl = "superseded_fl",
  /** column name */
  ToDttm = "to_dttm",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  VersionNumber = "version_number",
}

/** select "bill_aggregate_bool_exp_bool_and_arguments_columns" columns of table "bill" */
export enum Bill_Select_Column_Bill_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ConsolidatedBillFl = "consolidated_bill_fl",
  /** column name */
  DirtyFl = "dirty_fl",
  /** column name */
  FinalFl = "final_fl",
  /** column name */
  SupersededFl = "superseded_fl",
}

/** select "bill_aggregate_bool_exp_bool_or_arguments_columns" columns of table "bill" */
export enum Bill_Select_Column_Bill_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ConsolidatedBillFl = "consolidated_bill_fl",
  /** column name */
  DirtyFl = "dirty_fl",
  /** column name */
  FinalFl = "final_fl",
  /** column name */
  SupersededFl = "superseded_fl",
}

/** input type for updating data in table "bill" */
export type Bill_Set_Input = {
  bill_accepted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  bill_created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  bill_number?: InputMaybe<Scalars["String"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  billing_account_transaction_id?: InputMaybe<Scalars["bigint"]["input"]>
  billing_period_id?: InputMaybe<Scalars["bigint"]["input"]>
  consolidated_bill_fl?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  currency?: InputMaybe<Scalars["String"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  dirty_fl?: InputMaybe<Scalars["Boolean"]["input"]>
  due_dt?: InputMaybe<Scalars["date"]["input"]>
  final_fl?: InputMaybe<Scalars["Boolean"]["input"]>
  from_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  gross_amount?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  issue_dt?: InputMaybe<Scalars["date"]["input"]>
  net_amount?: InputMaybe<Scalars["numeric"]["input"]>
  status?: InputMaybe<Scalars["bill_status"]["input"]>
  superseded_fl?: InputMaybe<Scalars["Boolean"]["input"]>
  to_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  version_number?: InputMaybe<Scalars["Int"]["input"]>
}

/** Boolean expression to compare columns of type "bill_status". All fields are combined with logical 'AND'. */
export type Bill_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["bill_status"]["input"]>
  _gt?: InputMaybe<Scalars["bill_status"]["input"]>
  _gte?: InputMaybe<Scalars["bill_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["bill_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["bill_status"]["input"]>
  _lte?: InputMaybe<Scalars["bill_status"]["input"]>
  _neq?: InputMaybe<Scalars["bill_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["bill_status"]["input"]>>
}

/** aggregate stddev on columns */
export type Bill_Stddev_Fields = {
  __typename?: "bill_stddev_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  billing_account_transaction_id?: Maybe<Scalars["Float"]["output"]>
  billing_period_id?: Maybe<Scalars["Float"]["output"]>
  gross_amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  net_amount?: Maybe<Scalars["Float"]["output"]>
  version_number?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "bill" */
export type Bill_Stddev_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  billing_account_transaction_id?: InputMaybe<Order_By>
  billing_period_id?: InputMaybe<Order_By>
  gross_amount?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  net_amount?: InputMaybe<Order_By>
  version_number?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Bill_Stddev_Pop_Fields = {
  __typename?: "bill_stddev_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  billing_account_transaction_id?: Maybe<Scalars["Float"]["output"]>
  billing_period_id?: Maybe<Scalars["Float"]["output"]>
  gross_amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  net_amount?: Maybe<Scalars["Float"]["output"]>
  version_number?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "bill" */
export type Bill_Stddev_Pop_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  billing_account_transaction_id?: InputMaybe<Order_By>
  billing_period_id?: InputMaybe<Order_By>
  gross_amount?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  net_amount?: InputMaybe<Order_By>
  version_number?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Bill_Stddev_Samp_Fields = {
  __typename?: "bill_stddev_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  billing_account_transaction_id?: Maybe<Scalars["Float"]["output"]>
  billing_period_id?: Maybe<Scalars["Float"]["output"]>
  gross_amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  net_amount?: Maybe<Scalars["Float"]["output"]>
  version_number?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "bill" */
export type Bill_Stddev_Samp_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  billing_account_transaction_id?: InputMaybe<Order_By>
  billing_period_id?: InputMaybe<Order_By>
  gross_amount?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  net_amount?: InputMaybe<Order_By>
  version_number?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "bill" */
export type Bill_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bill_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Bill_Stream_Cursor_Value_Input = {
  bill_accepted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  bill_created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  bill_number?: InputMaybe<Scalars["String"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  billing_account_transaction_id?: InputMaybe<Scalars["bigint"]["input"]>
  billing_period_id?: InputMaybe<Scalars["bigint"]["input"]>
  consolidated_bill_fl?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  currency?: InputMaybe<Scalars["String"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  dirty_fl?: InputMaybe<Scalars["Boolean"]["input"]>
  due_dt?: InputMaybe<Scalars["date"]["input"]>
  final_fl?: InputMaybe<Scalars["Boolean"]["input"]>
  from_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  gross_amount?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  issue_dt?: InputMaybe<Scalars["date"]["input"]>
  net_amount?: InputMaybe<Scalars["numeric"]["input"]>
  status?: InputMaybe<Scalars["bill_status"]["input"]>
  superseded_fl?: InputMaybe<Scalars["Boolean"]["input"]>
  to_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  version_number?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate sum on columns */
export type Bill_Sum_Fields = {
  __typename?: "bill_sum_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  billing_account_transaction_id?: Maybe<Scalars["bigint"]["output"]>
  billing_period_id?: Maybe<Scalars["bigint"]["output"]>
  gross_amount?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  net_amount?: Maybe<Scalars["numeric"]["output"]>
  version_number?: Maybe<Scalars["Int"]["output"]>
}

/** order by sum() on columns of table "bill" */
export type Bill_Sum_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  billing_account_transaction_id?: InputMaybe<Order_By>
  billing_period_id?: InputMaybe<Order_By>
  gross_amount?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  net_amount?: InputMaybe<Order_By>
  version_number?: InputMaybe<Order_By>
}

/** update columns of table "bill" */
export enum Bill_Update_Column {
  /** column name */
  BillAcceptedAt = "bill_accepted_at",
  /** column name */
  BillCreatedAt = "bill_created_at",
  /** column name */
  BillNumber = "bill_number",
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  BillingAccountTransactionId = "billing_account_transaction_id",
  /** column name */
  BillingPeriodId = "billing_period_id",
  /** column name */
  ConsolidatedBillFl = "consolidated_bill_fl",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Currency = "currency",
  /** column name */
  Deleted = "deleted",
  /** column name */
  DirtyFl = "dirty_fl",
  /** column name */
  DueDt = "due_dt",
  /** column name */
  FinalFl = "final_fl",
  /** column name */
  FromDttm = "from_dttm",
  /** column name */
  GrossAmount = "gross_amount",
  /** column name */
  Id = "id",
  /** column name */
  IssueDt = "issue_dt",
  /** column name */
  NetAmount = "net_amount",
  /** column name */
  Status = "status",
  /** column name */
  SupersededFl = "superseded_fl",
  /** column name */
  ToDttm = "to_dttm",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  VersionNumber = "version_number",
}

export type Bill_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Bill_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bill_Set_Input>
  /** filter the rows which have to be updated */
  where: Bill_Bool_Exp
}

/** aggregate var_pop on columns */
export type Bill_Var_Pop_Fields = {
  __typename?: "bill_var_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  billing_account_transaction_id?: Maybe<Scalars["Float"]["output"]>
  billing_period_id?: Maybe<Scalars["Float"]["output"]>
  gross_amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  net_amount?: Maybe<Scalars["Float"]["output"]>
  version_number?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "bill" */
export type Bill_Var_Pop_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  billing_account_transaction_id?: InputMaybe<Order_By>
  billing_period_id?: InputMaybe<Order_By>
  gross_amount?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  net_amount?: InputMaybe<Order_By>
  version_number?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Bill_Var_Samp_Fields = {
  __typename?: "bill_var_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  billing_account_transaction_id?: Maybe<Scalars["Float"]["output"]>
  billing_period_id?: Maybe<Scalars["Float"]["output"]>
  gross_amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  net_amount?: Maybe<Scalars["Float"]["output"]>
  version_number?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "bill" */
export type Bill_Var_Samp_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  billing_account_transaction_id?: InputMaybe<Order_By>
  billing_period_id?: InputMaybe<Order_By>
  gross_amount?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  net_amount?: InputMaybe<Order_By>
  version_number?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Bill_Variance_Fields = {
  __typename?: "bill_variance_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  billing_account_transaction_id?: Maybe<Scalars["Float"]["output"]>
  billing_period_id?: Maybe<Scalars["Float"]["output"]>
  gross_amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  net_amount?: Maybe<Scalars["Float"]["output"]>
  version_number?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "bill" */
export type Bill_Variance_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  billing_account_transaction_id?: InputMaybe<Order_By>
  billing_period_id?: InputMaybe<Order_By>
  gross_amount?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  net_amount?: InputMaybe<Order_By>
  version_number?: InputMaybe<Order_By>
}

/** columns and relationships of "billing_account" */
export type Billing_Account = {
  __typename?: "billing_account"
  /** An array relationship */
  billing_account_contacts: Array<Billing_Account_Contact>
  /** An aggregate relationship */
  billing_account_contacts_aggregate: Billing_Account_Contact_Aggregate
  /** An object relationship */
  billing_account_number_agreement?: Maybe<Agreement>
  /** An object relationship */
  billing_account_setting: Billing_Account_Setting
  billing_account_transactions: Array<Billing_Account_Transaction>
  billing_account_transactions_aggregate: Billing_Account_Transaction_Aggregate
  /** An array relationship */
  cancellations: Array<Cancellations>
  /** An aggregate relationship */
  cancellations_aggregate: Cancellations_Aggregate
  cancelled?: Maybe<Scalars["timestamp"]["output"]>
  class: Scalars["billing_account_class"]["output"]
  closed?: Maybe<Scalars["timestamp"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  currency: Scalars["String"]["output"]
  /** An object relationship */
  customer: Customer
  customer_id: Scalars["bigint"]["output"]
  customer_user_rels: Array<Customer_User_Rel>
  customer_user_rels_aggregate: Customer_User_Rel_Aggregate
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  /** An object relationship */
  flex_market_subscription_eligibility?: Maybe<Axle_Trial_Eligibility>
  /** An array relationship */
  flex_market_subscriptions: Array<Flex_Market_Subscription>
  /** An aggregate relationship */
  flex_market_subscriptions_aggregate: Flex_Market_Subscription_Aggregate
  from_date: Scalars["timestamp"]["output"]
  id: Scalars["bigint"]["output"]
  name: Scalars["String"]["output"]
  number: Scalars["String"]["output"]
  /** An array relationship */
  product_accounts: Array<Product_Account>
  /** An aggregate relationship */
  product_accounts_aggregate: Product_Account_Aggregate
  /** An array relationship */
  reminders: Array<Reminder>
  /** An aggregate relationship */
  reminders_aggregate: Reminder_Aggregate
  settings_id: Scalars["bigint"]["output"]
  terminated?: Maybe<Scalars["timestamp"]["output"]>
  to_date?: Maybe<Scalars["timestamp"]["output"]>
  type: Scalars["billing_account_type"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "billing_account" */
export type Billing_AccountBilling_Account_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Contact_Order_By>>
  where?: InputMaybe<Billing_Account_Contact_Bool_Exp>
}

/** columns and relationships of "billing_account" */
export type Billing_AccountBilling_Account_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Contact_Order_By>>
  where?: InputMaybe<Billing_Account_Contact_Bool_Exp>
}

/** columns and relationships of "billing_account" */
export type Billing_AccountBilling_Account_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Transaction_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Transaction_Order_By>>
  where?: InputMaybe<Billing_Account_Transaction_Bool_Exp>
}

/** columns and relationships of "billing_account" */
export type Billing_AccountBilling_Account_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Transaction_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Transaction_Order_By>>
  where?: InputMaybe<Billing_Account_Transaction_Bool_Exp>
}

/** columns and relationships of "billing_account" */
export type Billing_AccountCancellationsArgs = {
  distinct_on?: InputMaybe<Array<Cancellations_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Cancellations_Order_By>>
  where?: InputMaybe<Cancellations_Bool_Exp>
}

/** columns and relationships of "billing_account" */
export type Billing_AccountCancellations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cancellations_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Cancellations_Order_By>>
  where?: InputMaybe<Cancellations_Bool_Exp>
}

/** columns and relationships of "billing_account" */
export type Billing_AccountCustomer_User_RelsArgs = {
  distinct_on?: InputMaybe<Array<Customer_User_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_User_Rel_Order_By>>
  where?: InputMaybe<Customer_User_Rel_Bool_Exp>
}

/** columns and relationships of "billing_account" */
export type Billing_AccountCustomer_User_Rels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_User_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_User_Rel_Order_By>>
  where?: InputMaybe<Customer_User_Rel_Bool_Exp>
}

/** columns and relationships of "billing_account" */
export type Billing_AccountFlex_Market_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Flex_Market_Subscription_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Flex_Market_Subscription_Order_By>>
  where?: InputMaybe<Flex_Market_Subscription_Bool_Exp>
}

/** columns and relationships of "billing_account" */
export type Billing_AccountFlex_Market_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Flex_Market_Subscription_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Flex_Market_Subscription_Order_By>>
  where?: InputMaybe<Flex_Market_Subscription_Bool_Exp>
}

/** columns and relationships of "billing_account" */
export type Billing_AccountProduct_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Product_Account_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Account_Order_By>>
  where?: InputMaybe<Product_Account_Bool_Exp>
}

/** columns and relationships of "billing_account" */
export type Billing_AccountProduct_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Account_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Account_Order_By>>
  where?: InputMaybe<Product_Account_Bool_Exp>
}

/** columns and relationships of "billing_account" */
export type Billing_AccountRemindersArgs = {
  distinct_on?: InputMaybe<Array<Reminder_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Reminder_Order_By>>
  where?: InputMaybe<Reminder_Bool_Exp>
}

/** columns and relationships of "billing_account" */
export type Billing_AccountReminders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reminder_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Reminder_Order_By>>
  where?: InputMaybe<Reminder_Bool_Exp>
}

/** aggregated selection of "billing_account" */
export type Billing_Account_Aggregate = {
  __typename?: "billing_account_aggregate"
  aggregate?: Maybe<Billing_Account_Aggregate_Fields>
  nodes: Array<Billing_Account>
}

export type Billing_Account_Aggregate_Bool_Exp = {
  count?: InputMaybe<Billing_Account_Aggregate_Bool_Exp_Count>
}

export type Billing_Account_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Billing_Account_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Billing_Account_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "billing_account" */
export type Billing_Account_Aggregate_Fields = {
  __typename?: "billing_account_aggregate_fields"
  avg?: Maybe<Billing_Account_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Billing_Account_Max_Fields>
  min?: Maybe<Billing_Account_Min_Fields>
  stddev?: Maybe<Billing_Account_Stddev_Fields>
  stddev_pop?: Maybe<Billing_Account_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Billing_Account_Stddev_Samp_Fields>
  sum?: Maybe<Billing_Account_Sum_Fields>
  var_pop?: Maybe<Billing_Account_Var_Pop_Fields>
  var_samp?: Maybe<Billing_Account_Var_Samp_Fields>
  variance?: Maybe<Billing_Account_Variance_Fields>
}

/** aggregate fields of "billing_account" */
export type Billing_Account_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Billing_Account_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "billing_account" */
export type Billing_Account_Aggregate_Order_By = {
  avg?: InputMaybe<Billing_Account_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Billing_Account_Max_Order_By>
  min?: InputMaybe<Billing_Account_Min_Order_By>
  stddev?: InputMaybe<Billing_Account_Stddev_Order_By>
  stddev_pop?: InputMaybe<Billing_Account_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Billing_Account_Stddev_Samp_Order_By>
  sum?: InputMaybe<Billing_Account_Sum_Order_By>
  var_pop?: InputMaybe<Billing_Account_Var_Pop_Order_By>
  var_samp?: InputMaybe<Billing_Account_Var_Samp_Order_By>
  variance?: InputMaybe<Billing_Account_Variance_Order_By>
}

/** input type for inserting array relation for remote table "billing_account" */
export type Billing_Account_Arr_Rel_Insert_Input = {
  data: Array<Billing_Account_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Billing_Account_On_Conflict>
}

/** aggregate avg on columns */
export type Billing_Account_Avg_Fields = {
  __typename?: "billing_account_avg_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  settings_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "billing_account" */
export type Billing_Account_Avg_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  settings_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "billing_account". All fields are combined with a logical 'AND'. */
export type Billing_Account_Bool_Exp = {
  _and?: InputMaybe<Array<Billing_Account_Bool_Exp>>
  _not?: InputMaybe<Billing_Account_Bool_Exp>
  _or?: InputMaybe<Array<Billing_Account_Bool_Exp>>
  billing_account_contacts?: InputMaybe<Billing_Account_Contact_Bool_Exp>
  billing_account_contacts_aggregate?: InputMaybe<Billing_Account_Contact_Aggregate_Bool_Exp>
  billing_account_number_agreement?: InputMaybe<Agreement_Bool_Exp>
  billing_account_setting?: InputMaybe<Billing_Account_Setting_Bool_Exp>
  cancellations?: InputMaybe<Cancellations_Bool_Exp>
  cancellations_aggregate?: InputMaybe<Cancellations_Aggregate_Bool_Exp>
  cancelled?: InputMaybe<Timestamp_Comparison_Exp>
  class?: InputMaybe<Billing_Account_Class_Comparison_Exp>
  closed?: InputMaybe<Timestamp_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  currency?: InputMaybe<String_Comparison_Exp>
  customer?: InputMaybe<Customer_Bool_Exp>
  customer_id?: InputMaybe<Bigint_Comparison_Exp>
  customer_user_rels?: InputMaybe<Customer_User_Rel_Bool_Exp>
  customer_user_rels_aggregate?: InputMaybe<Customer_User_Rel_Aggregate_Bool_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  flex_market_subscription_eligibility?: InputMaybe<Axle_Trial_Eligibility_Bool_Exp>
  flex_market_subscriptions?: InputMaybe<Flex_Market_Subscription_Bool_Exp>
  flex_market_subscriptions_aggregate?: InputMaybe<Flex_Market_Subscription_Aggregate_Bool_Exp>
  from_date?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  number?: InputMaybe<String_Comparison_Exp>
  product_accounts?: InputMaybe<Product_Account_Bool_Exp>
  product_accounts_aggregate?: InputMaybe<Product_Account_Aggregate_Bool_Exp>
  reminders?: InputMaybe<Reminder_Bool_Exp>
  reminders_aggregate?: InputMaybe<Reminder_Aggregate_Bool_Exp>
  settings_id?: InputMaybe<Bigint_Comparison_Exp>
  terminated?: InputMaybe<Timestamp_Comparison_Exp>
  to_date?: InputMaybe<Timestamp_Comparison_Exp>
  type?: InputMaybe<Billing_Account_Type_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** Boolean expression to compare columns of type "billing_account_class". All fields are combined with logical 'AND'. */
export type Billing_Account_Class_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["billing_account_class"]["input"]>
  _gt?: InputMaybe<Scalars["billing_account_class"]["input"]>
  _gte?: InputMaybe<Scalars["billing_account_class"]["input"]>
  _in?: InputMaybe<Array<Scalars["billing_account_class"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["billing_account_class"]["input"]>
  _lte?: InputMaybe<Scalars["billing_account_class"]["input"]>
  _neq?: InputMaybe<Scalars["billing_account_class"]["input"]>
  _nin?: InputMaybe<Array<Scalars["billing_account_class"]["input"]>>
}

/** unique or primary key constraints on table "billing_account" */
export enum Billing_Account_Constraint {
  /** unique or primary key constraint on columns "id" */
  BillingAccountPkey = "billing_account_pkey",
}

/** columns and relationships of "billing_account_contact" */
export type Billing_Account_Contact = {
  __typename?: "billing_account_contact"
  /** An object relationship */
  billing_account: Billing_Account
  billing_account_id: Scalars["bigint"]["output"]
  cancelled?: Maybe<Scalars["timestamp"]["output"]>
  /** An object relationship */
  contact: Contact
  contact_id: Scalars["bigint"]["output"]
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_date?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  primary: Scalars["Boolean"]["output"]
  to_date?: Maybe<Scalars["timestamp"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "billing_account_contact" */
export type Billing_Account_Contact_Aggregate = {
  __typename?: "billing_account_contact_aggregate"
  aggregate?: Maybe<Billing_Account_Contact_Aggregate_Fields>
  nodes: Array<Billing_Account_Contact>
}

export type Billing_Account_Contact_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Billing_Account_Contact_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Billing_Account_Contact_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<Billing_Account_Contact_Aggregate_Bool_Exp_Count>
}

export type Billing_Account_Contact_Aggregate_Bool_Exp_Bool_And = {
  arguments: Billing_Account_Contact_Select_Column_Billing_Account_Contact_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Billing_Account_Contact_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Billing_Account_Contact_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Billing_Account_Contact_Select_Column_Billing_Account_Contact_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Billing_Account_Contact_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Billing_Account_Contact_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Billing_Account_Contact_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Billing_Account_Contact_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "billing_account_contact" */
export type Billing_Account_Contact_Aggregate_Fields = {
  __typename?: "billing_account_contact_aggregate_fields"
  avg?: Maybe<Billing_Account_Contact_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Billing_Account_Contact_Max_Fields>
  min?: Maybe<Billing_Account_Contact_Min_Fields>
  stddev?: Maybe<Billing_Account_Contact_Stddev_Fields>
  stddev_pop?: Maybe<Billing_Account_Contact_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Billing_Account_Contact_Stddev_Samp_Fields>
  sum?: Maybe<Billing_Account_Contact_Sum_Fields>
  var_pop?: Maybe<Billing_Account_Contact_Var_Pop_Fields>
  var_samp?: Maybe<Billing_Account_Contact_Var_Samp_Fields>
  variance?: Maybe<Billing_Account_Contact_Variance_Fields>
}

/** aggregate fields of "billing_account_contact" */
export type Billing_Account_Contact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Billing_Account_Contact_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "billing_account_contact" */
export type Billing_Account_Contact_Aggregate_Order_By = {
  avg?: InputMaybe<Billing_Account_Contact_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Billing_Account_Contact_Max_Order_By>
  min?: InputMaybe<Billing_Account_Contact_Min_Order_By>
  stddev?: InputMaybe<Billing_Account_Contact_Stddev_Order_By>
  stddev_pop?: InputMaybe<Billing_Account_Contact_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Billing_Account_Contact_Stddev_Samp_Order_By>
  sum?: InputMaybe<Billing_Account_Contact_Sum_Order_By>
  var_pop?: InputMaybe<Billing_Account_Contact_Var_Pop_Order_By>
  var_samp?: InputMaybe<Billing_Account_Contact_Var_Samp_Order_By>
  variance?: InputMaybe<Billing_Account_Contact_Variance_Order_By>
}

/** input type for inserting array relation for remote table "billing_account_contact" */
export type Billing_Account_Contact_Arr_Rel_Insert_Input = {
  data: Array<Billing_Account_Contact_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Billing_Account_Contact_On_Conflict>
}

/** aggregate avg on columns */
export type Billing_Account_Contact_Avg_Fields = {
  __typename?: "billing_account_contact_avg_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  contact_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "billing_account_contact" */
export type Billing_Account_Contact_Avg_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  contact_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "billing_account_contact". All fields are combined with a logical 'AND'. */
export type Billing_Account_Contact_Bool_Exp = {
  _and?: InputMaybe<Array<Billing_Account_Contact_Bool_Exp>>
  _not?: InputMaybe<Billing_Account_Contact_Bool_Exp>
  _or?: InputMaybe<Array<Billing_Account_Contact_Bool_Exp>>
  billing_account?: InputMaybe<Billing_Account_Bool_Exp>
  billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  cancelled?: InputMaybe<Timestamp_Comparison_Exp>
  contact?: InputMaybe<Contact_Bool_Exp>
  contact_id?: InputMaybe<Bigint_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  from_date?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  primary?: InputMaybe<Boolean_Comparison_Exp>
  to_date?: InputMaybe<Timestamp_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "billing_account_contact" */
export enum Billing_Account_Contact_Constraint {
  /** unique or primary key constraint on columns "id" */
  BillingAccountContactPkey = "billing_account_contact_pkey",
}

/** input type for incrementing numeric columns in table "billing_account_contact" */
export type Billing_Account_Contact_Inc_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  contact_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "billing_account_contact" */
export type Billing_Account_Contact_Insert_Input = {
  billing_account?: InputMaybe<Billing_Account_Obj_Rel_Insert_Input>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  cancelled?: InputMaybe<Scalars["timestamp"]["input"]>
  contact?: InputMaybe<Contact_Obj_Rel_Insert_Input>
  contact_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_date?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  primary?: InputMaybe<Scalars["Boolean"]["input"]>
  to_date?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Billing_Account_Contact_Max_Fields = {
  __typename?: "billing_account_contact_max_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  cancelled?: Maybe<Scalars["timestamp"]["output"]>
  contact_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_date?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  to_date?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "billing_account_contact" */
export type Billing_Account_Contact_Max_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  cancelled?: InputMaybe<Order_By>
  contact_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  from_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  to_date?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Billing_Account_Contact_Min_Fields = {
  __typename?: "billing_account_contact_min_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  cancelled?: Maybe<Scalars["timestamp"]["output"]>
  contact_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_date?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  to_date?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "billing_account_contact" */
export type Billing_Account_Contact_Min_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  cancelled?: InputMaybe<Order_By>
  contact_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  from_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  to_date?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "billing_account_contact" */
export type Billing_Account_Contact_Mutation_Response = {
  __typename?: "billing_account_contact_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Billing_Account_Contact>
}

/** on_conflict condition type for table "billing_account_contact" */
export type Billing_Account_Contact_On_Conflict = {
  constraint: Billing_Account_Contact_Constraint
  update_columns?: Array<Billing_Account_Contact_Update_Column>
  where?: InputMaybe<Billing_Account_Contact_Bool_Exp>
}

/** Ordering options when selecting data from "billing_account_contact". */
export type Billing_Account_Contact_Order_By = {
  billing_account?: InputMaybe<Billing_Account_Order_By>
  billing_account_id?: InputMaybe<Order_By>
  cancelled?: InputMaybe<Order_By>
  contact?: InputMaybe<Contact_Order_By>
  contact_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  from_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  primary?: InputMaybe<Order_By>
  to_date?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: billing_account_contact */
export type Billing_Account_Contact_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "billing_account_contact" */
export enum Billing_Account_Contact_Select_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  Cancelled = "cancelled",
  /** column name */
  ContactId = "contact_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FromDate = "from_date",
  /** column name */
  Id = "id",
  /** column name */
  Primary = "primary",
  /** column name */
  ToDate = "to_date",
  /** column name */
  UpdatedAt = "updated_at",
}

/** select "billing_account_contact_aggregate_bool_exp_bool_and_arguments_columns" columns of table "billing_account_contact" */
export enum Billing_Account_Contact_Select_Column_Billing_Account_Contact_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Primary = "primary",
}

/** select "billing_account_contact_aggregate_bool_exp_bool_or_arguments_columns" columns of table "billing_account_contact" */
export enum Billing_Account_Contact_Select_Column_Billing_Account_Contact_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Primary = "primary",
}

/** input type for updating data in table "billing_account_contact" */
export type Billing_Account_Contact_Set_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  cancelled?: InputMaybe<Scalars["timestamp"]["input"]>
  contact_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_date?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  primary?: InputMaybe<Scalars["Boolean"]["input"]>
  to_date?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Billing_Account_Contact_Stddev_Fields = {
  __typename?: "billing_account_contact_stddev_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  contact_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "billing_account_contact" */
export type Billing_Account_Contact_Stddev_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  contact_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Billing_Account_Contact_Stddev_Pop_Fields = {
  __typename?: "billing_account_contact_stddev_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  contact_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "billing_account_contact" */
export type Billing_Account_Contact_Stddev_Pop_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  contact_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Billing_Account_Contact_Stddev_Samp_Fields = {
  __typename?: "billing_account_contact_stddev_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  contact_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "billing_account_contact" */
export type Billing_Account_Contact_Stddev_Samp_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  contact_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "billing_account_contact" */
export type Billing_Account_Contact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Billing_Account_Contact_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Billing_Account_Contact_Stream_Cursor_Value_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  cancelled?: InputMaybe<Scalars["timestamp"]["input"]>
  contact_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_date?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  primary?: InputMaybe<Scalars["Boolean"]["input"]>
  to_date?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Billing_Account_Contact_Sum_Fields = {
  __typename?: "billing_account_contact_sum_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  contact_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "billing_account_contact" */
export type Billing_Account_Contact_Sum_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  contact_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** update columns of table "billing_account_contact" */
export enum Billing_Account_Contact_Update_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  Cancelled = "cancelled",
  /** column name */
  ContactId = "contact_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FromDate = "from_date",
  /** column name */
  Id = "id",
  /** column name */
  Primary = "primary",
  /** column name */
  ToDate = "to_date",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Billing_Account_Contact_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Billing_Account_Contact_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Billing_Account_Contact_Set_Input>
  /** filter the rows which have to be updated */
  where: Billing_Account_Contact_Bool_Exp
}

/** aggregate var_pop on columns */
export type Billing_Account_Contact_Var_Pop_Fields = {
  __typename?: "billing_account_contact_var_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  contact_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "billing_account_contact" */
export type Billing_Account_Contact_Var_Pop_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  contact_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Billing_Account_Contact_Var_Samp_Fields = {
  __typename?: "billing_account_contact_var_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  contact_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "billing_account_contact" */
export type Billing_Account_Contact_Var_Samp_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  contact_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Billing_Account_Contact_Variance_Fields = {
  __typename?: "billing_account_contact_variance_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  contact_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "billing_account_contact" */
export type Billing_Account_Contact_Variance_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  contact_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** columns and relationships of "billing_account_ids_with_meter_point_ids" */
export type Billing_Account_Ids_With_Meter_Point_Ids = {
  __typename?: "billing_account_ids_with_meter_point_ids"
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_points?: Maybe<Array<Scalars["Int"]["output"]>>
}

/** aggregated selection of "billing_account_ids_with_meter_point_ids" */
export type Billing_Account_Ids_With_Meter_Point_Ids_Aggregate = {
  __typename?: "billing_account_ids_with_meter_point_ids_aggregate"
  aggregate?: Maybe<Billing_Account_Ids_With_Meter_Point_Ids_Aggregate_Fields>
  nodes: Array<Billing_Account_Ids_With_Meter_Point_Ids>
}

/** aggregate fields of "billing_account_ids_with_meter_point_ids" */
export type Billing_Account_Ids_With_Meter_Point_Ids_Aggregate_Fields = {
  __typename?: "billing_account_ids_with_meter_point_ids_aggregate_fields"
  avg?: Maybe<Billing_Account_Ids_With_Meter_Point_Ids_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Billing_Account_Ids_With_Meter_Point_Ids_Max_Fields>
  min?: Maybe<Billing_Account_Ids_With_Meter_Point_Ids_Min_Fields>
  stddev?: Maybe<Billing_Account_Ids_With_Meter_Point_Ids_Stddev_Fields>
  stddev_pop?: Maybe<Billing_Account_Ids_With_Meter_Point_Ids_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Billing_Account_Ids_With_Meter_Point_Ids_Stddev_Samp_Fields>
  sum?: Maybe<Billing_Account_Ids_With_Meter_Point_Ids_Sum_Fields>
  var_pop?: Maybe<Billing_Account_Ids_With_Meter_Point_Ids_Var_Pop_Fields>
  var_samp?: Maybe<Billing_Account_Ids_With_Meter_Point_Ids_Var_Samp_Fields>
  variance?: Maybe<Billing_Account_Ids_With_Meter_Point_Ids_Variance_Fields>
}

/** aggregate fields of "billing_account_ids_with_meter_point_ids" */
export type Billing_Account_Ids_With_Meter_Point_Ids_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Billing_Account_Ids_With_Meter_Point_Ids_Select_Column>
    >
    distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  }

/** aggregate avg on columns */
export type Billing_Account_Ids_With_Meter_Point_Ids_Avg_Fields = {
  __typename?: "billing_account_ids_with_meter_point_ids_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "billing_account_ids_with_meter_point_ids". All fields are combined with a logical 'AND'. */
export type Billing_Account_Ids_With_Meter_Point_Ids_Bool_Exp = {
  _and?: InputMaybe<Array<Billing_Account_Ids_With_Meter_Point_Ids_Bool_Exp>>
  _not?: InputMaybe<Billing_Account_Ids_With_Meter_Point_Ids_Bool_Exp>
  _or?: InputMaybe<Array<Billing_Account_Ids_With_Meter_Point_Ids_Bool_Exp>>
  id?: InputMaybe<Bigint_Comparison_Exp>
  meter_points?: InputMaybe<Int_Array_Comparison_Exp>
}

/** aggregate max on columns */
export type Billing_Account_Ids_With_Meter_Point_Ids_Max_Fields = {
  __typename?: "billing_account_ids_with_meter_point_ids_max_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_points?: Maybe<Array<Scalars["Int"]["output"]>>
}

/** aggregate min on columns */
export type Billing_Account_Ids_With_Meter_Point_Ids_Min_Fields = {
  __typename?: "billing_account_ids_with_meter_point_ids_min_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_points?: Maybe<Array<Scalars["Int"]["output"]>>
}

/** Ordering options when selecting data from "billing_account_ids_with_meter_point_ids". */
export type Billing_Account_Ids_With_Meter_Point_Ids_Order_By = {
  id?: InputMaybe<Order_By>
  meter_points?: InputMaybe<Order_By>
}

/** select columns of table "billing_account_ids_with_meter_point_ids" */
export enum Billing_Account_Ids_With_Meter_Point_Ids_Select_Column {
  /** column name */
  Id = "id",
  /** column name */
  MeterPoints = "meter_points",
}

/** aggregate stddev on columns */
export type Billing_Account_Ids_With_Meter_Point_Ids_Stddev_Fields = {
  __typename?: "billing_account_ids_with_meter_point_ids_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Billing_Account_Ids_With_Meter_Point_Ids_Stddev_Pop_Fields = {
  __typename?: "billing_account_ids_with_meter_point_ids_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Billing_Account_Ids_With_Meter_Point_Ids_Stddev_Samp_Fields = {
  __typename?: "billing_account_ids_with_meter_point_ids_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "billing_account_ids_with_meter_point_ids" */
export type Billing_Account_Ids_With_Meter_Point_Ids_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Billing_Account_Ids_With_Meter_Point_Ids_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Billing_Account_Ids_With_Meter_Point_Ids_Stream_Cursor_Value_Input =
  {
    id?: InputMaybe<Scalars["bigint"]["input"]>
    meter_points?: InputMaybe<Array<Scalars["Int"]["input"]>>
  }

/** aggregate sum on columns */
export type Billing_Account_Ids_With_Meter_Point_Ids_Sum_Fields = {
  __typename?: "billing_account_ids_with_meter_point_ids_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregate var_pop on columns */
export type Billing_Account_Ids_With_Meter_Point_Ids_Var_Pop_Fields = {
  __typename?: "billing_account_ids_with_meter_point_ids_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Billing_Account_Ids_With_Meter_Point_Ids_Var_Samp_Fields = {
  __typename?: "billing_account_ids_with_meter_point_ids_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Billing_Account_Ids_With_Meter_Point_Ids_Variance_Fields = {
  __typename?: "billing_account_ids_with_meter_point_ids_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** input type for incrementing numeric columns in table "billing_account" */
export type Billing_Account_Inc_Input = {
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  settings_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "billing_account" */
export type Billing_Account_Insert_Input = {
  billing_account_contacts?: InputMaybe<Billing_Account_Contact_Arr_Rel_Insert_Input>
  billing_account_number_agreement?: InputMaybe<Agreement_Obj_Rel_Insert_Input>
  billing_account_setting?: InputMaybe<Billing_Account_Setting_Obj_Rel_Insert_Input>
  cancellations?: InputMaybe<Cancellations_Arr_Rel_Insert_Input>
  cancelled?: InputMaybe<Scalars["timestamp"]["input"]>
  class?: InputMaybe<Scalars["billing_account_class"]["input"]>
  closed?: InputMaybe<Scalars["timestamp"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  currency?: InputMaybe<Scalars["String"]["input"]>
  customer?: InputMaybe<Customer_Obj_Rel_Insert_Input>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  customer_user_rels?: InputMaybe<Customer_User_Rel_Arr_Rel_Insert_Input>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  flex_market_subscription_eligibility?: InputMaybe<Axle_Trial_Eligibility_Obj_Rel_Insert_Input>
  flex_market_subscriptions?: InputMaybe<Flex_Market_Subscription_Arr_Rel_Insert_Input>
  from_date?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  number?: InputMaybe<Scalars["String"]["input"]>
  product_accounts?: InputMaybe<Product_Account_Arr_Rel_Insert_Input>
  reminders?: InputMaybe<Reminder_Arr_Rel_Insert_Input>
  settings_id?: InputMaybe<Scalars["bigint"]["input"]>
  terminated?: InputMaybe<Scalars["timestamp"]["input"]>
  to_date?: InputMaybe<Scalars["timestamp"]["input"]>
  type?: InputMaybe<Scalars["billing_account_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Billing_Account_Max_Fields = {
  __typename?: "billing_account_max_fields"
  cancelled?: Maybe<Scalars["timestamp"]["output"]>
  class?: Maybe<Scalars["billing_account_class"]["output"]>
  closed?: Maybe<Scalars["timestamp"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  currency?: Maybe<Scalars["String"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_date?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  number?: Maybe<Scalars["String"]["output"]>
  settings_id?: Maybe<Scalars["bigint"]["output"]>
  terminated?: Maybe<Scalars["timestamp"]["output"]>
  to_date?: Maybe<Scalars["timestamp"]["output"]>
  type?: Maybe<Scalars["billing_account_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "billing_account" */
export type Billing_Account_Max_Order_By = {
  cancelled?: InputMaybe<Order_By>
  class?: InputMaybe<Order_By>
  closed?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  currency?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  from_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  number?: InputMaybe<Order_By>
  settings_id?: InputMaybe<Order_By>
  terminated?: InputMaybe<Order_By>
  to_date?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Billing_Account_Min_Fields = {
  __typename?: "billing_account_min_fields"
  cancelled?: Maybe<Scalars["timestamp"]["output"]>
  class?: Maybe<Scalars["billing_account_class"]["output"]>
  closed?: Maybe<Scalars["timestamp"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  currency?: Maybe<Scalars["String"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_date?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  number?: Maybe<Scalars["String"]["output"]>
  settings_id?: Maybe<Scalars["bigint"]["output"]>
  terminated?: Maybe<Scalars["timestamp"]["output"]>
  to_date?: Maybe<Scalars["timestamp"]["output"]>
  type?: Maybe<Scalars["billing_account_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "billing_account" */
export type Billing_Account_Min_Order_By = {
  cancelled?: InputMaybe<Order_By>
  class?: InputMaybe<Order_By>
  closed?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  currency?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  from_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  number?: InputMaybe<Order_By>
  settings_id?: InputMaybe<Order_By>
  terminated?: InputMaybe<Order_By>
  to_date?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "billing_account" */
export type Billing_Account_Mutation_Response = {
  __typename?: "billing_account_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Billing_Account>
}

/** input type for inserting object relation for remote table "billing_account" */
export type Billing_Account_Obj_Rel_Insert_Input = {
  data: Billing_Account_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Billing_Account_On_Conflict>
}

/** on_conflict condition type for table "billing_account" */
export type Billing_Account_On_Conflict = {
  constraint: Billing_Account_Constraint
  update_columns?: Array<Billing_Account_Update_Column>
  where?: InputMaybe<Billing_Account_Bool_Exp>
}

/** Ordering options when selecting data from "billing_account". */
export type Billing_Account_Order_By = {
  billing_account_contacts_aggregate?: InputMaybe<Billing_Account_Contact_Aggregate_Order_By>
  billing_account_number_agreement?: InputMaybe<Agreement_Order_By>
  billing_account_setting?: InputMaybe<Billing_Account_Setting_Order_By>
  cancellations_aggregate?: InputMaybe<Cancellations_Aggregate_Order_By>
  cancelled?: InputMaybe<Order_By>
  class?: InputMaybe<Order_By>
  closed?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  currency?: InputMaybe<Order_By>
  customer?: InputMaybe<Customer_Order_By>
  customer_id?: InputMaybe<Order_By>
  customer_user_rels_aggregate?: InputMaybe<Customer_User_Rel_Aggregate_Order_By>
  deleted?: InputMaybe<Order_By>
  flex_market_subscription_eligibility?: InputMaybe<Axle_Trial_Eligibility_Order_By>
  flex_market_subscriptions_aggregate?: InputMaybe<Flex_Market_Subscription_Aggregate_Order_By>
  from_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  number?: InputMaybe<Order_By>
  product_accounts_aggregate?: InputMaybe<Product_Account_Aggregate_Order_By>
  reminders_aggregate?: InputMaybe<Reminder_Aggregate_Order_By>
  settings_id?: InputMaybe<Order_By>
  terminated?: InputMaybe<Order_By>
  to_date?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: billing_account */
export type Billing_Account_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "billing_account" */
export enum Billing_Account_Select_Column {
  /** column name */
  Cancelled = "cancelled",
  /** column name */
  Class = "class",
  /** column name */
  Closed = "closed",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Currency = "currency",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FromDate = "from_date",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  Number = "number",
  /** column name */
  SettingsId = "settings_id",
  /** column name */
  Terminated = "terminated",
  /** column name */
  ToDate = "to_date",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "billing_account" */
export type Billing_Account_Set_Input = {
  cancelled?: InputMaybe<Scalars["timestamp"]["input"]>
  class?: InputMaybe<Scalars["billing_account_class"]["input"]>
  closed?: InputMaybe<Scalars["timestamp"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  currency?: InputMaybe<Scalars["String"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_date?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  number?: InputMaybe<Scalars["String"]["input"]>
  settings_id?: InputMaybe<Scalars["bigint"]["input"]>
  terminated?: InputMaybe<Scalars["timestamp"]["input"]>
  to_date?: InputMaybe<Scalars["timestamp"]["input"]>
  type?: InputMaybe<Scalars["billing_account_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** columns and relationships of "billing_account_setting" */
export type Billing_Account_Setting = {
  __typename?: "billing_account_setting"
  bill_delivery_method?: Maybe<Scalars["bill_delivery_method"]["output"]>
  /** An array relationship */
  billing_accounts: Array<Billing_Account>
  /** An aggregate relationship */
  billing_accounts_aggregate: Billing_Account_Aggregate
  billing_cycle: Scalars["billing_cycle"]["output"]
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  receive_email?: Maybe<Scalars["Boolean"]["output"]>
  receive_post?: Maybe<Scalars["Boolean"]["output"]>
  receive_sms?: Maybe<Scalars["Boolean"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "billing_account_setting" */
export type Billing_Account_SettingBilling_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Order_By>>
  where?: InputMaybe<Billing_Account_Bool_Exp>
}

/** columns and relationships of "billing_account_setting" */
export type Billing_Account_SettingBilling_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Order_By>>
  where?: InputMaybe<Billing_Account_Bool_Exp>
}

/** aggregated selection of "billing_account_setting" */
export type Billing_Account_Setting_Aggregate = {
  __typename?: "billing_account_setting_aggregate"
  aggregate?: Maybe<Billing_Account_Setting_Aggregate_Fields>
  nodes: Array<Billing_Account_Setting>
}

/** aggregate fields of "billing_account_setting" */
export type Billing_Account_Setting_Aggregate_Fields = {
  __typename?: "billing_account_setting_aggregate_fields"
  avg?: Maybe<Billing_Account_Setting_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Billing_Account_Setting_Max_Fields>
  min?: Maybe<Billing_Account_Setting_Min_Fields>
  stddev?: Maybe<Billing_Account_Setting_Stddev_Fields>
  stddev_pop?: Maybe<Billing_Account_Setting_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Billing_Account_Setting_Stddev_Samp_Fields>
  sum?: Maybe<Billing_Account_Setting_Sum_Fields>
  var_pop?: Maybe<Billing_Account_Setting_Var_Pop_Fields>
  var_samp?: Maybe<Billing_Account_Setting_Var_Samp_Fields>
  variance?: Maybe<Billing_Account_Setting_Variance_Fields>
}

/** aggregate fields of "billing_account_setting" */
export type Billing_Account_Setting_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Billing_Account_Setting_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Billing_Account_Setting_Avg_Fields = {
  __typename?: "billing_account_setting_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "billing_account_setting". All fields are combined with a logical 'AND'. */
export type Billing_Account_Setting_Bool_Exp = {
  _and?: InputMaybe<Array<Billing_Account_Setting_Bool_Exp>>
  _not?: InputMaybe<Billing_Account_Setting_Bool_Exp>
  _or?: InputMaybe<Array<Billing_Account_Setting_Bool_Exp>>
  bill_delivery_method?: InputMaybe<Bill_Delivery_Method_Comparison_Exp>
  billing_accounts?: InputMaybe<Billing_Account_Bool_Exp>
  billing_accounts_aggregate?: InputMaybe<Billing_Account_Aggregate_Bool_Exp>
  billing_cycle?: InputMaybe<Billing_Cycle_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  receive_email?: InputMaybe<Boolean_Comparison_Exp>
  receive_post?: InputMaybe<Boolean_Comparison_Exp>
  receive_sms?: InputMaybe<Boolean_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "billing_account_setting" */
export enum Billing_Account_Setting_Constraint {
  /** unique or primary key constraint on columns "id" */
  BillingAccountSettingsPkey = "billing_account_settings_pkey",
}

/** input type for incrementing numeric columns in table "billing_account_setting" */
export type Billing_Account_Setting_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "billing_account_setting" */
export type Billing_Account_Setting_Insert_Input = {
  bill_delivery_method?: InputMaybe<Scalars["bill_delivery_method"]["input"]>
  billing_accounts?: InputMaybe<Billing_Account_Arr_Rel_Insert_Input>
  billing_cycle?: InputMaybe<Scalars["billing_cycle"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  receive_email?: InputMaybe<Scalars["Boolean"]["input"]>
  receive_post?: InputMaybe<Scalars["Boolean"]["input"]>
  receive_sms?: InputMaybe<Scalars["Boolean"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Billing_Account_Setting_Max_Fields = {
  __typename?: "billing_account_setting_max_fields"
  bill_delivery_method?: Maybe<Scalars["bill_delivery_method"]["output"]>
  billing_cycle?: Maybe<Scalars["billing_cycle"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Billing_Account_Setting_Min_Fields = {
  __typename?: "billing_account_setting_min_fields"
  bill_delivery_method?: Maybe<Scalars["bill_delivery_method"]["output"]>
  billing_cycle?: Maybe<Scalars["billing_cycle"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "billing_account_setting" */
export type Billing_Account_Setting_Mutation_Response = {
  __typename?: "billing_account_setting_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Billing_Account_Setting>
}

/** input type for inserting object relation for remote table "billing_account_setting" */
export type Billing_Account_Setting_Obj_Rel_Insert_Input = {
  data: Billing_Account_Setting_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Billing_Account_Setting_On_Conflict>
}

/** on_conflict condition type for table "billing_account_setting" */
export type Billing_Account_Setting_On_Conflict = {
  constraint: Billing_Account_Setting_Constraint
  update_columns?: Array<Billing_Account_Setting_Update_Column>
  where?: InputMaybe<Billing_Account_Setting_Bool_Exp>
}

/** Ordering options when selecting data from "billing_account_setting". */
export type Billing_Account_Setting_Order_By = {
  bill_delivery_method?: InputMaybe<Order_By>
  billing_accounts_aggregate?: InputMaybe<Billing_Account_Aggregate_Order_By>
  billing_cycle?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  receive_email?: InputMaybe<Order_By>
  receive_post?: InputMaybe<Order_By>
  receive_sms?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: billing_account_setting */
export type Billing_Account_Setting_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "billing_account_setting" */
export enum Billing_Account_Setting_Select_Column {
  /** column name */
  BillDeliveryMethod = "bill_delivery_method",
  /** column name */
  BillingCycle = "billing_cycle",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  ReceiveEmail = "receive_email",
  /** column name */
  ReceivePost = "receive_post",
  /** column name */
  ReceiveSms = "receive_sms",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "billing_account_setting" */
export type Billing_Account_Setting_Set_Input = {
  bill_delivery_method?: InputMaybe<Scalars["bill_delivery_method"]["input"]>
  billing_cycle?: InputMaybe<Scalars["billing_cycle"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  receive_email?: InputMaybe<Scalars["Boolean"]["input"]>
  receive_post?: InputMaybe<Scalars["Boolean"]["input"]>
  receive_sms?: InputMaybe<Scalars["Boolean"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Billing_Account_Setting_Stddev_Fields = {
  __typename?: "billing_account_setting_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Billing_Account_Setting_Stddev_Pop_Fields = {
  __typename?: "billing_account_setting_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Billing_Account_Setting_Stddev_Samp_Fields = {
  __typename?: "billing_account_setting_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "billing_account_setting" */
export type Billing_Account_Setting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Billing_Account_Setting_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Billing_Account_Setting_Stream_Cursor_Value_Input = {
  bill_delivery_method?: InputMaybe<Scalars["bill_delivery_method"]["input"]>
  billing_cycle?: InputMaybe<Scalars["billing_cycle"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  receive_email?: InputMaybe<Scalars["Boolean"]["input"]>
  receive_post?: InputMaybe<Scalars["Boolean"]["input"]>
  receive_sms?: InputMaybe<Scalars["Boolean"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Billing_Account_Setting_Sum_Fields = {
  __typename?: "billing_account_setting_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "billing_account_setting" */
export enum Billing_Account_Setting_Update_Column {
  /** column name */
  BillDeliveryMethod = "bill_delivery_method",
  /** column name */
  BillingCycle = "billing_cycle",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  ReceiveEmail = "receive_email",
  /** column name */
  ReceivePost = "receive_post",
  /** column name */
  ReceiveSms = "receive_sms",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Billing_Account_Setting_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Billing_Account_Setting_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Billing_Account_Setting_Set_Input>
  /** filter the rows which have to be updated */
  where: Billing_Account_Setting_Bool_Exp
}

/** aggregate var_pop on columns */
export type Billing_Account_Setting_Var_Pop_Fields = {
  __typename?: "billing_account_setting_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Billing_Account_Setting_Var_Samp_Fields = {
  __typename?: "billing_account_setting_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Billing_Account_Setting_Variance_Fields = {
  __typename?: "billing_account_setting_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev on columns */
export type Billing_Account_Stddev_Fields = {
  __typename?: "billing_account_stddev_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  settings_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "billing_account" */
export type Billing_Account_Stddev_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  settings_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Billing_Account_Stddev_Pop_Fields = {
  __typename?: "billing_account_stddev_pop_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  settings_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "billing_account" */
export type Billing_Account_Stddev_Pop_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  settings_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Billing_Account_Stddev_Samp_Fields = {
  __typename?: "billing_account_stddev_samp_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  settings_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "billing_account" */
export type Billing_Account_Stddev_Samp_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  settings_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "billing_account" */
export type Billing_Account_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Billing_Account_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Billing_Account_Stream_Cursor_Value_Input = {
  cancelled?: InputMaybe<Scalars["timestamp"]["input"]>
  class?: InputMaybe<Scalars["billing_account_class"]["input"]>
  closed?: InputMaybe<Scalars["timestamp"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  currency?: InputMaybe<Scalars["String"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_date?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  number?: InputMaybe<Scalars["String"]["input"]>
  settings_id?: InputMaybe<Scalars["bigint"]["input"]>
  terminated?: InputMaybe<Scalars["timestamp"]["input"]>
  to_date?: InputMaybe<Scalars["timestamp"]["input"]>
  type?: InputMaybe<Scalars["billing_account_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Billing_Account_Sum_Fields = {
  __typename?: "billing_account_sum_fields"
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  settings_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "billing_account" */
export type Billing_Account_Sum_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  settings_id?: InputMaybe<Order_By>
}

/** columns and relationships of "billing_account_transaction" */
export type Billing_Account_Transaction = {
  __typename?: "billing_account_transaction"
  accepted_at?: Maybe<Scalars["timestamp"]["output"]>
  account_balance?: Maybe<Scalars["numeric"]["output"]>
  authorised_at?: Maybe<Scalars["timestamp"]["output"]>
  billing_account?: Maybe<Billing_Account>
  billing_account_id: Scalars["bigint"]["output"]
  cancelled_at?: Maybe<Scalars["timestamp"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  created_dttm?: Maybe<Scalars["timestamp"]["output"]>
  credit_amount?: Maybe<Scalars["numeric"]["output"]>
  currency: Scalars["String"]["output"]
  debit_amount?: Maybe<Scalars["numeric"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  /** An object relationship */
  direct_debit_payment?: Maybe<Direct_Debit_Payment>
  due_date?: Maybe<Scalars["date"]["output"]>
  id: Scalars["bigint"]["output"]
  order_no?: Maybe<Scalars["Int"]["output"]>
  /** An object relationship */
  payment?: Maybe<Payment>
  payment_id?: Maybe<Scalars["bigint"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  rejected_at?: Maybe<Scalars["timestamp"]["output"]>
  status?: Maybe<Scalars["billing_account_transaction_status"]["output"]>
  type?: Maybe<Scalars["billing_account_transaction_type"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "billing_account_transaction" */
export type Billing_Account_Transaction_Aggregate = {
  __typename?: "billing_account_transaction_aggregate"
  aggregate?: Maybe<Billing_Account_Transaction_Aggregate_Fields>
  nodes: Array<Billing_Account_Transaction>
}

export type Billing_Account_Transaction_Aggregate_Bool_Exp = {
  count?: InputMaybe<Billing_Account_Transaction_Aggregate_Bool_Exp_Count>
}

export type Billing_Account_Transaction_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Billing_Account_Transaction_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Billing_Account_Transaction_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "billing_account_transaction" */
export type Billing_Account_Transaction_Aggregate_Fields = {
  __typename?: "billing_account_transaction_aggregate_fields"
  avg?: Maybe<Billing_Account_Transaction_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Billing_Account_Transaction_Max_Fields>
  min?: Maybe<Billing_Account_Transaction_Min_Fields>
  stddev?: Maybe<Billing_Account_Transaction_Stddev_Fields>
  stddev_pop?: Maybe<Billing_Account_Transaction_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Billing_Account_Transaction_Stddev_Samp_Fields>
  sum?: Maybe<Billing_Account_Transaction_Sum_Fields>
  var_pop?: Maybe<Billing_Account_Transaction_Var_Pop_Fields>
  var_samp?: Maybe<Billing_Account_Transaction_Var_Samp_Fields>
  variance?: Maybe<Billing_Account_Transaction_Variance_Fields>
}

/** aggregate fields of "billing_account_transaction" */
export type Billing_Account_Transaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Billing_Account_Transaction_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "billing_account_transaction" */
export type Billing_Account_Transaction_Aggregate_Order_By = {
  avg?: InputMaybe<Billing_Account_Transaction_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Billing_Account_Transaction_Max_Order_By>
  min?: InputMaybe<Billing_Account_Transaction_Min_Order_By>
  stddev?: InputMaybe<Billing_Account_Transaction_Stddev_Order_By>
  stddev_pop?: InputMaybe<Billing_Account_Transaction_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Billing_Account_Transaction_Stddev_Samp_Order_By>
  sum?: InputMaybe<Billing_Account_Transaction_Sum_Order_By>
  var_pop?: InputMaybe<Billing_Account_Transaction_Var_Pop_Order_By>
  var_samp?: InputMaybe<Billing_Account_Transaction_Var_Samp_Order_By>
  variance?: InputMaybe<Billing_Account_Transaction_Variance_Order_By>
}

/** input type for inserting array relation for remote table "billing_account_transaction" */
export type Billing_Account_Transaction_Arr_Rel_Insert_Input = {
  data: Array<Billing_Account_Transaction_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Billing_Account_Transaction_On_Conflict>
}

/** aggregate avg on columns */
export type Billing_Account_Transaction_Avg_Fields = {
  __typename?: "billing_account_transaction_avg_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  credit_amount?: Maybe<Scalars["Float"]["output"]>
  debit_amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  order_no?: Maybe<Scalars["Float"]["output"]>
  payment_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "billing_account_transaction" */
export type Billing_Account_Transaction_Avg_Order_By = {
  account_balance?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  credit_amount?: InputMaybe<Order_By>
  debit_amount?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  order_no?: InputMaybe<Order_By>
  payment_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "billing_account_transaction". All fields are combined with a logical 'AND'. */
export type Billing_Account_Transaction_Bool_Exp = {
  _and?: InputMaybe<Array<Billing_Account_Transaction_Bool_Exp>>
  _not?: InputMaybe<Billing_Account_Transaction_Bool_Exp>
  _or?: InputMaybe<Array<Billing_Account_Transaction_Bool_Exp>>
  accepted_at?: InputMaybe<Timestamp_Comparison_Exp>
  account_balance?: InputMaybe<Numeric_Comparison_Exp>
  authorised_at?: InputMaybe<Timestamp_Comparison_Exp>
  billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  cancelled_at?: InputMaybe<Timestamp_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  created_dttm?: InputMaybe<Timestamp_Comparison_Exp>
  credit_amount?: InputMaybe<Numeric_Comparison_Exp>
  currency?: InputMaybe<String_Comparison_Exp>
  debit_amount?: InputMaybe<Numeric_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  description?: InputMaybe<String_Comparison_Exp>
  direct_debit_payment?: InputMaybe<Direct_Debit_Payment_Bool_Exp>
  due_date?: InputMaybe<Date_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  order_no?: InputMaybe<Int_Comparison_Exp>
  payment?: InputMaybe<Payment_Bool_Exp>
  payment_id?: InputMaybe<Bigint_Comparison_Exp>
  reference?: InputMaybe<String_Comparison_Exp>
  rejected_at?: InputMaybe<Timestamp_Comparison_Exp>
  status?: InputMaybe<Billing_Account_Transaction_Status_Comparison_Exp>
  type?: InputMaybe<Billing_Account_Transaction_Type_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "billing_account_transaction" */
export enum Billing_Account_Transaction_Constraint {
  /** unique or primary key constraint on columns "id" */
  BillingAccountTransactionPkey = "billing_account_transaction_pkey",
}

/** input type for incrementing numeric columns in table "billing_account_transaction" */
export type Billing_Account_Transaction_Inc_Input = {
  account_balance?: InputMaybe<Scalars["numeric"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  credit_amount?: InputMaybe<Scalars["numeric"]["input"]>
  debit_amount?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  order_no?: InputMaybe<Scalars["Int"]["input"]>
  payment_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "billing_account_transaction" */
export type Billing_Account_Transaction_Insert_Input = {
  accepted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  account_balance?: InputMaybe<Scalars["numeric"]["input"]>
  authorised_at?: InputMaybe<Scalars["timestamp"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  cancelled_at?: InputMaybe<Scalars["timestamp"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  created_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  credit_amount?: InputMaybe<Scalars["numeric"]["input"]>
  currency?: InputMaybe<Scalars["String"]["input"]>
  debit_amount?: InputMaybe<Scalars["numeric"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  direct_debit_payment?: InputMaybe<Direct_Debit_Payment_Obj_Rel_Insert_Input>
  due_date?: InputMaybe<Scalars["date"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  order_no?: InputMaybe<Scalars["Int"]["input"]>
  payment?: InputMaybe<Payment_Obj_Rel_Insert_Input>
  payment_id?: InputMaybe<Scalars["bigint"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  rejected_at?: InputMaybe<Scalars["timestamp"]["input"]>
  status?: InputMaybe<Scalars["billing_account_transaction_status"]["input"]>
  type?: InputMaybe<Scalars["billing_account_transaction_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Billing_Account_Transaction_Max_Fields = {
  __typename?: "billing_account_transaction_max_fields"
  accepted_at?: Maybe<Scalars["timestamp"]["output"]>
  account_balance?: Maybe<Scalars["numeric"]["output"]>
  authorised_at?: Maybe<Scalars["timestamp"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  cancelled_at?: Maybe<Scalars["timestamp"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  created_dttm?: Maybe<Scalars["timestamp"]["output"]>
  credit_amount?: Maybe<Scalars["numeric"]["output"]>
  currency?: Maybe<Scalars["String"]["output"]>
  debit_amount?: Maybe<Scalars["numeric"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  due_date?: Maybe<Scalars["date"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  order_no?: Maybe<Scalars["Int"]["output"]>
  payment_id?: Maybe<Scalars["bigint"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  rejected_at?: Maybe<Scalars["timestamp"]["output"]>
  status?: Maybe<Scalars["billing_account_transaction_status"]["output"]>
  type?: Maybe<Scalars["billing_account_transaction_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "billing_account_transaction" */
export type Billing_Account_Transaction_Max_Order_By = {
  accepted_at?: InputMaybe<Order_By>
  account_balance?: InputMaybe<Order_By>
  authorised_at?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  cancelled_at?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  created_dttm?: InputMaybe<Order_By>
  credit_amount?: InputMaybe<Order_By>
  currency?: InputMaybe<Order_By>
  debit_amount?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  description?: InputMaybe<Order_By>
  due_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  order_no?: InputMaybe<Order_By>
  payment_id?: InputMaybe<Order_By>
  reference?: InputMaybe<Order_By>
  rejected_at?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Billing_Account_Transaction_Min_Fields = {
  __typename?: "billing_account_transaction_min_fields"
  accepted_at?: Maybe<Scalars["timestamp"]["output"]>
  account_balance?: Maybe<Scalars["numeric"]["output"]>
  authorised_at?: Maybe<Scalars["timestamp"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  cancelled_at?: Maybe<Scalars["timestamp"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  created_dttm?: Maybe<Scalars["timestamp"]["output"]>
  credit_amount?: Maybe<Scalars["numeric"]["output"]>
  currency?: Maybe<Scalars["String"]["output"]>
  debit_amount?: Maybe<Scalars["numeric"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  due_date?: Maybe<Scalars["date"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  order_no?: Maybe<Scalars["Int"]["output"]>
  payment_id?: Maybe<Scalars["bigint"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  rejected_at?: Maybe<Scalars["timestamp"]["output"]>
  status?: Maybe<Scalars["billing_account_transaction_status"]["output"]>
  type?: Maybe<Scalars["billing_account_transaction_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "billing_account_transaction" */
export type Billing_Account_Transaction_Min_Order_By = {
  accepted_at?: InputMaybe<Order_By>
  account_balance?: InputMaybe<Order_By>
  authorised_at?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  cancelled_at?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  created_dttm?: InputMaybe<Order_By>
  credit_amount?: InputMaybe<Order_By>
  currency?: InputMaybe<Order_By>
  debit_amount?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  description?: InputMaybe<Order_By>
  due_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  order_no?: InputMaybe<Order_By>
  payment_id?: InputMaybe<Order_By>
  reference?: InputMaybe<Order_By>
  rejected_at?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "billing_account_transaction" */
export type Billing_Account_Transaction_Mutation_Response = {
  __typename?: "billing_account_transaction_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Billing_Account_Transaction>
}

/** input type for inserting object relation for remote table "billing_account_transaction" */
export type Billing_Account_Transaction_Obj_Rel_Insert_Input = {
  data: Billing_Account_Transaction_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Billing_Account_Transaction_On_Conflict>
}

/** on_conflict condition type for table "billing_account_transaction" */
export type Billing_Account_Transaction_On_Conflict = {
  constraint: Billing_Account_Transaction_Constraint
  update_columns?: Array<Billing_Account_Transaction_Update_Column>
  where?: InputMaybe<Billing_Account_Transaction_Bool_Exp>
}

/** Ordering options when selecting data from "billing_account_transaction". */
export type Billing_Account_Transaction_Order_By = {
  accepted_at?: InputMaybe<Order_By>
  account_balance?: InputMaybe<Order_By>
  authorised_at?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  cancelled_at?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  created_dttm?: InputMaybe<Order_By>
  credit_amount?: InputMaybe<Order_By>
  currency?: InputMaybe<Order_By>
  debit_amount?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  description?: InputMaybe<Order_By>
  direct_debit_payment?: InputMaybe<Direct_Debit_Payment_Order_By>
  due_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  order_no?: InputMaybe<Order_By>
  payment?: InputMaybe<Payment_Order_By>
  payment_id?: InputMaybe<Order_By>
  reference?: InputMaybe<Order_By>
  rejected_at?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: billing_account_transaction */
export type Billing_Account_Transaction_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "billing_account_transaction" */
export enum Billing_Account_Transaction_Select_Column {
  /** column name */
  AcceptedAt = "accepted_at",
  /** column name */
  AccountBalance = "account_balance",
  /** column name */
  AuthorisedAt = "authorised_at",
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CancelledAt = "cancelled_at",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CreatedDttm = "created_dttm",
  /** column name */
  CreditAmount = "credit_amount",
  /** column name */
  Currency = "currency",
  /** column name */
  DebitAmount = "debit_amount",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Description = "description",
  /** column name */
  DueDate = "due_date",
  /** column name */
  Id = "id",
  /** column name */
  OrderNo = "order_no",
  /** column name */
  PaymentId = "payment_id",
  /** column name */
  Reference = "reference",
  /** column name */
  RejectedAt = "rejected_at",
  /** column name */
  Status = "status",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "billing_account_transaction" */
export type Billing_Account_Transaction_Set_Input = {
  accepted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  account_balance?: InputMaybe<Scalars["numeric"]["input"]>
  authorised_at?: InputMaybe<Scalars["timestamp"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  cancelled_at?: InputMaybe<Scalars["timestamp"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  created_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  credit_amount?: InputMaybe<Scalars["numeric"]["input"]>
  currency?: InputMaybe<Scalars["String"]["input"]>
  debit_amount?: InputMaybe<Scalars["numeric"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  due_date?: InputMaybe<Scalars["date"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  order_no?: InputMaybe<Scalars["Int"]["input"]>
  payment_id?: InputMaybe<Scalars["bigint"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  rejected_at?: InputMaybe<Scalars["timestamp"]["input"]>
  status?: InputMaybe<Scalars["billing_account_transaction_status"]["input"]>
  type?: InputMaybe<Scalars["billing_account_transaction_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** Boolean expression to compare columns of type "billing_account_transaction_status". All fields are combined with logical 'AND'. */
export type Billing_Account_Transaction_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["billing_account_transaction_status"]["input"]>
  _gt?: InputMaybe<Scalars["billing_account_transaction_status"]["input"]>
  _gte?: InputMaybe<Scalars["billing_account_transaction_status"]["input"]>
  _in?: InputMaybe<
    Array<Scalars["billing_account_transaction_status"]["input"]>
  >
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["billing_account_transaction_status"]["input"]>
  _lte?: InputMaybe<Scalars["billing_account_transaction_status"]["input"]>
  _neq?: InputMaybe<Scalars["billing_account_transaction_status"]["input"]>
  _nin?: InputMaybe<
    Array<Scalars["billing_account_transaction_status"]["input"]>
  >
}

/** aggregate stddev on columns */
export type Billing_Account_Transaction_Stddev_Fields = {
  __typename?: "billing_account_transaction_stddev_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  credit_amount?: Maybe<Scalars["Float"]["output"]>
  debit_amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  order_no?: Maybe<Scalars["Float"]["output"]>
  payment_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "billing_account_transaction" */
export type Billing_Account_Transaction_Stddev_Order_By = {
  account_balance?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  credit_amount?: InputMaybe<Order_By>
  debit_amount?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  order_no?: InputMaybe<Order_By>
  payment_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Billing_Account_Transaction_Stddev_Pop_Fields = {
  __typename?: "billing_account_transaction_stddev_pop_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  credit_amount?: Maybe<Scalars["Float"]["output"]>
  debit_amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  order_no?: Maybe<Scalars["Float"]["output"]>
  payment_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "billing_account_transaction" */
export type Billing_Account_Transaction_Stddev_Pop_Order_By = {
  account_balance?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  credit_amount?: InputMaybe<Order_By>
  debit_amount?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  order_no?: InputMaybe<Order_By>
  payment_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Billing_Account_Transaction_Stddev_Samp_Fields = {
  __typename?: "billing_account_transaction_stddev_samp_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  credit_amount?: Maybe<Scalars["Float"]["output"]>
  debit_amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  order_no?: Maybe<Scalars["Float"]["output"]>
  payment_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "billing_account_transaction" */
export type Billing_Account_Transaction_Stddev_Samp_Order_By = {
  account_balance?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  credit_amount?: InputMaybe<Order_By>
  debit_amount?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  order_no?: InputMaybe<Order_By>
  payment_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "billing_account_transaction" */
export type Billing_Account_Transaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Billing_Account_Transaction_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Billing_Account_Transaction_Stream_Cursor_Value_Input = {
  accepted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  account_balance?: InputMaybe<Scalars["numeric"]["input"]>
  authorised_at?: InputMaybe<Scalars["timestamp"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  cancelled_at?: InputMaybe<Scalars["timestamp"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  created_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  credit_amount?: InputMaybe<Scalars["numeric"]["input"]>
  currency?: InputMaybe<Scalars["String"]["input"]>
  debit_amount?: InputMaybe<Scalars["numeric"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  due_date?: InputMaybe<Scalars["date"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  order_no?: InputMaybe<Scalars["Int"]["input"]>
  payment_id?: InputMaybe<Scalars["bigint"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  rejected_at?: InputMaybe<Scalars["timestamp"]["input"]>
  status?: InputMaybe<Scalars["billing_account_transaction_status"]["input"]>
  type?: InputMaybe<Scalars["billing_account_transaction_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Billing_Account_Transaction_Sum_Fields = {
  __typename?: "billing_account_transaction_sum_fields"
  account_balance?: Maybe<Scalars["numeric"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  credit_amount?: Maybe<Scalars["numeric"]["output"]>
  debit_amount?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  order_no?: Maybe<Scalars["Int"]["output"]>
  payment_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "billing_account_transaction" */
export type Billing_Account_Transaction_Sum_Order_By = {
  account_balance?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  credit_amount?: InputMaybe<Order_By>
  debit_amount?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  order_no?: InputMaybe<Order_By>
  payment_id?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "billing_account_transaction_type". All fields are combined with logical 'AND'. */
export type Billing_Account_Transaction_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["billing_account_transaction_type"]["input"]>
  _gt?: InputMaybe<Scalars["billing_account_transaction_type"]["input"]>
  _gte?: InputMaybe<Scalars["billing_account_transaction_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["billing_account_transaction_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["billing_account_transaction_type"]["input"]>
  _lte?: InputMaybe<Scalars["billing_account_transaction_type"]["input"]>
  _neq?: InputMaybe<Scalars["billing_account_transaction_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["billing_account_transaction_type"]["input"]>>
}

/** update columns of table "billing_account_transaction" */
export enum Billing_Account_Transaction_Update_Column {
  /** column name */
  AcceptedAt = "accepted_at",
  /** column name */
  AccountBalance = "account_balance",
  /** column name */
  AuthorisedAt = "authorised_at",
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CancelledAt = "cancelled_at",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CreatedDttm = "created_dttm",
  /** column name */
  CreditAmount = "credit_amount",
  /** column name */
  Currency = "currency",
  /** column name */
  DebitAmount = "debit_amount",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Description = "description",
  /** column name */
  DueDate = "due_date",
  /** column name */
  Id = "id",
  /** column name */
  OrderNo = "order_no",
  /** column name */
  PaymentId = "payment_id",
  /** column name */
  Reference = "reference",
  /** column name */
  RejectedAt = "rejected_at",
  /** column name */
  Status = "status",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Billing_Account_Transaction_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Billing_Account_Transaction_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Billing_Account_Transaction_Set_Input>
  /** filter the rows which have to be updated */
  where: Billing_Account_Transaction_Bool_Exp
}

/** aggregate var_pop on columns */
export type Billing_Account_Transaction_Var_Pop_Fields = {
  __typename?: "billing_account_transaction_var_pop_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  credit_amount?: Maybe<Scalars["Float"]["output"]>
  debit_amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  order_no?: Maybe<Scalars["Float"]["output"]>
  payment_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "billing_account_transaction" */
export type Billing_Account_Transaction_Var_Pop_Order_By = {
  account_balance?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  credit_amount?: InputMaybe<Order_By>
  debit_amount?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  order_no?: InputMaybe<Order_By>
  payment_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Billing_Account_Transaction_Var_Samp_Fields = {
  __typename?: "billing_account_transaction_var_samp_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  credit_amount?: Maybe<Scalars["Float"]["output"]>
  debit_amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  order_no?: Maybe<Scalars["Float"]["output"]>
  payment_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "billing_account_transaction" */
export type Billing_Account_Transaction_Var_Samp_Order_By = {
  account_balance?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  credit_amount?: InputMaybe<Order_By>
  debit_amount?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  order_no?: InputMaybe<Order_By>
  payment_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Billing_Account_Transaction_Variance_Fields = {
  __typename?: "billing_account_transaction_variance_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  credit_amount?: Maybe<Scalars["Float"]["output"]>
  debit_amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  order_no?: Maybe<Scalars["Float"]["output"]>
  payment_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "billing_account_transaction" */
export type Billing_Account_Transaction_Variance_Order_By = {
  account_balance?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  credit_amount?: InputMaybe<Order_By>
  debit_amount?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  order_no?: InputMaybe<Order_By>
  payment_id?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "billing_account_type". All fields are combined with logical 'AND'. */
export type Billing_Account_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["billing_account_type"]["input"]>
  _gt?: InputMaybe<Scalars["billing_account_type"]["input"]>
  _gte?: InputMaybe<Scalars["billing_account_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["billing_account_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["billing_account_type"]["input"]>
  _lte?: InputMaybe<Scalars["billing_account_type"]["input"]>
  _neq?: InputMaybe<Scalars["billing_account_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["billing_account_type"]["input"]>>
}

/** update columns of table "billing_account" */
export enum Billing_Account_Update_Column {
  /** column name */
  Cancelled = "cancelled",
  /** column name */
  Class = "class",
  /** column name */
  Closed = "closed",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Currency = "currency",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FromDate = "from_date",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  Number = "number",
  /** column name */
  SettingsId = "settings_id",
  /** column name */
  Terminated = "terminated",
  /** column name */
  ToDate = "to_date",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Billing_Account_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Billing_Account_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Billing_Account_Set_Input>
  /** filter the rows which have to be updated */
  where: Billing_Account_Bool_Exp
}

/** aggregate var_pop on columns */
export type Billing_Account_Var_Pop_Fields = {
  __typename?: "billing_account_var_pop_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  settings_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "billing_account" */
export type Billing_Account_Var_Pop_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  settings_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Billing_Account_Var_Samp_Fields = {
  __typename?: "billing_account_var_samp_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  settings_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "billing_account" */
export type Billing_Account_Var_Samp_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  settings_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Billing_Account_Variance_Fields = {
  __typename?: "billing_account_variance_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  settings_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "billing_account" */
export type Billing_Account_Variance_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  settings_id?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "billing_cycle". All fields are combined with logical 'AND'. */
export type Billing_Cycle_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["billing_cycle"]["input"]>
  _gt?: InputMaybe<Scalars["billing_cycle"]["input"]>
  _gte?: InputMaybe<Scalars["billing_cycle"]["input"]>
  _in?: InputMaybe<Array<Scalars["billing_cycle"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["billing_cycle"]["input"]>
  _lte?: InputMaybe<Scalars["billing_cycle"]["input"]>
  _neq?: InputMaybe<Scalars["billing_cycle"]["input"]>
  _nin?: InputMaybe<Array<Scalars["billing_cycle"]["input"]>>
}

/** columns and relationships of "billing_period" */
export type Billing_Period = {
  __typename?: "billing_period"
  billing_account_id: Scalars["bigint"]["output"]
  /** An array relationship */
  bills: Array<Bill>
  /** An aggregate relationship */
  bills_aggregate: Bill_Aggregate
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_dt?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  status: Scalars["billing_period_status"]["output"]
  to_dt?: Maybe<Scalars["timestamp"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "billing_period" */
export type Billing_PeriodBillsArgs = {
  distinct_on?: InputMaybe<Array<Bill_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Bill_Order_By>>
  where?: InputMaybe<Bill_Bool_Exp>
}

/** columns and relationships of "billing_period" */
export type Billing_PeriodBills_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bill_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Bill_Order_By>>
  where?: InputMaybe<Bill_Bool_Exp>
}

/** aggregated selection of "billing_period" */
export type Billing_Period_Aggregate = {
  __typename?: "billing_period_aggregate"
  aggregate?: Maybe<Billing_Period_Aggregate_Fields>
  nodes: Array<Billing_Period>
}

/** aggregate fields of "billing_period" */
export type Billing_Period_Aggregate_Fields = {
  __typename?: "billing_period_aggregate_fields"
  avg?: Maybe<Billing_Period_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Billing_Period_Max_Fields>
  min?: Maybe<Billing_Period_Min_Fields>
  stddev?: Maybe<Billing_Period_Stddev_Fields>
  stddev_pop?: Maybe<Billing_Period_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Billing_Period_Stddev_Samp_Fields>
  sum?: Maybe<Billing_Period_Sum_Fields>
  var_pop?: Maybe<Billing_Period_Var_Pop_Fields>
  var_samp?: Maybe<Billing_Period_Var_Samp_Fields>
  variance?: Maybe<Billing_Period_Variance_Fields>
}

/** aggregate fields of "billing_period" */
export type Billing_Period_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Billing_Period_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Billing_Period_Avg_Fields = {
  __typename?: "billing_period_avg_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "billing_period". All fields are combined with a logical 'AND'. */
export type Billing_Period_Bool_Exp = {
  _and?: InputMaybe<Array<Billing_Period_Bool_Exp>>
  _not?: InputMaybe<Billing_Period_Bool_Exp>
  _or?: InputMaybe<Array<Billing_Period_Bool_Exp>>
  billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  bills?: InputMaybe<Bill_Bool_Exp>
  bills_aggregate?: InputMaybe<Bill_Aggregate_Bool_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  from_dt?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  status?: InputMaybe<Billing_Period_Status_Comparison_Exp>
  to_dt?: InputMaybe<Timestamp_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "billing_period" */
export enum Billing_Period_Constraint {
  /** unique or primary key constraint on columns "id" */
  BillingPeriodPk = "billing_period_pk",
}

/** input type for incrementing numeric columns in table "billing_period" */
export type Billing_Period_Inc_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "billing_period" */
export type Billing_Period_Insert_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  bills?: InputMaybe<Bill_Arr_Rel_Insert_Input>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["billing_period_status"]["input"]>
  to_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Billing_Period_Max_Fields = {
  __typename?: "billing_period_max_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_dt?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["billing_period_status"]["output"]>
  to_dt?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Billing_Period_Min_Fields = {
  __typename?: "billing_period_min_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_dt?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["billing_period_status"]["output"]>
  to_dt?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "billing_period" */
export type Billing_Period_Mutation_Response = {
  __typename?: "billing_period_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Billing_Period>
}

/** input type for inserting object relation for remote table "billing_period" */
export type Billing_Period_Obj_Rel_Insert_Input = {
  data: Billing_Period_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Billing_Period_On_Conflict>
}

/** on_conflict condition type for table "billing_period" */
export type Billing_Period_On_Conflict = {
  constraint: Billing_Period_Constraint
  update_columns?: Array<Billing_Period_Update_Column>
  where?: InputMaybe<Billing_Period_Bool_Exp>
}

/** Ordering options when selecting data from "billing_period". */
export type Billing_Period_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  bills_aggregate?: InputMaybe<Bill_Aggregate_Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  from_dt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  to_dt?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: billing_period */
export type Billing_Period_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "billing_period" */
export enum Billing_Period_Select_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FromDt = "from_dt",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  ToDt = "to_dt",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "billing_period" */
export type Billing_Period_Set_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["billing_period_status"]["input"]>
  to_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** Boolean expression to compare columns of type "billing_period_status". All fields are combined with logical 'AND'. */
export type Billing_Period_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["billing_period_status"]["input"]>
  _gt?: InputMaybe<Scalars["billing_period_status"]["input"]>
  _gte?: InputMaybe<Scalars["billing_period_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["billing_period_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["billing_period_status"]["input"]>
  _lte?: InputMaybe<Scalars["billing_period_status"]["input"]>
  _neq?: InputMaybe<Scalars["billing_period_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["billing_period_status"]["input"]>>
}

/** aggregate stddev on columns */
export type Billing_Period_Stddev_Fields = {
  __typename?: "billing_period_stddev_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Billing_Period_Stddev_Pop_Fields = {
  __typename?: "billing_period_stddev_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Billing_Period_Stddev_Samp_Fields = {
  __typename?: "billing_period_stddev_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "billing_period" */
export type Billing_Period_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Billing_Period_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Billing_Period_Stream_Cursor_Value_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["billing_period_status"]["input"]>
  to_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Billing_Period_Sum_Fields = {
  __typename?: "billing_period_sum_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "billing_period" */
export enum Billing_Period_Update_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FromDt = "from_dt",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  ToDt = "to_dt",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Billing_Period_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Billing_Period_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Billing_Period_Set_Input>
  /** filter the rows which have to be updated */
  where: Billing_Period_Bool_Exp
}

/** aggregate var_pop on columns */
export type Billing_Period_Var_Pop_Fields = {
  __typename?: "billing_period_var_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Billing_Period_Var_Samp_Fields = {
  __typename?: "billing_period_var_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Billing_Period_Variance_Fields = {
  __typename?: "billing_period_variance_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "bytea". All fields are combined with logical 'AND'. */
export type Bytea_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["bytea"]["input"]>
  _gt?: InputMaybe<Scalars["bytea"]["input"]>
  _gte?: InputMaybe<Scalars["bytea"]["input"]>
  _in?: InputMaybe<Array<Scalars["bytea"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["bytea"]["input"]>
  _lte?: InputMaybe<Scalars["bytea"]["input"]>
  _neq?: InputMaybe<Scalars["bytea"]["input"]>
  _nin?: InputMaybe<Array<Scalars["bytea"]["input"]>>
}

/** Boolean expression to compare columns of type "calculation_item_product_type". All fields are combined with logical 'AND'. */
export type Calculation_Item_Product_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["calculation_item_product_type"]["input"]>
  _gt?: InputMaybe<Scalars["calculation_item_product_type"]["input"]>
  _gte?: InputMaybe<Scalars["calculation_item_product_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["calculation_item_product_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["calculation_item_product_type"]["input"]>
  _lte?: InputMaybe<Scalars["calculation_item_product_type"]["input"]>
  _neq?: InputMaybe<Scalars["calculation_item_product_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["calculation_item_product_type"]["input"]>>
}

/** Boolean expression to compare columns of type "calculation_item_rate_type". All fields are combined with logical 'AND'. */
export type Calculation_Item_Rate_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["calculation_item_rate_type"]["input"]>
  _gt?: InputMaybe<Scalars["calculation_item_rate_type"]["input"]>
  _gte?: InputMaybe<Scalars["calculation_item_rate_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["calculation_item_rate_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["calculation_item_rate_type"]["input"]>
  _lte?: InputMaybe<Scalars["calculation_item_rate_type"]["input"]>
  _neq?: InputMaybe<Scalars["calculation_item_rate_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["calculation_item_rate_type"]["input"]>>
}

/** columns and relationships of "calculation_items" */
export type Calculation_Items = {
  __typename?: "calculation_items"
  direct_debit: Scalars["Boolean"]["output"]
  gsp_code: Scalars["String"]["output"]
  id: Scalars["bigint"]["output"]
  item_cost?: Maybe<Scalars["numeric"]["output"]>
  meterpoint_eac_1?: Maybe<Scalars["numeric"]["output"]>
  meterpoint_eac_2?: Maybe<Scalars["numeric"]["output"]>
  payment_review_calculation_fk: Scalars["bigint"]["output"]
  product_code?: Maybe<Scalars["String"]["output"]>
  product_rate_1?: Maybe<Scalars["numeric"]["output"]>
  product_rate_2?: Maybe<Scalars["numeric"]["output"]>
  product_standing_rate?: Maybe<Scalars["numeric"]["output"]>
  product_type: Scalars["calculation_item_product_type"]["output"]
  rate_type: Scalars["calculation_item_rate_type"]["output"]
}

/** aggregated selection of "calculation_items" */
export type Calculation_Items_Aggregate = {
  __typename?: "calculation_items_aggregate"
  aggregate?: Maybe<Calculation_Items_Aggregate_Fields>
  nodes: Array<Calculation_Items>
}

export type Calculation_Items_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Calculation_Items_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Calculation_Items_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<Calculation_Items_Aggregate_Bool_Exp_Count>
}

export type Calculation_Items_Aggregate_Bool_Exp_Bool_And = {
  arguments: Calculation_Items_Select_Column_Calculation_Items_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Calculation_Items_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Calculation_Items_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Calculation_Items_Select_Column_Calculation_Items_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Calculation_Items_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Calculation_Items_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Calculation_Items_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Calculation_Items_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "calculation_items" */
export type Calculation_Items_Aggregate_Fields = {
  __typename?: "calculation_items_aggregate_fields"
  avg?: Maybe<Calculation_Items_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Calculation_Items_Max_Fields>
  min?: Maybe<Calculation_Items_Min_Fields>
  stddev?: Maybe<Calculation_Items_Stddev_Fields>
  stddev_pop?: Maybe<Calculation_Items_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Calculation_Items_Stddev_Samp_Fields>
  sum?: Maybe<Calculation_Items_Sum_Fields>
  var_pop?: Maybe<Calculation_Items_Var_Pop_Fields>
  var_samp?: Maybe<Calculation_Items_Var_Samp_Fields>
  variance?: Maybe<Calculation_Items_Variance_Fields>
}

/** aggregate fields of "calculation_items" */
export type Calculation_Items_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Calculation_Items_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "calculation_items" */
export type Calculation_Items_Aggregate_Order_By = {
  avg?: InputMaybe<Calculation_Items_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Calculation_Items_Max_Order_By>
  min?: InputMaybe<Calculation_Items_Min_Order_By>
  stddev?: InputMaybe<Calculation_Items_Stddev_Order_By>
  stddev_pop?: InputMaybe<Calculation_Items_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Calculation_Items_Stddev_Samp_Order_By>
  sum?: InputMaybe<Calculation_Items_Sum_Order_By>
  var_pop?: InputMaybe<Calculation_Items_Var_Pop_Order_By>
  var_samp?: InputMaybe<Calculation_Items_Var_Samp_Order_By>
  variance?: InputMaybe<Calculation_Items_Variance_Order_By>
}

/** input type for inserting array relation for remote table "calculation_items" */
export type Calculation_Items_Arr_Rel_Insert_Input = {
  data: Array<Calculation_Items_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Calculation_Items_On_Conflict>
}

/** aggregate avg on columns */
export type Calculation_Items_Avg_Fields = {
  __typename?: "calculation_items_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  item_cost?: Maybe<Scalars["Float"]["output"]>
  meterpoint_eac_1?: Maybe<Scalars["Float"]["output"]>
  meterpoint_eac_2?: Maybe<Scalars["Float"]["output"]>
  payment_review_calculation_fk?: Maybe<Scalars["Float"]["output"]>
  product_rate_1?: Maybe<Scalars["Float"]["output"]>
  product_rate_2?: Maybe<Scalars["Float"]["output"]>
  product_standing_rate?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "calculation_items" */
export type Calculation_Items_Avg_Order_By = {
  id?: InputMaybe<Order_By>
  item_cost?: InputMaybe<Order_By>
  meterpoint_eac_1?: InputMaybe<Order_By>
  meterpoint_eac_2?: InputMaybe<Order_By>
  payment_review_calculation_fk?: InputMaybe<Order_By>
  product_rate_1?: InputMaybe<Order_By>
  product_rate_2?: InputMaybe<Order_By>
  product_standing_rate?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "calculation_items". All fields are combined with a logical 'AND'. */
export type Calculation_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Calculation_Items_Bool_Exp>>
  _not?: InputMaybe<Calculation_Items_Bool_Exp>
  _or?: InputMaybe<Array<Calculation_Items_Bool_Exp>>
  direct_debit?: InputMaybe<Boolean_Comparison_Exp>
  gsp_code?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  item_cost?: InputMaybe<Numeric_Comparison_Exp>
  meterpoint_eac_1?: InputMaybe<Numeric_Comparison_Exp>
  meterpoint_eac_2?: InputMaybe<Numeric_Comparison_Exp>
  payment_review_calculation_fk?: InputMaybe<Bigint_Comparison_Exp>
  product_code?: InputMaybe<String_Comparison_Exp>
  product_rate_1?: InputMaybe<Numeric_Comparison_Exp>
  product_rate_2?: InputMaybe<Numeric_Comparison_Exp>
  product_standing_rate?: InputMaybe<Numeric_Comparison_Exp>
  product_type?: InputMaybe<Calculation_Item_Product_Type_Comparison_Exp>
  rate_type?: InputMaybe<Calculation_Item_Rate_Type_Comparison_Exp>
}

/** unique or primary key constraints on table "calculation_items" */
export enum Calculation_Items_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkCalculatonItems = "pk_calculaton_items",
}

/** input type for incrementing numeric columns in table "calculation_items" */
export type Calculation_Items_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  item_cost?: InputMaybe<Scalars["numeric"]["input"]>
  meterpoint_eac_1?: InputMaybe<Scalars["numeric"]["input"]>
  meterpoint_eac_2?: InputMaybe<Scalars["numeric"]["input"]>
  payment_review_calculation_fk?: InputMaybe<Scalars["bigint"]["input"]>
  product_rate_1?: InputMaybe<Scalars["numeric"]["input"]>
  product_rate_2?: InputMaybe<Scalars["numeric"]["input"]>
  product_standing_rate?: InputMaybe<Scalars["numeric"]["input"]>
}

/** input type for inserting data into table "calculation_items" */
export type Calculation_Items_Insert_Input = {
  direct_debit?: InputMaybe<Scalars["Boolean"]["input"]>
  gsp_code?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  item_cost?: InputMaybe<Scalars["numeric"]["input"]>
  meterpoint_eac_1?: InputMaybe<Scalars["numeric"]["input"]>
  meterpoint_eac_2?: InputMaybe<Scalars["numeric"]["input"]>
  payment_review_calculation_fk?: InputMaybe<Scalars["bigint"]["input"]>
  product_code?: InputMaybe<Scalars["String"]["input"]>
  product_rate_1?: InputMaybe<Scalars["numeric"]["input"]>
  product_rate_2?: InputMaybe<Scalars["numeric"]["input"]>
  product_standing_rate?: InputMaybe<Scalars["numeric"]["input"]>
  product_type?: InputMaybe<Scalars["calculation_item_product_type"]["input"]>
  rate_type?: InputMaybe<Scalars["calculation_item_rate_type"]["input"]>
}

/** aggregate max on columns */
export type Calculation_Items_Max_Fields = {
  __typename?: "calculation_items_max_fields"
  gsp_code?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  item_cost?: Maybe<Scalars["numeric"]["output"]>
  meterpoint_eac_1?: Maybe<Scalars["numeric"]["output"]>
  meterpoint_eac_2?: Maybe<Scalars["numeric"]["output"]>
  payment_review_calculation_fk?: Maybe<Scalars["bigint"]["output"]>
  product_code?: Maybe<Scalars["String"]["output"]>
  product_rate_1?: Maybe<Scalars["numeric"]["output"]>
  product_rate_2?: Maybe<Scalars["numeric"]["output"]>
  product_standing_rate?: Maybe<Scalars["numeric"]["output"]>
  product_type?: Maybe<Scalars["calculation_item_product_type"]["output"]>
  rate_type?: Maybe<Scalars["calculation_item_rate_type"]["output"]>
}

/** order by max() on columns of table "calculation_items" */
export type Calculation_Items_Max_Order_By = {
  gsp_code?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  item_cost?: InputMaybe<Order_By>
  meterpoint_eac_1?: InputMaybe<Order_By>
  meterpoint_eac_2?: InputMaybe<Order_By>
  payment_review_calculation_fk?: InputMaybe<Order_By>
  product_code?: InputMaybe<Order_By>
  product_rate_1?: InputMaybe<Order_By>
  product_rate_2?: InputMaybe<Order_By>
  product_standing_rate?: InputMaybe<Order_By>
  product_type?: InputMaybe<Order_By>
  rate_type?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Calculation_Items_Min_Fields = {
  __typename?: "calculation_items_min_fields"
  gsp_code?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  item_cost?: Maybe<Scalars["numeric"]["output"]>
  meterpoint_eac_1?: Maybe<Scalars["numeric"]["output"]>
  meterpoint_eac_2?: Maybe<Scalars["numeric"]["output"]>
  payment_review_calculation_fk?: Maybe<Scalars["bigint"]["output"]>
  product_code?: Maybe<Scalars["String"]["output"]>
  product_rate_1?: Maybe<Scalars["numeric"]["output"]>
  product_rate_2?: Maybe<Scalars["numeric"]["output"]>
  product_standing_rate?: Maybe<Scalars["numeric"]["output"]>
  product_type?: Maybe<Scalars["calculation_item_product_type"]["output"]>
  rate_type?: Maybe<Scalars["calculation_item_rate_type"]["output"]>
}

/** order by min() on columns of table "calculation_items" */
export type Calculation_Items_Min_Order_By = {
  gsp_code?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  item_cost?: InputMaybe<Order_By>
  meterpoint_eac_1?: InputMaybe<Order_By>
  meterpoint_eac_2?: InputMaybe<Order_By>
  payment_review_calculation_fk?: InputMaybe<Order_By>
  product_code?: InputMaybe<Order_By>
  product_rate_1?: InputMaybe<Order_By>
  product_rate_2?: InputMaybe<Order_By>
  product_standing_rate?: InputMaybe<Order_By>
  product_type?: InputMaybe<Order_By>
  rate_type?: InputMaybe<Order_By>
}

/** response of any mutation on the table "calculation_items" */
export type Calculation_Items_Mutation_Response = {
  __typename?: "calculation_items_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Calculation_Items>
}

/** on_conflict condition type for table "calculation_items" */
export type Calculation_Items_On_Conflict = {
  constraint: Calculation_Items_Constraint
  update_columns?: Array<Calculation_Items_Update_Column>
  where?: InputMaybe<Calculation_Items_Bool_Exp>
}

/** Ordering options when selecting data from "calculation_items". */
export type Calculation_Items_Order_By = {
  direct_debit?: InputMaybe<Order_By>
  gsp_code?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  item_cost?: InputMaybe<Order_By>
  meterpoint_eac_1?: InputMaybe<Order_By>
  meterpoint_eac_2?: InputMaybe<Order_By>
  payment_review_calculation_fk?: InputMaybe<Order_By>
  product_code?: InputMaybe<Order_By>
  product_rate_1?: InputMaybe<Order_By>
  product_rate_2?: InputMaybe<Order_By>
  product_standing_rate?: InputMaybe<Order_By>
  product_type?: InputMaybe<Order_By>
  rate_type?: InputMaybe<Order_By>
}

/** primary key columns input for table: calculation_items */
export type Calculation_Items_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "calculation_items" */
export enum Calculation_Items_Select_Column {
  /** column name */
  DirectDebit = "direct_debit",
  /** column name */
  GspCode = "gsp_code",
  /** column name */
  Id = "id",
  /** column name */
  ItemCost = "item_cost",
  /** column name */
  MeterpointEac_1 = "meterpoint_eac_1",
  /** column name */
  MeterpointEac_2 = "meterpoint_eac_2",
  /** column name */
  PaymentReviewCalculationFk = "payment_review_calculation_fk",
  /** column name */
  ProductCode = "product_code",
  /** column name */
  ProductRate_1 = "product_rate_1",
  /** column name */
  ProductRate_2 = "product_rate_2",
  /** column name */
  ProductStandingRate = "product_standing_rate",
  /** column name */
  ProductType = "product_type",
  /** column name */
  RateType = "rate_type",
}

/** select "calculation_items_aggregate_bool_exp_bool_and_arguments_columns" columns of table "calculation_items" */
export enum Calculation_Items_Select_Column_Calculation_Items_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DirectDebit = "direct_debit",
}

/** select "calculation_items_aggregate_bool_exp_bool_or_arguments_columns" columns of table "calculation_items" */
export enum Calculation_Items_Select_Column_Calculation_Items_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DirectDebit = "direct_debit",
}

/** input type for updating data in table "calculation_items" */
export type Calculation_Items_Set_Input = {
  direct_debit?: InputMaybe<Scalars["Boolean"]["input"]>
  gsp_code?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  item_cost?: InputMaybe<Scalars["numeric"]["input"]>
  meterpoint_eac_1?: InputMaybe<Scalars["numeric"]["input"]>
  meterpoint_eac_2?: InputMaybe<Scalars["numeric"]["input"]>
  payment_review_calculation_fk?: InputMaybe<Scalars["bigint"]["input"]>
  product_code?: InputMaybe<Scalars["String"]["input"]>
  product_rate_1?: InputMaybe<Scalars["numeric"]["input"]>
  product_rate_2?: InputMaybe<Scalars["numeric"]["input"]>
  product_standing_rate?: InputMaybe<Scalars["numeric"]["input"]>
  product_type?: InputMaybe<Scalars["calculation_item_product_type"]["input"]>
  rate_type?: InputMaybe<Scalars["calculation_item_rate_type"]["input"]>
}

/** aggregate stddev on columns */
export type Calculation_Items_Stddev_Fields = {
  __typename?: "calculation_items_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  item_cost?: Maybe<Scalars["Float"]["output"]>
  meterpoint_eac_1?: Maybe<Scalars["Float"]["output"]>
  meterpoint_eac_2?: Maybe<Scalars["Float"]["output"]>
  payment_review_calculation_fk?: Maybe<Scalars["Float"]["output"]>
  product_rate_1?: Maybe<Scalars["Float"]["output"]>
  product_rate_2?: Maybe<Scalars["Float"]["output"]>
  product_standing_rate?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "calculation_items" */
export type Calculation_Items_Stddev_Order_By = {
  id?: InputMaybe<Order_By>
  item_cost?: InputMaybe<Order_By>
  meterpoint_eac_1?: InputMaybe<Order_By>
  meterpoint_eac_2?: InputMaybe<Order_By>
  payment_review_calculation_fk?: InputMaybe<Order_By>
  product_rate_1?: InputMaybe<Order_By>
  product_rate_2?: InputMaybe<Order_By>
  product_standing_rate?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Calculation_Items_Stddev_Pop_Fields = {
  __typename?: "calculation_items_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  item_cost?: Maybe<Scalars["Float"]["output"]>
  meterpoint_eac_1?: Maybe<Scalars["Float"]["output"]>
  meterpoint_eac_2?: Maybe<Scalars["Float"]["output"]>
  payment_review_calculation_fk?: Maybe<Scalars["Float"]["output"]>
  product_rate_1?: Maybe<Scalars["Float"]["output"]>
  product_rate_2?: Maybe<Scalars["Float"]["output"]>
  product_standing_rate?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "calculation_items" */
export type Calculation_Items_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>
  item_cost?: InputMaybe<Order_By>
  meterpoint_eac_1?: InputMaybe<Order_By>
  meterpoint_eac_2?: InputMaybe<Order_By>
  payment_review_calculation_fk?: InputMaybe<Order_By>
  product_rate_1?: InputMaybe<Order_By>
  product_rate_2?: InputMaybe<Order_By>
  product_standing_rate?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Calculation_Items_Stddev_Samp_Fields = {
  __typename?: "calculation_items_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  item_cost?: Maybe<Scalars["Float"]["output"]>
  meterpoint_eac_1?: Maybe<Scalars["Float"]["output"]>
  meterpoint_eac_2?: Maybe<Scalars["Float"]["output"]>
  payment_review_calculation_fk?: Maybe<Scalars["Float"]["output"]>
  product_rate_1?: Maybe<Scalars["Float"]["output"]>
  product_rate_2?: Maybe<Scalars["Float"]["output"]>
  product_standing_rate?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "calculation_items" */
export type Calculation_Items_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>
  item_cost?: InputMaybe<Order_By>
  meterpoint_eac_1?: InputMaybe<Order_By>
  meterpoint_eac_2?: InputMaybe<Order_By>
  payment_review_calculation_fk?: InputMaybe<Order_By>
  product_rate_1?: InputMaybe<Order_By>
  product_rate_2?: InputMaybe<Order_By>
  product_standing_rate?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "calculation_items" */
export type Calculation_Items_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Calculation_Items_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Calculation_Items_Stream_Cursor_Value_Input = {
  direct_debit?: InputMaybe<Scalars["Boolean"]["input"]>
  gsp_code?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  item_cost?: InputMaybe<Scalars["numeric"]["input"]>
  meterpoint_eac_1?: InputMaybe<Scalars["numeric"]["input"]>
  meterpoint_eac_2?: InputMaybe<Scalars["numeric"]["input"]>
  payment_review_calculation_fk?: InputMaybe<Scalars["bigint"]["input"]>
  product_code?: InputMaybe<Scalars["String"]["input"]>
  product_rate_1?: InputMaybe<Scalars["numeric"]["input"]>
  product_rate_2?: InputMaybe<Scalars["numeric"]["input"]>
  product_standing_rate?: InputMaybe<Scalars["numeric"]["input"]>
  product_type?: InputMaybe<Scalars["calculation_item_product_type"]["input"]>
  rate_type?: InputMaybe<Scalars["calculation_item_rate_type"]["input"]>
}

/** aggregate sum on columns */
export type Calculation_Items_Sum_Fields = {
  __typename?: "calculation_items_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  item_cost?: Maybe<Scalars["numeric"]["output"]>
  meterpoint_eac_1?: Maybe<Scalars["numeric"]["output"]>
  meterpoint_eac_2?: Maybe<Scalars["numeric"]["output"]>
  payment_review_calculation_fk?: Maybe<Scalars["bigint"]["output"]>
  product_rate_1?: Maybe<Scalars["numeric"]["output"]>
  product_rate_2?: Maybe<Scalars["numeric"]["output"]>
  product_standing_rate?: Maybe<Scalars["numeric"]["output"]>
}

/** order by sum() on columns of table "calculation_items" */
export type Calculation_Items_Sum_Order_By = {
  id?: InputMaybe<Order_By>
  item_cost?: InputMaybe<Order_By>
  meterpoint_eac_1?: InputMaybe<Order_By>
  meterpoint_eac_2?: InputMaybe<Order_By>
  payment_review_calculation_fk?: InputMaybe<Order_By>
  product_rate_1?: InputMaybe<Order_By>
  product_rate_2?: InputMaybe<Order_By>
  product_standing_rate?: InputMaybe<Order_By>
}

/** update columns of table "calculation_items" */
export enum Calculation_Items_Update_Column {
  /** column name */
  DirectDebit = "direct_debit",
  /** column name */
  GspCode = "gsp_code",
  /** column name */
  Id = "id",
  /** column name */
  ItemCost = "item_cost",
  /** column name */
  MeterpointEac_1 = "meterpoint_eac_1",
  /** column name */
  MeterpointEac_2 = "meterpoint_eac_2",
  /** column name */
  PaymentReviewCalculationFk = "payment_review_calculation_fk",
  /** column name */
  ProductCode = "product_code",
  /** column name */
  ProductRate_1 = "product_rate_1",
  /** column name */
  ProductRate_2 = "product_rate_2",
  /** column name */
  ProductStandingRate = "product_standing_rate",
  /** column name */
  ProductType = "product_type",
  /** column name */
  RateType = "rate_type",
}

export type Calculation_Items_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Calculation_Items_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Calculation_Items_Set_Input>
  /** filter the rows which have to be updated */
  where: Calculation_Items_Bool_Exp
}

/** aggregate var_pop on columns */
export type Calculation_Items_Var_Pop_Fields = {
  __typename?: "calculation_items_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  item_cost?: Maybe<Scalars["Float"]["output"]>
  meterpoint_eac_1?: Maybe<Scalars["Float"]["output"]>
  meterpoint_eac_2?: Maybe<Scalars["Float"]["output"]>
  payment_review_calculation_fk?: Maybe<Scalars["Float"]["output"]>
  product_rate_1?: Maybe<Scalars["Float"]["output"]>
  product_rate_2?: Maybe<Scalars["Float"]["output"]>
  product_standing_rate?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "calculation_items" */
export type Calculation_Items_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>
  item_cost?: InputMaybe<Order_By>
  meterpoint_eac_1?: InputMaybe<Order_By>
  meterpoint_eac_2?: InputMaybe<Order_By>
  payment_review_calculation_fk?: InputMaybe<Order_By>
  product_rate_1?: InputMaybe<Order_By>
  product_rate_2?: InputMaybe<Order_By>
  product_standing_rate?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Calculation_Items_Var_Samp_Fields = {
  __typename?: "calculation_items_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  item_cost?: Maybe<Scalars["Float"]["output"]>
  meterpoint_eac_1?: Maybe<Scalars["Float"]["output"]>
  meterpoint_eac_2?: Maybe<Scalars["Float"]["output"]>
  payment_review_calculation_fk?: Maybe<Scalars["Float"]["output"]>
  product_rate_1?: Maybe<Scalars["Float"]["output"]>
  product_rate_2?: Maybe<Scalars["Float"]["output"]>
  product_standing_rate?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "calculation_items" */
export type Calculation_Items_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>
  item_cost?: InputMaybe<Order_By>
  meterpoint_eac_1?: InputMaybe<Order_By>
  meterpoint_eac_2?: InputMaybe<Order_By>
  payment_review_calculation_fk?: InputMaybe<Order_By>
  product_rate_1?: InputMaybe<Order_By>
  product_rate_2?: InputMaybe<Order_By>
  product_standing_rate?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Calculation_Items_Variance_Fields = {
  __typename?: "calculation_items_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  item_cost?: Maybe<Scalars["Float"]["output"]>
  meterpoint_eac_1?: Maybe<Scalars["Float"]["output"]>
  meterpoint_eac_2?: Maybe<Scalars["Float"]["output"]>
  payment_review_calculation_fk?: Maybe<Scalars["Float"]["output"]>
  product_rate_1?: Maybe<Scalars["Float"]["output"]>
  product_rate_2?: Maybe<Scalars["Float"]["output"]>
  product_standing_rate?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "calculation_items" */
export type Calculation_Items_Variance_Order_By = {
  id?: InputMaybe<Order_By>
  item_cost?: InputMaybe<Order_By>
  meterpoint_eac_1?: InputMaybe<Order_By>
  meterpoint_eac_2?: InputMaybe<Order_By>
  payment_review_calculation_fk?: InputMaybe<Order_By>
  product_rate_1?: InputMaybe<Order_By>
  product_rate_2?: InputMaybe<Order_By>
  product_standing_rate?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "calculation_type_enum". All fields are combined with logical 'AND'. */
export type Calculation_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["calculation_type_enum"]["input"]>
  _gt?: InputMaybe<Scalars["calculation_type_enum"]["input"]>
  _gte?: InputMaybe<Scalars["calculation_type_enum"]["input"]>
  _in?: InputMaybe<Array<Scalars["calculation_type_enum"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["calculation_type_enum"]["input"]>
  _lte?: InputMaybe<Scalars["calculation_type_enum"]["input"]>
  _neq?: InputMaybe<Scalars["calculation_type_enum"]["input"]>
  _nin?: InputMaybe<Array<Scalars["calculation_type_enum"]["input"]>>
}

/** columns and relationships of "call_trace_audit" */
export type Call_Trace_Audit = {
  __typename?: "call_trace_audit"
  account_number: Scalars["String"]["output"]
  confirm_status: Scalars["call_trace_audit_confirmed_enum"]["output"]
  created_at: Scalars["timestamp"]["output"]
  data_updated: Scalars["String"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  gdpr_type: Scalars["call_trace_audit_gdpr_enum"]["output"]
  id: Scalars["bigint"]["output"]
  processed?: Maybe<Scalars["timestamp"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "call_trace_audit" */
export type Call_Trace_Audit_Aggregate = {
  __typename?: "call_trace_audit_aggregate"
  aggregate?: Maybe<Call_Trace_Audit_Aggregate_Fields>
  nodes: Array<Call_Trace_Audit>
}

/** aggregate fields of "call_trace_audit" */
export type Call_Trace_Audit_Aggregate_Fields = {
  __typename?: "call_trace_audit_aggregate_fields"
  avg?: Maybe<Call_Trace_Audit_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Call_Trace_Audit_Max_Fields>
  min?: Maybe<Call_Trace_Audit_Min_Fields>
  stddev?: Maybe<Call_Trace_Audit_Stddev_Fields>
  stddev_pop?: Maybe<Call_Trace_Audit_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Call_Trace_Audit_Stddev_Samp_Fields>
  sum?: Maybe<Call_Trace_Audit_Sum_Fields>
  var_pop?: Maybe<Call_Trace_Audit_Var_Pop_Fields>
  var_samp?: Maybe<Call_Trace_Audit_Var_Samp_Fields>
  variance?: Maybe<Call_Trace_Audit_Variance_Fields>
}

/** aggregate fields of "call_trace_audit" */
export type Call_Trace_Audit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Call_Trace_Audit_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Call_Trace_Audit_Avg_Fields = {
  __typename?: "call_trace_audit_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "call_trace_audit". All fields are combined with a logical 'AND'. */
export type Call_Trace_Audit_Bool_Exp = {
  _and?: InputMaybe<Array<Call_Trace_Audit_Bool_Exp>>
  _not?: InputMaybe<Call_Trace_Audit_Bool_Exp>
  _or?: InputMaybe<Array<Call_Trace_Audit_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  confirm_status?: InputMaybe<Call_Trace_Audit_Confirmed_Enum_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  data_updated?: InputMaybe<String_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  gdpr_type?: InputMaybe<Call_Trace_Audit_Gdpr_Enum_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  processed?: InputMaybe<Timestamp_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** Boolean expression to compare columns of type "call_trace_audit_confirmed_enum". All fields are combined with logical 'AND'. */
export type Call_Trace_Audit_Confirmed_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["call_trace_audit_confirmed_enum"]["input"]>
  _gt?: InputMaybe<Scalars["call_trace_audit_confirmed_enum"]["input"]>
  _gte?: InputMaybe<Scalars["call_trace_audit_confirmed_enum"]["input"]>
  _in?: InputMaybe<Array<Scalars["call_trace_audit_confirmed_enum"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["call_trace_audit_confirmed_enum"]["input"]>
  _lte?: InputMaybe<Scalars["call_trace_audit_confirmed_enum"]["input"]>
  _neq?: InputMaybe<Scalars["call_trace_audit_confirmed_enum"]["input"]>
  _nin?: InputMaybe<Array<Scalars["call_trace_audit_confirmed_enum"]["input"]>>
}

/** unique or primary key constraints on table "call_trace_audit" */
export enum Call_Trace_Audit_Constraint {
  /** unique or primary key constraint on columns "id" */
  PrimaryKeyCallTraceAudit = "primary_key_call_trace_audit",
}

/** Boolean expression to compare columns of type "call_trace_audit_gdpr_enum". All fields are combined with logical 'AND'. */
export type Call_Trace_Audit_Gdpr_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["call_trace_audit_gdpr_enum"]["input"]>
  _gt?: InputMaybe<Scalars["call_trace_audit_gdpr_enum"]["input"]>
  _gte?: InputMaybe<Scalars["call_trace_audit_gdpr_enum"]["input"]>
  _in?: InputMaybe<Array<Scalars["call_trace_audit_gdpr_enum"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["call_trace_audit_gdpr_enum"]["input"]>
  _lte?: InputMaybe<Scalars["call_trace_audit_gdpr_enum"]["input"]>
  _neq?: InputMaybe<Scalars["call_trace_audit_gdpr_enum"]["input"]>
  _nin?: InputMaybe<Array<Scalars["call_trace_audit_gdpr_enum"]["input"]>>
}

/** input type for incrementing numeric columns in table "call_trace_audit" */
export type Call_Trace_Audit_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "call_trace_audit" */
export type Call_Trace_Audit_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  confirm_status?: InputMaybe<
    Scalars["call_trace_audit_confirmed_enum"]["input"]
  >
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  data_updated?: InputMaybe<Scalars["String"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  gdpr_type?: InputMaybe<Scalars["call_trace_audit_gdpr_enum"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  processed?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Call_Trace_Audit_Max_Fields = {
  __typename?: "call_trace_audit_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  confirm_status?: Maybe<Scalars["call_trace_audit_confirmed_enum"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  data_updated?: Maybe<Scalars["String"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  gdpr_type?: Maybe<Scalars["call_trace_audit_gdpr_enum"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  processed?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Call_Trace_Audit_Min_Fields = {
  __typename?: "call_trace_audit_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  confirm_status?: Maybe<Scalars["call_trace_audit_confirmed_enum"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  data_updated?: Maybe<Scalars["String"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  gdpr_type?: Maybe<Scalars["call_trace_audit_gdpr_enum"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  processed?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "call_trace_audit" */
export type Call_Trace_Audit_Mutation_Response = {
  __typename?: "call_trace_audit_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Call_Trace_Audit>
}

/** on_conflict condition type for table "call_trace_audit" */
export type Call_Trace_Audit_On_Conflict = {
  constraint: Call_Trace_Audit_Constraint
  update_columns?: Array<Call_Trace_Audit_Update_Column>
  where?: InputMaybe<Call_Trace_Audit_Bool_Exp>
}

/** Ordering options when selecting data from "call_trace_audit". */
export type Call_Trace_Audit_Order_By = {
  account_number?: InputMaybe<Order_By>
  confirm_status?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  data_updated?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  gdpr_type?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  processed?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: call_trace_audit */
export type Call_Trace_Audit_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "call_trace_audit" */
export enum Call_Trace_Audit_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  ConfirmStatus = "confirm_status",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DataUpdated = "data_updated",
  /** column name */
  Deleted = "deleted",
  /** column name */
  GdprType = "gdpr_type",
  /** column name */
  Id = "id",
  /** column name */
  Processed = "processed",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "call_trace_audit" */
export type Call_Trace_Audit_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  confirm_status?: InputMaybe<
    Scalars["call_trace_audit_confirmed_enum"]["input"]
  >
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  data_updated?: InputMaybe<Scalars["String"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  gdpr_type?: InputMaybe<Scalars["call_trace_audit_gdpr_enum"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  processed?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Call_Trace_Audit_Stddev_Fields = {
  __typename?: "call_trace_audit_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Call_Trace_Audit_Stddev_Pop_Fields = {
  __typename?: "call_trace_audit_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Call_Trace_Audit_Stddev_Samp_Fields = {
  __typename?: "call_trace_audit_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "call_trace_audit" */
export type Call_Trace_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Call_Trace_Audit_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Call_Trace_Audit_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  confirm_status?: InputMaybe<
    Scalars["call_trace_audit_confirmed_enum"]["input"]
  >
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  data_updated?: InputMaybe<Scalars["String"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  gdpr_type?: InputMaybe<Scalars["call_trace_audit_gdpr_enum"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  processed?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Call_Trace_Audit_Sum_Fields = {
  __typename?: "call_trace_audit_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "call_trace_audit" */
export enum Call_Trace_Audit_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  ConfirmStatus = "confirm_status",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DataUpdated = "data_updated",
  /** column name */
  Deleted = "deleted",
  /** column name */
  GdprType = "gdpr_type",
  /** column name */
  Id = "id",
  /** column name */
  Processed = "processed",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Call_Trace_Audit_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Call_Trace_Audit_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Call_Trace_Audit_Set_Input>
  /** filter the rows which have to be updated */
  where: Call_Trace_Audit_Bool_Exp
}

/** aggregate var_pop on columns */
export type Call_Trace_Audit_Var_Pop_Fields = {
  __typename?: "call_trace_audit_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Call_Trace_Audit_Var_Samp_Fields = {
  __typename?: "call_trace_audit_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Call_Trace_Audit_Variance_Fields = {
  __typename?: "call_trace_audit_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "cancellation_origin". All fields are combined with logical 'AND'. */
export type Cancellation_Origin_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["cancellation_origin"]["input"]>
  _gt?: InputMaybe<Scalars["cancellation_origin"]["input"]>
  _gte?: InputMaybe<Scalars["cancellation_origin"]["input"]>
  _in?: InputMaybe<Array<Scalars["cancellation_origin"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["cancellation_origin"]["input"]>
  _lte?: InputMaybe<Scalars["cancellation_origin"]["input"]>
  _neq?: InputMaybe<Scalars["cancellation_origin"]["input"]>
  _nin?: InputMaybe<Array<Scalars["cancellation_origin"]["input"]>>
}

/** columns and relationships of "cancellation_reasons" */
export type Cancellation_Reasons = {
  __typename?: "cancellation_reasons"
  account_number: Scalars["bigint"]["output"]
  channel: Scalars["String"]["output"]
  created_date: Scalars["timestamp"]["output"]
  detail?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  meter_point_id: Scalars["numeric"]["output"]
  updated_date?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregated selection of "cancellation_reasons" */
export type Cancellation_Reasons_Aggregate = {
  __typename?: "cancellation_reasons_aggregate"
  aggregate?: Maybe<Cancellation_Reasons_Aggregate_Fields>
  nodes: Array<Cancellation_Reasons>
}

/** aggregate fields of "cancellation_reasons" */
export type Cancellation_Reasons_Aggregate_Fields = {
  __typename?: "cancellation_reasons_aggregate_fields"
  avg?: Maybe<Cancellation_Reasons_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Cancellation_Reasons_Max_Fields>
  min?: Maybe<Cancellation_Reasons_Min_Fields>
  stddev?: Maybe<Cancellation_Reasons_Stddev_Fields>
  stddev_pop?: Maybe<Cancellation_Reasons_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Cancellation_Reasons_Stddev_Samp_Fields>
  sum?: Maybe<Cancellation_Reasons_Sum_Fields>
  var_pop?: Maybe<Cancellation_Reasons_Var_Pop_Fields>
  var_samp?: Maybe<Cancellation_Reasons_Var_Samp_Fields>
  variance?: Maybe<Cancellation_Reasons_Variance_Fields>
}

/** aggregate fields of "cancellation_reasons" */
export type Cancellation_Reasons_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cancellation_Reasons_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Cancellation_Reasons_Avg_Fields = {
  __typename?: "cancellation_reasons_avg_fields"
  account_number?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "cancellation_reasons". All fields are combined with a logical 'AND'. */
export type Cancellation_Reasons_Bool_Exp = {
  _and?: InputMaybe<Array<Cancellation_Reasons_Bool_Exp>>
  _not?: InputMaybe<Cancellation_Reasons_Bool_Exp>
  _or?: InputMaybe<Array<Cancellation_Reasons_Bool_Exp>>
  account_number?: InputMaybe<Bigint_Comparison_Exp>
  channel?: InputMaybe<String_Comparison_Exp>
  created_date?: InputMaybe<Timestamp_Comparison_Exp>
  detail?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  meter_point_id?: InputMaybe<Numeric_Comparison_Exp>
  updated_date?: InputMaybe<Timestamp_Comparison_Exp>
}

/** input type for incrementing numeric columns in table "cancellation_reasons" */
export type Cancellation_Reasons_Inc_Input = {
  account_number?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["numeric"]["input"]>
}

/** input type for inserting data into table "cancellation_reasons" */
export type Cancellation_Reasons_Insert_Input = {
  account_number?: InputMaybe<Scalars["bigint"]["input"]>
  channel?: InputMaybe<Scalars["String"]["input"]>
  created_date?: InputMaybe<Scalars["timestamp"]["input"]>
  detail?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["numeric"]["input"]>
  updated_date?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Cancellation_Reasons_Max_Fields = {
  __typename?: "cancellation_reasons_max_fields"
  account_number?: Maybe<Scalars["bigint"]["output"]>
  channel?: Maybe<Scalars["String"]["output"]>
  created_date?: Maybe<Scalars["timestamp"]["output"]>
  detail?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["numeric"]["output"]>
  updated_date?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Cancellation_Reasons_Min_Fields = {
  __typename?: "cancellation_reasons_min_fields"
  account_number?: Maybe<Scalars["bigint"]["output"]>
  channel?: Maybe<Scalars["String"]["output"]>
  created_date?: Maybe<Scalars["timestamp"]["output"]>
  detail?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["numeric"]["output"]>
  updated_date?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "cancellation_reasons" */
export type Cancellation_Reasons_Mutation_Response = {
  __typename?: "cancellation_reasons_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Cancellation_Reasons>
}

/** Ordering options when selecting data from "cancellation_reasons". */
export type Cancellation_Reasons_Order_By = {
  account_number?: InputMaybe<Order_By>
  channel?: InputMaybe<Order_By>
  created_date?: InputMaybe<Order_By>
  detail?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  updated_date?: InputMaybe<Order_By>
}

/** select columns of table "cancellation_reasons" */
export enum Cancellation_Reasons_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  Channel = "channel",
  /** column name */
  CreatedDate = "created_date",
  /** column name */
  Detail = "detail",
  /** column name */
  Id = "id",
  /** column name */
  MeterPointId = "meter_point_id",
  /** column name */
  UpdatedDate = "updated_date",
}

/** input type for updating data in table "cancellation_reasons" */
export type Cancellation_Reasons_Set_Input = {
  account_number?: InputMaybe<Scalars["bigint"]["input"]>
  channel?: InputMaybe<Scalars["String"]["input"]>
  created_date?: InputMaybe<Scalars["timestamp"]["input"]>
  detail?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["numeric"]["input"]>
  updated_date?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Cancellation_Reasons_Stddev_Fields = {
  __typename?: "cancellation_reasons_stddev_fields"
  account_number?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Cancellation_Reasons_Stddev_Pop_Fields = {
  __typename?: "cancellation_reasons_stddev_pop_fields"
  account_number?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Cancellation_Reasons_Stddev_Samp_Fields = {
  __typename?: "cancellation_reasons_stddev_samp_fields"
  account_number?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "cancellation_reasons" */
export type Cancellation_Reasons_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cancellation_Reasons_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Cancellation_Reasons_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars["bigint"]["input"]>
  channel?: InputMaybe<Scalars["String"]["input"]>
  created_date?: InputMaybe<Scalars["timestamp"]["input"]>
  detail?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["numeric"]["input"]>
  updated_date?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Cancellation_Reasons_Sum_Fields = {
  __typename?: "cancellation_reasons_sum_fields"
  account_number?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["numeric"]["output"]>
}

export type Cancellation_Reasons_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cancellation_Reasons_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cancellation_Reasons_Set_Input>
  /** filter the rows which have to be updated */
  where: Cancellation_Reasons_Bool_Exp
}

/** aggregate var_pop on columns */
export type Cancellation_Reasons_Var_Pop_Fields = {
  __typename?: "cancellation_reasons_var_pop_fields"
  account_number?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Cancellation_Reasons_Var_Samp_Fields = {
  __typename?: "cancellation_reasons_var_samp_fields"
  account_number?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Cancellation_Reasons_Variance_Fields = {
  __typename?: "cancellation_reasons_variance_fields"
  account_number?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "cancellation_type". All fields are combined with logical 'AND'. */
export type Cancellation_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["cancellation_type"]["input"]>
  _gt?: InputMaybe<Scalars["cancellation_type"]["input"]>
  _gte?: InputMaybe<Scalars["cancellation_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["cancellation_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["cancellation_type"]["input"]>
  _lte?: InputMaybe<Scalars["cancellation_type"]["input"]>
  _neq?: InputMaybe<Scalars["cancellation_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["cancellation_type"]["input"]>>
}

/** columns and relationships of "cancellations" */
export type Cancellations = {
  __typename?: "cancellations"
  /** An object relationship */
  billing_account?: Maybe<Billing_Account>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted_by?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  meter_point_id?: Maybe<Scalars["bigint"]["output"]>
  origin: Scalars["cancellation_origin"]["output"]
  reason?: Maybe<Scalars["String"]["output"]>
  type: Scalars["cancellation_type"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "cancellations" */
export type Cancellations_Aggregate = {
  __typename?: "cancellations_aggregate"
  aggregate?: Maybe<Cancellations_Aggregate_Fields>
  nodes: Array<Cancellations>
}

export type Cancellations_Aggregate_Bool_Exp = {
  count?: InputMaybe<Cancellations_Aggregate_Bool_Exp_Count>
}

export type Cancellations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Cancellations_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Cancellations_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "cancellations" */
export type Cancellations_Aggregate_Fields = {
  __typename?: "cancellations_aggregate_fields"
  avg?: Maybe<Cancellations_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Cancellations_Max_Fields>
  min?: Maybe<Cancellations_Min_Fields>
  stddev?: Maybe<Cancellations_Stddev_Fields>
  stddev_pop?: Maybe<Cancellations_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Cancellations_Stddev_Samp_Fields>
  sum?: Maybe<Cancellations_Sum_Fields>
  var_pop?: Maybe<Cancellations_Var_Pop_Fields>
  var_samp?: Maybe<Cancellations_Var_Samp_Fields>
  variance?: Maybe<Cancellations_Variance_Fields>
}

/** aggregate fields of "cancellations" */
export type Cancellations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cancellations_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "cancellations" */
export type Cancellations_Aggregate_Order_By = {
  avg?: InputMaybe<Cancellations_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Cancellations_Max_Order_By>
  min?: InputMaybe<Cancellations_Min_Order_By>
  stddev?: InputMaybe<Cancellations_Stddev_Order_By>
  stddev_pop?: InputMaybe<Cancellations_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Cancellations_Stddev_Samp_Order_By>
  sum?: InputMaybe<Cancellations_Sum_Order_By>
  var_pop?: InputMaybe<Cancellations_Var_Pop_Order_By>
  var_samp?: InputMaybe<Cancellations_Var_Samp_Order_By>
  variance?: InputMaybe<Cancellations_Variance_Order_By>
}

/** input type for inserting array relation for remote table "cancellations" */
export type Cancellations_Arr_Rel_Insert_Input = {
  data: Array<Cancellations_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Cancellations_On_Conflict>
}

/** aggregate avg on columns */
export type Cancellations_Avg_Fields = {
  __typename?: "cancellations_avg_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "cancellations" */
export type Cancellations_Avg_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "cancellations". All fields are combined with a logical 'AND'. */
export type Cancellations_Bool_Exp = {
  _and?: InputMaybe<Array<Cancellations_Bool_Exp>>
  _not?: InputMaybe<Cancellations_Bool_Exp>
  _or?: InputMaybe<Array<Cancellations_Bool_Exp>>
  billing_account?: InputMaybe<Billing_Account_Bool_Exp>
  billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  customer_id?: InputMaybe<Bigint_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted_by?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  meter_point_id?: InputMaybe<Bigint_Comparison_Exp>
  origin?: InputMaybe<Cancellation_Origin_Comparison_Exp>
  reason?: InputMaybe<String_Comparison_Exp>
  type?: InputMaybe<Cancellation_Type_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "cancellations" */
export enum Cancellations_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkCancellations = "pk_cancellations",
}

/** input type for incrementing numeric columns in table "cancellations" */
export type Cancellations_Inc_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "cancellations" */
export type Cancellations_Insert_Input = {
  billing_account?: InputMaybe<Billing_Account_Obj_Rel_Insert_Input>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_by?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  origin?: InputMaybe<Scalars["cancellation_origin"]["input"]>
  reason?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["cancellation_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Cancellations_Max_Fields = {
  __typename?: "cancellations_max_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted_by?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["bigint"]["output"]>
  origin?: Maybe<Scalars["cancellation_origin"]["output"]>
  reason?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["cancellation_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "cancellations" */
export type Cancellations_Max_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  deleted_by?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  origin?: InputMaybe<Order_By>
  reason?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Cancellations_Min_Fields = {
  __typename?: "cancellations_min_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted_by?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["bigint"]["output"]>
  origin?: Maybe<Scalars["cancellation_origin"]["output"]>
  reason?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["cancellation_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "cancellations" */
export type Cancellations_Min_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  deleted_by?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  origin?: InputMaybe<Order_By>
  reason?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "cancellations" */
export type Cancellations_Mutation_Response = {
  __typename?: "cancellations_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Cancellations>
}

/** on_conflict condition type for table "cancellations" */
export type Cancellations_On_Conflict = {
  constraint: Cancellations_Constraint
  update_columns?: Array<Cancellations_Update_Column>
  where?: InputMaybe<Cancellations_Bool_Exp>
}

/** Ordering options when selecting data from "cancellations". */
export type Cancellations_Order_By = {
  billing_account?: InputMaybe<Billing_Account_Order_By>
  billing_account_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  deleted_by?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  origin?: InputMaybe<Order_By>
  reason?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: cancellations */
export type Cancellations_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "cancellations" */
export enum Cancellations_Select_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  DeletedBy = "deleted_by",
  /** column name */
  Id = "id",
  /** column name */
  MeterPointId = "meter_point_id",
  /** column name */
  Origin = "origin",
  /** column name */
  Reason = "reason",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "cancellations" */
export type Cancellations_Set_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_by?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  origin?: InputMaybe<Scalars["cancellation_origin"]["input"]>
  reason?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["cancellation_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Cancellations_Stddev_Fields = {
  __typename?: "cancellations_stddev_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "cancellations" */
export type Cancellations_Stddev_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Cancellations_Stddev_Pop_Fields = {
  __typename?: "cancellations_stddev_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "cancellations" */
export type Cancellations_Stddev_Pop_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Cancellations_Stddev_Samp_Fields = {
  __typename?: "cancellations_stddev_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "cancellations" */
export type Cancellations_Stddev_Samp_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "cancellations" */
export type Cancellations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cancellations_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Cancellations_Stream_Cursor_Value_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_by?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  origin?: InputMaybe<Scalars["cancellation_origin"]["input"]>
  reason?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["cancellation_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Cancellations_Sum_Fields = {
  __typename?: "cancellations_sum_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "cancellations" */
export type Cancellations_Sum_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** update columns of table "cancellations" */
export enum Cancellations_Update_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  DeletedBy = "deleted_by",
  /** column name */
  Id = "id",
  /** column name */
  MeterPointId = "meter_point_id",
  /** column name */
  Origin = "origin",
  /** column name */
  Reason = "reason",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Cancellations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cancellations_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cancellations_Set_Input>
  /** filter the rows which have to be updated */
  where: Cancellations_Bool_Exp
}

/** aggregate var_pop on columns */
export type Cancellations_Var_Pop_Fields = {
  __typename?: "cancellations_var_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "cancellations" */
export type Cancellations_Var_Pop_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Cancellations_Var_Samp_Fields = {
  __typename?: "cancellations_var_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "cancellations" */
export type Cancellations_Var_Samp_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Cancellations_Variance_Fields = {
  __typename?: "cancellations_variance_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "cancellations" */
export type Cancellations_Variance_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** columns and relationships of "card_payment" */
export type Card_Payment = {
  __typename?: "card_payment"
  account_number: Scalars["String"]["output"]
  authorised_at?: Maybe<Scalars["timestamp"]["output"]>
  card_expiry_date?: Maybe<Scalars["String"]["output"]>
  card_last4_digits?: Maybe<Scalars["String"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  customer_number: Scalars["String"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  error_code?: Maybe<Scalars["String"]["output"]>
  error_message?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  junifer_payment_status?: Maybe<Scalars["junifer_payment_status"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  source: Scalars["String"]["output"]
  status: Scalars["card_payment_status"]["output"]
  threeds_challenged_at?: Maybe<Scalars["timestamp"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
  uploaded_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregated selection of "card_payment" */
export type Card_Payment_Aggregate = {
  __typename?: "card_payment_aggregate"
  aggregate?: Maybe<Card_Payment_Aggregate_Fields>
  nodes: Array<Card_Payment>
}

/** aggregate fields of "card_payment" */
export type Card_Payment_Aggregate_Fields = {
  __typename?: "card_payment_aggregate_fields"
  avg?: Maybe<Card_Payment_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Card_Payment_Max_Fields>
  min?: Maybe<Card_Payment_Min_Fields>
  stddev?: Maybe<Card_Payment_Stddev_Fields>
  stddev_pop?: Maybe<Card_Payment_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Card_Payment_Stddev_Samp_Fields>
  sum?: Maybe<Card_Payment_Sum_Fields>
  var_pop?: Maybe<Card_Payment_Var_Pop_Fields>
  var_samp?: Maybe<Card_Payment_Var_Samp_Fields>
  variance?: Maybe<Card_Payment_Variance_Fields>
}

/** aggregate fields of "card_payment" */
export type Card_Payment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Card_Payment_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Card_Payment_Avg_Fields = {
  __typename?: "card_payment_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "card_payment". All fields are combined with a logical 'AND'. */
export type Card_Payment_Bool_Exp = {
  _and?: InputMaybe<Array<Card_Payment_Bool_Exp>>
  _not?: InputMaybe<Card_Payment_Bool_Exp>
  _or?: InputMaybe<Array<Card_Payment_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  authorised_at?: InputMaybe<Timestamp_Comparison_Exp>
  card_expiry_date?: InputMaybe<String_Comparison_Exp>
  card_last4_digits?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  customer_number?: InputMaybe<String_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  error_code?: InputMaybe<String_Comparison_Exp>
  error_message?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  junifer_payment_status?: InputMaybe<Junifer_Payment_Status_Comparison_Exp>
  reference?: InputMaybe<String_Comparison_Exp>
  source?: InputMaybe<String_Comparison_Exp>
  status?: InputMaybe<Card_Payment_Status_Comparison_Exp>
  threeds_challenged_at?: InputMaybe<Timestamp_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  uploaded_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "card_payment" */
export enum Card_Payment_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkCardPaymentNew = "pk_card_payment_new",
}

/** input type for incrementing numeric columns in table "card_payment" */
export type Card_Payment_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "card_payment" */
export type Card_Payment_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  authorised_at?: InputMaybe<Scalars["timestamp"]["input"]>
  card_expiry_date?: InputMaybe<Scalars["String"]["input"]>
  card_last4_digits?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_number?: InputMaybe<Scalars["String"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  error_code?: InputMaybe<Scalars["String"]["input"]>
  error_message?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_payment_status?: InputMaybe<
    Scalars["junifer_payment_status"]["input"]
  >
  reference?: InputMaybe<Scalars["String"]["input"]>
  source?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["card_payment_status"]["input"]>
  threeds_challenged_at?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  uploaded_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Card_Payment_Max_Fields = {
  __typename?: "card_payment_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  authorised_at?: Maybe<Scalars["timestamp"]["output"]>
  card_expiry_date?: Maybe<Scalars["String"]["output"]>
  card_last4_digits?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_number?: Maybe<Scalars["String"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  error_code?: Maybe<Scalars["String"]["output"]>
  error_message?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_payment_status?: Maybe<Scalars["junifer_payment_status"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  source?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["card_payment_status"]["output"]>
  threeds_challenged_at?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  uploaded_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Card_Payment_Min_Fields = {
  __typename?: "card_payment_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  authorised_at?: Maybe<Scalars["timestamp"]["output"]>
  card_expiry_date?: Maybe<Scalars["String"]["output"]>
  card_last4_digits?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_number?: Maybe<Scalars["String"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  error_code?: Maybe<Scalars["String"]["output"]>
  error_message?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_payment_status?: Maybe<Scalars["junifer_payment_status"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  source?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["card_payment_status"]["output"]>
  threeds_challenged_at?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  uploaded_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "card_payment" */
export type Card_Payment_Mutation_Response = {
  __typename?: "card_payment_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Card_Payment>
}

/** columns and relationships of "card_payment_old" */
export type Card_Payment_Old = {
  __typename?: "card_payment_old"
  account_id?: Maybe<Scalars["bigint"]["output"]>
  account_number?: Maybe<Scalars["String"]["output"]>
  agent_email?: Maybe<Scalars["String"]["output"]>
  agent_name?: Maybe<Scalars["String"]["output"]>
  amount: Scalars["bigint"]["output"]
  authorised_at?: Maybe<Scalars["timestamptz"]["output"]>
  card_expiry_date?: Maybe<Scalars["String"]["output"]>
  card_last4_digits?: Maybe<Scalars["String"]["output"]>
  cko_session_id?: Maybe<Scalars["String"]["output"]>
  created_at: Scalars["timestamptz"]["output"]
  custom_metadata?: Maybe<Scalars["json"]["output"]>
  customer_email?: Maybe<Scalars["String"]["output"]>
  customer_name?: Maybe<Scalars["String"]["output"]>
  customer_number?: Maybe<Scalars["String"]["output"]>
  error_code?: Maybe<Scalars["String"]["output"]>
  error_message?: Maybe<Scalars["String"]["output"]>
  external_id?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  is_junifer_payment?: Maybe<Scalars["Boolean"]["output"]>
  junifer_payment_id?: Maybe<Scalars["bigint"]["output"]>
  junifer_payment_status: Scalars["junifer_payment_status"]["output"]
  notification_error?: Maybe<Scalars["String"]["output"]>
  notification_status: Scalars["payment_notification_status"]["output"]
  payment_session_id?: Maybe<Scalars["String"]["output"]>
  reference: Scalars["String"]["output"]
  request_type?: Maybe<Scalars["payment_request_type"]["output"]>
  source: Scalars["String"]["output"]
  status: Scalars["card_payment_status"]["output"]
  threeds_challenged_at?: Maybe<Scalars["timestamptz"]["output"]>
  updated_at?: Maybe<Scalars["timestamptz"]["output"]>
  uploaded_at?: Maybe<Scalars["timestamptz"]["output"]>
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** columns and relationships of "card_payment_old" */
export type Card_Payment_OldCustom_MetadataArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregated selection of "card_payment_old" */
export type Card_Payment_Old_Aggregate = {
  __typename?: "card_payment_old_aggregate"
  aggregate?: Maybe<Card_Payment_Old_Aggregate_Fields>
  nodes: Array<Card_Payment_Old>
}

/** aggregate fields of "card_payment_old" */
export type Card_Payment_Old_Aggregate_Fields = {
  __typename?: "card_payment_old_aggregate_fields"
  avg?: Maybe<Card_Payment_Old_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Card_Payment_Old_Max_Fields>
  min?: Maybe<Card_Payment_Old_Min_Fields>
  stddev?: Maybe<Card_Payment_Old_Stddev_Fields>
  stddev_pop?: Maybe<Card_Payment_Old_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Card_Payment_Old_Stddev_Samp_Fields>
  sum?: Maybe<Card_Payment_Old_Sum_Fields>
  var_pop?: Maybe<Card_Payment_Old_Var_Pop_Fields>
  var_samp?: Maybe<Card_Payment_Old_Var_Samp_Fields>
  variance?: Maybe<Card_Payment_Old_Variance_Fields>
}

/** aggregate fields of "card_payment_old" */
export type Card_Payment_Old_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Card_Payment_Old_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Card_Payment_Old_Avg_Fields = {
  __typename?: "card_payment_old_avg_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_payment_id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "card_payment_old". All fields are combined with a logical 'AND'. */
export type Card_Payment_Old_Bool_Exp = {
  _and?: InputMaybe<Array<Card_Payment_Old_Bool_Exp>>
  _not?: InputMaybe<Card_Payment_Old_Bool_Exp>
  _or?: InputMaybe<Array<Card_Payment_Old_Bool_Exp>>
  account_id?: InputMaybe<Bigint_Comparison_Exp>
  account_number?: InputMaybe<String_Comparison_Exp>
  agent_email?: InputMaybe<String_Comparison_Exp>
  agent_name?: InputMaybe<String_Comparison_Exp>
  amount?: InputMaybe<Bigint_Comparison_Exp>
  authorised_at?: InputMaybe<Timestamptz_Comparison_Exp>
  card_expiry_date?: InputMaybe<String_Comparison_Exp>
  card_last4_digits?: InputMaybe<String_Comparison_Exp>
  cko_session_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  custom_metadata?: InputMaybe<Json_Comparison_Exp>
  customer_email?: InputMaybe<String_Comparison_Exp>
  customer_name?: InputMaybe<String_Comparison_Exp>
  customer_number?: InputMaybe<String_Comparison_Exp>
  error_code?: InputMaybe<String_Comparison_Exp>
  error_message?: InputMaybe<String_Comparison_Exp>
  external_id?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  is_junifer_payment?: InputMaybe<Boolean_Comparison_Exp>
  junifer_payment_id?: InputMaybe<Bigint_Comparison_Exp>
  junifer_payment_status?: InputMaybe<Junifer_Payment_Status_Comparison_Exp>
  notification_error?: InputMaybe<String_Comparison_Exp>
  notification_status?: InputMaybe<Payment_Notification_Status_Comparison_Exp>
  payment_session_id?: InputMaybe<String_Comparison_Exp>
  reference?: InputMaybe<String_Comparison_Exp>
  request_type?: InputMaybe<Payment_Request_Type_Comparison_Exp>
  source?: InputMaybe<String_Comparison_Exp>
  status?: InputMaybe<Card_Payment_Status_Comparison_Exp>
  threeds_challenged_at?: InputMaybe<Timestamptz_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  uploaded_at?: InputMaybe<Timestamptz_Comparison_Exp>
  user_id?: InputMaybe<Bigint_Comparison_Exp>
}

/** unique or primary key constraints on table "card_payment_old" */
export enum Card_Payment_Old_Constraint {
  /** unique or primary key constraint on columns "cko_session_id" */
  CardPaymentOldCkoSessionIdIndex = "card_payment_old_cko_session_id_index",
  /** unique or primary key constraint on columns "external_id" */
  CardPaymentOldExternalIdIndex = "card_payment_old_external_id_index",
  /** unique or primary key constraint on columns "id" */
  PkCardPayment = "pk_card_payment",
}

/** input type for incrementing numeric columns in table "card_payment_old" */
export type Card_Payment_Old_Inc_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  amount?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_payment_id?: InputMaybe<Scalars["bigint"]["input"]>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "card_payment_old" */
export type Card_Payment_Old_Insert_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  account_number?: InputMaybe<Scalars["String"]["input"]>
  agent_email?: InputMaybe<Scalars["String"]["input"]>
  agent_name?: InputMaybe<Scalars["String"]["input"]>
  amount?: InputMaybe<Scalars["bigint"]["input"]>
  authorised_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  card_expiry_date?: InputMaybe<Scalars["String"]["input"]>
  card_last4_digits?: InputMaybe<Scalars["String"]["input"]>
  cko_session_id?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  custom_metadata?: InputMaybe<Scalars["json"]["input"]>
  customer_email?: InputMaybe<Scalars["String"]["input"]>
  customer_name?: InputMaybe<Scalars["String"]["input"]>
  customer_number?: InputMaybe<Scalars["String"]["input"]>
  error_code?: InputMaybe<Scalars["String"]["input"]>
  error_message?: InputMaybe<Scalars["String"]["input"]>
  external_id?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  is_junifer_payment?: InputMaybe<Scalars["Boolean"]["input"]>
  junifer_payment_id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_payment_status?: InputMaybe<
    Scalars["junifer_payment_status"]["input"]
  >
  notification_error?: InputMaybe<Scalars["String"]["input"]>
  notification_status?: InputMaybe<
    Scalars["payment_notification_status"]["input"]
  >
  payment_session_id?: InputMaybe<Scalars["String"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  request_type?: InputMaybe<Scalars["payment_request_type"]["input"]>
  source?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["card_payment_status"]["input"]>
  threeds_challenged_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  uploaded_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate max on columns */
export type Card_Payment_Old_Max_Fields = {
  __typename?: "card_payment_old_max_fields"
  account_id?: Maybe<Scalars["bigint"]["output"]>
  account_number?: Maybe<Scalars["String"]["output"]>
  agent_email?: Maybe<Scalars["String"]["output"]>
  agent_name?: Maybe<Scalars["String"]["output"]>
  amount?: Maybe<Scalars["bigint"]["output"]>
  authorised_at?: Maybe<Scalars["timestamptz"]["output"]>
  card_expiry_date?: Maybe<Scalars["String"]["output"]>
  card_last4_digits?: Maybe<Scalars["String"]["output"]>
  cko_session_id?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  customer_email?: Maybe<Scalars["String"]["output"]>
  customer_name?: Maybe<Scalars["String"]["output"]>
  customer_number?: Maybe<Scalars["String"]["output"]>
  error_code?: Maybe<Scalars["String"]["output"]>
  error_message?: Maybe<Scalars["String"]["output"]>
  external_id?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_payment_id?: Maybe<Scalars["bigint"]["output"]>
  junifer_payment_status?: Maybe<Scalars["junifer_payment_status"]["output"]>
  notification_error?: Maybe<Scalars["String"]["output"]>
  notification_status?: Maybe<Scalars["payment_notification_status"]["output"]>
  payment_session_id?: Maybe<Scalars["String"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  request_type?: Maybe<Scalars["payment_request_type"]["output"]>
  source?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["card_payment_status"]["output"]>
  threeds_challenged_at?: Maybe<Scalars["timestamptz"]["output"]>
  updated_at?: Maybe<Scalars["timestamptz"]["output"]>
  uploaded_at?: Maybe<Scalars["timestamptz"]["output"]>
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregate min on columns */
export type Card_Payment_Old_Min_Fields = {
  __typename?: "card_payment_old_min_fields"
  account_id?: Maybe<Scalars["bigint"]["output"]>
  account_number?: Maybe<Scalars["String"]["output"]>
  agent_email?: Maybe<Scalars["String"]["output"]>
  agent_name?: Maybe<Scalars["String"]["output"]>
  amount?: Maybe<Scalars["bigint"]["output"]>
  authorised_at?: Maybe<Scalars["timestamptz"]["output"]>
  card_expiry_date?: Maybe<Scalars["String"]["output"]>
  card_last4_digits?: Maybe<Scalars["String"]["output"]>
  cko_session_id?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  customer_email?: Maybe<Scalars["String"]["output"]>
  customer_name?: Maybe<Scalars["String"]["output"]>
  customer_number?: Maybe<Scalars["String"]["output"]>
  error_code?: Maybe<Scalars["String"]["output"]>
  error_message?: Maybe<Scalars["String"]["output"]>
  external_id?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_payment_id?: Maybe<Scalars["bigint"]["output"]>
  junifer_payment_status?: Maybe<Scalars["junifer_payment_status"]["output"]>
  notification_error?: Maybe<Scalars["String"]["output"]>
  notification_status?: Maybe<Scalars["payment_notification_status"]["output"]>
  payment_session_id?: Maybe<Scalars["String"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  request_type?: Maybe<Scalars["payment_request_type"]["output"]>
  source?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["card_payment_status"]["output"]>
  threeds_challenged_at?: Maybe<Scalars["timestamptz"]["output"]>
  updated_at?: Maybe<Scalars["timestamptz"]["output"]>
  uploaded_at?: Maybe<Scalars["timestamptz"]["output"]>
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** response of any mutation on the table "card_payment_old" */
export type Card_Payment_Old_Mutation_Response = {
  __typename?: "card_payment_old_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Card_Payment_Old>
}

/** on_conflict condition type for table "card_payment_old" */
export type Card_Payment_Old_On_Conflict = {
  constraint: Card_Payment_Old_Constraint
  update_columns?: Array<Card_Payment_Old_Update_Column>
  where?: InputMaybe<Card_Payment_Old_Bool_Exp>
}

/** Ordering options when selecting data from "card_payment_old". */
export type Card_Payment_Old_Order_By = {
  account_id?: InputMaybe<Order_By>
  account_number?: InputMaybe<Order_By>
  agent_email?: InputMaybe<Order_By>
  agent_name?: InputMaybe<Order_By>
  amount?: InputMaybe<Order_By>
  authorised_at?: InputMaybe<Order_By>
  card_expiry_date?: InputMaybe<Order_By>
  card_last4_digits?: InputMaybe<Order_By>
  cko_session_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  custom_metadata?: InputMaybe<Order_By>
  customer_email?: InputMaybe<Order_By>
  customer_name?: InputMaybe<Order_By>
  customer_number?: InputMaybe<Order_By>
  error_code?: InputMaybe<Order_By>
  error_message?: InputMaybe<Order_By>
  external_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  is_junifer_payment?: InputMaybe<Order_By>
  junifer_payment_id?: InputMaybe<Order_By>
  junifer_payment_status?: InputMaybe<Order_By>
  notification_error?: InputMaybe<Order_By>
  notification_status?: InputMaybe<Order_By>
  payment_session_id?: InputMaybe<Order_By>
  reference?: InputMaybe<Order_By>
  request_type?: InputMaybe<Order_By>
  source?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  threeds_challenged_at?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  uploaded_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: card_payment_old */
export type Card_Payment_Old_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "card_payment_old" */
export enum Card_Payment_Old_Select_Column {
  /** column name */
  AccountId = "account_id",
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AgentEmail = "agent_email",
  /** column name */
  AgentName = "agent_name",
  /** column name */
  Amount = "amount",
  /** column name */
  AuthorisedAt = "authorised_at",
  /** column name */
  CardExpiryDate = "card_expiry_date",
  /** column name */
  CardLast4Digits = "card_last4_digits",
  /** column name */
  CkoSessionId = "cko_session_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomMetadata = "custom_metadata",
  /** column name */
  CustomerEmail = "customer_email",
  /** column name */
  CustomerName = "customer_name",
  /** column name */
  CustomerNumber = "customer_number",
  /** column name */
  ErrorCode = "error_code",
  /** column name */
  ErrorMessage = "error_message",
  /** column name */
  ExternalId = "external_id",
  /** column name */
  Id = "id",
  /** column name */
  IsJuniferPayment = "is_junifer_payment",
  /** column name */
  JuniferPaymentId = "junifer_payment_id",
  /** column name */
  JuniferPaymentStatus = "junifer_payment_status",
  /** column name */
  NotificationError = "notification_error",
  /** column name */
  NotificationStatus = "notification_status",
  /** column name */
  PaymentSessionId = "payment_session_id",
  /** column name */
  Reference = "reference",
  /** column name */
  RequestType = "request_type",
  /** column name */
  Source = "source",
  /** column name */
  Status = "status",
  /** column name */
  ThreedsChallengedAt = "threeds_challenged_at",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  UploadedAt = "uploaded_at",
  /** column name */
  UserId = "user_id",
}

/** input type for updating data in table "card_payment_old" */
export type Card_Payment_Old_Set_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  account_number?: InputMaybe<Scalars["String"]["input"]>
  agent_email?: InputMaybe<Scalars["String"]["input"]>
  agent_name?: InputMaybe<Scalars["String"]["input"]>
  amount?: InputMaybe<Scalars["bigint"]["input"]>
  authorised_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  card_expiry_date?: InputMaybe<Scalars["String"]["input"]>
  card_last4_digits?: InputMaybe<Scalars["String"]["input"]>
  cko_session_id?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  custom_metadata?: InputMaybe<Scalars["json"]["input"]>
  customer_email?: InputMaybe<Scalars["String"]["input"]>
  customer_name?: InputMaybe<Scalars["String"]["input"]>
  customer_number?: InputMaybe<Scalars["String"]["input"]>
  error_code?: InputMaybe<Scalars["String"]["input"]>
  error_message?: InputMaybe<Scalars["String"]["input"]>
  external_id?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  is_junifer_payment?: InputMaybe<Scalars["Boolean"]["input"]>
  junifer_payment_id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_payment_status?: InputMaybe<
    Scalars["junifer_payment_status"]["input"]
  >
  notification_error?: InputMaybe<Scalars["String"]["input"]>
  notification_status?: InputMaybe<
    Scalars["payment_notification_status"]["input"]
  >
  payment_session_id?: InputMaybe<Scalars["String"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  request_type?: InputMaybe<Scalars["payment_request_type"]["input"]>
  source?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["card_payment_status"]["input"]>
  threeds_challenged_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  uploaded_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate stddev on columns */
export type Card_Payment_Old_Stddev_Fields = {
  __typename?: "card_payment_old_stddev_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_payment_id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Card_Payment_Old_Stddev_Pop_Fields = {
  __typename?: "card_payment_old_stddev_pop_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_payment_id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Card_Payment_Old_Stddev_Samp_Fields = {
  __typename?: "card_payment_old_stddev_samp_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_payment_id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "card_payment_old" */
export type Card_Payment_Old_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Card_Payment_Old_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Card_Payment_Old_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  account_number?: InputMaybe<Scalars["String"]["input"]>
  agent_email?: InputMaybe<Scalars["String"]["input"]>
  agent_name?: InputMaybe<Scalars["String"]["input"]>
  amount?: InputMaybe<Scalars["bigint"]["input"]>
  authorised_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  card_expiry_date?: InputMaybe<Scalars["String"]["input"]>
  card_last4_digits?: InputMaybe<Scalars["String"]["input"]>
  cko_session_id?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  custom_metadata?: InputMaybe<Scalars["json"]["input"]>
  customer_email?: InputMaybe<Scalars["String"]["input"]>
  customer_name?: InputMaybe<Scalars["String"]["input"]>
  customer_number?: InputMaybe<Scalars["String"]["input"]>
  error_code?: InputMaybe<Scalars["String"]["input"]>
  error_message?: InputMaybe<Scalars["String"]["input"]>
  external_id?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  is_junifer_payment?: InputMaybe<Scalars["Boolean"]["input"]>
  junifer_payment_id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_payment_status?: InputMaybe<
    Scalars["junifer_payment_status"]["input"]
  >
  notification_error?: InputMaybe<Scalars["String"]["input"]>
  notification_status?: InputMaybe<
    Scalars["payment_notification_status"]["input"]
  >
  payment_session_id?: InputMaybe<Scalars["String"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  request_type?: InputMaybe<Scalars["payment_request_type"]["input"]>
  source?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["card_payment_status"]["input"]>
  threeds_challenged_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  uploaded_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate sum on columns */
export type Card_Payment_Old_Sum_Fields = {
  __typename?: "card_payment_old_sum_fields"
  account_id?: Maybe<Scalars["bigint"]["output"]>
  amount?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_payment_id?: Maybe<Scalars["bigint"]["output"]>
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "card_payment_old" */
export enum Card_Payment_Old_Update_Column {
  /** column name */
  AccountId = "account_id",
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AgentEmail = "agent_email",
  /** column name */
  AgentName = "agent_name",
  /** column name */
  Amount = "amount",
  /** column name */
  AuthorisedAt = "authorised_at",
  /** column name */
  CardExpiryDate = "card_expiry_date",
  /** column name */
  CardLast4Digits = "card_last4_digits",
  /** column name */
  CkoSessionId = "cko_session_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomMetadata = "custom_metadata",
  /** column name */
  CustomerEmail = "customer_email",
  /** column name */
  CustomerName = "customer_name",
  /** column name */
  CustomerNumber = "customer_number",
  /** column name */
  ErrorCode = "error_code",
  /** column name */
  ErrorMessage = "error_message",
  /** column name */
  ExternalId = "external_id",
  /** column name */
  Id = "id",
  /** column name */
  IsJuniferPayment = "is_junifer_payment",
  /** column name */
  JuniferPaymentId = "junifer_payment_id",
  /** column name */
  JuniferPaymentStatus = "junifer_payment_status",
  /** column name */
  NotificationError = "notification_error",
  /** column name */
  NotificationStatus = "notification_status",
  /** column name */
  PaymentSessionId = "payment_session_id",
  /** column name */
  Reference = "reference",
  /** column name */
  RequestType = "request_type",
  /** column name */
  Source = "source",
  /** column name */
  Status = "status",
  /** column name */
  ThreedsChallengedAt = "threeds_challenged_at",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  UploadedAt = "uploaded_at",
  /** column name */
  UserId = "user_id",
}

export type Card_Payment_Old_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Card_Payment_Old_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Card_Payment_Old_Set_Input>
  /** filter the rows which have to be updated */
  where: Card_Payment_Old_Bool_Exp
}

/** aggregate var_pop on columns */
export type Card_Payment_Old_Var_Pop_Fields = {
  __typename?: "card_payment_old_var_pop_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_payment_id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Card_Payment_Old_Var_Samp_Fields = {
  __typename?: "card_payment_old_var_samp_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_payment_id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Card_Payment_Old_Variance_Fields = {
  __typename?: "card_payment_old_variance_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_payment_id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** on_conflict condition type for table "card_payment" */
export type Card_Payment_On_Conflict = {
  constraint: Card_Payment_Constraint
  update_columns?: Array<Card_Payment_Update_Column>
  where?: InputMaybe<Card_Payment_Bool_Exp>
}

/** Ordering options when selecting data from "card_payment". */
export type Card_Payment_Order_By = {
  account_number?: InputMaybe<Order_By>
  authorised_at?: InputMaybe<Order_By>
  card_expiry_date?: InputMaybe<Order_By>
  card_last4_digits?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  customer_number?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  error_code?: InputMaybe<Order_By>
  error_message?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  junifer_payment_status?: InputMaybe<Order_By>
  reference?: InputMaybe<Order_By>
  source?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  threeds_challenged_at?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  uploaded_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: card_payment */
export type Card_Payment_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "card_payment" */
export enum Card_Payment_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AuthorisedAt = "authorised_at",
  /** column name */
  CardExpiryDate = "card_expiry_date",
  /** column name */
  CardLast4Digits = "card_last4_digits",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerNumber = "customer_number",
  /** column name */
  Deleted = "deleted",
  /** column name */
  ErrorCode = "error_code",
  /** column name */
  ErrorMessage = "error_message",
  /** column name */
  Id = "id",
  /** column name */
  JuniferPaymentStatus = "junifer_payment_status",
  /** column name */
  Reference = "reference",
  /** column name */
  Source = "source",
  /** column name */
  Status = "status",
  /** column name */
  ThreedsChallengedAt = "threeds_challenged_at",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  UploadedAt = "uploaded_at",
}

/** input type for updating data in table "card_payment" */
export type Card_Payment_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  authorised_at?: InputMaybe<Scalars["timestamp"]["input"]>
  card_expiry_date?: InputMaybe<Scalars["String"]["input"]>
  card_last4_digits?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_number?: InputMaybe<Scalars["String"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  error_code?: InputMaybe<Scalars["String"]["input"]>
  error_message?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_payment_status?: InputMaybe<
    Scalars["junifer_payment_status"]["input"]
  >
  reference?: InputMaybe<Scalars["String"]["input"]>
  source?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["card_payment_status"]["input"]>
  threeds_challenged_at?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  uploaded_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** Boolean expression to compare columns of type "card_payment_status". All fields are combined with logical 'AND'. */
export type Card_Payment_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["card_payment_status"]["input"]>
  _gt?: InputMaybe<Scalars["card_payment_status"]["input"]>
  _gte?: InputMaybe<Scalars["card_payment_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["card_payment_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["card_payment_status"]["input"]>
  _lte?: InputMaybe<Scalars["card_payment_status"]["input"]>
  _neq?: InputMaybe<Scalars["card_payment_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["card_payment_status"]["input"]>>
}

/** aggregate stddev on columns */
export type Card_Payment_Stddev_Fields = {
  __typename?: "card_payment_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Card_Payment_Stddev_Pop_Fields = {
  __typename?: "card_payment_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Card_Payment_Stddev_Samp_Fields = {
  __typename?: "card_payment_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "card_payment" */
export type Card_Payment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Card_Payment_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Card_Payment_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  authorised_at?: InputMaybe<Scalars["timestamp"]["input"]>
  card_expiry_date?: InputMaybe<Scalars["String"]["input"]>
  card_last4_digits?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_number?: InputMaybe<Scalars["String"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  error_code?: InputMaybe<Scalars["String"]["input"]>
  error_message?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_payment_status?: InputMaybe<
    Scalars["junifer_payment_status"]["input"]
  >
  reference?: InputMaybe<Scalars["String"]["input"]>
  source?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["card_payment_status"]["input"]>
  threeds_challenged_at?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  uploaded_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Card_Payment_Sum_Fields = {
  __typename?: "card_payment_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "card_payment" */
export enum Card_Payment_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AuthorisedAt = "authorised_at",
  /** column name */
  CardExpiryDate = "card_expiry_date",
  /** column name */
  CardLast4Digits = "card_last4_digits",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerNumber = "customer_number",
  /** column name */
  Deleted = "deleted",
  /** column name */
  ErrorCode = "error_code",
  /** column name */
  ErrorMessage = "error_message",
  /** column name */
  Id = "id",
  /** column name */
  JuniferPaymentStatus = "junifer_payment_status",
  /** column name */
  Reference = "reference",
  /** column name */
  Source = "source",
  /** column name */
  Status = "status",
  /** column name */
  ThreedsChallengedAt = "threeds_challenged_at",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  UploadedAt = "uploaded_at",
}

export type Card_Payment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Card_Payment_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Card_Payment_Set_Input>
  /** filter the rows which have to be updated */
  where: Card_Payment_Bool_Exp
}

/** aggregate var_pop on columns */
export type Card_Payment_Var_Pop_Fields = {
  __typename?: "card_payment_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Card_Payment_Var_Samp_Fields = {
  __typename?: "card_payment_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Card_Payment_Variance_Fields = {
  __typename?: "card_payment_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "cases" */
export type Cases = {
  __typename?: "cases"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  external_id: Scalars["String"]["output"]
  fields?: Maybe<Scalars["jsonb"]["output"]>
  id: Scalars["bigint"]["output"]
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** columns and relationships of "cases" */
export type CasesFieldsArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregated selection of "cases" */
export type Cases_Aggregate = {
  __typename?: "cases_aggregate"
  aggregate?: Maybe<Cases_Aggregate_Fields>
  nodes: Array<Cases>
}

/** aggregate fields of "cases" */
export type Cases_Aggregate_Fields = {
  __typename?: "cases_aggregate_fields"
  avg?: Maybe<Cases_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Cases_Max_Fields>
  min?: Maybe<Cases_Min_Fields>
  stddev?: Maybe<Cases_Stddev_Fields>
  stddev_pop?: Maybe<Cases_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Cases_Stddev_Samp_Fields>
  sum?: Maybe<Cases_Sum_Fields>
  var_pop?: Maybe<Cases_Var_Pop_Fields>
  var_samp?: Maybe<Cases_Var_Samp_Fields>
  variance?: Maybe<Cases_Variance_Fields>
}

/** aggregate fields of "cases" */
export type Cases_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cases_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Cases_Append_Input = {
  fields?: InputMaybe<Scalars["jsonb"]["input"]>
}

/** aggregate avg on columns */
export type Cases_Avg_Fields = {
  __typename?: "cases_avg_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "cases". All fields are combined with a logical 'AND'. */
export type Cases_Bool_Exp = {
  _and?: InputMaybe<Array<Cases_Bool_Exp>>
  _not?: InputMaybe<Cases_Bool_Exp>
  _or?: InputMaybe<Array<Cases_Bool_Exp>>
  billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>
  external_id?: InputMaybe<String_Comparison_Exp>
  fields?: InputMaybe<Jsonb_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "cases" */
export enum Cases_Constraint {
  /** unique or primary key constraint on columns "external_id" */
  CasesExternalIdKey1 = "cases_external_id_key1",
  /** unique or primary key constraint on columns "id" */
  PkCaseV2 = "pk_case_v2",
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Cases_Delete_At_Path_Input = {
  fields?: InputMaybe<Array<Scalars["String"]["input"]>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Cases_Delete_Elem_Input = {
  fields?: InputMaybe<Scalars["Int"]["input"]>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Cases_Delete_Key_Input = {
  fields?: InputMaybe<Scalars["String"]["input"]>
}

/** input type for incrementing numeric columns in table "cases" */
export type Cases_Inc_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "cases" */
export type Cases_Insert_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  external_id?: InputMaybe<Scalars["String"]["input"]>
  fields?: InputMaybe<Scalars["jsonb"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Cases_Max_Fields = {
  __typename?: "cases_max_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  external_id?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Cases_Min_Fields = {
  __typename?: "cases_min_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  external_id?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "cases" */
export type Cases_Mutation_Response = {
  __typename?: "cases_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Cases>
}

/** on_conflict condition type for table "cases" */
export type Cases_On_Conflict = {
  constraint: Cases_Constraint
  update_columns?: Array<Cases_Update_Column>
  where?: InputMaybe<Cases_Bool_Exp>
}

/** Ordering options when selecting data from "cases". */
export type Cases_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  external_id?: InputMaybe<Order_By>
  fields?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: cases */
export type Cases_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Cases_Prepend_Input = {
  fields?: InputMaybe<Scalars["jsonb"]["input"]>
}

/** select columns of table "cases" */
export enum Cases_Select_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  ExternalId = "external_id",
  /** column name */
  Fields = "fields",
  /** column name */
  Id = "id",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "cases" */
export type Cases_Set_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  external_id?: InputMaybe<Scalars["String"]["input"]>
  fields?: InputMaybe<Scalars["jsonb"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Cases_Stddev_Fields = {
  __typename?: "cases_stddev_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Cases_Stddev_Pop_Fields = {
  __typename?: "cases_stddev_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Cases_Stddev_Samp_Fields = {
  __typename?: "cases_stddev_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "cases" */
export type Cases_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cases_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Cases_Stream_Cursor_Value_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  external_id?: InputMaybe<Scalars["String"]["input"]>
  fields?: InputMaybe<Scalars["jsonb"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Cases_Sum_Fields = {
  __typename?: "cases_sum_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "cases" */
export enum Cases_Update_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  ExternalId = "external_id",
  /** column name */
  Fields = "fields",
  /** column name */
  Id = "id",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Cases_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Cases_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Cases_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Cases_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Cases_Delete_Key_Input>
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cases_Inc_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Cases_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cases_Set_Input>
  /** filter the rows which have to be updated */
  where: Cases_Bool_Exp
}

/** aggregate var_pop on columns */
export type Cases_Var_Pop_Fields = {
  __typename?: "cases_var_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Cases_Var_Samp_Fields = {
  __typename?: "cases_var_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Cases_Variance_Fields = {
  __typename?: "cases_variance_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "communication" */
export type Communication = {
  __typename?: "communication"
  content: Scalars["jsonb"]["output"]
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  external_identifier: Scalars["String"]["output"]
  group_id: Scalars["String"]["output"]
  id: Scalars["bigint"]["output"]
  received_at: Scalars["timestamp"]["output"]
  receiver_id: Scalars["String"]["output"]
  sender_id: Scalars["String"]["output"]
  state?: Maybe<Scalars["String"]["output"]>
  state_reason?: Maybe<Scalars["String"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "communication" */
export type CommunicationContentArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregated selection of "communication" */
export type Communication_Aggregate = {
  __typename?: "communication_aggregate"
  aggregate?: Maybe<Communication_Aggregate_Fields>
  nodes: Array<Communication>
}

/** aggregate fields of "communication" */
export type Communication_Aggregate_Fields = {
  __typename?: "communication_aggregate_fields"
  avg?: Maybe<Communication_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Communication_Max_Fields>
  min?: Maybe<Communication_Min_Fields>
  stddev?: Maybe<Communication_Stddev_Fields>
  stddev_pop?: Maybe<Communication_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Communication_Stddev_Samp_Fields>
  sum?: Maybe<Communication_Sum_Fields>
  var_pop?: Maybe<Communication_Var_Pop_Fields>
  var_samp?: Maybe<Communication_Var_Samp_Fields>
  variance?: Maybe<Communication_Variance_Fields>
}

/** aggregate fields of "communication" */
export type Communication_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Communication_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Communication_Append_Input = {
  content?: InputMaybe<Scalars["jsonb"]["input"]>
}

/** aggregate avg on columns */
export type Communication_Avg_Fields = {
  __typename?: "communication_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "communication". All fields are combined with a logical 'AND'. */
export type Communication_Bool_Exp = {
  _and?: InputMaybe<Array<Communication_Bool_Exp>>
  _not?: InputMaybe<Communication_Bool_Exp>
  _or?: InputMaybe<Array<Communication_Bool_Exp>>
  content?: InputMaybe<Jsonb_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  external_identifier?: InputMaybe<String_Comparison_Exp>
  group_id?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  received_at?: InputMaybe<Timestamp_Comparison_Exp>
  receiver_id?: InputMaybe<String_Comparison_Exp>
  sender_id?: InputMaybe<String_Comparison_Exp>
  state?: InputMaybe<String_Comparison_Exp>
  state_reason?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "communication" */
export enum Communication_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkCommunication = "pk_communication",
  /** unique or primary key constraint on columns "external_identifier" */
  UniqueExternalIdentifier = "unique_external_identifier",
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Communication_Delete_At_Path_Input = {
  content?: InputMaybe<Array<Scalars["String"]["input"]>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Communication_Delete_Elem_Input = {
  content?: InputMaybe<Scalars["Int"]["input"]>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Communication_Delete_Key_Input = {
  content?: InputMaybe<Scalars["String"]["input"]>
}

/** input type for incrementing numeric columns in table "communication" */
export type Communication_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "communication" */
export type Communication_Insert_Input = {
  content?: InputMaybe<Scalars["jsonb"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  external_identifier?: InputMaybe<Scalars["String"]["input"]>
  group_id?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  received_at?: InputMaybe<Scalars["timestamp"]["input"]>
  receiver_id?: InputMaybe<Scalars["String"]["input"]>
  sender_id?: InputMaybe<Scalars["String"]["input"]>
  state?: InputMaybe<Scalars["String"]["input"]>
  state_reason?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Communication_Max_Fields = {
  __typename?: "communication_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  external_identifier?: Maybe<Scalars["String"]["output"]>
  group_id?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  received_at?: Maybe<Scalars["timestamp"]["output"]>
  receiver_id?: Maybe<Scalars["String"]["output"]>
  sender_id?: Maybe<Scalars["String"]["output"]>
  state?: Maybe<Scalars["String"]["output"]>
  state_reason?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** columns and relationships of "communication_metadata" */
export type Communication_Metadata = {
  __typename?: "communication_metadata"
  communication_id: Scalars["bigint"]["output"]
  created_at: Scalars["timestamp"]["output"]
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  source?: Maybe<Scalars["String"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "communication_metadata" */
export type Communication_Metadata_Aggregate = {
  __typename?: "communication_metadata_aggregate"
  aggregate?: Maybe<Communication_Metadata_Aggregate_Fields>
  nodes: Array<Communication_Metadata>
}

/** aggregate fields of "communication_metadata" */
export type Communication_Metadata_Aggregate_Fields = {
  __typename?: "communication_metadata_aggregate_fields"
  avg?: Maybe<Communication_Metadata_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Communication_Metadata_Max_Fields>
  min?: Maybe<Communication_Metadata_Min_Fields>
  stddev?: Maybe<Communication_Metadata_Stddev_Fields>
  stddev_pop?: Maybe<Communication_Metadata_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Communication_Metadata_Stddev_Samp_Fields>
  sum?: Maybe<Communication_Metadata_Sum_Fields>
  var_pop?: Maybe<Communication_Metadata_Var_Pop_Fields>
  var_samp?: Maybe<Communication_Metadata_Var_Samp_Fields>
  variance?: Maybe<Communication_Metadata_Variance_Fields>
}

/** aggregate fields of "communication_metadata" */
export type Communication_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Communication_Metadata_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Communication_Metadata_Avg_Fields = {
  __typename?: "communication_metadata_avg_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "communication_metadata". All fields are combined with a logical 'AND'. */
export type Communication_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Communication_Metadata_Bool_Exp>>
  _not?: InputMaybe<Communication_Metadata_Bool_Exp>
  _or?: InputMaybe<Array<Communication_Metadata_Bool_Exp>>
  communication_id?: InputMaybe<Bigint_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  customer_id?: InputMaybe<Bigint_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  source?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "communication_metadata" */
export enum Communication_Metadata_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkCommunicationMetadata = "pk_communication_metadata",
  /** unique or primary key constraint on columns "communication_id" */
  UniqueCommunicationId = "unique_communication_id",
}

/** input type for incrementing numeric columns in table "communication_metadata" */
export type Communication_Metadata_Inc_Input = {
  communication_id?: InputMaybe<Scalars["bigint"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "communication_metadata" */
export type Communication_Metadata_Insert_Input = {
  communication_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  source?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Communication_Metadata_Max_Fields = {
  __typename?: "communication_metadata_max_fields"
  communication_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  source?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Communication_Metadata_Min_Fields = {
  __typename?: "communication_metadata_min_fields"
  communication_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  source?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "communication_metadata" */
export type Communication_Metadata_Mutation_Response = {
  __typename?: "communication_metadata_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Communication_Metadata>
}

/** on_conflict condition type for table "communication_metadata" */
export type Communication_Metadata_On_Conflict = {
  constraint: Communication_Metadata_Constraint
  update_columns?: Array<Communication_Metadata_Update_Column>
  where?: InputMaybe<Communication_Metadata_Bool_Exp>
}

/** Ordering options when selecting data from "communication_metadata". */
export type Communication_Metadata_Order_By = {
  communication_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  source?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: communication_metadata */
export type Communication_Metadata_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "communication_metadata" */
export enum Communication_Metadata_Select_Column {
  /** column name */
  CommunicationId = "communication_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  Source = "source",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "communication_metadata" */
export type Communication_Metadata_Set_Input = {
  communication_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  source?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Communication_Metadata_Stddev_Fields = {
  __typename?: "communication_metadata_stddev_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Communication_Metadata_Stddev_Pop_Fields = {
  __typename?: "communication_metadata_stddev_pop_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Communication_Metadata_Stddev_Samp_Fields = {
  __typename?: "communication_metadata_stddev_samp_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "communication_metadata" */
export type Communication_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Communication_Metadata_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Communication_Metadata_Stream_Cursor_Value_Input = {
  communication_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  source?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Communication_Metadata_Sum_Fields = {
  __typename?: "communication_metadata_sum_fields"
  communication_id?: Maybe<Scalars["bigint"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "communication_metadata" */
export enum Communication_Metadata_Update_Column {
  /** column name */
  CommunicationId = "communication_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  Source = "source",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Communication_Metadata_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Communication_Metadata_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Communication_Metadata_Set_Input>
  /** filter the rows which have to be updated */
  where: Communication_Metadata_Bool_Exp
}

/** aggregate var_pop on columns */
export type Communication_Metadata_Var_Pop_Fields = {
  __typename?: "communication_metadata_var_pop_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Communication_Metadata_Var_Samp_Fields = {
  __typename?: "communication_metadata_var_samp_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Communication_Metadata_Variance_Fields = {
  __typename?: "communication_metadata_variance_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate min on columns */
export type Communication_Min_Fields = {
  __typename?: "communication_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  external_identifier?: Maybe<Scalars["String"]["output"]>
  group_id?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  received_at?: Maybe<Scalars["timestamp"]["output"]>
  receiver_id?: Maybe<Scalars["String"]["output"]>
  sender_id?: Maybe<Scalars["String"]["output"]>
  state?: Maybe<Scalars["String"]["output"]>
  state_reason?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "communication" */
export type Communication_Mutation_Response = {
  __typename?: "communication_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Communication>
}

/** on_conflict condition type for table "communication" */
export type Communication_On_Conflict = {
  constraint: Communication_Constraint
  update_columns?: Array<Communication_Update_Column>
  where?: InputMaybe<Communication_Bool_Exp>
}

/** Ordering options when selecting data from "communication". */
export type Communication_Order_By = {
  content?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  external_identifier?: InputMaybe<Order_By>
  group_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  received_at?: InputMaybe<Order_By>
  receiver_id?: InputMaybe<Order_By>
  sender_id?: InputMaybe<Order_By>
  state?: InputMaybe<Order_By>
  state_reason?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: communication */
export type Communication_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Communication_Prepend_Input = {
  content?: InputMaybe<Scalars["jsonb"]["input"]>
}

/** select columns of table "communication" */
export enum Communication_Select_Column {
  /** column name */
  Content = "content",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  ExternalIdentifier = "external_identifier",
  /** column name */
  GroupId = "group_id",
  /** column name */
  Id = "id",
  /** column name */
  ReceivedAt = "received_at",
  /** column name */
  ReceiverId = "receiver_id",
  /** column name */
  SenderId = "sender_id",
  /** column name */
  State = "state",
  /** column name */
  StateReason = "state_reason",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "communication" */
export type Communication_Set_Input = {
  content?: InputMaybe<Scalars["jsonb"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  external_identifier?: InputMaybe<Scalars["String"]["input"]>
  group_id?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  received_at?: InputMaybe<Scalars["timestamp"]["input"]>
  receiver_id?: InputMaybe<Scalars["String"]["input"]>
  sender_id?: InputMaybe<Scalars["String"]["input"]>
  state?: InputMaybe<Scalars["String"]["input"]>
  state_reason?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Communication_Stddev_Fields = {
  __typename?: "communication_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Communication_Stddev_Pop_Fields = {
  __typename?: "communication_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Communication_Stddev_Samp_Fields = {
  __typename?: "communication_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "communication" */
export type Communication_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Communication_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Communication_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars["jsonb"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  external_identifier?: InputMaybe<Scalars["String"]["input"]>
  group_id?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  received_at?: InputMaybe<Scalars["timestamp"]["input"]>
  receiver_id?: InputMaybe<Scalars["String"]["input"]>
  sender_id?: InputMaybe<Scalars["String"]["input"]>
  state?: InputMaybe<Scalars["String"]["input"]>
  state_reason?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Communication_Sum_Fields = {
  __typename?: "communication_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** Boolean expression to compare columns of type "communication_type". All fields are combined with logical 'AND'. */
export type Communication_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["communication_type"]["input"]>
  _gt?: InputMaybe<Scalars["communication_type"]["input"]>
  _gte?: InputMaybe<Scalars["communication_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["communication_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["communication_type"]["input"]>
  _lte?: InputMaybe<Scalars["communication_type"]["input"]>
  _neq?: InputMaybe<Scalars["communication_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["communication_type"]["input"]>>
}

/** update columns of table "communication" */
export enum Communication_Update_Column {
  /** column name */
  Content = "content",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  ExternalIdentifier = "external_identifier",
  /** column name */
  GroupId = "group_id",
  /** column name */
  Id = "id",
  /** column name */
  ReceivedAt = "received_at",
  /** column name */
  ReceiverId = "receiver_id",
  /** column name */
  SenderId = "sender_id",
  /** column name */
  State = "state",
  /** column name */
  StateReason = "state_reason",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Communication_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Communication_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Communication_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Communication_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Communication_Delete_Key_Input>
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Communication_Inc_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Communication_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Communication_Set_Input>
  /** filter the rows which have to be updated */
  where: Communication_Bool_Exp
}

/** aggregate var_pop on columns */
export type Communication_Var_Pop_Fields = {
  __typename?: "communication_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Communication_Var_Samp_Fields = {
  __typename?: "communication_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Communication_Variance_Fields = {
  __typename?: "communication_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "communications" */
export type Communications = {
  __typename?: "communications"
  communication_type: Scalars["communication_type"]["output"]
  id: Scalars["bigint"]["output"]
  name: Scalars["String"]["output"]
}

/** aggregated selection of "communications" */
export type Communications_Aggregate = {
  __typename?: "communications_aggregate"
  aggregate?: Maybe<Communications_Aggregate_Fields>
  nodes: Array<Communications>
}

/** aggregate fields of "communications" */
export type Communications_Aggregate_Fields = {
  __typename?: "communications_aggregate_fields"
  avg?: Maybe<Communications_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Communications_Max_Fields>
  min?: Maybe<Communications_Min_Fields>
  stddev?: Maybe<Communications_Stddev_Fields>
  stddev_pop?: Maybe<Communications_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Communications_Stddev_Samp_Fields>
  sum?: Maybe<Communications_Sum_Fields>
  var_pop?: Maybe<Communications_Var_Pop_Fields>
  var_samp?: Maybe<Communications_Var_Samp_Fields>
  variance?: Maybe<Communications_Variance_Fields>
}

/** aggregate fields of "communications" */
export type Communications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Communications_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Communications_Avg_Fields = {
  __typename?: "communications_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "communications". All fields are combined with a logical 'AND'. */
export type Communications_Bool_Exp = {
  _and?: InputMaybe<Array<Communications_Bool_Exp>>
  _not?: InputMaybe<Communications_Bool_Exp>
  _or?: InputMaybe<Array<Communications_Bool_Exp>>
  communication_type?: InputMaybe<Communication_Type_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "communications" */
export enum Communications_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkCommunications = "pk_communications",
}

/** input type for incrementing numeric columns in table "communications" */
export type Communications_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "communications" */
export type Communications_Insert_Input = {
  communication_type?: InputMaybe<Scalars["communication_type"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Communications_Max_Fields = {
  __typename?: "communications_max_fields"
  communication_type?: Maybe<Scalars["communication_type"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Communications_Min_Fields = {
  __typename?: "communications_min_fields"
  communication_type?: Maybe<Scalars["communication_type"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "communications" */
export type Communications_Mutation_Response = {
  __typename?: "communications_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Communications>
}

/** input type for inserting object relation for remote table "communications" */
export type Communications_Obj_Rel_Insert_Input = {
  data: Communications_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Communications_On_Conflict>
}

/** on_conflict condition type for table "communications" */
export type Communications_On_Conflict = {
  constraint: Communications_Constraint
  update_columns?: Array<Communications_Update_Column>
  where?: InputMaybe<Communications_Bool_Exp>
}

/** Ordering options when selecting data from "communications". */
export type Communications_Order_By = {
  communication_type?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
}

/** primary key columns input for table: communications */
export type Communications_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "communications" */
export enum Communications_Select_Column {
  /** column name */
  CommunicationType = "communication_type",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
}

/** input type for updating data in table "communications" */
export type Communications_Set_Input = {
  communication_type?: InputMaybe<Scalars["communication_type"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Communications_Stddev_Fields = {
  __typename?: "communications_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Communications_Stddev_Pop_Fields = {
  __typename?: "communications_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Communications_Stddev_Samp_Fields = {
  __typename?: "communications_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "communications" */
export type Communications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Communications_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Communications_Stream_Cursor_Value_Input = {
  communication_type?: InputMaybe<Scalars["communication_type"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Communications_Sum_Fields = {
  __typename?: "communications_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "communications" */
export enum Communications_Update_Column {
  /** column name */
  CommunicationType = "communication_type",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
}

export type Communications_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Communications_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Communications_Set_Input>
  /** filter the rows which have to be updated */
  where: Communications_Bool_Exp
}

/** aggregate var_pop on columns */
export type Communications_Var_Pop_Fields = {
  __typename?: "communications_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Communications_Var_Samp_Fields = {
  __typename?: "communications_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Communications_Variance_Fields = {
  __typename?: "communications_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "complaint" */
export type Complaint = {
  __typename?: "complaint"
  agent_email?: Maybe<Scalars["String"]["output"]>
  agent_name?: Maybe<Scalars["String"]["output"]>
  category1?: Maybe<Scalars["String"]["output"]>
  category2?: Maybe<Scalars["String"]["output"]>
  category3?: Maybe<Scalars["String"]["output"]>
  channel?: Maybe<Scalars["String"]["output"]>
  closed_at?: Maybe<Scalars["timestamp"]["output"]>
  complaints_goodwill_amount?: Maybe<Scalars["numeric"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  d1_signposting_comms_sent: Scalars["Boolean"]["output"]
  d56_signposting_comms_sent: Scalars["Boolean"]["output"]
  date_raised?: Maybe<Scalars["timestamp"]["output"]>
  deadlock_comms_sent: Scalars["Boolean"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  details?: Maybe<Scalars["jsonb"]["output"]>
  external_identifier?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  internal_complaint_category?: Maybe<Scalars["String"]["output"]>
  ofgem_mapped_complaint_category?: Maybe<Scalars["String"]["output"]>
  ombudsman_case?: Maybe<Scalars["Boolean"]["output"]>
  overdue_signposting_comms_sent: Scalars["Boolean"]["output"]
  recent_signposting_comms_sent: Scalars["Boolean"]["output"]
  send_date_of_d1_signposting_comms?: Maybe<Scalars["timestamp"]["output"]>
  send_date_of_d56_signposting_comms?: Maybe<Scalars["timestamp"]["output"]>
  send_date_of_overdue_signposting_comms?: Maybe<Scalars["timestamp"]["output"]>
  send_date_of_recent_signposting_comms?: Maybe<Scalars["timestamp"]["output"]>
  source?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  sub_status?: Maybe<Scalars["String"]["output"]>
  team?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "complaint" */
export type ComplaintDetailsArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregated selection of "complaint" */
export type Complaint_Aggregate = {
  __typename?: "complaint_aggregate"
  aggregate?: Maybe<Complaint_Aggregate_Fields>
  nodes: Array<Complaint>
}

/** aggregate fields of "complaint" */
export type Complaint_Aggregate_Fields = {
  __typename?: "complaint_aggregate_fields"
  avg?: Maybe<Complaint_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Complaint_Max_Fields>
  min?: Maybe<Complaint_Min_Fields>
  stddev?: Maybe<Complaint_Stddev_Fields>
  stddev_pop?: Maybe<Complaint_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Complaint_Stddev_Samp_Fields>
  sum?: Maybe<Complaint_Sum_Fields>
  var_pop?: Maybe<Complaint_Var_Pop_Fields>
  var_samp?: Maybe<Complaint_Var_Samp_Fields>
  variance?: Maybe<Complaint_Variance_Fields>
}

/** aggregate fields of "complaint" */
export type Complaint_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Complaint_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** columns and relationships of "complaint_aggregations" */
export type Complaint_Aggregations = {
  __typename?: "complaint_aggregations"
  cab?: Maybe<Scalars["bigint"]["output"]>
  ehu?: Maybe<Scalars["bigint"]["output"]>
  exec?: Maybe<Scalars["bigint"]["output"]>
  newer_than_5_weeks?: Maybe<Scalars["bigint"]["output"]>
  older_than_5_weeks?: Maybe<Scalars["bigint"]["output"]>
  ombudsman?: Maybe<Scalars["bigint"]["output"]>
  open?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregated selection of "complaint_aggregations" */
export type Complaint_Aggregations_Aggregate = {
  __typename?: "complaint_aggregations_aggregate"
  aggregate?: Maybe<Complaint_Aggregations_Aggregate_Fields>
  nodes: Array<Complaint_Aggregations>
}

/** aggregate fields of "complaint_aggregations" */
export type Complaint_Aggregations_Aggregate_Fields = {
  __typename?: "complaint_aggregations_aggregate_fields"
  avg?: Maybe<Complaint_Aggregations_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Complaint_Aggregations_Max_Fields>
  min?: Maybe<Complaint_Aggregations_Min_Fields>
  stddev?: Maybe<Complaint_Aggregations_Stddev_Fields>
  stddev_pop?: Maybe<Complaint_Aggregations_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Complaint_Aggregations_Stddev_Samp_Fields>
  sum?: Maybe<Complaint_Aggregations_Sum_Fields>
  var_pop?: Maybe<Complaint_Aggregations_Var_Pop_Fields>
  var_samp?: Maybe<Complaint_Aggregations_Var_Samp_Fields>
  variance?: Maybe<Complaint_Aggregations_Variance_Fields>
}

/** aggregate fields of "complaint_aggregations" */
export type Complaint_Aggregations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Complaint_Aggregations_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Complaint_Aggregations_Avg_Fields = {
  __typename?: "complaint_aggregations_avg_fields"
  cab?: Maybe<Scalars["Float"]["output"]>
  ehu?: Maybe<Scalars["Float"]["output"]>
  exec?: Maybe<Scalars["Float"]["output"]>
  newer_than_5_weeks?: Maybe<Scalars["Float"]["output"]>
  older_than_5_weeks?: Maybe<Scalars["Float"]["output"]>
  ombudsman?: Maybe<Scalars["Float"]["output"]>
  open?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "complaint_aggregations". All fields are combined with a logical 'AND'. */
export type Complaint_Aggregations_Bool_Exp = {
  _and?: InputMaybe<Array<Complaint_Aggregations_Bool_Exp>>
  _not?: InputMaybe<Complaint_Aggregations_Bool_Exp>
  _or?: InputMaybe<Array<Complaint_Aggregations_Bool_Exp>>
  cab?: InputMaybe<Bigint_Comparison_Exp>
  ehu?: InputMaybe<Bigint_Comparison_Exp>
  exec?: InputMaybe<Bigint_Comparison_Exp>
  newer_than_5_weeks?: InputMaybe<Bigint_Comparison_Exp>
  older_than_5_weeks?: InputMaybe<Bigint_Comparison_Exp>
  ombudsman?: InputMaybe<Bigint_Comparison_Exp>
  open?: InputMaybe<Bigint_Comparison_Exp>
}

/** aggregate max on columns */
export type Complaint_Aggregations_Max_Fields = {
  __typename?: "complaint_aggregations_max_fields"
  cab?: Maybe<Scalars["bigint"]["output"]>
  ehu?: Maybe<Scalars["bigint"]["output"]>
  exec?: Maybe<Scalars["bigint"]["output"]>
  newer_than_5_weeks?: Maybe<Scalars["bigint"]["output"]>
  older_than_5_weeks?: Maybe<Scalars["bigint"]["output"]>
  ombudsman?: Maybe<Scalars["bigint"]["output"]>
  open?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregate min on columns */
export type Complaint_Aggregations_Min_Fields = {
  __typename?: "complaint_aggregations_min_fields"
  cab?: Maybe<Scalars["bigint"]["output"]>
  ehu?: Maybe<Scalars["bigint"]["output"]>
  exec?: Maybe<Scalars["bigint"]["output"]>
  newer_than_5_weeks?: Maybe<Scalars["bigint"]["output"]>
  older_than_5_weeks?: Maybe<Scalars["bigint"]["output"]>
  ombudsman?: Maybe<Scalars["bigint"]["output"]>
  open?: Maybe<Scalars["bigint"]["output"]>
}

/** Ordering options when selecting data from "complaint_aggregations". */
export type Complaint_Aggregations_Order_By = {
  cab?: InputMaybe<Order_By>
  ehu?: InputMaybe<Order_By>
  exec?: InputMaybe<Order_By>
  newer_than_5_weeks?: InputMaybe<Order_By>
  older_than_5_weeks?: InputMaybe<Order_By>
  ombudsman?: InputMaybe<Order_By>
  open?: InputMaybe<Order_By>
}

/** select columns of table "complaint_aggregations" */
export enum Complaint_Aggregations_Select_Column {
  /** column name */
  Cab = "cab",
  /** column name */
  Ehu = "ehu",
  /** column name */
  Exec = "exec",
  /** column name */
  NewerThan_5Weeks = "newer_than_5_weeks",
  /** column name */
  OlderThan_5Weeks = "older_than_5_weeks",
  /** column name */
  Ombudsman = "ombudsman",
  /** column name */
  Open = "open",
}

/** aggregate stddev on columns */
export type Complaint_Aggregations_Stddev_Fields = {
  __typename?: "complaint_aggregations_stddev_fields"
  cab?: Maybe<Scalars["Float"]["output"]>
  ehu?: Maybe<Scalars["Float"]["output"]>
  exec?: Maybe<Scalars["Float"]["output"]>
  newer_than_5_weeks?: Maybe<Scalars["Float"]["output"]>
  older_than_5_weeks?: Maybe<Scalars["Float"]["output"]>
  ombudsman?: Maybe<Scalars["Float"]["output"]>
  open?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Complaint_Aggregations_Stddev_Pop_Fields = {
  __typename?: "complaint_aggregations_stddev_pop_fields"
  cab?: Maybe<Scalars["Float"]["output"]>
  ehu?: Maybe<Scalars["Float"]["output"]>
  exec?: Maybe<Scalars["Float"]["output"]>
  newer_than_5_weeks?: Maybe<Scalars["Float"]["output"]>
  older_than_5_weeks?: Maybe<Scalars["Float"]["output"]>
  ombudsman?: Maybe<Scalars["Float"]["output"]>
  open?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Complaint_Aggregations_Stddev_Samp_Fields = {
  __typename?: "complaint_aggregations_stddev_samp_fields"
  cab?: Maybe<Scalars["Float"]["output"]>
  ehu?: Maybe<Scalars["Float"]["output"]>
  exec?: Maybe<Scalars["Float"]["output"]>
  newer_than_5_weeks?: Maybe<Scalars["Float"]["output"]>
  older_than_5_weeks?: Maybe<Scalars["Float"]["output"]>
  ombudsman?: Maybe<Scalars["Float"]["output"]>
  open?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "complaint_aggregations" */
export type Complaint_Aggregations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Complaint_Aggregations_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Complaint_Aggregations_Stream_Cursor_Value_Input = {
  cab?: InputMaybe<Scalars["bigint"]["input"]>
  ehu?: InputMaybe<Scalars["bigint"]["input"]>
  exec?: InputMaybe<Scalars["bigint"]["input"]>
  newer_than_5_weeks?: InputMaybe<Scalars["bigint"]["input"]>
  older_than_5_weeks?: InputMaybe<Scalars["bigint"]["input"]>
  ombudsman?: InputMaybe<Scalars["bigint"]["input"]>
  open?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate sum on columns */
export type Complaint_Aggregations_Sum_Fields = {
  __typename?: "complaint_aggregations_sum_fields"
  cab?: Maybe<Scalars["bigint"]["output"]>
  ehu?: Maybe<Scalars["bigint"]["output"]>
  exec?: Maybe<Scalars["bigint"]["output"]>
  newer_than_5_weeks?: Maybe<Scalars["bigint"]["output"]>
  older_than_5_weeks?: Maybe<Scalars["bigint"]["output"]>
  ombudsman?: Maybe<Scalars["bigint"]["output"]>
  open?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregate var_pop on columns */
export type Complaint_Aggregations_Var_Pop_Fields = {
  __typename?: "complaint_aggregations_var_pop_fields"
  cab?: Maybe<Scalars["Float"]["output"]>
  ehu?: Maybe<Scalars["Float"]["output"]>
  exec?: Maybe<Scalars["Float"]["output"]>
  newer_than_5_weeks?: Maybe<Scalars["Float"]["output"]>
  older_than_5_weeks?: Maybe<Scalars["Float"]["output"]>
  ombudsman?: Maybe<Scalars["Float"]["output"]>
  open?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Complaint_Aggregations_Var_Samp_Fields = {
  __typename?: "complaint_aggregations_var_samp_fields"
  cab?: Maybe<Scalars["Float"]["output"]>
  ehu?: Maybe<Scalars["Float"]["output"]>
  exec?: Maybe<Scalars["Float"]["output"]>
  newer_than_5_weeks?: Maybe<Scalars["Float"]["output"]>
  older_than_5_weeks?: Maybe<Scalars["Float"]["output"]>
  ombudsman?: Maybe<Scalars["Float"]["output"]>
  open?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Complaint_Aggregations_Variance_Fields = {
  __typename?: "complaint_aggregations_variance_fields"
  cab?: Maybe<Scalars["Float"]["output"]>
  ehu?: Maybe<Scalars["Float"]["output"]>
  exec?: Maybe<Scalars["Float"]["output"]>
  newer_than_5_weeks?: Maybe<Scalars["Float"]["output"]>
  older_than_5_weeks?: Maybe<Scalars["Float"]["output"]>
  ombudsman?: Maybe<Scalars["Float"]["output"]>
  open?: Maybe<Scalars["Float"]["output"]>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Complaint_Append_Input = {
  details?: InputMaybe<Scalars["jsonb"]["input"]>
}

/** aggregate avg on columns */
export type Complaint_Avg_Fields = {
  __typename?: "complaint_avg_fields"
  complaints_goodwill_amount?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "complaint". All fields are combined with a logical 'AND'. */
export type Complaint_Bool_Exp = {
  _and?: InputMaybe<Array<Complaint_Bool_Exp>>
  _not?: InputMaybe<Complaint_Bool_Exp>
  _or?: InputMaybe<Array<Complaint_Bool_Exp>>
  agent_email?: InputMaybe<String_Comparison_Exp>
  agent_name?: InputMaybe<String_Comparison_Exp>
  category1?: InputMaybe<String_Comparison_Exp>
  category2?: InputMaybe<String_Comparison_Exp>
  category3?: InputMaybe<String_Comparison_Exp>
  channel?: InputMaybe<String_Comparison_Exp>
  closed_at?: InputMaybe<Timestamp_Comparison_Exp>
  complaints_goodwill_amount?: InputMaybe<Numeric_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  customer_id?: InputMaybe<Bigint_Comparison_Exp>
  d1_signposting_comms_sent?: InputMaybe<Boolean_Comparison_Exp>
  d56_signposting_comms_sent?: InputMaybe<Boolean_Comparison_Exp>
  date_raised?: InputMaybe<Timestamp_Comparison_Exp>
  deadlock_comms_sent?: InputMaybe<Boolean_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  details?: InputMaybe<Jsonb_Comparison_Exp>
  external_identifier?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  internal_complaint_category?: InputMaybe<String_Comparison_Exp>
  ofgem_mapped_complaint_category?: InputMaybe<String_Comparison_Exp>
  ombudsman_case?: InputMaybe<Boolean_Comparison_Exp>
  overdue_signposting_comms_sent?: InputMaybe<Boolean_Comparison_Exp>
  recent_signposting_comms_sent?: InputMaybe<Boolean_Comparison_Exp>
  send_date_of_d1_signposting_comms?: InputMaybe<Timestamp_Comparison_Exp>
  send_date_of_d56_signposting_comms?: InputMaybe<Timestamp_Comparison_Exp>
  send_date_of_overdue_signposting_comms?: InputMaybe<Timestamp_Comparison_Exp>
  send_date_of_recent_signposting_comms?: InputMaybe<Timestamp_Comparison_Exp>
  source?: InputMaybe<String_Comparison_Exp>
  status?: InputMaybe<String_Comparison_Exp>
  sub_status?: InputMaybe<String_Comparison_Exp>
  team?: InputMaybe<String_Comparison_Exp>
  type?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "complaint" */
export enum Complaint_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkComplaint = "pk_complaint",
  /** unique or primary key constraint on columns "external_identifier" */
  UniqueComplaintExternalIdentifier = "unique_complaint_external_identifier",
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Complaint_Delete_At_Path_Input = {
  details?: InputMaybe<Array<Scalars["String"]["input"]>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Complaint_Delete_Elem_Input = {
  details?: InputMaybe<Scalars["Int"]["input"]>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Complaint_Delete_Key_Input = {
  details?: InputMaybe<Scalars["String"]["input"]>
}

/** input type for incrementing numeric columns in table "complaint" */
export type Complaint_Inc_Input = {
  complaints_goodwill_amount?: InputMaybe<Scalars["numeric"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "complaint" */
export type Complaint_Insert_Input = {
  agent_email?: InputMaybe<Scalars["String"]["input"]>
  agent_name?: InputMaybe<Scalars["String"]["input"]>
  category1?: InputMaybe<Scalars["String"]["input"]>
  category2?: InputMaybe<Scalars["String"]["input"]>
  category3?: InputMaybe<Scalars["String"]["input"]>
  channel?: InputMaybe<Scalars["String"]["input"]>
  closed_at?: InputMaybe<Scalars["timestamp"]["input"]>
  complaints_goodwill_amount?: InputMaybe<Scalars["numeric"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  d1_signposting_comms_sent?: InputMaybe<Scalars["Boolean"]["input"]>
  d56_signposting_comms_sent?: InputMaybe<Scalars["Boolean"]["input"]>
  date_raised?: InputMaybe<Scalars["timestamp"]["input"]>
  deadlock_comms_sent?: InputMaybe<Scalars["Boolean"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  details?: InputMaybe<Scalars["jsonb"]["input"]>
  external_identifier?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  internal_complaint_category?: InputMaybe<Scalars["String"]["input"]>
  ofgem_mapped_complaint_category?: InputMaybe<Scalars["String"]["input"]>
  ombudsman_case?: InputMaybe<Scalars["Boolean"]["input"]>
  overdue_signposting_comms_sent?: InputMaybe<Scalars["Boolean"]["input"]>
  recent_signposting_comms_sent?: InputMaybe<Scalars["Boolean"]["input"]>
  send_date_of_d1_signposting_comms?: InputMaybe<Scalars["timestamp"]["input"]>
  send_date_of_d56_signposting_comms?: InputMaybe<Scalars["timestamp"]["input"]>
  send_date_of_overdue_signposting_comms?: InputMaybe<
    Scalars["timestamp"]["input"]
  >
  send_date_of_recent_signposting_comms?: InputMaybe<
    Scalars["timestamp"]["input"]
  >
  source?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  sub_status?: InputMaybe<Scalars["String"]["input"]>
  team?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Complaint_Max_Fields = {
  __typename?: "complaint_max_fields"
  agent_email?: Maybe<Scalars["String"]["output"]>
  agent_name?: Maybe<Scalars["String"]["output"]>
  category1?: Maybe<Scalars["String"]["output"]>
  category2?: Maybe<Scalars["String"]["output"]>
  category3?: Maybe<Scalars["String"]["output"]>
  channel?: Maybe<Scalars["String"]["output"]>
  closed_at?: Maybe<Scalars["timestamp"]["output"]>
  complaints_goodwill_amount?: Maybe<Scalars["numeric"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  date_raised?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  external_identifier?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  internal_complaint_category?: Maybe<Scalars["String"]["output"]>
  ofgem_mapped_complaint_category?: Maybe<Scalars["String"]["output"]>
  send_date_of_d1_signposting_comms?: Maybe<Scalars["timestamp"]["output"]>
  send_date_of_d56_signposting_comms?: Maybe<Scalars["timestamp"]["output"]>
  send_date_of_overdue_signposting_comms?: Maybe<Scalars["timestamp"]["output"]>
  send_date_of_recent_signposting_comms?: Maybe<Scalars["timestamp"]["output"]>
  source?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  sub_status?: Maybe<Scalars["String"]["output"]>
  team?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Complaint_Min_Fields = {
  __typename?: "complaint_min_fields"
  agent_email?: Maybe<Scalars["String"]["output"]>
  agent_name?: Maybe<Scalars["String"]["output"]>
  category1?: Maybe<Scalars["String"]["output"]>
  category2?: Maybe<Scalars["String"]["output"]>
  category3?: Maybe<Scalars["String"]["output"]>
  channel?: Maybe<Scalars["String"]["output"]>
  closed_at?: Maybe<Scalars["timestamp"]["output"]>
  complaints_goodwill_amount?: Maybe<Scalars["numeric"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  date_raised?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  external_identifier?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  internal_complaint_category?: Maybe<Scalars["String"]["output"]>
  ofgem_mapped_complaint_category?: Maybe<Scalars["String"]["output"]>
  send_date_of_d1_signposting_comms?: Maybe<Scalars["timestamp"]["output"]>
  send_date_of_d56_signposting_comms?: Maybe<Scalars["timestamp"]["output"]>
  send_date_of_overdue_signposting_comms?: Maybe<Scalars["timestamp"]["output"]>
  send_date_of_recent_signposting_comms?: Maybe<Scalars["timestamp"]["output"]>
  source?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  sub_status?: Maybe<Scalars["String"]["output"]>
  team?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "complaint" */
export type Complaint_Mutation_Response = {
  __typename?: "complaint_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Complaint>
}

/** on_conflict condition type for table "complaint" */
export type Complaint_On_Conflict = {
  constraint: Complaint_Constraint
  update_columns?: Array<Complaint_Update_Column>
  where?: InputMaybe<Complaint_Bool_Exp>
}

/** Ordering options when selecting data from "complaint". */
export type Complaint_Order_By = {
  agent_email?: InputMaybe<Order_By>
  agent_name?: InputMaybe<Order_By>
  category1?: InputMaybe<Order_By>
  category2?: InputMaybe<Order_By>
  category3?: InputMaybe<Order_By>
  channel?: InputMaybe<Order_By>
  closed_at?: InputMaybe<Order_By>
  complaints_goodwill_amount?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  d1_signposting_comms_sent?: InputMaybe<Order_By>
  d56_signposting_comms_sent?: InputMaybe<Order_By>
  date_raised?: InputMaybe<Order_By>
  deadlock_comms_sent?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  details?: InputMaybe<Order_By>
  external_identifier?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  internal_complaint_category?: InputMaybe<Order_By>
  ofgem_mapped_complaint_category?: InputMaybe<Order_By>
  ombudsman_case?: InputMaybe<Order_By>
  overdue_signposting_comms_sent?: InputMaybe<Order_By>
  recent_signposting_comms_sent?: InputMaybe<Order_By>
  send_date_of_d1_signposting_comms?: InputMaybe<Order_By>
  send_date_of_d56_signposting_comms?: InputMaybe<Order_By>
  send_date_of_overdue_signposting_comms?: InputMaybe<Order_By>
  send_date_of_recent_signposting_comms?: InputMaybe<Order_By>
  source?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  sub_status?: InputMaybe<Order_By>
  team?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: complaint */
export type Complaint_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Complaint_Prepend_Input = {
  details?: InputMaybe<Scalars["jsonb"]["input"]>
}

/** select columns of table "complaint" */
export enum Complaint_Select_Column {
  /** column name */
  AgentEmail = "agent_email",
  /** column name */
  AgentName = "agent_name",
  /** column name */
  Category1 = "category1",
  /** column name */
  Category2 = "category2",
  /** column name */
  Category3 = "category3",
  /** column name */
  Channel = "channel",
  /** column name */
  ClosedAt = "closed_at",
  /** column name */
  ComplaintsGoodwillAmount = "complaints_goodwill_amount",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  D1SignpostingCommsSent = "d1_signposting_comms_sent",
  /** column name */
  D56SignpostingCommsSent = "d56_signposting_comms_sent",
  /** column name */
  DateRaised = "date_raised",
  /** column name */
  DeadlockCommsSent = "deadlock_comms_sent",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Details = "details",
  /** column name */
  ExternalIdentifier = "external_identifier",
  /** column name */
  Id = "id",
  /** column name */
  InternalComplaintCategory = "internal_complaint_category",
  /** column name */
  OfgemMappedComplaintCategory = "ofgem_mapped_complaint_category",
  /** column name */
  OmbudsmanCase = "ombudsman_case",
  /** column name */
  OverdueSignpostingCommsSent = "overdue_signposting_comms_sent",
  /** column name */
  RecentSignpostingCommsSent = "recent_signposting_comms_sent",
  /** column name */
  SendDateOfD1SignpostingComms = "send_date_of_d1_signposting_comms",
  /** column name */
  SendDateOfD56SignpostingComms = "send_date_of_d56_signposting_comms",
  /** column name */
  SendDateOfOverdueSignpostingComms = "send_date_of_overdue_signposting_comms",
  /** column name */
  SendDateOfRecentSignpostingComms = "send_date_of_recent_signposting_comms",
  /** column name */
  Source = "source",
  /** column name */
  Status = "status",
  /** column name */
  SubStatus = "sub_status",
  /** column name */
  Team = "team",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "complaint" */
export type Complaint_Set_Input = {
  agent_email?: InputMaybe<Scalars["String"]["input"]>
  agent_name?: InputMaybe<Scalars["String"]["input"]>
  category1?: InputMaybe<Scalars["String"]["input"]>
  category2?: InputMaybe<Scalars["String"]["input"]>
  category3?: InputMaybe<Scalars["String"]["input"]>
  channel?: InputMaybe<Scalars["String"]["input"]>
  closed_at?: InputMaybe<Scalars["timestamp"]["input"]>
  complaints_goodwill_amount?: InputMaybe<Scalars["numeric"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  d1_signposting_comms_sent?: InputMaybe<Scalars["Boolean"]["input"]>
  d56_signposting_comms_sent?: InputMaybe<Scalars["Boolean"]["input"]>
  date_raised?: InputMaybe<Scalars["timestamp"]["input"]>
  deadlock_comms_sent?: InputMaybe<Scalars["Boolean"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  details?: InputMaybe<Scalars["jsonb"]["input"]>
  external_identifier?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  internal_complaint_category?: InputMaybe<Scalars["String"]["input"]>
  ofgem_mapped_complaint_category?: InputMaybe<Scalars["String"]["input"]>
  ombudsman_case?: InputMaybe<Scalars["Boolean"]["input"]>
  overdue_signposting_comms_sent?: InputMaybe<Scalars["Boolean"]["input"]>
  recent_signposting_comms_sent?: InputMaybe<Scalars["Boolean"]["input"]>
  send_date_of_d1_signposting_comms?: InputMaybe<Scalars["timestamp"]["input"]>
  send_date_of_d56_signposting_comms?: InputMaybe<Scalars["timestamp"]["input"]>
  send_date_of_overdue_signposting_comms?: InputMaybe<
    Scalars["timestamp"]["input"]
  >
  send_date_of_recent_signposting_comms?: InputMaybe<
    Scalars["timestamp"]["input"]
  >
  source?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  sub_status?: InputMaybe<Scalars["String"]["input"]>
  team?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Complaint_Stddev_Fields = {
  __typename?: "complaint_stddev_fields"
  complaints_goodwill_amount?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Complaint_Stddev_Pop_Fields = {
  __typename?: "complaint_stddev_pop_fields"
  complaints_goodwill_amount?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Complaint_Stddev_Samp_Fields = {
  __typename?: "complaint_stddev_samp_fields"
  complaints_goodwill_amount?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "complaint" */
export type Complaint_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Complaint_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Complaint_Stream_Cursor_Value_Input = {
  agent_email?: InputMaybe<Scalars["String"]["input"]>
  agent_name?: InputMaybe<Scalars["String"]["input"]>
  category1?: InputMaybe<Scalars["String"]["input"]>
  category2?: InputMaybe<Scalars["String"]["input"]>
  category3?: InputMaybe<Scalars["String"]["input"]>
  channel?: InputMaybe<Scalars["String"]["input"]>
  closed_at?: InputMaybe<Scalars["timestamp"]["input"]>
  complaints_goodwill_amount?: InputMaybe<Scalars["numeric"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  d1_signposting_comms_sent?: InputMaybe<Scalars["Boolean"]["input"]>
  d56_signposting_comms_sent?: InputMaybe<Scalars["Boolean"]["input"]>
  date_raised?: InputMaybe<Scalars["timestamp"]["input"]>
  deadlock_comms_sent?: InputMaybe<Scalars["Boolean"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  details?: InputMaybe<Scalars["jsonb"]["input"]>
  external_identifier?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  internal_complaint_category?: InputMaybe<Scalars["String"]["input"]>
  ofgem_mapped_complaint_category?: InputMaybe<Scalars["String"]["input"]>
  ombudsman_case?: InputMaybe<Scalars["Boolean"]["input"]>
  overdue_signposting_comms_sent?: InputMaybe<Scalars["Boolean"]["input"]>
  recent_signposting_comms_sent?: InputMaybe<Scalars["Boolean"]["input"]>
  send_date_of_d1_signposting_comms?: InputMaybe<Scalars["timestamp"]["input"]>
  send_date_of_d56_signposting_comms?: InputMaybe<Scalars["timestamp"]["input"]>
  send_date_of_overdue_signposting_comms?: InputMaybe<
    Scalars["timestamp"]["input"]
  >
  send_date_of_recent_signposting_comms?: InputMaybe<
    Scalars["timestamp"]["input"]
  >
  source?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  sub_status?: InputMaybe<Scalars["String"]["input"]>
  team?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Complaint_Sum_Fields = {
  __typename?: "complaint_sum_fields"
  complaints_goodwill_amount?: Maybe<Scalars["numeric"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "complaint" */
export enum Complaint_Update_Column {
  /** column name */
  AgentEmail = "agent_email",
  /** column name */
  AgentName = "agent_name",
  /** column name */
  Category1 = "category1",
  /** column name */
  Category2 = "category2",
  /** column name */
  Category3 = "category3",
  /** column name */
  Channel = "channel",
  /** column name */
  ClosedAt = "closed_at",
  /** column name */
  ComplaintsGoodwillAmount = "complaints_goodwill_amount",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  D1SignpostingCommsSent = "d1_signposting_comms_sent",
  /** column name */
  D56SignpostingCommsSent = "d56_signposting_comms_sent",
  /** column name */
  DateRaised = "date_raised",
  /** column name */
  DeadlockCommsSent = "deadlock_comms_sent",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Details = "details",
  /** column name */
  ExternalIdentifier = "external_identifier",
  /** column name */
  Id = "id",
  /** column name */
  InternalComplaintCategory = "internal_complaint_category",
  /** column name */
  OfgemMappedComplaintCategory = "ofgem_mapped_complaint_category",
  /** column name */
  OmbudsmanCase = "ombudsman_case",
  /** column name */
  OverdueSignpostingCommsSent = "overdue_signposting_comms_sent",
  /** column name */
  RecentSignpostingCommsSent = "recent_signposting_comms_sent",
  /** column name */
  SendDateOfD1SignpostingComms = "send_date_of_d1_signposting_comms",
  /** column name */
  SendDateOfD56SignpostingComms = "send_date_of_d56_signposting_comms",
  /** column name */
  SendDateOfOverdueSignpostingComms = "send_date_of_overdue_signposting_comms",
  /** column name */
  SendDateOfRecentSignpostingComms = "send_date_of_recent_signposting_comms",
  /** column name */
  Source = "source",
  /** column name */
  Status = "status",
  /** column name */
  SubStatus = "sub_status",
  /** column name */
  Team = "team",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Complaint_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Complaint_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Complaint_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Complaint_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Complaint_Delete_Key_Input>
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Complaint_Inc_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Complaint_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Complaint_Set_Input>
  /** filter the rows which have to be updated */
  where: Complaint_Bool_Exp
}

/** aggregate var_pop on columns */
export type Complaint_Var_Pop_Fields = {
  __typename?: "complaint_var_pop_fields"
  complaints_goodwill_amount?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Complaint_Var_Samp_Fields = {
  __typename?: "complaint_var_samp_fields"
  complaints_goodwill_amount?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Complaint_Variance_Fields = {
  __typename?: "complaint_variance_fields"
  complaints_goodwill_amount?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "completed_sync_event_account" */
export type Completed_Sync_Event_Account = {
  __typename?: "completed_sync_event_account"
  additional_data?: Maybe<Scalars["json"]["output"]>
  claimed_at?: Maybe<Scalars["timestamptz"]["output"]>
  completed_at?: Maybe<Scalars["timestamptz"]["output"]>
  completion_reason?: Maybe<Scalars["String"]["output"]>
  created_at: Scalars["timestamptz"]["output"]
  error_code?: Maybe<Scalars["String"]["output"]>
  error_description?: Maybe<Scalars["String"]["output"]>
  event_type: Scalars["event_type"]["output"]
  id: Scalars["bigint"]["output"]
  initial_id?: Maybe<Scalars["bigint"]["output"]>
  last_known_error?: Maybe<Scalars["String"]["output"]>
  operation_type?: Maybe<Scalars["operation_type"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
  sync_pid?: Maybe<Scalars["String"]["output"]>
}

/** columns and relationships of "completed_sync_event_account" */
export type Completed_Sync_Event_AccountAdditional_DataArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregated selection of "completed_sync_event_account" */
export type Completed_Sync_Event_Account_Aggregate = {
  __typename?: "completed_sync_event_account_aggregate"
  aggregate?: Maybe<Completed_Sync_Event_Account_Aggregate_Fields>
  nodes: Array<Completed_Sync_Event_Account>
}

/** aggregate fields of "completed_sync_event_account" */
export type Completed_Sync_Event_Account_Aggregate_Fields = {
  __typename?: "completed_sync_event_account_aggregate_fields"
  avg?: Maybe<Completed_Sync_Event_Account_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Completed_Sync_Event_Account_Max_Fields>
  min?: Maybe<Completed_Sync_Event_Account_Min_Fields>
  stddev?: Maybe<Completed_Sync_Event_Account_Stddev_Fields>
  stddev_pop?: Maybe<Completed_Sync_Event_Account_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Completed_Sync_Event_Account_Stddev_Samp_Fields>
  sum?: Maybe<Completed_Sync_Event_Account_Sum_Fields>
  var_pop?: Maybe<Completed_Sync_Event_Account_Var_Pop_Fields>
  var_samp?: Maybe<Completed_Sync_Event_Account_Var_Samp_Fields>
  variance?: Maybe<Completed_Sync_Event_Account_Variance_Fields>
}

/** aggregate fields of "completed_sync_event_account" */
export type Completed_Sync_Event_Account_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Completed_Sync_Event_Account_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Completed_Sync_Event_Account_Avg_Fields = {
  __typename?: "completed_sync_event_account_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  initial_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "completed_sync_event_account". All fields are combined with a logical 'AND'. */
export type Completed_Sync_Event_Account_Bool_Exp = {
  _and?: InputMaybe<Array<Completed_Sync_Event_Account_Bool_Exp>>
  _not?: InputMaybe<Completed_Sync_Event_Account_Bool_Exp>
  _or?: InputMaybe<Array<Completed_Sync_Event_Account_Bool_Exp>>
  additional_data?: InputMaybe<Json_Comparison_Exp>
  claimed_at?: InputMaybe<Timestamptz_Comparison_Exp>
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>
  completion_reason?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  error_code?: InputMaybe<String_Comparison_Exp>
  error_description?: InputMaybe<String_Comparison_Exp>
  event_type?: InputMaybe<Event_Type_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  initial_id?: InputMaybe<Bigint_Comparison_Exp>
  last_known_error?: InputMaybe<String_Comparison_Exp>
  operation_type?: InputMaybe<Operation_Type_Comparison_Exp>
  reference?: InputMaybe<String_Comparison_Exp>
  retry_count?: InputMaybe<Int_Comparison_Exp>
  sync_pid?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "completed_sync_event_account" */
export enum Completed_Sync_Event_Account_Constraint {
  /** unique or primary key constraint on columns "id", "event_type" */
  CompletedSyncEventAccountPkey = "completed_sync_event_account_pkey",
}

/** input type for incrementing numeric columns in table "completed_sync_event_account" */
export type Completed_Sync_Event_Account_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  initial_id?: InputMaybe<Scalars["bigint"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "completed_sync_event_account" */
export type Completed_Sync_Event_Account_Insert_Input = {
  additional_data?: InputMaybe<Scalars["json"]["input"]>
  claimed_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  completed_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  completion_reason?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  error_code?: InputMaybe<Scalars["String"]["input"]>
  error_description?: InputMaybe<Scalars["String"]["input"]>
  event_type?: InputMaybe<Scalars["event_type"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  initial_id?: InputMaybe<Scalars["bigint"]["input"]>
  last_known_error?: InputMaybe<Scalars["String"]["input"]>
  operation_type?: InputMaybe<Scalars["operation_type"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  sync_pid?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Completed_Sync_Event_Account_Max_Fields = {
  __typename?: "completed_sync_event_account_max_fields"
  claimed_at?: Maybe<Scalars["timestamptz"]["output"]>
  completed_at?: Maybe<Scalars["timestamptz"]["output"]>
  completion_reason?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  error_code?: Maybe<Scalars["String"]["output"]>
  error_description?: Maybe<Scalars["String"]["output"]>
  event_type?: Maybe<Scalars["event_type"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  initial_id?: Maybe<Scalars["bigint"]["output"]>
  last_known_error?: Maybe<Scalars["String"]["output"]>
  operation_type?: Maybe<Scalars["operation_type"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
  sync_pid?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Completed_Sync_Event_Account_Min_Fields = {
  __typename?: "completed_sync_event_account_min_fields"
  claimed_at?: Maybe<Scalars["timestamptz"]["output"]>
  completed_at?: Maybe<Scalars["timestamptz"]["output"]>
  completion_reason?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  error_code?: Maybe<Scalars["String"]["output"]>
  error_description?: Maybe<Scalars["String"]["output"]>
  event_type?: Maybe<Scalars["event_type"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  initial_id?: Maybe<Scalars["bigint"]["output"]>
  last_known_error?: Maybe<Scalars["String"]["output"]>
  operation_type?: Maybe<Scalars["operation_type"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
  sync_pid?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "completed_sync_event_account" */
export type Completed_Sync_Event_Account_Mutation_Response = {
  __typename?: "completed_sync_event_account_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Completed_Sync_Event_Account>
}

/** on_conflict condition type for table "completed_sync_event_account" */
export type Completed_Sync_Event_Account_On_Conflict = {
  constraint: Completed_Sync_Event_Account_Constraint
  update_columns?: Array<Completed_Sync_Event_Account_Update_Column>
  where?: InputMaybe<Completed_Sync_Event_Account_Bool_Exp>
}

/** Ordering options when selecting data from "completed_sync_event_account". */
export type Completed_Sync_Event_Account_Order_By = {
  additional_data?: InputMaybe<Order_By>
  claimed_at?: InputMaybe<Order_By>
  completed_at?: InputMaybe<Order_By>
  completion_reason?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  error_code?: InputMaybe<Order_By>
  error_description?: InputMaybe<Order_By>
  event_type?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  initial_id?: InputMaybe<Order_By>
  last_known_error?: InputMaybe<Order_By>
  operation_type?: InputMaybe<Order_By>
  reference?: InputMaybe<Order_By>
  retry_count?: InputMaybe<Order_By>
  sync_pid?: InputMaybe<Order_By>
}

/** primary key columns input for table: completed_sync_event_account */
export type Completed_Sync_Event_Account_Pk_Columns_Input = {
  event_type: Scalars["event_type"]["input"]
  id: Scalars["bigint"]["input"]
}

/** select columns of table "completed_sync_event_account" */
export enum Completed_Sync_Event_Account_Select_Column {
  /** column name */
  AdditionalData = "additional_data",
  /** column name */
  ClaimedAt = "claimed_at",
  /** column name */
  CompletedAt = "completed_at",
  /** column name */
  CompletionReason = "completion_reason",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  ErrorCode = "error_code",
  /** column name */
  ErrorDescription = "error_description",
  /** column name */
  EventType = "event_type",
  /** column name */
  Id = "id",
  /** column name */
  InitialId = "initial_id",
  /** column name */
  LastKnownError = "last_known_error",
  /** column name */
  OperationType = "operation_type",
  /** column name */
  Reference = "reference",
  /** column name */
  RetryCount = "retry_count",
  /** column name */
  SyncPid = "sync_pid",
}

/** input type for updating data in table "completed_sync_event_account" */
export type Completed_Sync_Event_Account_Set_Input = {
  additional_data?: InputMaybe<Scalars["json"]["input"]>
  claimed_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  completed_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  completion_reason?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  error_code?: InputMaybe<Scalars["String"]["input"]>
  error_description?: InputMaybe<Scalars["String"]["input"]>
  event_type?: InputMaybe<Scalars["event_type"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  initial_id?: InputMaybe<Scalars["bigint"]["input"]>
  last_known_error?: InputMaybe<Scalars["String"]["input"]>
  operation_type?: InputMaybe<Scalars["operation_type"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  sync_pid?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Completed_Sync_Event_Account_Stddev_Fields = {
  __typename?: "completed_sync_event_account_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  initial_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Completed_Sync_Event_Account_Stddev_Pop_Fields = {
  __typename?: "completed_sync_event_account_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  initial_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Completed_Sync_Event_Account_Stddev_Samp_Fields = {
  __typename?: "completed_sync_event_account_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  initial_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "completed_sync_event_account" */
export type Completed_Sync_Event_Account_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Completed_Sync_Event_Account_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Completed_Sync_Event_Account_Stream_Cursor_Value_Input = {
  additional_data?: InputMaybe<Scalars["json"]["input"]>
  claimed_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  completed_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  completion_reason?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  error_code?: InputMaybe<Scalars["String"]["input"]>
  error_description?: InputMaybe<Scalars["String"]["input"]>
  event_type?: InputMaybe<Scalars["event_type"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  initial_id?: InputMaybe<Scalars["bigint"]["input"]>
  last_known_error?: InputMaybe<Scalars["String"]["input"]>
  operation_type?: InputMaybe<Scalars["operation_type"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  sync_pid?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Completed_Sync_Event_Account_Sum_Fields = {
  __typename?: "completed_sync_event_account_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  initial_id?: Maybe<Scalars["bigint"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
}

/** update columns of table "completed_sync_event_account" */
export enum Completed_Sync_Event_Account_Update_Column {
  /** column name */
  AdditionalData = "additional_data",
  /** column name */
  ClaimedAt = "claimed_at",
  /** column name */
  CompletedAt = "completed_at",
  /** column name */
  CompletionReason = "completion_reason",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  ErrorCode = "error_code",
  /** column name */
  ErrorDescription = "error_description",
  /** column name */
  EventType = "event_type",
  /** column name */
  Id = "id",
  /** column name */
  InitialId = "initial_id",
  /** column name */
  LastKnownError = "last_known_error",
  /** column name */
  OperationType = "operation_type",
  /** column name */
  Reference = "reference",
  /** column name */
  RetryCount = "retry_count",
  /** column name */
  SyncPid = "sync_pid",
}

export type Completed_Sync_Event_Account_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Completed_Sync_Event_Account_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Completed_Sync_Event_Account_Set_Input>
  /** filter the rows which have to be updated */
  where: Completed_Sync_Event_Account_Bool_Exp
}

/** aggregate var_pop on columns */
export type Completed_Sync_Event_Account_Var_Pop_Fields = {
  __typename?: "completed_sync_event_account_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  initial_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Completed_Sync_Event_Account_Var_Samp_Fields = {
  __typename?: "completed_sync_event_account_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  initial_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Completed_Sync_Event_Account_Variance_Fields = {
  __typename?: "completed_sync_event_account_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  initial_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "configuration" */
export type Configuration = {
  __typename?: "configuration"
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  editable?: Maybe<Scalars["Boolean"]["output"]>
  from_dt: Scalars["timestamp"]["output"]
  id: Scalars["bigint"]["output"]
  name: Scalars["configuration_name"]["output"]
  to_dt?: Maybe<Scalars["timestamp"]["output"]>
  ttl_ms: Scalars["bigint"]["output"]
  updated_at: Scalars["timestamp"]["output"]
  value: Scalars["String"]["output"]
}

/** aggregated selection of "configuration" */
export type Configuration_Aggregate = {
  __typename?: "configuration_aggregate"
  aggregate?: Maybe<Configuration_Aggregate_Fields>
  nodes: Array<Configuration>
}

/** aggregate fields of "configuration" */
export type Configuration_Aggregate_Fields = {
  __typename?: "configuration_aggregate_fields"
  avg?: Maybe<Configuration_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Configuration_Max_Fields>
  min?: Maybe<Configuration_Min_Fields>
  stddev?: Maybe<Configuration_Stddev_Fields>
  stddev_pop?: Maybe<Configuration_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Configuration_Stddev_Samp_Fields>
  sum?: Maybe<Configuration_Sum_Fields>
  var_pop?: Maybe<Configuration_Var_Pop_Fields>
  var_samp?: Maybe<Configuration_Var_Samp_Fields>
  variance?: Maybe<Configuration_Variance_Fields>
}

/** aggregate fields of "configuration" */
export type Configuration_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Configuration_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Configuration_Avg_Fields = {
  __typename?: "configuration_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ttl_ms?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "configuration". All fields are combined with a logical 'AND'. */
export type Configuration_Bool_Exp = {
  _and?: InputMaybe<Array<Configuration_Bool_Exp>>
  _not?: InputMaybe<Configuration_Bool_Exp>
  _or?: InputMaybe<Array<Configuration_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  editable?: InputMaybe<Boolean_Comparison_Exp>
  from_dt?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  name?: InputMaybe<Configuration_Name_Comparison_Exp>
  to_dt?: InputMaybe<Timestamp_Comparison_Exp>
  ttl_ms?: InputMaybe<Bigint_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  value?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "configuration" */
export enum Configuration_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkConfigurations = "pk_configurations",
  /** unique or primary key constraint on columns "name" */
  UIConfiguration = "u_i_configuration",
}

/** input type for incrementing numeric columns in table "configuration" */
export type Configuration_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  ttl_ms?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "configuration" */
export type Configuration_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  editable?: InputMaybe<Scalars["Boolean"]["input"]>
  from_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["configuration_name"]["input"]>
  to_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  ttl_ms?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  value?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Configuration_Max_Fields = {
  __typename?: "configuration_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_dt?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["configuration_name"]["output"]>
  to_dt?: Maybe<Scalars["timestamp"]["output"]>
  ttl_ms?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  value?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Configuration_Min_Fields = {
  __typename?: "configuration_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_dt?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["configuration_name"]["output"]>
  to_dt?: Maybe<Scalars["timestamp"]["output"]>
  ttl_ms?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  value?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "configuration" */
export type Configuration_Mutation_Response = {
  __typename?: "configuration_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Configuration>
}

/** Boolean expression to compare columns of type "configuration_name". All fields are combined with logical 'AND'. */
export type Configuration_Name_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["configuration_name"]["input"]>
  _gt?: InputMaybe<Scalars["configuration_name"]["input"]>
  _gte?: InputMaybe<Scalars["configuration_name"]["input"]>
  _in?: InputMaybe<Array<Scalars["configuration_name"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["configuration_name"]["input"]>
  _lte?: InputMaybe<Scalars["configuration_name"]["input"]>
  _neq?: InputMaybe<Scalars["configuration_name"]["input"]>
  _nin?: InputMaybe<Array<Scalars["configuration_name"]["input"]>>
}

/** on_conflict condition type for table "configuration" */
export type Configuration_On_Conflict = {
  constraint: Configuration_Constraint
  update_columns?: Array<Configuration_Update_Column>
  where?: InputMaybe<Configuration_Bool_Exp>
}

/** Ordering options when selecting data from "configuration". */
export type Configuration_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  editable?: InputMaybe<Order_By>
  from_dt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  to_dt?: InputMaybe<Order_By>
  ttl_ms?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  value?: InputMaybe<Order_By>
}

/** primary key columns input for table: configuration */
export type Configuration_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "configuration" */
export enum Configuration_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Editable = "editable",
  /** column name */
  FromDt = "from_dt",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  ToDt = "to_dt",
  /** column name */
  TtlMs = "ttl_ms",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  Value = "value",
}

/** input type for updating data in table "configuration" */
export type Configuration_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  editable?: InputMaybe<Scalars["Boolean"]["input"]>
  from_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["configuration_name"]["input"]>
  to_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  ttl_ms?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  value?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Configuration_Stddev_Fields = {
  __typename?: "configuration_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ttl_ms?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Configuration_Stddev_Pop_Fields = {
  __typename?: "configuration_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ttl_ms?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Configuration_Stddev_Samp_Fields = {
  __typename?: "configuration_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ttl_ms?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "configuration" */
export type Configuration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Configuration_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Configuration_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  editable?: InputMaybe<Scalars["Boolean"]["input"]>
  from_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["configuration_name"]["input"]>
  to_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  ttl_ms?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  value?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Configuration_Sum_Fields = {
  __typename?: "configuration_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  ttl_ms?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "configuration" */
export enum Configuration_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Editable = "editable",
  /** column name */
  FromDt = "from_dt",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  ToDt = "to_dt",
  /** column name */
  TtlMs = "ttl_ms",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  Value = "value",
}

export type Configuration_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Configuration_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Configuration_Set_Input>
  /** filter the rows which have to be updated */
  where: Configuration_Bool_Exp
}

/** aggregate var_pop on columns */
export type Configuration_Var_Pop_Fields = {
  __typename?: "configuration_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ttl_ms?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Configuration_Var_Samp_Fields = {
  __typename?: "configuration_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ttl_ms?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Configuration_Variance_Fields = {
  __typename?: "configuration_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ttl_ms?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "contact" */
export type Contact = {
  __typename?: "contact"
  /** An object relationship */
  address?: Maybe<Customer_Address>
  address_id?: Maybe<Scalars["bigint"]["output"]>
  /** An array relationship */
  billing_account_contacts: Array<Billing_Account_Contact>
  /** An aggregate relationship */
  billing_account_contacts_aggregate: Billing_Account_Contact_Aggregate
  care_of?: Maybe<Scalars["String"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  /** An array relationship */
  customer_contacts: Array<Customer_Contact>
  /** An aggregate relationship */
  customer_contacts_aggregate: Customer_Contact_Aggregate
  date_of_birth?: Maybe<Scalars["date"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  first_name?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  last_name?: Maybe<Scalars["String"]["output"]>
  phone_number1?: Maybe<Scalars["String"]["output"]>
  phone_number2?: Maybe<Scalars["String"]["output"]>
  phone_number3?: Maybe<Scalars["String"]["output"]>
  title?: Maybe<Scalars["title"]["output"]>
  type: Scalars["contact_type"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "contact" */
export type ContactBilling_Account_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Contact_Order_By>>
  where?: InputMaybe<Billing_Account_Contact_Bool_Exp>
}

/** columns and relationships of "contact" */
export type ContactBilling_Account_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Contact_Order_By>>
  where?: InputMaybe<Billing_Account_Contact_Bool_Exp>
}

/** columns and relationships of "contact" */
export type ContactCustomer_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Contact_Order_By>>
  where?: InputMaybe<Customer_Contact_Bool_Exp>
}

/** columns and relationships of "contact" */
export type ContactCustomer_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Contact_Order_By>>
  where?: InputMaybe<Customer_Contact_Bool_Exp>
}

/** aggregated selection of "contact" */
export type Contact_Aggregate = {
  __typename?: "contact_aggregate"
  aggregate?: Maybe<Contact_Aggregate_Fields>
  nodes: Array<Contact>
}

export type Contact_Aggregate_Bool_Exp = {
  count?: InputMaybe<Contact_Aggregate_Bool_Exp_Count>
}

export type Contact_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Contact_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Contact_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "contact" */
export type Contact_Aggregate_Fields = {
  __typename?: "contact_aggregate_fields"
  avg?: Maybe<Contact_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Contact_Max_Fields>
  min?: Maybe<Contact_Min_Fields>
  stddev?: Maybe<Contact_Stddev_Fields>
  stddev_pop?: Maybe<Contact_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Contact_Stddev_Samp_Fields>
  sum?: Maybe<Contact_Sum_Fields>
  var_pop?: Maybe<Contact_Var_Pop_Fields>
  var_samp?: Maybe<Contact_Var_Samp_Fields>
  variance?: Maybe<Contact_Variance_Fields>
}

/** aggregate fields of "contact" */
export type Contact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contact_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "contact" */
export type Contact_Aggregate_Order_By = {
  avg?: InputMaybe<Contact_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Contact_Max_Order_By>
  min?: InputMaybe<Contact_Min_Order_By>
  stddev?: InputMaybe<Contact_Stddev_Order_By>
  stddev_pop?: InputMaybe<Contact_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Contact_Stddev_Samp_Order_By>
  sum?: InputMaybe<Contact_Sum_Order_By>
  var_pop?: InputMaybe<Contact_Var_Pop_Order_By>
  var_samp?: InputMaybe<Contact_Var_Samp_Order_By>
  variance?: InputMaybe<Contact_Variance_Order_By>
}

/** input type for inserting array relation for remote table "contact" */
export type Contact_Arr_Rel_Insert_Input = {
  data: Array<Contact_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Contact_On_Conflict>
}

/** aggregate avg on columns */
export type Contact_Avg_Fields = {
  __typename?: "contact_avg_fields"
  address_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "contact" */
export type Contact_Avg_Order_By = {
  address_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "contact". All fields are combined with a logical 'AND'. */
export type Contact_Bool_Exp = {
  _and?: InputMaybe<Array<Contact_Bool_Exp>>
  _not?: InputMaybe<Contact_Bool_Exp>
  _or?: InputMaybe<Array<Contact_Bool_Exp>>
  address?: InputMaybe<Customer_Address_Bool_Exp>
  address_id?: InputMaybe<Bigint_Comparison_Exp>
  billing_account_contacts?: InputMaybe<Billing_Account_Contact_Bool_Exp>
  billing_account_contacts_aggregate?: InputMaybe<Billing_Account_Contact_Aggregate_Bool_Exp>
  care_of?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  customer_contacts?: InputMaybe<Customer_Contact_Bool_Exp>
  customer_contacts_aggregate?: InputMaybe<Customer_Contact_Aggregate_Bool_Exp>
  date_of_birth?: InputMaybe<Date_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  email?: InputMaybe<String_Comparison_Exp>
  first_name?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  last_name?: InputMaybe<String_Comparison_Exp>
  phone_number1?: InputMaybe<String_Comparison_Exp>
  phone_number2?: InputMaybe<String_Comparison_Exp>
  phone_number3?: InputMaybe<String_Comparison_Exp>
  title?: InputMaybe<Title_Comparison_Exp>
  type?: InputMaybe<Contact_Type_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "contact" */
export enum Contact_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkContact = "pk_contact",
}

/** input type for incrementing numeric columns in table "contact" */
export type Contact_Inc_Input = {
  address_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "contact" */
export type Contact_Insert_Input = {
  address?: InputMaybe<Customer_Address_Obj_Rel_Insert_Input>
  address_id?: InputMaybe<Scalars["bigint"]["input"]>
  billing_account_contacts?: InputMaybe<Billing_Account_Contact_Arr_Rel_Insert_Input>
  care_of?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_contacts?: InputMaybe<Customer_Contact_Arr_Rel_Insert_Input>
  date_of_birth?: InputMaybe<Scalars["date"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  first_name?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_name?: InputMaybe<Scalars["String"]["input"]>
  phone_number1?: InputMaybe<Scalars["String"]["input"]>
  phone_number2?: InputMaybe<Scalars["String"]["input"]>
  phone_number3?: InputMaybe<Scalars["String"]["input"]>
  title?: InputMaybe<Scalars["title"]["input"]>
  type?: InputMaybe<Scalars["contact_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Contact_Max_Fields = {
  __typename?: "contact_max_fields"
  address_id?: Maybe<Scalars["bigint"]["output"]>
  care_of?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  date_of_birth?: Maybe<Scalars["date"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  first_name?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_name?: Maybe<Scalars["String"]["output"]>
  phone_number1?: Maybe<Scalars["String"]["output"]>
  phone_number2?: Maybe<Scalars["String"]["output"]>
  phone_number3?: Maybe<Scalars["String"]["output"]>
  title?: Maybe<Scalars["title"]["output"]>
  type?: Maybe<Scalars["contact_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "contact" */
export type Contact_Max_Order_By = {
  address_id?: InputMaybe<Order_By>
  care_of?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  date_of_birth?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  email?: InputMaybe<Order_By>
  first_name?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  last_name?: InputMaybe<Order_By>
  phone_number1?: InputMaybe<Order_By>
  phone_number2?: InputMaybe<Order_By>
  phone_number3?: InputMaybe<Order_By>
  title?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Contact_Min_Fields = {
  __typename?: "contact_min_fields"
  address_id?: Maybe<Scalars["bigint"]["output"]>
  care_of?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  date_of_birth?: Maybe<Scalars["date"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  first_name?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_name?: Maybe<Scalars["String"]["output"]>
  phone_number1?: Maybe<Scalars["String"]["output"]>
  phone_number2?: Maybe<Scalars["String"]["output"]>
  phone_number3?: Maybe<Scalars["String"]["output"]>
  title?: Maybe<Scalars["title"]["output"]>
  type?: Maybe<Scalars["contact_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "contact" */
export type Contact_Min_Order_By = {
  address_id?: InputMaybe<Order_By>
  care_of?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  date_of_birth?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  email?: InputMaybe<Order_By>
  first_name?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  last_name?: InputMaybe<Order_By>
  phone_number1?: InputMaybe<Order_By>
  phone_number2?: InputMaybe<Order_By>
  phone_number3?: InputMaybe<Order_By>
  title?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "contact" */
export type Contact_Mutation_Response = {
  __typename?: "contact_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Contact>
}

/** input type for inserting object relation for remote table "contact" */
export type Contact_Obj_Rel_Insert_Input = {
  data: Contact_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Contact_On_Conflict>
}

/** on_conflict condition type for table "contact" */
export type Contact_On_Conflict = {
  constraint: Contact_Constraint
  update_columns?: Array<Contact_Update_Column>
  where?: InputMaybe<Contact_Bool_Exp>
}

/** Ordering options when selecting data from "contact". */
export type Contact_Order_By = {
  address?: InputMaybe<Customer_Address_Order_By>
  address_id?: InputMaybe<Order_By>
  billing_account_contacts_aggregate?: InputMaybe<Billing_Account_Contact_Aggregate_Order_By>
  care_of?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  customer_contacts_aggregate?: InputMaybe<Customer_Contact_Aggregate_Order_By>
  date_of_birth?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  email?: InputMaybe<Order_By>
  first_name?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  last_name?: InputMaybe<Order_By>
  phone_number1?: InputMaybe<Order_By>
  phone_number2?: InputMaybe<Order_By>
  phone_number3?: InputMaybe<Order_By>
  title?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: contact */
export type Contact_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "contact" */
export enum Contact_Select_Column {
  /** column name */
  AddressId = "address_id",
  /** column name */
  CareOf = "care_of",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DateOfBirth = "date_of_birth",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Email = "email",
  /** column name */
  FirstName = "first_name",
  /** column name */
  Id = "id",
  /** column name */
  LastName = "last_name",
  /** column name */
  PhoneNumber1 = "phone_number1",
  /** column name */
  PhoneNumber2 = "phone_number2",
  /** column name */
  PhoneNumber3 = "phone_number3",
  /** column name */
  Title = "title",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "contact" */
export type Contact_Set_Input = {
  address_id?: InputMaybe<Scalars["bigint"]["input"]>
  care_of?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  date_of_birth?: InputMaybe<Scalars["date"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  first_name?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_name?: InputMaybe<Scalars["String"]["input"]>
  phone_number1?: InputMaybe<Scalars["String"]["input"]>
  phone_number2?: InputMaybe<Scalars["String"]["input"]>
  phone_number3?: InputMaybe<Scalars["String"]["input"]>
  title?: InputMaybe<Scalars["title"]["input"]>
  type?: InputMaybe<Scalars["contact_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Contact_Stddev_Fields = {
  __typename?: "contact_stddev_fields"
  address_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "contact" */
export type Contact_Stddev_Order_By = {
  address_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Contact_Stddev_Pop_Fields = {
  __typename?: "contact_stddev_pop_fields"
  address_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "contact" */
export type Contact_Stddev_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Contact_Stddev_Samp_Fields = {
  __typename?: "contact_stddev_samp_fields"
  address_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "contact" */
export type Contact_Stddev_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "contact" */
export type Contact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contact_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Contact_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars["bigint"]["input"]>
  care_of?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  date_of_birth?: InputMaybe<Scalars["date"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  first_name?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_name?: InputMaybe<Scalars["String"]["input"]>
  phone_number1?: InputMaybe<Scalars["String"]["input"]>
  phone_number2?: InputMaybe<Scalars["String"]["input"]>
  phone_number3?: InputMaybe<Scalars["String"]["input"]>
  title?: InputMaybe<Scalars["title"]["input"]>
  type?: InputMaybe<Scalars["contact_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Contact_Sum_Fields = {
  __typename?: "contact_sum_fields"
  address_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "contact" */
export type Contact_Sum_Order_By = {
  address_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "contact_type". All fields are combined with logical 'AND'. */
export type Contact_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["contact_type"]["input"]>
  _gt?: InputMaybe<Scalars["contact_type"]["input"]>
  _gte?: InputMaybe<Scalars["contact_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["contact_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["contact_type"]["input"]>
  _lte?: InputMaybe<Scalars["contact_type"]["input"]>
  _neq?: InputMaybe<Scalars["contact_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["contact_type"]["input"]>>
}

/** update columns of table "contact" */
export enum Contact_Update_Column {
  /** column name */
  AddressId = "address_id",
  /** column name */
  CareOf = "care_of",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DateOfBirth = "date_of_birth",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Email = "email",
  /** column name */
  FirstName = "first_name",
  /** column name */
  Id = "id",
  /** column name */
  LastName = "last_name",
  /** column name */
  PhoneNumber1 = "phone_number1",
  /** column name */
  PhoneNumber2 = "phone_number2",
  /** column name */
  PhoneNumber3 = "phone_number3",
  /** column name */
  Title = "title",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Contact_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Contact_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Contact_Set_Input>
  /** filter the rows which have to be updated */
  where: Contact_Bool_Exp
}

/** aggregate var_pop on columns */
export type Contact_Var_Pop_Fields = {
  __typename?: "contact_var_pop_fields"
  address_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "contact" */
export type Contact_Var_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Contact_Var_Samp_Fields = {
  __typename?: "contact_var_samp_fields"
  address_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "contact" */
export type Contact_Var_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Contact_Variance_Fields = {
  __typename?: "contact_variance_fields"
  address_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "contact" */
export type Contact_Variance_Order_By = {
  address_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "created_from_type". All fields are combined with logical 'AND'. */
export type Created_From_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["created_from_type"]["input"]>
  _gt?: InputMaybe<Scalars["created_from_type"]["input"]>
  _gte?: InputMaybe<Scalars["created_from_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["created_from_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["created_from_type"]["input"]>
  _lte?: InputMaybe<Scalars["created_from_type"]["input"]>
  _neq?: InputMaybe<Scalars["created_from_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["created_from_type"]["input"]>>
}

/** Boolean expression to compare columns of type "credit_check_status". All fields are combined with logical 'AND'. */
export type Credit_Check_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["credit_check_status"]["input"]>
  _gt?: InputMaybe<Scalars["credit_check_status"]["input"]>
  _gte?: InputMaybe<Scalars["credit_check_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["credit_check_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["credit_check_status"]["input"]>
  _lte?: InputMaybe<Scalars["credit_check_status"]["input"]>
  _neq?: InputMaybe<Scalars["credit_check_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["credit_check_status"]["input"]>>
}

/** columns and relationships of "cs__soe_dashboard_total" */
export type Cs__Soe_Dashboard_Total = {
  __typename?: "cs__soe_dashboard_total"
  comms_hub_id?: Maybe<Scalars["String"]["output"]>
  dev_status?: Maybe<Scalars["String"]["output"]>
  device_id?: Maybe<Scalars["String"]["output"]>
  error?: Maybe<Scalars["String"]["output"]>
  error_status?: Maybe<Scalars["String"]["output"]>
  firmware_status?: Maybe<Scalars["String"]["output"]>
  firmware_version?: Maybe<Scalars["String"]["output"]>
  gbcs_version?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  installation_date?: Maybe<Scalars["String"]["output"]>
  last_orchestration?: Maybe<Scalars["String"]["output"]>
  last_reading?: Maybe<Scalars["String"]["output"]>
  last_reading_date_time?: Maybe<Scalars["String"]["output"]>
  last_updated?: Maybe<Scalars["String"]["output"]>
  latest_alert_code?: Maybe<Scalars["String"]["output"]>
  latest_alert_date?: Maybe<Scalars["String"]["output"]>
  latest_alert_status?: Maybe<Scalars["String"]["output"]>
  manufacturer?: Maybe<Scalars["String"]["output"]>
  meter_type?: Maybe<Scalars["String"]["output"]>
  model?: Maybe<Scalars["String"]["output"]>
  mpxn?: Maybe<Scalars["String"]["output"]>
  msn?: Maybe<Scalars["String"]["output"]>
  orchestration_status?: Maybe<Scalars["String"]["output"]>
  payment_mode?: Maybe<Scalars["String"]["output"]>
  pk: Scalars["bigint"]["output"]
  region?: Maybe<Scalars["String"]["output"]>
  smets_version?: Maybe<Scalars["String"]["output"]>
  srv?: Maybe<Scalars["String"]["output"]>
  ssd?: Maybe<Scalars["String"]["output"]>
  variant?: Maybe<Scalars["String"]["output"]>
  workstream?: Maybe<Scalars["String"]["output"]>
}

/** aggregated selection of "cs__soe_dashboard_total" */
export type Cs__Soe_Dashboard_Total_Aggregate = {
  __typename?: "cs__soe_dashboard_total_aggregate"
  aggregate?: Maybe<Cs__Soe_Dashboard_Total_Aggregate_Fields>
  nodes: Array<Cs__Soe_Dashboard_Total>
}

/** aggregate fields of "cs__soe_dashboard_total" */
export type Cs__Soe_Dashboard_Total_Aggregate_Fields = {
  __typename?: "cs__soe_dashboard_total_aggregate_fields"
  avg?: Maybe<Cs__Soe_Dashboard_Total_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Cs__Soe_Dashboard_Total_Max_Fields>
  min?: Maybe<Cs__Soe_Dashboard_Total_Min_Fields>
  stddev?: Maybe<Cs__Soe_Dashboard_Total_Stddev_Fields>
  stddev_pop?: Maybe<Cs__Soe_Dashboard_Total_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Cs__Soe_Dashboard_Total_Stddev_Samp_Fields>
  sum?: Maybe<Cs__Soe_Dashboard_Total_Sum_Fields>
  var_pop?: Maybe<Cs__Soe_Dashboard_Total_Var_Pop_Fields>
  var_samp?: Maybe<Cs__Soe_Dashboard_Total_Var_Samp_Fields>
  variance?: Maybe<Cs__Soe_Dashboard_Total_Variance_Fields>
}

/** aggregate fields of "cs__soe_dashboard_total" */
export type Cs__Soe_Dashboard_Total_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cs__Soe_Dashboard_Total_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Cs__Soe_Dashboard_Total_Avg_Fields = {
  __typename?: "cs__soe_dashboard_total_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  pk?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "cs__soe_dashboard_total". All fields are combined with a logical 'AND'. */
export type Cs__Soe_Dashboard_Total_Bool_Exp = {
  _and?: InputMaybe<Array<Cs__Soe_Dashboard_Total_Bool_Exp>>
  _not?: InputMaybe<Cs__Soe_Dashboard_Total_Bool_Exp>
  _or?: InputMaybe<Array<Cs__Soe_Dashboard_Total_Bool_Exp>>
  comms_hub_id?: InputMaybe<String_Comparison_Exp>
  dev_status?: InputMaybe<String_Comparison_Exp>
  device_id?: InputMaybe<String_Comparison_Exp>
  error?: InputMaybe<String_Comparison_Exp>
  error_status?: InputMaybe<String_Comparison_Exp>
  firmware_status?: InputMaybe<String_Comparison_Exp>
  firmware_version?: InputMaybe<String_Comparison_Exp>
  gbcs_version?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  installation_date?: InputMaybe<String_Comparison_Exp>
  last_orchestration?: InputMaybe<String_Comparison_Exp>
  last_reading?: InputMaybe<String_Comparison_Exp>
  last_reading_date_time?: InputMaybe<String_Comparison_Exp>
  last_updated?: InputMaybe<String_Comparison_Exp>
  latest_alert_code?: InputMaybe<String_Comparison_Exp>
  latest_alert_date?: InputMaybe<String_Comparison_Exp>
  latest_alert_status?: InputMaybe<String_Comparison_Exp>
  manufacturer?: InputMaybe<String_Comparison_Exp>
  meter_type?: InputMaybe<String_Comparison_Exp>
  model?: InputMaybe<String_Comparison_Exp>
  mpxn?: InputMaybe<String_Comparison_Exp>
  msn?: InputMaybe<String_Comparison_Exp>
  orchestration_status?: InputMaybe<String_Comparison_Exp>
  payment_mode?: InputMaybe<String_Comparison_Exp>
  pk?: InputMaybe<Bigint_Comparison_Exp>
  region?: InputMaybe<String_Comparison_Exp>
  smets_version?: InputMaybe<String_Comparison_Exp>
  srv?: InputMaybe<String_Comparison_Exp>
  ssd?: InputMaybe<String_Comparison_Exp>
  variant?: InputMaybe<String_Comparison_Exp>
  workstream?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "cs__soe_dashboard_total" */
export enum Cs__Soe_Dashboard_Total_Constraint {
  /** unique or primary key constraint on columns "id" */
  CsSoeDashboardTotalPkey = "cs__soe_dashboard_total_pkey",
}

/** input type for incrementing numeric columns in table "cs__soe_dashboard_total" */
export type Cs__Soe_Dashboard_Total_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  pk?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "cs__soe_dashboard_total" */
export type Cs__Soe_Dashboard_Total_Insert_Input = {
  comms_hub_id?: InputMaybe<Scalars["String"]["input"]>
  dev_status?: InputMaybe<Scalars["String"]["input"]>
  device_id?: InputMaybe<Scalars["String"]["input"]>
  error?: InputMaybe<Scalars["String"]["input"]>
  error_status?: InputMaybe<Scalars["String"]["input"]>
  firmware_status?: InputMaybe<Scalars["String"]["input"]>
  firmware_version?: InputMaybe<Scalars["String"]["input"]>
  gbcs_version?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  installation_date?: InputMaybe<Scalars["String"]["input"]>
  last_orchestration?: InputMaybe<Scalars["String"]["input"]>
  last_reading?: InputMaybe<Scalars["String"]["input"]>
  last_reading_date_time?: InputMaybe<Scalars["String"]["input"]>
  last_updated?: InputMaybe<Scalars["String"]["input"]>
  latest_alert_code?: InputMaybe<Scalars["String"]["input"]>
  latest_alert_date?: InputMaybe<Scalars["String"]["input"]>
  latest_alert_status?: InputMaybe<Scalars["String"]["input"]>
  manufacturer?: InputMaybe<Scalars["String"]["input"]>
  meter_type?: InputMaybe<Scalars["String"]["input"]>
  model?: InputMaybe<Scalars["String"]["input"]>
  mpxn?: InputMaybe<Scalars["String"]["input"]>
  msn?: InputMaybe<Scalars["String"]["input"]>
  orchestration_status?: InputMaybe<Scalars["String"]["input"]>
  payment_mode?: InputMaybe<Scalars["String"]["input"]>
  pk?: InputMaybe<Scalars["bigint"]["input"]>
  region?: InputMaybe<Scalars["String"]["input"]>
  smets_version?: InputMaybe<Scalars["String"]["input"]>
  srv?: InputMaybe<Scalars["String"]["input"]>
  ssd?: InputMaybe<Scalars["String"]["input"]>
  variant?: InputMaybe<Scalars["String"]["input"]>
  workstream?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Cs__Soe_Dashboard_Total_Max_Fields = {
  __typename?: "cs__soe_dashboard_total_max_fields"
  comms_hub_id?: Maybe<Scalars["String"]["output"]>
  dev_status?: Maybe<Scalars["String"]["output"]>
  device_id?: Maybe<Scalars["String"]["output"]>
  error?: Maybe<Scalars["String"]["output"]>
  error_status?: Maybe<Scalars["String"]["output"]>
  firmware_status?: Maybe<Scalars["String"]["output"]>
  firmware_version?: Maybe<Scalars["String"]["output"]>
  gbcs_version?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  installation_date?: Maybe<Scalars["String"]["output"]>
  last_orchestration?: Maybe<Scalars["String"]["output"]>
  last_reading?: Maybe<Scalars["String"]["output"]>
  last_reading_date_time?: Maybe<Scalars["String"]["output"]>
  last_updated?: Maybe<Scalars["String"]["output"]>
  latest_alert_code?: Maybe<Scalars["String"]["output"]>
  latest_alert_date?: Maybe<Scalars["String"]["output"]>
  latest_alert_status?: Maybe<Scalars["String"]["output"]>
  manufacturer?: Maybe<Scalars["String"]["output"]>
  meter_type?: Maybe<Scalars["String"]["output"]>
  model?: Maybe<Scalars["String"]["output"]>
  mpxn?: Maybe<Scalars["String"]["output"]>
  msn?: Maybe<Scalars["String"]["output"]>
  orchestration_status?: Maybe<Scalars["String"]["output"]>
  payment_mode?: Maybe<Scalars["String"]["output"]>
  pk?: Maybe<Scalars["bigint"]["output"]>
  region?: Maybe<Scalars["String"]["output"]>
  smets_version?: Maybe<Scalars["String"]["output"]>
  srv?: Maybe<Scalars["String"]["output"]>
  ssd?: Maybe<Scalars["String"]["output"]>
  variant?: Maybe<Scalars["String"]["output"]>
  workstream?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Cs__Soe_Dashboard_Total_Min_Fields = {
  __typename?: "cs__soe_dashboard_total_min_fields"
  comms_hub_id?: Maybe<Scalars["String"]["output"]>
  dev_status?: Maybe<Scalars["String"]["output"]>
  device_id?: Maybe<Scalars["String"]["output"]>
  error?: Maybe<Scalars["String"]["output"]>
  error_status?: Maybe<Scalars["String"]["output"]>
  firmware_status?: Maybe<Scalars["String"]["output"]>
  firmware_version?: Maybe<Scalars["String"]["output"]>
  gbcs_version?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  installation_date?: Maybe<Scalars["String"]["output"]>
  last_orchestration?: Maybe<Scalars["String"]["output"]>
  last_reading?: Maybe<Scalars["String"]["output"]>
  last_reading_date_time?: Maybe<Scalars["String"]["output"]>
  last_updated?: Maybe<Scalars["String"]["output"]>
  latest_alert_code?: Maybe<Scalars["String"]["output"]>
  latest_alert_date?: Maybe<Scalars["String"]["output"]>
  latest_alert_status?: Maybe<Scalars["String"]["output"]>
  manufacturer?: Maybe<Scalars["String"]["output"]>
  meter_type?: Maybe<Scalars["String"]["output"]>
  model?: Maybe<Scalars["String"]["output"]>
  mpxn?: Maybe<Scalars["String"]["output"]>
  msn?: Maybe<Scalars["String"]["output"]>
  orchestration_status?: Maybe<Scalars["String"]["output"]>
  payment_mode?: Maybe<Scalars["String"]["output"]>
  pk?: Maybe<Scalars["bigint"]["output"]>
  region?: Maybe<Scalars["String"]["output"]>
  smets_version?: Maybe<Scalars["String"]["output"]>
  srv?: Maybe<Scalars["String"]["output"]>
  ssd?: Maybe<Scalars["String"]["output"]>
  variant?: Maybe<Scalars["String"]["output"]>
  workstream?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "cs__soe_dashboard_total" */
export type Cs__Soe_Dashboard_Total_Mutation_Response = {
  __typename?: "cs__soe_dashboard_total_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Cs__Soe_Dashboard_Total>
}

/** on_conflict condition type for table "cs__soe_dashboard_total" */
export type Cs__Soe_Dashboard_Total_On_Conflict = {
  constraint: Cs__Soe_Dashboard_Total_Constraint
  update_columns?: Array<Cs__Soe_Dashboard_Total_Update_Column>
  where?: InputMaybe<Cs__Soe_Dashboard_Total_Bool_Exp>
}

/** Ordering options when selecting data from "cs__soe_dashboard_total". */
export type Cs__Soe_Dashboard_Total_Order_By = {
  comms_hub_id?: InputMaybe<Order_By>
  dev_status?: InputMaybe<Order_By>
  device_id?: InputMaybe<Order_By>
  error?: InputMaybe<Order_By>
  error_status?: InputMaybe<Order_By>
  firmware_status?: InputMaybe<Order_By>
  firmware_version?: InputMaybe<Order_By>
  gbcs_version?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  installation_date?: InputMaybe<Order_By>
  last_orchestration?: InputMaybe<Order_By>
  last_reading?: InputMaybe<Order_By>
  last_reading_date_time?: InputMaybe<Order_By>
  last_updated?: InputMaybe<Order_By>
  latest_alert_code?: InputMaybe<Order_By>
  latest_alert_date?: InputMaybe<Order_By>
  latest_alert_status?: InputMaybe<Order_By>
  manufacturer?: InputMaybe<Order_By>
  meter_type?: InputMaybe<Order_By>
  model?: InputMaybe<Order_By>
  mpxn?: InputMaybe<Order_By>
  msn?: InputMaybe<Order_By>
  orchestration_status?: InputMaybe<Order_By>
  payment_mode?: InputMaybe<Order_By>
  pk?: InputMaybe<Order_By>
  region?: InputMaybe<Order_By>
  smets_version?: InputMaybe<Order_By>
  srv?: InputMaybe<Order_By>
  ssd?: InputMaybe<Order_By>
  variant?: InputMaybe<Order_By>
  workstream?: InputMaybe<Order_By>
}

/** primary key columns input for table: cs__soe_dashboard_total */
export type Cs__Soe_Dashboard_Total_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "cs__soe_dashboard_total" */
export enum Cs__Soe_Dashboard_Total_Select_Column {
  /** column name */
  CommsHubId = "comms_hub_id",
  /** column name */
  DevStatus = "dev_status",
  /** column name */
  DeviceId = "device_id",
  /** column name */
  Error = "error",
  /** column name */
  ErrorStatus = "error_status",
  /** column name */
  FirmwareStatus = "firmware_status",
  /** column name */
  FirmwareVersion = "firmware_version",
  /** column name */
  GbcsVersion = "gbcs_version",
  /** column name */
  Id = "id",
  /** column name */
  InstallationDate = "installation_date",
  /** column name */
  LastOrchestration = "last_orchestration",
  /** column name */
  LastReading = "last_reading",
  /** column name */
  LastReadingDateTime = "last_reading_date_time",
  /** column name */
  LastUpdated = "last_updated",
  /** column name */
  LatestAlertCode = "latest_alert_code",
  /** column name */
  LatestAlertDate = "latest_alert_date",
  /** column name */
  LatestAlertStatus = "latest_alert_status",
  /** column name */
  Manufacturer = "manufacturer",
  /** column name */
  MeterType = "meter_type",
  /** column name */
  Model = "model",
  /** column name */
  Mpxn = "mpxn",
  /** column name */
  Msn = "msn",
  /** column name */
  OrchestrationStatus = "orchestration_status",
  /** column name */
  PaymentMode = "payment_mode",
  /** column name */
  Pk = "pk",
  /** column name */
  Region = "region",
  /** column name */
  SmetsVersion = "smets_version",
  /** column name */
  Srv = "srv",
  /** column name */
  Ssd = "ssd",
  /** column name */
  Variant = "variant",
  /** column name */
  Workstream = "workstream",
}

/** input type for updating data in table "cs__soe_dashboard_total" */
export type Cs__Soe_Dashboard_Total_Set_Input = {
  comms_hub_id?: InputMaybe<Scalars["String"]["input"]>
  dev_status?: InputMaybe<Scalars["String"]["input"]>
  device_id?: InputMaybe<Scalars["String"]["input"]>
  error?: InputMaybe<Scalars["String"]["input"]>
  error_status?: InputMaybe<Scalars["String"]["input"]>
  firmware_status?: InputMaybe<Scalars["String"]["input"]>
  firmware_version?: InputMaybe<Scalars["String"]["input"]>
  gbcs_version?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  installation_date?: InputMaybe<Scalars["String"]["input"]>
  last_orchestration?: InputMaybe<Scalars["String"]["input"]>
  last_reading?: InputMaybe<Scalars["String"]["input"]>
  last_reading_date_time?: InputMaybe<Scalars["String"]["input"]>
  last_updated?: InputMaybe<Scalars["String"]["input"]>
  latest_alert_code?: InputMaybe<Scalars["String"]["input"]>
  latest_alert_date?: InputMaybe<Scalars["String"]["input"]>
  latest_alert_status?: InputMaybe<Scalars["String"]["input"]>
  manufacturer?: InputMaybe<Scalars["String"]["input"]>
  meter_type?: InputMaybe<Scalars["String"]["input"]>
  model?: InputMaybe<Scalars["String"]["input"]>
  mpxn?: InputMaybe<Scalars["String"]["input"]>
  msn?: InputMaybe<Scalars["String"]["input"]>
  orchestration_status?: InputMaybe<Scalars["String"]["input"]>
  payment_mode?: InputMaybe<Scalars["String"]["input"]>
  pk?: InputMaybe<Scalars["bigint"]["input"]>
  region?: InputMaybe<Scalars["String"]["input"]>
  smets_version?: InputMaybe<Scalars["String"]["input"]>
  srv?: InputMaybe<Scalars["String"]["input"]>
  ssd?: InputMaybe<Scalars["String"]["input"]>
  variant?: InputMaybe<Scalars["String"]["input"]>
  workstream?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Cs__Soe_Dashboard_Total_Stddev_Fields = {
  __typename?: "cs__soe_dashboard_total_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  pk?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Cs__Soe_Dashboard_Total_Stddev_Pop_Fields = {
  __typename?: "cs__soe_dashboard_total_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  pk?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Cs__Soe_Dashboard_Total_Stddev_Samp_Fields = {
  __typename?: "cs__soe_dashboard_total_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  pk?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "cs__soe_dashboard_total" */
export type Cs__Soe_Dashboard_Total_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cs__Soe_Dashboard_Total_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Cs__Soe_Dashboard_Total_Stream_Cursor_Value_Input = {
  comms_hub_id?: InputMaybe<Scalars["String"]["input"]>
  dev_status?: InputMaybe<Scalars["String"]["input"]>
  device_id?: InputMaybe<Scalars["String"]["input"]>
  error?: InputMaybe<Scalars["String"]["input"]>
  error_status?: InputMaybe<Scalars["String"]["input"]>
  firmware_status?: InputMaybe<Scalars["String"]["input"]>
  firmware_version?: InputMaybe<Scalars["String"]["input"]>
  gbcs_version?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  installation_date?: InputMaybe<Scalars["String"]["input"]>
  last_orchestration?: InputMaybe<Scalars["String"]["input"]>
  last_reading?: InputMaybe<Scalars["String"]["input"]>
  last_reading_date_time?: InputMaybe<Scalars["String"]["input"]>
  last_updated?: InputMaybe<Scalars["String"]["input"]>
  latest_alert_code?: InputMaybe<Scalars["String"]["input"]>
  latest_alert_date?: InputMaybe<Scalars["String"]["input"]>
  latest_alert_status?: InputMaybe<Scalars["String"]["input"]>
  manufacturer?: InputMaybe<Scalars["String"]["input"]>
  meter_type?: InputMaybe<Scalars["String"]["input"]>
  model?: InputMaybe<Scalars["String"]["input"]>
  mpxn?: InputMaybe<Scalars["String"]["input"]>
  msn?: InputMaybe<Scalars["String"]["input"]>
  orchestration_status?: InputMaybe<Scalars["String"]["input"]>
  payment_mode?: InputMaybe<Scalars["String"]["input"]>
  pk?: InputMaybe<Scalars["bigint"]["input"]>
  region?: InputMaybe<Scalars["String"]["input"]>
  smets_version?: InputMaybe<Scalars["String"]["input"]>
  srv?: InputMaybe<Scalars["String"]["input"]>
  ssd?: InputMaybe<Scalars["String"]["input"]>
  variant?: InputMaybe<Scalars["String"]["input"]>
  workstream?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Cs__Soe_Dashboard_Total_Sum_Fields = {
  __typename?: "cs__soe_dashboard_total_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  pk?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "cs__soe_dashboard_total" */
export enum Cs__Soe_Dashboard_Total_Update_Column {
  /** column name */
  CommsHubId = "comms_hub_id",
  /** column name */
  DevStatus = "dev_status",
  /** column name */
  DeviceId = "device_id",
  /** column name */
  Error = "error",
  /** column name */
  ErrorStatus = "error_status",
  /** column name */
  FirmwareStatus = "firmware_status",
  /** column name */
  FirmwareVersion = "firmware_version",
  /** column name */
  GbcsVersion = "gbcs_version",
  /** column name */
  Id = "id",
  /** column name */
  InstallationDate = "installation_date",
  /** column name */
  LastOrchestration = "last_orchestration",
  /** column name */
  LastReading = "last_reading",
  /** column name */
  LastReadingDateTime = "last_reading_date_time",
  /** column name */
  LastUpdated = "last_updated",
  /** column name */
  LatestAlertCode = "latest_alert_code",
  /** column name */
  LatestAlertDate = "latest_alert_date",
  /** column name */
  LatestAlertStatus = "latest_alert_status",
  /** column name */
  Manufacturer = "manufacturer",
  /** column name */
  MeterType = "meter_type",
  /** column name */
  Model = "model",
  /** column name */
  Mpxn = "mpxn",
  /** column name */
  Msn = "msn",
  /** column name */
  OrchestrationStatus = "orchestration_status",
  /** column name */
  PaymentMode = "payment_mode",
  /** column name */
  Pk = "pk",
  /** column name */
  Region = "region",
  /** column name */
  SmetsVersion = "smets_version",
  /** column name */
  Srv = "srv",
  /** column name */
  Ssd = "ssd",
  /** column name */
  Variant = "variant",
  /** column name */
  Workstream = "workstream",
}

export type Cs__Soe_Dashboard_Total_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cs__Soe_Dashboard_Total_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cs__Soe_Dashboard_Total_Set_Input>
  /** filter the rows which have to be updated */
  where: Cs__Soe_Dashboard_Total_Bool_Exp
}

/** aggregate var_pop on columns */
export type Cs__Soe_Dashboard_Total_Var_Pop_Fields = {
  __typename?: "cs__soe_dashboard_total_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  pk?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Cs__Soe_Dashboard_Total_Var_Samp_Fields = {
  __typename?: "cs__soe_dashboard_total_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  pk?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Cs__Soe_Dashboard_Total_Variance_Fields = {
  __typename?: "cs__soe_dashboard_total_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  pk?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "current_future_product_details" */
export type Current_Future_Product_Details = {
  __typename?: "current_future_product_details"
  available_to_public?: Maybe<Scalars["Boolean"]["output"]>
  bundle_df_type_name?: Maybe<Scalars["String"]["output"]>
  bundle_dfn_group_code?: Maybe<Scalars["String"]["output"]>
  charge_value?: Maybe<Scalars["numeric"]["output"]>
  code?: Maybe<Scalars["String"]["output"]>
  direct_debit?: Maybe<Scalars["Boolean"]["output"]>
  display_name?: Maybe<Scalars["String"]["output"]>
  duration_value?: Maybe<Scalars["Int"]["output"]>
  early_termination_charge?: Maybe<Scalars["numeric"]["output"]>
  export?: Maybe<Scalars["Boolean"]["output"]>
  from_dt?: Maybe<Scalars["date"]["output"]>
  gsp_group?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  smart_payg?: Maybe<Scalars["Boolean"]["output"]>
  tariff_rates?: Maybe<Scalars["jsonb"]["output"]>
  variant_from_dt?: Maybe<Scalars["date"]["output"]>
  variant_type?: Maybe<Scalars["product_variant_type"]["output"]>
  vat_rate?: Maybe<Scalars["numeric"]["output"]>
}

/** columns and relationships of "current_future_product_details" */
export type Current_Future_Product_DetailsTariff_RatesArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregated selection of "current_future_product_details" */
export type Current_Future_Product_Details_Aggregate = {
  __typename?: "current_future_product_details_aggregate"
  aggregate?: Maybe<Current_Future_Product_Details_Aggregate_Fields>
  nodes: Array<Current_Future_Product_Details>
}

/** aggregate fields of "current_future_product_details" */
export type Current_Future_Product_Details_Aggregate_Fields = {
  __typename?: "current_future_product_details_aggregate_fields"
  avg?: Maybe<Current_Future_Product_Details_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Current_Future_Product_Details_Max_Fields>
  min?: Maybe<Current_Future_Product_Details_Min_Fields>
  stddev?: Maybe<Current_Future_Product_Details_Stddev_Fields>
  stddev_pop?: Maybe<Current_Future_Product_Details_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Current_Future_Product_Details_Stddev_Samp_Fields>
  sum?: Maybe<Current_Future_Product_Details_Sum_Fields>
  var_pop?: Maybe<Current_Future_Product_Details_Var_Pop_Fields>
  var_samp?: Maybe<Current_Future_Product_Details_Var_Samp_Fields>
  variance?: Maybe<Current_Future_Product_Details_Variance_Fields>
}

/** aggregate fields of "current_future_product_details" */
export type Current_Future_Product_Details_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Current_Future_Product_Details_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Current_Future_Product_Details_Avg_Fields = {
  __typename?: "current_future_product_details_avg_fields"
  charge_value?: Maybe<Scalars["Float"]["output"]>
  duration_value?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  vat_rate?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "current_future_product_details". All fields are combined with a logical 'AND'. */
export type Current_Future_Product_Details_Bool_Exp = {
  _and?: InputMaybe<Array<Current_Future_Product_Details_Bool_Exp>>
  _not?: InputMaybe<Current_Future_Product_Details_Bool_Exp>
  _or?: InputMaybe<Array<Current_Future_Product_Details_Bool_Exp>>
  available_to_public?: InputMaybe<Boolean_Comparison_Exp>
  bundle_df_type_name?: InputMaybe<String_Comparison_Exp>
  bundle_dfn_group_code?: InputMaybe<String_Comparison_Exp>
  charge_value?: InputMaybe<Numeric_Comparison_Exp>
  code?: InputMaybe<String_Comparison_Exp>
  direct_debit?: InputMaybe<Boolean_Comparison_Exp>
  display_name?: InputMaybe<String_Comparison_Exp>
  duration_value?: InputMaybe<Int_Comparison_Exp>
  early_termination_charge?: InputMaybe<Numeric_Comparison_Exp>
  export?: InputMaybe<Boolean_Comparison_Exp>
  from_dt?: InputMaybe<Date_Comparison_Exp>
  gsp_group?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  smart_payg?: InputMaybe<Boolean_Comparison_Exp>
  tariff_rates?: InputMaybe<Jsonb_Comparison_Exp>
  variant_from_dt?: InputMaybe<Date_Comparison_Exp>
  variant_type?: InputMaybe<Product_Variant_Type_Comparison_Exp>
  vat_rate?: InputMaybe<Numeric_Comparison_Exp>
}

/** aggregate max on columns */
export type Current_Future_Product_Details_Max_Fields = {
  __typename?: "current_future_product_details_max_fields"
  bundle_df_type_name?: Maybe<Scalars["String"]["output"]>
  bundle_dfn_group_code?: Maybe<Scalars["String"]["output"]>
  charge_value?: Maybe<Scalars["numeric"]["output"]>
  code?: Maybe<Scalars["String"]["output"]>
  display_name?: Maybe<Scalars["String"]["output"]>
  duration_value?: Maybe<Scalars["Int"]["output"]>
  early_termination_charge?: Maybe<Scalars["numeric"]["output"]>
  from_dt?: Maybe<Scalars["date"]["output"]>
  gsp_group?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  variant_from_dt?: Maybe<Scalars["date"]["output"]>
  variant_type?: Maybe<Scalars["product_variant_type"]["output"]>
  vat_rate?: Maybe<Scalars["numeric"]["output"]>
}

/** aggregate min on columns */
export type Current_Future_Product_Details_Min_Fields = {
  __typename?: "current_future_product_details_min_fields"
  bundle_df_type_name?: Maybe<Scalars["String"]["output"]>
  bundle_dfn_group_code?: Maybe<Scalars["String"]["output"]>
  charge_value?: Maybe<Scalars["numeric"]["output"]>
  code?: Maybe<Scalars["String"]["output"]>
  display_name?: Maybe<Scalars["String"]["output"]>
  duration_value?: Maybe<Scalars["Int"]["output"]>
  early_termination_charge?: Maybe<Scalars["numeric"]["output"]>
  from_dt?: Maybe<Scalars["date"]["output"]>
  gsp_group?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  variant_from_dt?: Maybe<Scalars["date"]["output"]>
  variant_type?: Maybe<Scalars["product_variant_type"]["output"]>
  vat_rate?: Maybe<Scalars["numeric"]["output"]>
}

/** Ordering options when selecting data from "current_future_product_details". */
export type Current_Future_Product_Details_Order_By = {
  available_to_public?: InputMaybe<Order_By>
  bundle_df_type_name?: InputMaybe<Order_By>
  bundle_dfn_group_code?: InputMaybe<Order_By>
  charge_value?: InputMaybe<Order_By>
  code?: InputMaybe<Order_By>
  direct_debit?: InputMaybe<Order_By>
  display_name?: InputMaybe<Order_By>
  duration_value?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  export?: InputMaybe<Order_By>
  from_dt?: InputMaybe<Order_By>
  gsp_group?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  smart_payg?: InputMaybe<Order_By>
  tariff_rates?: InputMaybe<Order_By>
  variant_from_dt?: InputMaybe<Order_By>
  variant_type?: InputMaybe<Order_By>
  vat_rate?: InputMaybe<Order_By>
}

/** select columns of table "current_future_product_details" */
export enum Current_Future_Product_Details_Select_Column {
  /** column name */
  AvailableToPublic = "available_to_public",
  /** column name */
  BundleDfTypeName = "bundle_df_type_name",
  /** column name */
  BundleDfnGroupCode = "bundle_dfn_group_code",
  /** column name */
  ChargeValue = "charge_value",
  /** column name */
  Code = "code",
  /** column name */
  DirectDebit = "direct_debit",
  /** column name */
  DisplayName = "display_name",
  /** column name */
  DurationValue = "duration_value",
  /** column name */
  EarlyTerminationCharge = "early_termination_charge",
  /** column name */
  Export = "export",
  /** column name */
  FromDt = "from_dt",
  /** column name */
  GspGroup = "gsp_group",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  SmartPayg = "smart_payg",
  /** column name */
  TariffRates = "tariff_rates",
  /** column name */
  VariantFromDt = "variant_from_dt",
  /** column name */
  VariantType = "variant_type",
  /** column name */
  VatRate = "vat_rate",
}

/** aggregate stddev on columns */
export type Current_Future_Product_Details_Stddev_Fields = {
  __typename?: "current_future_product_details_stddev_fields"
  charge_value?: Maybe<Scalars["Float"]["output"]>
  duration_value?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  vat_rate?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Current_Future_Product_Details_Stddev_Pop_Fields = {
  __typename?: "current_future_product_details_stddev_pop_fields"
  charge_value?: Maybe<Scalars["Float"]["output"]>
  duration_value?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  vat_rate?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Current_Future_Product_Details_Stddev_Samp_Fields = {
  __typename?: "current_future_product_details_stddev_samp_fields"
  charge_value?: Maybe<Scalars["Float"]["output"]>
  duration_value?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  vat_rate?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "current_future_product_details" */
export type Current_Future_Product_Details_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Current_Future_Product_Details_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Current_Future_Product_Details_Stream_Cursor_Value_Input = {
  available_to_public?: InputMaybe<Scalars["Boolean"]["input"]>
  bundle_df_type_name?: InputMaybe<Scalars["String"]["input"]>
  bundle_dfn_group_code?: InputMaybe<Scalars["String"]["input"]>
  charge_value?: InputMaybe<Scalars["numeric"]["input"]>
  code?: InputMaybe<Scalars["String"]["input"]>
  direct_debit?: InputMaybe<Scalars["Boolean"]["input"]>
  display_name?: InputMaybe<Scalars["String"]["input"]>
  duration_value?: InputMaybe<Scalars["Int"]["input"]>
  early_termination_charge?: InputMaybe<Scalars["numeric"]["input"]>
  export?: InputMaybe<Scalars["Boolean"]["input"]>
  from_dt?: InputMaybe<Scalars["date"]["input"]>
  gsp_group?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  smart_payg?: InputMaybe<Scalars["Boolean"]["input"]>
  tariff_rates?: InputMaybe<Scalars["jsonb"]["input"]>
  variant_from_dt?: InputMaybe<Scalars["date"]["input"]>
  variant_type?: InputMaybe<Scalars["product_variant_type"]["input"]>
  vat_rate?: InputMaybe<Scalars["numeric"]["input"]>
}

/** aggregate sum on columns */
export type Current_Future_Product_Details_Sum_Fields = {
  __typename?: "current_future_product_details_sum_fields"
  charge_value?: Maybe<Scalars["numeric"]["output"]>
  duration_value?: Maybe<Scalars["Int"]["output"]>
  early_termination_charge?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  vat_rate?: Maybe<Scalars["numeric"]["output"]>
}

/** aggregate var_pop on columns */
export type Current_Future_Product_Details_Var_Pop_Fields = {
  __typename?: "current_future_product_details_var_pop_fields"
  charge_value?: Maybe<Scalars["Float"]["output"]>
  duration_value?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  vat_rate?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Current_Future_Product_Details_Var_Samp_Fields = {
  __typename?: "current_future_product_details_var_samp_fields"
  charge_value?: Maybe<Scalars["Float"]["output"]>
  duration_value?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  vat_rate?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Current_Future_Product_Details_Variance_Fields = {
  __typename?: "current_future_product_details_variance_fields"
  charge_value?: Maybe<Scalars["Float"]["output"]>
  duration_value?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  vat_rate?: Maybe<Scalars["Float"]["output"]>
}

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = "ASC",
  /** descending ordering of the cursor */
  Desc = "DESC",
}

/** columns and relationships of "customer" */
export type Customer = {
  __typename?: "customer"
  /** An array relationship */
  billing_accounts: Array<Billing_Account>
  /** An aggregate relationship */
  billing_accounts_aggregate: Billing_Account_Aggregate
  class: Scalars["customer_class"]["output"]
  created_at: Scalars["timestamp"]["output"]
  /** An array relationship */
  customerReferralsByReferredId: Array<Customer_Referrals>
  /** An aggregate relationship */
  customerReferralsByReferredId_aggregate: Customer_Referrals_Aggregate
  /** An array relationship */
  customer_contacts: Array<Customer_Contact>
  /** An aggregate relationship */
  customer_contacts_aggregate: Customer_Contact_Aggregate
  customer_metadata_id: Scalars["bigint"]["output"]
  /** An object relationship */
  customer_metadatum: Customer_Metadata
  /** An array relationship */
  customer_property_rels: Array<Customer_Property_Rel>
  /** An aggregate relationship */
  customer_property_rels_aggregate: Customer_Property_Rel_Aggregate
  /** An array relationship */
  customer_referrals: Array<Customer_Referrals>
  /** An aggregate relationship */
  customer_referrals_aggregate: Customer_Referrals_Aggregate
  /** An object relationship */
  customer_setting: Customer_Setting
  customer_setting_id: Scalars["bigint"]["output"]
  customer_user_rels: Array<Customer_User_Rel>
  customer_user_rels_aggregate: Customer_User_Rel_Aggregate
  dataerased?: Maybe<Scalars["timestamp"]["output"]>
  deceased?: Maybe<Scalars["Boolean"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  /** An array relationship */
  enrolments: Array<Enrolment>
  /** An aggregate relationship */
  enrolments_aggregate: Enrolment_Aggregate
  first_name: Scalars["String"]["output"]
  id: Scalars["bigint"]["output"]
  last_name: Scalars["String"]["output"]
  number: Scalars["String"]["output"]
  /** An array relationship */
  report_problems: Array<Report_Problem>
  /** An aggregate relationship */
  report_problems_aggregate: Report_Problem_Aggregate
  state?: Maybe<Scalars["String"]["output"]>
  type: Scalars["customer_type"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "customer" */
export type CustomerBilling_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Order_By>>
  where?: InputMaybe<Billing_Account_Bool_Exp>
}

/** columns and relationships of "customer" */
export type CustomerBilling_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Order_By>>
  where?: InputMaybe<Billing_Account_Bool_Exp>
}

/** columns and relationships of "customer" */
export type CustomerCustomerReferralsByReferredIdArgs = {
  distinct_on?: InputMaybe<Array<Customer_Referrals_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Referrals_Order_By>>
  where?: InputMaybe<Customer_Referrals_Bool_Exp>
}

/** columns and relationships of "customer" */
export type CustomerCustomerReferralsByReferredId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Referrals_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Referrals_Order_By>>
  where?: InputMaybe<Customer_Referrals_Bool_Exp>
}

/** columns and relationships of "customer" */
export type CustomerCustomer_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Contact_Order_By>>
  where?: InputMaybe<Customer_Contact_Bool_Exp>
}

/** columns and relationships of "customer" */
export type CustomerCustomer_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Contact_Order_By>>
  where?: InputMaybe<Customer_Contact_Bool_Exp>
}

/** columns and relationships of "customer" */
export type CustomerCustomer_Property_RelsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Property_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Property_Rel_Order_By>>
  where?: InputMaybe<Customer_Property_Rel_Bool_Exp>
}

/** columns and relationships of "customer" */
export type CustomerCustomer_Property_Rels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Property_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Property_Rel_Order_By>>
  where?: InputMaybe<Customer_Property_Rel_Bool_Exp>
}

/** columns and relationships of "customer" */
export type CustomerCustomer_ReferralsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Referrals_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Referrals_Order_By>>
  where?: InputMaybe<Customer_Referrals_Bool_Exp>
}

/** columns and relationships of "customer" */
export type CustomerCustomer_Referrals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Referrals_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Referrals_Order_By>>
  where?: InputMaybe<Customer_Referrals_Bool_Exp>
}

/** columns and relationships of "customer" */
export type CustomerCustomer_User_RelsArgs = {
  distinct_on?: InputMaybe<Array<Customer_User_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_User_Rel_Order_By>>
  where?: InputMaybe<Customer_User_Rel_Bool_Exp>
}

/** columns and relationships of "customer" */
export type CustomerCustomer_User_Rels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_User_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_User_Rel_Order_By>>
  where?: InputMaybe<Customer_User_Rel_Bool_Exp>
}

/** columns and relationships of "customer" */
export type CustomerEnrolmentsArgs = {
  distinct_on?: InputMaybe<Array<Enrolment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Enrolment_Order_By>>
  where?: InputMaybe<Enrolment_Bool_Exp>
}

/** columns and relationships of "customer" */
export type CustomerEnrolments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enrolment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Enrolment_Order_By>>
  where?: InputMaybe<Enrolment_Bool_Exp>
}

/** columns and relationships of "customer" */
export type CustomerReport_ProblemsArgs = {
  distinct_on?: InputMaybe<Array<Report_Problem_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Report_Problem_Order_By>>
  where?: InputMaybe<Report_Problem_Bool_Exp>
}

/** columns and relationships of "customer" */
export type CustomerReport_Problems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Problem_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Report_Problem_Order_By>>
  where?: InputMaybe<Report_Problem_Bool_Exp>
}

/** columns and relationships of "address" */
export type Customer_Address = {
  __typename?: "customer_address"
  address1?: Maybe<Scalars["String"]["output"]>
  address2?: Maybe<Scalars["String"]["output"]>
  address3?: Maybe<Scalars["String"]["output"]>
  address4?: Maybe<Scalars["String"]["output"]>
  address5?: Maybe<Scalars["String"]["output"]>
  address6?: Maybe<Scalars["String"]["output"]>
  address7?: Maybe<Scalars["String"]["output"]>
  address8?: Maybe<Scalars["String"]["output"]>
  address9?: Maybe<Scalars["String"]["output"]>
  /** An array relationship */
  contacts: Array<Contact>
  /** An aggregate relationship */
  contacts_aggregate: Contact_Aggregate
  country_code?: Maybe<Scalars["String"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  postcode?: Maybe<Scalars["String"]["output"]>
  type: Scalars["String"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "address" */
export type Customer_AddressContactsArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Contact_Order_By>>
  where?: InputMaybe<Contact_Bool_Exp>
}

/** columns and relationships of "address" */
export type Customer_AddressContacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Contact_Order_By>>
  where?: InputMaybe<Contact_Bool_Exp>
}

/** aggregated selection of "address" */
export type Customer_Address_Aggregate = {
  __typename?: "customer_address_aggregate"
  aggregate?: Maybe<Customer_Address_Aggregate_Fields>
  nodes: Array<Customer_Address>
}

/** aggregate fields of "address" */
export type Customer_Address_Aggregate_Fields = {
  __typename?: "customer_address_aggregate_fields"
  avg?: Maybe<Customer_Address_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Customer_Address_Max_Fields>
  min?: Maybe<Customer_Address_Min_Fields>
  stddev?: Maybe<Customer_Address_Stddev_Fields>
  stddev_pop?: Maybe<Customer_Address_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Customer_Address_Stddev_Samp_Fields>
  sum?: Maybe<Customer_Address_Sum_Fields>
  var_pop?: Maybe<Customer_Address_Var_Pop_Fields>
  var_samp?: Maybe<Customer_Address_Var_Samp_Fields>
  variance?: Maybe<Customer_Address_Variance_Fields>
}

/** aggregate fields of "address" */
export type Customer_Address_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Address_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Customer_Address_Avg_Fields = {
  __typename?: "customer_address_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "address". All fields are combined with a logical 'AND'. */
export type Customer_Address_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Address_Bool_Exp>>
  _not?: InputMaybe<Customer_Address_Bool_Exp>
  _or?: InputMaybe<Array<Customer_Address_Bool_Exp>>
  address1?: InputMaybe<String_Comparison_Exp>
  address2?: InputMaybe<String_Comparison_Exp>
  address3?: InputMaybe<String_Comparison_Exp>
  address4?: InputMaybe<String_Comparison_Exp>
  address5?: InputMaybe<String_Comparison_Exp>
  address6?: InputMaybe<String_Comparison_Exp>
  address7?: InputMaybe<String_Comparison_Exp>
  address8?: InputMaybe<String_Comparison_Exp>
  address9?: InputMaybe<String_Comparison_Exp>
  contacts?: InputMaybe<Contact_Bool_Exp>
  contacts_aggregate?: InputMaybe<Contact_Aggregate_Bool_Exp>
  country_code?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  postcode?: InputMaybe<String_Comparison_Exp>
  type?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "address" */
export enum Customer_Address_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkAddress = "pk_address",
}

/** input type for incrementing numeric columns in table "address" */
export type Customer_Address_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "address" */
export type Customer_Address_Insert_Input = {
  address1?: InputMaybe<Scalars["String"]["input"]>
  address2?: InputMaybe<Scalars["String"]["input"]>
  address3?: InputMaybe<Scalars["String"]["input"]>
  address4?: InputMaybe<Scalars["String"]["input"]>
  address5?: InputMaybe<Scalars["String"]["input"]>
  address6?: InputMaybe<Scalars["String"]["input"]>
  address7?: InputMaybe<Scalars["String"]["input"]>
  address8?: InputMaybe<Scalars["String"]["input"]>
  address9?: InputMaybe<Scalars["String"]["input"]>
  contacts?: InputMaybe<Contact_Arr_Rel_Insert_Input>
  country_code?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Customer_Address_Max_Fields = {
  __typename?: "customer_address_max_fields"
  address1?: Maybe<Scalars["String"]["output"]>
  address2?: Maybe<Scalars["String"]["output"]>
  address3?: Maybe<Scalars["String"]["output"]>
  address4?: Maybe<Scalars["String"]["output"]>
  address5?: Maybe<Scalars["String"]["output"]>
  address6?: Maybe<Scalars["String"]["output"]>
  address7?: Maybe<Scalars["String"]["output"]>
  address8?: Maybe<Scalars["String"]["output"]>
  address9?: Maybe<Scalars["String"]["output"]>
  country_code?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  postcode?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Customer_Address_Min_Fields = {
  __typename?: "customer_address_min_fields"
  address1?: Maybe<Scalars["String"]["output"]>
  address2?: Maybe<Scalars["String"]["output"]>
  address3?: Maybe<Scalars["String"]["output"]>
  address4?: Maybe<Scalars["String"]["output"]>
  address5?: Maybe<Scalars["String"]["output"]>
  address6?: Maybe<Scalars["String"]["output"]>
  address7?: Maybe<Scalars["String"]["output"]>
  address8?: Maybe<Scalars["String"]["output"]>
  address9?: Maybe<Scalars["String"]["output"]>
  country_code?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  postcode?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "address" */
export type Customer_Address_Mutation_Response = {
  __typename?: "customer_address_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Address>
}

/** input type for inserting object relation for remote table "address" */
export type Customer_Address_Obj_Rel_Insert_Input = {
  data: Customer_Address_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Address_On_Conflict>
}

/** on_conflict condition type for table "address" */
export type Customer_Address_On_Conflict = {
  constraint: Customer_Address_Constraint
  update_columns?: Array<Customer_Address_Update_Column>
  where?: InputMaybe<Customer_Address_Bool_Exp>
}

/** Ordering options when selecting data from "address". */
export type Customer_Address_Order_By = {
  address1?: InputMaybe<Order_By>
  address2?: InputMaybe<Order_By>
  address3?: InputMaybe<Order_By>
  address4?: InputMaybe<Order_By>
  address5?: InputMaybe<Order_By>
  address6?: InputMaybe<Order_By>
  address7?: InputMaybe<Order_By>
  address8?: InputMaybe<Order_By>
  address9?: InputMaybe<Order_By>
  contacts_aggregate?: InputMaybe<Contact_Aggregate_Order_By>
  country_code?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  postcode?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: address */
export type Customer_Address_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "address" */
export enum Customer_Address_Select_Column {
  /** column name */
  Address1 = "address1",
  /** column name */
  Address2 = "address2",
  /** column name */
  Address3 = "address3",
  /** column name */
  Address4 = "address4",
  /** column name */
  Address5 = "address5",
  /** column name */
  Address6 = "address6",
  /** column name */
  Address7 = "address7",
  /** column name */
  Address8 = "address8",
  /** column name */
  Address9 = "address9",
  /** column name */
  CountryCode = "country_code",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  Postcode = "postcode",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "address" */
export type Customer_Address_Set_Input = {
  address1?: InputMaybe<Scalars["String"]["input"]>
  address2?: InputMaybe<Scalars["String"]["input"]>
  address3?: InputMaybe<Scalars["String"]["input"]>
  address4?: InputMaybe<Scalars["String"]["input"]>
  address5?: InputMaybe<Scalars["String"]["input"]>
  address6?: InputMaybe<Scalars["String"]["input"]>
  address7?: InputMaybe<Scalars["String"]["input"]>
  address8?: InputMaybe<Scalars["String"]["input"]>
  address9?: InputMaybe<Scalars["String"]["input"]>
  country_code?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Customer_Address_Stddev_Fields = {
  __typename?: "customer_address_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Customer_Address_Stddev_Pop_Fields = {
  __typename?: "customer_address_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Customer_Address_Stddev_Samp_Fields = {
  __typename?: "customer_address_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "customer_address" */
export type Customer_Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Address_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Customer_Address_Stream_Cursor_Value_Input = {
  address1?: InputMaybe<Scalars["String"]["input"]>
  address2?: InputMaybe<Scalars["String"]["input"]>
  address3?: InputMaybe<Scalars["String"]["input"]>
  address4?: InputMaybe<Scalars["String"]["input"]>
  address5?: InputMaybe<Scalars["String"]["input"]>
  address6?: InputMaybe<Scalars["String"]["input"]>
  address7?: InputMaybe<Scalars["String"]["input"]>
  address8?: InputMaybe<Scalars["String"]["input"]>
  address9?: InputMaybe<Scalars["String"]["input"]>
  country_code?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Customer_Address_Sum_Fields = {
  __typename?: "customer_address_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "address" */
export enum Customer_Address_Update_Column {
  /** column name */
  Address1 = "address1",
  /** column name */
  Address2 = "address2",
  /** column name */
  Address3 = "address3",
  /** column name */
  Address4 = "address4",
  /** column name */
  Address5 = "address5",
  /** column name */
  Address6 = "address6",
  /** column name */
  Address7 = "address7",
  /** column name */
  Address8 = "address8",
  /** column name */
  Address9 = "address9",
  /** column name */
  CountryCode = "country_code",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  Postcode = "postcode",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Customer_Address_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Customer_Address_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Address_Set_Input>
  /** filter the rows which have to be updated */
  where: Customer_Address_Bool_Exp
}

/** aggregate var_pop on columns */
export type Customer_Address_Var_Pop_Fields = {
  __typename?: "customer_address_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Customer_Address_Var_Samp_Fields = {
  __typename?: "customer_address_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Customer_Address_Variance_Fields = {
  __typename?: "customer_address_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregated selection of "customer" */
export type Customer_Aggregate = {
  __typename?: "customer_aggregate"
  aggregate?: Maybe<Customer_Aggregate_Fields>
  nodes: Array<Customer>
}

export type Customer_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customer_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Customer_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<Customer_Aggregate_Bool_Exp_Count>
}

export type Customer_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customer_Select_Column_Customer_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Customer_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Customer_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customer_Select_Column_Customer_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Customer_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Customer_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Customer_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "customer" */
export type Customer_Aggregate_Fields = {
  __typename?: "customer_aggregate_fields"
  avg?: Maybe<Customer_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Customer_Max_Fields>
  min?: Maybe<Customer_Min_Fields>
  stddev?: Maybe<Customer_Stddev_Fields>
  stddev_pop?: Maybe<Customer_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Customer_Stddev_Samp_Fields>
  sum?: Maybe<Customer_Sum_Fields>
  var_pop?: Maybe<Customer_Var_Pop_Fields>
  var_samp?: Maybe<Customer_Var_Samp_Fields>
  variance?: Maybe<Customer_Variance_Fields>
}

/** aggregate fields of "customer" */
export type Customer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "customer" */
export type Customer_Aggregate_Order_By = {
  avg?: InputMaybe<Customer_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Customer_Max_Order_By>
  min?: InputMaybe<Customer_Min_Order_By>
  stddev?: InputMaybe<Customer_Stddev_Order_By>
  stddev_pop?: InputMaybe<Customer_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Customer_Stddev_Samp_Order_By>
  sum?: InputMaybe<Customer_Sum_Order_By>
  var_pop?: InputMaybe<Customer_Var_Pop_Order_By>
  var_samp?: InputMaybe<Customer_Var_Samp_Order_By>
  variance?: InputMaybe<Customer_Variance_Order_By>
}

/** input type for inserting array relation for remote table "customer" */
export type Customer_Arr_Rel_Insert_Input = {
  data: Array<Customer_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_On_Conflict>
}

/** aggregate avg on columns */
export type Customer_Avg_Fields = {
  __typename?: "customer_avg_fields"
  customer_metadata_id?: Maybe<Scalars["Float"]["output"]>
  customer_setting_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "customer" */
export type Customer_Avg_Order_By = {
  customer_metadata_id?: InputMaybe<Order_By>
  customer_setting_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "customer". All fields are combined with a logical 'AND'. */
export type Customer_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Bool_Exp>>
  _not?: InputMaybe<Customer_Bool_Exp>
  _or?: InputMaybe<Array<Customer_Bool_Exp>>
  billing_accounts?: InputMaybe<Billing_Account_Bool_Exp>
  billing_accounts_aggregate?: InputMaybe<Billing_Account_Aggregate_Bool_Exp>
  class?: InputMaybe<Customer_Class_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  customerReferralsByReferredId?: InputMaybe<Customer_Referrals_Bool_Exp>
  customerReferralsByReferredId_aggregate?: InputMaybe<Customer_Referrals_Aggregate_Bool_Exp>
  customer_contacts?: InputMaybe<Customer_Contact_Bool_Exp>
  customer_contacts_aggregate?: InputMaybe<Customer_Contact_Aggregate_Bool_Exp>
  customer_metadata_id?: InputMaybe<Bigint_Comparison_Exp>
  customer_metadatum?: InputMaybe<Customer_Metadata_Bool_Exp>
  customer_property_rels?: InputMaybe<Customer_Property_Rel_Bool_Exp>
  customer_property_rels_aggregate?: InputMaybe<Customer_Property_Rel_Aggregate_Bool_Exp>
  customer_referrals?: InputMaybe<Customer_Referrals_Bool_Exp>
  customer_referrals_aggregate?: InputMaybe<Customer_Referrals_Aggregate_Bool_Exp>
  customer_setting?: InputMaybe<Customer_Setting_Bool_Exp>
  customer_setting_id?: InputMaybe<Bigint_Comparison_Exp>
  customer_user_rels?: InputMaybe<Customer_User_Rel_Bool_Exp>
  customer_user_rels_aggregate?: InputMaybe<Customer_User_Rel_Aggregate_Bool_Exp>
  dataerased?: InputMaybe<Timestamp_Comparison_Exp>
  deceased?: InputMaybe<Boolean_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  enrolments?: InputMaybe<Enrolment_Bool_Exp>
  enrolments_aggregate?: InputMaybe<Enrolment_Aggregate_Bool_Exp>
  first_name?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  last_name?: InputMaybe<String_Comparison_Exp>
  number?: InputMaybe<String_Comparison_Exp>
  report_problems?: InputMaybe<Report_Problem_Bool_Exp>
  report_problems_aggregate?: InputMaybe<Report_Problem_Aggregate_Bool_Exp>
  state?: InputMaybe<String_Comparison_Exp>
  type?: InputMaybe<Customer_Type_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** Boolean expression to compare columns of type "customer_class". All fields are combined with logical 'AND'. */
export type Customer_Class_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["customer_class"]["input"]>
  _gt?: InputMaybe<Scalars["customer_class"]["input"]>
  _gte?: InputMaybe<Scalars["customer_class"]["input"]>
  _in?: InputMaybe<Array<Scalars["customer_class"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["customer_class"]["input"]>
  _lte?: InputMaybe<Scalars["customer_class"]["input"]>
  _neq?: InputMaybe<Scalars["customer_class"]["input"]>
  _nin?: InputMaybe<Array<Scalars["customer_class"]["input"]>>
}

/** unique or primary key constraints on table "customer" */
export enum Customer_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkCustomers = "pk_customers",
}

/** columns and relationships of "customer_contact" */
export type Customer_Contact = {
  __typename?: "customer_contact"
  cancelled?: Maybe<Scalars["timestamp"]["output"]>
  /** An object relationship */
  contact: Contact
  contact_id: Scalars["bigint"]["output"]
  created_at: Scalars["timestamp"]["output"]
  /** An object relationship */
  customer: Customer
  customer_id: Scalars["bigint"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_date?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  primary: Scalars["Boolean"]["output"]
  to_date?: Maybe<Scalars["timestamp"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "customer_contact" */
export type Customer_Contact_Aggregate = {
  __typename?: "customer_contact_aggregate"
  aggregate?: Maybe<Customer_Contact_Aggregate_Fields>
  nodes: Array<Customer_Contact>
}

export type Customer_Contact_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customer_Contact_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Customer_Contact_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<Customer_Contact_Aggregate_Bool_Exp_Count>
}

export type Customer_Contact_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customer_Contact_Select_Column_Customer_Contact_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Customer_Contact_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Customer_Contact_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customer_Contact_Select_Column_Customer_Contact_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Customer_Contact_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Customer_Contact_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Contact_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Customer_Contact_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "customer_contact" */
export type Customer_Contact_Aggregate_Fields = {
  __typename?: "customer_contact_aggregate_fields"
  avg?: Maybe<Customer_Contact_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Customer_Contact_Max_Fields>
  min?: Maybe<Customer_Contact_Min_Fields>
  stddev?: Maybe<Customer_Contact_Stddev_Fields>
  stddev_pop?: Maybe<Customer_Contact_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Customer_Contact_Stddev_Samp_Fields>
  sum?: Maybe<Customer_Contact_Sum_Fields>
  var_pop?: Maybe<Customer_Contact_Var_Pop_Fields>
  var_samp?: Maybe<Customer_Contact_Var_Samp_Fields>
  variance?: Maybe<Customer_Contact_Variance_Fields>
}

/** aggregate fields of "customer_contact" */
export type Customer_Contact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Contact_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "customer_contact" */
export type Customer_Contact_Aggregate_Order_By = {
  avg?: InputMaybe<Customer_Contact_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Customer_Contact_Max_Order_By>
  min?: InputMaybe<Customer_Contact_Min_Order_By>
  stddev?: InputMaybe<Customer_Contact_Stddev_Order_By>
  stddev_pop?: InputMaybe<Customer_Contact_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Customer_Contact_Stddev_Samp_Order_By>
  sum?: InputMaybe<Customer_Contact_Sum_Order_By>
  var_pop?: InputMaybe<Customer_Contact_Var_Pop_Order_By>
  var_samp?: InputMaybe<Customer_Contact_Var_Samp_Order_By>
  variance?: InputMaybe<Customer_Contact_Variance_Order_By>
}

/** input type for inserting array relation for remote table "customer_contact" */
export type Customer_Contact_Arr_Rel_Insert_Input = {
  data: Array<Customer_Contact_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Contact_On_Conflict>
}

/** aggregate avg on columns */
export type Customer_Contact_Avg_Fields = {
  __typename?: "customer_contact_avg_fields"
  contact_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "customer_contact" */
export type Customer_Contact_Avg_Order_By = {
  contact_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "customer_contact". All fields are combined with a logical 'AND'. */
export type Customer_Contact_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Contact_Bool_Exp>>
  _not?: InputMaybe<Customer_Contact_Bool_Exp>
  _or?: InputMaybe<Array<Customer_Contact_Bool_Exp>>
  cancelled?: InputMaybe<Timestamp_Comparison_Exp>
  contact?: InputMaybe<Contact_Bool_Exp>
  contact_id?: InputMaybe<Bigint_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  customer?: InputMaybe<Customer_Bool_Exp>
  customer_id?: InputMaybe<Bigint_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  from_date?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  primary?: InputMaybe<Boolean_Comparison_Exp>
  to_date?: InputMaybe<Timestamp_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "customer_contact" */
export enum Customer_Contact_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerContactPkey = "customer_contact_pkey",
}

/** input type for incrementing numeric columns in table "customer_contact" */
export type Customer_Contact_Inc_Input = {
  contact_id?: InputMaybe<Scalars["bigint"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "customer_contact" */
export type Customer_Contact_Insert_Input = {
  cancelled?: InputMaybe<Scalars["timestamp"]["input"]>
  contact?: InputMaybe<Contact_Obj_Rel_Insert_Input>
  contact_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer?: InputMaybe<Customer_Obj_Rel_Insert_Input>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_date?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  primary?: InputMaybe<Scalars["Boolean"]["input"]>
  to_date?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Customer_Contact_Max_Fields = {
  __typename?: "customer_contact_max_fields"
  cancelled?: Maybe<Scalars["timestamp"]["output"]>
  contact_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_date?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  to_date?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "customer_contact" */
export type Customer_Contact_Max_Order_By = {
  cancelled?: InputMaybe<Order_By>
  contact_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  from_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  to_date?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Customer_Contact_Min_Fields = {
  __typename?: "customer_contact_min_fields"
  cancelled?: Maybe<Scalars["timestamp"]["output"]>
  contact_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_date?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  to_date?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "customer_contact" */
export type Customer_Contact_Min_Order_By = {
  cancelled?: InputMaybe<Order_By>
  contact_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  from_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  to_date?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "customer_contact" */
export type Customer_Contact_Mutation_Response = {
  __typename?: "customer_contact_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Contact>
}

/** on_conflict condition type for table "customer_contact" */
export type Customer_Contact_On_Conflict = {
  constraint: Customer_Contact_Constraint
  update_columns?: Array<Customer_Contact_Update_Column>
  where?: InputMaybe<Customer_Contact_Bool_Exp>
}

/** Ordering options when selecting data from "customer_contact". */
export type Customer_Contact_Order_By = {
  cancelled?: InputMaybe<Order_By>
  contact?: InputMaybe<Contact_Order_By>
  contact_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  customer?: InputMaybe<Customer_Order_By>
  customer_id?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  from_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  primary?: InputMaybe<Order_By>
  to_date?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: customer_contact */
export type Customer_Contact_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "customer_contact" */
export enum Customer_Contact_Select_Column {
  /** column name */
  Cancelled = "cancelled",
  /** column name */
  ContactId = "contact_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FromDate = "from_date",
  /** column name */
  Id = "id",
  /** column name */
  Primary = "primary",
  /** column name */
  ToDate = "to_date",
  /** column name */
  UpdatedAt = "updated_at",
}

/** select "customer_contact_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customer_contact" */
export enum Customer_Contact_Select_Column_Customer_Contact_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Primary = "primary",
}

/** select "customer_contact_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customer_contact" */
export enum Customer_Contact_Select_Column_Customer_Contact_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Primary = "primary",
}

/** input type for updating data in table "customer_contact" */
export type Customer_Contact_Set_Input = {
  cancelled?: InputMaybe<Scalars["timestamp"]["input"]>
  contact_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_date?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  primary?: InputMaybe<Scalars["Boolean"]["input"]>
  to_date?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Customer_Contact_Stddev_Fields = {
  __typename?: "customer_contact_stddev_fields"
  contact_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "customer_contact" */
export type Customer_Contact_Stddev_Order_By = {
  contact_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Customer_Contact_Stddev_Pop_Fields = {
  __typename?: "customer_contact_stddev_pop_fields"
  contact_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "customer_contact" */
export type Customer_Contact_Stddev_Pop_Order_By = {
  contact_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Customer_Contact_Stddev_Samp_Fields = {
  __typename?: "customer_contact_stddev_samp_fields"
  contact_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "customer_contact" */
export type Customer_Contact_Stddev_Samp_Order_By = {
  contact_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "customer_contact" */
export type Customer_Contact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Contact_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Customer_Contact_Stream_Cursor_Value_Input = {
  cancelled?: InputMaybe<Scalars["timestamp"]["input"]>
  contact_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_date?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  primary?: InputMaybe<Scalars["Boolean"]["input"]>
  to_date?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Customer_Contact_Sum_Fields = {
  __typename?: "customer_contact_sum_fields"
  contact_id?: Maybe<Scalars["bigint"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "customer_contact" */
export type Customer_Contact_Sum_Order_By = {
  contact_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** update columns of table "customer_contact" */
export enum Customer_Contact_Update_Column {
  /** column name */
  Cancelled = "cancelled",
  /** column name */
  ContactId = "contact_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FromDate = "from_date",
  /** column name */
  Id = "id",
  /** column name */
  Primary = "primary",
  /** column name */
  ToDate = "to_date",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Customer_Contact_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Customer_Contact_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Contact_Set_Input>
  /** filter the rows which have to be updated */
  where: Customer_Contact_Bool_Exp
}

/** aggregate var_pop on columns */
export type Customer_Contact_Var_Pop_Fields = {
  __typename?: "customer_contact_var_pop_fields"
  contact_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "customer_contact" */
export type Customer_Contact_Var_Pop_Order_By = {
  contact_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Customer_Contact_Var_Samp_Fields = {
  __typename?: "customer_contact_var_samp_fields"
  contact_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "customer_contact" */
export type Customer_Contact_Var_Samp_Order_By = {
  contact_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Customer_Contact_Variance_Fields = {
  __typename?: "customer_contact_variance_fields"
  contact_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "customer_contact" */
export type Customer_Contact_Variance_Order_By = {
  contact_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** input type for incrementing numeric columns in table "customer" */
export type Customer_Inc_Input = {
  customer_metadata_id?: InputMaybe<Scalars["bigint"]["input"]>
  customer_setting_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "customer" */
export type Customer_Insert_Input = {
  billing_accounts?: InputMaybe<Billing_Account_Arr_Rel_Insert_Input>
  class?: InputMaybe<Scalars["customer_class"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customerReferralsByReferredId?: InputMaybe<Customer_Referrals_Arr_Rel_Insert_Input>
  customer_contacts?: InputMaybe<Customer_Contact_Arr_Rel_Insert_Input>
  customer_metadata_id?: InputMaybe<Scalars["bigint"]["input"]>
  customer_metadatum?: InputMaybe<Customer_Metadata_Obj_Rel_Insert_Input>
  customer_property_rels?: InputMaybe<Customer_Property_Rel_Arr_Rel_Insert_Input>
  customer_referrals?: InputMaybe<Customer_Referrals_Arr_Rel_Insert_Input>
  customer_setting?: InputMaybe<Customer_Setting_Obj_Rel_Insert_Input>
  customer_setting_id?: InputMaybe<Scalars["bigint"]["input"]>
  customer_user_rels?: InputMaybe<Customer_User_Rel_Arr_Rel_Insert_Input>
  dataerased?: InputMaybe<Scalars["timestamp"]["input"]>
  deceased?: InputMaybe<Scalars["Boolean"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  enrolments?: InputMaybe<Enrolment_Arr_Rel_Insert_Input>
  first_name?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_name?: InputMaybe<Scalars["String"]["input"]>
  number?: InputMaybe<Scalars["String"]["input"]>
  report_problems?: InputMaybe<Report_Problem_Arr_Rel_Insert_Input>
  state?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["customer_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Customer_Max_Fields = {
  __typename?: "customer_max_fields"
  class?: Maybe<Scalars["customer_class"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_metadata_id?: Maybe<Scalars["bigint"]["output"]>
  customer_setting_id?: Maybe<Scalars["bigint"]["output"]>
  dataerased?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  first_name?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_name?: Maybe<Scalars["String"]["output"]>
  number?: Maybe<Scalars["String"]["output"]>
  state?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["customer_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "customer" */
export type Customer_Max_Order_By = {
  class?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  customer_metadata_id?: InputMaybe<Order_By>
  customer_setting_id?: InputMaybe<Order_By>
  dataerased?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  first_name?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  last_name?: InputMaybe<Order_By>
  number?: InputMaybe<Order_By>
  state?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** columns and relationships of "customer_metadata" */
export type Customer_Metadata = {
  __typename?: "customer_metadata"
  broker_agent?: Maybe<Scalars["String"]["output"]>
  correspondence_address?: Maybe<Scalars["json"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  created_from: Scalars["created_from_type"]["output"]
  /** An array relationship */
  customers: Array<Customer>
  /** An aggregate relationship */
  customers_aggregate: Customer_Aggregate
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  last_agreement_renew?: Maybe<Scalars["timestamp"]["output"]>
  last_ticket_at?: Maybe<Scalars["timestamp"]["output"]>
  psr_requested_at?: Maybe<Scalars["timestamp"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "customer_metadata" */
export type Customer_MetadataCorrespondence_AddressArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** columns and relationships of "customer_metadata" */
export type Customer_MetadataCustomersArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Order_By>>
  where?: InputMaybe<Customer_Bool_Exp>
}

/** columns and relationships of "customer_metadata" */
export type Customer_MetadataCustomers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Order_By>>
  where?: InputMaybe<Customer_Bool_Exp>
}

/** aggregated selection of "customer_metadata" */
export type Customer_Metadata_Aggregate = {
  __typename?: "customer_metadata_aggregate"
  aggregate?: Maybe<Customer_Metadata_Aggregate_Fields>
  nodes: Array<Customer_Metadata>
}

/** aggregate fields of "customer_metadata" */
export type Customer_Metadata_Aggregate_Fields = {
  __typename?: "customer_metadata_aggregate_fields"
  avg?: Maybe<Customer_Metadata_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Customer_Metadata_Max_Fields>
  min?: Maybe<Customer_Metadata_Min_Fields>
  stddev?: Maybe<Customer_Metadata_Stddev_Fields>
  stddev_pop?: Maybe<Customer_Metadata_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Customer_Metadata_Stddev_Samp_Fields>
  sum?: Maybe<Customer_Metadata_Sum_Fields>
  var_pop?: Maybe<Customer_Metadata_Var_Pop_Fields>
  var_samp?: Maybe<Customer_Metadata_Var_Samp_Fields>
  variance?: Maybe<Customer_Metadata_Variance_Fields>
}

/** aggregate fields of "customer_metadata" */
export type Customer_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Metadata_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Customer_Metadata_Avg_Fields = {
  __typename?: "customer_metadata_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "customer_metadata". All fields are combined with a logical 'AND'. */
export type Customer_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Metadata_Bool_Exp>>
  _not?: InputMaybe<Customer_Metadata_Bool_Exp>
  _or?: InputMaybe<Array<Customer_Metadata_Bool_Exp>>
  broker_agent?: InputMaybe<String_Comparison_Exp>
  correspondence_address?: InputMaybe<Json_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  created_from?: InputMaybe<Created_From_Type_Comparison_Exp>
  customers?: InputMaybe<Customer_Bool_Exp>
  customers_aggregate?: InputMaybe<Customer_Aggregate_Bool_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  last_agreement_renew?: InputMaybe<Timestamp_Comparison_Exp>
  last_ticket_at?: InputMaybe<Timestamp_Comparison_Exp>
  psr_requested_at?: InputMaybe<Timestamp_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "customer_metadata" */
export enum Customer_Metadata_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerMetadataPkey = "customer_metadata_pkey",
}

/** input type for incrementing numeric columns in table "customer_metadata" */
export type Customer_Metadata_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "customer_metadata" */
export type Customer_Metadata_Insert_Input = {
  broker_agent?: InputMaybe<Scalars["String"]["input"]>
  correspondence_address?: InputMaybe<Scalars["json"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  created_from?: InputMaybe<Scalars["created_from_type"]["input"]>
  customers?: InputMaybe<Customer_Arr_Rel_Insert_Input>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_agreement_renew?: InputMaybe<Scalars["timestamp"]["input"]>
  last_ticket_at?: InputMaybe<Scalars["timestamp"]["input"]>
  psr_requested_at?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Customer_Metadata_Max_Fields = {
  __typename?: "customer_metadata_max_fields"
  broker_agent?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  created_from?: Maybe<Scalars["created_from_type"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_agreement_renew?: Maybe<Scalars["timestamp"]["output"]>
  last_ticket_at?: Maybe<Scalars["timestamp"]["output"]>
  psr_requested_at?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Customer_Metadata_Min_Fields = {
  __typename?: "customer_metadata_min_fields"
  broker_agent?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  created_from?: Maybe<Scalars["created_from_type"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_agreement_renew?: Maybe<Scalars["timestamp"]["output"]>
  last_ticket_at?: Maybe<Scalars["timestamp"]["output"]>
  psr_requested_at?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "customer_metadata" */
export type Customer_Metadata_Mutation_Response = {
  __typename?: "customer_metadata_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Metadata>
}

/** input type for inserting object relation for remote table "customer_metadata" */
export type Customer_Metadata_Obj_Rel_Insert_Input = {
  data: Customer_Metadata_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Metadata_On_Conflict>
}

/** on_conflict condition type for table "customer_metadata" */
export type Customer_Metadata_On_Conflict = {
  constraint: Customer_Metadata_Constraint
  update_columns?: Array<Customer_Metadata_Update_Column>
  where?: InputMaybe<Customer_Metadata_Bool_Exp>
}

/** Ordering options when selecting data from "customer_metadata". */
export type Customer_Metadata_Order_By = {
  broker_agent?: InputMaybe<Order_By>
  correspondence_address?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  created_from?: InputMaybe<Order_By>
  customers_aggregate?: InputMaybe<Customer_Aggregate_Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  last_agreement_renew?: InputMaybe<Order_By>
  last_ticket_at?: InputMaybe<Order_By>
  psr_requested_at?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: customer_metadata */
export type Customer_Metadata_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "customer_metadata" */
export enum Customer_Metadata_Select_Column {
  /** column name */
  BrokerAgent = "broker_agent",
  /** column name */
  CorrespondenceAddress = "correspondence_address",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CreatedFrom = "created_from",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  LastAgreementRenew = "last_agreement_renew",
  /** column name */
  LastTicketAt = "last_ticket_at",
  /** column name */
  PsrRequestedAt = "psr_requested_at",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "customer_metadata" */
export type Customer_Metadata_Set_Input = {
  broker_agent?: InputMaybe<Scalars["String"]["input"]>
  correspondence_address?: InputMaybe<Scalars["json"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  created_from?: InputMaybe<Scalars["created_from_type"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_agreement_renew?: InputMaybe<Scalars["timestamp"]["input"]>
  last_ticket_at?: InputMaybe<Scalars["timestamp"]["input"]>
  psr_requested_at?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Customer_Metadata_Stddev_Fields = {
  __typename?: "customer_metadata_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Customer_Metadata_Stddev_Pop_Fields = {
  __typename?: "customer_metadata_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Customer_Metadata_Stddev_Samp_Fields = {
  __typename?: "customer_metadata_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "customer_metadata" */
export type Customer_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Metadata_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Customer_Metadata_Stream_Cursor_Value_Input = {
  broker_agent?: InputMaybe<Scalars["String"]["input"]>
  correspondence_address?: InputMaybe<Scalars["json"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  created_from?: InputMaybe<Scalars["created_from_type"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_agreement_renew?: InputMaybe<Scalars["timestamp"]["input"]>
  last_ticket_at?: InputMaybe<Scalars["timestamp"]["input"]>
  psr_requested_at?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Customer_Metadata_Sum_Fields = {
  __typename?: "customer_metadata_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "customer_metadata" */
export enum Customer_Metadata_Update_Column {
  /** column name */
  BrokerAgent = "broker_agent",
  /** column name */
  CorrespondenceAddress = "correspondence_address",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CreatedFrom = "created_from",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  LastAgreementRenew = "last_agreement_renew",
  /** column name */
  LastTicketAt = "last_ticket_at",
  /** column name */
  PsrRequestedAt = "psr_requested_at",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Customer_Metadata_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Customer_Metadata_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Metadata_Set_Input>
  /** filter the rows which have to be updated */
  where: Customer_Metadata_Bool_Exp
}

/** aggregate var_pop on columns */
export type Customer_Metadata_Var_Pop_Fields = {
  __typename?: "customer_metadata_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Customer_Metadata_Var_Samp_Fields = {
  __typename?: "customer_metadata_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Customer_Metadata_Variance_Fields = {
  __typename?: "customer_metadata_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate min on columns */
export type Customer_Min_Fields = {
  __typename?: "customer_min_fields"
  class?: Maybe<Scalars["customer_class"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_metadata_id?: Maybe<Scalars["bigint"]["output"]>
  customer_setting_id?: Maybe<Scalars["bigint"]["output"]>
  dataerased?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  first_name?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_name?: Maybe<Scalars["String"]["output"]>
  number?: Maybe<Scalars["String"]["output"]>
  state?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["customer_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "customer" */
export type Customer_Min_Order_By = {
  class?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  customer_metadata_id?: InputMaybe<Order_By>
  customer_setting_id?: InputMaybe<Order_By>
  dataerased?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  first_name?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  last_name?: InputMaybe<Order_By>
  number?: InputMaybe<Order_By>
  state?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "customer" */
export type Customer_Mutation_Response = {
  __typename?: "customer_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Customer>
}

/** input type for inserting object relation for remote table "customer" */
export type Customer_Obj_Rel_Insert_Input = {
  data: Customer_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_On_Conflict>
}

/** on_conflict condition type for table "customer" */
export type Customer_On_Conflict = {
  constraint: Customer_Constraint
  update_columns?: Array<Customer_Update_Column>
  where?: InputMaybe<Customer_Bool_Exp>
}

/** Ordering options when selecting data from "customer". */
export type Customer_Order_By = {
  billing_accounts_aggregate?: InputMaybe<Billing_Account_Aggregate_Order_By>
  class?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  customerReferralsByReferredId_aggregate?: InputMaybe<Customer_Referrals_Aggregate_Order_By>
  customer_contacts_aggregate?: InputMaybe<Customer_Contact_Aggregate_Order_By>
  customer_metadata_id?: InputMaybe<Order_By>
  customer_metadatum?: InputMaybe<Customer_Metadata_Order_By>
  customer_property_rels_aggregate?: InputMaybe<Customer_Property_Rel_Aggregate_Order_By>
  customer_referrals_aggregate?: InputMaybe<Customer_Referrals_Aggregate_Order_By>
  customer_setting?: InputMaybe<Customer_Setting_Order_By>
  customer_setting_id?: InputMaybe<Order_By>
  customer_user_rels_aggregate?: InputMaybe<Customer_User_Rel_Aggregate_Order_By>
  dataerased?: InputMaybe<Order_By>
  deceased?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  enrolments_aggregate?: InputMaybe<Enrolment_Aggregate_Order_By>
  first_name?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  last_name?: InputMaybe<Order_By>
  number?: InputMaybe<Order_By>
  report_problems_aggregate?: InputMaybe<Report_Problem_Aggregate_Order_By>
  state?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: customer */
export type Customer_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** columns and relationships of "customer_property_rel" */
export type Customer_Property_Rel = {
  __typename?: "customer_property_rel"
  created_at: Scalars["timestamp"]["output"]
  /** An object relationship */
  customer: Customer
  customer_id: Scalars["bigint"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  property?: Maybe<Property>
  property_id: Scalars["bigint"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "customer_property_rel" */
export type Customer_Property_Rel_Aggregate = {
  __typename?: "customer_property_rel_aggregate"
  aggregate?: Maybe<Customer_Property_Rel_Aggregate_Fields>
  nodes: Array<Customer_Property_Rel>
}

export type Customer_Property_Rel_Aggregate_Bool_Exp = {
  count?: InputMaybe<Customer_Property_Rel_Aggregate_Bool_Exp_Count>
}

export type Customer_Property_Rel_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Property_Rel_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Customer_Property_Rel_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "customer_property_rel" */
export type Customer_Property_Rel_Aggregate_Fields = {
  __typename?: "customer_property_rel_aggregate_fields"
  avg?: Maybe<Customer_Property_Rel_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Customer_Property_Rel_Max_Fields>
  min?: Maybe<Customer_Property_Rel_Min_Fields>
  stddev?: Maybe<Customer_Property_Rel_Stddev_Fields>
  stddev_pop?: Maybe<Customer_Property_Rel_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Customer_Property_Rel_Stddev_Samp_Fields>
  sum?: Maybe<Customer_Property_Rel_Sum_Fields>
  var_pop?: Maybe<Customer_Property_Rel_Var_Pop_Fields>
  var_samp?: Maybe<Customer_Property_Rel_Var_Samp_Fields>
  variance?: Maybe<Customer_Property_Rel_Variance_Fields>
}

/** aggregate fields of "customer_property_rel" */
export type Customer_Property_Rel_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Property_Rel_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "customer_property_rel" */
export type Customer_Property_Rel_Aggregate_Order_By = {
  avg?: InputMaybe<Customer_Property_Rel_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Customer_Property_Rel_Max_Order_By>
  min?: InputMaybe<Customer_Property_Rel_Min_Order_By>
  stddev?: InputMaybe<Customer_Property_Rel_Stddev_Order_By>
  stddev_pop?: InputMaybe<Customer_Property_Rel_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Customer_Property_Rel_Stddev_Samp_Order_By>
  sum?: InputMaybe<Customer_Property_Rel_Sum_Order_By>
  var_pop?: InputMaybe<Customer_Property_Rel_Var_Pop_Order_By>
  var_samp?: InputMaybe<Customer_Property_Rel_Var_Samp_Order_By>
  variance?: InputMaybe<Customer_Property_Rel_Variance_Order_By>
}

/** input type for inserting array relation for remote table "customer_property_rel" */
export type Customer_Property_Rel_Arr_Rel_Insert_Input = {
  data: Array<Customer_Property_Rel_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Property_Rel_On_Conflict>
}

/** aggregate avg on columns */
export type Customer_Property_Rel_Avg_Fields = {
  __typename?: "customer_property_rel_avg_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  property_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "customer_property_rel" */
export type Customer_Property_Rel_Avg_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  property_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "customer_property_rel". All fields are combined with a logical 'AND'. */
export type Customer_Property_Rel_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Property_Rel_Bool_Exp>>
  _not?: InputMaybe<Customer_Property_Rel_Bool_Exp>
  _or?: InputMaybe<Array<Customer_Property_Rel_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  customer?: InputMaybe<Customer_Bool_Exp>
  customer_id?: InputMaybe<Bigint_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  property_id?: InputMaybe<Bigint_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "customer_property_rel" */
export enum Customer_Property_Rel_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkCustomerProperty = "pk_customer_property",
}

/** input type for incrementing numeric columns in table "customer_property_rel" */
export type Customer_Property_Rel_Inc_Input = {
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  property_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "customer_property_rel" */
export type Customer_Property_Rel_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer?: InputMaybe<Customer_Obj_Rel_Insert_Input>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  property_id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Customer_Property_Rel_Max_Fields = {
  __typename?: "customer_property_rel_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  property_id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "customer_property_rel" */
export type Customer_Property_Rel_Max_Order_By = {
  created_at?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  property_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Customer_Property_Rel_Min_Fields = {
  __typename?: "customer_property_rel_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  property_id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "customer_property_rel" */
export type Customer_Property_Rel_Min_Order_By = {
  created_at?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  property_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "customer_property_rel" */
export type Customer_Property_Rel_Mutation_Response = {
  __typename?: "customer_property_rel_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Property_Rel>
}

/** on_conflict condition type for table "customer_property_rel" */
export type Customer_Property_Rel_On_Conflict = {
  constraint: Customer_Property_Rel_Constraint
  update_columns?: Array<Customer_Property_Rel_Update_Column>
  where?: InputMaybe<Customer_Property_Rel_Bool_Exp>
}

/** Ordering options when selecting data from "customer_property_rel". */
export type Customer_Property_Rel_Order_By = {
  created_at?: InputMaybe<Order_By>
  customer?: InputMaybe<Customer_Order_By>
  customer_id?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  property_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: customer_property_rel */
export type Customer_Property_Rel_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "customer_property_rel" */
export enum Customer_Property_Rel_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  PropertyId = "property_id",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "customer_property_rel" */
export type Customer_Property_Rel_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  property_id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Customer_Property_Rel_Stddev_Fields = {
  __typename?: "customer_property_rel_stddev_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  property_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "customer_property_rel" */
export type Customer_Property_Rel_Stddev_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  property_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Customer_Property_Rel_Stddev_Pop_Fields = {
  __typename?: "customer_property_rel_stddev_pop_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  property_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "customer_property_rel" */
export type Customer_Property_Rel_Stddev_Pop_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  property_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Customer_Property_Rel_Stddev_Samp_Fields = {
  __typename?: "customer_property_rel_stddev_samp_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  property_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "customer_property_rel" */
export type Customer_Property_Rel_Stddev_Samp_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  property_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "customer_property_rel" */
export type Customer_Property_Rel_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Property_Rel_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Customer_Property_Rel_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  property_id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Customer_Property_Rel_Sum_Fields = {
  __typename?: "customer_property_rel_sum_fields"
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  property_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "customer_property_rel" */
export type Customer_Property_Rel_Sum_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  property_id?: InputMaybe<Order_By>
}

/** update columns of table "customer_property_rel" */
export enum Customer_Property_Rel_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  PropertyId = "property_id",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Customer_Property_Rel_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Customer_Property_Rel_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Property_Rel_Set_Input>
  /** filter the rows which have to be updated */
  where: Customer_Property_Rel_Bool_Exp
}

/** aggregate var_pop on columns */
export type Customer_Property_Rel_Var_Pop_Fields = {
  __typename?: "customer_property_rel_var_pop_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  property_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "customer_property_rel" */
export type Customer_Property_Rel_Var_Pop_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  property_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Customer_Property_Rel_Var_Samp_Fields = {
  __typename?: "customer_property_rel_var_samp_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  property_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "customer_property_rel" */
export type Customer_Property_Rel_Var_Samp_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  property_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Customer_Property_Rel_Variance_Fields = {
  __typename?: "customer_property_rel_variance_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  property_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "customer_property_rel" */
export type Customer_Property_Rel_Variance_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  property_id?: InputMaybe<Order_By>
}

/** columns and relationships of "customer_psr_rel" */
export type Customer_Psr_Rel = {
  __typename?: "customer_psr_rel"
  consent: Scalars["Boolean"]["output"]
  created_at: Scalars["timestamp"]["output"]
  customer_id: Scalars["bigint"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_date?: Maybe<Scalars["date"]["output"]>
  id: Scalars["bigint"]["output"]
  note?: Maybe<Scalars["String"]["output"]>
  property_id: Scalars["bigint"]["output"]
  psr_id: Scalars["bigint"]["output"]
  to_date?: Maybe<Scalars["date"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "customer_psr_rel" */
export type Customer_Psr_Rel_Aggregate = {
  __typename?: "customer_psr_rel_aggregate"
  aggregate?: Maybe<Customer_Psr_Rel_Aggregate_Fields>
  nodes: Array<Customer_Psr_Rel>
}

/** aggregate fields of "customer_psr_rel" */
export type Customer_Psr_Rel_Aggregate_Fields = {
  __typename?: "customer_psr_rel_aggregate_fields"
  avg?: Maybe<Customer_Psr_Rel_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Customer_Psr_Rel_Max_Fields>
  min?: Maybe<Customer_Psr_Rel_Min_Fields>
  stddev?: Maybe<Customer_Psr_Rel_Stddev_Fields>
  stddev_pop?: Maybe<Customer_Psr_Rel_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Customer_Psr_Rel_Stddev_Samp_Fields>
  sum?: Maybe<Customer_Psr_Rel_Sum_Fields>
  var_pop?: Maybe<Customer_Psr_Rel_Var_Pop_Fields>
  var_samp?: Maybe<Customer_Psr_Rel_Var_Samp_Fields>
  variance?: Maybe<Customer_Psr_Rel_Variance_Fields>
}

/** aggregate fields of "customer_psr_rel" */
export type Customer_Psr_Rel_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Psr_Rel_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Customer_Psr_Rel_Avg_Fields = {
  __typename?: "customer_psr_rel_avg_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  property_id?: Maybe<Scalars["Float"]["output"]>
  psr_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "customer_psr_rel". All fields are combined with a logical 'AND'. */
export type Customer_Psr_Rel_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Psr_Rel_Bool_Exp>>
  _not?: InputMaybe<Customer_Psr_Rel_Bool_Exp>
  _or?: InputMaybe<Array<Customer_Psr_Rel_Bool_Exp>>
  consent?: InputMaybe<Boolean_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  customer_id?: InputMaybe<Bigint_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  from_date?: InputMaybe<Date_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  note?: InputMaybe<String_Comparison_Exp>
  property_id?: InputMaybe<Bigint_Comparison_Exp>
  psr_id?: InputMaybe<Bigint_Comparison_Exp>
  to_date?: InputMaybe<Date_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "customer_psr_rel" */
export enum Customer_Psr_Rel_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkCustomerPsrRel = "pk_customer_psr_rel",
}

/** input type for incrementing numeric columns in table "customer_psr_rel" */
export type Customer_Psr_Rel_Inc_Input = {
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  property_id?: InputMaybe<Scalars["bigint"]["input"]>
  psr_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "customer_psr_rel" */
export type Customer_Psr_Rel_Insert_Input = {
  consent?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_date?: InputMaybe<Scalars["date"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  note?: InputMaybe<Scalars["String"]["input"]>
  property_id?: InputMaybe<Scalars["bigint"]["input"]>
  psr_id?: InputMaybe<Scalars["bigint"]["input"]>
  to_date?: InputMaybe<Scalars["date"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Customer_Psr_Rel_Max_Fields = {
  __typename?: "customer_psr_rel_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_date?: Maybe<Scalars["date"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  note?: Maybe<Scalars["String"]["output"]>
  property_id?: Maybe<Scalars["bigint"]["output"]>
  psr_id?: Maybe<Scalars["bigint"]["output"]>
  to_date?: Maybe<Scalars["date"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Customer_Psr_Rel_Min_Fields = {
  __typename?: "customer_psr_rel_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_date?: Maybe<Scalars["date"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  note?: Maybe<Scalars["String"]["output"]>
  property_id?: Maybe<Scalars["bigint"]["output"]>
  psr_id?: Maybe<Scalars["bigint"]["output"]>
  to_date?: Maybe<Scalars["date"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "customer_psr_rel" */
export type Customer_Psr_Rel_Mutation_Response = {
  __typename?: "customer_psr_rel_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Psr_Rel>
}

/** on_conflict condition type for table "customer_psr_rel" */
export type Customer_Psr_Rel_On_Conflict = {
  constraint: Customer_Psr_Rel_Constraint
  update_columns?: Array<Customer_Psr_Rel_Update_Column>
  where?: InputMaybe<Customer_Psr_Rel_Bool_Exp>
}

/** Ordering options when selecting data from "customer_psr_rel". */
export type Customer_Psr_Rel_Order_By = {
  consent?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  from_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  note?: InputMaybe<Order_By>
  property_id?: InputMaybe<Order_By>
  psr_id?: InputMaybe<Order_By>
  to_date?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: customer_psr_rel */
export type Customer_Psr_Rel_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "customer_psr_rel" */
export enum Customer_Psr_Rel_Select_Column {
  /** column name */
  Consent = "consent",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FromDate = "from_date",
  /** column name */
  Id = "id",
  /** column name */
  Note = "note",
  /** column name */
  PropertyId = "property_id",
  /** column name */
  PsrId = "psr_id",
  /** column name */
  ToDate = "to_date",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "customer_psr_rel" */
export type Customer_Psr_Rel_Set_Input = {
  consent?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_date?: InputMaybe<Scalars["date"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  note?: InputMaybe<Scalars["String"]["input"]>
  property_id?: InputMaybe<Scalars["bigint"]["input"]>
  psr_id?: InputMaybe<Scalars["bigint"]["input"]>
  to_date?: InputMaybe<Scalars["date"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Customer_Psr_Rel_Stddev_Fields = {
  __typename?: "customer_psr_rel_stddev_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  property_id?: Maybe<Scalars["Float"]["output"]>
  psr_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Customer_Psr_Rel_Stddev_Pop_Fields = {
  __typename?: "customer_psr_rel_stddev_pop_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  property_id?: Maybe<Scalars["Float"]["output"]>
  psr_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Customer_Psr_Rel_Stddev_Samp_Fields = {
  __typename?: "customer_psr_rel_stddev_samp_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  property_id?: Maybe<Scalars["Float"]["output"]>
  psr_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "customer_psr_rel" */
export type Customer_Psr_Rel_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Psr_Rel_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Customer_Psr_Rel_Stream_Cursor_Value_Input = {
  consent?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_date?: InputMaybe<Scalars["date"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  note?: InputMaybe<Scalars["String"]["input"]>
  property_id?: InputMaybe<Scalars["bigint"]["input"]>
  psr_id?: InputMaybe<Scalars["bigint"]["input"]>
  to_date?: InputMaybe<Scalars["date"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Customer_Psr_Rel_Sum_Fields = {
  __typename?: "customer_psr_rel_sum_fields"
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  property_id?: Maybe<Scalars["bigint"]["output"]>
  psr_id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "customer_psr_rel" */
export enum Customer_Psr_Rel_Update_Column {
  /** column name */
  Consent = "consent",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FromDate = "from_date",
  /** column name */
  Id = "id",
  /** column name */
  Note = "note",
  /** column name */
  PropertyId = "property_id",
  /** column name */
  PsrId = "psr_id",
  /** column name */
  ToDate = "to_date",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Customer_Psr_Rel_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Customer_Psr_Rel_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Psr_Rel_Set_Input>
  /** filter the rows which have to be updated */
  where: Customer_Psr_Rel_Bool_Exp
}

/** aggregate var_pop on columns */
export type Customer_Psr_Rel_Var_Pop_Fields = {
  __typename?: "customer_psr_rel_var_pop_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  property_id?: Maybe<Scalars["Float"]["output"]>
  psr_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Customer_Psr_Rel_Var_Samp_Fields = {
  __typename?: "customer_psr_rel_var_samp_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  property_id?: Maybe<Scalars["Float"]["output"]>
  psr_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Customer_Psr_Rel_Variance_Fields = {
  __typename?: "customer_psr_rel_variance_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  property_id?: Maybe<Scalars["Float"]["output"]>
  psr_id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "customer_referrals" */
export type Customer_Referrals = {
  __typename?: "customer_referrals"
  created_at: Scalars["timestamp"]["output"]
  credit: Scalars["numeric"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  /** An object relationship */
  referee: Customer
  referee_id: Scalars["bigint"]["output"]
  /** An object relationship */
  referred: Customer
  referred_id: Scalars["bigint"]["output"]
  status: Scalars["referral_status"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "customer_referrals" */
export type Customer_Referrals_Aggregate = {
  __typename?: "customer_referrals_aggregate"
  aggregate?: Maybe<Customer_Referrals_Aggregate_Fields>
  nodes: Array<Customer_Referrals>
}

export type Customer_Referrals_Aggregate_Bool_Exp = {
  count?: InputMaybe<Customer_Referrals_Aggregate_Bool_Exp_Count>
}

export type Customer_Referrals_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Referrals_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Customer_Referrals_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "customer_referrals" */
export type Customer_Referrals_Aggregate_Fields = {
  __typename?: "customer_referrals_aggregate_fields"
  avg?: Maybe<Customer_Referrals_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Customer_Referrals_Max_Fields>
  min?: Maybe<Customer_Referrals_Min_Fields>
  stddev?: Maybe<Customer_Referrals_Stddev_Fields>
  stddev_pop?: Maybe<Customer_Referrals_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Customer_Referrals_Stddev_Samp_Fields>
  sum?: Maybe<Customer_Referrals_Sum_Fields>
  var_pop?: Maybe<Customer_Referrals_Var_Pop_Fields>
  var_samp?: Maybe<Customer_Referrals_Var_Samp_Fields>
  variance?: Maybe<Customer_Referrals_Variance_Fields>
}

/** aggregate fields of "customer_referrals" */
export type Customer_Referrals_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Referrals_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "customer_referrals" */
export type Customer_Referrals_Aggregate_Order_By = {
  avg?: InputMaybe<Customer_Referrals_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Customer_Referrals_Max_Order_By>
  min?: InputMaybe<Customer_Referrals_Min_Order_By>
  stddev?: InputMaybe<Customer_Referrals_Stddev_Order_By>
  stddev_pop?: InputMaybe<Customer_Referrals_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Customer_Referrals_Stddev_Samp_Order_By>
  sum?: InputMaybe<Customer_Referrals_Sum_Order_By>
  var_pop?: InputMaybe<Customer_Referrals_Var_Pop_Order_By>
  var_samp?: InputMaybe<Customer_Referrals_Var_Samp_Order_By>
  variance?: InputMaybe<Customer_Referrals_Variance_Order_By>
}

/** input type for inserting array relation for remote table "customer_referrals" */
export type Customer_Referrals_Arr_Rel_Insert_Input = {
  data: Array<Customer_Referrals_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Referrals_On_Conflict>
}

/** aggregate avg on columns */
export type Customer_Referrals_Avg_Fields = {
  __typename?: "customer_referrals_avg_fields"
  credit?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  referee_id?: Maybe<Scalars["Float"]["output"]>
  referred_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "customer_referrals" */
export type Customer_Referrals_Avg_Order_By = {
  credit?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  referee_id?: InputMaybe<Order_By>
  referred_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "customer_referrals". All fields are combined with a logical 'AND'. */
export type Customer_Referrals_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Referrals_Bool_Exp>>
  _not?: InputMaybe<Customer_Referrals_Bool_Exp>
  _or?: InputMaybe<Array<Customer_Referrals_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  credit?: InputMaybe<Numeric_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  referee?: InputMaybe<Customer_Bool_Exp>
  referee_id?: InputMaybe<Bigint_Comparison_Exp>
  referred?: InputMaybe<Customer_Bool_Exp>
  referred_id?: InputMaybe<Bigint_Comparison_Exp>
  status?: InputMaybe<Referral_Status_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "customer_referrals" */
export enum Customer_Referrals_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkReferralId = "pk_referral_id",
}

/** input type for incrementing numeric columns in table "customer_referrals" */
export type Customer_Referrals_Inc_Input = {
  credit?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  referee_id?: InputMaybe<Scalars["bigint"]["input"]>
  referred_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "customer_referrals" */
export type Customer_Referrals_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  credit?: InputMaybe<Scalars["numeric"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  referee?: InputMaybe<Customer_Obj_Rel_Insert_Input>
  referee_id?: InputMaybe<Scalars["bigint"]["input"]>
  referred?: InputMaybe<Customer_Obj_Rel_Insert_Input>
  referred_id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["referral_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Customer_Referrals_Max_Fields = {
  __typename?: "customer_referrals_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  credit?: Maybe<Scalars["numeric"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  referee_id?: Maybe<Scalars["bigint"]["output"]>
  referred_id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["referral_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "customer_referrals" */
export type Customer_Referrals_Max_Order_By = {
  created_at?: InputMaybe<Order_By>
  credit?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  referee_id?: InputMaybe<Order_By>
  referred_id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Customer_Referrals_Min_Fields = {
  __typename?: "customer_referrals_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  credit?: Maybe<Scalars["numeric"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  referee_id?: Maybe<Scalars["bigint"]["output"]>
  referred_id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["referral_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "customer_referrals" */
export type Customer_Referrals_Min_Order_By = {
  created_at?: InputMaybe<Order_By>
  credit?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  referee_id?: InputMaybe<Order_By>
  referred_id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "customer_referrals" */
export type Customer_Referrals_Mutation_Response = {
  __typename?: "customer_referrals_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Referrals>
}

/** on_conflict condition type for table "customer_referrals" */
export type Customer_Referrals_On_Conflict = {
  constraint: Customer_Referrals_Constraint
  update_columns?: Array<Customer_Referrals_Update_Column>
  where?: InputMaybe<Customer_Referrals_Bool_Exp>
}

/** Ordering options when selecting data from "customer_referrals". */
export type Customer_Referrals_Order_By = {
  created_at?: InputMaybe<Order_By>
  credit?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  referee?: InputMaybe<Customer_Order_By>
  referee_id?: InputMaybe<Order_By>
  referred?: InputMaybe<Customer_Order_By>
  referred_id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: customer_referrals */
export type Customer_Referrals_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "customer_referrals" */
export enum Customer_Referrals_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Credit = "credit",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  RefereeId = "referee_id",
  /** column name */
  ReferredId = "referred_id",
  /** column name */
  Status = "status",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "customer_referrals" */
export type Customer_Referrals_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  credit?: InputMaybe<Scalars["numeric"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  referee_id?: InputMaybe<Scalars["bigint"]["input"]>
  referred_id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["referral_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Customer_Referrals_Stddev_Fields = {
  __typename?: "customer_referrals_stddev_fields"
  credit?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  referee_id?: Maybe<Scalars["Float"]["output"]>
  referred_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "customer_referrals" */
export type Customer_Referrals_Stddev_Order_By = {
  credit?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  referee_id?: InputMaybe<Order_By>
  referred_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Customer_Referrals_Stddev_Pop_Fields = {
  __typename?: "customer_referrals_stddev_pop_fields"
  credit?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  referee_id?: Maybe<Scalars["Float"]["output"]>
  referred_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "customer_referrals" */
export type Customer_Referrals_Stddev_Pop_Order_By = {
  credit?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  referee_id?: InputMaybe<Order_By>
  referred_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Customer_Referrals_Stddev_Samp_Fields = {
  __typename?: "customer_referrals_stddev_samp_fields"
  credit?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  referee_id?: Maybe<Scalars["Float"]["output"]>
  referred_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "customer_referrals" */
export type Customer_Referrals_Stddev_Samp_Order_By = {
  credit?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  referee_id?: InputMaybe<Order_By>
  referred_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "customer_referrals" */
export type Customer_Referrals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Referrals_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Customer_Referrals_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  credit?: InputMaybe<Scalars["numeric"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  referee_id?: InputMaybe<Scalars["bigint"]["input"]>
  referred_id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["referral_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Customer_Referrals_Sum_Fields = {
  __typename?: "customer_referrals_sum_fields"
  credit?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  referee_id?: Maybe<Scalars["bigint"]["output"]>
  referred_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "customer_referrals" */
export type Customer_Referrals_Sum_Order_By = {
  credit?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  referee_id?: InputMaybe<Order_By>
  referred_id?: InputMaybe<Order_By>
}

/** update columns of table "customer_referrals" */
export enum Customer_Referrals_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Credit = "credit",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  RefereeId = "referee_id",
  /** column name */
  ReferredId = "referred_id",
  /** column name */
  Status = "status",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Customer_Referrals_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Customer_Referrals_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Referrals_Set_Input>
  /** filter the rows which have to be updated */
  where: Customer_Referrals_Bool_Exp
}

/** aggregate var_pop on columns */
export type Customer_Referrals_Var_Pop_Fields = {
  __typename?: "customer_referrals_var_pop_fields"
  credit?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  referee_id?: Maybe<Scalars["Float"]["output"]>
  referred_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "customer_referrals" */
export type Customer_Referrals_Var_Pop_Order_By = {
  credit?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  referee_id?: InputMaybe<Order_By>
  referred_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Customer_Referrals_Var_Samp_Fields = {
  __typename?: "customer_referrals_var_samp_fields"
  credit?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  referee_id?: Maybe<Scalars["Float"]["output"]>
  referred_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "customer_referrals" */
export type Customer_Referrals_Var_Samp_Order_By = {
  credit?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  referee_id?: InputMaybe<Order_By>
  referred_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Customer_Referrals_Variance_Fields = {
  __typename?: "customer_referrals_variance_fields"
  credit?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  referee_id?: Maybe<Scalars["Float"]["output"]>
  referred_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "customer_referrals" */
export type Customer_Referrals_Variance_Order_By = {
  credit?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  referee_id?: InputMaybe<Order_By>
  referred_id?: InputMaybe<Order_By>
}

/** select columns of table "customer" */
export enum Customer_Select_Column {
  /** column name */
  Class = "class",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerMetadataId = "customer_metadata_id",
  /** column name */
  CustomerSettingId = "customer_setting_id",
  /** column name */
  Dataerased = "dataerased",
  /** column name */
  Deceased = "deceased",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FirstName = "first_name",
  /** column name */
  Id = "id",
  /** column name */
  LastName = "last_name",
  /** column name */
  Number = "number",
  /** column name */
  State = "state",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** select "customer_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customer" */
export enum Customer_Select_Column_Customer_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deceased = "deceased",
}

/** select "customer_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customer" */
export enum Customer_Select_Column_Customer_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deceased = "deceased",
}

/** input type for updating data in table "customer" */
export type Customer_Set_Input = {
  class?: InputMaybe<Scalars["customer_class"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_metadata_id?: InputMaybe<Scalars["bigint"]["input"]>
  customer_setting_id?: InputMaybe<Scalars["bigint"]["input"]>
  dataerased?: InputMaybe<Scalars["timestamp"]["input"]>
  deceased?: InputMaybe<Scalars["Boolean"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  first_name?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_name?: InputMaybe<Scalars["String"]["input"]>
  number?: InputMaybe<Scalars["String"]["input"]>
  state?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["customer_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** columns and relationships of "customer_setting" */
export type Customer_Setting = {
  __typename?: "customer_setting"
  created_at: Scalars["timestamp"]["output"]
  /** An array relationship */
  customers: Array<Customer>
  /** An aggregate relationship */
  customers_aggregate: Customer_Aggregate
  dark_mode?: Maybe<Scalars["Boolean"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  energy_source_vote?: Maybe<Scalars["energy_source_type"]["output"]>
  ev_tariff_marketing_consent?: Maybe<Scalars["Boolean"]["output"]>
  ev_type?: Maybe<Scalars["ev_type"]["output"]>
  id: Scalars["bigint"]["output"]
  intend_to_buy_ev?: Maybe<Scalars["Boolean"]["output"]>
  is_eligible_for_my_new_account: Scalars["Boolean"]["output"]
  last_banner_shown_at?: Maybe<Scalars["timestamp"]["output"]>
  marketing_opt_in: Scalars["Boolean"]["output"]
  referrals_enabled: Scalars["Boolean"]["output"]
  smart_meter_interest: Scalars["Boolean"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "customer_setting" */
export type Customer_SettingCustomersArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Order_By>>
  where?: InputMaybe<Customer_Bool_Exp>
}

/** columns and relationships of "customer_setting" */
export type Customer_SettingCustomers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Order_By>>
  where?: InputMaybe<Customer_Bool_Exp>
}

/** aggregated selection of "customer_setting" */
export type Customer_Setting_Aggregate = {
  __typename?: "customer_setting_aggregate"
  aggregate?: Maybe<Customer_Setting_Aggregate_Fields>
  nodes: Array<Customer_Setting>
}

/** aggregate fields of "customer_setting" */
export type Customer_Setting_Aggregate_Fields = {
  __typename?: "customer_setting_aggregate_fields"
  avg?: Maybe<Customer_Setting_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Customer_Setting_Max_Fields>
  min?: Maybe<Customer_Setting_Min_Fields>
  stddev?: Maybe<Customer_Setting_Stddev_Fields>
  stddev_pop?: Maybe<Customer_Setting_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Customer_Setting_Stddev_Samp_Fields>
  sum?: Maybe<Customer_Setting_Sum_Fields>
  var_pop?: Maybe<Customer_Setting_Var_Pop_Fields>
  var_samp?: Maybe<Customer_Setting_Var_Samp_Fields>
  variance?: Maybe<Customer_Setting_Variance_Fields>
}

/** aggregate fields of "customer_setting" */
export type Customer_Setting_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Setting_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Customer_Setting_Avg_Fields = {
  __typename?: "customer_setting_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "customer_setting". All fields are combined with a logical 'AND'. */
export type Customer_Setting_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Setting_Bool_Exp>>
  _not?: InputMaybe<Customer_Setting_Bool_Exp>
  _or?: InputMaybe<Array<Customer_Setting_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  customers?: InputMaybe<Customer_Bool_Exp>
  customers_aggregate?: InputMaybe<Customer_Aggregate_Bool_Exp>
  dark_mode?: InputMaybe<Boolean_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  energy_source_vote?: InputMaybe<Energy_Source_Type_Comparison_Exp>
  ev_tariff_marketing_consent?: InputMaybe<Boolean_Comparison_Exp>
  ev_type?: InputMaybe<Ev_Type_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  intend_to_buy_ev?: InputMaybe<Boolean_Comparison_Exp>
  is_eligible_for_my_new_account?: InputMaybe<Boolean_Comparison_Exp>
  last_banner_shown_at?: InputMaybe<Timestamp_Comparison_Exp>
  marketing_opt_in?: InputMaybe<Boolean_Comparison_Exp>
  referrals_enabled?: InputMaybe<Boolean_Comparison_Exp>
  smart_meter_interest?: InputMaybe<Boolean_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "customer_setting" */
export enum Customer_Setting_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomerSettingsPkey = "customer_settings_pkey",
}

/** input type for incrementing numeric columns in table "customer_setting" */
export type Customer_Setting_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "customer_setting" */
export type Customer_Setting_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customers?: InputMaybe<Customer_Arr_Rel_Insert_Input>
  dark_mode?: InputMaybe<Scalars["Boolean"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  energy_source_vote?: InputMaybe<Scalars["energy_source_type"]["input"]>
  ev_tariff_marketing_consent?: InputMaybe<Scalars["Boolean"]["input"]>
  ev_type?: InputMaybe<Scalars["ev_type"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  intend_to_buy_ev?: InputMaybe<Scalars["Boolean"]["input"]>
  is_eligible_for_my_new_account?: InputMaybe<Scalars["Boolean"]["input"]>
  last_banner_shown_at?: InputMaybe<Scalars["timestamp"]["input"]>
  marketing_opt_in?: InputMaybe<Scalars["Boolean"]["input"]>
  referrals_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  smart_meter_interest?: InputMaybe<Scalars["Boolean"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Customer_Setting_Max_Fields = {
  __typename?: "customer_setting_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  energy_source_vote?: Maybe<Scalars["energy_source_type"]["output"]>
  ev_type?: Maybe<Scalars["ev_type"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_banner_shown_at?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Customer_Setting_Min_Fields = {
  __typename?: "customer_setting_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  energy_source_vote?: Maybe<Scalars["energy_source_type"]["output"]>
  ev_type?: Maybe<Scalars["ev_type"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_banner_shown_at?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "customer_setting" */
export type Customer_Setting_Mutation_Response = {
  __typename?: "customer_setting_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Setting>
}

/** input type for inserting object relation for remote table "customer_setting" */
export type Customer_Setting_Obj_Rel_Insert_Input = {
  data: Customer_Setting_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Setting_On_Conflict>
}

/** on_conflict condition type for table "customer_setting" */
export type Customer_Setting_On_Conflict = {
  constraint: Customer_Setting_Constraint
  update_columns?: Array<Customer_Setting_Update_Column>
  where?: InputMaybe<Customer_Setting_Bool_Exp>
}

/** Ordering options when selecting data from "customer_setting". */
export type Customer_Setting_Order_By = {
  created_at?: InputMaybe<Order_By>
  customers_aggregate?: InputMaybe<Customer_Aggregate_Order_By>
  dark_mode?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  energy_source_vote?: InputMaybe<Order_By>
  ev_tariff_marketing_consent?: InputMaybe<Order_By>
  ev_type?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  intend_to_buy_ev?: InputMaybe<Order_By>
  is_eligible_for_my_new_account?: InputMaybe<Order_By>
  last_banner_shown_at?: InputMaybe<Order_By>
  marketing_opt_in?: InputMaybe<Order_By>
  referrals_enabled?: InputMaybe<Order_By>
  smart_meter_interest?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: customer_setting */
export type Customer_Setting_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "customer_setting" */
export enum Customer_Setting_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DarkMode = "dark_mode",
  /** column name */
  Deleted = "deleted",
  /** column name */
  EnergySourceVote = "energy_source_vote",
  /** column name */
  EvTariffMarketingConsent = "ev_tariff_marketing_consent",
  /** column name */
  EvType = "ev_type",
  /** column name */
  Id = "id",
  /** column name */
  IntendToBuyEv = "intend_to_buy_ev",
  /** column name */
  IsEligibleForMyNewAccount = "is_eligible_for_my_new_account",
  /** column name */
  LastBannerShownAt = "last_banner_shown_at",
  /** column name */
  MarketingOptIn = "marketing_opt_in",
  /** column name */
  ReferralsEnabled = "referrals_enabled",
  /** column name */
  SmartMeterInterest = "smart_meter_interest",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "customer_setting" */
export type Customer_Setting_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  dark_mode?: InputMaybe<Scalars["Boolean"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  energy_source_vote?: InputMaybe<Scalars["energy_source_type"]["input"]>
  ev_tariff_marketing_consent?: InputMaybe<Scalars["Boolean"]["input"]>
  ev_type?: InputMaybe<Scalars["ev_type"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  intend_to_buy_ev?: InputMaybe<Scalars["Boolean"]["input"]>
  is_eligible_for_my_new_account?: InputMaybe<Scalars["Boolean"]["input"]>
  last_banner_shown_at?: InputMaybe<Scalars["timestamp"]["input"]>
  marketing_opt_in?: InputMaybe<Scalars["Boolean"]["input"]>
  referrals_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  smart_meter_interest?: InputMaybe<Scalars["Boolean"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Customer_Setting_Stddev_Fields = {
  __typename?: "customer_setting_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Customer_Setting_Stddev_Pop_Fields = {
  __typename?: "customer_setting_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Customer_Setting_Stddev_Samp_Fields = {
  __typename?: "customer_setting_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "customer_setting" */
export type Customer_Setting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Setting_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Customer_Setting_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  dark_mode?: InputMaybe<Scalars["Boolean"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  energy_source_vote?: InputMaybe<Scalars["energy_source_type"]["input"]>
  ev_tariff_marketing_consent?: InputMaybe<Scalars["Boolean"]["input"]>
  ev_type?: InputMaybe<Scalars["ev_type"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  intend_to_buy_ev?: InputMaybe<Scalars["Boolean"]["input"]>
  is_eligible_for_my_new_account?: InputMaybe<Scalars["Boolean"]["input"]>
  last_banner_shown_at?: InputMaybe<Scalars["timestamp"]["input"]>
  marketing_opt_in?: InputMaybe<Scalars["Boolean"]["input"]>
  referrals_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  smart_meter_interest?: InputMaybe<Scalars["Boolean"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Customer_Setting_Sum_Fields = {
  __typename?: "customer_setting_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "customer_setting" */
export enum Customer_Setting_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DarkMode = "dark_mode",
  /** column name */
  Deleted = "deleted",
  /** column name */
  EnergySourceVote = "energy_source_vote",
  /** column name */
  EvTariffMarketingConsent = "ev_tariff_marketing_consent",
  /** column name */
  EvType = "ev_type",
  /** column name */
  Id = "id",
  /** column name */
  IntendToBuyEv = "intend_to_buy_ev",
  /** column name */
  IsEligibleForMyNewAccount = "is_eligible_for_my_new_account",
  /** column name */
  LastBannerShownAt = "last_banner_shown_at",
  /** column name */
  MarketingOptIn = "marketing_opt_in",
  /** column name */
  ReferralsEnabled = "referrals_enabled",
  /** column name */
  SmartMeterInterest = "smart_meter_interest",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Customer_Setting_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Customer_Setting_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Setting_Set_Input>
  /** filter the rows which have to be updated */
  where: Customer_Setting_Bool_Exp
}

/** aggregate var_pop on columns */
export type Customer_Setting_Var_Pop_Fields = {
  __typename?: "customer_setting_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Customer_Setting_Var_Samp_Fields = {
  __typename?: "customer_setting_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Customer_Setting_Variance_Fields = {
  __typename?: "customer_setting_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev on columns */
export type Customer_Stddev_Fields = {
  __typename?: "customer_stddev_fields"
  customer_metadata_id?: Maybe<Scalars["Float"]["output"]>
  customer_setting_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "customer" */
export type Customer_Stddev_Order_By = {
  customer_metadata_id?: InputMaybe<Order_By>
  customer_setting_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Customer_Stddev_Pop_Fields = {
  __typename?: "customer_stddev_pop_fields"
  customer_metadata_id?: Maybe<Scalars["Float"]["output"]>
  customer_setting_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "customer" */
export type Customer_Stddev_Pop_Order_By = {
  customer_metadata_id?: InputMaybe<Order_By>
  customer_setting_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Customer_Stddev_Samp_Fields = {
  __typename?: "customer_stddev_samp_fields"
  customer_metadata_id?: Maybe<Scalars["Float"]["output"]>
  customer_setting_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "customer" */
export type Customer_Stddev_Samp_Order_By = {
  customer_metadata_id?: InputMaybe<Order_By>
  customer_setting_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "customer" */
export type Customer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Customer_Stream_Cursor_Value_Input = {
  class?: InputMaybe<Scalars["customer_class"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_metadata_id?: InputMaybe<Scalars["bigint"]["input"]>
  customer_setting_id?: InputMaybe<Scalars["bigint"]["input"]>
  dataerased?: InputMaybe<Scalars["timestamp"]["input"]>
  deceased?: InputMaybe<Scalars["Boolean"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  first_name?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_name?: InputMaybe<Scalars["String"]["input"]>
  number?: InputMaybe<Scalars["String"]["input"]>
  state?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["customer_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Customer_Sum_Fields = {
  __typename?: "customer_sum_fields"
  customer_metadata_id?: Maybe<Scalars["bigint"]["output"]>
  customer_setting_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "customer" */
export type Customer_Sum_Order_By = {
  customer_metadata_id?: InputMaybe<Order_By>
  customer_setting_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "customer_type". All fields are combined with logical 'AND'. */
export type Customer_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["customer_type"]["input"]>
  _gt?: InputMaybe<Scalars["customer_type"]["input"]>
  _gte?: InputMaybe<Scalars["customer_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["customer_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["customer_type"]["input"]>
  _lte?: InputMaybe<Scalars["customer_type"]["input"]>
  _neq?: InputMaybe<Scalars["customer_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["customer_type"]["input"]>>
}

/** update columns of table "customer" */
export enum Customer_Update_Column {
  /** column name */
  Class = "class",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerMetadataId = "customer_metadata_id",
  /** column name */
  CustomerSettingId = "customer_setting_id",
  /** column name */
  Dataerased = "dataerased",
  /** column name */
  Deceased = "deceased",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FirstName = "first_name",
  /** column name */
  Id = "id",
  /** column name */
  LastName = "last_name",
  /** column name */
  Number = "number",
  /** column name */
  State = "state",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Customer_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Customer_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Set_Input>
  /** filter the rows which have to be updated */
  where: Customer_Bool_Exp
}

/** columns and relationships of "customer_user_rel" */
export type Customer_User_Rel = {
  __typename?: "customer_user_rel"
  /** An object relationship */
  billing_account?: Maybe<Billing_Account>
  created_at: Scalars["timestamp"]["output"]
  /** An object relationship */
  customer: Customer
  customer_id: Scalars["bigint"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  updated_at: Scalars["timestamp"]["output"]
  user?: Maybe<Users>
  user_id: Scalars["bigint"]["output"]
}

/** aggregated selection of "customer_user_rel" */
export type Customer_User_Rel_Aggregate = {
  __typename?: "customer_user_rel_aggregate"
  aggregate?: Maybe<Customer_User_Rel_Aggregate_Fields>
  nodes: Array<Customer_User_Rel>
}

export type Customer_User_Rel_Aggregate_Bool_Exp = {
  count?: InputMaybe<Customer_User_Rel_Aggregate_Bool_Exp_Count>
}

export type Customer_User_Rel_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_User_Rel_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Customer_User_Rel_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "customer_user_rel" */
export type Customer_User_Rel_Aggregate_Fields = {
  __typename?: "customer_user_rel_aggregate_fields"
  avg?: Maybe<Customer_User_Rel_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Customer_User_Rel_Max_Fields>
  min?: Maybe<Customer_User_Rel_Min_Fields>
  stddev?: Maybe<Customer_User_Rel_Stddev_Fields>
  stddev_pop?: Maybe<Customer_User_Rel_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Customer_User_Rel_Stddev_Samp_Fields>
  sum?: Maybe<Customer_User_Rel_Sum_Fields>
  var_pop?: Maybe<Customer_User_Rel_Var_Pop_Fields>
  var_samp?: Maybe<Customer_User_Rel_Var_Samp_Fields>
  variance?: Maybe<Customer_User_Rel_Variance_Fields>
}

/** aggregate fields of "customer_user_rel" */
export type Customer_User_Rel_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_User_Rel_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "customer_user_rel" */
export type Customer_User_Rel_Aggregate_Order_By = {
  avg?: InputMaybe<Customer_User_Rel_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Customer_User_Rel_Max_Order_By>
  min?: InputMaybe<Customer_User_Rel_Min_Order_By>
  stddev?: InputMaybe<Customer_User_Rel_Stddev_Order_By>
  stddev_pop?: InputMaybe<Customer_User_Rel_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Customer_User_Rel_Stddev_Samp_Order_By>
  sum?: InputMaybe<Customer_User_Rel_Sum_Order_By>
  var_pop?: InputMaybe<Customer_User_Rel_Var_Pop_Order_By>
  var_samp?: InputMaybe<Customer_User_Rel_Var_Samp_Order_By>
  variance?: InputMaybe<Customer_User_Rel_Variance_Order_By>
}

/** input type for inserting array relation for remote table "customer_user_rel" */
export type Customer_User_Rel_Arr_Rel_Insert_Input = {
  data: Array<Customer_User_Rel_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_User_Rel_On_Conflict>
}

/** aggregate avg on columns */
export type Customer_User_Rel_Avg_Fields = {
  __typename?: "customer_user_rel_avg_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "customer_user_rel" */
export type Customer_User_Rel_Avg_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "customer_user_rel". All fields are combined with a logical 'AND'. */
export type Customer_User_Rel_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_User_Rel_Bool_Exp>>
  _not?: InputMaybe<Customer_User_Rel_Bool_Exp>
  _or?: InputMaybe<Array<Customer_User_Rel_Bool_Exp>>
  billing_account?: InputMaybe<Billing_Account_Bool_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  customer?: InputMaybe<Customer_Bool_Exp>
  customer_id?: InputMaybe<Bigint_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  user_id?: InputMaybe<Bigint_Comparison_Exp>
}

/** unique or primary key constraints on table "customer_user_rel" */
export enum Customer_User_Rel_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkCustomerUserRel = "pk_customer_user_rel",
  /** unique or primary key constraint on columns "user_id", "customer_id" */
  UkCustomerIdUserId = "uk_customer_id_user_id",
}

/** input type for incrementing numeric columns in table "customer_user_rel" */
export type Customer_User_Rel_Inc_Input = {
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "customer_user_rel" */
export type Customer_User_Rel_Insert_Input = {
  billing_account?: InputMaybe<Billing_Account_Obj_Rel_Insert_Input>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer?: InputMaybe<Customer_Obj_Rel_Insert_Input>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate max on columns */
export type Customer_User_Rel_Max_Fields = {
  __typename?: "customer_user_rel_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by max() on columns of table "customer_user_rel" */
export type Customer_User_Rel_Max_Order_By = {
  created_at?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Customer_User_Rel_Min_Fields = {
  __typename?: "customer_user_rel_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by min() on columns of table "customer_user_rel" */
export type Customer_User_Rel_Min_Order_By = {
  created_at?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** response of any mutation on the table "customer_user_rel" */
export type Customer_User_Rel_Mutation_Response = {
  __typename?: "customer_user_rel_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Customer_User_Rel>
}

/** on_conflict condition type for table "customer_user_rel" */
export type Customer_User_Rel_On_Conflict = {
  constraint: Customer_User_Rel_Constraint
  update_columns?: Array<Customer_User_Rel_Update_Column>
  where?: InputMaybe<Customer_User_Rel_Bool_Exp>
}

/** Ordering options when selecting data from "customer_user_rel". */
export type Customer_User_Rel_Order_By = {
  billing_account?: InputMaybe<Billing_Account_Order_By>
  created_at?: InputMaybe<Order_By>
  customer?: InputMaybe<Customer_Order_By>
  customer_id?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: customer_user_rel */
export type Customer_User_Rel_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "customer_user_rel" */
export enum Customer_User_Rel_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  UserId = "user_id",
}

/** input type for updating data in table "customer_user_rel" */
export type Customer_User_Rel_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate stddev on columns */
export type Customer_User_Rel_Stddev_Fields = {
  __typename?: "customer_user_rel_stddev_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "customer_user_rel" */
export type Customer_User_Rel_Stddev_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Customer_User_Rel_Stddev_Pop_Fields = {
  __typename?: "customer_user_rel_stddev_pop_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "customer_user_rel" */
export type Customer_User_Rel_Stddev_Pop_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Customer_User_Rel_Stddev_Samp_Fields = {
  __typename?: "customer_user_rel_stddev_samp_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "customer_user_rel" */
export type Customer_User_Rel_Stddev_Samp_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "customer_user_rel" */
export type Customer_User_Rel_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_User_Rel_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Customer_User_Rel_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate sum on columns */
export type Customer_User_Rel_Sum_Fields = {
  __typename?: "customer_user_rel_sum_fields"
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "customer_user_rel" */
export type Customer_User_Rel_Sum_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** update columns of table "customer_user_rel" */
export enum Customer_User_Rel_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  UserId = "user_id",
}

export type Customer_User_Rel_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Customer_User_Rel_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_User_Rel_Set_Input>
  /** filter the rows which have to be updated */
  where: Customer_User_Rel_Bool_Exp
}

/** aggregate var_pop on columns */
export type Customer_User_Rel_Var_Pop_Fields = {
  __typename?: "customer_user_rel_var_pop_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "customer_user_rel" */
export type Customer_User_Rel_Var_Pop_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Customer_User_Rel_Var_Samp_Fields = {
  __typename?: "customer_user_rel_var_samp_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "customer_user_rel" */
export type Customer_User_Rel_Var_Samp_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Customer_User_Rel_Variance_Fields = {
  __typename?: "customer_user_rel_variance_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "customer_user_rel" */
export type Customer_User_Rel_Variance_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate var_pop on columns */
export type Customer_Var_Pop_Fields = {
  __typename?: "customer_var_pop_fields"
  customer_metadata_id?: Maybe<Scalars["Float"]["output"]>
  customer_setting_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "customer" */
export type Customer_Var_Pop_Order_By = {
  customer_metadata_id?: InputMaybe<Order_By>
  customer_setting_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Customer_Var_Samp_Fields = {
  __typename?: "customer_var_samp_fields"
  customer_metadata_id?: Maybe<Scalars["Float"]["output"]>
  customer_setting_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "customer" */
export type Customer_Var_Samp_Order_By = {
  customer_metadata_id?: InputMaybe<Order_By>
  customer_setting_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Customer_Variance_Fields = {
  __typename?: "customer_variance_fields"
  customer_metadata_id?: Maybe<Scalars["Float"]["output"]>
  customer_setting_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "customer" */
export type Customer_Variance_Order_By = {
  customer_metadata_id?: InputMaybe<Order_By>
  customer_setting_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** columns and relationships of "dashboard_complete_view_v2" */
export type Dashboard_Complete_View_V2 = {
  __typename?: "dashboard_complete_view_v2"
  comms_hub_id?: Maybe<Scalars["String"]["output"]>
  dev_status?: Maybe<Scalars["String"]["output"]>
  device_id?: Maybe<Scalars["String"]["output"]>
  error?: Maybe<Scalars["String"]["output"]>
  error_status?: Maybe<Scalars["String"]["output"]>
  firmware_status?: Maybe<Scalars["String"]["output"]>
  firmware_version?: Maybe<Scalars["String"]["output"]>
  gbcs_version?: Maybe<Scalars["String"]["output"]>
  installation_date?: Maybe<Scalars["timestamptz"]["output"]>
  last_orchestration?: Maybe<Scalars["String"]["output"]>
  last_reading?: Maybe<Scalars["bigint"]["output"]>
  last_reading_date_time?: Maybe<Scalars["timestamptz"]["output"]>
  last_updated?: Maybe<Scalars["timestamptz"]["output"]>
  latest_alert_code?: Maybe<Scalars["String"]["output"]>
  latest_alert_date?: Maybe<Scalars["timestamptz"]["output"]>
  latest_alert_status?: Maybe<Scalars["String"]["output"]>
  manufacturer?: Maybe<Scalars["String"]["output"]>
  meter_type?: Maybe<Scalars["String"]["output"]>
  model?: Maybe<Scalars["String"]["output"]>
  mpxn?: Maybe<Scalars["String"]["output"]>
  msn?: Maybe<Scalars["String"]["output"]>
  orchestration_status?: Maybe<Scalars["String"]["output"]>
  payment_mode?: Maybe<Scalars["String"]["output"]>
  pk?: Maybe<Scalars["bigint"]["output"]>
  region?: Maybe<Scalars["String"]["output"]>
  smets_version?: Maybe<Scalars["String"]["output"]>
  srv?: Maybe<Scalars["String"]["output"]>
  ssd?: Maybe<Scalars["timestamptz"]["output"]>
  variant?: Maybe<Scalars["String"]["output"]>
  workstream?: Maybe<Scalars["String"]["output"]>
}

/** aggregated selection of "dashboard_complete_view_v2" */
export type Dashboard_Complete_View_V2_Aggregate = {
  __typename?: "dashboard_complete_view_v2_aggregate"
  aggregate?: Maybe<Dashboard_Complete_View_V2_Aggregate_Fields>
  nodes: Array<Dashboard_Complete_View_V2>
}

/** aggregate fields of "dashboard_complete_view_v2" */
export type Dashboard_Complete_View_V2_Aggregate_Fields = {
  __typename?: "dashboard_complete_view_v2_aggregate_fields"
  avg?: Maybe<Dashboard_Complete_View_V2_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Dashboard_Complete_View_V2_Max_Fields>
  min?: Maybe<Dashboard_Complete_View_V2_Min_Fields>
  stddev?: Maybe<Dashboard_Complete_View_V2_Stddev_Fields>
  stddev_pop?: Maybe<Dashboard_Complete_View_V2_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Dashboard_Complete_View_V2_Stddev_Samp_Fields>
  sum?: Maybe<Dashboard_Complete_View_V2_Sum_Fields>
  var_pop?: Maybe<Dashboard_Complete_View_V2_Var_Pop_Fields>
  var_samp?: Maybe<Dashboard_Complete_View_V2_Var_Samp_Fields>
  variance?: Maybe<Dashboard_Complete_View_V2_Variance_Fields>
}

/** aggregate fields of "dashboard_complete_view_v2" */
export type Dashboard_Complete_View_V2_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dashboard_Complete_View_V2_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Dashboard_Complete_View_V2_Avg_Fields = {
  __typename?: "dashboard_complete_view_v2_avg_fields"
  last_reading?: Maybe<Scalars["Float"]["output"]>
  pk?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "dashboard_complete_view_v2". All fields are combined with a logical 'AND'. */
export type Dashboard_Complete_View_V2_Bool_Exp = {
  _and?: InputMaybe<Array<Dashboard_Complete_View_V2_Bool_Exp>>
  _not?: InputMaybe<Dashboard_Complete_View_V2_Bool_Exp>
  _or?: InputMaybe<Array<Dashboard_Complete_View_V2_Bool_Exp>>
  comms_hub_id?: InputMaybe<String_Comparison_Exp>
  dev_status?: InputMaybe<String_Comparison_Exp>
  device_id?: InputMaybe<String_Comparison_Exp>
  error?: InputMaybe<String_Comparison_Exp>
  error_status?: InputMaybe<String_Comparison_Exp>
  firmware_status?: InputMaybe<String_Comparison_Exp>
  firmware_version?: InputMaybe<String_Comparison_Exp>
  gbcs_version?: InputMaybe<String_Comparison_Exp>
  installation_date?: InputMaybe<Timestamptz_Comparison_Exp>
  last_orchestration?: InputMaybe<String_Comparison_Exp>
  last_reading?: InputMaybe<Bigint_Comparison_Exp>
  last_reading_date_time?: InputMaybe<Timestamptz_Comparison_Exp>
  last_updated?: InputMaybe<Timestamptz_Comparison_Exp>
  latest_alert_code?: InputMaybe<String_Comparison_Exp>
  latest_alert_date?: InputMaybe<Timestamptz_Comparison_Exp>
  latest_alert_status?: InputMaybe<String_Comparison_Exp>
  manufacturer?: InputMaybe<String_Comparison_Exp>
  meter_type?: InputMaybe<String_Comparison_Exp>
  model?: InputMaybe<String_Comparison_Exp>
  mpxn?: InputMaybe<String_Comparison_Exp>
  msn?: InputMaybe<String_Comparison_Exp>
  orchestration_status?: InputMaybe<String_Comparison_Exp>
  payment_mode?: InputMaybe<String_Comparison_Exp>
  pk?: InputMaybe<Bigint_Comparison_Exp>
  region?: InputMaybe<String_Comparison_Exp>
  smets_version?: InputMaybe<String_Comparison_Exp>
  srv?: InputMaybe<String_Comparison_Exp>
  ssd?: InputMaybe<Timestamptz_Comparison_Exp>
  variant?: InputMaybe<String_Comparison_Exp>
  workstream?: InputMaybe<String_Comparison_Exp>
}

/** aggregate max on columns */
export type Dashboard_Complete_View_V2_Max_Fields = {
  __typename?: "dashboard_complete_view_v2_max_fields"
  comms_hub_id?: Maybe<Scalars["String"]["output"]>
  dev_status?: Maybe<Scalars["String"]["output"]>
  device_id?: Maybe<Scalars["String"]["output"]>
  error?: Maybe<Scalars["String"]["output"]>
  error_status?: Maybe<Scalars["String"]["output"]>
  firmware_status?: Maybe<Scalars["String"]["output"]>
  firmware_version?: Maybe<Scalars["String"]["output"]>
  gbcs_version?: Maybe<Scalars["String"]["output"]>
  installation_date?: Maybe<Scalars["timestamptz"]["output"]>
  last_orchestration?: Maybe<Scalars["String"]["output"]>
  last_reading?: Maybe<Scalars["bigint"]["output"]>
  last_reading_date_time?: Maybe<Scalars["timestamptz"]["output"]>
  last_updated?: Maybe<Scalars["timestamptz"]["output"]>
  latest_alert_code?: Maybe<Scalars["String"]["output"]>
  latest_alert_date?: Maybe<Scalars["timestamptz"]["output"]>
  latest_alert_status?: Maybe<Scalars["String"]["output"]>
  manufacturer?: Maybe<Scalars["String"]["output"]>
  meter_type?: Maybe<Scalars["String"]["output"]>
  model?: Maybe<Scalars["String"]["output"]>
  mpxn?: Maybe<Scalars["String"]["output"]>
  msn?: Maybe<Scalars["String"]["output"]>
  orchestration_status?: Maybe<Scalars["String"]["output"]>
  payment_mode?: Maybe<Scalars["String"]["output"]>
  pk?: Maybe<Scalars["bigint"]["output"]>
  region?: Maybe<Scalars["String"]["output"]>
  smets_version?: Maybe<Scalars["String"]["output"]>
  srv?: Maybe<Scalars["String"]["output"]>
  ssd?: Maybe<Scalars["timestamptz"]["output"]>
  variant?: Maybe<Scalars["String"]["output"]>
  workstream?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Dashboard_Complete_View_V2_Min_Fields = {
  __typename?: "dashboard_complete_view_v2_min_fields"
  comms_hub_id?: Maybe<Scalars["String"]["output"]>
  dev_status?: Maybe<Scalars["String"]["output"]>
  device_id?: Maybe<Scalars["String"]["output"]>
  error?: Maybe<Scalars["String"]["output"]>
  error_status?: Maybe<Scalars["String"]["output"]>
  firmware_status?: Maybe<Scalars["String"]["output"]>
  firmware_version?: Maybe<Scalars["String"]["output"]>
  gbcs_version?: Maybe<Scalars["String"]["output"]>
  installation_date?: Maybe<Scalars["timestamptz"]["output"]>
  last_orchestration?: Maybe<Scalars["String"]["output"]>
  last_reading?: Maybe<Scalars["bigint"]["output"]>
  last_reading_date_time?: Maybe<Scalars["timestamptz"]["output"]>
  last_updated?: Maybe<Scalars["timestamptz"]["output"]>
  latest_alert_code?: Maybe<Scalars["String"]["output"]>
  latest_alert_date?: Maybe<Scalars["timestamptz"]["output"]>
  latest_alert_status?: Maybe<Scalars["String"]["output"]>
  manufacturer?: Maybe<Scalars["String"]["output"]>
  meter_type?: Maybe<Scalars["String"]["output"]>
  model?: Maybe<Scalars["String"]["output"]>
  mpxn?: Maybe<Scalars["String"]["output"]>
  msn?: Maybe<Scalars["String"]["output"]>
  orchestration_status?: Maybe<Scalars["String"]["output"]>
  payment_mode?: Maybe<Scalars["String"]["output"]>
  pk?: Maybe<Scalars["bigint"]["output"]>
  region?: Maybe<Scalars["String"]["output"]>
  smets_version?: Maybe<Scalars["String"]["output"]>
  srv?: Maybe<Scalars["String"]["output"]>
  ssd?: Maybe<Scalars["timestamptz"]["output"]>
  variant?: Maybe<Scalars["String"]["output"]>
  workstream?: Maybe<Scalars["String"]["output"]>
}

/** Ordering options when selecting data from "dashboard_complete_view_v2". */
export type Dashboard_Complete_View_V2_Order_By = {
  comms_hub_id?: InputMaybe<Order_By>
  dev_status?: InputMaybe<Order_By>
  device_id?: InputMaybe<Order_By>
  error?: InputMaybe<Order_By>
  error_status?: InputMaybe<Order_By>
  firmware_status?: InputMaybe<Order_By>
  firmware_version?: InputMaybe<Order_By>
  gbcs_version?: InputMaybe<Order_By>
  installation_date?: InputMaybe<Order_By>
  last_orchestration?: InputMaybe<Order_By>
  last_reading?: InputMaybe<Order_By>
  last_reading_date_time?: InputMaybe<Order_By>
  last_updated?: InputMaybe<Order_By>
  latest_alert_code?: InputMaybe<Order_By>
  latest_alert_date?: InputMaybe<Order_By>
  latest_alert_status?: InputMaybe<Order_By>
  manufacturer?: InputMaybe<Order_By>
  meter_type?: InputMaybe<Order_By>
  model?: InputMaybe<Order_By>
  mpxn?: InputMaybe<Order_By>
  msn?: InputMaybe<Order_By>
  orchestration_status?: InputMaybe<Order_By>
  payment_mode?: InputMaybe<Order_By>
  pk?: InputMaybe<Order_By>
  region?: InputMaybe<Order_By>
  smets_version?: InputMaybe<Order_By>
  srv?: InputMaybe<Order_By>
  ssd?: InputMaybe<Order_By>
  variant?: InputMaybe<Order_By>
  workstream?: InputMaybe<Order_By>
}

/** select columns of table "dashboard_complete_view_v2" */
export enum Dashboard_Complete_View_V2_Select_Column {
  /** column name */
  CommsHubId = "comms_hub_id",
  /** column name */
  DevStatus = "dev_status",
  /** column name */
  DeviceId = "device_id",
  /** column name */
  Error = "error",
  /** column name */
  ErrorStatus = "error_status",
  /** column name */
  FirmwareStatus = "firmware_status",
  /** column name */
  FirmwareVersion = "firmware_version",
  /** column name */
  GbcsVersion = "gbcs_version",
  /** column name */
  InstallationDate = "installation_date",
  /** column name */
  LastOrchestration = "last_orchestration",
  /** column name */
  LastReading = "last_reading",
  /** column name */
  LastReadingDateTime = "last_reading_date_time",
  /** column name */
  LastUpdated = "last_updated",
  /** column name */
  LatestAlertCode = "latest_alert_code",
  /** column name */
  LatestAlertDate = "latest_alert_date",
  /** column name */
  LatestAlertStatus = "latest_alert_status",
  /** column name */
  Manufacturer = "manufacturer",
  /** column name */
  MeterType = "meter_type",
  /** column name */
  Model = "model",
  /** column name */
  Mpxn = "mpxn",
  /** column name */
  Msn = "msn",
  /** column name */
  OrchestrationStatus = "orchestration_status",
  /** column name */
  PaymentMode = "payment_mode",
  /** column name */
  Pk = "pk",
  /** column name */
  Region = "region",
  /** column name */
  SmetsVersion = "smets_version",
  /** column name */
  Srv = "srv",
  /** column name */
  Ssd = "ssd",
  /** column name */
  Variant = "variant",
  /** column name */
  Workstream = "workstream",
}

/** aggregate stddev on columns */
export type Dashboard_Complete_View_V2_Stddev_Fields = {
  __typename?: "dashboard_complete_view_v2_stddev_fields"
  last_reading?: Maybe<Scalars["Float"]["output"]>
  pk?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Dashboard_Complete_View_V2_Stddev_Pop_Fields = {
  __typename?: "dashboard_complete_view_v2_stddev_pop_fields"
  last_reading?: Maybe<Scalars["Float"]["output"]>
  pk?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Dashboard_Complete_View_V2_Stddev_Samp_Fields = {
  __typename?: "dashboard_complete_view_v2_stddev_samp_fields"
  last_reading?: Maybe<Scalars["Float"]["output"]>
  pk?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "dashboard_complete_view_v2" */
export type Dashboard_Complete_View_V2_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dashboard_Complete_View_V2_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Dashboard_Complete_View_V2_Stream_Cursor_Value_Input = {
  comms_hub_id?: InputMaybe<Scalars["String"]["input"]>
  dev_status?: InputMaybe<Scalars["String"]["input"]>
  device_id?: InputMaybe<Scalars["String"]["input"]>
  error?: InputMaybe<Scalars["String"]["input"]>
  error_status?: InputMaybe<Scalars["String"]["input"]>
  firmware_status?: InputMaybe<Scalars["String"]["input"]>
  firmware_version?: InputMaybe<Scalars["String"]["input"]>
  gbcs_version?: InputMaybe<Scalars["String"]["input"]>
  installation_date?: InputMaybe<Scalars["timestamptz"]["input"]>
  last_orchestration?: InputMaybe<Scalars["String"]["input"]>
  last_reading?: InputMaybe<Scalars["bigint"]["input"]>
  last_reading_date_time?: InputMaybe<Scalars["timestamptz"]["input"]>
  last_updated?: InputMaybe<Scalars["timestamptz"]["input"]>
  latest_alert_code?: InputMaybe<Scalars["String"]["input"]>
  latest_alert_date?: InputMaybe<Scalars["timestamptz"]["input"]>
  latest_alert_status?: InputMaybe<Scalars["String"]["input"]>
  manufacturer?: InputMaybe<Scalars["String"]["input"]>
  meter_type?: InputMaybe<Scalars["String"]["input"]>
  model?: InputMaybe<Scalars["String"]["input"]>
  mpxn?: InputMaybe<Scalars["String"]["input"]>
  msn?: InputMaybe<Scalars["String"]["input"]>
  orchestration_status?: InputMaybe<Scalars["String"]["input"]>
  payment_mode?: InputMaybe<Scalars["String"]["input"]>
  pk?: InputMaybe<Scalars["bigint"]["input"]>
  region?: InputMaybe<Scalars["String"]["input"]>
  smets_version?: InputMaybe<Scalars["String"]["input"]>
  srv?: InputMaybe<Scalars["String"]["input"]>
  ssd?: InputMaybe<Scalars["timestamptz"]["input"]>
  variant?: InputMaybe<Scalars["String"]["input"]>
  workstream?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Dashboard_Complete_View_V2_Sum_Fields = {
  __typename?: "dashboard_complete_view_v2_sum_fields"
  last_reading?: Maybe<Scalars["bigint"]["output"]>
  pk?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregate var_pop on columns */
export type Dashboard_Complete_View_V2_Var_Pop_Fields = {
  __typename?: "dashboard_complete_view_v2_var_pop_fields"
  last_reading?: Maybe<Scalars["Float"]["output"]>
  pk?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Dashboard_Complete_View_V2_Var_Samp_Fields = {
  __typename?: "dashboard_complete_view_v2_var_samp_fields"
  last_reading?: Maybe<Scalars["Float"]["output"]>
  pk?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Dashboard_Complete_View_V2_Variance_Fields = {
  __typename?: "dashboard_complete_view_v2_variance_fields"
  last_reading?: Maybe<Scalars["Float"]["output"]>
  pk?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["date"]["input"]>
  _gt?: InputMaybe<Scalars["date"]["input"]>
  _gte?: InputMaybe<Scalars["date"]["input"]>
  _in?: InputMaybe<Array<Scalars["date"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["date"]["input"]>
  _lte?: InputMaybe<Scalars["date"]["input"]>
  _neq?: InputMaybe<Scalars["date"]["input"]>
  _nin?: InputMaybe<Array<Scalars["date"]["input"]>>
}

/** Boolean expression to compare columns of type "datetime". All fields are combined with logical 'AND'. */
export type Datetime_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["datetime"]["input"]>
  _gt?: InputMaybe<Scalars["datetime"]["input"]>
  _gte?: InputMaybe<Scalars["datetime"]["input"]>
  _in?: InputMaybe<Array<Scalars["datetime"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["datetime"]["input"]>
  _lte?: InputMaybe<Scalars["datetime"]["input"]>
  _neq?: InputMaybe<Scalars["datetime"]["input"]>
  _nin?: InputMaybe<Array<Scalars["datetime"]["input"]>>
}

/** Boolean expression to compare columns of type "dcc_service_status". All fields are combined with logical 'AND'. */
export type Dcc_Service_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["dcc_service_status"]["input"]>
  _gt?: InputMaybe<Scalars["dcc_service_status"]["input"]>
  _gte?: InputMaybe<Scalars["dcc_service_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["dcc_service_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["dcc_service_status"]["input"]>
  _lte?: InputMaybe<Scalars["dcc_service_status"]["input"]>
  _neq?: InputMaybe<Scalars["dcc_service_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["dcc_service_status"]["input"]>>
}

/** columns and relationships of "deprecated_solar_quote_requests" */
export type Deprecated_Solar_Quote_Requests = {
  __typename?: "deprecated_solar_quote_requests"
  address_lines?: Maybe<Scalars["String"]["output"]>
  annual_electricity_consumption?: Maybe<Scalars["String"]["output"]>
  authorised_to_alter_property?: Maybe<Scalars["Boolean"]["output"]>
  consent_for_data_processing: Scalars["Boolean"]["output"]
  created_at: Scalars["timestamptz"]["output"]
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  email: Scalars["String"]["output"]
  flat_roof?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["bigint"]["output"]
  installation_time_frame?: Maybe<Scalars["time_frame"]["output"]>
  is_existing_customer?: Maybe<Scalars["Boolean"]["output"]>
  is_serviceable: Scalars["Boolean"]["output"]
  latitude?: Maybe<Scalars["numeric"]["output"]>
  lives_in_conservation_area?: Maybe<Scalars["Boolean"]["output"]>
  longitude?: Maybe<Scalars["numeric"]["output"]>
  name: Scalars["String"]["output"]
  not_in_service_area: Scalars["Boolean"]["output"]
  notes?: Maybe<Scalars["String"]["output"]>
  phone: Scalars["String"]["output"]
  pipedrive_deal_id?: Maybe<Scalars["bigint"]["output"]>
  pipedrive_lead_id?: Maybe<Scalars["String"]["output"]>
  pipedrive_person_id?: Maybe<Scalars["bigint"]["output"]>
  postcode: Scalars["String"]["output"]
  selected_package?: Maybe<Scalars["package"]["output"]>
  tariff?: Maybe<Scalars["String"]["output"]>
  time_indoors?: Maybe<Scalars["time_at_property"]["output"]>
  title?: Maybe<Scalars["String"]["output"]>
  unit_rate?: Maybe<Scalars["String"]["output"]>
  utm_content?: Maybe<Scalars["String"]["output"]>
  utm_gclid?: Maybe<Scalars["String"]["output"]>
  utm_id?: Maybe<Scalars["bigint"]["output"]>
  utm_medium?: Maybe<Scalars["String"]["output"]>
  utm_name?: Maybe<Scalars["String"]["output"]>
  utm_source?: Maybe<Scalars["String"]["output"]>
  utm_term?: Maybe<Scalars["String"]["output"]>
  utm_url?: Maybe<Scalars["String"]["output"]>
}

/** aggregated selection of "deprecated_solar_quote_requests" */
export type Deprecated_Solar_Quote_Requests_Aggregate = {
  __typename?: "deprecated_solar_quote_requests_aggregate"
  aggregate?: Maybe<Deprecated_Solar_Quote_Requests_Aggregate_Fields>
  nodes: Array<Deprecated_Solar_Quote_Requests>
}

/** aggregate fields of "deprecated_solar_quote_requests" */
export type Deprecated_Solar_Quote_Requests_Aggregate_Fields = {
  __typename?: "deprecated_solar_quote_requests_aggregate_fields"
  avg?: Maybe<Deprecated_Solar_Quote_Requests_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Deprecated_Solar_Quote_Requests_Max_Fields>
  min?: Maybe<Deprecated_Solar_Quote_Requests_Min_Fields>
  stddev?: Maybe<Deprecated_Solar_Quote_Requests_Stddev_Fields>
  stddev_pop?: Maybe<Deprecated_Solar_Quote_Requests_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Deprecated_Solar_Quote_Requests_Stddev_Samp_Fields>
  sum?: Maybe<Deprecated_Solar_Quote_Requests_Sum_Fields>
  var_pop?: Maybe<Deprecated_Solar_Quote_Requests_Var_Pop_Fields>
  var_samp?: Maybe<Deprecated_Solar_Quote_Requests_Var_Samp_Fields>
  variance?: Maybe<Deprecated_Solar_Quote_Requests_Variance_Fields>
}

/** aggregate fields of "deprecated_solar_quote_requests" */
export type Deprecated_Solar_Quote_Requests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Deprecated_Solar_Quote_Requests_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Deprecated_Solar_Quote_Requests_Avg_Fields = {
  __typename?: "deprecated_solar_quote_requests_avg_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  latitude?: Maybe<Scalars["Float"]["output"]>
  longitude?: Maybe<Scalars["Float"]["output"]>
  pipedrive_deal_id?: Maybe<Scalars["Float"]["output"]>
  pipedrive_person_id?: Maybe<Scalars["Float"]["output"]>
  utm_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "deprecated_solar_quote_requests". All fields are combined with a logical 'AND'. */
export type Deprecated_Solar_Quote_Requests_Bool_Exp = {
  _and?: InputMaybe<Array<Deprecated_Solar_Quote_Requests_Bool_Exp>>
  _not?: InputMaybe<Deprecated_Solar_Quote_Requests_Bool_Exp>
  _or?: InputMaybe<Array<Deprecated_Solar_Quote_Requests_Bool_Exp>>
  address_lines?: InputMaybe<String_Comparison_Exp>
  annual_electricity_consumption?: InputMaybe<String_Comparison_Exp>
  authorised_to_alter_property?: InputMaybe<Boolean_Comparison_Exp>
  consent_for_data_processing?: InputMaybe<Boolean_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  customer_id?: InputMaybe<Bigint_Comparison_Exp>
  email?: InputMaybe<String_Comparison_Exp>
  flat_roof?: InputMaybe<Boolean_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  installation_time_frame?: InputMaybe<Time_Frame_Comparison_Exp>
  is_existing_customer?: InputMaybe<Boolean_Comparison_Exp>
  is_serviceable?: InputMaybe<Boolean_Comparison_Exp>
  latitude?: InputMaybe<Numeric_Comparison_Exp>
  lives_in_conservation_area?: InputMaybe<Boolean_Comparison_Exp>
  longitude?: InputMaybe<Numeric_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  not_in_service_area?: InputMaybe<Boolean_Comparison_Exp>
  notes?: InputMaybe<String_Comparison_Exp>
  phone?: InputMaybe<String_Comparison_Exp>
  pipedrive_deal_id?: InputMaybe<Bigint_Comparison_Exp>
  pipedrive_lead_id?: InputMaybe<String_Comparison_Exp>
  pipedrive_person_id?: InputMaybe<Bigint_Comparison_Exp>
  postcode?: InputMaybe<String_Comparison_Exp>
  selected_package?: InputMaybe<Package_Comparison_Exp>
  tariff?: InputMaybe<String_Comparison_Exp>
  time_indoors?: InputMaybe<Time_At_Property_Comparison_Exp>
  title?: InputMaybe<String_Comparison_Exp>
  unit_rate?: InputMaybe<String_Comparison_Exp>
  utm_content?: InputMaybe<String_Comparison_Exp>
  utm_gclid?: InputMaybe<String_Comparison_Exp>
  utm_id?: InputMaybe<Bigint_Comparison_Exp>
  utm_medium?: InputMaybe<String_Comparison_Exp>
  utm_name?: InputMaybe<String_Comparison_Exp>
  utm_source?: InputMaybe<String_Comparison_Exp>
  utm_term?: InputMaybe<String_Comparison_Exp>
  utm_url?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "deprecated_solar_quote_requests" */
export enum Deprecated_Solar_Quote_Requests_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkAccounts = "pk_accounts",
}

/** input type for incrementing numeric columns in table "deprecated_solar_quote_requests" */
export type Deprecated_Solar_Quote_Requests_Inc_Input = {
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  latitude?: InputMaybe<Scalars["numeric"]["input"]>
  longitude?: InputMaybe<Scalars["numeric"]["input"]>
  pipedrive_deal_id?: InputMaybe<Scalars["bigint"]["input"]>
  pipedrive_person_id?: InputMaybe<Scalars["bigint"]["input"]>
  utm_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "deprecated_solar_quote_requests" */
export type Deprecated_Solar_Quote_Requests_Insert_Input = {
  address_lines?: InputMaybe<Scalars["String"]["input"]>
  annual_electricity_consumption?: InputMaybe<Scalars["String"]["input"]>
  authorised_to_alter_property?: InputMaybe<Scalars["Boolean"]["input"]>
  consent_for_data_processing?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  flat_roof?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  installation_time_frame?: InputMaybe<Scalars["time_frame"]["input"]>
  is_existing_customer?: InputMaybe<Scalars["Boolean"]["input"]>
  is_serviceable?: InputMaybe<Scalars["Boolean"]["input"]>
  latitude?: InputMaybe<Scalars["numeric"]["input"]>
  lives_in_conservation_area?: InputMaybe<Scalars["Boolean"]["input"]>
  longitude?: InputMaybe<Scalars["numeric"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  not_in_service_area?: InputMaybe<Scalars["Boolean"]["input"]>
  notes?: InputMaybe<Scalars["String"]["input"]>
  phone?: InputMaybe<Scalars["String"]["input"]>
  pipedrive_deal_id?: InputMaybe<Scalars["bigint"]["input"]>
  pipedrive_lead_id?: InputMaybe<Scalars["String"]["input"]>
  pipedrive_person_id?: InputMaybe<Scalars["bigint"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  selected_package?: InputMaybe<Scalars["package"]["input"]>
  tariff?: InputMaybe<Scalars["String"]["input"]>
  time_indoors?: InputMaybe<Scalars["time_at_property"]["input"]>
  title?: InputMaybe<Scalars["String"]["input"]>
  unit_rate?: InputMaybe<Scalars["String"]["input"]>
  utm_content?: InputMaybe<Scalars["String"]["input"]>
  utm_gclid?: InputMaybe<Scalars["String"]["input"]>
  utm_id?: InputMaybe<Scalars["bigint"]["input"]>
  utm_medium?: InputMaybe<Scalars["String"]["input"]>
  utm_name?: InputMaybe<Scalars["String"]["input"]>
  utm_source?: InputMaybe<Scalars["String"]["input"]>
  utm_term?: InputMaybe<Scalars["String"]["input"]>
  utm_url?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Deprecated_Solar_Quote_Requests_Max_Fields = {
  __typename?: "deprecated_solar_quote_requests_max_fields"
  address_lines?: Maybe<Scalars["String"]["output"]>
  annual_electricity_consumption?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  installation_time_frame?: Maybe<Scalars["time_frame"]["output"]>
  latitude?: Maybe<Scalars["numeric"]["output"]>
  longitude?: Maybe<Scalars["numeric"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  notes?: Maybe<Scalars["String"]["output"]>
  phone?: Maybe<Scalars["String"]["output"]>
  pipedrive_deal_id?: Maybe<Scalars["bigint"]["output"]>
  pipedrive_lead_id?: Maybe<Scalars["String"]["output"]>
  pipedrive_person_id?: Maybe<Scalars["bigint"]["output"]>
  postcode?: Maybe<Scalars["String"]["output"]>
  selected_package?: Maybe<Scalars["package"]["output"]>
  tariff?: Maybe<Scalars["String"]["output"]>
  time_indoors?: Maybe<Scalars["time_at_property"]["output"]>
  title?: Maybe<Scalars["String"]["output"]>
  unit_rate?: Maybe<Scalars["String"]["output"]>
  utm_content?: Maybe<Scalars["String"]["output"]>
  utm_gclid?: Maybe<Scalars["String"]["output"]>
  utm_id?: Maybe<Scalars["bigint"]["output"]>
  utm_medium?: Maybe<Scalars["String"]["output"]>
  utm_name?: Maybe<Scalars["String"]["output"]>
  utm_source?: Maybe<Scalars["String"]["output"]>
  utm_term?: Maybe<Scalars["String"]["output"]>
  utm_url?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Deprecated_Solar_Quote_Requests_Min_Fields = {
  __typename?: "deprecated_solar_quote_requests_min_fields"
  address_lines?: Maybe<Scalars["String"]["output"]>
  annual_electricity_consumption?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  installation_time_frame?: Maybe<Scalars["time_frame"]["output"]>
  latitude?: Maybe<Scalars["numeric"]["output"]>
  longitude?: Maybe<Scalars["numeric"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  notes?: Maybe<Scalars["String"]["output"]>
  phone?: Maybe<Scalars["String"]["output"]>
  pipedrive_deal_id?: Maybe<Scalars["bigint"]["output"]>
  pipedrive_lead_id?: Maybe<Scalars["String"]["output"]>
  pipedrive_person_id?: Maybe<Scalars["bigint"]["output"]>
  postcode?: Maybe<Scalars["String"]["output"]>
  selected_package?: Maybe<Scalars["package"]["output"]>
  tariff?: Maybe<Scalars["String"]["output"]>
  time_indoors?: Maybe<Scalars["time_at_property"]["output"]>
  title?: Maybe<Scalars["String"]["output"]>
  unit_rate?: Maybe<Scalars["String"]["output"]>
  utm_content?: Maybe<Scalars["String"]["output"]>
  utm_gclid?: Maybe<Scalars["String"]["output"]>
  utm_id?: Maybe<Scalars["bigint"]["output"]>
  utm_medium?: Maybe<Scalars["String"]["output"]>
  utm_name?: Maybe<Scalars["String"]["output"]>
  utm_source?: Maybe<Scalars["String"]["output"]>
  utm_term?: Maybe<Scalars["String"]["output"]>
  utm_url?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "deprecated_solar_quote_requests" */
export type Deprecated_Solar_Quote_Requests_Mutation_Response = {
  __typename?: "deprecated_solar_quote_requests_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Deprecated_Solar_Quote_Requests>
}

/** on_conflict condition type for table "deprecated_solar_quote_requests" */
export type Deprecated_Solar_Quote_Requests_On_Conflict = {
  constraint: Deprecated_Solar_Quote_Requests_Constraint
  update_columns?: Array<Deprecated_Solar_Quote_Requests_Update_Column>
  where?: InputMaybe<Deprecated_Solar_Quote_Requests_Bool_Exp>
}

/** Ordering options when selecting data from "deprecated_solar_quote_requests". */
export type Deprecated_Solar_Quote_Requests_Order_By = {
  address_lines?: InputMaybe<Order_By>
  annual_electricity_consumption?: InputMaybe<Order_By>
  authorised_to_alter_property?: InputMaybe<Order_By>
  consent_for_data_processing?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  email?: InputMaybe<Order_By>
  flat_roof?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  installation_time_frame?: InputMaybe<Order_By>
  is_existing_customer?: InputMaybe<Order_By>
  is_serviceable?: InputMaybe<Order_By>
  latitude?: InputMaybe<Order_By>
  lives_in_conservation_area?: InputMaybe<Order_By>
  longitude?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  not_in_service_area?: InputMaybe<Order_By>
  notes?: InputMaybe<Order_By>
  phone?: InputMaybe<Order_By>
  pipedrive_deal_id?: InputMaybe<Order_By>
  pipedrive_lead_id?: InputMaybe<Order_By>
  pipedrive_person_id?: InputMaybe<Order_By>
  postcode?: InputMaybe<Order_By>
  selected_package?: InputMaybe<Order_By>
  tariff?: InputMaybe<Order_By>
  time_indoors?: InputMaybe<Order_By>
  title?: InputMaybe<Order_By>
  unit_rate?: InputMaybe<Order_By>
  utm_content?: InputMaybe<Order_By>
  utm_gclid?: InputMaybe<Order_By>
  utm_id?: InputMaybe<Order_By>
  utm_medium?: InputMaybe<Order_By>
  utm_name?: InputMaybe<Order_By>
  utm_source?: InputMaybe<Order_By>
  utm_term?: InputMaybe<Order_By>
  utm_url?: InputMaybe<Order_By>
}

/** primary key columns input for table: deprecated_solar_quote_requests */
export type Deprecated_Solar_Quote_Requests_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "deprecated_solar_quote_requests" */
export enum Deprecated_Solar_Quote_Requests_Select_Column {
  /** column name */
  AddressLines = "address_lines",
  /** column name */
  AnnualElectricityConsumption = "annual_electricity_consumption",
  /** column name */
  AuthorisedToAlterProperty = "authorised_to_alter_property",
  /** column name */
  ConsentForDataProcessing = "consent_for_data_processing",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  Email = "email",
  /** column name */
  FlatRoof = "flat_roof",
  /** column name */
  Id = "id",
  /** column name */
  InstallationTimeFrame = "installation_time_frame",
  /** column name */
  IsExistingCustomer = "is_existing_customer",
  /** column name */
  IsServiceable = "is_serviceable",
  /** column name */
  Latitude = "latitude",
  /** column name */
  LivesInConservationArea = "lives_in_conservation_area",
  /** column name */
  Longitude = "longitude",
  /** column name */
  Name = "name",
  /** column name */
  NotInServiceArea = "not_in_service_area",
  /** column name */
  Notes = "notes",
  /** column name */
  Phone = "phone",
  /** column name */
  PipedriveDealId = "pipedrive_deal_id",
  /** column name */
  PipedriveLeadId = "pipedrive_lead_id",
  /** column name */
  PipedrivePersonId = "pipedrive_person_id",
  /** column name */
  Postcode = "postcode",
  /** column name */
  SelectedPackage = "selected_package",
  /** column name */
  Tariff = "tariff",
  /** column name */
  TimeIndoors = "time_indoors",
  /** column name */
  Title = "title",
  /** column name */
  UnitRate = "unit_rate",
  /** column name */
  UtmContent = "utm_content",
  /** column name */
  UtmGclid = "utm_gclid",
  /** column name */
  UtmId = "utm_id",
  /** column name */
  UtmMedium = "utm_medium",
  /** column name */
  UtmName = "utm_name",
  /** column name */
  UtmSource = "utm_source",
  /** column name */
  UtmTerm = "utm_term",
  /** column name */
  UtmUrl = "utm_url",
}

/** input type for updating data in table "deprecated_solar_quote_requests" */
export type Deprecated_Solar_Quote_Requests_Set_Input = {
  address_lines?: InputMaybe<Scalars["String"]["input"]>
  annual_electricity_consumption?: InputMaybe<Scalars["String"]["input"]>
  authorised_to_alter_property?: InputMaybe<Scalars["Boolean"]["input"]>
  consent_for_data_processing?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  flat_roof?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  installation_time_frame?: InputMaybe<Scalars["time_frame"]["input"]>
  is_existing_customer?: InputMaybe<Scalars["Boolean"]["input"]>
  is_serviceable?: InputMaybe<Scalars["Boolean"]["input"]>
  latitude?: InputMaybe<Scalars["numeric"]["input"]>
  lives_in_conservation_area?: InputMaybe<Scalars["Boolean"]["input"]>
  longitude?: InputMaybe<Scalars["numeric"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  not_in_service_area?: InputMaybe<Scalars["Boolean"]["input"]>
  notes?: InputMaybe<Scalars["String"]["input"]>
  phone?: InputMaybe<Scalars["String"]["input"]>
  pipedrive_deal_id?: InputMaybe<Scalars["bigint"]["input"]>
  pipedrive_lead_id?: InputMaybe<Scalars["String"]["input"]>
  pipedrive_person_id?: InputMaybe<Scalars["bigint"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  selected_package?: InputMaybe<Scalars["package"]["input"]>
  tariff?: InputMaybe<Scalars["String"]["input"]>
  time_indoors?: InputMaybe<Scalars["time_at_property"]["input"]>
  title?: InputMaybe<Scalars["String"]["input"]>
  unit_rate?: InputMaybe<Scalars["String"]["input"]>
  utm_content?: InputMaybe<Scalars["String"]["input"]>
  utm_gclid?: InputMaybe<Scalars["String"]["input"]>
  utm_id?: InputMaybe<Scalars["bigint"]["input"]>
  utm_medium?: InputMaybe<Scalars["String"]["input"]>
  utm_name?: InputMaybe<Scalars["String"]["input"]>
  utm_source?: InputMaybe<Scalars["String"]["input"]>
  utm_term?: InputMaybe<Scalars["String"]["input"]>
  utm_url?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Deprecated_Solar_Quote_Requests_Stddev_Fields = {
  __typename?: "deprecated_solar_quote_requests_stddev_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  latitude?: Maybe<Scalars["Float"]["output"]>
  longitude?: Maybe<Scalars["Float"]["output"]>
  pipedrive_deal_id?: Maybe<Scalars["Float"]["output"]>
  pipedrive_person_id?: Maybe<Scalars["Float"]["output"]>
  utm_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Deprecated_Solar_Quote_Requests_Stddev_Pop_Fields = {
  __typename?: "deprecated_solar_quote_requests_stddev_pop_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  latitude?: Maybe<Scalars["Float"]["output"]>
  longitude?: Maybe<Scalars["Float"]["output"]>
  pipedrive_deal_id?: Maybe<Scalars["Float"]["output"]>
  pipedrive_person_id?: Maybe<Scalars["Float"]["output"]>
  utm_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Deprecated_Solar_Quote_Requests_Stddev_Samp_Fields = {
  __typename?: "deprecated_solar_quote_requests_stddev_samp_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  latitude?: Maybe<Scalars["Float"]["output"]>
  longitude?: Maybe<Scalars["Float"]["output"]>
  pipedrive_deal_id?: Maybe<Scalars["Float"]["output"]>
  pipedrive_person_id?: Maybe<Scalars["Float"]["output"]>
  utm_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "deprecated_solar_quote_requests" */
export type Deprecated_Solar_Quote_Requests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Deprecated_Solar_Quote_Requests_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Deprecated_Solar_Quote_Requests_Stream_Cursor_Value_Input = {
  address_lines?: InputMaybe<Scalars["String"]["input"]>
  annual_electricity_consumption?: InputMaybe<Scalars["String"]["input"]>
  authorised_to_alter_property?: InputMaybe<Scalars["Boolean"]["input"]>
  consent_for_data_processing?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  flat_roof?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  installation_time_frame?: InputMaybe<Scalars["time_frame"]["input"]>
  is_existing_customer?: InputMaybe<Scalars["Boolean"]["input"]>
  is_serviceable?: InputMaybe<Scalars["Boolean"]["input"]>
  latitude?: InputMaybe<Scalars["numeric"]["input"]>
  lives_in_conservation_area?: InputMaybe<Scalars["Boolean"]["input"]>
  longitude?: InputMaybe<Scalars["numeric"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  not_in_service_area?: InputMaybe<Scalars["Boolean"]["input"]>
  notes?: InputMaybe<Scalars["String"]["input"]>
  phone?: InputMaybe<Scalars["String"]["input"]>
  pipedrive_deal_id?: InputMaybe<Scalars["bigint"]["input"]>
  pipedrive_lead_id?: InputMaybe<Scalars["String"]["input"]>
  pipedrive_person_id?: InputMaybe<Scalars["bigint"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  selected_package?: InputMaybe<Scalars["package"]["input"]>
  tariff?: InputMaybe<Scalars["String"]["input"]>
  time_indoors?: InputMaybe<Scalars["time_at_property"]["input"]>
  title?: InputMaybe<Scalars["String"]["input"]>
  unit_rate?: InputMaybe<Scalars["String"]["input"]>
  utm_content?: InputMaybe<Scalars["String"]["input"]>
  utm_gclid?: InputMaybe<Scalars["String"]["input"]>
  utm_id?: InputMaybe<Scalars["bigint"]["input"]>
  utm_medium?: InputMaybe<Scalars["String"]["input"]>
  utm_name?: InputMaybe<Scalars["String"]["input"]>
  utm_source?: InputMaybe<Scalars["String"]["input"]>
  utm_term?: InputMaybe<Scalars["String"]["input"]>
  utm_url?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Deprecated_Solar_Quote_Requests_Sum_Fields = {
  __typename?: "deprecated_solar_quote_requests_sum_fields"
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  latitude?: Maybe<Scalars["numeric"]["output"]>
  longitude?: Maybe<Scalars["numeric"]["output"]>
  pipedrive_deal_id?: Maybe<Scalars["bigint"]["output"]>
  pipedrive_person_id?: Maybe<Scalars["bigint"]["output"]>
  utm_id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "deprecated_solar_quote_requests" */
export enum Deprecated_Solar_Quote_Requests_Update_Column {
  /** column name */
  AddressLines = "address_lines",
  /** column name */
  AnnualElectricityConsumption = "annual_electricity_consumption",
  /** column name */
  AuthorisedToAlterProperty = "authorised_to_alter_property",
  /** column name */
  ConsentForDataProcessing = "consent_for_data_processing",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  Email = "email",
  /** column name */
  FlatRoof = "flat_roof",
  /** column name */
  Id = "id",
  /** column name */
  InstallationTimeFrame = "installation_time_frame",
  /** column name */
  IsExistingCustomer = "is_existing_customer",
  /** column name */
  IsServiceable = "is_serviceable",
  /** column name */
  Latitude = "latitude",
  /** column name */
  LivesInConservationArea = "lives_in_conservation_area",
  /** column name */
  Longitude = "longitude",
  /** column name */
  Name = "name",
  /** column name */
  NotInServiceArea = "not_in_service_area",
  /** column name */
  Notes = "notes",
  /** column name */
  Phone = "phone",
  /** column name */
  PipedriveDealId = "pipedrive_deal_id",
  /** column name */
  PipedriveLeadId = "pipedrive_lead_id",
  /** column name */
  PipedrivePersonId = "pipedrive_person_id",
  /** column name */
  Postcode = "postcode",
  /** column name */
  SelectedPackage = "selected_package",
  /** column name */
  Tariff = "tariff",
  /** column name */
  TimeIndoors = "time_indoors",
  /** column name */
  Title = "title",
  /** column name */
  UnitRate = "unit_rate",
  /** column name */
  UtmContent = "utm_content",
  /** column name */
  UtmGclid = "utm_gclid",
  /** column name */
  UtmId = "utm_id",
  /** column name */
  UtmMedium = "utm_medium",
  /** column name */
  UtmName = "utm_name",
  /** column name */
  UtmSource = "utm_source",
  /** column name */
  UtmTerm = "utm_term",
  /** column name */
  UtmUrl = "utm_url",
}

export type Deprecated_Solar_Quote_Requests_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Deprecated_Solar_Quote_Requests_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Deprecated_Solar_Quote_Requests_Set_Input>
  /** filter the rows which have to be updated */
  where: Deprecated_Solar_Quote_Requests_Bool_Exp
}

/** aggregate var_pop on columns */
export type Deprecated_Solar_Quote_Requests_Var_Pop_Fields = {
  __typename?: "deprecated_solar_quote_requests_var_pop_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  latitude?: Maybe<Scalars["Float"]["output"]>
  longitude?: Maybe<Scalars["Float"]["output"]>
  pipedrive_deal_id?: Maybe<Scalars["Float"]["output"]>
  pipedrive_person_id?: Maybe<Scalars["Float"]["output"]>
  utm_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Deprecated_Solar_Quote_Requests_Var_Samp_Fields = {
  __typename?: "deprecated_solar_quote_requests_var_samp_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  latitude?: Maybe<Scalars["Float"]["output"]>
  longitude?: Maybe<Scalars["Float"]["output"]>
  pipedrive_deal_id?: Maybe<Scalars["Float"]["output"]>
  pipedrive_person_id?: Maybe<Scalars["Float"]["output"]>
  utm_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Deprecated_Solar_Quote_Requests_Variance_Fields = {
  __typename?: "deprecated_solar_quote_requests_variance_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  latitude?: Maybe<Scalars["Float"]["output"]>
  longitude?: Maybe<Scalars["Float"]["output"]>
  pipedrive_deal_id?: Maybe<Scalars["Float"]["output"]>
  pipedrive_person_id?: Maybe<Scalars["Float"]["output"]>
  utm_id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "direct_debit" */
export type Direct_Debit = {
  __typename?: "direct_debit"
  account_number_masked: Scalars["String"]["output"]
  auth_request_at?: Maybe<Scalars["timestamp"]["output"]>
  authorized_at?: Maybe<Scalars["timestamp"]["output"]>
  bank_reference?: Maybe<Scalars["String"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  mandate_reference?: Maybe<Scalars["String"]["output"]>
  sort_code_masked: Scalars["String"]["output"]
  status?: Maybe<Scalars["direct_debit_status"]["output"]>
  terminated_at?: Maybe<Scalars["timestamp"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "direct_debit" */
export type Direct_Debit_Aggregate = {
  __typename?: "direct_debit_aggregate"
  aggregate?: Maybe<Direct_Debit_Aggregate_Fields>
  nodes: Array<Direct_Debit>
}

/** aggregate fields of "direct_debit" */
export type Direct_Debit_Aggregate_Fields = {
  __typename?: "direct_debit_aggregate_fields"
  avg?: Maybe<Direct_Debit_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Direct_Debit_Max_Fields>
  min?: Maybe<Direct_Debit_Min_Fields>
  stddev?: Maybe<Direct_Debit_Stddev_Fields>
  stddev_pop?: Maybe<Direct_Debit_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Direct_Debit_Stddev_Samp_Fields>
  sum?: Maybe<Direct_Debit_Sum_Fields>
  var_pop?: Maybe<Direct_Debit_Var_Pop_Fields>
  var_samp?: Maybe<Direct_Debit_Var_Samp_Fields>
  variance?: Maybe<Direct_Debit_Variance_Fields>
}

/** aggregate fields of "direct_debit" */
export type Direct_Debit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Direct_Debit_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Direct_Debit_Avg_Fields = {
  __typename?: "direct_debit_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "direct_debit". All fields are combined with a logical 'AND'. */
export type Direct_Debit_Bool_Exp = {
  _and?: InputMaybe<Array<Direct_Debit_Bool_Exp>>
  _not?: InputMaybe<Direct_Debit_Bool_Exp>
  _or?: InputMaybe<Array<Direct_Debit_Bool_Exp>>
  account_number_masked?: InputMaybe<String_Comparison_Exp>
  auth_request_at?: InputMaybe<Timestamp_Comparison_Exp>
  authorized_at?: InputMaybe<Timestamp_Comparison_Exp>
  bank_reference?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  mandate_reference?: InputMaybe<String_Comparison_Exp>
  sort_code_masked?: InputMaybe<String_Comparison_Exp>
  status?: InputMaybe<Direct_Debit_Status_Comparison_Exp>
  terminated_at?: InputMaybe<Timestamp_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "direct_debit" */
export enum Direct_Debit_Constraint {
  /** unique or primary key constraint on columns "id" */
  DirectDebitPkey = "direct_debit_pkey",
}

/** input type for incrementing numeric columns in table "direct_debit" */
export type Direct_Debit_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "direct_debit" */
export type Direct_Debit_Insert_Input = {
  account_number_masked?: InputMaybe<Scalars["String"]["input"]>
  auth_request_at?: InputMaybe<Scalars["timestamp"]["input"]>
  authorized_at?: InputMaybe<Scalars["timestamp"]["input"]>
  bank_reference?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  mandate_reference?: InputMaybe<Scalars["String"]["input"]>
  sort_code_masked?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["direct_debit_status"]["input"]>
  terminated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Direct_Debit_Max_Fields = {
  __typename?: "direct_debit_max_fields"
  account_number_masked?: Maybe<Scalars["String"]["output"]>
  auth_request_at?: Maybe<Scalars["timestamp"]["output"]>
  authorized_at?: Maybe<Scalars["timestamp"]["output"]>
  bank_reference?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  mandate_reference?: Maybe<Scalars["String"]["output"]>
  sort_code_masked?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["direct_debit_status"]["output"]>
  terminated_at?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Direct_Debit_Min_Fields = {
  __typename?: "direct_debit_min_fields"
  account_number_masked?: Maybe<Scalars["String"]["output"]>
  auth_request_at?: Maybe<Scalars["timestamp"]["output"]>
  authorized_at?: Maybe<Scalars["timestamp"]["output"]>
  bank_reference?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  mandate_reference?: Maybe<Scalars["String"]["output"]>
  sort_code_masked?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["direct_debit_status"]["output"]>
  terminated_at?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "direct_debit" */
export type Direct_Debit_Mutation_Response = {
  __typename?: "direct_debit_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Direct_Debit>
}

/** on_conflict condition type for table "direct_debit" */
export type Direct_Debit_On_Conflict = {
  constraint: Direct_Debit_Constraint
  update_columns?: Array<Direct_Debit_Update_Column>
  where?: InputMaybe<Direct_Debit_Bool_Exp>
}

/** Ordering options when selecting data from "direct_debit". */
export type Direct_Debit_Order_By = {
  account_number_masked?: InputMaybe<Order_By>
  auth_request_at?: InputMaybe<Order_By>
  authorized_at?: InputMaybe<Order_By>
  bank_reference?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  mandate_reference?: InputMaybe<Order_By>
  sort_code_masked?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  terminated_at?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** columns and relationships of "direct_debit_payment" */
export type Direct_Debit_Payment = {
  __typename?: "direct_debit_payment"
  bacs_processing_date?: Maybe<Scalars["timestamp"]["output"]>
  billing_account_id: Scalars["bigint"]["output"]
  billing_account_transactions: Array<Billing_Account_Transaction>
  billing_account_transactions_aggregate: Billing_Account_Transaction_Aggregate
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  direct_debit_id: Scalars["bigint"]["output"]
  id: Scalars["bigint"]["output"]
  success_plus_fl?: Maybe<Scalars["Boolean"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "direct_debit_payment" */
export type Direct_Debit_PaymentBilling_Account_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Transaction_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Transaction_Order_By>>
  where?: InputMaybe<Billing_Account_Transaction_Bool_Exp>
}

/** columns and relationships of "direct_debit_payment" */
export type Direct_Debit_PaymentBilling_Account_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Transaction_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Transaction_Order_By>>
  where?: InputMaybe<Billing_Account_Transaction_Bool_Exp>
}

/** aggregated selection of "direct_debit_payment" */
export type Direct_Debit_Payment_Aggregate = {
  __typename?: "direct_debit_payment_aggregate"
  aggregate?: Maybe<Direct_Debit_Payment_Aggregate_Fields>
  nodes: Array<Direct_Debit_Payment>
}

/** aggregate fields of "direct_debit_payment" */
export type Direct_Debit_Payment_Aggregate_Fields = {
  __typename?: "direct_debit_payment_aggregate_fields"
  avg?: Maybe<Direct_Debit_Payment_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Direct_Debit_Payment_Max_Fields>
  min?: Maybe<Direct_Debit_Payment_Min_Fields>
  stddev?: Maybe<Direct_Debit_Payment_Stddev_Fields>
  stddev_pop?: Maybe<Direct_Debit_Payment_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Direct_Debit_Payment_Stddev_Samp_Fields>
  sum?: Maybe<Direct_Debit_Payment_Sum_Fields>
  var_pop?: Maybe<Direct_Debit_Payment_Var_Pop_Fields>
  var_samp?: Maybe<Direct_Debit_Payment_Var_Samp_Fields>
  variance?: Maybe<Direct_Debit_Payment_Variance_Fields>
}

/** aggregate fields of "direct_debit_payment" */
export type Direct_Debit_Payment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Direct_Debit_Payment_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Direct_Debit_Payment_Avg_Fields = {
  __typename?: "direct_debit_payment_avg_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  direct_debit_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "direct_debit_payment". All fields are combined with a logical 'AND'. */
export type Direct_Debit_Payment_Bool_Exp = {
  _and?: InputMaybe<Array<Direct_Debit_Payment_Bool_Exp>>
  _not?: InputMaybe<Direct_Debit_Payment_Bool_Exp>
  _or?: InputMaybe<Array<Direct_Debit_Payment_Bool_Exp>>
  bacs_processing_date?: InputMaybe<Timestamp_Comparison_Exp>
  billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  billing_account_transactions?: InputMaybe<Billing_Account_Transaction_Bool_Exp>
  billing_account_transactions_aggregate?: InputMaybe<Billing_Account_Transaction_Aggregate_Bool_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  direct_debit_id?: InputMaybe<Bigint_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  success_plus_fl?: InputMaybe<Boolean_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "direct_debit_payment" */
export enum Direct_Debit_Payment_Constraint {
  /** unique or primary key constraint on columns "id" */
  DirectDebitPaymentPkey = "direct_debit_payment_pkey",
}

/** input type for incrementing numeric columns in table "direct_debit_payment" */
export type Direct_Debit_Payment_Inc_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  direct_debit_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "direct_debit_payment" */
export type Direct_Debit_Payment_Insert_Input = {
  bacs_processing_date?: InputMaybe<Scalars["timestamp"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  billing_account_transactions?: InputMaybe<Billing_Account_Transaction_Arr_Rel_Insert_Input>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  direct_debit_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  success_plus_fl?: InputMaybe<Scalars["Boolean"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Direct_Debit_Payment_Max_Fields = {
  __typename?: "direct_debit_payment_max_fields"
  bacs_processing_date?: Maybe<Scalars["timestamp"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  direct_debit_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Direct_Debit_Payment_Min_Fields = {
  __typename?: "direct_debit_payment_min_fields"
  bacs_processing_date?: Maybe<Scalars["timestamp"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  direct_debit_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "direct_debit_payment" */
export type Direct_Debit_Payment_Mutation_Response = {
  __typename?: "direct_debit_payment_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Direct_Debit_Payment>
}

/** input type for inserting object relation for remote table "direct_debit_payment" */
export type Direct_Debit_Payment_Obj_Rel_Insert_Input = {
  data: Direct_Debit_Payment_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Direct_Debit_Payment_On_Conflict>
}

/** on_conflict condition type for table "direct_debit_payment" */
export type Direct_Debit_Payment_On_Conflict = {
  constraint: Direct_Debit_Payment_Constraint
  update_columns?: Array<Direct_Debit_Payment_Update_Column>
  where?: InputMaybe<Direct_Debit_Payment_Bool_Exp>
}

/** Ordering options when selecting data from "direct_debit_payment". */
export type Direct_Debit_Payment_Order_By = {
  bacs_processing_date?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  billing_account_transactions_aggregate?: InputMaybe<Billing_Account_Transaction_Aggregate_Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  direct_debit_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  success_plus_fl?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: direct_debit_payment */
export type Direct_Debit_Payment_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "direct_debit_payment" */
export enum Direct_Debit_Payment_Select_Column {
  /** column name */
  BacsProcessingDate = "bacs_processing_date",
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  DirectDebitId = "direct_debit_id",
  /** column name */
  Id = "id",
  /** column name */
  SuccessPlusFl = "success_plus_fl",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "direct_debit_payment" */
export type Direct_Debit_Payment_Set_Input = {
  bacs_processing_date?: InputMaybe<Scalars["timestamp"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  direct_debit_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  success_plus_fl?: InputMaybe<Scalars["Boolean"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Direct_Debit_Payment_Stddev_Fields = {
  __typename?: "direct_debit_payment_stddev_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  direct_debit_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Direct_Debit_Payment_Stddev_Pop_Fields = {
  __typename?: "direct_debit_payment_stddev_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  direct_debit_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Direct_Debit_Payment_Stddev_Samp_Fields = {
  __typename?: "direct_debit_payment_stddev_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  direct_debit_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "direct_debit_payment" */
export type Direct_Debit_Payment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Direct_Debit_Payment_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Direct_Debit_Payment_Stream_Cursor_Value_Input = {
  bacs_processing_date?: InputMaybe<Scalars["timestamp"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  direct_debit_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  success_plus_fl?: InputMaybe<Scalars["Boolean"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Direct_Debit_Payment_Sum_Fields = {
  __typename?: "direct_debit_payment_sum_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  direct_debit_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "direct_debit_payment" */
export enum Direct_Debit_Payment_Update_Column {
  /** column name */
  BacsProcessingDate = "bacs_processing_date",
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  DirectDebitId = "direct_debit_id",
  /** column name */
  Id = "id",
  /** column name */
  SuccessPlusFl = "success_plus_fl",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Direct_Debit_Payment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Direct_Debit_Payment_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Direct_Debit_Payment_Set_Input>
  /** filter the rows which have to be updated */
  where: Direct_Debit_Payment_Bool_Exp
}

/** aggregate var_pop on columns */
export type Direct_Debit_Payment_Var_Pop_Fields = {
  __typename?: "direct_debit_payment_var_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  direct_debit_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Direct_Debit_Payment_Var_Samp_Fields = {
  __typename?: "direct_debit_payment_var_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  direct_debit_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Direct_Debit_Payment_Variance_Fields = {
  __typename?: "direct_debit_payment_variance_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  direct_debit_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** primary key columns input for table: direct_debit */
export type Direct_Debit_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "direct_debit" */
export enum Direct_Debit_Select_Column {
  /** column name */
  AccountNumberMasked = "account_number_masked",
  /** column name */
  AuthRequestAt = "auth_request_at",
  /** column name */
  AuthorizedAt = "authorized_at",
  /** column name */
  BankReference = "bank_reference",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  MandateReference = "mandate_reference",
  /** column name */
  SortCodeMasked = "sort_code_masked",
  /** column name */
  Status = "status",
  /** column name */
  TerminatedAt = "terminated_at",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "direct_debit" */
export type Direct_Debit_Set_Input = {
  account_number_masked?: InputMaybe<Scalars["String"]["input"]>
  auth_request_at?: InputMaybe<Scalars["timestamp"]["input"]>
  authorized_at?: InputMaybe<Scalars["timestamp"]["input"]>
  bank_reference?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  mandate_reference?: InputMaybe<Scalars["String"]["input"]>
  sort_code_masked?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["direct_debit_status"]["input"]>
  terminated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** Boolean expression to compare columns of type "direct_debit_status". All fields are combined with logical 'AND'. */
export type Direct_Debit_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["direct_debit_status"]["input"]>
  _gt?: InputMaybe<Scalars["direct_debit_status"]["input"]>
  _gte?: InputMaybe<Scalars["direct_debit_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["direct_debit_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["direct_debit_status"]["input"]>
  _lte?: InputMaybe<Scalars["direct_debit_status"]["input"]>
  _neq?: InputMaybe<Scalars["direct_debit_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["direct_debit_status"]["input"]>>
}

/** aggregate stddev on columns */
export type Direct_Debit_Stddev_Fields = {
  __typename?: "direct_debit_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Direct_Debit_Stddev_Pop_Fields = {
  __typename?: "direct_debit_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Direct_Debit_Stddev_Samp_Fields = {
  __typename?: "direct_debit_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "direct_debit" */
export type Direct_Debit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Direct_Debit_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Direct_Debit_Stream_Cursor_Value_Input = {
  account_number_masked?: InputMaybe<Scalars["String"]["input"]>
  auth_request_at?: InputMaybe<Scalars["timestamp"]["input"]>
  authorized_at?: InputMaybe<Scalars["timestamp"]["input"]>
  bank_reference?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  mandate_reference?: InputMaybe<Scalars["String"]["input"]>
  sort_code_masked?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["direct_debit_status"]["input"]>
  terminated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Direct_Debit_Sum_Fields = {
  __typename?: "direct_debit_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "direct_debit" */
export enum Direct_Debit_Update_Column {
  /** column name */
  AccountNumberMasked = "account_number_masked",
  /** column name */
  AuthRequestAt = "auth_request_at",
  /** column name */
  AuthorizedAt = "authorized_at",
  /** column name */
  BankReference = "bank_reference",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  MandateReference = "mandate_reference",
  /** column name */
  SortCodeMasked = "sort_code_masked",
  /** column name */
  Status = "status",
  /** column name */
  TerminatedAt = "terminated_at",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Direct_Debit_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Direct_Debit_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Direct_Debit_Set_Input>
  /** filter the rows which have to be updated */
  where: Direct_Debit_Bool_Exp
}

/** aggregate var_pop on columns */
export type Direct_Debit_Var_Pop_Fields = {
  __typename?: "direct_debit_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Direct_Debit_Var_Samp_Fields = {
  __typename?: "direct_debit_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Direct_Debit_Variance_Fields = {
  __typename?: "direct_debit_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "dunning_addacs_review_status". All fields are combined with logical 'AND'. */
export type Dunning_Addacs_Review_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["dunning_addacs_review_status"]["input"]>
  _gt?: InputMaybe<Scalars["dunning_addacs_review_status"]["input"]>
  _gte?: InputMaybe<Scalars["dunning_addacs_review_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["dunning_addacs_review_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["dunning_addacs_review_status"]["input"]>
  _lte?: InputMaybe<Scalars["dunning_addacs_review_status"]["input"]>
  _neq?: InputMaybe<Scalars["dunning_addacs_review_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["dunning_addacs_review_status"]["input"]>>
}

/** Boolean expression to compare columns of type "dunning_automation_events_status". All fields are combined with logical 'AND'. */
export type Dunning_Automation_Events_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["dunning_automation_events_status"]["input"]>
  _gt?: InputMaybe<Scalars["dunning_automation_events_status"]["input"]>
  _gte?: InputMaybe<Scalars["dunning_automation_events_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["dunning_automation_events_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["dunning_automation_events_status"]["input"]>
  _lte?: InputMaybe<Scalars["dunning_automation_events_status"]["input"]>
  _neq?: InputMaybe<Scalars["dunning_automation_events_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["dunning_automation_events_status"]["input"]>>
}

/** Boolean expression to compare columns of type "dunning_debt_ticket_review_status". All fields are combined with logical 'AND'. */
export type Dunning_Debt_Ticket_Review_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["dunning_debt_ticket_review_status"]["input"]>
  _gt?: InputMaybe<Scalars["dunning_debt_ticket_review_status"]["input"]>
  _gte?: InputMaybe<Scalars["dunning_debt_ticket_review_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["dunning_debt_ticket_review_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["dunning_debt_ticket_review_status"]["input"]>
  _lte?: InputMaybe<Scalars["dunning_debt_ticket_review_status"]["input"]>
  _neq?: InputMaybe<Scalars["dunning_debt_ticket_review_status"]["input"]>
  _nin?: InputMaybe<
    Array<Scalars["dunning_debt_ticket_review_status"]["input"]>
  >
}

/** Boolean expression to compare columns of type "dunning_job_email_status". All fields are combined with logical 'AND'. */
export type Dunning_Job_Email_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["dunning_job_email_status"]["input"]>
  _gt?: InputMaybe<Scalars["dunning_job_email_status"]["input"]>
  _gte?: InputMaybe<Scalars["dunning_job_email_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["dunning_job_email_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["dunning_job_email_status"]["input"]>
  _lte?: InputMaybe<Scalars["dunning_job_email_status"]["input"]>
  _neq?: InputMaybe<Scalars["dunning_job_email_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["dunning_job_email_status"]["input"]>>
}

/** Boolean expression to compare columns of type "dunning_job_statistic_type". All fields are combined with logical 'AND'. */
export type Dunning_Job_Statistic_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["dunning_job_statistic_type"]["input"]>
  _gt?: InputMaybe<Scalars["dunning_job_statistic_type"]["input"]>
  _gte?: InputMaybe<Scalars["dunning_job_statistic_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["dunning_job_statistic_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["dunning_job_statistic_type"]["input"]>
  _lte?: InputMaybe<Scalars["dunning_job_statistic_type"]["input"]>
  _neq?: InputMaybe<Scalars["dunning_job_statistic_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["dunning_job_statistic_type"]["input"]>>
}

/** Boolean expression to compare columns of type "dunning_legal_known_review_status". All fields are combined with logical 'AND'. */
export type Dunning_Legal_Known_Review_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["dunning_legal_known_review_status"]["input"]>
  _gt?: InputMaybe<Scalars["dunning_legal_known_review_status"]["input"]>
  _gte?: InputMaybe<Scalars["dunning_legal_known_review_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["dunning_legal_known_review_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["dunning_legal_known_review_status"]["input"]>
  _lte?: InputMaybe<Scalars["dunning_legal_known_review_status"]["input"]>
  _neq?: InputMaybe<Scalars["dunning_legal_known_review_status"]["input"]>
  _nin?: InputMaybe<
    Array<Scalars["dunning_legal_known_review_status"]["input"]>
  >
}

/** Boolean expression to compare columns of type "dunning_legal_occupier_review_status". All fields are combined with logical 'AND'. */
export type Dunning_Legal_Occupier_Review_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["dunning_legal_occupier_review_status"]["input"]>
  _gt?: InputMaybe<Scalars["dunning_legal_occupier_review_status"]["input"]>
  _gte?: InputMaybe<Scalars["dunning_legal_occupier_review_status"]["input"]>
  _in?: InputMaybe<
    Array<Scalars["dunning_legal_occupier_review_status"]["input"]>
  >
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["dunning_legal_occupier_review_status"]["input"]>
  _lte?: InputMaybe<Scalars["dunning_legal_occupier_review_status"]["input"]>
  _neq?: InputMaybe<Scalars["dunning_legal_occupier_review_status"]["input"]>
  _nin?: InputMaybe<
    Array<Scalars["dunning_legal_occupier_review_status"]["input"]>
  >
}

/** Boolean expression to compare columns of type "dunning_occupier_accounts_review_status". All fields are combined with logical 'AND'. */
export type Dunning_Occupier_Accounts_Review_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["dunning_occupier_accounts_review_status"]["input"]>
  _gt?: InputMaybe<Scalars["dunning_occupier_accounts_review_status"]["input"]>
  _gte?: InputMaybe<Scalars["dunning_occupier_accounts_review_status"]["input"]>
  _in?: InputMaybe<
    Array<Scalars["dunning_occupier_accounts_review_status"]["input"]>
  >
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["dunning_occupier_accounts_review_status"]["input"]>
  _lte?: InputMaybe<Scalars["dunning_occupier_accounts_review_status"]["input"]>
  _neq?: InputMaybe<Scalars["dunning_occupier_accounts_review_status"]["input"]>
  _nin?: InputMaybe<
    Array<Scalars["dunning_occupier_accounts_review_status"]["input"]>
  >
}

/** Boolean expression to compare columns of type "dunning_purge_status_enum". All fields are combined with logical 'AND'. */
export type Dunning_Purge_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["dunning_purge_status_enum"]["input"]>
  _gt?: InputMaybe<Scalars["dunning_purge_status_enum"]["input"]>
  _gte?: InputMaybe<Scalars["dunning_purge_status_enum"]["input"]>
  _in?: InputMaybe<Array<Scalars["dunning_purge_status_enum"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["dunning_purge_status_enum"]["input"]>
  _lte?: InputMaybe<Scalars["dunning_purge_status_enum"]["input"]>
  _neq?: InputMaybe<Scalars["dunning_purge_status_enum"]["input"]>
  _nin?: InputMaybe<Array<Scalars["dunning_purge_status_enum"]["input"]>>
}

/** Boolean expression to compare columns of type "dunning_standard_review_status". All fields are combined with logical 'AND'. */
export type Dunning_Standard_Review_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["dunning_standard_review_status"]["input"]>
  _gt?: InputMaybe<Scalars["dunning_standard_review_status"]["input"]>
  _gte?: InputMaybe<Scalars["dunning_standard_review_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["dunning_standard_review_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["dunning_standard_review_status"]["input"]>
  _lte?: InputMaybe<Scalars["dunning_standard_review_status"]["input"]>
  _neq?: InputMaybe<Scalars["dunning_standard_review_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["dunning_standard_review_status"]["input"]>>
}

/** Boolean expression to compare columns of type "dunning_status_enum". All fields are combined with logical 'AND'. */
export type Dunning_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["dunning_status_enum"]["input"]>
  _gt?: InputMaybe<Scalars["dunning_status_enum"]["input"]>
  _gte?: InputMaybe<Scalars["dunning_status_enum"]["input"]>
  _in?: InputMaybe<Array<Scalars["dunning_status_enum"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["dunning_status_enum"]["input"]>
  _lte?: InputMaybe<Scalars["dunning_status_enum"]["input"]>
  _neq?: InputMaybe<Scalars["dunning_status_enum"]["input"]>
  _nin?: InputMaybe<Array<Scalars["dunning_status_enum"]["input"]>>
}

/** Boolean expression to compare columns of type "dunning_terminating_accounts_review_status". All fields are combined with logical 'AND'. */
export type Dunning_Terminating_Accounts_Review_Status_Comparison_Exp = {
  _eq?: InputMaybe<
    Scalars["dunning_terminating_accounts_review_status"]["input"]
  >
  _gt?: InputMaybe<
    Scalars["dunning_terminating_accounts_review_status"]["input"]
  >
  _gte?: InputMaybe<
    Scalars["dunning_terminating_accounts_review_status"]["input"]
  >
  _in?: InputMaybe<
    Array<Scalars["dunning_terminating_accounts_review_status"]["input"]>
  >
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<
    Scalars["dunning_terminating_accounts_review_status"]["input"]
  >
  _lte?: InputMaybe<
    Scalars["dunning_terminating_accounts_review_status"]["input"]
  >
  _neq?: InputMaybe<
    Scalars["dunning_terminating_accounts_review_status"]["input"]
  >
  _nin?: InputMaybe<
    Array<Scalars["dunning_terminating_accounts_review_status"]["input"]>
  >
}

/** Boolean expression to compare columns of type "dunning_workflow_type_enum". All fields are combined with logical 'AND'. */
export type Dunning_Workflow_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["dunning_workflow_type_enum"]["input"]>
  _gt?: InputMaybe<Scalars["dunning_workflow_type_enum"]["input"]>
  _gte?: InputMaybe<Scalars["dunning_workflow_type_enum"]["input"]>
  _in?: InputMaybe<Array<Scalars["dunning_workflow_type_enum"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["dunning_workflow_type_enum"]["input"]>
  _lte?: InputMaybe<Scalars["dunning_workflow_type_enum"]["input"]>
  _neq?: InputMaybe<Scalars["dunning_workflow_type_enum"]["input"]>
  _nin?: InputMaybe<Array<Scalars["dunning_workflow_type_enum"]["input"]>>
}

/** columns and relationships of "email_messages" */
export type Email_Messages = {
  __typename?: "email_messages"
  email_provider_id?: Maybe<Scalars["String"]["output"]>
  failure_message?: Maybe<Scalars["String"]["output"]>
  html_content?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  last_attempted_at?: Maybe<Scalars["timestamptz"]["output"]>
  opened: Scalars["Boolean"]["output"]
  parameters_json: Scalars["json"]["output"]
  plain_content?: Maybe<Scalars["String"]["output"]>
  processed_at?: Maybe<Scalars["timestamptz"]["output"]>
  /** An object relationship */
  recipient?: Maybe<Recipients>
  recipient_id?: Maybe<Scalars["bigint"]["output"]>
  /** An object relationship */
  request: Requests
  request_id: Scalars["bigint"]["output"]
  retry_count: Scalars["Int"]["output"]
  sender_id?: Maybe<Scalars["bigint"]["output"]>
  status: Scalars["String"]["output"]
  subject?: Maybe<Scalars["String"]["output"]>
}

/** columns and relationships of "email_messages" */
export type Email_MessagesParameters_JsonArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregated selection of "email_messages" */
export type Email_Messages_Aggregate = {
  __typename?: "email_messages_aggregate"
  aggregate?: Maybe<Email_Messages_Aggregate_Fields>
  nodes: Array<Email_Messages>
}

/** aggregate fields of "email_messages" */
export type Email_Messages_Aggregate_Fields = {
  __typename?: "email_messages_aggregate_fields"
  avg?: Maybe<Email_Messages_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Email_Messages_Max_Fields>
  min?: Maybe<Email_Messages_Min_Fields>
  stddev?: Maybe<Email_Messages_Stddev_Fields>
  stddev_pop?: Maybe<Email_Messages_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Email_Messages_Stddev_Samp_Fields>
  sum?: Maybe<Email_Messages_Sum_Fields>
  var_pop?: Maybe<Email_Messages_Var_Pop_Fields>
  var_samp?: Maybe<Email_Messages_Var_Samp_Fields>
  variance?: Maybe<Email_Messages_Variance_Fields>
}

/** aggregate fields of "email_messages" */
export type Email_Messages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Messages_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Email_Messages_Avg_Fields = {
  __typename?: "email_messages_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  recipient_id?: Maybe<Scalars["Float"]["output"]>
  request_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
  sender_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "email_messages". All fields are combined with a logical 'AND'. */
export type Email_Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Messages_Bool_Exp>>
  _not?: InputMaybe<Email_Messages_Bool_Exp>
  _or?: InputMaybe<Array<Email_Messages_Bool_Exp>>
  email_provider_id?: InputMaybe<String_Comparison_Exp>
  failure_message?: InputMaybe<String_Comparison_Exp>
  html_content?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  last_attempted_at?: InputMaybe<Timestamptz_Comparison_Exp>
  opened?: InputMaybe<Boolean_Comparison_Exp>
  parameters_json?: InputMaybe<Json_Comparison_Exp>
  plain_content?: InputMaybe<String_Comparison_Exp>
  processed_at?: InputMaybe<Timestamptz_Comparison_Exp>
  recipient?: InputMaybe<Recipients_Bool_Exp>
  recipient_id?: InputMaybe<Bigint_Comparison_Exp>
  request?: InputMaybe<Requests_Bool_Exp>
  request_id?: InputMaybe<Bigint_Comparison_Exp>
  retry_count?: InputMaybe<Int_Comparison_Exp>
  sender_id?: InputMaybe<Bigint_Comparison_Exp>
  status?: InputMaybe<String_Comparison_Exp>
  subject?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "email_messages" */
export enum Email_Messages_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkEmailMessages = "pk_email_messages",
  /** unique or primary key constraint on columns "recipient_id" */
  UqEmailMessagesRecipientId = "uq_email_messages_recipient_id",
  /** unique or primary key constraint on columns "request_id" */
  UqEmailMessagesRequestId = "uq_email_messages_request_id",
}

/** input type for incrementing numeric columns in table "email_messages" */
export type Email_Messages_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  recipient_id?: InputMaybe<Scalars["bigint"]["input"]>
  request_id?: InputMaybe<Scalars["bigint"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  sender_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "email_messages" */
export type Email_Messages_Insert_Input = {
  email_provider_id?: InputMaybe<Scalars["String"]["input"]>
  failure_message?: InputMaybe<Scalars["String"]["input"]>
  html_content?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_attempted_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  opened?: InputMaybe<Scalars["Boolean"]["input"]>
  parameters_json?: InputMaybe<Scalars["json"]["input"]>
  plain_content?: InputMaybe<Scalars["String"]["input"]>
  processed_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  recipient?: InputMaybe<Recipients_Obj_Rel_Insert_Input>
  recipient_id?: InputMaybe<Scalars["bigint"]["input"]>
  request?: InputMaybe<Requests_Obj_Rel_Insert_Input>
  request_id?: InputMaybe<Scalars["bigint"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  sender_id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  subject?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Email_Messages_Max_Fields = {
  __typename?: "email_messages_max_fields"
  email_provider_id?: Maybe<Scalars["String"]["output"]>
  failure_message?: Maybe<Scalars["String"]["output"]>
  html_content?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_attempted_at?: Maybe<Scalars["timestamptz"]["output"]>
  plain_content?: Maybe<Scalars["String"]["output"]>
  processed_at?: Maybe<Scalars["timestamptz"]["output"]>
  recipient_id?: Maybe<Scalars["bigint"]["output"]>
  request_id?: Maybe<Scalars["bigint"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
  sender_id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  subject?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Email_Messages_Min_Fields = {
  __typename?: "email_messages_min_fields"
  email_provider_id?: Maybe<Scalars["String"]["output"]>
  failure_message?: Maybe<Scalars["String"]["output"]>
  html_content?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_attempted_at?: Maybe<Scalars["timestamptz"]["output"]>
  plain_content?: Maybe<Scalars["String"]["output"]>
  processed_at?: Maybe<Scalars["timestamptz"]["output"]>
  recipient_id?: Maybe<Scalars["bigint"]["output"]>
  request_id?: Maybe<Scalars["bigint"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
  sender_id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  subject?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "email_messages" */
export type Email_Messages_Mutation_Response = {
  __typename?: "email_messages_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Email_Messages>
}

/** input type for inserting object relation for remote table "email_messages" */
export type Email_Messages_Obj_Rel_Insert_Input = {
  data: Email_Messages_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Email_Messages_On_Conflict>
}

/** on_conflict condition type for table "email_messages" */
export type Email_Messages_On_Conflict = {
  constraint: Email_Messages_Constraint
  update_columns?: Array<Email_Messages_Update_Column>
  where?: InputMaybe<Email_Messages_Bool_Exp>
}

/** Ordering options when selecting data from "email_messages". */
export type Email_Messages_Order_By = {
  email_provider_id?: InputMaybe<Order_By>
  failure_message?: InputMaybe<Order_By>
  html_content?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  last_attempted_at?: InputMaybe<Order_By>
  opened?: InputMaybe<Order_By>
  parameters_json?: InputMaybe<Order_By>
  plain_content?: InputMaybe<Order_By>
  processed_at?: InputMaybe<Order_By>
  recipient?: InputMaybe<Recipients_Order_By>
  recipient_id?: InputMaybe<Order_By>
  request?: InputMaybe<Requests_Order_By>
  request_id?: InputMaybe<Order_By>
  retry_count?: InputMaybe<Order_By>
  sender_id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  subject?: InputMaybe<Order_By>
}

/** primary key columns input for table: email_messages */
export type Email_Messages_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "email_messages" */
export enum Email_Messages_Select_Column {
  /** column name */
  EmailProviderId = "email_provider_id",
  /** column name */
  FailureMessage = "failure_message",
  /** column name */
  HtmlContent = "html_content",
  /** column name */
  Id = "id",
  /** column name */
  LastAttemptedAt = "last_attempted_at",
  /** column name */
  Opened = "opened",
  /** column name */
  ParametersJson = "parameters_json",
  /** column name */
  PlainContent = "plain_content",
  /** column name */
  ProcessedAt = "processed_at",
  /** column name */
  RecipientId = "recipient_id",
  /** column name */
  RequestId = "request_id",
  /** column name */
  RetryCount = "retry_count",
  /** column name */
  SenderId = "sender_id",
  /** column name */
  Status = "status",
  /** column name */
  Subject = "subject",
}

/** input type for updating data in table "email_messages" */
export type Email_Messages_Set_Input = {
  email_provider_id?: InputMaybe<Scalars["String"]["input"]>
  failure_message?: InputMaybe<Scalars["String"]["input"]>
  html_content?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_attempted_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  opened?: InputMaybe<Scalars["Boolean"]["input"]>
  parameters_json?: InputMaybe<Scalars["json"]["input"]>
  plain_content?: InputMaybe<Scalars["String"]["input"]>
  processed_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  recipient_id?: InputMaybe<Scalars["bigint"]["input"]>
  request_id?: InputMaybe<Scalars["bigint"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  sender_id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  subject?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Email_Messages_Stddev_Fields = {
  __typename?: "email_messages_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  recipient_id?: Maybe<Scalars["Float"]["output"]>
  request_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
  sender_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Email_Messages_Stddev_Pop_Fields = {
  __typename?: "email_messages_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  recipient_id?: Maybe<Scalars["Float"]["output"]>
  request_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
  sender_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Email_Messages_Stddev_Samp_Fields = {
  __typename?: "email_messages_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  recipient_id?: Maybe<Scalars["Float"]["output"]>
  request_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
  sender_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "email_messages" */
export type Email_Messages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Messages_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Email_Messages_Stream_Cursor_Value_Input = {
  email_provider_id?: InputMaybe<Scalars["String"]["input"]>
  failure_message?: InputMaybe<Scalars["String"]["input"]>
  html_content?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_attempted_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  opened?: InputMaybe<Scalars["Boolean"]["input"]>
  parameters_json?: InputMaybe<Scalars["json"]["input"]>
  plain_content?: InputMaybe<Scalars["String"]["input"]>
  processed_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  recipient_id?: InputMaybe<Scalars["bigint"]["input"]>
  request_id?: InputMaybe<Scalars["bigint"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  sender_id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  subject?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Email_Messages_Sum_Fields = {
  __typename?: "email_messages_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  recipient_id?: Maybe<Scalars["bigint"]["output"]>
  request_id?: Maybe<Scalars["bigint"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
  sender_id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "email_messages" */
export enum Email_Messages_Update_Column {
  /** column name */
  EmailProviderId = "email_provider_id",
  /** column name */
  FailureMessage = "failure_message",
  /** column name */
  HtmlContent = "html_content",
  /** column name */
  Id = "id",
  /** column name */
  LastAttemptedAt = "last_attempted_at",
  /** column name */
  Opened = "opened",
  /** column name */
  ParametersJson = "parameters_json",
  /** column name */
  PlainContent = "plain_content",
  /** column name */
  ProcessedAt = "processed_at",
  /** column name */
  RecipientId = "recipient_id",
  /** column name */
  RequestId = "request_id",
  /** column name */
  RetryCount = "retry_count",
  /** column name */
  SenderId = "sender_id",
  /** column name */
  Status = "status",
  /** column name */
  Subject = "subject",
}

export type Email_Messages_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Email_Messages_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Messages_Set_Input>
  /** filter the rows which have to be updated */
  where: Email_Messages_Bool_Exp
}

/** aggregate var_pop on columns */
export type Email_Messages_Var_Pop_Fields = {
  __typename?: "email_messages_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  recipient_id?: Maybe<Scalars["Float"]["output"]>
  request_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
  sender_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Email_Messages_Var_Samp_Fields = {
  __typename?: "email_messages_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  recipient_id?: Maybe<Scalars["Float"]["output"]>
  request_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
  sender_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Email_Messages_Variance_Fields = {
  __typename?: "email_messages_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  recipient_id?: Maybe<Scalars["Float"]["output"]>
  request_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
  sender_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "email_status_enum". All fields are combined with logical 'AND'. */
export type Email_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["email_status_enum"]["input"]>
  _gt?: InputMaybe<Scalars["email_status_enum"]["input"]>
  _gte?: InputMaybe<Scalars["email_status_enum"]["input"]>
  _in?: InputMaybe<Array<Scalars["email_status_enum"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["email_status_enum"]["input"]>
  _lte?: InputMaybe<Scalars["email_status_enum"]["input"]>
  _neq?: InputMaybe<Scalars["email_status_enum"]["input"]>
  _nin?: InputMaybe<Array<Scalars["email_status_enum"]["input"]>>
}

/** Boolean expression to compare columns of type "email_template_ext_sender". All fields are combined with logical 'AND'. */
export type Email_Template_Ext_Sender_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["email_template_ext_sender"]["input"]>
  _gt?: InputMaybe<Scalars["email_template_ext_sender"]["input"]>
  _gte?: InputMaybe<Scalars["email_template_ext_sender"]["input"]>
  _in?: InputMaybe<Array<Scalars["email_template_ext_sender"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["email_template_ext_sender"]["input"]>
  _lte?: InputMaybe<Scalars["email_template_ext_sender"]["input"]>
  _neq?: InputMaybe<Scalars["email_template_ext_sender"]["input"]>
  _nin?: InputMaybe<Array<Scalars["email_template_ext_sender"]["input"]>>
}

/** columns and relationships of "email_templates" */
export type Email_Templates = {
  __typename?: "email_templates"
  attachment_content?: Maybe<Scalars["String"]["output"]>
  attachment_filename?: Maybe<Scalars["String"]["output"]>
  /** An object relationship */
  communication: Communications
  communication_id: Scalars["bigint"]["output"]
  created_at: Scalars["timestamptz"]["output"]
  html_content: Scalars["String"]["output"]
  id: Scalars["bigint"]["output"]
  is_live: Scalars["Boolean"]["output"]
  modified_by?: Maybe<Scalars["String"]["output"]>
  modified_reason?: Maybe<Scalars["String"]["output"]>
  plain_content: Scalars["String"]["output"]
  published_at?: Maybe<Scalars["timestamptz"]["output"]>
  subject: Scalars["String"]["output"]
  version: Scalars["Int"]["output"]
}

/** aggregated selection of "email_templates" */
export type Email_Templates_Aggregate = {
  __typename?: "email_templates_aggregate"
  aggregate?: Maybe<Email_Templates_Aggregate_Fields>
  nodes: Array<Email_Templates>
}

/** aggregate fields of "email_templates" */
export type Email_Templates_Aggregate_Fields = {
  __typename?: "email_templates_aggregate_fields"
  avg?: Maybe<Email_Templates_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Email_Templates_Max_Fields>
  min?: Maybe<Email_Templates_Min_Fields>
  stddev?: Maybe<Email_Templates_Stddev_Fields>
  stddev_pop?: Maybe<Email_Templates_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Email_Templates_Stddev_Samp_Fields>
  sum?: Maybe<Email_Templates_Sum_Fields>
  var_pop?: Maybe<Email_Templates_Var_Pop_Fields>
  var_samp?: Maybe<Email_Templates_Var_Samp_Fields>
  variance?: Maybe<Email_Templates_Variance_Fields>
}

/** aggregate fields of "email_templates" */
export type Email_Templates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Templates_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Email_Templates_Avg_Fields = {
  __typename?: "email_templates_avg_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  version?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "email_templates". All fields are combined with a logical 'AND'. */
export type Email_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Templates_Bool_Exp>>
  _not?: InputMaybe<Email_Templates_Bool_Exp>
  _or?: InputMaybe<Array<Email_Templates_Bool_Exp>>
  attachment_content?: InputMaybe<String_Comparison_Exp>
  attachment_filename?: InputMaybe<String_Comparison_Exp>
  communication?: InputMaybe<Communications_Bool_Exp>
  communication_id?: InputMaybe<Bigint_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  html_content?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  is_live?: InputMaybe<Boolean_Comparison_Exp>
  modified_by?: InputMaybe<String_Comparison_Exp>
  modified_reason?: InputMaybe<String_Comparison_Exp>
  plain_content?: InputMaybe<String_Comparison_Exp>
  published_at?: InputMaybe<Timestamptz_Comparison_Exp>
  subject?: InputMaybe<String_Comparison_Exp>
  version?: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "email_templates" */
export enum Email_Templates_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkEmailTemplates = "pk_email_templates",
  /** unique or primary key constraint on columns "communication_id", "version" */
  UxEmailTemplatesCommunicationIdVersion = "ux_email_templates_communication_id_version",
}

/** columns and relationships of "email_templates_ext" */
export type Email_Templates_Ext = {
  __typename?: "email_templates_ext"
  body: Scalars["String"]["output"]
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  name: Scalars["String"]["output"]
  reply_to_address?: Maybe<Scalars["String"]["output"]>
  sender: Scalars["email_template_ext_sender"]["output"]
  subject: Scalars["String"]["output"]
  updated_at: Scalars["timestamp"]["output"]
  version: Scalars["Int"]["output"]
}

/** aggregated selection of "email_templates_ext" */
export type Email_Templates_Ext_Aggregate = {
  __typename?: "email_templates_ext_aggregate"
  aggregate?: Maybe<Email_Templates_Ext_Aggregate_Fields>
  nodes: Array<Email_Templates_Ext>
}

/** aggregate fields of "email_templates_ext" */
export type Email_Templates_Ext_Aggregate_Fields = {
  __typename?: "email_templates_ext_aggregate_fields"
  avg?: Maybe<Email_Templates_Ext_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Email_Templates_Ext_Max_Fields>
  min?: Maybe<Email_Templates_Ext_Min_Fields>
  stddev?: Maybe<Email_Templates_Ext_Stddev_Fields>
  stddev_pop?: Maybe<Email_Templates_Ext_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Email_Templates_Ext_Stddev_Samp_Fields>
  sum?: Maybe<Email_Templates_Ext_Sum_Fields>
  var_pop?: Maybe<Email_Templates_Ext_Var_Pop_Fields>
  var_samp?: Maybe<Email_Templates_Ext_Var_Samp_Fields>
  variance?: Maybe<Email_Templates_Ext_Variance_Fields>
}

/** aggregate fields of "email_templates_ext" */
export type Email_Templates_Ext_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Templates_Ext_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Email_Templates_Ext_Avg_Fields = {
  __typename?: "email_templates_ext_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  version?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "email_templates_ext". All fields are combined with a logical 'AND'. */
export type Email_Templates_Ext_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Templates_Ext_Bool_Exp>>
  _not?: InputMaybe<Email_Templates_Ext_Bool_Exp>
  _or?: InputMaybe<Array<Email_Templates_Ext_Bool_Exp>>
  body?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  reply_to_address?: InputMaybe<String_Comparison_Exp>
  sender?: InputMaybe<Email_Template_Ext_Sender_Comparison_Exp>
  subject?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  version?: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "email_templates_ext" */
export enum Email_Templates_Ext_Constraint {
  /** unique or primary key constraint on columns "id" */
  EmailTemplatesExtPkey = "email_templates_ext_pkey",
}

/** input type for incrementing numeric columns in table "email_templates_ext" */
export type Email_Templates_Ext_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  version?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "email_templates_ext" */
export type Email_Templates_Ext_Insert_Input = {
  body?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  reply_to_address?: InputMaybe<Scalars["String"]["input"]>
  sender?: InputMaybe<Scalars["email_template_ext_sender"]["input"]>
  subject?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  version?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate max on columns */
export type Email_Templates_Ext_Max_Fields = {
  __typename?: "email_templates_ext_max_fields"
  body?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  reply_to_address?: Maybe<Scalars["String"]["output"]>
  sender?: Maybe<Scalars["email_template_ext_sender"]["output"]>
  subject?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  version?: Maybe<Scalars["Int"]["output"]>
}

/** aggregate min on columns */
export type Email_Templates_Ext_Min_Fields = {
  __typename?: "email_templates_ext_min_fields"
  body?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  reply_to_address?: Maybe<Scalars["String"]["output"]>
  sender?: Maybe<Scalars["email_template_ext_sender"]["output"]>
  subject?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  version?: Maybe<Scalars["Int"]["output"]>
}

/** response of any mutation on the table "email_templates_ext" */
export type Email_Templates_Ext_Mutation_Response = {
  __typename?: "email_templates_ext_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Email_Templates_Ext>
}

/** on_conflict condition type for table "email_templates_ext" */
export type Email_Templates_Ext_On_Conflict = {
  constraint: Email_Templates_Ext_Constraint
  update_columns?: Array<Email_Templates_Ext_Update_Column>
  where?: InputMaybe<Email_Templates_Ext_Bool_Exp>
}

/** Ordering options when selecting data from "email_templates_ext". */
export type Email_Templates_Ext_Order_By = {
  body?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  reply_to_address?: InputMaybe<Order_By>
  sender?: InputMaybe<Order_By>
  subject?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  version?: InputMaybe<Order_By>
}

/** primary key columns input for table: email_templates_ext */
export type Email_Templates_Ext_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "email_templates_ext" */
export enum Email_Templates_Ext_Select_Column {
  /** column name */
  Body = "body",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  ReplyToAddress = "reply_to_address",
  /** column name */
  Sender = "sender",
  /** column name */
  Subject = "subject",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  Version = "version",
}

/** input type for updating data in table "email_templates_ext" */
export type Email_Templates_Ext_Set_Input = {
  body?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  reply_to_address?: InputMaybe<Scalars["String"]["input"]>
  sender?: InputMaybe<Scalars["email_template_ext_sender"]["input"]>
  subject?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  version?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate stddev on columns */
export type Email_Templates_Ext_Stddev_Fields = {
  __typename?: "email_templates_ext_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  version?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Email_Templates_Ext_Stddev_Pop_Fields = {
  __typename?: "email_templates_ext_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  version?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Email_Templates_Ext_Stddev_Samp_Fields = {
  __typename?: "email_templates_ext_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  version?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "email_templates_ext" */
export type Email_Templates_Ext_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Templates_Ext_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Email_Templates_Ext_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  reply_to_address?: InputMaybe<Scalars["String"]["input"]>
  sender?: InputMaybe<Scalars["email_template_ext_sender"]["input"]>
  subject?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  version?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate sum on columns */
export type Email_Templates_Ext_Sum_Fields = {
  __typename?: "email_templates_ext_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  version?: Maybe<Scalars["Int"]["output"]>
}

/** update columns of table "email_templates_ext" */
export enum Email_Templates_Ext_Update_Column {
  /** column name */
  Body = "body",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  ReplyToAddress = "reply_to_address",
  /** column name */
  Sender = "sender",
  /** column name */
  Subject = "subject",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  Version = "version",
}

export type Email_Templates_Ext_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Email_Templates_Ext_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Templates_Ext_Set_Input>
  /** filter the rows which have to be updated */
  where: Email_Templates_Ext_Bool_Exp
}

/** aggregate var_pop on columns */
export type Email_Templates_Ext_Var_Pop_Fields = {
  __typename?: "email_templates_ext_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  version?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Email_Templates_Ext_Var_Samp_Fields = {
  __typename?: "email_templates_ext_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  version?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Email_Templates_Ext_Variance_Fields = {
  __typename?: "email_templates_ext_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  version?: Maybe<Scalars["Float"]["output"]>
}

/** input type for incrementing numeric columns in table "email_templates" */
export type Email_Templates_Inc_Input = {
  communication_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  version?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "email_templates" */
export type Email_Templates_Insert_Input = {
  attachment_content?: InputMaybe<Scalars["String"]["input"]>
  attachment_filename?: InputMaybe<Scalars["String"]["input"]>
  communication?: InputMaybe<Communications_Obj_Rel_Insert_Input>
  communication_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  html_content?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  is_live?: InputMaybe<Scalars["Boolean"]["input"]>
  modified_by?: InputMaybe<Scalars["String"]["input"]>
  modified_reason?: InputMaybe<Scalars["String"]["input"]>
  plain_content?: InputMaybe<Scalars["String"]["input"]>
  published_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  subject?: InputMaybe<Scalars["String"]["input"]>
  version?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate max on columns */
export type Email_Templates_Max_Fields = {
  __typename?: "email_templates_max_fields"
  attachment_content?: Maybe<Scalars["String"]["output"]>
  attachment_filename?: Maybe<Scalars["String"]["output"]>
  communication_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  html_content?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  modified_by?: Maybe<Scalars["String"]["output"]>
  modified_reason?: Maybe<Scalars["String"]["output"]>
  plain_content?: Maybe<Scalars["String"]["output"]>
  published_at?: Maybe<Scalars["timestamptz"]["output"]>
  subject?: Maybe<Scalars["String"]["output"]>
  version?: Maybe<Scalars["Int"]["output"]>
}

/** aggregate min on columns */
export type Email_Templates_Min_Fields = {
  __typename?: "email_templates_min_fields"
  attachment_content?: Maybe<Scalars["String"]["output"]>
  attachment_filename?: Maybe<Scalars["String"]["output"]>
  communication_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  html_content?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  modified_by?: Maybe<Scalars["String"]["output"]>
  modified_reason?: Maybe<Scalars["String"]["output"]>
  plain_content?: Maybe<Scalars["String"]["output"]>
  published_at?: Maybe<Scalars["timestamptz"]["output"]>
  subject?: Maybe<Scalars["String"]["output"]>
  version?: Maybe<Scalars["Int"]["output"]>
}

/** response of any mutation on the table "email_templates" */
export type Email_Templates_Mutation_Response = {
  __typename?: "email_templates_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Email_Templates>
}

/** on_conflict condition type for table "email_templates" */
export type Email_Templates_On_Conflict = {
  constraint: Email_Templates_Constraint
  update_columns?: Array<Email_Templates_Update_Column>
  where?: InputMaybe<Email_Templates_Bool_Exp>
}

/** Ordering options when selecting data from "email_templates". */
export type Email_Templates_Order_By = {
  attachment_content?: InputMaybe<Order_By>
  attachment_filename?: InputMaybe<Order_By>
  communication?: InputMaybe<Communications_Order_By>
  communication_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  html_content?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  is_live?: InputMaybe<Order_By>
  modified_by?: InputMaybe<Order_By>
  modified_reason?: InputMaybe<Order_By>
  plain_content?: InputMaybe<Order_By>
  published_at?: InputMaybe<Order_By>
  subject?: InputMaybe<Order_By>
  version?: InputMaybe<Order_By>
}

/** primary key columns input for table: email_templates */
export type Email_Templates_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "email_templates" */
export enum Email_Templates_Select_Column {
  /** column name */
  AttachmentContent = "attachment_content",
  /** column name */
  AttachmentFilename = "attachment_filename",
  /** column name */
  CommunicationId = "communication_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  HtmlContent = "html_content",
  /** column name */
  Id = "id",
  /** column name */
  IsLive = "is_live",
  /** column name */
  ModifiedBy = "modified_by",
  /** column name */
  ModifiedReason = "modified_reason",
  /** column name */
  PlainContent = "plain_content",
  /** column name */
  PublishedAt = "published_at",
  /** column name */
  Subject = "subject",
  /** column name */
  Version = "version",
}

/** input type for updating data in table "email_templates" */
export type Email_Templates_Set_Input = {
  attachment_content?: InputMaybe<Scalars["String"]["input"]>
  attachment_filename?: InputMaybe<Scalars["String"]["input"]>
  communication_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  html_content?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  is_live?: InputMaybe<Scalars["Boolean"]["input"]>
  modified_by?: InputMaybe<Scalars["String"]["input"]>
  modified_reason?: InputMaybe<Scalars["String"]["input"]>
  plain_content?: InputMaybe<Scalars["String"]["input"]>
  published_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  subject?: InputMaybe<Scalars["String"]["input"]>
  version?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate stddev on columns */
export type Email_Templates_Stddev_Fields = {
  __typename?: "email_templates_stddev_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  version?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Email_Templates_Stddev_Pop_Fields = {
  __typename?: "email_templates_stddev_pop_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  version?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Email_Templates_Stddev_Samp_Fields = {
  __typename?: "email_templates_stddev_samp_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  version?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "email_templates" */
export type Email_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Templates_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Email_Templates_Stream_Cursor_Value_Input = {
  attachment_content?: InputMaybe<Scalars["String"]["input"]>
  attachment_filename?: InputMaybe<Scalars["String"]["input"]>
  communication_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  html_content?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  is_live?: InputMaybe<Scalars["Boolean"]["input"]>
  modified_by?: InputMaybe<Scalars["String"]["input"]>
  modified_reason?: InputMaybe<Scalars["String"]["input"]>
  plain_content?: InputMaybe<Scalars["String"]["input"]>
  published_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  subject?: InputMaybe<Scalars["String"]["input"]>
  version?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate sum on columns */
export type Email_Templates_Sum_Fields = {
  __typename?: "email_templates_sum_fields"
  communication_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  version?: Maybe<Scalars["Int"]["output"]>
}

/** update columns of table "email_templates" */
export enum Email_Templates_Update_Column {
  /** column name */
  AttachmentContent = "attachment_content",
  /** column name */
  AttachmentFilename = "attachment_filename",
  /** column name */
  CommunicationId = "communication_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  HtmlContent = "html_content",
  /** column name */
  Id = "id",
  /** column name */
  IsLive = "is_live",
  /** column name */
  ModifiedBy = "modified_by",
  /** column name */
  ModifiedReason = "modified_reason",
  /** column name */
  PlainContent = "plain_content",
  /** column name */
  PublishedAt = "published_at",
  /** column name */
  Subject = "subject",
  /** column name */
  Version = "version",
}

export type Email_Templates_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Email_Templates_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Templates_Set_Input>
  /** filter the rows which have to be updated */
  where: Email_Templates_Bool_Exp
}

/** aggregate var_pop on columns */
export type Email_Templates_Var_Pop_Fields = {
  __typename?: "email_templates_var_pop_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  version?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Email_Templates_Var_Samp_Fields = {
  __typename?: "email_templates_var_samp_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  version?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Email_Templates_Variance_Fields = {
  __typename?: "email_templates_variance_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  version?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "energy_source_type". All fields are combined with logical 'AND'. */
export type Energy_Source_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["energy_source_type"]["input"]>
  _gt?: InputMaybe<Scalars["energy_source_type"]["input"]>
  _gte?: InputMaybe<Scalars["energy_source_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["energy_source_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["energy_source_type"]["input"]>
  _lte?: InputMaybe<Scalars["energy_source_type"]["input"]>
  _neq?: InputMaybe<Scalars["energy_source_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["energy_source_type"]["input"]>>
}

/** columns and relationships of "energy_usage_load_factors" */
export type Energy_Usage_Load_Factors = {
  __typename?: "energy_usage_load_factors"
  created_at: Scalars["timestamp"]["output"]
  date: Scalars["date"]["output"]
  day: Scalars["Int"]["output"]
  electricity_r1: Scalars["numeric"]["output"]
  electricity_r2_day: Scalars["numeric"]["output"]
  electricity_r2_night: Scalars["numeric"]["output"]
  gas: Scalars["numeric"]["output"]
  id: Scalars["bigint"]["output"]
  month: Scalars["Int"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "energy_usage_load_factors" */
export type Energy_Usage_Load_Factors_Aggregate = {
  __typename?: "energy_usage_load_factors_aggregate"
  aggregate?: Maybe<Energy_Usage_Load_Factors_Aggregate_Fields>
  nodes: Array<Energy_Usage_Load_Factors>
}

/** aggregate fields of "energy_usage_load_factors" */
export type Energy_Usage_Load_Factors_Aggregate_Fields = {
  __typename?: "energy_usage_load_factors_aggregate_fields"
  avg?: Maybe<Energy_Usage_Load_Factors_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Energy_Usage_Load_Factors_Max_Fields>
  min?: Maybe<Energy_Usage_Load_Factors_Min_Fields>
  stddev?: Maybe<Energy_Usage_Load_Factors_Stddev_Fields>
  stddev_pop?: Maybe<Energy_Usage_Load_Factors_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Energy_Usage_Load_Factors_Stddev_Samp_Fields>
  sum?: Maybe<Energy_Usage_Load_Factors_Sum_Fields>
  var_pop?: Maybe<Energy_Usage_Load_Factors_Var_Pop_Fields>
  var_samp?: Maybe<Energy_Usage_Load_Factors_Var_Samp_Fields>
  variance?: Maybe<Energy_Usage_Load_Factors_Variance_Fields>
}

/** aggregate fields of "energy_usage_load_factors" */
export type Energy_Usage_Load_Factors_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Energy_Usage_Load_Factors_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Energy_Usage_Load_Factors_Avg_Fields = {
  __typename?: "energy_usage_load_factors_avg_fields"
  day?: Maybe<Scalars["Float"]["output"]>
  electricity_r1?: Maybe<Scalars["Float"]["output"]>
  electricity_r2_day?: Maybe<Scalars["Float"]["output"]>
  electricity_r2_night?: Maybe<Scalars["Float"]["output"]>
  gas?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  month?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "energy_usage_load_factors". All fields are combined with a logical 'AND'. */
export type Energy_Usage_Load_Factors_Bool_Exp = {
  _and?: InputMaybe<Array<Energy_Usage_Load_Factors_Bool_Exp>>
  _not?: InputMaybe<Energy_Usage_Load_Factors_Bool_Exp>
  _or?: InputMaybe<Array<Energy_Usage_Load_Factors_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  date?: InputMaybe<Date_Comparison_Exp>
  day?: InputMaybe<Int_Comparison_Exp>
  electricity_r1?: InputMaybe<Numeric_Comparison_Exp>
  electricity_r2_day?: InputMaybe<Numeric_Comparison_Exp>
  electricity_r2_night?: InputMaybe<Numeric_Comparison_Exp>
  gas?: InputMaybe<Numeric_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  month?: InputMaybe<Int_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "energy_usage_load_factors" */
export enum Energy_Usage_Load_Factors_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkEnergyUsageLoadFactors = "pk_energy_usage_load_factors",
}

/** input type for incrementing numeric columns in table "energy_usage_load_factors" */
export type Energy_Usage_Load_Factors_Inc_Input = {
  day?: InputMaybe<Scalars["Int"]["input"]>
  electricity_r1?: InputMaybe<Scalars["numeric"]["input"]>
  electricity_r2_day?: InputMaybe<Scalars["numeric"]["input"]>
  electricity_r2_night?: InputMaybe<Scalars["numeric"]["input"]>
  gas?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  month?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "energy_usage_load_factors" */
export type Energy_Usage_Load_Factors_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  date?: InputMaybe<Scalars["date"]["input"]>
  day?: InputMaybe<Scalars["Int"]["input"]>
  electricity_r1?: InputMaybe<Scalars["numeric"]["input"]>
  electricity_r2_day?: InputMaybe<Scalars["numeric"]["input"]>
  electricity_r2_night?: InputMaybe<Scalars["numeric"]["input"]>
  gas?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  month?: InputMaybe<Scalars["Int"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Energy_Usage_Load_Factors_Max_Fields = {
  __typename?: "energy_usage_load_factors_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  date?: Maybe<Scalars["date"]["output"]>
  day?: Maybe<Scalars["Int"]["output"]>
  electricity_r1?: Maybe<Scalars["numeric"]["output"]>
  electricity_r2_day?: Maybe<Scalars["numeric"]["output"]>
  electricity_r2_night?: Maybe<Scalars["numeric"]["output"]>
  gas?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  month?: Maybe<Scalars["Int"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Energy_Usage_Load_Factors_Min_Fields = {
  __typename?: "energy_usage_load_factors_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  date?: Maybe<Scalars["date"]["output"]>
  day?: Maybe<Scalars["Int"]["output"]>
  electricity_r1?: Maybe<Scalars["numeric"]["output"]>
  electricity_r2_day?: Maybe<Scalars["numeric"]["output"]>
  electricity_r2_night?: Maybe<Scalars["numeric"]["output"]>
  gas?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  month?: Maybe<Scalars["Int"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "energy_usage_load_factors" */
export type Energy_Usage_Load_Factors_Mutation_Response = {
  __typename?: "energy_usage_load_factors_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Energy_Usage_Load_Factors>
}

/** on_conflict condition type for table "energy_usage_load_factors" */
export type Energy_Usage_Load_Factors_On_Conflict = {
  constraint: Energy_Usage_Load_Factors_Constraint
  update_columns?: Array<Energy_Usage_Load_Factors_Update_Column>
  where?: InputMaybe<Energy_Usage_Load_Factors_Bool_Exp>
}

/** Ordering options when selecting data from "energy_usage_load_factors". */
export type Energy_Usage_Load_Factors_Order_By = {
  created_at?: InputMaybe<Order_By>
  date?: InputMaybe<Order_By>
  day?: InputMaybe<Order_By>
  electricity_r1?: InputMaybe<Order_By>
  electricity_r2_day?: InputMaybe<Order_By>
  electricity_r2_night?: InputMaybe<Order_By>
  gas?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  month?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: energy_usage_load_factors */
export type Energy_Usage_Load_Factors_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "energy_usage_load_factors" */
export enum Energy_Usage_Load_Factors_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Date = "date",
  /** column name */
  Day = "day",
  /** column name */
  ElectricityR1 = "electricity_r1",
  /** column name */
  ElectricityR2Day = "electricity_r2_day",
  /** column name */
  ElectricityR2Night = "electricity_r2_night",
  /** column name */
  Gas = "gas",
  /** column name */
  Id = "id",
  /** column name */
  Month = "month",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "energy_usage_load_factors" */
export type Energy_Usage_Load_Factors_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  date?: InputMaybe<Scalars["date"]["input"]>
  day?: InputMaybe<Scalars["Int"]["input"]>
  electricity_r1?: InputMaybe<Scalars["numeric"]["input"]>
  electricity_r2_day?: InputMaybe<Scalars["numeric"]["input"]>
  electricity_r2_night?: InputMaybe<Scalars["numeric"]["input"]>
  gas?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  month?: InputMaybe<Scalars["Int"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Energy_Usage_Load_Factors_Stddev_Fields = {
  __typename?: "energy_usage_load_factors_stddev_fields"
  day?: Maybe<Scalars["Float"]["output"]>
  electricity_r1?: Maybe<Scalars["Float"]["output"]>
  electricity_r2_day?: Maybe<Scalars["Float"]["output"]>
  electricity_r2_night?: Maybe<Scalars["Float"]["output"]>
  gas?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  month?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Energy_Usage_Load_Factors_Stddev_Pop_Fields = {
  __typename?: "energy_usage_load_factors_stddev_pop_fields"
  day?: Maybe<Scalars["Float"]["output"]>
  electricity_r1?: Maybe<Scalars["Float"]["output"]>
  electricity_r2_day?: Maybe<Scalars["Float"]["output"]>
  electricity_r2_night?: Maybe<Scalars["Float"]["output"]>
  gas?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  month?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Energy_Usage_Load_Factors_Stddev_Samp_Fields = {
  __typename?: "energy_usage_load_factors_stddev_samp_fields"
  day?: Maybe<Scalars["Float"]["output"]>
  electricity_r1?: Maybe<Scalars["Float"]["output"]>
  electricity_r2_day?: Maybe<Scalars["Float"]["output"]>
  electricity_r2_night?: Maybe<Scalars["Float"]["output"]>
  gas?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  month?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "energy_usage_load_factors" */
export type Energy_Usage_Load_Factors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Energy_Usage_Load_Factors_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Energy_Usage_Load_Factors_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  date?: InputMaybe<Scalars["date"]["input"]>
  day?: InputMaybe<Scalars["Int"]["input"]>
  electricity_r1?: InputMaybe<Scalars["numeric"]["input"]>
  electricity_r2_day?: InputMaybe<Scalars["numeric"]["input"]>
  electricity_r2_night?: InputMaybe<Scalars["numeric"]["input"]>
  gas?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  month?: InputMaybe<Scalars["Int"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Energy_Usage_Load_Factors_Sum_Fields = {
  __typename?: "energy_usage_load_factors_sum_fields"
  day?: Maybe<Scalars["Int"]["output"]>
  electricity_r1?: Maybe<Scalars["numeric"]["output"]>
  electricity_r2_day?: Maybe<Scalars["numeric"]["output"]>
  electricity_r2_night?: Maybe<Scalars["numeric"]["output"]>
  gas?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  month?: Maybe<Scalars["Int"]["output"]>
}

/** update columns of table "energy_usage_load_factors" */
export enum Energy_Usage_Load_Factors_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Date = "date",
  /** column name */
  Day = "day",
  /** column name */
  ElectricityR1 = "electricity_r1",
  /** column name */
  ElectricityR2Day = "electricity_r2_day",
  /** column name */
  ElectricityR2Night = "electricity_r2_night",
  /** column name */
  Gas = "gas",
  /** column name */
  Id = "id",
  /** column name */
  Month = "month",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Energy_Usage_Load_Factors_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Energy_Usage_Load_Factors_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Energy_Usage_Load_Factors_Set_Input>
  /** filter the rows which have to be updated */
  where: Energy_Usage_Load_Factors_Bool_Exp
}

/** aggregate var_pop on columns */
export type Energy_Usage_Load_Factors_Var_Pop_Fields = {
  __typename?: "energy_usage_load_factors_var_pop_fields"
  day?: Maybe<Scalars["Float"]["output"]>
  electricity_r1?: Maybe<Scalars["Float"]["output"]>
  electricity_r2_day?: Maybe<Scalars["Float"]["output"]>
  electricity_r2_night?: Maybe<Scalars["Float"]["output"]>
  gas?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  month?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Energy_Usage_Load_Factors_Var_Samp_Fields = {
  __typename?: "energy_usage_load_factors_var_samp_fields"
  day?: Maybe<Scalars["Float"]["output"]>
  electricity_r1?: Maybe<Scalars["Float"]["output"]>
  electricity_r2_day?: Maybe<Scalars["Float"]["output"]>
  electricity_r2_night?: Maybe<Scalars["Float"]["output"]>
  gas?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  month?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Energy_Usage_Load_Factors_Variance_Fields = {
  __typename?: "energy_usage_load_factors_variance_fields"
  day?: Maybe<Scalars["Float"]["output"]>
  electricity_r1?: Maybe<Scalars["Float"]["output"]>
  electricity_r2_day?: Maybe<Scalars["Float"]["output"]>
  electricity_r2_night?: Maybe<Scalars["Float"]["output"]>
  gas?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  month?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "enrolment" */
export type Enrolment = {
  __typename?: "enrolment"
  agent_id?: Maybe<Scalars["String"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  broker?: Maybe<Scalars["String"]["output"]>
  /** SO-33786: paid-ad campaign reference (e.g. utm_campaign) the enrolment came from. Reporting only, not sent to Junifer. */
  campaign_reference?: Maybe<Scalars["String"]["output"]>
  communications_sent?: Maybe<Scalars["Boolean"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  /** An object relationship */
  customer?: Maybe<Customer>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  data?: Maybe<Scalars["json"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  /** The working start date for FSD enrolments. May differ from future_start_date when capped to the cooling-off deadline during a failed credit check. NULL for non-FSD enrolments. */
  effective_start_date?: Maybe<Scalars["date"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  enrolment_failure_message?: Maybe<Scalars["String"]["output"]>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries: Scalars["Int"]["output"]
  /** SO-31573: set when the GSOP exception ticket has been raised (success marker); NULL means still pending/failed. */
  fsd_gsop_exception_ticket_raised_at?: Maybe<Scalars["timestamp"]["output"]>
  future_start_date?: Maybe<Scalars["date"]["output"]>
  /** FSD requested status: SSD_DEFAULT (no date supplied, defaulted to minimum), FSD_COERCED (date below minimum, coerced), FSD (genuine FSD accepted). NULL = pre-migration row. */
  future_start_date_requested_status?: Maybe<
    Scalars["future_start_date_requested_status"]["output"]
  >
  id: Scalars["bigint"]["output"]
  junifer_account_id?: Maybe<Scalars["String"]["output"]>
  junifer_customer_id?: Maybe<Scalars["String"]["output"]>
  move_in_date?: Maybe<Scalars["date"]["output"]>
  mpans?: Maybe<Array<Scalars["String"]["output"]>>
  mprns?: Maybe<Array<Scalars["String"]["output"]>>
  old_billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  post_code?: Maybe<Scalars["String"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  submission_time?: Maybe<Scalars["timestamp"]["output"]>
  third_party_switch_reference?: Maybe<Scalars["String"]["output"]>
  type: Scalars["enrolment_type"]["output"]
  updated_at: Scalars["timestamp"]["output"]
  /** An array relationship */
  uswitch_records: Array<Uswitch_Record>
  /** An aggregate relationship */
  uswitch_records_aggregate: Uswitch_Record_Aggregate
  voucher?: Maybe<Scalars["String"]["output"]>
}

/** columns and relationships of "enrolment" */
export type EnrolmentDataArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** columns and relationships of "enrolment" */
export type EnrolmentUswitch_RecordsArgs = {
  distinct_on?: InputMaybe<Array<Uswitch_Record_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Uswitch_Record_Order_By>>
  where?: InputMaybe<Uswitch_Record_Bool_Exp>
}

/** columns and relationships of "enrolment" */
export type EnrolmentUswitch_Records_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uswitch_Record_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Uswitch_Record_Order_By>>
  where?: InputMaybe<Uswitch_Record_Bool_Exp>
}

/** aggregated selection of "enrolment" */
export type Enrolment_Aggregate = {
  __typename?: "enrolment_aggregate"
  aggregate?: Maybe<Enrolment_Aggregate_Fields>
  nodes: Array<Enrolment>
}

export type Enrolment_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Enrolment_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Enrolment_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<Enrolment_Aggregate_Bool_Exp_Count>
}

export type Enrolment_Aggregate_Bool_Exp_Bool_And = {
  arguments: Enrolment_Select_Column_Enrolment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Enrolment_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Enrolment_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Enrolment_Select_Column_Enrolment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Enrolment_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Enrolment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Enrolment_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Enrolment_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "enrolment" */
export type Enrolment_Aggregate_Fields = {
  __typename?: "enrolment_aggregate_fields"
  avg?: Maybe<Enrolment_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Enrolment_Max_Fields>
  min?: Maybe<Enrolment_Min_Fields>
  stddev?: Maybe<Enrolment_Stddev_Fields>
  stddev_pop?: Maybe<Enrolment_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Enrolment_Stddev_Samp_Fields>
  sum?: Maybe<Enrolment_Sum_Fields>
  var_pop?: Maybe<Enrolment_Var_Pop_Fields>
  var_samp?: Maybe<Enrolment_Var_Samp_Fields>
  variance?: Maybe<Enrolment_Variance_Fields>
}

/** aggregate fields of "enrolment" */
export type Enrolment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enrolment_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "enrolment" */
export type Enrolment_Aggregate_Order_By = {
  avg?: InputMaybe<Enrolment_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Enrolment_Max_Order_By>
  min?: InputMaybe<Enrolment_Min_Order_By>
  stddev?: InputMaybe<Enrolment_Stddev_Order_By>
  stddev_pop?: InputMaybe<Enrolment_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Enrolment_Stddev_Samp_Order_By>
  sum?: InputMaybe<Enrolment_Sum_Order_By>
  var_pop?: InputMaybe<Enrolment_Var_Pop_Order_By>
  var_samp?: InputMaybe<Enrolment_Var_Samp_Order_By>
  variance?: InputMaybe<Enrolment_Variance_Order_By>
}

/** input type for inserting array relation for remote table "enrolment" */
export type Enrolment_Arr_Rel_Insert_Input = {
  data: Array<Enrolment_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Enrolment_On_Conflict>
}

/** columns and relationships of "enrolment_automated_communications" */
export type Enrolment_Automated_Communications = {
  __typename?: "enrolment_automated_communications"
  comms_sent?: Maybe<Scalars["String"]["output"]>
  comms_sent_to?: Maybe<Scalars["String"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  enrolment_id?: Maybe<Scalars["bigint"]["output"]>
  id: Scalars["bigint"]["output"]
  paragraph_one?: Maybe<Scalars["String"]["output"]>
  paragraph_two?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregated selection of "enrolment_automated_communications" */
export type Enrolment_Automated_Communications_Aggregate = {
  __typename?: "enrolment_automated_communications_aggregate"
  aggregate?: Maybe<Enrolment_Automated_Communications_Aggregate_Fields>
  nodes: Array<Enrolment_Automated_Communications>
}

/** aggregate fields of "enrolment_automated_communications" */
export type Enrolment_Automated_Communications_Aggregate_Fields = {
  __typename?: "enrolment_automated_communications_aggregate_fields"
  avg?: Maybe<Enrolment_Automated_Communications_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Enrolment_Automated_Communications_Max_Fields>
  min?: Maybe<Enrolment_Automated_Communications_Min_Fields>
  stddev?: Maybe<Enrolment_Automated_Communications_Stddev_Fields>
  stddev_pop?: Maybe<Enrolment_Automated_Communications_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Enrolment_Automated_Communications_Stddev_Samp_Fields>
  sum?: Maybe<Enrolment_Automated_Communications_Sum_Fields>
  var_pop?: Maybe<Enrolment_Automated_Communications_Var_Pop_Fields>
  var_samp?: Maybe<Enrolment_Automated_Communications_Var_Samp_Fields>
  variance?: Maybe<Enrolment_Automated_Communications_Variance_Fields>
}

/** aggregate fields of "enrolment_automated_communications" */
export type Enrolment_Automated_Communications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enrolment_Automated_Communications_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Enrolment_Automated_Communications_Avg_Fields = {
  __typename?: "enrolment_automated_communications_avg_fields"
  enrolment_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "enrolment_automated_communications". All fields are combined with a logical 'AND'. */
export type Enrolment_Automated_Communications_Bool_Exp = {
  _and?: InputMaybe<Array<Enrolment_Automated_Communications_Bool_Exp>>
  _not?: InputMaybe<Enrolment_Automated_Communications_Bool_Exp>
  _or?: InputMaybe<Array<Enrolment_Automated_Communications_Bool_Exp>>
  comms_sent?: InputMaybe<String_Comparison_Exp>
  comms_sent_to?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  enrolment_id?: InputMaybe<Bigint_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  paragraph_one?: InputMaybe<String_Comparison_Exp>
  paragraph_two?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "enrolment_automated_communications" */
export enum Enrolment_Automated_Communications_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkEnrolmentAutomatedCommunications = "pk_enrolment_automated_communications",
}

/** input type for incrementing numeric columns in table "enrolment_automated_communications" */
export type Enrolment_Automated_Communications_Inc_Input = {
  enrolment_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "enrolment_automated_communications" */
export type Enrolment_Automated_Communications_Insert_Input = {
  comms_sent?: InputMaybe<Scalars["String"]["input"]>
  comms_sent_to?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  enrolment_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  paragraph_one?: InputMaybe<Scalars["String"]["input"]>
  paragraph_two?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Enrolment_Automated_Communications_Max_Fields = {
  __typename?: "enrolment_automated_communications_max_fields"
  comms_sent?: Maybe<Scalars["String"]["output"]>
  comms_sent_to?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  enrolment_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  paragraph_one?: Maybe<Scalars["String"]["output"]>
  paragraph_two?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Enrolment_Automated_Communications_Min_Fields = {
  __typename?: "enrolment_automated_communications_min_fields"
  comms_sent?: Maybe<Scalars["String"]["output"]>
  comms_sent_to?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  enrolment_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  paragraph_one?: Maybe<Scalars["String"]["output"]>
  paragraph_two?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "enrolment_automated_communications" */
export type Enrolment_Automated_Communications_Mutation_Response = {
  __typename?: "enrolment_automated_communications_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Enrolment_Automated_Communications>
}

/** on_conflict condition type for table "enrolment_automated_communications" */
export type Enrolment_Automated_Communications_On_Conflict = {
  constraint: Enrolment_Automated_Communications_Constraint
  update_columns?: Array<Enrolment_Automated_Communications_Update_Column>
  where?: InputMaybe<Enrolment_Automated_Communications_Bool_Exp>
}

/** Ordering options when selecting data from "enrolment_automated_communications". */
export type Enrolment_Automated_Communications_Order_By = {
  comms_sent?: InputMaybe<Order_By>
  comms_sent_to?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  enrolment_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  paragraph_one?: InputMaybe<Order_By>
  paragraph_two?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: enrolment_automated_communications */
export type Enrolment_Automated_Communications_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "enrolment_automated_communications" */
export enum Enrolment_Automated_Communications_Select_Column {
  /** column name */
  CommsSent = "comms_sent",
  /** column name */
  CommsSentTo = "comms_sent_to",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  EnrolmentId = "enrolment_id",
  /** column name */
  Id = "id",
  /** column name */
  ParagraphOne = "paragraph_one",
  /** column name */
  ParagraphTwo = "paragraph_two",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "enrolment_automated_communications" */
export type Enrolment_Automated_Communications_Set_Input = {
  comms_sent?: InputMaybe<Scalars["String"]["input"]>
  comms_sent_to?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  enrolment_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  paragraph_one?: InputMaybe<Scalars["String"]["input"]>
  paragraph_two?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Enrolment_Automated_Communications_Stddev_Fields = {
  __typename?: "enrolment_automated_communications_stddev_fields"
  enrolment_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Enrolment_Automated_Communications_Stddev_Pop_Fields = {
  __typename?: "enrolment_automated_communications_stddev_pop_fields"
  enrolment_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Enrolment_Automated_Communications_Stddev_Samp_Fields = {
  __typename?: "enrolment_automated_communications_stddev_samp_fields"
  enrolment_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "enrolment_automated_communications" */
export type Enrolment_Automated_Communications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enrolment_Automated_Communications_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Enrolment_Automated_Communications_Stream_Cursor_Value_Input = {
  comms_sent?: InputMaybe<Scalars["String"]["input"]>
  comms_sent_to?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  enrolment_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  paragraph_one?: InputMaybe<Scalars["String"]["input"]>
  paragraph_two?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Enrolment_Automated_Communications_Sum_Fields = {
  __typename?: "enrolment_automated_communications_sum_fields"
  enrolment_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "enrolment_automated_communications" */
export enum Enrolment_Automated_Communications_Update_Column {
  /** column name */
  CommsSent = "comms_sent",
  /** column name */
  CommsSentTo = "comms_sent_to",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  EnrolmentId = "enrolment_id",
  /** column name */
  Id = "id",
  /** column name */
  ParagraphOne = "paragraph_one",
  /** column name */
  ParagraphTwo = "paragraph_two",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Enrolment_Automated_Communications_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Enrolment_Automated_Communications_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enrolment_Automated_Communications_Set_Input>
  /** filter the rows which have to be updated */
  where: Enrolment_Automated_Communications_Bool_Exp
}

/** aggregate var_pop on columns */
export type Enrolment_Automated_Communications_Var_Pop_Fields = {
  __typename?: "enrolment_automated_communications_var_pop_fields"
  enrolment_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Enrolment_Automated_Communications_Var_Samp_Fields = {
  __typename?: "enrolment_automated_communications_var_samp_fields"
  enrolment_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Enrolment_Automated_Communications_Variance_Fields = {
  __typename?: "enrolment_automated_communications_variance_fields"
  enrolment_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate avg on columns */
export type Enrolment_Avg_Fields = {
  __typename?: "enrolment_avg_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  old_billing_account_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "enrolment" */
export type Enrolment_Avg_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  old_billing_account_id?: InputMaybe<Order_By>
  retry_count?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "enrolment". All fields are combined with a logical 'AND'. */
export type Enrolment_Bool_Exp = {
  _and?: InputMaybe<Array<Enrolment_Bool_Exp>>
  _not?: InputMaybe<Enrolment_Bool_Exp>
  _or?: InputMaybe<Array<Enrolment_Bool_Exp>>
  agent_id?: InputMaybe<String_Comparison_Exp>
  billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  broker?: InputMaybe<String_Comparison_Exp>
  campaign_reference?: InputMaybe<String_Comparison_Exp>
  communications_sent?: InputMaybe<Boolean_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  customer?: InputMaybe<Customer_Bool_Exp>
  customer_id?: InputMaybe<Bigint_Comparison_Exp>
  data?: InputMaybe<Json_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  effective_start_date?: InputMaybe<Date_Comparison_Exp>
  email?: InputMaybe<String_Comparison_Exp>
  enrolment_failure_message?: InputMaybe<String_Comparison_Exp>
  fsd_gsop_exception_retries?: InputMaybe<Int_Comparison_Exp>
  fsd_gsop_exception_ticket_raised_at?: InputMaybe<Timestamp_Comparison_Exp>
  future_start_date?: InputMaybe<Date_Comparison_Exp>
  future_start_date_requested_status?: InputMaybe<Future_Start_Date_Requested_Status_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  junifer_account_id?: InputMaybe<String_Comparison_Exp>
  junifer_customer_id?: InputMaybe<String_Comparison_Exp>
  move_in_date?: InputMaybe<Date_Comparison_Exp>
  mpans?: InputMaybe<String_Array_Comparison_Exp>
  mprns?: InputMaybe<String_Array_Comparison_Exp>
  old_billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  post_code?: InputMaybe<String_Comparison_Exp>
  retry_count?: InputMaybe<Int_Comparison_Exp>
  status?: InputMaybe<String_Comparison_Exp>
  submission_time?: InputMaybe<Timestamp_Comparison_Exp>
  third_party_switch_reference?: InputMaybe<String_Comparison_Exp>
  type?: InputMaybe<Enrolment_Type_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  uswitch_records?: InputMaybe<Uswitch_Record_Bool_Exp>
  uswitch_records_aggregate?: InputMaybe<Uswitch_Record_Aggregate_Bool_Exp>
  voucher?: InputMaybe<String_Comparison_Exp>
}

/** Boolean expression to compare columns of type "enrolment_broker". All fields are combined with logical 'AND'. */
export type Enrolment_Broker_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["enrolment_broker"]["input"]>
  _gt?: InputMaybe<Scalars["enrolment_broker"]["input"]>
  _gte?: InputMaybe<Scalars["enrolment_broker"]["input"]>
  _in?: InputMaybe<Array<Scalars["enrolment_broker"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["enrolment_broker"]["input"]>
  _lte?: InputMaybe<Scalars["enrolment_broker"]["input"]>
  _neq?: InputMaybe<Scalars["enrolment_broker"]["input"]>
  _nin?: InputMaybe<Array<Scalars["enrolment_broker"]["input"]>>
}

/** unique or primary key constraints on table "enrolment" */
export enum Enrolment_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkEnrolment = "pk_enrolment",
}

/** input type for incrementing numeric columns in table "enrolment" */
export type Enrolment_Inc_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  old_billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "enrolment" */
export type Enrolment_Insert_Input = {
  agent_id?: InputMaybe<Scalars["String"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  broker?: InputMaybe<Scalars["String"]["input"]>
  /** SO-33786: paid-ad campaign reference (e.g. utm_campaign) the enrolment came from. Reporting only, not sent to Junifer. */
  campaign_reference?: InputMaybe<Scalars["String"]["input"]>
  communications_sent?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer?: InputMaybe<Customer_Obj_Rel_Insert_Input>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  data?: InputMaybe<Scalars["json"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  /** The working start date for FSD enrolments. May differ from future_start_date when capped to the cooling-off deadline during a failed credit check. NULL for non-FSD enrolments. */
  effective_start_date?: InputMaybe<Scalars["date"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  enrolment_failure_message?: InputMaybe<Scalars["String"]["input"]>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: InputMaybe<Scalars["Int"]["input"]>
  /** SO-31573: set when the GSOP exception ticket has been raised (success marker); NULL means still pending/failed. */
  fsd_gsop_exception_ticket_raised_at?: InputMaybe<
    Scalars["timestamp"]["input"]
  >
  future_start_date?: InputMaybe<Scalars["date"]["input"]>
  /** FSD requested status: SSD_DEFAULT (no date supplied, defaulted to minimum), FSD_COERCED (date below minimum, coerced), FSD (genuine FSD accepted). NULL = pre-migration row. */
  future_start_date_requested_status?: InputMaybe<
    Scalars["future_start_date_requested_status"]["input"]
  >
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_account_id?: InputMaybe<Scalars["String"]["input"]>
  junifer_customer_id?: InputMaybe<Scalars["String"]["input"]>
  move_in_date?: InputMaybe<Scalars["date"]["input"]>
  mpans?: InputMaybe<Array<Scalars["String"]["input"]>>
  mprns?: InputMaybe<Array<Scalars["String"]["input"]>>
  old_billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  post_code?: InputMaybe<Scalars["String"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  submission_time?: InputMaybe<Scalars["timestamp"]["input"]>
  third_party_switch_reference?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["enrolment_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  uswitch_records?: InputMaybe<Uswitch_Record_Arr_Rel_Insert_Input>
  voucher?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Enrolment_Max_Fields = {
  __typename?: "enrolment_max_fields"
  agent_id?: Maybe<Scalars["String"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  broker?: Maybe<Scalars["String"]["output"]>
  /** SO-33786: paid-ad campaign reference (e.g. utm_campaign) the enrolment came from. Reporting only, not sent to Junifer. */
  campaign_reference?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  /** The working start date for FSD enrolments. May differ from future_start_date when capped to the cooling-off deadline during a failed credit check. NULL for non-FSD enrolments. */
  effective_start_date?: Maybe<Scalars["date"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  enrolment_failure_message?: Maybe<Scalars["String"]["output"]>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: Maybe<Scalars["Int"]["output"]>
  /** SO-31573: set when the GSOP exception ticket has been raised (success marker); NULL means still pending/failed. */
  fsd_gsop_exception_ticket_raised_at?: Maybe<Scalars["timestamp"]["output"]>
  future_start_date?: Maybe<Scalars["date"]["output"]>
  /** FSD requested status: SSD_DEFAULT (no date supplied, defaulted to minimum), FSD_COERCED (date below minimum, coerced), FSD (genuine FSD accepted). NULL = pre-migration row. */
  future_start_date_requested_status?: Maybe<
    Scalars["future_start_date_requested_status"]["output"]
  >
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_account_id?: Maybe<Scalars["String"]["output"]>
  junifer_customer_id?: Maybe<Scalars["String"]["output"]>
  move_in_date?: Maybe<Scalars["date"]["output"]>
  mpans?: Maybe<Array<Scalars["String"]["output"]>>
  mprns?: Maybe<Array<Scalars["String"]["output"]>>
  old_billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  post_code?: Maybe<Scalars["String"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  submission_time?: Maybe<Scalars["timestamp"]["output"]>
  third_party_switch_reference?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["enrolment_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  voucher?: Maybe<Scalars["String"]["output"]>
}

/** order by max() on columns of table "enrolment" */
export type Enrolment_Max_Order_By = {
  agent_id?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  broker?: InputMaybe<Order_By>
  /** SO-33786: paid-ad campaign reference (e.g. utm_campaign) the enrolment came from. Reporting only, not sent to Junifer. */
  campaign_reference?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  /** The working start date for FSD enrolments. May differ from future_start_date when capped to the cooling-off deadline during a failed credit check. NULL for non-FSD enrolments. */
  effective_start_date?: InputMaybe<Order_By>
  email?: InputMaybe<Order_By>
  enrolment_failure_message?: InputMaybe<Order_By>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: InputMaybe<Order_By>
  /** SO-31573: set when the GSOP exception ticket has been raised (success marker); NULL means still pending/failed. */
  fsd_gsop_exception_ticket_raised_at?: InputMaybe<Order_By>
  future_start_date?: InputMaybe<Order_By>
  /** FSD requested status: SSD_DEFAULT (no date supplied, defaulted to minimum), FSD_COERCED (date below minimum, coerced), FSD (genuine FSD accepted). NULL = pre-migration row. */
  future_start_date_requested_status?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  junifer_account_id?: InputMaybe<Order_By>
  junifer_customer_id?: InputMaybe<Order_By>
  move_in_date?: InputMaybe<Order_By>
  mpans?: InputMaybe<Order_By>
  mprns?: InputMaybe<Order_By>
  old_billing_account_id?: InputMaybe<Order_By>
  post_code?: InputMaybe<Order_By>
  retry_count?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  submission_time?: InputMaybe<Order_By>
  third_party_switch_reference?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  voucher?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Enrolment_Min_Fields = {
  __typename?: "enrolment_min_fields"
  agent_id?: Maybe<Scalars["String"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  broker?: Maybe<Scalars["String"]["output"]>
  /** SO-33786: paid-ad campaign reference (e.g. utm_campaign) the enrolment came from. Reporting only, not sent to Junifer. */
  campaign_reference?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  /** The working start date for FSD enrolments. May differ from future_start_date when capped to the cooling-off deadline during a failed credit check. NULL for non-FSD enrolments. */
  effective_start_date?: Maybe<Scalars["date"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  enrolment_failure_message?: Maybe<Scalars["String"]["output"]>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: Maybe<Scalars["Int"]["output"]>
  /** SO-31573: set when the GSOP exception ticket has been raised (success marker); NULL means still pending/failed. */
  fsd_gsop_exception_ticket_raised_at?: Maybe<Scalars["timestamp"]["output"]>
  future_start_date?: Maybe<Scalars["date"]["output"]>
  /** FSD requested status: SSD_DEFAULT (no date supplied, defaulted to minimum), FSD_COERCED (date below minimum, coerced), FSD (genuine FSD accepted). NULL = pre-migration row. */
  future_start_date_requested_status?: Maybe<
    Scalars["future_start_date_requested_status"]["output"]
  >
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_account_id?: Maybe<Scalars["String"]["output"]>
  junifer_customer_id?: Maybe<Scalars["String"]["output"]>
  move_in_date?: Maybe<Scalars["date"]["output"]>
  mpans?: Maybe<Array<Scalars["String"]["output"]>>
  mprns?: Maybe<Array<Scalars["String"]["output"]>>
  old_billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  post_code?: Maybe<Scalars["String"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  submission_time?: Maybe<Scalars["timestamp"]["output"]>
  third_party_switch_reference?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["enrolment_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  voucher?: Maybe<Scalars["String"]["output"]>
}

/** order by min() on columns of table "enrolment" */
export type Enrolment_Min_Order_By = {
  agent_id?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  broker?: InputMaybe<Order_By>
  /** SO-33786: paid-ad campaign reference (e.g. utm_campaign) the enrolment came from. Reporting only, not sent to Junifer. */
  campaign_reference?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  /** The working start date for FSD enrolments. May differ from future_start_date when capped to the cooling-off deadline during a failed credit check. NULL for non-FSD enrolments. */
  effective_start_date?: InputMaybe<Order_By>
  email?: InputMaybe<Order_By>
  enrolment_failure_message?: InputMaybe<Order_By>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: InputMaybe<Order_By>
  /** SO-31573: set when the GSOP exception ticket has been raised (success marker); NULL means still pending/failed. */
  fsd_gsop_exception_ticket_raised_at?: InputMaybe<Order_By>
  future_start_date?: InputMaybe<Order_By>
  /** FSD requested status: SSD_DEFAULT (no date supplied, defaulted to minimum), FSD_COERCED (date below minimum, coerced), FSD (genuine FSD accepted). NULL = pre-migration row. */
  future_start_date_requested_status?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  junifer_account_id?: InputMaybe<Order_By>
  junifer_customer_id?: InputMaybe<Order_By>
  move_in_date?: InputMaybe<Order_By>
  mpans?: InputMaybe<Order_By>
  mprns?: InputMaybe<Order_By>
  old_billing_account_id?: InputMaybe<Order_By>
  post_code?: InputMaybe<Order_By>
  retry_count?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  submission_time?: InputMaybe<Order_By>
  third_party_switch_reference?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  voucher?: InputMaybe<Order_By>
}

/** response of any mutation on the table "enrolment" */
export type Enrolment_Mutation_Response = {
  __typename?: "enrolment_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Enrolment>
}

/** input type for inserting object relation for remote table "enrolment" */
export type Enrolment_Obj_Rel_Insert_Input = {
  data: Enrolment_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Enrolment_On_Conflict>
}

/** on_conflict condition type for table "enrolment" */
export type Enrolment_On_Conflict = {
  constraint: Enrolment_Constraint
  update_columns?: Array<Enrolment_Update_Column>
  where?: InputMaybe<Enrolment_Bool_Exp>
}

/** Ordering options when selecting data from "enrolment". */
export type Enrolment_Order_By = {
  agent_id?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  broker?: InputMaybe<Order_By>
  campaign_reference?: InputMaybe<Order_By>
  communications_sent?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  customer?: InputMaybe<Customer_Order_By>
  customer_id?: InputMaybe<Order_By>
  data?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  effective_start_date?: InputMaybe<Order_By>
  email?: InputMaybe<Order_By>
  enrolment_failure_message?: InputMaybe<Order_By>
  fsd_gsop_exception_retries?: InputMaybe<Order_By>
  fsd_gsop_exception_ticket_raised_at?: InputMaybe<Order_By>
  future_start_date?: InputMaybe<Order_By>
  future_start_date_requested_status?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  junifer_account_id?: InputMaybe<Order_By>
  junifer_customer_id?: InputMaybe<Order_By>
  move_in_date?: InputMaybe<Order_By>
  mpans?: InputMaybe<Order_By>
  mprns?: InputMaybe<Order_By>
  old_billing_account_id?: InputMaybe<Order_By>
  post_code?: InputMaybe<Order_By>
  retry_count?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  submission_time?: InputMaybe<Order_By>
  third_party_switch_reference?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  uswitch_records_aggregate?: InputMaybe<Uswitch_Record_Aggregate_Order_By>
  voucher?: InputMaybe<Order_By>
}

/** primary key columns input for table: enrolment */
export type Enrolment_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "enrolment" */
export enum Enrolment_Select_Column {
  /** column name */
  AgentId = "agent_id",
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  Broker = "broker",
  /** column name */
  CampaignReference = "campaign_reference",
  /** column name */
  CommunicationsSent = "communications_sent",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  Data = "data",
  /** column name */
  Deleted = "deleted",
  /** column name */
  EffectiveStartDate = "effective_start_date",
  /** column name */
  Email = "email",
  /** column name */
  EnrolmentFailureMessage = "enrolment_failure_message",
  /** column name */
  FsdGsopExceptionRetries = "fsd_gsop_exception_retries",
  /** column name */
  FsdGsopExceptionTicketRaisedAt = "fsd_gsop_exception_ticket_raised_at",
  /** column name */
  FutureStartDate = "future_start_date",
  /** column name */
  FutureStartDateRequestedStatus = "future_start_date_requested_status",
  /** column name */
  Id = "id",
  /** column name */
  JuniferAccountId = "junifer_account_id",
  /** column name */
  JuniferCustomerId = "junifer_customer_id",
  /** column name */
  MoveInDate = "move_in_date",
  /** column name */
  Mpans = "mpans",
  /** column name */
  Mprns = "mprns",
  /** column name */
  OldBillingAccountId = "old_billing_account_id",
  /** column name */
  PostCode = "post_code",
  /** column name */
  RetryCount = "retry_count",
  /** column name */
  Status = "status",
  /** column name */
  SubmissionTime = "submission_time",
  /** column name */
  ThirdPartySwitchReference = "third_party_switch_reference",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  Voucher = "voucher",
}

/** select "enrolment_aggregate_bool_exp_bool_and_arguments_columns" columns of table "enrolment" */
export enum Enrolment_Select_Column_Enrolment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CommunicationsSent = "communications_sent",
}

/** select "enrolment_aggregate_bool_exp_bool_or_arguments_columns" columns of table "enrolment" */
export enum Enrolment_Select_Column_Enrolment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CommunicationsSent = "communications_sent",
}

/** input type for updating data in table "enrolment" */
export type Enrolment_Set_Input = {
  agent_id?: InputMaybe<Scalars["String"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  broker?: InputMaybe<Scalars["String"]["input"]>
  /** SO-33786: paid-ad campaign reference (e.g. utm_campaign) the enrolment came from. Reporting only, not sent to Junifer. */
  campaign_reference?: InputMaybe<Scalars["String"]["input"]>
  communications_sent?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  data?: InputMaybe<Scalars["json"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  /** The working start date for FSD enrolments. May differ from future_start_date when capped to the cooling-off deadline during a failed credit check. NULL for non-FSD enrolments. */
  effective_start_date?: InputMaybe<Scalars["date"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  enrolment_failure_message?: InputMaybe<Scalars["String"]["input"]>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: InputMaybe<Scalars["Int"]["input"]>
  /** SO-31573: set when the GSOP exception ticket has been raised (success marker); NULL means still pending/failed. */
  fsd_gsop_exception_ticket_raised_at?: InputMaybe<
    Scalars["timestamp"]["input"]
  >
  future_start_date?: InputMaybe<Scalars["date"]["input"]>
  /** FSD requested status: SSD_DEFAULT (no date supplied, defaulted to minimum), FSD_COERCED (date below minimum, coerced), FSD (genuine FSD accepted). NULL = pre-migration row. */
  future_start_date_requested_status?: InputMaybe<
    Scalars["future_start_date_requested_status"]["input"]
  >
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_account_id?: InputMaybe<Scalars["String"]["input"]>
  junifer_customer_id?: InputMaybe<Scalars["String"]["input"]>
  move_in_date?: InputMaybe<Scalars["date"]["input"]>
  mpans?: InputMaybe<Array<Scalars["String"]["input"]>>
  mprns?: InputMaybe<Array<Scalars["String"]["input"]>>
  old_billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  post_code?: InputMaybe<Scalars["String"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  submission_time?: InputMaybe<Scalars["timestamp"]["input"]>
  third_party_switch_reference?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["enrolment_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  voucher?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Enrolment_Stddev_Fields = {
  __typename?: "enrolment_stddev_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  old_billing_account_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "enrolment" */
export type Enrolment_Stddev_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  old_billing_account_id?: InputMaybe<Order_By>
  retry_count?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Enrolment_Stddev_Pop_Fields = {
  __typename?: "enrolment_stddev_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  old_billing_account_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "enrolment" */
export type Enrolment_Stddev_Pop_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  old_billing_account_id?: InputMaybe<Order_By>
  retry_count?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Enrolment_Stddev_Samp_Fields = {
  __typename?: "enrolment_stddev_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  old_billing_account_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "enrolment" */
export type Enrolment_Stddev_Samp_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  old_billing_account_id?: InputMaybe<Order_By>
  retry_count?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "enrolment" */
export type Enrolment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enrolment_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Enrolment_Stream_Cursor_Value_Input = {
  agent_id?: InputMaybe<Scalars["String"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  broker?: InputMaybe<Scalars["String"]["input"]>
  /** SO-33786: paid-ad campaign reference (e.g. utm_campaign) the enrolment came from. Reporting only, not sent to Junifer. */
  campaign_reference?: InputMaybe<Scalars["String"]["input"]>
  communications_sent?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  data?: InputMaybe<Scalars["json"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  /** The working start date for FSD enrolments. May differ from future_start_date when capped to the cooling-off deadline during a failed credit check. NULL for non-FSD enrolments. */
  effective_start_date?: InputMaybe<Scalars["date"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  enrolment_failure_message?: InputMaybe<Scalars["String"]["input"]>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: InputMaybe<Scalars["Int"]["input"]>
  /** SO-31573: set when the GSOP exception ticket has been raised (success marker); NULL means still pending/failed. */
  fsd_gsop_exception_ticket_raised_at?: InputMaybe<
    Scalars["timestamp"]["input"]
  >
  future_start_date?: InputMaybe<Scalars["date"]["input"]>
  /** FSD requested status: SSD_DEFAULT (no date supplied, defaulted to minimum), FSD_COERCED (date below minimum, coerced), FSD (genuine FSD accepted). NULL = pre-migration row. */
  future_start_date_requested_status?: InputMaybe<
    Scalars["future_start_date_requested_status"]["input"]
  >
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_account_id?: InputMaybe<Scalars["String"]["input"]>
  junifer_customer_id?: InputMaybe<Scalars["String"]["input"]>
  move_in_date?: InputMaybe<Scalars["date"]["input"]>
  mpans?: InputMaybe<Array<Scalars["String"]["input"]>>
  mprns?: InputMaybe<Array<Scalars["String"]["input"]>>
  old_billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  post_code?: InputMaybe<Scalars["String"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  submission_time?: InputMaybe<Scalars["timestamp"]["input"]>
  third_party_switch_reference?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["enrolment_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  voucher?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Enrolment_Sum_Fields = {
  __typename?: "enrolment_sum_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  old_billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
}

/** order by sum() on columns of table "enrolment" */
export type Enrolment_Sum_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  old_billing_account_id?: InputMaybe<Order_By>
  retry_count?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "enrolment_type". All fields are combined with logical 'AND'. */
export type Enrolment_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["enrolment_type"]["input"]>
  _gt?: InputMaybe<Scalars["enrolment_type"]["input"]>
  _gte?: InputMaybe<Scalars["enrolment_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["enrolment_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["enrolment_type"]["input"]>
  _lte?: InputMaybe<Scalars["enrolment_type"]["input"]>
  _neq?: InputMaybe<Scalars["enrolment_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["enrolment_type"]["input"]>>
}

/** update columns of table "enrolment" */
export enum Enrolment_Update_Column {
  /** column name */
  AgentId = "agent_id",
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  Broker = "broker",
  /** column name */
  CampaignReference = "campaign_reference",
  /** column name */
  CommunicationsSent = "communications_sent",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  Data = "data",
  /** column name */
  Deleted = "deleted",
  /** column name */
  EffectiveStartDate = "effective_start_date",
  /** column name */
  Email = "email",
  /** column name */
  EnrolmentFailureMessage = "enrolment_failure_message",
  /** column name */
  FsdGsopExceptionRetries = "fsd_gsop_exception_retries",
  /** column name */
  FsdGsopExceptionTicketRaisedAt = "fsd_gsop_exception_ticket_raised_at",
  /** column name */
  FutureStartDate = "future_start_date",
  /** column name */
  FutureStartDateRequestedStatus = "future_start_date_requested_status",
  /** column name */
  Id = "id",
  /** column name */
  JuniferAccountId = "junifer_account_id",
  /** column name */
  JuniferCustomerId = "junifer_customer_id",
  /** column name */
  MoveInDate = "move_in_date",
  /** column name */
  Mpans = "mpans",
  /** column name */
  Mprns = "mprns",
  /** column name */
  OldBillingAccountId = "old_billing_account_id",
  /** column name */
  PostCode = "post_code",
  /** column name */
  RetryCount = "retry_count",
  /** column name */
  Status = "status",
  /** column name */
  SubmissionTime = "submission_time",
  /** column name */
  ThirdPartySwitchReference = "third_party_switch_reference",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  Voucher = "voucher",
}

export type Enrolment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Enrolment_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enrolment_Set_Input>
  /** filter the rows which have to be updated */
  where: Enrolment_Bool_Exp
}

/** aggregate var_pop on columns */
export type Enrolment_Var_Pop_Fields = {
  __typename?: "enrolment_var_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  old_billing_account_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "enrolment" */
export type Enrolment_Var_Pop_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  old_billing_account_id?: InputMaybe<Order_By>
  retry_count?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Enrolment_Var_Samp_Fields = {
  __typename?: "enrolment_var_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  old_billing_account_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "enrolment" */
export type Enrolment_Var_Samp_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  old_billing_account_id?: InputMaybe<Order_By>
  retry_count?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Enrolment_Variance_Fields = {
  __typename?: "enrolment_variance_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  old_billing_account_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "enrolment" */
export type Enrolment_Variance_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  /** SO-31573: number of failed attempts to raise the GSOP exception ticket; the retry sweep stops at FSD_MAX_RETRIES_FOR_GSOP. */
  fsd_gsop_exception_retries?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  old_billing_account_id?: InputMaybe<Order_By>
  retry_count?: InputMaybe<Order_By>
}

/** enrolments_grouped_by_brokerNative Query Arguments */
export type Enrolments_Grouped_By_Broker_Arguments = {
  brokers?: InputMaybe<Scalars["json"]["input"]>
  createdAtEnd: Scalars["timestamp"]["input"]
  createdAtStart: Scalars["timestamp"]["input"]
  enrolmentFailureMessageNRegex?: InputMaybe<Scalars["String"]["input"]>
  enrolmentFailureMessageRegex?: InputMaybe<Scalars["String"]["input"]>
  onboardingStatus?: InputMaybe<Scalars["json"]["input"]>
  search?: InputMaybe<Scalars["String"]["input"]>
}

export type Enrolments_Grouped_By_Broker_Model = {
  __typename?: "enrolments_grouped_by_broker_model"
  broker?: Maybe<Scalars["String"]["output"]>
  count?: Maybe<Scalars["bigint"]["output"]>
}

/** Boolean expression to filter rows from the logical model for "enrolments_grouped_by_broker_model". All fields are combined with a logical 'AND'. */
export type Enrolments_Grouped_By_Broker_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Enrolments_Grouped_By_Broker_Model_Bool_Exp_Bool_Exp>>
  _not?: InputMaybe<Enrolments_Grouped_By_Broker_Model_Bool_Exp_Bool_Exp>
  _or?: InputMaybe<Array<Enrolments_Grouped_By_Broker_Model_Bool_Exp_Bool_Exp>>
  broker?: InputMaybe<String_Comparison_Exp>
  count?: InputMaybe<Bigint_Comparison_Exp>
}

export enum Enrolments_Grouped_By_Broker_Model_Enum_Name {
  /** column name */
  Broker = "broker",
  /** column name */
  Count = "count",
}

/** Ordering options when selecting data from "enrolments_grouped_by_broker_model". */
export type Enrolments_Grouped_By_Broker_Model_Order_By = {
  broker?: InputMaybe<Order_By>
  count?: InputMaybe<Order_By>
}

/** columns and relationships of "entity_mappings" */
export type Entity_Mappings = {
  __typename?: "entity_mappings"
  account_credit_mapping?: Maybe<Account_Credit>
  core_id?: Maybe<Scalars["String"]["output"]>
  entity_type?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  junifer_id?: Maybe<Scalars["String"]["output"]>
}

/** aggregated selection of "entity_mappings" */
export type Entity_Mappings_Aggregate = {
  __typename?: "entity_mappings_aggregate"
  aggregate?: Maybe<Entity_Mappings_Aggregate_Fields>
  nodes: Array<Entity_Mappings>
}

/** aggregate fields of "entity_mappings" */
export type Entity_Mappings_Aggregate_Fields = {
  __typename?: "entity_mappings_aggregate_fields"
  avg?: Maybe<Entity_Mappings_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Entity_Mappings_Max_Fields>
  min?: Maybe<Entity_Mappings_Min_Fields>
  stddev?: Maybe<Entity_Mappings_Stddev_Fields>
  stddev_pop?: Maybe<Entity_Mappings_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Entity_Mappings_Stddev_Samp_Fields>
  sum?: Maybe<Entity_Mappings_Sum_Fields>
  var_pop?: Maybe<Entity_Mappings_Var_Pop_Fields>
  var_samp?: Maybe<Entity_Mappings_Var_Samp_Fields>
  variance?: Maybe<Entity_Mappings_Variance_Fields>
}

/** aggregate fields of "entity_mappings" */
export type Entity_Mappings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Entity_Mappings_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Entity_Mappings_Avg_Fields = {
  __typename?: "entity_mappings_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "entity_mappings". All fields are combined with a logical 'AND'. */
export type Entity_Mappings_Bool_Exp = {
  _and?: InputMaybe<Array<Entity_Mappings_Bool_Exp>>
  _not?: InputMaybe<Entity_Mappings_Bool_Exp>
  _or?: InputMaybe<Array<Entity_Mappings_Bool_Exp>>
  core_id?: InputMaybe<String_Comparison_Exp>
  entity_type?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  junifer_id?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "entity_mappings" */
export enum Entity_Mappings_Constraint {
  /** unique or primary key constraint on columns "id" */
  EntityMappingsPkey = "entity_mappings_pkey",
  /** unique or primary key constraint on columns "entity_type", "core_id" */
  UqEntityMappingsEntityTypeCoreId = "uq__entity_mappings__entity_type__core_id",
  /** unique or primary key constraint on columns "entity_type", "junifer_id" */
  UqEntityMappingsEntityTypeJuniferId = "uq__entity_mappings__entity_type__junifer_id",
}

/** input type for incrementing numeric columns in table "entity_mappings" */
export type Entity_Mappings_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "entity_mappings" */
export type Entity_Mappings_Insert_Input = {
  core_id?: InputMaybe<Scalars["String"]["input"]>
  entity_type?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_id?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Entity_Mappings_Max_Fields = {
  __typename?: "entity_mappings_max_fields"
  core_id?: Maybe<Scalars["String"]["output"]>
  entity_type?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_id?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Entity_Mappings_Min_Fields = {
  __typename?: "entity_mappings_min_fields"
  core_id?: Maybe<Scalars["String"]["output"]>
  entity_type?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_id?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "entity_mappings" */
export type Entity_Mappings_Mutation_Response = {
  __typename?: "entity_mappings_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Entity_Mappings>
}

/** on_conflict condition type for table "entity_mappings" */
export type Entity_Mappings_On_Conflict = {
  constraint: Entity_Mappings_Constraint
  update_columns?: Array<Entity_Mappings_Update_Column>
  where?: InputMaybe<Entity_Mappings_Bool_Exp>
}

/** Ordering options when selecting data from "entity_mappings". */
export type Entity_Mappings_Order_By = {
  core_id?: InputMaybe<Order_By>
  entity_type?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  junifer_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: entity_mappings */
export type Entity_Mappings_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "entity_mappings" */
export enum Entity_Mappings_Select_Column {
  /** column name */
  CoreId = "core_id",
  /** column name */
  EntityType = "entity_type",
  /** column name */
  Id = "id",
  /** column name */
  JuniferId = "junifer_id",
}

/** input type for updating data in table "entity_mappings" */
export type Entity_Mappings_Set_Input = {
  core_id?: InputMaybe<Scalars["String"]["input"]>
  entity_type?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_id?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Entity_Mappings_Stddev_Fields = {
  __typename?: "entity_mappings_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Entity_Mappings_Stddev_Pop_Fields = {
  __typename?: "entity_mappings_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Entity_Mappings_Stddev_Samp_Fields = {
  __typename?: "entity_mappings_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "entity_mappings" */
export type Entity_Mappings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Entity_Mappings_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Entity_Mappings_Stream_Cursor_Value_Input = {
  core_id?: InputMaybe<Scalars["String"]["input"]>
  entity_type?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_id?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Entity_Mappings_Sum_Fields = {
  __typename?: "entity_mappings_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "entity_mappings" */
export enum Entity_Mappings_Update_Column {
  /** column name */
  CoreId = "core_id",
  /** column name */
  EntityType = "entity_type",
  /** column name */
  Id = "id",
  /** column name */
  JuniferId = "junifer_id",
}

export type Entity_Mappings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Entity_Mappings_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Entity_Mappings_Set_Input>
  /** filter the rows which have to be updated */
  where: Entity_Mappings_Bool_Exp
}

/** aggregate var_pop on columns */
export type Entity_Mappings_Var_Pop_Fields = {
  __typename?: "entity_mappings_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Entity_Mappings_Var_Samp_Fields = {
  __typename?: "entity_mappings_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Entity_Mappings_Variance_Fields = {
  __typename?: "entity_mappings_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "estimated_rate_name". All fields are combined with logical 'AND'. */
export type Estimated_Rate_Name_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["estimated_rate_name"]["input"]>
  _gt?: InputMaybe<Scalars["estimated_rate_name"]["input"]>
  _gte?: InputMaybe<Scalars["estimated_rate_name"]["input"]>
  _in?: InputMaybe<Array<Scalars["estimated_rate_name"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["estimated_rate_name"]["input"]>
  _lte?: InputMaybe<Scalars["estimated_rate_name"]["input"]>
  _neq?: InputMaybe<Scalars["estimated_rate_name"]["input"]>
  _nin?: InputMaybe<Array<Scalars["estimated_rate_name"]["input"]>>
}

/** columns and relationships of "estimated_usage" */
export type Estimated_Usage = {
  __typename?: "estimated_usage"
  cancelfl?: Maybe<Scalars["Boolean"]["output"]>
  consumption_from_dt?: Maybe<Scalars["timestamp"]["output"]>
  consumption_to_dt?: Maybe<Scalars["timestamp"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  /** An object relationship */
  meter_point: Meter_Point
  meter_point_id: Scalars["bigint"]["output"]
  meter_point_type?: Maybe<Scalars["String"]["output"]>
  rate_name: Scalars["estimated_rate_name"]["output"]
  source?: Maybe<Scalars["String"]["output"]>
  type: Scalars["estimated_usage_type"]["output"]
  units: Scalars["String"]["output"]
  updated_at: Scalars["timestamp"]["output"]
  usage: Scalars["numeric"]["output"]
}

/** aggregated selection of "estimated_usage" */
export type Estimated_Usage_Aggregate = {
  __typename?: "estimated_usage_aggregate"
  aggregate?: Maybe<Estimated_Usage_Aggregate_Fields>
  nodes: Array<Estimated_Usage>
}

export type Estimated_Usage_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Estimated_Usage_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Estimated_Usage_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<Estimated_Usage_Aggregate_Bool_Exp_Count>
}

export type Estimated_Usage_Aggregate_Bool_Exp_Bool_And = {
  arguments: Estimated_Usage_Select_Column_Estimated_Usage_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Estimated_Usage_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Estimated_Usage_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Estimated_Usage_Select_Column_Estimated_Usage_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Estimated_Usage_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Estimated_Usage_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Estimated_Usage_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Estimated_Usage_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "estimated_usage" */
export type Estimated_Usage_Aggregate_Fields = {
  __typename?: "estimated_usage_aggregate_fields"
  avg?: Maybe<Estimated_Usage_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Estimated_Usage_Max_Fields>
  min?: Maybe<Estimated_Usage_Min_Fields>
  stddev?: Maybe<Estimated_Usage_Stddev_Fields>
  stddev_pop?: Maybe<Estimated_Usage_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Estimated_Usage_Stddev_Samp_Fields>
  sum?: Maybe<Estimated_Usage_Sum_Fields>
  var_pop?: Maybe<Estimated_Usage_Var_Pop_Fields>
  var_samp?: Maybe<Estimated_Usage_Var_Samp_Fields>
  variance?: Maybe<Estimated_Usage_Variance_Fields>
}

/** aggregate fields of "estimated_usage" */
export type Estimated_Usage_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Estimated_Usage_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "estimated_usage" */
export type Estimated_Usage_Aggregate_Order_By = {
  avg?: InputMaybe<Estimated_Usage_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Estimated_Usage_Max_Order_By>
  min?: InputMaybe<Estimated_Usage_Min_Order_By>
  stddev?: InputMaybe<Estimated_Usage_Stddev_Order_By>
  stddev_pop?: InputMaybe<Estimated_Usage_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Estimated_Usage_Stddev_Samp_Order_By>
  sum?: InputMaybe<Estimated_Usage_Sum_Order_By>
  var_pop?: InputMaybe<Estimated_Usage_Var_Pop_Order_By>
  var_samp?: InputMaybe<Estimated_Usage_Var_Samp_Order_By>
  variance?: InputMaybe<Estimated_Usage_Variance_Order_By>
}

/** input type for inserting array relation for remote table "estimated_usage" */
export type Estimated_Usage_Arr_Rel_Insert_Input = {
  data: Array<Estimated_Usage_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Estimated_Usage_On_Conflict>
}

/** aggregate avg on columns */
export type Estimated_Usage_Avg_Fields = {
  __typename?: "estimated_usage_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
  usage?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "estimated_usage" */
export type Estimated_Usage_Avg_Order_By = {
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  usage?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "estimated_usage". All fields are combined with a logical 'AND'. */
export type Estimated_Usage_Bool_Exp = {
  _and?: InputMaybe<Array<Estimated_Usage_Bool_Exp>>
  _not?: InputMaybe<Estimated_Usage_Bool_Exp>
  _or?: InputMaybe<Array<Estimated_Usage_Bool_Exp>>
  cancelfl?: InputMaybe<Boolean_Comparison_Exp>
  consumption_from_dt?: InputMaybe<Timestamp_Comparison_Exp>
  consumption_to_dt?: InputMaybe<Timestamp_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  meter_point?: InputMaybe<Meter_Point_Bool_Exp>
  meter_point_id?: InputMaybe<Bigint_Comparison_Exp>
  meter_point_type?: InputMaybe<String_Comparison_Exp>
  rate_name?: InputMaybe<Estimated_Rate_Name_Comparison_Exp>
  source?: InputMaybe<String_Comparison_Exp>
  type?: InputMaybe<Estimated_Usage_Type_Comparison_Exp>
  units?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  usage?: InputMaybe<Numeric_Comparison_Exp>
}

/** unique or primary key constraints on table "estimated_usage" */
export enum Estimated_Usage_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkEstimatedUsage = "pk_estimated_usage",
}

/** input type for incrementing numeric columns in table "estimated_usage" */
export type Estimated_Usage_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  usage?: InputMaybe<Scalars["numeric"]["input"]>
}

/** input type for inserting data into table "estimated_usage" */
export type Estimated_Usage_Insert_Input = {
  cancelfl?: InputMaybe<Scalars["Boolean"]["input"]>
  consumption_from_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  consumption_to_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point?: InputMaybe<Meter_Point_Obj_Rel_Insert_Input>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_type?: InputMaybe<Scalars["String"]["input"]>
  rate_name?: InputMaybe<Scalars["estimated_rate_name"]["input"]>
  source?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["estimated_usage_type"]["input"]>
  units?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  usage?: InputMaybe<Scalars["numeric"]["input"]>
}

/** aggregate max on columns */
export type Estimated_Usage_Max_Fields = {
  __typename?: "estimated_usage_max_fields"
  consumption_from_dt?: Maybe<Scalars["timestamp"]["output"]>
  consumption_to_dt?: Maybe<Scalars["timestamp"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_type?: Maybe<Scalars["String"]["output"]>
  rate_name?: Maybe<Scalars["estimated_rate_name"]["output"]>
  source?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["estimated_usage_type"]["output"]>
  units?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  usage?: Maybe<Scalars["numeric"]["output"]>
}

/** order by max() on columns of table "estimated_usage" */
export type Estimated_Usage_Max_Order_By = {
  consumption_from_dt?: InputMaybe<Order_By>
  consumption_to_dt?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  meter_point_type?: InputMaybe<Order_By>
  rate_name?: InputMaybe<Order_By>
  source?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  units?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  usage?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Estimated_Usage_Min_Fields = {
  __typename?: "estimated_usage_min_fields"
  consumption_from_dt?: Maybe<Scalars["timestamp"]["output"]>
  consumption_to_dt?: Maybe<Scalars["timestamp"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_type?: Maybe<Scalars["String"]["output"]>
  rate_name?: Maybe<Scalars["estimated_rate_name"]["output"]>
  source?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["estimated_usage_type"]["output"]>
  units?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  usage?: Maybe<Scalars["numeric"]["output"]>
}

/** order by min() on columns of table "estimated_usage" */
export type Estimated_Usage_Min_Order_By = {
  consumption_from_dt?: InputMaybe<Order_By>
  consumption_to_dt?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  meter_point_type?: InputMaybe<Order_By>
  rate_name?: InputMaybe<Order_By>
  source?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  units?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  usage?: InputMaybe<Order_By>
}

/** response of any mutation on the table "estimated_usage" */
export type Estimated_Usage_Mutation_Response = {
  __typename?: "estimated_usage_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Estimated_Usage>
}

/** on_conflict condition type for table "estimated_usage" */
export type Estimated_Usage_On_Conflict = {
  constraint: Estimated_Usage_Constraint
  update_columns?: Array<Estimated_Usage_Update_Column>
  where?: InputMaybe<Estimated_Usage_Bool_Exp>
}

/** Ordering options when selecting data from "estimated_usage". */
export type Estimated_Usage_Order_By = {
  cancelfl?: InputMaybe<Order_By>
  consumption_from_dt?: InputMaybe<Order_By>
  consumption_to_dt?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point?: InputMaybe<Meter_Point_Order_By>
  meter_point_id?: InputMaybe<Order_By>
  meter_point_type?: InputMaybe<Order_By>
  rate_name?: InputMaybe<Order_By>
  source?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  units?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  usage?: InputMaybe<Order_By>
}

/** primary key columns input for table: estimated_usage */
export type Estimated_Usage_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "estimated_usage" */
export enum Estimated_Usage_Select_Column {
  /** column name */
  Cancelfl = "cancelfl",
  /** column name */
  ConsumptionFromDt = "consumption_from_dt",
  /** column name */
  ConsumptionToDt = "consumption_to_dt",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  MeterPointId = "meter_point_id",
  /** column name */
  MeterPointType = "meter_point_type",
  /** column name */
  RateName = "rate_name",
  /** column name */
  Source = "source",
  /** column name */
  Type = "type",
  /** column name */
  Units = "units",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  Usage = "usage",
}

/** select "estimated_usage_aggregate_bool_exp_bool_and_arguments_columns" columns of table "estimated_usage" */
export enum Estimated_Usage_Select_Column_Estimated_Usage_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Cancelfl = "cancelfl",
}

/** select "estimated_usage_aggregate_bool_exp_bool_or_arguments_columns" columns of table "estimated_usage" */
export enum Estimated_Usage_Select_Column_Estimated_Usage_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Cancelfl = "cancelfl",
}

/** input type for updating data in table "estimated_usage" */
export type Estimated_Usage_Set_Input = {
  cancelfl?: InputMaybe<Scalars["Boolean"]["input"]>
  consumption_from_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  consumption_to_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_type?: InputMaybe<Scalars["String"]["input"]>
  rate_name?: InputMaybe<Scalars["estimated_rate_name"]["input"]>
  source?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["estimated_usage_type"]["input"]>
  units?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  usage?: InputMaybe<Scalars["numeric"]["input"]>
}

/** aggregate stddev on columns */
export type Estimated_Usage_Stddev_Fields = {
  __typename?: "estimated_usage_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
  usage?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "estimated_usage" */
export type Estimated_Usage_Stddev_Order_By = {
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  usage?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Estimated_Usage_Stddev_Pop_Fields = {
  __typename?: "estimated_usage_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
  usage?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "estimated_usage" */
export type Estimated_Usage_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  usage?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Estimated_Usage_Stddev_Samp_Fields = {
  __typename?: "estimated_usage_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
  usage?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "estimated_usage" */
export type Estimated_Usage_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  usage?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "estimated_usage" */
export type Estimated_Usage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Estimated_Usage_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Estimated_Usage_Stream_Cursor_Value_Input = {
  cancelfl?: InputMaybe<Scalars["Boolean"]["input"]>
  consumption_from_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  consumption_to_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_type?: InputMaybe<Scalars["String"]["input"]>
  rate_name?: InputMaybe<Scalars["estimated_rate_name"]["input"]>
  source?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["estimated_usage_type"]["input"]>
  units?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  usage?: InputMaybe<Scalars["numeric"]["input"]>
}

/** aggregate sum on columns */
export type Estimated_Usage_Sum_Fields = {
  __typename?: "estimated_usage_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["bigint"]["output"]>
  usage?: Maybe<Scalars["numeric"]["output"]>
}

/** order by sum() on columns of table "estimated_usage" */
export type Estimated_Usage_Sum_Order_By = {
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  usage?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "estimated_usage_type". All fields are combined with logical 'AND'. */
export type Estimated_Usage_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["estimated_usage_type"]["input"]>
  _gt?: InputMaybe<Scalars["estimated_usage_type"]["input"]>
  _gte?: InputMaybe<Scalars["estimated_usage_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["estimated_usage_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["estimated_usage_type"]["input"]>
  _lte?: InputMaybe<Scalars["estimated_usage_type"]["input"]>
  _neq?: InputMaybe<Scalars["estimated_usage_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["estimated_usage_type"]["input"]>>
}

/** update columns of table "estimated_usage" */
export enum Estimated_Usage_Update_Column {
  /** column name */
  Cancelfl = "cancelfl",
  /** column name */
  ConsumptionFromDt = "consumption_from_dt",
  /** column name */
  ConsumptionToDt = "consumption_to_dt",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  MeterPointId = "meter_point_id",
  /** column name */
  MeterPointType = "meter_point_type",
  /** column name */
  RateName = "rate_name",
  /** column name */
  Source = "source",
  /** column name */
  Type = "type",
  /** column name */
  Units = "units",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  Usage = "usage",
}

export type Estimated_Usage_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Estimated_Usage_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Estimated_Usage_Set_Input>
  /** filter the rows which have to be updated */
  where: Estimated_Usage_Bool_Exp
}

/** aggregate var_pop on columns */
export type Estimated_Usage_Var_Pop_Fields = {
  __typename?: "estimated_usage_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
  usage?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "estimated_usage" */
export type Estimated_Usage_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  usage?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Estimated_Usage_Var_Samp_Fields = {
  __typename?: "estimated_usage_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
  usage?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "estimated_usage" */
export type Estimated_Usage_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  usage?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Estimated_Usage_Variance_Fields = {
  __typename?: "estimated_usage_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
  usage?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "estimated_usage" */
export type Estimated_Usage_Variance_Order_By = {
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  usage?: InputMaybe<Order_By>
}

/** columns and relationships of "ev_smart_tariff_waitlist" */
export type Ev_Smart_Tariff_Waitlist = {
  __typename?: "ev_smart_tariff_waitlist"
  billing_account_id: Scalars["bigint"]["output"]
  created_at: Scalars["timestamptz"]["output"]
  deleted?: Maybe<Scalars["timestamptz"]["output"]>
  /** An object relationship */
  ev_tariff_eligibility_check: Ev_Tariff_Eligibility_Checks
  ev_tariff_eligibility_checks_id: Scalars["bigint"]["output"]
  id: Scalars["bigint"]["output"]
  updated_at: Scalars["timestamptz"]["output"]
}

/** aggregated selection of "ev_smart_tariff_waitlist" */
export type Ev_Smart_Tariff_Waitlist_Aggregate = {
  __typename?: "ev_smart_tariff_waitlist_aggregate"
  aggregate?: Maybe<Ev_Smart_Tariff_Waitlist_Aggregate_Fields>
  nodes: Array<Ev_Smart_Tariff_Waitlist>
}

export type Ev_Smart_Tariff_Waitlist_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ev_Smart_Tariff_Waitlist_Aggregate_Bool_Exp_Count>
}

export type Ev_Smart_Tariff_Waitlist_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ev_Smart_Tariff_Waitlist_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Ev_Smart_Tariff_Waitlist_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "ev_smart_tariff_waitlist" */
export type Ev_Smart_Tariff_Waitlist_Aggregate_Fields = {
  __typename?: "ev_smart_tariff_waitlist_aggregate_fields"
  avg?: Maybe<Ev_Smart_Tariff_Waitlist_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Ev_Smart_Tariff_Waitlist_Max_Fields>
  min?: Maybe<Ev_Smart_Tariff_Waitlist_Min_Fields>
  stddev?: Maybe<Ev_Smart_Tariff_Waitlist_Stddev_Fields>
  stddev_pop?: Maybe<Ev_Smart_Tariff_Waitlist_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Ev_Smart_Tariff_Waitlist_Stddev_Samp_Fields>
  sum?: Maybe<Ev_Smart_Tariff_Waitlist_Sum_Fields>
  var_pop?: Maybe<Ev_Smart_Tariff_Waitlist_Var_Pop_Fields>
  var_samp?: Maybe<Ev_Smart_Tariff_Waitlist_Var_Samp_Fields>
  variance?: Maybe<Ev_Smart_Tariff_Waitlist_Variance_Fields>
}

/** aggregate fields of "ev_smart_tariff_waitlist" */
export type Ev_Smart_Tariff_Waitlist_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ev_Smart_Tariff_Waitlist_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "ev_smart_tariff_waitlist" */
export type Ev_Smart_Tariff_Waitlist_Aggregate_Order_By = {
  avg?: InputMaybe<Ev_Smart_Tariff_Waitlist_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Ev_Smart_Tariff_Waitlist_Max_Order_By>
  min?: InputMaybe<Ev_Smart_Tariff_Waitlist_Min_Order_By>
  stddev?: InputMaybe<Ev_Smart_Tariff_Waitlist_Stddev_Order_By>
  stddev_pop?: InputMaybe<Ev_Smart_Tariff_Waitlist_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Ev_Smart_Tariff_Waitlist_Stddev_Samp_Order_By>
  sum?: InputMaybe<Ev_Smart_Tariff_Waitlist_Sum_Order_By>
  var_pop?: InputMaybe<Ev_Smart_Tariff_Waitlist_Var_Pop_Order_By>
  var_samp?: InputMaybe<Ev_Smart_Tariff_Waitlist_Var_Samp_Order_By>
  variance?: InputMaybe<Ev_Smart_Tariff_Waitlist_Variance_Order_By>
}

/** input type for inserting array relation for remote table "ev_smart_tariff_waitlist" */
export type Ev_Smart_Tariff_Waitlist_Arr_Rel_Insert_Input = {
  data: Array<Ev_Smart_Tariff_Waitlist_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Ev_Smart_Tariff_Waitlist_On_Conflict>
}

/** aggregate avg on columns */
export type Ev_Smart_Tariff_Waitlist_Avg_Fields = {
  __typename?: "ev_smart_tariff_waitlist_avg_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  ev_tariff_eligibility_checks_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "ev_smart_tariff_waitlist" */
export type Ev_Smart_Tariff_Waitlist_Avg_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  ev_tariff_eligibility_checks_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "ev_smart_tariff_waitlist". All fields are combined with a logical 'AND'. */
export type Ev_Smart_Tariff_Waitlist_Bool_Exp = {
  _and?: InputMaybe<Array<Ev_Smart_Tariff_Waitlist_Bool_Exp>>
  _not?: InputMaybe<Ev_Smart_Tariff_Waitlist_Bool_Exp>
  _or?: InputMaybe<Array<Ev_Smart_Tariff_Waitlist_Bool_Exp>>
  billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted?: InputMaybe<Timestamptz_Comparison_Exp>
  ev_tariff_eligibility_check?: InputMaybe<Ev_Tariff_Eligibility_Checks_Bool_Exp>
  ev_tariff_eligibility_checks_id?: InputMaybe<Bigint_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "ev_smart_tariff_waitlist" */
export enum Ev_Smart_Tariff_Waitlist_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkEvSmartTariffWaitlist = "pk_ev_smart_tariff_waitlist",
  /** unique or primary key constraint on columns "billing_account_id" */
  UqEvSmartTariffWaitlistBillingAccount = "uq_ev_smart_tariff_waitlist_billing_account",
}

/** input type for incrementing numeric columns in table "ev_smart_tariff_waitlist" */
export type Ev_Smart_Tariff_Waitlist_Inc_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  ev_tariff_eligibility_checks_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "ev_smart_tariff_waitlist" */
export type Ev_Smart_Tariff_Waitlist_Insert_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  deleted?: InputMaybe<Scalars["timestamptz"]["input"]>
  ev_tariff_eligibility_check?: InputMaybe<Ev_Tariff_Eligibility_Checks_Obj_Rel_Insert_Input>
  ev_tariff_eligibility_checks_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamptz"]["input"]>
}

/** aggregate max on columns */
export type Ev_Smart_Tariff_Waitlist_Max_Fields = {
  __typename?: "ev_smart_tariff_waitlist_max_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  deleted?: Maybe<Scalars["timestamptz"]["output"]>
  ev_tariff_eligibility_checks_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamptz"]["output"]>
}

/** order by max() on columns of table "ev_smart_tariff_waitlist" */
export type Ev_Smart_Tariff_Waitlist_Max_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  ev_tariff_eligibility_checks_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Ev_Smart_Tariff_Waitlist_Min_Fields = {
  __typename?: "ev_smart_tariff_waitlist_min_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  deleted?: Maybe<Scalars["timestamptz"]["output"]>
  ev_tariff_eligibility_checks_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamptz"]["output"]>
}

/** order by min() on columns of table "ev_smart_tariff_waitlist" */
export type Ev_Smart_Tariff_Waitlist_Min_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  ev_tariff_eligibility_checks_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "ev_smart_tariff_waitlist" */
export type Ev_Smart_Tariff_Waitlist_Mutation_Response = {
  __typename?: "ev_smart_tariff_waitlist_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Ev_Smart_Tariff_Waitlist>
}

/** on_conflict condition type for table "ev_smart_tariff_waitlist" */
export type Ev_Smart_Tariff_Waitlist_On_Conflict = {
  constraint: Ev_Smart_Tariff_Waitlist_Constraint
  update_columns?: Array<Ev_Smart_Tariff_Waitlist_Update_Column>
  where?: InputMaybe<Ev_Smart_Tariff_Waitlist_Bool_Exp>
}

/** Ordering options when selecting data from "ev_smart_tariff_waitlist". */
export type Ev_Smart_Tariff_Waitlist_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  ev_tariff_eligibility_check?: InputMaybe<Ev_Tariff_Eligibility_Checks_Order_By>
  ev_tariff_eligibility_checks_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: ev_smart_tariff_waitlist */
export type Ev_Smart_Tariff_Waitlist_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "ev_smart_tariff_waitlist" */
export enum Ev_Smart_Tariff_Waitlist_Select_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  EvTariffEligibilityChecksId = "ev_tariff_eligibility_checks_id",
  /** column name */
  Id = "id",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "ev_smart_tariff_waitlist" */
export type Ev_Smart_Tariff_Waitlist_Set_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  deleted?: InputMaybe<Scalars["timestamptz"]["input"]>
  ev_tariff_eligibility_checks_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamptz"]["input"]>
}

/** aggregate stddev on columns */
export type Ev_Smart_Tariff_Waitlist_Stddev_Fields = {
  __typename?: "ev_smart_tariff_waitlist_stddev_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  ev_tariff_eligibility_checks_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "ev_smart_tariff_waitlist" */
export type Ev_Smart_Tariff_Waitlist_Stddev_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  ev_tariff_eligibility_checks_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Ev_Smart_Tariff_Waitlist_Stddev_Pop_Fields = {
  __typename?: "ev_smart_tariff_waitlist_stddev_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  ev_tariff_eligibility_checks_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "ev_smart_tariff_waitlist" */
export type Ev_Smart_Tariff_Waitlist_Stddev_Pop_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  ev_tariff_eligibility_checks_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Ev_Smart_Tariff_Waitlist_Stddev_Samp_Fields = {
  __typename?: "ev_smart_tariff_waitlist_stddev_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  ev_tariff_eligibility_checks_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "ev_smart_tariff_waitlist" */
export type Ev_Smart_Tariff_Waitlist_Stddev_Samp_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  ev_tariff_eligibility_checks_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "ev_smart_tariff_waitlist" */
export type Ev_Smart_Tariff_Waitlist_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ev_Smart_Tariff_Waitlist_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Ev_Smart_Tariff_Waitlist_Stream_Cursor_Value_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  deleted?: InputMaybe<Scalars["timestamptz"]["input"]>
  ev_tariff_eligibility_checks_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamptz"]["input"]>
}

/** aggregate sum on columns */
export type Ev_Smart_Tariff_Waitlist_Sum_Fields = {
  __typename?: "ev_smart_tariff_waitlist_sum_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  ev_tariff_eligibility_checks_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "ev_smart_tariff_waitlist" */
export type Ev_Smart_Tariff_Waitlist_Sum_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  ev_tariff_eligibility_checks_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** update columns of table "ev_smart_tariff_waitlist" */
export enum Ev_Smart_Tariff_Waitlist_Update_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  EvTariffEligibilityChecksId = "ev_tariff_eligibility_checks_id",
  /** column name */
  Id = "id",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Ev_Smart_Tariff_Waitlist_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ev_Smart_Tariff_Waitlist_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ev_Smart_Tariff_Waitlist_Set_Input>
  /** filter the rows which have to be updated */
  where: Ev_Smart_Tariff_Waitlist_Bool_Exp
}

/** aggregate var_pop on columns */
export type Ev_Smart_Tariff_Waitlist_Var_Pop_Fields = {
  __typename?: "ev_smart_tariff_waitlist_var_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  ev_tariff_eligibility_checks_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "ev_smart_tariff_waitlist" */
export type Ev_Smart_Tariff_Waitlist_Var_Pop_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  ev_tariff_eligibility_checks_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Ev_Smart_Tariff_Waitlist_Var_Samp_Fields = {
  __typename?: "ev_smart_tariff_waitlist_var_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  ev_tariff_eligibility_checks_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "ev_smart_tariff_waitlist" */
export type Ev_Smart_Tariff_Waitlist_Var_Samp_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  ev_tariff_eligibility_checks_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Ev_Smart_Tariff_Waitlist_Variance_Fields = {
  __typename?: "ev_smart_tariff_waitlist_variance_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  ev_tariff_eligibility_checks_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "ev_smart_tariff_waitlist" */
export type Ev_Smart_Tariff_Waitlist_Variance_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  ev_tariff_eligibility_checks_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "ev_tariff_eligibility_check_channel". All fields are combined with logical 'AND'. */
export type Ev_Tariff_Eligibility_Check_Channel_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["ev_tariff_eligibility_check_channel"]["input"]>
  _gt?: InputMaybe<Scalars["ev_tariff_eligibility_check_channel"]["input"]>
  _gte?: InputMaybe<Scalars["ev_tariff_eligibility_check_channel"]["input"]>
  _in?: InputMaybe<
    Array<Scalars["ev_tariff_eligibility_check_channel"]["input"]>
  >
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["ev_tariff_eligibility_check_channel"]["input"]>
  _lte?: InputMaybe<Scalars["ev_tariff_eligibility_check_channel"]["input"]>
  _neq?: InputMaybe<Scalars["ev_tariff_eligibility_check_channel"]["input"]>
  _nin?: InputMaybe<
    Array<Scalars["ev_tariff_eligibility_check_channel"]["input"]>
  >
}

/** columns and relationships of "ev_tariff_eligibility_checks" */
export type Ev_Tariff_Eligibility_Checks = {
  __typename?: "ev_tariff_eligibility_checks"
  axle_charger_asset_id?: Maybe<Scalars["String"]["output"]>
  axle_charger_name?: Maybe<Scalars["String"]["output"]>
  axle_ev_asset_id?: Maybe<Scalars["String"]["output"]>
  axle_ev_name?: Maybe<Scalars["String"]["output"]>
  billing_account_id: Scalars["bigint"]["output"]
  channel?: Maybe<Scalars["ev_tariff_eligibility_check_channel"]["output"]>
  created_at: Scalars["timestamptz"]["output"]
  deleted?: Maybe<Scalars["timestamptz"]["output"]>
  /** An array relationship */
  ev_smart_tariff_waitlists: Array<Ev_Smart_Tariff_Waitlist>
  /** An aggregate relationship */
  ev_smart_tariff_waitlists_aggregate: Ev_Smart_Tariff_Waitlist_Aggregate
  failure_reasons?: Maybe<
    Array<Scalars["ev_tariff_ineligibility_reason"]["output"]>
  >
  id: Scalars["bigint"]["output"]
  is_eligible_for_smart_charging?: Maybe<Scalars["Boolean"]["output"]>
  is_supported_soon?: Maybe<Scalars["Boolean"]["output"]>
  meter_point_identifier?: Maybe<Scalars["String"]["output"]>
  /** An array relationship */
  smart_chargings: Array<Smart_Charging>
  /** An aggregate relationship */
  smart_chargings_aggregate: Smart_Charging_Aggregate
  updated_at: Scalars["timestamptz"]["output"]
  vehicle_fuel_type?: Maybe<Scalars["String"]["output"]>
  vehicle_make?: Maybe<Scalars["String"]["output"]>
  vehicle_year_of_manufacture?: Maybe<Scalars["Int"]["output"]>
}

/** columns and relationships of "ev_tariff_eligibility_checks" */
export type Ev_Tariff_Eligibility_ChecksEv_Smart_Tariff_WaitlistsArgs = {
  distinct_on?: InputMaybe<Array<Ev_Smart_Tariff_Waitlist_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Ev_Smart_Tariff_Waitlist_Order_By>>
  where?: InputMaybe<Ev_Smart_Tariff_Waitlist_Bool_Exp>
}

/** columns and relationships of "ev_tariff_eligibility_checks" */
export type Ev_Tariff_Eligibility_ChecksEv_Smart_Tariff_Waitlists_AggregateArgs =
  {
    distinct_on?: InputMaybe<Array<Ev_Smart_Tariff_Waitlist_Select_Column>>
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<Array<Ev_Smart_Tariff_Waitlist_Order_By>>
    where?: InputMaybe<Ev_Smart_Tariff_Waitlist_Bool_Exp>
  }

/** columns and relationships of "ev_tariff_eligibility_checks" */
export type Ev_Tariff_Eligibility_ChecksSmart_ChargingsArgs = {
  distinct_on?: InputMaybe<Array<Smart_Charging_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Smart_Charging_Order_By>>
  where?: InputMaybe<Smart_Charging_Bool_Exp>
}

/** columns and relationships of "ev_tariff_eligibility_checks" */
export type Ev_Tariff_Eligibility_ChecksSmart_Chargings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Smart_Charging_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Smart_Charging_Order_By>>
  where?: InputMaybe<Smart_Charging_Bool_Exp>
}

/** aggregated selection of "ev_tariff_eligibility_checks" */
export type Ev_Tariff_Eligibility_Checks_Aggregate = {
  __typename?: "ev_tariff_eligibility_checks_aggregate"
  aggregate?: Maybe<Ev_Tariff_Eligibility_Checks_Aggregate_Fields>
  nodes: Array<Ev_Tariff_Eligibility_Checks>
}

/** aggregate fields of "ev_tariff_eligibility_checks" */
export type Ev_Tariff_Eligibility_Checks_Aggregate_Fields = {
  __typename?: "ev_tariff_eligibility_checks_aggregate_fields"
  avg?: Maybe<Ev_Tariff_Eligibility_Checks_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Ev_Tariff_Eligibility_Checks_Max_Fields>
  min?: Maybe<Ev_Tariff_Eligibility_Checks_Min_Fields>
  stddev?: Maybe<Ev_Tariff_Eligibility_Checks_Stddev_Fields>
  stddev_pop?: Maybe<Ev_Tariff_Eligibility_Checks_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Ev_Tariff_Eligibility_Checks_Stddev_Samp_Fields>
  sum?: Maybe<Ev_Tariff_Eligibility_Checks_Sum_Fields>
  var_pop?: Maybe<Ev_Tariff_Eligibility_Checks_Var_Pop_Fields>
  var_samp?: Maybe<Ev_Tariff_Eligibility_Checks_Var_Samp_Fields>
  variance?: Maybe<Ev_Tariff_Eligibility_Checks_Variance_Fields>
}

/** aggregate fields of "ev_tariff_eligibility_checks" */
export type Ev_Tariff_Eligibility_Checks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ev_Tariff_Eligibility_Checks_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Ev_Tariff_Eligibility_Checks_Avg_Fields = {
  __typename?: "ev_tariff_eligibility_checks_avg_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  vehicle_year_of_manufacture?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "ev_tariff_eligibility_checks". All fields are combined with a logical 'AND'. */
export type Ev_Tariff_Eligibility_Checks_Bool_Exp = {
  _and?: InputMaybe<Array<Ev_Tariff_Eligibility_Checks_Bool_Exp>>
  _not?: InputMaybe<Ev_Tariff_Eligibility_Checks_Bool_Exp>
  _or?: InputMaybe<Array<Ev_Tariff_Eligibility_Checks_Bool_Exp>>
  axle_charger_asset_id?: InputMaybe<String_Comparison_Exp>
  axle_charger_name?: InputMaybe<String_Comparison_Exp>
  axle_ev_asset_id?: InputMaybe<String_Comparison_Exp>
  axle_ev_name?: InputMaybe<String_Comparison_Exp>
  billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  channel?: InputMaybe<Ev_Tariff_Eligibility_Check_Channel_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted?: InputMaybe<Timestamptz_Comparison_Exp>
  ev_smart_tariff_waitlists?: InputMaybe<Ev_Smart_Tariff_Waitlist_Bool_Exp>
  ev_smart_tariff_waitlists_aggregate?: InputMaybe<Ev_Smart_Tariff_Waitlist_Aggregate_Bool_Exp>
  failure_reasons?: InputMaybe<Ev_Tariff_Ineligibility_Reason_Array_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  is_eligible_for_smart_charging?: InputMaybe<Boolean_Comparison_Exp>
  is_supported_soon?: InputMaybe<Boolean_Comparison_Exp>
  meter_point_identifier?: InputMaybe<String_Comparison_Exp>
  smart_chargings?: InputMaybe<Smart_Charging_Bool_Exp>
  smart_chargings_aggregate?: InputMaybe<Smart_Charging_Aggregate_Bool_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
  vehicle_fuel_type?: InputMaybe<String_Comparison_Exp>
  vehicle_make?: InputMaybe<String_Comparison_Exp>
  vehicle_year_of_manufacture?: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "ev_tariff_eligibility_checks" */
export enum Ev_Tariff_Eligibility_Checks_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkEvTariffEligibilityChecks = "pk_ev_tariff_eligibility_checks",
}

/** input type for incrementing numeric columns in table "ev_tariff_eligibility_checks" */
export type Ev_Tariff_Eligibility_Checks_Inc_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  vehicle_year_of_manufacture?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "ev_tariff_eligibility_checks" */
export type Ev_Tariff_Eligibility_Checks_Insert_Input = {
  axle_charger_asset_id?: InputMaybe<Scalars["String"]["input"]>
  axle_charger_name?: InputMaybe<Scalars["String"]["input"]>
  axle_ev_asset_id?: InputMaybe<Scalars["String"]["input"]>
  axle_ev_name?: InputMaybe<Scalars["String"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  channel?: InputMaybe<Scalars["ev_tariff_eligibility_check_channel"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  deleted?: InputMaybe<Scalars["timestamptz"]["input"]>
  ev_smart_tariff_waitlists?: InputMaybe<Ev_Smart_Tariff_Waitlist_Arr_Rel_Insert_Input>
  failure_reasons?: InputMaybe<
    Array<Scalars["ev_tariff_ineligibility_reason"]["input"]>
  >
  id?: InputMaybe<Scalars["bigint"]["input"]>
  is_eligible_for_smart_charging?: InputMaybe<Scalars["Boolean"]["input"]>
  is_supported_soon?: InputMaybe<Scalars["Boolean"]["input"]>
  meter_point_identifier?: InputMaybe<Scalars["String"]["input"]>
  smart_chargings?: InputMaybe<Smart_Charging_Arr_Rel_Insert_Input>
  updated_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  vehicle_fuel_type?: InputMaybe<Scalars["String"]["input"]>
  vehicle_make?: InputMaybe<Scalars["String"]["input"]>
  vehicle_year_of_manufacture?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate max on columns */
export type Ev_Tariff_Eligibility_Checks_Max_Fields = {
  __typename?: "ev_tariff_eligibility_checks_max_fields"
  axle_charger_asset_id?: Maybe<Scalars["String"]["output"]>
  axle_charger_name?: Maybe<Scalars["String"]["output"]>
  axle_ev_asset_id?: Maybe<Scalars["String"]["output"]>
  axle_ev_name?: Maybe<Scalars["String"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  channel?: Maybe<Scalars["ev_tariff_eligibility_check_channel"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  deleted?: Maybe<Scalars["timestamptz"]["output"]>
  failure_reasons?: Maybe<
    Array<Scalars["ev_tariff_ineligibility_reason"]["output"]>
  >
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_identifier?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamptz"]["output"]>
  vehicle_fuel_type?: Maybe<Scalars["String"]["output"]>
  vehicle_make?: Maybe<Scalars["String"]["output"]>
  vehicle_year_of_manufacture?: Maybe<Scalars["Int"]["output"]>
}

/** aggregate min on columns */
export type Ev_Tariff_Eligibility_Checks_Min_Fields = {
  __typename?: "ev_tariff_eligibility_checks_min_fields"
  axle_charger_asset_id?: Maybe<Scalars["String"]["output"]>
  axle_charger_name?: Maybe<Scalars["String"]["output"]>
  axle_ev_asset_id?: Maybe<Scalars["String"]["output"]>
  axle_ev_name?: Maybe<Scalars["String"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  channel?: Maybe<Scalars["ev_tariff_eligibility_check_channel"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  deleted?: Maybe<Scalars["timestamptz"]["output"]>
  failure_reasons?: Maybe<
    Array<Scalars["ev_tariff_ineligibility_reason"]["output"]>
  >
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_identifier?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamptz"]["output"]>
  vehicle_fuel_type?: Maybe<Scalars["String"]["output"]>
  vehicle_make?: Maybe<Scalars["String"]["output"]>
  vehicle_year_of_manufacture?: Maybe<Scalars["Int"]["output"]>
}

/** response of any mutation on the table "ev_tariff_eligibility_checks" */
export type Ev_Tariff_Eligibility_Checks_Mutation_Response = {
  __typename?: "ev_tariff_eligibility_checks_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Ev_Tariff_Eligibility_Checks>
}

/** input type for inserting object relation for remote table "ev_tariff_eligibility_checks" */
export type Ev_Tariff_Eligibility_Checks_Obj_Rel_Insert_Input = {
  data: Ev_Tariff_Eligibility_Checks_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Ev_Tariff_Eligibility_Checks_On_Conflict>
}

/** on_conflict condition type for table "ev_tariff_eligibility_checks" */
export type Ev_Tariff_Eligibility_Checks_On_Conflict = {
  constraint: Ev_Tariff_Eligibility_Checks_Constraint
  update_columns?: Array<Ev_Tariff_Eligibility_Checks_Update_Column>
  where?: InputMaybe<Ev_Tariff_Eligibility_Checks_Bool_Exp>
}

/** Ordering options when selecting data from "ev_tariff_eligibility_checks". */
export type Ev_Tariff_Eligibility_Checks_Order_By = {
  axle_charger_asset_id?: InputMaybe<Order_By>
  axle_charger_name?: InputMaybe<Order_By>
  axle_ev_asset_id?: InputMaybe<Order_By>
  axle_ev_name?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  channel?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  ev_smart_tariff_waitlists_aggregate?: InputMaybe<Ev_Smart_Tariff_Waitlist_Aggregate_Order_By>
  failure_reasons?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  is_eligible_for_smart_charging?: InputMaybe<Order_By>
  is_supported_soon?: InputMaybe<Order_By>
  meter_point_identifier?: InputMaybe<Order_By>
  smart_chargings_aggregate?: InputMaybe<Smart_Charging_Aggregate_Order_By>
  updated_at?: InputMaybe<Order_By>
  vehicle_fuel_type?: InputMaybe<Order_By>
  vehicle_make?: InputMaybe<Order_By>
  vehicle_year_of_manufacture?: InputMaybe<Order_By>
}

/** primary key columns input for table: ev_tariff_eligibility_checks */
export type Ev_Tariff_Eligibility_Checks_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "ev_tariff_eligibility_checks" */
export enum Ev_Tariff_Eligibility_Checks_Select_Column {
  /** column name */
  AxleChargerAssetId = "axle_charger_asset_id",
  /** column name */
  AxleChargerName = "axle_charger_name",
  /** column name */
  AxleEvAssetId = "axle_ev_asset_id",
  /** column name */
  AxleEvName = "axle_ev_name",
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  Channel = "channel",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FailureReasons = "failure_reasons",
  /** column name */
  Id = "id",
  /** column name */
  IsEligibleForSmartCharging = "is_eligible_for_smart_charging",
  /** column name */
  IsSupportedSoon = "is_supported_soon",
  /** column name */
  MeterPointIdentifier = "meter_point_identifier",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  VehicleFuelType = "vehicle_fuel_type",
  /** column name */
  VehicleMake = "vehicle_make",
  /** column name */
  VehicleYearOfManufacture = "vehicle_year_of_manufacture",
}

/** input type for updating data in table "ev_tariff_eligibility_checks" */
export type Ev_Tariff_Eligibility_Checks_Set_Input = {
  axle_charger_asset_id?: InputMaybe<Scalars["String"]["input"]>
  axle_charger_name?: InputMaybe<Scalars["String"]["input"]>
  axle_ev_asset_id?: InputMaybe<Scalars["String"]["input"]>
  axle_ev_name?: InputMaybe<Scalars["String"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  channel?: InputMaybe<Scalars["ev_tariff_eligibility_check_channel"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  deleted?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_reasons?: InputMaybe<
    Array<Scalars["ev_tariff_ineligibility_reason"]["input"]>
  >
  id?: InputMaybe<Scalars["bigint"]["input"]>
  is_eligible_for_smart_charging?: InputMaybe<Scalars["Boolean"]["input"]>
  is_supported_soon?: InputMaybe<Scalars["Boolean"]["input"]>
  meter_point_identifier?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  vehicle_fuel_type?: InputMaybe<Scalars["String"]["input"]>
  vehicle_make?: InputMaybe<Scalars["String"]["input"]>
  vehicle_year_of_manufacture?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate stddev on columns */
export type Ev_Tariff_Eligibility_Checks_Stddev_Fields = {
  __typename?: "ev_tariff_eligibility_checks_stddev_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  vehicle_year_of_manufacture?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Ev_Tariff_Eligibility_Checks_Stddev_Pop_Fields = {
  __typename?: "ev_tariff_eligibility_checks_stddev_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  vehicle_year_of_manufacture?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Ev_Tariff_Eligibility_Checks_Stddev_Samp_Fields = {
  __typename?: "ev_tariff_eligibility_checks_stddev_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  vehicle_year_of_manufacture?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "ev_tariff_eligibility_checks" */
export type Ev_Tariff_Eligibility_Checks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ev_Tariff_Eligibility_Checks_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Ev_Tariff_Eligibility_Checks_Stream_Cursor_Value_Input = {
  axle_charger_asset_id?: InputMaybe<Scalars["String"]["input"]>
  axle_charger_name?: InputMaybe<Scalars["String"]["input"]>
  axle_ev_asset_id?: InputMaybe<Scalars["String"]["input"]>
  axle_ev_name?: InputMaybe<Scalars["String"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  channel?: InputMaybe<Scalars["ev_tariff_eligibility_check_channel"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  deleted?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_reasons?: InputMaybe<
    Array<Scalars["ev_tariff_ineligibility_reason"]["input"]>
  >
  id?: InputMaybe<Scalars["bigint"]["input"]>
  is_eligible_for_smart_charging?: InputMaybe<Scalars["Boolean"]["input"]>
  is_supported_soon?: InputMaybe<Scalars["Boolean"]["input"]>
  meter_point_identifier?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  vehicle_fuel_type?: InputMaybe<Scalars["String"]["input"]>
  vehicle_make?: InputMaybe<Scalars["String"]["input"]>
  vehicle_year_of_manufacture?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate sum on columns */
export type Ev_Tariff_Eligibility_Checks_Sum_Fields = {
  __typename?: "ev_tariff_eligibility_checks_sum_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  vehicle_year_of_manufacture?: Maybe<Scalars["Int"]["output"]>
}

/** update columns of table "ev_tariff_eligibility_checks" */
export enum Ev_Tariff_Eligibility_Checks_Update_Column {
  /** column name */
  AxleChargerAssetId = "axle_charger_asset_id",
  /** column name */
  AxleChargerName = "axle_charger_name",
  /** column name */
  AxleEvAssetId = "axle_ev_asset_id",
  /** column name */
  AxleEvName = "axle_ev_name",
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  Channel = "channel",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FailureReasons = "failure_reasons",
  /** column name */
  Id = "id",
  /** column name */
  IsEligibleForSmartCharging = "is_eligible_for_smart_charging",
  /** column name */
  IsSupportedSoon = "is_supported_soon",
  /** column name */
  MeterPointIdentifier = "meter_point_identifier",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  VehicleFuelType = "vehicle_fuel_type",
  /** column name */
  VehicleMake = "vehicle_make",
  /** column name */
  VehicleYearOfManufacture = "vehicle_year_of_manufacture",
}

export type Ev_Tariff_Eligibility_Checks_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ev_Tariff_Eligibility_Checks_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ev_Tariff_Eligibility_Checks_Set_Input>
  /** filter the rows which have to be updated */
  where: Ev_Tariff_Eligibility_Checks_Bool_Exp
}

/** aggregate var_pop on columns */
export type Ev_Tariff_Eligibility_Checks_Var_Pop_Fields = {
  __typename?: "ev_tariff_eligibility_checks_var_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  vehicle_year_of_manufacture?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Ev_Tariff_Eligibility_Checks_Var_Samp_Fields = {
  __typename?: "ev_tariff_eligibility_checks_var_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  vehicle_year_of_manufacture?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Ev_Tariff_Eligibility_Checks_Variance_Fields = {
  __typename?: "ev_tariff_eligibility_checks_variance_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  vehicle_year_of_manufacture?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "ev_tariff_ineligibility_reason". All fields are combined with logical 'AND'. */
export type Ev_Tariff_Ineligibility_Reason_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<
    Array<Scalars["ev_tariff_ineligibility_reason"]["input"]>
  >
  /** does the array contain the given value */
  _contains?: InputMaybe<
    Array<Scalars["ev_tariff_ineligibility_reason"]["input"]>
  >
  _eq?: InputMaybe<Array<Scalars["ev_tariff_ineligibility_reason"]["input"]>>
  _gt?: InputMaybe<Array<Scalars["ev_tariff_ineligibility_reason"]["input"]>>
  _gte?: InputMaybe<Array<Scalars["ev_tariff_ineligibility_reason"]["input"]>>
  _in?: InputMaybe<
    Array<Array<Scalars["ev_tariff_ineligibility_reason"]["input"]>>
  >
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Array<Scalars["ev_tariff_ineligibility_reason"]["input"]>>
  _lte?: InputMaybe<Array<Scalars["ev_tariff_ineligibility_reason"]["input"]>>
  _neq?: InputMaybe<Array<Scalars["ev_tariff_ineligibility_reason"]["input"]>>
  _nin?: InputMaybe<
    Array<Array<Scalars["ev_tariff_ineligibility_reason"]["input"]>>
  >
}

/** Boolean expression to compare columns of type "ev_type". All fields are combined with logical 'AND'. */
export type Ev_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["ev_type"]["input"]>
  _gt?: InputMaybe<Scalars["ev_type"]["input"]>
  _gte?: InputMaybe<Scalars["ev_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["ev_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["ev_type"]["input"]>
  _lte?: InputMaybe<Scalars["ev_type"]["input"]>
  _neq?: InputMaybe<Scalars["ev_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["ev_type"]["input"]>>
}

/** Boolean expression to compare columns of type "event_type". All fields are combined with logical 'AND'. */
export type Event_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["event_type"]["input"]>
  _gt?: InputMaybe<Scalars["event_type"]["input"]>
  _gte?: InputMaybe<Scalars["event_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["event_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["event_type"]["input"]>
  _lte?: InputMaybe<Scalars["event_type"]["input"]>
  _neq?: InputMaybe<Scalars["event_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["event_type"]["input"]>>
}

/** columns and relationships of "feature" */
export type Feature = {
  __typename?: "feature"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  enabled: Scalars["Boolean"]["output"]
  id: Scalars["bigint"]["output"]
  name: Scalars["feature_name"]["output"]
  squad_name: Scalars["squad"]["output"]
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregated selection of "feature" */
export type Feature_Aggregate = {
  __typename?: "feature_aggregate"
  aggregate?: Maybe<Feature_Aggregate_Fields>
  nodes: Array<Feature>
}

/** aggregate fields of "feature" */
export type Feature_Aggregate_Fields = {
  __typename?: "feature_aggregate_fields"
  avg?: Maybe<Feature_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Feature_Max_Fields>
  min?: Maybe<Feature_Min_Fields>
  stddev?: Maybe<Feature_Stddev_Fields>
  stddev_pop?: Maybe<Feature_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Feature_Stddev_Samp_Fields>
  sum?: Maybe<Feature_Sum_Fields>
  var_pop?: Maybe<Feature_Var_Pop_Fields>
  var_samp?: Maybe<Feature_Var_Samp_Fields>
  variance?: Maybe<Feature_Variance_Fields>
}

/** aggregate fields of "feature" */
export type Feature_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feature_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Feature_Avg_Fields = {
  __typename?: "feature_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "feature". All fields are combined with a logical 'AND'. */
export type Feature_Bool_Exp = {
  _and?: InputMaybe<Array<Feature_Bool_Exp>>
  _not?: InputMaybe<Feature_Bool_Exp>
  _or?: InputMaybe<Array<Feature_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  description?: InputMaybe<String_Comparison_Exp>
  enabled?: InputMaybe<Boolean_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  name?: InputMaybe<Feature_Name_Comparison_Exp>
  squad_name?: InputMaybe<Squad_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "feature" */
export enum Feature_Constraint {
  /** unique or primary key constraint on columns "name" */
  FeatureNameKey = "feature_name_key",
  /** unique or primary key constraint on columns "id" */
  PkFeature = "pk_feature",
}

/** input type for incrementing numeric columns in table "feature" */
export type Feature_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "feature" */
export type Feature_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["feature_name"]["input"]>
  squad_name?: InputMaybe<Scalars["squad"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Feature_Max_Fields = {
  __typename?: "feature_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["feature_name"]["output"]>
  squad_name?: Maybe<Scalars["squad"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Feature_Min_Fields = {
  __typename?: "feature_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["feature_name"]["output"]>
  squad_name?: Maybe<Scalars["squad"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "feature" */
export type Feature_Mutation_Response = {
  __typename?: "feature_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Feature>
}

/** Boolean expression to compare columns of type "feature_name". All fields are combined with logical 'AND'. */
export type Feature_Name_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["feature_name"]["input"]>
  _gt?: InputMaybe<Scalars["feature_name"]["input"]>
  _gte?: InputMaybe<Scalars["feature_name"]["input"]>
  _in?: InputMaybe<Array<Scalars["feature_name"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["feature_name"]["input"]>
  _lte?: InputMaybe<Scalars["feature_name"]["input"]>
  _neq?: InputMaybe<Scalars["feature_name"]["input"]>
  _nin?: InputMaybe<Array<Scalars["feature_name"]["input"]>>
}

/** on_conflict condition type for table "feature" */
export type Feature_On_Conflict = {
  constraint: Feature_Constraint
  update_columns?: Array<Feature_Update_Column>
  where?: InputMaybe<Feature_Bool_Exp>
}

/** Ordering options when selecting data from "feature". */
export type Feature_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  description?: InputMaybe<Order_By>
  enabled?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  squad_name?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: feature */
export type Feature_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "feature" */
export enum Feature_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Description = "description",
  /** column name */
  Enabled = "enabled",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  SquadName = "squad_name",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "feature" */
export type Feature_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["feature_name"]["input"]>
  squad_name?: InputMaybe<Scalars["squad"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Feature_Stddev_Fields = {
  __typename?: "feature_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Feature_Stddev_Pop_Fields = {
  __typename?: "feature_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Feature_Stddev_Samp_Fields = {
  __typename?: "feature_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "feature" */
export type Feature_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feature_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Feature_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["feature_name"]["input"]>
  squad_name?: InputMaybe<Scalars["squad"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Feature_Sum_Fields = {
  __typename?: "feature_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "feature" */
export enum Feature_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Description = "description",
  /** column name */
  Enabled = "enabled",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  SquadName = "squad_name",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Feature_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Feature_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feature_Set_Input>
  /** filter the rows which have to be updated */
  where: Feature_Bool_Exp
}

/** aggregate var_pop on columns */
export type Feature_Var_Pop_Fields = {
  __typename?: "feature_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Feature_Var_Samp_Fields = {
  __typename?: "feature_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Feature_Variance_Fields = {
  __typename?: "feature_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "configuration" */
export type Financials_Configuration = {
  __typename?: "financials_configuration"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_dttm?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  name: Scalars["String"]["output"]
  to_dttm?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  value: Scalars["String"]["output"]
}

/** aggregated selection of "configuration" */
export type Financials_Configuration_Aggregate = {
  __typename?: "financials_configuration_aggregate"
  aggregate?: Maybe<Financials_Configuration_Aggregate_Fields>
  nodes: Array<Financials_Configuration>
}

/** aggregate fields of "configuration" */
export type Financials_Configuration_Aggregate_Fields = {
  __typename?: "financials_configuration_aggregate_fields"
  avg?: Maybe<Financials_Configuration_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Configuration_Max_Fields>
  min?: Maybe<Financials_Configuration_Min_Fields>
  stddev?: Maybe<Financials_Configuration_Stddev_Fields>
  stddev_pop?: Maybe<Financials_Configuration_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Financials_Configuration_Stddev_Samp_Fields>
  sum?: Maybe<Financials_Configuration_Sum_Fields>
  var_pop?: Maybe<Financials_Configuration_Var_Pop_Fields>
  var_samp?: Maybe<Financials_Configuration_Var_Samp_Fields>
  variance?: Maybe<Financials_Configuration_Variance_Fields>
}

/** aggregate fields of "configuration" */
export type Financials_Configuration_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Financials_Configuration_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Financials_Configuration_Avg_Fields = {
  __typename?: "financials_configuration_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "configuration". All fields are combined with a logical 'AND'. */
export type Financials_Configuration_Bool_Exp = {
  _and?: InputMaybe<Array<Financials_Configuration_Bool_Exp>>
  _not?: InputMaybe<Financials_Configuration_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Configuration_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  from_dttm?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  to_dttm?: InputMaybe<Timestamp_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  value?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "configuration" */
export enum Financials_Configuration_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkConfigurations = "pk_configurations",
}

/** input type for incrementing numeric columns in table "configuration" */
export type Financials_Configuration_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "configuration" */
export type Financials_Configuration_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  to_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  value?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Financials_Configuration_Max_Fields = {
  __typename?: "financials_configuration_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_dttm?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  to_dttm?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  value?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Financials_Configuration_Min_Fields = {
  __typename?: "financials_configuration_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_dttm?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  to_dttm?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  value?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "configuration" */
export type Financials_Configuration_Mutation_Response = {
  __typename?: "financials_configuration_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Configuration>
}

/** on_conflict condition type for table "configuration" */
export type Financials_Configuration_On_Conflict = {
  constraint: Financials_Configuration_Constraint
  update_columns?: Array<Financials_Configuration_Update_Column>
  where?: InputMaybe<Financials_Configuration_Bool_Exp>
}

/** Ordering options when selecting data from "configuration". */
export type Financials_Configuration_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  from_dttm?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  to_dttm?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  value?: InputMaybe<Order_By>
}

/** primary key columns input for table: configuration */
export type Financials_Configuration_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "configuration" */
export enum Financials_Configuration_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FromDttm = "from_dttm",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  ToDttm = "to_dttm",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  Value = "value",
}

/** input type for updating data in table "configuration" */
export type Financials_Configuration_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  to_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  value?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Financials_Configuration_Stddev_Fields = {
  __typename?: "financials_configuration_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Financials_Configuration_Stddev_Pop_Fields = {
  __typename?: "financials_configuration_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Financials_Configuration_Stddev_Samp_Fields = {
  __typename?: "financials_configuration_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "financials_configuration" */
export type Financials_Configuration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Configuration_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Configuration_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  to_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  value?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Financials_Configuration_Sum_Fields = {
  __typename?: "financials_configuration_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "configuration" */
export enum Financials_Configuration_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FromDttm = "from_dttm",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  ToDttm = "to_dttm",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  Value = "value",
}

export type Financials_Configuration_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Financials_Configuration_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Configuration_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Configuration_Bool_Exp
}

/** aggregate var_pop on columns */
export type Financials_Configuration_Var_Pop_Fields = {
  __typename?: "financials_configuration_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Financials_Configuration_Var_Samp_Fields = {
  __typename?: "financials_configuration_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Financials_Configuration_Variance_Fields = {
  __typename?: "financials_configuration_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "qrtz_blob_triggers" */
export type Financials_Qrtz_Blob_Triggers = {
  __typename?: "financials_qrtz_blob_triggers"
  blob_data?: Maybe<Scalars["String"]["output"]>
  sched_name: Scalars["String"]["output"]
  trigger_group: Scalars["String"]["output"]
  trigger_name: Scalars["String"]["output"]
}

/** aggregated selection of "qrtz_blob_triggers" */
export type Financials_Qrtz_Blob_Triggers_Aggregate = {
  __typename?: "financials_qrtz_blob_triggers_aggregate"
  aggregate?: Maybe<Financials_Qrtz_Blob_Triggers_Aggregate_Fields>
  nodes: Array<Financials_Qrtz_Blob_Triggers>
}

/** aggregate fields of "qrtz_blob_triggers" */
export type Financials_Qrtz_Blob_Triggers_Aggregate_Fields = {
  __typename?: "financials_qrtz_blob_triggers_aggregate_fields"
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Qrtz_Blob_Triggers_Max_Fields>
  min?: Maybe<Financials_Qrtz_Blob_Triggers_Min_Fields>
}

/** aggregate fields of "qrtz_blob_triggers" */
export type Financials_Qrtz_Blob_Triggers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Financials_Qrtz_Blob_Triggers_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** Boolean expression to filter rows from the table "qrtz_blob_triggers". All fields are combined with a logical 'AND'. */
export type Financials_Qrtz_Blob_Triggers_Bool_Exp = {
  _and?: InputMaybe<Array<Financials_Qrtz_Blob_Triggers_Bool_Exp>>
  _not?: InputMaybe<Financials_Qrtz_Blob_Triggers_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Qrtz_Blob_Triggers_Bool_Exp>>
  blob_data?: InputMaybe<String_Comparison_Exp>
  sched_name?: InputMaybe<String_Comparison_Exp>
  trigger_group?: InputMaybe<String_Comparison_Exp>
  trigger_name?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "qrtz_blob_triggers" */
export enum Financials_Qrtz_Blob_Triggers_Constraint {
  /** unique or primary key constraint on columns "sched_name", "trigger_group", "trigger_name" */
  QrtzBlobTriggersPkey = "qrtz_blob_triggers_pkey",
}

/** input type for inserting data into table "qrtz_blob_triggers" */
export type Financials_Qrtz_Blob_Triggers_Insert_Input = {
  blob_data?: InputMaybe<Scalars["String"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Financials_Qrtz_Blob_Triggers_Max_Fields = {
  __typename?: "financials_qrtz_blob_triggers_max_fields"
  blob_data?: Maybe<Scalars["String"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Financials_Qrtz_Blob_Triggers_Min_Fields = {
  __typename?: "financials_qrtz_blob_triggers_min_fields"
  blob_data?: Maybe<Scalars["String"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "qrtz_blob_triggers" */
export type Financials_Qrtz_Blob_Triggers_Mutation_Response = {
  __typename?: "financials_qrtz_blob_triggers_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Qrtz_Blob_Triggers>
}

/** on_conflict condition type for table "qrtz_blob_triggers" */
export type Financials_Qrtz_Blob_Triggers_On_Conflict = {
  constraint: Financials_Qrtz_Blob_Triggers_Constraint
  update_columns?: Array<Financials_Qrtz_Blob_Triggers_Update_Column>
  where?: InputMaybe<Financials_Qrtz_Blob_Triggers_Bool_Exp>
}

/** Ordering options when selecting data from "qrtz_blob_triggers". */
export type Financials_Qrtz_Blob_Triggers_Order_By = {
  blob_data?: InputMaybe<Order_By>
  sched_name?: InputMaybe<Order_By>
  trigger_group?: InputMaybe<Order_By>
  trigger_name?: InputMaybe<Order_By>
}

/** primary key columns input for table: qrtz_blob_triggers */
export type Financials_Qrtz_Blob_Triggers_Pk_Columns_Input = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

/** select columns of table "qrtz_blob_triggers" */
export enum Financials_Qrtz_Blob_Triggers_Select_Column {
  /** column name */
  BlobData = "blob_data",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
}

/** input type for updating data in table "qrtz_blob_triggers" */
export type Financials_Qrtz_Blob_Triggers_Set_Input = {
  blob_data?: InputMaybe<Scalars["String"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** Streaming cursor of the table "financials_qrtz_blob_triggers" */
export type Financials_Qrtz_Blob_Triggers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Qrtz_Blob_Triggers_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Qrtz_Blob_Triggers_Stream_Cursor_Value_Input = {
  blob_data?: InputMaybe<Scalars["String"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** update columns of table "qrtz_blob_triggers" */
export enum Financials_Qrtz_Blob_Triggers_Update_Column {
  /** column name */
  BlobData = "blob_data",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
}

export type Financials_Qrtz_Blob_Triggers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Qrtz_Blob_Triggers_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Qrtz_Blob_Triggers_Bool_Exp
}

/** columns and relationships of "qrtz_calendars" */
export type Financials_Qrtz_Calendars = {
  __typename?: "financials_qrtz_calendars"
  calendar: Scalars["String"]["output"]
  calendar_name: Scalars["String"]["output"]
  sched_name: Scalars["String"]["output"]
}

/** aggregated selection of "qrtz_calendars" */
export type Financials_Qrtz_Calendars_Aggregate = {
  __typename?: "financials_qrtz_calendars_aggregate"
  aggregate?: Maybe<Financials_Qrtz_Calendars_Aggregate_Fields>
  nodes: Array<Financials_Qrtz_Calendars>
}

/** aggregate fields of "qrtz_calendars" */
export type Financials_Qrtz_Calendars_Aggregate_Fields = {
  __typename?: "financials_qrtz_calendars_aggregate_fields"
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Qrtz_Calendars_Max_Fields>
  min?: Maybe<Financials_Qrtz_Calendars_Min_Fields>
}

/** aggregate fields of "qrtz_calendars" */
export type Financials_Qrtz_Calendars_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Financials_Qrtz_Calendars_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** Boolean expression to filter rows from the table "qrtz_calendars". All fields are combined with a logical 'AND'. */
export type Financials_Qrtz_Calendars_Bool_Exp = {
  _and?: InputMaybe<Array<Financials_Qrtz_Calendars_Bool_Exp>>
  _not?: InputMaybe<Financials_Qrtz_Calendars_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Qrtz_Calendars_Bool_Exp>>
  calendar?: InputMaybe<String_Comparison_Exp>
  calendar_name?: InputMaybe<String_Comparison_Exp>
  sched_name?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "qrtz_calendars" */
export enum Financials_Qrtz_Calendars_Constraint {
  /** unique or primary key constraint on columns "sched_name", "calendar_name" */
  QrtzCalendarsPkey = "qrtz_calendars_pkey",
}

/** input type for inserting data into table "qrtz_calendars" */
export type Financials_Qrtz_Calendars_Insert_Input = {
  calendar?: InputMaybe<Scalars["String"]["input"]>
  calendar_name?: InputMaybe<Scalars["String"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Financials_Qrtz_Calendars_Max_Fields = {
  __typename?: "financials_qrtz_calendars_max_fields"
  calendar?: Maybe<Scalars["String"]["output"]>
  calendar_name?: Maybe<Scalars["String"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Financials_Qrtz_Calendars_Min_Fields = {
  __typename?: "financials_qrtz_calendars_min_fields"
  calendar?: Maybe<Scalars["String"]["output"]>
  calendar_name?: Maybe<Scalars["String"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "qrtz_calendars" */
export type Financials_Qrtz_Calendars_Mutation_Response = {
  __typename?: "financials_qrtz_calendars_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Qrtz_Calendars>
}

/** on_conflict condition type for table "qrtz_calendars" */
export type Financials_Qrtz_Calendars_On_Conflict = {
  constraint: Financials_Qrtz_Calendars_Constraint
  update_columns?: Array<Financials_Qrtz_Calendars_Update_Column>
  where?: InputMaybe<Financials_Qrtz_Calendars_Bool_Exp>
}

/** Ordering options when selecting data from "qrtz_calendars". */
export type Financials_Qrtz_Calendars_Order_By = {
  calendar?: InputMaybe<Order_By>
  calendar_name?: InputMaybe<Order_By>
  sched_name?: InputMaybe<Order_By>
}

/** primary key columns input for table: qrtz_calendars */
export type Financials_Qrtz_Calendars_Pk_Columns_Input = {
  calendar_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

/** select columns of table "qrtz_calendars" */
export enum Financials_Qrtz_Calendars_Select_Column {
  /** column name */
  Calendar = "calendar",
  /** column name */
  CalendarName = "calendar_name",
  /** column name */
  SchedName = "sched_name",
}

/** input type for updating data in table "qrtz_calendars" */
export type Financials_Qrtz_Calendars_Set_Input = {
  calendar?: InputMaybe<Scalars["String"]["input"]>
  calendar_name?: InputMaybe<Scalars["String"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
}

/** Streaming cursor of the table "financials_qrtz_calendars" */
export type Financials_Qrtz_Calendars_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Qrtz_Calendars_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Qrtz_Calendars_Stream_Cursor_Value_Input = {
  calendar?: InputMaybe<Scalars["String"]["input"]>
  calendar_name?: InputMaybe<Scalars["String"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
}

/** update columns of table "qrtz_calendars" */
export enum Financials_Qrtz_Calendars_Update_Column {
  /** column name */
  Calendar = "calendar",
  /** column name */
  CalendarName = "calendar_name",
  /** column name */
  SchedName = "sched_name",
}

export type Financials_Qrtz_Calendars_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Qrtz_Calendars_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Qrtz_Calendars_Bool_Exp
}

/** columns and relationships of "qrtz_cron_triggers" */
export type Financials_Qrtz_Cron_Triggers = {
  __typename?: "financials_qrtz_cron_triggers"
  cron_expression: Scalars["String"]["output"]
  sched_name: Scalars["String"]["output"]
  time_zone_id?: Maybe<Scalars["String"]["output"]>
  trigger_group: Scalars["String"]["output"]
  trigger_name: Scalars["String"]["output"]
}

/** aggregated selection of "qrtz_cron_triggers" */
export type Financials_Qrtz_Cron_Triggers_Aggregate = {
  __typename?: "financials_qrtz_cron_triggers_aggregate"
  aggregate?: Maybe<Financials_Qrtz_Cron_Triggers_Aggregate_Fields>
  nodes: Array<Financials_Qrtz_Cron_Triggers>
}

/** aggregate fields of "qrtz_cron_triggers" */
export type Financials_Qrtz_Cron_Triggers_Aggregate_Fields = {
  __typename?: "financials_qrtz_cron_triggers_aggregate_fields"
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Qrtz_Cron_Triggers_Max_Fields>
  min?: Maybe<Financials_Qrtz_Cron_Triggers_Min_Fields>
}

/** aggregate fields of "qrtz_cron_triggers" */
export type Financials_Qrtz_Cron_Triggers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Financials_Qrtz_Cron_Triggers_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** Boolean expression to filter rows from the table "qrtz_cron_triggers". All fields are combined with a logical 'AND'. */
export type Financials_Qrtz_Cron_Triggers_Bool_Exp = {
  _and?: InputMaybe<Array<Financials_Qrtz_Cron_Triggers_Bool_Exp>>
  _not?: InputMaybe<Financials_Qrtz_Cron_Triggers_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Qrtz_Cron_Triggers_Bool_Exp>>
  cron_expression?: InputMaybe<String_Comparison_Exp>
  sched_name?: InputMaybe<String_Comparison_Exp>
  time_zone_id?: InputMaybe<String_Comparison_Exp>
  trigger_group?: InputMaybe<String_Comparison_Exp>
  trigger_name?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "qrtz_cron_triggers" */
export enum Financials_Qrtz_Cron_Triggers_Constraint {
  /** unique or primary key constraint on columns "sched_name", "trigger_group", "trigger_name" */
  QrtzCronTriggersPkey = "qrtz_cron_triggers_pkey",
}

/** input type for inserting data into table "qrtz_cron_triggers" */
export type Financials_Qrtz_Cron_Triggers_Insert_Input = {
  cron_expression?: InputMaybe<Scalars["String"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  time_zone_id?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Financials_Qrtz_Cron_Triggers_Max_Fields = {
  __typename?: "financials_qrtz_cron_triggers_max_fields"
  cron_expression?: Maybe<Scalars["String"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  time_zone_id?: Maybe<Scalars["String"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Financials_Qrtz_Cron_Triggers_Min_Fields = {
  __typename?: "financials_qrtz_cron_triggers_min_fields"
  cron_expression?: Maybe<Scalars["String"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  time_zone_id?: Maybe<Scalars["String"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "qrtz_cron_triggers" */
export type Financials_Qrtz_Cron_Triggers_Mutation_Response = {
  __typename?: "financials_qrtz_cron_triggers_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Qrtz_Cron_Triggers>
}

/** on_conflict condition type for table "qrtz_cron_triggers" */
export type Financials_Qrtz_Cron_Triggers_On_Conflict = {
  constraint: Financials_Qrtz_Cron_Triggers_Constraint
  update_columns?: Array<Financials_Qrtz_Cron_Triggers_Update_Column>
  where?: InputMaybe<Financials_Qrtz_Cron_Triggers_Bool_Exp>
}

/** Ordering options when selecting data from "qrtz_cron_triggers". */
export type Financials_Qrtz_Cron_Triggers_Order_By = {
  cron_expression?: InputMaybe<Order_By>
  sched_name?: InputMaybe<Order_By>
  time_zone_id?: InputMaybe<Order_By>
  trigger_group?: InputMaybe<Order_By>
  trigger_name?: InputMaybe<Order_By>
}

/** primary key columns input for table: qrtz_cron_triggers */
export type Financials_Qrtz_Cron_Triggers_Pk_Columns_Input = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

/** select columns of table "qrtz_cron_triggers" */
export enum Financials_Qrtz_Cron_Triggers_Select_Column {
  /** column name */
  CronExpression = "cron_expression",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  TimeZoneId = "time_zone_id",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
}

/** input type for updating data in table "qrtz_cron_triggers" */
export type Financials_Qrtz_Cron_Triggers_Set_Input = {
  cron_expression?: InputMaybe<Scalars["String"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  time_zone_id?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** Streaming cursor of the table "financials_qrtz_cron_triggers" */
export type Financials_Qrtz_Cron_Triggers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Qrtz_Cron_Triggers_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Qrtz_Cron_Triggers_Stream_Cursor_Value_Input = {
  cron_expression?: InputMaybe<Scalars["String"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  time_zone_id?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** update columns of table "qrtz_cron_triggers" */
export enum Financials_Qrtz_Cron_Triggers_Update_Column {
  /** column name */
  CronExpression = "cron_expression",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  TimeZoneId = "time_zone_id",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
}

export type Financials_Qrtz_Cron_Triggers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Qrtz_Cron_Triggers_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Qrtz_Cron_Triggers_Bool_Exp
}

/** columns and relationships of "qrtz_fired_triggers" */
export type Financials_Qrtz_Fired_Triggers = {
  __typename?: "financials_qrtz_fired_triggers"
  entry_id: Scalars["String"]["output"]
  fired_time: Scalars["bigint"]["output"]
  instance_name: Scalars["String"]["output"]
  is_nonconcurrent?: Maybe<Scalars["Boolean"]["output"]>
  is_update_data?: Maybe<Scalars["Boolean"]["output"]>
  job_group?: Maybe<Scalars["String"]["output"]>
  job_name?: Maybe<Scalars["String"]["output"]>
  priority: Scalars["Int"]["output"]
  requests_recovery?: Maybe<Scalars["Boolean"]["output"]>
  sched_name: Scalars["String"]["output"]
  sched_time: Scalars["bigint"]["output"]
  state: Scalars["String"]["output"]
  trigger_group: Scalars["String"]["output"]
  trigger_name: Scalars["String"]["output"]
}

/** aggregated selection of "qrtz_fired_triggers" */
export type Financials_Qrtz_Fired_Triggers_Aggregate = {
  __typename?: "financials_qrtz_fired_triggers_aggregate"
  aggregate?: Maybe<Financials_Qrtz_Fired_Triggers_Aggregate_Fields>
  nodes: Array<Financials_Qrtz_Fired_Triggers>
}

/** aggregate fields of "qrtz_fired_triggers" */
export type Financials_Qrtz_Fired_Triggers_Aggregate_Fields = {
  __typename?: "financials_qrtz_fired_triggers_aggregate_fields"
  avg?: Maybe<Financials_Qrtz_Fired_Triggers_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Qrtz_Fired_Triggers_Max_Fields>
  min?: Maybe<Financials_Qrtz_Fired_Triggers_Min_Fields>
  stddev?: Maybe<Financials_Qrtz_Fired_Triggers_Stddev_Fields>
  stddev_pop?: Maybe<Financials_Qrtz_Fired_Triggers_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Financials_Qrtz_Fired_Triggers_Stddev_Samp_Fields>
  sum?: Maybe<Financials_Qrtz_Fired_Triggers_Sum_Fields>
  var_pop?: Maybe<Financials_Qrtz_Fired_Triggers_Var_Pop_Fields>
  var_samp?: Maybe<Financials_Qrtz_Fired_Triggers_Var_Samp_Fields>
  variance?: Maybe<Financials_Qrtz_Fired_Triggers_Variance_Fields>
}

/** aggregate fields of "qrtz_fired_triggers" */
export type Financials_Qrtz_Fired_Triggers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Financials_Qrtz_Fired_Triggers_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Financials_Qrtz_Fired_Triggers_Avg_Fields = {
  __typename?: "financials_qrtz_fired_triggers_avg_fields"
  fired_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  sched_time?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "qrtz_fired_triggers". All fields are combined with a logical 'AND'. */
export type Financials_Qrtz_Fired_Triggers_Bool_Exp = {
  _and?: InputMaybe<Array<Financials_Qrtz_Fired_Triggers_Bool_Exp>>
  _not?: InputMaybe<Financials_Qrtz_Fired_Triggers_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Qrtz_Fired_Triggers_Bool_Exp>>
  entry_id?: InputMaybe<String_Comparison_Exp>
  fired_time?: InputMaybe<Bigint_Comparison_Exp>
  instance_name?: InputMaybe<String_Comparison_Exp>
  is_nonconcurrent?: InputMaybe<Boolean_Comparison_Exp>
  is_update_data?: InputMaybe<Boolean_Comparison_Exp>
  job_group?: InputMaybe<String_Comparison_Exp>
  job_name?: InputMaybe<String_Comparison_Exp>
  priority?: InputMaybe<Int_Comparison_Exp>
  requests_recovery?: InputMaybe<Boolean_Comparison_Exp>
  sched_name?: InputMaybe<String_Comparison_Exp>
  sched_time?: InputMaybe<Bigint_Comparison_Exp>
  state?: InputMaybe<String_Comparison_Exp>
  trigger_group?: InputMaybe<String_Comparison_Exp>
  trigger_name?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "qrtz_fired_triggers" */
export enum Financials_Qrtz_Fired_Triggers_Constraint {
  /** unique or primary key constraint on columns "entry_id", "sched_name" */
  QrtzFiredTriggersPkey = "qrtz_fired_triggers_pkey",
}

/** input type for incrementing numeric columns in table "qrtz_fired_triggers" */
export type Financials_Qrtz_Fired_Triggers_Inc_Input = {
  fired_time?: InputMaybe<Scalars["bigint"]["input"]>
  priority?: InputMaybe<Scalars["Int"]["input"]>
  sched_time?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "qrtz_fired_triggers" */
export type Financials_Qrtz_Fired_Triggers_Insert_Input = {
  entry_id?: InputMaybe<Scalars["String"]["input"]>
  fired_time?: InputMaybe<Scalars["bigint"]["input"]>
  instance_name?: InputMaybe<Scalars["String"]["input"]>
  is_nonconcurrent?: InputMaybe<Scalars["Boolean"]["input"]>
  is_update_data?: InputMaybe<Scalars["Boolean"]["input"]>
  job_group?: InputMaybe<Scalars["String"]["input"]>
  job_name?: InputMaybe<Scalars["String"]["input"]>
  priority?: InputMaybe<Scalars["Int"]["input"]>
  requests_recovery?: InputMaybe<Scalars["Boolean"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  sched_time?: InputMaybe<Scalars["bigint"]["input"]>
  state?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Financials_Qrtz_Fired_Triggers_Max_Fields = {
  __typename?: "financials_qrtz_fired_triggers_max_fields"
  entry_id?: Maybe<Scalars["String"]["output"]>
  fired_time?: Maybe<Scalars["bigint"]["output"]>
  instance_name?: Maybe<Scalars["String"]["output"]>
  job_group?: Maybe<Scalars["String"]["output"]>
  job_name?: Maybe<Scalars["String"]["output"]>
  priority?: Maybe<Scalars["Int"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  sched_time?: Maybe<Scalars["bigint"]["output"]>
  state?: Maybe<Scalars["String"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Financials_Qrtz_Fired_Triggers_Min_Fields = {
  __typename?: "financials_qrtz_fired_triggers_min_fields"
  entry_id?: Maybe<Scalars["String"]["output"]>
  fired_time?: Maybe<Scalars["bigint"]["output"]>
  instance_name?: Maybe<Scalars["String"]["output"]>
  job_group?: Maybe<Scalars["String"]["output"]>
  job_name?: Maybe<Scalars["String"]["output"]>
  priority?: Maybe<Scalars["Int"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  sched_time?: Maybe<Scalars["bigint"]["output"]>
  state?: Maybe<Scalars["String"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "qrtz_fired_triggers" */
export type Financials_Qrtz_Fired_Triggers_Mutation_Response = {
  __typename?: "financials_qrtz_fired_triggers_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Qrtz_Fired_Triggers>
}

/** on_conflict condition type for table "qrtz_fired_triggers" */
export type Financials_Qrtz_Fired_Triggers_On_Conflict = {
  constraint: Financials_Qrtz_Fired_Triggers_Constraint
  update_columns?: Array<Financials_Qrtz_Fired_Triggers_Update_Column>
  where?: InputMaybe<Financials_Qrtz_Fired_Triggers_Bool_Exp>
}

/** Ordering options when selecting data from "qrtz_fired_triggers". */
export type Financials_Qrtz_Fired_Triggers_Order_By = {
  entry_id?: InputMaybe<Order_By>
  fired_time?: InputMaybe<Order_By>
  instance_name?: InputMaybe<Order_By>
  is_nonconcurrent?: InputMaybe<Order_By>
  is_update_data?: InputMaybe<Order_By>
  job_group?: InputMaybe<Order_By>
  job_name?: InputMaybe<Order_By>
  priority?: InputMaybe<Order_By>
  requests_recovery?: InputMaybe<Order_By>
  sched_name?: InputMaybe<Order_By>
  sched_time?: InputMaybe<Order_By>
  state?: InputMaybe<Order_By>
  trigger_group?: InputMaybe<Order_By>
  trigger_name?: InputMaybe<Order_By>
}

/** primary key columns input for table: qrtz_fired_triggers */
export type Financials_Qrtz_Fired_Triggers_Pk_Columns_Input = {
  entry_id: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

/** select columns of table "qrtz_fired_triggers" */
export enum Financials_Qrtz_Fired_Triggers_Select_Column {
  /** column name */
  EntryId = "entry_id",
  /** column name */
  FiredTime = "fired_time",
  /** column name */
  InstanceName = "instance_name",
  /** column name */
  IsNonconcurrent = "is_nonconcurrent",
  /** column name */
  IsUpdateData = "is_update_data",
  /** column name */
  JobGroup = "job_group",
  /** column name */
  JobName = "job_name",
  /** column name */
  Priority = "priority",
  /** column name */
  RequestsRecovery = "requests_recovery",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  SchedTime = "sched_time",
  /** column name */
  State = "state",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
}

/** input type for updating data in table "qrtz_fired_triggers" */
export type Financials_Qrtz_Fired_Triggers_Set_Input = {
  entry_id?: InputMaybe<Scalars["String"]["input"]>
  fired_time?: InputMaybe<Scalars["bigint"]["input"]>
  instance_name?: InputMaybe<Scalars["String"]["input"]>
  is_nonconcurrent?: InputMaybe<Scalars["Boolean"]["input"]>
  is_update_data?: InputMaybe<Scalars["Boolean"]["input"]>
  job_group?: InputMaybe<Scalars["String"]["input"]>
  job_name?: InputMaybe<Scalars["String"]["input"]>
  priority?: InputMaybe<Scalars["Int"]["input"]>
  requests_recovery?: InputMaybe<Scalars["Boolean"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  sched_time?: InputMaybe<Scalars["bigint"]["input"]>
  state?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Financials_Qrtz_Fired_Triggers_Stddev_Fields = {
  __typename?: "financials_qrtz_fired_triggers_stddev_fields"
  fired_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  sched_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Financials_Qrtz_Fired_Triggers_Stddev_Pop_Fields = {
  __typename?: "financials_qrtz_fired_triggers_stddev_pop_fields"
  fired_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  sched_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Financials_Qrtz_Fired_Triggers_Stddev_Samp_Fields = {
  __typename?: "financials_qrtz_fired_triggers_stddev_samp_fields"
  fired_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  sched_time?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "financials_qrtz_fired_triggers" */
export type Financials_Qrtz_Fired_Triggers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Qrtz_Fired_Triggers_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Qrtz_Fired_Triggers_Stream_Cursor_Value_Input = {
  entry_id?: InputMaybe<Scalars["String"]["input"]>
  fired_time?: InputMaybe<Scalars["bigint"]["input"]>
  instance_name?: InputMaybe<Scalars["String"]["input"]>
  is_nonconcurrent?: InputMaybe<Scalars["Boolean"]["input"]>
  is_update_data?: InputMaybe<Scalars["Boolean"]["input"]>
  job_group?: InputMaybe<Scalars["String"]["input"]>
  job_name?: InputMaybe<Scalars["String"]["input"]>
  priority?: InputMaybe<Scalars["Int"]["input"]>
  requests_recovery?: InputMaybe<Scalars["Boolean"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  sched_time?: InputMaybe<Scalars["bigint"]["input"]>
  state?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Financials_Qrtz_Fired_Triggers_Sum_Fields = {
  __typename?: "financials_qrtz_fired_triggers_sum_fields"
  fired_time?: Maybe<Scalars["bigint"]["output"]>
  priority?: Maybe<Scalars["Int"]["output"]>
  sched_time?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "qrtz_fired_triggers" */
export enum Financials_Qrtz_Fired_Triggers_Update_Column {
  /** column name */
  EntryId = "entry_id",
  /** column name */
  FiredTime = "fired_time",
  /** column name */
  InstanceName = "instance_name",
  /** column name */
  IsNonconcurrent = "is_nonconcurrent",
  /** column name */
  IsUpdateData = "is_update_data",
  /** column name */
  JobGroup = "job_group",
  /** column name */
  JobName = "job_name",
  /** column name */
  Priority = "priority",
  /** column name */
  RequestsRecovery = "requests_recovery",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  SchedTime = "sched_time",
  /** column name */
  State = "state",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
}

export type Financials_Qrtz_Fired_Triggers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Financials_Qrtz_Fired_Triggers_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Qrtz_Fired_Triggers_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Qrtz_Fired_Triggers_Bool_Exp
}

/** aggregate var_pop on columns */
export type Financials_Qrtz_Fired_Triggers_Var_Pop_Fields = {
  __typename?: "financials_qrtz_fired_triggers_var_pop_fields"
  fired_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  sched_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Financials_Qrtz_Fired_Triggers_Var_Samp_Fields = {
  __typename?: "financials_qrtz_fired_triggers_var_samp_fields"
  fired_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  sched_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Financials_Qrtz_Fired_Triggers_Variance_Fields = {
  __typename?: "financials_qrtz_fired_triggers_variance_fields"
  fired_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  sched_time?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "qrtz_job_details" */
export type Financials_Qrtz_Job_Details = {
  __typename?: "financials_qrtz_job_details"
  description?: Maybe<Scalars["String"]["output"]>
  is_durable?: Maybe<Scalars["Boolean"]["output"]>
  is_nonconcurrent?: Maybe<Scalars["Boolean"]["output"]>
  is_update_data?: Maybe<Scalars["Boolean"]["output"]>
  job_class_name: Scalars["String"]["output"]
  job_data?: Maybe<Scalars["bytea"]["output"]>
  job_group: Scalars["String"]["output"]
  job_name: Scalars["String"]["output"]
  requests_recovery?: Maybe<Scalars["Boolean"]["output"]>
  sched_name: Scalars["String"]["output"]
}

/** aggregated selection of "qrtz_job_details" */
export type Financials_Qrtz_Job_Details_Aggregate = {
  __typename?: "financials_qrtz_job_details_aggregate"
  aggregate?: Maybe<Financials_Qrtz_Job_Details_Aggregate_Fields>
  nodes: Array<Financials_Qrtz_Job_Details>
}

/** aggregate fields of "qrtz_job_details" */
export type Financials_Qrtz_Job_Details_Aggregate_Fields = {
  __typename?: "financials_qrtz_job_details_aggregate_fields"
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Qrtz_Job_Details_Max_Fields>
  min?: Maybe<Financials_Qrtz_Job_Details_Min_Fields>
}

/** aggregate fields of "qrtz_job_details" */
export type Financials_Qrtz_Job_Details_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Financials_Qrtz_Job_Details_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** Boolean expression to filter rows from the table "qrtz_job_details". All fields are combined with a logical 'AND'. */
export type Financials_Qrtz_Job_Details_Bool_Exp = {
  _and?: InputMaybe<Array<Financials_Qrtz_Job_Details_Bool_Exp>>
  _not?: InputMaybe<Financials_Qrtz_Job_Details_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Qrtz_Job_Details_Bool_Exp>>
  description?: InputMaybe<String_Comparison_Exp>
  is_durable?: InputMaybe<Boolean_Comparison_Exp>
  is_nonconcurrent?: InputMaybe<Boolean_Comparison_Exp>
  is_update_data?: InputMaybe<Boolean_Comparison_Exp>
  job_class_name?: InputMaybe<String_Comparison_Exp>
  job_data?: InputMaybe<Bytea_Comparison_Exp>
  job_group?: InputMaybe<String_Comparison_Exp>
  job_name?: InputMaybe<String_Comparison_Exp>
  requests_recovery?: InputMaybe<Boolean_Comparison_Exp>
  sched_name?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "qrtz_job_details" */
export enum Financials_Qrtz_Job_Details_Constraint {
  /** unique or primary key constraint on columns "job_group", "sched_name", "job_name" */
  QrtzJobDetailsPkey = "qrtz_job_details_pkey",
}

/** input type for inserting data into table "qrtz_job_details" */
export type Financials_Qrtz_Job_Details_Insert_Input = {
  description?: InputMaybe<Scalars["String"]["input"]>
  is_durable?: InputMaybe<Scalars["Boolean"]["input"]>
  is_nonconcurrent?: InputMaybe<Scalars["Boolean"]["input"]>
  is_update_data?: InputMaybe<Scalars["Boolean"]["input"]>
  job_class_name?: InputMaybe<Scalars["String"]["input"]>
  job_data?: InputMaybe<Scalars["bytea"]["input"]>
  job_group?: InputMaybe<Scalars["String"]["input"]>
  job_name?: InputMaybe<Scalars["String"]["input"]>
  requests_recovery?: InputMaybe<Scalars["Boolean"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Financials_Qrtz_Job_Details_Max_Fields = {
  __typename?: "financials_qrtz_job_details_max_fields"
  description?: Maybe<Scalars["String"]["output"]>
  job_class_name?: Maybe<Scalars["String"]["output"]>
  job_group?: Maybe<Scalars["String"]["output"]>
  job_name?: Maybe<Scalars["String"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Financials_Qrtz_Job_Details_Min_Fields = {
  __typename?: "financials_qrtz_job_details_min_fields"
  description?: Maybe<Scalars["String"]["output"]>
  job_class_name?: Maybe<Scalars["String"]["output"]>
  job_group?: Maybe<Scalars["String"]["output"]>
  job_name?: Maybe<Scalars["String"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "qrtz_job_details" */
export type Financials_Qrtz_Job_Details_Mutation_Response = {
  __typename?: "financials_qrtz_job_details_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Qrtz_Job_Details>
}

/** on_conflict condition type for table "qrtz_job_details" */
export type Financials_Qrtz_Job_Details_On_Conflict = {
  constraint: Financials_Qrtz_Job_Details_Constraint
  update_columns?: Array<Financials_Qrtz_Job_Details_Update_Column>
  where?: InputMaybe<Financials_Qrtz_Job_Details_Bool_Exp>
}

/** Ordering options when selecting data from "qrtz_job_details". */
export type Financials_Qrtz_Job_Details_Order_By = {
  description?: InputMaybe<Order_By>
  is_durable?: InputMaybe<Order_By>
  is_nonconcurrent?: InputMaybe<Order_By>
  is_update_data?: InputMaybe<Order_By>
  job_class_name?: InputMaybe<Order_By>
  job_data?: InputMaybe<Order_By>
  job_group?: InputMaybe<Order_By>
  job_name?: InputMaybe<Order_By>
  requests_recovery?: InputMaybe<Order_By>
  sched_name?: InputMaybe<Order_By>
}

/** primary key columns input for table: qrtz_job_details */
export type Financials_Qrtz_Job_Details_Pk_Columns_Input = {
  job_group: Scalars["String"]["input"]
  job_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

/** select columns of table "qrtz_job_details" */
export enum Financials_Qrtz_Job_Details_Select_Column {
  /** column name */
  Description = "description",
  /** column name */
  IsDurable = "is_durable",
  /** column name */
  IsNonconcurrent = "is_nonconcurrent",
  /** column name */
  IsUpdateData = "is_update_data",
  /** column name */
  JobClassName = "job_class_name",
  /** column name */
  JobData = "job_data",
  /** column name */
  JobGroup = "job_group",
  /** column name */
  JobName = "job_name",
  /** column name */
  RequestsRecovery = "requests_recovery",
  /** column name */
  SchedName = "sched_name",
}

/** input type for updating data in table "qrtz_job_details" */
export type Financials_Qrtz_Job_Details_Set_Input = {
  description?: InputMaybe<Scalars["String"]["input"]>
  is_durable?: InputMaybe<Scalars["Boolean"]["input"]>
  is_nonconcurrent?: InputMaybe<Scalars["Boolean"]["input"]>
  is_update_data?: InputMaybe<Scalars["Boolean"]["input"]>
  job_class_name?: InputMaybe<Scalars["String"]["input"]>
  job_data?: InputMaybe<Scalars["bytea"]["input"]>
  job_group?: InputMaybe<Scalars["String"]["input"]>
  job_name?: InputMaybe<Scalars["String"]["input"]>
  requests_recovery?: InputMaybe<Scalars["Boolean"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
}

/** Streaming cursor of the table "financials_qrtz_job_details" */
export type Financials_Qrtz_Job_Details_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Qrtz_Job_Details_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Qrtz_Job_Details_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars["String"]["input"]>
  is_durable?: InputMaybe<Scalars["Boolean"]["input"]>
  is_nonconcurrent?: InputMaybe<Scalars["Boolean"]["input"]>
  is_update_data?: InputMaybe<Scalars["Boolean"]["input"]>
  job_class_name?: InputMaybe<Scalars["String"]["input"]>
  job_data?: InputMaybe<Scalars["bytea"]["input"]>
  job_group?: InputMaybe<Scalars["String"]["input"]>
  job_name?: InputMaybe<Scalars["String"]["input"]>
  requests_recovery?: InputMaybe<Scalars["Boolean"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
}

/** update columns of table "qrtz_job_details" */
export enum Financials_Qrtz_Job_Details_Update_Column {
  /** column name */
  Description = "description",
  /** column name */
  IsDurable = "is_durable",
  /** column name */
  IsNonconcurrent = "is_nonconcurrent",
  /** column name */
  IsUpdateData = "is_update_data",
  /** column name */
  JobClassName = "job_class_name",
  /** column name */
  JobData = "job_data",
  /** column name */
  JobGroup = "job_group",
  /** column name */
  JobName = "job_name",
  /** column name */
  RequestsRecovery = "requests_recovery",
  /** column name */
  SchedName = "sched_name",
}

export type Financials_Qrtz_Job_Details_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Qrtz_Job_Details_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Qrtz_Job_Details_Bool_Exp
}

/** columns and relationships of "qrtz_scheduler_state" */
export type Financials_Qrtz_Scheduler_State = {
  __typename?: "financials_qrtz_scheduler_state"
  checkin_interval?: Maybe<Scalars["bigint"]["output"]>
  instance_name: Scalars["String"]["output"]
  last_checkin_time?: Maybe<Scalars["bigint"]["output"]>
  sched_name: Scalars["String"]["output"]
}

/** aggregated selection of "qrtz_scheduler_state" */
export type Financials_Qrtz_Scheduler_State_Aggregate = {
  __typename?: "financials_qrtz_scheduler_state_aggregate"
  aggregate?: Maybe<Financials_Qrtz_Scheduler_State_Aggregate_Fields>
  nodes: Array<Financials_Qrtz_Scheduler_State>
}

/** aggregate fields of "qrtz_scheduler_state" */
export type Financials_Qrtz_Scheduler_State_Aggregate_Fields = {
  __typename?: "financials_qrtz_scheduler_state_aggregate_fields"
  avg?: Maybe<Financials_Qrtz_Scheduler_State_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Qrtz_Scheduler_State_Max_Fields>
  min?: Maybe<Financials_Qrtz_Scheduler_State_Min_Fields>
  stddev?: Maybe<Financials_Qrtz_Scheduler_State_Stddev_Fields>
  stddev_pop?: Maybe<Financials_Qrtz_Scheduler_State_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Financials_Qrtz_Scheduler_State_Stddev_Samp_Fields>
  sum?: Maybe<Financials_Qrtz_Scheduler_State_Sum_Fields>
  var_pop?: Maybe<Financials_Qrtz_Scheduler_State_Var_Pop_Fields>
  var_samp?: Maybe<Financials_Qrtz_Scheduler_State_Var_Samp_Fields>
  variance?: Maybe<Financials_Qrtz_Scheduler_State_Variance_Fields>
}

/** aggregate fields of "qrtz_scheduler_state" */
export type Financials_Qrtz_Scheduler_State_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Financials_Qrtz_Scheduler_State_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Financials_Qrtz_Scheduler_State_Avg_Fields = {
  __typename?: "financials_qrtz_scheduler_state_avg_fields"
  checkin_interval?: Maybe<Scalars["Float"]["output"]>
  last_checkin_time?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "qrtz_scheduler_state". All fields are combined with a logical 'AND'. */
export type Financials_Qrtz_Scheduler_State_Bool_Exp = {
  _and?: InputMaybe<Array<Financials_Qrtz_Scheduler_State_Bool_Exp>>
  _not?: InputMaybe<Financials_Qrtz_Scheduler_State_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Qrtz_Scheduler_State_Bool_Exp>>
  checkin_interval?: InputMaybe<Bigint_Comparison_Exp>
  instance_name?: InputMaybe<String_Comparison_Exp>
  last_checkin_time?: InputMaybe<Bigint_Comparison_Exp>
  sched_name?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "qrtz_scheduler_state" */
export enum Financials_Qrtz_Scheduler_State_Constraint {
  /** unique or primary key constraint on columns "instance_name", "sched_name" */
  QrtzSchedulerStatePkey = "qrtz_scheduler_state_pkey",
}

/** input type for incrementing numeric columns in table "qrtz_scheduler_state" */
export type Financials_Qrtz_Scheduler_State_Inc_Input = {
  checkin_interval?: InputMaybe<Scalars["bigint"]["input"]>
  last_checkin_time?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "qrtz_scheduler_state" */
export type Financials_Qrtz_Scheduler_State_Insert_Input = {
  checkin_interval?: InputMaybe<Scalars["bigint"]["input"]>
  instance_name?: InputMaybe<Scalars["String"]["input"]>
  last_checkin_time?: InputMaybe<Scalars["bigint"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Financials_Qrtz_Scheduler_State_Max_Fields = {
  __typename?: "financials_qrtz_scheduler_state_max_fields"
  checkin_interval?: Maybe<Scalars["bigint"]["output"]>
  instance_name?: Maybe<Scalars["String"]["output"]>
  last_checkin_time?: Maybe<Scalars["bigint"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Financials_Qrtz_Scheduler_State_Min_Fields = {
  __typename?: "financials_qrtz_scheduler_state_min_fields"
  checkin_interval?: Maybe<Scalars["bigint"]["output"]>
  instance_name?: Maybe<Scalars["String"]["output"]>
  last_checkin_time?: Maybe<Scalars["bigint"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "qrtz_scheduler_state" */
export type Financials_Qrtz_Scheduler_State_Mutation_Response = {
  __typename?: "financials_qrtz_scheduler_state_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Qrtz_Scheduler_State>
}

/** on_conflict condition type for table "qrtz_scheduler_state" */
export type Financials_Qrtz_Scheduler_State_On_Conflict = {
  constraint: Financials_Qrtz_Scheduler_State_Constraint
  update_columns?: Array<Financials_Qrtz_Scheduler_State_Update_Column>
  where?: InputMaybe<Financials_Qrtz_Scheduler_State_Bool_Exp>
}

/** Ordering options when selecting data from "qrtz_scheduler_state". */
export type Financials_Qrtz_Scheduler_State_Order_By = {
  checkin_interval?: InputMaybe<Order_By>
  instance_name?: InputMaybe<Order_By>
  last_checkin_time?: InputMaybe<Order_By>
  sched_name?: InputMaybe<Order_By>
}

/** primary key columns input for table: qrtz_scheduler_state */
export type Financials_Qrtz_Scheduler_State_Pk_Columns_Input = {
  instance_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

/** select columns of table "qrtz_scheduler_state" */
export enum Financials_Qrtz_Scheduler_State_Select_Column {
  /** column name */
  CheckinInterval = "checkin_interval",
  /** column name */
  InstanceName = "instance_name",
  /** column name */
  LastCheckinTime = "last_checkin_time",
  /** column name */
  SchedName = "sched_name",
}

/** input type for updating data in table "qrtz_scheduler_state" */
export type Financials_Qrtz_Scheduler_State_Set_Input = {
  checkin_interval?: InputMaybe<Scalars["bigint"]["input"]>
  instance_name?: InputMaybe<Scalars["String"]["input"]>
  last_checkin_time?: InputMaybe<Scalars["bigint"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Financials_Qrtz_Scheduler_State_Stddev_Fields = {
  __typename?: "financials_qrtz_scheduler_state_stddev_fields"
  checkin_interval?: Maybe<Scalars["Float"]["output"]>
  last_checkin_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Financials_Qrtz_Scheduler_State_Stddev_Pop_Fields = {
  __typename?: "financials_qrtz_scheduler_state_stddev_pop_fields"
  checkin_interval?: Maybe<Scalars["Float"]["output"]>
  last_checkin_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Financials_Qrtz_Scheduler_State_Stddev_Samp_Fields = {
  __typename?: "financials_qrtz_scheduler_state_stddev_samp_fields"
  checkin_interval?: Maybe<Scalars["Float"]["output"]>
  last_checkin_time?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "financials_qrtz_scheduler_state" */
export type Financials_Qrtz_Scheduler_State_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Qrtz_Scheduler_State_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Qrtz_Scheduler_State_Stream_Cursor_Value_Input = {
  checkin_interval?: InputMaybe<Scalars["bigint"]["input"]>
  instance_name?: InputMaybe<Scalars["String"]["input"]>
  last_checkin_time?: InputMaybe<Scalars["bigint"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Financials_Qrtz_Scheduler_State_Sum_Fields = {
  __typename?: "financials_qrtz_scheduler_state_sum_fields"
  checkin_interval?: Maybe<Scalars["bigint"]["output"]>
  last_checkin_time?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "qrtz_scheduler_state" */
export enum Financials_Qrtz_Scheduler_State_Update_Column {
  /** column name */
  CheckinInterval = "checkin_interval",
  /** column name */
  InstanceName = "instance_name",
  /** column name */
  LastCheckinTime = "last_checkin_time",
  /** column name */
  SchedName = "sched_name",
}

export type Financials_Qrtz_Scheduler_State_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Financials_Qrtz_Scheduler_State_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Qrtz_Scheduler_State_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Qrtz_Scheduler_State_Bool_Exp
}

/** aggregate var_pop on columns */
export type Financials_Qrtz_Scheduler_State_Var_Pop_Fields = {
  __typename?: "financials_qrtz_scheduler_state_var_pop_fields"
  checkin_interval?: Maybe<Scalars["Float"]["output"]>
  last_checkin_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Financials_Qrtz_Scheduler_State_Var_Samp_Fields = {
  __typename?: "financials_qrtz_scheduler_state_var_samp_fields"
  checkin_interval?: Maybe<Scalars["Float"]["output"]>
  last_checkin_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Financials_Qrtz_Scheduler_State_Variance_Fields = {
  __typename?: "financials_qrtz_scheduler_state_variance_fields"
  checkin_interval?: Maybe<Scalars["Float"]["output"]>
  last_checkin_time?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "qrtz_simple_triggers" */
export type Financials_Qrtz_Simple_Triggers = {
  __typename?: "financials_qrtz_simple_triggers"
  repeat_count: Scalars["bigint"]["output"]
  repeat_interval: Scalars["bigint"]["output"]
  sched_name: Scalars["String"]["output"]
  times_triggered: Scalars["bigint"]["output"]
  trigger_group: Scalars["String"]["output"]
  trigger_name: Scalars["String"]["output"]
}

/** aggregated selection of "qrtz_simple_triggers" */
export type Financials_Qrtz_Simple_Triggers_Aggregate = {
  __typename?: "financials_qrtz_simple_triggers_aggregate"
  aggregate?: Maybe<Financials_Qrtz_Simple_Triggers_Aggregate_Fields>
  nodes: Array<Financials_Qrtz_Simple_Triggers>
}

/** aggregate fields of "qrtz_simple_triggers" */
export type Financials_Qrtz_Simple_Triggers_Aggregate_Fields = {
  __typename?: "financials_qrtz_simple_triggers_aggregate_fields"
  avg?: Maybe<Financials_Qrtz_Simple_Triggers_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Qrtz_Simple_Triggers_Max_Fields>
  min?: Maybe<Financials_Qrtz_Simple_Triggers_Min_Fields>
  stddev?: Maybe<Financials_Qrtz_Simple_Triggers_Stddev_Fields>
  stddev_pop?: Maybe<Financials_Qrtz_Simple_Triggers_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Financials_Qrtz_Simple_Triggers_Stddev_Samp_Fields>
  sum?: Maybe<Financials_Qrtz_Simple_Triggers_Sum_Fields>
  var_pop?: Maybe<Financials_Qrtz_Simple_Triggers_Var_Pop_Fields>
  var_samp?: Maybe<Financials_Qrtz_Simple_Triggers_Var_Samp_Fields>
  variance?: Maybe<Financials_Qrtz_Simple_Triggers_Variance_Fields>
}

/** aggregate fields of "qrtz_simple_triggers" */
export type Financials_Qrtz_Simple_Triggers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Financials_Qrtz_Simple_Triggers_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Financials_Qrtz_Simple_Triggers_Avg_Fields = {
  __typename?: "financials_qrtz_simple_triggers_avg_fields"
  repeat_count?: Maybe<Scalars["Float"]["output"]>
  repeat_interval?: Maybe<Scalars["Float"]["output"]>
  times_triggered?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "qrtz_simple_triggers". All fields are combined with a logical 'AND'. */
export type Financials_Qrtz_Simple_Triggers_Bool_Exp = {
  _and?: InputMaybe<Array<Financials_Qrtz_Simple_Triggers_Bool_Exp>>
  _not?: InputMaybe<Financials_Qrtz_Simple_Triggers_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Qrtz_Simple_Triggers_Bool_Exp>>
  repeat_count?: InputMaybe<Bigint_Comparison_Exp>
  repeat_interval?: InputMaybe<Bigint_Comparison_Exp>
  sched_name?: InputMaybe<String_Comparison_Exp>
  times_triggered?: InputMaybe<Bigint_Comparison_Exp>
  trigger_group?: InputMaybe<String_Comparison_Exp>
  trigger_name?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "qrtz_simple_triggers" */
export enum Financials_Qrtz_Simple_Triggers_Constraint {
  /** unique or primary key constraint on columns "sched_name", "trigger_group", "trigger_name" */
  QrtzSimpleTriggersPkey = "qrtz_simple_triggers_pkey",
}

/** input type for incrementing numeric columns in table "qrtz_simple_triggers" */
export type Financials_Qrtz_Simple_Triggers_Inc_Input = {
  repeat_count?: InputMaybe<Scalars["bigint"]["input"]>
  repeat_interval?: InputMaybe<Scalars["bigint"]["input"]>
  times_triggered?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "qrtz_simple_triggers" */
export type Financials_Qrtz_Simple_Triggers_Insert_Input = {
  repeat_count?: InputMaybe<Scalars["bigint"]["input"]>
  repeat_interval?: InputMaybe<Scalars["bigint"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  times_triggered?: InputMaybe<Scalars["bigint"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Financials_Qrtz_Simple_Triggers_Max_Fields = {
  __typename?: "financials_qrtz_simple_triggers_max_fields"
  repeat_count?: Maybe<Scalars["bigint"]["output"]>
  repeat_interval?: Maybe<Scalars["bigint"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  times_triggered?: Maybe<Scalars["bigint"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Financials_Qrtz_Simple_Triggers_Min_Fields = {
  __typename?: "financials_qrtz_simple_triggers_min_fields"
  repeat_count?: Maybe<Scalars["bigint"]["output"]>
  repeat_interval?: Maybe<Scalars["bigint"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  times_triggered?: Maybe<Scalars["bigint"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "qrtz_simple_triggers" */
export type Financials_Qrtz_Simple_Triggers_Mutation_Response = {
  __typename?: "financials_qrtz_simple_triggers_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Qrtz_Simple_Triggers>
}

/** on_conflict condition type for table "qrtz_simple_triggers" */
export type Financials_Qrtz_Simple_Triggers_On_Conflict = {
  constraint: Financials_Qrtz_Simple_Triggers_Constraint
  update_columns?: Array<Financials_Qrtz_Simple_Triggers_Update_Column>
  where?: InputMaybe<Financials_Qrtz_Simple_Triggers_Bool_Exp>
}

/** Ordering options when selecting data from "qrtz_simple_triggers". */
export type Financials_Qrtz_Simple_Triggers_Order_By = {
  repeat_count?: InputMaybe<Order_By>
  repeat_interval?: InputMaybe<Order_By>
  sched_name?: InputMaybe<Order_By>
  times_triggered?: InputMaybe<Order_By>
  trigger_group?: InputMaybe<Order_By>
  trigger_name?: InputMaybe<Order_By>
}

/** primary key columns input for table: qrtz_simple_triggers */
export type Financials_Qrtz_Simple_Triggers_Pk_Columns_Input = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

/** select columns of table "qrtz_simple_triggers" */
export enum Financials_Qrtz_Simple_Triggers_Select_Column {
  /** column name */
  RepeatCount = "repeat_count",
  /** column name */
  RepeatInterval = "repeat_interval",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  TimesTriggered = "times_triggered",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
}

/** input type for updating data in table "qrtz_simple_triggers" */
export type Financials_Qrtz_Simple_Triggers_Set_Input = {
  repeat_count?: InputMaybe<Scalars["bigint"]["input"]>
  repeat_interval?: InputMaybe<Scalars["bigint"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  times_triggered?: InputMaybe<Scalars["bigint"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Financials_Qrtz_Simple_Triggers_Stddev_Fields = {
  __typename?: "financials_qrtz_simple_triggers_stddev_fields"
  repeat_count?: Maybe<Scalars["Float"]["output"]>
  repeat_interval?: Maybe<Scalars["Float"]["output"]>
  times_triggered?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Financials_Qrtz_Simple_Triggers_Stddev_Pop_Fields = {
  __typename?: "financials_qrtz_simple_triggers_stddev_pop_fields"
  repeat_count?: Maybe<Scalars["Float"]["output"]>
  repeat_interval?: Maybe<Scalars["Float"]["output"]>
  times_triggered?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Financials_Qrtz_Simple_Triggers_Stddev_Samp_Fields = {
  __typename?: "financials_qrtz_simple_triggers_stddev_samp_fields"
  repeat_count?: Maybe<Scalars["Float"]["output"]>
  repeat_interval?: Maybe<Scalars["Float"]["output"]>
  times_triggered?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "financials_qrtz_simple_triggers" */
export type Financials_Qrtz_Simple_Triggers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Qrtz_Simple_Triggers_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Qrtz_Simple_Triggers_Stream_Cursor_Value_Input = {
  repeat_count?: InputMaybe<Scalars["bigint"]["input"]>
  repeat_interval?: InputMaybe<Scalars["bigint"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  times_triggered?: InputMaybe<Scalars["bigint"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Financials_Qrtz_Simple_Triggers_Sum_Fields = {
  __typename?: "financials_qrtz_simple_triggers_sum_fields"
  repeat_count?: Maybe<Scalars["bigint"]["output"]>
  repeat_interval?: Maybe<Scalars["bigint"]["output"]>
  times_triggered?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "qrtz_simple_triggers" */
export enum Financials_Qrtz_Simple_Triggers_Update_Column {
  /** column name */
  RepeatCount = "repeat_count",
  /** column name */
  RepeatInterval = "repeat_interval",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  TimesTriggered = "times_triggered",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
}

export type Financials_Qrtz_Simple_Triggers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Financials_Qrtz_Simple_Triggers_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Qrtz_Simple_Triggers_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Qrtz_Simple_Triggers_Bool_Exp
}

/** aggregate var_pop on columns */
export type Financials_Qrtz_Simple_Triggers_Var_Pop_Fields = {
  __typename?: "financials_qrtz_simple_triggers_var_pop_fields"
  repeat_count?: Maybe<Scalars["Float"]["output"]>
  repeat_interval?: Maybe<Scalars["Float"]["output"]>
  times_triggered?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Financials_Qrtz_Simple_Triggers_Var_Samp_Fields = {
  __typename?: "financials_qrtz_simple_triggers_var_samp_fields"
  repeat_count?: Maybe<Scalars["Float"]["output"]>
  repeat_interval?: Maybe<Scalars["Float"]["output"]>
  times_triggered?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Financials_Qrtz_Simple_Triggers_Variance_Fields = {
  __typename?: "financials_qrtz_simple_triggers_variance_fields"
  repeat_count?: Maybe<Scalars["Float"]["output"]>
  repeat_interval?: Maybe<Scalars["Float"]["output"]>
  times_triggered?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "qrtz_simprop_triggers" */
export type Financials_Qrtz_Simprop_Triggers = {
  __typename?: "financials_qrtz_simprop_triggers"
  bool_prop_1?: Maybe<Scalars["Boolean"]["output"]>
  bool_prop_2?: Maybe<Scalars["Boolean"]["output"]>
  dec_prop_1?: Maybe<Scalars["numeric"]["output"]>
  dec_prop_2?: Maybe<Scalars["numeric"]["output"]>
  int_prop_1?: Maybe<Scalars["Int"]["output"]>
  int_prop_2?: Maybe<Scalars["Int"]["output"]>
  long_prop_1?: Maybe<Scalars["bigint"]["output"]>
  long_prop_2?: Maybe<Scalars["bigint"]["output"]>
  sched_name: Scalars["String"]["output"]
  str_prop_1?: Maybe<Scalars["String"]["output"]>
  str_prop_2?: Maybe<Scalars["String"]["output"]>
  str_prop_3?: Maybe<Scalars["String"]["output"]>
  trigger_group: Scalars["String"]["output"]
  trigger_name: Scalars["String"]["output"]
}

/** aggregated selection of "qrtz_simprop_triggers" */
export type Financials_Qrtz_Simprop_Triggers_Aggregate = {
  __typename?: "financials_qrtz_simprop_triggers_aggregate"
  aggregate?: Maybe<Financials_Qrtz_Simprop_Triggers_Aggregate_Fields>
  nodes: Array<Financials_Qrtz_Simprop_Triggers>
}

/** aggregate fields of "qrtz_simprop_triggers" */
export type Financials_Qrtz_Simprop_Triggers_Aggregate_Fields = {
  __typename?: "financials_qrtz_simprop_triggers_aggregate_fields"
  avg?: Maybe<Financials_Qrtz_Simprop_Triggers_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Qrtz_Simprop_Triggers_Max_Fields>
  min?: Maybe<Financials_Qrtz_Simprop_Triggers_Min_Fields>
  stddev?: Maybe<Financials_Qrtz_Simprop_Triggers_Stddev_Fields>
  stddev_pop?: Maybe<Financials_Qrtz_Simprop_Triggers_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Financials_Qrtz_Simprop_Triggers_Stddev_Samp_Fields>
  sum?: Maybe<Financials_Qrtz_Simprop_Triggers_Sum_Fields>
  var_pop?: Maybe<Financials_Qrtz_Simprop_Triggers_Var_Pop_Fields>
  var_samp?: Maybe<Financials_Qrtz_Simprop_Triggers_Var_Samp_Fields>
  variance?: Maybe<Financials_Qrtz_Simprop_Triggers_Variance_Fields>
}

/** aggregate fields of "qrtz_simprop_triggers" */
export type Financials_Qrtz_Simprop_Triggers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Financials_Qrtz_Simprop_Triggers_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Financials_Qrtz_Simprop_Triggers_Avg_Fields = {
  __typename?: "financials_qrtz_simprop_triggers_avg_fields"
  dec_prop_1?: Maybe<Scalars["Float"]["output"]>
  dec_prop_2?: Maybe<Scalars["Float"]["output"]>
  int_prop_1?: Maybe<Scalars["Float"]["output"]>
  int_prop_2?: Maybe<Scalars["Float"]["output"]>
  long_prop_1?: Maybe<Scalars["Float"]["output"]>
  long_prop_2?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "qrtz_simprop_triggers". All fields are combined with a logical 'AND'. */
export type Financials_Qrtz_Simprop_Triggers_Bool_Exp = {
  _and?: InputMaybe<Array<Financials_Qrtz_Simprop_Triggers_Bool_Exp>>
  _not?: InputMaybe<Financials_Qrtz_Simprop_Triggers_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Qrtz_Simprop_Triggers_Bool_Exp>>
  bool_prop_1?: InputMaybe<Boolean_Comparison_Exp>
  bool_prop_2?: InputMaybe<Boolean_Comparison_Exp>
  dec_prop_1?: InputMaybe<Numeric_Comparison_Exp>
  dec_prop_2?: InputMaybe<Numeric_Comparison_Exp>
  int_prop_1?: InputMaybe<Int_Comparison_Exp>
  int_prop_2?: InputMaybe<Int_Comparison_Exp>
  long_prop_1?: InputMaybe<Bigint_Comparison_Exp>
  long_prop_2?: InputMaybe<Bigint_Comparison_Exp>
  sched_name?: InputMaybe<String_Comparison_Exp>
  str_prop_1?: InputMaybe<String_Comparison_Exp>
  str_prop_2?: InputMaybe<String_Comparison_Exp>
  str_prop_3?: InputMaybe<String_Comparison_Exp>
  trigger_group?: InputMaybe<String_Comparison_Exp>
  trigger_name?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "qrtz_simprop_triggers" */
export enum Financials_Qrtz_Simprop_Triggers_Constraint {
  /** unique or primary key constraint on columns "sched_name", "trigger_group", "trigger_name" */
  QrtzSimpropTriggersPkey = "qrtz_simprop_triggers_pkey",
}

/** input type for incrementing numeric columns in table "qrtz_simprop_triggers" */
export type Financials_Qrtz_Simprop_Triggers_Inc_Input = {
  dec_prop_1?: InputMaybe<Scalars["numeric"]["input"]>
  dec_prop_2?: InputMaybe<Scalars["numeric"]["input"]>
  int_prop_1?: InputMaybe<Scalars["Int"]["input"]>
  int_prop_2?: InputMaybe<Scalars["Int"]["input"]>
  long_prop_1?: InputMaybe<Scalars["bigint"]["input"]>
  long_prop_2?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "qrtz_simprop_triggers" */
export type Financials_Qrtz_Simprop_Triggers_Insert_Input = {
  bool_prop_1?: InputMaybe<Scalars["Boolean"]["input"]>
  bool_prop_2?: InputMaybe<Scalars["Boolean"]["input"]>
  dec_prop_1?: InputMaybe<Scalars["numeric"]["input"]>
  dec_prop_2?: InputMaybe<Scalars["numeric"]["input"]>
  int_prop_1?: InputMaybe<Scalars["Int"]["input"]>
  int_prop_2?: InputMaybe<Scalars["Int"]["input"]>
  long_prop_1?: InputMaybe<Scalars["bigint"]["input"]>
  long_prop_2?: InputMaybe<Scalars["bigint"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  str_prop_1?: InputMaybe<Scalars["String"]["input"]>
  str_prop_2?: InputMaybe<Scalars["String"]["input"]>
  str_prop_3?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Financials_Qrtz_Simprop_Triggers_Max_Fields = {
  __typename?: "financials_qrtz_simprop_triggers_max_fields"
  dec_prop_1?: Maybe<Scalars["numeric"]["output"]>
  dec_prop_2?: Maybe<Scalars["numeric"]["output"]>
  int_prop_1?: Maybe<Scalars["Int"]["output"]>
  int_prop_2?: Maybe<Scalars["Int"]["output"]>
  long_prop_1?: Maybe<Scalars["bigint"]["output"]>
  long_prop_2?: Maybe<Scalars["bigint"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  str_prop_1?: Maybe<Scalars["String"]["output"]>
  str_prop_2?: Maybe<Scalars["String"]["output"]>
  str_prop_3?: Maybe<Scalars["String"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Financials_Qrtz_Simprop_Triggers_Min_Fields = {
  __typename?: "financials_qrtz_simprop_triggers_min_fields"
  dec_prop_1?: Maybe<Scalars["numeric"]["output"]>
  dec_prop_2?: Maybe<Scalars["numeric"]["output"]>
  int_prop_1?: Maybe<Scalars["Int"]["output"]>
  int_prop_2?: Maybe<Scalars["Int"]["output"]>
  long_prop_1?: Maybe<Scalars["bigint"]["output"]>
  long_prop_2?: Maybe<Scalars["bigint"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  str_prop_1?: Maybe<Scalars["String"]["output"]>
  str_prop_2?: Maybe<Scalars["String"]["output"]>
  str_prop_3?: Maybe<Scalars["String"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "qrtz_simprop_triggers" */
export type Financials_Qrtz_Simprop_Triggers_Mutation_Response = {
  __typename?: "financials_qrtz_simprop_triggers_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Qrtz_Simprop_Triggers>
}

/** on_conflict condition type for table "qrtz_simprop_triggers" */
export type Financials_Qrtz_Simprop_Triggers_On_Conflict = {
  constraint: Financials_Qrtz_Simprop_Triggers_Constraint
  update_columns?: Array<Financials_Qrtz_Simprop_Triggers_Update_Column>
  where?: InputMaybe<Financials_Qrtz_Simprop_Triggers_Bool_Exp>
}

/** Ordering options when selecting data from "qrtz_simprop_triggers". */
export type Financials_Qrtz_Simprop_Triggers_Order_By = {
  bool_prop_1?: InputMaybe<Order_By>
  bool_prop_2?: InputMaybe<Order_By>
  dec_prop_1?: InputMaybe<Order_By>
  dec_prop_2?: InputMaybe<Order_By>
  int_prop_1?: InputMaybe<Order_By>
  int_prop_2?: InputMaybe<Order_By>
  long_prop_1?: InputMaybe<Order_By>
  long_prop_2?: InputMaybe<Order_By>
  sched_name?: InputMaybe<Order_By>
  str_prop_1?: InputMaybe<Order_By>
  str_prop_2?: InputMaybe<Order_By>
  str_prop_3?: InputMaybe<Order_By>
  trigger_group?: InputMaybe<Order_By>
  trigger_name?: InputMaybe<Order_By>
}

/** primary key columns input for table: qrtz_simprop_triggers */
export type Financials_Qrtz_Simprop_Triggers_Pk_Columns_Input = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

/** select columns of table "qrtz_simprop_triggers" */
export enum Financials_Qrtz_Simprop_Triggers_Select_Column {
  /** column name */
  BoolProp_1 = "bool_prop_1",
  /** column name */
  BoolProp_2 = "bool_prop_2",
  /** column name */
  DecProp_1 = "dec_prop_1",
  /** column name */
  DecProp_2 = "dec_prop_2",
  /** column name */
  IntProp_1 = "int_prop_1",
  /** column name */
  IntProp_2 = "int_prop_2",
  /** column name */
  LongProp_1 = "long_prop_1",
  /** column name */
  LongProp_2 = "long_prop_2",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  StrProp_1 = "str_prop_1",
  /** column name */
  StrProp_2 = "str_prop_2",
  /** column name */
  StrProp_3 = "str_prop_3",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
}

/** input type for updating data in table "qrtz_simprop_triggers" */
export type Financials_Qrtz_Simprop_Triggers_Set_Input = {
  bool_prop_1?: InputMaybe<Scalars["Boolean"]["input"]>
  bool_prop_2?: InputMaybe<Scalars["Boolean"]["input"]>
  dec_prop_1?: InputMaybe<Scalars["numeric"]["input"]>
  dec_prop_2?: InputMaybe<Scalars["numeric"]["input"]>
  int_prop_1?: InputMaybe<Scalars["Int"]["input"]>
  int_prop_2?: InputMaybe<Scalars["Int"]["input"]>
  long_prop_1?: InputMaybe<Scalars["bigint"]["input"]>
  long_prop_2?: InputMaybe<Scalars["bigint"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  str_prop_1?: InputMaybe<Scalars["String"]["input"]>
  str_prop_2?: InputMaybe<Scalars["String"]["input"]>
  str_prop_3?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Financials_Qrtz_Simprop_Triggers_Stddev_Fields = {
  __typename?: "financials_qrtz_simprop_triggers_stddev_fields"
  dec_prop_1?: Maybe<Scalars["Float"]["output"]>
  dec_prop_2?: Maybe<Scalars["Float"]["output"]>
  int_prop_1?: Maybe<Scalars["Float"]["output"]>
  int_prop_2?: Maybe<Scalars["Float"]["output"]>
  long_prop_1?: Maybe<Scalars["Float"]["output"]>
  long_prop_2?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Financials_Qrtz_Simprop_Triggers_Stddev_Pop_Fields = {
  __typename?: "financials_qrtz_simprop_triggers_stddev_pop_fields"
  dec_prop_1?: Maybe<Scalars["Float"]["output"]>
  dec_prop_2?: Maybe<Scalars["Float"]["output"]>
  int_prop_1?: Maybe<Scalars["Float"]["output"]>
  int_prop_2?: Maybe<Scalars["Float"]["output"]>
  long_prop_1?: Maybe<Scalars["Float"]["output"]>
  long_prop_2?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Financials_Qrtz_Simprop_Triggers_Stddev_Samp_Fields = {
  __typename?: "financials_qrtz_simprop_triggers_stddev_samp_fields"
  dec_prop_1?: Maybe<Scalars["Float"]["output"]>
  dec_prop_2?: Maybe<Scalars["Float"]["output"]>
  int_prop_1?: Maybe<Scalars["Float"]["output"]>
  int_prop_2?: Maybe<Scalars["Float"]["output"]>
  long_prop_1?: Maybe<Scalars["Float"]["output"]>
  long_prop_2?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "financials_qrtz_simprop_triggers" */
export type Financials_Qrtz_Simprop_Triggers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Qrtz_Simprop_Triggers_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Qrtz_Simprop_Triggers_Stream_Cursor_Value_Input = {
  bool_prop_1?: InputMaybe<Scalars["Boolean"]["input"]>
  bool_prop_2?: InputMaybe<Scalars["Boolean"]["input"]>
  dec_prop_1?: InputMaybe<Scalars["numeric"]["input"]>
  dec_prop_2?: InputMaybe<Scalars["numeric"]["input"]>
  int_prop_1?: InputMaybe<Scalars["Int"]["input"]>
  int_prop_2?: InputMaybe<Scalars["Int"]["input"]>
  long_prop_1?: InputMaybe<Scalars["bigint"]["input"]>
  long_prop_2?: InputMaybe<Scalars["bigint"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  str_prop_1?: InputMaybe<Scalars["String"]["input"]>
  str_prop_2?: InputMaybe<Scalars["String"]["input"]>
  str_prop_3?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Financials_Qrtz_Simprop_Triggers_Sum_Fields = {
  __typename?: "financials_qrtz_simprop_triggers_sum_fields"
  dec_prop_1?: Maybe<Scalars["numeric"]["output"]>
  dec_prop_2?: Maybe<Scalars["numeric"]["output"]>
  int_prop_1?: Maybe<Scalars["Int"]["output"]>
  int_prop_2?: Maybe<Scalars["Int"]["output"]>
  long_prop_1?: Maybe<Scalars["bigint"]["output"]>
  long_prop_2?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "qrtz_simprop_triggers" */
export enum Financials_Qrtz_Simprop_Triggers_Update_Column {
  /** column name */
  BoolProp_1 = "bool_prop_1",
  /** column name */
  BoolProp_2 = "bool_prop_2",
  /** column name */
  DecProp_1 = "dec_prop_1",
  /** column name */
  DecProp_2 = "dec_prop_2",
  /** column name */
  IntProp_1 = "int_prop_1",
  /** column name */
  IntProp_2 = "int_prop_2",
  /** column name */
  LongProp_1 = "long_prop_1",
  /** column name */
  LongProp_2 = "long_prop_2",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  StrProp_1 = "str_prop_1",
  /** column name */
  StrProp_2 = "str_prop_2",
  /** column name */
  StrProp_3 = "str_prop_3",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
}

export type Financials_Qrtz_Simprop_Triggers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Financials_Qrtz_Simprop_Triggers_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Qrtz_Simprop_Triggers_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Qrtz_Simprop_Triggers_Bool_Exp
}

/** aggregate var_pop on columns */
export type Financials_Qrtz_Simprop_Triggers_Var_Pop_Fields = {
  __typename?: "financials_qrtz_simprop_triggers_var_pop_fields"
  dec_prop_1?: Maybe<Scalars["Float"]["output"]>
  dec_prop_2?: Maybe<Scalars["Float"]["output"]>
  int_prop_1?: Maybe<Scalars["Float"]["output"]>
  int_prop_2?: Maybe<Scalars["Float"]["output"]>
  long_prop_1?: Maybe<Scalars["Float"]["output"]>
  long_prop_2?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Financials_Qrtz_Simprop_Triggers_Var_Samp_Fields = {
  __typename?: "financials_qrtz_simprop_triggers_var_samp_fields"
  dec_prop_1?: Maybe<Scalars["Float"]["output"]>
  dec_prop_2?: Maybe<Scalars["Float"]["output"]>
  int_prop_1?: Maybe<Scalars["Float"]["output"]>
  int_prop_2?: Maybe<Scalars["Float"]["output"]>
  long_prop_1?: Maybe<Scalars["Float"]["output"]>
  long_prop_2?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Financials_Qrtz_Simprop_Triggers_Variance_Fields = {
  __typename?: "financials_qrtz_simprop_triggers_variance_fields"
  dec_prop_1?: Maybe<Scalars["Float"]["output"]>
  dec_prop_2?: Maybe<Scalars["Float"]["output"]>
  int_prop_1?: Maybe<Scalars["Float"]["output"]>
  int_prop_2?: Maybe<Scalars["Float"]["output"]>
  long_prop_1?: Maybe<Scalars["Float"]["output"]>
  long_prop_2?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "qrtz_triggers" */
export type Financials_Qrtz_Triggers = {
  __typename?: "financials_qrtz_triggers"
  calendar_name?: Maybe<Scalars["String"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  end_time?: Maybe<Scalars["bigint"]["output"]>
  job_data?: Maybe<Scalars["bytea"]["output"]>
  job_group: Scalars["String"]["output"]
  job_name: Scalars["String"]["output"]
  misfire_instr?: Maybe<Scalars["smallint"]["output"]>
  next_fire_time?: Maybe<Scalars["bigint"]["output"]>
  prev_fire_time?: Maybe<Scalars["bigint"]["output"]>
  priority?: Maybe<Scalars["Int"]["output"]>
  sched_name: Scalars["String"]["output"]
  start_time: Scalars["bigint"]["output"]
  trigger_group: Scalars["String"]["output"]
  trigger_name: Scalars["String"]["output"]
  trigger_state: Scalars["String"]["output"]
  trigger_type: Scalars["String"]["output"]
}

/** aggregated selection of "qrtz_triggers" */
export type Financials_Qrtz_Triggers_Aggregate = {
  __typename?: "financials_qrtz_triggers_aggregate"
  aggregate?: Maybe<Financials_Qrtz_Triggers_Aggregate_Fields>
  nodes: Array<Financials_Qrtz_Triggers>
}

/** aggregate fields of "qrtz_triggers" */
export type Financials_Qrtz_Triggers_Aggregate_Fields = {
  __typename?: "financials_qrtz_triggers_aggregate_fields"
  avg?: Maybe<Financials_Qrtz_Triggers_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Qrtz_Triggers_Max_Fields>
  min?: Maybe<Financials_Qrtz_Triggers_Min_Fields>
  stddev?: Maybe<Financials_Qrtz_Triggers_Stddev_Fields>
  stddev_pop?: Maybe<Financials_Qrtz_Triggers_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Financials_Qrtz_Triggers_Stddev_Samp_Fields>
  sum?: Maybe<Financials_Qrtz_Triggers_Sum_Fields>
  var_pop?: Maybe<Financials_Qrtz_Triggers_Var_Pop_Fields>
  var_samp?: Maybe<Financials_Qrtz_Triggers_Var_Samp_Fields>
  variance?: Maybe<Financials_Qrtz_Triggers_Variance_Fields>
}

/** aggregate fields of "qrtz_triggers" */
export type Financials_Qrtz_Triggers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Financials_Qrtz_Triggers_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Financials_Qrtz_Triggers_Avg_Fields = {
  __typename?: "financials_qrtz_triggers_avg_fields"
  end_time?: Maybe<Scalars["Float"]["output"]>
  misfire_instr?: Maybe<Scalars["Float"]["output"]>
  next_fire_time?: Maybe<Scalars["Float"]["output"]>
  prev_fire_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  start_time?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "qrtz_triggers". All fields are combined with a logical 'AND'. */
export type Financials_Qrtz_Triggers_Bool_Exp = {
  _and?: InputMaybe<Array<Financials_Qrtz_Triggers_Bool_Exp>>
  _not?: InputMaybe<Financials_Qrtz_Triggers_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Qrtz_Triggers_Bool_Exp>>
  calendar_name?: InputMaybe<String_Comparison_Exp>
  description?: InputMaybe<String_Comparison_Exp>
  end_time?: InputMaybe<Bigint_Comparison_Exp>
  job_data?: InputMaybe<Bytea_Comparison_Exp>
  job_group?: InputMaybe<String_Comparison_Exp>
  job_name?: InputMaybe<String_Comparison_Exp>
  misfire_instr?: InputMaybe<Smallint_Comparison_Exp>
  next_fire_time?: InputMaybe<Bigint_Comparison_Exp>
  prev_fire_time?: InputMaybe<Bigint_Comparison_Exp>
  priority?: InputMaybe<Int_Comparison_Exp>
  sched_name?: InputMaybe<String_Comparison_Exp>
  start_time?: InputMaybe<Bigint_Comparison_Exp>
  trigger_group?: InputMaybe<String_Comparison_Exp>
  trigger_name?: InputMaybe<String_Comparison_Exp>
  trigger_state?: InputMaybe<String_Comparison_Exp>
  trigger_type?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "qrtz_triggers" */
export enum Financials_Qrtz_Triggers_Constraint {
  /** unique or primary key constraint on columns "sched_name", "trigger_group", "trigger_name" */
  QrtzTriggersPkey = "qrtz_triggers_pkey",
}

/** input type for incrementing numeric columns in table "qrtz_triggers" */
export type Financials_Qrtz_Triggers_Inc_Input = {
  end_time?: InputMaybe<Scalars["bigint"]["input"]>
  misfire_instr?: InputMaybe<Scalars["smallint"]["input"]>
  next_fire_time?: InputMaybe<Scalars["bigint"]["input"]>
  prev_fire_time?: InputMaybe<Scalars["bigint"]["input"]>
  priority?: InputMaybe<Scalars["Int"]["input"]>
  start_time?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "qrtz_triggers" */
export type Financials_Qrtz_Triggers_Insert_Input = {
  calendar_name?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  end_time?: InputMaybe<Scalars["bigint"]["input"]>
  job_data?: InputMaybe<Scalars["bytea"]["input"]>
  job_group?: InputMaybe<Scalars["String"]["input"]>
  job_name?: InputMaybe<Scalars["String"]["input"]>
  misfire_instr?: InputMaybe<Scalars["smallint"]["input"]>
  next_fire_time?: InputMaybe<Scalars["bigint"]["input"]>
  prev_fire_time?: InputMaybe<Scalars["bigint"]["input"]>
  priority?: InputMaybe<Scalars["Int"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  start_time?: InputMaybe<Scalars["bigint"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
  trigger_state?: InputMaybe<Scalars["String"]["input"]>
  trigger_type?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Financials_Qrtz_Triggers_Max_Fields = {
  __typename?: "financials_qrtz_triggers_max_fields"
  calendar_name?: Maybe<Scalars["String"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  end_time?: Maybe<Scalars["bigint"]["output"]>
  job_group?: Maybe<Scalars["String"]["output"]>
  job_name?: Maybe<Scalars["String"]["output"]>
  misfire_instr?: Maybe<Scalars["smallint"]["output"]>
  next_fire_time?: Maybe<Scalars["bigint"]["output"]>
  prev_fire_time?: Maybe<Scalars["bigint"]["output"]>
  priority?: Maybe<Scalars["Int"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  start_time?: Maybe<Scalars["bigint"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
  trigger_state?: Maybe<Scalars["String"]["output"]>
  trigger_type?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Financials_Qrtz_Triggers_Min_Fields = {
  __typename?: "financials_qrtz_triggers_min_fields"
  calendar_name?: Maybe<Scalars["String"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  end_time?: Maybe<Scalars["bigint"]["output"]>
  job_group?: Maybe<Scalars["String"]["output"]>
  job_name?: Maybe<Scalars["String"]["output"]>
  misfire_instr?: Maybe<Scalars["smallint"]["output"]>
  next_fire_time?: Maybe<Scalars["bigint"]["output"]>
  prev_fire_time?: Maybe<Scalars["bigint"]["output"]>
  priority?: Maybe<Scalars["Int"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  start_time?: Maybe<Scalars["bigint"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
  trigger_state?: Maybe<Scalars["String"]["output"]>
  trigger_type?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "qrtz_triggers" */
export type Financials_Qrtz_Triggers_Mutation_Response = {
  __typename?: "financials_qrtz_triggers_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Qrtz_Triggers>
}

/** on_conflict condition type for table "qrtz_triggers" */
export type Financials_Qrtz_Triggers_On_Conflict = {
  constraint: Financials_Qrtz_Triggers_Constraint
  update_columns?: Array<Financials_Qrtz_Triggers_Update_Column>
  where?: InputMaybe<Financials_Qrtz_Triggers_Bool_Exp>
}

/** Ordering options when selecting data from "qrtz_triggers". */
export type Financials_Qrtz_Triggers_Order_By = {
  calendar_name?: InputMaybe<Order_By>
  description?: InputMaybe<Order_By>
  end_time?: InputMaybe<Order_By>
  job_data?: InputMaybe<Order_By>
  job_group?: InputMaybe<Order_By>
  job_name?: InputMaybe<Order_By>
  misfire_instr?: InputMaybe<Order_By>
  next_fire_time?: InputMaybe<Order_By>
  prev_fire_time?: InputMaybe<Order_By>
  priority?: InputMaybe<Order_By>
  sched_name?: InputMaybe<Order_By>
  start_time?: InputMaybe<Order_By>
  trigger_group?: InputMaybe<Order_By>
  trigger_name?: InputMaybe<Order_By>
  trigger_state?: InputMaybe<Order_By>
  trigger_type?: InputMaybe<Order_By>
}

/** primary key columns input for table: qrtz_triggers */
export type Financials_Qrtz_Triggers_Pk_Columns_Input = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

/** select columns of table "qrtz_triggers" */
export enum Financials_Qrtz_Triggers_Select_Column {
  /** column name */
  CalendarName = "calendar_name",
  /** column name */
  Description = "description",
  /** column name */
  EndTime = "end_time",
  /** column name */
  JobData = "job_data",
  /** column name */
  JobGroup = "job_group",
  /** column name */
  JobName = "job_name",
  /** column name */
  MisfireInstr = "misfire_instr",
  /** column name */
  NextFireTime = "next_fire_time",
  /** column name */
  PrevFireTime = "prev_fire_time",
  /** column name */
  Priority = "priority",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  StartTime = "start_time",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
  /** column name */
  TriggerState = "trigger_state",
  /** column name */
  TriggerType = "trigger_type",
}

/** input type for updating data in table "qrtz_triggers" */
export type Financials_Qrtz_Triggers_Set_Input = {
  calendar_name?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  end_time?: InputMaybe<Scalars["bigint"]["input"]>
  job_data?: InputMaybe<Scalars["bytea"]["input"]>
  job_group?: InputMaybe<Scalars["String"]["input"]>
  job_name?: InputMaybe<Scalars["String"]["input"]>
  misfire_instr?: InputMaybe<Scalars["smallint"]["input"]>
  next_fire_time?: InputMaybe<Scalars["bigint"]["input"]>
  prev_fire_time?: InputMaybe<Scalars["bigint"]["input"]>
  priority?: InputMaybe<Scalars["Int"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  start_time?: InputMaybe<Scalars["bigint"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
  trigger_state?: InputMaybe<Scalars["String"]["input"]>
  trigger_type?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Financials_Qrtz_Triggers_Stddev_Fields = {
  __typename?: "financials_qrtz_triggers_stddev_fields"
  end_time?: Maybe<Scalars["Float"]["output"]>
  misfire_instr?: Maybe<Scalars["Float"]["output"]>
  next_fire_time?: Maybe<Scalars["Float"]["output"]>
  prev_fire_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  start_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Financials_Qrtz_Triggers_Stddev_Pop_Fields = {
  __typename?: "financials_qrtz_triggers_stddev_pop_fields"
  end_time?: Maybe<Scalars["Float"]["output"]>
  misfire_instr?: Maybe<Scalars["Float"]["output"]>
  next_fire_time?: Maybe<Scalars["Float"]["output"]>
  prev_fire_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  start_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Financials_Qrtz_Triggers_Stddev_Samp_Fields = {
  __typename?: "financials_qrtz_triggers_stddev_samp_fields"
  end_time?: Maybe<Scalars["Float"]["output"]>
  misfire_instr?: Maybe<Scalars["Float"]["output"]>
  next_fire_time?: Maybe<Scalars["Float"]["output"]>
  prev_fire_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  start_time?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "financials_qrtz_triggers" */
export type Financials_Qrtz_Triggers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Qrtz_Triggers_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Qrtz_Triggers_Stream_Cursor_Value_Input = {
  calendar_name?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  end_time?: InputMaybe<Scalars["bigint"]["input"]>
  job_data?: InputMaybe<Scalars["bytea"]["input"]>
  job_group?: InputMaybe<Scalars["String"]["input"]>
  job_name?: InputMaybe<Scalars["String"]["input"]>
  misfire_instr?: InputMaybe<Scalars["smallint"]["input"]>
  next_fire_time?: InputMaybe<Scalars["bigint"]["input"]>
  prev_fire_time?: InputMaybe<Scalars["bigint"]["input"]>
  priority?: InputMaybe<Scalars["Int"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  start_time?: InputMaybe<Scalars["bigint"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
  trigger_state?: InputMaybe<Scalars["String"]["input"]>
  trigger_type?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Financials_Qrtz_Triggers_Sum_Fields = {
  __typename?: "financials_qrtz_triggers_sum_fields"
  end_time?: Maybe<Scalars["bigint"]["output"]>
  misfire_instr?: Maybe<Scalars["smallint"]["output"]>
  next_fire_time?: Maybe<Scalars["bigint"]["output"]>
  prev_fire_time?: Maybe<Scalars["bigint"]["output"]>
  priority?: Maybe<Scalars["Int"]["output"]>
  start_time?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "qrtz_triggers" */
export enum Financials_Qrtz_Triggers_Update_Column {
  /** column name */
  CalendarName = "calendar_name",
  /** column name */
  Description = "description",
  /** column name */
  EndTime = "end_time",
  /** column name */
  JobData = "job_data",
  /** column name */
  JobGroup = "job_group",
  /** column name */
  JobName = "job_name",
  /** column name */
  MisfireInstr = "misfire_instr",
  /** column name */
  NextFireTime = "next_fire_time",
  /** column name */
  PrevFireTime = "prev_fire_time",
  /** column name */
  Priority = "priority",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  StartTime = "start_time",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
  /** column name */
  TriggerState = "trigger_state",
  /** column name */
  TriggerType = "trigger_type",
}

export type Financials_Qrtz_Triggers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Financials_Qrtz_Triggers_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Qrtz_Triggers_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Qrtz_Triggers_Bool_Exp
}

/** aggregate var_pop on columns */
export type Financials_Qrtz_Triggers_Var_Pop_Fields = {
  __typename?: "financials_qrtz_triggers_var_pop_fields"
  end_time?: Maybe<Scalars["Float"]["output"]>
  misfire_instr?: Maybe<Scalars["Float"]["output"]>
  next_fire_time?: Maybe<Scalars["Float"]["output"]>
  prev_fire_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  start_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Financials_Qrtz_Triggers_Var_Samp_Fields = {
  __typename?: "financials_qrtz_triggers_var_samp_fields"
  end_time?: Maybe<Scalars["Float"]["output"]>
  misfire_instr?: Maybe<Scalars["Float"]["output"]>
  next_fire_time?: Maybe<Scalars["Float"]["output"]>
  prev_fire_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  start_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Financials_Qrtz_Triggers_Variance_Fields = {
  __typename?: "financials_qrtz_triggers_variance_fields"
  end_time?: Maybe<Scalars["Float"]["output"]>
  misfire_instr?: Maybe<Scalars["Float"]["output"]>
  next_fire_time?: Maybe<Scalars["Float"]["output"]>
  prev_fire_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  start_time?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "warrant_account_criteria" */
export type Financials_Warrant_Account_Criteria = {
  __typename?: "financials_warrant_account_criteria"
  account_number: Scalars["String"]["output"]
  created_at: Scalars["timestamp"]["output"]
  exit_reasons?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  meets_exit_criteria?: Maybe<Scalars["Boolean"]["output"]>
  meets_pause_criteria?: Maybe<Scalars["Boolean"]["output"]>
  pause_reasons?: Maybe<Scalars["String"]["output"]>
  version?: Maybe<Scalars["String"]["output"]>
}

/** aggregated selection of "warrant_account_criteria" */
export type Financials_Warrant_Account_Criteria_Aggregate = {
  __typename?: "financials_warrant_account_criteria_aggregate"
  aggregate?: Maybe<Financials_Warrant_Account_Criteria_Aggregate_Fields>
  nodes: Array<Financials_Warrant_Account_Criteria>
}

/** aggregate fields of "warrant_account_criteria" */
export type Financials_Warrant_Account_Criteria_Aggregate_Fields = {
  __typename?: "financials_warrant_account_criteria_aggregate_fields"
  avg?: Maybe<Financials_Warrant_Account_Criteria_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Warrant_Account_Criteria_Max_Fields>
  min?: Maybe<Financials_Warrant_Account_Criteria_Min_Fields>
  stddev?: Maybe<Financials_Warrant_Account_Criteria_Stddev_Fields>
  stddev_pop?: Maybe<Financials_Warrant_Account_Criteria_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Financials_Warrant_Account_Criteria_Stddev_Samp_Fields>
  sum?: Maybe<Financials_Warrant_Account_Criteria_Sum_Fields>
  var_pop?: Maybe<Financials_Warrant_Account_Criteria_Var_Pop_Fields>
  var_samp?: Maybe<Financials_Warrant_Account_Criteria_Var_Samp_Fields>
  variance?: Maybe<Financials_Warrant_Account_Criteria_Variance_Fields>
}

/** aggregate fields of "warrant_account_criteria" */
export type Financials_Warrant_Account_Criteria_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Financials_Warrant_Account_Criteria_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Financials_Warrant_Account_Criteria_Avg_Fields = {
  __typename?: "financials_warrant_account_criteria_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "warrant_account_criteria". All fields are combined with a logical 'AND'. */
export type Financials_Warrant_Account_Criteria_Bool_Exp = {
  _and?: InputMaybe<Array<Financials_Warrant_Account_Criteria_Bool_Exp>>
  _not?: InputMaybe<Financials_Warrant_Account_Criteria_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Warrant_Account_Criteria_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  exit_reasons?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  meets_exit_criteria?: InputMaybe<Boolean_Comparison_Exp>
  meets_pause_criteria?: InputMaybe<Boolean_Comparison_Exp>
  pause_reasons?: InputMaybe<String_Comparison_Exp>
  version?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "warrant_account_criteria" */
export enum Financials_Warrant_Account_Criteria_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarrantAccountCriteriaPkey = "warrant_account_criteria_pkey",
}

/** input type for incrementing numeric columns in table "warrant_account_criteria" */
export type Financials_Warrant_Account_Criteria_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "warrant_account_criteria" */
export type Financials_Warrant_Account_Criteria_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  exit_reasons?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meets_exit_criteria?: InputMaybe<Scalars["Boolean"]["input"]>
  meets_pause_criteria?: InputMaybe<Scalars["Boolean"]["input"]>
  pause_reasons?: InputMaybe<Scalars["String"]["input"]>
  version?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Financials_Warrant_Account_Criteria_Max_Fields = {
  __typename?: "financials_warrant_account_criteria_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  exit_reasons?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  pause_reasons?: Maybe<Scalars["String"]["output"]>
  version?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Financials_Warrant_Account_Criteria_Min_Fields = {
  __typename?: "financials_warrant_account_criteria_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  exit_reasons?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  pause_reasons?: Maybe<Scalars["String"]["output"]>
  version?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "warrant_account_criteria" */
export type Financials_Warrant_Account_Criteria_Mutation_Response = {
  __typename?: "financials_warrant_account_criteria_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Warrant_Account_Criteria>
}

/** on_conflict condition type for table "warrant_account_criteria" */
export type Financials_Warrant_Account_Criteria_On_Conflict = {
  constraint: Financials_Warrant_Account_Criteria_Constraint
  update_columns?: Array<Financials_Warrant_Account_Criteria_Update_Column>
  where?: InputMaybe<Financials_Warrant_Account_Criteria_Bool_Exp>
}

/** Ordering options when selecting data from "warrant_account_criteria". */
export type Financials_Warrant_Account_Criteria_Order_By = {
  account_number?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  exit_reasons?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meets_exit_criteria?: InputMaybe<Order_By>
  meets_pause_criteria?: InputMaybe<Order_By>
  pause_reasons?: InputMaybe<Order_By>
  version?: InputMaybe<Order_By>
}

/** primary key columns input for table: warrant_account_criteria */
export type Financials_Warrant_Account_Criteria_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "warrant_account_criteria" */
export enum Financials_Warrant_Account_Criteria_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  ExitReasons = "exit_reasons",
  /** column name */
  Id = "id",
  /** column name */
  MeetsExitCriteria = "meets_exit_criteria",
  /** column name */
  MeetsPauseCriteria = "meets_pause_criteria",
  /** column name */
  PauseReasons = "pause_reasons",
  /** column name */
  Version = "version",
}

/** input type for updating data in table "warrant_account_criteria" */
export type Financials_Warrant_Account_Criteria_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  exit_reasons?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meets_exit_criteria?: InputMaybe<Scalars["Boolean"]["input"]>
  meets_pause_criteria?: InputMaybe<Scalars["Boolean"]["input"]>
  pause_reasons?: InputMaybe<Scalars["String"]["input"]>
  version?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Financials_Warrant_Account_Criteria_Stddev_Fields = {
  __typename?: "financials_warrant_account_criteria_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Financials_Warrant_Account_Criteria_Stddev_Pop_Fields = {
  __typename?: "financials_warrant_account_criteria_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Financials_Warrant_Account_Criteria_Stddev_Samp_Fields = {
  __typename?: "financials_warrant_account_criteria_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "financials_warrant_account_criteria" */
export type Financials_Warrant_Account_Criteria_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Warrant_Account_Criteria_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Warrant_Account_Criteria_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  exit_reasons?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meets_exit_criteria?: InputMaybe<Scalars["Boolean"]["input"]>
  meets_pause_criteria?: InputMaybe<Scalars["Boolean"]["input"]>
  pause_reasons?: InputMaybe<Scalars["String"]["input"]>
  version?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Financials_Warrant_Account_Criteria_Sum_Fields = {
  __typename?: "financials_warrant_account_criteria_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "warrant_account_criteria" */
export enum Financials_Warrant_Account_Criteria_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  ExitReasons = "exit_reasons",
  /** column name */
  Id = "id",
  /** column name */
  MeetsExitCriteria = "meets_exit_criteria",
  /** column name */
  MeetsPauseCriteria = "meets_pause_criteria",
  /** column name */
  PauseReasons = "pause_reasons",
  /** column name */
  Version = "version",
}

export type Financials_Warrant_Account_Criteria_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Financials_Warrant_Account_Criteria_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Warrant_Account_Criteria_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Warrant_Account_Criteria_Bool_Exp
}

/** aggregate var_pop on columns */
export type Financials_Warrant_Account_Criteria_Var_Pop_Fields = {
  __typename?: "financials_warrant_account_criteria_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Financials_Warrant_Account_Criteria_Var_Samp_Fields = {
  __typename?: "financials_warrant_account_criteria_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Financials_Warrant_Account_Criteria_Variance_Fields = {
  __typename?: "financials_warrant_account_criteria_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "warrant_account_sync_criteria" */
export type Financials_Warrant_Account_Sync_Criteria = {
  __typename?: "financials_warrant_account_sync_criteria"
  account_id?: Maybe<Scalars["String"]["output"]>
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  exclusion_reason?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  is_excluded_for_dca?: Maybe<Scalars["String"]["output"]>
  is_excluded_for_early_stage_collection?: Maybe<Scalars["String"]["output"]>
  is_excluded_for_litigation?: Maybe<Scalars["String"]["output"]>
  is_excluded_for_warrant?: Maybe<Scalars["String"]["output"]>
  is_exit_trigger_for_warrant?: Maybe<Scalars["String"]["output"]>
  is_pause_trigger_for_warrant?: Maybe<Scalars["String"]["output"]>
  version?: Maybe<Scalars["String"]["output"]>
}

/** aggregated selection of "warrant_account_sync_criteria" */
export type Financials_Warrant_Account_Sync_Criteria_Aggregate = {
  __typename?: "financials_warrant_account_sync_criteria_aggregate"
  aggregate?: Maybe<Financials_Warrant_Account_Sync_Criteria_Aggregate_Fields>
  nodes: Array<Financials_Warrant_Account_Sync_Criteria>
}

/** aggregate fields of "warrant_account_sync_criteria" */
export type Financials_Warrant_Account_Sync_Criteria_Aggregate_Fields = {
  __typename?: "financials_warrant_account_sync_criteria_aggregate_fields"
  avg?: Maybe<Financials_Warrant_Account_Sync_Criteria_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Warrant_Account_Sync_Criteria_Max_Fields>
  min?: Maybe<Financials_Warrant_Account_Sync_Criteria_Min_Fields>
  stddev?: Maybe<Financials_Warrant_Account_Sync_Criteria_Stddev_Fields>
  stddev_pop?: Maybe<Financials_Warrant_Account_Sync_Criteria_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Financials_Warrant_Account_Sync_Criteria_Stddev_Samp_Fields>
  sum?: Maybe<Financials_Warrant_Account_Sync_Criteria_Sum_Fields>
  var_pop?: Maybe<Financials_Warrant_Account_Sync_Criteria_Var_Pop_Fields>
  var_samp?: Maybe<Financials_Warrant_Account_Sync_Criteria_Var_Samp_Fields>
  variance?: Maybe<Financials_Warrant_Account_Sync_Criteria_Variance_Fields>
}

/** aggregate fields of "warrant_account_sync_criteria" */
export type Financials_Warrant_Account_Sync_Criteria_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Financials_Warrant_Account_Sync_Criteria_Select_Column>
    >
    distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  }

/** aggregate avg on columns */
export type Financials_Warrant_Account_Sync_Criteria_Avg_Fields = {
  __typename?: "financials_warrant_account_sync_criteria_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "warrant_account_sync_criteria". All fields are combined with a logical 'AND'. */
export type Financials_Warrant_Account_Sync_Criteria_Bool_Exp = {
  _and?: InputMaybe<Array<Financials_Warrant_Account_Sync_Criteria_Bool_Exp>>
  _not?: InputMaybe<Financials_Warrant_Account_Sync_Criteria_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Warrant_Account_Sync_Criteria_Bool_Exp>>
  account_id?: InputMaybe<String_Comparison_Exp>
  account_number?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  exclusion_reason?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  is_excluded_for_dca?: InputMaybe<String_Comparison_Exp>
  is_excluded_for_early_stage_collection?: InputMaybe<String_Comparison_Exp>
  is_excluded_for_litigation?: InputMaybe<String_Comparison_Exp>
  is_excluded_for_warrant?: InputMaybe<String_Comparison_Exp>
  is_exit_trigger_for_warrant?: InputMaybe<String_Comparison_Exp>
  is_pause_trigger_for_warrant?: InputMaybe<String_Comparison_Exp>
  version?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "warrant_account_sync_criteria" */
export enum Financials_Warrant_Account_Sync_Criteria_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarrantAccountSyncCriteriaPkey = "warrant_account_sync_criteria_pkey",
}

/** input type for incrementing numeric columns in table "warrant_account_sync_criteria" */
export type Financials_Warrant_Account_Sync_Criteria_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "warrant_account_sync_criteria" */
export type Financials_Warrant_Account_Sync_Criteria_Insert_Input = {
  account_id?: InputMaybe<Scalars["String"]["input"]>
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  exclusion_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  is_excluded_for_dca?: InputMaybe<Scalars["String"]["input"]>
  is_excluded_for_early_stage_collection?: InputMaybe<
    Scalars["String"]["input"]
  >
  is_excluded_for_litigation?: InputMaybe<Scalars["String"]["input"]>
  is_excluded_for_warrant?: InputMaybe<Scalars["String"]["input"]>
  is_exit_trigger_for_warrant?: InputMaybe<Scalars["String"]["input"]>
  is_pause_trigger_for_warrant?: InputMaybe<Scalars["String"]["input"]>
  version?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Financials_Warrant_Account_Sync_Criteria_Max_Fields = {
  __typename?: "financials_warrant_account_sync_criteria_max_fields"
  account_id?: Maybe<Scalars["String"]["output"]>
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  exclusion_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  is_excluded_for_dca?: Maybe<Scalars["String"]["output"]>
  is_excluded_for_early_stage_collection?: Maybe<Scalars["String"]["output"]>
  is_excluded_for_litigation?: Maybe<Scalars["String"]["output"]>
  is_excluded_for_warrant?: Maybe<Scalars["String"]["output"]>
  is_exit_trigger_for_warrant?: Maybe<Scalars["String"]["output"]>
  is_pause_trigger_for_warrant?: Maybe<Scalars["String"]["output"]>
  version?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Financials_Warrant_Account_Sync_Criteria_Min_Fields = {
  __typename?: "financials_warrant_account_sync_criteria_min_fields"
  account_id?: Maybe<Scalars["String"]["output"]>
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  exclusion_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  is_excluded_for_dca?: Maybe<Scalars["String"]["output"]>
  is_excluded_for_early_stage_collection?: Maybe<Scalars["String"]["output"]>
  is_excluded_for_litigation?: Maybe<Scalars["String"]["output"]>
  is_excluded_for_warrant?: Maybe<Scalars["String"]["output"]>
  is_exit_trigger_for_warrant?: Maybe<Scalars["String"]["output"]>
  is_pause_trigger_for_warrant?: Maybe<Scalars["String"]["output"]>
  version?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "warrant_account_sync_criteria" */
export type Financials_Warrant_Account_Sync_Criteria_Mutation_Response = {
  __typename?: "financials_warrant_account_sync_criteria_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Warrant_Account_Sync_Criteria>
}

/** on_conflict condition type for table "warrant_account_sync_criteria" */
export type Financials_Warrant_Account_Sync_Criteria_On_Conflict = {
  constraint: Financials_Warrant_Account_Sync_Criteria_Constraint
  update_columns?: Array<Financials_Warrant_Account_Sync_Criteria_Update_Column>
  where?: InputMaybe<Financials_Warrant_Account_Sync_Criteria_Bool_Exp>
}

/** Ordering options when selecting data from "warrant_account_sync_criteria". */
export type Financials_Warrant_Account_Sync_Criteria_Order_By = {
  account_id?: InputMaybe<Order_By>
  account_number?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  exclusion_reason?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  is_excluded_for_dca?: InputMaybe<Order_By>
  is_excluded_for_early_stage_collection?: InputMaybe<Order_By>
  is_excluded_for_litigation?: InputMaybe<Order_By>
  is_excluded_for_warrant?: InputMaybe<Order_By>
  is_exit_trigger_for_warrant?: InputMaybe<Order_By>
  is_pause_trigger_for_warrant?: InputMaybe<Order_By>
  version?: InputMaybe<Order_By>
}

/** primary key columns input for table: warrant_account_sync_criteria */
export type Financials_Warrant_Account_Sync_Criteria_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "warrant_account_sync_criteria" */
export enum Financials_Warrant_Account_Sync_Criteria_Select_Column {
  /** column name */
  AccountId = "account_id",
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  ExclusionReason = "exclusion_reason",
  /** column name */
  Id = "id",
  /** column name */
  IsExcludedForDca = "is_excluded_for_dca",
  /** column name */
  IsExcludedForEarlyStageCollection = "is_excluded_for_early_stage_collection",
  /** column name */
  IsExcludedForLitigation = "is_excluded_for_litigation",
  /** column name */
  IsExcludedForWarrant = "is_excluded_for_warrant",
  /** column name */
  IsExitTriggerForWarrant = "is_exit_trigger_for_warrant",
  /** column name */
  IsPauseTriggerForWarrant = "is_pause_trigger_for_warrant",
  /** column name */
  Version = "version",
}

/** input type for updating data in table "warrant_account_sync_criteria" */
export type Financials_Warrant_Account_Sync_Criteria_Set_Input = {
  account_id?: InputMaybe<Scalars["String"]["input"]>
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  exclusion_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  is_excluded_for_dca?: InputMaybe<Scalars["String"]["input"]>
  is_excluded_for_early_stage_collection?: InputMaybe<
    Scalars["String"]["input"]
  >
  is_excluded_for_litigation?: InputMaybe<Scalars["String"]["input"]>
  is_excluded_for_warrant?: InputMaybe<Scalars["String"]["input"]>
  is_exit_trigger_for_warrant?: InputMaybe<Scalars["String"]["input"]>
  is_pause_trigger_for_warrant?: InputMaybe<Scalars["String"]["input"]>
  version?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Financials_Warrant_Account_Sync_Criteria_Stddev_Fields = {
  __typename?: "financials_warrant_account_sync_criteria_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Financials_Warrant_Account_Sync_Criteria_Stddev_Pop_Fields = {
  __typename?: "financials_warrant_account_sync_criteria_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Financials_Warrant_Account_Sync_Criteria_Stddev_Samp_Fields = {
  __typename?: "financials_warrant_account_sync_criteria_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "financials_warrant_account_sync_criteria" */
export type Financials_Warrant_Account_Sync_Criteria_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Warrant_Account_Sync_Criteria_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Warrant_Account_Sync_Criteria_Stream_Cursor_Value_Input =
  {
    account_id?: InputMaybe<Scalars["String"]["input"]>
    account_number?: InputMaybe<Scalars["String"]["input"]>
    created_at?: InputMaybe<Scalars["timestamp"]["input"]>
    exclusion_reason?: InputMaybe<Scalars["String"]["input"]>
    id?: InputMaybe<Scalars["bigint"]["input"]>
    is_excluded_for_dca?: InputMaybe<Scalars["String"]["input"]>
    is_excluded_for_early_stage_collection?: InputMaybe<
      Scalars["String"]["input"]
    >
    is_excluded_for_litigation?: InputMaybe<Scalars["String"]["input"]>
    is_excluded_for_warrant?: InputMaybe<Scalars["String"]["input"]>
    is_exit_trigger_for_warrant?: InputMaybe<Scalars["String"]["input"]>
    is_pause_trigger_for_warrant?: InputMaybe<Scalars["String"]["input"]>
    version?: InputMaybe<Scalars["String"]["input"]>
  }

/** aggregate sum on columns */
export type Financials_Warrant_Account_Sync_Criteria_Sum_Fields = {
  __typename?: "financials_warrant_account_sync_criteria_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "warrant_account_sync_criteria" */
export enum Financials_Warrant_Account_Sync_Criteria_Update_Column {
  /** column name */
  AccountId = "account_id",
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  ExclusionReason = "exclusion_reason",
  /** column name */
  Id = "id",
  /** column name */
  IsExcludedForDca = "is_excluded_for_dca",
  /** column name */
  IsExcludedForEarlyStageCollection = "is_excluded_for_early_stage_collection",
  /** column name */
  IsExcludedForLitigation = "is_excluded_for_litigation",
  /** column name */
  IsExcludedForWarrant = "is_excluded_for_warrant",
  /** column name */
  IsExitTriggerForWarrant = "is_exit_trigger_for_warrant",
  /** column name */
  IsPauseTriggerForWarrant = "is_pause_trigger_for_warrant",
  /** column name */
  Version = "version",
}

export type Financials_Warrant_Account_Sync_Criteria_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Financials_Warrant_Account_Sync_Criteria_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Warrant_Account_Sync_Criteria_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Warrant_Account_Sync_Criteria_Bool_Exp
}

/** aggregate var_pop on columns */
export type Financials_Warrant_Account_Sync_Criteria_Var_Pop_Fields = {
  __typename?: "financials_warrant_account_sync_criteria_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Financials_Warrant_Account_Sync_Criteria_Var_Samp_Fields = {
  __typename?: "financials_warrant_account_sync_criteria_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Financials_Warrant_Account_Sync_Criteria_Variance_Fields = {
  __typename?: "financials_warrant_account_sync_criteria_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "warrant_communications_sent_count" */
export type Financials_Warrant_Communications_Sent_Count = {
  __typename?: "financials_warrant_communications_sent_count"
  id: Scalars["bigint"]["output"]
  total: Scalars["Int"]["output"]
  warrant_job_id: Scalars["bigint"]["output"]
}

/** aggregated selection of "warrant_communications_sent_count" */
export type Financials_Warrant_Communications_Sent_Count_Aggregate = {
  __typename?: "financials_warrant_communications_sent_count_aggregate"
  aggregate?: Maybe<Financials_Warrant_Communications_Sent_Count_Aggregate_Fields>
  nodes: Array<Financials_Warrant_Communications_Sent_Count>
}

/** aggregate fields of "warrant_communications_sent_count" */
export type Financials_Warrant_Communications_Sent_Count_Aggregate_Fields = {
  __typename?: "financials_warrant_communications_sent_count_aggregate_fields"
  avg?: Maybe<Financials_Warrant_Communications_Sent_Count_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Warrant_Communications_Sent_Count_Max_Fields>
  min?: Maybe<Financials_Warrant_Communications_Sent_Count_Min_Fields>
  stddev?: Maybe<Financials_Warrant_Communications_Sent_Count_Stddev_Fields>
  stddev_pop?: Maybe<Financials_Warrant_Communications_Sent_Count_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Financials_Warrant_Communications_Sent_Count_Stddev_Samp_Fields>
  sum?: Maybe<Financials_Warrant_Communications_Sent_Count_Sum_Fields>
  var_pop?: Maybe<Financials_Warrant_Communications_Sent_Count_Var_Pop_Fields>
  var_samp?: Maybe<Financials_Warrant_Communications_Sent_Count_Var_Samp_Fields>
  variance?: Maybe<Financials_Warrant_Communications_Sent_Count_Variance_Fields>
}

/** aggregate fields of "warrant_communications_sent_count" */
export type Financials_Warrant_Communications_Sent_Count_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Financials_Warrant_Communications_Sent_Count_Select_Column>
    >
    distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  }

/** aggregate avg on columns */
export type Financials_Warrant_Communications_Sent_Count_Avg_Fields = {
  __typename?: "financials_warrant_communications_sent_count_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  total?: Maybe<Scalars["Float"]["output"]>
  warrant_job_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "warrant_communications_sent_count". All fields are combined with a logical 'AND'. */
export type Financials_Warrant_Communications_Sent_Count_Bool_Exp = {
  _and?: InputMaybe<
    Array<Financials_Warrant_Communications_Sent_Count_Bool_Exp>
  >
  _not?: InputMaybe<Financials_Warrant_Communications_Sent_Count_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Warrant_Communications_Sent_Count_Bool_Exp>>
  id?: InputMaybe<Bigint_Comparison_Exp>
  total?: InputMaybe<Int_Comparison_Exp>
  warrant_job_id?: InputMaybe<Bigint_Comparison_Exp>
}

/** unique or primary key constraints on table "warrant_communications_sent_count" */
export enum Financials_Warrant_Communications_Sent_Count_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarrantCommunicationsSentCountPkey = "warrant_communications_sent_count_pkey",
  /** unique or primary key constraint on columns "warrant_job_id" */
  WarrantTotalUniqueJobId = "warrant_total_unique_job_id",
}

/** input type for incrementing numeric columns in table "warrant_communications_sent_count" */
export type Financials_Warrant_Communications_Sent_Count_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  total?: InputMaybe<Scalars["Int"]["input"]>
  warrant_job_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "warrant_communications_sent_count" */
export type Financials_Warrant_Communications_Sent_Count_Insert_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  total?: InputMaybe<Scalars["Int"]["input"]>
  warrant_job_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate max on columns */
export type Financials_Warrant_Communications_Sent_Count_Max_Fields = {
  __typename?: "financials_warrant_communications_sent_count_max_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  total?: Maybe<Scalars["Int"]["output"]>
  warrant_job_id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregate min on columns */
export type Financials_Warrant_Communications_Sent_Count_Min_Fields = {
  __typename?: "financials_warrant_communications_sent_count_min_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  total?: Maybe<Scalars["Int"]["output"]>
  warrant_job_id?: Maybe<Scalars["bigint"]["output"]>
}

/** response of any mutation on the table "warrant_communications_sent_count" */
export type Financials_Warrant_Communications_Sent_Count_Mutation_Response = {
  __typename?: "financials_warrant_communications_sent_count_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Warrant_Communications_Sent_Count>
}

/** on_conflict condition type for table "warrant_communications_sent_count" */
export type Financials_Warrant_Communications_Sent_Count_On_Conflict = {
  constraint: Financials_Warrant_Communications_Sent_Count_Constraint
  update_columns?: Array<Financials_Warrant_Communications_Sent_Count_Update_Column>
  where?: InputMaybe<Financials_Warrant_Communications_Sent_Count_Bool_Exp>
}

/** Ordering options when selecting data from "warrant_communications_sent_count". */
export type Financials_Warrant_Communications_Sent_Count_Order_By = {
  id?: InputMaybe<Order_By>
  total?: InputMaybe<Order_By>
  warrant_job_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: warrant_communications_sent_count */
export type Financials_Warrant_Communications_Sent_Count_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "warrant_communications_sent_count" */
export enum Financials_Warrant_Communications_Sent_Count_Select_Column {
  /** column name */
  Id = "id",
  /** column name */
  Total = "total",
  /** column name */
  WarrantJobId = "warrant_job_id",
}

/** input type for updating data in table "warrant_communications_sent_count" */
export type Financials_Warrant_Communications_Sent_Count_Set_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  total?: InputMaybe<Scalars["Int"]["input"]>
  warrant_job_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate stddev on columns */
export type Financials_Warrant_Communications_Sent_Count_Stddev_Fields = {
  __typename?: "financials_warrant_communications_sent_count_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  total?: Maybe<Scalars["Float"]["output"]>
  warrant_job_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Financials_Warrant_Communications_Sent_Count_Stddev_Pop_Fields = {
  __typename?: "financials_warrant_communications_sent_count_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  total?: Maybe<Scalars["Float"]["output"]>
  warrant_job_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Financials_Warrant_Communications_Sent_Count_Stddev_Samp_Fields = {
  __typename?: "financials_warrant_communications_sent_count_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  total?: Maybe<Scalars["Float"]["output"]>
  warrant_job_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "financials_warrant_communications_sent_count" */
export type Financials_Warrant_Communications_Sent_Count_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Warrant_Communications_Sent_Count_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Warrant_Communications_Sent_Count_Stream_Cursor_Value_Input =
  {
    id?: InputMaybe<Scalars["bigint"]["input"]>
    total?: InputMaybe<Scalars["Int"]["input"]>
    warrant_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  }

/** aggregate sum on columns */
export type Financials_Warrant_Communications_Sent_Count_Sum_Fields = {
  __typename?: "financials_warrant_communications_sent_count_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  total?: Maybe<Scalars["Int"]["output"]>
  warrant_job_id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "warrant_communications_sent_count" */
export enum Financials_Warrant_Communications_Sent_Count_Update_Column {
  /** column name */
  Id = "id",
  /** column name */
  Total = "total",
  /** column name */
  WarrantJobId = "warrant_job_id",
}

export type Financials_Warrant_Communications_Sent_Count_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Financials_Warrant_Communications_Sent_Count_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Warrant_Communications_Sent_Count_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Warrant_Communications_Sent_Count_Bool_Exp
}

/** aggregate var_pop on columns */
export type Financials_Warrant_Communications_Sent_Count_Var_Pop_Fields = {
  __typename?: "financials_warrant_communications_sent_count_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  total?: Maybe<Scalars["Float"]["output"]>
  warrant_job_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Financials_Warrant_Communications_Sent_Count_Var_Samp_Fields = {
  __typename?: "financials_warrant_communications_sent_count_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  total?: Maybe<Scalars["Float"]["output"]>
  warrant_job_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Financials_Warrant_Communications_Sent_Count_Variance_Fields = {
  __typename?: "financials_warrant_communications_sent_count_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  total?: Maybe<Scalars["Float"]["output"]>
  warrant_job_id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "warrants_accounts" */
export type Financials_Warrants_Accounts = {
  __typename?: "financials_warrants_accounts"
  account_number: Scalars["String"]["output"]
  created_at: Scalars["timestamp"]["output"]
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted_by_agent_email?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  pause_start?: Maybe<Scalars["date"]["output"]>
  status: Scalars["warrants_account_state"]["output"]
  updated_at: Scalars["timestamp"]["output"]
  visit_completed_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregated selection of "warrants_accounts" */
export type Financials_Warrants_Accounts_Aggregate = {
  __typename?: "financials_warrants_accounts_aggregate"
  aggregate?: Maybe<Financials_Warrants_Accounts_Aggregate_Fields>
  nodes: Array<Financials_Warrants_Accounts>
}

/** aggregate fields of "warrants_accounts" */
export type Financials_Warrants_Accounts_Aggregate_Fields = {
  __typename?: "financials_warrants_accounts_aggregate_fields"
  avg?: Maybe<Financials_Warrants_Accounts_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Warrants_Accounts_Max_Fields>
  min?: Maybe<Financials_Warrants_Accounts_Min_Fields>
  stddev?: Maybe<Financials_Warrants_Accounts_Stddev_Fields>
  stddev_pop?: Maybe<Financials_Warrants_Accounts_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Financials_Warrants_Accounts_Stddev_Samp_Fields>
  sum?: Maybe<Financials_Warrants_Accounts_Sum_Fields>
  var_pop?: Maybe<Financials_Warrants_Accounts_Var_Pop_Fields>
  var_samp?: Maybe<Financials_Warrants_Accounts_Var_Samp_Fields>
  variance?: Maybe<Financials_Warrants_Accounts_Variance_Fields>
}

/** aggregate fields of "warrants_accounts" */
export type Financials_Warrants_Accounts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Financials_Warrants_Accounts_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Financials_Warrants_Accounts_Avg_Fields = {
  __typename?: "financials_warrants_accounts_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "warrants_accounts". All fields are combined with a logical 'AND'. */
export type Financials_Warrants_Accounts_Bool_Exp = {
  _and?: InputMaybe<Array<Financials_Warrants_Accounts_Bool_Exp>>
  _not?: InputMaybe<Financials_Warrants_Accounts_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Warrants_Accounts_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted_by_agent_email?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  pause_start?: InputMaybe<Date_Comparison_Exp>
  status?: InputMaybe<Warrants_Account_State_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  visit_completed_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "warrants_accounts" */
export enum Financials_Warrants_Accounts_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarrantsAccountsPkey = "warrants_accounts_pkey",
}

/** columns and relationships of "warrants_accounts_history" */
export type Financials_Warrants_Accounts_History = {
  __typename?: "financials_warrants_accounts_history"
  account_number: Scalars["String"]["output"]
  created_at: Scalars["timestamp"]["output"]
  current_status?: Maybe<Scalars["warrants_account_state"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  message?: Maybe<Scalars["String"]["output"]>
  next_status?: Maybe<Scalars["warrants_account_state"]["output"]>
  status: Scalars["warrants_account_history_status"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "warrants_accounts_history" */
export type Financials_Warrants_Accounts_History_Aggregate = {
  __typename?: "financials_warrants_accounts_history_aggregate"
  aggregate?: Maybe<Financials_Warrants_Accounts_History_Aggregate_Fields>
  nodes: Array<Financials_Warrants_Accounts_History>
}

/** aggregate fields of "warrants_accounts_history" */
export type Financials_Warrants_Accounts_History_Aggregate_Fields = {
  __typename?: "financials_warrants_accounts_history_aggregate_fields"
  avg?: Maybe<Financials_Warrants_Accounts_History_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Warrants_Accounts_History_Max_Fields>
  min?: Maybe<Financials_Warrants_Accounts_History_Min_Fields>
  stddev?: Maybe<Financials_Warrants_Accounts_History_Stddev_Fields>
  stddev_pop?: Maybe<Financials_Warrants_Accounts_History_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Financials_Warrants_Accounts_History_Stddev_Samp_Fields>
  sum?: Maybe<Financials_Warrants_Accounts_History_Sum_Fields>
  var_pop?: Maybe<Financials_Warrants_Accounts_History_Var_Pop_Fields>
  var_samp?: Maybe<Financials_Warrants_Accounts_History_Var_Samp_Fields>
  variance?: Maybe<Financials_Warrants_Accounts_History_Variance_Fields>
}

/** aggregate fields of "warrants_accounts_history" */
export type Financials_Warrants_Accounts_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<
    Array<Financials_Warrants_Accounts_History_Select_Column>
  >
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Financials_Warrants_Accounts_History_Avg_Fields = {
  __typename?: "financials_warrants_accounts_history_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "warrants_accounts_history". All fields are combined with a logical 'AND'. */
export type Financials_Warrants_Accounts_History_Bool_Exp = {
  _and?: InputMaybe<Array<Financials_Warrants_Accounts_History_Bool_Exp>>
  _not?: InputMaybe<Financials_Warrants_Accounts_History_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Warrants_Accounts_History_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  current_status?: InputMaybe<Warrants_Account_State_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  message?: InputMaybe<String_Comparison_Exp>
  next_status?: InputMaybe<Warrants_Account_State_Comparison_Exp>
  status?: InputMaybe<Warrants_Account_History_Status_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "warrants_accounts_history" */
export enum Financials_Warrants_Accounts_History_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarrantsAccountsHistoryPkey = "warrants_accounts_history_pkey",
}

/** input type for incrementing numeric columns in table "warrants_accounts_history" */
export type Financials_Warrants_Accounts_History_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "warrants_accounts_history" */
export type Financials_Warrants_Accounts_History_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  current_status?: InputMaybe<Scalars["warrants_account_state"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  message?: InputMaybe<Scalars["String"]["input"]>
  next_status?: InputMaybe<Scalars["warrants_account_state"]["input"]>
  status?: InputMaybe<Scalars["warrants_account_history_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Financials_Warrants_Accounts_History_Max_Fields = {
  __typename?: "financials_warrants_accounts_history_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  current_status?: Maybe<Scalars["warrants_account_state"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  message?: Maybe<Scalars["String"]["output"]>
  next_status?: Maybe<Scalars["warrants_account_state"]["output"]>
  status?: Maybe<Scalars["warrants_account_history_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Financials_Warrants_Accounts_History_Min_Fields = {
  __typename?: "financials_warrants_accounts_history_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  current_status?: Maybe<Scalars["warrants_account_state"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  message?: Maybe<Scalars["String"]["output"]>
  next_status?: Maybe<Scalars["warrants_account_state"]["output"]>
  status?: Maybe<Scalars["warrants_account_history_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "warrants_accounts_history" */
export type Financials_Warrants_Accounts_History_Mutation_Response = {
  __typename?: "financials_warrants_accounts_history_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Warrants_Accounts_History>
}

/** on_conflict condition type for table "warrants_accounts_history" */
export type Financials_Warrants_Accounts_History_On_Conflict = {
  constraint: Financials_Warrants_Accounts_History_Constraint
  update_columns?: Array<Financials_Warrants_Accounts_History_Update_Column>
  where?: InputMaybe<Financials_Warrants_Accounts_History_Bool_Exp>
}

/** Ordering options when selecting data from "warrants_accounts_history". */
export type Financials_Warrants_Accounts_History_Order_By = {
  account_number?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  current_status?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  message?: InputMaybe<Order_By>
  next_status?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: warrants_accounts_history */
export type Financials_Warrants_Accounts_History_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "warrants_accounts_history" */
export enum Financials_Warrants_Accounts_History_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CurrentStatus = "current_status",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  Id = "id",
  /** column name */
  Message = "message",
  /** column name */
  NextStatus = "next_status",
  /** column name */
  Status = "status",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "warrants_accounts_history" */
export type Financials_Warrants_Accounts_History_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  current_status?: InputMaybe<Scalars["warrants_account_state"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  message?: InputMaybe<Scalars["String"]["input"]>
  next_status?: InputMaybe<Scalars["warrants_account_state"]["input"]>
  status?: InputMaybe<Scalars["warrants_account_history_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Financials_Warrants_Accounts_History_Stddev_Fields = {
  __typename?: "financials_warrants_accounts_history_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Financials_Warrants_Accounts_History_Stddev_Pop_Fields = {
  __typename?: "financials_warrants_accounts_history_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Financials_Warrants_Accounts_History_Stddev_Samp_Fields = {
  __typename?: "financials_warrants_accounts_history_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "financials_warrants_accounts_history" */
export type Financials_Warrants_Accounts_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Warrants_Accounts_History_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Warrants_Accounts_History_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  current_status?: InputMaybe<Scalars["warrants_account_state"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  message?: InputMaybe<Scalars["String"]["input"]>
  next_status?: InputMaybe<Scalars["warrants_account_state"]["input"]>
  status?: InputMaybe<Scalars["warrants_account_history_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Financials_Warrants_Accounts_History_Sum_Fields = {
  __typename?: "financials_warrants_accounts_history_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "warrants_accounts_history" */
export enum Financials_Warrants_Accounts_History_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CurrentStatus = "current_status",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  Id = "id",
  /** column name */
  Message = "message",
  /** column name */
  NextStatus = "next_status",
  /** column name */
  Status = "status",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Financials_Warrants_Accounts_History_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Financials_Warrants_Accounts_History_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Warrants_Accounts_History_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Warrants_Accounts_History_Bool_Exp
}

/** aggregate var_pop on columns */
export type Financials_Warrants_Accounts_History_Var_Pop_Fields = {
  __typename?: "financials_warrants_accounts_history_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Financials_Warrants_Accounts_History_Var_Samp_Fields = {
  __typename?: "financials_warrants_accounts_history_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Financials_Warrants_Accounts_History_Variance_Fields = {
  __typename?: "financials_warrants_accounts_history_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** input type for incrementing numeric columns in table "warrants_accounts" */
export type Financials_Warrants_Accounts_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "warrants_accounts" */
export type Financials_Warrants_Accounts_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_by_agent_email?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  pause_start?: InputMaybe<Scalars["date"]["input"]>
  status?: InputMaybe<Scalars["warrants_account_state"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  visit_completed_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Financials_Warrants_Accounts_Max_Fields = {
  __typename?: "financials_warrants_accounts_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted_by_agent_email?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  pause_start?: Maybe<Scalars["date"]["output"]>
  status?: Maybe<Scalars["warrants_account_state"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  visit_completed_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Financials_Warrants_Accounts_Min_Fields = {
  __typename?: "financials_warrants_accounts_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted_by_agent_email?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  pause_start?: Maybe<Scalars["date"]["output"]>
  status?: Maybe<Scalars["warrants_account_state"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  visit_completed_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "warrants_accounts" */
export type Financials_Warrants_Accounts_Mutation_Response = {
  __typename?: "financials_warrants_accounts_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Warrants_Accounts>
}

/** on_conflict condition type for table "warrants_accounts" */
export type Financials_Warrants_Accounts_On_Conflict = {
  constraint: Financials_Warrants_Accounts_Constraint
  update_columns?: Array<Financials_Warrants_Accounts_Update_Column>
  where?: InputMaybe<Financials_Warrants_Accounts_Bool_Exp>
}

/** Ordering options when selecting data from "warrants_accounts". */
export type Financials_Warrants_Accounts_Order_By = {
  account_number?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  deleted_by_agent_email?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  pause_start?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  visit_completed_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: warrants_accounts */
export type Financials_Warrants_Accounts_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "warrants_accounts" */
export enum Financials_Warrants_Accounts_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  DeletedByAgentEmail = "deleted_by_agent_email",
  /** column name */
  Id = "id",
  /** column name */
  PauseStart = "pause_start",
  /** column name */
  Status = "status",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  VisitCompletedAt = "visit_completed_at",
}

/** input type for updating data in table "warrants_accounts" */
export type Financials_Warrants_Accounts_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_by_agent_email?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  pause_start?: InputMaybe<Scalars["date"]["input"]>
  status?: InputMaybe<Scalars["warrants_account_state"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  visit_completed_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Financials_Warrants_Accounts_Stddev_Fields = {
  __typename?: "financials_warrants_accounts_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Financials_Warrants_Accounts_Stddev_Pop_Fields = {
  __typename?: "financials_warrants_accounts_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Financials_Warrants_Accounts_Stddev_Samp_Fields = {
  __typename?: "financials_warrants_accounts_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "financials_warrants_accounts" */
export type Financials_Warrants_Accounts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Warrants_Accounts_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Warrants_Accounts_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_by_agent_email?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  pause_start?: InputMaybe<Scalars["date"]["input"]>
  status?: InputMaybe<Scalars["warrants_account_state"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  visit_completed_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Financials_Warrants_Accounts_Sum_Fields = {
  __typename?: "financials_warrants_accounts_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "warrants_accounts" */
export enum Financials_Warrants_Accounts_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  DeletedByAgentEmail = "deleted_by_agent_email",
  /** column name */
  Id = "id",
  /** column name */
  PauseStart = "pause_start",
  /** column name */
  Status = "status",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  VisitCompletedAt = "visit_completed_at",
}

export type Financials_Warrants_Accounts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Financials_Warrants_Accounts_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Warrants_Accounts_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Warrants_Accounts_Bool_Exp
}

/** aggregate var_pop on columns */
export type Financials_Warrants_Accounts_Var_Pop_Fields = {
  __typename?: "financials_warrants_accounts_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Financials_Warrants_Accounts_Var_Samp_Fields = {
  __typename?: "financials_warrants_accounts_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Financials_Warrants_Accounts_Variance_Fields = {
  __typename?: "financials_warrants_accounts_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "warrants_accounts_whitelist" */
export type Financials_Warrants_Accounts_Whitelist = {
  __typename?: "financials_warrants_accounts_whitelist"
  account_number: Scalars["String"]["output"]
  created_at: Scalars["timestamp"]["output"]
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
}

/** aggregated selection of "warrants_accounts_whitelist" */
export type Financials_Warrants_Accounts_Whitelist_Aggregate = {
  __typename?: "financials_warrants_accounts_whitelist_aggregate"
  aggregate?: Maybe<Financials_Warrants_Accounts_Whitelist_Aggregate_Fields>
  nodes: Array<Financials_Warrants_Accounts_Whitelist>
}

/** aggregate fields of "warrants_accounts_whitelist" */
export type Financials_Warrants_Accounts_Whitelist_Aggregate_Fields = {
  __typename?: "financials_warrants_accounts_whitelist_aggregate_fields"
  avg?: Maybe<Financials_Warrants_Accounts_Whitelist_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Warrants_Accounts_Whitelist_Max_Fields>
  min?: Maybe<Financials_Warrants_Accounts_Whitelist_Min_Fields>
  stddev?: Maybe<Financials_Warrants_Accounts_Whitelist_Stddev_Fields>
  stddev_pop?: Maybe<Financials_Warrants_Accounts_Whitelist_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Financials_Warrants_Accounts_Whitelist_Stddev_Samp_Fields>
  sum?: Maybe<Financials_Warrants_Accounts_Whitelist_Sum_Fields>
  var_pop?: Maybe<Financials_Warrants_Accounts_Whitelist_Var_Pop_Fields>
  var_samp?: Maybe<Financials_Warrants_Accounts_Whitelist_Var_Samp_Fields>
  variance?: Maybe<Financials_Warrants_Accounts_Whitelist_Variance_Fields>
}

/** aggregate fields of "warrants_accounts_whitelist" */
export type Financials_Warrants_Accounts_Whitelist_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<
    Array<Financials_Warrants_Accounts_Whitelist_Select_Column>
  >
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Financials_Warrants_Accounts_Whitelist_Avg_Fields = {
  __typename?: "financials_warrants_accounts_whitelist_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "warrants_accounts_whitelist". All fields are combined with a logical 'AND'. */
export type Financials_Warrants_Accounts_Whitelist_Bool_Exp = {
  _and?: InputMaybe<Array<Financials_Warrants_Accounts_Whitelist_Bool_Exp>>
  _not?: InputMaybe<Financials_Warrants_Accounts_Whitelist_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Warrants_Accounts_Whitelist_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
}

/** unique or primary key constraints on table "warrants_accounts_whitelist" */
export enum Financials_Warrants_Accounts_Whitelist_Constraint {
  /** unique or primary key constraint on columns "account_number" */
  UniqueAccountNumber = "unique_account_number",
  /** unique or primary key constraint on columns "id" */
  WarrantsAccountsWhitelistPkey = "warrants_accounts_whitelist_pkey",
}

/** input type for incrementing numeric columns in table "warrants_accounts_whitelist" */
export type Financials_Warrants_Accounts_Whitelist_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "warrants_accounts_whitelist" */
export type Financials_Warrants_Accounts_Whitelist_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate max on columns */
export type Financials_Warrants_Accounts_Whitelist_Max_Fields = {
  __typename?: "financials_warrants_accounts_whitelist_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregate min on columns */
export type Financials_Warrants_Accounts_Whitelist_Min_Fields = {
  __typename?: "financials_warrants_accounts_whitelist_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** response of any mutation on the table "warrants_accounts_whitelist" */
export type Financials_Warrants_Accounts_Whitelist_Mutation_Response = {
  __typename?: "financials_warrants_accounts_whitelist_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Warrants_Accounts_Whitelist>
}

/** on_conflict condition type for table "warrants_accounts_whitelist" */
export type Financials_Warrants_Accounts_Whitelist_On_Conflict = {
  constraint: Financials_Warrants_Accounts_Whitelist_Constraint
  update_columns?: Array<Financials_Warrants_Accounts_Whitelist_Update_Column>
  where?: InputMaybe<Financials_Warrants_Accounts_Whitelist_Bool_Exp>
}

/** Ordering options when selecting data from "warrants_accounts_whitelist". */
export type Financials_Warrants_Accounts_Whitelist_Order_By = {
  account_number?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** primary key columns input for table: warrants_accounts_whitelist */
export type Financials_Warrants_Accounts_Whitelist_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "warrants_accounts_whitelist" */
export enum Financials_Warrants_Accounts_Whitelist_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  Id = "id",
}

/** input type for updating data in table "warrants_accounts_whitelist" */
export type Financials_Warrants_Accounts_Whitelist_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate stddev on columns */
export type Financials_Warrants_Accounts_Whitelist_Stddev_Fields = {
  __typename?: "financials_warrants_accounts_whitelist_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Financials_Warrants_Accounts_Whitelist_Stddev_Pop_Fields = {
  __typename?: "financials_warrants_accounts_whitelist_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Financials_Warrants_Accounts_Whitelist_Stddev_Samp_Fields = {
  __typename?: "financials_warrants_accounts_whitelist_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "financials_warrants_accounts_whitelist" */
export type Financials_Warrants_Accounts_Whitelist_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Warrants_Accounts_Whitelist_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Warrants_Accounts_Whitelist_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate sum on columns */
export type Financials_Warrants_Accounts_Whitelist_Sum_Fields = {
  __typename?: "financials_warrants_accounts_whitelist_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "warrants_accounts_whitelist" */
export enum Financials_Warrants_Accounts_Whitelist_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  Id = "id",
}

export type Financials_Warrants_Accounts_Whitelist_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Financials_Warrants_Accounts_Whitelist_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Warrants_Accounts_Whitelist_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Warrants_Accounts_Whitelist_Bool_Exp
}

/** aggregate var_pop on columns */
export type Financials_Warrants_Accounts_Whitelist_Var_Pop_Fields = {
  __typename?: "financials_warrants_accounts_whitelist_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Financials_Warrants_Accounts_Whitelist_Var_Samp_Fields = {
  __typename?: "financials_warrants_accounts_whitelist_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Financials_Warrants_Accounts_Whitelist_Variance_Fields = {
  __typename?: "financials_warrants_accounts_whitelist_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "warrants_communication_group" */
export type Financials_Warrants_Communication_Group = {
  __typename?: "financials_warrants_communication_group"
  account_number: Scalars["String"]["output"]
  created_at: Scalars["timestamp"]["output"]
  current_priority_level: Scalars["Int"]["output"]
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  error_description?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  parent_status: Scalars["warrants_account_state"]["output"]
  status: Scalars["warrant_communication_group_status"]["output"]
}

/** aggregated selection of "warrants_communication_group" */
export type Financials_Warrants_Communication_Group_Aggregate = {
  __typename?: "financials_warrants_communication_group_aggregate"
  aggregate?: Maybe<Financials_Warrants_Communication_Group_Aggregate_Fields>
  nodes: Array<Financials_Warrants_Communication_Group>
}

/** aggregate fields of "warrants_communication_group" */
export type Financials_Warrants_Communication_Group_Aggregate_Fields = {
  __typename?: "financials_warrants_communication_group_aggregate_fields"
  avg?: Maybe<Financials_Warrants_Communication_Group_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Warrants_Communication_Group_Max_Fields>
  min?: Maybe<Financials_Warrants_Communication_Group_Min_Fields>
  stddev?: Maybe<Financials_Warrants_Communication_Group_Stddev_Fields>
  stddev_pop?: Maybe<Financials_Warrants_Communication_Group_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Financials_Warrants_Communication_Group_Stddev_Samp_Fields>
  sum?: Maybe<Financials_Warrants_Communication_Group_Sum_Fields>
  var_pop?: Maybe<Financials_Warrants_Communication_Group_Var_Pop_Fields>
  var_samp?: Maybe<Financials_Warrants_Communication_Group_Var_Samp_Fields>
  variance?: Maybe<Financials_Warrants_Communication_Group_Variance_Fields>
}

/** aggregate fields of "warrants_communication_group" */
export type Financials_Warrants_Communication_Group_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Financials_Warrants_Communication_Group_Select_Column>
    >
    distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  }

/** aggregate avg on columns */
export type Financials_Warrants_Communication_Group_Avg_Fields = {
  __typename?: "financials_warrants_communication_group_avg_fields"
  current_priority_level?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "warrants_communication_group". All fields are combined with a logical 'AND'. */
export type Financials_Warrants_Communication_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Financials_Warrants_Communication_Group_Bool_Exp>>
  _not?: InputMaybe<Financials_Warrants_Communication_Group_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Warrants_Communication_Group_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  current_priority_level?: InputMaybe<Int_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>
  error_description?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  parent_status?: InputMaybe<Warrants_Account_State_Comparison_Exp>
  status?: InputMaybe<Warrant_Communication_Group_Status_Comparison_Exp>
}

/** unique or primary key constraints on table "warrants_communication_group" */
export enum Financials_Warrants_Communication_Group_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarrantsCommunicationGroupPkey = "warrants_communication_group_pkey",
}

/** input type for incrementing numeric columns in table "warrants_communication_group" */
export type Financials_Warrants_Communication_Group_Inc_Input = {
  current_priority_level?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "warrants_communication_group" */
export type Financials_Warrants_Communication_Group_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  current_priority_level?: InputMaybe<Scalars["Int"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  error_description?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  parent_status?: InputMaybe<Scalars["warrants_account_state"]["input"]>
  status?: InputMaybe<Scalars["warrant_communication_group_status"]["input"]>
}

/** aggregate max on columns */
export type Financials_Warrants_Communication_Group_Max_Fields = {
  __typename?: "financials_warrants_communication_group_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  current_priority_level?: Maybe<Scalars["Int"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  error_description?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  parent_status?: Maybe<Scalars["warrants_account_state"]["output"]>
  status?: Maybe<Scalars["warrant_communication_group_status"]["output"]>
}

/** aggregate min on columns */
export type Financials_Warrants_Communication_Group_Min_Fields = {
  __typename?: "financials_warrants_communication_group_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  current_priority_level?: Maybe<Scalars["Int"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  error_description?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  parent_status?: Maybe<Scalars["warrants_account_state"]["output"]>
  status?: Maybe<Scalars["warrant_communication_group_status"]["output"]>
}

/** response of any mutation on the table "warrants_communication_group" */
export type Financials_Warrants_Communication_Group_Mutation_Response = {
  __typename?: "financials_warrants_communication_group_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Warrants_Communication_Group>
}

/** on_conflict condition type for table "warrants_communication_group" */
export type Financials_Warrants_Communication_Group_On_Conflict = {
  constraint: Financials_Warrants_Communication_Group_Constraint
  update_columns?: Array<Financials_Warrants_Communication_Group_Update_Column>
  where?: InputMaybe<Financials_Warrants_Communication_Group_Bool_Exp>
}

/** Ordering options when selecting data from "warrants_communication_group". */
export type Financials_Warrants_Communication_Group_Order_By = {
  account_number?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  current_priority_level?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  error_description?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  parent_status?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
}

/** primary key columns input for table: warrants_communication_group */
export type Financials_Warrants_Communication_Group_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "warrants_communication_group" */
export enum Financials_Warrants_Communication_Group_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CurrentPriorityLevel = "current_priority_level",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  ErrorDescription = "error_description",
  /** column name */
  Id = "id",
  /** column name */
  ParentStatus = "parent_status",
  /** column name */
  Status = "status",
}

/** input type for updating data in table "warrants_communication_group" */
export type Financials_Warrants_Communication_Group_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  current_priority_level?: InputMaybe<Scalars["Int"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  error_description?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  parent_status?: InputMaybe<Scalars["warrants_account_state"]["input"]>
  status?: InputMaybe<Scalars["warrant_communication_group_status"]["input"]>
}

/** aggregate stddev on columns */
export type Financials_Warrants_Communication_Group_Stddev_Fields = {
  __typename?: "financials_warrants_communication_group_stddev_fields"
  current_priority_level?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Financials_Warrants_Communication_Group_Stddev_Pop_Fields = {
  __typename?: "financials_warrants_communication_group_stddev_pop_fields"
  current_priority_level?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Financials_Warrants_Communication_Group_Stddev_Samp_Fields = {
  __typename?: "financials_warrants_communication_group_stddev_samp_fields"
  current_priority_level?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "financials_warrants_communication_group" */
export type Financials_Warrants_Communication_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Warrants_Communication_Group_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Warrants_Communication_Group_Stream_Cursor_Value_Input =
  {
    account_number?: InputMaybe<Scalars["String"]["input"]>
    created_at?: InputMaybe<Scalars["timestamp"]["input"]>
    current_priority_level?: InputMaybe<Scalars["Int"]["input"]>
    deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
    error_description?: InputMaybe<Scalars["String"]["input"]>
    id?: InputMaybe<Scalars["bigint"]["input"]>
    parent_status?: InputMaybe<Scalars["warrants_account_state"]["input"]>
    status?: InputMaybe<Scalars["warrant_communication_group_status"]["input"]>
  }

/** aggregate sum on columns */
export type Financials_Warrants_Communication_Group_Sum_Fields = {
  __typename?: "financials_warrants_communication_group_sum_fields"
  current_priority_level?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "warrants_communication_group" */
export enum Financials_Warrants_Communication_Group_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CurrentPriorityLevel = "current_priority_level",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  ErrorDescription = "error_description",
  /** column name */
  Id = "id",
  /** column name */
  ParentStatus = "parent_status",
  /** column name */
  Status = "status",
}

export type Financials_Warrants_Communication_Group_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Financials_Warrants_Communication_Group_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Warrants_Communication_Group_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Warrants_Communication_Group_Bool_Exp
}

/** aggregate var_pop on columns */
export type Financials_Warrants_Communication_Group_Var_Pop_Fields = {
  __typename?: "financials_warrants_communication_group_var_pop_fields"
  current_priority_level?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Financials_Warrants_Communication_Group_Var_Samp_Fields = {
  __typename?: "financials_warrants_communication_group_var_samp_fields"
  current_priority_level?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Financials_Warrants_Communication_Group_Variance_Fields = {
  __typename?: "financials_warrants_communication_group_variance_fields"
  current_priority_level?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "warrants_communications" */
export type Financials_Warrants_Communications = {
  __typename?: "financials_warrants_communications"
  comms_id?: Maybe<Scalars["String"]["output"]>
  created_at: Scalars["timestamptz"]["output"]
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  delivery_external_status?: Maybe<Scalars["String"]["output"]>
  delivery_status: Scalars["warrant_communication_delivery_status"]["output"]
  error_description?: Maybe<Scalars["String"]["output"]>
  group_id: Scalars["bigint"]["output"]
  id: Scalars["bigint"]["output"]
  parent_priority_level: Scalars["Int"]["output"]
  type: Scalars["warrant_communication_type"]["output"]
}

/** aggregated selection of "warrants_communications" */
export type Financials_Warrants_Communications_Aggregate = {
  __typename?: "financials_warrants_communications_aggregate"
  aggregate?: Maybe<Financials_Warrants_Communications_Aggregate_Fields>
  nodes: Array<Financials_Warrants_Communications>
}

/** aggregate fields of "warrants_communications" */
export type Financials_Warrants_Communications_Aggregate_Fields = {
  __typename?: "financials_warrants_communications_aggregate_fields"
  avg?: Maybe<Financials_Warrants_Communications_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Warrants_Communications_Max_Fields>
  min?: Maybe<Financials_Warrants_Communications_Min_Fields>
  stddev?: Maybe<Financials_Warrants_Communications_Stddev_Fields>
  stddev_pop?: Maybe<Financials_Warrants_Communications_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Financials_Warrants_Communications_Stddev_Samp_Fields>
  sum?: Maybe<Financials_Warrants_Communications_Sum_Fields>
  var_pop?: Maybe<Financials_Warrants_Communications_Var_Pop_Fields>
  var_samp?: Maybe<Financials_Warrants_Communications_Var_Samp_Fields>
  variance?: Maybe<Financials_Warrants_Communications_Variance_Fields>
}

/** aggregate fields of "warrants_communications" */
export type Financials_Warrants_Communications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Financials_Warrants_Communications_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Financials_Warrants_Communications_Avg_Fields = {
  __typename?: "financials_warrants_communications_avg_fields"
  group_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  parent_priority_level?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "warrants_communications". All fields are combined with a logical 'AND'. */
export type Financials_Warrants_Communications_Bool_Exp = {
  _and?: InputMaybe<Array<Financials_Warrants_Communications_Bool_Exp>>
  _not?: InputMaybe<Financials_Warrants_Communications_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Warrants_Communications_Bool_Exp>>
  comms_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>
  delivery_external_status?: InputMaybe<String_Comparison_Exp>
  delivery_status?: InputMaybe<Warrant_Communication_Delivery_Status_Comparison_Exp>
  error_description?: InputMaybe<String_Comparison_Exp>
  group_id?: InputMaybe<Bigint_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  parent_priority_level?: InputMaybe<Int_Comparison_Exp>
  type?: InputMaybe<Warrant_Communication_Type_Comparison_Exp>
}

/** unique or primary key constraints on table "warrants_communications" */
export enum Financials_Warrants_Communications_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarrantsCommunicationsPkey = "warrants_communications_pkey",
}

/** input type for incrementing numeric columns in table "warrants_communications" */
export type Financials_Warrants_Communications_Inc_Input = {
  group_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  parent_priority_level?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "warrants_communications" */
export type Financials_Warrants_Communications_Insert_Input = {
  comms_id?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  delivery_external_status?: InputMaybe<Scalars["String"]["input"]>
  delivery_status?: InputMaybe<
    Scalars["warrant_communication_delivery_status"]["input"]
  >
  error_description?: InputMaybe<Scalars["String"]["input"]>
  group_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  parent_priority_level?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<Scalars["warrant_communication_type"]["input"]>
}

/** aggregate max on columns */
export type Financials_Warrants_Communications_Max_Fields = {
  __typename?: "financials_warrants_communications_max_fields"
  comms_id?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  delivery_external_status?: Maybe<Scalars["String"]["output"]>
  delivery_status?: Maybe<
    Scalars["warrant_communication_delivery_status"]["output"]
  >
  error_description?: Maybe<Scalars["String"]["output"]>
  group_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  parent_priority_level?: Maybe<Scalars["Int"]["output"]>
  type?: Maybe<Scalars["warrant_communication_type"]["output"]>
}

/** aggregate min on columns */
export type Financials_Warrants_Communications_Min_Fields = {
  __typename?: "financials_warrants_communications_min_fields"
  comms_id?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  delivery_external_status?: Maybe<Scalars["String"]["output"]>
  delivery_status?: Maybe<
    Scalars["warrant_communication_delivery_status"]["output"]
  >
  error_description?: Maybe<Scalars["String"]["output"]>
  group_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  parent_priority_level?: Maybe<Scalars["Int"]["output"]>
  type?: Maybe<Scalars["warrant_communication_type"]["output"]>
}

/** response of any mutation on the table "warrants_communications" */
export type Financials_Warrants_Communications_Mutation_Response = {
  __typename?: "financials_warrants_communications_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Warrants_Communications>
}

/** on_conflict condition type for table "warrants_communications" */
export type Financials_Warrants_Communications_On_Conflict = {
  constraint: Financials_Warrants_Communications_Constraint
  update_columns?: Array<Financials_Warrants_Communications_Update_Column>
  where?: InputMaybe<Financials_Warrants_Communications_Bool_Exp>
}

/** Ordering options when selecting data from "warrants_communications". */
export type Financials_Warrants_Communications_Order_By = {
  comms_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  delivery_external_status?: InputMaybe<Order_By>
  delivery_status?: InputMaybe<Order_By>
  error_description?: InputMaybe<Order_By>
  group_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  parent_priority_level?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
}

/** primary key columns input for table: warrants_communications */
export type Financials_Warrants_Communications_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "warrants_communications" */
export enum Financials_Warrants_Communications_Select_Column {
  /** column name */
  CommsId = "comms_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  DeliveryExternalStatus = "delivery_external_status",
  /** column name */
  DeliveryStatus = "delivery_status",
  /** column name */
  ErrorDescription = "error_description",
  /** column name */
  GroupId = "group_id",
  /** column name */
  Id = "id",
  /** column name */
  ParentPriorityLevel = "parent_priority_level",
  /** column name */
  Type = "type",
}

/** input type for updating data in table "warrants_communications" */
export type Financials_Warrants_Communications_Set_Input = {
  comms_id?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  delivery_external_status?: InputMaybe<Scalars["String"]["input"]>
  delivery_status?: InputMaybe<
    Scalars["warrant_communication_delivery_status"]["input"]
  >
  error_description?: InputMaybe<Scalars["String"]["input"]>
  group_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  parent_priority_level?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<Scalars["warrant_communication_type"]["input"]>
}

/** aggregate stddev on columns */
export type Financials_Warrants_Communications_Stddev_Fields = {
  __typename?: "financials_warrants_communications_stddev_fields"
  group_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  parent_priority_level?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Financials_Warrants_Communications_Stddev_Pop_Fields = {
  __typename?: "financials_warrants_communications_stddev_pop_fields"
  group_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  parent_priority_level?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Financials_Warrants_Communications_Stddev_Samp_Fields = {
  __typename?: "financials_warrants_communications_stddev_samp_fields"
  group_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  parent_priority_level?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "financials_warrants_communications" */
export type Financials_Warrants_Communications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Warrants_Communications_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Warrants_Communications_Stream_Cursor_Value_Input = {
  comms_id?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  delivery_external_status?: InputMaybe<Scalars["String"]["input"]>
  delivery_status?: InputMaybe<
    Scalars["warrant_communication_delivery_status"]["input"]
  >
  error_description?: InputMaybe<Scalars["String"]["input"]>
  group_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  parent_priority_level?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<Scalars["warrant_communication_type"]["input"]>
}

/** aggregate sum on columns */
export type Financials_Warrants_Communications_Sum_Fields = {
  __typename?: "financials_warrants_communications_sum_fields"
  group_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  parent_priority_level?: Maybe<Scalars["Int"]["output"]>
}

/** update columns of table "warrants_communications" */
export enum Financials_Warrants_Communications_Update_Column {
  /** column name */
  CommsId = "comms_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  DeliveryExternalStatus = "delivery_external_status",
  /** column name */
  DeliveryStatus = "delivery_status",
  /** column name */
  ErrorDescription = "error_description",
  /** column name */
  GroupId = "group_id",
  /** column name */
  Id = "id",
  /** column name */
  ParentPriorityLevel = "parent_priority_level",
  /** column name */
  Type = "type",
}

export type Financials_Warrants_Communications_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Financials_Warrants_Communications_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Warrants_Communications_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Warrants_Communications_Bool_Exp
}

/** aggregate var_pop on columns */
export type Financials_Warrants_Communications_Var_Pop_Fields = {
  __typename?: "financials_warrants_communications_var_pop_fields"
  group_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  parent_priority_level?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Financials_Warrants_Communications_Var_Samp_Fields = {
  __typename?: "financials_warrants_communications_var_samp_fields"
  group_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  parent_priority_level?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Financials_Warrants_Communications_Variance_Fields = {
  __typename?: "financials_warrants_communications_variance_fields"
  group_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  parent_priority_level?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "warrants_dca_queue" */
export type Financials_Warrants_Dca_Queue = {
  __typename?: "financials_warrants_dca_queue"
  account_number: Scalars["String"]["output"]
  created_at: Scalars["timestamp"]["output"]
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  processed_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregated selection of "warrants_dca_queue" */
export type Financials_Warrants_Dca_Queue_Aggregate = {
  __typename?: "financials_warrants_dca_queue_aggregate"
  aggregate?: Maybe<Financials_Warrants_Dca_Queue_Aggregate_Fields>
  nodes: Array<Financials_Warrants_Dca_Queue>
}

/** aggregate fields of "warrants_dca_queue" */
export type Financials_Warrants_Dca_Queue_Aggregate_Fields = {
  __typename?: "financials_warrants_dca_queue_aggregate_fields"
  avg?: Maybe<Financials_Warrants_Dca_Queue_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Warrants_Dca_Queue_Max_Fields>
  min?: Maybe<Financials_Warrants_Dca_Queue_Min_Fields>
  stddev?: Maybe<Financials_Warrants_Dca_Queue_Stddev_Fields>
  stddev_pop?: Maybe<Financials_Warrants_Dca_Queue_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Financials_Warrants_Dca_Queue_Stddev_Samp_Fields>
  sum?: Maybe<Financials_Warrants_Dca_Queue_Sum_Fields>
  var_pop?: Maybe<Financials_Warrants_Dca_Queue_Var_Pop_Fields>
  var_samp?: Maybe<Financials_Warrants_Dca_Queue_Var_Samp_Fields>
  variance?: Maybe<Financials_Warrants_Dca_Queue_Variance_Fields>
}

/** aggregate fields of "warrants_dca_queue" */
export type Financials_Warrants_Dca_Queue_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Financials_Warrants_Dca_Queue_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Financials_Warrants_Dca_Queue_Avg_Fields = {
  __typename?: "financials_warrants_dca_queue_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "warrants_dca_queue". All fields are combined with a logical 'AND'. */
export type Financials_Warrants_Dca_Queue_Bool_Exp = {
  _and?: InputMaybe<Array<Financials_Warrants_Dca_Queue_Bool_Exp>>
  _not?: InputMaybe<Financials_Warrants_Dca_Queue_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Warrants_Dca_Queue_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  processed_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "warrants_dca_queue" */
export enum Financials_Warrants_Dca_Queue_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarrantsDcaQueuePkey = "warrants_dca_queue_pkey",
}

/** input type for incrementing numeric columns in table "warrants_dca_queue" */
export type Financials_Warrants_Dca_Queue_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "warrants_dca_queue" */
export type Financials_Warrants_Dca_Queue_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  processed_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Financials_Warrants_Dca_Queue_Max_Fields = {
  __typename?: "financials_warrants_dca_queue_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  processed_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Financials_Warrants_Dca_Queue_Min_Fields = {
  __typename?: "financials_warrants_dca_queue_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  processed_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "warrants_dca_queue" */
export type Financials_Warrants_Dca_Queue_Mutation_Response = {
  __typename?: "financials_warrants_dca_queue_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Warrants_Dca_Queue>
}

/** on_conflict condition type for table "warrants_dca_queue" */
export type Financials_Warrants_Dca_Queue_On_Conflict = {
  constraint: Financials_Warrants_Dca_Queue_Constraint
  update_columns?: Array<Financials_Warrants_Dca_Queue_Update_Column>
  where?: InputMaybe<Financials_Warrants_Dca_Queue_Bool_Exp>
}

/** Ordering options when selecting data from "warrants_dca_queue". */
export type Financials_Warrants_Dca_Queue_Order_By = {
  account_number?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  processed_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: warrants_dca_queue */
export type Financials_Warrants_Dca_Queue_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "warrants_dca_queue" */
export enum Financials_Warrants_Dca_Queue_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  Id = "id",
  /** column name */
  ProcessedAt = "processed_at",
}

/** input type for updating data in table "warrants_dca_queue" */
export type Financials_Warrants_Dca_Queue_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  processed_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Financials_Warrants_Dca_Queue_Stddev_Fields = {
  __typename?: "financials_warrants_dca_queue_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Financials_Warrants_Dca_Queue_Stddev_Pop_Fields = {
  __typename?: "financials_warrants_dca_queue_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Financials_Warrants_Dca_Queue_Stddev_Samp_Fields = {
  __typename?: "financials_warrants_dca_queue_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "financials_warrants_dca_queue" */
export type Financials_Warrants_Dca_Queue_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Warrants_Dca_Queue_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Warrants_Dca_Queue_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  processed_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Financials_Warrants_Dca_Queue_Sum_Fields = {
  __typename?: "financials_warrants_dca_queue_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "warrants_dca_queue" */
export enum Financials_Warrants_Dca_Queue_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  Id = "id",
  /** column name */
  ProcessedAt = "processed_at",
}

export type Financials_Warrants_Dca_Queue_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Financials_Warrants_Dca_Queue_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Warrants_Dca_Queue_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Warrants_Dca_Queue_Bool_Exp
}

/** aggregate var_pop on columns */
export type Financials_Warrants_Dca_Queue_Var_Pop_Fields = {
  __typename?: "financials_warrants_dca_queue_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Financials_Warrants_Dca_Queue_Var_Samp_Fields = {
  __typename?: "financials_warrants_dca_queue_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Financials_Warrants_Dca_Queue_Variance_Fields = {
  __typename?: "financials_warrants_dca_queue_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "warrants_dca_tickets" */
export type Financials_Warrants_Dca_Tickets = {
  __typename?: "financials_warrants_dca_tickets"
  account_number: Scalars["String"]["output"]
  created_at: Scalars["timestamp"]["output"]
  dca_type: Scalars["warrants_dca_type"]["output"]
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  status: Scalars["warrants_dca_tickets_status"]["output"]
  ticket_definition?: Maybe<Scalars["String"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
  type: Scalars["warrants_ticket_type"]["output"]
  visit_type?: Maybe<Scalars["warrants_visit_type"]["output"]>
}

/** aggregated selection of "warrants_dca_tickets" */
export type Financials_Warrants_Dca_Tickets_Aggregate = {
  __typename?: "financials_warrants_dca_tickets_aggregate"
  aggregate?: Maybe<Financials_Warrants_Dca_Tickets_Aggregate_Fields>
  nodes: Array<Financials_Warrants_Dca_Tickets>
}

/** aggregate fields of "warrants_dca_tickets" */
export type Financials_Warrants_Dca_Tickets_Aggregate_Fields = {
  __typename?: "financials_warrants_dca_tickets_aggregate_fields"
  avg?: Maybe<Financials_Warrants_Dca_Tickets_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Warrants_Dca_Tickets_Max_Fields>
  min?: Maybe<Financials_Warrants_Dca_Tickets_Min_Fields>
  stddev?: Maybe<Financials_Warrants_Dca_Tickets_Stddev_Fields>
  stddev_pop?: Maybe<Financials_Warrants_Dca_Tickets_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Financials_Warrants_Dca_Tickets_Stddev_Samp_Fields>
  sum?: Maybe<Financials_Warrants_Dca_Tickets_Sum_Fields>
  var_pop?: Maybe<Financials_Warrants_Dca_Tickets_Var_Pop_Fields>
  var_samp?: Maybe<Financials_Warrants_Dca_Tickets_Var_Samp_Fields>
  variance?: Maybe<Financials_Warrants_Dca_Tickets_Variance_Fields>
}

/** aggregate fields of "warrants_dca_tickets" */
export type Financials_Warrants_Dca_Tickets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Financials_Warrants_Dca_Tickets_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Financials_Warrants_Dca_Tickets_Avg_Fields = {
  __typename?: "financials_warrants_dca_tickets_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "warrants_dca_tickets". All fields are combined with a logical 'AND'. */
export type Financials_Warrants_Dca_Tickets_Bool_Exp = {
  _and?: InputMaybe<Array<Financials_Warrants_Dca_Tickets_Bool_Exp>>
  _not?: InputMaybe<Financials_Warrants_Dca_Tickets_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Warrants_Dca_Tickets_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  dca_type?: InputMaybe<Warrants_Dca_Type_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  status?: InputMaybe<Warrants_Dca_Tickets_Status_Comparison_Exp>
  ticket_definition?: InputMaybe<String_Comparison_Exp>
  ticket_id?: InputMaybe<String_Comparison_Exp>
  ticket_step?: InputMaybe<String_Comparison_Exp>
  type?: InputMaybe<Warrants_Ticket_Type_Comparison_Exp>
  visit_type?: InputMaybe<Warrants_Visit_Type_Comparison_Exp>
}

/** unique or primary key constraints on table "warrants_dca_tickets" */
export enum Financials_Warrants_Dca_Tickets_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarrantsDcaTicketsPkey = "warrants_dca_tickets_pkey",
}

/** input type for incrementing numeric columns in table "warrants_dca_tickets" */
export type Financials_Warrants_Dca_Tickets_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "warrants_dca_tickets" */
export type Financials_Warrants_Dca_Tickets_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  dca_type?: InputMaybe<Scalars["warrants_dca_type"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["warrants_dca_tickets_status"]["input"]>
  ticket_definition?: InputMaybe<Scalars["String"]["input"]>
  ticket_id?: InputMaybe<Scalars["String"]["input"]>
  ticket_step?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["warrants_ticket_type"]["input"]>
  visit_type?: InputMaybe<Scalars["warrants_visit_type"]["input"]>
}

/** aggregate max on columns */
export type Financials_Warrants_Dca_Tickets_Max_Fields = {
  __typename?: "financials_warrants_dca_tickets_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  dca_type?: Maybe<Scalars["warrants_dca_type"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["warrants_dca_tickets_status"]["output"]>
  ticket_definition?: Maybe<Scalars["String"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["warrants_ticket_type"]["output"]>
  visit_type?: Maybe<Scalars["warrants_visit_type"]["output"]>
}

/** aggregate min on columns */
export type Financials_Warrants_Dca_Tickets_Min_Fields = {
  __typename?: "financials_warrants_dca_tickets_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  dca_type?: Maybe<Scalars["warrants_dca_type"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["warrants_dca_tickets_status"]["output"]>
  ticket_definition?: Maybe<Scalars["String"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["warrants_ticket_type"]["output"]>
  visit_type?: Maybe<Scalars["warrants_visit_type"]["output"]>
}

/** response of any mutation on the table "warrants_dca_tickets" */
export type Financials_Warrants_Dca_Tickets_Mutation_Response = {
  __typename?: "financials_warrants_dca_tickets_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Warrants_Dca_Tickets>
}

/** on_conflict condition type for table "warrants_dca_tickets" */
export type Financials_Warrants_Dca_Tickets_On_Conflict = {
  constraint: Financials_Warrants_Dca_Tickets_Constraint
  update_columns?: Array<Financials_Warrants_Dca_Tickets_Update_Column>
  where?: InputMaybe<Financials_Warrants_Dca_Tickets_Bool_Exp>
}

/** Ordering options when selecting data from "warrants_dca_tickets". */
export type Financials_Warrants_Dca_Tickets_Order_By = {
  account_number?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  dca_type?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  ticket_definition?: InputMaybe<Order_By>
  ticket_id?: InputMaybe<Order_By>
  ticket_step?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  visit_type?: InputMaybe<Order_By>
}

/** primary key columns input for table: warrants_dca_tickets */
export type Financials_Warrants_Dca_Tickets_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "warrants_dca_tickets" */
export enum Financials_Warrants_Dca_Tickets_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DcaType = "dca_type",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  TicketDefinition = "ticket_definition",
  /** column name */
  TicketId = "ticket_id",
  /** column name */
  TicketStep = "ticket_step",
  /** column name */
  Type = "type",
  /** column name */
  VisitType = "visit_type",
}

/** input type for updating data in table "warrants_dca_tickets" */
export type Financials_Warrants_Dca_Tickets_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  dca_type?: InputMaybe<Scalars["warrants_dca_type"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["warrants_dca_tickets_status"]["input"]>
  ticket_definition?: InputMaybe<Scalars["String"]["input"]>
  ticket_id?: InputMaybe<Scalars["String"]["input"]>
  ticket_step?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["warrants_ticket_type"]["input"]>
  visit_type?: InputMaybe<Scalars["warrants_visit_type"]["input"]>
}

/** aggregate stddev on columns */
export type Financials_Warrants_Dca_Tickets_Stddev_Fields = {
  __typename?: "financials_warrants_dca_tickets_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Financials_Warrants_Dca_Tickets_Stddev_Pop_Fields = {
  __typename?: "financials_warrants_dca_tickets_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Financials_Warrants_Dca_Tickets_Stddev_Samp_Fields = {
  __typename?: "financials_warrants_dca_tickets_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "financials_warrants_dca_tickets" */
export type Financials_Warrants_Dca_Tickets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Warrants_Dca_Tickets_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Warrants_Dca_Tickets_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  dca_type?: InputMaybe<Scalars["warrants_dca_type"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["warrants_dca_tickets_status"]["input"]>
  ticket_definition?: InputMaybe<Scalars["String"]["input"]>
  ticket_id?: InputMaybe<Scalars["String"]["input"]>
  ticket_step?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["warrants_ticket_type"]["input"]>
  visit_type?: InputMaybe<Scalars["warrants_visit_type"]["input"]>
}

/** aggregate sum on columns */
export type Financials_Warrants_Dca_Tickets_Sum_Fields = {
  __typename?: "financials_warrants_dca_tickets_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "warrants_dca_tickets" */
export enum Financials_Warrants_Dca_Tickets_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DcaType = "dca_type",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  TicketDefinition = "ticket_definition",
  /** column name */
  TicketId = "ticket_id",
  /** column name */
  TicketStep = "ticket_step",
  /** column name */
  Type = "type",
  /** column name */
  VisitType = "visit_type",
}

export type Financials_Warrants_Dca_Tickets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Financials_Warrants_Dca_Tickets_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Warrants_Dca_Tickets_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Warrants_Dca_Tickets_Bool_Exp
}

/** aggregate var_pop on columns */
export type Financials_Warrants_Dca_Tickets_Var_Pop_Fields = {
  __typename?: "financials_warrants_dca_tickets_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Financials_Warrants_Dca_Tickets_Var_Samp_Fields = {
  __typename?: "financials_warrants_dca_tickets_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Financials_Warrants_Dca_Tickets_Variance_Fields = {
  __typename?: "financials_warrants_dca_tickets_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "warrants_files_account" */
export type Financials_Warrants_Files_Account = {
  __typename?: "financials_warrants_files_account"
  account_number: Scalars["String"]["output"]
  created_at: Scalars["timestamp"]["output"]
  customer_name?: Maybe<Scalars["String"]["output"]>
  data?: Maybe<Scalars["jsonb"]["output"]>
  dca_type: Scalars["warrants_files_dca_type"]["output"]
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  error_message?: Maybe<Scalars["String"]["output"]>
  file_type: Scalars["warrants_files_type"]["output"]
  id: Scalars["bigint"]["output"]
  job_id: Scalars["bigint"]["output"]
  retry_count: Scalars["Int"]["output"]
  status: Scalars["warrants_files_account_status"]["output"]
}

/** columns and relationships of "warrants_files_account" */
export type Financials_Warrants_Files_AccountDataArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregated selection of "warrants_files_account" */
export type Financials_Warrants_Files_Account_Aggregate = {
  __typename?: "financials_warrants_files_account_aggregate"
  aggregate?: Maybe<Financials_Warrants_Files_Account_Aggregate_Fields>
  nodes: Array<Financials_Warrants_Files_Account>
}

/** aggregate fields of "warrants_files_account" */
export type Financials_Warrants_Files_Account_Aggregate_Fields = {
  __typename?: "financials_warrants_files_account_aggregate_fields"
  avg?: Maybe<Financials_Warrants_Files_Account_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Warrants_Files_Account_Max_Fields>
  min?: Maybe<Financials_Warrants_Files_Account_Min_Fields>
  stddev?: Maybe<Financials_Warrants_Files_Account_Stddev_Fields>
  stddev_pop?: Maybe<Financials_Warrants_Files_Account_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Financials_Warrants_Files_Account_Stddev_Samp_Fields>
  sum?: Maybe<Financials_Warrants_Files_Account_Sum_Fields>
  var_pop?: Maybe<Financials_Warrants_Files_Account_Var_Pop_Fields>
  var_samp?: Maybe<Financials_Warrants_Files_Account_Var_Samp_Fields>
  variance?: Maybe<Financials_Warrants_Files_Account_Variance_Fields>
}

/** aggregate fields of "warrants_files_account" */
export type Financials_Warrants_Files_Account_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Financials_Warrants_Files_Account_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Financials_Warrants_Files_Account_Append_Input = {
  data?: InputMaybe<Scalars["jsonb"]["input"]>
}

/** aggregate avg on columns */
export type Financials_Warrants_Files_Account_Avg_Fields = {
  __typename?: "financials_warrants_files_account_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  job_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "warrants_files_account". All fields are combined with a logical 'AND'. */
export type Financials_Warrants_Files_Account_Bool_Exp = {
  _and?: InputMaybe<Array<Financials_Warrants_Files_Account_Bool_Exp>>
  _not?: InputMaybe<Financials_Warrants_Files_Account_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Warrants_Files_Account_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  customer_name?: InputMaybe<String_Comparison_Exp>
  data?: InputMaybe<Jsonb_Comparison_Exp>
  dca_type?: InputMaybe<Warrants_Files_Dca_Type_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>
  error_message?: InputMaybe<String_Comparison_Exp>
  file_type?: InputMaybe<Warrants_Files_Type_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  job_id?: InputMaybe<Bigint_Comparison_Exp>
  retry_count?: InputMaybe<Int_Comparison_Exp>
  status?: InputMaybe<Warrants_Files_Account_Status_Comparison_Exp>
}

/** unique or primary key constraints on table "warrants_files_account" */
export enum Financials_Warrants_Files_Account_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarrantsFilesAccountPkey = "warrants_files_account_pkey",
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Financials_Warrants_Files_Account_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars["String"]["input"]>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Financials_Warrants_Files_Account_Delete_Elem_Input = {
  data?: InputMaybe<Scalars["Int"]["input"]>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Financials_Warrants_Files_Account_Delete_Key_Input = {
  data?: InputMaybe<Scalars["String"]["input"]>
}

/** input type for incrementing numeric columns in table "warrants_files_account" */
export type Financials_Warrants_Files_Account_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  job_id?: InputMaybe<Scalars["bigint"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "warrants_files_account" */
export type Financials_Warrants_Files_Account_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_name?: InputMaybe<Scalars["String"]["input"]>
  data?: InputMaybe<Scalars["jsonb"]["input"]>
  dca_type?: InputMaybe<Scalars["warrants_files_dca_type"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  error_message?: InputMaybe<Scalars["String"]["input"]>
  file_type?: InputMaybe<Scalars["warrants_files_type"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  job_id?: InputMaybe<Scalars["bigint"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  status?: InputMaybe<Scalars["warrants_files_account_status"]["input"]>
}

/** aggregate max on columns */
export type Financials_Warrants_Files_Account_Max_Fields = {
  __typename?: "financials_warrants_files_account_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_name?: Maybe<Scalars["String"]["output"]>
  dca_type?: Maybe<Scalars["warrants_files_dca_type"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  error_message?: Maybe<Scalars["String"]["output"]>
  file_type?: Maybe<Scalars["warrants_files_type"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  job_id?: Maybe<Scalars["bigint"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
  status?: Maybe<Scalars["warrants_files_account_status"]["output"]>
}

/** aggregate min on columns */
export type Financials_Warrants_Files_Account_Min_Fields = {
  __typename?: "financials_warrants_files_account_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_name?: Maybe<Scalars["String"]["output"]>
  dca_type?: Maybe<Scalars["warrants_files_dca_type"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  error_message?: Maybe<Scalars["String"]["output"]>
  file_type?: Maybe<Scalars["warrants_files_type"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  job_id?: Maybe<Scalars["bigint"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
  status?: Maybe<Scalars["warrants_files_account_status"]["output"]>
}

/** response of any mutation on the table "warrants_files_account" */
export type Financials_Warrants_Files_Account_Mutation_Response = {
  __typename?: "financials_warrants_files_account_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Warrants_Files_Account>
}

/** on_conflict condition type for table "warrants_files_account" */
export type Financials_Warrants_Files_Account_On_Conflict = {
  constraint: Financials_Warrants_Files_Account_Constraint
  update_columns?: Array<Financials_Warrants_Files_Account_Update_Column>
  where?: InputMaybe<Financials_Warrants_Files_Account_Bool_Exp>
}

/** Ordering options when selecting data from "warrants_files_account". */
export type Financials_Warrants_Files_Account_Order_By = {
  account_number?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  customer_name?: InputMaybe<Order_By>
  data?: InputMaybe<Order_By>
  dca_type?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  error_message?: InputMaybe<Order_By>
  file_type?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_id?: InputMaybe<Order_By>
  retry_count?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
}

/** primary key columns input for table: warrants_files_account */
export type Financials_Warrants_Files_Account_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Financials_Warrants_Files_Account_Prepend_Input = {
  data?: InputMaybe<Scalars["jsonb"]["input"]>
}

/** select columns of table "warrants_files_account" */
export enum Financials_Warrants_Files_Account_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerName = "customer_name",
  /** column name */
  Data = "data",
  /** column name */
  DcaType = "dca_type",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  ErrorMessage = "error_message",
  /** column name */
  FileType = "file_type",
  /** column name */
  Id = "id",
  /** column name */
  JobId = "job_id",
  /** column name */
  RetryCount = "retry_count",
  /** column name */
  Status = "status",
}

/** input type for updating data in table "warrants_files_account" */
export type Financials_Warrants_Files_Account_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_name?: InputMaybe<Scalars["String"]["input"]>
  data?: InputMaybe<Scalars["jsonb"]["input"]>
  dca_type?: InputMaybe<Scalars["warrants_files_dca_type"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  error_message?: InputMaybe<Scalars["String"]["input"]>
  file_type?: InputMaybe<Scalars["warrants_files_type"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  job_id?: InputMaybe<Scalars["bigint"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  status?: InputMaybe<Scalars["warrants_files_account_status"]["input"]>
}

/** aggregate stddev on columns */
export type Financials_Warrants_Files_Account_Stddev_Fields = {
  __typename?: "financials_warrants_files_account_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  job_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Financials_Warrants_Files_Account_Stddev_Pop_Fields = {
  __typename?: "financials_warrants_files_account_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  job_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Financials_Warrants_Files_Account_Stddev_Samp_Fields = {
  __typename?: "financials_warrants_files_account_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  job_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "financials_warrants_files_account" */
export type Financials_Warrants_Files_Account_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Warrants_Files_Account_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Warrants_Files_Account_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_name?: InputMaybe<Scalars["String"]["input"]>
  data?: InputMaybe<Scalars["jsonb"]["input"]>
  dca_type?: InputMaybe<Scalars["warrants_files_dca_type"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  error_message?: InputMaybe<Scalars["String"]["input"]>
  file_type?: InputMaybe<Scalars["warrants_files_type"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  job_id?: InputMaybe<Scalars["bigint"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  status?: InputMaybe<Scalars["warrants_files_account_status"]["input"]>
}

/** aggregate sum on columns */
export type Financials_Warrants_Files_Account_Sum_Fields = {
  __typename?: "financials_warrants_files_account_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  job_id?: Maybe<Scalars["bigint"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
}

/** update columns of table "warrants_files_account" */
export enum Financials_Warrants_Files_Account_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerName = "customer_name",
  /** column name */
  Data = "data",
  /** column name */
  DcaType = "dca_type",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  ErrorMessage = "error_message",
  /** column name */
  FileType = "file_type",
  /** column name */
  Id = "id",
  /** column name */
  JobId = "job_id",
  /** column name */
  RetryCount = "retry_count",
  /** column name */
  Status = "status",
}

export type Financials_Warrants_Files_Account_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Financials_Warrants_Files_Account_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Financials_Warrants_Files_Account_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Financials_Warrants_Files_Account_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Financials_Warrants_Files_Account_Delete_Key_Input>
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Financials_Warrants_Files_Account_Inc_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Financials_Warrants_Files_Account_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Warrants_Files_Account_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Warrants_Files_Account_Bool_Exp
}

/** aggregate var_pop on columns */
export type Financials_Warrants_Files_Account_Var_Pop_Fields = {
  __typename?: "financials_warrants_files_account_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  job_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Financials_Warrants_Files_Account_Var_Samp_Fields = {
  __typename?: "financials_warrants_files_account_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  job_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Financials_Warrants_Files_Account_Variance_Fields = {
  __typename?: "financials_warrants_files_account_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  job_id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "warrants_files_job" */
export type Financials_Warrants_Files_Job = {
  __typename?: "financials_warrants_files_job"
  created_at: Scalars["timestamp"]["output"]
  ended_at?: Maybe<Scalars["timestamp"]["output"]>
  error_message?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  started_at: Scalars["timestamp"]["output"]
  status: Scalars["warrants_files_job_status"]["output"]
}

/** aggregated selection of "warrants_files_job" */
export type Financials_Warrants_Files_Job_Aggregate = {
  __typename?: "financials_warrants_files_job_aggregate"
  aggregate?: Maybe<Financials_Warrants_Files_Job_Aggregate_Fields>
  nodes: Array<Financials_Warrants_Files_Job>
}

/** aggregate fields of "warrants_files_job" */
export type Financials_Warrants_Files_Job_Aggregate_Fields = {
  __typename?: "financials_warrants_files_job_aggregate_fields"
  avg?: Maybe<Financials_Warrants_Files_Job_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Warrants_Files_Job_Max_Fields>
  min?: Maybe<Financials_Warrants_Files_Job_Min_Fields>
  stddev?: Maybe<Financials_Warrants_Files_Job_Stddev_Fields>
  stddev_pop?: Maybe<Financials_Warrants_Files_Job_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Financials_Warrants_Files_Job_Stddev_Samp_Fields>
  sum?: Maybe<Financials_Warrants_Files_Job_Sum_Fields>
  var_pop?: Maybe<Financials_Warrants_Files_Job_Var_Pop_Fields>
  var_samp?: Maybe<Financials_Warrants_Files_Job_Var_Samp_Fields>
  variance?: Maybe<Financials_Warrants_Files_Job_Variance_Fields>
}

/** aggregate fields of "warrants_files_job" */
export type Financials_Warrants_Files_Job_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Financials_Warrants_Files_Job_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Financials_Warrants_Files_Job_Avg_Fields = {
  __typename?: "financials_warrants_files_job_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "warrants_files_job". All fields are combined with a logical 'AND'. */
export type Financials_Warrants_Files_Job_Bool_Exp = {
  _and?: InputMaybe<Array<Financials_Warrants_Files_Job_Bool_Exp>>
  _not?: InputMaybe<Financials_Warrants_Files_Job_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Warrants_Files_Job_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  ended_at?: InputMaybe<Timestamp_Comparison_Exp>
  error_message?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  started_at?: InputMaybe<Timestamp_Comparison_Exp>
  status?: InputMaybe<Warrants_Files_Job_Status_Comparison_Exp>
}

/** unique or primary key constraints on table "warrants_files_job" */
export enum Financials_Warrants_Files_Job_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarrantsFilesJobPkey = "warrants_files_job_pkey",
}

/** input type for incrementing numeric columns in table "warrants_files_job" */
export type Financials_Warrants_Files_Job_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "warrants_files_job" */
export type Financials_Warrants_Files_Job_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  ended_at?: InputMaybe<Scalars["timestamp"]["input"]>
  error_message?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  started_at?: InputMaybe<Scalars["timestamp"]["input"]>
  status?: InputMaybe<Scalars["warrants_files_job_status"]["input"]>
}

/** aggregate max on columns */
export type Financials_Warrants_Files_Job_Max_Fields = {
  __typename?: "financials_warrants_files_job_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  ended_at?: Maybe<Scalars["timestamp"]["output"]>
  error_message?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  started_at?: Maybe<Scalars["timestamp"]["output"]>
  status?: Maybe<Scalars["warrants_files_job_status"]["output"]>
}

/** aggregate min on columns */
export type Financials_Warrants_Files_Job_Min_Fields = {
  __typename?: "financials_warrants_files_job_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  ended_at?: Maybe<Scalars["timestamp"]["output"]>
  error_message?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  started_at?: Maybe<Scalars["timestamp"]["output"]>
  status?: Maybe<Scalars["warrants_files_job_status"]["output"]>
}

/** response of any mutation on the table "warrants_files_job" */
export type Financials_Warrants_Files_Job_Mutation_Response = {
  __typename?: "financials_warrants_files_job_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Warrants_Files_Job>
}

/** on_conflict condition type for table "warrants_files_job" */
export type Financials_Warrants_Files_Job_On_Conflict = {
  constraint: Financials_Warrants_Files_Job_Constraint
  update_columns?: Array<Financials_Warrants_Files_Job_Update_Column>
  where?: InputMaybe<Financials_Warrants_Files_Job_Bool_Exp>
}

/** Ordering options when selecting data from "warrants_files_job". */
export type Financials_Warrants_Files_Job_Order_By = {
  created_at?: InputMaybe<Order_By>
  ended_at?: InputMaybe<Order_By>
  error_message?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  started_at?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
}

/** primary key columns input for table: warrants_files_job */
export type Financials_Warrants_Files_Job_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "warrants_files_job" */
export enum Financials_Warrants_Files_Job_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  EndedAt = "ended_at",
  /** column name */
  ErrorMessage = "error_message",
  /** column name */
  Id = "id",
  /** column name */
  StartedAt = "started_at",
  /** column name */
  Status = "status",
}

/** input type for updating data in table "warrants_files_job" */
export type Financials_Warrants_Files_Job_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  ended_at?: InputMaybe<Scalars["timestamp"]["input"]>
  error_message?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  started_at?: InputMaybe<Scalars["timestamp"]["input"]>
  status?: InputMaybe<Scalars["warrants_files_job_status"]["input"]>
}

/** aggregate stddev on columns */
export type Financials_Warrants_Files_Job_Stddev_Fields = {
  __typename?: "financials_warrants_files_job_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Financials_Warrants_Files_Job_Stddev_Pop_Fields = {
  __typename?: "financials_warrants_files_job_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Financials_Warrants_Files_Job_Stddev_Samp_Fields = {
  __typename?: "financials_warrants_files_job_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "financials_warrants_files_job" */
export type Financials_Warrants_Files_Job_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Warrants_Files_Job_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Warrants_Files_Job_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  ended_at?: InputMaybe<Scalars["timestamp"]["input"]>
  error_message?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  started_at?: InputMaybe<Scalars["timestamp"]["input"]>
  status?: InputMaybe<Scalars["warrants_files_job_status"]["input"]>
}

/** aggregate sum on columns */
export type Financials_Warrants_Files_Job_Sum_Fields = {
  __typename?: "financials_warrants_files_job_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "warrants_files_job" */
export enum Financials_Warrants_Files_Job_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  EndedAt = "ended_at",
  /** column name */
  ErrorMessage = "error_message",
  /** column name */
  Id = "id",
  /** column name */
  StartedAt = "started_at",
  /** column name */
  Status = "status",
}

export type Financials_Warrants_Files_Job_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Financials_Warrants_Files_Job_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Warrants_Files_Job_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Warrants_Files_Job_Bool_Exp
}

/** aggregate var_pop on columns */
export type Financials_Warrants_Files_Job_Var_Pop_Fields = {
  __typename?: "financials_warrants_files_job_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Financials_Warrants_Files_Job_Var_Samp_Fields = {
  __typename?: "financials_warrants_files_job_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Financials_Warrants_Files_Job_Variance_Fields = {
  __typename?: "financials_warrants_files_job_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "warrants_files_processed" */
export type Financials_Warrants_Files_Processed = {
  __typename?: "financials_warrants_files_processed"
  created_at: Scalars["timestamp"]["output"]
  dca_type: Scalars["warrants_files_dca_type"]["output"]
  file_name: Scalars["String"]["output"]
  file_type: Scalars["warrants_files_type"]["output"]
  folder: Scalars["String"]["output"]
  id: Scalars["bigint"]["output"]
  job_id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregated selection of "warrants_files_processed" */
export type Financials_Warrants_Files_Processed_Aggregate = {
  __typename?: "financials_warrants_files_processed_aggregate"
  aggregate?: Maybe<Financials_Warrants_Files_Processed_Aggregate_Fields>
  nodes: Array<Financials_Warrants_Files_Processed>
}

/** aggregate fields of "warrants_files_processed" */
export type Financials_Warrants_Files_Processed_Aggregate_Fields = {
  __typename?: "financials_warrants_files_processed_aggregate_fields"
  avg?: Maybe<Financials_Warrants_Files_Processed_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Warrants_Files_Processed_Max_Fields>
  min?: Maybe<Financials_Warrants_Files_Processed_Min_Fields>
  stddev?: Maybe<Financials_Warrants_Files_Processed_Stddev_Fields>
  stddev_pop?: Maybe<Financials_Warrants_Files_Processed_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Financials_Warrants_Files_Processed_Stddev_Samp_Fields>
  sum?: Maybe<Financials_Warrants_Files_Processed_Sum_Fields>
  var_pop?: Maybe<Financials_Warrants_Files_Processed_Var_Pop_Fields>
  var_samp?: Maybe<Financials_Warrants_Files_Processed_Var_Samp_Fields>
  variance?: Maybe<Financials_Warrants_Files_Processed_Variance_Fields>
}

/** aggregate fields of "warrants_files_processed" */
export type Financials_Warrants_Files_Processed_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Financials_Warrants_Files_Processed_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Financials_Warrants_Files_Processed_Avg_Fields = {
  __typename?: "financials_warrants_files_processed_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  job_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "warrants_files_processed". All fields are combined with a logical 'AND'. */
export type Financials_Warrants_Files_Processed_Bool_Exp = {
  _and?: InputMaybe<Array<Financials_Warrants_Files_Processed_Bool_Exp>>
  _not?: InputMaybe<Financials_Warrants_Files_Processed_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Warrants_Files_Processed_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  dca_type?: InputMaybe<Warrants_Files_Dca_Type_Comparison_Exp>
  file_name?: InputMaybe<String_Comparison_Exp>
  file_type?: InputMaybe<Warrants_Files_Type_Comparison_Exp>
  folder?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  job_id?: InputMaybe<Bigint_Comparison_Exp>
}

/** unique or primary key constraints on table "warrants_files_processed" */
export enum Financials_Warrants_Files_Processed_Constraint {
  /** unique or primary key constraint on columns "file_name", "file_type", "dca_type" */
  UqWarrantsFilesProcessed = "uq_warrants_files_processed",
  /** unique or primary key constraint on columns "id" */
  WarrantsFilesProcessedPkey = "warrants_files_processed_pkey",
}

/** input type for incrementing numeric columns in table "warrants_files_processed" */
export type Financials_Warrants_Files_Processed_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  job_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "warrants_files_processed" */
export type Financials_Warrants_Files_Processed_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  dca_type?: InputMaybe<Scalars["warrants_files_dca_type"]["input"]>
  file_name?: InputMaybe<Scalars["String"]["input"]>
  file_type?: InputMaybe<Scalars["warrants_files_type"]["input"]>
  folder?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  job_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate max on columns */
export type Financials_Warrants_Files_Processed_Max_Fields = {
  __typename?: "financials_warrants_files_processed_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  dca_type?: Maybe<Scalars["warrants_files_dca_type"]["output"]>
  file_name?: Maybe<Scalars["String"]["output"]>
  file_type?: Maybe<Scalars["warrants_files_type"]["output"]>
  folder?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  job_id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregate min on columns */
export type Financials_Warrants_Files_Processed_Min_Fields = {
  __typename?: "financials_warrants_files_processed_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  dca_type?: Maybe<Scalars["warrants_files_dca_type"]["output"]>
  file_name?: Maybe<Scalars["String"]["output"]>
  file_type?: Maybe<Scalars["warrants_files_type"]["output"]>
  folder?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  job_id?: Maybe<Scalars["bigint"]["output"]>
}

/** response of any mutation on the table "warrants_files_processed" */
export type Financials_Warrants_Files_Processed_Mutation_Response = {
  __typename?: "financials_warrants_files_processed_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Warrants_Files_Processed>
}

/** on_conflict condition type for table "warrants_files_processed" */
export type Financials_Warrants_Files_Processed_On_Conflict = {
  constraint: Financials_Warrants_Files_Processed_Constraint
  update_columns?: Array<Financials_Warrants_Files_Processed_Update_Column>
  where?: InputMaybe<Financials_Warrants_Files_Processed_Bool_Exp>
}

/** Ordering options when selecting data from "warrants_files_processed". */
export type Financials_Warrants_Files_Processed_Order_By = {
  created_at?: InputMaybe<Order_By>
  dca_type?: InputMaybe<Order_By>
  file_name?: InputMaybe<Order_By>
  file_type?: InputMaybe<Order_By>
  folder?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: warrants_files_processed */
export type Financials_Warrants_Files_Processed_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "warrants_files_processed" */
export enum Financials_Warrants_Files_Processed_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DcaType = "dca_type",
  /** column name */
  FileName = "file_name",
  /** column name */
  FileType = "file_type",
  /** column name */
  Folder = "folder",
  /** column name */
  Id = "id",
  /** column name */
  JobId = "job_id",
}

/** input type for updating data in table "warrants_files_processed" */
export type Financials_Warrants_Files_Processed_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  dca_type?: InputMaybe<Scalars["warrants_files_dca_type"]["input"]>
  file_name?: InputMaybe<Scalars["String"]["input"]>
  file_type?: InputMaybe<Scalars["warrants_files_type"]["input"]>
  folder?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  job_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate stddev on columns */
export type Financials_Warrants_Files_Processed_Stddev_Fields = {
  __typename?: "financials_warrants_files_processed_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  job_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Financials_Warrants_Files_Processed_Stddev_Pop_Fields = {
  __typename?: "financials_warrants_files_processed_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  job_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Financials_Warrants_Files_Processed_Stddev_Samp_Fields = {
  __typename?: "financials_warrants_files_processed_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  job_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "financials_warrants_files_processed" */
export type Financials_Warrants_Files_Processed_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Warrants_Files_Processed_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Warrants_Files_Processed_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  dca_type?: InputMaybe<Scalars["warrants_files_dca_type"]["input"]>
  file_name?: InputMaybe<Scalars["String"]["input"]>
  file_type?: InputMaybe<Scalars["warrants_files_type"]["input"]>
  folder?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  job_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate sum on columns */
export type Financials_Warrants_Files_Processed_Sum_Fields = {
  __typename?: "financials_warrants_files_processed_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  job_id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "warrants_files_processed" */
export enum Financials_Warrants_Files_Processed_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DcaType = "dca_type",
  /** column name */
  FileName = "file_name",
  /** column name */
  FileType = "file_type",
  /** column name */
  Folder = "folder",
  /** column name */
  Id = "id",
  /** column name */
  JobId = "job_id",
}

export type Financials_Warrants_Files_Processed_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Financials_Warrants_Files_Processed_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Warrants_Files_Processed_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Warrants_Files_Processed_Bool_Exp
}

/** aggregate var_pop on columns */
export type Financials_Warrants_Files_Processed_Var_Pop_Fields = {
  __typename?: "financials_warrants_files_processed_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  job_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Financials_Warrants_Files_Processed_Var_Samp_Fields = {
  __typename?: "financials_warrants_files_processed_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  job_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Financials_Warrants_Files_Processed_Variance_Fields = {
  __typename?: "financials_warrants_files_processed_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  job_id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "warrants_job" */
export type Financials_Warrants_Job = {
  __typename?: "financials_warrants_job"
  created_at: Scalars["timestamp"]["output"]
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  ended_at?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  message?: Maybe<Scalars["String"]["output"]>
  started_at: Scalars["timestamp"]["output"]
  status: Scalars["warrants_job_status"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "warrants_job" */
export type Financials_Warrants_Job_Aggregate = {
  __typename?: "financials_warrants_job_aggregate"
  aggregate?: Maybe<Financials_Warrants_Job_Aggregate_Fields>
  nodes: Array<Financials_Warrants_Job>
}

/** aggregate fields of "warrants_job" */
export type Financials_Warrants_Job_Aggregate_Fields = {
  __typename?: "financials_warrants_job_aggregate_fields"
  avg?: Maybe<Financials_Warrants_Job_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Financials_Warrants_Job_Max_Fields>
  min?: Maybe<Financials_Warrants_Job_Min_Fields>
  stddev?: Maybe<Financials_Warrants_Job_Stddev_Fields>
  stddev_pop?: Maybe<Financials_Warrants_Job_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Financials_Warrants_Job_Stddev_Samp_Fields>
  sum?: Maybe<Financials_Warrants_Job_Sum_Fields>
  var_pop?: Maybe<Financials_Warrants_Job_Var_Pop_Fields>
  var_samp?: Maybe<Financials_Warrants_Job_Var_Samp_Fields>
  variance?: Maybe<Financials_Warrants_Job_Variance_Fields>
}

/** aggregate fields of "warrants_job" */
export type Financials_Warrants_Job_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Financials_Warrants_Job_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Financials_Warrants_Job_Avg_Fields = {
  __typename?: "financials_warrants_job_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "warrants_job". All fields are combined with a logical 'AND'. */
export type Financials_Warrants_Job_Bool_Exp = {
  _and?: InputMaybe<Array<Financials_Warrants_Job_Bool_Exp>>
  _not?: InputMaybe<Financials_Warrants_Job_Bool_Exp>
  _or?: InputMaybe<Array<Financials_Warrants_Job_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>
  ended_at?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  message?: InputMaybe<String_Comparison_Exp>
  started_at?: InputMaybe<Timestamp_Comparison_Exp>
  status?: InputMaybe<Warrants_Job_Status_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "warrants_job" */
export enum Financials_Warrants_Job_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarrantsJobPkey = "warrants_job_pkey",
}

/** input type for incrementing numeric columns in table "warrants_job" */
export type Financials_Warrants_Job_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "warrants_job" */
export type Financials_Warrants_Job_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  ended_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  message?: InputMaybe<Scalars["String"]["input"]>
  started_at?: InputMaybe<Scalars["timestamp"]["input"]>
  status?: InputMaybe<Scalars["warrants_job_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Financials_Warrants_Job_Max_Fields = {
  __typename?: "financials_warrants_job_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  ended_at?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  message?: Maybe<Scalars["String"]["output"]>
  started_at?: Maybe<Scalars["timestamp"]["output"]>
  status?: Maybe<Scalars["warrants_job_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Financials_Warrants_Job_Min_Fields = {
  __typename?: "financials_warrants_job_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted_at?: Maybe<Scalars["timestamp"]["output"]>
  ended_at?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  message?: Maybe<Scalars["String"]["output"]>
  started_at?: Maybe<Scalars["timestamp"]["output"]>
  status?: Maybe<Scalars["warrants_job_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "warrants_job" */
export type Financials_Warrants_Job_Mutation_Response = {
  __typename?: "financials_warrants_job_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Financials_Warrants_Job>
}

/** on_conflict condition type for table "warrants_job" */
export type Financials_Warrants_Job_On_Conflict = {
  constraint: Financials_Warrants_Job_Constraint
  update_columns?: Array<Financials_Warrants_Job_Update_Column>
  where?: InputMaybe<Financials_Warrants_Job_Bool_Exp>
}

/** Ordering options when selecting data from "warrants_job". */
export type Financials_Warrants_Job_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted_at?: InputMaybe<Order_By>
  ended_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  message?: InputMaybe<Order_By>
  started_at?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: warrants_job */
export type Financials_Warrants_Job_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "warrants_job" */
export enum Financials_Warrants_Job_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  EndedAt = "ended_at",
  /** column name */
  Id = "id",
  /** column name */
  Message = "message",
  /** column name */
  StartedAt = "started_at",
  /** column name */
  Status = "status",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "warrants_job" */
export type Financials_Warrants_Job_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  ended_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  message?: InputMaybe<Scalars["String"]["input"]>
  started_at?: InputMaybe<Scalars["timestamp"]["input"]>
  status?: InputMaybe<Scalars["warrants_job_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Financials_Warrants_Job_Stddev_Fields = {
  __typename?: "financials_warrants_job_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Financials_Warrants_Job_Stddev_Pop_Fields = {
  __typename?: "financials_warrants_job_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Financials_Warrants_Job_Stddev_Samp_Fields = {
  __typename?: "financials_warrants_job_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "financials_warrants_job" */
export type Financials_Warrants_Job_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Financials_Warrants_Job_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Financials_Warrants_Job_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted_at?: InputMaybe<Scalars["timestamp"]["input"]>
  ended_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  message?: InputMaybe<Scalars["String"]["input"]>
  started_at?: InputMaybe<Scalars["timestamp"]["input"]>
  status?: InputMaybe<Scalars["warrants_job_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Financials_Warrants_Job_Sum_Fields = {
  __typename?: "financials_warrants_job_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "warrants_job" */
export enum Financials_Warrants_Job_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DeletedAt = "deleted_at",
  /** column name */
  EndedAt = "ended_at",
  /** column name */
  Id = "id",
  /** column name */
  Message = "message",
  /** column name */
  StartedAt = "started_at",
  /** column name */
  Status = "status",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Financials_Warrants_Job_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Financials_Warrants_Job_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Warrants_Job_Set_Input>
  /** filter the rows which have to be updated */
  where: Financials_Warrants_Job_Bool_Exp
}

/** aggregate var_pop on columns */
export type Financials_Warrants_Job_Var_Pop_Fields = {
  __typename?: "financials_warrants_job_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Financials_Warrants_Job_Var_Samp_Fields = {
  __typename?: "financials_warrants_job_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Financials_Warrants_Job_Variance_Fields = {
  __typename?: "financials_warrants_job_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "find_test_accounts" */
export type Find_Test_Accounts = {
  __typename?: "find_test_accounts"
  account_num?: Maybe<Scalars["String"]["output"]>
  billing_acc_id?: Maybe<Scalars["bigint"]["output"]>
  fuel_type?: Maybe<Scalars["String"]["output"]>
  has_smart_meter?: Maybe<Scalars["Boolean"]["output"]>
  inside_renewal_window?: Maybe<Scalars["Boolean"]["output"]>
  is_active_agreement?: Maybe<Scalars["Boolean"]["output"]>
  is_seasonal?: Maybe<Scalars["Boolean"]["output"]>
  latest_status?: Maybe<Scalars["String"]["output"]>
  multi_meterpoints?: Maybe<Scalars["Boolean"]["output"]>
  to_date?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregated selection of "find_test_accounts" */
export type Find_Test_Accounts_Aggregate = {
  __typename?: "find_test_accounts_aggregate"
  aggregate?: Maybe<Find_Test_Accounts_Aggregate_Fields>
  nodes: Array<Find_Test_Accounts>
}

/** aggregate fields of "find_test_accounts" */
export type Find_Test_Accounts_Aggregate_Fields = {
  __typename?: "find_test_accounts_aggregate_fields"
  avg?: Maybe<Find_Test_Accounts_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Find_Test_Accounts_Max_Fields>
  min?: Maybe<Find_Test_Accounts_Min_Fields>
  stddev?: Maybe<Find_Test_Accounts_Stddev_Fields>
  stddev_pop?: Maybe<Find_Test_Accounts_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Find_Test_Accounts_Stddev_Samp_Fields>
  sum?: Maybe<Find_Test_Accounts_Sum_Fields>
  var_pop?: Maybe<Find_Test_Accounts_Var_Pop_Fields>
  var_samp?: Maybe<Find_Test_Accounts_Var_Samp_Fields>
  variance?: Maybe<Find_Test_Accounts_Variance_Fields>
}

/** aggregate fields of "find_test_accounts" */
export type Find_Test_Accounts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Find_Test_Accounts_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Find_Test_Accounts_Avg_Fields = {
  __typename?: "find_test_accounts_avg_fields"
  billing_acc_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "find_test_accounts". All fields are combined with a logical 'AND'. */
export type Find_Test_Accounts_Bool_Exp = {
  _and?: InputMaybe<Array<Find_Test_Accounts_Bool_Exp>>
  _not?: InputMaybe<Find_Test_Accounts_Bool_Exp>
  _or?: InputMaybe<Array<Find_Test_Accounts_Bool_Exp>>
  account_num?: InputMaybe<String_Comparison_Exp>
  billing_acc_id?: InputMaybe<Bigint_Comparison_Exp>
  fuel_type?: InputMaybe<String_Comparison_Exp>
  has_smart_meter?: InputMaybe<Boolean_Comparison_Exp>
  inside_renewal_window?: InputMaybe<Boolean_Comparison_Exp>
  is_active_agreement?: InputMaybe<Boolean_Comparison_Exp>
  is_seasonal?: InputMaybe<Boolean_Comparison_Exp>
  latest_status?: InputMaybe<String_Comparison_Exp>
  multi_meterpoints?: InputMaybe<Boolean_Comparison_Exp>
  to_date?: InputMaybe<Timestamp_Comparison_Exp>
}

/** aggregate max on columns */
export type Find_Test_Accounts_Max_Fields = {
  __typename?: "find_test_accounts_max_fields"
  account_num?: Maybe<Scalars["String"]["output"]>
  billing_acc_id?: Maybe<Scalars["bigint"]["output"]>
  fuel_type?: Maybe<Scalars["String"]["output"]>
  latest_status?: Maybe<Scalars["String"]["output"]>
  to_date?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Find_Test_Accounts_Min_Fields = {
  __typename?: "find_test_accounts_min_fields"
  account_num?: Maybe<Scalars["String"]["output"]>
  billing_acc_id?: Maybe<Scalars["bigint"]["output"]>
  fuel_type?: Maybe<Scalars["String"]["output"]>
  latest_status?: Maybe<Scalars["String"]["output"]>
  to_date?: Maybe<Scalars["timestamp"]["output"]>
}

/** Ordering options when selecting data from "find_test_accounts". */
export type Find_Test_Accounts_Order_By = {
  account_num?: InputMaybe<Order_By>
  billing_acc_id?: InputMaybe<Order_By>
  fuel_type?: InputMaybe<Order_By>
  has_smart_meter?: InputMaybe<Order_By>
  inside_renewal_window?: InputMaybe<Order_By>
  is_active_agreement?: InputMaybe<Order_By>
  is_seasonal?: InputMaybe<Order_By>
  latest_status?: InputMaybe<Order_By>
  multi_meterpoints?: InputMaybe<Order_By>
  to_date?: InputMaybe<Order_By>
}

/** select columns of table "find_test_accounts" */
export enum Find_Test_Accounts_Select_Column {
  /** column name */
  AccountNum = "account_num",
  /** column name */
  BillingAccId = "billing_acc_id",
  /** column name */
  FuelType = "fuel_type",
  /** column name */
  HasSmartMeter = "has_smart_meter",
  /** column name */
  InsideRenewalWindow = "inside_renewal_window",
  /** column name */
  IsActiveAgreement = "is_active_agreement",
  /** column name */
  IsSeasonal = "is_seasonal",
  /** column name */
  LatestStatus = "latest_status",
  /** column name */
  MultiMeterpoints = "multi_meterpoints",
  /** column name */
  ToDate = "to_date",
}

/** aggregate stddev on columns */
export type Find_Test_Accounts_Stddev_Fields = {
  __typename?: "find_test_accounts_stddev_fields"
  billing_acc_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Find_Test_Accounts_Stddev_Pop_Fields = {
  __typename?: "find_test_accounts_stddev_pop_fields"
  billing_acc_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Find_Test_Accounts_Stddev_Samp_Fields = {
  __typename?: "find_test_accounts_stddev_samp_fields"
  billing_acc_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "find_test_accounts" */
export type Find_Test_Accounts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Find_Test_Accounts_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Find_Test_Accounts_Stream_Cursor_Value_Input = {
  account_num?: InputMaybe<Scalars["String"]["input"]>
  billing_acc_id?: InputMaybe<Scalars["bigint"]["input"]>
  fuel_type?: InputMaybe<Scalars["String"]["input"]>
  has_smart_meter?: InputMaybe<Scalars["Boolean"]["input"]>
  inside_renewal_window?: InputMaybe<Scalars["Boolean"]["input"]>
  is_active_agreement?: InputMaybe<Scalars["Boolean"]["input"]>
  is_seasonal?: InputMaybe<Scalars["Boolean"]["input"]>
  latest_status?: InputMaybe<Scalars["String"]["input"]>
  multi_meterpoints?: InputMaybe<Scalars["Boolean"]["input"]>
  to_date?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Find_Test_Accounts_Sum_Fields = {
  __typename?: "find_test_accounts_sum_fields"
  billing_acc_id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregate var_pop on columns */
export type Find_Test_Accounts_Var_Pop_Fields = {
  __typename?: "find_test_accounts_var_pop_fields"
  billing_acc_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Find_Test_Accounts_Var_Samp_Fields = {
  __typename?: "find_test_accounts_var_samp_fields"
  billing_acc_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Find_Test_Accounts_Variance_Fields = {
  __typename?: "find_test_accounts_variance_fields"
  billing_acc_id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "flex_market_subscription" */
export type Flex_Market_Subscription = {
  __typename?: "flex_market_subscription"
  /** An object relationship */
  billing_account: Billing_Account
  billing_account_id: Scalars["bigint"]["output"]
  consented_at?: Maybe<Scalars["timestamp"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  /** An array relationship */
  flex_market_subscription_billings: Array<Flex_Market_Subscription_Billing>
  /** An aggregate relationship */
  flex_market_subscription_billings_aggregate: Flex_Market_Subscription_Billing_Aggregate
  id: Scalars["bigint"]["output"]
  meter_point?: Maybe<Meter_Point>
  meter_point_id: Scalars["bigint"]["output"]
  offboarded_at?: Maybe<Scalars["timestamp"]["output"]>
  onboarded_at: Scalars["timestamp"]["output"]
  site_id: Scalars["uuid"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "flex_market_subscription" */
export type Flex_Market_SubscriptionFlex_Market_Subscription_BillingsArgs = {
  distinct_on?: InputMaybe<
    Array<Flex_Market_Subscription_Billing_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Flex_Market_Subscription_Billing_Order_By>>
  where?: InputMaybe<Flex_Market_Subscription_Billing_Bool_Exp>
}

/** columns and relationships of "flex_market_subscription" */
export type Flex_Market_SubscriptionFlex_Market_Subscription_Billings_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Flex_Market_Subscription_Billing_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<Array<Flex_Market_Subscription_Billing_Order_By>>
    where?: InputMaybe<Flex_Market_Subscription_Billing_Bool_Exp>
  }

/** aggregated selection of "flex_market_subscription" */
export type Flex_Market_Subscription_Aggregate = {
  __typename?: "flex_market_subscription_aggregate"
  aggregate?: Maybe<Flex_Market_Subscription_Aggregate_Fields>
  nodes: Array<Flex_Market_Subscription>
}

export type Flex_Market_Subscription_Aggregate_Bool_Exp = {
  count?: InputMaybe<Flex_Market_Subscription_Aggregate_Bool_Exp_Count>
}

export type Flex_Market_Subscription_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Flex_Market_Subscription_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Flex_Market_Subscription_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "flex_market_subscription" */
export type Flex_Market_Subscription_Aggregate_Fields = {
  __typename?: "flex_market_subscription_aggregate_fields"
  avg?: Maybe<Flex_Market_Subscription_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Flex_Market_Subscription_Max_Fields>
  min?: Maybe<Flex_Market_Subscription_Min_Fields>
  stddev?: Maybe<Flex_Market_Subscription_Stddev_Fields>
  stddev_pop?: Maybe<Flex_Market_Subscription_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Flex_Market_Subscription_Stddev_Samp_Fields>
  sum?: Maybe<Flex_Market_Subscription_Sum_Fields>
  var_pop?: Maybe<Flex_Market_Subscription_Var_Pop_Fields>
  var_samp?: Maybe<Flex_Market_Subscription_Var_Samp_Fields>
  variance?: Maybe<Flex_Market_Subscription_Variance_Fields>
}

/** aggregate fields of "flex_market_subscription" */
export type Flex_Market_Subscription_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Flex_Market_Subscription_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "flex_market_subscription" */
export type Flex_Market_Subscription_Aggregate_Order_By = {
  avg?: InputMaybe<Flex_Market_Subscription_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Flex_Market_Subscription_Max_Order_By>
  min?: InputMaybe<Flex_Market_Subscription_Min_Order_By>
  stddev?: InputMaybe<Flex_Market_Subscription_Stddev_Order_By>
  stddev_pop?: InputMaybe<Flex_Market_Subscription_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Flex_Market_Subscription_Stddev_Samp_Order_By>
  sum?: InputMaybe<Flex_Market_Subscription_Sum_Order_By>
  var_pop?: InputMaybe<Flex_Market_Subscription_Var_Pop_Order_By>
  var_samp?: InputMaybe<Flex_Market_Subscription_Var_Samp_Order_By>
  variance?: InputMaybe<Flex_Market_Subscription_Variance_Order_By>
}

/** input type for inserting array relation for remote table "flex_market_subscription" */
export type Flex_Market_Subscription_Arr_Rel_Insert_Input = {
  data: Array<Flex_Market_Subscription_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Flex_Market_Subscription_On_Conflict>
}

/** aggregate avg on columns */
export type Flex_Market_Subscription_Avg_Fields = {
  __typename?: "flex_market_subscription_avg_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "flex_market_subscription" */
export type Flex_Market_Subscription_Avg_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** columns and relationships of "flex_market_subscription_billing" */
export type Flex_Market_Subscription_Billing = {
  __typename?: "flex_market_subscription_billing"
  billing_period_start: Scalars["timestamp"]["output"]
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  status: Scalars["flex_market_subscription_billing_status"]["output"]
  subscription_id: Scalars["bigint"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "flex_market_subscription_billing" */
export type Flex_Market_Subscription_Billing_Aggregate = {
  __typename?: "flex_market_subscription_billing_aggregate"
  aggregate?: Maybe<Flex_Market_Subscription_Billing_Aggregate_Fields>
  nodes: Array<Flex_Market_Subscription_Billing>
}

export type Flex_Market_Subscription_Billing_Aggregate_Bool_Exp = {
  count?: InputMaybe<Flex_Market_Subscription_Billing_Aggregate_Bool_Exp_Count>
}

export type Flex_Market_Subscription_Billing_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Flex_Market_Subscription_Billing_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Flex_Market_Subscription_Billing_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "flex_market_subscription_billing" */
export type Flex_Market_Subscription_Billing_Aggregate_Fields = {
  __typename?: "flex_market_subscription_billing_aggregate_fields"
  avg?: Maybe<Flex_Market_Subscription_Billing_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Flex_Market_Subscription_Billing_Max_Fields>
  min?: Maybe<Flex_Market_Subscription_Billing_Min_Fields>
  stddev?: Maybe<Flex_Market_Subscription_Billing_Stddev_Fields>
  stddev_pop?: Maybe<Flex_Market_Subscription_Billing_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Flex_Market_Subscription_Billing_Stddev_Samp_Fields>
  sum?: Maybe<Flex_Market_Subscription_Billing_Sum_Fields>
  var_pop?: Maybe<Flex_Market_Subscription_Billing_Var_Pop_Fields>
  var_samp?: Maybe<Flex_Market_Subscription_Billing_Var_Samp_Fields>
  variance?: Maybe<Flex_Market_Subscription_Billing_Variance_Fields>
}

/** aggregate fields of "flex_market_subscription_billing" */
export type Flex_Market_Subscription_Billing_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Flex_Market_Subscription_Billing_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "flex_market_subscription_billing" */
export type Flex_Market_Subscription_Billing_Aggregate_Order_By = {
  avg?: InputMaybe<Flex_Market_Subscription_Billing_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Flex_Market_Subscription_Billing_Max_Order_By>
  min?: InputMaybe<Flex_Market_Subscription_Billing_Min_Order_By>
  stddev?: InputMaybe<Flex_Market_Subscription_Billing_Stddev_Order_By>
  stddev_pop?: InputMaybe<Flex_Market_Subscription_Billing_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Flex_Market_Subscription_Billing_Stddev_Samp_Order_By>
  sum?: InputMaybe<Flex_Market_Subscription_Billing_Sum_Order_By>
  var_pop?: InputMaybe<Flex_Market_Subscription_Billing_Var_Pop_Order_By>
  var_samp?: InputMaybe<Flex_Market_Subscription_Billing_Var_Samp_Order_By>
  variance?: InputMaybe<Flex_Market_Subscription_Billing_Variance_Order_By>
}

/** input type for inserting array relation for remote table "flex_market_subscription_billing" */
export type Flex_Market_Subscription_Billing_Arr_Rel_Insert_Input = {
  data: Array<Flex_Market_Subscription_Billing_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Flex_Market_Subscription_Billing_On_Conflict>
}

/** aggregate avg on columns */
export type Flex_Market_Subscription_Billing_Avg_Fields = {
  __typename?: "flex_market_subscription_billing_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  subscription_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "flex_market_subscription_billing" */
export type Flex_Market_Subscription_Billing_Avg_Order_By = {
  id?: InputMaybe<Order_By>
  subscription_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "flex_market_subscription_billing". All fields are combined with a logical 'AND'. */
export type Flex_Market_Subscription_Billing_Bool_Exp = {
  _and?: InputMaybe<Array<Flex_Market_Subscription_Billing_Bool_Exp>>
  _not?: InputMaybe<Flex_Market_Subscription_Billing_Bool_Exp>
  _or?: InputMaybe<Array<Flex_Market_Subscription_Billing_Bool_Exp>>
  billing_period_start?: InputMaybe<Timestamp_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  status?: InputMaybe<Flex_Market_Subscription_Billing_Status_Comparison_Exp>
  subscription_id?: InputMaybe<Bigint_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** columns and relationships of "flex_market_subscription_billing_component" */
export type Flex_Market_Subscription_Billing_Component = {
  __typename?: "flex_market_subscription_billing_component"
  amount?: Maybe<Scalars["numeric"]["output"]>
  billing_id: Scalars["bigint"]["output"]
  category: Scalars["flex_market_subscription_billing_component_category"]["output"]
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_date: Scalars["timestamp"]["output"]
  id: Scalars["bigint"]["output"]
  idempotency_key: Scalars["String"]["output"]
  last_error_category?: Maybe<Scalars["String"]["output"]>
  last_error_message?: Maybe<Scalars["String"]["output"]>
  num_retries?: Maybe<Scalars["Int"]["output"]>
  scheduled_at: Scalars["timestamp"]["output"]
  status: Scalars["flex_market_subscription_billing_component_status"]["output"]
  to_date: Scalars["timestamp"]["output"]
  type: Scalars["flex_market_subscription_billing_component_type"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "flex_market_subscription_billing_component" */
export type Flex_Market_Subscription_Billing_Component_Aggregate = {
  __typename?: "flex_market_subscription_billing_component_aggregate"
  aggregate?: Maybe<Flex_Market_Subscription_Billing_Component_Aggregate_Fields>
  nodes: Array<Flex_Market_Subscription_Billing_Component>
}

/** aggregate fields of "flex_market_subscription_billing_component" */
export type Flex_Market_Subscription_Billing_Component_Aggregate_Fields = {
  __typename?: "flex_market_subscription_billing_component_aggregate_fields"
  avg?: Maybe<Flex_Market_Subscription_Billing_Component_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Flex_Market_Subscription_Billing_Component_Max_Fields>
  min?: Maybe<Flex_Market_Subscription_Billing_Component_Min_Fields>
  stddev?: Maybe<Flex_Market_Subscription_Billing_Component_Stddev_Fields>
  stddev_pop?: Maybe<Flex_Market_Subscription_Billing_Component_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Flex_Market_Subscription_Billing_Component_Stddev_Samp_Fields>
  sum?: Maybe<Flex_Market_Subscription_Billing_Component_Sum_Fields>
  var_pop?: Maybe<Flex_Market_Subscription_Billing_Component_Var_Pop_Fields>
  var_samp?: Maybe<Flex_Market_Subscription_Billing_Component_Var_Samp_Fields>
  variance?: Maybe<Flex_Market_Subscription_Billing_Component_Variance_Fields>
}

/** aggregate fields of "flex_market_subscription_billing_component" */
export type Flex_Market_Subscription_Billing_Component_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Flex_Market_Subscription_Billing_Component_Select_Column>
    >
    distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  }

/** aggregate avg on columns */
export type Flex_Market_Subscription_Billing_Component_Avg_Fields = {
  __typename?: "flex_market_subscription_billing_component_avg_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  billing_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  num_retries?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "flex_market_subscription_billing_component". All fields are combined with a logical 'AND'. */
export type Flex_Market_Subscription_Billing_Component_Bool_Exp = {
  _and?: InputMaybe<Array<Flex_Market_Subscription_Billing_Component_Bool_Exp>>
  _not?: InputMaybe<Flex_Market_Subscription_Billing_Component_Bool_Exp>
  _or?: InputMaybe<Array<Flex_Market_Subscription_Billing_Component_Bool_Exp>>
  amount?: InputMaybe<Numeric_Comparison_Exp>
  billing_id?: InputMaybe<Bigint_Comparison_Exp>
  category?: InputMaybe<Flex_Market_Subscription_Billing_Component_Category_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  from_date?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  idempotency_key?: InputMaybe<String_Comparison_Exp>
  last_error_category?: InputMaybe<String_Comparison_Exp>
  last_error_message?: InputMaybe<String_Comparison_Exp>
  num_retries?: InputMaybe<Int_Comparison_Exp>
  scheduled_at?: InputMaybe<Timestamp_Comparison_Exp>
  status?: InputMaybe<Flex_Market_Subscription_Billing_Component_Status_Comparison_Exp>
  to_date?: InputMaybe<Timestamp_Comparison_Exp>
  type?: InputMaybe<Flex_Market_Subscription_Billing_Component_Type_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** Boolean expression to compare columns of type "flex_market_subscription_billing_component_category". All fields are combined with logical 'AND'. */
export type Flex_Market_Subscription_Billing_Component_Category_Comparison_Exp =
  {
    _eq?: InputMaybe<
      Scalars["flex_market_subscription_billing_component_category"]["input"]
    >
    _gt?: InputMaybe<
      Scalars["flex_market_subscription_billing_component_category"]["input"]
    >
    _gte?: InputMaybe<
      Scalars["flex_market_subscription_billing_component_category"]["input"]
    >
    _in?: InputMaybe<
      Array<
        Scalars["flex_market_subscription_billing_component_category"]["input"]
      >
    >
    _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
    _lt?: InputMaybe<
      Scalars["flex_market_subscription_billing_component_category"]["input"]
    >
    _lte?: InputMaybe<
      Scalars["flex_market_subscription_billing_component_category"]["input"]
    >
    _neq?: InputMaybe<
      Scalars["flex_market_subscription_billing_component_category"]["input"]
    >
    _nin?: InputMaybe<
      Array<
        Scalars["flex_market_subscription_billing_component_category"]["input"]
      >
    >
  }

/** unique or primary key constraints on table "flex_market_subscription_billing_component" */
export enum Flex_Market_Subscription_Billing_Component_Constraint {
  /** unique or primary key constraint on columns "idempotency_key" */
  FlexMarketSubscriptionBillingComponentIdempotencyKeyKey = "flex_market_subscription_billing_component_idempotency_key_key",
  /** unique or primary key constraint on columns "id" */
  FlexMarketSubscriptionBillingComponentPkey = "flex_market_subscription_billing_component_pkey",
}

/** input type for incrementing numeric columns in table "flex_market_subscription_billing_component" */
export type Flex_Market_Subscription_Billing_Component_Inc_Input = {
  amount?: InputMaybe<Scalars["numeric"]["input"]>
  billing_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  num_retries?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "flex_market_subscription_billing_component" */
export type Flex_Market_Subscription_Billing_Component_Insert_Input = {
  amount?: InputMaybe<Scalars["numeric"]["input"]>
  billing_id?: InputMaybe<Scalars["bigint"]["input"]>
  category?: InputMaybe<
    Scalars["flex_market_subscription_billing_component_category"]["input"]
  >
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_date?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  idempotency_key?: InputMaybe<Scalars["String"]["input"]>
  last_error_category?: InputMaybe<Scalars["String"]["input"]>
  last_error_message?: InputMaybe<Scalars["String"]["input"]>
  num_retries?: InputMaybe<Scalars["Int"]["input"]>
  scheduled_at?: InputMaybe<Scalars["timestamp"]["input"]>
  status?: InputMaybe<
    Scalars["flex_market_subscription_billing_component_status"]["input"]
  >
  to_date?: InputMaybe<Scalars["timestamp"]["input"]>
  type?: InputMaybe<
    Scalars["flex_market_subscription_billing_component_type"]["input"]
  >
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Flex_Market_Subscription_Billing_Component_Max_Fields = {
  __typename?: "flex_market_subscription_billing_component_max_fields"
  amount?: Maybe<Scalars["numeric"]["output"]>
  billing_id?: Maybe<Scalars["bigint"]["output"]>
  category?: Maybe<
    Scalars["flex_market_subscription_billing_component_category"]["output"]
  >
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_date?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  idempotency_key?: Maybe<Scalars["String"]["output"]>
  last_error_category?: Maybe<Scalars["String"]["output"]>
  last_error_message?: Maybe<Scalars["String"]["output"]>
  num_retries?: Maybe<Scalars["Int"]["output"]>
  scheduled_at?: Maybe<Scalars["timestamp"]["output"]>
  status?: Maybe<
    Scalars["flex_market_subscription_billing_component_status"]["output"]
  >
  to_date?: Maybe<Scalars["timestamp"]["output"]>
  type?: Maybe<
    Scalars["flex_market_subscription_billing_component_type"]["output"]
  >
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Flex_Market_Subscription_Billing_Component_Min_Fields = {
  __typename?: "flex_market_subscription_billing_component_min_fields"
  amount?: Maybe<Scalars["numeric"]["output"]>
  billing_id?: Maybe<Scalars["bigint"]["output"]>
  category?: Maybe<
    Scalars["flex_market_subscription_billing_component_category"]["output"]
  >
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_date?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  idempotency_key?: Maybe<Scalars["String"]["output"]>
  last_error_category?: Maybe<Scalars["String"]["output"]>
  last_error_message?: Maybe<Scalars["String"]["output"]>
  num_retries?: Maybe<Scalars["Int"]["output"]>
  scheduled_at?: Maybe<Scalars["timestamp"]["output"]>
  status?: Maybe<
    Scalars["flex_market_subscription_billing_component_status"]["output"]
  >
  to_date?: Maybe<Scalars["timestamp"]["output"]>
  type?: Maybe<
    Scalars["flex_market_subscription_billing_component_type"]["output"]
  >
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "flex_market_subscription_billing_component" */
export type Flex_Market_Subscription_Billing_Component_Mutation_Response = {
  __typename?: "flex_market_subscription_billing_component_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Flex_Market_Subscription_Billing_Component>
}

/** on_conflict condition type for table "flex_market_subscription_billing_component" */
export type Flex_Market_Subscription_Billing_Component_On_Conflict = {
  constraint: Flex_Market_Subscription_Billing_Component_Constraint
  update_columns?: Array<Flex_Market_Subscription_Billing_Component_Update_Column>
  where?: InputMaybe<Flex_Market_Subscription_Billing_Component_Bool_Exp>
}

/** Ordering options when selecting data from "flex_market_subscription_billing_component". */
export type Flex_Market_Subscription_Billing_Component_Order_By = {
  amount?: InputMaybe<Order_By>
  billing_id?: InputMaybe<Order_By>
  category?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  from_date?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  idempotency_key?: InputMaybe<Order_By>
  last_error_category?: InputMaybe<Order_By>
  last_error_message?: InputMaybe<Order_By>
  num_retries?: InputMaybe<Order_By>
  scheduled_at?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  to_date?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: flex_market_subscription_billing_component */
export type Flex_Market_Subscription_Billing_Component_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "flex_market_subscription_billing_component" */
export enum Flex_Market_Subscription_Billing_Component_Select_Column {
  /** column name */
  Amount = "amount",
  /** column name */
  BillingId = "billing_id",
  /** column name */
  Category = "category",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FromDate = "from_date",
  /** column name */
  Id = "id",
  /** column name */
  IdempotencyKey = "idempotency_key",
  /** column name */
  LastErrorCategory = "last_error_category",
  /** column name */
  LastErrorMessage = "last_error_message",
  /** column name */
  NumRetries = "num_retries",
  /** column name */
  ScheduledAt = "scheduled_at",
  /** column name */
  Status = "status",
  /** column name */
  ToDate = "to_date",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "flex_market_subscription_billing_component" */
export type Flex_Market_Subscription_Billing_Component_Set_Input = {
  amount?: InputMaybe<Scalars["numeric"]["input"]>
  billing_id?: InputMaybe<Scalars["bigint"]["input"]>
  category?: InputMaybe<
    Scalars["flex_market_subscription_billing_component_category"]["input"]
  >
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_date?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  idempotency_key?: InputMaybe<Scalars["String"]["input"]>
  last_error_category?: InputMaybe<Scalars["String"]["input"]>
  last_error_message?: InputMaybe<Scalars["String"]["input"]>
  num_retries?: InputMaybe<Scalars["Int"]["input"]>
  scheduled_at?: InputMaybe<Scalars["timestamp"]["input"]>
  status?: InputMaybe<
    Scalars["flex_market_subscription_billing_component_status"]["input"]
  >
  to_date?: InputMaybe<Scalars["timestamp"]["input"]>
  type?: InputMaybe<
    Scalars["flex_market_subscription_billing_component_type"]["input"]
  >
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** Boolean expression to compare columns of type "flex_market_subscription_billing_component_status". All fields are combined with logical 'AND'. */
export type Flex_Market_Subscription_Billing_Component_Status_Comparison_Exp = {
  _eq?: InputMaybe<
    Scalars["flex_market_subscription_billing_component_status"]["input"]
  >
  _gt?: InputMaybe<
    Scalars["flex_market_subscription_billing_component_status"]["input"]
  >
  _gte?: InputMaybe<
    Scalars["flex_market_subscription_billing_component_status"]["input"]
  >
  _in?: InputMaybe<
    Array<Scalars["flex_market_subscription_billing_component_status"]["input"]>
  >
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<
    Scalars["flex_market_subscription_billing_component_status"]["input"]
  >
  _lte?: InputMaybe<
    Scalars["flex_market_subscription_billing_component_status"]["input"]
  >
  _neq?: InputMaybe<
    Scalars["flex_market_subscription_billing_component_status"]["input"]
  >
  _nin?: InputMaybe<
    Array<Scalars["flex_market_subscription_billing_component_status"]["input"]>
  >
}

/** aggregate stddev on columns */
export type Flex_Market_Subscription_Billing_Component_Stddev_Fields = {
  __typename?: "flex_market_subscription_billing_component_stddev_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  billing_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  num_retries?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Flex_Market_Subscription_Billing_Component_Stddev_Pop_Fields = {
  __typename?: "flex_market_subscription_billing_component_stddev_pop_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  billing_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  num_retries?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Flex_Market_Subscription_Billing_Component_Stddev_Samp_Fields = {
  __typename?: "flex_market_subscription_billing_component_stddev_samp_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  billing_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  num_retries?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "flex_market_subscription_billing_component" */
export type Flex_Market_Subscription_Billing_Component_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Flex_Market_Subscription_Billing_Component_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Flex_Market_Subscription_Billing_Component_Stream_Cursor_Value_Input =
  {
    amount?: InputMaybe<Scalars["numeric"]["input"]>
    billing_id?: InputMaybe<Scalars["bigint"]["input"]>
    category?: InputMaybe<
      Scalars["flex_market_subscription_billing_component_category"]["input"]
    >
    created_at?: InputMaybe<Scalars["timestamp"]["input"]>
    deleted?: InputMaybe<Scalars["timestamp"]["input"]>
    from_date?: InputMaybe<Scalars["timestamp"]["input"]>
    id?: InputMaybe<Scalars["bigint"]["input"]>
    idempotency_key?: InputMaybe<Scalars["String"]["input"]>
    last_error_category?: InputMaybe<Scalars["String"]["input"]>
    last_error_message?: InputMaybe<Scalars["String"]["input"]>
    num_retries?: InputMaybe<Scalars["Int"]["input"]>
    scheduled_at?: InputMaybe<Scalars["timestamp"]["input"]>
    status?: InputMaybe<
      Scalars["flex_market_subscription_billing_component_status"]["input"]
    >
    to_date?: InputMaybe<Scalars["timestamp"]["input"]>
    type?: InputMaybe<
      Scalars["flex_market_subscription_billing_component_type"]["input"]
    >
    updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  }

/** aggregate sum on columns */
export type Flex_Market_Subscription_Billing_Component_Sum_Fields = {
  __typename?: "flex_market_subscription_billing_component_sum_fields"
  amount?: Maybe<Scalars["numeric"]["output"]>
  billing_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  num_retries?: Maybe<Scalars["Int"]["output"]>
}

/** Boolean expression to compare columns of type "flex_market_subscription_billing_component_type". All fields are combined with logical 'AND'. */
export type Flex_Market_Subscription_Billing_Component_Type_Comparison_Exp = {
  _eq?: InputMaybe<
    Scalars["flex_market_subscription_billing_component_type"]["input"]
  >
  _gt?: InputMaybe<
    Scalars["flex_market_subscription_billing_component_type"]["input"]
  >
  _gte?: InputMaybe<
    Scalars["flex_market_subscription_billing_component_type"]["input"]
  >
  _in?: InputMaybe<
    Array<Scalars["flex_market_subscription_billing_component_type"]["input"]>
  >
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<
    Scalars["flex_market_subscription_billing_component_type"]["input"]
  >
  _lte?: InputMaybe<
    Scalars["flex_market_subscription_billing_component_type"]["input"]
  >
  _neq?: InputMaybe<
    Scalars["flex_market_subscription_billing_component_type"]["input"]
  >
  _nin?: InputMaybe<
    Array<Scalars["flex_market_subscription_billing_component_type"]["input"]>
  >
}

/** update columns of table "flex_market_subscription_billing_component" */
export enum Flex_Market_Subscription_Billing_Component_Update_Column {
  /** column name */
  Amount = "amount",
  /** column name */
  BillingId = "billing_id",
  /** column name */
  Category = "category",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FromDate = "from_date",
  /** column name */
  Id = "id",
  /** column name */
  IdempotencyKey = "idempotency_key",
  /** column name */
  LastErrorCategory = "last_error_category",
  /** column name */
  LastErrorMessage = "last_error_message",
  /** column name */
  NumRetries = "num_retries",
  /** column name */
  ScheduledAt = "scheduled_at",
  /** column name */
  Status = "status",
  /** column name */
  ToDate = "to_date",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Flex_Market_Subscription_Billing_Component_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Flex_Market_Subscription_Billing_Component_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Flex_Market_Subscription_Billing_Component_Set_Input>
  /** filter the rows which have to be updated */
  where: Flex_Market_Subscription_Billing_Component_Bool_Exp
}

/** aggregate var_pop on columns */
export type Flex_Market_Subscription_Billing_Component_Var_Pop_Fields = {
  __typename?: "flex_market_subscription_billing_component_var_pop_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  billing_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  num_retries?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Flex_Market_Subscription_Billing_Component_Var_Samp_Fields = {
  __typename?: "flex_market_subscription_billing_component_var_samp_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  billing_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  num_retries?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Flex_Market_Subscription_Billing_Component_Variance_Fields = {
  __typename?: "flex_market_subscription_billing_component_variance_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  billing_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  num_retries?: Maybe<Scalars["Float"]["output"]>
}

/** unique or primary key constraints on table "flex_market_subscription_billing" */
export enum Flex_Market_Subscription_Billing_Constraint {
  /** unique or primary key constraint on columns "id" */
  FlexMarketSubscriptionBillingPkey = "flex_market_subscription_billing_pkey",
}

/** input type for incrementing numeric columns in table "flex_market_subscription_billing" */
export type Flex_Market_Subscription_Billing_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  subscription_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "flex_market_subscription_billing" */
export type Flex_Market_Subscription_Billing_Insert_Input = {
  billing_period_start?: InputMaybe<Scalars["timestamp"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<
    Scalars["flex_market_subscription_billing_status"]["input"]
  >
  subscription_id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Flex_Market_Subscription_Billing_Max_Fields = {
  __typename?: "flex_market_subscription_billing_max_fields"
  billing_period_start?: Maybe<Scalars["timestamp"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["flex_market_subscription_billing_status"]["output"]>
  subscription_id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "flex_market_subscription_billing" */
export type Flex_Market_Subscription_Billing_Max_Order_By = {
  billing_period_start?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  subscription_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Flex_Market_Subscription_Billing_Min_Fields = {
  __typename?: "flex_market_subscription_billing_min_fields"
  billing_period_start?: Maybe<Scalars["timestamp"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["flex_market_subscription_billing_status"]["output"]>
  subscription_id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "flex_market_subscription_billing" */
export type Flex_Market_Subscription_Billing_Min_Order_By = {
  billing_period_start?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  subscription_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "flex_market_subscription_billing" */
export type Flex_Market_Subscription_Billing_Mutation_Response = {
  __typename?: "flex_market_subscription_billing_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Flex_Market_Subscription_Billing>
}

/** on_conflict condition type for table "flex_market_subscription_billing" */
export type Flex_Market_Subscription_Billing_On_Conflict = {
  constraint: Flex_Market_Subscription_Billing_Constraint
  update_columns?: Array<Flex_Market_Subscription_Billing_Update_Column>
  where?: InputMaybe<Flex_Market_Subscription_Billing_Bool_Exp>
}

/** Ordering options when selecting data from "flex_market_subscription_billing". */
export type Flex_Market_Subscription_Billing_Order_By = {
  billing_period_start?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  subscription_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: flex_market_subscription_billing */
export type Flex_Market_Subscription_Billing_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "flex_market_subscription_billing" */
export enum Flex_Market_Subscription_Billing_Select_Column {
  /** column name */
  BillingPeriodStart = "billing_period_start",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  SubscriptionId = "subscription_id",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "flex_market_subscription_billing" */
export type Flex_Market_Subscription_Billing_Set_Input = {
  billing_period_start?: InputMaybe<Scalars["timestamp"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<
    Scalars["flex_market_subscription_billing_status"]["input"]
  >
  subscription_id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** Boolean expression to compare columns of type "flex_market_subscription_billing_status". All fields are combined with logical 'AND'. */
export type Flex_Market_Subscription_Billing_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["flex_market_subscription_billing_status"]["input"]>
  _gt?: InputMaybe<Scalars["flex_market_subscription_billing_status"]["input"]>
  _gte?: InputMaybe<Scalars["flex_market_subscription_billing_status"]["input"]>
  _in?: InputMaybe<
    Array<Scalars["flex_market_subscription_billing_status"]["input"]>
  >
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["flex_market_subscription_billing_status"]["input"]>
  _lte?: InputMaybe<Scalars["flex_market_subscription_billing_status"]["input"]>
  _neq?: InputMaybe<Scalars["flex_market_subscription_billing_status"]["input"]>
  _nin?: InputMaybe<
    Array<Scalars["flex_market_subscription_billing_status"]["input"]>
  >
}

/** aggregate stddev on columns */
export type Flex_Market_Subscription_Billing_Stddev_Fields = {
  __typename?: "flex_market_subscription_billing_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  subscription_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "flex_market_subscription_billing" */
export type Flex_Market_Subscription_Billing_Stddev_Order_By = {
  id?: InputMaybe<Order_By>
  subscription_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Flex_Market_Subscription_Billing_Stddev_Pop_Fields = {
  __typename?: "flex_market_subscription_billing_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  subscription_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "flex_market_subscription_billing" */
export type Flex_Market_Subscription_Billing_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>
  subscription_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Flex_Market_Subscription_Billing_Stddev_Samp_Fields = {
  __typename?: "flex_market_subscription_billing_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  subscription_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "flex_market_subscription_billing" */
export type Flex_Market_Subscription_Billing_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>
  subscription_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "flex_market_subscription_billing" */
export type Flex_Market_Subscription_Billing_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Flex_Market_Subscription_Billing_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Flex_Market_Subscription_Billing_Stream_Cursor_Value_Input = {
  billing_period_start?: InputMaybe<Scalars["timestamp"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<
    Scalars["flex_market_subscription_billing_status"]["input"]
  >
  subscription_id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Flex_Market_Subscription_Billing_Sum_Fields = {
  __typename?: "flex_market_subscription_billing_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  subscription_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "flex_market_subscription_billing" */
export type Flex_Market_Subscription_Billing_Sum_Order_By = {
  id?: InputMaybe<Order_By>
  subscription_id?: InputMaybe<Order_By>
}

/** update columns of table "flex_market_subscription_billing" */
export enum Flex_Market_Subscription_Billing_Update_Column {
  /** column name */
  BillingPeriodStart = "billing_period_start",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  SubscriptionId = "subscription_id",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Flex_Market_Subscription_Billing_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Flex_Market_Subscription_Billing_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Flex_Market_Subscription_Billing_Set_Input>
  /** filter the rows which have to be updated */
  where: Flex_Market_Subscription_Billing_Bool_Exp
}

/** aggregate var_pop on columns */
export type Flex_Market_Subscription_Billing_Var_Pop_Fields = {
  __typename?: "flex_market_subscription_billing_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  subscription_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "flex_market_subscription_billing" */
export type Flex_Market_Subscription_Billing_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>
  subscription_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Flex_Market_Subscription_Billing_Var_Samp_Fields = {
  __typename?: "flex_market_subscription_billing_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  subscription_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "flex_market_subscription_billing" */
export type Flex_Market_Subscription_Billing_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>
  subscription_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Flex_Market_Subscription_Billing_Variance_Fields = {
  __typename?: "flex_market_subscription_billing_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  subscription_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "flex_market_subscription_billing" */
export type Flex_Market_Subscription_Billing_Variance_Order_By = {
  id?: InputMaybe<Order_By>
  subscription_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "flex_market_subscription". All fields are combined with a logical 'AND'. */
export type Flex_Market_Subscription_Bool_Exp = {
  _and?: InputMaybe<Array<Flex_Market_Subscription_Bool_Exp>>
  _not?: InputMaybe<Flex_Market_Subscription_Bool_Exp>
  _or?: InputMaybe<Array<Flex_Market_Subscription_Bool_Exp>>
  billing_account?: InputMaybe<Billing_Account_Bool_Exp>
  billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  consented_at?: InputMaybe<Timestamp_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  flex_market_subscription_billings?: InputMaybe<Flex_Market_Subscription_Billing_Bool_Exp>
  flex_market_subscription_billings_aggregate?: InputMaybe<Flex_Market_Subscription_Billing_Aggregate_Bool_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  meter_point_id?: InputMaybe<Bigint_Comparison_Exp>
  offboarded_at?: InputMaybe<Timestamp_Comparison_Exp>
  onboarded_at?: InputMaybe<Timestamp_Comparison_Exp>
  site_id?: InputMaybe<Uuid_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "flex_market_subscription" */
export enum Flex_Market_Subscription_Constraint {
  /** unique or primary key constraint on columns "id" */
  FlexMarketSubscriptionPkey = "flex_market_subscription_pkey",
  /** unique or primary key constraint on columns "site_id" */
  UxFlexMarketSubscriptionSiteId = "ux_flex_market_subscription_site_id",
}

/** input type for incrementing numeric columns in table "flex_market_subscription" */
export type Flex_Market_Subscription_Inc_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "flex_market_subscription" */
export type Flex_Market_Subscription_Insert_Input = {
  billing_account?: InputMaybe<Billing_Account_Obj_Rel_Insert_Input>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  consented_at?: InputMaybe<Scalars["timestamp"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  flex_market_subscription_billings?: InputMaybe<Flex_Market_Subscription_Billing_Arr_Rel_Insert_Input>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  offboarded_at?: InputMaybe<Scalars["timestamp"]["input"]>
  onboarded_at?: InputMaybe<Scalars["timestamp"]["input"]>
  site_id?: InputMaybe<Scalars["uuid"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Flex_Market_Subscription_Max_Fields = {
  __typename?: "flex_market_subscription_max_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  consented_at?: Maybe<Scalars["timestamp"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["bigint"]["output"]>
  offboarded_at?: Maybe<Scalars["timestamp"]["output"]>
  onboarded_at?: Maybe<Scalars["timestamp"]["output"]>
  site_id?: Maybe<Scalars["uuid"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "flex_market_subscription" */
export type Flex_Market_Subscription_Max_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  consented_at?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  offboarded_at?: InputMaybe<Order_By>
  onboarded_at?: InputMaybe<Order_By>
  site_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Flex_Market_Subscription_Min_Fields = {
  __typename?: "flex_market_subscription_min_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  consented_at?: Maybe<Scalars["timestamp"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["bigint"]["output"]>
  offboarded_at?: Maybe<Scalars["timestamp"]["output"]>
  onboarded_at?: Maybe<Scalars["timestamp"]["output"]>
  site_id?: Maybe<Scalars["uuid"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "flex_market_subscription" */
export type Flex_Market_Subscription_Min_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  consented_at?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  offboarded_at?: InputMaybe<Order_By>
  onboarded_at?: InputMaybe<Order_By>
  site_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "flex_market_subscription" */
export type Flex_Market_Subscription_Mutation_Response = {
  __typename?: "flex_market_subscription_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Flex_Market_Subscription>
}

/** on_conflict condition type for table "flex_market_subscription" */
export type Flex_Market_Subscription_On_Conflict = {
  constraint: Flex_Market_Subscription_Constraint
  update_columns?: Array<Flex_Market_Subscription_Update_Column>
  where?: InputMaybe<Flex_Market_Subscription_Bool_Exp>
}

/** Ordering options when selecting data from "flex_market_subscription". */
export type Flex_Market_Subscription_Order_By = {
  billing_account?: InputMaybe<Billing_Account_Order_By>
  billing_account_id?: InputMaybe<Order_By>
  consented_at?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  flex_market_subscription_billings_aggregate?: InputMaybe<Flex_Market_Subscription_Billing_Aggregate_Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  offboarded_at?: InputMaybe<Order_By>
  onboarded_at?: InputMaybe<Order_By>
  site_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: flex_market_subscription */
export type Flex_Market_Subscription_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "flex_market_subscription" */
export enum Flex_Market_Subscription_Select_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  ConsentedAt = "consented_at",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  MeterPointId = "meter_point_id",
  /** column name */
  OffboardedAt = "offboarded_at",
  /** column name */
  OnboardedAt = "onboarded_at",
  /** column name */
  SiteId = "site_id",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "flex_market_subscription" */
export type Flex_Market_Subscription_Set_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  consented_at?: InputMaybe<Scalars["timestamp"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  offboarded_at?: InputMaybe<Scalars["timestamp"]["input"]>
  onboarded_at?: InputMaybe<Scalars["timestamp"]["input"]>
  site_id?: InputMaybe<Scalars["uuid"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Flex_Market_Subscription_Stddev_Fields = {
  __typename?: "flex_market_subscription_stddev_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "flex_market_subscription" */
export type Flex_Market_Subscription_Stddev_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Flex_Market_Subscription_Stddev_Pop_Fields = {
  __typename?: "flex_market_subscription_stddev_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "flex_market_subscription" */
export type Flex_Market_Subscription_Stddev_Pop_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Flex_Market_Subscription_Stddev_Samp_Fields = {
  __typename?: "flex_market_subscription_stddev_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "flex_market_subscription" */
export type Flex_Market_Subscription_Stddev_Samp_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "flex_market_subscription" */
export type Flex_Market_Subscription_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Flex_Market_Subscription_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Flex_Market_Subscription_Stream_Cursor_Value_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  consented_at?: InputMaybe<Scalars["timestamp"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  offboarded_at?: InputMaybe<Scalars["timestamp"]["input"]>
  onboarded_at?: InputMaybe<Scalars["timestamp"]["input"]>
  site_id?: InputMaybe<Scalars["uuid"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Flex_Market_Subscription_Sum_Fields = {
  __typename?: "flex_market_subscription_sum_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "flex_market_subscription" */
export type Flex_Market_Subscription_Sum_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** update columns of table "flex_market_subscription" */
export enum Flex_Market_Subscription_Update_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  ConsentedAt = "consented_at",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  MeterPointId = "meter_point_id",
  /** column name */
  OffboardedAt = "offboarded_at",
  /** column name */
  OnboardedAt = "onboarded_at",
  /** column name */
  SiteId = "site_id",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Flex_Market_Subscription_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Flex_Market_Subscription_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Flex_Market_Subscription_Set_Input>
  /** filter the rows which have to be updated */
  where: Flex_Market_Subscription_Bool_Exp
}

/** aggregate var_pop on columns */
export type Flex_Market_Subscription_Var_Pop_Fields = {
  __typename?: "flex_market_subscription_var_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "flex_market_subscription" */
export type Flex_Market_Subscription_Var_Pop_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Flex_Market_Subscription_Var_Samp_Fields = {
  __typename?: "flex_market_subscription_var_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "flex_market_subscription" */
export type Flex_Market_Subscription_Var_Samp_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Flex_Market_Subscription_Variance_Fields = {
  __typename?: "flex_market_subscription_variance_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "flex_market_subscription" */
export type Flex_Market_Subscription_Variance_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** columns and relationships of "flyway_schema_history" */
export type Flyway_Schema_History = {
  __typename?: "flyway_schema_history"
  checksum?: Maybe<Scalars["Int"]["output"]>
  description: Scalars["String"]["output"]
  execution_time: Scalars["Int"]["output"]
  installed_by: Scalars["String"]["output"]
  installed_on: Scalars["timestamp"]["output"]
  installed_rank: Scalars["Int"]["output"]
  script: Scalars["String"]["output"]
  success: Scalars["Boolean"]["output"]
  type: Scalars["String"]["output"]
  version?: Maybe<Scalars["String"]["output"]>
}

/** aggregated selection of "flyway_schema_history" */
export type Flyway_Schema_History_Aggregate = {
  __typename?: "flyway_schema_history_aggregate"
  aggregate?: Maybe<Flyway_Schema_History_Aggregate_Fields>
  nodes: Array<Flyway_Schema_History>
}

/** aggregate fields of "flyway_schema_history" */
export type Flyway_Schema_History_Aggregate_Fields = {
  __typename?: "flyway_schema_history_aggregate_fields"
  avg?: Maybe<Flyway_Schema_History_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Flyway_Schema_History_Max_Fields>
  min?: Maybe<Flyway_Schema_History_Min_Fields>
  stddev?: Maybe<Flyway_Schema_History_Stddev_Fields>
  stddev_pop?: Maybe<Flyway_Schema_History_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Flyway_Schema_History_Stddev_Samp_Fields>
  sum?: Maybe<Flyway_Schema_History_Sum_Fields>
  var_pop?: Maybe<Flyway_Schema_History_Var_Pop_Fields>
  var_samp?: Maybe<Flyway_Schema_History_Var_Samp_Fields>
  variance?: Maybe<Flyway_Schema_History_Variance_Fields>
}

/** aggregate fields of "flyway_schema_history" */
export type Flyway_Schema_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Flyway_Schema_History_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Flyway_Schema_History_Avg_Fields = {
  __typename?: "flyway_schema_history_avg_fields"
  checksum?: Maybe<Scalars["Float"]["output"]>
  execution_time?: Maybe<Scalars["Float"]["output"]>
  installed_rank?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "flyway_schema_history". All fields are combined with a logical 'AND'. */
export type Flyway_Schema_History_Bool_Exp = {
  _and?: InputMaybe<Array<Flyway_Schema_History_Bool_Exp>>
  _not?: InputMaybe<Flyway_Schema_History_Bool_Exp>
  _or?: InputMaybe<Array<Flyway_Schema_History_Bool_Exp>>
  checksum?: InputMaybe<Int_Comparison_Exp>
  description?: InputMaybe<String_Comparison_Exp>
  execution_time?: InputMaybe<Int_Comparison_Exp>
  installed_by?: InputMaybe<String_Comparison_Exp>
  installed_on?: InputMaybe<Timestamp_Comparison_Exp>
  installed_rank?: InputMaybe<Int_Comparison_Exp>
  script?: InputMaybe<String_Comparison_Exp>
  success?: InputMaybe<Boolean_Comparison_Exp>
  type?: InputMaybe<String_Comparison_Exp>
  version?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "flyway_schema_history" */
export enum Flyway_Schema_History_Constraint {
  /** unique or primary key constraint on columns "installed_rank" */
  FlywaySchemaHistoryPk = "flyway_schema_history_pk",
}

/** input type for incrementing numeric columns in table "flyway_schema_history" */
export type Flyway_Schema_History_Inc_Input = {
  checksum?: InputMaybe<Scalars["Int"]["input"]>
  execution_time?: InputMaybe<Scalars["Int"]["input"]>
  installed_rank?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "flyway_schema_history" */
export type Flyway_Schema_History_Insert_Input = {
  checksum?: InputMaybe<Scalars["Int"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  execution_time?: InputMaybe<Scalars["Int"]["input"]>
  installed_by?: InputMaybe<Scalars["String"]["input"]>
  installed_on?: InputMaybe<Scalars["timestamp"]["input"]>
  installed_rank?: InputMaybe<Scalars["Int"]["input"]>
  script?: InputMaybe<Scalars["String"]["input"]>
  success?: InputMaybe<Scalars["Boolean"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  version?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Flyway_Schema_History_Max_Fields = {
  __typename?: "flyway_schema_history_max_fields"
  checksum?: Maybe<Scalars["Int"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  execution_time?: Maybe<Scalars["Int"]["output"]>
  installed_by?: Maybe<Scalars["String"]["output"]>
  installed_on?: Maybe<Scalars["timestamp"]["output"]>
  installed_rank?: Maybe<Scalars["Int"]["output"]>
  script?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  version?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Flyway_Schema_History_Min_Fields = {
  __typename?: "flyway_schema_history_min_fields"
  checksum?: Maybe<Scalars["Int"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  execution_time?: Maybe<Scalars["Int"]["output"]>
  installed_by?: Maybe<Scalars["String"]["output"]>
  installed_on?: Maybe<Scalars["timestamp"]["output"]>
  installed_rank?: Maybe<Scalars["Int"]["output"]>
  script?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  version?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "flyway_schema_history" */
export type Flyway_Schema_History_Mutation_Response = {
  __typename?: "flyway_schema_history_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Flyway_Schema_History>
}

/** on_conflict condition type for table "flyway_schema_history" */
export type Flyway_Schema_History_On_Conflict = {
  constraint: Flyway_Schema_History_Constraint
  update_columns?: Array<Flyway_Schema_History_Update_Column>
  where?: InputMaybe<Flyway_Schema_History_Bool_Exp>
}

/** Ordering options when selecting data from "flyway_schema_history". */
export type Flyway_Schema_History_Order_By = {
  checksum?: InputMaybe<Order_By>
  description?: InputMaybe<Order_By>
  execution_time?: InputMaybe<Order_By>
  installed_by?: InputMaybe<Order_By>
  installed_on?: InputMaybe<Order_By>
  installed_rank?: InputMaybe<Order_By>
  script?: InputMaybe<Order_By>
  success?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  version?: InputMaybe<Order_By>
}

/** primary key columns input for table: flyway_schema_history */
export type Flyway_Schema_History_Pk_Columns_Input = {
  installed_rank: Scalars["Int"]["input"]
}

/** select columns of table "flyway_schema_history" */
export enum Flyway_Schema_History_Select_Column {
  /** column name */
  Checksum = "checksum",
  /** column name */
  Description = "description",
  /** column name */
  ExecutionTime = "execution_time",
  /** column name */
  InstalledBy = "installed_by",
  /** column name */
  InstalledOn = "installed_on",
  /** column name */
  InstalledRank = "installed_rank",
  /** column name */
  Script = "script",
  /** column name */
  Success = "success",
  /** column name */
  Type = "type",
  /** column name */
  Version = "version",
}

/** input type for updating data in table "flyway_schema_history" */
export type Flyway_Schema_History_Set_Input = {
  checksum?: InputMaybe<Scalars["Int"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  execution_time?: InputMaybe<Scalars["Int"]["input"]>
  installed_by?: InputMaybe<Scalars["String"]["input"]>
  installed_on?: InputMaybe<Scalars["timestamp"]["input"]>
  installed_rank?: InputMaybe<Scalars["Int"]["input"]>
  script?: InputMaybe<Scalars["String"]["input"]>
  success?: InputMaybe<Scalars["Boolean"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  version?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Flyway_Schema_History_Stddev_Fields = {
  __typename?: "flyway_schema_history_stddev_fields"
  checksum?: Maybe<Scalars["Float"]["output"]>
  execution_time?: Maybe<Scalars["Float"]["output"]>
  installed_rank?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Flyway_Schema_History_Stddev_Pop_Fields = {
  __typename?: "flyway_schema_history_stddev_pop_fields"
  checksum?: Maybe<Scalars["Float"]["output"]>
  execution_time?: Maybe<Scalars["Float"]["output"]>
  installed_rank?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Flyway_Schema_History_Stddev_Samp_Fields = {
  __typename?: "flyway_schema_history_stddev_samp_fields"
  checksum?: Maybe<Scalars["Float"]["output"]>
  execution_time?: Maybe<Scalars["Float"]["output"]>
  installed_rank?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "flyway_schema_history" */
export type Flyway_Schema_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Flyway_Schema_History_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Flyway_Schema_History_Stream_Cursor_Value_Input = {
  checksum?: InputMaybe<Scalars["Int"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  execution_time?: InputMaybe<Scalars["Int"]["input"]>
  installed_by?: InputMaybe<Scalars["String"]["input"]>
  installed_on?: InputMaybe<Scalars["timestamp"]["input"]>
  installed_rank?: InputMaybe<Scalars["Int"]["input"]>
  script?: InputMaybe<Scalars["String"]["input"]>
  success?: InputMaybe<Scalars["Boolean"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  version?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Flyway_Schema_History_Sum_Fields = {
  __typename?: "flyway_schema_history_sum_fields"
  checksum?: Maybe<Scalars["Int"]["output"]>
  execution_time?: Maybe<Scalars["Int"]["output"]>
  installed_rank?: Maybe<Scalars["Int"]["output"]>
}

/** update columns of table "flyway_schema_history" */
export enum Flyway_Schema_History_Update_Column {
  /** column name */
  Checksum = "checksum",
  /** column name */
  Description = "description",
  /** column name */
  ExecutionTime = "execution_time",
  /** column name */
  InstalledBy = "installed_by",
  /** column name */
  InstalledOn = "installed_on",
  /** column name */
  InstalledRank = "installed_rank",
  /** column name */
  Script = "script",
  /** column name */
  Success = "success",
  /** column name */
  Type = "type",
  /** column name */
  Version = "version",
}

export type Flyway_Schema_History_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Flyway_Schema_History_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Flyway_Schema_History_Set_Input>
  /** filter the rows which have to be updated */
  where: Flyway_Schema_History_Bool_Exp
}

/** aggregate var_pop on columns */
export type Flyway_Schema_History_Var_Pop_Fields = {
  __typename?: "flyway_schema_history_var_pop_fields"
  checksum?: Maybe<Scalars["Float"]["output"]>
  execution_time?: Maybe<Scalars["Float"]["output"]>
  installed_rank?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Flyway_Schema_History_Var_Samp_Fields = {
  __typename?: "flyway_schema_history_var_samp_fields"
  checksum?: Maybe<Scalars["Float"]["output"]>
  execution_time?: Maybe<Scalars["Float"]["output"]>
  installed_rank?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Flyway_Schema_History_Variance_Fields = {
  __typename?: "flyway_schema_history_variance_fields"
  checksum?: Maybe<Scalars["Float"]["output"]>
  execution_time?: Maybe<Scalars["Float"]["output"]>
  installed_rank?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "frequency". All fields are combined with logical 'AND'. */
export type Frequency_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["frequency"]["input"]>
  _gt?: InputMaybe<Scalars["frequency"]["input"]>
  _gte?: InputMaybe<Scalars["frequency"]["input"]>
  _in?: InputMaybe<Array<Scalars["frequency"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["frequency"]["input"]>
  _lte?: InputMaybe<Scalars["frequency"]["input"]>
  _neq?: InputMaybe<Scalars["frequency"]["input"]>
  _nin?: InputMaybe<Array<Scalars["frequency"]["input"]>>
}

/** columns and relationships of "freshdesk_contact" */
export type Freshdesk_Contact = {
  __typename?: "freshdesk_contact"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  external_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_retry_at?: Maybe<Scalars["timestamp"]["output"]>
  mobile?: Maybe<Scalars["String"]["output"]>
  phone?: Maybe<Scalars["String"]["output"]>
  raw_data?: Maybe<Scalars["jsonb"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** columns and relationships of "freshdesk_contact" */
export type Freshdesk_ContactRaw_DataArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregated selection of "freshdesk_contact" */
export type Freshdesk_Contact_Aggregate = {
  __typename?: "freshdesk_contact_aggregate"
  aggregate?: Maybe<Freshdesk_Contact_Aggregate_Fields>
  nodes: Array<Freshdesk_Contact>
}

/** aggregate fields of "freshdesk_contact" */
export type Freshdesk_Contact_Aggregate_Fields = {
  __typename?: "freshdesk_contact_aggregate_fields"
  avg?: Maybe<Freshdesk_Contact_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Freshdesk_Contact_Max_Fields>
  min?: Maybe<Freshdesk_Contact_Min_Fields>
  stddev?: Maybe<Freshdesk_Contact_Stddev_Fields>
  stddev_pop?: Maybe<Freshdesk_Contact_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Freshdesk_Contact_Stddev_Samp_Fields>
  sum?: Maybe<Freshdesk_Contact_Sum_Fields>
  var_pop?: Maybe<Freshdesk_Contact_Var_Pop_Fields>
  var_samp?: Maybe<Freshdesk_Contact_Var_Samp_Fields>
  variance?: Maybe<Freshdesk_Contact_Variance_Fields>
}

/** aggregate fields of "freshdesk_contact" */
export type Freshdesk_Contact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Freshdesk_Contact_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Freshdesk_Contact_Append_Input = {
  raw_data?: InputMaybe<Scalars["jsonb"]["input"]>
}

/** aggregate avg on columns */
export type Freshdesk_Contact_Avg_Fields = {
  __typename?: "freshdesk_contact_avg_fields"
  external_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "freshdesk_contact". All fields are combined with a logical 'AND'. */
export type Freshdesk_Contact_Bool_Exp = {
  _and?: InputMaybe<Array<Freshdesk_Contact_Bool_Exp>>
  _not?: InputMaybe<Freshdesk_Contact_Bool_Exp>
  _or?: InputMaybe<Array<Freshdesk_Contact_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  email?: InputMaybe<String_Comparison_Exp>
  external_id?: InputMaybe<Bigint_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  last_retry_at?: InputMaybe<Timestamp_Comparison_Exp>
  mobile?: InputMaybe<String_Comparison_Exp>
  phone?: InputMaybe<String_Comparison_Exp>
  raw_data?: InputMaybe<Jsonb_Comparison_Exp>
  retry_count?: InputMaybe<Int_Comparison_Exp>
  type?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Freshdesk_Contact_Delete_At_Path_Input = {
  raw_data?: InputMaybe<Array<Scalars["String"]["input"]>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Freshdesk_Contact_Delete_Elem_Input = {
  raw_data?: InputMaybe<Scalars["Int"]["input"]>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Freshdesk_Contact_Delete_Key_Input = {
  raw_data?: InputMaybe<Scalars["String"]["input"]>
}

/** input type for incrementing numeric columns in table "freshdesk_contact" */
export type Freshdesk_Contact_Inc_Input = {
  external_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "freshdesk_contact" */
export type Freshdesk_Contact_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  external_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_retry_at?: InputMaybe<Scalars["timestamp"]["input"]>
  mobile?: InputMaybe<Scalars["String"]["input"]>
  phone?: InputMaybe<Scalars["String"]["input"]>
  raw_data?: InputMaybe<Scalars["jsonb"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Freshdesk_Contact_Max_Fields = {
  __typename?: "freshdesk_contact_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  external_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_retry_at?: Maybe<Scalars["timestamp"]["output"]>
  mobile?: Maybe<Scalars["String"]["output"]>
  phone?: Maybe<Scalars["String"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Freshdesk_Contact_Min_Fields = {
  __typename?: "freshdesk_contact_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  external_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_retry_at?: Maybe<Scalars["timestamp"]["output"]>
  mobile?: Maybe<Scalars["String"]["output"]>
  phone?: Maybe<Scalars["String"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "freshdesk_contact" */
export type Freshdesk_Contact_Mutation_Response = {
  __typename?: "freshdesk_contact_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Freshdesk_Contact>
}

/** Ordering options when selecting data from "freshdesk_contact". */
export type Freshdesk_Contact_Order_By = {
  account_number?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  email?: InputMaybe<Order_By>
  external_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  last_retry_at?: InputMaybe<Order_By>
  mobile?: InputMaybe<Order_By>
  phone?: InputMaybe<Order_By>
  raw_data?: InputMaybe<Order_By>
  retry_count?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Freshdesk_Contact_Prepend_Input = {
  raw_data?: InputMaybe<Scalars["jsonb"]["input"]>
}

/** select columns of table "freshdesk_contact" */
export enum Freshdesk_Contact_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Email = "email",
  /** column name */
  ExternalId = "external_id",
  /** column name */
  Id = "id",
  /** column name */
  LastRetryAt = "last_retry_at",
  /** column name */
  Mobile = "mobile",
  /** column name */
  Phone = "phone",
  /** column name */
  RawData = "raw_data",
  /** column name */
  RetryCount = "retry_count",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "freshdesk_contact" */
export type Freshdesk_Contact_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  external_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_retry_at?: InputMaybe<Scalars["timestamp"]["input"]>
  mobile?: InputMaybe<Scalars["String"]["input"]>
  phone?: InputMaybe<Scalars["String"]["input"]>
  raw_data?: InputMaybe<Scalars["jsonb"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Freshdesk_Contact_Stddev_Fields = {
  __typename?: "freshdesk_contact_stddev_fields"
  external_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Freshdesk_Contact_Stddev_Pop_Fields = {
  __typename?: "freshdesk_contact_stddev_pop_fields"
  external_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Freshdesk_Contact_Stddev_Samp_Fields = {
  __typename?: "freshdesk_contact_stddev_samp_fields"
  external_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "freshdesk_contact" */
export type Freshdesk_Contact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Freshdesk_Contact_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Freshdesk_Contact_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  external_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_retry_at?: InputMaybe<Scalars["timestamp"]["input"]>
  mobile?: InputMaybe<Scalars["String"]["input"]>
  phone?: InputMaybe<Scalars["String"]["input"]>
  raw_data?: InputMaybe<Scalars["jsonb"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Freshdesk_Contact_Sum_Fields = {
  __typename?: "freshdesk_contact_sum_fields"
  external_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
}

export type Freshdesk_Contact_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Freshdesk_Contact_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Freshdesk_Contact_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Freshdesk_Contact_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Freshdesk_Contact_Delete_Key_Input>
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Freshdesk_Contact_Inc_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Freshdesk_Contact_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Freshdesk_Contact_Set_Input>
  /** filter the rows which have to be updated */
  where: Freshdesk_Contact_Bool_Exp
}

/** aggregate var_pop on columns */
export type Freshdesk_Contact_Var_Pop_Fields = {
  __typename?: "freshdesk_contact_var_pop_fields"
  external_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Freshdesk_Contact_Var_Samp_Fields = {
  __typename?: "freshdesk_contact_var_samp_fields"
  external_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Freshdesk_Contact_Variance_Fields = {
  __typename?: "freshdesk_contact_variance_fields"
  external_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "freshdesk_ticket" */
export type Freshdesk_Ticket = {
  __typename?: "freshdesk_ticket"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  external_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_retry_at?: Maybe<Scalars["timestamp"]["output"]>
  raw_data?: Maybe<Scalars["jsonb"]["output"]>
  requester_external_id?: Maybe<Scalars["String"]["output"]>
  responder_external_id?: Maybe<Scalars["String"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** columns and relationships of "freshdesk_ticket" */
export type Freshdesk_TicketRaw_DataArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregated selection of "freshdesk_ticket" */
export type Freshdesk_Ticket_Aggregate = {
  __typename?: "freshdesk_ticket_aggregate"
  aggregate?: Maybe<Freshdesk_Ticket_Aggregate_Fields>
  nodes: Array<Freshdesk_Ticket>
}

/** aggregate fields of "freshdesk_ticket" */
export type Freshdesk_Ticket_Aggregate_Fields = {
  __typename?: "freshdesk_ticket_aggregate_fields"
  avg?: Maybe<Freshdesk_Ticket_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Freshdesk_Ticket_Max_Fields>
  min?: Maybe<Freshdesk_Ticket_Min_Fields>
  stddev?: Maybe<Freshdesk_Ticket_Stddev_Fields>
  stddev_pop?: Maybe<Freshdesk_Ticket_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Freshdesk_Ticket_Stddev_Samp_Fields>
  sum?: Maybe<Freshdesk_Ticket_Sum_Fields>
  var_pop?: Maybe<Freshdesk_Ticket_Var_Pop_Fields>
  var_samp?: Maybe<Freshdesk_Ticket_Var_Samp_Fields>
  variance?: Maybe<Freshdesk_Ticket_Variance_Fields>
}

/** aggregate fields of "freshdesk_ticket" */
export type Freshdesk_Ticket_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Freshdesk_Ticket_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Freshdesk_Ticket_Append_Input = {
  raw_data?: InputMaybe<Scalars["jsonb"]["input"]>
}

/** aggregate avg on columns */
export type Freshdesk_Ticket_Avg_Fields = {
  __typename?: "freshdesk_ticket_avg_fields"
  external_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "freshdesk_ticket". All fields are combined with a logical 'AND'. */
export type Freshdesk_Ticket_Bool_Exp = {
  _and?: InputMaybe<Array<Freshdesk_Ticket_Bool_Exp>>
  _not?: InputMaybe<Freshdesk_Ticket_Bool_Exp>
  _or?: InputMaybe<Array<Freshdesk_Ticket_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  external_id?: InputMaybe<Bigint_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  last_retry_at?: InputMaybe<Timestamp_Comparison_Exp>
  raw_data?: InputMaybe<Jsonb_Comparison_Exp>
  requester_external_id?: InputMaybe<String_Comparison_Exp>
  responder_external_id?: InputMaybe<String_Comparison_Exp>
  retry_count?: InputMaybe<Int_Comparison_Exp>
  type?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Freshdesk_Ticket_Delete_At_Path_Input = {
  raw_data?: InputMaybe<Array<Scalars["String"]["input"]>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Freshdesk_Ticket_Delete_Elem_Input = {
  raw_data?: InputMaybe<Scalars["Int"]["input"]>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Freshdesk_Ticket_Delete_Key_Input = {
  raw_data?: InputMaybe<Scalars["String"]["input"]>
}

/** input type for incrementing numeric columns in table "freshdesk_ticket" */
export type Freshdesk_Ticket_Inc_Input = {
  external_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "freshdesk_ticket" */
export type Freshdesk_Ticket_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  external_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_retry_at?: InputMaybe<Scalars["timestamp"]["input"]>
  raw_data?: InputMaybe<Scalars["jsonb"]["input"]>
  requester_external_id?: InputMaybe<Scalars["String"]["input"]>
  responder_external_id?: InputMaybe<Scalars["String"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Freshdesk_Ticket_Max_Fields = {
  __typename?: "freshdesk_ticket_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  external_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_retry_at?: Maybe<Scalars["timestamp"]["output"]>
  requester_external_id?: Maybe<Scalars["String"]["output"]>
  responder_external_id?: Maybe<Scalars["String"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Freshdesk_Ticket_Min_Fields = {
  __typename?: "freshdesk_ticket_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  external_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_retry_at?: Maybe<Scalars["timestamp"]["output"]>
  requester_external_id?: Maybe<Scalars["String"]["output"]>
  responder_external_id?: Maybe<Scalars["String"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "freshdesk_ticket" */
export type Freshdesk_Ticket_Mutation_Response = {
  __typename?: "freshdesk_ticket_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Freshdesk_Ticket>
}

/** Ordering options when selecting data from "freshdesk_ticket". */
export type Freshdesk_Ticket_Order_By = {
  created_at?: InputMaybe<Order_By>
  external_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  last_retry_at?: InputMaybe<Order_By>
  raw_data?: InputMaybe<Order_By>
  requester_external_id?: InputMaybe<Order_By>
  responder_external_id?: InputMaybe<Order_By>
  retry_count?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Freshdesk_Ticket_Prepend_Input = {
  raw_data?: InputMaybe<Scalars["jsonb"]["input"]>
}

/** select columns of table "freshdesk_ticket" */
export enum Freshdesk_Ticket_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  ExternalId = "external_id",
  /** column name */
  Id = "id",
  /** column name */
  LastRetryAt = "last_retry_at",
  /** column name */
  RawData = "raw_data",
  /** column name */
  RequesterExternalId = "requester_external_id",
  /** column name */
  ResponderExternalId = "responder_external_id",
  /** column name */
  RetryCount = "retry_count",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "freshdesk_ticket" */
export type Freshdesk_Ticket_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  external_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_retry_at?: InputMaybe<Scalars["timestamp"]["input"]>
  raw_data?: InputMaybe<Scalars["jsonb"]["input"]>
  requester_external_id?: InputMaybe<Scalars["String"]["input"]>
  responder_external_id?: InputMaybe<Scalars["String"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Freshdesk_Ticket_Stddev_Fields = {
  __typename?: "freshdesk_ticket_stddev_fields"
  external_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Freshdesk_Ticket_Stddev_Pop_Fields = {
  __typename?: "freshdesk_ticket_stddev_pop_fields"
  external_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Freshdesk_Ticket_Stddev_Samp_Fields = {
  __typename?: "freshdesk_ticket_stddev_samp_fields"
  external_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "freshdesk_ticket" */
export type Freshdesk_Ticket_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Freshdesk_Ticket_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Freshdesk_Ticket_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  external_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_retry_at?: InputMaybe<Scalars["timestamp"]["input"]>
  raw_data?: InputMaybe<Scalars["jsonb"]["input"]>
  requester_external_id?: InputMaybe<Scalars["String"]["input"]>
  responder_external_id?: InputMaybe<Scalars["String"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Freshdesk_Ticket_Sum_Fields = {
  __typename?: "freshdesk_ticket_sum_fields"
  external_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
}

export type Freshdesk_Ticket_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Freshdesk_Ticket_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Freshdesk_Ticket_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Freshdesk_Ticket_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Freshdesk_Ticket_Delete_Key_Input>
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Freshdesk_Ticket_Inc_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Freshdesk_Ticket_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Freshdesk_Ticket_Set_Input>
  /** filter the rows which have to be updated */
  where: Freshdesk_Ticket_Bool_Exp
}

/** aggregate var_pop on columns */
export type Freshdesk_Ticket_Var_Pop_Fields = {
  __typename?: "freshdesk_ticket_var_pop_fields"
  external_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Freshdesk_Ticket_Var_Samp_Fields = {
  __typename?: "freshdesk_ticket_var_samp_fields"
  external_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Freshdesk_Ticket_Variance_Fields = {
  __typename?: "freshdesk_ticket_variance_fields"
  external_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

export type Function_Get_Smart_Meter_Dashboard_Data_From_View_V8_Args = {
  alert_date_from_arg?: InputMaybe<Scalars["timestamp"]["input"]>
  alert_date_to_arg?: InputMaybe<Scalars["timestamp"]["input"]>
  alert_status_arg?: InputMaybe<Scalars["_text"]["input"]>
  alerts_arg?: InputMaybe<Scalars["_text"]["input"]>
  dev_statuses_arg?: InputMaybe<Scalars["_text"]["input"]>
  device_id_arg?: InputMaybe<Scalars["_text"]["input"]>
  error_arg?: InputMaybe<Scalars["_text"]["input"]>
  error_status_arg?: InputMaybe<Scalars["_text"]["input"]>
  firmware_status_arg?: InputMaybe<Scalars["_text"]["input"]>
  firmware_version_arg?: InputMaybe<Scalars["_text"]["input"]>
  gbcs_version_arg?: InputMaybe<Scalars["_text"]["input"]>
  installed_date_from_arg?: InputMaybe<Scalars["timestamp"]["input"]>
  installed_date_to_arg?: InputMaybe<Scalars["timestamp"]["input"]>
  last_orchestration_arg?: InputMaybe<Scalars["_text"]["input"]>
  last_read_date_from_arg?: InputMaybe<Scalars["timestamp"]["input"]>
  last_read_date_to_arg?: InputMaybe<Scalars["timestamp"]["input"]>
  limit_arg?: InputMaybe<Scalars["Int"]["input"]>
  manufacturer_arg?: InputMaybe<Scalars["_text"]["input"]>
  meter_type_arg?: InputMaybe<Scalars["_text"]["input"]>
  model_arg?: InputMaybe<Scalars["_text"]["input"]>
  offset_arg?: InputMaybe<Scalars["Int"]["input"]>
  orchestration_status_arg?: InputMaybe<Scalars["_text"]["input"]>
  payment_mode_arg?: InputMaybe<Scalars["_text"]["input"]>
  readings_received_filter_arg?: InputMaybe<Scalars["Boolean"]["input"]>
  region_arg?: InputMaybe<Scalars["_text"]["input"]>
  smets_version_arg?: InputMaybe<Scalars["_text"]["input"]>
  sort_column_arg?: InputMaybe<Scalars["String"]["input"]>
  sort_dxn_arg?: InputMaybe<Scalars["String"]["input"]>
  srv_arg?: InputMaybe<Scalars["_text"]["input"]>
  ssd_from_arg?: InputMaybe<Scalars["timestamp"]["input"]>
  ssd_to_arg?: InputMaybe<Scalars["timestamp"]["input"]>
  variant_arg?: InputMaybe<Scalars["_text"]["input"]>
  workstreams_arg?: InputMaybe<Scalars["_text"]["input"]>
}

/** Boolean expression to compare columns of type "future_start_date_requested_status". All fields are combined with logical 'AND'. */
export type Future_Start_Date_Requested_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["future_start_date_requested_status"]["input"]>
  _gt?: InputMaybe<Scalars["future_start_date_requested_status"]["input"]>
  _gte?: InputMaybe<Scalars["future_start_date_requested_status"]["input"]>
  _in?: InputMaybe<
    Array<Scalars["future_start_date_requested_status"]["input"]>
  >
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["future_start_date_requested_status"]["input"]>
  _lte?: InputMaybe<Scalars["future_start_date_requested_status"]["input"]>
  _neq?: InputMaybe<Scalars["future_start_date_requested_status"]["input"]>
  _nin?: InputMaybe<
    Array<Scalars["future_start_date_requested_status"]["input"]>
  >
}

/** columns and relationships of "install_codes" */
export type Install_Codes = {
  __typename?: "install_codes"
  asn_date?: Maybe<Scalars["date"]["output"]>
  asn_outcome?: Maybe<Scalars["String"]["output"]>
  comment?: Maybe<Scalars["String"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  cs_dashboard?: Maybe<Cs__Soe_Dashboard_Total>
  device_id?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  identifier: Scalars["String"]["output"]
  install_code?: Maybe<Scalars["String"]["output"]>
  last_date_checked?: Maybe<Scalars["date"]["output"]>
  map_id?: Maybe<Scalars["String"]["output"]>
  map_name?: Maybe<Scalars["String"]["output"]>
  /** An object relationship */
  meter?: Maybe<Meter>
  /** An object relationship */
  meter_point?: Maybe<Meter_Point>
  msn: Scalars["String"]["output"]
  requested_date?: Maybe<Scalars["date"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "install_codes" */
export type Install_Codes_Aggregate = {
  __typename?: "install_codes_aggregate"
  aggregate?: Maybe<Install_Codes_Aggregate_Fields>
  nodes: Array<Install_Codes>
}

/** aggregate fields of "install_codes" */
export type Install_Codes_Aggregate_Fields = {
  __typename?: "install_codes_aggregate_fields"
  avg?: Maybe<Install_Codes_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Install_Codes_Max_Fields>
  min?: Maybe<Install_Codes_Min_Fields>
  stddev?: Maybe<Install_Codes_Stddev_Fields>
  stddev_pop?: Maybe<Install_Codes_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Install_Codes_Stddev_Samp_Fields>
  sum?: Maybe<Install_Codes_Sum_Fields>
  var_pop?: Maybe<Install_Codes_Var_Pop_Fields>
  var_samp?: Maybe<Install_Codes_Var_Samp_Fields>
  variance?: Maybe<Install_Codes_Variance_Fields>
}

/** aggregate fields of "install_codes" */
export type Install_Codes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Install_Codes_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Install_Codes_Avg_Fields = {
  __typename?: "install_codes_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "install_codes". All fields are combined with a logical 'AND'. */
export type Install_Codes_Bool_Exp = {
  _and?: InputMaybe<Array<Install_Codes_Bool_Exp>>
  _not?: InputMaybe<Install_Codes_Bool_Exp>
  _or?: InputMaybe<Array<Install_Codes_Bool_Exp>>
  asn_date?: InputMaybe<Date_Comparison_Exp>
  asn_outcome?: InputMaybe<String_Comparison_Exp>
  comment?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  device_id?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  identifier?: InputMaybe<String_Comparison_Exp>
  install_code?: InputMaybe<String_Comparison_Exp>
  last_date_checked?: InputMaybe<Date_Comparison_Exp>
  map_id?: InputMaybe<String_Comparison_Exp>
  map_name?: InputMaybe<String_Comparison_Exp>
  meter?: InputMaybe<Meter_Bool_Exp>
  meter_point?: InputMaybe<Meter_Point_Bool_Exp>
  msn?: InputMaybe<String_Comparison_Exp>
  requested_date?: InputMaybe<Date_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "install_codes" */
export enum Install_Codes_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkInstallCodes = "pk_install_codes",
  /** unique or primary key constraint on columns "msn" */
  UqInstallCodesMsn = "uq_install_codes_msn",
}

/** input type for incrementing numeric columns in table "install_codes" */
export type Install_Codes_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "install_codes" */
export type Install_Codes_Insert_Input = {
  asn_date?: InputMaybe<Scalars["date"]["input"]>
  asn_outcome?: InputMaybe<Scalars["String"]["input"]>
  comment?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  device_id?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  identifier?: InputMaybe<Scalars["String"]["input"]>
  install_code?: InputMaybe<Scalars["String"]["input"]>
  last_date_checked?: InputMaybe<Scalars["date"]["input"]>
  map_id?: InputMaybe<Scalars["String"]["input"]>
  map_name?: InputMaybe<Scalars["String"]["input"]>
  meter?: InputMaybe<Meter_Obj_Rel_Insert_Input>
  meter_point?: InputMaybe<Meter_Point_Obj_Rel_Insert_Input>
  msn?: InputMaybe<Scalars["String"]["input"]>
  requested_date?: InputMaybe<Scalars["date"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Install_Codes_Max_Fields = {
  __typename?: "install_codes_max_fields"
  asn_date?: Maybe<Scalars["date"]["output"]>
  asn_outcome?: Maybe<Scalars["String"]["output"]>
  comment?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  device_id?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  identifier?: Maybe<Scalars["String"]["output"]>
  install_code?: Maybe<Scalars["String"]["output"]>
  last_date_checked?: Maybe<Scalars["date"]["output"]>
  map_id?: Maybe<Scalars["String"]["output"]>
  map_name?: Maybe<Scalars["String"]["output"]>
  msn?: Maybe<Scalars["String"]["output"]>
  requested_date?: Maybe<Scalars["date"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Install_Codes_Min_Fields = {
  __typename?: "install_codes_min_fields"
  asn_date?: Maybe<Scalars["date"]["output"]>
  asn_outcome?: Maybe<Scalars["String"]["output"]>
  comment?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  device_id?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  identifier?: Maybe<Scalars["String"]["output"]>
  install_code?: Maybe<Scalars["String"]["output"]>
  last_date_checked?: Maybe<Scalars["date"]["output"]>
  map_id?: Maybe<Scalars["String"]["output"]>
  map_name?: Maybe<Scalars["String"]["output"]>
  msn?: Maybe<Scalars["String"]["output"]>
  requested_date?: Maybe<Scalars["date"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "install_codes" */
export type Install_Codes_Mutation_Response = {
  __typename?: "install_codes_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Install_Codes>
}

/** input type for inserting object relation for remote table "install_codes" */
export type Install_Codes_Obj_Rel_Insert_Input = {
  data: Install_Codes_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Install_Codes_On_Conflict>
}

/** on_conflict condition type for table "install_codes" */
export type Install_Codes_On_Conflict = {
  constraint: Install_Codes_Constraint
  update_columns?: Array<Install_Codes_Update_Column>
  where?: InputMaybe<Install_Codes_Bool_Exp>
}

/** Ordering options when selecting data from "install_codes". */
export type Install_Codes_Order_By = {
  asn_date?: InputMaybe<Order_By>
  asn_outcome?: InputMaybe<Order_By>
  comment?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  device_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  identifier?: InputMaybe<Order_By>
  install_code?: InputMaybe<Order_By>
  last_date_checked?: InputMaybe<Order_By>
  map_id?: InputMaybe<Order_By>
  map_name?: InputMaybe<Order_By>
  meter?: InputMaybe<Meter_Order_By>
  meter_point?: InputMaybe<Meter_Point_Order_By>
  msn?: InputMaybe<Order_By>
  requested_date?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: install_codes */
export type Install_Codes_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "install_codes" */
export enum Install_Codes_Select_Column {
  /** column name */
  AsnDate = "asn_date",
  /** column name */
  AsnOutcome = "asn_outcome",
  /** column name */
  Comment = "comment",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DeviceId = "device_id",
  /** column name */
  Id = "id",
  /** column name */
  Identifier = "identifier",
  /** column name */
  InstallCode = "install_code",
  /** column name */
  LastDateChecked = "last_date_checked",
  /** column name */
  MapId = "map_id",
  /** column name */
  MapName = "map_name",
  /** column name */
  Msn = "msn",
  /** column name */
  RequestedDate = "requested_date",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "install_codes" */
export type Install_Codes_Set_Input = {
  asn_date?: InputMaybe<Scalars["date"]["input"]>
  asn_outcome?: InputMaybe<Scalars["String"]["input"]>
  comment?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  device_id?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  identifier?: InputMaybe<Scalars["String"]["input"]>
  install_code?: InputMaybe<Scalars["String"]["input"]>
  last_date_checked?: InputMaybe<Scalars["date"]["input"]>
  map_id?: InputMaybe<Scalars["String"]["input"]>
  map_name?: InputMaybe<Scalars["String"]["input"]>
  msn?: InputMaybe<Scalars["String"]["input"]>
  requested_date?: InputMaybe<Scalars["date"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Install_Codes_Stddev_Fields = {
  __typename?: "install_codes_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Install_Codes_Stddev_Pop_Fields = {
  __typename?: "install_codes_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Install_Codes_Stddev_Samp_Fields = {
  __typename?: "install_codes_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "install_codes" */
export type Install_Codes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Install_Codes_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Install_Codes_Stream_Cursor_Value_Input = {
  asn_date?: InputMaybe<Scalars["date"]["input"]>
  asn_outcome?: InputMaybe<Scalars["String"]["input"]>
  comment?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  device_id?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  identifier?: InputMaybe<Scalars["String"]["input"]>
  install_code?: InputMaybe<Scalars["String"]["input"]>
  last_date_checked?: InputMaybe<Scalars["date"]["input"]>
  map_id?: InputMaybe<Scalars["String"]["input"]>
  map_name?: InputMaybe<Scalars["String"]["input"]>
  msn?: InputMaybe<Scalars["String"]["input"]>
  requested_date?: InputMaybe<Scalars["date"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Install_Codes_Sum_Fields = {
  __typename?: "install_codes_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "install_codes" */
export enum Install_Codes_Update_Column {
  /** column name */
  AsnDate = "asn_date",
  /** column name */
  AsnOutcome = "asn_outcome",
  /** column name */
  Comment = "comment",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DeviceId = "device_id",
  /** column name */
  Id = "id",
  /** column name */
  Identifier = "identifier",
  /** column name */
  InstallCode = "install_code",
  /** column name */
  LastDateChecked = "last_date_checked",
  /** column name */
  MapId = "map_id",
  /** column name */
  MapName = "map_name",
  /** column name */
  Msn = "msn",
  /** column name */
  RequestedDate = "requested_date",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Install_Codes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Install_Codes_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Install_Codes_Set_Input>
  /** filter the rows which have to be updated */
  where: Install_Codes_Bool_Exp
}

/** aggregate var_pop on columns */
export type Install_Codes_Var_Pop_Fields = {
  __typename?: "install_codes_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Install_Codes_Var_Samp_Fields = {
  __typename?: "install_codes_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Install_Codes_Variance_Fields = {
  __typename?: "install_codes_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["json"]["input"]>
  _gt?: InputMaybe<Scalars["json"]["input"]>
  _gte?: InputMaybe<Scalars["json"]["input"]>
  _in?: InputMaybe<Array<Scalars["json"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["json"]["input"]>
  _lte?: InputMaybe<Scalars["json"]["input"]>
  _neq?: InputMaybe<Scalars["json"]["input"]>
  _nin?: InputMaybe<Array<Scalars["json"]["input"]>>
}

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>
}

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars["jsonb"]["input"]>
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars["jsonb"]["input"]>
  _eq?: InputMaybe<Scalars["jsonb"]["input"]>
  _gt?: InputMaybe<Scalars["jsonb"]["input"]>
  _gte?: InputMaybe<Scalars["jsonb"]["input"]>
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars["String"]["input"]>
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars["String"]["input"]>>
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars["String"]["input"]>>
  _in?: InputMaybe<Array<Scalars["jsonb"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["jsonb"]["input"]>
  _lte?: InputMaybe<Scalars["jsonb"]["input"]>
  _neq?: InputMaybe<Scalars["jsonb"]["input"]>
  _nin?: InputMaybe<Array<Scalars["jsonb"]["input"]>>
}

/** columns and relationships of "junifer__Account" */
export type Junifer__Account = {
  __typename?: "junifer__Account"
  accountTypeFk?: Maybe<Scalars["bigint"]["output"]>
  autoRebillBehaviour?: Maybe<Scalars["String"]["output"]>
  billPackageFk?: Maybe<Scalars["bigint"]["output"]>
  billingAlignDttm?: Maybe<Scalars["timestamptz"]["output"]>
  billingCycleFk?: Maybe<Scalars["bigint"]["output"]>
  billingEntityFk?: Maybe<Scalars["bigint"]["output"]>
  billing_account?: Maybe<Billing_Account>
  cancelFl?: Maybe<Scalars["String"]["output"]>
  cancelledDttm?: Maybe<Scalars["timestamptz"]["output"]>
  cancelledUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  closedDttm?: Maybe<Scalars["timestamptz"]["output"]>
  createdDttm?: Maybe<Scalars["timestamptz"]["output"]>
  createdUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  currencyFk?: Maybe<Scalars["bigint"]["output"]>
  /** An object relationship */
  customer?: Maybe<Junifer__Customer>
  customerFk?: Maybe<Scalars["bigint"]["output"]>
  deleteFl?: Maybe<Scalars["String"]["output"]>
  dunningPackageFk?: Maybe<Scalars["bigint"]["output"]>
  fromDttm?: Maybe<Scalars["timestamptz"]["output"]>
  id: Scalars["bigint"]["output"]
  initialBillStatus?: Maybe<Scalars["String"]["output"]>
  languageTblFk?: Maybe<Scalars["bigint"]["output"]>
  lastAccountTransactionFk?: Maybe<Scalars["bigint"]["output"]>
  /** An object relationship */
  last_transaction?: Maybe<Junifer__AccountTransaction>
  name?: Maybe<Scalars["String"]["output"]>
  number?: Maybe<Scalars["String"]["output"]>
  overrideAllocateCreditOnRebill?: Maybe<Scalars["String"]["output"]>
  parentAccountFk?: Maybe<Scalars["bigint"]["output"]>
  parentOverridesChildFl?: Maybe<Scalars["String"]["output"]>
  parentReconciliationBillingFl?: Maybe<Scalars["String"]["output"]>
  partitionId?: Maybe<Scalars["bigint"]["output"]>
  payPointLocation?: Maybe<Scalars["String"]["output"]>
  paymentDataErasedFl?: Maybe<Scalars["String"]["output"]>
  paymentTermFk?: Maybe<Scalars["bigint"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  salesTaxExemptFl?: Maybe<Scalars["String"]["output"]>
  /** An object relationship */
  synchronized_account?: Maybe<Synchronized_Accounts>
  terminatedDttm?: Maybe<Scalars["timestamptz"]["output"]>
  terminatedUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  toDttm?: Maybe<Scalars["timestamptz"]["output"]>
  txnAllocatorComponentFk?: Maybe<Scalars["bigint"]["output"]>
  versionNo?: Maybe<Scalars["Int"]["output"]>
}

/** columns and relationships of "junifer__AccountTransaction" */
export type Junifer__AccountTransaction = {
  __typename?: "junifer__AccountTransaction"
  acceptedByUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  acceptedDttm?: Maybe<Scalars["date"]["output"]>
  accountBalance?: Maybe<Scalars["numeric"]["output"]>
  accountFk?: Maybe<Scalars["bigint"]["output"]>
  accountTransactionTypeFk?: Maybe<Scalars["bigint"]["output"]>
  authorisedByUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  authorisedDttm?: Maybe<Scalars["timestamptz"]["output"]>
  cancelAccountTransactionFk?: Maybe<Scalars["bigint"]["output"]>
  cancelledByUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  cancelledDttm?: Maybe<Scalars["timestamptz"]["output"]>
  collectionCancelledByUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  collectionCancelledDttm?: Maybe<Scalars["timestamptz"]["output"]>
  collectionDt?: Maybe<Scalars["date"]["output"]>
  collectionRequestDt?: Maybe<Scalars["date"]["output"]>
  collectionScheduledFl?: Maybe<Scalars["String"]["output"]>
  createdDttm?: Maybe<Scalars["timestamptz"]["output"]>
  createdUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  creditAmount?: Maybe<Scalars["numeric"]["output"]>
  creditBalance?: Maybe<Scalars["numeric"]["output"]>
  currencyFk?: Maybe<Scalars["bigint"]["output"]>
  debitAmount?: Maybe<Scalars["numeric"]["output"]>
  debitBalance?: Maybe<Scalars["numeric"]["output"]>
  deleteFl?: Maybe<Scalars["String"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  dueDt?: Maybe<Scalars["date"]["output"]>
  dunningFl?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  maxCollectionAmount?: Maybe<Scalars["numeric"]["output"]>
  orderNo?: Maybe<Scalars["Int"]["output"]>
  partitionId?: Maybe<Scalars["bigint"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  rejectedByUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  rejectedDttm?: Maybe<Scalars["timestamptz"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  versionNo?: Maybe<Scalars["Int"]["output"]>
}

/** aggregated selection of "junifer__AccountTransaction" */
export type Junifer__AccountTransaction_Aggregate = {
  __typename?: "junifer__AccountTransaction_aggregate"
  aggregate?: Maybe<Junifer__AccountTransaction_Aggregate_Fields>
  nodes: Array<Junifer__AccountTransaction>
}

/** aggregate fields of "junifer__AccountTransaction" */
export type Junifer__AccountTransaction_Aggregate_Fields = {
  __typename?: "junifer__AccountTransaction_aggregate_fields"
  avg?: Maybe<Junifer__AccountTransaction_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Junifer__AccountTransaction_Max_Fields>
  min?: Maybe<Junifer__AccountTransaction_Min_Fields>
  stddev?: Maybe<Junifer__AccountTransaction_Stddev_Fields>
  stddev_pop?: Maybe<Junifer__AccountTransaction_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Junifer__AccountTransaction_Stddev_Samp_Fields>
  sum?: Maybe<Junifer__AccountTransaction_Sum_Fields>
  var_pop?: Maybe<Junifer__AccountTransaction_Var_Pop_Fields>
  var_samp?: Maybe<Junifer__AccountTransaction_Var_Samp_Fields>
  variance?: Maybe<Junifer__AccountTransaction_Variance_Fields>
}

/** aggregate fields of "junifer__AccountTransaction" */
export type Junifer__AccountTransaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Junifer__AccountTransaction_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Junifer__AccountTransaction_Avg_Fields = {
  __typename?: "junifer__AccountTransaction_avg_fields"
  acceptedByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  accountBalance?: Maybe<Scalars["Float"]["output"]>
  accountFk?: Maybe<Scalars["Float"]["output"]>
  accountTransactionTypeFk?: Maybe<Scalars["Float"]["output"]>
  authorisedByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  cancelAccountTransactionFk?: Maybe<Scalars["Float"]["output"]>
  cancelledByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  collectionCancelledByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  createdUserTblFk?: Maybe<Scalars["Float"]["output"]>
  creditAmount?: Maybe<Scalars["Float"]["output"]>
  creditBalance?: Maybe<Scalars["Float"]["output"]>
  currencyFk?: Maybe<Scalars["Float"]["output"]>
  debitAmount?: Maybe<Scalars["Float"]["output"]>
  debitBalance?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  maxCollectionAmount?: Maybe<Scalars["Float"]["output"]>
  orderNo?: Maybe<Scalars["Float"]["output"]>
  partitionId?: Maybe<Scalars["Float"]["output"]>
  rejectedByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  versionNo?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "junifer__AccountTransaction". All fields are combined with a logical 'AND'. */
export type Junifer__AccountTransaction_Bool_Exp = {
  _and?: InputMaybe<Array<Junifer__AccountTransaction_Bool_Exp>>
  _not?: InputMaybe<Junifer__AccountTransaction_Bool_Exp>
  _or?: InputMaybe<Array<Junifer__AccountTransaction_Bool_Exp>>
  acceptedByUserTblFk?: InputMaybe<Bigint_Comparison_Exp>
  acceptedDttm?: InputMaybe<Date_Comparison_Exp>
  accountBalance?: InputMaybe<Numeric_Comparison_Exp>
  accountFk?: InputMaybe<Bigint_Comparison_Exp>
  accountTransactionTypeFk?: InputMaybe<Bigint_Comparison_Exp>
  authorisedByUserTblFk?: InputMaybe<Bigint_Comparison_Exp>
  authorisedDttm?: InputMaybe<Timestamptz_Comparison_Exp>
  cancelAccountTransactionFk?: InputMaybe<Bigint_Comparison_Exp>
  cancelledByUserTblFk?: InputMaybe<Bigint_Comparison_Exp>
  cancelledDttm?: InputMaybe<Timestamptz_Comparison_Exp>
  collectionCancelledByUserTblFk?: InputMaybe<Bigint_Comparison_Exp>
  collectionCancelledDttm?: InputMaybe<Timestamptz_Comparison_Exp>
  collectionDt?: InputMaybe<Date_Comparison_Exp>
  collectionRequestDt?: InputMaybe<Date_Comparison_Exp>
  collectionScheduledFl?: InputMaybe<String_Comparison_Exp>
  createdDttm?: InputMaybe<Timestamptz_Comparison_Exp>
  createdUserTblFk?: InputMaybe<Bigint_Comparison_Exp>
  creditAmount?: InputMaybe<Numeric_Comparison_Exp>
  creditBalance?: InputMaybe<Numeric_Comparison_Exp>
  currencyFk?: InputMaybe<Bigint_Comparison_Exp>
  debitAmount?: InputMaybe<Numeric_Comparison_Exp>
  debitBalance?: InputMaybe<Numeric_Comparison_Exp>
  deleteFl?: InputMaybe<String_Comparison_Exp>
  description?: InputMaybe<String_Comparison_Exp>
  dueDt?: InputMaybe<Date_Comparison_Exp>
  dunningFl?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  maxCollectionAmount?: InputMaybe<Numeric_Comparison_Exp>
  orderNo?: InputMaybe<Int_Comparison_Exp>
  partitionId?: InputMaybe<Bigint_Comparison_Exp>
  reference?: InputMaybe<String_Comparison_Exp>
  rejectedByUserTblFk?: InputMaybe<Bigint_Comparison_Exp>
  rejectedDttm?: InputMaybe<Timestamptz_Comparison_Exp>
  status?: InputMaybe<String_Comparison_Exp>
  versionNo?: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "junifer__AccountTransaction" */
export enum Junifer__AccountTransaction_Constraint {
  /** unique or primary key constraint on columns "id", "accountFk" */
  IxJuniferAccountTransactionSs1 = "ix_junifer__AccountTransactionSs1",
  /** unique or primary key constraint on columns "id" */
  JuniferAccountTransactionPkey = "junifer__AccountTransaction_pkey",
}

/** input type for incrementing numeric columns in table "junifer__AccountTransaction" */
export type Junifer__AccountTransaction_Inc_Input = {
  acceptedByUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  accountBalance?: InputMaybe<Scalars["numeric"]["input"]>
  accountFk?: InputMaybe<Scalars["bigint"]["input"]>
  accountTransactionTypeFk?: InputMaybe<Scalars["bigint"]["input"]>
  authorisedByUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  cancelAccountTransactionFk?: InputMaybe<Scalars["bigint"]["input"]>
  cancelledByUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  collectionCancelledByUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  createdUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  creditAmount?: InputMaybe<Scalars["numeric"]["input"]>
  creditBalance?: InputMaybe<Scalars["numeric"]["input"]>
  currencyFk?: InputMaybe<Scalars["bigint"]["input"]>
  debitAmount?: InputMaybe<Scalars["numeric"]["input"]>
  debitBalance?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  maxCollectionAmount?: InputMaybe<Scalars["numeric"]["input"]>
  orderNo?: InputMaybe<Scalars["Int"]["input"]>
  partitionId?: InputMaybe<Scalars["bigint"]["input"]>
  rejectedByUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  versionNo?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "junifer__AccountTransaction" */
export type Junifer__AccountTransaction_Insert_Input = {
  acceptedByUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  acceptedDttm?: InputMaybe<Scalars["date"]["input"]>
  accountBalance?: InputMaybe<Scalars["numeric"]["input"]>
  accountFk?: InputMaybe<Scalars["bigint"]["input"]>
  accountTransactionTypeFk?: InputMaybe<Scalars["bigint"]["input"]>
  authorisedByUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  authorisedDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  cancelAccountTransactionFk?: InputMaybe<Scalars["bigint"]["input"]>
  cancelledByUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  cancelledDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  collectionCancelledByUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  collectionCancelledDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  collectionDt?: InputMaybe<Scalars["date"]["input"]>
  collectionRequestDt?: InputMaybe<Scalars["date"]["input"]>
  collectionScheduledFl?: InputMaybe<Scalars["String"]["input"]>
  createdDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  createdUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  creditAmount?: InputMaybe<Scalars["numeric"]["input"]>
  creditBalance?: InputMaybe<Scalars["numeric"]["input"]>
  currencyFk?: InputMaybe<Scalars["bigint"]["input"]>
  debitAmount?: InputMaybe<Scalars["numeric"]["input"]>
  debitBalance?: InputMaybe<Scalars["numeric"]["input"]>
  deleteFl?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  dueDt?: InputMaybe<Scalars["date"]["input"]>
  dunningFl?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  maxCollectionAmount?: InputMaybe<Scalars["numeric"]["input"]>
  orderNo?: InputMaybe<Scalars["Int"]["input"]>
  partitionId?: InputMaybe<Scalars["bigint"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  rejectedByUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  rejectedDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  versionNo?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate max on columns */
export type Junifer__AccountTransaction_Max_Fields = {
  __typename?: "junifer__AccountTransaction_max_fields"
  acceptedByUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  acceptedDttm?: Maybe<Scalars["date"]["output"]>
  accountBalance?: Maybe<Scalars["numeric"]["output"]>
  accountFk?: Maybe<Scalars["bigint"]["output"]>
  accountTransactionTypeFk?: Maybe<Scalars["bigint"]["output"]>
  authorisedByUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  authorisedDttm?: Maybe<Scalars["timestamptz"]["output"]>
  cancelAccountTransactionFk?: Maybe<Scalars["bigint"]["output"]>
  cancelledByUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  cancelledDttm?: Maybe<Scalars["timestamptz"]["output"]>
  collectionCancelledByUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  collectionCancelledDttm?: Maybe<Scalars["timestamptz"]["output"]>
  collectionDt?: Maybe<Scalars["date"]["output"]>
  collectionRequestDt?: Maybe<Scalars["date"]["output"]>
  collectionScheduledFl?: Maybe<Scalars["String"]["output"]>
  createdDttm?: Maybe<Scalars["timestamptz"]["output"]>
  createdUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  creditAmount?: Maybe<Scalars["numeric"]["output"]>
  creditBalance?: Maybe<Scalars["numeric"]["output"]>
  currencyFk?: Maybe<Scalars["bigint"]["output"]>
  debitAmount?: Maybe<Scalars["numeric"]["output"]>
  debitBalance?: Maybe<Scalars["numeric"]["output"]>
  deleteFl?: Maybe<Scalars["String"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  dueDt?: Maybe<Scalars["date"]["output"]>
  dunningFl?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  maxCollectionAmount?: Maybe<Scalars["numeric"]["output"]>
  orderNo?: Maybe<Scalars["Int"]["output"]>
  partitionId?: Maybe<Scalars["bigint"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  rejectedByUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  rejectedDttm?: Maybe<Scalars["timestamptz"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  versionNo?: Maybe<Scalars["Int"]["output"]>
}

/** aggregate min on columns */
export type Junifer__AccountTransaction_Min_Fields = {
  __typename?: "junifer__AccountTransaction_min_fields"
  acceptedByUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  acceptedDttm?: Maybe<Scalars["date"]["output"]>
  accountBalance?: Maybe<Scalars["numeric"]["output"]>
  accountFk?: Maybe<Scalars["bigint"]["output"]>
  accountTransactionTypeFk?: Maybe<Scalars["bigint"]["output"]>
  authorisedByUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  authorisedDttm?: Maybe<Scalars["timestamptz"]["output"]>
  cancelAccountTransactionFk?: Maybe<Scalars["bigint"]["output"]>
  cancelledByUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  cancelledDttm?: Maybe<Scalars["timestamptz"]["output"]>
  collectionCancelledByUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  collectionCancelledDttm?: Maybe<Scalars["timestamptz"]["output"]>
  collectionDt?: Maybe<Scalars["date"]["output"]>
  collectionRequestDt?: Maybe<Scalars["date"]["output"]>
  collectionScheduledFl?: Maybe<Scalars["String"]["output"]>
  createdDttm?: Maybe<Scalars["timestamptz"]["output"]>
  createdUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  creditAmount?: Maybe<Scalars["numeric"]["output"]>
  creditBalance?: Maybe<Scalars["numeric"]["output"]>
  currencyFk?: Maybe<Scalars["bigint"]["output"]>
  debitAmount?: Maybe<Scalars["numeric"]["output"]>
  debitBalance?: Maybe<Scalars["numeric"]["output"]>
  deleteFl?: Maybe<Scalars["String"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  dueDt?: Maybe<Scalars["date"]["output"]>
  dunningFl?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  maxCollectionAmount?: Maybe<Scalars["numeric"]["output"]>
  orderNo?: Maybe<Scalars["Int"]["output"]>
  partitionId?: Maybe<Scalars["bigint"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  rejectedByUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  rejectedDttm?: Maybe<Scalars["timestamptz"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  versionNo?: Maybe<Scalars["Int"]["output"]>
}

/** response of any mutation on the table "junifer__AccountTransaction" */
export type Junifer__AccountTransaction_Mutation_Response = {
  __typename?: "junifer__AccountTransaction_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Junifer__AccountTransaction>
}

/** input type for inserting object relation for remote table "junifer__AccountTransaction" */
export type Junifer__AccountTransaction_Obj_Rel_Insert_Input = {
  data: Junifer__AccountTransaction_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Junifer__AccountTransaction_On_Conflict>
}

/** on_conflict condition type for table "junifer__AccountTransaction" */
export type Junifer__AccountTransaction_On_Conflict = {
  constraint: Junifer__AccountTransaction_Constraint
  update_columns?: Array<Junifer__AccountTransaction_Update_Column>
  where?: InputMaybe<Junifer__AccountTransaction_Bool_Exp>
}

/** Ordering options when selecting data from "junifer__AccountTransaction". */
export type Junifer__AccountTransaction_Order_By = {
  acceptedByUserTblFk?: InputMaybe<Order_By>
  acceptedDttm?: InputMaybe<Order_By>
  accountBalance?: InputMaybe<Order_By>
  accountFk?: InputMaybe<Order_By>
  accountTransactionTypeFk?: InputMaybe<Order_By>
  authorisedByUserTblFk?: InputMaybe<Order_By>
  authorisedDttm?: InputMaybe<Order_By>
  cancelAccountTransactionFk?: InputMaybe<Order_By>
  cancelledByUserTblFk?: InputMaybe<Order_By>
  cancelledDttm?: InputMaybe<Order_By>
  collectionCancelledByUserTblFk?: InputMaybe<Order_By>
  collectionCancelledDttm?: InputMaybe<Order_By>
  collectionDt?: InputMaybe<Order_By>
  collectionRequestDt?: InputMaybe<Order_By>
  collectionScheduledFl?: InputMaybe<Order_By>
  createdDttm?: InputMaybe<Order_By>
  createdUserTblFk?: InputMaybe<Order_By>
  creditAmount?: InputMaybe<Order_By>
  creditBalance?: InputMaybe<Order_By>
  currencyFk?: InputMaybe<Order_By>
  debitAmount?: InputMaybe<Order_By>
  debitBalance?: InputMaybe<Order_By>
  deleteFl?: InputMaybe<Order_By>
  description?: InputMaybe<Order_By>
  dueDt?: InputMaybe<Order_By>
  dunningFl?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  maxCollectionAmount?: InputMaybe<Order_By>
  orderNo?: InputMaybe<Order_By>
  partitionId?: InputMaybe<Order_By>
  reference?: InputMaybe<Order_By>
  rejectedByUserTblFk?: InputMaybe<Order_By>
  rejectedDttm?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  versionNo?: InputMaybe<Order_By>
}

/** primary key columns input for table: junifer__AccountTransaction */
export type Junifer__AccountTransaction_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "junifer__AccountTransaction" */
export enum Junifer__AccountTransaction_Select_Column {
  /** column name */
  AcceptedByUserTblFk = "acceptedByUserTblFk",
  /** column name */
  AcceptedDttm = "acceptedDttm",
  /** column name */
  AccountBalance = "accountBalance",
  /** column name */
  AccountFk = "accountFk",
  /** column name */
  AccountTransactionTypeFk = "accountTransactionTypeFk",
  /** column name */
  AuthorisedByUserTblFk = "authorisedByUserTblFk",
  /** column name */
  AuthorisedDttm = "authorisedDttm",
  /** column name */
  CancelAccountTransactionFk = "cancelAccountTransactionFk",
  /** column name */
  CancelledByUserTblFk = "cancelledByUserTblFk",
  /** column name */
  CancelledDttm = "cancelledDttm",
  /** column name */
  CollectionCancelledByUserTblFk = "collectionCancelledByUserTblFk",
  /** column name */
  CollectionCancelledDttm = "collectionCancelledDttm",
  /** column name */
  CollectionDt = "collectionDt",
  /** column name */
  CollectionRequestDt = "collectionRequestDt",
  /** column name */
  CollectionScheduledFl = "collectionScheduledFl",
  /** column name */
  CreatedDttm = "createdDttm",
  /** column name */
  CreatedUserTblFk = "createdUserTblFk",
  /** column name */
  CreditAmount = "creditAmount",
  /** column name */
  CreditBalance = "creditBalance",
  /** column name */
  CurrencyFk = "currencyFk",
  /** column name */
  DebitAmount = "debitAmount",
  /** column name */
  DebitBalance = "debitBalance",
  /** column name */
  DeleteFl = "deleteFl",
  /** column name */
  Description = "description",
  /** column name */
  DueDt = "dueDt",
  /** column name */
  DunningFl = "dunningFl",
  /** column name */
  Id = "id",
  /** column name */
  MaxCollectionAmount = "maxCollectionAmount",
  /** column name */
  OrderNo = "orderNo",
  /** column name */
  PartitionId = "partitionId",
  /** column name */
  Reference = "reference",
  /** column name */
  RejectedByUserTblFk = "rejectedByUserTblFk",
  /** column name */
  RejectedDttm = "rejectedDttm",
  /** column name */
  Status = "status",
  /** column name */
  VersionNo = "versionNo",
}

/** input type for updating data in table "junifer__AccountTransaction" */
export type Junifer__AccountTransaction_Set_Input = {
  acceptedByUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  acceptedDttm?: InputMaybe<Scalars["date"]["input"]>
  accountBalance?: InputMaybe<Scalars["numeric"]["input"]>
  accountFk?: InputMaybe<Scalars["bigint"]["input"]>
  accountTransactionTypeFk?: InputMaybe<Scalars["bigint"]["input"]>
  authorisedByUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  authorisedDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  cancelAccountTransactionFk?: InputMaybe<Scalars["bigint"]["input"]>
  cancelledByUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  cancelledDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  collectionCancelledByUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  collectionCancelledDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  collectionDt?: InputMaybe<Scalars["date"]["input"]>
  collectionRequestDt?: InputMaybe<Scalars["date"]["input"]>
  collectionScheduledFl?: InputMaybe<Scalars["String"]["input"]>
  createdDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  createdUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  creditAmount?: InputMaybe<Scalars["numeric"]["input"]>
  creditBalance?: InputMaybe<Scalars["numeric"]["input"]>
  currencyFk?: InputMaybe<Scalars["bigint"]["input"]>
  debitAmount?: InputMaybe<Scalars["numeric"]["input"]>
  debitBalance?: InputMaybe<Scalars["numeric"]["input"]>
  deleteFl?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  dueDt?: InputMaybe<Scalars["date"]["input"]>
  dunningFl?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  maxCollectionAmount?: InputMaybe<Scalars["numeric"]["input"]>
  orderNo?: InputMaybe<Scalars["Int"]["input"]>
  partitionId?: InputMaybe<Scalars["bigint"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  rejectedByUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  rejectedDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  versionNo?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate stddev on columns */
export type Junifer__AccountTransaction_Stddev_Fields = {
  __typename?: "junifer__AccountTransaction_stddev_fields"
  acceptedByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  accountBalance?: Maybe<Scalars["Float"]["output"]>
  accountFk?: Maybe<Scalars["Float"]["output"]>
  accountTransactionTypeFk?: Maybe<Scalars["Float"]["output"]>
  authorisedByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  cancelAccountTransactionFk?: Maybe<Scalars["Float"]["output"]>
  cancelledByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  collectionCancelledByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  createdUserTblFk?: Maybe<Scalars["Float"]["output"]>
  creditAmount?: Maybe<Scalars["Float"]["output"]>
  creditBalance?: Maybe<Scalars["Float"]["output"]>
  currencyFk?: Maybe<Scalars["Float"]["output"]>
  debitAmount?: Maybe<Scalars["Float"]["output"]>
  debitBalance?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  maxCollectionAmount?: Maybe<Scalars["Float"]["output"]>
  orderNo?: Maybe<Scalars["Float"]["output"]>
  partitionId?: Maybe<Scalars["Float"]["output"]>
  rejectedByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  versionNo?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Junifer__AccountTransaction_Stddev_Pop_Fields = {
  __typename?: "junifer__AccountTransaction_stddev_pop_fields"
  acceptedByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  accountBalance?: Maybe<Scalars["Float"]["output"]>
  accountFk?: Maybe<Scalars["Float"]["output"]>
  accountTransactionTypeFk?: Maybe<Scalars["Float"]["output"]>
  authorisedByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  cancelAccountTransactionFk?: Maybe<Scalars["Float"]["output"]>
  cancelledByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  collectionCancelledByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  createdUserTblFk?: Maybe<Scalars["Float"]["output"]>
  creditAmount?: Maybe<Scalars["Float"]["output"]>
  creditBalance?: Maybe<Scalars["Float"]["output"]>
  currencyFk?: Maybe<Scalars["Float"]["output"]>
  debitAmount?: Maybe<Scalars["Float"]["output"]>
  debitBalance?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  maxCollectionAmount?: Maybe<Scalars["Float"]["output"]>
  orderNo?: Maybe<Scalars["Float"]["output"]>
  partitionId?: Maybe<Scalars["Float"]["output"]>
  rejectedByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  versionNo?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Junifer__AccountTransaction_Stddev_Samp_Fields = {
  __typename?: "junifer__AccountTransaction_stddev_samp_fields"
  acceptedByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  accountBalance?: Maybe<Scalars["Float"]["output"]>
  accountFk?: Maybe<Scalars["Float"]["output"]>
  accountTransactionTypeFk?: Maybe<Scalars["Float"]["output"]>
  authorisedByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  cancelAccountTransactionFk?: Maybe<Scalars["Float"]["output"]>
  cancelledByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  collectionCancelledByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  createdUserTblFk?: Maybe<Scalars["Float"]["output"]>
  creditAmount?: Maybe<Scalars["Float"]["output"]>
  creditBalance?: Maybe<Scalars["Float"]["output"]>
  currencyFk?: Maybe<Scalars["Float"]["output"]>
  debitAmount?: Maybe<Scalars["Float"]["output"]>
  debitBalance?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  maxCollectionAmount?: Maybe<Scalars["Float"]["output"]>
  orderNo?: Maybe<Scalars["Float"]["output"]>
  partitionId?: Maybe<Scalars["Float"]["output"]>
  rejectedByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  versionNo?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "junifer__AccountTransaction" */
export type Junifer__AccountTransaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Junifer__AccountTransaction_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Junifer__AccountTransaction_Stream_Cursor_Value_Input = {
  acceptedByUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  acceptedDttm?: InputMaybe<Scalars["date"]["input"]>
  accountBalance?: InputMaybe<Scalars["numeric"]["input"]>
  accountFk?: InputMaybe<Scalars["bigint"]["input"]>
  accountTransactionTypeFk?: InputMaybe<Scalars["bigint"]["input"]>
  authorisedByUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  authorisedDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  cancelAccountTransactionFk?: InputMaybe<Scalars["bigint"]["input"]>
  cancelledByUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  cancelledDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  collectionCancelledByUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  collectionCancelledDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  collectionDt?: InputMaybe<Scalars["date"]["input"]>
  collectionRequestDt?: InputMaybe<Scalars["date"]["input"]>
  collectionScheduledFl?: InputMaybe<Scalars["String"]["input"]>
  createdDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  createdUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  creditAmount?: InputMaybe<Scalars["numeric"]["input"]>
  creditBalance?: InputMaybe<Scalars["numeric"]["input"]>
  currencyFk?: InputMaybe<Scalars["bigint"]["input"]>
  debitAmount?: InputMaybe<Scalars["numeric"]["input"]>
  debitBalance?: InputMaybe<Scalars["numeric"]["input"]>
  deleteFl?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  dueDt?: InputMaybe<Scalars["date"]["input"]>
  dunningFl?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  maxCollectionAmount?: InputMaybe<Scalars["numeric"]["input"]>
  orderNo?: InputMaybe<Scalars["Int"]["input"]>
  partitionId?: InputMaybe<Scalars["bigint"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  rejectedByUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  rejectedDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  versionNo?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate sum on columns */
export type Junifer__AccountTransaction_Sum_Fields = {
  __typename?: "junifer__AccountTransaction_sum_fields"
  acceptedByUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  accountBalance?: Maybe<Scalars["numeric"]["output"]>
  accountFk?: Maybe<Scalars["bigint"]["output"]>
  accountTransactionTypeFk?: Maybe<Scalars["bigint"]["output"]>
  authorisedByUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  cancelAccountTransactionFk?: Maybe<Scalars["bigint"]["output"]>
  cancelledByUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  collectionCancelledByUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  createdUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  creditAmount?: Maybe<Scalars["numeric"]["output"]>
  creditBalance?: Maybe<Scalars["numeric"]["output"]>
  currencyFk?: Maybe<Scalars["bigint"]["output"]>
  debitAmount?: Maybe<Scalars["numeric"]["output"]>
  debitBalance?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  maxCollectionAmount?: Maybe<Scalars["numeric"]["output"]>
  orderNo?: Maybe<Scalars["Int"]["output"]>
  partitionId?: Maybe<Scalars["bigint"]["output"]>
  rejectedByUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  versionNo?: Maybe<Scalars["Int"]["output"]>
}

/** update columns of table "junifer__AccountTransaction" */
export enum Junifer__AccountTransaction_Update_Column {
  /** column name */
  AcceptedByUserTblFk = "acceptedByUserTblFk",
  /** column name */
  AcceptedDttm = "acceptedDttm",
  /** column name */
  AccountBalance = "accountBalance",
  /** column name */
  AccountFk = "accountFk",
  /** column name */
  AccountTransactionTypeFk = "accountTransactionTypeFk",
  /** column name */
  AuthorisedByUserTblFk = "authorisedByUserTblFk",
  /** column name */
  AuthorisedDttm = "authorisedDttm",
  /** column name */
  CancelAccountTransactionFk = "cancelAccountTransactionFk",
  /** column name */
  CancelledByUserTblFk = "cancelledByUserTblFk",
  /** column name */
  CancelledDttm = "cancelledDttm",
  /** column name */
  CollectionCancelledByUserTblFk = "collectionCancelledByUserTblFk",
  /** column name */
  CollectionCancelledDttm = "collectionCancelledDttm",
  /** column name */
  CollectionDt = "collectionDt",
  /** column name */
  CollectionRequestDt = "collectionRequestDt",
  /** column name */
  CollectionScheduledFl = "collectionScheduledFl",
  /** column name */
  CreatedDttm = "createdDttm",
  /** column name */
  CreatedUserTblFk = "createdUserTblFk",
  /** column name */
  CreditAmount = "creditAmount",
  /** column name */
  CreditBalance = "creditBalance",
  /** column name */
  CurrencyFk = "currencyFk",
  /** column name */
  DebitAmount = "debitAmount",
  /** column name */
  DebitBalance = "debitBalance",
  /** column name */
  DeleteFl = "deleteFl",
  /** column name */
  Description = "description",
  /** column name */
  DueDt = "dueDt",
  /** column name */
  DunningFl = "dunningFl",
  /** column name */
  Id = "id",
  /** column name */
  MaxCollectionAmount = "maxCollectionAmount",
  /** column name */
  OrderNo = "orderNo",
  /** column name */
  PartitionId = "partitionId",
  /** column name */
  Reference = "reference",
  /** column name */
  RejectedByUserTblFk = "rejectedByUserTblFk",
  /** column name */
  RejectedDttm = "rejectedDttm",
  /** column name */
  Status = "status",
  /** column name */
  VersionNo = "versionNo",
}

export type Junifer__AccountTransaction_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Junifer__AccountTransaction_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Junifer__AccountTransaction_Set_Input>
  /** filter the rows which have to be updated */
  where: Junifer__AccountTransaction_Bool_Exp
}

/** aggregate var_pop on columns */
export type Junifer__AccountTransaction_Var_Pop_Fields = {
  __typename?: "junifer__AccountTransaction_var_pop_fields"
  acceptedByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  accountBalance?: Maybe<Scalars["Float"]["output"]>
  accountFk?: Maybe<Scalars["Float"]["output"]>
  accountTransactionTypeFk?: Maybe<Scalars["Float"]["output"]>
  authorisedByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  cancelAccountTransactionFk?: Maybe<Scalars["Float"]["output"]>
  cancelledByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  collectionCancelledByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  createdUserTblFk?: Maybe<Scalars["Float"]["output"]>
  creditAmount?: Maybe<Scalars["Float"]["output"]>
  creditBalance?: Maybe<Scalars["Float"]["output"]>
  currencyFk?: Maybe<Scalars["Float"]["output"]>
  debitAmount?: Maybe<Scalars["Float"]["output"]>
  debitBalance?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  maxCollectionAmount?: Maybe<Scalars["Float"]["output"]>
  orderNo?: Maybe<Scalars["Float"]["output"]>
  partitionId?: Maybe<Scalars["Float"]["output"]>
  rejectedByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  versionNo?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Junifer__AccountTransaction_Var_Samp_Fields = {
  __typename?: "junifer__AccountTransaction_var_samp_fields"
  acceptedByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  accountBalance?: Maybe<Scalars["Float"]["output"]>
  accountFk?: Maybe<Scalars["Float"]["output"]>
  accountTransactionTypeFk?: Maybe<Scalars["Float"]["output"]>
  authorisedByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  cancelAccountTransactionFk?: Maybe<Scalars["Float"]["output"]>
  cancelledByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  collectionCancelledByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  createdUserTblFk?: Maybe<Scalars["Float"]["output"]>
  creditAmount?: Maybe<Scalars["Float"]["output"]>
  creditBalance?: Maybe<Scalars["Float"]["output"]>
  currencyFk?: Maybe<Scalars["Float"]["output"]>
  debitAmount?: Maybe<Scalars["Float"]["output"]>
  debitBalance?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  maxCollectionAmount?: Maybe<Scalars["Float"]["output"]>
  orderNo?: Maybe<Scalars["Float"]["output"]>
  partitionId?: Maybe<Scalars["Float"]["output"]>
  rejectedByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  versionNo?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Junifer__AccountTransaction_Variance_Fields = {
  __typename?: "junifer__AccountTransaction_variance_fields"
  acceptedByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  accountBalance?: Maybe<Scalars["Float"]["output"]>
  accountFk?: Maybe<Scalars["Float"]["output"]>
  accountTransactionTypeFk?: Maybe<Scalars["Float"]["output"]>
  authorisedByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  cancelAccountTransactionFk?: Maybe<Scalars["Float"]["output"]>
  cancelledByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  collectionCancelledByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  createdUserTblFk?: Maybe<Scalars["Float"]["output"]>
  creditAmount?: Maybe<Scalars["Float"]["output"]>
  creditBalance?: Maybe<Scalars["Float"]["output"]>
  currencyFk?: Maybe<Scalars["Float"]["output"]>
  debitAmount?: Maybe<Scalars["Float"]["output"]>
  debitBalance?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  maxCollectionAmount?: Maybe<Scalars["Float"]["output"]>
  orderNo?: Maybe<Scalars["Float"]["output"]>
  partitionId?: Maybe<Scalars["Float"]["output"]>
  rejectedByUserTblFk?: Maybe<Scalars["Float"]["output"]>
  versionNo?: Maybe<Scalars["Float"]["output"]>
}

/** aggregated selection of "junifer__Account" */
export type Junifer__Account_Aggregate = {
  __typename?: "junifer__Account_aggregate"
  aggregate?: Maybe<Junifer__Account_Aggregate_Fields>
  nodes: Array<Junifer__Account>
}

/** aggregate fields of "junifer__Account" */
export type Junifer__Account_Aggregate_Fields = {
  __typename?: "junifer__Account_aggregate_fields"
  avg?: Maybe<Junifer__Account_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Junifer__Account_Max_Fields>
  min?: Maybe<Junifer__Account_Min_Fields>
  stddev?: Maybe<Junifer__Account_Stddev_Fields>
  stddev_pop?: Maybe<Junifer__Account_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Junifer__Account_Stddev_Samp_Fields>
  sum?: Maybe<Junifer__Account_Sum_Fields>
  var_pop?: Maybe<Junifer__Account_Var_Pop_Fields>
  var_samp?: Maybe<Junifer__Account_Var_Samp_Fields>
  variance?: Maybe<Junifer__Account_Variance_Fields>
}

/** aggregate fields of "junifer__Account" */
export type Junifer__Account_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Junifer__Account_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Junifer__Account_Avg_Fields = {
  __typename?: "junifer__Account_avg_fields"
  accountTypeFk?: Maybe<Scalars["Float"]["output"]>
  billPackageFk?: Maybe<Scalars["Float"]["output"]>
  billingCycleFk?: Maybe<Scalars["Float"]["output"]>
  billingEntityFk?: Maybe<Scalars["Float"]["output"]>
  cancelledUserTblFk?: Maybe<Scalars["Float"]["output"]>
  createdUserTblFk?: Maybe<Scalars["Float"]["output"]>
  currencyFk?: Maybe<Scalars["Float"]["output"]>
  customerFk?: Maybe<Scalars["Float"]["output"]>
  dunningPackageFk?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  languageTblFk?: Maybe<Scalars["Float"]["output"]>
  lastAccountTransactionFk?: Maybe<Scalars["Float"]["output"]>
  parentAccountFk?: Maybe<Scalars["Float"]["output"]>
  partitionId?: Maybe<Scalars["Float"]["output"]>
  paymentTermFk?: Maybe<Scalars["Float"]["output"]>
  terminatedUserTblFk?: Maybe<Scalars["Float"]["output"]>
  txnAllocatorComponentFk?: Maybe<Scalars["Float"]["output"]>
  versionNo?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "junifer__Account". All fields are combined with a logical 'AND'. */
export type Junifer__Account_Bool_Exp = {
  _and?: InputMaybe<Array<Junifer__Account_Bool_Exp>>
  _not?: InputMaybe<Junifer__Account_Bool_Exp>
  _or?: InputMaybe<Array<Junifer__Account_Bool_Exp>>
  accountTypeFk?: InputMaybe<Bigint_Comparison_Exp>
  autoRebillBehaviour?: InputMaybe<String_Comparison_Exp>
  billPackageFk?: InputMaybe<Bigint_Comparison_Exp>
  billingAlignDttm?: InputMaybe<Timestamptz_Comparison_Exp>
  billingCycleFk?: InputMaybe<Bigint_Comparison_Exp>
  billingEntityFk?: InputMaybe<Bigint_Comparison_Exp>
  cancelFl?: InputMaybe<String_Comparison_Exp>
  cancelledDttm?: InputMaybe<Timestamptz_Comparison_Exp>
  cancelledUserTblFk?: InputMaybe<Bigint_Comparison_Exp>
  closedDttm?: InputMaybe<Timestamptz_Comparison_Exp>
  createdDttm?: InputMaybe<Timestamptz_Comparison_Exp>
  createdUserTblFk?: InputMaybe<Bigint_Comparison_Exp>
  currencyFk?: InputMaybe<Bigint_Comparison_Exp>
  customer?: InputMaybe<Junifer__Customer_Bool_Exp>
  customerFk?: InputMaybe<Bigint_Comparison_Exp>
  deleteFl?: InputMaybe<String_Comparison_Exp>
  dunningPackageFk?: InputMaybe<Bigint_Comparison_Exp>
  fromDttm?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  initialBillStatus?: InputMaybe<String_Comparison_Exp>
  languageTblFk?: InputMaybe<Bigint_Comparison_Exp>
  lastAccountTransactionFk?: InputMaybe<Bigint_Comparison_Exp>
  last_transaction?: InputMaybe<Junifer__AccountTransaction_Bool_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  number?: InputMaybe<String_Comparison_Exp>
  overrideAllocateCreditOnRebill?: InputMaybe<String_Comparison_Exp>
  parentAccountFk?: InputMaybe<Bigint_Comparison_Exp>
  parentOverridesChildFl?: InputMaybe<String_Comparison_Exp>
  parentReconciliationBillingFl?: InputMaybe<String_Comparison_Exp>
  partitionId?: InputMaybe<Bigint_Comparison_Exp>
  payPointLocation?: InputMaybe<String_Comparison_Exp>
  paymentDataErasedFl?: InputMaybe<String_Comparison_Exp>
  paymentTermFk?: InputMaybe<Bigint_Comparison_Exp>
  reference?: InputMaybe<String_Comparison_Exp>
  salesTaxExemptFl?: InputMaybe<String_Comparison_Exp>
  synchronized_account?: InputMaybe<Synchronized_Accounts_Bool_Exp>
  terminatedDttm?: InputMaybe<Timestamptz_Comparison_Exp>
  terminatedUserTblFk?: InputMaybe<Bigint_Comparison_Exp>
  toDttm?: InputMaybe<Timestamptz_Comparison_Exp>
  txnAllocatorComponentFk?: InputMaybe<Bigint_Comparison_Exp>
  versionNo?: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "junifer__Account" */
export enum Junifer__Account_Constraint {
  /** unique or primary key constraint on columns "id" */
  JuniferAccountPkey = "junifer__Account_pkey",
}

/** input type for incrementing numeric columns in table "junifer__Account" */
export type Junifer__Account_Inc_Input = {
  accountTypeFk?: InputMaybe<Scalars["bigint"]["input"]>
  billPackageFk?: InputMaybe<Scalars["bigint"]["input"]>
  billingCycleFk?: InputMaybe<Scalars["bigint"]["input"]>
  billingEntityFk?: InputMaybe<Scalars["bigint"]["input"]>
  cancelledUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  createdUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  currencyFk?: InputMaybe<Scalars["bigint"]["input"]>
  customerFk?: InputMaybe<Scalars["bigint"]["input"]>
  dunningPackageFk?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  languageTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  lastAccountTransactionFk?: InputMaybe<Scalars["bigint"]["input"]>
  parentAccountFk?: InputMaybe<Scalars["bigint"]["input"]>
  partitionId?: InputMaybe<Scalars["bigint"]["input"]>
  paymentTermFk?: InputMaybe<Scalars["bigint"]["input"]>
  terminatedUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  txnAllocatorComponentFk?: InputMaybe<Scalars["bigint"]["input"]>
  versionNo?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "junifer__Account" */
export type Junifer__Account_Insert_Input = {
  accountTypeFk?: InputMaybe<Scalars["bigint"]["input"]>
  autoRebillBehaviour?: InputMaybe<Scalars["String"]["input"]>
  billPackageFk?: InputMaybe<Scalars["bigint"]["input"]>
  billingAlignDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  billingCycleFk?: InputMaybe<Scalars["bigint"]["input"]>
  billingEntityFk?: InputMaybe<Scalars["bigint"]["input"]>
  cancelFl?: InputMaybe<Scalars["String"]["input"]>
  cancelledDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  cancelledUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  closedDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  createdDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  createdUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  currencyFk?: InputMaybe<Scalars["bigint"]["input"]>
  customer?: InputMaybe<Junifer__Customer_Obj_Rel_Insert_Input>
  customerFk?: InputMaybe<Scalars["bigint"]["input"]>
  deleteFl?: InputMaybe<Scalars["String"]["input"]>
  dunningPackageFk?: InputMaybe<Scalars["bigint"]["input"]>
  fromDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  initialBillStatus?: InputMaybe<Scalars["String"]["input"]>
  languageTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  lastAccountTransactionFk?: InputMaybe<Scalars["bigint"]["input"]>
  last_transaction?: InputMaybe<Junifer__AccountTransaction_Obj_Rel_Insert_Input>
  name?: InputMaybe<Scalars["String"]["input"]>
  number?: InputMaybe<Scalars["String"]["input"]>
  overrideAllocateCreditOnRebill?: InputMaybe<Scalars["String"]["input"]>
  parentAccountFk?: InputMaybe<Scalars["bigint"]["input"]>
  parentOverridesChildFl?: InputMaybe<Scalars["String"]["input"]>
  parentReconciliationBillingFl?: InputMaybe<Scalars["String"]["input"]>
  partitionId?: InputMaybe<Scalars["bigint"]["input"]>
  payPointLocation?: InputMaybe<Scalars["String"]["input"]>
  paymentDataErasedFl?: InputMaybe<Scalars["String"]["input"]>
  paymentTermFk?: InputMaybe<Scalars["bigint"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  salesTaxExemptFl?: InputMaybe<Scalars["String"]["input"]>
  synchronized_account?: InputMaybe<Synchronized_Accounts_Obj_Rel_Insert_Input>
  terminatedDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  terminatedUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  toDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  txnAllocatorComponentFk?: InputMaybe<Scalars["bigint"]["input"]>
  versionNo?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate max on columns */
export type Junifer__Account_Max_Fields = {
  __typename?: "junifer__Account_max_fields"
  accountTypeFk?: Maybe<Scalars["bigint"]["output"]>
  autoRebillBehaviour?: Maybe<Scalars["String"]["output"]>
  billPackageFk?: Maybe<Scalars["bigint"]["output"]>
  billingAlignDttm?: Maybe<Scalars["timestamptz"]["output"]>
  billingCycleFk?: Maybe<Scalars["bigint"]["output"]>
  billingEntityFk?: Maybe<Scalars["bigint"]["output"]>
  cancelFl?: Maybe<Scalars["String"]["output"]>
  cancelledDttm?: Maybe<Scalars["timestamptz"]["output"]>
  cancelledUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  closedDttm?: Maybe<Scalars["timestamptz"]["output"]>
  createdDttm?: Maybe<Scalars["timestamptz"]["output"]>
  createdUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  currencyFk?: Maybe<Scalars["bigint"]["output"]>
  customerFk?: Maybe<Scalars["bigint"]["output"]>
  deleteFl?: Maybe<Scalars["String"]["output"]>
  dunningPackageFk?: Maybe<Scalars["bigint"]["output"]>
  fromDttm?: Maybe<Scalars["timestamptz"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  initialBillStatus?: Maybe<Scalars["String"]["output"]>
  languageTblFk?: Maybe<Scalars["bigint"]["output"]>
  lastAccountTransactionFk?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  number?: Maybe<Scalars["String"]["output"]>
  overrideAllocateCreditOnRebill?: Maybe<Scalars["String"]["output"]>
  parentAccountFk?: Maybe<Scalars["bigint"]["output"]>
  parentOverridesChildFl?: Maybe<Scalars["String"]["output"]>
  parentReconciliationBillingFl?: Maybe<Scalars["String"]["output"]>
  partitionId?: Maybe<Scalars["bigint"]["output"]>
  payPointLocation?: Maybe<Scalars["String"]["output"]>
  paymentDataErasedFl?: Maybe<Scalars["String"]["output"]>
  paymentTermFk?: Maybe<Scalars["bigint"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  salesTaxExemptFl?: Maybe<Scalars["String"]["output"]>
  terminatedDttm?: Maybe<Scalars["timestamptz"]["output"]>
  terminatedUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  toDttm?: Maybe<Scalars["timestamptz"]["output"]>
  txnAllocatorComponentFk?: Maybe<Scalars["bigint"]["output"]>
  versionNo?: Maybe<Scalars["Int"]["output"]>
}

/** aggregate min on columns */
export type Junifer__Account_Min_Fields = {
  __typename?: "junifer__Account_min_fields"
  accountTypeFk?: Maybe<Scalars["bigint"]["output"]>
  autoRebillBehaviour?: Maybe<Scalars["String"]["output"]>
  billPackageFk?: Maybe<Scalars["bigint"]["output"]>
  billingAlignDttm?: Maybe<Scalars["timestamptz"]["output"]>
  billingCycleFk?: Maybe<Scalars["bigint"]["output"]>
  billingEntityFk?: Maybe<Scalars["bigint"]["output"]>
  cancelFl?: Maybe<Scalars["String"]["output"]>
  cancelledDttm?: Maybe<Scalars["timestamptz"]["output"]>
  cancelledUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  closedDttm?: Maybe<Scalars["timestamptz"]["output"]>
  createdDttm?: Maybe<Scalars["timestamptz"]["output"]>
  createdUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  currencyFk?: Maybe<Scalars["bigint"]["output"]>
  customerFk?: Maybe<Scalars["bigint"]["output"]>
  deleteFl?: Maybe<Scalars["String"]["output"]>
  dunningPackageFk?: Maybe<Scalars["bigint"]["output"]>
  fromDttm?: Maybe<Scalars["timestamptz"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  initialBillStatus?: Maybe<Scalars["String"]["output"]>
  languageTblFk?: Maybe<Scalars["bigint"]["output"]>
  lastAccountTransactionFk?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  number?: Maybe<Scalars["String"]["output"]>
  overrideAllocateCreditOnRebill?: Maybe<Scalars["String"]["output"]>
  parentAccountFk?: Maybe<Scalars["bigint"]["output"]>
  parentOverridesChildFl?: Maybe<Scalars["String"]["output"]>
  parentReconciliationBillingFl?: Maybe<Scalars["String"]["output"]>
  partitionId?: Maybe<Scalars["bigint"]["output"]>
  payPointLocation?: Maybe<Scalars["String"]["output"]>
  paymentDataErasedFl?: Maybe<Scalars["String"]["output"]>
  paymentTermFk?: Maybe<Scalars["bigint"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  salesTaxExemptFl?: Maybe<Scalars["String"]["output"]>
  terminatedDttm?: Maybe<Scalars["timestamptz"]["output"]>
  terminatedUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  toDttm?: Maybe<Scalars["timestamptz"]["output"]>
  txnAllocatorComponentFk?: Maybe<Scalars["bigint"]["output"]>
  versionNo?: Maybe<Scalars["Int"]["output"]>
}

/** response of any mutation on the table "junifer__Account" */
export type Junifer__Account_Mutation_Response = {
  __typename?: "junifer__Account_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Junifer__Account>
}

/** on_conflict condition type for table "junifer__Account" */
export type Junifer__Account_On_Conflict = {
  constraint: Junifer__Account_Constraint
  update_columns?: Array<Junifer__Account_Update_Column>
  where?: InputMaybe<Junifer__Account_Bool_Exp>
}

/** Ordering options when selecting data from "junifer__Account". */
export type Junifer__Account_Order_By = {
  accountTypeFk?: InputMaybe<Order_By>
  autoRebillBehaviour?: InputMaybe<Order_By>
  billPackageFk?: InputMaybe<Order_By>
  billingAlignDttm?: InputMaybe<Order_By>
  billingCycleFk?: InputMaybe<Order_By>
  billingEntityFk?: InputMaybe<Order_By>
  cancelFl?: InputMaybe<Order_By>
  cancelledDttm?: InputMaybe<Order_By>
  cancelledUserTblFk?: InputMaybe<Order_By>
  closedDttm?: InputMaybe<Order_By>
  createdDttm?: InputMaybe<Order_By>
  createdUserTblFk?: InputMaybe<Order_By>
  currencyFk?: InputMaybe<Order_By>
  customer?: InputMaybe<Junifer__Customer_Order_By>
  customerFk?: InputMaybe<Order_By>
  deleteFl?: InputMaybe<Order_By>
  dunningPackageFk?: InputMaybe<Order_By>
  fromDttm?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  initialBillStatus?: InputMaybe<Order_By>
  languageTblFk?: InputMaybe<Order_By>
  lastAccountTransactionFk?: InputMaybe<Order_By>
  last_transaction?: InputMaybe<Junifer__AccountTransaction_Order_By>
  name?: InputMaybe<Order_By>
  number?: InputMaybe<Order_By>
  overrideAllocateCreditOnRebill?: InputMaybe<Order_By>
  parentAccountFk?: InputMaybe<Order_By>
  parentOverridesChildFl?: InputMaybe<Order_By>
  parentReconciliationBillingFl?: InputMaybe<Order_By>
  partitionId?: InputMaybe<Order_By>
  payPointLocation?: InputMaybe<Order_By>
  paymentDataErasedFl?: InputMaybe<Order_By>
  paymentTermFk?: InputMaybe<Order_By>
  reference?: InputMaybe<Order_By>
  salesTaxExemptFl?: InputMaybe<Order_By>
  synchronized_account?: InputMaybe<Synchronized_Accounts_Order_By>
  terminatedDttm?: InputMaybe<Order_By>
  terminatedUserTblFk?: InputMaybe<Order_By>
  toDttm?: InputMaybe<Order_By>
  txnAllocatorComponentFk?: InputMaybe<Order_By>
  versionNo?: InputMaybe<Order_By>
}

/** primary key columns input for table: junifer__Account */
export type Junifer__Account_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "junifer__Account" */
export enum Junifer__Account_Select_Column {
  /** column name */
  AccountTypeFk = "accountTypeFk",
  /** column name */
  AutoRebillBehaviour = "autoRebillBehaviour",
  /** column name */
  BillPackageFk = "billPackageFk",
  /** column name */
  BillingAlignDttm = "billingAlignDttm",
  /** column name */
  BillingCycleFk = "billingCycleFk",
  /** column name */
  BillingEntityFk = "billingEntityFk",
  /** column name */
  CancelFl = "cancelFl",
  /** column name */
  CancelledDttm = "cancelledDttm",
  /** column name */
  CancelledUserTblFk = "cancelledUserTblFk",
  /** column name */
  ClosedDttm = "closedDttm",
  /** column name */
  CreatedDttm = "createdDttm",
  /** column name */
  CreatedUserTblFk = "createdUserTblFk",
  /** column name */
  CurrencyFk = "currencyFk",
  /** column name */
  CustomerFk = "customerFk",
  /** column name */
  DeleteFl = "deleteFl",
  /** column name */
  DunningPackageFk = "dunningPackageFk",
  /** column name */
  FromDttm = "fromDttm",
  /** column name */
  Id = "id",
  /** column name */
  InitialBillStatus = "initialBillStatus",
  /** column name */
  LanguageTblFk = "languageTblFk",
  /** column name */
  LastAccountTransactionFk = "lastAccountTransactionFk",
  /** column name */
  Name = "name",
  /** column name */
  Number = "number",
  /** column name */
  OverrideAllocateCreditOnRebill = "overrideAllocateCreditOnRebill",
  /** column name */
  ParentAccountFk = "parentAccountFk",
  /** column name */
  ParentOverridesChildFl = "parentOverridesChildFl",
  /** column name */
  ParentReconciliationBillingFl = "parentReconciliationBillingFl",
  /** column name */
  PartitionId = "partitionId",
  /** column name */
  PayPointLocation = "payPointLocation",
  /** column name */
  PaymentDataErasedFl = "paymentDataErasedFl",
  /** column name */
  PaymentTermFk = "paymentTermFk",
  /** column name */
  Reference = "reference",
  /** column name */
  SalesTaxExemptFl = "salesTaxExemptFl",
  /** column name */
  TerminatedDttm = "terminatedDttm",
  /** column name */
  TerminatedUserTblFk = "terminatedUserTblFk",
  /** column name */
  ToDttm = "toDttm",
  /** column name */
  TxnAllocatorComponentFk = "txnAllocatorComponentFk",
  /** column name */
  VersionNo = "versionNo",
}

/** input type for updating data in table "junifer__Account" */
export type Junifer__Account_Set_Input = {
  accountTypeFk?: InputMaybe<Scalars["bigint"]["input"]>
  autoRebillBehaviour?: InputMaybe<Scalars["String"]["input"]>
  billPackageFk?: InputMaybe<Scalars["bigint"]["input"]>
  billingAlignDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  billingCycleFk?: InputMaybe<Scalars["bigint"]["input"]>
  billingEntityFk?: InputMaybe<Scalars["bigint"]["input"]>
  cancelFl?: InputMaybe<Scalars["String"]["input"]>
  cancelledDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  cancelledUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  closedDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  createdDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  createdUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  currencyFk?: InputMaybe<Scalars["bigint"]["input"]>
  customerFk?: InputMaybe<Scalars["bigint"]["input"]>
  deleteFl?: InputMaybe<Scalars["String"]["input"]>
  dunningPackageFk?: InputMaybe<Scalars["bigint"]["input"]>
  fromDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  initialBillStatus?: InputMaybe<Scalars["String"]["input"]>
  languageTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  lastAccountTransactionFk?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  number?: InputMaybe<Scalars["String"]["input"]>
  overrideAllocateCreditOnRebill?: InputMaybe<Scalars["String"]["input"]>
  parentAccountFk?: InputMaybe<Scalars["bigint"]["input"]>
  parentOverridesChildFl?: InputMaybe<Scalars["String"]["input"]>
  parentReconciliationBillingFl?: InputMaybe<Scalars["String"]["input"]>
  partitionId?: InputMaybe<Scalars["bigint"]["input"]>
  payPointLocation?: InputMaybe<Scalars["String"]["input"]>
  paymentDataErasedFl?: InputMaybe<Scalars["String"]["input"]>
  paymentTermFk?: InputMaybe<Scalars["bigint"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  salesTaxExemptFl?: InputMaybe<Scalars["String"]["input"]>
  terminatedDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  terminatedUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  toDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  txnAllocatorComponentFk?: InputMaybe<Scalars["bigint"]["input"]>
  versionNo?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate stddev on columns */
export type Junifer__Account_Stddev_Fields = {
  __typename?: "junifer__Account_stddev_fields"
  accountTypeFk?: Maybe<Scalars["Float"]["output"]>
  billPackageFk?: Maybe<Scalars["Float"]["output"]>
  billingCycleFk?: Maybe<Scalars["Float"]["output"]>
  billingEntityFk?: Maybe<Scalars["Float"]["output"]>
  cancelledUserTblFk?: Maybe<Scalars["Float"]["output"]>
  createdUserTblFk?: Maybe<Scalars["Float"]["output"]>
  currencyFk?: Maybe<Scalars["Float"]["output"]>
  customerFk?: Maybe<Scalars["Float"]["output"]>
  dunningPackageFk?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  languageTblFk?: Maybe<Scalars["Float"]["output"]>
  lastAccountTransactionFk?: Maybe<Scalars["Float"]["output"]>
  parentAccountFk?: Maybe<Scalars["Float"]["output"]>
  partitionId?: Maybe<Scalars["Float"]["output"]>
  paymentTermFk?: Maybe<Scalars["Float"]["output"]>
  terminatedUserTblFk?: Maybe<Scalars["Float"]["output"]>
  txnAllocatorComponentFk?: Maybe<Scalars["Float"]["output"]>
  versionNo?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Junifer__Account_Stddev_Pop_Fields = {
  __typename?: "junifer__Account_stddev_pop_fields"
  accountTypeFk?: Maybe<Scalars["Float"]["output"]>
  billPackageFk?: Maybe<Scalars["Float"]["output"]>
  billingCycleFk?: Maybe<Scalars["Float"]["output"]>
  billingEntityFk?: Maybe<Scalars["Float"]["output"]>
  cancelledUserTblFk?: Maybe<Scalars["Float"]["output"]>
  createdUserTblFk?: Maybe<Scalars["Float"]["output"]>
  currencyFk?: Maybe<Scalars["Float"]["output"]>
  customerFk?: Maybe<Scalars["Float"]["output"]>
  dunningPackageFk?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  languageTblFk?: Maybe<Scalars["Float"]["output"]>
  lastAccountTransactionFk?: Maybe<Scalars["Float"]["output"]>
  parentAccountFk?: Maybe<Scalars["Float"]["output"]>
  partitionId?: Maybe<Scalars["Float"]["output"]>
  paymentTermFk?: Maybe<Scalars["Float"]["output"]>
  terminatedUserTblFk?: Maybe<Scalars["Float"]["output"]>
  txnAllocatorComponentFk?: Maybe<Scalars["Float"]["output"]>
  versionNo?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Junifer__Account_Stddev_Samp_Fields = {
  __typename?: "junifer__Account_stddev_samp_fields"
  accountTypeFk?: Maybe<Scalars["Float"]["output"]>
  billPackageFk?: Maybe<Scalars["Float"]["output"]>
  billingCycleFk?: Maybe<Scalars["Float"]["output"]>
  billingEntityFk?: Maybe<Scalars["Float"]["output"]>
  cancelledUserTblFk?: Maybe<Scalars["Float"]["output"]>
  createdUserTblFk?: Maybe<Scalars["Float"]["output"]>
  currencyFk?: Maybe<Scalars["Float"]["output"]>
  customerFk?: Maybe<Scalars["Float"]["output"]>
  dunningPackageFk?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  languageTblFk?: Maybe<Scalars["Float"]["output"]>
  lastAccountTransactionFk?: Maybe<Scalars["Float"]["output"]>
  parentAccountFk?: Maybe<Scalars["Float"]["output"]>
  partitionId?: Maybe<Scalars["Float"]["output"]>
  paymentTermFk?: Maybe<Scalars["Float"]["output"]>
  terminatedUserTblFk?: Maybe<Scalars["Float"]["output"]>
  txnAllocatorComponentFk?: Maybe<Scalars["Float"]["output"]>
  versionNo?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "junifer__Account" */
export type Junifer__Account_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Junifer__Account_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Junifer__Account_Stream_Cursor_Value_Input = {
  accountTypeFk?: InputMaybe<Scalars["bigint"]["input"]>
  autoRebillBehaviour?: InputMaybe<Scalars["String"]["input"]>
  billPackageFk?: InputMaybe<Scalars["bigint"]["input"]>
  billingAlignDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  billingCycleFk?: InputMaybe<Scalars["bigint"]["input"]>
  billingEntityFk?: InputMaybe<Scalars["bigint"]["input"]>
  cancelFl?: InputMaybe<Scalars["String"]["input"]>
  cancelledDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  cancelledUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  closedDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  createdDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  createdUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  currencyFk?: InputMaybe<Scalars["bigint"]["input"]>
  customerFk?: InputMaybe<Scalars["bigint"]["input"]>
  deleteFl?: InputMaybe<Scalars["String"]["input"]>
  dunningPackageFk?: InputMaybe<Scalars["bigint"]["input"]>
  fromDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  initialBillStatus?: InputMaybe<Scalars["String"]["input"]>
  languageTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  lastAccountTransactionFk?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  number?: InputMaybe<Scalars["String"]["input"]>
  overrideAllocateCreditOnRebill?: InputMaybe<Scalars["String"]["input"]>
  parentAccountFk?: InputMaybe<Scalars["bigint"]["input"]>
  parentOverridesChildFl?: InputMaybe<Scalars["String"]["input"]>
  parentReconciliationBillingFl?: InputMaybe<Scalars["String"]["input"]>
  partitionId?: InputMaybe<Scalars["bigint"]["input"]>
  payPointLocation?: InputMaybe<Scalars["String"]["input"]>
  paymentDataErasedFl?: InputMaybe<Scalars["String"]["input"]>
  paymentTermFk?: InputMaybe<Scalars["bigint"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  salesTaxExemptFl?: InputMaybe<Scalars["String"]["input"]>
  terminatedDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  terminatedUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  toDttm?: InputMaybe<Scalars["timestamptz"]["input"]>
  txnAllocatorComponentFk?: InputMaybe<Scalars["bigint"]["input"]>
  versionNo?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate sum on columns */
export type Junifer__Account_Sum_Fields = {
  __typename?: "junifer__Account_sum_fields"
  accountTypeFk?: Maybe<Scalars["bigint"]["output"]>
  billPackageFk?: Maybe<Scalars["bigint"]["output"]>
  billingCycleFk?: Maybe<Scalars["bigint"]["output"]>
  billingEntityFk?: Maybe<Scalars["bigint"]["output"]>
  cancelledUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  createdUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  currencyFk?: Maybe<Scalars["bigint"]["output"]>
  customerFk?: Maybe<Scalars["bigint"]["output"]>
  dunningPackageFk?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  languageTblFk?: Maybe<Scalars["bigint"]["output"]>
  lastAccountTransactionFk?: Maybe<Scalars["bigint"]["output"]>
  parentAccountFk?: Maybe<Scalars["bigint"]["output"]>
  partitionId?: Maybe<Scalars["bigint"]["output"]>
  paymentTermFk?: Maybe<Scalars["bigint"]["output"]>
  terminatedUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  txnAllocatorComponentFk?: Maybe<Scalars["bigint"]["output"]>
  versionNo?: Maybe<Scalars["Int"]["output"]>
}

/** update columns of table "junifer__Account" */
export enum Junifer__Account_Update_Column {
  /** column name */
  AccountTypeFk = "accountTypeFk",
  /** column name */
  AutoRebillBehaviour = "autoRebillBehaviour",
  /** column name */
  BillPackageFk = "billPackageFk",
  /** column name */
  BillingAlignDttm = "billingAlignDttm",
  /** column name */
  BillingCycleFk = "billingCycleFk",
  /** column name */
  BillingEntityFk = "billingEntityFk",
  /** column name */
  CancelFl = "cancelFl",
  /** column name */
  CancelledDttm = "cancelledDttm",
  /** column name */
  CancelledUserTblFk = "cancelledUserTblFk",
  /** column name */
  ClosedDttm = "closedDttm",
  /** column name */
  CreatedDttm = "createdDttm",
  /** column name */
  CreatedUserTblFk = "createdUserTblFk",
  /** column name */
  CurrencyFk = "currencyFk",
  /** column name */
  CustomerFk = "customerFk",
  /** column name */
  DeleteFl = "deleteFl",
  /** column name */
  DunningPackageFk = "dunningPackageFk",
  /** column name */
  FromDttm = "fromDttm",
  /** column name */
  Id = "id",
  /** column name */
  InitialBillStatus = "initialBillStatus",
  /** column name */
  LanguageTblFk = "languageTblFk",
  /** column name */
  LastAccountTransactionFk = "lastAccountTransactionFk",
  /** column name */
  Name = "name",
  /** column name */
  Number = "number",
  /** column name */
  OverrideAllocateCreditOnRebill = "overrideAllocateCreditOnRebill",
  /** column name */
  ParentAccountFk = "parentAccountFk",
  /** column name */
  ParentOverridesChildFl = "parentOverridesChildFl",
  /** column name */
  ParentReconciliationBillingFl = "parentReconciliationBillingFl",
  /** column name */
  PartitionId = "partitionId",
  /** column name */
  PayPointLocation = "payPointLocation",
  /** column name */
  PaymentDataErasedFl = "paymentDataErasedFl",
  /** column name */
  PaymentTermFk = "paymentTermFk",
  /** column name */
  Reference = "reference",
  /** column name */
  SalesTaxExemptFl = "salesTaxExemptFl",
  /** column name */
  TerminatedDttm = "terminatedDttm",
  /** column name */
  TerminatedUserTblFk = "terminatedUserTblFk",
  /** column name */
  ToDttm = "toDttm",
  /** column name */
  TxnAllocatorComponentFk = "txnAllocatorComponentFk",
  /** column name */
  VersionNo = "versionNo",
}

export type Junifer__Account_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Junifer__Account_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Junifer__Account_Set_Input>
  /** filter the rows which have to be updated */
  where: Junifer__Account_Bool_Exp
}

/** aggregate var_pop on columns */
export type Junifer__Account_Var_Pop_Fields = {
  __typename?: "junifer__Account_var_pop_fields"
  accountTypeFk?: Maybe<Scalars["Float"]["output"]>
  billPackageFk?: Maybe<Scalars["Float"]["output"]>
  billingCycleFk?: Maybe<Scalars["Float"]["output"]>
  billingEntityFk?: Maybe<Scalars["Float"]["output"]>
  cancelledUserTblFk?: Maybe<Scalars["Float"]["output"]>
  createdUserTblFk?: Maybe<Scalars["Float"]["output"]>
  currencyFk?: Maybe<Scalars["Float"]["output"]>
  customerFk?: Maybe<Scalars["Float"]["output"]>
  dunningPackageFk?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  languageTblFk?: Maybe<Scalars["Float"]["output"]>
  lastAccountTransactionFk?: Maybe<Scalars["Float"]["output"]>
  parentAccountFk?: Maybe<Scalars["Float"]["output"]>
  partitionId?: Maybe<Scalars["Float"]["output"]>
  paymentTermFk?: Maybe<Scalars["Float"]["output"]>
  terminatedUserTblFk?: Maybe<Scalars["Float"]["output"]>
  txnAllocatorComponentFk?: Maybe<Scalars["Float"]["output"]>
  versionNo?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Junifer__Account_Var_Samp_Fields = {
  __typename?: "junifer__Account_var_samp_fields"
  accountTypeFk?: Maybe<Scalars["Float"]["output"]>
  billPackageFk?: Maybe<Scalars["Float"]["output"]>
  billingCycleFk?: Maybe<Scalars["Float"]["output"]>
  billingEntityFk?: Maybe<Scalars["Float"]["output"]>
  cancelledUserTblFk?: Maybe<Scalars["Float"]["output"]>
  createdUserTblFk?: Maybe<Scalars["Float"]["output"]>
  currencyFk?: Maybe<Scalars["Float"]["output"]>
  customerFk?: Maybe<Scalars["Float"]["output"]>
  dunningPackageFk?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  languageTblFk?: Maybe<Scalars["Float"]["output"]>
  lastAccountTransactionFk?: Maybe<Scalars["Float"]["output"]>
  parentAccountFk?: Maybe<Scalars["Float"]["output"]>
  partitionId?: Maybe<Scalars["Float"]["output"]>
  paymentTermFk?: Maybe<Scalars["Float"]["output"]>
  terminatedUserTblFk?: Maybe<Scalars["Float"]["output"]>
  txnAllocatorComponentFk?: Maybe<Scalars["Float"]["output"]>
  versionNo?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Junifer__Account_Variance_Fields = {
  __typename?: "junifer__Account_variance_fields"
  accountTypeFk?: Maybe<Scalars["Float"]["output"]>
  billPackageFk?: Maybe<Scalars["Float"]["output"]>
  billingCycleFk?: Maybe<Scalars["Float"]["output"]>
  billingEntityFk?: Maybe<Scalars["Float"]["output"]>
  cancelledUserTblFk?: Maybe<Scalars["Float"]["output"]>
  createdUserTblFk?: Maybe<Scalars["Float"]["output"]>
  currencyFk?: Maybe<Scalars["Float"]["output"]>
  customerFk?: Maybe<Scalars["Float"]["output"]>
  dunningPackageFk?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  languageTblFk?: Maybe<Scalars["Float"]["output"]>
  lastAccountTransactionFk?: Maybe<Scalars["Float"]["output"]>
  parentAccountFk?: Maybe<Scalars["Float"]["output"]>
  partitionId?: Maybe<Scalars["Float"]["output"]>
  paymentTermFk?: Maybe<Scalars["Float"]["output"]>
  terminatedUserTblFk?: Maybe<Scalars["Float"]["output"]>
  txnAllocatorComponentFk?: Maybe<Scalars["Float"]["output"]>
  versionNo?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "junifer__Customer" */
export type Junifer__Customer = {
  __typename?: "junifer__Customer"
  billingEntityFk?: Maybe<Scalars["bigint"]["output"]>
  companyName?: Maybe<Scalars["String"]["output"]>
  companyNo?: Maybe<Scalars["String"]["output"]>
  companyRegAddressFk?: Maybe<Scalars["bigint"]["output"]>
  creditScore?: Maybe<Scalars["Int"]["output"]>
  customerClassFk?: Maybe<Scalars["bigint"]["output"]>
  customerTypeFk?: Maybe<Scalars["bigint"]["output"]>
  dataErasedFl?: Maybe<Scalars["String"]["output"]>
  deceasedFl?: Maybe<Scalars["String"]["output"]>
  deleteFl?: Maybe<Scalars["String"]["output"]>
  forename?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  managerUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  marketingOptOutFl?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  number?: Maybe<Scalars["String"]["output"]>
  partitionId?: Maybe<Scalars["bigint"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  state?: Maybe<Scalars["String"]["output"]>
  surname?: Maybe<Scalars["String"]["output"]>
  taxExemptReasonFk?: Maybe<Scalars["bigint"]["output"]>
  titleFk?: Maybe<Scalars["bigint"]["output"]>
  txnAllocatorComponentFk?: Maybe<Scalars["bigint"]["output"]>
  versionNo?: Maybe<Scalars["Int"]["output"]>
}

/** aggregated selection of "junifer__Customer" */
export type Junifer__Customer_Aggregate = {
  __typename?: "junifer__Customer_aggregate"
  aggregate?: Maybe<Junifer__Customer_Aggregate_Fields>
  nodes: Array<Junifer__Customer>
}

/** aggregate fields of "junifer__Customer" */
export type Junifer__Customer_Aggregate_Fields = {
  __typename?: "junifer__Customer_aggregate_fields"
  avg?: Maybe<Junifer__Customer_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Junifer__Customer_Max_Fields>
  min?: Maybe<Junifer__Customer_Min_Fields>
  stddev?: Maybe<Junifer__Customer_Stddev_Fields>
  stddev_pop?: Maybe<Junifer__Customer_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Junifer__Customer_Stddev_Samp_Fields>
  sum?: Maybe<Junifer__Customer_Sum_Fields>
  var_pop?: Maybe<Junifer__Customer_Var_Pop_Fields>
  var_samp?: Maybe<Junifer__Customer_Var_Samp_Fields>
  variance?: Maybe<Junifer__Customer_Variance_Fields>
}

/** aggregate fields of "junifer__Customer" */
export type Junifer__Customer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Junifer__Customer_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Junifer__Customer_Avg_Fields = {
  __typename?: "junifer__Customer_avg_fields"
  billingEntityFk?: Maybe<Scalars["Float"]["output"]>
  companyRegAddressFk?: Maybe<Scalars["Float"]["output"]>
  creditScore?: Maybe<Scalars["Float"]["output"]>
  customerClassFk?: Maybe<Scalars["Float"]["output"]>
  customerTypeFk?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  managerUserTblFk?: Maybe<Scalars["Float"]["output"]>
  partitionId?: Maybe<Scalars["Float"]["output"]>
  taxExemptReasonFk?: Maybe<Scalars["Float"]["output"]>
  titleFk?: Maybe<Scalars["Float"]["output"]>
  txnAllocatorComponentFk?: Maybe<Scalars["Float"]["output"]>
  versionNo?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "junifer__Customer". All fields are combined with a logical 'AND'. */
export type Junifer__Customer_Bool_Exp = {
  _and?: InputMaybe<Array<Junifer__Customer_Bool_Exp>>
  _not?: InputMaybe<Junifer__Customer_Bool_Exp>
  _or?: InputMaybe<Array<Junifer__Customer_Bool_Exp>>
  billingEntityFk?: InputMaybe<Bigint_Comparison_Exp>
  companyName?: InputMaybe<String_Comparison_Exp>
  companyNo?: InputMaybe<String_Comparison_Exp>
  companyRegAddressFk?: InputMaybe<Bigint_Comparison_Exp>
  creditScore?: InputMaybe<Int_Comparison_Exp>
  customerClassFk?: InputMaybe<Bigint_Comparison_Exp>
  customerTypeFk?: InputMaybe<Bigint_Comparison_Exp>
  dataErasedFl?: InputMaybe<String_Comparison_Exp>
  deceasedFl?: InputMaybe<String_Comparison_Exp>
  deleteFl?: InputMaybe<String_Comparison_Exp>
  forename?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  managerUserTblFk?: InputMaybe<Bigint_Comparison_Exp>
  marketingOptOutFl?: InputMaybe<String_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  number?: InputMaybe<String_Comparison_Exp>
  partitionId?: InputMaybe<Bigint_Comparison_Exp>
  reference?: InputMaybe<String_Comparison_Exp>
  state?: InputMaybe<String_Comparison_Exp>
  surname?: InputMaybe<String_Comparison_Exp>
  taxExemptReasonFk?: InputMaybe<Bigint_Comparison_Exp>
  titleFk?: InputMaybe<Bigint_Comparison_Exp>
  txnAllocatorComponentFk?: InputMaybe<Bigint_Comparison_Exp>
  versionNo?: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "junifer__Customer" */
export enum Junifer__Customer_Constraint {
  /** unique or primary key constraint on columns "id" */
  JuniferCustomerPkey = "junifer__Customer_pkey",
}

/** input type for incrementing numeric columns in table "junifer__Customer" */
export type Junifer__Customer_Inc_Input = {
  billingEntityFk?: InputMaybe<Scalars["bigint"]["input"]>
  companyRegAddressFk?: InputMaybe<Scalars["bigint"]["input"]>
  creditScore?: InputMaybe<Scalars["Int"]["input"]>
  customerClassFk?: InputMaybe<Scalars["bigint"]["input"]>
  customerTypeFk?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  managerUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  partitionId?: InputMaybe<Scalars["bigint"]["input"]>
  taxExemptReasonFk?: InputMaybe<Scalars["bigint"]["input"]>
  titleFk?: InputMaybe<Scalars["bigint"]["input"]>
  txnAllocatorComponentFk?: InputMaybe<Scalars["bigint"]["input"]>
  versionNo?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "junifer__Customer" */
export type Junifer__Customer_Insert_Input = {
  billingEntityFk?: InputMaybe<Scalars["bigint"]["input"]>
  companyName?: InputMaybe<Scalars["String"]["input"]>
  companyNo?: InputMaybe<Scalars["String"]["input"]>
  companyRegAddressFk?: InputMaybe<Scalars["bigint"]["input"]>
  creditScore?: InputMaybe<Scalars["Int"]["input"]>
  customerClassFk?: InputMaybe<Scalars["bigint"]["input"]>
  customerTypeFk?: InputMaybe<Scalars["bigint"]["input"]>
  dataErasedFl?: InputMaybe<Scalars["String"]["input"]>
  deceasedFl?: InputMaybe<Scalars["String"]["input"]>
  deleteFl?: InputMaybe<Scalars["String"]["input"]>
  forename?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  managerUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  marketingOptOutFl?: InputMaybe<Scalars["String"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  number?: InputMaybe<Scalars["String"]["input"]>
  partitionId?: InputMaybe<Scalars["bigint"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  state?: InputMaybe<Scalars["String"]["input"]>
  surname?: InputMaybe<Scalars["String"]["input"]>
  taxExemptReasonFk?: InputMaybe<Scalars["bigint"]["input"]>
  titleFk?: InputMaybe<Scalars["bigint"]["input"]>
  txnAllocatorComponentFk?: InputMaybe<Scalars["bigint"]["input"]>
  versionNo?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate max on columns */
export type Junifer__Customer_Max_Fields = {
  __typename?: "junifer__Customer_max_fields"
  billingEntityFk?: Maybe<Scalars["bigint"]["output"]>
  companyName?: Maybe<Scalars["String"]["output"]>
  companyNo?: Maybe<Scalars["String"]["output"]>
  companyRegAddressFk?: Maybe<Scalars["bigint"]["output"]>
  creditScore?: Maybe<Scalars["Int"]["output"]>
  customerClassFk?: Maybe<Scalars["bigint"]["output"]>
  customerTypeFk?: Maybe<Scalars["bigint"]["output"]>
  dataErasedFl?: Maybe<Scalars["String"]["output"]>
  deceasedFl?: Maybe<Scalars["String"]["output"]>
  deleteFl?: Maybe<Scalars["String"]["output"]>
  forename?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  managerUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  marketingOptOutFl?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  number?: Maybe<Scalars["String"]["output"]>
  partitionId?: Maybe<Scalars["bigint"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  state?: Maybe<Scalars["String"]["output"]>
  surname?: Maybe<Scalars["String"]["output"]>
  taxExemptReasonFk?: Maybe<Scalars["bigint"]["output"]>
  titleFk?: Maybe<Scalars["bigint"]["output"]>
  txnAllocatorComponentFk?: Maybe<Scalars["bigint"]["output"]>
  versionNo?: Maybe<Scalars["Int"]["output"]>
}

/** aggregate min on columns */
export type Junifer__Customer_Min_Fields = {
  __typename?: "junifer__Customer_min_fields"
  billingEntityFk?: Maybe<Scalars["bigint"]["output"]>
  companyName?: Maybe<Scalars["String"]["output"]>
  companyNo?: Maybe<Scalars["String"]["output"]>
  companyRegAddressFk?: Maybe<Scalars["bigint"]["output"]>
  creditScore?: Maybe<Scalars["Int"]["output"]>
  customerClassFk?: Maybe<Scalars["bigint"]["output"]>
  customerTypeFk?: Maybe<Scalars["bigint"]["output"]>
  dataErasedFl?: Maybe<Scalars["String"]["output"]>
  deceasedFl?: Maybe<Scalars["String"]["output"]>
  deleteFl?: Maybe<Scalars["String"]["output"]>
  forename?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  managerUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  marketingOptOutFl?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  number?: Maybe<Scalars["String"]["output"]>
  partitionId?: Maybe<Scalars["bigint"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  state?: Maybe<Scalars["String"]["output"]>
  surname?: Maybe<Scalars["String"]["output"]>
  taxExemptReasonFk?: Maybe<Scalars["bigint"]["output"]>
  titleFk?: Maybe<Scalars["bigint"]["output"]>
  txnAllocatorComponentFk?: Maybe<Scalars["bigint"]["output"]>
  versionNo?: Maybe<Scalars["Int"]["output"]>
}

/** response of any mutation on the table "junifer__Customer" */
export type Junifer__Customer_Mutation_Response = {
  __typename?: "junifer__Customer_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Junifer__Customer>
}

/** input type for inserting object relation for remote table "junifer__Customer" */
export type Junifer__Customer_Obj_Rel_Insert_Input = {
  data: Junifer__Customer_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Junifer__Customer_On_Conflict>
}

/** on_conflict condition type for table "junifer__Customer" */
export type Junifer__Customer_On_Conflict = {
  constraint: Junifer__Customer_Constraint
  update_columns?: Array<Junifer__Customer_Update_Column>
  where?: InputMaybe<Junifer__Customer_Bool_Exp>
}

/** Ordering options when selecting data from "junifer__Customer". */
export type Junifer__Customer_Order_By = {
  billingEntityFk?: InputMaybe<Order_By>
  companyName?: InputMaybe<Order_By>
  companyNo?: InputMaybe<Order_By>
  companyRegAddressFk?: InputMaybe<Order_By>
  creditScore?: InputMaybe<Order_By>
  customerClassFk?: InputMaybe<Order_By>
  customerTypeFk?: InputMaybe<Order_By>
  dataErasedFl?: InputMaybe<Order_By>
  deceasedFl?: InputMaybe<Order_By>
  deleteFl?: InputMaybe<Order_By>
  forename?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  managerUserTblFk?: InputMaybe<Order_By>
  marketingOptOutFl?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  number?: InputMaybe<Order_By>
  partitionId?: InputMaybe<Order_By>
  reference?: InputMaybe<Order_By>
  state?: InputMaybe<Order_By>
  surname?: InputMaybe<Order_By>
  taxExemptReasonFk?: InputMaybe<Order_By>
  titleFk?: InputMaybe<Order_By>
  txnAllocatorComponentFk?: InputMaybe<Order_By>
  versionNo?: InputMaybe<Order_By>
}

/** primary key columns input for table: junifer__Customer */
export type Junifer__Customer_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "junifer__Customer" */
export enum Junifer__Customer_Select_Column {
  /** column name */
  BillingEntityFk = "billingEntityFk",
  /** column name */
  CompanyName = "companyName",
  /** column name */
  CompanyNo = "companyNo",
  /** column name */
  CompanyRegAddressFk = "companyRegAddressFk",
  /** column name */
  CreditScore = "creditScore",
  /** column name */
  CustomerClassFk = "customerClassFk",
  /** column name */
  CustomerTypeFk = "customerTypeFk",
  /** column name */
  DataErasedFl = "dataErasedFl",
  /** column name */
  DeceasedFl = "deceasedFl",
  /** column name */
  DeleteFl = "deleteFl",
  /** column name */
  Forename = "forename",
  /** column name */
  Id = "id",
  /** column name */
  ManagerUserTblFk = "managerUserTblFk",
  /** column name */
  MarketingOptOutFl = "marketingOptOutFl",
  /** column name */
  Name = "name",
  /** column name */
  Number = "number",
  /** column name */
  PartitionId = "partitionId",
  /** column name */
  Reference = "reference",
  /** column name */
  State = "state",
  /** column name */
  Surname = "surname",
  /** column name */
  TaxExemptReasonFk = "taxExemptReasonFk",
  /** column name */
  TitleFk = "titleFk",
  /** column name */
  TxnAllocatorComponentFk = "txnAllocatorComponentFk",
  /** column name */
  VersionNo = "versionNo",
}

/** input type for updating data in table "junifer__Customer" */
export type Junifer__Customer_Set_Input = {
  billingEntityFk?: InputMaybe<Scalars["bigint"]["input"]>
  companyName?: InputMaybe<Scalars["String"]["input"]>
  companyNo?: InputMaybe<Scalars["String"]["input"]>
  companyRegAddressFk?: InputMaybe<Scalars["bigint"]["input"]>
  creditScore?: InputMaybe<Scalars["Int"]["input"]>
  customerClassFk?: InputMaybe<Scalars["bigint"]["input"]>
  customerTypeFk?: InputMaybe<Scalars["bigint"]["input"]>
  dataErasedFl?: InputMaybe<Scalars["String"]["input"]>
  deceasedFl?: InputMaybe<Scalars["String"]["input"]>
  deleteFl?: InputMaybe<Scalars["String"]["input"]>
  forename?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  managerUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  marketingOptOutFl?: InputMaybe<Scalars["String"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  number?: InputMaybe<Scalars["String"]["input"]>
  partitionId?: InputMaybe<Scalars["bigint"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  state?: InputMaybe<Scalars["String"]["input"]>
  surname?: InputMaybe<Scalars["String"]["input"]>
  taxExemptReasonFk?: InputMaybe<Scalars["bigint"]["input"]>
  titleFk?: InputMaybe<Scalars["bigint"]["input"]>
  txnAllocatorComponentFk?: InputMaybe<Scalars["bigint"]["input"]>
  versionNo?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate stddev on columns */
export type Junifer__Customer_Stddev_Fields = {
  __typename?: "junifer__Customer_stddev_fields"
  billingEntityFk?: Maybe<Scalars["Float"]["output"]>
  companyRegAddressFk?: Maybe<Scalars["Float"]["output"]>
  creditScore?: Maybe<Scalars["Float"]["output"]>
  customerClassFk?: Maybe<Scalars["Float"]["output"]>
  customerTypeFk?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  managerUserTblFk?: Maybe<Scalars["Float"]["output"]>
  partitionId?: Maybe<Scalars["Float"]["output"]>
  taxExemptReasonFk?: Maybe<Scalars["Float"]["output"]>
  titleFk?: Maybe<Scalars["Float"]["output"]>
  txnAllocatorComponentFk?: Maybe<Scalars["Float"]["output"]>
  versionNo?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Junifer__Customer_Stddev_Pop_Fields = {
  __typename?: "junifer__Customer_stddev_pop_fields"
  billingEntityFk?: Maybe<Scalars["Float"]["output"]>
  companyRegAddressFk?: Maybe<Scalars["Float"]["output"]>
  creditScore?: Maybe<Scalars["Float"]["output"]>
  customerClassFk?: Maybe<Scalars["Float"]["output"]>
  customerTypeFk?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  managerUserTblFk?: Maybe<Scalars["Float"]["output"]>
  partitionId?: Maybe<Scalars["Float"]["output"]>
  taxExemptReasonFk?: Maybe<Scalars["Float"]["output"]>
  titleFk?: Maybe<Scalars["Float"]["output"]>
  txnAllocatorComponentFk?: Maybe<Scalars["Float"]["output"]>
  versionNo?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Junifer__Customer_Stddev_Samp_Fields = {
  __typename?: "junifer__Customer_stddev_samp_fields"
  billingEntityFk?: Maybe<Scalars["Float"]["output"]>
  companyRegAddressFk?: Maybe<Scalars["Float"]["output"]>
  creditScore?: Maybe<Scalars["Float"]["output"]>
  customerClassFk?: Maybe<Scalars["Float"]["output"]>
  customerTypeFk?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  managerUserTblFk?: Maybe<Scalars["Float"]["output"]>
  partitionId?: Maybe<Scalars["Float"]["output"]>
  taxExemptReasonFk?: Maybe<Scalars["Float"]["output"]>
  titleFk?: Maybe<Scalars["Float"]["output"]>
  txnAllocatorComponentFk?: Maybe<Scalars["Float"]["output"]>
  versionNo?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "junifer__Customer" */
export type Junifer__Customer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Junifer__Customer_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Junifer__Customer_Stream_Cursor_Value_Input = {
  billingEntityFk?: InputMaybe<Scalars["bigint"]["input"]>
  companyName?: InputMaybe<Scalars["String"]["input"]>
  companyNo?: InputMaybe<Scalars["String"]["input"]>
  companyRegAddressFk?: InputMaybe<Scalars["bigint"]["input"]>
  creditScore?: InputMaybe<Scalars["Int"]["input"]>
  customerClassFk?: InputMaybe<Scalars["bigint"]["input"]>
  customerTypeFk?: InputMaybe<Scalars["bigint"]["input"]>
  dataErasedFl?: InputMaybe<Scalars["String"]["input"]>
  deceasedFl?: InputMaybe<Scalars["String"]["input"]>
  deleteFl?: InputMaybe<Scalars["String"]["input"]>
  forename?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  managerUserTblFk?: InputMaybe<Scalars["bigint"]["input"]>
  marketingOptOutFl?: InputMaybe<Scalars["String"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  number?: InputMaybe<Scalars["String"]["input"]>
  partitionId?: InputMaybe<Scalars["bigint"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  state?: InputMaybe<Scalars["String"]["input"]>
  surname?: InputMaybe<Scalars["String"]["input"]>
  taxExemptReasonFk?: InputMaybe<Scalars["bigint"]["input"]>
  titleFk?: InputMaybe<Scalars["bigint"]["input"]>
  txnAllocatorComponentFk?: InputMaybe<Scalars["bigint"]["input"]>
  versionNo?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate sum on columns */
export type Junifer__Customer_Sum_Fields = {
  __typename?: "junifer__Customer_sum_fields"
  billingEntityFk?: Maybe<Scalars["bigint"]["output"]>
  companyRegAddressFk?: Maybe<Scalars["bigint"]["output"]>
  creditScore?: Maybe<Scalars["Int"]["output"]>
  customerClassFk?: Maybe<Scalars["bigint"]["output"]>
  customerTypeFk?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  managerUserTblFk?: Maybe<Scalars["bigint"]["output"]>
  partitionId?: Maybe<Scalars["bigint"]["output"]>
  taxExemptReasonFk?: Maybe<Scalars["bigint"]["output"]>
  titleFk?: Maybe<Scalars["bigint"]["output"]>
  txnAllocatorComponentFk?: Maybe<Scalars["bigint"]["output"]>
  versionNo?: Maybe<Scalars["Int"]["output"]>
}

/** update columns of table "junifer__Customer" */
export enum Junifer__Customer_Update_Column {
  /** column name */
  BillingEntityFk = "billingEntityFk",
  /** column name */
  CompanyName = "companyName",
  /** column name */
  CompanyNo = "companyNo",
  /** column name */
  CompanyRegAddressFk = "companyRegAddressFk",
  /** column name */
  CreditScore = "creditScore",
  /** column name */
  CustomerClassFk = "customerClassFk",
  /** column name */
  CustomerTypeFk = "customerTypeFk",
  /** column name */
  DataErasedFl = "dataErasedFl",
  /** column name */
  DeceasedFl = "deceasedFl",
  /** column name */
  DeleteFl = "deleteFl",
  /** column name */
  Forename = "forename",
  /** column name */
  Id = "id",
  /** column name */
  ManagerUserTblFk = "managerUserTblFk",
  /** column name */
  MarketingOptOutFl = "marketingOptOutFl",
  /** column name */
  Name = "name",
  /** column name */
  Number = "number",
  /** column name */
  PartitionId = "partitionId",
  /** column name */
  Reference = "reference",
  /** column name */
  State = "state",
  /** column name */
  Surname = "surname",
  /** column name */
  TaxExemptReasonFk = "taxExemptReasonFk",
  /** column name */
  TitleFk = "titleFk",
  /** column name */
  TxnAllocatorComponentFk = "txnAllocatorComponentFk",
  /** column name */
  VersionNo = "versionNo",
}

export type Junifer__Customer_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Junifer__Customer_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Junifer__Customer_Set_Input>
  /** filter the rows which have to be updated */
  where: Junifer__Customer_Bool_Exp
}

/** aggregate var_pop on columns */
export type Junifer__Customer_Var_Pop_Fields = {
  __typename?: "junifer__Customer_var_pop_fields"
  billingEntityFk?: Maybe<Scalars["Float"]["output"]>
  companyRegAddressFk?: Maybe<Scalars["Float"]["output"]>
  creditScore?: Maybe<Scalars["Float"]["output"]>
  customerClassFk?: Maybe<Scalars["Float"]["output"]>
  customerTypeFk?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  managerUserTblFk?: Maybe<Scalars["Float"]["output"]>
  partitionId?: Maybe<Scalars["Float"]["output"]>
  taxExemptReasonFk?: Maybe<Scalars["Float"]["output"]>
  titleFk?: Maybe<Scalars["Float"]["output"]>
  txnAllocatorComponentFk?: Maybe<Scalars["Float"]["output"]>
  versionNo?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Junifer__Customer_Var_Samp_Fields = {
  __typename?: "junifer__Customer_var_samp_fields"
  billingEntityFk?: Maybe<Scalars["Float"]["output"]>
  companyRegAddressFk?: Maybe<Scalars["Float"]["output"]>
  creditScore?: Maybe<Scalars["Float"]["output"]>
  customerClassFk?: Maybe<Scalars["Float"]["output"]>
  customerTypeFk?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  managerUserTblFk?: Maybe<Scalars["Float"]["output"]>
  partitionId?: Maybe<Scalars["Float"]["output"]>
  taxExemptReasonFk?: Maybe<Scalars["Float"]["output"]>
  titleFk?: Maybe<Scalars["Float"]["output"]>
  txnAllocatorComponentFk?: Maybe<Scalars["Float"]["output"]>
  versionNo?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Junifer__Customer_Variance_Fields = {
  __typename?: "junifer__Customer_variance_fields"
  billingEntityFk?: Maybe<Scalars["Float"]["output"]>
  companyRegAddressFk?: Maybe<Scalars["Float"]["output"]>
  creditScore?: Maybe<Scalars["Float"]["output"]>
  customerClassFk?: Maybe<Scalars["Float"]["output"]>
  customerTypeFk?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  managerUserTblFk?: Maybe<Scalars["Float"]["output"]>
  partitionId?: Maybe<Scalars["Float"]["output"]>
  taxExemptReasonFk?: Maybe<Scalars["Float"]["output"]>
  titleFk?: Maybe<Scalars["Float"]["output"]>
  txnAllocatorComponentFk?: Maybe<Scalars["Float"]["output"]>
  versionNo?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "junifer_payment_status". All fields are combined with logical 'AND'. */
export type Junifer_Payment_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["junifer_payment_status"]["input"]>
  _gt?: InputMaybe<Scalars["junifer_payment_status"]["input"]>
  _gte?: InputMaybe<Scalars["junifer_payment_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["junifer_payment_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["junifer_payment_status"]["input"]>
  _lte?: InputMaybe<Scalars["junifer_payment_status"]["input"]>
  _neq?: InputMaybe<Scalars["junifer_payment_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["junifer_payment_status"]["input"]>>
}

/** columns and relationships of "last_errored_submissions" */
export type Last_Errored_Submissions = {
  __typename?: "last_errored_submissions"
  account_number?: Maybe<Scalars["String"]["output"]>
  comment?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  debug_data?: Maybe<Scalars["json"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  failed_attempts?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_attempt?: Maybe<Scalars["timestamp"]["output"]>
  meter_point_identifier?: Maybe<Scalars["String"]["output"]>
  meterpoint_id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["meter_reading_submission_request_status"]["output"]>
  submission_data?: Maybe<Scalars["json"]["output"]>
  submission_values?: Maybe<Scalars["json"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  user_email?: Maybe<Scalars["String"]["output"]>
}

/** columns and relationships of "last_errored_submissions" */
export type Last_Errored_SubmissionsDebug_DataArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** columns and relationships of "last_errored_submissions" */
export type Last_Errored_SubmissionsSubmission_DataArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** columns and relationships of "last_errored_submissions" */
export type Last_Errored_SubmissionsSubmission_ValuesArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregated selection of "last_errored_submissions" */
export type Last_Errored_Submissions_Aggregate = {
  __typename?: "last_errored_submissions_aggregate"
  aggregate?: Maybe<Last_Errored_Submissions_Aggregate_Fields>
  nodes: Array<Last_Errored_Submissions>
}

/** aggregate fields of "last_errored_submissions" */
export type Last_Errored_Submissions_Aggregate_Fields = {
  __typename?: "last_errored_submissions_aggregate_fields"
  avg?: Maybe<Last_Errored_Submissions_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Last_Errored_Submissions_Max_Fields>
  min?: Maybe<Last_Errored_Submissions_Min_Fields>
  stddev?: Maybe<Last_Errored_Submissions_Stddev_Fields>
  stddev_pop?: Maybe<Last_Errored_Submissions_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Last_Errored_Submissions_Stddev_Samp_Fields>
  sum?: Maybe<Last_Errored_Submissions_Sum_Fields>
  var_pop?: Maybe<Last_Errored_Submissions_Var_Pop_Fields>
  var_samp?: Maybe<Last_Errored_Submissions_Var_Samp_Fields>
  variance?: Maybe<Last_Errored_Submissions_Variance_Fields>
}

/** aggregate fields of "last_errored_submissions" */
export type Last_Errored_Submissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Last_Errored_Submissions_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Last_Errored_Submissions_Avg_Fields = {
  __typename?: "last_errored_submissions_avg_fields"
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meterpoint_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "last_errored_submissions". All fields are combined with a logical 'AND'. */
export type Last_Errored_Submissions_Bool_Exp = {
  _and?: InputMaybe<Array<Last_Errored_Submissions_Bool_Exp>>
  _not?: InputMaybe<Last_Errored_Submissions_Bool_Exp>
  _or?: InputMaybe<Array<Last_Errored_Submissions_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  comment?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  debug_data?: InputMaybe<Json_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  failed_attempts?: InputMaybe<Int_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  last_attempt?: InputMaybe<Timestamp_Comparison_Exp>
  meter_point_identifier?: InputMaybe<String_Comparison_Exp>
  meterpoint_id?: InputMaybe<Bigint_Comparison_Exp>
  status?: InputMaybe<Meter_Reading_Submission_Request_Status_Comparison_Exp>
  submission_data?: InputMaybe<Json_Comparison_Exp>
  submission_values?: InputMaybe<Json_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  user_email?: InputMaybe<String_Comparison_Exp>
}

/** aggregate max on columns */
export type Last_Errored_Submissions_Max_Fields = {
  __typename?: "last_errored_submissions_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  comment?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  failed_attempts?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_attempt?: Maybe<Scalars["timestamp"]["output"]>
  meter_point_identifier?: Maybe<Scalars["String"]["output"]>
  meterpoint_id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["meter_reading_submission_request_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  user_email?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Last_Errored_Submissions_Min_Fields = {
  __typename?: "last_errored_submissions_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  comment?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  failed_attempts?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_attempt?: Maybe<Scalars["timestamp"]["output"]>
  meter_point_identifier?: Maybe<Scalars["String"]["output"]>
  meterpoint_id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["meter_reading_submission_request_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  user_email?: Maybe<Scalars["String"]["output"]>
}

/** Ordering options when selecting data from "last_errored_submissions". */
export type Last_Errored_Submissions_Order_By = {
  account_number?: InputMaybe<Order_By>
  comment?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  debug_data?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  failed_attempts?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  last_attempt?: InputMaybe<Order_By>
  meter_point_identifier?: InputMaybe<Order_By>
  meterpoint_id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  submission_data?: InputMaybe<Order_By>
  submission_values?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_email?: InputMaybe<Order_By>
}

/** select columns of table "last_errored_submissions" */
export enum Last_Errored_Submissions_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  Comment = "comment",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DebugData = "debug_data",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FailedAttempts = "failed_attempts",
  /** column name */
  Id = "id",
  /** column name */
  LastAttempt = "last_attempt",
  /** column name */
  MeterPointIdentifier = "meter_point_identifier",
  /** column name */
  MeterpointId = "meterpoint_id",
  /** column name */
  Status = "status",
  /** column name */
  SubmissionData = "submission_data",
  /** column name */
  SubmissionValues = "submission_values",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  UserEmail = "user_email",
}

/** aggregate stddev on columns */
export type Last_Errored_Submissions_Stddev_Fields = {
  __typename?: "last_errored_submissions_stddev_fields"
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meterpoint_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Last_Errored_Submissions_Stddev_Pop_Fields = {
  __typename?: "last_errored_submissions_stddev_pop_fields"
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meterpoint_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Last_Errored_Submissions_Stddev_Samp_Fields = {
  __typename?: "last_errored_submissions_stddev_samp_fields"
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meterpoint_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "last_errored_submissions" */
export type Last_Errored_Submissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Last_Errored_Submissions_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Last_Errored_Submissions_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  comment?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  debug_data?: InputMaybe<Scalars["json"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  failed_attempts?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_attempt?: InputMaybe<Scalars["timestamp"]["input"]>
  meter_point_identifier?: InputMaybe<Scalars["String"]["input"]>
  meterpoint_id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<
    Scalars["meter_reading_submission_request_status"]["input"]
  >
  submission_data?: InputMaybe<Scalars["json"]["input"]>
  submission_values?: InputMaybe<Scalars["json"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  user_email?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Last_Errored_Submissions_Sum_Fields = {
  __typename?: "last_errored_submissions_sum_fields"
  failed_attempts?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meterpoint_id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregate var_pop on columns */
export type Last_Errored_Submissions_Var_Pop_Fields = {
  __typename?: "last_errored_submissions_var_pop_fields"
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meterpoint_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Last_Errored_Submissions_Var_Samp_Fields = {
  __typename?: "last_errored_submissions_var_samp_fields"
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meterpoint_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Last_Errored_Submissions_Variance_Fields = {
  __typename?: "last_errored_submissions_variance_fields"
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meterpoint_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "leaving_type". All fields are combined with logical 'AND'. */
export type Leaving_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["leaving_type"]["input"]>
  _gt?: InputMaybe<Scalars["leaving_type"]["input"]>
  _gte?: InputMaybe<Scalars["leaving_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["leaving_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["leaving_type"]["input"]>
  _lte?: InputMaybe<Scalars["leaving_type"]["input"]>
  _neq?: InputMaybe<Scalars["leaving_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["leaving_type"]["input"]>>
}

/** Boolean expression to compare columns of type "match_level". All fields are combined with logical 'AND'. */
export type Match_Level_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["match_level"]["input"]>
  _gt?: InputMaybe<Scalars["match_level"]["input"]>
  _gte?: InputMaybe<Scalars["match_level"]["input"]>
  _in?: InputMaybe<Array<Scalars["match_level"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["match_level"]["input"]>
  _lte?: InputMaybe<Scalars["match_level"]["input"]>
  _neq?: InputMaybe<Scalars["match_level"]["input"]>
  _nin?: InputMaybe<Array<Scalars["match_level"]["input"]>>
}

/** columns and relationships of "meter" */
export type Meter = {
  __typename?: "meter"
  /** An object relationship */
  asset: Asset
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  identifier: Scalars["String"]["output"]
  /** An object relationship */
  install_codes?: Maybe<Install_Codes>
  /** An array relationship */
  meter_meter_point_rels: Array<Meter_Meter_Point_Rel>
  /** An aggregate relationship */
  meter_meter_point_rels_aggregate: Meter_Meter_Point_Rel_Aggregate
  /** An array relationship */
  registers: Array<Register>
  /** An aggregate relationship */
  registers_aggregate: Register_Aggregate
  type: Scalars["meter_type"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "meter" */
export type MeterMeter_Meter_Point_RelsArgs = {
  distinct_on?: InputMaybe<Array<Meter_Meter_Point_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Meter_Point_Rel_Order_By>>
  where?: InputMaybe<Meter_Meter_Point_Rel_Bool_Exp>
}

/** columns and relationships of "meter" */
export type MeterMeter_Meter_Point_Rels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Meter_Point_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Meter_Point_Rel_Order_By>>
  where?: InputMaybe<Meter_Meter_Point_Rel_Bool_Exp>
}

/** columns and relationships of "meter" */
export type MeterRegistersArgs = {
  distinct_on?: InputMaybe<Array<Register_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Register_Order_By>>
  where?: InputMaybe<Register_Bool_Exp>
}

/** columns and relationships of "meter" */
export type MeterRegisters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Register_Order_By>>
  where?: InputMaybe<Register_Bool_Exp>
}

/** aggregated selection of "meter" */
export type Meter_Aggregate = {
  __typename?: "meter_aggregate"
  aggregate?: Maybe<Meter_Aggregate_Fields>
  nodes: Array<Meter>
}

/** aggregate fields of "meter" */
export type Meter_Aggregate_Fields = {
  __typename?: "meter_aggregate_fields"
  avg?: Maybe<Meter_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Meter_Max_Fields>
  min?: Maybe<Meter_Min_Fields>
  stddev?: Maybe<Meter_Stddev_Fields>
  stddev_pop?: Maybe<Meter_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Meter_Stddev_Samp_Fields>
  sum?: Maybe<Meter_Sum_Fields>
  var_pop?: Maybe<Meter_Var_Pop_Fields>
  var_samp?: Maybe<Meter_Var_Samp_Fields>
  variance?: Maybe<Meter_Variance_Fields>
}

/** aggregate fields of "meter" */
export type Meter_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Meter_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Meter_Avg_Fields = {
  __typename?: "meter_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "meter". All fields are combined with a logical 'AND'. */
export type Meter_Bool_Exp = {
  _and?: InputMaybe<Array<Meter_Bool_Exp>>
  _not?: InputMaybe<Meter_Bool_Exp>
  _or?: InputMaybe<Array<Meter_Bool_Exp>>
  asset?: InputMaybe<Asset_Bool_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  description?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  identifier?: InputMaybe<String_Comparison_Exp>
  install_codes?: InputMaybe<Install_Codes_Bool_Exp>
  meter_meter_point_rels?: InputMaybe<Meter_Meter_Point_Rel_Bool_Exp>
  meter_meter_point_rels_aggregate?: InputMaybe<Meter_Meter_Point_Rel_Aggregate_Bool_Exp>
  registers?: InputMaybe<Register_Bool_Exp>
  registers_aggregate?: InputMaybe<Register_Aggregate_Bool_Exp>
  type?: InputMaybe<Meter_Type_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "meter" */
export enum Meter_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkMeter = "pk_meter",
}

/** input type for incrementing numeric columns in table "meter" */
export type Meter_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "meter" */
export type Meter_Insert_Input = {
  asset?: InputMaybe<Asset_Obj_Rel_Insert_Input>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  identifier?: InputMaybe<Scalars["String"]["input"]>
  install_codes?: InputMaybe<Install_Codes_Obj_Rel_Insert_Input>
  meter_meter_point_rels?: InputMaybe<Meter_Meter_Point_Rel_Arr_Rel_Insert_Input>
  registers?: InputMaybe<Register_Arr_Rel_Insert_Input>
  type?: InputMaybe<Scalars["meter_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Meter_Max_Fields = {
  __typename?: "meter_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  identifier?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["meter_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** columns and relationships of "meter_meter_point_rel" */
export type Meter_Meter_Point_Rel = {
  __typename?: "meter_meter_point_rel"
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_dt: Scalars["timestamp"]["output"]
  id: Scalars["bigint"]["output"]
  /** An object relationship */
  meter: Meter
  meter_id: Scalars["bigint"]["output"]
  /** An object relationship */
  meter_point: Meter_Point
  meter_point_id: Scalars["bigint"]["output"]
  register_id?: Maybe<Scalars["bigint"]["output"]>
  to_dt?: Maybe<Scalars["timestamp"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "meter_meter_point_rel" */
export type Meter_Meter_Point_Rel_Aggregate = {
  __typename?: "meter_meter_point_rel_aggregate"
  aggregate?: Maybe<Meter_Meter_Point_Rel_Aggregate_Fields>
  nodes: Array<Meter_Meter_Point_Rel>
}

export type Meter_Meter_Point_Rel_Aggregate_Bool_Exp = {
  count?: InputMaybe<Meter_Meter_Point_Rel_Aggregate_Bool_Exp_Count>
}

export type Meter_Meter_Point_Rel_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Meter_Meter_Point_Rel_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Meter_Meter_Point_Rel_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "meter_meter_point_rel" */
export type Meter_Meter_Point_Rel_Aggregate_Fields = {
  __typename?: "meter_meter_point_rel_aggregate_fields"
  avg?: Maybe<Meter_Meter_Point_Rel_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Meter_Meter_Point_Rel_Max_Fields>
  min?: Maybe<Meter_Meter_Point_Rel_Min_Fields>
  stddev?: Maybe<Meter_Meter_Point_Rel_Stddev_Fields>
  stddev_pop?: Maybe<Meter_Meter_Point_Rel_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Meter_Meter_Point_Rel_Stddev_Samp_Fields>
  sum?: Maybe<Meter_Meter_Point_Rel_Sum_Fields>
  var_pop?: Maybe<Meter_Meter_Point_Rel_Var_Pop_Fields>
  var_samp?: Maybe<Meter_Meter_Point_Rel_Var_Samp_Fields>
  variance?: Maybe<Meter_Meter_Point_Rel_Variance_Fields>
}

/** aggregate fields of "meter_meter_point_rel" */
export type Meter_Meter_Point_Rel_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Meter_Meter_Point_Rel_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "meter_meter_point_rel" */
export type Meter_Meter_Point_Rel_Aggregate_Order_By = {
  avg?: InputMaybe<Meter_Meter_Point_Rel_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Meter_Meter_Point_Rel_Max_Order_By>
  min?: InputMaybe<Meter_Meter_Point_Rel_Min_Order_By>
  stddev?: InputMaybe<Meter_Meter_Point_Rel_Stddev_Order_By>
  stddev_pop?: InputMaybe<Meter_Meter_Point_Rel_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Meter_Meter_Point_Rel_Stddev_Samp_Order_By>
  sum?: InputMaybe<Meter_Meter_Point_Rel_Sum_Order_By>
  var_pop?: InputMaybe<Meter_Meter_Point_Rel_Var_Pop_Order_By>
  var_samp?: InputMaybe<Meter_Meter_Point_Rel_Var_Samp_Order_By>
  variance?: InputMaybe<Meter_Meter_Point_Rel_Variance_Order_By>
}

/** input type for inserting array relation for remote table "meter_meter_point_rel" */
export type Meter_Meter_Point_Rel_Arr_Rel_Insert_Input = {
  data: Array<Meter_Meter_Point_Rel_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Meter_Meter_Point_Rel_On_Conflict>
}

/** aggregate avg on columns */
export type Meter_Meter_Point_Rel_Avg_Fields = {
  __typename?: "meter_meter_point_rel_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  meter_id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
  register_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "meter_meter_point_rel" */
export type Meter_Meter_Point_Rel_Avg_Order_By = {
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  register_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "meter_meter_point_rel". All fields are combined with a logical 'AND'. */
export type Meter_Meter_Point_Rel_Bool_Exp = {
  _and?: InputMaybe<Array<Meter_Meter_Point_Rel_Bool_Exp>>
  _not?: InputMaybe<Meter_Meter_Point_Rel_Bool_Exp>
  _or?: InputMaybe<Array<Meter_Meter_Point_Rel_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  from_dt?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  meter?: InputMaybe<Meter_Bool_Exp>
  meter_id?: InputMaybe<Bigint_Comparison_Exp>
  meter_point?: InputMaybe<Meter_Point_Bool_Exp>
  meter_point_id?: InputMaybe<Bigint_Comparison_Exp>
  register_id?: InputMaybe<Bigint_Comparison_Exp>
  to_dt?: InputMaybe<Timestamp_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "meter_meter_point_rel" */
export enum Meter_Meter_Point_Rel_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkMeterMeterPointRel = "pk_meter_meter_point_rel",
}

/** input type for incrementing numeric columns in table "meter_meter_point_rel" */
export type Meter_Meter_Point_Rel_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  register_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "meter_meter_point_rel" */
export type Meter_Meter_Point_Rel_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter?: InputMaybe<Meter_Obj_Rel_Insert_Input>
  meter_id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point?: InputMaybe<Meter_Point_Obj_Rel_Insert_Input>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  register_id?: InputMaybe<Scalars["bigint"]["input"]>
  to_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Meter_Meter_Point_Rel_Max_Fields = {
  __typename?: "meter_meter_point_rel_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_dt?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["bigint"]["output"]>
  register_id?: Maybe<Scalars["bigint"]["output"]>
  to_dt?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "meter_meter_point_rel" */
export type Meter_Meter_Point_Rel_Max_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  from_dt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  register_id?: InputMaybe<Order_By>
  to_dt?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Meter_Meter_Point_Rel_Min_Fields = {
  __typename?: "meter_meter_point_rel_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_dt?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["bigint"]["output"]>
  register_id?: Maybe<Scalars["bigint"]["output"]>
  to_dt?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "meter_meter_point_rel" */
export type Meter_Meter_Point_Rel_Min_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  from_dt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  register_id?: InputMaybe<Order_By>
  to_dt?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "meter_meter_point_rel" */
export type Meter_Meter_Point_Rel_Mutation_Response = {
  __typename?: "meter_meter_point_rel_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Meter_Meter_Point_Rel>
}

/** on_conflict condition type for table "meter_meter_point_rel" */
export type Meter_Meter_Point_Rel_On_Conflict = {
  constraint: Meter_Meter_Point_Rel_Constraint
  update_columns?: Array<Meter_Meter_Point_Rel_Update_Column>
  where?: InputMaybe<Meter_Meter_Point_Rel_Bool_Exp>
}

/** Ordering options when selecting data from "meter_meter_point_rel". */
export type Meter_Meter_Point_Rel_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  from_dt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter?: InputMaybe<Meter_Order_By>
  meter_id?: InputMaybe<Order_By>
  meter_point?: InputMaybe<Meter_Point_Order_By>
  meter_point_id?: InputMaybe<Order_By>
  register_id?: InputMaybe<Order_By>
  to_dt?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: meter_meter_point_rel */
export type Meter_Meter_Point_Rel_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "meter_meter_point_rel" */
export enum Meter_Meter_Point_Rel_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FromDt = "from_dt",
  /** column name */
  Id = "id",
  /** column name */
  MeterId = "meter_id",
  /** column name */
  MeterPointId = "meter_point_id",
  /** column name */
  RegisterId = "register_id",
  /** column name */
  ToDt = "to_dt",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "meter_meter_point_rel" */
export type Meter_Meter_Point_Rel_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  register_id?: InputMaybe<Scalars["bigint"]["input"]>
  to_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Meter_Meter_Point_Rel_Stddev_Fields = {
  __typename?: "meter_meter_point_rel_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  meter_id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
  register_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "meter_meter_point_rel" */
export type Meter_Meter_Point_Rel_Stddev_Order_By = {
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  register_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Meter_Meter_Point_Rel_Stddev_Pop_Fields = {
  __typename?: "meter_meter_point_rel_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  meter_id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
  register_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "meter_meter_point_rel" */
export type Meter_Meter_Point_Rel_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  register_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Meter_Meter_Point_Rel_Stddev_Samp_Fields = {
  __typename?: "meter_meter_point_rel_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  meter_id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
  register_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "meter_meter_point_rel" */
export type Meter_Meter_Point_Rel_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  register_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "meter_meter_point_rel" */
export type Meter_Meter_Point_Rel_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Meter_Meter_Point_Rel_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Meter_Meter_Point_Rel_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  register_id?: InputMaybe<Scalars["bigint"]["input"]>
  to_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Meter_Meter_Point_Rel_Sum_Fields = {
  __typename?: "meter_meter_point_rel_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["bigint"]["output"]>
  register_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "meter_meter_point_rel" */
export type Meter_Meter_Point_Rel_Sum_Order_By = {
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  register_id?: InputMaybe<Order_By>
}

/** update columns of table "meter_meter_point_rel" */
export enum Meter_Meter_Point_Rel_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FromDt = "from_dt",
  /** column name */
  Id = "id",
  /** column name */
  MeterId = "meter_id",
  /** column name */
  MeterPointId = "meter_point_id",
  /** column name */
  RegisterId = "register_id",
  /** column name */
  ToDt = "to_dt",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Meter_Meter_Point_Rel_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Meter_Meter_Point_Rel_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Meter_Meter_Point_Rel_Set_Input>
  /** filter the rows which have to be updated */
  where: Meter_Meter_Point_Rel_Bool_Exp
}

/** aggregate var_pop on columns */
export type Meter_Meter_Point_Rel_Var_Pop_Fields = {
  __typename?: "meter_meter_point_rel_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  meter_id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
  register_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "meter_meter_point_rel" */
export type Meter_Meter_Point_Rel_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  register_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Meter_Meter_Point_Rel_Var_Samp_Fields = {
  __typename?: "meter_meter_point_rel_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  meter_id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
  register_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "meter_meter_point_rel" */
export type Meter_Meter_Point_Rel_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  register_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Meter_Meter_Point_Rel_Variance_Fields = {
  __typename?: "meter_meter_point_rel_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  meter_id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
  register_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "meter_meter_point_rel" */
export type Meter_Meter_Point_Rel_Variance_Order_By = {
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  register_id?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Meter_Min_Fields = {
  __typename?: "meter_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  identifier?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["meter_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "meter" */
export type Meter_Mutation_Response = {
  __typename?: "meter_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Meter>
}

/** input type for inserting object relation for remote table "meter" */
export type Meter_Obj_Rel_Insert_Input = {
  data: Meter_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Meter_On_Conflict>
}

/** on_conflict condition type for table "meter" */
export type Meter_On_Conflict = {
  constraint: Meter_Constraint
  update_columns?: Array<Meter_Update_Column>
  where?: InputMaybe<Meter_Bool_Exp>
}

/** Ordering options when selecting data from "meter". */
export type Meter_Order_By = {
  asset?: InputMaybe<Asset_Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  description?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  identifier?: InputMaybe<Order_By>
  install_codes?: InputMaybe<Install_Codes_Order_By>
  meter_meter_point_rels_aggregate?: InputMaybe<Meter_Meter_Point_Rel_Aggregate_Order_By>
  registers_aggregate?: InputMaybe<Register_Aggregate_Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: meter */
export type Meter_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** columns and relationships of "meter_point" */
export type Meter_Point = {
  __typename?: "meter_point"
  change_of_tenancy_fl: Scalars["Boolean"]["output"]
  created_at: Scalars["timestamp"]["output"]
  dcc_service_status?: Maybe<Scalars["dcc_service_status"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  /** An array relationship */
  estimated_usages: Array<Estimated_Usage>
  /** An aggregate relationship */
  estimated_usages_aggregate: Estimated_Usage_Aggregate
  from_dt?: Maybe<Scalars["date"]["output"]>
  id: Scalars["bigint"]["output"]
  identifier: Scalars["String"]["output"]
  /** An object relationship */
  install_codes?: Maybe<Install_Codes>
  measurement_type?: Maybe<Scalars["meter_point_measurement_type"]["output"]>
  /** An array relationship */
  meter_meter_point_rels: Array<Meter_Meter_Point_Rel>
  /** An aggregate relationship */
  meter_meter_point_rels_aggregate: Meter_Meter_Point_Rel_Aggregate
  meter_operator_code?: Maybe<Scalars["String"]["output"]>
  /** An object relationship */
  meter_point_electricity?: Maybe<Meter_Point_Electricity>
  /** An object relationship */
  meter_point_ga?: Maybe<Meter_Point_Gas>
  /** An array relationship */
  meter_point_histories: Array<Meter_Point_History>
  /** An aggregate relationship */
  meter_point_histories_aggregate: Meter_Point_History_Aggregate
  /** An array relationship */
  meter_readings: Array<Meter_Reading>
  /** An aggregate relationship */
  meter_readings_aggregate: Meter_Reading_Aggregate
  operation_type?: Maybe<Scalars["operation_type"]["output"]>
  /** An object relationship */
  property?: Maybe<Property>
  property_id?: Maybe<Scalars["bigint"]["output"]>
  reading_frequency_code?: Maybe<Scalars["String"]["output"]>
  service_type?: Maybe<Scalars["String"]["output"]>
  supply_start_date?: Maybe<Scalars["date"]["output"]>
  to_dt?: Maybe<Scalars["date"]["output"]>
  type: Scalars["meter_point_type"]["output"]
  uk_gsp_group?: Maybe<Scalars["String"]["output"]>
  uk_profile_class?: Maybe<Scalars["uk_profile_class"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "meter_point" */
export type Meter_PointEstimated_UsagesArgs = {
  distinct_on?: InputMaybe<Array<Estimated_Usage_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Estimated_Usage_Order_By>>
  where?: InputMaybe<Estimated_Usage_Bool_Exp>
}

/** columns and relationships of "meter_point" */
export type Meter_PointEstimated_Usages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estimated_Usage_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Estimated_Usage_Order_By>>
  where?: InputMaybe<Estimated_Usage_Bool_Exp>
}

/** columns and relationships of "meter_point" */
export type Meter_PointMeter_Meter_Point_RelsArgs = {
  distinct_on?: InputMaybe<Array<Meter_Meter_Point_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Meter_Point_Rel_Order_By>>
  where?: InputMaybe<Meter_Meter_Point_Rel_Bool_Exp>
}

/** columns and relationships of "meter_point" */
export type Meter_PointMeter_Meter_Point_Rels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Meter_Point_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Meter_Point_Rel_Order_By>>
  where?: InputMaybe<Meter_Meter_Point_Rel_Bool_Exp>
}

/** columns and relationships of "meter_point" */
export type Meter_PointMeter_Point_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Meter_Point_History_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Point_History_Order_By>>
  where?: InputMaybe<Meter_Point_History_Bool_Exp>
}

/** columns and relationships of "meter_point" */
export type Meter_PointMeter_Point_Histories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Point_History_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Point_History_Order_By>>
  where?: InputMaybe<Meter_Point_History_Bool_Exp>
}

/** columns and relationships of "meter_point" */
export type Meter_PointMeter_ReadingsArgs = {
  distinct_on?: InputMaybe<Array<Meter_Reading_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Reading_Order_By>>
  where?: InputMaybe<Meter_Reading_Bool_Exp>
}

/** columns and relationships of "meter_point" */
export type Meter_PointMeter_Readings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Reading_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Reading_Order_By>>
  where?: InputMaybe<Meter_Reading_Bool_Exp>
}

/** aggregated selection of "meter_point" */
export type Meter_Point_Aggregate = {
  __typename?: "meter_point_aggregate"
  aggregate?: Maybe<Meter_Point_Aggregate_Fields>
  nodes: Array<Meter_Point>
}

export type Meter_Point_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Meter_Point_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Meter_Point_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<Meter_Point_Aggregate_Bool_Exp_Count>
}

export type Meter_Point_Aggregate_Bool_Exp_Bool_And = {
  arguments: Meter_Point_Select_Column_Meter_Point_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Meter_Point_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Meter_Point_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Meter_Point_Select_Column_Meter_Point_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Meter_Point_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Meter_Point_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Meter_Point_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Meter_Point_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "meter_point" */
export type Meter_Point_Aggregate_Fields = {
  __typename?: "meter_point_aggregate_fields"
  avg?: Maybe<Meter_Point_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Meter_Point_Max_Fields>
  min?: Maybe<Meter_Point_Min_Fields>
  stddev?: Maybe<Meter_Point_Stddev_Fields>
  stddev_pop?: Maybe<Meter_Point_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Meter_Point_Stddev_Samp_Fields>
  sum?: Maybe<Meter_Point_Sum_Fields>
  var_pop?: Maybe<Meter_Point_Var_Pop_Fields>
  var_samp?: Maybe<Meter_Point_Var_Samp_Fields>
  variance?: Maybe<Meter_Point_Variance_Fields>
}

/** aggregate fields of "meter_point" */
export type Meter_Point_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Meter_Point_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "meter_point" */
export type Meter_Point_Aggregate_Order_By = {
  avg?: InputMaybe<Meter_Point_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Meter_Point_Max_Order_By>
  min?: InputMaybe<Meter_Point_Min_Order_By>
  stddev?: InputMaybe<Meter_Point_Stddev_Order_By>
  stddev_pop?: InputMaybe<Meter_Point_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Meter_Point_Stddev_Samp_Order_By>
  sum?: InputMaybe<Meter_Point_Sum_Order_By>
  var_pop?: InputMaybe<Meter_Point_Var_Pop_Order_By>
  var_samp?: InputMaybe<Meter_Point_Var_Samp_Order_By>
  variance?: InputMaybe<Meter_Point_Variance_Order_By>
}

/** input type for inserting array relation for remote table "meter_point" */
export type Meter_Point_Arr_Rel_Insert_Input = {
  data: Array<Meter_Point_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Meter_Point_On_Conflict>
}

/** aggregate avg on columns */
export type Meter_Point_Avg_Fields = {
  __typename?: "meter_point_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  property_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "meter_point" */
export type Meter_Point_Avg_Order_By = {
  id?: InputMaybe<Order_By>
  property_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "meter_point". All fields are combined with a logical 'AND'. */
export type Meter_Point_Bool_Exp = {
  _and?: InputMaybe<Array<Meter_Point_Bool_Exp>>
  _not?: InputMaybe<Meter_Point_Bool_Exp>
  _or?: InputMaybe<Array<Meter_Point_Bool_Exp>>
  change_of_tenancy_fl?: InputMaybe<Boolean_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  dcc_service_status?: InputMaybe<Dcc_Service_Status_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  estimated_usages?: InputMaybe<Estimated_Usage_Bool_Exp>
  estimated_usages_aggregate?: InputMaybe<Estimated_Usage_Aggregate_Bool_Exp>
  from_dt?: InputMaybe<Date_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  identifier?: InputMaybe<String_Comparison_Exp>
  install_codes?: InputMaybe<Install_Codes_Bool_Exp>
  measurement_type?: InputMaybe<Meter_Point_Measurement_Type_Comparison_Exp>
  meter_meter_point_rels?: InputMaybe<Meter_Meter_Point_Rel_Bool_Exp>
  meter_meter_point_rels_aggregate?: InputMaybe<Meter_Meter_Point_Rel_Aggregate_Bool_Exp>
  meter_operator_code?: InputMaybe<String_Comparison_Exp>
  meter_point_electricity?: InputMaybe<Meter_Point_Electricity_Bool_Exp>
  meter_point_ga?: InputMaybe<Meter_Point_Gas_Bool_Exp>
  meter_point_histories?: InputMaybe<Meter_Point_History_Bool_Exp>
  meter_point_histories_aggregate?: InputMaybe<Meter_Point_History_Aggregate_Bool_Exp>
  meter_readings?: InputMaybe<Meter_Reading_Bool_Exp>
  meter_readings_aggregate?: InputMaybe<Meter_Reading_Aggregate_Bool_Exp>
  operation_type?: InputMaybe<Operation_Type_Comparison_Exp>
  property?: InputMaybe<Property_Bool_Exp>
  property_id?: InputMaybe<Bigint_Comparison_Exp>
  reading_frequency_code?: InputMaybe<String_Comparison_Exp>
  service_type?: InputMaybe<String_Comparison_Exp>
  supply_start_date?: InputMaybe<Date_Comparison_Exp>
  to_dt?: InputMaybe<Date_Comparison_Exp>
  type?: InputMaybe<Meter_Point_Type_Comparison_Exp>
  uk_gsp_group?: InputMaybe<String_Comparison_Exp>
  uk_profile_class?: InputMaybe<Uk_Profile_Class_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "meter_point" */
export enum Meter_Point_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkMeterPoint = "pk_meter_point",
}

/** columns and relationships of "meter_point_electricity" */
export type Meter_Point_Electricity = {
  __typename?: "meter_point_electricity"
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  distribution_network_operator?: Maybe<Scalars["String"]["output"]>
  energised?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["bigint"]["output"]
  is_rts_meter?: Maybe<Scalars["Boolean"]["output"]>
  line_loss_factor_class_id?: Maybe<Scalars["String"]["output"]>
  measurement_class?: Maybe<Scalars["String"]["output"]>
  /** An object relationship */
  meter_point: Meter_Point
  meter_serial_number?: Maybe<Scalars["String"]["output"]>
  meter_timeswitch_code?: Maybe<Scalars["String"]["output"]>
  meter_type?: Maybe<Scalars["meter_type"]["output"]>
  mhhs_enabled?: Maybe<Scalars["Boolean"]["output"]>
  mop_market_participant?: Maybe<Scalars["String"]["output"]>
  smso_market_participant_code?: Maybe<Scalars["String"]["output"]>
  standard_settlement_configuration_code?: Maybe<Scalars["String"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "meter_point_electricity" */
export type Meter_Point_Electricity_Aggregate = {
  __typename?: "meter_point_electricity_aggregate"
  aggregate?: Maybe<Meter_Point_Electricity_Aggregate_Fields>
  nodes: Array<Meter_Point_Electricity>
}

/** aggregate fields of "meter_point_electricity" */
export type Meter_Point_Electricity_Aggregate_Fields = {
  __typename?: "meter_point_electricity_aggregate_fields"
  avg?: Maybe<Meter_Point_Electricity_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Meter_Point_Electricity_Max_Fields>
  min?: Maybe<Meter_Point_Electricity_Min_Fields>
  stddev?: Maybe<Meter_Point_Electricity_Stddev_Fields>
  stddev_pop?: Maybe<Meter_Point_Electricity_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Meter_Point_Electricity_Stddev_Samp_Fields>
  sum?: Maybe<Meter_Point_Electricity_Sum_Fields>
  var_pop?: Maybe<Meter_Point_Electricity_Var_Pop_Fields>
  var_samp?: Maybe<Meter_Point_Electricity_Var_Samp_Fields>
  variance?: Maybe<Meter_Point_Electricity_Variance_Fields>
}

/** aggregate fields of "meter_point_electricity" */
export type Meter_Point_Electricity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Meter_Point_Electricity_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Meter_Point_Electricity_Avg_Fields = {
  __typename?: "meter_point_electricity_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "meter_point_electricity". All fields are combined with a logical 'AND'. */
export type Meter_Point_Electricity_Bool_Exp = {
  _and?: InputMaybe<Array<Meter_Point_Electricity_Bool_Exp>>
  _not?: InputMaybe<Meter_Point_Electricity_Bool_Exp>
  _or?: InputMaybe<Array<Meter_Point_Electricity_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  distribution_network_operator?: InputMaybe<String_Comparison_Exp>
  energised?: InputMaybe<Boolean_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  is_rts_meter?: InputMaybe<Boolean_Comparison_Exp>
  line_loss_factor_class_id?: InputMaybe<String_Comparison_Exp>
  measurement_class?: InputMaybe<String_Comparison_Exp>
  meter_point?: InputMaybe<Meter_Point_Bool_Exp>
  meter_serial_number?: InputMaybe<String_Comparison_Exp>
  meter_timeswitch_code?: InputMaybe<String_Comparison_Exp>
  meter_type?: InputMaybe<Meter_Type_Comparison_Exp>
  mhhs_enabled?: InputMaybe<Boolean_Comparison_Exp>
  mop_market_participant?: InputMaybe<String_Comparison_Exp>
  smso_market_participant_code?: InputMaybe<String_Comparison_Exp>
  standard_settlement_configuration_code?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "meter_point_electricity" */
export enum Meter_Point_Electricity_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkMeterPointsElectricity = "pk_meter_points_electricity",
}

/** input type for incrementing numeric columns in table "meter_point_electricity" */
export type Meter_Point_Electricity_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "meter_point_electricity" */
export type Meter_Point_Electricity_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  distribution_network_operator?: InputMaybe<Scalars["String"]["input"]>
  energised?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  is_rts_meter?: InputMaybe<Scalars["Boolean"]["input"]>
  line_loss_factor_class_id?: InputMaybe<Scalars["String"]["input"]>
  measurement_class?: InputMaybe<Scalars["String"]["input"]>
  meter_point?: InputMaybe<Meter_Point_Obj_Rel_Insert_Input>
  meter_serial_number?: InputMaybe<Scalars["String"]["input"]>
  meter_timeswitch_code?: InputMaybe<Scalars["String"]["input"]>
  meter_type?: InputMaybe<Scalars["meter_type"]["input"]>
  mhhs_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  mop_market_participant?: InputMaybe<Scalars["String"]["input"]>
  smso_market_participant_code?: InputMaybe<Scalars["String"]["input"]>
  standard_settlement_configuration_code?: InputMaybe<
    Scalars["String"]["input"]
  >
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Meter_Point_Electricity_Max_Fields = {
  __typename?: "meter_point_electricity_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  distribution_network_operator?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  line_loss_factor_class_id?: Maybe<Scalars["String"]["output"]>
  measurement_class?: Maybe<Scalars["String"]["output"]>
  meter_serial_number?: Maybe<Scalars["String"]["output"]>
  meter_timeswitch_code?: Maybe<Scalars["String"]["output"]>
  meter_type?: Maybe<Scalars["meter_type"]["output"]>
  mop_market_participant?: Maybe<Scalars["String"]["output"]>
  smso_market_participant_code?: Maybe<Scalars["String"]["output"]>
  standard_settlement_configuration_code?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Meter_Point_Electricity_Min_Fields = {
  __typename?: "meter_point_electricity_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  distribution_network_operator?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  line_loss_factor_class_id?: Maybe<Scalars["String"]["output"]>
  measurement_class?: Maybe<Scalars["String"]["output"]>
  meter_serial_number?: Maybe<Scalars["String"]["output"]>
  meter_timeswitch_code?: Maybe<Scalars["String"]["output"]>
  meter_type?: Maybe<Scalars["meter_type"]["output"]>
  mop_market_participant?: Maybe<Scalars["String"]["output"]>
  smso_market_participant_code?: Maybe<Scalars["String"]["output"]>
  standard_settlement_configuration_code?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "meter_point_electricity" */
export type Meter_Point_Electricity_Mutation_Response = {
  __typename?: "meter_point_electricity_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Meter_Point_Electricity>
}

/** input type for inserting object relation for remote table "meter_point_electricity" */
export type Meter_Point_Electricity_Obj_Rel_Insert_Input = {
  data: Meter_Point_Electricity_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Meter_Point_Electricity_On_Conflict>
}

/** on_conflict condition type for table "meter_point_electricity" */
export type Meter_Point_Electricity_On_Conflict = {
  constraint: Meter_Point_Electricity_Constraint
  update_columns?: Array<Meter_Point_Electricity_Update_Column>
  where?: InputMaybe<Meter_Point_Electricity_Bool_Exp>
}

/** Ordering options when selecting data from "meter_point_electricity". */
export type Meter_Point_Electricity_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  distribution_network_operator?: InputMaybe<Order_By>
  energised?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  is_rts_meter?: InputMaybe<Order_By>
  line_loss_factor_class_id?: InputMaybe<Order_By>
  measurement_class?: InputMaybe<Order_By>
  meter_point?: InputMaybe<Meter_Point_Order_By>
  meter_serial_number?: InputMaybe<Order_By>
  meter_timeswitch_code?: InputMaybe<Order_By>
  meter_type?: InputMaybe<Order_By>
  mhhs_enabled?: InputMaybe<Order_By>
  mop_market_participant?: InputMaybe<Order_By>
  smso_market_participant_code?: InputMaybe<Order_By>
  standard_settlement_configuration_code?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: meter_point_electricity */
export type Meter_Point_Electricity_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "meter_point_electricity" */
export enum Meter_Point_Electricity_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  DistributionNetworkOperator = "distribution_network_operator",
  /** column name */
  Energised = "energised",
  /** column name */
  Id = "id",
  /** column name */
  IsRtsMeter = "is_rts_meter",
  /** column name */
  LineLossFactorClassId = "line_loss_factor_class_id",
  /** column name */
  MeasurementClass = "measurement_class",
  /** column name */
  MeterSerialNumber = "meter_serial_number",
  /** column name */
  MeterTimeswitchCode = "meter_timeswitch_code",
  /** column name */
  MeterType = "meter_type",
  /** column name */
  MhhsEnabled = "mhhs_enabled",
  /** column name */
  MopMarketParticipant = "mop_market_participant",
  /** column name */
  SmsoMarketParticipantCode = "smso_market_participant_code",
  /** column name */
  StandardSettlementConfigurationCode = "standard_settlement_configuration_code",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "meter_point_electricity" */
export type Meter_Point_Electricity_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  distribution_network_operator?: InputMaybe<Scalars["String"]["input"]>
  energised?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  is_rts_meter?: InputMaybe<Scalars["Boolean"]["input"]>
  line_loss_factor_class_id?: InputMaybe<Scalars["String"]["input"]>
  measurement_class?: InputMaybe<Scalars["String"]["input"]>
  meter_serial_number?: InputMaybe<Scalars["String"]["input"]>
  meter_timeswitch_code?: InputMaybe<Scalars["String"]["input"]>
  meter_type?: InputMaybe<Scalars["meter_type"]["input"]>
  mhhs_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  mop_market_participant?: InputMaybe<Scalars["String"]["input"]>
  smso_market_participant_code?: InputMaybe<Scalars["String"]["input"]>
  standard_settlement_configuration_code?: InputMaybe<
    Scalars["String"]["input"]
  >
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Meter_Point_Electricity_Stddev_Fields = {
  __typename?: "meter_point_electricity_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Meter_Point_Electricity_Stddev_Pop_Fields = {
  __typename?: "meter_point_electricity_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Meter_Point_Electricity_Stddev_Samp_Fields = {
  __typename?: "meter_point_electricity_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "meter_point_electricity" */
export type Meter_Point_Electricity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Meter_Point_Electricity_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Meter_Point_Electricity_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  distribution_network_operator?: InputMaybe<Scalars["String"]["input"]>
  energised?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  is_rts_meter?: InputMaybe<Scalars["Boolean"]["input"]>
  line_loss_factor_class_id?: InputMaybe<Scalars["String"]["input"]>
  measurement_class?: InputMaybe<Scalars["String"]["input"]>
  meter_serial_number?: InputMaybe<Scalars["String"]["input"]>
  meter_timeswitch_code?: InputMaybe<Scalars["String"]["input"]>
  meter_type?: InputMaybe<Scalars["meter_type"]["input"]>
  mhhs_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  mop_market_participant?: InputMaybe<Scalars["String"]["input"]>
  smso_market_participant_code?: InputMaybe<Scalars["String"]["input"]>
  standard_settlement_configuration_code?: InputMaybe<
    Scalars["String"]["input"]
  >
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Meter_Point_Electricity_Sum_Fields = {
  __typename?: "meter_point_electricity_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "meter_point_electricity" */
export enum Meter_Point_Electricity_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  DistributionNetworkOperator = "distribution_network_operator",
  /** column name */
  Energised = "energised",
  /** column name */
  Id = "id",
  /** column name */
  IsRtsMeter = "is_rts_meter",
  /** column name */
  LineLossFactorClassId = "line_loss_factor_class_id",
  /** column name */
  MeasurementClass = "measurement_class",
  /** column name */
  MeterSerialNumber = "meter_serial_number",
  /** column name */
  MeterTimeswitchCode = "meter_timeswitch_code",
  /** column name */
  MeterType = "meter_type",
  /** column name */
  MhhsEnabled = "mhhs_enabled",
  /** column name */
  MopMarketParticipant = "mop_market_participant",
  /** column name */
  SmsoMarketParticipantCode = "smso_market_participant_code",
  /** column name */
  StandardSettlementConfigurationCode = "standard_settlement_configuration_code",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Meter_Point_Electricity_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Meter_Point_Electricity_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Meter_Point_Electricity_Set_Input>
  /** filter the rows which have to be updated */
  where: Meter_Point_Electricity_Bool_Exp
}

/** aggregate var_pop on columns */
export type Meter_Point_Electricity_Var_Pop_Fields = {
  __typename?: "meter_point_electricity_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Meter_Point_Electricity_Var_Samp_Fields = {
  __typename?: "meter_point_electricity_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Meter_Point_Electricity_Variance_Fields = {
  __typename?: "meter_point_electricity_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "meter_point_event_type". All fields are combined with logical 'AND'. */
export type Meter_Point_Event_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["meter_point_event_type"]["input"]>
  _gt?: InputMaybe<Scalars["meter_point_event_type"]["input"]>
  _gte?: InputMaybe<Scalars["meter_point_event_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["meter_point_event_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["meter_point_event_type"]["input"]>
  _lte?: InputMaybe<Scalars["meter_point_event_type"]["input"]>
  _neq?: InputMaybe<Scalars["meter_point_event_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["meter_point_event_type"]["input"]>>
}

/** columns and relationships of "meter_point_gas" */
export type Meter_Point_Gas = {
  __typename?: "meter_point_gas"
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  designation?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  igt_identifier?: Maybe<Scalars["String"]["output"]>
  mam_market_participant?: Maybe<Scalars["String"]["output"]>
  /** An object relationship */
  meter_point: Meter_Point
  meter_serial_number?: Maybe<Scalars["String"]["output"]>
  prepay_detected?: Maybe<Scalars["Boolean"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "meter_point_gas" */
export type Meter_Point_Gas_Aggregate = {
  __typename?: "meter_point_gas_aggregate"
  aggregate?: Maybe<Meter_Point_Gas_Aggregate_Fields>
  nodes: Array<Meter_Point_Gas>
}

/** aggregate fields of "meter_point_gas" */
export type Meter_Point_Gas_Aggregate_Fields = {
  __typename?: "meter_point_gas_aggregate_fields"
  avg?: Maybe<Meter_Point_Gas_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Meter_Point_Gas_Max_Fields>
  min?: Maybe<Meter_Point_Gas_Min_Fields>
  stddev?: Maybe<Meter_Point_Gas_Stddev_Fields>
  stddev_pop?: Maybe<Meter_Point_Gas_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Meter_Point_Gas_Stddev_Samp_Fields>
  sum?: Maybe<Meter_Point_Gas_Sum_Fields>
  var_pop?: Maybe<Meter_Point_Gas_Var_Pop_Fields>
  var_samp?: Maybe<Meter_Point_Gas_Var_Samp_Fields>
  variance?: Maybe<Meter_Point_Gas_Variance_Fields>
}

/** aggregate fields of "meter_point_gas" */
export type Meter_Point_Gas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Meter_Point_Gas_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Meter_Point_Gas_Avg_Fields = {
  __typename?: "meter_point_gas_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "meter_point_gas". All fields are combined with a logical 'AND'. */
export type Meter_Point_Gas_Bool_Exp = {
  _and?: InputMaybe<Array<Meter_Point_Gas_Bool_Exp>>
  _not?: InputMaybe<Meter_Point_Gas_Bool_Exp>
  _or?: InputMaybe<Array<Meter_Point_Gas_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  designation?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  igt_identifier?: InputMaybe<String_Comparison_Exp>
  mam_market_participant?: InputMaybe<String_Comparison_Exp>
  meter_point?: InputMaybe<Meter_Point_Bool_Exp>
  meter_serial_number?: InputMaybe<String_Comparison_Exp>
  prepay_detected?: InputMaybe<Boolean_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "meter_point_gas" */
export enum Meter_Point_Gas_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkMeterPointGas = "pk_meter_point_gas",
}

/** input type for incrementing numeric columns in table "meter_point_gas" */
export type Meter_Point_Gas_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "meter_point_gas" */
export type Meter_Point_Gas_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  designation?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  igt_identifier?: InputMaybe<Scalars["String"]["input"]>
  mam_market_participant?: InputMaybe<Scalars["String"]["input"]>
  meter_point?: InputMaybe<Meter_Point_Obj_Rel_Insert_Input>
  meter_serial_number?: InputMaybe<Scalars["String"]["input"]>
  prepay_detected?: InputMaybe<Scalars["Boolean"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Meter_Point_Gas_Max_Fields = {
  __typename?: "meter_point_gas_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  designation?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  igt_identifier?: Maybe<Scalars["String"]["output"]>
  mam_market_participant?: Maybe<Scalars["String"]["output"]>
  meter_serial_number?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Meter_Point_Gas_Min_Fields = {
  __typename?: "meter_point_gas_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  designation?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  igt_identifier?: Maybe<Scalars["String"]["output"]>
  mam_market_participant?: Maybe<Scalars["String"]["output"]>
  meter_serial_number?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "meter_point_gas" */
export type Meter_Point_Gas_Mutation_Response = {
  __typename?: "meter_point_gas_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Meter_Point_Gas>
}

/** input type for inserting object relation for remote table "meter_point_gas" */
export type Meter_Point_Gas_Obj_Rel_Insert_Input = {
  data: Meter_Point_Gas_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Meter_Point_Gas_On_Conflict>
}

/** on_conflict condition type for table "meter_point_gas" */
export type Meter_Point_Gas_On_Conflict = {
  constraint: Meter_Point_Gas_Constraint
  update_columns?: Array<Meter_Point_Gas_Update_Column>
  where?: InputMaybe<Meter_Point_Gas_Bool_Exp>
}

/** Ordering options when selecting data from "meter_point_gas". */
export type Meter_Point_Gas_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  designation?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  igt_identifier?: InputMaybe<Order_By>
  mam_market_participant?: InputMaybe<Order_By>
  meter_point?: InputMaybe<Meter_Point_Order_By>
  meter_serial_number?: InputMaybe<Order_By>
  prepay_detected?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: meter_point_gas */
export type Meter_Point_Gas_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "meter_point_gas" */
export enum Meter_Point_Gas_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Designation = "designation",
  /** column name */
  Id = "id",
  /** column name */
  IgtIdentifier = "igt_identifier",
  /** column name */
  MamMarketParticipant = "mam_market_participant",
  /** column name */
  MeterSerialNumber = "meter_serial_number",
  /** column name */
  PrepayDetected = "prepay_detected",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "meter_point_gas" */
export type Meter_Point_Gas_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  designation?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  igt_identifier?: InputMaybe<Scalars["String"]["input"]>
  mam_market_participant?: InputMaybe<Scalars["String"]["input"]>
  meter_serial_number?: InputMaybe<Scalars["String"]["input"]>
  prepay_detected?: InputMaybe<Scalars["Boolean"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Meter_Point_Gas_Stddev_Fields = {
  __typename?: "meter_point_gas_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Meter_Point_Gas_Stddev_Pop_Fields = {
  __typename?: "meter_point_gas_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Meter_Point_Gas_Stddev_Samp_Fields = {
  __typename?: "meter_point_gas_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "meter_point_gas" */
export type Meter_Point_Gas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Meter_Point_Gas_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Meter_Point_Gas_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  designation?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  igt_identifier?: InputMaybe<Scalars["String"]["input"]>
  mam_market_participant?: InputMaybe<Scalars["String"]["input"]>
  meter_serial_number?: InputMaybe<Scalars["String"]["input"]>
  prepay_detected?: InputMaybe<Scalars["Boolean"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Meter_Point_Gas_Sum_Fields = {
  __typename?: "meter_point_gas_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "meter_point_gas" */
export enum Meter_Point_Gas_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Designation = "designation",
  /** column name */
  Id = "id",
  /** column name */
  IgtIdentifier = "igt_identifier",
  /** column name */
  MamMarketParticipant = "mam_market_participant",
  /** column name */
  MeterSerialNumber = "meter_serial_number",
  /** column name */
  PrepayDetected = "prepay_detected",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Meter_Point_Gas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Meter_Point_Gas_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Meter_Point_Gas_Set_Input>
  /** filter the rows which have to be updated */
  where: Meter_Point_Gas_Bool_Exp
}

/** aggregate var_pop on columns */
export type Meter_Point_Gas_Var_Pop_Fields = {
  __typename?: "meter_point_gas_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Meter_Point_Gas_Var_Samp_Fields = {
  __typename?: "meter_point_gas_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Meter_Point_Gas_Variance_Fields = {
  __typename?: "meter_point_gas_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "meter_point_history" */
export type Meter_Point_History = {
  __typename?: "meter_point_history"
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  event_type: Scalars["meter_point_event_type"]["output"]
  id: Scalars["bigint"]["output"]
  /** An object relationship */
  meter_point: Meter_Point
  meter_point_id: Scalars["bigint"]["output"]
  status: Scalars["meter_point_supply_status"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "meter_point_history" */
export type Meter_Point_History_Aggregate = {
  __typename?: "meter_point_history_aggregate"
  aggregate?: Maybe<Meter_Point_History_Aggregate_Fields>
  nodes: Array<Meter_Point_History>
}

export type Meter_Point_History_Aggregate_Bool_Exp = {
  count?: InputMaybe<Meter_Point_History_Aggregate_Bool_Exp_Count>
}

export type Meter_Point_History_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Meter_Point_History_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Meter_Point_History_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "meter_point_history" */
export type Meter_Point_History_Aggregate_Fields = {
  __typename?: "meter_point_history_aggregate_fields"
  avg?: Maybe<Meter_Point_History_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Meter_Point_History_Max_Fields>
  min?: Maybe<Meter_Point_History_Min_Fields>
  stddev?: Maybe<Meter_Point_History_Stddev_Fields>
  stddev_pop?: Maybe<Meter_Point_History_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Meter_Point_History_Stddev_Samp_Fields>
  sum?: Maybe<Meter_Point_History_Sum_Fields>
  var_pop?: Maybe<Meter_Point_History_Var_Pop_Fields>
  var_samp?: Maybe<Meter_Point_History_Var_Samp_Fields>
  variance?: Maybe<Meter_Point_History_Variance_Fields>
}

/** aggregate fields of "meter_point_history" */
export type Meter_Point_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Meter_Point_History_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "meter_point_history" */
export type Meter_Point_History_Aggregate_Order_By = {
  avg?: InputMaybe<Meter_Point_History_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Meter_Point_History_Max_Order_By>
  min?: InputMaybe<Meter_Point_History_Min_Order_By>
  stddev?: InputMaybe<Meter_Point_History_Stddev_Order_By>
  stddev_pop?: InputMaybe<Meter_Point_History_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Meter_Point_History_Stddev_Samp_Order_By>
  sum?: InputMaybe<Meter_Point_History_Sum_Order_By>
  var_pop?: InputMaybe<Meter_Point_History_Var_Pop_Order_By>
  var_samp?: InputMaybe<Meter_Point_History_Var_Samp_Order_By>
  variance?: InputMaybe<Meter_Point_History_Variance_Order_By>
}

/** input type for inserting array relation for remote table "meter_point_history" */
export type Meter_Point_History_Arr_Rel_Insert_Input = {
  data: Array<Meter_Point_History_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Meter_Point_History_On_Conflict>
}

/** aggregate avg on columns */
export type Meter_Point_History_Avg_Fields = {
  __typename?: "meter_point_history_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "meter_point_history" */
export type Meter_Point_History_Avg_Order_By = {
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "meter_point_history". All fields are combined with a logical 'AND'. */
export type Meter_Point_History_Bool_Exp = {
  _and?: InputMaybe<Array<Meter_Point_History_Bool_Exp>>
  _not?: InputMaybe<Meter_Point_History_Bool_Exp>
  _or?: InputMaybe<Array<Meter_Point_History_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  event_type?: InputMaybe<Meter_Point_Event_Type_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  meter_point?: InputMaybe<Meter_Point_Bool_Exp>
  meter_point_id?: InputMaybe<Bigint_Comparison_Exp>
  status?: InputMaybe<Meter_Point_Supply_Status_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "meter_point_history" */
export enum Meter_Point_History_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkMeterPointsHistory = "pk_meter_points_history",
}

/** input type for incrementing numeric columns in table "meter_point_history" */
export type Meter_Point_History_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "meter_point_history" */
export type Meter_Point_History_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  event_type?: InputMaybe<Scalars["meter_point_event_type"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point?: InputMaybe<Meter_Point_Obj_Rel_Insert_Input>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["meter_point_supply_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Meter_Point_History_Max_Fields = {
  __typename?: "meter_point_history_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  event_type?: Maybe<Scalars["meter_point_event_type"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["meter_point_supply_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "meter_point_history" */
export type Meter_Point_History_Max_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  event_type?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Meter_Point_History_Min_Fields = {
  __typename?: "meter_point_history_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  event_type?: Maybe<Scalars["meter_point_event_type"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["meter_point_supply_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "meter_point_history" */
export type Meter_Point_History_Min_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  event_type?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "meter_point_history" */
export type Meter_Point_History_Mutation_Response = {
  __typename?: "meter_point_history_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Meter_Point_History>
}

/** on_conflict condition type for table "meter_point_history" */
export type Meter_Point_History_On_Conflict = {
  constraint: Meter_Point_History_Constraint
  update_columns?: Array<Meter_Point_History_Update_Column>
  where?: InputMaybe<Meter_Point_History_Bool_Exp>
}

/** Ordering options when selecting data from "meter_point_history". */
export type Meter_Point_History_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  event_type?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point?: InputMaybe<Meter_Point_Order_By>
  meter_point_id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: meter_point_history */
export type Meter_Point_History_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "meter_point_history" */
export enum Meter_Point_History_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  EventType = "event_type",
  /** column name */
  Id = "id",
  /** column name */
  MeterPointId = "meter_point_id",
  /** column name */
  Status = "status",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "meter_point_history" */
export type Meter_Point_History_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  event_type?: InputMaybe<Scalars["meter_point_event_type"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["meter_point_supply_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Meter_Point_History_Stddev_Fields = {
  __typename?: "meter_point_history_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "meter_point_history" */
export type Meter_Point_History_Stddev_Order_By = {
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Meter_Point_History_Stddev_Pop_Fields = {
  __typename?: "meter_point_history_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "meter_point_history" */
export type Meter_Point_History_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Meter_Point_History_Stddev_Samp_Fields = {
  __typename?: "meter_point_history_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "meter_point_history" */
export type Meter_Point_History_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "meter_point_history" */
export type Meter_Point_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Meter_Point_History_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Meter_Point_History_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  event_type?: InputMaybe<Scalars["meter_point_event_type"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["meter_point_supply_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Meter_Point_History_Sum_Fields = {
  __typename?: "meter_point_history_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "meter_point_history" */
export type Meter_Point_History_Sum_Order_By = {
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** update columns of table "meter_point_history" */
export enum Meter_Point_History_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  EventType = "event_type",
  /** column name */
  Id = "id",
  /** column name */
  MeterPointId = "meter_point_id",
  /** column name */
  Status = "status",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Meter_Point_History_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Meter_Point_History_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Meter_Point_History_Set_Input>
  /** filter the rows which have to be updated */
  where: Meter_Point_History_Bool_Exp
}

/** aggregate var_pop on columns */
export type Meter_Point_History_Var_Pop_Fields = {
  __typename?: "meter_point_history_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "meter_point_history" */
export type Meter_Point_History_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Meter_Point_History_Var_Samp_Fields = {
  __typename?: "meter_point_history_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "meter_point_history" */
export type Meter_Point_History_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Meter_Point_History_Variance_Fields = {
  __typename?: "meter_point_history_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "meter_point_history" */
export type Meter_Point_History_Variance_Order_By = {
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** input type for incrementing numeric columns in table "meter_point" */
export type Meter_Point_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  property_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "meter_point" */
export type Meter_Point_Insert_Input = {
  change_of_tenancy_fl?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  dcc_service_status?: InputMaybe<Scalars["dcc_service_status"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  estimated_usages?: InputMaybe<Estimated_Usage_Arr_Rel_Insert_Input>
  from_dt?: InputMaybe<Scalars["date"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  identifier?: InputMaybe<Scalars["String"]["input"]>
  install_codes?: InputMaybe<Install_Codes_Obj_Rel_Insert_Input>
  measurement_type?: InputMaybe<
    Scalars["meter_point_measurement_type"]["input"]
  >
  meter_meter_point_rels?: InputMaybe<Meter_Meter_Point_Rel_Arr_Rel_Insert_Input>
  meter_operator_code?: InputMaybe<Scalars["String"]["input"]>
  meter_point_electricity?: InputMaybe<Meter_Point_Electricity_Obj_Rel_Insert_Input>
  meter_point_ga?: InputMaybe<Meter_Point_Gas_Obj_Rel_Insert_Input>
  meter_point_histories?: InputMaybe<Meter_Point_History_Arr_Rel_Insert_Input>
  meter_readings?: InputMaybe<Meter_Reading_Arr_Rel_Insert_Input>
  operation_type?: InputMaybe<Scalars["operation_type"]["input"]>
  property?: InputMaybe<Property_Obj_Rel_Insert_Input>
  property_id?: InputMaybe<Scalars["bigint"]["input"]>
  reading_frequency_code?: InputMaybe<Scalars["String"]["input"]>
  service_type?: InputMaybe<Scalars["String"]["input"]>
  supply_start_date?: InputMaybe<Scalars["date"]["input"]>
  to_dt?: InputMaybe<Scalars["date"]["input"]>
  type?: InputMaybe<Scalars["meter_point_type"]["input"]>
  uk_gsp_group?: InputMaybe<Scalars["String"]["input"]>
  uk_profile_class?: InputMaybe<Scalars["uk_profile_class"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Meter_Point_Max_Fields = {
  __typename?: "meter_point_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  dcc_service_status?: Maybe<Scalars["dcc_service_status"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_dt?: Maybe<Scalars["date"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  identifier?: Maybe<Scalars["String"]["output"]>
  measurement_type?: Maybe<Scalars["meter_point_measurement_type"]["output"]>
  meter_operator_code?: Maybe<Scalars["String"]["output"]>
  operation_type?: Maybe<Scalars["operation_type"]["output"]>
  property_id?: Maybe<Scalars["bigint"]["output"]>
  reading_frequency_code?: Maybe<Scalars["String"]["output"]>
  service_type?: Maybe<Scalars["String"]["output"]>
  supply_start_date?: Maybe<Scalars["date"]["output"]>
  to_dt?: Maybe<Scalars["date"]["output"]>
  type?: Maybe<Scalars["meter_point_type"]["output"]>
  uk_gsp_group?: Maybe<Scalars["String"]["output"]>
  uk_profile_class?: Maybe<Scalars["uk_profile_class"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "meter_point" */
export type Meter_Point_Max_Order_By = {
  created_at?: InputMaybe<Order_By>
  dcc_service_status?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  from_dt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  identifier?: InputMaybe<Order_By>
  measurement_type?: InputMaybe<Order_By>
  meter_operator_code?: InputMaybe<Order_By>
  operation_type?: InputMaybe<Order_By>
  property_id?: InputMaybe<Order_By>
  reading_frequency_code?: InputMaybe<Order_By>
  service_type?: InputMaybe<Order_By>
  supply_start_date?: InputMaybe<Order_By>
  to_dt?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  uk_gsp_group?: InputMaybe<Order_By>
  uk_profile_class?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "meter_point_measurement_type". All fields are combined with logical 'AND'. */
export type Meter_Point_Measurement_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["meter_point_measurement_type"]["input"]>
  _gt?: InputMaybe<Scalars["meter_point_measurement_type"]["input"]>
  _gte?: InputMaybe<Scalars["meter_point_measurement_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["meter_point_measurement_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["meter_point_measurement_type"]["input"]>
  _lte?: InputMaybe<Scalars["meter_point_measurement_type"]["input"]>
  _neq?: InputMaybe<Scalars["meter_point_measurement_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["meter_point_measurement_type"]["input"]>>
}

/** aggregate min on columns */
export type Meter_Point_Min_Fields = {
  __typename?: "meter_point_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  dcc_service_status?: Maybe<Scalars["dcc_service_status"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_dt?: Maybe<Scalars["date"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  identifier?: Maybe<Scalars["String"]["output"]>
  measurement_type?: Maybe<Scalars["meter_point_measurement_type"]["output"]>
  meter_operator_code?: Maybe<Scalars["String"]["output"]>
  operation_type?: Maybe<Scalars["operation_type"]["output"]>
  property_id?: Maybe<Scalars["bigint"]["output"]>
  reading_frequency_code?: Maybe<Scalars["String"]["output"]>
  service_type?: Maybe<Scalars["String"]["output"]>
  supply_start_date?: Maybe<Scalars["date"]["output"]>
  to_dt?: Maybe<Scalars["date"]["output"]>
  type?: Maybe<Scalars["meter_point_type"]["output"]>
  uk_gsp_group?: Maybe<Scalars["String"]["output"]>
  uk_profile_class?: Maybe<Scalars["uk_profile_class"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "meter_point" */
export type Meter_Point_Min_Order_By = {
  created_at?: InputMaybe<Order_By>
  dcc_service_status?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  from_dt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  identifier?: InputMaybe<Order_By>
  measurement_type?: InputMaybe<Order_By>
  meter_operator_code?: InputMaybe<Order_By>
  operation_type?: InputMaybe<Order_By>
  property_id?: InputMaybe<Order_By>
  reading_frequency_code?: InputMaybe<Order_By>
  service_type?: InputMaybe<Order_By>
  supply_start_date?: InputMaybe<Order_By>
  to_dt?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  uk_gsp_group?: InputMaybe<Order_By>
  uk_profile_class?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "meter_point" */
export type Meter_Point_Mutation_Response = {
  __typename?: "meter_point_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Meter_Point>
}

/** input type for inserting object relation for remote table "meter_point" */
export type Meter_Point_Obj_Rel_Insert_Input = {
  data: Meter_Point_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Meter_Point_On_Conflict>
}

/** on_conflict condition type for table "meter_point" */
export type Meter_Point_On_Conflict = {
  constraint: Meter_Point_Constraint
  update_columns?: Array<Meter_Point_Update_Column>
  where?: InputMaybe<Meter_Point_Bool_Exp>
}

/** Ordering options when selecting data from "meter_point". */
export type Meter_Point_Order_By = {
  change_of_tenancy_fl?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  dcc_service_status?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  estimated_usages_aggregate?: InputMaybe<Estimated_Usage_Aggregate_Order_By>
  from_dt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  identifier?: InputMaybe<Order_By>
  install_codes?: InputMaybe<Install_Codes_Order_By>
  measurement_type?: InputMaybe<Order_By>
  meter_meter_point_rels_aggregate?: InputMaybe<Meter_Meter_Point_Rel_Aggregate_Order_By>
  meter_operator_code?: InputMaybe<Order_By>
  meter_point_electricity?: InputMaybe<Meter_Point_Electricity_Order_By>
  meter_point_ga?: InputMaybe<Meter_Point_Gas_Order_By>
  meter_point_histories_aggregate?: InputMaybe<Meter_Point_History_Aggregate_Order_By>
  meter_readings_aggregate?: InputMaybe<Meter_Reading_Aggregate_Order_By>
  operation_type?: InputMaybe<Order_By>
  property?: InputMaybe<Property_Order_By>
  property_id?: InputMaybe<Order_By>
  reading_frequency_code?: InputMaybe<Order_By>
  service_type?: InputMaybe<Order_By>
  supply_start_date?: InputMaybe<Order_By>
  to_dt?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  uk_gsp_group?: InputMaybe<Order_By>
  uk_profile_class?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: meter_point */
export type Meter_Point_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "meter_point" */
export enum Meter_Point_Select_Column {
  /** column name */
  ChangeOfTenancyFl = "change_of_tenancy_fl",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DccServiceStatus = "dcc_service_status",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FromDt = "from_dt",
  /** column name */
  Id = "id",
  /** column name */
  Identifier = "identifier",
  /** column name */
  MeasurementType = "measurement_type",
  /** column name */
  MeterOperatorCode = "meter_operator_code",
  /** column name */
  OperationType = "operation_type",
  /** column name */
  PropertyId = "property_id",
  /** column name */
  ReadingFrequencyCode = "reading_frequency_code",
  /** column name */
  ServiceType = "service_type",
  /** column name */
  SupplyStartDate = "supply_start_date",
  /** column name */
  ToDt = "to_dt",
  /** column name */
  Type = "type",
  /** column name */
  UkGspGroup = "uk_gsp_group",
  /** column name */
  UkProfileClass = "uk_profile_class",
  /** column name */
  UpdatedAt = "updated_at",
}

/** select "meter_point_aggregate_bool_exp_bool_and_arguments_columns" columns of table "meter_point" */
export enum Meter_Point_Select_Column_Meter_Point_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ChangeOfTenancyFl = "change_of_tenancy_fl",
}

/** select "meter_point_aggregate_bool_exp_bool_or_arguments_columns" columns of table "meter_point" */
export enum Meter_Point_Select_Column_Meter_Point_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ChangeOfTenancyFl = "change_of_tenancy_fl",
}

/** input type for updating data in table "meter_point" */
export type Meter_Point_Set_Input = {
  change_of_tenancy_fl?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  dcc_service_status?: InputMaybe<Scalars["dcc_service_status"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_dt?: InputMaybe<Scalars["date"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  identifier?: InputMaybe<Scalars["String"]["input"]>
  measurement_type?: InputMaybe<
    Scalars["meter_point_measurement_type"]["input"]
  >
  meter_operator_code?: InputMaybe<Scalars["String"]["input"]>
  operation_type?: InputMaybe<Scalars["operation_type"]["input"]>
  property_id?: InputMaybe<Scalars["bigint"]["input"]>
  reading_frequency_code?: InputMaybe<Scalars["String"]["input"]>
  service_type?: InputMaybe<Scalars["String"]["input"]>
  supply_start_date?: InputMaybe<Scalars["date"]["input"]>
  to_dt?: InputMaybe<Scalars["date"]["input"]>
  type?: InputMaybe<Scalars["meter_point_type"]["input"]>
  uk_gsp_group?: InputMaybe<Scalars["String"]["input"]>
  uk_profile_class?: InputMaybe<Scalars["uk_profile_class"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Meter_Point_Stddev_Fields = {
  __typename?: "meter_point_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  property_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "meter_point" */
export type Meter_Point_Stddev_Order_By = {
  id?: InputMaybe<Order_By>
  property_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Meter_Point_Stddev_Pop_Fields = {
  __typename?: "meter_point_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  property_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "meter_point" */
export type Meter_Point_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>
  property_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Meter_Point_Stddev_Samp_Fields = {
  __typename?: "meter_point_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  property_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "meter_point" */
export type Meter_Point_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>
  property_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "meter_point" */
export type Meter_Point_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Meter_Point_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Meter_Point_Stream_Cursor_Value_Input = {
  change_of_tenancy_fl?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  dcc_service_status?: InputMaybe<Scalars["dcc_service_status"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_dt?: InputMaybe<Scalars["date"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  identifier?: InputMaybe<Scalars["String"]["input"]>
  measurement_type?: InputMaybe<
    Scalars["meter_point_measurement_type"]["input"]
  >
  meter_operator_code?: InputMaybe<Scalars["String"]["input"]>
  operation_type?: InputMaybe<Scalars["operation_type"]["input"]>
  property_id?: InputMaybe<Scalars["bigint"]["input"]>
  reading_frequency_code?: InputMaybe<Scalars["String"]["input"]>
  service_type?: InputMaybe<Scalars["String"]["input"]>
  supply_start_date?: InputMaybe<Scalars["date"]["input"]>
  to_dt?: InputMaybe<Scalars["date"]["input"]>
  type?: InputMaybe<Scalars["meter_point_type"]["input"]>
  uk_gsp_group?: InputMaybe<Scalars["String"]["input"]>
  uk_profile_class?: InputMaybe<Scalars["uk_profile_class"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Meter_Point_Sum_Fields = {
  __typename?: "meter_point_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  property_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "meter_point" */
export type Meter_Point_Sum_Order_By = {
  id?: InputMaybe<Order_By>
  property_id?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "meter_point_supply_status". All fields are combined with logical 'AND'. */
export type Meter_Point_Supply_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["meter_point_supply_status"]["input"]>
  _gt?: InputMaybe<Scalars["meter_point_supply_status"]["input"]>
  _gte?: InputMaybe<Scalars["meter_point_supply_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["meter_point_supply_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["meter_point_supply_status"]["input"]>
  _lte?: InputMaybe<Scalars["meter_point_supply_status"]["input"]>
  _neq?: InputMaybe<Scalars["meter_point_supply_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["meter_point_supply_status"]["input"]>>
}

/** Boolean expression to compare columns of type "meter_point_type". All fields are combined with logical 'AND'. */
export type Meter_Point_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["meter_point_type"]["input"]>
  _gt?: InputMaybe<Scalars["meter_point_type"]["input"]>
  _gte?: InputMaybe<Scalars["meter_point_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["meter_point_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["meter_point_type"]["input"]>
  _lte?: InputMaybe<Scalars["meter_point_type"]["input"]>
  _neq?: InputMaybe<Scalars["meter_point_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["meter_point_type"]["input"]>>
}

/** update columns of table "meter_point" */
export enum Meter_Point_Update_Column {
  /** column name */
  ChangeOfTenancyFl = "change_of_tenancy_fl",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DccServiceStatus = "dcc_service_status",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FromDt = "from_dt",
  /** column name */
  Id = "id",
  /** column name */
  Identifier = "identifier",
  /** column name */
  MeasurementType = "measurement_type",
  /** column name */
  MeterOperatorCode = "meter_operator_code",
  /** column name */
  OperationType = "operation_type",
  /** column name */
  PropertyId = "property_id",
  /** column name */
  ReadingFrequencyCode = "reading_frequency_code",
  /** column name */
  ServiceType = "service_type",
  /** column name */
  SupplyStartDate = "supply_start_date",
  /** column name */
  ToDt = "to_dt",
  /** column name */
  Type = "type",
  /** column name */
  UkGspGroup = "uk_gsp_group",
  /** column name */
  UkProfileClass = "uk_profile_class",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Meter_Point_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Meter_Point_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Meter_Point_Set_Input>
  /** filter the rows which have to be updated */
  where: Meter_Point_Bool_Exp
}

/** aggregate var_pop on columns */
export type Meter_Point_Var_Pop_Fields = {
  __typename?: "meter_point_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  property_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "meter_point" */
export type Meter_Point_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>
  property_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Meter_Point_Var_Samp_Fields = {
  __typename?: "meter_point_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  property_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "meter_point" */
export type Meter_Point_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>
  property_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Meter_Point_Variance_Fields = {
  __typename?: "meter_point_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  property_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "meter_point" */
export type Meter_Point_Variance_Order_By = {
  id?: InputMaybe<Order_By>
  property_id?: InputMaybe<Order_By>
}

/** columns and relationships of "meter_reading" */
export type Meter_Reading = {
  __typename?: "meter_reading"
  consumption?: Maybe<Scalars["numeric"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  cumulative: Scalars["numeric"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  error_description?: Maybe<Scalars["String"]["output"]>
  from_dttm?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  meter_id?: Maybe<Scalars["bigint"]["output"]>
  /** An object relationship */
  meter_point: Meter_Point
  meter_point_id: Scalars["bigint"]["output"]
  pending_register_reading_id?: Maybe<Scalars["String"]["output"]>
  quality: Scalars["meter_reading_quality"]["output"]
  rate_name?: Maybe<Scalars["String"]["output"]>
  reading_dttm: Scalars["timestamp"]["output"]
  /** An object relationship */
  register?: Maybe<Register>
  register_id?: Maybe<Scalars["bigint"]["output"]>
  sequence_type: Scalars["meter_reading_sequence_type"]["output"]
  source: Scalars["meter_reading_source"]["output"]
  status?: Maybe<Scalars["meter_reading_status"]["output"]>
  submission_processed: Scalars["Boolean"]["output"]
  unit: Scalars["meter_reading_unit"]["output"]
  updated_at: Scalars["timestamp"]["output"]
  workflow_status?: Maybe<Scalars["meter_reading_workflow_status"]["output"]>
}

/** aggregated selection of "meter_reading" */
export type Meter_Reading_Aggregate = {
  __typename?: "meter_reading_aggregate"
  aggregate?: Maybe<Meter_Reading_Aggregate_Fields>
  nodes: Array<Meter_Reading>
}

export type Meter_Reading_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Meter_Reading_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Meter_Reading_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<Meter_Reading_Aggregate_Bool_Exp_Count>
}

export type Meter_Reading_Aggregate_Bool_Exp_Bool_And = {
  arguments: Meter_Reading_Select_Column_Meter_Reading_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Meter_Reading_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Meter_Reading_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Meter_Reading_Select_Column_Meter_Reading_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Meter_Reading_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Meter_Reading_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Meter_Reading_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Meter_Reading_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "meter_reading" */
export type Meter_Reading_Aggregate_Fields = {
  __typename?: "meter_reading_aggregate_fields"
  avg?: Maybe<Meter_Reading_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Meter_Reading_Max_Fields>
  min?: Maybe<Meter_Reading_Min_Fields>
  stddev?: Maybe<Meter_Reading_Stddev_Fields>
  stddev_pop?: Maybe<Meter_Reading_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Meter_Reading_Stddev_Samp_Fields>
  sum?: Maybe<Meter_Reading_Sum_Fields>
  var_pop?: Maybe<Meter_Reading_Var_Pop_Fields>
  var_samp?: Maybe<Meter_Reading_Var_Samp_Fields>
  variance?: Maybe<Meter_Reading_Variance_Fields>
}

/** aggregate fields of "meter_reading" */
export type Meter_Reading_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Meter_Reading_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "meter_reading" */
export type Meter_Reading_Aggregate_Order_By = {
  avg?: InputMaybe<Meter_Reading_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Meter_Reading_Max_Order_By>
  min?: InputMaybe<Meter_Reading_Min_Order_By>
  stddev?: InputMaybe<Meter_Reading_Stddev_Order_By>
  stddev_pop?: InputMaybe<Meter_Reading_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Meter_Reading_Stddev_Samp_Order_By>
  sum?: InputMaybe<Meter_Reading_Sum_Order_By>
  var_pop?: InputMaybe<Meter_Reading_Var_Pop_Order_By>
  var_samp?: InputMaybe<Meter_Reading_Var_Samp_Order_By>
  variance?: InputMaybe<Meter_Reading_Variance_Order_By>
}

/** input type for inserting array relation for remote table "meter_reading" */
export type Meter_Reading_Arr_Rel_Insert_Input = {
  data: Array<Meter_Reading_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Meter_Reading_On_Conflict>
}

/** aggregate avg on columns */
export type Meter_Reading_Avg_Fields = {
  __typename?: "meter_reading_avg_fields"
  consumption?: Maybe<Scalars["Float"]["output"]>
  cumulative?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
  register_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "meter_reading" */
export type Meter_Reading_Avg_Order_By = {
  consumption?: InputMaybe<Order_By>
  cumulative?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  register_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "meter_reading". All fields are combined with a logical 'AND'. */
export type Meter_Reading_Bool_Exp = {
  _and?: InputMaybe<Array<Meter_Reading_Bool_Exp>>
  _not?: InputMaybe<Meter_Reading_Bool_Exp>
  _or?: InputMaybe<Array<Meter_Reading_Bool_Exp>>
  consumption?: InputMaybe<Numeric_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  cumulative?: InputMaybe<Numeric_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  error_description?: InputMaybe<String_Comparison_Exp>
  from_dttm?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  meter_id?: InputMaybe<Bigint_Comparison_Exp>
  meter_point?: InputMaybe<Meter_Point_Bool_Exp>
  meter_point_id?: InputMaybe<Bigint_Comparison_Exp>
  pending_register_reading_id?: InputMaybe<String_Comparison_Exp>
  quality?: InputMaybe<Meter_Reading_Quality_Comparison_Exp>
  rate_name?: InputMaybe<String_Comparison_Exp>
  reading_dttm?: InputMaybe<Timestamp_Comparison_Exp>
  register?: InputMaybe<Register_Bool_Exp>
  register_id?: InputMaybe<Bigint_Comparison_Exp>
  sequence_type?: InputMaybe<Meter_Reading_Sequence_Type_Comparison_Exp>
  source?: InputMaybe<Meter_Reading_Source_Comparison_Exp>
  status?: InputMaybe<Meter_Reading_Status_Comparison_Exp>
  submission_processed?: InputMaybe<Boolean_Comparison_Exp>
  unit?: InputMaybe<Meter_Reading_Unit_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  workflow_status?: InputMaybe<Meter_Reading_Workflow_Status_Comparison_Exp>
}

/** unique or primary key constraints on table "meter_reading" */
export enum Meter_Reading_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkMeterReading = "pk_meter_reading",
}

/** Boolean expression to compare columns of type "meter_reading_fuel". All fields are combined with logical 'AND'. */
export type Meter_Reading_Fuel_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["meter_reading_fuel"]["input"]>
  _gt?: InputMaybe<Scalars["meter_reading_fuel"]["input"]>
  _gte?: InputMaybe<Scalars["meter_reading_fuel"]["input"]>
  _in?: InputMaybe<Array<Scalars["meter_reading_fuel"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["meter_reading_fuel"]["input"]>
  _lte?: InputMaybe<Scalars["meter_reading_fuel"]["input"]>
  _neq?: InputMaybe<Scalars["meter_reading_fuel"]["input"]>
  _nin?: InputMaybe<Array<Scalars["meter_reading_fuel"]["input"]>>
}

/** input type for incrementing numeric columns in table "meter_reading" */
export type Meter_Reading_Inc_Input = {
  consumption?: InputMaybe<Scalars["numeric"]["input"]>
  cumulative?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  register_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "meter_reading" */
export type Meter_Reading_Insert_Input = {
  consumption?: InputMaybe<Scalars["numeric"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  cumulative?: InputMaybe<Scalars["numeric"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  error_description?: InputMaybe<Scalars["String"]["input"]>
  from_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point?: InputMaybe<Meter_Point_Obj_Rel_Insert_Input>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  pending_register_reading_id?: InputMaybe<Scalars["String"]["input"]>
  quality?: InputMaybe<Scalars["meter_reading_quality"]["input"]>
  rate_name?: InputMaybe<Scalars["String"]["input"]>
  reading_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  register?: InputMaybe<Register_Obj_Rel_Insert_Input>
  register_id?: InputMaybe<Scalars["bigint"]["input"]>
  sequence_type?: InputMaybe<Scalars["meter_reading_sequence_type"]["input"]>
  source?: InputMaybe<Scalars["meter_reading_source"]["input"]>
  status?: InputMaybe<Scalars["meter_reading_status"]["input"]>
  submission_processed?: InputMaybe<Scalars["Boolean"]["input"]>
  unit?: InputMaybe<Scalars["meter_reading_unit"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  workflow_status?: InputMaybe<
    Scalars["meter_reading_workflow_status"]["input"]
  >
}

/** aggregate max on columns */
export type Meter_Reading_Max_Fields = {
  __typename?: "meter_reading_max_fields"
  consumption?: Maybe<Scalars["numeric"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  cumulative?: Maybe<Scalars["numeric"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  error_description?: Maybe<Scalars["String"]["output"]>
  from_dttm?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["bigint"]["output"]>
  pending_register_reading_id?: Maybe<Scalars["String"]["output"]>
  quality?: Maybe<Scalars["meter_reading_quality"]["output"]>
  rate_name?: Maybe<Scalars["String"]["output"]>
  reading_dttm?: Maybe<Scalars["timestamp"]["output"]>
  register_id?: Maybe<Scalars["bigint"]["output"]>
  sequence_type?: Maybe<Scalars["meter_reading_sequence_type"]["output"]>
  source?: Maybe<Scalars["meter_reading_source"]["output"]>
  status?: Maybe<Scalars["meter_reading_status"]["output"]>
  unit?: Maybe<Scalars["meter_reading_unit"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  workflow_status?: Maybe<Scalars["meter_reading_workflow_status"]["output"]>
}

/** order by max() on columns of table "meter_reading" */
export type Meter_Reading_Max_Order_By = {
  consumption?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  cumulative?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  error_description?: InputMaybe<Order_By>
  from_dttm?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  pending_register_reading_id?: InputMaybe<Order_By>
  quality?: InputMaybe<Order_By>
  rate_name?: InputMaybe<Order_By>
  reading_dttm?: InputMaybe<Order_By>
  register_id?: InputMaybe<Order_By>
  sequence_type?: InputMaybe<Order_By>
  source?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  unit?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  workflow_status?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Meter_Reading_Min_Fields = {
  __typename?: "meter_reading_min_fields"
  consumption?: Maybe<Scalars["numeric"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  cumulative?: Maybe<Scalars["numeric"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  error_description?: Maybe<Scalars["String"]["output"]>
  from_dttm?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["bigint"]["output"]>
  pending_register_reading_id?: Maybe<Scalars["String"]["output"]>
  quality?: Maybe<Scalars["meter_reading_quality"]["output"]>
  rate_name?: Maybe<Scalars["String"]["output"]>
  reading_dttm?: Maybe<Scalars["timestamp"]["output"]>
  register_id?: Maybe<Scalars["bigint"]["output"]>
  sequence_type?: Maybe<Scalars["meter_reading_sequence_type"]["output"]>
  source?: Maybe<Scalars["meter_reading_source"]["output"]>
  status?: Maybe<Scalars["meter_reading_status"]["output"]>
  unit?: Maybe<Scalars["meter_reading_unit"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  workflow_status?: Maybe<Scalars["meter_reading_workflow_status"]["output"]>
}

/** order by min() on columns of table "meter_reading" */
export type Meter_Reading_Min_Order_By = {
  consumption?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  cumulative?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  error_description?: InputMaybe<Order_By>
  from_dttm?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  pending_register_reading_id?: InputMaybe<Order_By>
  quality?: InputMaybe<Order_By>
  rate_name?: InputMaybe<Order_By>
  reading_dttm?: InputMaybe<Order_By>
  register_id?: InputMaybe<Order_By>
  sequence_type?: InputMaybe<Order_By>
  source?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  unit?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  workflow_status?: InputMaybe<Order_By>
}

/** response of any mutation on the table "meter_reading" */
export type Meter_Reading_Mutation_Response = {
  __typename?: "meter_reading_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Meter_Reading>
}

/** on_conflict condition type for table "meter_reading" */
export type Meter_Reading_On_Conflict = {
  constraint: Meter_Reading_Constraint
  update_columns?: Array<Meter_Reading_Update_Column>
  where?: InputMaybe<Meter_Reading_Bool_Exp>
}

/** Ordering options when selecting data from "meter_reading". */
export type Meter_Reading_Order_By = {
  consumption?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  cumulative?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  error_description?: InputMaybe<Order_By>
  from_dttm?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  meter_point?: InputMaybe<Meter_Point_Order_By>
  meter_point_id?: InputMaybe<Order_By>
  pending_register_reading_id?: InputMaybe<Order_By>
  quality?: InputMaybe<Order_By>
  rate_name?: InputMaybe<Order_By>
  reading_dttm?: InputMaybe<Order_By>
  register?: InputMaybe<Register_Order_By>
  register_id?: InputMaybe<Order_By>
  sequence_type?: InputMaybe<Order_By>
  source?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  submission_processed?: InputMaybe<Order_By>
  unit?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  workflow_status?: InputMaybe<Order_By>
}

/** primary key columns input for table: meter_reading */
export type Meter_Reading_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** Boolean expression to compare columns of type "meter_reading_quality". All fields are combined with logical 'AND'. */
export type Meter_Reading_Quality_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["meter_reading_quality"]["input"]>
  _gt?: InputMaybe<Scalars["meter_reading_quality"]["input"]>
  _gte?: InputMaybe<Scalars["meter_reading_quality"]["input"]>
  _in?: InputMaybe<Array<Scalars["meter_reading_quality"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["meter_reading_quality"]["input"]>
  _lte?: InputMaybe<Scalars["meter_reading_quality"]["input"]>
  _neq?: InputMaybe<Scalars["meter_reading_quality"]["input"]>
  _nin?: InputMaybe<Array<Scalars["meter_reading_quality"]["input"]>>
}

/** select columns of table "meter_reading" */
export enum Meter_Reading_Select_Column {
  /** column name */
  Consumption = "consumption",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Cumulative = "cumulative",
  /** column name */
  Deleted = "deleted",
  /** column name */
  ErrorDescription = "error_description",
  /** column name */
  FromDttm = "from_dttm",
  /** column name */
  Id = "id",
  /** column name */
  MeterId = "meter_id",
  /** column name */
  MeterPointId = "meter_point_id",
  /** column name */
  PendingRegisterReadingId = "pending_register_reading_id",
  /** column name */
  Quality = "quality",
  /** column name */
  RateName = "rate_name",
  /** column name */
  ReadingDttm = "reading_dttm",
  /** column name */
  RegisterId = "register_id",
  /** column name */
  SequenceType = "sequence_type",
  /** column name */
  Source = "source",
  /** column name */
  Status = "status",
  /** column name */
  SubmissionProcessed = "submission_processed",
  /** column name */
  Unit = "unit",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  WorkflowStatus = "workflow_status",
}

/** select "meter_reading_aggregate_bool_exp_bool_and_arguments_columns" columns of table "meter_reading" */
export enum Meter_Reading_Select_Column_Meter_Reading_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  SubmissionProcessed = "submission_processed",
}

/** select "meter_reading_aggregate_bool_exp_bool_or_arguments_columns" columns of table "meter_reading" */
export enum Meter_Reading_Select_Column_Meter_Reading_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  SubmissionProcessed = "submission_processed",
}

/** Boolean expression to compare columns of type "meter_reading_sequence_type". All fields are combined with logical 'AND'. */
export type Meter_Reading_Sequence_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["meter_reading_sequence_type"]["input"]>
  _gt?: InputMaybe<Scalars["meter_reading_sequence_type"]["input"]>
  _gte?: InputMaybe<Scalars["meter_reading_sequence_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["meter_reading_sequence_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["meter_reading_sequence_type"]["input"]>
  _lte?: InputMaybe<Scalars["meter_reading_sequence_type"]["input"]>
  _neq?: InputMaybe<Scalars["meter_reading_sequence_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["meter_reading_sequence_type"]["input"]>>
}

/** input type for updating data in table "meter_reading" */
export type Meter_Reading_Set_Input = {
  consumption?: InputMaybe<Scalars["numeric"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  cumulative?: InputMaybe<Scalars["numeric"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  error_description?: InputMaybe<Scalars["String"]["input"]>
  from_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  pending_register_reading_id?: InputMaybe<Scalars["String"]["input"]>
  quality?: InputMaybe<Scalars["meter_reading_quality"]["input"]>
  rate_name?: InputMaybe<Scalars["String"]["input"]>
  reading_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  register_id?: InputMaybe<Scalars["bigint"]["input"]>
  sequence_type?: InputMaybe<Scalars["meter_reading_sequence_type"]["input"]>
  source?: InputMaybe<Scalars["meter_reading_source"]["input"]>
  status?: InputMaybe<Scalars["meter_reading_status"]["input"]>
  submission_processed?: InputMaybe<Scalars["Boolean"]["input"]>
  unit?: InputMaybe<Scalars["meter_reading_unit"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  workflow_status?: InputMaybe<
    Scalars["meter_reading_workflow_status"]["input"]
  >
}

/** Boolean expression to compare columns of type "meter_reading_source". All fields are combined with logical 'AND'. */
export type Meter_Reading_Source_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["meter_reading_source"]["input"]>
  _gt?: InputMaybe<Scalars["meter_reading_source"]["input"]>
  _gte?: InputMaybe<Scalars["meter_reading_source"]["input"]>
  _in?: InputMaybe<Array<Scalars["meter_reading_source"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["meter_reading_source"]["input"]>
  _lte?: InputMaybe<Scalars["meter_reading_source"]["input"]>
  _neq?: InputMaybe<Scalars["meter_reading_source"]["input"]>
  _nin?: InputMaybe<Array<Scalars["meter_reading_source"]["input"]>>
}

/** Boolean expression to compare columns of type "meter_reading_status". All fields are combined with logical 'AND'. */
export type Meter_Reading_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["meter_reading_status"]["input"]>
  _gt?: InputMaybe<Scalars["meter_reading_status"]["input"]>
  _gte?: InputMaybe<Scalars["meter_reading_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["meter_reading_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["meter_reading_status"]["input"]>
  _lte?: InputMaybe<Scalars["meter_reading_status"]["input"]>
  _neq?: InputMaybe<Scalars["meter_reading_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["meter_reading_status"]["input"]>>
}

/** aggregate stddev on columns */
export type Meter_Reading_Stddev_Fields = {
  __typename?: "meter_reading_stddev_fields"
  consumption?: Maybe<Scalars["Float"]["output"]>
  cumulative?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
  register_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "meter_reading" */
export type Meter_Reading_Stddev_Order_By = {
  consumption?: InputMaybe<Order_By>
  cumulative?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  register_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Meter_Reading_Stddev_Pop_Fields = {
  __typename?: "meter_reading_stddev_pop_fields"
  consumption?: Maybe<Scalars["Float"]["output"]>
  cumulative?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
  register_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "meter_reading" */
export type Meter_Reading_Stddev_Pop_Order_By = {
  consumption?: InputMaybe<Order_By>
  cumulative?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  register_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Meter_Reading_Stddev_Samp_Fields = {
  __typename?: "meter_reading_stddev_samp_fields"
  consumption?: Maybe<Scalars["Float"]["output"]>
  cumulative?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
  register_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "meter_reading" */
export type Meter_Reading_Stddev_Samp_Order_By = {
  consumption?: InputMaybe<Order_By>
  cumulative?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  register_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "meter_reading" */
export type Meter_Reading_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Meter_Reading_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Meter_Reading_Stream_Cursor_Value_Input = {
  consumption?: InputMaybe<Scalars["numeric"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  cumulative?: InputMaybe<Scalars["numeric"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  error_description?: InputMaybe<Scalars["String"]["input"]>
  from_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  pending_register_reading_id?: InputMaybe<Scalars["String"]["input"]>
  quality?: InputMaybe<Scalars["meter_reading_quality"]["input"]>
  rate_name?: InputMaybe<Scalars["String"]["input"]>
  reading_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  register_id?: InputMaybe<Scalars["bigint"]["input"]>
  sequence_type?: InputMaybe<Scalars["meter_reading_sequence_type"]["input"]>
  source?: InputMaybe<Scalars["meter_reading_source"]["input"]>
  status?: InputMaybe<Scalars["meter_reading_status"]["input"]>
  submission_processed?: InputMaybe<Scalars["Boolean"]["input"]>
  unit?: InputMaybe<Scalars["meter_reading_unit"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  workflow_status?: InputMaybe<
    Scalars["meter_reading_workflow_status"]["input"]
  >
}

/** columns and relationships of "meter_reading_submission_request" */
export type Meter_Reading_Submission_Request = {
  __typename?: "meter_reading_submission_request"
  account_number?: Maybe<Scalars["String"]["output"]>
  comment?: Maybe<Scalars["String"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  debug_data?: Maybe<Scalars["json"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  failed_attempts?: Maybe<Scalars["Int"]["output"]>
  id: Scalars["bigint"]["output"]
  junifer_status?: Maybe<Scalars["meter_reading_status"]["output"]>
  last_attempt?: Maybe<Scalars["timestamp"]["output"]>
  meter_point_identifier?: Maybe<Scalars["String"]["output"]>
  meterpoint_id: Scalars["bigint"]["output"]
  status: Scalars["meter_reading_submission_request_status"]["output"]
  submission_data: Scalars["json"]["output"]
  submission_source?: Maybe<
    Scalars["meter_reading_submission_source"]["output"]
  >
  submission_values: Scalars["json"]["output"]
  updated_at: Scalars["timestamp"]["output"]
  user_email?: Maybe<Scalars["String"]["output"]>
}

/** columns and relationships of "meter_reading_submission_request" */
export type Meter_Reading_Submission_RequestDebug_DataArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** columns and relationships of "meter_reading_submission_request" */
export type Meter_Reading_Submission_RequestSubmission_DataArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** columns and relationships of "meter_reading_submission_request" */
export type Meter_Reading_Submission_RequestSubmission_ValuesArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregated selection of "meter_reading_submission_request" */
export type Meter_Reading_Submission_Request_Aggregate = {
  __typename?: "meter_reading_submission_request_aggregate"
  aggregate?: Maybe<Meter_Reading_Submission_Request_Aggregate_Fields>
  nodes: Array<Meter_Reading_Submission_Request>
}

/** aggregate fields of "meter_reading_submission_request" */
export type Meter_Reading_Submission_Request_Aggregate_Fields = {
  __typename?: "meter_reading_submission_request_aggregate_fields"
  avg?: Maybe<Meter_Reading_Submission_Request_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Meter_Reading_Submission_Request_Max_Fields>
  min?: Maybe<Meter_Reading_Submission_Request_Min_Fields>
  stddev?: Maybe<Meter_Reading_Submission_Request_Stddev_Fields>
  stddev_pop?: Maybe<Meter_Reading_Submission_Request_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Meter_Reading_Submission_Request_Stddev_Samp_Fields>
  sum?: Maybe<Meter_Reading_Submission_Request_Sum_Fields>
  var_pop?: Maybe<Meter_Reading_Submission_Request_Var_Pop_Fields>
  var_samp?: Maybe<Meter_Reading_Submission_Request_Var_Samp_Fields>
  variance?: Maybe<Meter_Reading_Submission_Request_Variance_Fields>
}

/** aggregate fields of "meter_reading_submission_request" */
export type Meter_Reading_Submission_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Meter_Reading_Submission_Request_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Meter_Reading_Submission_Request_Avg_Fields = {
  __typename?: "meter_reading_submission_request_avg_fields"
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meterpoint_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "meter_reading_submission_request". All fields are combined with a logical 'AND'. */
export type Meter_Reading_Submission_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Meter_Reading_Submission_Request_Bool_Exp>>
  _not?: InputMaybe<Meter_Reading_Submission_Request_Bool_Exp>
  _or?: InputMaybe<Array<Meter_Reading_Submission_Request_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  comment?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  debug_data?: InputMaybe<Json_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  failed_attempts?: InputMaybe<Int_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  junifer_status?: InputMaybe<Meter_Reading_Status_Comparison_Exp>
  last_attempt?: InputMaybe<Timestamp_Comparison_Exp>
  meter_point_identifier?: InputMaybe<String_Comparison_Exp>
  meterpoint_id?: InputMaybe<Bigint_Comparison_Exp>
  status?: InputMaybe<Meter_Reading_Submission_Request_Status_Comparison_Exp>
  submission_data?: InputMaybe<Json_Comparison_Exp>
  submission_source?: InputMaybe<Meter_Reading_Submission_Source_Comparison_Exp>
  submission_values?: InputMaybe<Json_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  user_email?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "meter_reading_submission_request" */
export enum Meter_Reading_Submission_Request_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkMeterReadingSubmissionRequest = "pk_meter_reading_submission_request",
}

/** input type for incrementing numeric columns in table "meter_reading_submission_request" */
export type Meter_Reading_Submission_Request_Inc_Input = {
  failed_attempts?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meterpoint_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "meter_reading_submission_request" */
export type Meter_Reading_Submission_Request_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  comment?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  debug_data?: InputMaybe<Scalars["json"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  failed_attempts?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_status?: InputMaybe<Scalars["meter_reading_status"]["input"]>
  last_attempt?: InputMaybe<Scalars["timestamp"]["input"]>
  meter_point_identifier?: InputMaybe<Scalars["String"]["input"]>
  meterpoint_id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<
    Scalars["meter_reading_submission_request_status"]["input"]
  >
  submission_data?: InputMaybe<Scalars["json"]["input"]>
  submission_source?: InputMaybe<
    Scalars["meter_reading_submission_source"]["input"]
  >
  submission_values?: InputMaybe<Scalars["json"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  user_email?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Meter_Reading_Submission_Request_Max_Fields = {
  __typename?: "meter_reading_submission_request_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  comment?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  failed_attempts?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_status?: Maybe<Scalars["meter_reading_status"]["output"]>
  last_attempt?: Maybe<Scalars["timestamp"]["output"]>
  meter_point_identifier?: Maybe<Scalars["String"]["output"]>
  meterpoint_id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["meter_reading_submission_request_status"]["output"]>
  submission_source?: Maybe<
    Scalars["meter_reading_submission_source"]["output"]
  >
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  user_email?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Meter_Reading_Submission_Request_Min_Fields = {
  __typename?: "meter_reading_submission_request_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  comment?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  failed_attempts?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_status?: Maybe<Scalars["meter_reading_status"]["output"]>
  last_attempt?: Maybe<Scalars["timestamp"]["output"]>
  meter_point_identifier?: Maybe<Scalars["String"]["output"]>
  meterpoint_id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["meter_reading_submission_request_status"]["output"]>
  submission_source?: Maybe<
    Scalars["meter_reading_submission_source"]["output"]
  >
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  user_email?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "meter_reading_submission_request" */
export type Meter_Reading_Submission_Request_Mutation_Response = {
  __typename?: "meter_reading_submission_request_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Meter_Reading_Submission_Request>
}

/** on_conflict condition type for table "meter_reading_submission_request" */
export type Meter_Reading_Submission_Request_On_Conflict = {
  constraint: Meter_Reading_Submission_Request_Constraint
  update_columns?: Array<Meter_Reading_Submission_Request_Update_Column>
  where?: InputMaybe<Meter_Reading_Submission_Request_Bool_Exp>
}

/** Ordering options when selecting data from "meter_reading_submission_request". */
export type Meter_Reading_Submission_Request_Order_By = {
  account_number?: InputMaybe<Order_By>
  comment?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  debug_data?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  failed_attempts?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  junifer_status?: InputMaybe<Order_By>
  last_attempt?: InputMaybe<Order_By>
  meter_point_identifier?: InputMaybe<Order_By>
  meterpoint_id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  submission_data?: InputMaybe<Order_By>
  submission_source?: InputMaybe<Order_By>
  submission_values?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_email?: InputMaybe<Order_By>
}

/** primary key columns input for table: meter_reading_submission_request */
export type Meter_Reading_Submission_Request_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "meter_reading_submission_request" */
export enum Meter_Reading_Submission_Request_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  Comment = "comment",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DebugData = "debug_data",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FailedAttempts = "failed_attempts",
  /** column name */
  Id = "id",
  /** column name */
  JuniferStatus = "junifer_status",
  /** column name */
  LastAttempt = "last_attempt",
  /** column name */
  MeterPointIdentifier = "meter_point_identifier",
  /** column name */
  MeterpointId = "meterpoint_id",
  /** column name */
  Status = "status",
  /** column name */
  SubmissionData = "submission_data",
  /** column name */
  SubmissionSource = "submission_source",
  /** column name */
  SubmissionValues = "submission_values",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  UserEmail = "user_email",
}

/** input type for updating data in table "meter_reading_submission_request" */
export type Meter_Reading_Submission_Request_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  comment?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  debug_data?: InputMaybe<Scalars["json"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  failed_attempts?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_status?: InputMaybe<Scalars["meter_reading_status"]["input"]>
  last_attempt?: InputMaybe<Scalars["timestamp"]["input"]>
  meter_point_identifier?: InputMaybe<Scalars["String"]["input"]>
  meterpoint_id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<
    Scalars["meter_reading_submission_request_status"]["input"]
  >
  submission_data?: InputMaybe<Scalars["json"]["input"]>
  submission_source?: InputMaybe<
    Scalars["meter_reading_submission_source"]["input"]
  >
  submission_values?: InputMaybe<Scalars["json"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  user_email?: InputMaybe<Scalars["String"]["input"]>
}

/** Boolean expression to compare columns of type "meter_reading_submission_request_status". All fields are combined with logical 'AND'. */
export type Meter_Reading_Submission_Request_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["meter_reading_submission_request_status"]["input"]>
  _gt?: InputMaybe<Scalars["meter_reading_submission_request_status"]["input"]>
  _gte?: InputMaybe<Scalars["meter_reading_submission_request_status"]["input"]>
  _in?: InputMaybe<
    Array<Scalars["meter_reading_submission_request_status"]["input"]>
  >
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["meter_reading_submission_request_status"]["input"]>
  _lte?: InputMaybe<Scalars["meter_reading_submission_request_status"]["input"]>
  _neq?: InputMaybe<Scalars["meter_reading_submission_request_status"]["input"]>
  _nin?: InputMaybe<
    Array<Scalars["meter_reading_submission_request_status"]["input"]>
  >
}

/** aggregate stddev on columns */
export type Meter_Reading_Submission_Request_Stddev_Fields = {
  __typename?: "meter_reading_submission_request_stddev_fields"
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meterpoint_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Meter_Reading_Submission_Request_Stddev_Pop_Fields = {
  __typename?: "meter_reading_submission_request_stddev_pop_fields"
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meterpoint_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Meter_Reading_Submission_Request_Stddev_Samp_Fields = {
  __typename?: "meter_reading_submission_request_stddev_samp_fields"
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meterpoint_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "meter_reading_submission_request" */
export type Meter_Reading_Submission_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Meter_Reading_Submission_Request_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Meter_Reading_Submission_Request_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  comment?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  debug_data?: InputMaybe<Scalars["json"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  failed_attempts?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_status?: InputMaybe<Scalars["meter_reading_status"]["input"]>
  last_attempt?: InputMaybe<Scalars["timestamp"]["input"]>
  meter_point_identifier?: InputMaybe<Scalars["String"]["input"]>
  meterpoint_id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<
    Scalars["meter_reading_submission_request_status"]["input"]
  >
  submission_data?: InputMaybe<Scalars["json"]["input"]>
  submission_source?: InputMaybe<
    Scalars["meter_reading_submission_source"]["input"]
  >
  submission_values?: InputMaybe<Scalars["json"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  user_email?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Meter_Reading_Submission_Request_Sum_Fields = {
  __typename?: "meter_reading_submission_request_sum_fields"
  failed_attempts?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meterpoint_id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "meter_reading_submission_request" */
export enum Meter_Reading_Submission_Request_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  Comment = "comment",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DebugData = "debug_data",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FailedAttempts = "failed_attempts",
  /** column name */
  Id = "id",
  /** column name */
  JuniferStatus = "junifer_status",
  /** column name */
  LastAttempt = "last_attempt",
  /** column name */
  MeterPointIdentifier = "meter_point_identifier",
  /** column name */
  MeterpointId = "meterpoint_id",
  /** column name */
  Status = "status",
  /** column name */
  SubmissionData = "submission_data",
  /** column name */
  SubmissionSource = "submission_source",
  /** column name */
  SubmissionValues = "submission_values",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  UserEmail = "user_email",
}

export type Meter_Reading_Submission_Request_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Meter_Reading_Submission_Request_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Meter_Reading_Submission_Request_Set_Input>
  /** filter the rows which have to be updated */
  where: Meter_Reading_Submission_Request_Bool_Exp
}

/** aggregate var_pop on columns */
export type Meter_Reading_Submission_Request_Var_Pop_Fields = {
  __typename?: "meter_reading_submission_request_var_pop_fields"
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meterpoint_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Meter_Reading_Submission_Request_Var_Samp_Fields = {
  __typename?: "meter_reading_submission_request_var_samp_fields"
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meterpoint_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Meter_Reading_Submission_Request_Variance_Fields = {
  __typename?: "meter_reading_submission_request_variance_fields"
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meterpoint_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "meter_reading_submission_source". All fields are combined with logical 'AND'. */
export type Meter_Reading_Submission_Source_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["meter_reading_submission_source"]["input"]>
  _gt?: InputMaybe<Scalars["meter_reading_submission_source"]["input"]>
  _gte?: InputMaybe<Scalars["meter_reading_submission_source"]["input"]>
  _in?: InputMaybe<Array<Scalars["meter_reading_submission_source"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["meter_reading_submission_source"]["input"]>
  _lte?: InputMaybe<Scalars["meter_reading_submission_source"]["input"]>
  _neq?: InputMaybe<Scalars["meter_reading_submission_source"]["input"]>
  _nin?: InputMaybe<Array<Scalars["meter_reading_submission_source"]["input"]>>
}

/** columns and relationships of "meter_reading_submission_tokens" */
export type Meter_Reading_Submission_Tokens = {
  __typename?: "meter_reading_submission_tokens"
  hashed_token: Scalars["String"]["output"]
  junifer_account_id: Scalars["Int"]["output"]
  token_expiry: Scalars["timestamp"]["output"]
  token_generated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "meter_reading_submission_tokens" */
export type Meter_Reading_Submission_Tokens_Aggregate = {
  __typename?: "meter_reading_submission_tokens_aggregate"
  aggregate?: Maybe<Meter_Reading_Submission_Tokens_Aggregate_Fields>
  nodes: Array<Meter_Reading_Submission_Tokens>
}

/** aggregate fields of "meter_reading_submission_tokens" */
export type Meter_Reading_Submission_Tokens_Aggregate_Fields = {
  __typename?: "meter_reading_submission_tokens_aggregate_fields"
  avg?: Maybe<Meter_Reading_Submission_Tokens_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Meter_Reading_Submission_Tokens_Max_Fields>
  min?: Maybe<Meter_Reading_Submission_Tokens_Min_Fields>
  stddev?: Maybe<Meter_Reading_Submission_Tokens_Stddev_Fields>
  stddev_pop?: Maybe<Meter_Reading_Submission_Tokens_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Meter_Reading_Submission_Tokens_Stddev_Samp_Fields>
  sum?: Maybe<Meter_Reading_Submission_Tokens_Sum_Fields>
  var_pop?: Maybe<Meter_Reading_Submission_Tokens_Var_Pop_Fields>
  var_samp?: Maybe<Meter_Reading_Submission_Tokens_Var_Samp_Fields>
  variance?: Maybe<Meter_Reading_Submission_Tokens_Variance_Fields>
}

/** aggregate fields of "meter_reading_submission_tokens" */
export type Meter_Reading_Submission_Tokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Meter_Reading_Submission_Tokens_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Meter_Reading_Submission_Tokens_Avg_Fields = {
  __typename?: "meter_reading_submission_tokens_avg_fields"
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "meter_reading_submission_tokens". All fields are combined with a logical 'AND'. */
export type Meter_Reading_Submission_Tokens_Bool_Exp = {
  _and?: InputMaybe<Array<Meter_Reading_Submission_Tokens_Bool_Exp>>
  _not?: InputMaybe<Meter_Reading_Submission_Tokens_Bool_Exp>
  _or?: InputMaybe<Array<Meter_Reading_Submission_Tokens_Bool_Exp>>
  hashed_token?: InputMaybe<String_Comparison_Exp>
  junifer_account_id?: InputMaybe<Int_Comparison_Exp>
  token_expiry?: InputMaybe<Timestamp_Comparison_Exp>
  token_generated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "meter_reading_submission_tokens" */
export enum Meter_Reading_Submission_Tokens_Constraint {
  /** unique or primary key constraint on columns "hashed_token" */
  MeterReadingSubmissionTokensHashedTokenKey = "meter_reading_submission_tokens_hashed_token_key",
  /** unique or primary key constraint on columns "junifer_account_id", "hashed_token" */
  MeterReadingSubmissionTokensPkey = "meter_reading_submission_tokens_pkey",
}

/** input type for incrementing numeric columns in table "meter_reading_submission_tokens" */
export type Meter_Reading_Submission_Tokens_Inc_Input = {
  junifer_account_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "meter_reading_submission_tokens" */
export type Meter_Reading_Submission_Tokens_Insert_Input = {
  hashed_token?: InputMaybe<Scalars["String"]["input"]>
  junifer_account_id?: InputMaybe<Scalars["Int"]["input"]>
  token_expiry?: InputMaybe<Scalars["timestamp"]["input"]>
  token_generated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Meter_Reading_Submission_Tokens_Max_Fields = {
  __typename?: "meter_reading_submission_tokens_max_fields"
  hashed_token?: Maybe<Scalars["String"]["output"]>
  junifer_account_id?: Maybe<Scalars["Int"]["output"]>
  token_expiry?: Maybe<Scalars["timestamp"]["output"]>
  token_generated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Meter_Reading_Submission_Tokens_Min_Fields = {
  __typename?: "meter_reading_submission_tokens_min_fields"
  hashed_token?: Maybe<Scalars["String"]["output"]>
  junifer_account_id?: Maybe<Scalars["Int"]["output"]>
  token_expiry?: Maybe<Scalars["timestamp"]["output"]>
  token_generated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "meter_reading_submission_tokens" */
export type Meter_Reading_Submission_Tokens_Mutation_Response = {
  __typename?: "meter_reading_submission_tokens_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Meter_Reading_Submission_Tokens>
}

/** on_conflict condition type for table "meter_reading_submission_tokens" */
export type Meter_Reading_Submission_Tokens_On_Conflict = {
  constraint: Meter_Reading_Submission_Tokens_Constraint
  update_columns?: Array<Meter_Reading_Submission_Tokens_Update_Column>
  where?: InputMaybe<Meter_Reading_Submission_Tokens_Bool_Exp>
}

/** Ordering options when selecting data from "meter_reading_submission_tokens". */
export type Meter_Reading_Submission_Tokens_Order_By = {
  hashed_token?: InputMaybe<Order_By>
  junifer_account_id?: InputMaybe<Order_By>
  token_expiry?: InputMaybe<Order_By>
  token_generated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: meter_reading_submission_tokens */
export type Meter_Reading_Submission_Tokens_Pk_Columns_Input = {
  hashed_token: Scalars["String"]["input"]
  junifer_account_id: Scalars["Int"]["input"]
}

/** select columns of table "meter_reading_submission_tokens" */
export enum Meter_Reading_Submission_Tokens_Select_Column {
  /** column name */
  HashedToken = "hashed_token",
  /** column name */
  JuniferAccountId = "junifer_account_id",
  /** column name */
  TokenExpiry = "token_expiry",
  /** column name */
  TokenGeneratedAt = "token_generated_at",
}

/** input type for updating data in table "meter_reading_submission_tokens" */
export type Meter_Reading_Submission_Tokens_Set_Input = {
  hashed_token?: InputMaybe<Scalars["String"]["input"]>
  junifer_account_id?: InputMaybe<Scalars["Int"]["input"]>
  token_expiry?: InputMaybe<Scalars["timestamp"]["input"]>
  token_generated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Meter_Reading_Submission_Tokens_Stddev_Fields = {
  __typename?: "meter_reading_submission_tokens_stddev_fields"
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Meter_Reading_Submission_Tokens_Stddev_Pop_Fields = {
  __typename?: "meter_reading_submission_tokens_stddev_pop_fields"
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Meter_Reading_Submission_Tokens_Stddev_Samp_Fields = {
  __typename?: "meter_reading_submission_tokens_stddev_samp_fields"
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "meter_reading_submission_tokens" */
export type Meter_Reading_Submission_Tokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Meter_Reading_Submission_Tokens_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Meter_Reading_Submission_Tokens_Stream_Cursor_Value_Input = {
  hashed_token?: InputMaybe<Scalars["String"]["input"]>
  junifer_account_id?: InputMaybe<Scalars["Int"]["input"]>
  token_expiry?: InputMaybe<Scalars["timestamp"]["input"]>
  token_generated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Meter_Reading_Submission_Tokens_Sum_Fields = {
  __typename?: "meter_reading_submission_tokens_sum_fields"
  junifer_account_id?: Maybe<Scalars["Int"]["output"]>
}

/** update columns of table "meter_reading_submission_tokens" */
export enum Meter_Reading_Submission_Tokens_Update_Column {
  /** column name */
  HashedToken = "hashed_token",
  /** column name */
  JuniferAccountId = "junifer_account_id",
  /** column name */
  TokenExpiry = "token_expiry",
  /** column name */
  TokenGeneratedAt = "token_generated_at",
}

export type Meter_Reading_Submission_Tokens_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Meter_Reading_Submission_Tokens_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Meter_Reading_Submission_Tokens_Set_Input>
  /** filter the rows which have to be updated */
  where: Meter_Reading_Submission_Tokens_Bool_Exp
}

/** aggregate var_pop on columns */
export type Meter_Reading_Submission_Tokens_Var_Pop_Fields = {
  __typename?: "meter_reading_submission_tokens_var_pop_fields"
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Meter_Reading_Submission_Tokens_Var_Samp_Fields = {
  __typename?: "meter_reading_submission_tokens_var_samp_fields"
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Meter_Reading_Submission_Tokens_Variance_Fields = {
  __typename?: "meter_reading_submission_tokens_variance_fields"
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate sum on columns */
export type Meter_Reading_Sum_Fields = {
  __typename?: "meter_reading_sum_fields"
  consumption?: Maybe<Scalars["numeric"]["output"]>
  cumulative?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["bigint"]["output"]>
  register_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "meter_reading" */
export type Meter_Reading_Sum_Order_By = {
  consumption?: InputMaybe<Order_By>
  cumulative?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  register_id?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "meter_reading_unit". All fields are combined with logical 'AND'. */
export type Meter_Reading_Unit_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["meter_reading_unit"]["input"]>
  _gt?: InputMaybe<Scalars["meter_reading_unit"]["input"]>
  _gte?: InputMaybe<Scalars["meter_reading_unit"]["input"]>
  _in?: InputMaybe<Array<Scalars["meter_reading_unit"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["meter_reading_unit"]["input"]>
  _lte?: InputMaybe<Scalars["meter_reading_unit"]["input"]>
  _neq?: InputMaybe<Scalars["meter_reading_unit"]["input"]>
  _nin?: InputMaybe<Array<Scalars["meter_reading_unit"]["input"]>>
}

/** update columns of table "meter_reading" */
export enum Meter_Reading_Update_Column {
  /** column name */
  Consumption = "consumption",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Cumulative = "cumulative",
  /** column name */
  Deleted = "deleted",
  /** column name */
  ErrorDescription = "error_description",
  /** column name */
  FromDttm = "from_dttm",
  /** column name */
  Id = "id",
  /** column name */
  MeterId = "meter_id",
  /** column name */
  MeterPointId = "meter_point_id",
  /** column name */
  PendingRegisterReadingId = "pending_register_reading_id",
  /** column name */
  Quality = "quality",
  /** column name */
  RateName = "rate_name",
  /** column name */
  ReadingDttm = "reading_dttm",
  /** column name */
  RegisterId = "register_id",
  /** column name */
  SequenceType = "sequence_type",
  /** column name */
  Source = "source",
  /** column name */
  Status = "status",
  /** column name */
  SubmissionProcessed = "submission_processed",
  /** column name */
  Unit = "unit",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  WorkflowStatus = "workflow_status",
}

export type Meter_Reading_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Meter_Reading_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Meter_Reading_Set_Input>
  /** filter the rows which have to be updated */
  where: Meter_Reading_Bool_Exp
}

/** aggregate var_pop on columns */
export type Meter_Reading_Var_Pop_Fields = {
  __typename?: "meter_reading_var_pop_fields"
  consumption?: Maybe<Scalars["Float"]["output"]>
  cumulative?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
  register_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "meter_reading" */
export type Meter_Reading_Var_Pop_Order_By = {
  consumption?: InputMaybe<Order_By>
  cumulative?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  register_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Meter_Reading_Var_Samp_Fields = {
  __typename?: "meter_reading_var_samp_fields"
  consumption?: Maybe<Scalars["Float"]["output"]>
  cumulative?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
  register_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "meter_reading" */
export type Meter_Reading_Var_Samp_Order_By = {
  consumption?: InputMaybe<Order_By>
  cumulative?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  register_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Meter_Reading_Variance_Fields = {
  __typename?: "meter_reading_variance_fields"
  consumption?: Maybe<Scalars["Float"]["output"]>
  cumulative?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
  register_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "meter_reading" */
export type Meter_Reading_Variance_Order_By = {
  consumption?: InputMaybe<Order_By>
  cumulative?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  register_id?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "meter_reading_workflow_status". All fields are combined with logical 'AND'. */
export type Meter_Reading_Workflow_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["meter_reading_workflow_status"]["input"]>
  _gt?: InputMaybe<Scalars["meter_reading_workflow_status"]["input"]>
  _gte?: InputMaybe<Scalars["meter_reading_workflow_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["meter_reading_workflow_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["meter_reading_workflow_status"]["input"]>
  _lte?: InputMaybe<Scalars["meter_reading_workflow_status"]["input"]>
  _neq?: InputMaybe<Scalars["meter_reading_workflow_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["meter_reading_workflow_status"]["input"]>>
}

/** select columns of table "meter" */
export enum Meter_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Description = "description",
  /** column name */
  Id = "id",
  /** column name */
  Identifier = "identifier",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "meter" */
export type Meter_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  identifier?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["meter_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Meter_Stddev_Fields = {
  __typename?: "meter_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Meter_Stddev_Pop_Fields = {
  __typename?: "meter_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Meter_Stddev_Samp_Fields = {
  __typename?: "meter_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "meter" */
export type Meter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Meter_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Meter_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  identifier?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["meter_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Meter_Sum_Fields = {
  __typename?: "meter_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** Boolean expression to compare columns of type "meter_type". All fields are combined with logical 'AND'. */
export type Meter_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["meter_type"]["input"]>
  _gt?: InputMaybe<Scalars["meter_type"]["input"]>
  _gte?: InputMaybe<Scalars["meter_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["meter_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["meter_type"]["input"]>
  _lte?: InputMaybe<Scalars["meter_type"]["input"]>
  _neq?: InputMaybe<Scalars["meter_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["meter_type"]["input"]>>
}

/** update columns of table "meter" */
export enum Meter_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Description = "description",
  /** column name */
  Id = "id",
  /** column name */
  Identifier = "identifier",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Meter_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Meter_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Meter_Set_Input>
  /** filter the rows which have to be updated */
  where: Meter_Bool_Exp
}

/** aggregate var_pop on columns */
export type Meter_Var_Pop_Fields = {
  __typename?: "meter_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Meter_Var_Samp_Fields = {
  __typename?: "meter_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Meter_Variance_Fields = {
  __typename?: "meter_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** missing_contact_detailsNative Query Arguments */
export type Missing_Contact_Details_Arguments = {
  limit: Scalars["Int"]["input"]
}

export type Missing_Contact_Details_Model = {
  __typename?: "missing_contact_details_model"
  billing_account_id: Scalars["bigint"]["output"]
  contact_email?: Maybe<Scalars["String"]["output"]>
  contact_phone1?: Maybe<Scalars["String"]["output"]>
  contact_phone2?: Maybe<Scalars["String"]["output"]>
  contact_phone3?: Maybe<Scalars["String"]["output"]>
  customer_email?: Maybe<Scalars["String"]["output"]>
  customer_phone1?: Maybe<Scalars["String"]["output"]>
  customer_phone2?: Maybe<Scalars["String"]["output"]>
  customer_phone3?: Maybe<Scalars["String"]["output"]>
  junifer_account_number: Scalars["String"]["output"]
}

/** Boolean expression to filter rows from the logical model for "missing_contact_details_model". All fields are combined with a logical 'AND'. */
export type Missing_Contact_Details_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Missing_Contact_Details_Model_Bool_Exp_Bool_Exp>>
  _not?: InputMaybe<Missing_Contact_Details_Model_Bool_Exp_Bool_Exp>
  _or?: InputMaybe<Array<Missing_Contact_Details_Model_Bool_Exp_Bool_Exp>>
  billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  contact_email?: InputMaybe<String_Comparison_Exp>
  contact_phone1?: InputMaybe<String_Comparison_Exp>
  contact_phone2?: InputMaybe<String_Comparison_Exp>
  contact_phone3?: InputMaybe<String_Comparison_Exp>
  customer_email?: InputMaybe<String_Comparison_Exp>
  customer_phone1?: InputMaybe<String_Comparison_Exp>
  customer_phone2?: InputMaybe<String_Comparison_Exp>
  customer_phone3?: InputMaybe<String_Comparison_Exp>
  junifer_account_number?: InputMaybe<String_Comparison_Exp>
}

export enum Missing_Contact_Details_Model_Enum_Name {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  ContactEmail = "contact_email",
  /** column name */
  ContactPhone1 = "contact_phone1",
  /** column name */
  ContactPhone2 = "contact_phone2",
  /** column name */
  ContactPhone3 = "contact_phone3",
  /** column name */
  CustomerEmail = "customer_email",
  /** column name */
  CustomerPhone1 = "customer_phone1",
  /** column name */
  CustomerPhone2 = "customer_phone2",
  /** column name */
  CustomerPhone3 = "customer_phone3",
  /** column name */
  JuniferAccountNumber = "junifer_account_number",
}

/** Ordering options when selecting data from "missing_contact_details_model". */
export type Missing_Contact_Details_Model_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  contact_email?: InputMaybe<Order_By>
  contact_phone1?: InputMaybe<Order_By>
  contact_phone2?: InputMaybe<Order_By>
  contact_phone3?: InputMaybe<Order_By>
  customer_email?: InputMaybe<Order_By>
  customer_phone1?: InputMaybe<Order_By>
  customer_phone2?: InputMaybe<Order_By>
  customer_phone3?: InputMaybe<Order_By>
  junifer_account_number?: InputMaybe<Order_By>
}

/** mutation root */
export type Mutation_Root = {
  __typename?: "mutation_root"
  accountsForAudit?: Maybe<AccountsForAuditResponse>
  /** Marks payment review records as deleted */
  action_payment_review_records_delete_by_ids?: Maybe<PaymentReviewRecordsDeleteByIdsResponse>
  addCoreGroupVulnerability?: Maybe<AddCoreGroupVulnerabilityResponse>
  applyCredit?: Maybe<ApplyCreditResponse>
  /** Apply referral code to user */
  applyReferralCode: Scalars["String"]["output"]
  changeOfTenancy?: Maybe<ChangeOfTenancyResponseDto>
  /** Change User password */
  changeUserPassword: Scalars["String"]["output"]
  closeNoEvidence?: Maybe<CloseNoEvidenceResponse>
  createAccountCredit: Scalars["String"]["output"]
  /** Create a new user for Junifer Account Number */
  createUserFromJunifer?: Maybe<UserResponse>
  /** delete data from the table: "ElecNominations" */
  delete_ElecNominations?: Maybe<ElecNominations_Mutation_Response>
  /** delete data from the table: "ElecTrades" */
  delete_ElecTrades?: Maybe<ElecTrades_Mutation_Response>
  /** delete data from the table: "ElecTradesHistory" */
  delete_ElecTradesHistory?: Maybe<ElecTradesHistory_Mutation_Response>
  /** delete single row from the table: "ElecTradesHistory" */
  delete_ElecTradesHistory_by_pk?: Maybe<ElecTradesHistory>
  /** delete single row from the table: "ElecTrades" */
  delete_ElecTrades_by_pk?: Maybe<ElecTrades>
  /** delete data from the table: "GasTrades" */
  delete_GasTrades?: Maybe<GasTrades_Mutation_Response>
  /** delete data from the table: "GasTradesHistory" */
  delete_GasTradesHistory?: Maybe<GasTradesHistory_Mutation_Response>
  /** delete single row from the table: "GasTradesHistory" */
  delete_GasTradesHistory_by_pk?: Maybe<GasTradesHistory>
  /** delete single row from the table: "GasTrades" */
  delete_GasTrades_by_pk?: Maybe<GasTrades>
  /** delete data from the table: "account_credit" */
  delete_account_credit?: Maybe<Account_Credit_Mutation_Response>
  /** delete single row from the table: "account_credit" */
  delete_account_credit_by_pk?: Maybe<Account_Credit>
  /** delete data from the table: "active_outbound_photo_request" */
  delete_active_outbound_photo_request?: Maybe<Active_Outbound_Photo_Request_Mutation_Response>
  /** delete data from the table: "address" */
  delete_address?: Maybe<Address_Mutation_Response>
  /** delete single row from the table: "address" */
  delete_address_by_pk?: Maybe<Address>
  /** delete data from the table: "admin_passes" */
  delete_admin_passes?: Maybe<Admin_Passes_Mutation_Response>
  /** delete single row from the table: "admin_passes" */
  delete_admin_passes_by_pk?: Maybe<Admin_Passes>
  /** delete data from the table: "admin_roles" */
  delete_admin_roles?: Maybe<Admin_Roles_Mutation_Response>
  /** delete single row from the table: "admin_roles" */
  delete_admin_roles_by_pk?: Maybe<Admin_Roles>
  /** delete data from the table: "agreement" */
  delete_agreement?: Maybe<Agreement_Mutation_Response>
  /** delete single row from the table: "agreement" */
  delete_agreement_by_pk?: Maybe<Agreement>
  /** delete data from the table: "asset" */
  delete_asset?: Maybe<Asset_Mutation_Response>
  /** delete single row from the table: "asset" */
  delete_asset_by_pk?: Maybe<Asset>
  /** delete data from the table: "attachment" */
  delete_attachment?: Maybe<Attachment_Mutation_Response>
  /** delete single row from the table: "attachment" */
  delete_attachment_by_pk?: Maybe<Attachment>
  /** delete data from the table: "axle_trial_eligibility" */
  delete_axle_trial_eligibility?: Maybe<Axle_Trial_Eligibility_Mutation_Response>
  /** delete single row from the table: "axle_trial_eligibility" */
  delete_axle_trial_eligibility_by_pk?: Maybe<Axle_Trial_Eligibility>
  /** delete data from the table: "bill" */
  delete_bill?: Maybe<Bill_Mutation_Response>
  /** delete single row from the table: "bill" */
  delete_bill_by_pk?: Maybe<Bill>
  /** delete data from the table: "billing_account" */
  delete_billing_account?: Maybe<Billing_Account_Mutation_Response>
  /** delete single row from the table: "billing_account" */
  delete_billing_account_by_pk?: Maybe<Billing_Account>
  /** delete data from the table: "billing_account_contact" */
  delete_billing_account_contact?: Maybe<Billing_Account_Contact_Mutation_Response>
  /** delete single row from the table: "billing_account_contact" */
  delete_billing_account_contact_by_pk?: Maybe<Billing_Account_Contact>
  /** delete data from the table: "billing_account_setting" */
  delete_billing_account_setting?: Maybe<Billing_Account_Setting_Mutation_Response>
  /** delete single row from the table: "billing_account_setting" */
  delete_billing_account_setting_by_pk?: Maybe<Billing_Account_Setting>
  /** delete data from the table: "billing_account_transaction" */
  delete_billing_account_transaction?: Maybe<Billing_Account_Transaction_Mutation_Response>
  /** delete single row from the table: "billing_account_transaction" */
  delete_billing_account_transaction_by_pk?: Maybe<Billing_Account_Transaction>
  /** delete data from the table: "billing_period" */
  delete_billing_period?: Maybe<Billing_Period_Mutation_Response>
  /** delete single row from the table: "billing_period" */
  delete_billing_period_by_pk?: Maybe<Billing_Period>
  /** delete data from the table: "calculation_items" */
  delete_calculation_items?: Maybe<Calculation_Items_Mutation_Response>
  /** delete single row from the table: "calculation_items" */
  delete_calculation_items_by_pk?: Maybe<Calculation_Items>
  /** delete data from the table: "call_trace_audit" */
  delete_call_trace_audit?: Maybe<Call_Trace_Audit_Mutation_Response>
  /** delete single row from the table: "call_trace_audit" */
  delete_call_trace_audit_by_pk?: Maybe<Call_Trace_Audit>
  /** delete data from the table: "cancellation_reasons" */
  delete_cancellation_reasons?: Maybe<Cancellation_Reasons_Mutation_Response>
  /** delete data from the table: "cancellations" */
  delete_cancellations?: Maybe<Cancellations_Mutation_Response>
  /** delete single row from the table: "cancellations" */
  delete_cancellations_by_pk?: Maybe<Cancellations>
  /** delete data from the table: "card_payment" */
  delete_card_payment?: Maybe<Card_Payment_Mutation_Response>
  /** delete single row from the table: "card_payment" */
  delete_card_payment_by_pk?: Maybe<Card_Payment>
  /** delete data from the table: "card_payment_old" */
  delete_card_payment_old?: Maybe<Card_Payment_Old_Mutation_Response>
  /** delete single row from the table: "card_payment_old" */
  delete_card_payment_old_by_pk?: Maybe<Card_Payment_Old>
  /** delete data from the table: "cases" */
  delete_cases?: Maybe<Cases_Mutation_Response>
  /** delete single row from the table: "cases" */
  delete_cases_by_pk?: Maybe<Cases>
  /** delete data from the table: "communication" */
  delete_communication?: Maybe<Communication_Mutation_Response>
  /** delete single row from the table: "communication" */
  delete_communication_by_pk?: Maybe<Communication>
  /** delete data from the table: "communication_metadata" */
  delete_communication_metadata?: Maybe<Communication_Metadata_Mutation_Response>
  /** delete single row from the table: "communication_metadata" */
  delete_communication_metadata_by_pk?: Maybe<Communication_Metadata>
  /** delete data from the table: "communications" */
  delete_communications?: Maybe<Communications_Mutation_Response>
  /** delete single row from the table: "communications" */
  delete_communications_by_pk?: Maybe<Communications>
  /** delete data from the table: "complaint" */
  delete_complaint?: Maybe<Complaint_Mutation_Response>
  /** delete single row from the table: "complaint" */
  delete_complaint_by_pk?: Maybe<Complaint>
  /** delete data from the table: "completed_sync_event_account" */
  delete_completed_sync_event_account?: Maybe<Completed_Sync_Event_Account_Mutation_Response>
  /** delete single row from the table: "completed_sync_event_account" */
  delete_completed_sync_event_account_by_pk?: Maybe<Completed_Sync_Event_Account>
  /** delete data from the table: "configuration" */
  delete_configuration?: Maybe<Configuration_Mutation_Response>
  /** delete single row from the table: "configuration" */
  delete_configuration_by_pk?: Maybe<Configuration>
  /** delete data from the table: "contact" */
  delete_contact?: Maybe<Contact_Mutation_Response>
  /** delete single row from the table: "contact" */
  delete_contact_by_pk?: Maybe<Contact>
  /** delete data from the table: "cs__soe_dashboard_total" */
  delete_cs__soe_dashboard_total?: Maybe<Cs__Soe_Dashboard_Total_Mutation_Response>
  /** delete single row from the table: "cs__soe_dashboard_total" */
  delete_cs__soe_dashboard_total_by_pk?: Maybe<Cs__Soe_Dashboard_Total>
  /** delete data from the table: "customer" */
  delete_customer?: Maybe<Customer_Mutation_Response>
  /** delete data from the table: "address" */
  delete_customer_address?: Maybe<Customer_Address_Mutation_Response>
  /** delete single row from the table: "address" */
  delete_customer_address_by_pk?: Maybe<Customer_Address>
  /** delete single row from the table: "customer" */
  delete_customer_by_pk?: Maybe<Customer>
  /** delete data from the table: "customer_contact" */
  delete_customer_contact?: Maybe<Customer_Contact_Mutation_Response>
  /** delete single row from the table: "customer_contact" */
  delete_customer_contact_by_pk?: Maybe<Customer_Contact>
  /** delete data from the table: "customer_metadata" */
  delete_customer_metadata?: Maybe<Customer_Metadata_Mutation_Response>
  /** delete single row from the table: "customer_metadata" */
  delete_customer_metadata_by_pk?: Maybe<Customer_Metadata>
  /** delete data from the table: "customer_property_rel" */
  delete_customer_property_rel?: Maybe<Customer_Property_Rel_Mutation_Response>
  /** delete single row from the table: "customer_property_rel" */
  delete_customer_property_rel_by_pk?: Maybe<Customer_Property_Rel>
  /** delete data from the table: "customer_psr_rel" */
  delete_customer_psr_rel?: Maybe<Customer_Psr_Rel_Mutation_Response>
  /** delete single row from the table: "customer_psr_rel" */
  delete_customer_psr_rel_by_pk?: Maybe<Customer_Psr_Rel>
  /** delete data from the table: "customer_referrals" */
  delete_customer_referrals?: Maybe<Customer_Referrals_Mutation_Response>
  /** delete single row from the table: "customer_referrals" */
  delete_customer_referrals_by_pk?: Maybe<Customer_Referrals>
  /** delete data from the table: "customer_setting" */
  delete_customer_setting?: Maybe<Customer_Setting_Mutation_Response>
  /** delete single row from the table: "customer_setting" */
  delete_customer_setting_by_pk?: Maybe<Customer_Setting>
  /** delete data from the table: "customer_user_rel" */
  delete_customer_user_rel?: Maybe<Customer_User_Rel_Mutation_Response>
  /** delete single row from the table: "customer_user_rel" */
  delete_customer_user_rel_by_pk?: Maybe<Customer_User_Rel>
  /** delete data from the table: "deprecated_solar_quote_requests" */
  delete_deprecated_solar_quote_requests?: Maybe<Deprecated_Solar_Quote_Requests_Mutation_Response>
  /** delete single row from the table: "deprecated_solar_quote_requests" */
  delete_deprecated_solar_quote_requests_by_pk?: Maybe<Deprecated_Solar_Quote_Requests>
  /** delete data from the table: "direct_debit" */
  delete_direct_debit?: Maybe<Direct_Debit_Mutation_Response>
  /** delete single row from the table: "direct_debit" */
  delete_direct_debit_by_pk?: Maybe<Direct_Debit>
  /** delete data from the table: "direct_debit_payment" */
  delete_direct_debit_payment?: Maybe<Direct_Debit_Payment_Mutation_Response>
  /** delete single row from the table: "direct_debit_payment" */
  delete_direct_debit_payment_by_pk?: Maybe<Direct_Debit_Payment>
  /** delete data from the table: "email_messages" */
  delete_email_messages?: Maybe<Email_Messages_Mutation_Response>
  /** delete single row from the table: "email_messages" */
  delete_email_messages_by_pk?: Maybe<Email_Messages>
  /** delete data from the table: "email_templates" */
  delete_email_templates?: Maybe<Email_Templates_Mutation_Response>
  /** delete single row from the table: "email_templates" */
  delete_email_templates_by_pk?: Maybe<Email_Templates>
  /** delete data from the table: "email_templates_ext" */
  delete_email_templates_ext?: Maybe<Email_Templates_Ext_Mutation_Response>
  /** delete single row from the table: "email_templates_ext" */
  delete_email_templates_ext_by_pk?: Maybe<Email_Templates_Ext>
  /** delete data from the table: "energy_usage_load_factors" */
  delete_energy_usage_load_factors?: Maybe<Energy_Usage_Load_Factors_Mutation_Response>
  /** delete single row from the table: "energy_usage_load_factors" */
  delete_energy_usage_load_factors_by_pk?: Maybe<Energy_Usage_Load_Factors>
  /** delete data from the table: "enrolment" */
  delete_enrolment?: Maybe<Enrolment_Mutation_Response>
  /** delete data from the table: "enrolment_automated_communications" */
  delete_enrolment_automated_communications?: Maybe<Enrolment_Automated_Communications_Mutation_Response>
  /** delete single row from the table: "enrolment_automated_communications" */
  delete_enrolment_automated_communications_by_pk?: Maybe<Enrolment_Automated_Communications>
  /** delete single row from the table: "enrolment" */
  delete_enrolment_by_pk?: Maybe<Enrolment>
  /** delete data from the table: "entity_mappings" */
  delete_entity_mappings?: Maybe<Entity_Mappings_Mutation_Response>
  /** delete single row from the table: "entity_mappings" */
  delete_entity_mappings_by_pk?: Maybe<Entity_Mappings>
  /** delete data from the table: "estimated_usage" */
  delete_estimated_usage?: Maybe<Estimated_Usage_Mutation_Response>
  /** delete single row from the table: "estimated_usage" */
  delete_estimated_usage_by_pk?: Maybe<Estimated_Usage>
  /** delete data from the table: "ev_smart_tariff_waitlist" */
  delete_ev_smart_tariff_waitlist?: Maybe<Ev_Smart_Tariff_Waitlist_Mutation_Response>
  /** delete single row from the table: "ev_smart_tariff_waitlist" */
  delete_ev_smart_tariff_waitlist_by_pk?: Maybe<Ev_Smart_Tariff_Waitlist>
  /** delete data from the table: "ev_tariff_eligibility_checks" */
  delete_ev_tariff_eligibility_checks?: Maybe<Ev_Tariff_Eligibility_Checks_Mutation_Response>
  /** delete single row from the table: "ev_tariff_eligibility_checks" */
  delete_ev_tariff_eligibility_checks_by_pk?: Maybe<Ev_Tariff_Eligibility_Checks>
  /** delete data from the table: "feature" */
  delete_feature?: Maybe<Feature_Mutation_Response>
  /** delete single row from the table: "feature" */
  delete_feature_by_pk?: Maybe<Feature>
  /** delete data from the table: "configuration" */
  delete_financials_configuration?: Maybe<Financials_Configuration_Mutation_Response>
  /** delete single row from the table: "configuration" */
  delete_financials_configuration_by_pk?: Maybe<Financials_Configuration>
  /** delete data from the table: "qrtz_blob_triggers" */
  delete_financials_qrtz_blob_triggers?: Maybe<Financials_Qrtz_Blob_Triggers_Mutation_Response>
  /** delete single row from the table: "qrtz_blob_triggers" */
  delete_financials_qrtz_blob_triggers_by_pk?: Maybe<Financials_Qrtz_Blob_Triggers>
  /** delete data from the table: "qrtz_calendars" */
  delete_financials_qrtz_calendars?: Maybe<Financials_Qrtz_Calendars_Mutation_Response>
  /** delete single row from the table: "qrtz_calendars" */
  delete_financials_qrtz_calendars_by_pk?: Maybe<Financials_Qrtz_Calendars>
  /** delete data from the table: "qrtz_cron_triggers" */
  delete_financials_qrtz_cron_triggers?: Maybe<Financials_Qrtz_Cron_Triggers_Mutation_Response>
  /** delete single row from the table: "qrtz_cron_triggers" */
  delete_financials_qrtz_cron_triggers_by_pk?: Maybe<Financials_Qrtz_Cron_Triggers>
  /** delete data from the table: "qrtz_fired_triggers" */
  delete_financials_qrtz_fired_triggers?: Maybe<Financials_Qrtz_Fired_Triggers_Mutation_Response>
  /** delete single row from the table: "qrtz_fired_triggers" */
  delete_financials_qrtz_fired_triggers_by_pk?: Maybe<Financials_Qrtz_Fired_Triggers>
  /** delete data from the table: "qrtz_job_details" */
  delete_financials_qrtz_job_details?: Maybe<Financials_Qrtz_Job_Details_Mutation_Response>
  /** delete single row from the table: "qrtz_job_details" */
  delete_financials_qrtz_job_details_by_pk?: Maybe<Financials_Qrtz_Job_Details>
  /** delete data from the table: "qrtz_scheduler_state" */
  delete_financials_qrtz_scheduler_state?: Maybe<Financials_Qrtz_Scheduler_State_Mutation_Response>
  /** delete single row from the table: "qrtz_scheduler_state" */
  delete_financials_qrtz_scheduler_state_by_pk?: Maybe<Financials_Qrtz_Scheduler_State>
  /** delete data from the table: "qrtz_simple_triggers" */
  delete_financials_qrtz_simple_triggers?: Maybe<Financials_Qrtz_Simple_Triggers_Mutation_Response>
  /** delete single row from the table: "qrtz_simple_triggers" */
  delete_financials_qrtz_simple_triggers_by_pk?: Maybe<Financials_Qrtz_Simple_Triggers>
  /** delete data from the table: "qrtz_simprop_triggers" */
  delete_financials_qrtz_simprop_triggers?: Maybe<Financials_Qrtz_Simprop_Triggers_Mutation_Response>
  /** delete single row from the table: "qrtz_simprop_triggers" */
  delete_financials_qrtz_simprop_triggers_by_pk?: Maybe<Financials_Qrtz_Simprop_Triggers>
  /** delete data from the table: "qrtz_triggers" */
  delete_financials_qrtz_triggers?: Maybe<Financials_Qrtz_Triggers_Mutation_Response>
  /** delete single row from the table: "qrtz_triggers" */
  delete_financials_qrtz_triggers_by_pk?: Maybe<Financials_Qrtz_Triggers>
  /** delete data from the table: "warrant_account_criteria" */
  delete_financials_warrant_account_criteria?: Maybe<Financials_Warrant_Account_Criteria_Mutation_Response>
  /** delete single row from the table: "warrant_account_criteria" */
  delete_financials_warrant_account_criteria_by_pk?: Maybe<Financials_Warrant_Account_Criteria>
  /** delete data from the table: "warrant_account_sync_criteria" */
  delete_financials_warrant_account_sync_criteria?: Maybe<Financials_Warrant_Account_Sync_Criteria_Mutation_Response>
  /** delete single row from the table: "warrant_account_sync_criteria" */
  delete_financials_warrant_account_sync_criteria_by_pk?: Maybe<Financials_Warrant_Account_Sync_Criteria>
  /** delete data from the table: "warrant_communications_sent_count" */
  delete_financials_warrant_communications_sent_count?: Maybe<Financials_Warrant_Communications_Sent_Count_Mutation_Response>
  /** delete single row from the table: "warrant_communications_sent_count" */
  delete_financials_warrant_communications_sent_count_by_pk?: Maybe<Financials_Warrant_Communications_Sent_Count>
  /** delete data from the table: "warrants_accounts" */
  delete_financials_warrants_accounts?: Maybe<Financials_Warrants_Accounts_Mutation_Response>
  /** delete single row from the table: "warrants_accounts" */
  delete_financials_warrants_accounts_by_pk?: Maybe<Financials_Warrants_Accounts>
  /** delete data from the table: "warrants_accounts_history" */
  delete_financials_warrants_accounts_history?: Maybe<Financials_Warrants_Accounts_History_Mutation_Response>
  /** delete single row from the table: "warrants_accounts_history" */
  delete_financials_warrants_accounts_history_by_pk?: Maybe<Financials_Warrants_Accounts_History>
  /** delete data from the table: "warrants_accounts_whitelist" */
  delete_financials_warrants_accounts_whitelist?: Maybe<Financials_Warrants_Accounts_Whitelist_Mutation_Response>
  /** delete single row from the table: "warrants_accounts_whitelist" */
  delete_financials_warrants_accounts_whitelist_by_pk?: Maybe<Financials_Warrants_Accounts_Whitelist>
  /** delete data from the table: "warrants_communication_group" */
  delete_financials_warrants_communication_group?: Maybe<Financials_Warrants_Communication_Group_Mutation_Response>
  /** delete single row from the table: "warrants_communication_group" */
  delete_financials_warrants_communication_group_by_pk?: Maybe<Financials_Warrants_Communication_Group>
  /** delete data from the table: "warrants_communications" */
  delete_financials_warrants_communications?: Maybe<Financials_Warrants_Communications_Mutation_Response>
  /** delete single row from the table: "warrants_communications" */
  delete_financials_warrants_communications_by_pk?: Maybe<Financials_Warrants_Communications>
  /** delete data from the table: "warrants_dca_queue" */
  delete_financials_warrants_dca_queue?: Maybe<Financials_Warrants_Dca_Queue_Mutation_Response>
  /** delete single row from the table: "warrants_dca_queue" */
  delete_financials_warrants_dca_queue_by_pk?: Maybe<Financials_Warrants_Dca_Queue>
  /** delete data from the table: "warrants_dca_tickets" */
  delete_financials_warrants_dca_tickets?: Maybe<Financials_Warrants_Dca_Tickets_Mutation_Response>
  /** delete single row from the table: "warrants_dca_tickets" */
  delete_financials_warrants_dca_tickets_by_pk?: Maybe<Financials_Warrants_Dca_Tickets>
  /** delete data from the table: "warrants_files_account" */
  delete_financials_warrants_files_account?: Maybe<Financials_Warrants_Files_Account_Mutation_Response>
  /** delete single row from the table: "warrants_files_account" */
  delete_financials_warrants_files_account_by_pk?: Maybe<Financials_Warrants_Files_Account>
  /** delete data from the table: "warrants_files_job" */
  delete_financials_warrants_files_job?: Maybe<Financials_Warrants_Files_Job_Mutation_Response>
  /** delete single row from the table: "warrants_files_job" */
  delete_financials_warrants_files_job_by_pk?: Maybe<Financials_Warrants_Files_Job>
  /** delete data from the table: "warrants_files_processed" */
  delete_financials_warrants_files_processed?: Maybe<Financials_Warrants_Files_Processed_Mutation_Response>
  /** delete single row from the table: "warrants_files_processed" */
  delete_financials_warrants_files_processed_by_pk?: Maybe<Financials_Warrants_Files_Processed>
  /** delete data from the table: "warrants_job" */
  delete_financials_warrants_job?: Maybe<Financials_Warrants_Job_Mutation_Response>
  /** delete single row from the table: "warrants_job" */
  delete_financials_warrants_job_by_pk?: Maybe<Financials_Warrants_Job>
  /** delete data from the table: "flex_market_subscription" */
  delete_flex_market_subscription?: Maybe<Flex_Market_Subscription_Mutation_Response>
  /** delete data from the table: "flex_market_subscription_billing" */
  delete_flex_market_subscription_billing?: Maybe<Flex_Market_Subscription_Billing_Mutation_Response>
  /** delete single row from the table: "flex_market_subscription_billing" */
  delete_flex_market_subscription_billing_by_pk?: Maybe<Flex_Market_Subscription_Billing>
  /** delete data from the table: "flex_market_subscription_billing_component" */
  delete_flex_market_subscription_billing_component?: Maybe<Flex_Market_Subscription_Billing_Component_Mutation_Response>
  /** delete single row from the table: "flex_market_subscription_billing_component" */
  delete_flex_market_subscription_billing_component_by_pk?: Maybe<Flex_Market_Subscription_Billing_Component>
  /** delete single row from the table: "flex_market_subscription" */
  delete_flex_market_subscription_by_pk?: Maybe<Flex_Market_Subscription>
  /** delete data from the table: "flyway_schema_history" */
  delete_flyway_schema_history?: Maybe<Flyway_Schema_History_Mutation_Response>
  /** delete single row from the table: "flyway_schema_history" */
  delete_flyway_schema_history_by_pk?: Maybe<Flyway_Schema_History>
  /** delete data from the table: "freshdesk_contact" */
  delete_freshdesk_contact?: Maybe<Freshdesk_Contact_Mutation_Response>
  /** delete data from the table: "freshdesk_ticket" */
  delete_freshdesk_ticket?: Maybe<Freshdesk_Ticket_Mutation_Response>
  /** delete data from the table: "install_codes" */
  delete_install_codes?: Maybe<Install_Codes_Mutation_Response>
  /** delete single row from the table: "install_codes" */
  delete_install_codes_by_pk?: Maybe<Install_Codes>
  /** delete data from the table: "junifer__Account" */
  delete_junifer__Account?: Maybe<Junifer__Account_Mutation_Response>
  /** delete data from the table: "junifer__AccountTransaction" */
  delete_junifer__AccountTransaction?: Maybe<Junifer__AccountTransaction_Mutation_Response>
  /** delete single row from the table: "junifer__AccountTransaction" */
  delete_junifer__AccountTransaction_by_pk?: Maybe<Junifer__AccountTransaction>
  /** delete single row from the table: "junifer__Account" */
  delete_junifer__Account_by_pk?: Maybe<Junifer__Account>
  /** delete data from the table: "junifer__Customer" */
  delete_junifer__Customer?: Maybe<Junifer__Customer_Mutation_Response>
  /** delete single row from the table: "junifer__Customer" */
  delete_junifer__Customer_by_pk?: Maybe<Junifer__Customer>
  /** delete data from the table: "meter" */
  delete_meter?: Maybe<Meter_Mutation_Response>
  /** delete single row from the table: "meter" */
  delete_meter_by_pk?: Maybe<Meter>
  /** delete data from the table: "meter_meter_point_rel" */
  delete_meter_meter_point_rel?: Maybe<Meter_Meter_Point_Rel_Mutation_Response>
  /** delete single row from the table: "meter_meter_point_rel" */
  delete_meter_meter_point_rel_by_pk?: Maybe<Meter_Meter_Point_Rel>
  /** delete data from the table: "meter_point" */
  delete_meter_point?: Maybe<Meter_Point_Mutation_Response>
  /** delete single row from the table: "meter_point" */
  delete_meter_point_by_pk?: Maybe<Meter_Point>
  /** delete data from the table: "meter_point_electricity" */
  delete_meter_point_electricity?: Maybe<Meter_Point_Electricity_Mutation_Response>
  /** delete single row from the table: "meter_point_electricity" */
  delete_meter_point_electricity_by_pk?: Maybe<Meter_Point_Electricity>
  /** delete data from the table: "meter_point_gas" */
  delete_meter_point_gas?: Maybe<Meter_Point_Gas_Mutation_Response>
  /** delete single row from the table: "meter_point_gas" */
  delete_meter_point_gas_by_pk?: Maybe<Meter_Point_Gas>
  /** delete data from the table: "meter_point_history" */
  delete_meter_point_history?: Maybe<Meter_Point_History_Mutation_Response>
  /** delete single row from the table: "meter_point_history" */
  delete_meter_point_history_by_pk?: Maybe<Meter_Point_History>
  /** delete data from the table: "meter_reading" */
  delete_meter_reading?: Maybe<Meter_Reading_Mutation_Response>
  /** delete single row from the table: "meter_reading" */
  delete_meter_reading_by_pk?: Maybe<Meter_Reading>
  /** delete data from the table: "meter_reading_submission_request" */
  delete_meter_reading_submission_request?: Maybe<Meter_Reading_Submission_Request_Mutation_Response>
  /** delete single row from the table: "meter_reading_submission_request" */
  delete_meter_reading_submission_request_by_pk?: Maybe<Meter_Reading_Submission_Request>
  /** delete data from the table: "meter_reading_submission_tokens" */
  delete_meter_reading_submission_tokens?: Maybe<Meter_Reading_Submission_Tokens_Mutation_Response>
  /** delete single row from the table: "meter_reading_submission_tokens" */
  delete_meter_reading_submission_tokens_by_pk?: Maybe<Meter_Reading_Submission_Tokens>
  /** delete data from the table: "note" */
  delete_note?: Maybe<Note_Mutation_Response>
  /** delete single row from the table: "note" */
  delete_note_by_pk?: Maybe<Note>
  /** delete data from the table: "nova_submissions" */
  delete_nova_submissions?: Maybe<Nova_Submissions_Mutation_Response>
  /** delete data from the table: "outbound_photo_request" */
  delete_outbound_photo_request?: Maybe<Outbound_Photo_Request_Mutation_Response>
  /** delete single row from the table: "outbound_photo_request" */
  delete_outbound_photo_request_by_pk?: Maybe<Outbound_Photo_Request>
  /** delete data from the table: "password_reset_tokens" */
  delete_password_reset_tokens?: Maybe<Password_Reset_Tokens_Mutation_Response>
  /** delete single row from the table: "password_reset_tokens" */
  delete_password_reset_tokens_by_pk?: Maybe<Password_Reset_Tokens>
  /** delete data from the table: "payment" */
  delete_payment?: Maybe<Payment_Mutation_Response>
  /** delete single row from the table: "payment" */
  delete_payment_by_pk?: Maybe<Payment>
  /** delete data from the table: "payment_method" */
  delete_payment_method?: Maybe<Payment_Method_Mutation_Response>
  /** delete single row from the table: "payment_method" */
  delete_payment_method_by_pk?: Maybe<Payment_Method>
  /** delete data from the table: "payment_review_account_balance_reserve_rates" */
  delete_payment_review_account_balance_reserve_rates?: Maybe<Payment_Review_Account_Balance_Reserve_Rates_Mutation_Response>
  /** delete single row from the table: "payment_review_account_balance_reserve_rates" */
  delete_payment_review_account_balance_reserve_rates_by_pk?: Maybe<Payment_Review_Account_Balance_Reserve_Rates>
  /** delete data from the table: "payment_review_account_exclusions" */
  delete_payment_review_account_exclusions?: Maybe<Payment_Review_Account_Exclusions_Mutation_Response>
  /** delete single row from the table: "payment_review_account_exclusions" */
  delete_payment_review_account_exclusions_by_pk?: Maybe<Payment_Review_Account_Exclusions>
  /** delete data from the table: "payment_review_calculation" */
  delete_payment_review_calculation?: Maybe<Payment_Review_Calculation_Mutation_Response>
  /** delete single row from the table: "payment_review_calculation" */
  delete_payment_review_calculation_by_pk?: Maybe<Payment_Review_Calculation>
  /** delete data from the table: "payment_review_future_product_rates" */
  delete_payment_review_future_product_rates?: Maybe<Payment_Review_Future_Product_Rates_Mutation_Response>
  /** delete single row from the table: "payment_review_future_product_rates" */
  delete_payment_review_future_product_rates_by_pk?: Maybe<Payment_Review_Future_Product_Rates>
  /** delete data from the table: "payment_review_record_emails" */
  delete_payment_review_record_emails?: Maybe<Payment_Review_Record_Emails_Mutation_Response>
  /** delete single row from the table: "payment_review_record_emails" */
  delete_payment_review_record_emails_by_pk?: Maybe<Payment_Review_Record_Emails>
  /** delete data from the table: "payment_review_record_notes" */
  delete_payment_review_record_notes?: Maybe<Payment_Review_Record_Notes_Mutation_Response>
  /** delete single row from the table: "payment_review_record_notes" */
  delete_payment_review_record_notes_by_pk?: Maybe<Payment_Review_Record_Notes>
  /** delete data from the table: "payment_review_records" */
  delete_payment_review_records?: Maybe<Payment_Review_Records_Mutation_Response>
  /** delete single row from the table: "payment_review_records" */
  delete_payment_review_records_by_pk?: Maybe<Payment_Review_Records>
  /** delete data from the table: "payment_reviews" */
  delete_payment_reviews?: Maybe<Payment_Reviews_Mutation_Response>
  /** delete single row from the table: "payment_reviews" */
  delete_payment_reviews_by_pk?: Maybe<Payment_Reviews>
  /** delete data from the table: "payment_schedule" */
  delete_payment_schedule?: Maybe<Payment_Schedule_Mutation_Response>
  /** delete single row from the table: "payment_schedule" */
  delete_payment_schedule_by_pk?: Maybe<Payment_Schedule>
  /** delete data from the table: "postcode_gsp_cache" */
  delete_postcode_gsp_cache?: Maybe<Postcode_Gsp_Cache_Mutation_Response>
  /** delete single row from the table: "postcode_gsp_cache" */
  delete_postcode_gsp_cache_by_pk?: Maybe<Postcode_Gsp_Cache>
  /** delete data from the table: "product" */
  delete_product?: Maybe<Product_Mutation_Response>
  /** delete data from the table: "product_account" */
  delete_product_account?: Maybe<Product_Account_Mutation_Response>
  /** delete data from the table: "product_account_agreement_rel" */
  delete_product_account_agreement_rel?: Maybe<Product_Account_Agreement_Rel_Mutation_Response>
  /** delete single row from the table: "product_account_agreement_rel" */
  delete_product_account_agreement_rel_by_pk?: Maybe<Product_Account_Agreement_Rel>
  /** delete single row from the table: "product_account" */
  delete_product_account_by_pk?: Maybe<Product_Account>
  /** delete single row from the table: "product" */
  delete_product_by_pk?: Maybe<Product>
  /** delete data from the table: "product_elec" */
  delete_product_elec?: Maybe<Product_Elec_Mutation_Response>
  /** delete single row from the table: "product_elec" */
  delete_product_elec_by_pk?: Maybe<Product_Elec>
  /** delete data from the table: "product_gas" */
  delete_product_gas?: Maybe<Product_Gas_Mutation_Response>
  /** delete single row from the table: "product_gas" */
  delete_product_gas_by_pk?: Maybe<Product_Gas>
  /** delete data from the table: "product_variant" */
  delete_product_variant?: Maybe<Product_Variant_Mutation_Response>
  /** delete single row from the table: "product_variant" */
  delete_product_variant_by_pk?: Maybe<Product_Variant>
  /** delete data from the table: "product_variant_elec" */
  delete_product_variant_elec?: Maybe<Product_Variant_Elec_Mutation_Response>
  /** delete single row from the table: "product_variant_elec" */
  delete_product_variant_elec_by_pk?: Maybe<Product_Variant_Elec>
  /** delete data from the table: "product_variant_gas" */
  delete_product_variant_gas?: Maybe<Product_Variant_Gas_Mutation_Response>
  /** delete single row from the table: "product_variant_gas" */
  delete_product_variant_gas_by_pk?: Maybe<Product_Variant_Gas>
  /** delete data from the table: "property" */
  delete_property?: Maybe<Property_Mutation_Response>
  /** delete single row from the table: "property" */
  delete_property_by_pk?: Maybe<Property>
  /** delete data from the table: "psr" */
  delete_psr?: Maybe<Psr_Mutation_Response>
  /** delete single row from the table: "psr" */
  delete_psr_by_pk?: Maybe<Psr>
  /** delete data from the table: "quote" */
  delete_quote?: Maybe<Quote_Mutation_Response>
  /** delete single row from the table: "quote" */
  delete_quote_by_pk?: Maybe<Quote>
  /** delete data from the table: "quote_request" */
  delete_quote_request?: Maybe<Quote_Request_Mutation_Response>
  /** delete single row from the table: "quote_request" */
  delete_quote_request_by_pk?: Maybe<Quote_Request>
  /** delete data from the table: "recipients" */
  delete_recipients?: Maybe<Recipients_Mutation_Response>
  /** delete single row from the table: "recipients" */
  delete_recipients_by_pk?: Maybe<Recipients>
  /** delete data from the table: "refresh_tokens" */
  delete_refresh_tokens?: Maybe<Refresh_Tokens_Mutation_Response>
  /** delete data from the table: "refunds" */
  delete_refunds?: Maybe<Refunds_Mutation_Response>
  /** delete single row from the table: "refunds" */
  delete_refunds_by_pk?: Maybe<Refunds>
  /** delete data from the table: "register" */
  delete_register?: Maybe<Register_Mutation_Response>
  /** delete single row from the table: "register" */
  delete_register_by_pk?: Maybe<Register>
  /** delete data from the table: "registration_credit_check" */
  delete_registration_credit_check?: Maybe<Registration_Credit_Check_Mutation_Response>
  /** delete data from the table: "registration_credit_check_address" */
  delete_registration_credit_check_address?: Maybe<Registration_Credit_Check_Address_Mutation_Response>
  /** delete single row from the table: "registration_credit_check_address" */
  delete_registration_credit_check_address_by_pk?: Maybe<Registration_Credit_Check_Address>
  /** delete single row from the table: "registration_credit_check" */
  delete_registration_credit_check_by_pk?: Maybe<Registration_Credit_Check>
  /** delete data from the table: "reminder" */
  delete_reminder?: Maybe<Reminder_Mutation_Response>
  /** delete single row from the table: "reminder" */
  delete_reminder_by_pk?: Maybe<Reminder>
  /** delete data from the table: "renewal" */
  delete_renewal?: Maybe<Renewal_Mutation_Response>
  /** delete single row from the table: "renewal" */
  delete_renewal_by_pk?: Maybe<Renewal>
  /** delete data from the table: "report_problem" */
  delete_report_problem?: Maybe<Report_Problem_Mutation_Response>
  /** delete data from the table: "report_problem_attachments" */
  delete_report_problem_attachments?: Maybe<Report_Problem_Attachments_Mutation_Response>
  /** delete single row from the table: "report_problem_attachments" */
  delete_report_problem_attachments_by_pk?: Maybe<Report_Problem_Attachments>
  /** delete single row from the table: "report_problem" */
  delete_report_problem_by_pk?: Maybe<Report_Problem>
  /** delete data from the table: "requests" */
  delete_requests?: Maybe<Requests_Mutation_Response>
  /** delete single row from the table: "requests" */
  delete_requests_by_pk?: Maybe<Requests>
  /** delete data from the table: "rts_meters_report" */
  delete_rts_meters_report?: Maybe<Rts_Meters_Report_Mutation_Response>
  /** delete data from the table: "scheduled_payment" */
  delete_scheduled_payment?: Maybe<Scheduled_Payment_Mutation_Response>
  /** delete single row from the table: "scheduled_payment" */
  delete_scheduled_payment_by_pk?: Maybe<Scheduled_Payment>
  /** delete data from the table: "scheduled_refund" */
  delete_scheduled_refund?: Maybe<Scheduled_Refund_Mutation_Response>
  /** delete single row from the table: "scheduled_refund" */
  delete_scheduled_refund_by_pk?: Maybe<Scheduled_Refund>
  /** delete data from the table: "smart_charging" */
  delete_smart_charging?: Maybe<Smart_Charging_Mutation_Response>
  /** delete single row from the table: "smart_charging" */
  delete_smart_charging_by_pk?: Maybe<Smart_Charging>
  /** delete data from the table: "smart_meter_dashboard_response_v7" */
  delete_smart_meter_dashboard_response_v7?: Maybe<Smart_Meter_Dashboard_Response_V7_Mutation_Response>
  /** delete data from the table: "smart_meters_eligible_for_exchange" */
  delete_smart_meters_eligible_for_exchange?: Maybe<Smart_Meters_Eligible_For_Exchange_Mutation_Response>
  /** delete single row from the table: "smart_meters_eligible_for_exchange" */
  delete_smart_meters_eligible_for_exchange_by_pk?: Maybe<Smart_Meters_Eligible_For_Exchange>
  /** delete data from the table: "sync_status" */
  delete_sync_status?: Maybe<Sync_Status_Mutation_Response>
  /** delete single row from the table: "sync_status" */
  delete_sync_status_by_pk?: Maybe<Sync_Status>
  /** delete data from the table: "synchronized_accounts" */
  delete_synchronized_accounts?: Maybe<Synchronized_Accounts_Mutation_Response>
  /** delete single row from the table: "synchronized_accounts" */
  delete_synchronized_accounts_by_pk?: Maybe<Synchronized_Accounts>
  /** delete data from the table: "ticket" */
  delete_ticket?: Maybe<Ticket_Mutation_Response>
  /** delete single row from the table: "ticket" */
  delete_ticket_by_pk?: Maybe<Ticket>
  /** delete data from the table: "automation_account_store" */
  delete_tickets_automation_account_store?: Maybe<Tickets_Automation_Account_Store_Mutation_Response>
  /** delete single row from the table: "automation_account_store" */
  delete_tickets_automation_account_store_by_pk?: Maybe<Tickets_Automation_Account_Store>
  /** delete data from the table: "automation_config" */
  delete_tickets_automation_config?: Maybe<Tickets_Automation_Config_Mutation_Response>
  /** delete single row from the table: "automation_config" */
  delete_tickets_automation_config_by_pk?: Maybe<Tickets_Automation_Config>
  /** delete data from the table: "automation_config_default" */
  delete_tickets_automation_config_default?: Maybe<Tickets_Automation_Config_Default_Mutation_Response>
  /** delete single row from the table: "automation_config_default" */
  delete_tickets_automation_config_default_by_pk?: Maybe<Tickets_Automation_Config_Default>
  /** delete data from the table: "automation_config_purge" */
  delete_tickets_automation_config_purge?: Maybe<Tickets_Automation_Config_Purge_Mutation_Response>
  /** delete single row from the table: "automation_config_purge" */
  delete_tickets_automation_config_purge_by_pk?: Maybe<Tickets_Automation_Config_Purge>
  /** delete data from the table: "automation_default_ticket_action" */
  delete_tickets_automation_default_ticket_action?: Maybe<Tickets_Automation_Default_Ticket_Action_Mutation_Response>
  /** delete single row from the table: "automation_default_ticket_action" */
  delete_tickets_automation_default_ticket_action_by_pk?: Maybe<Tickets_Automation_Default_Ticket_Action>
  /** delete data from the table: "automation_defaults_acceptable_accounts_table" */
  delete_tickets_automation_defaults_acceptable_accounts_table?: Maybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Mutation_Response>
  /** delete single row from the table: "automation_defaults_acceptable_accounts_table" */
  delete_tickets_automation_defaults_acceptable_accounts_table_by_pk?: Maybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table>
  /** delete data from the table: "automation_defaults_opened_predefaults" */
  delete_tickets_automation_defaults_opened_predefaults?: Maybe<Tickets_Automation_Defaults_Opened_Predefaults_Mutation_Response>
  /** delete single row from the table: "automation_defaults_opened_predefaults" */
  delete_tickets_automation_defaults_opened_predefaults_by_pk?: Maybe<Tickets_Automation_Defaults_Opened_Predefaults>
  /** delete data from the table: "automation_job" */
  delete_tickets_automation_job?: Maybe<Tickets_Automation_Job_Mutation_Response>
  /** delete single row from the table: "automation_job" */
  delete_tickets_automation_job_by_pk?: Maybe<Tickets_Automation_Job>
  /** delete data from the table: "automation_purge_job" */
  delete_tickets_automation_purge_job?: Maybe<Tickets_Automation_Purge_Job_Mutation_Response>
  /** delete single row from the table: "automation_purge_job" */
  delete_tickets_automation_purge_job_by_pk?: Maybe<Tickets_Automation_Purge_Job>
  /** delete data from the table: "automation_ticket_store" */
  delete_tickets_automation_ticket_store?: Maybe<Tickets_Automation_Ticket_Store_Mutation_Response>
  /** delete single row from the table: "automation_ticket_store" */
  delete_tickets_automation_ticket_store_by_pk?: Maybe<Tickets_Automation_Ticket_Store>
  /** delete data from the table: "dca_account_allocation" */
  delete_tickets_dca_account_allocation?: Maybe<Tickets_Dca_Account_Allocation_Mutation_Response>
  /** delete single row from the table: "dca_account_allocation" */
  delete_tickets_dca_account_allocation_by_pk?: Maybe<Tickets_Dca_Account_Allocation>
  /** delete data from the table: "dca_allocation_configuration" */
  delete_tickets_dca_allocation_configuration?: Maybe<Tickets_Dca_Allocation_Configuration_Mutation_Response>
  /** delete single row from the table: "dca_allocation_configuration" */
  delete_tickets_dca_allocation_configuration_by_pk?: Maybe<Tickets_Dca_Allocation_Configuration>
  /** delete data from the table: "dca_configuration_v2" */
  delete_tickets_dca_configuration_v2?: Maybe<Tickets_Dca_Configuration_V2_Mutation_Response>
  /** delete single row from the table: "dca_configuration_v2" */
  delete_tickets_dca_configuration_v2_by_pk?: Maybe<Tickets_Dca_Configuration_V2>
  /** delete data from the table: "dca_segmentation" */
  delete_tickets_dca_segmentation?: Maybe<Tickets_Dca_Segmentation_Mutation_Response>
  /** delete single row from the table: "dca_segmentation" */
  delete_tickets_dca_segmentation_by_pk?: Maybe<Tickets_Dca_Segmentation>
  /** delete data from the table: "dunning_account_store" */
  delete_tickets_dunning_account_store?: Maybe<Tickets_Dunning_Account_Store_Mutation_Response>
  /** delete single row from the table: "dunning_account_store" */
  delete_tickets_dunning_account_store_by_pk?: Maybe<Tickets_Dunning_Account_Store>
  /** delete data from the table: "dunning_addacs_review_records" */
  delete_tickets_dunning_addacs_review_records?: Maybe<Tickets_Dunning_Addacs_Review_Records_Mutation_Response>
  /** delete single row from the table: "dunning_addacs_review_records" */
  delete_tickets_dunning_addacs_review_records_by_pk?: Maybe<Tickets_Dunning_Addacs_Review_Records>
  /** delete data from the table: "dunning_automation_events" */
  delete_tickets_dunning_automation_events?: Maybe<Tickets_Dunning_Automation_Events_Mutation_Response>
  /** delete single row from the table: "dunning_automation_events" */
  delete_tickets_dunning_automation_events_by_pk?: Maybe<Tickets_Dunning_Automation_Events>
  /** delete data from the table: "dunning_debt_ticket_review_records" */
  delete_tickets_dunning_debt_ticket_review_records?: Maybe<Tickets_Dunning_Debt_Ticket_Review_Records_Mutation_Response>
  /** delete single row from the table: "dunning_debt_ticket_review_records" */
  delete_tickets_dunning_debt_ticket_review_records_by_pk?: Maybe<Tickets_Dunning_Debt_Ticket_Review_Records>
  /** delete data from the table: "dunning_job" */
  delete_tickets_dunning_job?: Maybe<Tickets_Dunning_Job_Mutation_Response>
  /** delete single row from the table: "dunning_job" */
  delete_tickets_dunning_job_by_pk?: Maybe<Tickets_Dunning_Job>
  /** delete data from the table: "dunning_legal_known_ticket_records" */
  delete_tickets_dunning_legal_known_ticket_records?: Maybe<Tickets_Dunning_Legal_Known_Ticket_Records_Mutation_Response>
  /** delete single row from the table: "dunning_legal_known_ticket_records" */
  delete_tickets_dunning_legal_known_ticket_records_by_pk?: Maybe<Tickets_Dunning_Legal_Known_Ticket_Records>
  /** delete data from the table: "dunning_legal_occupier_ticket_records" */
  delete_tickets_dunning_legal_occupier_ticket_records?: Maybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Mutation_Response>
  /** delete single row from the table: "dunning_legal_occupier_ticket_records" */
  delete_tickets_dunning_legal_occupier_ticket_records_by_pk?: Maybe<Tickets_Dunning_Legal_Occupier_Ticket_Records>
  /** delete data from the table: "dunning_occupier_accounts_review_records" */
  delete_tickets_dunning_occupier_accounts_review_records?: Maybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Mutation_Response>
  /** delete single row from the table: "dunning_occupier_accounts_review_records" */
  delete_tickets_dunning_occupier_accounts_review_records_by_pk?: Maybe<Tickets_Dunning_Occupier_Accounts_Review_Records>
  /** delete data from the table: "dunning_purge_job" */
  delete_tickets_dunning_purge_job?: Maybe<Tickets_Dunning_Purge_Job_Mutation_Response>
  /** delete single row from the table: "dunning_purge_job" */
  delete_tickets_dunning_purge_job_by_pk?: Maybe<Tickets_Dunning_Purge_Job>
  /** delete data from the table: "dunning_standard_ticket_records" */
  delete_tickets_dunning_standard_ticket_records?: Maybe<Tickets_Dunning_Standard_Ticket_Records_Mutation_Response>
  /** delete single row from the table: "dunning_standard_ticket_records" */
  delete_tickets_dunning_standard_ticket_records_by_pk?: Maybe<Tickets_Dunning_Standard_Ticket_Records>
  /** delete data from the table: "dunning_statistics" */
  delete_tickets_dunning_statistics?: Maybe<Tickets_Dunning_Statistics_Mutation_Response>
  /** delete single row from the table: "dunning_statistics" */
  delete_tickets_dunning_statistics_by_pk?: Maybe<Tickets_Dunning_Statistics>
  /** delete data from the table: "dunning_terminating_accounts_review_records" */
  delete_tickets_dunning_terminating_accounts_review_records?: Maybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Mutation_Response>
  /** delete single row from the table: "dunning_terminating_accounts_review_records" */
  delete_tickets_dunning_terminating_accounts_review_records_by_pk?: Maybe<Tickets_Dunning_Terminating_Accounts_Review_Records>
  /** delete data from the table: "dunning_ticket_store" */
  delete_tickets_dunning_ticket_store?: Maybe<Tickets_Dunning_Ticket_Store_Mutation_Response>
  /** delete single row from the table: "dunning_ticket_store" */
  delete_tickets_dunning_ticket_store_by_pk?: Maybe<Tickets_Dunning_Ticket_Store>
  /** delete data from the table: "dunning_workflow" */
  delete_tickets_dunning_workflow?: Maybe<Tickets_Dunning_Workflow_Mutation_Response>
  /** delete single row from the table: "dunning_workflow" */
  delete_tickets_dunning_workflow_by_pk?: Maybe<Tickets_Dunning_Workflow>
  /** delete data from the table: "external_event" */
  delete_tickets_external_event?: Maybe<Tickets_External_Event_Mutation_Response>
  /** delete single row from the table: "external_event" */
  delete_tickets_external_event_by_pk?: Maybe<Tickets_External_Event>
  /** delete data from the table: "external_tickets" */
  delete_tickets_external_tickets?: Maybe<Tickets_External_Tickets_Mutation_Response>
  /** delete single row from the table: "external_tickets" */
  delete_tickets_external_tickets_by_pk?: Maybe<Tickets_External_Tickets>
  /** delete data from the table: "qrtz_blob_triggers" */
  delete_tickets_qrtz_blob_triggers?: Maybe<Tickets_Qrtz_Blob_Triggers_Mutation_Response>
  /** delete single row from the table: "qrtz_blob_triggers" */
  delete_tickets_qrtz_blob_triggers_by_pk?: Maybe<Tickets_Qrtz_Blob_Triggers>
  /** delete data from the table: "qrtz_calendars" */
  delete_tickets_qrtz_calendars?: Maybe<Tickets_Qrtz_Calendars_Mutation_Response>
  /** delete single row from the table: "qrtz_calendars" */
  delete_tickets_qrtz_calendars_by_pk?: Maybe<Tickets_Qrtz_Calendars>
  /** delete data from the table: "qrtz_cron_triggers" */
  delete_tickets_qrtz_cron_triggers?: Maybe<Tickets_Qrtz_Cron_Triggers_Mutation_Response>
  /** delete single row from the table: "qrtz_cron_triggers" */
  delete_tickets_qrtz_cron_triggers_by_pk?: Maybe<Tickets_Qrtz_Cron_Triggers>
  /** delete data from the table: "qrtz_fired_triggers" */
  delete_tickets_qrtz_fired_triggers?: Maybe<Tickets_Qrtz_Fired_Triggers_Mutation_Response>
  /** delete single row from the table: "qrtz_fired_triggers" */
  delete_tickets_qrtz_fired_triggers_by_pk?: Maybe<Tickets_Qrtz_Fired_Triggers>
  /** delete data from the table: "qrtz_job_details" */
  delete_tickets_qrtz_job_details?: Maybe<Tickets_Qrtz_Job_Details_Mutation_Response>
  /** delete single row from the table: "qrtz_job_details" */
  delete_tickets_qrtz_job_details_by_pk?: Maybe<Tickets_Qrtz_Job_Details>
  /** delete data from the table: "qrtz_locks" */
  delete_tickets_qrtz_locks?: Maybe<Tickets_Qrtz_Locks_Mutation_Response>
  /** delete single row from the table: "qrtz_locks" */
  delete_tickets_qrtz_locks_by_pk?: Maybe<Tickets_Qrtz_Locks>
  /** delete data from the table: "qrtz_paused_trigger_grps" */
  delete_tickets_qrtz_paused_trigger_grps?: Maybe<Tickets_Qrtz_Paused_Trigger_Grps_Mutation_Response>
  /** delete single row from the table: "qrtz_paused_trigger_grps" */
  delete_tickets_qrtz_paused_trigger_grps_by_pk?: Maybe<Tickets_Qrtz_Paused_Trigger_Grps>
  /** delete data from the table: "qrtz_scheduler_state" */
  delete_tickets_qrtz_scheduler_state?: Maybe<Tickets_Qrtz_Scheduler_State_Mutation_Response>
  /** delete single row from the table: "qrtz_scheduler_state" */
  delete_tickets_qrtz_scheduler_state_by_pk?: Maybe<Tickets_Qrtz_Scheduler_State>
  /** delete data from the table: "qrtz_simple_triggers" */
  delete_tickets_qrtz_simple_triggers?: Maybe<Tickets_Qrtz_Simple_Triggers_Mutation_Response>
  /** delete single row from the table: "qrtz_simple_triggers" */
  delete_tickets_qrtz_simple_triggers_by_pk?: Maybe<Tickets_Qrtz_Simple_Triggers>
  /** delete data from the table: "qrtz_simprop_triggers" */
  delete_tickets_qrtz_simprop_triggers?: Maybe<Tickets_Qrtz_Simprop_Triggers_Mutation_Response>
  /** delete single row from the table: "qrtz_simprop_triggers" */
  delete_tickets_qrtz_simprop_triggers_by_pk?: Maybe<Tickets_Qrtz_Simprop_Triggers>
  /** delete data from the table: "qrtz_triggers" */
  delete_tickets_qrtz_triggers?: Maybe<Tickets_Qrtz_Triggers_Mutation_Response>
  /** delete single row from the table: "qrtz_triggers" */
  delete_tickets_qrtz_triggers_by_pk?: Maybe<Tickets_Qrtz_Triggers>
  /** delete data from the table: "trustpilot_invitations" */
  delete_trustpilot_invitations?: Maybe<Trustpilot_Invitations_Mutation_Response>
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>
  /** delete data from the table: "uswitch_record" */
  delete_uswitch_record?: Maybe<Uswitch_Record_Mutation_Response>
  /** delete single row from the table: "uswitch_record" */
  delete_uswitch_record_by_pk?: Maybe<Uswitch_Record>
  /** delete data from the table: "warm_home_discount_application" */
  delete_warm_home_discount_application?: Maybe<Warm_Home_Discount_Application_Mutation_Response>
  /** delete single row from the table: "warm_home_discount_application" */
  delete_warm_home_discount_application_by_pk?: Maybe<Warm_Home_Discount_Application>
  /** delete data from the table: "warm_home_discount_application_status_history" */
  delete_warm_home_discount_application_status_history?: Maybe<Warm_Home_Discount_Application_Status_History_Mutation_Response>
  /** delete single row from the table: "warm_home_discount_application_status_history" */
  delete_warm_home_discount_application_status_history_by_pk?: Maybe<Warm_Home_Discount_Application_Status_History>
  /** delete data from the table: "warm_home_discount_criteria" */
  delete_warm_home_discount_criteria?: Maybe<Warm_Home_Discount_Criteria_Mutation_Response>
  /** delete single row from the table: "warm_home_discount_criteria" */
  delete_warm_home_discount_criteria_by_pk?: Maybe<Warm_Home_Discount_Criteria>
  /** delete data from the table: "warm_home_discount_criteria_rel" */
  delete_warm_home_discount_criteria_rel?: Maybe<Warm_Home_Discount_Criteria_Rel_Mutation_Response>
  /** delete single row from the table: "warm_home_discount_criteria_rel" */
  delete_warm_home_discount_criteria_rel_by_pk?: Maybe<Warm_Home_Discount_Criteria_Rel>
  getApplications?: Maybe<Array<Maybe<WhdApplicationsResponse>>>
  /** insert data into the table: "ElecNominations" */
  insert_ElecNominations?: Maybe<ElecNominations_Mutation_Response>
  /** insert a single row into the table: "ElecNominations" */
  insert_ElecNominations_one?: Maybe<ElecNominations>
  /** insert data into the table: "ElecTrades" */
  insert_ElecTrades?: Maybe<ElecTrades_Mutation_Response>
  /** insert data into the table: "ElecTradesHistory" */
  insert_ElecTradesHistory?: Maybe<ElecTradesHistory_Mutation_Response>
  /** insert a single row into the table: "ElecTradesHistory" */
  insert_ElecTradesHistory_one?: Maybe<ElecTradesHistory>
  /** insert a single row into the table: "ElecTrades" */
  insert_ElecTrades_one?: Maybe<ElecTrades>
  /** insert data into the table: "GasTrades" */
  insert_GasTrades?: Maybe<GasTrades_Mutation_Response>
  /** insert data into the table: "GasTradesHistory" */
  insert_GasTradesHistory?: Maybe<GasTradesHistory_Mutation_Response>
  /** insert a single row into the table: "GasTradesHistory" */
  insert_GasTradesHistory_one?: Maybe<GasTradesHistory>
  /** insert a single row into the table: "GasTrades" */
  insert_GasTrades_one?: Maybe<GasTrades>
  /** insert data into the table: "account_credit" */
  insert_account_credit?: Maybe<Account_Credit_Mutation_Response>
  /** insert a single row into the table: "account_credit" */
  insert_account_credit_one?: Maybe<Account_Credit>
  /** insert data into the table: "active_outbound_photo_request" */
  insert_active_outbound_photo_request?: Maybe<Active_Outbound_Photo_Request_Mutation_Response>
  /** insert a single row into the table: "active_outbound_photo_request" */
  insert_active_outbound_photo_request_one?: Maybe<Active_Outbound_Photo_Request>
  /** insert data into the table: "address" */
  insert_address?: Maybe<Address_Mutation_Response>
  /** insert a single row into the table: "address" */
  insert_address_one?: Maybe<Address>
  /** insert data into the table: "admin_passes" */
  insert_admin_passes?: Maybe<Admin_Passes_Mutation_Response>
  /** insert a single row into the table: "admin_passes" */
  insert_admin_passes_one?: Maybe<Admin_Passes>
  /** insert data into the table: "admin_roles" */
  insert_admin_roles?: Maybe<Admin_Roles_Mutation_Response>
  /** insert a single row into the table: "admin_roles" */
  insert_admin_roles_one?: Maybe<Admin_Roles>
  /** insert data into the table: "agreement" */
  insert_agreement?: Maybe<Agreement_Mutation_Response>
  /** insert a single row into the table: "agreement" */
  insert_agreement_one?: Maybe<Agreement>
  /** insert data into the table: "asset" */
  insert_asset?: Maybe<Asset_Mutation_Response>
  /** insert a single row into the table: "asset" */
  insert_asset_one?: Maybe<Asset>
  /** insert data into the table: "attachment" */
  insert_attachment?: Maybe<Attachment_Mutation_Response>
  /** insert a single row into the table: "attachment" */
  insert_attachment_one?: Maybe<Attachment>
  /** insert data into the table: "axle_trial_eligibility" */
  insert_axle_trial_eligibility?: Maybe<Axle_Trial_Eligibility_Mutation_Response>
  /** insert a single row into the table: "axle_trial_eligibility" */
  insert_axle_trial_eligibility_one?: Maybe<Axle_Trial_Eligibility>
  /** insert data into the table: "bill" */
  insert_bill?: Maybe<Bill_Mutation_Response>
  /** insert a single row into the table: "bill" */
  insert_bill_one?: Maybe<Bill>
  /** insert data into the table: "billing_account" */
  insert_billing_account?: Maybe<Billing_Account_Mutation_Response>
  /** insert data into the table: "billing_account_contact" */
  insert_billing_account_contact?: Maybe<Billing_Account_Contact_Mutation_Response>
  /** insert a single row into the table: "billing_account_contact" */
  insert_billing_account_contact_one?: Maybe<Billing_Account_Contact>
  /** insert a single row into the table: "billing_account" */
  insert_billing_account_one?: Maybe<Billing_Account>
  /** insert data into the table: "billing_account_setting" */
  insert_billing_account_setting?: Maybe<Billing_Account_Setting_Mutation_Response>
  /** insert a single row into the table: "billing_account_setting" */
  insert_billing_account_setting_one?: Maybe<Billing_Account_Setting>
  /** insert data into the table: "billing_account_transaction" */
  insert_billing_account_transaction?: Maybe<Billing_Account_Transaction_Mutation_Response>
  /** insert a single row into the table: "billing_account_transaction" */
  insert_billing_account_transaction_one?: Maybe<Billing_Account_Transaction>
  /** insert data into the table: "billing_period" */
  insert_billing_period?: Maybe<Billing_Period_Mutation_Response>
  /** insert a single row into the table: "billing_period" */
  insert_billing_period_one?: Maybe<Billing_Period>
  /** insert data into the table: "calculation_items" */
  insert_calculation_items?: Maybe<Calculation_Items_Mutation_Response>
  /** insert a single row into the table: "calculation_items" */
  insert_calculation_items_one?: Maybe<Calculation_Items>
  /** insert data into the table: "call_trace_audit" */
  insert_call_trace_audit?: Maybe<Call_Trace_Audit_Mutation_Response>
  /** insert a single row into the table: "call_trace_audit" */
  insert_call_trace_audit_one?: Maybe<Call_Trace_Audit>
  /** insert data into the table: "cancellation_reasons" */
  insert_cancellation_reasons?: Maybe<Cancellation_Reasons_Mutation_Response>
  /** insert a single row into the table: "cancellation_reasons" */
  insert_cancellation_reasons_one?: Maybe<Cancellation_Reasons>
  /** insert data into the table: "cancellations" */
  insert_cancellations?: Maybe<Cancellations_Mutation_Response>
  /** insert a single row into the table: "cancellations" */
  insert_cancellations_one?: Maybe<Cancellations>
  /** insert data into the table: "card_payment" */
  insert_card_payment?: Maybe<Card_Payment_Mutation_Response>
  /** insert data into the table: "card_payment_old" */
  insert_card_payment_old?: Maybe<Card_Payment_Old_Mutation_Response>
  /** insert a single row into the table: "card_payment_old" */
  insert_card_payment_old_one?: Maybe<Card_Payment_Old>
  /** insert a single row into the table: "card_payment" */
  insert_card_payment_one?: Maybe<Card_Payment>
  /** insert data into the table: "cases" */
  insert_cases?: Maybe<Cases_Mutation_Response>
  /** insert a single row into the table: "cases" */
  insert_cases_one?: Maybe<Cases>
  /** insert data into the table: "communication" */
  insert_communication?: Maybe<Communication_Mutation_Response>
  /** insert data into the table: "communication_metadata" */
  insert_communication_metadata?: Maybe<Communication_Metadata_Mutation_Response>
  /** insert a single row into the table: "communication_metadata" */
  insert_communication_metadata_one?: Maybe<Communication_Metadata>
  /** insert a single row into the table: "communication" */
  insert_communication_one?: Maybe<Communication>
  /** insert data into the table: "communications" */
  insert_communications?: Maybe<Communications_Mutation_Response>
  /** insert a single row into the table: "communications" */
  insert_communications_one?: Maybe<Communications>
  /** insert data into the table: "complaint" */
  insert_complaint?: Maybe<Complaint_Mutation_Response>
  /** insert a single row into the table: "complaint" */
  insert_complaint_one?: Maybe<Complaint>
  /** insert data into the table: "completed_sync_event_account" */
  insert_completed_sync_event_account?: Maybe<Completed_Sync_Event_Account_Mutation_Response>
  /** insert a single row into the table: "completed_sync_event_account" */
  insert_completed_sync_event_account_one?: Maybe<Completed_Sync_Event_Account>
  /** insert data into the table: "configuration" */
  insert_configuration?: Maybe<Configuration_Mutation_Response>
  /** insert a single row into the table: "configuration" */
  insert_configuration_one?: Maybe<Configuration>
  /** insert data into the table: "contact" */
  insert_contact?: Maybe<Contact_Mutation_Response>
  /** insert a single row into the table: "contact" */
  insert_contact_one?: Maybe<Contact>
  /** insert data into the table: "cs__soe_dashboard_total" */
  insert_cs__soe_dashboard_total?: Maybe<Cs__Soe_Dashboard_Total_Mutation_Response>
  /** insert a single row into the table: "cs__soe_dashboard_total" */
  insert_cs__soe_dashboard_total_one?: Maybe<Cs__Soe_Dashboard_Total>
  /** insert data into the table: "customer" */
  insert_customer?: Maybe<Customer_Mutation_Response>
  /** insert data into the table: "address" */
  insert_customer_address?: Maybe<Customer_Address_Mutation_Response>
  /** insert a single row into the table: "address" */
  insert_customer_address_one?: Maybe<Customer_Address>
  /** insert data into the table: "customer_contact" */
  insert_customer_contact?: Maybe<Customer_Contact_Mutation_Response>
  /** insert a single row into the table: "customer_contact" */
  insert_customer_contact_one?: Maybe<Customer_Contact>
  /** insert data into the table: "customer_metadata" */
  insert_customer_metadata?: Maybe<Customer_Metadata_Mutation_Response>
  /** insert a single row into the table: "customer_metadata" */
  insert_customer_metadata_one?: Maybe<Customer_Metadata>
  /** insert a single row into the table: "customer" */
  insert_customer_one?: Maybe<Customer>
  /** insert data into the table: "customer_property_rel" */
  insert_customer_property_rel?: Maybe<Customer_Property_Rel_Mutation_Response>
  /** insert a single row into the table: "customer_property_rel" */
  insert_customer_property_rel_one?: Maybe<Customer_Property_Rel>
  /** insert data into the table: "customer_psr_rel" */
  insert_customer_psr_rel?: Maybe<Customer_Psr_Rel_Mutation_Response>
  /** insert a single row into the table: "customer_psr_rel" */
  insert_customer_psr_rel_one?: Maybe<Customer_Psr_Rel>
  /** insert data into the table: "customer_referrals" */
  insert_customer_referrals?: Maybe<Customer_Referrals_Mutation_Response>
  /** insert a single row into the table: "customer_referrals" */
  insert_customer_referrals_one?: Maybe<Customer_Referrals>
  /** insert data into the table: "customer_setting" */
  insert_customer_setting?: Maybe<Customer_Setting_Mutation_Response>
  /** insert a single row into the table: "customer_setting" */
  insert_customer_setting_one?: Maybe<Customer_Setting>
  /** insert data into the table: "customer_user_rel" */
  insert_customer_user_rel?: Maybe<Customer_User_Rel_Mutation_Response>
  /** insert a single row into the table: "customer_user_rel" */
  insert_customer_user_rel_one?: Maybe<Customer_User_Rel>
  /** insert data into the table: "deprecated_solar_quote_requests" */
  insert_deprecated_solar_quote_requests?: Maybe<Deprecated_Solar_Quote_Requests_Mutation_Response>
  /** insert a single row into the table: "deprecated_solar_quote_requests" */
  insert_deprecated_solar_quote_requests_one?: Maybe<Deprecated_Solar_Quote_Requests>
  /** insert data into the table: "direct_debit" */
  insert_direct_debit?: Maybe<Direct_Debit_Mutation_Response>
  /** insert a single row into the table: "direct_debit" */
  insert_direct_debit_one?: Maybe<Direct_Debit>
  /** insert data into the table: "direct_debit_payment" */
  insert_direct_debit_payment?: Maybe<Direct_Debit_Payment_Mutation_Response>
  /** insert a single row into the table: "direct_debit_payment" */
  insert_direct_debit_payment_one?: Maybe<Direct_Debit_Payment>
  /** insert data into the table: "email_messages" */
  insert_email_messages?: Maybe<Email_Messages_Mutation_Response>
  /** insert a single row into the table: "email_messages" */
  insert_email_messages_one?: Maybe<Email_Messages>
  /** insert data into the table: "email_templates" */
  insert_email_templates?: Maybe<Email_Templates_Mutation_Response>
  /** insert data into the table: "email_templates_ext" */
  insert_email_templates_ext?: Maybe<Email_Templates_Ext_Mutation_Response>
  /** insert a single row into the table: "email_templates_ext" */
  insert_email_templates_ext_one?: Maybe<Email_Templates_Ext>
  /** insert a single row into the table: "email_templates" */
  insert_email_templates_one?: Maybe<Email_Templates>
  /** insert data into the table: "energy_usage_load_factors" */
  insert_energy_usage_load_factors?: Maybe<Energy_Usage_Load_Factors_Mutation_Response>
  /** insert a single row into the table: "energy_usage_load_factors" */
  insert_energy_usage_load_factors_one?: Maybe<Energy_Usage_Load_Factors>
  /** insert data into the table: "enrolment" */
  insert_enrolment?: Maybe<Enrolment_Mutation_Response>
  /** insert data into the table: "enrolment_automated_communications" */
  insert_enrolment_automated_communications?: Maybe<Enrolment_Automated_Communications_Mutation_Response>
  /** insert a single row into the table: "enrolment_automated_communications" */
  insert_enrolment_automated_communications_one?: Maybe<Enrolment_Automated_Communications>
  /** insert a single row into the table: "enrolment" */
  insert_enrolment_one?: Maybe<Enrolment>
  /** insert data into the table: "entity_mappings" */
  insert_entity_mappings?: Maybe<Entity_Mappings_Mutation_Response>
  /** insert a single row into the table: "entity_mappings" */
  insert_entity_mappings_one?: Maybe<Entity_Mappings>
  /** insert data into the table: "estimated_usage" */
  insert_estimated_usage?: Maybe<Estimated_Usage_Mutation_Response>
  /** insert a single row into the table: "estimated_usage" */
  insert_estimated_usage_one?: Maybe<Estimated_Usage>
  /** insert data into the table: "ev_smart_tariff_waitlist" */
  insert_ev_smart_tariff_waitlist?: Maybe<Ev_Smart_Tariff_Waitlist_Mutation_Response>
  /** insert a single row into the table: "ev_smart_tariff_waitlist" */
  insert_ev_smart_tariff_waitlist_one?: Maybe<Ev_Smart_Tariff_Waitlist>
  /** insert data into the table: "ev_tariff_eligibility_checks" */
  insert_ev_tariff_eligibility_checks?: Maybe<Ev_Tariff_Eligibility_Checks_Mutation_Response>
  /** insert a single row into the table: "ev_tariff_eligibility_checks" */
  insert_ev_tariff_eligibility_checks_one?: Maybe<Ev_Tariff_Eligibility_Checks>
  /** insert data into the table: "feature" */
  insert_feature?: Maybe<Feature_Mutation_Response>
  /** insert a single row into the table: "feature" */
  insert_feature_one?: Maybe<Feature>
  /** insert data into the table: "configuration" */
  insert_financials_configuration?: Maybe<Financials_Configuration_Mutation_Response>
  /** insert a single row into the table: "configuration" */
  insert_financials_configuration_one?: Maybe<Financials_Configuration>
  /** insert data into the table: "qrtz_blob_triggers" */
  insert_financials_qrtz_blob_triggers?: Maybe<Financials_Qrtz_Blob_Triggers_Mutation_Response>
  /** insert a single row into the table: "qrtz_blob_triggers" */
  insert_financials_qrtz_blob_triggers_one?: Maybe<Financials_Qrtz_Blob_Triggers>
  /** insert data into the table: "qrtz_calendars" */
  insert_financials_qrtz_calendars?: Maybe<Financials_Qrtz_Calendars_Mutation_Response>
  /** insert a single row into the table: "qrtz_calendars" */
  insert_financials_qrtz_calendars_one?: Maybe<Financials_Qrtz_Calendars>
  /** insert data into the table: "qrtz_cron_triggers" */
  insert_financials_qrtz_cron_triggers?: Maybe<Financials_Qrtz_Cron_Triggers_Mutation_Response>
  /** insert a single row into the table: "qrtz_cron_triggers" */
  insert_financials_qrtz_cron_triggers_one?: Maybe<Financials_Qrtz_Cron_Triggers>
  /** insert data into the table: "qrtz_fired_triggers" */
  insert_financials_qrtz_fired_triggers?: Maybe<Financials_Qrtz_Fired_Triggers_Mutation_Response>
  /** insert a single row into the table: "qrtz_fired_triggers" */
  insert_financials_qrtz_fired_triggers_one?: Maybe<Financials_Qrtz_Fired_Triggers>
  /** insert data into the table: "qrtz_job_details" */
  insert_financials_qrtz_job_details?: Maybe<Financials_Qrtz_Job_Details_Mutation_Response>
  /** insert a single row into the table: "qrtz_job_details" */
  insert_financials_qrtz_job_details_one?: Maybe<Financials_Qrtz_Job_Details>
  /** insert data into the table: "qrtz_scheduler_state" */
  insert_financials_qrtz_scheduler_state?: Maybe<Financials_Qrtz_Scheduler_State_Mutation_Response>
  /** insert a single row into the table: "qrtz_scheduler_state" */
  insert_financials_qrtz_scheduler_state_one?: Maybe<Financials_Qrtz_Scheduler_State>
  /** insert data into the table: "qrtz_simple_triggers" */
  insert_financials_qrtz_simple_triggers?: Maybe<Financials_Qrtz_Simple_Triggers_Mutation_Response>
  /** insert a single row into the table: "qrtz_simple_triggers" */
  insert_financials_qrtz_simple_triggers_one?: Maybe<Financials_Qrtz_Simple_Triggers>
  /** insert data into the table: "qrtz_simprop_triggers" */
  insert_financials_qrtz_simprop_triggers?: Maybe<Financials_Qrtz_Simprop_Triggers_Mutation_Response>
  /** insert a single row into the table: "qrtz_simprop_triggers" */
  insert_financials_qrtz_simprop_triggers_one?: Maybe<Financials_Qrtz_Simprop_Triggers>
  /** insert data into the table: "qrtz_triggers" */
  insert_financials_qrtz_triggers?: Maybe<Financials_Qrtz_Triggers_Mutation_Response>
  /** insert a single row into the table: "qrtz_triggers" */
  insert_financials_qrtz_triggers_one?: Maybe<Financials_Qrtz_Triggers>
  /** insert data into the table: "warrant_account_criteria" */
  insert_financials_warrant_account_criteria?: Maybe<Financials_Warrant_Account_Criteria_Mutation_Response>
  /** insert a single row into the table: "warrant_account_criteria" */
  insert_financials_warrant_account_criteria_one?: Maybe<Financials_Warrant_Account_Criteria>
  /** insert data into the table: "warrant_account_sync_criteria" */
  insert_financials_warrant_account_sync_criteria?: Maybe<Financials_Warrant_Account_Sync_Criteria_Mutation_Response>
  /** insert a single row into the table: "warrant_account_sync_criteria" */
  insert_financials_warrant_account_sync_criteria_one?: Maybe<Financials_Warrant_Account_Sync_Criteria>
  /** insert data into the table: "warrant_communications_sent_count" */
  insert_financials_warrant_communications_sent_count?: Maybe<Financials_Warrant_Communications_Sent_Count_Mutation_Response>
  /** insert a single row into the table: "warrant_communications_sent_count" */
  insert_financials_warrant_communications_sent_count_one?: Maybe<Financials_Warrant_Communications_Sent_Count>
  /** insert data into the table: "warrants_accounts" */
  insert_financials_warrants_accounts?: Maybe<Financials_Warrants_Accounts_Mutation_Response>
  /** insert data into the table: "warrants_accounts_history" */
  insert_financials_warrants_accounts_history?: Maybe<Financials_Warrants_Accounts_History_Mutation_Response>
  /** insert a single row into the table: "warrants_accounts_history" */
  insert_financials_warrants_accounts_history_one?: Maybe<Financials_Warrants_Accounts_History>
  /** insert a single row into the table: "warrants_accounts" */
  insert_financials_warrants_accounts_one?: Maybe<Financials_Warrants_Accounts>
  /** insert data into the table: "warrants_accounts_whitelist" */
  insert_financials_warrants_accounts_whitelist?: Maybe<Financials_Warrants_Accounts_Whitelist_Mutation_Response>
  /** insert a single row into the table: "warrants_accounts_whitelist" */
  insert_financials_warrants_accounts_whitelist_one?: Maybe<Financials_Warrants_Accounts_Whitelist>
  /** insert data into the table: "warrants_communication_group" */
  insert_financials_warrants_communication_group?: Maybe<Financials_Warrants_Communication_Group_Mutation_Response>
  /** insert a single row into the table: "warrants_communication_group" */
  insert_financials_warrants_communication_group_one?: Maybe<Financials_Warrants_Communication_Group>
  /** insert data into the table: "warrants_communications" */
  insert_financials_warrants_communications?: Maybe<Financials_Warrants_Communications_Mutation_Response>
  /** insert a single row into the table: "warrants_communications" */
  insert_financials_warrants_communications_one?: Maybe<Financials_Warrants_Communications>
  /** insert data into the table: "warrants_dca_queue" */
  insert_financials_warrants_dca_queue?: Maybe<Financials_Warrants_Dca_Queue_Mutation_Response>
  /** insert a single row into the table: "warrants_dca_queue" */
  insert_financials_warrants_dca_queue_one?: Maybe<Financials_Warrants_Dca_Queue>
  /** insert data into the table: "warrants_dca_tickets" */
  insert_financials_warrants_dca_tickets?: Maybe<Financials_Warrants_Dca_Tickets_Mutation_Response>
  /** insert a single row into the table: "warrants_dca_tickets" */
  insert_financials_warrants_dca_tickets_one?: Maybe<Financials_Warrants_Dca_Tickets>
  /** insert data into the table: "warrants_files_account" */
  insert_financials_warrants_files_account?: Maybe<Financials_Warrants_Files_Account_Mutation_Response>
  /** insert a single row into the table: "warrants_files_account" */
  insert_financials_warrants_files_account_one?: Maybe<Financials_Warrants_Files_Account>
  /** insert data into the table: "warrants_files_job" */
  insert_financials_warrants_files_job?: Maybe<Financials_Warrants_Files_Job_Mutation_Response>
  /** insert a single row into the table: "warrants_files_job" */
  insert_financials_warrants_files_job_one?: Maybe<Financials_Warrants_Files_Job>
  /** insert data into the table: "warrants_files_processed" */
  insert_financials_warrants_files_processed?: Maybe<Financials_Warrants_Files_Processed_Mutation_Response>
  /** insert a single row into the table: "warrants_files_processed" */
  insert_financials_warrants_files_processed_one?: Maybe<Financials_Warrants_Files_Processed>
  /** insert data into the table: "warrants_job" */
  insert_financials_warrants_job?: Maybe<Financials_Warrants_Job_Mutation_Response>
  /** insert a single row into the table: "warrants_job" */
  insert_financials_warrants_job_one?: Maybe<Financials_Warrants_Job>
  /** insert data into the table: "flex_market_subscription" */
  insert_flex_market_subscription?: Maybe<Flex_Market_Subscription_Mutation_Response>
  /** insert data into the table: "flex_market_subscription_billing" */
  insert_flex_market_subscription_billing?: Maybe<Flex_Market_Subscription_Billing_Mutation_Response>
  /** insert data into the table: "flex_market_subscription_billing_component" */
  insert_flex_market_subscription_billing_component?: Maybe<Flex_Market_Subscription_Billing_Component_Mutation_Response>
  /** insert a single row into the table: "flex_market_subscription_billing_component" */
  insert_flex_market_subscription_billing_component_one?: Maybe<Flex_Market_Subscription_Billing_Component>
  /** insert a single row into the table: "flex_market_subscription_billing" */
  insert_flex_market_subscription_billing_one?: Maybe<Flex_Market_Subscription_Billing>
  /** insert a single row into the table: "flex_market_subscription" */
  insert_flex_market_subscription_one?: Maybe<Flex_Market_Subscription>
  /** insert data into the table: "flyway_schema_history" */
  insert_flyway_schema_history?: Maybe<Flyway_Schema_History_Mutation_Response>
  /** insert a single row into the table: "flyway_schema_history" */
  insert_flyway_schema_history_one?: Maybe<Flyway_Schema_History>
  /** insert data into the table: "freshdesk_contact" */
  insert_freshdesk_contact?: Maybe<Freshdesk_Contact_Mutation_Response>
  /** insert a single row into the table: "freshdesk_contact" */
  insert_freshdesk_contact_one?: Maybe<Freshdesk_Contact>
  /** insert data into the table: "freshdesk_ticket" */
  insert_freshdesk_ticket?: Maybe<Freshdesk_Ticket_Mutation_Response>
  /** insert a single row into the table: "freshdesk_ticket" */
  insert_freshdesk_ticket_one?: Maybe<Freshdesk_Ticket>
  /** insert data into the table: "install_codes" */
  insert_install_codes?: Maybe<Install_Codes_Mutation_Response>
  /** insert a single row into the table: "install_codes" */
  insert_install_codes_one?: Maybe<Install_Codes>
  /** insert data into the table: "junifer__Account" */
  insert_junifer__Account?: Maybe<Junifer__Account_Mutation_Response>
  /** insert data into the table: "junifer__AccountTransaction" */
  insert_junifer__AccountTransaction?: Maybe<Junifer__AccountTransaction_Mutation_Response>
  /** insert a single row into the table: "junifer__AccountTransaction" */
  insert_junifer__AccountTransaction_one?: Maybe<Junifer__AccountTransaction>
  /** insert a single row into the table: "junifer__Account" */
  insert_junifer__Account_one?: Maybe<Junifer__Account>
  /** insert data into the table: "junifer__Customer" */
  insert_junifer__Customer?: Maybe<Junifer__Customer_Mutation_Response>
  /** insert a single row into the table: "junifer__Customer" */
  insert_junifer__Customer_one?: Maybe<Junifer__Customer>
  /** insert data into the table: "meter" */
  insert_meter?: Maybe<Meter_Mutation_Response>
  /** insert data into the table: "meter_meter_point_rel" */
  insert_meter_meter_point_rel?: Maybe<Meter_Meter_Point_Rel_Mutation_Response>
  /** insert a single row into the table: "meter_meter_point_rel" */
  insert_meter_meter_point_rel_one?: Maybe<Meter_Meter_Point_Rel>
  /** insert a single row into the table: "meter" */
  insert_meter_one?: Maybe<Meter>
  /** insert data into the table: "meter_point" */
  insert_meter_point?: Maybe<Meter_Point_Mutation_Response>
  /** insert data into the table: "meter_point_electricity" */
  insert_meter_point_electricity?: Maybe<Meter_Point_Electricity_Mutation_Response>
  /** insert a single row into the table: "meter_point_electricity" */
  insert_meter_point_electricity_one?: Maybe<Meter_Point_Electricity>
  /** insert data into the table: "meter_point_gas" */
  insert_meter_point_gas?: Maybe<Meter_Point_Gas_Mutation_Response>
  /** insert a single row into the table: "meter_point_gas" */
  insert_meter_point_gas_one?: Maybe<Meter_Point_Gas>
  /** insert data into the table: "meter_point_history" */
  insert_meter_point_history?: Maybe<Meter_Point_History_Mutation_Response>
  /** insert a single row into the table: "meter_point_history" */
  insert_meter_point_history_one?: Maybe<Meter_Point_History>
  /** insert a single row into the table: "meter_point" */
  insert_meter_point_one?: Maybe<Meter_Point>
  /** insert data into the table: "meter_reading" */
  insert_meter_reading?: Maybe<Meter_Reading_Mutation_Response>
  /** insert a single row into the table: "meter_reading" */
  insert_meter_reading_one?: Maybe<Meter_Reading>
  /** insert data into the table: "meter_reading_submission_request" */
  insert_meter_reading_submission_request?: Maybe<Meter_Reading_Submission_Request_Mutation_Response>
  /** insert a single row into the table: "meter_reading_submission_request" */
  insert_meter_reading_submission_request_one?: Maybe<Meter_Reading_Submission_Request>
  /** insert data into the table: "meter_reading_submission_tokens" */
  insert_meter_reading_submission_tokens?: Maybe<Meter_Reading_Submission_Tokens_Mutation_Response>
  /** insert a single row into the table: "meter_reading_submission_tokens" */
  insert_meter_reading_submission_tokens_one?: Maybe<Meter_Reading_Submission_Tokens>
  /** insert data into the table: "note" */
  insert_note?: Maybe<Note_Mutation_Response>
  /** insert a single row into the table: "note" */
  insert_note_one?: Maybe<Note>
  /** insert data into the table: "nova_submissions" */
  insert_nova_submissions?: Maybe<Nova_Submissions_Mutation_Response>
  /** insert a single row into the table: "nova_submissions" */
  insert_nova_submissions_one?: Maybe<Nova_Submissions>
  /** insert data into the table: "outbound_photo_request" */
  insert_outbound_photo_request?: Maybe<Outbound_Photo_Request_Mutation_Response>
  /** insert a single row into the table: "outbound_photo_request" */
  insert_outbound_photo_request_one?: Maybe<Outbound_Photo_Request>
  /** insert data into the table: "password_reset_tokens" */
  insert_password_reset_tokens?: Maybe<Password_Reset_Tokens_Mutation_Response>
  /** insert a single row into the table: "password_reset_tokens" */
  insert_password_reset_tokens_one?: Maybe<Password_Reset_Tokens>
  /** insert data into the table: "payment" */
  insert_payment?: Maybe<Payment_Mutation_Response>
  /** insert data into the table: "payment_method" */
  insert_payment_method?: Maybe<Payment_Method_Mutation_Response>
  /** insert a single row into the table: "payment_method" */
  insert_payment_method_one?: Maybe<Payment_Method>
  /** insert a single row into the table: "payment" */
  insert_payment_one?: Maybe<Payment>
  /** insert data into the table: "payment_review_account_balance_reserve_rates" */
  insert_payment_review_account_balance_reserve_rates?: Maybe<Payment_Review_Account_Balance_Reserve_Rates_Mutation_Response>
  /** insert a single row into the table: "payment_review_account_balance_reserve_rates" */
  insert_payment_review_account_balance_reserve_rates_one?: Maybe<Payment_Review_Account_Balance_Reserve_Rates>
  /** insert data into the table: "payment_review_account_exclusions" */
  insert_payment_review_account_exclusions?: Maybe<Payment_Review_Account_Exclusions_Mutation_Response>
  /** insert a single row into the table: "payment_review_account_exclusions" */
  insert_payment_review_account_exclusions_one?: Maybe<Payment_Review_Account_Exclusions>
  /** insert data into the table: "payment_review_calculation" */
  insert_payment_review_calculation?: Maybe<Payment_Review_Calculation_Mutation_Response>
  /** insert a single row into the table: "payment_review_calculation" */
  insert_payment_review_calculation_one?: Maybe<Payment_Review_Calculation>
  /** insert data into the table: "payment_review_future_product_rates" */
  insert_payment_review_future_product_rates?: Maybe<Payment_Review_Future_Product_Rates_Mutation_Response>
  /** insert a single row into the table: "payment_review_future_product_rates" */
  insert_payment_review_future_product_rates_one?: Maybe<Payment_Review_Future_Product_Rates>
  /** insert data into the table: "payment_review_record_emails" */
  insert_payment_review_record_emails?: Maybe<Payment_Review_Record_Emails_Mutation_Response>
  /** insert a single row into the table: "payment_review_record_emails" */
  insert_payment_review_record_emails_one?: Maybe<Payment_Review_Record_Emails>
  /** insert data into the table: "payment_review_record_notes" */
  insert_payment_review_record_notes?: Maybe<Payment_Review_Record_Notes_Mutation_Response>
  /** insert a single row into the table: "payment_review_record_notes" */
  insert_payment_review_record_notes_one?: Maybe<Payment_Review_Record_Notes>
  /** insert data into the table: "payment_review_records" */
  insert_payment_review_records?: Maybe<Payment_Review_Records_Mutation_Response>
  /** insert a single row into the table: "payment_review_records" */
  insert_payment_review_records_one?: Maybe<Payment_Review_Records>
  /** insert data into the table: "payment_reviews" */
  insert_payment_reviews?: Maybe<Payment_Reviews_Mutation_Response>
  /** insert a single row into the table: "payment_reviews" */
  insert_payment_reviews_one?: Maybe<Payment_Reviews>
  /** insert data into the table: "payment_schedule" */
  insert_payment_schedule?: Maybe<Payment_Schedule_Mutation_Response>
  /** insert a single row into the table: "payment_schedule" */
  insert_payment_schedule_one?: Maybe<Payment_Schedule>
  /** insert data into the table: "postcode_gsp_cache" */
  insert_postcode_gsp_cache?: Maybe<Postcode_Gsp_Cache_Mutation_Response>
  /** insert a single row into the table: "postcode_gsp_cache" */
  insert_postcode_gsp_cache_one?: Maybe<Postcode_Gsp_Cache>
  /** insert data into the table: "product" */
  insert_product?: Maybe<Product_Mutation_Response>
  /** insert data into the table: "product_account" */
  insert_product_account?: Maybe<Product_Account_Mutation_Response>
  /** insert data into the table: "product_account_agreement_rel" */
  insert_product_account_agreement_rel?: Maybe<Product_Account_Agreement_Rel_Mutation_Response>
  /** insert a single row into the table: "product_account_agreement_rel" */
  insert_product_account_agreement_rel_one?: Maybe<Product_Account_Agreement_Rel>
  /** insert a single row into the table: "product_account" */
  insert_product_account_one?: Maybe<Product_Account>
  /** insert data into the table: "product_elec" */
  insert_product_elec?: Maybe<Product_Elec_Mutation_Response>
  /** insert a single row into the table: "product_elec" */
  insert_product_elec_one?: Maybe<Product_Elec>
  /** insert data into the table: "product_gas" */
  insert_product_gas?: Maybe<Product_Gas_Mutation_Response>
  /** insert a single row into the table: "product_gas" */
  insert_product_gas_one?: Maybe<Product_Gas>
  /** insert a single row into the table: "product" */
  insert_product_one?: Maybe<Product>
  /** insert data into the table: "product_variant" */
  insert_product_variant?: Maybe<Product_Variant_Mutation_Response>
  /** insert data into the table: "product_variant_elec" */
  insert_product_variant_elec?: Maybe<Product_Variant_Elec_Mutation_Response>
  /** insert a single row into the table: "product_variant_elec" */
  insert_product_variant_elec_one?: Maybe<Product_Variant_Elec>
  /** insert data into the table: "product_variant_gas" */
  insert_product_variant_gas?: Maybe<Product_Variant_Gas_Mutation_Response>
  /** insert a single row into the table: "product_variant_gas" */
  insert_product_variant_gas_one?: Maybe<Product_Variant_Gas>
  /** insert a single row into the table: "product_variant" */
  insert_product_variant_one?: Maybe<Product_Variant>
  /** insert data into the table: "property" */
  insert_property?: Maybe<Property_Mutation_Response>
  /** insert a single row into the table: "property" */
  insert_property_one?: Maybe<Property>
  /** insert data into the table: "psr" */
  insert_psr?: Maybe<Psr_Mutation_Response>
  /** insert a single row into the table: "psr" */
  insert_psr_one?: Maybe<Psr>
  /** insert data into the table: "quote" */
  insert_quote?: Maybe<Quote_Mutation_Response>
  /** insert a single row into the table: "quote" */
  insert_quote_one?: Maybe<Quote>
  /** insert data into the table: "quote_request" */
  insert_quote_request?: Maybe<Quote_Request_Mutation_Response>
  /** insert a single row into the table: "quote_request" */
  insert_quote_request_one?: Maybe<Quote_Request>
  /** insert data into the table: "recipients" */
  insert_recipients?: Maybe<Recipients_Mutation_Response>
  /** insert a single row into the table: "recipients" */
  insert_recipients_one?: Maybe<Recipients>
  /** insert data into the table: "refresh_tokens" */
  insert_refresh_tokens?: Maybe<Refresh_Tokens_Mutation_Response>
  /** insert a single row into the table: "refresh_tokens" */
  insert_refresh_tokens_one?: Maybe<Refresh_Tokens>
  /** insert data into the table: "refunds" */
  insert_refunds?: Maybe<Refunds_Mutation_Response>
  /** insert a single row into the table: "refunds" */
  insert_refunds_one?: Maybe<Refunds>
  /** insert data into the table: "register" */
  insert_register?: Maybe<Register_Mutation_Response>
  /** insert a single row into the table: "register" */
  insert_register_one?: Maybe<Register>
  /** insert data into the table: "registration_credit_check" */
  insert_registration_credit_check?: Maybe<Registration_Credit_Check_Mutation_Response>
  /** insert data into the table: "registration_credit_check_address" */
  insert_registration_credit_check_address?: Maybe<Registration_Credit_Check_Address_Mutation_Response>
  /** insert a single row into the table: "registration_credit_check_address" */
  insert_registration_credit_check_address_one?: Maybe<Registration_Credit_Check_Address>
  /** insert a single row into the table: "registration_credit_check" */
  insert_registration_credit_check_one?: Maybe<Registration_Credit_Check>
  /** insert data into the table: "reminder" */
  insert_reminder?: Maybe<Reminder_Mutation_Response>
  /** insert a single row into the table: "reminder" */
  insert_reminder_one?: Maybe<Reminder>
  /** insert data into the table: "renewal" */
  insert_renewal?: Maybe<Renewal_Mutation_Response>
  /** insert a single row into the table: "renewal" */
  insert_renewal_one?: Maybe<Renewal>
  /** insert data into the table: "report_problem" */
  insert_report_problem?: Maybe<Report_Problem_Mutation_Response>
  /** insert data into the table: "report_problem_attachments" */
  insert_report_problem_attachments?: Maybe<Report_Problem_Attachments_Mutation_Response>
  /** insert a single row into the table: "report_problem_attachments" */
  insert_report_problem_attachments_one?: Maybe<Report_Problem_Attachments>
  /** insert a single row into the table: "report_problem" */
  insert_report_problem_one?: Maybe<Report_Problem>
  /** insert data into the table: "requests" */
  insert_requests?: Maybe<Requests_Mutation_Response>
  /** insert a single row into the table: "requests" */
  insert_requests_one?: Maybe<Requests>
  /** insert data into the table: "rts_meters_report" */
  insert_rts_meters_report?: Maybe<Rts_Meters_Report_Mutation_Response>
  /** insert a single row into the table: "rts_meters_report" */
  insert_rts_meters_report_one?: Maybe<Rts_Meters_Report>
  /** insert data into the table: "scheduled_payment" */
  insert_scheduled_payment?: Maybe<Scheduled_Payment_Mutation_Response>
  /** insert a single row into the table: "scheduled_payment" */
  insert_scheduled_payment_one?: Maybe<Scheduled_Payment>
  /** insert data into the table: "scheduled_refund" */
  insert_scheduled_refund?: Maybe<Scheduled_Refund_Mutation_Response>
  /** insert a single row into the table: "scheduled_refund" */
  insert_scheduled_refund_one?: Maybe<Scheduled_Refund>
  /** insert data into the table: "smart_charging" */
  insert_smart_charging?: Maybe<Smart_Charging_Mutation_Response>
  /** insert a single row into the table: "smart_charging" */
  insert_smart_charging_one?: Maybe<Smart_Charging>
  /** insert data into the table: "smart_meter_dashboard_response_v7" */
  insert_smart_meter_dashboard_response_v7?: Maybe<Smart_Meter_Dashboard_Response_V7_Mutation_Response>
  /** insert a single row into the table: "smart_meter_dashboard_response_v7" */
  insert_smart_meter_dashboard_response_v7_one?: Maybe<Smart_Meter_Dashboard_Response_V7>
  /** insert data into the table: "smart_meters_eligible_for_exchange" */
  insert_smart_meters_eligible_for_exchange?: Maybe<Smart_Meters_Eligible_For_Exchange_Mutation_Response>
  /** insert a single row into the table: "smart_meters_eligible_for_exchange" */
  insert_smart_meters_eligible_for_exchange_one?: Maybe<Smart_Meters_Eligible_For_Exchange>
  /** insert data into the table: "sync_status" */
  insert_sync_status?: Maybe<Sync_Status_Mutation_Response>
  /** insert a single row into the table: "sync_status" */
  insert_sync_status_one?: Maybe<Sync_Status>
  /** insert data into the table: "synchronized_accounts" */
  insert_synchronized_accounts?: Maybe<Synchronized_Accounts_Mutation_Response>
  /** insert a single row into the table: "synchronized_accounts" */
  insert_synchronized_accounts_one?: Maybe<Synchronized_Accounts>
  /** insert data into the table: "ticket" */
  insert_ticket?: Maybe<Ticket_Mutation_Response>
  /** insert a single row into the table: "ticket" */
  insert_ticket_one?: Maybe<Ticket>
  /** insert data into the table: "automation_account_store" */
  insert_tickets_automation_account_store?: Maybe<Tickets_Automation_Account_Store_Mutation_Response>
  /** insert a single row into the table: "automation_account_store" */
  insert_tickets_automation_account_store_one?: Maybe<Tickets_Automation_Account_Store>
  /** insert data into the table: "automation_config" */
  insert_tickets_automation_config?: Maybe<Tickets_Automation_Config_Mutation_Response>
  /** insert data into the table: "automation_config_default" */
  insert_tickets_automation_config_default?: Maybe<Tickets_Automation_Config_Default_Mutation_Response>
  /** insert a single row into the table: "automation_config_default" */
  insert_tickets_automation_config_default_one?: Maybe<Tickets_Automation_Config_Default>
  /** insert a single row into the table: "automation_config" */
  insert_tickets_automation_config_one?: Maybe<Tickets_Automation_Config>
  /** insert data into the table: "automation_config_purge" */
  insert_tickets_automation_config_purge?: Maybe<Tickets_Automation_Config_Purge_Mutation_Response>
  /** insert a single row into the table: "automation_config_purge" */
  insert_tickets_automation_config_purge_one?: Maybe<Tickets_Automation_Config_Purge>
  /** insert data into the table: "automation_default_ticket_action" */
  insert_tickets_automation_default_ticket_action?: Maybe<Tickets_Automation_Default_Ticket_Action_Mutation_Response>
  /** insert a single row into the table: "automation_default_ticket_action" */
  insert_tickets_automation_default_ticket_action_one?: Maybe<Tickets_Automation_Default_Ticket_Action>
  /** insert data into the table: "automation_defaults_acceptable_accounts_table" */
  insert_tickets_automation_defaults_acceptable_accounts_table?: Maybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Mutation_Response>
  /** insert a single row into the table: "automation_defaults_acceptable_accounts_table" */
  insert_tickets_automation_defaults_acceptable_accounts_table_one?: Maybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table>
  /** insert data into the table: "automation_defaults_opened_predefaults" */
  insert_tickets_automation_defaults_opened_predefaults?: Maybe<Tickets_Automation_Defaults_Opened_Predefaults_Mutation_Response>
  /** insert a single row into the table: "automation_defaults_opened_predefaults" */
  insert_tickets_automation_defaults_opened_predefaults_one?: Maybe<Tickets_Automation_Defaults_Opened_Predefaults>
  /** insert data into the table: "automation_job" */
  insert_tickets_automation_job?: Maybe<Tickets_Automation_Job_Mutation_Response>
  /** insert a single row into the table: "automation_job" */
  insert_tickets_automation_job_one?: Maybe<Tickets_Automation_Job>
  /** insert data into the table: "automation_purge_job" */
  insert_tickets_automation_purge_job?: Maybe<Tickets_Automation_Purge_Job_Mutation_Response>
  /** insert a single row into the table: "automation_purge_job" */
  insert_tickets_automation_purge_job_one?: Maybe<Tickets_Automation_Purge_Job>
  /** insert data into the table: "automation_ticket_store" */
  insert_tickets_automation_ticket_store?: Maybe<Tickets_Automation_Ticket_Store_Mutation_Response>
  /** insert a single row into the table: "automation_ticket_store" */
  insert_tickets_automation_ticket_store_one?: Maybe<Tickets_Automation_Ticket_Store>
  /** insert data into the table: "dca_account_allocation" */
  insert_tickets_dca_account_allocation?: Maybe<Tickets_Dca_Account_Allocation_Mutation_Response>
  /** insert a single row into the table: "dca_account_allocation" */
  insert_tickets_dca_account_allocation_one?: Maybe<Tickets_Dca_Account_Allocation>
  /** insert data into the table: "dca_allocation_configuration" */
  insert_tickets_dca_allocation_configuration?: Maybe<Tickets_Dca_Allocation_Configuration_Mutation_Response>
  /** insert a single row into the table: "dca_allocation_configuration" */
  insert_tickets_dca_allocation_configuration_one?: Maybe<Tickets_Dca_Allocation_Configuration>
  /** insert data into the table: "dca_configuration_v2" */
  insert_tickets_dca_configuration_v2?: Maybe<Tickets_Dca_Configuration_V2_Mutation_Response>
  /** insert a single row into the table: "dca_configuration_v2" */
  insert_tickets_dca_configuration_v2_one?: Maybe<Tickets_Dca_Configuration_V2>
  /** insert data into the table: "dca_segmentation" */
  insert_tickets_dca_segmentation?: Maybe<Tickets_Dca_Segmentation_Mutation_Response>
  /** insert a single row into the table: "dca_segmentation" */
  insert_tickets_dca_segmentation_one?: Maybe<Tickets_Dca_Segmentation>
  /** insert data into the table: "dunning_account_store" */
  insert_tickets_dunning_account_store?: Maybe<Tickets_Dunning_Account_Store_Mutation_Response>
  /** insert a single row into the table: "dunning_account_store" */
  insert_tickets_dunning_account_store_one?: Maybe<Tickets_Dunning_Account_Store>
  /** insert data into the table: "dunning_addacs_review_records" */
  insert_tickets_dunning_addacs_review_records?: Maybe<Tickets_Dunning_Addacs_Review_Records_Mutation_Response>
  /** insert a single row into the table: "dunning_addacs_review_records" */
  insert_tickets_dunning_addacs_review_records_one?: Maybe<Tickets_Dunning_Addacs_Review_Records>
  /** insert data into the table: "dunning_automation_events" */
  insert_tickets_dunning_automation_events?: Maybe<Tickets_Dunning_Automation_Events_Mutation_Response>
  /** insert a single row into the table: "dunning_automation_events" */
  insert_tickets_dunning_automation_events_one?: Maybe<Tickets_Dunning_Automation_Events>
  /** insert data into the table: "dunning_debt_ticket_review_records" */
  insert_tickets_dunning_debt_ticket_review_records?: Maybe<Tickets_Dunning_Debt_Ticket_Review_Records_Mutation_Response>
  /** insert a single row into the table: "dunning_debt_ticket_review_records" */
  insert_tickets_dunning_debt_ticket_review_records_one?: Maybe<Tickets_Dunning_Debt_Ticket_Review_Records>
  /** insert data into the table: "dunning_job" */
  insert_tickets_dunning_job?: Maybe<Tickets_Dunning_Job_Mutation_Response>
  /** insert a single row into the table: "dunning_job" */
  insert_tickets_dunning_job_one?: Maybe<Tickets_Dunning_Job>
  /** insert data into the table: "dunning_legal_known_ticket_records" */
  insert_tickets_dunning_legal_known_ticket_records?: Maybe<Tickets_Dunning_Legal_Known_Ticket_Records_Mutation_Response>
  /** insert a single row into the table: "dunning_legal_known_ticket_records" */
  insert_tickets_dunning_legal_known_ticket_records_one?: Maybe<Tickets_Dunning_Legal_Known_Ticket_Records>
  /** insert data into the table: "dunning_legal_occupier_ticket_records" */
  insert_tickets_dunning_legal_occupier_ticket_records?: Maybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Mutation_Response>
  /** insert a single row into the table: "dunning_legal_occupier_ticket_records" */
  insert_tickets_dunning_legal_occupier_ticket_records_one?: Maybe<Tickets_Dunning_Legal_Occupier_Ticket_Records>
  /** insert data into the table: "dunning_occupier_accounts_review_records" */
  insert_tickets_dunning_occupier_accounts_review_records?: Maybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Mutation_Response>
  /** insert a single row into the table: "dunning_occupier_accounts_review_records" */
  insert_tickets_dunning_occupier_accounts_review_records_one?: Maybe<Tickets_Dunning_Occupier_Accounts_Review_Records>
  /** insert data into the table: "dunning_purge_job" */
  insert_tickets_dunning_purge_job?: Maybe<Tickets_Dunning_Purge_Job_Mutation_Response>
  /** insert a single row into the table: "dunning_purge_job" */
  insert_tickets_dunning_purge_job_one?: Maybe<Tickets_Dunning_Purge_Job>
  /** insert data into the table: "dunning_standard_ticket_records" */
  insert_tickets_dunning_standard_ticket_records?: Maybe<Tickets_Dunning_Standard_Ticket_Records_Mutation_Response>
  /** insert a single row into the table: "dunning_standard_ticket_records" */
  insert_tickets_dunning_standard_ticket_records_one?: Maybe<Tickets_Dunning_Standard_Ticket_Records>
  /** insert data into the table: "dunning_statistics" */
  insert_tickets_dunning_statistics?: Maybe<Tickets_Dunning_Statistics_Mutation_Response>
  /** insert a single row into the table: "dunning_statistics" */
  insert_tickets_dunning_statistics_one?: Maybe<Tickets_Dunning_Statistics>
  /** insert data into the table: "dunning_terminating_accounts_review_records" */
  insert_tickets_dunning_terminating_accounts_review_records?: Maybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Mutation_Response>
  /** insert a single row into the table: "dunning_terminating_accounts_review_records" */
  insert_tickets_dunning_terminating_accounts_review_records_one?: Maybe<Tickets_Dunning_Terminating_Accounts_Review_Records>
  /** insert data into the table: "dunning_ticket_store" */
  insert_tickets_dunning_ticket_store?: Maybe<Tickets_Dunning_Ticket_Store_Mutation_Response>
  /** insert a single row into the table: "dunning_ticket_store" */
  insert_tickets_dunning_ticket_store_one?: Maybe<Tickets_Dunning_Ticket_Store>
  /** insert data into the table: "dunning_workflow" */
  insert_tickets_dunning_workflow?: Maybe<Tickets_Dunning_Workflow_Mutation_Response>
  /** insert a single row into the table: "dunning_workflow" */
  insert_tickets_dunning_workflow_one?: Maybe<Tickets_Dunning_Workflow>
  /** insert data into the table: "external_event" */
  insert_tickets_external_event?: Maybe<Tickets_External_Event_Mutation_Response>
  /** insert a single row into the table: "external_event" */
  insert_tickets_external_event_one?: Maybe<Tickets_External_Event>
  /** insert data into the table: "external_tickets" */
  insert_tickets_external_tickets?: Maybe<Tickets_External_Tickets_Mutation_Response>
  /** insert a single row into the table: "external_tickets" */
  insert_tickets_external_tickets_one?: Maybe<Tickets_External_Tickets>
  /** insert data into the table: "qrtz_blob_triggers" */
  insert_tickets_qrtz_blob_triggers?: Maybe<Tickets_Qrtz_Blob_Triggers_Mutation_Response>
  /** insert a single row into the table: "qrtz_blob_triggers" */
  insert_tickets_qrtz_blob_triggers_one?: Maybe<Tickets_Qrtz_Blob_Triggers>
  /** insert data into the table: "qrtz_calendars" */
  insert_tickets_qrtz_calendars?: Maybe<Tickets_Qrtz_Calendars_Mutation_Response>
  /** insert a single row into the table: "qrtz_calendars" */
  insert_tickets_qrtz_calendars_one?: Maybe<Tickets_Qrtz_Calendars>
  /** insert data into the table: "qrtz_cron_triggers" */
  insert_tickets_qrtz_cron_triggers?: Maybe<Tickets_Qrtz_Cron_Triggers_Mutation_Response>
  /** insert a single row into the table: "qrtz_cron_triggers" */
  insert_tickets_qrtz_cron_triggers_one?: Maybe<Tickets_Qrtz_Cron_Triggers>
  /** insert data into the table: "qrtz_fired_triggers" */
  insert_tickets_qrtz_fired_triggers?: Maybe<Tickets_Qrtz_Fired_Triggers_Mutation_Response>
  /** insert a single row into the table: "qrtz_fired_triggers" */
  insert_tickets_qrtz_fired_triggers_one?: Maybe<Tickets_Qrtz_Fired_Triggers>
  /** insert data into the table: "qrtz_job_details" */
  insert_tickets_qrtz_job_details?: Maybe<Tickets_Qrtz_Job_Details_Mutation_Response>
  /** insert a single row into the table: "qrtz_job_details" */
  insert_tickets_qrtz_job_details_one?: Maybe<Tickets_Qrtz_Job_Details>
  /** insert data into the table: "qrtz_locks" */
  insert_tickets_qrtz_locks?: Maybe<Tickets_Qrtz_Locks_Mutation_Response>
  /** insert a single row into the table: "qrtz_locks" */
  insert_tickets_qrtz_locks_one?: Maybe<Tickets_Qrtz_Locks>
  /** insert data into the table: "qrtz_paused_trigger_grps" */
  insert_tickets_qrtz_paused_trigger_grps?: Maybe<Tickets_Qrtz_Paused_Trigger_Grps_Mutation_Response>
  /** insert a single row into the table: "qrtz_paused_trigger_grps" */
  insert_tickets_qrtz_paused_trigger_grps_one?: Maybe<Tickets_Qrtz_Paused_Trigger_Grps>
  /** insert data into the table: "qrtz_scheduler_state" */
  insert_tickets_qrtz_scheduler_state?: Maybe<Tickets_Qrtz_Scheduler_State_Mutation_Response>
  /** insert a single row into the table: "qrtz_scheduler_state" */
  insert_tickets_qrtz_scheduler_state_one?: Maybe<Tickets_Qrtz_Scheduler_State>
  /** insert data into the table: "qrtz_simple_triggers" */
  insert_tickets_qrtz_simple_triggers?: Maybe<Tickets_Qrtz_Simple_Triggers_Mutation_Response>
  /** insert a single row into the table: "qrtz_simple_triggers" */
  insert_tickets_qrtz_simple_triggers_one?: Maybe<Tickets_Qrtz_Simple_Triggers>
  /** insert data into the table: "qrtz_simprop_triggers" */
  insert_tickets_qrtz_simprop_triggers?: Maybe<Tickets_Qrtz_Simprop_Triggers_Mutation_Response>
  /** insert a single row into the table: "qrtz_simprop_triggers" */
  insert_tickets_qrtz_simprop_triggers_one?: Maybe<Tickets_Qrtz_Simprop_Triggers>
  /** insert data into the table: "qrtz_triggers" */
  insert_tickets_qrtz_triggers?: Maybe<Tickets_Qrtz_Triggers_Mutation_Response>
  /** insert a single row into the table: "qrtz_triggers" */
  insert_tickets_qrtz_triggers_one?: Maybe<Tickets_Qrtz_Triggers>
  /** insert data into the table: "trustpilot_invitations" */
  insert_trustpilot_invitations?: Maybe<Trustpilot_Invitations_Mutation_Response>
  /** insert a single row into the table: "trustpilot_invitations" */
  insert_trustpilot_invitations_one?: Maybe<Trustpilot_Invitations>
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>
  /** insert data into the table: "uswitch_record" */
  insert_uswitch_record?: Maybe<Uswitch_Record_Mutation_Response>
  /** insert a single row into the table: "uswitch_record" */
  insert_uswitch_record_one?: Maybe<Uswitch_Record>
  /** insert data into the table: "warm_home_discount_application" */
  insert_warm_home_discount_application?: Maybe<Warm_Home_Discount_Application_Mutation_Response>
  /** insert a single row into the table: "warm_home_discount_application" */
  insert_warm_home_discount_application_one?: Maybe<Warm_Home_Discount_Application>
  /** insert data into the table: "warm_home_discount_application_status_history" */
  insert_warm_home_discount_application_status_history?: Maybe<Warm_Home_Discount_Application_Status_History_Mutation_Response>
  /** insert a single row into the table: "warm_home_discount_application_status_history" */
  insert_warm_home_discount_application_status_history_one?: Maybe<Warm_Home_Discount_Application_Status_History>
  /** insert data into the table: "warm_home_discount_criteria" */
  insert_warm_home_discount_criteria?: Maybe<Warm_Home_Discount_Criteria_Mutation_Response>
  /** insert a single row into the table: "warm_home_discount_criteria" */
  insert_warm_home_discount_criteria_one?: Maybe<Warm_Home_Discount_Criteria>
  /** insert data into the table: "warm_home_discount_criteria_rel" */
  insert_warm_home_discount_criteria_rel?: Maybe<Warm_Home_Discount_Criteria_Rel_Mutation_Response>
  /** insert a single row into the table: "warm_home_discount_criteria_rel" */
  insert_warm_home_discount_criteria_rel_one?: Maybe<Warm_Home_Discount_Criteria_Rel>
  rejectApprovedApplications?: Maybe<RejectApprovedApplicationsResponse>
  /** Retry payment review with filters */
  retryPaymentReviewRecordsByFilters?: Maybe<PaymentReviewsOperationResponse>
  /** Retry payment review with payment review record id list */
  retryPaymentReviewRecordsById?: Maybe<PaymentReviewsOperationResponse>
  updateManyApplications?: Maybe<UpdateWarmHomeDiscountApplicationsResponse>
  /** update data of the table: "ElecNominations" */
  update_ElecNominations?: Maybe<ElecNominations_Mutation_Response>
  /** update data of the table: "ElecTrades" */
  update_ElecTrades?: Maybe<ElecTrades_Mutation_Response>
  /** update data of the table: "ElecTradesHistory" */
  update_ElecTradesHistory?: Maybe<ElecTradesHistory_Mutation_Response>
  /** update single row of the table: "ElecTradesHistory" */
  update_ElecTradesHistory_by_pk?: Maybe<ElecTradesHistory>
  /** update single row of the table: "ElecTrades" */
  update_ElecTrades_by_pk?: Maybe<ElecTrades>
  /** update data of the table: "GasTrades" */
  update_GasTrades?: Maybe<GasTrades_Mutation_Response>
  /** update data of the table: "GasTradesHistory" */
  update_GasTradesHistory?: Maybe<GasTradesHistory_Mutation_Response>
  /** update single row of the table: "GasTradesHistory" */
  update_GasTradesHistory_by_pk?: Maybe<GasTradesHistory>
  /** update single row of the table: "GasTrades" */
  update_GasTrades_by_pk?: Maybe<GasTrades>
  /** update data of the table: "account_credit" */
  update_account_credit?: Maybe<Account_Credit_Mutation_Response>
  /** update single row of the table: "account_credit" */
  update_account_credit_by_pk?: Maybe<Account_Credit>
  /** update multiples rows of table: "account_credit" */
  update_account_credit_many?: Maybe<
    Array<Maybe<Account_Credit_Mutation_Response>>
  >
  /** update data of the table: "active_outbound_photo_request" */
  update_active_outbound_photo_request?: Maybe<Active_Outbound_Photo_Request_Mutation_Response>
  /** update multiples rows of table: "active_outbound_photo_request" */
  update_active_outbound_photo_request_many?: Maybe<
    Array<Maybe<Active_Outbound_Photo_Request_Mutation_Response>>
  >
  /** update data of the table: "address" */
  update_address?: Maybe<Address_Mutation_Response>
  /** update single row of the table: "address" */
  update_address_by_pk?: Maybe<Address>
  /** update multiples rows of table: "address" */
  update_address_many?: Maybe<Array<Maybe<Address_Mutation_Response>>>
  /** update data of the table: "admin_passes" */
  update_admin_passes?: Maybe<Admin_Passes_Mutation_Response>
  /** update single row of the table: "admin_passes" */
  update_admin_passes_by_pk?: Maybe<Admin_Passes>
  /** update multiples rows of table: "admin_passes" */
  update_admin_passes_many?: Maybe<Array<Maybe<Admin_Passes_Mutation_Response>>>
  /** update data of the table: "admin_roles" */
  update_admin_roles?: Maybe<Admin_Roles_Mutation_Response>
  /** update single row of the table: "admin_roles" */
  update_admin_roles_by_pk?: Maybe<Admin_Roles>
  /** update multiples rows of table: "admin_roles" */
  update_admin_roles_many?: Maybe<Array<Maybe<Admin_Roles_Mutation_Response>>>
  /** update data of the table: "agreement" */
  update_agreement?: Maybe<Agreement_Mutation_Response>
  /** update single row of the table: "agreement" */
  update_agreement_by_pk?: Maybe<Agreement>
  /** update multiples rows of table: "agreement" */
  update_agreement_many?: Maybe<Array<Maybe<Agreement_Mutation_Response>>>
  /** update data of the table: "asset" */
  update_asset?: Maybe<Asset_Mutation_Response>
  /** update single row of the table: "asset" */
  update_asset_by_pk?: Maybe<Asset>
  /** update multiples rows of table: "asset" */
  update_asset_many?: Maybe<Array<Maybe<Asset_Mutation_Response>>>
  /** update data of the table: "attachment" */
  update_attachment?: Maybe<Attachment_Mutation_Response>
  /** update single row of the table: "attachment" */
  update_attachment_by_pk?: Maybe<Attachment>
  /** update multiples rows of table: "attachment" */
  update_attachment_many?: Maybe<Array<Maybe<Attachment_Mutation_Response>>>
  /** update data of the table: "axle_trial_eligibility" */
  update_axle_trial_eligibility?: Maybe<Axle_Trial_Eligibility_Mutation_Response>
  /** update single row of the table: "axle_trial_eligibility" */
  update_axle_trial_eligibility_by_pk?: Maybe<Axle_Trial_Eligibility>
  /** update multiples rows of table: "axle_trial_eligibility" */
  update_axle_trial_eligibility_many?: Maybe<
    Array<Maybe<Axle_Trial_Eligibility_Mutation_Response>>
  >
  /** update data of the table: "bill" */
  update_bill?: Maybe<Bill_Mutation_Response>
  /** update single row of the table: "bill" */
  update_bill_by_pk?: Maybe<Bill>
  /** update multiples rows of table: "bill" */
  update_bill_many?: Maybe<Array<Maybe<Bill_Mutation_Response>>>
  /** update data of the table: "billing_account" */
  update_billing_account?: Maybe<Billing_Account_Mutation_Response>
  /** update single row of the table: "billing_account" */
  update_billing_account_by_pk?: Maybe<Billing_Account>
  /** update data of the table: "billing_account_contact" */
  update_billing_account_contact?: Maybe<Billing_Account_Contact_Mutation_Response>
  /** update single row of the table: "billing_account_contact" */
  update_billing_account_contact_by_pk?: Maybe<Billing_Account_Contact>
  /** update multiples rows of table: "billing_account_contact" */
  update_billing_account_contact_many?: Maybe<
    Array<Maybe<Billing_Account_Contact_Mutation_Response>>
  >
  /** update multiples rows of table: "billing_account" */
  update_billing_account_many?: Maybe<
    Array<Maybe<Billing_Account_Mutation_Response>>
  >
  /** update data of the table: "billing_account_setting" */
  update_billing_account_setting?: Maybe<Billing_Account_Setting_Mutation_Response>
  /** update single row of the table: "billing_account_setting" */
  update_billing_account_setting_by_pk?: Maybe<Billing_Account_Setting>
  /** update multiples rows of table: "billing_account_setting" */
  update_billing_account_setting_many?: Maybe<
    Array<Maybe<Billing_Account_Setting_Mutation_Response>>
  >
  /** update data of the table: "billing_account_transaction" */
  update_billing_account_transaction?: Maybe<Billing_Account_Transaction_Mutation_Response>
  /** update single row of the table: "billing_account_transaction" */
  update_billing_account_transaction_by_pk?: Maybe<Billing_Account_Transaction>
  /** update multiples rows of table: "billing_account_transaction" */
  update_billing_account_transaction_many?: Maybe<
    Array<Maybe<Billing_Account_Transaction_Mutation_Response>>
  >
  /** update data of the table: "billing_period" */
  update_billing_period?: Maybe<Billing_Period_Mutation_Response>
  /** update single row of the table: "billing_period" */
  update_billing_period_by_pk?: Maybe<Billing_Period>
  /** update multiples rows of table: "billing_period" */
  update_billing_period_many?: Maybe<
    Array<Maybe<Billing_Period_Mutation_Response>>
  >
  /** update data of the table: "calculation_items" */
  update_calculation_items?: Maybe<Calculation_Items_Mutation_Response>
  /** update single row of the table: "calculation_items" */
  update_calculation_items_by_pk?: Maybe<Calculation_Items>
  /** update multiples rows of table: "calculation_items" */
  update_calculation_items_many?: Maybe<
    Array<Maybe<Calculation_Items_Mutation_Response>>
  >
  /** update data of the table: "call_trace_audit" */
  update_call_trace_audit?: Maybe<Call_Trace_Audit_Mutation_Response>
  /** update single row of the table: "call_trace_audit" */
  update_call_trace_audit_by_pk?: Maybe<Call_Trace_Audit>
  /** update multiples rows of table: "call_trace_audit" */
  update_call_trace_audit_many?: Maybe<
    Array<Maybe<Call_Trace_Audit_Mutation_Response>>
  >
  /** update data of the table: "cancellation_reasons" */
  update_cancellation_reasons?: Maybe<Cancellation_Reasons_Mutation_Response>
  /** update multiples rows of table: "cancellation_reasons" */
  update_cancellation_reasons_many?: Maybe<
    Array<Maybe<Cancellation_Reasons_Mutation_Response>>
  >
  /** update data of the table: "cancellations" */
  update_cancellations?: Maybe<Cancellations_Mutation_Response>
  /** update single row of the table: "cancellations" */
  update_cancellations_by_pk?: Maybe<Cancellations>
  /** update multiples rows of table: "cancellations" */
  update_cancellations_many?: Maybe<
    Array<Maybe<Cancellations_Mutation_Response>>
  >
  /** update data of the table: "card_payment" */
  update_card_payment?: Maybe<Card_Payment_Mutation_Response>
  /** update single row of the table: "card_payment" */
  update_card_payment_by_pk?: Maybe<Card_Payment>
  /** update multiples rows of table: "card_payment" */
  update_card_payment_many?: Maybe<Array<Maybe<Card_Payment_Mutation_Response>>>
  /** update data of the table: "card_payment_old" */
  update_card_payment_old?: Maybe<Card_Payment_Old_Mutation_Response>
  /** update single row of the table: "card_payment_old" */
  update_card_payment_old_by_pk?: Maybe<Card_Payment_Old>
  /** update multiples rows of table: "card_payment_old" */
  update_card_payment_old_many?: Maybe<
    Array<Maybe<Card_Payment_Old_Mutation_Response>>
  >
  /** update data of the table: "cases" */
  update_cases?: Maybe<Cases_Mutation_Response>
  /** update single row of the table: "cases" */
  update_cases_by_pk?: Maybe<Cases>
  /** update multiples rows of table: "cases" */
  update_cases_many?: Maybe<Array<Maybe<Cases_Mutation_Response>>>
  /** update data of the table: "communication" */
  update_communication?: Maybe<Communication_Mutation_Response>
  /** update single row of the table: "communication" */
  update_communication_by_pk?: Maybe<Communication>
  /** update multiples rows of table: "communication" */
  update_communication_many?: Maybe<
    Array<Maybe<Communication_Mutation_Response>>
  >
  /** update data of the table: "communication_metadata" */
  update_communication_metadata?: Maybe<Communication_Metadata_Mutation_Response>
  /** update single row of the table: "communication_metadata" */
  update_communication_metadata_by_pk?: Maybe<Communication_Metadata>
  /** update multiples rows of table: "communication_metadata" */
  update_communication_metadata_many?: Maybe<
    Array<Maybe<Communication_Metadata_Mutation_Response>>
  >
  /** update data of the table: "communications" */
  update_communications?: Maybe<Communications_Mutation_Response>
  /** update single row of the table: "communications" */
  update_communications_by_pk?: Maybe<Communications>
  /** update multiples rows of table: "communications" */
  update_communications_many?: Maybe<
    Array<Maybe<Communications_Mutation_Response>>
  >
  /** update data of the table: "complaint" */
  update_complaint?: Maybe<Complaint_Mutation_Response>
  /** update single row of the table: "complaint" */
  update_complaint_by_pk?: Maybe<Complaint>
  /** update multiples rows of table: "complaint" */
  update_complaint_many?: Maybe<Array<Maybe<Complaint_Mutation_Response>>>
  /** update data of the table: "completed_sync_event_account" */
  update_completed_sync_event_account?: Maybe<Completed_Sync_Event_Account_Mutation_Response>
  /** update single row of the table: "completed_sync_event_account" */
  update_completed_sync_event_account_by_pk?: Maybe<Completed_Sync_Event_Account>
  /** update multiples rows of table: "completed_sync_event_account" */
  update_completed_sync_event_account_many?: Maybe<
    Array<Maybe<Completed_Sync_Event_Account_Mutation_Response>>
  >
  /** update data of the table: "configuration" */
  update_configuration?: Maybe<Configuration_Mutation_Response>
  /** update single row of the table: "configuration" */
  update_configuration_by_pk?: Maybe<Configuration>
  /** update multiples rows of table: "configuration" */
  update_configuration_many?: Maybe<
    Array<Maybe<Configuration_Mutation_Response>>
  >
  /** update data of the table: "contact" */
  update_contact?: Maybe<Contact_Mutation_Response>
  /** update single row of the table: "contact" */
  update_contact_by_pk?: Maybe<Contact>
  /** update multiples rows of table: "contact" */
  update_contact_many?: Maybe<Array<Maybe<Contact_Mutation_Response>>>
  /** update data of the table: "cs__soe_dashboard_total" */
  update_cs__soe_dashboard_total?: Maybe<Cs__Soe_Dashboard_Total_Mutation_Response>
  /** update single row of the table: "cs__soe_dashboard_total" */
  update_cs__soe_dashboard_total_by_pk?: Maybe<Cs__Soe_Dashboard_Total>
  /** update multiples rows of table: "cs__soe_dashboard_total" */
  update_cs__soe_dashboard_total_many?: Maybe<
    Array<Maybe<Cs__Soe_Dashboard_Total_Mutation_Response>>
  >
  /** update data of the table: "customer" */
  update_customer?: Maybe<Customer_Mutation_Response>
  /** update data of the table: "address" */
  update_customer_address?: Maybe<Customer_Address_Mutation_Response>
  /** update single row of the table: "address" */
  update_customer_address_by_pk?: Maybe<Customer_Address>
  /** update multiples rows of table: "address" */
  update_customer_address_many?: Maybe<
    Array<Maybe<Customer_Address_Mutation_Response>>
  >
  /** update single row of the table: "customer" */
  update_customer_by_pk?: Maybe<Customer>
  /** update data of the table: "customer_contact" */
  update_customer_contact?: Maybe<Customer_Contact_Mutation_Response>
  /** update single row of the table: "customer_contact" */
  update_customer_contact_by_pk?: Maybe<Customer_Contact>
  /** update multiples rows of table: "customer_contact" */
  update_customer_contact_many?: Maybe<
    Array<Maybe<Customer_Contact_Mutation_Response>>
  >
  /** update multiples rows of table: "customer" */
  update_customer_many?: Maybe<Array<Maybe<Customer_Mutation_Response>>>
  /** update data of the table: "customer_metadata" */
  update_customer_metadata?: Maybe<Customer_Metadata_Mutation_Response>
  /** update single row of the table: "customer_metadata" */
  update_customer_metadata_by_pk?: Maybe<Customer_Metadata>
  /** update multiples rows of table: "customer_metadata" */
  update_customer_metadata_many?: Maybe<
    Array<Maybe<Customer_Metadata_Mutation_Response>>
  >
  /** update data of the table: "customer_property_rel" */
  update_customer_property_rel?: Maybe<Customer_Property_Rel_Mutation_Response>
  /** update single row of the table: "customer_property_rel" */
  update_customer_property_rel_by_pk?: Maybe<Customer_Property_Rel>
  /** update multiples rows of table: "customer_property_rel" */
  update_customer_property_rel_many?: Maybe<
    Array<Maybe<Customer_Property_Rel_Mutation_Response>>
  >
  /** update data of the table: "customer_psr_rel" */
  update_customer_psr_rel?: Maybe<Customer_Psr_Rel_Mutation_Response>
  /** update single row of the table: "customer_psr_rel" */
  update_customer_psr_rel_by_pk?: Maybe<Customer_Psr_Rel>
  /** update multiples rows of table: "customer_psr_rel" */
  update_customer_psr_rel_many?: Maybe<
    Array<Maybe<Customer_Psr_Rel_Mutation_Response>>
  >
  /** update data of the table: "customer_referrals" */
  update_customer_referrals?: Maybe<Customer_Referrals_Mutation_Response>
  /** update single row of the table: "customer_referrals" */
  update_customer_referrals_by_pk?: Maybe<Customer_Referrals>
  /** update multiples rows of table: "customer_referrals" */
  update_customer_referrals_many?: Maybe<
    Array<Maybe<Customer_Referrals_Mutation_Response>>
  >
  /** update data of the table: "customer_setting" */
  update_customer_setting?: Maybe<Customer_Setting_Mutation_Response>
  /** update single row of the table: "customer_setting" */
  update_customer_setting_by_pk?: Maybe<Customer_Setting>
  /** update multiples rows of table: "customer_setting" */
  update_customer_setting_many?: Maybe<
    Array<Maybe<Customer_Setting_Mutation_Response>>
  >
  /** update data of the table: "customer_user_rel" */
  update_customer_user_rel?: Maybe<Customer_User_Rel_Mutation_Response>
  /** update single row of the table: "customer_user_rel" */
  update_customer_user_rel_by_pk?: Maybe<Customer_User_Rel>
  /** update multiples rows of table: "customer_user_rel" */
  update_customer_user_rel_many?: Maybe<
    Array<Maybe<Customer_User_Rel_Mutation_Response>>
  >
  /** update data of the table: "deprecated_solar_quote_requests" */
  update_deprecated_solar_quote_requests?: Maybe<Deprecated_Solar_Quote_Requests_Mutation_Response>
  /** update single row of the table: "deprecated_solar_quote_requests" */
  update_deprecated_solar_quote_requests_by_pk?: Maybe<Deprecated_Solar_Quote_Requests>
  /** update multiples rows of table: "deprecated_solar_quote_requests" */
  update_deprecated_solar_quote_requests_many?: Maybe<
    Array<Maybe<Deprecated_Solar_Quote_Requests_Mutation_Response>>
  >
  /** update data of the table: "direct_debit" */
  update_direct_debit?: Maybe<Direct_Debit_Mutation_Response>
  /** update single row of the table: "direct_debit" */
  update_direct_debit_by_pk?: Maybe<Direct_Debit>
  /** update multiples rows of table: "direct_debit" */
  update_direct_debit_many?: Maybe<Array<Maybe<Direct_Debit_Mutation_Response>>>
  /** update data of the table: "direct_debit_payment" */
  update_direct_debit_payment?: Maybe<Direct_Debit_Payment_Mutation_Response>
  /** update single row of the table: "direct_debit_payment" */
  update_direct_debit_payment_by_pk?: Maybe<Direct_Debit_Payment>
  /** update multiples rows of table: "direct_debit_payment" */
  update_direct_debit_payment_many?: Maybe<
    Array<Maybe<Direct_Debit_Payment_Mutation_Response>>
  >
  /** update data of the table: "email_messages" */
  update_email_messages?: Maybe<Email_Messages_Mutation_Response>
  /** update single row of the table: "email_messages" */
  update_email_messages_by_pk?: Maybe<Email_Messages>
  /** update multiples rows of table: "email_messages" */
  update_email_messages_many?: Maybe<
    Array<Maybe<Email_Messages_Mutation_Response>>
  >
  /** update data of the table: "email_templates" */
  update_email_templates?: Maybe<Email_Templates_Mutation_Response>
  /** update single row of the table: "email_templates" */
  update_email_templates_by_pk?: Maybe<Email_Templates>
  /** update data of the table: "email_templates_ext" */
  update_email_templates_ext?: Maybe<Email_Templates_Ext_Mutation_Response>
  /** update single row of the table: "email_templates_ext" */
  update_email_templates_ext_by_pk?: Maybe<Email_Templates_Ext>
  /** update multiples rows of table: "email_templates_ext" */
  update_email_templates_ext_many?: Maybe<
    Array<Maybe<Email_Templates_Ext_Mutation_Response>>
  >
  /** update multiples rows of table: "email_templates" */
  update_email_templates_many?: Maybe<
    Array<Maybe<Email_Templates_Mutation_Response>>
  >
  /** update data of the table: "energy_usage_load_factors" */
  update_energy_usage_load_factors?: Maybe<Energy_Usage_Load_Factors_Mutation_Response>
  /** update single row of the table: "energy_usage_load_factors" */
  update_energy_usage_load_factors_by_pk?: Maybe<Energy_Usage_Load_Factors>
  /** update multiples rows of table: "energy_usage_load_factors" */
  update_energy_usage_load_factors_many?: Maybe<
    Array<Maybe<Energy_Usage_Load_Factors_Mutation_Response>>
  >
  /** update data of the table: "enrolment" */
  update_enrolment?: Maybe<Enrolment_Mutation_Response>
  /** update data of the table: "enrolment_automated_communications" */
  update_enrolment_automated_communications?: Maybe<Enrolment_Automated_Communications_Mutation_Response>
  /** update single row of the table: "enrolment_automated_communications" */
  update_enrolment_automated_communications_by_pk?: Maybe<Enrolment_Automated_Communications>
  /** update multiples rows of table: "enrolment_automated_communications" */
  update_enrolment_automated_communications_many?: Maybe<
    Array<Maybe<Enrolment_Automated_Communications_Mutation_Response>>
  >
  /** update single row of the table: "enrolment" */
  update_enrolment_by_pk?: Maybe<Enrolment>
  /** update multiples rows of table: "enrolment" */
  update_enrolment_many?: Maybe<Array<Maybe<Enrolment_Mutation_Response>>>
  /** update data of the table: "entity_mappings" */
  update_entity_mappings?: Maybe<Entity_Mappings_Mutation_Response>
  /** update single row of the table: "entity_mappings" */
  update_entity_mappings_by_pk?: Maybe<Entity_Mappings>
  /** update multiples rows of table: "entity_mappings" */
  update_entity_mappings_many?: Maybe<
    Array<Maybe<Entity_Mappings_Mutation_Response>>
  >
  /** update data of the table: "estimated_usage" */
  update_estimated_usage?: Maybe<Estimated_Usage_Mutation_Response>
  /** update single row of the table: "estimated_usage" */
  update_estimated_usage_by_pk?: Maybe<Estimated_Usage>
  /** update multiples rows of table: "estimated_usage" */
  update_estimated_usage_many?: Maybe<
    Array<Maybe<Estimated_Usage_Mutation_Response>>
  >
  /** update data of the table: "ev_smart_tariff_waitlist" */
  update_ev_smart_tariff_waitlist?: Maybe<Ev_Smart_Tariff_Waitlist_Mutation_Response>
  /** update single row of the table: "ev_smart_tariff_waitlist" */
  update_ev_smart_tariff_waitlist_by_pk?: Maybe<Ev_Smart_Tariff_Waitlist>
  /** update multiples rows of table: "ev_smart_tariff_waitlist" */
  update_ev_smart_tariff_waitlist_many?: Maybe<
    Array<Maybe<Ev_Smart_Tariff_Waitlist_Mutation_Response>>
  >
  /** update data of the table: "ev_tariff_eligibility_checks" */
  update_ev_tariff_eligibility_checks?: Maybe<Ev_Tariff_Eligibility_Checks_Mutation_Response>
  /** update single row of the table: "ev_tariff_eligibility_checks" */
  update_ev_tariff_eligibility_checks_by_pk?: Maybe<Ev_Tariff_Eligibility_Checks>
  /** update multiples rows of table: "ev_tariff_eligibility_checks" */
  update_ev_tariff_eligibility_checks_many?: Maybe<
    Array<Maybe<Ev_Tariff_Eligibility_Checks_Mutation_Response>>
  >
  /** update data of the table: "feature" */
  update_feature?: Maybe<Feature_Mutation_Response>
  /** update single row of the table: "feature" */
  update_feature_by_pk?: Maybe<Feature>
  /** update multiples rows of table: "feature" */
  update_feature_many?: Maybe<Array<Maybe<Feature_Mutation_Response>>>
  /** update data of the table: "configuration" */
  update_financials_configuration?: Maybe<Financials_Configuration_Mutation_Response>
  /** update single row of the table: "configuration" */
  update_financials_configuration_by_pk?: Maybe<Financials_Configuration>
  /** update multiples rows of table: "configuration" */
  update_financials_configuration_many?: Maybe<
    Array<Maybe<Financials_Configuration_Mutation_Response>>
  >
  /** update data of the table: "qrtz_blob_triggers" */
  update_financials_qrtz_blob_triggers?: Maybe<Financials_Qrtz_Blob_Triggers_Mutation_Response>
  /** update single row of the table: "qrtz_blob_triggers" */
  update_financials_qrtz_blob_triggers_by_pk?: Maybe<Financials_Qrtz_Blob_Triggers>
  /** update multiples rows of table: "qrtz_blob_triggers" */
  update_financials_qrtz_blob_triggers_many?: Maybe<
    Array<Maybe<Financials_Qrtz_Blob_Triggers_Mutation_Response>>
  >
  /** update data of the table: "qrtz_calendars" */
  update_financials_qrtz_calendars?: Maybe<Financials_Qrtz_Calendars_Mutation_Response>
  /** update single row of the table: "qrtz_calendars" */
  update_financials_qrtz_calendars_by_pk?: Maybe<Financials_Qrtz_Calendars>
  /** update multiples rows of table: "qrtz_calendars" */
  update_financials_qrtz_calendars_many?: Maybe<
    Array<Maybe<Financials_Qrtz_Calendars_Mutation_Response>>
  >
  /** update data of the table: "qrtz_cron_triggers" */
  update_financials_qrtz_cron_triggers?: Maybe<Financials_Qrtz_Cron_Triggers_Mutation_Response>
  /** update single row of the table: "qrtz_cron_triggers" */
  update_financials_qrtz_cron_triggers_by_pk?: Maybe<Financials_Qrtz_Cron_Triggers>
  /** update multiples rows of table: "qrtz_cron_triggers" */
  update_financials_qrtz_cron_triggers_many?: Maybe<
    Array<Maybe<Financials_Qrtz_Cron_Triggers_Mutation_Response>>
  >
  /** update data of the table: "qrtz_fired_triggers" */
  update_financials_qrtz_fired_triggers?: Maybe<Financials_Qrtz_Fired_Triggers_Mutation_Response>
  /** update single row of the table: "qrtz_fired_triggers" */
  update_financials_qrtz_fired_triggers_by_pk?: Maybe<Financials_Qrtz_Fired_Triggers>
  /** update multiples rows of table: "qrtz_fired_triggers" */
  update_financials_qrtz_fired_triggers_many?: Maybe<
    Array<Maybe<Financials_Qrtz_Fired_Triggers_Mutation_Response>>
  >
  /** update data of the table: "qrtz_job_details" */
  update_financials_qrtz_job_details?: Maybe<Financials_Qrtz_Job_Details_Mutation_Response>
  /** update single row of the table: "qrtz_job_details" */
  update_financials_qrtz_job_details_by_pk?: Maybe<Financials_Qrtz_Job_Details>
  /** update multiples rows of table: "qrtz_job_details" */
  update_financials_qrtz_job_details_many?: Maybe<
    Array<Maybe<Financials_Qrtz_Job_Details_Mutation_Response>>
  >
  /** update data of the table: "qrtz_scheduler_state" */
  update_financials_qrtz_scheduler_state?: Maybe<Financials_Qrtz_Scheduler_State_Mutation_Response>
  /** update single row of the table: "qrtz_scheduler_state" */
  update_financials_qrtz_scheduler_state_by_pk?: Maybe<Financials_Qrtz_Scheduler_State>
  /** update multiples rows of table: "qrtz_scheduler_state" */
  update_financials_qrtz_scheduler_state_many?: Maybe<
    Array<Maybe<Financials_Qrtz_Scheduler_State_Mutation_Response>>
  >
  /** update data of the table: "qrtz_simple_triggers" */
  update_financials_qrtz_simple_triggers?: Maybe<Financials_Qrtz_Simple_Triggers_Mutation_Response>
  /** update single row of the table: "qrtz_simple_triggers" */
  update_financials_qrtz_simple_triggers_by_pk?: Maybe<Financials_Qrtz_Simple_Triggers>
  /** update multiples rows of table: "qrtz_simple_triggers" */
  update_financials_qrtz_simple_triggers_many?: Maybe<
    Array<Maybe<Financials_Qrtz_Simple_Triggers_Mutation_Response>>
  >
  /** update data of the table: "qrtz_simprop_triggers" */
  update_financials_qrtz_simprop_triggers?: Maybe<Financials_Qrtz_Simprop_Triggers_Mutation_Response>
  /** update single row of the table: "qrtz_simprop_triggers" */
  update_financials_qrtz_simprop_triggers_by_pk?: Maybe<Financials_Qrtz_Simprop_Triggers>
  /** update multiples rows of table: "qrtz_simprop_triggers" */
  update_financials_qrtz_simprop_triggers_many?: Maybe<
    Array<Maybe<Financials_Qrtz_Simprop_Triggers_Mutation_Response>>
  >
  /** update data of the table: "qrtz_triggers" */
  update_financials_qrtz_triggers?: Maybe<Financials_Qrtz_Triggers_Mutation_Response>
  /** update single row of the table: "qrtz_triggers" */
  update_financials_qrtz_triggers_by_pk?: Maybe<Financials_Qrtz_Triggers>
  /** update multiples rows of table: "qrtz_triggers" */
  update_financials_qrtz_triggers_many?: Maybe<
    Array<Maybe<Financials_Qrtz_Triggers_Mutation_Response>>
  >
  /** update data of the table: "warrant_account_criteria" */
  update_financials_warrant_account_criteria?: Maybe<Financials_Warrant_Account_Criteria_Mutation_Response>
  /** update single row of the table: "warrant_account_criteria" */
  update_financials_warrant_account_criteria_by_pk?: Maybe<Financials_Warrant_Account_Criteria>
  /** update multiples rows of table: "warrant_account_criteria" */
  update_financials_warrant_account_criteria_many?: Maybe<
    Array<Maybe<Financials_Warrant_Account_Criteria_Mutation_Response>>
  >
  /** update data of the table: "warrant_account_sync_criteria" */
  update_financials_warrant_account_sync_criteria?: Maybe<Financials_Warrant_Account_Sync_Criteria_Mutation_Response>
  /** update single row of the table: "warrant_account_sync_criteria" */
  update_financials_warrant_account_sync_criteria_by_pk?: Maybe<Financials_Warrant_Account_Sync_Criteria>
  /** update multiples rows of table: "warrant_account_sync_criteria" */
  update_financials_warrant_account_sync_criteria_many?: Maybe<
    Array<Maybe<Financials_Warrant_Account_Sync_Criteria_Mutation_Response>>
  >
  /** update data of the table: "warrant_communications_sent_count" */
  update_financials_warrant_communications_sent_count?: Maybe<Financials_Warrant_Communications_Sent_Count_Mutation_Response>
  /** update single row of the table: "warrant_communications_sent_count" */
  update_financials_warrant_communications_sent_count_by_pk?: Maybe<Financials_Warrant_Communications_Sent_Count>
  /** update multiples rows of table: "warrant_communications_sent_count" */
  update_financials_warrant_communications_sent_count_many?: Maybe<
    Array<Maybe<Financials_Warrant_Communications_Sent_Count_Mutation_Response>>
  >
  /** update data of the table: "warrants_accounts" */
  update_financials_warrants_accounts?: Maybe<Financials_Warrants_Accounts_Mutation_Response>
  /** update single row of the table: "warrants_accounts" */
  update_financials_warrants_accounts_by_pk?: Maybe<Financials_Warrants_Accounts>
  /** update data of the table: "warrants_accounts_history" */
  update_financials_warrants_accounts_history?: Maybe<Financials_Warrants_Accounts_History_Mutation_Response>
  /** update single row of the table: "warrants_accounts_history" */
  update_financials_warrants_accounts_history_by_pk?: Maybe<Financials_Warrants_Accounts_History>
  /** update multiples rows of table: "warrants_accounts_history" */
  update_financials_warrants_accounts_history_many?: Maybe<
    Array<Maybe<Financials_Warrants_Accounts_History_Mutation_Response>>
  >
  /** update multiples rows of table: "warrants_accounts" */
  update_financials_warrants_accounts_many?: Maybe<
    Array<Maybe<Financials_Warrants_Accounts_Mutation_Response>>
  >
  /** update data of the table: "warrants_accounts_whitelist" */
  update_financials_warrants_accounts_whitelist?: Maybe<Financials_Warrants_Accounts_Whitelist_Mutation_Response>
  /** update single row of the table: "warrants_accounts_whitelist" */
  update_financials_warrants_accounts_whitelist_by_pk?: Maybe<Financials_Warrants_Accounts_Whitelist>
  /** update multiples rows of table: "warrants_accounts_whitelist" */
  update_financials_warrants_accounts_whitelist_many?: Maybe<
    Array<Maybe<Financials_Warrants_Accounts_Whitelist_Mutation_Response>>
  >
  /** update data of the table: "warrants_communication_group" */
  update_financials_warrants_communication_group?: Maybe<Financials_Warrants_Communication_Group_Mutation_Response>
  /** update single row of the table: "warrants_communication_group" */
  update_financials_warrants_communication_group_by_pk?: Maybe<Financials_Warrants_Communication_Group>
  /** update multiples rows of table: "warrants_communication_group" */
  update_financials_warrants_communication_group_many?: Maybe<
    Array<Maybe<Financials_Warrants_Communication_Group_Mutation_Response>>
  >
  /** update data of the table: "warrants_communications" */
  update_financials_warrants_communications?: Maybe<Financials_Warrants_Communications_Mutation_Response>
  /** update single row of the table: "warrants_communications" */
  update_financials_warrants_communications_by_pk?: Maybe<Financials_Warrants_Communications>
  /** update multiples rows of table: "warrants_communications" */
  update_financials_warrants_communications_many?: Maybe<
    Array<Maybe<Financials_Warrants_Communications_Mutation_Response>>
  >
  /** update data of the table: "warrants_dca_queue" */
  update_financials_warrants_dca_queue?: Maybe<Financials_Warrants_Dca_Queue_Mutation_Response>
  /** update single row of the table: "warrants_dca_queue" */
  update_financials_warrants_dca_queue_by_pk?: Maybe<Financials_Warrants_Dca_Queue>
  /** update multiples rows of table: "warrants_dca_queue" */
  update_financials_warrants_dca_queue_many?: Maybe<
    Array<Maybe<Financials_Warrants_Dca_Queue_Mutation_Response>>
  >
  /** update data of the table: "warrants_dca_tickets" */
  update_financials_warrants_dca_tickets?: Maybe<Financials_Warrants_Dca_Tickets_Mutation_Response>
  /** update single row of the table: "warrants_dca_tickets" */
  update_financials_warrants_dca_tickets_by_pk?: Maybe<Financials_Warrants_Dca_Tickets>
  /** update multiples rows of table: "warrants_dca_tickets" */
  update_financials_warrants_dca_tickets_many?: Maybe<
    Array<Maybe<Financials_Warrants_Dca_Tickets_Mutation_Response>>
  >
  /** update data of the table: "warrants_files_account" */
  update_financials_warrants_files_account?: Maybe<Financials_Warrants_Files_Account_Mutation_Response>
  /** update single row of the table: "warrants_files_account" */
  update_financials_warrants_files_account_by_pk?: Maybe<Financials_Warrants_Files_Account>
  /** update multiples rows of table: "warrants_files_account" */
  update_financials_warrants_files_account_many?: Maybe<
    Array<Maybe<Financials_Warrants_Files_Account_Mutation_Response>>
  >
  /** update data of the table: "warrants_files_job" */
  update_financials_warrants_files_job?: Maybe<Financials_Warrants_Files_Job_Mutation_Response>
  /** update single row of the table: "warrants_files_job" */
  update_financials_warrants_files_job_by_pk?: Maybe<Financials_Warrants_Files_Job>
  /** update multiples rows of table: "warrants_files_job" */
  update_financials_warrants_files_job_many?: Maybe<
    Array<Maybe<Financials_Warrants_Files_Job_Mutation_Response>>
  >
  /** update data of the table: "warrants_files_processed" */
  update_financials_warrants_files_processed?: Maybe<Financials_Warrants_Files_Processed_Mutation_Response>
  /** update single row of the table: "warrants_files_processed" */
  update_financials_warrants_files_processed_by_pk?: Maybe<Financials_Warrants_Files_Processed>
  /** update multiples rows of table: "warrants_files_processed" */
  update_financials_warrants_files_processed_many?: Maybe<
    Array<Maybe<Financials_Warrants_Files_Processed_Mutation_Response>>
  >
  /** update data of the table: "warrants_job" */
  update_financials_warrants_job?: Maybe<Financials_Warrants_Job_Mutation_Response>
  /** update single row of the table: "warrants_job" */
  update_financials_warrants_job_by_pk?: Maybe<Financials_Warrants_Job>
  /** update multiples rows of table: "warrants_job" */
  update_financials_warrants_job_many?: Maybe<
    Array<Maybe<Financials_Warrants_Job_Mutation_Response>>
  >
  /** update data of the table: "flex_market_subscription" */
  update_flex_market_subscription?: Maybe<Flex_Market_Subscription_Mutation_Response>
  /** update data of the table: "flex_market_subscription_billing" */
  update_flex_market_subscription_billing?: Maybe<Flex_Market_Subscription_Billing_Mutation_Response>
  /** update single row of the table: "flex_market_subscription_billing" */
  update_flex_market_subscription_billing_by_pk?: Maybe<Flex_Market_Subscription_Billing>
  /** update data of the table: "flex_market_subscription_billing_component" */
  update_flex_market_subscription_billing_component?: Maybe<Flex_Market_Subscription_Billing_Component_Mutation_Response>
  /** update single row of the table: "flex_market_subscription_billing_component" */
  update_flex_market_subscription_billing_component_by_pk?: Maybe<Flex_Market_Subscription_Billing_Component>
  /** update multiples rows of table: "flex_market_subscription_billing_component" */
  update_flex_market_subscription_billing_component_many?: Maybe<
    Array<Maybe<Flex_Market_Subscription_Billing_Component_Mutation_Response>>
  >
  /** update multiples rows of table: "flex_market_subscription_billing" */
  update_flex_market_subscription_billing_many?: Maybe<
    Array<Maybe<Flex_Market_Subscription_Billing_Mutation_Response>>
  >
  /** update single row of the table: "flex_market_subscription" */
  update_flex_market_subscription_by_pk?: Maybe<Flex_Market_Subscription>
  /** update multiples rows of table: "flex_market_subscription" */
  update_flex_market_subscription_many?: Maybe<
    Array<Maybe<Flex_Market_Subscription_Mutation_Response>>
  >
  /** update data of the table: "flyway_schema_history" */
  update_flyway_schema_history?: Maybe<Flyway_Schema_History_Mutation_Response>
  /** update single row of the table: "flyway_schema_history" */
  update_flyway_schema_history_by_pk?: Maybe<Flyway_Schema_History>
  /** update multiples rows of table: "flyway_schema_history" */
  update_flyway_schema_history_many?: Maybe<
    Array<Maybe<Flyway_Schema_History_Mutation_Response>>
  >
  /** update data of the table: "freshdesk_contact" */
  update_freshdesk_contact?: Maybe<Freshdesk_Contact_Mutation_Response>
  /** update multiples rows of table: "freshdesk_contact" */
  update_freshdesk_contact_many?: Maybe<
    Array<Maybe<Freshdesk_Contact_Mutation_Response>>
  >
  /** update data of the table: "freshdesk_ticket" */
  update_freshdesk_ticket?: Maybe<Freshdesk_Ticket_Mutation_Response>
  /** update multiples rows of table: "freshdesk_ticket" */
  update_freshdesk_ticket_many?: Maybe<
    Array<Maybe<Freshdesk_Ticket_Mutation_Response>>
  >
  /** update data of the table: "install_codes" */
  update_install_codes?: Maybe<Install_Codes_Mutation_Response>
  /** update single row of the table: "install_codes" */
  update_install_codes_by_pk?: Maybe<Install_Codes>
  /** update multiples rows of table: "install_codes" */
  update_install_codes_many?: Maybe<
    Array<Maybe<Install_Codes_Mutation_Response>>
  >
  /** update data of the table: "junifer__Account" */
  update_junifer__Account?: Maybe<Junifer__Account_Mutation_Response>
  /** update data of the table: "junifer__AccountTransaction" */
  update_junifer__AccountTransaction?: Maybe<Junifer__AccountTransaction_Mutation_Response>
  /** update single row of the table: "junifer__AccountTransaction" */
  update_junifer__AccountTransaction_by_pk?: Maybe<Junifer__AccountTransaction>
  /** update multiples rows of table: "junifer__AccountTransaction" */
  update_junifer__AccountTransaction_many?: Maybe<
    Array<Maybe<Junifer__AccountTransaction_Mutation_Response>>
  >
  /** update single row of the table: "junifer__Account" */
  update_junifer__Account_by_pk?: Maybe<Junifer__Account>
  /** update multiples rows of table: "junifer__Account" */
  update_junifer__Account_many?: Maybe<
    Array<Maybe<Junifer__Account_Mutation_Response>>
  >
  /** update data of the table: "junifer__Customer" */
  update_junifer__Customer?: Maybe<Junifer__Customer_Mutation_Response>
  /** update single row of the table: "junifer__Customer" */
  update_junifer__Customer_by_pk?: Maybe<Junifer__Customer>
  /** update multiples rows of table: "junifer__Customer" */
  update_junifer__Customer_many?: Maybe<
    Array<Maybe<Junifer__Customer_Mutation_Response>>
  >
  /** update data of the table: "meter" */
  update_meter?: Maybe<Meter_Mutation_Response>
  /** update single row of the table: "meter" */
  update_meter_by_pk?: Maybe<Meter>
  /** update multiples rows of table: "meter" */
  update_meter_many?: Maybe<Array<Maybe<Meter_Mutation_Response>>>
  /** update data of the table: "meter_meter_point_rel" */
  update_meter_meter_point_rel?: Maybe<Meter_Meter_Point_Rel_Mutation_Response>
  /** update single row of the table: "meter_meter_point_rel" */
  update_meter_meter_point_rel_by_pk?: Maybe<Meter_Meter_Point_Rel>
  /** update multiples rows of table: "meter_meter_point_rel" */
  update_meter_meter_point_rel_many?: Maybe<
    Array<Maybe<Meter_Meter_Point_Rel_Mutation_Response>>
  >
  /** update data of the table: "meter_point" */
  update_meter_point?: Maybe<Meter_Point_Mutation_Response>
  /** update single row of the table: "meter_point" */
  update_meter_point_by_pk?: Maybe<Meter_Point>
  /** update data of the table: "meter_point_electricity" */
  update_meter_point_electricity?: Maybe<Meter_Point_Electricity_Mutation_Response>
  /** update single row of the table: "meter_point_electricity" */
  update_meter_point_electricity_by_pk?: Maybe<Meter_Point_Electricity>
  /** update multiples rows of table: "meter_point_electricity" */
  update_meter_point_electricity_many?: Maybe<
    Array<Maybe<Meter_Point_Electricity_Mutation_Response>>
  >
  /** update data of the table: "meter_point_gas" */
  update_meter_point_gas?: Maybe<Meter_Point_Gas_Mutation_Response>
  /** update single row of the table: "meter_point_gas" */
  update_meter_point_gas_by_pk?: Maybe<Meter_Point_Gas>
  /** update multiples rows of table: "meter_point_gas" */
  update_meter_point_gas_many?: Maybe<
    Array<Maybe<Meter_Point_Gas_Mutation_Response>>
  >
  /** update data of the table: "meter_point_history" */
  update_meter_point_history?: Maybe<Meter_Point_History_Mutation_Response>
  /** update single row of the table: "meter_point_history" */
  update_meter_point_history_by_pk?: Maybe<Meter_Point_History>
  /** update multiples rows of table: "meter_point_history" */
  update_meter_point_history_many?: Maybe<
    Array<Maybe<Meter_Point_History_Mutation_Response>>
  >
  /** update multiples rows of table: "meter_point" */
  update_meter_point_many?: Maybe<Array<Maybe<Meter_Point_Mutation_Response>>>
  /** update data of the table: "meter_reading" */
  update_meter_reading?: Maybe<Meter_Reading_Mutation_Response>
  /** update single row of the table: "meter_reading" */
  update_meter_reading_by_pk?: Maybe<Meter_Reading>
  /** update multiples rows of table: "meter_reading" */
  update_meter_reading_many?: Maybe<
    Array<Maybe<Meter_Reading_Mutation_Response>>
  >
  /** update data of the table: "meter_reading_submission_request" */
  update_meter_reading_submission_request?: Maybe<Meter_Reading_Submission_Request_Mutation_Response>
  /** update single row of the table: "meter_reading_submission_request" */
  update_meter_reading_submission_request_by_pk?: Maybe<Meter_Reading_Submission_Request>
  /** update multiples rows of table: "meter_reading_submission_request" */
  update_meter_reading_submission_request_many?: Maybe<
    Array<Maybe<Meter_Reading_Submission_Request_Mutation_Response>>
  >
  /** update data of the table: "meter_reading_submission_tokens" */
  update_meter_reading_submission_tokens?: Maybe<Meter_Reading_Submission_Tokens_Mutation_Response>
  /** update single row of the table: "meter_reading_submission_tokens" */
  update_meter_reading_submission_tokens_by_pk?: Maybe<Meter_Reading_Submission_Tokens>
  /** update multiples rows of table: "meter_reading_submission_tokens" */
  update_meter_reading_submission_tokens_many?: Maybe<
    Array<Maybe<Meter_Reading_Submission_Tokens_Mutation_Response>>
  >
  /** update data of the table: "note" */
  update_note?: Maybe<Note_Mutation_Response>
  /** update single row of the table: "note" */
  update_note_by_pk?: Maybe<Note>
  /** update multiples rows of table: "note" */
  update_note_many?: Maybe<Array<Maybe<Note_Mutation_Response>>>
  /** update data of the table: "nova_submissions" */
  update_nova_submissions?: Maybe<Nova_Submissions_Mutation_Response>
  /** update multiples rows of table: "nova_submissions" */
  update_nova_submissions_many?: Maybe<
    Array<Maybe<Nova_Submissions_Mutation_Response>>
  >
  /** update data of the table: "outbound_photo_request" */
  update_outbound_photo_request?: Maybe<Outbound_Photo_Request_Mutation_Response>
  /** update single row of the table: "outbound_photo_request" */
  update_outbound_photo_request_by_pk?: Maybe<Outbound_Photo_Request>
  /** update multiples rows of table: "outbound_photo_request" */
  update_outbound_photo_request_many?: Maybe<
    Array<Maybe<Outbound_Photo_Request_Mutation_Response>>
  >
  /** update data of the table: "password_reset_tokens" */
  update_password_reset_tokens?: Maybe<Password_Reset_Tokens_Mutation_Response>
  /** update single row of the table: "password_reset_tokens" */
  update_password_reset_tokens_by_pk?: Maybe<Password_Reset_Tokens>
  /** update multiples rows of table: "password_reset_tokens" */
  update_password_reset_tokens_many?: Maybe<
    Array<Maybe<Password_Reset_Tokens_Mutation_Response>>
  >
  /** update data of the table: "payment" */
  update_payment?: Maybe<Payment_Mutation_Response>
  /** update single row of the table: "payment" */
  update_payment_by_pk?: Maybe<Payment>
  /** update multiples rows of table: "payment" */
  update_payment_many?: Maybe<Array<Maybe<Payment_Mutation_Response>>>
  /** update data of the table: "payment_method" */
  update_payment_method?: Maybe<Payment_Method_Mutation_Response>
  /** update single row of the table: "payment_method" */
  update_payment_method_by_pk?: Maybe<Payment_Method>
  /** update multiples rows of table: "payment_method" */
  update_payment_method_many?: Maybe<
    Array<Maybe<Payment_Method_Mutation_Response>>
  >
  /** update data of the table: "payment_review_account_balance_reserve_rates" */
  update_payment_review_account_balance_reserve_rates?: Maybe<Payment_Review_Account_Balance_Reserve_Rates_Mutation_Response>
  /** update single row of the table: "payment_review_account_balance_reserve_rates" */
  update_payment_review_account_balance_reserve_rates_by_pk?: Maybe<Payment_Review_Account_Balance_Reserve_Rates>
  /** update multiples rows of table: "payment_review_account_balance_reserve_rates" */
  update_payment_review_account_balance_reserve_rates_many?: Maybe<
    Array<Maybe<Payment_Review_Account_Balance_Reserve_Rates_Mutation_Response>>
  >
  /** update data of the table: "payment_review_account_exclusions" */
  update_payment_review_account_exclusions?: Maybe<Payment_Review_Account_Exclusions_Mutation_Response>
  /** update single row of the table: "payment_review_account_exclusions" */
  update_payment_review_account_exclusions_by_pk?: Maybe<Payment_Review_Account_Exclusions>
  /** update multiples rows of table: "payment_review_account_exclusions" */
  update_payment_review_account_exclusions_many?: Maybe<
    Array<Maybe<Payment_Review_Account_Exclusions_Mutation_Response>>
  >
  /** update data of the table: "payment_review_calculation" */
  update_payment_review_calculation?: Maybe<Payment_Review_Calculation_Mutation_Response>
  /** update single row of the table: "payment_review_calculation" */
  update_payment_review_calculation_by_pk?: Maybe<Payment_Review_Calculation>
  /** update multiples rows of table: "payment_review_calculation" */
  update_payment_review_calculation_many?: Maybe<
    Array<Maybe<Payment_Review_Calculation_Mutation_Response>>
  >
  /** update data of the table: "payment_review_future_product_rates" */
  update_payment_review_future_product_rates?: Maybe<Payment_Review_Future_Product_Rates_Mutation_Response>
  /** update single row of the table: "payment_review_future_product_rates" */
  update_payment_review_future_product_rates_by_pk?: Maybe<Payment_Review_Future_Product_Rates>
  /** update multiples rows of table: "payment_review_future_product_rates" */
  update_payment_review_future_product_rates_many?: Maybe<
    Array<Maybe<Payment_Review_Future_Product_Rates_Mutation_Response>>
  >
  /** update data of the table: "payment_review_record_emails" */
  update_payment_review_record_emails?: Maybe<Payment_Review_Record_Emails_Mutation_Response>
  /** update single row of the table: "payment_review_record_emails" */
  update_payment_review_record_emails_by_pk?: Maybe<Payment_Review_Record_Emails>
  /** update multiples rows of table: "payment_review_record_emails" */
  update_payment_review_record_emails_many?: Maybe<
    Array<Maybe<Payment_Review_Record_Emails_Mutation_Response>>
  >
  /** update data of the table: "payment_review_record_notes" */
  update_payment_review_record_notes?: Maybe<Payment_Review_Record_Notes_Mutation_Response>
  /** update single row of the table: "payment_review_record_notes" */
  update_payment_review_record_notes_by_pk?: Maybe<Payment_Review_Record_Notes>
  /** update multiples rows of table: "payment_review_record_notes" */
  update_payment_review_record_notes_many?: Maybe<
    Array<Maybe<Payment_Review_Record_Notes_Mutation_Response>>
  >
  /** update data of the table: "payment_review_records" */
  update_payment_review_records?: Maybe<Payment_Review_Records_Mutation_Response>
  /** update single row of the table: "payment_review_records" */
  update_payment_review_records_by_pk?: Maybe<Payment_Review_Records>
  /** update multiples rows of table: "payment_review_records" */
  update_payment_review_records_many?: Maybe<
    Array<Maybe<Payment_Review_Records_Mutation_Response>>
  >
  /** update data of the table: "payment_reviews" */
  update_payment_reviews?: Maybe<Payment_Reviews_Mutation_Response>
  /** update single row of the table: "payment_reviews" */
  update_payment_reviews_by_pk?: Maybe<Payment_Reviews>
  /** update multiples rows of table: "payment_reviews" */
  update_payment_reviews_many?: Maybe<
    Array<Maybe<Payment_Reviews_Mutation_Response>>
  >
  /** update data of the table: "payment_schedule" */
  update_payment_schedule?: Maybe<Payment_Schedule_Mutation_Response>
  /** update single row of the table: "payment_schedule" */
  update_payment_schedule_by_pk?: Maybe<Payment_Schedule>
  /** update multiples rows of table: "payment_schedule" */
  update_payment_schedule_many?: Maybe<
    Array<Maybe<Payment_Schedule_Mutation_Response>>
  >
  /** update data of the table: "postcode_gsp_cache" */
  update_postcode_gsp_cache?: Maybe<Postcode_Gsp_Cache_Mutation_Response>
  /** update single row of the table: "postcode_gsp_cache" */
  update_postcode_gsp_cache_by_pk?: Maybe<Postcode_Gsp_Cache>
  /** update multiples rows of table: "postcode_gsp_cache" */
  update_postcode_gsp_cache_many?: Maybe<
    Array<Maybe<Postcode_Gsp_Cache_Mutation_Response>>
  >
  /** update data of the table: "product" */
  update_product?: Maybe<Product_Mutation_Response>
  /** update data of the table: "product_account" */
  update_product_account?: Maybe<Product_Account_Mutation_Response>
  /** update data of the table: "product_account_agreement_rel" */
  update_product_account_agreement_rel?: Maybe<Product_Account_Agreement_Rel_Mutation_Response>
  /** update single row of the table: "product_account_agreement_rel" */
  update_product_account_agreement_rel_by_pk?: Maybe<Product_Account_Agreement_Rel>
  /** update multiples rows of table: "product_account_agreement_rel" */
  update_product_account_agreement_rel_many?: Maybe<
    Array<Maybe<Product_Account_Agreement_Rel_Mutation_Response>>
  >
  /** update single row of the table: "product_account" */
  update_product_account_by_pk?: Maybe<Product_Account>
  /** update multiples rows of table: "product_account" */
  update_product_account_many?: Maybe<
    Array<Maybe<Product_Account_Mutation_Response>>
  >
  /** update single row of the table: "product" */
  update_product_by_pk?: Maybe<Product>
  /** update data of the table: "product_elec" */
  update_product_elec?: Maybe<Product_Elec_Mutation_Response>
  /** update single row of the table: "product_elec" */
  update_product_elec_by_pk?: Maybe<Product_Elec>
  /** update multiples rows of table: "product_elec" */
  update_product_elec_many?: Maybe<Array<Maybe<Product_Elec_Mutation_Response>>>
  /** update data of the table: "product_gas" */
  update_product_gas?: Maybe<Product_Gas_Mutation_Response>
  /** update single row of the table: "product_gas" */
  update_product_gas_by_pk?: Maybe<Product_Gas>
  /** update multiples rows of table: "product_gas" */
  update_product_gas_many?: Maybe<Array<Maybe<Product_Gas_Mutation_Response>>>
  /** update multiples rows of table: "product" */
  update_product_many?: Maybe<Array<Maybe<Product_Mutation_Response>>>
  /** update data of the table: "product_variant" */
  update_product_variant?: Maybe<Product_Variant_Mutation_Response>
  /** update single row of the table: "product_variant" */
  update_product_variant_by_pk?: Maybe<Product_Variant>
  /** update data of the table: "product_variant_elec" */
  update_product_variant_elec?: Maybe<Product_Variant_Elec_Mutation_Response>
  /** update single row of the table: "product_variant_elec" */
  update_product_variant_elec_by_pk?: Maybe<Product_Variant_Elec>
  /** update multiples rows of table: "product_variant_elec" */
  update_product_variant_elec_many?: Maybe<
    Array<Maybe<Product_Variant_Elec_Mutation_Response>>
  >
  /** update data of the table: "product_variant_gas" */
  update_product_variant_gas?: Maybe<Product_Variant_Gas_Mutation_Response>
  /** update single row of the table: "product_variant_gas" */
  update_product_variant_gas_by_pk?: Maybe<Product_Variant_Gas>
  /** update multiples rows of table: "product_variant_gas" */
  update_product_variant_gas_many?: Maybe<
    Array<Maybe<Product_Variant_Gas_Mutation_Response>>
  >
  /** update multiples rows of table: "product_variant" */
  update_product_variant_many?: Maybe<
    Array<Maybe<Product_Variant_Mutation_Response>>
  >
  /** update data of the table: "property" */
  update_property?: Maybe<Property_Mutation_Response>
  /** update single row of the table: "property" */
  update_property_by_pk?: Maybe<Property>
  /** update multiples rows of table: "property" */
  update_property_many?: Maybe<Array<Maybe<Property_Mutation_Response>>>
  /** update data of the table: "psr" */
  update_psr?: Maybe<Psr_Mutation_Response>
  /** update single row of the table: "psr" */
  update_psr_by_pk?: Maybe<Psr>
  /** update multiples rows of table: "psr" */
  update_psr_many?: Maybe<Array<Maybe<Psr_Mutation_Response>>>
  /** update data of the table: "quote" */
  update_quote?: Maybe<Quote_Mutation_Response>
  /** update single row of the table: "quote" */
  update_quote_by_pk?: Maybe<Quote>
  /** update multiples rows of table: "quote" */
  update_quote_many?: Maybe<Array<Maybe<Quote_Mutation_Response>>>
  /** update data of the table: "quote_request" */
  update_quote_request?: Maybe<Quote_Request_Mutation_Response>
  /** update single row of the table: "quote_request" */
  update_quote_request_by_pk?: Maybe<Quote_Request>
  /** update multiples rows of table: "quote_request" */
  update_quote_request_many?: Maybe<
    Array<Maybe<Quote_Request_Mutation_Response>>
  >
  /** update data of the table: "recipients" */
  update_recipients?: Maybe<Recipients_Mutation_Response>
  /** update single row of the table: "recipients" */
  update_recipients_by_pk?: Maybe<Recipients>
  /** update multiples rows of table: "recipients" */
  update_recipients_many?: Maybe<Array<Maybe<Recipients_Mutation_Response>>>
  /** update data of the table: "refresh_tokens" */
  update_refresh_tokens?: Maybe<Refresh_Tokens_Mutation_Response>
  /** update multiples rows of table: "refresh_tokens" */
  update_refresh_tokens_many?: Maybe<
    Array<Maybe<Refresh_Tokens_Mutation_Response>>
  >
  /** update data of the table: "refunds" */
  update_refunds?: Maybe<Refunds_Mutation_Response>
  /** update single row of the table: "refunds" */
  update_refunds_by_pk?: Maybe<Refunds>
  /** update multiples rows of table: "refunds" */
  update_refunds_many?: Maybe<Array<Maybe<Refunds_Mutation_Response>>>
  /** update data of the table: "register" */
  update_register?: Maybe<Register_Mutation_Response>
  /** update single row of the table: "register" */
  update_register_by_pk?: Maybe<Register>
  /** update multiples rows of table: "register" */
  update_register_many?: Maybe<Array<Maybe<Register_Mutation_Response>>>
  /** update data of the table: "registration_credit_check" */
  update_registration_credit_check?: Maybe<Registration_Credit_Check_Mutation_Response>
  /** update data of the table: "registration_credit_check_address" */
  update_registration_credit_check_address?: Maybe<Registration_Credit_Check_Address_Mutation_Response>
  /** update single row of the table: "registration_credit_check_address" */
  update_registration_credit_check_address_by_pk?: Maybe<Registration_Credit_Check_Address>
  /** update multiples rows of table: "registration_credit_check_address" */
  update_registration_credit_check_address_many?: Maybe<
    Array<Maybe<Registration_Credit_Check_Address_Mutation_Response>>
  >
  /** update single row of the table: "registration_credit_check" */
  update_registration_credit_check_by_pk?: Maybe<Registration_Credit_Check>
  /** update multiples rows of table: "registration_credit_check" */
  update_registration_credit_check_many?: Maybe<
    Array<Maybe<Registration_Credit_Check_Mutation_Response>>
  >
  /** update data of the table: "reminder" */
  update_reminder?: Maybe<Reminder_Mutation_Response>
  /** update single row of the table: "reminder" */
  update_reminder_by_pk?: Maybe<Reminder>
  /** update multiples rows of table: "reminder" */
  update_reminder_many?: Maybe<Array<Maybe<Reminder_Mutation_Response>>>
  /** update data of the table: "renewal" */
  update_renewal?: Maybe<Renewal_Mutation_Response>
  /** update single row of the table: "renewal" */
  update_renewal_by_pk?: Maybe<Renewal>
  /** update multiples rows of table: "renewal" */
  update_renewal_many?: Maybe<Array<Maybe<Renewal_Mutation_Response>>>
  /** update data of the table: "report_problem" */
  update_report_problem?: Maybe<Report_Problem_Mutation_Response>
  /** update data of the table: "report_problem_attachments" */
  update_report_problem_attachments?: Maybe<Report_Problem_Attachments_Mutation_Response>
  /** update single row of the table: "report_problem_attachments" */
  update_report_problem_attachments_by_pk?: Maybe<Report_Problem_Attachments>
  /** update multiples rows of table: "report_problem_attachments" */
  update_report_problem_attachments_many?: Maybe<
    Array<Maybe<Report_Problem_Attachments_Mutation_Response>>
  >
  /** update single row of the table: "report_problem" */
  update_report_problem_by_pk?: Maybe<Report_Problem>
  /** update multiples rows of table: "report_problem" */
  update_report_problem_many?: Maybe<
    Array<Maybe<Report_Problem_Mutation_Response>>
  >
  /** update data of the table: "requests" */
  update_requests?: Maybe<Requests_Mutation_Response>
  /** update single row of the table: "requests" */
  update_requests_by_pk?: Maybe<Requests>
  /** update multiples rows of table: "requests" */
  update_requests_many?: Maybe<Array<Maybe<Requests_Mutation_Response>>>
  /** update data of the table: "rts_meters_report" */
  update_rts_meters_report?: Maybe<Rts_Meters_Report_Mutation_Response>
  /** update multiples rows of table: "rts_meters_report" */
  update_rts_meters_report_many?: Maybe<
    Array<Maybe<Rts_Meters_Report_Mutation_Response>>
  >
  /** update data of the table: "scheduled_payment" */
  update_scheduled_payment?: Maybe<Scheduled_Payment_Mutation_Response>
  /** update single row of the table: "scheduled_payment" */
  update_scheduled_payment_by_pk?: Maybe<Scheduled_Payment>
  /** update multiples rows of table: "scheduled_payment" */
  update_scheduled_payment_many?: Maybe<
    Array<Maybe<Scheduled_Payment_Mutation_Response>>
  >
  /** update data of the table: "scheduled_refund" */
  update_scheduled_refund?: Maybe<Scheduled_Refund_Mutation_Response>
  /** update single row of the table: "scheduled_refund" */
  update_scheduled_refund_by_pk?: Maybe<Scheduled_Refund>
  /** update multiples rows of table: "scheduled_refund" */
  update_scheduled_refund_many?: Maybe<
    Array<Maybe<Scheduled_Refund_Mutation_Response>>
  >
  /** update data of the table: "smart_charging" */
  update_smart_charging?: Maybe<Smart_Charging_Mutation_Response>
  /** update single row of the table: "smart_charging" */
  update_smart_charging_by_pk?: Maybe<Smart_Charging>
  /** update multiples rows of table: "smart_charging" */
  update_smart_charging_many?: Maybe<
    Array<Maybe<Smart_Charging_Mutation_Response>>
  >
  /** update data of the table: "smart_meter_dashboard_response_v7" */
  update_smart_meter_dashboard_response_v7?: Maybe<Smart_Meter_Dashboard_Response_V7_Mutation_Response>
  /** update multiples rows of table: "smart_meter_dashboard_response_v7" */
  update_smart_meter_dashboard_response_v7_many?: Maybe<
    Array<Maybe<Smart_Meter_Dashboard_Response_V7_Mutation_Response>>
  >
  /** update data of the table: "smart_meters_eligible_for_exchange" */
  update_smart_meters_eligible_for_exchange?: Maybe<Smart_Meters_Eligible_For_Exchange_Mutation_Response>
  /** update single row of the table: "smart_meters_eligible_for_exchange" */
  update_smart_meters_eligible_for_exchange_by_pk?: Maybe<Smart_Meters_Eligible_For_Exchange>
  /** update multiples rows of table: "smart_meters_eligible_for_exchange" */
  update_smart_meters_eligible_for_exchange_many?: Maybe<
    Array<Maybe<Smart_Meters_Eligible_For_Exchange_Mutation_Response>>
  >
  /** update data of the table: "sync_status" */
  update_sync_status?: Maybe<Sync_Status_Mutation_Response>
  /** update single row of the table: "sync_status" */
  update_sync_status_by_pk?: Maybe<Sync_Status>
  /** update multiples rows of table: "sync_status" */
  update_sync_status_many?: Maybe<Array<Maybe<Sync_Status_Mutation_Response>>>
  /** update data of the table: "synchronized_accounts" */
  update_synchronized_accounts?: Maybe<Synchronized_Accounts_Mutation_Response>
  /** update single row of the table: "synchronized_accounts" */
  update_synchronized_accounts_by_pk?: Maybe<Synchronized_Accounts>
  /** update multiples rows of table: "synchronized_accounts" */
  update_synchronized_accounts_many?: Maybe<
    Array<Maybe<Synchronized_Accounts_Mutation_Response>>
  >
  /** update data of the table: "ticket" */
  update_ticket?: Maybe<Ticket_Mutation_Response>
  /** update single row of the table: "ticket" */
  update_ticket_by_pk?: Maybe<Ticket>
  /** update multiples rows of table: "ticket" */
  update_ticket_many?: Maybe<Array<Maybe<Ticket_Mutation_Response>>>
  /** update data of the table: "automation_account_store" */
  update_tickets_automation_account_store?: Maybe<Tickets_Automation_Account_Store_Mutation_Response>
  /** update single row of the table: "automation_account_store" */
  update_tickets_automation_account_store_by_pk?: Maybe<Tickets_Automation_Account_Store>
  /** update multiples rows of table: "automation_account_store" */
  update_tickets_automation_account_store_many?: Maybe<
    Array<Maybe<Tickets_Automation_Account_Store_Mutation_Response>>
  >
  /** update data of the table: "automation_config" */
  update_tickets_automation_config?: Maybe<Tickets_Automation_Config_Mutation_Response>
  /** update single row of the table: "automation_config" */
  update_tickets_automation_config_by_pk?: Maybe<Tickets_Automation_Config>
  /** update data of the table: "automation_config_default" */
  update_tickets_automation_config_default?: Maybe<Tickets_Automation_Config_Default_Mutation_Response>
  /** update single row of the table: "automation_config_default" */
  update_tickets_automation_config_default_by_pk?: Maybe<Tickets_Automation_Config_Default>
  /** update multiples rows of table: "automation_config_default" */
  update_tickets_automation_config_default_many?: Maybe<
    Array<Maybe<Tickets_Automation_Config_Default_Mutation_Response>>
  >
  /** update multiples rows of table: "automation_config" */
  update_tickets_automation_config_many?: Maybe<
    Array<Maybe<Tickets_Automation_Config_Mutation_Response>>
  >
  /** update data of the table: "automation_config_purge" */
  update_tickets_automation_config_purge?: Maybe<Tickets_Automation_Config_Purge_Mutation_Response>
  /** update single row of the table: "automation_config_purge" */
  update_tickets_automation_config_purge_by_pk?: Maybe<Tickets_Automation_Config_Purge>
  /** update multiples rows of table: "automation_config_purge" */
  update_tickets_automation_config_purge_many?: Maybe<
    Array<Maybe<Tickets_Automation_Config_Purge_Mutation_Response>>
  >
  /** update data of the table: "automation_default_ticket_action" */
  update_tickets_automation_default_ticket_action?: Maybe<Tickets_Automation_Default_Ticket_Action_Mutation_Response>
  /** update single row of the table: "automation_default_ticket_action" */
  update_tickets_automation_default_ticket_action_by_pk?: Maybe<Tickets_Automation_Default_Ticket_Action>
  /** update multiples rows of table: "automation_default_ticket_action" */
  update_tickets_automation_default_ticket_action_many?: Maybe<
    Array<Maybe<Tickets_Automation_Default_Ticket_Action_Mutation_Response>>
  >
  /** update data of the table: "automation_defaults_acceptable_accounts_table" */
  update_tickets_automation_defaults_acceptable_accounts_table?: Maybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Mutation_Response>
  /** update single row of the table: "automation_defaults_acceptable_accounts_table" */
  update_tickets_automation_defaults_acceptable_accounts_table_by_pk?: Maybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table>
  /** update multiples rows of table: "automation_defaults_acceptable_accounts_table" */
  update_tickets_automation_defaults_acceptable_accounts_table_many?: Maybe<
    Array<
      Maybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Mutation_Response>
    >
  >
  /** update data of the table: "automation_defaults_opened_predefaults" */
  update_tickets_automation_defaults_opened_predefaults?: Maybe<Tickets_Automation_Defaults_Opened_Predefaults_Mutation_Response>
  /** update single row of the table: "automation_defaults_opened_predefaults" */
  update_tickets_automation_defaults_opened_predefaults_by_pk?: Maybe<Tickets_Automation_Defaults_Opened_Predefaults>
  /** update multiples rows of table: "automation_defaults_opened_predefaults" */
  update_tickets_automation_defaults_opened_predefaults_many?: Maybe<
    Array<
      Maybe<Tickets_Automation_Defaults_Opened_Predefaults_Mutation_Response>
    >
  >
  /** update data of the table: "automation_job" */
  update_tickets_automation_job?: Maybe<Tickets_Automation_Job_Mutation_Response>
  /** update single row of the table: "automation_job" */
  update_tickets_automation_job_by_pk?: Maybe<Tickets_Automation_Job>
  /** update multiples rows of table: "automation_job" */
  update_tickets_automation_job_many?: Maybe<
    Array<Maybe<Tickets_Automation_Job_Mutation_Response>>
  >
  /** update data of the table: "automation_purge_job" */
  update_tickets_automation_purge_job?: Maybe<Tickets_Automation_Purge_Job_Mutation_Response>
  /** update single row of the table: "automation_purge_job" */
  update_tickets_automation_purge_job_by_pk?: Maybe<Tickets_Automation_Purge_Job>
  /** update multiples rows of table: "automation_purge_job" */
  update_tickets_automation_purge_job_many?: Maybe<
    Array<Maybe<Tickets_Automation_Purge_Job_Mutation_Response>>
  >
  /** update data of the table: "automation_ticket_store" */
  update_tickets_automation_ticket_store?: Maybe<Tickets_Automation_Ticket_Store_Mutation_Response>
  /** update single row of the table: "automation_ticket_store" */
  update_tickets_automation_ticket_store_by_pk?: Maybe<Tickets_Automation_Ticket_Store>
  /** update multiples rows of table: "automation_ticket_store" */
  update_tickets_automation_ticket_store_many?: Maybe<
    Array<Maybe<Tickets_Automation_Ticket_Store_Mutation_Response>>
  >
  /** update data of the table: "dca_account_allocation" */
  update_tickets_dca_account_allocation?: Maybe<Tickets_Dca_Account_Allocation_Mutation_Response>
  /** update single row of the table: "dca_account_allocation" */
  update_tickets_dca_account_allocation_by_pk?: Maybe<Tickets_Dca_Account_Allocation>
  /** update multiples rows of table: "dca_account_allocation" */
  update_tickets_dca_account_allocation_many?: Maybe<
    Array<Maybe<Tickets_Dca_Account_Allocation_Mutation_Response>>
  >
  /** update data of the table: "dca_allocation_configuration" */
  update_tickets_dca_allocation_configuration?: Maybe<Tickets_Dca_Allocation_Configuration_Mutation_Response>
  /** update single row of the table: "dca_allocation_configuration" */
  update_tickets_dca_allocation_configuration_by_pk?: Maybe<Tickets_Dca_Allocation_Configuration>
  /** update multiples rows of table: "dca_allocation_configuration" */
  update_tickets_dca_allocation_configuration_many?: Maybe<
    Array<Maybe<Tickets_Dca_Allocation_Configuration_Mutation_Response>>
  >
  /** update data of the table: "dca_configuration_v2" */
  update_tickets_dca_configuration_v2?: Maybe<Tickets_Dca_Configuration_V2_Mutation_Response>
  /** update single row of the table: "dca_configuration_v2" */
  update_tickets_dca_configuration_v2_by_pk?: Maybe<Tickets_Dca_Configuration_V2>
  /** update multiples rows of table: "dca_configuration_v2" */
  update_tickets_dca_configuration_v2_many?: Maybe<
    Array<Maybe<Tickets_Dca_Configuration_V2_Mutation_Response>>
  >
  /** update data of the table: "dca_segmentation" */
  update_tickets_dca_segmentation?: Maybe<Tickets_Dca_Segmentation_Mutation_Response>
  /** update single row of the table: "dca_segmentation" */
  update_tickets_dca_segmentation_by_pk?: Maybe<Tickets_Dca_Segmentation>
  /** update multiples rows of table: "dca_segmentation" */
  update_tickets_dca_segmentation_many?: Maybe<
    Array<Maybe<Tickets_Dca_Segmentation_Mutation_Response>>
  >
  /** update data of the table: "dunning_account_store" */
  update_tickets_dunning_account_store?: Maybe<Tickets_Dunning_Account_Store_Mutation_Response>
  /** update single row of the table: "dunning_account_store" */
  update_tickets_dunning_account_store_by_pk?: Maybe<Tickets_Dunning_Account_Store>
  /** update multiples rows of table: "dunning_account_store" */
  update_tickets_dunning_account_store_many?: Maybe<
    Array<Maybe<Tickets_Dunning_Account_Store_Mutation_Response>>
  >
  /** update data of the table: "dunning_addacs_review_records" */
  update_tickets_dunning_addacs_review_records?: Maybe<Tickets_Dunning_Addacs_Review_Records_Mutation_Response>
  /** update single row of the table: "dunning_addacs_review_records" */
  update_tickets_dunning_addacs_review_records_by_pk?: Maybe<Tickets_Dunning_Addacs_Review_Records>
  /** update multiples rows of table: "dunning_addacs_review_records" */
  update_tickets_dunning_addacs_review_records_many?: Maybe<
    Array<Maybe<Tickets_Dunning_Addacs_Review_Records_Mutation_Response>>
  >
  /** update data of the table: "dunning_automation_events" */
  update_tickets_dunning_automation_events?: Maybe<Tickets_Dunning_Automation_Events_Mutation_Response>
  /** update single row of the table: "dunning_automation_events" */
  update_tickets_dunning_automation_events_by_pk?: Maybe<Tickets_Dunning_Automation_Events>
  /** update multiples rows of table: "dunning_automation_events" */
  update_tickets_dunning_automation_events_many?: Maybe<
    Array<Maybe<Tickets_Dunning_Automation_Events_Mutation_Response>>
  >
  /** update data of the table: "dunning_debt_ticket_review_records" */
  update_tickets_dunning_debt_ticket_review_records?: Maybe<Tickets_Dunning_Debt_Ticket_Review_Records_Mutation_Response>
  /** update single row of the table: "dunning_debt_ticket_review_records" */
  update_tickets_dunning_debt_ticket_review_records_by_pk?: Maybe<Tickets_Dunning_Debt_Ticket_Review_Records>
  /** update multiples rows of table: "dunning_debt_ticket_review_records" */
  update_tickets_dunning_debt_ticket_review_records_many?: Maybe<
    Array<Maybe<Tickets_Dunning_Debt_Ticket_Review_Records_Mutation_Response>>
  >
  /** update data of the table: "dunning_job" */
  update_tickets_dunning_job?: Maybe<Tickets_Dunning_Job_Mutation_Response>
  /** update single row of the table: "dunning_job" */
  update_tickets_dunning_job_by_pk?: Maybe<Tickets_Dunning_Job>
  /** update multiples rows of table: "dunning_job" */
  update_tickets_dunning_job_many?: Maybe<
    Array<Maybe<Tickets_Dunning_Job_Mutation_Response>>
  >
  /** update data of the table: "dunning_legal_known_ticket_records" */
  update_tickets_dunning_legal_known_ticket_records?: Maybe<Tickets_Dunning_Legal_Known_Ticket_Records_Mutation_Response>
  /** update single row of the table: "dunning_legal_known_ticket_records" */
  update_tickets_dunning_legal_known_ticket_records_by_pk?: Maybe<Tickets_Dunning_Legal_Known_Ticket_Records>
  /** update multiples rows of table: "dunning_legal_known_ticket_records" */
  update_tickets_dunning_legal_known_ticket_records_many?: Maybe<
    Array<Maybe<Tickets_Dunning_Legal_Known_Ticket_Records_Mutation_Response>>
  >
  /** update data of the table: "dunning_legal_occupier_ticket_records" */
  update_tickets_dunning_legal_occupier_ticket_records?: Maybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Mutation_Response>
  /** update single row of the table: "dunning_legal_occupier_ticket_records" */
  update_tickets_dunning_legal_occupier_ticket_records_by_pk?: Maybe<Tickets_Dunning_Legal_Occupier_Ticket_Records>
  /** update multiples rows of table: "dunning_legal_occupier_ticket_records" */
  update_tickets_dunning_legal_occupier_ticket_records_many?: Maybe<
    Array<
      Maybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Mutation_Response>
    >
  >
  /** update data of the table: "dunning_occupier_accounts_review_records" */
  update_tickets_dunning_occupier_accounts_review_records?: Maybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Mutation_Response>
  /** update single row of the table: "dunning_occupier_accounts_review_records" */
  update_tickets_dunning_occupier_accounts_review_records_by_pk?: Maybe<Tickets_Dunning_Occupier_Accounts_Review_Records>
  /** update multiples rows of table: "dunning_occupier_accounts_review_records" */
  update_tickets_dunning_occupier_accounts_review_records_many?: Maybe<
    Array<
      Maybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Mutation_Response>
    >
  >
  /** update data of the table: "dunning_purge_job" */
  update_tickets_dunning_purge_job?: Maybe<Tickets_Dunning_Purge_Job_Mutation_Response>
  /** update single row of the table: "dunning_purge_job" */
  update_tickets_dunning_purge_job_by_pk?: Maybe<Tickets_Dunning_Purge_Job>
  /** update multiples rows of table: "dunning_purge_job" */
  update_tickets_dunning_purge_job_many?: Maybe<
    Array<Maybe<Tickets_Dunning_Purge_Job_Mutation_Response>>
  >
  /** update data of the table: "dunning_standard_ticket_records" */
  update_tickets_dunning_standard_ticket_records?: Maybe<Tickets_Dunning_Standard_Ticket_Records_Mutation_Response>
  /** update single row of the table: "dunning_standard_ticket_records" */
  update_tickets_dunning_standard_ticket_records_by_pk?: Maybe<Tickets_Dunning_Standard_Ticket_Records>
  /** update multiples rows of table: "dunning_standard_ticket_records" */
  update_tickets_dunning_standard_ticket_records_many?: Maybe<
    Array<Maybe<Tickets_Dunning_Standard_Ticket_Records_Mutation_Response>>
  >
  /** update data of the table: "dunning_statistics" */
  update_tickets_dunning_statistics?: Maybe<Tickets_Dunning_Statistics_Mutation_Response>
  /** update single row of the table: "dunning_statistics" */
  update_tickets_dunning_statistics_by_pk?: Maybe<Tickets_Dunning_Statistics>
  /** update multiples rows of table: "dunning_statistics" */
  update_tickets_dunning_statistics_many?: Maybe<
    Array<Maybe<Tickets_Dunning_Statistics_Mutation_Response>>
  >
  /** update data of the table: "dunning_terminating_accounts_review_records" */
  update_tickets_dunning_terminating_accounts_review_records?: Maybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Mutation_Response>
  /** update single row of the table: "dunning_terminating_accounts_review_records" */
  update_tickets_dunning_terminating_accounts_review_records_by_pk?: Maybe<Tickets_Dunning_Terminating_Accounts_Review_Records>
  /** update multiples rows of table: "dunning_terminating_accounts_review_records" */
  update_tickets_dunning_terminating_accounts_review_records_many?: Maybe<
    Array<
      Maybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Mutation_Response>
    >
  >
  /** update data of the table: "dunning_ticket_store" */
  update_tickets_dunning_ticket_store?: Maybe<Tickets_Dunning_Ticket_Store_Mutation_Response>
  /** update single row of the table: "dunning_ticket_store" */
  update_tickets_dunning_ticket_store_by_pk?: Maybe<Tickets_Dunning_Ticket_Store>
  /** update multiples rows of table: "dunning_ticket_store" */
  update_tickets_dunning_ticket_store_many?: Maybe<
    Array<Maybe<Tickets_Dunning_Ticket_Store_Mutation_Response>>
  >
  /** update data of the table: "dunning_workflow" */
  update_tickets_dunning_workflow?: Maybe<Tickets_Dunning_Workflow_Mutation_Response>
  /** update single row of the table: "dunning_workflow" */
  update_tickets_dunning_workflow_by_pk?: Maybe<Tickets_Dunning_Workflow>
  /** update multiples rows of table: "dunning_workflow" */
  update_tickets_dunning_workflow_many?: Maybe<
    Array<Maybe<Tickets_Dunning_Workflow_Mutation_Response>>
  >
  /** update data of the table: "external_event" */
  update_tickets_external_event?: Maybe<Tickets_External_Event_Mutation_Response>
  /** update single row of the table: "external_event" */
  update_tickets_external_event_by_pk?: Maybe<Tickets_External_Event>
  /** update multiples rows of table: "external_event" */
  update_tickets_external_event_many?: Maybe<
    Array<Maybe<Tickets_External_Event_Mutation_Response>>
  >
  /** update data of the table: "external_tickets" */
  update_tickets_external_tickets?: Maybe<Tickets_External_Tickets_Mutation_Response>
  /** update single row of the table: "external_tickets" */
  update_tickets_external_tickets_by_pk?: Maybe<Tickets_External_Tickets>
  /** update multiples rows of table: "external_tickets" */
  update_tickets_external_tickets_many?: Maybe<
    Array<Maybe<Tickets_External_Tickets_Mutation_Response>>
  >
  /** update data of the table: "qrtz_blob_triggers" */
  update_tickets_qrtz_blob_triggers?: Maybe<Tickets_Qrtz_Blob_Triggers_Mutation_Response>
  /** update single row of the table: "qrtz_blob_triggers" */
  update_tickets_qrtz_blob_triggers_by_pk?: Maybe<Tickets_Qrtz_Blob_Triggers>
  /** update multiples rows of table: "qrtz_blob_triggers" */
  update_tickets_qrtz_blob_triggers_many?: Maybe<
    Array<Maybe<Tickets_Qrtz_Blob_Triggers_Mutation_Response>>
  >
  /** update data of the table: "qrtz_calendars" */
  update_tickets_qrtz_calendars?: Maybe<Tickets_Qrtz_Calendars_Mutation_Response>
  /** update single row of the table: "qrtz_calendars" */
  update_tickets_qrtz_calendars_by_pk?: Maybe<Tickets_Qrtz_Calendars>
  /** update multiples rows of table: "qrtz_calendars" */
  update_tickets_qrtz_calendars_many?: Maybe<
    Array<Maybe<Tickets_Qrtz_Calendars_Mutation_Response>>
  >
  /** update data of the table: "qrtz_cron_triggers" */
  update_tickets_qrtz_cron_triggers?: Maybe<Tickets_Qrtz_Cron_Triggers_Mutation_Response>
  /** update single row of the table: "qrtz_cron_triggers" */
  update_tickets_qrtz_cron_triggers_by_pk?: Maybe<Tickets_Qrtz_Cron_Triggers>
  /** update multiples rows of table: "qrtz_cron_triggers" */
  update_tickets_qrtz_cron_triggers_many?: Maybe<
    Array<Maybe<Tickets_Qrtz_Cron_Triggers_Mutation_Response>>
  >
  /** update data of the table: "qrtz_fired_triggers" */
  update_tickets_qrtz_fired_triggers?: Maybe<Tickets_Qrtz_Fired_Triggers_Mutation_Response>
  /** update single row of the table: "qrtz_fired_triggers" */
  update_tickets_qrtz_fired_triggers_by_pk?: Maybe<Tickets_Qrtz_Fired_Triggers>
  /** update multiples rows of table: "qrtz_fired_triggers" */
  update_tickets_qrtz_fired_triggers_many?: Maybe<
    Array<Maybe<Tickets_Qrtz_Fired_Triggers_Mutation_Response>>
  >
  /** update data of the table: "qrtz_job_details" */
  update_tickets_qrtz_job_details?: Maybe<Tickets_Qrtz_Job_Details_Mutation_Response>
  /** update single row of the table: "qrtz_job_details" */
  update_tickets_qrtz_job_details_by_pk?: Maybe<Tickets_Qrtz_Job_Details>
  /** update multiples rows of table: "qrtz_job_details" */
  update_tickets_qrtz_job_details_many?: Maybe<
    Array<Maybe<Tickets_Qrtz_Job_Details_Mutation_Response>>
  >
  /** update data of the table: "qrtz_locks" */
  update_tickets_qrtz_locks?: Maybe<Tickets_Qrtz_Locks_Mutation_Response>
  /** update single row of the table: "qrtz_locks" */
  update_tickets_qrtz_locks_by_pk?: Maybe<Tickets_Qrtz_Locks>
  /** update multiples rows of table: "qrtz_locks" */
  update_tickets_qrtz_locks_many?: Maybe<
    Array<Maybe<Tickets_Qrtz_Locks_Mutation_Response>>
  >
  /** update data of the table: "qrtz_paused_trigger_grps" */
  update_tickets_qrtz_paused_trigger_grps?: Maybe<Tickets_Qrtz_Paused_Trigger_Grps_Mutation_Response>
  /** update single row of the table: "qrtz_paused_trigger_grps" */
  update_tickets_qrtz_paused_trigger_grps_by_pk?: Maybe<Tickets_Qrtz_Paused_Trigger_Grps>
  /** update multiples rows of table: "qrtz_paused_trigger_grps" */
  update_tickets_qrtz_paused_trigger_grps_many?: Maybe<
    Array<Maybe<Tickets_Qrtz_Paused_Trigger_Grps_Mutation_Response>>
  >
  /** update data of the table: "qrtz_scheduler_state" */
  update_tickets_qrtz_scheduler_state?: Maybe<Tickets_Qrtz_Scheduler_State_Mutation_Response>
  /** update single row of the table: "qrtz_scheduler_state" */
  update_tickets_qrtz_scheduler_state_by_pk?: Maybe<Tickets_Qrtz_Scheduler_State>
  /** update multiples rows of table: "qrtz_scheduler_state" */
  update_tickets_qrtz_scheduler_state_many?: Maybe<
    Array<Maybe<Tickets_Qrtz_Scheduler_State_Mutation_Response>>
  >
  /** update data of the table: "qrtz_simple_triggers" */
  update_tickets_qrtz_simple_triggers?: Maybe<Tickets_Qrtz_Simple_Triggers_Mutation_Response>
  /** update single row of the table: "qrtz_simple_triggers" */
  update_tickets_qrtz_simple_triggers_by_pk?: Maybe<Tickets_Qrtz_Simple_Triggers>
  /** update multiples rows of table: "qrtz_simple_triggers" */
  update_tickets_qrtz_simple_triggers_many?: Maybe<
    Array<Maybe<Tickets_Qrtz_Simple_Triggers_Mutation_Response>>
  >
  /** update data of the table: "qrtz_simprop_triggers" */
  update_tickets_qrtz_simprop_triggers?: Maybe<Tickets_Qrtz_Simprop_Triggers_Mutation_Response>
  /** update single row of the table: "qrtz_simprop_triggers" */
  update_tickets_qrtz_simprop_triggers_by_pk?: Maybe<Tickets_Qrtz_Simprop_Triggers>
  /** update multiples rows of table: "qrtz_simprop_triggers" */
  update_tickets_qrtz_simprop_triggers_many?: Maybe<
    Array<Maybe<Tickets_Qrtz_Simprop_Triggers_Mutation_Response>>
  >
  /** update data of the table: "qrtz_triggers" */
  update_tickets_qrtz_triggers?: Maybe<Tickets_Qrtz_Triggers_Mutation_Response>
  /** update single row of the table: "qrtz_triggers" */
  update_tickets_qrtz_triggers_by_pk?: Maybe<Tickets_Qrtz_Triggers>
  /** update multiples rows of table: "qrtz_triggers" */
  update_tickets_qrtz_triggers_many?: Maybe<
    Array<Maybe<Tickets_Qrtz_Triggers_Mutation_Response>>
  >
  /** update data of the table: "trustpilot_invitations" */
  update_trustpilot_invitations?: Maybe<Trustpilot_Invitations_Mutation_Response>
  /** update multiples rows of table: "trustpilot_invitations" */
  update_trustpilot_invitations_many?: Maybe<
    Array<Maybe<Trustpilot_Invitations_Mutation_Response>>
  >
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>
  /** update data of the table: "uswitch_record" */
  update_uswitch_record?: Maybe<Uswitch_Record_Mutation_Response>
  /** update single row of the table: "uswitch_record" */
  update_uswitch_record_by_pk?: Maybe<Uswitch_Record>
  /** update multiples rows of table: "uswitch_record" */
  update_uswitch_record_many?: Maybe<
    Array<Maybe<Uswitch_Record_Mutation_Response>>
  >
  /** update data of the table: "warm_home_discount_application" */
  update_warm_home_discount_application?: Maybe<Warm_Home_Discount_Application_Mutation_Response>
  /** update single row of the table: "warm_home_discount_application" */
  update_warm_home_discount_application_by_pk?: Maybe<Warm_Home_Discount_Application>
  /** update multiples rows of table: "warm_home_discount_application" */
  update_warm_home_discount_application_many?: Maybe<
    Array<Maybe<Warm_Home_Discount_Application_Mutation_Response>>
  >
  /** update data of the table: "warm_home_discount_application_status_history" */
  update_warm_home_discount_application_status_history?: Maybe<Warm_Home_Discount_Application_Status_History_Mutation_Response>
  /** update single row of the table: "warm_home_discount_application_status_history" */
  update_warm_home_discount_application_status_history_by_pk?: Maybe<Warm_Home_Discount_Application_Status_History>
  /** update multiples rows of table: "warm_home_discount_application_status_history" */
  update_warm_home_discount_application_status_history_many?: Maybe<
    Array<
      Maybe<Warm_Home_Discount_Application_Status_History_Mutation_Response>
    >
  >
  /** update data of the table: "warm_home_discount_criteria" */
  update_warm_home_discount_criteria?: Maybe<Warm_Home_Discount_Criteria_Mutation_Response>
  /** update single row of the table: "warm_home_discount_criteria" */
  update_warm_home_discount_criteria_by_pk?: Maybe<Warm_Home_Discount_Criteria>
  /** update multiples rows of table: "warm_home_discount_criteria" */
  update_warm_home_discount_criteria_many?: Maybe<
    Array<Maybe<Warm_Home_Discount_Criteria_Mutation_Response>>
  >
  /** update data of the table: "warm_home_discount_criteria_rel" */
  update_warm_home_discount_criteria_rel?: Maybe<Warm_Home_Discount_Criteria_Rel_Mutation_Response>
  /** update single row of the table: "warm_home_discount_criteria_rel" */
  update_warm_home_discount_criteria_rel_by_pk?: Maybe<Warm_Home_Discount_Criteria_Rel>
  /** update multiples rows of table: "warm_home_discount_criteria_rel" */
  update_warm_home_discount_criteria_rel_many?: Maybe<
    Array<Maybe<Warm_Home_Discount_Criteria_Rel_Mutation_Response>>
  >
}

/** mutation root */
export type Mutation_RootAccountsForAuditArgs = {
  account_numbers?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
}

/** mutation root */
export type Mutation_RootAction_Payment_Review_Records_Delete_By_IdsArgs = {
  request: PaymentReviewRecordsDeleteByIdsRequest
}

/** mutation root */
export type Mutation_RootAddCoreGroupVulnerabilityArgs = {
  warm_home_discounts_interface: WhdInterface
}

/** mutation root */
export type Mutation_RootApplyCreditArgs = {
  warm_home_discounts_interface: WhdInterface
}

/** mutation root */
export type Mutation_RootApplyReferralCodeArgs = {
  id: Scalars["BigInt"]["input"]
  userApplyReferralCodeInput: UserApplyReferralCodeInput
}

/** mutation root */
export type Mutation_RootChangeOfTenancyArgs = {
  changeOfTenancyRequestDtoInput: ChangeOfTenancyRequestDtoInput
}

/** mutation root */
export type Mutation_RootChangeUserPasswordArgs = {
  id: Scalars["BigInt"]["input"]
  userChangePasswordInput: UserChangePasswordInput
}

/** mutation root */
export type Mutation_RootCloseNoEvidenceArgs = {
  warm_home_discounts_interface: WhdInterface
}

/** mutation root */
export type Mutation_RootCreateAccountCreditArgs = {
  createAccountCreditRequest: CreateAccountCreditRequest
}

/** mutation root */
export type Mutation_RootCreateUserFromJuniferArgs = {
  userCreateFromJuniferInput: UserCreateFromJuniferInput
}

/** mutation root */
export type Mutation_RootDelete_ElecNominationsArgs = {
  where: ElecNominations_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_ElecTradesArgs = {
  where: ElecTrades_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_ElecTradesHistoryArgs = {
  where: ElecTradesHistory_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_ElecTradesHistory_By_PkArgs = {
  id: Scalars["Int"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_ElecTrades_By_PkArgs = {
  id: Scalars["Int"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_GasTradesArgs = {
  where: GasTrades_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_GasTradesHistoryArgs = {
  where: GasTradesHistory_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_GasTradesHistory_By_PkArgs = {
  id: Scalars["Int"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_GasTrades_By_PkArgs = {
  id: Scalars["Int"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Account_CreditArgs = {
  where: Account_Credit_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Account_Credit_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Active_Outbound_Photo_RequestArgs = {
  where: Active_Outbound_Photo_Request_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_AddressArgs = {
  where: Address_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Address_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Admin_PassesArgs = {
  where: Admin_Passes_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Admin_Passes_By_PkArgs = {
  id: Scalars["Int"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Admin_RolesArgs = {
  where: Admin_Roles_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Admin_Roles_By_PkArgs = {
  id: Scalars["Int"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_AgreementArgs = {
  where: Agreement_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Agreement_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_AssetArgs = {
  where: Asset_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Asset_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_AttachmentArgs = {
  where: Attachment_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Attachment_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Axle_Trial_EligibilityArgs = {
  where: Axle_Trial_Eligibility_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Axle_Trial_Eligibility_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_BillArgs = {
  where: Bill_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Bill_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Billing_AccountArgs = {
  where: Billing_Account_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Billing_Account_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Billing_Account_ContactArgs = {
  where: Billing_Account_Contact_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Billing_Account_Contact_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Billing_Account_SettingArgs = {
  where: Billing_Account_Setting_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Billing_Account_Setting_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Billing_Account_TransactionArgs = {
  where: Billing_Account_Transaction_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Billing_Account_Transaction_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Billing_PeriodArgs = {
  where: Billing_Period_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Billing_Period_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Calculation_ItemsArgs = {
  where: Calculation_Items_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Calculation_Items_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Call_Trace_AuditArgs = {
  where: Call_Trace_Audit_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Call_Trace_Audit_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Cancellation_ReasonsArgs = {
  where: Cancellation_Reasons_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_CancellationsArgs = {
  where: Cancellations_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Cancellations_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Card_PaymentArgs = {
  where: Card_Payment_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Card_Payment_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Card_Payment_OldArgs = {
  where: Card_Payment_Old_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Card_Payment_Old_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_CasesArgs = {
  where: Cases_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Cases_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_CommunicationArgs = {
  where: Communication_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Communication_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Communication_MetadataArgs = {
  where: Communication_Metadata_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Communication_Metadata_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_CommunicationsArgs = {
  where: Communications_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Communications_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_ComplaintArgs = {
  where: Complaint_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Complaint_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Completed_Sync_Event_AccountArgs = {
  where: Completed_Sync_Event_Account_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Completed_Sync_Event_Account_By_PkArgs = {
  event_type: Scalars["event_type"]["input"]
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_ConfigurationArgs = {
  where: Configuration_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Configuration_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_ContactArgs = {
  where: Contact_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Contact_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Cs__Soe_Dashboard_TotalArgs = {
  where: Cs__Soe_Dashboard_Total_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Cs__Soe_Dashboard_Total_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_CustomerArgs = {
  where: Customer_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Customer_AddressArgs = {
  where: Customer_Address_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Customer_Address_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Customer_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Customer_ContactArgs = {
  where: Customer_Contact_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Customer_Contact_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Customer_MetadataArgs = {
  where: Customer_Metadata_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Customer_Metadata_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Customer_Property_RelArgs = {
  where: Customer_Property_Rel_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Customer_Property_Rel_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Customer_Psr_RelArgs = {
  where: Customer_Psr_Rel_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Customer_Psr_Rel_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Customer_ReferralsArgs = {
  where: Customer_Referrals_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Customer_Referrals_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Customer_SettingArgs = {
  where: Customer_Setting_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Customer_Setting_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Customer_User_RelArgs = {
  where: Customer_User_Rel_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Customer_User_Rel_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Deprecated_Solar_Quote_RequestsArgs = {
  where: Deprecated_Solar_Quote_Requests_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Deprecated_Solar_Quote_Requests_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Direct_DebitArgs = {
  where: Direct_Debit_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Direct_Debit_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Direct_Debit_PaymentArgs = {
  where: Direct_Debit_Payment_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Direct_Debit_Payment_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Email_MessagesArgs = {
  where: Email_Messages_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Email_Messages_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Email_TemplatesArgs = {
  where: Email_Templates_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Email_Templates_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Email_Templates_ExtArgs = {
  where: Email_Templates_Ext_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Email_Templates_Ext_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Energy_Usage_Load_FactorsArgs = {
  where: Energy_Usage_Load_Factors_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Energy_Usage_Load_Factors_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_EnrolmentArgs = {
  where: Enrolment_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Enrolment_Automated_CommunicationsArgs = {
  where: Enrolment_Automated_Communications_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Enrolment_Automated_Communications_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Enrolment_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Entity_MappingsArgs = {
  where: Entity_Mappings_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Entity_Mappings_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Estimated_UsageArgs = {
  where: Estimated_Usage_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Estimated_Usage_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Ev_Smart_Tariff_WaitlistArgs = {
  where: Ev_Smart_Tariff_Waitlist_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Ev_Smart_Tariff_Waitlist_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Ev_Tariff_Eligibility_ChecksArgs = {
  where: Ev_Tariff_Eligibility_Checks_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Ev_Tariff_Eligibility_Checks_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_FeatureArgs = {
  where: Feature_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Feature_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Financials_ConfigurationArgs = {
  where: Financials_Configuration_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Financials_Configuration_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Financials_Qrtz_Blob_TriggersArgs = {
  where: Financials_Qrtz_Blob_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Financials_Qrtz_Blob_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Financials_Qrtz_CalendarsArgs = {
  where: Financials_Qrtz_Calendars_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Financials_Qrtz_Calendars_By_PkArgs = {
  calendar_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Financials_Qrtz_Cron_TriggersArgs = {
  where: Financials_Qrtz_Cron_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Financials_Qrtz_Cron_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Financials_Qrtz_Fired_TriggersArgs = {
  where: Financials_Qrtz_Fired_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Financials_Qrtz_Fired_Triggers_By_PkArgs = {
  entry_id: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Financials_Qrtz_Job_DetailsArgs = {
  where: Financials_Qrtz_Job_Details_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Financials_Qrtz_Job_Details_By_PkArgs = {
  job_group: Scalars["String"]["input"]
  job_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Financials_Qrtz_Scheduler_StateArgs = {
  where: Financials_Qrtz_Scheduler_State_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Financials_Qrtz_Scheduler_State_By_PkArgs = {
  instance_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Financials_Qrtz_Simple_TriggersArgs = {
  where: Financials_Qrtz_Simple_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Financials_Qrtz_Simple_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Financials_Qrtz_Simprop_TriggersArgs = {
  where: Financials_Qrtz_Simprop_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Financials_Qrtz_Simprop_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Financials_Qrtz_TriggersArgs = {
  where: Financials_Qrtz_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Financials_Qrtz_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Financials_Warrant_Account_CriteriaArgs = {
  where: Financials_Warrant_Account_Criteria_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Financials_Warrant_Account_Criteria_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

/** mutation root */
export type Mutation_RootDelete_Financials_Warrant_Account_Sync_CriteriaArgs = {
  where: Financials_Warrant_Account_Sync_Criteria_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Financials_Warrant_Account_Sync_Criteria_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

/** mutation root */
export type Mutation_RootDelete_Financials_Warrant_Communications_Sent_CountArgs =
  {
    where: Financials_Warrant_Communications_Sent_Count_Bool_Exp
  }

/** mutation root */
export type Mutation_RootDelete_Financials_Warrant_Communications_Sent_Count_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

/** mutation root */
export type Mutation_RootDelete_Financials_Warrants_AccountsArgs = {
  where: Financials_Warrants_Accounts_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Financials_Warrants_Accounts_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Financials_Warrants_Accounts_HistoryArgs = {
  where: Financials_Warrants_Accounts_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Financials_Warrants_Accounts_History_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

/** mutation root */
export type Mutation_RootDelete_Financials_Warrants_Accounts_WhitelistArgs = {
  where: Financials_Warrants_Accounts_Whitelist_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Financials_Warrants_Accounts_Whitelist_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

/** mutation root */
export type Mutation_RootDelete_Financials_Warrants_Communication_GroupArgs = {
  where: Financials_Warrants_Communication_Group_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Financials_Warrants_Communication_Group_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

/** mutation root */
export type Mutation_RootDelete_Financials_Warrants_CommunicationsArgs = {
  where: Financials_Warrants_Communications_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Financials_Warrants_Communications_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Financials_Warrants_Dca_QueueArgs = {
  where: Financials_Warrants_Dca_Queue_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Financials_Warrants_Dca_Queue_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Financials_Warrants_Dca_TicketsArgs = {
  where: Financials_Warrants_Dca_Tickets_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Financials_Warrants_Dca_Tickets_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Financials_Warrants_Files_AccountArgs = {
  where: Financials_Warrants_Files_Account_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Financials_Warrants_Files_Account_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Financials_Warrants_Files_JobArgs = {
  where: Financials_Warrants_Files_Job_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Financials_Warrants_Files_Job_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Financials_Warrants_Files_ProcessedArgs = {
  where: Financials_Warrants_Files_Processed_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Financials_Warrants_Files_Processed_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

/** mutation root */
export type Mutation_RootDelete_Financials_Warrants_JobArgs = {
  where: Financials_Warrants_Job_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Financials_Warrants_Job_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Flex_Market_SubscriptionArgs = {
  where: Flex_Market_Subscription_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Flex_Market_Subscription_BillingArgs = {
  where: Flex_Market_Subscription_Billing_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Flex_Market_Subscription_Billing_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Flex_Market_Subscription_Billing_ComponentArgs =
  {
    where: Flex_Market_Subscription_Billing_Component_Bool_Exp
  }

/** mutation root */
export type Mutation_RootDelete_Flex_Market_Subscription_Billing_Component_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

/** mutation root */
export type Mutation_RootDelete_Flex_Market_Subscription_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Flyway_Schema_HistoryArgs = {
  where: Flyway_Schema_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Flyway_Schema_History_By_PkArgs = {
  installed_rank: Scalars["Int"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Freshdesk_ContactArgs = {
  where: Freshdesk_Contact_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Freshdesk_TicketArgs = {
  where: Freshdesk_Ticket_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Install_CodesArgs = {
  where: Install_Codes_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Install_Codes_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Junifer__AccountArgs = {
  where: Junifer__Account_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Junifer__AccountTransactionArgs = {
  where: Junifer__AccountTransaction_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Junifer__AccountTransaction_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Junifer__Account_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Junifer__CustomerArgs = {
  where: Junifer__Customer_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Junifer__Customer_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_MeterArgs = {
  where: Meter_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Meter_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Meter_Meter_Point_RelArgs = {
  where: Meter_Meter_Point_Rel_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Meter_Meter_Point_Rel_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Meter_PointArgs = {
  where: Meter_Point_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Meter_Point_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Meter_Point_ElectricityArgs = {
  where: Meter_Point_Electricity_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Meter_Point_Electricity_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Meter_Point_GasArgs = {
  where: Meter_Point_Gas_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Meter_Point_Gas_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Meter_Point_HistoryArgs = {
  where: Meter_Point_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Meter_Point_History_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Meter_ReadingArgs = {
  where: Meter_Reading_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Meter_Reading_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Meter_Reading_Submission_RequestArgs = {
  where: Meter_Reading_Submission_Request_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Meter_Reading_Submission_Request_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Meter_Reading_Submission_TokensArgs = {
  where: Meter_Reading_Submission_Tokens_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Meter_Reading_Submission_Tokens_By_PkArgs = {
  hashed_token: Scalars["String"]["input"]
  junifer_account_id: Scalars["Int"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_NoteArgs = {
  where: Note_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Note_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Nova_SubmissionsArgs = {
  where: Nova_Submissions_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Outbound_Photo_RequestArgs = {
  where: Outbound_Photo_Request_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Outbound_Photo_Request_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Password_Reset_TokensArgs = {
  where: Password_Reset_Tokens_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Password_Reset_Tokens_By_PkArgs = {
  token: Scalars["bytea"]["input"]
  user_id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_PaymentArgs = {
  where: Payment_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Payment_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Payment_MethodArgs = {
  where: Payment_Method_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Payment_Method_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Payment_Review_Account_Balance_Reserve_RatesArgs =
  {
    where: Payment_Review_Account_Balance_Reserve_Rates_Bool_Exp
  }

/** mutation root */
export type Mutation_RootDelete_Payment_Review_Account_Balance_Reserve_Rates_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

/** mutation root */
export type Mutation_RootDelete_Payment_Review_Account_ExclusionsArgs = {
  where: Payment_Review_Account_Exclusions_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Payment_Review_Account_Exclusions_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Payment_Review_CalculationArgs = {
  where: Payment_Review_Calculation_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Payment_Review_Calculation_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Payment_Review_Future_Product_RatesArgs = {
  where: Payment_Review_Future_Product_Rates_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Payment_Review_Future_Product_Rates_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

/** mutation root */
export type Mutation_RootDelete_Payment_Review_Record_EmailsArgs = {
  where: Payment_Review_Record_Emails_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Payment_Review_Record_Emails_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Payment_Review_Record_NotesArgs = {
  where: Payment_Review_Record_Notes_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Payment_Review_Record_Notes_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Payment_Review_RecordsArgs = {
  where: Payment_Review_Records_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Payment_Review_Records_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Payment_ReviewsArgs = {
  where: Payment_Reviews_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Payment_Reviews_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Payment_ScheduleArgs = {
  where: Payment_Schedule_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Payment_Schedule_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Postcode_Gsp_CacheArgs = {
  where: Postcode_Gsp_Cache_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Postcode_Gsp_Cache_By_PkArgs = {
  postcode: Scalars["String"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_ProductArgs = {
  where: Product_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Product_AccountArgs = {
  where: Product_Account_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Product_Account_Agreement_RelArgs = {
  where: Product_Account_Agreement_Rel_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Product_Account_Agreement_Rel_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Product_Account_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Product_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Product_ElecArgs = {
  where: Product_Elec_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Product_Elec_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Product_GasArgs = {
  where: Product_Gas_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Product_Gas_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Product_VariantArgs = {
  where: Product_Variant_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Product_Variant_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Product_Variant_ElecArgs = {
  where: Product_Variant_Elec_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Product_Variant_Elec_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Product_Variant_GasArgs = {
  where: Product_Variant_Gas_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Product_Variant_Gas_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_PropertyArgs = {
  where: Property_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Property_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_PsrArgs = {
  where: Psr_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Psr_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_QuoteArgs = {
  where: Quote_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Quote_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Quote_RequestArgs = {
  where: Quote_Request_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Quote_Request_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_RecipientsArgs = {
  where: Recipients_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Recipients_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Refresh_TokensArgs = {
  where: Refresh_Tokens_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_RefundsArgs = {
  where: Refunds_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Refunds_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_RegisterArgs = {
  where: Register_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Register_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Registration_Credit_CheckArgs = {
  where: Registration_Credit_Check_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Registration_Credit_Check_AddressArgs = {
  where: Registration_Credit_Check_Address_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Registration_Credit_Check_Address_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Registration_Credit_Check_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_ReminderArgs = {
  where: Reminder_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Reminder_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_RenewalArgs = {
  where: Renewal_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Renewal_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Report_ProblemArgs = {
  where: Report_Problem_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Report_Problem_AttachmentsArgs = {
  where: Report_Problem_Attachments_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Report_Problem_Attachments_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Report_Problem_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_RequestsArgs = {
  where: Requests_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Requests_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Rts_Meters_ReportArgs = {
  where: Rts_Meters_Report_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Scheduled_PaymentArgs = {
  where: Scheduled_Payment_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Scheduled_Payment_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Scheduled_RefundArgs = {
  where: Scheduled_Refund_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Scheduled_Refund_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Smart_ChargingArgs = {
  where: Smart_Charging_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Smart_Charging_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Smart_Meter_Dashboard_Response_V7Args = {
  where: Smart_Meter_Dashboard_Response_V7_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Smart_Meters_Eligible_For_ExchangeArgs = {
  where: Smart_Meters_Eligible_For_Exchange_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Smart_Meters_Eligible_For_Exchange_By_PkArgs = {
  meter_serial_number: Scalars["String"]["input"]
  mpxn: Scalars["String"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Sync_StatusArgs = {
  where: Sync_Status_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Sync_Status_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Synchronized_AccountsArgs = {
  where: Synchronized_Accounts_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Synchronized_Accounts_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_TicketArgs = {
  where: Ticket_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Ticket_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Automation_Account_StoreArgs = {
  where: Tickets_Automation_Account_Store_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Automation_Account_Store_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Automation_ConfigArgs = {
  where: Tickets_Automation_Config_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Automation_Config_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Automation_Config_DefaultArgs = {
  where: Tickets_Automation_Config_Default_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Automation_Config_Default_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Automation_Config_PurgeArgs = {
  where: Tickets_Automation_Config_Purge_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Automation_Config_Purge_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Automation_Default_Ticket_ActionArgs = {
  where: Tickets_Automation_Default_Ticket_Action_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Automation_Default_Ticket_Action_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

/** mutation root */
export type Mutation_RootDelete_Tickets_Automation_Defaults_Acceptable_Accounts_TableArgs =
  {
    where: Tickets_Automation_Defaults_Acceptable_Accounts_Table_Bool_Exp
  }

/** mutation root */
export type Mutation_RootDelete_Tickets_Automation_Defaults_Acceptable_Accounts_Table_By_PkArgs =
  {
    accountid: Scalars["bigint"]["input"]
  }

/** mutation root */
export type Mutation_RootDelete_Tickets_Automation_Defaults_Opened_PredefaultsArgs =
  {
    where: Tickets_Automation_Defaults_Opened_Predefaults_Bool_Exp
  }

/** mutation root */
export type Mutation_RootDelete_Tickets_Automation_Defaults_Opened_Predefaults_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

/** mutation root */
export type Mutation_RootDelete_Tickets_Automation_JobArgs = {
  where: Tickets_Automation_Job_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Automation_Job_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Automation_Purge_JobArgs = {
  where: Tickets_Automation_Purge_Job_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Automation_Purge_Job_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Automation_Ticket_StoreArgs = {
  where: Tickets_Automation_Ticket_Store_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Automation_Ticket_Store_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Dca_Account_AllocationArgs = {
  where: Tickets_Dca_Account_Allocation_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Dca_Account_Allocation_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Dca_Allocation_ConfigurationArgs = {
  where: Tickets_Dca_Allocation_Configuration_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Dca_Allocation_Configuration_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

/** mutation root */
export type Mutation_RootDelete_Tickets_Dca_Configuration_V2Args = {
  where: Tickets_Dca_Configuration_V2_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Dca_Configuration_V2_By_PkArgs = {
  dca: Scalars["String"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Dca_SegmentationArgs = {
  where: Tickets_Dca_Segmentation_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Dca_Segmentation_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Account_StoreArgs = {
  where: Tickets_Dunning_Account_Store_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Account_Store_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Addacs_Review_RecordsArgs = {
  where: Tickets_Dunning_Addacs_Review_Records_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Addacs_Review_Records_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Automation_EventsArgs = {
  where: Tickets_Dunning_Automation_Events_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Automation_Events_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Debt_Ticket_Review_RecordsArgs =
  {
    where: Tickets_Dunning_Debt_Ticket_Review_Records_Bool_Exp
  }

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Debt_Ticket_Review_Records_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_JobArgs = {
  where: Tickets_Dunning_Job_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Job_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Legal_Known_Ticket_RecordsArgs =
  {
    where: Tickets_Dunning_Legal_Known_Ticket_Records_Bool_Exp
  }

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Legal_Known_Ticket_Records_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Legal_Occupier_Ticket_RecordsArgs =
  {
    where: Tickets_Dunning_Legal_Occupier_Ticket_Records_Bool_Exp
  }

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Legal_Occupier_Ticket_Records_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Occupier_Accounts_Review_RecordsArgs =
  {
    where: Tickets_Dunning_Occupier_Accounts_Review_Records_Bool_Exp
  }

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Occupier_Accounts_Review_Records_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Purge_JobArgs = {
  where: Tickets_Dunning_Purge_Job_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Purge_Job_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Standard_Ticket_RecordsArgs = {
  where: Tickets_Dunning_Standard_Ticket_Records_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Standard_Ticket_Records_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_StatisticsArgs = {
  where: Tickets_Dunning_Statistics_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Statistics_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Terminating_Accounts_Review_RecordsArgs =
  {
    where: Tickets_Dunning_Terminating_Accounts_Review_Records_Bool_Exp
  }

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Terminating_Accounts_Review_Records_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Ticket_StoreArgs = {
  where: Tickets_Dunning_Ticket_Store_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Ticket_Store_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_WorkflowArgs = {
  where: Tickets_Dunning_Workflow_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Dunning_Workflow_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_External_EventArgs = {
  where: Tickets_External_Event_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_External_Event_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_External_TicketsArgs = {
  where: Tickets_External_Tickets_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_External_Tickets_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Qrtz_Blob_TriggersArgs = {
  where: Tickets_Qrtz_Blob_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Qrtz_Blob_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Qrtz_CalendarsArgs = {
  where: Tickets_Qrtz_Calendars_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Qrtz_Calendars_By_PkArgs = {
  calendar_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Qrtz_Cron_TriggersArgs = {
  where: Tickets_Qrtz_Cron_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Qrtz_Cron_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Qrtz_Fired_TriggersArgs = {
  where: Tickets_Qrtz_Fired_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Qrtz_Fired_Triggers_By_PkArgs = {
  entry_id: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Qrtz_Job_DetailsArgs = {
  where: Tickets_Qrtz_Job_Details_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Qrtz_Job_Details_By_PkArgs = {
  job_group: Scalars["String"]["input"]
  job_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Qrtz_LocksArgs = {
  where: Tickets_Qrtz_Locks_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Qrtz_Locks_By_PkArgs = {
  lock_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Qrtz_Paused_Trigger_GrpsArgs = {
  where: Tickets_Qrtz_Paused_Trigger_Grps_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Qrtz_Paused_Trigger_Grps_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Qrtz_Scheduler_StateArgs = {
  where: Tickets_Qrtz_Scheduler_State_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Qrtz_Scheduler_State_By_PkArgs = {
  instance_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Qrtz_Simple_TriggersArgs = {
  where: Tickets_Qrtz_Simple_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Qrtz_Simple_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Qrtz_Simprop_TriggersArgs = {
  where: Tickets_Qrtz_Simprop_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Qrtz_Simprop_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Qrtz_TriggersArgs = {
  where: Tickets_Qrtz_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Tickets_Qrtz_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Trustpilot_InvitationsArgs = {
  where: Trustpilot_Invitations_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Uswitch_RecordArgs = {
  where: Uswitch_Record_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Uswitch_Record_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Warm_Home_Discount_ApplicationArgs = {
  where: Warm_Home_Discount_Application_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Warm_Home_Discount_Application_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Warm_Home_Discount_Application_Status_HistoryArgs =
  {
    where: Warm_Home_Discount_Application_Status_History_Bool_Exp
  }

/** mutation root */
export type Mutation_RootDelete_Warm_Home_Discount_Application_Status_History_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

/** mutation root */
export type Mutation_RootDelete_Warm_Home_Discount_CriteriaArgs = {
  where: Warm_Home_Discount_Criteria_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Warm_Home_Discount_Criteria_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootDelete_Warm_Home_Discount_Criteria_RelArgs = {
  where: Warm_Home_Discount_Criteria_Rel_Bool_Exp
}

/** mutation root */
export type Mutation_RootDelete_Warm_Home_Discount_Criteria_Rel_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** mutation root */
export type Mutation_RootGetApplicationsArgs = {
  whdApplicationsRequest: WhdApplicationsRequest
}

/** mutation root */
export type Mutation_RootInsert_ElecNominationsArgs = {
  if_matched?: InputMaybe<ElecNominations_If_Matched>
  objects: Array<ElecNominations_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_ElecNominations_OneArgs = {
  if_matched?: InputMaybe<ElecNominations_If_Matched>
  object: ElecNominations_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_ElecTradesArgs = {
  if_matched?: InputMaybe<ElecTrades_If_Matched>
  objects: Array<ElecTrades_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_ElecTradesHistoryArgs = {
  if_matched?: InputMaybe<ElecTradesHistory_If_Matched>
  objects: Array<ElecTradesHistory_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_ElecTradesHistory_OneArgs = {
  if_matched?: InputMaybe<ElecTradesHistory_If_Matched>
  object: ElecTradesHistory_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_ElecTrades_OneArgs = {
  if_matched?: InputMaybe<ElecTrades_If_Matched>
  object: ElecTrades_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_GasTradesArgs = {
  if_matched?: InputMaybe<GasTrades_If_Matched>
  objects: Array<GasTrades_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_GasTradesHistoryArgs = {
  if_matched?: InputMaybe<GasTradesHistory_If_Matched>
  objects: Array<GasTradesHistory_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_GasTradesHistory_OneArgs = {
  if_matched?: InputMaybe<GasTradesHistory_If_Matched>
  object: GasTradesHistory_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_GasTrades_OneArgs = {
  if_matched?: InputMaybe<GasTrades_If_Matched>
  object: GasTrades_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_Account_CreditArgs = {
  objects: Array<Account_Credit_Insert_Input>
  on_conflict?: InputMaybe<Account_Credit_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Account_Credit_OneArgs = {
  object: Account_Credit_Insert_Input
  on_conflict?: InputMaybe<Account_Credit_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Active_Outbound_Photo_RequestArgs = {
  objects: Array<Active_Outbound_Photo_Request_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_Active_Outbound_Photo_Request_OneArgs = {
  object: Active_Outbound_Photo_Request_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_AddressArgs = {
  objects: Array<Address_Insert_Input>
  on_conflict?: InputMaybe<Address_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Address_OneArgs = {
  object: Address_Insert_Input
  on_conflict?: InputMaybe<Address_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Admin_PassesArgs = {
  objects: Array<Admin_Passes_Insert_Input>
  on_conflict?: InputMaybe<Admin_Passes_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Admin_Passes_OneArgs = {
  object: Admin_Passes_Insert_Input
  on_conflict?: InputMaybe<Admin_Passes_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Admin_RolesArgs = {
  objects: Array<Admin_Roles_Insert_Input>
  on_conflict?: InputMaybe<Admin_Roles_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Admin_Roles_OneArgs = {
  object: Admin_Roles_Insert_Input
  on_conflict?: InputMaybe<Admin_Roles_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_AgreementArgs = {
  objects: Array<Agreement_Insert_Input>
  on_conflict?: InputMaybe<Agreement_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Agreement_OneArgs = {
  object: Agreement_Insert_Input
  on_conflict?: InputMaybe<Agreement_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_AssetArgs = {
  objects: Array<Asset_Insert_Input>
  on_conflict?: InputMaybe<Asset_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Asset_OneArgs = {
  object: Asset_Insert_Input
  on_conflict?: InputMaybe<Asset_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_AttachmentArgs = {
  objects: Array<Attachment_Insert_Input>
  on_conflict?: InputMaybe<Attachment_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Attachment_OneArgs = {
  object: Attachment_Insert_Input
  on_conflict?: InputMaybe<Attachment_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Axle_Trial_EligibilityArgs = {
  objects: Array<Axle_Trial_Eligibility_Insert_Input>
  on_conflict?: InputMaybe<Axle_Trial_Eligibility_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Axle_Trial_Eligibility_OneArgs = {
  object: Axle_Trial_Eligibility_Insert_Input
  on_conflict?: InputMaybe<Axle_Trial_Eligibility_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_BillArgs = {
  objects: Array<Bill_Insert_Input>
  on_conflict?: InputMaybe<Bill_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Bill_OneArgs = {
  object: Bill_Insert_Input
  on_conflict?: InputMaybe<Bill_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Billing_AccountArgs = {
  objects: Array<Billing_Account_Insert_Input>
  on_conflict?: InputMaybe<Billing_Account_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Billing_Account_ContactArgs = {
  objects: Array<Billing_Account_Contact_Insert_Input>
  on_conflict?: InputMaybe<Billing_Account_Contact_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Billing_Account_Contact_OneArgs = {
  object: Billing_Account_Contact_Insert_Input
  on_conflict?: InputMaybe<Billing_Account_Contact_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Billing_Account_OneArgs = {
  object: Billing_Account_Insert_Input
  on_conflict?: InputMaybe<Billing_Account_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Billing_Account_SettingArgs = {
  objects: Array<Billing_Account_Setting_Insert_Input>
  on_conflict?: InputMaybe<Billing_Account_Setting_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Billing_Account_Setting_OneArgs = {
  object: Billing_Account_Setting_Insert_Input
  on_conflict?: InputMaybe<Billing_Account_Setting_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Billing_Account_TransactionArgs = {
  objects: Array<Billing_Account_Transaction_Insert_Input>
  on_conflict?: InputMaybe<Billing_Account_Transaction_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Billing_Account_Transaction_OneArgs = {
  object: Billing_Account_Transaction_Insert_Input
  on_conflict?: InputMaybe<Billing_Account_Transaction_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Billing_PeriodArgs = {
  objects: Array<Billing_Period_Insert_Input>
  on_conflict?: InputMaybe<Billing_Period_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Billing_Period_OneArgs = {
  object: Billing_Period_Insert_Input
  on_conflict?: InputMaybe<Billing_Period_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Calculation_ItemsArgs = {
  objects: Array<Calculation_Items_Insert_Input>
  on_conflict?: InputMaybe<Calculation_Items_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Calculation_Items_OneArgs = {
  object: Calculation_Items_Insert_Input
  on_conflict?: InputMaybe<Calculation_Items_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Call_Trace_AuditArgs = {
  objects: Array<Call_Trace_Audit_Insert_Input>
  on_conflict?: InputMaybe<Call_Trace_Audit_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Call_Trace_Audit_OneArgs = {
  object: Call_Trace_Audit_Insert_Input
  on_conflict?: InputMaybe<Call_Trace_Audit_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Cancellation_ReasonsArgs = {
  objects: Array<Cancellation_Reasons_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_Cancellation_Reasons_OneArgs = {
  object: Cancellation_Reasons_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_CancellationsArgs = {
  objects: Array<Cancellations_Insert_Input>
  on_conflict?: InputMaybe<Cancellations_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Cancellations_OneArgs = {
  object: Cancellations_Insert_Input
  on_conflict?: InputMaybe<Cancellations_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Card_PaymentArgs = {
  objects: Array<Card_Payment_Insert_Input>
  on_conflict?: InputMaybe<Card_Payment_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Card_Payment_OldArgs = {
  objects: Array<Card_Payment_Old_Insert_Input>
  on_conflict?: InputMaybe<Card_Payment_Old_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Card_Payment_Old_OneArgs = {
  object: Card_Payment_Old_Insert_Input
  on_conflict?: InputMaybe<Card_Payment_Old_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Card_Payment_OneArgs = {
  object: Card_Payment_Insert_Input
  on_conflict?: InputMaybe<Card_Payment_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_CasesArgs = {
  objects: Array<Cases_Insert_Input>
  on_conflict?: InputMaybe<Cases_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Cases_OneArgs = {
  object: Cases_Insert_Input
  on_conflict?: InputMaybe<Cases_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_CommunicationArgs = {
  objects: Array<Communication_Insert_Input>
  on_conflict?: InputMaybe<Communication_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Communication_MetadataArgs = {
  objects: Array<Communication_Metadata_Insert_Input>
  on_conflict?: InputMaybe<Communication_Metadata_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Communication_Metadata_OneArgs = {
  object: Communication_Metadata_Insert_Input
  on_conflict?: InputMaybe<Communication_Metadata_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Communication_OneArgs = {
  object: Communication_Insert_Input
  on_conflict?: InputMaybe<Communication_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_CommunicationsArgs = {
  objects: Array<Communications_Insert_Input>
  on_conflict?: InputMaybe<Communications_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Communications_OneArgs = {
  object: Communications_Insert_Input
  on_conflict?: InputMaybe<Communications_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_ComplaintArgs = {
  objects: Array<Complaint_Insert_Input>
  on_conflict?: InputMaybe<Complaint_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Complaint_OneArgs = {
  object: Complaint_Insert_Input
  on_conflict?: InputMaybe<Complaint_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Completed_Sync_Event_AccountArgs = {
  objects: Array<Completed_Sync_Event_Account_Insert_Input>
  on_conflict?: InputMaybe<Completed_Sync_Event_Account_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Completed_Sync_Event_Account_OneArgs = {
  object: Completed_Sync_Event_Account_Insert_Input
  on_conflict?: InputMaybe<Completed_Sync_Event_Account_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_ConfigurationArgs = {
  objects: Array<Configuration_Insert_Input>
  on_conflict?: InputMaybe<Configuration_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Configuration_OneArgs = {
  object: Configuration_Insert_Input
  on_conflict?: InputMaybe<Configuration_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_ContactArgs = {
  objects: Array<Contact_Insert_Input>
  on_conflict?: InputMaybe<Contact_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Contact_OneArgs = {
  object: Contact_Insert_Input
  on_conflict?: InputMaybe<Contact_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Cs__Soe_Dashboard_TotalArgs = {
  objects: Array<Cs__Soe_Dashboard_Total_Insert_Input>
  on_conflict?: InputMaybe<Cs__Soe_Dashboard_Total_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Cs__Soe_Dashboard_Total_OneArgs = {
  object: Cs__Soe_Dashboard_Total_Insert_Input
  on_conflict?: InputMaybe<Cs__Soe_Dashboard_Total_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_CustomerArgs = {
  objects: Array<Customer_Insert_Input>
  on_conflict?: InputMaybe<Customer_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Customer_AddressArgs = {
  objects: Array<Customer_Address_Insert_Input>
  on_conflict?: InputMaybe<Customer_Address_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Customer_Address_OneArgs = {
  object: Customer_Address_Insert_Input
  on_conflict?: InputMaybe<Customer_Address_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Customer_ContactArgs = {
  objects: Array<Customer_Contact_Insert_Input>
  on_conflict?: InputMaybe<Customer_Contact_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Customer_Contact_OneArgs = {
  object: Customer_Contact_Insert_Input
  on_conflict?: InputMaybe<Customer_Contact_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Customer_MetadataArgs = {
  objects: Array<Customer_Metadata_Insert_Input>
  on_conflict?: InputMaybe<Customer_Metadata_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Customer_Metadata_OneArgs = {
  object: Customer_Metadata_Insert_Input
  on_conflict?: InputMaybe<Customer_Metadata_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Customer_OneArgs = {
  object: Customer_Insert_Input
  on_conflict?: InputMaybe<Customer_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Customer_Property_RelArgs = {
  objects: Array<Customer_Property_Rel_Insert_Input>
  on_conflict?: InputMaybe<Customer_Property_Rel_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Customer_Property_Rel_OneArgs = {
  object: Customer_Property_Rel_Insert_Input
  on_conflict?: InputMaybe<Customer_Property_Rel_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Customer_Psr_RelArgs = {
  objects: Array<Customer_Psr_Rel_Insert_Input>
  on_conflict?: InputMaybe<Customer_Psr_Rel_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Customer_Psr_Rel_OneArgs = {
  object: Customer_Psr_Rel_Insert_Input
  on_conflict?: InputMaybe<Customer_Psr_Rel_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Customer_ReferralsArgs = {
  objects: Array<Customer_Referrals_Insert_Input>
  on_conflict?: InputMaybe<Customer_Referrals_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Customer_Referrals_OneArgs = {
  object: Customer_Referrals_Insert_Input
  on_conflict?: InputMaybe<Customer_Referrals_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Customer_SettingArgs = {
  objects: Array<Customer_Setting_Insert_Input>
  on_conflict?: InputMaybe<Customer_Setting_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Customer_Setting_OneArgs = {
  object: Customer_Setting_Insert_Input
  on_conflict?: InputMaybe<Customer_Setting_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Customer_User_RelArgs = {
  objects: Array<Customer_User_Rel_Insert_Input>
  on_conflict?: InputMaybe<Customer_User_Rel_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Customer_User_Rel_OneArgs = {
  object: Customer_User_Rel_Insert_Input
  on_conflict?: InputMaybe<Customer_User_Rel_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Deprecated_Solar_Quote_RequestsArgs = {
  objects: Array<Deprecated_Solar_Quote_Requests_Insert_Input>
  on_conflict?: InputMaybe<Deprecated_Solar_Quote_Requests_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Deprecated_Solar_Quote_Requests_OneArgs = {
  object: Deprecated_Solar_Quote_Requests_Insert_Input
  on_conflict?: InputMaybe<Deprecated_Solar_Quote_Requests_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Direct_DebitArgs = {
  objects: Array<Direct_Debit_Insert_Input>
  on_conflict?: InputMaybe<Direct_Debit_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Direct_Debit_OneArgs = {
  object: Direct_Debit_Insert_Input
  on_conflict?: InputMaybe<Direct_Debit_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Direct_Debit_PaymentArgs = {
  objects: Array<Direct_Debit_Payment_Insert_Input>
  on_conflict?: InputMaybe<Direct_Debit_Payment_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Direct_Debit_Payment_OneArgs = {
  object: Direct_Debit_Payment_Insert_Input
  on_conflict?: InputMaybe<Direct_Debit_Payment_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Email_MessagesArgs = {
  objects: Array<Email_Messages_Insert_Input>
  on_conflict?: InputMaybe<Email_Messages_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Email_Messages_OneArgs = {
  object: Email_Messages_Insert_Input
  on_conflict?: InputMaybe<Email_Messages_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Email_TemplatesArgs = {
  objects: Array<Email_Templates_Insert_Input>
  on_conflict?: InputMaybe<Email_Templates_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Email_Templates_ExtArgs = {
  objects: Array<Email_Templates_Ext_Insert_Input>
  on_conflict?: InputMaybe<Email_Templates_Ext_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Email_Templates_Ext_OneArgs = {
  object: Email_Templates_Ext_Insert_Input
  on_conflict?: InputMaybe<Email_Templates_Ext_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Email_Templates_OneArgs = {
  object: Email_Templates_Insert_Input
  on_conflict?: InputMaybe<Email_Templates_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Energy_Usage_Load_FactorsArgs = {
  objects: Array<Energy_Usage_Load_Factors_Insert_Input>
  on_conflict?: InputMaybe<Energy_Usage_Load_Factors_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Energy_Usage_Load_Factors_OneArgs = {
  object: Energy_Usage_Load_Factors_Insert_Input
  on_conflict?: InputMaybe<Energy_Usage_Load_Factors_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_EnrolmentArgs = {
  objects: Array<Enrolment_Insert_Input>
  on_conflict?: InputMaybe<Enrolment_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Enrolment_Automated_CommunicationsArgs = {
  objects: Array<Enrolment_Automated_Communications_Insert_Input>
  on_conflict?: InputMaybe<Enrolment_Automated_Communications_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Enrolment_Automated_Communications_OneArgs = {
  object: Enrolment_Automated_Communications_Insert_Input
  on_conflict?: InputMaybe<Enrolment_Automated_Communications_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Enrolment_OneArgs = {
  object: Enrolment_Insert_Input
  on_conflict?: InputMaybe<Enrolment_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Entity_MappingsArgs = {
  objects: Array<Entity_Mappings_Insert_Input>
  on_conflict?: InputMaybe<Entity_Mappings_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Entity_Mappings_OneArgs = {
  object: Entity_Mappings_Insert_Input
  on_conflict?: InputMaybe<Entity_Mappings_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Estimated_UsageArgs = {
  objects: Array<Estimated_Usage_Insert_Input>
  on_conflict?: InputMaybe<Estimated_Usage_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Estimated_Usage_OneArgs = {
  object: Estimated_Usage_Insert_Input
  on_conflict?: InputMaybe<Estimated_Usage_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Ev_Smart_Tariff_WaitlistArgs = {
  objects: Array<Ev_Smart_Tariff_Waitlist_Insert_Input>
  on_conflict?: InputMaybe<Ev_Smart_Tariff_Waitlist_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Ev_Smart_Tariff_Waitlist_OneArgs = {
  object: Ev_Smart_Tariff_Waitlist_Insert_Input
  on_conflict?: InputMaybe<Ev_Smart_Tariff_Waitlist_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Ev_Tariff_Eligibility_ChecksArgs = {
  objects: Array<Ev_Tariff_Eligibility_Checks_Insert_Input>
  on_conflict?: InputMaybe<Ev_Tariff_Eligibility_Checks_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Ev_Tariff_Eligibility_Checks_OneArgs = {
  object: Ev_Tariff_Eligibility_Checks_Insert_Input
  on_conflict?: InputMaybe<Ev_Tariff_Eligibility_Checks_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_FeatureArgs = {
  objects: Array<Feature_Insert_Input>
  on_conflict?: InputMaybe<Feature_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Feature_OneArgs = {
  object: Feature_Insert_Input
  on_conflict?: InputMaybe<Feature_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_ConfigurationArgs = {
  objects: Array<Financials_Configuration_Insert_Input>
  on_conflict?: InputMaybe<Financials_Configuration_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Configuration_OneArgs = {
  object: Financials_Configuration_Insert_Input
  on_conflict?: InputMaybe<Financials_Configuration_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Qrtz_Blob_TriggersArgs = {
  objects: Array<Financials_Qrtz_Blob_Triggers_Insert_Input>
  on_conflict?: InputMaybe<Financials_Qrtz_Blob_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Qrtz_Blob_Triggers_OneArgs = {
  object: Financials_Qrtz_Blob_Triggers_Insert_Input
  on_conflict?: InputMaybe<Financials_Qrtz_Blob_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Qrtz_CalendarsArgs = {
  objects: Array<Financials_Qrtz_Calendars_Insert_Input>
  on_conflict?: InputMaybe<Financials_Qrtz_Calendars_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Qrtz_Calendars_OneArgs = {
  object: Financials_Qrtz_Calendars_Insert_Input
  on_conflict?: InputMaybe<Financials_Qrtz_Calendars_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Qrtz_Cron_TriggersArgs = {
  objects: Array<Financials_Qrtz_Cron_Triggers_Insert_Input>
  on_conflict?: InputMaybe<Financials_Qrtz_Cron_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Qrtz_Cron_Triggers_OneArgs = {
  object: Financials_Qrtz_Cron_Triggers_Insert_Input
  on_conflict?: InputMaybe<Financials_Qrtz_Cron_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Qrtz_Fired_TriggersArgs = {
  objects: Array<Financials_Qrtz_Fired_Triggers_Insert_Input>
  on_conflict?: InputMaybe<Financials_Qrtz_Fired_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Qrtz_Fired_Triggers_OneArgs = {
  object: Financials_Qrtz_Fired_Triggers_Insert_Input
  on_conflict?: InputMaybe<Financials_Qrtz_Fired_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Qrtz_Job_DetailsArgs = {
  objects: Array<Financials_Qrtz_Job_Details_Insert_Input>
  on_conflict?: InputMaybe<Financials_Qrtz_Job_Details_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Qrtz_Job_Details_OneArgs = {
  object: Financials_Qrtz_Job_Details_Insert_Input
  on_conflict?: InputMaybe<Financials_Qrtz_Job_Details_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Qrtz_Scheduler_StateArgs = {
  objects: Array<Financials_Qrtz_Scheduler_State_Insert_Input>
  on_conflict?: InputMaybe<Financials_Qrtz_Scheduler_State_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Qrtz_Scheduler_State_OneArgs = {
  object: Financials_Qrtz_Scheduler_State_Insert_Input
  on_conflict?: InputMaybe<Financials_Qrtz_Scheduler_State_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Qrtz_Simple_TriggersArgs = {
  objects: Array<Financials_Qrtz_Simple_Triggers_Insert_Input>
  on_conflict?: InputMaybe<Financials_Qrtz_Simple_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Qrtz_Simple_Triggers_OneArgs = {
  object: Financials_Qrtz_Simple_Triggers_Insert_Input
  on_conflict?: InputMaybe<Financials_Qrtz_Simple_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Qrtz_Simprop_TriggersArgs = {
  objects: Array<Financials_Qrtz_Simprop_Triggers_Insert_Input>
  on_conflict?: InputMaybe<Financials_Qrtz_Simprop_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Qrtz_Simprop_Triggers_OneArgs = {
  object: Financials_Qrtz_Simprop_Triggers_Insert_Input
  on_conflict?: InputMaybe<Financials_Qrtz_Simprop_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Qrtz_TriggersArgs = {
  objects: Array<Financials_Qrtz_Triggers_Insert_Input>
  on_conflict?: InputMaybe<Financials_Qrtz_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Qrtz_Triggers_OneArgs = {
  object: Financials_Qrtz_Triggers_Insert_Input
  on_conflict?: InputMaybe<Financials_Qrtz_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Warrant_Account_CriteriaArgs = {
  objects: Array<Financials_Warrant_Account_Criteria_Insert_Input>
  on_conflict?: InputMaybe<Financials_Warrant_Account_Criteria_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Warrant_Account_Criteria_OneArgs = {
  object: Financials_Warrant_Account_Criteria_Insert_Input
  on_conflict?: InputMaybe<Financials_Warrant_Account_Criteria_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Warrant_Account_Sync_CriteriaArgs = {
  objects: Array<Financials_Warrant_Account_Sync_Criteria_Insert_Input>
  on_conflict?: InputMaybe<Financials_Warrant_Account_Sync_Criteria_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Warrant_Account_Sync_Criteria_OneArgs =
  {
    object: Financials_Warrant_Account_Sync_Criteria_Insert_Input
    on_conflict?: InputMaybe<Financials_Warrant_Account_Sync_Criteria_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Financials_Warrant_Communications_Sent_CountArgs =
  {
    objects: Array<Financials_Warrant_Communications_Sent_Count_Insert_Input>
    on_conflict?: InputMaybe<Financials_Warrant_Communications_Sent_Count_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Financials_Warrant_Communications_Sent_Count_OneArgs =
  {
    object: Financials_Warrant_Communications_Sent_Count_Insert_Input
    on_conflict?: InputMaybe<Financials_Warrant_Communications_Sent_Count_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Financials_Warrants_AccountsArgs = {
  objects: Array<Financials_Warrants_Accounts_Insert_Input>
  on_conflict?: InputMaybe<Financials_Warrants_Accounts_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Warrants_Accounts_HistoryArgs = {
  objects: Array<Financials_Warrants_Accounts_History_Insert_Input>
  on_conflict?: InputMaybe<Financials_Warrants_Accounts_History_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Warrants_Accounts_History_OneArgs = {
  object: Financials_Warrants_Accounts_History_Insert_Input
  on_conflict?: InputMaybe<Financials_Warrants_Accounts_History_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Warrants_Accounts_OneArgs = {
  object: Financials_Warrants_Accounts_Insert_Input
  on_conflict?: InputMaybe<Financials_Warrants_Accounts_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Warrants_Accounts_WhitelistArgs = {
  objects: Array<Financials_Warrants_Accounts_Whitelist_Insert_Input>
  on_conflict?: InputMaybe<Financials_Warrants_Accounts_Whitelist_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Warrants_Accounts_Whitelist_OneArgs =
  {
    object: Financials_Warrants_Accounts_Whitelist_Insert_Input
    on_conflict?: InputMaybe<Financials_Warrants_Accounts_Whitelist_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Financials_Warrants_Communication_GroupArgs = {
  objects: Array<Financials_Warrants_Communication_Group_Insert_Input>
  on_conflict?: InputMaybe<Financials_Warrants_Communication_Group_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Warrants_Communication_Group_OneArgs =
  {
    object: Financials_Warrants_Communication_Group_Insert_Input
    on_conflict?: InputMaybe<Financials_Warrants_Communication_Group_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Financials_Warrants_CommunicationsArgs = {
  objects: Array<Financials_Warrants_Communications_Insert_Input>
  on_conflict?: InputMaybe<Financials_Warrants_Communications_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Warrants_Communications_OneArgs = {
  object: Financials_Warrants_Communications_Insert_Input
  on_conflict?: InputMaybe<Financials_Warrants_Communications_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Warrants_Dca_QueueArgs = {
  objects: Array<Financials_Warrants_Dca_Queue_Insert_Input>
  on_conflict?: InputMaybe<Financials_Warrants_Dca_Queue_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Warrants_Dca_Queue_OneArgs = {
  object: Financials_Warrants_Dca_Queue_Insert_Input
  on_conflict?: InputMaybe<Financials_Warrants_Dca_Queue_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Warrants_Dca_TicketsArgs = {
  objects: Array<Financials_Warrants_Dca_Tickets_Insert_Input>
  on_conflict?: InputMaybe<Financials_Warrants_Dca_Tickets_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Warrants_Dca_Tickets_OneArgs = {
  object: Financials_Warrants_Dca_Tickets_Insert_Input
  on_conflict?: InputMaybe<Financials_Warrants_Dca_Tickets_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Warrants_Files_AccountArgs = {
  objects: Array<Financials_Warrants_Files_Account_Insert_Input>
  on_conflict?: InputMaybe<Financials_Warrants_Files_Account_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Warrants_Files_Account_OneArgs = {
  object: Financials_Warrants_Files_Account_Insert_Input
  on_conflict?: InputMaybe<Financials_Warrants_Files_Account_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Warrants_Files_JobArgs = {
  objects: Array<Financials_Warrants_Files_Job_Insert_Input>
  on_conflict?: InputMaybe<Financials_Warrants_Files_Job_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Warrants_Files_Job_OneArgs = {
  object: Financials_Warrants_Files_Job_Insert_Input
  on_conflict?: InputMaybe<Financials_Warrants_Files_Job_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Warrants_Files_ProcessedArgs = {
  objects: Array<Financials_Warrants_Files_Processed_Insert_Input>
  on_conflict?: InputMaybe<Financials_Warrants_Files_Processed_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Warrants_Files_Processed_OneArgs = {
  object: Financials_Warrants_Files_Processed_Insert_Input
  on_conflict?: InputMaybe<Financials_Warrants_Files_Processed_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Warrants_JobArgs = {
  objects: Array<Financials_Warrants_Job_Insert_Input>
  on_conflict?: InputMaybe<Financials_Warrants_Job_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Financials_Warrants_Job_OneArgs = {
  object: Financials_Warrants_Job_Insert_Input
  on_conflict?: InputMaybe<Financials_Warrants_Job_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Flex_Market_SubscriptionArgs = {
  objects: Array<Flex_Market_Subscription_Insert_Input>
  on_conflict?: InputMaybe<Flex_Market_Subscription_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Flex_Market_Subscription_BillingArgs = {
  objects: Array<Flex_Market_Subscription_Billing_Insert_Input>
  on_conflict?: InputMaybe<Flex_Market_Subscription_Billing_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Flex_Market_Subscription_Billing_ComponentArgs =
  {
    objects: Array<Flex_Market_Subscription_Billing_Component_Insert_Input>
    on_conflict?: InputMaybe<Flex_Market_Subscription_Billing_Component_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Flex_Market_Subscription_Billing_Component_OneArgs =
  {
    object: Flex_Market_Subscription_Billing_Component_Insert_Input
    on_conflict?: InputMaybe<Flex_Market_Subscription_Billing_Component_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Flex_Market_Subscription_Billing_OneArgs = {
  object: Flex_Market_Subscription_Billing_Insert_Input
  on_conflict?: InputMaybe<Flex_Market_Subscription_Billing_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Flex_Market_Subscription_OneArgs = {
  object: Flex_Market_Subscription_Insert_Input
  on_conflict?: InputMaybe<Flex_Market_Subscription_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Flyway_Schema_HistoryArgs = {
  objects: Array<Flyway_Schema_History_Insert_Input>
  on_conflict?: InputMaybe<Flyway_Schema_History_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Flyway_Schema_History_OneArgs = {
  object: Flyway_Schema_History_Insert_Input
  on_conflict?: InputMaybe<Flyway_Schema_History_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Freshdesk_ContactArgs = {
  objects: Array<Freshdesk_Contact_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_Freshdesk_Contact_OneArgs = {
  object: Freshdesk_Contact_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_Freshdesk_TicketArgs = {
  objects: Array<Freshdesk_Ticket_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_Freshdesk_Ticket_OneArgs = {
  object: Freshdesk_Ticket_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_Install_CodesArgs = {
  objects: Array<Install_Codes_Insert_Input>
  on_conflict?: InputMaybe<Install_Codes_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Install_Codes_OneArgs = {
  object: Install_Codes_Insert_Input
  on_conflict?: InputMaybe<Install_Codes_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Junifer__AccountArgs = {
  objects: Array<Junifer__Account_Insert_Input>
  on_conflict?: InputMaybe<Junifer__Account_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Junifer__AccountTransactionArgs = {
  objects: Array<Junifer__AccountTransaction_Insert_Input>
  on_conflict?: InputMaybe<Junifer__AccountTransaction_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Junifer__AccountTransaction_OneArgs = {
  object: Junifer__AccountTransaction_Insert_Input
  on_conflict?: InputMaybe<Junifer__AccountTransaction_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Junifer__Account_OneArgs = {
  object: Junifer__Account_Insert_Input
  on_conflict?: InputMaybe<Junifer__Account_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Junifer__CustomerArgs = {
  objects: Array<Junifer__Customer_Insert_Input>
  on_conflict?: InputMaybe<Junifer__Customer_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Junifer__Customer_OneArgs = {
  object: Junifer__Customer_Insert_Input
  on_conflict?: InputMaybe<Junifer__Customer_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_MeterArgs = {
  objects: Array<Meter_Insert_Input>
  on_conflict?: InputMaybe<Meter_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Meter_Meter_Point_RelArgs = {
  objects: Array<Meter_Meter_Point_Rel_Insert_Input>
  on_conflict?: InputMaybe<Meter_Meter_Point_Rel_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Meter_Meter_Point_Rel_OneArgs = {
  object: Meter_Meter_Point_Rel_Insert_Input
  on_conflict?: InputMaybe<Meter_Meter_Point_Rel_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Meter_OneArgs = {
  object: Meter_Insert_Input
  on_conflict?: InputMaybe<Meter_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Meter_PointArgs = {
  objects: Array<Meter_Point_Insert_Input>
  on_conflict?: InputMaybe<Meter_Point_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Meter_Point_ElectricityArgs = {
  objects: Array<Meter_Point_Electricity_Insert_Input>
  on_conflict?: InputMaybe<Meter_Point_Electricity_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Meter_Point_Electricity_OneArgs = {
  object: Meter_Point_Electricity_Insert_Input
  on_conflict?: InputMaybe<Meter_Point_Electricity_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Meter_Point_GasArgs = {
  objects: Array<Meter_Point_Gas_Insert_Input>
  on_conflict?: InputMaybe<Meter_Point_Gas_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Meter_Point_Gas_OneArgs = {
  object: Meter_Point_Gas_Insert_Input
  on_conflict?: InputMaybe<Meter_Point_Gas_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Meter_Point_HistoryArgs = {
  objects: Array<Meter_Point_History_Insert_Input>
  on_conflict?: InputMaybe<Meter_Point_History_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Meter_Point_History_OneArgs = {
  object: Meter_Point_History_Insert_Input
  on_conflict?: InputMaybe<Meter_Point_History_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Meter_Point_OneArgs = {
  object: Meter_Point_Insert_Input
  on_conflict?: InputMaybe<Meter_Point_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Meter_ReadingArgs = {
  objects: Array<Meter_Reading_Insert_Input>
  on_conflict?: InputMaybe<Meter_Reading_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Meter_Reading_OneArgs = {
  object: Meter_Reading_Insert_Input
  on_conflict?: InputMaybe<Meter_Reading_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Meter_Reading_Submission_RequestArgs = {
  objects: Array<Meter_Reading_Submission_Request_Insert_Input>
  on_conflict?: InputMaybe<Meter_Reading_Submission_Request_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Meter_Reading_Submission_Request_OneArgs = {
  object: Meter_Reading_Submission_Request_Insert_Input
  on_conflict?: InputMaybe<Meter_Reading_Submission_Request_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Meter_Reading_Submission_TokensArgs = {
  objects: Array<Meter_Reading_Submission_Tokens_Insert_Input>
  on_conflict?: InputMaybe<Meter_Reading_Submission_Tokens_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Meter_Reading_Submission_Tokens_OneArgs = {
  object: Meter_Reading_Submission_Tokens_Insert_Input
  on_conflict?: InputMaybe<Meter_Reading_Submission_Tokens_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_NoteArgs = {
  objects: Array<Note_Insert_Input>
  on_conflict?: InputMaybe<Note_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Note_OneArgs = {
  object: Note_Insert_Input
  on_conflict?: InputMaybe<Note_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Nova_SubmissionsArgs = {
  objects: Array<Nova_Submissions_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_Nova_Submissions_OneArgs = {
  object: Nova_Submissions_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_Outbound_Photo_RequestArgs = {
  objects: Array<Outbound_Photo_Request_Insert_Input>
  on_conflict?: InputMaybe<Outbound_Photo_Request_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Outbound_Photo_Request_OneArgs = {
  object: Outbound_Photo_Request_Insert_Input
  on_conflict?: InputMaybe<Outbound_Photo_Request_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Password_Reset_TokensArgs = {
  objects: Array<Password_Reset_Tokens_Insert_Input>
  on_conflict?: InputMaybe<Password_Reset_Tokens_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Password_Reset_Tokens_OneArgs = {
  object: Password_Reset_Tokens_Insert_Input
  on_conflict?: InputMaybe<Password_Reset_Tokens_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_PaymentArgs = {
  objects: Array<Payment_Insert_Input>
  on_conflict?: InputMaybe<Payment_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Payment_MethodArgs = {
  objects: Array<Payment_Method_Insert_Input>
  on_conflict?: InputMaybe<Payment_Method_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Payment_Method_OneArgs = {
  object: Payment_Method_Insert_Input
  on_conflict?: InputMaybe<Payment_Method_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Payment_OneArgs = {
  object: Payment_Insert_Input
  on_conflict?: InputMaybe<Payment_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Payment_Review_Account_Balance_Reserve_RatesArgs =
  {
    objects: Array<Payment_Review_Account_Balance_Reserve_Rates_Insert_Input>
    on_conflict?: InputMaybe<Payment_Review_Account_Balance_Reserve_Rates_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Payment_Review_Account_Balance_Reserve_Rates_OneArgs =
  {
    object: Payment_Review_Account_Balance_Reserve_Rates_Insert_Input
    on_conflict?: InputMaybe<Payment_Review_Account_Balance_Reserve_Rates_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Payment_Review_Account_ExclusionsArgs = {
  objects: Array<Payment_Review_Account_Exclusions_Insert_Input>
  on_conflict?: InputMaybe<Payment_Review_Account_Exclusions_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Payment_Review_Account_Exclusions_OneArgs = {
  object: Payment_Review_Account_Exclusions_Insert_Input
  on_conflict?: InputMaybe<Payment_Review_Account_Exclusions_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Payment_Review_CalculationArgs = {
  objects: Array<Payment_Review_Calculation_Insert_Input>
  on_conflict?: InputMaybe<Payment_Review_Calculation_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Payment_Review_Calculation_OneArgs = {
  object: Payment_Review_Calculation_Insert_Input
  on_conflict?: InputMaybe<Payment_Review_Calculation_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Payment_Review_Future_Product_RatesArgs = {
  objects: Array<Payment_Review_Future_Product_Rates_Insert_Input>
  on_conflict?: InputMaybe<Payment_Review_Future_Product_Rates_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Payment_Review_Future_Product_Rates_OneArgs = {
  object: Payment_Review_Future_Product_Rates_Insert_Input
  on_conflict?: InputMaybe<Payment_Review_Future_Product_Rates_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Payment_Review_Record_EmailsArgs = {
  objects: Array<Payment_Review_Record_Emails_Insert_Input>
  on_conflict?: InputMaybe<Payment_Review_Record_Emails_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Payment_Review_Record_Emails_OneArgs = {
  object: Payment_Review_Record_Emails_Insert_Input
  on_conflict?: InputMaybe<Payment_Review_Record_Emails_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Payment_Review_Record_NotesArgs = {
  objects: Array<Payment_Review_Record_Notes_Insert_Input>
  on_conflict?: InputMaybe<Payment_Review_Record_Notes_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Payment_Review_Record_Notes_OneArgs = {
  object: Payment_Review_Record_Notes_Insert_Input
  on_conflict?: InputMaybe<Payment_Review_Record_Notes_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Payment_Review_RecordsArgs = {
  objects: Array<Payment_Review_Records_Insert_Input>
  on_conflict?: InputMaybe<Payment_Review_Records_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Payment_Review_Records_OneArgs = {
  object: Payment_Review_Records_Insert_Input
  on_conflict?: InputMaybe<Payment_Review_Records_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Payment_ReviewsArgs = {
  objects: Array<Payment_Reviews_Insert_Input>
  on_conflict?: InputMaybe<Payment_Reviews_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Payment_Reviews_OneArgs = {
  object: Payment_Reviews_Insert_Input
  on_conflict?: InputMaybe<Payment_Reviews_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Payment_ScheduleArgs = {
  objects: Array<Payment_Schedule_Insert_Input>
  on_conflict?: InputMaybe<Payment_Schedule_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Payment_Schedule_OneArgs = {
  object: Payment_Schedule_Insert_Input
  on_conflict?: InputMaybe<Payment_Schedule_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Postcode_Gsp_CacheArgs = {
  objects: Array<Postcode_Gsp_Cache_Insert_Input>
  on_conflict?: InputMaybe<Postcode_Gsp_Cache_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Postcode_Gsp_Cache_OneArgs = {
  object: Postcode_Gsp_Cache_Insert_Input
  on_conflict?: InputMaybe<Postcode_Gsp_Cache_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_ProductArgs = {
  objects: Array<Product_Insert_Input>
  on_conflict?: InputMaybe<Product_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Product_AccountArgs = {
  objects: Array<Product_Account_Insert_Input>
  on_conflict?: InputMaybe<Product_Account_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Product_Account_Agreement_RelArgs = {
  objects: Array<Product_Account_Agreement_Rel_Insert_Input>
  on_conflict?: InputMaybe<Product_Account_Agreement_Rel_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Product_Account_Agreement_Rel_OneArgs = {
  object: Product_Account_Agreement_Rel_Insert_Input
  on_conflict?: InputMaybe<Product_Account_Agreement_Rel_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Product_Account_OneArgs = {
  object: Product_Account_Insert_Input
  on_conflict?: InputMaybe<Product_Account_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Product_ElecArgs = {
  objects: Array<Product_Elec_Insert_Input>
  on_conflict?: InputMaybe<Product_Elec_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Product_Elec_OneArgs = {
  object: Product_Elec_Insert_Input
  on_conflict?: InputMaybe<Product_Elec_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Product_GasArgs = {
  objects: Array<Product_Gas_Insert_Input>
  on_conflict?: InputMaybe<Product_Gas_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Product_Gas_OneArgs = {
  object: Product_Gas_Insert_Input
  on_conflict?: InputMaybe<Product_Gas_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Product_OneArgs = {
  object: Product_Insert_Input
  on_conflict?: InputMaybe<Product_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Product_VariantArgs = {
  objects: Array<Product_Variant_Insert_Input>
  on_conflict?: InputMaybe<Product_Variant_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Product_Variant_ElecArgs = {
  objects: Array<Product_Variant_Elec_Insert_Input>
  on_conflict?: InputMaybe<Product_Variant_Elec_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Product_Variant_Elec_OneArgs = {
  object: Product_Variant_Elec_Insert_Input
  on_conflict?: InputMaybe<Product_Variant_Elec_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Product_Variant_GasArgs = {
  objects: Array<Product_Variant_Gas_Insert_Input>
  on_conflict?: InputMaybe<Product_Variant_Gas_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Product_Variant_Gas_OneArgs = {
  object: Product_Variant_Gas_Insert_Input
  on_conflict?: InputMaybe<Product_Variant_Gas_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Product_Variant_OneArgs = {
  object: Product_Variant_Insert_Input
  on_conflict?: InputMaybe<Product_Variant_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_PropertyArgs = {
  objects: Array<Property_Insert_Input>
  on_conflict?: InputMaybe<Property_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Property_OneArgs = {
  object: Property_Insert_Input
  on_conflict?: InputMaybe<Property_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_PsrArgs = {
  objects: Array<Psr_Insert_Input>
  on_conflict?: InputMaybe<Psr_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Psr_OneArgs = {
  object: Psr_Insert_Input
  on_conflict?: InputMaybe<Psr_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_QuoteArgs = {
  objects: Array<Quote_Insert_Input>
  on_conflict?: InputMaybe<Quote_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Quote_OneArgs = {
  object: Quote_Insert_Input
  on_conflict?: InputMaybe<Quote_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Quote_RequestArgs = {
  objects: Array<Quote_Request_Insert_Input>
  on_conflict?: InputMaybe<Quote_Request_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Quote_Request_OneArgs = {
  object: Quote_Request_Insert_Input
  on_conflict?: InputMaybe<Quote_Request_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_RecipientsArgs = {
  objects: Array<Recipients_Insert_Input>
  on_conflict?: InputMaybe<Recipients_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Recipients_OneArgs = {
  object: Recipients_Insert_Input
  on_conflict?: InputMaybe<Recipients_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Refresh_TokensArgs = {
  objects: Array<Refresh_Tokens_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_Refresh_Tokens_OneArgs = {
  object: Refresh_Tokens_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_RefundsArgs = {
  objects: Array<Refunds_Insert_Input>
  on_conflict?: InputMaybe<Refunds_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Refunds_OneArgs = {
  object: Refunds_Insert_Input
  on_conflict?: InputMaybe<Refunds_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_RegisterArgs = {
  objects: Array<Register_Insert_Input>
  on_conflict?: InputMaybe<Register_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Register_OneArgs = {
  object: Register_Insert_Input
  on_conflict?: InputMaybe<Register_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Registration_Credit_CheckArgs = {
  objects: Array<Registration_Credit_Check_Insert_Input>
  on_conflict?: InputMaybe<Registration_Credit_Check_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Registration_Credit_Check_AddressArgs = {
  objects: Array<Registration_Credit_Check_Address_Insert_Input>
  on_conflict?: InputMaybe<Registration_Credit_Check_Address_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Registration_Credit_Check_Address_OneArgs = {
  object: Registration_Credit_Check_Address_Insert_Input
  on_conflict?: InputMaybe<Registration_Credit_Check_Address_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Registration_Credit_Check_OneArgs = {
  object: Registration_Credit_Check_Insert_Input
  on_conflict?: InputMaybe<Registration_Credit_Check_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_ReminderArgs = {
  objects: Array<Reminder_Insert_Input>
  on_conflict?: InputMaybe<Reminder_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Reminder_OneArgs = {
  object: Reminder_Insert_Input
  on_conflict?: InputMaybe<Reminder_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_RenewalArgs = {
  objects: Array<Renewal_Insert_Input>
  on_conflict?: InputMaybe<Renewal_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Renewal_OneArgs = {
  object: Renewal_Insert_Input
  on_conflict?: InputMaybe<Renewal_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Report_ProblemArgs = {
  objects: Array<Report_Problem_Insert_Input>
  on_conflict?: InputMaybe<Report_Problem_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Report_Problem_AttachmentsArgs = {
  objects: Array<Report_Problem_Attachments_Insert_Input>
  on_conflict?: InputMaybe<Report_Problem_Attachments_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Report_Problem_Attachments_OneArgs = {
  object: Report_Problem_Attachments_Insert_Input
  on_conflict?: InputMaybe<Report_Problem_Attachments_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Report_Problem_OneArgs = {
  object: Report_Problem_Insert_Input
  on_conflict?: InputMaybe<Report_Problem_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_RequestsArgs = {
  objects: Array<Requests_Insert_Input>
  on_conflict?: InputMaybe<Requests_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Requests_OneArgs = {
  object: Requests_Insert_Input
  on_conflict?: InputMaybe<Requests_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Rts_Meters_ReportArgs = {
  objects: Array<Rts_Meters_Report_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_Rts_Meters_Report_OneArgs = {
  object: Rts_Meters_Report_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_Scheduled_PaymentArgs = {
  objects: Array<Scheduled_Payment_Insert_Input>
  on_conflict?: InputMaybe<Scheduled_Payment_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Scheduled_Payment_OneArgs = {
  object: Scheduled_Payment_Insert_Input
  on_conflict?: InputMaybe<Scheduled_Payment_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Scheduled_RefundArgs = {
  objects: Array<Scheduled_Refund_Insert_Input>
  on_conflict?: InputMaybe<Scheduled_Refund_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Scheduled_Refund_OneArgs = {
  object: Scheduled_Refund_Insert_Input
  on_conflict?: InputMaybe<Scheduled_Refund_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Smart_ChargingArgs = {
  objects: Array<Smart_Charging_Insert_Input>
  on_conflict?: InputMaybe<Smart_Charging_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Smart_Charging_OneArgs = {
  object: Smart_Charging_Insert_Input
  on_conflict?: InputMaybe<Smart_Charging_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Smart_Meter_Dashboard_Response_V7Args = {
  objects: Array<Smart_Meter_Dashboard_Response_V7_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_Smart_Meter_Dashboard_Response_V7_OneArgs = {
  object: Smart_Meter_Dashboard_Response_V7_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_Smart_Meters_Eligible_For_ExchangeArgs = {
  objects: Array<Smart_Meters_Eligible_For_Exchange_Insert_Input>
  on_conflict?: InputMaybe<Smart_Meters_Eligible_For_Exchange_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Smart_Meters_Eligible_For_Exchange_OneArgs = {
  object: Smart_Meters_Eligible_For_Exchange_Insert_Input
  on_conflict?: InputMaybe<Smart_Meters_Eligible_For_Exchange_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Sync_StatusArgs = {
  objects: Array<Sync_Status_Insert_Input>
  on_conflict?: InputMaybe<Sync_Status_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Sync_Status_OneArgs = {
  object: Sync_Status_Insert_Input
  on_conflict?: InputMaybe<Sync_Status_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Synchronized_AccountsArgs = {
  objects: Array<Synchronized_Accounts_Insert_Input>
  on_conflict?: InputMaybe<Synchronized_Accounts_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Synchronized_Accounts_OneArgs = {
  object: Synchronized_Accounts_Insert_Input
  on_conflict?: InputMaybe<Synchronized_Accounts_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_TicketArgs = {
  objects: Array<Ticket_Insert_Input>
  on_conflict?: InputMaybe<Ticket_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Ticket_OneArgs = {
  object: Ticket_Insert_Input
  on_conflict?: InputMaybe<Ticket_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Automation_Account_StoreArgs = {
  objects: Array<Tickets_Automation_Account_Store_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Automation_Account_Store_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Automation_Account_Store_OneArgs = {
  object: Tickets_Automation_Account_Store_Insert_Input
  on_conflict?: InputMaybe<Tickets_Automation_Account_Store_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Automation_ConfigArgs = {
  objects: Array<Tickets_Automation_Config_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Automation_Config_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Automation_Config_DefaultArgs = {
  objects: Array<Tickets_Automation_Config_Default_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Automation_Config_Default_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Automation_Config_Default_OneArgs = {
  object: Tickets_Automation_Config_Default_Insert_Input
  on_conflict?: InputMaybe<Tickets_Automation_Config_Default_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Automation_Config_OneArgs = {
  object: Tickets_Automation_Config_Insert_Input
  on_conflict?: InputMaybe<Tickets_Automation_Config_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Automation_Config_PurgeArgs = {
  objects: Array<Tickets_Automation_Config_Purge_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Automation_Config_Purge_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Automation_Config_Purge_OneArgs = {
  object: Tickets_Automation_Config_Purge_Insert_Input
  on_conflict?: InputMaybe<Tickets_Automation_Config_Purge_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Automation_Default_Ticket_ActionArgs = {
  objects: Array<Tickets_Automation_Default_Ticket_Action_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Automation_Default_Ticket_Action_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Automation_Default_Ticket_Action_OneArgs =
  {
    object: Tickets_Automation_Default_Ticket_Action_Insert_Input
    on_conflict?: InputMaybe<Tickets_Automation_Default_Ticket_Action_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Tickets_Automation_Defaults_Acceptable_Accounts_TableArgs =
  {
    objects: Array<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Insert_Input>
    on_conflict?: InputMaybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Tickets_Automation_Defaults_Acceptable_Accounts_Table_OneArgs =
  {
    object: Tickets_Automation_Defaults_Acceptable_Accounts_Table_Insert_Input
    on_conflict?: InputMaybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Tickets_Automation_Defaults_Opened_PredefaultsArgs =
  {
    objects: Array<Tickets_Automation_Defaults_Opened_Predefaults_Insert_Input>
    on_conflict?: InputMaybe<Tickets_Automation_Defaults_Opened_Predefaults_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Tickets_Automation_Defaults_Opened_Predefaults_OneArgs =
  {
    object: Tickets_Automation_Defaults_Opened_Predefaults_Insert_Input
    on_conflict?: InputMaybe<Tickets_Automation_Defaults_Opened_Predefaults_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Tickets_Automation_JobArgs = {
  objects: Array<Tickets_Automation_Job_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Automation_Job_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Automation_Job_OneArgs = {
  object: Tickets_Automation_Job_Insert_Input
  on_conflict?: InputMaybe<Tickets_Automation_Job_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Automation_Purge_JobArgs = {
  objects: Array<Tickets_Automation_Purge_Job_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Automation_Purge_Job_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Automation_Purge_Job_OneArgs = {
  object: Tickets_Automation_Purge_Job_Insert_Input
  on_conflict?: InputMaybe<Tickets_Automation_Purge_Job_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Automation_Ticket_StoreArgs = {
  objects: Array<Tickets_Automation_Ticket_Store_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Automation_Ticket_Store_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Automation_Ticket_Store_OneArgs = {
  object: Tickets_Automation_Ticket_Store_Insert_Input
  on_conflict?: InputMaybe<Tickets_Automation_Ticket_Store_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dca_Account_AllocationArgs = {
  objects: Array<Tickets_Dca_Account_Allocation_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Dca_Account_Allocation_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dca_Account_Allocation_OneArgs = {
  object: Tickets_Dca_Account_Allocation_Insert_Input
  on_conflict?: InputMaybe<Tickets_Dca_Account_Allocation_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dca_Allocation_ConfigurationArgs = {
  objects: Array<Tickets_Dca_Allocation_Configuration_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Dca_Allocation_Configuration_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dca_Allocation_Configuration_OneArgs = {
  object: Tickets_Dca_Allocation_Configuration_Insert_Input
  on_conflict?: InputMaybe<Tickets_Dca_Allocation_Configuration_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dca_Configuration_V2Args = {
  objects: Array<Tickets_Dca_Configuration_V2_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Dca_Configuration_V2_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dca_Configuration_V2_OneArgs = {
  object: Tickets_Dca_Configuration_V2_Insert_Input
  on_conflict?: InputMaybe<Tickets_Dca_Configuration_V2_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dca_SegmentationArgs = {
  objects: Array<Tickets_Dca_Segmentation_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Dca_Segmentation_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dca_Segmentation_OneArgs = {
  object: Tickets_Dca_Segmentation_Insert_Input
  on_conflict?: InputMaybe<Tickets_Dca_Segmentation_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Account_StoreArgs = {
  objects: Array<Tickets_Dunning_Account_Store_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Dunning_Account_Store_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Account_Store_OneArgs = {
  object: Tickets_Dunning_Account_Store_Insert_Input
  on_conflict?: InputMaybe<Tickets_Dunning_Account_Store_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Addacs_Review_RecordsArgs = {
  objects: Array<Tickets_Dunning_Addacs_Review_Records_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Dunning_Addacs_Review_Records_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Addacs_Review_Records_OneArgs =
  {
    object: Tickets_Dunning_Addacs_Review_Records_Insert_Input
    on_conflict?: InputMaybe<Tickets_Dunning_Addacs_Review_Records_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Automation_EventsArgs = {
  objects: Array<Tickets_Dunning_Automation_Events_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Dunning_Automation_Events_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Automation_Events_OneArgs = {
  object: Tickets_Dunning_Automation_Events_Insert_Input
  on_conflict?: InputMaybe<Tickets_Dunning_Automation_Events_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Debt_Ticket_Review_RecordsArgs =
  {
    objects: Array<Tickets_Dunning_Debt_Ticket_Review_Records_Insert_Input>
    on_conflict?: InputMaybe<Tickets_Dunning_Debt_Ticket_Review_Records_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Debt_Ticket_Review_Records_OneArgs =
  {
    object: Tickets_Dunning_Debt_Ticket_Review_Records_Insert_Input
    on_conflict?: InputMaybe<Tickets_Dunning_Debt_Ticket_Review_Records_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_JobArgs = {
  objects: Array<Tickets_Dunning_Job_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Dunning_Job_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Job_OneArgs = {
  object: Tickets_Dunning_Job_Insert_Input
  on_conflict?: InputMaybe<Tickets_Dunning_Job_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Legal_Known_Ticket_RecordsArgs =
  {
    objects: Array<Tickets_Dunning_Legal_Known_Ticket_Records_Insert_Input>
    on_conflict?: InputMaybe<Tickets_Dunning_Legal_Known_Ticket_Records_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Legal_Known_Ticket_Records_OneArgs =
  {
    object: Tickets_Dunning_Legal_Known_Ticket_Records_Insert_Input
    on_conflict?: InputMaybe<Tickets_Dunning_Legal_Known_Ticket_Records_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Legal_Occupier_Ticket_RecordsArgs =
  {
    objects: Array<Tickets_Dunning_Legal_Occupier_Ticket_Records_Insert_Input>
    on_conflict?: InputMaybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Legal_Occupier_Ticket_Records_OneArgs =
  {
    object: Tickets_Dunning_Legal_Occupier_Ticket_Records_Insert_Input
    on_conflict?: InputMaybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Occupier_Accounts_Review_RecordsArgs =
  {
    objects: Array<Tickets_Dunning_Occupier_Accounts_Review_Records_Insert_Input>
    on_conflict?: InputMaybe<Tickets_Dunning_Occupier_Accounts_Review_Records_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Occupier_Accounts_Review_Records_OneArgs =
  {
    object: Tickets_Dunning_Occupier_Accounts_Review_Records_Insert_Input
    on_conflict?: InputMaybe<Tickets_Dunning_Occupier_Accounts_Review_Records_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Purge_JobArgs = {
  objects: Array<Tickets_Dunning_Purge_Job_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Dunning_Purge_Job_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Purge_Job_OneArgs = {
  object: Tickets_Dunning_Purge_Job_Insert_Input
  on_conflict?: InputMaybe<Tickets_Dunning_Purge_Job_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Standard_Ticket_RecordsArgs = {
  objects: Array<Tickets_Dunning_Standard_Ticket_Records_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Dunning_Standard_Ticket_Records_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Standard_Ticket_Records_OneArgs =
  {
    object: Tickets_Dunning_Standard_Ticket_Records_Insert_Input
    on_conflict?: InputMaybe<Tickets_Dunning_Standard_Ticket_Records_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_StatisticsArgs = {
  objects: Array<Tickets_Dunning_Statistics_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Dunning_Statistics_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Statistics_OneArgs = {
  object: Tickets_Dunning_Statistics_Insert_Input
  on_conflict?: InputMaybe<Tickets_Dunning_Statistics_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Terminating_Accounts_Review_RecordsArgs =
  {
    objects: Array<Tickets_Dunning_Terminating_Accounts_Review_Records_Insert_Input>
    on_conflict?: InputMaybe<Tickets_Dunning_Terminating_Accounts_Review_Records_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Terminating_Accounts_Review_Records_OneArgs =
  {
    object: Tickets_Dunning_Terminating_Accounts_Review_Records_Insert_Input
    on_conflict?: InputMaybe<Tickets_Dunning_Terminating_Accounts_Review_Records_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Ticket_StoreArgs = {
  objects: Array<Tickets_Dunning_Ticket_Store_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Dunning_Ticket_Store_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Ticket_Store_OneArgs = {
  object: Tickets_Dunning_Ticket_Store_Insert_Input
  on_conflict?: InputMaybe<Tickets_Dunning_Ticket_Store_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_WorkflowArgs = {
  objects: Array<Tickets_Dunning_Workflow_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Dunning_Workflow_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Dunning_Workflow_OneArgs = {
  object: Tickets_Dunning_Workflow_Insert_Input
  on_conflict?: InputMaybe<Tickets_Dunning_Workflow_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_External_EventArgs = {
  objects: Array<Tickets_External_Event_Insert_Input>
  on_conflict?: InputMaybe<Tickets_External_Event_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_External_Event_OneArgs = {
  object: Tickets_External_Event_Insert_Input
  on_conflict?: InputMaybe<Tickets_External_Event_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_External_TicketsArgs = {
  objects: Array<Tickets_External_Tickets_Insert_Input>
  on_conflict?: InputMaybe<Tickets_External_Tickets_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_External_Tickets_OneArgs = {
  object: Tickets_External_Tickets_Insert_Input
  on_conflict?: InputMaybe<Tickets_External_Tickets_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Qrtz_Blob_TriggersArgs = {
  objects: Array<Tickets_Qrtz_Blob_Triggers_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Qrtz_Blob_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Qrtz_Blob_Triggers_OneArgs = {
  object: Tickets_Qrtz_Blob_Triggers_Insert_Input
  on_conflict?: InputMaybe<Tickets_Qrtz_Blob_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Qrtz_CalendarsArgs = {
  objects: Array<Tickets_Qrtz_Calendars_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Qrtz_Calendars_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Qrtz_Calendars_OneArgs = {
  object: Tickets_Qrtz_Calendars_Insert_Input
  on_conflict?: InputMaybe<Tickets_Qrtz_Calendars_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Qrtz_Cron_TriggersArgs = {
  objects: Array<Tickets_Qrtz_Cron_Triggers_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Qrtz_Cron_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Qrtz_Cron_Triggers_OneArgs = {
  object: Tickets_Qrtz_Cron_Triggers_Insert_Input
  on_conflict?: InputMaybe<Tickets_Qrtz_Cron_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Qrtz_Fired_TriggersArgs = {
  objects: Array<Tickets_Qrtz_Fired_Triggers_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Qrtz_Fired_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Qrtz_Fired_Triggers_OneArgs = {
  object: Tickets_Qrtz_Fired_Triggers_Insert_Input
  on_conflict?: InputMaybe<Tickets_Qrtz_Fired_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Qrtz_Job_DetailsArgs = {
  objects: Array<Tickets_Qrtz_Job_Details_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Qrtz_Job_Details_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Qrtz_Job_Details_OneArgs = {
  object: Tickets_Qrtz_Job_Details_Insert_Input
  on_conflict?: InputMaybe<Tickets_Qrtz_Job_Details_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Qrtz_LocksArgs = {
  objects: Array<Tickets_Qrtz_Locks_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Qrtz_Locks_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Qrtz_Locks_OneArgs = {
  object: Tickets_Qrtz_Locks_Insert_Input
  on_conflict?: InputMaybe<Tickets_Qrtz_Locks_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Qrtz_Paused_Trigger_GrpsArgs = {
  objects: Array<Tickets_Qrtz_Paused_Trigger_Grps_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Qrtz_Paused_Trigger_Grps_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Qrtz_Paused_Trigger_Grps_OneArgs = {
  object: Tickets_Qrtz_Paused_Trigger_Grps_Insert_Input
  on_conflict?: InputMaybe<Tickets_Qrtz_Paused_Trigger_Grps_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Qrtz_Scheduler_StateArgs = {
  objects: Array<Tickets_Qrtz_Scheduler_State_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Qrtz_Scheduler_State_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Qrtz_Scheduler_State_OneArgs = {
  object: Tickets_Qrtz_Scheduler_State_Insert_Input
  on_conflict?: InputMaybe<Tickets_Qrtz_Scheduler_State_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Qrtz_Simple_TriggersArgs = {
  objects: Array<Tickets_Qrtz_Simple_Triggers_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Qrtz_Simple_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Qrtz_Simple_Triggers_OneArgs = {
  object: Tickets_Qrtz_Simple_Triggers_Insert_Input
  on_conflict?: InputMaybe<Tickets_Qrtz_Simple_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Qrtz_Simprop_TriggersArgs = {
  objects: Array<Tickets_Qrtz_Simprop_Triggers_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Qrtz_Simprop_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Qrtz_Simprop_Triggers_OneArgs = {
  object: Tickets_Qrtz_Simprop_Triggers_Insert_Input
  on_conflict?: InputMaybe<Tickets_Qrtz_Simprop_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Qrtz_TriggersArgs = {
  objects: Array<Tickets_Qrtz_Triggers_Insert_Input>
  on_conflict?: InputMaybe<Tickets_Qrtz_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Tickets_Qrtz_Triggers_OneArgs = {
  object: Tickets_Qrtz_Triggers_Insert_Input
  on_conflict?: InputMaybe<Tickets_Qrtz_Triggers_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Trustpilot_InvitationsArgs = {
  objects: Array<Trustpilot_Invitations_Insert_Input>
}

/** mutation root */
export type Mutation_RootInsert_Trustpilot_Invitations_OneArgs = {
  object: Trustpilot_Invitations_Insert_Input
}

/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>
  on_conflict?: InputMaybe<Users_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input
  on_conflict?: InputMaybe<Users_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Uswitch_RecordArgs = {
  objects: Array<Uswitch_Record_Insert_Input>
  on_conflict?: InputMaybe<Uswitch_Record_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Uswitch_Record_OneArgs = {
  object: Uswitch_Record_Insert_Input
  on_conflict?: InputMaybe<Uswitch_Record_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Warm_Home_Discount_ApplicationArgs = {
  objects: Array<Warm_Home_Discount_Application_Insert_Input>
  on_conflict?: InputMaybe<Warm_Home_Discount_Application_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Warm_Home_Discount_Application_OneArgs = {
  object: Warm_Home_Discount_Application_Insert_Input
  on_conflict?: InputMaybe<Warm_Home_Discount_Application_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Warm_Home_Discount_Application_Status_HistoryArgs =
  {
    objects: Array<Warm_Home_Discount_Application_Status_History_Insert_Input>
    on_conflict?: InputMaybe<Warm_Home_Discount_Application_Status_History_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Warm_Home_Discount_Application_Status_History_OneArgs =
  {
    object: Warm_Home_Discount_Application_Status_History_Insert_Input
    on_conflict?: InputMaybe<Warm_Home_Discount_Application_Status_History_On_Conflict>
  }

/** mutation root */
export type Mutation_RootInsert_Warm_Home_Discount_CriteriaArgs = {
  objects: Array<Warm_Home_Discount_Criteria_Insert_Input>
  on_conflict?: InputMaybe<Warm_Home_Discount_Criteria_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Warm_Home_Discount_Criteria_OneArgs = {
  object: Warm_Home_Discount_Criteria_Insert_Input
  on_conflict?: InputMaybe<Warm_Home_Discount_Criteria_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Warm_Home_Discount_Criteria_RelArgs = {
  objects: Array<Warm_Home_Discount_Criteria_Rel_Insert_Input>
  on_conflict?: InputMaybe<Warm_Home_Discount_Criteria_Rel_On_Conflict>
}

/** mutation root */
export type Mutation_RootInsert_Warm_Home_Discount_Criteria_Rel_OneArgs = {
  object: Warm_Home_Discount_Criteria_Rel_Insert_Input
  on_conflict?: InputMaybe<Warm_Home_Discount_Criteria_Rel_On_Conflict>
}

/** mutation root */
export type Mutation_RootRejectApprovedApplicationsArgs = {
  warm_home_discounts_interface: WhdInterface
}

/** mutation root */
export type Mutation_RootRetryPaymentReviewRecordsByFiltersArgs = {
  filters: Filters
  paymentReviewId: Scalars["BigInt"]["input"]
  retryConfig: RetryConfig
}

/** mutation root */
export type Mutation_RootRetryPaymentReviewRecordsByIdArgs = {
  retryConfig: RetryConfigWithIds
}

/** mutation root */
export type Mutation_RootUpdateManyApplicationsArgs = {
  updateRequest: UpdateWarmHomeDiscountApplicationsRequest
}

/** mutation root */
export type Mutation_RootUpdate_ElecNominationsArgs = {
  _inc?: InputMaybe<ElecNominations_Inc_Input>
  _set?: InputMaybe<ElecNominations_Set_Input>
  where: ElecNominations_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_ElecTradesArgs = {
  _inc?: InputMaybe<ElecTrades_Inc_Input>
  _set?: InputMaybe<ElecTrades_Set_Input>
  where: ElecTrades_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_ElecTradesHistoryArgs = {
  _inc?: InputMaybe<ElecTradesHistory_Inc_Input>
  _set?: InputMaybe<ElecTradesHistory_Set_Input>
  where: ElecTradesHistory_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_ElecTradesHistory_By_PkArgs = {
  _inc?: InputMaybe<ElecTradesHistory_Inc_Input>
  _set?: InputMaybe<ElecTradesHistory_Set_Input>
  pk_columns: ElecTradesHistory_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_ElecTrades_By_PkArgs = {
  _inc?: InputMaybe<ElecTrades_Inc_Input>
  _set?: InputMaybe<ElecTrades_Set_Input>
  pk_columns: ElecTrades_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_GasTradesArgs = {
  _inc?: InputMaybe<GasTrades_Inc_Input>
  _set?: InputMaybe<GasTrades_Set_Input>
  where: GasTrades_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_GasTradesHistoryArgs = {
  _inc?: InputMaybe<GasTradesHistory_Inc_Input>
  _set?: InputMaybe<GasTradesHistory_Set_Input>
  where: GasTradesHistory_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_GasTradesHistory_By_PkArgs = {
  _inc?: InputMaybe<GasTradesHistory_Inc_Input>
  _set?: InputMaybe<GasTradesHistory_Set_Input>
  pk_columns: GasTradesHistory_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_GasTrades_By_PkArgs = {
  _inc?: InputMaybe<GasTrades_Inc_Input>
  _set?: InputMaybe<GasTrades_Set_Input>
  pk_columns: GasTrades_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Account_CreditArgs = {
  _inc?: InputMaybe<Account_Credit_Inc_Input>
  _set?: InputMaybe<Account_Credit_Set_Input>
  where: Account_Credit_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Account_Credit_By_PkArgs = {
  _inc?: InputMaybe<Account_Credit_Inc_Input>
  _set?: InputMaybe<Account_Credit_Set_Input>
  pk_columns: Account_Credit_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Account_Credit_ManyArgs = {
  updates: Array<Account_Credit_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Active_Outbound_Photo_RequestArgs = {
  _append?: InputMaybe<Active_Outbound_Photo_Request_Append_Input>
  _delete_at_path?: InputMaybe<Active_Outbound_Photo_Request_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Active_Outbound_Photo_Request_Delete_Elem_Input>
  _delete_key?: InputMaybe<Active_Outbound_Photo_Request_Delete_Key_Input>
  _inc?: InputMaybe<Active_Outbound_Photo_Request_Inc_Input>
  _prepend?: InputMaybe<Active_Outbound_Photo_Request_Prepend_Input>
  _set?: InputMaybe<Active_Outbound_Photo_Request_Set_Input>
  where: Active_Outbound_Photo_Request_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Active_Outbound_Photo_Request_ManyArgs = {
  updates: Array<Active_Outbound_Photo_Request_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_AddressArgs = {
  _inc?: InputMaybe<Address_Inc_Input>
  _set?: InputMaybe<Address_Set_Input>
  where: Address_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Address_By_PkArgs = {
  _inc?: InputMaybe<Address_Inc_Input>
  _set?: InputMaybe<Address_Set_Input>
  pk_columns: Address_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Address_ManyArgs = {
  updates: Array<Address_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Admin_PassesArgs = {
  _inc?: InputMaybe<Admin_Passes_Inc_Input>
  _set?: InputMaybe<Admin_Passes_Set_Input>
  where: Admin_Passes_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Admin_Passes_By_PkArgs = {
  _inc?: InputMaybe<Admin_Passes_Inc_Input>
  _set?: InputMaybe<Admin_Passes_Set_Input>
  pk_columns: Admin_Passes_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Admin_Passes_ManyArgs = {
  updates: Array<Admin_Passes_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Admin_RolesArgs = {
  _inc?: InputMaybe<Admin_Roles_Inc_Input>
  _set?: InputMaybe<Admin_Roles_Set_Input>
  where: Admin_Roles_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Admin_Roles_By_PkArgs = {
  _inc?: InputMaybe<Admin_Roles_Inc_Input>
  _set?: InputMaybe<Admin_Roles_Set_Input>
  pk_columns: Admin_Roles_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Admin_Roles_ManyArgs = {
  updates: Array<Admin_Roles_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_AgreementArgs = {
  _inc?: InputMaybe<Agreement_Inc_Input>
  _set?: InputMaybe<Agreement_Set_Input>
  where: Agreement_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Agreement_By_PkArgs = {
  _inc?: InputMaybe<Agreement_Inc_Input>
  _set?: InputMaybe<Agreement_Set_Input>
  pk_columns: Agreement_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Agreement_ManyArgs = {
  updates: Array<Agreement_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_AssetArgs = {
  _inc?: InputMaybe<Asset_Inc_Input>
  _set?: InputMaybe<Asset_Set_Input>
  where: Asset_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Asset_By_PkArgs = {
  _inc?: InputMaybe<Asset_Inc_Input>
  _set?: InputMaybe<Asset_Set_Input>
  pk_columns: Asset_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Asset_ManyArgs = {
  updates: Array<Asset_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_AttachmentArgs = {
  _inc?: InputMaybe<Attachment_Inc_Input>
  _set?: InputMaybe<Attachment_Set_Input>
  where: Attachment_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Attachment_By_PkArgs = {
  _inc?: InputMaybe<Attachment_Inc_Input>
  _set?: InputMaybe<Attachment_Set_Input>
  pk_columns: Attachment_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Attachment_ManyArgs = {
  updates: Array<Attachment_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Axle_Trial_EligibilityArgs = {
  _inc?: InputMaybe<Axle_Trial_Eligibility_Inc_Input>
  _set?: InputMaybe<Axle_Trial_Eligibility_Set_Input>
  where: Axle_Trial_Eligibility_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Axle_Trial_Eligibility_By_PkArgs = {
  _inc?: InputMaybe<Axle_Trial_Eligibility_Inc_Input>
  _set?: InputMaybe<Axle_Trial_Eligibility_Set_Input>
  pk_columns: Axle_Trial_Eligibility_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Axle_Trial_Eligibility_ManyArgs = {
  updates: Array<Axle_Trial_Eligibility_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_BillArgs = {
  _inc?: InputMaybe<Bill_Inc_Input>
  _set?: InputMaybe<Bill_Set_Input>
  where: Bill_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Bill_By_PkArgs = {
  _inc?: InputMaybe<Bill_Inc_Input>
  _set?: InputMaybe<Bill_Set_Input>
  pk_columns: Bill_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Bill_ManyArgs = {
  updates: Array<Bill_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Billing_AccountArgs = {
  _inc?: InputMaybe<Billing_Account_Inc_Input>
  _set?: InputMaybe<Billing_Account_Set_Input>
  where: Billing_Account_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Billing_Account_By_PkArgs = {
  _inc?: InputMaybe<Billing_Account_Inc_Input>
  _set?: InputMaybe<Billing_Account_Set_Input>
  pk_columns: Billing_Account_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Billing_Account_ContactArgs = {
  _inc?: InputMaybe<Billing_Account_Contact_Inc_Input>
  _set?: InputMaybe<Billing_Account_Contact_Set_Input>
  where: Billing_Account_Contact_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Billing_Account_Contact_By_PkArgs = {
  _inc?: InputMaybe<Billing_Account_Contact_Inc_Input>
  _set?: InputMaybe<Billing_Account_Contact_Set_Input>
  pk_columns: Billing_Account_Contact_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Billing_Account_Contact_ManyArgs = {
  updates: Array<Billing_Account_Contact_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Billing_Account_ManyArgs = {
  updates: Array<Billing_Account_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Billing_Account_SettingArgs = {
  _inc?: InputMaybe<Billing_Account_Setting_Inc_Input>
  _set?: InputMaybe<Billing_Account_Setting_Set_Input>
  where: Billing_Account_Setting_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Billing_Account_Setting_By_PkArgs = {
  _inc?: InputMaybe<Billing_Account_Setting_Inc_Input>
  _set?: InputMaybe<Billing_Account_Setting_Set_Input>
  pk_columns: Billing_Account_Setting_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Billing_Account_Setting_ManyArgs = {
  updates: Array<Billing_Account_Setting_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Billing_Account_TransactionArgs = {
  _inc?: InputMaybe<Billing_Account_Transaction_Inc_Input>
  _set?: InputMaybe<Billing_Account_Transaction_Set_Input>
  where: Billing_Account_Transaction_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Billing_Account_Transaction_By_PkArgs = {
  _inc?: InputMaybe<Billing_Account_Transaction_Inc_Input>
  _set?: InputMaybe<Billing_Account_Transaction_Set_Input>
  pk_columns: Billing_Account_Transaction_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Billing_Account_Transaction_ManyArgs = {
  updates: Array<Billing_Account_Transaction_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Billing_PeriodArgs = {
  _inc?: InputMaybe<Billing_Period_Inc_Input>
  _set?: InputMaybe<Billing_Period_Set_Input>
  where: Billing_Period_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Billing_Period_By_PkArgs = {
  _inc?: InputMaybe<Billing_Period_Inc_Input>
  _set?: InputMaybe<Billing_Period_Set_Input>
  pk_columns: Billing_Period_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Billing_Period_ManyArgs = {
  updates: Array<Billing_Period_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Calculation_ItemsArgs = {
  _inc?: InputMaybe<Calculation_Items_Inc_Input>
  _set?: InputMaybe<Calculation_Items_Set_Input>
  where: Calculation_Items_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Calculation_Items_By_PkArgs = {
  _inc?: InputMaybe<Calculation_Items_Inc_Input>
  _set?: InputMaybe<Calculation_Items_Set_Input>
  pk_columns: Calculation_Items_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Calculation_Items_ManyArgs = {
  updates: Array<Calculation_Items_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Call_Trace_AuditArgs = {
  _inc?: InputMaybe<Call_Trace_Audit_Inc_Input>
  _set?: InputMaybe<Call_Trace_Audit_Set_Input>
  where: Call_Trace_Audit_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Call_Trace_Audit_By_PkArgs = {
  _inc?: InputMaybe<Call_Trace_Audit_Inc_Input>
  _set?: InputMaybe<Call_Trace_Audit_Set_Input>
  pk_columns: Call_Trace_Audit_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Call_Trace_Audit_ManyArgs = {
  updates: Array<Call_Trace_Audit_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Cancellation_ReasonsArgs = {
  _inc?: InputMaybe<Cancellation_Reasons_Inc_Input>
  _set?: InputMaybe<Cancellation_Reasons_Set_Input>
  where: Cancellation_Reasons_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Cancellation_Reasons_ManyArgs = {
  updates: Array<Cancellation_Reasons_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_CancellationsArgs = {
  _inc?: InputMaybe<Cancellations_Inc_Input>
  _set?: InputMaybe<Cancellations_Set_Input>
  where: Cancellations_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Cancellations_By_PkArgs = {
  _inc?: InputMaybe<Cancellations_Inc_Input>
  _set?: InputMaybe<Cancellations_Set_Input>
  pk_columns: Cancellations_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Cancellations_ManyArgs = {
  updates: Array<Cancellations_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Card_PaymentArgs = {
  _inc?: InputMaybe<Card_Payment_Inc_Input>
  _set?: InputMaybe<Card_Payment_Set_Input>
  where: Card_Payment_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Card_Payment_By_PkArgs = {
  _inc?: InputMaybe<Card_Payment_Inc_Input>
  _set?: InputMaybe<Card_Payment_Set_Input>
  pk_columns: Card_Payment_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Card_Payment_ManyArgs = {
  updates: Array<Card_Payment_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Card_Payment_OldArgs = {
  _inc?: InputMaybe<Card_Payment_Old_Inc_Input>
  _set?: InputMaybe<Card_Payment_Old_Set_Input>
  where: Card_Payment_Old_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Card_Payment_Old_By_PkArgs = {
  _inc?: InputMaybe<Card_Payment_Old_Inc_Input>
  _set?: InputMaybe<Card_Payment_Old_Set_Input>
  pk_columns: Card_Payment_Old_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Card_Payment_Old_ManyArgs = {
  updates: Array<Card_Payment_Old_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_CasesArgs = {
  _append?: InputMaybe<Cases_Append_Input>
  _delete_at_path?: InputMaybe<Cases_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Cases_Delete_Elem_Input>
  _delete_key?: InputMaybe<Cases_Delete_Key_Input>
  _inc?: InputMaybe<Cases_Inc_Input>
  _prepend?: InputMaybe<Cases_Prepend_Input>
  _set?: InputMaybe<Cases_Set_Input>
  where: Cases_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Cases_By_PkArgs = {
  _append?: InputMaybe<Cases_Append_Input>
  _delete_at_path?: InputMaybe<Cases_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Cases_Delete_Elem_Input>
  _delete_key?: InputMaybe<Cases_Delete_Key_Input>
  _inc?: InputMaybe<Cases_Inc_Input>
  _prepend?: InputMaybe<Cases_Prepend_Input>
  _set?: InputMaybe<Cases_Set_Input>
  pk_columns: Cases_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Cases_ManyArgs = {
  updates: Array<Cases_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_CommunicationArgs = {
  _append?: InputMaybe<Communication_Append_Input>
  _delete_at_path?: InputMaybe<Communication_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Communication_Delete_Elem_Input>
  _delete_key?: InputMaybe<Communication_Delete_Key_Input>
  _inc?: InputMaybe<Communication_Inc_Input>
  _prepend?: InputMaybe<Communication_Prepend_Input>
  _set?: InputMaybe<Communication_Set_Input>
  where: Communication_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Communication_By_PkArgs = {
  _append?: InputMaybe<Communication_Append_Input>
  _delete_at_path?: InputMaybe<Communication_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Communication_Delete_Elem_Input>
  _delete_key?: InputMaybe<Communication_Delete_Key_Input>
  _inc?: InputMaybe<Communication_Inc_Input>
  _prepend?: InputMaybe<Communication_Prepend_Input>
  _set?: InputMaybe<Communication_Set_Input>
  pk_columns: Communication_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Communication_ManyArgs = {
  updates: Array<Communication_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Communication_MetadataArgs = {
  _inc?: InputMaybe<Communication_Metadata_Inc_Input>
  _set?: InputMaybe<Communication_Metadata_Set_Input>
  where: Communication_Metadata_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Communication_Metadata_By_PkArgs = {
  _inc?: InputMaybe<Communication_Metadata_Inc_Input>
  _set?: InputMaybe<Communication_Metadata_Set_Input>
  pk_columns: Communication_Metadata_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Communication_Metadata_ManyArgs = {
  updates: Array<Communication_Metadata_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_CommunicationsArgs = {
  _inc?: InputMaybe<Communications_Inc_Input>
  _set?: InputMaybe<Communications_Set_Input>
  where: Communications_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Communications_By_PkArgs = {
  _inc?: InputMaybe<Communications_Inc_Input>
  _set?: InputMaybe<Communications_Set_Input>
  pk_columns: Communications_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Communications_ManyArgs = {
  updates: Array<Communications_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_ComplaintArgs = {
  _append?: InputMaybe<Complaint_Append_Input>
  _delete_at_path?: InputMaybe<Complaint_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Complaint_Delete_Elem_Input>
  _delete_key?: InputMaybe<Complaint_Delete_Key_Input>
  _inc?: InputMaybe<Complaint_Inc_Input>
  _prepend?: InputMaybe<Complaint_Prepend_Input>
  _set?: InputMaybe<Complaint_Set_Input>
  where: Complaint_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Complaint_By_PkArgs = {
  _append?: InputMaybe<Complaint_Append_Input>
  _delete_at_path?: InputMaybe<Complaint_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Complaint_Delete_Elem_Input>
  _delete_key?: InputMaybe<Complaint_Delete_Key_Input>
  _inc?: InputMaybe<Complaint_Inc_Input>
  _prepend?: InputMaybe<Complaint_Prepend_Input>
  _set?: InputMaybe<Complaint_Set_Input>
  pk_columns: Complaint_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Complaint_ManyArgs = {
  updates: Array<Complaint_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Completed_Sync_Event_AccountArgs = {
  _inc?: InputMaybe<Completed_Sync_Event_Account_Inc_Input>
  _set?: InputMaybe<Completed_Sync_Event_Account_Set_Input>
  where: Completed_Sync_Event_Account_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Completed_Sync_Event_Account_By_PkArgs = {
  _inc?: InputMaybe<Completed_Sync_Event_Account_Inc_Input>
  _set?: InputMaybe<Completed_Sync_Event_Account_Set_Input>
  pk_columns: Completed_Sync_Event_Account_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Completed_Sync_Event_Account_ManyArgs = {
  updates: Array<Completed_Sync_Event_Account_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_ConfigurationArgs = {
  _inc?: InputMaybe<Configuration_Inc_Input>
  _set?: InputMaybe<Configuration_Set_Input>
  where: Configuration_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Configuration_By_PkArgs = {
  _inc?: InputMaybe<Configuration_Inc_Input>
  _set?: InputMaybe<Configuration_Set_Input>
  pk_columns: Configuration_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Configuration_ManyArgs = {
  updates: Array<Configuration_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_ContactArgs = {
  _inc?: InputMaybe<Contact_Inc_Input>
  _set?: InputMaybe<Contact_Set_Input>
  where: Contact_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Contact_By_PkArgs = {
  _inc?: InputMaybe<Contact_Inc_Input>
  _set?: InputMaybe<Contact_Set_Input>
  pk_columns: Contact_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Contact_ManyArgs = {
  updates: Array<Contact_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Cs__Soe_Dashboard_TotalArgs = {
  _inc?: InputMaybe<Cs__Soe_Dashboard_Total_Inc_Input>
  _set?: InputMaybe<Cs__Soe_Dashboard_Total_Set_Input>
  where: Cs__Soe_Dashboard_Total_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Cs__Soe_Dashboard_Total_By_PkArgs = {
  _inc?: InputMaybe<Cs__Soe_Dashboard_Total_Inc_Input>
  _set?: InputMaybe<Cs__Soe_Dashboard_Total_Set_Input>
  pk_columns: Cs__Soe_Dashboard_Total_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Cs__Soe_Dashboard_Total_ManyArgs = {
  updates: Array<Cs__Soe_Dashboard_Total_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_CustomerArgs = {
  _inc?: InputMaybe<Customer_Inc_Input>
  _set?: InputMaybe<Customer_Set_Input>
  where: Customer_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Customer_AddressArgs = {
  _inc?: InputMaybe<Customer_Address_Inc_Input>
  _set?: InputMaybe<Customer_Address_Set_Input>
  where: Customer_Address_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Customer_Address_By_PkArgs = {
  _inc?: InputMaybe<Customer_Address_Inc_Input>
  _set?: InputMaybe<Customer_Address_Set_Input>
  pk_columns: Customer_Address_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Customer_Address_ManyArgs = {
  updates: Array<Customer_Address_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Customer_By_PkArgs = {
  _inc?: InputMaybe<Customer_Inc_Input>
  _set?: InputMaybe<Customer_Set_Input>
  pk_columns: Customer_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Customer_ContactArgs = {
  _inc?: InputMaybe<Customer_Contact_Inc_Input>
  _set?: InputMaybe<Customer_Contact_Set_Input>
  where: Customer_Contact_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Customer_Contact_By_PkArgs = {
  _inc?: InputMaybe<Customer_Contact_Inc_Input>
  _set?: InputMaybe<Customer_Contact_Set_Input>
  pk_columns: Customer_Contact_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Customer_Contact_ManyArgs = {
  updates: Array<Customer_Contact_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Customer_ManyArgs = {
  updates: Array<Customer_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Customer_MetadataArgs = {
  _inc?: InputMaybe<Customer_Metadata_Inc_Input>
  _set?: InputMaybe<Customer_Metadata_Set_Input>
  where: Customer_Metadata_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Customer_Metadata_By_PkArgs = {
  _inc?: InputMaybe<Customer_Metadata_Inc_Input>
  _set?: InputMaybe<Customer_Metadata_Set_Input>
  pk_columns: Customer_Metadata_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Customer_Metadata_ManyArgs = {
  updates: Array<Customer_Metadata_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Customer_Property_RelArgs = {
  _inc?: InputMaybe<Customer_Property_Rel_Inc_Input>
  _set?: InputMaybe<Customer_Property_Rel_Set_Input>
  where: Customer_Property_Rel_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Customer_Property_Rel_By_PkArgs = {
  _inc?: InputMaybe<Customer_Property_Rel_Inc_Input>
  _set?: InputMaybe<Customer_Property_Rel_Set_Input>
  pk_columns: Customer_Property_Rel_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Customer_Property_Rel_ManyArgs = {
  updates: Array<Customer_Property_Rel_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Customer_Psr_RelArgs = {
  _inc?: InputMaybe<Customer_Psr_Rel_Inc_Input>
  _set?: InputMaybe<Customer_Psr_Rel_Set_Input>
  where: Customer_Psr_Rel_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Customer_Psr_Rel_By_PkArgs = {
  _inc?: InputMaybe<Customer_Psr_Rel_Inc_Input>
  _set?: InputMaybe<Customer_Psr_Rel_Set_Input>
  pk_columns: Customer_Psr_Rel_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Customer_Psr_Rel_ManyArgs = {
  updates: Array<Customer_Psr_Rel_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Customer_ReferralsArgs = {
  _inc?: InputMaybe<Customer_Referrals_Inc_Input>
  _set?: InputMaybe<Customer_Referrals_Set_Input>
  where: Customer_Referrals_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Customer_Referrals_By_PkArgs = {
  _inc?: InputMaybe<Customer_Referrals_Inc_Input>
  _set?: InputMaybe<Customer_Referrals_Set_Input>
  pk_columns: Customer_Referrals_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Customer_Referrals_ManyArgs = {
  updates: Array<Customer_Referrals_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Customer_SettingArgs = {
  _inc?: InputMaybe<Customer_Setting_Inc_Input>
  _set?: InputMaybe<Customer_Setting_Set_Input>
  where: Customer_Setting_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Customer_Setting_By_PkArgs = {
  _inc?: InputMaybe<Customer_Setting_Inc_Input>
  _set?: InputMaybe<Customer_Setting_Set_Input>
  pk_columns: Customer_Setting_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Customer_Setting_ManyArgs = {
  updates: Array<Customer_Setting_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Customer_User_RelArgs = {
  _inc?: InputMaybe<Customer_User_Rel_Inc_Input>
  _set?: InputMaybe<Customer_User_Rel_Set_Input>
  where: Customer_User_Rel_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Customer_User_Rel_By_PkArgs = {
  _inc?: InputMaybe<Customer_User_Rel_Inc_Input>
  _set?: InputMaybe<Customer_User_Rel_Set_Input>
  pk_columns: Customer_User_Rel_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Customer_User_Rel_ManyArgs = {
  updates: Array<Customer_User_Rel_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Deprecated_Solar_Quote_RequestsArgs = {
  _inc?: InputMaybe<Deprecated_Solar_Quote_Requests_Inc_Input>
  _set?: InputMaybe<Deprecated_Solar_Quote_Requests_Set_Input>
  where: Deprecated_Solar_Quote_Requests_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Deprecated_Solar_Quote_Requests_By_PkArgs = {
  _inc?: InputMaybe<Deprecated_Solar_Quote_Requests_Inc_Input>
  _set?: InputMaybe<Deprecated_Solar_Quote_Requests_Set_Input>
  pk_columns: Deprecated_Solar_Quote_Requests_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Deprecated_Solar_Quote_Requests_ManyArgs = {
  updates: Array<Deprecated_Solar_Quote_Requests_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Direct_DebitArgs = {
  _inc?: InputMaybe<Direct_Debit_Inc_Input>
  _set?: InputMaybe<Direct_Debit_Set_Input>
  where: Direct_Debit_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Direct_Debit_By_PkArgs = {
  _inc?: InputMaybe<Direct_Debit_Inc_Input>
  _set?: InputMaybe<Direct_Debit_Set_Input>
  pk_columns: Direct_Debit_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Direct_Debit_ManyArgs = {
  updates: Array<Direct_Debit_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Direct_Debit_PaymentArgs = {
  _inc?: InputMaybe<Direct_Debit_Payment_Inc_Input>
  _set?: InputMaybe<Direct_Debit_Payment_Set_Input>
  where: Direct_Debit_Payment_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Direct_Debit_Payment_By_PkArgs = {
  _inc?: InputMaybe<Direct_Debit_Payment_Inc_Input>
  _set?: InputMaybe<Direct_Debit_Payment_Set_Input>
  pk_columns: Direct_Debit_Payment_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Direct_Debit_Payment_ManyArgs = {
  updates: Array<Direct_Debit_Payment_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Email_MessagesArgs = {
  _inc?: InputMaybe<Email_Messages_Inc_Input>
  _set?: InputMaybe<Email_Messages_Set_Input>
  where: Email_Messages_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Email_Messages_By_PkArgs = {
  _inc?: InputMaybe<Email_Messages_Inc_Input>
  _set?: InputMaybe<Email_Messages_Set_Input>
  pk_columns: Email_Messages_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Email_Messages_ManyArgs = {
  updates: Array<Email_Messages_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Email_TemplatesArgs = {
  _inc?: InputMaybe<Email_Templates_Inc_Input>
  _set?: InputMaybe<Email_Templates_Set_Input>
  where: Email_Templates_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Email_Templates_By_PkArgs = {
  _inc?: InputMaybe<Email_Templates_Inc_Input>
  _set?: InputMaybe<Email_Templates_Set_Input>
  pk_columns: Email_Templates_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Email_Templates_ExtArgs = {
  _inc?: InputMaybe<Email_Templates_Ext_Inc_Input>
  _set?: InputMaybe<Email_Templates_Ext_Set_Input>
  where: Email_Templates_Ext_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Email_Templates_Ext_By_PkArgs = {
  _inc?: InputMaybe<Email_Templates_Ext_Inc_Input>
  _set?: InputMaybe<Email_Templates_Ext_Set_Input>
  pk_columns: Email_Templates_Ext_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Email_Templates_Ext_ManyArgs = {
  updates: Array<Email_Templates_Ext_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Email_Templates_ManyArgs = {
  updates: Array<Email_Templates_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Energy_Usage_Load_FactorsArgs = {
  _inc?: InputMaybe<Energy_Usage_Load_Factors_Inc_Input>
  _set?: InputMaybe<Energy_Usage_Load_Factors_Set_Input>
  where: Energy_Usage_Load_Factors_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Energy_Usage_Load_Factors_By_PkArgs = {
  _inc?: InputMaybe<Energy_Usage_Load_Factors_Inc_Input>
  _set?: InputMaybe<Energy_Usage_Load_Factors_Set_Input>
  pk_columns: Energy_Usage_Load_Factors_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Energy_Usage_Load_Factors_ManyArgs = {
  updates: Array<Energy_Usage_Load_Factors_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_EnrolmentArgs = {
  _inc?: InputMaybe<Enrolment_Inc_Input>
  _set?: InputMaybe<Enrolment_Set_Input>
  where: Enrolment_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Enrolment_Automated_CommunicationsArgs = {
  _inc?: InputMaybe<Enrolment_Automated_Communications_Inc_Input>
  _set?: InputMaybe<Enrolment_Automated_Communications_Set_Input>
  where: Enrolment_Automated_Communications_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Enrolment_Automated_Communications_By_PkArgs = {
  _inc?: InputMaybe<Enrolment_Automated_Communications_Inc_Input>
  _set?: InputMaybe<Enrolment_Automated_Communications_Set_Input>
  pk_columns: Enrolment_Automated_Communications_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Enrolment_Automated_Communications_ManyArgs = {
  updates: Array<Enrolment_Automated_Communications_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Enrolment_By_PkArgs = {
  _inc?: InputMaybe<Enrolment_Inc_Input>
  _set?: InputMaybe<Enrolment_Set_Input>
  pk_columns: Enrolment_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Enrolment_ManyArgs = {
  updates: Array<Enrolment_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Entity_MappingsArgs = {
  _inc?: InputMaybe<Entity_Mappings_Inc_Input>
  _set?: InputMaybe<Entity_Mappings_Set_Input>
  where: Entity_Mappings_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Entity_Mappings_By_PkArgs = {
  _inc?: InputMaybe<Entity_Mappings_Inc_Input>
  _set?: InputMaybe<Entity_Mappings_Set_Input>
  pk_columns: Entity_Mappings_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Entity_Mappings_ManyArgs = {
  updates: Array<Entity_Mappings_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Estimated_UsageArgs = {
  _inc?: InputMaybe<Estimated_Usage_Inc_Input>
  _set?: InputMaybe<Estimated_Usage_Set_Input>
  where: Estimated_Usage_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Estimated_Usage_By_PkArgs = {
  _inc?: InputMaybe<Estimated_Usage_Inc_Input>
  _set?: InputMaybe<Estimated_Usage_Set_Input>
  pk_columns: Estimated_Usage_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Estimated_Usage_ManyArgs = {
  updates: Array<Estimated_Usage_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Ev_Smart_Tariff_WaitlistArgs = {
  _inc?: InputMaybe<Ev_Smart_Tariff_Waitlist_Inc_Input>
  _set?: InputMaybe<Ev_Smart_Tariff_Waitlist_Set_Input>
  where: Ev_Smart_Tariff_Waitlist_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Ev_Smart_Tariff_Waitlist_By_PkArgs = {
  _inc?: InputMaybe<Ev_Smart_Tariff_Waitlist_Inc_Input>
  _set?: InputMaybe<Ev_Smart_Tariff_Waitlist_Set_Input>
  pk_columns: Ev_Smart_Tariff_Waitlist_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Ev_Smart_Tariff_Waitlist_ManyArgs = {
  updates: Array<Ev_Smart_Tariff_Waitlist_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Ev_Tariff_Eligibility_ChecksArgs = {
  _inc?: InputMaybe<Ev_Tariff_Eligibility_Checks_Inc_Input>
  _set?: InputMaybe<Ev_Tariff_Eligibility_Checks_Set_Input>
  where: Ev_Tariff_Eligibility_Checks_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Ev_Tariff_Eligibility_Checks_By_PkArgs = {
  _inc?: InputMaybe<Ev_Tariff_Eligibility_Checks_Inc_Input>
  _set?: InputMaybe<Ev_Tariff_Eligibility_Checks_Set_Input>
  pk_columns: Ev_Tariff_Eligibility_Checks_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Ev_Tariff_Eligibility_Checks_ManyArgs = {
  updates: Array<Ev_Tariff_Eligibility_Checks_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_FeatureArgs = {
  _inc?: InputMaybe<Feature_Inc_Input>
  _set?: InputMaybe<Feature_Set_Input>
  where: Feature_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Feature_By_PkArgs = {
  _inc?: InputMaybe<Feature_Inc_Input>
  _set?: InputMaybe<Feature_Set_Input>
  pk_columns: Feature_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Feature_ManyArgs = {
  updates: Array<Feature_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Financials_ConfigurationArgs = {
  _inc?: InputMaybe<Financials_Configuration_Inc_Input>
  _set?: InputMaybe<Financials_Configuration_Set_Input>
  where: Financials_Configuration_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Configuration_By_PkArgs = {
  _inc?: InputMaybe<Financials_Configuration_Inc_Input>
  _set?: InputMaybe<Financials_Configuration_Set_Input>
  pk_columns: Financials_Configuration_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Configuration_ManyArgs = {
  updates: Array<Financials_Configuration_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Blob_TriggersArgs = {
  _set?: InputMaybe<Financials_Qrtz_Blob_Triggers_Set_Input>
  where: Financials_Qrtz_Blob_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Blob_Triggers_By_PkArgs = {
  _set?: InputMaybe<Financials_Qrtz_Blob_Triggers_Set_Input>
  pk_columns: Financials_Qrtz_Blob_Triggers_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Blob_Triggers_ManyArgs = {
  updates: Array<Financials_Qrtz_Blob_Triggers_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_CalendarsArgs = {
  _set?: InputMaybe<Financials_Qrtz_Calendars_Set_Input>
  where: Financials_Qrtz_Calendars_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Calendars_By_PkArgs = {
  _set?: InputMaybe<Financials_Qrtz_Calendars_Set_Input>
  pk_columns: Financials_Qrtz_Calendars_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Calendars_ManyArgs = {
  updates: Array<Financials_Qrtz_Calendars_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Cron_TriggersArgs = {
  _set?: InputMaybe<Financials_Qrtz_Cron_Triggers_Set_Input>
  where: Financials_Qrtz_Cron_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Cron_Triggers_By_PkArgs = {
  _set?: InputMaybe<Financials_Qrtz_Cron_Triggers_Set_Input>
  pk_columns: Financials_Qrtz_Cron_Triggers_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Cron_Triggers_ManyArgs = {
  updates: Array<Financials_Qrtz_Cron_Triggers_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Fired_TriggersArgs = {
  _inc?: InputMaybe<Financials_Qrtz_Fired_Triggers_Inc_Input>
  _set?: InputMaybe<Financials_Qrtz_Fired_Triggers_Set_Input>
  where: Financials_Qrtz_Fired_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Fired_Triggers_By_PkArgs = {
  _inc?: InputMaybe<Financials_Qrtz_Fired_Triggers_Inc_Input>
  _set?: InputMaybe<Financials_Qrtz_Fired_Triggers_Set_Input>
  pk_columns: Financials_Qrtz_Fired_Triggers_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Fired_Triggers_ManyArgs = {
  updates: Array<Financials_Qrtz_Fired_Triggers_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Job_DetailsArgs = {
  _set?: InputMaybe<Financials_Qrtz_Job_Details_Set_Input>
  where: Financials_Qrtz_Job_Details_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Job_Details_By_PkArgs = {
  _set?: InputMaybe<Financials_Qrtz_Job_Details_Set_Input>
  pk_columns: Financials_Qrtz_Job_Details_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Job_Details_ManyArgs = {
  updates: Array<Financials_Qrtz_Job_Details_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Scheduler_StateArgs = {
  _inc?: InputMaybe<Financials_Qrtz_Scheduler_State_Inc_Input>
  _set?: InputMaybe<Financials_Qrtz_Scheduler_State_Set_Input>
  where: Financials_Qrtz_Scheduler_State_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Scheduler_State_By_PkArgs = {
  _inc?: InputMaybe<Financials_Qrtz_Scheduler_State_Inc_Input>
  _set?: InputMaybe<Financials_Qrtz_Scheduler_State_Set_Input>
  pk_columns: Financials_Qrtz_Scheduler_State_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Scheduler_State_ManyArgs = {
  updates: Array<Financials_Qrtz_Scheduler_State_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Simple_TriggersArgs = {
  _inc?: InputMaybe<Financials_Qrtz_Simple_Triggers_Inc_Input>
  _set?: InputMaybe<Financials_Qrtz_Simple_Triggers_Set_Input>
  where: Financials_Qrtz_Simple_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Simple_Triggers_By_PkArgs = {
  _inc?: InputMaybe<Financials_Qrtz_Simple_Triggers_Inc_Input>
  _set?: InputMaybe<Financials_Qrtz_Simple_Triggers_Set_Input>
  pk_columns: Financials_Qrtz_Simple_Triggers_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Simple_Triggers_ManyArgs = {
  updates: Array<Financials_Qrtz_Simple_Triggers_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Simprop_TriggersArgs = {
  _inc?: InputMaybe<Financials_Qrtz_Simprop_Triggers_Inc_Input>
  _set?: InputMaybe<Financials_Qrtz_Simprop_Triggers_Set_Input>
  where: Financials_Qrtz_Simprop_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Simprop_Triggers_By_PkArgs = {
  _inc?: InputMaybe<Financials_Qrtz_Simprop_Triggers_Inc_Input>
  _set?: InputMaybe<Financials_Qrtz_Simprop_Triggers_Set_Input>
  pk_columns: Financials_Qrtz_Simprop_Triggers_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Simprop_Triggers_ManyArgs = {
  updates: Array<Financials_Qrtz_Simprop_Triggers_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_TriggersArgs = {
  _inc?: InputMaybe<Financials_Qrtz_Triggers_Inc_Input>
  _set?: InputMaybe<Financials_Qrtz_Triggers_Set_Input>
  where: Financials_Qrtz_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Triggers_By_PkArgs = {
  _inc?: InputMaybe<Financials_Qrtz_Triggers_Inc_Input>
  _set?: InputMaybe<Financials_Qrtz_Triggers_Set_Input>
  pk_columns: Financials_Qrtz_Triggers_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Qrtz_Triggers_ManyArgs = {
  updates: Array<Financials_Qrtz_Triggers_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrant_Account_CriteriaArgs = {
  _inc?: InputMaybe<Financials_Warrant_Account_Criteria_Inc_Input>
  _set?: InputMaybe<Financials_Warrant_Account_Criteria_Set_Input>
  where: Financials_Warrant_Account_Criteria_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrant_Account_Criteria_By_PkArgs =
  {
    _inc?: InputMaybe<Financials_Warrant_Account_Criteria_Inc_Input>
    _set?: InputMaybe<Financials_Warrant_Account_Criteria_Set_Input>
    pk_columns: Financials_Warrant_Account_Criteria_Pk_Columns_Input
  }

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrant_Account_Criteria_ManyArgs = {
  updates: Array<Financials_Warrant_Account_Criteria_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrant_Account_Sync_CriteriaArgs = {
  _inc?: InputMaybe<Financials_Warrant_Account_Sync_Criteria_Inc_Input>
  _set?: InputMaybe<Financials_Warrant_Account_Sync_Criteria_Set_Input>
  where: Financials_Warrant_Account_Sync_Criteria_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrant_Account_Sync_Criteria_By_PkArgs =
  {
    _inc?: InputMaybe<Financials_Warrant_Account_Sync_Criteria_Inc_Input>
    _set?: InputMaybe<Financials_Warrant_Account_Sync_Criteria_Set_Input>
    pk_columns: Financials_Warrant_Account_Sync_Criteria_Pk_Columns_Input
  }

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrant_Account_Sync_Criteria_ManyArgs =
  {
    updates: Array<Financials_Warrant_Account_Sync_Criteria_Updates>
  }

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrant_Communications_Sent_CountArgs =
  {
    _inc?: InputMaybe<Financials_Warrant_Communications_Sent_Count_Inc_Input>
    _set?: InputMaybe<Financials_Warrant_Communications_Sent_Count_Set_Input>
    where: Financials_Warrant_Communications_Sent_Count_Bool_Exp
  }

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrant_Communications_Sent_Count_By_PkArgs =
  {
    _inc?: InputMaybe<Financials_Warrant_Communications_Sent_Count_Inc_Input>
    _set?: InputMaybe<Financials_Warrant_Communications_Sent_Count_Set_Input>
    pk_columns: Financials_Warrant_Communications_Sent_Count_Pk_Columns_Input
  }

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrant_Communications_Sent_Count_ManyArgs =
  {
    updates: Array<Financials_Warrant_Communications_Sent_Count_Updates>
  }

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_AccountsArgs = {
  _inc?: InputMaybe<Financials_Warrants_Accounts_Inc_Input>
  _set?: InputMaybe<Financials_Warrants_Accounts_Set_Input>
  where: Financials_Warrants_Accounts_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Accounts_By_PkArgs = {
  _inc?: InputMaybe<Financials_Warrants_Accounts_Inc_Input>
  _set?: InputMaybe<Financials_Warrants_Accounts_Set_Input>
  pk_columns: Financials_Warrants_Accounts_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Accounts_HistoryArgs = {
  _inc?: InputMaybe<Financials_Warrants_Accounts_History_Inc_Input>
  _set?: InputMaybe<Financials_Warrants_Accounts_History_Set_Input>
  where: Financials_Warrants_Accounts_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Accounts_History_By_PkArgs =
  {
    _inc?: InputMaybe<Financials_Warrants_Accounts_History_Inc_Input>
    _set?: InputMaybe<Financials_Warrants_Accounts_History_Set_Input>
    pk_columns: Financials_Warrants_Accounts_History_Pk_Columns_Input
  }

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Accounts_History_ManyArgs =
  {
    updates: Array<Financials_Warrants_Accounts_History_Updates>
  }

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Accounts_ManyArgs = {
  updates: Array<Financials_Warrants_Accounts_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Accounts_WhitelistArgs = {
  _inc?: InputMaybe<Financials_Warrants_Accounts_Whitelist_Inc_Input>
  _set?: InputMaybe<Financials_Warrants_Accounts_Whitelist_Set_Input>
  where: Financials_Warrants_Accounts_Whitelist_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Accounts_Whitelist_By_PkArgs =
  {
    _inc?: InputMaybe<Financials_Warrants_Accounts_Whitelist_Inc_Input>
    _set?: InputMaybe<Financials_Warrants_Accounts_Whitelist_Set_Input>
    pk_columns: Financials_Warrants_Accounts_Whitelist_Pk_Columns_Input
  }

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Accounts_Whitelist_ManyArgs =
  {
    updates: Array<Financials_Warrants_Accounts_Whitelist_Updates>
  }

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Communication_GroupArgs = {
  _inc?: InputMaybe<Financials_Warrants_Communication_Group_Inc_Input>
  _set?: InputMaybe<Financials_Warrants_Communication_Group_Set_Input>
  where: Financials_Warrants_Communication_Group_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Communication_Group_By_PkArgs =
  {
    _inc?: InputMaybe<Financials_Warrants_Communication_Group_Inc_Input>
    _set?: InputMaybe<Financials_Warrants_Communication_Group_Set_Input>
    pk_columns: Financials_Warrants_Communication_Group_Pk_Columns_Input
  }

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Communication_Group_ManyArgs =
  {
    updates: Array<Financials_Warrants_Communication_Group_Updates>
  }

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_CommunicationsArgs = {
  _inc?: InputMaybe<Financials_Warrants_Communications_Inc_Input>
  _set?: InputMaybe<Financials_Warrants_Communications_Set_Input>
  where: Financials_Warrants_Communications_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Communications_By_PkArgs = {
  _inc?: InputMaybe<Financials_Warrants_Communications_Inc_Input>
  _set?: InputMaybe<Financials_Warrants_Communications_Set_Input>
  pk_columns: Financials_Warrants_Communications_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Communications_ManyArgs = {
  updates: Array<Financials_Warrants_Communications_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Dca_QueueArgs = {
  _inc?: InputMaybe<Financials_Warrants_Dca_Queue_Inc_Input>
  _set?: InputMaybe<Financials_Warrants_Dca_Queue_Set_Input>
  where: Financials_Warrants_Dca_Queue_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Dca_Queue_By_PkArgs = {
  _inc?: InputMaybe<Financials_Warrants_Dca_Queue_Inc_Input>
  _set?: InputMaybe<Financials_Warrants_Dca_Queue_Set_Input>
  pk_columns: Financials_Warrants_Dca_Queue_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Dca_Queue_ManyArgs = {
  updates: Array<Financials_Warrants_Dca_Queue_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Dca_TicketsArgs = {
  _inc?: InputMaybe<Financials_Warrants_Dca_Tickets_Inc_Input>
  _set?: InputMaybe<Financials_Warrants_Dca_Tickets_Set_Input>
  where: Financials_Warrants_Dca_Tickets_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Dca_Tickets_By_PkArgs = {
  _inc?: InputMaybe<Financials_Warrants_Dca_Tickets_Inc_Input>
  _set?: InputMaybe<Financials_Warrants_Dca_Tickets_Set_Input>
  pk_columns: Financials_Warrants_Dca_Tickets_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Dca_Tickets_ManyArgs = {
  updates: Array<Financials_Warrants_Dca_Tickets_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Files_AccountArgs = {
  _append?: InputMaybe<Financials_Warrants_Files_Account_Append_Input>
  _delete_at_path?: InputMaybe<Financials_Warrants_Files_Account_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Financials_Warrants_Files_Account_Delete_Elem_Input>
  _delete_key?: InputMaybe<Financials_Warrants_Files_Account_Delete_Key_Input>
  _inc?: InputMaybe<Financials_Warrants_Files_Account_Inc_Input>
  _prepend?: InputMaybe<Financials_Warrants_Files_Account_Prepend_Input>
  _set?: InputMaybe<Financials_Warrants_Files_Account_Set_Input>
  where: Financials_Warrants_Files_Account_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Files_Account_By_PkArgs = {
  _append?: InputMaybe<Financials_Warrants_Files_Account_Append_Input>
  _delete_at_path?: InputMaybe<Financials_Warrants_Files_Account_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Financials_Warrants_Files_Account_Delete_Elem_Input>
  _delete_key?: InputMaybe<Financials_Warrants_Files_Account_Delete_Key_Input>
  _inc?: InputMaybe<Financials_Warrants_Files_Account_Inc_Input>
  _prepend?: InputMaybe<Financials_Warrants_Files_Account_Prepend_Input>
  _set?: InputMaybe<Financials_Warrants_Files_Account_Set_Input>
  pk_columns: Financials_Warrants_Files_Account_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Files_Account_ManyArgs = {
  updates: Array<Financials_Warrants_Files_Account_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Files_JobArgs = {
  _inc?: InputMaybe<Financials_Warrants_Files_Job_Inc_Input>
  _set?: InputMaybe<Financials_Warrants_Files_Job_Set_Input>
  where: Financials_Warrants_Files_Job_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Files_Job_By_PkArgs = {
  _inc?: InputMaybe<Financials_Warrants_Files_Job_Inc_Input>
  _set?: InputMaybe<Financials_Warrants_Files_Job_Set_Input>
  pk_columns: Financials_Warrants_Files_Job_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Files_Job_ManyArgs = {
  updates: Array<Financials_Warrants_Files_Job_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Files_ProcessedArgs = {
  _inc?: InputMaybe<Financials_Warrants_Files_Processed_Inc_Input>
  _set?: InputMaybe<Financials_Warrants_Files_Processed_Set_Input>
  where: Financials_Warrants_Files_Processed_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Files_Processed_By_PkArgs =
  {
    _inc?: InputMaybe<Financials_Warrants_Files_Processed_Inc_Input>
    _set?: InputMaybe<Financials_Warrants_Files_Processed_Set_Input>
    pk_columns: Financials_Warrants_Files_Processed_Pk_Columns_Input
  }

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Files_Processed_ManyArgs = {
  updates: Array<Financials_Warrants_Files_Processed_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_JobArgs = {
  _inc?: InputMaybe<Financials_Warrants_Job_Inc_Input>
  _set?: InputMaybe<Financials_Warrants_Job_Set_Input>
  where: Financials_Warrants_Job_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Job_By_PkArgs = {
  _inc?: InputMaybe<Financials_Warrants_Job_Inc_Input>
  _set?: InputMaybe<Financials_Warrants_Job_Set_Input>
  pk_columns: Financials_Warrants_Job_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Financials_Warrants_Job_ManyArgs = {
  updates: Array<Financials_Warrants_Job_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Flex_Market_SubscriptionArgs = {
  _inc?: InputMaybe<Flex_Market_Subscription_Inc_Input>
  _set?: InputMaybe<Flex_Market_Subscription_Set_Input>
  where: Flex_Market_Subscription_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Flex_Market_Subscription_BillingArgs = {
  _inc?: InputMaybe<Flex_Market_Subscription_Billing_Inc_Input>
  _set?: InputMaybe<Flex_Market_Subscription_Billing_Set_Input>
  where: Flex_Market_Subscription_Billing_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Flex_Market_Subscription_Billing_By_PkArgs = {
  _inc?: InputMaybe<Flex_Market_Subscription_Billing_Inc_Input>
  _set?: InputMaybe<Flex_Market_Subscription_Billing_Set_Input>
  pk_columns: Flex_Market_Subscription_Billing_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Flex_Market_Subscription_Billing_ComponentArgs =
  {
    _inc?: InputMaybe<Flex_Market_Subscription_Billing_Component_Inc_Input>
    _set?: InputMaybe<Flex_Market_Subscription_Billing_Component_Set_Input>
    where: Flex_Market_Subscription_Billing_Component_Bool_Exp
  }

/** mutation root */
export type Mutation_RootUpdate_Flex_Market_Subscription_Billing_Component_By_PkArgs =
  {
    _inc?: InputMaybe<Flex_Market_Subscription_Billing_Component_Inc_Input>
    _set?: InputMaybe<Flex_Market_Subscription_Billing_Component_Set_Input>
    pk_columns: Flex_Market_Subscription_Billing_Component_Pk_Columns_Input
  }

/** mutation root */
export type Mutation_RootUpdate_Flex_Market_Subscription_Billing_Component_ManyArgs =
  {
    updates: Array<Flex_Market_Subscription_Billing_Component_Updates>
  }

/** mutation root */
export type Mutation_RootUpdate_Flex_Market_Subscription_Billing_ManyArgs = {
  updates: Array<Flex_Market_Subscription_Billing_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Flex_Market_Subscription_By_PkArgs = {
  _inc?: InputMaybe<Flex_Market_Subscription_Inc_Input>
  _set?: InputMaybe<Flex_Market_Subscription_Set_Input>
  pk_columns: Flex_Market_Subscription_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Flex_Market_Subscription_ManyArgs = {
  updates: Array<Flex_Market_Subscription_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Flyway_Schema_HistoryArgs = {
  _inc?: InputMaybe<Flyway_Schema_History_Inc_Input>
  _set?: InputMaybe<Flyway_Schema_History_Set_Input>
  where: Flyway_Schema_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Flyway_Schema_History_By_PkArgs = {
  _inc?: InputMaybe<Flyway_Schema_History_Inc_Input>
  _set?: InputMaybe<Flyway_Schema_History_Set_Input>
  pk_columns: Flyway_Schema_History_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Flyway_Schema_History_ManyArgs = {
  updates: Array<Flyway_Schema_History_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Freshdesk_ContactArgs = {
  _append?: InputMaybe<Freshdesk_Contact_Append_Input>
  _delete_at_path?: InputMaybe<Freshdesk_Contact_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Freshdesk_Contact_Delete_Elem_Input>
  _delete_key?: InputMaybe<Freshdesk_Contact_Delete_Key_Input>
  _inc?: InputMaybe<Freshdesk_Contact_Inc_Input>
  _prepend?: InputMaybe<Freshdesk_Contact_Prepend_Input>
  _set?: InputMaybe<Freshdesk_Contact_Set_Input>
  where: Freshdesk_Contact_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Freshdesk_Contact_ManyArgs = {
  updates: Array<Freshdesk_Contact_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Freshdesk_TicketArgs = {
  _append?: InputMaybe<Freshdesk_Ticket_Append_Input>
  _delete_at_path?: InputMaybe<Freshdesk_Ticket_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Freshdesk_Ticket_Delete_Elem_Input>
  _delete_key?: InputMaybe<Freshdesk_Ticket_Delete_Key_Input>
  _inc?: InputMaybe<Freshdesk_Ticket_Inc_Input>
  _prepend?: InputMaybe<Freshdesk_Ticket_Prepend_Input>
  _set?: InputMaybe<Freshdesk_Ticket_Set_Input>
  where: Freshdesk_Ticket_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Freshdesk_Ticket_ManyArgs = {
  updates: Array<Freshdesk_Ticket_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Install_CodesArgs = {
  _inc?: InputMaybe<Install_Codes_Inc_Input>
  _set?: InputMaybe<Install_Codes_Set_Input>
  where: Install_Codes_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Install_Codes_By_PkArgs = {
  _inc?: InputMaybe<Install_Codes_Inc_Input>
  _set?: InputMaybe<Install_Codes_Set_Input>
  pk_columns: Install_Codes_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Install_Codes_ManyArgs = {
  updates: Array<Install_Codes_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Junifer__AccountArgs = {
  _inc?: InputMaybe<Junifer__Account_Inc_Input>
  _set?: InputMaybe<Junifer__Account_Set_Input>
  where: Junifer__Account_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Junifer__AccountTransactionArgs = {
  _inc?: InputMaybe<Junifer__AccountTransaction_Inc_Input>
  _set?: InputMaybe<Junifer__AccountTransaction_Set_Input>
  where: Junifer__AccountTransaction_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Junifer__AccountTransaction_By_PkArgs = {
  _inc?: InputMaybe<Junifer__AccountTransaction_Inc_Input>
  _set?: InputMaybe<Junifer__AccountTransaction_Set_Input>
  pk_columns: Junifer__AccountTransaction_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Junifer__AccountTransaction_ManyArgs = {
  updates: Array<Junifer__AccountTransaction_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Junifer__Account_By_PkArgs = {
  _inc?: InputMaybe<Junifer__Account_Inc_Input>
  _set?: InputMaybe<Junifer__Account_Set_Input>
  pk_columns: Junifer__Account_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Junifer__Account_ManyArgs = {
  updates: Array<Junifer__Account_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Junifer__CustomerArgs = {
  _inc?: InputMaybe<Junifer__Customer_Inc_Input>
  _set?: InputMaybe<Junifer__Customer_Set_Input>
  where: Junifer__Customer_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Junifer__Customer_By_PkArgs = {
  _inc?: InputMaybe<Junifer__Customer_Inc_Input>
  _set?: InputMaybe<Junifer__Customer_Set_Input>
  pk_columns: Junifer__Customer_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Junifer__Customer_ManyArgs = {
  updates: Array<Junifer__Customer_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_MeterArgs = {
  _inc?: InputMaybe<Meter_Inc_Input>
  _set?: InputMaybe<Meter_Set_Input>
  where: Meter_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Meter_By_PkArgs = {
  _inc?: InputMaybe<Meter_Inc_Input>
  _set?: InputMaybe<Meter_Set_Input>
  pk_columns: Meter_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Meter_ManyArgs = {
  updates: Array<Meter_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Meter_Meter_Point_RelArgs = {
  _inc?: InputMaybe<Meter_Meter_Point_Rel_Inc_Input>
  _set?: InputMaybe<Meter_Meter_Point_Rel_Set_Input>
  where: Meter_Meter_Point_Rel_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Meter_Meter_Point_Rel_By_PkArgs = {
  _inc?: InputMaybe<Meter_Meter_Point_Rel_Inc_Input>
  _set?: InputMaybe<Meter_Meter_Point_Rel_Set_Input>
  pk_columns: Meter_Meter_Point_Rel_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Meter_Meter_Point_Rel_ManyArgs = {
  updates: Array<Meter_Meter_Point_Rel_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Meter_PointArgs = {
  _inc?: InputMaybe<Meter_Point_Inc_Input>
  _set?: InputMaybe<Meter_Point_Set_Input>
  where: Meter_Point_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Meter_Point_By_PkArgs = {
  _inc?: InputMaybe<Meter_Point_Inc_Input>
  _set?: InputMaybe<Meter_Point_Set_Input>
  pk_columns: Meter_Point_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Meter_Point_ElectricityArgs = {
  _inc?: InputMaybe<Meter_Point_Electricity_Inc_Input>
  _set?: InputMaybe<Meter_Point_Electricity_Set_Input>
  where: Meter_Point_Electricity_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Meter_Point_Electricity_By_PkArgs = {
  _inc?: InputMaybe<Meter_Point_Electricity_Inc_Input>
  _set?: InputMaybe<Meter_Point_Electricity_Set_Input>
  pk_columns: Meter_Point_Electricity_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Meter_Point_Electricity_ManyArgs = {
  updates: Array<Meter_Point_Electricity_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Meter_Point_GasArgs = {
  _inc?: InputMaybe<Meter_Point_Gas_Inc_Input>
  _set?: InputMaybe<Meter_Point_Gas_Set_Input>
  where: Meter_Point_Gas_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Meter_Point_Gas_By_PkArgs = {
  _inc?: InputMaybe<Meter_Point_Gas_Inc_Input>
  _set?: InputMaybe<Meter_Point_Gas_Set_Input>
  pk_columns: Meter_Point_Gas_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Meter_Point_Gas_ManyArgs = {
  updates: Array<Meter_Point_Gas_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Meter_Point_HistoryArgs = {
  _inc?: InputMaybe<Meter_Point_History_Inc_Input>
  _set?: InputMaybe<Meter_Point_History_Set_Input>
  where: Meter_Point_History_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Meter_Point_History_By_PkArgs = {
  _inc?: InputMaybe<Meter_Point_History_Inc_Input>
  _set?: InputMaybe<Meter_Point_History_Set_Input>
  pk_columns: Meter_Point_History_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Meter_Point_History_ManyArgs = {
  updates: Array<Meter_Point_History_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Meter_Point_ManyArgs = {
  updates: Array<Meter_Point_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Meter_ReadingArgs = {
  _inc?: InputMaybe<Meter_Reading_Inc_Input>
  _set?: InputMaybe<Meter_Reading_Set_Input>
  where: Meter_Reading_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Meter_Reading_By_PkArgs = {
  _inc?: InputMaybe<Meter_Reading_Inc_Input>
  _set?: InputMaybe<Meter_Reading_Set_Input>
  pk_columns: Meter_Reading_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Meter_Reading_ManyArgs = {
  updates: Array<Meter_Reading_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Meter_Reading_Submission_RequestArgs = {
  _inc?: InputMaybe<Meter_Reading_Submission_Request_Inc_Input>
  _set?: InputMaybe<Meter_Reading_Submission_Request_Set_Input>
  where: Meter_Reading_Submission_Request_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Meter_Reading_Submission_Request_By_PkArgs = {
  _inc?: InputMaybe<Meter_Reading_Submission_Request_Inc_Input>
  _set?: InputMaybe<Meter_Reading_Submission_Request_Set_Input>
  pk_columns: Meter_Reading_Submission_Request_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Meter_Reading_Submission_Request_ManyArgs = {
  updates: Array<Meter_Reading_Submission_Request_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Meter_Reading_Submission_TokensArgs = {
  _inc?: InputMaybe<Meter_Reading_Submission_Tokens_Inc_Input>
  _set?: InputMaybe<Meter_Reading_Submission_Tokens_Set_Input>
  where: Meter_Reading_Submission_Tokens_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Meter_Reading_Submission_Tokens_By_PkArgs = {
  _inc?: InputMaybe<Meter_Reading_Submission_Tokens_Inc_Input>
  _set?: InputMaybe<Meter_Reading_Submission_Tokens_Set_Input>
  pk_columns: Meter_Reading_Submission_Tokens_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Meter_Reading_Submission_Tokens_ManyArgs = {
  updates: Array<Meter_Reading_Submission_Tokens_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_NoteArgs = {
  _inc?: InputMaybe<Note_Inc_Input>
  _set?: InputMaybe<Note_Set_Input>
  where: Note_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Note_By_PkArgs = {
  _inc?: InputMaybe<Note_Inc_Input>
  _set?: InputMaybe<Note_Set_Input>
  pk_columns: Note_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Note_ManyArgs = {
  updates: Array<Note_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Nova_SubmissionsArgs = {
  _inc?: InputMaybe<Nova_Submissions_Inc_Input>
  _set?: InputMaybe<Nova_Submissions_Set_Input>
  where: Nova_Submissions_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Nova_Submissions_ManyArgs = {
  updates: Array<Nova_Submissions_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Outbound_Photo_RequestArgs = {
  _append?: InputMaybe<Outbound_Photo_Request_Append_Input>
  _delete_at_path?: InputMaybe<Outbound_Photo_Request_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Outbound_Photo_Request_Delete_Elem_Input>
  _delete_key?: InputMaybe<Outbound_Photo_Request_Delete_Key_Input>
  _inc?: InputMaybe<Outbound_Photo_Request_Inc_Input>
  _prepend?: InputMaybe<Outbound_Photo_Request_Prepend_Input>
  _set?: InputMaybe<Outbound_Photo_Request_Set_Input>
  where: Outbound_Photo_Request_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Outbound_Photo_Request_By_PkArgs = {
  _append?: InputMaybe<Outbound_Photo_Request_Append_Input>
  _delete_at_path?: InputMaybe<Outbound_Photo_Request_Delete_At_Path_Input>
  _delete_elem?: InputMaybe<Outbound_Photo_Request_Delete_Elem_Input>
  _delete_key?: InputMaybe<Outbound_Photo_Request_Delete_Key_Input>
  _inc?: InputMaybe<Outbound_Photo_Request_Inc_Input>
  _prepend?: InputMaybe<Outbound_Photo_Request_Prepend_Input>
  _set?: InputMaybe<Outbound_Photo_Request_Set_Input>
  pk_columns: Outbound_Photo_Request_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Outbound_Photo_Request_ManyArgs = {
  updates: Array<Outbound_Photo_Request_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Password_Reset_TokensArgs = {
  _inc?: InputMaybe<Password_Reset_Tokens_Inc_Input>
  _set?: InputMaybe<Password_Reset_Tokens_Set_Input>
  where: Password_Reset_Tokens_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Password_Reset_Tokens_By_PkArgs = {
  _inc?: InputMaybe<Password_Reset_Tokens_Inc_Input>
  _set?: InputMaybe<Password_Reset_Tokens_Set_Input>
  pk_columns: Password_Reset_Tokens_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Password_Reset_Tokens_ManyArgs = {
  updates: Array<Password_Reset_Tokens_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_PaymentArgs = {
  _inc?: InputMaybe<Payment_Inc_Input>
  _set?: InputMaybe<Payment_Set_Input>
  where: Payment_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Payment_By_PkArgs = {
  _inc?: InputMaybe<Payment_Inc_Input>
  _set?: InputMaybe<Payment_Set_Input>
  pk_columns: Payment_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Payment_ManyArgs = {
  updates: Array<Payment_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Payment_MethodArgs = {
  _inc?: InputMaybe<Payment_Method_Inc_Input>
  _set?: InputMaybe<Payment_Method_Set_Input>
  where: Payment_Method_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Payment_Method_By_PkArgs = {
  _inc?: InputMaybe<Payment_Method_Inc_Input>
  _set?: InputMaybe<Payment_Method_Set_Input>
  pk_columns: Payment_Method_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Payment_Method_ManyArgs = {
  updates: Array<Payment_Method_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Payment_Review_Account_Balance_Reserve_RatesArgs =
  {
    _inc?: InputMaybe<Payment_Review_Account_Balance_Reserve_Rates_Inc_Input>
    _set?: InputMaybe<Payment_Review_Account_Balance_Reserve_Rates_Set_Input>
    where: Payment_Review_Account_Balance_Reserve_Rates_Bool_Exp
  }

/** mutation root */
export type Mutation_RootUpdate_Payment_Review_Account_Balance_Reserve_Rates_By_PkArgs =
  {
    _inc?: InputMaybe<Payment_Review_Account_Balance_Reserve_Rates_Inc_Input>
    _set?: InputMaybe<Payment_Review_Account_Balance_Reserve_Rates_Set_Input>
    pk_columns: Payment_Review_Account_Balance_Reserve_Rates_Pk_Columns_Input
  }

/** mutation root */
export type Mutation_RootUpdate_Payment_Review_Account_Balance_Reserve_Rates_ManyArgs =
  {
    updates: Array<Payment_Review_Account_Balance_Reserve_Rates_Updates>
  }

/** mutation root */
export type Mutation_RootUpdate_Payment_Review_Account_ExclusionsArgs = {
  _inc?: InputMaybe<Payment_Review_Account_Exclusions_Inc_Input>
  _set?: InputMaybe<Payment_Review_Account_Exclusions_Set_Input>
  where: Payment_Review_Account_Exclusions_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Payment_Review_Account_Exclusions_By_PkArgs = {
  _inc?: InputMaybe<Payment_Review_Account_Exclusions_Inc_Input>
  _set?: InputMaybe<Payment_Review_Account_Exclusions_Set_Input>
  pk_columns: Payment_Review_Account_Exclusions_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Payment_Review_Account_Exclusions_ManyArgs = {
  updates: Array<Payment_Review_Account_Exclusions_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Payment_Review_CalculationArgs = {
  _inc?: InputMaybe<Payment_Review_Calculation_Inc_Input>
  _set?: InputMaybe<Payment_Review_Calculation_Set_Input>
  where: Payment_Review_Calculation_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Payment_Review_Calculation_By_PkArgs = {
  _inc?: InputMaybe<Payment_Review_Calculation_Inc_Input>
  _set?: InputMaybe<Payment_Review_Calculation_Set_Input>
  pk_columns: Payment_Review_Calculation_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Payment_Review_Calculation_ManyArgs = {
  updates: Array<Payment_Review_Calculation_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Payment_Review_Future_Product_RatesArgs = {
  _inc?: InputMaybe<Payment_Review_Future_Product_Rates_Inc_Input>
  _set?: InputMaybe<Payment_Review_Future_Product_Rates_Set_Input>
  where: Payment_Review_Future_Product_Rates_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Payment_Review_Future_Product_Rates_By_PkArgs =
  {
    _inc?: InputMaybe<Payment_Review_Future_Product_Rates_Inc_Input>
    _set?: InputMaybe<Payment_Review_Future_Product_Rates_Set_Input>
    pk_columns: Payment_Review_Future_Product_Rates_Pk_Columns_Input
  }

/** mutation root */
export type Mutation_RootUpdate_Payment_Review_Future_Product_Rates_ManyArgs = {
  updates: Array<Payment_Review_Future_Product_Rates_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Payment_Review_Record_EmailsArgs = {
  _inc?: InputMaybe<Payment_Review_Record_Emails_Inc_Input>
  _set?: InputMaybe<Payment_Review_Record_Emails_Set_Input>
  where: Payment_Review_Record_Emails_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Payment_Review_Record_Emails_By_PkArgs = {
  _inc?: InputMaybe<Payment_Review_Record_Emails_Inc_Input>
  _set?: InputMaybe<Payment_Review_Record_Emails_Set_Input>
  pk_columns: Payment_Review_Record_Emails_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Payment_Review_Record_Emails_ManyArgs = {
  updates: Array<Payment_Review_Record_Emails_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Payment_Review_Record_NotesArgs = {
  _inc?: InputMaybe<Payment_Review_Record_Notes_Inc_Input>
  _set?: InputMaybe<Payment_Review_Record_Notes_Set_Input>
  where: Payment_Review_Record_Notes_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Payment_Review_Record_Notes_By_PkArgs = {
  _inc?: InputMaybe<Payment_Review_Record_Notes_Inc_Input>
  _set?: InputMaybe<Payment_Review_Record_Notes_Set_Input>
  pk_columns: Payment_Review_Record_Notes_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Payment_Review_Record_Notes_ManyArgs = {
  updates: Array<Payment_Review_Record_Notes_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Payment_Review_RecordsArgs = {
  _inc?: InputMaybe<Payment_Review_Records_Inc_Input>
  _set?: InputMaybe<Payment_Review_Records_Set_Input>
  where: Payment_Review_Records_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Payment_Review_Records_By_PkArgs = {
  _inc?: InputMaybe<Payment_Review_Records_Inc_Input>
  _set?: InputMaybe<Payment_Review_Records_Set_Input>
  pk_columns: Payment_Review_Records_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Payment_Review_Records_ManyArgs = {
  updates: Array<Payment_Review_Records_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Payment_ReviewsArgs = {
  _inc?: InputMaybe<Payment_Reviews_Inc_Input>
  _set?: InputMaybe<Payment_Reviews_Set_Input>
  where: Payment_Reviews_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Payment_Reviews_By_PkArgs = {
  _inc?: InputMaybe<Payment_Reviews_Inc_Input>
  _set?: InputMaybe<Payment_Reviews_Set_Input>
  pk_columns: Payment_Reviews_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Payment_Reviews_ManyArgs = {
  updates: Array<Payment_Reviews_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Payment_ScheduleArgs = {
  _inc?: InputMaybe<Payment_Schedule_Inc_Input>
  _set?: InputMaybe<Payment_Schedule_Set_Input>
  where: Payment_Schedule_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Payment_Schedule_By_PkArgs = {
  _inc?: InputMaybe<Payment_Schedule_Inc_Input>
  _set?: InputMaybe<Payment_Schedule_Set_Input>
  pk_columns: Payment_Schedule_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Payment_Schedule_ManyArgs = {
  updates: Array<Payment_Schedule_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Postcode_Gsp_CacheArgs = {
  _inc?: InputMaybe<Postcode_Gsp_Cache_Inc_Input>
  _set?: InputMaybe<Postcode_Gsp_Cache_Set_Input>
  where: Postcode_Gsp_Cache_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Postcode_Gsp_Cache_By_PkArgs = {
  _inc?: InputMaybe<Postcode_Gsp_Cache_Inc_Input>
  _set?: InputMaybe<Postcode_Gsp_Cache_Set_Input>
  pk_columns: Postcode_Gsp_Cache_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Postcode_Gsp_Cache_ManyArgs = {
  updates: Array<Postcode_Gsp_Cache_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_ProductArgs = {
  _inc?: InputMaybe<Product_Inc_Input>
  _set?: InputMaybe<Product_Set_Input>
  where: Product_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Product_AccountArgs = {
  _inc?: InputMaybe<Product_Account_Inc_Input>
  _set?: InputMaybe<Product_Account_Set_Input>
  where: Product_Account_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Product_Account_Agreement_RelArgs = {
  _inc?: InputMaybe<Product_Account_Agreement_Rel_Inc_Input>
  _set?: InputMaybe<Product_Account_Agreement_Rel_Set_Input>
  where: Product_Account_Agreement_Rel_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Product_Account_Agreement_Rel_By_PkArgs = {
  _inc?: InputMaybe<Product_Account_Agreement_Rel_Inc_Input>
  _set?: InputMaybe<Product_Account_Agreement_Rel_Set_Input>
  pk_columns: Product_Account_Agreement_Rel_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Product_Account_Agreement_Rel_ManyArgs = {
  updates: Array<Product_Account_Agreement_Rel_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Product_Account_By_PkArgs = {
  _inc?: InputMaybe<Product_Account_Inc_Input>
  _set?: InputMaybe<Product_Account_Set_Input>
  pk_columns: Product_Account_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Product_Account_ManyArgs = {
  updates: Array<Product_Account_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Product_By_PkArgs = {
  _inc?: InputMaybe<Product_Inc_Input>
  _set?: InputMaybe<Product_Set_Input>
  pk_columns: Product_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Product_ElecArgs = {
  _inc?: InputMaybe<Product_Elec_Inc_Input>
  _set?: InputMaybe<Product_Elec_Set_Input>
  where: Product_Elec_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Product_Elec_By_PkArgs = {
  _inc?: InputMaybe<Product_Elec_Inc_Input>
  _set?: InputMaybe<Product_Elec_Set_Input>
  pk_columns: Product_Elec_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Product_Elec_ManyArgs = {
  updates: Array<Product_Elec_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Product_GasArgs = {
  _inc?: InputMaybe<Product_Gas_Inc_Input>
  _set?: InputMaybe<Product_Gas_Set_Input>
  where: Product_Gas_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Product_Gas_By_PkArgs = {
  _inc?: InputMaybe<Product_Gas_Inc_Input>
  _set?: InputMaybe<Product_Gas_Set_Input>
  pk_columns: Product_Gas_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Product_Gas_ManyArgs = {
  updates: Array<Product_Gas_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Product_ManyArgs = {
  updates: Array<Product_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Product_VariantArgs = {
  _inc?: InputMaybe<Product_Variant_Inc_Input>
  _set?: InputMaybe<Product_Variant_Set_Input>
  where: Product_Variant_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Product_Variant_By_PkArgs = {
  _inc?: InputMaybe<Product_Variant_Inc_Input>
  _set?: InputMaybe<Product_Variant_Set_Input>
  pk_columns: Product_Variant_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Product_Variant_ElecArgs = {
  _inc?: InputMaybe<Product_Variant_Elec_Inc_Input>
  _set?: InputMaybe<Product_Variant_Elec_Set_Input>
  where: Product_Variant_Elec_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Product_Variant_Elec_By_PkArgs = {
  _inc?: InputMaybe<Product_Variant_Elec_Inc_Input>
  _set?: InputMaybe<Product_Variant_Elec_Set_Input>
  pk_columns: Product_Variant_Elec_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Product_Variant_Elec_ManyArgs = {
  updates: Array<Product_Variant_Elec_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Product_Variant_GasArgs = {
  _inc?: InputMaybe<Product_Variant_Gas_Inc_Input>
  _set?: InputMaybe<Product_Variant_Gas_Set_Input>
  where: Product_Variant_Gas_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Product_Variant_Gas_By_PkArgs = {
  _inc?: InputMaybe<Product_Variant_Gas_Inc_Input>
  _set?: InputMaybe<Product_Variant_Gas_Set_Input>
  pk_columns: Product_Variant_Gas_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Product_Variant_Gas_ManyArgs = {
  updates: Array<Product_Variant_Gas_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Product_Variant_ManyArgs = {
  updates: Array<Product_Variant_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_PropertyArgs = {
  _inc?: InputMaybe<Property_Inc_Input>
  _set?: InputMaybe<Property_Set_Input>
  where: Property_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Property_By_PkArgs = {
  _inc?: InputMaybe<Property_Inc_Input>
  _set?: InputMaybe<Property_Set_Input>
  pk_columns: Property_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Property_ManyArgs = {
  updates: Array<Property_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_PsrArgs = {
  _inc?: InputMaybe<Psr_Inc_Input>
  _set?: InputMaybe<Psr_Set_Input>
  where: Psr_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Psr_By_PkArgs = {
  _inc?: InputMaybe<Psr_Inc_Input>
  _set?: InputMaybe<Psr_Set_Input>
  pk_columns: Psr_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Psr_ManyArgs = {
  updates: Array<Psr_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_QuoteArgs = {
  _inc?: InputMaybe<Quote_Inc_Input>
  _set?: InputMaybe<Quote_Set_Input>
  where: Quote_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Quote_By_PkArgs = {
  _inc?: InputMaybe<Quote_Inc_Input>
  _set?: InputMaybe<Quote_Set_Input>
  pk_columns: Quote_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Quote_ManyArgs = {
  updates: Array<Quote_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Quote_RequestArgs = {
  _inc?: InputMaybe<Quote_Request_Inc_Input>
  _set?: InputMaybe<Quote_Request_Set_Input>
  where: Quote_Request_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Quote_Request_By_PkArgs = {
  _inc?: InputMaybe<Quote_Request_Inc_Input>
  _set?: InputMaybe<Quote_Request_Set_Input>
  pk_columns: Quote_Request_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Quote_Request_ManyArgs = {
  updates: Array<Quote_Request_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_RecipientsArgs = {
  _inc?: InputMaybe<Recipients_Inc_Input>
  _set?: InputMaybe<Recipients_Set_Input>
  where: Recipients_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Recipients_By_PkArgs = {
  _inc?: InputMaybe<Recipients_Inc_Input>
  _set?: InputMaybe<Recipients_Set_Input>
  pk_columns: Recipients_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Recipients_ManyArgs = {
  updates: Array<Recipients_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Refresh_TokensArgs = {
  _inc?: InputMaybe<Refresh_Tokens_Inc_Input>
  _set?: InputMaybe<Refresh_Tokens_Set_Input>
  where: Refresh_Tokens_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Refresh_Tokens_ManyArgs = {
  updates: Array<Refresh_Tokens_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_RefundsArgs = {
  _inc?: InputMaybe<Refunds_Inc_Input>
  _set?: InputMaybe<Refunds_Set_Input>
  where: Refunds_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Refunds_By_PkArgs = {
  _inc?: InputMaybe<Refunds_Inc_Input>
  _set?: InputMaybe<Refunds_Set_Input>
  pk_columns: Refunds_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Refunds_ManyArgs = {
  updates: Array<Refunds_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_RegisterArgs = {
  _inc?: InputMaybe<Register_Inc_Input>
  _set?: InputMaybe<Register_Set_Input>
  where: Register_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Register_By_PkArgs = {
  _inc?: InputMaybe<Register_Inc_Input>
  _set?: InputMaybe<Register_Set_Input>
  pk_columns: Register_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Register_ManyArgs = {
  updates: Array<Register_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Registration_Credit_CheckArgs = {
  _inc?: InputMaybe<Registration_Credit_Check_Inc_Input>
  _set?: InputMaybe<Registration_Credit_Check_Set_Input>
  where: Registration_Credit_Check_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Registration_Credit_Check_AddressArgs = {
  _inc?: InputMaybe<Registration_Credit_Check_Address_Inc_Input>
  _set?: InputMaybe<Registration_Credit_Check_Address_Set_Input>
  where: Registration_Credit_Check_Address_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Registration_Credit_Check_Address_By_PkArgs = {
  _inc?: InputMaybe<Registration_Credit_Check_Address_Inc_Input>
  _set?: InputMaybe<Registration_Credit_Check_Address_Set_Input>
  pk_columns: Registration_Credit_Check_Address_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Registration_Credit_Check_Address_ManyArgs = {
  updates: Array<Registration_Credit_Check_Address_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Registration_Credit_Check_By_PkArgs = {
  _inc?: InputMaybe<Registration_Credit_Check_Inc_Input>
  _set?: InputMaybe<Registration_Credit_Check_Set_Input>
  pk_columns: Registration_Credit_Check_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Registration_Credit_Check_ManyArgs = {
  updates: Array<Registration_Credit_Check_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_ReminderArgs = {
  _inc?: InputMaybe<Reminder_Inc_Input>
  _set?: InputMaybe<Reminder_Set_Input>
  where: Reminder_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Reminder_By_PkArgs = {
  _inc?: InputMaybe<Reminder_Inc_Input>
  _set?: InputMaybe<Reminder_Set_Input>
  pk_columns: Reminder_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Reminder_ManyArgs = {
  updates: Array<Reminder_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_RenewalArgs = {
  _inc?: InputMaybe<Renewal_Inc_Input>
  _set?: InputMaybe<Renewal_Set_Input>
  where: Renewal_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Renewal_By_PkArgs = {
  _inc?: InputMaybe<Renewal_Inc_Input>
  _set?: InputMaybe<Renewal_Set_Input>
  pk_columns: Renewal_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Renewal_ManyArgs = {
  updates: Array<Renewal_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Report_ProblemArgs = {
  _inc?: InputMaybe<Report_Problem_Inc_Input>
  _set?: InputMaybe<Report_Problem_Set_Input>
  where: Report_Problem_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Report_Problem_AttachmentsArgs = {
  _inc?: InputMaybe<Report_Problem_Attachments_Inc_Input>
  _set?: InputMaybe<Report_Problem_Attachments_Set_Input>
  where: Report_Problem_Attachments_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Report_Problem_Attachments_By_PkArgs = {
  _inc?: InputMaybe<Report_Problem_Attachments_Inc_Input>
  _set?: InputMaybe<Report_Problem_Attachments_Set_Input>
  pk_columns: Report_Problem_Attachments_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Report_Problem_Attachments_ManyArgs = {
  updates: Array<Report_Problem_Attachments_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Report_Problem_By_PkArgs = {
  _inc?: InputMaybe<Report_Problem_Inc_Input>
  _set?: InputMaybe<Report_Problem_Set_Input>
  pk_columns: Report_Problem_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Report_Problem_ManyArgs = {
  updates: Array<Report_Problem_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_RequestsArgs = {
  _inc?: InputMaybe<Requests_Inc_Input>
  _set?: InputMaybe<Requests_Set_Input>
  where: Requests_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Requests_By_PkArgs = {
  _inc?: InputMaybe<Requests_Inc_Input>
  _set?: InputMaybe<Requests_Set_Input>
  pk_columns: Requests_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Requests_ManyArgs = {
  updates: Array<Requests_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Rts_Meters_ReportArgs = {
  _inc?: InputMaybe<Rts_Meters_Report_Inc_Input>
  _set?: InputMaybe<Rts_Meters_Report_Set_Input>
  where: Rts_Meters_Report_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Rts_Meters_Report_ManyArgs = {
  updates: Array<Rts_Meters_Report_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Scheduled_PaymentArgs = {
  _inc?: InputMaybe<Scheduled_Payment_Inc_Input>
  _set?: InputMaybe<Scheduled_Payment_Set_Input>
  where: Scheduled_Payment_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Scheduled_Payment_By_PkArgs = {
  _inc?: InputMaybe<Scheduled_Payment_Inc_Input>
  _set?: InputMaybe<Scheduled_Payment_Set_Input>
  pk_columns: Scheduled_Payment_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Scheduled_Payment_ManyArgs = {
  updates: Array<Scheduled_Payment_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Scheduled_RefundArgs = {
  _inc?: InputMaybe<Scheduled_Refund_Inc_Input>
  _set?: InputMaybe<Scheduled_Refund_Set_Input>
  where: Scheduled_Refund_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Scheduled_Refund_By_PkArgs = {
  _inc?: InputMaybe<Scheduled_Refund_Inc_Input>
  _set?: InputMaybe<Scheduled_Refund_Set_Input>
  pk_columns: Scheduled_Refund_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Scheduled_Refund_ManyArgs = {
  updates: Array<Scheduled_Refund_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Smart_ChargingArgs = {
  _inc?: InputMaybe<Smart_Charging_Inc_Input>
  _set?: InputMaybe<Smart_Charging_Set_Input>
  where: Smart_Charging_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Smart_Charging_By_PkArgs = {
  _inc?: InputMaybe<Smart_Charging_Inc_Input>
  _set?: InputMaybe<Smart_Charging_Set_Input>
  pk_columns: Smart_Charging_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Smart_Charging_ManyArgs = {
  updates: Array<Smart_Charging_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Smart_Meter_Dashboard_Response_V7Args = {
  _inc?: InputMaybe<Smart_Meter_Dashboard_Response_V7_Inc_Input>
  _set?: InputMaybe<Smart_Meter_Dashboard_Response_V7_Set_Input>
  where: Smart_Meter_Dashboard_Response_V7_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Smart_Meter_Dashboard_Response_V7_ManyArgs = {
  updates: Array<Smart_Meter_Dashboard_Response_V7_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Smart_Meters_Eligible_For_ExchangeArgs = {
  _set?: InputMaybe<Smart_Meters_Eligible_For_Exchange_Set_Input>
  where: Smart_Meters_Eligible_For_Exchange_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Smart_Meters_Eligible_For_Exchange_By_PkArgs = {
  _set?: InputMaybe<Smart_Meters_Eligible_For_Exchange_Set_Input>
  pk_columns: Smart_Meters_Eligible_For_Exchange_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Smart_Meters_Eligible_For_Exchange_ManyArgs = {
  updates: Array<Smart_Meters_Eligible_For_Exchange_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Sync_StatusArgs = {
  _inc?: InputMaybe<Sync_Status_Inc_Input>
  _set?: InputMaybe<Sync_Status_Set_Input>
  where: Sync_Status_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Sync_Status_By_PkArgs = {
  _inc?: InputMaybe<Sync_Status_Inc_Input>
  _set?: InputMaybe<Sync_Status_Set_Input>
  pk_columns: Sync_Status_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Sync_Status_ManyArgs = {
  updates: Array<Sync_Status_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Synchronized_AccountsArgs = {
  _inc?: InputMaybe<Synchronized_Accounts_Inc_Input>
  _set?: InputMaybe<Synchronized_Accounts_Set_Input>
  where: Synchronized_Accounts_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Synchronized_Accounts_By_PkArgs = {
  _inc?: InputMaybe<Synchronized_Accounts_Inc_Input>
  _set?: InputMaybe<Synchronized_Accounts_Set_Input>
  pk_columns: Synchronized_Accounts_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Synchronized_Accounts_ManyArgs = {
  updates: Array<Synchronized_Accounts_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_TicketArgs = {
  _inc?: InputMaybe<Ticket_Inc_Input>
  _set?: InputMaybe<Ticket_Set_Input>
  where: Ticket_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Ticket_By_PkArgs = {
  _inc?: InputMaybe<Ticket_Inc_Input>
  _set?: InputMaybe<Ticket_Set_Input>
  pk_columns: Ticket_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Ticket_ManyArgs = {
  updates: Array<Ticket_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Account_StoreArgs = {
  _inc?: InputMaybe<Tickets_Automation_Account_Store_Inc_Input>
  _set?: InputMaybe<Tickets_Automation_Account_Store_Set_Input>
  where: Tickets_Automation_Account_Store_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Account_Store_By_PkArgs = {
  _inc?: InputMaybe<Tickets_Automation_Account_Store_Inc_Input>
  _set?: InputMaybe<Tickets_Automation_Account_Store_Set_Input>
  pk_columns: Tickets_Automation_Account_Store_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Account_Store_ManyArgs = {
  updates: Array<Tickets_Automation_Account_Store_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_ConfigArgs = {
  _inc?: InputMaybe<Tickets_Automation_Config_Inc_Input>
  _set?: InputMaybe<Tickets_Automation_Config_Set_Input>
  where: Tickets_Automation_Config_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Config_By_PkArgs = {
  _inc?: InputMaybe<Tickets_Automation_Config_Inc_Input>
  _set?: InputMaybe<Tickets_Automation_Config_Set_Input>
  pk_columns: Tickets_Automation_Config_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Config_DefaultArgs = {
  _inc?: InputMaybe<Tickets_Automation_Config_Default_Inc_Input>
  _set?: InputMaybe<Tickets_Automation_Config_Default_Set_Input>
  where: Tickets_Automation_Config_Default_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Config_Default_By_PkArgs = {
  _inc?: InputMaybe<Tickets_Automation_Config_Default_Inc_Input>
  _set?: InputMaybe<Tickets_Automation_Config_Default_Set_Input>
  pk_columns: Tickets_Automation_Config_Default_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Config_Default_ManyArgs = {
  updates: Array<Tickets_Automation_Config_Default_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Config_ManyArgs = {
  updates: Array<Tickets_Automation_Config_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Config_PurgeArgs = {
  _inc?: InputMaybe<Tickets_Automation_Config_Purge_Inc_Input>
  _set?: InputMaybe<Tickets_Automation_Config_Purge_Set_Input>
  where: Tickets_Automation_Config_Purge_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Config_Purge_By_PkArgs = {
  _inc?: InputMaybe<Tickets_Automation_Config_Purge_Inc_Input>
  _set?: InputMaybe<Tickets_Automation_Config_Purge_Set_Input>
  pk_columns: Tickets_Automation_Config_Purge_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Config_Purge_ManyArgs = {
  updates: Array<Tickets_Automation_Config_Purge_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Default_Ticket_ActionArgs = {
  _inc?: InputMaybe<Tickets_Automation_Default_Ticket_Action_Inc_Input>
  _set?: InputMaybe<Tickets_Automation_Default_Ticket_Action_Set_Input>
  where: Tickets_Automation_Default_Ticket_Action_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Default_Ticket_Action_By_PkArgs =
  {
    _inc?: InputMaybe<Tickets_Automation_Default_Ticket_Action_Inc_Input>
    _set?: InputMaybe<Tickets_Automation_Default_Ticket_Action_Set_Input>
    pk_columns: Tickets_Automation_Default_Ticket_Action_Pk_Columns_Input
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Default_Ticket_Action_ManyArgs =
  {
    updates: Array<Tickets_Automation_Default_Ticket_Action_Updates>
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Defaults_Acceptable_Accounts_TableArgs =
  {
    _inc?: InputMaybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Inc_Input>
    _set?: InputMaybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Set_Input>
    where: Tickets_Automation_Defaults_Acceptable_Accounts_Table_Bool_Exp
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Defaults_Acceptable_Accounts_Table_By_PkArgs =
  {
    _inc?: InputMaybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Inc_Input>
    _set?: InputMaybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Set_Input>
    pk_columns: Tickets_Automation_Defaults_Acceptable_Accounts_Table_Pk_Columns_Input
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Defaults_Acceptable_Accounts_Table_ManyArgs =
  {
    updates: Array<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Updates>
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Defaults_Opened_PredefaultsArgs =
  {
    _inc?: InputMaybe<Tickets_Automation_Defaults_Opened_Predefaults_Inc_Input>
    _set?: InputMaybe<Tickets_Automation_Defaults_Opened_Predefaults_Set_Input>
    where: Tickets_Automation_Defaults_Opened_Predefaults_Bool_Exp
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Defaults_Opened_Predefaults_By_PkArgs =
  {
    _inc?: InputMaybe<Tickets_Automation_Defaults_Opened_Predefaults_Inc_Input>
    _set?: InputMaybe<Tickets_Automation_Defaults_Opened_Predefaults_Set_Input>
    pk_columns: Tickets_Automation_Defaults_Opened_Predefaults_Pk_Columns_Input
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Defaults_Opened_Predefaults_ManyArgs =
  {
    updates: Array<Tickets_Automation_Defaults_Opened_Predefaults_Updates>
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_JobArgs = {
  _inc?: InputMaybe<Tickets_Automation_Job_Inc_Input>
  _set?: InputMaybe<Tickets_Automation_Job_Set_Input>
  where: Tickets_Automation_Job_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Job_By_PkArgs = {
  _inc?: InputMaybe<Tickets_Automation_Job_Inc_Input>
  _set?: InputMaybe<Tickets_Automation_Job_Set_Input>
  pk_columns: Tickets_Automation_Job_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Job_ManyArgs = {
  updates: Array<Tickets_Automation_Job_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Purge_JobArgs = {
  _inc?: InputMaybe<Tickets_Automation_Purge_Job_Inc_Input>
  _set?: InputMaybe<Tickets_Automation_Purge_Job_Set_Input>
  where: Tickets_Automation_Purge_Job_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Purge_Job_By_PkArgs = {
  _inc?: InputMaybe<Tickets_Automation_Purge_Job_Inc_Input>
  _set?: InputMaybe<Tickets_Automation_Purge_Job_Set_Input>
  pk_columns: Tickets_Automation_Purge_Job_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Purge_Job_ManyArgs = {
  updates: Array<Tickets_Automation_Purge_Job_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Ticket_StoreArgs = {
  _inc?: InputMaybe<Tickets_Automation_Ticket_Store_Inc_Input>
  _set?: InputMaybe<Tickets_Automation_Ticket_Store_Set_Input>
  where: Tickets_Automation_Ticket_Store_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Ticket_Store_By_PkArgs = {
  _inc?: InputMaybe<Tickets_Automation_Ticket_Store_Inc_Input>
  _set?: InputMaybe<Tickets_Automation_Ticket_Store_Set_Input>
  pk_columns: Tickets_Automation_Ticket_Store_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Automation_Ticket_Store_ManyArgs = {
  updates: Array<Tickets_Automation_Ticket_Store_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dca_Account_AllocationArgs = {
  _inc?: InputMaybe<Tickets_Dca_Account_Allocation_Inc_Input>
  _set?: InputMaybe<Tickets_Dca_Account_Allocation_Set_Input>
  where: Tickets_Dca_Account_Allocation_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dca_Account_Allocation_By_PkArgs = {
  _inc?: InputMaybe<Tickets_Dca_Account_Allocation_Inc_Input>
  _set?: InputMaybe<Tickets_Dca_Account_Allocation_Set_Input>
  pk_columns: Tickets_Dca_Account_Allocation_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dca_Account_Allocation_ManyArgs = {
  updates: Array<Tickets_Dca_Account_Allocation_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dca_Allocation_ConfigurationArgs = {
  _inc?: InputMaybe<Tickets_Dca_Allocation_Configuration_Inc_Input>
  _set?: InputMaybe<Tickets_Dca_Allocation_Configuration_Set_Input>
  where: Tickets_Dca_Allocation_Configuration_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dca_Allocation_Configuration_By_PkArgs =
  {
    _inc?: InputMaybe<Tickets_Dca_Allocation_Configuration_Inc_Input>
    _set?: InputMaybe<Tickets_Dca_Allocation_Configuration_Set_Input>
    pk_columns: Tickets_Dca_Allocation_Configuration_Pk_Columns_Input
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dca_Allocation_Configuration_ManyArgs =
  {
    updates: Array<Tickets_Dca_Allocation_Configuration_Updates>
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dca_Configuration_V2Args = {
  _set?: InputMaybe<Tickets_Dca_Configuration_V2_Set_Input>
  where: Tickets_Dca_Configuration_V2_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dca_Configuration_V2_By_PkArgs = {
  _set?: InputMaybe<Tickets_Dca_Configuration_V2_Set_Input>
  pk_columns: Tickets_Dca_Configuration_V2_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dca_Configuration_V2_ManyArgs = {
  updates: Array<Tickets_Dca_Configuration_V2_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dca_SegmentationArgs = {
  _inc?: InputMaybe<Tickets_Dca_Segmentation_Inc_Input>
  _set?: InputMaybe<Tickets_Dca_Segmentation_Set_Input>
  where: Tickets_Dca_Segmentation_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dca_Segmentation_By_PkArgs = {
  _inc?: InputMaybe<Tickets_Dca_Segmentation_Inc_Input>
  _set?: InputMaybe<Tickets_Dca_Segmentation_Set_Input>
  pk_columns: Tickets_Dca_Segmentation_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dca_Segmentation_ManyArgs = {
  updates: Array<Tickets_Dca_Segmentation_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Account_StoreArgs = {
  _inc?: InputMaybe<Tickets_Dunning_Account_Store_Inc_Input>
  _set?: InputMaybe<Tickets_Dunning_Account_Store_Set_Input>
  where: Tickets_Dunning_Account_Store_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Account_Store_By_PkArgs = {
  _inc?: InputMaybe<Tickets_Dunning_Account_Store_Inc_Input>
  _set?: InputMaybe<Tickets_Dunning_Account_Store_Set_Input>
  pk_columns: Tickets_Dunning_Account_Store_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Account_Store_ManyArgs = {
  updates: Array<Tickets_Dunning_Account_Store_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Addacs_Review_RecordsArgs = {
  _inc?: InputMaybe<Tickets_Dunning_Addacs_Review_Records_Inc_Input>
  _set?: InputMaybe<Tickets_Dunning_Addacs_Review_Records_Set_Input>
  where: Tickets_Dunning_Addacs_Review_Records_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Addacs_Review_Records_By_PkArgs =
  {
    _inc?: InputMaybe<Tickets_Dunning_Addacs_Review_Records_Inc_Input>
    _set?: InputMaybe<Tickets_Dunning_Addacs_Review_Records_Set_Input>
    pk_columns: Tickets_Dunning_Addacs_Review_Records_Pk_Columns_Input
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Addacs_Review_Records_ManyArgs =
  {
    updates: Array<Tickets_Dunning_Addacs_Review_Records_Updates>
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Automation_EventsArgs = {
  _inc?: InputMaybe<Tickets_Dunning_Automation_Events_Inc_Input>
  _set?: InputMaybe<Tickets_Dunning_Automation_Events_Set_Input>
  where: Tickets_Dunning_Automation_Events_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Automation_Events_By_PkArgs = {
  _inc?: InputMaybe<Tickets_Dunning_Automation_Events_Inc_Input>
  _set?: InputMaybe<Tickets_Dunning_Automation_Events_Set_Input>
  pk_columns: Tickets_Dunning_Automation_Events_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Automation_Events_ManyArgs = {
  updates: Array<Tickets_Dunning_Automation_Events_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Debt_Ticket_Review_RecordsArgs =
  {
    _inc?: InputMaybe<Tickets_Dunning_Debt_Ticket_Review_Records_Inc_Input>
    _set?: InputMaybe<Tickets_Dunning_Debt_Ticket_Review_Records_Set_Input>
    where: Tickets_Dunning_Debt_Ticket_Review_Records_Bool_Exp
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Debt_Ticket_Review_Records_By_PkArgs =
  {
    _inc?: InputMaybe<Tickets_Dunning_Debt_Ticket_Review_Records_Inc_Input>
    _set?: InputMaybe<Tickets_Dunning_Debt_Ticket_Review_Records_Set_Input>
    pk_columns: Tickets_Dunning_Debt_Ticket_Review_Records_Pk_Columns_Input
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Debt_Ticket_Review_Records_ManyArgs =
  {
    updates: Array<Tickets_Dunning_Debt_Ticket_Review_Records_Updates>
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_JobArgs = {
  _inc?: InputMaybe<Tickets_Dunning_Job_Inc_Input>
  _set?: InputMaybe<Tickets_Dunning_Job_Set_Input>
  where: Tickets_Dunning_Job_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Job_By_PkArgs = {
  _inc?: InputMaybe<Tickets_Dunning_Job_Inc_Input>
  _set?: InputMaybe<Tickets_Dunning_Job_Set_Input>
  pk_columns: Tickets_Dunning_Job_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Job_ManyArgs = {
  updates: Array<Tickets_Dunning_Job_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Legal_Known_Ticket_RecordsArgs =
  {
    _inc?: InputMaybe<Tickets_Dunning_Legal_Known_Ticket_Records_Inc_Input>
    _set?: InputMaybe<Tickets_Dunning_Legal_Known_Ticket_Records_Set_Input>
    where: Tickets_Dunning_Legal_Known_Ticket_Records_Bool_Exp
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Legal_Known_Ticket_Records_By_PkArgs =
  {
    _inc?: InputMaybe<Tickets_Dunning_Legal_Known_Ticket_Records_Inc_Input>
    _set?: InputMaybe<Tickets_Dunning_Legal_Known_Ticket_Records_Set_Input>
    pk_columns: Tickets_Dunning_Legal_Known_Ticket_Records_Pk_Columns_Input
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Legal_Known_Ticket_Records_ManyArgs =
  {
    updates: Array<Tickets_Dunning_Legal_Known_Ticket_Records_Updates>
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Legal_Occupier_Ticket_RecordsArgs =
  {
    _inc?: InputMaybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Inc_Input>
    _set?: InputMaybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Set_Input>
    where: Tickets_Dunning_Legal_Occupier_Ticket_Records_Bool_Exp
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Legal_Occupier_Ticket_Records_By_PkArgs =
  {
    _inc?: InputMaybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Inc_Input>
    _set?: InputMaybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Set_Input>
    pk_columns: Tickets_Dunning_Legal_Occupier_Ticket_Records_Pk_Columns_Input
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Legal_Occupier_Ticket_Records_ManyArgs =
  {
    updates: Array<Tickets_Dunning_Legal_Occupier_Ticket_Records_Updates>
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Occupier_Accounts_Review_RecordsArgs =
  {
    _inc?: InputMaybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Inc_Input>
    _set?: InputMaybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Set_Input>
    where: Tickets_Dunning_Occupier_Accounts_Review_Records_Bool_Exp
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Occupier_Accounts_Review_Records_By_PkArgs =
  {
    _inc?: InputMaybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Inc_Input>
    _set?: InputMaybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Set_Input>
    pk_columns: Tickets_Dunning_Occupier_Accounts_Review_Records_Pk_Columns_Input
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Occupier_Accounts_Review_Records_ManyArgs =
  {
    updates: Array<Tickets_Dunning_Occupier_Accounts_Review_Records_Updates>
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Purge_JobArgs = {
  _inc?: InputMaybe<Tickets_Dunning_Purge_Job_Inc_Input>
  _set?: InputMaybe<Tickets_Dunning_Purge_Job_Set_Input>
  where: Tickets_Dunning_Purge_Job_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Purge_Job_By_PkArgs = {
  _inc?: InputMaybe<Tickets_Dunning_Purge_Job_Inc_Input>
  _set?: InputMaybe<Tickets_Dunning_Purge_Job_Set_Input>
  pk_columns: Tickets_Dunning_Purge_Job_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Purge_Job_ManyArgs = {
  updates: Array<Tickets_Dunning_Purge_Job_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Standard_Ticket_RecordsArgs = {
  _inc?: InputMaybe<Tickets_Dunning_Standard_Ticket_Records_Inc_Input>
  _set?: InputMaybe<Tickets_Dunning_Standard_Ticket_Records_Set_Input>
  where: Tickets_Dunning_Standard_Ticket_Records_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Standard_Ticket_Records_By_PkArgs =
  {
    _inc?: InputMaybe<Tickets_Dunning_Standard_Ticket_Records_Inc_Input>
    _set?: InputMaybe<Tickets_Dunning_Standard_Ticket_Records_Set_Input>
    pk_columns: Tickets_Dunning_Standard_Ticket_Records_Pk_Columns_Input
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Standard_Ticket_Records_ManyArgs =
  {
    updates: Array<Tickets_Dunning_Standard_Ticket_Records_Updates>
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_StatisticsArgs = {
  _inc?: InputMaybe<Tickets_Dunning_Statistics_Inc_Input>
  _set?: InputMaybe<Tickets_Dunning_Statistics_Set_Input>
  where: Tickets_Dunning_Statistics_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Statistics_By_PkArgs = {
  _inc?: InputMaybe<Tickets_Dunning_Statistics_Inc_Input>
  _set?: InputMaybe<Tickets_Dunning_Statistics_Set_Input>
  pk_columns: Tickets_Dunning_Statistics_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Statistics_ManyArgs = {
  updates: Array<Tickets_Dunning_Statistics_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Terminating_Accounts_Review_RecordsArgs =
  {
    _inc?: InputMaybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Inc_Input>
    _set?: InputMaybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Set_Input>
    where: Tickets_Dunning_Terminating_Accounts_Review_Records_Bool_Exp
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Terminating_Accounts_Review_Records_By_PkArgs =
  {
    _inc?: InputMaybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Inc_Input>
    _set?: InputMaybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Set_Input>
    pk_columns: Tickets_Dunning_Terminating_Accounts_Review_Records_Pk_Columns_Input
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Terminating_Accounts_Review_Records_ManyArgs =
  {
    updates: Array<Tickets_Dunning_Terminating_Accounts_Review_Records_Updates>
  }

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Ticket_StoreArgs = {
  _inc?: InputMaybe<Tickets_Dunning_Ticket_Store_Inc_Input>
  _set?: InputMaybe<Tickets_Dunning_Ticket_Store_Set_Input>
  where: Tickets_Dunning_Ticket_Store_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Ticket_Store_By_PkArgs = {
  _inc?: InputMaybe<Tickets_Dunning_Ticket_Store_Inc_Input>
  _set?: InputMaybe<Tickets_Dunning_Ticket_Store_Set_Input>
  pk_columns: Tickets_Dunning_Ticket_Store_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Ticket_Store_ManyArgs = {
  updates: Array<Tickets_Dunning_Ticket_Store_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_WorkflowArgs = {
  _inc?: InputMaybe<Tickets_Dunning_Workflow_Inc_Input>
  _set?: InputMaybe<Tickets_Dunning_Workflow_Set_Input>
  where: Tickets_Dunning_Workflow_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Workflow_By_PkArgs = {
  _inc?: InputMaybe<Tickets_Dunning_Workflow_Inc_Input>
  _set?: InputMaybe<Tickets_Dunning_Workflow_Set_Input>
  pk_columns: Tickets_Dunning_Workflow_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Dunning_Workflow_ManyArgs = {
  updates: Array<Tickets_Dunning_Workflow_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_External_EventArgs = {
  _inc?: InputMaybe<Tickets_External_Event_Inc_Input>
  _set?: InputMaybe<Tickets_External_Event_Set_Input>
  where: Tickets_External_Event_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_External_Event_By_PkArgs = {
  _inc?: InputMaybe<Tickets_External_Event_Inc_Input>
  _set?: InputMaybe<Tickets_External_Event_Set_Input>
  pk_columns: Tickets_External_Event_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_External_Event_ManyArgs = {
  updates: Array<Tickets_External_Event_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_External_TicketsArgs = {
  _inc?: InputMaybe<Tickets_External_Tickets_Inc_Input>
  _set?: InputMaybe<Tickets_External_Tickets_Set_Input>
  where: Tickets_External_Tickets_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_External_Tickets_By_PkArgs = {
  _inc?: InputMaybe<Tickets_External_Tickets_Inc_Input>
  _set?: InputMaybe<Tickets_External_Tickets_Set_Input>
  pk_columns: Tickets_External_Tickets_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_External_Tickets_ManyArgs = {
  updates: Array<Tickets_External_Tickets_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Blob_TriggersArgs = {
  _set?: InputMaybe<Tickets_Qrtz_Blob_Triggers_Set_Input>
  where: Tickets_Qrtz_Blob_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Blob_Triggers_By_PkArgs = {
  _set?: InputMaybe<Tickets_Qrtz_Blob_Triggers_Set_Input>
  pk_columns: Tickets_Qrtz_Blob_Triggers_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Blob_Triggers_ManyArgs = {
  updates: Array<Tickets_Qrtz_Blob_Triggers_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_CalendarsArgs = {
  _set?: InputMaybe<Tickets_Qrtz_Calendars_Set_Input>
  where: Tickets_Qrtz_Calendars_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Calendars_By_PkArgs = {
  _set?: InputMaybe<Tickets_Qrtz_Calendars_Set_Input>
  pk_columns: Tickets_Qrtz_Calendars_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Calendars_ManyArgs = {
  updates: Array<Tickets_Qrtz_Calendars_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Cron_TriggersArgs = {
  _set?: InputMaybe<Tickets_Qrtz_Cron_Triggers_Set_Input>
  where: Tickets_Qrtz_Cron_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Cron_Triggers_By_PkArgs = {
  _set?: InputMaybe<Tickets_Qrtz_Cron_Triggers_Set_Input>
  pk_columns: Tickets_Qrtz_Cron_Triggers_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Cron_Triggers_ManyArgs = {
  updates: Array<Tickets_Qrtz_Cron_Triggers_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Fired_TriggersArgs = {
  _inc?: InputMaybe<Tickets_Qrtz_Fired_Triggers_Inc_Input>
  _set?: InputMaybe<Tickets_Qrtz_Fired_Triggers_Set_Input>
  where: Tickets_Qrtz_Fired_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Fired_Triggers_By_PkArgs = {
  _inc?: InputMaybe<Tickets_Qrtz_Fired_Triggers_Inc_Input>
  _set?: InputMaybe<Tickets_Qrtz_Fired_Triggers_Set_Input>
  pk_columns: Tickets_Qrtz_Fired_Triggers_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Fired_Triggers_ManyArgs = {
  updates: Array<Tickets_Qrtz_Fired_Triggers_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Job_DetailsArgs = {
  _set?: InputMaybe<Tickets_Qrtz_Job_Details_Set_Input>
  where: Tickets_Qrtz_Job_Details_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Job_Details_By_PkArgs = {
  _set?: InputMaybe<Tickets_Qrtz_Job_Details_Set_Input>
  pk_columns: Tickets_Qrtz_Job_Details_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Job_Details_ManyArgs = {
  updates: Array<Tickets_Qrtz_Job_Details_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_LocksArgs = {
  _set?: InputMaybe<Tickets_Qrtz_Locks_Set_Input>
  where: Tickets_Qrtz_Locks_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Locks_By_PkArgs = {
  _set?: InputMaybe<Tickets_Qrtz_Locks_Set_Input>
  pk_columns: Tickets_Qrtz_Locks_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Locks_ManyArgs = {
  updates: Array<Tickets_Qrtz_Locks_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Paused_Trigger_GrpsArgs = {
  _set?: InputMaybe<Tickets_Qrtz_Paused_Trigger_Grps_Set_Input>
  where: Tickets_Qrtz_Paused_Trigger_Grps_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Paused_Trigger_Grps_By_PkArgs = {
  _set?: InputMaybe<Tickets_Qrtz_Paused_Trigger_Grps_Set_Input>
  pk_columns: Tickets_Qrtz_Paused_Trigger_Grps_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Paused_Trigger_Grps_ManyArgs = {
  updates: Array<Tickets_Qrtz_Paused_Trigger_Grps_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Scheduler_StateArgs = {
  _inc?: InputMaybe<Tickets_Qrtz_Scheduler_State_Inc_Input>
  _set?: InputMaybe<Tickets_Qrtz_Scheduler_State_Set_Input>
  where: Tickets_Qrtz_Scheduler_State_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Scheduler_State_By_PkArgs = {
  _inc?: InputMaybe<Tickets_Qrtz_Scheduler_State_Inc_Input>
  _set?: InputMaybe<Tickets_Qrtz_Scheduler_State_Set_Input>
  pk_columns: Tickets_Qrtz_Scheduler_State_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Scheduler_State_ManyArgs = {
  updates: Array<Tickets_Qrtz_Scheduler_State_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Simple_TriggersArgs = {
  _inc?: InputMaybe<Tickets_Qrtz_Simple_Triggers_Inc_Input>
  _set?: InputMaybe<Tickets_Qrtz_Simple_Triggers_Set_Input>
  where: Tickets_Qrtz_Simple_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Simple_Triggers_By_PkArgs = {
  _inc?: InputMaybe<Tickets_Qrtz_Simple_Triggers_Inc_Input>
  _set?: InputMaybe<Tickets_Qrtz_Simple_Triggers_Set_Input>
  pk_columns: Tickets_Qrtz_Simple_Triggers_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Simple_Triggers_ManyArgs = {
  updates: Array<Tickets_Qrtz_Simple_Triggers_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Simprop_TriggersArgs = {
  _inc?: InputMaybe<Tickets_Qrtz_Simprop_Triggers_Inc_Input>
  _set?: InputMaybe<Tickets_Qrtz_Simprop_Triggers_Set_Input>
  where: Tickets_Qrtz_Simprop_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Simprop_Triggers_By_PkArgs = {
  _inc?: InputMaybe<Tickets_Qrtz_Simprop_Triggers_Inc_Input>
  _set?: InputMaybe<Tickets_Qrtz_Simprop_Triggers_Set_Input>
  pk_columns: Tickets_Qrtz_Simprop_Triggers_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Simprop_Triggers_ManyArgs = {
  updates: Array<Tickets_Qrtz_Simprop_Triggers_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_TriggersArgs = {
  _inc?: InputMaybe<Tickets_Qrtz_Triggers_Inc_Input>
  _set?: InputMaybe<Tickets_Qrtz_Triggers_Set_Input>
  where: Tickets_Qrtz_Triggers_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Triggers_By_PkArgs = {
  _inc?: InputMaybe<Tickets_Qrtz_Triggers_Inc_Input>
  _set?: InputMaybe<Tickets_Qrtz_Triggers_Set_Input>
  pk_columns: Tickets_Qrtz_Triggers_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Tickets_Qrtz_Triggers_ManyArgs = {
  updates: Array<Tickets_Qrtz_Triggers_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Trustpilot_InvitationsArgs = {
  _inc?: InputMaybe<Trustpilot_Invitations_Inc_Input>
  _set?: InputMaybe<Trustpilot_Invitations_Set_Input>
  where: Trustpilot_Invitations_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Trustpilot_Invitations_ManyArgs = {
  updates: Array<Trustpilot_Invitations_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _inc?: InputMaybe<Users_Inc_Input>
  _set?: InputMaybe<Users_Set_Input>
  where: Users_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _inc?: InputMaybe<Users_Inc_Input>
  _set?: InputMaybe<Users_Set_Input>
  pk_columns: Users_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Uswitch_RecordArgs = {
  _inc?: InputMaybe<Uswitch_Record_Inc_Input>
  _set?: InputMaybe<Uswitch_Record_Set_Input>
  where: Uswitch_Record_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Uswitch_Record_By_PkArgs = {
  _inc?: InputMaybe<Uswitch_Record_Inc_Input>
  _set?: InputMaybe<Uswitch_Record_Set_Input>
  pk_columns: Uswitch_Record_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Uswitch_Record_ManyArgs = {
  updates: Array<Uswitch_Record_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Warm_Home_Discount_ApplicationArgs = {
  _inc?: InputMaybe<Warm_Home_Discount_Application_Inc_Input>
  _set?: InputMaybe<Warm_Home_Discount_Application_Set_Input>
  where: Warm_Home_Discount_Application_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Warm_Home_Discount_Application_By_PkArgs = {
  _inc?: InputMaybe<Warm_Home_Discount_Application_Inc_Input>
  _set?: InputMaybe<Warm_Home_Discount_Application_Set_Input>
  pk_columns: Warm_Home_Discount_Application_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Warm_Home_Discount_Application_ManyArgs = {
  updates: Array<Warm_Home_Discount_Application_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Warm_Home_Discount_Application_Status_HistoryArgs =
  {
    _inc?: InputMaybe<Warm_Home_Discount_Application_Status_History_Inc_Input>
    _set?: InputMaybe<Warm_Home_Discount_Application_Status_History_Set_Input>
    where: Warm_Home_Discount_Application_Status_History_Bool_Exp
  }

/** mutation root */
export type Mutation_RootUpdate_Warm_Home_Discount_Application_Status_History_By_PkArgs =
  {
    _inc?: InputMaybe<Warm_Home_Discount_Application_Status_History_Inc_Input>
    _set?: InputMaybe<Warm_Home_Discount_Application_Status_History_Set_Input>
    pk_columns: Warm_Home_Discount_Application_Status_History_Pk_Columns_Input
  }

/** mutation root */
export type Mutation_RootUpdate_Warm_Home_Discount_Application_Status_History_ManyArgs =
  {
    updates: Array<Warm_Home_Discount_Application_Status_History_Updates>
  }

/** mutation root */
export type Mutation_RootUpdate_Warm_Home_Discount_CriteriaArgs = {
  _inc?: InputMaybe<Warm_Home_Discount_Criteria_Inc_Input>
  _set?: InputMaybe<Warm_Home_Discount_Criteria_Set_Input>
  where: Warm_Home_Discount_Criteria_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Warm_Home_Discount_Criteria_By_PkArgs = {
  _inc?: InputMaybe<Warm_Home_Discount_Criteria_Inc_Input>
  _set?: InputMaybe<Warm_Home_Discount_Criteria_Set_Input>
  pk_columns: Warm_Home_Discount_Criteria_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Warm_Home_Discount_Criteria_ManyArgs = {
  updates: Array<Warm_Home_Discount_Criteria_Updates>
}

/** mutation root */
export type Mutation_RootUpdate_Warm_Home_Discount_Criteria_RelArgs = {
  _inc?: InputMaybe<Warm_Home_Discount_Criteria_Rel_Inc_Input>
  _set?: InputMaybe<Warm_Home_Discount_Criteria_Rel_Set_Input>
  where: Warm_Home_Discount_Criteria_Rel_Bool_Exp
}

/** mutation root */
export type Mutation_RootUpdate_Warm_Home_Discount_Criteria_Rel_By_PkArgs = {
  _inc?: InputMaybe<Warm_Home_Discount_Criteria_Rel_Inc_Input>
  _set?: InputMaybe<Warm_Home_Discount_Criteria_Rel_Set_Input>
  pk_columns: Warm_Home_Discount_Criteria_Rel_Pk_Columns_Input
}

/** mutation root */
export type Mutation_RootUpdate_Warm_Home_Discount_Criteria_Rel_ManyArgs = {
  updates: Array<Warm_Home_Discount_Criteria_Rel_Updates>
}

/** columns and relationships of "note" */
export type Note = {
  __typename?: "note"
  content?: Maybe<Scalars["String"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  style: Scalars["String"]["output"]
  summary: Scalars["String"]["output"]
  ticket_id?: Maybe<Scalars["bigint"]["output"]>
  type: Scalars["String"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "note" */
export type Note_Aggregate = {
  __typename?: "note_aggregate"
  aggregate?: Maybe<Note_Aggregate_Fields>
  nodes: Array<Note>
}

/** aggregate fields of "note" */
export type Note_Aggregate_Fields = {
  __typename?: "note_aggregate_fields"
  avg?: Maybe<Note_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Note_Max_Fields>
  min?: Maybe<Note_Min_Fields>
  stddev?: Maybe<Note_Stddev_Fields>
  stddev_pop?: Maybe<Note_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Note_Stddev_Samp_Fields>
  sum?: Maybe<Note_Sum_Fields>
  var_pop?: Maybe<Note_Var_Pop_Fields>
  var_samp?: Maybe<Note_Var_Samp_Fields>
  variance?: Maybe<Note_Variance_Fields>
}

/** aggregate fields of "note" */
export type Note_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Note_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Note_Avg_Fields = {
  __typename?: "note_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ticket_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "note". All fields are combined with a logical 'AND'. */
export type Note_Bool_Exp = {
  _and?: InputMaybe<Array<Note_Bool_Exp>>
  _not?: InputMaybe<Note_Bool_Exp>
  _or?: InputMaybe<Array<Note_Bool_Exp>>
  content?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  style?: InputMaybe<String_Comparison_Exp>
  summary?: InputMaybe<String_Comparison_Exp>
  ticket_id?: InputMaybe<Bigint_Comparison_Exp>
  type?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "note" */
export enum Note_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkNote = "pk_note",
}

/** input type for incrementing numeric columns in table "note" */
export type Note_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  ticket_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "note" */
export type Note_Insert_Input = {
  content?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  style?: InputMaybe<Scalars["String"]["input"]>
  summary?: InputMaybe<Scalars["String"]["input"]>
  ticket_id?: InputMaybe<Scalars["bigint"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Note_Max_Fields = {
  __typename?: "note_max_fields"
  content?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  style?: Maybe<Scalars["String"]["output"]>
  summary?: Maybe<Scalars["String"]["output"]>
  ticket_id?: Maybe<Scalars["bigint"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Note_Min_Fields = {
  __typename?: "note_min_fields"
  content?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  style?: Maybe<Scalars["String"]["output"]>
  summary?: Maybe<Scalars["String"]["output"]>
  ticket_id?: Maybe<Scalars["bigint"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "note" */
export type Note_Mutation_Response = {
  __typename?: "note_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Note>
}

/** on_conflict condition type for table "note" */
export type Note_On_Conflict = {
  constraint: Note_Constraint
  update_columns?: Array<Note_Update_Column>
  where?: InputMaybe<Note_Bool_Exp>
}

/** Ordering options when selecting data from "note". */
export type Note_Order_By = {
  content?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  style?: InputMaybe<Order_By>
  summary?: InputMaybe<Order_By>
  ticket_id?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: note */
export type Note_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "note" */
export enum Note_Select_Column {
  /** column name */
  Content = "content",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  Style = "style",
  /** column name */
  Summary = "summary",
  /** column name */
  TicketId = "ticket_id",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "note" */
export type Note_Set_Input = {
  content?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  style?: InputMaybe<Scalars["String"]["input"]>
  summary?: InputMaybe<Scalars["String"]["input"]>
  ticket_id?: InputMaybe<Scalars["bigint"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Note_Stddev_Fields = {
  __typename?: "note_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ticket_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Note_Stddev_Pop_Fields = {
  __typename?: "note_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ticket_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Note_Stddev_Samp_Fields = {
  __typename?: "note_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ticket_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "note" */
export type Note_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Note_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Note_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  style?: InputMaybe<Scalars["String"]["input"]>
  summary?: InputMaybe<Scalars["String"]["input"]>
  ticket_id?: InputMaybe<Scalars["bigint"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Note_Sum_Fields = {
  __typename?: "note_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  ticket_id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "note" */
export enum Note_Update_Column {
  /** column name */
  Content = "content",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  Style = "style",
  /** column name */
  Summary = "summary",
  /** column name */
  TicketId = "ticket_id",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Note_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Note_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Note_Set_Input>
  /** filter the rows which have to be updated */
  where: Note_Bool_Exp
}

/** aggregate var_pop on columns */
export type Note_Var_Pop_Fields = {
  __typename?: "note_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ticket_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Note_Var_Samp_Fields = {
  __typename?: "note_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ticket_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Note_Variance_Fields = {
  __typename?: "note_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ticket_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "notes_status_enum". All fields are combined with logical 'AND'. */
export type Notes_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["notes_status_enum"]["input"]>
  _gt?: InputMaybe<Scalars["notes_status_enum"]["input"]>
  _gte?: InputMaybe<Scalars["notes_status_enum"]["input"]>
  _in?: InputMaybe<Array<Scalars["notes_status_enum"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["notes_status_enum"]["input"]>
  _lte?: InputMaybe<Scalars["notes_status_enum"]["input"]>
  _neq?: InputMaybe<Scalars["notes_status_enum"]["input"]>
  _nin?: InputMaybe<Array<Scalars["notes_status_enum"]["input"]>>
}

/** columns and relationships of "nova_submissions" */
export type Nova_Submissions = {
  __typename?: "nova_submissions"
  account_number?: Maybe<Scalars["String"]["output"]>
  comment?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  debug_data?: Maybe<Scalars["json"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  error_code_1?: Maybe<Scalars["String"]["output"]>
  error_code_2?: Maybe<Scalars["String"]["output"]>
  failed_attempts?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_attempt?: Maybe<Scalars["timestamp"]["output"]>
  meter_point_identifier?: Maybe<Scalars["String"]["output"]>
  meterpoint_id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["meter_reading_submission_request_status"]["output"]>
  submission_data?: Maybe<Scalars["json"]["output"]>
  submission_values?: Maybe<Scalars["json"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  user_email?: Maybe<Scalars["String"]["output"]>
}

/** columns and relationships of "nova_submissions" */
export type Nova_SubmissionsDebug_DataArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** columns and relationships of "nova_submissions" */
export type Nova_SubmissionsSubmission_DataArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** columns and relationships of "nova_submissions" */
export type Nova_SubmissionsSubmission_ValuesArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregated selection of "nova_submissions" */
export type Nova_Submissions_Aggregate = {
  __typename?: "nova_submissions_aggregate"
  aggregate?: Maybe<Nova_Submissions_Aggregate_Fields>
  nodes: Array<Nova_Submissions>
}

/** aggregate fields of "nova_submissions" */
export type Nova_Submissions_Aggregate_Fields = {
  __typename?: "nova_submissions_aggregate_fields"
  avg?: Maybe<Nova_Submissions_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Nova_Submissions_Max_Fields>
  min?: Maybe<Nova_Submissions_Min_Fields>
  stddev?: Maybe<Nova_Submissions_Stddev_Fields>
  stddev_pop?: Maybe<Nova_Submissions_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Nova_Submissions_Stddev_Samp_Fields>
  sum?: Maybe<Nova_Submissions_Sum_Fields>
  var_pop?: Maybe<Nova_Submissions_Var_Pop_Fields>
  var_samp?: Maybe<Nova_Submissions_Var_Samp_Fields>
  variance?: Maybe<Nova_Submissions_Variance_Fields>
}

/** aggregate fields of "nova_submissions" */
export type Nova_Submissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Nova_Submissions_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Nova_Submissions_Avg_Fields = {
  __typename?: "nova_submissions_avg_fields"
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meterpoint_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "nova_submissions". All fields are combined with a logical 'AND'. */
export type Nova_Submissions_Bool_Exp = {
  _and?: InputMaybe<Array<Nova_Submissions_Bool_Exp>>
  _not?: InputMaybe<Nova_Submissions_Bool_Exp>
  _or?: InputMaybe<Array<Nova_Submissions_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  comment?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  debug_data?: InputMaybe<Json_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  error_code_1?: InputMaybe<String_Comparison_Exp>
  error_code_2?: InputMaybe<String_Comparison_Exp>
  failed_attempts?: InputMaybe<Int_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  last_attempt?: InputMaybe<Timestamp_Comparison_Exp>
  meter_point_identifier?: InputMaybe<String_Comparison_Exp>
  meterpoint_id?: InputMaybe<Bigint_Comparison_Exp>
  status?: InputMaybe<Meter_Reading_Submission_Request_Status_Comparison_Exp>
  submission_data?: InputMaybe<Json_Comparison_Exp>
  submission_values?: InputMaybe<Json_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  user_email?: InputMaybe<String_Comparison_Exp>
}

/** input type for incrementing numeric columns in table "nova_submissions" */
export type Nova_Submissions_Inc_Input = {
  failed_attempts?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meterpoint_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "nova_submissions" */
export type Nova_Submissions_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  comment?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  debug_data?: InputMaybe<Scalars["json"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  error_code_1?: InputMaybe<Scalars["String"]["input"]>
  error_code_2?: InputMaybe<Scalars["String"]["input"]>
  failed_attempts?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_attempt?: InputMaybe<Scalars["timestamp"]["input"]>
  meter_point_identifier?: InputMaybe<Scalars["String"]["input"]>
  meterpoint_id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<
    Scalars["meter_reading_submission_request_status"]["input"]
  >
  submission_data?: InputMaybe<Scalars["json"]["input"]>
  submission_values?: InputMaybe<Scalars["json"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  user_email?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Nova_Submissions_Max_Fields = {
  __typename?: "nova_submissions_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  comment?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  error_code_1?: Maybe<Scalars["String"]["output"]>
  error_code_2?: Maybe<Scalars["String"]["output"]>
  failed_attempts?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_attempt?: Maybe<Scalars["timestamp"]["output"]>
  meter_point_identifier?: Maybe<Scalars["String"]["output"]>
  meterpoint_id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["meter_reading_submission_request_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  user_email?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Nova_Submissions_Min_Fields = {
  __typename?: "nova_submissions_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  comment?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  error_code_1?: Maybe<Scalars["String"]["output"]>
  error_code_2?: Maybe<Scalars["String"]["output"]>
  failed_attempts?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_attempt?: Maybe<Scalars["timestamp"]["output"]>
  meter_point_identifier?: Maybe<Scalars["String"]["output"]>
  meterpoint_id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["meter_reading_submission_request_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  user_email?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "nova_submissions" */
export type Nova_Submissions_Mutation_Response = {
  __typename?: "nova_submissions_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Nova_Submissions>
}

/** Ordering options when selecting data from "nova_submissions". */
export type Nova_Submissions_Order_By = {
  account_number?: InputMaybe<Order_By>
  comment?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  debug_data?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  error_code_1?: InputMaybe<Order_By>
  error_code_2?: InputMaybe<Order_By>
  failed_attempts?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  last_attempt?: InputMaybe<Order_By>
  meter_point_identifier?: InputMaybe<Order_By>
  meterpoint_id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  submission_data?: InputMaybe<Order_By>
  submission_values?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_email?: InputMaybe<Order_By>
}

/** select columns of table "nova_submissions" */
export enum Nova_Submissions_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  Comment = "comment",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DebugData = "debug_data",
  /** column name */
  Deleted = "deleted",
  /** column name */
  ErrorCode_1 = "error_code_1",
  /** column name */
  ErrorCode_2 = "error_code_2",
  /** column name */
  FailedAttempts = "failed_attempts",
  /** column name */
  Id = "id",
  /** column name */
  LastAttempt = "last_attempt",
  /** column name */
  MeterPointIdentifier = "meter_point_identifier",
  /** column name */
  MeterpointId = "meterpoint_id",
  /** column name */
  Status = "status",
  /** column name */
  SubmissionData = "submission_data",
  /** column name */
  SubmissionValues = "submission_values",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  UserEmail = "user_email",
}

/** input type for updating data in table "nova_submissions" */
export type Nova_Submissions_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  comment?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  debug_data?: InputMaybe<Scalars["json"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  error_code_1?: InputMaybe<Scalars["String"]["input"]>
  error_code_2?: InputMaybe<Scalars["String"]["input"]>
  failed_attempts?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_attempt?: InputMaybe<Scalars["timestamp"]["input"]>
  meter_point_identifier?: InputMaybe<Scalars["String"]["input"]>
  meterpoint_id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<
    Scalars["meter_reading_submission_request_status"]["input"]
  >
  submission_data?: InputMaybe<Scalars["json"]["input"]>
  submission_values?: InputMaybe<Scalars["json"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  user_email?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Nova_Submissions_Stddev_Fields = {
  __typename?: "nova_submissions_stddev_fields"
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meterpoint_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Nova_Submissions_Stddev_Pop_Fields = {
  __typename?: "nova_submissions_stddev_pop_fields"
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meterpoint_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Nova_Submissions_Stddev_Samp_Fields = {
  __typename?: "nova_submissions_stddev_samp_fields"
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meterpoint_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "nova_submissions" */
export type Nova_Submissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nova_Submissions_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Nova_Submissions_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  comment?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  debug_data?: InputMaybe<Scalars["json"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  error_code_1?: InputMaybe<Scalars["String"]["input"]>
  error_code_2?: InputMaybe<Scalars["String"]["input"]>
  failed_attempts?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_attempt?: InputMaybe<Scalars["timestamp"]["input"]>
  meter_point_identifier?: InputMaybe<Scalars["String"]["input"]>
  meterpoint_id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<
    Scalars["meter_reading_submission_request_status"]["input"]
  >
  submission_data?: InputMaybe<Scalars["json"]["input"]>
  submission_values?: InputMaybe<Scalars["json"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  user_email?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Nova_Submissions_Sum_Fields = {
  __typename?: "nova_submissions_sum_fields"
  failed_attempts?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meterpoint_id?: Maybe<Scalars["bigint"]["output"]>
}

export type Nova_Submissions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Nova_Submissions_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Nova_Submissions_Set_Input>
  /** filter the rows which have to be updated */
  where: Nova_Submissions_Bool_Exp
}

/** aggregate var_pop on columns */
export type Nova_Submissions_Var_Pop_Fields = {
  __typename?: "nova_submissions_var_pop_fields"
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meterpoint_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Nova_Submissions_Var_Samp_Fields = {
  __typename?: "nova_submissions_var_samp_fields"
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meterpoint_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Nova_Submissions_Variance_Fields = {
  __typename?: "nova_submissions_variance_fields"
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meterpoint_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["numeric"]["input"]>
  _gt?: InputMaybe<Scalars["numeric"]["input"]>
  _gte?: InputMaybe<Scalars["numeric"]["input"]>
  _in?: InputMaybe<Array<Scalars["numeric"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["numeric"]["input"]>
  _lte?: InputMaybe<Scalars["numeric"]["input"]>
  _neq?: InputMaybe<Scalars["numeric"]["input"]>
  _nin?: InputMaybe<Array<Scalars["numeric"]["input"]>>
}

/** Boolean expression to compare columns of type "occupier_status". All fields are combined with logical 'AND'. */
export type Occupier_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["occupier_status"]["input"]>
  _gt?: InputMaybe<Scalars["occupier_status"]["input"]>
  _gte?: InputMaybe<Scalars["occupier_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["occupier_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["occupier_status"]["input"]>
  _lte?: InputMaybe<Scalars["occupier_status"]["input"]>
  _neq?: InputMaybe<Scalars["occupier_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["occupier_status"]["input"]>>
}

/** Boolean expression to compare columns of type "operation_type". All fields are combined with logical 'AND'. */
export type Operation_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["operation_type"]["input"]>
  _gt?: InputMaybe<Scalars["operation_type"]["input"]>
  _gte?: InputMaybe<Scalars["operation_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["operation_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["operation_type"]["input"]>
  _lte?: InputMaybe<Scalars["operation_type"]["input"]>
  _neq?: InputMaybe<Scalars["operation_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["operation_type"]["input"]>>
}

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls first */
  Asc = "asc",
  /** in ascending order, nulls first */
  AscNullsFirst = "asc_nulls_first",
  /** in ascending order, nulls last */
  AscNullsLast = "asc_nulls_last",
  /** in descending order, nulls last */
  Desc = "desc",
  /** in descending order, nulls first */
  DescNullsFirst = "desc_nulls_first",
  /** in descending order, nulls last */
  DescNullsLast = "desc_nulls_last",
}

/** columns and relationships of "outbound_photo_request" */
export type Outbound_Photo_Request = {
  __typename?: "outbound_photo_request"
  account_id?: Maybe<Scalars["bigint"]["output"]>
  account_number: Scalars["String"]["output"]
  case_id?: Maybe<Scalars["String"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  emails_sent_at?: Maybe<Scalars["jsonb"]["output"]>
  freshdesk_group_id: Scalars["bigint"]["output"]
  freshdesk_group_name: Scalars["String"]["output"]
  freshdesk_ticket_id?: Maybe<Scalars["bigint"]["output"]>
  fuel: Scalars["meter_reading_fuel"]["output"]
  id: Scalars["bigint"]["output"]
  request_reason: Scalars["String"]["output"]
  status: Scalars["outbound_photo_request_status"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "outbound_photo_request" */
export type Outbound_Photo_RequestEmails_Sent_AtArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregated selection of "outbound_photo_request" */
export type Outbound_Photo_Request_Aggregate = {
  __typename?: "outbound_photo_request_aggregate"
  aggregate?: Maybe<Outbound_Photo_Request_Aggregate_Fields>
  nodes: Array<Outbound_Photo_Request>
}

/** aggregate fields of "outbound_photo_request" */
export type Outbound_Photo_Request_Aggregate_Fields = {
  __typename?: "outbound_photo_request_aggregate_fields"
  avg?: Maybe<Outbound_Photo_Request_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Outbound_Photo_Request_Max_Fields>
  min?: Maybe<Outbound_Photo_Request_Min_Fields>
  stddev?: Maybe<Outbound_Photo_Request_Stddev_Fields>
  stddev_pop?: Maybe<Outbound_Photo_Request_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Outbound_Photo_Request_Stddev_Samp_Fields>
  sum?: Maybe<Outbound_Photo_Request_Sum_Fields>
  var_pop?: Maybe<Outbound_Photo_Request_Var_Pop_Fields>
  var_samp?: Maybe<Outbound_Photo_Request_Var_Samp_Fields>
  variance?: Maybe<Outbound_Photo_Request_Variance_Fields>
}

/** aggregate fields of "outbound_photo_request" */
export type Outbound_Photo_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Outbound_Photo_Request_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** append existing jsonb value of filtered columns with new jsonb value */
export type Outbound_Photo_Request_Append_Input = {
  emails_sent_at?: InputMaybe<Scalars["jsonb"]["input"]>
}

/** aggregate avg on columns */
export type Outbound_Photo_Request_Avg_Fields = {
  __typename?: "outbound_photo_request_avg_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_group_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_ticket_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "outbound_photo_request". All fields are combined with a logical 'AND'. */
export type Outbound_Photo_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Outbound_Photo_Request_Bool_Exp>>
  _not?: InputMaybe<Outbound_Photo_Request_Bool_Exp>
  _or?: InputMaybe<Array<Outbound_Photo_Request_Bool_Exp>>
  account_id?: InputMaybe<Bigint_Comparison_Exp>
  account_number?: InputMaybe<String_Comparison_Exp>
  case_id?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  email_message_id?: InputMaybe<Bigint_Comparison_Exp>
  emails_sent_at?: InputMaybe<Jsonb_Comparison_Exp>
  freshdesk_group_id?: InputMaybe<Bigint_Comparison_Exp>
  freshdesk_group_name?: InputMaybe<String_Comparison_Exp>
  freshdesk_ticket_id?: InputMaybe<Bigint_Comparison_Exp>
  fuel?: InputMaybe<Meter_Reading_Fuel_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  request_reason?: InputMaybe<String_Comparison_Exp>
  status?: InputMaybe<Outbound_Photo_Request_Status_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "outbound_photo_request" */
export enum Outbound_Photo_Request_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkOutboundPhotoRequest = "pk_outbound_photo_request",
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Outbound_Photo_Request_Delete_At_Path_Input = {
  emails_sent_at?: InputMaybe<Array<Scalars["String"]["input"]>>
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Outbound_Photo_Request_Delete_Elem_Input = {
  emails_sent_at?: InputMaybe<Scalars["Int"]["input"]>
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Outbound_Photo_Request_Delete_Key_Input = {
  emails_sent_at?: InputMaybe<Scalars["String"]["input"]>
}

/** input type for incrementing numeric columns in table "outbound_photo_request" */
export type Outbound_Photo_Request_Inc_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  freshdesk_group_id?: InputMaybe<Scalars["bigint"]["input"]>
  freshdesk_ticket_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "outbound_photo_request" */
export type Outbound_Photo_Request_Insert_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  account_number?: InputMaybe<Scalars["String"]["input"]>
  case_id?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  emails_sent_at?: InputMaybe<Scalars["jsonb"]["input"]>
  freshdesk_group_id?: InputMaybe<Scalars["bigint"]["input"]>
  freshdesk_group_name?: InputMaybe<Scalars["String"]["input"]>
  freshdesk_ticket_id?: InputMaybe<Scalars["bigint"]["input"]>
  fuel?: InputMaybe<Scalars["meter_reading_fuel"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  request_reason?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["outbound_photo_request_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Outbound_Photo_Request_Max_Fields = {
  __typename?: "outbound_photo_request_max_fields"
  account_id?: Maybe<Scalars["bigint"]["output"]>
  account_number?: Maybe<Scalars["String"]["output"]>
  case_id?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  freshdesk_group_id?: Maybe<Scalars["bigint"]["output"]>
  freshdesk_group_name?: Maybe<Scalars["String"]["output"]>
  freshdesk_ticket_id?: Maybe<Scalars["bigint"]["output"]>
  fuel?: Maybe<Scalars["meter_reading_fuel"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  request_reason?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["outbound_photo_request_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Outbound_Photo_Request_Min_Fields = {
  __typename?: "outbound_photo_request_min_fields"
  account_id?: Maybe<Scalars["bigint"]["output"]>
  account_number?: Maybe<Scalars["String"]["output"]>
  case_id?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  freshdesk_group_id?: Maybe<Scalars["bigint"]["output"]>
  freshdesk_group_name?: Maybe<Scalars["String"]["output"]>
  freshdesk_ticket_id?: Maybe<Scalars["bigint"]["output"]>
  fuel?: Maybe<Scalars["meter_reading_fuel"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  request_reason?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["outbound_photo_request_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "outbound_photo_request" */
export type Outbound_Photo_Request_Mutation_Response = {
  __typename?: "outbound_photo_request_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Outbound_Photo_Request>
}

/** on_conflict condition type for table "outbound_photo_request" */
export type Outbound_Photo_Request_On_Conflict = {
  constraint: Outbound_Photo_Request_Constraint
  update_columns?: Array<Outbound_Photo_Request_Update_Column>
  where?: InputMaybe<Outbound_Photo_Request_Bool_Exp>
}

/** Ordering options when selecting data from "outbound_photo_request". */
export type Outbound_Photo_Request_Order_By = {
  account_id?: InputMaybe<Order_By>
  account_number?: InputMaybe<Order_By>
  case_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  email_message_id?: InputMaybe<Order_By>
  emails_sent_at?: InputMaybe<Order_By>
  freshdesk_group_id?: InputMaybe<Order_By>
  freshdesk_group_name?: InputMaybe<Order_By>
  freshdesk_ticket_id?: InputMaybe<Order_By>
  fuel?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  request_reason?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: outbound_photo_request */
export type Outbound_Photo_Request_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Outbound_Photo_Request_Prepend_Input = {
  emails_sent_at?: InputMaybe<Scalars["jsonb"]["input"]>
}

/** select columns of table "outbound_photo_request" */
export enum Outbound_Photo_Request_Select_Column {
  /** column name */
  AccountId = "account_id",
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CaseId = "case_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  EmailMessageId = "email_message_id",
  /** column name */
  EmailsSentAt = "emails_sent_at",
  /** column name */
  FreshdeskGroupId = "freshdesk_group_id",
  /** column name */
  FreshdeskGroupName = "freshdesk_group_name",
  /** column name */
  FreshdeskTicketId = "freshdesk_ticket_id",
  /** column name */
  Fuel = "fuel",
  /** column name */
  Id = "id",
  /** column name */
  RequestReason = "request_reason",
  /** column name */
  Status = "status",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "outbound_photo_request" */
export type Outbound_Photo_Request_Set_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  account_number?: InputMaybe<Scalars["String"]["input"]>
  case_id?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  emails_sent_at?: InputMaybe<Scalars["jsonb"]["input"]>
  freshdesk_group_id?: InputMaybe<Scalars["bigint"]["input"]>
  freshdesk_group_name?: InputMaybe<Scalars["String"]["input"]>
  freshdesk_ticket_id?: InputMaybe<Scalars["bigint"]["input"]>
  fuel?: InputMaybe<Scalars["meter_reading_fuel"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  request_reason?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["outbound_photo_request_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** Boolean expression to compare columns of type "outbound_photo_request_status". All fields are combined with logical 'AND'. */
export type Outbound_Photo_Request_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["outbound_photo_request_status"]["input"]>
  _gt?: InputMaybe<Scalars["outbound_photo_request_status"]["input"]>
  _gte?: InputMaybe<Scalars["outbound_photo_request_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["outbound_photo_request_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["outbound_photo_request_status"]["input"]>
  _lte?: InputMaybe<Scalars["outbound_photo_request_status"]["input"]>
  _neq?: InputMaybe<Scalars["outbound_photo_request_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["outbound_photo_request_status"]["input"]>>
}

/** aggregate stddev on columns */
export type Outbound_Photo_Request_Stddev_Fields = {
  __typename?: "outbound_photo_request_stddev_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_group_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_ticket_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Outbound_Photo_Request_Stddev_Pop_Fields = {
  __typename?: "outbound_photo_request_stddev_pop_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_group_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_ticket_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Outbound_Photo_Request_Stddev_Samp_Fields = {
  __typename?: "outbound_photo_request_stddev_samp_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_group_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_ticket_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "outbound_photo_request" */
export type Outbound_Photo_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Outbound_Photo_Request_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Outbound_Photo_Request_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  account_number?: InputMaybe<Scalars["String"]["input"]>
  case_id?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  emails_sent_at?: InputMaybe<Scalars["jsonb"]["input"]>
  freshdesk_group_id?: InputMaybe<Scalars["bigint"]["input"]>
  freshdesk_group_name?: InputMaybe<Scalars["String"]["input"]>
  freshdesk_ticket_id?: InputMaybe<Scalars["bigint"]["input"]>
  fuel?: InputMaybe<Scalars["meter_reading_fuel"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  request_reason?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["outbound_photo_request_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Outbound_Photo_Request_Sum_Fields = {
  __typename?: "outbound_photo_request_sum_fields"
  account_id?: Maybe<Scalars["bigint"]["output"]>
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  freshdesk_group_id?: Maybe<Scalars["bigint"]["output"]>
  freshdesk_ticket_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "outbound_photo_request" */
export enum Outbound_Photo_Request_Update_Column {
  /** column name */
  AccountId = "account_id",
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CaseId = "case_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  EmailMessageId = "email_message_id",
  /** column name */
  EmailsSentAt = "emails_sent_at",
  /** column name */
  FreshdeskGroupId = "freshdesk_group_id",
  /** column name */
  FreshdeskGroupName = "freshdesk_group_name",
  /** column name */
  FreshdeskTicketId = "freshdesk_ticket_id",
  /** column name */
  Fuel = "fuel",
  /** column name */
  Id = "id",
  /** column name */
  RequestReason = "request_reason",
  /** column name */
  Status = "status",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Outbound_Photo_Request_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Outbound_Photo_Request_Append_Input>
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Outbound_Photo_Request_Delete_At_Path_Input>
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Outbound_Photo_Request_Delete_Elem_Input>
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Outbound_Photo_Request_Delete_Key_Input>
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Outbound_Photo_Request_Inc_Input>
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Outbound_Photo_Request_Prepend_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Outbound_Photo_Request_Set_Input>
  /** filter the rows which have to be updated */
  where: Outbound_Photo_Request_Bool_Exp
}

/** aggregate var_pop on columns */
export type Outbound_Photo_Request_Var_Pop_Fields = {
  __typename?: "outbound_photo_request_var_pop_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_group_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_ticket_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Outbound_Photo_Request_Var_Samp_Fields = {
  __typename?: "outbound_photo_request_var_samp_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_group_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_ticket_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Outbound_Photo_Request_Variance_Fields = {
  __typename?: "outbound_photo_request_variance_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_group_id?: Maybe<Scalars["Float"]["output"]>
  freshdesk_ticket_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "package". All fields are combined with logical 'AND'. */
export type Package_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["package"]["input"]>
  _gt?: InputMaybe<Scalars["package"]["input"]>
  _gte?: InputMaybe<Scalars["package"]["input"]>
  _in?: InputMaybe<Array<Scalars["package"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["package"]["input"]>
  _lte?: InputMaybe<Scalars["package"]["input"]>
  _neq?: InputMaybe<Scalars["package"]["input"]>
  _nin?: InputMaybe<Array<Scalars["package"]["input"]>>
}

/** columns and relationships of "password_reset_tokens" */
export type Password_Reset_Tokens = {
  __typename?: "password_reset_tokens"
  token: Scalars["bytea"]["output"]
  token_claimed_at?: Maybe<Scalars["timestamp"]["output"]>
  token_expiry: Scalars["timestamp"]["output"]
  token_generated_at: Scalars["timestamp"]["output"]
  /** An object relationship */
  user: Users
  user_id: Scalars["bigint"]["output"]
}

/** aggregated selection of "password_reset_tokens" */
export type Password_Reset_Tokens_Aggregate = {
  __typename?: "password_reset_tokens_aggregate"
  aggregate?: Maybe<Password_Reset_Tokens_Aggregate_Fields>
  nodes: Array<Password_Reset_Tokens>
}

export type Password_Reset_Tokens_Aggregate_Bool_Exp = {
  count?: InputMaybe<Password_Reset_Tokens_Aggregate_Bool_Exp_Count>
}

export type Password_Reset_Tokens_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Password_Reset_Tokens_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Password_Reset_Tokens_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "password_reset_tokens" */
export type Password_Reset_Tokens_Aggregate_Fields = {
  __typename?: "password_reset_tokens_aggregate_fields"
  avg?: Maybe<Password_Reset_Tokens_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Password_Reset_Tokens_Max_Fields>
  min?: Maybe<Password_Reset_Tokens_Min_Fields>
  stddev?: Maybe<Password_Reset_Tokens_Stddev_Fields>
  stddev_pop?: Maybe<Password_Reset_Tokens_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Password_Reset_Tokens_Stddev_Samp_Fields>
  sum?: Maybe<Password_Reset_Tokens_Sum_Fields>
  var_pop?: Maybe<Password_Reset_Tokens_Var_Pop_Fields>
  var_samp?: Maybe<Password_Reset_Tokens_Var_Samp_Fields>
  variance?: Maybe<Password_Reset_Tokens_Variance_Fields>
}

/** aggregate fields of "password_reset_tokens" */
export type Password_Reset_Tokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Password_Reset_Tokens_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "password_reset_tokens" */
export type Password_Reset_Tokens_Aggregate_Order_By = {
  avg?: InputMaybe<Password_Reset_Tokens_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Password_Reset_Tokens_Max_Order_By>
  min?: InputMaybe<Password_Reset_Tokens_Min_Order_By>
  stddev?: InputMaybe<Password_Reset_Tokens_Stddev_Order_By>
  stddev_pop?: InputMaybe<Password_Reset_Tokens_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Password_Reset_Tokens_Stddev_Samp_Order_By>
  sum?: InputMaybe<Password_Reset_Tokens_Sum_Order_By>
  var_pop?: InputMaybe<Password_Reset_Tokens_Var_Pop_Order_By>
  var_samp?: InputMaybe<Password_Reset_Tokens_Var_Samp_Order_By>
  variance?: InputMaybe<Password_Reset_Tokens_Variance_Order_By>
}

/** input type for inserting array relation for remote table "password_reset_tokens" */
export type Password_Reset_Tokens_Arr_Rel_Insert_Input = {
  data: Array<Password_Reset_Tokens_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Password_Reset_Tokens_On_Conflict>
}

/** aggregate avg on columns */
export type Password_Reset_Tokens_Avg_Fields = {
  __typename?: "password_reset_tokens_avg_fields"
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "password_reset_tokens" */
export type Password_Reset_Tokens_Avg_Order_By = {
  user_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "password_reset_tokens". All fields are combined with a logical 'AND'. */
export type Password_Reset_Tokens_Bool_Exp = {
  _and?: InputMaybe<Array<Password_Reset_Tokens_Bool_Exp>>
  _not?: InputMaybe<Password_Reset_Tokens_Bool_Exp>
  _or?: InputMaybe<Array<Password_Reset_Tokens_Bool_Exp>>
  token?: InputMaybe<Bytea_Comparison_Exp>
  token_claimed_at?: InputMaybe<Timestamp_Comparison_Exp>
  token_expiry?: InputMaybe<Timestamp_Comparison_Exp>
  token_generated_at?: InputMaybe<Timestamp_Comparison_Exp>
  user?: InputMaybe<Users_Bool_Exp>
  user_id?: InputMaybe<Bigint_Comparison_Exp>
}

/** unique or primary key constraints on table "password_reset_tokens" */
export enum Password_Reset_Tokens_Constraint {
  /** unique or primary key constraint on columns "user_id", "token" */
  PasswordResetTokensPkey = "password_reset_tokens_pkey",
  /** unique or primary key constraint on columns "token" */
  PasswordResetTokensTokenKey = "password_reset_tokens_token_key",
}

/** input type for incrementing numeric columns in table "password_reset_tokens" */
export type Password_Reset_Tokens_Inc_Input = {
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "password_reset_tokens" */
export type Password_Reset_Tokens_Insert_Input = {
  token?: InputMaybe<Scalars["bytea"]["input"]>
  token_claimed_at?: InputMaybe<Scalars["timestamp"]["input"]>
  token_expiry?: InputMaybe<Scalars["timestamp"]["input"]>
  token_generated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate max on columns */
export type Password_Reset_Tokens_Max_Fields = {
  __typename?: "password_reset_tokens_max_fields"
  token_claimed_at?: Maybe<Scalars["timestamp"]["output"]>
  token_expiry?: Maybe<Scalars["timestamp"]["output"]>
  token_generated_at?: Maybe<Scalars["timestamp"]["output"]>
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by max() on columns of table "password_reset_tokens" */
export type Password_Reset_Tokens_Max_Order_By = {
  token_claimed_at?: InputMaybe<Order_By>
  token_expiry?: InputMaybe<Order_By>
  token_generated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Password_Reset_Tokens_Min_Fields = {
  __typename?: "password_reset_tokens_min_fields"
  token_claimed_at?: Maybe<Scalars["timestamp"]["output"]>
  token_expiry?: Maybe<Scalars["timestamp"]["output"]>
  token_generated_at?: Maybe<Scalars["timestamp"]["output"]>
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by min() on columns of table "password_reset_tokens" */
export type Password_Reset_Tokens_Min_Order_By = {
  token_claimed_at?: InputMaybe<Order_By>
  token_expiry?: InputMaybe<Order_By>
  token_generated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** response of any mutation on the table "password_reset_tokens" */
export type Password_Reset_Tokens_Mutation_Response = {
  __typename?: "password_reset_tokens_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Password_Reset_Tokens>
}

/** on_conflict condition type for table "password_reset_tokens" */
export type Password_Reset_Tokens_On_Conflict = {
  constraint: Password_Reset_Tokens_Constraint
  update_columns?: Array<Password_Reset_Tokens_Update_Column>
  where?: InputMaybe<Password_Reset_Tokens_Bool_Exp>
}

/** Ordering options when selecting data from "password_reset_tokens". */
export type Password_Reset_Tokens_Order_By = {
  token?: InputMaybe<Order_By>
  token_claimed_at?: InputMaybe<Order_By>
  token_expiry?: InputMaybe<Order_By>
  token_generated_at?: InputMaybe<Order_By>
  user?: InputMaybe<Users_Order_By>
  user_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: password_reset_tokens */
export type Password_Reset_Tokens_Pk_Columns_Input = {
  token: Scalars["bytea"]["input"]
  user_id: Scalars["bigint"]["input"]
}

/** select columns of table "password_reset_tokens" */
export enum Password_Reset_Tokens_Select_Column {
  /** column name */
  Token = "token",
  /** column name */
  TokenClaimedAt = "token_claimed_at",
  /** column name */
  TokenExpiry = "token_expiry",
  /** column name */
  TokenGeneratedAt = "token_generated_at",
  /** column name */
  UserId = "user_id",
}

/** input type for updating data in table "password_reset_tokens" */
export type Password_Reset_Tokens_Set_Input = {
  token?: InputMaybe<Scalars["bytea"]["input"]>
  token_claimed_at?: InputMaybe<Scalars["timestamp"]["input"]>
  token_expiry?: InputMaybe<Scalars["timestamp"]["input"]>
  token_generated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate stddev on columns */
export type Password_Reset_Tokens_Stddev_Fields = {
  __typename?: "password_reset_tokens_stddev_fields"
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "password_reset_tokens" */
export type Password_Reset_Tokens_Stddev_Order_By = {
  user_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Password_Reset_Tokens_Stddev_Pop_Fields = {
  __typename?: "password_reset_tokens_stddev_pop_fields"
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "password_reset_tokens" */
export type Password_Reset_Tokens_Stddev_Pop_Order_By = {
  user_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Password_Reset_Tokens_Stddev_Samp_Fields = {
  __typename?: "password_reset_tokens_stddev_samp_fields"
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "password_reset_tokens" */
export type Password_Reset_Tokens_Stddev_Samp_Order_By = {
  user_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "password_reset_tokens" */
export type Password_Reset_Tokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Password_Reset_Tokens_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Password_Reset_Tokens_Stream_Cursor_Value_Input = {
  token?: InputMaybe<Scalars["bytea"]["input"]>
  token_claimed_at?: InputMaybe<Scalars["timestamp"]["input"]>
  token_expiry?: InputMaybe<Scalars["timestamp"]["input"]>
  token_generated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate sum on columns */
export type Password_Reset_Tokens_Sum_Fields = {
  __typename?: "password_reset_tokens_sum_fields"
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "password_reset_tokens" */
export type Password_Reset_Tokens_Sum_Order_By = {
  user_id?: InputMaybe<Order_By>
}

/** update columns of table "password_reset_tokens" */
export enum Password_Reset_Tokens_Update_Column {
  /** column name */
  Token = "token",
  /** column name */
  TokenClaimedAt = "token_claimed_at",
  /** column name */
  TokenExpiry = "token_expiry",
  /** column name */
  TokenGeneratedAt = "token_generated_at",
  /** column name */
  UserId = "user_id",
}

export type Password_Reset_Tokens_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Password_Reset_Tokens_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Password_Reset_Tokens_Set_Input>
  /** filter the rows which have to be updated */
  where: Password_Reset_Tokens_Bool_Exp
}

/** aggregate var_pop on columns */
export type Password_Reset_Tokens_Var_Pop_Fields = {
  __typename?: "password_reset_tokens_var_pop_fields"
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "password_reset_tokens" */
export type Password_Reset_Tokens_Var_Pop_Order_By = {
  user_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Password_Reset_Tokens_Var_Samp_Fields = {
  __typename?: "password_reset_tokens_var_samp_fields"
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "password_reset_tokens" */
export type Password_Reset_Tokens_Var_Samp_Order_By = {
  user_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Password_Reset_Tokens_Variance_Fields = {
  __typename?: "password_reset_tokens_variance_fields"
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "password_reset_tokens" */
export type Password_Reset_Tokens_Variance_Order_By = {
  user_id?: InputMaybe<Order_By>
}

/** columns and relationships of "payment" */
export type Payment = {
  __typename?: "payment"
  amount: Scalars["numeric"]["output"]
  cancelled_at?: Maybe<Scalars["timestamp"]["output"]>
  collection_dt?: Maybe<Scalars["date"]["output"]>
  collection_request_dt?: Maybe<Scalars["date"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  currency: Scalars["String"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  payment_method_id?: Maybe<Scalars["bigint"]["output"]>
  posted_dt?: Maybe<Scalars["date"]["output"]>
  request_type: Scalars["payment_request_type"]["output"]
  status: Scalars["payment_status"]["output"]
  type?: Maybe<Scalars["payment_method_type"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "payment" */
export type Payment_Aggregate = {
  __typename?: "payment_aggregate"
  aggregate?: Maybe<Payment_Aggregate_Fields>
  nodes: Array<Payment>
}

/** aggregate fields of "payment" */
export type Payment_Aggregate_Fields = {
  __typename?: "payment_aggregate_fields"
  avg?: Maybe<Payment_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Payment_Max_Fields>
  min?: Maybe<Payment_Min_Fields>
  stddev?: Maybe<Payment_Stddev_Fields>
  stddev_pop?: Maybe<Payment_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Payment_Stddev_Samp_Fields>
  sum?: Maybe<Payment_Sum_Fields>
  var_pop?: Maybe<Payment_Var_Pop_Fields>
  var_samp?: Maybe<Payment_Var_Samp_Fields>
  variance?: Maybe<Payment_Variance_Fields>
}

/** aggregate fields of "payment" */
export type Payment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Payment_Avg_Fields = {
  __typename?: "payment_avg_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_method_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "payment". All fields are combined with a logical 'AND'. */
export type Payment_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Bool_Exp>>
  _not?: InputMaybe<Payment_Bool_Exp>
  _or?: InputMaybe<Array<Payment_Bool_Exp>>
  amount?: InputMaybe<Numeric_Comparison_Exp>
  cancelled_at?: InputMaybe<Timestamp_Comparison_Exp>
  collection_dt?: InputMaybe<Date_Comparison_Exp>
  collection_request_dt?: InputMaybe<Date_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  currency?: InputMaybe<String_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  payment_method_id?: InputMaybe<Bigint_Comparison_Exp>
  posted_dt?: InputMaybe<Date_Comparison_Exp>
  request_type?: InputMaybe<Payment_Request_Type_Comparison_Exp>
  status?: InputMaybe<Payment_Status_Comparison_Exp>
  type?: InputMaybe<Payment_Method_Type_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "payment" */
export enum Payment_Constraint {
  /** unique or primary key constraint on columns "id" */
  PaymentPkey = "payment_pkey",
}

/** input type for incrementing numeric columns in table "payment" */
export type Payment_Inc_Input = {
  amount?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_method_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "payment" */
export type Payment_Insert_Input = {
  amount?: InputMaybe<Scalars["numeric"]["input"]>
  cancelled_at?: InputMaybe<Scalars["timestamp"]["input"]>
  collection_dt?: InputMaybe<Scalars["date"]["input"]>
  collection_request_dt?: InputMaybe<Scalars["date"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  currency?: InputMaybe<Scalars["String"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_method_id?: InputMaybe<Scalars["bigint"]["input"]>
  posted_dt?: InputMaybe<Scalars["date"]["input"]>
  request_type?: InputMaybe<Scalars["payment_request_type"]["input"]>
  status?: InputMaybe<Scalars["payment_status"]["input"]>
  type?: InputMaybe<Scalars["payment_method_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Payment_Max_Fields = {
  __typename?: "payment_max_fields"
  amount?: Maybe<Scalars["numeric"]["output"]>
  cancelled_at?: Maybe<Scalars["timestamp"]["output"]>
  collection_dt?: Maybe<Scalars["date"]["output"]>
  collection_request_dt?: Maybe<Scalars["date"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  currency?: Maybe<Scalars["String"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  payment_method_id?: Maybe<Scalars["bigint"]["output"]>
  posted_dt?: Maybe<Scalars["date"]["output"]>
  request_type?: Maybe<Scalars["payment_request_type"]["output"]>
  status?: Maybe<Scalars["payment_status"]["output"]>
  type?: Maybe<Scalars["payment_method_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** columns and relationships of "payment_method" */
export type Payment_Method = {
  __typename?: "payment_method"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  default_status: Scalars["payment_method_default_status"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_dt?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  status: Scalars["payment_method_status"]["output"]
  to_dt?: Maybe<Scalars["timestamp"]["output"]>
  type: Scalars["payment_method_type"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "payment_method" */
export type Payment_Method_Aggregate = {
  __typename?: "payment_method_aggregate"
  aggregate?: Maybe<Payment_Method_Aggregate_Fields>
  nodes: Array<Payment_Method>
}

/** aggregate fields of "payment_method" */
export type Payment_Method_Aggregate_Fields = {
  __typename?: "payment_method_aggregate_fields"
  avg?: Maybe<Payment_Method_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Payment_Method_Max_Fields>
  min?: Maybe<Payment_Method_Min_Fields>
  stddev?: Maybe<Payment_Method_Stddev_Fields>
  stddev_pop?: Maybe<Payment_Method_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Payment_Method_Stddev_Samp_Fields>
  sum?: Maybe<Payment_Method_Sum_Fields>
  var_pop?: Maybe<Payment_Method_Var_Pop_Fields>
  var_samp?: Maybe<Payment_Method_Var_Samp_Fields>
  variance?: Maybe<Payment_Method_Variance_Fields>
}

/** aggregate fields of "payment_method" */
export type Payment_Method_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Method_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Payment_Method_Avg_Fields = {
  __typename?: "payment_method_avg_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "payment_method". All fields are combined with a logical 'AND'. */
export type Payment_Method_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Method_Bool_Exp>>
  _not?: InputMaybe<Payment_Method_Bool_Exp>
  _or?: InputMaybe<Array<Payment_Method_Bool_Exp>>
  billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  default_status?: InputMaybe<Payment_Method_Default_Status_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  from_dt?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  status?: InputMaybe<Payment_Method_Status_Comparison_Exp>
  to_dt?: InputMaybe<Timestamp_Comparison_Exp>
  type?: InputMaybe<Payment_Method_Type_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "payment_method" */
export enum Payment_Method_Constraint {
  /** unique or primary key constraint on columns "id" */
  PaymentMethodPkey = "payment_method_pkey",
}

/** Boolean expression to compare columns of type "payment_method_default_status". All fields are combined with logical 'AND'. */
export type Payment_Method_Default_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["payment_method_default_status"]["input"]>
  _gt?: InputMaybe<Scalars["payment_method_default_status"]["input"]>
  _gte?: InputMaybe<Scalars["payment_method_default_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["payment_method_default_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["payment_method_default_status"]["input"]>
  _lte?: InputMaybe<Scalars["payment_method_default_status"]["input"]>
  _neq?: InputMaybe<Scalars["payment_method_default_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["payment_method_default_status"]["input"]>>
}

/** input type for incrementing numeric columns in table "payment_method" */
export type Payment_Method_Inc_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "payment_method" */
export type Payment_Method_Insert_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  default_status?: InputMaybe<Scalars["payment_method_default_status"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["payment_method_status"]["input"]>
  to_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  type?: InputMaybe<Scalars["payment_method_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Payment_Method_Max_Fields = {
  __typename?: "payment_method_max_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  default_status?: Maybe<Scalars["payment_method_default_status"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_dt?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["payment_method_status"]["output"]>
  to_dt?: Maybe<Scalars["timestamp"]["output"]>
  type?: Maybe<Scalars["payment_method_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Payment_Method_Min_Fields = {
  __typename?: "payment_method_min_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  default_status?: Maybe<Scalars["payment_method_default_status"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  from_dt?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["payment_method_status"]["output"]>
  to_dt?: Maybe<Scalars["timestamp"]["output"]>
  type?: Maybe<Scalars["payment_method_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "payment_method" */
export type Payment_Method_Mutation_Response = {
  __typename?: "payment_method_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Method>
}

/** on_conflict condition type for table "payment_method" */
export type Payment_Method_On_Conflict = {
  constraint: Payment_Method_Constraint
  update_columns?: Array<Payment_Method_Update_Column>
  where?: InputMaybe<Payment_Method_Bool_Exp>
}

/** Ordering options when selecting data from "payment_method". */
export type Payment_Method_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  default_status?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  from_dt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  to_dt?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: payment_method */
export type Payment_Method_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "payment_method" */
export enum Payment_Method_Select_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DefaultStatus = "default_status",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FromDt = "from_dt",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  ToDt = "to_dt",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "payment_method" */
export type Payment_Method_Set_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  default_status?: InputMaybe<Scalars["payment_method_default_status"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["payment_method_status"]["input"]>
  to_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  type?: InputMaybe<Scalars["payment_method_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** Boolean expression to compare columns of type "payment_method_status". All fields are combined with logical 'AND'. */
export type Payment_Method_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["payment_method_status"]["input"]>
  _gt?: InputMaybe<Scalars["payment_method_status"]["input"]>
  _gte?: InputMaybe<Scalars["payment_method_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["payment_method_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["payment_method_status"]["input"]>
  _lte?: InputMaybe<Scalars["payment_method_status"]["input"]>
  _neq?: InputMaybe<Scalars["payment_method_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["payment_method_status"]["input"]>>
}

/** aggregate stddev on columns */
export type Payment_Method_Stddev_Fields = {
  __typename?: "payment_method_stddev_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Payment_Method_Stddev_Pop_Fields = {
  __typename?: "payment_method_stddev_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Payment_Method_Stddev_Samp_Fields = {
  __typename?: "payment_method_stddev_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "payment_method" */
export type Payment_Method_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Method_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Payment_Method_Stream_Cursor_Value_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  default_status?: InputMaybe<Scalars["payment_method_default_status"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  from_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["payment_method_status"]["input"]>
  to_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  type?: InputMaybe<Scalars["payment_method_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Payment_Method_Sum_Fields = {
  __typename?: "payment_method_sum_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** Boolean expression to compare columns of type "payment_method_type". All fields are combined with logical 'AND'. */
export type Payment_Method_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["payment_method_type"]["input"]>
  _gt?: InputMaybe<Scalars["payment_method_type"]["input"]>
  _gte?: InputMaybe<Scalars["payment_method_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["payment_method_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["payment_method_type"]["input"]>
  _lte?: InputMaybe<Scalars["payment_method_type"]["input"]>
  _neq?: InputMaybe<Scalars["payment_method_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["payment_method_type"]["input"]>>
}

/** update columns of table "payment_method" */
export enum Payment_Method_Update_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DefaultStatus = "default_status",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FromDt = "from_dt",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  ToDt = "to_dt",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Payment_Method_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Method_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Method_Set_Input>
  /** filter the rows which have to be updated */
  where: Payment_Method_Bool_Exp
}

/** aggregate var_pop on columns */
export type Payment_Method_Var_Pop_Fields = {
  __typename?: "payment_method_var_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Payment_Method_Var_Samp_Fields = {
  __typename?: "payment_method_var_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Payment_Method_Variance_Fields = {
  __typename?: "payment_method_variance_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate min on columns */
export type Payment_Min_Fields = {
  __typename?: "payment_min_fields"
  amount?: Maybe<Scalars["numeric"]["output"]>
  cancelled_at?: Maybe<Scalars["timestamp"]["output"]>
  collection_dt?: Maybe<Scalars["date"]["output"]>
  collection_request_dt?: Maybe<Scalars["date"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  currency?: Maybe<Scalars["String"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  payment_method_id?: Maybe<Scalars["bigint"]["output"]>
  posted_dt?: Maybe<Scalars["date"]["output"]>
  request_type?: Maybe<Scalars["payment_request_type"]["output"]>
  status?: Maybe<Scalars["payment_status"]["output"]>
  type?: Maybe<Scalars["payment_method_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "payment" */
export type Payment_Mutation_Response = {
  __typename?: "payment_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Payment>
}

/** Boolean expression to compare columns of type "payment_notification_status". All fields are combined with logical 'AND'. */
export type Payment_Notification_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["payment_notification_status"]["input"]>
  _gt?: InputMaybe<Scalars["payment_notification_status"]["input"]>
  _gte?: InputMaybe<Scalars["payment_notification_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["payment_notification_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["payment_notification_status"]["input"]>
  _lte?: InputMaybe<Scalars["payment_notification_status"]["input"]>
  _neq?: InputMaybe<Scalars["payment_notification_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["payment_notification_status"]["input"]>>
}

/** input type for inserting object relation for remote table "payment" */
export type Payment_Obj_Rel_Insert_Input = {
  data: Payment_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_On_Conflict>
}

/** on_conflict condition type for table "payment" */
export type Payment_On_Conflict = {
  constraint: Payment_Constraint
  update_columns?: Array<Payment_Update_Column>
  where?: InputMaybe<Payment_Bool_Exp>
}

/** Ordering options when selecting data from "payment". */
export type Payment_Order_By = {
  amount?: InputMaybe<Order_By>
  cancelled_at?: InputMaybe<Order_By>
  collection_dt?: InputMaybe<Order_By>
  collection_request_dt?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  currency?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  payment_method_id?: InputMaybe<Order_By>
  posted_dt?: InputMaybe<Order_By>
  request_type?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: payment */
export type Payment_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** Boolean expression to compare columns of type "payment_request_type". All fields are combined with logical 'AND'. */
export type Payment_Request_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["payment_request_type"]["input"]>
  _gt?: InputMaybe<Scalars["payment_request_type"]["input"]>
  _gte?: InputMaybe<Scalars["payment_request_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["payment_request_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["payment_request_type"]["input"]>
  _lte?: InputMaybe<Scalars["payment_request_type"]["input"]>
  _neq?: InputMaybe<Scalars["payment_request_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["payment_request_type"]["input"]>>
}

/** columns and relationships of "payment_review_account_balance_reserve_rates" */
export type Payment_Review_Account_Balance_Reserve_Rates = {
  __typename?: "payment_review_account_balance_reserve_rates"
  id: Scalars["bigint"]["output"]
  payment_spread: Scalars["payment_review_record_payment_spread"]["output"]
  rate: Scalars["numeric"]["output"]
  rate_month: Scalars["Int"]["output"]
}

/** aggregated selection of "payment_review_account_balance_reserve_rates" */
export type Payment_Review_Account_Balance_Reserve_Rates_Aggregate = {
  __typename?: "payment_review_account_balance_reserve_rates_aggregate"
  aggregate?: Maybe<Payment_Review_Account_Balance_Reserve_Rates_Aggregate_Fields>
  nodes: Array<Payment_Review_Account_Balance_Reserve_Rates>
}

/** aggregate fields of "payment_review_account_balance_reserve_rates" */
export type Payment_Review_Account_Balance_Reserve_Rates_Aggregate_Fields = {
  __typename?: "payment_review_account_balance_reserve_rates_aggregate_fields"
  avg?: Maybe<Payment_Review_Account_Balance_Reserve_Rates_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Payment_Review_Account_Balance_Reserve_Rates_Max_Fields>
  min?: Maybe<Payment_Review_Account_Balance_Reserve_Rates_Min_Fields>
  stddev?: Maybe<Payment_Review_Account_Balance_Reserve_Rates_Stddev_Fields>
  stddev_pop?: Maybe<Payment_Review_Account_Balance_Reserve_Rates_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Payment_Review_Account_Balance_Reserve_Rates_Stddev_Samp_Fields>
  sum?: Maybe<Payment_Review_Account_Balance_Reserve_Rates_Sum_Fields>
  var_pop?: Maybe<Payment_Review_Account_Balance_Reserve_Rates_Var_Pop_Fields>
  var_samp?: Maybe<Payment_Review_Account_Balance_Reserve_Rates_Var_Samp_Fields>
  variance?: Maybe<Payment_Review_Account_Balance_Reserve_Rates_Variance_Fields>
}

/** aggregate fields of "payment_review_account_balance_reserve_rates" */
export type Payment_Review_Account_Balance_Reserve_Rates_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Payment_Review_Account_Balance_Reserve_Rates_Select_Column>
    >
    distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  }

/** aggregate avg on columns */
export type Payment_Review_Account_Balance_Reserve_Rates_Avg_Fields = {
  __typename?: "payment_review_account_balance_reserve_rates_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  rate?: Maybe<Scalars["Float"]["output"]>
  rate_month?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "payment_review_account_balance_reserve_rates". All fields are combined with a logical 'AND'. */
export type Payment_Review_Account_Balance_Reserve_Rates_Bool_Exp = {
  _and?: InputMaybe<
    Array<Payment_Review_Account_Balance_Reserve_Rates_Bool_Exp>
  >
  _not?: InputMaybe<Payment_Review_Account_Balance_Reserve_Rates_Bool_Exp>
  _or?: InputMaybe<Array<Payment_Review_Account_Balance_Reserve_Rates_Bool_Exp>>
  id?: InputMaybe<Bigint_Comparison_Exp>
  payment_spread?: InputMaybe<Payment_Review_Record_Payment_Spread_Comparison_Exp>
  rate?: InputMaybe<Numeric_Comparison_Exp>
  rate_month?: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "payment_review_account_balance_reserve_rates" */
export enum Payment_Review_Account_Balance_Reserve_Rates_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkPaymentReviewAccountBalanceReserveRates = "pk_payment_review_account_balance_reserve_rates",
}

/** input type for incrementing numeric columns in table "payment_review_account_balance_reserve_rates" */
export type Payment_Review_Account_Balance_Reserve_Rates_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  rate?: InputMaybe<Scalars["numeric"]["input"]>
  rate_month?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "payment_review_account_balance_reserve_rates" */
export type Payment_Review_Account_Balance_Reserve_Rates_Insert_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_spread?: InputMaybe<
    Scalars["payment_review_record_payment_spread"]["input"]
  >
  rate?: InputMaybe<Scalars["numeric"]["input"]>
  rate_month?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate max on columns */
export type Payment_Review_Account_Balance_Reserve_Rates_Max_Fields = {
  __typename?: "payment_review_account_balance_reserve_rates_max_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  payment_spread?: Maybe<
    Scalars["payment_review_record_payment_spread"]["output"]
  >
  rate?: Maybe<Scalars["numeric"]["output"]>
  rate_month?: Maybe<Scalars["Int"]["output"]>
}

/** aggregate min on columns */
export type Payment_Review_Account_Balance_Reserve_Rates_Min_Fields = {
  __typename?: "payment_review_account_balance_reserve_rates_min_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  payment_spread?: Maybe<
    Scalars["payment_review_record_payment_spread"]["output"]
  >
  rate?: Maybe<Scalars["numeric"]["output"]>
  rate_month?: Maybe<Scalars["Int"]["output"]>
}

/** response of any mutation on the table "payment_review_account_balance_reserve_rates" */
export type Payment_Review_Account_Balance_Reserve_Rates_Mutation_Response = {
  __typename?: "payment_review_account_balance_reserve_rates_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Review_Account_Balance_Reserve_Rates>
}

/** on_conflict condition type for table "payment_review_account_balance_reserve_rates" */
export type Payment_Review_Account_Balance_Reserve_Rates_On_Conflict = {
  constraint: Payment_Review_Account_Balance_Reserve_Rates_Constraint
  update_columns?: Array<Payment_Review_Account_Balance_Reserve_Rates_Update_Column>
  where?: InputMaybe<Payment_Review_Account_Balance_Reserve_Rates_Bool_Exp>
}

/** Ordering options when selecting data from "payment_review_account_balance_reserve_rates". */
export type Payment_Review_Account_Balance_Reserve_Rates_Order_By = {
  id?: InputMaybe<Order_By>
  payment_spread?: InputMaybe<Order_By>
  rate?: InputMaybe<Order_By>
  rate_month?: InputMaybe<Order_By>
}

/** primary key columns input for table: payment_review_account_balance_reserve_rates */
export type Payment_Review_Account_Balance_Reserve_Rates_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "payment_review_account_balance_reserve_rates" */
export enum Payment_Review_Account_Balance_Reserve_Rates_Select_Column {
  /** column name */
  Id = "id",
  /** column name */
  PaymentSpread = "payment_spread",
  /** column name */
  Rate = "rate",
  /** column name */
  RateMonth = "rate_month",
}

/** input type for updating data in table "payment_review_account_balance_reserve_rates" */
export type Payment_Review_Account_Balance_Reserve_Rates_Set_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_spread?: InputMaybe<
    Scalars["payment_review_record_payment_spread"]["input"]
  >
  rate?: InputMaybe<Scalars["numeric"]["input"]>
  rate_month?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate stddev on columns */
export type Payment_Review_Account_Balance_Reserve_Rates_Stddev_Fields = {
  __typename?: "payment_review_account_balance_reserve_rates_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  rate?: Maybe<Scalars["Float"]["output"]>
  rate_month?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Payment_Review_Account_Balance_Reserve_Rates_Stddev_Pop_Fields = {
  __typename?: "payment_review_account_balance_reserve_rates_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  rate?: Maybe<Scalars["Float"]["output"]>
  rate_month?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Payment_Review_Account_Balance_Reserve_Rates_Stddev_Samp_Fields = {
  __typename?: "payment_review_account_balance_reserve_rates_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  rate?: Maybe<Scalars["Float"]["output"]>
  rate_month?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "payment_review_account_balance_reserve_rates" */
export type Payment_Review_Account_Balance_Reserve_Rates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Review_Account_Balance_Reserve_Rates_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Payment_Review_Account_Balance_Reserve_Rates_Stream_Cursor_Value_Input =
  {
    id?: InputMaybe<Scalars["bigint"]["input"]>
    payment_spread?: InputMaybe<
      Scalars["payment_review_record_payment_spread"]["input"]
    >
    rate?: InputMaybe<Scalars["numeric"]["input"]>
    rate_month?: InputMaybe<Scalars["Int"]["input"]>
  }

/** aggregate sum on columns */
export type Payment_Review_Account_Balance_Reserve_Rates_Sum_Fields = {
  __typename?: "payment_review_account_balance_reserve_rates_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  rate?: Maybe<Scalars["numeric"]["output"]>
  rate_month?: Maybe<Scalars["Int"]["output"]>
}

/** update columns of table "payment_review_account_balance_reserve_rates" */
export enum Payment_Review_Account_Balance_Reserve_Rates_Update_Column {
  /** column name */
  Id = "id",
  /** column name */
  PaymentSpread = "payment_spread",
  /** column name */
  Rate = "rate",
  /** column name */
  RateMonth = "rate_month",
}

export type Payment_Review_Account_Balance_Reserve_Rates_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Review_Account_Balance_Reserve_Rates_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Review_Account_Balance_Reserve_Rates_Set_Input>
  /** filter the rows which have to be updated */
  where: Payment_Review_Account_Balance_Reserve_Rates_Bool_Exp
}

/** aggregate var_pop on columns */
export type Payment_Review_Account_Balance_Reserve_Rates_Var_Pop_Fields = {
  __typename?: "payment_review_account_balance_reserve_rates_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  rate?: Maybe<Scalars["Float"]["output"]>
  rate_month?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Payment_Review_Account_Balance_Reserve_Rates_Var_Samp_Fields = {
  __typename?: "payment_review_account_balance_reserve_rates_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  rate?: Maybe<Scalars["Float"]["output"]>
  rate_month?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Payment_Review_Account_Balance_Reserve_Rates_Variance_Fields = {
  __typename?: "payment_review_account_balance_reserve_rates_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  rate?: Maybe<Scalars["Float"]["output"]>
  rate_month?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "payment_review_account_exclusions" */
export type Payment_Review_Account_Exclusions = {
  __typename?: "payment_review_account_exclusions"
  account_id: Scalars["bigint"]["output"]
  created_at: Scalars["timestamptz"]["output"]
  id: Scalars["bigint"]["output"]
  payment_review_id: Scalars["bigint"]["output"]
}

/** aggregated selection of "payment_review_account_exclusions" */
export type Payment_Review_Account_Exclusions_Aggregate = {
  __typename?: "payment_review_account_exclusions_aggregate"
  aggregate?: Maybe<Payment_Review_Account_Exclusions_Aggregate_Fields>
  nodes: Array<Payment_Review_Account_Exclusions>
}

/** aggregate fields of "payment_review_account_exclusions" */
export type Payment_Review_Account_Exclusions_Aggregate_Fields = {
  __typename?: "payment_review_account_exclusions_aggregate_fields"
  avg?: Maybe<Payment_Review_Account_Exclusions_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Payment_Review_Account_Exclusions_Max_Fields>
  min?: Maybe<Payment_Review_Account_Exclusions_Min_Fields>
  stddev?: Maybe<Payment_Review_Account_Exclusions_Stddev_Fields>
  stddev_pop?: Maybe<Payment_Review_Account_Exclusions_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Payment_Review_Account_Exclusions_Stddev_Samp_Fields>
  sum?: Maybe<Payment_Review_Account_Exclusions_Sum_Fields>
  var_pop?: Maybe<Payment_Review_Account_Exclusions_Var_Pop_Fields>
  var_samp?: Maybe<Payment_Review_Account_Exclusions_Var_Samp_Fields>
  variance?: Maybe<Payment_Review_Account_Exclusions_Variance_Fields>
}

/** aggregate fields of "payment_review_account_exclusions" */
export type Payment_Review_Account_Exclusions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Review_Account_Exclusions_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Payment_Review_Account_Exclusions_Avg_Fields = {
  __typename?: "payment_review_account_exclusions_avg_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_review_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "payment_review_account_exclusions". All fields are combined with a logical 'AND'. */
export type Payment_Review_Account_Exclusions_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Review_Account_Exclusions_Bool_Exp>>
  _not?: InputMaybe<Payment_Review_Account_Exclusions_Bool_Exp>
  _or?: InputMaybe<Array<Payment_Review_Account_Exclusions_Bool_Exp>>
  account_id?: InputMaybe<Bigint_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  payment_review_id?: InputMaybe<Bigint_Comparison_Exp>
}

/** unique or primary key constraints on table "payment_review_account_exclusions" */
export enum Payment_Review_Account_Exclusions_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkPaymentReviewAccountExclusions = "pk_payment_review_account_exclusions",
  /** unique or primary key constraint on columns "account_id", "payment_review_id" */
  UniqueConstraintAccountIdAndReviewId = "unique_constraint_account_id_and_review_id",
}

/** input type for incrementing numeric columns in table "payment_review_account_exclusions" */
export type Payment_Review_Account_Exclusions_Inc_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_review_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "payment_review_account_exclusions" */
export type Payment_Review_Account_Exclusions_Insert_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_review_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate max on columns */
export type Payment_Review_Account_Exclusions_Max_Fields = {
  __typename?: "payment_review_account_exclusions_max_fields"
  account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  payment_review_id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregate min on columns */
export type Payment_Review_Account_Exclusions_Min_Fields = {
  __typename?: "payment_review_account_exclusions_min_fields"
  account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  payment_review_id?: Maybe<Scalars["bigint"]["output"]>
}

/** response of any mutation on the table "payment_review_account_exclusions" */
export type Payment_Review_Account_Exclusions_Mutation_Response = {
  __typename?: "payment_review_account_exclusions_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Review_Account_Exclusions>
}

/** on_conflict condition type for table "payment_review_account_exclusions" */
export type Payment_Review_Account_Exclusions_On_Conflict = {
  constraint: Payment_Review_Account_Exclusions_Constraint
  update_columns?: Array<Payment_Review_Account_Exclusions_Update_Column>
  where?: InputMaybe<Payment_Review_Account_Exclusions_Bool_Exp>
}

/** Ordering options when selecting data from "payment_review_account_exclusions". */
export type Payment_Review_Account_Exclusions_Order_By = {
  account_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  payment_review_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: payment_review_account_exclusions */
export type Payment_Review_Account_Exclusions_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "payment_review_account_exclusions" */
export enum Payment_Review_Account_Exclusions_Select_Column {
  /** column name */
  AccountId = "account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  PaymentReviewId = "payment_review_id",
}

/** input type for updating data in table "payment_review_account_exclusions" */
export type Payment_Review_Account_Exclusions_Set_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_review_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate stddev on columns */
export type Payment_Review_Account_Exclusions_Stddev_Fields = {
  __typename?: "payment_review_account_exclusions_stddev_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_review_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Payment_Review_Account_Exclusions_Stddev_Pop_Fields = {
  __typename?: "payment_review_account_exclusions_stddev_pop_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_review_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Payment_Review_Account_Exclusions_Stddev_Samp_Fields = {
  __typename?: "payment_review_account_exclusions_stddev_samp_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_review_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "payment_review_account_exclusions" */
export type Payment_Review_Account_Exclusions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Review_Account_Exclusions_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Payment_Review_Account_Exclusions_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_review_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate sum on columns */
export type Payment_Review_Account_Exclusions_Sum_Fields = {
  __typename?: "payment_review_account_exclusions_sum_fields"
  account_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  payment_review_id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "payment_review_account_exclusions" */
export enum Payment_Review_Account_Exclusions_Update_Column {
  /** column name */
  AccountId = "account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  PaymentReviewId = "payment_review_id",
}

export type Payment_Review_Account_Exclusions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Review_Account_Exclusions_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Review_Account_Exclusions_Set_Input>
  /** filter the rows which have to be updated */
  where: Payment_Review_Account_Exclusions_Bool_Exp
}

/** aggregate var_pop on columns */
export type Payment_Review_Account_Exclusions_Var_Pop_Fields = {
  __typename?: "payment_review_account_exclusions_var_pop_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_review_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Payment_Review_Account_Exclusions_Var_Samp_Fields = {
  __typename?: "payment_review_account_exclusions_var_samp_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_review_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Payment_Review_Account_Exclusions_Variance_Fields = {
  __typename?: "payment_review_account_exclusions_variance_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_review_id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "payment_review_calculation" */
export type Payment_Review_Calculation = {
  __typename?: "payment_review_calculation"
  account_balance?: Maybe<Scalars["numeric"]["output"]>
  account_balance_applied?: Maybe<Scalars["numeric"]["output"]>
  account_balance_reserve?: Maybe<Scalars["numeric"]["output"]>
  account_balance_reserve_rate_percentage?: Maybe<Scalars["numeric"]["output"]>
  account_effective_balance_applied?: Maybe<Scalars["numeric"]["output"]>
  account_total?: Maybe<Scalars["numeric"]["output"]>
  annual_standard_charge_cost: Scalars["numeric"]["output"]
  /** An array relationship */
  calculation_items: Array<Calculation_Items>
  /** An aggregate relationship */
  calculation_items_aggregate: Calculation_Items_Aggregate
  created_at: Scalars["timestamptz"]["output"]
  estimate_annual_cost?: Maybe<Scalars["numeric"]["output"]>
  id: Scalars["bigint"]["output"]
  monthly_standard_charge_cost: Scalars["numeric"]["output"]
  new_monthly_amount: Scalars["numeric"]["output"]
  new_monthly_amount_without_balance?: Maybe<Scalars["numeric"]["output"]>
  new_monthly_amount_without_checks: Scalars["numeric"]["output"]
  next_payment_date?: Maybe<Scalars["date"]["output"]>
  /** An object relationship */
  payment_review_record: Payment_Review_Records
  payment_review_record_id: Scalars["bigint"]["output"]
  payment_type?: Maybe<
    Scalars["payment_review_calculation_payment_spread"]["output"]
  >
}

/** columns and relationships of "payment_review_calculation" */
export type Payment_Review_CalculationCalculation_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Calculation_Items_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Calculation_Items_Order_By>>
  where?: InputMaybe<Calculation_Items_Bool_Exp>
}

/** columns and relationships of "payment_review_calculation" */
export type Payment_Review_CalculationCalculation_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Calculation_Items_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Calculation_Items_Order_By>>
  where?: InputMaybe<Calculation_Items_Bool_Exp>
}

/** aggregated selection of "payment_review_calculation" */
export type Payment_Review_Calculation_Aggregate = {
  __typename?: "payment_review_calculation_aggregate"
  aggregate?: Maybe<Payment_Review_Calculation_Aggregate_Fields>
  nodes: Array<Payment_Review_Calculation>
}

export type Payment_Review_Calculation_Aggregate_Bool_Exp = {
  count?: InputMaybe<Payment_Review_Calculation_Aggregate_Bool_Exp_Count>
}

export type Payment_Review_Calculation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Payment_Review_Calculation_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Payment_Review_Calculation_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "payment_review_calculation" */
export type Payment_Review_Calculation_Aggregate_Fields = {
  __typename?: "payment_review_calculation_aggregate_fields"
  avg?: Maybe<Payment_Review_Calculation_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Payment_Review_Calculation_Max_Fields>
  min?: Maybe<Payment_Review_Calculation_Min_Fields>
  stddev?: Maybe<Payment_Review_Calculation_Stddev_Fields>
  stddev_pop?: Maybe<Payment_Review_Calculation_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Payment_Review_Calculation_Stddev_Samp_Fields>
  sum?: Maybe<Payment_Review_Calculation_Sum_Fields>
  var_pop?: Maybe<Payment_Review_Calculation_Var_Pop_Fields>
  var_samp?: Maybe<Payment_Review_Calculation_Var_Samp_Fields>
  variance?: Maybe<Payment_Review_Calculation_Variance_Fields>
}

/** aggregate fields of "payment_review_calculation" */
export type Payment_Review_Calculation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Review_Calculation_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "payment_review_calculation" */
export type Payment_Review_Calculation_Aggregate_Order_By = {
  avg?: InputMaybe<Payment_Review_Calculation_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Payment_Review_Calculation_Max_Order_By>
  min?: InputMaybe<Payment_Review_Calculation_Min_Order_By>
  stddev?: InputMaybe<Payment_Review_Calculation_Stddev_Order_By>
  stddev_pop?: InputMaybe<Payment_Review_Calculation_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Payment_Review_Calculation_Stddev_Samp_Order_By>
  sum?: InputMaybe<Payment_Review_Calculation_Sum_Order_By>
  var_pop?: InputMaybe<Payment_Review_Calculation_Var_Pop_Order_By>
  var_samp?: InputMaybe<Payment_Review_Calculation_Var_Samp_Order_By>
  variance?: InputMaybe<Payment_Review_Calculation_Variance_Order_By>
}

/** input type for inserting array relation for remote table "payment_review_calculation" */
export type Payment_Review_Calculation_Arr_Rel_Insert_Input = {
  data: Array<Payment_Review_Calculation_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_Review_Calculation_On_Conflict>
}

/** aggregate avg on columns */
export type Payment_Review_Calculation_Avg_Fields = {
  __typename?: "payment_review_calculation_avg_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  account_balance_applied?: Maybe<Scalars["Float"]["output"]>
  account_balance_reserve?: Maybe<Scalars["Float"]["output"]>
  account_balance_reserve_rate_percentage?: Maybe<Scalars["Float"]["output"]>
  account_effective_balance_applied?: Maybe<Scalars["Float"]["output"]>
  account_total?: Maybe<Scalars["Float"]["output"]>
  annual_standard_charge_cost?: Maybe<Scalars["Float"]["output"]>
  estimate_annual_cost?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  monthly_standard_charge_cost?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount_without_balance?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount_without_checks?: Maybe<Scalars["Float"]["output"]>
  payment_review_record_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "payment_review_calculation" */
export type Payment_Review_Calculation_Avg_Order_By = {
  account_balance?: InputMaybe<Order_By>
  account_balance_applied?: InputMaybe<Order_By>
  account_balance_reserve?: InputMaybe<Order_By>
  account_balance_reserve_rate_percentage?: InputMaybe<Order_By>
  account_effective_balance_applied?: InputMaybe<Order_By>
  account_total?: InputMaybe<Order_By>
  annual_standard_charge_cost?: InputMaybe<Order_By>
  estimate_annual_cost?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  monthly_standard_charge_cost?: InputMaybe<Order_By>
  new_monthly_amount?: InputMaybe<Order_By>
  new_monthly_amount_without_balance?: InputMaybe<Order_By>
  new_monthly_amount_without_checks?: InputMaybe<Order_By>
  payment_review_record_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "payment_review_calculation". All fields are combined with a logical 'AND'. */
export type Payment_Review_Calculation_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Review_Calculation_Bool_Exp>>
  _not?: InputMaybe<Payment_Review_Calculation_Bool_Exp>
  _or?: InputMaybe<Array<Payment_Review_Calculation_Bool_Exp>>
  account_balance?: InputMaybe<Numeric_Comparison_Exp>
  account_balance_applied?: InputMaybe<Numeric_Comparison_Exp>
  account_balance_reserve?: InputMaybe<Numeric_Comparison_Exp>
  account_balance_reserve_rate_percentage?: InputMaybe<Numeric_Comparison_Exp>
  account_effective_balance_applied?: InputMaybe<Numeric_Comparison_Exp>
  account_total?: InputMaybe<Numeric_Comparison_Exp>
  annual_standard_charge_cost?: InputMaybe<Numeric_Comparison_Exp>
  calculation_items?: InputMaybe<Calculation_Items_Bool_Exp>
  calculation_items_aggregate?: InputMaybe<Calculation_Items_Aggregate_Bool_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  estimate_annual_cost?: InputMaybe<Numeric_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  monthly_standard_charge_cost?: InputMaybe<Numeric_Comparison_Exp>
  new_monthly_amount?: InputMaybe<Numeric_Comparison_Exp>
  new_monthly_amount_without_balance?: InputMaybe<Numeric_Comparison_Exp>
  new_monthly_amount_without_checks?: InputMaybe<Numeric_Comparison_Exp>
  next_payment_date?: InputMaybe<Date_Comparison_Exp>
  payment_review_record?: InputMaybe<Payment_Review_Records_Bool_Exp>
  payment_review_record_id?: InputMaybe<Bigint_Comparison_Exp>
  payment_type?: InputMaybe<Payment_Review_Calculation_Payment_Spread_Comparison_Exp>
}

/** unique or primary key constraints on table "payment_review_calculation" */
export enum Payment_Review_Calculation_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkPaymentReviewCalculation = "pk_payment_review_calculation",
}

/** input type for incrementing numeric columns in table "payment_review_calculation" */
export type Payment_Review_Calculation_Inc_Input = {
  account_balance?: InputMaybe<Scalars["numeric"]["input"]>
  account_balance_applied?: InputMaybe<Scalars["numeric"]["input"]>
  account_balance_reserve?: InputMaybe<Scalars["numeric"]["input"]>
  account_balance_reserve_rate_percentage?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  account_effective_balance_applied?: InputMaybe<Scalars["numeric"]["input"]>
  account_total?: InputMaybe<Scalars["numeric"]["input"]>
  annual_standard_charge_cost?: InputMaybe<Scalars["numeric"]["input"]>
  estimate_annual_cost?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  monthly_standard_charge_cost?: InputMaybe<Scalars["numeric"]["input"]>
  new_monthly_amount?: InputMaybe<Scalars["numeric"]["input"]>
  new_monthly_amount_without_balance?: InputMaybe<Scalars["numeric"]["input"]>
  new_monthly_amount_without_checks?: InputMaybe<Scalars["numeric"]["input"]>
  payment_review_record_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "payment_review_calculation" */
export type Payment_Review_Calculation_Insert_Input = {
  account_balance?: InputMaybe<Scalars["numeric"]["input"]>
  account_balance_applied?: InputMaybe<Scalars["numeric"]["input"]>
  account_balance_reserve?: InputMaybe<Scalars["numeric"]["input"]>
  account_balance_reserve_rate_percentage?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  account_effective_balance_applied?: InputMaybe<Scalars["numeric"]["input"]>
  account_total?: InputMaybe<Scalars["numeric"]["input"]>
  annual_standard_charge_cost?: InputMaybe<Scalars["numeric"]["input"]>
  calculation_items?: InputMaybe<Calculation_Items_Arr_Rel_Insert_Input>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  estimate_annual_cost?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  monthly_standard_charge_cost?: InputMaybe<Scalars["numeric"]["input"]>
  new_monthly_amount?: InputMaybe<Scalars["numeric"]["input"]>
  new_monthly_amount_without_balance?: InputMaybe<Scalars["numeric"]["input"]>
  new_monthly_amount_without_checks?: InputMaybe<Scalars["numeric"]["input"]>
  next_payment_date?: InputMaybe<Scalars["date"]["input"]>
  payment_review_record?: InputMaybe<Payment_Review_Records_Obj_Rel_Insert_Input>
  payment_review_record_id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_type?: InputMaybe<
    Scalars["payment_review_calculation_payment_spread"]["input"]
  >
}

/** aggregate max on columns */
export type Payment_Review_Calculation_Max_Fields = {
  __typename?: "payment_review_calculation_max_fields"
  account_balance?: Maybe<Scalars["numeric"]["output"]>
  account_balance_applied?: Maybe<Scalars["numeric"]["output"]>
  account_balance_reserve?: Maybe<Scalars["numeric"]["output"]>
  account_balance_reserve_rate_percentage?: Maybe<Scalars["numeric"]["output"]>
  account_effective_balance_applied?: Maybe<Scalars["numeric"]["output"]>
  account_total?: Maybe<Scalars["numeric"]["output"]>
  annual_standard_charge_cost?: Maybe<Scalars["numeric"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  estimate_annual_cost?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  monthly_standard_charge_cost?: Maybe<Scalars["numeric"]["output"]>
  new_monthly_amount?: Maybe<Scalars["numeric"]["output"]>
  new_monthly_amount_without_balance?: Maybe<Scalars["numeric"]["output"]>
  new_monthly_amount_without_checks?: Maybe<Scalars["numeric"]["output"]>
  next_payment_date?: Maybe<Scalars["date"]["output"]>
  payment_review_record_id?: Maybe<Scalars["bigint"]["output"]>
  payment_type?: Maybe<
    Scalars["payment_review_calculation_payment_spread"]["output"]
  >
}

/** order by max() on columns of table "payment_review_calculation" */
export type Payment_Review_Calculation_Max_Order_By = {
  account_balance?: InputMaybe<Order_By>
  account_balance_applied?: InputMaybe<Order_By>
  account_balance_reserve?: InputMaybe<Order_By>
  account_balance_reserve_rate_percentage?: InputMaybe<Order_By>
  account_effective_balance_applied?: InputMaybe<Order_By>
  account_total?: InputMaybe<Order_By>
  annual_standard_charge_cost?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  estimate_annual_cost?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  monthly_standard_charge_cost?: InputMaybe<Order_By>
  new_monthly_amount?: InputMaybe<Order_By>
  new_monthly_amount_without_balance?: InputMaybe<Order_By>
  new_monthly_amount_without_checks?: InputMaybe<Order_By>
  next_payment_date?: InputMaybe<Order_By>
  payment_review_record_id?: InputMaybe<Order_By>
  payment_type?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Payment_Review_Calculation_Min_Fields = {
  __typename?: "payment_review_calculation_min_fields"
  account_balance?: Maybe<Scalars["numeric"]["output"]>
  account_balance_applied?: Maybe<Scalars["numeric"]["output"]>
  account_balance_reserve?: Maybe<Scalars["numeric"]["output"]>
  account_balance_reserve_rate_percentage?: Maybe<Scalars["numeric"]["output"]>
  account_effective_balance_applied?: Maybe<Scalars["numeric"]["output"]>
  account_total?: Maybe<Scalars["numeric"]["output"]>
  annual_standard_charge_cost?: Maybe<Scalars["numeric"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  estimate_annual_cost?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  monthly_standard_charge_cost?: Maybe<Scalars["numeric"]["output"]>
  new_monthly_amount?: Maybe<Scalars["numeric"]["output"]>
  new_monthly_amount_without_balance?: Maybe<Scalars["numeric"]["output"]>
  new_monthly_amount_without_checks?: Maybe<Scalars["numeric"]["output"]>
  next_payment_date?: Maybe<Scalars["date"]["output"]>
  payment_review_record_id?: Maybe<Scalars["bigint"]["output"]>
  payment_type?: Maybe<
    Scalars["payment_review_calculation_payment_spread"]["output"]
  >
}

/** order by min() on columns of table "payment_review_calculation" */
export type Payment_Review_Calculation_Min_Order_By = {
  account_balance?: InputMaybe<Order_By>
  account_balance_applied?: InputMaybe<Order_By>
  account_balance_reserve?: InputMaybe<Order_By>
  account_balance_reserve_rate_percentage?: InputMaybe<Order_By>
  account_effective_balance_applied?: InputMaybe<Order_By>
  account_total?: InputMaybe<Order_By>
  annual_standard_charge_cost?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  estimate_annual_cost?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  monthly_standard_charge_cost?: InputMaybe<Order_By>
  new_monthly_amount?: InputMaybe<Order_By>
  new_monthly_amount_without_balance?: InputMaybe<Order_By>
  new_monthly_amount_without_checks?: InputMaybe<Order_By>
  next_payment_date?: InputMaybe<Order_By>
  payment_review_record_id?: InputMaybe<Order_By>
  payment_type?: InputMaybe<Order_By>
}

/** response of any mutation on the table "payment_review_calculation" */
export type Payment_Review_Calculation_Mutation_Response = {
  __typename?: "payment_review_calculation_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Review_Calculation>
}

/** on_conflict condition type for table "payment_review_calculation" */
export type Payment_Review_Calculation_On_Conflict = {
  constraint: Payment_Review_Calculation_Constraint
  update_columns?: Array<Payment_Review_Calculation_Update_Column>
  where?: InputMaybe<Payment_Review_Calculation_Bool_Exp>
}

/** Ordering options when selecting data from "payment_review_calculation". */
export type Payment_Review_Calculation_Order_By = {
  account_balance?: InputMaybe<Order_By>
  account_balance_applied?: InputMaybe<Order_By>
  account_balance_reserve?: InputMaybe<Order_By>
  account_balance_reserve_rate_percentage?: InputMaybe<Order_By>
  account_effective_balance_applied?: InputMaybe<Order_By>
  account_total?: InputMaybe<Order_By>
  annual_standard_charge_cost?: InputMaybe<Order_By>
  calculation_items_aggregate?: InputMaybe<Calculation_Items_Aggregate_Order_By>
  created_at?: InputMaybe<Order_By>
  estimate_annual_cost?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  monthly_standard_charge_cost?: InputMaybe<Order_By>
  new_monthly_amount?: InputMaybe<Order_By>
  new_monthly_amount_without_balance?: InputMaybe<Order_By>
  new_monthly_amount_without_checks?: InputMaybe<Order_By>
  next_payment_date?: InputMaybe<Order_By>
  payment_review_record?: InputMaybe<Payment_Review_Records_Order_By>
  payment_review_record_id?: InputMaybe<Order_By>
  payment_type?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "payment_review_calculation_payment_spread". All fields are combined with logical 'AND'. */
export type Payment_Review_Calculation_Payment_Spread_Comparison_Exp = {
  _eq?: InputMaybe<
    Scalars["payment_review_calculation_payment_spread"]["input"]
  >
  _gt?: InputMaybe<
    Scalars["payment_review_calculation_payment_spread"]["input"]
  >
  _gte?: InputMaybe<
    Scalars["payment_review_calculation_payment_spread"]["input"]
  >
  _in?: InputMaybe<
    Array<Scalars["payment_review_calculation_payment_spread"]["input"]>
  >
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<
    Scalars["payment_review_calculation_payment_spread"]["input"]
  >
  _lte?: InputMaybe<
    Scalars["payment_review_calculation_payment_spread"]["input"]
  >
  _neq?: InputMaybe<
    Scalars["payment_review_calculation_payment_spread"]["input"]
  >
  _nin?: InputMaybe<
    Array<Scalars["payment_review_calculation_payment_spread"]["input"]>
  >
}

/** primary key columns input for table: payment_review_calculation */
export type Payment_Review_Calculation_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "payment_review_calculation" */
export enum Payment_Review_Calculation_Select_Column {
  /** column name */
  AccountBalance = "account_balance",
  /** column name */
  AccountBalanceApplied = "account_balance_applied",
  /** column name */
  AccountBalanceReserve = "account_balance_reserve",
  /** column name */
  AccountBalanceReserveRatePercentage = "account_balance_reserve_rate_percentage",
  /** column name */
  AccountEffectiveBalanceApplied = "account_effective_balance_applied",
  /** column name */
  AccountTotal = "account_total",
  /** column name */
  AnnualStandardChargeCost = "annual_standard_charge_cost",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  EstimateAnnualCost = "estimate_annual_cost",
  /** column name */
  Id = "id",
  /** column name */
  MonthlyStandardChargeCost = "monthly_standard_charge_cost",
  /** column name */
  NewMonthlyAmount = "new_monthly_amount",
  /** column name */
  NewMonthlyAmountWithoutBalance = "new_monthly_amount_without_balance",
  /** column name */
  NewMonthlyAmountWithoutChecks = "new_monthly_amount_without_checks",
  /** column name */
  NextPaymentDate = "next_payment_date",
  /** column name */
  PaymentReviewRecordId = "payment_review_record_id",
  /** column name */
  PaymentType = "payment_type",
}

/** input type for updating data in table "payment_review_calculation" */
export type Payment_Review_Calculation_Set_Input = {
  account_balance?: InputMaybe<Scalars["numeric"]["input"]>
  account_balance_applied?: InputMaybe<Scalars["numeric"]["input"]>
  account_balance_reserve?: InputMaybe<Scalars["numeric"]["input"]>
  account_balance_reserve_rate_percentage?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  account_effective_balance_applied?: InputMaybe<Scalars["numeric"]["input"]>
  account_total?: InputMaybe<Scalars["numeric"]["input"]>
  annual_standard_charge_cost?: InputMaybe<Scalars["numeric"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  estimate_annual_cost?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  monthly_standard_charge_cost?: InputMaybe<Scalars["numeric"]["input"]>
  new_monthly_amount?: InputMaybe<Scalars["numeric"]["input"]>
  new_monthly_amount_without_balance?: InputMaybe<Scalars["numeric"]["input"]>
  new_monthly_amount_without_checks?: InputMaybe<Scalars["numeric"]["input"]>
  next_payment_date?: InputMaybe<Scalars["date"]["input"]>
  payment_review_record_id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_type?: InputMaybe<
    Scalars["payment_review_calculation_payment_spread"]["input"]
  >
}

/** aggregate stddev on columns */
export type Payment_Review_Calculation_Stddev_Fields = {
  __typename?: "payment_review_calculation_stddev_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  account_balance_applied?: Maybe<Scalars["Float"]["output"]>
  account_balance_reserve?: Maybe<Scalars["Float"]["output"]>
  account_balance_reserve_rate_percentage?: Maybe<Scalars["Float"]["output"]>
  account_effective_balance_applied?: Maybe<Scalars["Float"]["output"]>
  account_total?: Maybe<Scalars["Float"]["output"]>
  annual_standard_charge_cost?: Maybe<Scalars["Float"]["output"]>
  estimate_annual_cost?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  monthly_standard_charge_cost?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount_without_balance?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount_without_checks?: Maybe<Scalars["Float"]["output"]>
  payment_review_record_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "payment_review_calculation" */
export type Payment_Review_Calculation_Stddev_Order_By = {
  account_balance?: InputMaybe<Order_By>
  account_balance_applied?: InputMaybe<Order_By>
  account_balance_reserve?: InputMaybe<Order_By>
  account_balance_reserve_rate_percentage?: InputMaybe<Order_By>
  account_effective_balance_applied?: InputMaybe<Order_By>
  account_total?: InputMaybe<Order_By>
  annual_standard_charge_cost?: InputMaybe<Order_By>
  estimate_annual_cost?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  monthly_standard_charge_cost?: InputMaybe<Order_By>
  new_monthly_amount?: InputMaybe<Order_By>
  new_monthly_amount_without_balance?: InputMaybe<Order_By>
  new_monthly_amount_without_checks?: InputMaybe<Order_By>
  payment_review_record_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Payment_Review_Calculation_Stddev_Pop_Fields = {
  __typename?: "payment_review_calculation_stddev_pop_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  account_balance_applied?: Maybe<Scalars["Float"]["output"]>
  account_balance_reserve?: Maybe<Scalars["Float"]["output"]>
  account_balance_reserve_rate_percentage?: Maybe<Scalars["Float"]["output"]>
  account_effective_balance_applied?: Maybe<Scalars["Float"]["output"]>
  account_total?: Maybe<Scalars["Float"]["output"]>
  annual_standard_charge_cost?: Maybe<Scalars["Float"]["output"]>
  estimate_annual_cost?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  monthly_standard_charge_cost?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount_without_balance?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount_without_checks?: Maybe<Scalars["Float"]["output"]>
  payment_review_record_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "payment_review_calculation" */
export type Payment_Review_Calculation_Stddev_Pop_Order_By = {
  account_balance?: InputMaybe<Order_By>
  account_balance_applied?: InputMaybe<Order_By>
  account_balance_reserve?: InputMaybe<Order_By>
  account_balance_reserve_rate_percentage?: InputMaybe<Order_By>
  account_effective_balance_applied?: InputMaybe<Order_By>
  account_total?: InputMaybe<Order_By>
  annual_standard_charge_cost?: InputMaybe<Order_By>
  estimate_annual_cost?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  monthly_standard_charge_cost?: InputMaybe<Order_By>
  new_monthly_amount?: InputMaybe<Order_By>
  new_monthly_amount_without_balance?: InputMaybe<Order_By>
  new_monthly_amount_without_checks?: InputMaybe<Order_By>
  payment_review_record_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Payment_Review_Calculation_Stddev_Samp_Fields = {
  __typename?: "payment_review_calculation_stddev_samp_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  account_balance_applied?: Maybe<Scalars["Float"]["output"]>
  account_balance_reserve?: Maybe<Scalars["Float"]["output"]>
  account_balance_reserve_rate_percentage?: Maybe<Scalars["Float"]["output"]>
  account_effective_balance_applied?: Maybe<Scalars["Float"]["output"]>
  account_total?: Maybe<Scalars["Float"]["output"]>
  annual_standard_charge_cost?: Maybe<Scalars["Float"]["output"]>
  estimate_annual_cost?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  monthly_standard_charge_cost?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount_without_balance?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount_without_checks?: Maybe<Scalars["Float"]["output"]>
  payment_review_record_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "payment_review_calculation" */
export type Payment_Review_Calculation_Stddev_Samp_Order_By = {
  account_balance?: InputMaybe<Order_By>
  account_balance_applied?: InputMaybe<Order_By>
  account_balance_reserve?: InputMaybe<Order_By>
  account_balance_reserve_rate_percentage?: InputMaybe<Order_By>
  account_effective_balance_applied?: InputMaybe<Order_By>
  account_total?: InputMaybe<Order_By>
  annual_standard_charge_cost?: InputMaybe<Order_By>
  estimate_annual_cost?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  monthly_standard_charge_cost?: InputMaybe<Order_By>
  new_monthly_amount?: InputMaybe<Order_By>
  new_monthly_amount_without_balance?: InputMaybe<Order_By>
  new_monthly_amount_without_checks?: InputMaybe<Order_By>
  payment_review_record_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "payment_review_calculation" */
export type Payment_Review_Calculation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Review_Calculation_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Payment_Review_Calculation_Stream_Cursor_Value_Input = {
  account_balance?: InputMaybe<Scalars["numeric"]["input"]>
  account_balance_applied?: InputMaybe<Scalars["numeric"]["input"]>
  account_balance_reserve?: InputMaybe<Scalars["numeric"]["input"]>
  account_balance_reserve_rate_percentage?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  account_effective_balance_applied?: InputMaybe<Scalars["numeric"]["input"]>
  account_total?: InputMaybe<Scalars["numeric"]["input"]>
  annual_standard_charge_cost?: InputMaybe<Scalars["numeric"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  estimate_annual_cost?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  monthly_standard_charge_cost?: InputMaybe<Scalars["numeric"]["input"]>
  new_monthly_amount?: InputMaybe<Scalars["numeric"]["input"]>
  new_monthly_amount_without_balance?: InputMaybe<Scalars["numeric"]["input"]>
  new_monthly_amount_without_checks?: InputMaybe<Scalars["numeric"]["input"]>
  next_payment_date?: InputMaybe<Scalars["date"]["input"]>
  payment_review_record_id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_type?: InputMaybe<
    Scalars["payment_review_calculation_payment_spread"]["input"]
  >
}

/** aggregate sum on columns */
export type Payment_Review_Calculation_Sum_Fields = {
  __typename?: "payment_review_calculation_sum_fields"
  account_balance?: Maybe<Scalars["numeric"]["output"]>
  account_balance_applied?: Maybe<Scalars["numeric"]["output"]>
  account_balance_reserve?: Maybe<Scalars["numeric"]["output"]>
  account_balance_reserve_rate_percentage?: Maybe<Scalars["numeric"]["output"]>
  account_effective_balance_applied?: Maybe<Scalars["numeric"]["output"]>
  account_total?: Maybe<Scalars["numeric"]["output"]>
  annual_standard_charge_cost?: Maybe<Scalars["numeric"]["output"]>
  estimate_annual_cost?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  monthly_standard_charge_cost?: Maybe<Scalars["numeric"]["output"]>
  new_monthly_amount?: Maybe<Scalars["numeric"]["output"]>
  new_monthly_amount_without_balance?: Maybe<Scalars["numeric"]["output"]>
  new_monthly_amount_without_checks?: Maybe<Scalars["numeric"]["output"]>
  payment_review_record_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "payment_review_calculation" */
export type Payment_Review_Calculation_Sum_Order_By = {
  account_balance?: InputMaybe<Order_By>
  account_balance_applied?: InputMaybe<Order_By>
  account_balance_reserve?: InputMaybe<Order_By>
  account_balance_reserve_rate_percentage?: InputMaybe<Order_By>
  account_effective_balance_applied?: InputMaybe<Order_By>
  account_total?: InputMaybe<Order_By>
  annual_standard_charge_cost?: InputMaybe<Order_By>
  estimate_annual_cost?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  monthly_standard_charge_cost?: InputMaybe<Order_By>
  new_monthly_amount?: InputMaybe<Order_By>
  new_monthly_amount_without_balance?: InputMaybe<Order_By>
  new_monthly_amount_without_checks?: InputMaybe<Order_By>
  payment_review_record_id?: InputMaybe<Order_By>
}

/** update columns of table "payment_review_calculation" */
export enum Payment_Review_Calculation_Update_Column {
  /** column name */
  AccountBalance = "account_balance",
  /** column name */
  AccountBalanceApplied = "account_balance_applied",
  /** column name */
  AccountBalanceReserve = "account_balance_reserve",
  /** column name */
  AccountBalanceReserveRatePercentage = "account_balance_reserve_rate_percentage",
  /** column name */
  AccountEffectiveBalanceApplied = "account_effective_balance_applied",
  /** column name */
  AccountTotal = "account_total",
  /** column name */
  AnnualStandardChargeCost = "annual_standard_charge_cost",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  EstimateAnnualCost = "estimate_annual_cost",
  /** column name */
  Id = "id",
  /** column name */
  MonthlyStandardChargeCost = "monthly_standard_charge_cost",
  /** column name */
  NewMonthlyAmount = "new_monthly_amount",
  /** column name */
  NewMonthlyAmountWithoutBalance = "new_monthly_amount_without_balance",
  /** column name */
  NewMonthlyAmountWithoutChecks = "new_monthly_amount_without_checks",
  /** column name */
  NextPaymentDate = "next_payment_date",
  /** column name */
  PaymentReviewRecordId = "payment_review_record_id",
  /** column name */
  PaymentType = "payment_type",
}

export type Payment_Review_Calculation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Review_Calculation_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Review_Calculation_Set_Input>
  /** filter the rows which have to be updated */
  where: Payment_Review_Calculation_Bool_Exp
}

/** aggregate var_pop on columns */
export type Payment_Review_Calculation_Var_Pop_Fields = {
  __typename?: "payment_review_calculation_var_pop_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  account_balance_applied?: Maybe<Scalars["Float"]["output"]>
  account_balance_reserve?: Maybe<Scalars["Float"]["output"]>
  account_balance_reserve_rate_percentage?: Maybe<Scalars["Float"]["output"]>
  account_effective_balance_applied?: Maybe<Scalars["Float"]["output"]>
  account_total?: Maybe<Scalars["Float"]["output"]>
  annual_standard_charge_cost?: Maybe<Scalars["Float"]["output"]>
  estimate_annual_cost?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  monthly_standard_charge_cost?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount_without_balance?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount_without_checks?: Maybe<Scalars["Float"]["output"]>
  payment_review_record_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "payment_review_calculation" */
export type Payment_Review_Calculation_Var_Pop_Order_By = {
  account_balance?: InputMaybe<Order_By>
  account_balance_applied?: InputMaybe<Order_By>
  account_balance_reserve?: InputMaybe<Order_By>
  account_balance_reserve_rate_percentage?: InputMaybe<Order_By>
  account_effective_balance_applied?: InputMaybe<Order_By>
  account_total?: InputMaybe<Order_By>
  annual_standard_charge_cost?: InputMaybe<Order_By>
  estimate_annual_cost?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  monthly_standard_charge_cost?: InputMaybe<Order_By>
  new_monthly_amount?: InputMaybe<Order_By>
  new_monthly_amount_without_balance?: InputMaybe<Order_By>
  new_monthly_amount_without_checks?: InputMaybe<Order_By>
  payment_review_record_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Payment_Review_Calculation_Var_Samp_Fields = {
  __typename?: "payment_review_calculation_var_samp_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  account_balance_applied?: Maybe<Scalars["Float"]["output"]>
  account_balance_reserve?: Maybe<Scalars["Float"]["output"]>
  account_balance_reserve_rate_percentage?: Maybe<Scalars["Float"]["output"]>
  account_effective_balance_applied?: Maybe<Scalars["Float"]["output"]>
  account_total?: Maybe<Scalars["Float"]["output"]>
  annual_standard_charge_cost?: Maybe<Scalars["Float"]["output"]>
  estimate_annual_cost?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  monthly_standard_charge_cost?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount_without_balance?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount_without_checks?: Maybe<Scalars["Float"]["output"]>
  payment_review_record_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "payment_review_calculation" */
export type Payment_Review_Calculation_Var_Samp_Order_By = {
  account_balance?: InputMaybe<Order_By>
  account_balance_applied?: InputMaybe<Order_By>
  account_balance_reserve?: InputMaybe<Order_By>
  account_balance_reserve_rate_percentage?: InputMaybe<Order_By>
  account_effective_balance_applied?: InputMaybe<Order_By>
  account_total?: InputMaybe<Order_By>
  annual_standard_charge_cost?: InputMaybe<Order_By>
  estimate_annual_cost?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  monthly_standard_charge_cost?: InputMaybe<Order_By>
  new_monthly_amount?: InputMaybe<Order_By>
  new_monthly_amount_without_balance?: InputMaybe<Order_By>
  new_monthly_amount_without_checks?: InputMaybe<Order_By>
  payment_review_record_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Payment_Review_Calculation_Variance_Fields = {
  __typename?: "payment_review_calculation_variance_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  account_balance_applied?: Maybe<Scalars["Float"]["output"]>
  account_balance_reserve?: Maybe<Scalars["Float"]["output"]>
  account_balance_reserve_rate_percentage?: Maybe<Scalars["Float"]["output"]>
  account_effective_balance_applied?: Maybe<Scalars["Float"]["output"]>
  account_total?: Maybe<Scalars["Float"]["output"]>
  annual_standard_charge_cost?: Maybe<Scalars["Float"]["output"]>
  estimate_annual_cost?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  monthly_standard_charge_cost?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount_without_balance?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount_without_checks?: Maybe<Scalars["Float"]["output"]>
  payment_review_record_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "payment_review_calculation" */
export type Payment_Review_Calculation_Variance_Order_By = {
  account_balance?: InputMaybe<Order_By>
  account_balance_applied?: InputMaybe<Order_By>
  account_balance_reserve?: InputMaybe<Order_By>
  account_balance_reserve_rate_percentage?: InputMaybe<Order_By>
  account_effective_balance_applied?: InputMaybe<Order_By>
  account_total?: InputMaybe<Order_By>
  annual_standard_charge_cost?: InputMaybe<Order_By>
  estimate_annual_cost?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  monthly_standard_charge_cost?: InputMaybe<Order_By>
  new_monthly_amount?: InputMaybe<Order_By>
  new_monthly_amount_without_balance?: InputMaybe<Order_By>
  new_monthly_amount_without_checks?: InputMaybe<Order_By>
  payment_review_record_id?: InputMaybe<Order_By>
}

/** payment_review_dashboard_summaryNative Query Arguments */
export type Payment_Review_Dashboard_Summary_Arguments = {
  paymentReviewId: Scalars["bigint"]["input"]
}

export type Payment_Review_Dashboard_Summary_Model = {
  __typename?: "payment_review_dashboard_summary_model"
  count: Scalars["bigint"]["output"]
  status: Scalars["String"]["output"]
}

/** Boolean expression to filter rows from the logical model for "payment_review_dashboard_summary_model". All fields are combined with a logical 'AND'. */
export type Payment_Review_Dashboard_Summary_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<
    Array<Payment_Review_Dashboard_Summary_Model_Bool_Exp_Bool_Exp>
  >
  _not?: InputMaybe<Payment_Review_Dashboard_Summary_Model_Bool_Exp_Bool_Exp>
  _or?: InputMaybe<
    Array<Payment_Review_Dashboard_Summary_Model_Bool_Exp_Bool_Exp>
  >
  count?: InputMaybe<Bigint_Comparison_Exp>
  status?: InputMaybe<String_Comparison_Exp>
}

export enum Payment_Review_Dashboard_Summary_Model_Enum_Name {
  /** column name */
  Count = "count",
  /** column name */
  Status = "status",
}

/** Ordering options when selecting data from "payment_review_dashboard_summary_model". */
export type Payment_Review_Dashboard_Summary_Model_Order_By = {
  count?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "payment_review_datasource". All fields are combined with logical 'AND'. */
export type Payment_Review_Datasource_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["payment_review_datasource"]["input"]>
  _gt?: InputMaybe<Scalars["payment_review_datasource"]["input"]>
  _gte?: InputMaybe<Scalars["payment_review_datasource"]["input"]>
  _in?: InputMaybe<Array<Scalars["payment_review_datasource"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["payment_review_datasource"]["input"]>
  _lte?: InputMaybe<Scalars["payment_review_datasource"]["input"]>
  _neq?: InputMaybe<Scalars["payment_review_datasource"]["input"]>
  _nin?: InputMaybe<Array<Scalars["payment_review_datasource"]["input"]>>
}

/** columns and relationships of "payment_review_future_product_rates" */
export type Payment_Review_Future_Product_Rates = {
  __typename?: "payment_review_future_product_rates"
  direct_debit: Scalars["Boolean"]["output"]
  dual_fuel_discount?: Maybe<Scalars["numeric"]["output"]>
  early_termination_charge?: Maybe<Scalars["numeric"]["output"]>
  gsp_group: Scalars["String"]["output"]
  id: Scalars["bigint"]["output"]
  online_discount?: Maybe<Scalars["numeric"]["output"]>
  product_code: Scalars["String"]["output"]
  product_display?: Maybe<Scalars["String"]["output"]>
  product_name?: Maybe<Scalars["String"]["output"]>
  rate_1: Scalars["numeric"]["output"]
  rate_2?: Maybe<Scalars["numeric"]["output"]>
  standing_charge: Scalars["numeric"]["output"]
}

/** aggregated selection of "payment_review_future_product_rates" */
export type Payment_Review_Future_Product_Rates_Aggregate = {
  __typename?: "payment_review_future_product_rates_aggregate"
  aggregate?: Maybe<Payment_Review_Future_Product_Rates_Aggregate_Fields>
  nodes: Array<Payment_Review_Future_Product_Rates>
}

/** aggregate fields of "payment_review_future_product_rates" */
export type Payment_Review_Future_Product_Rates_Aggregate_Fields = {
  __typename?: "payment_review_future_product_rates_aggregate_fields"
  avg?: Maybe<Payment_Review_Future_Product_Rates_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Payment_Review_Future_Product_Rates_Max_Fields>
  min?: Maybe<Payment_Review_Future_Product_Rates_Min_Fields>
  stddev?: Maybe<Payment_Review_Future_Product_Rates_Stddev_Fields>
  stddev_pop?: Maybe<Payment_Review_Future_Product_Rates_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Payment_Review_Future_Product_Rates_Stddev_Samp_Fields>
  sum?: Maybe<Payment_Review_Future_Product_Rates_Sum_Fields>
  var_pop?: Maybe<Payment_Review_Future_Product_Rates_Var_Pop_Fields>
  var_samp?: Maybe<Payment_Review_Future_Product_Rates_Var_Samp_Fields>
  variance?: Maybe<Payment_Review_Future_Product_Rates_Variance_Fields>
}

/** aggregate fields of "payment_review_future_product_rates" */
export type Payment_Review_Future_Product_Rates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Review_Future_Product_Rates_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Payment_Review_Future_Product_Rates_Avg_Fields = {
  __typename?: "payment_review_future_product_rates_avg_fields"
  dual_fuel_discount?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  online_discount?: Maybe<Scalars["Float"]["output"]>
  rate_1?: Maybe<Scalars["Float"]["output"]>
  rate_2?: Maybe<Scalars["Float"]["output"]>
  standing_charge?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "payment_review_future_product_rates". All fields are combined with a logical 'AND'. */
export type Payment_Review_Future_Product_Rates_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Review_Future_Product_Rates_Bool_Exp>>
  _not?: InputMaybe<Payment_Review_Future_Product_Rates_Bool_Exp>
  _or?: InputMaybe<Array<Payment_Review_Future_Product_Rates_Bool_Exp>>
  direct_debit?: InputMaybe<Boolean_Comparison_Exp>
  dual_fuel_discount?: InputMaybe<Numeric_Comparison_Exp>
  early_termination_charge?: InputMaybe<Numeric_Comparison_Exp>
  gsp_group?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  online_discount?: InputMaybe<Numeric_Comparison_Exp>
  product_code?: InputMaybe<String_Comparison_Exp>
  product_display?: InputMaybe<String_Comparison_Exp>
  product_name?: InputMaybe<String_Comparison_Exp>
  rate_1?: InputMaybe<Numeric_Comparison_Exp>
  rate_2?: InputMaybe<Numeric_Comparison_Exp>
  standing_charge?: InputMaybe<Numeric_Comparison_Exp>
}

/** unique or primary key constraints on table "payment_review_future_product_rates" */
export enum Payment_Review_Future_Product_Rates_Constraint {
  /** unique or primary key constraint on columns "id" */
  PaymentReviewFutureProductRatesPkey = "payment_review_future_product_rates_pkey",
  /** unique or primary key constraint on columns "gsp_group", "direct_debit", "product_code" */
  UniqueConstraintPaymentReviewFutureRates = "unique_constraint_payment_review_future_rates",
}

/** input type for incrementing numeric columns in table "payment_review_future_product_rates" */
export type Payment_Review_Future_Product_Rates_Inc_Input = {
  dual_fuel_discount?: InputMaybe<Scalars["numeric"]["input"]>
  early_termination_charge?: InputMaybe<Scalars["numeric"]["input"]>
  online_discount?: InputMaybe<Scalars["numeric"]["input"]>
  rate_1?: InputMaybe<Scalars["numeric"]["input"]>
  rate_2?: InputMaybe<Scalars["numeric"]["input"]>
  standing_charge?: InputMaybe<Scalars["numeric"]["input"]>
}

/** input type for inserting data into table "payment_review_future_product_rates" */
export type Payment_Review_Future_Product_Rates_Insert_Input = {
  direct_debit?: InputMaybe<Scalars["Boolean"]["input"]>
  dual_fuel_discount?: InputMaybe<Scalars["numeric"]["input"]>
  early_termination_charge?: InputMaybe<Scalars["numeric"]["input"]>
  gsp_group?: InputMaybe<Scalars["String"]["input"]>
  online_discount?: InputMaybe<Scalars["numeric"]["input"]>
  product_code?: InputMaybe<Scalars["String"]["input"]>
  product_display?: InputMaybe<Scalars["String"]["input"]>
  product_name?: InputMaybe<Scalars["String"]["input"]>
  rate_1?: InputMaybe<Scalars["numeric"]["input"]>
  rate_2?: InputMaybe<Scalars["numeric"]["input"]>
  standing_charge?: InputMaybe<Scalars["numeric"]["input"]>
}

/** aggregate max on columns */
export type Payment_Review_Future_Product_Rates_Max_Fields = {
  __typename?: "payment_review_future_product_rates_max_fields"
  dual_fuel_discount?: Maybe<Scalars["numeric"]["output"]>
  early_termination_charge?: Maybe<Scalars["numeric"]["output"]>
  gsp_group?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  online_discount?: Maybe<Scalars["numeric"]["output"]>
  product_code?: Maybe<Scalars["String"]["output"]>
  product_display?: Maybe<Scalars["String"]["output"]>
  product_name?: Maybe<Scalars["String"]["output"]>
  rate_1?: Maybe<Scalars["numeric"]["output"]>
  rate_2?: Maybe<Scalars["numeric"]["output"]>
  standing_charge?: Maybe<Scalars["numeric"]["output"]>
}

/** aggregate min on columns */
export type Payment_Review_Future_Product_Rates_Min_Fields = {
  __typename?: "payment_review_future_product_rates_min_fields"
  dual_fuel_discount?: Maybe<Scalars["numeric"]["output"]>
  early_termination_charge?: Maybe<Scalars["numeric"]["output"]>
  gsp_group?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  online_discount?: Maybe<Scalars["numeric"]["output"]>
  product_code?: Maybe<Scalars["String"]["output"]>
  product_display?: Maybe<Scalars["String"]["output"]>
  product_name?: Maybe<Scalars["String"]["output"]>
  rate_1?: Maybe<Scalars["numeric"]["output"]>
  rate_2?: Maybe<Scalars["numeric"]["output"]>
  standing_charge?: Maybe<Scalars["numeric"]["output"]>
}

/** response of any mutation on the table "payment_review_future_product_rates" */
export type Payment_Review_Future_Product_Rates_Mutation_Response = {
  __typename?: "payment_review_future_product_rates_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Review_Future_Product_Rates>
}

/** on_conflict condition type for table "payment_review_future_product_rates" */
export type Payment_Review_Future_Product_Rates_On_Conflict = {
  constraint: Payment_Review_Future_Product_Rates_Constraint
  update_columns?: Array<Payment_Review_Future_Product_Rates_Update_Column>
  where?: InputMaybe<Payment_Review_Future_Product_Rates_Bool_Exp>
}

/** Ordering options when selecting data from "payment_review_future_product_rates". */
export type Payment_Review_Future_Product_Rates_Order_By = {
  direct_debit?: InputMaybe<Order_By>
  dual_fuel_discount?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  gsp_group?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  online_discount?: InputMaybe<Order_By>
  product_code?: InputMaybe<Order_By>
  product_display?: InputMaybe<Order_By>
  product_name?: InputMaybe<Order_By>
  rate_1?: InputMaybe<Order_By>
  rate_2?: InputMaybe<Order_By>
  standing_charge?: InputMaybe<Order_By>
}

/** primary key columns input for table: payment_review_future_product_rates */
export type Payment_Review_Future_Product_Rates_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "payment_review_future_product_rates" */
export enum Payment_Review_Future_Product_Rates_Select_Column {
  /** column name */
  DirectDebit = "direct_debit",
  /** column name */
  DualFuelDiscount = "dual_fuel_discount",
  /** column name */
  EarlyTerminationCharge = "early_termination_charge",
  /** column name */
  GspGroup = "gsp_group",
  /** column name */
  Id = "id",
  /** column name */
  OnlineDiscount = "online_discount",
  /** column name */
  ProductCode = "product_code",
  /** column name */
  ProductDisplay = "product_display",
  /** column name */
  ProductName = "product_name",
  /** column name */
  Rate_1 = "rate_1",
  /** column name */
  Rate_2 = "rate_2",
  /** column name */
  StandingCharge = "standing_charge",
}

/** input type for updating data in table "payment_review_future_product_rates" */
export type Payment_Review_Future_Product_Rates_Set_Input = {
  direct_debit?: InputMaybe<Scalars["Boolean"]["input"]>
  dual_fuel_discount?: InputMaybe<Scalars["numeric"]["input"]>
  early_termination_charge?: InputMaybe<Scalars["numeric"]["input"]>
  gsp_group?: InputMaybe<Scalars["String"]["input"]>
  online_discount?: InputMaybe<Scalars["numeric"]["input"]>
  product_code?: InputMaybe<Scalars["String"]["input"]>
  product_display?: InputMaybe<Scalars["String"]["input"]>
  product_name?: InputMaybe<Scalars["String"]["input"]>
  rate_1?: InputMaybe<Scalars["numeric"]["input"]>
  rate_2?: InputMaybe<Scalars["numeric"]["input"]>
  standing_charge?: InputMaybe<Scalars["numeric"]["input"]>
}

/** aggregate stddev on columns */
export type Payment_Review_Future_Product_Rates_Stddev_Fields = {
  __typename?: "payment_review_future_product_rates_stddev_fields"
  dual_fuel_discount?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  online_discount?: Maybe<Scalars["Float"]["output"]>
  rate_1?: Maybe<Scalars["Float"]["output"]>
  rate_2?: Maybe<Scalars["Float"]["output"]>
  standing_charge?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Payment_Review_Future_Product_Rates_Stddev_Pop_Fields = {
  __typename?: "payment_review_future_product_rates_stddev_pop_fields"
  dual_fuel_discount?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  online_discount?: Maybe<Scalars["Float"]["output"]>
  rate_1?: Maybe<Scalars["Float"]["output"]>
  rate_2?: Maybe<Scalars["Float"]["output"]>
  standing_charge?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Payment_Review_Future_Product_Rates_Stddev_Samp_Fields = {
  __typename?: "payment_review_future_product_rates_stddev_samp_fields"
  dual_fuel_discount?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  online_discount?: Maybe<Scalars["Float"]["output"]>
  rate_1?: Maybe<Scalars["Float"]["output"]>
  rate_2?: Maybe<Scalars["Float"]["output"]>
  standing_charge?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "payment_review_future_product_rates" */
export type Payment_Review_Future_Product_Rates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Review_Future_Product_Rates_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Payment_Review_Future_Product_Rates_Stream_Cursor_Value_Input = {
  direct_debit?: InputMaybe<Scalars["Boolean"]["input"]>
  dual_fuel_discount?: InputMaybe<Scalars["numeric"]["input"]>
  early_termination_charge?: InputMaybe<Scalars["numeric"]["input"]>
  gsp_group?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  online_discount?: InputMaybe<Scalars["numeric"]["input"]>
  product_code?: InputMaybe<Scalars["String"]["input"]>
  product_display?: InputMaybe<Scalars["String"]["input"]>
  product_name?: InputMaybe<Scalars["String"]["input"]>
  rate_1?: InputMaybe<Scalars["numeric"]["input"]>
  rate_2?: InputMaybe<Scalars["numeric"]["input"]>
  standing_charge?: InputMaybe<Scalars["numeric"]["input"]>
}

/** aggregate sum on columns */
export type Payment_Review_Future_Product_Rates_Sum_Fields = {
  __typename?: "payment_review_future_product_rates_sum_fields"
  dual_fuel_discount?: Maybe<Scalars["numeric"]["output"]>
  early_termination_charge?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  online_discount?: Maybe<Scalars["numeric"]["output"]>
  rate_1?: Maybe<Scalars["numeric"]["output"]>
  rate_2?: Maybe<Scalars["numeric"]["output"]>
  standing_charge?: Maybe<Scalars["numeric"]["output"]>
}

/** update columns of table "payment_review_future_product_rates" */
export enum Payment_Review_Future_Product_Rates_Update_Column {
  /** column name */
  DirectDebit = "direct_debit",
  /** column name */
  DualFuelDiscount = "dual_fuel_discount",
  /** column name */
  EarlyTerminationCharge = "early_termination_charge",
  /** column name */
  GspGroup = "gsp_group",
  /** column name */
  OnlineDiscount = "online_discount",
  /** column name */
  ProductCode = "product_code",
  /** column name */
  ProductDisplay = "product_display",
  /** column name */
  ProductName = "product_name",
  /** column name */
  Rate_1 = "rate_1",
  /** column name */
  Rate_2 = "rate_2",
  /** column name */
  StandingCharge = "standing_charge",
}

export type Payment_Review_Future_Product_Rates_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Review_Future_Product_Rates_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Review_Future_Product_Rates_Set_Input>
  /** filter the rows which have to be updated */
  where: Payment_Review_Future_Product_Rates_Bool_Exp
}

/** aggregate var_pop on columns */
export type Payment_Review_Future_Product_Rates_Var_Pop_Fields = {
  __typename?: "payment_review_future_product_rates_var_pop_fields"
  dual_fuel_discount?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  online_discount?: Maybe<Scalars["Float"]["output"]>
  rate_1?: Maybe<Scalars["Float"]["output"]>
  rate_2?: Maybe<Scalars["Float"]["output"]>
  standing_charge?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Payment_Review_Future_Product_Rates_Var_Samp_Fields = {
  __typename?: "payment_review_future_product_rates_var_samp_fields"
  dual_fuel_discount?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  online_discount?: Maybe<Scalars["Float"]["output"]>
  rate_1?: Maybe<Scalars["Float"]["output"]>
  rate_2?: Maybe<Scalars["Float"]["output"]>
  standing_charge?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Payment_Review_Future_Product_Rates_Variance_Fields = {
  __typename?: "payment_review_future_product_rates_variance_fields"
  dual_fuel_discount?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  online_discount?: Maybe<Scalars["Float"]["output"]>
  rate_1?: Maybe<Scalars["Float"]["output"]>
  rate_2?: Maybe<Scalars["Float"]["output"]>
  standing_charge?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "payment_review_record_emails" */
export type Payment_Review_Record_Emails = {
  __typename?: "payment_review_record_emails"
  created_at: Scalars["timestamptz"]["output"]
  email_provider_id?: Maybe<Scalars["bigint"]["output"]>
  failure_error_code: Scalars["String"]["output"]
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  /** An object relationship */
  payment_review_record: Payment_Review_Records
  payment_review_record_id: Scalars["bigint"]["output"]
  sent_at?: Maybe<Scalars["timestamptz"]["output"]>
  status: Scalars["email_status_enum"]["output"]
}

/** aggregated selection of "payment_review_record_emails" */
export type Payment_Review_Record_Emails_Aggregate = {
  __typename?: "payment_review_record_emails_aggregate"
  aggregate?: Maybe<Payment_Review_Record_Emails_Aggregate_Fields>
  nodes: Array<Payment_Review_Record_Emails>
}

/** aggregate fields of "payment_review_record_emails" */
export type Payment_Review_Record_Emails_Aggregate_Fields = {
  __typename?: "payment_review_record_emails_aggregate_fields"
  avg?: Maybe<Payment_Review_Record_Emails_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Payment_Review_Record_Emails_Max_Fields>
  min?: Maybe<Payment_Review_Record_Emails_Min_Fields>
  stddev?: Maybe<Payment_Review_Record_Emails_Stddev_Fields>
  stddev_pop?: Maybe<Payment_Review_Record_Emails_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Payment_Review_Record_Emails_Stddev_Samp_Fields>
  sum?: Maybe<Payment_Review_Record_Emails_Sum_Fields>
  var_pop?: Maybe<Payment_Review_Record_Emails_Var_Pop_Fields>
  var_samp?: Maybe<Payment_Review_Record_Emails_Var_Samp_Fields>
  variance?: Maybe<Payment_Review_Record_Emails_Variance_Fields>
}

/** aggregate fields of "payment_review_record_emails" */
export type Payment_Review_Record_Emails_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Review_Record_Emails_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Payment_Review_Record_Emails_Avg_Fields = {
  __typename?: "payment_review_record_emails_avg_fields"
  email_provider_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_review_record_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "payment_review_record_emails". All fields are combined with a logical 'AND'. */
export type Payment_Review_Record_Emails_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Review_Record_Emails_Bool_Exp>>
  _not?: InputMaybe<Payment_Review_Record_Emails_Bool_Exp>
  _or?: InputMaybe<Array<Payment_Review_Record_Emails_Bool_Exp>>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  email_provider_id?: InputMaybe<Bigint_Comparison_Exp>
  failure_error_code?: InputMaybe<String_Comparison_Exp>
  failure_reason?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  payment_review_record?: InputMaybe<Payment_Review_Records_Bool_Exp>
  payment_review_record_id?: InputMaybe<Bigint_Comparison_Exp>
  sent_at?: InputMaybe<Timestamptz_Comparison_Exp>
  status?: InputMaybe<Email_Status_Enum_Comparison_Exp>
}

/** unique or primary key constraints on table "payment_review_record_emails" */
export enum Payment_Review_Record_Emails_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkPaymentReviewRecordEmails = "pk_payment_review_record_emails",
  /** unique or primary key constraint on columns "payment_review_record_id" */
  UniqueConstraintPaymentReviewRecordEmails = "unique_constraint_payment_review_record_emails",
}

/** input type for incrementing numeric columns in table "payment_review_record_emails" */
export type Payment_Review_Record_Emails_Inc_Input = {
  email_provider_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_review_record_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "payment_review_record_emails" */
export type Payment_Review_Record_Emails_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  email_provider_id?: InputMaybe<Scalars["bigint"]["input"]>
  failure_error_code?: InputMaybe<Scalars["String"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_review_record?: InputMaybe<Payment_Review_Records_Obj_Rel_Insert_Input>
  payment_review_record_id?: InputMaybe<Scalars["bigint"]["input"]>
  sent_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  status?: InputMaybe<Scalars["email_status_enum"]["input"]>
}

/** aggregate max on columns */
export type Payment_Review_Record_Emails_Max_Fields = {
  __typename?: "payment_review_record_emails_max_fields"
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  email_provider_id?: Maybe<Scalars["bigint"]["output"]>
  failure_error_code?: Maybe<Scalars["String"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  payment_review_record_id?: Maybe<Scalars["bigint"]["output"]>
  sent_at?: Maybe<Scalars["timestamptz"]["output"]>
  status?: Maybe<Scalars["email_status_enum"]["output"]>
}

/** aggregate min on columns */
export type Payment_Review_Record_Emails_Min_Fields = {
  __typename?: "payment_review_record_emails_min_fields"
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  email_provider_id?: Maybe<Scalars["bigint"]["output"]>
  failure_error_code?: Maybe<Scalars["String"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  payment_review_record_id?: Maybe<Scalars["bigint"]["output"]>
  sent_at?: Maybe<Scalars["timestamptz"]["output"]>
  status?: Maybe<Scalars["email_status_enum"]["output"]>
}

/** response of any mutation on the table "payment_review_record_emails" */
export type Payment_Review_Record_Emails_Mutation_Response = {
  __typename?: "payment_review_record_emails_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Review_Record_Emails>
}

/** input type for inserting object relation for remote table "payment_review_record_emails" */
export type Payment_Review_Record_Emails_Obj_Rel_Insert_Input = {
  data: Payment_Review_Record_Emails_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_Review_Record_Emails_On_Conflict>
}

/** on_conflict condition type for table "payment_review_record_emails" */
export type Payment_Review_Record_Emails_On_Conflict = {
  constraint: Payment_Review_Record_Emails_Constraint
  update_columns?: Array<Payment_Review_Record_Emails_Update_Column>
  where?: InputMaybe<Payment_Review_Record_Emails_Bool_Exp>
}

/** Ordering options when selecting data from "payment_review_record_emails". */
export type Payment_Review_Record_Emails_Order_By = {
  created_at?: InputMaybe<Order_By>
  email_provider_id?: InputMaybe<Order_By>
  failure_error_code?: InputMaybe<Order_By>
  failure_reason?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  payment_review_record?: InputMaybe<Payment_Review_Records_Order_By>
  payment_review_record_id?: InputMaybe<Order_By>
  sent_at?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
}

/** primary key columns input for table: payment_review_record_emails */
export type Payment_Review_Record_Emails_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "payment_review_record_emails" */
export enum Payment_Review_Record_Emails_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  EmailProviderId = "email_provider_id",
  /** column name */
  FailureErrorCode = "failure_error_code",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  PaymentReviewRecordId = "payment_review_record_id",
  /** column name */
  SentAt = "sent_at",
  /** column name */
  Status = "status",
}

/** input type for updating data in table "payment_review_record_emails" */
export type Payment_Review_Record_Emails_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  email_provider_id?: InputMaybe<Scalars["bigint"]["input"]>
  failure_error_code?: InputMaybe<Scalars["String"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_review_record_id?: InputMaybe<Scalars["bigint"]["input"]>
  sent_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  status?: InputMaybe<Scalars["email_status_enum"]["input"]>
}

/** aggregate stddev on columns */
export type Payment_Review_Record_Emails_Stddev_Fields = {
  __typename?: "payment_review_record_emails_stddev_fields"
  email_provider_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_review_record_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Payment_Review_Record_Emails_Stddev_Pop_Fields = {
  __typename?: "payment_review_record_emails_stddev_pop_fields"
  email_provider_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_review_record_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Payment_Review_Record_Emails_Stddev_Samp_Fields = {
  __typename?: "payment_review_record_emails_stddev_samp_fields"
  email_provider_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_review_record_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "payment_review_record_emails" */
export type Payment_Review_Record_Emails_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Review_Record_Emails_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Payment_Review_Record_Emails_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  email_provider_id?: InputMaybe<Scalars["bigint"]["input"]>
  failure_error_code?: InputMaybe<Scalars["String"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_review_record_id?: InputMaybe<Scalars["bigint"]["input"]>
  sent_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  status?: InputMaybe<Scalars["email_status_enum"]["input"]>
}

/** aggregate sum on columns */
export type Payment_Review_Record_Emails_Sum_Fields = {
  __typename?: "payment_review_record_emails_sum_fields"
  email_provider_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  payment_review_record_id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "payment_review_record_emails" */
export enum Payment_Review_Record_Emails_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  EmailProviderId = "email_provider_id",
  /** column name */
  FailureErrorCode = "failure_error_code",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  PaymentReviewRecordId = "payment_review_record_id",
  /** column name */
  SentAt = "sent_at",
  /** column name */
  Status = "status",
}

export type Payment_Review_Record_Emails_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Review_Record_Emails_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Review_Record_Emails_Set_Input>
  /** filter the rows which have to be updated */
  where: Payment_Review_Record_Emails_Bool_Exp
}

/** aggregate var_pop on columns */
export type Payment_Review_Record_Emails_Var_Pop_Fields = {
  __typename?: "payment_review_record_emails_var_pop_fields"
  email_provider_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_review_record_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Payment_Review_Record_Emails_Var_Samp_Fields = {
  __typename?: "payment_review_record_emails_var_samp_fields"
  email_provider_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_review_record_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Payment_Review_Record_Emails_Variance_Fields = {
  __typename?: "payment_review_record_emails_variance_fields"
  email_provider_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_review_record_id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "payment_review_record_notes" */
export type Payment_Review_Record_Notes = {
  __typename?: "payment_review_record_notes"
  created_at: Scalars["timestamptz"]["output"]
  failure_error_code: Scalars["String"]["output"]
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  junifer_note_id?: Maybe<Scalars["bigint"]["output"]>
  /** An object relationship */
  payment_review_record: Payment_Review_Records
  payment_review_record_id: Scalars["bigint"]["output"]
  sent_at?: Maybe<Scalars["timestamptz"]["output"]>
  status: Scalars["notes_status_enum"]["output"]
}

/** aggregated selection of "payment_review_record_notes" */
export type Payment_Review_Record_Notes_Aggregate = {
  __typename?: "payment_review_record_notes_aggregate"
  aggregate?: Maybe<Payment_Review_Record_Notes_Aggregate_Fields>
  nodes: Array<Payment_Review_Record_Notes>
}

/** aggregate fields of "payment_review_record_notes" */
export type Payment_Review_Record_Notes_Aggregate_Fields = {
  __typename?: "payment_review_record_notes_aggregate_fields"
  avg?: Maybe<Payment_Review_Record_Notes_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Payment_Review_Record_Notes_Max_Fields>
  min?: Maybe<Payment_Review_Record_Notes_Min_Fields>
  stddev?: Maybe<Payment_Review_Record_Notes_Stddev_Fields>
  stddev_pop?: Maybe<Payment_Review_Record_Notes_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Payment_Review_Record_Notes_Stddev_Samp_Fields>
  sum?: Maybe<Payment_Review_Record_Notes_Sum_Fields>
  var_pop?: Maybe<Payment_Review_Record_Notes_Var_Pop_Fields>
  var_samp?: Maybe<Payment_Review_Record_Notes_Var_Samp_Fields>
  variance?: Maybe<Payment_Review_Record_Notes_Variance_Fields>
}

/** aggregate fields of "payment_review_record_notes" */
export type Payment_Review_Record_Notes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Review_Record_Notes_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Payment_Review_Record_Notes_Avg_Fields = {
  __typename?: "payment_review_record_notes_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_note_id?: Maybe<Scalars["Float"]["output"]>
  payment_review_record_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "payment_review_record_notes". All fields are combined with a logical 'AND'. */
export type Payment_Review_Record_Notes_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Review_Record_Notes_Bool_Exp>>
  _not?: InputMaybe<Payment_Review_Record_Notes_Bool_Exp>
  _or?: InputMaybe<Array<Payment_Review_Record_Notes_Bool_Exp>>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  failure_error_code?: InputMaybe<String_Comparison_Exp>
  failure_reason?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  junifer_note_id?: InputMaybe<Bigint_Comparison_Exp>
  payment_review_record?: InputMaybe<Payment_Review_Records_Bool_Exp>
  payment_review_record_id?: InputMaybe<Bigint_Comparison_Exp>
  sent_at?: InputMaybe<Timestamptz_Comparison_Exp>
  status?: InputMaybe<Notes_Status_Enum_Comparison_Exp>
}

/** unique or primary key constraints on table "payment_review_record_notes" */
export enum Payment_Review_Record_Notes_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkPaymentReviewRecordNotes = "pk_payment_review_record_notes",
  /** unique or primary key constraint on columns "payment_review_record_id" */
  UniqueConstraintPaymentReviewRecordNotes = "unique_constraint_payment_review_record_notes",
}

/** input type for incrementing numeric columns in table "payment_review_record_notes" */
export type Payment_Review_Record_Notes_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_note_id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_review_record_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "payment_review_record_notes" */
export type Payment_Review_Record_Notes_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_error_code?: InputMaybe<Scalars["String"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_note_id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_review_record?: InputMaybe<Payment_Review_Records_Obj_Rel_Insert_Input>
  payment_review_record_id?: InputMaybe<Scalars["bigint"]["input"]>
  sent_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  status?: InputMaybe<Scalars["notes_status_enum"]["input"]>
}

/** aggregate max on columns */
export type Payment_Review_Record_Notes_Max_Fields = {
  __typename?: "payment_review_record_notes_max_fields"
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  failure_error_code?: Maybe<Scalars["String"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_note_id?: Maybe<Scalars["bigint"]["output"]>
  payment_review_record_id?: Maybe<Scalars["bigint"]["output"]>
  sent_at?: Maybe<Scalars["timestamptz"]["output"]>
  status?: Maybe<Scalars["notes_status_enum"]["output"]>
}

/** aggregate min on columns */
export type Payment_Review_Record_Notes_Min_Fields = {
  __typename?: "payment_review_record_notes_min_fields"
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  failure_error_code?: Maybe<Scalars["String"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_note_id?: Maybe<Scalars["bigint"]["output"]>
  payment_review_record_id?: Maybe<Scalars["bigint"]["output"]>
  sent_at?: Maybe<Scalars["timestamptz"]["output"]>
  status?: Maybe<Scalars["notes_status_enum"]["output"]>
}

/** response of any mutation on the table "payment_review_record_notes" */
export type Payment_Review_Record_Notes_Mutation_Response = {
  __typename?: "payment_review_record_notes_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Review_Record_Notes>
}

/** input type for inserting object relation for remote table "payment_review_record_notes" */
export type Payment_Review_Record_Notes_Obj_Rel_Insert_Input = {
  data: Payment_Review_Record_Notes_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_Review_Record_Notes_On_Conflict>
}

/** on_conflict condition type for table "payment_review_record_notes" */
export type Payment_Review_Record_Notes_On_Conflict = {
  constraint: Payment_Review_Record_Notes_Constraint
  update_columns?: Array<Payment_Review_Record_Notes_Update_Column>
  where?: InputMaybe<Payment_Review_Record_Notes_Bool_Exp>
}

/** Ordering options when selecting data from "payment_review_record_notes". */
export type Payment_Review_Record_Notes_Order_By = {
  created_at?: InputMaybe<Order_By>
  failure_error_code?: InputMaybe<Order_By>
  failure_reason?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  junifer_note_id?: InputMaybe<Order_By>
  payment_review_record?: InputMaybe<Payment_Review_Records_Order_By>
  payment_review_record_id?: InputMaybe<Order_By>
  sent_at?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
}

/** primary key columns input for table: payment_review_record_notes */
export type Payment_Review_Record_Notes_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "payment_review_record_notes" */
export enum Payment_Review_Record_Notes_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  FailureErrorCode = "failure_error_code",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  JuniferNoteId = "junifer_note_id",
  /** column name */
  PaymentReviewRecordId = "payment_review_record_id",
  /** column name */
  SentAt = "sent_at",
  /** column name */
  Status = "status",
}

/** input type for updating data in table "payment_review_record_notes" */
export type Payment_Review_Record_Notes_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_error_code?: InputMaybe<Scalars["String"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_note_id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_review_record_id?: InputMaybe<Scalars["bigint"]["input"]>
  sent_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  status?: InputMaybe<Scalars["notes_status_enum"]["input"]>
}

/** aggregate stddev on columns */
export type Payment_Review_Record_Notes_Stddev_Fields = {
  __typename?: "payment_review_record_notes_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_note_id?: Maybe<Scalars["Float"]["output"]>
  payment_review_record_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Payment_Review_Record_Notes_Stddev_Pop_Fields = {
  __typename?: "payment_review_record_notes_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_note_id?: Maybe<Scalars["Float"]["output"]>
  payment_review_record_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Payment_Review_Record_Notes_Stddev_Samp_Fields = {
  __typename?: "payment_review_record_notes_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_note_id?: Maybe<Scalars["Float"]["output"]>
  payment_review_record_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "payment_review_record_notes" */
export type Payment_Review_Record_Notes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Review_Record_Notes_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Payment_Review_Record_Notes_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_error_code?: InputMaybe<Scalars["String"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_note_id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_review_record_id?: InputMaybe<Scalars["bigint"]["input"]>
  sent_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  status?: InputMaybe<Scalars["notes_status_enum"]["input"]>
}

/** aggregate sum on columns */
export type Payment_Review_Record_Notes_Sum_Fields = {
  __typename?: "payment_review_record_notes_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_note_id?: Maybe<Scalars["bigint"]["output"]>
  payment_review_record_id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "payment_review_record_notes" */
export enum Payment_Review_Record_Notes_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  FailureErrorCode = "failure_error_code",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  JuniferNoteId = "junifer_note_id",
  /** column name */
  PaymentReviewRecordId = "payment_review_record_id",
  /** column name */
  SentAt = "sent_at",
  /** column name */
  Status = "status",
}

export type Payment_Review_Record_Notes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Review_Record_Notes_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Review_Record_Notes_Set_Input>
  /** filter the rows which have to be updated */
  where: Payment_Review_Record_Notes_Bool_Exp
}

/** aggregate var_pop on columns */
export type Payment_Review_Record_Notes_Var_Pop_Fields = {
  __typename?: "payment_review_record_notes_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_note_id?: Maybe<Scalars["Float"]["output"]>
  payment_review_record_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Payment_Review_Record_Notes_Var_Samp_Fields = {
  __typename?: "payment_review_record_notes_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_note_id?: Maybe<Scalars["Float"]["output"]>
  payment_review_record_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Payment_Review_Record_Notes_Variance_Fields = {
  __typename?: "payment_review_record_notes_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_note_id?: Maybe<Scalars["Float"]["output"]>
  payment_review_record_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "payment_review_record_payment_frequency". All fields are combined with logical 'AND'. */
export type Payment_Review_Record_Payment_Frequency_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["payment_review_record_payment_frequency"]["input"]>
  _gt?: InputMaybe<Scalars["payment_review_record_payment_frequency"]["input"]>
  _gte?: InputMaybe<Scalars["payment_review_record_payment_frequency"]["input"]>
  _in?: InputMaybe<
    Array<Scalars["payment_review_record_payment_frequency"]["input"]>
  >
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["payment_review_record_payment_frequency"]["input"]>
  _lte?: InputMaybe<Scalars["payment_review_record_payment_frequency"]["input"]>
  _neq?: InputMaybe<Scalars["payment_review_record_payment_frequency"]["input"]>
  _nin?: InputMaybe<
    Array<Scalars["payment_review_record_payment_frequency"]["input"]>
  >
}

/** Boolean expression to compare columns of type "payment_review_record_payment_spread". All fields are combined with logical 'AND'. */
export type Payment_Review_Record_Payment_Spread_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["payment_review_record_payment_spread"]["input"]>
  _gt?: InputMaybe<Scalars["payment_review_record_payment_spread"]["input"]>
  _gte?: InputMaybe<Scalars["payment_review_record_payment_spread"]["input"]>
  _in?: InputMaybe<
    Array<Scalars["payment_review_record_payment_spread"]["input"]>
  >
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["payment_review_record_payment_spread"]["input"]>
  _lte?: InputMaybe<Scalars["payment_review_record_payment_spread"]["input"]>
  _neq?: InputMaybe<Scalars["payment_review_record_payment_spread"]["input"]>
  _nin?: InputMaybe<
    Array<Scalars["payment_review_record_payment_spread"]["input"]>
  >
}

/** Boolean expression to compare columns of type "payment_review_record_status". All fields are combined with logical 'AND'. */
export type Payment_Review_Record_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["payment_review_record_status"]["input"]>
  _gt?: InputMaybe<Scalars["payment_review_record_status"]["input"]>
  _gte?: InputMaybe<Scalars["payment_review_record_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["payment_review_record_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["payment_review_record_status"]["input"]>
  _lte?: InputMaybe<Scalars["payment_review_record_status"]["input"]>
  _neq?: InputMaybe<Scalars["payment_review_record_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["payment_review_record_status"]["input"]>>
}

/** columns and relationships of "payment_review_records" */
export type Payment_Review_Records = {
  __typename?: "payment_review_records"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at: Scalars["timestamptz"]["output"]
  created_junifer_note_id?: Maybe<Scalars["bigint"]["output"]>
  created_junifer_payment_schedule_period_id?: Maybe<Scalars["Int"]["output"]>
  customer_first_name?: Maybe<Scalars["String"]["output"]>
  discount_id?: Maybe<Scalars["bigint"]["output"]>
  discount_value?: Maybe<Scalars["numeric"]["output"]>
  email_address?: Maybe<Scalars["String"]["output"]>
  email_sent_at?: Maybe<Scalars["timestamptz"]["output"]>
  failure_error_code?: Maybe<Scalars["String"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  has_active_payment_plan?: Maybe<Scalars["Boolean"]["output"]>
  has_electricity?: Maybe<Scalars["Boolean"]["output"]>
  has_svt_tariff?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["bigint"]["output"]
  ignore_account_balance: Scalars["Boolean"]["output"]
  ignore_increase_threshold: Scalars["Boolean"]["output"]
  is_deleted: Scalars["Boolean"]["output"]
  junifer_account_id: Scalars["bigint"]["output"]
  junifer_note_created_at?: Maybe<Scalars["timestamptz"]["output"]>
  junifer_payment_schedule_period_id?: Maybe<Scalars["bigint"]["output"]>
  last_ignore_account_balance: Scalars["Boolean"]["output"]
  last_ignore_increase_threshold: Scalars["Boolean"]["output"]
  last_retry_time?: Maybe<Scalars["timestamptz"]["output"]>
  next_payment_date?: Maybe<Scalars["date"]["output"]>
  on_exclusion_list: Scalars["Boolean"]["output"]
  payment_frequency?: Maybe<
    Scalars["payment_review_record_payment_frequency"]["output"]
  >
  /** An array relationship */
  payment_review_calculations: Array<Payment_Review_Calculation>
  /** An aggregate relationship */
  payment_review_calculations_aggregate: Payment_Review_Calculation_Aggregate
  payment_review_id: Scalars["bigint"]["output"]
  /** An object relationship */
  payment_review_record_email?: Maybe<Payment_Review_Record_Emails>
  /** An object relationship */
  payment_review_record_note?: Maybe<Payment_Review_Record_Notes>
  payment_schedule_period_amount?: Maybe<Scalars["numeric"]["output"]>
  payment_schedule_period_from?: Maybe<Scalars["date"]["output"]>
  payment_spread?: Maybe<
    Scalars["payment_review_record_payment_spread"]["output"]
  >
  retry_count?: Maybe<Scalars["Int"]["output"]>
  seasonal_scheduled_amount?: Maybe<Scalars["numeric"]["output"]>
  status: Scalars["payment_review_record_status"]["output"]
  updated_at?: Maybe<Scalars["timestamptz"]["output"]>
}

/** columns and relationships of "payment_review_records" */
export type Payment_Review_RecordsPayment_Review_CalculationsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Review_Calculation_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Calculation_Order_By>>
  where?: InputMaybe<Payment_Review_Calculation_Bool_Exp>
}

/** columns and relationships of "payment_review_records" */
export type Payment_Review_RecordsPayment_Review_Calculations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Review_Calculation_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Calculation_Order_By>>
  where?: InputMaybe<Payment_Review_Calculation_Bool_Exp>
}

/** aggregated selection of "payment_review_records" */
export type Payment_Review_Records_Aggregate = {
  __typename?: "payment_review_records_aggregate"
  aggregate?: Maybe<Payment_Review_Records_Aggregate_Fields>
  nodes: Array<Payment_Review_Records>
}

/** aggregate fields of "payment_review_records" */
export type Payment_Review_Records_Aggregate_Fields = {
  __typename?: "payment_review_records_aggregate_fields"
  avg?: Maybe<Payment_Review_Records_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Payment_Review_Records_Max_Fields>
  min?: Maybe<Payment_Review_Records_Min_Fields>
  stddev?: Maybe<Payment_Review_Records_Stddev_Fields>
  stddev_pop?: Maybe<Payment_Review_Records_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Payment_Review_Records_Stddev_Samp_Fields>
  sum?: Maybe<Payment_Review_Records_Sum_Fields>
  var_pop?: Maybe<Payment_Review_Records_Var_Pop_Fields>
  var_samp?: Maybe<Payment_Review_Records_Var_Samp_Fields>
  variance?: Maybe<Payment_Review_Records_Variance_Fields>
}

/** aggregate fields of "payment_review_records" */
export type Payment_Review_Records_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Review_Records_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Payment_Review_Records_Avg_Fields = {
  __typename?: "payment_review_records_avg_fields"
  created_junifer_note_id?: Maybe<Scalars["Float"]["output"]>
  created_junifer_payment_schedule_period_id?: Maybe<Scalars["Float"]["output"]>
  discount_id?: Maybe<Scalars["Float"]["output"]>
  discount_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  junifer_payment_schedule_period_id?: Maybe<Scalars["Float"]["output"]>
  payment_review_id?: Maybe<Scalars["Float"]["output"]>
  payment_schedule_period_amount?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
  seasonal_scheduled_amount?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "payment_review_records". All fields are combined with a logical 'AND'. */
export type Payment_Review_Records_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Review_Records_Bool_Exp>>
  _not?: InputMaybe<Payment_Review_Records_Bool_Exp>
  _or?: InputMaybe<Array<Payment_Review_Records_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  created_junifer_note_id?: InputMaybe<Bigint_Comparison_Exp>
  created_junifer_payment_schedule_period_id?: InputMaybe<Int_Comparison_Exp>
  customer_first_name?: InputMaybe<String_Comparison_Exp>
  discount_id?: InputMaybe<Bigint_Comparison_Exp>
  discount_value?: InputMaybe<Numeric_Comparison_Exp>
  email_address?: InputMaybe<String_Comparison_Exp>
  email_sent_at?: InputMaybe<Timestamptz_Comparison_Exp>
  failure_error_code?: InputMaybe<String_Comparison_Exp>
  failure_reason?: InputMaybe<String_Comparison_Exp>
  has_active_payment_plan?: InputMaybe<Boolean_Comparison_Exp>
  has_electricity?: InputMaybe<Boolean_Comparison_Exp>
  has_svt_tariff?: InputMaybe<Boolean_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  ignore_account_balance?: InputMaybe<Boolean_Comparison_Exp>
  ignore_increase_threshold?: InputMaybe<Boolean_Comparison_Exp>
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>
  junifer_account_id?: InputMaybe<Bigint_Comparison_Exp>
  junifer_note_created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  junifer_payment_schedule_period_id?: InputMaybe<Bigint_Comparison_Exp>
  last_ignore_account_balance?: InputMaybe<Boolean_Comparison_Exp>
  last_ignore_increase_threshold?: InputMaybe<Boolean_Comparison_Exp>
  last_retry_time?: InputMaybe<Timestamptz_Comparison_Exp>
  next_payment_date?: InputMaybe<Date_Comparison_Exp>
  on_exclusion_list?: InputMaybe<Boolean_Comparison_Exp>
  payment_frequency?: InputMaybe<Payment_Review_Record_Payment_Frequency_Comparison_Exp>
  payment_review_calculations?: InputMaybe<Payment_Review_Calculation_Bool_Exp>
  payment_review_calculations_aggregate?: InputMaybe<Payment_Review_Calculation_Aggregate_Bool_Exp>
  payment_review_id?: InputMaybe<Bigint_Comparison_Exp>
  payment_review_record_email?: InputMaybe<Payment_Review_Record_Emails_Bool_Exp>
  payment_review_record_note?: InputMaybe<Payment_Review_Record_Notes_Bool_Exp>
  payment_schedule_period_amount?: InputMaybe<Numeric_Comparison_Exp>
  payment_schedule_period_from?: InputMaybe<Date_Comparison_Exp>
  payment_spread?: InputMaybe<Payment_Review_Record_Payment_Spread_Comparison_Exp>
  retry_count?: InputMaybe<Int_Comparison_Exp>
  seasonal_scheduled_amount?: InputMaybe<Numeric_Comparison_Exp>
  status?: InputMaybe<Payment_Review_Record_Status_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "payment_review_records" */
export enum Payment_Review_Records_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkPaymentReviewRecords = "pk_payment_review_records",
  /** unique or primary key constraint on columns "payment_review_id", "junifer_account_id" */
  UniqueConstraintPaymentReviewAccount = "unique_constraint_payment_review_account",
}

/** input type for incrementing numeric columns in table "payment_review_records" */
export type Payment_Review_Records_Inc_Input = {
  created_junifer_note_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_junifer_payment_schedule_period_id?: InputMaybe<
    Scalars["Int"]["input"]
  >
  discount_id?: InputMaybe<Scalars["bigint"]["input"]>
  discount_value?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_payment_schedule_period_id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_review_id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_schedule_period_amount?: InputMaybe<Scalars["numeric"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  seasonal_scheduled_amount?: InputMaybe<Scalars["numeric"]["input"]>
}

/** input type for inserting data into table "payment_review_records" */
export type Payment_Review_Records_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  created_junifer_note_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_junifer_payment_schedule_period_id?: InputMaybe<
    Scalars["Int"]["input"]
  >
  customer_first_name?: InputMaybe<Scalars["String"]["input"]>
  discount_id?: InputMaybe<Scalars["bigint"]["input"]>
  discount_value?: InputMaybe<Scalars["numeric"]["input"]>
  email_address?: InputMaybe<Scalars["String"]["input"]>
  email_sent_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_error_code?: InputMaybe<Scalars["String"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  has_active_payment_plan?: InputMaybe<Scalars["Boolean"]["input"]>
  has_electricity?: InputMaybe<Scalars["Boolean"]["input"]>
  has_svt_tariff?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  ignore_account_balance?: InputMaybe<Scalars["Boolean"]["input"]>
  ignore_increase_threshold?: InputMaybe<Scalars["Boolean"]["input"]>
  is_deleted?: InputMaybe<Scalars["Boolean"]["input"]>
  junifer_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_note_created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  junifer_payment_schedule_period_id?: InputMaybe<Scalars["bigint"]["input"]>
  last_ignore_account_balance?: InputMaybe<Scalars["Boolean"]["input"]>
  last_ignore_increase_threshold?: InputMaybe<Scalars["Boolean"]["input"]>
  last_retry_time?: InputMaybe<Scalars["timestamptz"]["input"]>
  next_payment_date?: InputMaybe<Scalars["date"]["input"]>
  on_exclusion_list?: InputMaybe<Scalars["Boolean"]["input"]>
  payment_frequency?: InputMaybe<
    Scalars["payment_review_record_payment_frequency"]["input"]
  >
  payment_review_calculations?: InputMaybe<Payment_Review_Calculation_Arr_Rel_Insert_Input>
  payment_review_id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_review_record_email?: InputMaybe<Payment_Review_Record_Emails_Obj_Rel_Insert_Input>
  payment_review_record_note?: InputMaybe<Payment_Review_Record_Notes_Obj_Rel_Insert_Input>
  payment_schedule_period_amount?: InputMaybe<Scalars["numeric"]["input"]>
  payment_schedule_period_from?: InputMaybe<Scalars["date"]["input"]>
  payment_spread?: InputMaybe<
    Scalars["payment_review_record_payment_spread"]["input"]
  >
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  seasonal_scheduled_amount?: InputMaybe<Scalars["numeric"]["input"]>
  status?: InputMaybe<Scalars["payment_review_record_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamptz"]["input"]>
}

/** aggregate max on columns */
export type Payment_Review_Records_Max_Fields = {
  __typename?: "payment_review_records_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  created_junifer_note_id?: Maybe<Scalars["bigint"]["output"]>
  created_junifer_payment_schedule_period_id?: Maybe<Scalars["Int"]["output"]>
  customer_first_name?: Maybe<Scalars["String"]["output"]>
  discount_id?: Maybe<Scalars["bigint"]["output"]>
  discount_value?: Maybe<Scalars["numeric"]["output"]>
  email_address?: Maybe<Scalars["String"]["output"]>
  email_sent_at?: Maybe<Scalars["timestamptz"]["output"]>
  failure_error_code?: Maybe<Scalars["String"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_account_id?: Maybe<Scalars["bigint"]["output"]>
  junifer_note_created_at?: Maybe<Scalars["timestamptz"]["output"]>
  junifer_payment_schedule_period_id?: Maybe<Scalars["bigint"]["output"]>
  last_retry_time?: Maybe<Scalars["timestamptz"]["output"]>
  next_payment_date?: Maybe<Scalars["date"]["output"]>
  payment_frequency?: Maybe<
    Scalars["payment_review_record_payment_frequency"]["output"]
  >
  payment_review_id?: Maybe<Scalars["bigint"]["output"]>
  payment_schedule_period_amount?: Maybe<Scalars["numeric"]["output"]>
  payment_schedule_period_from?: Maybe<Scalars["date"]["output"]>
  payment_spread?: Maybe<
    Scalars["payment_review_record_payment_spread"]["output"]
  >
  retry_count?: Maybe<Scalars["Int"]["output"]>
  seasonal_scheduled_amount?: Maybe<Scalars["numeric"]["output"]>
  status?: Maybe<Scalars["payment_review_record_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamptz"]["output"]>
}

/** aggregate min on columns */
export type Payment_Review_Records_Min_Fields = {
  __typename?: "payment_review_records_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  created_junifer_note_id?: Maybe<Scalars["bigint"]["output"]>
  created_junifer_payment_schedule_period_id?: Maybe<Scalars["Int"]["output"]>
  customer_first_name?: Maybe<Scalars["String"]["output"]>
  discount_id?: Maybe<Scalars["bigint"]["output"]>
  discount_value?: Maybe<Scalars["numeric"]["output"]>
  email_address?: Maybe<Scalars["String"]["output"]>
  email_sent_at?: Maybe<Scalars["timestamptz"]["output"]>
  failure_error_code?: Maybe<Scalars["String"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_account_id?: Maybe<Scalars["bigint"]["output"]>
  junifer_note_created_at?: Maybe<Scalars["timestamptz"]["output"]>
  junifer_payment_schedule_period_id?: Maybe<Scalars["bigint"]["output"]>
  last_retry_time?: Maybe<Scalars["timestamptz"]["output"]>
  next_payment_date?: Maybe<Scalars["date"]["output"]>
  payment_frequency?: Maybe<
    Scalars["payment_review_record_payment_frequency"]["output"]
  >
  payment_review_id?: Maybe<Scalars["bigint"]["output"]>
  payment_schedule_period_amount?: Maybe<Scalars["numeric"]["output"]>
  payment_schedule_period_from?: Maybe<Scalars["date"]["output"]>
  payment_spread?: Maybe<
    Scalars["payment_review_record_payment_spread"]["output"]
  >
  retry_count?: Maybe<Scalars["Int"]["output"]>
  seasonal_scheduled_amount?: Maybe<Scalars["numeric"]["output"]>
  status?: Maybe<Scalars["payment_review_record_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamptz"]["output"]>
}

/** response of any mutation on the table "payment_review_records" */
export type Payment_Review_Records_Mutation_Response = {
  __typename?: "payment_review_records_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Review_Records>
}

/** input type for inserting object relation for remote table "payment_review_records" */
export type Payment_Review_Records_Obj_Rel_Insert_Input = {
  data: Payment_Review_Records_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_Review_Records_On_Conflict>
}

/** on_conflict condition type for table "payment_review_records" */
export type Payment_Review_Records_On_Conflict = {
  constraint: Payment_Review_Records_Constraint
  update_columns?: Array<Payment_Review_Records_Update_Column>
  where?: InputMaybe<Payment_Review_Records_Bool_Exp>
}

/** Ordering options when selecting data from "payment_review_records". */
export type Payment_Review_Records_Order_By = {
  account_number?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  created_junifer_note_id?: InputMaybe<Order_By>
  created_junifer_payment_schedule_period_id?: InputMaybe<Order_By>
  customer_first_name?: InputMaybe<Order_By>
  discount_id?: InputMaybe<Order_By>
  discount_value?: InputMaybe<Order_By>
  email_address?: InputMaybe<Order_By>
  email_sent_at?: InputMaybe<Order_By>
  failure_error_code?: InputMaybe<Order_By>
  failure_reason?: InputMaybe<Order_By>
  has_active_payment_plan?: InputMaybe<Order_By>
  has_electricity?: InputMaybe<Order_By>
  has_svt_tariff?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  ignore_account_balance?: InputMaybe<Order_By>
  ignore_increase_threshold?: InputMaybe<Order_By>
  is_deleted?: InputMaybe<Order_By>
  junifer_account_id?: InputMaybe<Order_By>
  junifer_note_created_at?: InputMaybe<Order_By>
  junifer_payment_schedule_period_id?: InputMaybe<Order_By>
  last_ignore_account_balance?: InputMaybe<Order_By>
  last_ignore_increase_threshold?: InputMaybe<Order_By>
  last_retry_time?: InputMaybe<Order_By>
  next_payment_date?: InputMaybe<Order_By>
  on_exclusion_list?: InputMaybe<Order_By>
  payment_frequency?: InputMaybe<Order_By>
  payment_review_calculations_aggregate?: InputMaybe<Payment_Review_Calculation_Aggregate_Order_By>
  payment_review_id?: InputMaybe<Order_By>
  payment_review_record_email?: InputMaybe<Payment_Review_Record_Emails_Order_By>
  payment_review_record_note?: InputMaybe<Payment_Review_Record_Notes_Order_By>
  payment_schedule_period_amount?: InputMaybe<Order_By>
  payment_schedule_period_from?: InputMaybe<Order_By>
  payment_spread?: InputMaybe<Order_By>
  retry_count?: InputMaybe<Order_By>
  seasonal_scheduled_amount?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: payment_review_records */
export type Payment_Review_Records_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "payment_review_records" */
export enum Payment_Review_Records_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CreatedJuniferNoteId = "created_junifer_note_id",
  /** column name */
  CreatedJuniferPaymentSchedulePeriodId = "created_junifer_payment_schedule_period_id",
  /** column name */
  CustomerFirstName = "customer_first_name",
  /** column name */
  DiscountId = "discount_id",
  /** column name */
  DiscountValue = "discount_value",
  /** column name */
  EmailAddress = "email_address",
  /** column name */
  EmailSentAt = "email_sent_at",
  /** column name */
  FailureErrorCode = "failure_error_code",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  HasActivePaymentPlan = "has_active_payment_plan",
  /** column name */
  HasElectricity = "has_electricity",
  /** column name */
  HasSvtTariff = "has_svt_tariff",
  /** column name */
  Id = "id",
  /** column name */
  IgnoreAccountBalance = "ignore_account_balance",
  /** column name */
  IgnoreIncreaseThreshold = "ignore_increase_threshold",
  /** column name */
  IsDeleted = "is_deleted",
  /** column name */
  JuniferAccountId = "junifer_account_id",
  /** column name */
  JuniferNoteCreatedAt = "junifer_note_created_at",
  /** column name */
  JuniferPaymentSchedulePeriodId = "junifer_payment_schedule_period_id",
  /** column name */
  LastIgnoreAccountBalance = "last_ignore_account_balance",
  /** column name */
  LastIgnoreIncreaseThreshold = "last_ignore_increase_threshold",
  /** column name */
  LastRetryTime = "last_retry_time",
  /** column name */
  NextPaymentDate = "next_payment_date",
  /** column name */
  OnExclusionList = "on_exclusion_list",
  /** column name */
  PaymentFrequency = "payment_frequency",
  /** column name */
  PaymentReviewId = "payment_review_id",
  /** column name */
  PaymentSchedulePeriodAmount = "payment_schedule_period_amount",
  /** column name */
  PaymentSchedulePeriodFrom = "payment_schedule_period_from",
  /** column name */
  PaymentSpread = "payment_spread",
  /** column name */
  RetryCount = "retry_count",
  /** column name */
  SeasonalScheduledAmount = "seasonal_scheduled_amount",
  /** column name */
  Status = "status",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "payment_review_records" */
export type Payment_Review_Records_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  created_junifer_note_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_junifer_payment_schedule_period_id?: InputMaybe<
    Scalars["Int"]["input"]
  >
  customer_first_name?: InputMaybe<Scalars["String"]["input"]>
  discount_id?: InputMaybe<Scalars["bigint"]["input"]>
  discount_value?: InputMaybe<Scalars["numeric"]["input"]>
  email_address?: InputMaybe<Scalars["String"]["input"]>
  email_sent_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_error_code?: InputMaybe<Scalars["String"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  has_active_payment_plan?: InputMaybe<Scalars["Boolean"]["input"]>
  has_electricity?: InputMaybe<Scalars["Boolean"]["input"]>
  has_svt_tariff?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  ignore_account_balance?: InputMaybe<Scalars["Boolean"]["input"]>
  ignore_increase_threshold?: InputMaybe<Scalars["Boolean"]["input"]>
  is_deleted?: InputMaybe<Scalars["Boolean"]["input"]>
  junifer_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_note_created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  junifer_payment_schedule_period_id?: InputMaybe<Scalars["bigint"]["input"]>
  last_ignore_account_balance?: InputMaybe<Scalars["Boolean"]["input"]>
  last_ignore_increase_threshold?: InputMaybe<Scalars["Boolean"]["input"]>
  last_retry_time?: InputMaybe<Scalars["timestamptz"]["input"]>
  next_payment_date?: InputMaybe<Scalars["date"]["input"]>
  on_exclusion_list?: InputMaybe<Scalars["Boolean"]["input"]>
  payment_frequency?: InputMaybe<
    Scalars["payment_review_record_payment_frequency"]["input"]
  >
  payment_review_id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_schedule_period_amount?: InputMaybe<Scalars["numeric"]["input"]>
  payment_schedule_period_from?: InputMaybe<Scalars["date"]["input"]>
  payment_spread?: InputMaybe<
    Scalars["payment_review_record_payment_spread"]["input"]
  >
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  seasonal_scheduled_amount?: InputMaybe<Scalars["numeric"]["input"]>
  status?: InputMaybe<Scalars["payment_review_record_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamptz"]["input"]>
}

/** aggregate stddev on columns */
export type Payment_Review_Records_Stddev_Fields = {
  __typename?: "payment_review_records_stddev_fields"
  created_junifer_note_id?: Maybe<Scalars["Float"]["output"]>
  created_junifer_payment_schedule_period_id?: Maybe<Scalars["Float"]["output"]>
  discount_id?: Maybe<Scalars["Float"]["output"]>
  discount_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  junifer_payment_schedule_period_id?: Maybe<Scalars["Float"]["output"]>
  payment_review_id?: Maybe<Scalars["Float"]["output"]>
  payment_schedule_period_amount?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
  seasonal_scheduled_amount?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Payment_Review_Records_Stddev_Pop_Fields = {
  __typename?: "payment_review_records_stddev_pop_fields"
  created_junifer_note_id?: Maybe<Scalars["Float"]["output"]>
  created_junifer_payment_schedule_period_id?: Maybe<Scalars["Float"]["output"]>
  discount_id?: Maybe<Scalars["Float"]["output"]>
  discount_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  junifer_payment_schedule_period_id?: Maybe<Scalars["Float"]["output"]>
  payment_review_id?: Maybe<Scalars["Float"]["output"]>
  payment_schedule_period_amount?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
  seasonal_scheduled_amount?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Payment_Review_Records_Stddev_Samp_Fields = {
  __typename?: "payment_review_records_stddev_samp_fields"
  created_junifer_note_id?: Maybe<Scalars["Float"]["output"]>
  created_junifer_payment_schedule_period_id?: Maybe<Scalars["Float"]["output"]>
  discount_id?: Maybe<Scalars["Float"]["output"]>
  discount_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  junifer_payment_schedule_period_id?: Maybe<Scalars["Float"]["output"]>
  payment_review_id?: Maybe<Scalars["Float"]["output"]>
  payment_schedule_period_amount?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
  seasonal_scheduled_amount?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "payment_review_records" */
export type Payment_Review_Records_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Review_Records_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Payment_Review_Records_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  created_junifer_note_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_junifer_payment_schedule_period_id?: InputMaybe<
    Scalars["Int"]["input"]
  >
  customer_first_name?: InputMaybe<Scalars["String"]["input"]>
  discount_id?: InputMaybe<Scalars["bigint"]["input"]>
  discount_value?: InputMaybe<Scalars["numeric"]["input"]>
  email_address?: InputMaybe<Scalars["String"]["input"]>
  email_sent_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_error_code?: InputMaybe<Scalars["String"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  has_active_payment_plan?: InputMaybe<Scalars["Boolean"]["input"]>
  has_electricity?: InputMaybe<Scalars["Boolean"]["input"]>
  has_svt_tariff?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  ignore_account_balance?: InputMaybe<Scalars["Boolean"]["input"]>
  ignore_increase_threshold?: InputMaybe<Scalars["Boolean"]["input"]>
  is_deleted?: InputMaybe<Scalars["Boolean"]["input"]>
  junifer_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_note_created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  junifer_payment_schedule_period_id?: InputMaybe<Scalars["bigint"]["input"]>
  last_ignore_account_balance?: InputMaybe<Scalars["Boolean"]["input"]>
  last_ignore_increase_threshold?: InputMaybe<Scalars["Boolean"]["input"]>
  last_retry_time?: InputMaybe<Scalars["timestamptz"]["input"]>
  next_payment_date?: InputMaybe<Scalars["date"]["input"]>
  on_exclusion_list?: InputMaybe<Scalars["Boolean"]["input"]>
  payment_frequency?: InputMaybe<
    Scalars["payment_review_record_payment_frequency"]["input"]
  >
  payment_review_id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_schedule_period_amount?: InputMaybe<Scalars["numeric"]["input"]>
  payment_schedule_period_from?: InputMaybe<Scalars["date"]["input"]>
  payment_spread?: InputMaybe<
    Scalars["payment_review_record_payment_spread"]["input"]
  >
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  seasonal_scheduled_amount?: InputMaybe<Scalars["numeric"]["input"]>
  status?: InputMaybe<Scalars["payment_review_record_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamptz"]["input"]>
}

/** aggregate sum on columns */
export type Payment_Review_Records_Sum_Fields = {
  __typename?: "payment_review_records_sum_fields"
  created_junifer_note_id?: Maybe<Scalars["bigint"]["output"]>
  created_junifer_payment_schedule_period_id?: Maybe<Scalars["Int"]["output"]>
  discount_id?: Maybe<Scalars["bigint"]["output"]>
  discount_value?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_account_id?: Maybe<Scalars["bigint"]["output"]>
  junifer_payment_schedule_period_id?: Maybe<Scalars["bigint"]["output"]>
  payment_review_id?: Maybe<Scalars["bigint"]["output"]>
  payment_schedule_period_amount?: Maybe<Scalars["numeric"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
  seasonal_scheduled_amount?: Maybe<Scalars["numeric"]["output"]>
}

/** update columns of table "payment_review_records" */
export enum Payment_Review_Records_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CreatedJuniferNoteId = "created_junifer_note_id",
  /** column name */
  CreatedJuniferPaymentSchedulePeriodId = "created_junifer_payment_schedule_period_id",
  /** column name */
  CustomerFirstName = "customer_first_name",
  /** column name */
  DiscountId = "discount_id",
  /** column name */
  DiscountValue = "discount_value",
  /** column name */
  EmailAddress = "email_address",
  /** column name */
  EmailSentAt = "email_sent_at",
  /** column name */
  FailureErrorCode = "failure_error_code",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  HasActivePaymentPlan = "has_active_payment_plan",
  /** column name */
  HasElectricity = "has_electricity",
  /** column name */
  HasSvtTariff = "has_svt_tariff",
  /** column name */
  Id = "id",
  /** column name */
  IgnoreAccountBalance = "ignore_account_balance",
  /** column name */
  IgnoreIncreaseThreshold = "ignore_increase_threshold",
  /** column name */
  IsDeleted = "is_deleted",
  /** column name */
  JuniferAccountId = "junifer_account_id",
  /** column name */
  JuniferNoteCreatedAt = "junifer_note_created_at",
  /** column name */
  JuniferPaymentSchedulePeriodId = "junifer_payment_schedule_period_id",
  /** column name */
  LastIgnoreAccountBalance = "last_ignore_account_balance",
  /** column name */
  LastIgnoreIncreaseThreshold = "last_ignore_increase_threshold",
  /** column name */
  LastRetryTime = "last_retry_time",
  /** column name */
  NextPaymentDate = "next_payment_date",
  /** column name */
  OnExclusionList = "on_exclusion_list",
  /** column name */
  PaymentFrequency = "payment_frequency",
  /** column name */
  PaymentReviewId = "payment_review_id",
  /** column name */
  PaymentSchedulePeriodAmount = "payment_schedule_period_amount",
  /** column name */
  PaymentSchedulePeriodFrom = "payment_schedule_period_from",
  /** column name */
  PaymentSpread = "payment_spread",
  /** column name */
  RetryCount = "retry_count",
  /** column name */
  SeasonalScheduledAmount = "seasonal_scheduled_amount",
  /** column name */
  Status = "status",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Payment_Review_Records_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Review_Records_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Review_Records_Set_Input>
  /** filter the rows which have to be updated */
  where: Payment_Review_Records_Bool_Exp
}

/** aggregate var_pop on columns */
export type Payment_Review_Records_Var_Pop_Fields = {
  __typename?: "payment_review_records_var_pop_fields"
  created_junifer_note_id?: Maybe<Scalars["Float"]["output"]>
  created_junifer_payment_schedule_period_id?: Maybe<Scalars["Float"]["output"]>
  discount_id?: Maybe<Scalars["Float"]["output"]>
  discount_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  junifer_payment_schedule_period_id?: Maybe<Scalars["Float"]["output"]>
  payment_review_id?: Maybe<Scalars["Float"]["output"]>
  payment_schedule_period_amount?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
  seasonal_scheduled_amount?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Payment_Review_Records_Var_Samp_Fields = {
  __typename?: "payment_review_records_var_samp_fields"
  created_junifer_note_id?: Maybe<Scalars["Float"]["output"]>
  created_junifer_payment_schedule_period_id?: Maybe<Scalars["Float"]["output"]>
  discount_id?: Maybe<Scalars["Float"]["output"]>
  discount_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  junifer_payment_schedule_period_id?: Maybe<Scalars["Float"]["output"]>
  payment_review_id?: Maybe<Scalars["Float"]["output"]>
  payment_schedule_period_amount?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
  seasonal_scheduled_amount?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Payment_Review_Records_Variance_Fields = {
  __typename?: "payment_review_records_variance_fields"
  created_junifer_note_id?: Maybe<Scalars["Float"]["output"]>
  created_junifer_payment_schedule_period_id?: Maybe<Scalars["Float"]["output"]>
  discount_id?: Maybe<Scalars["Float"]["output"]>
  discount_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  junifer_payment_schedule_period_id?: Maybe<Scalars["Float"]["output"]>
  payment_review_id?: Maybe<Scalars["Float"]["output"]>
  payment_schedule_period_amount?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
  seasonal_scheduled_amount?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "payment_review_records_view" */
export type Payment_Review_Records_View = {
  __typename?: "payment_review_records_view"
  account_balance?: Maybe<Scalars["numeric"]["output"]>
  account_balance_applied?: Maybe<Scalars["numeric"]["output"]>
  account_number?: Maybe<Scalars["String"]["output"]>
  calc_id?: Maybe<Scalars["bigint"]["output"]>
  change_percentage?: Maybe<Scalars["numeric"]["output"]>
  changed_amount?: Maybe<Scalars["numeric"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  estimate_annual_cost?: Maybe<Scalars["numeric"]["output"]>
  failure_error_code?: Maybe<Scalars["String"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_account_id?: Maybe<Scalars["bigint"]["output"]>
  last_retry_time?: Maybe<Scalars["timestamptz"]["output"]>
  new_monthly_amount?: Maybe<Scalars["numeric"]["output"]>
  next_payment_date?: Maybe<Scalars["date"]["output"]>
  payment_review_id?: Maybe<Scalars["bigint"]["output"]>
  payment_schedule_period_amount?: Maybe<Scalars["numeric"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
  status?: Maybe<Scalars["payment_review_record_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamptz"]["output"]>
}

/** aggregated selection of "payment_review_records_view" */
export type Payment_Review_Records_View_Aggregate = {
  __typename?: "payment_review_records_view_aggregate"
  aggregate?: Maybe<Payment_Review_Records_View_Aggregate_Fields>
  nodes: Array<Payment_Review_Records_View>
}

/** aggregate fields of "payment_review_records_view" */
export type Payment_Review_Records_View_Aggregate_Fields = {
  __typename?: "payment_review_records_view_aggregate_fields"
  avg?: Maybe<Payment_Review_Records_View_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Payment_Review_Records_View_Max_Fields>
  min?: Maybe<Payment_Review_Records_View_Min_Fields>
  stddev?: Maybe<Payment_Review_Records_View_Stddev_Fields>
  stddev_pop?: Maybe<Payment_Review_Records_View_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Payment_Review_Records_View_Stddev_Samp_Fields>
  sum?: Maybe<Payment_Review_Records_View_Sum_Fields>
  var_pop?: Maybe<Payment_Review_Records_View_Var_Pop_Fields>
  var_samp?: Maybe<Payment_Review_Records_View_Var_Samp_Fields>
  variance?: Maybe<Payment_Review_Records_View_Variance_Fields>
}

/** aggregate fields of "payment_review_records_view" */
export type Payment_Review_Records_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Review_Records_View_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Payment_Review_Records_View_Avg_Fields = {
  __typename?: "payment_review_records_view_avg_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  account_balance_applied?: Maybe<Scalars["Float"]["output"]>
  calc_id?: Maybe<Scalars["Float"]["output"]>
  change_percentage?: Maybe<Scalars["Float"]["output"]>
  changed_amount?: Maybe<Scalars["Float"]["output"]>
  estimate_annual_cost?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount?: Maybe<Scalars["Float"]["output"]>
  payment_review_id?: Maybe<Scalars["Float"]["output"]>
  payment_schedule_period_amount?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "payment_review_records_view". All fields are combined with a logical 'AND'. */
export type Payment_Review_Records_View_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Review_Records_View_Bool_Exp>>
  _not?: InputMaybe<Payment_Review_Records_View_Bool_Exp>
  _or?: InputMaybe<Array<Payment_Review_Records_View_Bool_Exp>>
  account_balance?: InputMaybe<Numeric_Comparison_Exp>
  account_balance_applied?: InputMaybe<Numeric_Comparison_Exp>
  account_number?: InputMaybe<String_Comparison_Exp>
  calc_id?: InputMaybe<Bigint_Comparison_Exp>
  change_percentage?: InputMaybe<Numeric_Comparison_Exp>
  changed_amount?: InputMaybe<Numeric_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  estimate_annual_cost?: InputMaybe<Numeric_Comparison_Exp>
  failure_error_code?: InputMaybe<String_Comparison_Exp>
  failure_reason?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  junifer_account_id?: InputMaybe<Bigint_Comparison_Exp>
  last_retry_time?: InputMaybe<Timestamptz_Comparison_Exp>
  new_monthly_amount?: InputMaybe<Numeric_Comparison_Exp>
  next_payment_date?: InputMaybe<Date_Comparison_Exp>
  payment_review_id?: InputMaybe<Bigint_Comparison_Exp>
  payment_schedule_period_amount?: InputMaybe<Numeric_Comparison_Exp>
  retry_count?: InputMaybe<Int_Comparison_Exp>
  status?: InputMaybe<Payment_Review_Record_Status_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** aggregate max on columns */
export type Payment_Review_Records_View_Max_Fields = {
  __typename?: "payment_review_records_view_max_fields"
  account_balance?: Maybe<Scalars["numeric"]["output"]>
  account_balance_applied?: Maybe<Scalars["numeric"]["output"]>
  account_number?: Maybe<Scalars["String"]["output"]>
  calc_id?: Maybe<Scalars["bigint"]["output"]>
  change_percentage?: Maybe<Scalars["numeric"]["output"]>
  changed_amount?: Maybe<Scalars["numeric"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  estimate_annual_cost?: Maybe<Scalars["numeric"]["output"]>
  failure_error_code?: Maybe<Scalars["String"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_account_id?: Maybe<Scalars["bigint"]["output"]>
  last_retry_time?: Maybe<Scalars["timestamptz"]["output"]>
  new_monthly_amount?: Maybe<Scalars["numeric"]["output"]>
  next_payment_date?: Maybe<Scalars["date"]["output"]>
  payment_review_id?: Maybe<Scalars["bigint"]["output"]>
  payment_schedule_period_amount?: Maybe<Scalars["numeric"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
  status?: Maybe<Scalars["payment_review_record_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamptz"]["output"]>
}

/** aggregate min on columns */
export type Payment_Review_Records_View_Min_Fields = {
  __typename?: "payment_review_records_view_min_fields"
  account_balance?: Maybe<Scalars["numeric"]["output"]>
  account_balance_applied?: Maybe<Scalars["numeric"]["output"]>
  account_number?: Maybe<Scalars["String"]["output"]>
  calc_id?: Maybe<Scalars["bigint"]["output"]>
  change_percentage?: Maybe<Scalars["numeric"]["output"]>
  changed_amount?: Maybe<Scalars["numeric"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  estimate_annual_cost?: Maybe<Scalars["numeric"]["output"]>
  failure_error_code?: Maybe<Scalars["String"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_account_id?: Maybe<Scalars["bigint"]["output"]>
  last_retry_time?: Maybe<Scalars["timestamptz"]["output"]>
  new_monthly_amount?: Maybe<Scalars["numeric"]["output"]>
  next_payment_date?: Maybe<Scalars["date"]["output"]>
  payment_review_id?: Maybe<Scalars["bigint"]["output"]>
  payment_schedule_period_amount?: Maybe<Scalars["numeric"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
  status?: Maybe<Scalars["payment_review_record_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamptz"]["output"]>
}

/** Ordering options when selecting data from "payment_review_records_view". */
export type Payment_Review_Records_View_Order_By = {
  account_balance?: InputMaybe<Order_By>
  account_balance_applied?: InputMaybe<Order_By>
  account_number?: InputMaybe<Order_By>
  calc_id?: InputMaybe<Order_By>
  change_percentage?: InputMaybe<Order_By>
  changed_amount?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  estimate_annual_cost?: InputMaybe<Order_By>
  failure_error_code?: InputMaybe<Order_By>
  failure_reason?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  junifer_account_id?: InputMaybe<Order_By>
  last_retry_time?: InputMaybe<Order_By>
  new_monthly_amount?: InputMaybe<Order_By>
  next_payment_date?: InputMaybe<Order_By>
  payment_review_id?: InputMaybe<Order_By>
  payment_schedule_period_amount?: InputMaybe<Order_By>
  retry_count?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** select columns of table "payment_review_records_view" */
export enum Payment_Review_Records_View_Select_Column {
  /** column name */
  AccountBalance = "account_balance",
  /** column name */
  AccountBalanceApplied = "account_balance_applied",
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CalcId = "calc_id",
  /** column name */
  ChangePercentage = "change_percentage",
  /** column name */
  ChangedAmount = "changed_amount",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  EstimateAnnualCost = "estimate_annual_cost",
  /** column name */
  FailureErrorCode = "failure_error_code",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  JuniferAccountId = "junifer_account_id",
  /** column name */
  LastRetryTime = "last_retry_time",
  /** column name */
  NewMonthlyAmount = "new_monthly_amount",
  /** column name */
  NextPaymentDate = "next_payment_date",
  /** column name */
  PaymentReviewId = "payment_review_id",
  /** column name */
  PaymentSchedulePeriodAmount = "payment_schedule_period_amount",
  /** column name */
  RetryCount = "retry_count",
  /** column name */
  Status = "status",
  /** column name */
  UpdatedAt = "updated_at",
}

/** aggregate stddev on columns */
export type Payment_Review_Records_View_Stddev_Fields = {
  __typename?: "payment_review_records_view_stddev_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  account_balance_applied?: Maybe<Scalars["Float"]["output"]>
  calc_id?: Maybe<Scalars["Float"]["output"]>
  change_percentage?: Maybe<Scalars["Float"]["output"]>
  changed_amount?: Maybe<Scalars["Float"]["output"]>
  estimate_annual_cost?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount?: Maybe<Scalars["Float"]["output"]>
  payment_review_id?: Maybe<Scalars["Float"]["output"]>
  payment_schedule_period_amount?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Payment_Review_Records_View_Stddev_Pop_Fields = {
  __typename?: "payment_review_records_view_stddev_pop_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  account_balance_applied?: Maybe<Scalars["Float"]["output"]>
  calc_id?: Maybe<Scalars["Float"]["output"]>
  change_percentage?: Maybe<Scalars["Float"]["output"]>
  changed_amount?: Maybe<Scalars["Float"]["output"]>
  estimate_annual_cost?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount?: Maybe<Scalars["Float"]["output"]>
  payment_review_id?: Maybe<Scalars["Float"]["output"]>
  payment_schedule_period_amount?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Payment_Review_Records_View_Stddev_Samp_Fields = {
  __typename?: "payment_review_records_view_stddev_samp_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  account_balance_applied?: Maybe<Scalars["Float"]["output"]>
  calc_id?: Maybe<Scalars["Float"]["output"]>
  change_percentage?: Maybe<Scalars["Float"]["output"]>
  changed_amount?: Maybe<Scalars["Float"]["output"]>
  estimate_annual_cost?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount?: Maybe<Scalars["Float"]["output"]>
  payment_review_id?: Maybe<Scalars["Float"]["output"]>
  payment_schedule_period_amount?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "payment_review_records_view" */
export type Payment_Review_Records_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Review_Records_View_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Payment_Review_Records_View_Stream_Cursor_Value_Input = {
  account_balance?: InputMaybe<Scalars["numeric"]["input"]>
  account_balance_applied?: InputMaybe<Scalars["numeric"]["input"]>
  account_number?: InputMaybe<Scalars["String"]["input"]>
  calc_id?: InputMaybe<Scalars["bigint"]["input"]>
  change_percentage?: InputMaybe<Scalars["numeric"]["input"]>
  changed_amount?: InputMaybe<Scalars["numeric"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  estimate_annual_cost?: InputMaybe<Scalars["numeric"]["input"]>
  failure_error_code?: InputMaybe<Scalars["String"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  last_retry_time?: InputMaybe<Scalars["timestamptz"]["input"]>
  new_monthly_amount?: InputMaybe<Scalars["numeric"]["input"]>
  next_payment_date?: InputMaybe<Scalars["date"]["input"]>
  payment_review_id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_schedule_period_amount?: InputMaybe<Scalars["numeric"]["input"]>
  retry_count?: InputMaybe<Scalars["Int"]["input"]>
  status?: InputMaybe<Scalars["payment_review_record_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamptz"]["input"]>
}

/** aggregate sum on columns */
export type Payment_Review_Records_View_Sum_Fields = {
  __typename?: "payment_review_records_view_sum_fields"
  account_balance?: Maybe<Scalars["numeric"]["output"]>
  account_balance_applied?: Maybe<Scalars["numeric"]["output"]>
  calc_id?: Maybe<Scalars["bigint"]["output"]>
  change_percentage?: Maybe<Scalars["numeric"]["output"]>
  changed_amount?: Maybe<Scalars["numeric"]["output"]>
  estimate_annual_cost?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_account_id?: Maybe<Scalars["bigint"]["output"]>
  new_monthly_amount?: Maybe<Scalars["numeric"]["output"]>
  payment_review_id?: Maybe<Scalars["bigint"]["output"]>
  payment_schedule_period_amount?: Maybe<Scalars["numeric"]["output"]>
  retry_count?: Maybe<Scalars["Int"]["output"]>
}

/** aggregate var_pop on columns */
export type Payment_Review_Records_View_Var_Pop_Fields = {
  __typename?: "payment_review_records_view_var_pop_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  account_balance_applied?: Maybe<Scalars["Float"]["output"]>
  calc_id?: Maybe<Scalars["Float"]["output"]>
  change_percentage?: Maybe<Scalars["Float"]["output"]>
  changed_amount?: Maybe<Scalars["Float"]["output"]>
  estimate_annual_cost?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount?: Maybe<Scalars["Float"]["output"]>
  payment_review_id?: Maybe<Scalars["Float"]["output"]>
  payment_schedule_period_amount?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Payment_Review_Records_View_Var_Samp_Fields = {
  __typename?: "payment_review_records_view_var_samp_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  account_balance_applied?: Maybe<Scalars["Float"]["output"]>
  calc_id?: Maybe<Scalars["Float"]["output"]>
  change_percentage?: Maybe<Scalars["Float"]["output"]>
  changed_amount?: Maybe<Scalars["Float"]["output"]>
  estimate_annual_cost?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount?: Maybe<Scalars["Float"]["output"]>
  payment_review_id?: Maybe<Scalars["Float"]["output"]>
  payment_schedule_period_amount?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Payment_Review_Records_View_Variance_Fields = {
  __typename?: "payment_review_records_view_variance_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  account_balance_applied?: Maybe<Scalars["Float"]["output"]>
  calc_id?: Maybe<Scalars["Float"]["output"]>
  change_percentage?: Maybe<Scalars["Float"]["output"]>
  changed_amount?: Maybe<Scalars["Float"]["output"]>
  estimate_annual_cost?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  new_monthly_amount?: Maybe<Scalars["Float"]["output"]>
  payment_review_id?: Maybe<Scalars["Float"]["output"]>
  payment_schedule_period_amount?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "payment_reviews" */
export type Payment_Reviews = {
  __typename?: "payment_reviews"
  config_account_for_ebss: Scalars["Boolean"]["output"]
  config_calculation_type: Scalars["calculation_type_enum"]["output"]
  config_datasource: Scalars["payment_review_datasource"]["output"]
  config_ebbs_enabled: Scalars["Boolean"]["output"]
  config_ebss_value: Scalars["numeric"]["output"]
  config_enabled: Scalars["Boolean"]["output"]
  config_overide_threshold_percentage: Scalars["numeric"]["output"]
  config_override_threshold_absolute: Scalars["numeric"]["output"]
  config_tariff_change_in_weeks_threshold: Scalars["numeric"]["output"]
  created_at: Scalars["timestamptz"]["output"]
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  name: Scalars["String"]["output"]
  starts_at: Scalars["timestamptz"]["output"]
  type: Scalars["payment_reviews_type_enum"]["output"]
  updated_at?: Maybe<Scalars["timestamptz"]["output"]>
}

/** aggregated selection of "payment_reviews" */
export type Payment_Reviews_Aggregate = {
  __typename?: "payment_reviews_aggregate"
  aggregate?: Maybe<Payment_Reviews_Aggregate_Fields>
  nodes: Array<Payment_Reviews>
}

/** aggregate fields of "payment_reviews" */
export type Payment_Reviews_Aggregate_Fields = {
  __typename?: "payment_reviews_aggregate_fields"
  avg?: Maybe<Payment_Reviews_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Payment_Reviews_Max_Fields>
  min?: Maybe<Payment_Reviews_Min_Fields>
  stddev?: Maybe<Payment_Reviews_Stddev_Fields>
  stddev_pop?: Maybe<Payment_Reviews_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Payment_Reviews_Stddev_Samp_Fields>
  sum?: Maybe<Payment_Reviews_Sum_Fields>
  var_pop?: Maybe<Payment_Reviews_Var_Pop_Fields>
  var_samp?: Maybe<Payment_Reviews_Var_Samp_Fields>
  variance?: Maybe<Payment_Reviews_Variance_Fields>
}

/** aggregate fields of "payment_reviews" */
export type Payment_Reviews_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Reviews_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Payment_Reviews_Avg_Fields = {
  __typename?: "payment_reviews_avg_fields"
  config_ebss_value?: Maybe<Scalars["Float"]["output"]>
  config_overide_threshold_percentage?: Maybe<Scalars["Float"]["output"]>
  config_override_threshold_absolute?: Maybe<Scalars["Float"]["output"]>
  config_tariff_change_in_weeks_threshold?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "payment_reviews". All fields are combined with a logical 'AND'. */
export type Payment_Reviews_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Reviews_Bool_Exp>>
  _not?: InputMaybe<Payment_Reviews_Bool_Exp>
  _or?: InputMaybe<Array<Payment_Reviews_Bool_Exp>>
  config_account_for_ebss?: InputMaybe<Boolean_Comparison_Exp>
  config_calculation_type?: InputMaybe<Calculation_Type_Enum_Comparison_Exp>
  config_datasource?: InputMaybe<Payment_Review_Datasource_Comparison_Exp>
  config_ebbs_enabled?: InputMaybe<Boolean_Comparison_Exp>
  config_ebss_value?: InputMaybe<Numeric_Comparison_Exp>
  config_enabled?: InputMaybe<Boolean_Comparison_Exp>
  config_overide_threshold_percentage?: InputMaybe<Numeric_Comparison_Exp>
  config_override_threshold_absolute?: InputMaybe<Numeric_Comparison_Exp>
  config_tariff_change_in_weeks_threshold?: InputMaybe<Numeric_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  failure_reason?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  starts_at?: InputMaybe<Timestamptz_Comparison_Exp>
  type?: InputMaybe<Payment_Reviews_Type_Enum_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "payment_reviews" */
export enum Payment_Reviews_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkPaymentReviews = "pk_payment_reviews",
}

/** input type for incrementing numeric columns in table "payment_reviews" */
export type Payment_Reviews_Inc_Input = {
  config_ebss_value?: InputMaybe<Scalars["numeric"]["input"]>
  config_overide_threshold_percentage?: InputMaybe<Scalars["numeric"]["input"]>
  config_override_threshold_absolute?: InputMaybe<Scalars["numeric"]["input"]>
  config_tariff_change_in_weeks_threshold?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "payment_reviews" */
export type Payment_Reviews_Insert_Input = {
  config_account_for_ebss?: InputMaybe<Scalars["Boolean"]["input"]>
  config_calculation_type?: InputMaybe<
    Scalars["calculation_type_enum"]["input"]
  >
  config_datasource?: InputMaybe<Scalars["payment_review_datasource"]["input"]>
  config_ebbs_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  config_ebss_value?: InputMaybe<Scalars["numeric"]["input"]>
  config_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  config_overide_threshold_percentage?: InputMaybe<Scalars["numeric"]["input"]>
  config_override_threshold_absolute?: InputMaybe<Scalars["numeric"]["input"]>
  config_tariff_change_in_weeks_threshold?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  starts_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  type?: InputMaybe<Scalars["payment_reviews_type_enum"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamptz"]["input"]>
}

/** aggregate max on columns */
export type Payment_Reviews_Max_Fields = {
  __typename?: "payment_reviews_max_fields"
  config_calculation_type?: Maybe<Scalars["calculation_type_enum"]["output"]>
  config_datasource?: Maybe<Scalars["payment_review_datasource"]["output"]>
  config_ebss_value?: Maybe<Scalars["numeric"]["output"]>
  config_overide_threshold_percentage?: Maybe<Scalars["numeric"]["output"]>
  config_override_threshold_absolute?: Maybe<Scalars["numeric"]["output"]>
  config_tariff_change_in_weeks_threshold?: Maybe<Scalars["numeric"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  starts_at?: Maybe<Scalars["timestamptz"]["output"]>
  type?: Maybe<Scalars["payment_reviews_type_enum"]["output"]>
  updated_at?: Maybe<Scalars["timestamptz"]["output"]>
}

/** aggregate min on columns */
export type Payment_Reviews_Min_Fields = {
  __typename?: "payment_reviews_min_fields"
  config_calculation_type?: Maybe<Scalars["calculation_type_enum"]["output"]>
  config_datasource?: Maybe<Scalars["payment_review_datasource"]["output"]>
  config_ebss_value?: Maybe<Scalars["numeric"]["output"]>
  config_overide_threshold_percentage?: Maybe<Scalars["numeric"]["output"]>
  config_override_threshold_absolute?: Maybe<Scalars["numeric"]["output"]>
  config_tariff_change_in_weeks_threshold?: Maybe<Scalars["numeric"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  starts_at?: Maybe<Scalars["timestamptz"]["output"]>
  type?: Maybe<Scalars["payment_reviews_type_enum"]["output"]>
  updated_at?: Maybe<Scalars["timestamptz"]["output"]>
}

/** response of any mutation on the table "payment_reviews" */
export type Payment_Reviews_Mutation_Response = {
  __typename?: "payment_reviews_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Reviews>
}

/** on_conflict condition type for table "payment_reviews" */
export type Payment_Reviews_On_Conflict = {
  constraint: Payment_Reviews_Constraint
  update_columns?: Array<Payment_Reviews_Update_Column>
  where?: InputMaybe<Payment_Reviews_Bool_Exp>
}

/** Ordering options when selecting data from "payment_reviews". */
export type Payment_Reviews_Order_By = {
  config_account_for_ebss?: InputMaybe<Order_By>
  config_calculation_type?: InputMaybe<Order_By>
  config_datasource?: InputMaybe<Order_By>
  config_ebbs_enabled?: InputMaybe<Order_By>
  config_ebss_value?: InputMaybe<Order_By>
  config_enabled?: InputMaybe<Order_By>
  config_overide_threshold_percentage?: InputMaybe<Order_By>
  config_override_threshold_absolute?: InputMaybe<Order_By>
  config_tariff_change_in_weeks_threshold?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  failure_reason?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  starts_at?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: payment_reviews */
export type Payment_Reviews_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "payment_reviews" */
export enum Payment_Reviews_Select_Column {
  /** column name */
  ConfigAccountForEbss = "config_account_for_ebss",
  /** column name */
  ConfigCalculationType = "config_calculation_type",
  /** column name */
  ConfigDatasource = "config_datasource",
  /** column name */
  ConfigEbbsEnabled = "config_ebbs_enabled",
  /** column name */
  ConfigEbssValue = "config_ebss_value",
  /** column name */
  ConfigEnabled = "config_enabled",
  /** column name */
  ConfigOverideThresholdPercentage = "config_overide_threshold_percentage",
  /** column name */
  ConfigOverrideThresholdAbsolute = "config_override_threshold_absolute",
  /** column name */
  ConfigTariffChangeInWeeksThreshold = "config_tariff_change_in_weeks_threshold",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  StartsAt = "starts_at",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "payment_reviews" */
export type Payment_Reviews_Set_Input = {
  config_account_for_ebss?: InputMaybe<Scalars["Boolean"]["input"]>
  config_calculation_type?: InputMaybe<
    Scalars["calculation_type_enum"]["input"]
  >
  config_datasource?: InputMaybe<Scalars["payment_review_datasource"]["input"]>
  config_ebbs_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  config_ebss_value?: InputMaybe<Scalars["numeric"]["input"]>
  config_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  config_overide_threshold_percentage?: InputMaybe<Scalars["numeric"]["input"]>
  config_override_threshold_absolute?: InputMaybe<Scalars["numeric"]["input"]>
  config_tariff_change_in_weeks_threshold?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  starts_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  type?: InputMaybe<Scalars["payment_reviews_type_enum"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamptz"]["input"]>
}

/** aggregate stddev on columns */
export type Payment_Reviews_Stddev_Fields = {
  __typename?: "payment_reviews_stddev_fields"
  config_ebss_value?: Maybe<Scalars["Float"]["output"]>
  config_overide_threshold_percentage?: Maybe<Scalars["Float"]["output"]>
  config_override_threshold_absolute?: Maybe<Scalars["Float"]["output"]>
  config_tariff_change_in_weeks_threshold?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Payment_Reviews_Stddev_Pop_Fields = {
  __typename?: "payment_reviews_stddev_pop_fields"
  config_ebss_value?: Maybe<Scalars["Float"]["output"]>
  config_overide_threshold_percentage?: Maybe<Scalars["Float"]["output"]>
  config_override_threshold_absolute?: Maybe<Scalars["Float"]["output"]>
  config_tariff_change_in_weeks_threshold?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Payment_Reviews_Stddev_Samp_Fields = {
  __typename?: "payment_reviews_stddev_samp_fields"
  config_ebss_value?: Maybe<Scalars["Float"]["output"]>
  config_overide_threshold_percentage?: Maybe<Scalars["Float"]["output"]>
  config_override_threshold_absolute?: Maybe<Scalars["Float"]["output"]>
  config_tariff_change_in_weeks_threshold?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "payment_reviews" */
export type Payment_Reviews_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Reviews_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Payment_Reviews_Stream_Cursor_Value_Input = {
  config_account_for_ebss?: InputMaybe<Scalars["Boolean"]["input"]>
  config_calculation_type?: InputMaybe<
    Scalars["calculation_type_enum"]["input"]
  >
  config_datasource?: InputMaybe<Scalars["payment_review_datasource"]["input"]>
  config_ebbs_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  config_ebss_value?: InputMaybe<Scalars["numeric"]["input"]>
  config_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  config_overide_threshold_percentage?: InputMaybe<Scalars["numeric"]["input"]>
  config_override_threshold_absolute?: InputMaybe<Scalars["numeric"]["input"]>
  config_tariff_change_in_weeks_threshold?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  starts_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  type?: InputMaybe<Scalars["payment_reviews_type_enum"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamptz"]["input"]>
}

/** aggregate sum on columns */
export type Payment_Reviews_Sum_Fields = {
  __typename?: "payment_reviews_sum_fields"
  config_ebss_value?: Maybe<Scalars["numeric"]["output"]>
  config_overide_threshold_percentage?: Maybe<Scalars["numeric"]["output"]>
  config_override_threshold_absolute?: Maybe<Scalars["numeric"]["output"]>
  config_tariff_change_in_weeks_threshold?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** Boolean expression to compare columns of type "payment_reviews_type_enum". All fields are combined with logical 'AND'. */
export type Payment_Reviews_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["payment_reviews_type_enum"]["input"]>
  _gt?: InputMaybe<Scalars["payment_reviews_type_enum"]["input"]>
  _gte?: InputMaybe<Scalars["payment_reviews_type_enum"]["input"]>
  _in?: InputMaybe<Array<Scalars["payment_reviews_type_enum"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["payment_reviews_type_enum"]["input"]>
  _lte?: InputMaybe<Scalars["payment_reviews_type_enum"]["input"]>
  _neq?: InputMaybe<Scalars["payment_reviews_type_enum"]["input"]>
  _nin?: InputMaybe<Array<Scalars["payment_reviews_type_enum"]["input"]>>
}

/** update columns of table "payment_reviews" */
export enum Payment_Reviews_Update_Column {
  /** column name */
  ConfigAccountForEbss = "config_account_for_ebss",
  /** column name */
  ConfigCalculationType = "config_calculation_type",
  /** column name */
  ConfigDatasource = "config_datasource",
  /** column name */
  ConfigEbbsEnabled = "config_ebbs_enabled",
  /** column name */
  ConfigEbssValue = "config_ebss_value",
  /** column name */
  ConfigEnabled = "config_enabled",
  /** column name */
  ConfigOverideThresholdPercentage = "config_overide_threshold_percentage",
  /** column name */
  ConfigOverrideThresholdAbsolute = "config_override_threshold_absolute",
  /** column name */
  ConfigTariffChangeInWeeksThreshold = "config_tariff_change_in_weeks_threshold",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  StartsAt = "starts_at",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Payment_Reviews_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Reviews_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Reviews_Set_Input>
  /** filter the rows which have to be updated */
  where: Payment_Reviews_Bool_Exp
}

/** aggregate var_pop on columns */
export type Payment_Reviews_Var_Pop_Fields = {
  __typename?: "payment_reviews_var_pop_fields"
  config_ebss_value?: Maybe<Scalars["Float"]["output"]>
  config_overide_threshold_percentage?: Maybe<Scalars["Float"]["output"]>
  config_override_threshold_absolute?: Maybe<Scalars["Float"]["output"]>
  config_tariff_change_in_weeks_threshold?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Payment_Reviews_Var_Samp_Fields = {
  __typename?: "payment_reviews_var_samp_fields"
  config_ebss_value?: Maybe<Scalars["Float"]["output"]>
  config_overide_threshold_percentage?: Maybe<Scalars["Float"]["output"]>
  config_override_threshold_absolute?: Maybe<Scalars["Float"]["output"]>
  config_tariff_change_in_weeks_threshold?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Payment_Reviews_Variance_Fields = {
  __typename?: "payment_reviews_variance_fields"
  config_ebss_value?: Maybe<Scalars["Float"]["output"]>
  config_overide_threshold_percentage?: Maybe<Scalars["Float"]["output"]>
  config_override_threshold_absolute?: Maybe<Scalars["Float"]["output"]>
  config_tariff_change_in_weeks_threshold?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "payment_schedule" */
export type Payment_Schedule = {
  __typename?: "payment_schedule"
  amount: Scalars["numeric"]["output"]
  billing_account_id: Scalars["bigint"]["output"]
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  first_payment_dt?: Maybe<Scalars["date"]["output"]>
  frequency: Scalars["payment_schedule_frequency"]["output"]
  frequency_alignment_dt?: Maybe<Scalars["date"]["output"]>
  frequency_multiplier?: Maybe<Scalars["Int"]["output"]>
  from_dt?: Maybe<Scalars["timestamp"]["output"]>
  high_percentage?: Maybe<Scalars["Int"]["output"]>
  id: Scalars["bigint"]["output"]
  low_percentage?: Maybe<Scalars["Int"]["output"]>
  seasonal_adjustment_id?: Maybe<Scalars["bigint"]["output"]>
  seasonal_payment_fl?: Maybe<Scalars["Boolean"]["output"]>
  status: Scalars["payment_schedule_status"]["output"]
  stopped_at?: Maybe<Scalars["timestamp"]["output"]>
  to_dt?: Maybe<Scalars["timestamp"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "payment_schedule" */
export type Payment_Schedule_Aggregate = {
  __typename?: "payment_schedule_aggregate"
  aggregate?: Maybe<Payment_Schedule_Aggregate_Fields>
  nodes: Array<Payment_Schedule>
}

/** aggregate fields of "payment_schedule" */
export type Payment_Schedule_Aggregate_Fields = {
  __typename?: "payment_schedule_aggregate_fields"
  avg?: Maybe<Payment_Schedule_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Payment_Schedule_Max_Fields>
  min?: Maybe<Payment_Schedule_Min_Fields>
  stddev?: Maybe<Payment_Schedule_Stddev_Fields>
  stddev_pop?: Maybe<Payment_Schedule_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Payment_Schedule_Stddev_Samp_Fields>
  sum?: Maybe<Payment_Schedule_Sum_Fields>
  var_pop?: Maybe<Payment_Schedule_Var_Pop_Fields>
  var_samp?: Maybe<Payment_Schedule_Var_Samp_Fields>
  variance?: Maybe<Payment_Schedule_Variance_Fields>
}

/** aggregate fields of "payment_schedule" */
export type Payment_Schedule_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Schedule_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Payment_Schedule_Avg_Fields = {
  __typename?: "payment_schedule_avg_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  frequency_multiplier?: Maybe<Scalars["Float"]["output"]>
  high_percentage?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  low_percentage?: Maybe<Scalars["Float"]["output"]>
  seasonal_adjustment_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "payment_schedule". All fields are combined with a logical 'AND'. */
export type Payment_Schedule_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Schedule_Bool_Exp>>
  _not?: InputMaybe<Payment_Schedule_Bool_Exp>
  _or?: InputMaybe<Array<Payment_Schedule_Bool_Exp>>
  amount?: InputMaybe<Numeric_Comparison_Exp>
  billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  first_payment_dt?: InputMaybe<Date_Comparison_Exp>
  frequency?: InputMaybe<Payment_Schedule_Frequency_Comparison_Exp>
  frequency_alignment_dt?: InputMaybe<Date_Comparison_Exp>
  frequency_multiplier?: InputMaybe<Int_Comparison_Exp>
  from_dt?: InputMaybe<Timestamp_Comparison_Exp>
  high_percentage?: InputMaybe<Int_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  low_percentage?: InputMaybe<Int_Comparison_Exp>
  seasonal_adjustment_id?: InputMaybe<Bigint_Comparison_Exp>
  seasonal_payment_fl?: InputMaybe<Boolean_Comparison_Exp>
  status?: InputMaybe<Payment_Schedule_Status_Comparison_Exp>
  stopped_at?: InputMaybe<Timestamp_Comparison_Exp>
  to_dt?: InputMaybe<Timestamp_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "payment_schedule" */
export enum Payment_Schedule_Constraint {
  /** unique or primary key constraint on columns "id" */
  PaymentSchedulePkey = "payment_schedule_pkey",
}

/** Boolean expression to compare columns of type "payment_schedule_frequency". All fields are combined with logical 'AND'. */
export type Payment_Schedule_Frequency_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["payment_schedule_frequency"]["input"]>
  _gt?: InputMaybe<Scalars["payment_schedule_frequency"]["input"]>
  _gte?: InputMaybe<Scalars["payment_schedule_frequency"]["input"]>
  _in?: InputMaybe<Array<Scalars["payment_schedule_frequency"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["payment_schedule_frequency"]["input"]>
  _lte?: InputMaybe<Scalars["payment_schedule_frequency"]["input"]>
  _neq?: InputMaybe<Scalars["payment_schedule_frequency"]["input"]>
  _nin?: InputMaybe<Array<Scalars["payment_schedule_frequency"]["input"]>>
}

/** input type for incrementing numeric columns in table "payment_schedule" */
export type Payment_Schedule_Inc_Input = {
  amount?: InputMaybe<Scalars["numeric"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  frequency_multiplier?: InputMaybe<Scalars["Int"]["input"]>
  high_percentage?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  low_percentage?: InputMaybe<Scalars["Int"]["input"]>
  seasonal_adjustment_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "payment_schedule" */
export type Payment_Schedule_Insert_Input = {
  amount?: InputMaybe<Scalars["numeric"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  first_payment_dt?: InputMaybe<Scalars["date"]["input"]>
  frequency?: InputMaybe<Scalars["payment_schedule_frequency"]["input"]>
  frequency_alignment_dt?: InputMaybe<Scalars["date"]["input"]>
  frequency_multiplier?: InputMaybe<Scalars["Int"]["input"]>
  from_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  high_percentage?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  low_percentage?: InputMaybe<Scalars["Int"]["input"]>
  seasonal_adjustment_id?: InputMaybe<Scalars["bigint"]["input"]>
  seasonal_payment_fl?: InputMaybe<Scalars["Boolean"]["input"]>
  status?: InputMaybe<Scalars["payment_schedule_status"]["input"]>
  stopped_at?: InputMaybe<Scalars["timestamp"]["input"]>
  to_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Payment_Schedule_Max_Fields = {
  __typename?: "payment_schedule_max_fields"
  amount?: Maybe<Scalars["numeric"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  first_payment_dt?: Maybe<Scalars["date"]["output"]>
  frequency?: Maybe<Scalars["payment_schedule_frequency"]["output"]>
  frequency_alignment_dt?: Maybe<Scalars["date"]["output"]>
  frequency_multiplier?: Maybe<Scalars["Int"]["output"]>
  from_dt?: Maybe<Scalars["timestamp"]["output"]>
  high_percentage?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  low_percentage?: Maybe<Scalars["Int"]["output"]>
  seasonal_adjustment_id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["payment_schedule_status"]["output"]>
  stopped_at?: Maybe<Scalars["timestamp"]["output"]>
  to_dt?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Payment_Schedule_Min_Fields = {
  __typename?: "payment_schedule_min_fields"
  amount?: Maybe<Scalars["numeric"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  first_payment_dt?: Maybe<Scalars["date"]["output"]>
  frequency?: Maybe<Scalars["payment_schedule_frequency"]["output"]>
  frequency_alignment_dt?: Maybe<Scalars["date"]["output"]>
  frequency_multiplier?: Maybe<Scalars["Int"]["output"]>
  from_dt?: Maybe<Scalars["timestamp"]["output"]>
  high_percentage?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  low_percentage?: Maybe<Scalars["Int"]["output"]>
  seasonal_adjustment_id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["payment_schedule_status"]["output"]>
  stopped_at?: Maybe<Scalars["timestamp"]["output"]>
  to_dt?: Maybe<Scalars["timestamp"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "payment_schedule" */
export type Payment_Schedule_Mutation_Response = {
  __typename?: "payment_schedule_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Schedule>
}

/** on_conflict condition type for table "payment_schedule" */
export type Payment_Schedule_On_Conflict = {
  constraint: Payment_Schedule_Constraint
  update_columns?: Array<Payment_Schedule_Update_Column>
  where?: InputMaybe<Payment_Schedule_Bool_Exp>
}

/** Ordering options when selecting data from "payment_schedule". */
export type Payment_Schedule_Order_By = {
  amount?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  first_payment_dt?: InputMaybe<Order_By>
  frequency?: InputMaybe<Order_By>
  frequency_alignment_dt?: InputMaybe<Order_By>
  frequency_multiplier?: InputMaybe<Order_By>
  from_dt?: InputMaybe<Order_By>
  high_percentage?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  low_percentage?: InputMaybe<Order_By>
  seasonal_adjustment_id?: InputMaybe<Order_By>
  seasonal_payment_fl?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  stopped_at?: InputMaybe<Order_By>
  to_dt?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: payment_schedule */
export type Payment_Schedule_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "payment_schedule" */
export enum Payment_Schedule_Select_Column {
  /** column name */
  Amount = "amount",
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FirstPaymentDt = "first_payment_dt",
  /** column name */
  Frequency = "frequency",
  /** column name */
  FrequencyAlignmentDt = "frequency_alignment_dt",
  /** column name */
  FrequencyMultiplier = "frequency_multiplier",
  /** column name */
  FromDt = "from_dt",
  /** column name */
  HighPercentage = "high_percentage",
  /** column name */
  Id = "id",
  /** column name */
  LowPercentage = "low_percentage",
  /** column name */
  SeasonalAdjustmentId = "seasonal_adjustment_id",
  /** column name */
  SeasonalPaymentFl = "seasonal_payment_fl",
  /** column name */
  Status = "status",
  /** column name */
  StoppedAt = "stopped_at",
  /** column name */
  ToDt = "to_dt",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "payment_schedule" */
export type Payment_Schedule_Set_Input = {
  amount?: InputMaybe<Scalars["numeric"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  first_payment_dt?: InputMaybe<Scalars["date"]["input"]>
  frequency?: InputMaybe<Scalars["payment_schedule_frequency"]["input"]>
  frequency_alignment_dt?: InputMaybe<Scalars["date"]["input"]>
  frequency_multiplier?: InputMaybe<Scalars["Int"]["input"]>
  from_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  high_percentage?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  low_percentage?: InputMaybe<Scalars["Int"]["input"]>
  seasonal_adjustment_id?: InputMaybe<Scalars["bigint"]["input"]>
  seasonal_payment_fl?: InputMaybe<Scalars["Boolean"]["input"]>
  status?: InputMaybe<Scalars["payment_schedule_status"]["input"]>
  stopped_at?: InputMaybe<Scalars["timestamp"]["input"]>
  to_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** Boolean expression to compare columns of type "payment_schedule_status". All fields are combined with logical 'AND'. */
export type Payment_Schedule_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["payment_schedule_status"]["input"]>
  _gt?: InputMaybe<Scalars["payment_schedule_status"]["input"]>
  _gte?: InputMaybe<Scalars["payment_schedule_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["payment_schedule_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["payment_schedule_status"]["input"]>
  _lte?: InputMaybe<Scalars["payment_schedule_status"]["input"]>
  _neq?: InputMaybe<Scalars["payment_schedule_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["payment_schedule_status"]["input"]>>
}

/** aggregate stddev on columns */
export type Payment_Schedule_Stddev_Fields = {
  __typename?: "payment_schedule_stddev_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  frequency_multiplier?: Maybe<Scalars["Float"]["output"]>
  high_percentage?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  low_percentage?: Maybe<Scalars["Float"]["output"]>
  seasonal_adjustment_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Payment_Schedule_Stddev_Pop_Fields = {
  __typename?: "payment_schedule_stddev_pop_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  frequency_multiplier?: Maybe<Scalars["Float"]["output"]>
  high_percentage?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  low_percentage?: Maybe<Scalars["Float"]["output"]>
  seasonal_adjustment_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Payment_Schedule_Stddev_Samp_Fields = {
  __typename?: "payment_schedule_stddev_samp_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  frequency_multiplier?: Maybe<Scalars["Float"]["output"]>
  high_percentage?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  low_percentage?: Maybe<Scalars["Float"]["output"]>
  seasonal_adjustment_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "payment_schedule" */
export type Payment_Schedule_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Schedule_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Payment_Schedule_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars["numeric"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  first_payment_dt?: InputMaybe<Scalars["date"]["input"]>
  frequency?: InputMaybe<Scalars["payment_schedule_frequency"]["input"]>
  frequency_alignment_dt?: InputMaybe<Scalars["date"]["input"]>
  frequency_multiplier?: InputMaybe<Scalars["Int"]["input"]>
  from_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  high_percentage?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  low_percentage?: InputMaybe<Scalars["Int"]["input"]>
  seasonal_adjustment_id?: InputMaybe<Scalars["bigint"]["input"]>
  seasonal_payment_fl?: InputMaybe<Scalars["Boolean"]["input"]>
  status?: InputMaybe<Scalars["payment_schedule_status"]["input"]>
  stopped_at?: InputMaybe<Scalars["timestamp"]["input"]>
  to_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Payment_Schedule_Sum_Fields = {
  __typename?: "payment_schedule_sum_fields"
  amount?: Maybe<Scalars["numeric"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  frequency_multiplier?: Maybe<Scalars["Int"]["output"]>
  high_percentage?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  low_percentage?: Maybe<Scalars["Int"]["output"]>
  seasonal_adjustment_id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "payment_schedule" */
export enum Payment_Schedule_Update_Column {
  /** column name */
  Amount = "amount",
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  FirstPaymentDt = "first_payment_dt",
  /** column name */
  Frequency = "frequency",
  /** column name */
  FrequencyAlignmentDt = "frequency_alignment_dt",
  /** column name */
  FrequencyMultiplier = "frequency_multiplier",
  /** column name */
  FromDt = "from_dt",
  /** column name */
  HighPercentage = "high_percentage",
  /** column name */
  Id = "id",
  /** column name */
  LowPercentage = "low_percentage",
  /** column name */
  SeasonalAdjustmentId = "seasonal_adjustment_id",
  /** column name */
  SeasonalPaymentFl = "seasonal_payment_fl",
  /** column name */
  Status = "status",
  /** column name */
  StoppedAt = "stopped_at",
  /** column name */
  ToDt = "to_dt",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Payment_Schedule_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Schedule_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Schedule_Set_Input>
  /** filter the rows which have to be updated */
  where: Payment_Schedule_Bool_Exp
}

/** aggregate var_pop on columns */
export type Payment_Schedule_Var_Pop_Fields = {
  __typename?: "payment_schedule_var_pop_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  frequency_multiplier?: Maybe<Scalars["Float"]["output"]>
  high_percentage?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  low_percentage?: Maybe<Scalars["Float"]["output"]>
  seasonal_adjustment_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Payment_Schedule_Var_Samp_Fields = {
  __typename?: "payment_schedule_var_samp_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  frequency_multiplier?: Maybe<Scalars["Float"]["output"]>
  high_percentage?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  low_percentage?: Maybe<Scalars["Float"]["output"]>
  seasonal_adjustment_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Payment_Schedule_Variance_Fields = {
  __typename?: "payment_schedule_variance_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  frequency_multiplier?: Maybe<Scalars["Float"]["output"]>
  high_percentage?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  low_percentage?: Maybe<Scalars["Float"]["output"]>
  seasonal_adjustment_id?: Maybe<Scalars["Float"]["output"]>
}

/** select columns of table "payment" */
export enum Payment_Select_Column {
  /** column name */
  Amount = "amount",
  /** column name */
  CancelledAt = "cancelled_at",
  /** column name */
  CollectionDt = "collection_dt",
  /** column name */
  CollectionRequestDt = "collection_request_dt",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Currency = "currency",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  PaymentMethodId = "payment_method_id",
  /** column name */
  PostedDt = "posted_dt",
  /** column name */
  RequestType = "request_type",
  /** column name */
  Status = "status",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "payment" */
export type Payment_Set_Input = {
  amount?: InputMaybe<Scalars["numeric"]["input"]>
  cancelled_at?: InputMaybe<Scalars["timestamp"]["input"]>
  collection_dt?: InputMaybe<Scalars["date"]["input"]>
  collection_request_dt?: InputMaybe<Scalars["date"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  currency?: InputMaybe<Scalars["String"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_method_id?: InputMaybe<Scalars["bigint"]["input"]>
  posted_dt?: InputMaybe<Scalars["date"]["input"]>
  request_type?: InputMaybe<Scalars["payment_request_type"]["input"]>
  status?: InputMaybe<Scalars["payment_status"]["input"]>
  type?: InputMaybe<Scalars["payment_method_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** Boolean expression to compare columns of type "payment_status". All fields are combined with logical 'AND'. */
export type Payment_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["payment_status"]["input"]>
  _gt?: InputMaybe<Scalars["payment_status"]["input"]>
  _gte?: InputMaybe<Scalars["payment_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["payment_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["payment_status"]["input"]>
  _lte?: InputMaybe<Scalars["payment_status"]["input"]>
  _neq?: InputMaybe<Scalars["payment_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["payment_status"]["input"]>>
}

/** aggregate stddev on columns */
export type Payment_Stddev_Fields = {
  __typename?: "payment_stddev_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_method_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Payment_Stddev_Pop_Fields = {
  __typename?: "payment_stddev_pop_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_method_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Payment_Stddev_Samp_Fields = {
  __typename?: "payment_stddev_samp_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_method_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "payment" */
export type Payment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Payment_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars["numeric"]["input"]>
  cancelled_at?: InputMaybe<Scalars["timestamp"]["input"]>
  collection_dt?: InputMaybe<Scalars["date"]["input"]>
  collection_request_dt?: InputMaybe<Scalars["date"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  currency?: InputMaybe<Scalars["String"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_method_id?: InputMaybe<Scalars["bigint"]["input"]>
  posted_dt?: InputMaybe<Scalars["date"]["input"]>
  request_type?: InputMaybe<Scalars["payment_request_type"]["input"]>
  status?: InputMaybe<Scalars["payment_status"]["input"]>
  type?: InputMaybe<Scalars["payment_method_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Payment_Sum_Fields = {
  __typename?: "payment_sum_fields"
  amount?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  payment_method_id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "payment" */
export enum Payment_Update_Column {
  /** column name */
  Amount = "amount",
  /** column name */
  CancelledAt = "cancelled_at",
  /** column name */
  CollectionDt = "collection_dt",
  /** column name */
  CollectionRequestDt = "collection_request_dt",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Currency = "currency",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  PaymentMethodId = "payment_method_id",
  /** column name */
  PostedDt = "posted_dt",
  /** column name */
  RequestType = "request_type",
  /** column name */
  Status = "status",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Payment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Set_Input>
  /** filter the rows which have to be updated */
  where: Payment_Bool_Exp
}

/** aggregate var_pop on columns */
export type Payment_Var_Pop_Fields = {
  __typename?: "payment_var_pop_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_method_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Payment_Var_Samp_Fields = {
  __typename?: "payment_var_samp_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_method_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Payment_Variance_Fields = {
  __typename?: "payment_variance_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_method_id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "postcode_gsp_cache" */
export type Postcode_Gsp_Cache = {
  __typename?: "postcode_gsp_cache"
  created_at: Scalars["timestamp"]["output"]
  gsp_group_ids: Scalars["String"]["output"]
  id: Scalars["bigint"]["output"]
  postcode: Scalars["String"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "postcode_gsp_cache" */
export type Postcode_Gsp_Cache_Aggregate = {
  __typename?: "postcode_gsp_cache_aggregate"
  aggregate?: Maybe<Postcode_Gsp_Cache_Aggregate_Fields>
  nodes: Array<Postcode_Gsp_Cache>
}

/** aggregate fields of "postcode_gsp_cache" */
export type Postcode_Gsp_Cache_Aggregate_Fields = {
  __typename?: "postcode_gsp_cache_aggregate_fields"
  avg?: Maybe<Postcode_Gsp_Cache_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Postcode_Gsp_Cache_Max_Fields>
  min?: Maybe<Postcode_Gsp_Cache_Min_Fields>
  stddev?: Maybe<Postcode_Gsp_Cache_Stddev_Fields>
  stddev_pop?: Maybe<Postcode_Gsp_Cache_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Postcode_Gsp_Cache_Stddev_Samp_Fields>
  sum?: Maybe<Postcode_Gsp_Cache_Sum_Fields>
  var_pop?: Maybe<Postcode_Gsp_Cache_Var_Pop_Fields>
  var_samp?: Maybe<Postcode_Gsp_Cache_Var_Samp_Fields>
  variance?: Maybe<Postcode_Gsp_Cache_Variance_Fields>
}

/** aggregate fields of "postcode_gsp_cache" */
export type Postcode_Gsp_Cache_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Postcode_Gsp_Cache_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Postcode_Gsp_Cache_Avg_Fields = {
  __typename?: "postcode_gsp_cache_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "postcode_gsp_cache". All fields are combined with a logical 'AND'. */
export type Postcode_Gsp_Cache_Bool_Exp = {
  _and?: InputMaybe<Array<Postcode_Gsp_Cache_Bool_Exp>>
  _not?: InputMaybe<Postcode_Gsp_Cache_Bool_Exp>
  _or?: InputMaybe<Array<Postcode_Gsp_Cache_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  gsp_group_ids?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  postcode?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "postcode_gsp_cache" */
export enum Postcode_Gsp_Cache_Constraint {
  /** unique or primary key constraint on columns "postcode" */
  PkPostcodeGspCache = "pk_postcode_gsp_cache",
}

/** input type for incrementing numeric columns in table "postcode_gsp_cache" */
export type Postcode_Gsp_Cache_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "postcode_gsp_cache" */
export type Postcode_Gsp_Cache_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  gsp_group_ids?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Postcode_Gsp_Cache_Max_Fields = {
  __typename?: "postcode_gsp_cache_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  gsp_group_ids?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  postcode?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Postcode_Gsp_Cache_Min_Fields = {
  __typename?: "postcode_gsp_cache_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  gsp_group_ids?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  postcode?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "postcode_gsp_cache" */
export type Postcode_Gsp_Cache_Mutation_Response = {
  __typename?: "postcode_gsp_cache_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Postcode_Gsp_Cache>
}

/** on_conflict condition type for table "postcode_gsp_cache" */
export type Postcode_Gsp_Cache_On_Conflict = {
  constraint: Postcode_Gsp_Cache_Constraint
  update_columns?: Array<Postcode_Gsp_Cache_Update_Column>
  where?: InputMaybe<Postcode_Gsp_Cache_Bool_Exp>
}

/** Ordering options when selecting data from "postcode_gsp_cache". */
export type Postcode_Gsp_Cache_Order_By = {
  created_at?: InputMaybe<Order_By>
  gsp_group_ids?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  postcode?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: postcode_gsp_cache */
export type Postcode_Gsp_Cache_Pk_Columns_Input = {
  postcode: Scalars["String"]["input"]
}

/** select columns of table "postcode_gsp_cache" */
export enum Postcode_Gsp_Cache_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  GspGroupIds = "gsp_group_ids",
  /** column name */
  Id = "id",
  /** column name */
  Postcode = "postcode",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "postcode_gsp_cache" */
export type Postcode_Gsp_Cache_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  gsp_group_ids?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Postcode_Gsp_Cache_Stddev_Fields = {
  __typename?: "postcode_gsp_cache_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Postcode_Gsp_Cache_Stddev_Pop_Fields = {
  __typename?: "postcode_gsp_cache_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Postcode_Gsp_Cache_Stddev_Samp_Fields = {
  __typename?: "postcode_gsp_cache_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "postcode_gsp_cache" */
export type Postcode_Gsp_Cache_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Postcode_Gsp_Cache_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Postcode_Gsp_Cache_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  gsp_group_ids?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Postcode_Gsp_Cache_Sum_Fields = {
  __typename?: "postcode_gsp_cache_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "postcode_gsp_cache" */
export enum Postcode_Gsp_Cache_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  GspGroupIds = "gsp_group_ids",
  /** column name */
  Id = "id",
  /** column name */
  Postcode = "postcode",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Postcode_Gsp_Cache_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Postcode_Gsp_Cache_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Postcode_Gsp_Cache_Set_Input>
  /** filter the rows which have to be updated */
  where: Postcode_Gsp_Cache_Bool_Exp
}

/** aggregate var_pop on columns */
export type Postcode_Gsp_Cache_Var_Pop_Fields = {
  __typename?: "postcode_gsp_cache_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Postcode_Gsp_Cache_Var_Samp_Fields = {
  __typename?: "postcode_gsp_cache_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Postcode_Gsp_Cache_Variance_Fields = {
  __typename?: "postcode_gsp_cache_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "price_unit". All fields are combined with logical 'AND'. */
export type Price_Unit_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["price_unit"]["input"]>
  _gt?: InputMaybe<Scalars["price_unit"]["input"]>
  _gte?: InputMaybe<Scalars["price_unit"]["input"]>
  _in?: InputMaybe<Array<Scalars["price_unit"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["price_unit"]["input"]>
  _lte?: InputMaybe<Scalars["price_unit"]["input"]>
  _neq?: InputMaybe<Scalars["price_unit"]["input"]>
  _nin?: InputMaybe<Array<Scalars["price_unit"]["input"]>>
}

/** columns and relationships of "product" */
export type Product = {
  __typename?: "product"
  code: Scalars["String"]["output"]
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  display_name: Scalars["String"]["output"]
  id: Scalars["bigint"]["output"]
  name: Scalars["String"]["output"]
  /** An object relationship */
  product_elec?: Maybe<Product_Elec>
  /** An object relationship */
  product_ga?: Maybe<Product_Gas>
  /** An array relationship */
  product_variants: Array<Product_Variant>
  /** An aggregate relationship */
  product_variants_aggregate: Product_Variant_Aggregate
  type: Scalars["product_type"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "product" */
export type ProductProduct_VariantsArgs = {
  distinct_on?: InputMaybe<Array<Product_Variant_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Variant_Order_By>>
  where?: InputMaybe<Product_Variant_Bool_Exp>
}

/** columns and relationships of "product" */
export type ProductProduct_Variants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variant_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Variant_Order_By>>
  where?: InputMaybe<Product_Variant_Bool_Exp>
}

/** columns and relationships of "product_account" */
export type Product_Account = {
  __typename?: "product_account"
  /** An array relationship */
  agreement_rels: Array<Product_Account_Agreement_Rel>
  /** An aggregate relationship */
  agreement_rels_aggregate: Product_Account_Agreement_Rel_Aggregate
  /** An object relationship */
  billing_account: Billing_Account
  billing_account_id: Scalars["bigint"]["output"]
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  type: Scalars["product_account_type"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "product_account" */
export type Product_AccountAgreement_RelsArgs = {
  distinct_on?: InputMaybe<Array<Product_Account_Agreement_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Account_Agreement_Rel_Order_By>>
  where?: InputMaybe<Product_Account_Agreement_Rel_Bool_Exp>
}

/** columns and relationships of "product_account" */
export type Product_AccountAgreement_Rels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Account_Agreement_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Account_Agreement_Rel_Order_By>>
  where?: InputMaybe<Product_Account_Agreement_Rel_Bool_Exp>
}

/** aggregated selection of "product_account" */
export type Product_Account_Aggregate = {
  __typename?: "product_account_aggregate"
  aggregate?: Maybe<Product_Account_Aggregate_Fields>
  nodes: Array<Product_Account>
}

export type Product_Account_Aggregate_Bool_Exp = {
  count?: InputMaybe<Product_Account_Aggregate_Bool_Exp_Count>
}

export type Product_Account_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Product_Account_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Product_Account_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "product_account" */
export type Product_Account_Aggregate_Fields = {
  __typename?: "product_account_aggregate_fields"
  avg?: Maybe<Product_Account_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Product_Account_Max_Fields>
  min?: Maybe<Product_Account_Min_Fields>
  stddev?: Maybe<Product_Account_Stddev_Fields>
  stddev_pop?: Maybe<Product_Account_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Product_Account_Stddev_Samp_Fields>
  sum?: Maybe<Product_Account_Sum_Fields>
  var_pop?: Maybe<Product_Account_Var_Pop_Fields>
  var_samp?: Maybe<Product_Account_Var_Samp_Fields>
  variance?: Maybe<Product_Account_Variance_Fields>
}

/** aggregate fields of "product_account" */
export type Product_Account_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Account_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "product_account" */
export type Product_Account_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Account_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Product_Account_Max_Order_By>
  min?: InputMaybe<Product_Account_Min_Order_By>
  stddev?: InputMaybe<Product_Account_Stddev_Order_By>
  stddev_pop?: InputMaybe<Product_Account_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Product_Account_Stddev_Samp_Order_By>
  sum?: InputMaybe<Product_Account_Sum_Order_By>
  var_pop?: InputMaybe<Product_Account_Var_Pop_Order_By>
  var_samp?: InputMaybe<Product_Account_Var_Samp_Order_By>
  variance?: InputMaybe<Product_Account_Variance_Order_By>
}

/** columns and relationships of "product_account_agreement_rel" */
export type Product_Account_Agreement_Rel = {
  __typename?: "product_account_agreement_rel"
  /** An object relationship */
  agreement: Agreement
  agreement_id: Scalars["bigint"]["output"]
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  /** An object relationship */
  product_account: Product_Account
  product_account_id: Scalars["bigint"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "product_account_agreement_rel" */
export type Product_Account_Agreement_Rel_Aggregate = {
  __typename?: "product_account_agreement_rel_aggregate"
  aggregate?: Maybe<Product_Account_Agreement_Rel_Aggregate_Fields>
  nodes: Array<Product_Account_Agreement_Rel>
}

export type Product_Account_Agreement_Rel_Aggregate_Bool_Exp = {
  count?: InputMaybe<Product_Account_Agreement_Rel_Aggregate_Bool_Exp_Count>
}

export type Product_Account_Agreement_Rel_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Product_Account_Agreement_Rel_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Product_Account_Agreement_Rel_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "product_account_agreement_rel" */
export type Product_Account_Agreement_Rel_Aggregate_Fields = {
  __typename?: "product_account_agreement_rel_aggregate_fields"
  avg?: Maybe<Product_Account_Agreement_Rel_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Product_Account_Agreement_Rel_Max_Fields>
  min?: Maybe<Product_Account_Agreement_Rel_Min_Fields>
  stddev?: Maybe<Product_Account_Agreement_Rel_Stddev_Fields>
  stddev_pop?: Maybe<Product_Account_Agreement_Rel_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Product_Account_Agreement_Rel_Stddev_Samp_Fields>
  sum?: Maybe<Product_Account_Agreement_Rel_Sum_Fields>
  var_pop?: Maybe<Product_Account_Agreement_Rel_Var_Pop_Fields>
  var_samp?: Maybe<Product_Account_Agreement_Rel_Var_Samp_Fields>
  variance?: Maybe<Product_Account_Agreement_Rel_Variance_Fields>
}

/** aggregate fields of "product_account_agreement_rel" */
export type Product_Account_Agreement_Rel_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Account_Agreement_Rel_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "product_account_agreement_rel" */
export type Product_Account_Agreement_Rel_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Account_Agreement_Rel_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Product_Account_Agreement_Rel_Max_Order_By>
  min?: InputMaybe<Product_Account_Agreement_Rel_Min_Order_By>
  stddev?: InputMaybe<Product_Account_Agreement_Rel_Stddev_Order_By>
  stddev_pop?: InputMaybe<Product_Account_Agreement_Rel_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Product_Account_Agreement_Rel_Stddev_Samp_Order_By>
  sum?: InputMaybe<Product_Account_Agreement_Rel_Sum_Order_By>
  var_pop?: InputMaybe<Product_Account_Agreement_Rel_Var_Pop_Order_By>
  var_samp?: InputMaybe<Product_Account_Agreement_Rel_Var_Samp_Order_By>
  variance?: InputMaybe<Product_Account_Agreement_Rel_Variance_Order_By>
}

/** input type for inserting array relation for remote table "product_account_agreement_rel" */
export type Product_Account_Agreement_Rel_Arr_Rel_Insert_Input = {
  data: Array<Product_Account_Agreement_Rel_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Account_Agreement_Rel_On_Conflict>
}

/** aggregate avg on columns */
export type Product_Account_Agreement_Rel_Avg_Fields = {
  __typename?: "product_account_agreement_rel_avg_fields"
  agreement_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  product_account_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "product_account_agreement_rel" */
export type Product_Account_Agreement_Rel_Avg_Order_By = {
  agreement_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  product_account_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "product_account_agreement_rel". All fields are combined with a logical 'AND'. */
export type Product_Account_Agreement_Rel_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Account_Agreement_Rel_Bool_Exp>>
  _not?: InputMaybe<Product_Account_Agreement_Rel_Bool_Exp>
  _or?: InputMaybe<Array<Product_Account_Agreement_Rel_Bool_Exp>>
  agreement?: InputMaybe<Agreement_Bool_Exp>
  agreement_id?: InputMaybe<Bigint_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  product_account?: InputMaybe<Product_Account_Bool_Exp>
  product_account_id?: InputMaybe<Bigint_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "product_account_agreement_rel" */
export enum Product_Account_Agreement_Rel_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductAccountAgreementRelPkey = "product_account_agreement_rel_pkey",
}

/** input type for incrementing numeric columns in table "product_account_agreement_rel" */
export type Product_Account_Agreement_Rel_Inc_Input = {
  agreement_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  product_account_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "product_account_agreement_rel" */
export type Product_Account_Agreement_Rel_Insert_Input = {
  agreement?: InputMaybe<Agreement_Obj_Rel_Insert_Input>
  agreement_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  product_account?: InputMaybe<Product_Account_Obj_Rel_Insert_Input>
  product_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Product_Account_Agreement_Rel_Max_Fields = {
  __typename?: "product_account_agreement_rel_max_fields"
  agreement_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  product_account_id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "product_account_agreement_rel" */
export type Product_Account_Agreement_Rel_Max_Order_By = {
  agreement_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  product_account_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Product_Account_Agreement_Rel_Min_Fields = {
  __typename?: "product_account_agreement_rel_min_fields"
  agreement_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  product_account_id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "product_account_agreement_rel" */
export type Product_Account_Agreement_Rel_Min_Order_By = {
  agreement_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  product_account_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "product_account_agreement_rel" */
export type Product_Account_Agreement_Rel_Mutation_Response = {
  __typename?: "product_account_agreement_rel_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Product_Account_Agreement_Rel>
}

/** on_conflict condition type for table "product_account_agreement_rel" */
export type Product_Account_Agreement_Rel_On_Conflict = {
  constraint: Product_Account_Agreement_Rel_Constraint
  update_columns?: Array<Product_Account_Agreement_Rel_Update_Column>
  where?: InputMaybe<Product_Account_Agreement_Rel_Bool_Exp>
}

/** Ordering options when selecting data from "product_account_agreement_rel". */
export type Product_Account_Agreement_Rel_Order_By = {
  agreement?: InputMaybe<Agreement_Order_By>
  agreement_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  product_account?: InputMaybe<Product_Account_Order_By>
  product_account_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: product_account_agreement_rel */
export type Product_Account_Agreement_Rel_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "product_account_agreement_rel" */
export enum Product_Account_Agreement_Rel_Select_Column {
  /** column name */
  AgreementId = "agreement_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  ProductAccountId = "product_account_id",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "product_account_agreement_rel" */
export type Product_Account_Agreement_Rel_Set_Input = {
  agreement_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  product_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Product_Account_Agreement_Rel_Stddev_Fields = {
  __typename?: "product_account_agreement_rel_stddev_fields"
  agreement_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  product_account_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "product_account_agreement_rel" */
export type Product_Account_Agreement_Rel_Stddev_Order_By = {
  agreement_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  product_account_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Product_Account_Agreement_Rel_Stddev_Pop_Fields = {
  __typename?: "product_account_agreement_rel_stddev_pop_fields"
  agreement_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  product_account_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "product_account_agreement_rel" */
export type Product_Account_Agreement_Rel_Stddev_Pop_Order_By = {
  agreement_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  product_account_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Product_Account_Agreement_Rel_Stddev_Samp_Fields = {
  __typename?: "product_account_agreement_rel_stddev_samp_fields"
  agreement_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  product_account_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "product_account_agreement_rel" */
export type Product_Account_Agreement_Rel_Stddev_Samp_Order_By = {
  agreement_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  product_account_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "product_account_agreement_rel" */
export type Product_Account_Agreement_Rel_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Account_Agreement_Rel_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Product_Account_Agreement_Rel_Stream_Cursor_Value_Input = {
  agreement_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  product_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Product_Account_Agreement_Rel_Sum_Fields = {
  __typename?: "product_account_agreement_rel_sum_fields"
  agreement_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  product_account_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "product_account_agreement_rel" */
export type Product_Account_Agreement_Rel_Sum_Order_By = {
  agreement_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  product_account_id?: InputMaybe<Order_By>
}

/** update columns of table "product_account_agreement_rel" */
export enum Product_Account_Agreement_Rel_Update_Column {
  /** column name */
  AgreementId = "agreement_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  ProductAccountId = "product_account_id",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Product_Account_Agreement_Rel_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Account_Agreement_Rel_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Account_Agreement_Rel_Set_Input>
  /** filter the rows which have to be updated */
  where: Product_Account_Agreement_Rel_Bool_Exp
}

/** aggregate var_pop on columns */
export type Product_Account_Agreement_Rel_Var_Pop_Fields = {
  __typename?: "product_account_agreement_rel_var_pop_fields"
  agreement_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  product_account_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "product_account_agreement_rel" */
export type Product_Account_Agreement_Rel_Var_Pop_Order_By = {
  agreement_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  product_account_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Product_Account_Agreement_Rel_Var_Samp_Fields = {
  __typename?: "product_account_agreement_rel_var_samp_fields"
  agreement_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  product_account_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "product_account_agreement_rel" */
export type Product_Account_Agreement_Rel_Var_Samp_Order_By = {
  agreement_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  product_account_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Product_Account_Agreement_Rel_Variance_Fields = {
  __typename?: "product_account_agreement_rel_variance_fields"
  agreement_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  product_account_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "product_account_agreement_rel" */
export type Product_Account_Agreement_Rel_Variance_Order_By = {
  agreement_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  product_account_id?: InputMaybe<Order_By>
}

/** input type for inserting array relation for remote table "product_account" */
export type Product_Account_Arr_Rel_Insert_Input = {
  data: Array<Product_Account_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Account_On_Conflict>
}

/** aggregate avg on columns */
export type Product_Account_Avg_Fields = {
  __typename?: "product_account_avg_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "product_account" */
export type Product_Account_Avg_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "product_account". All fields are combined with a logical 'AND'. */
export type Product_Account_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Account_Bool_Exp>>
  _not?: InputMaybe<Product_Account_Bool_Exp>
  _or?: InputMaybe<Array<Product_Account_Bool_Exp>>
  agreement_rels?: InputMaybe<Product_Account_Agreement_Rel_Bool_Exp>
  agreement_rels_aggregate?: InputMaybe<Product_Account_Agreement_Rel_Aggregate_Bool_Exp>
  billing_account?: InputMaybe<Billing_Account_Bool_Exp>
  billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  type?: InputMaybe<Product_Account_Type_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "product_account" */
export enum Product_Account_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductAccountPkey = "product_account_pkey",
  /** unique or primary key constraint on columns "type", "billing_account_id" */
  UqTypeBillingaccountid = "uq_type_billingaccountid",
}

/** input type for incrementing numeric columns in table "product_account" */
export type Product_Account_Inc_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "product_account" */
export type Product_Account_Insert_Input = {
  agreement_rels?: InputMaybe<Product_Account_Agreement_Rel_Arr_Rel_Insert_Input>
  billing_account?: InputMaybe<Billing_Account_Obj_Rel_Insert_Input>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  type?: InputMaybe<Scalars["product_account_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Product_Account_Max_Fields = {
  __typename?: "product_account_max_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  type?: Maybe<Scalars["product_account_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "product_account" */
export type Product_Account_Max_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Product_Account_Min_Fields = {
  __typename?: "product_account_min_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  type?: Maybe<Scalars["product_account_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "product_account" */
export type Product_Account_Min_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "product_account" */
export type Product_Account_Mutation_Response = {
  __typename?: "product_account_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Product_Account>
}

/** input type for inserting object relation for remote table "product_account" */
export type Product_Account_Obj_Rel_Insert_Input = {
  data: Product_Account_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Account_On_Conflict>
}

/** on_conflict condition type for table "product_account" */
export type Product_Account_On_Conflict = {
  constraint: Product_Account_Constraint
  update_columns?: Array<Product_Account_Update_Column>
  where?: InputMaybe<Product_Account_Bool_Exp>
}

/** Ordering options when selecting data from "product_account". */
export type Product_Account_Order_By = {
  agreement_rels_aggregate?: InputMaybe<Product_Account_Agreement_Rel_Aggregate_Order_By>
  billing_account?: InputMaybe<Billing_Account_Order_By>
  billing_account_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: product_account */
export type Product_Account_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "product_account" */
export enum Product_Account_Select_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "product_account" */
export type Product_Account_Set_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  type?: InputMaybe<Scalars["product_account_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Product_Account_Stddev_Fields = {
  __typename?: "product_account_stddev_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "product_account" */
export type Product_Account_Stddev_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Product_Account_Stddev_Pop_Fields = {
  __typename?: "product_account_stddev_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "product_account" */
export type Product_Account_Stddev_Pop_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Product_Account_Stddev_Samp_Fields = {
  __typename?: "product_account_stddev_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "product_account" */
export type Product_Account_Stddev_Samp_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "product_account" */
export type Product_Account_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Account_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Product_Account_Stream_Cursor_Value_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  type?: InputMaybe<Scalars["product_account_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Product_Account_Sum_Fields = {
  __typename?: "product_account_sum_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "product_account" */
export type Product_Account_Sum_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "product_account_type". All fields are combined with logical 'AND'. */
export type Product_Account_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["product_account_type"]["input"]>
  _gt?: InputMaybe<Scalars["product_account_type"]["input"]>
  _gte?: InputMaybe<Scalars["product_account_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["product_account_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["product_account_type"]["input"]>
  _lte?: InputMaybe<Scalars["product_account_type"]["input"]>
  _neq?: InputMaybe<Scalars["product_account_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["product_account_type"]["input"]>>
}

/** update columns of table "product_account" */
export enum Product_Account_Update_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Product_Account_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Account_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Account_Set_Input>
  /** filter the rows which have to be updated */
  where: Product_Account_Bool_Exp
}

/** aggregate var_pop on columns */
export type Product_Account_Var_Pop_Fields = {
  __typename?: "product_account_var_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "product_account" */
export type Product_Account_Var_Pop_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Product_Account_Var_Samp_Fields = {
  __typename?: "product_account_var_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "product_account" */
export type Product_Account_Var_Samp_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Product_Account_Variance_Fields = {
  __typename?: "product_account_variance_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "product_account" */
export type Product_Account_Variance_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregated selection of "product" */
export type Product_Aggregate = {
  __typename?: "product_aggregate"
  aggregate?: Maybe<Product_Aggregate_Fields>
  nodes: Array<Product>
}

/** aggregate fields of "product" */
export type Product_Aggregate_Fields = {
  __typename?: "product_aggregate_fields"
  avg?: Maybe<Product_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Product_Max_Fields>
  min?: Maybe<Product_Min_Fields>
  stddev?: Maybe<Product_Stddev_Fields>
  stddev_pop?: Maybe<Product_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Product_Stddev_Samp_Fields>
  sum?: Maybe<Product_Sum_Fields>
  var_pop?: Maybe<Product_Var_Pop_Fields>
  var_samp?: Maybe<Product_Var_Samp_Fields>
  variance?: Maybe<Product_Variance_Fields>
}

/** aggregate fields of "product" */
export type Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Product_Avg_Fields = {
  __typename?: "product_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "product". All fields are combined with a logical 'AND'. */
export type Product_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Bool_Exp>>
  _not?: InputMaybe<Product_Bool_Exp>
  _or?: InputMaybe<Array<Product_Bool_Exp>>
  code?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  display_name?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  product_elec?: InputMaybe<Product_Elec_Bool_Exp>
  product_ga?: InputMaybe<Product_Gas_Bool_Exp>
  product_variants?: InputMaybe<Product_Variant_Bool_Exp>
  product_variants_aggregate?: InputMaybe<Product_Variant_Aggregate_Bool_Exp>
  type?: InputMaybe<Product_Type_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "product" */
export enum Product_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkProduct = "pk_product",
}

/** columns and relationships of "product_elec" */
export type Product_Elec = {
  __typename?: "product_elec"
  available_in_the_past: Scalars["Boolean"]["output"]
  available_to_public: Scalars["Boolean"]["output"]
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  duration_frequency?: Maybe<Scalars["frequency"]["output"]>
  duration_value?: Maybe<Scalars["Int"]["output"]>
  end_dt?: Maybe<Scalars["date"]["output"]>
  export: Scalars["Boolean"]["output"]
  from_dt: Scalars["date"]["output"]
  id: Scalars["bigint"]["output"]
  /** An object relationship */
  product: Product
  requires_smart_charging: Scalars["Boolean"]["output"]
  short_code: Scalars["String"]["output"]
  smart_payg: Scalars["Boolean"]["output"]
  status?: Maybe<Scalars["String"]["output"]>
  to_dt?: Maybe<Scalars["date"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
  variable: Scalars["Boolean"]["output"]
}

/** aggregated selection of "product_elec" */
export type Product_Elec_Aggregate = {
  __typename?: "product_elec_aggregate"
  aggregate?: Maybe<Product_Elec_Aggregate_Fields>
  nodes: Array<Product_Elec>
}

/** aggregate fields of "product_elec" */
export type Product_Elec_Aggregate_Fields = {
  __typename?: "product_elec_aggregate_fields"
  avg?: Maybe<Product_Elec_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Product_Elec_Max_Fields>
  min?: Maybe<Product_Elec_Min_Fields>
  stddev?: Maybe<Product_Elec_Stddev_Fields>
  stddev_pop?: Maybe<Product_Elec_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Product_Elec_Stddev_Samp_Fields>
  sum?: Maybe<Product_Elec_Sum_Fields>
  var_pop?: Maybe<Product_Elec_Var_Pop_Fields>
  var_samp?: Maybe<Product_Elec_Var_Samp_Fields>
  variance?: Maybe<Product_Elec_Variance_Fields>
}

/** aggregate fields of "product_elec" */
export type Product_Elec_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Elec_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Product_Elec_Avg_Fields = {
  __typename?: "product_elec_avg_fields"
  duration_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "product_elec". All fields are combined with a logical 'AND'. */
export type Product_Elec_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Elec_Bool_Exp>>
  _not?: InputMaybe<Product_Elec_Bool_Exp>
  _or?: InputMaybe<Array<Product_Elec_Bool_Exp>>
  available_in_the_past?: InputMaybe<Boolean_Comparison_Exp>
  available_to_public?: InputMaybe<Boolean_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  duration_frequency?: InputMaybe<Frequency_Comparison_Exp>
  duration_value?: InputMaybe<Int_Comparison_Exp>
  end_dt?: InputMaybe<Date_Comparison_Exp>
  export?: InputMaybe<Boolean_Comparison_Exp>
  from_dt?: InputMaybe<Date_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  product?: InputMaybe<Product_Bool_Exp>
  requires_smart_charging?: InputMaybe<Boolean_Comparison_Exp>
  short_code?: InputMaybe<String_Comparison_Exp>
  smart_payg?: InputMaybe<Boolean_Comparison_Exp>
  status?: InputMaybe<String_Comparison_Exp>
  to_dt?: InputMaybe<Date_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  variable?: InputMaybe<Boolean_Comparison_Exp>
}

/** unique or primary key constraints on table "product_elec" */
export enum Product_Elec_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkProductElec = "pk_product_elec",
}

/** input type for incrementing numeric columns in table "product_elec" */
export type Product_Elec_Inc_Input = {
  duration_value?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "product_elec" */
export type Product_Elec_Insert_Input = {
  available_in_the_past?: InputMaybe<Scalars["Boolean"]["input"]>
  available_to_public?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  duration_frequency?: InputMaybe<Scalars["frequency"]["input"]>
  duration_value?: InputMaybe<Scalars["Int"]["input"]>
  end_dt?: InputMaybe<Scalars["date"]["input"]>
  export?: InputMaybe<Scalars["Boolean"]["input"]>
  from_dt?: InputMaybe<Scalars["date"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>
  requires_smart_charging?: InputMaybe<Scalars["Boolean"]["input"]>
  short_code?: InputMaybe<Scalars["String"]["input"]>
  smart_payg?: InputMaybe<Scalars["Boolean"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  to_dt?: InputMaybe<Scalars["date"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  variable?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate max on columns */
export type Product_Elec_Max_Fields = {
  __typename?: "product_elec_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  duration_frequency?: Maybe<Scalars["frequency"]["output"]>
  duration_value?: Maybe<Scalars["Int"]["output"]>
  end_dt?: Maybe<Scalars["date"]["output"]>
  from_dt?: Maybe<Scalars["date"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  short_code?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  to_dt?: Maybe<Scalars["date"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Product_Elec_Min_Fields = {
  __typename?: "product_elec_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  duration_frequency?: Maybe<Scalars["frequency"]["output"]>
  duration_value?: Maybe<Scalars["Int"]["output"]>
  end_dt?: Maybe<Scalars["date"]["output"]>
  from_dt?: Maybe<Scalars["date"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  short_code?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  to_dt?: Maybe<Scalars["date"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "product_elec" */
export type Product_Elec_Mutation_Response = {
  __typename?: "product_elec_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Product_Elec>
}

/** input type for inserting object relation for remote table "product_elec" */
export type Product_Elec_Obj_Rel_Insert_Input = {
  data: Product_Elec_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Elec_On_Conflict>
}

/** on_conflict condition type for table "product_elec" */
export type Product_Elec_On_Conflict = {
  constraint: Product_Elec_Constraint
  update_columns?: Array<Product_Elec_Update_Column>
  where?: InputMaybe<Product_Elec_Bool_Exp>
}

/** Ordering options when selecting data from "product_elec". */
export type Product_Elec_Order_By = {
  available_in_the_past?: InputMaybe<Order_By>
  available_to_public?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  duration_frequency?: InputMaybe<Order_By>
  duration_value?: InputMaybe<Order_By>
  end_dt?: InputMaybe<Order_By>
  export?: InputMaybe<Order_By>
  from_dt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  product?: InputMaybe<Product_Order_By>
  requires_smart_charging?: InputMaybe<Order_By>
  short_code?: InputMaybe<Order_By>
  smart_payg?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  to_dt?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  variable?: InputMaybe<Order_By>
}

/** primary key columns input for table: product_elec */
export type Product_Elec_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "product_elec" */
export enum Product_Elec_Select_Column {
  /** column name */
  AvailableInThePast = "available_in_the_past",
  /** column name */
  AvailableToPublic = "available_to_public",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  DurationFrequency = "duration_frequency",
  /** column name */
  DurationValue = "duration_value",
  /** column name */
  EndDt = "end_dt",
  /** column name */
  Export = "export",
  /** column name */
  FromDt = "from_dt",
  /** column name */
  Id = "id",
  /** column name */
  RequiresSmartCharging = "requires_smart_charging",
  /** column name */
  ShortCode = "short_code",
  /** column name */
  SmartPayg = "smart_payg",
  /** column name */
  Status = "status",
  /** column name */
  ToDt = "to_dt",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  Variable = "variable",
}

/** input type for updating data in table "product_elec" */
export type Product_Elec_Set_Input = {
  available_in_the_past?: InputMaybe<Scalars["Boolean"]["input"]>
  available_to_public?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  duration_frequency?: InputMaybe<Scalars["frequency"]["input"]>
  duration_value?: InputMaybe<Scalars["Int"]["input"]>
  end_dt?: InputMaybe<Scalars["date"]["input"]>
  export?: InputMaybe<Scalars["Boolean"]["input"]>
  from_dt?: InputMaybe<Scalars["date"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  requires_smart_charging?: InputMaybe<Scalars["Boolean"]["input"]>
  short_code?: InputMaybe<Scalars["String"]["input"]>
  smart_payg?: InputMaybe<Scalars["Boolean"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  to_dt?: InputMaybe<Scalars["date"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  variable?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate stddev on columns */
export type Product_Elec_Stddev_Fields = {
  __typename?: "product_elec_stddev_fields"
  duration_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Product_Elec_Stddev_Pop_Fields = {
  __typename?: "product_elec_stddev_pop_fields"
  duration_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Product_Elec_Stddev_Samp_Fields = {
  __typename?: "product_elec_stddev_samp_fields"
  duration_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "product_elec" */
export type Product_Elec_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Elec_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Product_Elec_Stream_Cursor_Value_Input = {
  available_in_the_past?: InputMaybe<Scalars["Boolean"]["input"]>
  available_to_public?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  duration_frequency?: InputMaybe<Scalars["frequency"]["input"]>
  duration_value?: InputMaybe<Scalars["Int"]["input"]>
  end_dt?: InputMaybe<Scalars["date"]["input"]>
  export?: InputMaybe<Scalars["Boolean"]["input"]>
  from_dt?: InputMaybe<Scalars["date"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  requires_smart_charging?: InputMaybe<Scalars["Boolean"]["input"]>
  short_code?: InputMaybe<Scalars["String"]["input"]>
  smart_payg?: InputMaybe<Scalars["Boolean"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  to_dt?: InputMaybe<Scalars["date"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  variable?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate sum on columns */
export type Product_Elec_Sum_Fields = {
  __typename?: "product_elec_sum_fields"
  duration_value?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "product_elec" */
export enum Product_Elec_Update_Column {
  /** column name */
  AvailableInThePast = "available_in_the_past",
  /** column name */
  AvailableToPublic = "available_to_public",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  DurationFrequency = "duration_frequency",
  /** column name */
  DurationValue = "duration_value",
  /** column name */
  EndDt = "end_dt",
  /** column name */
  Export = "export",
  /** column name */
  FromDt = "from_dt",
  /** column name */
  Id = "id",
  /** column name */
  RequiresSmartCharging = "requires_smart_charging",
  /** column name */
  ShortCode = "short_code",
  /** column name */
  SmartPayg = "smart_payg",
  /** column name */
  Status = "status",
  /** column name */
  ToDt = "to_dt",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  Variable = "variable",
}

export type Product_Elec_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Elec_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Elec_Set_Input>
  /** filter the rows which have to be updated */
  where: Product_Elec_Bool_Exp
}

/** aggregate var_pop on columns */
export type Product_Elec_Var_Pop_Fields = {
  __typename?: "product_elec_var_pop_fields"
  duration_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Product_Elec_Var_Samp_Fields = {
  __typename?: "product_elec_var_samp_fields"
  duration_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Product_Elec_Variance_Fields = {
  __typename?: "product_elec_variance_fields"
  duration_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "product_gas" */
export type Product_Gas = {
  __typename?: "product_gas"
  available_in_the_past: Scalars["Boolean"]["output"]
  available_to_public: Scalars["Boolean"]["output"]
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  duration_frequency?: Maybe<Scalars["frequency"]["output"]>
  duration_value?: Maybe<Scalars["Int"]["output"]>
  end_dt?: Maybe<Scalars["date"]["output"]>
  export: Scalars["Boolean"]["output"]
  from_dt: Scalars["date"]["output"]
  id: Scalars["bigint"]["output"]
  /** An object relationship */
  product: Product
  short_code: Scalars["String"]["output"]
  smart_payg: Scalars["Boolean"]["output"]
  status?: Maybe<Scalars["String"]["output"]>
  to_dt?: Maybe<Scalars["date"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
  variable: Scalars["Boolean"]["output"]
}

/** aggregated selection of "product_gas" */
export type Product_Gas_Aggregate = {
  __typename?: "product_gas_aggregate"
  aggregate?: Maybe<Product_Gas_Aggregate_Fields>
  nodes: Array<Product_Gas>
}

/** aggregate fields of "product_gas" */
export type Product_Gas_Aggregate_Fields = {
  __typename?: "product_gas_aggregate_fields"
  avg?: Maybe<Product_Gas_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Product_Gas_Max_Fields>
  min?: Maybe<Product_Gas_Min_Fields>
  stddev?: Maybe<Product_Gas_Stddev_Fields>
  stddev_pop?: Maybe<Product_Gas_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Product_Gas_Stddev_Samp_Fields>
  sum?: Maybe<Product_Gas_Sum_Fields>
  var_pop?: Maybe<Product_Gas_Var_Pop_Fields>
  var_samp?: Maybe<Product_Gas_Var_Samp_Fields>
  variance?: Maybe<Product_Gas_Variance_Fields>
}

/** aggregate fields of "product_gas" */
export type Product_Gas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Gas_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Product_Gas_Avg_Fields = {
  __typename?: "product_gas_avg_fields"
  duration_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "product_gas". All fields are combined with a logical 'AND'. */
export type Product_Gas_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Gas_Bool_Exp>>
  _not?: InputMaybe<Product_Gas_Bool_Exp>
  _or?: InputMaybe<Array<Product_Gas_Bool_Exp>>
  available_in_the_past?: InputMaybe<Boolean_Comparison_Exp>
  available_to_public?: InputMaybe<Boolean_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  duration_frequency?: InputMaybe<Frequency_Comparison_Exp>
  duration_value?: InputMaybe<Int_Comparison_Exp>
  end_dt?: InputMaybe<Date_Comparison_Exp>
  export?: InputMaybe<Boolean_Comparison_Exp>
  from_dt?: InputMaybe<Date_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  product?: InputMaybe<Product_Bool_Exp>
  short_code?: InputMaybe<String_Comparison_Exp>
  smart_payg?: InputMaybe<Boolean_Comparison_Exp>
  status?: InputMaybe<String_Comparison_Exp>
  to_dt?: InputMaybe<Date_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  variable?: InputMaybe<Boolean_Comparison_Exp>
}

/** unique or primary key constraints on table "product_gas" */
export enum Product_Gas_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkProductGas = "pk_product_gas",
}

/** input type for incrementing numeric columns in table "product_gas" */
export type Product_Gas_Inc_Input = {
  duration_value?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "product_gas" */
export type Product_Gas_Insert_Input = {
  available_in_the_past?: InputMaybe<Scalars["Boolean"]["input"]>
  available_to_public?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  duration_frequency?: InputMaybe<Scalars["frequency"]["input"]>
  duration_value?: InputMaybe<Scalars["Int"]["input"]>
  end_dt?: InputMaybe<Scalars["date"]["input"]>
  export?: InputMaybe<Scalars["Boolean"]["input"]>
  from_dt?: InputMaybe<Scalars["date"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>
  short_code?: InputMaybe<Scalars["String"]["input"]>
  smart_payg?: InputMaybe<Scalars["Boolean"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  to_dt?: InputMaybe<Scalars["date"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  variable?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate max on columns */
export type Product_Gas_Max_Fields = {
  __typename?: "product_gas_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  duration_frequency?: Maybe<Scalars["frequency"]["output"]>
  duration_value?: Maybe<Scalars["Int"]["output"]>
  end_dt?: Maybe<Scalars["date"]["output"]>
  from_dt?: Maybe<Scalars["date"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  short_code?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  to_dt?: Maybe<Scalars["date"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Product_Gas_Min_Fields = {
  __typename?: "product_gas_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  duration_frequency?: Maybe<Scalars["frequency"]["output"]>
  duration_value?: Maybe<Scalars["Int"]["output"]>
  end_dt?: Maybe<Scalars["date"]["output"]>
  from_dt?: Maybe<Scalars["date"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  short_code?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  to_dt?: Maybe<Scalars["date"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "product_gas" */
export type Product_Gas_Mutation_Response = {
  __typename?: "product_gas_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Product_Gas>
}

/** input type for inserting object relation for remote table "product_gas" */
export type Product_Gas_Obj_Rel_Insert_Input = {
  data: Product_Gas_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Gas_On_Conflict>
}

/** on_conflict condition type for table "product_gas" */
export type Product_Gas_On_Conflict = {
  constraint: Product_Gas_Constraint
  update_columns?: Array<Product_Gas_Update_Column>
  where?: InputMaybe<Product_Gas_Bool_Exp>
}

/** Ordering options when selecting data from "product_gas". */
export type Product_Gas_Order_By = {
  available_in_the_past?: InputMaybe<Order_By>
  available_to_public?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  duration_frequency?: InputMaybe<Order_By>
  duration_value?: InputMaybe<Order_By>
  end_dt?: InputMaybe<Order_By>
  export?: InputMaybe<Order_By>
  from_dt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  product?: InputMaybe<Product_Order_By>
  short_code?: InputMaybe<Order_By>
  smart_payg?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  to_dt?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  variable?: InputMaybe<Order_By>
}

/** primary key columns input for table: product_gas */
export type Product_Gas_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "product_gas" */
export enum Product_Gas_Select_Column {
  /** column name */
  AvailableInThePast = "available_in_the_past",
  /** column name */
  AvailableToPublic = "available_to_public",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  DurationFrequency = "duration_frequency",
  /** column name */
  DurationValue = "duration_value",
  /** column name */
  EndDt = "end_dt",
  /** column name */
  Export = "export",
  /** column name */
  FromDt = "from_dt",
  /** column name */
  Id = "id",
  /** column name */
  ShortCode = "short_code",
  /** column name */
  SmartPayg = "smart_payg",
  /** column name */
  Status = "status",
  /** column name */
  ToDt = "to_dt",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  Variable = "variable",
}

/** input type for updating data in table "product_gas" */
export type Product_Gas_Set_Input = {
  available_in_the_past?: InputMaybe<Scalars["Boolean"]["input"]>
  available_to_public?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  duration_frequency?: InputMaybe<Scalars["frequency"]["input"]>
  duration_value?: InputMaybe<Scalars["Int"]["input"]>
  end_dt?: InputMaybe<Scalars["date"]["input"]>
  export?: InputMaybe<Scalars["Boolean"]["input"]>
  from_dt?: InputMaybe<Scalars["date"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  short_code?: InputMaybe<Scalars["String"]["input"]>
  smart_payg?: InputMaybe<Scalars["Boolean"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  to_dt?: InputMaybe<Scalars["date"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  variable?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate stddev on columns */
export type Product_Gas_Stddev_Fields = {
  __typename?: "product_gas_stddev_fields"
  duration_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Product_Gas_Stddev_Pop_Fields = {
  __typename?: "product_gas_stddev_pop_fields"
  duration_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Product_Gas_Stddev_Samp_Fields = {
  __typename?: "product_gas_stddev_samp_fields"
  duration_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "product_gas" */
export type Product_Gas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Gas_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Product_Gas_Stream_Cursor_Value_Input = {
  available_in_the_past?: InputMaybe<Scalars["Boolean"]["input"]>
  available_to_public?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  duration_frequency?: InputMaybe<Scalars["frequency"]["input"]>
  duration_value?: InputMaybe<Scalars["Int"]["input"]>
  end_dt?: InputMaybe<Scalars["date"]["input"]>
  export?: InputMaybe<Scalars["Boolean"]["input"]>
  from_dt?: InputMaybe<Scalars["date"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  short_code?: InputMaybe<Scalars["String"]["input"]>
  smart_payg?: InputMaybe<Scalars["Boolean"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  to_dt?: InputMaybe<Scalars["date"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  variable?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate sum on columns */
export type Product_Gas_Sum_Fields = {
  __typename?: "product_gas_sum_fields"
  duration_value?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "product_gas" */
export enum Product_Gas_Update_Column {
  /** column name */
  AvailableInThePast = "available_in_the_past",
  /** column name */
  AvailableToPublic = "available_to_public",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  DurationFrequency = "duration_frequency",
  /** column name */
  DurationValue = "duration_value",
  /** column name */
  EndDt = "end_dt",
  /** column name */
  Export = "export",
  /** column name */
  FromDt = "from_dt",
  /** column name */
  Id = "id",
  /** column name */
  ShortCode = "short_code",
  /** column name */
  SmartPayg = "smart_payg",
  /** column name */
  Status = "status",
  /** column name */
  ToDt = "to_dt",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  Variable = "variable",
}

export type Product_Gas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Gas_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Gas_Set_Input>
  /** filter the rows which have to be updated */
  where: Product_Gas_Bool_Exp
}

/** aggregate var_pop on columns */
export type Product_Gas_Var_Pop_Fields = {
  __typename?: "product_gas_var_pop_fields"
  duration_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Product_Gas_Var_Samp_Fields = {
  __typename?: "product_gas_var_samp_fields"
  duration_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Product_Gas_Variance_Fields = {
  __typename?: "product_gas_variance_fields"
  duration_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** input type for incrementing numeric columns in table "product" */
export type Product_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "product" */
export type Product_Insert_Input = {
  code?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  display_name?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  product_elec?: InputMaybe<Product_Elec_Obj_Rel_Insert_Input>
  product_ga?: InputMaybe<Product_Gas_Obj_Rel_Insert_Input>
  product_variants?: InputMaybe<Product_Variant_Arr_Rel_Insert_Input>
  type?: InputMaybe<Scalars["product_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Product_Max_Fields = {
  __typename?: "product_max_fields"
  code?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  display_name?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["product_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Product_Min_Fields = {
  __typename?: "product_min_fields"
  code?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  display_name?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["product_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "product" */
export type Product_Mutation_Response = {
  __typename?: "product_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Product>
}

/** input type for inserting object relation for remote table "product" */
export type Product_Obj_Rel_Insert_Input = {
  data: Product_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Product_On_Conflict>
}

/** on_conflict condition type for table "product" */
export type Product_On_Conflict = {
  constraint: Product_Constraint
  update_columns?: Array<Product_Update_Column>
  where?: InputMaybe<Product_Bool_Exp>
}

/** Ordering options when selecting data from "product". */
export type Product_Order_By = {
  code?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  display_name?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  product_elec?: InputMaybe<Product_Elec_Order_By>
  product_ga?: InputMaybe<Product_Gas_Order_By>
  product_variants_aggregate?: InputMaybe<Product_Variant_Aggregate_Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: product */
export type Product_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "product" */
export enum Product_Select_Column {
  /** column name */
  Code = "code",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  DisplayName = "display_name",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "product" */
export type Product_Set_Input = {
  code?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  display_name?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["product_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Product_Stddev_Fields = {
  __typename?: "product_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Product_Stddev_Pop_Fields = {
  __typename?: "product_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Product_Stddev_Samp_Fields = {
  __typename?: "product_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "product" */
export type Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Product_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  display_name?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["product_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Product_Sum_Fields = {
  __typename?: "product_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** Boolean expression to compare columns of type "product_type". All fields are combined with logical 'AND'. */
export type Product_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["product_type"]["input"]>
  _gt?: InputMaybe<Scalars["product_type"]["input"]>
  _gte?: InputMaybe<Scalars["product_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["product_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["product_type"]["input"]>
  _lte?: InputMaybe<Scalars["product_type"]["input"]>
  _neq?: InputMaybe<Scalars["product_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["product_type"]["input"]>>
}

/** update columns of table "product" */
export enum Product_Update_Column {
  /** column name */
  Code = "code",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  DisplayName = "display_name",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Product_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Set_Input>
  /** filter the rows which have to be updated */
  where: Product_Bool_Exp
}

/** aggregate var_pop on columns */
export type Product_Var_Pop_Fields = {
  __typename?: "product_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Product_Var_Samp_Fields = {
  __typename?: "product_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Product_Variance_Fields = {
  __typename?: "product_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "product_variant" */
export type Product_Variant = {
  __typename?: "product_variant"
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  /** An object relationship */
  product: Product
  product_id: Scalars["bigint"]["output"]
  /** An array relationship */
  product_variant_elecs: Array<Product_Variant_Elec>
  /** An aggregate relationship */
  product_variant_elecs_aggregate: Product_Variant_Elec_Aggregate
  /** An array relationship */
  product_variant_gas: Array<Product_Variant_Gas>
  /** An aggregate relationship */
  product_variant_gas_aggregate: Product_Variant_Gas_Aggregate
  type?: Maybe<Scalars["product_variant_type"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "product_variant" */
export type Product_VariantProduct_Variant_ElecsArgs = {
  distinct_on?: InputMaybe<Array<Product_Variant_Elec_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Variant_Elec_Order_By>>
  where?: InputMaybe<Product_Variant_Elec_Bool_Exp>
}

/** columns and relationships of "product_variant" */
export type Product_VariantProduct_Variant_Elecs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variant_Elec_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Variant_Elec_Order_By>>
  where?: InputMaybe<Product_Variant_Elec_Bool_Exp>
}

/** columns and relationships of "product_variant" */
export type Product_VariantProduct_Variant_GasArgs = {
  distinct_on?: InputMaybe<Array<Product_Variant_Gas_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Variant_Gas_Order_By>>
  where?: InputMaybe<Product_Variant_Gas_Bool_Exp>
}

/** columns and relationships of "product_variant" */
export type Product_VariantProduct_Variant_Gas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variant_Gas_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Variant_Gas_Order_By>>
  where?: InputMaybe<Product_Variant_Gas_Bool_Exp>
}

/** aggregated selection of "product_variant" */
export type Product_Variant_Aggregate = {
  __typename?: "product_variant_aggregate"
  aggregate?: Maybe<Product_Variant_Aggregate_Fields>
  nodes: Array<Product_Variant>
}

export type Product_Variant_Aggregate_Bool_Exp = {
  count?: InputMaybe<Product_Variant_Aggregate_Bool_Exp_Count>
}

export type Product_Variant_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Product_Variant_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Product_Variant_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "product_variant" */
export type Product_Variant_Aggregate_Fields = {
  __typename?: "product_variant_aggregate_fields"
  avg?: Maybe<Product_Variant_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Product_Variant_Max_Fields>
  min?: Maybe<Product_Variant_Min_Fields>
  stddev?: Maybe<Product_Variant_Stddev_Fields>
  stddev_pop?: Maybe<Product_Variant_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Product_Variant_Stddev_Samp_Fields>
  sum?: Maybe<Product_Variant_Sum_Fields>
  var_pop?: Maybe<Product_Variant_Var_Pop_Fields>
  var_samp?: Maybe<Product_Variant_Var_Samp_Fields>
  variance?: Maybe<Product_Variant_Variance_Fields>
}

/** aggregate fields of "product_variant" */
export type Product_Variant_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Variant_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "product_variant" */
export type Product_Variant_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Variant_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Product_Variant_Max_Order_By>
  min?: InputMaybe<Product_Variant_Min_Order_By>
  stddev?: InputMaybe<Product_Variant_Stddev_Order_By>
  stddev_pop?: InputMaybe<Product_Variant_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Product_Variant_Stddev_Samp_Order_By>
  sum?: InputMaybe<Product_Variant_Sum_Order_By>
  var_pop?: InputMaybe<Product_Variant_Var_Pop_Order_By>
  var_samp?: InputMaybe<Product_Variant_Var_Samp_Order_By>
  variance?: InputMaybe<Product_Variant_Variance_Order_By>
}

/** input type for inserting array relation for remote table "product_variant" */
export type Product_Variant_Arr_Rel_Insert_Input = {
  data: Array<Product_Variant_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Variant_On_Conflict>
}

/** aggregate avg on columns */
export type Product_Variant_Avg_Fields = {
  __typename?: "product_variant_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  product_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "product_variant" */
export type Product_Variant_Avg_Order_By = {
  id?: InputMaybe<Order_By>
  product_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "product_variant". All fields are combined with a logical 'AND'. */
export type Product_Variant_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Variant_Bool_Exp>>
  _not?: InputMaybe<Product_Variant_Bool_Exp>
  _or?: InputMaybe<Array<Product_Variant_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  product?: InputMaybe<Product_Bool_Exp>
  product_id?: InputMaybe<Bigint_Comparison_Exp>
  product_variant_elecs?: InputMaybe<Product_Variant_Elec_Bool_Exp>
  product_variant_elecs_aggregate?: InputMaybe<Product_Variant_Elec_Aggregate_Bool_Exp>
  product_variant_gas?: InputMaybe<Product_Variant_Gas_Bool_Exp>
  product_variant_gas_aggregate?: InputMaybe<Product_Variant_Gas_Aggregate_Bool_Exp>
  type?: InputMaybe<Product_Variant_Type_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "product_variant" */
export enum Product_Variant_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkProductVariant = "pk_product_variant",
}

/** columns and relationships of "product_variant_elec" */
export type Product_Variant_Elec = {
  __typename?: "product_variant_elec"
  active_for_enrolment: Scalars["Boolean"]["output"]
  active_for_renewal: Scalars["Boolean"]["output"]
  charge_unit: Scalars["price_unit"]["output"]
  charge_value: Scalars["numeric"]["output"]
  created_at: Scalars["timestamp"]["output"]
  day_rate_unit: Scalars["price_unit"]["output"]
  day_rate_value: Scalars["numeric"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  direct_debit?: Maybe<Scalars["Boolean"]["output"]>
  dual_fuel_discount: Scalars["numeric"]["output"]
  early_termination_charge: Scalars["numeric"]["output"]
  from_dt: Scalars["date"]["output"]
  gsp_group: Scalars["String"]["output"]
  hh_rate_definition_id?: Maybe<Scalars["bigint"]["output"]>
  hh_rate_definition_item_id?: Maybe<Scalars["bigint"]["output"]>
  id: Scalars["bigint"]["output"]
  night_rate_unit: Scalars["price_unit"]["output"]
  night_rate_value: Scalars["numeric"]["output"]
  online_discount: Scalars["numeric"]["output"]
  product_rate_id?: Maybe<Scalars["bigint"]["output"]>
  /** An object relationship */
  product_variant?: Maybe<Product_Variant>
  product_variant_id?: Maybe<Scalars["bigint"]["output"]>
  rate_type?: Maybe<Scalars["product_variant_rate_type"]["output"]>
  recommend_for_enrolment: Scalars["Boolean"]["output"]
  recommend_for_renewal: Scalars["Boolean"]["output"]
  sales_tax_name?: Maybe<Scalars["String"]["output"]>
  tax_rate?: Maybe<Scalars["numeric"]["output"]>
  to_dt?: Maybe<Scalars["date"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "product_variant_elec" */
export type Product_Variant_Elec_Aggregate = {
  __typename?: "product_variant_elec_aggregate"
  aggregate?: Maybe<Product_Variant_Elec_Aggregate_Fields>
  nodes: Array<Product_Variant_Elec>
}

export type Product_Variant_Elec_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Product_Variant_Elec_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Product_Variant_Elec_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<Product_Variant_Elec_Aggregate_Bool_Exp_Count>
}

export type Product_Variant_Elec_Aggregate_Bool_Exp_Bool_And = {
  arguments: Product_Variant_Elec_Select_Column_Product_Variant_Elec_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Product_Variant_Elec_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Product_Variant_Elec_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Product_Variant_Elec_Select_Column_Product_Variant_Elec_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Product_Variant_Elec_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Product_Variant_Elec_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Product_Variant_Elec_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Product_Variant_Elec_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "product_variant_elec" */
export type Product_Variant_Elec_Aggregate_Fields = {
  __typename?: "product_variant_elec_aggregate_fields"
  avg?: Maybe<Product_Variant_Elec_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Product_Variant_Elec_Max_Fields>
  min?: Maybe<Product_Variant_Elec_Min_Fields>
  stddev?: Maybe<Product_Variant_Elec_Stddev_Fields>
  stddev_pop?: Maybe<Product_Variant_Elec_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Product_Variant_Elec_Stddev_Samp_Fields>
  sum?: Maybe<Product_Variant_Elec_Sum_Fields>
  var_pop?: Maybe<Product_Variant_Elec_Var_Pop_Fields>
  var_samp?: Maybe<Product_Variant_Elec_Var_Samp_Fields>
  variance?: Maybe<Product_Variant_Elec_Variance_Fields>
}

/** aggregate fields of "product_variant_elec" */
export type Product_Variant_Elec_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Variant_Elec_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "product_variant_elec" */
export type Product_Variant_Elec_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Variant_Elec_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Product_Variant_Elec_Max_Order_By>
  min?: InputMaybe<Product_Variant_Elec_Min_Order_By>
  stddev?: InputMaybe<Product_Variant_Elec_Stddev_Order_By>
  stddev_pop?: InputMaybe<Product_Variant_Elec_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Product_Variant_Elec_Stddev_Samp_Order_By>
  sum?: InputMaybe<Product_Variant_Elec_Sum_Order_By>
  var_pop?: InputMaybe<Product_Variant_Elec_Var_Pop_Order_By>
  var_samp?: InputMaybe<Product_Variant_Elec_Var_Samp_Order_By>
  variance?: InputMaybe<Product_Variant_Elec_Variance_Order_By>
}

/** input type for inserting array relation for remote table "product_variant_elec" */
export type Product_Variant_Elec_Arr_Rel_Insert_Input = {
  data: Array<Product_Variant_Elec_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Variant_Elec_On_Conflict>
}

/** aggregate avg on columns */
export type Product_Variant_Elec_Avg_Fields = {
  __typename?: "product_variant_elec_avg_fields"
  charge_value?: Maybe<Scalars["Float"]["output"]>
  day_rate_value?: Maybe<Scalars["Float"]["output"]>
  dual_fuel_discount?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  hh_rate_definition_id?: Maybe<Scalars["Float"]["output"]>
  hh_rate_definition_item_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  night_rate_value?: Maybe<Scalars["Float"]["output"]>
  online_discount?: Maybe<Scalars["Float"]["output"]>
  product_rate_id?: Maybe<Scalars["Float"]["output"]>
  product_variant_id?: Maybe<Scalars["Float"]["output"]>
  tax_rate?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "product_variant_elec" */
export type Product_Variant_Elec_Avg_Order_By = {
  charge_value?: InputMaybe<Order_By>
  day_rate_value?: InputMaybe<Order_By>
  dual_fuel_discount?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  hh_rate_definition_id?: InputMaybe<Order_By>
  hh_rate_definition_item_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  night_rate_value?: InputMaybe<Order_By>
  online_discount?: InputMaybe<Order_By>
  product_rate_id?: InputMaybe<Order_By>
  product_variant_id?: InputMaybe<Order_By>
  tax_rate?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "product_variant_elec". All fields are combined with a logical 'AND'. */
export type Product_Variant_Elec_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Variant_Elec_Bool_Exp>>
  _not?: InputMaybe<Product_Variant_Elec_Bool_Exp>
  _or?: InputMaybe<Array<Product_Variant_Elec_Bool_Exp>>
  active_for_enrolment?: InputMaybe<Boolean_Comparison_Exp>
  active_for_renewal?: InputMaybe<Boolean_Comparison_Exp>
  charge_unit?: InputMaybe<Price_Unit_Comparison_Exp>
  charge_value?: InputMaybe<Numeric_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  day_rate_unit?: InputMaybe<Price_Unit_Comparison_Exp>
  day_rate_value?: InputMaybe<Numeric_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  direct_debit?: InputMaybe<Boolean_Comparison_Exp>
  dual_fuel_discount?: InputMaybe<Numeric_Comparison_Exp>
  early_termination_charge?: InputMaybe<Numeric_Comparison_Exp>
  from_dt?: InputMaybe<Date_Comparison_Exp>
  gsp_group?: InputMaybe<String_Comparison_Exp>
  hh_rate_definition_id?: InputMaybe<Bigint_Comparison_Exp>
  hh_rate_definition_item_id?: InputMaybe<Bigint_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  night_rate_unit?: InputMaybe<Price_Unit_Comparison_Exp>
  night_rate_value?: InputMaybe<Numeric_Comparison_Exp>
  online_discount?: InputMaybe<Numeric_Comparison_Exp>
  product_rate_id?: InputMaybe<Bigint_Comparison_Exp>
  product_variant?: InputMaybe<Product_Variant_Bool_Exp>
  product_variant_id?: InputMaybe<Bigint_Comparison_Exp>
  rate_type?: InputMaybe<Product_Variant_Rate_Type_Comparison_Exp>
  recommend_for_enrolment?: InputMaybe<Boolean_Comparison_Exp>
  recommend_for_renewal?: InputMaybe<Boolean_Comparison_Exp>
  sales_tax_name?: InputMaybe<String_Comparison_Exp>
  tax_rate?: InputMaybe<Numeric_Comparison_Exp>
  to_dt?: InputMaybe<Date_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "product_variant_elec" */
export enum Product_Variant_Elec_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkProductVariantElec = "pk_product_variant_elec",
}

/** input type for incrementing numeric columns in table "product_variant_elec" */
export type Product_Variant_Elec_Inc_Input = {
  charge_value?: InputMaybe<Scalars["numeric"]["input"]>
  day_rate_value?: InputMaybe<Scalars["numeric"]["input"]>
  dual_fuel_discount?: InputMaybe<Scalars["numeric"]["input"]>
  early_termination_charge?: InputMaybe<Scalars["numeric"]["input"]>
  hh_rate_definition_id?: InputMaybe<Scalars["bigint"]["input"]>
  hh_rate_definition_item_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  night_rate_value?: InputMaybe<Scalars["numeric"]["input"]>
  online_discount?: InputMaybe<Scalars["numeric"]["input"]>
  product_rate_id?: InputMaybe<Scalars["bigint"]["input"]>
  product_variant_id?: InputMaybe<Scalars["bigint"]["input"]>
  tax_rate?: InputMaybe<Scalars["numeric"]["input"]>
}

/** input type for inserting data into table "product_variant_elec" */
export type Product_Variant_Elec_Insert_Input = {
  active_for_enrolment?: InputMaybe<Scalars["Boolean"]["input"]>
  active_for_renewal?: InputMaybe<Scalars["Boolean"]["input"]>
  charge_unit?: InputMaybe<Scalars["price_unit"]["input"]>
  charge_value?: InputMaybe<Scalars["numeric"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  day_rate_unit?: InputMaybe<Scalars["price_unit"]["input"]>
  day_rate_value?: InputMaybe<Scalars["numeric"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  direct_debit?: InputMaybe<Scalars["Boolean"]["input"]>
  dual_fuel_discount?: InputMaybe<Scalars["numeric"]["input"]>
  early_termination_charge?: InputMaybe<Scalars["numeric"]["input"]>
  from_dt?: InputMaybe<Scalars["date"]["input"]>
  gsp_group?: InputMaybe<Scalars["String"]["input"]>
  hh_rate_definition_id?: InputMaybe<Scalars["bigint"]["input"]>
  hh_rate_definition_item_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  night_rate_unit?: InputMaybe<Scalars["price_unit"]["input"]>
  night_rate_value?: InputMaybe<Scalars["numeric"]["input"]>
  online_discount?: InputMaybe<Scalars["numeric"]["input"]>
  product_rate_id?: InputMaybe<Scalars["bigint"]["input"]>
  product_variant?: InputMaybe<Product_Variant_Obj_Rel_Insert_Input>
  product_variant_id?: InputMaybe<Scalars["bigint"]["input"]>
  rate_type?: InputMaybe<Scalars["product_variant_rate_type"]["input"]>
  recommend_for_enrolment?: InputMaybe<Scalars["Boolean"]["input"]>
  recommend_for_renewal?: InputMaybe<Scalars["Boolean"]["input"]>
  sales_tax_name?: InputMaybe<Scalars["String"]["input"]>
  tax_rate?: InputMaybe<Scalars["numeric"]["input"]>
  to_dt?: InputMaybe<Scalars["date"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Product_Variant_Elec_Max_Fields = {
  __typename?: "product_variant_elec_max_fields"
  charge_unit?: Maybe<Scalars["price_unit"]["output"]>
  charge_value?: Maybe<Scalars["numeric"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  day_rate_unit?: Maybe<Scalars["price_unit"]["output"]>
  day_rate_value?: Maybe<Scalars["numeric"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  dual_fuel_discount?: Maybe<Scalars["numeric"]["output"]>
  early_termination_charge?: Maybe<Scalars["numeric"]["output"]>
  from_dt?: Maybe<Scalars["date"]["output"]>
  gsp_group?: Maybe<Scalars["String"]["output"]>
  hh_rate_definition_id?: Maybe<Scalars["bigint"]["output"]>
  hh_rate_definition_item_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  night_rate_unit?: Maybe<Scalars["price_unit"]["output"]>
  night_rate_value?: Maybe<Scalars["numeric"]["output"]>
  online_discount?: Maybe<Scalars["numeric"]["output"]>
  product_rate_id?: Maybe<Scalars["bigint"]["output"]>
  product_variant_id?: Maybe<Scalars["bigint"]["output"]>
  rate_type?: Maybe<Scalars["product_variant_rate_type"]["output"]>
  sales_tax_name?: Maybe<Scalars["String"]["output"]>
  tax_rate?: Maybe<Scalars["numeric"]["output"]>
  to_dt?: Maybe<Scalars["date"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "product_variant_elec" */
export type Product_Variant_Elec_Max_Order_By = {
  charge_unit?: InputMaybe<Order_By>
  charge_value?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  day_rate_unit?: InputMaybe<Order_By>
  day_rate_value?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  dual_fuel_discount?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  from_dt?: InputMaybe<Order_By>
  gsp_group?: InputMaybe<Order_By>
  hh_rate_definition_id?: InputMaybe<Order_By>
  hh_rate_definition_item_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  night_rate_unit?: InputMaybe<Order_By>
  night_rate_value?: InputMaybe<Order_By>
  online_discount?: InputMaybe<Order_By>
  product_rate_id?: InputMaybe<Order_By>
  product_variant_id?: InputMaybe<Order_By>
  rate_type?: InputMaybe<Order_By>
  sales_tax_name?: InputMaybe<Order_By>
  tax_rate?: InputMaybe<Order_By>
  to_dt?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Product_Variant_Elec_Min_Fields = {
  __typename?: "product_variant_elec_min_fields"
  charge_unit?: Maybe<Scalars["price_unit"]["output"]>
  charge_value?: Maybe<Scalars["numeric"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  day_rate_unit?: Maybe<Scalars["price_unit"]["output"]>
  day_rate_value?: Maybe<Scalars["numeric"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  dual_fuel_discount?: Maybe<Scalars["numeric"]["output"]>
  early_termination_charge?: Maybe<Scalars["numeric"]["output"]>
  from_dt?: Maybe<Scalars["date"]["output"]>
  gsp_group?: Maybe<Scalars["String"]["output"]>
  hh_rate_definition_id?: Maybe<Scalars["bigint"]["output"]>
  hh_rate_definition_item_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  night_rate_unit?: Maybe<Scalars["price_unit"]["output"]>
  night_rate_value?: Maybe<Scalars["numeric"]["output"]>
  online_discount?: Maybe<Scalars["numeric"]["output"]>
  product_rate_id?: Maybe<Scalars["bigint"]["output"]>
  product_variant_id?: Maybe<Scalars["bigint"]["output"]>
  rate_type?: Maybe<Scalars["product_variant_rate_type"]["output"]>
  sales_tax_name?: Maybe<Scalars["String"]["output"]>
  tax_rate?: Maybe<Scalars["numeric"]["output"]>
  to_dt?: Maybe<Scalars["date"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "product_variant_elec" */
export type Product_Variant_Elec_Min_Order_By = {
  charge_unit?: InputMaybe<Order_By>
  charge_value?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  day_rate_unit?: InputMaybe<Order_By>
  day_rate_value?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  dual_fuel_discount?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  from_dt?: InputMaybe<Order_By>
  gsp_group?: InputMaybe<Order_By>
  hh_rate_definition_id?: InputMaybe<Order_By>
  hh_rate_definition_item_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  night_rate_unit?: InputMaybe<Order_By>
  night_rate_value?: InputMaybe<Order_By>
  online_discount?: InputMaybe<Order_By>
  product_rate_id?: InputMaybe<Order_By>
  product_variant_id?: InputMaybe<Order_By>
  rate_type?: InputMaybe<Order_By>
  sales_tax_name?: InputMaybe<Order_By>
  tax_rate?: InputMaybe<Order_By>
  to_dt?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "product_variant_elec" */
export type Product_Variant_Elec_Mutation_Response = {
  __typename?: "product_variant_elec_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Product_Variant_Elec>
}

/** on_conflict condition type for table "product_variant_elec" */
export type Product_Variant_Elec_On_Conflict = {
  constraint: Product_Variant_Elec_Constraint
  update_columns?: Array<Product_Variant_Elec_Update_Column>
  where?: InputMaybe<Product_Variant_Elec_Bool_Exp>
}

/** Ordering options when selecting data from "product_variant_elec". */
export type Product_Variant_Elec_Order_By = {
  active_for_enrolment?: InputMaybe<Order_By>
  active_for_renewal?: InputMaybe<Order_By>
  charge_unit?: InputMaybe<Order_By>
  charge_value?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  day_rate_unit?: InputMaybe<Order_By>
  day_rate_value?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  direct_debit?: InputMaybe<Order_By>
  dual_fuel_discount?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  from_dt?: InputMaybe<Order_By>
  gsp_group?: InputMaybe<Order_By>
  hh_rate_definition_id?: InputMaybe<Order_By>
  hh_rate_definition_item_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  night_rate_unit?: InputMaybe<Order_By>
  night_rate_value?: InputMaybe<Order_By>
  online_discount?: InputMaybe<Order_By>
  product_rate_id?: InputMaybe<Order_By>
  product_variant?: InputMaybe<Product_Variant_Order_By>
  product_variant_id?: InputMaybe<Order_By>
  rate_type?: InputMaybe<Order_By>
  recommend_for_enrolment?: InputMaybe<Order_By>
  recommend_for_renewal?: InputMaybe<Order_By>
  sales_tax_name?: InputMaybe<Order_By>
  tax_rate?: InputMaybe<Order_By>
  to_dt?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: product_variant_elec */
export type Product_Variant_Elec_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "product_variant_elec" */
export enum Product_Variant_Elec_Select_Column {
  /** column name */
  ActiveForEnrolment = "active_for_enrolment",
  /** column name */
  ActiveForRenewal = "active_for_renewal",
  /** column name */
  ChargeUnit = "charge_unit",
  /** column name */
  ChargeValue = "charge_value",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DayRateUnit = "day_rate_unit",
  /** column name */
  DayRateValue = "day_rate_value",
  /** column name */
  Deleted = "deleted",
  /** column name */
  DirectDebit = "direct_debit",
  /** column name */
  DualFuelDiscount = "dual_fuel_discount",
  /** column name */
  EarlyTerminationCharge = "early_termination_charge",
  /** column name */
  FromDt = "from_dt",
  /** column name */
  GspGroup = "gsp_group",
  /** column name */
  HhRateDefinitionId = "hh_rate_definition_id",
  /** column name */
  HhRateDefinitionItemId = "hh_rate_definition_item_id",
  /** column name */
  Id = "id",
  /** column name */
  NightRateUnit = "night_rate_unit",
  /** column name */
  NightRateValue = "night_rate_value",
  /** column name */
  OnlineDiscount = "online_discount",
  /** column name */
  ProductRateId = "product_rate_id",
  /** column name */
  ProductVariantId = "product_variant_id",
  /** column name */
  RateType = "rate_type",
  /** column name */
  RecommendForEnrolment = "recommend_for_enrolment",
  /** column name */
  RecommendForRenewal = "recommend_for_renewal",
  /** column name */
  SalesTaxName = "sales_tax_name",
  /** column name */
  TaxRate = "tax_rate",
  /** column name */
  ToDt = "to_dt",
  /** column name */
  UpdatedAt = "updated_at",
}

/** select "product_variant_elec_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product_variant_elec" */
export enum Product_Variant_Elec_Select_Column_Product_Variant_Elec_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ActiveForEnrolment = "active_for_enrolment",
  /** column name */
  ActiveForRenewal = "active_for_renewal",
  /** column name */
  DirectDebit = "direct_debit",
  /** column name */
  RecommendForEnrolment = "recommend_for_enrolment",
  /** column name */
  RecommendForRenewal = "recommend_for_renewal",
}

/** select "product_variant_elec_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product_variant_elec" */
export enum Product_Variant_Elec_Select_Column_Product_Variant_Elec_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ActiveForEnrolment = "active_for_enrolment",
  /** column name */
  ActiveForRenewal = "active_for_renewal",
  /** column name */
  DirectDebit = "direct_debit",
  /** column name */
  RecommendForEnrolment = "recommend_for_enrolment",
  /** column name */
  RecommendForRenewal = "recommend_for_renewal",
}

/** input type for updating data in table "product_variant_elec" */
export type Product_Variant_Elec_Set_Input = {
  active_for_enrolment?: InputMaybe<Scalars["Boolean"]["input"]>
  active_for_renewal?: InputMaybe<Scalars["Boolean"]["input"]>
  charge_unit?: InputMaybe<Scalars["price_unit"]["input"]>
  charge_value?: InputMaybe<Scalars["numeric"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  day_rate_unit?: InputMaybe<Scalars["price_unit"]["input"]>
  day_rate_value?: InputMaybe<Scalars["numeric"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  direct_debit?: InputMaybe<Scalars["Boolean"]["input"]>
  dual_fuel_discount?: InputMaybe<Scalars["numeric"]["input"]>
  early_termination_charge?: InputMaybe<Scalars["numeric"]["input"]>
  from_dt?: InputMaybe<Scalars["date"]["input"]>
  gsp_group?: InputMaybe<Scalars["String"]["input"]>
  hh_rate_definition_id?: InputMaybe<Scalars["bigint"]["input"]>
  hh_rate_definition_item_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  night_rate_unit?: InputMaybe<Scalars["price_unit"]["input"]>
  night_rate_value?: InputMaybe<Scalars["numeric"]["input"]>
  online_discount?: InputMaybe<Scalars["numeric"]["input"]>
  product_rate_id?: InputMaybe<Scalars["bigint"]["input"]>
  product_variant_id?: InputMaybe<Scalars["bigint"]["input"]>
  rate_type?: InputMaybe<Scalars["product_variant_rate_type"]["input"]>
  recommend_for_enrolment?: InputMaybe<Scalars["Boolean"]["input"]>
  recommend_for_renewal?: InputMaybe<Scalars["Boolean"]["input"]>
  sales_tax_name?: InputMaybe<Scalars["String"]["input"]>
  tax_rate?: InputMaybe<Scalars["numeric"]["input"]>
  to_dt?: InputMaybe<Scalars["date"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Product_Variant_Elec_Stddev_Fields = {
  __typename?: "product_variant_elec_stddev_fields"
  charge_value?: Maybe<Scalars["Float"]["output"]>
  day_rate_value?: Maybe<Scalars["Float"]["output"]>
  dual_fuel_discount?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  hh_rate_definition_id?: Maybe<Scalars["Float"]["output"]>
  hh_rate_definition_item_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  night_rate_value?: Maybe<Scalars["Float"]["output"]>
  online_discount?: Maybe<Scalars["Float"]["output"]>
  product_rate_id?: Maybe<Scalars["Float"]["output"]>
  product_variant_id?: Maybe<Scalars["Float"]["output"]>
  tax_rate?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "product_variant_elec" */
export type Product_Variant_Elec_Stddev_Order_By = {
  charge_value?: InputMaybe<Order_By>
  day_rate_value?: InputMaybe<Order_By>
  dual_fuel_discount?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  hh_rate_definition_id?: InputMaybe<Order_By>
  hh_rate_definition_item_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  night_rate_value?: InputMaybe<Order_By>
  online_discount?: InputMaybe<Order_By>
  product_rate_id?: InputMaybe<Order_By>
  product_variant_id?: InputMaybe<Order_By>
  tax_rate?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Product_Variant_Elec_Stddev_Pop_Fields = {
  __typename?: "product_variant_elec_stddev_pop_fields"
  charge_value?: Maybe<Scalars["Float"]["output"]>
  day_rate_value?: Maybe<Scalars["Float"]["output"]>
  dual_fuel_discount?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  hh_rate_definition_id?: Maybe<Scalars["Float"]["output"]>
  hh_rate_definition_item_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  night_rate_value?: Maybe<Scalars["Float"]["output"]>
  online_discount?: Maybe<Scalars["Float"]["output"]>
  product_rate_id?: Maybe<Scalars["Float"]["output"]>
  product_variant_id?: Maybe<Scalars["Float"]["output"]>
  tax_rate?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "product_variant_elec" */
export type Product_Variant_Elec_Stddev_Pop_Order_By = {
  charge_value?: InputMaybe<Order_By>
  day_rate_value?: InputMaybe<Order_By>
  dual_fuel_discount?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  hh_rate_definition_id?: InputMaybe<Order_By>
  hh_rate_definition_item_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  night_rate_value?: InputMaybe<Order_By>
  online_discount?: InputMaybe<Order_By>
  product_rate_id?: InputMaybe<Order_By>
  product_variant_id?: InputMaybe<Order_By>
  tax_rate?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Product_Variant_Elec_Stddev_Samp_Fields = {
  __typename?: "product_variant_elec_stddev_samp_fields"
  charge_value?: Maybe<Scalars["Float"]["output"]>
  day_rate_value?: Maybe<Scalars["Float"]["output"]>
  dual_fuel_discount?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  hh_rate_definition_id?: Maybe<Scalars["Float"]["output"]>
  hh_rate_definition_item_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  night_rate_value?: Maybe<Scalars["Float"]["output"]>
  online_discount?: Maybe<Scalars["Float"]["output"]>
  product_rate_id?: Maybe<Scalars["Float"]["output"]>
  product_variant_id?: Maybe<Scalars["Float"]["output"]>
  tax_rate?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "product_variant_elec" */
export type Product_Variant_Elec_Stddev_Samp_Order_By = {
  charge_value?: InputMaybe<Order_By>
  day_rate_value?: InputMaybe<Order_By>
  dual_fuel_discount?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  hh_rate_definition_id?: InputMaybe<Order_By>
  hh_rate_definition_item_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  night_rate_value?: InputMaybe<Order_By>
  online_discount?: InputMaybe<Order_By>
  product_rate_id?: InputMaybe<Order_By>
  product_variant_id?: InputMaybe<Order_By>
  tax_rate?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "product_variant_elec" */
export type Product_Variant_Elec_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Variant_Elec_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Product_Variant_Elec_Stream_Cursor_Value_Input = {
  active_for_enrolment?: InputMaybe<Scalars["Boolean"]["input"]>
  active_for_renewal?: InputMaybe<Scalars["Boolean"]["input"]>
  charge_unit?: InputMaybe<Scalars["price_unit"]["input"]>
  charge_value?: InputMaybe<Scalars["numeric"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  day_rate_unit?: InputMaybe<Scalars["price_unit"]["input"]>
  day_rate_value?: InputMaybe<Scalars["numeric"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  direct_debit?: InputMaybe<Scalars["Boolean"]["input"]>
  dual_fuel_discount?: InputMaybe<Scalars["numeric"]["input"]>
  early_termination_charge?: InputMaybe<Scalars["numeric"]["input"]>
  from_dt?: InputMaybe<Scalars["date"]["input"]>
  gsp_group?: InputMaybe<Scalars["String"]["input"]>
  hh_rate_definition_id?: InputMaybe<Scalars["bigint"]["input"]>
  hh_rate_definition_item_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  night_rate_unit?: InputMaybe<Scalars["price_unit"]["input"]>
  night_rate_value?: InputMaybe<Scalars["numeric"]["input"]>
  online_discount?: InputMaybe<Scalars["numeric"]["input"]>
  product_rate_id?: InputMaybe<Scalars["bigint"]["input"]>
  product_variant_id?: InputMaybe<Scalars["bigint"]["input"]>
  rate_type?: InputMaybe<Scalars["product_variant_rate_type"]["input"]>
  recommend_for_enrolment?: InputMaybe<Scalars["Boolean"]["input"]>
  recommend_for_renewal?: InputMaybe<Scalars["Boolean"]["input"]>
  sales_tax_name?: InputMaybe<Scalars["String"]["input"]>
  tax_rate?: InputMaybe<Scalars["numeric"]["input"]>
  to_dt?: InputMaybe<Scalars["date"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Product_Variant_Elec_Sum_Fields = {
  __typename?: "product_variant_elec_sum_fields"
  charge_value?: Maybe<Scalars["numeric"]["output"]>
  day_rate_value?: Maybe<Scalars["numeric"]["output"]>
  dual_fuel_discount?: Maybe<Scalars["numeric"]["output"]>
  early_termination_charge?: Maybe<Scalars["numeric"]["output"]>
  hh_rate_definition_id?: Maybe<Scalars["bigint"]["output"]>
  hh_rate_definition_item_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  night_rate_value?: Maybe<Scalars["numeric"]["output"]>
  online_discount?: Maybe<Scalars["numeric"]["output"]>
  product_rate_id?: Maybe<Scalars["bigint"]["output"]>
  product_variant_id?: Maybe<Scalars["bigint"]["output"]>
  tax_rate?: Maybe<Scalars["numeric"]["output"]>
}

/** order by sum() on columns of table "product_variant_elec" */
export type Product_Variant_Elec_Sum_Order_By = {
  charge_value?: InputMaybe<Order_By>
  day_rate_value?: InputMaybe<Order_By>
  dual_fuel_discount?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  hh_rate_definition_id?: InputMaybe<Order_By>
  hh_rate_definition_item_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  night_rate_value?: InputMaybe<Order_By>
  online_discount?: InputMaybe<Order_By>
  product_rate_id?: InputMaybe<Order_By>
  product_variant_id?: InputMaybe<Order_By>
  tax_rate?: InputMaybe<Order_By>
}

/** update columns of table "product_variant_elec" */
export enum Product_Variant_Elec_Update_Column {
  /** column name */
  ActiveForEnrolment = "active_for_enrolment",
  /** column name */
  ActiveForRenewal = "active_for_renewal",
  /** column name */
  ChargeUnit = "charge_unit",
  /** column name */
  ChargeValue = "charge_value",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DayRateUnit = "day_rate_unit",
  /** column name */
  DayRateValue = "day_rate_value",
  /** column name */
  Deleted = "deleted",
  /** column name */
  DirectDebit = "direct_debit",
  /** column name */
  DualFuelDiscount = "dual_fuel_discount",
  /** column name */
  EarlyTerminationCharge = "early_termination_charge",
  /** column name */
  FromDt = "from_dt",
  /** column name */
  GspGroup = "gsp_group",
  /** column name */
  HhRateDefinitionId = "hh_rate_definition_id",
  /** column name */
  HhRateDefinitionItemId = "hh_rate_definition_item_id",
  /** column name */
  Id = "id",
  /** column name */
  NightRateUnit = "night_rate_unit",
  /** column name */
  NightRateValue = "night_rate_value",
  /** column name */
  OnlineDiscount = "online_discount",
  /** column name */
  ProductRateId = "product_rate_id",
  /** column name */
  ProductVariantId = "product_variant_id",
  /** column name */
  RateType = "rate_type",
  /** column name */
  RecommendForEnrolment = "recommend_for_enrolment",
  /** column name */
  RecommendForRenewal = "recommend_for_renewal",
  /** column name */
  SalesTaxName = "sales_tax_name",
  /** column name */
  TaxRate = "tax_rate",
  /** column name */
  ToDt = "to_dt",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Product_Variant_Elec_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Variant_Elec_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Variant_Elec_Set_Input>
  /** filter the rows which have to be updated */
  where: Product_Variant_Elec_Bool_Exp
}

/** aggregate var_pop on columns */
export type Product_Variant_Elec_Var_Pop_Fields = {
  __typename?: "product_variant_elec_var_pop_fields"
  charge_value?: Maybe<Scalars["Float"]["output"]>
  day_rate_value?: Maybe<Scalars["Float"]["output"]>
  dual_fuel_discount?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  hh_rate_definition_id?: Maybe<Scalars["Float"]["output"]>
  hh_rate_definition_item_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  night_rate_value?: Maybe<Scalars["Float"]["output"]>
  online_discount?: Maybe<Scalars["Float"]["output"]>
  product_rate_id?: Maybe<Scalars["Float"]["output"]>
  product_variant_id?: Maybe<Scalars["Float"]["output"]>
  tax_rate?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "product_variant_elec" */
export type Product_Variant_Elec_Var_Pop_Order_By = {
  charge_value?: InputMaybe<Order_By>
  day_rate_value?: InputMaybe<Order_By>
  dual_fuel_discount?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  hh_rate_definition_id?: InputMaybe<Order_By>
  hh_rate_definition_item_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  night_rate_value?: InputMaybe<Order_By>
  online_discount?: InputMaybe<Order_By>
  product_rate_id?: InputMaybe<Order_By>
  product_variant_id?: InputMaybe<Order_By>
  tax_rate?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Product_Variant_Elec_Var_Samp_Fields = {
  __typename?: "product_variant_elec_var_samp_fields"
  charge_value?: Maybe<Scalars["Float"]["output"]>
  day_rate_value?: Maybe<Scalars["Float"]["output"]>
  dual_fuel_discount?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  hh_rate_definition_id?: Maybe<Scalars["Float"]["output"]>
  hh_rate_definition_item_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  night_rate_value?: Maybe<Scalars["Float"]["output"]>
  online_discount?: Maybe<Scalars["Float"]["output"]>
  product_rate_id?: Maybe<Scalars["Float"]["output"]>
  product_variant_id?: Maybe<Scalars["Float"]["output"]>
  tax_rate?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "product_variant_elec" */
export type Product_Variant_Elec_Var_Samp_Order_By = {
  charge_value?: InputMaybe<Order_By>
  day_rate_value?: InputMaybe<Order_By>
  dual_fuel_discount?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  hh_rate_definition_id?: InputMaybe<Order_By>
  hh_rate_definition_item_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  night_rate_value?: InputMaybe<Order_By>
  online_discount?: InputMaybe<Order_By>
  product_rate_id?: InputMaybe<Order_By>
  product_variant_id?: InputMaybe<Order_By>
  tax_rate?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Product_Variant_Elec_Variance_Fields = {
  __typename?: "product_variant_elec_variance_fields"
  charge_value?: Maybe<Scalars["Float"]["output"]>
  day_rate_value?: Maybe<Scalars["Float"]["output"]>
  dual_fuel_discount?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  hh_rate_definition_id?: Maybe<Scalars["Float"]["output"]>
  hh_rate_definition_item_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  night_rate_value?: Maybe<Scalars["Float"]["output"]>
  online_discount?: Maybe<Scalars["Float"]["output"]>
  product_rate_id?: Maybe<Scalars["Float"]["output"]>
  product_variant_id?: Maybe<Scalars["Float"]["output"]>
  tax_rate?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "product_variant_elec" */
export type Product_Variant_Elec_Variance_Order_By = {
  charge_value?: InputMaybe<Order_By>
  day_rate_value?: InputMaybe<Order_By>
  dual_fuel_discount?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  hh_rate_definition_id?: InputMaybe<Order_By>
  hh_rate_definition_item_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  night_rate_value?: InputMaybe<Order_By>
  online_discount?: InputMaybe<Order_By>
  product_rate_id?: InputMaybe<Order_By>
  product_variant_id?: InputMaybe<Order_By>
  tax_rate?: InputMaybe<Order_By>
}

/** columns and relationships of "product_variant_gas" */
export type Product_Variant_Gas = {
  __typename?: "product_variant_gas"
  active_for_enrolment: Scalars["Boolean"]["output"]
  active_for_renewal: Scalars["Boolean"]["output"]
  charge_unit: Scalars["price_unit"]["output"]
  charge_value: Scalars["numeric"]["output"]
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  direct_debit?: Maybe<Scalars["Boolean"]["output"]>
  dual_fuel_discount: Scalars["numeric"]["output"]
  early_termination_charge: Scalars["numeric"]["output"]
  from_dt: Scalars["date"]["output"]
  gsp_group: Scalars["String"]["output"]
  id: Scalars["bigint"]["output"]
  online_discount: Scalars["numeric"]["output"]
  /** An object relationship */
  product_variant?: Maybe<Product_Variant>
  product_variant_id?: Maybe<Scalars["bigint"]["output"]>
  rate_type?: Maybe<Scalars["product_variant_rate_type"]["output"]>
  rate_unit: Scalars["price_unit"]["output"]
  rate_value: Scalars["numeric"]["output"]
  recommend_for_enrolment: Scalars["Boolean"]["output"]
  recommend_for_renewal: Scalars["Boolean"]["output"]
  sales_tax_name?: Maybe<Scalars["String"]["output"]>
  tax_rate?: Maybe<Scalars["numeric"]["output"]>
  to_dt?: Maybe<Scalars["date"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "product_variant_gas" */
export type Product_Variant_Gas_Aggregate = {
  __typename?: "product_variant_gas_aggregate"
  aggregate?: Maybe<Product_Variant_Gas_Aggregate_Fields>
  nodes: Array<Product_Variant_Gas>
}

export type Product_Variant_Gas_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Product_Variant_Gas_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Product_Variant_Gas_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<Product_Variant_Gas_Aggregate_Bool_Exp_Count>
}

export type Product_Variant_Gas_Aggregate_Bool_Exp_Bool_And = {
  arguments: Product_Variant_Gas_Select_Column_Product_Variant_Gas_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Product_Variant_Gas_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Product_Variant_Gas_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Product_Variant_Gas_Select_Column_Product_Variant_Gas_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Product_Variant_Gas_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Product_Variant_Gas_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Product_Variant_Gas_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Product_Variant_Gas_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "product_variant_gas" */
export type Product_Variant_Gas_Aggregate_Fields = {
  __typename?: "product_variant_gas_aggregate_fields"
  avg?: Maybe<Product_Variant_Gas_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Product_Variant_Gas_Max_Fields>
  min?: Maybe<Product_Variant_Gas_Min_Fields>
  stddev?: Maybe<Product_Variant_Gas_Stddev_Fields>
  stddev_pop?: Maybe<Product_Variant_Gas_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Product_Variant_Gas_Stddev_Samp_Fields>
  sum?: Maybe<Product_Variant_Gas_Sum_Fields>
  var_pop?: Maybe<Product_Variant_Gas_Var_Pop_Fields>
  var_samp?: Maybe<Product_Variant_Gas_Var_Samp_Fields>
  variance?: Maybe<Product_Variant_Gas_Variance_Fields>
}

/** aggregate fields of "product_variant_gas" */
export type Product_Variant_Gas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Variant_Gas_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "product_variant_gas" */
export type Product_Variant_Gas_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Variant_Gas_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Product_Variant_Gas_Max_Order_By>
  min?: InputMaybe<Product_Variant_Gas_Min_Order_By>
  stddev?: InputMaybe<Product_Variant_Gas_Stddev_Order_By>
  stddev_pop?: InputMaybe<Product_Variant_Gas_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Product_Variant_Gas_Stddev_Samp_Order_By>
  sum?: InputMaybe<Product_Variant_Gas_Sum_Order_By>
  var_pop?: InputMaybe<Product_Variant_Gas_Var_Pop_Order_By>
  var_samp?: InputMaybe<Product_Variant_Gas_Var_Samp_Order_By>
  variance?: InputMaybe<Product_Variant_Gas_Variance_Order_By>
}

/** input type for inserting array relation for remote table "product_variant_gas" */
export type Product_Variant_Gas_Arr_Rel_Insert_Input = {
  data: Array<Product_Variant_Gas_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Variant_Gas_On_Conflict>
}

/** aggregate avg on columns */
export type Product_Variant_Gas_Avg_Fields = {
  __typename?: "product_variant_gas_avg_fields"
  charge_value?: Maybe<Scalars["Float"]["output"]>
  dual_fuel_discount?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  online_discount?: Maybe<Scalars["Float"]["output"]>
  product_variant_id?: Maybe<Scalars["Float"]["output"]>
  rate_value?: Maybe<Scalars["Float"]["output"]>
  tax_rate?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "product_variant_gas" */
export type Product_Variant_Gas_Avg_Order_By = {
  charge_value?: InputMaybe<Order_By>
  dual_fuel_discount?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  online_discount?: InputMaybe<Order_By>
  product_variant_id?: InputMaybe<Order_By>
  rate_value?: InputMaybe<Order_By>
  tax_rate?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "product_variant_gas". All fields are combined with a logical 'AND'. */
export type Product_Variant_Gas_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Variant_Gas_Bool_Exp>>
  _not?: InputMaybe<Product_Variant_Gas_Bool_Exp>
  _or?: InputMaybe<Array<Product_Variant_Gas_Bool_Exp>>
  active_for_enrolment?: InputMaybe<Boolean_Comparison_Exp>
  active_for_renewal?: InputMaybe<Boolean_Comparison_Exp>
  charge_unit?: InputMaybe<Price_Unit_Comparison_Exp>
  charge_value?: InputMaybe<Numeric_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  direct_debit?: InputMaybe<Boolean_Comparison_Exp>
  dual_fuel_discount?: InputMaybe<Numeric_Comparison_Exp>
  early_termination_charge?: InputMaybe<Numeric_Comparison_Exp>
  from_dt?: InputMaybe<Date_Comparison_Exp>
  gsp_group?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  online_discount?: InputMaybe<Numeric_Comparison_Exp>
  product_variant?: InputMaybe<Product_Variant_Bool_Exp>
  product_variant_id?: InputMaybe<Bigint_Comparison_Exp>
  rate_type?: InputMaybe<Product_Variant_Rate_Type_Comparison_Exp>
  rate_unit?: InputMaybe<Price_Unit_Comparison_Exp>
  rate_value?: InputMaybe<Numeric_Comparison_Exp>
  recommend_for_enrolment?: InputMaybe<Boolean_Comparison_Exp>
  recommend_for_renewal?: InputMaybe<Boolean_Comparison_Exp>
  sales_tax_name?: InputMaybe<String_Comparison_Exp>
  tax_rate?: InputMaybe<Numeric_Comparison_Exp>
  to_dt?: InputMaybe<Date_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "product_variant_gas" */
export enum Product_Variant_Gas_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkProductVariantGas = "pk_product_variant_gas",
}

/** input type for incrementing numeric columns in table "product_variant_gas" */
export type Product_Variant_Gas_Inc_Input = {
  charge_value?: InputMaybe<Scalars["numeric"]["input"]>
  dual_fuel_discount?: InputMaybe<Scalars["numeric"]["input"]>
  early_termination_charge?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  online_discount?: InputMaybe<Scalars["numeric"]["input"]>
  product_variant_id?: InputMaybe<Scalars["bigint"]["input"]>
  rate_value?: InputMaybe<Scalars["numeric"]["input"]>
  tax_rate?: InputMaybe<Scalars["numeric"]["input"]>
}

/** input type for inserting data into table "product_variant_gas" */
export type Product_Variant_Gas_Insert_Input = {
  active_for_enrolment?: InputMaybe<Scalars["Boolean"]["input"]>
  active_for_renewal?: InputMaybe<Scalars["Boolean"]["input"]>
  charge_unit?: InputMaybe<Scalars["price_unit"]["input"]>
  charge_value?: InputMaybe<Scalars["numeric"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  direct_debit?: InputMaybe<Scalars["Boolean"]["input"]>
  dual_fuel_discount?: InputMaybe<Scalars["numeric"]["input"]>
  early_termination_charge?: InputMaybe<Scalars["numeric"]["input"]>
  from_dt?: InputMaybe<Scalars["date"]["input"]>
  gsp_group?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  online_discount?: InputMaybe<Scalars["numeric"]["input"]>
  product_variant?: InputMaybe<Product_Variant_Obj_Rel_Insert_Input>
  product_variant_id?: InputMaybe<Scalars["bigint"]["input"]>
  rate_type?: InputMaybe<Scalars["product_variant_rate_type"]["input"]>
  rate_unit?: InputMaybe<Scalars["price_unit"]["input"]>
  rate_value?: InputMaybe<Scalars["numeric"]["input"]>
  recommend_for_enrolment?: InputMaybe<Scalars["Boolean"]["input"]>
  recommend_for_renewal?: InputMaybe<Scalars["Boolean"]["input"]>
  sales_tax_name?: InputMaybe<Scalars["String"]["input"]>
  tax_rate?: InputMaybe<Scalars["numeric"]["input"]>
  to_dt?: InputMaybe<Scalars["date"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Product_Variant_Gas_Max_Fields = {
  __typename?: "product_variant_gas_max_fields"
  charge_unit?: Maybe<Scalars["price_unit"]["output"]>
  charge_value?: Maybe<Scalars["numeric"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  dual_fuel_discount?: Maybe<Scalars["numeric"]["output"]>
  early_termination_charge?: Maybe<Scalars["numeric"]["output"]>
  from_dt?: Maybe<Scalars["date"]["output"]>
  gsp_group?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  online_discount?: Maybe<Scalars["numeric"]["output"]>
  product_variant_id?: Maybe<Scalars["bigint"]["output"]>
  rate_type?: Maybe<Scalars["product_variant_rate_type"]["output"]>
  rate_unit?: Maybe<Scalars["price_unit"]["output"]>
  rate_value?: Maybe<Scalars["numeric"]["output"]>
  sales_tax_name?: Maybe<Scalars["String"]["output"]>
  tax_rate?: Maybe<Scalars["numeric"]["output"]>
  to_dt?: Maybe<Scalars["date"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "product_variant_gas" */
export type Product_Variant_Gas_Max_Order_By = {
  charge_unit?: InputMaybe<Order_By>
  charge_value?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  dual_fuel_discount?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  from_dt?: InputMaybe<Order_By>
  gsp_group?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  online_discount?: InputMaybe<Order_By>
  product_variant_id?: InputMaybe<Order_By>
  rate_type?: InputMaybe<Order_By>
  rate_unit?: InputMaybe<Order_By>
  rate_value?: InputMaybe<Order_By>
  sales_tax_name?: InputMaybe<Order_By>
  tax_rate?: InputMaybe<Order_By>
  to_dt?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Product_Variant_Gas_Min_Fields = {
  __typename?: "product_variant_gas_min_fields"
  charge_unit?: Maybe<Scalars["price_unit"]["output"]>
  charge_value?: Maybe<Scalars["numeric"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  dual_fuel_discount?: Maybe<Scalars["numeric"]["output"]>
  early_termination_charge?: Maybe<Scalars["numeric"]["output"]>
  from_dt?: Maybe<Scalars["date"]["output"]>
  gsp_group?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  online_discount?: Maybe<Scalars["numeric"]["output"]>
  product_variant_id?: Maybe<Scalars["bigint"]["output"]>
  rate_type?: Maybe<Scalars["product_variant_rate_type"]["output"]>
  rate_unit?: Maybe<Scalars["price_unit"]["output"]>
  rate_value?: Maybe<Scalars["numeric"]["output"]>
  sales_tax_name?: Maybe<Scalars["String"]["output"]>
  tax_rate?: Maybe<Scalars["numeric"]["output"]>
  to_dt?: Maybe<Scalars["date"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "product_variant_gas" */
export type Product_Variant_Gas_Min_Order_By = {
  charge_unit?: InputMaybe<Order_By>
  charge_value?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  dual_fuel_discount?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  from_dt?: InputMaybe<Order_By>
  gsp_group?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  online_discount?: InputMaybe<Order_By>
  product_variant_id?: InputMaybe<Order_By>
  rate_type?: InputMaybe<Order_By>
  rate_unit?: InputMaybe<Order_By>
  rate_value?: InputMaybe<Order_By>
  sales_tax_name?: InputMaybe<Order_By>
  tax_rate?: InputMaybe<Order_By>
  to_dt?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "product_variant_gas" */
export type Product_Variant_Gas_Mutation_Response = {
  __typename?: "product_variant_gas_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Product_Variant_Gas>
}

/** on_conflict condition type for table "product_variant_gas" */
export type Product_Variant_Gas_On_Conflict = {
  constraint: Product_Variant_Gas_Constraint
  update_columns?: Array<Product_Variant_Gas_Update_Column>
  where?: InputMaybe<Product_Variant_Gas_Bool_Exp>
}

/** Ordering options when selecting data from "product_variant_gas". */
export type Product_Variant_Gas_Order_By = {
  active_for_enrolment?: InputMaybe<Order_By>
  active_for_renewal?: InputMaybe<Order_By>
  charge_unit?: InputMaybe<Order_By>
  charge_value?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  direct_debit?: InputMaybe<Order_By>
  dual_fuel_discount?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  from_dt?: InputMaybe<Order_By>
  gsp_group?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  online_discount?: InputMaybe<Order_By>
  product_variant?: InputMaybe<Product_Variant_Order_By>
  product_variant_id?: InputMaybe<Order_By>
  rate_type?: InputMaybe<Order_By>
  rate_unit?: InputMaybe<Order_By>
  rate_value?: InputMaybe<Order_By>
  recommend_for_enrolment?: InputMaybe<Order_By>
  recommend_for_renewal?: InputMaybe<Order_By>
  sales_tax_name?: InputMaybe<Order_By>
  tax_rate?: InputMaybe<Order_By>
  to_dt?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: product_variant_gas */
export type Product_Variant_Gas_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "product_variant_gas" */
export enum Product_Variant_Gas_Select_Column {
  /** column name */
  ActiveForEnrolment = "active_for_enrolment",
  /** column name */
  ActiveForRenewal = "active_for_renewal",
  /** column name */
  ChargeUnit = "charge_unit",
  /** column name */
  ChargeValue = "charge_value",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  DirectDebit = "direct_debit",
  /** column name */
  DualFuelDiscount = "dual_fuel_discount",
  /** column name */
  EarlyTerminationCharge = "early_termination_charge",
  /** column name */
  FromDt = "from_dt",
  /** column name */
  GspGroup = "gsp_group",
  /** column name */
  Id = "id",
  /** column name */
  OnlineDiscount = "online_discount",
  /** column name */
  ProductVariantId = "product_variant_id",
  /** column name */
  RateType = "rate_type",
  /** column name */
  RateUnit = "rate_unit",
  /** column name */
  RateValue = "rate_value",
  /** column name */
  RecommendForEnrolment = "recommend_for_enrolment",
  /** column name */
  RecommendForRenewal = "recommend_for_renewal",
  /** column name */
  SalesTaxName = "sales_tax_name",
  /** column name */
  TaxRate = "tax_rate",
  /** column name */
  ToDt = "to_dt",
  /** column name */
  UpdatedAt = "updated_at",
}

/** select "product_variant_gas_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product_variant_gas" */
export enum Product_Variant_Gas_Select_Column_Product_Variant_Gas_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ActiveForEnrolment = "active_for_enrolment",
  /** column name */
  ActiveForRenewal = "active_for_renewal",
  /** column name */
  DirectDebit = "direct_debit",
  /** column name */
  RecommendForEnrolment = "recommend_for_enrolment",
  /** column name */
  RecommendForRenewal = "recommend_for_renewal",
}

/** select "product_variant_gas_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product_variant_gas" */
export enum Product_Variant_Gas_Select_Column_Product_Variant_Gas_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ActiveForEnrolment = "active_for_enrolment",
  /** column name */
  ActiveForRenewal = "active_for_renewal",
  /** column name */
  DirectDebit = "direct_debit",
  /** column name */
  RecommendForEnrolment = "recommend_for_enrolment",
  /** column name */
  RecommendForRenewal = "recommend_for_renewal",
}

/** input type for updating data in table "product_variant_gas" */
export type Product_Variant_Gas_Set_Input = {
  active_for_enrolment?: InputMaybe<Scalars["Boolean"]["input"]>
  active_for_renewal?: InputMaybe<Scalars["Boolean"]["input"]>
  charge_unit?: InputMaybe<Scalars["price_unit"]["input"]>
  charge_value?: InputMaybe<Scalars["numeric"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  direct_debit?: InputMaybe<Scalars["Boolean"]["input"]>
  dual_fuel_discount?: InputMaybe<Scalars["numeric"]["input"]>
  early_termination_charge?: InputMaybe<Scalars["numeric"]["input"]>
  from_dt?: InputMaybe<Scalars["date"]["input"]>
  gsp_group?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  online_discount?: InputMaybe<Scalars["numeric"]["input"]>
  product_variant_id?: InputMaybe<Scalars["bigint"]["input"]>
  rate_type?: InputMaybe<Scalars["product_variant_rate_type"]["input"]>
  rate_unit?: InputMaybe<Scalars["price_unit"]["input"]>
  rate_value?: InputMaybe<Scalars["numeric"]["input"]>
  recommend_for_enrolment?: InputMaybe<Scalars["Boolean"]["input"]>
  recommend_for_renewal?: InputMaybe<Scalars["Boolean"]["input"]>
  sales_tax_name?: InputMaybe<Scalars["String"]["input"]>
  tax_rate?: InputMaybe<Scalars["numeric"]["input"]>
  to_dt?: InputMaybe<Scalars["date"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Product_Variant_Gas_Stddev_Fields = {
  __typename?: "product_variant_gas_stddev_fields"
  charge_value?: Maybe<Scalars["Float"]["output"]>
  dual_fuel_discount?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  online_discount?: Maybe<Scalars["Float"]["output"]>
  product_variant_id?: Maybe<Scalars["Float"]["output"]>
  rate_value?: Maybe<Scalars["Float"]["output"]>
  tax_rate?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "product_variant_gas" */
export type Product_Variant_Gas_Stddev_Order_By = {
  charge_value?: InputMaybe<Order_By>
  dual_fuel_discount?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  online_discount?: InputMaybe<Order_By>
  product_variant_id?: InputMaybe<Order_By>
  rate_value?: InputMaybe<Order_By>
  tax_rate?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Product_Variant_Gas_Stddev_Pop_Fields = {
  __typename?: "product_variant_gas_stddev_pop_fields"
  charge_value?: Maybe<Scalars["Float"]["output"]>
  dual_fuel_discount?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  online_discount?: Maybe<Scalars["Float"]["output"]>
  product_variant_id?: Maybe<Scalars["Float"]["output"]>
  rate_value?: Maybe<Scalars["Float"]["output"]>
  tax_rate?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "product_variant_gas" */
export type Product_Variant_Gas_Stddev_Pop_Order_By = {
  charge_value?: InputMaybe<Order_By>
  dual_fuel_discount?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  online_discount?: InputMaybe<Order_By>
  product_variant_id?: InputMaybe<Order_By>
  rate_value?: InputMaybe<Order_By>
  tax_rate?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Product_Variant_Gas_Stddev_Samp_Fields = {
  __typename?: "product_variant_gas_stddev_samp_fields"
  charge_value?: Maybe<Scalars["Float"]["output"]>
  dual_fuel_discount?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  online_discount?: Maybe<Scalars["Float"]["output"]>
  product_variant_id?: Maybe<Scalars["Float"]["output"]>
  rate_value?: Maybe<Scalars["Float"]["output"]>
  tax_rate?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "product_variant_gas" */
export type Product_Variant_Gas_Stddev_Samp_Order_By = {
  charge_value?: InputMaybe<Order_By>
  dual_fuel_discount?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  online_discount?: InputMaybe<Order_By>
  product_variant_id?: InputMaybe<Order_By>
  rate_value?: InputMaybe<Order_By>
  tax_rate?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "product_variant_gas" */
export type Product_Variant_Gas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Variant_Gas_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Product_Variant_Gas_Stream_Cursor_Value_Input = {
  active_for_enrolment?: InputMaybe<Scalars["Boolean"]["input"]>
  active_for_renewal?: InputMaybe<Scalars["Boolean"]["input"]>
  charge_unit?: InputMaybe<Scalars["price_unit"]["input"]>
  charge_value?: InputMaybe<Scalars["numeric"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  direct_debit?: InputMaybe<Scalars["Boolean"]["input"]>
  dual_fuel_discount?: InputMaybe<Scalars["numeric"]["input"]>
  early_termination_charge?: InputMaybe<Scalars["numeric"]["input"]>
  from_dt?: InputMaybe<Scalars["date"]["input"]>
  gsp_group?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  online_discount?: InputMaybe<Scalars["numeric"]["input"]>
  product_variant_id?: InputMaybe<Scalars["bigint"]["input"]>
  rate_type?: InputMaybe<Scalars["product_variant_rate_type"]["input"]>
  rate_unit?: InputMaybe<Scalars["price_unit"]["input"]>
  rate_value?: InputMaybe<Scalars["numeric"]["input"]>
  recommend_for_enrolment?: InputMaybe<Scalars["Boolean"]["input"]>
  recommend_for_renewal?: InputMaybe<Scalars["Boolean"]["input"]>
  sales_tax_name?: InputMaybe<Scalars["String"]["input"]>
  tax_rate?: InputMaybe<Scalars["numeric"]["input"]>
  to_dt?: InputMaybe<Scalars["date"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Product_Variant_Gas_Sum_Fields = {
  __typename?: "product_variant_gas_sum_fields"
  charge_value?: Maybe<Scalars["numeric"]["output"]>
  dual_fuel_discount?: Maybe<Scalars["numeric"]["output"]>
  early_termination_charge?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  online_discount?: Maybe<Scalars["numeric"]["output"]>
  product_variant_id?: Maybe<Scalars["bigint"]["output"]>
  rate_value?: Maybe<Scalars["numeric"]["output"]>
  tax_rate?: Maybe<Scalars["numeric"]["output"]>
}

/** order by sum() on columns of table "product_variant_gas" */
export type Product_Variant_Gas_Sum_Order_By = {
  charge_value?: InputMaybe<Order_By>
  dual_fuel_discount?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  online_discount?: InputMaybe<Order_By>
  product_variant_id?: InputMaybe<Order_By>
  rate_value?: InputMaybe<Order_By>
  tax_rate?: InputMaybe<Order_By>
}

/** update columns of table "product_variant_gas" */
export enum Product_Variant_Gas_Update_Column {
  /** column name */
  ActiveForEnrolment = "active_for_enrolment",
  /** column name */
  ActiveForRenewal = "active_for_renewal",
  /** column name */
  ChargeUnit = "charge_unit",
  /** column name */
  ChargeValue = "charge_value",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  DirectDebit = "direct_debit",
  /** column name */
  DualFuelDiscount = "dual_fuel_discount",
  /** column name */
  EarlyTerminationCharge = "early_termination_charge",
  /** column name */
  FromDt = "from_dt",
  /** column name */
  GspGroup = "gsp_group",
  /** column name */
  Id = "id",
  /** column name */
  OnlineDiscount = "online_discount",
  /** column name */
  ProductVariantId = "product_variant_id",
  /** column name */
  RateType = "rate_type",
  /** column name */
  RateUnit = "rate_unit",
  /** column name */
  RateValue = "rate_value",
  /** column name */
  RecommendForEnrolment = "recommend_for_enrolment",
  /** column name */
  RecommendForRenewal = "recommend_for_renewal",
  /** column name */
  SalesTaxName = "sales_tax_name",
  /** column name */
  TaxRate = "tax_rate",
  /** column name */
  ToDt = "to_dt",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Product_Variant_Gas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Variant_Gas_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Variant_Gas_Set_Input>
  /** filter the rows which have to be updated */
  where: Product_Variant_Gas_Bool_Exp
}

/** aggregate var_pop on columns */
export type Product_Variant_Gas_Var_Pop_Fields = {
  __typename?: "product_variant_gas_var_pop_fields"
  charge_value?: Maybe<Scalars["Float"]["output"]>
  dual_fuel_discount?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  online_discount?: Maybe<Scalars["Float"]["output"]>
  product_variant_id?: Maybe<Scalars["Float"]["output"]>
  rate_value?: Maybe<Scalars["Float"]["output"]>
  tax_rate?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "product_variant_gas" */
export type Product_Variant_Gas_Var_Pop_Order_By = {
  charge_value?: InputMaybe<Order_By>
  dual_fuel_discount?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  online_discount?: InputMaybe<Order_By>
  product_variant_id?: InputMaybe<Order_By>
  rate_value?: InputMaybe<Order_By>
  tax_rate?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Product_Variant_Gas_Var_Samp_Fields = {
  __typename?: "product_variant_gas_var_samp_fields"
  charge_value?: Maybe<Scalars["Float"]["output"]>
  dual_fuel_discount?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  online_discount?: Maybe<Scalars["Float"]["output"]>
  product_variant_id?: Maybe<Scalars["Float"]["output"]>
  rate_value?: Maybe<Scalars["Float"]["output"]>
  tax_rate?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "product_variant_gas" */
export type Product_Variant_Gas_Var_Samp_Order_By = {
  charge_value?: InputMaybe<Order_By>
  dual_fuel_discount?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  online_discount?: InputMaybe<Order_By>
  product_variant_id?: InputMaybe<Order_By>
  rate_value?: InputMaybe<Order_By>
  tax_rate?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Product_Variant_Gas_Variance_Fields = {
  __typename?: "product_variant_gas_variance_fields"
  charge_value?: Maybe<Scalars["Float"]["output"]>
  dual_fuel_discount?: Maybe<Scalars["Float"]["output"]>
  early_termination_charge?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  online_discount?: Maybe<Scalars["Float"]["output"]>
  product_variant_id?: Maybe<Scalars["Float"]["output"]>
  rate_value?: Maybe<Scalars["Float"]["output"]>
  tax_rate?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "product_variant_gas" */
export type Product_Variant_Gas_Variance_Order_By = {
  charge_value?: InputMaybe<Order_By>
  dual_fuel_discount?: InputMaybe<Order_By>
  early_termination_charge?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  online_discount?: InputMaybe<Order_By>
  product_variant_id?: InputMaybe<Order_By>
  rate_value?: InputMaybe<Order_By>
  tax_rate?: InputMaybe<Order_By>
}

/** input type for incrementing numeric columns in table "product_variant" */
export type Product_Variant_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  product_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "product_variant" */
export type Product_Variant_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>
  product_id?: InputMaybe<Scalars["bigint"]["input"]>
  product_variant_elecs?: InputMaybe<Product_Variant_Elec_Arr_Rel_Insert_Input>
  product_variant_gas?: InputMaybe<Product_Variant_Gas_Arr_Rel_Insert_Input>
  type?: InputMaybe<Scalars["product_variant_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Product_Variant_Max_Fields = {
  __typename?: "product_variant_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  product_id?: Maybe<Scalars["bigint"]["output"]>
  type?: Maybe<Scalars["product_variant_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "product_variant" */
export type Product_Variant_Max_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  product_id?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Product_Variant_Min_Fields = {
  __typename?: "product_variant_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  product_id?: Maybe<Scalars["bigint"]["output"]>
  type?: Maybe<Scalars["product_variant_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "product_variant" */
export type Product_Variant_Min_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  product_id?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "product_variant" */
export type Product_Variant_Mutation_Response = {
  __typename?: "product_variant_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Product_Variant>
}

/** input type for inserting object relation for remote table "product_variant" */
export type Product_Variant_Obj_Rel_Insert_Input = {
  data: Product_Variant_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Variant_On_Conflict>
}

/** on_conflict condition type for table "product_variant" */
export type Product_Variant_On_Conflict = {
  constraint: Product_Variant_Constraint
  update_columns?: Array<Product_Variant_Update_Column>
  where?: InputMaybe<Product_Variant_Bool_Exp>
}

/** Ordering options when selecting data from "product_variant". */
export type Product_Variant_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  product?: InputMaybe<Product_Order_By>
  product_id?: InputMaybe<Order_By>
  product_variant_elecs_aggregate?: InputMaybe<Product_Variant_Elec_Aggregate_Order_By>
  product_variant_gas_aggregate?: InputMaybe<Product_Variant_Gas_Aggregate_Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: product_variant */
export type Product_Variant_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** Boolean expression to compare columns of type "product_variant_rate_type". All fields are combined with logical 'AND'. */
export type Product_Variant_Rate_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["product_variant_rate_type"]["input"]>
  _gt?: InputMaybe<Scalars["product_variant_rate_type"]["input"]>
  _gte?: InputMaybe<Scalars["product_variant_rate_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["product_variant_rate_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["product_variant_rate_type"]["input"]>
  _lte?: InputMaybe<Scalars["product_variant_rate_type"]["input"]>
  _neq?: InputMaybe<Scalars["product_variant_rate_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["product_variant_rate_type"]["input"]>>
}

/** select columns of table "product_variant" */
export enum Product_Variant_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  ProductId = "product_id",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "product_variant" */
export type Product_Variant_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  product_id?: InputMaybe<Scalars["bigint"]["input"]>
  type?: InputMaybe<Scalars["product_variant_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Product_Variant_Stddev_Fields = {
  __typename?: "product_variant_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  product_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "product_variant" */
export type Product_Variant_Stddev_Order_By = {
  id?: InputMaybe<Order_By>
  product_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Product_Variant_Stddev_Pop_Fields = {
  __typename?: "product_variant_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  product_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "product_variant" */
export type Product_Variant_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>
  product_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Product_Variant_Stddev_Samp_Fields = {
  __typename?: "product_variant_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  product_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "product_variant" */
export type Product_Variant_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>
  product_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "product_variant" */
export type Product_Variant_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Variant_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Product_Variant_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  product_id?: InputMaybe<Scalars["bigint"]["input"]>
  type?: InputMaybe<Scalars["product_variant_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Product_Variant_Sum_Fields = {
  __typename?: "product_variant_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  product_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "product_variant" */
export type Product_Variant_Sum_Order_By = {
  id?: InputMaybe<Order_By>
  product_id?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "product_variant_type". All fields are combined with logical 'AND'. */
export type Product_Variant_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["product_variant_type"]["input"]>
  _gt?: InputMaybe<Scalars["product_variant_type"]["input"]>
  _gte?: InputMaybe<Scalars["product_variant_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["product_variant_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["product_variant_type"]["input"]>
  _lte?: InputMaybe<Scalars["product_variant_type"]["input"]>
  _neq?: InputMaybe<Scalars["product_variant_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["product_variant_type"]["input"]>>
}

/** update columns of table "product_variant" */
export enum Product_Variant_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  ProductId = "product_id",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Product_Variant_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Variant_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Variant_Set_Input>
  /** filter the rows which have to be updated */
  where: Product_Variant_Bool_Exp
}

/** aggregate var_pop on columns */
export type Product_Variant_Var_Pop_Fields = {
  __typename?: "product_variant_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  product_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "product_variant" */
export type Product_Variant_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>
  product_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Product_Variant_Var_Samp_Fields = {
  __typename?: "product_variant_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  product_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "product_variant" */
export type Product_Variant_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>
  product_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Product_Variant_Variance_Fields = {
  __typename?: "product_variant_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  product_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "product_variant" */
export type Product_Variant_Variance_Order_By = {
  id?: InputMaybe<Order_By>
  product_id?: InputMaybe<Order_By>
}

/** columns and relationships of "product_view" */
export type Product_View = {
  __typename?: "product_view"
  active_for_enrolment?: Maybe<Scalars["Boolean"]["output"]>
  active_for_renewal?: Maybe<Scalars["Boolean"]["output"]>
  available_to_public?: Maybe<Scalars["Boolean"]["output"]>
  code?: Maybe<Scalars["String"]["output"]>
  direct_debit?: Maybe<Scalars["Boolean"]["output"]>
  display_name?: Maybe<Scalars["String"]["output"]>
  duration_frequency?: Maybe<Scalars["frequency"]["output"]>
  duration_value?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  recommend_for_enrolment?: Maybe<Scalars["Boolean"]["output"]>
  recommend_for_renewal?: Maybe<Scalars["Boolean"]["output"]>
  requires_smart_charging?: Maybe<Scalars["Boolean"]["output"]>
}

/** aggregated selection of "product_view" */
export type Product_View_Aggregate = {
  __typename?: "product_view_aggregate"
  aggregate?: Maybe<Product_View_Aggregate_Fields>
  nodes: Array<Product_View>
}

/** aggregate fields of "product_view" */
export type Product_View_Aggregate_Fields = {
  __typename?: "product_view_aggregate_fields"
  avg?: Maybe<Product_View_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Product_View_Max_Fields>
  min?: Maybe<Product_View_Min_Fields>
  stddev?: Maybe<Product_View_Stddev_Fields>
  stddev_pop?: Maybe<Product_View_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Product_View_Stddev_Samp_Fields>
  sum?: Maybe<Product_View_Sum_Fields>
  var_pop?: Maybe<Product_View_Var_Pop_Fields>
  var_samp?: Maybe<Product_View_Var_Samp_Fields>
  variance?: Maybe<Product_View_Variance_Fields>
}

/** aggregate fields of "product_view" */
export type Product_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_View_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Product_View_Avg_Fields = {
  __typename?: "product_view_avg_fields"
  duration_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "product_view". All fields are combined with a logical 'AND'. */
export type Product_View_Bool_Exp = {
  _and?: InputMaybe<Array<Product_View_Bool_Exp>>
  _not?: InputMaybe<Product_View_Bool_Exp>
  _or?: InputMaybe<Array<Product_View_Bool_Exp>>
  active_for_enrolment?: InputMaybe<Boolean_Comparison_Exp>
  active_for_renewal?: InputMaybe<Boolean_Comparison_Exp>
  available_to_public?: InputMaybe<Boolean_Comparison_Exp>
  code?: InputMaybe<String_Comparison_Exp>
  direct_debit?: InputMaybe<Boolean_Comparison_Exp>
  display_name?: InputMaybe<String_Comparison_Exp>
  duration_frequency?: InputMaybe<Frequency_Comparison_Exp>
  duration_value?: InputMaybe<Int_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  recommend_for_enrolment?: InputMaybe<Boolean_Comparison_Exp>
  recommend_for_renewal?: InputMaybe<Boolean_Comparison_Exp>
  requires_smart_charging?: InputMaybe<Boolean_Comparison_Exp>
}

/** aggregate max on columns */
export type Product_View_Max_Fields = {
  __typename?: "product_view_max_fields"
  code?: Maybe<Scalars["String"]["output"]>
  display_name?: Maybe<Scalars["String"]["output"]>
  duration_frequency?: Maybe<Scalars["frequency"]["output"]>
  duration_value?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Product_View_Min_Fields = {
  __typename?: "product_view_min_fields"
  code?: Maybe<Scalars["String"]["output"]>
  display_name?: Maybe<Scalars["String"]["output"]>
  duration_frequency?: Maybe<Scalars["frequency"]["output"]>
  duration_value?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
}

/** Ordering options when selecting data from "product_view". */
export type Product_View_Order_By = {
  active_for_enrolment?: InputMaybe<Order_By>
  active_for_renewal?: InputMaybe<Order_By>
  available_to_public?: InputMaybe<Order_By>
  code?: InputMaybe<Order_By>
  direct_debit?: InputMaybe<Order_By>
  display_name?: InputMaybe<Order_By>
  duration_frequency?: InputMaybe<Order_By>
  duration_value?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  recommend_for_enrolment?: InputMaybe<Order_By>
  recommend_for_renewal?: InputMaybe<Order_By>
  requires_smart_charging?: InputMaybe<Order_By>
}

/** select columns of table "product_view" */
export enum Product_View_Select_Column {
  /** column name */
  ActiveForEnrolment = "active_for_enrolment",
  /** column name */
  ActiveForRenewal = "active_for_renewal",
  /** column name */
  AvailableToPublic = "available_to_public",
  /** column name */
  Code = "code",
  /** column name */
  DirectDebit = "direct_debit",
  /** column name */
  DisplayName = "display_name",
  /** column name */
  DurationFrequency = "duration_frequency",
  /** column name */
  DurationValue = "duration_value",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  RecommendForEnrolment = "recommend_for_enrolment",
  /** column name */
  RecommendForRenewal = "recommend_for_renewal",
  /** column name */
  RequiresSmartCharging = "requires_smart_charging",
}

/** aggregate stddev on columns */
export type Product_View_Stddev_Fields = {
  __typename?: "product_view_stddev_fields"
  duration_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Product_View_Stddev_Pop_Fields = {
  __typename?: "product_view_stddev_pop_fields"
  duration_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Product_View_Stddev_Samp_Fields = {
  __typename?: "product_view_stddev_samp_fields"
  duration_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "product_view" */
export type Product_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_View_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Product_View_Stream_Cursor_Value_Input = {
  active_for_enrolment?: InputMaybe<Scalars["Boolean"]["input"]>
  active_for_renewal?: InputMaybe<Scalars["Boolean"]["input"]>
  available_to_public?: InputMaybe<Scalars["Boolean"]["input"]>
  code?: InputMaybe<Scalars["String"]["input"]>
  direct_debit?: InputMaybe<Scalars["Boolean"]["input"]>
  display_name?: InputMaybe<Scalars["String"]["input"]>
  duration_frequency?: InputMaybe<Scalars["frequency"]["input"]>
  duration_value?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  recommend_for_enrolment?: InputMaybe<Scalars["Boolean"]["input"]>
  recommend_for_renewal?: InputMaybe<Scalars["Boolean"]["input"]>
  requires_smart_charging?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate sum on columns */
export type Product_View_Sum_Fields = {
  __typename?: "product_view_sum_fields"
  duration_value?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregate var_pop on columns */
export type Product_View_Var_Pop_Fields = {
  __typename?: "product_view_var_pop_fields"
  duration_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Product_View_Var_Samp_Fields = {
  __typename?: "product_view_var_samp_fields"
  duration_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Product_View_Variance_Fields = {
  __typename?: "product_view_variance_fields"
  duration_value?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "property" */
export type Property = {
  __typename?: "property"
  /** An object relationship */
  address: Address
  address_id: Scalars["bigint"]["output"]
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  identifier?: Maybe<Scalars["String"]["output"]>
  /** An array relationship */
  meter_points: Array<Meter_Point>
  /** An aggregate relationship */
  meter_points_aggregate: Meter_Point_Aggregate
  type: Scalars["property_type"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "property" */
export type PropertyMeter_PointsArgs = {
  distinct_on?: InputMaybe<Array<Meter_Point_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Point_Order_By>>
  where?: InputMaybe<Meter_Point_Bool_Exp>
}

/** columns and relationships of "property" */
export type PropertyMeter_Points_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Point_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Point_Order_By>>
  where?: InputMaybe<Meter_Point_Bool_Exp>
}

/** aggregated selection of "property" */
export type Property_Aggregate = {
  __typename?: "property_aggregate"
  aggregate?: Maybe<Property_Aggregate_Fields>
  nodes: Array<Property>
}

export type Property_Aggregate_Bool_Exp = {
  count?: InputMaybe<Property_Aggregate_Bool_Exp_Count>
}

export type Property_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Property_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "property" */
export type Property_Aggregate_Fields = {
  __typename?: "property_aggregate_fields"
  avg?: Maybe<Property_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Property_Max_Fields>
  min?: Maybe<Property_Min_Fields>
  stddev?: Maybe<Property_Stddev_Fields>
  stddev_pop?: Maybe<Property_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Property_Stddev_Samp_Fields>
  sum?: Maybe<Property_Sum_Fields>
  var_pop?: Maybe<Property_Var_Pop_Fields>
  var_samp?: Maybe<Property_Var_Samp_Fields>
  variance?: Maybe<Property_Variance_Fields>
}

/** aggregate fields of "property" */
export type Property_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "property" */
export type Property_Aggregate_Order_By = {
  avg?: InputMaybe<Property_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Property_Max_Order_By>
  min?: InputMaybe<Property_Min_Order_By>
  stddev?: InputMaybe<Property_Stddev_Order_By>
  stddev_pop?: InputMaybe<Property_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Property_Stddev_Samp_Order_By>
  sum?: InputMaybe<Property_Sum_Order_By>
  var_pop?: InputMaybe<Property_Var_Pop_Order_By>
  var_samp?: InputMaybe<Property_Var_Samp_Order_By>
  variance?: InputMaybe<Property_Variance_Order_By>
}

/** input type for inserting array relation for remote table "property" */
export type Property_Arr_Rel_Insert_Input = {
  data: Array<Property_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Property_On_Conflict>
}

/** aggregate avg on columns */
export type Property_Avg_Fields = {
  __typename?: "property_avg_fields"
  address_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "property" */
export type Property_Avg_Order_By = {
  address_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "property". All fields are combined with a logical 'AND'. */
export type Property_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Bool_Exp>>
  _not?: InputMaybe<Property_Bool_Exp>
  _or?: InputMaybe<Array<Property_Bool_Exp>>
  address?: InputMaybe<Address_Bool_Exp>
  address_id?: InputMaybe<Bigint_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  identifier?: InputMaybe<String_Comparison_Exp>
  meter_points?: InputMaybe<Meter_Point_Bool_Exp>
  meter_points_aggregate?: InputMaybe<Meter_Point_Aggregate_Bool_Exp>
  type?: InputMaybe<Property_Type_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "property" */
export enum Property_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkProperty = "pk_property",
}

/** input type for incrementing numeric columns in table "property" */
export type Property_Inc_Input = {
  address_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "property" */
export type Property_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>
  address_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  identifier?: InputMaybe<Scalars["String"]["input"]>
  meter_points?: InputMaybe<Meter_Point_Arr_Rel_Insert_Input>
  type?: InputMaybe<Scalars["property_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Property_Max_Fields = {
  __typename?: "property_max_fields"
  address_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  identifier?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["property_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "property" */
export type Property_Max_Order_By = {
  address_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  identifier?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Property_Min_Fields = {
  __typename?: "property_min_fields"
  address_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  identifier?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["property_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "property" */
export type Property_Min_Order_By = {
  address_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  identifier?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "property" */
export type Property_Mutation_Response = {
  __typename?: "property_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Property>
}

/** input type for inserting object relation for remote table "property" */
export type Property_Obj_Rel_Insert_Input = {
  data: Property_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Property_On_Conflict>
}

/** on_conflict condition type for table "property" */
export type Property_On_Conflict = {
  constraint: Property_Constraint
  update_columns?: Array<Property_Update_Column>
  where?: InputMaybe<Property_Bool_Exp>
}

/** Ordering options when selecting data from "property". */
export type Property_Order_By = {
  address?: InputMaybe<Address_Order_By>
  address_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  identifier?: InputMaybe<Order_By>
  meter_points_aggregate?: InputMaybe<Meter_Point_Aggregate_Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: property */
export type Property_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "property" */
export enum Property_Select_Column {
  /** column name */
  AddressId = "address_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  Identifier = "identifier",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "property" */
export type Property_Set_Input = {
  address_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  identifier?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["property_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Property_Stddev_Fields = {
  __typename?: "property_stddev_fields"
  address_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "property" */
export type Property_Stddev_Order_By = {
  address_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Property_Stddev_Pop_Fields = {
  __typename?: "property_stddev_pop_fields"
  address_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "property" */
export type Property_Stddev_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Property_Stddev_Samp_Fields = {
  __typename?: "property_stddev_samp_fields"
  address_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "property" */
export type Property_Stddev_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "property" */
export type Property_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Property_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  identifier?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["property_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Property_Sum_Fields = {
  __typename?: "property_sum_fields"
  address_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "property" */
export type Property_Sum_Order_By = {
  address_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "property_type". All fields are combined with logical 'AND'. */
export type Property_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["property_type"]["input"]>
  _gt?: InputMaybe<Scalars["property_type"]["input"]>
  _gte?: InputMaybe<Scalars["property_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["property_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["property_type"]["input"]>
  _lte?: InputMaybe<Scalars["property_type"]["input"]>
  _neq?: InputMaybe<Scalars["property_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["property_type"]["input"]>>
}

/** update columns of table "property" */
export enum Property_Update_Column {
  /** column name */
  AddressId = "address_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  Identifier = "identifier",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Property_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Set_Input>
  /** filter the rows which have to be updated */
  where: Property_Bool_Exp
}

/** aggregate var_pop on columns */
export type Property_Var_Pop_Fields = {
  __typename?: "property_var_pop_fields"
  address_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "property" */
export type Property_Var_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Property_Var_Samp_Fields = {
  __typename?: "property_var_samp_fields"
  address_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "property" */
export type Property_Var_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Property_Variance_Fields = {
  __typename?: "property_variance_fields"
  address_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "property" */
export type Property_Variance_Order_By = {
  address_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** columns and relationships of "psr" */
export type Psr = {
  __typename?: "psr"
  code_elec?: Maybe<Scalars["String"]["output"]>
  code_gas?: Maybe<Scalars["String"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  expirable?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["bigint"]["output"]
  name: Scalars["String"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "psr" */
export type Psr_Aggregate = {
  __typename?: "psr_aggregate"
  aggregate?: Maybe<Psr_Aggregate_Fields>
  nodes: Array<Psr>
}

/** aggregate fields of "psr" */
export type Psr_Aggregate_Fields = {
  __typename?: "psr_aggregate_fields"
  avg?: Maybe<Psr_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Psr_Max_Fields>
  min?: Maybe<Psr_Min_Fields>
  stddev?: Maybe<Psr_Stddev_Fields>
  stddev_pop?: Maybe<Psr_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Psr_Stddev_Samp_Fields>
  sum?: Maybe<Psr_Sum_Fields>
  var_pop?: Maybe<Psr_Var_Pop_Fields>
  var_samp?: Maybe<Psr_Var_Samp_Fields>
  variance?: Maybe<Psr_Variance_Fields>
}

/** aggregate fields of "psr" */
export type Psr_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Psr_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Psr_Avg_Fields = {
  __typename?: "psr_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "psr". All fields are combined with a logical 'AND'. */
export type Psr_Bool_Exp = {
  _and?: InputMaybe<Array<Psr_Bool_Exp>>
  _not?: InputMaybe<Psr_Bool_Exp>
  _or?: InputMaybe<Array<Psr_Bool_Exp>>
  code_elec?: InputMaybe<String_Comparison_Exp>
  code_gas?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  expirable?: InputMaybe<Boolean_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "psr" */
export enum Psr_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkPsr = "pk_psr",
  /** unique or primary key constraint on columns "name" */
  UqPsrName = "uq_psr_name",
}

/** input type for incrementing numeric columns in table "psr" */
export type Psr_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "psr" */
export type Psr_Insert_Input = {
  code_elec?: InputMaybe<Scalars["String"]["input"]>
  code_gas?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  expirable?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Psr_Max_Fields = {
  __typename?: "psr_max_fields"
  code_elec?: Maybe<Scalars["String"]["output"]>
  code_gas?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Psr_Min_Fields = {
  __typename?: "psr_min_fields"
  code_elec?: Maybe<Scalars["String"]["output"]>
  code_gas?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "psr" */
export type Psr_Mutation_Response = {
  __typename?: "psr_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Psr>
}

/** on_conflict condition type for table "psr" */
export type Psr_On_Conflict = {
  constraint: Psr_Constraint
  update_columns?: Array<Psr_Update_Column>
  where?: InputMaybe<Psr_Bool_Exp>
}

/** Ordering options when selecting data from "psr". */
export type Psr_Order_By = {
  code_elec?: InputMaybe<Order_By>
  code_gas?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  expirable?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: psr */
export type Psr_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "psr" */
export enum Psr_Select_Column {
  /** column name */
  CodeElec = "code_elec",
  /** column name */
  CodeGas = "code_gas",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Expirable = "expirable",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "psr" */
export type Psr_Set_Input = {
  code_elec?: InputMaybe<Scalars["String"]["input"]>
  code_gas?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  expirable?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Psr_Stddev_Fields = {
  __typename?: "psr_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Psr_Stddev_Pop_Fields = {
  __typename?: "psr_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Psr_Stddev_Samp_Fields = {
  __typename?: "psr_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "psr" */
export type Psr_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Psr_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Psr_Stream_Cursor_Value_Input = {
  code_elec?: InputMaybe<Scalars["String"]["input"]>
  code_gas?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  expirable?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Psr_Sum_Fields = {
  __typename?: "psr_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "psr" */
export enum Psr_Update_Column {
  /** column name */
  CodeElec = "code_elec",
  /** column name */
  CodeGas = "code_gas",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Expirable = "expirable",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Psr_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Psr_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Psr_Set_Input>
  /** filter the rows which have to be updated */
  where: Psr_Bool_Exp
}

/** aggregate var_pop on columns */
export type Psr_Var_Pop_Fields = {
  __typename?: "psr_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Psr_Var_Samp_Fields = {
  __typename?: "psr_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Psr_Variance_Fields = {
  __typename?: "psr_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

export type Query_Root = {
  __typename?: "query_root"
  /** fetch data from the table: "ElecNominations" */
  ElecNominations: Array<ElecNominations>
  /** fetch aggregated fields from the table: "ElecNominations" */
  ElecNominations_aggregate: ElecNominations_Aggregate
  /** fetch data from the table: "ElecTrades" */
  ElecTrades: Array<ElecTrades>
  /** fetch data from the table: "ElecTradesHistory" */
  ElecTradesHistory: Array<ElecTradesHistory>
  /** fetch aggregated fields from the table: "ElecTradesHistory" */
  ElecTradesHistory_aggregate: ElecTradesHistory_Aggregate
  /** fetch data from the table: "ElecTradesHistory" using primary key columns */
  ElecTradesHistory_by_pk?: Maybe<ElecTradesHistory>
  /** fetch aggregated fields from the table: "ElecTrades" */
  ElecTrades_aggregate: ElecTrades_Aggregate
  /** fetch data from the table: "ElecTrades" using primary key columns */
  ElecTrades_by_pk?: Maybe<ElecTrades>
  /** fetch data from the table: "GasTrades" */
  GasTrades: Array<GasTrades>
  /** fetch data from the table: "GasTradesHistory" */
  GasTradesHistory: Array<GasTradesHistory>
  /** fetch aggregated fields from the table: "GasTradesHistory" */
  GasTradesHistory_aggregate: GasTradesHistory_Aggregate
  /** fetch data from the table: "GasTradesHistory" using primary key columns */
  GasTradesHistory_by_pk?: Maybe<GasTradesHistory>
  /** fetch aggregated fields from the table: "GasTrades" */
  GasTrades_aggregate: GasTrades_Aggregate
  /** fetch data from the table: "GasTrades" using primary key columns */
  GasTrades_by_pk?: Maybe<GasTrades>
  /** fetch data from the table: "account_credit" */
  account_credit: Array<Account_Credit>
  /** fetch aggregated fields from the table: "account_credit" */
  account_credit_aggregate: Account_Credit_Aggregate
  /** fetch data from the table: "account_credit" using primary key columns */
  account_credit_by_pk?: Maybe<Account_Credit>
  /** Downloads payment review results by filters */
  action_payment_review_records_download?: Maybe<PaymentReviewRecordsDownloadResponse>
  /** fetch data from the table: "active_outbound_photo_request" */
  active_outbound_photo_request: Array<Active_Outbound_Photo_Request>
  /** fetch aggregated fields from the table: "active_outbound_photo_request" */
  active_outbound_photo_request_aggregate: Active_Outbound_Photo_Request_Aggregate
  /** fetch data from the table: "address" */
  address: Array<Address>
  /** fetch aggregated fields from the table: "address" */
  address_aggregate: Address_Aggregate
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk?: Maybe<Address>
  /** An array relationship */
  admin_passes: Array<Admin_Passes>
  /** An aggregate relationship */
  admin_passes_aggregate: Admin_Passes_Aggregate
  /** fetch data from the table: "admin_passes" using primary key columns */
  admin_passes_by_pk?: Maybe<Admin_Passes>
  /** An array relationship */
  admin_roles: Array<Admin_Roles>
  /** An aggregate relationship */
  admin_roles_aggregate: Admin_Roles_Aggregate
  /** fetch data from the table: "admin_roles" using primary key columns */
  admin_roles_by_pk?: Maybe<Admin_Roles>
  /** fetch data from the table: "agreement" */
  agreement: Array<Agreement>
  /** fetch aggregated fields from the table: "agreement" */
  agreement_aggregate: Agreement_Aggregate
  /** fetch data from the table: "agreement" using primary key columns */
  agreement_by_pk?: Maybe<Agreement>
  /** fetch data from the table: "asset" */
  asset: Array<Asset>
  /** fetch aggregated fields from the table: "asset" */
  asset_aggregate: Asset_Aggregate
  /** fetch data from the table: "asset" using primary key columns */
  asset_by_pk?: Maybe<Asset>
  /** fetch data from the table: "attachment" */
  attachment: Array<Attachment>
  /** fetch aggregated fields from the table: "attachment" */
  attachment_aggregate: Attachment_Aggregate
  /** fetch data from the table: "attachment" using primary key columns */
  attachment_by_pk?: Maybe<Attachment>
  /** fetch data from the table: "axle_trial_eligibility" */
  axle_trial_eligibility: Array<Axle_Trial_Eligibility>
  /** fetch aggregated fields from the table: "axle_trial_eligibility" */
  axle_trial_eligibility_aggregate: Axle_Trial_Eligibility_Aggregate
  /** fetch data from the table: "axle_trial_eligibility" using primary key columns */
  axle_trial_eligibility_by_pk?: Maybe<Axle_Trial_Eligibility>
  /** fetch data from the table: "bill" */
  bill: Array<Bill>
  /** fetch aggregated fields from the table: "bill" */
  bill_aggregate: Bill_Aggregate
  /** fetch data from the table: "bill" using primary key columns */
  bill_by_pk?: Maybe<Bill>
  /** fetch data from the table: "billing_account" */
  billing_account: Array<Billing_Account>
  /** fetch aggregated fields from the table: "billing_account" */
  billing_account_aggregate: Billing_Account_Aggregate
  /** fetch data from the table: "billing_account" using primary key columns */
  billing_account_by_pk?: Maybe<Billing_Account>
  /** fetch data from the table: "billing_account_contact" */
  billing_account_contact: Array<Billing_Account_Contact>
  /** fetch aggregated fields from the table: "billing_account_contact" */
  billing_account_contact_aggregate: Billing_Account_Contact_Aggregate
  /** fetch data from the table: "billing_account_contact" using primary key columns */
  billing_account_contact_by_pk?: Maybe<Billing_Account_Contact>
  /** fetch data from the table: "billing_account_ids_with_meter_point_ids" */
  billing_account_ids_with_meter_point_ids: Array<Billing_Account_Ids_With_Meter_Point_Ids>
  /** fetch aggregated fields from the table: "billing_account_ids_with_meter_point_ids" */
  billing_account_ids_with_meter_point_ids_aggregate: Billing_Account_Ids_With_Meter_Point_Ids_Aggregate
  /** fetch data from the table: "billing_account_setting" */
  billing_account_setting: Array<Billing_Account_Setting>
  /** fetch aggregated fields from the table: "billing_account_setting" */
  billing_account_setting_aggregate: Billing_Account_Setting_Aggregate
  /** fetch data from the table: "billing_account_setting" using primary key columns */
  billing_account_setting_by_pk?: Maybe<Billing_Account_Setting>
  /** fetch data from the table: "billing_account_transaction" */
  billing_account_transaction: Array<Billing_Account_Transaction>
  /** fetch aggregated fields from the table: "billing_account_transaction" */
  billing_account_transaction_aggregate: Billing_Account_Transaction_Aggregate
  /** fetch data from the table: "billing_account_transaction" using primary key columns */
  billing_account_transaction_by_pk?: Maybe<Billing_Account_Transaction>
  /** fetch data from the table: "billing_period" */
  billing_period: Array<Billing_Period>
  /** fetch aggregated fields from the table: "billing_period" */
  billing_period_aggregate: Billing_Period_Aggregate
  /** fetch data from the table: "billing_period" using primary key columns */
  billing_period_by_pk?: Maybe<Billing_Period>
  /** An array relationship */
  calculation_items: Array<Calculation_Items>
  /** An aggregate relationship */
  calculation_items_aggregate: Calculation_Items_Aggregate
  /** fetch data from the table: "calculation_items" using primary key columns */
  calculation_items_by_pk?: Maybe<Calculation_Items>
  /** fetch data from the table: "call_trace_audit" */
  call_trace_audit: Array<Call_Trace_Audit>
  /** fetch aggregated fields from the table: "call_trace_audit" */
  call_trace_audit_aggregate: Call_Trace_Audit_Aggregate
  /** fetch data from the table: "call_trace_audit" using primary key columns */
  call_trace_audit_by_pk?: Maybe<Call_Trace_Audit>
  /** fetch data from the table: "cancellation_reasons" */
  cancellation_reasons: Array<Cancellation_Reasons>
  /** fetch aggregated fields from the table: "cancellation_reasons" */
  cancellation_reasons_aggregate: Cancellation_Reasons_Aggregate
  /** An array relationship */
  cancellations: Array<Cancellations>
  /** An aggregate relationship */
  cancellations_aggregate: Cancellations_Aggregate
  /** fetch data from the table: "cancellations" using primary key columns */
  cancellations_by_pk?: Maybe<Cancellations>
  /** fetch data from the table: "card_payment" */
  card_payment: Array<Card_Payment>
  /** fetch aggregated fields from the table: "card_payment" */
  card_payment_aggregate: Card_Payment_Aggregate
  /** fetch data from the table: "card_payment" using primary key columns */
  card_payment_by_pk?: Maybe<Card_Payment>
  /** fetch data from the table: "card_payment_old" */
  card_payment_old: Array<Card_Payment_Old>
  /** fetch aggregated fields from the table: "card_payment_old" */
  card_payment_old_aggregate: Card_Payment_Old_Aggregate
  /** fetch data from the table: "card_payment_old" using primary key columns */
  card_payment_old_by_pk?: Maybe<Card_Payment_Old>
  /** fetch data from the table: "cases" */
  cases: Array<Cases>
  /** fetch aggregated fields from the table: "cases" */
  cases_aggregate: Cases_Aggregate
  /** fetch data from the table: "cases" using primary key columns */
  cases_by_pk?: Maybe<Cases>
  /** fetch data from the table: "communication" */
  communication: Array<Communication>
  /** fetch aggregated fields from the table: "communication" */
  communication_aggregate: Communication_Aggregate
  /** fetch data from the table: "communication" using primary key columns */
  communication_by_pk?: Maybe<Communication>
  /** fetch data from the table: "communication_metadata" */
  communication_metadata: Array<Communication_Metadata>
  /** fetch aggregated fields from the table: "communication_metadata" */
  communication_metadata_aggregate: Communication_Metadata_Aggregate
  /** fetch data from the table: "communication_metadata" using primary key columns */
  communication_metadata_by_pk?: Maybe<Communication_Metadata>
  /** fetch data from the table: "communications" */
  communications: Array<Communications>
  /** fetch aggregated fields from the table: "communications" */
  communications_aggregate: Communications_Aggregate
  /** fetch data from the table: "communications" using primary key columns */
  communications_by_pk?: Maybe<Communications>
  /** fetch data from the table: "complaint" */
  complaint: Array<Complaint>
  /** fetch aggregated fields from the table: "complaint" */
  complaint_aggregate: Complaint_Aggregate
  /** fetch data from the table: "complaint_aggregations" */
  complaint_aggregations: Array<Complaint_Aggregations>
  /** fetch aggregated fields from the table: "complaint_aggregations" */
  complaint_aggregations_aggregate: Complaint_Aggregations_Aggregate
  /** fetch data from the table: "complaint" using primary key columns */
  complaint_by_pk?: Maybe<Complaint>
  /** fetch data from the table: "completed_sync_event_account" */
  completed_sync_event_account: Array<Completed_Sync_Event_Account>
  /** fetch aggregated fields from the table: "completed_sync_event_account" */
  completed_sync_event_account_aggregate: Completed_Sync_Event_Account_Aggregate
  /** fetch data from the table: "completed_sync_event_account" using primary key columns */
  completed_sync_event_account_by_pk?: Maybe<Completed_Sync_Event_Account>
  /** fetch data from the table: "configuration" */
  configuration: Array<Configuration>
  /** fetch aggregated fields from the table: "configuration" */
  configuration_aggregate: Configuration_Aggregate
  /** fetch data from the table: "configuration" using primary key columns */
  configuration_by_pk?: Maybe<Configuration>
  /** fetch data from the table: "contact" */
  contact: Array<Contact>
  /** fetch aggregated fields from the table: "contact" */
  contact_aggregate: Contact_Aggregate
  /** fetch data from the table: "contact" using primary key columns */
  contact_by_pk?: Maybe<Contact>
  /** fetch data from the table: "cs__soe_dashboard_total" */
  cs__soe_dashboard_total: Array<Cs__Soe_Dashboard_Total>
  /** fetch aggregated fields from the table: "cs__soe_dashboard_total" */
  cs__soe_dashboard_total_aggregate: Cs__Soe_Dashboard_Total_Aggregate
  /** fetch data from the table: "cs__soe_dashboard_total" using primary key columns */
  cs__soe_dashboard_total_by_pk?: Maybe<Cs__Soe_Dashboard_Total>
  /** fetch data from the table: "current_future_product_details" */
  current_future_product_details: Array<Current_Future_Product_Details>
  /** fetch aggregated fields from the table: "current_future_product_details" */
  current_future_product_details_aggregate: Current_Future_Product_Details_Aggregate
  /** fetch data from the table: "customer" */
  customer: Array<Customer>
  /** fetch data from the table: "address" */
  customer_address: Array<Customer_Address>
  /** fetch aggregated fields from the table: "address" */
  customer_address_aggregate: Customer_Address_Aggregate
  /** fetch data from the table: "address" using primary key columns */
  customer_address_by_pk?: Maybe<Customer_Address>
  /** fetch aggregated fields from the table: "customer" */
  customer_aggregate: Customer_Aggregate
  /** fetch data from the table: "customer" using primary key columns */
  customer_by_pk?: Maybe<Customer>
  /** fetch data from the table: "customer_contact" */
  customer_contact: Array<Customer_Contact>
  /** fetch aggregated fields from the table: "customer_contact" */
  customer_contact_aggregate: Customer_Contact_Aggregate
  /** fetch data from the table: "customer_contact" using primary key columns */
  customer_contact_by_pk?: Maybe<Customer_Contact>
  /** fetch data from the table: "customer_metadata" */
  customer_metadata: Array<Customer_Metadata>
  /** fetch aggregated fields from the table: "customer_metadata" */
  customer_metadata_aggregate: Customer_Metadata_Aggregate
  /** fetch data from the table: "customer_metadata" using primary key columns */
  customer_metadata_by_pk?: Maybe<Customer_Metadata>
  /** fetch data from the table: "customer_property_rel" */
  customer_property_rel: Array<Customer_Property_Rel>
  /** fetch aggregated fields from the table: "customer_property_rel" */
  customer_property_rel_aggregate: Customer_Property_Rel_Aggregate
  /** fetch data from the table: "customer_property_rel" using primary key columns */
  customer_property_rel_by_pk?: Maybe<Customer_Property_Rel>
  /** fetch data from the table: "customer_psr_rel" */
  customer_psr_rel: Array<Customer_Psr_Rel>
  /** fetch aggregated fields from the table: "customer_psr_rel" */
  customer_psr_rel_aggregate: Customer_Psr_Rel_Aggregate
  /** fetch data from the table: "customer_psr_rel" using primary key columns */
  customer_psr_rel_by_pk?: Maybe<Customer_Psr_Rel>
  /** An array relationship */
  customer_referrals: Array<Customer_Referrals>
  /** An aggregate relationship */
  customer_referrals_aggregate: Customer_Referrals_Aggregate
  /** fetch data from the table: "customer_referrals" using primary key columns */
  customer_referrals_by_pk?: Maybe<Customer_Referrals>
  /** fetch data from the table: "customer_setting" */
  customer_setting: Array<Customer_Setting>
  /** fetch aggregated fields from the table: "customer_setting" */
  customer_setting_aggregate: Customer_Setting_Aggregate
  /** fetch data from the table: "customer_setting" using primary key columns */
  customer_setting_by_pk?: Maybe<Customer_Setting>
  /** fetch data from the table: "customer_user_rel" */
  customer_user_rel: Array<Customer_User_Rel>
  /** fetch aggregated fields from the table: "customer_user_rel" */
  customer_user_rel_aggregate: Customer_User_Rel_Aggregate
  /** fetch data from the table: "customer_user_rel" using primary key columns */
  customer_user_rel_by_pk?: Maybe<Customer_User_Rel>
  /** fetch data from the table: "dashboard_complete_view_v2" */
  dashboard_complete_view_v2: Array<Dashboard_Complete_View_V2>
  /** fetch aggregated fields from the table: "dashboard_complete_view_v2" */
  dashboard_complete_view_v2_aggregate: Dashboard_Complete_View_V2_Aggregate
  /** fetch data from the table: "deprecated_solar_quote_requests" */
  deprecated_solar_quote_requests: Array<Deprecated_Solar_Quote_Requests>
  /** fetch aggregated fields from the table: "deprecated_solar_quote_requests" */
  deprecated_solar_quote_requests_aggregate: Deprecated_Solar_Quote_Requests_Aggregate
  /** fetch data from the table: "deprecated_solar_quote_requests" using primary key columns */
  deprecated_solar_quote_requests_by_pk?: Maybe<Deprecated_Solar_Quote_Requests>
  /** fetch data from the table: "direct_debit" */
  direct_debit: Array<Direct_Debit>
  /** fetch aggregated fields from the table: "direct_debit" */
  direct_debit_aggregate: Direct_Debit_Aggregate
  /** fetch data from the table: "direct_debit" using primary key columns */
  direct_debit_by_pk?: Maybe<Direct_Debit>
  /** fetch data from the table: "direct_debit_payment" */
  direct_debit_payment: Array<Direct_Debit_Payment>
  /** fetch aggregated fields from the table: "direct_debit_payment" */
  direct_debit_payment_aggregate: Direct_Debit_Payment_Aggregate
  /** fetch data from the table: "direct_debit_payment" using primary key columns */
  direct_debit_payment_by_pk?: Maybe<Direct_Debit_Payment>
  /** fetch data from the table: "email_messages" */
  email_messages: Array<Email_Messages>
  /** fetch aggregated fields from the table: "email_messages" */
  email_messages_aggregate: Email_Messages_Aggregate
  /** fetch data from the table: "email_messages" using primary key columns */
  email_messages_by_pk?: Maybe<Email_Messages>
  /** fetch data from the table: "email_templates" */
  email_templates: Array<Email_Templates>
  /** fetch aggregated fields from the table: "email_templates" */
  email_templates_aggregate: Email_Templates_Aggregate
  /** fetch data from the table: "email_templates" using primary key columns */
  email_templates_by_pk?: Maybe<Email_Templates>
  /** fetch data from the table: "email_templates_ext" */
  email_templates_ext: Array<Email_Templates_Ext>
  /** fetch aggregated fields from the table: "email_templates_ext" */
  email_templates_ext_aggregate: Email_Templates_Ext_Aggregate
  /** fetch data from the table: "email_templates_ext" using primary key columns */
  email_templates_ext_by_pk?: Maybe<Email_Templates_Ext>
  /** fetch data from the table: "energy_usage_load_factors" */
  energy_usage_load_factors: Array<Energy_Usage_Load_Factors>
  /** fetch aggregated fields from the table: "energy_usage_load_factors" */
  energy_usage_load_factors_aggregate: Energy_Usage_Load_Factors_Aggregate
  /** fetch data from the table: "energy_usage_load_factors" using primary key columns */
  energy_usage_load_factors_by_pk?: Maybe<Energy_Usage_Load_Factors>
  /** fetch data from the table: "enrolment" */
  enrolment: Array<Enrolment>
  /** fetch aggregated fields from the table: "enrolment" */
  enrolment_aggregate: Enrolment_Aggregate
  /** fetch data from the table: "enrolment_automated_communications" */
  enrolment_automated_communications: Array<Enrolment_Automated_Communications>
  /** fetch aggregated fields from the table: "enrolment_automated_communications" */
  enrolment_automated_communications_aggregate: Enrolment_Automated_Communications_Aggregate
  /** fetch data from the table: "enrolment_automated_communications" using primary key columns */
  enrolment_automated_communications_by_pk?: Maybe<Enrolment_Automated_Communications>
  /** fetch data from the table: "enrolment" using primary key columns */
  enrolment_by_pk?: Maybe<Enrolment>
  enrolments_grouped_by_broker: Array<Enrolments_Grouped_By_Broker_Model>
  /** fetch data from the table: "entity_mappings" */
  entity_mappings: Array<Entity_Mappings>
  /** fetch aggregated fields from the table: "entity_mappings" */
  entity_mappings_aggregate: Entity_Mappings_Aggregate
  /** fetch data from the table: "entity_mappings" using primary key columns */
  entity_mappings_by_pk?: Maybe<Entity_Mappings>
  /** fetch data from the table: "estimated_usage" */
  estimated_usage: Array<Estimated_Usage>
  /** fetch aggregated fields from the table: "estimated_usage" */
  estimated_usage_aggregate: Estimated_Usage_Aggregate
  /** fetch data from the table: "estimated_usage" using primary key columns */
  estimated_usage_by_pk?: Maybe<Estimated_Usage>
  /** fetch data from the table: "ev_smart_tariff_waitlist" */
  ev_smart_tariff_waitlist: Array<Ev_Smart_Tariff_Waitlist>
  /** fetch aggregated fields from the table: "ev_smart_tariff_waitlist" */
  ev_smart_tariff_waitlist_aggregate: Ev_Smart_Tariff_Waitlist_Aggregate
  /** fetch data from the table: "ev_smart_tariff_waitlist" using primary key columns */
  ev_smart_tariff_waitlist_by_pk?: Maybe<Ev_Smart_Tariff_Waitlist>
  /** fetch data from the table: "ev_tariff_eligibility_checks" */
  ev_tariff_eligibility_checks: Array<Ev_Tariff_Eligibility_Checks>
  /** fetch aggregated fields from the table: "ev_tariff_eligibility_checks" */
  ev_tariff_eligibility_checks_aggregate: Ev_Tariff_Eligibility_Checks_Aggregate
  /** fetch data from the table: "ev_tariff_eligibility_checks" using primary key columns */
  ev_tariff_eligibility_checks_by_pk?: Maybe<Ev_Tariff_Eligibility_Checks>
  /** Export Whd audit candidates */
  exportAuditCandidates?: Maybe<WhdExportAuditCandidatesResponse>
  /** Whd Export data */
  exportData?: Maybe<WhdExportDataResponse>
  /** fetch data from the table: "feature" */
  feature: Array<Feature>
  /** fetch aggregated fields from the table: "feature" */
  feature_aggregate: Feature_Aggregate
  /** fetch data from the table: "feature" using primary key columns */
  feature_by_pk?: Maybe<Feature>
  /** fetch data from the table: "configuration" */
  financials_configuration: Array<Financials_Configuration>
  /** fetch aggregated fields from the table: "configuration" */
  financials_configuration_aggregate: Financials_Configuration_Aggregate
  /** fetch data from the table: "configuration" using primary key columns */
  financials_configuration_by_pk?: Maybe<Financials_Configuration>
  /** fetch data from the table: "qrtz_blob_triggers" */
  financials_qrtz_blob_triggers: Array<Financials_Qrtz_Blob_Triggers>
  /** fetch aggregated fields from the table: "qrtz_blob_triggers" */
  financials_qrtz_blob_triggers_aggregate: Financials_Qrtz_Blob_Triggers_Aggregate
  /** fetch data from the table: "qrtz_blob_triggers" using primary key columns */
  financials_qrtz_blob_triggers_by_pk?: Maybe<Financials_Qrtz_Blob_Triggers>
  /** fetch data from the table: "qrtz_calendars" */
  financials_qrtz_calendars: Array<Financials_Qrtz_Calendars>
  /** fetch aggregated fields from the table: "qrtz_calendars" */
  financials_qrtz_calendars_aggregate: Financials_Qrtz_Calendars_Aggregate
  /** fetch data from the table: "qrtz_calendars" using primary key columns */
  financials_qrtz_calendars_by_pk?: Maybe<Financials_Qrtz_Calendars>
  /** fetch data from the table: "qrtz_cron_triggers" */
  financials_qrtz_cron_triggers: Array<Financials_Qrtz_Cron_Triggers>
  /** fetch aggregated fields from the table: "qrtz_cron_triggers" */
  financials_qrtz_cron_triggers_aggregate: Financials_Qrtz_Cron_Triggers_Aggregate
  /** fetch data from the table: "qrtz_cron_triggers" using primary key columns */
  financials_qrtz_cron_triggers_by_pk?: Maybe<Financials_Qrtz_Cron_Triggers>
  /** fetch data from the table: "qrtz_fired_triggers" */
  financials_qrtz_fired_triggers: Array<Financials_Qrtz_Fired_Triggers>
  /** fetch aggregated fields from the table: "qrtz_fired_triggers" */
  financials_qrtz_fired_triggers_aggregate: Financials_Qrtz_Fired_Triggers_Aggregate
  /** fetch data from the table: "qrtz_fired_triggers" using primary key columns */
  financials_qrtz_fired_triggers_by_pk?: Maybe<Financials_Qrtz_Fired_Triggers>
  /** fetch data from the table: "qrtz_job_details" */
  financials_qrtz_job_details: Array<Financials_Qrtz_Job_Details>
  /** fetch aggregated fields from the table: "qrtz_job_details" */
  financials_qrtz_job_details_aggregate: Financials_Qrtz_Job_Details_Aggregate
  /** fetch data from the table: "qrtz_job_details" using primary key columns */
  financials_qrtz_job_details_by_pk?: Maybe<Financials_Qrtz_Job_Details>
  /** fetch data from the table: "qrtz_scheduler_state" */
  financials_qrtz_scheduler_state: Array<Financials_Qrtz_Scheduler_State>
  /** fetch aggregated fields from the table: "qrtz_scheduler_state" */
  financials_qrtz_scheduler_state_aggregate: Financials_Qrtz_Scheduler_State_Aggregate
  /** fetch data from the table: "qrtz_scheduler_state" using primary key columns */
  financials_qrtz_scheduler_state_by_pk?: Maybe<Financials_Qrtz_Scheduler_State>
  /** fetch data from the table: "qrtz_simple_triggers" */
  financials_qrtz_simple_triggers: Array<Financials_Qrtz_Simple_Triggers>
  /** fetch aggregated fields from the table: "qrtz_simple_triggers" */
  financials_qrtz_simple_triggers_aggregate: Financials_Qrtz_Simple_Triggers_Aggregate
  /** fetch data from the table: "qrtz_simple_triggers" using primary key columns */
  financials_qrtz_simple_triggers_by_pk?: Maybe<Financials_Qrtz_Simple_Triggers>
  /** fetch data from the table: "qrtz_simprop_triggers" */
  financials_qrtz_simprop_triggers: Array<Financials_Qrtz_Simprop_Triggers>
  /** fetch aggregated fields from the table: "qrtz_simprop_triggers" */
  financials_qrtz_simprop_triggers_aggregate: Financials_Qrtz_Simprop_Triggers_Aggregate
  /** fetch data from the table: "qrtz_simprop_triggers" using primary key columns */
  financials_qrtz_simprop_triggers_by_pk?: Maybe<Financials_Qrtz_Simprop_Triggers>
  /** fetch data from the table: "qrtz_triggers" */
  financials_qrtz_triggers: Array<Financials_Qrtz_Triggers>
  /** fetch aggregated fields from the table: "qrtz_triggers" */
  financials_qrtz_triggers_aggregate: Financials_Qrtz_Triggers_Aggregate
  /** fetch data from the table: "qrtz_triggers" using primary key columns */
  financials_qrtz_triggers_by_pk?: Maybe<Financials_Qrtz_Triggers>
  /** fetch data from the table: "warrant_account_criteria" */
  financials_warrant_account_criteria: Array<Financials_Warrant_Account_Criteria>
  /** fetch aggregated fields from the table: "warrant_account_criteria" */
  financials_warrant_account_criteria_aggregate: Financials_Warrant_Account_Criteria_Aggregate
  /** fetch data from the table: "warrant_account_criteria" using primary key columns */
  financials_warrant_account_criteria_by_pk?: Maybe<Financials_Warrant_Account_Criteria>
  /** fetch data from the table: "warrant_account_sync_criteria" */
  financials_warrant_account_sync_criteria: Array<Financials_Warrant_Account_Sync_Criteria>
  /** fetch aggregated fields from the table: "warrant_account_sync_criteria" */
  financials_warrant_account_sync_criteria_aggregate: Financials_Warrant_Account_Sync_Criteria_Aggregate
  /** fetch data from the table: "warrant_account_sync_criteria" using primary key columns */
  financials_warrant_account_sync_criteria_by_pk?: Maybe<Financials_Warrant_Account_Sync_Criteria>
  /** fetch data from the table: "warrant_communications_sent_count" */
  financials_warrant_communications_sent_count: Array<Financials_Warrant_Communications_Sent_Count>
  /** fetch aggregated fields from the table: "warrant_communications_sent_count" */
  financials_warrant_communications_sent_count_aggregate: Financials_Warrant_Communications_Sent_Count_Aggregate
  /** fetch data from the table: "warrant_communications_sent_count" using primary key columns */
  financials_warrant_communications_sent_count_by_pk?: Maybe<Financials_Warrant_Communications_Sent_Count>
  /** fetch data from the table: "warrants_accounts" */
  financials_warrants_accounts: Array<Financials_Warrants_Accounts>
  /** fetch aggregated fields from the table: "warrants_accounts" */
  financials_warrants_accounts_aggregate: Financials_Warrants_Accounts_Aggregate
  /** fetch data from the table: "warrants_accounts" using primary key columns */
  financials_warrants_accounts_by_pk?: Maybe<Financials_Warrants_Accounts>
  /** fetch data from the table: "warrants_accounts_history" */
  financials_warrants_accounts_history: Array<Financials_Warrants_Accounts_History>
  /** fetch aggregated fields from the table: "warrants_accounts_history" */
  financials_warrants_accounts_history_aggregate: Financials_Warrants_Accounts_History_Aggregate
  /** fetch data from the table: "warrants_accounts_history" using primary key columns */
  financials_warrants_accounts_history_by_pk?: Maybe<Financials_Warrants_Accounts_History>
  /** fetch data from the table: "warrants_accounts_whitelist" */
  financials_warrants_accounts_whitelist: Array<Financials_Warrants_Accounts_Whitelist>
  /** fetch aggregated fields from the table: "warrants_accounts_whitelist" */
  financials_warrants_accounts_whitelist_aggregate: Financials_Warrants_Accounts_Whitelist_Aggregate
  /** fetch data from the table: "warrants_accounts_whitelist" using primary key columns */
  financials_warrants_accounts_whitelist_by_pk?: Maybe<Financials_Warrants_Accounts_Whitelist>
  /** fetch data from the table: "warrants_communication_group" */
  financials_warrants_communication_group: Array<Financials_Warrants_Communication_Group>
  /** fetch aggregated fields from the table: "warrants_communication_group" */
  financials_warrants_communication_group_aggregate: Financials_Warrants_Communication_Group_Aggregate
  /** fetch data from the table: "warrants_communication_group" using primary key columns */
  financials_warrants_communication_group_by_pk?: Maybe<Financials_Warrants_Communication_Group>
  /** fetch data from the table: "warrants_communications" */
  financials_warrants_communications: Array<Financials_Warrants_Communications>
  /** fetch aggregated fields from the table: "warrants_communications" */
  financials_warrants_communications_aggregate: Financials_Warrants_Communications_Aggregate
  /** fetch data from the table: "warrants_communications" using primary key columns */
  financials_warrants_communications_by_pk?: Maybe<Financials_Warrants_Communications>
  /** fetch data from the table: "warrants_dca_queue" */
  financials_warrants_dca_queue: Array<Financials_Warrants_Dca_Queue>
  /** fetch aggregated fields from the table: "warrants_dca_queue" */
  financials_warrants_dca_queue_aggregate: Financials_Warrants_Dca_Queue_Aggregate
  /** fetch data from the table: "warrants_dca_queue" using primary key columns */
  financials_warrants_dca_queue_by_pk?: Maybe<Financials_Warrants_Dca_Queue>
  /** fetch data from the table: "warrants_dca_tickets" */
  financials_warrants_dca_tickets: Array<Financials_Warrants_Dca_Tickets>
  /** fetch aggregated fields from the table: "warrants_dca_tickets" */
  financials_warrants_dca_tickets_aggregate: Financials_Warrants_Dca_Tickets_Aggregate
  /** fetch data from the table: "warrants_dca_tickets" using primary key columns */
  financials_warrants_dca_tickets_by_pk?: Maybe<Financials_Warrants_Dca_Tickets>
  /** fetch data from the table: "warrants_files_account" */
  financials_warrants_files_account: Array<Financials_Warrants_Files_Account>
  /** fetch aggregated fields from the table: "warrants_files_account" */
  financials_warrants_files_account_aggregate: Financials_Warrants_Files_Account_Aggregate
  /** fetch data from the table: "warrants_files_account" using primary key columns */
  financials_warrants_files_account_by_pk?: Maybe<Financials_Warrants_Files_Account>
  /** fetch data from the table: "warrants_files_job" */
  financials_warrants_files_job: Array<Financials_Warrants_Files_Job>
  /** fetch aggregated fields from the table: "warrants_files_job" */
  financials_warrants_files_job_aggregate: Financials_Warrants_Files_Job_Aggregate
  /** fetch data from the table: "warrants_files_job" using primary key columns */
  financials_warrants_files_job_by_pk?: Maybe<Financials_Warrants_Files_Job>
  /** fetch data from the table: "warrants_files_processed" */
  financials_warrants_files_processed: Array<Financials_Warrants_Files_Processed>
  /** fetch aggregated fields from the table: "warrants_files_processed" */
  financials_warrants_files_processed_aggregate: Financials_Warrants_Files_Processed_Aggregate
  /** fetch data from the table: "warrants_files_processed" using primary key columns */
  financials_warrants_files_processed_by_pk?: Maybe<Financials_Warrants_Files_Processed>
  /** fetch data from the table: "warrants_job" */
  financials_warrants_job: Array<Financials_Warrants_Job>
  /** fetch aggregated fields from the table: "warrants_job" */
  financials_warrants_job_aggregate: Financials_Warrants_Job_Aggregate
  /** fetch data from the table: "warrants_job" using primary key columns */
  financials_warrants_job_by_pk?: Maybe<Financials_Warrants_Job>
  /** fetch data from the table: "find_test_accounts" */
  find_test_accounts: Array<Find_Test_Accounts>
  /** fetch aggregated fields from the table: "find_test_accounts" */
  find_test_accounts_aggregate: Find_Test_Accounts_Aggregate
  /** fetch data from the table: "flex_market_subscription" */
  flex_market_subscription: Array<Flex_Market_Subscription>
  /** fetch aggregated fields from the table: "flex_market_subscription" */
  flex_market_subscription_aggregate: Flex_Market_Subscription_Aggregate
  /** fetch data from the table: "flex_market_subscription_billing" */
  flex_market_subscription_billing: Array<Flex_Market_Subscription_Billing>
  /** fetch aggregated fields from the table: "flex_market_subscription_billing" */
  flex_market_subscription_billing_aggregate: Flex_Market_Subscription_Billing_Aggregate
  /** fetch data from the table: "flex_market_subscription_billing" using primary key columns */
  flex_market_subscription_billing_by_pk?: Maybe<Flex_Market_Subscription_Billing>
  /** fetch data from the table: "flex_market_subscription_billing_component" */
  flex_market_subscription_billing_component: Array<Flex_Market_Subscription_Billing_Component>
  /** fetch aggregated fields from the table: "flex_market_subscription_billing_component" */
  flex_market_subscription_billing_component_aggregate: Flex_Market_Subscription_Billing_Component_Aggregate
  /** fetch data from the table: "flex_market_subscription_billing_component" using primary key columns */
  flex_market_subscription_billing_component_by_pk?: Maybe<Flex_Market_Subscription_Billing_Component>
  /** fetch data from the table: "flex_market_subscription" using primary key columns */
  flex_market_subscription_by_pk?: Maybe<Flex_Market_Subscription>
  /** fetch data from the table: "flyway_schema_history" */
  flyway_schema_history: Array<Flyway_Schema_History>
  /** fetch aggregated fields from the table: "flyway_schema_history" */
  flyway_schema_history_aggregate: Flyway_Schema_History_Aggregate
  /** fetch data from the table: "flyway_schema_history" using primary key columns */
  flyway_schema_history_by_pk?: Maybe<Flyway_Schema_History>
  /** fetch data from the table: "freshdesk_contact" */
  freshdesk_contact: Array<Freshdesk_Contact>
  /** fetch aggregated fields from the table: "freshdesk_contact" */
  freshdesk_contact_aggregate: Freshdesk_Contact_Aggregate
  /** fetch data from the table: "freshdesk_ticket" */
  freshdesk_ticket: Array<Freshdesk_Ticket>
  /** fetch aggregated fields from the table: "freshdesk_ticket" */
  freshdesk_ticket_aggregate: Freshdesk_Ticket_Aggregate
  /** execute function "function_get_smart_meter_dashboard_data_from_view_v8" which returns "smart_meter_dashboard_response_v7" */
  function_get_smart_meter_dashboard_data_from_view_v8: Array<Smart_Meter_Dashboard_Response_V7>
  /** execute function "function_get_smart_meter_dashboard_data_from_view_v8" and query aggregates on result of table type "smart_meter_dashboard_response_v7" */
  function_get_smart_meter_dashboard_data_from_view_v8_aggregate: Smart_Meter_Dashboard_Response_V7_Aggregate
  getCriteria?: Maybe<Array<Maybe<CriteriaResponse>>>
  getEmailContent?: Maybe<EmailContentResponse>
  getUploadedFiles?: Maybe<GetUploadedFilesResponse>
  /** fetch data from the table: "install_codes" */
  install_codes: Array<Install_Codes>
  /** fetch aggregated fields from the table: "install_codes" */
  install_codes_aggregate: Install_Codes_Aggregate
  /** fetch data from the table: "install_codes" using primary key columns */
  install_codes_by_pk?: Maybe<Install_Codes>
  /** fetch data from the table: "junifer__Account" */
  junifer__Account: Array<Junifer__Account>
  /** fetch data from the table: "junifer__AccountTransaction" */
  junifer__AccountTransaction: Array<Junifer__AccountTransaction>
  /** fetch aggregated fields from the table: "junifer__AccountTransaction" */
  junifer__AccountTransaction_aggregate: Junifer__AccountTransaction_Aggregate
  /** fetch data from the table: "junifer__AccountTransaction" using primary key columns */
  junifer__AccountTransaction_by_pk?: Maybe<Junifer__AccountTransaction>
  /** fetch aggregated fields from the table: "junifer__Account" */
  junifer__Account_aggregate: Junifer__Account_Aggregate
  /** fetch data from the table: "junifer__Account" using primary key columns */
  junifer__Account_by_pk?: Maybe<Junifer__Account>
  /** fetch data from the table: "junifer__Customer" */
  junifer__Customer: Array<Junifer__Customer>
  /** fetch aggregated fields from the table: "junifer__Customer" */
  junifer__Customer_aggregate: Junifer__Customer_Aggregate
  /** fetch data from the table: "junifer__Customer" using primary key columns */
  junifer__Customer_by_pk?: Maybe<Junifer__Customer>
  /** fetch data from the table: "last_errored_submissions" */
  last_errored_submissions: Array<Last_Errored_Submissions>
  /** fetch aggregated fields from the table: "last_errored_submissions" */
  last_errored_submissions_aggregate: Last_Errored_Submissions_Aggregate
  /** fetch data from the table: "meter" */
  meter: Array<Meter>
  /** fetch aggregated fields from the table: "meter" */
  meter_aggregate: Meter_Aggregate
  /** fetch data from the table: "meter" using primary key columns */
  meter_by_pk?: Maybe<Meter>
  /** fetch data from the table: "meter_meter_point_rel" */
  meter_meter_point_rel: Array<Meter_Meter_Point_Rel>
  /** fetch aggregated fields from the table: "meter_meter_point_rel" */
  meter_meter_point_rel_aggregate: Meter_Meter_Point_Rel_Aggregate
  /** fetch data from the table: "meter_meter_point_rel" using primary key columns */
  meter_meter_point_rel_by_pk?: Maybe<Meter_Meter_Point_Rel>
  /** fetch data from the table: "meter_point" */
  meter_point: Array<Meter_Point>
  /** fetch aggregated fields from the table: "meter_point" */
  meter_point_aggregate: Meter_Point_Aggregate
  /** fetch data from the table: "meter_point" using primary key columns */
  meter_point_by_pk?: Maybe<Meter_Point>
  /** fetch data from the table: "meter_point_electricity" */
  meter_point_electricity: Array<Meter_Point_Electricity>
  /** fetch aggregated fields from the table: "meter_point_electricity" */
  meter_point_electricity_aggregate: Meter_Point_Electricity_Aggregate
  /** fetch data from the table: "meter_point_electricity" using primary key columns */
  meter_point_electricity_by_pk?: Maybe<Meter_Point_Electricity>
  /** fetch data from the table: "meter_point_gas" */
  meter_point_gas: Array<Meter_Point_Gas>
  /** fetch aggregated fields from the table: "meter_point_gas" */
  meter_point_gas_aggregate: Meter_Point_Gas_Aggregate
  /** fetch data from the table: "meter_point_gas" using primary key columns */
  meter_point_gas_by_pk?: Maybe<Meter_Point_Gas>
  /** fetch data from the table: "meter_point_history" */
  meter_point_history: Array<Meter_Point_History>
  /** fetch aggregated fields from the table: "meter_point_history" */
  meter_point_history_aggregate: Meter_Point_History_Aggregate
  /** fetch data from the table: "meter_point_history" using primary key columns */
  meter_point_history_by_pk?: Maybe<Meter_Point_History>
  /** fetch data from the table: "meter_reading" */
  meter_reading: Array<Meter_Reading>
  /** fetch aggregated fields from the table: "meter_reading" */
  meter_reading_aggregate: Meter_Reading_Aggregate
  /** fetch data from the table: "meter_reading" using primary key columns */
  meter_reading_by_pk?: Maybe<Meter_Reading>
  /** fetch data from the table: "meter_reading_submission_request" */
  meter_reading_submission_request: Array<Meter_Reading_Submission_Request>
  /** fetch aggregated fields from the table: "meter_reading_submission_request" */
  meter_reading_submission_request_aggregate: Meter_Reading_Submission_Request_Aggregate
  /** fetch data from the table: "meter_reading_submission_request" using primary key columns */
  meter_reading_submission_request_by_pk?: Maybe<Meter_Reading_Submission_Request>
  /** fetch data from the table: "meter_reading_submission_tokens" */
  meter_reading_submission_tokens: Array<Meter_Reading_Submission_Tokens>
  /** fetch aggregated fields from the table: "meter_reading_submission_tokens" */
  meter_reading_submission_tokens_aggregate: Meter_Reading_Submission_Tokens_Aggregate
  /** fetch data from the table: "meter_reading_submission_tokens" using primary key columns */
  meter_reading_submission_tokens_by_pk?: Maybe<Meter_Reading_Submission_Tokens>
  missing_contact_details: Array<Missing_Contact_Details_Model>
  /** fetch data from the table: "note" */
  note: Array<Note>
  /** fetch aggregated fields from the table: "note" */
  note_aggregate: Note_Aggregate
  /** fetch data from the table: "note" using primary key columns */
  note_by_pk?: Maybe<Note>
  /** fetch data from the table: "nova_submissions" */
  nova_submissions: Array<Nova_Submissions>
  /** fetch aggregated fields from the table: "nova_submissions" */
  nova_submissions_aggregate: Nova_Submissions_Aggregate
  /** fetch data from the table: "outbound_photo_request" */
  outbound_photo_request: Array<Outbound_Photo_Request>
  /** fetch aggregated fields from the table: "outbound_photo_request" */
  outbound_photo_request_aggregate: Outbound_Photo_Request_Aggregate
  /** fetch data from the table: "outbound_photo_request" using primary key columns */
  outbound_photo_request_by_pk?: Maybe<Outbound_Photo_Request>
  /** An array relationship */
  password_reset_tokens: Array<Password_Reset_Tokens>
  /** An aggregate relationship */
  password_reset_tokens_aggregate: Password_Reset_Tokens_Aggregate
  /** fetch data from the table: "password_reset_tokens" using primary key columns */
  password_reset_tokens_by_pk?: Maybe<Password_Reset_Tokens>
  /** fetch data from the table: "payment" */
  payment: Array<Payment>
  /** fetch aggregated fields from the table: "payment" */
  payment_aggregate: Payment_Aggregate
  /** fetch data from the table: "payment" using primary key columns */
  payment_by_pk?: Maybe<Payment>
  /** fetch data from the table: "payment_method" */
  payment_method: Array<Payment_Method>
  /** fetch aggregated fields from the table: "payment_method" */
  payment_method_aggregate: Payment_Method_Aggregate
  /** fetch data from the table: "payment_method" using primary key columns */
  payment_method_by_pk?: Maybe<Payment_Method>
  /** fetch data from the table: "payment_review_account_balance_reserve_rates" */
  payment_review_account_balance_reserve_rates: Array<Payment_Review_Account_Balance_Reserve_Rates>
  /** fetch aggregated fields from the table: "payment_review_account_balance_reserve_rates" */
  payment_review_account_balance_reserve_rates_aggregate: Payment_Review_Account_Balance_Reserve_Rates_Aggregate
  /** fetch data from the table: "payment_review_account_balance_reserve_rates" using primary key columns */
  payment_review_account_balance_reserve_rates_by_pk?: Maybe<Payment_Review_Account_Balance_Reserve_Rates>
  /** fetch data from the table: "payment_review_account_exclusions" */
  payment_review_account_exclusions: Array<Payment_Review_Account_Exclusions>
  /** fetch aggregated fields from the table: "payment_review_account_exclusions" */
  payment_review_account_exclusions_aggregate: Payment_Review_Account_Exclusions_Aggregate
  /** fetch data from the table: "payment_review_account_exclusions" using primary key columns */
  payment_review_account_exclusions_by_pk?: Maybe<Payment_Review_Account_Exclusions>
  /** fetch data from the table: "payment_review_calculation" */
  payment_review_calculation: Array<Payment_Review_Calculation>
  /** fetch aggregated fields from the table: "payment_review_calculation" */
  payment_review_calculation_aggregate: Payment_Review_Calculation_Aggregate
  /** fetch data from the table: "payment_review_calculation" using primary key columns */
  payment_review_calculation_by_pk?: Maybe<Payment_Review_Calculation>
  payment_review_dashboard_summary: Array<Payment_Review_Dashboard_Summary_Model>
  /** fetch data from the table: "payment_review_future_product_rates" */
  payment_review_future_product_rates: Array<Payment_Review_Future_Product_Rates>
  /** fetch aggregated fields from the table: "payment_review_future_product_rates" */
  payment_review_future_product_rates_aggregate: Payment_Review_Future_Product_Rates_Aggregate
  /** fetch data from the table: "payment_review_future_product_rates" using primary key columns */
  payment_review_future_product_rates_by_pk?: Maybe<Payment_Review_Future_Product_Rates>
  /** fetch data from the table: "payment_review_record_emails" */
  payment_review_record_emails: Array<Payment_Review_Record_Emails>
  /** fetch aggregated fields from the table: "payment_review_record_emails" */
  payment_review_record_emails_aggregate: Payment_Review_Record_Emails_Aggregate
  /** fetch data from the table: "payment_review_record_emails" using primary key columns */
  payment_review_record_emails_by_pk?: Maybe<Payment_Review_Record_Emails>
  /** fetch data from the table: "payment_review_record_notes" */
  payment_review_record_notes: Array<Payment_Review_Record_Notes>
  /** fetch aggregated fields from the table: "payment_review_record_notes" */
  payment_review_record_notes_aggregate: Payment_Review_Record_Notes_Aggregate
  /** fetch data from the table: "payment_review_record_notes" using primary key columns */
  payment_review_record_notes_by_pk?: Maybe<Payment_Review_Record_Notes>
  /** fetch data from the table: "payment_review_records" */
  payment_review_records: Array<Payment_Review_Records>
  /** fetch aggregated fields from the table: "payment_review_records" */
  payment_review_records_aggregate: Payment_Review_Records_Aggregate
  /** fetch data from the table: "payment_review_records" using primary key columns */
  payment_review_records_by_pk?: Maybe<Payment_Review_Records>
  /** fetch data from the table: "payment_review_records_view" */
  payment_review_records_view: Array<Payment_Review_Records_View>
  /** fetch aggregated fields from the table: "payment_review_records_view" */
  payment_review_records_view_aggregate: Payment_Review_Records_View_Aggregate
  /** fetch data from the table: "payment_reviews" */
  payment_reviews: Array<Payment_Reviews>
  /** fetch aggregated fields from the table: "payment_reviews" */
  payment_reviews_aggregate: Payment_Reviews_Aggregate
  /** fetch data from the table: "payment_reviews" using primary key columns */
  payment_reviews_by_pk?: Maybe<Payment_Reviews>
  /** fetch data from the table: "payment_schedule" */
  payment_schedule: Array<Payment_Schedule>
  /** fetch aggregated fields from the table: "payment_schedule" */
  payment_schedule_aggregate: Payment_Schedule_Aggregate
  /** fetch data from the table: "payment_schedule" using primary key columns */
  payment_schedule_by_pk?: Maybe<Payment_Schedule>
  /** fetch data from the table: "postcode_gsp_cache" */
  postcode_gsp_cache: Array<Postcode_Gsp_Cache>
  /** fetch aggregated fields from the table: "postcode_gsp_cache" */
  postcode_gsp_cache_aggregate: Postcode_Gsp_Cache_Aggregate
  /** fetch data from the table: "postcode_gsp_cache" using primary key columns */
  postcode_gsp_cache_by_pk?: Maybe<Postcode_Gsp_Cache>
  /** fetch data from the table: "product" */
  product: Array<Product>
  /** fetch data from the table: "product_account" */
  product_account: Array<Product_Account>
  /** fetch aggregated fields from the table: "product_account" */
  product_account_aggregate: Product_Account_Aggregate
  /** fetch data from the table: "product_account_agreement_rel" */
  product_account_agreement_rel: Array<Product_Account_Agreement_Rel>
  /** fetch aggregated fields from the table: "product_account_agreement_rel" */
  product_account_agreement_rel_aggregate: Product_Account_Agreement_Rel_Aggregate
  /** fetch data from the table: "product_account_agreement_rel" using primary key columns */
  product_account_agreement_rel_by_pk?: Maybe<Product_Account_Agreement_Rel>
  /** fetch data from the table: "product_account" using primary key columns */
  product_account_by_pk?: Maybe<Product_Account>
  /** fetch aggregated fields from the table: "product" */
  product_aggregate: Product_Aggregate
  /** fetch data from the table: "product" using primary key columns */
  product_by_pk?: Maybe<Product>
  /** fetch data from the table: "product_elec" */
  product_elec: Array<Product_Elec>
  /** fetch aggregated fields from the table: "product_elec" */
  product_elec_aggregate: Product_Elec_Aggregate
  /** fetch data from the table: "product_elec" using primary key columns */
  product_elec_by_pk?: Maybe<Product_Elec>
  /** fetch data from the table: "product_gas" */
  product_gas: Array<Product_Gas>
  /** fetch aggregated fields from the table: "product_gas" */
  product_gas_aggregate: Product_Gas_Aggregate
  /** fetch data from the table: "product_gas" using primary key columns */
  product_gas_by_pk?: Maybe<Product_Gas>
  /** fetch data from the table: "product_variant" */
  product_variant: Array<Product_Variant>
  /** fetch aggregated fields from the table: "product_variant" */
  product_variant_aggregate: Product_Variant_Aggregate
  /** fetch data from the table: "product_variant" using primary key columns */
  product_variant_by_pk?: Maybe<Product_Variant>
  /** fetch data from the table: "product_variant_elec" */
  product_variant_elec: Array<Product_Variant_Elec>
  /** fetch aggregated fields from the table: "product_variant_elec" */
  product_variant_elec_aggregate: Product_Variant_Elec_Aggregate
  /** fetch data from the table: "product_variant_elec" using primary key columns */
  product_variant_elec_by_pk?: Maybe<Product_Variant_Elec>
  /** An array relationship */
  product_variant_gas: Array<Product_Variant_Gas>
  /** An aggregate relationship */
  product_variant_gas_aggregate: Product_Variant_Gas_Aggregate
  /** fetch data from the table: "product_variant_gas" using primary key columns */
  product_variant_gas_by_pk?: Maybe<Product_Variant_Gas>
  /** fetch data from the table: "product_view" */
  product_view: Array<Product_View>
  /** fetch aggregated fields from the table: "product_view" */
  product_view_aggregate: Product_View_Aggregate
  /** fetch data from the table: "property" */
  property: Array<Property>
  /** fetch aggregated fields from the table: "property" */
  property_aggregate: Property_Aggregate
  /** fetch data from the table: "property" using primary key columns */
  property_by_pk?: Maybe<Property>
  /** fetch data from the table: "psr" */
  psr: Array<Psr>
  /** fetch aggregated fields from the table: "psr" */
  psr_aggregate: Psr_Aggregate
  /** fetch data from the table: "psr" using primary key columns */
  psr_by_pk?: Maybe<Psr>
  /** fetch data from the table: "quote" */
  quote: Array<Quote>
  /** fetch aggregated fields from the table: "quote" */
  quote_aggregate: Quote_Aggregate
  /** fetch data from the table: "quote" using primary key columns */
  quote_by_pk?: Maybe<Quote>
  /** fetch data from the table: "quote_request" */
  quote_request: Array<Quote_Request>
  /** fetch aggregated fields from the table: "quote_request" */
  quote_request_aggregate: Quote_Request_Aggregate
  /** fetch data from the table: "quote_request" using primary key columns */
  quote_request_by_pk?: Maybe<Quote_Request>
  /** fetch data from the table: "recipients" */
  recipients: Array<Recipients>
  /** fetch aggregated fields from the table: "recipients" */
  recipients_aggregate: Recipients_Aggregate
  /** fetch data from the table: "recipients" using primary key columns */
  recipients_by_pk?: Maybe<Recipients>
  /** An array relationship */
  refresh_tokens: Array<Refresh_Tokens>
  /** An aggregate relationship */
  refresh_tokens_aggregate: Refresh_Tokens_Aggregate
  /** fetch data from the table: "refunds" */
  refunds: Array<Refunds>
  /** fetch aggregated fields from the table: "refunds" */
  refunds_aggregate: Refunds_Aggregate
  /** fetch data from the table: "refunds" using primary key columns */
  refunds_by_pk?: Maybe<Refunds>
  /** fetch data from the table: "register" */
  register: Array<Register>
  /** fetch aggregated fields from the table: "register" */
  register_aggregate: Register_Aggregate
  /** fetch data from the table: "register" using primary key columns */
  register_by_pk?: Maybe<Register>
  /** fetch data from the table: "registration_credit_check" */
  registration_credit_check: Array<Registration_Credit_Check>
  /** fetch data from the table: "registration_credit_check_address" */
  registration_credit_check_address: Array<Registration_Credit_Check_Address>
  /** fetch aggregated fields from the table: "registration_credit_check_address" */
  registration_credit_check_address_aggregate: Registration_Credit_Check_Address_Aggregate
  /** fetch data from the table: "registration_credit_check_address" using primary key columns */
  registration_credit_check_address_by_pk?: Maybe<Registration_Credit_Check_Address>
  /** fetch aggregated fields from the table: "registration_credit_check" */
  registration_credit_check_aggregate: Registration_Credit_Check_Aggregate
  /** fetch data from the table: "registration_credit_check" using primary key columns */
  registration_credit_check_by_pk?: Maybe<Registration_Credit_Check>
  /** fetch data from the table: "reminder" */
  reminder: Array<Reminder>
  /** fetch aggregated fields from the table: "reminder" */
  reminder_aggregate: Reminder_Aggregate
  /** fetch data from the table: "reminder" using primary key columns */
  reminder_by_pk?: Maybe<Reminder>
  /** fetch data from the table: "renewal" */
  renewal: Array<Renewal>
  /** fetch aggregated fields from the table: "renewal" */
  renewal_aggregate: Renewal_Aggregate
  /** fetch data from the table: "renewal" using primary key columns */
  renewal_by_pk?: Maybe<Renewal>
  /** fetch data from the table: "report_problem" */
  report_problem: Array<Report_Problem>
  /** fetch aggregated fields from the table: "report_problem" */
  report_problem_aggregate: Report_Problem_Aggregate
  /** An array relationship */
  report_problem_attachments: Array<Report_Problem_Attachments>
  /** An aggregate relationship */
  report_problem_attachments_aggregate: Report_Problem_Attachments_Aggregate
  /** fetch data from the table: "report_problem_attachments" using primary key columns */
  report_problem_attachments_by_pk?: Maybe<Report_Problem_Attachments>
  /** fetch data from the table: "report_problem" using primary key columns */
  report_problem_by_pk?: Maybe<Report_Problem>
  /** fetch data from the table: "requests" */
  requests: Array<Requests>
  /** fetch aggregated fields from the table: "requests" */
  requests_aggregate: Requests_Aggregate
  /** fetch data from the table: "requests" using primary key columns */
  requests_by_pk?: Maybe<Requests>
  /** fetch data from the table: "rts_meters_report" */
  rts_meters_report: Array<Rts_Meters_Report>
  /** fetch aggregated fields from the table: "rts_meters_report" */
  rts_meters_report_aggregate: Rts_Meters_Report_Aggregate
  /** fetch data from the table: "scheduled_payment" */
  scheduled_payment: Array<Scheduled_Payment>
  /** fetch aggregated fields from the table: "scheduled_payment" */
  scheduled_payment_aggregate: Scheduled_Payment_Aggregate
  /** fetch data from the table: "scheduled_payment" using primary key columns */
  scheduled_payment_by_pk?: Maybe<Scheduled_Payment>
  /** fetch data from the table: "scheduled_refund" */
  scheduled_refund: Array<Scheduled_Refund>
  /** fetch aggregated fields from the table: "scheduled_refund" */
  scheduled_refund_aggregate: Scheduled_Refund_Aggregate
  /** fetch data from the table: "scheduled_refund" using primary key columns */
  scheduled_refund_by_pk?: Maybe<Scheduled_Refund>
  /** fetch data from the table: "smart_charging" */
  smart_charging: Array<Smart_Charging>
  /** fetch aggregated fields from the table: "smart_charging" */
  smart_charging_aggregate: Smart_Charging_Aggregate
  /** fetch data from the table: "smart_charging" using primary key columns */
  smart_charging_by_pk?: Maybe<Smart_Charging>
  /** fetch data from the table: "smart_meter_dashboard_response_v7" */
  smart_meter_dashboard_response_v7: Array<Smart_Meter_Dashboard_Response_V7>
  /** fetch aggregated fields from the table: "smart_meter_dashboard_response_v7" */
  smart_meter_dashboard_response_v7_aggregate: Smart_Meter_Dashboard_Response_V7_Aggregate
  smart_meter_dashboard_summary: Array<Smart_Meter_Dashboard_Order_By_Dev_Status_Model>
  smart_meter_dashboard_workstream_summary: Array<Smart_Meter_Dashboard_Order_By_Workstream_Model>
  /** fetch data from the table: "smart_meters_eligible_for_exchange" */
  smart_meters_eligible_for_exchange: Array<Smart_Meters_Eligible_For_Exchange>
  /** fetch aggregated fields from the table: "smart_meters_eligible_for_exchange" */
  smart_meters_eligible_for_exchange_aggregate: Smart_Meters_Eligible_For_Exchange_Aggregate
  /** fetch data from the table: "smart_meters_eligible_for_exchange" using primary key columns */
  smart_meters_eligible_for_exchange_by_pk?: Maybe<Smart_Meters_Eligible_For_Exchange>
  /** fetch data from the table: "sync_status" */
  sync_status: Array<Sync_Status>
  /** fetch aggregated fields from the table: "sync_status" */
  sync_status_aggregate: Sync_Status_Aggregate
  /** fetch data from the table: "sync_status" using primary key columns */
  sync_status_by_pk?: Maybe<Sync_Status>
  /** fetch data from the table: "synchronized_accounts" */
  synchronized_accounts: Array<Synchronized_Accounts>
  /** fetch aggregated fields from the table: "synchronized_accounts" */
  synchronized_accounts_aggregate: Synchronized_Accounts_Aggregate
  /** fetch data from the table: "synchronized_accounts" using primary key columns */
  synchronized_accounts_by_pk?: Maybe<Synchronized_Accounts>
  /** fetch data from the table: "ticket" */
  ticket: Array<Ticket>
  /** fetch aggregated fields from the table: "ticket" */
  ticket_aggregate: Ticket_Aggregate
  /** fetch data from the table: "ticket" using primary key columns */
  ticket_by_pk?: Maybe<Ticket>
  /** fetch data from the table: "automation_account_store" */
  tickets_automation_account_store: Array<Tickets_Automation_Account_Store>
  /** fetch aggregated fields from the table: "automation_account_store" */
  tickets_automation_account_store_aggregate: Tickets_Automation_Account_Store_Aggregate
  /** fetch data from the table: "automation_account_store" using primary key columns */
  tickets_automation_account_store_by_pk?: Maybe<Tickets_Automation_Account_Store>
  /** fetch data from the table: "automation_config" */
  tickets_automation_config: Array<Tickets_Automation_Config>
  /** fetch aggregated fields from the table: "automation_config" */
  tickets_automation_config_aggregate: Tickets_Automation_Config_Aggregate
  /** fetch data from the table: "automation_config" using primary key columns */
  tickets_automation_config_by_pk?: Maybe<Tickets_Automation_Config>
  /** fetch data from the table: "automation_config_default" */
  tickets_automation_config_default: Array<Tickets_Automation_Config_Default>
  /** fetch aggregated fields from the table: "automation_config_default" */
  tickets_automation_config_default_aggregate: Tickets_Automation_Config_Default_Aggregate
  /** fetch data from the table: "automation_config_default" using primary key columns */
  tickets_automation_config_default_by_pk?: Maybe<Tickets_Automation_Config_Default>
  /** fetch data from the table: "automation_config_purge" */
  tickets_automation_config_purge: Array<Tickets_Automation_Config_Purge>
  /** fetch aggregated fields from the table: "automation_config_purge" */
  tickets_automation_config_purge_aggregate: Tickets_Automation_Config_Purge_Aggregate
  /** fetch data from the table: "automation_config_purge" using primary key columns */
  tickets_automation_config_purge_by_pk?: Maybe<Tickets_Automation_Config_Purge>
  /** fetch data from the table: "automation_default_ticket_action" */
  tickets_automation_default_ticket_action: Array<Tickets_Automation_Default_Ticket_Action>
  /** fetch aggregated fields from the table: "automation_default_ticket_action" */
  tickets_automation_default_ticket_action_aggregate: Tickets_Automation_Default_Ticket_Action_Aggregate
  /** fetch data from the table: "automation_default_ticket_action" using primary key columns */
  tickets_automation_default_ticket_action_by_pk?: Maybe<Tickets_Automation_Default_Ticket_Action>
  /** fetch data from the table: "automation_defaults_acceptable_accounts_table" */
  tickets_automation_defaults_acceptable_accounts_table: Array<Tickets_Automation_Defaults_Acceptable_Accounts_Table>
  /** fetch aggregated fields from the table: "automation_defaults_acceptable_accounts_table" */
  tickets_automation_defaults_acceptable_accounts_table_aggregate: Tickets_Automation_Defaults_Acceptable_Accounts_Table_Aggregate
  /** fetch data from the table: "automation_defaults_acceptable_accounts_table" using primary key columns */
  tickets_automation_defaults_acceptable_accounts_table_by_pk?: Maybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table>
  /** fetch data from the table: "automation_defaults_opened_predefaults" */
  tickets_automation_defaults_opened_predefaults: Array<Tickets_Automation_Defaults_Opened_Predefaults>
  /** fetch aggregated fields from the table: "automation_defaults_opened_predefaults" */
  tickets_automation_defaults_opened_predefaults_aggregate: Tickets_Automation_Defaults_Opened_Predefaults_Aggregate
  /** fetch data from the table: "automation_defaults_opened_predefaults" using primary key columns */
  tickets_automation_defaults_opened_predefaults_by_pk?: Maybe<Tickets_Automation_Defaults_Opened_Predefaults>
  /** fetch data from the table: "automation_job" */
  tickets_automation_job: Array<Tickets_Automation_Job>
  /** fetch aggregated fields from the table: "automation_job" */
  tickets_automation_job_aggregate: Tickets_Automation_Job_Aggregate
  /** fetch data from the table: "automation_job" using primary key columns */
  tickets_automation_job_by_pk?: Maybe<Tickets_Automation_Job>
  /** fetch data from the table: "automation_purge_job" */
  tickets_automation_purge_job: Array<Tickets_Automation_Purge_Job>
  /** fetch aggregated fields from the table: "automation_purge_job" */
  tickets_automation_purge_job_aggregate: Tickets_Automation_Purge_Job_Aggregate
  /** fetch data from the table: "automation_purge_job" using primary key columns */
  tickets_automation_purge_job_by_pk?: Maybe<Tickets_Automation_Purge_Job>
  /** fetch data from the table: "automation_ticket_store" */
  tickets_automation_ticket_store: Array<Tickets_Automation_Ticket_Store>
  /** fetch aggregated fields from the table: "automation_ticket_store" */
  tickets_automation_ticket_store_aggregate: Tickets_Automation_Ticket_Store_Aggregate
  /** fetch data from the table: "automation_ticket_store" using primary key columns */
  tickets_automation_ticket_store_by_pk?: Maybe<Tickets_Automation_Ticket_Store>
  /** fetch data from the table: "dca_account_allocation" */
  tickets_dca_account_allocation: Array<Tickets_Dca_Account_Allocation>
  /** fetch aggregated fields from the table: "dca_account_allocation" */
  tickets_dca_account_allocation_aggregate: Tickets_Dca_Account_Allocation_Aggregate
  /** fetch data from the table: "dca_account_allocation" using primary key columns */
  tickets_dca_account_allocation_by_pk?: Maybe<Tickets_Dca_Account_Allocation>
  /** fetch data from the table: "dca_allocation_configuration" */
  tickets_dca_allocation_configuration: Array<Tickets_Dca_Allocation_Configuration>
  /** fetch aggregated fields from the table: "dca_allocation_configuration" */
  tickets_dca_allocation_configuration_aggregate: Tickets_Dca_Allocation_Configuration_Aggregate
  /** fetch data from the table: "dca_allocation_configuration" using primary key columns */
  tickets_dca_allocation_configuration_by_pk?: Maybe<Tickets_Dca_Allocation_Configuration>
  /** fetch data from the table: "dca_configuration_v2" */
  tickets_dca_configuration_v2: Array<Tickets_Dca_Configuration_V2>
  /** fetch aggregated fields from the table: "dca_configuration_v2" */
  tickets_dca_configuration_v2_aggregate: Tickets_Dca_Configuration_V2_Aggregate
  /** fetch data from the table: "dca_configuration_v2" using primary key columns */
  tickets_dca_configuration_v2_by_pk?: Maybe<Tickets_Dca_Configuration_V2>
  /** fetch data from the table: "dca_segmentation" */
  tickets_dca_segmentation: Array<Tickets_Dca_Segmentation>
  /** fetch aggregated fields from the table: "dca_segmentation" */
  tickets_dca_segmentation_aggregate: Tickets_Dca_Segmentation_Aggregate
  /** fetch data from the table: "dca_segmentation" using primary key columns */
  tickets_dca_segmentation_by_pk?: Maybe<Tickets_Dca_Segmentation>
  /** fetch data from the table: "dunning_account_store" */
  tickets_dunning_account_store: Array<Tickets_Dunning_Account_Store>
  /** fetch aggregated fields from the table: "dunning_account_store" */
  tickets_dunning_account_store_aggregate: Tickets_Dunning_Account_Store_Aggregate
  /** fetch data from the table: "dunning_account_store" using primary key columns */
  tickets_dunning_account_store_by_pk?: Maybe<Tickets_Dunning_Account_Store>
  /** fetch data from the table: "dunning_addacs_review_records" */
  tickets_dunning_addacs_review_records: Array<Tickets_Dunning_Addacs_Review_Records>
  /** fetch aggregated fields from the table: "dunning_addacs_review_records" */
  tickets_dunning_addacs_review_records_aggregate: Tickets_Dunning_Addacs_Review_Records_Aggregate
  /** fetch data from the table: "dunning_addacs_review_records" using primary key columns */
  tickets_dunning_addacs_review_records_by_pk?: Maybe<Tickets_Dunning_Addacs_Review_Records>
  /** fetch data from the table: "dunning_automation_events" */
  tickets_dunning_automation_events: Array<Tickets_Dunning_Automation_Events>
  /** fetch aggregated fields from the table: "dunning_automation_events" */
  tickets_dunning_automation_events_aggregate: Tickets_Dunning_Automation_Events_Aggregate
  /** fetch data from the table: "dunning_automation_events" using primary key columns */
  tickets_dunning_automation_events_by_pk?: Maybe<Tickets_Dunning_Automation_Events>
  /** fetch data from the table: "dunning_debt_ticket_review_records" */
  tickets_dunning_debt_ticket_review_records: Array<Tickets_Dunning_Debt_Ticket_Review_Records>
  /** fetch aggregated fields from the table: "dunning_debt_ticket_review_records" */
  tickets_dunning_debt_ticket_review_records_aggregate: Tickets_Dunning_Debt_Ticket_Review_Records_Aggregate
  /** fetch data from the table: "dunning_debt_ticket_review_records" using primary key columns */
  tickets_dunning_debt_ticket_review_records_by_pk?: Maybe<Tickets_Dunning_Debt_Ticket_Review_Records>
  /** fetch data from the table: "dunning_job" */
  tickets_dunning_job: Array<Tickets_Dunning_Job>
  /** fetch aggregated fields from the table: "dunning_job" */
  tickets_dunning_job_aggregate: Tickets_Dunning_Job_Aggregate
  /** fetch data from the table: "dunning_job" using primary key columns */
  tickets_dunning_job_by_pk?: Maybe<Tickets_Dunning_Job>
  /** fetch data from the table: "dunning_legal_known_ticket_records" */
  tickets_dunning_legal_known_ticket_records: Array<Tickets_Dunning_Legal_Known_Ticket_Records>
  /** fetch aggregated fields from the table: "dunning_legal_known_ticket_records" */
  tickets_dunning_legal_known_ticket_records_aggregate: Tickets_Dunning_Legal_Known_Ticket_Records_Aggregate
  /** fetch data from the table: "dunning_legal_known_ticket_records" using primary key columns */
  tickets_dunning_legal_known_ticket_records_by_pk?: Maybe<Tickets_Dunning_Legal_Known_Ticket_Records>
  /** fetch data from the table: "dunning_legal_occupier_ticket_records" */
  tickets_dunning_legal_occupier_ticket_records: Array<Tickets_Dunning_Legal_Occupier_Ticket_Records>
  /** fetch aggregated fields from the table: "dunning_legal_occupier_ticket_records" */
  tickets_dunning_legal_occupier_ticket_records_aggregate: Tickets_Dunning_Legal_Occupier_Ticket_Records_Aggregate
  /** fetch data from the table: "dunning_legal_occupier_ticket_records" using primary key columns */
  tickets_dunning_legal_occupier_ticket_records_by_pk?: Maybe<Tickets_Dunning_Legal_Occupier_Ticket_Records>
  /** fetch data from the table: "dunning_occupier_accounts_review_records" */
  tickets_dunning_occupier_accounts_review_records: Array<Tickets_Dunning_Occupier_Accounts_Review_Records>
  /** fetch aggregated fields from the table: "dunning_occupier_accounts_review_records" */
  tickets_dunning_occupier_accounts_review_records_aggregate: Tickets_Dunning_Occupier_Accounts_Review_Records_Aggregate
  /** fetch data from the table: "dunning_occupier_accounts_review_records" using primary key columns */
  tickets_dunning_occupier_accounts_review_records_by_pk?: Maybe<Tickets_Dunning_Occupier_Accounts_Review_Records>
  /** fetch data from the table: "dunning_purge_job" */
  tickets_dunning_purge_job: Array<Tickets_Dunning_Purge_Job>
  /** fetch aggregated fields from the table: "dunning_purge_job" */
  tickets_dunning_purge_job_aggregate: Tickets_Dunning_Purge_Job_Aggregate
  /** fetch data from the table: "dunning_purge_job" using primary key columns */
  tickets_dunning_purge_job_by_pk?: Maybe<Tickets_Dunning_Purge_Job>
  /** fetch data from the table: "dunning_standard_ticket_records" */
  tickets_dunning_standard_ticket_records: Array<Tickets_Dunning_Standard_Ticket_Records>
  /** fetch aggregated fields from the table: "dunning_standard_ticket_records" */
  tickets_dunning_standard_ticket_records_aggregate: Tickets_Dunning_Standard_Ticket_Records_Aggregate
  /** fetch data from the table: "dunning_standard_ticket_records" using primary key columns */
  tickets_dunning_standard_ticket_records_by_pk?: Maybe<Tickets_Dunning_Standard_Ticket_Records>
  /** fetch data from the table: "dunning_statistics" */
  tickets_dunning_statistics: Array<Tickets_Dunning_Statistics>
  /** fetch aggregated fields from the table: "dunning_statistics" */
  tickets_dunning_statistics_aggregate: Tickets_Dunning_Statistics_Aggregate
  /** fetch data from the table: "dunning_statistics" using primary key columns */
  tickets_dunning_statistics_by_pk?: Maybe<Tickets_Dunning_Statistics>
  /** fetch data from the table: "dunning_terminating_accounts_review_records" */
  tickets_dunning_terminating_accounts_review_records: Array<Tickets_Dunning_Terminating_Accounts_Review_Records>
  /** fetch aggregated fields from the table: "dunning_terminating_accounts_review_records" */
  tickets_dunning_terminating_accounts_review_records_aggregate: Tickets_Dunning_Terminating_Accounts_Review_Records_Aggregate
  /** fetch data from the table: "dunning_terminating_accounts_review_records" using primary key columns */
  tickets_dunning_terminating_accounts_review_records_by_pk?: Maybe<Tickets_Dunning_Terminating_Accounts_Review_Records>
  /** fetch data from the table: "dunning_ticket_store" */
  tickets_dunning_ticket_store: Array<Tickets_Dunning_Ticket_Store>
  /** fetch aggregated fields from the table: "dunning_ticket_store" */
  tickets_dunning_ticket_store_aggregate: Tickets_Dunning_Ticket_Store_Aggregate
  /** fetch data from the table: "dunning_ticket_store" using primary key columns */
  tickets_dunning_ticket_store_by_pk?: Maybe<Tickets_Dunning_Ticket_Store>
  /** fetch data from the table: "dunning_workflow" */
  tickets_dunning_workflow: Array<Tickets_Dunning_Workflow>
  /** fetch aggregated fields from the table: "dunning_workflow" */
  tickets_dunning_workflow_aggregate: Tickets_Dunning_Workflow_Aggregate
  /** fetch data from the table: "dunning_workflow" using primary key columns */
  tickets_dunning_workflow_by_pk?: Maybe<Tickets_Dunning_Workflow>
  /** fetch data from the table: "external_event" */
  tickets_external_event: Array<Tickets_External_Event>
  /** fetch aggregated fields from the table: "external_event" */
  tickets_external_event_aggregate: Tickets_External_Event_Aggregate
  /** fetch data from the table: "external_event" using primary key columns */
  tickets_external_event_by_pk?: Maybe<Tickets_External_Event>
  /** fetch data from the table: "external_tickets" */
  tickets_external_tickets: Array<Tickets_External_Tickets>
  /** fetch aggregated fields from the table: "external_tickets" */
  tickets_external_tickets_aggregate: Tickets_External_Tickets_Aggregate
  /** fetch data from the table: "external_tickets" using primary key columns */
  tickets_external_tickets_by_pk?: Maybe<Tickets_External_Tickets>
  /** fetch data from the table: "qrtz_blob_triggers" */
  tickets_qrtz_blob_triggers: Array<Tickets_Qrtz_Blob_Triggers>
  /** fetch aggregated fields from the table: "qrtz_blob_triggers" */
  tickets_qrtz_blob_triggers_aggregate: Tickets_Qrtz_Blob_Triggers_Aggregate
  /** fetch data from the table: "qrtz_blob_triggers" using primary key columns */
  tickets_qrtz_blob_triggers_by_pk?: Maybe<Tickets_Qrtz_Blob_Triggers>
  /** fetch data from the table: "qrtz_calendars" */
  tickets_qrtz_calendars: Array<Tickets_Qrtz_Calendars>
  /** fetch aggregated fields from the table: "qrtz_calendars" */
  tickets_qrtz_calendars_aggregate: Tickets_Qrtz_Calendars_Aggregate
  /** fetch data from the table: "qrtz_calendars" using primary key columns */
  tickets_qrtz_calendars_by_pk?: Maybe<Tickets_Qrtz_Calendars>
  /** fetch data from the table: "qrtz_cron_triggers" */
  tickets_qrtz_cron_triggers: Array<Tickets_Qrtz_Cron_Triggers>
  /** fetch aggregated fields from the table: "qrtz_cron_triggers" */
  tickets_qrtz_cron_triggers_aggregate: Tickets_Qrtz_Cron_Triggers_Aggregate
  /** fetch data from the table: "qrtz_cron_triggers" using primary key columns */
  tickets_qrtz_cron_triggers_by_pk?: Maybe<Tickets_Qrtz_Cron_Triggers>
  /** fetch data from the table: "qrtz_fired_triggers" */
  tickets_qrtz_fired_triggers: Array<Tickets_Qrtz_Fired_Triggers>
  /** fetch aggregated fields from the table: "qrtz_fired_triggers" */
  tickets_qrtz_fired_triggers_aggregate: Tickets_Qrtz_Fired_Triggers_Aggregate
  /** fetch data from the table: "qrtz_fired_triggers" using primary key columns */
  tickets_qrtz_fired_triggers_by_pk?: Maybe<Tickets_Qrtz_Fired_Triggers>
  /** fetch data from the table: "qrtz_job_details" */
  tickets_qrtz_job_details: Array<Tickets_Qrtz_Job_Details>
  /** fetch aggregated fields from the table: "qrtz_job_details" */
  tickets_qrtz_job_details_aggregate: Tickets_Qrtz_Job_Details_Aggregate
  /** fetch data from the table: "qrtz_job_details" using primary key columns */
  tickets_qrtz_job_details_by_pk?: Maybe<Tickets_Qrtz_Job_Details>
  /** fetch data from the table: "qrtz_locks" */
  tickets_qrtz_locks: Array<Tickets_Qrtz_Locks>
  /** fetch aggregated fields from the table: "qrtz_locks" */
  tickets_qrtz_locks_aggregate: Tickets_Qrtz_Locks_Aggregate
  /** fetch data from the table: "qrtz_locks" using primary key columns */
  tickets_qrtz_locks_by_pk?: Maybe<Tickets_Qrtz_Locks>
  /** fetch data from the table: "qrtz_paused_trigger_grps" */
  tickets_qrtz_paused_trigger_grps: Array<Tickets_Qrtz_Paused_Trigger_Grps>
  /** fetch aggregated fields from the table: "qrtz_paused_trigger_grps" */
  tickets_qrtz_paused_trigger_grps_aggregate: Tickets_Qrtz_Paused_Trigger_Grps_Aggregate
  /** fetch data from the table: "qrtz_paused_trigger_grps" using primary key columns */
  tickets_qrtz_paused_trigger_grps_by_pk?: Maybe<Tickets_Qrtz_Paused_Trigger_Grps>
  /** fetch data from the table: "qrtz_scheduler_state" */
  tickets_qrtz_scheduler_state: Array<Tickets_Qrtz_Scheduler_State>
  /** fetch aggregated fields from the table: "qrtz_scheduler_state" */
  tickets_qrtz_scheduler_state_aggregate: Tickets_Qrtz_Scheduler_State_Aggregate
  /** fetch data from the table: "qrtz_scheduler_state" using primary key columns */
  tickets_qrtz_scheduler_state_by_pk?: Maybe<Tickets_Qrtz_Scheduler_State>
  /** fetch data from the table: "qrtz_simple_triggers" */
  tickets_qrtz_simple_triggers: Array<Tickets_Qrtz_Simple_Triggers>
  /** fetch aggregated fields from the table: "qrtz_simple_triggers" */
  tickets_qrtz_simple_triggers_aggregate: Tickets_Qrtz_Simple_Triggers_Aggregate
  /** fetch data from the table: "qrtz_simple_triggers" using primary key columns */
  tickets_qrtz_simple_triggers_by_pk?: Maybe<Tickets_Qrtz_Simple_Triggers>
  /** fetch data from the table: "qrtz_simprop_triggers" */
  tickets_qrtz_simprop_triggers: Array<Tickets_Qrtz_Simprop_Triggers>
  /** fetch aggregated fields from the table: "qrtz_simprop_triggers" */
  tickets_qrtz_simprop_triggers_aggregate: Tickets_Qrtz_Simprop_Triggers_Aggregate
  /** fetch data from the table: "qrtz_simprop_triggers" using primary key columns */
  tickets_qrtz_simprop_triggers_by_pk?: Maybe<Tickets_Qrtz_Simprop_Triggers>
  /** fetch data from the table: "qrtz_triggers" */
  tickets_qrtz_triggers: Array<Tickets_Qrtz_Triggers>
  /** fetch aggregated fields from the table: "qrtz_triggers" */
  tickets_qrtz_triggers_aggregate: Tickets_Qrtz_Triggers_Aggregate
  /** fetch data from the table: "qrtz_triggers" using primary key columns */
  tickets_qrtz_triggers_by_pk?: Maybe<Tickets_Qrtz_Triggers>
  /** fetch data from the table: "trustpilot_invitations" */
  trustpilot_invitations: Array<Trustpilot_Invitations>
  /** fetch aggregated fields from the table: "trustpilot_invitations" */
  trustpilot_invitations_aggregate: Trustpilot_Invitations_Aggregate
  /** fetch data from the table: "users" */
  users: Array<Users>
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>
  /** fetch data from the table: "uswitch_record" */
  uswitch_record: Array<Uswitch_Record>
  /** fetch aggregated fields from the table: "uswitch_record" */
  uswitch_record_aggregate: Uswitch_Record_Aggregate
  /** fetch data from the table: "uswitch_record" using primary key columns */
  uswitch_record_by_pk?: Maybe<Uswitch_Record>
  /** fetch data from the table: "warm_home_discount_application" */
  warm_home_discount_application: Array<Warm_Home_Discount_Application>
  /** fetch aggregated fields from the table: "warm_home_discount_application" */
  warm_home_discount_application_aggregate: Warm_Home_Discount_Application_Aggregate
  /** fetch data from the table: "warm_home_discount_application" using primary key columns */
  warm_home_discount_application_by_pk?: Maybe<Warm_Home_Discount_Application>
  /** fetch data from the table: "warm_home_discount_application_status_history" */
  warm_home_discount_application_status_history: Array<Warm_Home_Discount_Application_Status_History>
  /** fetch aggregated fields from the table: "warm_home_discount_application_status_history" */
  warm_home_discount_application_status_history_aggregate: Warm_Home_Discount_Application_Status_History_Aggregate
  /** fetch data from the table: "warm_home_discount_application_status_history" using primary key columns */
  warm_home_discount_application_status_history_by_pk?: Maybe<Warm_Home_Discount_Application_Status_History>
  /** fetch data from the table: "warm_home_discount_criteria" */
  warm_home_discount_criteria: Array<Warm_Home_Discount_Criteria>
  /** fetch aggregated fields from the table: "warm_home_discount_criteria" */
  warm_home_discount_criteria_aggregate: Warm_Home_Discount_Criteria_Aggregate
  /** fetch data from the table: "warm_home_discount_criteria" using primary key columns */
  warm_home_discount_criteria_by_pk?: Maybe<Warm_Home_Discount_Criteria>
  /** fetch data from the table: "warm_home_discount_criteria_rel" */
  warm_home_discount_criteria_rel: Array<Warm_Home_Discount_Criteria_Rel>
  /** fetch aggregated fields from the table: "warm_home_discount_criteria_rel" */
  warm_home_discount_criteria_rel_aggregate: Warm_Home_Discount_Criteria_Rel_Aggregate
  /** fetch data from the table: "warm_home_discount_criteria_rel" using primary key columns */
  warm_home_discount_criteria_rel_by_pk?: Maybe<Warm_Home_Discount_Criteria_Rel>
}

export type Query_RootElecNominationsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<ElecNominations_Order_By>>
  where?: InputMaybe<ElecNominations_Bool_Exp>
}

export type Query_RootElecNominations_AggregateArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<ElecNominations_Order_By>>
  where?: InputMaybe<ElecNominations_Bool_Exp>
}

export type Query_RootElecTradesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<ElecTrades_Order_By>>
  where?: InputMaybe<ElecTrades_Bool_Exp>
}

export type Query_RootElecTradesHistoryArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<ElecTradesHistory_Order_By>>
  where?: InputMaybe<ElecTradesHistory_Bool_Exp>
}

export type Query_RootElecTradesHistory_AggregateArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<ElecTradesHistory_Order_By>>
  where?: InputMaybe<ElecTradesHistory_Bool_Exp>
}

export type Query_RootElecTradesHistory_By_PkArgs = {
  id: Scalars["Int"]["input"]
}

export type Query_RootElecTrades_AggregateArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<ElecTrades_Order_By>>
  where?: InputMaybe<ElecTrades_Bool_Exp>
}

export type Query_RootElecTrades_By_PkArgs = {
  id: Scalars["Int"]["input"]
}

export type Query_RootGasTradesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<GasTrades_Order_By>>
  where?: InputMaybe<GasTrades_Bool_Exp>
}

export type Query_RootGasTradesHistoryArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<GasTradesHistory_Order_By>>
  where?: InputMaybe<GasTradesHistory_Bool_Exp>
}

export type Query_RootGasTradesHistory_AggregateArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<GasTradesHistory_Order_By>>
  where?: InputMaybe<GasTradesHistory_Bool_Exp>
}

export type Query_RootGasTradesHistory_By_PkArgs = {
  id: Scalars["Int"]["input"]
}

export type Query_RootGasTrades_AggregateArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<GasTrades_Order_By>>
  where?: InputMaybe<GasTrades_Bool_Exp>
}

export type Query_RootGasTrades_By_PkArgs = {
  id: Scalars["Int"]["input"]
}

export type Query_RootAccount_CreditArgs = {
  distinct_on?: InputMaybe<Array<Account_Credit_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Account_Credit_Order_By>>
  where?: InputMaybe<Account_Credit_Bool_Exp>
}

export type Query_RootAccount_Credit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Credit_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Account_Credit_Order_By>>
  where?: InputMaybe<Account_Credit_Bool_Exp>
}

export type Query_RootAccount_Credit_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootAction_Payment_Review_Records_DownloadArgs = {
  filters: PaymentReviewRecordsDownloadFilters
}

export type Query_RootActive_Outbound_Photo_RequestArgs = {
  distinct_on?: InputMaybe<Array<Active_Outbound_Photo_Request_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Active_Outbound_Photo_Request_Order_By>>
  where?: InputMaybe<Active_Outbound_Photo_Request_Bool_Exp>
}

export type Query_RootActive_Outbound_Photo_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Active_Outbound_Photo_Request_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Active_Outbound_Photo_Request_Order_By>>
  where?: InputMaybe<Active_Outbound_Photo_Request_Bool_Exp>
}

export type Query_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Address_Order_By>>
  where?: InputMaybe<Address_Bool_Exp>
}

export type Query_RootAddress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Address_Order_By>>
  where?: InputMaybe<Address_Bool_Exp>
}

export type Query_RootAddress_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootAdmin_PassesArgs = {
  distinct_on?: InputMaybe<Array<Admin_Passes_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Admin_Passes_Order_By>>
  where?: InputMaybe<Admin_Passes_Bool_Exp>
}

export type Query_RootAdmin_Passes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Passes_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Admin_Passes_Order_By>>
  where?: InputMaybe<Admin_Passes_Bool_Exp>
}

export type Query_RootAdmin_Passes_By_PkArgs = {
  id: Scalars["Int"]["input"]
}

export type Query_RootAdmin_RolesArgs = {
  distinct_on?: InputMaybe<Array<Admin_Roles_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Admin_Roles_Order_By>>
  where?: InputMaybe<Admin_Roles_Bool_Exp>
}

export type Query_RootAdmin_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Roles_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Admin_Roles_Order_By>>
  where?: InputMaybe<Admin_Roles_Bool_Exp>
}

export type Query_RootAdmin_Roles_By_PkArgs = {
  id: Scalars["Int"]["input"]
}

export type Query_RootAgreementArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Agreement_Order_By>>
  where?: InputMaybe<Agreement_Bool_Exp>
}

export type Query_RootAgreement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Agreement_Order_By>>
  where?: InputMaybe<Agreement_Bool_Exp>
}

export type Query_RootAgreement_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootAssetArgs = {
  distinct_on?: InputMaybe<Array<Asset_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Asset_Order_By>>
  where?: InputMaybe<Asset_Bool_Exp>
}

export type Query_RootAsset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Asset_Order_By>>
  where?: InputMaybe<Asset_Bool_Exp>
}

export type Query_RootAsset_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootAttachmentArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Attachment_Order_By>>
  where?: InputMaybe<Attachment_Bool_Exp>
}

export type Query_RootAttachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Attachment_Order_By>>
  where?: InputMaybe<Attachment_Bool_Exp>
}

export type Query_RootAttachment_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootAxle_Trial_EligibilityArgs = {
  distinct_on?: InputMaybe<Array<Axle_Trial_Eligibility_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Axle_Trial_Eligibility_Order_By>>
  where?: InputMaybe<Axle_Trial_Eligibility_Bool_Exp>
}

export type Query_RootAxle_Trial_Eligibility_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Axle_Trial_Eligibility_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Axle_Trial_Eligibility_Order_By>>
  where?: InputMaybe<Axle_Trial_Eligibility_Bool_Exp>
}

export type Query_RootAxle_Trial_Eligibility_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootBillArgs = {
  distinct_on?: InputMaybe<Array<Bill_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Bill_Order_By>>
  where?: InputMaybe<Bill_Bool_Exp>
}

export type Query_RootBill_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bill_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Bill_Order_By>>
  where?: InputMaybe<Bill_Bool_Exp>
}

export type Query_RootBill_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootBilling_AccountArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Order_By>>
  where?: InputMaybe<Billing_Account_Bool_Exp>
}

export type Query_RootBilling_Account_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Order_By>>
  where?: InputMaybe<Billing_Account_Bool_Exp>
}

export type Query_RootBilling_Account_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootBilling_Account_ContactArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Contact_Order_By>>
  where?: InputMaybe<Billing_Account_Contact_Bool_Exp>
}

export type Query_RootBilling_Account_Contact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Contact_Order_By>>
  where?: InputMaybe<Billing_Account_Contact_Bool_Exp>
}

export type Query_RootBilling_Account_Contact_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootBilling_Account_Ids_With_Meter_Point_IdsArgs = {
  distinct_on?: InputMaybe<
    Array<Billing_Account_Ids_With_Meter_Point_Ids_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Billing_Account_Ids_With_Meter_Point_Ids_Order_By>
  >
  where?: InputMaybe<Billing_Account_Ids_With_Meter_Point_Ids_Bool_Exp>
}

export type Query_RootBilling_Account_Ids_With_Meter_Point_Ids_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Billing_Account_Ids_With_Meter_Point_Ids_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Billing_Account_Ids_With_Meter_Point_Ids_Order_By>
  >
  where?: InputMaybe<Billing_Account_Ids_With_Meter_Point_Ids_Bool_Exp>
}

export type Query_RootBilling_Account_SettingArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Setting_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Setting_Order_By>>
  where?: InputMaybe<Billing_Account_Setting_Bool_Exp>
}

export type Query_RootBilling_Account_Setting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Setting_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Setting_Order_By>>
  where?: InputMaybe<Billing_Account_Setting_Bool_Exp>
}

export type Query_RootBilling_Account_Setting_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootBilling_Account_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Transaction_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Transaction_Order_By>>
  where?: InputMaybe<Billing_Account_Transaction_Bool_Exp>
}

export type Query_RootBilling_Account_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Transaction_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Transaction_Order_By>>
  where?: InputMaybe<Billing_Account_Transaction_Bool_Exp>
}

export type Query_RootBilling_Account_Transaction_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootBilling_PeriodArgs = {
  distinct_on?: InputMaybe<Array<Billing_Period_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Period_Order_By>>
  where?: InputMaybe<Billing_Period_Bool_Exp>
}

export type Query_RootBilling_Period_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Billing_Period_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Period_Order_By>>
  where?: InputMaybe<Billing_Period_Bool_Exp>
}

export type Query_RootBilling_Period_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootCalculation_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Calculation_Items_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Calculation_Items_Order_By>>
  where?: InputMaybe<Calculation_Items_Bool_Exp>
}

export type Query_RootCalculation_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Calculation_Items_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Calculation_Items_Order_By>>
  where?: InputMaybe<Calculation_Items_Bool_Exp>
}

export type Query_RootCalculation_Items_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootCall_Trace_AuditArgs = {
  distinct_on?: InputMaybe<Array<Call_Trace_Audit_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Call_Trace_Audit_Order_By>>
  where?: InputMaybe<Call_Trace_Audit_Bool_Exp>
}

export type Query_RootCall_Trace_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Call_Trace_Audit_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Call_Trace_Audit_Order_By>>
  where?: InputMaybe<Call_Trace_Audit_Bool_Exp>
}

export type Query_RootCall_Trace_Audit_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootCancellation_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Cancellation_Reasons_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Cancellation_Reasons_Order_By>>
  where?: InputMaybe<Cancellation_Reasons_Bool_Exp>
}

export type Query_RootCancellation_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cancellation_Reasons_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Cancellation_Reasons_Order_By>>
  where?: InputMaybe<Cancellation_Reasons_Bool_Exp>
}

export type Query_RootCancellationsArgs = {
  distinct_on?: InputMaybe<Array<Cancellations_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Cancellations_Order_By>>
  where?: InputMaybe<Cancellations_Bool_Exp>
}

export type Query_RootCancellations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cancellations_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Cancellations_Order_By>>
  where?: InputMaybe<Cancellations_Bool_Exp>
}

export type Query_RootCancellations_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootCard_PaymentArgs = {
  distinct_on?: InputMaybe<Array<Card_Payment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Card_Payment_Order_By>>
  where?: InputMaybe<Card_Payment_Bool_Exp>
}

export type Query_RootCard_Payment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Card_Payment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Card_Payment_Order_By>>
  where?: InputMaybe<Card_Payment_Bool_Exp>
}

export type Query_RootCard_Payment_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootCard_Payment_OldArgs = {
  distinct_on?: InputMaybe<Array<Card_Payment_Old_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Card_Payment_Old_Order_By>>
  where?: InputMaybe<Card_Payment_Old_Bool_Exp>
}

export type Query_RootCard_Payment_Old_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Card_Payment_Old_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Card_Payment_Old_Order_By>>
  where?: InputMaybe<Card_Payment_Old_Bool_Exp>
}

export type Query_RootCard_Payment_Old_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootCasesArgs = {
  distinct_on?: InputMaybe<Array<Cases_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Cases_Order_By>>
  where?: InputMaybe<Cases_Bool_Exp>
}

export type Query_RootCases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cases_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Cases_Order_By>>
  where?: InputMaybe<Cases_Bool_Exp>
}

export type Query_RootCases_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootCommunicationArgs = {
  distinct_on?: InputMaybe<Array<Communication_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Communication_Order_By>>
  where?: InputMaybe<Communication_Bool_Exp>
}

export type Query_RootCommunication_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Communication_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Communication_Order_By>>
  where?: InputMaybe<Communication_Bool_Exp>
}

export type Query_RootCommunication_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootCommunication_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Communication_Metadata_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Communication_Metadata_Order_By>>
  where?: InputMaybe<Communication_Metadata_Bool_Exp>
}

export type Query_RootCommunication_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Communication_Metadata_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Communication_Metadata_Order_By>>
  where?: InputMaybe<Communication_Metadata_Bool_Exp>
}

export type Query_RootCommunication_Metadata_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootCommunicationsArgs = {
  distinct_on?: InputMaybe<Array<Communications_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Communications_Order_By>>
  where?: InputMaybe<Communications_Bool_Exp>
}

export type Query_RootCommunications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Communications_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Communications_Order_By>>
  where?: InputMaybe<Communications_Bool_Exp>
}

export type Query_RootCommunications_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootComplaintArgs = {
  distinct_on?: InputMaybe<Array<Complaint_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Complaint_Order_By>>
  where?: InputMaybe<Complaint_Bool_Exp>
}

export type Query_RootComplaint_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Complaint_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Complaint_Order_By>>
  where?: InputMaybe<Complaint_Bool_Exp>
}

export type Query_RootComplaint_AggregationsArgs = {
  distinct_on?: InputMaybe<Array<Complaint_Aggregations_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Complaint_Aggregations_Order_By>>
  where?: InputMaybe<Complaint_Aggregations_Bool_Exp>
}

export type Query_RootComplaint_Aggregations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Complaint_Aggregations_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Complaint_Aggregations_Order_By>>
  where?: InputMaybe<Complaint_Aggregations_Bool_Exp>
}

export type Query_RootComplaint_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootCompleted_Sync_Event_AccountArgs = {
  distinct_on?: InputMaybe<Array<Completed_Sync_Event_Account_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Completed_Sync_Event_Account_Order_By>>
  where?: InputMaybe<Completed_Sync_Event_Account_Bool_Exp>
}

export type Query_RootCompleted_Sync_Event_Account_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Completed_Sync_Event_Account_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Completed_Sync_Event_Account_Order_By>>
  where?: InputMaybe<Completed_Sync_Event_Account_Bool_Exp>
}

export type Query_RootCompleted_Sync_Event_Account_By_PkArgs = {
  event_type: Scalars["event_type"]["input"]
  id: Scalars["bigint"]["input"]
}

export type Query_RootConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Configuration_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Configuration_Order_By>>
  where?: InputMaybe<Configuration_Bool_Exp>
}

export type Query_RootConfiguration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Configuration_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Configuration_Order_By>>
  where?: InputMaybe<Configuration_Bool_Exp>
}

export type Query_RootConfiguration_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootContactArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Contact_Order_By>>
  where?: InputMaybe<Contact_Bool_Exp>
}

export type Query_RootContact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Contact_Order_By>>
  where?: InputMaybe<Contact_Bool_Exp>
}

export type Query_RootContact_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootCs__Soe_Dashboard_TotalArgs = {
  distinct_on?: InputMaybe<Array<Cs__Soe_Dashboard_Total_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Cs__Soe_Dashboard_Total_Order_By>>
  where?: InputMaybe<Cs__Soe_Dashboard_Total_Bool_Exp>
}

export type Query_RootCs__Soe_Dashboard_Total_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cs__Soe_Dashboard_Total_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Cs__Soe_Dashboard_Total_Order_By>>
  where?: InputMaybe<Cs__Soe_Dashboard_Total_Bool_Exp>
}

export type Query_RootCs__Soe_Dashboard_Total_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootCurrent_Future_Product_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Current_Future_Product_Details_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Current_Future_Product_Details_Order_By>>
  where?: InputMaybe<Current_Future_Product_Details_Bool_Exp>
}

export type Query_RootCurrent_Future_Product_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Current_Future_Product_Details_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Current_Future_Product_Details_Order_By>>
  where?: InputMaybe<Current_Future_Product_Details_Bool_Exp>
}

export type Query_RootCustomerArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Order_By>>
  where?: InputMaybe<Customer_Bool_Exp>
}

export type Query_RootCustomer_AddressArgs = {
  distinct_on?: InputMaybe<Array<Customer_Address_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Address_Order_By>>
  where?: InputMaybe<Customer_Address_Bool_Exp>
}

export type Query_RootCustomer_Address_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Address_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Address_Order_By>>
  where?: InputMaybe<Customer_Address_Bool_Exp>
}

export type Query_RootCustomer_Address_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootCustomer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Order_By>>
  where?: InputMaybe<Customer_Bool_Exp>
}

export type Query_RootCustomer_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootCustomer_ContactArgs = {
  distinct_on?: InputMaybe<Array<Customer_Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Contact_Order_By>>
  where?: InputMaybe<Customer_Contact_Bool_Exp>
}

export type Query_RootCustomer_Contact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Contact_Order_By>>
  where?: InputMaybe<Customer_Contact_Bool_Exp>
}

export type Query_RootCustomer_Contact_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootCustomer_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Customer_Metadata_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Metadata_Order_By>>
  where?: InputMaybe<Customer_Metadata_Bool_Exp>
}

export type Query_RootCustomer_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Metadata_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Metadata_Order_By>>
  where?: InputMaybe<Customer_Metadata_Bool_Exp>
}

export type Query_RootCustomer_Metadata_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootCustomer_Property_RelArgs = {
  distinct_on?: InputMaybe<Array<Customer_Property_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Property_Rel_Order_By>>
  where?: InputMaybe<Customer_Property_Rel_Bool_Exp>
}

export type Query_RootCustomer_Property_Rel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Property_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Property_Rel_Order_By>>
  where?: InputMaybe<Customer_Property_Rel_Bool_Exp>
}

export type Query_RootCustomer_Property_Rel_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootCustomer_Psr_RelArgs = {
  distinct_on?: InputMaybe<Array<Customer_Psr_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Psr_Rel_Order_By>>
  where?: InputMaybe<Customer_Psr_Rel_Bool_Exp>
}

export type Query_RootCustomer_Psr_Rel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Psr_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Psr_Rel_Order_By>>
  where?: InputMaybe<Customer_Psr_Rel_Bool_Exp>
}

export type Query_RootCustomer_Psr_Rel_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootCustomer_ReferralsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Referrals_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Referrals_Order_By>>
  where?: InputMaybe<Customer_Referrals_Bool_Exp>
}

export type Query_RootCustomer_Referrals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Referrals_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Referrals_Order_By>>
  where?: InputMaybe<Customer_Referrals_Bool_Exp>
}

export type Query_RootCustomer_Referrals_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootCustomer_SettingArgs = {
  distinct_on?: InputMaybe<Array<Customer_Setting_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Setting_Order_By>>
  where?: InputMaybe<Customer_Setting_Bool_Exp>
}

export type Query_RootCustomer_Setting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Setting_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Setting_Order_By>>
  where?: InputMaybe<Customer_Setting_Bool_Exp>
}

export type Query_RootCustomer_Setting_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootCustomer_User_RelArgs = {
  distinct_on?: InputMaybe<Array<Customer_User_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_User_Rel_Order_By>>
  where?: InputMaybe<Customer_User_Rel_Bool_Exp>
}

export type Query_RootCustomer_User_Rel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_User_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_User_Rel_Order_By>>
  where?: InputMaybe<Customer_User_Rel_Bool_Exp>
}

export type Query_RootCustomer_User_Rel_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootDashboard_Complete_View_V2Args = {
  distinct_on?: InputMaybe<Array<Dashboard_Complete_View_V2_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Dashboard_Complete_View_V2_Order_By>>
  where?: InputMaybe<Dashboard_Complete_View_V2_Bool_Exp>
}

export type Query_RootDashboard_Complete_View_V2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dashboard_Complete_View_V2_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Dashboard_Complete_View_V2_Order_By>>
  where?: InputMaybe<Dashboard_Complete_View_V2_Bool_Exp>
}

export type Query_RootDeprecated_Solar_Quote_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Deprecated_Solar_Quote_Requests_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Deprecated_Solar_Quote_Requests_Order_By>>
  where?: InputMaybe<Deprecated_Solar_Quote_Requests_Bool_Exp>
}

export type Query_RootDeprecated_Solar_Quote_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Deprecated_Solar_Quote_Requests_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Deprecated_Solar_Quote_Requests_Order_By>>
  where?: InputMaybe<Deprecated_Solar_Quote_Requests_Bool_Exp>
}

export type Query_RootDeprecated_Solar_Quote_Requests_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootDirect_DebitArgs = {
  distinct_on?: InputMaybe<Array<Direct_Debit_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Direct_Debit_Order_By>>
  where?: InputMaybe<Direct_Debit_Bool_Exp>
}

export type Query_RootDirect_Debit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Direct_Debit_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Direct_Debit_Order_By>>
  where?: InputMaybe<Direct_Debit_Bool_Exp>
}

export type Query_RootDirect_Debit_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootDirect_Debit_PaymentArgs = {
  distinct_on?: InputMaybe<Array<Direct_Debit_Payment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Direct_Debit_Payment_Order_By>>
  where?: InputMaybe<Direct_Debit_Payment_Bool_Exp>
}

export type Query_RootDirect_Debit_Payment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Direct_Debit_Payment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Direct_Debit_Payment_Order_By>>
  where?: InputMaybe<Direct_Debit_Payment_Bool_Exp>
}

export type Query_RootDirect_Debit_Payment_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootEmail_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Email_Messages_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Email_Messages_Order_By>>
  where?: InputMaybe<Email_Messages_Bool_Exp>
}

export type Query_RootEmail_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Messages_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Email_Messages_Order_By>>
  where?: InputMaybe<Email_Messages_Bool_Exp>
}

export type Query_RootEmail_Messages_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootEmail_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Email_Templates_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Email_Templates_Order_By>>
  where?: InputMaybe<Email_Templates_Bool_Exp>
}

export type Query_RootEmail_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Templates_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Email_Templates_Order_By>>
  where?: InputMaybe<Email_Templates_Bool_Exp>
}

export type Query_RootEmail_Templates_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootEmail_Templates_ExtArgs = {
  distinct_on?: InputMaybe<Array<Email_Templates_Ext_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Email_Templates_Ext_Order_By>>
  where?: InputMaybe<Email_Templates_Ext_Bool_Exp>
}

export type Query_RootEmail_Templates_Ext_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Templates_Ext_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Email_Templates_Ext_Order_By>>
  where?: InputMaybe<Email_Templates_Ext_Bool_Exp>
}

export type Query_RootEmail_Templates_Ext_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootEnergy_Usage_Load_FactorsArgs = {
  distinct_on?: InputMaybe<Array<Energy_Usage_Load_Factors_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Energy_Usage_Load_Factors_Order_By>>
  where?: InputMaybe<Energy_Usage_Load_Factors_Bool_Exp>
}

export type Query_RootEnergy_Usage_Load_Factors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Usage_Load_Factors_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Energy_Usage_Load_Factors_Order_By>>
  where?: InputMaybe<Energy_Usage_Load_Factors_Bool_Exp>
}

export type Query_RootEnergy_Usage_Load_Factors_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootEnrolmentArgs = {
  distinct_on?: InputMaybe<Array<Enrolment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Enrolment_Order_By>>
  where?: InputMaybe<Enrolment_Bool_Exp>
}

export type Query_RootEnrolment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enrolment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Enrolment_Order_By>>
  where?: InputMaybe<Enrolment_Bool_Exp>
}

export type Query_RootEnrolment_Automated_CommunicationsArgs = {
  distinct_on?: InputMaybe<
    Array<Enrolment_Automated_Communications_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Enrolment_Automated_Communications_Order_By>>
  where?: InputMaybe<Enrolment_Automated_Communications_Bool_Exp>
}

export type Query_RootEnrolment_Automated_Communications_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Enrolment_Automated_Communications_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Enrolment_Automated_Communications_Order_By>>
  where?: InputMaybe<Enrolment_Automated_Communications_Bool_Exp>
}

export type Query_RootEnrolment_Automated_Communications_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootEnrolment_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootEnrolments_Grouped_By_BrokerArgs = {
  args: Enrolments_Grouped_By_Broker_Arguments
  distinct_on?: InputMaybe<Array<Enrolments_Grouped_By_Broker_Model_Enum_Name>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Enrolments_Grouped_By_Broker_Model_Order_By>>
  where?: InputMaybe<Enrolments_Grouped_By_Broker_Model_Bool_Exp_Bool_Exp>
}

export type Query_RootEntity_MappingsArgs = {
  distinct_on?: InputMaybe<Array<Entity_Mappings_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Entity_Mappings_Order_By>>
  where?: InputMaybe<Entity_Mappings_Bool_Exp>
}

export type Query_RootEntity_Mappings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Mappings_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Entity_Mappings_Order_By>>
  where?: InputMaybe<Entity_Mappings_Bool_Exp>
}

export type Query_RootEntity_Mappings_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootEstimated_UsageArgs = {
  distinct_on?: InputMaybe<Array<Estimated_Usage_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Estimated_Usage_Order_By>>
  where?: InputMaybe<Estimated_Usage_Bool_Exp>
}

export type Query_RootEstimated_Usage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estimated_Usage_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Estimated_Usage_Order_By>>
  where?: InputMaybe<Estimated_Usage_Bool_Exp>
}

export type Query_RootEstimated_Usage_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootEv_Smart_Tariff_WaitlistArgs = {
  distinct_on?: InputMaybe<Array<Ev_Smart_Tariff_Waitlist_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Ev_Smart_Tariff_Waitlist_Order_By>>
  where?: InputMaybe<Ev_Smart_Tariff_Waitlist_Bool_Exp>
}

export type Query_RootEv_Smart_Tariff_Waitlist_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ev_Smart_Tariff_Waitlist_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Ev_Smart_Tariff_Waitlist_Order_By>>
  where?: InputMaybe<Ev_Smart_Tariff_Waitlist_Bool_Exp>
}

export type Query_RootEv_Smart_Tariff_Waitlist_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootEv_Tariff_Eligibility_ChecksArgs = {
  distinct_on?: InputMaybe<Array<Ev_Tariff_Eligibility_Checks_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Ev_Tariff_Eligibility_Checks_Order_By>>
  where?: InputMaybe<Ev_Tariff_Eligibility_Checks_Bool_Exp>
}

export type Query_RootEv_Tariff_Eligibility_Checks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ev_Tariff_Eligibility_Checks_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Ev_Tariff_Eligibility_Checks_Order_By>>
  where?: InputMaybe<Ev_Tariff_Eligibility_Checks_Bool_Exp>
}

export type Query_RootEv_Tariff_Eligibility_Checks_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootExportDataArgs = {
  year: Scalars["String"]["input"]
}

export type Query_RootFeatureArgs = {
  distinct_on?: InputMaybe<Array<Feature_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Feature_Order_By>>
  where?: InputMaybe<Feature_Bool_Exp>
}

export type Query_RootFeature_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Feature_Order_By>>
  where?: InputMaybe<Feature_Bool_Exp>
}

export type Query_RootFeature_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootFinancials_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Financials_Configuration_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Configuration_Order_By>>
  where?: InputMaybe<Financials_Configuration_Bool_Exp>
}

export type Query_RootFinancials_Configuration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Configuration_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Configuration_Order_By>>
  where?: InputMaybe<Financials_Configuration_Bool_Exp>
}

export type Query_RootFinancials_Configuration_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootFinancials_Qrtz_Blob_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Blob_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Blob_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Blob_Triggers_Bool_Exp>
}

export type Query_RootFinancials_Qrtz_Blob_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Blob_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Blob_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Blob_Triggers_Bool_Exp>
}

export type Query_RootFinancials_Qrtz_Blob_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

export type Query_RootFinancials_Qrtz_CalendarsArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Calendars_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Calendars_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Calendars_Bool_Exp>
}

export type Query_RootFinancials_Qrtz_Calendars_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Calendars_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Calendars_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Calendars_Bool_Exp>
}

export type Query_RootFinancials_Qrtz_Calendars_By_PkArgs = {
  calendar_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

export type Query_RootFinancials_Qrtz_Cron_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Cron_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Cron_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Cron_Triggers_Bool_Exp>
}

export type Query_RootFinancials_Qrtz_Cron_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Cron_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Cron_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Cron_Triggers_Bool_Exp>
}

export type Query_RootFinancials_Qrtz_Cron_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

export type Query_RootFinancials_Qrtz_Fired_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Fired_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Fired_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Fired_Triggers_Bool_Exp>
}

export type Query_RootFinancials_Qrtz_Fired_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Fired_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Fired_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Fired_Triggers_Bool_Exp>
}

export type Query_RootFinancials_Qrtz_Fired_Triggers_By_PkArgs = {
  entry_id: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

export type Query_RootFinancials_Qrtz_Job_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Job_Details_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Job_Details_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Job_Details_Bool_Exp>
}

export type Query_RootFinancials_Qrtz_Job_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Job_Details_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Job_Details_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Job_Details_Bool_Exp>
}

export type Query_RootFinancials_Qrtz_Job_Details_By_PkArgs = {
  job_group: Scalars["String"]["input"]
  job_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

export type Query_RootFinancials_Qrtz_Scheduler_StateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Scheduler_State_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Scheduler_State_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Scheduler_State_Bool_Exp>
}

export type Query_RootFinancials_Qrtz_Scheduler_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Scheduler_State_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Scheduler_State_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Scheduler_State_Bool_Exp>
}

export type Query_RootFinancials_Qrtz_Scheduler_State_By_PkArgs = {
  instance_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

export type Query_RootFinancials_Qrtz_Simple_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Simple_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Simple_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Simple_Triggers_Bool_Exp>
}

export type Query_RootFinancials_Qrtz_Simple_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Simple_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Simple_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Simple_Triggers_Bool_Exp>
}

export type Query_RootFinancials_Qrtz_Simple_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

export type Query_RootFinancials_Qrtz_Simprop_TriggersArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Qrtz_Simprop_Triggers_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Simprop_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Simprop_Triggers_Bool_Exp>
}

export type Query_RootFinancials_Qrtz_Simprop_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Qrtz_Simprop_Triggers_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Simprop_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Simprop_Triggers_Bool_Exp>
}

export type Query_RootFinancials_Qrtz_Simprop_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

export type Query_RootFinancials_Qrtz_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Triggers_Bool_Exp>
}

export type Query_RootFinancials_Qrtz_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Triggers_Bool_Exp>
}

export type Query_RootFinancials_Qrtz_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

export type Query_RootFinancials_Warrant_Account_CriteriaArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrant_Account_Criteria_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrant_Account_Criteria_Order_By>>
  where?: InputMaybe<Financials_Warrant_Account_Criteria_Bool_Exp>
}

export type Query_RootFinancials_Warrant_Account_Criteria_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrant_Account_Criteria_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrant_Account_Criteria_Order_By>>
  where?: InputMaybe<Financials_Warrant_Account_Criteria_Bool_Exp>
}

export type Query_RootFinancials_Warrant_Account_Criteria_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootFinancials_Warrant_Account_Sync_CriteriaArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrant_Account_Sync_Criteria_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Financials_Warrant_Account_Sync_Criteria_Order_By>
  >
  where?: InputMaybe<Financials_Warrant_Account_Sync_Criteria_Bool_Exp>
}

export type Query_RootFinancials_Warrant_Account_Sync_Criteria_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrant_Account_Sync_Criteria_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Financials_Warrant_Account_Sync_Criteria_Order_By>
  >
  where?: InputMaybe<Financials_Warrant_Account_Sync_Criteria_Bool_Exp>
}

export type Query_RootFinancials_Warrant_Account_Sync_Criteria_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootFinancials_Warrant_Communications_Sent_CountArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrant_Communications_Sent_Count_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Financials_Warrant_Communications_Sent_Count_Order_By>
  >
  where?: InputMaybe<Financials_Warrant_Communications_Sent_Count_Bool_Exp>
}

export type Query_RootFinancials_Warrant_Communications_Sent_Count_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Financials_Warrant_Communications_Sent_Count_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Financials_Warrant_Communications_Sent_Count_Order_By>
    >
    where?: InputMaybe<Financials_Warrant_Communications_Sent_Count_Bool_Exp>
  }

export type Query_RootFinancials_Warrant_Communications_Sent_Count_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootFinancials_Warrants_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Financials_Warrants_Accounts_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Accounts_Order_By>>
  where?: InputMaybe<Financials_Warrants_Accounts_Bool_Exp>
}

export type Query_RootFinancials_Warrants_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Warrants_Accounts_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Accounts_Order_By>>
  where?: InputMaybe<Financials_Warrants_Accounts_Bool_Exp>
}

export type Query_RootFinancials_Warrants_Accounts_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootFinancials_Warrants_Accounts_HistoryArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrants_Accounts_History_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Accounts_History_Order_By>>
  where?: InputMaybe<Financials_Warrants_Accounts_History_Bool_Exp>
}

export type Query_RootFinancials_Warrants_Accounts_History_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrants_Accounts_History_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Accounts_History_Order_By>>
  where?: InputMaybe<Financials_Warrants_Accounts_History_Bool_Exp>
}

export type Query_RootFinancials_Warrants_Accounts_History_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootFinancials_Warrants_Accounts_WhitelistArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrants_Accounts_Whitelist_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Accounts_Whitelist_Order_By>>
  where?: InputMaybe<Financials_Warrants_Accounts_Whitelist_Bool_Exp>
}

export type Query_RootFinancials_Warrants_Accounts_Whitelist_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrants_Accounts_Whitelist_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Accounts_Whitelist_Order_By>>
  where?: InputMaybe<Financials_Warrants_Accounts_Whitelist_Bool_Exp>
}

export type Query_RootFinancials_Warrants_Accounts_Whitelist_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootFinancials_Warrants_Communication_GroupArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrants_Communication_Group_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Communication_Group_Order_By>>
  where?: InputMaybe<Financials_Warrants_Communication_Group_Bool_Exp>
}

export type Query_RootFinancials_Warrants_Communication_Group_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrants_Communication_Group_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Communication_Group_Order_By>>
  where?: InputMaybe<Financials_Warrants_Communication_Group_Bool_Exp>
}

export type Query_RootFinancials_Warrants_Communication_Group_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootFinancials_Warrants_CommunicationsArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrants_Communications_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Communications_Order_By>>
  where?: InputMaybe<Financials_Warrants_Communications_Bool_Exp>
}

export type Query_RootFinancials_Warrants_Communications_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrants_Communications_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Communications_Order_By>>
  where?: InputMaybe<Financials_Warrants_Communications_Bool_Exp>
}

export type Query_RootFinancials_Warrants_Communications_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootFinancials_Warrants_Dca_QueueArgs = {
  distinct_on?: InputMaybe<Array<Financials_Warrants_Dca_Queue_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Dca_Queue_Order_By>>
  where?: InputMaybe<Financials_Warrants_Dca_Queue_Bool_Exp>
}

export type Query_RootFinancials_Warrants_Dca_Queue_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Warrants_Dca_Queue_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Dca_Queue_Order_By>>
  where?: InputMaybe<Financials_Warrants_Dca_Queue_Bool_Exp>
}

export type Query_RootFinancials_Warrants_Dca_Queue_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootFinancials_Warrants_Dca_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Financials_Warrants_Dca_Tickets_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Dca_Tickets_Order_By>>
  where?: InputMaybe<Financials_Warrants_Dca_Tickets_Bool_Exp>
}

export type Query_RootFinancials_Warrants_Dca_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Warrants_Dca_Tickets_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Dca_Tickets_Order_By>>
  where?: InputMaybe<Financials_Warrants_Dca_Tickets_Bool_Exp>
}

export type Query_RootFinancials_Warrants_Dca_Tickets_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootFinancials_Warrants_Files_AccountArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrants_Files_Account_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Files_Account_Order_By>>
  where?: InputMaybe<Financials_Warrants_Files_Account_Bool_Exp>
}

export type Query_RootFinancials_Warrants_Files_Account_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrants_Files_Account_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Files_Account_Order_By>>
  where?: InputMaybe<Financials_Warrants_Files_Account_Bool_Exp>
}

export type Query_RootFinancials_Warrants_Files_Account_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootFinancials_Warrants_Files_JobArgs = {
  distinct_on?: InputMaybe<Array<Financials_Warrants_Files_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Files_Job_Order_By>>
  where?: InputMaybe<Financials_Warrants_Files_Job_Bool_Exp>
}

export type Query_RootFinancials_Warrants_Files_Job_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Warrants_Files_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Files_Job_Order_By>>
  where?: InputMaybe<Financials_Warrants_Files_Job_Bool_Exp>
}

export type Query_RootFinancials_Warrants_Files_Job_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootFinancials_Warrants_Files_ProcessedArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrants_Files_Processed_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Files_Processed_Order_By>>
  where?: InputMaybe<Financials_Warrants_Files_Processed_Bool_Exp>
}

export type Query_RootFinancials_Warrants_Files_Processed_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrants_Files_Processed_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Files_Processed_Order_By>>
  where?: InputMaybe<Financials_Warrants_Files_Processed_Bool_Exp>
}

export type Query_RootFinancials_Warrants_Files_Processed_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootFinancials_Warrants_JobArgs = {
  distinct_on?: InputMaybe<Array<Financials_Warrants_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Job_Order_By>>
  where?: InputMaybe<Financials_Warrants_Job_Bool_Exp>
}

export type Query_RootFinancials_Warrants_Job_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Warrants_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Job_Order_By>>
  where?: InputMaybe<Financials_Warrants_Job_Bool_Exp>
}

export type Query_RootFinancials_Warrants_Job_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootFind_Test_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Find_Test_Accounts_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Find_Test_Accounts_Order_By>>
  where?: InputMaybe<Find_Test_Accounts_Bool_Exp>
}

export type Query_RootFind_Test_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Find_Test_Accounts_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Find_Test_Accounts_Order_By>>
  where?: InputMaybe<Find_Test_Accounts_Bool_Exp>
}

export type Query_RootFlex_Market_SubscriptionArgs = {
  distinct_on?: InputMaybe<Array<Flex_Market_Subscription_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Flex_Market_Subscription_Order_By>>
  where?: InputMaybe<Flex_Market_Subscription_Bool_Exp>
}

export type Query_RootFlex_Market_Subscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Flex_Market_Subscription_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Flex_Market_Subscription_Order_By>>
  where?: InputMaybe<Flex_Market_Subscription_Bool_Exp>
}

export type Query_RootFlex_Market_Subscription_BillingArgs = {
  distinct_on?: InputMaybe<
    Array<Flex_Market_Subscription_Billing_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Flex_Market_Subscription_Billing_Order_By>>
  where?: InputMaybe<Flex_Market_Subscription_Billing_Bool_Exp>
}

export type Query_RootFlex_Market_Subscription_Billing_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Flex_Market_Subscription_Billing_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Flex_Market_Subscription_Billing_Order_By>>
  where?: InputMaybe<Flex_Market_Subscription_Billing_Bool_Exp>
}

export type Query_RootFlex_Market_Subscription_Billing_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootFlex_Market_Subscription_Billing_ComponentArgs = {
  distinct_on?: InputMaybe<
    Array<Flex_Market_Subscription_Billing_Component_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Flex_Market_Subscription_Billing_Component_Order_By>
  >
  where?: InputMaybe<Flex_Market_Subscription_Billing_Component_Bool_Exp>
}

export type Query_RootFlex_Market_Subscription_Billing_Component_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Flex_Market_Subscription_Billing_Component_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Flex_Market_Subscription_Billing_Component_Order_By>
    >
    where?: InputMaybe<Flex_Market_Subscription_Billing_Component_Bool_Exp>
  }

export type Query_RootFlex_Market_Subscription_Billing_Component_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootFlex_Market_Subscription_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootFlyway_Schema_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Flyway_Schema_History_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Flyway_Schema_History_Order_By>>
  where?: InputMaybe<Flyway_Schema_History_Bool_Exp>
}

export type Query_RootFlyway_Schema_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Flyway_Schema_History_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Flyway_Schema_History_Order_By>>
  where?: InputMaybe<Flyway_Schema_History_Bool_Exp>
}

export type Query_RootFlyway_Schema_History_By_PkArgs = {
  installed_rank: Scalars["Int"]["input"]
}

export type Query_RootFreshdesk_ContactArgs = {
  distinct_on?: InputMaybe<Array<Freshdesk_Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Freshdesk_Contact_Order_By>>
  where?: InputMaybe<Freshdesk_Contact_Bool_Exp>
}

export type Query_RootFreshdesk_Contact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Freshdesk_Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Freshdesk_Contact_Order_By>>
  where?: InputMaybe<Freshdesk_Contact_Bool_Exp>
}

export type Query_RootFreshdesk_TicketArgs = {
  distinct_on?: InputMaybe<Array<Freshdesk_Ticket_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Freshdesk_Ticket_Order_By>>
  where?: InputMaybe<Freshdesk_Ticket_Bool_Exp>
}

export type Query_RootFreshdesk_Ticket_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Freshdesk_Ticket_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Freshdesk_Ticket_Order_By>>
  where?: InputMaybe<Freshdesk_Ticket_Bool_Exp>
}

export type Query_RootFunction_Get_Smart_Meter_Dashboard_Data_From_View_V8Args =
  {
    args?: InputMaybe<Function_Get_Smart_Meter_Dashboard_Data_From_View_V8_Args>
    distinct_on?: InputMaybe<
      Array<Smart_Meter_Dashboard_Response_V7_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<Array<Smart_Meter_Dashboard_Response_V7_Order_By>>
    where?: InputMaybe<Smart_Meter_Dashboard_Response_V7_Bool_Exp>
  }

export type Query_RootFunction_Get_Smart_Meter_Dashboard_Data_From_View_V8_AggregateArgs =
  {
    args?: InputMaybe<Function_Get_Smart_Meter_Dashboard_Data_From_View_V8_Args>
    distinct_on?: InputMaybe<
      Array<Smart_Meter_Dashboard_Response_V7_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<Array<Smart_Meter_Dashboard_Response_V7_Order_By>>
    where?: InputMaybe<Smart_Meter_Dashboard_Response_V7_Bool_Exp>
  }

export type Query_RootGetEmailContentArgs = {
  path: Scalars["String"]["input"]
}

export type Query_RootGetUploadedFilesArgs = {
  accountId: Scalars["BigInt"]["input"]
  date?: InputMaybe<Scalars["String"]["input"]>
}

export type Query_RootInstall_CodesArgs = {
  distinct_on?: InputMaybe<Array<Install_Codes_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Install_Codes_Order_By>>
  where?: InputMaybe<Install_Codes_Bool_Exp>
}

export type Query_RootInstall_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Install_Codes_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Install_Codes_Order_By>>
  where?: InputMaybe<Install_Codes_Bool_Exp>
}

export type Query_RootInstall_Codes_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootJunifer__AccountArgs = {
  distinct_on?: InputMaybe<Array<Junifer__Account_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Junifer__Account_Order_By>>
  where?: InputMaybe<Junifer__Account_Bool_Exp>
}

export type Query_RootJunifer__AccountTransactionArgs = {
  distinct_on?: InputMaybe<Array<Junifer__AccountTransaction_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Junifer__AccountTransaction_Order_By>>
  where?: InputMaybe<Junifer__AccountTransaction_Bool_Exp>
}

export type Query_RootJunifer__AccountTransaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Junifer__AccountTransaction_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Junifer__AccountTransaction_Order_By>>
  where?: InputMaybe<Junifer__AccountTransaction_Bool_Exp>
}

export type Query_RootJunifer__AccountTransaction_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootJunifer__Account_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Junifer__Account_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Junifer__Account_Order_By>>
  where?: InputMaybe<Junifer__Account_Bool_Exp>
}

export type Query_RootJunifer__Account_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootJunifer__CustomerArgs = {
  distinct_on?: InputMaybe<Array<Junifer__Customer_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Junifer__Customer_Order_By>>
  where?: InputMaybe<Junifer__Customer_Bool_Exp>
}

export type Query_RootJunifer__Customer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Junifer__Customer_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Junifer__Customer_Order_By>>
  where?: InputMaybe<Junifer__Customer_Bool_Exp>
}

export type Query_RootJunifer__Customer_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootLast_Errored_SubmissionsArgs = {
  distinct_on?: InputMaybe<Array<Last_Errored_Submissions_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Last_Errored_Submissions_Order_By>>
  where?: InputMaybe<Last_Errored_Submissions_Bool_Exp>
}

export type Query_RootLast_Errored_Submissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Last_Errored_Submissions_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Last_Errored_Submissions_Order_By>>
  where?: InputMaybe<Last_Errored_Submissions_Bool_Exp>
}

export type Query_RootMeterArgs = {
  distinct_on?: InputMaybe<Array<Meter_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Order_By>>
  where?: InputMaybe<Meter_Bool_Exp>
}

export type Query_RootMeter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Order_By>>
  where?: InputMaybe<Meter_Bool_Exp>
}

export type Query_RootMeter_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootMeter_Meter_Point_RelArgs = {
  distinct_on?: InputMaybe<Array<Meter_Meter_Point_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Meter_Point_Rel_Order_By>>
  where?: InputMaybe<Meter_Meter_Point_Rel_Bool_Exp>
}

export type Query_RootMeter_Meter_Point_Rel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Meter_Point_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Meter_Point_Rel_Order_By>>
  where?: InputMaybe<Meter_Meter_Point_Rel_Bool_Exp>
}

export type Query_RootMeter_Meter_Point_Rel_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootMeter_PointArgs = {
  distinct_on?: InputMaybe<Array<Meter_Point_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Point_Order_By>>
  where?: InputMaybe<Meter_Point_Bool_Exp>
}

export type Query_RootMeter_Point_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Point_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Point_Order_By>>
  where?: InputMaybe<Meter_Point_Bool_Exp>
}

export type Query_RootMeter_Point_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootMeter_Point_ElectricityArgs = {
  distinct_on?: InputMaybe<Array<Meter_Point_Electricity_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Point_Electricity_Order_By>>
  where?: InputMaybe<Meter_Point_Electricity_Bool_Exp>
}

export type Query_RootMeter_Point_Electricity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Point_Electricity_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Point_Electricity_Order_By>>
  where?: InputMaybe<Meter_Point_Electricity_Bool_Exp>
}

export type Query_RootMeter_Point_Electricity_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootMeter_Point_GasArgs = {
  distinct_on?: InputMaybe<Array<Meter_Point_Gas_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Point_Gas_Order_By>>
  where?: InputMaybe<Meter_Point_Gas_Bool_Exp>
}

export type Query_RootMeter_Point_Gas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Point_Gas_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Point_Gas_Order_By>>
  where?: InputMaybe<Meter_Point_Gas_Bool_Exp>
}

export type Query_RootMeter_Point_Gas_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootMeter_Point_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Meter_Point_History_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Point_History_Order_By>>
  where?: InputMaybe<Meter_Point_History_Bool_Exp>
}

export type Query_RootMeter_Point_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Point_History_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Point_History_Order_By>>
  where?: InputMaybe<Meter_Point_History_Bool_Exp>
}

export type Query_RootMeter_Point_History_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootMeter_ReadingArgs = {
  distinct_on?: InputMaybe<Array<Meter_Reading_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Reading_Order_By>>
  where?: InputMaybe<Meter_Reading_Bool_Exp>
}

export type Query_RootMeter_Reading_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Reading_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Reading_Order_By>>
  where?: InputMaybe<Meter_Reading_Bool_Exp>
}

export type Query_RootMeter_Reading_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootMeter_Reading_Submission_RequestArgs = {
  distinct_on?: InputMaybe<
    Array<Meter_Reading_Submission_Request_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Reading_Submission_Request_Order_By>>
  where?: InputMaybe<Meter_Reading_Submission_Request_Bool_Exp>
}

export type Query_RootMeter_Reading_Submission_Request_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Meter_Reading_Submission_Request_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Reading_Submission_Request_Order_By>>
  where?: InputMaybe<Meter_Reading_Submission_Request_Bool_Exp>
}

export type Query_RootMeter_Reading_Submission_Request_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootMeter_Reading_Submission_TokensArgs = {
  distinct_on?: InputMaybe<Array<Meter_Reading_Submission_Tokens_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Reading_Submission_Tokens_Order_By>>
  where?: InputMaybe<Meter_Reading_Submission_Tokens_Bool_Exp>
}

export type Query_RootMeter_Reading_Submission_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Reading_Submission_Tokens_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Reading_Submission_Tokens_Order_By>>
  where?: InputMaybe<Meter_Reading_Submission_Tokens_Bool_Exp>
}

export type Query_RootMeter_Reading_Submission_Tokens_By_PkArgs = {
  hashed_token: Scalars["String"]["input"]
  junifer_account_id: Scalars["Int"]["input"]
}

export type Query_RootMissing_Contact_DetailsArgs = {
  args: Missing_Contact_Details_Arguments
  distinct_on?: InputMaybe<Array<Missing_Contact_Details_Model_Enum_Name>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Missing_Contact_Details_Model_Order_By>>
  where?: InputMaybe<Missing_Contact_Details_Model_Bool_Exp_Bool_Exp>
}

export type Query_RootNoteArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Note_Order_By>>
  where?: InputMaybe<Note_Bool_Exp>
}

export type Query_RootNote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Note_Order_By>>
  where?: InputMaybe<Note_Bool_Exp>
}

export type Query_RootNote_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootNova_SubmissionsArgs = {
  distinct_on?: InputMaybe<Array<Nova_Submissions_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Nova_Submissions_Order_By>>
  where?: InputMaybe<Nova_Submissions_Bool_Exp>
}

export type Query_RootNova_Submissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nova_Submissions_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Nova_Submissions_Order_By>>
  where?: InputMaybe<Nova_Submissions_Bool_Exp>
}

export type Query_RootOutbound_Photo_RequestArgs = {
  distinct_on?: InputMaybe<Array<Outbound_Photo_Request_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Outbound_Photo_Request_Order_By>>
  where?: InputMaybe<Outbound_Photo_Request_Bool_Exp>
}

export type Query_RootOutbound_Photo_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Outbound_Photo_Request_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Outbound_Photo_Request_Order_By>>
  where?: InputMaybe<Outbound_Photo_Request_Bool_Exp>
}

export type Query_RootOutbound_Photo_Request_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootPassword_Reset_TokensArgs = {
  distinct_on?: InputMaybe<Array<Password_Reset_Tokens_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Password_Reset_Tokens_Order_By>>
  where?: InputMaybe<Password_Reset_Tokens_Bool_Exp>
}

export type Query_RootPassword_Reset_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Password_Reset_Tokens_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Password_Reset_Tokens_Order_By>>
  where?: InputMaybe<Password_Reset_Tokens_Bool_Exp>
}

export type Query_RootPassword_Reset_Tokens_By_PkArgs = {
  token: Scalars["bytea"]["input"]
  user_id: Scalars["bigint"]["input"]
}

export type Query_RootPaymentArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Order_By>>
  where?: InputMaybe<Payment_Bool_Exp>
}

export type Query_RootPayment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Order_By>>
  where?: InputMaybe<Payment_Bool_Exp>
}

export type Query_RootPayment_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootPayment_MethodArgs = {
  distinct_on?: InputMaybe<Array<Payment_Method_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Method_Order_By>>
  where?: InputMaybe<Payment_Method_Bool_Exp>
}

export type Query_RootPayment_Method_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Method_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Method_Order_By>>
  where?: InputMaybe<Payment_Method_Bool_Exp>
}

export type Query_RootPayment_Method_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootPayment_Review_Account_Balance_Reserve_RatesArgs = {
  distinct_on?: InputMaybe<
    Array<Payment_Review_Account_Balance_Reserve_Rates_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Payment_Review_Account_Balance_Reserve_Rates_Order_By>
  >
  where?: InputMaybe<Payment_Review_Account_Balance_Reserve_Rates_Bool_Exp>
}

export type Query_RootPayment_Review_Account_Balance_Reserve_Rates_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Payment_Review_Account_Balance_Reserve_Rates_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Payment_Review_Account_Balance_Reserve_Rates_Order_By>
    >
    where?: InputMaybe<Payment_Review_Account_Balance_Reserve_Rates_Bool_Exp>
  }

export type Query_RootPayment_Review_Account_Balance_Reserve_Rates_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootPayment_Review_Account_ExclusionsArgs = {
  distinct_on?: InputMaybe<
    Array<Payment_Review_Account_Exclusions_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Account_Exclusions_Order_By>>
  where?: InputMaybe<Payment_Review_Account_Exclusions_Bool_Exp>
}

export type Query_RootPayment_Review_Account_Exclusions_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Payment_Review_Account_Exclusions_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Account_Exclusions_Order_By>>
  where?: InputMaybe<Payment_Review_Account_Exclusions_Bool_Exp>
}

export type Query_RootPayment_Review_Account_Exclusions_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootPayment_Review_CalculationArgs = {
  distinct_on?: InputMaybe<Array<Payment_Review_Calculation_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Calculation_Order_By>>
  where?: InputMaybe<Payment_Review_Calculation_Bool_Exp>
}

export type Query_RootPayment_Review_Calculation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Review_Calculation_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Calculation_Order_By>>
  where?: InputMaybe<Payment_Review_Calculation_Bool_Exp>
}

export type Query_RootPayment_Review_Calculation_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootPayment_Review_Dashboard_SummaryArgs = {
  args: Payment_Review_Dashboard_Summary_Arguments
  distinct_on?: InputMaybe<
    Array<Payment_Review_Dashboard_Summary_Model_Enum_Name>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Dashboard_Summary_Model_Order_By>>
  where?: InputMaybe<Payment_Review_Dashboard_Summary_Model_Bool_Exp_Bool_Exp>
}

export type Query_RootPayment_Review_Future_Product_RatesArgs = {
  distinct_on?: InputMaybe<
    Array<Payment_Review_Future_Product_Rates_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Future_Product_Rates_Order_By>>
  where?: InputMaybe<Payment_Review_Future_Product_Rates_Bool_Exp>
}

export type Query_RootPayment_Review_Future_Product_Rates_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Payment_Review_Future_Product_Rates_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Future_Product_Rates_Order_By>>
  where?: InputMaybe<Payment_Review_Future_Product_Rates_Bool_Exp>
}

export type Query_RootPayment_Review_Future_Product_Rates_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootPayment_Review_Record_EmailsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Review_Record_Emails_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Record_Emails_Order_By>>
  where?: InputMaybe<Payment_Review_Record_Emails_Bool_Exp>
}

export type Query_RootPayment_Review_Record_Emails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Review_Record_Emails_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Record_Emails_Order_By>>
  where?: InputMaybe<Payment_Review_Record_Emails_Bool_Exp>
}

export type Query_RootPayment_Review_Record_Emails_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootPayment_Review_Record_NotesArgs = {
  distinct_on?: InputMaybe<Array<Payment_Review_Record_Notes_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Record_Notes_Order_By>>
  where?: InputMaybe<Payment_Review_Record_Notes_Bool_Exp>
}

export type Query_RootPayment_Review_Record_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Review_Record_Notes_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Record_Notes_Order_By>>
  where?: InputMaybe<Payment_Review_Record_Notes_Bool_Exp>
}

export type Query_RootPayment_Review_Record_Notes_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootPayment_Review_RecordsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Review_Records_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Records_Order_By>>
  where?: InputMaybe<Payment_Review_Records_Bool_Exp>
}

export type Query_RootPayment_Review_Records_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Review_Records_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Records_Order_By>>
  where?: InputMaybe<Payment_Review_Records_Bool_Exp>
}

export type Query_RootPayment_Review_Records_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootPayment_Review_Records_ViewArgs = {
  distinct_on?: InputMaybe<Array<Payment_Review_Records_View_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Records_View_Order_By>>
  where?: InputMaybe<Payment_Review_Records_View_Bool_Exp>
}

export type Query_RootPayment_Review_Records_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Review_Records_View_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Records_View_Order_By>>
  where?: InputMaybe<Payment_Review_Records_View_Bool_Exp>
}

export type Query_RootPayment_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Reviews_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Reviews_Order_By>>
  where?: InputMaybe<Payment_Reviews_Bool_Exp>
}

export type Query_RootPayment_Reviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Reviews_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Reviews_Order_By>>
  where?: InputMaybe<Payment_Reviews_Bool_Exp>
}

export type Query_RootPayment_Reviews_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootPayment_ScheduleArgs = {
  distinct_on?: InputMaybe<Array<Payment_Schedule_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Schedule_Order_By>>
  where?: InputMaybe<Payment_Schedule_Bool_Exp>
}

export type Query_RootPayment_Schedule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Schedule_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Schedule_Order_By>>
  where?: InputMaybe<Payment_Schedule_Bool_Exp>
}

export type Query_RootPayment_Schedule_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootPostcode_Gsp_CacheArgs = {
  distinct_on?: InputMaybe<Array<Postcode_Gsp_Cache_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Postcode_Gsp_Cache_Order_By>>
  where?: InputMaybe<Postcode_Gsp_Cache_Bool_Exp>
}

export type Query_RootPostcode_Gsp_Cache_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Postcode_Gsp_Cache_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Postcode_Gsp_Cache_Order_By>>
  where?: InputMaybe<Postcode_Gsp_Cache_Bool_Exp>
}

export type Query_RootPostcode_Gsp_Cache_By_PkArgs = {
  postcode: Scalars["String"]["input"]
}

export type Query_RootProductArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Order_By>>
  where?: InputMaybe<Product_Bool_Exp>
}

export type Query_RootProduct_AccountArgs = {
  distinct_on?: InputMaybe<Array<Product_Account_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Account_Order_By>>
  where?: InputMaybe<Product_Account_Bool_Exp>
}

export type Query_RootProduct_Account_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Account_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Account_Order_By>>
  where?: InputMaybe<Product_Account_Bool_Exp>
}

export type Query_RootProduct_Account_Agreement_RelArgs = {
  distinct_on?: InputMaybe<Array<Product_Account_Agreement_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Account_Agreement_Rel_Order_By>>
  where?: InputMaybe<Product_Account_Agreement_Rel_Bool_Exp>
}

export type Query_RootProduct_Account_Agreement_Rel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Account_Agreement_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Account_Agreement_Rel_Order_By>>
  where?: InputMaybe<Product_Account_Agreement_Rel_Bool_Exp>
}

export type Query_RootProduct_Account_Agreement_Rel_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootProduct_Account_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootProduct_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Order_By>>
  where?: InputMaybe<Product_Bool_Exp>
}

export type Query_RootProduct_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootProduct_ElecArgs = {
  distinct_on?: InputMaybe<Array<Product_Elec_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Elec_Order_By>>
  where?: InputMaybe<Product_Elec_Bool_Exp>
}

export type Query_RootProduct_Elec_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Elec_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Elec_Order_By>>
  where?: InputMaybe<Product_Elec_Bool_Exp>
}

export type Query_RootProduct_Elec_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootProduct_GasArgs = {
  distinct_on?: InputMaybe<Array<Product_Gas_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Gas_Order_By>>
  where?: InputMaybe<Product_Gas_Bool_Exp>
}

export type Query_RootProduct_Gas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Gas_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Gas_Order_By>>
  where?: InputMaybe<Product_Gas_Bool_Exp>
}

export type Query_RootProduct_Gas_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootProduct_VariantArgs = {
  distinct_on?: InputMaybe<Array<Product_Variant_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Variant_Order_By>>
  where?: InputMaybe<Product_Variant_Bool_Exp>
}

export type Query_RootProduct_Variant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variant_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Variant_Order_By>>
  where?: InputMaybe<Product_Variant_Bool_Exp>
}

export type Query_RootProduct_Variant_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootProduct_Variant_ElecArgs = {
  distinct_on?: InputMaybe<Array<Product_Variant_Elec_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Variant_Elec_Order_By>>
  where?: InputMaybe<Product_Variant_Elec_Bool_Exp>
}

export type Query_RootProduct_Variant_Elec_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variant_Elec_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Variant_Elec_Order_By>>
  where?: InputMaybe<Product_Variant_Elec_Bool_Exp>
}

export type Query_RootProduct_Variant_Elec_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootProduct_Variant_GasArgs = {
  distinct_on?: InputMaybe<Array<Product_Variant_Gas_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Variant_Gas_Order_By>>
  where?: InputMaybe<Product_Variant_Gas_Bool_Exp>
}

export type Query_RootProduct_Variant_Gas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variant_Gas_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Variant_Gas_Order_By>>
  where?: InputMaybe<Product_Variant_Gas_Bool_Exp>
}

export type Query_RootProduct_Variant_Gas_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootProduct_ViewArgs = {
  distinct_on?: InputMaybe<Array<Product_View_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_View_Order_By>>
  where?: InputMaybe<Product_View_Bool_Exp>
}

export type Query_RootProduct_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_View_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_View_Order_By>>
  where?: InputMaybe<Product_View_Bool_Exp>
}

export type Query_RootPropertyArgs = {
  distinct_on?: InputMaybe<Array<Property_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Property_Order_By>>
  where?: InputMaybe<Property_Bool_Exp>
}

export type Query_RootProperty_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Property_Order_By>>
  where?: InputMaybe<Property_Bool_Exp>
}

export type Query_RootProperty_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootPsrArgs = {
  distinct_on?: InputMaybe<Array<Psr_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Psr_Order_By>>
  where?: InputMaybe<Psr_Bool_Exp>
}

export type Query_RootPsr_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Psr_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Psr_Order_By>>
  where?: InputMaybe<Psr_Bool_Exp>
}

export type Query_RootPsr_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootQuoteArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Quote_Order_By>>
  where?: InputMaybe<Quote_Bool_Exp>
}

export type Query_RootQuote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Quote_Order_By>>
  where?: InputMaybe<Quote_Bool_Exp>
}

export type Query_RootQuote_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootQuote_RequestArgs = {
  distinct_on?: InputMaybe<Array<Quote_Request_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Quote_Request_Order_By>>
  where?: InputMaybe<Quote_Request_Bool_Exp>
}

export type Query_RootQuote_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Request_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Quote_Request_Order_By>>
  where?: InputMaybe<Quote_Request_Bool_Exp>
}

export type Query_RootQuote_Request_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootRecipientsArgs = {
  distinct_on?: InputMaybe<Array<Recipients_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Recipients_Order_By>>
  where?: InputMaybe<Recipients_Bool_Exp>
}

export type Query_RootRecipients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Recipients_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Recipients_Order_By>>
  where?: InputMaybe<Recipients_Bool_Exp>
}

export type Query_RootRecipients_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootRefresh_TokensArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Tokens_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Refresh_Tokens_Order_By>>
  where?: InputMaybe<Refresh_Tokens_Bool_Exp>
}

export type Query_RootRefresh_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Tokens_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Refresh_Tokens_Order_By>>
  where?: InputMaybe<Refresh_Tokens_Bool_Exp>
}

export type Query_RootRefundsArgs = {
  distinct_on?: InputMaybe<Array<Refunds_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Refunds_Order_By>>
  where?: InputMaybe<Refunds_Bool_Exp>
}

export type Query_RootRefunds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refunds_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Refunds_Order_By>>
  where?: InputMaybe<Refunds_Bool_Exp>
}

export type Query_RootRefunds_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootRegisterArgs = {
  distinct_on?: InputMaybe<Array<Register_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Register_Order_By>>
  where?: InputMaybe<Register_Bool_Exp>
}

export type Query_RootRegister_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Register_Order_By>>
  where?: InputMaybe<Register_Bool_Exp>
}

export type Query_RootRegister_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootRegistration_Credit_CheckArgs = {
  distinct_on?: InputMaybe<Array<Registration_Credit_Check_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Registration_Credit_Check_Order_By>>
  where?: InputMaybe<Registration_Credit_Check_Bool_Exp>
}

export type Query_RootRegistration_Credit_Check_AddressArgs = {
  distinct_on?: InputMaybe<
    Array<Registration_Credit_Check_Address_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Registration_Credit_Check_Address_Order_By>>
  where?: InputMaybe<Registration_Credit_Check_Address_Bool_Exp>
}

export type Query_RootRegistration_Credit_Check_Address_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Registration_Credit_Check_Address_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Registration_Credit_Check_Address_Order_By>>
  where?: InputMaybe<Registration_Credit_Check_Address_Bool_Exp>
}

export type Query_RootRegistration_Credit_Check_Address_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootRegistration_Credit_Check_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Registration_Credit_Check_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Registration_Credit_Check_Order_By>>
  where?: InputMaybe<Registration_Credit_Check_Bool_Exp>
}

export type Query_RootRegistration_Credit_Check_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootReminderArgs = {
  distinct_on?: InputMaybe<Array<Reminder_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Reminder_Order_By>>
  where?: InputMaybe<Reminder_Bool_Exp>
}

export type Query_RootReminder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reminder_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Reminder_Order_By>>
  where?: InputMaybe<Reminder_Bool_Exp>
}

export type Query_RootReminder_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootRenewalArgs = {
  distinct_on?: InputMaybe<Array<Renewal_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Renewal_Order_By>>
  where?: InputMaybe<Renewal_Bool_Exp>
}

export type Query_RootRenewal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Renewal_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Renewal_Order_By>>
  where?: InputMaybe<Renewal_Bool_Exp>
}

export type Query_RootRenewal_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootReport_ProblemArgs = {
  distinct_on?: InputMaybe<Array<Report_Problem_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Report_Problem_Order_By>>
  where?: InputMaybe<Report_Problem_Bool_Exp>
}

export type Query_RootReport_Problem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Problem_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Report_Problem_Order_By>>
  where?: InputMaybe<Report_Problem_Bool_Exp>
}

export type Query_RootReport_Problem_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Report_Problem_Attachments_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Report_Problem_Attachments_Order_By>>
  where?: InputMaybe<Report_Problem_Attachments_Bool_Exp>
}

export type Query_RootReport_Problem_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Problem_Attachments_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Report_Problem_Attachments_Order_By>>
  where?: InputMaybe<Report_Problem_Attachments_Bool_Exp>
}

export type Query_RootReport_Problem_Attachments_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootReport_Problem_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootRequestsArgs = {
  distinct_on?: InputMaybe<Array<Requests_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Requests_Order_By>>
  where?: InputMaybe<Requests_Bool_Exp>
}

export type Query_RootRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Requests_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Requests_Order_By>>
  where?: InputMaybe<Requests_Bool_Exp>
}

export type Query_RootRequests_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootRts_Meters_ReportArgs = {
  distinct_on?: InputMaybe<Array<Rts_Meters_Report_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Rts_Meters_Report_Order_By>>
  where?: InputMaybe<Rts_Meters_Report_Bool_Exp>
}

export type Query_RootRts_Meters_Report_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rts_Meters_Report_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Rts_Meters_Report_Order_By>>
  where?: InputMaybe<Rts_Meters_Report_Bool_Exp>
}

export type Query_RootScheduled_PaymentArgs = {
  distinct_on?: InputMaybe<Array<Scheduled_Payment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Scheduled_Payment_Order_By>>
  where?: InputMaybe<Scheduled_Payment_Bool_Exp>
}

export type Query_RootScheduled_Payment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scheduled_Payment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Scheduled_Payment_Order_By>>
  where?: InputMaybe<Scheduled_Payment_Bool_Exp>
}

export type Query_RootScheduled_Payment_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootScheduled_RefundArgs = {
  distinct_on?: InputMaybe<Array<Scheduled_Refund_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Scheduled_Refund_Order_By>>
  where?: InputMaybe<Scheduled_Refund_Bool_Exp>
}

export type Query_RootScheduled_Refund_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scheduled_Refund_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Scheduled_Refund_Order_By>>
  where?: InputMaybe<Scheduled_Refund_Bool_Exp>
}

export type Query_RootScheduled_Refund_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootSmart_ChargingArgs = {
  distinct_on?: InputMaybe<Array<Smart_Charging_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Smart_Charging_Order_By>>
  where?: InputMaybe<Smart_Charging_Bool_Exp>
}

export type Query_RootSmart_Charging_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Smart_Charging_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Smart_Charging_Order_By>>
  where?: InputMaybe<Smart_Charging_Bool_Exp>
}

export type Query_RootSmart_Charging_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootSmart_Meter_Dashboard_Response_V7Args = {
  distinct_on?: InputMaybe<
    Array<Smart_Meter_Dashboard_Response_V7_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Smart_Meter_Dashboard_Response_V7_Order_By>>
  where?: InputMaybe<Smart_Meter_Dashboard_Response_V7_Bool_Exp>
}

export type Query_RootSmart_Meter_Dashboard_Response_V7_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Smart_Meter_Dashboard_Response_V7_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Smart_Meter_Dashboard_Response_V7_Order_By>>
  where?: InputMaybe<Smart_Meter_Dashboard_Response_V7_Bool_Exp>
}

export type Query_RootSmart_Meter_Dashboard_SummaryArgs = {
  distinct_on?: InputMaybe<
    Array<Smart_Meter_Dashboard_Order_By_Dev_Status_Model_Enum_Name>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Smart_Meter_Dashboard_Order_By_Dev_Status_Model_Order_By>
  >
  where?: InputMaybe<Smart_Meter_Dashboard_Order_By_Dev_Status_Model_Bool_Exp_Bool_Exp>
}

export type Query_RootSmart_Meter_Dashboard_Workstream_SummaryArgs = {
  distinct_on?: InputMaybe<
    Array<Smart_Meter_Dashboard_Order_By_Workstream_Model_Enum_Name>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Smart_Meter_Dashboard_Order_By_Workstream_Model_Order_By>
  >
  where?: InputMaybe<Smart_Meter_Dashboard_Order_By_Workstream_Model_Bool_Exp_Bool_Exp>
}

export type Query_RootSmart_Meters_Eligible_For_ExchangeArgs = {
  distinct_on?: InputMaybe<
    Array<Smart_Meters_Eligible_For_Exchange_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Smart_Meters_Eligible_For_Exchange_Order_By>>
  where?: InputMaybe<Smart_Meters_Eligible_For_Exchange_Bool_Exp>
}

export type Query_RootSmart_Meters_Eligible_For_Exchange_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Smart_Meters_Eligible_For_Exchange_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Smart_Meters_Eligible_For_Exchange_Order_By>>
  where?: InputMaybe<Smart_Meters_Eligible_For_Exchange_Bool_Exp>
}

export type Query_RootSmart_Meters_Eligible_For_Exchange_By_PkArgs = {
  meter_serial_number: Scalars["String"]["input"]
  mpxn: Scalars["String"]["input"]
}

export type Query_RootSync_StatusArgs = {
  distinct_on?: InputMaybe<Array<Sync_Status_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Sync_Status_Order_By>>
  where?: InputMaybe<Sync_Status_Bool_Exp>
}

export type Query_RootSync_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sync_Status_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Sync_Status_Order_By>>
  where?: InputMaybe<Sync_Status_Bool_Exp>
}

export type Query_RootSync_Status_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootSynchronized_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Synchronized_Accounts_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Synchronized_Accounts_Order_By>>
  where?: InputMaybe<Synchronized_Accounts_Bool_Exp>
}

export type Query_RootSynchronized_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Synchronized_Accounts_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Synchronized_Accounts_Order_By>>
  where?: InputMaybe<Synchronized_Accounts_Bool_Exp>
}

export type Query_RootSynchronized_Accounts_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTicketArgs = {
  distinct_on?: InputMaybe<Array<Ticket_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Ticket_Order_By>>
  where?: InputMaybe<Ticket_Bool_Exp>
}

export type Query_RootTicket_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticket_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Ticket_Order_By>>
  where?: InputMaybe<Ticket_Bool_Exp>
}

export type Query_RootTicket_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_Automation_Account_StoreArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Automation_Account_Store_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Account_Store_Order_By>>
  where?: InputMaybe<Tickets_Automation_Account_Store_Bool_Exp>
}

export type Query_RootTickets_Automation_Account_Store_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Automation_Account_Store_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Account_Store_Order_By>>
  where?: InputMaybe<Tickets_Automation_Account_Store_Bool_Exp>
}

export type Query_RootTickets_Automation_Account_Store_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_Automation_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Automation_Config_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Config_Order_By>>
  where?: InputMaybe<Tickets_Automation_Config_Bool_Exp>
}

export type Query_RootTickets_Automation_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Automation_Config_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Config_Order_By>>
  where?: InputMaybe<Tickets_Automation_Config_Bool_Exp>
}

export type Query_RootTickets_Automation_Config_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_Automation_Config_DefaultArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Automation_Config_Default_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Config_Default_Order_By>>
  where?: InputMaybe<Tickets_Automation_Config_Default_Bool_Exp>
}

export type Query_RootTickets_Automation_Config_Default_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Automation_Config_Default_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Config_Default_Order_By>>
  where?: InputMaybe<Tickets_Automation_Config_Default_Bool_Exp>
}

export type Query_RootTickets_Automation_Config_Default_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_Automation_Config_PurgeArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Automation_Config_Purge_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Config_Purge_Order_By>>
  where?: InputMaybe<Tickets_Automation_Config_Purge_Bool_Exp>
}

export type Query_RootTickets_Automation_Config_Purge_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Automation_Config_Purge_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Config_Purge_Order_By>>
  where?: InputMaybe<Tickets_Automation_Config_Purge_Bool_Exp>
}

export type Query_RootTickets_Automation_Config_Purge_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_Automation_Default_Ticket_ActionArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Automation_Default_Ticket_Action_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Tickets_Automation_Default_Ticket_Action_Order_By>
  >
  where?: InputMaybe<Tickets_Automation_Default_Ticket_Action_Bool_Exp>
}

export type Query_RootTickets_Automation_Default_Ticket_Action_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Automation_Default_Ticket_Action_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Tickets_Automation_Default_Ticket_Action_Order_By>
  >
  where?: InputMaybe<Tickets_Automation_Default_Ticket_Action_Bool_Exp>
}

export type Query_RootTickets_Automation_Default_Ticket_Action_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_Automation_Defaults_Acceptable_Accounts_TableArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Order_By>
    >
    where?: InputMaybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Bool_Exp>
  }

export type Query_RootTickets_Automation_Defaults_Acceptable_Accounts_Table_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Order_By>
    >
    where?: InputMaybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Bool_Exp>
  }

export type Query_RootTickets_Automation_Defaults_Acceptable_Accounts_Table_By_PkArgs =
  {
    accountid: Scalars["bigint"]["input"]
  }

export type Query_RootTickets_Automation_Defaults_Opened_PredefaultsArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Automation_Defaults_Opened_Predefaults_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Tickets_Automation_Defaults_Opened_Predefaults_Order_By>
  >
  where?: InputMaybe<Tickets_Automation_Defaults_Opened_Predefaults_Bool_Exp>
}

export type Query_RootTickets_Automation_Defaults_Opened_Predefaults_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Automation_Defaults_Opened_Predefaults_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Tickets_Automation_Defaults_Opened_Predefaults_Order_By>
    >
    where?: InputMaybe<Tickets_Automation_Defaults_Opened_Predefaults_Bool_Exp>
  }

export type Query_RootTickets_Automation_Defaults_Opened_Predefaults_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

export type Query_RootTickets_Automation_JobArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Automation_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Job_Order_By>>
  where?: InputMaybe<Tickets_Automation_Job_Bool_Exp>
}

export type Query_RootTickets_Automation_Job_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Automation_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Job_Order_By>>
  where?: InputMaybe<Tickets_Automation_Job_Bool_Exp>
}

export type Query_RootTickets_Automation_Job_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_Automation_Purge_JobArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Automation_Purge_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Purge_Job_Order_By>>
  where?: InputMaybe<Tickets_Automation_Purge_Job_Bool_Exp>
}

export type Query_RootTickets_Automation_Purge_Job_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Automation_Purge_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Purge_Job_Order_By>>
  where?: InputMaybe<Tickets_Automation_Purge_Job_Bool_Exp>
}

export type Query_RootTickets_Automation_Purge_Job_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_Automation_Ticket_StoreArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Automation_Ticket_Store_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Ticket_Store_Order_By>>
  where?: InputMaybe<Tickets_Automation_Ticket_Store_Bool_Exp>
}

export type Query_RootTickets_Automation_Ticket_Store_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Automation_Ticket_Store_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Ticket_Store_Order_By>>
  where?: InputMaybe<Tickets_Automation_Ticket_Store_Bool_Exp>
}

export type Query_RootTickets_Automation_Ticket_Store_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_Dca_Account_AllocationArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dca_Account_Allocation_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dca_Account_Allocation_Order_By>>
  where?: InputMaybe<Tickets_Dca_Account_Allocation_Bool_Exp>
}

export type Query_RootTickets_Dca_Account_Allocation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dca_Account_Allocation_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dca_Account_Allocation_Order_By>>
  where?: InputMaybe<Tickets_Dca_Account_Allocation_Bool_Exp>
}

export type Query_RootTickets_Dca_Account_Allocation_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_Dca_Allocation_ConfigurationArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Dca_Allocation_Configuration_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dca_Allocation_Configuration_Order_By>>
  where?: InputMaybe<Tickets_Dca_Allocation_Configuration_Bool_Exp>
}

export type Query_RootTickets_Dca_Allocation_Configuration_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Dca_Allocation_Configuration_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dca_Allocation_Configuration_Order_By>>
  where?: InputMaybe<Tickets_Dca_Allocation_Configuration_Bool_Exp>
}

export type Query_RootTickets_Dca_Allocation_Configuration_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_Dca_Configuration_V2Args = {
  distinct_on?: InputMaybe<Array<Tickets_Dca_Configuration_V2_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dca_Configuration_V2_Order_By>>
  where?: InputMaybe<Tickets_Dca_Configuration_V2_Bool_Exp>
}

export type Query_RootTickets_Dca_Configuration_V2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dca_Configuration_V2_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dca_Configuration_V2_Order_By>>
  where?: InputMaybe<Tickets_Dca_Configuration_V2_Bool_Exp>
}

export type Query_RootTickets_Dca_Configuration_V2_By_PkArgs = {
  dca: Scalars["String"]["input"]
}

export type Query_RootTickets_Dca_SegmentationArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dca_Segmentation_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dca_Segmentation_Order_By>>
  where?: InputMaybe<Tickets_Dca_Segmentation_Bool_Exp>
}

export type Query_RootTickets_Dca_Segmentation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dca_Segmentation_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dca_Segmentation_Order_By>>
  where?: InputMaybe<Tickets_Dca_Segmentation_Bool_Exp>
}

export type Query_RootTickets_Dca_Segmentation_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_Dunning_Account_StoreArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Account_Store_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Account_Store_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Account_Store_Bool_Exp>
}

export type Query_RootTickets_Dunning_Account_Store_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Account_Store_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Account_Store_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Account_Store_Bool_Exp>
}

export type Query_RootTickets_Dunning_Account_Store_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_Dunning_Addacs_Review_RecordsArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Dunning_Addacs_Review_Records_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Addacs_Review_Records_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Addacs_Review_Records_Bool_Exp>
}

export type Query_RootTickets_Dunning_Addacs_Review_Records_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Dunning_Addacs_Review_Records_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Addacs_Review_Records_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Addacs_Review_Records_Bool_Exp>
}

export type Query_RootTickets_Dunning_Addacs_Review_Records_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_Dunning_Automation_EventsArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Dunning_Automation_Events_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Automation_Events_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Automation_Events_Bool_Exp>
}

export type Query_RootTickets_Dunning_Automation_Events_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Dunning_Automation_Events_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Automation_Events_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Automation_Events_Bool_Exp>
}

export type Query_RootTickets_Dunning_Automation_Events_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_Dunning_Debt_Ticket_Review_RecordsArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Dunning_Debt_Ticket_Review_Records_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Tickets_Dunning_Debt_Ticket_Review_Records_Order_By>
  >
  where?: InputMaybe<Tickets_Dunning_Debt_Ticket_Review_Records_Bool_Exp>
}

export type Query_RootTickets_Dunning_Debt_Ticket_Review_Records_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Dunning_Debt_Ticket_Review_Records_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Tickets_Dunning_Debt_Ticket_Review_Records_Order_By>
    >
    where?: InputMaybe<Tickets_Dunning_Debt_Ticket_Review_Records_Bool_Exp>
  }

export type Query_RootTickets_Dunning_Debt_Ticket_Review_Records_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_Dunning_JobArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Job_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Job_Bool_Exp>
}

export type Query_RootTickets_Dunning_Job_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Job_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Job_Bool_Exp>
}

export type Query_RootTickets_Dunning_Job_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_Dunning_Legal_Known_Ticket_RecordsArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Dunning_Legal_Known_Ticket_Records_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Tickets_Dunning_Legal_Known_Ticket_Records_Order_By>
  >
  where?: InputMaybe<Tickets_Dunning_Legal_Known_Ticket_Records_Bool_Exp>
}

export type Query_RootTickets_Dunning_Legal_Known_Ticket_Records_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Dunning_Legal_Known_Ticket_Records_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Tickets_Dunning_Legal_Known_Ticket_Records_Order_By>
    >
    where?: InputMaybe<Tickets_Dunning_Legal_Known_Ticket_Records_Bool_Exp>
  }

export type Query_RootTickets_Dunning_Legal_Known_Ticket_Records_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_Dunning_Legal_Occupier_Ticket_RecordsArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Dunning_Legal_Occupier_Ticket_Records_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Tickets_Dunning_Legal_Occupier_Ticket_Records_Order_By>
  >
  where?: InputMaybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Bool_Exp>
}

export type Query_RootTickets_Dunning_Legal_Occupier_Ticket_Records_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Dunning_Legal_Occupier_Ticket_Records_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Tickets_Dunning_Legal_Occupier_Ticket_Records_Order_By>
    >
    where?: InputMaybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Bool_Exp>
  }

export type Query_RootTickets_Dunning_Legal_Occupier_Ticket_Records_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

export type Query_RootTickets_Dunning_Occupier_Accounts_Review_RecordsArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Dunning_Occupier_Accounts_Review_Records_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Tickets_Dunning_Occupier_Accounts_Review_Records_Order_By>
  >
  where?: InputMaybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Bool_Exp>
}

export type Query_RootTickets_Dunning_Occupier_Accounts_Review_Records_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Dunning_Occupier_Accounts_Review_Records_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Tickets_Dunning_Occupier_Accounts_Review_Records_Order_By>
    >
    where?: InputMaybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Bool_Exp>
  }

export type Query_RootTickets_Dunning_Occupier_Accounts_Review_Records_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

export type Query_RootTickets_Dunning_Purge_JobArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Purge_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Purge_Job_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Purge_Job_Bool_Exp>
}

export type Query_RootTickets_Dunning_Purge_Job_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Purge_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Purge_Job_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Purge_Job_Bool_Exp>
}

export type Query_RootTickets_Dunning_Purge_Job_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_Dunning_Standard_Ticket_RecordsArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Dunning_Standard_Ticket_Records_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Standard_Ticket_Records_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Standard_Ticket_Records_Bool_Exp>
}

export type Query_RootTickets_Dunning_Standard_Ticket_Records_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Dunning_Standard_Ticket_Records_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Standard_Ticket_Records_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Standard_Ticket_Records_Bool_Exp>
}

export type Query_RootTickets_Dunning_Standard_Ticket_Records_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_Dunning_StatisticsArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Statistics_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Statistics_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Statistics_Bool_Exp>
}

export type Query_RootTickets_Dunning_Statistics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Statistics_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Statistics_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Statistics_Bool_Exp>
}

export type Query_RootTickets_Dunning_Statistics_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_Dunning_Terminating_Accounts_Review_RecordsArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Dunning_Terminating_Accounts_Review_Records_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Tickets_Dunning_Terminating_Accounts_Review_Records_Order_By>
    >
    where?: InputMaybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Bool_Exp>
  }

export type Query_RootTickets_Dunning_Terminating_Accounts_Review_Records_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Dunning_Terminating_Accounts_Review_Records_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Tickets_Dunning_Terminating_Accounts_Review_Records_Order_By>
    >
    where?: InputMaybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Bool_Exp>
  }

export type Query_RootTickets_Dunning_Terminating_Accounts_Review_Records_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

export type Query_RootTickets_Dunning_Ticket_StoreArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Ticket_Store_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Ticket_Store_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Ticket_Store_Bool_Exp>
}

export type Query_RootTickets_Dunning_Ticket_Store_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Ticket_Store_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Ticket_Store_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Ticket_Store_Bool_Exp>
}

export type Query_RootTickets_Dunning_Ticket_Store_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_Dunning_WorkflowArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Workflow_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Workflow_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Workflow_Bool_Exp>
}

export type Query_RootTickets_Dunning_Workflow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Workflow_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Workflow_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Workflow_Bool_Exp>
}

export type Query_RootTickets_Dunning_Workflow_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_External_EventArgs = {
  distinct_on?: InputMaybe<Array<Tickets_External_Event_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_External_Event_Order_By>>
  where?: InputMaybe<Tickets_External_Event_Bool_Exp>
}

export type Query_RootTickets_External_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_External_Event_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_External_Event_Order_By>>
  where?: InputMaybe<Tickets_External_Event_Bool_Exp>
}

export type Query_RootTickets_External_Event_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_External_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Tickets_External_Tickets_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_External_Tickets_Order_By>>
  where?: InputMaybe<Tickets_External_Tickets_Bool_Exp>
}

export type Query_RootTickets_External_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_External_Tickets_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_External_Tickets_Order_By>>
  where?: InputMaybe<Tickets_External_Tickets_Bool_Exp>
}

export type Query_RootTickets_External_Tickets_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootTickets_Qrtz_Blob_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Blob_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Blob_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Blob_Triggers_Bool_Exp>
}

export type Query_RootTickets_Qrtz_Blob_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Blob_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Blob_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Blob_Triggers_Bool_Exp>
}

export type Query_RootTickets_Qrtz_Blob_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

export type Query_RootTickets_Qrtz_CalendarsArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Calendars_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Calendars_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Calendars_Bool_Exp>
}

export type Query_RootTickets_Qrtz_Calendars_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Calendars_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Calendars_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Calendars_Bool_Exp>
}

export type Query_RootTickets_Qrtz_Calendars_By_PkArgs = {
  calendar_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

export type Query_RootTickets_Qrtz_Cron_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Cron_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Cron_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Cron_Triggers_Bool_Exp>
}

export type Query_RootTickets_Qrtz_Cron_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Cron_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Cron_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Cron_Triggers_Bool_Exp>
}

export type Query_RootTickets_Qrtz_Cron_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

export type Query_RootTickets_Qrtz_Fired_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Fired_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Fired_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Fired_Triggers_Bool_Exp>
}

export type Query_RootTickets_Qrtz_Fired_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Fired_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Fired_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Fired_Triggers_Bool_Exp>
}

export type Query_RootTickets_Qrtz_Fired_Triggers_By_PkArgs = {
  entry_id: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

export type Query_RootTickets_Qrtz_Job_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Job_Details_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Job_Details_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Job_Details_Bool_Exp>
}

export type Query_RootTickets_Qrtz_Job_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Job_Details_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Job_Details_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Job_Details_Bool_Exp>
}

export type Query_RootTickets_Qrtz_Job_Details_By_PkArgs = {
  job_group: Scalars["String"]["input"]
  job_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

export type Query_RootTickets_Qrtz_LocksArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Locks_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Locks_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Locks_Bool_Exp>
}

export type Query_RootTickets_Qrtz_Locks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Locks_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Locks_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Locks_Bool_Exp>
}

export type Query_RootTickets_Qrtz_Locks_By_PkArgs = {
  lock_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

export type Query_RootTickets_Qrtz_Paused_Trigger_GrpsArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Qrtz_Paused_Trigger_Grps_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Paused_Trigger_Grps_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Paused_Trigger_Grps_Bool_Exp>
}

export type Query_RootTickets_Qrtz_Paused_Trigger_Grps_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Qrtz_Paused_Trigger_Grps_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Paused_Trigger_Grps_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Paused_Trigger_Grps_Bool_Exp>
}

export type Query_RootTickets_Qrtz_Paused_Trigger_Grps_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
}

export type Query_RootTickets_Qrtz_Scheduler_StateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Scheduler_State_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Scheduler_State_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Scheduler_State_Bool_Exp>
}

export type Query_RootTickets_Qrtz_Scheduler_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Scheduler_State_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Scheduler_State_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Scheduler_State_Bool_Exp>
}

export type Query_RootTickets_Qrtz_Scheduler_State_By_PkArgs = {
  instance_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

export type Query_RootTickets_Qrtz_Simple_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Simple_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Simple_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Simple_Triggers_Bool_Exp>
}

export type Query_RootTickets_Qrtz_Simple_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Simple_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Simple_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Simple_Triggers_Bool_Exp>
}

export type Query_RootTickets_Qrtz_Simple_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

export type Query_RootTickets_Qrtz_Simprop_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Simprop_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Simprop_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Simprop_Triggers_Bool_Exp>
}

export type Query_RootTickets_Qrtz_Simprop_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Simprop_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Simprop_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Simprop_Triggers_Bool_Exp>
}

export type Query_RootTickets_Qrtz_Simprop_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

export type Query_RootTickets_Qrtz_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Triggers_Bool_Exp>
}

export type Query_RootTickets_Qrtz_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Triggers_Bool_Exp>
}

export type Query_RootTickets_Qrtz_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

export type Query_RootTrustpilot_InvitationsArgs = {
  distinct_on?: InputMaybe<Array<Trustpilot_Invitations_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Trustpilot_Invitations_Order_By>>
  where?: InputMaybe<Trustpilot_Invitations_Bool_Exp>
}

export type Query_RootTrustpilot_Invitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trustpilot_Invitations_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Trustpilot_Invitations_Order_By>>
  where?: InputMaybe<Trustpilot_Invitations_Bool_Exp>
}

export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Users_Order_By>>
  where?: InputMaybe<Users_Bool_Exp>
}

export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Users_Order_By>>
  where?: InputMaybe<Users_Bool_Exp>
}

export type Query_RootUsers_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootUswitch_RecordArgs = {
  distinct_on?: InputMaybe<Array<Uswitch_Record_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Uswitch_Record_Order_By>>
  where?: InputMaybe<Uswitch_Record_Bool_Exp>
}

export type Query_RootUswitch_Record_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uswitch_Record_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Uswitch_Record_Order_By>>
  where?: InputMaybe<Uswitch_Record_Bool_Exp>
}

export type Query_RootUswitch_Record_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootWarm_Home_Discount_ApplicationArgs = {
  distinct_on?: InputMaybe<Array<Warm_Home_Discount_Application_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Warm_Home_Discount_Application_Order_By>>
  where?: InputMaybe<Warm_Home_Discount_Application_Bool_Exp>
}

export type Query_RootWarm_Home_Discount_Application_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Warm_Home_Discount_Application_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Warm_Home_Discount_Application_Order_By>>
  where?: InputMaybe<Warm_Home_Discount_Application_Bool_Exp>
}

export type Query_RootWarm_Home_Discount_Application_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootWarm_Home_Discount_Application_Status_HistoryArgs = {
  distinct_on?: InputMaybe<
    Array<Warm_Home_Discount_Application_Status_History_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Warm_Home_Discount_Application_Status_History_Order_By>
  >
  where?: InputMaybe<Warm_Home_Discount_Application_Status_History_Bool_Exp>
}

export type Query_RootWarm_Home_Discount_Application_Status_History_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Warm_Home_Discount_Application_Status_History_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Warm_Home_Discount_Application_Status_History_Order_By>
    >
    where?: InputMaybe<Warm_Home_Discount_Application_Status_History_Bool_Exp>
  }

export type Query_RootWarm_Home_Discount_Application_Status_History_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

export type Query_RootWarm_Home_Discount_CriteriaArgs = {
  distinct_on?: InputMaybe<Array<Warm_Home_Discount_Criteria_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Warm_Home_Discount_Criteria_Order_By>>
  where?: InputMaybe<Warm_Home_Discount_Criteria_Bool_Exp>
}

export type Query_RootWarm_Home_Discount_Criteria_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Warm_Home_Discount_Criteria_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Warm_Home_Discount_Criteria_Order_By>>
  where?: InputMaybe<Warm_Home_Discount_Criteria_Bool_Exp>
}

export type Query_RootWarm_Home_Discount_Criteria_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Query_RootWarm_Home_Discount_Criteria_RelArgs = {
  distinct_on?: InputMaybe<Array<Warm_Home_Discount_Criteria_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Warm_Home_Discount_Criteria_Rel_Order_By>>
  where?: InputMaybe<Warm_Home_Discount_Criteria_Rel_Bool_Exp>
}

export type Query_RootWarm_Home_Discount_Criteria_Rel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Warm_Home_Discount_Criteria_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Warm_Home_Discount_Criteria_Rel_Order_By>>
  where?: InputMaybe<Warm_Home_Discount_Criteria_Rel_Bool_Exp>
}

export type Query_RootWarm_Home_Discount_Criteria_Rel_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

/** columns and relationships of "quote" */
export type Quote = {
  __typename?: "quote"
  account_id?: Maybe<Scalars["bigint"]["output"]>
  archiveddttm?: Maybe<Scalars["timestamp"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  data: Scalars["json"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  /** An array relationship */
  quote_requests: Array<Quote_Request>
  /** An aggregate relationship */
  quote_requests_aggregate: Quote_Request_Aggregate
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "quote" */
export type QuoteDataArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** columns and relationships of "quote" */
export type QuoteQuote_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Quote_Request_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Quote_Request_Order_By>>
  where?: InputMaybe<Quote_Request_Bool_Exp>
}

/** columns and relationships of "quote" */
export type QuoteQuote_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Request_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Quote_Request_Order_By>>
  where?: InputMaybe<Quote_Request_Bool_Exp>
}

/** aggregated selection of "quote" */
export type Quote_Aggregate = {
  __typename?: "quote_aggregate"
  aggregate?: Maybe<Quote_Aggregate_Fields>
  nodes: Array<Quote>
}

/** aggregate fields of "quote" */
export type Quote_Aggregate_Fields = {
  __typename?: "quote_aggregate_fields"
  avg?: Maybe<Quote_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Quote_Max_Fields>
  min?: Maybe<Quote_Min_Fields>
  stddev?: Maybe<Quote_Stddev_Fields>
  stddev_pop?: Maybe<Quote_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Quote_Stddev_Samp_Fields>
  sum?: Maybe<Quote_Sum_Fields>
  var_pop?: Maybe<Quote_Var_Pop_Fields>
  var_samp?: Maybe<Quote_Var_Samp_Fields>
  variance?: Maybe<Quote_Variance_Fields>
}

/** aggregate fields of "quote" */
export type Quote_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quote_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Quote_Avg_Fields = {
  __typename?: "quote_avg_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "quote". All fields are combined with a logical 'AND'. */
export type Quote_Bool_Exp = {
  _and?: InputMaybe<Array<Quote_Bool_Exp>>
  _not?: InputMaybe<Quote_Bool_Exp>
  _or?: InputMaybe<Array<Quote_Bool_Exp>>
  account_id?: InputMaybe<Bigint_Comparison_Exp>
  archiveddttm?: InputMaybe<Timestamp_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  data?: InputMaybe<Json_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  quote_requests?: InputMaybe<Quote_Request_Bool_Exp>
  quote_requests_aggregate?: InputMaybe<Quote_Request_Aggregate_Bool_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "quote" */
export enum Quote_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkQuote = "pk_quote",
}

/** input type for incrementing numeric columns in table "quote" */
export type Quote_Inc_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "quote" */
export type Quote_Insert_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  archiveddttm?: InputMaybe<Scalars["timestamp"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  data?: InputMaybe<Scalars["json"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  quote_requests?: InputMaybe<Quote_Request_Arr_Rel_Insert_Input>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Quote_Max_Fields = {
  __typename?: "quote_max_fields"
  account_id?: Maybe<Scalars["bigint"]["output"]>
  archiveddttm?: Maybe<Scalars["timestamp"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Quote_Min_Fields = {
  __typename?: "quote_min_fields"
  account_id?: Maybe<Scalars["bigint"]["output"]>
  archiveddttm?: Maybe<Scalars["timestamp"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "quote" */
export type Quote_Mutation_Response = {
  __typename?: "quote_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Quote>
}

/** input type for inserting object relation for remote table "quote" */
export type Quote_Obj_Rel_Insert_Input = {
  data: Quote_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Quote_On_Conflict>
}

/** on_conflict condition type for table "quote" */
export type Quote_On_Conflict = {
  constraint: Quote_Constraint
  update_columns?: Array<Quote_Update_Column>
  where?: InputMaybe<Quote_Bool_Exp>
}

/** Ordering options when selecting data from "quote". */
export type Quote_Order_By = {
  account_id?: InputMaybe<Order_By>
  archiveddttm?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  data?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  quote_requests_aggregate?: InputMaybe<Quote_Request_Aggregate_Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: quote */
export type Quote_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** columns and relationships of "quote_request" */
export type Quote_Request = {
  __typename?: "quote_request"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  data: Scalars["json"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  /** An object relationship */
  quote?: Maybe<Quote>
  quote_id?: Maybe<Scalars["bigint"]["output"]>
  type: Scalars["quote_request_type"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "quote_request" */
export type Quote_RequestDataArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregated selection of "quote_request" */
export type Quote_Request_Aggregate = {
  __typename?: "quote_request_aggregate"
  aggregate?: Maybe<Quote_Request_Aggregate_Fields>
  nodes: Array<Quote_Request>
}

export type Quote_Request_Aggregate_Bool_Exp = {
  count?: InputMaybe<Quote_Request_Aggregate_Bool_Exp_Count>
}

export type Quote_Request_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quote_Request_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Quote_Request_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "quote_request" */
export type Quote_Request_Aggregate_Fields = {
  __typename?: "quote_request_aggregate_fields"
  avg?: Maybe<Quote_Request_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Quote_Request_Max_Fields>
  min?: Maybe<Quote_Request_Min_Fields>
  stddev?: Maybe<Quote_Request_Stddev_Fields>
  stddev_pop?: Maybe<Quote_Request_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Quote_Request_Stddev_Samp_Fields>
  sum?: Maybe<Quote_Request_Sum_Fields>
  var_pop?: Maybe<Quote_Request_Var_Pop_Fields>
  var_samp?: Maybe<Quote_Request_Var_Samp_Fields>
  variance?: Maybe<Quote_Request_Variance_Fields>
}

/** aggregate fields of "quote_request" */
export type Quote_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quote_Request_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "quote_request" */
export type Quote_Request_Aggregate_Order_By = {
  avg?: InputMaybe<Quote_Request_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Quote_Request_Max_Order_By>
  min?: InputMaybe<Quote_Request_Min_Order_By>
  stddev?: InputMaybe<Quote_Request_Stddev_Order_By>
  stddev_pop?: InputMaybe<Quote_Request_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Quote_Request_Stddev_Samp_Order_By>
  sum?: InputMaybe<Quote_Request_Sum_Order_By>
  var_pop?: InputMaybe<Quote_Request_Var_Pop_Order_By>
  var_samp?: InputMaybe<Quote_Request_Var_Samp_Order_By>
  variance?: InputMaybe<Quote_Request_Variance_Order_By>
}

/** input type for inserting array relation for remote table "quote_request" */
export type Quote_Request_Arr_Rel_Insert_Input = {
  data: Array<Quote_Request_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Quote_Request_On_Conflict>
}

/** aggregate avg on columns */
export type Quote_Request_Avg_Fields = {
  __typename?: "quote_request_avg_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  quote_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "quote_request" */
export type Quote_Request_Avg_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  quote_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "quote_request". All fields are combined with a logical 'AND'. */
export type Quote_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Quote_Request_Bool_Exp>>
  _not?: InputMaybe<Quote_Request_Bool_Exp>
  _or?: InputMaybe<Array<Quote_Request_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  customer_id?: InputMaybe<Bigint_Comparison_Exp>
  data?: InputMaybe<Json_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  quote?: InputMaybe<Quote_Bool_Exp>
  quote_id?: InputMaybe<Bigint_Comparison_Exp>
  type?: InputMaybe<Quote_Request_Type_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "quote_request" */
export enum Quote_Request_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkQuoteRequest = "pk_quote_request",
}

/** input type for incrementing numeric columns in table "quote_request" */
export type Quote_Request_Inc_Input = {
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  quote_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "quote_request" */
export type Quote_Request_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  data?: InputMaybe<Scalars["json"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  quote?: InputMaybe<Quote_Obj_Rel_Insert_Input>
  quote_id?: InputMaybe<Scalars["bigint"]["input"]>
  type?: InputMaybe<Scalars["quote_request_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Quote_Request_Max_Fields = {
  __typename?: "quote_request_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  quote_id?: Maybe<Scalars["bigint"]["output"]>
  type?: Maybe<Scalars["quote_request_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "quote_request" */
export type Quote_Request_Max_Order_By = {
  account_number?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  quote_id?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Quote_Request_Min_Fields = {
  __typename?: "quote_request_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  quote_id?: Maybe<Scalars["bigint"]["output"]>
  type?: Maybe<Scalars["quote_request_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "quote_request" */
export type Quote_Request_Min_Order_By = {
  account_number?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  quote_id?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "quote_request" */
export type Quote_Request_Mutation_Response = {
  __typename?: "quote_request_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Quote_Request>
}

/** on_conflict condition type for table "quote_request" */
export type Quote_Request_On_Conflict = {
  constraint: Quote_Request_Constraint
  update_columns?: Array<Quote_Request_Update_Column>
  where?: InputMaybe<Quote_Request_Bool_Exp>
}

/** Ordering options when selecting data from "quote_request". */
export type Quote_Request_Order_By = {
  account_number?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  data?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  quote?: InputMaybe<Quote_Order_By>
  quote_id?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: quote_request */
export type Quote_Request_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "quote_request" */
export enum Quote_Request_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  Data = "data",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  QuoteId = "quote_id",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "quote_request" */
export type Quote_Request_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  data?: InputMaybe<Scalars["json"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  quote_id?: InputMaybe<Scalars["bigint"]["input"]>
  type?: InputMaybe<Scalars["quote_request_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Quote_Request_Stddev_Fields = {
  __typename?: "quote_request_stddev_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  quote_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "quote_request" */
export type Quote_Request_Stddev_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  quote_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Quote_Request_Stddev_Pop_Fields = {
  __typename?: "quote_request_stddev_pop_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  quote_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "quote_request" */
export type Quote_Request_Stddev_Pop_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  quote_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Quote_Request_Stddev_Samp_Fields = {
  __typename?: "quote_request_stddev_samp_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  quote_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "quote_request" */
export type Quote_Request_Stddev_Samp_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  quote_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "quote_request" */
export type Quote_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quote_Request_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Quote_Request_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  data?: InputMaybe<Scalars["json"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  quote_id?: InputMaybe<Scalars["bigint"]["input"]>
  type?: InputMaybe<Scalars["quote_request_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Quote_Request_Sum_Fields = {
  __typename?: "quote_request_sum_fields"
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  quote_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "quote_request" */
export type Quote_Request_Sum_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  quote_id?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "quote_request_type". All fields are combined with logical 'AND'. */
export type Quote_Request_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["quote_request_type"]["input"]>
  _gt?: InputMaybe<Scalars["quote_request_type"]["input"]>
  _gte?: InputMaybe<Scalars["quote_request_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["quote_request_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["quote_request_type"]["input"]>
  _lte?: InputMaybe<Scalars["quote_request_type"]["input"]>
  _neq?: InputMaybe<Scalars["quote_request_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["quote_request_type"]["input"]>>
}

/** update columns of table "quote_request" */
export enum Quote_Request_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  Data = "data",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  QuoteId = "quote_id",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Quote_Request_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quote_Request_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quote_Request_Set_Input>
  /** filter the rows which have to be updated */
  where: Quote_Request_Bool_Exp
}

/** aggregate var_pop on columns */
export type Quote_Request_Var_Pop_Fields = {
  __typename?: "quote_request_var_pop_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  quote_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "quote_request" */
export type Quote_Request_Var_Pop_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  quote_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Quote_Request_Var_Samp_Fields = {
  __typename?: "quote_request_var_samp_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  quote_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "quote_request" */
export type Quote_Request_Var_Samp_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  quote_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Quote_Request_Variance_Fields = {
  __typename?: "quote_request_variance_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  quote_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "quote_request" */
export type Quote_Request_Variance_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  quote_id?: InputMaybe<Order_By>
}

/** select columns of table "quote" */
export enum Quote_Select_Column {
  /** column name */
  AccountId = "account_id",
  /** column name */
  Archiveddttm = "archiveddttm",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Data = "data",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "quote" */
export type Quote_Set_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  archiveddttm?: InputMaybe<Scalars["timestamp"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  data?: InputMaybe<Scalars["json"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Quote_Stddev_Fields = {
  __typename?: "quote_stddev_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Quote_Stddev_Pop_Fields = {
  __typename?: "quote_stddev_pop_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Quote_Stddev_Samp_Fields = {
  __typename?: "quote_stddev_samp_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "quote" */
export type Quote_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quote_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Quote_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  archiveddttm?: InputMaybe<Scalars["timestamp"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  data?: InputMaybe<Scalars["json"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Quote_Sum_Fields = {
  __typename?: "quote_sum_fields"
  account_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "quote" */
export enum Quote_Update_Column {
  /** column name */
  AccountId = "account_id",
  /** column name */
  Archiveddttm = "archiveddttm",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Data = "data",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Quote_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quote_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quote_Set_Input>
  /** filter the rows which have to be updated */
  where: Quote_Bool_Exp
}

/** aggregate var_pop on columns */
export type Quote_Var_Pop_Fields = {
  __typename?: "quote_var_pop_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Quote_Var_Samp_Fields = {
  __typename?: "quote_var_samp_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Quote_Variance_Fields = {
  __typename?: "quote_variance_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "recipients" */
export type Recipients = {
  __typename?: "recipients"
  account_id?: Maybe<Scalars["Int"]["output"]>
  address1?: Maybe<Scalars["String"]["output"]>
  address2?: Maybe<Scalars["String"]["output"]>
  address3?: Maybe<Scalars["String"]["output"]>
  city?: Maybe<Scalars["String"]["output"]>
  customer_id?: Maybe<Scalars["Int"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  /** An object relationship */
  email_message?: Maybe<Email_Messages>
  id: Scalars["bigint"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  phone_number?: Maybe<Scalars["String"]["output"]>
  post_code?: Maybe<Scalars["String"]["output"]>
}

/** aggregated selection of "recipients" */
export type Recipients_Aggregate = {
  __typename?: "recipients_aggregate"
  aggregate?: Maybe<Recipients_Aggregate_Fields>
  nodes: Array<Recipients>
}

/** aggregate fields of "recipients" */
export type Recipients_Aggregate_Fields = {
  __typename?: "recipients_aggregate_fields"
  avg?: Maybe<Recipients_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Recipients_Max_Fields>
  min?: Maybe<Recipients_Min_Fields>
  stddev?: Maybe<Recipients_Stddev_Fields>
  stddev_pop?: Maybe<Recipients_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Recipients_Stddev_Samp_Fields>
  sum?: Maybe<Recipients_Sum_Fields>
  var_pop?: Maybe<Recipients_Var_Pop_Fields>
  var_samp?: Maybe<Recipients_Var_Samp_Fields>
  variance?: Maybe<Recipients_Variance_Fields>
}

/** aggregate fields of "recipients" */
export type Recipients_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Recipients_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Recipients_Avg_Fields = {
  __typename?: "recipients_avg_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "recipients". All fields are combined with a logical 'AND'. */
export type Recipients_Bool_Exp = {
  _and?: InputMaybe<Array<Recipients_Bool_Exp>>
  _not?: InputMaybe<Recipients_Bool_Exp>
  _or?: InputMaybe<Array<Recipients_Bool_Exp>>
  account_id?: InputMaybe<Int_Comparison_Exp>
  address1?: InputMaybe<String_Comparison_Exp>
  address2?: InputMaybe<String_Comparison_Exp>
  address3?: InputMaybe<String_Comparison_Exp>
  city?: InputMaybe<String_Comparison_Exp>
  customer_id?: InputMaybe<Int_Comparison_Exp>
  email?: InputMaybe<String_Comparison_Exp>
  email_message?: InputMaybe<Email_Messages_Bool_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  name?: InputMaybe<String_Comparison_Exp>
  phone_number?: InputMaybe<String_Comparison_Exp>
  post_code?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "recipients" */
export enum Recipients_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkRecipients = "pk_recipients",
}

/** input type for incrementing numeric columns in table "recipients" */
export type Recipients_Inc_Input = {
  account_id?: InputMaybe<Scalars["Int"]["input"]>
  customer_id?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "recipients" */
export type Recipients_Insert_Input = {
  account_id?: InputMaybe<Scalars["Int"]["input"]>
  address1?: InputMaybe<Scalars["String"]["input"]>
  address2?: InputMaybe<Scalars["String"]["input"]>
  address3?: InputMaybe<Scalars["String"]["input"]>
  city?: InputMaybe<Scalars["String"]["input"]>
  customer_id?: InputMaybe<Scalars["Int"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  email_message?: InputMaybe<Email_Messages_Obj_Rel_Insert_Input>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  phone_number?: InputMaybe<Scalars["String"]["input"]>
  post_code?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Recipients_Max_Fields = {
  __typename?: "recipients_max_fields"
  account_id?: Maybe<Scalars["Int"]["output"]>
  address1?: Maybe<Scalars["String"]["output"]>
  address2?: Maybe<Scalars["String"]["output"]>
  address3?: Maybe<Scalars["String"]["output"]>
  city?: Maybe<Scalars["String"]["output"]>
  customer_id?: Maybe<Scalars["Int"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  phone_number?: Maybe<Scalars["String"]["output"]>
  post_code?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Recipients_Min_Fields = {
  __typename?: "recipients_min_fields"
  account_id?: Maybe<Scalars["Int"]["output"]>
  address1?: Maybe<Scalars["String"]["output"]>
  address2?: Maybe<Scalars["String"]["output"]>
  address3?: Maybe<Scalars["String"]["output"]>
  city?: Maybe<Scalars["String"]["output"]>
  customer_id?: Maybe<Scalars["Int"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  phone_number?: Maybe<Scalars["String"]["output"]>
  post_code?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "recipients" */
export type Recipients_Mutation_Response = {
  __typename?: "recipients_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Recipients>
}

/** input type for inserting object relation for remote table "recipients" */
export type Recipients_Obj_Rel_Insert_Input = {
  data: Recipients_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Recipients_On_Conflict>
}

/** on_conflict condition type for table "recipients" */
export type Recipients_On_Conflict = {
  constraint: Recipients_Constraint
  update_columns?: Array<Recipients_Update_Column>
  where?: InputMaybe<Recipients_Bool_Exp>
}

/** Ordering options when selecting data from "recipients". */
export type Recipients_Order_By = {
  account_id?: InputMaybe<Order_By>
  address1?: InputMaybe<Order_By>
  address2?: InputMaybe<Order_By>
  address3?: InputMaybe<Order_By>
  city?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  email?: InputMaybe<Order_By>
  email_message?: InputMaybe<Email_Messages_Order_By>
  id?: InputMaybe<Order_By>
  name?: InputMaybe<Order_By>
  phone_number?: InputMaybe<Order_By>
  post_code?: InputMaybe<Order_By>
}

/** primary key columns input for table: recipients */
export type Recipients_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "recipients" */
export enum Recipients_Select_Column {
  /** column name */
  AccountId = "account_id",
  /** column name */
  Address1 = "address1",
  /** column name */
  Address2 = "address2",
  /** column name */
  Address3 = "address3",
  /** column name */
  City = "city",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  Email = "email",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  PhoneNumber = "phone_number",
  /** column name */
  PostCode = "post_code",
}

/** input type for updating data in table "recipients" */
export type Recipients_Set_Input = {
  account_id?: InputMaybe<Scalars["Int"]["input"]>
  address1?: InputMaybe<Scalars["String"]["input"]>
  address2?: InputMaybe<Scalars["String"]["input"]>
  address3?: InputMaybe<Scalars["String"]["input"]>
  city?: InputMaybe<Scalars["String"]["input"]>
  customer_id?: InputMaybe<Scalars["Int"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  phone_number?: InputMaybe<Scalars["String"]["input"]>
  post_code?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Recipients_Stddev_Fields = {
  __typename?: "recipients_stddev_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Recipients_Stddev_Pop_Fields = {
  __typename?: "recipients_stddev_pop_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Recipients_Stddev_Samp_Fields = {
  __typename?: "recipients_stddev_samp_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "recipients" */
export type Recipients_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Recipients_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Recipients_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars["Int"]["input"]>
  address1?: InputMaybe<Scalars["String"]["input"]>
  address2?: InputMaybe<Scalars["String"]["input"]>
  address3?: InputMaybe<Scalars["String"]["input"]>
  city?: InputMaybe<Scalars["String"]["input"]>
  customer_id?: InputMaybe<Scalars["Int"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  phone_number?: InputMaybe<Scalars["String"]["input"]>
  post_code?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Recipients_Sum_Fields = {
  __typename?: "recipients_sum_fields"
  account_id?: Maybe<Scalars["Int"]["output"]>
  customer_id?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "recipients" */
export enum Recipients_Update_Column {
  /** column name */
  AccountId = "account_id",
  /** column name */
  Address1 = "address1",
  /** column name */
  Address2 = "address2",
  /** column name */
  Address3 = "address3",
  /** column name */
  City = "city",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  Email = "email",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  PhoneNumber = "phone_number",
  /** column name */
  PostCode = "post_code",
}

export type Recipients_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Recipients_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Recipients_Set_Input>
  /** filter the rows which have to be updated */
  where: Recipients_Bool_Exp
}

/** aggregate var_pop on columns */
export type Recipients_Var_Pop_Fields = {
  __typename?: "recipients_var_pop_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Recipients_Var_Samp_Fields = {
  __typename?: "recipients_var_samp_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Recipients_Variance_Fields = {
  __typename?: "recipients_variance_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "referral_status". All fields are combined with logical 'AND'. */
export type Referral_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["referral_status"]["input"]>
  _gt?: InputMaybe<Scalars["referral_status"]["input"]>
  _gte?: InputMaybe<Scalars["referral_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["referral_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["referral_status"]["input"]>
  _lte?: InputMaybe<Scalars["referral_status"]["input"]>
  _neq?: InputMaybe<Scalars["referral_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["referral_status"]["input"]>>
}

/** columns and relationships of "refresh_tokens" */
export type Refresh_Tokens = {
  __typename?: "refresh_tokens"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  crypted_token?: Maybe<Scalars["String"]["output"]>
  expiry_datetime: Scalars["timestamp"]["output"]
  group_id: Scalars["uuid"]["output"]
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  /** An object relationship */
  user?: Maybe<Users>
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregated selection of "refresh_tokens" */
export type Refresh_Tokens_Aggregate = {
  __typename?: "refresh_tokens_aggregate"
  aggregate?: Maybe<Refresh_Tokens_Aggregate_Fields>
  nodes: Array<Refresh_Tokens>
}

export type Refresh_Tokens_Aggregate_Bool_Exp = {
  count?: InputMaybe<Refresh_Tokens_Aggregate_Bool_Exp_Count>
}

export type Refresh_Tokens_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Refresh_Tokens_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Refresh_Tokens_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "refresh_tokens" */
export type Refresh_Tokens_Aggregate_Fields = {
  __typename?: "refresh_tokens_aggregate_fields"
  avg?: Maybe<Refresh_Tokens_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Refresh_Tokens_Max_Fields>
  min?: Maybe<Refresh_Tokens_Min_Fields>
  stddev?: Maybe<Refresh_Tokens_Stddev_Fields>
  stddev_pop?: Maybe<Refresh_Tokens_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Refresh_Tokens_Stddev_Samp_Fields>
  sum?: Maybe<Refresh_Tokens_Sum_Fields>
  var_pop?: Maybe<Refresh_Tokens_Var_Pop_Fields>
  var_samp?: Maybe<Refresh_Tokens_Var_Samp_Fields>
  variance?: Maybe<Refresh_Tokens_Variance_Fields>
}

/** aggregate fields of "refresh_tokens" */
export type Refresh_Tokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Refresh_Tokens_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "refresh_tokens" */
export type Refresh_Tokens_Aggregate_Order_By = {
  avg?: InputMaybe<Refresh_Tokens_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Refresh_Tokens_Max_Order_By>
  min?: InputMaybe<Refresh_Tokens_Min_Order_By>
  stddev?: InputMaybe<Refresh_Tokens_Stddev_Order_By>
  stddev_pop?: InputMaybe<Refresh_Tokens_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Refresh_Tokens_Stddev_Samp_Order_By>
  sum?: InputMaybe<Refresh_Tokens_Sum_Order_By>
  var_pop?: InputMaybe<Refresh_Tokens_Var_Pop_Order_By>
  var_samp?: InputMaybe<Refresh_Tokens_Var_Samp_Order_By>
  variance?: InputMaybe<Refresh_Tokens_Variance_Order_By>
}

/** input type for inserting array relation for remote table "refresh_tokens" */
export type Refresh_Tokens_Arr_Rel_Insert_Input = {
  data: Array<Refresh_Tokens_Insert_Input>
}

/** aggregate avg on columns */
export type Refresh_Tokens_Avg_Fields = {
  __typename?: "refresh_tokens_avg_fields"
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "refresh_tokens" */
export type Refresh_Tokens_Avg_Order_By = {
  user_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "refresh_tokens". All fields are combined with a logical 'AND'. */
export type Refresh_Tokens_Bool_Exp = {
  _and?: InputMaybe<Array<Refresh_Tokens_Bool_Exp>>
  _not?: InputMaybe<Refresh_Tokens_Bool_Exp>
  _or?: InputMaybe<Array<Refresh_Tokens_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  crypted_token?: InputMaybe<String_Comparison_Exp>
  expiry_datetime?: InputMaybe<Timestamp_Comparison_Exp>
  group_id?: InputMaybe<Uuid_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  user?: InputMaybe<Users_Bool_Exp>
  user_id?: InputMaybe<Bigint_Comparison_Exp>
}

/** input type for incrementing numeric columns in table "refresh_tokens" */
export type Refresh_Tokens_Inc_Input = {
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "refresh_tokens" */
export type Refresh_Tokens_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  crypted_token?: InputMaybe<Scalars["String"]["input"]>
  expiry_datetime?: InputMaybe<Scalars["timestamp"]["input"]>
  group_id?: InputMaybe<Scalars["uuid"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate max on columns */
export type Refresh_Tokens_Max_Fields = {
  __typename?: "refresh_tokens_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  crypted_token?: Maybe<Scalars["String"]["output"]>
  expiry_datetime?: Maybe<Scalars["timestamp"]["output"]>
  group_id?: Maybe<Scalars["uuid"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by max() on columns of table "refresh_tokens" */
export type Refresh_Tokens_Max_Order_By = {
  created_at?: InputMaybe<Order_By>
  crypted_token?: InputMaybe<Order_By>
  expiry_datetime?: InputMaybe<Order_By>
  group_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Refresh_Tokens_Min_Fields = {
  __typename?: "refresh_tokens_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  crypted_token?: Maybe<Scalars["String"]["output"]>
  expiry_datetime?: Maybe<Scalars["timestamp"]["output"]>
  group_id?: Maybe<Scalars["uuid"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by min() on columns of table "refresh_tokens" */
export type Refresh_Tokens_Min_Order_By = {
  created_at?: InputMaybe<Order_By>
  crypted_token?: InputMaybe<Order_By>
  expiry_datetime?: InputMaybe<Order_By>
  group_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** response of any mutation on the table "refresh_tokens" */
export type Refresh_Tokens_Mutation_Response = {
  __typename?: "refresh_tokens_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Refresh_Tokens>
}

/** Ordering options when selecting data from "refresh_tokens". */
export type Refresh_Tokens_Order_By = {
  created_at?: InputMaybe<Order_By>
  crypted_token?: InputMaybe<Order_By>
  expiry_datetime?: InputMaybe<Order_By>
  group_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user?: InputMaybe<Users_Order_By>
  user_id?: InputMaybe<Order_By>
}

/** select columns of table "refresh_tokens" */
export enum Refresh_Tokens_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CryptedToken = "crypted_token",
  /** column name */
  ExpiryDatetime = "expiry_datetime",
  /** column name */
  GroupId = "group_id",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  UserId = "user_id",
}

/** input type for updating data in table "refresh_tokens" */
export type Refresh_Tokens_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  crypted_token?: InputMaybe<Scalars["String"]["input"]>
  expiry_datetime?: InputMaybe<Scalars["timestamp"]["input"]>
  group_id?: InputMaybe<Scalars["uuid"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate stddev on columns */
export type Refresh_Tokens_Stddev_Fields = {
  __typename?: "refresh_tokens_stddev_fields"
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "refresh_tokens" */
export type Refresh_Tokens_Stddev_Order_By = {
  user_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Refresh_Tokens_Stddev_Pop_Fields = {
  __typename?: "refresh_tokens_stddev_pop_fields"
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "refresh_tokens" */
export type Refresh_Tokens_Stddev_Pop_Order_By = {
  user_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Refresh_Tokens_Stddev_Samp_Fields = {
  __typename?: "refresh_tokens_stddev_samp_fields"
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "refresh_tokens" */
export type Refresh_Tokens_Stddev_Samp_Order_By = {
  user_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "refresh_tokens" */
export type Refresh_Tokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Refresh_Tokens_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Refresh_Tokens_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  crypted_token?: InputMaybe<Scalars["String"]["input"]>
  expiry_datetime?: InputMaybe<Scalars["timestamp"]["input"]>
  group_id?: InputMaybe<Scalars["uuid"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate sum on columns */
export type Refresh_Tokens_Sum_Fields = {
  __typename?: "refresh_tokens_sum_fields"
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "refresh_tokens" */
export type Refresh_Tokens_Sum_Order_By = {
  user_id?: InputMaybe<Order_By>
}

export type Refresh_Tokens_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Refresh_Tokens_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Refresh_Tokens_Set_Input>
  /** filter the rows which have to be updated */
  where: Refresh_Tokens_Bool_Exp
}

/** aggregate var_pop on columns */
export type Refresh_Tokens_Var_Pop_Fields = {
  __typename?: "refresh_tokens_var_pop_fields"
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "refresh_tokens" */
export type Refresh_Tokens_Var_Pop_Order_By = {
  user_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Refresh_Tokens_Var_Samp_Fields = {
  __typename?: "refresh_tokens_var_samp_fields"
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "refresh_tokens" */
export type Refresh_Tokens_Var_Samp_Order_By = {
  user_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Refresh_Tokens_Variance_Fields = {
  __typename?: "refresh_tokens_variance_fields"
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "refresh_tokens" */
export type Refresh_Tokens_Variance_Order_By = {
  user_id?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "refund_status". All fields are combined with logical 'AND'. */
export type Refund_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["refund_status"]["input"]>
  _gt?: InputMaybe<Scalars["refund_status"]["input"]>
  _gte?: InputMaybe<Scalars["refund_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["refund_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["refund_status"]["input"]>
  _lte?: InputMaybe<Scalars["refund_status"]["input"]>
  _neq?: InputMaybe<Scalars["refund_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["refund_status"]["input"]>>
}

/** Boolean expression to compare columns of type "refund_type". All fields are combined with logical 'AND'. */
export type Refund_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["refund_type"]["input"]>
  _gt?: InputMaybe<Scalars["refund_type"]["input"]>
  _gte?: InputMaybe<Scalars["refund_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["refund_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["refund_type"]["input"]>
  _lte?: InputMaybe<Scalars["refund_type"]["input"]>
  _neq?: InputMaybe<Scalars["refund_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["refund_type"]["input"]>>
}

/** columns and relationships of "refunds" */
export type Refunds = {
  __typename?: "refunds"
  created_at: Scalars["timestamptz"]["output"]
  current_payment_amount_in_pence?: Maybe<Scalars["Int"]["output"]>
  customer_first_name: Scalars["String"]["output"]
  email: Scalars["String"]["output"]
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  follow_up_review?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["bigint"]["output"]
  junifer_account_id: Scalars["bigint"]["output"]
  junifer_account_number: Scalars["String"]["output"]
  junifer_refund_id?: Maybe<Scalars["bigint"]["output"]>
  notification_to_user_sent_at?: Maybe<Scalars["timestamptz"]["output"]>
  payment_date?: Maybe<Scalars["timestamptz"]["output"]>
  refund_amount_in_pence: Scalars["Int"]["output"]
  seasonal?: Maybe<Scalars["Boolean"]["output"]>
  status: Scalars["String"]["output"]
  suggested_payment_amount_in_pence?: Maybe<Scalars["Int"]["output"]>
  suggested_summer_payment_amount_in_pence?: Maybe<Scalars["Int"]["output"]>
  suggested_winter_payment_amount_in_pence?: Maybe<Scalars["Int"]["output"]>
  type: Scalars["refund_type"]["output"]
  updated_at?: Maybe<Scalars["timestamptz"]["output"]>
}

/** aggregated selection of "refunds" */
export type Refunds_Aggregate = {
  __typename?: "refunds_aggregate"
  aggregate?: Maybe<Refunds_Aggregate_Fields>
  nodes: Array<Refunds>
}

/** aggregate fields of "refunds" */
export type Refunds_Aggregate_Fields = {
  __typename?: "refunds_aggregate_fields"
  avg?: Maybe<Refunds_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Refunds_Max_Fields>
  min?: Maybe<Refunds_Min_Fields>
  stddev?: Maybe<Refunds_Stddev_Fields>
  stddev_pop?: Maybe<Refunds_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Refunds_Stddev_Samp_Fields>
  sum?: Maybe<Refunds_Sum_Fields>
  var_pop?: Maybe<Refunds_Var_Pop_Fields>
  var_samp?: Maybe<Refunds_Var_Samp_Fields>
  variance?: Maybe<Refunds_Variance_Fields>
}

/** aggregate fields of "refunds" */
export type Refunds_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Refunds_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Refunds_Avg_Fields = {
  __typename?: "refunds_avg_fields"
  current_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  junifer_refund_id?: Maybe<Scalars["Float"]["output"]>
  refund_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_summer_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_winter_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "refunds". All fields are combined with a logical 'AND'. */
export type Refunds_Bool_Exp = {
  _and?: InputMaybe<Array<Refunds_Bool_Exp>>
  _not?: InputMaybe<Refunds_Bool_Exp>
  _or?: InputMaybe<Array<Refunds_Bool_Exp>>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  current_payment_amount_in_pence?: InputMaybe<Int_Comparison_Exp>
  customer_first_name?: InputMaybe<String_Comparison_Exp>
  email?: InputMaybe<String_Comparison_Exp>
  email_message_id?: InputMaybe<Bigint_Comparison_Exp>
  follow_up_review?: InputMaybe<Boolean_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  junifer_account_id?: InputMaybe<Bigint_Comparison_Exp>
  junifer_account_number?: InputMaybe<String_Comparison_Exp>
  junifer_refund_id?: InputMaybe<Bigint_Comparison_Exp>
  notification_to_user_sent_at?: InputMaybe<Timestamptz_Comparison_Exp>
  payment_date?: InputMaybe<Timestamptz_Comparison_Exp>
  refund_amount_in_pence?: InputMaybe<Int_Comparison_Exp>
  seasonal?: InputMaybe<Boolean_Comparison_Exp>
  status?: InputMaybe<String_Comparison_Exp>
  suggested_payment_amount_in_pence?: InputMaybe<Int_Comparison_Exp>
  suggested_summer_payment_amount_in_pence?: InputMaybe<Int_Comparison_Exp>
  suggested_winter_payment_amount_in_pence?: InputMaybe<Int_Comparison_Exp>
  type?: InputMaybe<Refund_Type_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "refunds" */
export enum Refunds_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkRefunds = "pk_refunds",
}

/** input type for incrementing numeric columns in table "refunds" */
export type Refunds_Inc_Input = {
  current_payment_amount_in_pence?: InputMaybe<Scalars["Int"]["input"]>
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_refund_id?: InputMaybe<Scalars["bigint"]["input"]>
  refund_amount_in_pence?: InputMaybe<Scalars["Int"]["input"]>
  suggested_payment_amount_in_pence?: InputMaybe<Scalars["Int"]["input"]>
  suggested_summer_payment_amount_in_pence?: InputMaybe<Scalars["Int"]["input"]>
  suggested_winter_payment_amount_in_pence?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "refunds" */
export type Refunds_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  current_payment_amount_in_pence?: InputMaybe<Scalars["Int"]["input"]>
  customer_first_name?: InputMaybe<Scalars["String"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  follow_up_review?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_account_number?: InputMaybe<Scalars["String"]["input"]>
  junifer_refund_id?: InputMaybe<Scalars["bigint"]["input"]>
  notification_to_user_sent_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  payment_date?: InputMaybe<Scalars["timestamptz"]["input"]>
  refund_amount_in_pence?: InputMaybe<Scalars["Int"]["input"]>
  seasonal?: InputMaybe<Scalars["Boolean"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  suggested_payment_amount_in_pence?: InputMaybe<Scalars["Int"]["input"]>
  suggested_summer_payment_amount_in_pence?: InputMaybe<Scalars["Int"]["input"]>
  suggested_winter_payment_amount_in_pence?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<Scalars["refund_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamptz"]["input"]>
}

/** aggregate max on columns */
export type Refunds_Max_Fields = {
  __typename?: "refunds_max_fields"
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  current_payment_amount_in_pence?: Maybe<Scalars["Int"]["output"]>
  customer_first_name?: Maybe<Scalars["String"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_account_id?: Maybe<Scalars["bigint"]["output"]>
  junifer_account_number?: Maybe<Scalars["String"]["output"]>
  junifer_refund_id?: Maybe<Scalars["bigint"]["output"]>
  notification_to_user_sent_at?: Maybe<Scalars["timestamptz"]["output"]>
  payment_date?: Maybe<Scalars["timestamptz"]["output"]>
  refund_amount_in_pence?: Maybe<Scalars["Int"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  suggested_payment_amount_in_pence?: Maybe<Scalars["Int"]["output"]>
  suggested_summer_payment_amount_in_pence?: Maybe<Scalars["Int"]["output"]>
  suggested_winter_payment_amount_in_pence?: Maybe<Scalars["Int"]["output"]>
  type?: Maybe<Scalars["refund_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamptz"]["output"]>
}

/** aggregate min on columns */
export type Refunds_Min_Fields = {
  __typename?: "refunds_min_fields"
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  current_payment_amount_in_pence?: Maybe<Scalars["Int"]["output"]>
  customer_first_name?: Maybe<Scalars["String"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_account_id?: Maybe<Scalars["bigint"]["output"]>
  junifer_account_number?: Maybe<Scalars["String"]["output"]>
  junifer_refund_id?: Maybe<Scalars["bigint"]["output"]>
  notification_to_user_sent_at?: Maybe<Scalars["timestamptz"]["output"]>
  payment_date?: Maybe<Scalars["timestamptz"]["output"]>
  refund_amount_in_pence?: Maybe<Scalars["Int"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  suggested_payment_amount_in_pence?: Maybe<Scalars["Int"]["output"]>
  suggested_summer_payment_amount_in_pence?: Maybe<Scalars["Int"]["output"]>
  suggested_winter_payment_amount_in_pence?: Maybe<Scalars["Int"]["output"]>
  type?: Maybe<Scalars["refund_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamptz"]["output"]>
}

/** response of any mutation on the table "refunds" */
export type Refunds_Mutation_Response = {
  __typename?: "refunds_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Refunds>
}

/** on_conflict condition type for table "refunds" */
export type Refunds_On_Conflict = {
  constraint: Refunds_Constraint
  update_columns?: Array<Refunds_Update_Column>
  where?: InputMaybe<Refunds_Bool_Exp>
}

/** Ordering options when selecting data from "refunds". */
export type Refunds_Order_By = {
  created_at?: InputMaybe<Order_By>
  current_payment_amount_in_pence?: InputMaybe<Order_By>
  customer_first_name?: InputMaybe<Order_By>
  email?: InputMaybe<Order_By>
  email_message_id?: InputMaybe<Order_By>
  follow_up_review?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  junifer_account_id?: InputMaybe<Order_By>
  junifer_account_number?: InputMaybe<Order_By>
  junifer_refund_id?: InputMaybe<Order_By>
  notification_to_user_sent_at?: InputMaybe<Order_By>
  payment_date?: InputMaybe<Order_By>
  refund_amount_in_pence?: InputMaybe<Order_By>
  seasonal?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  suggested_payment_amount_in_pence?: InputMaybe<Order_By>
  suggested_summer_payment_amount_in_pence?: InputMaybe<Order_By>
  suggested_winter_payment_amount_in_pence?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: refunds */
export type Refunds_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "refunds" */
export enum Refunds_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CurrentPaymentAmountInPence = "current_payment_amount_in_pence",
  /** column name */
  CustomerFirstName = "customer_first_name",
  /** column name */
  Email = "email",
  /** column name */
  EmailMessageId = "email_message_id",
  /** column name */
  FollowUpReview = "follow_up_review",
  /** column name */
  Id = "id",
  /** column name */
  JuniferAccountId = "junifer_account_id",
  /** column name */
  JuniferAccountNumber = "junifer_account_number",
  /** column name */
  JuniferRefundId = "junifer_refund_id",
  /** column name */
  NotificationToUserSentAt = "notification_to_user_sent_at",
  /** column name */
  PaymentDate = "payment_date",
  /** column name */
  RefundAmountInPence = "refund_amount_in_pence",
  /** column name */
  Seasonal = "seasonal",
  /** column name */
  Status = "status",
  /** column name */
  SuggestedPaymentAmountInPence = "suggested_payment_amount_in_pence",
  /** column name */
  SuggestedSummerPaymentAmountInPence = "suggested_summer_payment_amount_in_pence",
  /** column name */
  SuggestedWinterPaymentAmountInPence = "suggested_winter_payment_amount_in_pence",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "refunds" */
export type Refunds_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  current_payment_amount_in_pence?: InputMaybe<Scalars["Int"]["input"]>
  customer_first_name?: InputMaybe<Scalars["String"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  follow_up_review?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_account_number?: InputMaybe<Scalars["String"]["input"]>
  junifer_refund_id?: InputMaybe<Scalars["bigint"]["input"]>
  notification_to_user_sent_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  payment_date?: InputMaybe<Scalars["timestamptz"]["input"]>
  refund_amount_in_pence?: InputMaybe<Scalars["Int"]["input"]>
  seasonal?: InputMaybe<Scalars["Boolean"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  suggested_payment_amount_in_pence?: InputMaybe<Scalars["Int"]["input"]>
  suggested_summer_payment_amount_in_pence?: InputMaybe<Scalars["Int"]["input"]>
  suggested_winter_payment_amount_in_pence?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<Scalars["refund_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamptz"]["input"]>
}

/** aggregate stddev on columns */
export type Refunds_Stddev_Fields = {
  __typename?: "refunds_stddev_fields"
  current_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  junifer_refund_id?: Maybe<Scalars["Float"]["output"]>
  refund_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_summer_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_winter_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Refunds_Stddev_Pop_Fields = {
  __typename?: "refunds_stddev_pop_fields"
  current_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  junifer_refund_id?: Maybe<Scalars["Float"]["output"]>
  refund_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_summer_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_winter_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Refunds_Stddev_Samp_Fields = {
  __typename?: "refunds_stddev_samp_fields"
  current_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  junifer_refund_id?: Maybe<Scalars["Float"]["output"]>
  refund_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_summer_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_winter_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "refunds" */
export type Refunds_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Refunds_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Refunds_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  current_payment_amount_in_pence?: InputMaybe<Scalars["Int"]["input"]>
  customer_first_name?: InputMaybe<Scalars["String"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  follow_up_review?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_account_number?: InputMaybe<Scalars["String"]["input"]>
  junifer_refund_id?: InputMaybe<Scalars["bigint"]["input"]>
  notification_to_user_sent_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  payment_date?: InputMaybe<Scalars["timestamptz"]["input"]>
  refund_amount_in_pence?: InputMaybe<Scalars["Int"]["input"]>
  seasonal?: InputMaybe<Scalars["Boolean"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  suggested_payment_amount_in_pence?: InputMaybe<Scalars["Int"]["input"]>
  suggested_summer_payment_amount_in_pence?: InputMaybe<Scalars["Int"]["input"]>
  suggested_winter_payment_amount_in_pence?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<Scalars["refund_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamptz"]["input"]>
}

/** aggregate sum on columns */
export type Refunds_Sum_Fields = {
  __typename?: "refunds_sum_fields"
  current_payment_amount_in_pence?: Maybe<Scalars["Int"]["output"]>
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_account_id?: Maybe<Scalars["bigint"]["output"]>
  junifer_refund_id?: Maybe<Scalars["bigint"]["output"]>
  refund_amount_in_pence?: Maybe<Scalars["Int"]["output"]>
  suggested_payment_amount_in_pence?: Maybe<Scalars["Int"]["output"]>
  suggested_summer_payment_amount_in_pence?: Maybe<Scalars["Int"]["output"]>
  suggested_winter_payment_amount_in_pence?: Maybe<Scalars["Int"]["output"]>
}

/** update columns of table "refunds" */
export enum Refunds_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CurrentPaymentAmountInPence = "current_payment_amount_in_pence",
  /** column name */
  CustomerFirstName = "customer_first_name",
  /** column name */
  Email = "email",
  /** column name */
  EmailMessageId = "email_message_id",
  /** column name */
  FollowUpReview = "follow_up_review",
  /** column name */
  Id = "id",
  /** column name */
  JuniferAccountId = "junifer_account_id",
  /** column name */
  JuniferAccountNumber = "junifer_account_number",
  /** column name */
  JuniferRefundId = "junifer_refund_id",
  /** column name */
  NotificationToUserSentAt = "notification_to_user_sent_at",
  /** column name */
  PaymentDate = "payment_date",
  /** column name */
  RefundAmountInPence = "refund_amount_in_pence",
  /** column name */
  Seasonal = "seasonal",
  /** column name */
  Status = "status",
  /** column name */
  SuggestedPaymentAmountInPence = "suggested_payment_amount_in_pence",
  /** column name */
  SuggestedSummerPaymentAmountInPence = "suggested_summer_payment_amount_in_pence",
  /** column name */
  SuggestedWinterPaymentAmountInPence = "suggested_winter_payment_amount_in_pence",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Refunds_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Refunds_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Refunds_Set_Input>
  /** filter the rows which have to be updated */
  where: Refunds_Bool_Exp
}

/** aggregate var_pop on columns */
export type Refunds_Var_Pop_Fields = {
  __typename?: "refunds_var_pop_fields"
  current_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  junifer_refund_id?: Maybe<Scalars["Float"]["output"]>
  refund_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_summer_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_winter_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Refunds_Var_Samp_Fields = {
  __typename?: "refunds_var_samp_fields"
  current_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  junifer_refund_id?: Maybe<Scalars["Float"]["output"]>
  refund_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_summer_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_winter_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Refunds_Variance_Fields = {
  __typename?: "refunds_variance_fields"
  current_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  junifer_refund_id?: Maybe<Scalars["Float"]["output"]>
  refund_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_summer_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_winter_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "register" */
export type Register = {
  __typename?: "register"
  created_at: Scalars["timestamp"]["output"]
  decimal_places: Scalars["Int"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  digits: Scalars["Int"]["output"]
  from_dttm?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  identifier?: Maybe<Scalars["String"]["output"]>
  /** An object relationship */
  meter: Meter
  meter_id: Scalars["bigint"]["output"]
  /** An array relationship */
  meter_readings: Array<Meter_Reading>
  /** An aggregate relationship */
  meter_readings_aggregate: Meter_Reading_Aggregate
  rate_name?: Maybe<Scalars["String"]["output"]>
  reading_mode: Scalars["String"]["output"]
  to_dttm?: Maybe<Scalars["timestamp"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
  usage: Scalars["numeric"]["output"]
}

/** columns and relationships of "register" */
export type RegisterMeter_ReadingsArgs = {
  distinct_on?: InputMaybe<Array<Meter_Reading_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Reading_Order_By>>
  where?: InputMaybe<Meter_Reading_Bool_Exp>
}

/** columns and relationships of "register" */
export type RegisterMeter_Readings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Reading_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Reading_Order_By>>
  where?: InputMaybe<Meter_Reading_Bool_Exp>
}

/** aggregated selection of "register" */
export type Register_Aggregate = {
  __typename?: "register_aggregate"
  aggregate?: Maybe<Register_Aggregate_Fields>
  nodes: Array<Register>
}

export type Register_Aggregate_Bool_Exp = {
  count?: InputMaybe<Register_Aggregate_Bool_Exp_Count>
}

export type Register_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Register_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Register_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "register" */
export type Register_Aggregate_Fields = {
  __typename?: "register_aggregate_fields"
  avg?: Maybe<Register_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Register_Max_Fields>
  min?: Maybe<Register_Min_Fields>
  stddev?: Maybe<Register_Stddev_Fields>
  stddev_pop?: Maybe<Register_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Register_Stddev_Samp_Fields>
  sum?: Maybe<Register_Sum_Fields>
  var_pop?: Maybe<Register_Var_Pop_Fields>
  var_samp?: Maybe<Register_Var_Samp_Fields>
  variance?: Maybe<Register_Variance_Fields>
}

/** aggregate fields of "register" */
export type Register_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Register_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "register" */
export type Register_Aggregate_Order_By = {
  avg?: InputMaybe<Register_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Register_Max_Order_By>
  min?: InputMaybe<Register_Min_Order_By>
  stddev?: InputMaybe<Register_Stddev_Order_By>
  stddev_pop?: InputMaybe<Register_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Register_Stddev_Samp_Order_By>
  sum?: InputMaybe<Register_Sum_Order_By>
  var_pop?: InputMaybe<Register_Var_Pop_Order_By>
  var_samp?: InputMaybe<Register_Var_Samp_Order_By>
  variance?: InputMaybe<Register_Variance_Order_By>
}

/** input type for inserting array relation for remote table "register" */
export type Register_Arr_Rel_Insert_Input = {
  data: Array<Register_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Register_On_Conflict>
}

/** aggregate avg on columns */
export type Register_Avg_Fields = {
  __typename?: "register_avg_fields"
  decimal_places?: Maybe<Scalars["Float"]["output"]>
  digits?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_id?: Maybe<Scalars["Float"]["output"]>
  usage?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "register" */
export type Register_Avg_Order_By = {
  decimal_places?: InputMaybe<Order_By>
  digits?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  usage?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "register". All fields are combined with a logical 'AND'. */
export type Register_Bool_Exp = {
  _and?: InputMaybe<Array<Register_Bool_Exp>>
  _not?: InputMaybe<Register_Bool_Exp>
  _or?: InputMaybe<Array<Register_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  decimal_places?: InputMaybe<Int_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  digits?: InputMaybe<Int_Comparison_Exp>
  from_dttm?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  identifier?: InputMaybe<String_Comparison_Exp>
  meter?: InputMaybe<Meter_Bool_Exp>
  meter_id?: InputMaybe<Bigint_Comparison_Exp>
  meter_readings?: InputMaybe<Meter_Reading_Bool_Exp>
  meter_readings_aggregate?: InputMaybe<Meter_Reading_Aggregate_Bool_Exp>
  rate_name?: InputMaybe<String_Comparison_Exp>
  reading_mode?: InputMaybe<String_Comparison_Exp>
  to_dttm?: InputMaybe<Timestamp_Comparison_Exp>
  type?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  usage?: InputMaybe<Numeric_Comparison_Exp>
}

/** unique or primary key constraints on table "register" */
export enum Register_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkRegister = "pk_register",
}

/** input type for incrementing numeric columns in table "register" */
export type Register_Inc_Input = {
  decimal_places?: InputMaybe<Scalars["Int"]["input"]>
  digits?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_id?: InputMaybe<Scalars["bigint"]["input"]>
  usage?: InputMaybe<Scalars["numeric"]["input"]>
}

/** input type for inserting data into table "register" */
export type Register_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  decimal_places?: InputMaybe<Scalars["Int"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  digits?: InputMaybe<Scalars["Int"]["input"]>
  from_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  identifier?: InputMaybe<Scalars["String"]["input"]>
  meter?: InputMaybe<Meter_Obj_Rel_Insert_Input>
  meter_id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_readings?: InputMaybe<Meter_Reading_Arr_Rel_Insert_Input>
  rate_name?: InputMaybe<Scalars["String"]["input"]>
  reading_mode?: InputMaybe<Scalars["String"]["input"]>
  to_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  usage?: InputMaybe<Scalars["numeric"]["input"]>
}

/** aggregate max on columns */
export type Register_Max_Fields = {
  __typename?: "register_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  decimal_places?: Maybe<Scalars["Int"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  digits?: Maybe<Scalars["Int"]["output"]>
  from_dttm?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  identifier?: Maybe<Scalars["String"]["output"]>
  meter_id?: Maybe<Scalars["bigint"]["output"]>
  rate_name?: Maybe<Scalars["String"]["output"]>
  reading_mode?: Maybe<Scalars["String"]["output"]>
  to_dttm?: Maybe<Scalars["timestamp"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  usage?: Maybe<Scalars["numeric"]["output"]>
}

/** order by max() on columns of table "register" */
export type Register_Max_Order_By = {
  created_at?: InputMaybe<Order_By>
  decimal_places?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  digits?: InputMaybe<Order_By>
  from_dttm?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  identifier?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  rate_name?: InputMaybe<Order_By>
  reading_mode?: InputMaybe<Order_By>
  to_dttm?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  usage?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Register_Min_Fields = {
  __typename?: "register_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  decimal_places?: Maybe<Scalars["Int"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  digits?: Maybe<Scalars["Int"]["output"]>
  from_dttm?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  identifier?: Maybe<Scalars["String"]["output"]>
  meter_id?: Maybe<Scalars["bigint"]["output"]>
  rate_name?: Maybe<Scalars["String"]["output"]>
  reading_mode?: Maybe<Scalars["String"]["output"]>
  to_dttm?: Maybe<Scalars["timestamp"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  usage?: Maybe<Scalars["numeric"]["output"]>
}

/** order by min() on columns of table "register" */
export type Register_Min_Order_By = {
  created_at?: InputMaybe<Order_By>
  decimal_places?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  digits?: InputMaybe<Order_By>
  from_dttm?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  identifier?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  rate_name?: InputMaybe<Order_By>
  reading_mode?: InputMaybe<Order_By>
  to_dttm?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  usage?: InputMaybe<Order_By>
}

/** response of any mutation on the table "register" */
export type Register_Mutation_Response = {
  __typename?: "register_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Register>
}

/** input type for inserting object relation for remote table "register" */
export type Register_Obj_Rel_Insert_Input = {
  data: Register_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Register_On_Conflict>
}

/** on_conflict condition type for table "register" */
export type Register_On_Conflict = {
  constraint: Register_Constraint
  update_columns?: Array<Register_Update_Column>
  where?: InputMaybe<Register_Bool_Exp>
}

/** Ordering options when selecting data from "register". */
export type Register_Order_By = {
  created_at?: InputMaybe<Order_By>
  decimal_places?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  digits?: InputMaybe<Order_By>
  from_dttm?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  identifier?: InputMaybe<Order_By>
  meter?: InputMaybe<Meter_Order_By>
  meter_id?: InputMaybe<Order_By>
  meter_readings_aggregate?: InputMaybe<Meter_Reading_Aggregate_Order_By>
  rate_name?: InputMaybe<Order_By>
  reading_mode?: InputMaybe<Order_By>
  to_dttm?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  usage?: InputMaybe<Order_By>
}

/** primary key columns input for table: register */
export type Register_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "register" */
export enum Register_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DecimalPlaces = "decimal_places",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Digits = "digits",
  /** column name */
  FromDttm = "from_dttm",
  /** column name */
  Id = "id",
  /** column name */
  Identifier = "identifier",
  /** column name */
  MeterId = "meter_id",
  /** column name */
  RateName = "rate_name",
  /** column name */
  ReadingMode = "reading_mode",
  /** column name */
  ToDttm = "to_dttm",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  Usage = "usage",
}

/** input type for updating data in table "register" */
export type Register_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  decimal_places?: InputMaybe<Scalars["Int"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  digits?: InputMaybe<Scalars["Int"]["input"]>
  from_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  identifier?: InputMaybe<Scalars["String"]["input"]>
  meter_id?: InputMaybe<Scalars["bigint"]["input"]>
  rate_name?: InputMaybe<Scalars["String"]["input"]>
  reading_mode?: InputMaybe<Scalars["String"]["input"]>
  to_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  usage?: InputMaybe<Scalars["numeric"]["input"]>
}

/** aggregate stddev on columns */
export type Register_Stddev_Fields = {
  __typename?: "register_stddev_fields"
  decimal_places?: Maybe<Scalars["Float"]["output"]>
  digits?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_id?: Maybe<Scalars["Float"]["output"]>
  usage?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "register" */
export type Register_Stddev_Order_By = {
  decimal_places?: InputMaybe<Order_By>
  digits?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  usage?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Register_Stddev_Pop_Fields = {
  __typename?: "register_stddev_pop_fields"
  decimal_places?: Maybe<Scalars["Float"]["output"]>
  digits?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_id?: Maybe<Scalars["Float"]["output"]>
  usage?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "register" */
export type Register_Stddev_Pop_Order_By = {
  decimal_places?: InputMaybe<Order_By>
  digits?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  usage?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Register_Stddev_Samp_Fields = {
  __typename?: "register_stddev_samp_fields"
  decimal_places?: Maybe<Scalars["Float"]["output"]>
  digits?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_id?: Maybe<Scalars["Float"]["output"]>
  usage?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "register" */
export type Register_Stddev_Samp_Order_By = {
  decimal_places?: InputMaybe<Order_By>
  digits?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  usage?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "register" */
export type Register_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Register_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Register_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  decimal_places?: InputMaybe<Scalars["Int"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  digits?: InputMaybe<Scalars["Int"]["input"]>
  from_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  identifier?: InputMaybe<Scalars["String"]["input"]>
  meter_id?: InputMaybe<Scalars["bigint"]["input"]>
  rate_name?: InputMaybe<Scalars["String"]["input"]>
  reading_mode?: InputMaybe<Scalars["String"]["input"]>
  to_dttm?: InputMaybe<Scalars["timestamp"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  usage?: InputMaybe<Scalars["numeric"]["input"]>
}

/** aggregate sum on columns */
export type Register_Sum_Fields = {
  __typename?: "register_sum_fields"
  decimal_places?: Maybe<Scalars["Int"]["output"]>
  digits?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_id?: Maybe<Scalars["bigint"]["output"]>
  usage?: Maybe<Scalars["numeric"]["output"]>
}

/** order by sum() on columns of table "register" */
export type Register_Sum_Order_By = {
  decimal_places?: InputMaybe<Order_By>
  digits?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  usage?: InputMaybe<Order_By>
}

/** update columns of table "register" */
export enum Register_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DecimalPlaces = "decimal_places",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Digits = "digits",
  /** column name */
  FromDttm = "from_dttm",
  /** column name */
  Id = "id",
  /** column name */
  Identifier = "identifier",
  /** column name */
  MeterId = "meter_id",
  /** column name */
  RateName = "rate_name",
  /** column name */
  ReadingMode = "reading_mode",
  /** column name */
  ToDttm = "to_dttm",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  Usage = "usage",
}

export type Register_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Register_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Register_Set_Input>
  /** filter the rows which have to be updated */
  where: Register_Bool_Exp
}

/** aggregate var_pop on columns */
export type Register_Var_Pop_Fields = {
  __typename?: "register_var_pop_fields"
  decimal_places?: Maybe<Scalars["Float"]["output"]>
  digits?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_id?: Maybe<Scalars["Float"]["output"]>
  usage?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "register" */
export type Register_Var_Pop_Order_By = {
  decimal_places?: InputMaybe<Order_By>
  digits?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  usage?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Register_Var_Samp_Fields = {
  __typename?: "register_var_samp_fields"
  decimal_places?: Maybe<Scalars["Float"]["output"]>
  digits?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_id?: Maybe<Scalars["Float"]["output"]>
  usage?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "register" */
export type Register_Var_Samp_Order_By = {
  decimal_places?: InputMaybe<Order_By>
  digits?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  usage?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Register_Variance_Fields = {
  __typename?: "register_variance_fields"
  decimal_places?: Maybe<Scalars["Float"]["output"]>
  digits?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_id?: Maybe<Scalars["Float"]["output"]>
  usage?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "register" */
export type Register_Variance_Order_By = {
  decimal_places?: InputMaybe<Order_By>
  digits?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_id?: InputMaybe<Order_By>
  usage?: InputMaybe<Order_By>
}

/** columns and relationships of "registration_credit_check" */
export type Registration_Credit_Check = {
  __typename?: "registration_credit_check"
  account_number: Scalars["String"]["output"]
  ao_score_ca?: Maybe<Scalars["Int"]["output"]>
  ao_score_qs?: Maybe<Scalars["Int"]["output"]>
  billing_account_id: Scalars["bigint"]["output"]
  billing_account_start_dt: Scalars["timestamp"]["output"]
  broker: Scalars["enrolment_broker"]["output"]
  created_dt: Scalars["timestamp"]["output"]
  date_of_birth?: Maybe<Scalars["date"]["output"]>
  deposit_agent?: Maybe<Scalars["String"]["output"]>
  deposit_amount?: Maybe<Scalars["numeric"]["output"]>
  deposit_deadline_dt?: Maybe<Scalars["timestamp"]["output"]>
  deposit_paid_dt?: Maybe<Scalars["timestamp"]["output"]>
  enrolment_created_dt: Scalars["timestamp"]["output"]
  error_message?: Maybe<Scalars["String"]["output"]>
  first_name?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  last_name?: Maybe<Scalars["String"]["output"]>
  match_level_ca?: Maybe<Scalars["match_level"]["output"]>
  match_level_qs?: Maybe<Scalars["match_level"]["output"]>
  on_demand_scored: Scalars["Boolean"]["output"]
  reasons_ca?: Maybe<Scalars["String"]["output"]>
  reasons_qs?: Maybe<Scalars["String"]["output"]>
  /** An object relationship */
  registration_credit_check_billing_account?: Maybe<Billing_Account>
  /** An array relationship */
  registration_credit_check_registraion_credit_check_address: Array<Registration_Credit_Check_Address>
  /** An aggregate relationship */
  registration_credit_check_registraion_credit_check_address_aggregate: Registration_Credit_Check_Address_Aggregate
  retry_count?: Maybe<Scalars["smallint"]["output"]>
  soe_cancelled_dt?: Maybe<Scalars["timestamp"]["output"]>
  source: Scalars["enrolment_type"]["output"]
  status: Scalars["credit_check_status"]["output"]
  title?: Maybe<Scalars["title"]["output"]>
  updated_dt: Scalars["timestamp"]["output"]
}

/** columns and relationships of "registration_credit_check" */
export type Registration_Credit_CheckRegistration_Credit_Check_Registraion_Credit_Check_AddressArgs =
  {
    distinct_on?: InputMaybe<
      Array<Registration_Credit_Check_Address_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<Array<Registration_Credit_Check_Address_Order_By>>
    where?: InputMaybe<Registration_Credit_Check_Address_Bool_Exp>
  }

/** columns and relationships of "registration_credit_check" */
export type Registration_Credit_CheckRegistration_Credit_Check_Registraion_Credit_Check_Address_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Registration_Credit_Check_Address_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<Array<Registration_Credit_Check_Address_Order_By>>
    where?: InputMaybe<Registration_Credit_Check_Address_Bool_Exp>
  }

/** columns and relationships of "registration_credit_check_address" */
export type Registration_Credit_Check_Address = {
  __typename?: "registration_credit_check_address"
  billing_account_id: Scalars["bigint"]["output"]
  buildingname?: Maybe<Scalars["String"]["output"]>
  created_dt: Scalars["timestamp"]["output"]
  id: Scalars["bigint"]["output"]
  is_supply_address?: Maybe<Scalars["Boolean"]["output"]>
  postcode: Scalars["String"]["output"]
  street1?: Maybe<Scalars["String"]["output"]>
  street2?: Maybe<Scalars["String"]["output"]>
  updated_dt: Scalars["timestamp"]["output"]
}

/** aggregated selection of "registration_credit_check_address" */
export type Registration_Credit_Check_Address_Aggregate = {
  __typename?: "registration_credit_check_address_aggregate"
  aggregate?: Maybe<Registration_Credit_Check_Address_Aggregate_Fields>
  nodes: Array<Registration_Credit_Check_Address>
}

export type Registration_Credit_Check_Address_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Registration_Credit_Check_Address_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Registration_Credit_Check_Address_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<Registration_Credit_Check_Address_Aggregate_Bool_Exp_Count>
}

export type Registration_Credit_Check_Address_Aggregate_Bool_Exp_Bool_And = {
  arguments: Registration_Credit_Check_Address_Select_Column_Registration_Credit_Check_Address_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Registration_Credit_Check_Address_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Registration_Credit_Check_Address_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Registration_Credit_Check_Address_Select_Column_Registration_Credit_Check_Address_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Registration_Credit_Check_Address_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Registration_Credit_Check_Address_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Registration_Credit_Check_Address_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Registration_Credit_Check_Address_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "registration_credit_check_address" */
export type Registration_Credit_Check_Address_Aggregate_Fields = {
  __typename?: "registration_credit_check_address_aggregate_fields"
  avg?: Maybe<Registration_Credit_Check_Address_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Registration_Credit_Check_Address_Max_Fields>
  min?: Maybe<Registration_Credit_Check_Address_Min_Fields>
  stddev?: Maybe<Registration_Credit_Check_Address_Stddev_Fields>
  stddev_pop?: Maybe<Registration_Credit_Check_Address_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Registration_Credit_Check_Address_Stddev_Samp_Fields>
  sum?: Maybe<Registration_Credit_Check_Address_Sum_Fields>
  var_pop?: Maybe<Registration_Credit_Check_Address_Var_Pop_Fields>
  var_samp?: Maybe<Registration_Credit_Check_Address_Var_Samp_Fields>
  variance?: Maybe<Registration_Credit_Check_Address_Variance_Fields>
}

/** aggregate fields of "registration_credit_check_address" */
export type Registration_Credit_Check_Address_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Registration_Credit_Check_Address_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "registration_credit_check_address" */
export type Registration_Credit_Check_Address_Aggregate_Order_By = {
  avg?: InputMaybe<Registration_Credit_Check_Address_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Registration_Credit_Check_Address_Max_Order_By>
  min?: InputMaybe<Registration_Credit_Check_Address_Min_Order_By>
  stddev?: InputMaybe<Registration_Credit_Check_Address_Stddev_Order_By>
  stddev_pop?: InputMaybe<Registration_Credit_Check_Address_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Registration_Credit_Check_Address_Stddev_Samp_Order_By>
  sum?: InputMaybe<Registration_Credit_Check_Address_Sum_Order_By>
  var_pop?: InputMaybe<Registration_Credit_Check_Address_Var_Pop_Order_By>
  var_samp?: InputMaybe<Registration_Credit_Check_Address_Var_Samp_Order_By>
  variance?: InputMaybe<Registration_Credit_Check_Address_Variance_Order_By>
}

/** input type for inserting array relation for remote table "registration_credit_check_address" */
export type Registration_Credit_Check_Address_Arr_Rel_Insert_Input = {
  data: Array<Registration_Credit_Check_Address_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Registration_Credit_Check_Address_On_Conflict>
}

/** aggregate avg on columns */
export type Registration_Credit_Check_Address_Avg_Fields = {
  __typename?: "registration_credit_check_address_avg_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "registration_credit_check_address" */
export type Registration_Credit_Check_Address_Avg_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "registration_credit_check_address". All fields are combined with a logical 'AND'. */
export type Registration_Credit_Check_Address_Bool_Exp = {
  _and?: InputMaybe<Array<Registration_Credit_Check_Address_Bool_Exp>>
  _not?: InputMaybe<Registration_Credit_Check_Address_Bool_Exp>
  _or?: InputMaybe<Array<Registration_Credit_Check_Address_Bool_Exp>>
  billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  buildingname?: InputMaybe<String_Comparison_Exp>
  created_dt?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  is_supply_address?: InputMaybe<Boolean_Comparison_Exp>
  postcode?: InputMaybe<String_Comparison_Exp>
  street1?: InputMaybe<String_Comparison_Exp>
  street2?: InputMaybe<String_Comparison_Exp>
  updated_dt?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "registration_credit_check_address" */
export enum Registration_Credit_Check_Address_Constraint {
  /** unique or primary key constraint on columns "street2", "postcode", "buildingname", "street1", "billing_account_id" */
  TuAddressBillingAccountIdBuildingnameStreet1Street2Key = "tu_address_billing_account_id_buildingname_street1_street2__key",
  /** unique or primary key constraint on columns "id" */
  TuAddressPkey = "tu_address_pkey",
}

/** input type for incrementing numeric columns in table "registration_credit_check_address" */
export type Registration_Credit_Check_Address_Inc_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "registration_credit_check_address" */
export type Registration_Credit_Check_Address_Insert_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  buildingname?: InputMaybe<Scalars["String"]["input"]>
  created_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  is_supply_address?: InputMaybe<Scalars["Boolean"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  street1?: InputMaybe<Scalars["String"]["input"]>
  street2?: InputMaybe<Scalars["String"]["input"]>
  updated_dt?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Registration_Credit_Check_Address_Max_Fields = {
  __typename?: "registration_credit_check_address_max_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  buildingname?: Maybe<Scalars["String"]["output"]>
  created_dt?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  postcode?: Maybe<Scalars["String"]["output"]>
  street1?: Maybe<Scalars["String"]["output"]>
  street2?: Maybe<Scalars["String"]["output"]>
  updated_dt?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "registration_credit_check_address" */
export type Registration_Credit_Check_Address_Max_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  buildingname?: InputMaybe<Order_By>
  created_dt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  postcode?: InputMaybe<Order_By>
  street1?: InputMaybe<Order_By>
  street2?: InputMaybe<Order_By>
  updated_dt?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Registration_Credit_Check_Address_Min_Fields = {
  __typename?: "registration_credit_check_address_min_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  buildingname?: Maybe<Scalars["String"]["output"]>
  created_dt?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  postcode?: Maybe<Scalars["String"]["output"]>
  street1?: Maybe<Scalars["String"]["output"]>
  street2?: Maybe<Scalars["String"]["output"]>
  updated_dt?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "registration_credit_check_address" */
export type Registration_Credit_Check_Address_Min_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  buildingname?: InputMaybe<Order_By>
  created_dt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  postcode?: InputMaybe<Order_By>
  street1?: InputMaybe<Order_By>
  street2?: InputMaybe<Order_By>
  updated_dt?: InputMaybe<Order_By>
}

/** response of any mutation on the table "registration_credit_check_address" */
export type Registration_Credit_Check_Address_Mutation_Response = {
  __typename?: "registration_credit_check_address_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Registration_Credit_Check_Address>
}

/** on_conflict condition type for table "registration_credit_check_address" */
export type Registration_Credit_Check_Address_On_Conflict = {
  constraint: Registration_Credit_Check_Address_Constraint
  update_columns?: Array<Registration_Credit_Check_Address_Update_Column>
  where?: InputMaybe<Registration_Credit_Check_Address_Bool_Exp>
}

/** Ordering options when selecting data from "registration_credit_check_address". */
export type Registration_Credit_Check_Address_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  buildingname?: InputMaybe<Order_By>
  created_dt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  is_supply_address?: InputMaybe<Order_By>
  postcode?: InputMaybe<Order_By>
  street1?: InputMaybe<Order_By>
  street2?: InputMaybe<Order_By>
  updated_dt?: InputMaybe<Order_By>
}

/** primary key columns input for table: registration_credit_check_address */
export type Registration_Credit_Check_Address_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "registration_credit_check_address" */
export enum Registration_Credit_Check_Address_Select_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  Buildingname = "buildingname",
  /** column name */
  CreatedDt = "created_dt",
  /** column name */
  Id = "id",
  /** column name */
  IsSupplyAddress = "is_supply_address",
  /** column name */
  Postcode = "postcode",
  /** column name */
  Street1 = "street1",
  /** column name */
  Street2 = "street2",
  /** column name */
  UpdatedDt = "updated_dt",
}

/** select "registration_credit_check_address_aggregate_bool_exp_bool_and_arguments_columns" columns of table "registration_credit_check_address" */
export enum Registration_Credit_Check_Address_Select_Column_Registration_Credit_Check_Address_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsSupplyAddress = "is_supply_address",
}

/** select "registration_credit_check_address_aggregate_bool_exp_bool_or_arguments_columns" columns of table "registration_credit_check_address" */
export enum Registration_Credit_Check_Address_Select_Column_Registration_Credit_Check_Address_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsSupplyAddress = "is_supply_address",
}

/** input type for updating data in table "registration_credit_check_address" */
export type Registration_Credit_Check_Address_Set_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  buildingname?: InputMaybe<Scalars["String"]["input"]>
  created_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  is_supply_address?: InputMaybe<Scalars["Boolean"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  street1?: InputMaybe<Scalars["String"]["input"]>
  street2?: InputMaybe<Scalars["String"]["input"]>
  updated_dt?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Registration_Credit_Check_Address_Stddev_Fields = {
  __typename?: "registration_credit_check_address_stddev_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "registration_credit_check_address" */
export type Registration_Credit_Check_Address_Stddev_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Registration_Credit_Check_Address_Stddev_Pop_Fields = {
  __typename?: "registration_credit_check_address_stddev_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "registration_credit_check_address" */
export type Registration_Credit_Check_Address_Stddev_Pop_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Registration_Credit_Check_Address_Stddev_Samp_Fields = {
  __typename?: "registration_credit_check_address_stddev_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "registration_credit_check_address" */
export type Registration_Credit_Check_Address_Stddev_Samp_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "registration_credit_check_address" */
export type Registration_Credit_Check_Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Registration_Credit_Check_Address_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Registration_Credit_Check_Address_Stream_Cursor_Value_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  buildingname?: InputMaybe<Scalars["String"]["input"]>
  created_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  is_supply_address?: InputMaybe<Scalars["Boolean"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  street1?: InputMaybe<Scalars["String"]["input"]>
  street2?: InputMaybe<Scalars["String"]["input"]>
  updated_dt?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Registration_Credit_Check_Address_Sum_Fields = {
  __typename?: "registration_credit_check_address_sum_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "registration_credit_check_address" */
export type Registration_Credit_Check_Address_Sum_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** update columns of table "registration_credit_check_address" */
export enum Registration_Credit_Check_Address_Update_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  Buildingname = "buildingname",
  /** column name */
  CreatedDt = "created_dt",
  /** column name */
  Id = "id",
  /** column name */
  IsSupplyAddress = "is_supply_address",
  /** column name */
  Postcode = "postcode",
  /** column name */
  Street1 = "street1",
  /** column name */
  Street2 = "street2",
  /** column name */
  UpdatedDt = "updated_dt",
}

export type Registration_Credit_Check_Address_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Registration_Credit_Check_Address_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Registration_Credit_Check_Address_Set_Input>
  /** filter the rows which have to be updated */
  where: Registration_Credit_Check_Address_Bool_Exp
}

/** aggregate var_pop on columns */
export type Registration_Credit_Check_Address_Var_Pop_Fields = {
  __typename?: "registration_credit_check_address_var_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "registration_credit_check_address" */
export type Registration_Credit_Check_Address_Var_Pop_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Registration_Credit_Check_Address_Var_Samp_Fields = {
  __typename?: "registration_credit_check_address_var_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "registration_credit_check_address" */
export type Registration_Credit_Check_Address_Var_Samp_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Registration_Credit_Check_Address_Variance_Fields = {
  __typename?: "registration_credit_check_address_variance_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "registration_credit_check_address" */
export type Registration_Credit_Check_Address_Variance_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregated selection of "registration_credit_check" */
export type Registration_Credit_Check_Aggregate = {
  __typename?: "registration_credit_check_aggregate"
  aggregate?: Maybe<Registration_Credit_Check_Aggregate_Fields>
  nodes: Array<Registration_Credit_Check>
}

/** aggregate fields of "registration_credit_check" */
export type Registration_Credit_Check_Aggregate_Fields = {
  __typename?: "registration_credit_check_aggregate_fields"
  avg?: Maybe<Registration_Credit_Check_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Registration_Credit_Check_Max_Fields>
  min?: Maybe<Registration_Credit_Check_Min_Fields>
  stddev?: Maybe<Registration_Credit_Check_Stddev_Fields>
  stddev_pop?: Maybe<Registration_Credit_Check_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Registration_Credit_Check_Stddev_Samp_Fields>
  sum?: Maybe<Registration_Credit_Check_Sum_Fields>
  var_pop?: Maybe<Registration_Credit_Check_Var_Pop_Fields>
  var_samp?: Maybe<Registration_Credit_Check_Var_Samp_Fields>
  variance?: Maybe<Registration_Credit_Check_Variance_Fields>
}

/** aggregate fields of "registration_credit_check" */
export type Registration_Credit_Check_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Registration_Credit_Check_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Registration_Credit_Check_Avg_Fields = {
  __typename?: "registration_credit_check_avg_fields"
  ao_score_ca?: Maybe<Scalars["Float"]["output"]>
  ao_score_qs?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  deposit_amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "registration_credit_check". All fields are combined with a logical 'AND'. */
export type Registration_Credit_Check_Bool_Exp = {
  _and?: InputMaybe<Array<Registration_Credit_Check_Bool_Exp>>
  _not?: InputMaybe<Registration_Credit_Check_Bool_Exp>
  _or?: InputMaybe<Array<Registration_Credit_Check_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  ao_score_ca?: InputMaybe<Int_Comparison_Exp>
  ao_score_qs?: InputMaybe<Int_Comparison_Exp>
  billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  billing_account_start_dt?: InputMaybe<Timestamp_Comparison_Exp>
  broker?: InputMaybe<Enrolment_Broker_Comparison_Exp>
  created_dt?: InputMaybe<Timestamp_Comparison_Exp>
  date_of_birth?: InputMaybe<Date_Comparison_Exp>
  deposit_agent?: InputMaybe<String_Comparison_Exp>
  deposit_amount?: InputMaybe<Numeric_Comparison_Exp>
  deposit_deadline_dt?: InputMaybe<Timestamp_Comparison_Exp>
  deposit_paid_dt?: InputMaybe<Timestamp_Comparison_Exp>
  enrolment_created_dt?: InputMaybe<Timestamp_Comparison_Exp>
  error_message?: InputMaybe<String_Comparison_Exp>
  first_name?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  last_name?: InputMaybe<String_Comparison_Exp>
  match_level_ca?: InputMaybe<Match_Level_Comparison_Exp>
  match_level_qs?: InputMaybe<Match_Level_Comparison_Exp>
  on_demand_scored?: InputMaybe<Boolean_Comparison_Exp>
  reasons_ca?: InputMaybe<String_Comparison_Exp>
  reasons_qs?: InputMaybe<String_Comparison_Exp>
  registration_credit_check_billing_account?: InputMaybe<Billing_Account_Bool_Exp>
  registration_credit_check_registraion_credit_check_address?: InputMaybe<Registration_Credit_Check_Address_Bool_Exp>
  registration_credit_check_registraion_credit_check_address_aggregate?: InputMaybe<Registration_Credit_Check_Address_Aggregate_Bool_Exp>
  retry_count?: InputMaybe<Smallint_Comparison_Exp>
  soe_cancelled_dt?: InputMaybe<Timestamp_Comparison_Exp>
  source?: InputMaybe<Enrolment_Type_Comparison_Exp>
  status?: InputMaybe<Credit_Check_Status_Comparison_Exp>
  title?: InputMaybe<Title_Comparison_Exp>
  updated_dt?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "registration_credit_check" */
export enum Registration_Credit_Check_Constraint {
  /** unique or primary key constraint on columns "billing_account_id" */
  RegistrationCreditCheckBillingAccountIdKey = "registration_credit_check_billing_account_id_key",
  /** unique or primary key constraint on columns "id" */
  RegistrationCreditCheckPkey = "registration_credit_check_pkey",
}

/** input type for incrementing numeric columns in table "registration_credit_check" */
export type Registration_Credit_Check_Inc_Input = {
  ao_score_ca?: InputMaybe<Scalars["Int"]["input"]>
  ao_score_qs?: InputMaybe<Scalars["Int"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  deposit_amount?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  retry_count?: InputMaybe<Scalars["smallint"]["input"]>
}

/** input type for inserting data into table "registration_credit_check" */
export type Registration_Credit_Check_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  ao_score_ca?: InputMaybe<Scalars["Int"]["input"]>
  ao_score_qs?: InputMaybe<Scalars["Int"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  billing_account_start_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  broker?: InputMaybe<Scalars["enrolment_broker"]["input"]>
  created_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  date_of_birth?: InputMaybe<Scalars["date"]["input"]>
  deposit_agent?: InputMaybe<Scalars["String"]["input"]>
  deposit_amount?: InputMaybe<Scalars["numeric"]["input"]>
  deposit_deadline_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  deposit_paid_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  enrolment_created_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  error_message?: InputMaybe<Scalars["String"]["input"]>
  first_name?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_name?: InputMaybe<Scalars["String"]["input"]>
  match_level_ca?: InputMaybe<Scalars["match_level"]["input"]>
  match_level_qs?: InputMaybe<Scalars["match_level"]["input"]>
  on_demand_scored?: InputMaybe<Scalars["Boolean"]["input"]>
  reasons_ca?: InputMaybe<Scalars["String"]["input"]>
  reasons_qs?: InputMaybe<Scalars["String"]["input"]>
  registration_credit_check_billing_account?: InputMaybe<Billing_Account_Obj_Rel_Insert_Input>
  registration_credit_check_registraion_credit_check_address?: InputMaybe<Registration_Credit_Check_Address_Arr_Rel_Insert_Input>
  retry_count?: InputMaybe<Scalars["smallint"]["input"]>
  soe_cancelled_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  source?: InputMaybe<Scalars["enrolment_type"]["input"]>
  status?: InputMaybe<Scalars["credit_check_status"]["input"]>
  title?: InputMaybe<Scalars["title"]["input"]>
  updated_dt?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Registration_Credit_Check_Max_Fields = {
  __typename?: "registration_credit_check_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  ao_score_ca?: Maybe<Scalars["Int"]["output"]>
  ao_score_qs?: Maybe<Scalars["Int"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  billing_account_start_dt?: Maybe<Scalars["timestamp"]["output"]>
  broker?: Maybe<Scalars["enrolment_broker"]["output"]>
  created_dt?: Maybe<Scalars["timestamp"]["output"]>
  date_of_birth?: Maybe<Scalars["date"]["output"]>
  deposit_agent?: Maybe<Scalars["String"]["output"]>
  deposit_amount?: Maybe<Scalars["numeric"]["output"]>
  deposit_deadline_dt?: Maybe<Scalars["timestamp"]["output"]>
  deposit_paid_dt?: Maybe<Scalars["timestamp"]["output"]>
  enrolment_created_dt?: Maybe<Scalars["timestamp"]["output"]>
  error_message?: Maybe<Scalars["String"]["output"]>
  first_name?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_name?: Maybe<Scalars["String"]["output"]>
  match_level_ca?: Maybe<Scalars["match_level"]["output"]>
  match_level_qs?: Maybe<Scalars["match_level"]["output"]>
  reasons_ca?: Maybe<Scalars["String"]["output"]>
  reasons_qs?: Maybe<Scalars["String"]["output"]>
  retry_count?: Maybe<Scalars["smallint"]["output"]>
  soe_cancelled_dt?: Maybe<Scalars["timestamp"]["output"]>
  source?: Maybe<Scalars["enrolment_type"]["output"]>
  status?: Maybe<Scalars["credit_check_status"]["output"]>
  title?: Maybe<Scalars["title"]["output"]>
  updated_dt?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Registration_Credit_Check_Min_Fields = {
  __typename?: "registration_credit_check_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  ao_score_ca?: Maybe<Scalars["Int"]["output"]>
  ao_score_qs?: Maybe<Scalars["Int"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  billing_account_start_dt?: Maybe<Scalars["timestamp"]["output"]>
  broker?: Maybe<Scalars["enrolment_broker"]["output"]>
  created_dt?: Maybe<Scalars["timestamp"]["output"]>
  date_of_birth?: Maybe<Scalars["date"]["output"]>
  deposit_agent?: Maybe<Scalars["String"]["output"]>
  deposit_amount?: Maybe<Scalars["numeric"]["output"]>
  deposit_deadline_dt?: Maybe<Scalars["timestamp"]["output"]>
  deposit_paid_dt?: Maybe<Scalars["timestamp"]["output"]>
  enrolment_created_dt?: Maybe<Scalars["timestamp"]["output"]>
  error_message?: Maybe<Scalars["String"]["output"]>
  first_name?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_name?: Maybe<Scalars["String"]["output"]>
  match_level_ca?: Maybe<Scalars["match_level"]["output"]>
  match_level_qs?: Maybe<Scalars["match_level"]["output"]>
  reasons_ca?: Maybe<Scalars["String"]["output"]>
  reasons_qs?: Maybe<Scalars["String"]["output"]>
  retry_count?: Maybe<Scalars["smallint"]["output"]>
  soe_cancelled_dt?: Maybe<Scalars["timestamp"]["output"]>
  source?: Maybe<Scalars["enrolment_type"]["output"]>
  status?: Maybe<Scalars["credit_check_status"]["output"]>
  title?: Maybe<Scalars["title"]["output"]>
  updated_dt?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "registration_credit_check" */
export type Registration_Credit_Check_Mutation_Response = {
  __typename?: "registration_credit_check_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Registration_Credit_Check>
}

/** on_conflict condition type for table "registration_credit_check" */
export type Registration_Credit_Check_On_Conflict = {
  constraint: Registration_Credit_Check_Constraint
  update_columns?: Array<Registration_Credit_Check_Update_Column>
  where?: InputMaybe<Registration_Credit_Check_Bool_Exp>
}

/** Ordering options when selecting data from "registration_credit_check". */
export type Registration_Credit_Check_Order_By = {
  account_number?: InputMaybe<Order_By>
  ao_score_ca?: InputMaybe<Order_By>
  ao_score_qs?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  billing_account_start_dt?: InputMaybe<Order_By>
  broker?: InputMaybe<Order_By>
  created_dt?: InputMaybe<Order_By>
  date_of_birth?: InputMaybe<Order_By>
  deposit_agent?: InputMaybe<Order_By>
  deposit_amount?: InputMaybe<Order_By>
  deposit_deadline_dt?: InputMaybe<Order_By>
  deposit_paid_dt?: InputMaybe<Order_By>
  enrolment_created_dt?: InputMaybe<Order_By>
  error_message?: InputMaybe<Order_By>
  first_name?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  last_name?: InputMaybe<Order_By>
  match_level_ca?: InputMaybe<Order_By>
  match_level_qs?: InputMaybe<Order_By>
  on_demand_scored?: InputMaybe<Order_By>
  reasons_ca?: InputMaybe<Order_By>
  reasons_qs?: InputMaybe<Order_By>
  registration_credit_check_billing_account?: InputMaybe<Billing_Account_Order_By>
  registration_credit_check_registraion_credit_check_address_aggregate?: InputMaybe<Registration_Credit_Check_Address_Aggregate_Order_By>
  retry_count?: InputMaybe<Order_By>
  soe_cancelled_dt?: InputMaybe<Order_By>
  source?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  title?: InputMaybe<Order_By>
  updated_dt?: InputMaybe<Order_By>
}

/** primary key columns input for table: registration_credit_check */
export type Registration_Credit_Check_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "registration_credit_check" */
export enum Registration_Credit_Check_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AoScoreCa = "ao_score_ca",
  /** column name */
  AoScoreQs = "ao_score_qs",
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  BillingAccountStartDt = "billing_account_start_dt",
  /** column name */
  Broker = "broker",
  /** column name */
  CreatedDt = "created_dt",
  /** column name */
  DateOfBirth = "date_of_birth",
  /** column name */
  DepositAgent = "deposit_agent",
  /** column name */
  DepositAmount = "deposit_amount",
  /** column name */
  DepositDeadlineDt = "deposit_deadline_dt",
  /** column name */
  DepositPaidDt = "deposit_paid_dt",
  /** column name */
  EnrolmentCreatedDt = "enrolment_created_dt",
  /** column name */
  ErrorMessage = "error_message",
  /** column name */
  FirstName = "first_name",
  /** column name */
  Id = "id",
  /** column name */
  LastName = "last_name",
  /** column name */
  MatchLevelCa = "match_level_ca",
  /** column name */
  MatchLevelQs = "match_level_qs",
  /** column name */
  OnDemandScored = "on_demand_scored",
  /** column name */
  ReasonsCa = "reasons_ca",
  /** column name */
  ReasonsQs = "reasons_qs",
  /** column name */
  RetryCount = "retry_count",
  /** column name */
  SoeCancelledDt = "soe_cancelled_dt",
  /** column name */
  Source = "source",
  /** column name */
  Status = "status",
  /** column name */
  Title = "title",
  /** column name */
  UpdatedDt = "updated_dt",
}

/** input type for updating data in table "registration_credit_check" */
export type Registration_Credit_Check_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  ao_score_ca?: InputMaybe<Scalars["Int"]["input"]>
  ao_score_qs?: InputMaybe<Scalars["Int"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  billing_account_start_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  broker?: InputMaybe<Scalars["enrolment_broker"]["input"]>
  created_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  date_of_birth?: InputMaybe<Scalars["date"]["input"]>
  deposit_agent?: InputMaybe<Scalars["String"]["input"]>
  deposit_amount?: InputMaybe<Scalars["numeric"]["input"]>
  deposit_deadline_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  deposit_paid_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  enrolment_created_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  error_message?: InputMaybe<Scalars["String"]["input"]>
  first_name?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_name?: InputMaybe<Scalars["String"]["input"]>
  match_level_ca?: InputMaybe<Scalars["match_level"]["input"]>
  match_level_qs?: InputMaybe<Scalars["match_level"]["input"]>
  on_demand_scored?: InputMaybe<Scalars["Boolean"]["input"]>
  reasons_ca?: InputMaybe<Scalars["String"]["input"]>
  reasons_qs?: InputMaybe<Scalars["String"]["input"]>
  retry_count?: InputMaybe<Scalars["smallint"]["input"]>
  soe_cancelled_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  source?: InputMaybe<Scalars["enrolment_type"]["input"]>
  status?: InputMaybe<Scalars["credit_check_status"]["input"]>
  title?: InputMaybe<Scalars["title"]["input"]>
  updated_dt?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Registration_Credit_Check_Stddev_Fields = {
  __typename?: "registration_credit_check_stddev_fields"
  ao_score_ca?: Maybe<Scalars["Float"]["output"]>
  ao_score_qs?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  deposit_amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Registration_Credit_Check_Stddev_Pop_Fields = {
  __typename?: "registration_credit_check_stddev_pop_fields"
  ao_score_ca?: Maybe<Scalars["Float"]["output"]>
  ao_score_qs?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  deposit_amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Registration_Credit_Check_Stddev_Samp_Fields = {
  __typename?: "registration_credit_check_stddev_samp_fields"
  ao_score_ca?: Maybe<Scalars["Float"]["output"]>
  ao_score_qs?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  deposit_amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "registration_credit_check" */
export type Registration_Credit_Check_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Registration_Credit_Check_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Registration_Credit_Check_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  ao_score_ca?: InputMaybe<Scalars["Int"]["input"]>
  ao_score_qs?: InputMaybe<Scalars["Int"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  billing_account_start_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  broker?: InputMaybe<Scalars["enrolment_broker"]["input"]>
  created_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  date_of_birth?: InputMaybe<Scalars["date"]["input"]>
  deposit_agent?: InputMaybe<Scalars["String"]["input"]>
  deposit_amount?: InputMaybe<Scalars["numeric"]["input"]>
  deposit_deadline_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  deposit_paid_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  enrolment_created_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  error_message?: InputMaybe<Scalars["String"]["input"]>
  first_name?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_name?: InputMaybe<Scalars["String"]["input"]>
  match_level_ca?: InputMaybe<Scalars["match_level"]["input"]>
  match_level_qs?: InputMaybe<Scalars["match_level"]["input"]>
  on_demand_scored?: InputMaybe<Scalars["Boolean"]["input"]>
  reasons_ca?: InputMaybe<Scalars["String"]["input"]>
  reasons_qs?: InputMaybe<Scalars["String"]["input"]>
  retry_count?: InputMaybe<Scalars["smallint"]["input"]>
  soe_cancelled_dt?: InputMaybe<Scalars["timestamp"]["input"]>
  source?: InputMaybe<Scalars["enrolment_type"]["input"]>
  status?: InputMaybe<Scalars["credit_check_status"]["input"]>
  title?: InputMaybe<Scalars["title"]["input"]>
  updated_dt?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Registration_Credit_Check_Sum_Fields = {
  __typename?: "registration_credit_check_sum_fields"
  ao_score_ca?: Maybe<Scalars["Int"]["output"]>
  ao_score_qs?: Maybe<Scalars["Int"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  deposit_amount?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  retry_count?: Maybe<Scalars["smallint"]["output"]>
}

/** update columns of table "registration_credit_check" */
export enum Registration_Credit_Check_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AoScoreCa = "ao_score_ca",
  /** column name */
  AoScoreQs = "ao_score_qs",
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  BillingAccountStartDt = "billing_account_start_dt",
  /** column name */
  Broker = "broker",
  /** column name */
  CreatedDt = "created_dt",
  /** column name */
  DateOfBirth = "date_of_birth",
  /** column name */
  DepositAgent = "deposit_agent",
  /** column name */
  DepositAmount = "deposit_amount",
  /** column name */
  DepositDeadlineDt = "deposit_deadline_dt",
  /** column name */
  DepositPaidDt = "deposit_paid_dt",
  /** column name */
  EnrolmentCreatedDt = "enrolment_created_dt",
  /** column name */
  ErrorMessage = "error_message",
  /** column name */
  FirstName = "first_name",
  /** column name */
  Id = "id",
  /** column name */
  LastName = "last_name",
  /** column name */
  MatchLevelCa = "match_level_ca",
  /** column name */
  MatchLevelQs = "match_level_qs",
  /** column name */
  OnDemandScored = "on_demand_scored",
  /** column name */
  ReasonsCa = "reasons_ca",
  /** column name */
  ReasonsQs = "reasons_qs",
  /** column name */
  RetryCount = "retry_count",
  /** column name */
  SoeCancelledDt = "soe_cancelled_dt",
  /** column name */
  Source = "source",
  /** column name */
  Status = "status",
  /** column name */
  Title = "title",
  /** column name */
  UpdatedDt = "updated_dt",
}

export type Registration_Credit_Check_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Registration_Credit_Check_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Registration_Credit_Check_Set_Input>
  /** filter the rows which have to be updated */
  where: Registration_Credit_Check_Bool_Exp
}

/** aggregate var_pop on columns */
export type Registration_Credit_Check_Var_Pop_Fields = {
  __typename?: "registration_credit_check_var_pop_fields"
  ao_score_ca?: Maybe<Scalars["Float"]["output"]>
  ao_score_qs?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  deposit_amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Registration_Credit_Check_Var_Samp_Fields = {
  __typename?: "registration_credit_check_var_samp_fields"
  ao_score_ca?: Maybe<Scalars["Float"]["output"]>
  ao_score_qs?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  deposit_amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Registration_Credit_Check_Variance_Fields = {
  __typename?: "registration_credit_check_variance_fields"
  ao_score_ca?: Maybe<Scalars["Float"]["output"]>
  ao_score_qs?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  deposit_amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  retry_count?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "reminder" */
export type Reminder = {
  __typename?: "reminder"
  active: Scalars["Boolean"]["output"]
  alignment: Scalars["smallint"]["output"]
  /** An object relationship */
  billing_account: Billing_Account
  billing_account_id: Scalars["bigint"]["output"]
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  frequency: Scalars["reminder_frequency"]["output"]
  id: Scalars["bigint"]["output"]
  last_sent_at?: Maybe<Scalars["timestamp"]["output"]>
  type: Scalars["reminder_type"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "reminder" */
export type Reminder_Aggregate = {
  __typename?: "reminder_aggregate"
  aggregate?: Maybe<Reminder_Aggregate_Fields>
  nodes: Array<Reminder>
}

export type Reminder_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Reminder_Aggregate_Bool_Exp_Bool_And>
  bool_or?: InputMaybe<Reminder_Aggregate_Bool_Exp_Bool_Or>
  count?: InputMaybe<Reminder_Aggregate_Bool_Exp_Count>
}

export type Reminder_Aggregate_Bool_Exp_Bool_And = {
  arguments: Reminder_Select_Column_Reminder_Aggregate_Bool_Exp_Bool_And_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Reminder_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Reminder_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Reminder_Select_Column_Reminder_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Reminder_Bool_Exp>
  predicate: Boolean_Comparison_Exp
}

export type Reminder_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Reminder_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Reminder_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "reminder" */
export type Reminder_Aggregate_Fields = {
  __typename?: "reminder_aggregate_fields"
  avg?: Maybe<Reminder_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Reminder_Max_Fields>
  min?: Maybe<Reminder_Min_Fields>
  stddev?: Maybe<Reminder_Stddev_Fields>
  stddev_pop?: Maybe<Reminder_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Reminder_Stddev_Samp_Fields>
  sum?: Maybe<Reminder_Sum_Fields>
  var_pop?: Maybe<Reminder_Var_Pop_Fields>
  var_samp?: Maybe<Reminder_Var_Samp_Fields>
  variance?: Maybe<Reminder_Variance_Fields>
}

/** aggregate fields of "reminder" */
export type Reminder_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reminder_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "reminder" */
export type Reminder_Aggregate_Order_By = {
  avg?: InputMaybe<Reminder_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Reminder_Max_Order_By>
  min?: InputMaybe<Reminder_Min_Order_By>
  stddev?: InputMaybe<Reminder_Stddev_Order_By>
  stddev_pop?: InputMaybe<Reminder_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Reminder_Stddev_Samp_Order_By>
  sum?: InputMaybe<Reminder_Sum_Order_By>
  var_pop?: InputMaybe<Reminder_Var_Pop_Order_By>
  var_samp?: InputMaybe<Reminder_Var_Samp_Order_By>
  variance?: InputMaybe<Reminder_Variance_Order_By>
}

/** input type for inserting array relation for remote table "reminder" */
export type Reminder_Arr_Rel_Insert_Input = {
  data: Array<Reminder_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Reminder_On_Conflict>
}

/** aggregate avg on columns */
export type Reminder_Avg_Fields = {
  __typename?: "reminder_avg_fields"
  alignment?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "reminder" */
export type Reminder_Avg_Order_By = {
  alignment?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "reminder". All fields are combined with a logical 'AND'. */
export type Reminder_Bool_Exp = {
  _and?: InputMaybe<Array<Reminder_Bool_Exp>>
  _not?: InputMaybe<Reminder_Bool_Exp>
  _or?: InputMaybe<Array<Reminder_Bool_Exp>>
  active?: InputMaybe<Boolean_Comparison_Exp>
  alignment?: InputMaybe<Smallint_Comparison_Exp>
  billing_account?: InputMaybe<Billing_Account_Bool_Exp>
  billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  frequency?: InputMaybe<Reminder_Frequency_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  last_sent_at?: InputMaybe<Timestamp_Comparison_Exp>
  type?: InputMaybe<Reminder_Type_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "reminder" */
export enum Reminder_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkReminder = "pk_reminder",
  /** unique or primary key constraint on columns "type", "billing_account_id" */
  UqReminderBillingAccountTypeActive = "uq_reminder_billing_account_type_active",
}

/** Boolean expression to compare columns of type "reminder_frequency". All fields are combined with logical 'AND'. */
export type Reminder_Frequency_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["reminder_frequency"]["input"]>
  _gt?: InputMaybe<Scalars["reminder_frequency"]["input"]>
  _gte?: InputMaybe<Scalars["reminder_frequency"]["input"]>
  _in?: InputMaybe<Array<Scalars["reminder_frequency"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["reminder_frequency"]["input"]>
  _lte?: InputMaybe<Scalars["reminder_frequency"]["input"]>
  _neq?: InputMaybe<Scalars["reminder_frequency"]["input"]>
  _nin?: InputMaybe<Array<Scalars["reminder_frequency"]["input"]>>
}

/** input type for incrementing numeric columns in table "reminder" */
export type Reminder_Inc_Input = {
  alignment?: InputMaybe<Scalars["smallint"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "reminder" */
export type Reminder_Insert_Input = {
  active?: InputMaybe<Scalars["Boolean"]["input"]>
  alignment?: InputMaybe<Scalars["smallint"]["input"]>
  billing_account?: InputMaybe<Billing_Account_Obj_Rel_Insert_Input>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  frequency?: InputMaybe<Scalars["reminder_frequency"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_sent_at?: InputMaybe<Scalars["timestamp"]["input"]>
  type?: InputMaybe<Scalars["reminder_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Reminder_Max_Fields = {
  __typename?: "reminder_max_fields"
  alignment?: Maybe<Scalars["smallint"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  frequency?: Maybe<Scalars["reminder_frequency"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_sent_at?: Maybe<Scalars["timestamp"]["output"]>
  type?: Maybe<Scalars["reminder_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "reminder" */
export type Reminder_Max_Order_By = {
  alignment?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  frequency?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  last_sent_at?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Reminder_Min_Fields = {
  __typename?: "reminder_min_fields"
  alignment?: Maybe<Scalars["smallint"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  frequency?: Maybe<Scalars["reminder_frequency"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_sent_at?: Maybe<Scalars["timestamp"]["output"]>
  type?: Maybe<Scalars["reminder_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "reminder" */
export type Reminder_Min_Order_By = {
  alignment?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  frequency?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  last_sent_at?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "reminder" */
export type Reminder_Mutation_Response = {
  __typename?: "reminder_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Reminder>
}

/** on_conflict condition type for table "reminder" */
export type Reminder_On_Conflict = {
  constraint: Reminder_Constraint
  update_columns?: Array<Reminder_Update_Column>
  where?: InputMaybe<Reminder_Bool_Exp>
}

/** Ordering options when selecting data from "reminder". */
export type Reminder_Order_By = {
  active?: InputMaybe<Order_By>
  alignment?: InputMaybe<Order_By>
  billing_account?: InputMaybe<Billing_Account_Order_By>
  billing_account_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  frequency?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  last_sent_at?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: reminder */
export type Reminder_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "reminder" */
export enum Reminder_Select_Column {
  /** column name */
  Active = "active",
  /** column name */
  Alignment = "alignment",
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Frequency = "frequency",
  /** column name */
  Id = "id",
  /** column name */
  LastSentAt = "last_sent_at",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** select "reminder_aggregate_bool_exp_bool_and_arguments_columns" columns of table "reminder" */
export enum Reminder_Select_Column_Reminder_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = "active",
}

/** select "reminder_aggregate_bool_exp_bool_or_arguments_columns" columns of table "reminder" */
export enum Reminder_Select_Column_Reminder_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = "active",
}

/** input type for updating data in table "reminder" */
export type Reminder_Set_Input = {
  active?: InputMaybe<Scalars["Boolean"]["input"]>
  alignment?: InputMaybe<Scalars["smallint"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  frequency?: InputMaybe<Scalars["reminder_frequency"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_sent_at?: InputMaybe<Scalars["timestamp"]["input"]>
  type?: InputMaybe<Scalars["reminder_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Reminder_Stddev_Fields = {
  __typename?: "reminder_stddev_fields"
  alignment?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "reminder" */
export type Reminder_Stddev_Order_By = {
  alignment?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Reminder_Stddev_Pop_Fields = {
  __typename?: "reminder_stddev_pop_fields"
  alignment?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "reminder" */
export type Reminder_Stddev_Pop_Order_By = {
  alignment?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Reminder_Stddev_Samp_Fields = {
  __typename?: "reminder_stddev_samp_fields"
  alignment?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "reminder" */
export type Reminder_Stddev_Samp_Order_By = {
  alignment?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "reminder" */
export type Reminder_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reminder_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Reminder_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars["Boolean"]["input"]>
  alignment?: InputMaybe<Scalars["smallint"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  frequency?: InputMaybe<Scalars["reminder_frequency"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_sent_at?: InputMaybe<Scalars["timestamp"]["input"]>
  type?: InputMaybe<Scalars["reminder_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Reminder_Sum_Fields = {
  __typename?: "reminder_sum_fields"
  alignment?: Maybe<Scalars["smallint"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "reminder" */
export type Reminder_Sum_Order_By = {
  alignment?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "reminder_type". All fields are combined with logical 'AND'. */
export type Reminder_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["reminder_type"]["input"]>
  _gt?: InputMaybe<Scalars["reminder_type"]["input"]>
  _gte?: InputMaybe<Scalars["reminder_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["reminder_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["reminder_type"]["input"]>
  _lte?: InputMaybe<Scalars["reminder_type"]["input"]>
  _neq?: InputMaybe<Scalars["reminder_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["reminder_type"]["input"]>>
}

/** update columns of table "reminder" */
export enum Reminder_Update_Column {
  /** column name */
  Active = "active",
  /** column name */
  Alignment = "alignment",
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Frequency = "frequency",
  /** column name */
  Id = "id",
  /** column name */
  LastSentAt = "last_sent_at",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Reminder_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Reminder_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reminder_Set_Input>
  /** filter the rows which have to be updated */
  where: Reminder_Bool_Exp
}

/** aggregate var_pop on columns */
export type Reminder_Var_Pop_Fields = {
  __typename?: "reminder_var_pop_fields"
  alignment?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "reminder" */
export type Reminder_Var_Pop_Order_By = {
  alignment?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Reminder_Var_Samp_Fields = {
  __typename?: "reminder_var_samp_fields"
  alignment?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "reminder" */
export type Reminder_Var_Samp_Order_By = {
  alignment?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Reminder_Variance_Fields = {
  __typename?: "reminder_variance_fields"
  alignment?: Maybe<Scalars["Float"]["output"]>
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "reminder" */
export type Reminder_Variance_Order_By = {
  alignment?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** columns and relationships of "renewal" */
export type Renewal = {
  __typename?: "renewal"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  broker?: Maybe<Scalars["String"]["output"]>
  cancelled?: Maybe<Scalars["Boolean"]["output"]>
  complex_meter_configuration?: Maybe<Scalars["Boolean"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  out_of_sync_tariffs?: Maybe<Scalars["Boolean"]["output"]>
  /** An array relationship */
  renewal_agreements: Array<Agreement>
  /** An aggregate relationship */
  renewal_agreements_aggregate: Agreement_Aggregate
  status?: Maybe<Scalars["String"]["output"]>
  third_party_switch_reference?: Maybe<Scalars["String"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
  uploaded_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** columns and relationships of "renewal" */
export type RenewalRenewal_AgreementsArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Agreement_Order_By>>
  where?: InputMaybe<Agreement_Bool_Exp>
}

/** columns and relationships of "renewal" */
export type RenewalRenewal_Agreements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Agreement_Order_By>>
  where?: InputMaybe<Agreement_Bool_Exp>
}

/** aggregated selection of "renewal" */
export type Renewal_Aggregate = {
  __typename?: "renewal_aggregate"
  aggregate?: Maybe<Renewal_Aggregate_Fields>
  nodes: Array<Renewal>
}

/** aggregate fields of "renewal" */
export type Renewal_Aggregate_Fields = {
  __typename?: "renewal_aggregate_fields"
  avg?: Maybe<Renewal_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Renewal_Max_Fields>
  min?: Maybe<Renewal_Min_Fields>
  stddev?: Maybe<Renewal_Stddev_Fields>
  stddev_pop?: Maybe<Renewal_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Renewal_Stddev_Samp_Fields>
  sum?: Maybe<Renewal_Sum_Fields>
  var_pop?: Maybe<Renewal_Var_Pop_Fields>
  var_samp?: Maybe<Renewal_Var_Samp_Fields>
  variance?: Maybe<Renewal_Variance_Fields>
}

/** aggregate fields of "renewal" */
export type Renewal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Renewal_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Renewal_Avg_Fields = {
  __typename?: "renewal_avg_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "renewal". All fields are combined with a logical 'AND'. */
export type Renewal_Bool_Exp = {
  _and?: InputMaybe<Array<Renewal_Bool_Exp>>
  _not?: InputMaybe<Renewal_Bool_Exp>
  _or?: InputMaybe<Array<Renewal_Bool_Exp>>
  billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  broker?: InputMaybe<String_Comparison_Exp>
  cancelled?: InputMaybe<Boolean_Comparison_Exp>
  complex_meter_configuration?: InputMaybe<Boolean_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  out_of_sync_tariffs?: InputMaybe<Boolean_Comparison_Exp>
  renewal_agreements?: InputMaybe<Agreement_Bool_Exp>
  renewal_agreements_aggregate?: InputMaybe<Agreement_Aggregate_Bool_Exp>
  status?: InputMaybe<String_Comparison_Exp>
  third_party_switch_reference?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  uploaded_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "renewal" */
export enum Renewal_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkRenewal = "pk_renewal",
}

/** input type for incrementing numeric columns in table "renewal" */
export type Renewal_Inc_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "renewal" */
export type Renewal_Insert_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  broker?: InputMaybe<Scalars["String"]["input"]>
  cancelled?: InputMaybe<Scalars["Boolean"]["input"]>
  complex_meter_configuration?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  out_of_sync_tariffs?: InputMaybe<Scalars["Boolean"]["input"]>
  renewal_agreements?: InputMaybe<Agreement_Arr_Rel_Insert_Input>
  status?: InputMaybe<Scalars["String"]["input"]>
  third_party_switch_reference?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  uploaded_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Renewal_Max_Fields = {
  __typename?: "renewal_max_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  broker?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  third_party_switch_reference?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  uploaded_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Renewal_Min_Fields = {
  __typename?: "renewal_min_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  broker?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  third_party_switch_reference?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  uploaded_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "renewal" */
export type Renewal_Mutation_Response = {
  __typename?: "renewal_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Renewal>
}

/** input type for inserting object relation for remote table "renewal" */
export type Renewal_Obj_Rel_Insert_Input = {
  data: Renewal_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Renewal_On_Conflict>
}

/** on_conflict condition type for table "renewal" */
export type Renewal_On_Conflict = {
  constraint: Renewal_Constraint
  update_columns?: Array<Renewal_Update_Column>
  where?: InputMaybe<Renewal_Bool_Exp>
}

/** Ordering options when selecting data from "renewal". */
export type Renewal_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  broker?: InputMaybe<Order_By>
  cancelled?: InputMaybe<Order_By>
  complex_meter_configuration?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  out_of_sync_tariffs?: InputMaybe<Order_By>
  renewal_agreements_aggregate?: InputMaybe<Agreement_Aggregate_Order_By>
  status?: InputMaybe<Order_By>
  third_party_switch_reference?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  uploaded_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: renewal */
export type Renewal_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "renewal" */
export enum Renewal_Select_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  Broker = "broker",
  /** column name */
  Cancelled = "cancelled",
  /** column name */
  ComplexMeterConfiguration = "complex_meter_configuration",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  OutOfSyncTariffs = "out_of_sync_tariffs",
  /** column name */
  Status = "status",
  /** column name */
  ThirdPartySwitchReference = "third_party_switch_reference",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  UploadedAt = "uploaded_at",
}

/** input type for updating data in table "renewal" */
export type Renewal_Set_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  broker?: InputMaybe<Scalars["String"]["input"]>
  cancelled?: InputMaybe<Scalars["Boolean"]["input"]>
  complex_meter_configuration?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  out_of_sync_tariffs?: InputMaybe<Scalars["Boolean"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  third_party_switch_reference?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  uploaded_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Renewal_Stddev_Fields = {
  __typename?: "renewal_stddev_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Renewal_Stddev_Pop_Fields = {
  __typename?: "renewal_stddev_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Renewal_Stddev_Samp_Fields = {
  __typename?: "renewal_stddev_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "renewal" */
export type Renewal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Renewal_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Renewal_Stream_Cursor_Value_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  broker?: InputMaybe<Scalars["String"]["input"]>
  cancelled?: InputMaybe<Scalars["Boolean"]["input"]>
  complex_meter_configuration?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  out_of_sync_tariffs?: InputMaybe<Scalars["Boolean"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  third_party_switch_reference?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  uploaded_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Renewal_Sum_Fields = {
  __typename?: "renewal_sum_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "renewal" */
export enum Renewal_Update_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  Broker = "broker",
  /** column name */
  Cancelled = "cancelled",
  /** column name */
  ComplexMeterConfiguration = "complex_meter_configuration",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  OutOfSyncTariffs = "out_of_sync_tariffs",
  /** column name */
  Status = "status",
  /** column name */
  ThirdPartySwitchReference = "third_party_switch_reference",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  UploadedAt = "uploaded_at",
}

export type Renewal_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Renewal_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Renewal_Set_Input>
  /** filter the rows which have to be updated */
  where: Renewal_Bool_Exp
}

/** aggregate var_pop on columns */
export type Renewal_Var_Pop_Fields = {
  __typename?: "renewal_var_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Renewal_Var_Samp_Fields = {
  __typename?: "renewal_var_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Renewal_Variance_Fields = {
  __typename?: "renewal_variance_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "report_problem" */
export type Report_Problem = {
  __typename?: "report_problem"
  created_at: Scalars["timestamp"]["output"]
  /** An object relationship */
  customer: Customer
  customer_id: Scalars["bigint"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  description: Scalars["String"]["output"]
  id: Scalars["bigint"]["output"]
  /** An array relationship */
  report_problem_attachments: Array<Report_Problem_Attachments>
  /** An aggregate relationship */
  report_problem_attachments_aggregate: Report_Problem_Attachments_Aggregate
  session_details?: Maybe<Scalars["json"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "report_problem" */
export type Report_ProblemReport_Problem_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Report_Problem_Attachments_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Report_Problem_Attachments_Order_By>>
  where?: InputMaybe<Report_Problem_Attachments_Bool_Exp>
}

/** columns and relationships of "report_problem" */
export type Report_ProblemReport_Problem_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Problem_Attachments_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Report_Problem_Attachments_Order_By>>
  where?: InputMaybe<Report_Problem_Attachments_Bool_Exp>
}

/** columns and relationships of "report_problem" */
export type Report_ProblemSession_DetailsArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregated selection of "report_problem" */
export type Report_Problem_Aggregate = {
  __typename?: "report_problem_aggregate"
  aggregate?: Maybe<Report_Problem_Aggregate_Fields>
  nodes: Array<Report_Problem>
}

export type Report_Problem_Aggregate_Bool_Exp = {
  count?: InputMaybe<Report_Problem_Aggregate_Bool_Exp_Count>
}

export type Report_Problem_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Report_Problem_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Report_Problem_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "report_problem" */
export type Report_Problem_Aggregate_Fields = {
  __typename?: "report_problem_aggregate_fields"
  avg?: Maybe<Report_Problem_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Report_Problem_Max_Fields>
  min?: Maybe<Report_Problem_Min_Fields>
  stddev?: Maybe<Report_Problem_Stddev_Fields>
  stddev_pop?: Maybe<Report_Problem_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Report_Problem_Stddev_Samp_Fields>
  sum?: Maybe<Report_Problem_Sum_Fields>
  var_pop?: Maybe<Report_Problem_Var_Pop_Fields>
  var_samp?: Maybe<Report_Problem_Var_Samp_Fields>
  variance?: Maybe<Report_Problem_Variance_Fields>
}

/** aggregate fields of "report_problem" */
export type Report_Problem_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Report_Problem_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "report_problem" */
export type Report_Problem_Aggregate_Order_By = {
  avg?: InputMaybe<Report_Problem_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Report_Problem_Max_Order_By>
  min?: InputMaybe<Report_Problem_Min_Order_By>
  stddev?: InputMaybe<Report_Problem_Stddev_Order_By>
  stddev_pop?: InputMaybe<Report_Problem_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Report_Problem_Stddev_Samp_Order_By>
  sum?: InputMaybe<Report_Problem_Sum_Order_By>
  var_pop?: InputMaybe<Report_Problem_Var_Pop_Order_By>
  var_samp?: InputMaybe<Report_Problem_Var_Samp_Order_By>
  variance?: InputMaybe<Report_Problem_Variance_Order_By>
}

/** input type for inserting array relation for remote table "report_problem" */
export type Report_Problem_Arr_Rel_Insert_Input = {
  data: Array<Report_Problem_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Report_Problem_On_Conflict>
}

/** columns and relationships of "report_problem_attachments" */
export type Report_Problem_Attachments = {
  __typename?: "report_problem_attachments"
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id: Scalars["bigint"]["output"]
  image_content_type: Scalars["String"]["output"]
  image_file_name: Scalars["String"]["output"]
  image_file_size: Scalars["Int"]["output"]
  image_updated_at?: Maybe<Scalars["timestamp"]["output"]>
  /** An object relationship */
  report_problem: Report_Problem
  report_problem_id: Scalars["bigint"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "report_problem_attachments" */
export type Report_Problem_Attachments_Aggregate = {
  __typename?: "report_problem_attachments_aggregate"
  aggregate?: Maybe<Report_Problem_Attachments_Aggregate_Fields>
  nodes: Array<Report_Problem_Attachments>
}

export type Report_Problem_Attachments_Aggregate_Bool_Exp = {
  count?: InputMaybe<Report_Problem_Attachments_Aggregate_Bool_Exp_Count>
}

export type Report_Problem_Attachments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Report_Problem_Attachments_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Report_Problem_Attachments_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "report_problem_attachments" */
export type Report_Problem_Attachments_Aggregate_Fields = {
  __typename?: "report_problem_attachments_aggregate_fields"
  avg?: Maybe<Report_Problem_Attachments_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Report_Problem_Attachments_Max_Fields>
  min?: Maybe<Report_Problem_Attachments_Min_Fields>
  stddev?: Maybe<Report_Problem_Attachments_Stddev_Fields>
  stddev_pop?: Maybe<Report_Problem_Attachments_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Report_Problem_Attachments_Stddev_Samp_Fields>
  sum?: Maybe<Report_Problem_Attachments_Sum_Fields>
  var_pop?: Maybe<Report_Problem_Attachments_Var_Pop_Fields>
  var_samp?: Maybe<Report_Problem_Attachments_Var_Samp_Fields>
  variance?: Maybe<Report_Problem_Attachments_Variance_Fields>
}

/** aggregate fields of "report_problem_attachments" */
export type Report_Problem_Attachments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Report_Problem_Attachments_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "report_problem_attachments" */
export type Report_Problem_Attachments_Aggregate_Order_By = {
  avg?: InputMaybe<Report_Problem_Attachments_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Report_Problem_Attachments_Max_Order_By>
  min?: InputMaybe<Report_Problem_Attachments_Min_Order_By>
  stddev?: InputMaybe<Report_Problem_Attachments_Stddev_Order_By>
  stddev_pop?: InputMaybe<Report_Problem_Attachments_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Report_Problem_Attachments_Stddev_Samp_Order_By>
  sum?: InputMaybe<Report_Problem_Attachments_Sum_Order_By>
  var_pop?: InputMaybe<Report_Problem_Attachments_Var_Pop_Order_By>
  var_samp?: InputMaybe<Report_Problem_Attachments_Var_Samp_Order_By>
  variance?: InputMaybe<Report_Problem_Attachments_Variance_Order_By>
}

/** input type for inserting array relation for remote table "report_problem_attachments" */
export type Report_Problem_Attachments_Arr_Rel_Insert_Input = {
  data: Array<Report_Problem_Attachments_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Report_Problem_Attachments_On_Conflict>
}

/** aggregate avg on columns */
export type Report_Problem_Attachments_Avg_Fields = {
  __typename?: "report_problem_attachments_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  image_file_size?: Maybe<Scalars["Float"]["output"]>
  report_problem_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "report_problem_attachments" */
export type Report_Problem_Attachments_Avg_Order_By = {
  id?: InputMaybe<Order_By>
  image_file_size?: InputMaybe<Order_By>
  report_problem_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "report_problem_attachments". All fields are combined with a logical 'AND'. */
export type Report_Problem_Attachments_Bool_Exp = {
  _and?: InputMaybe<Array<Report_Problem_Attachments_Bool_Exp>>
  _not?: InputMaybe<Report_Problem_Attachments_Bool_Exp>
  _or?: InputMaybe<Array<Report_Problem_Attachments_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  image_content_type?: InputMaybe<String_Comparison_Exp>
  image_file_name?: InputMaybe<String_Comparison_Exp>
  image_file_size?: InputMaybe<Int_Comparison_Exp>
  image_updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  report_problem?: InputMaybe<Report_Problem_Bool_Exp>
  report_problem_id?: InputMaybe<Bigint_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "report_problem_attachments" */
export enum Report_Problem_Attachments_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProblemReportAttachmentsPkey = "problem_report_attachments_pkey",
}

/** input type for incrementing numeric columns in table "report_problem_attachments" */
export type Report_Problem_Attachments_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  image_file_size?: InputMaybe<Scalars["Int"]["input"]>
  report_problem_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "report_problem_attachments" */
export type Report_Problem_Attachments_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  image_content_type?: InputMaybe<Scalars["String"]["input"]>
  image_file_name?: InputMaybe<Scalars["String"]["input"]>
  image_file_size?: InputMaybe<Scalars["Int"]["input"]>
  image_updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  report_problem?: InputMaybe<Report_Problem_Obj_Rel_Insert_Input>
  report_problem_id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Report_Problem_Attachments_Max_Fields = {
  __typename?: "report_problem_attachments_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  image_content_type?: Maybe<Scalars["String"]["output"]>
  image_file_name?: Maybe<Scalars["String"]["output"]>
  image_file_size?: Maybe<Scalars["Int"]["output"]>
  image_updated_at?: Maybe<Scalars["timestamp"]["output"]>
  report_problem_id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "report_problem_attachments" */
export type Report_Problem_Attachments_Max_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  image_content_type?: InputMaybe<Order_By>
  image_file_name?: InputMaybe<Order_By>
  image_file_size?: InputMaybe<Order_By>
  image_updated_at?: InputMaybe<Order_By>
  report_problem_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Report_Problem_Attachments_Min_Fields = {
  __typename?: "report_problem_attachments_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  image_content_type?: Maybe<Scalars["String"]["output"]>
  image_file_name?: Maybe<Scalars["String"]["output"]>
  image_file_size?: Maybe<Scalars["Int"]["output"]>
  image_updated_at?: Maybe<Scalars["timestamp"]["output"]>
  report_problem_id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "report_problem_attachments" */
export type Report_Problem_Attachments_Min_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  image_content_type?: InputMaybe<Order_By>
  image_file_name?: InputMaybe<Order_By>
  image_file_size?: InputMaybe<Order_By>
  image_updated_at?: InputMaybe<Order_By>
  report_problem_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "report_problem_attachments" */
export type Report_Problem_Attachments_Mutation_Response = {
  __typename?: "report_problem_attachments_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Report_Problem_Attachments>
}

/** on_conflict condition type for table "report_problem_attachments" */
export type Report_Problem_Attachments_On_Conflict = {
  constraint: Report_Problem_Attachments_Constraint
  update_columns?: Array<Report_Problem_Attachments_Update_Column>
  where?: InputMaybe<Report_Problem_Attachments_Bool_Exp>
}

/** Ordering options when selecting data from "report_problem_attachments". */
export type Report_Problem_Attachments_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  image_content_type?: InputMaybe<Order_By>
  image_file_name?: InputMaybe<Order_By>
  image_file_size?: InputMaybe<Order_By>
  image_updated_at?: InputMaybe<Order_By>
  report_problem?: InputMaybe<Report_Problem_Order_By>
  report_problem_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: report_problem_attachments */
export type Report_Problem_Attachments_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "report_problem_attachments" */
export enum Report_Problem_Attachments_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  ImageContentType = "image_content_type",
  /** column name */
  ImageFileName = "image_file_name",
  /** column name */
  ImageFileSize = "image_file_size",
  /** column name */
  ImageUpdatedAt = "image_updated_at",
  /** column name */
  ReportProblemId = "report_problem_id",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "report_problem_attachments" */
export type Report_Problem_Attachments_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  image_content_type?: InputMaybe<Scalars["String"]["input"]>
  image_file_name?: InputMaybe<Scalars["String"]["input"]>
  image_file_size?: InputMaybe<Scalars["Int"]["input"]>
  image_updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  report_problem_id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Report_Problem_Attachments_Stddev_Fields = {
  __typename?: "report_problem_attachments_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  image_file_size?: Maybe<Scalars["Float"]["output"]>
  report_problem_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "report_problem_attachments" */
export type Report_Problem_Attachments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>
  image_file_size?: InputMaybe<Order_By>
  report_problem_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Report_Problem_Attachments_Stddev_Pop_Fields = {
  __typename?: "report_problem_attachments_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  image_file_size?: Maybe<Scalars["Float"]["output"]>
  report_problem_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "report_problem_attachments" */
export type Report_Problem_Attachments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>
  image_file_size?: InputMaybe<Order_By>
  report_problem_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Report_Problem_Attachments_Stddev_Samp_Fields = {
  __typename?: "report_problem_attachments_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  image_file_size?: Maybe<Scalars["Float"]["output"]>
  report_problem_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "report_problem_attachments" */
export type Report_Problem_Attachments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>
  image_file_size?: InputMaybe<Order_By>
  report_problem_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "report_problem_attachments" */
export type Report_Problem_Attachments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Report_Problem_Attachments_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Report_Problem_Attachments_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  image_content_type?: InputMaybe<Scalars["String"]["input"]>
  image_file_name?: InputMaybe<Scalars["String"]["input"]>
  image_file_size?: InputMaybe<Scalars["Int"]["input"]>
  image_updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  report_problem_id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Report_Problem_Attachments_Sum_Fields = {
  __typename?: "report_problem_attachments_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  image_file_size?: Maybe<Scalars["Int"]["output"]>
  report_problem_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "report_problem_attachments" */
export type Report_Problem_Attachments_Sum_Order_By = {
  id?: InputMaybe<Order_By>
  image_file_size?: InputMaybe<Order_By>
  report_problem_id?: InputMaybe<Order_By>
}

/** update columns of table "report_problem_attachments" */
export enum Report_Problem_Attachments_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  ImageContentType = "image_content_type",
  /** column name */
  ImageFileName = "image_file_name",
  /** column name */
  ImageFileSize = "image_file_size",
  /** column name */
  ImageUpdatedAt = "image_updated_at",
  /** column name */
  ReportProblemId = "report_problem_id",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Report_Problem_Attachments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Report_Problem_Attachments_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Report_Problem_Attachments_Set_Input>
  /** filter the rows which have to be updated */
  where: Report_Problem_Attachments_Bool_Exp
}

/** aggregate var_pop on columns */
export type Report_Problem_Attachments_Var_Pop_Fields = {
  __typename?: "report_problem_attachments_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  image_file_size?: Maybe<Scalars["Float"]["output"]>
  report_problem_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "report_problem_attachments" */
export type Report_Problem_Attachments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>
  image_file_size?: InputMaybe<Order_By>
  report_problem_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Report_Problem_Attachments_Var_Samp_Fields = {
  __typename?: "report_problem_attachments_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  image_file_size?: Maybe<Scalars["Float"]["output"]>
  report_problem_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "report_problem_attachments" */
export type Report_Problem_Attachments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>
  image_file_size?: InputMaybe<Order_By>
  report_problem_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Report_Problem_Attachments_Variance_Fields = {
  __typename?: "report_problem_attachments_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  image_file_size?: Maybe<Scalars["Float"]["output"]>
  report_problem_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "report_problem_attachments" */
export type Report_Problem_Attachments_Variance_Order_By = {
  id?: InputMaybe<Order_By>
  image_file_size?: InputMaybe<Order_By>
  report_problem_id?: InputMaybe<Order_By>
}

/** aggregate avg on columns */
export type Report_Problem_Avg_Fields = {
  __typename?: "report_problem_avg_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "report_problem" */
export type Report_Problem_Avg_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "report_problem". All fields are combined with a logical 'AND'. */
export type Report_Problem_Bool_Exp = {
  _and?: InputMaybe<Array<Report_Problem_Bool_Exp>>
  _not?: InputMaybe<Report_Problem_Bool_Exp>
  _or?: InputMaybe<Array<Report_Problem_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  customer?: InputMaybe<Customer_Bool_Exp>
  customer_id?: InputMaybe<Bigint_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  description?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  report_problem_attachments?: InputMaybe<Report_Problem_Attachments_Bool_Exp>
  report_problem_attachments_aggregate?: InputMaybe<Report_Problem_Attachments_Aggregate_Bool_Exp>
  session_details?: InputMaybe<Json_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "report_problem" */
export enum Report_Problem_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProblemReportsPkey = "problem_reports_pkey",
}

/** input type for incrementing numeric columns in table "report_problem" */
export type Report_Problem_Inc_Input = {
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "report_problem" */
export type Report_Problem_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer?: InputMaybe<Customer_Obj_Rel_Insert_Input>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  report_problem_attachments?: InputMaybe<Report_Problem_Attachments_Arr_Rel_Insert_Input>
  session_details?: InputMaybe<Scalars["json"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Report_Problem_Max_Fields = {
  __typename?: "report_problem_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "report_problem" */
export type Report_Problem_Max_Order_By = {
  created_at?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  description?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Report_Problem_Min_Fields = {
  __typename?: "report_problem_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "report_problem" */
export type Report_Problem_Min_Order_By = {
  created_at?: InputMaybe<Order_By>
  customer_id?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  description?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "report_problem" */
export type Report_Problem_Mutation_Response = {
  __typename?: "report_problem_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Report_Problem>
}

/** input type for inserting object relation for remote table "report_problem" */
export type Report_Problem_Obj_Rel_Insert_Input = {
  data: Report_Problem_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Report_Problem_On_Conflict>
}

/** on_conflict condition type for table "report_problem" */
export type Report_Problem_On_Conflict = {
  constraint: Report_Problem_Constraint
  update_columns?: Array<Report_Problem_Update_Column>
  where?: InputMaybe<Report_Problem_Bool_Exp>
}

/** Ordering options when selecting data from "report_problem". */
export type Report_Problem_Order_By = {
  created_at?: InputMaybe<Order_By>
  customer?: InputMaybe<Customer_Order_By>
  customer_id?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  description?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  report_problem_attachments_aggregate?: InputMaybe<Report_Problem_Attachments_Aggregate_Order_By>
  session_details?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: report_problem */
export type Report_Problem_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "report_problem" */
export enum Report_Problem_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Description = "description",
  /** column name */
  Id = "id",
  /** column name */
  SessionDetails = "session_details",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "report_problem" */
export type Report_Problem_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  session_details?: InputMaybe<Scalars["json"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Report_Problem_Stddev_Fields = {
  __typename?: "report_problem_stddev_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "report_problem" */
export type Report_Problem_Stddev_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Report_Problem_Stddev_Pop_Fields = {
  __typename?: "report_problem_stddev_pop_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "report_problem" */
export type Report_Problem_Stddev_Pop_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Report_Problem_Stddev_Samp_Fields = {
  __typename?: "report_problem_stddev_samp_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "report_problem" */
export type Report_Problem_Stddev_Samp_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "report_problem" */
export type Report_Problem_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Report_Problem_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Report_Problem_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  session_details?: InputMaybe<Scalars["json"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Report_Problem_Sum_Fields = {
  __typename?: "report_problem_sum_fields"
  customer_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "report_problem" */
export type Report_Problem_Sum_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** update columns of table "report_problem" */
export enum Report_Problem_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CustomerId = "customer_id",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Description = "description",
  /** column name */
  Id = "id",
  /** column name */
  SessionDetails = "session_details",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Report_Problem_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Report_Problem_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Report_Problem_Set_Input>
  /** filter the rows which have to be updated */
  where: Report_Problem_Bool_Exp
}

/** aggregate var_pop on columns */
export type Report_Problem_Var_Pop_Fields = {
  __typename?: "report_problem_var_pop_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "report_problem" */
export type Report_Problem_Var_Pop_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Report_Problem_Var_Samp_Fields = {
  __typename?: "report_problem_var_samp_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "report_problem" */
export type Report_Problem_Var_Samp_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Report_Problem_Variance_Fields = {
  __typename?: "report_problem_variance_fields"
  customer_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "report_problem" */
export type Report_Problem_Variance_Order_By = {
  customer_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** columns and relationships of "requests" */
export type Requests = {
  __typename?: "requests"
  communication_id?: Maybe<Scalars["bigint"]["output"]>
  communication_name: Scalars["String"]["output"]
  created_at: Scalars["timestamptz"]["output"]
  id: Scalars["bigint"]["output"]
}

/** aggregated selection of "requests" */
export type Requests_Aggregate = {
  __typename?: "requests_aggregate"
  aggregate?: Maybe<Requests_Aggregate_Fields>
  nodes: Array<Requests>
}

/** aggregate fields of "requests" */
export type Requests_Aggregate_Fields = {
  __typename?: "requests_aggregate_fields"
  avg?: Maybe<Requests_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Requests_Max_Fields>
  min?: Maybe<Requests_Min_Fields>
  stddev?: Maybe<Requests_Stddev_Fields>
  stddev_pop?: Maybe<Requests_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Requests_Stddev_Samp_Fields>
  sum?: Maybe<Requests_Sum_Fields>
  var_pop?: Maybe<Requests_Var_Pop_Fields>
  var_samp?: Maybe<Requests_Var_Samp_Fields>
  variance?: Maybe<Requests_Variance_Fields>
}

/** aggregate fields of "requests" */
export type Requests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Requests_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Requests_Avg_Fields = {
  __typename?: "requests_avg_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "requests". All fields are combined with a logical 'AND'. */
export type Requests_Bool_Exp = {
  _and?: InputMaybe<Array<Requests_Bool_Exp>>
  _not?: InputMaybe<Requests_Bool_Exp>
  _or?: InputMaybe<Array<Requests_Bool_Exp>>
  communication_id?: InputMaybe<Bigint_Comparison_Exp>
  communication_name?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
}

/** unique or primary key constraints on table "requests" */
export enum Requests_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkRequests = "pk_requests",
}

/** input type for incrementing numeric columns in table "requests" */
export type Requests_Inc_Input = {
  communication_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "requests" */
export type Requests_Insert_Input = {
  communication_id?: InputMaybe<Scalars["bigint"]["input"]>
  communication_name?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate max on columns */
export type Requests_Max_Fields = {
  __typename?: "requests_max_fields"
  communication_id?: Maybe<Scalars["bigint"]["output"]>
  communication_name?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregate min on columns */
export type Requests_Min_Fields = {
  __typename?: "requests_min_fields"
  communication_id?: Maybe<Scalars["bigint"]["output"]>
  communication_name?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** response of any mutation on the table "requests" */
export type Requests_Mutation_Response = {
  __typename?: "requests_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Requests>
}

/** input type for inserting object relation for remote table "requests" */
export type Requests_Obj_Rel_Insert_Input = {
  data: Requests_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Requests_On_Conflict>
}

/** on_conflict condition type for table "requests" */
export type Requests_On_Conflict = {
  constraint: Requests_Constraint
  update_columns?: Array<Requests_Update_Column>
  where?: InputMaybe<Requests_Bool_Exp>
}

/** Ordering options when selecting data from "requests". */
export type Requests_Order_By = {
  communication_id?: InputMaybe<Order_By>
  communication_name?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** primary key columns input for table: requests */
export type Requests_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "requests" */
export enum Requests_Select_Column {
  /** column name */
  CommunicationId = "communication_id",
  /** column name */
  CommunicationName = "communication_name",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
}

/** input type for updating data in table "requests" */
export type Requests_Set_Input = {
  communication_id?: InputMaybe<Scalars["bigint"]["input"]>
  communication_name?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate stddev on columns */
export type Requests_Stddev_Fields = {
  __typename?: "requests_stddev_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Requests_Stddev_Pop_Fields = {
  __typename?: "requests_stddev_pop_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Requests_Stddev_Samp_Fields = {
  __typename?: "requests_stddev_samp_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "requests" */
export type Requests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Requests_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Requests_Stream_Cursor_Value_Input = {
  communication_id?: InputMaybe<Scalars["bigint"]["input"]>
  communication_name?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate sum on columns */
export type Requests_Sum_Fields = {
  __typename?: "requests_sum_fields"
  communication_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "requests" */
export enum Requests_Update_Column {
  /** column name */
  CommunicationId = "communication_id",
  /** column name */
  CommunicationName = "communication_name",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
}

export type Requests_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Requests_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Requests_Set_Input>
  /** filter the rows which have to be updated */
  where: Requests_Bool_Exp
}

/** aggregate var_pop on columns */
export type Requests_Var_Pop_Fields = {
  __typename?: "requests_var_pop_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Requests_Var_Samp_Fields = {
  __typename?: "requests_var_samp_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Requests_Variance_Fields = {
  __typename?: "requests_variance_fields"
  communication_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "rts_meters_report" */
export type Rts_Meters_Report = {
  __typename?: "rts_meters_report"
  account_number: Scalars["bigint"]["output"]
  created_at: Scalars["timestamp"]["output"]
  gsp_code?: Maybe<Scalars["String"]["output"]>
  gsp_name?: Maybe<Scalars["String"]["output"]>
  meter_register?: Maybe<Scalars["String"]["output"]>
  meter_type?: Maybe<Scalars["String"]["output"]>
  meter_type_category?: Maybe<Scalars["String"]["output"]>
  mpxn: Scalars["bigint"]["output"]
  msn: Scalars["String"]["output"]
  product_bundle_name?: Maybe<Scalars["String"]["output"]>
  rate_name?: Maybe<Scalars["String"]["output"]>
  ssd_end_date?: Maybe<Scalars["date"]["output"]>
  ssd_start_of_meterpoint?: Maybe<Scalars["date"]["output"]>
  supply_address?: Maybe<Scalars["String"]["output"]>
  supply_postcode?: Maybe<Scalars["String"]["output"]>
  tpr?: Maybe<Scalars["String"]["output"]>
}

/** aggregated selection of "rts_meters_report" */
export type Rts_Meters_Report_Aggregate = {
  __typename?: "rts_meters_report_aggregate"
  aggregate?: Maybe<Rts_Meters_Report_Aggregate_Fields>
  nodes: Array<Rts_Meters_Report>
}

/** aggregate fields of "rts_meters_report" */
export type Rts_Meters_Report_Aggregate_Fields = {
  __typename?: "rts_meters_report_aggregate_fields"
  avg?: Maybe<Rts_Meters_Report_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Rts_Meters_Report_Max_Fields>
  min?: Maybe<Rts_Meters_Report_Min_Fields>
  stddev?: Maybe<Rts_Meters_Report_Stddev_Fields>
  stddev_pop?: Maybe<Rts_Meters_Report_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Rts_Meters_Report_Stddev_Samp_Fields>
  sum?: Maybe<Rts_Meters_Report_Sum_Fields>
  var_pop?: Maybe<Rts_Meters_Report_Var_Pop_Fields>
  var_samp?: Maybe<Rts_Meters_Report_Var_Samp_Fields>
  variance?: Maybe<Rts_Meters_Report_Variance_Fields>
}

/** aggregate fields of "rts_meters_report" */
export type Rts_Meters_Report_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rts_Meters_Report_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Rts_Meters_Report_Avg_Fields = {
  __typename?: "rts_meters_report_avg_fields"
  account_number?: Maybe<Scalars["Float"]["output"]>
  mpxn?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "rts_meters_report". All fields are combined with a logical 'AND'. */
export type Rts_Meters_Report_Bool_Exp = {
  _and?: InputMaybe<Array<Rts_Meters_Report_Bool_Exp>>
  _not?: InputMaybe<Rts_Meters_Report_Bool_Exp>
  _or?: InputMaybe<Array<Rts_Meters_Report_Bool_Exp>>
  account_number?: InputMaybe<Bigint_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  gsp_code?: InputMaybe<String_Comparison_Exp>
  gsp_name?: InputMaybe<String_Comparison_Exp>
  meter_register?: InputMaybe<String_Comparison_Exp>
  meter_type?: InputMaybe<String_Comparison_Exp>
  meter_type_category?: InputMaybe<String_Comparison_Exp>
  mpxn?: InputMaybe<Bigint_Comparison_Exp>
  msn?: InputMaybe<String_Comparison_Exp>
  product_bundle_name?: InputMaybe<String_Comparison_Exp>
  rate_name?: InputMaybe<String_Comparison_Exp>
  ssd_end_date?: InputMaybe<Date_Comparison_Exp>
  ssd_start_of_meterpoint?: InputMaybe<Date_Comparison_Exp>
  supply_address?: InputMaybe<String_Comparison_Exp>
  supply_postcode?: InputMaybe<String_Comparison_Exp>
  tpr?: InputMaybe<String_Comparison_Exp>
}

/** input type for incrementing numeric columns in table "rts_meters_report" */
export type Rts_Meters_Report_Inc_Input = {
  account_number?: InputMaybe<Scalars["bigint"]["input"]>
  mpxn?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "rts_meters_report" */
export type Rts_Meters_Report_Insert_Input = {
  account_number?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  gsp_code?: InputMaybe<Scalars["String"]["input"]>
  gsp_name?: InputMaybe<Scalars["String"]["input"]>
  meter_register?: InputMaybe<Scalars["String"]["input"]>
  meter_type?: InputMaybe<Scalars["String"]["input"]>
  meter_type_category?: InputMaybe<Scalars["String"]["input"]>
  mpxn?: InputMaybe<Scalars["bigint"]["input"]>
  msn?: InputMaybe<Scalars["String"]["input"]>
  product_bundle_name?: InputMaybe<Scalars["String"]["input"]>
  rate_name?: InputMaybe<Scalars["String"]["input"]>
  ssd_end_date?: InputMaybe<Scalars["date"]["input"]>
  ssd_start_of_meterpoint?: InputMaybe<Scalars["date"]["input"]>
  supply_address?: InputMaybe<Scalars["String"]["input"]>
  supply_postcode?: InputMaybe<Scalars["String"]["input"]>
  tpr?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Rts_Meters_Report_Max_Fields = {
  __typename?: "rts_meters_report_max_fields"
  account_number?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  gsp_code?: Maybe<Scalars["String"]["output"]>
  gsp_name?: Maybe<Scalars["String"]["output"]>
  meter_register?: Maybe<Scalars["String"]["output"]>
  meter_type?: Maybe<Scalars["String"]["output"]>
  meter_type_category?: Maybe<Scalars["String"]["output"]>
  mpxn?: Maybe<Scalars["bigint"]["output"]>
  msn?: Maybe<Scalars["String"]["output"]>
  product_bundle_name?: Maybe<Scalars["String"]["output"]>
  rate_name?: Maybe<Scalars["String"]["output"]>
  ssd_end_date?: Maybe<Scalars["date"]["output"]>
  ssd_start_of_meterpoint?: Maybe<Scalars["date"]["output"]>
  supply_address?: Maybe<Scalars["String"]["output"]>
  supply_postcode?: Maybe<Scalars["String"]["output"]>
  tpr?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Rts_Meters_Report_Min_Fields = {
  __typename?: "rts_meters_report_min_fields"
  account_number?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  gsp_code?: Maybe<Scalars["String"]["output"]>
  gsp_name?: Maybe<Scalars["String"]["output"]>
  meter_register?: Maybe<Scalars["String"]["output"]>
  meter_type?: Maybe<Scalars["String"]["output"]>
  meter_type_category?: Maybe<Scalars["String"]["output"]>
  mpxn?: Maybe<Scalars["bigint"]["output"]>
  msn?: Maybe<Scalars["String"]["output"]>
  product_bundle_name?: Maybe<Scalars["String"]["output"]>
  rate_name?: Maybe<Scalars["String"]["output"]>
  ssd_end_date?: Maybe<Scalars["date"]["output"]>
  ssd_start_of_meterpoint?: Maybe<Scalars["date"]["output"]>
  supply_address?: Maybe<Scalars["String"]["output"]>
  supply_postcode?: Maybe<Scalars["String"]["output"]>
  tpr?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "rts_meters_report" */
export type Rts_Meters_Report_Mutation_Response = {
  __typename?: "rts_meters_report_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Rts_Meters_Report>
}

/** Ordering options when selecting data from "rts_meters_report". */
export type Rts_Meters_Report_Order_By = {
  account_number?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  gsp_code?: InputMaybe<Order_By>
  gsp_name?: InputMaybe<Order_By>
  meter_register?: InputMaybe<Order_By>
  meter_type?: InputMaybe<Order_By>
  meter_type_category?: InputMaybe<Order_By>
  mpxn?: InputMaybe<Order_By>
  msn?: InputMaybe<Order_By>
  product_bundle_name?: InputMaybe<Order_By>
  rate_name?: InputMaybe<Order_By>
  ssd_end_date?: InputMaybe<Order_By>
  ssd_start_of_meterpoint?: InputMaybe<Order_By>
  supply_address?: InputMaybe<Order_By>
  supply_postcode?: InputMaybe<Order_By>
  tpr?: InputMaybe<Order_By>
}

/** select columns of table "rts_meters_report" */
export enum Rts_Meters_Report_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  GspCode = "gsp_code",
  /** column name */
  GspName = "gsp_name",
  /** column name */
  MeterRegister = "meter_register",
  /** column name */
  MeterType = "meter_type",
  /** column name */
  MeterTypeCategory = "meter_type_category",
  /** column name */
  Mpxn = "mpxn",
  /** column name */
  Msn = "msn",
  /** column name */
  ProductBundleName = "product_bundle_name",
  /** column name */
  RateName = "rate_name",
  /** column name */
  SsdEndDate = "ssd_end_date",
  /** column name */
  SsdStartOfMeterpoint = "ssd_start_of_meterpoint",
  /** column name */
  SupplyAddress = "supply_address",
  /** column name */
  SupplyPostcode = "supply_postcode",
  /** column name */
  Tpr = "tpr",
}

/** input type for updating data in table "rts_meters_report" */
export type Rts_Meters_Report_Set_Input = {
  account_number?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  gsp_code?: InputMaybe<Scalars["String"]["input"]>
  gsp_name?: InputMaybe<Scalars["String"]["input"]>
  meter_register?: InputMaybe<Scalars["String"]["input"]>
  meter_type?: InputMaybe<Scalars["String"]["input"]>
  meter_type_category?: InputMaybe<Scalars["String"]["input"]>
  mpxn?: InputMaybe<Scalars["bigint"]["input"]>
  msn?: InputMaybe<Scalars["String"]["input"]>
  product_bundle_name?: InputMaybe<Scalars["String"]["input"]>
  rate_name?: InputMaybe<Scalars["String"]["input"]>
  ssd_end_date?: InputMaybe<Scalars["date"]["input"]>
  ssd_start_of_meterpoint?: InputMaybe<Scalars["date"]["input"]>
  supply_address?: InputMaybe<Scalars["String"]["input"]>
  supply_postcode?: InputMaybe<Scalars["String"]["input"]>
  tpr?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Rts_Meters_Report_Stddev_Fields = {
  __typename?: "rts_meters_report_stddev_fields"
  account_number?: Maybe<Scalars["Float"]["output"]>
  mpxn?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Rts_Meters_Report_Stddev_Pop_Fields = {
  __typename?: "rts_meters_report_stddev_pop_fields"
  account_number?: Maybe<Scalars["Float"]["output"]>
  mpxn?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Rts_Meters_Report_Stddev_Samp_Fields = {
  __typename?: "rts_meters_report_stddev_samp_fields"
  account_number?: Maybe<Scalars["Float"]["output"]>
  mpxn?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "rts_meters_report" */
export type Rts_Meters_Report_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rts_Meters_Report_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Rts_Meters_Report_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  gsp_code?: InputMaybe<Scalars["String"]["input"]>
  gsp_name?: InputMaybe<Scalars["String"]["input"]>
  meter_register?: InputMaybe<Scalars["String"]["input"]>
  meter_type?: InputMaybe<Scalars["String"]["input"]>
  meter_type_category?: InputMaybe<Scalars["String"]["input"]>
  mpxn?: InputMaybe<Scalars["bigint"]["input"]>
  msn?: InputMaybe<Scalars["String"]["input"]>
  product_bundle_name?: InputMaybe<Scalars["String"]["input"]>
  rate_name?: InputMaybe<Scalars["String"]["input"]>
  ssd_end_date?: InputMaybe<Scalars["date"]["input"]>
  ssd_start_of_meterpoint?: InputMaybe<Scalars["date"]["input"]>
  supply_address?: InputMaybe<Scalars["String"]["input"]>
  supply_postcode?: InputMaybe<Scalars["String"]["input"]>
  tpr?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Rts_Meters_Report_Sum_Fields = {
  __typename?: "rts_meters_report_sum_fields"
  account_number?: Maybe<Scalars["bigint"]["output"]>
  mpxn?: Maybe<Scalars["bigint"]["output"]>
}

export type Rts_Meters_Report_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Rts_Meters_Report_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rts_Meters_Report_Set_Input>
  /** filter the rows which have to be updated */
  where: Rts_Meters_Report_Bool_Exp
}

/** aggregate var_pop on columns */
export type Rts_Meters_Report_Var_Pop_Fields = {
  __typename?: "rts_meters_report_var_pop_fields"
  account_number?: Maybe<Scalars["Float"]["output"]>
  mpxn?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Rts_Meters_Report_Var_Samp_Fields = {
  __typename?: "rts_meters_report_var_samp_fields"
  account_number?: Maybe<Scalars["Float"]["output"]>
  mpxn?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Rts_Meters_Report_Variance_Fields = {
  __typename?: "rts_meters_report_variance_fields"
  account_number?: Maybe<Scalars["Float"]["output"]>
  mpxn?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "scheduled_payment" */
export type Scheduled_Payment = {
  __typename?: "scheduled_payment"
  amount?: Maybe<Scalars["numeric"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  due_dt?: Maybe<Scalars["date"]["output"]>
  id: Scalars["bigint"]["output"]
  payment_id?: Maybe<Scalars["bigint"]["output"]>
  payment_schedule_id: Scalars["bigint"]["output"]
  reference?: Maybe<Scalars["String"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "scheduled_payment" */
export type Scheduled_Payment_Aggregate = {
  __typename?: "scheduled_payment_aggregate"
  aggregate?: Maybe<Scheduled_Payment_Aggregate_Fields>
  nodes: Array<Scheduled_Payment>
}

/** aggregate fields of "scheduled_payment" */
export type Scheduled_Payment_Aggregate_Fields = {
  __typename?: "scheduled_payment_aggregate_fields"
  avg?: Maybe<Scheduled_Payment_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Scheduled_Payment_Max_Fields>
  min?: Maybe<Scheduled_Payment_Min_Fields>
  stddev?: Maybe<Scheduled_Payment_Stddev_Fields>
  stddev_pop?: Maybe<Scheduled_Payment_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Scheduled_Payment_Stddev_Samp_Fields>
  sum?: Maybe<Scheduled_Payment_Sum_Fields>
  var_pop?: Maybe<Scheduled_Payment_Var_Pop_Fields>
  var_samp?: Maybe<Scheduled_Payment_Var_Samp_Fields>
  variance?: Maybe<Scheduled_Payment_Variance_Fields>
}

/** aggregate fields of "scheduled_payment" */
export type Scheduled_Payment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scheduled_Payment_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Scheduled_Payment_Avg_Fields = {
  __typename?: "scheduled_payment_avg_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_id?: Maybe<Scalars["Float"]["output"]>
  payment_schedule_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "scheduled_payment". All fields are combined with a logical 'AND'. */
export type Scheduled_Payment_Bool_Exp = {
  _and?: InputMaybe<Array<Scheduled_Payment_Bool_Exp>>
  _not?: InputMaybe<Scheduled_Payment_Bool_Exp>
  _or?: InputMaybe<Array<Scheduled_Payment_Bool_Exp>>
  amount?: InputMaybe<Numeric_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  due_dt?: InputMaybe<Date_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  payment_id?: InputMaybe<Bigint_Comparison_Exp>
  payment_schedule_id?: InputMaybe<Bigint_Comparison_Exp>
  reference?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "scheduled_payment" */
export enum Scheduled_Payment_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScheduledPaymentPkey = "scheduled_payment_pkey",
}

/** input type for incrementing numeric columns in table "scheduled_payment" */
export type Scheduled_Payment_Inc_Input = {
  amount?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_schedule_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "scheduled_payment" */
export type Scheduled_Payment_Insert_Input = {
  amount?: InputMaybe<Scalars["numeric"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  due_dt?: InputMaybe<Scalars["date"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_schedule_id?: InputMaybe<Scalars["bigint"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Scheduled_Payment_Max_Fields = {
  __typename?: "scheduled_payment_max_fields"
  amount?: Maybe<Scalars["numeric"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  due_dt?: Maybe<Scalars["date"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  payment_id?: Maybe<Scalars["bigint"]["output"]>
  payment_schedule_id?: Maybe<Scalars["bigint"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Scheduled_Payment_Min_Fields = {
  __typename?: "scheduled_payment_min_fields"
  amount?: Maybe<Scalars["numeric"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  due_dt?: Maybe<Scalars["date"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  payment_id?: Maybe<Scalars["bigint"]["output"]>
  payment_schedule_id?: Maybe<Scalars["bigint"]["output"]>
  reference?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "scheduled_payment" */
export type Scheduled_Payment_Mutation_Response = {
  __typename?: "scheduled_payment_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Scheduled_Payment>
}

/** on_conflict condition type for table "scheduled_payment" */
export type Scheduled_Payment_On_Conflict = {
  constraint: Scheduled_Payment_Constraint
  update_columns?: Array<Scheduled_Payment_Update_Column>
  where?: InputMaybe<Scheduled_Payment_Bool_Exp>
}

/** Ordering options when selecting data from "scheduled_payment". */
export type Scheduled_Payment_Order_By = {
  amount?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  due_dt?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  payment_id?: InputMaybe<Order_By>
  payment_schedule_id?: InputMaybe<Order_By>
  reference?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: scheduled_payment */
export type Scheduled_Payment_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "scheduled_payment" */
export enum Scheduled_Payment_Select_Column {
  /** column name */
  Amount = "amount",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  DueDt = "due_dt",
  /** column name */
  Id = "id",
  /** column name */
  PaymentId = "payment_id",
  /** column name */
  PaymentScheduleId = "payment_schedule_id",
  /** column name */
  Reference = "reference",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "scheduled_payment" */
export type Scheduled_Payment_Set_Input = {
  amount?: InputMaybe<Scalars["numeric"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  due_dt?: InputMaybe<Scalars["date"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_schedule_id?: InputMaybe<Scalars["bigint"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Scheduled_Payment_Stddev_Fields = {
  __typename?: "scheduled_payment_stddev_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_id?: Maybe<Scalars["Float"]["output"]>
  payment_schedule_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Scheduled_Payment_Stddev_Pop_Fields = {
  __typename?: "scheduled_payment_stddev_pop_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_id?: Maybe<Scalars["Float"]["output"]>
  payment_schedule_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Scheduled_Payment_Stddev_Samp_Fields = {
  __typename?: "scheduled_payment_stddev_samp_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_id?: Maybe<Scalars["Float"]["output"]>
  payment_schedule_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "scheduled_payment" */
export type Scheduled_Payment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scheduled_Payment_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Scheduled_Payment_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars["numeric"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  due_dt?: InputMaybe<Scalars["date"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_schedule_id?: InputMaybe<Scalars["bigint"]["input"]>
  reference?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Scheduled_Payment_Sum_Fields = {
  __typename?: "scheduled_payment_sum_fields"
  amount?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  payment_id?: Maybe<Scalars["bigint"]["output"]>
  payment_schedule_id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "scheduled_payment" */
export enum Scheduled_Payment_Update_Column {
  /** column name */
  Amount = "amount",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  DueDt = "due_dt",
  /** column name */
  Id = "id",
  /** column name */
  PaymentId = "payment_id",
  /** column name */
  PaymentScheduleId = "payment_schedule_id",
  /** column name */
  Reference = "reference",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Scheduled_Payment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Scheduled_Payment_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Scheduled_Payment_Set_Input>
  /** filter the rows which have to be updated */
  where: Scheduled_Payment_Bool_Exp
}

/** aggregate var_pop on columns */
export type Scheduled_Payment_Var_Pop_Fields = {
  __typename?: "scheduled_payment_var_pop_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_id?: Maybe<Scalars["Float"]["output"]>
  payment_schedule_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Scheduled_Payment_Var_Samp_Fields = {
  __typename?: "scheduled_payment_var_samp_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_id?: Maybe<Scalars["Float"]["output"]>
  payment_schedule_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Scheduled_Payment_Variance_Fields = {
  __typename?: "scheduled_payment_variance_fields"
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  payment_id?: Maybe<Scalars["Float"]["output"]>
  payment_schedule_id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "scheduled_refund" */
export type Scheduled_Refund = {
  __typename?: "scheduled_refund"
  billing_account_id: Scalars["bigint"]["output"]
  created_at: Scalars["timestamp"]["output"]
  current_payment_amount_in_pence?: Maybe<Scalars["numeric"]["output"]>
  customer_first_name?: Maybe<Scalars["String"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  follow_up_review?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["bigint"]["output"]
  junifer_account_id?: Maybe<Scalars["bigint"]["output"]>
  junifer_account_number?: Maybe<Scalars["String"]["output"]>
  notification_to_user_sent_at?: Maybe<Scalars["timestamp"]["output"]>
  payment_date: Scalars["timestamp"]["output"]
  payment_id?: Maybe<Scalars["bigint"]["output"]>
  refund_amount_in_pence: Scalars["numeric"]["output"]
  seasonal: Scalars["Boolean"]["output"]
  status: Scalars["refund_status"]["output"]
  suggested_payment_amount_in_pence?: Maybe<Scalars["numeric"]["output"]>
  suggested_summer_payment_amount_in_pence?: Maybe<Scalars["numeric"]["output"]>
  suggested_winter_payment_amount_in_pence?: Maybe<Scalars["numeric"]["output"]>
  type: Scalars["refund_type"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "scheduled_refund" */
export type Scheduled_Refund_Aggregate = {
  __typename?: "scheduled_refund_aggregate"
  aggregate?: Maybe<Scheduled_Refund_Aggregate_Fields>
  nodes: Array<Scheduled_Refund>
}

/** aggregate fields of "scheduled_refund" */
export type Scheduled_Refund_Aggregate_Fields = {
  __typename?: "scheduled_refund_aggregate_fields"
  avg?: Maybe<Scheduled_Refund_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Scheduled_Refund_Max_Fields>
  min?: Maybe<Scheduled_Refund_Min_Fields>
  stddev?: Maybe<Scheduled_Refund_Stddev_Fields>
  stddev_pop?: Maybe<Scheduled_Refund_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Scheduled_Refund_Stddev_Samp_Fields>
  sum?: Maybe<Scheduled_Refund_Sum_Fields>
  var_pop?: Maybe<Scheduled_Refund_Var_Pop_Fields>
  var_samp?: Maybe<Scheduled_Refund_Var_Samp_Fields>
  variance?: Maybe<Scheduled_Refund_Variance_Fields>
}

/** aggregate fields of "scheduled_refund" */
export type Scheduled_Refund_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scheduled_Refund_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Scheduled_Refund_Avg_Fields = {
  __typename?: "scheduled_refund_avg_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  current_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  payment_id?: Maybe<Scalars["Float"]["output"]>
  refund_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_summer_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_winter_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "scheduled_refund". All fields are combined with a logical 'AND'. */
export type Scheduled_Refund_Bool_Exp = {
  _and?: InputMaybe<Array<Scheduled_Refund_Bool_Exp>>
  _not?: InputMaybe<Scheduled_Refund_Bool_Exp>
  _or?: InputMaybe<Array<Scheduled_Refund_Bool_Exp>>
  billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  current_payment_amount_in_pence?: InputMaybe<Numeric_Comparison_Exp>
  customer_first_name?: InputMaybe<String_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  email?: InputMaybe<String_Comparison_Exp>
  email_message_id?: InputMaybe<Bigint_Comparison_Exp>
  follow_up_review?: InputMaybe<Boolean_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  junifer_account_id?: InputMaybe<Bigint_Comparison_Exp>
  junifer_account_number?: InputMaybe<String_Comparison_Exp>
  notification_to_user_sent_at?: InputMaybe<Timestamp_Comparison_Exp>
  payment_date?: InputMaybe<Timestamp_Comparison_Exp>
  payment_id?: InputMaybe<Bigint_Comparison_Exp>
  refund_amount_in_pence?: InputMaybe<Numeric_Comparison_Exp>
  seasonal?: InputMaybe<Boolean_Comparison_Exp>
  status?: InputMaybe<Refund_Status_Comparison_Exp>
  suggested_payment_amount_in_pence?: InputMaybe<Numeric_Comparison_Exp>
  suggested_summer_payment_amount_in_pence?: InputMaybe<Numeric_Comparison_Exp>
  suggested_winter_payment_amount_in_pence?: InputMaybe<Numeric_Comparison_Exp>
  type?: InputMaybe<Refund_Type_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "scheduled_refund" */
export enum Scheduled_Refund_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScheduledRefundPkey = "scheduled_refund_pkey",
}

/** input type for incrementing numeric columns in table "scheduled_refund" */
export type Scheduled_Refund_Inc_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  current_payment_amount_in_pence?: InputMaybe<Scalars["numeric"]["input"]>
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  payment_id?: InputMaybe<Scalars["bigint"]["input"]>
  refund_amount_in_pence?: InputMaybe<Scalars["numeric"]["input"]>
  suggested_payment_amount_in_pence?: InputMaybe<Scalars["numeric"]["input"]>
  suggested_summer_payment_amount_in_pence?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  suggested_winter_payment_amount_in_pence?: InputMaybe<
    Scalars["numeric"]["input"]
  >
}

/** input type for inserting data into table "scheduled_refund" */
export type Scheduled_Refund_Insert_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  current_payment_amount_in_pence?: InputMaybe<Scalars["numeric"]["input"]>
  customer_first_name?: InputMaybe<Scalars["String"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  follow_up_review?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_account_number?: InputMaybe<Scalars["String"]["input"]>
  notification_to_user_sent_at?: InputMaybe<Scalars["timestamp"]["input"]>
  payment_date?: InputMaybe<Scalars["timestamp"]["input"]>
  payment_id?: InputMaybe<Scalars["bigint"]["input"]>
  refund_amount_in_pence?: InputMaybe<Scalars["numeric"]["input"]>
  seasonal?: InputMaybe<Scalars["Boolean"]["input"]>
  status?: InputMaybe<Scalars["refund_status"]["input"]>
  suggested_payment_amount_in_pence?: InputMaybe<Scalars["numeric"]["input"]>
  suggested_summer_payment_amount_in_pence?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  suggested_winter_payment_amount_in_pence?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  type?: InputMaybe<Scalars["refund_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Scheduled_Refund_Max_Fields = {
  __typename?: "scheduled_refund_max_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  current_payment_amount_in_pence?: Maybe<Scalars["numeric"]["output"]>
  customer_first_name?: Maybe<Scalars["String"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_account_id?: Maybe<Scalars["bigint"]["output"]>
  junifer_account_number?: Maybe<Scalars["String"]["output"]>
  notification_to_user_sent_at?: Maybe<Scalars["timestamp"]["output"]>
  payment_date?: Maybe<Scalars["timestamp"]["output"]>
  payment_id?: Maybe<Scalars["bigint"]["output"]>
  refund_amount_in_pence?: Maybe<Scalars["numeric"]["output"]>
  status?: Maybe<Scalars["refund_status"]["output"]>
  suggested_payment_amount_in_pence?: Maybe<Scalars["numeric"]["output"]>
  suggested_summer_payment_amount_in_pence?: Maybe<Scalars["numeric"]["output"]>
  suggested_winter_payment_amount_in_pence?: Maybe<Scalars["numeric"]["output"]>
  type?: Maybe<Scalars["refund_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Scheduled_Refund_Min_Fields = {
  __typename?: "scheduled_refund_min_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  current_payment_amount_in_pence?: Maybe<Scalars["numeric"]["output"]>
  customer_first_name?: Maybe<Scalars["String"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_account_id?: Maybe<Scalars["bigint"]["output"]>
  junifer_account_number?: Maybe<Scalars["String"]["output"]>
  notification_to_user_sent_at?: Maybe<Scalars["timestamp"]["output"]>
  payment_date?: Maybe<Scalars["timestamp"]["output"]>
  payment_id?: Maybe<Scalars["bigint"]["output"]>
  refund_amount_in_pence?: Maybe<Scalars["numeric"]["output"]>
  status?: Maybe<Scalars["refund_status"]["output"]>
  suggested_payment_amount_in_pence?: Maybe<Scalars["numeric"]["output"]>
  suggested_summer_payment_amount_in_pence?: Maybe<Scalars["numeric"]["output"]>
  suggested_winter_payment_amount_in_pence?: Maybe<Scalars["numeric"]["output"]>
  type?: Maybe<Scalars["refund_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "scheduled_refund" */
export type Scheduled_Refund_Mutation_Response = {
  __typename?: "scheduled_refund_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Scheduled_Refund>
}

/** on_conflict condition type for table "scheduled_refund" */
export type Scheduled_Refund_On_Conflict = {
  constraint: Scheduled_Refund_Constraint
  update_columns?: Array<Scheduled_Refund_Update_Column>
  where?: InputMaybe<Scheduled_Refund_Bool_Exp>
}

/** Ordering options when selecting data from "scheduled_refund". */
export type Scheduled_Refund_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  current_payment_amount_in_pence?: InputMaybe<Order_By>
  customer_first_name?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  email?: InputMaybe<Order_By>
  email_message_id?: InputMaybe<Order_By>
  follow_up_review?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  junifer_account_id?: InputMaybe<Order_By>
  junifer_account_number?: InputMaybe<Order_By>
  notification_to_user_sent_at?: InputMaybe<Order_By>
  payment_date?: InputMaybe<Order_By>
  payment_id?: InputMaybe<Order_By>
  refund_amount_in_pence?: InputMaybe<Order_By>
  seasonal?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  suggested_payment_amount_in_pence?: InputMaybe<Order_By>
  suggested_summer_payment_amount_in_pence?: InputMaybe<Order_By>
  suggested_winter_payment_amount_in_pence?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: scheduled_refund */
export type Scheduled_Refund_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "scheduled_refund" */
export enum Scheduled_Refund_Select_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CurrentPaymentAmountInPence = "current_payment_amount_in_pence",
  /** column name */
  CustomerFirstName = "customer_first_name",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Email = "email",
  /** column name */
  EmailMessageId = "email_message_id",
  /** column name */
  FollowUpReview = "follow_up_review",
  /** column name */
  Id = "id",
  /** column name */
  JuniferAccountId = "junifer_account_id",
  /** column name */
  JuniferAccountNumber = "junifer_account_number",
  /** column name */
  NotificationToUserSentAt = "notification_to_user_sent_at",
  /** column name */
  PaymentDate = "payment_date",
  /** column name */
  PaymentId = "payment_id",
  /** column name */
  RefundAmountInPence = "refund_amount_in_pence",
  /** column name */
  Seasonal = "seasonal",
  /** column name */
  Status = "status",
  /** column name */
  SuggestedPaymentAmountInPence = "suggested_payment_amount_in_pence",
  /** column name */
  SuggestedSummerPaymentAmountInPence = "suggested_summer_payment_amount_in_pence",
  /** column name */
  SuggestedWinterPaymentAmountInPence = "suggested_winter_payment_amount_in_pence",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "scheduled_refund" */
export type Scheduled_Refund_Set_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  current_payment_amount_in_pence?: InputMaybe<Scalars["numeric"]["input"]>
  customer_first_name?: InputMaybe<Scalars["String"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  follow_up_review?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_account_number?: InputMaybe<Scalars["String"]["input"]>
  notification_to_user_sent_at?: InputMaybe<Scalars["timestamp"]["input"]>
  payment_date?: InputMaybe<Scalars["timestamp"]["input"]>
  payment_id?: InputMaybe<Scalars["bigint"]["input"]>
  refund_amount_in_pence?: InputMaybe<Scalars["numeric"]["input"]>
  seasonal?: InputMaybe<Scalars["Boolean"]["input"]>
  status?: InputMaybe<Scalars["refund_status"]["input"]>
  suggested_payment_amount_in_pence?: InputMaybe<Scalars["numeric"]["input"]>
  suggested_summer_payment_amount_in_pence?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  suggested_winter_payment_amount_in_pence?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  type?: InputMaybe<Scalars["refund_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Scheduled_Refund_Stddev_Fields = {
  __typename?: "scheduled_refund_stddev_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  current_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  payment_id?: Maybe<Scalars["Float"]["output"]>
  refund_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_summer_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_winter_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Scheduled_Refund_Stddev_Pop_Fields = {
  __typename?: "scheduled_refund_stddev_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  current_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  payment_id?: Maybe<Scalars["Float"]["output"]>
  refund_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_summer_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_winter_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Scheduled_Refund_Stddev_Samp_Fields = {
  __typename?: "scheduled_refund_stddev_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  current_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  payment_id?: Maybe<Scalars["Float"]["output"]>
  refund_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_summer_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_winter_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "scheduled_refund" */
export type Scheduled_Refund_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scheduled_Refund_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Scheduled_Refund_Stream_Cursor_Value_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  current_payment_amount_in_pence?: InputMaybe<Scalars["numeric"]["input"]>
  customer_first_name?: InputMaybe<Scalars["String"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  follow_up_review?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_account_number?: InputMaybe<Scalars["String"]["input"]>
  notification_to_user_sent_at?: InputMaybe<Scalars["timestamp"]["input"]>
  payment_date?: InputMaybe<Scalars["timestamp"]["input"]>
  payment_id?: InputMaybe<Scalars["bigint"]["input"]>
  refund_amount_in_pence?: InputMaybe<Scalars["numeric"]["input"]>
  seasonal?: InputMaybe<Scalars["Boolean"]["input"]>
  status?: InputMaybe<Scalars["refund_status"]["input"]>
  suggested_payment_amount_in_pence?: InputMaybe<Scalars["numeric"]["input"]>
  suggested_summer_payment_amount_in_pence?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  suggested_winter_payment_amount_in_pence?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  type?: InputMaybe<Scalars["refund_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Scheduled_Refund_Sum_Fields = {
  __typename?: "scheduled_refund_sum_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  current_payment_amount_in_pence?: Maybe<Scalars["numeric"]["output"]>
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_account_id?: Maybe<Scalars["bigint"]["output"]>
  payment_id?: Maybe<Scalars["bigint"]["output"]>
  refund_amount_in_pence?: Maybe<Scalars["numeric"]["output"]>
  suggested_payment_amount_in_pence?: Maybe<Scalars["numeric"]["output"]>
  suggested_summer_payment_amount_in_pence?: Maybe<Scalars["numeric"]["output"]>
  suggested_winter_payment_amount_in_pence?: Maybe<Scalars["numeric"]["output"]>
}

/** update columns of table "scheduled_refund" */
export enum Scheduled_Refund_Update_Column {
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CurrentPaymentAmountInPence = "current_payment_amount_in_pence",
  /** column name */
  CustomerFirstName = "customer_first_name",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Email = "email",
  /** column name */
  EmailMessageId = "email_message_id",
  /** column name */
  FollowUpReview = "follow_up_review",
  /** column name */
  Id = "id",
  /** column name */
  JuniferAccountId = "junifer_account_id",
  /** column name */
  JuniferAccountNumber = "junifer_account_number",
  /** column name */
  NotificationToUserSentAt = "notification_to_user_sent_at",
  /** column name */
  PaymentDate = "payment_date",
  /** column name */
  PaymentId = "payment_id",
  /** column name */
  RefundAmountInPence = "refund_amount_in_pence",
  /** column name */
  Seasonal = "seasonal",
  /** column name */
  Status = "status",
  /** column name */
  SuggestedPaymentAmountInPence = "suggested_payment_amount_in_pence",
  /** column name */
  SuggestedSummerPaymentAmountInPence = "suggested_summer_payment_amount_in_pence",
  /** column name */
  SuggestedWinterPaymentAmountInPence = "suggested_winter_payment_amount_in_pence",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Scheduled_Refund_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Scheduled_Refund_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Scheduled_Refund_Set_Input>
  /** filter the rows which have to be updated */
  where: Scheduled_Refund_Bool_Exp
}

/** aggregate var_pop on columns */
export type Scheduled_Refund_Var_Pop_Fields = {
  __typename?: "scheduled_refund_var_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  current_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  payment_id?: Maybe<Scalars["Float"]["output"]>
  refund_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_summer_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_winter_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Scheduled_Refund_Var_Samp_Fields = {
  __typename?: "scheduled_refund_var_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  current_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  payment_id?: Maybe<Scalars["Float"]["output"]>
  refund_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_summer_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_winter_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Scheduled_Refund_Variance_Fields = {
  __typename?: "scheduled_refund_variance_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  current_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_account_id?: Maybe<Scalars["Float"]["output"]>
  payment_id?: Maybe<Scalars["Float"]["output"]>
  refund_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_summer_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
  suggested_winter_payment_amount_in_pence?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["smallint"]["input"]>
  _gt?: InputMaybe<Scalars["smallint"]["input"]>
  _gte?: InputMaybe<Scalars["smallint"]["input"]>
  _in?: InputMaybe<Array<Scalars["smallint"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["smallint"]["input"]>
  _lte?: InputMaybe<Scalars["smallint"]["input"]>
  _neq?: InputMaybe<Scalars["smallint"]["input"]>
  _nin?: InputMaybe<Array<Scalars["smallint"]["input"]>>
}

/** columns and relationships of "smart_charging" */
export type Smart_Charging = {
  __typename?: "smart_charging"
  axle_site_id?: Maybe<Scalars["String"]["output"]>
  billing_account_id: Scalars["bigint"]["output"]
  created_at: Scalars["timestamptz"]["output"]
  deleted?: Maybe<Scalars["timestamptz"]["output"]>
  eligibility_check_id?: Maybe<Scalars["bigint"]["output"]>
  /** An object relationship */
  ev_tariff_eligibility_check?: Maybe<Ev_Tariff_Eligibility_Checks>
  id: Scalars["bigint"]["output"]
  meter_point_id: Scalars["bigint"]["output"]
  offboarded_at?: Maybe<Scalars["timestamptz"]["output"]>
  onboarded_at?: Maybe<Scalars["timestamptz"]["output"]>
  updated_at: Scalars["timestamptz"]["output"]
}

/** aggregated selection of "smart_charging" */
export type Smart_Charging_Aggregate = {
  __typename?: "smart_charging_aggregate"
  aggregate?: Maybe<Smart_Charging_Aggregate_Fields>
  nodes: Array<Smart_Charging>
}

export type Smart_Charging_Aggregate_Bool_Exp = {
  count?: InputMaybe<Smart_Charging_Aggregate_Bool_Exp_Count>
}

export type Smart_Charging_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Smart_Charging_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Smart_Charging_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "smart_charging" */
export type Smart_Charging_Aggregate_Fields = {
  __typename?: "smart_charging_aggregate_fields"
  avg?: Maybe<Smart_Charging_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Smart_Charging_Max_Fields>
  min?: Maybe<Smart_Charging_Min_Fields>
  stddev?: Maybe<Smart_Charging_Stddev_Fields>
  stddev_pop?: Maybe<Smart_Charging_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Smart_Charging_Stddev_Samp_Fields>
  sum?: Maybe<Smart_Charging_Sum_Fields>
  var_pop?: Maybe<Smart_Charging_Var_Pop_Fields>
  var_samp?: Maybe<Smart_Charging_Var_Samp_Fields>
  variance?: Maybe<Smart_Charging_Variance_Fields>
}

/** aggregate fields of "smart_charging" */
export type Smart_Charging_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Smart_Charging_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "smart_charging" */
export type Smart_Charging_Aggregate_Order_By = {
  avg?: InputMaybe<Smart_Charging_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Smart_Charging_Max_Order_By>
  min?: InputMaybe<Smart_Charging_Min_Order_By>
  stddev?: InputMaybe<Smart_Charging_Stddev_Order_By>
  stddev_pop?: InputMaybe<Smart_Charging_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Smart_Charging_Stddev_Samp_Order_By>
  sum?: InputMaybe<Smart_Charging_Sum_Order_By>
  var_pop?: InputMaybe<Smart_Charging_Var_Pop_Order_By>
  var_samp?: InputMaybe<Smart_Charging_Var_Samp_Order_By>
  variance?: InputMaybe<Smart_Charging_Variance_Order_By>
}

/** input type for inserting array relation for remote table "smart_charging" */
export type Smart_Charging_Arr_Rel_Insert_Input = {
  data: Array<Smart_Charging_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Smart_Charging_On_Conflict>
}

/** aggregate avg on columns */
export type Smart_Charging_Avg_Fields = {
  __typename?: "smart_charging_avg_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  eligibility_check_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "smart_charging" */
export type Smart_Charging_Avg_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  eligibility_check_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "smart_charging". All fields are combined with a logical 'AND'. */
export type Smart_Charging_Bool_Exp = {
  _and?: InputMaybe<Array<Smart_Charging_Bool_Exp>>
  _not?: InputMaybe<Smart_Charging_Bool_Exp>
  _or?: InputMaybe<Array<Smart_Charging_Bool_Exp>>
  axle_site_id?: InputMaybe<String_Comparison_Exp>
  billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  deleted?: InputMaybe<Timestamptz_Comparison_Exp>
  eligibility_check_id?: InputMaybe<Bigint_Comparison_Exp>
  ev_tariff_eligibility_check?: InputMaybe<Ev_Tariff_Eligibility_Checks_Bool_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  meter_point_id?: InputMaybe<Bigint_Comparison_Exp>
  offboarded_at?: InputMaybe<Timestamptz_Comparison_Exp>
  onboarded_at?: InputMaybe<Timestamptz_Comparison_Exp>
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>
}

/** unique or primary key constraints on table "smart_charging" */
export enum Smart_Charging_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkSmartCharging = "pk_smart_charging",
  /** unique or primary key constraint on columns "axle_site_id" */
  SmartChargingAxleSiteIdActiveIdx = "smart_charging_axle_site_id_active_idx",
  /** unique or primary key constraint on columns "billing_account_id" */
  SmartChargingBillingAccountIdActiveIdx = "smart_charging_billing_account_id_active_idx",
}

/** input type for incrementing numeric columns in table "smart_charging" */
export type Smart_Charging_Inc_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  eligibility_check_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "smart_charging" */
export type Smart_Charging_Insert_Input = {
  axle_site_id?: InputMaybe<Scalars["String"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  deleted?: InputMaybe<Scalars["timestamptz"]["input"]>
  eligibility_check_id?: InputMaybe<Scalars["bigint"]["input"]>
  ev_tariff_eligibility_check?: InputMaybe<Ev_Tariff_Eligibility_Checks_Obj_Rel_Insert_Input>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  offboarded_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  onboarded_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamptz"]["input"]>
}

/** aggregate max on columns */
export type Smart_Charging_Max_Fields = {
  __typename?: "smart_charging_max_fields"
  axle_site_id?: Maybe<Scalars["String"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  deleted?: Maybe<Scalars["timestamptz"]["output"]>
  eligibility_check_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["bigint"]["output"]>
  offboarded_at?: Maybe<Scalars["timestamptz"]["output"]>
  onboarded_at?: Maybe<Scalars["timestamptz"]["output"]>
  updated_at?: Maybe<Scalars["timestamptz"]["output"]>
}

/** order by max() on columns of table "smart_charging" */
export type Smart_Charging_Max_Order_By = {
  axle_site_id?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  eligibility_check_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  offboarded_at?: InputMaybe<Order_By>
  onboarded_at?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Smart_Charging_Min_Fields = {
  __typename?: "smart_charging_min_fields"
  axle_site_id?: Maybe<Scalars["String"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  deleted?: Maybe<Scalars["timestamptz"]["output"]>
  eligibility_check_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["bigint"]["output"]>
  offboarded_at?: Maybe<Scalars["timestamptz"]["output"]>
  onboarded_at?: Maybe<Scalars["timestamptz"]["output"]>
  updated_at?: Maybe<Scalars["timestamptz"]["output"]>
}

/** order by min() on columns of table "smart_charging" */
export type Smart_Charging_Min_Order_By = {
  axle_site_id?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  eligibility_check_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  offboarded_at?: InputMaybe<Order_By>
  onboarded_at?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "smart_charging" */
export type Smart_Charging_Mutation_Response = {
  __typename?: "smart_charging_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Smart_Charging>
}

/** on_conflict condition type for table "smart_charging" */
export type Smart_Charging_On_Conflict = {
  constraint: Smart_Charging_Constraint
  update_columns?: Array<Smart_Charging_Update_Column>
  where?: InputMaybe<Smart_Charging_Bool_Exp>
}

/** Ordering options when selecting data from "smart_charging". */
export type Smart_Charging_Order_By = {
  axle_site_id?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  eligibility_check_id?: InputMaybe<Order_By>
  ev_tariff_eligibility_check?: InputMaybe<Ev_Tariff_Eligibility_Checks_Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
  offboarded_at?: InputMaybe<Order_By>
  onboarded_at?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: smart_charging */
export type Smart_Charging_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "smart_charging" */
export enum Smart_Charging_Select_Column {
  /** column name */
  AxleSiteId = "axle_site_id",
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  EligibilityCheckId = "eligibility_check_id",
  /** column name */
  Id = "id",
  /** column name */
  MeterPointId = "meter_point_id",
  /** column name */
  OffboardedAt = "offboarded_at",
  /** column name */
  OnboardedAt = "onboarded_at",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "smart_charging" */
export type Smart_Charging_Set_Input = {
  axle_site_id?: InputMaybe<Scalars["String"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  deleted?: InputMaybe<Scalars["timestamptz"]["input"]>
  eligibility_check_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  offboarded_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  onboarded_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamptz"]["input"]>
}

/** aggregate stddev on columns */
export type Smart_Charging_Stddev_Fields = {
  __typename?: "smart_charging_stddev_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  eligibility_check_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "smart_charging" */
export type Smart_Charging_Stddev_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  eligibility_check_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Smart_Charging_Stddev_Pop_Fields = {
  __typename?: "smart_charging_stddev_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  eligibility_check_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "smart_charging" */
export type Smart_Charging_Stddev_Pop_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  eligibility_check_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Smart_Charging_Stddev_Samp_Fields = {
  __typename?: "smart_charging_stddev_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  eligibility_check_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "smart_charging" */
export type Smart_Charging_Stddev_Samp_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  eligibility_check_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "smart_charging" */
export type Smart_Charging_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Smart_Charging_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Smart_Charging_Stream_Cursor_Value_Input = {
  axle_site_id?: InputMaybe<Scalars["String"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  deleted?: InputMaybe<Scalars["timestamptz"]["input"]>
  eligibility_check_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  meter_point_id?: InputMaybe<Scalars["bigint"]["input"]>
  offboarded_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  onboarded_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamptz"]["input"]>
}

/** aggregate sum on columns */
export type Smart_Charging_Sum_Fields = {
  __typename?: "smart_charging_sum_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  eligibility_check_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  meter_point_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "smart_charging" */
export type Smart_Charging_Sum_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  eligibility_check_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** update columns of table "smart_charging" */
export enum Smart_Charging_Update_Column {
  /** column name */
  AxleSiteId = "axle_site_id",
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  EligibilityCheckId = "eligibility_check_id",
  /** column name */
  Id = "id",
  /** column name */
  MeterPointId = "meter_point_id",
  /** column name */
  OffboardedAt = "offboarded_at",
  /** column name */
  OnboardedAt = "onboarded_at",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Smart_Charging_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Smart_Charging_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Smart_Charging_Set_Input>
  /** filter the rows which have to be updated */
  where: Smart_Charging_Bool_Exp
}

/** aggregate var_pop on columns */
export type Smart_Charging_Var_Pop_Fields = {
  __typename?: "smart_charging_var_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  eligibility_check_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "smart_charging" */
export type Smart_Charging_Var_Pop_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  eligibility_check_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Smart_Charging_Var_Samp_Fields = {
  __typename?: "smart_charging_var_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  eligibility_check_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "smart_charging" */
export type Smart_Charging_Var_Samp_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  eligibility_check_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Smart_Charging_Variance_Fields = {
  __typename?: "smart_charging_variance_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  eligibility_check_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  meter_point_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "smart_charging" */
export type Smart_Charging_Variance_Order_By = {
  billing_account_id?: InputMaybe<Order_By>
  eligibility_check_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  meter_point_id?: InputMaybe<Order_By>
}

export type Smart_Meter_Dashboard_Order_By_Dev_Status_Model = {
  __typename?: "smart_meter_dashboard_order_by_dev_status_model"
  count: Scalars["bigint"]["output"]
  dev_status: Scalars["String"]["output"]
}

/** Boolean expression to filter rows from the logical model for "smart_meter_dashboard_order_by_dev_status_model". All fields are combined with a logical 'AND'. */
export type Smart_Meter_Dashboard_Order_By_Dev_Status_Model_Bool_Exp_Bool_Exp =
  {
    _and?: InputMaybe<
      Array<Smart_Meter_Dashboard_Order_By_Dev_Status_Model_Bool_Exp_Bool_Exp>
    >
    _not?: InputMaybe<Smart_Meter_Dashboard_Order_By_Dev_Status_Model_Bool_Exp_Bool_Exp>
    _or?: InputMaybe<
      Array<Smart_Meter_Dashboard_Order_By_Dev_Status_Model_Bool_Exp_Bool_Exp>
    >
    count?: InputMaybe<Bigint_Comparison_Exp>
    dev_status?: InputMaybe<String_Comparison_Exp>
  }

export enum Smart_Meter_Dashboard_Order_By_Dev_Status_Model_Enum_Name {
  /** column name */
  Count = "count",
  /** column name */
  DevStatus = "dev_status",
}

/** Ordering options when selecting data from "smart_meter_dashboard_order_by_dev_status_model". */
export type Smart_Meter_Dashboard_Order_By_Dev_Status_Model_Order_By = {
  count?: InputMaybe<Order_By>
  dev_status?: InputMaybe<Order_By>
}

export type Smart_Meter_Dashboard_Order_By_Workstream_Model = {
  __typename?: "smart_meter_dashboard_order_by_workstream_model"
  count: Scalars["bigint"]["output"]
  workstream?: Maybe<Scalars["String"]["output"]>
}

/** Boolean expression to filter rows from the logical model for "smart_meter_dashboard_order_by_workstream_model". All fields are combined with a logical 'AND'. */
export type Smart_Meter_Dashboard_Order_By_Workstream_Model_Bool_Exp_Bool_Exp =
  {
    _and?: InputMaybe<
      Array<Smart_Meter_Dashboard_Order_By_Workstream_Model_Bool_Exp_Bool_Exp>
    >
    _not?: InputMaybe<Smart_Meter_Dashboard_Order_By_Workstream_Model_Bool_Exp_Bool_Exp>
    _or?: InputMaybe<
      Array<Smart_Meter_Dashboard_Order_By_Workstream_Model_Bool_Exp_Bool_Exp>
    >
    count?: InputMaybe<Bigint_Comparison_Exp>
    workstream?: InputMaybe<String_Comparison_Exp>
  }

export enum Smart_Meter_Dashboard_Order_By_Workstream_Model_Enum_Name {
  /** column name */
  Count = "count",
  /** column name */
  Workstream = "workstream",
}

/** Ordering options when selecting data from "smart_meter_dashboard_order_by_workstream_model". */
export type Smart_Meter_Dashboard_Order_By_Workstream_Model_Order_By = {
  count?: InputMaybe<Order_By>
  workstream?: InputMaybe<Order_By>
}

/** columns and relationships of "smart_meter_dashboard_response_v7" */
export type Smart_Meter_Dashboard_Response_V7 = {
  __typename?: "smart_meter_dashboard_response_v7"
  comms_hub_id?: Maybe<Scalars["String"]["output"]>
  dev_status?: Maybe<Scalars["String"]["output"]>
  device_id?: Maybe<Scalars["String"]["output"]>
  error?: Maybe<Scalars["String"]["output"]>
  error_status?: Maybe<Scalars["String"]["output"]>
  firmware_status?: Maybe<Scalars["String"]["output"]>
  firmware_version?: Maybe<Scalars["String"]["output"]>
  gbcs_version?: Maybe<Scalars["String"]["output"]>
  installation_date?: Maybe<Scalars["timestamptz"]["output"]>
  last_orchestration?: Maybe<Scalars["String"]["output"]>
  latest_alert?: Maybe<Scalars["String"]["output"]>
  latest_alert_date?: Maybe<Scalars["timestamptz"]["output"]>
  latest_alert_status?: Maybe<Scalars["String"]["output"]>
  manufacturer?: Maybe<Scalars["String"]["output"]>
  meter_type?: Maybe<Scalars["String"]["output"]>
  model?: Maybe<Scalars["String"]["output"]>
  mpxn?: Maybe<Scalars["String"]["output"]>
  msn?: Maybe<Scalars["String"]["output"]>
  orchestration_status?: Maybe<Scalars["String"]["output"]>
  payment_mode?: Maybe<Scalars["String"]["output"]>
  pk?: Maybe<Scalars["bigint"]["output"]>
  reading?: Maybe<Scalars["numeric"]["output"]>
  reading_date_time?: Maybe<Scalars["timestamp"]["output"]>
  region?: Maybe<Scalars["String"]["output"]>
  smets_version?: Maybe<Scalars["String"]["output"]>
  srv?: Maybe<Scalars["String"]["output"]>
  ssd?: Maybe<Scalars["timestamptz"]["output"]>
  variant?: Maybe<Scalars["String"]["output"]>
  workstream?: Maybe<Scalars["String"]["output"]>
}

export type Smart_Meter_Dashboard_Response_V7_Aggregate = {
  __typename?: "smart_meter_dashboard_response_v7_aggregate"
  aggregate?: Maybe<Smart_Meter_Dashboard_Response_V7_Aggregate_Fields>
  nodes: Array<Smart_Meter_Dashboard_Response_V7>
}

/** aggregate fields of "smart_meter_dashboard_response_v7" */
export type Smart_Meter_Dashboard_Response_V7_Aggregate_Fields = {
  __typename?: "smart_meter_dashboard_response_v7_aggregate_fields"
  avg?: Maybe<Smart_Meter_Dashboard_Response_V7_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Smart_Meter_Dashboard_Response_V7_Max_Fields>
  min?: Maybe<Smart_Meter_Dashboard_Response_V7_Min_Fields>
  stddev?: Maybe<Smart_Meter_Dashboard_Response_V7_Stddev_Fields>
  stddev_pop?: Maybe<Smart_Meter_Dashboard_Response_V7_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Smart_Meter_Dashboard_Response_V7_Stddev_Samp_Fields>
  sum?: Maybe<Smart_Meter_Dashboard_Response_V7_Sum_Fields>
  var_pop?: Maybe<Smart_Meter_Dashboard_Response_V7_Var_Pop_Fields>
  var_samp?: Maybe<Smart_Meter_Dashboard_Response_V7_Var_Samp_Fields>
  variance?: Maybe<Smart_Meter_Dashboard_Response_V7_Variance_Fields>
}

/** aggregate fields of "smart_meter_dashboard_response_v7" */
export type Smart_Meter_Dashboard_Response_V7_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Smart_Meter_Dashboard_Response_V7_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Smart_Meter_Dashboard_Response_V7_Avg_Fields = {
  __typename?: "smart_meter_dashboard_response_v7_avg_fields"
  pk?: Maybe<Scalars["Float"]["output"]>
  reading?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "smart_meter_dashboard_response_v7". All fields are combined with a logical 'AND'. */
export type Smart_Meter_Dashboard_Response_V7_Bool_Exp = {
  _and?: InputMaybe<Array<Smart_Meter_Dashboard_Response_V7_Bool_Exp>>
  _not?: InputMaybe<Smart_Meter_Dashboard_Response_V7_Bool_Exp>
  _or?: InputMaybe<Array<Smart_Meter_Dashboard_Response_V7_Bool_Exp>>
  comms_hub_id?: InputMaybe<String_Comparison_Exp>
  dev_status?: InputMaybe<String_Comparison_Exp>
  device_id?: InputMaybe<String_Comparison_Exp>
  error?: InputMaybe<String_Comparison_Exp>
  error_status?: InputMaybe<String_Comparison_Exp>
  firmware_status?: InputMaybe<String_Comparison_Exp>
  firmware_version?: InputMaybe<String_Comparison_Exp>
  gbcs_version?: InputMaybe<String_Comparison_Exp>
  installation_date?: InputMaybe<Timestamptz_Comparison_Exp>
  last_orchestration?: InputMaybe<String_Comparison_Exp>
  latest_alert?: InputMaybe<String_Comparison_Exp>
  latest_alert_date?: InputMaybe<Timestamptz_Comparison_Exp>
  latest_alert_status?: InputMaybe<String_Comparison_Exp>
  manufacturer?: InputMaybe<String_Comparison_Exp>
  meter_type?: InputMaybe<String_Comparison_Exp>
  model?: InputMaybe<String_Comparison_Exp>
  mpxn?: InputMaybe<String_Comparison_Exp>
  msn?: InputMaybe<String_Comparison_Exp>
  orchestration_status?: InputMaybe<String_Comparison_Exp>
  payment_mode?: InputMaybe<String_Comparison_Exp>
  pk?: InputMaybe<Bigint_Comparison_Exp>
  reading?: InputMaybe<Numeric_Comparison_Exp>
  reading_date_time?: InputMaybe<Timestamp_Comparison_Exp>
  region?: InputMaybe<String_Comparison_Exp>
  smets_version?: InputMaybe<String_Comparison_Exp>
  srv?: InputMaybe<String_Comparison_Exp>
  ssd?: InputMaybe<Timestamptz_Comparison_Exp>
  variant?: InputMaybe<String_Comparison_Exp>
  workstream?: InputMaybe<String_Comparison_Exp>
}

/** input type for incrementing numeric columns in table "smart_meter_dashboard_response_v7" */
export type Smart_Meter_Dashboard_Response_V7_Inc_Input = {
  pk?: InputMaybe<Scalars["bigint"]["input"]>
  reading?: InputMaybe<Scalars["numeric"]["input"]>
}

/** input type for inserting data into table "smart_meter_dashboard_response_v7" */
export type Smart_Meter_Dashboard_Response_V7_Insert_Input = {
  comms_hub_id?: InputMaybe<Scalars["String"]["input"]>
  dev_status?: InputMaybe<Scalars["String"]["input"]>
  device_id?: InputMaybe<Scalars["String"]["input"]>
  error?: InputMaybe<Scalars["String"]["input"]>
  error_status?: InputMaybe<Scalars["String"]["input"]>
  firmware_status?: InputMaybe<Scalars["String"]["input"]>
  firmware_version?: InputMaybe<Scalars["String"]["input"]>
  gbcs_version?: InputMaybe<Scalars["String"]["input"]>
  installation_date?: InputMaybe<Scalars["timestamptz"]["input"]>
  last_orchestration?: InputMaybe<Scalars["String"]["input"]>
  latest_alert?: InputMaybe<Scalars["String"]["input"]>
  latest_alert_date?: InputMaybe<Scalars["timestamptz"]["input"]>
  latest_alert_status?: InputMaybe<Scalars["String"]["input"]>
  manufacturer?: InputMaybe<Scalars["String"]["input"]>
  meter_type?: InputMaybe<Scalars["String"]["input"]>
  model?: InputMaybe<Scalars["String"]["input"]>
  mpxn?: InputMaybe<Scalars["String"]["input"]>
  msn?: InputMaybe<Scalars["String"]["input"]>
  orchestration_status?: InputMaybe<Scalars["String"]["input"]>
  payment_mode?: InputMaybe<Scalars["String"]["input"]>
  pk?: InputMaybe<Scalars["bigint"]["input"]>
  reading?: InputMaybe<Scalars["numeric"]["input"]>
  reading_date_time?: InputMaybe<Scalars["timestamp"]["input"]>
  region?: InputMaybe<Scalars["String"]["input"]>
  smets_version?: InputMaybe<Scalars["String"]["input"]>
  srv?: InputMaybe<Scalars["String"]["input"]>
  ssd?: InputMaybe<Scalars["timestamptz"]["input"]>
  variant?: InputMaybe<Scalars["String"]["input"]>
  workstream?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Smart_Meter_Dashboard_Response_V7_Max_Fields = {
  __typename?: "smart_meter_dashboard_response_v7_max_fields"
  comms_hub_id?: Maybe<Scalars["String"]["output"]>
  dev_status?: Maybe<Scalars["String"]["output"]>
  device_id?: Maybe<Scalars["String"]["output"]>
  error?: Maybe<Scalars["String"]["output"]>
  error_status?: Maybe<Scalars["String"]["output"]>
  firmware_status?: Maybe<Scalars["String"]["output"]>
  firmware_version?: Maybe<Scalars["String"]["output"]>
  gbcs_version?: Maybe<Scalars["String"]["output"]>
  installation_date?: Maybe<Scalars["timestamptz"]["output"]>
  last_orchestration?: Maybe<Scalars["String"]["output"]>
  latest_alert?: Maybe<Scalars["String"]["output"]>
  latest_alert_date?: Maybe<Scalars["timestamptz"]["output"]>
  latest_alert_status?: Maybe<Scalars["String"]["output"]>
  manufacturer?: Maybe<Scalars["String"]["output"]>
  meter_type?: Maybe<Scalars["String"]["output"]>
  model?: Maybe<Scalars["String"]["output"]>
  mpxn?: Maybe<Scalars["String"]["output"]>
  msn?: Maybe<Scalars["String"]["output"]>
  orchestration_status?: Maybe<Scalars["String"]["output"]>
  payment_mode?: Maybe<Scalars["String"]["output"]>
  pk?: Maybe<Scalars["bigint"]["output"]>
  reading?: Maybe<Scalars["numeric"]["output"]>
  reading_date_time?: Maybe<Scalars["timestamp"]["output"]>
  region?: Maybe<Scalars["String"]["output"]>
  smets_version?: Maybe<Scalars["String"]["output"]>
  srv?: Maybe<Scalars["String"]["output"]>
  ssd?: Maybe<Scalars["timestamptz"]["output"]>
  variant?: Maybe<Scalars["String"]["output"]>
  workstream?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Smart_Meter_Dashboard_Response_V7_Min_Fields = {
  __typename?: "smart_meter_dashboard_response_v7_min_fields"
  comms_hub_id?: Maybe<Scalars["String"]["output"]>
  dev_status?: Maybe<Scalars["String"]["output"]>
  device_id?: Maybe<Scalars["String"]["output"]>
  error?: Maybe<Scalars["String"]["output"]>
  error_status?: Maybe<Scalars["String"]["output"]>
  firmware_status?: Maybe<Scalars["String"]["output"]>
  firmware_version?: Maybe<Scalars["String"]["output"]>
  gbcs_version?: Maybe<Scalars["String"]["output"]>
  installation_date?: Maybe<Scalars["timestamptz"]["output"]>
  last_orchestration?: Maybe<Scalars["String"]["output"]>
  latest_alert?: Maybe<Scalars["String"]["output"]>
  latest_alert_date?: Maybe<Scalars["timestamptz"]["output"]>
  latest_alert_status?: Maybe<Scalars["String"]["output"]>
  manufacturer?: Maybe<Scalars["String"]["output"]>
  meter_type?: Maybe<Scalars["String"]["output"]>
  model?: Maybe<Scalars["String"]["output"]>
  mpxn?: Maybe<Scalars["String"]["output"]>
  msn?: Maybe<Scalars["String"]["output"]>
  orchestration_status?: Maybe<Scalars["String"]["output"]>
  payment_mode?: Maybe<Scalars["String"]["output"]>
  pk?: Maybe<Scalars["bigint"]["output"]>
  reading?: Maybe<Scalars["numeric"]["output"]>
  reading_date_time?: Maybe<Scalars["timestamp"]["output"]>
  region?: Maybe<Scalars["String"]["output"]>
  smets_version?: Maybe<Scalars["String"]["output"]>
  srv?: Maybe<Scalars["String"]["output"]>
  ssd?: Maybe<Scalars["timestamptz"]["output"]>
  variant?: Maybe<Scalars["String"]["output"]>
  workstream?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "smart_meter_dashboard_response_v7" */
export type Smart_Meter_Dashboard_Response_V7_Mutation_Response = {
  __typename?: "smart_meter_dashboard_response_v7_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Smart_Meter_Dashboard_Response_V7>
}

/** Ordering options when selecting data from "smart_meter_dashboard_response_v7". */
export type Smart_Meter_Dashboard_Response_V7_Order_By = {
  comms_hub_id?: InputMaybe<Order_By>
  dev_status?: InputMaybe<Order_By>
  device_id?: InputMaybe<Order_By>
  error?: InputMaybe<Order_By>
  error_status?: InputMaybe<Order_By>
  firmware_status?: InputMaybe<Order_By>
  firmware_version?: InputMaybe<Order_By>
  gbcs_version?: InputMaybe<Order_By>
  installation_date?: InputMaybe<Order_By>
  last_orchestration?: InputMaybe<Order_By>
  latest_alert?: InputMaybe<Order_By>
  latest_alert_date?: InputMaybe<Order_By>
  latest_alert_status?: InputMaybe<Order_By>
  manufacturer?: InputMaybe<Order_By>
  meter_type?: InputMaybe<Order_By>
  model?: InputMaybe<Order_By>
  mpxn?: InputMaybe<Order_By>
  msn?: InputMaybe<Order_By>
  orchestration_status?: InputMaybe<Order_By>
  payment_mode?: InputMaybe<Order_By>
  pk?: InputMaybe<Order_By>
  reading?: InputMaybe<Order_By>
  reading_date_time?: InputMaybe<Order_By>
  region?: InputMaybe<Order_By>
  smets_version?: InputMaybe<Order_By>
  srv?: InputMaybe<Order_By>
  ssd?: InputMaybe<Order_By>
  variant?: InputMaybe<Order_By>
  workstream?: InputMaybe<Order_By>
}

/** select columns of table "smart_meter_dashboard_response_v7" */
export enum Smart_Meter_Dashboard_Response_V7_Select_Column {
  /** column name */
  CommsHubId = "comms_hub_id",
  /** column name */
  DevStatus = "dev_status",
  /** column name */
  DeviceId = "device_id",
  /** column name */
  Error = "error",
  /** column name */
  ErrorStatus = "error_status",
  /** column name */
  FirmwareStatus = "firmware_status",
  /** column name */
  FirmwareVersion = "firmware_version",
  /** column name */
  GbcsVersion = "gbcs_version",
  /** column name */
  InstallationDate = "installation_date",
  /** column name */
  LastOrchestration = "last_orchestration",
  /** column name */
  LatestAlert = "latest_alert",
  /** column name */
  LatestAlertDate = "latest_alert_date",
  /** column name */
  LatestAlertStatus = "latest_alert_status",
  /** column name */
  Manufacturer = "manufacturer",
  /** column name */
  MeterType = "meter_type",
  /** column name */
  Model = "model",
  /** column name */
  Mpxn = "mpxn",
  /** column name */
  Msn = "msn",
  /** column name */
  OrchestrationStatus = "orchestration_status",
  /** column name */
  PaymentMode = "payment_mode",
  /** column name */
  Pk = "pk",
  /** column name */
  Reading = "reading",
  /** column name */
  ReadingDateTime = "reading_date_time",
  /** column name */
  Region = "region",
  /** column name */
  SmetsVersion = "smets_version",
  /** column name */
  Srv = "srv",
  /** column name */
  Ssd = "ssd",
  /** column name */
  Variant = "variant",
  /** column name */
  Workstream = "workstream",
}

/** input type for updating data in table "smart_meter_dashboard_response_v7" */
export type Smart_Meter_Dashboard_Response_V7_Set_Input = {
  comms_hub_id?: InputMaybe<Scalars["String"]["input"]>
  dev_status?: InputMaybe<Scalars["String"]["input"]>
  device_id?: InputMaybe<Scalars["String"]["input"]>
  error?: InputMaybe<Scalars["String"]["input"]>
  error_status?: InputMaybe<Scalars["String"]["input"]>
  firmware_status?: InputMaybe<Scalars["String"]["input"]>
  firmware_version?: InputMaybe<Scalars["String"]["input"]>
  gbcs_version?: InputMaybe<Scalars["String"]["input"]>
  installation_date?: InputMaybe<Scalars["timestamptz"]["input"]>
  last_orchestration?: InputMaybe<Scalars["String"]["input"]>
  latest_alert?: InputMaybe<Scalars["String"]["input"]>
  latest_alert_date?: InputMaybe<Scalars["timestamptz"]["input"]>
  latest_alert_status?: InputMaybe<Scalars["String"]["input"]>
  manufacturer?: InputMaybe<Scalars["String"]["input"]>
  meter_type?: InputMaybe<Scalars["String"]["input"]>
  model?: InputMaybe<Scalars["String"]["input"]>
  mpxn?: InputMaybe<Scalars["String"]["input"]>
  msn?: InputMaybe<Scalars["String"]["input"]>
  orchestration_status?: InputMaybe<Scalars["String"]["input"]>
  payment_mode?: InputMaybe<Scalars["String"]["input"]>
  pk?: InputMaybe<Scalars["bigint"]["input"]>
  reading?: InputMaybe<Scalars["numeric"]["input"]>
  reading_date_time?: InputMaybe<Scalars["timestamp"]["input"]>
  region?: InputMaybe<Scalars["String"]["input"]>
  smets_version?: InputMaybe<Scalars["String"]["input"]>
  srv?: InputMaybe<Scalars["String"]["input"]>
  ssd?: InputMaybe<Scalars["timestamptz"]["input"]>
  variant?: InputMaybe<Scalars["String"]["input"]>
  workstream?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Smart_Meter_Dashboard_Response_V7_Stddev_Fields = {
  __typename?: "smart_meter_dashboard_response_v7_stddev_fields"
  pk?: Maybe<Scalars["Float"]["output"]>
  reading?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Smart_Meter_Dashboard_Response_V7_Stddev_Pop_Fields = {
  __typename?: "smart_meter_dashboard_response_v7_stddev_pop_fields"
  pk?: Maybe<Scalars["Float"]["output"]>
  reading?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Smart_Meter_Dashboard_Response_V7_Stddev_Samp_Fields = {
  __typename?: "smart_meter_dashboard_response_v7_stddev_samp_fields"
  pk?: Maybe<Scalars["Float"]["output"]>
  reading?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "smart_meter_dashboard_response_v7" */
export type Smart_Meter_Dashboard_Response_V7_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Smart_Meter_Dashboard_Response_V7_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Smart_Meter_Dashboard_Response_V7_Stream_Cursor_Value_Input = {
  comms_hub_id?: InputMaybe<Scalars["String"]["input"]>
  dev_status?: InputMaybe<Scalars["String"]["input"]>
  device_id?: InputMaybe<Scalars["String"]["input"]>
  error?: InputMaybe<Scalars["String"]["input"]>
  error_status?: InputMaybe<Scalars["String"]["input"]>
  firmware_status?: InputMaybe<Scalars["String"]["input"]>
  firmware_version?: InputMaybe<Scalars["String"]["input"]>
  gbcs_version?: InputMaybe<Scalars["String"]["input"]>
  installation_date?: InputMaybe<Scalars["timestamptz"]["input"]>
  last_orchestration?: InputMaybe<Scalars["String"]["input"]>
  latest_alert?: InputMaybe<Scalars["String"]["input"]>
  latest_alert_date?: InputMaybe<Scalars["timestamptz"]["input"]>
  latest_alert_status?: InputMaybe<Scalars["String"]["input"]>
  manufacturer?: InputMaybe<Scalars["String"]["input"]>
  meter_type?: InputMaybe<Scalars["String"]["input"]>
  model?: InputMaybe<Scalars["String"]["input"]>
  mpxn?: InputMaybe<Scalars["String"]["input"]>
  msn?: InputMaybe<Scalars["String"]["input"]>
  orchestration_status?: InputMaybe<Scalars["String"]["input"]>
  payment_mode?: InputMaybe<Scalars["String"]["input"]>
  pk?: InputMaybe<Scalars["bigint"]["input"]>
  reading?: InputMaybe<Scalars["numeric"]["input"]>
  reading_date_time?: InputMaybe<Scalars["timestamp"]["input"]>
  region?: InputMaybe<Scalars["String"]["input"]>
  smets_version?: InputMaybe<Scalars["String"]["input"]>
  srv?: InputMaybe<Scalars["String"]["input"]>
  ssd?: InputMaybe<Scalars["timestamptz"]["input"]>
  variant?: InputMaybe<Scalars["String"]["input"]>
  workstream?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Smart_Meter_Dashboard_Response_V7_Sum_Fields = {
  __typename?: "smart_meter_dashboard_response_v7_sum_fields"
  pk?: Maybe<Scalars["bigint"]["output"]>
  reading?: Maybe<Scalars["numeric"]["output"]>
}

export type Smart_Meter_Dashboard_Response_V7_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Smart_Meter_Dashboard_Response_V7_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Smart_Meter_Dashboard_Response_V7_Set_Input>
  /** filter the rows which have to be updated */
  where: Smart_Meter_Dashboard_Response_V7_Bool_Exp
}

/** aggregate var_pop on columns */
export type Smart_Meter_Dashboard_Response_V7_Var_Pop_Fields = {
  __typename?: "smart_meter_dashboard_response_v7_var_pop_fields"
  pk?: Maybe<Scalars["Float"]["output"]>
  reading?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Smart_Meter_Dashboard_Response_V7_Var_Samp_Fields = {
  __typename?: "smart_meter_dashboard_response_v7_var_samp_fields"
  pk?: Maybe<Scalars["Float"]["output"]>
  reading?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Smart_Meter_Dashboard_Response_V7_Variance_Fields = {
  __typename?: "smart_meter_dashboard_response_v7_variance_fields"
  pk?: Maybe<Scalars["Float"]["output"]>
  reading?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "smart_meters_eligible_for_exchange" */
export type Smart_Meters_Eligible_For_Exchange = {
  __typename?: "smart_meters_eligible_for_exchange"
  confirmed_etc_waived?: Maybe<Scalars["Boolean"]["output"]>
  created_at: Scalars["timestamp"]["output"]
  deleted: Scalars["Boolean"]["output"]
  exchange_eligibility_reason?: Maybe<Scalars["String"]["output"]>
  fuel?: Maybe<Scalars["String"]["output"]>
  meter_serial_number: Scalars["String"]["output"]
  meter_type?: Maybe<Scalars["String"]["output"]>
  mpxn: Scalars["String"]["output"]
  source_file?: Maybe<Scalars["String"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "smart_meters_eligible_for_exchange" */
export type Smart_Meters_Eligible_For_Exchange_Aggregate = {
  __typename?: "smart_meters_eligible_for_exchange_aggregate"
  aggregate?: Maybe<Smart_Meters_Eligible_For_Exchange_Aggregate_Fields>
  nodes: Array<Smart_Meters_Eligible_For_Exchange>
}

/** aggregate fields of "smart_meters_eligible_for_exchange" */
export type Smart_Meters_Eligible_For_Exchange_Aggregate_Fields = {
  __typename?: "smart_meters_eligible_for_exchange_aggregate_fields"
  count: Scalars["Int"]["output"]
  max?: Maybe<Smart_Meters_Eligible_For_Exchange_Max_Fields>
  min?: Maybe<Smart_Meters_Eligible_For_Exchange_Min_Fields>
}

/** aggregate fields of "smart_meters_eligible_for_exchange" */
export type Smart_Meters_Eligible_For_Exchange_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Smart_Meters_Eligible_For_Exchange_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** Boolean expression to filter rows from the table "smart_meters_eligible_for_exchange". All fields are combined with a logical 'AND'. */
export type Smart_Meters_Eligible_For_Exchange_Bool_Exp = {
  _and?: InputMaybe<Array<Smart_Meters_Eligible_For_Exchange_Bool_Exp>>
  _not?: InputMaybe<Smart_Meters_Eligible_For_Exchange_Bool_Exp>
  _or?: InputMaybe<Array<Smart_Meters_Eligible_For_Exchange_Bool_Exp>>
  confirmed_etc_waived?: InputMaybe<Boolean_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Boolean_Comparison_Exp>
  exchange_eligibility_reason?: InputMaybe<String_Comparison_Exp>
  fuel?: InputMaybe<String_Comparison_Exp>
  meter_serial_number?: InputMaybe<String_Comparison_Exp>
  meter_type?: InputMaybe<String_Comparison_Exp>
  mpxn?: InputMaybe<String_Comparison_Exp>
  source_file?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "smart_meters_eligible_for_exchange" */
export enum Smart_Meters_Eligible_For_Exchange_Constraint {
  /** unique or primary key constraint on columns "mpxn", "meter_serial_number" */
  SmartMetersEligibleForExchangePkey = "smart_meters_eligible_for_exchange_pkey",
}

/** input type for inserting data into table "smart_meters_eligible_for_exchange" */
export type Smart_Meters_Eligible_For_Exchange_Insert_Input = {
  confirmed_etc_waived?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>
  exchange_eligibility_reason?: InputMaybe<Scalars["String"]["input"]>
  fuel?: InputMaybe<Scalars["String"]["input"]>
  meter_serial_number?: InputMaybe<Scalars["String"]["input"]>
  meter_type?: InputMaybe<Scalars["String"]["input"]>
  mpxn?: InputMaybe<Scalars["String"]["input"]>
  source_file?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Smart_Meters_Eligible_For_Exchange_Max_Fields = {
  __typename?: "smart_meters_eligible_for_exchange_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  exchange_eligibility_reason?: Maybe<Scalars["String"]["output"]>
  fuel?: Maybe<Scalars["String"]["output"]>
  meter_serial_number?: Maybe<Scalars["String"]["output"]>
  meter_type?: Maybe<Scalars["String"]["output"]>
  mpxn?: Maybe<Scalars["String"]["output"]>
  source_file?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Smart_Meters_Eligible_For_Exchange_Min_Fields = {
  __typename?: "smart_meters_eligible_for_exchange_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  exchange_eligibility_reason?: Maybe<Scalars["String"]["output"]>
  fuel?: Maybe<Scalars["String"]["output"]>
  meter_serial_number?: Maybe<Scalars["String"]["output"]>
  meter_type?: Maybe<Scalars["String"]["output"]>
  mpxn?: Maybe<Scalars["String"]["output"]>
  source_file?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "smart_meters_eligible_for_exchange" */
export type Smart_Meters_Eligible_For_Exchange_Mutation_Response = {
  __typename?: "smart_meters_eligible_for_exchange_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Smart_Meters_Eligible_For_Exchange>
}

/** on_conflict condition type for table "smart_meters_eligible_for_exchange" */
export type Smart_Meters_Eligible_For_Exchange_On_Conflict = {
  constraint: Smart_Meters_Eligible_For_Exchange_Constraint
  update_columns?: Array<Smart_Meters_Eligible_For_Exchange_Update_Column>
  where?: InputMaybe<Smart_Meters_Eligible_For_Exchange_Bool_Exp>
}

/** Ordering options when selecting data from "smart_meters_eligible_for_exchange". */
export type Smart_Meters_Eligible_For_Exchange_Order_By = {
  confirmed_etc_waived?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  exchange_eligibility_reason?: InputMaybe<Order_By>
  fuel?: InputMaybe<Order_By>
  meter_serial_number?: InputMaybe<Order_By>
  meter_type?: InputMaybe<Order_By>
  mpxn?: InputMaybe<Order_By>
  source_file?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: smart_meters_eligible_for_exchange */
export type Smart_Meters_Eligible_For_Exchange_Pk_Columns_Input = {
  meter_serial_number: Scalars["String"]["input"]
  mpxn: Scalars["String"]["input"]
}

/** select columns of table "smart_meters_eligible_for_exchange" */
export enum Smart_Meters_Eligible_For_Exchange_Select_Column {
  /** column name */
  ConfirmedEtcWaived = "confirmed_etc_waived",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  ExchangeEligibilityReason = "exchange_eligibility_reason",
  /** column name */
  Fuel = "fuel",
  /** column name */
  MeterSerialNumber = "meter_serial_number",
  /** column name */
  MeterType = "meter_type",
  /** column name */
  Mpxn = "mpxn",
  /** column name */
  SourceFile = "source_file",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "smart_meters_eligible_for_exchange" */
export type Smart_Meters_Eligible_For_Exchange_Set_Input = {
  confirmed_etc_waived?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>
  exchange_eligibility_reason?: InputMaybe<Scalars["String"]["input"]>
  fuel?: InputMaybe<Scalars["String"]["input"]>
  meter_serial_number?: InputMaybe<Scalars["String"]["input"]>
  meter_type?: InputMaybe<Scalars["String"]["input"]>
  mpxn?: InputMaybe<Scalars["String"]["input"]>
  source_file?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** Streaming cursor of the table "smart_meters_eligible_for_exchange" */
export type Smart_Meters_Eligible_For_Exchange_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Smart_Meters_Eligible_For_Exchange_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Smart_Meters_Eligible_For_Exchange_Stream_Cursor_Value_Input = {
  confirmed_etc_waived?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>
  exchange_eligibility_reason?: InputMaybe<Scalars["String"]["input"]>
  fuel?: InputMaybe<Scalars["String"]["input"]>
  meter_serial_number?: InputMaybe<Scalars["String"]["input"]>
  meter_type?: InputMaybe<Scalars["String"]["input"]>
  mpxn?: InputMaybe<Scalars["String"]["input"]>
  source_file?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** update columns of table "smart_meters_eligible_for_exchange" */
export enum Smart_Meters_Eligible_For_Exchange_Update_Column {
  /** column name */
  ConfirmedEtcWaived = "confirmed_etc_waived",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  ExchangeEligibilityReason = "exchange_eligibility_reason",
  /** column name */
  Fuel = "fuel",
  /** column name */
  MeterSerialNumber = "meter_serial_number",
  /** column name */
  MeterType = "meter_type",
  /** column name */
  Mpxn = "mpxn",
  /** column name */
  SourceFile = "source_file",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Smart_Meters_Eligible_For_Exchange_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Smart_Meters_Eligible_For_Exchange_Set_Input>
  /** filter the rows which have to be updated */
  where: Smart_Meters_Eligible_For_Exchange_Bool_Exp
}

/** Boolean expression to compare columns of type "squad". All fields are combined with logical 'AND'. */
export type Squad_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["squad"]["input"]>
  _gt?: InputMaybe<Scalars["squad"]["input"]>
  _gte?: InputMaybe<Scalars["squad"]["input"]>
  _in?: InputMaybe<Array<Scalars["squad"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["squad"]["input"]>
  _lte?: InputMaybe<Scalars["squad"]["input"]>
  _neq?: InputMaybe<Scalars["squad"]["input"]>
  _nin?: InputMaybe<Array<Scalars["squad"]["input"]>>
}

export type Subscription_Root = {
  __typename?: "subscription_root"
  /** fetch data from the table: "ElecNominations" */
  ElecNominations: Array<ElecNominations>
  /** fetch aggregated fields from the table: "ElecNominations" */
  ElecNominations_aggregate: ElecNominations_Aggregate
  /** fetch data from the table: "ElecTrades" */
  ElecTrades: Array<ElecTrades>
  /** fetch data from the table: "ElecTradesHistory" */
  ElecTradesHistory: Array<ElecTradesHistory>
  /** fetch aggregated fields from the table: "ElecTradesHistory" */
  ElecTradesHistory_aggregate: ElecTradesHistory_Aggregate
  /** fetch data from the table: "ElecTradesHistory" using primary key columns */
  ElecTradesHistory_by_pk?: Maybe<ElecTradesHistory>
  /** fetch aggregated fields from the table: "ElecTrades" */
  ElecTrades_aggregate: ElecTrades_Aggregate
  /** fetch data from the table: "ElecTrades" using primary key columns */
  ElecTrades_by_pk?: Maybe<ElecTrades>
  /** fetch data from the table: "GasTrades" */
  GasTrades: Array<GasTrades>
  /** fetch data from the table: "GasTradesHistory" */
  GasTradesHistory: Array<GasTradesHistory>
  /** fetch aggregated fields from the table: "GasTradesHistory" */
  GasTradesHistory_aggregate: GasTradesHistory_Aggregate
  /** fetch data from the table: "GasTradesHistory" using primary key columns */
  GasTradesHistory_by_pk?: Maybe<GasTradesHistory>
  /** fetch aggregated fields from the table: "GasTrades" */
  GasTrades_aggregate: GasTrades_Aggregate
  /** fetch data from the table: "GasTrades" using primary key columns */
  GasTrades_by_pk?: Maybe<GasTrades>
  /** fetch data from the table: "account_credit" */
  account_credit: Array<Account_Credit>
  /** fetch aggregated fields from the table: "account_credit" */
  account_credit_aggregate: Account_Credit_Aggregate
  /** fetch data from the table: "account_credit" using primary key columns */
  account_credit_by_pk?: Maybe<Account_Credit>
  /** fetch data from the table in a streaming manner: "account_credit" */
  account_credit_stream: Array<Account_Credit>
  /** fetch data from the table: "active_outbound_photo_request" */
  active_outbound_photo_request: Array<Active_Outbound_Photo_Request>
  /** fetch aggregated fields from the table: "active_outbound_photo_request" */
  active_outbound_photo_request_aggregate: Active_Outbound_Photo_Request_Aggregate
  /** fetch data from the table in a streaming manner: "active_outbound_photo_request" */
  active_outbound_photo_request_stream: Array<Active_Outbound_Photo_Request>
  /** fetch data from the table: "address" */
  address: Array<Address>
  /** fetch aggregated fields from the table: "address" */
  address_aggregate: Address_Aggregate
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk?: Maybe<Address>
  /** fetch data from the table in a streaming manner: "address" */
  address_stream: Array<Address>
  /** An array relationship */
  admin_passes: Array<Admin_Passes>
  /** An aggregate relationship */
  admin_passes_aggregate: Admin_Passes_Aggregate
  /** fetch data from the table: "admin_passes" using primary key columns */
  admin_passes_by_pk?: Maybe<Admin_Passes>
  /** fetch data from the table in a streaming manner: "admin_passes" */
  admin_passes_stream: Array<Admin_Passes>
  /** An array relationship */
  admin_roles: Array<Admin_Roles>
  /** An aggregate relationship */
  admin_roles_aggregate: Admin_Roles_Aggregate
  /** fetch data from the table: "admin_roles" using primary key columns */
  admin_roles_by_pk?: Maybe<Admin_Roles>
  /** fetch data from the table in a streaming manner: "admin_roles" */
  admin_roles_stream: Array<Admin_Roles>
  /** fetch data from the table: "agreement" */
  agreement: Array<Agreement>
  /** fetch aggregated fields from the table: "agreement" */
  agreement_aggregate: Agreement_Aggregate
  /** fetch data from the table: "agreement" using primary key columns */
  agreement_by_pk?: Maybe<Agreement>
  /** fetch data from the table in a streaming manner: "agreement" */
  agreement_stream: Array<Agreement>
  /** fetch data from the table: "asset" */
  asset: Array<Asset>
  /** fetch aggregated fields from the table: "asset" */
  asset_aggregate: Asset_Aggregate
  /** fetch data from the table: "asset" using primary key columns */
  asset_by_pk?: Maybe<Asset>
  /** fetch data from the table in a streaming manner: "asset" */
  asset_stream: Array<Asset>
  /** fetch data from the table: "attachment" */
  attachment: Array<Attachment>
  /** fetch aggregated fields from the table: "attachment" */
  attachment_aggregate: Attachment_Aggregate
  /** fetch data from the table: "attachment" using primary key columns */
  attachment_by_pk?: Maybe<Attachment>
  /** fetch data from the table in a streaming manner: "attachment" */
  attachment_stream: Array<Attachment>
  /** fetch data from the table: "axle_trial_eligibility" */
  axle_trial_eligibility: Array<Axle_Trial_Eligibility>
  /** fetch aggregated fields from the table: "axle_trial_eligibility" */
  axle_trial_eligibility_aggregate: Axle_Trial_Eligibility_Aggregate
  /** fetch data from the table: "axle_trial_eligibility" using primary key columns */
  axle_trial_eligibility_by_pk?: Maybe<Axle_Trial_Eligibility>
  /** fetch data from the table in a streaming manner: "axle_trial_eligibility" */
  axle_trial_eligibility_stream: Array<Axle_Trial_Eligibility>
  /** fetch data from the table: "bill" */
  bill: Array<Bill>
  /** fetch aggregated fields from the table: "bill" */
  bill_aggregate: Bill_Aggregate
  /** fetch data from the table: "bill" using primary key columns */
  bill_by_pk?: Maybe<Bill>
  /** fetch data from the table in a streaming manner: "bill" */
  bill_stream: Array<Bill>
  /** fetch data from the table: "billing_account" */
  billing_account: Array<Billing_Account>
  /** fetch aggregated fields from the table: "billing_account" */
  billing_account_aggregate: Billing_Account_Aggregate
  /** fetch data from the table: "billing_account" using primary key columns */
  billing_account_by_pk?: Maybe<Billing_Account>
  /** fetch data from the table: "billing_account_contact" */
  billing_account_contact: Array<Billing_Account_Contact>
  /** fetch aggregated fields from the table: "billing_account_contact" */
  billing_account_contact_aggregate: Billing_Account_Contact_Aggregate
  /** fetch data from the table: "billing_account_contact" using primary key columns */
  billing_account_contact_by_pk?: Maybe<Billing_Account_Contact>
  /** fetch data from the table in a streaming manner: "billing_account_contact" */
  billing_account_contact_stream: Array<Billing_Account_Contact>
  /** fetch data from the table: "billing_account_ids_with_meter_point_ids" */
  billing_account_ids_with_meter_point_ids: Array<Billing_Account_Ids_With_Meter_Point_Ids>
  /** fetch aggregated fields from the table: "billing_account_ids_with_meter_point_ids" */
  billing_account_ids_with_meter_point_ids_aggregate: Billing_Account_Ids_With_Meter_Point_Ids_Aggregate
  /** fetch data from the table in a streaming manner: "billing_account_ids_with_meter_point_ids" */
  billing_account_ids_with_meter_point_ids_stream: Array<Billing_Account_Ids_With_Meter_Point_Ids>
  /** fetch data from the table: "billing_account_setting" */
  billing_account_setting: Array<Billing_Account_Setting>
  /** fetch aggregated fields from the table: "billing_account_setting" */
  billing_account_setting_aggregate: Billing_Account_Setting_Aggregate
  /** fetch data from the table: "billing_account_setting" using primary key columns */
  billing_account_setting_by_pk?: Maybe<Billing_Account_Setting>
  /** fetch data from the table in a streaming manner: "billing_account_setting" */
  billing_account_setting_stream: Array<Billing_Account_Setting>
  /** fetch data from the table in a streaming manner: "billing_account" */
  billing_account_stream: Array<Billing_Account>
  /** fetch data from the table: "billing_account_transaction" */
  billing_account_transaction: Array<Billing_Account_Transaction>
  /** fetch aggregated fields from the table: "billing_account_transaction" */
  billing_account_transaction_aggregate: Billing_Account_Transaction_Aggregate
  /** fetch data from the table: "billing_account_transaction" using primary key columns */
  billing_account_transaction_by_pk?: Maybe<Billing_Account_Transaction>
  /** fetch data from the table in a streaming manner: "billing_account_transaction" */
  billing_account_transaction_stream: Array<Billing_Account_Transaction>
  /** fetch data from the table: "billing_period" */
  billing_period: Array<Billing_Period>
  /** fetch aggregated fields from the table: "billing_period" */
  billing_period_aggregate: Billing_Period_Aggregate
  /** fetch data from the table: "billing_period" using primary key columns */
  billing_period_by_pk?: Maybe<Billing_Period>
  /** fetch data from the table in a streaming manner: "billing_period" */
  billing_period_stream: Array<Billing_Period>
  /** An array relationship */
  calculation_items: Array<Calculation_Items>
  /** An aggregate relationship */
  calculation_items_aggregate: Calculation_Items_Aggregate
  /** fetch data from the table: "calculation_items" using primary key columns */
  calculation_items_by_pk?: Maybe<Calculation_Items>
  /** fetch data from the table in a streaming manner: "calculation_items" */
  calculation_items_stream: Array<Calculation_Items>
  /** fetch data from the table: "call_trace_audit" */
  call_trace_audit: Array<Call_Trace_Audit>
  /** fetch aggregated fields from the table: "call_trace_audit" */
  call_trace_audit_aggregate: Call_Trace_Audit_Aggregate
  /** fetch data from the table: "call_trace_audit" using primary key columns */
  call_trace_audit_by_pk?: Maybe<Call_Trace_Audit>
  /** fetch data from the table in a streaming manner: "call_trace_audit" */
  call_trace_audit_stream: Array<Call_Trace_Audit>
  /** fetch data from the table: "cancellation_reasons" */
  cancellation_reasons: Array<Cancellation_Reasons>
  /** fetch aggregated fields from the table: "cancellation_reasons" */
  cancellation_reasons_aggregate: Cancellation_Reasons_Aggregate
  /** fetch data from the table in a streaming manner: "cancellation_reasons" */
  cancellation_reasons_stream: Array<Cancellation_Reasons>
  /** An array relationship */
  cancellations: Array<Cancellations>
  /** An aggregate relationship */
  cancellations_aggregate: Cancellations_Aggregate
  /** fetch data from the table: "cancellations" using primary key columns */
  cancellations_by_pk?: Maybe<Cancellations>
  /** fetch data from the table in a streaming manner: "cancellations" */
  cancellations_stream: Array<Cancellations>
  /** fetch data from the table: "card_payment" */
  card_payment: Array<Card_Payment>
  /** fetch aggregated fields from the table: "card_payment" */
  card_payment_aggregate: Card_Payment_Aggregate
  /** fetch data from the table: "card_payment" using primary key columns */
  card_payment_by_pk?: Maybe<Card_Payment>
  /** fetch data from the table: "card_payment_old" */
  card_payment_old: Array<Card_Payment_Old>
  /** fetch aggregated fields from the table: "card_payment_old" */
  card_payment_old_aggregate: Card_Payment_Old_Aggregate
  /** fetch data from the table: "card_payment_old" using primary key columns */
  card_payment_old_by_pk?: Maybe<Card_Payment_Old>
  /** fetch data from the table in a streaming manner: "card_payment_old" */
  card_payment_old_stream: Array<Card_Payment_Old>
  /** fetch data from the table in a streaming manner: "card_payment" */
  card_payment_stream: Array<Card_Payment>
  /** fetch data from the table: "cases" */
  cases: Array<Cases>
  /** fetch aggregated fields from the table: "cases" */
  cases_aggregate: Cases_Aggregate
  /** fetch data from the table: "cases" using primary key columns */
  cases_by_pk?: Maybe<Cases>
  /** fetch data from the table in a streaming manner: "cases" */
  cases_stream: Array<Cases>
  /** fetch data from the table: "communication" */
  communication: Array<Communication>
  /** fetch aggregated fields from the table: "communication" */
  communication_aggregate: Communication_Aggregate
  /** fetch data from the table: "communication" using primary key columns */
  communication_by_pk?: Maybe<Communication>
  /** fetch data from the table: "communication_metadata" */
  communication_metadata: Array<Communication_Metadata>
  /** fetch aggregated fields from the table: "communication_metadata" */
  communication_metadata_aggregate: Communication_Metadata_Aggregate
  /** fetch data from the table: "communication_metadata" using primary key columns */
  communication_metadata_by_pk?: Maybe<Communication_Metadata>
  /** fetch data from the table in a streaming manner: "communication_metadata" */
  communication_metadata_stream: Array<Communication_Metadata>
  /** fetch data from the table in a streaming manner: "communication" */
  communication_stream: Array<Communication>
  /** fetch data from the table: "communications" */
  communications: Array<Communications>
  /** fetch aggregated fields from the table: "communications" */
  communications_aggregate: Communications_Aggregate
  /** fetch data from the table: "communications" using primary key columns */
  communications_by_pk?: Maybe<Communications>
  /** fetch data from the table in a streaming manner: "communications" */
  communications_stream: Array<Communications>
  /** fetch data from the table: "complaint" */
  complaint: Array<Complaint>
  /** fetch aggregated fields from the table: "complaint" */
  complaint_aggregate: Complaint_Aggregate
  /** fetch data from the table: "complaint_aggregations" */
  complaint_aggregations: Array<Complaint_Aggregations>
  /** fetch aggregated fields from the table: "complaint_aggregations" */
  complaint_aggregations_aggregate: Complaint_Aggregations_Aggregate
  /** fetch data from the table in a streaming manner: "complaint_aggregations" */
  complaint_aggregations_stream: Array<Complaint_Aggregations>
  /** fetch data from the table: "complaint" using primary key columns */
  complaint_by_pk?: Maybe<Complaint>
  /** fetch data from the table in a streaming manner: "complaint" */
  complaint_stream: Array<Complaint>
  /** fetch data from the table: "completed_sync_event_account" */
  completed_sync_event_account: Array<Completed_Sync_Event_Account>
  /** fetch aggregated fields from the table: "completed_sync_event_account" */
  completed_sync_event_account_aggregate: Completed_Sync_Event_Account_Aggregate
  /** fetch data from the table: "completed_sync_event_account" using primary key columns */
  completed_sync_event_account_by_pk?: Maybe<Completed_Sync_Event_Account>
  /** fetch data from the table in a streaming manner: "completed_sync_event_account" */
  completed_sync_event_account_stream: Array<Completed_Sync_Event_Account>
  /** fetch data from the table: "configuration" */
  configuration: Array<Configuration>
  /** fetch aggregated fields from the table: "configuration" */
  configuration_aggregate: Configuration_Aggregate
  /** fetch data from the table: "configuration" using primary key columns */
  configuration_by_pk?: Maybe<Configuration>
  /** fetch data from the table in a streaming manner: "configuration" */
  configuration_stream: Array<Configuration>
  /** fetch data from the table: "contact" */
  contact: Array<Contact>
  /** fetch aggregated fields from the table: "contact" */
  contact_aggregate: Contact_Aggregate
  /** fetch data from the table: "contact" using primary key columns */
  contact_by_pk?: Maybe<Contact>
  /** fetch data from the table in a streaming manner: "contact" */
  contact_stream: Array<Contact>
  /** fetch data from the table: "cs__soe_dashboard_total" */
  cs__soe_dashboard_total: Array<Cs__Soe_Dashboard_Total>
  /** fetch aggregated fields from the table: "cs__soe_dashboard_total" */
  cs__soe_dashboard_total_aggregate: Cs__Soe_Dashboard_Total_Aggregate
  /** fetch data from the table: "cs__soe_dashboard_total" using primary key columns */
  cs__soe_dashboard_total_by_pk?: Maybe<Cs__Soe_Dashboard_Total>
  /** fetch data from the table in a streaming manner: "cs__soe_dashboard_total" */
  cs__soe_dashboard_total_stream: Array<Cs__Soe_Dashboard_Total>
  /** fetch data from the table: "current_future_product_details" */
  current_future_product_details: Array<Current_Future_Product_Details>
  /** fetch aggregated fields from the table: "current_future_product_details" */
  current_future_product_details_aggregate: Current_Future_Product_Details_Aggregate
  /** fetch data from the table in a streaming manner: "current_future_product_details" */
  current_future_product_details_stream: Array<Current_Future_Product_Details>
  /** fetch data from the table: "customer" */
  customer: Array<Customer>
  /** fetch data from the table: "address" */
  customer_address: Array<Customer_Address>
  /** fetch aggregated fields from the table: "address" */
  customer_address_aggregate: Customer_Address_Aggregate
  /** fetch data from the table: "address" using primary key columns */
  customer_address_by_pk?: Maybe<Customer_Address>
  /** fetch data from the table in a streaming manner: "address" */
  customer_address_stream: Array<Customer_Address>
  /** fetch aggregated fields from the table: "customer" */
  customer_aggregate: Customer_Aggregate
  /** fetch data from the table: "customer" using primary key columns */
  customer_by_pk?: Maybe<Customer>
  /** fetch data from the table: "customer_contact" */
  customer_contact: Array<Customer_Contact>
  /** fetch aggregated fields from the table: "customer_contact" */
  customer_contact_aggregate: Customer_Contact_Aggregate
  /** fetch data from the table: "customer_contact" using primary key columns */
  customer_contact_by_pk?: Maybe<Customer_Contact>
  /** fetch data from the table in a streaming manner: "customer_contact" */
  customer_contact_stream: Array<Customer_Contact>
  /** fetch data from the table: "customer_metadata" */
  customer_metadata: Array<Customer_Metadata>
  /** fetch aggregated fields from the table: "customer_metadata" */
  customer_metadata_aggregate: Customer_Metadata_Aggregate
  /** fetch data from the table: "customer_metadata" using primary key columns */
  customer_metadata_by_pk?: Maybe<Customer_Metadata>
  /** fetch data from the table in a streaming manner: "customer_metadata" */
  customer_metadata_stream: Array<Customer_Metadata>
  /** fetch data from the table: "customer_property_rel" */
  customer_property_rel: Array<Customer_Property_Rel>
  /** fetch aggregated fields from the table: "customer_property_rel" */
  customer_property_rel_aggregate: Customer_Property_Rel_Aggregate
  /** fetch data from the table: "customer_property_rel" using primary key columns */
  customer_property_rel_by_pk?: Maybe<Customer_Property_Rel>
  /** fetch data from the table in a streaming manner: "customer_property_rel" */
  customer_property_rel_stream: Array<Customer_Property_Rel>
  /** fetch data from the table: "customer_psr_rel" */
  customer_psr_rel: Array<Customer_Psr_Rel>
  /** fetch aggregated fields from the table: "customer_psr_rel" */
  customer_psr_rel_aggregate: Customer_Psr_Rel_Aggregate
  /** fetch data from the table: "customer_psr_rel" using primary key columns */
  customer_psr_rel_by_pk?: Maybe<Customer_Psr_Rel>
  /** fetch data from the table in a streaming manner: "customer_psr_rel" */
  customer_psr_rel_stream: Array<Customer_Psr_Rel>
  /** An array relationship */
  customer_referrals: Array<Customer_Referrals>
  /** An aggregate relationship */
  customer_referrals_aggregate: Customer_Referrals_Aggregate
  /** fetch data from the table: "customer_referrals" using primary key columns */
  customer_referrals_by_pk?: Maybe<Customer_Referrals>
  /** fetch data from the table in a streaming manner: "customer_referrals" */
  customer_referrals_stream: Array<Customer_Referrals>
  /** fetch data from the table: "customer_setting" */
  customer_setting: Array<Customer_Setting>
  /** fetch aggregated fields from the table: "customer_setting" */
  customer_setting_aggregate: Customer_Setting_Aggregate
  /** fetch data from the table: "customer_setting" using primary key columns */
  customer_setting_by_pk?: Maybe<Customer_Setting>
  /** fetch data from the table in a streaming manner: "customer_setting" */
  customer_setting_stream: Array<Customer_Setting>
  /** fetch data from the table in a streaming manner: "customer" */
  customer_stream: Array<Customer>
  /** fetch data from the table: "customer_user_rel" */
  customer_user_rel: Array<Customer_User_Rel>
  /** fetch aggregated fields from the table: "customer_user_rel" */
  customer_user_rel_aggregate: Customer_User_Rel_Aggregate
  /** fetch data from the table: "customer_user_rel" using primary key columns */
  customer_user_rel_by_pk?: Maybe<Customer_User_Rel>
  /** fetch data from the table in a streaming manner: "customer_user_rel" */
  customer_user_rel_stream: Array<Customer_User_Rel>
  /** fetch data from the table: "dashboard_complete_view_v2" */
  dashboard_complete_view_v2: Array<Dashboard_Complete_View_V2>
  /** fetch aggregated fields from the table: "dashboard_complete_view_v2" */
  dashboard_complete_view_v2_aggregate: Dashboard_Complete_View_V2_Aggregate
  /** fetch data from the table in a streaming manner: "dashboard_complete_view_v2" */
  dashboard_complete_view_v2_stream: Array<Dashboard_Complete_View_V2>
  /** fetch data from the table: "deprecated_solar_quote_requests" */
  deprecated_solar_quote_requests: Array<Deprecated_Solar_Quote_Requests>
  /** fetch aggregated fields from the table: "deprecated_solar_quote_requests" */
  deprecated_solar_quote_requests_aggregate: Deprecated_Solar_Quote_Requests_Aggregate
  /** fetch data from the table: "deprecated_solar_quote_requests" using primary key columns */
  deprecated_solar_quote_requests_by_pk?: Maybe<Deprecated_Solar_Quote_Requests>
  /** fetch data from the table in a streaming manner: "deprecated_solar_quote_requests" */
  deprecated_solar_quote_requests_stream: Array<Deprecated_Solar_Quote_Requests>
  /** fetch data from the table: "direct_debit" */
  direct_debit: Array<Direct_Debit>
  /** fetch aggregated fields from the table: "direct_debit" */
  direct_debit_aggregate: Direct_Debit_Aggregate
  /** fetch data from the table: "direct_debit" using primary key columns */
  direct_debit_by_pk?: Maybe<Direct_Debit>
  /** fetch data from the table: "direct_debit_payment" */
  direct_debit_payment: Array<Direct_Debit_Payment>
  /** fetch aggregated fields from the table: "direct_debit_payment" */
  direct_debit_payment_aggregate: Direct_Debit_Payment_Aggregate
  /** fetch data from the table: "direct_debit_payment" using primary key columns */
  direct_debit_payment_by_pk?: Maybe<Direct_Debit_Payment>
  /** fetch data from the table in a streaming manner: "direct_debit_payment" */
  direct_debit_payment_stream: Array<Direct_Debit_Payment>
  /** fetch data from the table in a streaming manner: "direct_debit" */
  direct_debit_stream: Array<Direct_Debit>
  /** fetch data from the table: "email_messages" */
  email_messages: Array<Email_Messages>
  /** fetch aggregated fields from the table: "email_messages" */
  email_messages_aggregate: Email_Messages_Aggregate
  /** fetch data from the table: "email_messages" using primary key columns */
  email_messages_by_pk?: Maybe<Email_Messages>
  /** fetch data from the table in a streaming manner: "email_messages" */
  email_messages_stream: Array<Email_Messages>
  /** fetch data from the table: "email_templates" */
  email_templates: Array<Email_Templates>
  /** fetch aggregated fields from the table: "email_templates" */
  email_templates_aggregate: Email_Templates_Aggregate
  /** fetch data from the table: "email_templates" using primary key columns */
  email_templates_by_pk?: Maybe<Email_Templates>
  /** fetch data from the table: "email_templates_ext" */
  email_templates_ext: Array<Email_Templates_Ext>
  /** fetch aggregated fields from the table: "email_templates_ext" */
  email_templates_ext_aggregate: Email_Templates_Ext_Aggregate
  /** fetch data from the table: "email_templates_ext" using primary key columns */
  email_templates_ext_by_pk?: Maybe<Email_Templates_Ext>
  /** fetch data from the table in a streaming manner: "email_templates_ext" */
  email_templates_ext_stream: Array<Email_Templates_Ext>
  /** fetch data from the table in a streaming manner: "email_templates" */
  email_templates_stream: Array<Email_Templates>
  /** fetch data from the table: "energy_usage_load_factors" */
  energy_usage_load_factors: Array<Energy_Usage_Load_Factors>
  /** fetch aggregated fields from the table: "energy_usage_load_factors" */
  energy_usage_load_factors_aggregate: Energy_Usage_Load_Factors_Aggregate
  /** fetch data from the table: "energy_usage_load_factors" using primary key columns */
  energy_usage_load_factors_by_pk?: Maybe<Energy_Usage_Load_Factors>
  /** fetch data from the table in a streaming manner: "energy_usage_load_factors" */
  energy_usage_load_factors_stream: Array<Energy_Usage_Load_Factors>
  /** fetch data from the table: "enrolment" */
  enrolment: Array<Enrolment>
  /** fetch aggregated fields from the table: "enrolment" */
  enrolment_aggregate: Enrolment_Aggregate
  /** fetch data from the table: "enrolment_automated_communications" */
  enrolment_automated_communications: Array<Enrolment_Automated_Communications>
  /** fetch aggregated fields from the table: "enrolment_automated_communications" */
  enrolment_automated_communications_aggregate: Enrolment_Automated_Communications_Aggregate
  /** fetch data from the table: "enrolment_automated_communications" using primary key columns */
  enrolment_automated_communications_by_pk?: Maybe<Enrolment_Automated_Communications>
  /** fetch data from the table in a streaming manner: "enrolment_automated_communications" */
  enrolment_automated_communications_stream: Array<Enrolment_Automated_Communications>
  /** fetch data from the table: "enrolment" using primary key columns */
  enrolment_by_pk?: Maybe<Enrolment>
  /** fetch data from the table in a streaming manner: "enrolment" */
  enrolment_stream: Array<Enrolment>
  enrolments_grouped_by_broker: Array<Enrolments_Grouped_By_Broker_Model>
  /** fetch data from the table: "entity_mappings" */
  entity_mappings: Array<Entity_Mappings>
  /** fetch aggregated fields from the table: "entity_mappings" */
  entity_mappings_aggregate: Entity_Mappings_Aggregate
  /** fetch data from the table: "entity_mappings" using primary key columns */
  entity_mappings_by_pk?: Maybe<Entity_Mappings>
  /** fetch data from the table in a streaming manner: "entity_mappings" */
  entity_mappings_stream: Array<Entity_Mappings>
  /** fetch data from the table: "estimated_usage" */
  estimated_usage: Array<Estimated_Usage>
  /** fetch aggregated fields from the table: "estimated_usage" */
  estimated_usage_aggregate: Estimated_Usage_Aggregate
  /** fetch data from the table: "estimated_usage" using primary key columns */
  estimated_usage_by_pk?: Maybe<Estimated_Usage>
  /** fetch data from the table in a streaming manner: "estimated_usage" */
  estimated_usage_stream: Array<Estimated_Usage>
  /** fetch data from the table: "ev_smart_tariff_waitlist" */
  ev_smart_tariff_waitlist: Array<Ev_Smart_Tariff_Waitlist>
  /** fetch aggregated fields from the table: "ev_smart_tariff_waitlist" */
  ev_smart_tariff_waitlist_aggregate: Ev_Smart_Tariff_Waitlist_Aggregate
  /** fetch data from the table: "ev_smart_tariff_waitlist" using primary key columns */
  ev_smart_tariff_waitlist_by_pk?: Maybe<Ev_Smart_Tariff_Waitlist>
  /** fetch data from the table in a streaming manner: "ev_smart_tariff_waitlist" */
  ev_smart_tariff_waitlist_stream: Array<Ev_Smart_Tariff_Waitlist>
  /** fetch data from the table: "ev_tariff_eligibility_checks" */
  ev_tariff_eligibility_checks: Array<Ev_Tariff_Eligibility_Checks>
  /** fetch aggregated fields from the table: "ev_tariff_eligibility_checks" */
  ev_tariff_eligibility_checks_aggregate: Ev_Tariff_Eligibility_Checks_Aggregate
  /** fetch data from the table: "ev_tariff_eligibility_checks" using primary key columns */
  ev_tariff_eligibility_checks_by_pk?: Maybe<Ev_Tariff_Eligibility_Checks>
  /** fetch data from the table in a streaming manner: "ev_tariff_eligibility_checks" */
  ev_tariff_eligibility_checks_stream: Array<Ev_Tariff_Eligibility_Checks>
  /** fetch data from the table: "feature" */
  feature: Array<Feature>
  /** fetch aggregated fields from the table: "feature" */
  feature_aggregate: Feature_Aggregate
  /** fetch data from the table: "feature" using primary key columns */
  feature_by_pk?: Maybe<Feature>
  /** fetch data from the table in a streaming manner: "feature" */
  feature_stream: Array<Feature>
  /** fetch data from the table: "configuration" */
  financials_configuration: Array<Financials_Configuration>
  /** fetch aggregated fields from the table: "configuration" */
  financials_configuration_aggregate: Financials_Configuration_Aggregate
  /** fetch data from the table: "configuration" using primary key columns */
  financials_configuration_by_pk?: Maybe<Financials_Configuration>
  /** fetch data from the table in a streaming manner: "configuration" */
  financials_configuration_stream: Array<Financials_Configuration>
  /** fetch data from the table: "qrtz_blob_triggers" */
  financials_qrtz_blob_triggers: Array<Financials_Qrtz_Blob_Triggers>
  /** fetch aggregated fields from the table: "qrtz_blob_triggers" */
  financials_qrtz_blob_triggers_aggregate: Financials_Qrtz_Blob_Triggers_Aggregate
  /** fetch data from the table: "qrtz_blob_triggers" using primary key columns */
  financials_qrtz_blob_triggers_by_pk?: Maybe<Financials_Qrtz_Blob_Triggers>
  /** fetch data from the table in a streaming manner: "qrtz_blob_triggers" */
  financials_qrtz_blob_triggers_stream: Array<Financials_Qrtz_Blob_Triggers>
  /** fetch data from the table: "qrtz_calendars" */
  financials_qrtz_calendars: Array<Financials_Qrtz_Calendars>
  /** fetch aggregated fields from the table: "qrtz_calendars" */
  financials_qrtz_calendars_aggregate: Financials_Qrtz_Calendars_Aggregate
  /** fetch data from the table: "qrtz_calendars" using primary key columns */
  financials_qrtz_calendars_by_pk?: Maybe<Financials_Qrtz_Calendars>
  /** fetch data from the table in a streaming manner: "qrtz_calendars" */
  financials_qrtz_calendars_stream: Array<Financials_Qrtz_Calendars>
  /** fetch data from the table: "qrtz_cron_triggers" */
  financials_qrtz_cron_triggers: Array<Financials_Qrtz_Cron_Triggers>
  /** fetch aggregated fields from the table: "qrtz_cron_triggers" */
  financials_qrtz_cron_triggers_aggregate: Financials_Qrtz_Cron_Triggers_Aggregate
  /** fetch data from the table: "qrtz_cron_triggers" using primary key columns */
  financials_qrtz_cron_triggers_by_pk?: Maybe<Financials_Qrtz_Cron_Triggers>
  /** fetch data from the table in a streaming manner: "qrtz_cron_triggers" */
  financials_qrtz_cron_triggers_stream: Array<Financials_Qrtz_Cron_Triggers>
  /** fetch data from the table: "qrtz_fired_triggers" */
  financials_qrtz_fired_triggers: Array<Financials_Qrtz_Fired_Triggers>
  /** fetch aggregated fields from the table: "qrtz_fired_triggers" */
  financials_qrtz_fired_triggers_aggregate: Financials_Qrtz_Fired_Triggers_Aggregate
  /** fetch data from the table: "qrtz_fired_triggers" using primary key columns */
  financials_qrtz_fired_triggers_by_pk?: Maybe<Financials_Qrtz_Fired_Triggers>
  /** fetch data from the table in a streaming manner: "qrtz_fired_triggers" */
  financials_qrtz_fired_triggers_stream: Array<Financials_Qrtz_Fired_Triggers>
  /** fetch data from the table: "qrtz_job_details" */
  financials_qrtz_job_details: Array<Financials_Qrtz_Job_Details>
  /** fetch aggregated fields from the table: "qrtz_job_details" */
  financials_qrtz_job_details_aggregate: Financials_Qrtz_Job_Details_Aggregate
  /** fetch data from the table: "qrtz_job_details" using primary key columns */
  financials_qrtz_job_details_by_pk?: Maybe<Financials_Qrtz_Job_Details>
  /** fetch data from the table in a streaming manner: "qrtz_job_details" */
  financials_qrtz_job_details_stream: Array<Financials_Qrtz_Job_Details>
  /** fetch data from the table: "qrtz_scheduler_state" */
  financials_qrtz_scheduler_state: Array<Financials_Qrtz_Scheduler_State>
  /** fetch aggregated fields from the table: "qrtz_scheduler_state" */
  financials_qrtz_scheduler_state_aggregate: Financials_Qrtz_Scheduler_State_Aggregate
  /** fetch data from the table: "qrtz_scheduler_state" using primary key columns */
  financials_qrtz_scheduler_state_by_pk?: Maybe<Financials_Qrtz_Scheduler_State>
  /** fetch data from the table in a streaming manner: "qrtz_scheduler_state" */
  financials_qrtz_scheduler_state_stream: Array<Financials_Qrtz_Scheduler_State>
  /** fetch data from the table: "qrtz_simple_triggers" */
  financials_qrtz_simple_triggers: Array<Financials_Qrtz_Simple_Triggers>
  /** fetch aggregated fields from the table: "qrtz_simple_triggers" */
  financials_qrtz_simple_triggers_aggregate: Financials_Qrtz_Simple_Triggers_Aggregate
  /** fetch data from the table: "qrtz_simple_triggers" using primary key columns */
  financials_qrtz_simple_triggers_by_pk?: Maybe<Financials_Qrtz_Simple_Triggers>
  /** fetch data from the table in a streaming manner: "qrtz_simple_triggers" */
  financials_qrtz_simple_triggers_stream: Array<Financials_Qrtz_Simple_Triggers>
  /** fetch data from the table: "qrtz_simprop_triggers" */
  financials_qrtz_simprop_triggers: Array<Financials_Qrtz_Simprop_Triggers>
  /** fetch aggregated fields from the table: "qrtz_simprop_triggers" */
  financials_qrtz_simprop_triggers_aggregate: Financials_Qrtz_Simprop_Triggers_Aggregate
  /** fetch data from the table: "qrtz_simprop_triggers" using primary key columns */
  financials_qrtz_simprop_triggers_by_pk?: Maybe<Financials_Qrtz_Simprop_Triggers>
  /** fetch data from the table in a streaming manner: "qrtz_simprop_triggers" */
  financials_qrtz_simprop_triggers_stream: Array<Financials_Qrtz_Simprop_Triggers>
  /** fetch data from the table: "qrtz_triggers" */
  financials_qrtz_triggers: Array<Financials_Qrtz_Triggers>
  /** fetch aggregated fields from the table: "qrtz_triggers" */
  financials_qrtz_triggers_aggregate: Financials_Qrtz_Triggers_Aggregate
  /** fetch data from the table: "qrtz_triggers" using primary key columns */
  financials_qrtz_triggers_by_pk?: Maybe<Financials_Qrtz_Triggers>
  /** fetch data from the table in a streaming manner: "qrtz_triggers" */
  financials_qrtz_triggers_stream: Array<Financials_Qrtz_Triggers>
  /** fetch data from the table: "warrant_account_criteria" */
  financials_warrant_account_criteria: Array<Financials_Warrant_Account_Criteria>
  /** fetch aggregated fields from the table: "warrant_account_criteria" */
  financials_warrant_account_criteria_aggregate: Financials_Warrant_Account_Criteria_Aggregate
  /** fetch data from the table: "warrant_account_criteria" using primary key columns */
  financials_warrant_account_criteria_by_pk?: Maybe<Financials_Warrant_Account_Criteria>
  /** fetch data from the table in a streaming manner: "warrant_account_criteria" */
  financials_warrant_account_criteria_stream: Array<Financials_Warrant_Account_Criteria>
  /** fetch data from the table: "warrant_account_sync_criteria" */
  financials_warrant_account_sync_criteria: Array<Financials_Warrant_Account_Sync_Criteria>
  /** fetch aggregated fields from the table: "warrant_account_sync_criteria" */
  financials_warrant_account_sync_criteria_aggregate: Financials_Warrant_Account_Sync_Criteria_Aggregate
  /** fetch data from the table: "warrant_account_sync_criteria" using primary key columns */
  financials_warrant_account_sync_criteria_by_pk?: Maybe<Financials_Warrant_Account_Sync_Criteria>
  /** fetch data from the table in a streaming manner: "warrant_account_sync_criteria" */
  financials_warrant_account_sync_criteria_stream: Array<Financials_Warrant_Account_Sync_Criteria>
  /** fetch data from the table: "warrant_communications_sent_count" */
  financials_warrant_communications_sent_count: Array<Financials_Warrant_Communications_Sent_Count>
  /** fetch aggregated fields from the table: "warrant_communications_sent_count" */
  financials_warrant_communications_sent_count_aggregate: Financials_Warrant_Communications_Sent_Count_Aggregate
  /** fetch data from the table: "warrant_communications_sent_count" using primary key columns */
  financials_warrant_communications_sent_count_by_pk?: Maybe<Financials_Warrant_Communications_Sent_Count>
  /** fetch data from the table in a streaming manner: "warrant_communications_sent_count" */
  financials_warrant_communications_sent_count_stream: Array<Financials_Warrant_Communications_Sent_Count>
  /** fetch data from the table: "warrants_accounts" */
  financials_warrants_accounts: Array<Financials_Warrants_Accounts>
  /** fetch aggregated fields from the table: "warrants_accounts" */
  financials_warrants_accounts_aggregate: Financials_Warrants_Accounts_Aggregate
  /** fetch data from the table: "warrants_accounts" using primary key columns */
  financials_warrants_accounts_by_pk?: Maybe<Financials_Warrants_Accounts>
  /** fetch data from the table: "warrants_accounts_history" */
  financials_warrants_accounts_history: Array<Financials_Warrants_Accounts_History>
  /** fetch aggregated fields from the table: "warrants_accounts_history" */
  financials_warrants_accounts_history_aggregate: Financials_Warrants_Accounts_History_Aggregate
  /** fetch data from the table: "warrants_accounts_history" using primary key columns */
  financials_warrants_accounts_history_by_pk?: Maybe<Financials_Warrants_Accounts_History>
  /** fetch data from the table in a streaming manner: "warrants_accounts_history" */
  financials_warrants_accounts_history_stream: Array<Financials_Warrants_Accounts_History>
  /** fetch data from the table in a streaming manner: "warrants_accounts" */
  financials_warrants_accounts_stream: Array<Financials_Warrants_Accounts>
  /** fetch data from the table: "warrants_accounts_whitelist" */
  financials_warrants_accounts_whitelist: Array<Financials_Warrants_Accounts_Whitelist>
  /** fetch aggregated fields from the table: "warrants_accounts_whitelist" */
  financials_warrants_accounts_whitelist_aggregate: Financials_Warrants_Accounts_Whitelist_Aggregate
  /** fetch data from the table: "warrants_accounts_whitelist" using primary key columns */
  financials_warrants_accounts_whitelist_by_pk?: Maybe<Financials_Warrants_Accounts_Whitelist>
  /** fetch data from the table in a streaming manner: "warrants_accounts_whitelist" */
  financials_warrants_accounts_whitelist_stream: Array<Financials_Warrants_Accounts_Whitelist>
  /** fetch data from the table: "warrants_communication_group" */
  financials_warrants_communication_group: Array<Financials_Warrants_Communication_Group>
  /** fetch aggregated fields from the table: "warrants_communication_group" */
  financials_warrants_communication_group_aggregate: Financials_Warrants_Communication_Group_Aggregate
  /** fetch data from the table: "warrants_communication_group" using primary key columns */
  financials_warrants_communication_group_by_pk?: Maybe<Financials_Warrants_Communication_Group>
  /** fetch data from the table in a streaming manner: "warrants_communication_group" */
  financials_warrants_communication_group_stream: Array<Financials_Warrants_Communication_Group>
  /** fetch data from the table: "warrants_communications" */
  financials_warrants_communications: Array<Financials_Warrants_Communications>
  /** fetch aggregated fields from the table: "warrants_communications" */
  financials_warrants_communications_aggregate: Financials_Warrants_Communications_Aggregate
  /** fetch data from the table: "warrants_communications" using primary key columns */
  financials_warrants_communications_by_pk?: Maybe<Financials_Warrants_Communications>
  /** fetch data from the table in a streaming manner: "warrants_communications" */
  financials_warrants_communications_stream: Array<Financials_Warrants_Communications>
  /** fetch data from the table: "warrants_dca_queue" */
  financials_warrants_dca_queue: Array<Financials_Warrants_Dca_Queue>
  /** fetch aggregated fields from the table: "warrants_dca_queue" */
  financials_warrants_dca_queue_aggregate: Financials_Warrants_Dca_Queue_Aggregate
  /** fetch data from the table: "warrants_dca_queue" using primary key columns */
  financials_warrants_dca_queue_by_pk?: Maybe<Financials_Warrants_Dca_Queue>
  /** fetch data from the table in a streaming manner: "warrants_dca_queue" */
  financials_warrants_dca_queue_stream: Array<Financials_Warrants_Dca_Queue>
  /** fetch data from the table: "warrants_dca_tickets" */
  financials_warrants_dca_tickets: Array<Financials_Warrants_Dca_Tickets>
  /** fetch aggregated fields from the table: "warrants_dca_tickets" */
  financials_warrants_dca_tickets_aggregate: Financials_Warrants_Dca_Tickets_Aggregate
  /** fetch data from the table: "warrants_dca_tickets" using primary key columns */
  financials_warrants_dca_tickets_by_pk?: Maybe<Financials_Warrants_Dca_Tickets>
  /** fetch data from the table in a streaming manner: "warrants_dca_tickets" */
  financials_warrants_dca_tickets_stream: Array<Financials_Warrants_Dca_Tickets>
  /** fetch data from the table: "warrants_files_account" */
  financials_warrants_files_account: Array<Financials_Warrants_Files_Account>
  /** fetch aggregated fields from the table: "warrants_files_account" */
  financials_warrants_files_account_aggregate: Financials_Warrants_Files_Account_Aggregate
  /** fetch data from the table: "warrants_files_account" using primary key columns */
  financials_warrants_files_account_by_pk?: Maybe<Financials_Warrants_Files_Account>
  /** fetch data from the table in a streaming manner: "warrants_files_account" */
  financials_warrants_files_account_stream: Array<Financials_Warrants_Files_Account>
  /** fetch data from the table: "warrants_files_job" */
  financials_warrants_files_job: Array<Financials_Warrants_Files_Job>
  /** fetch aggregated fields from the table: "warrants_files_job" */
  financials_warrants_files_job_aggregate: Financials_Warrants_Files_Job_Aggregate
  /** fetch data from the table: "warrants_files_job" using primary key columns */
  financials_warrants_files_job_by_pk?: Maybe<Financials_Warrants_Files_Job>
  /** fetch data from the table in a streaming manner: "warrants_files_job" */
  financials_warrants_files_job_stream: Array<Financials_Warrants_Files_Job>
  /** fetch data from the table: "warrants_files_processed" */
  financials_warrants_files_processed: Array<Financials_Warrants_Files_Processed>
  /** fetch aggregated fields from the table: "warrants_files_processed" */
  financials_warrants_files_processed_aggregate: Financials_Warrants_Files_Processed_Aggregate
  /** fetch data from the table: "warrants_files_processed" using primary key columns */
  financials_warrants_files_processed_by_pk?: Maybe<Financials_Warrants_Files_Processed>
  /** fetch data from the table in a streaming manner: "warrants_files_processed" */
  financials_warrants_files_processed_stream: Array<Financials_Warrants_Files_Processed>
  /** fetch data from the table: "warrants_job" */
  financials_warrants_job: Array<Financials_Warrants_Job>
  /** fetch aggregated fields from the table: "warrants_job" */
  financials_warrants_job_aggregate: Financials_Warrants_Job_Aggregate
  /** fetch data from the table: "warrants_job" using primary key columns */
  financials_warrants_job_by_pk?: Maybe<Financials_Warrants_Job>
  /** fetch data from the table in a streaming manner: "warrants_job" */
  financials_warrants_job_stream: Array<Financials_Warrants_Job>
  /** fetch data from the table: "find_test_accounts" */
  find_test_accounts: Array<Find_Test_Accounts>
  /** fetch aggregated fields from the table: "find_test_accounts" */
  find_test_accounts_aggregate: Find_Test_Accounts_Aggregate
  /** fetch data from the table in a streaming manner: "find_test_accounts" */
  find_test_accounts_stream: Array<Find_Test_Accounts>
  /** fetch data from the table: "flex_market_subscription" */
  flex_market_subscription: Array<Flex_Market_Subscription>
  /** fetch aggregated fields from the table: "flex_market_subscription" */
  flex_market_subscription_aggregate: Flex_Market_Subscription_Aggregate
  /** fetch data from the table: "flex_market_subscription_billing" */
  flex_market_subscription_billing: Array<Flex_Market_Subscription_Billing>
  /** fetch aggregated fields from the table: "flex_market_subscription_billing" */
  flex_market_subscription_billing_aggregate: Flex_Market_Subscription_Billing_Aggregate
  /** fetch data from the table: "flex_market_subscription_billing" using primary key columns */
  flex_market_subscription_billing_by_pk?: Maybe<Flex_Market_Subscription_Billing>
  /** fetch data from the table: "flex_market_subscription_billing_component" */
  flex_market_subscription_billing_component: Array<Flex_Market_Subscription_Billing_Component>
  /** fetch aggregated fields from the table: "flex_market_subscription_billing_component" */
  flex_market_subscription_billing_component_aggregate: Flex_Market_Subscription_Billing_Component_Aggregate
  /** fetch data from the table: "flex_market_subscription_billing_component" using primary key columns */
  flex_market_subscription_billing_component_by_pk?: Maybe<Flex_Market_Subscription_Billing_Component>
  /** fetch data from the table in a streaming manner: "flex_market_subscription_billing_component" */
  flex_market_subscription_billing_component_stream: Array<Flex_Market_Subscription_Billing_Component>
  /** fetch data from the table in a streaming manner: "flex_market_subscription_billing" */
  flex_market_subscription_billing_stream: Array<Flex_Market_Subscription_Billing>
  /** fetch data from the table: "flex_market_subscription" using primary key columns */
  flex_market_subscription_by_pk?: Maybe<Flex_Market_Subscription>
  /** fetch data from the table in a streaming manner: "flex_market_subscription" */
  flex_market_subscription_stream: Array<Flex_Market_Subscription>
  /** fetch data from the table: "flyway_schema_history" */
  flyway_schema_history: Array<Flyway_Schema_History>
  /** fetch aggregated fields from the table: "flyway_schema_history" */
  flyway_schema_history_aggregate: Flyway_Schema_History_Aggregate
  /** fetch data from the table: "flyway_schema_history" using primary key columns */
  flyway_schema_history_by_pk?: Maybe<Flyway_Schema_History>
  /** fetch data from the table in a streaming manner: "flyway_schema_history" */
  flyway_schema_history_stream: Array<Flyway_Schema_History>
  /** fetch data from the table: "freshdesk_contact" */
  freshdesk_contact: Array<Freshdesk_Contact>
  /** fetch aggregated fields from the table: "freshdesk_contact" */
  freshdesk_contact_aggregate: Freshdesk_Contact_Aggregate
  /** fetch data from the table in a streaming manner: "freshdesk_contact" */
  freshdesk_contact_stream: Array<Freshdesk_Contact>
  /** fetch data from the table: "freshdesk_ticket" */
  freshdesk_ticket: Array<Freshdesk_Ticket>
  /** fetch aggregated fields from the table: "freshdesk_ticket" */
  freshdesk_ticket_aggregate: Freshdesk_Ticket_Aggregate
  /** fetch data from the table in a streaming manner: "freshdesk_ticket" */
  freshdesk_ticket_stream: Array<Freshdesk_Ticket>
  /** execute function "function_get_smart_meter_dashboard_data_from_view_v8" which returns "smart_meter_dashboard_response_v7" */
  function_get_smart_meter_dashboard_data_from_view_v8: Array<Smart_Meter_Dashboard_Response_V7>
  /** execute function "function_get_smart_meter_dashboard_data_from_view_v8" and query aggregates on result of table type "smart_meter_dashboard_response_v7" */
  function_get_smart_meter_dashboard_data_from_view_v8_aggregate: Smart_Meter_Dashboard_Response_V7_Aggregate
  /** fetch data from the table: "install_codes" */
  install_codes: Array<Install_Codes>
  /** fetch aggregated fields from the table: "install_codes" */
  install_codes_aggregate: Install_Codes_Aggregate
  /** fetch data from the table: "install_codes" using primary key columns */
  install_codes_by_pk?: Maybe<Install_Codes>
  /** fetch data from the table in a streaming manner: "install_codes" */
  install_codes_stream: Array<Install_Codes>
  /** fetch data from the table: "junifer__Account" */
  junifer__Account: Array<Junifer__Account>
  /** fetch data from the table: "junifer__AccountTransaction" */
  junifer__AccountTransaction: Array<Junifer__AccountTransaction>
  /** fetch aggregated fields from the table: "junifer__AccountTransaction" */
  junifer__AccountTransaction_aggregate: Junifer__AccountTransaction_Aggregate
  /** fetch data from the table: "junifer__AccountTransaction" using primary key columns */
  junifer__AccountTransaction_by_pk?: Maybe<Junifer__AccountTransaction>
  /** fetch data from the table in a streaming manner: "junifer__AccountTransaction" */
  junifer__AccountTransaction_stream: Array<Junifer__AccountTransaction>
  /** fetch aggregated fields from the table: "junifer__Account" */
  junifer__Account_aggregate: Junifer__Account_Aggregate
  /** fetch data from the table: "junifer__Account" using primary key columns */
  junifer__Account_by_pk?: Maybe<Junifer__Account>
  /** fetch data from the table in a streaming manner: "junifer__Account" */
  junifer__Account_stream: Array<Junifer__Account>
  /** fetch data from the table: "junifer__Customer" */
  junifer__Customer: Array<Junifer__Customer>
  /** fetch aggregated fields from the table: "junifer__Customer" */
  junifer__Customer_aggregate: Junifer__Customer_Aggregate
  /** fetch data from the table: "junifer__Customer" using primary key columns */
  junifer__Customer_by_pk?: Maybe<Junifer__Customer>
  /** fetch data from the table in a streaming manner: "junifer__Customer" */
  junifer__Customer_stream: Array<Junifer__Customer>
  /** fetch data from the table: "last_errored_submissions" */
  last_errored_submissions: Array<Last_Errored_Submissions>
  /** fetch aggregated fields from the table: "last_errored_submissions" */
  last_errored_submissions_aggregate: Last_Errored_Submissions_Aggregate
  /** fetch data from the table in a streaming manner: "last_errored_submissions" */
  last_errored_submissions_stream: Array<Last_Errored_Submissions>
  /** fetch data from the table: "meter" */
  meter: Array<Meter>
  /** fetch aggregated fields from the table: "meter" */
  meter_aggregate: Meter_Aggregate
  /** fetch data from the table: "meter" using primary key columns */
  meter_by_pk?: Maybe<Meter>
  /** fetch data from the table: "meter_meter_point_rel" */
  meter_meter_point_rel: Array<Meter_Meter_Point_Rel>
  /** fetch aggregated fields from the table: "meter_meter_point_rel" */
  meter_meter_point_rel_aggregate: Meter_Meter_Point_Rel_Aggregate
  /** fetch data from the table: "meter_meter_point_rel" using primary key columns */
  meter_meter_point_rel_by_pk?: Maybe<Meter_Meter_Point_Rel>
  /** fetch data from the table in a streaming manner: "meter_meter_point_rel" */
  meter_meter_point_rel_stream: Array<Meter_Meter_Point_Rel>
  /** fetch data from the table: "meter_point" */
  meter_point: Array<Meter_Point>
  /** fetch aggregated fields from the table: "meter_point" */
  meter_point_aggregate: Meter_Point_Aggregate
  /** fetch data from the table: "meter_point" using primary key columns */
  meter_point_by_pk?: Maybe<Meter_Point>
  /** fetch data from the table: "meter_point_electricity" */
  meter_point_electricity: Array<Meter_Point_Electricity>
  /** fetch aggregated fields from the table: "meter_point_electricity" */
  meter_point_electricity_aggregate: Meter_Point_Electricity_Aggregate
  /** fetch data from the table: "meter_point_electricity" using primary key columns */
  meter_point_electricity_by_pk?: Maybe<Meter_Point_Electricity>
  /** fetch data from the table in a streaming manner: "meter_point_electricity" */
  meter_point_electricity_stream: Array<Meter_Point_Electricity>
  /** fetch data from the table: "meter_point_gas" */
  meter_point_gas: Array<Meter_Point_Gas>
  /** fetch aggregated fields from the table: "meter_point_gas" */
  meter_point_gas_aggregate: Meter_Point_Gas_Aggregate
  /** fetch data from the table: "meter_point_gas" using primary key columns */
  meter_point_gas_by_pk?: Maybe<Meter_Point_Gas>
  /** fetch data from the table in a streaming manner: "meter_point_gas" */
  meter_point_gas_stream: Array<Meter_Point_Gas>
  /** fetch data from the table: "meter_point_history" */
  meter_point_history: Array<Meter_Point_History>
  /** fetch aggregated fields from the table: "meter_point_history" */
  meter_point_history_aggregate: Meter_Point_History_Aggregate
  /** fetch data from the table: "meter_point_history" using primary key columns */
  meter_point_history_by_pk?: Maybe<Meter_Point_History>
  /** fetch data from the table in a streaming manner: "meter_point_history" */
  meter_point_history_stream: Array<Meter_Point_History>
  /** fetch data from the table in a streaming manner: "meter_point" */
  meter_point_stream: Array<Meter_Point>
  /** fetch data from the table: "meter_reading" */
  meter_reading: Array<Meter_Reading>
  /** fetch aggregated fields from the table: "meter_reading" */
  meter_reading_aggregate: Meter_Reading_Aggregate
  /** fetch data from the table: "meter_reading" using primary key columns */
  meter_reading_by_pk?: Maybe<Meter_Reading>
  /** fetch data from the table in a streaming manner: "meter_reading" */
  meter_reading_stream: Array<Meter_Reading>
  /** fetch data from the table: "meter_reading_submission_request" */
  meter_reading_submission_request: Array<Meter_Reading_Submission_Request>
  /** fetch aggregated fields from the table: "meter_reading_submission_request" */
  meter_reading_submission_request_aggregate: Meter_Reading_Submission_Request_Aggregate
  /** fetch data from the table: "meter_reading_submission_request" using primary key columns */
  meter_reading_submission_request_by_pk?: Maybe<Meter_Reading_Submission_Request>
  /** fetch data from the table in a streaming manner: "meter_reading_submission_request" */
  meter_reading_submission_request_stream: Array<Meter_Reading_Submission_Request>
  /** fetch data from the table: "meter_reading_submission_tokens" */
  meter_reading_submission_tokens: Array<Meter_Reading_Submission_Tokens>
  /** fetch aggregated fields from the table: "meter_reading_submission_tokens" */
  meter_reading_submission_tokens_aggregate: Meter_Reading_Submission_Tokens_Aggregate
  /** fetch data from the table: "meter_reading_submission_tokens" using primary key columns */
  meter_reading_submission_tokens_by_pk?: Maybe<Meter_Reading_Submission_Tokens>
  /** fetch data from the table in a streaming manner: "meter_reading_submission_tokens" */
  meter_reading_submission_tokens_stream: Array<Meter_Reading_Submission_Tokens>
  /** fetch data from the table in a streaming manner: "meter" */
  meter_stream: Array<Meter>
  missing_contact_details: Array<Missing_Contact_Details_Model>
  /** fetch data from the table: "note" */
  note: Array<Note>
  /** fetch aggregated fields from the table: "note" */
  note_aggregate: Note_Aggregate
  /** fetch data from the table: "note" using primary key columns */
  note_by_pk?: Maybe<Note>
  /** fetch data from the table in a streaming manner: "note" */
  note_stream: Array<Note>
  /** fetch data from the table: "nova_submissions" */
  nova_submissions: Array<Nova_Submissions>
  /** fetch aggregated fields from the table: "nova_submissions" */
  nova_submissions_aggregate: Nova_Submissions_Aggregate
  /** fetch data from the table in a streaming manner: "nova_submissions" */
  nova_submissions_stream: Array<Nova_Submissions>
  /** fetch data from the table: "outbound_photo_request" */
  outbound_photo_request: Array<Outbound_Photo_Request>
  /** fetch aggregated fields from the table: "outbound_photo_request" */
  outbound_photo_request_aggregate: Outbound_Photo_Request_Aggregate
  /** fetch data from the table: "outbound_photo_request" using primary key columns */
  outbound_photo_request_by_pk?: Maybe<Outbound_Photo_Request>
  /** fetch data from the table in a streaming manner: "outbound_photo_request" */
  outbound_photo_request_stream: Array<Outbound_Photo_Request>
  /** An array relationship */
  password_reset_tokens: Array<Password_Reset_Tokens>
  /** An aggregate relationship */
  password_reset_tokens_aggregate: Password_Reset_Tokens_Aggregate
  /** fetch data from the table: "password_reset_tokens" using primary key columns */
  password_reset_tokens_by_pk?: Maybe<Password_Reset_Tokens>
  /** fetch data from the table in a streaming manner: "password_reset_tokens" */
  password_reset_tokens_stream: Array<Password_Reset_Tokens>
  /** fetch data from the table: "payment" */
  payment: Array<Payment>
  /** fetch aggregated fields from the table: "payment" */
  payment_aggregate: Payment_Aggregate
  /** fetch data from the table: "payment" using primary key columns */
  payment_by_pk?: Maybe<Payment>
  /** fetch data from the table: "payment_method" */
  payment_method: Array<Payment_Method>
  /** fetch aggregated fields from the table: "payment_method" */
  payment_method_aggregate: Payment_Method_Aggregate
  /** fetch data from the table: "payment_method" using primary key columns */
  payment_method_by_pk?: Maybe<Payment_Method>
  /** fetch data from the table in a streaming manner: "payment_method" */
  payment_method_stream: Array<Payment_Method>
  /** fetch data from the table: "payment_review_account_balance_reserve_rates" */
  payment_review_account_balance_reserve_rates: Array<Payment_Review_Account_Balance_Reserve_Rates>
  /** fetch aggregated fields from the table: "payment_review_account_balance_reserve_rates" */
  payment_review_account_balance_reserve_rates_aggregate: Payment_Review_Account_Balance_Reserve_Rates_Aggregate
  /** fetch data from the table: "payment_review_account_balance_reserve_rates" using primary key columns */
  payment_review_account_balance_reserve_rates_by_pk?: Maybe<Payment_Review_Account_Balance_Reserve_Rates>
  /** fetch data from the table in a streaming manner: "payment_review_account_balance_reserve_rates" */
  payment_review_account_balance_reserve_rates_stream: Array<Payment_Review_Account_Balance_Reserve_Rates>
  /** fetch data from the table: "payment_review_account_exclusions" */
  payment_review_account_exclusions: Array<Payment_Review_Account_Exclusions>
  /** fetch aggregated fields from the table: "payment_review_account_exclusions" */
  payment_review_account_exclusions_aggregate: Payment_Review_Account_Exclusions_Aggregate
  /** fetch data from the table: "payment_review_account_exclusions" using primary key columns */
  payment_review_account_exclusions_by_pk?: Maybe<Payment_Review_Account_Exclusions>
  /** fetch data from the table in a streaming manner: "payment_review_account_exclusions" */
  payment_review_account_exclusions_stream: Array<Payment_Review_Account_Exclusions>
  /** fetch data from the table: "payment_review_calculation" */
  payment_review_calculation: Array<Payment_Review_Calculation>
  /** fetch aggregated fields from the table: "payment_review_calculation" */
  payment_review_calculation_aggregate: Payment_Review_Calculation_Aggregate
  /** fetch data from the table: "payment_review_calculation" using primary key columns */
  payment_review_calculation_by_pk?: Maybe<Payment_Review_Calculation>
  /** fetch data from the table in a streaming manner: "payment_review_calculation" */
  payment_review_calculation_stream: Array<Payment_Review_Calculation>
  payment_review_dashboard_summary: Array<Payment_Review_Dashboard_Summary_Model>
  /** fetch data from the table: "payment_review_future_product_rates" */
  payment_review_future_product_rates: Array<Payment_Review_Future_Product_Rates>
  /** fetch aggregated fields from the table: "payment_review_future_product_rates" */
  payment_review_future_product_rates_aggregate: Payment_Review_Future_Product_Rates_Aggregate
  /** fetch data from the table: "payment_review_future_product_rates" using primary key columns */
  payment_review_future_product_rates_by_pk?: Maybe<Payment_Review_Future_Product_Rates>
  /** fetch data from the table in a streaming manner: "payment_review_future_product_rates" */
  payment_review_future_product_rates_stream: Array<Payment_Review_Future_Product_Rates>
  /** fetch data from the table: "payment_review_record_emails" */
  payment_review_record_emails: Array<Payment_Review_Record_Emails>
  /** fetch aggregated fields from the table: "payment_review_record_emails" */
  payment_review_record_emails_aggregate: Payment_Review_Record_Emails_Aggregate
  /** fetch data from the table: "payment_review_record_emails" using primary key columns */
  payment_review_record_emails_by_pk?: Maybe<Payment_Review_Record_Emails>
  /** fetch data from the table in a streaming manner: "payment_review_record_emails" */
  payment_review_record_emails_stream: Array<Payment_Review_Record_Emails>
  /** fetch data from the table: "payment_review_record_notes" */
  payment_review_record_notes: Array<Payment_Review_Record_Notes>
  /** fetch aggregated fields from the table: "payment_review_record_notes" */
  payment_review_record_notes_aggregate: Payment_Review_Record_Notes_Aggregate
  /** fetch data from the table: "payment_review_record_notes" using primary key columns */
  payment_review_record_notes_by_pk?: Maybe<Payment_Review_Record_Notes>
  /** fetch data from the table in a streaming manner: "payment_review_record_notes" */
  payment_review_record_notes_stream: Array<Payment_Review_Record_Notes>
  /** fetch data from the table: "payment_review_records" */
  payment_review_records: Array<Payment_Review_Records>
  /** fetch aggregated fields from the table: "payment_review_records" */
  payment_review_records_aggregate: Payment_Review_Records_Aggregate
  /** fetch data from the table: "payment_review_records" using primary key columns */
  payment_review_records_by_pk?: Maybe<Payment_Review_Records>
  /** fetch data from the table in a streaming manner: "payment_review_records" */
  payment_review_records_stream: Array<Payment_Review_Records>
  /** fetch data from the table: "payment_review_records_view" */
  payment_review_records_view: Array<Payment_Review_Records_View>
  /** fetch aggregated fields from the table: "payment_review_records_view" */
  payment_review_records_view_aggregate: Payment_Review_Records_View_Aggregate
  /** fetch data from the table in a streaming manner: "payment_review_records_view" */
  payment_review_records_view_stream: Array<Payment_Review_Records_View>
  /** fetch data from the table: "payment_reviews" */
  payment_reviews: Array<Payment_Reviews>
  /** fetch aggregated fields from the table: "payment_reviews" */
  payment_reviews_aggregate: Payment_Reviews_Aggregate
  /** fetch data from the table: "payment_reviews" using primary key columns */
  payment_reviews_by_pk?: Maybe<Payment_Reviews>
  /** fetch data from the table in a streaming manner: "payment_reviews" */
  payment_reviews_stream: Array<Payment_Reviews>
  /** fetch data from the table: "payment_schedule" */
  payment_schedule: Array<Payment_Schedule>
  /** fetch aggregated fields from the table: "payment_schedule" */
  payment_schedule_aggregate: Payment_Schedule_Aggregate
  /** fetch data from the table: "payment_schedule" using primary key columns */
  payment_schedule_by_pk?: Maybe<Payment_Schedule>
  /** fetch data from the table in a streaming manner: "payment_schedule" */
  payment_schedule_stream: Array<Payment_Schedule>
  /** fetch data from the table in a streaming manner: "payment" */
  payment_stream: Array<Payment>
  /** fetch data from the table: "postcode_gsp_cache" */
  postcode_gsp_cache: Array<Postcode_Gsp_Cache>
  /** fetch aggregated fields from the table: "postcode_gsp_cache" */
  postcode_gsp_cache_aggregate: Postcode_Gsp_Cache_Aggregate
  /** fetch data from the table: "postcode_gsp_cache" using primary key columns */
  postcode_gsp_cache_by_pk?: Maybe<Postcode_Gsp_Cache>
  /** fetch data from the table in a streaming manner: "postcode_gsp_cache" */
  postcode_gsp_cache_stream: Array<Postcode_Gsp_Cache>
  /** fetch data from the table: "product" */
  product: Array<Product>
  /** fetch data from the table: "product_account" */
  product_account: Array<Product_Account>
  /** fetch aggregated fields from the table: "product_account" */
  product_account_aggregate: Product_Account_Aggregate
  /** fetch data from the table: "product_account_agreement_rel" */
  product_account_agreement_rel: Array<Product_Account_Agreement_Rel>
  /** fetch aggregated fields from the table: "product_account_agreement_rel" */
  product_account_agreement_rel_aggregate: Product_Account_Agreement_Rel_Aggregate
  /** fetch data from the table: "product_account_agreement_rel" using primary key columns */
  product_account_agreement_rel_by_pk?: Maybe<Product_Account_Agreement_Rel>
  /** fetch data from the table in a streaming manner: "product_account_agreement_rel" */
  product_account_agreement_rel_stream: Array<Product_Account_Agreement_Rel>
  /** fetch data from the table: "product_account" using primary key columns */
  product_account_by_pk?: Maybe<Product_Account>
  /** fetch data from the table in a streaming manner: "product_account" */
  product_account_stream: Array<Product_Account>
  /** fetch aggregated fields from the table: "product" */
  product_aggregate: Product_Aggregate
  /** fetch data from the table: "product" using primary key columns */
  product_by_pk?: Maybe<Product>
  /** fetch data from the table: "product_elec" */
  product_elec: Array<Product_Elec>
  /** fetch aggregated fields from the table: "product_elec" */
  product_elec_aggregate: Product_Elec_Aggregate
  /** fetch data from the table: "product_elec" using primary key columns */
  product_elec_by_pk?: Maybe<Product_Elec>
  /** fetch data from the table in a streaming manner: "product_elec" */
  product_elec_stream: Array<Product_Elec>
  /** fetch data from the table: "product_gas" */
  product_gas: Array<Product_Gas>
  /** fetch aggregated fields from the table: "product_gas" */
  product_gas_aggregate: Product_Gas_Aggregate
  /** fetch data from the table: "product_gas" using primary key columns */
  product_gas_by_pk?: Maybe<Product_Gas>
  /** fetch data from the table in a streaming manner: "product_gas" */
  product_gas_stream: Array<Product_Gas>
  /** fetch data from the table in a streaming manner: "product" */
  product_stream: Array<Product>
  /** fetch data from the table: "product_variant" */
  product_variant: Array<Product_Variant>
  /** fetch aggregated fields from the table: "product_variant" */
  product_variant_aggregate: Product_Variant_Aggregate
  /** fetch data from the table: "product_variant" using primary key columns */
  product_variant_by_pk?: Maybe<Product_Variant>
  /** fetch data from the table: "product_variant_elec" */
  product_variant_elec: Array<Product_Variant_Elec>
  /** fetch aggregated fields from the table: "product_variant_elec" */
  product_variant_elec_aggregate: Product_Variant_Elec_Aggregate
  /** fetch data from the table: "product_variant_elec" using primary key columns */
  product_variant_elec_by_pk?: Maybe<Product_Variant_Elec>
  /** fetch data from the table in a streaming manner: "product_variant_elec" */
  product_variant_elec_stream: Array<Product_Variant_Elec>
  /** An array relationship */
  product_variant_gas: Array<Product_Variant_Gas>
  /** An aggregate relationship */
  product_variant_gas_aggregate: Product_Variant_Gas_Aggregate
  /** fetch data from the table: "product_variant_gas" using primary key columns */
  product_variant_gas_by_pk?: Maybe<Product_Variant_Gas>
  /** fetch data from the table in a streaming manner: "product_variant_gas" */
  product_variant_gas_stream: Array<Product_Variant_Gas>
  /** fetch data from the table in a streaming manner: "product_variant" */
  product_variant_stream: Array<Product_Variant>
  /** fetch data from the table: "product_view" */
  product_view: Array<Product_View>
  /** fetch aggregated fields from the table: "product_view" */
  product_view_aggregate: Product_View_Aggregate
  /** fetch data from the table in a streaming manner: "product_view" */
  product_view_stream: Array<Product_View>
  /** fetch data from the table: "property" */
  property: Array<Property>
  /** fetch aggregated fields from the table: "property" */
  property_aggregate: Property_Aggregate
  /** fetch data from the table: "property" using primary key columns */
  property_by_pk?: Maybe<Property>
  /** fetch data from the table in a streaming manner: "property" */
  property_stream: Array<Property>
  /** fetch data from the table: "psr" */
  psr: Array<Psr>
  /** fetch aggregated fields from the table: "psr" */
  psr_aggregate: Psr_Aggregate
  /** fetch data from the table: "psr" using primary key columns */
  psr_by_pk?: Maybe<Psr>
  /** fetch data from the table in a streaming manner: "psr" */
  psr_stream: Array<Psr>
  /** fetch data from the table: "quote" */
  quote: Array<Quote>
  /** fetch aggregated fields from the table: "quote" */
  quote_aggregate: Quote_Aggregate
  /** fetch data from the table: "quote" using primary key columns */
  quote_by_pk?: Maybe<Quote>
  /** fetch data from the table: "quote_request" */
  quote_request: Array<Quote_Request>
  /** fetch aggregated fields from the table: "quote_request" */
  quote_request_aggregate: Quote_Request_Aggregate
  /** fetch data from the table: "quote_request" using primary key columns */
  quote_request_by_pk?: Maybe<Quote_Request>
  /** fetch data from the table in a streaming manner: "quote_request" */
  quote_request_stream: Array<Quote_Request>
  /** fetch data from the table in a streaming manner: "quote" */
  quote_stream: Array<Quote>
  /** fetch data from the table: "recipients" */
  recipients: Array<Recipients>
  /** fetch aggregated fields from the table: "recipients" */
  recipients_aggregate: Recipients_Aggregate
  /** fetch data from the table: "recipients" using primary key columns */
  recipients_by_pk?: Maybe<Recipients>
  /** fetch data from the table in a streaming manner: "recipients" */
  recipients_stream: Array<Recipients>
  /** An array relationship */
  refresh_tokens: Array<Refresh_Tokens>
  /** An aggregate relationship */
  refresh_tokens_aggregate: Refresh_Tokens_Aggregate
  /** fetch data from the table in a streaming manner: "refresh_tokens" */
  refresh_tokens_stream: Array<Refresh_Tokens>
  /** fetch data from the table: "refunds" */
  refunds: Array<Refunds>
  /** fetch aggregated fields from the table: "refunds" */
  refunds_aggregate: Refunds_Aggregate
  /** fetch data from the table: "refunds" using primary key columns */
  refunds_by_pk?: Maybe<Refunds>
  /** fetch data from the table in a streaming manner: "refunds" */
  refunds_stream: Array<Refunds>
  /** fetch data from the table: "register" */
  register: Array<Register>
  /** fetch aggregated fields from the table: "register" */
  register_aggregate: Register_Aggregate
  /** fetch data from the table: "register" using primary key columns */
  register_by_pk?: Maybe<Register>
  /** fetch data from the table in a streaming manner: "register" */
  register_stream: Array<Register>
  /** fetch data from the table: "registration_credit_check" */
  registration_credit_check: Array<Registration_Credit_Check>
  /** fetch data from the table: "registration_credit_check_address" */
  registration_credit_check_address: Array<Registration_Credit_Check_Address>
  /** fetch aggregated fields from the table: "registration_credit_check_address" */
  registration_credit_check_address_aggregate: Registration_Credit_Check_Address_Aggregate
  /** fetch data from the table: "registration_credit_check_address" using primary key columns */
  registration_credit_check_address_by_pk?: Maybe<Registration_Credit_Check_Address>
  /** fetch data from the table in a streaming manner: "registration_credit_check_address" */
  registration_credit_check_address_stream: Array<Registration_Credit_Check_Address>
  /** fetch aggregated fields from the table: "registration_credit_check" */
  registration_credit_check_aggregate: Registration_Credit_Check_Aggregate
  /** fetch data from the table: "registration_credit_check" using primary key columns */
  registration_credit_check_by_pk?: Maybe<Registration_Credit_Check>
  /** fetch data from the table in a streaming manner: "registration_credit_check" */
  registration_credit_check_stream: Array<Registration_Credit_Check>
  /** fetch data from the table: "reminder" */
  reminder: Array<Reminder>
  /** fetch aggregated fields from the table: "reminder" */
  reminder_aggregate: Reminder_Aggregate
  /** fetch data from the table: "reminder" using primary key columns */
  reminder_by_pk?: Maybe<Reminder>
  /** fetch data from the table in a streaming manner: "reminder" */
  reminder_stream: Array<Reminder>
  /** fetch data from the table: "renewal" */
  renewal: Array<Renewal>
  /** fetch aggregated fields from the table: "renewal" */
  renewal_aggregate: Renewal_Aggregate
  /** fetch data from the table: "renewal" using primary key columns */
  renewal_by_pk?: Maybe<Renewal>
  /** fetch data from the table in a streaming manner: "renewal" */
  renewal_stream: Array<Renewal>
  /** fetch data from the table: "report_problem" */
  report_problem: Array<Report_Problem>
  /** fetch aggregated fields from the table: "report_problem" */
  report_problem_aggregate: Report_Problem_Aggregate
  /** An array relationship */
  report_problem_attachments: Array<Report_Problem_Attachments>
  /** An aggregate relationship */
  report_problem_attachments_aggregate: Report_Problem_Attachments_Aggregate
  /** fetch data from the table: "report_problem_attachments" using primary key columns */
  report_problem_attachments_by_pk?: Maybe<Report_Problem_Attachments>
  /** fetch data from the table in a streaming manner: "report_problem_attachments" */
  report_problem_attachments_stream: Array<Report_Problem_Attachments>
  /** fetch data from the table: "report_problem" using primary key columns */
  report_problem_by_pk?: Maybe<Report_Problem>
  /** fetch data from the table in a streaming manner: "report_problem" */
  report_problem_stream: Array<Report_Problem>
  /** fetch data from the table: "requests" */
  requests: Array<Requests>
  /** fetch aggregated fields from the table: "requests" */
  requests_aggregate: Requests_Aggregate
  /** fetch data from the table: "requests" using primary key columns */
  requests_by_pk?: Maybe<Requests>
  /** fetch data from the table in a streaming manner: "requests" */
  requests_stream: Array<Requests>
  /** fetch data from the table: "rts_meters_report" */
  rts_meters_report: Array<Rts_Meters_Report>
  /** fetch aggregated fields from the table: "rts_meters_report" */
  rts_meters_report_aggregate: Rts_Meters_Report_Aggregate
  /** fetch data from the table in a streaming manner: "rts_meters_report" */
  rts_meters_report_stream: Array<Rts_Meters_Report>
  /** fetch data from the table: "scheduled_payment" */
  scheduled_payment: Array<Scheduled_Payment>
  /** fetch aggregated fields from the table: "scheduled_payment" */
  scheduled_payment_aggregate: Scheduled_Payment_Aggregate
  /** fetch data from the table: "scheduled_payment" using primary key columns */
  scheduled_payment_by_pk?: Maybe<Scheduled_Payment>
  /** fetch data from the table in a streaming manner: "scheduled_payment" */
  scheduled_payment_stream: Array<Scheduled_Payment>
  /** fetch data from the table: "scheduled_refund" */
  scheduled_refund: Array<Scheduled_Refund>
  /** fetch aggregated fields from the table: "scheduled_refund" */
  scheduled_refund_aggregate: Scheduled_Refund_Aggregate
  /** fetch data from the table: "scheduled_refund" using primary key columns */
  scheduled_refund_by_pk?: Maybe<Scheduled_Refund>
  /** fetch data from the table in a streaming manner: "scheduled_refund" */
  scheduled_refund_stream: Array<Scheduled_Refund>
  /** fetch data from the table: "smart_charging" */
  smart_charging: Array<Smart_Charging>
  /** fetch aggregated fields from the table: "smart_charging" */
  smart_charging_aggregate: Smart_Charging_Aggregate
  /** fetch data from the table: "smart_charging" using primary key columns */
  smart_charging_by_pk?: Maybe<Smart_Charging>
  /** fetch data from the table in a streaming manner: "smart_charging" */
  smart_charging_stream: Array<Smart_Charging>
  /** fetch data from the table: "smart_meter_dashboard_response_v7" */
  smart_meter_dashboard_response_v7: Array<Smart_Meter_Dashboard_Response_V7>
  /** fetch aggregated fields from the table: "smart_meter_dashboard_response_v7" */
  smart_meter_dashboard_response_v7_aggregate: Smart_Meter_Dashboard_Response_V7_Aggregate
  /** fetch data from the table in a streaming manner: "smart_meter_dashboard_response_v7" */
  smart_meter_dashboard_response_v7_stream: Array<Smart_Meter_Dashboard_Response_V7>
  smart_meter_dashboard_summary: Array<Smart_Meter_Dashboard_Order_By_Dev_Status_Model>
  smart_meter_dashboard_workstream_summary: Array<Smart_Meter_Dashboard_Order_By_Workstream_Model>
  /** fetch data from the table: "smart_meters_eligible_for_exchange" */
  smart_meters_eligible_for_exchange: Array<Smart_Meters_Eligible_For_Exchange>
  /** fetch aggregated fields from the table: "smart_meters_eligible_for_exchange" */
  smart_meters_eligible_for_exchange_aggregate: Smart_Meters_Eligible_For_Exchange_Aggregate
  /** fetch data from the table: "smart_meters_eligible_for_exchange" using primary key columns */
  smart_meters_eligible_for_exchange_by_pk?: Maybe<Smart_Meters_Eligible_For_Exchange>
  /** fetch data from the table in a streaming manner: "smart_meters_eligible_for_exchange" */
  smart_meters_eligible_for_exchange_stream: Array<Smart_Meters_Eligible_For_Exchange>
  /** fetch data from the table: "sync_status" */
  sync_status: Array<Sync_Status>
  /** fetch aggregated fields from the table: "sync_status" */
  sync_status_aggregate: Sync_Status_Aggregate
  /** fetch data from the table: "sync_status" using primary key columns */
  sync_status_by_pk?: Maybe<Sync_Status>
  /** fetch data from the table in a streaming manner: "sync_status" */
  sync_status_stream: Array<Sync_Status>
  /** fetch data from the table: "synchronized_accounts" */
  synchronized_accounts: Array<Synchronized_Accounts>
  /** fetch aggregated fields from the table: "synchronized_accounts" */
  synchronized_accounts_aggregate: Synchronized_Accounts_Aggregate
  /** fetch data from the table: "synchronized_accounts" using primary key columns */
  synchronized_accounts_by_pk?: Maybe<Synchronized_Accounts>
  /** fetch data from the table in a streaming manner: "synchronized_accounts" */
  synchronized_accounts_stream: Array<Synchronized_Accounts>
  /** fetch data from the table: "ticket" */
  ticket: Array<Ticket>
  /** fetch aggregated fields from the table: "ticket" */
  ticket_aggregate: Ticket_Aggregate
  /** fetch data from the table: "ticket" using primary key columns */
  ticket_by_pk?: Maybe<Ticket>
  /** fetch data from the table in a streaming manner: "ticket" */
  ticket_stream: Array<Ticket>
  /** fetch data from the table: "automation_account_store" */
  tickets_automation_account_store: Array<Tickets_Automation_Account_Store>
  /** fetch aggregated fields from the table: "automation_account_store" */
  tickets_automation_account_store_aggregate: Tickets_Automation_Account_Store_Aggregate
  /** fetch data from the table: "automation_account_store" using primary key columns */
  tickets_automation_account_store_by_pk?: Maybe<Tickets_Automation_Account_Store>
  /** fetch data from the table in a streaming manner: "automation_account_store" */
  tickets_automation_account_store_stream: Array<Tickets_Automation_Account_Store>
  /** fetch data from the table: "automation_config" */
  tickets_automation_config: Array<Tickets_Automation_Config>
  /** fetch aggregated fields from the table: "automation_config" */
  tickets_automation_config_aggregate: Tickets_Automation_Config_Aggregate
  /** fetch data from the table: "automation_config" using primary key columns */
  tickets_automation_config_by_pk?: Maybe<Tickets_Automation_Config>
  /** fetch data from the table: "automation_config_default" */
  tickets_automation_config_default: Array<Tickets_Automation_Config_Default>
  /** fetch aggregated fields from the table: "automation_config_default" */
  tickets_automation_config_default_aggregate: Tickets_Automation_Config_Default_Aggregate
  /** fetch data from the table: "automation_config_default" using primary key columns */
  tickets_automation_config_default_by_pk?: Maybe<Tickets_Automation_Config_Default>
  /** fetch data from the table in a streaming manner: "automation_config_default" */
  tickets_automation_config_default_stream: Array<Tickets_Automation_Config_Default>
  /** fetch data from the table: "automation_config_purge" */
  tickets_automation_config_purge: Array<Tickets_Automation_Config_Purge>
  /** fetch aggregated fields from the table: "automation_config_purge" */
  tickets_automation_config_purge_aggregate: Tickets_Automation_Config_Purge_Aggregate
  /** fetch data from the table: "automation_config_purge" using primary key columns */
  tickets_automation_config_purge_by_pk?: Maybe<Tickets_Automation_Config_Purge>
  /** fetch data from the table in a streaming manner: "automation_config_purge" */
  tickets_automation_config_purge_stream: Array<Tickets_Automation_Config_Purge>
  /** fetch data from the table in a streaming manner: "automation_config" */
  tickets_automation_config_stream: Array<Tickets_Automation_Config>
  /** fetch data from the table: "automation_default_ticket_action" */
  tickets_automation_default_ticket_action: Array<Tickets_Automation_Default_Ticket_Action>
  /** fetch aggregated fields from the table: "automation_default_ticket_action" */
  tickets_automation_default_ticket_action_aggregate: Tickets_Automation_Default_Ticket_Action_Aggregate
  /** fetch data from the table: "automation_default_ticket_action" using primary key columns */
  tickets_automation_default_ticket_action_by_pk?: Maybe<Tickets_Automation_Default_Ticket_Action>
  /** fetch data from the table in a streaming manner: "automation_default_ticket_action" */
  tickets_automation_default_ticket_action_stream: Array<Tickets_Automation_Default_Ticket_Action>
  /** fetch data from the table: "automation_defaults_acceptable_accounts_table" */
  tickets_automation_defaults_acceptable_accounts_table: Array<Tickets_Automation_Defaults_Acceptable_Accounts_Table>
  /** fetch aggregated fields from the table: "automation_defaults_acceptable_accounts_table" */
  tickets_automation_defaults_acceptable_accounts_table_aggregate: Tickets_Automation_Defaults_Acceptable_Accounts_Table_Aggregate
  /** fetch data from the table: "automation_defaults_acceptable_accounts_table" using primary key columns */
  tickets_automation_defaults_acceptable_accounts_table_by_pk?: Maybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table>
  /** fetch data from the table in a streaming manner: "automation_defaults_acceptable_accounts_table" */
  tickets_automation_defaults_acceptable_accounts_table_stream: Array<Tickets_Automation_Defaults_Acceptable_Accounts_Table>
  /** fetch data from the table: "automation_defaults_opened_predefaults" */
  tickets_automation_defaults_opened_predefaults: Array<Tickets_Automation_Defaults_Opened_Predefaults>
  /** fetch aggregated fields from the table: "automation_defaults_opened_predefaults" */
  tickets_automation_defaults_opened_predefaults_aggregate: Tickets_Automation_Defaults_Opened_Predefaults_Aggregate
  /** fetch data from the table: "automation_defaults_opened_predefaults" using primary key columns */
  tickets_automation_defaults_opened_predefaults_by_pk?: Maybe<Tickets_Automation_Defaults_Opened_Predefaults>
  /** fetch data from the table in a streaming manner: "automation_defaults_opened_predefaults" */
  tickets_automation_defaults_opened_predefaults_stream: Array<Tickets_Automation_Defaults_Opened_Predefaults>
  /** fetch data from the table: "automation_job" */
  tickets_automation_job: Array<Tickets_Automation_Job>
  /** fetch aggregated fields from the table: "automation_job" */
  tickets_automation_job_aggregate: Tickets_Automation_Job_Aggregate
  /** fetch data from the table: "automation_job" using primary key columns */
  tickets_automation_job_by_pk?: Maybe<Tickets_Automation_Job>
  /** fetch data from the table in a streaming manner: "automation_job" */
  tickets_automation_job_stream: Array<Tickets_Automation_Job>
  /** fetch data from the table: "automation_purge_job" */
  tickets_automation_purge_job: Array<Tickets_Automation_Purge_Job>
  /** fetch aggregated fields from the table: "automation_purge_job" */
  tickets_automation_purge_job_aggregate: Tickets_Automation_Purge_Job_Aggregate
  /** fetch data from the table: "automation_purge_job" using primary key columns */
  tickets_automation_purge_job_by_pk?: Maybe<Tickets_Automation_Purge_Job>
  /** fetch data from the table in a streaming manner: "automation_purge_job" */
  tickets_automation_purge_job_stream: Array<Tickets_Automation_Purge_Job>
  /** fetch data from the table: "automation_ticket_store" */
  tickets_automation_ticket_store: Array<Tickets_Automation_Ticket_Store>
  /** fetch aggregated fields from the table: "automation_ticket_store" */
  tickets_automation_ticket_store_aggregate: Tickets_Automation_Ticket_Store_Aggregate
  /** fetch data from the table: "automation_ticket_store" using primary key columns */
  tickets_automation_ticket_store_by_pk?: Maybe<Tickets_Automation_Ticket_Store>
  /** fetch data from the table in a streaming manner: "automation_ticket_store" */
  tickets_automation_ticket_store_stream: Array<Tickets_Automation_Ticket_Store>
  /** fetch data from the table: "dca_account_allocation" */
  tickets_dca_account_allocation: Array<Tickets_Dca_Account_Allocation>
  /** fetch aggregated fields from the table: "dca_account_allocation" */
  tickets_dca_account_allocation_aggregate: Tickets_Dca_Account_Allocation_Aggregate
  /** fetch data from the table: "dca_account_allocation" using primary key columns */
  tickets_dca_account_allocation_by_pk?: Maybe<Tickets_Dca_Account_Allocation>
  /** fetch data from the table in a streaming manner: "dca_account_allocation" */
  tickets_dca_account_allocation_stream: Array<Tickets_Dca_Account_Allocation>
  /** fetch data from the table: "dca_allocation_configuration" */
  tickets_dca_allocation_configuration: Array<Tickets_Dca_Allocation_Configuration>
  /** fetch aggregated fields from the table: "dca_allocation_configuration" */
  tickets_dca_allocation_configuration_aggregate: Tickets_Dca_Allocation_Configuration_Aggregate
  /** fetch data from the table: "dca_allocation_configuration" using primary key columns */
  tickets_dca_allocation_configuration_by_pk?: Maybe<Tickets_Dca_Allocation_Configuration>
  /** fetch data from the table in a streaming manner: "dca_allocation_configuration" */
  tickets_dca_allocation_configuration_stream: Array<Tickets_Dca_Allocation_Configuration>
  /** fetch data from the table: "dca_configuration_v2" */
  tickets_dca_configuration_v2: Array<Tickets_Dca_Configuration_V2>
  /** fetch aggregated fields from the table: "dca_configuration_v2" */
  tickets_dca_configuration_v2_aggregate: Tickets_Dca_Configuration_V2_Aggregate
  /** fetch data from the table: "dca_configuration_v2" using primary key columns */
  tickets_dca_configuration_v2_by_pk?: Maybe<Tickets_Dca_Configuration_V2>
  /** fetch data from the table in a streaming manner: "dca_configuration_v2" */
  tickets_dca_configuration_v2_stream: Array<Tickets_Dca_Configuration_V2>
  /** fetch data from the table: "dca_segmentation" */
  tickets_dca_segmentation: Array<Tickets_Dca_Segmentation>
  /** fetch aggregated fields from the table: "dca_segmentation" */
  tickets_dca_segmentation_aggregate: Tickets_Dca_Segmentation_Aggregate
  /** fetch data from the table: "dca_segmentation" using primary key columns */
  tickets_dca_segmentation_by_pk?: Maybe<Tickets_Dca_Segmentation>
  /** fetch data from the table in a streaming manner: "dca_segmentation" */
  tickets_dca_segmentation_stream: Array<Tickets_Dca_Segmentation>
  /** fetch data from the table: "dunning_account_store" */
  tickets_dunning_account_store: Array<Tickets_Dunning_Account_Store>
  /** fetch aggregated fields from the table: "dunning_account_store" */
  tickets_dunning_account_store_aggregate: Tickets_Dunning_Account_Store_Aggregate
  /** fetch data from the table: "dunning_account_store" using primary key columns */
  tickets_dunning_account_store_by_pk?: Maybe<Tickets_Dunning_Account_Store>
  /** fetch data from the table in a streaming manner: "dunning_account_store" */
  tickets_dunning_account_store_stream: Array<Tickets_Dunning_Account_Store>
  /** fetch data from the table: "dunning_addacs_review_records" */
  tickets_dunning_addacs_review_records: Array<Tickets_Dunning_Addacs_Review_Records>
  /** fetch aggregated fields from the table: "dunning_addacs_review_records" */
  tickets_dunning_addacs_review_records_aggregate: Tickets_Dunning_Addacs_Review_Records_Aggregate
  /** fetch data from the table: "dunning_addacs_review_records" using primary key columns */
  tickets_dunning_addacs_review_records_by_pk?: Maybe<Tickets_Dunning_Addacs_Review_Records>
  /** fetch data from the table in a streaming manner: "dunning_addacs_review_records" */
  tickets_dunning_addacs_review_records_stream: Array<Tickets_Dunning_Addacs_Review_Records>
  /** fetch data from the table: "dunning_automation_events" */
  tickets_dunning_automation_events: Array<Tickets_Dunning_Automation_Events>
  /** fetch aggregated fields from the table: "dunning_automation_events" */
  tickets_dunning_automation_events_aggregate: Tickets_Dunning_Automation_Events_Aggregate
  /** fetch data from the table: "dunning_automation_events" using primary key columns */
  tickets_dunning_automation_events_by_pk?: Maybe<Tickets_Dunning_Automation_Events>
  /** fetch data from the table in a streaming manner: "dunning_automation_events" */
  tickets_dunning_automation_events_stream: Array<Tickets_Dunning_Automation_Events>
  /** fetch data from the table: "dunning_debt_ticket_review_records" */
  tickets_dunning_debt_ticket_review_records: Array<Tickets_Dunning_Debt_Ticket_Review_Records>
  /** fetch aggregated fields from the table: "dunning_debt_ticket_review_records" */
  tickets_dunning_debt_ticket_review_records_aggregate: Tickets_Dunning_Debt_Ticket_Review_Records_Aggregate
  /** fetch data from the table: "dunning_debt_ticket_review_records" using primary key columns */
  tickets_dunning_debt_ticket_review_records_by_pk?: Maybe<Tickets_Dunning_Debt_Ticket_Review_Records>
  /** fetch data from the table in a streaming manner: "dunning_debt_ticket_review_records" */
  tickets_dunning_debt_ticket_review_records_stream: Array<Tickets_Dunning_Debt_Ticket_Review_Records>
  /** fetch data from the table: "dunning_job" */
  tickets_dunning_job: Array<Tickets_Dunning_Job>
  /** fetch aggregated fields from the table: "dunning_job" */
  tickets_dunning_job_aggregate: Tickets_Dunning_Job_Aggregate
  /** fetch data from the table: "dunning_job" using primary key columns */
  tickets_dunning_job_by_pk?: Maybe<Tickets_Dunning_Job>
  /** fetch data from the table in a streaming manner: "dunning_job" */
  tickets_dunning_job_stream: Array<Tickets_Dunning_Job>
  /** fetch data from the table: "dunning_legal_known_ticket_records" */
  tickets_dunning_legal_known_ticket_records: Array<Tickets_Dunning_Legal_Known_Ticket_Records>
  /** fetch aggregated fields from the table: "dunning_legal_known_ticket_records" */
  tickets_dunning_legal_known_ticket_records_aggregate: Tickets_Dunning_Legal_Known_Ticket_Records_Aggregate
  /** fetch data from the table: "dunning_legal_known_ticket_records" using primary key columns */
  tickets_dunning_legal_known_ticket_records_by_pk?: Maybe<Tickets_Dunning_Legal_Known_Ticket_Records>
  /** fetch data from the table in a streaming manner: "dunning_legal_known_ticket_records" */
  tickets_dunning_legal_known_ticket_records_stream: Array<Tickets_Dunning_Legal_Known_Ticket_Records>
  /** fetch data from the table: "dunning_legal_occupier_ticket_records" */
  tickets_dunning_legal_occupier_ticket_records: Array<Tickets_Dunning_Legal_Occupier_Ticket_Records>
  /** fetch aggregated fields from the table: "dunning_legal_occupier_ticket_records" */
  tickets_dunning_legal_occupier_ticket_records_aggregate: Tickets_Dunning_Legal_Occupier_Ticket_Records_Aggregate
  /** fetch data from the table: "dunning_legal_occupier_ticket_records" using primary key columns */
  tickets_dunning_legal_occupier_ticket_records_by_pk?: Maybe<Tickets_Dunning_Legal_Occupier_Ticket_Records>
  /** fetch data from the table in a streaming manner: "dunning_legal_occupier_ticket_records" */
  tickets_dunning_legal_occupier_ticket_records_stream: Array<Tickets_Dunning_Legal_Occupier_Ticket_Records>
  /** fetch data from the table: "dunning_occupier_accounts_review_records" */
  tickets_dunning_occupier_accounts_review_records: Array<Tickets_Dunning_Occupier_Accounts_Review_Records>
  /** fetch aggregated fields from the table: "dunning_occupier_accounts_review_records" */
  tickets_dunning_occupier_accounts_review_records_aggregate: Tickets_Dunning_Occupier_Accounts_Review_Records_Aggregate
  /** fetch data from the table: "dunning_occupier_accounts_review_records" using primary key columns */
  tickets_dunning_occupier_accounts_review_records_by_pk?: Maybe<Tickets_Dunning_Occupier_Accounts_Review_Records>
  /** fetch data from the table in a streaming manner: "dunning_occupier_accounts_review_records" */
  tickets_dunning_occupier_accounts_review_records_stream: Array<Tickets_Dunning_Occupier_Accounts_Review_Records>
  /** fetch data from the table: "dunning_purge_job" */
  tickets_dunning_purge_job: Array<Tickets_Dunning_Purge_Job>
  /** fetch aggregated fields from the table: "dunning_purge_job" */
  tickets_dunning_purge_job_aggregate: Tickets_Dunning_Purge_Job_Aggregate
  /** fetch data from the table: "dunning_purge_job" using primary key columns */
  tickets_dunning_purge_job_by_pk?: Maybe<Tickets_Dunning_Purge_Job>
  /** fetch data from the table in a streaming manner: "dunning_purge_job" */
  tickets_dunning_purge_job_stream: Array<Tickets_Dunning_Purge_Job>
  /** fetch data from the table: "dunning_standard_ticket_records" */
  tickets_dunning_standard_ticket_records: Array<Tickets_Dunning_Standard_Ticket_Records>
  /** fetch aggregated fields from the table: "dunning_standard_ticket_records" */
  tickets_dunning_standard_ticket_records_aggregate: Tickets_Dunning_Standard_Ticket_Records_Aggregate
  /** fetch data from the table: "dunning_standard_ticket_records" using primary key columns */
  tickets_dunning_standard_ticket_records_by_pk?: Maybe<Tickets_Dunning_Standard_Ticket_Records>
  /** fetch data from the table in a streaming manner: "dunning_standard_ticket_records" */
  tickets_dunning_standard_ticket_records_stream: Array<Tickets_Dunning_Standard_Ticket_Records>
  /** fetch data from the table: "dunning_statistics" */
  tickets_dunning_statistics: Array<Tickets_Dunning_Statistics>
  /** fetch aggregated fields from the table: "dunning_statistics" */
  tickets_dunning_statistics_aggregate: Tickets_Dunning_Statistics_Aggregate
  /** fetch data from the table: "dunning_statistics" using primary key columns */
  tickets_dunning_statistics_by_pk?: Maybe<Tickets_Dunning_Statistics>
  /** fetch data from the table in a streaming manner: "dunning_statistics" */
  tickets_dunning_statistics_stream: Array<Tickets_Dunning_Statistics>
  /** fetch data from the table: "dunning_terminating_accounts_review_records" */
  tickets_dunning_terminating_accounts_review_records: Array<Tickets_Dunning_Terminating_Accounts_Review_Records>
  /** fetch aggregated fields from the table: "dunning_terminating_accounts_review_records" */
  tickets_dunning_terminating_accounts_review_records_aggregate: Tickets_Dunning_Terminating_Accounts_Review_Records_Aggregate
  /** fetch data from the table: "dunning_terminating_accounts_review_records" using primary key columns */
  tickets_dunning_terminating_accounts_review_records_by_pk?: Maybe<Tickets_Dunning_Terminating_Accounts_Review_Records>
  /** fetch data from the table in a streaming manner: "dunning_terminating_accounts_review_records" */
  tickets_dunning_terminating_accounts_review_records_stream: Array<Tickets_Dunning_Terminating_Accounts_Review_Records>
  /** fetch data from the table: "dunning_ticket_store" */
  tickets_dunning_ticket_store: Array<Tickets_Dunning_Ticket_Store>
  /** fetch aggregated fields from the table: "dunning_ticket_store" */
  tickets_dunning_ticket_store_aggregate: Tickets_Dunning_Ticket_Store_Aggregate
  /** fetch data from the table: "dunning_ticket_store" using primary key columns */
  tickets_dunning_ticket_store_by_pk?: Maybe<Tickets_Dunning_Ticket_Store>
  /** fetch data from the table in a streaming manner: "dunning_ticket_store" */
  tickets_dunning_ticket_store_stream: Array<Tickets_Dunning_Ticket_Store>
  /** fetch data from the table: "dunning_workflow" */
  tickets_dunning_workflow: Array<Tickets_Dunning_Workflow>
  /** fetch aggregated fields from the table: "dunning_workflow" */
  tickets_dunning_workflow_aggregate: Tickets_Dunning_Workflow_Aggregate
  /** fetch data from the table: "dunning_workflow" using primary key columns */
  tickets_dunning_workflow_by_pk?: Maybe<Tickets_Dunning_Workflow>
  /** fetch data from the table in a streaming manner: "dunning_workflow" */
  tickets_dunning_workflow_stream: Array<Tickets_Dunning_Workflow>
  /** fetch data from the table: "external_event" */
  tickets_external_event: Array<Tickets_External_Event>
  /** fetch aggregated fields from the table: "external_event" */
  tickets_external_event_aggregate: Tickets_External_Event_Aggregate
  /** fetch data from the table: "external_event" using primary key columns */
  tickets_external_event_by_pk?: Maybe<Tickets_External_Event>
  /** fetch data from the table in a streaming manner: "external_event" */
  tickets_external_event_stream: Array<Tickets_External_Event>
  /** fetch data from the table: "external_tickets" */
  tickets_external_tickets: Array<Tickets_External_Tickets>
  /** fetch aggregated fields from the table: "external_tickets" */
  tickets_external_tickets_aggregate: Tickets_External_Tickets_Aggregate
  /** fetch data from the table: "external_tickets" using primary key columns */
  tickets_external_tickets_by_pk?: Maybe<Tickets_External_Tickets>
  /** fetch data from the table in a streaming manner: "external_tickets" */
  tickets_external_tickets_stream: Array<Tickets_External_Tickets>
  /** fetch data from the table: "qrtz_blob_triggers" */
  tickets_qrtz_blob_triggers: Array<Tickets_Qrtz_Blob_Triggers>
  /** fetch aggregated fields from the table: "qrtz_blob_triggers" */
  tickets_qrtz_blob_triggers_aggregate: Tickets_Qrtz_Blob_Triggers_Aggregate
  /** fetch data from the table: "qrtz_blob_triggers" using primary key columns */
  tickets_qrtz_blob_triggers_by_pk?: Maybe<Tickets_Qrtz_Blob_Triggers>
  /** fetch data from the table in a streaming manner: "qrtz_blob_triggers" */
  tickets_qrtz_blob_triggers_stream: Array<Tickets_Qrtz_Blob_Triggers>
  /** fetch data from the table: "qrtz_calendars" */
  tickets_qrtz_calendars: Array<Tickets_Qrtz_Calendars>
  /** fetch aggregated fields from the table: "qrtz_calendars" */
  tickets_qrtz_calendars_aggregate: Tickets_Qrtz_Calendars_Aggregate
  /** fetch data from the table: "qrtz_calendars" using primary key columns */
  tickets_qrtz_calendars_by_pk?: Maybe<Tickets_Qrtz_Calendars>
  /** fetch data from the table in a streaming manner: "qrtz_calendars" */
  tickets_qrtz_calendars_stream: Array<Tickets_Qrtz_Calendars>
  /** fetch data from the table: "qrtz_cron_triggers" */
  tickets_qrtz_cron_triggers: Array<Tickets_Qrtz_Cron_Triggers>
  /** fetch aggregated fields from the table: "qrtz_cron_triggers" */
  tickets_qrtz_cron_triggers_aggregate: Tickets_Qrtz_Cron_Triggers_Aggregate
  /** fetch data from the table: "qrtz_cron_triggers" using primary key columns */
  tickets_qrtz_cron_triggers_by_pk?: Maybe<Tickets_Qrtz_Cron_Triggers>
  /** fetch data from the table in a streaming manner: "qrtz_cron_triggers" */
  tickets_qrtz_cron_triggers_stream: Array<Tickets_Qrtz_Cron_Triggers>
  /** fetch data from the table: "qrtz_fired_triggers" */
  tickets_qrtz_fired_triggers: Array<Tickets_Qrtz_Fired_Triggers>
  /** fetch aggregated fields from the table: "qrtz_fired_triggers" */
  tickets_qrtz_fired_triggers_aggregate: Tickets_Qrtz_Fired_Triggers_Aggregate
  /** fetch data from the table: "qrtz_fired_triggers" using primary key columns */
  tickets_qrtz_fired_triggers_by_pk?: Maybe<Tickets_Qrtz_Fired_Triggers>
  /** fetch data from the table in a streaming manner: "qrtz_fired_triggers" */
  tickets_qrtz_fired_triggers_stream: Array<Tickets_Qrtz_Fired_Triggers>
  /** fetch data from the table: "qrtz_job_details" */
  tickets_qrtz_job_details: Array<Tickets_Qrtz_Job_Details>
  /** fetch aggregated fields from the table: "qrtz_job_details" */
  tickets_qrtz_job_details_aggregate: Tickets_Qrtz_Job_Details_Aggregate
  /** fetch data from the table: "qrtz_job_details" using primary key columns */
  tickets_qrtz_job_details_by_pk?: Maybe<Tickets_Qrtz_Job_Details>
  /** fetch data from the table in a streaming manner: "qrtz_job_details" */
  tickets_qrtz_job_details_stream: Array<Tickets_Qrtz_Job_Details>
  /** fetch data from the table: "qrtz_locks" */
  tickets_qrtz_locks: Array<Tickets_Qrtz_Locks>
  /** fetch aggregated fields from the table: "qrtz_locks" */
  tickets_qrtz_locks_aggregate: Tickets_Qrtz_Locks_Aggregate
  /** fetch data from the table: "qrtz_locks" using primary key columns */
  tickets_qrtz_locks_by_pk?: Maybe<Tickets_Qrtz_Locks>
  /** fetch data from the table in a streaming manner: "qrtz_locks" */
  tickets_qrtz_locks_stream: Array<Tickets_Qrtz_Locks>
  /** fetch data from the table: "qrtz_paused_trigger_grps" */
  tickets_qrtz_paused_trigger_grps: Array<Tickets_Qrtz_Paused_Trigger_Grps>
  /** fetch aggregated fields from the table: "qrtz_paused_trigger_grps" */
  tickets_qrtz_paused_trigger_grps_aggregate: Tickets_Qrtz_Paused_Trigger_Grps_Aggregate
  /** fetch data from the table: "qrtz_paused_trigger_grps" using primary key columns */
  tickets_qrtz_paused_trigger_grps_by_pk?: Maybe<Tickets_Qrtz_Paused_Trigger_Grps>
  /** fetch data from the table in a streaming manner: "qrtz_paused_trigger_grps" */
  tickets_qrtz_paused_trigger_grps_stream: Array<Tickets_Qrtz_Paused_Trigger_Grps>
  /** fetch data from the table: "qrtz_scheduler_state" */
  tickets_qrtz_scheduler_state: Array<Tickets_Qrtz_Scheduler_State>
  /** fetch aggregated fields from the table: "qrtz_scheduler_state" */
  tickets_qrtz_scheduler_state_aggregate: Tickets_Qrtz_Scheduler_State_Aggregate
  /** fetch data from the table: "qrtz_scheduler_state" using primary key columns */
  tickets_qrtz_scheduler_state_by_pk?: Maybe<Tickets_Qrtz_Scheduler_State>
  /** fetch data from the table in a streaming manner: "qrtz_scheduler_state" */
  tickets_qrtz_scheduler_state_stream: Array<Tickets_Qrtz_Scheduler_State>
  /** fetch data from the table: "qrtz_simple_triggers" */
  tickets_qrtz_simple_triggers: Array<Tickets_Qrtz_Simple_Triggers>
  /** fetch aggregated fields from the table: "qrtz_simple_triggers" */
  tickets_qrtz_simple_triggers_aggregate: Tickets_Qrtz_Simple_Triggers_Aggregate
  /** fetch data from the table: "qrtz_simple_triggers" using primary key columns */
  tickets_qrtz_simple_triggers_by_pk?: Maybe<Tickets_Qrtz_Simple_Triggers>
  /** fetch data from the table in a streaming manner: "qrtz_simple_triggers" */
  tickets_qrtz_simple_triggers_stream: Array<Tickets_Qrtz_Simple_Triggers>
  /** fetch data from the table: "qrtz_simprop_triggers" */
  tickets_qrtz_simprop_triggers: Array<Tickets_Qrtz_Simprop_Triggers>
  /** fetch aggregated fields from the table: "qrtz_simprop_triggers" */
  tickets_qrtz_simprop_triggers_aggregate: Tickets_Qrtz_Simprop_Triggers_Aggregate
  /** fetch data from the table: "qrtz_simprop_triggers" using primary key columns */
  tickets_qrtz_simprop_triggers_by_pk?: Maybe<Tickets_Qrtz_Simprop_Triggers>
  /** fetch data from the table in a streaming manner: "qrtz_simprop_triggers" */
  tickets_qrtz_simprop_triggers_stream: Array<Tickets_Qrtz_Simprop_Triggers>
  /** fetch data from the table: "qrtz_triggers" */
  tickets_qrtz_triggers: Array<Tickets_Qrtz_Triggers>
  /** fetch aggregated fields from the table: "qrtz_triggers" */
  tickets_qrtz_triggers_aggregate: Tickets_Qrtz_Triggers_Aggregate
  /** fetch data from the table: "qrtz_triggers" using primary key columns */
  tickets_qrtz_triggers_by_pk?: Maybe<Tickets_Qrtz_Triggers>
  /** fetch data from the table in a streaming manner: "qrtz_triggers" */
  tickets_qrtz_triggers_stream: Array<Tickets_Qrtz_Triggers>
  /** fetch data from the table: "trustpilot_invitations" */
  trustpilot_invitations: Array<Trustpilot_Invitations>
  /** fetch aggregated fields from the table: "trustpilot_invitations" */
  trustpilot_invitations_aggregate: Trustpilot_Invitations_Aggregate
  /** fetch data from the table in a streaming manner: "trustpilot_invitations" */
  trustpilot_invitations_stream: Array<Trustpilot_Invitations>
  /** fetch data from the table: "users" */
  users: Array<Users>
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>
  /** fetch data from the table: "uswitch_record" */
  uswitch_record: Array<Uswitch_Record>
  /** fetch aggregated fields from the table: "uswitch_record" */
  uswitch_record_aggregate: Uswitch_Record_Aggregate
  /** fetch data from the table: "uswitch_record" using primary key columns */
  uswitch_record_by_pk?: Maybe<Uswitch_Record>
  /** fetch data from the table in a streaming manner: "uswitch_record" */
  uswitch_record_stream: Array<Uswitch_Record>
  /** fetch data from the table: "warm_home_discount_application" */
  warm_home_discount_application: Array<Warm_Home_Discount_Application>
  /** fetch aggregated fields from the table: "warm_home_discount_application" */
  warm_home_discount_application_aggregate: Warm_Home_Discount_Application_Aggregate
  /** fetch data from the table: "warm_home_discount_application" using primary key columns */
  warm_home_discount_application_by_pk?: Maybe<Warm_Home_Discount_Application>
  /** fetch data from the table: "warm_home_discount_application_status_history" */
  warm_home_discount_application_status_history: Array<Warm_Home_Discount_Application_Status_History>
  /** fetch aggregated fields from the table: "warm_home_discount_application_status_history" */
  warm_home_discount_application_status_history_aggregate: Warm_Home_Discount_Application_Status_History_Aggregate
  /** fetch data from the table: "warm_home_discount_application_status_history" using primary key columns */
  warm_home_discount_application_status_history_by_pk?: Maybe<Warm_Home_Discount_Application_Status_History>
  /** fetch data from the table in a streaming manner: "warm_home_discount_application_status_history" */
  warm_home_discount_application_status_history_stream: Array<Warm_Home_Discount_Application_Status_History>
  /** fetch data from the table in a streaming manner: "warm_home_discount_application" */
  warm_home_discount_application_stream: Array<Warm_Home_Discount_Application>
  /** fetch data from the table: "warm_home_discount_criteria" */
  warm_home_discount_criteria: Array<Warm_Home_Discount_Criteria>
  /** fetch aggregated fields from the table: "warm_home_discount_criteria" */
  warm_home_discount_criteria_aggregate: Warm_Home_Discount_Criteria_Aggregate
  /** fetch data from the table: "warm_home_discount_criteria" using primary key columns */
  warm_home_discount_criteria_by_pk?: Maybe<Warm_Home_Discount_Criteria>
  /** fetch data from the table: "warm_home_discount_criteria_rel" */
  warm_home_discount_criteria_rel: Array<Warm_Home_Discount_Criteria_Rel>
  /** fetch aggregated fields from the table: "warm_home_discount_criteria_rel" */
  warm_home_discount_criteria_rel_aggregate: Warm_Home_Discount_Criteria_Rel_Aggregate
  /** fetch data from the table: "warm_home_discount_criteria_rel" using primary key columns */
  warm_home_discount_criteria_rel_by_pk?: Maybe<Warm_Home_Discount_Criteria_Rel>
  /** fetch data from the table in a streaming manner: "warm_home_discount_criteria_rel" */
  warm_home_discount_criteria_rel_stream: Array<Warm_Home_Discount_Criteria_Rel>
  /** fetch data from the table in a streaming manner: "warm_home_discount_criteria" */
  warm_home_discount_criteria_stream: Array<Warm_Home_Discount_Criteria>
}

export type Subscription_RootElecNominationsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<ElecNominations_Order_By>>
  where?: InputMaybe<ElecNominations_Bool_Exp>
}

export type Subscription_RootElecNominations_AggregateArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<ElecNominations_Order_By>>
  where?: InputMaybe<ElecNominations_Bool_Exp>
}

export type Subscription_RootElecTradesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<ElecTrades_Order_By>>
  where?: InputMaybe<ElecTrades_Bool_Exp>
}

export type Subscription_RootElecTradesHistoryArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<ElecTradesHistory_Order_By>>
  where?: InputMaybe<ElecTradesHistory_Bool_Exp>
}

export type Subscription_RootElecTradesHistory_AggregateArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<ElecTradesHistory_Order_By>>
  where?: InputMaybe<ElecTradesHistory_Bool_Exp>
}

export type Subscription_RootElecTradesHistory_By_PkArgs = {
  id: Scalars["Int"]["input"]
}

export type Subscription_RootElecTrades_AggregateArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<ElecTrades_Order_By>>
  where?: InputMaybe<ElecTrades_Bool_Exp>
}

export type Subscription_RootElecTrades_By_PkArgs = {
  id: Scalars["Int"]["input"]
}

export type Subscription_RootGasTradesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<GasTrades_Order_By>>
  where?: InputMaybe<GasTrades_Bool_Exp>
}

export type Subscription_RootGasTradesHistoryArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<GasTradesHistory_Order_By>>
  where?: InputMaybe<GasTradesHistory_Bool_Exp>
}

export type Subscription_RootGasTradesHistory_AggregateArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<GasTradesHistory_Order_By>>
  where?: InputMaybe<GasTradesHistory_Bool_Exp>
}

export type Subscription_RootGasTradesHistory_By_PkArgs = {
  id: Scalars["Int"]["input"]
}

export type Subscription_RootGasTrades_AggregateArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<GasTrades_Order_By>>
  where?: InputMaybe<GasTrades_Bool_Exp>
}

export type Subscription_RootGasTrades_By_PkArgs = {
  id: Scalars["Int"]["input"]
}

export type Subscription_RootAccount_CreditArgs = {
  distinct_on?: InputMaybe<Array<Account_Credit_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Account_Credit_Order_By>>
  where?: InputMaybe<Account_Credit_Bool_Exp>
}

export type Subscription_RootAccount_Credit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Credit_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Account_Credit_Order_By>>
  where?: InputMaybe<Account_Credit_Bool_Exp>
}

export type Subscription_RootAccount_Credit_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootAccount_Credit_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Account_Credit_Stream_Cursor_Input>>
  where?: InputMaybe<Account_Credit_Bool_Exp>
}

export type Subscription_RootActive_Outbound_Photo_RequestArgs = {
  distinct_on?: InputMaybe<Array<Active_Outbound_Photo_Request_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Active_Outbound_Photo_Request_Order_By>>
  where?: InputMaybe<Active_Outbound_Photo_Request_Bool_Exp>
}

export type Subscription_RootActive_Outbound_Photo_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Active_Outbound_Photo_Request_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Active_Outbound_Photo_Request_Order_By>>
  where?: InputMaybe<Active_Outbound_Photo_Request_Bool_Exp>
}

export type Subscription_RootActive_Outbound_Photo_Request_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Active_Outbound_Photo_Request_Stream_Cursor_Input>>
  where?: InputMaybe<Active_Outbound_Photo_Request_Bool_Exp>
}

export type Subscription_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Address_Order_By>>
  where?: InputMaybe<Address_Bool_Exp>
}

export type Subscription_RootAddress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Address_Order_By>>
  where?: InputMaybe<Address_Bool_Exp>
}

export type Subscription_RootAddress_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootAddress_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Address_Stream_Cursor_Input>>
  where?: InputMaybe<Address_Bool_Exp>
}

export type Subscription_RootAdmin_PassesArgs = {
  distinct_on?: InputMaybe<Array<Admin_Passes_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Admin_Passes_Order_By>>
  where?: InputMaybe<Admin_Passes_Bool_Exp>
}

export type Subscription_RootAdmin_Passes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Passes_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Admin_Passes_Order_By>>
  where?: InputMaybe<Admin_Passes_Bool_Exp>
}

export type Subscription_RootAdmin_Passes_By_PkArgs = {
  id: Scalars["Int"]["input"]
}

export type Subscription_RootAdmin_Passes_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Admin_Passes_Stream_Cursor_Input>>
  where?: InputMaybe<Admin_Passes_Bool_Exp>
}

export type Subscription_RootAdmin_RolesArgs = {
  distinct_on?: InputMaybe<Array<Admin_Roles_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Admin_Roles_Order_By>>
  where?: InputMaybe<Admin_Roles_Bool_Exp>
}

export type Subscription_RootAdmin_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Roles_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Admin_Roles_Order_By>>
  where?: InputMaybe<Admin_Roles_Bool_Exp>
}

export type Subscription_RootAdmin_Roles_By_PkArgs = {
  id: Scalars["Int"]["input"]
}

export type Subscription_RootAdmin_Roles_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Admin_Roles_Stream_Cursor_Input>>
  where?: InputMaybe<Admin_Roles_Bool_Exp>
}

export type Subscription_RootAgreementArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Agreement_Order_By>>
  where?: InputMaybe<Agreement_Bool_Exp>
}

export type Subscription_RootAgreement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreement_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Agreement_Order_By>>
  where?: InputMaybe<Agreement_Bool_Exp>
}

export type Subscription_RootAgreement_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootAgreement_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Agreement_Stream_Cursor_Input>>
  where?: InputMaybe<Agreement_Bool_Exp>
}

export type Subscription_RootAssetArgs = {
  distinct_on?: InputMaybe<Array<Asset_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Asset_Order_By>>
  where?: InputMaybe<Asset_Bool_Exp>
}

export type Subscription_RootAsset_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Asset_Order_By>>
  where?: InputMaybe<Asset_Bool_Exp>
}

export type Subscription_RootAsset_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootAsset_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Asset_Stream_Cursor_Input>>
  where?: InputMaybe<Asset_Bool_Exp>
}

export type Subscription_RootAttachmentArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Attachment_Order_By>>
  where?: InputMaybe<Attachment_Bool_Exp>
}

export type Subscription_RootAttachment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Attachment_Order_By>>
  where?: InputMaybe<Attachment_Bool_Exp>
}

export type Subscription_RootAttachment_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootAttachment_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Attachment_Stream_Cursor_Input>>
  where?: InputMaybe<Attachment_Bool_Exp>
}

export type Subscription_RootAxle_Trial_EligibilityArgs = {
  distinct_on?: InputMaybe<Array<Axle_Trial_Eligibility_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Axle_Trial_Eligibility_Order_By>>
  where?: InputMaybe<Axle_Trial_Eligibility_Bool_Exp>
}

export type Subscription_RootAxle_Trial_Eligibility_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Axle_Trial_Eligibility_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Axle_Trial_Eligibility_Order_By>>
  where?: InputMaybe<Axle_Trial_Eligibility_Bool_Exp>
}

export type Subscription_RootAxle_Trial_Eligibility_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootAxle_Trial_Eligibility_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Axle_Trial_Eligibility_Stream_Cursor_Input>>
  where?: InputMaybe<Axle_Trial_Eligibility_Bool_Exp>
}

export type Subscription_RootBillArgs = {
  distinct_on?: InputMaybe<Array<Bill_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Bill_Order_By>>
  where?: InputMaybe<Bill_Bool_Exp>
}

export type Subscription_RootBill_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bill_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Bill_Order_By>>
  where?: InputMaybe<Bill_Bool_Exp>
}

export type Subscription_RootBill_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootBill_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Bill_Stream_Cursor_Input>>
  where?: InputMaybe<Bill_Bool_Exp>
}

export type Subscription_RootBilling_AccountArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Order_By>>
  where?: InputMaybe<Billing_Account_Bool_Exp>
}

export type Subscription_RootBilling_Account_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Order_By>>
  where?: InputMaybe<Billing_Account_Bool_Exp>
}

export type Subscription_RootBilling_Account_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootBilling_Account_ContactArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Contact_Order_By>>
  where?: InputMaybe<Billing_Account_Contact_Bool_Exp>
}

export type Subscription_RootBilling_Account_Contact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Contact_Order_By>>
  where?: InputMaybe<Billing_Account_Contact_Bool_Exp>
}

export type Subscription_RootBilling_Account_Contact_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootBilling_Account_Contact_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Billing_Account_Contact_Stream_Cursor_Input>>
  where?: InputMaybe<Billing_Account_Contact_Bool_Exp>
}

export type Subscription_RootBilling_Account_Ids_With_Meter_Point_IdsArgs = {
  distinct_on?: InputMaybe<
    Array<Billing_Account_Ids_With_Meter_Point_Ids_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Billing_Account_Ids_With_Meter_Point_Ids_Order_By>
  >
  where?: InputMaybe<Billing_Account_Ids_With_Meter_Point_Ids_Bool_Exp>
}

export type Subscription_RootBilling_Account_Ids_With_Meter_Point_Ids_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Billing_Account_Ids_With_Meter_Point_Ids_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Billing_Account_Ids_With_Meter_Point_Ids_Order_By>
    >
    where?: InputMaybe<Billing_Account_Ids_With_Meter_Point_Ids_Bool_Exp>
  }

export type Subscription_RootBilling_Account_Ids_With_Meter_Point_Ids_StreamArgs =
  {
    batch_size: Scalars["Int"]["input"]
    cursor: Array<
      InputMaybe<Billing_Account_Ids_With_Meter_Point_Ids_Stream_Cursor_Input>
    >
    where?: InputMaybe<Billing_Account_Ids_With_Meter_Point_Ids_Bool_Exp>
  }

export type Subscription_RootBilling_Account_SettingArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Setting_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Setting_Order_By>>
  where?: InputMaybe<Billing_Account_Setting_Bool_Exp>
}

export type Subscription_RootBilling_Account_Setting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Setting_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Setting_Order_By>>
  where?: InputMaybe<Billing_Account_Setting_Bool_Exp>
}

export type Subscription_RootBilling_Account_Setting_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootBilling_Account_Setting_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Billing_Account_Setting_Stream_Cursor_Input>>
  where?: InputMaybe<Billing_Account_Setting_Bool_Exp>
}

export type Subscription_RootBilling_Account_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Billing_Account_Stream_Cursor_Input>>
  where?: InputMaybe<Billing_Account_Bool_Exp>
}

export type Subscription_RootBilling_Account_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Transaction_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Transaction_Order_By>>
  where?: InputMaybe<Billing_Account_Transaction_Bool_Exp>
}

export type Subscription_RootBilling_Account_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Transaction_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Transaction_Order_By>>
  where?: InputMaybe<Billing_Account_Transaction_Bool_Exp>
}

export type Subscription_RootBilling_Account_Transaction_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootBilling_Account_Transaction_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Billing_Account_Transaction_Stream_Cursor_Input>>
  where?: InputMaybe<Billing_Account_Transaction_Bool_Exp>
}

export type Subscription_RootBilling_PeriodArgs = {
  distinct_on?: InputMaybe<Array<Billing_Period_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Period_Order_By>>
  where?: InputMaybe<Billing_Period_Bool_Exp>
}

export type Subscription_RootBilling_Period_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Billing_Period_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Period_Order_By>>
  where?: InputMaybe<Billing_Period_Bool_Exp>
}

export type Subscription_RootBilling_Period_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootBilling_Period_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Billing_Period_Stream_Cursor_Input>>
  where?: InputMaybe<Billing_Period_Bool_Exp>
}

export type Subscription_RootCalculation_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Calculation_Items_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Calculation_Items_Order_By>>
  where?: InputMaybe<Calculation_Items_Bool_Exp>
}

export type Subscription_RootCalculation_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Calculation_Items_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Calculation_Items_Order_By>>
  where?: InputMaybe<Calculation_Items_Bool_Exp>
}

export type Subscription_RootCalculation_Items_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootCalculation_Items_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Calculation_Items_Stream_Cursor_Input>>
  where?: InputMaybe<Calculation_Items_Bool_Exp>
}

export type Subscription_RootCall_Trace_AuditArgs = {
  distinct_on?: InputMaybe<Array<Call_Trace_Audit_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Call_Trace_Audit_Order_By>>
  where?: InputMaybe<Call_Trace_Audit_Bool_Exp>
}

export type Subscription_RootCall_Trace_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Call_Trace_Audit_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Call_Trace_Audit_Order_By>>
  where?: InputMaybe<Call_Trace_Audit_Bool_Exp>
}

export type Subscription_RootCall_Trace_Audit_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootCall_Trace_Audit_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Call_Trace_Audit_Stream_Cursor_Input>>
  where?: InputMaybe<Call_Trace_Audit_Bool_Exp>
}

export type Subscription_RootCancellation_ReasonsArgs = {
  distinct_on?: InputMaybe<Array<Cancellation_Reasons_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Cancellation_Reasons_Order_By>>
  where?: InputMaybe<Cancellation_Reasons_Bool_Exp>
}

export type Subscription_RootCancellation_Reasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cancellation_Reasons_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Cancellation_Reasons_Order_By>>
  where?: InputMaybe<Cancellation_Reasons_Bool_Exp>
}

export type Subscription_RootCancellation_Reasons_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Cancellation_Reasons_Stream_Cursor_Input>>
  where?: InputMaybe<Cancellation_Reasons_Bool_Exp>
}

export type Subscription_RootCancellationsArgs = {
  distinct_on?: InputMaybe<Array<Cancellations_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Cancellations_Order_By>>
  where?: InputMaybe<Cancellations_Bool_Exp>
}

export type Subscription_RootCancellations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cancellations_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Cancellations_Order_By>>
  where?: InputMaybe<Cancellations_Bool_Exp>
}

export type Subscription_RootCancellations_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootCancellations_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Cancellations_Stream_Cursor_Input>>
  where?: InputMaybe<Cancellations_Bool_Exp>
}

export type Subscription_RootCard_PaymentArgs = {
  distinct_on?: InputMaybe<Array<Card_Payment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Card_Payment_Order_By>>
  where?: InputMaybe<Card_Payment_Bool_Exp>
}

export type Subscription_RootCard_Payment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Card_Payment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Card_Payment_Order_By>>
  where?: InputMaybe<Card_Payment_Bool_Exp>
}

export type Subscription_RootCard_Payment_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootCard_Payment_OldArgs = {
  distinct_on?: InputMaybe<Array<Card_Payment_Old_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Card_Payment_Old_Order_By>>
  where?: InputMaybe<Card_Payment_Old_Bool_Exp>
}

export type Subscription_RootCard_Payment_Old_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Card_Payment_Old_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Card_Payment_Old_Order_By>>
  where?: InputMaybe<Card_Payment_Old_Bool_Exp>
}

export type Subscription_RootCard_Payment_Old_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootCard_Payment_Old_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Card_Payment_Old_Stream_Cursor_Input>>
  where?: InputMaybe<Card_Payment_Old_Bool_Exp>
}

export type Subscription_RootCard_Payment_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Card_Payment_Stream_Cursor_Input>>
  where?: InputMaybe<Card_Payment_Bool_Exp>
}

export type Subscription_RootCasesArgs = {
  distinct_on?: InputMaybe<Array<Cases_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Cases_Order_By>>
  where?: InputMaybe<Cases_Bool_Exp>
}

export type Subscription_RootCases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cases_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Cases_Order_By>>
  where?: InputMaybe<Cases_Bool_Exp>
}

export type Subscription_RootCases_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootCases_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Cases_Stream_Cursor_Input>>
  where?: InputMaybe<Cases_Bool_Exp>
}

export type Subscription_RootCommunicationArgs = {
  distinct_on?: InputMaybe<Array<Communication_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Communication_Order_By>>
  where?: InputMaybe<Communication_Bool_Exp>
}

export type Subscription_RootCommunication_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Communication_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Communication_Order_By>>
  where?: InputMaybe<Communication_Bool_Exp>
}

export type Subscription_RootCommunication_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootCommunication_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Communication_Metadata_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Communication_Metadata_Order_By>>
  where?: InputMaybe<Communication_Metadata_Bool_Exp>
}

export type Subscription_RootCommunication_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Communication_Metadata_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Communication_Metadata_Order_By>>
  where?: InputMaybe<Communication_Metadata_Bool_Exp>
}

export type Subscription_RootCommunication_Metadata_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootCommunication_Metadata_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Communication_Metadata_Stream_Cursor_Input>>
  where?: InputMaybe<Communication_Metadata_Bool_Exp>
}

export type Subscription_RootCommunication_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Communication_Stream_Cursor_Input>>
  where?: InputMaybe<Communication_Bool_Exp>
}

export type Subscription_RootCommunicationsArgs = {
  distinct_on?: InputMaybe<Array<Communications_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Communications_Order_By>>
  where?: InputMaybe<Communications_Bool_Exp>
}

export type Subscription_RootCommunications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Communications_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Communications_Order_By>>
  where?: InputMaybe<Communications_Bool_Exp>
}

export type Subscription_RootCommunications_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootCommunications_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Communications_Stream_Cursor_Input>>
  where?: InputMaybe<Communications_Bool_Exp>
}

export type Subscription_RootComplaintArgs = {
  distinct_on?: InputMaybe<Array<Complaint_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Complaint_Order_By>>
  where?: InputMaybe<Complaint_Bool_Exp>
}

export type Subscription_RootComplaint_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Complaint_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Complaint_Order_By>>
  where?: InputMaybe<Complaint_Bool_Exp>
}

export type Subscription_RootComplaint_AggregationsArgs = {
  distinct_on?: InputMaybe<Array<Complaint_Aggregations_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Complaint_Aggregations_Order_By>>
  where?: InputMaybe<Complaint_Aggregations_Bool_Exp>
}

export type Subscription_RootComplaint_Aggregations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Complaint_Aggregations_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Complaint_Aggregations_Order_By>>
  where?: InputMaybe<Complaint_Aggregations_Bool_Exp>
}

export type Subscription_RootComplaint_Aggregations_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Complaint_Aggregations_Stream_Cursor_Input>>
  where?: InputMaybe<Complaint_Aggregations_Bool_Exp>
}

export type Subscription_RootComplaint_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootComplaint_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Complaint_Stream_Cursor_Input>>
  where?: InputMaybe<Complaint_Bool_Exp>
}

export type Subscription_RootCompleted_Sync_Event_AccountArgs = {
  distinct_on?: InputMaybe<Array<Completed_Sync_Event_Account_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Completed_Sync_Event_Account_Order_By>>
  where?: InputMaybe<Completed_Sync_Event_Account_Bool_Exp>
}

export type Subscription_RootCompleted_Sync_Event_Account_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Completed_Sync_Event_Account_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Completed_Sync_Event_Account_Order_By>>
  where?: InputMaybe<Completed_Sync_Event_Account_Bool_Exp>
}

export type Subscription_RootCompleted_Sync_Event_Account_By_PkArgs = {
  event_type: Scalars["event_type"]["input"]
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootCompleted_Sync_Event_Account_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Completed_Sync_Event_Account_Stream_Cursor_Input>>
  where?: InputMaybe<Completed_Sync_Event_Account_Bool_Exp>
}

export type Subscription_RootConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Configuration_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Configuration_Order_By>>
  where?: InputMaybe<Configuration_Bool_Exp>
}

export type Subscription_RootConfiguration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Configuration_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Configuration_Order_By>>
  where?: InputMaybe<Configuration_Bool_Exp>
}

export type Subscription_RootConfiguration_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootConfiguration_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Configuration_Stream_Cursor_Input>>
  where?: InputMaybe<Configuration_Bool_Exp>
}

export type Subscription_RootContactArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Contact_Order_By>>
  where?: InputMaybe<Contact_Bool_Exp>
}

export type Subscription_RootContact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Contact_Order_By>>
  where?: InputMaybe<Contact_Bool_Exp>
}

export type Subscription_RootContact_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootContact_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Contact_Stream_Cursor_Input>>
  where?: InputMaybe<Contact_Bool_Exp>
}

export type Subscription_RootCs__Soe_Dashboard_TotalArgs = {
  distinct_on?: InputMaybe<Array<Cs__Soe_Dashboard_Total_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Cs__Soe_Dashboard_Total_Order_By>>
  where?: InputMaybe<Cs__Soe_Dashboard_Total_Bool_Exp>
}

export type Subscription_RootCs__Soe_Dashboard_Total_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cs__Soe_Dashboard_Total_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Cs__Soe_Dashboard_Total_Order_By>>
  where?: InputMaybe<Cs__Soe_Dashboard_Total_Bool_Exp>
}

export type Subscription_RootCs__Soe_Dashboard_Total_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootCs__Soe_Dashboard_Total_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Cs__Soe_Dashboard_Total_Stream_Cursor_Input>>
  where?: InputMaybe<Cs__Soe_Dashboard_Total_Bool_Exp>
}

export type Subscription_RootCurrent_Future_Product_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Current_Future_Product_Details_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Current_Future_Product_Details_Order_By>>
  where?: InputMaybe<Current_Future_Product_Details_Bool_Exp>
}

export type Subscription_RootCurrent_Future_Product_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Current_Future_Product_Details_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Current_Future_Product_Details_Order_By>>
  where?: InputMaybe<Current_Future_Product_Details_Bool_Exp>
}

export type Subscription_RootCurrent_Future_Product_Details_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Current_Future_Product_Details_Stream_Cursor_Input>>
  where?: InputMaybe<Current_Future_Product_Details_Bool_Exp>
}

export type Subscription_RootCustomerArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Order_By>>
  where?: InputMaybe<Customer_Bool_Exp>
}

export type Subscription_RootCustomer_AddressArgs = {
  distinct_on?: InputMaybe<Array<Customer_Address_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Address_Order_By>>
  where?: InputMaybe<Customer_Address_Bool_Exp>
}

export type Subscription_RootCustomer_Address_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Address_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Address_Order_By>>
  where?: InputMaybe<Customer_Address_Bool_Exp>
}

export type Subscription_RootCustomer_Address_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootCustomer_Address_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Customer_Address_Stream_Cursor_Input>>
  where?: InputMaybe<Customer_Address_Bool_Exp>
}

export type Subscription_RootCustomer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Order_By>>
  where?: InputMaybe<Customer_Bool_Exp>
}

export type Subscription_RootCustomer_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootCustomer_ContactArgs = {
  distinct_on?: InputMaybe<Array<Customer_Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Contact_Order_By>>
  where?: InputMaybe<Customer_Contact_Bool_Exp>
}

export type Subscription_RootCustomer_Contact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Contact_Order_By>>
  where?: InputMaybe<Customer_Contact_Bool_Exp>
}

export type Subscription_RootCustomer_Contact_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootCustomer_Contact_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Customer_Contact_Stream_Cursor_Input>>
  where?: InputMaybe<Customer_Contact_Bool_Exp>
}

export type Subscription_RootCustomer_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Customer_Metadata_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Metadata_Order_By>>
  where?: InputMaybe<Customer_Metadata_Bool_Exp>
}

export type Subscription_RootCustomer_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Metadata_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Metadata_Order_By>>
  where?: InputMaybe<Customer_Metadata_Bool_Exp>
}

export type Subscription_RootCustomer_Metadata_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootCustomer_Metadata_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Customer_Metadata_Stream_Cursor_Input>>
  where?: InputMaybe<Customer_Metadata_Bool_Exp>
}

export type Subscription_RootCustomer_Property_RelArgs = {
  distinct_on?: InputMaybe<Array<Customer_Property_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Property_Rel_Order_By>>
  where?: InputMaybe<Customer_Property_Rel_Bool_Exp>
}

export type Subscription_RootCustomer_Property_Rel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Property_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Property_Rel_Order_By>>
  where?: InputMaybe<Customer_Property_Rel_Bool_Exp>
}

export type Subscription_RootCustomer_Property_Rel_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootCustomer_Property_Rel_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Customer_Property_Rel_Stream_Cursor_Input>>
  where?: InputMaybe<Customer_Property_Rel_Bool_Exp>
}

export type Subscription_RootCustomer_Psr_RelArgs = {
  distinct_on?: InputMaybe<Array<Customer_Psr_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Psr_Rel_Order_By>>
  where?: InputMaybe<Customer_Psr_Rel_Bool_Exp>
}

export type Subscription_RootCustomer_Psr_Rel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Psr_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Psr_Rel_Order_By>>
  where?: InputMaybe<Customer_Psr_Rel_Bool_Exp>
}

export type Subscription_RootCustomer_Psr_Rel_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootCustomer_Psr_Rel_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Customer_Psr_Rel_Stream_Cursor_Input>>
  where?: InputMaybe<Customer_Psr_Rel_Bool_Exp>
}

export type Subscription_RootCustomer_ReferralsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Referrals_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Referrals_Order_By>>
  where?: InputMaybe<Customer_Referrals_Bool_Exp>
}

export type Subscription_RootCustomer_Referrals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Referrals_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Referrals_Order_By>>
  where?: InputMaybe<Customer_Referrals_Bool_Exp>
}

export type Subscription_RootCustomer_Referrals_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootCustomer_Referrals_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Customer_Referrals_Stream_Cursor_Input>>
  where?: InputMaybe<Customer_Referrals_Bool_Exp>
}

export type Subscription_RootCustomer_SettingArgs = {
  distinct_on?: InputMaybe<Array<Customer_Setting_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Setting_Order_By>>
  where?: InputMaybe<Customer_Setting_Bool_Exp>
}

export type Subscription_RootCustomer_Setting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Setting_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_Setting_Order_By>>
  where?: InputMaybe<Customer_Setting_Bool_Exp>
}

export type Subscription_RootCustomer_Setting_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootCustomer_Setting_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Customer_Setting_Stream_Cursor_Input>>
  where?: InputMaybe<Customer_Setting_Bool_Exp>
}

export type Subscription_RootCustomer_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Customer_Stream_Cursor_Input>>
  where?: InputMaybe<Customer_Bool_Exp>
}

export type Subscription_RootCustomer_User_RelArgs = {
  distinct_on?: InputMaybe<Array<Customer_User_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_User_Rel_Order_By>>
  where?: InputMaybe<Customer_User_Rel_Bool_Exp>
}

export type Subscription_RootCustomer_User_Rel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_User_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_User_Rel_Order_By>>
  where?: InputMaybe<Customer_User_Rel_Bool_Exp>
}

export type Subscription_RootCustomer_User_Rel_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootCustomer_User_Rel_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Customer_User_Rel_Stream_Cursor_Input>>
  where?: InputMaybe<Customer_User_Rel_Bool_Exp>
}

export type Subscription_RootDashboard_Complete_View_V2Args = {
  distinct_on?: InputMaybe<Array<Dashboard_Complete_View_V2_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Dashboard_Complete_View_V2_Order_By>>
  where?: InputMaybe<Dashboard_Complete_View_V2_Bool_Exp>
}

export type Subscription_RootDashboard_Complete_View_V2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dashboard_Complete_View_V2_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Dashboard_Complete_View_V2_Order_By>>
  where?: InputMaybe<Dashboard_Complete_View_V2_Bool_Exp>
}

export type Subscription_RootDashboard_Complete_View_V2_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Dashboard_Complete_View_V2_Stream_Cursor_Input>>
  where?: InputMaybe<Dashboard_Complete_View_V2_Bool_Exp>
}

export type Subscription_RootDeprecated_Solar_Quote_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Deprecated_Solar_Quote_Requests_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Deprecated_Solar_Quote_Requests_Order_By>>
  where?: InputMaybe<Deprecated_Solar_Quote_Requests_Bool_Exp>
}

export type Subscription_RootDeprecated_Solar_Quote_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Deprecated_Solar_Quote_Requests_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Deprecated_Solar_Quote_Requests_Order_By>>
  where?: InputMaybe<Deprecated_Solar_Quote_Requests_Bool_Exp>
}

export type Subscription_RootDeprecated_Solar_Quote_Requests_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootDeprecated_Solar_Quote_Requests_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Deprecated_Solar_Quote_Requests_Stream_Cursor_Input>>
  where?: InputMaybe<Deprecated_Solar_Quote_Requests_Bool_Exp>
}

export type Subscription_RootDirect_DebitArgs = {
  distinct_on?: InputMaybe<Array<Direct_Debit_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Direct_Debit_Order_By>>
  where?: InputMaybe<Direct_Debit_Bool_Exp>
}

export type Subscription_RootDirect_Debit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Direct_Debit_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Direct_Debit_Order_By>>
  where?: InputMaybe<Direct_Debit_Bool_Exp>
}

export type Subscription_RootDirect_Debit_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootDirect_Debit_PaymentArgs = {
  distinct_on?: InputMaybe<Array<Direct_Debit_Payment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Direct_Debit_Payment_Order_By>>
  where?: InputMaybe<Direct_Debit_Payment_Bool_Exp>
}

export type Subscription_RootDirect_Debit_Payment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Direct_Debit_Payment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Direct_Debit_Payment_Order_By>>
  where?: InputMaybe<Direct_Debit_Payment_Bool_Exp>
}

export type Subscription_RootDirect_Debit_Payment_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootDirect_Debit_Payment_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Direct_Debit_Payment_Stream_Cursor_Input>>
  where?: InputMaybe<Direct_Debit_Payment_Bool_Exp>
}

export type Subscription_RootDirect_Debit_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Direct_Debit_Stream_Cursor_Input>>
  where?: InputMaybe<Direct_Debit_Bool_Exp>
}

export type Subscription_RootEmail_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Email_Messages_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Email_Messages_Order_By>>
  where?: InputMaybe<Email_Messages_Bool_Exp>
}

export type Subscription_RootEmail_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Messages_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Email_Messages_Order_By>>
  where?: InputMaybe<Email_Messages_Bool_Exp>
}

export type Subscription_RootEmail_Messages_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootEmail_Messages_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Email_Messages_Stream_Cursor_Input>>
  where?: InputMaybe<Email_Messages_Bool_Exp>
}

export type Subscription_RootEmail_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Email_Templates_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Email_Templates_Order_By>>
  where?: InputMaybe<Email_Templates_Bool_Exp>
}

export type Subscription_RootEmail_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Templates_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Email_Templates_Order_By>>
  where?: InputMaybe<Email_Templates_Bool_Exp>
}

export type Subscription_RootEmail_Templates_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootEmail_Templates_ExtArgs = {
  distinct_on?: InputMaybe<Array<Email_Templates_Ext_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Email_Templates_Ext_Order_By>>
  where?: InputMaybe<Email_Templates_Ext_Bool_Exp>
}

export type Subscription_RootEmail_Templates_Ext_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Templates_Ext_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Email_Templates_Ext_Order_By>>
  where?: InputMaybe<Email_Templates_Ext_Bool_Exp>
}

export type Subscription_RootEmail_Templates_Ext_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootEmail_Templates_Ext_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Email_Templates_Ext_Stream_Cursor_Input>>
  where?: InputMaybe<Email_Templates_Ext_Bool_Exp>
}

export type Subscription_RootEmail_Templates_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Email_Templates_Stream_Cursor_Input>>
  where?: InputMaybe<Email_Templates_Bool_Exp>
}

export type Subscription_RootEnergy_Usage_Load_FactorsArgs = {
  distinct_on?: InputMaybe<Array<Energy_Usage_Load_Factors_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Energy_Usage_Load_Factors_Order_By>>
  where?: InputMaybe<Energy_Usage_Load_Factors_Bool_Exp>
}

export type Subscription_RootEnergy_Usage_Load_Factors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Energy_Usage_Load_Factors_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Energy_Usage_Load_Factors_Order_By>>
  where?: InputMaybe<Energy_Usage_Load_Factors_Bool_Exp>
}

export type Subscription_RootEnergy_Usage_Load_Factors_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootEnergy_Usage_Load_Factors_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Energy_Usage_Load_Factors_Stream_Cursor_Input>>
  where?: InputMaybe<Energy_Usage_Load_Factors_Bool_Exp>
}

export type Subscription_RootEnrolmentArgs = {
  distinct_on?: InputMaybe<Array<Enrolment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Enrolment_Order_By>>
  where?: InputMaybe<Enrolment_Bool_Exp>
}

export type Subscription_RootEnrolment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enrolment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Enrolment_Order_By>>
  where?: InputMaybe<Enrolment_Bool_Exp>
}

export type Subscription_RootEnrolment_Automated_CommunicationsArgs = {
  distinct_on?: InputMaybe<
    Array<Enrolment_Automated_Communications_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Enrolment_Automated_Communications_Order_By>>
  where?: InputMaybe<Enrolment_Automated_Communications_Bool_Exp>
}

export type Subscription_RootEnrolment_Automated_Communications_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Enrolment_Automated_Communications_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<Array<Enrolment_Automated_Communications_Order_By>>
    where?: InputMaybe<Enrolment_Automated_Communications_Bool_Exp>
  }

export type Subscription_RootEnrolment_Automated_Communications_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootEnrolment_Automated_Communications_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<
    InputMaybe<Enrolment_Automated_Communications_Stream_Cursor_Input>
  >
  where?: InputMaybe<Enrolment_Automated_Communications_Bool_Exp>
}

export type Subscription_RootEnrolment_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootEnrolment_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Enrolment_Stream_Cursor_Input>>
  where?: InputMaybe<Enrolment_Bool_Exp>
}

export type Subscription_RootEnrolments_Grouped_By_BrokerArgs = {
  args: Enrolments_Grouped_By_Broker_Arguments
  distinct_on?: InputMaybe<Array<Enrolments_Grouped_By_Broker_Model_Enum_Name>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Enrolments_Grouped_By_Broker_Model_Order_By>>
  where?: InputMaybe<Enrolments_Grouped_By_Broker_Model_Bool_Exp_Bool_Exp>
}

export type Subscription_RootEntity_MappingsArgs = {
  distinct_on?: InputMaybe<Array<Entity_Mappings_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Entity_Mappings_Order_By>>
  where?: InputMaybe<Entity_Mappings_Bool_Exp>
}

export type Subscription_RootEntity_Mappings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Mappings_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Entity_Mappings_Order_By>>
  where?: InputMaybe<Entity_Mappings_Bool_Exp>
}

export type Subscription_RootEntity_Mappings_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootEntity_Mappings_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Entity_Mappings_Stream_Cursor_Input>>
  where?: InputMaybe<Entity_Mappings_Bool_Exp>
}

export type Subscription_RootEstimated_UsageArgs = {
  distinct_on?: InputMaybe<Array<Estimated_Usage_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Estimated_Usage_Order_By>>
  where?: InputMaybe<Estimated_Usage_Bool_Exp>
}

export type Subscription_RootEstimated_Usage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Estimated_Usage_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Estimated_Usage_Order_By>>
  where?: InputMaybe<Estimated_Usage_Bool_Exp>
}

export type Subscription_RootEstimated_Usage_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootEstimated_Usage_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Estimated_Usage_Stream_Cursor_Input>>
  where?: InputMaybe<Estimated_Usage_Bool_Exp>
}

export type Subscription_RootEv_Smart_Tariff_WaitlistArgs = {
  distinct_on?: InputMaybe<Array<Ev_Smart_Tariff_Waitlist_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Ev_Smart_Tariff_Waitlist_Order_By>>
  where?: InputMaybe<Ev_Smart_Tariff_Waitlist_Bool_Exp>
}

export type Subscription_RootEv_Smart_Tariff_Waitlist_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ev_Smart_Tariff_Waitlist_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Ev_Smart_Tariff_Waitlist_Order_By>>
  where?: InputMaybe<Ev_Smart_Tariff_Waitlist_Bool_Exp>
}

export type Subscription_RootEv_Smart_Tariff_Waitlist_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootEv_Smart_Tariff_Waitlist_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Ev_Smart_Tariff_Waitlist_Stream_Cursor_Input>>
  where?: InputMaybe<Ev_Smart_Tariff_Waitlist_Bool_Exp>
}

export type Subscription_RootEv_Tariff_Eligibility_ChecksArgs = {
  distinct_on?: InputMaybe<Array<Ev_Tariff_Eligibility_Checks_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Ev_Tariff_Eligibility_Checks_Order_By>>
  where?: InputMaybe<Ev_Tariff_Eligibility_Checks_Bool_Exp>
}

export type Subscription_RootEv_Tariff_Eligibility_Checks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ev_Tariff_Eligibility_Checks_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Ev_Tariff_Eligibility_Checks_Order_By>>
  where?: InputMaybe<Ev_Tariff_Eligibility_Checks_Bool_Exp>
}

export type Subscription_RootEv_Tariff_Eligibility_Checks_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootEv_Tariff_Eligibility_Checks_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Ev_Tariff_Eligibility_Checks_Stream_Cursor_Input>>
  where?: InputMaybe<Ev_Tariff_Eligibility_Checks_Bool_Exp>
}

export type Subscription_RootFeatureArgs = {
  distinct_on?: InputMaybe<Array<Feature_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Feature_Order_By>>
  where?: InputMaybe<Feature_Bool_Exp>
}

export type Subscription_RootFeature_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Feature_Order_By>>
  where?: InputMaybe<Feature_Bool_Exp>
}

export type Subscription_RootFeature_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootFeature_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Feature_Stream_Cursor_Input>>
  where?: InputMaybe<Feature_Bool_Exp>
}

export type Subscription_RootFinancials_ConfigurationArgs = {
  distinct_on?: InputMaybe<Array<Financials_Configuration_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Configuration_Order_By>>
  where?: InputMaybe<Financials_Configuration_Bool_Exp>
}

export type Subscription_RootFinancials_Configuration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Configuration_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Configuration_Order_By>>
  where?: InputMaybe<Financials_Configuration_Bool_Exp>
}

export type Subscription_RootFinancials_Configuration_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootFinancials_Configuration_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Financials_Configuration_Stream_Cursor_Input>>
  where?: InputMaybe<Financials_Configuration_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Blob_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Blob_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Blob_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Blob_Triggers_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Blob_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Blob_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Blob_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Blob_Triggers_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Blob_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

export type Subscription_RootFinancials_Qrtz_Blob_Triggers_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Financials_Qrtz_Blob_Triggers_Stream_Cursor_Input>>
  where?: InputMaybe<Financials_Qrtz_Blob_Triggers_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_CalendarsArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Calendars_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Calendars_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Calendars_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Calendars_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Calendars_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Calendars_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Calendars_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Calendars_By_PkArgs = {
  calendar_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

export type Subscription_RootFinancials_Qrtz_Calendars_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Financials_Qrtz_Calendars_Stream_Cursor_Input>>
  where?: InputMaybe<Financials_Qrtz_Calendars_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Cron_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Cron_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Cron_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Cron_Triggers_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Cron_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Cron_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Cron_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Cron_Triggers_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Cron_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

export type Subscription_RootFinancials_Qrtz_Cron_Triggers_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Financials_Qrtz_Cron_Triggers_Stream_Cursor_Input>>
  where?: InputMaybe<Financials_Qrtz_Cron_Triggers_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Fired_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Fired_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Fired_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Fired_Triggers_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Fired_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Fired_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Fired_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Fired_Triggers_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Fired_Triggers_By_PkArgs = {
  entry_id: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

export type Subscription_RootFinancials_Qrtz_Fired_Triggers_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Financials_Qrtz_Fired_Triggers_Stream_Cursor_Input>>
  where?: InputMaybe<Financials_Qrtz_Fired_Triggers_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Job_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Job_Details_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Job_Details_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Job_Details_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Job_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Job_Details_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Job_Details_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Job_Details_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Job_Details_By_PkArgs = {
  job_group: Scalars["String"]["input"]
  job_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

export type Subscription_RootFinancials_Qrtz_Job_Details_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Financials_Qrtz_Job_Details_Stream_Cursor_Input>>
  where?: InputMaybe<Financials_Qrtz_Job_Details_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Scheduler_StateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Scheduler_State_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Scheduler_State_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Scheduler_State_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Scheduler_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Scheduler_State_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Scheduler_State_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Scheduler_State_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Scheduler_State_By_PkArgs = {
  instance_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

export type Subscription_RootFinancials_Qrtz_Scheduler_State_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Financials_Qrtz_Scheduler_State_Stream_Cursor_Input>>
  where?: InputMaybe<Financials_Qrtz_Scheduler_State_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Simple_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Simple_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Simple_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Simple_Triggers_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Simple_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Simple_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Simple_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Simple_Triggers_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Simple_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

export type Subscription_RootFinancials_Qrtz_Simple_Triggers_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Financials_Qrtz_Simple_Triggers_Stream_Cursor_Input>>
  where?: InputMaybe<Financials_Qrtz_Simple_Triggers_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Simprop_TriggersArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Qrtz_Simprop_Triggers_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Simprop_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Simprop_Triggers_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Simprop_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Qrtz_Simprop_Triggers_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Simprop_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Simprop_Triggers_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Simprop_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

export type Subscription_RootFinancials_Qrtz_Simprop_Triggers_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<
    InputMaybe<Financials_Qrtz_Simprop_Triggers_Stream_Cursor_Input>
  >
  where?: InputMaybe<Financials_Qrtz_Simprop_Triggers_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Triggers_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Qrtz_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Qrtz_Triggers_Order_By>>
  where?: InputMaybe<Financials_Qrtz_Triggers_Bool_Exp>
}

export type Subscription_RootFinancials_Qrtz_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

export type Subscription_RootFinancials_Qrtz_Triggers_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Financials_Qrtz_Triggers_Stream_Cursor_Input>>
  where?: InputMaybe<Financials_Qrtz_Triggers_Bool_Exp>
}

export type Subscription_RootFinancials_Warrant_Account_CriteriaArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrant_Account_Criteria_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrant_Account_Criteria_Order_By>>
  where?: InputMaybe<Financials_Warrant_Account_Criteria_Bool_Exp>
}

export type Subscription_RootFinancials_Warrant_Account_Criteria_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Financials_Warrant_Account_Criteria_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<Array<Financials_Warrant_Account_Criteria_Order_By>>
    where?: InputMaybe<Financials_Warrant_Account_Criteria_Bool_Exp>
  }

export type Subscription_RootFinancials_Warrant_Account_Criteria_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootFinancials_Warrant_Account_Criteria_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<
    InputMaybe<Financials_Warrant_Account_Criteria_Stream_Cursor_Input>
  >
  where?: InputMaybe<Financials_Warrant_Account_Criteria_Bool_Exp>
}

export type Subscription_RootFinancials_Warrant_Account_Sync_CriteriaArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrant_Account_Sync_Criteria_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Financials_Warrant_Account_Sync_Criteria_Order_By>
  >
  where?: InputMaybe<Financials_Warrant_Account_Sync_Criteria_Bool_Exp>
}

export type Subscription_RootFinancials_Warrant_Account_Sync_Criteria_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Financials_Warrant_Account_Sync_Criteria_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Financials_Warrant_Account_Sync_Criteria_Order_By>
    >
    where?: InputMaybe<Financials_Warrant_Account_Sync_Criteria_Bool_Exp>
  }

export type Subscription_RootFinancials_Warrant_Account_Sync_Criteria_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

export type Subscription_RootFinancials_Warrant_Account_Sync_Criteria_StreamArgs =
  {
    batch_size: Scalars["Int"]["input"]
    cursor: Array<
      InputMaybe<Financials_Warrant_Account_Sync_Criteria_Stream_Cursor_Input>
    >
    where?: InputMaybe<Financials_Warrant_Account_Sync_Criteria_Bool_Exp>
  }

export type Subscription_RootFinancials_Warrant_Communications_Sent_CountArgs =
  {
    distinct_on?: InputMaybe<
      Array<Financials_Warrant_Communications_Sent_Count_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Financials_Warrant_Communications_Sent_Count_Order_By>
    >
    where?: InputMaybe<Financials_Warrant_Communications_Sent_Count_Bool_Exp>
  }

export type Subscription_RootFinancials_Warrant_Communications_Sent_Count_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Financials_Warrant_Communications_Sent_Count_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Financials_Warrant_Communications_Sent_Count_Order_By>
    >
    where?: InputMaybe<Financials_Warrant_Communications_Sent_Count_Bool_Exp>
  }

export type Subscription_RootFinancials_Warrant_Communications_Sent_Count_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

export type Subscription_RootFinancials_Warrant_Communications_Sent_Count_StreamArgs =
  {
    batch_size: Scalars["Int"]["input"]
    cursor: Array<
      InputMaybe<Financials_Warrant_Communications_Sent_Count_Stream_Cursor_Input>
    >
    where?: InputMaybe<Financials_Warrant_Communications_Sent_Count_Bool_Exp>
  }

export type Subscription_RootFinancials_Warrants_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Financials_Warrants_Accounts_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Accounts_Order_By>>
  where?: InputMaybe<Financials_Warrants_Accounts_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Warrants_Accounts_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Accounts_Order_By>>
  where?: InputMaybe<Financials_Warrants_Accounts_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Accounts_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootFinancials_Warrants_Accounts_HistoryArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrants_Accounts_History_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Accounts_History_Order_By>>
  where?: InputMaybe<Financials_Warrants_Accounts_History_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Accounts_History_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Financials_Warrants_Accounts_History_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<Array<Financials_Warrants_Accounts_History_Order_By>>
    where?: InputMaybe<Financials_Warrants_Accounts_History_Bool_Exp>
  }

export type Subscription_RootFinancials_Warrants_Accounts_History_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootFinancials_Warrants_Accounts_History_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<
    InputMaybe<Financials_Warrants_Accounts_History_Stream_Cursor_Input>
  >
  where?: InputMaybe<Financials_Warrants_Accounts_History_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Accounts_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Financials_Warrants_Accounts_Stream_Cursor_Input>>
  where?: InputMaybe<Financials_Warrants_Accounts_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Accounts_WhitelistArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrants_Accounts_Whitelist_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Accounts_Whitelist_Order_By>>
  where?: InputMaybe<Financials_Warrants_Accounts_Whitelist_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Accounts_Whitelist_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Financials_Warrants_Accounts_Whitelist_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Financials_Warrants_Accounts_Whitelist_Order_By>
    >
    where?: InputMaybe<Financials_Warrants_Accounts_Whitelist_Bool_Exp>
  }

export type Subscription_RootFinancials_Warrants_Accounts_Whitelist_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

export type Subscription_RootFinancials_Warrants_Accounts_Whitelist_StreamArgs =
  {
    batch_size: Scalars["Int"]["input"]
    cursor: Array<
      InputMaybe<Financials_Warrants_Accounts_Whitelist_Stream_Cursor_Input>
    >
    where?: InputMaybe<Financials_Warrants_Accounts_Whitelist_Bool_Exp>
  }

export type Subscription_RootFinancials_Warrants_Communication_GroupArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrants_Communication_Group_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Communication_Group_Order_By>>
  where?: InputMaybe<Financials_Warrants_Communication_Group_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Communication_Group_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Financials_Warrants_Communication_Group_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Financials_Warrants_Communication_Group_Order_By>
    >
    where?: InputMaybe<Financials_Warrants_Communication_Group_Bool_Exp>
  }

export type Subscription_RootFinancials_Warrants_Communication_Group_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

export type Subscription_RootFinancials_Warrants_Communication_Group_StreamArgs =
  {
    batch_size: Scalars["Int"]["input"]
    cursor: Array<
      InputMaybe<Financials_Warrants_Communication_Group_Stream_Cursor_Input>
    >
    where?: InputMaybe<Financials_Warrants_Communication_Group_Bool_Exp>
  }

export type Subscription_RootFinancials_Warrants_CommunicationsArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrants_Communications_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Communications_Order_By>>
  where?: InputMaybe<Financials_Warrants_Communications_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Communications_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Financials_Warrants_Communications_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<Array<Financials_Warrants_Communications_Order_By>>
    where?: InputMaybe<Financials_Warrants_Communications_Bool_Exp>
  }

export type Subscription_RootFinancials_Warrants_Communications_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootFinancials_Warrants_Communications_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<
    InputMaybe<Financials_Warrants_Communications_Stream_Cursor_Input>
  >
  where?: InputMaybe<Financials_Warrants_Communications_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Dca_QueueArgs = {
  distinct_on?: InputMaybe<Array<Financials_Warrants_Dca_Queue_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Dca_Queue_Order_By>>
  where?: InputMaybe<Financials_Warrants_Dca_Queue_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Dca_Queue_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Warrants_Dca_Queue_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Dca_Queue_Order_By>>
  where?: InputMaybe<Financials_Warrants_Dca_Queue_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Dca_Queue_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootFinancials_Warrants_Dca_Queue_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Financials_Warrants_Dca_Queue_Stream_Cursor_Input>>
  where?: InputMaybe<Financials_Warrants_Dca_Queue_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Dca_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Financials_Warrants_Dca_Tickets_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Dca_Tickets_Order_By>>
  where?: InputMaybe<Financials_Warrants_Dca_Tickets_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Dca_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Warrants_Dca_Tickets_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Dca_Tickets_Order_By>>
  where?: InputMaybe<Financials_Warrants_Dca_Tickets_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Dca_Tickets_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootFinancials_Warrants_Dca_Tickets_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Financials_Warrants_Dca_Tickets_Stream_Cursor_Input>>
  where?: InputMaybe<Financials_Warrants_Dca_Tickets_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Files_AccountArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrants_Files_Account_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Files_Account_Order_By>>
  where?: InputMaybe<Financials_Warrants_Files_Account_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Files_Account_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrants_Files_Account_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Files_Account_Order_By>>
  where?: InputMaybe<Financials_Warrants_Files_Account_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Files_Account_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootFinancials_Warrants_Files_Account_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<
    InputMaybe<Financials_Warrants_Files_Account_Stream_Cursor_Input>
  >
  where?: InputMaybe<Financials_Warrants_Files_Account_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Files_JobArgs = {
  distinct_on?: InputMaybe<Array<Financials_Warrants_Files_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Files_Job_Order_By>>
  where?: InputMaybe<Financials_Warrants_Files_Job_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Files_Job_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Warrants_Files_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Files_Job_Order_By>>
  where?: InputMaybe<Financials_Warrants_Files_Job_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Files_Job_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootFinancials_Warrants_Files_Job_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Financials_Warrants_Files_Job_Stream_Cursor_Input>>
  where?: InputMaybe<Financials_Warrants_Files_Job_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Files_ProcessedArgs = {
  distinct_on?: InputMaybe<
    Array<Financials_Warrants_Files_Processed_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Files_Processed_Order_By>>
  where?: InputMaybe<Financials_Warrants_Files_Processed_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Files_Processed_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Financials_Warrants_Files_Processed_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<Array<Financials_Warrants_Files_Processed_Order_By>>
    where?: InputMaybe<Financials_Warrants_Files_Processed_Bool_Exp>
  }

export type Subscription_RootFinancials_Warrants_Files_Processed_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootFinancials_Warrants_Files_Processed_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<
    InputMaybe<Financials_Warrants_Files_Processed_Stream_Cursor_Input>
  >
  where?: InputMaybe<Financials_Warrants_Files_Processed_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_JobArgs = {
  distinct_on?: InputMaybe<Array<Financials_Warrants_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Job_Order_By>>
  where?: InputMaybe<Financials_Warrants_Job_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Job_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Financials_Warrants_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Financials_Warrants_Job_Order_By>>
  where?: InputMaybe<Financials_Warrants_Job_Bool_Exp>
}

export type Subscription_RootFinancials_Warrants_Job_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootFinancials_Warrants_Job_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Financials_Warrants_Job_Stream_Cursor_Input>>
  where?: InputMaybe<Financials_Warrants_Job_Bool_Exp>
}

export type Subscription_RootFind_Test_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Find_Test_Accounts_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Find_Test_Accounts_Order_By>>
  where?: InputMaybe<Find_Test_Accounts_Bool_Exp>
}

export type Subscription_RootFind_Test_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Find_Test_Accounts_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Find_Test_Accounts_Order_By>>
  where?: InputMaybe<Find_Test_Accounts_Bool_Exp>
}

export type Subscription_RootFind_Test_Accounts_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Find_Test_Accounts_Stream_Cursor_Input>>
  where?: InputMaybe<Find_Test_Accounts_Bool_Exp>
}

export type Subscription_RootFlex_Market_SubscriptionArgs = {
  distinct_on?: InputMaybe<Array<Flex_Market_Subscription_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Flex_Market_Subscription_Order_By>>
  where?: InputMaybe<Flex_Market_Subscription_Bool_Exp>
}

export type Subscription_RootFlex_Market_Subscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Flex_Market_Subscription_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Flex_Market_Subscription_Order_By>>
  where?: InputMaybe<Flex_Market_Subscription_Bool_Exp>
}

export type Subscription_RootFlex_Market_Subscription_BillingArgs = {
  distinct_on?: InputMaybe<
    Array<Flex_Market_Subscription_Billing_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Flex_Market_Subscription_Billing_Order_By>>
  where?: InputMaybe<Flex_Market_Subscription_Billing_Bool_Exp>
}

export type Subscription_RootFlex_Market_Subscription_Billing_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Flex_Market_Subscription_Billing_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Flex_Market_Subscription_Billing_Order_By>>
  where?: InputMaybe<Flex_Market_Subscription_Billing_Bool_Exp>
}

export type Subscription_RootFlex_Market_Subscription_Billing_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootFlex_Market_Subscription_Billing_ComponentArgs = {
  distinct_on?: InputMaybe<
    Array<Flex_Market_Subscription_Billing_Component_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Flex_Market_Subscription_Billing_Component_Order_By>
  >
  where?: InputMaybe<Flex_Market_Subscription_Billing_Component_Bool_Exp>
}

export type Subscription_RootFlex_Market_Subscription_Billing_Component_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Flex_Market_Subscription_Billing_Component_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Flex_Market_Subscription_Billing_Component_Order_By>
    >
    where?: InputMaybe<Flex_Market_Subscription_Billing_Component_Bool_Exp>
  }

export type Subscription_RootFlex_Market_Subscription_Billing_Component_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

export type Subscription_RootFlex_Market_Subscription_Billing_Component_StreamArgs =
  {
    batch_size: Scalars["Int"]["input"]
    cursor: Array<
      InputMaybe<Flex_Market_Subscription_Billing_Component_Stream_Cursor_Input>
    >
    where?: InputMaybe<Flex_Market_Subscription_Billing_Component_Bool_Exp>
  }

export type Subscription_RootFlex_Market_Subscription_Billing_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<
    InputMaybe<Flex_Market_Subscription_Billing_Stream_Cursor_Input>
  >
  where?: InputMaybe<Flex_Market_Subscription_Billing_Bool_Exp>
}

export type Subscription_RootFlex_Market_Subscription_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootFlex_Market_Subscription_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Flex_Market_Subscription_Stream_Cursor_Input>>
  where?: InputMaybe<Flex_Market_Subscription_Bool_Exp>
}

export type Subscription_RootFlyway_Schema_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Flyway_Schema_History_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Flyway_Schema_History_Order_By>>
  where?: InputMaybe<Flyway_Schema_History_Bool_Exp>
}

export type Subscription_RootFlyway_Schema_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Flyway_Schema_History_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Flyway_Schema_History_Order_By>>
  where?: InputMaybe<Flyway_Schema_History_Bool_Exp>
}

export type Subscription_RootFlyway_Schema_History_By_PkArgs = {
  installed_rank: Scalars["Int"]["input"]
}

export type Subscription_RootFlyway_Schema_History_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Flyway_Schema_History_Stream_Cursor_Input>>
  where?: InputMaybe<Flyway_Schema_History_Bool_Exp>
}

export type Subscription_RootFreshdesk_ContactArgs = {
  distinct_on?: InputMaybe<Array<Freshdesk_Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Freshdesk_Contact_Order_By>>
  where?: InputMaybe<Freshdesk_Contact_Bool_Exp>
}

export type Subscription_RootFreshdesk_Contact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Freshdesk_Contact_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Freshdesk_Contact_Order_By>>
  where?: InputMaybe<Freshdesk_Contact_Bool_Exp>
}

export type Subscription_RootFreshdesk_Contact_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Freshdesk_Contact_Stream_Cursor_Input>>
  where?: InputMaybe<Freshdesk_Contact_Bool_Exp>
}

export type Subscription_RootFreshdesk_TicketArgs = {
  distinct_on?: InputMaybe<Array<Freshdesk_Ticket_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Freshdesk_Ticket_Order_By>>
  where?: InputMaybe<Freshdesk_Ticket_Bool_Exp>
}

export type Subscription_RootFreshdesk_Ticket_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Freshdesk_Ticket_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Freshdesk_Ticket_Order_By>>
  where?: InputMaybe<Freshdesk_Ticket_Bool_Exp>
}

export type Subscription_RootFreshdesk_Ticket_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Freshdesk_Ticket_Stream_Cursor_Input>>
  where?: InputMaybe<Freshdesk_Ticket_Bool_Exp>
}

export type Subscription_RootFunction_Get_Smart_Meter_Dashboard_Data_From_View_V8Args =
  {
    args?: InputMaybe<Function_Get_Smart_Meter_Dashboard_Data_From_View_V8_Args>
    distinct_on?: InputMaybe<
      Array<Smart_Meter_Dashboard_Response_V7_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<Array<Smart_Meter_Dashboard_Response_V7_Order_By>>
    where?: InputMaybe<Smart_Meter_Dashboard_Response_V7_Bool_Exp>
  }

export type Subscription_RootFunction_Get_Smart_Meter_Dashboard_Data_From_View_V8_AggregateArgs =
  {
    args?: InputMaybe<Function_Get_Smart_Meter_Dashboard_Data_From_View_V8_Args>
    distinct_on?: InputMaybe<
      Array<Smart_Meter_Dashboard_Response_V7_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<Array<Smart_Meter_Dashboard_Response_V7_Order_By>>
    where?: InputMaybe<Smart_Meter_Dashboard_Response_V7_Bool_Exp>
  }

export type Subscription_RootInstall_CodesArgs = {
  distinct_on?: InputMaybe<Array<Install_Codes_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Install_Codes_Order_By>>
  where?: InputMaybe<Install_Codes_Bool_Exp>
}

export type Subscription_RootInstall_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Install_Codes_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Install_Codes_Order_By>>
  where?: InputMaybe<Install_Codes_Bool_Exp>
}

export type Subscription_RootInstall_Codes_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootInstall_Codes_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Install_Codes_Stream_Cursor_Input>>
  where?: InputMaybe<Install_Codes_Bool_Exp>
}

export type Subscription_RootJunifer__AccountArgs = {
  distinct_on?: InputMaybe<Array<Junifer__Account_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Junifer__Account_Order_By>>
  where?: InputMaybe<Junifer__Account_Bool_Exp>
}

export type Subscription_RootJunifer__AccountTransactionArgs = {
  distinct_on?: InputMaybe<Array<Junifer__AccountTransaction_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Junifer__AccountTransaction_Order_By>>
  where?: InputMaybe<Junifer__AccountTransaction_Bool_Exp>
}

export type Subscription_RootJunifer__AccountTransaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Junifer__AccountTransaction_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Junifer__AccountTransaction_Order_By>>
  where?: InputMaybe<Junifer__AccountTransaction_Bool_Exp>
}

export type Subscription_RootJunifer__AccountTransaction_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootJunifer__AccountTransaction_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Junifer__AccountTransaction_Stream_Cursor_Input>>
  where?: InputMaybe<Junifer__AccountTransaction_Bool_Exp>
}

export type Subscription_RootJunifer__Account_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Junifer__Account_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Junifer__Account_Order_By>>
  where?: InputMaybe<Junifer__Account_Bool_Exp>
}

export type Subscription_RootJunifer__Account_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootJunifer__Account_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Junifer__Account_Stream_Cursor_Input>>
  where?: InputMaybe<Junifer__Account_Bool_Exp>
}

export type Subscription_RootJunifer__CustomerArgs = {
  distinct_on?: InputMaybe<Array<Junifer__Customer_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Junifer__Customer_Order_By>>
  where?: InputMaybe<Junifer__Customer_Bool_Exp>
}

export type Subscription_RootJunifer__Customer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Junifer__Customer_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Junifer__Customer_Order_By>>
  where?: InputMaybe<Junifer__Customer_Bool_Exp>
}

export type Subscription_RootJunifer__Customer_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootJunifer__Customer_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Junifer__Customer_Stream_Cursor_Input>>
  where?: InputMaybe<Junifer__Customer_Bool_Exp>
}

export type Subscription_RootLast_Errored_SubmissionsArgs = {
  distinct_on?: InputMaybe<Array<Last_Errored_Submissions_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Last_Errored_Submissions_Order_By>>
  where?: InputMaybe<Last_Errored_Submissions_Bool_Exp>
}

export type Subscription_RootLast_Errored_Submissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Last_Errored_Submissions_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Last_Errored_Submissions_Order_By>>
  where?: InputMaybe<Last_Errored_Submissions_Bool_Exp>
}

export type Subscription_RootLast_Errored_Submissions_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Last_Errored_Submissions_Stream_Cursor_Input>>
  where?: InputMaybe<Last_Errored_Submissions_Bool_Exp>
}

export type Subscription_RootMeterArgs = {
  distinct_on?: InputMaybe<Array<Meter_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Order_By>>
  where?: InputMaybe<Meter_Bool_Exp>
}

export type Subscription_RootMeter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Order_By>>
  where?: InputMaybe<Meter_Bool_Exp>
}

export type Subscription_RootMeter_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootMeter_Meter_Point_RelArgs = {
  distinct_on?: InputMaybe<Array<Meter_Meter_Point_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Meter_Point_Rel_Order_By>>
  where?: InputMaybe<Meter_Meter_Point_Rel_Bool_Exp>
}

export type Subscription_RootMeter_Meter_Point_Rel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Meter_Point_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Meter_Point_Rel_Order_By>>
  where?: InputMaybe<Meter_Meter_Point_Rel_Bool_Exp>
}

export type Subscription_RootMeter_Meter_Point_Rel_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootMeter_Meter_Point_Rel_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Meter_Meter_Point_Rel_Stream_Cursor_Input>>
  where?: InputMaybe<Meter_Meter_Point_Rel_Bool_Exp>
}

export type Subscription_RootMeter_PointArgs = {
  distinct_on?: InputMaybe<Array<Meter_Point_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Point_Order_By>>
  where?: InputMaybe<Meter_Point_Bool_Exp>
}

export type Subscription_RootMeter_Point_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Point_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Point_Order_By>>
  where?: InputMaybe<Meter_Point_Bool_Exp>
}

export type Subscription_RootMeter_Point_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootMeter_Point_ElectricityArgs = {
  distinct_on?: InputMaybe<Array<Meter_Point_Electricity_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Point_Electricity_Order_By>>
  where?: InputMaybe<Meter_Point_Electricity_Bool_Exp>
}

export type Subscription_RootMeter_Point_Electricity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Point_Electricity_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Point_Electricity_Order_By>>
  where?: InputMaybe<Meter_Point_Electricity_Bool_Exp>
}

export type Subscription_RootMeter_Point_Electricity_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootMeter_Point_Electricity_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Meter_Point_Electricity_Stream_Cursor_Input>>
  where?: InputMaybe<Meter_Point_Electricity_Bool_Exp>
}

export type Subscription_RootMeter_Point_GasArgs = {
  distinct_on?: InputMaybe<Array<Meter_Point_Gas_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Point_Gas_Order_By>>
  where?: InputMaybe<Meter_Point_Gas_Bool_Exp>
}

export type Subscription_RootMeter_Point_Gas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Point_Gas_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Point_Gas_Order_By>>
  where?: InputMaybe<Meter_Point_Gas_Bool_Exp>
}

export type Subscription_RootMeter_Point_Gas_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootMeter_Point_Gas_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Meter_Point_Gas_Stream_Cursor_Input>>
  where?: InputMaybe<Meter_Point_Gas_Bool_Exp>
}

export type Subscription_RootMeter_Point_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Meter_Point_History_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Point_History_Order_By>>
  where?: InputMaybe<Meter_Point_History_Bool_Exp>
}

export type Subscription_RootMeter_Point_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Point_History_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Point_History_Order_By>>
  where?: InputMaybe<Meter_Point_History_Bool_Exp>
}

export type Subscription_RootMeter_Point_History_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootMeter_Point_History_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Meter_Point_History_Stream_Cursor_Input>>
  where?: InputMaybe<Meter_Point_History_Bool_Exp>
}

export type Subscription_RootMeter_Point_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Meter_Point_Stream_Cursor_Input>>
  where?: InputMaybe<Meter_Point_Bool_Exp>
}

export type Subscription_RootMeter_ReadingArgs = {
  distinct_on?: InputMaybe<Array<Meter_Reading_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Reading_Order_By>>
  where?: InputMaybe<Meter_Reading_Bool_Exp>
}

export type Subscription_RootMeter_Reading_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Reading_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Reading_Order_By>>
  where?: InputMaybe<Meter_Reading_Bool_Exp>
}

export type Subscription_RootMeter_Reading_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootMeter_Reading_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Meter_Reading_Stream_Cursor_Input>>
  where?: InputMaybe<Meter_Reading_Bool_Exp>
}

export type Subscription_RootMeter_Reading_Submission_RequestArgs = {
  distinct_on?: InputMaybe<
    Array<Meter_Reading_Submission_Request_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Reading_Submission_Request_Order_By>>
  where?: InputMaybe<Meter_Reading_Submission_Request_Bool_Exp>
}

export type Subscription_RootMeter_Reading_Submission_Request_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Meter_Reading_Submission_Request_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Reading_Submission_Request_Order_By>>
  where?: InputMaybe<Meter_Reading_Submission_Request_Bool_Exp>
}

export type Subscription_RootMeter_Reading_Submission_Request_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootMeter_Reading_Submission_Request_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<
    InputMaybe<Meter_Reading_Submission_Request_Stream_Cursor_Input>
  >
  where?: InputMaybe<Meter_Reading_Submission_Request_Bool_Exp>
}

export type Subscription_RootMeter_Reading_Submission_TokensArgs = {
  distinct_on?: InputMaybe<Array<Meter_Reading_Submission_Tokens_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Reading_Submission_Tokens_Order_By>>
  where?: InputMaybe<Meter_Reading_Submission_Tokens_Bool_Exp>
}

export type Subscription_RootMeter_Reading_Submission_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Meter_Reading_Submission_Tokens_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Meter_Reading_Submission_Tokens_Order_By>>
  where?: InputMaybe<Meter_Reading_Submission_Tokens_Bool_Exp>
}

export type Subscription_RootMeter_Reading_Submission_Tokens_By_PkArgs = {
  hashed_token: Scalars["String"]["input"]
  junifer_account_id: Scalars["Int"]["input"]
}

export type Subscription_RootMeter_Reading_Submission_Tokens_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Meter_Reading_Submission_Tokens_Stream_Cursor_Input>>
  where?: InputMaybe<Meter_Reading_Submission_Tokens_Bool_Exp>
}

export type Subscription_RootMeter_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Meter_Stream_Cursor_Input>>
  where?: InputMaybe<Meter_Bool_Exp>
}

export type Subscription_RootMissing_Contact_DetailsArgs = {
  args: Missing_Contact_Details_Arguments
  distinct_on?: InputMaybe<Array<Missing_Contact_Details_Model_Enum_Name>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Missing_Contact_Details_Model_Order_By>>
  where?: InputMaybe<Missing_Contact_Details_Model_Bool_Exp_Bool_Exp>
}

export type Subscription_RootNoteArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Note_Order_By>>
  where?: InputMaybe<Note_Bool_Exp>
}

export type Subscription_RootNote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Note_Order_By>>
  where?: InputMaybe<Note_Bool_Exp>
}

export type Subscription_RootNote_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootNote_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Note_Stream_Cursor_Input>>
  where?: InputMaybe<Note_Bool_Exp>
}

export type Subscription_RootNova_SubmissionsArgs = {
  distinct_on?: InputMaybe<Array<Nova_Submissions_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Nova_Submissions_Order_By>>
  where?: InputMaybe<Nova_Submissions_Bool_Exp>
}

export type Subscription_RootNova_Submissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nova_Submissions_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Nova_Submissions_Order_By>>
  where?: InputMaybe<Nova_Submissions_Bool_Exp>
}

export type Subscription_RootNova_Submissions_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Nova_Submissions_Stream_Cursor_Input>>
  where?: InputMaybe<Nova_Submissions_Bool_Exp>
}

export type Subscription_RootOutbound_Photo_RequestArgs = {
  distinct_on?: InputMaybe<Array<Outbound_Photo_Request_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Outbound_Photo_Request_Order_By>>
  where?: InputMaybe<Outbound_Photo_Request_Bool_Exp>
}

export type Subscription_RootOutbound_Photo_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Outbound_Photo_Request_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Outbound_Photo_Request_Order_By>>
  where?: InputMaybe<Outbound_Photo_Request_Bool_Exp>
}

export type Subscription_RootOutbound_Photo_Request_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootOutbound_Photo_Request_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Outbound_Photo_Request_Stream_Cursor_Input>>
  where?: InputMaybe<Outbound_Photo_Request_Bool_Exp>
}

export type Subscription_RootPassword_Reset_TokensArgs = {
  distinct_on?: InputMaybe<Array<Password_Reset_Tokens_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Password_Reset_Tokens_Order_By>>
  where?: InputMaybe<Password_Reset_Tokens_Bool_Exp>
}

export type Subscription_RootPassword_Reset_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Password_Reset_Tokens_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Password_Reset_Tokens_Order_By>>
  where?: InputMaybe<Password_Reset_Tokens_Bool_Exp>
}

export type Subscription_RootPassword_Reset_Tokens_By_PkArgs = {
  token: Scalars["bytea"]["input"]
  user_id: Scalars["bigint"]["input"]
}

export type Subscription_RootPassword_Reset_Tokens_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Password_Reset_Tokens_Stream_Cursor_Input>>
  where?: InputMaybe<Password_Reset_Tokens_Bool_Exp>
}

export type Subscription_RootPaymentArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Order_By>>
  where?: InputMaybe<Payment_Bool_Exp>
}

export type Subscription_RootPayment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Order_By>>
  where?: InputMaybe<Payment_Bool_Exp>
}

export type Subscription_RootPayment_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootPayment_MethodArgs = {
  distinct_on?: InputMaybe<Array<Payment_Method_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Method_Order_By>>
  where?: InputMaybe<Payment_Method_Bool_Exp>
}

export type Subscription_RootPayment_Method_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Method_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Method_Order_By>>
  where?: InputMaybe<Payment_Method_Bool_Exp>
}

export type Subscription_RootPayment_Method_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootPayment_Method_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Payment_Method_Stream_Cursor_Input>>
  where?: InputMaybe<Payment_Method_Bool_Exp>
}

export type Subscription_RootPayment_Review_Account_Balance_Reserve_RatesArgs =
  {
    distinct_on?: InputMaybe<
      Array<Payment_Review_Account_Balance_Reserve_Rates_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Payment_Review_Account_Balance_Reserve_Rates_Order_By>
    >
    where?: InputMaybe<Payment_Review_Account_Balance_Reserve_Rates_Bool_Exp>
  }

export type Subscription_RootPayment_Review_Account_Balance_Reserve_Rates_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Payment_Review_Account_Balance_Reserve_Rates_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Payment_Review_Account_Balance_Reserve_Rates_Order_By>
    >
    where?: InputMaybe<Payment_Review_Account_Balance_Reserve_Rates_Bool_Exp>
  }

export type Subscription_RootPayment_Review_Account_Balance_Reserve_Rates_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

export type Subscription_RootPayment_Review_Account_Balance_Reserve_Rates_StreamArgs =
  {
    batch_size: Scalars["Int"]["input"]
    cursor: Array<
      InputMaybe<Payment_Review_Account_Balance_Reserve_Rates_Stream_Cursor_Input>
    >
    where?: InputMaybe<Payment_Review_Account_Balance_Reserve_Rates_Bool_Exp>
  }

export type Subscription_RootPayment_Review_Account_ExclusionsArgs = {
  distinct_on?: InputMaybe<
    Array<Payment_Review_Account_Exclusions_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Account_Exclusions_Order_By>>
  where?: InputMaybe<Payment_Review_Account_Exclusions_Bool_Exp>
}

export type Subscription_RootPayment_Review_Account_Exclusions_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Payment_Review_Account_Exclusions_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Account_Exclusions_Order_By>>
  where?: InputMaybe<Payment_Review_Account_Exclusions_Bool_Exp>
}

export type Subscription_RootPayment_Review_Account_Exclusions_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootPayment_Review_Account_Exclusions_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<
    InputMaybe<Payment_Review_Account_Exclusions_Stream_Cursor_Input>
  >
  where?: InputMaybe<Payment_Review_Account_Exclusions_Bool_Exp>
}

export type Subscription_RootPayment_Review_CalculationArgs = {
  distinct_on?: InputMaybe<Array<Payment_Review_Calculation_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Calculation_Order_By>>
  where?: InputMaybe<Payment_Review_Calculation_Bool_Exp>
}

export type Subscription_RootPayment_Review_Calculation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Review_Calculation_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Calculation_Order_By>>
  where?: InputMaybe<Payment_Review_Calculation_Bool_Exp>
}

export type Subscription_RootPayment_Review_Calculation_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootPayment_Review_Calculation_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Payment_Review_Calculation_Stream_Cursor_Input>>
  where?: InputMaybe<Payment_Review_Calculation_Bool_Exp>
}

export type Subscription_RootPayment_Review_Dashboard_SummaryArgs = {
  args: Payment_Review_Dashboard_Summary_Arguments
  distinct_on?: InputMaybe<
    Array<Payment_Review_Dashboard_Summary_Model_Enum_Name>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Dashboard_Summary_Model_Order_By>>
  where?: InputMaybe<Payment_Review_Dashboard_Summary_Model_Bool_Exp_Bool_Exp>
}

export type Subscription_RootPayment_Review_Future_Product_RatesArgs = {
  distinct_on?: InputMaybe<
    Array<Payment_Review_Future_Product_Rates_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Future_Product_Rates_Order_By>>
  where?: InputMaybe<Payment_Review_Future_Product_Rates_Bool_Exp>
}

export type Subscription_RootPayment_Review_Future_Product_Rates_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Payment_Review_Future_Product_Rates_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<Array<Payment_Review_Future_Product_Rates_Order_By>>
    where?: InputMaybe<Payment_Review_Future_Product_Rates_Bool_Exp>
  }

export type Subscription_RootPayment_Review_Future_Product_Rates_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootPayment_Review_Future_Product_Rates_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<
    InputMaybe<Payment_Review_Future_Product_Rates_Stream_Cursor_Input>
  >
  where?: InputMaybe<Payment_Review_Future_Product_Rates_Bool_Exp>
}

export type Subscription_RootPayment_Review_Record_EmailsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Review_Record_Emails_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Record_Emails_Order_By>>
  where?: InputMaybe<Payment_Review_Record_Emails_Bool_Exp>
}

export type Subscription_RootPayment_Review_Record_Emails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Review_Record_Emails_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Record_Emails_Order_By>>
  where?: InputMaybe<Payment_Review_Record_Emails_Bool_Exp>
}

export type Subscription_RootPayment_Review_Record_Emails_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootPayment_Review_Record_Emails_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Payment_Review_Record_Emails_Stream_Cursor_Input>>
  where?: InputMaybe<Payment_Review_Record_Emails_Bool_Exp>
}

export type Subscription_RootPayment_Review_Record_NotesArgs = {
  distinct_on?: InputMaybe<Array<Payment_Review_Record_Notes_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Record_Notes_Order_By>>
  where?: InputMaybe<Payment_Review_Record_Notes_Bool_Exp>
}

export type Subscription_RootPayment_Review_Record_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Review_Record_Notes_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Record_Notes_Order_By>>
  where?: InputMaybe<Payment_Review_Record_Notes_Bool_Exp>
}

export type Subscription_RootPayment_Review_Record_Notes_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootPayment_Review_Record_Notes_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Payment_Review_Record_Notes_Stream_Cursor_Input>>
  where?: InputMaybe<Payment_Review_Record_Notes_Bool_Exp>
}

export type Subscription_RootPayment_Review_RecordsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Review_Records_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Records_Order_By>>
  where?: InputMaybe<Payment_Review_Records_Bool_Exp>
}

export type Subscription_RootPayment_Review_Records_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Review_Records_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Records_Order_By>>
  where?: InputMaybe<Payment_Review_Records_Bool_Exp>
}

export type Subscription_RootPayment_Review_Records_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootPayment_Review_Records_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Payment_Review_Records_Stream_Cursor_Input>>
  where?: InputMaybe<Payment_Review_Records_Bool_Exp>
}

export type Subscription_RootPayment_Review_Records_ViewArgs = {
  distinct_on?: InputMaybe<Array<Payment_Review_Records_View_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Records_View_Order_By>>
  where?: InputMaybe<Payment_Review_Records_View_Bool_Exp>
}

export type Subscription_RootPayment_Review_Records_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Review_Records_View_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Review_Records_View_Order_By>>
  where?: InputMaybe<Payment_Review_Records_View_Bool_Exp>
}

export type Subscription_RootPayment_Review_Records_View_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Payment_Review_Records_View_Stream_Cursor_Input>>
  where?: InputMaybe<Payment_Review_Records_View_Bool_Exp>
}

export type Subscription_RootPayment_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Reviews_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Reviews_Order_By>>
  where?: InputMaybe<Payment_Reviews_Bool_Exp>
}

export type Subscription_RootPayment_Reviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Reviews_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Reviews_Order_By>>
  where?: InputMaybe<Payment_Reviews_Bool_Exp>
}

export type Subscription_RootPayment_Reviews_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootPayment_Reviews_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Payment_Reviews_Stream_Cursor_Input>>
  where?: InputMaybe<Payment_Reviews_Bool_Exp>
}

export type Subscription_RootPayment_ScheduleArgs = {
  distinct_on?: InputMaybe<Array<Payment_Schedule_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Schedule_Order_By>>
  where?: InputMaybe<Payment_Schedule_Bool_Exp>
}

export type Subscription_RootPayment_Schedule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Schedule_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Payment_Schedule_Order_By>>
  where?: InputMaybe<Payment_Schedule_Bool_Exp>
}

export type Subscription_RootPayment_Schedule_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootPayment_Schedule_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Payment_Schedule_Stream_Cursor_Input>>
  where?: InputMaybe<Payment_Schedule_Bool_Exp>
}

export type Subscription_RootPayment_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Payment_Stream_Cursor_Input>>
  where?: InputMaybe<Payment_Bool_Exp>
}

export type Subscription_RootPostcode_Gsp_CacheArgs = {
  distinct_on?: InputMaybe<Array<Postcode_Gsp_Cache_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Postcode_Gsp_Cache_Order_By>>
  where?: InputMaybe<Postcode_Gsp_Cache_Bool_Exp>
}

export type Subscription_RootPostcode_Gsp_Cache_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Postcode_Gsp_Cache_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Postcode_Gsp_Cache_Order_By>>
  where?: InputMaybe<Postcode_Gsp_Cache_Bool_Exp>
}

export type Subscription_RootPostcode_Gsp_Cache_By_PkArgs = {
  postcode: Scalars["String"]["input"]
}

export type Subscription_RootPostcode_Gsp_Cache_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Postcode_Gsp_Cache_Stream_Cursor_Input>>
  where?: InputMaybe<Postcode_Gsp_Cache_Bool_Exp>
}

export type Subscription_RootProductArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Order_By>>
  where?: InputMaybe<Product_Bool_Exp>
}

export type Subscription_RootProduct_AccountArgs = {
  distinct_on?: InputMaybe<Array<Product_Account_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Account_Order_By>>
  where?: InputMaybe<Product_Account_Bool_Exp>
}

export type Subscription_RootProduct_Account_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Account_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Account_Order_By>>
  where?: InputMaybe<Product_Account_Bool_Exp>
}

export type Subscription_RootProduct_Account_Agreement_RelArgs = {
  distinct_on?: InputMaybe<Array<Product_Account_Agreement_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Account_Agreement_Rel_Order_By>>
  where?: InputMaybe<Product_Account_Agreement_Rel_Bool_Exp>
}

export type Subscription_RootProduct_Account_Agreement_Rel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Account_Agreement_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Account_Agreement_Rel_Order_By>>
  where?: InputMaybe<Product_Account_Agreement_Rel_Bool_Exp>
}

export type Subscription_RootProduct_Account_Agreement_Rel_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootProduct_Account_Agreement_Rel_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Product_Account_Agreement_Rel_Stream_Cursor_Input>>
  where?: InputMaybe<Product_Account_Agreement_Rel_Bool_Exp>
}

export type Subscription_RootProduct_Account_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootProduct_Account_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Product_Account_Stream_Cursor_Input>>
  where?: InputMaybe<Product_Account_Bool_Exp>
}

export type Subscription_RootProduct_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Order_By>>
  where?: InputMaybe<Product_Bool_Exp>
}

export type Subscription_RootProduct_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootProduct_ElecArgs = {
  distinct_on?: InputMaybe<Array<Product_Elec_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Elec_Order_By>>
  where?: InputMaybe<Product_Elec_Bool_Exp>
}

export type Subscription_RootProduct_Elec_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Elec_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Elec_Order_By>>
  where?: InputMaybe<Product_Elec_Bool_Exp>
}

export type Subscription_RootProduct_Elec_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootProduct_Elec_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Product_Elec_Stream_Cursor_Input>>
  where?: InputMaybe<Product_Elec_Bool_Exp>
}

export type Subscription_RootProduct_GasArgs = {
  distinct_on?: InputMaybe<Array<Product_Gas_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Gas_Order_By>>
  where?: InputMaybe<Product_Gas_Bool_Exp>
}

export type Subscription_RootProduct_Gas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Gas_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Gas_Order_By>>
  where?: InputMaybe<Product_Gas_Bool_Exp>
}

export type Subscription_RootProduct_Gas_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootProduct_Gas_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Product_Gas_Stream_Cursor_Input>>
  where?: InputMaybe<Product_Gas_Bool_Exp>
}

export type Subscription_RootProduct_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Product_Stream_Cursor_Input>>
  where?: InputMaybe<Product_Bool_Exp>
}

export type Subscription_RootProduct_VariantArgs = {
  distinct_on?: InputMaybe<Array<Product_Variant_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Variant_Order_By>>
  where?: InputMaybe<Product_Variant_Bool_Exp>
}

export type Subscription_RootProduct_Variant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variant_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Variant_Order_By>>
  where?: InputMaybe<Product_Variant_Bool_Exp>
}

export type Subscription_RootProduct_Variant_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootProduct_Variant_ElecArgs = {
  distinct_on?: InputMaybe<Array<Product_Variant_Elec_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Variant_Elec_Order_By>>
  where?: InputMaybe<Product_Variant_Elec_Bool_Exp>
}

export type Subscription_RootProduct_Variant_Elec_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variant_Elec_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Variant_Elec_Order_By>>
  where?: InputMaybe<Product_Variant_Elec_Bool_Exp>
}

export type Subscription_RootProduct_Variant_Elec_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootProduct_Variant_Elec_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Product_Variant_Elec_Stream_Cursor_Input>>
  where?: InputMaybe<Product_Variant_Elec_Bool_Exp>
}

export type Subscription_RootProduct_Variant_GasArgs = {
  distinct_on?: InputMaybe<Array<Product_Variant_Gas_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Variant_Gas_Order_By>>
  where?: InputMaybe<Product_Variant_Gas_Bool_Exp>
}

export type Subscription_RootProduct_Variant_Gas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Variant_Gas_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_Variant_Gas_Order_By>>
  where?: InputMaybe<Product_Variant_Gas_Bool_Exp>
}

export type Subscription_RootProduct_Variant_Gas_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootProduct_Variant_Gas_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Product_Variant_Gas_Stream_Cursor_Input>>
  where?: InputMaybe<Product_Variant_Gas_Bool_Exp>
}

export type Subscription_RootProduct_Variant_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Product_Variant_Stream_Cursor_Input>>
  where?: InputMaybe<Product_Variant_Bool_Exp>
}

export type Subscription_RootProduct_ViewArgs = {
  distinct_on?: InputMaybe<Array<Product_View_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_View_Order_By>>
  where?: InputMaybe<Product_View_Bool_Exp>
}

export type Subscription_RootProduct_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_View_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Product_View_Order_By>>
  where?: InputMaybe<Product_View_Bool_Exp>
}

export type Subscription_RootProduct_View_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Product_View_Stream_Cursor_Input>>
  where?: InputMaybe<Product_View_Bool_Exp>
}

export type Subscription_RootPropertyArgs = {
  distinct_on?: InputMaybe<Array<Property_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Property_Order_By>>
  where?: InputMaybe<Property_Bool_Exp>
}

export type Subscription_RootProperty_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Property_Order_By>>
  where?: InputMaybe<Property_Bool_Exp>
}

export type Subscription_RootProperty_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootProperty_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Property_Stream_Cursor_Input>>
  where?: InputMaybe<Property_Bool_Exp>
}

export type Subscription_RootPsrArgs = {
  distinct_on?: InputMaybe<Array<Psr_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Psr_Order_By>>
  where?: InputMaybe<Psr_Bool_Exp>
}

export type Subscription_RootPsr_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Psr_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Psr_Order_By>>
  where?: InputMaybe<Psr_Bool_Exp>
}

export type Subscription_RootPsr_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootPsr_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Psr_Stream_Cursor_Input>>
  where?: InputMaybe<Psr_Bool_Exp>
}

export type Subscription_RootQuoteArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Quote_Order_By>>
  where?: InputMaybe<Quote_Bool_Exp>
}

export type Subscription_RootQuote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Quote_Order_By>>
  where?: InputMaybe<Quote_Bool_Exp>
}

export type Subscription_RootQuote_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootQuote_RequestArgs = {
  distinct_on?: InputMaybe<Array<Quote_Request_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Quote_Request_Order_By>>
  where?: InputMaybe<Quote_Request_Bool_Exp>
}

export type Subscription_RootQuote_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Request_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Quote_Request_Order_By>>
  where?: InputMaybe<Quote_Request_Bool_Exp>
}

export type Subscription_RootQuote_Request_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootQuote_Request_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Quote_Request_Stream_Cursor_Input>>
  where?: InputMaybe<Quote_Request_Bool_Exp>
}

export type Subscription_RootQuote_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Quote_Stream_Cursor_Input>>
  where?: InputMaybe<Quote_Bool_Exp>
}

export type Subscription_RootRecipientsArgs = {
  distinct_on?: InputMaybe<Array<Recipients_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Recipients_Order_By>>
  where?: InputMaybe<Recipients_Bool_Exp>
}

export type Subscription_RootRecipients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Recipients_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Recipients_Order_By>>
  where?: InputMaybe<Recipients_Bool_Exp>
}

export type Subscription_RootRecipients_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootRecipients_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Recipients_Stream_Cursor_Input>>
  where?: InputMaybe<Recipients_Bool_Exp>
}

export type Subscription_RootRefresh_TokensArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Tokens_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Refresh_Tokens_Order_By>>
  where?: InputMaybe<Refresh_Tokens_Bool_Exp>
}

export type Subscription_RootRefresh_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Tokens_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Refresh_Tokens_Order_By>>
  where?: InputMaybe<Refresh_Tokens_Bool_Exp>
}

export type Subscription_RootRefresh_Tokens_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Refresh_Tokens_Stream_Cursor_Input>>
  where?: InputMaybe<Refresh_Tokens_Bool_Exp>
}

export type Subscription_RootRefundsArgs = {
  distinct_on?: InputMaybe<Array<Refunds_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Refunds_Order_By>>
  where?: InputMaybe<Refunds_Bool_Exp>
}

export type Subscription_RootRefunds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refunds_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Refunds_Order_By>>
  where?: InputMaybe<Refunds_Bool_Exp>
}

export type Subscription_RootRefunds_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootRefunds_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Refunds_Stream_Cursor_Input>>
  where?: InputMaybe<Refunds_Bool_Exp>
}

export type Subscription_RootRegisterArgs = {
  distinct_on?: InputMaybe<Array<Register_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Register_Order_By>>
  where?: InputMaybe<Register_Bool_Exp>
}

export type Subscription_RootRegister_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Register_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Register_Order_By>>
  where?: InputMaybe<Register_Bool_Exp>
}

export type Subscription_RootRegister_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootRegister_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Register_Stream_Cursor_Input>>
  where?: InputMaybe<Register_Bool_Exp>
}

export type Subscription_RootRegistration_Credit_CheckArgs = {
  distinct_on?: InputMaybe<Array<Registration_Credit_Check_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Registration_Credit_Check_Order_By>>
  where?: InputMaybe<Registration_Credit_Check_Bool_Exp>
}

export type Subscription_RootRegistration_Credit_Check_AddressArgs = {
  distinct_on?: InputMaybe<
    Array<Registration_Credit_Check_Address_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Registration_Credit_Check_Address_Order_By>>
  where?: InputMaybe<Registration_Credit_Check_Address_Bool_Exp>
}

export type Subscription_RootRegistration_Credit_Check_Address_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Registration_Credit_Check_Address_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Registration_Credit_Check_Address_Order_By>>
  where?: InputMaybe<Registration_Credit_Check_Address_Bool_Exp>
}

export type Subscription_RootRegistration_Credit_Check_Address_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootRegistration_Credit_Check_Address_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<
    InputMaybe<Registration_Credit_Check_Address_Stream_Cursor_Input>
  >
  where?: InputMaybe<Registration_Credit_Check_Address_Bool_Exp>
}

export type Subscription_RootRegistration_Credit_Check_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Registration_Credit_Check_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Registration_Credit_Check_Order_By>>
  where?: InputMaybe<Registration_Credit_Check_Bool_Exp>
}

export type Subscription_RootRegistration_Credit_Check_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootRegistration_Credit_Check_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Registration_Credit_Check_Stream_Cursor_Input>>
  where?: InputMaybe<Registration_Credit_Check_Bool_Exp>
}

export type Subscription_RootReminderArgs = {
  distinct_on?: InputMaybe<Array<Reminder_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Reminder_Order_By>>
  where?: InputMaybe<Reminder_Bool_Exp>
}

export type Subscription_RootReminder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reminder_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Reminder_Order_By>>
  where?: InputMaybe<Reminder_Bool_Exp>
}

export type Subscription_RootReminder_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootReminder_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Reminder_Stream_Cursor_Input>>
  where?: InputMaybe<Reminder_Bool_Exp>
}

export type Subscription_RootRenewalArgs = {
  distinct_on?: InputMaybe<Array<Renewal_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Renewal_Order_By>>
  where?: InputMaybe<Renewal_Bool_Exp>
}

export type Subscription_RootRenewal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Renewal_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Renewal_Order_By>>
  where?: InputMaybe<Renewal_Bool_Exp>
}

export type Subscription_RootRenewal_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootRenewal_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Renewal_Stream_Cursor_Input>>
  where?: InputMaybe<Renewal_Bool_Exp>
}

export type Subscription_RootReport_ProblemArgs = {
  distinct_on?: InputMaybe<Array<Report_Problem_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Report_Problem_Order_By>>
  where?: InputMaybe<Report_Problem_Bool_Exp>
}

export type Subscription_RootReport_Problem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Problem_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Report_Problem_Order_By>>
  where?: InputMaybe<Report_Problem_Bool_Exp>
}

export type Subscription_RootReport_Problem_AttachmentsArgs = {
  distinct_on?: InputMaybe<Array<Report_Problem_Attachments_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Report_Problem_Attachments_Order_By>>
  where?: InputMaybe<Report_Problem_Attachments_Bool_Exp>
}

export type Subscription_RootReport_Problem_Attachments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Problem_Attachments_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Report_Problem_Attachments_Order_By>>
  where?: InputMaybe<Report_Problem_Attachments_Bool_Exp>
}

export type Subscription_RootReport_Problem_Attachments_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootReport_Problem_Attachments_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Report_Problem_Attachments_Stream_Cursor_Input>>
  where?: InputMaybe<Report_Problem_Attachments_Bool_Exp>
}

export type Subscription_RootReport_Problem_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootReport_Problem_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Report_Problem_Stream_Cursor_Input>>
  where?: InputMaybe<Report_Problem_Bool_Exp>
}

export type Subscription_RootRequestsArgs = {
  distinct_on?: InputMaybe<Array<Requests_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Requests_Order_By>>
  where?: InputMaybe<Requests_Bool_Exp>
}

export type Subscription_RootRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Requests_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Requests_Order_By>>
  where?: InputMaybe<Requests_Bool_Exp>
}

export type Subscription_RootRequests_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootRequests_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Requests_Stream_Cursor_Input>>
  where?: InputMaybe<Requests_Bool_Exp>
}

export type Subscription_RootRts_Meters_ReportArgs = {
  distinct_on?: InputMaybe<Array<Rts_Meters_Report_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Rts_Meters_Report_Order_By>>
  where?: InputMaybe<Rts_Meters_Report_Bool_Exp>
}

export type Subscription_RootRts_Meters_Report_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rts_Meters_Report_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Rts_Meters_Report_Order_By>>
  where?: InputMaybe<Rts_Meters_Report_Bool_Exp>
}

export type Subscription_RootRts_Meters_Report_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Rts_Meters_Report_Stream_Cursor_Input>>
  where?: InputMaybe<Rts_Meters_Report_Bool_Exp>
}

export type Subscription_RootScheduled_PaymentArgs = {
  distinct_on?: InputMaybe<Array<Scheduled_Payment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Scheduled_Payment_Order_By>>
  where?: InputMaybe<Scheduled_Payment_Bool_Exp>
}

export type Subscription_RootScheduled_Payment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scheduled_Payment_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Scheduled_Payment_Order_By>>
  where?: InputMaybe<Scheduled_Payment_Bool_Exp>
}

export type Subscription_RootScheduled_Payment_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootScheduled_Payment_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Scheduled_Payment_Stream_Cursor_Input>>
  where?: InputMaybe<Scheduled_Payment_Bool_Exp>
}

export type Subscription_RootScheduled_RefundArgs = {
  distinct_on?: InputMaybe<Array<Scheduled_Refund_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Scheduled_Refund_Order_By>>
  where?: InputMaybe<Scheduled_Refund_Bool_Exp>
}

export type Subscription_RootScheduled_Refund_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scheduled_Refund_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Scheduled_Refund_Order_By>>
  where?: InputMaybe<Scheduled_Refund_Bool_Exp>
}

export type Subscription_RootScheduled_Refund_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootScheduled_Refund_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Scheduled_Refund_Stream_Cursor_Input>>
  where?: InputMaybe<Scheduled_Refund_Bool_Exp>
}

export type Subscription_RootSmart_ChargingArgs = {
  distinct_on?: InputMaybe<Array<Smart_Charging_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Smart_Charging_Order_By>>
  where?: InputMaybe<Smart_Charging_Bool_Exp>
}

export type Subscription_RootSmart_Charging_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Smart_Charging_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Smart_Charging_Order_By>>
  where?: InputMaybe<Smart_Charging_Bool_Exp>
}

export type Subscription_RootSmart_Charging_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootSmart_Charging_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Smart_Charging_Stream_Cursor_Input>>
  where?: InputMaybe<Smart_Charging_Bool_Exp>
}

export type Subscription_RootSmart_Meter_Dashboard_Response_V7Args = {
  distinct_on?: InputMaybe<
    Array<Smart_Meter_Dashboard_Response_V7_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Smart_Meter_Dashboard_Response_V7_Order_By>>
  where?: InputMaybe<Smart_Meter_Dashboard_Response_V7_Bool_Exp>
}

export type Subscription_RootSmart_Meter_Dashboard_Response_V7_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Smart_Meter_Dashboard_Response_V7_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Smart_Meter_Dashboard_Response_V7_Order_By>>
  where?: InputMaybe<Smart_Meter_Dashboard_Response_V7_Bool_Exp>
}

export type Subscription_RootSmart_Meter_Dashboard_Response_V7_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<
    InputMaybe<Smart_Meter_Dashboard_Response_V7_Stream_Cursor_Input>
  >
  where?: InputMaybe<Smart_Meter_Dashboard_Response_V7_Bool_Exp>
}

export type Subscription_RootSmart_Meter_Dashboard_SummaryArgs = {
  distinct_on?: InputMaybe<
    Array<Smart_Meter_Dashboard_Order_By_Dev_Status_Model_Enum_Name>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Smart_Meter_Dashboard_Order_By_Dev_Status_Model_Order_By>
  >
  where?: InputMaybe<Smart_Meter_Dashboard_Order_By_Dev_Status_Model_Bool_Exp_Bool_Exp>
}

export type Subscription_RootSmart_Meter_Dashboard_Workstream_SummaryArgs = {
  distinct_on?: InputMaybe<
    Array<Smart_Meter_Dashboard_Order_By_Workstream_Model_Enum_Name>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Smart_Meter_Dashboard_Order_By_Workstream_Model_Order_By>
  >
  where?: InputMaybe<Smart_Meter_Dashboard_Order_By_Workstream_Model_Bool_Exp_Bool_Exp>
}

export type Subscription_RootSmart_Meters_Eligible_For_ExchangeArgs = {
  distinct_on?: InputMaybe<
    Array<Smart_Meters_Eligible_For_Exchange_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Smart_Meters_Eligible_For_Exchange_Order_By>>
  where?: InputMaybe<Smart_Meters_Eligible_For_Exchange_Bool_Exp>
}

export type Subscription_RootSmart_Meters_Eligible_For_Exchange_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Smart_Meters_Eligible_For_Exchange_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<Array<Smart_Meters_Eligible_For_Exchange_Order_By>>
    where?: InputMaybe<Smart_Meters_Eligible_For_Exchange_Bool_Exp>
  }

export type Subscription_RootSmart_Meters_Eligible_For_Exchange_By_PkArgs = {
  meter_serial_number: Scalars["String"]["input"]
  mpxn: Scalars["String"]["input"]
}

export type Subscription_RootSmart_Meters_Eligible_For_Exchange_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<
    InputMaybe<Smart_Meters_Eligible_For_Exchange_Stream_Cursor_Input>
  >
  where?: InputMaybe<Smart_Meters_Eligible_For_Exchange_Bool_Exp>
}

export type Subscription_RootSync_StatusArgs = {
  distinct_on?: InputMaybe<Array<Sync_Status_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Sync_Status_Order_By>>
  where?: InputMaybe<Sync_Status_Bool_Exp>
}

export type Subscription_RootSync_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sync_Status_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Sync_Status_Order_By>>
  where?: InputMaybe<Sync_Status_Bool_Exp>
}

export type Subscription_RootSync_Status_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootSync_Status_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Sync_Status_Stream_Cursor_Input>>
  where?: InputMaybe<Sync_Status_Bool_Exp>
}

export type Subscription_RootSynchronized_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Synchronized_Accounts_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Synchronized_Accounts_Order_By>>
  where?: InputMaybe<Synchronized_Accounts_Bool_Exp>
}

export type Subscription_RootSynchronized_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Synchronized_Accounts_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Synchronized_Accounts_Order_By>>
  where?: InputMaybe<Synchronized_Accounts_Bool_Exp>
}

export type Subscription_RootSynchronized_Accounts_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootSynchronized_Accounts_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Synchronized_Accounts_Stream_Cursor_Input>>
  where?: InputMaybe<Synchronized_Accounts_Bool_Exp>
}

export type Subscription_RootTicketArgs = {
  distinct_on?: InputMaybe<Array<Ticket_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Ticket_Order_By>>
  where?: InputMaybe<Ticket_Bool_Exp>
}

export type Subscription_RootTicket_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticket_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Ticket_Order_By>>
  where?: InputMaybe<Ticket_Bool_Exp>
}

export type Subscription_RootTicket_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootTicket_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Ticket_Stream_Cursor_Input>>
  where?: InputMaybe<Ticket_Bool_Exp>
}

export type Subscription_RootTickets_Automation_Account_StoreArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Automation_Account_Store_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Account_Store_Order_By>>
  where?: InputMaybe<Tickets_Automation_Account_Store_Bool_Exp>
}

export type Subscription_RootTickets_Automation_Account_Store_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Automation_Account_Store_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Account_Store_Order_By>>
  where?: InputMaybe<Tickets_Automation_Account_Store_Bool_Exp>
}

export type Subscription_RootTickets_Automation_Account_Store_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootTickets_Automation_Account_Store_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<
    InputMaybe<Tickets_Automation_Account_Store_Stream_Cursor_Input>
  >
  where?: InputMaybe<Tickets_Automation_Account_Store_Bool_Exp>
}

export type Subscription_RootTickets_Automation_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Automation_Config_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Config_Order_By>>
  where?: InputMaybe<Tickets_Automation_Config_Bool_Exp>
}

export type Subscription_RootTickets_Automation_Config_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Automation_Config_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Config_Order_By>>
  where?: InputMaybe<Tickets_Automation_Config_Bool_Exp>
}

export type Subscription_RootTickets_Automation_Config_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootTickets_Automation_Config_DefaultArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Automation_Config_Default_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Config_Default_Order_By>>
  where?: InputMaybe<Tickets_Automation_Config_Default_Bool_Exp>
}

export type Subscription_RootTickets_Automation_Config_Default_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Automation_Config_Default_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Config_Default_Order_By>>
  where?: InputMaybe<Tickets_Automation_Config_Default_Bool_Exp>
}

export type Subscription_RootTickets_Automation_Config_Default_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootTickets_Automation_Config_Default_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<
    InputMaybe<Tickets_Automation_Config_Default_Stream_Cursor_Input>
  >
  where?: InputMaybe<Tickets_Automation_Config_Default_Bool_Exp>
}

export type Subscription_RootTickets_Automation_Config_PurgeArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Automation_Config_Purge_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Config_Purge_Order_By>>
  where?: InputMaybe<Tickets_Automation_Config_Purge_Bool_Exp>
}

export type Subscription_RootTickets_Automation_Config_Purge_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Automation_Config_Purge_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Config_Purge_Order_By>>
  where?: InputMaybe<Tickets_Automation_Config_Purge_Bool_Exp>
}

export type Subscription_RootTickets_Automation_Config_Purge_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootTickets_Automation_Config_Purge_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Automation_Config_Purge_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Automation_Config_Purge_Bool_Exp>
}

export type Subscription_RootTickets_Automation_Config_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Automation_Config_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Automation_Config_Bool_Exp>
}

export type Subscription_RootTickets_Automation_Default_Ticket_ActionArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Automation_Default_Ticket_Action_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Tickets_Automation_Default_Ticket_Action_Order_By>
  >
  where?: InputMaybe<Tickets_Automation_Default_Ticket_Action_Bool_Exp>
}

export type Subscription_RootTickets_Automation_Default_Ticket_Action_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Automation_Default_Ticket_Action_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Tickets_Automation_Default_Ticket_Action_Order_By>
    >
    where?: InputMaybe<Tickets_Automation_Default_Ticket_Action_Bool_Exp>
  }

export type Subscription_RootTickets_Automation_Default_Ticket_Action_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

export type Subscription_RootTickets_Automation_Default_Ticket_Action_StreamArgs =
  {
    batch_size: Scalars["Int"]["input"]
    cursor: Array<
      InputMaybe<Tickets_Automation_Default_Ticket_Action_Stream_Cursor_Input>
    >
    where?: InputMaybe<Tickets_Automation_Default_Ticket_Action_Bool_Exp>
  }

export type Subscription_RootTickets_Automation_Defaults_Acceptable_Accounts_TableArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Order_By>
    >
    where?: InputMaybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Bool_Exp>
  }

export type Subscription_RootTickets_Automation_Defaults_Acceptable_Accounts_Table_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Order_By>
    >
    where?: InputMaybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Bool_Exp>
  }

export type Subscription_RootTickets_Automation_Defaults_Acceptable_Accounts_Table_By_PkArgs =
  {
    accountid: Scalars["bigint"]["input"]
  }

export type Subscription_RootTickets_Automation_Defaults_Acceptable_Accounts_Table_StreamArgs =
  {
    batch_size: Scalars["Int"]["input"]
    cursor: Array<
      InputMaybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Stream_Cursor_Input>
    >
    where?: InputMaybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Bool_Exp>
  }

export type Subscription_RootTickets_Automation_Defaults_Opened_PredefaultsArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Automation_Defaults_Opened_Predefaults_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Tickets_Automation_Defaults_Opened_Predefaults_Order_By>
    >
    where?: InputMaybe<Tickets_Automation_Defaults_Opened_Predefaults_Bool_Exp>
  }

export type Subscription_RootTickets_Automation_Defaults_Opened_Predefaults_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Automation_Defaults_Opened_Predefaults_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Tickets_Automation_Defaults_Opened_Predefaults_Order_By>
    >
    where?: InputMaybe<Tickets_Automation_Defaults_Opened_Predefaults_Bool_Exp>
  }

export type Subscription_RootTickets_Automation_Defaults_Opened_Predefaults_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

export type Subscription_RootTickets_Automation_Defaults_Opened_Predefaults_StreamArgs =
  {
    batch_size: Scalars["Int"]["input"]
    cursor: Array<
      InputMaybe<Tickets_Automation_Defaults_Opened_Predefaults_Stream_Cursor_Input>
    >
    where?: InputMaybe<Tickets_Automation_Defaults_Opened_Predefaults_Bool_Exp>
  }

export type Subscription_RootTickets_Automation_JobArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Automation_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Job_Order_By>>
  where?: InputMaybe<Tickets_Automation_Job_Bool_Exp>
}

export type Subscription_RootTickets_Automation_Job_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Automation_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Job_Order_By>>
  where?: InputMaybe<Tickets_Automation_Job_Bool_Exp>
}

export type Subscription_RootTickets_Automation_Job_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootTickets_Automation_Job_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Automation_Job_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Automation_Job_Bool_Exp>
}

export type Subscription_RootTickets_Automation_Purge_JobArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Automation_Purge_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Purge_Job_Order_By>>
  where?: InputMaybe<Tickets_Automation_Purge_Job_Bool_Exp>
}

export type Subscription_RootTickets_Automation_Purge_Job_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Automation_Purge_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Purge_Job_Order_By>>
  where?: InputMaybe<Tickets_Automation_Purge_Job_Bool_Exp>
}

export type Subscription_RootTickets_Automation_Purge_Job_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootTickets_Automation_Purge_Job_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Automation_Purge_Job_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Automation_Purge_Job_Bool_Exp>
}

export type Subscription_RootTickets_Automation_Ticket_StoreArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Automation_Ticket_Store_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Ticket_Store_Order_By>>
  where?: InputMaybe<Tickets_Automation_Ticket_Store_Bool_Exp>
}

export type Subscription_RootTickets_Automation_Ticket_Store_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Automation_Ticket_Store_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Automation_Ticket_Store_Order_By>>
  where?: InputMaybe<Tickets_Automation_Ticket_Store_Bool_Exp>
}

export type Subscription_RootTickets_Automation_Ticket_Store_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootTickets_Automation_Ticket_Store_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Automation_Ticket_Store_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Automation_Ticket_Store_Bool_Exp>
}

export type Subscription_RootTickets_Dca_Account_AllocationArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dca_Account_Allocation_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dca_Account_Allocation_Order_By>>
  where?: InputMaybe<Tickets_Dca_Account_Allocation_Bool_Exp>
}

export type Subscription_RootTickets_Dca_Account_Allocation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dca_Account_Allocation_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dca_Account_Allocation_Order_By>>
  where?: InputMaybe<Tickets_Dca_Account_Allocation_Bool_Exp>
}

export type Subscription_RootTickets_Dca_Account_Allocation_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootTickets_Dca_Account_Allocation_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Dca_Account_Allocation_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Dca_Account_Allocation_Bool_Exp>
}

export type Subscription_RootTickets_Dca_Allocation_ConfigurationArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Dca_Allocation_Configuration_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dca_Allocation_Configuration_Order_By>>
  where?: InputMaybe<Tickets_Dca_Allocation_Configuration_Bool_Exp>
}

export type Subscription_RootTickets_Dca_Allocation_Configuration_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Dca_Allocation_Configuration_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<Array<Tickets_Dca_Allocation_Configuration_Order_By>>
    where?: InputMaybe<Tickets_Dca_Allocation_Configuration_Bool_Exp>
  }

export type Subscription_RootTickets_Dca_Allocation_Configuration_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootTickets_Dca_Allocation_Configuration_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<
    InputMaybe<Tickets_Dca_Allocation_Configuration_Stream_Cursor_Input>
  >
  where?: InputMaybe<Tickets_Dca_Allocation_Configuration_Bool_Exp>
}

export type Subscription_RootTickets_Dca_Configuration_V2Args = {
  distinct_on?: InputMaybe<Array<Tickets_Dca_Configuration_V2_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dca_Configuration_V2_Order_By>>
  where?: InputMaybe<Tickets_Dca_Configuration_V2_Bool_Exp>
}

export type Subscription_RootTickets_Dca_Configuration_V2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dca_Configuration_V2_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dca_Configuration_V2_Order_By>>
  where?: InputMaybe<Tickets_Dca_Configuration_V2_Bool_Exp>
}

export type Subscription_RootTickets_Dca_Configuration_V2_By_PkArgs = {
  dca: Scalars["String"]["input"]
}

export type Subscription_RootTickets_Dca_Configuration_V2_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Dca_Configuration_V2_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Dca_Configuration_V2_Bool_Exp>
}

export type Subscription_RootTickets_Dca_SegmentationArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dca_Segmentation_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dca_Segmentation_Order_By>>
  where?: InputMaybe<Tickets_Dca_Segmentation_Bool_Exp>
}

export type Subscription_RootTickets_Dca_Segmentation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dca_Segmentation_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dca_Segmentation_Order_By>>
  where?: InputMaybe<Tickets_Dca_Segmentation_Bool_Exp>
}

export type Subscription_RootTickets_Dca_Segmentation_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootTickets_Dca_Segmentation_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Dca_Segmentation_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Dca_Segmentation_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Account_StoreArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Account_Store_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Account_Store_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Account_Store_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Account_Store_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Account_Store_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Account_Store_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Account_Store_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Account_Store_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootTickets_Dunning_Account_Store_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Dunning_Account_Store_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Dunning_Account_Store_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Addacs_Review_RecordsArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Dunning_Addacs_Review_Records_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Addacs_Review_Records_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Addacs_Review_Records_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Addacs_Review_Records_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Dunning_Addacs_Review_Records_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<Array<Tickets_Dunning_Addacs_Review_Records_Order_By>>
    where?: InputMaybe<Tickets_Dunning_Addacs_Review_Records_Bool_Exp>
  }

export type Subscription_RootTickets_Dunning_Addacs_Review_Records_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootTickets_Dunning_Addacs_Review_Records_StreamArgs =
  {
    batch_size: Scalars["Int"]["input"]
    cursor: Array<
      InputMaybe<Tickets_Dunning_Addacs_Review_Records_Stream_Cursor_Input>
    >
    where?: InputMaybe<Tickets_Dunning_Addacs_Review_Records_Bool_Exp>
  }

export type Subscription_RootTickets_Dunning_Automation_EventsArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Dunning_Automation_Events_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Automation_Events_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Automation_Events_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Automation_Events_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Dunning_Automation_Events_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Automation_Events_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Automation_Events_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Automation_Events_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootTickets_Dunning_Automation_Events_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<
    InputMaybe<Tickets_Dunning_Automation_Events_Stream_Cursor_Input>
  >
  where?: InputMaybe<Tickets_Dunning_Automation_Events_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Debt_Ticket_Review_RecordsArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Dunning_Debt_Ticket_Review_Records_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Tickets_Dunning_Debt_Ticket_Review_Records_Order_By>
  >
  where?: InputMaybe<Tickets_Dunning_Debt_Ticket_Review_Records_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Debt_Ticket_Review_Records_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Dunning_Debt_Ticket_Review_Records_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Tickets_Dunning_Debt_Ticket_Review_Records_Order_By>
    >
    where?: InputMaybe<Tickets_Dunning_Debt_Ticket_Review_Records_Bool_Exp>
  }

export type Subscription_RootTickets_Dunning_Debt_Ticket_Review_Records_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

export type Subscription_RootTickets_Dunning_Debt_Ticket_Review_Records_StreamArgs =
  {
    batch_size: Scalars["Int"]["input"]
    cursor: Array<
      InputMaybe<Tickets_Dunning_Debt_Ticket_Review_Records_Stream_Cursor_Input>
    >
    where?: InputMaybe<Tickets_Dunning_Debt_Ticket_Review_Records_Bool_Exp>
  }

export type Subscription_RootTickets_Dunning_JobArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Job_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Job_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Job_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Job_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Job_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Job_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootTickets_Dunning_Job_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Dunning_Job_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Dunning_Job_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Legal_Known_Ticket_RecordsArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Dunning_Legal_Known_Ticket_Records_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<
    Array<Tickets_Dunning_Legal_Known_Ticket_Records_Order_By>
  >
  where?: InputMaybe<Tickets_Dunning_Legal_Known_Ticket_Records_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Legal_Known_Ticket_Records_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Dunning_Legal_Known_Ticket_Records_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Tickets_Dunning_Legal_Known_Ticket_Records_Order_By>
    >
    where?: InputMaybe<Tickets_Dunning_Legal_Known_Ticket_Records_Bool_Exp>
  }

export type Subscription_RootTickets_Dunning_Legal_Known_Ticket_Records_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

export type Subscription_RootTickets_Dunning_Legal_Known_Ticket_Records_StreamArgs =
  {
    batch_size: Scalars["Int"]["input"]
    cursor: Array<
      InputMaybe<Tickets_Dunning_Legal_Known_Ticket_Records_Stream_Cursor_Input>
    >
    where?: InputMaybe<Tickets_Dunning_Legal_Known_Ticket_Records_Bool_Exp>
  }

export type Subscription_RootTickets_Dunning_Legal_Occupier_Ticket_RecordsArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Dunning_Legal_Occupier_Ticket_Records_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Tickets_Dunning_Legal_Occupier_Ticket_Records_Order_By>
    >
    where?: InputMaybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Bool_Exp>
  }

export type Subscription_RootTickets_Dunning_Legal_Occupier_Ticket_Records_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Dunning_Legal_Occupier_Ticket_Records_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Tickets_Dunning_Legal_Occupier_Ticket_Records_Order_By>
    >
    where?: InputMaybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Bool_Exp>
  }

export type Subscription_RootTickets_Dunning_Legal_Occupier_Ticket_Records_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

export type Subscription_RootTickets_Dunning_Legal_Occupier_Ticket_Records_StreamArgs =
  {
    batch_size: Scalars["Int"]["input"]
    cursor: Array<
      InputMaybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Stream_Cursor_Input>
    >
    where?: InputMaybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Bool_Exp>
  }

export type Subscription_RootTickets_Dunning_Occupier_Accounts_Review_RecordsArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Dunning_Occupier_Accounts_Review_Records_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Tickets_Dunning_Occupier_Accounts_Review_Records_Order_By>
    >
    where?: InputMaybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Bool_Exp>
  }

export type Subscription_RootTickets_Dunning_Occupier_Accounts_Review_Records_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Dunning_Occupier_Accounts_Review_Records_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Tickets_Dunning_Occupier_Accounts_Review_Records_Order_By>
    >
    where?: InputMaybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Bool_Exp>
  }

export type Subscription_RootTickets_Dunning_Occupier_Accounts_Review_Records_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

export type Subscription_RootTickets_Dunning_Occupier_Accounts_Review_Records_StreamArgs =
  {
    batch_size: Scalars["Int"]["input"]
    cursor: Array<
      InputMaybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Stream_Cursor_Input>
    >
    where?: InputMaybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Bool_Exp>
  }

export type Subscription_RootTickets_Dunning_Purge_JobArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Purge_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Purge_Job_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Purge_Job_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Purge_Job_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Purge_Job_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Purge_Job_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Purge_Job_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Purge_Job_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootTickets_Dunning_Purge_Job_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Dunning_Purge_Job_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Dunning_Purge_Job_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Standard_Ticket_RecordsArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Dunning_Standard_Ticket_Records_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Standard_Ticket_Records_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Standard_Ticket_Records_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Standard_Ticket_Records_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Dunning_Standard_Ticket_Records_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Tickets_Dunning_Standard_Ticket_Records_Order_By>
    >
    where?: InputMaybe<Tickets_Dunning_Standard_Ticket_Records_Bool_Exp>
  }

export type Subscription_RootTickets_Dunning_Standard_Ticket_Records_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

export type Subscription_RootTickets_Dunning_Standard_Ticket_Records_StreamArgs =
  {
    batch_size: Scalars["Int"]["input"]
    cursor: Array<
      InputMaybe<Tickets_Dunning_Standard_Ticket_Records_Stream_Cursor_Input>
    >
    where?: InputMaybe<Tickets_Dunning_Standard_Ticket_Records_Bool_Exp>
  }

export type Subscription_RootTickets_Dunning_StatisticsArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Statistics_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Statistics_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Statistics_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Statistics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Statistics_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Statistics_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Statistics_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Statistics_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootTickets_Dunning_Statistics_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Dunning_Statistics_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Dunning_Statistics_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Terminating_Accounts_Review_RecordsArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Dunning_Terminating_Accounts_Review_Records_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Tickets_Dunning_Terminating_Accounts_Review_Records_Order_By>
    >
    where?: InputMaybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Bool_Exp>
  }

export type Subscription_RootTickets_Dunning_Terminating_Accounts_Review_Records_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Tickets_Dunning_Terminating_Accounts_Review_Records_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Tickets_Dunning_Terminating_Accounts_Review_Records_Order_By>
    >
    where?: InputMaybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Bool_Exp>
  }

export type Subscription_RootTickets_Dunning_Terminating_Accounts_Review_Records_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

export type Subscription_RootTickets_Dunning_Terminating_Accounts_Review_Records_StreamArgs =
  {
    batch_size: Scalars["Int"]["input"]
    cursor: Array<
      InputMaybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Stream_Cursor_Input>
    >
    where?: InputMaybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Bool_Exp>
  }

export type Subscription_RootTickets_Dunning_Ticket_StoreArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Ticket_Store_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Ticket_Store_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Ticket_Store_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Ticket_Store_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Ticket_Store_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Ticket_Store_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Ticket_Store_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Ticket_Store_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootTickets_Dunning_Ticket_Store_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Dunning_Ticket_Store_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Dunning_Ticket_Store_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_WorkflowArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Workflow_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Workflow_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Workflow_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Workflow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Dunning_Workflow_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Dunning_Workflow_Order_By>>
  where?: InputMaybe<Tickets_Dunning_Workflow_Bool_Exp>
}

export type Subscription_RootTickets_Dunning_Workflow_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootTickets_Dunning_Workflow_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Dunning_Workflow_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Dunning_Workflow_Bool_Exp>
}

export type Subscription_RootTickets_External_EventArgs = {
  distinct_on?: InputMaybe<Array<Tickets_External_Event_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_External_Event_Order_By>>
  where?: InputMaybe<Tickets_External_Event_Bool_Exp>
}

export type Subscription_RootTickets_External_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_External_Event_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_External_Event_Order_By>>
  where?: InputMaybe<Tickets_External_Event_Bool_Exp>
}

export type Subscription_RootTickets_External_Event_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootTickets_External_Event_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_External_Event_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_External_Event_Bool_Exp>
}

export type Subscription_RootTickets_External_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Tickets_External_Tickets_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_External_Tickets_Order_By>>
  where?: InputMaybe<Tickets_External_Tickets_Bool_Exp>
}

export type Subscription_RootTickets_External_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_External_Tickets_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_External_Tickets_Order_By>>
  where?: InputMaybe<Tickets_External_Tickets_Bool_Exp>
}

export type Subscription_RootTickets_External_Tickets_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootTickets_External_Tickets_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_External_Tickets_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_External_Tickets_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Blob_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Blob_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Blob_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Blob_Triggers_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Blob_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Blob_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Blob_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Blob_Triggers_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Blob_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

export type Subscription_RootTickets_Qrtz_Blob_Triggers_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Qrtz_Blob_Triggers_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Qrtz_Blob_Triggers_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_CalendarsArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Calendars_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Calendars_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Calendars_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Calendars_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Calendars_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Calendars_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Calendars_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Calendars_By_PkArgs = {
  calendar_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

export type Subscription_RootTickets_Qrtz_Calendars_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Qrtz_Calendars_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Qrtz_Calendars_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Cron_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Cron_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Cron_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Cron_Triggers_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Cron_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Cron_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Cron_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Cron_Triggers_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Cron_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

export type Subscription_RootTickets_Qrtz_Cron_Triggers_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Qrtz_Cron_Triggers_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Qrtz_Cron_Triggers_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Fired_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Fired_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Fired_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Fired_Triggers_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Fired_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Fired_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Fired_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Fired_Triggers_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Fired_Triggers_By_PkArgs = {
  entry_id: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

export type Subscription_RootTickets_Qrtz_Fired_Triggers_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Qrtz_Fired_Triggers_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Qrtz_Fired_Triggers_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Job_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Job_Details_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Job_Details_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Job_Details_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Job_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Job_Details_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Job_Details_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Job_Details_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Job_Details_By_PkArgs = {
  job_group: Scalars["String"]["input"]
  job_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

export type Subscription_RootTickets_Qrtz_Job_Details_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Qrtz_Job_Details_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Qrtz_Job_Details_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_LocksArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Locks_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Locks_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Locks_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Locks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Locks_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Locks_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Locks_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Locks_By_PkArgs = {
  lock_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

export type Subscription_RootTickets_Qrtz_Locks_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Qrtz_Locks_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Qrtz_Locks_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Paused_Trigger_GrpsArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Qrtz_Paused_Trigger_Grps_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Paused_Trigger_Grps_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Paused_Trigger_Grps_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Paused_Trigger_Grps_AggregateArgs = {
  distinct_on?: InputMaybe<
    Array<Tickets_Qrtz_Paused_Trigger_Grps_Select_Column>
  >
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Paused_Trigger_Grps_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Paused_Trigger_Grps_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Paused_Trigger_Grps_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
}

export type Subscription_RootTickets_Qrtz_Paused_Trigger_Grps_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<
    InputMaybe<Tickets_Qrtz_Paused_Trigger_Grps_Stream_Cursor_Input>
  >
  where?: InputMaybe<Tickets_Qrtz_Paused_Trigger_Grps_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Scheduler_StateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Scheduler_State_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Scheduler_State_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Scheduler_State_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Scheduler_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Scheduler_State_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Scheduler_State_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Scheduler_State_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Scheduler_State_By_PkArgs = {
  instance_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

export type Subscription_RootTickets_Qrtz_Scheduler_State_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Qrtz_Scheduler_State_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Qrtz_Scheduler_State_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Simple_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Simple_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Simple_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Simple_Triggers_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Simple_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Simple_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Simple_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Simple_Triggers_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Simple_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

export type Subscription_RootTickets_Qrtz_Simple_Triggers_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Qrtz_Simple_Triggers_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Qrtz_Simple_Triggers_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Simprop_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Simprop_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Simprop_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Simprop_Triggers_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Simprop_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Simprop_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Simprop_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Simprop_Triggers_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Simprop_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

export type Subscription_RootTickets_Qrtz_Simprop_Triggers_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Qrtz_Simprop_Triggers_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Qrtz_Simprop_Triggers_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Triggers_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tickets_Qrtz_Triggers_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Tickets_Qrtz_Triggers_Order_By>>
  where?: InputMaybe<Tickets_Qrtz_Triggers_Bool_Exp>
}

export type Subscription_RootTickets_Qrtz_Triggers_By_PkArgs = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

export type Subscription_RootTickets_Qrtz_Triggers_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Tickets_Qrtz_Triggers_Stream_Cursor_Input>>
  where?: InputMaybe<Tickets_Qrtz_Triggers_Bool_Exp>
}

export type Subscription_RootTrustpilot_InvitationsArgs = {
  distinct_on?: InputMaybe<Array<Trustpilot_Invitations_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Trustpilot_Invitations_Order_By>>
  where?: InputMaybe<Trustpilot_Invitations_Bool_Exp>
}

export type Subscription_RootTrustpilot_Invitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trustpilot_Invitations_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Trustpilot_Invitations_Order_By>>
  where?: InputMaybe<Trustpilot_Invitations_Bool_Exp>
}

export type Subscription_RootTrustpilot_Invitations_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Trustpilot_Invitations_Stream_Cursor_Input>>
  where?: InputMaybe<Trustpilot_Invitations_Bool_Exp>
}

export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Users_Order_By>>
  where?: InputMaybe<Users_Bool_Exp>
}

export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Users_Order_By>>
  where?: InputMaybe<Users_Bool_Exp>
}

export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>
  where?: InputMaybe<Users_Bool_Exp>
}

export type Subscription_RootUswitch_RecordArgs = {
  distinct_on?: InputMaybe<Array<Uswitch_Record_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Uswitch_Record_Order_By>>
  where?: InputMaybe<Uswitch_Record_Bool_Exp>
}

export type Subscription_RootUswitch_Record_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uswitch_Record_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Uswitch_Record_Order_By>>
  where?: InputMaybe<Uswitch_Record_Bool_Exp>
}

export type Subscription_RootUswitch_Record_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootUswitch_Record_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Uswitch_Record_Stream_Cursor_Input>>
  where?: InputMaybe<Uswitch_Record_Bool_Exp>
}

export type Subscription_RootWarm_Home_Discount_ApplicationArgs = {
  distinct_on?: InputMaybe<Array<Warm_Home_Discount_Application_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Warm_Home_Discount_Application_Order_By>>
  where?: InputMaybe<Warm_Home_Discount_Application_Bool_Exp>
}

export type Subscription_RootWarm_Home_Discount_Application_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Warm_Home_Discount_Application_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Warm_Home_Discount_Application_Order_By>>
  where?: InputMaybe<Warm_Home_Discount_Application_Bool_Exp>
}

export type Subscription_RootWarm_Home_Discount_Application_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootWarm_Home_Discount_Application_Status_HistoryArgs =
  {
    distinct_on?: InputMaybe<
      Array<Warm_Home_Discount_Application_Status_History_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Warm_Home_Discount_Application_Status_History_Order_By>
    >
    where?: InputMaybe<Warm_Home_Discount_Application_Status_History_Bool_Exp>
  }

export type Subscription_RootWarm_Home_Discount_Application_Status_History_AggregateArgs =
  {
    distinct_on?: InputMaybe<
      Array<Warm_Home_Discount_Application_Status_History_Select_Column>
    >
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<
      Array<Warm_Home_Discount_Application_Status_History_Order_By>
    >
    where?: InputMaybe<Warm_Home_Discount_Application_Status_History_Bool_Exp>
  }

export type Subscription_RootWarm_Home_Discount_Application_Status_History_By_PkArgs =
  {
    id: Scalars["bigint"]["input"]
  }

export type Subscription_RootWarm_Home_Discount_Application_Status_History_StreamArgs =
  {
    batch_size: Scalars["Int"]["input"]
    cursor: Array<
      InputMaybe<Warm_Home_Discount_Application_Status_History_Stream_Cursor_Input>
    >
    where?: InputMaybe<Warm_Home_Discount_Application_Status_History_Bool_Exp>
  }

export type Subscription_RootWarm_Home_Discount_Application_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Warm_Home_Discount_Application_Stream_Cursor_Input>>
  where?: InputMaybe<Warm_Home_Discount_Application_Bool_Exp>
}

export type Subscription_RootWarm_Home_Discount_CriteriaArgs = {
  distinct_on?: InputMaybe<Array<Warm_Home_Discount_Criteria_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Warm_Home_Discount_Criteria_Order_By>>
  where?: InputMaybe<Warm_Home_Discount_Criteria_Bool_Exp>
}

export type Subscription_RootWarm_Home_Discount_Criteria_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Warm_Home_Discount_Criteria_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Warm_Home_Discount_Criteria_Order_By>>
  where?: InputMaybe<Warm_Home_Discount_Criteria_Bool_Exp>
}

export type Subscription_RootWarm_Home_Discount_Criteria_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootWarm_Home_Discount_Criteria_RelArgs = {
  distinct_on?: InputMaybe<Array<Warm_Home_Discount_Criteria_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Warm_Home_Discount_Criteria_Rel_Order_By>>
  where?: InputMaybe<Warm_Home_Discount_Criteria_Rel_Bool_Exp>
}

export type Subscription_RootWarm_Home_Discount_Criteria_Rel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Warm_Home_Discount_Criteria_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Warm_Home_Discount_Criteria_Rel_Order_By>>
  where?: InputMaybe<Warm_Home_Discount_Criteria_Rel_Bool_Exp>
}

export type Subscription_RootWarm_Home_Discount_Criteria_Rel_By_PkArgs = {
  id: Scalars["bigint"]["input"]
}

export type Subscription_RootWarm_Home_Discount_Criteria_Rel_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Warm_Home_Discount_Criteria_Rel_Stream_Cursor_Input>>
  where?: InputMaybe<Warm_Home_Discount_Criteria_Rel_Bool_Exp>
}

export type Subscription_RootWarm_Home_Discount_Criteria_StreamArgs = {
  batch_size: Scalars["Int"]["input"]
  cursor: Array<InputMaybe<Warm_Home_Discount_Criteria_Stream_Cursor_Input>>
  where?: InputMaybe<Warm_Home_Discount_Criteria_Bool_Exp>
}

/** columns and relationships of "sync_status" */
export type Sync_Status = {
  __typename?: "sync_status"
  entity_id: Scalars["bigint"]["output"]
  id: Scalars["bigint"]["output"]
  table_name: Scalars["String"]["output"]
  transaction_id: Scalars["String"]["output"]
}

/** aggregated selection of "sync_status" */
export type Sync_Status_Aggregate = {
  __typename?: "sync_status_aggregate"
  aggregate?: Maybe<Sync_Status_Aggregate_Fields>
  nodes: Array<Sync_Status>
}

/** aggregate fields of "sync_status" */
export type Sync_Status_Aggregate_Fields = {
  __typename?: "sync_status_aggregate_fields"
  avg?: Maybe<Sync_Status_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Sync_Status_Max_Fields>
  min?: Maybe<Sync_Status_Min_Fields>
  stddev?: Maybe<Sync_Status_Stddev_Fields>
  stddev_pop?: Maybe<Sync_Status_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Sync_Status_Stddev_Samp_Fields>
  sum?: Maybe<Sync_Status_Sum_Fields>
  var_pop?: Maybe<Sync_Status_Var_Pop_Fields>
  var_samp?: Maybe<Sync_Status_Var_Samp_Fields>
  variance?: Maybe<Sync_Status_Variance_Fields>
}

/** aggregate fields of "sync_status" */
export type Sync_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sync_Status_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Sync_Status_Avg_Fields = {
  __typename?: "sync_status_avg_fields"
  entity_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "sync_status". All fields are combined with a logical 'AND'. */
export type Sync_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Sync_Status_Bool_Exp>>
  _not?: InputMaybe<Sync_Status_Bool_Exp>
  _or?: InputMaybe<Array<Sync_Status_Bool_Exp>>
  entity_id?: InputMaybe<Bigint_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  table_name?: InputMaybe<String_Comparison_Exp>
  transaction_id?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "sync_status" */
export enum Sync_Status_Constraint {
  /** unique or primary key constraint on columns "id" */
  SyncStatusPkey = "sync_status_pkey",
  /** unique or primary key constraint on columns "table_name", "transaction_id" */
  SyncStatusTableTransactionIdIndex = "sync_status_table_transaction_id_index",
}

/** input type for incrementing numeric columns in table "sync_status" */
export type Sync_Status_Inc_Input = {
  entity_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "sync_status" */
export type Sync_Status_Insert_Input = {
  entity_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  table_name?: InputMaybe<Scalars["String"]["input"]>
  transaction_id?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Sync_Status_Max_Fields = {
  __typename?: "sync_status_max_fields"
  entity_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  table_name?: Maybe<Scalars["String"]["output"]>
  transaction_id?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Sync_Status_Min_Fields = {
  __typename?: "sync_status_min_fields"
  entity_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  table_name?: Maybe<Scalars["String"]["output"]>
  transaction_id?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "sync_status" */
export type Sync_Status_Mutation_Response = {
  __typename?: "sync_status_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Sync_Status>
}

/** on_conflict condition type for table "sync_status" */
export type Sync_Status_On_Conflict = {
  constraint: Sync_Status_Constraint
  update_columns?: Array<Sync_Status_Update_Column>
  where?: InputMaybe<Sync_Status_Bool_Exp>
}

/** Ordering options when selecting data from "sync_status". */
export type Sync_Status_Order_By = {
  entity_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  table_name?: InputMaybe<Order_By>
  transaction_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: sync_status */
export type Sync_Status_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "sync_status" */
export enum Sync_Status_Select_Column {
  /** column name */
  EntityId = "entity_id",
  /** column name */
  Id = "id",
  /** column name */
  TableName = "table_name",
  /** column name */
  TransactionId = "transaction_id",
}

/** input type for updating data in table "sync_status" */
export type Sync_Status_Set_Input = {
  entity_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  table_name?: InputMaybe<Scalars["String"]["input"]>
  transaction_id?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Sync_Status_Stddev_Fields = {
  __typename?: "sync_status_stddev_fields"
  entity_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Sync_Status_Stddev_Pop_Fields = {
  __typename?: "sync_status_stddev_pop_fields"
  entity_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Sync_Status_Stddev_Samp_Fields = {
  __typename?: "sync_status_stddev_samp_fields"
  entity_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "sync_status" */
export type Sync_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sync_Status_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Sync_Status_Stream_Cursor_Value_Input = {
  entity_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  table_name?: InputMaybe<Scalars["String"]["input"]>
  transaction_id?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Sync_Status_Sum_Fields = {
  __typename?: "sync_status_sum_fields"
  entity_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "sync_status" */
export enum Sync_Status_Update_Column {
  /** column name */
  EntityId = "entity_id",
  /** column name */
  Id = "id",
  /** column name */
  TableName = "table_name",
  /** column name */
  TransactionId = "transaction_id",
}

export type Sync_Status_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sync_Status_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sync_Status_Set_Input>
  /** filter the rows which have to be updated */
  where: Sync_Status_Bool_Exp
}

/** aggregate var_pop on columns */
export type Sync_Status_Var_Pop_Fields = {
  __typename?: "sync_status_var_pop_fields"
  entity_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Sync_Status_Var_Samp_Fields = {
  __typename?: "sync_status_var_samp_fields"
  entity_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Sync_Status_Variance_Fields = {
  __typename?: "sync_status_variance_fields"
  entity_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "synchronized_accounts" */
export type Synchronized_Accounts = {
  __typename?: "synchronized_accounts"
  accountId?: Maybe<Scalars["bigint"]["output"]>
  id: Scalars["bigint"]["output"]
  juniferAccountId: Scalars["bigint"]["output"]
  locked: Scalars["Boolean"]["output"]
  synchronized_account_billing_account: Array<Billing_Account>
  synchronized_account_billing_account_aggregate: Billing_Account_Aggregate
}

/** columns and relationships of "synchronized_accounts" */
export type Synchronized_AccountsSynchronized_Account_Billing_AccountArgs = {
  distinct_on?: InputMaybe<Array<Billing_Account_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Billing_Account_Order_By>>
  where?: InputMaybe<Billing_Account_Bool_Exp>
}

/** columns and relationships of "synchronized_accounts" */
export type Synchronized_AccountsSynchronized_Account_Billing_Account_AggregateArgs =
  {
    distinct_on?: InputMaybe<Array<Billing_Account_Select_Column>>
    limit?: InputMaybe<Scalars["Int"]["input"]>
    offset?: InputMaybe<Scalars["Int"]["input"]>
    order_by?: InputMaybe<Array<Billing_Account_Order_By>>
    where?: InputMaybe<Billing_Account_Bool_Exp>
  }

/** aggregated selection of "synchronized_accounts" */
export type Synchronized_Accounts_Aggregate = {
  __typename?: "synchronized_accounts_aggregate"
  aggregate?: Maybe<Synchronized_Accounts_Aggregate_Fields>
  nodes: Array<Synchronized_Accounts>
}

/** aggregate fields of "synchronized_accounts" */
export type Synchronized_Accounts_Aggregate_Fields = {
  __typename?: "synchronized_accounts_aggregate_fields"
  avg?: Maybe<Synchronized_Accounts_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Synchronized_Accounts_Max_Fields>
  min?: Maybe<Synchronized_Accounts_Min_Fields>
  stddev?: Maybe<Synchronized_Accounts_Stddev_Fields>
  stddev_pop?: Maybe<Synchronized_Accounts_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Synchronized_Accounts_Stddev_Samp_Fields>
  sum?: Maybe<Synchronized_Accounts_Sum_Fields>
  var_pop?: Maybe<Synchronized_Accounts_Var_Pop_Fields>
  var_samp?: Maybe<Synchronized_Accounts_Var_Samp_Fields>
  variance?: Maybe<Synchronized_Accounts_Variance_Fields>
}

/** aggregate fields of "synchronized_accounts" */
export type Synchronized_Accounts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Synchronized_Accounts_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Synchronized_Accounts_Avg_Fields = {
  __typename?: "synchronized_accounts_avg_fields"
  accountId?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  juniferAccountId?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "synchronized_accounts". All fields are combined with a logical 'AND'. */
export type Synchronized_Accounts_Bool_Exp = {
  _and?: InputMaybe<Array<Synchronized_Accounts_Bool_Exp>>
  _not?: InputMaybe<Synchronized_Accounts_Bool_Exp>
  _or?: InputMaybe<Array<Synchronized_Accounts_Bool_Exp>>
  accountId?: InputMaybe<Bigint_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  juniferAccountId?: InputMaybe<Bigint_Comparison_Exp>
  locked?: InputMaybe<Boolean_Comparison_Exp>
}

/** unique or primary key constraints on table "synchronized_accounts" */
export enum Synchronized_Accounts_Constraint {
  /** unique or primary key constraint on columns "id" */
  SynchronizedAccountsPkey = "synchronized_accounts_pkey",
}

/** input type for incrementing numeric columns in table "synchronized_accounts" */
export type Synchronized_Accounts_Inc_Input = {
  accountId?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  juniferAccountId?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "synchronized_accounts" */
export type Synchronized_Accounts_Insert_Input = {
  accountId?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  juniferAccountId?: InputMaybe<Scalars["bigint"]["input"]>
  locked?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate max on columns */
export type Synchronized_Accounts_Max_Fields = {
  __typename?: "synchronized_accounts_max_fields"
  accountId?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  juniferAccountId?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregate min on columns */
export type Synchronized_Accounts_Min_Fields = {
  __typename?: "synchronized_accounts_min_fields"
  accountId?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  juniferAccountId?: Maybe<Scalars["bigint"]["output"]>
}

/** response of any mutation on the table "synchronized_accounts" */
export type Synchronized_Accounts_Mutation_Response = {
  __typename?: "synchronized_accounts_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Synchronized_Accounts>
}

/** input type for inserting object relation for remote table "synchronized_accounts" */
export type Synchronized_Accounts_Obj_Rel_Insert_Input = {
  data: Synchronized_Accounts_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Synchronized_Accounts_On_Conflict>
}

/** on_conflict condition type for table "synchronized_accounts" */
export type Synchronized_Accounts_On_Conflict = {
  constraint: Synchronized_Accounts_Constraint
  update_columns?: Array<Synchronized_Accounts_Update_Column>
  where?: InputMaybe<Synchronized_Accounts_Bool_Exp>
}

/** Ordering options when selecting data from "synchronized_accounts". */
export type Synchronized_Accounts_Order_By = {
  accountId?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  juniferAccountId?: InputMaybe<Order_By>
  locked?: InputMaybe<Order_By>
}

/** primary key columns input for table: synchronized_accounts */
export type Synchronized_Accounts_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "synchronized_accounts" */
export enum Synchronized_Accounts_Select_Column {
  /** column name */
  AccountId = "accountId",
  /** column name */
  Id = "id",
  /** column name */
  JuniferAccountId = "juniferAccountId",
  /** column name */
  Locked = "locked",
}

/** input type for updating data in table "synchronized_accounts" */
export type Synchronized_Accounts_Set_Input = {
  accountId?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  juniferAccountId?: InputMaybe<Scalars["bigint"]["input"]>
  locked?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate stddev on columns */
export type Synchronized_Accounts_Stddev_Fields = {
  __typename?: "synchronized_accounts_stddev_fields"
  accountId?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  juniferAccountId?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Synchronized_Accounts_Stddev_Pop_Fields = {
  __typename?: "synchronized_accounts_stddev_pop_fields"
  accountId?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  juniferAccountId?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Synchronized_Accounts_Stddev_Samp_Fields = {
  __typename?: "synchronized_accounts_stddev_samp_fields"
  accountId?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  juniferAccountId?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "synchronized_accounts" */
export type Synchronized_Accounts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Synchronized_Accounts_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Synchronized_Accounts_Stream_Cursor_Value_Input = {
  accountId?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  juniferAccountId?: InputMaybe<Scalars["bigint"]["input"]>
  locked?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate sum on columns */
export type Synchronized_Accounts_Sum_Fields = {
  __typename?: "synchronized_accounts_sum_fields"
  accountId?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  juniferAccountId?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "synchronized_accounts" */
export enum Synchronized_Accounts_Update_Column {
  /** column name */
  AccountId = "accountId",
  /** column name */
  Id = "id",
  /** column name */
  JuniferAccountId = "juniferAccountId",
  /** column name */
  Locked = "locked",
}

export type Synchronized_Accounts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Synchronized_Accounts_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Synchronized_Accounts_Set_Input>
  /** filter the rows which have to be updated */
  where: Synchronized_Accounts_Bool_Exp
}

/** aggregate var_pop on columns */
export type Synchronized_Accounts_Var_Pop_Fields = {
  __typename?: "synchronized_accounts_var_pop_fields"
  accountId?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  juniferAccountId?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Synchronized_Accounts_Var_Samp_Fields = {
  __typename?: "synchronized_accounts_var_samp_fields"
  accountId?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  juniferAccountId?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Synchronized_Accounts_Variance_Fields = {
  __typename?: "synchronized_accounts_variance_fields"
  accountId?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  juniferAccountId?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "ticket" */
export type Ticket = {
  __typename?: "ticket"
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  description: Scalars["String"]["output"]
  id: Scalars["bigint"]["output"]
  key_identifier: Scalars["String"]["output"]
  status: Scalars["String"]["output"]
  summary: Scalars["String"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "ticket" */
export type Ticket_Aggregate = {
  __typename?: "ticket_aggregate"
  aggregate?: Maybe<Ticket_Aggregate_Fields>
  nodes: Array<Ticket>
}

/** aggregate fields of "ticket" */
export type Ticket_Aggregate_Fields = {
  __typename?: "ticket_aggregate_fields"
  avg?: Maybe<Ticket_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Ticket_Max_Fields>
  min?: Maybe<Ticket_Min_Fields>
  stddev?: Maybe<Ticket_Stddev_Fields>
  stddev_pop?: Maybe<Ticket_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Ticket_Stddev_Samp_Fields>
  sum?: Maybe<Ticket_Sum_Fields>
  var_pop?: Maybe<Ticket_Var_Pop_Fields>
  var_samp?: Maybe<Ticket_Var_Samp_Fields>
  variance?: Maybe<Ticket_Variance_Fields>
}

/** aggregate fields of "ticket" */
export type Ticket_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ticket_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Ticket_Avg_Fields = {
  __typename?: "ticket_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "ticket". All fields are combined with a logical 'AND'. */
export type Ticket_Bool_Exp = {
  _and?: InputMaybe<Array<Ticket_Bool_Exp>>
  _not?: InputMaybe<Ticket_Bool_Exp>
  _or?: InputMaybe<Array<Ticket_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  description?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  key_identifier?: InputMaybe<String_Comparison_Exp>
  status?: InputMaybe<String_Comparison_Exp>
  summary?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "ticket" */
export enum Ticket_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkTicket = "pk_ticket",
}

/** Boolean expression to compare columns of type "ticket_creation_status". All fields are combined with logical 'AND'. */
export type Ticket_Creation_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["ticket_creation_status"]["input"]>
  _gt?: InputMaybe<Scalars["ticket_creation_status"]["input"]>
  _gte?: InputMaybe<Scalars["ticket_creation_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["ticket_creation_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["ticket_creation_status"]["input"]>
  _lte?: InputMaybe<Scalars["ticket_creation_status"]["input"]>
  _neq?: InputMaybe<Scalars["ticket_creation_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["ticket_creation_status"]["input"]>>
}

/** input type for incrementing numeric columns in table "ticket" */
export type Ticket_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "ticket" */
export type Ticket_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  key_identifier?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  summary?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Ticket_Max_Fields = {
  __typename?: "ticket_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  key_identifier?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  summary?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Ticket_Min_Fields = {
  __typename?: "ticket_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  key_identifier?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["String"]["output"]>
  summary?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "ticket" */
export type Ticket_Mutation_Response = {
  __typename?: "ticket_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Ticket>
}

/** on_conflict condition type for table "ticket" */
export type Ticket_On_Conflict = {
  constraint: Ticket_Constraint
  update_columns?: Array<Ticket_Update_Column>
  where?: InputMaybe<Ticket_Bool_Exp>
}

/** Ordering options when selecting data from "ticket". */
export type Ticket_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  description?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  key_identifier?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  summary?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: ticket */
export type Ticket_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "ticket" */
export enum Ticket_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Description = "description",
  /** column name */
  Id = "id",
  /** column name */
  KeyIdentifier = "key_identifier",
  /** column name */
  Status = "status",
  /** column name */
  Summary = "summary",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "ticket" */
export type Ticket_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  key_identifier?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  summary?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Ticket_Stddev_Fields = {
  __typename?: "ticket_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Ticket_Stddev_Pop_Fields = {
  __typename?: "ticket_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Ticket_Stddev_Samp_Fields = {
  __typename?: "ticket_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "ticket" */
export type Ticket_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ticket_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Ticket_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  key_identifier?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  summary?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Ticket_Sum_Fields = {
  __typename?: "ticket_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "ticket" */
export enum Ticket_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Description = "description",
  /** column name */
  Id = "id",
  /** column name */
  KeyIdentifier = "key_identifier",
  /** column name */
  Status = "status",
  /** column name */
  Summary = "summary",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Ticket_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ticket_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ticket_Set_Input>
  /** filter the rows which have to be updated */
  where: Ticket_Bool_Exp
}

/** aggregate var_pop on columns */
export type Ticket_Var_Pop_Fields = {
  __typename?: "ticket_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Ticket_Var_Samp_Fields = {
  __typename?: "ticket_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Ticket_Variance_Fields = {
  __typename?: "ticket_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "automation_account_store" */
export type Tickets_Automation_Account_Store = {
  __typename?: "tickets_automation_account_store"
  account_balance?: Maybe<Scalars["numeric"]["output"]>
  account_id?: Maybe<Scalars["bigint"]["output"]>
  account_in_review?: Maybe<Scalars["Boolean"]["output"]>
  account_live?: Maybe<Scalars["Boolean"]["output"]>
  account_number?: Maybe<Scalars["String"]["output"]>
  automation_job_id: Scalars["bigint"]["output"]
  collection_status?: Maybe<Scalars["Int"]["output"]>
  created_at: Scalars["timestamptz"]["output"]
  dd_status?: Maybe<Scalars["String"]["output"]>
  debt_over_120_days?: Maybe<Scalars["numeric"]["output"]>
  deceased?: Maybe<Scalars["Boolean"]["output"]>
  direct_debit_created?: Maybe<Scalars["date"]["output"]>
  dr_ticket_open?: Maybe<Scalars["Boolean"]["output"]>
  et_ticket_open?: Maybe<Scalars["Boolean"]["output"]>
  final_bill_received?: Maybe<Scalars["date"]["output"]>
  id: Scalars["bigint"]["output"]
  open_complaint?: Maybe<Scalars["Boolean"]["output"]>
  payment_plan?: Maybe<Scalars["Boolean"]["output"]>
  pending_payments?: Maybe<Scalars["numeric"]["output"]>
  projected_debt_12_months?: Maybe<Scalars["numeric"]["output"]>
  recently_unbilled?: Maybe<Scalars["Boolean"]["output"]>
  updated_at: Scalars["timestamp"]["output"]
  with_dca?: Maybe<Scalars["Boolean"]["output"]>
}

/** aggregated selection of "automation_account_store" */
export type Tickets_Automation_Account_Store_Aggregate = {
  __typename?: "tickets_automation_account_store_aggregate"
  aggregate?: Maybe<Tickets_Automation_Account_Store_Aggregate_Fields>
  nodes: Array<Tickets_Automation_Account_Store>
}

/** aggregate fields of "automation_account_store" */
export type Tickets_Automation_Account_Store_Aggregate_Fields = {
  __typename?: "tickets_automation_account_store_aggregate_fields"
  avg?: Maybe<Tickets_Automation_Account_Store_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Automation_Account_Store_Max_Fields>
  min?: Maybe<Tickets_Automation_Account_Store_Min_Fields>
  stddev?: Maybe<Tickets_Automation_Account_Store_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Automation_Account_Store_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Automation_Account_Store_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Automation_Account_Store_Sum_Fields>
  var_pop?: Maybe<Tickets_Automation_Account_Store_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Automation_Account_Store_Var_Samp_Fields>
  variance?: Maybe<Tickets_Automation_Account_Store_Variance_Fields>
}

/** aggregate fields of "automation_account_store" */
export type Tickets_Automation_Account_Store_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Automation_Account_Store_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_Automation_Account_Store_Avg_Fields = {
  __typename?: "tickets_automation_account_store_avg_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  account_id?: Maybe<Scalars["Float"]["output"]>
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  collection_status?: Maybe<Scalars["Float"]["output"]>
  debt_over_120_days?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  pending_payments?: Maybe<Scalars["Float"]["output"]>
  projected_debt_12_months?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "automation_account_store". All fields are combined with a logical 'AND'. */
export type Tickets_Automation_Account_Store_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Automation_Account_Store_Bool_Exp>>
  _not?: InputMaybe<Tickets_Automation_Account_Store_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Automation_Account_Store_Bool_Exp>>
  account_balance?: InputMaybe<Numeric_Comparison_Exp>
  account_id?: InputMaybe<Bigint_Comparison_Exp>
  account_in_review?: InputMaybe<Boolean_Comparison_Exp>
  account_live?: InputMaybe<Boolean_Comparison_Exp>
  account_number?: InputMaybe<String_Comparison_Exp>
  automation_job_id?: InputMaybe<Bigint_Comparison_Exp>
  collection_status?: InputMaybe<Int_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  dd_status?: InputMaybe<String_Comparison_Exp>
  debt_over_120_days?: InputMaybe<Numeric_Comparison_Exp>
  deceased?: InputMaybe<Boolean_Comparison_Exp>
  direct_debit_created?: InputMaybe<Date_Comparison_Exp>
  dr_ticket_open?: InputMaybe<Boolean_Comparison_Exp>
  et_ticket_open?: InputMaybe<Boolean_Comparison_Exp>
  final_bill_received?: InputMaybe<Date_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  open_complaint?: InputMaybe<Boolean_Comparison_Exp>
  payment_plan?: InputMaybe<Boolean_Comparison_Exp>
  pending_payments?: InputMaybe<Numeric_Comparison_Exp>
  projected_debt_12_months?: InputMaybe<Numeric_Comparison_Exp>
  recently_unbilled?: InputMaybe<Boolean_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  with_dca?: InputMaybe<Boolean_Comparison_Exp>
}

/** unique or primary key constraints on table "automation_account_store" */
export enum Tickets_Automation_Account_Store_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkAutomationAccountStore = "pk_automation_account_store",
}

/** input type for incrementing numeric columns in table "automation_account_store" */
export type Tickets_Automation_Account_Store_Inc_Input = {
  account_balance?: InputMaybe<Scalars["numeric"]["input"]>
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  automation_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  collection_status?: InputMaybe<Scalars["Int"]["input"]>
  debt_over_120_days?: InputMaybe<Scalars["numeric"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  pending_payments?: InputMaybe<Scalars["numeric"]["input"]>
  projected_debt_12_months?: InputMaybe<Scalars["numeric"]["input"]>
}

/** input type for inserting data into table "automation_account_store" */
export type Tickets_Automation_Account_Store_Insert_Input = {
  account_balance?: InputMaybe<Scalars["numeric"]["input"]>
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  account_in_review?: InputMaybe<Scalars["Boolean"]["input"]>
  account_live?: InputMaybe<Scalars["Boolean"]["input"]>
  account_number?: InputMaybe<Scalars["String"]["input"]>
  automation_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  collection_status?: InputMaybe<Scalars["Int"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  dd_status?: InputMaybe<Scalars["String"]["input"]>
  debt_over_120_days?: InputMaybe<Scalars["numeric"]["input"]>
  deceased?: InputMaybe<Scalars["Boolean"]["input"]>
  direct_debit_created?: InputMaybe<Scalars["date"]["input"]>
  dr_ticket_open?: InputMaybe<Scalars["Boolean"]["input"]>
  et_ticket_open?: InputMaybe<Scalars["Boolean"]["input"]>
  final_bill_received?: InputMaybe<Scalars["date"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  open_complaint?: InputMaybe<Scalars["Boolean"]["input"]>
  payment_plan?: InputMaybe<Scalars["Boolean"]["input"]>
  pending_payments?: InputMaybe<Scalars["numeric"]["input"]>
  projected_debt_12_months?: InputMaybe<Scalars["numeric"]["input"]>
  recently_unbilled?: InputMaybe<Scalars["Boolean"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  with_dca?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Automation_Account_Store_Max_Fields = {
  __typename?: "tickets_automation_account_store_max_fields"
  account_balance?: Maybe<Scalars["numeric"]["output"]>
  account_id?: Maybe<Scalars["bigint"]["output"]>
  account_number?: Maybe<Scalars["String"]["output"]>
  automation_job_id?: Maybe<Scalars["bigint"]["output"]>
  collection_status?: Maybe<Scalars["Int"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  dd_status?: Maybe<Scalars["String"]["output"]>
  debt_over_120_days?: Maybe<Scalars["numeric"]["output"]>
  direct_debit_created?: Maybe<Scalars["date"]["output"]>
  final_bill_received?: Maybe<Scalars["date"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  pending_payments?: Maybe<Scalars["numeric"]["output"]>
  projected_debt_12_months?: Maybe<Scalars["numeric"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Automation_Account_Store_Min_Fields = {
  __typename?: "tickets_automation_account_store_min_fields"
  account_balance?: Maybe<Scalars["numeric"]["output"]>
  account_id?: Maybe<Scalars["bigint"]["output"]>
  account_number?: Maybe<Scalars["String"]["output"]>
  automation_job_id?: Maybe<Scalars["bigint"]["output"]>
  collection_status?: Maybe<Scalars["Int"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  dd_status?: Maybe<Scalars["String"]["output"]>
  debt_over_120_days?: Maybe<Scalars["numeric"]["output"]>
  direct_debit_created?: Maybe<Scalars["date"]["output"]>
  final_bill_received?: Maybe<Scalars["date"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  pending_payments?: Maybe<Scalars["numeric"]["output"]>
  projected_debt_12_months?: Maybe<Scalars["numeric"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "automation_account_store" */
export type Tickets_Automation_Account_Store_Mutation_Response = {
  __typename?: "tickets_automation_account_store_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Automation_Account_Store>
}

/** on_conflict condition type for table "automation_account_store" */
export type Tickets_Automation_Account_Store_On_Conflict = {
  constraint: Tickets_Automation_Account_Store_Constraint
  update_columns?: Array<Tickets_Automation_Account_Store_Update_Column>
  where?: InputMaybe<Tickets_Automation_Account_Store_Bool_Exp>
}

/** Ordering options when selecting data from "automation_account_store". */
export type Tickets_Automation_Account_Store_Order_By = {
  account_balance?: InputMaybe<Order_By>
  account_id?: InputMaybe<Order_By>
  account_in_review?: InputMaybe<Order_By>
  account_live?: InputMaybe<Order_By>
  account_number?: InputMaybe<Order_By>
  automation_job_id?: InputMaybe<Order_By>
  collection_status?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  dd_status?: InputMaybe<Order_By>
  debt_over_120_days?: InputMaybe<Order_By>
  deceased?: InputMaybe<Order_By>
  direct_debit_created?: InputMaybe<Order_By>
  dr_ticket_open?: InputMaybe<Order_By>
  et_ticket_open?: InputMaybe<Order_By>
  final_bill_received?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  open_complaint?: InputMaybe<Order_By>
  payment_plan?: InputMaybe<Order_By>
  pending_payments?: InputMaybe<Order_By>
  projected_debt_12_months?: InputMaybe<Order_By>
  recently_unbilled?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  with_dca?: InputMaybe<Order_By>
}

/** primary key columns input for table: automation_account_store */
export type Tickets_Automation_Account_Store_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "automation_account_store" */
export enum Tickets_Automation_Account_Store_Select_Column {
  /** column name */
  AccountBalance = "account_balance",
  /** column name */
  AccountId = "account_id",
  /** column name */
  AccountInReview = "account_in_review",
  /** column name */
  AccountLive = "account_live",
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AutomationJobId = "automation_job_id",
  /** column name */
  CollectionStatus = "collection_status",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DdStatus = "dd_status",
  /** column name */
  DebtOver_120Days = "debt_over_120_days",
  /** column name */
  Deceased = "deceased",
  /** column name */
  DirectDebitCreated = "direct_debit_created",
  /** column name */
  DrTicketOpen = "dr_ticket_open",
  /** column name */
  EtTicketOpen = "et_ticket_open",
  /** column name */
  FinalBillReceived = "final_bill_received",
  /** column name */
  Id = "id",
  /** column name */
  OpenComplaint = "open_complaint",
  /** column name */
  PaymentPlan = "payment_plan",
  /** column name */
  PendingPayments = "pending_payments",
  /** column name */
  ProjectedDebt_12Months = "projected_debt_12_months",
  /** column name */
  RecentlyUnbilled = "recently_unbilled",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  WithDca = "with_dca",
}

/** input type for updating data in table "automation_account_store" */
export type Tickets_Automation_Account_Store_Set_Input = {
  account_balance?: InputMaybe<Scalars["numeric"]["input"]>
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  account_in_review?: InputMaybe<Scalars["Boolean"]["input"]>
  account_live?: InputMaybe<Scalars["Boolean"]["input"]>
  account_number?: InputMaybe<Scalars["String"]["input"]>
  automation_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  collection_status?: InputMaybe<Scalars["Int"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  dd_status?: InputMaybe<Scalars["String"]["input"]>
  debt_over_120_days?: InputMaybe<Scalars["numeric"]["input"]>
  deceased?: InputMaybe<Scalars["Boolean"]["input"]>
  direct_debit_created?: InputMaybe<Scalars["date"]["input"]>
  dr_ticket_open?: InputMaybe<Scalars["Boolean"]["input"]>
  et_ticket_open?: InputMaybe<Scalars["Boolean"]["input"]>
  final_bill_received?: InputMaybe<Scalars["date"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  open_complaint?: InputMaybe<Scalars["Boolean"]["input"]>
  payment_plan?: InputMaybe<Scalars["Boolean"]["input"]>
  pending_payments?: InputMaybe<Scalars["numeric"]["input"]>
  projected_debt_12_months?: InputMaybe<Scalars["numeric"]["input"]>
  recently_unbilled?: InputMaybe<Scalars["Boolean"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  with_dca?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Automation_Account_Store_Stddev_Fields = {
  __typename?: "tickets_automation_account_store_stddev_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  account_id?: Maybe<Scalars["Float"]["output"]>
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  collection_status?: Maybe<Scalars["Float"]["output"]>
  debt_over_120_days?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  pending_payments?: Maybe<Scalars["Float"]["output"]>
  projected_debt_12_months?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Automation_Account_Store_Stddev_Pop_Fields = {
  __typename?: "tickets_automation_account_store_stddev_pop_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  account_id?: Maybe<Scalars["Float"]["output"]>
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  collection_status?: Maybe<Scalars["Float"]["output"]>
  debt_over_120_days?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  pending_payments?: Maybe<Scalars["Float"]["output"]>
  projected_debt_12_months?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Automation_Account_Store_Stddev_Samp_Fields = {
  __typename?: "tickets_automation_account_store_stddev_samp_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  account_id?: Maybe<Scalars["Float"]["output"]>
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  collection_status?: Maybe<Scalars["Float"]["output"]>
  debt_over_120_days?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  pending_payments?: Maybe<Scalars["Float"]["output"]>
  projected_debt_12_months?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_automation_account_store" */
export type Tickets_Automation_Account_Store_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Automation_Account_Store_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Automation_Account_Store_Stream_Cursor_Value_Input = {
  account_balance?: InputMaybe<Scalars["numeric"]["input"]>
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  account_in_review?: InputMaybe<Scalars["Boolean"]["input"]>
  account_live?: InputMaybe<Scalars["Boolean"]["input"]>
  account_number?: InputMaybe<Scalars["String"]["input"]>
  automation_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  collection_status?: InputMaybe<Scalars["Int"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  dd_status?: InputMaybe<Scalars["String"]["input"]>
  debt_over_120_days?: InputMaybe<Scalars["numeric"]["input"]>
  deceased?: InputMaybe<Scalars["Boolean"]["input"]>
  direct_debit_created?: InputMaybe<Scalars["date"]["input"]>
  dr_ticket_open?: InputMaybe<Scalars["Boolean"]["input"]>
  et_ticket_open?: InputMaybe<Scalars["Boolean"]["input"]>
  final_bill_received?: InputMaybe<Scalars["date"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  open_complaint?: InputMaybe<Scalars["Boolean"]["input"]>
  payment_plan?: InputMaybe<Scalars["Boolean"]["input"]>
  pending_payments?: InputMaybe<Scalars["numeric"]["input"]>
  projected_debt_12_months?: InputMaybe<Scalars["numeric"]["input"]>
  recently_unbilled?: InputMaybe<Scalars["Boolean"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  with_dca?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_Automation_Account_Store_Sum_Fields = {
  __typename?: "tickets_automation_account_store_sum_fields"
  account_balance?: Maybe<Scalars["numeric"]["output"]>
  account_id?: Maybe<Scalars["bigint"]["output"]>
  automation_job_id?: Maybe<Scalars["bigint"]["output"]>
  collection_status?: Maybe<Scalars["Int"]["output"]>
  debt_over_120_days?: Maybe<Scalars["numeric"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  pending_payments?: Maybe<Scalars["numeric"]["output"]>
  projected_debt_12_months?: Maybe<Scalars["numeric"]["output"]>
}

/** update columns of table "automation_account_store" */
export enum Tickets_Automation_Account_Store_Update_Column {
  /** column name */
  AccountBalance = "account_balance",
  /** column name */
  AccountId = "account_id",
  /** column name */
  AccountInReview = "account_in_review",
  /** column name */
  AccountLive = "account_live",
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AutomationJobId = "automation_job_id",
  /** column name */
  CollectionStatus = "collection_status",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DdStatus = "dd_status",
  /** column name */
  DebtOver_120Days = "debt_over_120_days",
  /** column name */
  Deceased = "deceased",
  /** column name */
  DirectDebitCreated = "direct_debit_created",
  /** column name */
  DrTicketOpen = "dr_ticket_open",
  /** column name */
  EtTicketOpen = "et_ticket_open",
  /** column name */
  FinalBillReceived = "final_bill_received",
  /** column name */
  Id = "id",
  /** column name */
  OpenComplaint = "open_complaint",
  /** column name */
  PaymentPlan = "payment_plan",
  /** column name */
  PendingPayments = "pending_payments",
  /** column name */
  ProjectedDebt_12Months = "projected_debt_12_months",
  /** column name */
  RecentlyUnbilled = "recently_unbilled",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  WithDca = "with_dca",
}

export type Tickets_Automation_Account_Store_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Automation_Account_Store_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Automation_Account_Store_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Automation_Account_Store_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Automation_Account_Store_Var_Pop_Fields = {
  __typename?: "tickets_automation_account_store_var_pop_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  account_id?: Maybe<Scalars["Float"]["output"]>
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  collection_status?: Maybe<Scalars["Float"]["output"]>
  debt_over_120_days?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  pending_payments?: Maybe<Scalars["Float"]["output"]>
  projected_debt_12_months?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Automation_Account_Store_Var_Samp_Fields = {
  __typename?: "tickets_automation_account_store_var_samp_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  account_id?: Maybe<Scalars["Float"]["output"]>
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  collection_status?: Maybe<Scalars["Float"]["output"]>
  debt_over_120_days?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  pending_payments?: Maybe<Scalars["Float"]["output"]>
  projected_debt_12_months?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Automation_Account_Store_Variance_Fields = {
  __typename?: "tickets_automation_account_store_variance_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  account_id?: Maybe<Scalars["Float"]["output"]>
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  collection_status?: Maybe<Scalars["Float"]["output"]>
  debt_over_120_days?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  pending_payments?: Maybe<Scalars["Float"]["output"]>
  projected_debt_12_months?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "automation_config" */
export type Tickets_Automation_Config = {
  __typename?: "tickets_automation_config"
  config_enabled: Scalars["Boolean"]["output"]
  created_at: Scalars["timestamptz"]["output"]
  id: Scalars["bigint"]["output"]
}

/** aggregated selection of "automation_config" */
export type Tickets_Automation_Config_Aggregate = {
  __typename?: "tickets_automation_config_aggregate"
  aggregate?: Maybe<Tickets_Automation_Config_Aggregate_Fields>
  nodes: Array<Tickets_Automation_Config>
}

/** aggregate fields of "automation_config" */
export type Tickets_Automation_Config_Aggregate_Fields = {
  __typename?: "tickets_automation_config_aggregate_fields"
  avg?: Maybe<Tickets_Automation_Config_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Automation_Config_Max_Fields>
  min?: Maybe<Tickets_Automation_Config_Min_Fields>
  stddev?: Maybe<Tickets_Automation_Config_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Automation_Config_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Automation_Config_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Automation_Config_Sum_Fields>
  var_pop?: Maybe<Tickets_Automation_Config_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Automation_Config_Var_Samp_Fields>
  variance?: Maybe<Tickets_Automation_Config_Variance_Fields>
}

/** aggregate fields of "automation_config" */
export type Tickets_Automation_Config_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Automation_Config_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_Automation_Config_Avg_Fields = {
  __typename?: "tickets_automation_config_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "automation_config". All fields are combined with a logical 'AND'. */
export type Tickets_Automation_Config_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Automation_Config_Bool_Exp>>
  _not?: InputMaybe<Tickets_Automation_Config_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Automation_Config_Bool_Exp>>
  config_enabled?: InputMaybe<Boolean_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
}

/** unique or primary key constraints on table "automation_config" */
export enum Tickets_Automation_Config_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkAutomationConfig = "pk_automation_config",
}

/** columns and relationships of "automation_config_default" */
export type Tickets_Automation_Config_Default = {
  __typename?: "tickets_automation_config_default"
  automation_config_id: Scalars["bigint"]["output"]
  config_automation_default_batch_account_size: Scalars["Int"]["output"]
  config_automation_default_delay_ms: Scalars["Int"]["output"]
  config_batch_publish_accounts: Scalars["Int"]["output"]
  config_enable_table_lookup_for_opening_tickets: Scalars["Boolean"]["output"]
  config_job_communication_bcc_emails: Scalars["String"]["output"]
  config_job_communication_email: Scalars["String"]["output"]
  config_job_communication_name: Scalars["String"]["output"]
  config_job_communication_template_name: Scalars["String"]["output"]
  config_maximum_projected_debt_remainder: Scalars["numeric"]["output"]
  config_minimum_balance_pounds_final: Scalars["numeric"]["output"]
  config_minimum_balance_pounds_live: Scalars["numeric"]["output"]
  config_minimum_collections_status: Scalars["Int"]["output"]
  config_minimum_dd_age_in_days: Scalars["Int"]["output"]
  config_minimum_final_bill_age_in_days: Scalars["Int"]["output"]
  config_minimum_old_debt_size_in_pounds: Scalars["numeric"]["output"]
  config_pre_default_to_default_threshold_in_days: Scalars["bigint"]["output"]
  config_pre_satisfied_to_default_threshold_in_days: Scalars["bigint"]["output"]
  config_pre_satisfied_to_satisfied_threshold_in_days: Scalars["bigint"]["output"]
  cron_expression: Scalars["String"]["output"]
  id: Scalars["bigint"]["output"]
  max_predefaults_per_run?: Maybe<Scalars["Int"]["output"]>
}

/** aggregated selection of "automation_config_default" */
export type Tickets_Automation_Config_Default_Aggregate = {
  __typename?: "tickets_automation_config_default_aggregate"
  aggregate?: Maybe<Tickets_Automation_Config_Default_Aggregate_Fields>
  nodes: Array<Tickets_Automation_Config_Default>
}

/** aggregate fields of "automation_config_default" */
export type Tickets_Automation_Config_Default_Aggregate_Fields = {
  __typename?: "tickets_automation_config_default_aggregate_fields"
  avg?: Maybe<Tickets_Automation_Config_Default_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Automation_Config_Default_Max_Fields>
  min?: Maybe<Tickets_Automation_Config_Default_Min_Fields>
  stddev?: Maybe<Tickets_Automation_Config_Default_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Automation_Config_Default_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Automation_Config_Default_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Automation_Config_Default_Sum_Fields>
  var_pop?: Maybe<Tickets_Automation_Config_Default_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Automation_Config_Default_Var_Samp_Fields>
  variance?: Maybe<Tickets_Automation_Config_Default_Variance_Fields>
}

/** aggregate fields of "automation_config_default" */
export type Tickets_Automation_Config_Default_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Automation_Config_Default_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_Automation_Config_Default_Avg_Fields = {
  __typename?: "tickets_automation_config_default_avg_fields"
  automation_config_id?: Maybe<Scalars["Float"]["output"]>
  config_automation_default_batch_account_size?: Maybe<
    Scalars["Float"]["output"]
  >
  config_automation_default_delay_ms?: Maybe<Scalars["Float"]["output"]>
  config_batch_publish_accounts?: Maybe<Scalars["Float"]["output"]>
  config_maximum_projected_debt_remainder?: Maybe<Scalars["Float"]["output"]>
  config_minimum_balance_pounds_final?: Maybe<Scalars["Float"]["output"]>
  config_minimum_balance_pounds_live?: Maybe<Scalars["Float"]["output"]>
  config_minimum_collections_status?: Maybe<Scalars["Float"]["output"]>
  config_minimum_dd_age_in_days?: Maybe<Scalars["Float"]["output"]>
  config_minimum_final_bill_age_in_days?: Maybe<Scalars["Float"]["output"]>
  config_minimum_old_debt_size_in_pounds?: Maybe<Scalars["Float"]["output"]>
  config_pre_default_to_default_threshold_in_days?: Maybe<
    Scalars["Float"]["output"]
  >
  config_pre_satisfied_to_default_threshold_in_days?: Maybe<
    Scalars["Float"]["output"]
  >
  config_pre_satisfied_to_satisfied_threshold_in_days?: Maybe<
    Scalars["Float"]["output"]
  >
  id?: Maybe<Scalars["Float"]["output"]>
  max_predefaults_per_run?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "automation_config_default". All fields are combined with a logical 'AND'. */
export type Tickets_Automation_Config_Default_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Automation_Config_Default_Bool_Exp>>
  _not?: InputMaybe<Tickets_Automation_Config_Default_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Automation_Config_Default_Bool_Exp>>
  automation_config_id?: InputMaybe<Bigint_Comparison_Exp>
  config_automation_default_batch_account_size?: InputMaybe<Int_Comparison_Exp>
  config_automation_default_delay_ms?: InputMaybe<Int_Comparison_Exp>
  config_batch_publish_accounts?: InputMaybe<Int_Comparison_Exp>
  config_enable_table_lookup_for_opening_tickets?: InputMaybe<Boolean_Comparison_Exp>
  config_job_communication_bcc_emails?: InputMaybe<String_Comparison_Exp>
  config_job_communication_email?: InputMaybe<String_Comparison_Exp>
  config_job_communication_name?: InputMaybe<String_Comparison_Exp>
  config_job_communication_template_name?: InputMaybe<String_Comparison_Exp>
  config_maximum_projected_debt_remainder?: InputMaybe<Numeric_Comparison_Exp>
  config_minimum_balance_pounds_final?: InputMaybe<Numeric_Comparison_Exp>
  config_minimum_balance_pounds_live?: InputMaybe<Numeric_Comparison_Exp>
  config_minimum_collections_status?: InputMaybe<Int_Comparison_Exp>
  config_minimum_dd_age_in_days?: InputMaybe<Int_Comparison_Exp>
  config_minimum_final_bill_age_in_days?: InputMaybe<Int_Comparison_Exp>
  config_minimum_old_debt_size_in_pounds?: InputMaybe<Numeric_Comparison_Exp>
  config_pre_default_to_default_threshold_in_days?: InputMaybe<Bigint_Comparison_Exp>
  config_pre_satisfied_to_default_threshold_in_days?: InputMaybe<Bigint_Comparison_Exp>
  config_pre_satisfied_to_satisfied_threshold_in_days?: InputMaybe<Bigint_Comparison_Exp>
  cron_expression?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  max_predefaults_per_run?: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "automation_config_default" */
export enum Tickets_Automation_Config_Default_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkAutomationConfigDefault = "pk_automation_config_default",
}

/** input type for incrementing numeric columns in table "automation_config_default" */
export type Tickets_Automation_Config_Default_Inc_Input = {
  automation_config_id?: InputMaybe<Scalars["bigint"]["input"]>
  config_automation_default_batch_account_size?: InputMaybe<
    Scalars["Int"]["input"]
  >
  config_automation_default_delay_ms?: InputMaybe<Scalars["Int"]["input"]>
  config_batch_publish_accounts?: InputMaybe<Scalars["Int"]["input"]>
  config_maximum_projected_debt_remainder?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  config_minimum_balance_pounds_final?: InputMaybe<Scalars["numeric"]["input"]>
  config_minimum_balance_pounds_live?: InputMaybe<Scalars["numeric"]["input"]>
  config_minimum_collections_status?: InputMaybe<Scalars["Int"]["input"]>
  config_minimum_dd_age_in_days?: InputMaybe<Scalars["Int"]["input"]>
  config_minimum_final_bill_age_in_days?: InputMaybe<Scalars["Int"]["input"]>
  config_minimum_old_debt_size_in_pounds?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  config_pre_default_to_default_threshold_in_days?: InputMaybe<
    Scalars["bigint"]["input"]
  >
  config_pre_satisfied_to_default_threshold_in_days?: InputMaybe<
    Scalars["bigint"]["input"]
  >
  config_pre_satisfied_to_satisfied_threshold_in_days?: InputMaybe<
    Scalars["bigint"]["input"]
  >
  id?: InputMaybe<Scalars["bigint"]["input"]>
  max_predefaults_per_run?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "automation_config_default" */
export type Tickets_Automation_Config_Default_Insert_Input = {
  automation_config_id?: InputMaybe<Scalars["bigint"]["input"]>
  config_automation_default_batch_account_size?: InputMaybe<
    Scalars["Int"]["input"]
  >
  config_automation_default_delay_ms?: InputMaybe<Scalars["Int"]["input"]>
  config_batch_publish_accounts?: InputMaybe<Scalars["Int"]["input"]>
  config_enable_table_lookup_for_opening_tickets?: InputMaybe<
    Scalars["Boolean"]["input"]
  >
  config_job_communication_bcc_emails?: InputMaybe<Scalars["String"]["input"]>
  config_job_communication_email?: InputMaybe<Scalars["String"]["input"]>
  config_job_communication_name?: InputMaybe<Scalars["String"]["input"]>
  config_job_communication_template_name?: InputMaybe<
    Scalars["String"]["input"]
  >
  config_maximum_projected_debt_remainder?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  config_minimum_balance_pounds_final?: InputMaybe<Scalars["numeric"]["input"]>
  config_minimum_balance_pounds_live?: InputMaybe<Scalars["numeric"]["input"]>
  config_minimum_collections_status?: InputMaybe<Scalars["Int"]["input"]>
  config_minimum_dd_age_in_days?: InputMaybe<Scalars["Int"]["input"]>
  config_minimum_final_bill_age_in_days?: InputMaybe<Scalars["Int"]["input"]>
  config_minimum_old_debt_size_in_pounds?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  config_pre_default_to_default_threshold_in_days?: InputMaybe<
    Scalars["bigint"]["input"]
  >
  config_pre_satisfied_to_default_threshold_in_days?: InputMaybe<
    Scalars["bigint"]["input"]
  >
  config_pre_satisfied_to_satisfied_threshold_in_days?: InputMaybe<
    Scalars["bigint"]["input"]
  >
  cron_expression?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  max_predefaults_per_run?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Automation_Config_Default_Max_Fields = {
  __typename?: "tickets_automation_config_default_max_fields"
  automation_config_id?: Maybe<Scalars["bigint"]["output"]>
  config_automation_default_batch_account_size?: Maybe<Scalars["Int"]["output"]>
  config_automation_default_delay_ms?: Maybe<Scalars["Int"]["output"]>
  config_batch_publish_accounts?: Maybe<Scalars["Int"]["output"]>
  config_job_communication_bcc_emails?: Maybe<Scalars["String"]["output"]>
  config_job_communication_email?: Maybe<Scalars["String"]["output"]>
  config_job_communication_name?: Maybe<Scalars["String"]["output"]>
  config_job_communication_template_name?: Maybe<Scalars["String"]["output"]>
  config_maximum_projected_debt_remainder?: Maybe<Scalars["numeric"]["output"]>
  config_minimum_balance_pounds_final?: Maybe<Scalars["numeric"]["output"]>
  config_minimum_balance_pounds_live?: Maybe<Scalars["numeric"]["output"]>
  config_minimum_collections_status?: Maybe<Scalars["Int"]["output"]>
  config_minimum_dd_age_in_days?: Maybe<Scalars["Int"]["output"]>
  config_minimum_final_bill_age_in_days?: Maybe<Scalars["Int"]["output"]>
  config_minimum_old_debt_size_in_pounds?: Maybe<Scalars["numeric"]["output"]>
  config_pre_default_to_default_threshold_in_days?: Maybe<
    Scalars["bigint"]["output"]
  >
  config_pre_satisfied_to_default_threshold_in_days?: Maybe<
    Scalars["bigint"]["output"]
  >
  config_pre_satisfied_to_satisfied_threshold_in_days?: Maybe<
    Scalars["bigint"]["output"]
  >
  cron_expression?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  max_predefaults_per_run?: Maybe<Scalars["Int"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Automation_Config_Default_Min_Fields = {
  __typename?: "tickets_automation_config_default_min_fields"
  automation_config_id?: Maybe<Scalars["bigint"]["output"]>
  config_automation_default_batch_account_size?: Maybe<Scalars["Int"]["output"]>
  config_automation_default_delay_ms?: Maybe<Scalars["Int"]["output"]>
  config_batch_publish_accounts?: Maybe<Scalars["Int"]["output"]>
  config_job_communication_bcc_emails?: Maybe<Scalars["String"]["output"]>
  config_job_communication_email?: Maybe<Scalars["String"]["output"]>
  config_job_communication_name?: Maybe<Scalars["String"]["output"]>
  config_job_communication_template_name?: Maybe<Scalars["String"]["output"]>
  config_maximum_projected_debt_remainder?: Maybe<Scalars["numeric"]["output"]>
  config_minimum_balance_pounds_final?: Maybe<Scalars["numeric"]["output"]>
  config_minimum_balance_pounds_live?: Maybe<Scalars["numeric"]["output"]>
  config_minimum_collections_status?: Maybe<Scalars["Int"]["output"]>
  config_minimum_dd_age_in_days?: Maybe<Scalars["Int"]["output"]>
  config_minimum_final_bill_age_in_days?: Maybe<Scalars["Int"]["output"]>
  config_minimum_old_debt_size_in_pounds?: Maybe<Scalars["numeric"]["output"]>
  config_pre_default_to_default_threshold_in_days?: Maybe<
    Scalars["bigint"]["output"]
  >
  config_pre_satisfied_to_default_threshold_in_days?: Maybe<
    Scalars["bigint"]["output"]
  >
  config_pre_satisfied_to_satisfied_threshold_in_days?: Maybe<
    Scalars["bigint"]["output"]
  >
  cron_expression?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  max_predefaults_per_run?: Maybe<Scalars["Int"]["output"]>
}

/** response of any mutation on the table "automation_config_default" */
export type Tickets_Automation_Config_Default_Mutation_Response = {
  __typename?: "tickets_automation_config_default_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Automation_Config_Default>
}

/** on_conflict condition type for table "automation_config_default" */
export type Tickets_Automation_Config_Default_On_Conflict = {
  constraint: Tickets_Automation_Config_Default_Constraint
  update_columns?: Array<Tickets_Automation_Config_Default_Update_Column>
  where?: InputMaybe<Tickets_Automation_Config_Default_Bool_Exp>
}

/** Ordering options when selecting data from "automation_config_default". */
export type Tickets_Automation_Config_Default_Order_By = {
  automation_config_id?: InputMaybe<Order_By>
  config_automation_default_batch_account_size?: InputMaybe<Order_By>
  config_automation_default_delay_ms?: InputMaybe<Order_By>
  config_batch_publish_accounts?: InputMaybe<Order_By>
  config_enable_table_lookup_for_opening_tickets?: InputMaybe<Order_By>
  config_job_communication_bcc_emails?: InputMaybe<Order_By>
  config_job_communication_email?: InputMaybe<Order_By>
  config_job_communication_name?: InputMaybe<Order_By>
  config_job_communication_template_name?: InputMaybe<Order_By>
  config_maximum_projected_debt_remainder?: InputMaybe<Order_By>
  config_minimum_balance_pounds_final?: InputMaybe<Order_By>
  config_minimum_balance_pounds_live?: InputMaybe<Order_By>
  config_minimum_collections_status?: InputMaybe<Order_By>
  config_minimum_dd_age_in_days?: InputMaybe<Order_By>
  config_minimum_final_bill_age_in_days?: InputMaybe<Order_By>
  config_minimum_old_debt_size_in_pounds?: InputMaybe<Order_By>
  config_pre_default_to_default_threshold_in_days?: InputMaybe<Order_By>
  config_pre_satisfied_to_default_threshold_in_days?: InputMaybe<Order_By>
  config_pre_satisfied_to_satisfied_threshold_in_days?: InputMaybe<Order_By>
  cron_expression?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  max_predefaults_per_run?: InputMaybe<Order_By>
}

/** primary key columns input for table: automation_config_default */
export type Tickets_Automation_Config_Default_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "automation_config_default" */
export enum Tickets_Automation_Config_Default_Select_Column {
  /** column name */
  AutomationConfigId = "automation_config_id",
  /** column name */
  ConfigAutomationDefaultBatchAccountSize = "config_automation_default_batch_account_size",
  /** column name */
  ConfigAutomationDefaultDelayMs = "config_automation_default_delay_ms",
  /** column name */
  ConfigBatchPublishAccounts = "config_batch_publish_accounts",
  /** column name */
  ConfigEnableTableLookupForOpeningTickets = "config_enable_table_lookup_for_opening_tickets",
  /** column name */
  ConfigJobCommunicationBccEmails = "config_job_communication_bcc_emails",
  /** column name */
  ConfigJobCommunicationEmail = "config_job_communication_email",
  /** column name */
  ConfigJobCommunicationName = "config_job_communication_name",
  /** column name */
  ConfigJobCommunicationTemplateName = "config_job_communication_template_name",
  /** column name */
  ConfigMaximumProjectedDebtRemainder = "config_maximum_projected_debt_remainder",
  /** column name */
  ConfigMinimumBalancePoundsFinal = "config_minimum_balance_pounds_final",
  /** column name */
  ConfigMinimumBalancePoundsLive = "config_minimum_balance_pounds_live",
  /** column name */
  ConfigMinimumCollectionsStatus = "config_minimum_collections_status",
  /** column name */
  ConfigMinimumDdAgeInDays = "config_minimum_dd_age_in_days",
  /** column name */
  ConfigMinimumFinalBillAgeInDays = "config_minimum_final_bill_age_in_days",
  /** column name */
  ConfigMinimumOldDebtSizeInPounds = "config_minimum_old_debt_size_in_pounds",
  /** column name */
  ConfigPreDefaultToDefaultThresholdInDays = "config_pre_default_to_default_threshold_in_days",
  /** column name */
  ConfigPreSatisfiedToDefaultThresholdInDays = "config_pre_satisfied_to_default_threshold_in_days",
  /** column name */
  ConfigPreSatisfiedToSatisfiedThresholdInDays = "config_pre_satisfied_to_satisfied_threshold_in_days",
  /** column name */
  CronExpression = "cron_expression",
  /** column name */
  Id = "id",
  /** column name */
  MaxPredefaultsPerRun = "max_predefaults_per_run",
}

/** input type for updating data in table "automation_config_default" */
export type Tickets_Automation_Config_Default_Set_Input = {
  automation_config_id?: InputMaybe<Scalars["bigint"]["input"]>
  config_automation_default_batch_account_size?: InputMaybe<
    Scalars["Int"]["input"]
  >
  config_automation_default_delay_ms?: InputMaybe<Scalars["Int"]["input"]>
  config_batch_publish_accounts?: InputMaybe<Scalars["Int"]["input"]>
  config_enable_table_lookup_for_opening_tickets?: InputMaybe<
    Scalars["Boolean"]["input"]
  >
  config_job_communication_bcc_emails?: InputMaybe<Scalars["String"]["input"]>
  config_job_communication_email?: InputMaybe<Scalars["String"]["input"]>
  config_job_communication_name?: InputMaybe<Scalars["String"]["input"]>
  config_job_communication_template_name?: InputMaybe<
    Scalars["String"]["input"]
  >
  config_maximum_projected_debt_remainder?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  config_minimum_balance_pounds_final?: InputMaybe<Scalars["numeric"]["input"]>
  config_minimum_balance_pounds_live?: InputMaybe<Scalars["numeric"]["input"]>
  config_minimum_collections_status?: InputMaybe<Scalars["Int"]["input"]>
  config_minimum_dd_age_in_days?: InputMaybe<Scalars["Int"]["input"]>
  config_minimum_final_bill_age_in_days?: InputMaybe<Scalars["Int"]["input"]>
  config_minimum_old_debt_size_in_pounds?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  config_pre_default_to_default_threshold_in_days?: InputMaybe<
    Scalars["bigint"]["input"]
  >
  config_pre_satisfied_to_default_threshold_in_days?: InputMaybe<
    Scalars["bigint"]["input"]
  >
  config_pre_satisfied_to_satisfied_threshold_in_days?: InputMaybe<
    Scalars["bigint"]["input"]
  >
  cron_expression?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  max_predefaults_per_run?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Automation_Config_Default_Stddev_Fields = {
  __typename?: "tickets_automation_config_default_stddev_fields"
  automation_config_id?: Maybe<Scalars["Float"]["output"]>
  config_automation_default_batch_account_size?: Maybe<
    Scalars["Float"]["output"]
  >
  config_automation_default_delay_ms?: Maybe<Scalars["Float"]["output"]>
  config_batch_publish_accounts?: Maybe<Scalars["Float"]["output"]>
  config_maximum_projected_debt_remainder?: Maybe<Scalars["Float"]["output"]>
  config_minimum_balance_pounds_final?: Maybe<Scalars["Float"]["output"]>
  config_minimum_balance_pounds_live?: Maybe<Scalars["Float"]["output"]>
  config_minimum_collections_status?: Maybe<Scalars["Float"]["output"]>
  config_minimum_dd_age_in_days?: Maybe<Scalars["Float"]["output"]>
  config_minimum_final_bill_age_in_days?: Maybe<Scalars["Float"]["output"]>
  config_minimum_old_debt_size_in_pounds?: Maybe<Scalars["Float"]["output"]>
  config_pre_default_to_default_threshold_in_days?: Maybe<
    Scalars["Float"]["output"]
  >
  config_pre_satisfied_to_default_threshold_in_days?: Maybe<
    Scalars["Float"]["output"]
  >
  config_pre_satisfied_to_satisfied_threshold_in_days?: Maybe<
    Scalars["Float"]["output"]
  >
  id?: Maybe<Scalars["Float"]["output"]>
  max_predefaults_per_run?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Automation_Config_Default_Stddev_Pop_Fields = {
  __typename?: "tickets_automation_config_default_stddev_pop_fields"
  automation_config_id?: Maybe<Scalars["Float"]["output"]>
  config_automation_default_batch_account_size?: Maybe<
    Scalars["Float"]["output"]
  >
  config_automation_default_delay_ms?: Maybe<Scalars["Float"]["output"]>
  config_batch_publish_accounts?: Maybe<Scalars["Float"]["output"]>
  config_maximum_projected_debt_remainder?: Maybe<Scalars["Float"]["output"]>
  config_minimum_balance_pounds_final?: Maybe<Scalars["Float"]["output"]>
  config_minimum_balance_pounds_live?: Maybe<Scalars["Float"]["output"]>
  config_minimum_collections_status?: Maybe<Scalars["Float"]["output"]>
  config_minimum_dd_age_in_days?: Maybe<Scalars["Float"]["output"]>
  config_minimum_final_bill_age_in_days?: Maybe<Scalars["Float"]["output"]>
  config_minimum_old_debt_size_in_pounds?: Maybe<Scalars["Float"]["output"]>
  config_pre_default_to_default_threshold_in_days?: Maybe<
    Scalars["Float"]["output"]
  >
  config_pre_satisfied_to_default_threshold_in_days?: Maybe<
    Scalars["Float"]["output"]
  >
  config_pre_satisfied_to_satisfied_threshold_in_days?: Maybe<
    Scalars["Float"]["output"]
  >
  id?: Maybe<Scalars["Float"]["output"]>
  max_predefaults_per_run?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Automation_Config_Default_Stddev_Samp_Fields = {
  __typename?: "tickets_automation_config_default_stddev_samp_fields"
  automation_config_id?: Maybe<Scalars["Float"]["output"]>
  config_automation_default_batch_account_size?: Maybe<
    Scalars["Float"]["output"]
  >
  config_automation_default_delay_ms?: Maybe<Scalars["Float"]["output"]>
  config_batch_publish_accounts?: Maybe<Scalars["Float"]["output"]>
  config_maximum_projected_debt_remainder?: Maybe<Scalars["Float"]["output"]>
  config_minimum_balance_pounds_final?: Maybe<Scalars["Float"]["output"]>
  config_minimum_balance_pounds_live?: Maybe<Scalars["Float"]["output"]>
  config_minimum_collections_status?: Maybe<Scalars["Float"]["output"]>
  config_minimum_dd_age_in_days?: Maybe<Scalars["Float"]["output"]>
  config_minimum_final_bill_age_in_days?: Maybe<Scalars["Float"]["output"]>
  config_minimum_old_debt_size_in_pounds?: Maybe<Scalars["Float"]["output"]>
  config_pre_default_to_default_threshold_in_days?: Maybe<
    Scalars["Float"]["output"]
  >
  config_pre_satisfied_to_default_threshold_in_days?: Maybe<
    Scalars["Float"]["output"]
  >
  config_pre_satisfied_to_satisfied_threshold_in_days?: Maybe<
    Scalars["Float"]["output"]
  >
  id?: Maybe<Scalars["Float"]["output"]>
  max_predefaults_per_run?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_automation_config_default" */
export type Tickets_Automation_Config_Default_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Automation_Config_Default_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Automation_Config_Default_Stream_Cursor_Value_Input = {
  automation_config_id?: InputMaybe<Scalars["bigint"]["input"]>
  config_automation_default_batch_account_size?: InputMaybe<
    Scalars["Int"]["input"]
  >
  config_automation_default_delay_ms?: InputMaybe<Scalars["Int"]["input"]>
  config_batch_publish_accounts?: InputMaybe<Scalars["Int"]["input"]>
  config_enable_table_lookup_for_opening_tickets?: InputMaybe<
    Scalars["Boolean"]["input"]
  >
  config_job_communication_bcc_emails?: InputMaybe<Scalars["String"]["input"]>
  config_job_communication_email?: InputMaybe<Scalars["String"]["input"]>
  config_job_communication_name?: InputMaybe<Scalars["String"]["input"]>
  config_job_communication_template_name?: InputMaybe<
    Scalars["String"]["input"]
  >
  config_maximum_projected_debt_remainder?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  config_minimum_balance_pounds_final?: InputMaybe<Scalars["numeric"]["input"]>
  config_minimum_balance_pounds_live?: InputMaybe<Scalars["numeric"]["input"]>
  config_minimum_collections_status?: InputMaybe<Scalars["Int"]["input"]>
  config_minimum_dd_age_in_days?: InputMaybe<Scalars["Int"]["input"]>
  config_minimum_final_bill_age_in_days?: InputMaybe<Scalars["Int"]["input"]>
  config_minimum_old_debt_size_in_pounds?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  config_pre_default_to_default_threshold_in_days?: InputMaybe<
    Scalars["bigint"]["input"]
  >
  config_pre_satisfied_to_default_threshold_in_days?: InputMaybe<
    Scalars["bigint"]["input"]
  >
  config_pre_satisfied_to_satisfied_threshold_in_days?: InputMaybe<
    Scalars["bigint"]["input"]
  >
  cron_expression?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  max_predefaults_per_run?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_Automation_Config_Default_Sum_Fields = {
  __typename?: "tickets_automation_config_default_sum_fields"
  automation_config_id?: Maybe<Scalars["bigint"]["output"]>
  config_automation_default_batch_account_size?: Maybe<Scalars["Int"]["output"]>
  config_automation_default_delay_ms?: Maybe<Scalars["Int"]["output"]>
  config_batch_publish_accounts?: Maybe<Scalars["Int"]["output"]>
  config_maximum_projected_debt_remainder?: Maybe<Scalars["numeric"]["output"]>
  config_minimum_balance_pounds_final?: Maybe<Scalars["numeric"]["output"]>
  config_minimum_balance_pounds_live?: Maybe<Scalars["numeric"]["output"]>
  config_minimum_collections_status?: Maybe<Scalars["Int"]["output"]>
  config_minimum_dd_age_in_days?: Maybe<Scalars["Int"]["output"]>
  config_minimum_final_bill_age_in_days?: Maybe<Scalars["Int"]["output"]>
  config_minimum_old_debt_size_in_pounds?: Maybe<Scalars["numeric"]["output"]>
  config_pre_default_to_default_threshold_in_days?: Maybe<
    Scalars["bigint"]["output"]
  >
  config_pre_satisfied_to_default_threshold_in_days?: Maybe<
    Scalars["bigint"]["output"]
  >
  config_pre_satisfied_to_satisfied_threshold_in_days?: Maybe<
    Scalars["bigint"]["output"]
  >
  id?: Maybe<Scalars["bigint"]["output"]>
  max_predefaults_per_run?: Maybe<Scalars["Int"]["output"]>
}

/** update columns of table "automation_config_default" */
export enum Tickets_Automation_Config_Default_Update_Column {
  /** column name */
  AutomationConfigId = "automation_config_id",
  /** column name */
  ConfigAutomationDefaultBatchAccountSize = "config_automation_default_batch_account_size",
  /** column name */
  ConfigAutomationDefaultDelayMs = "config_automation_default_delay_ms",
  /** column name */
  ConfigBatchPublishAccounts = "config_batch_publish_accounts",
  /** column name */
  ConfigEnableTableLookupForOpeningTickets = "config_enable_table_lookup_for_opening_tickets",
  /** column name */
  ConfigJobCommunicationBccEmails = "config_job_communication_bcc_emails",
  /** column name */
  ConfigJobCommunicationEmail = "config_job_communication_email",
  /** column name */
  ConfigJobCommunicationName = "config_job_communication_name",
  /** column name */
  ConfigJobCommunicationTemplateName = "config_job_communication_template_name",
  /** column name */
  ConfigMaximumProjectedDebtRemainder = "config_maximum_projected_debt_remainder",
  /** column name */
  ConfigMinimumBalancePoundsFinal = "config_minimum_balance_pounds_final",
  /** column name */
  ConfigMinimumBalancePoundsLive = "config_minimum_balance_pounds_live",
  /** column name */
  ConfigMinimumCollectionsStatus = "config_minimum_collections_status",
  /** column name */
  ConfigMinimumDdAgeInDays = "config_minimum_dd_age_in_days",
  /** column name */
  ConfigMinimumFinalBillAgeInDays = "config_minimum_final_bill_age_in_days",
  /** column name */
  ConfigMinimumOldDebtSizeInPounds = "config_minimum_old_debt_size_in_pounds",
  /** column name */
  ConfigPreDefaultToDefaultThresholdInDays = "config_pre_default_to_default_threshold_in_days",
  /** column name */
  ConfigPreSatisfiedToDefaultThresholdInDays = "config_pre_satisfied_to_default_threshold_in_days",
  /** column name */
  ConfigPreSatisfiedToSatisfiedThresholdInDays = "config_pre_satisfied_to_satisfied_threshold_in_days",
  /** column name */
  CronExpression = "cron_expression",
  /** column name */
  Id = "id",
  /** column name */
  MaxPredefaultsPerRun = "max_predefaults_per_run",
}

export type Tickets_Automation_Config_Default_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Automation_Config_Default_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Automation_Config_Default_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Automation_Config_Default_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Automation_Config_Default_Var_Pop_Fields = {
  __typename?: "tickets_automation_config_default_var_pop_fields"
  automation_config_id?: Maybe<Scalars["Float"]["output"]>
  config_automation_default_batch_account_size?: Maybe<
    Scalars["Float"]["output"]
  >
  config_automation_default_delay_ms?: Maybe<Scalars["Float"]["output"]>
  config_batch_publish_accounts?: Maybe<Scalars["Float"]["output"]>
  config_maximum_projected_debt_remainder?: Maybe<Scalars["Float"]["output"]>
  config_minimum_balance_pounds_final?: Maybe<Scalars["Float"]["output"]>
  config_minimum_balance_pounds_live?: Maybe<Scalars["Float"]["output"]>
  config_minimum_collections_status?: Maybe<Scalars["Float"]["output"]>
  config_minimum_dd_age_in_days?: Maybe<Scalars["Float"]["output"]>
  config_minimum_final_bill_age_in_days?: Maybe<Scalars["Float"]["output"]>
  config_minimum_old_debt_size_in_pounds?: Maybe<Scalars["Float"]["output"]>
  config_pre_default_to_default_threshold_in_days?: Maybe<
    Scalars["Float"]["output"]
  >
  config_pre_satisfied_to_default_threshold_in_days?: Maybe<
    Scalars["Float"]["output"]
  >
  config_pre_satisfied_to_satisfied_threshold_in_days?: Maybe<
    Scalars["Float"]["output"]
  >
  id?: Maybe<Scalars["Float"]["output"]>
  max_predefaults_per_run?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Automation_Config_Default_Var_Samp_Fields = {
  __typename?: "tickets_automation_config_default_var_samp_fields"
  automation_config_id?: Maybe<Scalars["Float"]["output"]>
  config_automation_default_batch_account_size?: Maybe<
    Scalars["Float"]["output"]
  >
  config_automation_default_delay_ms?: Maybe<Scalars["Float"]["output"]>
  config_batch_publish_accounts?: Maybe<Scalars["Float"]["output"]>
  config_maximum_projected_debt_remainder?: Maybe<Scalars["Float"]["output"]>
  config_minimum_balance_pounds_final?: Maybe<Scalars["Float"]["output"]>
  config_minimum_balance_pounds_live?: Maybe<Scalars["Float"]["output"]>
  config_minimum_collections_status?: Maybe<Scalars["Float"]["output"]>
  config_minimum_dd_age_in_days?: Maybe<Scalars["Float"]["output"]>
  config_minimum_final_bill_age_in_days?: Maybe<Scalars["Float"]["output"]>
  config_minimum_old_debt_size_in_pounds?: Maybe<Scalars["Float"]["output"]>
  config_pre_default_to_default_threshold_in_days?: Maybe<
    Scalars["Float"]["output"]
  >
  config_pre_satisfied_to_default_threshold_in_days?: Maybe<
    Scalars["Float"]["output"]
  >
  config_pre_satisfied_to_satisfied_threshold_in_days?: Maybe<
    Scalars["Float"]["output"]
  >
  id?: Maybe<Scalars["Float"]["output"]>
  max_predefaults_per_run?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Automation_Config_Default_Variance_Fields = {
  __typename?: "tickets_automation_config_default_variance_fields"
  automation_config_id?: Maybe<Scalars["Float"]["output"]>
  config_automation_default_batch_account_size?: Maybe<
    Scalars["Float"]["output"]
  >
  config_automation_default_delay_ms?: Maybe<Scalars["Float"]["output"]>
  config_batch_publish_accounts?: Maybe<Scalars["Float"]["output"]>
  config_maximum_projected_debt_remainder?: Maybe<Scalars["Float"]["output"]>
  config_minimum_balance_pounds_final?: Maybe<Scalars["Float"]["output"]>
  config_minimum_balance_pounds_live?: Maybe<Scalars["Float"]["output"]>
  config_minimum_collections_status?: Maybe<Scalars["Float"]["output"]>
  config_minimum_dd_age_in_days?: Maybe<Scalars["Float"]["output"]>
  config_minimum_final_bill_age_in_days?: Maybe<Scalars["Float"]["output"]>
  config_minimum_old_debt_size_in_pounds?: Maybe<Scalars["Float"]["output"]>
  config_pre_default_to_default_threshold_in_days?: Maybe<
    Scalars["Float"]["output"]
  >
  config_pre_satisfied_to_default_threshold_in_days?: Maybe<
    Scalars["Float"]["output"]
  >
  config_pre_satisfied_to_satisfied_threshold_in_days?: Maybe<
    Scalars["Float"]["output"]
  >
  id?: Maybe<Scalars["Float"]["output"]>
  max_predefaults_per_run?: Maybe<Scalars["Float"]["output"]>
}

/** input type for incrementing numeric columns in table "automation_config" */
export type Tickets_Automation_Config_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "automation_config" */
export type Tickets_Automation_Config_Insert_Input = {
  config_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Automation_Config_Max_Fields = {
  __typename?: "tickets_automation_config_max_fields"
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Automation_Config_Min_Fields = {
  __typename?: "tickets_automation_config_min_fields"
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** response of any mutation on the table "automation_config" */
export type Tickets_Automation_Config_Mutation_Response = {
  __typename?: "tickets_automation_config_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Automation_Config>
}

/** on_conflict condition type for table "automation_config" */
export type Tickets_Automation_Config_On_Conflict = {
  constraint: Tickets_Automation_Config_Constraint
  update_columns?: Array<Tickets_Automation_Config_Update_Column>
  where?: InputMaybe<Tickets_Automation_Config_Bool_Exp>
}

/** Ordering options when selecting data from "automation_config". */
export type Tickets_Automation_Config_Order_By = {
  config_enabled?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** primary key columns input for table: automation_config */
export type Tickets_Automation_Config_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** columns and relationships of "automation_config_purge" */
export type Tickets_Automation_Config_Purge = {
  __typename?: "tickets_automation_config_purge"
  automation_config_id: Scalars["bigint"]["output"]
  config_purge_data_threshold_in_days: Scalars["bigint"]["output"]
  cron_expression: Scalars["String"]["output"]
  id: Scalars["bigint"]["output"]
  is_enabled?: Maybe<Scalars["Boolean"]["output"]>
}

/** aggregated selection of "automation_config_purge" */
export type Tickets_Automation_Config_Purge_Aggregate = {
  __typename?: "tickets_automation_config_purge_aggregate"
  aggregate?: Maybe<Tickets_Automation_Config_Purge_Aggregate_Fields>
  nodes: Array<Tickets_Automation_Config_Purge>
}

/** aggregate fields of "automation_config_purge" */
export type Tickets_Automation_Config_Purge_Aggregate_Fields = {
  __typename?: "tickets_automation_config_purge_aggregate_fields"
  avg?: Maybe<Tickets_Automation_Config_Purge_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Automation_Config_Purge_Max_Fields>
  min?: Maybe<Tickets_Automation_Config_Purge_Min_Fields>
  stddev?: Maybe<Tickets_Automation_Config_Purge_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Automation_Config_Purge_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Automation_Config_Purge_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Automation_Config_Purge_Sum_Fields>
  var_pop?: Maybe<Tickets_Automation_Config_Purge_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Automation_Config_Purge_Var_Samp_Fields>
  variance?: Maybe<Tickets_Automation_Config_Purge_Variance_Fields>
}

/** aggregate fields of "automation_config_purge" */
export type Tickets_Automation_Config_Purge_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Automation_Config_Purge_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_Automation_Config_Purge_Avg_Fields = {
  __typename?: "tickets_automation_config_purge_avg_fields"
  automation_config_id?: Maybe<Scalars["Float"]["output"]>
  config_purge_data_threshold_in_days?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "automation_config_purge". All fields are combined with a logical 'AND'. */
export type Tickets_Automation_Config_Purge_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Automation_Config_Purge_Bool_Exp>>
  _not?: InputMaybe<Tickets_Automation_Config_Purge_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Automation_Config_Purge_Bool_Exp>>
  automation_config_id?: InputMaybe<Bigint_Comparison_Exp>
  config_purge_data_threshold_in_days?: InputMaybe<Bigint_Comparison_Exp>
  cron_expression?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  is_enabled?: InputMaybe<Boolean_Comparison_Exp>
}

/** unique or primary key constraints on table "automation_config_purge" */
export enum Tickets_Automation_Config_Purge_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkAutomationConfigPurge = "pk_automation_config_purge",
}

/** input type for incrementing numeric columns in table "automation_config_purge" */
export type Tickets_Automation_Config_Purge_Inc_Input = {
  automation_config_id?: InputMaybe<Scalars["bigint"]["input"]>
  config_purge_data_threshold_in_days?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "automation_config_purge" */
export type Tickets_Automation_Config_Purge_Insert_Input = {
  automation_config_id?: InputMaybe<Scalars["bigint"]["input"]>
  config_purge_data_threshold_in_days?: InputMaybe<Scalars["bigint"]["input"]>
  cron_expression?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  is_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Automation_Config_Purge_Max_Fields = {
  __typename?: "tickets_automation_config_purge_max_fields"
  automation_config_id?: Maybe<Scalars["bigint"]["output"]>
  config_purge_data_threshold_in_days?: Maybe<Scalars["bigint"]["output"]>
  cron_expression?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Automation_Config_Purge_Min_Fields = {
  __typename?: "tickets_automation_config_purge_min_fields"
  automation_config_id?: Maybe<Scalars["bigint"]["output"]>
  config_purge_data_threshold_in_days?: Maybe<Scalars["bigint"]["output"]>
  cron_expression?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** response of any mutation on the table "automation_config_purge" */
export type Tickets_Automation_Config_Purge_Mutation_Response = {
  __typename?: "tickets_automation_config_purge_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Automation_Config_Purge>
}

/** on_conflict condition type for table "automation_config_purge" */
export type Tickets_Automation_Config_Purge_On_Conflict = {
  constraint: Tickets_Automation_Config_Purge_Constraint
  update_columns?: Array<Tickets_Automation_Config_Purge_Update_Column>
  where?: InputMaybe<Tickets_Automation_Config_Purge_Bool_Exp>
}

/** Ordering options when selecting data from "automation_config_purge". */
export type Tickets_Automation_Config_Purge_Order_By = {
  automation_config_id?: InputMaybe<Order_By>
  config_purge_data_threshold_in_days?: InputMaybe<Order_By>
  cron_expression?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  is_enabled?: InputMaybe<Order_By>
}

/** primary key columns input for table: automation_config_purge */
export type Tickets_Automation_Config_Purge_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "automation_config_purge" */
export enum Tickets_Automation_Config_Purge_Select_Column {
  /** column name */
  AutomationConfigId = "automation_config_id",
  /** column name */
  ConfigPurgeDataThresholdInDays = "config_purge_data_threshold_in_days",
  /** column name */
  CronExpression = "cron_expression",
  /** column name */
  Id = "id",
  /** column name */
  IsEnabled = "is_enabled",
}

/** input type for updating data in table "automation_config_purge" */
export type Tickets_Automation_Config_Purge_Set_Input = {
  automation_config_id?: InputMaybe<Scalars["bigint"]["input"]>
  config_purge_data_threshold_in_days?: InputMaybe<Scalars["bigint"]["input"]>
  cron_expression?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  is_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Automation_Config_Purge_Stddev_Fields = {
  __typename?: "tickets_automation_config_purge_stddev_fields"
  automation_config_id?: Maybe<Scalars["Float"]["output"]>
  config_purge_data_threshold_in_days?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Automation_Config_Purge_Stddev_Pop_Fields = {
  __typename?: "tickets_automation_config_purge_stddev_pop_fields"
  automation_config_id?: Maybe<Scalars["Float"]["output"]>
  config_purge_data_threshold_in_days?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Automation_Config_Purge_Stddev_Samp_Fields = {
  __typename?: "tickets_automation_config_purge_stddev_samp_fields"
  automation_config_id?: Maybe<Scalars["Float"]["output"]>
  config_purge_data_threshold_in_days?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_automation_config_purge" */
export type Tickets_Automation_Config_Purge_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Automation_Config_Purge_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Automation_Config_Purge_Stream_Cursor_Value_Input = {
  automation_config_id?: InputMaybe<Scalars["bigint"]["input"]>
  config_purge_data_threshold_in_days?: InputMaybe<Scalars["bigint"]["input"]>
  cron_expression?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  is_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_Automation_Config_Purge_Sum_Fields = {
  __typename?: "tickets_automation_config_purge_sum_fields"
  automation_config_id?: Maybe<Scalars["bigint"]["output"]>
  config_purge_data_threshold_in_days?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "automation_config_purge" */
export enum Tickets_Automation_Config_Purge_Update_Column {
  /** column name */
  AutomationConfigId = "automation_config_id",
  /** column name */
  ConfigPurgeDataThresholdInDays = "config_purge_data_threshold_in_days",
  /** column name */
  CronExpression = "cron_expression",
  /** column name */
  Id = "id",
  /** column name */
  IsEnabled = "is_enabled",
}

export type Tickets_Automation_Config_Purge_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Automation_Config_Purge_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Automation_Config_Purge_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Automation_Config_Purge_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Automation_Config_Purge_Var_Pop_Fields = {
  __typename?: "tickets_automation_config_purge_var_pop_fields"
  automation_config_id?: Maybe<Scalars["Float"]["output"]>
  config_purge_data_threshold_in_days?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Automation_Config_Purge_Var_Samp_Fields = {
  __typename?: "tickets_automation_config_purge_var_samp_fields"
  automation_config_id?: Maybe<Scalars["Float"]["output"]>
  config_purge_data_threshold_in_days?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Automation_Config_Purge_Variance_Fields = {
  __typename?: "tickets_automation_config_purge_variance_fields"
  automation_config_id?: Maybe<Scalars["Float"]["output"]>
  config_purge_data_threshold_in_days?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** select columns of table "automation_config" */
export enum Tickets_Automation_Config_Select_Column {
  /** column name */
  ConfigEnabled = "config_enabled",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
}

/** input type for updating data in table "automation_config" */
export type Tickets_Automation_Config_Set_Input = {
  config_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Automation_Config_Stddev_Fields = {
  __typename?: "tickets_automation_config_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Automation_Config_Stddev_Pop_Fields = {
  __typename?: "tickets_automation_config_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Automation_Config_Stddev_Samp_Fields = {
  __typename?: "tickets_automation_config_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_automation_config" */
export type Tickets_Automation_Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Automation_Config_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Automation_Config_Stream_Cursor_Value_Input = {
  config_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_Automation_Config_Sum_Fields = {
  __typename?: "tickets_automation_config_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "automation_config" */
export enum Tickets_Automation_Config_Update_Column {
  /** column name */
  ConfigEnabled = "config_enabled",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
}

export type Tickets_Automation_Config_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Automation_Config_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Automation_Config_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Automation_Config_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Automation_Config_Var_Pop_Fields = {
  __typename?: "tickets_automation_config_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Automation_Config_Var_Samp_Fields = {
  __typename?: "tickets_automation_config_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Automation_Config_Variance_Fields = {
  __typename?: "tickets_automation_config_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "automation_default_ticket_action" */
export type Tickets_Automation_Default_Ticket_Action = {
  __typename?: "tickets_automation_default_ticket_action"
  account_number?: Maybe<Scalars["String"]["output"]>
  automation_job_id: Scalars["bigint"]["output"]
  created_at: Scalars["timestamptz"]["output"]
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  move_ticket_reason?: Maybe<Scalars["String"]["output"]>
  new_step_code?: Maybe<Scalars["String"]["output"]>
  previous_step_code?: Maybe<Scalars["String"]["output"]>
  reject_reasons?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["automation_default_record_status_enum"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
}

/** aggregated selection of "automation_default_ticket_action" */
export type Tickets_Automation_Default_Ticket_Action_Aggregate = {
  __typename?: "tickets_automation_default_ticket_action_aggregate"
  aggregate?: Maybe<Tickets_Automation_Default_Ticket_Action_Aggregate_Fields>
  nodes: Array<Tickets_Automation_Default_Ticket_Action>
}

/** aggregate fields of "automation_default_ticket_action" */
export type Tickets_Automation_Default_Ticket_Action_Aggregate_Fields = {
  __typename?: "tickets_automation_default_ticket_action_aggregate_fields"
  avg?: Maybe<Tickets_Automation_Default_Ticket_Action_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Automation_Default_Ticket_Action_Max_Fields>
  min?: Maybe<Tickets_Automation_Default_Ticket_Action_Min_Fields>
  stddev?: Maybe<Tickets_Automation_Default_Ticket_Action_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Automation_Default_Ticket_Action_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Automation_Default_Ticket_Action_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Automation_Default_Ticket_Action_Sum_Fields>
  var_pop?: Maybe<Tickets_Automation_Default_Ticket_Action_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Automation_Default_Ticket_Action_Var_Samp_Fields>
  variance?: Maybe<Tickets_Automation_Default_Ticket_Action_Variance_Fields>
}

/** aggregate fields of "automation_default_ticket_action" */
export type Tickets_Automation_Default_Ticket_Action_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Tickets_Automation_Default_Ticket_Action_Select_Column>
    >
    distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  }

/** aggregate avg on columns */
export type Tickets_Automation_Default_Ticket_Action_Avg_Fields = {
  __typename?: "tickets_automation_default_ticket_action_avg_fields"
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "automation_default_ticket_action". All fields are combined with a logical 'AND'. */
export type Tickets_Automation_Default_Ticket_Action_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Automation_Default_Ticket_Action_Bool_Exp>>
  _not?: InputMaybe<Tickets_Automation_Default_Ticket_Action_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Automation_Default_Ticket_Action_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  automation_job_id?: InputMaybe<Bigint_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  failure_reason?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  move_ticket_reason?: InputMaybe<String_Comparison_Exp>
  new_step_code?: InputMaybe<String_Comparison_Exp>
  previous_step_code?: InputMaybe<String_Comparison_Exp>
  reject_reasons?: InputMaybe<String_Comparison_Exp>
  status?: InputMaybe<Automation_Default_Record_Status_Enum_Comparison_Exp>
  ticket_id?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "automation_default_ticket_action" */
export enum Tickets_Automation_Default_Ticket_Action_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkAutomationDefaultJourneyRecord = "pk_automation_default_journey_record",
}

/** input type for incrementing numeric columns in table "automation_default_ticket_action" */
export type Tickets_Automation_Default_Ticket_Action_Inc_Input = {
  automation_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "automation_default_ticket_action" */
export type Tickets_Automation_Default_Ticket_Action_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  automation_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  move_ticket_reason?: InputMaybe<Scalars["String"]["input"]>
  new_step_code?: InputMaybe<Scalars["String"]["input"]>
  previous_step_code?: InputMaybe<Scalars["String"]["input"]>
  reject_reasons?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["automation_default_record_status_enum"]["input"]>
  ticket_id?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Automation_Default_Ticket_Action_Max_Fields = {
  __typename?: "tickets_automation_default_ticket_action_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  automation_job_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  move_ticket_reason?: Maybe<Scalars["String"]["output"]>
  new_step_code?: Maybe<Scalars["String"]["output"]>
  previous_step_code?: Maybe<Scalars["String"]["output"]>
  reject_reasons?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["automation_default_record_status_enum"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Automation_Default_Ticket_Action_Min_Fields = {
  __typename?: "tickets_automation_default_ticket_action_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  automation_job_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  move_ticket_reason?: Maybe<Scalars["String"]["output"]>
  new_step_code?: Maybe<Scalars["String"]["output"]>
  previous_step_code?: Maybe<Scalars["String"]["output"]>
  reject_reasons?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["automation_default_record_status_enum"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "automation_default_ticket_action" */
export type Tickets_Automation_Default_Ticket_Action_Mutation_Response = {
  __typename?: "tickets_automation_default_ticket_action_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Automation_Default_Ticket_Action>
}

/** on_conflict condition type for table "automation_default_ticket_action" */
export type Tickets_Automation_Default_Ticket_Action_On_Conflict = {
  constraint: Tickets_Automation_Default_Ticket_Action_Constraint
  update_columns?: Array<Tickets_Automation_Default_Ticket_Action_Update_Column>
  where?: InputMaybe<Tickets_Automation_Default_Ticket_Action_Bool_Exp>
}

/** Ordering options when selecting data from "automation_default_ticket_action". */
export type Tickets_Automation_Default_Ticket_Action_Order_By = {
  account_number?: InputMaybe<Order_By>
  automation_job_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  failure_reason?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  move_ticket_reason?: InputMaybe<Order_By>
  new_step_code?: InputMaybe<Order_By>
  previous_step_code?: InputMaybe<Order_By>
  reject_reasons?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  ticket_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: automation_default_ticket_action */
export type Tickets_Automation_Default_Ticket_Action_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "automation_default_ticket_action" */
export enum Tickets_Automation_Default_Ticket_Action_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AutomationJobId = "automation_job_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  MoveTicketReason = "move_ticket_reason",
  /** column name */
  NewStepCode = "new_step_code",
  /** column name */
  PreviousStepCode = "previous_step_code",
  /** column name */
  RejectReasons = "reject_reasons",
  /** column name */
  Status = "status",
  /** column name */
  TicketId = "ticket_id",
}

/** input type for updating data in table "automation_default_ticket_action" */
export type Tickets_Automation_Default_Ticket_Action_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  automation_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  move_ticket_reason?: InputMaybe<Scalars["String"]["input"]>
  new_step_code?: InputMaybe<Scalars["String"]["input"]>
  previous_step_code?: InputMaybe<Scalars["String"]["input"]>
  reject_reasons?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["automation_default_record_status_enum"]["input"]>
  ticket_id?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Automation_Default_Ticket_Action_Stddev_Fields = {
  __typename?: "tickets_automation_default_ticket_action_stddev_fields"
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Automation_Default_Ticket_Action_Stddev_Pop_Fields = {
  __typename?: "tickets_automation_default_ticket_action_stddev_pop_fields"
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Automation_Default_Ticket_Action_Stddev_Samp_Fields = {
  __typename?: "tickets_automation_default_ticket_action_stddev_samp_fields"
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_automation_default_ticket_action" */
export type Tickets_Automation_Default_Ticket_Action_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Automation_Default_Ticket_Action_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Automation_Default_Ticket_Action_Stream_Cursor_Value_Input =
  {
    account_number?: InputMaybe<Scalars["String"]["input"]>
    automation_job_id?: InputMaybe<Scalars["bigint"]["input"]>
    created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
    failure_reason?: InputMaybe<Scalars["String"]["input"]>
    id?: InputMaybe<Scalars["bigint"]["input"]>
    move_ticket_reason?: InputMaybe<Scalars["String"]["input"]>
    new_step_code?: InputMaybe<Scalars["String"]["input"]>
    previous_step_code?: InputMaybe<Scalars["String"]["input"]>
    reject_reasons?: InputMaybe<Scalars["String"]["input"]>
    status?: InputMaybe<
      Scalars["automation_default_record_status_enum"]["input"]
    >
    ticket_id?: InputMaybe<Scalars["String"]["input"]>
  }

/** aggregate sum on columns */
export type Tickets_Automation_Default_Ticket_Action_Sum_Fields = {
  __typename?: "tickets_automation_default_ticket_action_sum_fields"
  automation_job_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "automation_default_ticket_action" */
export enum Tickets_Automation_Default_Ticket_Action_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AutomationJobId = "automation_job_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  MoveTicketReason = "move_ticket_reason",
  /** column name */
  NewStepCode = "new_step_code",
  /** column name */
  PreviousStepCode = "previous_step_code",
  /** column name */
  RejectReasons = "reject_reasons",
  /** column name */
  Status = "status",
  /** column name */
  TicketId = "ticket_id",
}

export type Tickets_Automation_Default_Ticket_Action_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Automation_Default_Ticket_Action_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Automation_Default_Ticket_Action_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Automation_Default_Ticket_Action_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Automation_Default_Ticket_Action_Var_Pop_Fields = {
  __typename?: "tickets_automation_default_ticket_action_var_pop_fields"
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Automation_Default_Ticket_Action_Var_Samp_Fields = {
  __typename?: "tickets_automation_default_ticket_action_var_samp_fields"
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Automation_Default_Ticket_Action_Variance_Fields = {
  __typename?: "tickets_automation_default_ticket_action_variance_fields"
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "automation_defaults_acceptable_accounts_table" */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table = {
  __typename?: "tickets_automation_defaults_acceptable_accounts_table"
  accountid: Scalars["bigint"]["output"]
  start_process_at: Scalars["date"]["output"]
}

/** aggregated selection of "automation_defaults_acceptable_accounts_table" */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_Aggregate = {
  __typename?: "tickets_automation_defaults_acceptable_accounts_table_aggregate"
  aggregate?: Maybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Aggregate_Fields>
  nodes: Array<Tickets_Automation_Defaults_Acceptable_Accounts_Table>
}

/** aggregate fields of "automation_defaults_acceptable_accounts_table" */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_Aggregate_Fields =
  {
    __typename?: "tickets_automation_defaults_acceptable_accounts_table_aggregate_fields"
    avg?: Maybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Avg_Fields>
    count: Scalars["Int"]["output"]
    max?: Maybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Max_Fields>
    min?: Maybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Min_Fields>
    stddev?: Maybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Stddev_Fields>
    stddev_pop?: Maybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Stddev_Pop_Fields>
    stddev_samp?: Maybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Stddev_Samp_Fields>
    sum?: Maybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Sum_Fields>
    var_pop?: Maybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Var_Pop_Fields>
    var_samp?: Maybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Var_Samp_Fields>
    variance?: Maybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Variance_Fields>
  }

/** aggregate fields of "automation_defaults_acceptable_accounts_table" */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Select_Column>
    >
    distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  }

/** aggregate avg on columns */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_Avg_Fields = {
  __typename?: "tickets_automation_defaults_acceptable_accounts_table_avg_fields"
  accountid?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "automation_defaults_acceptable_accounts_table". All fields are combined with a logical 'AND'. */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_Bool_Exp = {
  _and?: InputMaybe<
    Array<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Bool_Exp>
  >
  _not?: InputMaybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Bool_Exp>
  _or?: InputMaybe<
    Array<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Bool_Exp>
  >
  accountid?: InputMaybe<Bigint_Comparison_Exp>
  start_process_at?: InputMaybe<Date_Comparison_Exp>
}

/** unique or primary key constraints on table "automation_defaults_acceptable_accounts_table" */
export enum Tickets_Automation_Defaults_Acceptable_Accounts_Table_Constraint {
  /** unique or primary key constraint on columns "accountid" */
  PkAutomationDefaultAcceptableAccountsTable = "pk_automation_default_acceptable_accounts_table",
}

/** input type for incrementing numeric columns in table "automation_defaults_acceptable_accounts_table" */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_Inc_Input = {
  accountid?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "automation_defaults_acceptable_accounts_table" */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_Insert_Input =
  {
    accountid?: InputMaybe<Scalars["bigint"]["input"]>
    start_process_at?: InputMaybe<Scalars["date"]["input"]>
  }

/** aggregate max on columns */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_Max_Fields = {
  __typename?: "tickets_automation_defaults_acceptable_accounts_table_max_fields"
  accountid?: Maybe<Scalars["bigint"]["output"]>
  start_process_at?: Maybe<Scalars["date"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_Min_Fields = {
  __typename?: "tickets_automation_defaults_acceptable_accounts_table_min_fields"
  accountid?: Maybe<Scalars["bigint"]["output"]>
  start_process_at?: Maybe<Scalars["date"]["output"]>
}

/** response of any mutation on the table "automation_defaults_acceptable_accounts_table" */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_Mutation_Response =
  {
    __typename?: "tickets_automation_defaults_acceptable_accounts_table_mutation_response"
    /** number of rows affected by the mutation */
    affected_rows: Scalars["Int"]["output"]
    /** data from the rows affected by the mutation */
    returning: Array<Tickets_Automation_Defaults_Acceptable_Accounts_Table>
  }

/** on_conflict condition type for table "automation_defaults_acceptable_accounts_table" */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_On_Conflict =
  {
    constraint: Tickets_Automation_Defaults_Acceptable_Accounts_Table_Constraint
    update_columns?: Array<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Update_Column>
    where?: InputMaybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Bool_Exp>
  }

/** Ordering options when selecting data from "automation_defaults_acceptable_accounts_table". */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_Order_By = {
  accountid?: InputMaybe<Order_By>
  start_process_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: automation_defaults_acceptable_accounts_table */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_Pk_Columns_Input =
  {
    accountid: Scalars["bigint"]["input"]
  }

/** select columns of table "automation_defaults_acceptable_accounts_table" */
export enum Tickets_Automation_Defaults_Acceptable_Accounts_Table_Select_Column {
  /** column name */
  Accountid = "accountid",
  /** column name */
  StartProcessAt = "start_process_at",
}

/** input type for updating data in table "automation_defaults_acceptable_accounts_table" */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_Set_Input = {
  accountid?: InputMaybe<Scalars["bigint"]["input"]>
  start_process_at?: InputMaybe<Scalars["date"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_Stddev_Fields =
  {
    __typename?: "tickets_automation_defaults_acceptable_accounts_table_stddev_fields"
    accountid?: Maybe<Scalars["Float"]["output"]>
  }

/** aggregate stddev_pop on columns */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_Stddev_Pop_Fields =
  {
    __typename?: "tickets_automation_defaults_acceptable_accounts_table_stddev_pop_fields"
    accountid?: Maybe<Scalars["Float"]["output"]>
  }

/** aggregate stddev_samp on columns */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_Stddev_Samp_Fields =
  {
    __typename?: "tickets_automation_defaults_acceptable_accounts_table_stddev_samp_fields"
    accountid?: Maybe<Scalars["Float"]["output"]>
  }

/** Streaming cursor of the table "tickets_automation_defaults_acceptable_accounts_table" */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_Stream_Cursor_Input =
  {
    /** Stream column input with initial value */
    initial_value: Tickets_Automation_Defaults_Acceptable_Accounts_Table_Stream_Cursor_Value_Input
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>
  }

/** Initial value of the column from where the streaming should start */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_Stream_Cursor_Value_Input =
  {
    accountid?: InputMaybe<Scalars["bigint"]["input"]>
    start_process_at?: InputMaybe<Scalars["date"]["input"]>
  }

/** aggregate sum on columns */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_Sum_Fields = {
  __typename?: "tickets_automation_defaults_acceptable_accounts_table_sum_fields"
  accountid?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "automation_defaults_acceptable_accounts_table" */
export enum Tickets_Automation_Defaults_Acceptable_Accounts_Table_Update_Column {
  /** column name */
  Accountid = "accountid",
  /** column name */
  StartProcessAt = "start_process_at",
}

export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Automation_Defaults_Acceptable_Accounts_Table_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Automation_Defaults_Acceptable_Accounts_Table_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_Var_Pop_Fields =
  {
    __typename?: "tickets_automation_defaults_acceptable_accounts_table_var_pop_fields"
    accountid?: Maybe<Scalars["Float"]["output"]>
  }

/** aggregate var_samp on columns */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_Var_Samp_Fields =
  {
    __typename?: "tickets_automation_defaults_acceptable_accounts_table_var_samp_fields"
    accountid?: Maybe<Scalars["Float"]["output"]>
  }

/** aggregate variance on columns */
export type Tickets_Automation_Defaults_Acceptable_Accounts_Table_Variance_Fields =
  {
    __typename?: "tickets_automation_defaults_acceptable_accounts_table_variance_fields"
    accountid?: Maybe<Scalars["Float"]["output"]>
  }

/** columns and relationships of "automation_defaults_opened_predefaults" */
export type Tickets_Automation_Defaults_Opened_Predefaults = {
  __typename?: "tickets_automation_defaults_opened_predefaults"
  automation_job_id: Scalars["bigint"]["output"]
  id: Scalars["bigint"]["output"]
  total: Scalars["bigint"]["output"]
}

/** aggregated selection of "automation_defaults_opened_predefaults" */
export type Tickets_Automation_Defaults_Opened_Predefaults_Aggregate = {
  __typename?: "tickets_automation_defaults_opened_predefaults_aggregate"
  aggregate?: Maybe<Tickets_Automation_Defaults_Opened_Predefaults_Aggregate_Fields>
  nodes: Array<Tickets_Automation_Defaults_Opened_Predefaults>
}

/** aggregate fields of "automation_defaults_opened_predefaults" */
export type Tickets_Automation_Defaults_Opened_Predefaults_Aggregate_Fields = {
  __typename?: "tickets_automation_defaults_opened_predefaults_aggregate_fields"
  avg?: Maybe<Tickets_Automation_Defaults_Opened_Predefaults_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Automation_Defaults_Opened_Predefaults_Max_Fields>
  min?: Maybe<Tickets_Automation_Defaults_Opened_Predefaults_Min_Fields>
  stddev?: Maybe<Tickets_Automation_Defaults_Opened_Predefaults_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Automation_Defaults_Opened_Predefaults_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Automation_Defaults_Opened_Predefaults_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Automation_Defaults_Opened_Predefaults_Sum_Fields>
  var_pop?: Maybe<Tickets_Automation_Defaults_Opened_Predefaults_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Automation_Defaults_Opened_Predefaults_Var_Samp_Fields>
  variance?: Maybe<Tickets_Automation_Defaults_Opened_Predefaults_Variance_Fields>
}

/** aggregate fields of "automation_defaults_opened_predefaults" */
export type Tickets_Automation_Defaults_Opened_Predefaults_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Tickets_Automation_Defaults_Opened_Predefaults_Select_Column>
    >
    distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  }

/** aggregate avg on columns */
export type Tickets_Automation_Defaults_Opened_Predefaults_Avg_Fields = {
  __typename?: "tickets_automation_defaults_opened_predefaults_avg_fields"
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  total?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "automation_defaults_opened_predefaults". All fields are combined with a logical 'AND'. */
export type Tickets_Automation_Defaults_Opened_Predefaults_Bool_Exp = {
  _and?: InputMaybe<
    Array<Tickets_Automation_Defaults_Opened_Predefaults_Bool_Exp>
  >
  _not?: InputMaybe<Tickets_Automation_Defaults_Opened_Predefaults_Bool_Exp>
  _or?: InputMaybe<
    Array<Tickets_Automation_Defaults_Opened_Predefaults_Bool_Exp>
  >
  automation_job_id?: InputMaybe<Bigint_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  total?: InputMaybe<Bigint_Comparison_Exp>
}

/** unique or primary key constraints on table "automation_defaults_opened_predefaults" */
export enum Tickets_Automation_Defaults_Opened_Predefaults_Constraint {
  /** unique or primary key constraint on columns "id" */
  AutomationDefaultsOpenedPredefaultsPkey = "automation_defaults_opened_predefaults_pkey",
}

/** input type for incrementing numeric columns in table "automation_defaults_opened_predefaults" */
export type Tickets_Automation_Defaults_Opened_Predefaults_Inc_Input = {
  automation_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  total?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "automation_defaults_opened_predefaults" */
export type Tickets_Automation_Defaults_Opened_Predefaults_Insert_Input = {
  automation_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  total?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Automation_Defaults_Opened_Predefaults_Max_Fields = {
  __typename?: "tickets_automation_defaults_opened_predefaults_max_fields"
  automation_job_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  total?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Automation_Defaults_Opened_Predefaults_Min_Fields = {
  __typename?: "tickets_automation_defaults_opened_predefaults_min_fields"
  automation_job_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  total?: Maybe<Scalars["bigint"]["output"]>
}

/** response of any mutation on the table "automation_defaults_opened_predefaults" */
export type Tickets_Automation_Defaults_Opened_Predefaults_Mutation_Response = {
  __typename?: "tickets_automation_defaults_opened_predefaults_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Automation_Defaults_Opened_Predefaults>
}

/** on_conflict condition type for table "automation_defaults_opened_predefaults" */
export type Tickets_Automation_Defaults_Opened_Predefaults_On_Conflict = {
  constraint: Tickets_Automation_Defaults_Opened_Predefaults_Constraint
  update_columns?: Array<Tickets_Automation_Defaults_Opened_Predefaults_Update_Column>
  where?: InputMaybe<Tickets_Automation_Defaults_Opened_Predefaults_Bool_Exp>
}

/** Ordering options when selecting data from "automation_defaults_opened_predefaults". */
export type Tickets_Automation_Defaults_Opened_Predefaults_Order_By = {
  automation_job_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  total?: InputMaybe<Order_By>
}

/** primary key columns input for table: automation_defaults_opened_predefaults */
export type Tickets_Automation_Defaults_Opened_Predefaults_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "automation_defaults_opened_predefaults" */
export enum Tickets_Automation_Defaults_Opened_Predefaults_Select_Column {
  /** column name */
  AutomationJobId = "automation_job_id",
  /** column name */
  Id = "id",
  /** column name */
  Total = "total",
}

/** input type for updating data in table "automation_defaults_opened_predefaults" */
export type Tickets_Automation_Defaults_Opened_Predefaults_Set_Input = {
  automation_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  total?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Automation_Defaults_Opened_Predefaults_Stddev_Fields = {
  __typename?: "tickets_automation_defaults_opened_predefaults_stddev_fields"
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  total?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Automation_Defaults_Opened_Predefaults_Stddev_Pop_Fields = {
  __typename?: "tickets_automation_defaults_opened_predefaults_stddev_pop_fields"
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  total?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Automation_Defaults_Opened_Predefaults_Stddev_Samp_Fields =
  {
    __typename?: "tickets_automation_defaults_opened_predefaults_stddev_samp_fields"
    automation_job_id?: Maybe<Scalars["Float"]["output"]>
    id?: Maybe<Scalars["Float"]["output"]>
    total?: Maybe<Scalars["Float"]["output"]>
  }

/** Streaming cursor of the table "tickets_automation_defaults_opened_predefaults" */
export type Tickets_Automation_Defaults_Opened_Predefaults_Stream_Cursor_Input =
  {
    /** Stream column input with initial value */
    initial_value: Tickets_Automation_Defaults_Opened_Predefaults_Stream_Cursor_Value_Input
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>
  }

/** Initial value of the column from where the streaming should start */
export type Tickets_Automation_Defaults_Opened_Predefaults_Stream_Cursor_Value_Input =
  {
    automation_job_id?: InputMaybe<Scalars["bigint"]["input"]>
    id?: InputMaybe<Scalars["bigint"]["input"]>
    total?: InputMaybe<Scalars["bigint"]["input"]>
  }

/** aggregate sum on columns */
export type Tickets_Automation_Defaults_Opened_Predefaults_Sum_Fields = {
  __typename?: "tickets_automation_defaults_opened_predefaults_sum_fields"
  automation_job_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  total?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "automation_defaults_opened_predefaults" */
export enum Tickets_Automation_Defaults_Opened_Predefaults_Update_Column {
  /** column name */
  AutomationJobId = "automation_job_id",
  /** column name */
  Id = "id",
  /** column name */
  Total = "total",
}

export type Tickets_Automation_Defaults_Opened_Predefaults_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Automation_Defaults_Opened_Predefaults_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Automation_Defaults_Opened_Predefaults_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Automation_Defaults_Opened_Predefaults_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Automation_Defaults_Opened_Predefaults_Var_Pop_Fields = {
  __typename?: "tickets_automation_defaults_opened_predefaults_var_pop_fields"
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  total?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Automation_Defaults_Opened_Predefaults_Var_Samp_Fields = {
  __typename?: "tickets_automation_defaults_opened_predefaults_var_samp_fields"
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  total?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Automation_Defaults_Opened_Predefaults_Variance_Fields = {
  __typename?: "tickets_automation_defaults_opened_predefaults_variance_fields"
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  total?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "automation_job" */
export type Tickets_Automation_Job = {
  __typename?: "tickets_automation_job"
  email_failure_message?: Maybe<Scalars["String"]["output"]>
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  email_status: Scalars["automation_job_email_status"]["output"]
  ended_at?: Maybe<Scalars["timestamptz"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  started_at: Scalars["timestamptz"]["output"]
  status: Scalars["automation_status_enum"]["output"]
  uuid: Scalars["String"]["output"]
}

/** aggregated selection of "automation_job" */
export type Tickets_Automation_Job_Aggregate = {
  __typename?: "tickets_automation_job_aggregate"
  aggregate?: Maybe<Tickets_Automation_Job_Aggregate_Fields>
  nodes: Array<Tickets_Automation_Job>
}

/** aggregate fields of "automation_job" */
export type Tickets_Automation_Job_Aggregate_Fields = {
  __typename?: "tickets_automation_job_aggregate_fields"
  avg?: Maybe<Tickets_Automation_Job_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Automation_Job_Max_Fields>
  min?: Maybe<Tickets_Automation_Job_Min_Fields>
  stddev?: Maybe<Tickets_Automation_Job_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Automation_Job_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Automation_Job_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Automation_Job_Sum_Fields>
  var_pop?: Maybe<Tickets_Automation_Job_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Automation_Job_Var_Samp_Fields>
  variance?: Maybe<Tickets_Automation_Job_Variance_Fields>
}

/** aggregate fields of "automation_job" */
export type Tickets_Automation_Job_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Automation_Job_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_Automation_Job_Avg_Fields = {
  __typename?: "tickets_automation_job_avg_fields"
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "automation_job". All fields are combined with a logical 'AND'. */
export type Tickets_Automation_Job_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Automation_Job_Bool_Exp>>
  _not?: InputMaybe<Tickets_Automation_Job_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Automation_Job_Bool_Exp>>
  email_failure_message?: InputMaybe<String_Comparison_Exp>
  email_message_id?: InputMaybe<Bigint_Comparison_Exp>
  email_status?: InputMaybe<Automation_Job_Email_Status_Comparison_Exp>
  ended_at?: InputMaybe<Timestamptz_Comparison_Exp>
  failure_reason?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  started_at?: InputMaybe<Timestamptz_Comparison_Exp>
  status?: InputMaybe<Automation_Status_Enum_Comparison_Exp>
  uuid?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "automation_job" */
export enum Tickets_Automation_Job_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkAutomationJob = "pk_automation_job",
}

/** input type for incrementing numeric columns in table "automation_job" */
export type Tickets_Automation_Job_Inc_Input = {
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "automation_job" */
export type Tickets_Automation_Job_Insert_Input = {
  email_failure_message?: InputMaybe<Scalars["String"]["input"]>
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  email_status?: InputMaybe<Scalars["automation_job_email_status"]["input"]>
  ended_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  started_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  status?: InputMaybe<Scalars["automation_status_enum"]["input"]>
  uuid?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Automation_Job_Max_Fields = {
  __typename?: "tickets_automation_job_max_fields"
  email_failure_message?: Maybe<Scalars["String"]["output"]>
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  email_status?: Maybe<Scalars["automation_job_email_status"]["output"]>
  ended_at?: Maybe<Scalars["timestamptz"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  started_at?: Maybe<Scalars["timestamptz"]["output"]>
  status?: Maybe<Scalars["automation_status_enum"]["output"]>
  uuid?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Automation_Job_Min_Fields = {
  __typename?: "tickets_automation_job_min_fields"
  email_failure_message?: Maybe<Scalars["String"]["output"]>
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  email_status?: Maybe<Scalars["automation_job_email_status"]["output"]>
  ended_at?: Maybe<Scalars["timestamptz"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  started_at?: Maybe<Scalars["timestamptz"]["output"]>
  status?: Maybe<Scalars["automation_status_enum"]["output"]>
  uuid?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "automation_job" */
export type Tickets_Automation_Job_Mutation_Response = {
  __typename?: "tickets_automation_job_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Automation_Job>
}

/** on_conflict condition type for table "automation_job" */
export type Tickets_Automation_Job_On_Conflict = {
  constraint: Tickets_Automation_Job_Constraint
  update_columns?: Array<Tickets_Automation_Job_Update_Column>
  where?: InputMaybe<Tickets_Automation_Job_Bool_Exp>
}

/** Ordering options when selecting data from "automation_job". */
export type Tickets_Automation_Job_Order_By = {
  email_failure_message?: InputMaybe<Order_By>
  email_message_id?: InputMaybe<Order_By>
  email_status?: InputMaybe<Order_By>
  ended_at?: InputMaybe<Order_By>
  failure_reason?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  started_at?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  uuid?: InputMaybe<Order_By>
}

/** primary key columns input for table: automation_job */
export type Tickets_Automation_Job_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "automation_job" */
export enum Tickets_Automation_Job_Select_Column {
  /** column name */
  EmailFailureMessage = "email_failure_message",
  /** column name */
  EmailMessageId = "email_message_id",
  /** column name */
  EmailStatus = "email_status",
  /** column name */
  EndedAt = "ended_at",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  StartedAt = "started_at",
  /** column name */
  Status = "status",
  /** column name */
  Uuid = "uuid",
}

/** input type for updating data in table "automation_job" */
export type Tickets_Automation_Job_Set_Input = {
  email_failure_message?: InputMaybe<Scalars["String"]["input"]>
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  email_status?: InputMaybe<Scalars["automation_job_email_status"]["input"]>
  ended_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  started_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  status?: InputMaybe<Scalars["automation_status_enum"]["input"]>
  uuid?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Automation_Job_Stddev_Fields = {
  __typename?: "tickets_automation_job_stddev_fields"
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Automation_Job_Stddev_Pop_Fields = {
  __typename?: "tickets_automation_job_stddev_pop_fields"
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Automation_Job_Stddev_Samp_Fields = {
  __typename?: "tickets_automation_job_stddev_samp_fields"
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_automation_job" */
export type Tickets_Automation_Job_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Automation_Job_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Automation_Job_Stream_Cursor_Value_Input = {
  email_failure_message?: InputMaybe<Scalars["String"]["input"]>
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  email_status?: InputMaybe<Scalars["automation_job_email_status"]["input"]>
  ended_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  started_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  status?: InputMaybe<Scalars["automation_status_enum"]["input"]>
  uuid?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_Automation_Job_Sum_Fields = {
  __typename?: "tickets_automation_job_sum_fields"
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "automation_job" */
export enum Tickets_Automation_Job_Update_Column {
  /** column name */
  EmailFailureMessage = "email_failure_message",
  /** column name */
  EmailMessageId = "email_message_id",
  /** column name */
  EmailStatus = "email_status",
  /** column name */
  EndedAt = "ended_at",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  StartedAt = "started_at",
  /** column name */
  Status = "status",
  /** column name */
  Uuid = "uuid",
}

export type Tickets_Automation_Job_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Automation_Job_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Automation_Job_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Automation_Job_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Automation_Job_Var_Pop_Fields = {
  __typename?: "tickets_automation_job_var_pop_fields"
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Automation_Job_Var_Samp_Fields = {
  __typename?: "tickets_automation_job_var_samp_fields"
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Automation_Job_Variance_Fields = {
  __typename?: "tickets_automation_job_variance_fields"
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "automation_purge_job" */
export type Tickets_Automation_Purge_Job = {
  __typename?: "tickets_automation_purge_job"
  accounts_deleted?: Maybe<Scalars["bigint"]["output"]>
  actions_deleted?: Maybe<Scalars["bigint"]["output"]>
  completed_at?: Maybe<Scalars["timestamptz"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  started_at: Scalars["timestamptz"]["output"]
  status: Scalars["automation_status_enum"]["output"]
  tickets_deleted?: Maybe<Scalars["bigint"]["output"]>
  uuid: Scalars["String"]["output"]
}

/** aggregated selection of "automation_purge_job" */
export type Tickets_Automation_Purge_Job_Aggregate = {
  __typename?: "tickets_automation_purge_job_aggregate"
  aggregate?: Maybe<Tickets_Automation_Purge_Job_Aggregate_Fields>
  nodes: Array<Tickets_Automation_Purge_Job>
}

/** aggregate fields of "automation_purge_job" */
export type Tickets_Automation_Purge_Job_Aggregate_Fields = {
  __typename?: "tickets_automation_purge_job_aggregate_fields"
  avg?: Maybe<Tickets_Automation_Purge_Job_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Automation_Purge_Job_Max_Fields>
  min?: Maybe<Tickets_Automation_Purge_Job_Min_Fields>
  stddev?: Maybe<Tickets_Automation_Purge_Job_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Automation_Purge_Job_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Automation_Purge_Job_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Automation_Purge_Job_Sum_Fields>
  var_pop?: Maybe<Tickets_Automation_Purge_Job_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Automation_Purge_Job_Var_Samp_Fields>
  variance?: Maybe<Tickets_Automation_Purge_Job_Variance_Fields>
}

/** aggregate fields of "automation_purge_job" */
export type Tickets_Automation_Purge_Job_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Automation_Purge_Job_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_Automation_Purge_Job_Avg_Fields = {
  __typename?: "tickets_automation_purge_job_avg_fields"
  accounts_deleted?: Maybe<Scalars["Float"]["output"]>
  actions_deleted?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  tickets_deleted?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "automation_purge_job". All fields are combined with a logical 'AND'. */
export type Tickets_Automation_Purge_Job_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Automation_Purge_Job_Bool_Exp>>
  _not?: InputMaybe<Tickets_Automation_Purge_Job_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Automation_Purge_Job_Bool_Exp>>
  accounts_deleted?: InputMaybe<Bigint_Comparison_Exp>
  actions_deleted?: InputMaybe<Bigint_Comparison_Exp>
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>
  failure_reason?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  started_at?: InputMaybe<Timestamptz_Comparison_Exp>
  status?: InputMaybe<Automation_Status_Enum_Comparison_Exp>
  tickets_deleted?: InputMaybe<Bigint_Comparison_Exp>
  uuid?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "automation_purge_job" */
export enum Tickets_Automation_Purge_Job_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkAutomationPurgeJob = "pk_automation_purge_job",
}

/** input type for incrementing numeric columns in table "automation_purge_job" */
export type Tickets_Automation_Purge_Job_Inc_Input = {
  accounts_deleted?: InputMaybe<Scalars["bigint"]["input"]>
  actions_deleted?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  tickets_deleted?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "automation_purge_job" */
export type Tickets_Automation_Purge_Job_Insert_Input = {
  accounts_deleted?: InputMaybe<Scalars["bigint"]["input"]>
  actions_deleted?: InputMaybe<Scalars["bigint"]["input"]>
  completed_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  started_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  status?: InputMaybe<Scalars["automation_status_enum"]["input"]>
  tickets_deleted?: InputMaybe<Scalars["bigint"]["input"]>
  uuid?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Automation_Purge_Job_Max_Fields = {
  __typename?: "tickets_automation_purge_job_max_fields"
  accounts_deleted?: Maybe<Scalars["bigint"]["output"]>
  actions_deleted?: Maybe<Scalars["bigint"]["output"]>
  completed_at?: Maybe<Scalars["timestamptz"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  started_at?: Maybe<Scalars["timestamptz"]["output"]>
  status?: Maybe<Scalars["automation_status_enum"]["output"]>
  tickets_deleted?: Maybe<Scalars["bigint"]["output"]>
  uuid?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Automation_Purge_Job_Min_Fields = {
  __typename?: "tickets_automation_purge_job_min_fields"
  accounts_deleted?: Maybe<Scalars["bigint"]["output"]>
  actions_deleted?: Maybe<Scalars["bigint"]["output"]>
  completed_at?: Maybe<Scalars["timestamptz"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  started_at?: Maybe<Scalars["timestamptz"]["output"]>
  status?: Maybe<Scalars["automation_status_enum"]["output"]>
  tickets_deleted?: Maybe<Scalars["bigint"]["output"]>
  uuid?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "automation_purge_job" */
export type Tickets_Automation_Purge_Job_Mutation_Response = {
  __typename?: "tickets_automation_purge_job_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Automation_Purge_Job>
}

/** on_conflict condition type for table "automation_purge_job" */
export type Tickets_Automation_Purge_Job_On_Conflict = {
  constraint: Tickets_Automation_Purge_Job_Constraint
  update_columns?: Array<Tickets_Automation_Purge_Job_Update_Column>
  where?: InputMaybe<Tickets_Automation_Purge_Job_Bool_Exp>
}

/** Ordering options when selecting data from "automation_purge_job". */
export type Tickets_Automation_Purge_Job_Order_By = {
  accounts_deleted?: InputMaybe<Order_By>
  actions_deleted?: InputMaybe<Order_By>
  completed_at?: InputMaybe<Order_By>
  failure_reason?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  started_at?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  tickets_deleted?: InputMaybe<Order_By>
  uuid?: InputMaybe<Order_By>
}

/** primary key columns input for table: automation_purge_job */
export type Tickets_Automation_Purge_Job_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "automation_purge_job" */
export enum Tickets_Automation_Purge_Job_Select_Column {
  /** column name */
  AccountsDeleted = "accounts_deleted",
  /** column name */
  ActionsDeleted = "actions_deleted",
  /** column name */
  CompletedAt = "completed_at",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  StartedAt = "started_at",
  /** column name */
  Status = "status",
  /** column name */
  TicketsDeleted = "tickets_deleted",
  /** column name */
  Uuid = "uuid",
}

/** input type for updating data in table "automation_purge_job" */
export type Tickets_Automation_Purge_Job_Set_Input = {
  accounts_deleted?: InputMaybe<Scalars["bigint"]["input"]>
  actions_deleted?: InputMaybe<Scalars["bigint"]["input"]>
  completed_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  started_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  status?: InputMaybe<Scalars["automation_status_enum"]["input"]>
  tickets_deleted?: InputMaybe<Scalars["bigint"]["input"]>
  uuid?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Automation_Purge_Job_Stddev_Fields = {
  __typename?: "tickets_automation_purge_job_stddev_fields"
  accounts_deleted?: Maybe<Scalars["Float"]["output"]>
  actions_deleted?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  tickets_deleted?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Automation_Purge_Job_Stddev_Pop_Fields = {
  __typename?: "tickets_automation_purge_job_stddev_pop_fields"
  accounts_deleted?: Maybe<Scalars["Float"]["output"]>
  actions_deleted?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  tickets_deleted?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Automation_Purge_Job_Stddev_Samp_Fields = {
  __typename?: "tickets_automation_purge_job_stddev_samp_fields"
  accounts_deleted?: Maybe<Scalars["Float"]["output"]>
  actions_deleted?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  tickets_deleted?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_automation_purge_job" */
export type Tickets_Automation_Purge_Job_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Automation_Purge_Job_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Automation_Purge_Job_Stream_Cursor_Value_Input = {
  accounts_deleted?: InputMaybe<Scalars["bigint"]["input"]>
  actions_deleted?: InputMaybe<Scalars["bigint"]["input"]>
  completed_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  started_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  status?: InputMaybe<Scalars["automation_status_enum"]["input"]>
  tickets_deleted?: InputMaybe<Scalars["bigint"]["input"]>
  uuid?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_Automation_Purge_Job_Sum_Fields = {
  __typename?: "tickets_automation_purge_job_sum_fields"
  accounts_deleted?: Maybe<Scalars["bigint"]["output"]>
  actions_deleted?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  tickets_deleted?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "automation_purge_job" */
export enum Tickets_Automation_Purge_Job_Update_Column {
  /** column name */
  AccountsDeleted = "accounts_deleted",
  /** column name */
  ActionsDeleted = "actions_deleted",
  /** column name */
  CompletedAt = "completed_at",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  StartedAt = "started_at",
  /** column name */
  Status = "status",
  /** column name */
  TicketsDeleted = "tickets_deleted",
  /** column name */
  Uuid = "uuid",
}

export type Tickets_Automation_Purge_Job_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Automation_Purge_Job_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Automation_Purge_Job_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Automation_Purge_Job_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Automation_Purge_Job_Var_Pop_Fields = {
  __typename?: "tickets_automation_purge_job_var_pop_fields"
  accounts_deleted?: Maybe<Scalars["Float"]["output"]>
  actions_deleted?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  tickets_deleted?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Automation_Purge_Job_Var_Samp_Fields = {
  __typename?: "tickets_automation_purge_job_var_samp_fields"
  accounts_deleted?: Maybe<Scalars["Float"]["output"]>
  actions_deleted?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  tickets_deleted?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Automation_Purge_Job_Variance_Fields = {
  __typename?: "tickets_automation_purge_job_variance_fields"
  accounts_deleted?: Maybe<Scalars["Float"]["output"]>
  actions_deleted?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  tickets_deleted?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "automation_ticket_store" */
export type Tickets_Automation_Ticket_Store = {
  __typename?: "tickets_automation_ticket_store"
  account_number?: Maybe<Scalars["String"]["output"]>
  automation_job_id: Scalars["bigint"]["output"]
  created_at: Scalars["timestamptz"]["output"]
  id: Scalars["bigint"]["output"]
  ticket_created?: Maybe<Scalars["date"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_identifier?: Maybe<Scalars["String"]["output"]>
  ticket_latest_action_date?: Maybe<Scalars["date"]["output"]>
  ticket_prefix?: Maybe<Scalars["String"]["output"]>
  ticket_status?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
  ticket_summary?: Maybe<Scalars["String"]["output"]>
}

/** aggregated selection of "automation_ticket_store" */
export type Tickets_Automation_Ticket_Store_Aggregate = {
  __typename?: "tickets_automation_ticket_store_aggregate"
  aggregate?: Maybe<Tickets_Automation_Ticket_Store_Aggregate_Fields>
  nodes: Array<Tickets_Automation_Ticket_Store>
}

/** aggregate fields of "automation_ticket_store" */
export type Tickets_Automation_Ticket_Store_Aggregate_Fields = {
  __typename?: "tickets_automation_ticket_store_aggregate_fields"
  avg?: Maybe<Tickets_Automation_Ticket_Store_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Automation_Ticket_Store_Max_Fields>
  min?: Maybe<Tickets_Automation_Ticket_Store_Min_Fields>
  stddev?: Maybe<Tickets_Automation_Ticket_Store_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Automation_Ticket_Store_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Automation_Ticket_Store_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Automation_Ticket_Store_Sum_Fields>
  var_pop?: Maybe<Tickets_Automation_Ticket_Store_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Automation_Ticket_Store_Var_Samp_Fields>
  variance?: Maybe<Tickets_Automation_Ticket_Store_Variance_Fields>
}

/** aggregate fields of "automation_ticket_store" */
export type Tickets_Automation_Ticket_Store_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Automation_Ticket_Store_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_Automation_Ticket_Store_Avg_Fields = {
  __typename?: "tickets_automation_ticket_store_avg_fields"
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "automation_ticket_store". All fields are combined with a logical 'AND'. */
export type Tickets_Automation_Ticket_Store_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Automation_Ticket_Store_Bool_Exp>>
  _not?: InputMaybe<Tickets_Automation_Ticket_Store_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Automation_Ticket_Store_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  automation_job_id?: InputMaybe<Bigint_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  ticket_created?: InputMaybe<Date_Comparison_Exp>
  ticket_id?: InputMaybe<String_Comparison_Exp>
  ticket_identifier?: InputMaybe<String_Comparison_Exp>
  ticket_latest_action_date?: InputMaybe<Date_Comparison_Exp>
  ticket_prefix?: InputMaybe<String_Comparison_Exp>
  ticket_status?: InputMaybe<String_Comparison_Exp>
  ticket_step?: InputMaybe<String_Comparison_Exp>
  ticket_summary?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "automation_ticket_store" */
export enum Tickets_Automation_Ticket_Store_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkAutomationTicketStore = "pk_automation_ticket_store",
}

/** input type for incrementing numeric columns in table "automation_ticket_store" */
export type Tickets_Automation_Ticket_Store_Inc_Input = {
  automation_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "automation_ticket_store" */
export type Tickets_Automation_Ticket_Store_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  automation_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  ticket_created?: InputMaybe<Scalars["date"]["input"]>
  ticket_id?: InputMaybe<Scalars["String"]["input"]>
  ticket_identifier?: InputMaybe<Scalars["String"]["input"]>
  ticket_latest_action_date?: InputMaybe<Scalars["date"]["input"]>
  ticket_prefix?: InputMaybe<Scalars["String"]["input"]>
  ticket_status?: InputMaybe<Scalars["String"]["input"]>
  ticket_step?: InputMaybe<Scalars["String"]["input"]>
  ticket_summary?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Automation_Ticket_Store_Max_Fields = {
  __typename?: "tickets_automation_ticket_store_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  automation_job_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  ticket_created?: Maybe<Scalars["date"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_identifier?: Maybe<Scalars["String"]["output"]>
  ticket_latest_action_date?: Maybe<Scalars["date"]["output"]>
  ticket_prefix?: Maybe<Scalars["String"]["output"]>
  ticket_status?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
  ticket_summary?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Automation_Ticket_Store_Min_Fields = {
  __typename?: "tickets_automation_ticket_store_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  automation_job_id?: Maybe<Scalars["bigint"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  ticket_created?: Maybe<Scalars["date"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_identifier?: Maybe<Scalars["String"]["output"]>
  ticket_latest_action_date?: Maybe<Scalars["date"]["output"]>
  ticket_prefix?: Maybe<Scalars["String"]["output"]>
  ticket_status?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
  ticket_summary?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "automation_ticket_store" */
export type Tickets_Automation_Ticket_Store_Mutation_Response = {
  __typename?: "tickets_automation_ticket_store_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Automation_Ticket_Store>
}

/** on_conflict condition type for table "automation_ticket_store" */
export type Tickets_Automation_Ticket_Store_On_Conflict = {
  constraint: Tickets_Automation_Ticket_Store_Constraint
  update_columns?: Array<Tickets_Automation_Ticket_Store_Update_Column>
  where?: InputMaybe<Tickets_Automation_Ticket_Store_Bool_Exp>
}

/** Ordering options when selecting data from "automation_ticket_store". */
export type Tickets_Automation_Ticket_Store_Order_By = {
  account_number?: InputMaybe<Order_By>
  automation_job_id?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  ticket_created?: InputMaybe<Order_By>
  ticket_id?: InputMaybe<Order_By>
  ticket_identifier?: InputMaybe<Order_By>
  ticket_latest_action_date?: InputMaybe<Order_By>
  ticket_prefix?: InputMaybe<Order_By>
  ticket_status?: InputMaybe<Order_By>
  ticket_step?: InputMaybe<Order_By>
  ticket_summary?: InputMaybe<Order_By>
}

/** primary key columns input for table: automation_ticket_store */
export type Tickets_Automation_Ticket_Store_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "automation_ticket_store" */
export enum Tickets_Automation_Ticket_Store_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AutomationJobId = "automation_job_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  TicketCreated = "ticket_created",
  /** column name */
  TicketId = "ticket_id",
  /** column name */
  TicketIdentifier = "ticket_identifier",
  /** column name */
  TicketLatestActionDate = "ticket_latest_action_date",
  /** column name */
  TicketPrefix = "ticket_prefix",
  /** column name */
  TicketStatus = "ticket_status",
  /** column name */
  TicketStep = "ticket_step",
  /** column name */
  TicketSummary = "ticket_summary",
}

/** input type for updating data in table "automation_ticket_store" */
export type Tickets_Automation_Ticket_Store_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  automation_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  ticket_created?: InputMaybe<Scalars["date"]["input"]>
  ticket_id?: InputMaybe<Scalars["String"]["input"]>
  ticket_identifier?: InputMaybe<Scalars["String"]["input"]>
  ticket_latest_action_date?: InputMaybe<Scalars["date"]["input"]>
  ticket_prefix?: InputMaybe<Scalars["String"]["input"]>
  ticket_status?: InputMaybe<Scalars["String"]["input"]>
  ticket_step?: InputMaybe<Scalars["String"]["input"]>
  ticket_summary?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Automation_Ticket_Store_Stddev_Fields = {
  __typename?: "tickets_automation_ticket_store_stddev_fields"
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Automation_Ticket_Store_Stddev_Pop_Fields = {
  __typename?: "tickets_automation_ticket_store_stddev_pop_fields"
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Automation_Ticket_Store_Stddev_Samp_Fields = {
  __typename?: "tickets_automation_ticket_store_stddev_samp_fields"
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_automation_ticket_store" */
export type Tickets_Automation_Ticket_Store_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Automation_Ticket_Store_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Automation_Ticket_Store_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  automation_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  ticket_created?: InputMaybe<Scalars["date"]["input"]>
  ticket_id?: InputMaybe<Scalars["String"]["input"]>
  ticket_identifier?: InputMaybe<Scalars["String"]["input"]>
  ticket_latest_action_date?: InputMaybe<Scalars["date"]["input"]>
  ticket_prefix?: InputMaybe<Scalars["String"]["input"]>
  ticket_status?: InputMaybe<Scalars["String"]["input"]>
  ticket_step?: InputMaybe<Scalars["String"]["input"]>
  ticket_summary?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_Automation_Ticket_Store_Sum_Fields = {
  __typename?: "tickets_automation_ticket_store_sum_fields"
  automation_job_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "automation_ticket_store" */
export enum Tickets_Automation_Ticket_Store_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AutomationJobId = "automation_job_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  TicketCreated = "ticket_created",
  /** column name */
  TicketId = "ticket_id",
  /** column name */
  TicketIdentifier = "ticket_identifier",
  /** column name */
  TicketLatestActionDate = "ticket_latest_action_date",
  /** column name */
  TicketPrefix = "ticket_prefix",
  /** column name */
  TicketStatus = "ticket_status",
  /** column name */
  TicketStep = "ticket_step",
  /** column name */
  TicketSummary = "ticket_summary",
}

export type Tickets_Automation_Ticket_Store_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Automation_Ticket_Store_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Automation_Ticket_Store_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Automation_Ticket_Store_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Automation_Ticket_Store_Var_Pop_Fields = {
  __typename?: "tickets_automation_ticket_store_var_pop_fields"
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Automation_Ticket_Store_Var_Samp_Fields = {
  __typename?: "tickets_automation_ticket_store_var_samp_fields"
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Automation_Ticket_Store_Variance_Fields = {
  __typename?: "tickets_automation_ticket_store_variance_fields"
  automation_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "dca_account_allocation" */
export type Tickets_Dca_Account_Allocation = {
  __typename?: "tickets_dca_account_allocation"
  account_id?: Maybe<Scalars["bigint"]["output"]>
  account_status?: Maybe<Scalars["account_state"]["output"]>
  big_query_account_data: Scalars["String"]["output"]
  comment?: Maybe<Scalars["String"]["output"]>
  current_placement?: Maybe<Scalars["bigint"]["output"]>
  dca_id?: Maybe<Scalars["bigint"]["output"]>
  id: Scalars["bigint"]["output"]
  job_run_date: Scalars["date"]["output"]
  junifer_account_number: Scalars["String"]["output"]
  occupier_status?: Maybe<Scalars["occupier_status"]["output"]>
  psr?: Maybe<Scalars["Boolean"]["output"]>
  supply_status?: Maybe<Scalars["leaving_type"]["output"]>
  ticket_creation_status?: Maybe<Scalars["ticket_creation_status"]["output"]>
  ticket_definition_code: Scalars["String"]["output"]
  ticket_id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregated selection of "dca_account_allocation" */
export type Tickets_Dca_Account_Allocation_Aggregate = {
  __typename?: "tickets_dca_account_allocation_aggregate"
  aggregate?: Maybe<Tickets_Dca_Account_Allocation_Aggregate_Fields>
  nodes: Array<Tickets_Dca_Account_Allocation>
}

/** aggregate fields of "dca_account_allocation" */
export type Tickets_Dca_Account_Allocation_Aggregate_Fields = {
  __typename?: "tickets_dca_account_allocation_aggregate_fields"
  avg?: Maybe<Tickets_Dca_Account_Allocation_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Dca_Account_Allocation_Max_Fields>
  min?: Maybe<Tickets_Dca_Account_Allocation_Min_Fields>
  stddev?: Maybe<Tickets_Dca_Account_Allocation_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Dca_Account_Allocation_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Dca_Account_Allocation_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Dca_Account_Allocation_Sum_Fields>
  var_pop?: Maybe<Tickets_Dca_Account_Allocation_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Dca_Account_Allocation_Var_Samp_Fields>
  variance?: Maybe<Tickets_Dca_Account_Allocation_Variance_Fields>
}

/** aggregate fields of "dca_account_allocation" */
export type Tickets_Dca_Account_Allocation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Dca_Account_Allocation_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_Dca_Account_Allocation_Avg_Fields = {
  __typename?: "tickets_dca_account_allocation_avg_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  current_placement?: Maybe<Scalars["Float"]["output"]>
  dca_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  ticket_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "dca_account_allocation". All fields are combined with a logical 'AND'. */
export type Tickets_Dca_Account_Allocation_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Dca_Account_Allocation_Bool_Exp>>
  _not?: InputMaybe<Tickets_Dca_Account_Allocation_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Dca_Account_Allocation_Bool_Exp>>
  account_id?: InputMaybe<Bigint_Comparison_Exp>
  account_status?: InputMaybe<Account_State_Comparison_Exp>
  big_query_account_data?: InputMaybe<String_Comparison_Exp>
  comment?: InputMaybe<String_Comparison_Exp>
  current_placement?: InputMaybe<Bigint_Comparison_Exp>
  dca_id?: InputMaybe<Bigint_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  job_run_date?: InputMaybe<Date_Comparison_Exp>
  junifer_account_number?: InputMaybe<String_Comparison_Exp>
  occupier_status?: InputMaybe<Occupier_Status_Comparison_Exp>
  psr?: InputMaybe<Boolean_Comparison_Exp>
  supply_status?: InputMaybe<Leaving_Type_Comparison_Exp>
  ticket_creation_status?: InputMaybe<Ticket_Creation_Status_Comparison_Exp>
  ticket_definition_code?: InputMaybe<String_Comparison_Exp>
  ticket_id?: InputMaybe<Bigint_Comparison_Exp>
}

/** unique or primary key constraints on table "dca_account_allocation" */
export enum Tickets_Dca_Account_Allocation_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkDcaAccountAllocation = "pk_dca_account_allocation",
}

/** input type for incrementing numeric columns in table "dca_account_allocation" */
export type Tickets_Dca_Account_Allocation_Inc_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  current_placement?: InputMaybe<Scalars["bigint"]["input"]>
  dca_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  ticket_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "dca_account_allocation" */
export type Tickets_Dca_Account_Allocation_Insert_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  account_status?: InputMaybe<Scalars["account_state"]["input"]>
  big_query_account_data?: InputMaybe<Scalars["String"]["input"]>
  comment?: InputMaybe<Scalars["String"]["input"]>
  current_placement?: InputMaybe<Scalars["bigint"]["input"]>
  dca_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  job_run_date?: InputMaybe<Scalars["date"]["input"]>
  junifer_account_number?: InputMaybe<Scalars["String"]["input"]>
  occupier_status?: InputMaybe<Scalars["occupier_status"]["input"]>
  psr?: InputMaybe<Scalars["Boolean"]["input"]>
  supply_status?: InputMaybe<Scalars["leaving_type"]["input"]>
  ticket_creation_status?: InputMaybe<
    Scalars["ticket_creation_status"]["input"]
  >
  ticket_definition_code?: InputMaybe<Scalars["String"]["input"]>
  ticket_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Dca_Account_Allocation_Max_Fields = {
  __typename?: "tickets_dca_account_allocation_max_fields"
  account_id?: Maybe<Scalars["bigint"]["output"]>
  account_status?: Maybe<Scalars["account_state"]["output"]>
  big_query_account_data?: Maybe<Scalars["String"]["output"]>
  comment?: Maybe<Scalars["String"]["output"]>
  current_placement?: Maybe<Scalars["bigint"]["output"]>
  dca_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  job_run_date?: Maybe<Scalars["date"]["output"]>
  junifer_account_number?: Maybe<Scalars["String"]["output"]>
  occupier_status?: Maybe<Scalars["occupier_status"]["output"]>
  supply_status?: Maybe<Scalars["leaving_type"]["output"]>
  ticket_creation_status?: Maybe<Scalars["ticket_creation_status"]["output"]>
  ticket_definition_code?: Maybe<Scalars["String"]["output"]>
  ticket_id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Dca_Account_Allocation_Min_Fields = {
  __typename?: "tickets_dca_account_allocation_min_fields"
  account_id?: Maybe<Scalars["bigint"]["output"]>
  account_status?: Maybe<Scalars["account_state"]["output"]>
  big_query_account_data?: Maybe<Scalars["String"]["output"]>
  comment?: Maybe<Scalars["String"]["output"]>
  current_placement?: Maybe<Scalars["bigint"]["output"]>
  dca_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  job_run_date?: Maybe<Scalars["date"]["output"]>
  junifer_account_number?: Maybe<Scalars["String"]["output"]>
  occupier_status?: Maybe<Scalars["occupier_status"]["output"]>
  supply_status?: Maybe<Scalars["leaving_type"]["output"]>
  ticket_creation_status?: Maybe<Scalars["ticket_creation_status"]["output"]>
  ticket_definition_code?: Maybe<Scalars["String"]["output"]>
  ticket_id?: Maybe<Scalars["bigint"]["output"]>
}

/** response of any mutation on the table "dca_account_allocation" */
export type Tickets_Dca_Account_Allocation_Mutation_Response = {
  __typename?: "tickets_dca_account_allocation_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Dca_Account_Allocation>
}

/** on_conflict condition type for table "dca_account_allocation" */
export type Tickets_Dca_Account_Allocation_On_Conflict = {
  constraint: Tickets_Dca_Account_Allocation_Constraint
  update_columns?: Array<Tickets_Dca_Account_Allocation_Update_Column>
  where?: InputMaybe<Tickets_Dca_Account_Allocation_Bool_Exp>
}

/** Ordering options when selecting data from "dca_account_allocation". */
export type Tickets_Dca_Account_Allocation_Order_By = {
  account_id?: InputMaybe<Order_By>
  account_status?: InputMaybe<Order_By>
  big_query_account_data?: InputMaybe<Order_By>
  comment?: InputMaybe<Order_By>
  current_placement?: InputMaybe<Order_By>
  dca_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  job_run_date?: InputMaybe<Order_By>
  junifer_account_number?: InputMaybe<Order_By>
  occupier_status?: InputMaybe<Order_By>
  psr?: InputMaybe<Order_By>
  supply_status?: InputMaybe<Order_By>
  ticket_creation_status?: InputMaybe<Order_By>
  ticket_definition_code?: InputMaybe<Order_By>
  ticket_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: dca_account_allocation */
export type Tickets_Dca_Account_Allocation_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "dca_account_allocation" */
export enum Tickets_Dca_Account_Allocation_Select_Column {
  /** column name */
  AccountId = "account_id",
  /** column name */
  AccountStatus = "account_status",
  /** column name */
  BigQueryAccountData = "big_query_account_data",
  /** column name */
  Comment = "comment",
  /** column name */
  CurrentPlacement = "current_placement",
  /** column name */
  DcaId = "dca_id",
  /** column name */
  Id = "id",
  /** column name */
  JobRunDate = "job_run_date",
  /** column name */
  JuniferAccountNumber = "junifer_account_number",
  /** column name */
  OccupierStatus = "occupier_status",
  /** column name */
  Psr = "psr",
  /** column name */
  SupplyStatus = "supply_status",
  /** column name */
  TicketCreationStatus = "ticket_creation_status",
  /** column name */
  TicketDefinitionCode = "ticket_definition_code",
  /** column name */
  TicketId = "ticket_id",
}

/** input type for updating data in table "dca_account_allocation" */
export type Tickets_Dca_Account_Allocation_Set_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  account_status?: InputMaybe<Scalars["account_state"]["input"]>
  big_query_account_data?: InputMaybe<Scalars["String"]["input"]>
  comment?: InputMaybe<Scalars["String"]["input"]>
  current_placement?: InputMaybe<Scalars["bigint"]["input"]>
  dca_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  job_run_date?: InputMaybe<Scalars["date"]["input"]>
  junifer_account_number?: InputMaybe<Scalars["String"]["input"]>
  occupier_status?: InputMaybe<Scalars["occupier_status"]["input"]>
  psr?: InputMaybe<Scalars["Boolean"]["input"]>
  supply_status?: InputMaybe<Scalars["leaving_type"]["input"]>
  ticket_creation_status?: InputMaybe<
    Scalars["ticket_creation_status"]["input"]
  >
  ticket_definition_code?: InputMaybe<Scalars["String"]["input"]>
  ticket_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Dca_Account_Allocation_Stddev_Fields = {
  __typename?: "tickets_dca_account_allocation_stddev_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  current_placement?: Maybe<Scalars["Float"]["output"]>
  dca_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  ticket_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Dca_Account_Allocation_Stddev_Pop_Fields = {
  __typename?: "tickets_dca_account_allocation_stddev_pop_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  current_placement?: Maybe<Scalars["Float"]["output"]>
  dca_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  ticket_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Dca_Account_Allocation_Stddev_Samp_Fields = {
  __typename?: "tickets_dca_account_allocation_stddev_samp_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  current_placement?: Maybe<Scalars["Float"]["output"]>
  dca_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  ticket_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_dca_account_allocation" */
export type Tickets_Dca_Account_Allocation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Dca_Account_Allocation_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Dca_Account_Allocation_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars["bigint"]["input"]>
  account_status?: InputMaybe<Scalars["account_state"]["input"]>
  big_query_account_data?: InputMaybe<Scalars["String"]["input"]>
  comment?: InputMaybe<Scalars["String"]["input"]>
  current_placement?: InputMaybe<Scalars["bigint"]["input"]>
  dca_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  job_run_date?: InputMaybe<Scalars["date"]["input"]>
  junifer_account_number?: InputMaybe<Scalars["String"]["input"]>
  occupier_status?: InputMaybe<Scalars["occupier_status"]["input"]>
  psr?: InputMaybe<Scalars["Boolean"]["input"]>
  supply_status?: InputMaybe<Scalars["leaving_type"]["input"]>
  ticket_creation_status?: InputMaybe<
    Scalars["ticket_creation_status"]["input"]
  >
  ticket_definition_code?: InputMaybe<Scalars["String"]["input"]>
  ticket_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_Dca_Account_Allocation_Sum_Fields = {
  __typename?: "tickets_dca_account_allocation_sum_fields"
  account_id?: Maybe<Scalars["bigint"]["output"]>
  current_placement?: Maybe<Scalars["bigint"]["output"]>
  dca_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  ticket_id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "dca_account_allocation" */
export enum Tickets_Dca_Account_Allocation_Update_Column {
  /** column name */
  AccountId = "account_id",
  /** column name */
  AccountStatus = "account_status",
  /** column name */
  BigQueryAccountData = "big_query_account_data",
  /** column name */
  Comment = "comment",
  /** column name */
  CurrentPlacement = "current_placement",
  /** column name */
  DcaId = "dca_id",
  /** column name */
  Id = "id",
  /** column name */
  JobRunDate = "job_run_date",
  /** column name */
  JuniferAccountNumber = "junifer_account_number",
  /** column name */
  OccupierStatus = "occupier_status",
  /** column name */
  Psr = "psr",
  /** column name */
  SupplyStatus = "supply_status",
  /** column name */
  TicketCreationStatus = "ticket_creation_status",
  /** column name */
  TicketDefinitionCode = "ticket_definition_code",
  /** column name */
  TicketId = "ticket_id",
}

export type Tickets_Dca_Account_Allocation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Dca_Account_Allocation_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Dca_Account_Allocation_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Dca_Account_Allocation_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Dca_Account_Allocation_Var_Pop_Fields = {
  __typename?: "tickets_dca_account_allocation_var_pop_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  current_placement?: Maybe<Scalars["Float"]["output"]>
  dca_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  ticket_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Dca_Account_Allocation_Var_Samp_Fields = {
  __typename?: "tickets_dca_account_allocation_var_samp_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  current_placement?: Maybe<Scalars["Float"]["output"]>
  dca_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  ticket_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Dca_Account_Allocation_Variance_Fields = {
  __typename?: "tickets_dca_account_allocation_variance_fields"
  account_id?: Maybe<Scalars["Float"]["output"]>
  current_placement?: Maybe<Scalars["Float"]["output"]>
  dca_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  ticket_id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "dca_allocation_configuration" */
export type Tickets_Dca_Allocation_Configuration = {
  __typename?: "tickets_dca_allocation_configuration"
  created_at: Scalars["timestamp"]["output"]
  dca_id: Scalars["String"]["output"]
  deleted: Scalars["Boolean"]["output"]
  id: Scalars["bigint"]["output"]
  last_dca_id: Scalars["String"]["output"]
  last_placement?: Maybe<Scalars["Int"]["output"]>
  placement: Scalars["Int"]["output"]
  segmentation_id: Scalars["bigint"]["output"]
  updated_at: Scalars["timestamp"]["output"]
  weight: Scalars["numeric"]["output"]
}

/** aggregated selection of "dca_allocation_configuration" */
export type Tickets_Dca_Allocation_Configuration_Aggregate = {
  __typename?: "tickets_dca_allocation_configuration_aggregate"
  aggregate?: Maybe<Tickets_Dca_Allocation_Configuration_Aggregate_Fields>
  nodes: Array<Tickets_Dca_Allocation_Configuration>
}

/** aggregate fields of "dca_allocation_configuration" */
export type Tickets_Dca_Allocation_Configuration_Aggregate_Fields = {
  __typename?: "tickets_dca_allocation_configuration_aggregate_fields"
  avg?: Maybe<Tickets_Dca_Allocation_Configuration_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Dca_Allocation_Configuration_Max_Fields>
  min?: Maybe<Tickets_Dca_Allocation_Configuration_Min_Fields>
  stddev?: Maybe<Tickets_Dca_Allocation_Configuration_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Dca_Allocation_Configuration_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Dca_Allocation_Configuration_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Dca_Allocation_Configuration_Sum_Fields>
  var_pop?: Maybe<Tickets_Dca_Allocation_Configuration_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Dca_Allocation_Configuration_Var_Samp_Fields>
  variance?: Maybe<Tickets_Dca_Allocation_Configuration_Variance_Fields>
}

/** aggregate fields of "dca_allocation_configuration" */
export type Tickets_Dca_Allocation_Configuration_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<
    Array<Tickets_Dca_Allocation_Configuration_Select_Column>
  >
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_Dca_Allocation_Configuration_Avg_Fields = {
  __typename?: "tickets_dca_allocation_configuration_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  last_placement?: Maybe<Scalars["Float"]["output"]>
  placement?: Maybe<Scalars["Float"]["output"]>
  segmentation_id?: Maybe<Scalars["Float"]["output"]>
  weight?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "dca_allocation_configuration". All fields are combined with a logical 'AND'. */
export type Tickets_Dca_Allocation_Configuration_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Dca_Allocation_Configuration_Bool_Exp>>
  _not?: InputMaybe<Tickets_Dca_Allocation_Configuration_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Dca_Allocation_Configuration_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  dca_id?: InputMaybe<String_Comparison_Exp>
  deleted?: InputMaybe<Boolean_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  last_dca_id?: InputMaybe<String_Comparison_Exp>
  last_placement?: InputMaybe<Int_Comparison_Exp>
  placement?: InputMaybe<Int_Comparison_Exp>
  segmentation_id?: InputMaybe<Bigint_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  weight?: InputMaybe<Numeric_Comparison_Exp>
}

/** unique or primary key constraints on table "dca_allocation_configuration" */
export enum Tickets_Dca_Allocation_Configuration_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkDcaAllocationConfiguration = "pk_dca_allocation_configuration",
}

/** input type for incrementing numeric columns in table "dca_allocation_configuration" */
export type Tickets_Dca_Allocation_Configuration_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_placement?: InputMaybe<Scalars["Int"]["input"]>
  placement?: InputMaybe<Scalars["Int"]["input"]>
  segmentation_id?: InputMaybe<Scalars["bigint"]["input"]>
  weight?: InputMaybe<Scalars["numeric"]["input"]>
}

/** input type for inserting data into table "dca_allocation_configuration" */
export type Tickets_Dca_Allocation_Configuration_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  dca_id?: InputMaybe<Scalars["String"]["input"]>
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_dca_id?: InputMaybe<Scalars["String"]["input"]>
  last_placement?: InputMaybe<Scalars["Int"]["input"]>
  placement?: InputMaybe<Scalars["Int"]["input"]>
  segmentation_id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  weight?: InputMaybe<Scalars["numeric"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Dca_Allocation_Configuration_Max_Fields = {
  __typename?: "tickets_dca_allocation_configuration_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  dca_id?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_dca_id?: Maybe<Scalars["String"]["output"]>
  last_placement?: Maybe<Scalars["Int"]["output"]>
  placement?: Maybe<Scalars["Int"]["output"]>
  segmentation_id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  weight?: Maybe<Scalars["numeric"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Dca_Allocation_Configuration_Min_Fields = {
  __typename?: "tickets_dca_allocation_configuration_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  dca_id?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_dca_id?: Maybe<Scalars["String"]["output"]>
  last_placement?: Maybe<Scalars["Int"]["output"]>
  placement?: Maybe<Scalars["Int"]["output"]>
  segmentation_id?: Maybe<Scalars["bigint"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  weight?: Maybe<Scalars["numeric"]["output"]>
}

/** response of any mutation on the table "dca_allocation_configuration" */
export type Tickets_Dca_Allocation_Configuration_Mutation_Response = {
  __typename?: "tickets_dca_allocation_configuration_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Dca_Allocation_Configuration>
}

/** on_conflict condition type for table "dca_allocation_configuration" */
export type Tickets_Dca_Allocation_Configuration_On_Conflict = {
  constraint: Tickets_Dca_Allocation_Configuration_Constraint
  update_columns?: Array<Tickets_Dca_Allocation_Configuration_Update_Column>
  where?: InputMaybe<Tickets_Dca_Allocation_Configuration_Bool_Exp>
}

/** Ordering options when selecting data from "dca_allocation_configuration". */
export type Tickets_Dca_Allocation_Configuration_Order_By = {
  created_at?: InputMaybe<Order_By>
  dca_id?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  last_dca_id?: InputMaybe<Order_By>
  last_placement?: InputMaybe<Order_By>
  placement?: InputMaybe<Order_By>
  segmentation_id?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  weight?: InputMaybe<Order_By>
}

/** primary key columns input for table: dca_allocation_configuration */
export type Tickets_Dca_Allocation_Configuration_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "dca_allocation_configuration" */
export enum Tickets_Dca_Allocation_Configuration_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DcaId = "dca_id",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  LastDcaId = "last_dca_id",
  /** column name */
  LastPlacement = "last_placement",
  /** column name */
  Placement = "placement",
  /** column name */
  SegmentationId = "segmentation_id",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  Weight = "weight",
}

/** input type for updating data in table "dca_allocation_configuration" */
export type Tickets_Dca_Allocation_Configuration_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  dca_id?: InputMaybe<Scalars["String"]["input"]>
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_dca_id?: InputMaybe<Scalars["String"]["input"]>
  last_placement?: InputMaybe<Scalars["Int"]["input"]>
  placement?: InputMaybe<Scalars["Int"]["input"]>
  segmentation_id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  weight?: InputMaybe<Scalars["numeric"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Dca_Allocation_Configuration_Stddev_Fields = {
  __typename?: "tickets_dca_allocation_configuration_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  last_placement?: Maybe<Scalars["Float"]["output"]>
  placement?: Maybe<Scalars["Float"]["output"]>
  segmentation_id?: Maybe<Scalars["Float"]["output"]>
  weight?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Dca_Allocation_Configuration_Stddev_Pop_Fields = {
  __typename?: "tickets_dca_allocation_configuration_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  last_placement?: Maybe<Scalars["Float"]["output"]>
  placement?: Maybe<Scalars["Float"]["output"]>
  segmentation_id?: Maybe<Scalars["Float"]["output"]>
  weight?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Dca_Allocation_Configuration_Stddev_Samp_Fields = {
  __typename?: "tickets_dca_allocation_configuration_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  last_placement?: Maybe<Scalars["Float"]["output"]>
  placement?: Maybe<Scalars["Float"]["output"]>
  segmentation_id?: Maybe<Scalars["Float"]["output"]>
  weight?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_dca_allocation_configuration" */
export type Tickets_Dca_Allocation_Configuration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Dca_Allocation_Configuration_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Dca_Allocation_Configuration_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  dca_id?: InputMaybe<Scalars["String"]["input"]>
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_dca_id?: InputMaybe<Scalars["String"]["input"]>
  last_placement?: InputMaybe<Scalars["Int"]["input"]>
  placement?: InputMaybe<Scalars["Int"]["input"]>
  segmentation_id?: InputMaybe<Scalars["bigint"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  weight?: InputMaybe<Scalars["numeric"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_Dca_Allocation_Configuration_Sum_Fields = {
  __typename?: "tickets_dca_allocation_configuration_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  last_placement?: Maybe<Scalars["Int"]["output"]>
  placement?: Maybe<Scalars["Int"]["output"]>
  segmentation_id?: Maybe<Scalars["bigint"]["output"]>
  weight?: Maybe<Scalars["numeric"]["output"]>
}

/** update columns of table "dca_allocation_configuration" */
export enum Tickets_Dca_Allocation_Configuration_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DcaId = "dca_id",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Id = "id",
  /** column name */
  LastDcaId = "last_dca_id",
  /** column name */
  LastPlacement = "last_placement",
  /** column name */
  Placement = "placement",
  /** column name */
  SegmentationId = "segmentation_id",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  Weight = "weight",
}

export type Tickets_Dca_Allocation_Configuration_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Dca_Allocation_Configuration_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Dca_Allocation_Configuration_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Dca_Allocation_Configuration_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Dca_Allocation_Configuration_Var_Pop_Fields = {
  __typename?: "tickets_dca_allocation_configuration_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  last_placement?: Maybe<Scalars["Float"]["output"]>
  placement?: Maybe<Scalars["Float"]["output"]>
  segmentation_id?: Maybe<Scalars["Float"]["output"]>
  weight?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Dca_Allocation_Configuration_Var_Samp_Fields = {
  __typename?: "tickets_dca_allocation_configuration_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  last_placement?: Maybe<Scalars["Float"]["output"]>
  placement?: Maybe<Scalars["Float"]["output"]>
  segmentation_id?: Maybe<Scalars["Float"]["output"]>
  weight?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Dca_Allocation_Configuration_Variance_Fields = {
  __typename?: "tickets_dca_allocation_configuration_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  last_placement?: Maybe<Scalars["Float"]["output"]>
  placement?: Maybe<Scalars["Float"]["output"]>
  segmentation_id?: Maybe<Scalars["Float"]["output"]>
  weight?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "dca_configuration_v2" */
export type Tickets_Dca_Configuration_V2 = {
  __typename?: "tickets_dca_configuration_v2"
  dca: Scalars["String"]["output"]
  junifer_ticket_definition: Scalars["String"]["output"]
}

/** aggregated selection of "dca_configuration_v2" */
export type Tickets_Dca_Configuration_V2_Aggregate = {
  __typename?: "tickets_dca_configuration_v2_aggregate"
  aggregate?: Maybe<Tickets_Dca_Configuration_V2_Aggregate_Fields>
  nodes: Array<Tickets_Dca_Configuration_V2>
}

/** aggregate fields of "dca_configuration_v2" */
export type Tickets_Dca_Configuration_V2_Aggregate_Fields = {
  __typename?: "tickets_dca_configuration_v2_aggregate_fields"
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Dca_Configuration_V2_Max_Fields>
  min?: Maybe<Tickets_Dca_Configuration_V2_Min_Fields>
}

/** aggregate fields of "dca_configuration_v2" */
export type Tickets_Dca_Configuration_V2_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Dca_Configuration_V2_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** Boolean expression to filter rows from the table "dca_configuration_v2". All fields are combined with a logical 'AND'. */
export type Tickets_Dca_Configuration_V2_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Dca_Configuration_V2_Bool_Exp>>
  _not?: InputMaybe<Tickets_Dca_Configuration_V2_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Dca_Configuration_V2_Bool_Exp>>
  dca?: InputMaybe<String_Comparison_Exp>
  junifer_ticket_definition?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "dca_configuration_v2" */
export enum Tickets_Dca_Configuration_V2_Constraint {
  /** unique or primary key constraint on columns "dca" */
  PkDcaConfigurationV2 = "pk_dca_configuration_v2",
}

/** input type for inserting data into table "dca_configuration_v2" */
export type Tickets_Dca_Configuration_V2_Insert_Input = {
  dca?: InputMaybe<Scalars["String"]["input"]>
  junifer_ticket_definition?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Dca_Configuration_V2_Max_Fields = {
  __typename?: "tickets_dca_configuration_v2_max_fields"
  dca?: Maybe<Scalars["String"]["output"]>
  junifer_ticket_definition?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Dca_Configuration_V2_Min_Fields = {
  __typename?: "tickets_dca_configuration_v2_min_fields"
  dca?: Maybe<Scalars["String"]["output"]>
  junifer_ticket_definition?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "dca_configuration_v2" */
export type Tickets_Dca_Configuration_V2_Mutation_Response = {
  __typename?: "tickets_dca_configuration_v2_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Dca_Configuration_V2>
}

/** on_conflict condition type for table "dca_configuration_v2" */
export type Tickets_Dca_Configuration_V2_On_Conflict = {
  constraint: Tickets_Dca_Configuration_V2_Constraint
  update_columns?: Array<Tickets_Dca_Configuration_V2_Update_Column>
  where?: InputMaybe<Tickets_Dca_Configuration_V2_Bool_Exp>
}

/** Ordering options when selecting data from "dca_configuration_v2". */
export type Tickets_Dca_Configuration_V2_Order_By = {
  dca?: InputMaybe<Order_By>
  junifer_ticket_definition?: InputMaybe<Order_By>
}

/** primary key columns input for table: dca_configuration_v2 */
export type Tickets_Dca_Configuration_V2_Pk_Columns_Input = {
  dca: Scalars["String"]["input"]
}

/** select columns of table "dca_configuration_v2" */
export enum Tickets_Dca_Configuration_V2_Select_Column {
  /** column name */
  Dca = "dca",
  /** column name */
  JuniferTicketDefinition = "junifer_ticket_definition",
}

/** input type for updating data in table "dca_configuration_v2" */
export type Tickets_Dca_Configuration_V2_Set_Input = {
  dca?: InputMaybe<Scalars["String"]["input"]>
  junifer_ticket_definition?: InputMaybe<Scalars["String"]["input"]>
}

/** Streaming cursor of the table "tickets_dca_configuration_v2" */
export type Tickets_Dca_Configuration_V2_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Dca_Configuration_V2_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Dca_Configuration_V2_Stream_Cursor_Value_Input = {
  dca?: InputMaybe<Scalars["String"]["input"]>
  junifer_ticket_definition?: InputMaybe<Scalars["String"]["input"]>
}

/** update columns of table "dca_configuration_v2" */
export enum Tickets_Dca_Configuration_V2_Update_Column {
  /** column name */
  Dca = "dca",
  /** column name */
  JuniferTicketDefinition = "junifer_ticket_definition",
}

export type Tickets_Dca_Configuration_V2_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Dca_Configuration_V2_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Dca_Configuration_V2_Bool_Exp
}

/** columns and relationships of "dca_segmentation" */
export type Tickets_Dca_Segmentation = {
  __typename?: "tickets_dca_segmentation"
  account_state: Scalars["account_state"]["output"]
  change_type?: Maybe<Scalars["leaving_type"]["output"]>
  id: Scalars["bigint"]["output"]
  occupier: Scalars["occupier_status"]["output"]
  psr: Scalars["Boolean"]["output"]
}

/** aggregated selection of "dca_segmentation" */
export type Tickets_Dca_Segmentation_Aggregate = {
  __typename?: "tickets_dca_segmentation_aggregate"
  aggregate?: Maybe<Tickets_Dca_Segmentation_Aggregate_Fields>
  nodes: Array<Tickets_Dca_Segmentation>
}

/** aggregate fields of "dca_segmentation" */
export type Tickets_Dca_Segmentation_Aggregate_Fields = {
  __typename?: "tickets_dca_segmentation_aggregate_fields"
  avg?: Maybe<Tickets_Dca_Segmentation_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Dca_Segmentation_Max_Fields>
  min?: Maybe<Tickets_Dca_Segmentation_Min_Fields>
  stddev?: Maybe<Tickets_Dca_Segmentation_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Dca_Segmentation_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Dca_Segmentation_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Dca_Segmentation_Sum_Fields>
  var_pop?: Maybe<Tickets_Dca_Segmentation_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Dca_Segmentation_Var_Samp_Fields>
  variance?: Maybe<Tickets_Dca_Segmentation_Variance_Fields>
}

/** aggregate fields of "dca_segmentation" */
export type Tickets_Dca_Segmentation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Dca_Segmentation_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_Dca_Segmentation_Avg_Fields = {
  __typename?: "tickets_dca_segmentation_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "dca_segmentation". All fields are combined with a logical 'AND'. */
export type Tickets_Dca_Segmentation_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Dca_Segmentation_Bool_Exp>>
  _not?: InputMaybe<Tickets_Dca_Segmentation_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Dca_Segmentation_Bool_Exp>>
  account_state?: InputMaybe<Account_State_Comparison_Exp>
  change_type?: InputMaybe<Leaving_Type_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  occupier?: InputMaybe<Occupier_Status_Comparison_Exp>
  psr?: InputMaybe<Boolean_Comparison_Exp>
}

/** unique or primary key constraints on table "dca_segmentation" */
export enum Tickets_Dca_Segmentation_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkDcaSegmentation = "pk_dca_segmentation",
  /** unique or primary key constraint on columns "occupier", "change_type", "account_state", "psr" */
  UniqueConstraintDcaSegmentation = "unique_constraint_dca_segmentation",
}

/** input type for incrementing numeric columns in table "dca_segmentation" */
export type Tickets_Dca_Segmentation_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "dca_segmentation" */
export type Tickets_Dca_Segmentation_Insert_Input = {
  account_state?: InputMaybe<Scalars["account_state"]["input"]>
  change_type?: InputMaybe<Scalars["leaving_type"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  occupier?: InputMaybe<Scalars["occupier_status"]["input"]>
  psr?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Dca_Segmentation_Max_Fields = {
  __typename?: "tickets_dca_segmentation_max_fields"
  account_state?: Maybe<Scalars["account_state"]["output"]>
  change_type?: Maybe<Scalars["leaving_type"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  occupier?: Maybe<Scalars["occupier_status"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Dca_Segmentation_Min_Fields = {
  __typename?: "tickets_dca_segmentation_min_fields"
  account_state?: Maybe<Scalars["account_state"]["output"]>
  change_type?: Maybe<Scalars["leaving_type"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  occupier?: Maybe<Scalars["occupier_status"]["output"]>
}

/** response of any mutation on the table "dca_segmentation" */
export type Tickets_Dca_Segmentation_Mutation_Response = {
  __typename?: "tickets_dca_segmentation_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Dca_Segmentation>
}

/** on_conflict condition type for table "dca_segmentation" */
export type Tickets_Dca_Segmentation_On_Conflict = {
  constraint: Tickets_Dca_Segmentation_Constraint
  update_columns?: Array<Tickets_Dca_Segmentation_Update_Column>
  where?: InputMaybe<Tickets_Dca_Segmentation_Bool_Exp>
}

/** Ordering options when selecting data from "dca_segmentation". */
export type Tickets_Dca_Segmentation_Order_By = {
  account_state?: InputMaybe<Order_By>
  change_type?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  occupier?: InputMaybe<Order_By>
  psr?: InputMaybe<Order_By>
}

/** primary key columns input for table: dca_segmentation */
export type Tickets_Dca_Segmentation_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "dca_segmentation" */
export enum Tickets_Dca_Segmentation_Select_Column {
  /** column name */
  AccountState = "account_state",
  /** column name */
  ChangeType = "change_type",
  /** column name */
  Id = "id",
  /** column name */
  Occupier = "occupier",
  /** column name */
  Psr = "psr",
}

/** input type for updating data in table "dca_segmentation" */
export type Tickets_Dca_Segmentation_Set_Input = {
  account_state?: InputMaybe<Scalars["account_state"]["input"]>
  change_type?: InputMaybe<Scalars["leaving_type"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  occupier?: InputMaybe<Scalars["occupier_status"]["input"]>
  psr?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Dca_Segmentation_Stddev_Fields = {
  __typename?: "tickets_dca_segmentation_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Dca_Segmentation_Stddev_Pop_Fields = {
  __typename?: "tickets_dca_segmentation_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Dca_Segmentation_Stddev_Samp_Fields = {
  __typename?: "tickets_dca_segmentation_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_dca_segmentation" */
export type Tickets_Dca_Segmentation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Dca_Segmentation_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Dca_Segmentation_Stream_Cursor_Value_Input = {
  account_state?: InputMaybe<Scalars["account_state"]["input"]>
  change_type?: InputMaybe<Scalars["leaving_type"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  occupier?: InputMaybe<Scalars["occupier_status"]["input"]>
  psr?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_Dca_Segmentation_Sum_Fields = {
  __typename?: "tickets_dca_segmentation_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "dca_segmentation" */
export enum Tickets_Dca_Segmentation_Update_Column {
  /** column name */
  AccountState = "account_state",
  /** column name */
  ChangeType = "change_type",
  /** column name */
  Id = "id",
  /** column name */
  Occupier = "occupier",
  /** column name */
  Psr = "psr",
}

export type Tickets_Dca_Segmentation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Dca_Segmentation_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Dca_Segmentation_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Dca_Segmentation_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Dca_Segmentation_Var_Pop_Fields = {
  __typename?: "tickets_dca_segmentation_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Dca_Segmentation_Var_Samp_Fields = {
  __typename?: "tickets_dca_segmentation_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Dca_Segmentation_Variance_Fields = {
  __typename?: "tickets_dca_segmentation_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "dunning_account_store" */
export type Tickets_Dunning_Account_Store = {
  __typename?: "tickets_dunning_account_store"
  account_balance?: Maybe<Scalars["numeric"]["output"]>
  account_group?: Maybe<Scalars["account_group_enum"]["output"]>
  account_in_review?: Maybe<Scalars["Boolean"]["output"]>
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  account_sub_group?: Maybe<Scalars["account_sub_group_enum"]["output"]>
  balance_plus_un_billed?: Maybe<Scalars["numeric"]["output"]>
  created_at: Scalars["timestamptz"]["output"]
  dd_created_at?: Maybe<Scalars["date"]["output"]>
  dd_status?: Maybe<Scalars["String"]["output"]>
  dd_unpaid_ticket?: Maybe<Scalars["Boolean"]["output"]>
  dr_ticket_to_open?: Maybe<Scalars["Boolean"]["output"]>
  dunning_job_id: Scalars["bigint"]["output"]
  et_ticket_to_open?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["bigint"]["output"]
  last_payment_date?: Maybe<Scalars["date"]["output"]>
  occupier_account?: Maybe<Scalars["Boolean"]["output"]>
  open_complaint?: Maybe<Scalars["Boolean"]["output"]>
  payment_in_last_70_days?: Maybe<Scalars["Boolean"]["output"]>
  payment_plan?: Maybe<Scalars["Boolean"]["output"]>
  promise_to_pay?: Maybe<Scalars["Boolean"]["output"]>
  recent_payments?: Maybe<Scalars["numeric"]["output"]>
  un_billed_status?: Maybe<Scalars["Boolean"]["output"]>
  with_dca?: Maybe<Scalars["Boolean"]["output"]>
}

/** aggregated selection of "dunning_account_store" */
export type Tickets_Dunning_Account_Store_Aggregate = {
  __typename?: "tickets_dunning_account_store_aggregate"
  aggregate?: Maybe<Tickets_Dunning_Account_Store_Aggregate_Fields>
  nodes: Array<Tickets_Dunning_Account_Store>
}

/** aggregate fields of "dunning_account_store" */
export type Tickets_Dunning_Account_Store_Aggregate_Fields = {
  __typename?: "tickets_dunning_account_store_aggregate_fields"
  avg?: Maybe<Tickets_Dunning_Account_Store_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Dunning_Account_Store_Max_Fields>
  min?: Maybe<Tickets_Dunning_Account_Store_Min_Fields>
  stddev?: Maybe<Tickets_Dunning_Account_Store_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Dunning_Account_Store_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Dunning_Account_Store_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Dunning_Account_Store_Sum_Fields>
  var_pop?: Maybe<Tickets_Dunning_Account_Store_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Dunning_Account_Store_Var_Samp_Fields>
  variance?: Maybe<Tickets_Dunning_Account_Store_Variance_Fields>
}

/** aggregate fields of "dunning_account_store" */
export type Tickets_Dunning_Account_Store_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Dunning_Account_Store_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_Dunning_Account_Store_Avg_Fields = {
  __typename?: "tickets_dunning_account_store_avg_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  balance_plus_un_billed?: Maybe<Scalars["Float"]["output"]>
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  recent_payments?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "dunning_account_store". All fields are combined with a logical 'AND'. */
export type Tickets_Dunning_Account_Store_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Dunning_Account_Store_Bool_Exp>>
  _not?: InputMaybe<Tickets_Dunning_Account_Store_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Dunning_Account_Store_Bool_Exp>>
  account_balance?: InputMaybe<Numeric_Comparison_Exp>
  account_group?: InputMaybe<Account_Group_Enum_Comparison_Exp>
  account_in_review?: InputMaybe<Boolean_Comparison_Exp>
  account_number?: InputMaybe<String_Comparison_Exp>
  account_status?: InputMaybe<String_Comparison_Exp>
  account_sub_group?: InputMaybe<Account_Sub_Group_Enum_Comparison_Exp>
  balance_plus_un_billed?: InputMaybe<Numeric_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  dd_created_at?: InputMaybe<Date_Comparison_Exp>
  dd_status?: InputMaybe<String_Comparison_Exp>
  dd_unpaid_ticket?: InputMaybe<Boolean_Comparison_Exp>
  dr_ticket_to_open?: InputMaybe<Boolean_Comparison_Exp>
  dunning_job_id?: InputMaybe<Bigint_Comparison_Exp>
  et_ticket_to_open?: InputMaybe<Boolean_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  last_payment_date?: InputMaybe<Date_Comparison_Exp>
  occupier_account?: InputMaybe<Boolean_Comparison_Exp>
  open_complaint?: InputMaybe<Boolean_Comparison_Exp>
  payment_in_last_70_days?: InputMaybe<Boolean_Comparison_Exp>
  payment_plan?: InputMaybe<Boolean_Comparison_Exp>
  promise_to_pay?: InputMaybe<Boolean_Comparison_Exp>
  recent_payments?: InputMaybe<Numeric_Comparison_Exp>
  un_billed_status?: InputMaybe<Boolean_Comparison_Exp>
  with_dca?: InputMaybe<Boolean_Comparison_Exp>
}

/** unique or primary key constraints on table "dunning_account_store" */
export enum Tickets_Dunning_Account_Store_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkDunningAccountStore = "pk_dunning_account_store",
  /** unique or primary key constraint on columns "dunning_job_id", "account_number" */
  UniqueConstraintAccountNumberDunningJob = "unique_constraint_account_number_dunning_job",
}

/** input type for incrementing numeric columns in table "dunning_account_store" */
export type Tickets_Dunning_Account_Store_Inc_Input = {
  account_balance?: InputMaybe<Scalars["numeric"]["input"]>
  balance_plus_un_billed?: InputMaybe<Scalars["numeric"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  recent_payments?: InputMaybe<Scalars["numeric"]["input"]>
}

/** input type for inserting data into table "dunning_account_store" */
export type Tickets_Dunning_Account_Store_Insert_Input = {
  account_balance?: InputMaybe<Scalars["numeric"]["input"]>
  account_group?: InputMaybe<Scalars["account_group_enum"]["input"]>
  account_in_review?: InputMaybe<Scalars["Boolean"]["input"]>
  account_number?: InputMaybe<Scalars["String"]["input"]>
  account_status?: InputMaybe<Scalars["String"]["input"]>
  account_sub_group?: InputMaybe<Scalars["account_sub_group_enum"]["input"]>
  balance_plus_un_billed?: InputMaybe<Scalars["numeric"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  dd_created_at?: InputMaybe<Scalars["date"]["input"]>
  dd_status?: InputMaybe<Scalars["String"]["input"]>
  dd_unpaid_ticket?: InputMaybe<Scalars["Boolean"]["input"]>
  dr_ticket_to_open?: InputMaybe<Scalars["Boolean"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  et_ticket_to_open?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_payment_date?: InputMaybe<Scalars["date"]["input"]>
  occupier_account?: InputMaybe<Scalars["Boolean"]["input"]>
  open_complaint?: InputMaybe<Scalars["Boolean"]["input"]>
  payment_in_last_70_days?: InputMaybe<Scalars["Boolean"]["input"]>
  payment_plan?: InputMaybe<Scalars["Boolean"]["input"]>
  promise_to_pay?: InputMaybe<Scalars["Boolean"]["input"]>
  recent_payments?: InputMaybe<Scalars["numeric"]["input"]>
  un_billed_status?: InputMaybe<Scalars["Boolean"]["input"]>
  with_dca?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Dunning_Account_Store_Max_Fields = {
  __typename?: "tickets_dunning_account_store_max_fields"
  account_balance?: Maybe<Scalars["numeric"]["output"]>
  account_group?: Maybe<Scalars["account_group_enum"]["output"]>
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  account_sub_group?: Maybe<Scalars["account_sub_group_enum"]["output"]>
  balance_plus_un_billed?: Maybe<Scalars["numeric"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  dd_created_at?: Maybe<Scalars["date"]["output"]>
  dd_status?: Maybe<Scalars["String"]["output"]>
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_payment_date?: Maybe<Scalars["date"]["output"]>
  recent_payments?: Maybe<Scalars["numeric"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Dunning_Account_Store_Min_Fields = {
  __typename?: "tickets_dunning_account_store_min_fields"
  account_balance?: Maybe<Scalars["numeric"]["output"]>
  account_group?: Maybe<Scalars["account_group_enum"]["output"]>
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  account_sub_group?: Maybe<Scalars["account_sub_group_enum"]["output"]>
  balance_plus_un_billed?: Maybe<Scalars["numeric"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  dd_created_at?: Maybe<Scalars["date"]["output"]>
  dd_status?: Maybe<Scalars["String"]["output"]>
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_payment_date?: Maybe<Scalars["date"]["output"]>
  recent_payments?: Maybe<Scalars["numeric"]["output"]>
}

/** response of any mutation on the table "dunning_account_store" */
export type Tickets_Dunning_Account_Store_Mutation_Response = {
  __typename?: "tickets_dunning_account_store_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Dunning_Account_Store>
}

/** on_conflict condition type for table "dunning_account_store" */
export type Tickets_Dunning_Account_Store_On_Conflict = {
  constraint: Tickets_Dunning_Account_Store_Constraint
  update_columns?: Array<Tickets_Dunning_Account_Store_Update_Column>
  where?: InputMaybe<Tickets_Dunning_Account_Store_Bool_Exp>
}

/** Ordering options when selecting data from "dunning_account_store". */
export type Tickets_Dunning_Account_Store_Order_By = {
  account_balance?: InputMaybe<Order_By>
  account_group?: InputMaybe<Order_By>
  account_in_review?: InputMaybe<Order_By>
  account_number?: InputMaybe<Order_By>
  account_status?: InputMaybe<Order_By>
  account_sub_group?: InputMaybe<Order_By>
  balance_plus_un_billed?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  dd_created_at?: InputMaybe<Order_By>
  dd_status?: InputMaybe<Order_By>
  dd_unpaid_ticket?: InputMaybe<Order_By>
  dr_ticket_to_open?: InputMaybe<Order_By>
  dunning_job_id?: InputMaybe<Order_By>
  et_ticket_to_open?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  last_payment_date?: InputMaybe<Order_By>
  occupier_account?: InputMaybe<Order_By>
  open_complaint?: InputMaybe<Order_By>
  payment_in_last_70_days?: InputMaybe<Order_By>
  payment_plan?: InputMaybe<Order_By>
  promise_to_pay?: InputMaybe<Order_By>
  recent_payments?: InputMaybe<Order_By>
  un_billed_status?: InputMaybe<Order_By>
  with_dca?: InputMaybe<Order_By>
}

/** primary key columns input for table: dunning_account_store */
export type Tickets_Dunning_Account_Store_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "dunning_account_store" */
export enum Tickets_Dunning_Account_Store_Select_Column {
  /** column name */
  AccountBalance = "account_balance",
  /** column name */
  AccountGroup = "account_group",
  /** column name */
  AccountInReview = "account_in_review",
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AccountStatus = "account_status",
  /** column name */
  AccountSubGroup = "account_sub_group",
  /** column name */
  BalancePlusUnBilled = "balance_plus_un_billed",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DdCreatedAt = "dd_created_at",
  /** column name */
  DdStatus = "dd_status",
  /** column name */
  DdUnpaidTicket = "dd_unpaid_ticket",
  /** column name */
  DrTicketToOpen = "dr_ticket_to_open",
  /** column name */
  DunningJobId = "dunning_job_id",
  /** column name */
  EtTicketToOpen = "et_ticket_to_open",
  /** column name */
  Id = "id",
  /** column name */
  LastPaymentDate = "last_payment_date",
  /** column name */
  OccupierAccount = "occupier_account",
  /** column name */
  OpenComplaint = "open_complaint",
  /** column name */
  PaymentInLast_70Days = "payment_in_last_70_days",
  /** column name */
  PaymentPlan = "payment_plan",
  /** column name */
  PromiseToPay = "promise_to_pay",
  /** column name */
  RecentPayments = "recent_payments",
  /** column name */
  UnBilledStatus = "un_billed_status",
  /** column name */
  WithDca = "with_dca",
}

/** input type for updating data in table "dunning_account_store" */
export type Tickets_Dunning_Account_Store_Set_Input = {
  account_balance?: InputMaybe<Scalars["numeric"]["input"]>
  account_group?: InputMaybe<Scalars["account_group_enum"]["input"]>
  account_in_review?: InputMaybe<Scalars["Boolean"]["input"]>
  account_number?: InputMaybe<Scalars["String"]["input"]>
  account_status?: InputMaybe<Scalars["String"]["input"]>
  account_sub_group?: InputMaybe<Scalars["account_sub_group_enum"]["input"]>
  balance_plus_un_billed?: InputMaybe<Scalars["numeric"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  dd_created_at?: InputMaybe<Scalars["date"]["input"]>
  dd_status?: InputMaybe<Scalars["String"]["input"]>
  dd_unpaid_ticket?: InputMaybe<Scalars["Boolean"]["input"]>
  dr_ticket_to_open?: InputMaybe<Scalars["Boolean"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  et_ticket_to_open?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_payment_date?: InputMaybe<Scalars["date"]["input"]>
  occupier_account?: InputMaybe<Scalars["Boolean"]["input"]>
  open_complaint?: InputMaybe<Scalars["Boolean"]["input"]>
  payment_in_last_70_days?: InputMaybe<Scalars["Boolean"]["input"]>
  payment_plan?: InputMaybe<Scalars["Boolean"]["input"]>
  promise_to_pay?: InputMaybe<Scalars["Boolean"]["input"]>
  recent_payments?: InputMaybe<Scalars["numeric"]["input"]>
  un_billed_status?: InputMaybe<Scalars["Boolean"]["input"]>
  with_dca?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Dunning_Account_Store_Stddev_Fields = {
  __typename?: "tickets_dunning_account_store_stddev_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  balance_plus_un_billed?: Maybe<Scalars["Float"]["output"]>
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  recent_payments?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Dunning_Account_Store_Stddev_Pop_Fields = {
  __typename?: "tickets_dunning_account_store_stddev_pop_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  balance_plus_un_billed?: Maybe<Scalars["Float"]["output"]>
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  recent_payments?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Dunning_Account_Store_Stddev_Samp_Fields = {
  __typename?: "tickets_dunning_account_store_stddev_samp_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  balance_plus_un_billed?: Maybe<Scalars["Float"]["output"]>
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  recent_payments?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_dunning_account_store" */
export type Tickets_Dunning_Account_Store_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Dunning_Account_Store_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Dunning_Account_Store_Stream_Cursor_Value_Input = {
  account_balance?: InputMaybe<Scalars["numeric"]["input"]>
  account_group?: InputMaybe<Scalars["account_group_enum"]["input"]>
  account_in_review?: InputMaybe<Scalars["Boolean"]["input"]>
  account_number?: InputMaybe<Scalars["String"]["input"]>
  account_status?: InputMaybe<Scalars["String"]["input"]>
  account_sub_group?: InputMaybe<Scalars["account_sub_group_enum"]["input"]>
  balance_plus_un_billed?: InputMaybe<Scalars["numeric"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  dd_created_at?: InputMaybe<Scalars["date"]["input"]>
  dd_status?: InputMaybe<Scalars["String"]["input"]>
  dd_unpaid_ticket?: InputMaybe<Scalars["Boolean"]["input"]>
  dr_ticket_to_open?: InputMaybe<Scalars["Boolean"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  et_ticket_to_open?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_payment_date?: InputMaybe<Scalars["date"]["input"]>
  occupier_account?: InputMaybe<Scalars["Boolean"]["input"]>
  open_complaint?: InputMaybe<Scalars["Boolean"]["input"]>
  payment_in_last_70_days?: InputMaybe<Scalars["Boolean"]["input"]>
  payment_plan?: InputMaybe<Scalars["Boolean"]["input"]>
  promise_to_pay?: InputMaybe<Scalars["Boolean"]["input"]>
  recent_payments?: InputMaybe<Scalars["numeric"]["input"]>
  un_billed_status?: InputMaybe<Scalars["Boolean"]["input"]>
  with_dca?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_Dunning_Account_Store_Sum_Fields = {
  __typename?: "tickets_dunning_account_store_sum_fields"
  account_balance?: Maybe<Scalars["numeric"]["output"]>
  balance_plus_un_billed?: Maybe<Scalars["numeric"]["output"]>
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  recent_payments?: Maybe<Scalars["numeric"]["output"]>
}

/** update columns of table "dunning_account_store" */
export enum Tickets_Dunning_Account_Store_Update_Column {
  /** column name */
  AccountBalance = "account_balance",
  /** column name */
  AccountGroup = "account_group",
  /** column name */
  AccountInReview = "account_in_review",
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AccountStatus = "account_status",
  /** column name */
  AccountSubGroup = "account_sub_group",
  /** column name */
  BalancePlusUnBilled = "balance_plus_un_billed",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DdCreatedAt = "dd_created_at",
  /** column name */
  DdStatus = "dd_status",
  /** column name */
  DdUnpaidTicket = "dd_unpaid_ticket",
  /** column name */
  DrTicketToOpen = "dr_ticket_to_open",
  /** column name */
  DunningJobId = "dunning_job_id",
  /** column name */
  EtTicketToOpen = "et_ticket_to_open",
  /** column name */
  Id = "id",
  /** column name */
  LastPaymentDate = "last_payment_date",
  /** column name */
  OccupierAccount = "occupier_account",
  /** column name */
  OpenComplaint = "open_complaint",
  /** column name */
  PaymentInLast_70Days = "payment_in_last_70_days",
  /** column name */
  PaymentPlan = "payment_plan",
  /** column name */
  PromiseToPay = "promise_to_pay",
  /** column name */
  RecentPayments = "recent_payments",
  /** column name */
  UnBilledStatus = "un_billed_status",
  /** column name */
  WithDca = "with_dca",
}

export type Tickets_Dunning_Account_Store_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Dunning_Account_Store_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Dunning_Account_Store_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Dunning_Account_Store_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Dunning_Account_Store_Var_Pop_Fields = {
  __typename?: "tickets_dunning_account_store_var_pop_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  balance_plus_un_billed?: Maybe<Scalars["Float"]["output"]>
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  recent_payments?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Dunning_Account_Store_Var_Samp_Fields = {
  __typename?: "tickets_dunning_account_store_var_samp_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  balance_plus_un_billed?: Maybe<Scalars["Float"]["output"]>
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  recent_payments?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Dunning_Account_Store_Variance_Fields = {
  __typename?: "tickets_dunning_account_store_variance_fields"
  account_balance?: Maybe<Scalars["Float"]["output"]>
  balance_plus_un_billed?: Maybe<Scalars["Float"]["output"]>
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  recent_payments?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "dunning_addacs_review_records" */
export type Tickets_Dunning_Addacs_Review_Records = {
  __typename?: "tickets_dunning_addacs_review_records"
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  dd_status?: Maybe<Scalars["String"]["output"]>
  dunning_job_id: Scalars["bigint"]["output"]
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  status?: Maybe<Scalars["dunning_addacs_review_status"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_is_last_step: Scalars["Boolean"]["output"]
  ticket_next_step?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
}

/** aggregated selection of "dunning_addacs_review_records" */
export type Tickets_Dunning_Addacs_Review_Records_Aggregate = {
  __typename?: "tickets_dunning_addacs_review_records_aggregate"
  aggregate?: Maybe<Tickets_Dunning_Addacs_Review_Records_Aggregate_Fields>
  nodes: Array<Tickets_Dunning_Addacs_Review_Records>
}

/** aggregate fields of "dunning_addacs_review_records" */
export type Tickets_Dunning_Addacs_Review_Records_Aggregate_Fields = {
  __typename?: "tickets_dunning_addacs_review_records_aggregate_fields"
  avg?: Maybe<Tickets_Dunning_Addacs_Review_Records_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Dunning_Addacs_Review_Records_Max_Fields>
  min?: Maybe<Tickets_Dunning_Addacs_Review_Records_Min_Fields>
  stddev?: Maybe<Tickets_Dunning_Addacs_Review_Records_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Dunning_Addacs_Review_Records_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Dunning_Addacs_Review_Records_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Dunning_Addacs_Review_Records_Sum_Fields>
  var_pop?: Maybe<Tickets_Dunning_Addacs_Review_Records_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Dunning_Addacs_Review_Records_Var_Samp_Fields>
  variance?: Maybe<Tickets_Dunning_Addacs_Review_Records_Variance_Fields>
}

/** aggregate fields of "dunning_addacs_review_records" */
export type Tickets_Dunning_Addacs_Review_Records_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<
    Array<Tickets_Dunning_Addacs_Review_Records_Select_Column>
  >
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_Dunning_Addacs_Review_Records_Avg_Fields = {
  __typename?: "tickets_dunning_addacs_review_records_avg_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "dunning_addacs_review_records". All fields are combined with a logical 'AND'. */
export type Tickets_Dunning_Addacs_Review_Records_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Dunning_Addacs_Review_Records_Bool_Exp>>
  _not?: InputMaybe<Tickets_Dunning_Addacs_Review_Records_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Dunning_Addacs_Review_Records_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  account_status?: InputMaybe<String_Comparison_Exp>
  dd_status?: InputMaybe<String_Comparison_Exp>
  dunning_job_id?: InputMaybe<Bigint_Comparison_Exp>
  failure_reason?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  status?: InputMaybe<Dunning_Addacs_Review_Status_Comparison_Exp>
  ticket_id?: InputMaybe<String_Comparison_Exp>
  ticket_is_last_step?: InputMaybe<Boolean_Comparison_Exp>
  ticket_next_step?: InputMaybe<String_Comparison_Exp>
  ticket_step?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "dunning_addacs_review_records" */
export enum Tickets_Dunning_Addacs_Review_Records_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkDunningAddacsRecordsReport = "pk_dunning_addacs_records_report",
}

/** input type for incrementing numeric columns in table "dunning_addacs_review_records" */
export type Tickets_Dunning_Addacs_Review_Records_Inc_Input = {
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "dunning_addacs_review_records" */
export type Tickets_Dunning_Addacs_Review_Records_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  account_status?: InputMaybe<Scalars["String"]["input"]>
  dd_status?: InputMaybe<Scalars["String"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["dunning_addacs_review_status"]["input"]>
  ticket_id?: InputMaybe<Scalars["String"]["input"]>
  ticket_is_last_step?: InputMaybe<Scalars["Boolean"]["input"]>
  ticket_next_step?: InputMaybe<Scalars["String"]["input"]>
  ticket_step?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Dunning_Addacs_Review_Records_Max_Fields = {
  __typename?: "tickets_dunning_addacs_review_records_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  dd_status?: Maybe<Scalars["String"]["output"]>
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["dunning_addacs_review_status"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_next_step?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Dunning_Addacs_Review_Records_Min_Fields = {
  __typename?: "tickets_dunning_addacs_review_records_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  dd_status?: Maybe<Scalars["String"]["output"]>
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["dunning_addacs_review_status"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_next_step?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "dunning_addacs_review_records" */
export type Tickets_Dunning_Addacs_Review_Records_Mutation_Response = {
  __typename?: "tickets_dunning_addacs_review_records_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Dunning_Addacs_Review_Records>
}

/** on_conflict condition type for table "dunning_addacs_review_records" */
export type Tickets_Dunning_Addacs_Review_Records_On_Conflict = {
  constraint: Tickets_Dunning_Addacs_Review_Records_Constraint
  update_columns?: Array<Tickets_Dunning_Addacs_Review_Records_Update_Column>
  where?: InputMaybe<Tickets_Dunning_Addacs_Review_Records_Bool_Exp>
}

/** Ordering options when selecting data from "dunning_addacs_review_records". */
export type Tickets_Dunning_Addacs_Review_Records_Order_By = {
  account_number?: InputMaybe<Order_By>
  account_status?: InputMaybe<Order_By>
  dd_status?: InputMaybe<Order_By>
  dunning_job_id?: InputMaybe<Order_By>
  failure_reason?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  ticket_id?: InputMaybe<Order_By>
  ticket_is_last_step?: InputMaybe<Order_By>
  ticket_next_step?: InputMaybe<Order_By>
  ticket_step?: InputMaybe<Order_By>
}

/** primary key columns input for table: dunning_addacs_review_records */
export type Tickets_Dunning_Addacs_Review_Records_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "dunning_addacs_review_records" */
export enum Tickets_Dunning_Addacs_Review_Records_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AccountStatus = "account_status",
  /** column name */
  DdStatus = "dd_status",
  /** column name */
  DunningJobId = "dunning_job_id",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  TicketId = "ticket_id",
  /** column name */
  TicketIsLastStep = "ticket_is_last_step",
  /** column name */
  TicketNextStep = "ticket_next_step",
  /** column name */
  TicketStep = "ticket_step",
}

/** input type for updating data in table "dunning_addacs_review_records" */
export type Tickets_Dunning_Addacs_Review_Records_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  account_status?: InputMaybe<Scalars["String"]["input"]>
  dd_status?: InputMaybe<Scalars["String"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["dunning_addacs_review_status"]["input"]>
  ticket_id?: InputMaybe<Scalars["String"]["input"]>
  ticket_is_last_step?: InputMaybe<Scalars["Boolean"]["input"]>
  ticket_next_step?: InputMaybe<Scalars["String"]["input"]>
  ticket_step?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Dunning_Addacs_Review_Records_Stddev_Fields = {
  __typename?: "tickets_dunning_addacs_review_records_stddev_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Dunning_Addacs_Review_Records_Stddev_Pop_Fields = {
  __typename?: "tickets_dunning_addacs_review_records_stddev_pop_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Dunning_Addacs_Review_Records_Stddev_Samp_Fields = {
  __typename?: "tickets_dunning_addacs_review_records_stddev_samp_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_dunning_addacs_review_records" */
export type Tickets_Dunning_Addacs_Review_Records_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Dunning_Addacs_Review_Records_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Dunning_Addacs_Review_Records_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  account_status?: InputMaybe<Scalars["String"]["input"]>
  dd_status?: InputMaybe<Scalars["String"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["dunning_addacs_review_status"]["input"]>
  ticket_id?: InputMaybe<Scalars["String"]["input"]>
  ticket_is_last_step?: InputMaybe<Scalars["Boolean"]["input"]>
  ticket_next_step?: InputMaybe<Scalars["String"]["input"]>
  ticket_step?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_Dunning_Addacs_Review_Records_Sum_Fields = {
  __typename?: "tickets_dunning_addacs_review_records_sum_fields"
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "dunning_addacs_review_records" */
export enum Tickets_Dunning_Addacs_Review_Records_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AccountStatus = "account_status",
  /** column name */
  DdStatus = "dd_status",
  /** column name */
  DunningJobId = "dunning_job_id",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  TicketId = "ticket_id",
  /** column name */
  TicketIsLastStep = "ticket_is_last_step",
  /** column name */
  TicketNextStep = "ticket_next_step",
  /** column name */
  TicketStep = "ticket_step",
}

export type Tickets_Dunning_Addacs_Review_Records_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Dunning_Addacs_Review_Records_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Dunning_Addacs_Review_Records_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Dunning_Addacs_Review_Records_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Dunning_Addacs_Review_Records_Var_Pop_Fields = {
  __typename?: "tickets_dunning_addacs_review_records_var_pop_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Dunning_Addacs_Review_Records_Var_Samp_Fields = {
  __typename?: "tickets_dunning_addacs_review_records_var_samp_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Dunning_Addacs_Review_Records_Variance_Fields = {
  __typename?: "tickets_dunning_addacs_review_records_variance_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "dunning_automation_events" */
export type Tickets_Dunning_Automation_Events = {
  __typename?: "tickets_dunning_automation_events"
  created_at: Scalars["timestamptz"]["output"]
  id: Scalars["bigint"]["output"]
  metadata?: Maybe<Scalars["json"]["output"]>
  session_id: Scalars["String"]["output"]
  status: Scalars["dunning_automation_events_status"]["output"]
}

/** columns and relationships of "dunning_automation_events" */
export type Tickets_Dunning_Automation_EventsMetadataArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregated selection of "dunning_automation_events" */
export type Tickets_Dunning_Automation_Events_Aggregate = {
  __typename?: "tickets_dunning_automation_events_aggregate"
  aggregate?: Maybe<Tickets_Dunning_Automation_Events_Aggregate_Fields>
  nodes: Array<Tickets_Dunning_Automation_Events>
}

/** aggregate fields of "dunning_automation_events" */
export type Tickets_Dunning_Automation_Events_Aggregate_Fields = {
  __typename?: "tickets_dunning_automation_events_aggregate_fields"
  avg?: Maybe<Tickets_Dunning_Automation_Events_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Dunning_Automation_Events_Max_Fields>
  min?: Maybe<Tickets_Dunning_Automation_Events_Min_Fields>
  stddev?: Maybe<Tickets_Dunning_Automation_Events_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Dunning_Automation_Events_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Dunning_Automation_Events_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Dunning_Automation_Events_Sum_Fields>
  var_pop?: Maybe<Tickets_Dunning_Automation_Events_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Dunning_Automation_Events_Var_Samp_Fields>
  variance?: Maybe<Tickets_Dunning_Automation_Events_Variance_Fields>
}

/** aggregate fields of "dunning_automation_events" */
export type Tickets_Dunning_Automation_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Dunning_Automation_Events_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_Dunning_Automation_Events_Avg_Fields = {
  __typename?: "tickets_dunning_automation_events_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "dunning_automation_events". All fields are combined with a logical 'AND'. */
export type Tickets_Dunning_Automation_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Dunning_Automation_Events_Bool_Exp>>
  _not?: InputMaybe<Tickets_Dunning_Automation_Events_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Dunning_Automation_Events_Bool_Exp>>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  metadata?: InputMaybe<Json_Comparison_Exp>
  session_id?: InputMaybe<String_Comparison_Exp>
  status?: InputMaybe<Dunning_Automation_Events_Status_Comparison_Exp>
}

/** unique or primary key constraints on table "dunning_automation_events" */
export enum Tickets_Dunning_Automation_Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkDunningAutomationEvents = "pk_dunning_automation_events",
}

/** input type for incrementing numeric columns in table "dunning_automation_events" */
export type Tickets_Dunning_Automation_Events_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "dunning_automation_events" */
export type Tickets_Dunning_Automation_Events_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  metadata?: InputMaybe<Scalars["json"]["input"]>
  session_id?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["dunning_automation_events_status"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Dunning_Automation_Events_Max_Fields = {
  __typename?: "tickets_dunning_automation_events_max_fields"
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  session_id?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["dunning_automation_events_status"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Dunning_Automation_Events_Min_Fields = {
  __typename?: "tickets_dunning_automation_events_min_fields"
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  session_id?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["dunning_automation_events_status"]["output"]>
}

/** response of any mutation on the table "dunning_automation_events" */
export type Tickets_Dunning_Automation_Events_Mutation_Response = {
  __typename?: "tickets_dunning_automation_events_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Dunning_Automation_Events>
}

/** on_conflict condition type for table "dunning_automation_events" */
export type Tickets_Dunning_Automation_Events_On_Conflict = {
  constraint: Tickets_Dunning_Automation_Events_Constraint
  update_columns?: Array<Tickets_Dunning_Automation_Events_Update_Column>
  where?: InputMaybe<Tickets_Dunning_Automation_Events_Bool_Exp>
}

/** Ordering options when selecting data from "dunning_automation_events". */
export type Tickets_Dunning_Automation_Events_Order_By = {
  created_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  metadata?: InputMaybe<Order_By>
  session_id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
}

/** primary key columns input for table: dunning_automation_events */
export type Tickets_Dunning_Automation_Events_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "dunning_automation_events" */
export enum Tickets_Dunning_Automation_Events_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  Metadata = "metadata",
  /** column name */
  SessionId = "session_id",
  /** column name */
  Status = "status",
}

/** input type for updating data in table "dunning_automation_events" */
export type Tickets_Dunning_Automation_Events_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  metadata?: InputMaybe<Scalars["json"]["input"]>
  session_id?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["dunning_automation_events_status"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Dunning_Automation_Events_Stddev_Fields = {
  __typename?: "tickets_dunning_automation_events_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Dunning_Automation_Events_Stddev_Pop_Fields = {
  __typename?: "tickets_dunning_automation_events_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Dunning_Automation_Events_Stddev_Samp_Fields = {
  __typename?: "tickets_dunning_automation_events_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_dunning_automation_events" */
export type Tickets_Dunning_Automation_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Dunning_Automation_Events_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Dunning_Automation_Events_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  metadata?: InputMaybe<Scalars["json"]["input"]>
  session_id?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["dunning_automation_events_status"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_Dunning_Automation_Events_Sum_Fields = {
  __typename?: "tickets_dunning_automation_events_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "dunning_automation_events" */
export enum Tickets_Dunning_Automation_Events_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  Metadata = "metadata",
  /** column name */
  SessionId = "session_id",
  /** column name */
  Status = "status",
}

export type Tickets_Dunning_Automation_Events_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Dunning_Automation_Events_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Dunning_Automation_Events_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Dunning_Automation_Events_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Dunning_Automation_Events_Var_Pop_Fields = {
  __typename?: "tickets_dunning_automation_events_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Dunning_Automation_Events_Var_Samp_Fields = {
  __typename?: "tickets_dunning_automation_events_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Dunning_Automation_Events_Variance_Fields = {
  __typename?: "tickets_dunning_automation_events_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "dunning_debt_ticket_review_records" */
export type Tickets_Dunning_Debt_Ticket_Review_Records = {
  __typename?: "tickets_dunning_debt_ticket_review_records"
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  balance_plus_un_billed?: Maybe<Scalars["numeric"]["output"]>
  dunning_job_id: Scalars["bigint"]["output"]
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  status?: Maybe<Scalars["dunning_debt_ticket_review_status"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_next_step?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
}

/** aggregated selection of "dunning_debt_ticket_review_records" */
export type Tickets_Dunning_Debt_Ticket_Review_Records_Aggregate = {
  __typename?: "tickets_dunning_debt_ticket_review_records_aggregate"
  aggregate?: Maybe<Tickets_Dunning_Debt_Ticket_Review_Records_Aggregate_Fields>
  nodes: Array<Tickets_Dunning_Debt_Ticket_Review_Records>
}

/** aggregate fields of "dunning_debt_ticket_review_records" */
export type Tickets_Dunning_Debt_Ticket_Review_Records_Aggregate_Fields = {
  __typename?: "tickets_dunning_debt_ticket_review_records_aggregate_fields"
  avg?: Maybe<Tickets_Dunning_Debt_Ticket_Review_Records_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Dunning_Debt_Ticket_Review_Records_Max_Fields>
  min?: Maybe<Tickets_Dunning_Debt_Ticket_Review_Records_Min_Fields>
  stddev?: Maybe<Tickets_Dunning_Debt_Ticket_Review_Records_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Dunning_Debt_Ticket_Review_Records_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Dunning_Debt_Ticket_Review_Records_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Dunning_Debt_Ticket_Review_Records_Sum_Fields>
  var_pop?: Maybe<Tickets_Dunning_Debt_Ticket_Review_Records_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Dunning_Debt_Ticket_Review_Records_Var_Samp_Fields>
  variance?: Maybe<Tickets_Dunning_Debt_Ticket_Review_Records_Variance_Fields>
}

/** aggregate fields of "dunning_debt_ticket_review_records" */
export type Tickets_Dunning_Debt_Ticket_Review_Records_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Tickets_Dunning_Debt_Ticket_Review_Records_Select_Column>
    >
    distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  }

/** aggregate avg on columns */
export type Tickets_Dunning_Debt_Ticket_Review_Records_Avg_Fields = {
  __typename?: "tickets_dunning_debt_ticket_review_records_avg_fields"
  balance_plus_un_billed?: Maybe<Scalars["Float"]["output"]>
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "dunning_debt_ticket_review_records". All fields are combined with a logical 'AND'. */
export type Tickets_Dunning_Debt_Ticket_Review_Records_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Dunning_Debt_Ticket_Review_Records_Bool_Exp>>
  _not?: InputMaybe<Tickets_Dunning_Debt_Ticket_Review_Records_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Dunning_Debt_Ticket_Review_Records_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  account_status?: InputMaybe<String_Comparison_Exp>
  balance_plus_un_billed?: InputMaybe<Numeric_Comparison_Exp>
  dunning_job_id?: InputMaybe<Bigint_Comparison_Exp>
  failure_reason?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  status?: InputMaybe<Dunning_Debt_Ticket_Review_Status_Comparison_Exp>
  ticket_id?: InputMaybe<String_Comparison_Exp>
  ticket_next_step?: InputMaybe<String_Comparison_Exp>
  ticket_step?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "dunning_debt_ticket_review_records" */
export enum Tickets_Dunning_Debt_Ticket_Review_Records_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkDunningDebtTicketRecordsReport = "pk_dunning_debt_ticket_records_report",
}

/** input type for incrementing numeric columns in table "dunning_debt_ticket_review_records" */
export type Tickets_Dunning_Debt_Ticket_Review_Records_Inc_Input = {
  balance_plus_un_billed?: InputMaybe<Scalars["numeric"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "dunning_debt_ticket_review_records" */
export type Tickets_Dunning_Debt_Ticket_Review_Records_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  account_status?: InputMaybe<Scalars["String"]["input"]>
  balance_plus_un_billed?: InputMaybe<Scalars["numeric"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["dunning_debt_ticket_review_status"]["input"]>
  ticket_id?: InputMaybe<Scalars["String"]["input"]>
  ticket_next_step?: InputMaybe<Scalars["String"]["input"]>
  ticket_step?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Dunning_Debt_Ticket_Review_Records_Max_Fields = {
  __typename?: "tickets_dunning_debt_ticket_review_records_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  balance_plus_un_billed?: Maybe<Scalars["numeric"]["output"]>
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["dunning_debt_ticket_review_status"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_next_step?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Dunning_Debt_Ticket_Review_Records_Min_Fields = {
  __typename?: "tickets_dunning_debt_ticket_review_records_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  balance_plus_un_billed?: Maybe<Scalars["numeric"]["output"]>
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["dunning_debt_ticket_review_status"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_next_step?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "dunning_debt_ticket_review_records" */
export type Tickets_Dunning_Debt_Ticket_Review_Records_Mutation_Response = {
  __typename?: "tickets_dunning_debt_ticket_review_records_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Dunning_Debt_Ticket_Review_Records>
}

/** on_conflict condition type for table "dunning_debt_ticket_review_records" */
export type Tickets_Dunning_Debt_Ticket_Review_Records_On_Conflict = {
  constraint: Tickets_Dunning_Debt_Ticket_Review_Records_Constraint
  update_columns?: Array<Tickets_Dunning_Debt_Ticket_Review_Records_Update_Column>
  where?: InputMaybe<Tickets_Dunning_Debt_Ticket_Review_Records_Bool_Exp>
}

/** Ordering options when selecting data from "dunning_debt_ticket_review_records". */
export type Tickets_Dunning_Debt_Ticket_Review_Records_Order_By = {
  account_number?: InputMaybe<Order_By>
  account_status?: InputMaybe<Order_By>
  balance_plus_un_billed?: InputMaybe<Order_By>
  dunning_job_id?: InputMaybe<Order_By>
  failure_reason?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  ticket_id?: InputMaybe<Order_By>
  ticket_next_step?: InputMaybe<Order_By>
  ticket_step?: InputMaybe<Order_By>
}

/** primary key columns input for table: dunning_debt_ticket_review_records */
export type Tickets_Dunning_Debt_Ticket_Review_Records_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "dunning_debt_ticket_review_records" */
export enum Tickets_Dunning_Debt_Ticket_Review_Records_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AccountStatus = "account_status",
  /** column name */
  BalancePlusUnBilled = "balance_plus_un_billed",
  /** column name */
  DunningJobId = "dunning_job_id",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  TicketId = "ticket_id",
  /** column name */
  TicketNextStep = "ticket_next_step",
  /** column name */
  TicketStep = "ticket_step",
}

/** input type for updating data in table "dunning_debt_ticket_review_records" */
export type Tickets_Dunning_Debt_Ticket_Review_Records_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  account_status?: InputMaybe<Scalars["String"]["input"]>
  balance_plus_un_billed?: InputMaybe<Scalars["numeric"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["dunning_debt_ticket_review_status"]["input"]>
  ticket_id?: InputMaybe<Scalars["String"]["input"]>
  ticket_next_step?: InputMaybe<Scalars["String"]["input"]>
  ticket_step?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Dunning_Debt_Ticket_Review_Records_Stddev_Fields = {
  __typename?: "tickets_dunning_debt_ticket_review_records_stddev_fields"
  balance_plus_un_billed?: Maybe<Scalars["Float"]["output"]>
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Dunning_Debt_Ticket_Review_Records_Stddev_Pop_Fields = {
  __typename?: "tickets_dunning_debt_ticket_review_records_stddev_pop_fields"
  balance_plus_un_billed?: Maybe<Scalars["Float"]["output"]>
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Dunning_Debt_Ticket_Review_Records_Stddev_Samp_Fields = {
  __typename?: "tickets_dunning_debt_ticket_review_records_stddev_samp_fields"
  balance_plus_un_billed?: Maybe<Scalars["Float"]["output"]>
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_dunning_debt_ticket_review_records" */
export type Tickets_Dunning_Debt_Ticket_Review_Records_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Dunning_Debt_Ticket_Review_Records_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Dunning_Debt_Ticket_Review_Records_Stream_Cursor_Value_Input =
  {
    account_number?: InputMaybe<Scalars["String"]["input"]>
    account_status?: InputMaybe<Scalars["String"]["input"]>
    balance_plus_un_billed?: InputMaybe<Scalars["numeric"]["input"]>
    dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
    failure_reason?: InputMaybe<Scalars["String"]["input"]>
    id?: InputMaybe<Scalars["bigint"]["input"]>
    status?: InputMaybe<Scalars["dunning_debt_ticket_review_status"]["input"]>
    ticket_id?: InputMaybe<Scalars["String"]["input"]>
    ticket_next_step?: InputMaybe<Scalars["String"]["input"]>
    ticket_step?: InputMaybe<Scalars["String"]["input"]>
  }

/** aggregate sum on columns */
export type Tickets_Dunning_Debt_Ticket_Review_Records_Sum_Fields = {
  __typename?: "tickets_dunning_debt_ticket_review_records_sum_fields"
  balance_plus_un_billed?: Maybe<Scalars["numeric"]["output"]>
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "dunning_debt_ticket_review_records" */
export enum Tickets_Dunning_Debt_Ticket_Review_Records_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AccountStatus = "account_status",
  /** column name */
  BalancePlusUnBilled = "balance_plus_un_billed",
  /** column name */
  DunningJobId = "dunning_job_id",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  TicketId = "ticket_id",
  /** column name */
  TicketNextStep = "ticket_next_step",
  /** column name */
  TicketStep = "ticket_step",
}

export type Tickets_Dunning_Debt_Ticket_Review_Records_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Dunning_Debt_Ticket_Review_Records_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Dunning_Debt_Ticket_Review_Records_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Dunning_Debt_Ticket_Review_Records_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Dunning_Debt_Ticket_Review_Records_Var_Pop_Fields = {
  __typename?: "tickets_dunning_debt_ticket_review_records_var_pop_fields"
  balance_plus_un_billed?: Maybe<Scalars["Float"]["output"]>
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Dunning_Debt_Ticket_Review_Records_Var_Samp_Fields = {
  __typename?: "tickets_dunning_debt_ticket_review_records_var_samp_fields"
  balance_plus_un_billed?: Maybe<Scalars["Float"]["output"]>
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Dunning_Debt_Ticket_Review_Records_Variance_Fields = {
  __typename?: "tickets_dunning_debt_ticket_review_records_variance_fields"
  balance_plus_un_billed?: Maybe<Scalars["Float"]["output"]>
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "dunning_job" */
export type Tickets_Dunning_Job = {
  __typename?: "tickets_dunning_job"
  email_failure_message?: Maybe<Scalars["String"]["output"]>
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  email_status: Scalars["dunning_job_email_status"]["output"]
  ended_at?: Maybe<Scalars["timestamptz"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  started_at: Scalars["timestamptz"]["output"]
  status: Scalars["dunning_status_enum"]["output"]
  uuid: Scalars["String"]["output"]
}

/** aggregated selection of "dunning_job" */
export type Tickets_Dunning_Job_Aggregate = {
  __typename?: "tickets_dunning_job_aggregate"
  aggregate?: Maybe<Tickets_Dunning_Job_Aggregate_Fields>
  nodes: Array<Tickets_Dunning_Job>
}

/** aggregate fields of "dunning_job" */
export type Tickets_Dunning_Job_Aggregate_Fields = {
  __typename?: "tickets_dunning_job_aggregate_fields"
  avg?: Maybe<Tickets_Dunning_Job_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Dunning_Job_Max_Fields>
  min?: Maybe<Tickets_Dunning_Job_Min_Fields>
  stddev?: Maybe<Tickets_Dunning_Job_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Dunning_Job_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Dunning_Job_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Dunning_Job_Sum_Fields>
  var_pop?: Maybe<Tickets_Dunning_Job_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Dunning_Job_Var_Samp_Fields>
  variance?: Maybe<Tickets_Dunning_Job_Variance_Fields>
}

/** aggregate fields of "dunning_job" */
export type Tickets_Dunning_Job_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Dunning_Job_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_Dunning_Job_Avg_Fields = {
  __typename?: "tickets_dunning_job_avg_fields"
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "dunning_job". All fields are combined with a logical 'AND'. */
export type Tickets_Dunning_Job_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Dunning_Job_Bool_Exp>>
  _not?: InputMaybe<Tickets_Dunning_Job_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Dunning_Job_Bool_Exp>>
  email_failure_message?: InputMaybe<String_Comparison_Exp>
  email_message_id?: InputMaybe<Bigint_Comparison_Exp>
  email_status?: InputMaybe<Dunning_Job_Email_Status_Comparison_Exp>
  ended_at?: InputMaybe<Timestamptz_Comparison_Exp>
  failure_reason?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  started_at?: InputMaybe<Timestamptz_Comparison_Exp>
  status?: InputMaybe<Dunning_Status_Enum_Comparison_Exp>
  uuid?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "dunning_job" */
export enum Tickets_Dunning_Job_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkDunningJob = "pk_dunning_job",
}

/** input type for incrementing numeric columns in table "dunning_job" */
export type Tickets_Dunning_Job_Inc_Input = {
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "dunning_job" */
export type Tickets_Dunning_Job_Insert_Input = {
  email_failure_message?: InputMaybe<Scalars["String"]["input"]>
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  email_status?: InputMaybe<Scalars["dunning_job_email_status"]["input"]>
  ended_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  started_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  status?: InputMaybe<Scalars["dunning_status_enum"]["input"]>
  uuid?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Dunning_Job_Max_Fields = {
  __typename?: "tickets_dunning_job_max_fields"
  email_failure_message?: Maybe<Scalars["String"]["output"]>
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  email_status?: Maybe<Scalars["dunning_job_email_status"]["output"]>
  ended_at?: Maybe<Scalars["timestamptz"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  started_at?: Maybe<Scalars["timestamptz"]["output"]>
  status?: Maybe<Scalars["dunning_status_enum"]["output"]>
  uuid?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Dunning_Job_Min_Fields = {
  __typename?: "tickets_dunning_job_min_fields"
  email_failure_message?: Maybe<Scalars["String"]["output"]>
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  email_status?: Maybe<Scalars["dunning_job_email_status"]["output"]>
  ended_at?: Maybe<Scalars["timestamptz"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  started_at?: Maybe<Scalars["timestamptz"]["output"]>
  status?: Maybe<Scalars["dunning_status_enum"]["output"]>
  uuid?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "dunning_job" */
export type Tickets_Dunning_Job_Mutation_Response = {
  __typename?: "tickets_dunning_job_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Dunning_Job>
}

/** on_conflict condition type for table "dunning_job" */
export type Tickets_Dunning_Job_On_Conflict = {
  constraint: Tickets_Dunning_Job_Constraint
  update_columns?: Array<Tickets_Dunning_Job_Update_Column>
  where?: InputMaybe<Tickets_Dunning_Job_Bool_Exp>
}

/** Ordering options when selecting data from "dunning_job". */
export type Tickets_Dunning_Job_Order_By = {
  email_failure_message?: InputMaybe<Order_By>
  email_message_id?: InputMaybe<Order_By>
  email_status?: InputMaybe<Order_By>
  ended_at?: InputMaybe<Order_By>
  failure_reason?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  started_at?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  uuid?: InputMaybe<Order_By>
}

/** primary key columns input for table: dunning_job */
export type Tickets_Dunning_Job_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "dunning_job" */
export enum Tickets_Dunning_Job_Select_Column {
  /** column name */
  EmailFailureMessage = "email_failure_message",
  /** column name */
  EmailMessageId = "email_message_id",
  /** column name */
  EmailStatus = "email_status",
  /** column name */
  EndedAt = "ended_at",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  StartedAt = "started_at",
  /** column name */
  Status = "status",
  /** column name */
  Uuid = "uuid",
}

/** input type for updating data in table "dunning_job" */
export type Tickets_Dunning_Job_Set_Input = {
  email_failure_message?: InputMaybe<Scalars["String"]["input"]>
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  email_status?: InputMaybe<Scalars["dunning_job_email_status"]["input"]>
  ended_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  started_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  status?: InputMaybe<Scalars["dunning_status_enum"]["input"]>
  uuid?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Dunning_Job_Stddev_Fields = {
  __typename?: "tickets_dunning_job_stddev_fields"
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Dunning_Job_Stddev_Pop_Fields = {
  __typename?: "tickets_dunning_job_stddev_pop_fields"
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Dunning_Job_Stddev_Samp_Fields = {
  __typename?: "tickets_dunning_job_stddev_samp_fields"
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_dunning_job" */
export type Tickets_Dunning_Job_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Dunning_Job_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Dunning_Job_Stream_Cursor_Value_Input = {
  email_failure_message?: InputMaybe<Scalars["String"]["input"]>
  email_message_id?: InputMaybe<Scalars["bigint"]["input"]>
  email_status?: InputMaybe<Scalars["dunning_job_email_status"]["input"]>
  ended_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  started_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  status?: InputMaybe<Scalars["dunning_status_enum"]["input"]>
  uuid?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_Dunning_Job_Sum_Fields = {
  __typename?: "tickets_dunning_job_sum_fields"
  email_message_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "dunning_job" */
export enum Tickets_Dunning_Job_Update_Column {
  /** column name */
  EmailFailureMessage = "email_failure_message",
  /** column name */
  EmailMessageId = "email_message_id",
  /** column name */
  EmailStatus = "email_status",
  /** column name */
  EndedAt = "ended_at",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  StartedAt = "started_at",
  /** column name */
  Status = "status",
  /** column name */
  Uuid = "uuid",
}

export type Tickets_Dunning_Job_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Dunning_Job_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Dunning_Job_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Dunning_Job_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Dunning_Job_Var_Pop_Fields = {
  __typename?: "tickets_dunning_job_var_pop_fields"
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Dunning_Job_Var_Samp_Fields = {
  __typename?: "tickets_dunning_job_var_samp_fields"
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Dunning_Job_Variance_Fields = {
  __typename?: "tickets_dunning_job_variance_fields"
  email_message_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "dunning_legal_known_ticket_records" */
export type Tickets_Dunning_Legal_Known_Ticket_Records = {
  __typename?: "tickets_dunning_legal_known_ticket_records"
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  dd_status?: Maybe<Scalars["String"]["output"]>
  dunning_job_id: Scalars["bigint"]["output"]
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  status?: Maybe<Scalars["dunning_legal_known_review_status"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_is_last_step: Scalars["Boolean"]["output"]
  ticket_next_step?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
}

/** aggregated selection of "dunning_legal_known_ticket_records" */
export type Tickets_Dunning_Legal_Known_Ticket_Records_Aggregate = {
  __typename?: "tickets_dunning_legal_known_ticket_records_aggregate"
  aggregate?: Maybe<Tickets_Dunning_Legal_Known_Ticket_Records_Aggregate_Fields>
  nodes: Array<Tickets_Dunning_Legal_Known_Ticket_Records>
}

/** aggregate fields of "dunning_legal_known_ticket_records" */
export type Tickets_Dunning_Legal_Known_Ticket_Records_Aggregate_Fields = {
  __typename?: "tickets_dunning_legal_known_ticket_records_aggregate_fields"
  avg?: Maybe<Tickets_Dunning_Legal_Known_Ticket_Records_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Dunning_Legal_Known_Ticket_Records_Max_Fields>
  min?: Maybe<Tickets_Dunning_Legal_Known_Ticket_Records_Min_Fields>
  stddev?: Maybe<Tickets_Dunning_Legal_Known_Ticket_Records_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Dunning_Legal_Known_Ticket_Records_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Dunning_Legal_Known_Ticket_Records_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Dunning_Legal_Known_Ticket_Records_Sum_Fields>
  var_pop?: Maybe<Tickets_Dunning_Legal_Known_Ticket_Records_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Dunning_Legal_Known_Ticket_Records_Var_Samp_Fields>
  variance?: Maybe<Tickets_Dunning_Legal_Known_Ticket_Records_Variance_Fields>
}

/** aggregate fields of "dunning_legal_known_ticket_records" */
export type Tickets_Dunning_Legal_Known_Ticket_Records_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Tickets_Dunning_Legal_Known_Ticket_Records_Select_Column>
    >
    distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  }

/** aggregate avg on columns */
export type Tickets_Dunning_Legal_Known_Ticket_Records_Avg_Fields = {
  __typename?: "tickets_dunning_legal_known_ticket_records_avg_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "dunning_legal_known_ticket_records". All fields are combined with a logical 'AND'. */
export type Tickets_Dunning_Legal_Known_Ticket_Records_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Dunning_Legal_Known_Ticket_Records_Bool_Exp>>
  _not?: InputMaybe<Tickets_Dunning_Legal_Known_Ticket_Records_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Dunning_Legal_Known_Ticket_Records_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  account_status?: InputMaybe<String_Comparison_Exp>
  dd_status?: InputMaybe<String_Comparison_Exp>
  dunning_job_id?: InputMaybe<Bigint_Comparison_Exp>
  failure_reason?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  status?: InputMaybe<Dunning_Legal_Known_Review_Status_Comparison_Exp>
  ticket_id?: InputMaybe<String_Comparison_Exp>
  ticket_is_last_step?: InputMaybe<Boolean_Comparison_Exp>
  ticket_next_step?: InputMaybe<String_Comparison_Exp>
  ticket_step?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "dunning_legal_known_ticket_records" */
export enum Tickets_Dunning_Legal_Known_Ticket_Records_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkDunningLegalKnownTicketRecords = "pk_dunning_legal_known_ticket_records",
}

/** input type for incrementing numeric columns in table "dunning_legal_known_ticket_records" */
export type Tickets_Dunning_Legal_Known_Ticket_Records_Inc_Input = {
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "dunning_legal_known_ticket_records" */
export type Tickets_Dunning_Legal_Known_Ticket_Records_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  account_status?: InputMaybe<Scalars["String"]["input"]>
  dd_status?: InputMaybe<Scalars["String"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["dunning_legal_known_review_status"]["input"]>
  ticket_id?: InputMaybe<Scalars["String"]["input"]>
  ticket_is_last_step?: InputMaybe<Scalars["Boolean"]["input"]>
  ticket_next_step?: InputMaybe<Scalars["String"]["input"]>
  ticket_step?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Dunning_Legal_Known_Ticket_Records_Max_Fields = {
  __typename?: "tickets_dunning_legal_known_ticket_records_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  dd_status?: Maybe<Scalars["String"]["output"]>
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["dunning_legal_known_review_status"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_next_step?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Dunning_Legal_Known_Ticket_Records_Min_Fields = {
  __typename?: "tickets_dunning_legal_known_ticket_records_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  dd_status?: Maybe<Scalars["String"]["output"]>
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["dunning_legal_known_review_status"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_next_step?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "dunning_legal_known_ticket_records" */
export type Tickets_Dunning_Legal_Known_Ticket_Records_Mutation_Response = {
  __typename?: "tickets_dunning_legal_known_ticket_records_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Dunning_Legal_Known_Ticket_Records>
}

/** on_conflict condition type for table "dunning_legal_known_ticket_records" */
export type Tickets_Dunning_Legal_Known_Ticket_Records_On_Conflict = {
  constraint: Tickets_Dunning_Legal_Known_Ticket_Records_Constraint
  update_columns?: Array<Tickets_Dunning_Legal_Known_Ticket_Records_Update_Column>
  where?: InputMaybe<Tickets_Dunning_Legal_Known_Ticket_Records_Bool_Exp>
}

/** Ordering options when selecting data from "dunning_legal_known_ticket_records". */
export type Tickets_Dunning_Legal_Known_Ticket_Records_Order_By = {
  account_number?: InputMaybe<Order_By>
  account_status?: InputMaybe<Order_By>
  dd_status?: InputMaybe<Order_By>
  dunning_job_id?: InputMaybe<Order_By>
  failure_reason?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  ticket_id?: InputMaybe<Order_By>
  ticket_is_last_step?: InputMaybe<Order_By>
  ticket_next_step?: InputMaybe<Order_By>
  ticket_step?: InputMaybe<Order_By>
}

/** primary key columns input for table: dunning_legal_known_ticket_records */
export type Tickets_Dunning_Legal_Known_Ticket_Records_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "dunning_legal_known_ticket_records" */
export enum Tickets_Dunning_Legal_Known_Ticket_Records_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AccountStatus = "account_status",
  /** column name */
  DdStatus = "dd_status",
  /** column name */
  DunningJobId = "dunning_job_id",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  TicketId = "ticket_id",
  /** column name */
  TicketIsLastStep = "ticket_is_last_step",
  /** column name */
  TicketNextStep = "ticket_next_step",
  /** column name */
  TicketStep = "ticket_step",
}

/** input type for updating data in table "dunning_legal_known_ticket_records" */
export type Tickets_Dunning_Legal_Known_Ticket_Records_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  account_status?: InputMaybe<Scalars["String"]["input"]>
  dd_status?: InputMaybe<Scalars["String"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["dunning_legal_known_review_status"]["input"]>
  ticket_id?: InputMaybe<Scalars["String"]["input"]>
  ticket_is_last_step?: InputMaybe<Scalars["Boolean"]["input"]>
  ticket_next_step?: InputMaybe<Scalars["String"]["input"]>
  ticket_step?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Dunning_Legal_Known_Ticket_Records_Stddev_Fields = {
  __typename?: "tickets_dunning_legal_known_ticket_records_stddev_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Dunning_Legal_Known_Ticket_Records_Stddev_Pop_Fields = {
  __typename?: "tickets_dunning_legal_known_ticket_records_stddev_pop_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Dunning_Legal_Known_Ticket_Records_Stddev_Samp_Fields = {
  __typename?: "tickets_dunning_legal_known_ticket_records_stddev_samp_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_dunning_legal_known_ticket_records" */
export type Tickets_Dunning_Legal_Known_Ticket_Records_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Dunning_Legal_Known_Ticket_Records_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Dunning_Legal_Known_Ticket_Records_Stream_Cursor_Value_Input =
  {
    account_number?: InputMaybe<Scalars["String"]["input"]>
    account_status?: InputMaybe<Scalars["String"]["input"]>
    dd_status?: InputMaybe<Scalars["String"]["input"]>
    dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
    failure_reason?: InputMaybe<Scalars["String"]["input"]>
    id?: InputMaybe<Scalars["bigint"]["input"]>
    status?: InputMaybe<Scalars["dunning_legal_known_review_status"]["input"]>
    ticket_id?: InputMaybe<Scalars["String"]["input"]>
    ticket_is_last_step?: InputMaybe<Scalars["Boolean"]["input"]>
    ticket_next_step?: InputMaybe<Scalars["String"]["input"]>
    ticket_step?: InputMaybe<Scalars["String"]["input"]>
  }

/** aggregate sum on columns */
export type Tickets_Dunning_Legal_Known_Ticket_Records_Sum_Fields = {
  __typename?: "tickets_dunning_legal_known_ticket_records_sum_fields"
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "dunning_legal_known_ticket_records" */
export enum Tickets_Dunning_Legal_Known_Ticket_Records_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AccountStatus = "account_status",
  /** column name */
  DdStatus = "dd_status",
  /** column name */
  DunningJobId = "dunning_job_id",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  TicketId = "ticket_id",
  /** column name */
  TicketIsLastStep = "ticket_is_last_step",
  /** column name */
  TicketNextStep = "ticket_next_step",
  /** column name */
  TicketStep = "ticket_step",
}

export type Tickets_Dunning_Legal_Known_Ticket_Records_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Dunning_Legal_Known_Ticket_Records_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Dunning_Legal_Known_Ticket_Records_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Dunning_Legal_Known_Ticket_Records_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Dunning_Legal_Known_Ticket_Records_Var_Pop_Fields = {
  __typename?: "tickets_dunning_legal_known_ticket_records_var_pop_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Dunning_Legal_Known_Ticket_Records_Var_Samp_Fields = {
  __typename?: "tickets_dunning_legal_known_ticket_records_var_samp_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Dunning_Legal_Known_Ticket_Records_Variance_Fields = {
  __typename?: "tickets_dunning_legal_known_ticket_records_variance_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "dunning_legal_occupier_ticket_records" */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records = {
  __typename?: "tickets_dunning_legal_occupier_ticket_records"
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  dd_status?: Maybe<Scalars["String"]["output"]>
  dunning_job_id: Scalars["bigint"]["output"]
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  status?: Maybe<Scalars["dunning_legal_occupier_review_status"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_is_last_step: Scalars["Boolean"]["output"]
  ticket_next_step?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
}

/** aggregated selection of "dunning_legal_occupier_ticket_records" */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records_Aggregate = {
  __typename?: "tickets_dunning_legal_occupier_ticket_records_aggregate"
  aggregate?: Maybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Aggregate_Fields>
  nodes: Array<Tickets_Dunning_Legal_Occupier_Ticket_Records>
}

/** aggregate fields of "dunning_legal_occupier_ticket_records" */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records_Aggregate_Fields = {
  __typename?: "tickets_dunning_legal_occupier_ticket_records_aggregate_fields"
  avg?: Maybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Max_Fields>
  min?: Maybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Min_Fields>
  stddev?: Maybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Sum_Fields>
  var_pop?: Maybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Var_Samp_Fields>
  variance?: Maybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Variance_Fields>
}

/** aggregate fields of "dunning_legal_occupier_ticket_records" */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Tickets_Dunning_Legal_Occupier_Ticket_Records_Select_Column>
    >
    distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  }

/** aggregate avg on columns */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records_Avg_Fields = {
  __typename?: "tickets_dunning_legal_occupier_ticket_records_avg_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "dunning_legal_occupier_ticket_records". All fields are combined with a logical 'AND'. */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records_Bool_Exp = {
  _and?: InputMaybe<
    Array<Tickets_Dunning_Legal_Occupier_Ticket_Records_Bool_Exp>
  >
  _not?: InputMaybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Bool_Exp>
  _or?: InputMaybe<
    Array<Tickets_Dunning_Legal_Occupier_Ticket_Records_Bool_Exp>
  >
  account_number?: InputMaybe<String_Comparison_Exp>
  account_status?: InputMaybe<String_Comparison_Exp>
  dd_status?: InputMaybe<String_Comparison_Exp>
  dunning_job_id?: InputMaybe<Bigint_Comparison_Exp>
  failure_reason?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  status?: InputMaybe<Dunning_Legal_Occupier_Review_Status_Comparison_Exp>
  ticket_id?: InputMaybe<String_Comparison_Exp>
  ticket_is_last_step?: InputMaybe<Boolean_Comparison_Exp>
  ticket_next_step?: InputMaybe<String_Comparison_Exp>
  ticket_step?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "dunning_legal_occupier_ticket_records" */
export enum Tickets_Dunning_Legal_Occupier_Ticket_Records_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkDunningLegalOccupierTicketRecords = "pk_dunning_legal_occupier_ticket_records",
}

/** input type for incrementing numeric columns in table "dunning_legal_occupier_ticket_records" */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records_Inc_Input = {
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "dunning_legal_occupier_ticket_records" */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  account_status?: InputMaybe<Scalars["String"]["input"]>
  dd_status?: InputMaybe<Scalars["String"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["dunning_legal_occupier_review_status"]["input"]>
  ticket_id?: InputMaybe<Scalars["String"]["input"]>
  ticket_is_last_step?: InputMaybe<Scalars["Boolean"]["input"]>
  ticket_next_step?: InputMaybe<Scalars["String"]["input"]>
  ticket_step?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records_Max_Fields = {
  __typename?: "tickets_dunning_legal_occupier_ticket_records_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  dd_status?: Maybe<Scalars["String"]["output"]>
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["dunning_legal_occupier_review_status"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_next_step?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records_Min_Fields = {
  __typename?: "tickets_dunning_legal_occupier_ticket_records_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  dd_status?: Maybe<Scalars["String"]["output"]>
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["dunning_legal_occupier_review_status"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_next_step?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "dunning_legal_occupier_ticket_records" */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records_Mutation_Response = {
  __typename?: "tickets_dunning_legal_occupier_ticket_records_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Dunning_Legal_Occupier_Ticket_Records>
}

/** on_conflict condition type for table "dunning_legal_occupier_ticket_records" */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records_On_Conflict = {
  constraint: Tickets_Dunning_Legal_Occupier_Ticket_Records_Constraint
  update_columns?: Array<Tickets_Dunning_Legal_Occupier_Ticket_Records_Update_Column>
  where?: InputMaybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Bool_Exp>
}

/** Ordering options when selecting data from "dunning_legal_occupier_ticket_records". */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records_Order_By = {
  account_number?: InputMaybe<Order_By>
  account_status?: InputMaybe<Order_By>
  dd_status?: InputMaybe<Order_By>
  dunning_job_id?: InputMaybe<Order_By>
  failure_reason?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  ticket_id?: InputMaybe<Order_By>
  ticket_is_last_step?: InputMaybe<Order_By>
  ticket_next_step?: InputMaybe<Order_By>
  ticket_step?: InputMaybe<Order_By>
}

/** primary key columns input for table: dunning_legal_occupier_ticket_records */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "dunning_legal_occupier_ticket_records" */
export enum Tickets_Dunning_Legal_Occupier_Ticket_Records_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AccountStatus = "account_status",
  /** column name */
  DdStatus = "dd_status",
  /** column name */
  DunningJobId = "dunning_job_id",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  TicketId = "ticket_id",
  /** column name */
  TicketIsLastStep = "ticket_is_last_step",
  /** column name */
  TicketNextStep = "ticket_next_step",
  /** column name */
  TicketStep = "ticket_step",
}

/** input type for updating data in table "dunning_legal_occupier_ticket_records" */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  account_status?: InputMaybe<Scalars["String"]["input"]>
  dd_status?: InputMaybe<Scalars["String"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["dunning_legal_occupier_review_status"]["input"]>
  ticket_id?: InputMaybe<Scalars["String"]["input"]>
  ticket_is_last_step?: InputMaybe<Scalars["Boolean"]["input"]>
  ticket_next_step?: InputMaybe<Scalars["String"]["input"]>
  ticket_step?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records_Stddev_Fields = {
  __typename?: "tickets_dunning_legal_occupier_ticket_records_stddev_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records_Stddev_Pop_Fields = {
  __typename?: "tickets_dunning_legal_occupier_ticket_records_stddev_pop_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records_Stddev_Samp_Fields = {
  __typename?: "tickets_dunning_legal_occupier_ticket_records_stddev_samp_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_dunning_legal_occupier_ticket_records" */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records_Stream_Cursor_Input =
  {
    /** Stream column input with initial value */
    initial_value: Tickets_Dunning_Legal_Occupier_Ticket_Records_Stream_Cursor_Value_Input
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>
  }

/** Initial value of the column from where the streaming should start */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records_Stream_Cursor_Value_Input =
  {
    account_number?: InputMaybe<Scalars["String"]["input"]>
    account_status?: InputMaybe<Scalars["String"]["input"]>
    dd_status?: InputMaybe<Scalars["String"]["input"]>
    dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
    failure_reason?: InputMaybe<Scalars["String"]["input"]>
    id?: InputMaybe<Scalars["bigint"]["input"]>
    status?: InputMaybe<
      Scalars["dunning_legal_occupier_review_status"]["input"]
    >
    ticket_id?: InputMaybe<Scalars["String"]["input"]>
    ticket_is_last_step?: InputMaybe<Scalars["Boolean"]["input"]>
    ticket_next_step?: InputMaybe<Scalars["String"]["input"]>
    ticket_step?: InputMaybe<Scalars["String"]["input"]>
  }

/** aggregate sum on columns */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records_Sum_Fields = {
  __typename?: "tickets_dunning_legal_occupier_ticket_records_sum_fields"
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "dunning_legal_occupier_ticket_records" */
export enum Tickets_Dunning_Legal_Occupier_Ticket_Records_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AccountStatus = "account_status",
  /** column name */
  DdStatus = "dd_status",
  /** column name */
  DunningJobId = "dunning_job_id",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  TicketId = "ticket_id",
  /** column name */
  TicketIsLastStep = "ticket_is_last_step",
  /** column name */
  TicketNextStep = "ticket_next_step",
  /** column name */
  TicketStep = "ticket_step",
}

export type Tickets_Dunning_Legal_Occupier_Ticket_Records_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Dunning_Legal_Occupier_Ticket_Records_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Dunning_Legal_Occupier_Ticket_Records_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records_Var_Pop_Fields = {
  __typename?: "tickets_dunning_legal_occupier_ticket_records_var_pop_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records_Var_Samp_Fields = {
  __typename?: "tickets_dunning_legal_occupier_ticket_records_var_samp_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Dunning_Legal_Occupier_Ticket_Records_Variance_Fields = {
  __typename?: "tickets_dunning_legal_occupier_ticket_records_variance_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "dunning_occupier_accounts_review_records" */
export type Tickets_Dunning_Occupier_Accounts_Review_Records = {
  __typename?: "tickets_dunning_occupier_accounts_review_records"
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  dd_status?: Maybe<Scalars["String"]["output"]>
  dunning_job_id: Scalars["bigint"]["output"]
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  status?: Maybe<Scalars["dunning_occupier_accounts_review_status"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_next_step?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
}

/** aggregated selection of "dunning_occupier_accounts_review_records" */
export type Tickets_Dunning_Occupier_Accounts_Review_Records_Aggregate = {
  __typename?: "tickets_dunning_occupier_accounts_review_records_aggregate"
  aggregate?: Maybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Aggregate_Fields>
  nodes: Array<Tickets_Dunning_Occupier_Accounts_Review_Records>
}

/** aggregate fields of "dunning_occupier_accounts_review_records" */
export type Tickets_Dunning_Occupier_Accounts_Review_Records_Aggregate_Fields =
  {
    __typename?: "tickets_dunning_occupier_accounts_review_records_aggregate_fields"
    avg?: Maybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Avg_Fields>
    count: Scalars["Int"]["output"]
    max?: Maybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Max_Fields>
    min?: Maybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Min_Fields>
    stddev?: Maybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Stddev_Fields>
    stddev_pop?: Maybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Stddev_Pop_Fields>
    stddev_samp?: Maybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Stddev_Samp_Fields>
    sum?: Maybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Sum_Fields>
    var_pop?: Maybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Var_Pop_Fields>
    var_samp?: Maybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Var_Samp_Fields>
    variance?: Maybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Variance_Fields>
  }

/** aggregate fields of "dunning_occupier_accounts_review_records" */
export type Tickets_Dunning_Occupier_Accounts_Review_Records_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Tickets_Dunning_Occupier_Accounts_Review_Records_Select_Column>
    >
    distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  }

/** aggregate avg on columns */
export type Tickets_Dunning_Occupier_Accounts_Review_Records_Avg_Fields = {
  __typename?: "tickets_dunning_occupier_accounts_review_records_avg_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "dunning_occupier_accounts_review_records". All fields are combined with a logical 'AND'. */
export type Tickets_Dunning_Occupier_Accounts_Review_Records_Bool_Exp = {
  _and?: InputMaybe<
    Array<Tickets_Dunning_Occupier_Accounts_Review_Records_Bool_Exp>
  >
  _not?: InputMaybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Bool_Exp>
  _or?: InputMaybe<
    Array<Tickets_Dunning_Occupier_Accounts_Review_Records_Bool_Exp>
  >
  account_number?: InputMaybe<String_Comparison_Exp>
  account_status?: InputMaybe<String_Comparison_Exp>
  dd_status?: InputMaybe<String_Comparison_Exp>
  dunning_job_id?: InputMaybe<Bigint_Comparison_Exp>
  failure_reason?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  status?: InputMaybe<Dunning_Occupier_Accounts_Review_Status_Comparison_Exp>
  ticket_id?: InputMaybe<String_Comparison_Exp>
  ticket_next_step?: InputMaybe<String_Comparison_Exp>
  ticket_step?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "dunning_occupier_accounts_review_records" */
export enum Tickets_Dunning_Occupier_Accounts_Review_Records_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkDunningOccupierAccountsReviewRecords = "pk_dunning_occupier_accounts_review_records",
}

/** input type for incrementing numeric columns in table "dunning_occupier_accounts_review_records" */
export type Tickets_Dunning_Occupier_Accounts_Review_Records_Inc_Input = {
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "dunning_occupier_accounts_review_records" */
export type Tickets_Dunning_Occupier_Accounts_Review_Records_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  account_status?: InputMaybe<Scalars["String"]["input"]>
  dd_status?: InputMaybe<Scalars["String"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<
    Scalars["dunning_occupier_accounts_review_status"]["input"]
  >
  ticket_id?: InputMaybe<Scalars["String"]["input"]>
  ticket_next_step?: InputMaybe<Scalars["String"]["input"]>
  ticket_step?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Dunning_Occupier_Accounts_Review_Records_Max_Fields = {
  __typename?: "tickets_dunning_occupier_accounts_review_records_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  dd_status?: Maybe<Scalars["String"]["output"]>
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["dunning_occupier_accounts_review_status"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_next_step?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Dunning_Occupier_Accounts_Review_Records_Min_Fields = {
  __typename?: "tickets_dunning_occupier_accounts_review_records_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  dd_status?: Maybe<Scalars["String"]["output"]>
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["dunning_occupier_accounts_review_status"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_next_step?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "dunning_occupier_accounts_review_records" */
export type Tickets_Dunning_Occupier_Accounts_Review_Records_Mutation_Response =
  {
    __typename?: "tickets_dunning_occupier_accounts_review_records_mutation_response"
    /** number of rows affected by the mutation */
    affected_rows: Scalars["Int"]["output"]
    /** data from the rows affected by the mutation */
    returning: Array<Tickets_Dunning_Occupier_Accounts_Review_Records>
  }

/** on_conflict condition type for table "dunning_occupier_accounts_review_records" */
export type Tickets_Dunning_Occupier_Accounts_Review_Records_On_Conflict = {
  constraint: Tickets_Dunning_Occupier_Accounts_Review_Records_Constraint
  update_columns?: Array<Tickets_Dunning_Occupier_Accounts_Review_Records_Update_Column>
  where?: InputMaybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Bool_Exp>
}

/** Ordering options when selecting data from "dunning_occupier_accounts_review_records". */
export type Tickets_Dunning_Occupier_Accounts_Review_Records_Order_By = {
  account_number?: InputMaybe<Order_By>
  account_status?: InputMaybe<Order_By>
  dd_status?: InputMaybe<Order_By>
  dunning_job_id?: InputMaybe<Order_By>
  failure_reason?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  ticket_id?: InputMaybe<Order_By>
  ticket_next_step?: InputMaybe<Order_By>
  ticket_step?: InputMaybe<Order_By>
}

/** primary key columns input for table: dunning_occupier_accounts_review_records */
export type Tickets_Dunning_Occupier_Accounts_Review_Records_Pk_Columns_Input =
  {
    id: Scalars["bigint"]["input"]
  }

/** select columns of table "dunning_occupier_accounts_review_records" */
export enum Tickets_Dunning_Occupier_Accounts_Review_Records_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AccountStatus = "account_status",
  /** column name */
  DdStatus = "dd_status",
  /** column name */
  DunningJobId = "dunning_job_id",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  TicketId = "ticket_id",
  /** column name */
  TicketNextStep = "ticket_next_step",
  /** column name */
  TicketStep = "ticket_step",
}

/** input type for updating data in table "dunning_occupier_accounts_review_records" */
export type Tickets_Dunning_Occupier_Accounts_Review_Records_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  account_status?: InputMaybe<Scalars["String"]["input"]>
  dd_status?: InputMaybe<Scalars["String"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<
    Scalars["dunning_occupier_accounts_review_status"]["input"]
  >
  ticket_id?: InputMaybe<Scalars["String"]["input"]>
  ticket_next_step?: InputMaybe<Scalars["String"]["input"]>
  ticket_step?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Dunning_Occupier_Accounts_Review_Records_Stddev_Fields = {
  __typename?: "tickets_dunning_occupier_accounts_review_records_stddev_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Dunning_Occupier_Accounts_Review_Records_Stddev_Pop_Fields =
  {
    __typename?: "tickets_dunning_occupier_accounts_review_records_stddev_pop_fields"
    dunning_job_id?: Maybe<Scalars["Float"]["output"]>
    id?: Maybe<Scalars["Float"]["output"]>
  }

/** aggregate stddev_samp on columns */
export type Tickets_Dunning_Occupier_Accounts_Review_Records_Stddev_Samp_Fields =
  {
    __typename?: "tickets_dunning_occupier_accounts_review_records_stddev_samp_fields"
    dunning_job_id?: Maybe<Scalars["Float"]["output"]>
    id?: Maybe<Scalars["Float"]["output"]>
  }

/** Streaming cursor of the table "tickets_dunning_occupier_accounts_review_records" */
export type Tickets_Dunning_Occupier_Accounts_Review_Records_Stream_Cursor_Input =
  {
    /** Stream column input with initial value */
    initial_value: Tickets_Dunning_Occupier_Accounts_Review_Records_Stream_Cursor_Value_Input
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>
  }

/** Initial value of the column from where the streaming should start */
export type Tickets_Dunning_Occupier_Accounts_Review_Records_Stream_Cursor_Value_Input =
  {
    account_number?: InputMaybe<Scalars["String"]["input"]>
    account_status?: InputMaybe<Scalars["String"]["input"]>
    dd_status?: InputMaybe<Scalars["String"]["input"]>
    dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
    failure_reason?: InputMaybe<Scalars["String"]["input"]>
    id?: InputMaybe<Scalars["bigint"]["input"]>
    status?: InputMaybe<
      Scalars["dunning_occupier_accounts_review_status"]["input"]
    >
    ticket_id?: InputMaybe<Scalars["String"]["input"]>
    ticket_next_step?: InputMaybe<Scalars["String"]["input"]>
    ticket_step?: InputMaybe<Scalars["String"]["input"]>
  }

/** aggregate sum on columns */
export type Tickets_Dunning_Occupier_Accounts_Review_Records_Sum_Fields = {
  __typename?: "tickets_dunning_occupier_accounts_review_records_sum_fields"
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "dunning_occupier_accounts_review_records" */
export enum Tickets_Dunning_Occupier_Accounts_Review_Records_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AccountStatus = "account_status",
  /** column name */
  DdStatus = "dd_status",
  /** column name */
  DunningJobId = "dunning_job_id",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  TicketId = "ticket_id",
  /** column name */
  TicketNextStep = "ticket_next_step",
  /** column name */
  TicketStep = "ticket_step",
}

export type Tickets_Dunning_Occupier_Accounts_Review_Records_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Dunning_Occupier_Accounts_Review_Records_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Dunning_Occupier_Accounts_Review_Records_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Dunning_Occupier_Accounts_Review_Records_Var_Pop_Fields = {
  __typename?: "tickets_dunning_occupier_accounts_review_records_var_pop_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Dunning_Occupier_Accounts_Review_Records_Var_Samp_Fields = {
  __typename?: "tickets_dunning_occupier_accounts_review_records_var_samp_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Dunning_Occupier_Accounts_Review_Records_Variance_Fields = {
  __typename?: "tickets_dunning_occupier_accounts_review_records_variance_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "dunning_purge_job" */
export type Tickets_Dunning_Purge_Job = {
  __typename?: "tickets_dunning_purge_job"
  accounts_deleted?: Maybe<Scalars["bigint"]["output"]>
  completed_at?: Maybe<Scalars["timestamptz"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  started_at: Scalars["timestamptz"]["output"]
  status: Scalars["dunning_purge_status_enum"]["output"]
  tickets_deleted?: Maybe<Scalars["bigint"]["output"]>
  uuid: Scalars["String"]["output"]
}

/** aggregated selection of "dunning_purge_job" */
export type Tickets_Dunning_Purge_Job_Aggregate = {
  __typename?: "tickets_dunning_purge_job_aggregate"
  aggregate?: Maybe<Tickets_Dunning_Purge_Job_Aggregate_Fields>
  nodes: Array<Tickets_Dunning_Purge_Job>
}

/** aggregate fields of "dunning_purge_job" */
export type Tickets_Dunning_Purge_Job_Aggregate_Fields = {
  __typename?: "tickets_dunning_purge_job_aggregate_fields"
  avg?: Maybe<Tickets_Dunning_Purge_Job_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Dunning_Purge_Job_Max_Fields>
  min?: Maybe<Tickets_Dunning_Purge_Job_Min_Fields>
  stddev?: Maybe<Tickets_Dunning_Purge_Job_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Dunning_Purge_Job_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Dunning_Purge_Job_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Dunning_Purge_Job_Sum_Fields>
  var_pop?: Maybe<Tickets_Dunning_Purge_Job_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Dunning_Purge_Job_Var_Samp_Fields>
  variance?: Maybe<Tickets_Dunning_Purge_Job_Variance_Fields>
}

/** aggregate fields of "dunning_purge_job" */
export type Tickets_Dunning_Purge_Job_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Dunning_Purge_Job_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_Dunning_Purge_Job_Avg_Fields = {
  __typename?: "tickets_dunning_purge_job_avg_fields"
  accounts_deleted?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  tickets_deleted?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "dunning_purge_job". All fields are combined with a logical 'AND'. */
export type Tickets_Dunning_Purge_Job_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Dunning_Purge_Job_Bool_Exp>>
  _not?: InputMaybe<Tickets_Dunning_Purge_Job_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Dunning_Purge_Job_Bool_Exp>>
  accounts_deleted?: InputMaybe<Bigint_Comparison_Exp>
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>
  failure_reason?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  started_at?: InputMaybe<Timestamptz_Comparison_Exp>
  status?: InputMaybe<Dunning_Purge_Status_Enum_Comparison_Exp>
  tickets_deleted?: InputMaybe<Bigint_Comparison_Exp>
  uuid?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "dunning_purge_job" */
export enum Tickets_Dunning_Purge_Job_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkDunningPurgeJob = "pk_dunning_purge_job",
}

/** input type for incrementing numeric columns in table "dunning_purge_job" */
export type Tickets_Dunning_Purge_Job_Inc_Input = {
  accounts_deleted?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  tickets_deleted?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "dunning_purge_job" */
export type Tickets_Dunning_Purge_Job_Insert_Input = {
  accounts_deleted?: InputMaybe<Scalars["bigint"]["input"]>
  completed_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  started_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  status?: InputMaybe<Scalars["dunning_purge_status_enum"]["input"]>
  tickets_deleted?: InputMaybe<Scalars["bigint"]["input"]>
  uuid?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Dunning_Purge_Job_Max_Fields = {
  __typename?: "tickets_dunning_purge_job_max_fields"
  accounts_deleted?: Maybe<Scalars["bigint"]["output"]>
  completed_at?: Maybe<Scalars["timestamptz"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  started_at?: Maybe<Scalars["timestamptz"]["output"]>
  status?: Maybe<Scalars["dunning_purge_status_enum"]["output"]>
  tickets_deleted?: Maybe<Scalars["bigint"]["output"]>
  uuid?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Dunning_Purge_Job_Min_Fields = {
  __typename?: "tickets_dunning_purge_job_min_fields"
  accounts_deleted?: Maybe<Scalars["bigint"]["output"]>
  completed_at?: Maybe<Scalars["timestamptz"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  started_at?: Maybe<Scalars["timestamptz"]["output"]>
  status?: Maybe<Scalars["dunning_purge_status_enum"]["output"]>
  tickets_deleted?: Maybe<Scalars["bigint"]["output"]>
  uuid?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "dunning_purge_job" */
export type Tickets_Dunning_Purge_Job_Mutation_Response = {
  __typename?: "tickets_dunning_purge_job_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Dunning_Purge_Job>
}

/** on_conflict condition type for table "dunning_purge_job" */
export type Tickets_Dunning_Purge_Job_On_Conflict = {
  constraint: Tickets_Dunning_Purge_Job_Constraint
  update_columns?: Array<Tickets_Dunning_Purge_Job_Update_Column>
  where?: InputMaybe<Tickets_Dunning_Purge_Job_Bool_Exp>
}

/** Ordering options when selecting data from "dunning_purge_job". */
export type Tickets_Dunning_Purge_Job_Order_By = {
  accounts_deleted?: InputMaybe<Order_By>
  completed_at?: InputMaybe<Order_By>
  failure_reason?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  started_at?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  tickets_deleted?: InputMaybe<Order_By>
  uuid?: InputMaybe<Order_By>
}

/** primary key columns input for table: dunning_purge_job */
export type Tickets_Dunning_Purge_Job_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "dunning_purge_job" */
export enum Tickets_Dunning_Purge_Job_Select_Column {
  /** column name */
  AccountsDeleted = "accounts_deleted",
  /** column name */
  CompletedAt = "completed_at",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  StartedAt = "started_at",
  /** column name */
  Status = "status",
  /** column name */
  TicketsDeleted = "tickets_deleted",
  /** column name */
  Uuid = "uuid",
}

/** input type for updating data in table "dunning_purge_job" */
export type Tickets_Dunning_Purge_Job_Set_Input = {
  accounts_deleted?: InputMaybe<Scalars["bigint"]["input"]>
  completed_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  started_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  status?: InputMaybe<Scalars["dunning_purge_status_enum"]["input"]>
  tickets_deleted?: InputMaybe<Scalars["bigint"]["input"]>
  uuid?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Dunning_Purge_Job_Stddev_Fields = {
  __typename?: "tickets_dunning_purge_job_stddev_fields"
  accounts_deleted?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  tickets_deleted?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Dunning_Purge_Job_Stddev_Pop_Fields = {
  __typename?: "tickets_dunning_purge_job_stddev_pop_fields"
  accounts_deleted?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  tickets_deleted?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Dunning_Purge_Job_Stddev_Samp_Fields = {
  __typename?: "tickets_dunning_purge_job_stddev_samp_fields"
  accounts_deleted?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  tickets_deleted?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_dunning_purge_job" */
export type Tickets_Dunning_Purge_Job_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Dunning_Purge_Job_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Dunning_Purge_Job_Stream_Cursor_Value_Input = {
  accounts_deleted?: InputMaybe<Scalars["bigint"]["input"]>
  completed_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  started_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  status?: InputMaybe<Scalars["dunning_purge_status_enum"]["input"]>
  tickets_deleted?: InputMaybe<Scalars["bigint"]["input"]>
  uuid?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_Dunning_Purge_Job_Sum_Fields = {
  __typename?: "tickets_dunning_purge_job_sum_fields"
  accounts_deleted?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  tickets_deleted?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "dunning_purge_job" */
export enum Tickets_Dunning_Purge_Job_Update_Column {
  /** column name */
  AccountsDeleted = "accounts_deleted",
  /** column name */
  CompletedAt = "completed_at",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  StartedAt = "started_at",
  /** column name */
  Status = "status",
  /** column name */
  TicketsDeleted = "tickets_deleted",
  /** column name */
  Uuid = "uuid",
}

export type Tickets_Dunning_Purge_Job_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Dunning_Purge_Job_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Dunning_Purge_Job_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Dunning_Purge_Job_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Dunning_Purge_Job_Var_Pop_Fields = {
  __typename?: "tickets_dunning_purge_job_var_pop_fields"
  accounts_deleted?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  tickets_deleted?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Dunning_Purge_Job_Var_Samp_Fields = {
  __typename?: "tickets_dunning_purge_job_var_samp_fields"
  accounts_deleted?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  tickets_deleted?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Dunning_Purge_Job_Variance_Fields = {
  __typename?: "tickets_dunning_purge_job_variance_fields"
  accounts_deleted?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  tickets_deleted?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "dunning_standard_ticket_records" */
export type Tickets_Dunning_Standard_Ticket_Records = {
  __typename?: "tickets_dunning_standard_ticket_records"
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  dd_status?: Maybe<Scalars["String"]["output"]>
  dunning_job_id: Scalars["bigint"]["output"]
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  status?: Maybe<Scalars["dunning_standard_review_status"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_is_last_step: Scalars["Boolean"]["output"]
  ticket_next_step?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
}

/** aggregated selection of "dunning_standard_ticket_records" */
export type Tickets_Dunning_Standard_Ticket_Records_Aggregate = {
  __typename?: "tickets_dunning_standard_ticket_records_aggregate"
  aggregate?: Maybe<Tickets_Dunning_Standard_Ticket_Records_Aggregate_Fields>
  nodes: Array<Tickets_Dunning_Standard_Ticket_Records>
}

/** aggregate fields of "dunning_standard_ticket_records" */
export type Tickets_Dunning_Standard_Ticket_Records_Aggregate_Fields = {
  __typename?: "tickets_dunning_standard_ticket_records_aggregate_fields"
  avg?: Maybe<Tickets_Dunning_Standard_Ticket_Records_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Dunning_Standard_Ticket_Records_Max_Fields>
  min?: Maybe<Tickets_Dunning_Standard_Ticket_Records_Min_Fields>
  stddev?: Maybe<Tickets_Dunning_Standard_Ticket_Records_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Dunning_Standard_Ticket_Records_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Dunning_Standard_Ticket_Records_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Dunning_Standard_Ticket_Records_Sum_Fields>
  var_pop?: Maybe<Tickets_Dunning_Standard_Ticket_Records_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Dunning_Standard_Ticket_Records_Var_Samp_Fields>
  variance?: Maybe<Tickets_Dunning_Standard_Ticket_Records_Variance_Fields>
}

/** aggregate fields of "dunning_standard_ticket_records" */
export type Tickets_Dunning_Standard_Ticket_Records_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Tickets_Dunning_Standard_Ticket_Records_Select_Column>
    >
    distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  }

/** aggregate avg on columns */
export type Tickets_Dunning_Standard_Ticket_Records_Avg_Fields = {
  __typename?: "tickets_dunning_standard_ticket_records_avg_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "dunning_standard_ticket_records". All fields are combined with a logical 'AND'. */
export type Tickets_Dunning_Standard_Ticket_Records_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Dunning_Standard_Ticket_Records_Bool_Exp>>
  _not?: InputMaybe<Tickets_Dunning_Standard_Ticket_Records_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Dunning_Standard_Ticket_Records_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  account_status?: InputMaybe<String_Comparison_Exp>
  dd_status?: InputMaybe<String_Comparison_Exp>
  dunning_job_id?: InputMaybe<Bigint_Comparison_Exp>
  failure_reason?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  status?: InputMaybe<Dunning_Standard_Review_Status_Comparison_Exp>
  ticket_id?: InputMaybe<String_Comparison_Exp>
  ticket_is_last_step?: InputMaybe<Boolean_Comparison_Exp>
  ticket_next_step?: InputMaybe<String_Comparison_Exp>
  ticket_step?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "dunning_standard_ticket_records" */
export enum Tickets_Dunning_Standard_Ticket_Records_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkDunningStandardTicketRecords = "pk_dunning_standard_ticket_records",
}

/** input type for incrementing numeric columns in table "dunning_standard_ticket_records" */
export type Tickets_Dunning_Standard_Ticket_Records_Inc_Input = {
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "dunning_standard_ticket_records" */
export type Tickets_Dunning_Standard_Ticket_Records_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  account_status?: InputMaybe<Scalars["String"]["input"]>
  dd_status?: InputMaybe<Scalars["String"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["dunning_standard_review_status"]["input"]>
  ticket_id?: InputMaybe<Scalars["String"]["input"]>
  ticket_is_last_step?: InputMaybe<Scalars["Boolean"]["input"]>
  ticket_next_step?: InputMaybe<Scalars["String"]["input"]>
  ticket_step?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Dunning_Standard_Ticket_Records_Max_Fields = {
  __typename?: "tickets_dunning_standard_ticket_records_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  dd_status?: Maybe<Scalars["String"]["output"]>
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["dunning_standard_review_status"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_next_step?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Dunning_Standard_Ticket_Records_Min_Fields = {
  __typename?: "tickets_dunning_standard_ticket_records_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  dd_status?: Maybe<Scalars["String"]["output"]>
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["dunning_standard_review_status"]["output"]>
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_next_step?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "dunning_standard_ticket_records" */
export type Tickets_Dunning_Standard_Ticket_Records_Mutation_Response = {
  __typename?: "tickets_dunning_standard_ticket_records_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Dunning_Standard_Ticket_Records>
}

/** on_conflict condition type for table "dunning_standard_ticket_records" */
export type Tickets_Dunning_Standard_Ticket_Records_On_Conflict = {
  constraint: Tickets_Dunning_Standard_Ticket_Records_Constraint
  update_columns?: Array<Tickets_Dunning_Standard_Ticket_Records_Update_Column>
  where?: InputMaybe<Tickets_Dunning_Standard_Ticket_Records_Bool_Exp>
}

/** Ordering options when selecting data from "dunning_standard_ticket_records". */
export type Tickets_Dunning_Standard_Ticket_Records_Order_By = {
  account_number?: InputMaybe<Order_By>
  account_status?: InputMaybe<Order_By>
  dd_status?: InputMaybe<Order_By>
  dunning_job_id?: InputMaybe<Order_By>
  failure_reason?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  ticket_id?: InputMaybe<Order_By>
  ticket_is_last_step?: InputMaybe<Order_By>
  ticket_next_step?: InputMaybe<Order_By>
  ticket_step?: InputMaybe<Order_By>
}

/** primary key columns input for table: dunning_standard_ticket_records */
export type Tickets_Dunning_Standard_Ticket_Records_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "dunning_standard_ticket_records" */
export enum Tickets_Dunning_Standard_Ticket_Records_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AccountStatus = "account_status",
  /** column name */
  DdStatus = "dd_status",
  /** column name */
  DunningJobId = "dunning_job_id",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  TicketId = "ticket_id",
  /** column name */
  TicketIsLastStep = "ticket_is_last_step",
  /** column name */
  TicketNextStep = "ticket_next_step",
  /** column name */
  TicketStep = "ticket_step",
}

/** input type for updating data in table "dunning_standard_ticket_records" */
export type Tickets_Dunning_Standard_Ticket_Records_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  account_status?: InputMaybe<Scalars["String"]["input"]>
  dd_status?: InputMaybe<Scalars["String"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["dunning_standard_review_status"]["input"]>
  ticket_id?: InputMaybe<Scalars["String"]["input"]>
  ticket_is_last_step?: InputMaybe<Scalars["Boolean"]["input"]>
  ticket_next_step?: InputMaybe<Scalars["String"]["input"]>
  ticket_step?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Dunning_Standard_Ticket_Records_Stddev_Fields = {
  __typename?: "tickets_dunning_standard_ticket_records_stddev_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Dunning_Standard_Ticket_Records_Stddev_Pop_Fields = {
  __typename?: "tickets_dunning_standard_ticket_records_stddev_pop_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Dunning_Standard_Ticket_Records_Stddev_Samp_Fields = {
  __typename?: "tickets_dunning_standard_ticket_records_stddev_samp_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_dunning_standard_ticket_records" */
export type Tickets_Dunning_Standard_Ticket_Records_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Dunning_Standard_Ticket_Records_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Dunning_Standard_Ticket_Records_Stream_Cursor_Value_Input =
  {
    account_number?: InputMaybe<Scalars["String"]["input"]>
    account_status?: InputMaybe<Scalars["String"]["input"]>
    dd_status?: InputMaybe<Scalars["String"]["input"]>
    dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
    failure_reason?: InputMaybe<Scalars["String"]["input"]>
    id?: InputMaybe<Scalars["bigint"]["input"]>
    status?: InputMaybe<Scalars["dunning_standard_review_status"]["input"]>
    ticket_id?: InputMaybe<Scalars["String"]["input"]>
    ticket_is_last_step?: InputMaybe<Scalars["Boolean"]["input"]>
    ticket_next_step?: InputMaybe<Scalars["String"]["input"]>
    ticket_step?: InputMaybe<Scalars["String"]["input"]>
  }

/** aggregate sum on columns */
export type Tickets_Dunning_Standard_Ticket_Records_Sum_Fields = {
  __typename?: "tickets_dunning_standard_ticket_records_sum_fields"
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "dunning_standard_ticket_records" */
export enum Tickets_Dunning_Standard_Ticket_Records_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AccountStatus = "account_status",
  /** column name */
  DdStatus = "dd_status",
  /** column name */
  DunningJobId = "dunning_job_id",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  TicketId = "ticket_id",
  /** column name */
  TicketIsLastStep = "ticket_is_last_step",
  /** column name */
  TicketNextStep = "ticket_next_step",
  /** column name */
  TicketStep = "ticket_step",
}

export type Tickets_Dunning_Standard_Ticket_Records_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Dunning_Standard_Ticket_Records_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Dunning_Standard_Ticket_Records_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Dunning_Standard_Ticket_Records_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Dunning_Standard_Ticket_Records_Var_Pop_Fields = {
  __typename?: "tickets_dunning_standard_ticket_records_var_pop_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Dunning_Standard_Ticket_Records_Var_Samp_Fields = {
  __typename?: "tickets_dunning_standard_ticket_records_var_samp_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Dunning_Standard_Ticket_Records_Variance_Fields = {
  __typename?: "tickets_dunning_standard_ticket_records_variance_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "dunning_statistics" */
export type Tickets_Dunning_Statistics = {
  __typename?: "tickets_dunning_statistics"
  created_at: Scalars["timestamptz"]["output"]
  dunning_job_id: Scalars["bigint"]["output"]
  id: Scalars["bigint"]["output"]
  statistic_type: Scalars["dunning_job_statistic_type"]["output"]
  total_accounts?: Maybe<Scalars["Int"]["output"]>
  total_after_sorting_and_limiting?: Maybe<Scalars["Int"]["output"]>
  total_valid_account_after_ticket_match?: Maybe<Scalars["Int"]["output"]>
  total_valid_accounts?: Maybe<Scalars["Int"]["output"]>
}

/** aggregated selection of "dunning_statistics" */
export type Tickets_Dunning_Statistics_Aggregate = {
  __typename?: "tickets_dunning_statistics_aggregate"
  aggregate?: Maybe<Tickets_Dunning_Statistics_Aggregate_Fields>
  nodes: Array<Tickets_Dunning_Statistics>
}

/** aggregate fields of "dunning_statistics" */
export type Tickets_Dunning_Statistics_Aggregate_Fields = {
  __typename?: "tickets_dunning_statistics_aggregate_fields"
  avg?: Maybe<Tickets_Dunning_Statistics_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Dunning_Statistics_Max_Fields>
  min?: Maybe<Tickets_Dunning_Statistics_Min_Fields>
  stddev?: Maybe<Tickets_Dunning_Statistics_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Dunning_Statistics_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Dunning_Statistics_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Dunning_Statistics_Sum_Fields>
  var_pop?: Maybe<Tickets_Dunning_Statistics_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Dunning_Statistics_Var_Samp_Fields>
  variance?: Maybe<Tickets_Dunning_Statistics_Variance_Fields>
}

/** aggregate fields of "dunning_statistics" */
export type Tickets_Dunning_Statistics_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Dunning_Statistics_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_Dunning_Statistics_Avg_Fields = {
  __typename?: "tickets_dunning_statistics_avg_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  total_accounts?: Maybe<Scalars["Float"]["output"]>
  total_after_sorting_and_limiting?: Maybe<Scalars["Float"]["output"]>
  total_valid_account_after_ticket_match?: Maybe<Scalars["Float"]["output"]>
  total_valid_accounts?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "dunning_statistics". All fields are combined with a logical 'AND'. */
export type Tickets_Dunning_Statistics_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Dunning_Statistics_Bool_Exp>>
  _not?: InputMaybe<Tickets_Dunning_Statistics_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Dunning_Statistics_Bool_Exp>>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  dunning_job_id?: InputMaybe<Bigint_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  statistic_type?: InputMaybe<Dunning_Job_Statistic_Type_Comparison_Exp>
  total_accounts?: InputMaybe<Int_Comparison_Exp>
  total_after_sorting_and_limiting?: InputMaybe<Int_Comparison_Exp>
  total_valid_account_after_ticket_match?: InputMaybe<Int_Comparison_Exp>
  total_valid_accounts?: InputMaybe<Int_Comparison_Exp>
}

/** unique or primary key constraints on table "dunning_statistics" */
export enum Tickets_Dunning_Statistics_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkDunningDunningStatistics = "pk_dunning_dunning_statistics",
  /** unique or primary key constraint on columns "dunning_job_id", "statistic_type" */
  UniqueConstraintStatisticTypeDunningJob = "unique_constraint_statistic_type_dunning_job",
}

/** input type for incrementing numeric columns in table "dunning_statistics" */
export type Tickets_Dunning_Statistics_Inc_Input = {
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  total_accounts?: InputMaybe<Scalars["Int"]["input"]>
  total_after_sorting_and_limiting?: InputMaybe<Scalars["Int"]["input"]>
  total_valid_account_after_ticket_match?: InputMaybe<Scalars["Int"]["input"]>
  total_valid_accounts?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "dunning_statistics" */
export type Tickets_Dunning_Statistics_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  statistic_type?: InputMaybe<Scalars["dunning_job_statistic_type"]["input"]>
  total_accounts?: InputMaybe<Scalars["Int"]["input"]>
  total_after_sorting_and_limiting?: InputMaybe<Scalars["Int"]["input"]>
  total_valid_account_after_ticket_match?: InputMaybe<Scalars["Int"]["input"]>
  total_valid_accounts?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Dunning_Statistics_Max_Fields = {
  __typename?: "tickets_dunning_statistics_max_fields"
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  statistic_type?: Maybe<Scalars["dunning_job_statistic_type"]["output"]>
  total_accounts?: Maybe<Scalars["Int"]["output"]>
  total_after_sorting_and_limiting?: Maybe<Scalars["Int"]["output"]>
  total_valid_account_after_ticket_match?: Maybe<Scalars["Int"]["output"]>
  total_valid_accounts?: Maybe<Scalars["Int"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Dunning_Statistics_Min_Fields = {
  __typename?: "tickets_dunning_statistics_min_fields"
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  statistic_type?: Maybe<Scalars["dunning_job_statistic_type"]["output"]>
  total_accounts?: Maybe<Scalars["Int"]["output"]>
  total_after_sorting_and_limiting?: Maybe<Scalars["Int"]["output"]>
  total_valid_account_after_ticket_match?: Maybe<Scalars["Int"]["output"]>
  total_valid_accounts?: Maybe<Scalars["Int"]["output"]>
}

/** response of any mutation on the table "dunning_statistics" */
export type Tickets_Dunning_Statistics_Mutation_Response = {
  __typename?: "tickets_dunning_statistics_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Dunning_Statistics>
}

/** on_conflict condition type for table "dunning_statistics" */
export type Tickets_Dunning_Statistics_On_Conflict = {
  constraint: Tickets_Dunning_Statistics_Constraint
  update_columns?: Array<Tickets_Dunning_Statistics_Update_Column>
  where?: InputMaybe<Tickets_Dunning_Statistics_Bool_Exp>
}

/** Ordering options when selecting data from "dunning_statistics". */
export type Tickets_Dunning_Statistics_Order_By = {
  created_at?: InputMaybe<Order_By>
  dunning_job_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  statistic_type?: InputMaybe<Order_By>
  total_accounts?: InputMaybe<Order_By>
  total_after_sorting_and_limiting?: InputMaybe<Order_By>
  total_valid_account_after_ticket_match?: InputMaybe<Order_By>
  total_valid_accounts?: InputMaybe<Order_By>
}

/** primary key columns input for table: dunning_statistics */
export type Tickets_Dunning_Statistics_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "dunning_statistics" */
export enum Tickets_Dunning_Statistics_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DunningJobId = "dunning_job_id",
  /** column name */
  Id = "id",
  /** column name */
  StatisticType = "statistic_type",
  /** column name */
  TotalAccounts = "total_accounts",
  /** column name */
  TotalAfterSortingAndLimiting = "total_after_sorting_and_limiting",
  /** column name */
  TotalValidAccountAfterTicketMatch = "total_valid_account_after_ticket_match",
  /** column name */
  TotalValidAccounts = "total_valid_accounts",
}

/** input type for updating data in table "dunning_statistics" */
export type Tickets_Dunning_Statistics_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  statistic_type?: InputMaybe<Scalars["dunning_job_statistic_type"]["input"]>
  total_accounts?: InputMaybe<Scalars["Int"]["input"]>
  total_after_sorting_and_limiting?: InputMaybe<Scalars["Int"]["input"]>
  total_valid_account_after_ticket_match?: InputMaybe<Scalars["Int"]["input"]>
  total_valid_accounts?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Dunning_Statistics_Stddev_Fields = {
  __typename?: "tickets_dunning_statistics_stddev_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  total_accounts?: Maybe<Scalars["Float"]["output"]>
  total_after_sorting_and_limiting?: Maybe<Scalars["Float"]["output"]>
  total_valid_account_after_ticket_match?: Maybe<Scalars["Float"]["output"]>
  total_valid_accounts?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Dunning_Statistics_Stddev_Pop_Fields = {
  __typename?: "tickets_dunning_statistics_stddev_pop_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  total_accounts?: Maybe<Scalars["Float"]["output"]>
  total_after_sorting_and_limiting?: Maybe<Scalars["Float"]["output"]>
  total_valid_account_after_ticket_match?: Maybe<Scalars["Float"]["output"]>
  total_valid_accounts?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Dunning_Statistics_Stddev_Samp_Fields = {
  __typename?: "tickets_dunning_statistics_stddev_samp_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  total_accounts?: Maybe<Scalars["Float"]["output"]>
  total_after_sorting_and_limiting?: Maybe<Scalars["Float"]["output"]>
  total_valid_account_after_ticket_match?: Maybe<Scalars["Float"]["output"]>
  total_valid_accounts?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_dunning_statistics" */
export type Tickets_Dunning_Statistics_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Dunning_Statistics_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Dunning_Statistics_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  statistic_type?: InputMaybe<Scalars["dunning_job_statistic_type"]["input"]>
  total_accounts?: InputMaybe<Scalars["Int"]["input"]>
  total_after_sorting_and_limiting?: InputMaybe<Scalars["Int"]["input"]>
  total_valid_account_after_ticket_match?: InputMaybe<Scalars["Int"]["input"]>
  total_valid_accounts?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_Dunning_Statistics_Sum_Fields = {
  __typename?: "tickets_dunning_statistics_sum_fields"
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  total_accounts?: Maybe<Scalars["Int"]["output"]>
  total_after_sorting_and_limiting?: Maybe<Scalars["Int"]["output"]>
  total_valid_account_after_ticket_match?: Maybe<Scalars["Int"]["output"]>
  total_valid_accounts?: Maybe<Scalars["Int"]["output"]>
}

/** update columns of table "dunning_statistics" */
export enum Tickets_Dunning_Statistics_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DunningJobId = "dunning_job_id",
  /** column name */
  Id = "id",
  /** column name */
  StatisticType = "statistic_type",
  /** column name */
  TotalAccounts = "total_accounts",
  /** column name */
  TotalAfterSortingAndLimiting = "total_after_sorting_and_limiting",
  /** column name */
  TotalValidAccountAfterTicketMatch = "total_valid_account_after_ticket_match",
  /** column name */
  TotalValidAccounts = "total_valid_accounts",
}

export type Tickets_Dunning_Statistics_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Dunning_Statistics_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Dunning_Statistics_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Dunning_Statistics_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Dunning_Statistics_Var_Pop_Fields = {
  __typename?: "tickets_dunning_statistics_var_pop_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  total_accounts?: Maybe<Scalars["Float"]["output"]>
  total_after_sorting_and_limiting?: Maybe<Scalars["Float"]["output"]>
  total_valid_account_after_ticket_match?: Maybe<Scalars["Float"]["output"]>
  total_valid_accounts?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Dunning_Statistics_Var_Samp_Fields = {
  __typename?: "tickets_dunning_statistics_var_samp_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  total_accounts?: Maybe<Scalars["Float"]["output"]>
  total_after_sorting_and_limiting?: Maybe<Scalars["Float"]["output"]>
  total_valid_account_after_ticket_match?: Maybe<Scalars["Float"]["output"]>
  total_valid_accounts?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Dunning_Statistics_Variance_Fields = {
  __typename?: "tickets_dunning_statistics_variance_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  total_accounts?: Maybe<Scalars["Float"]["output"]>
  total_after_sorting_and_limiting?: Maybe<Scalars["Float"]["output"]>
  total_valid_account_after_ticket_match?: Maybe<Scalars["Float"]["output"]>
  total_valid_accounts?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "dunning_terminating_accounts_review_records" */
export type Tickets_Dunning_Terminating_Accounts_Review_Records = {
  __typename?: "tickets_dunning_terminating_accounts_review_records"
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  dd_status?: Maybe<Scalars["String"]["output"]>
  dunning_job_id: Scalars["bigint"]["output"]
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  status?: Maybe<
    Scalars["dunning_terminating_accounts_review_status"]["output"]
  >
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_next_step?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
}

/** aggregated selection of "dunning_terminating_accounts_review_records" */
export type Tickets_Dunning_Terminating_Accounts_Review_Records_Aggregate = {
  __typename?: "tickets_dunning_terminating_accounts_review_records_aggregate"
  aggregate?: Maybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Aggregate_Fields>
  nodes: Array<Tickets_Dunning_Terminating_Accounts_Review_Records>
}

/** aggregate fields of "dunning_terminating_accounts_review_records" */
export type Tickets_Dunning_Terminating_Accounts_Review_Records_Aggregate_Fields =
  {
    __typename?: "tickets_dunning_terminating_accounts_review_records_aggregate_fields"
    avg?: Maybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Avg_Fields>
    count: Scalars["Int"]["output"]
    max?: Maybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Max_Fields>
    min?: Maybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Min_Fields>
    stddev?: Maybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Stddev_Fields>
    stddev_pop?: Maybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Stddev_Pop_Fields>
    stddev_samp?: Maybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Stddev_Samp_Fields>
    sum?: Maybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Sum_Fields>
    var_pop?: Maybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Var_Pop_Fields>
    var_samp?: Maybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Var_Samp_Fields>
    variance?: Maybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Variance_Fields>
  }

/** aggregate fields of "dunning_terminating_accounts_review_records" */
export type Tickets_Dunning_Terminating_Accounts_Review_Records_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Tickets_Dunning_Terminating_Accounts_Review_Records_Select_Column>
    >
    distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  }

/** aggregate avg on columns */
export type Tickets_Dunning_Terminating_Accounts_Review_Records_Avg_Fields = {
  __typename?: "tickets_dunning_terminating_accounts_review_records_avg_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "dunning_terminating_accounts_review_records". All fields are combined with a logical 'AND'. */
export type Tickets_Dunning_Terminating_Accounts_Review_Records_Bool_Exp = {
  _and?: InputMaybe<
    Array<Tickets_Dunning_Terminating_Accounts_Review_Records_Bool_Exp>
  >
  _not?: InputMaybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Bool_Exp>
  _or?: InputMaybe<
    Array<Tickets_Dunning_Terminating_Accounts_Review_Records_Bool_Exp>
  >
  account_number?: InputMaybe<String_Comparison_Exp>
  account_status?: InputMaybe<String_Comparison_Exp>
  dd_status?: InputMaybe<String_Comparison_Exp>
  dunning_job_id?: InputMaybe<Bigint_Comparison_Exp>
  failure_reason?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  status?: InputMaybe<Dunning_Terminating_Accounts_Review_Status_Comparison_Exp>
  ticket_id?: InputMaybe<String_Comparison_Exp>
  ticket_next_step?: InputMaybe<String_Comparison_Exp>
  ticket_step?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "dunning_terminating_accounts_review_records" */
export enum Tickets_Dunning_Terminating_Accounts_Review_Records_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkDunningTerminatingAccountsReviewRecords = "pk_dunning_terminating_accounts_review_records",
}

/** input type for incrementing numeric columns in table "dunning_terminating_accounts_review_records" */
export type Tickets_Dunning_Terminating_Accounts_Review_Records_Inc_Input = {
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "dunning_terminating_accounts_review_records" */
export type Tickets_Dunning_Terminating_Accounts_Review_Records_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  account_status?: InputMaybe<Scalars["String"]["input"]>
  dd_status?: InputMaybe<Scalars["String"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<
    Scalars["dunning_terminating_accounts_review_status"]["input"]
  >
  ticket_id?: InputMaybe<Scalars["String"]["input"]>
  ticket_next_step?: InputMaybe<Scalars["String"]["input"]>
  ticket_step?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Dunning_Terminating_Accounts_Review_Records_Max_Fields = {
  __typename?: "tickets_dunning_terminating_accounts_review_records_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  dd_status?: Maybe<Scalars["String"]["output"]>
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<
    Scalars["dunning_terminating_accounts_review_status"]["output"]
  >
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_next_step?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Dunning_Terminating_Accounts_Review_Records_Min_Fields = {
  __typename?: "tickets_dunning_terminating_accounts_review_records_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  account_status?: Maybe<Scalars["String"]["output"]>
  dd_status?: Maybe<Scalars["String"]["output"]>
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  failure_reason?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<
    Scalars["dunning_terminating_accounts_review_status"]["output"]
  >
  ticket_id?: Maybe<Scalars["String"]["output"]>
  ticket_next_step?: Maybe<Scalars["String"]["output"]>
  ticket_step?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "dunning_terminating_accounts_review_records" */
export type Tickets_Dunning_Terminating_Accounts_Review_Records_Mutation_Response =
  {
    __typename?: "tickets_dunning_terminating_accounts_review_records_mutation_response"
    /** number of rows affected by the mutation */
    affected_rows: Scalars["Int"]["output"]
    /** data from the rows affected by the mutation */
    returning: Array<Tickets_Dunning_Terminating_Accounts_Review_Records>
  }

/** on_conflict condition type for table "dunning_terminating_accounts_review_records" */
export type Tickets_Dunning_Terminating_Accounts_Review_Records_On_Conflict = {
  constraint: Tickets_Dunning_Terminating_Accounts_Review_Records_Constraint
  update_columns?: Array<Tickets_Dunning_Terminating_Accounts_Review_Records_Update_Column>
  where?: InputMaybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Bool_Exp>
}

/** Ordering options when selecting data from "dunning_terminating_accounts_review_records". */
export type Tickets_Dunning_Terminating_Accounts_Review_Records_Order_By = {
  account_number?: InputMaybe<Order_By>
  account_status?: InputMaybe<Order_By>
  dd_status?: InputMaybe<Order_By>
  dunning_job_id?: InputMaybe<Order_By>
  failure_reason?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  ticket_id?: InputMaybe<Order_By>
  ticket_next_step?: InputMaybe<Order_By>
  ticket_step?: InputMaybe<Order_By>
}

/** primary key columns input for table: dunning_terminating_accounts_review_records */
export type Tickets_Dunning_Terminating_Accounts_Review_Records_Pk_Columns_Input =
  {
    id: Scalars["bigint"]["input"]
  }

/** select columns of table "dunning_terminating_accounts_review_records" */
export enum Tickets_Dunning_Terminating_Accounts_Review_Records_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AccountStatus = "account_status",
  /** column name */
  DdStatus = "dd_status",
  /** column name */
  DunningJobId = "dunning_job_id",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  TicketId = "ticket_id",
  /** column name */
  TicketNextStep = "ticket_next_step",
  /** column name */
  TicketStep = "ticket_step",
}

/** input type for updating data in table "dunning_terminating_accounts_review_records" */
export type Tickets_Dunning_Terminating_Accounts_Review_Records_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  account_status?: InputMaybe<Scalars["String"]["input"]>
  dd_status?: InputMaybe<Scalars["String"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  failure_reason?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<
    Scalars["dunning_terminating_accounts_review_status"]["input"]
  >
  ticket_id?: InputMaybe<Scalars["String"]["input"]>
  ticket_next_step?: InputMaybe<Scalars["String"]["input"]>
  ticket_step?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Dunning_Terminating_Accounts_Review_Records_Stddev_Fields =
  {
    __typename?: "tickets_dunning_terminating_accounts_review_records_stddev_fields"
    dunning_job_id?: Maybe<Scalars["Float"]["output"]>
    id?: Maybe<Scalars["Float"]["output"]>
  }

/** aggregate stddev_pop on columns */
export type Tickets_Dunning_Terminating_Accounts_Review_Records_Stddev_Pop_Fields =
  {
    __typename?: "tickets_dunning_terminating_accounts_review_records_stddev_pop_fields"
    dunning_job_id?: Maybe<Scalars["Float"]["output"]>
    id?: Maybe<Scalars["Float"]["output"]>
  }

/** aggregate stddev_samp on columns */
export type Tickets_Dunning_Terminating_Accounts_Review_Records_Stddev_Samp_Fields =
  {
    __typename?: "tickets_dunning_terminating_accounts_review_records_stddev_samp_fields"
    dunning_job_id?: Maybe<Scalars["Float"]["output"]>
    id?: Maybe<Scalars["Float"]["output"]>
  }

/** Streaming cursor of the table "tickets_dunning_terminating_accounts_review_records" */
export type Tickets_Dunning_Terminating_Accounts_Review_Records_Stream_Cursor_Input =
  {
    /** Stream column input with initial value */
    initial_value: Tickets_Dunning_Terminating_Accounts_Review_Records_Stream_Cursor_Value_Input
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>
  }

/** Initial value of the column from where the streaming should start */
export type Tickets_Dunning_Terminating_Accounts_Review_Records_Stream_Cursor_Value_Input =
  {
    account_number?: InputMaybe<Scalars["String"]["input"]>
    account_status?: InputMaybe<Scalars["String"]["input"]>
    dd_status?: InputMaybe<Scalars["String"]["input"]>
    dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
    failure_reason?: InputMaybe<Scalars["String"]["input"]>
    id?: InputMaybe<Scalars["bigint"]["input"]>
    status?: InputMaybe<
      Scalars["dunning_terminating_accounts_review_status"]["input"]
    >
    ticket_id?: InputMaybe<Scalars["String"]["input"]>
    ticket_next_step?: InputMaybe<Scalars["String"]["input"]>
    ticket_step?: InputMaybe<Scalars["String"]["input"]>
  }

/** aggregate sum on columns */
export type Tickets_Dunning_Terminating_Accounts_Review_Records_Sum_Fields = {
  __typename?: "tickets_dunning_terminating_accounts_review_records_sum_fields"
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "dunning_terminating_accounts_review_records" */
export enum Tickets_Dunning_Terminating_Accounts_Review_Records_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  AccountStatus = "account_status",
  /** column name */
  DdStatus = "dd_status",
  /** column name */
  DunningJobId = "dunning_job_id",
  /** column name */
  FailureReason = "failure_reason",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  TicketId = "ticket_id",
  /** column name */
  TicketNextStep = "ticket_next_step",
  /** column name */
  TicketStep = "ticket_step",
}

export type Tickets_Dunning_Terminating_Accounts_Review_Records_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Dunning_Terminating_Accounts_Review_Records_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Dunning_Terminating_Accounts_Review_Records_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Dunning_Terminating_Accounts_Review_Records_Var_Pop_Fields =
  {
    __typename?: "tickets_dunning_terminating_accounts_review_records_var_pop_fields"
    dunning_job_id?: Maybe<Scalars["Float"]["output"]>
    id?: Maybe<Scalars["Float"]["output"]>
  }

/** aggregate var_samp on columns */
export type Tickets_Dunning_Terminating_Accounts_Review_Records_Var_Samp_Fields =
  {
    __typename?: "tickets_dunning_terminating_accounts_review_records_var_samp_fields"
    dunning_job_id?: Maybe<Scalars["Float"]["output"]>
    id?: Maybe<Scalars["Float"]["output"]>
  }

/** aggregate variance on columns */
export type Tickets_Dunning_Terminating_Accounts_Review_Records_Variance_Fields =
  {
    __typename?: "tickets_dunning_terminating_accounts_review_records_variance_fields"
    dunning_job_id?: Maybe<Scalars["Float"]["output"]>
    id?: Maybe<Scalars["Float"]["output"]>
  }

/** columns and relationships of "dunning_ticket_store" */
export type Tickets_Dunning_Ticket_Store = {
  __typename?: "tickets_dunning_ticket_store"
  accountnumber?: Maybe<Scalars["String"]["output"]>
  created_at: Scalars["timestamptz"]["output"]
  dunning_job_id: Scalars["bigint"]["output"]
  id: Scalars["bigint"]["output"]
  latestticketactiondate?: Maybe<Scalars["date"]["output"]>
  ticketcreated?: Maybe<Scalars["date"]["output"]>
  ticketid?: Maybe<Scalars["String"]["output"]>
  ticketidentifier?: Maybe<Scalars["String"]["output"]>
  ticketprefix?: Maybe<Scalars["String"]["output"]>
  ticketstatus?: Maybe<Scalars["String"]["output"]>
  ticketstep?: Maybe<Scalars["String"]["output"]>
  ticketsummary?: Maybe<Scalars["String"]["output"]>
}

/** aggregated selection of "dunning_ticket_store" */
export type Tickets_Dunning_Ticket_Store_Aggregate = {
  __typename?: "tickets_dunning_ticket_store_aggregate"
  aggregate?: Maybe<Tickets_Dunning_Ticket_Store_Aggregate_Fields>
  nodes: Array<Tickets_Dunning_Ticket_Store>
}

/** aggregate fields of "dunning_ticket_store" */
export type Tickets_Dunning_Ticket_Store_Aggregate_Fields = {
  __typename?: "tickets_dunning_ticket_store_aggregate_fields"
  avg?: Maybe<Tickets_Dunning_Ticket_Store_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Dunning_Ticket_Store_Max_Fields>
  min?: Maybe<Tickets_Dunning_Ticket_Store_Min_Fields>
  stddev?: Maybe<Tickets_Dunning_Ticket_Store_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Dunning_Ticket_Store_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Dunning_Ticket_Store_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Dunning_Ticket_Store_Sum_Fields>
  var_pop?: Maybe<Tickets_Dunning_Ticket_Store_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Dunning_Ticket_Store_Var_Samp_Fields>
  variance?: Maybe<Tickets_Dunning_Ticket_Store_Variance_Fields>
}

/** aggregate fields of "dunning_ticket_store" */
export type Tickets_Dunning_Ticket_Store_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Dunning_Ticket_Store_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_Dunning_Ticket_Store_Avg_Fields = {
  __typename?: "tickets_dunning_ticket_store_avg_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "dunning_ticket_store". All fields are combined with a logical 'AND'. */
export type Tickets_Dunning_Ticket_Store_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Dunning_Ticket_Store_Bool_Exp>>
  _not?: InputMaybe<Tickets_Dunning_Ticket_Store_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Dunning_Ticket_Store_Bool_Exp>>
  accountnumber?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  dunning_job_id?: InputMaybe<Bigint_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  latestticketactiondate?: InputMaybe<Date_Comparison_Exp>
  ticketcreated?: InputMaybe<Date_Comparison_Exp>
  ticketid?: InputMaybe<String_Comparison_Exp>
  ticketidentifier?: InputMaybe<String_Comparison_Exp>
  ticketprefix?: InputMaybe<String_Comparison_Exp>
  ticketstatus?: InputMaybe<String_Comparison_Exp>
  ticketstep?: InputMaybe<String_Comparison_Exp>
  ticketsummary?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "dunning_ticket_store" */
export enum Tickets_Dunning_Ticket_Store_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkDunningTicketStore = "pk_dunning_ticket_store",
}

/** input type for incrementing numeric columns in table "dunning_ticket_store" */
export type Tickets_Dunning_Ticket_Store_Inc_Input = {
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "dunning_ticket_store" */
export type Tickets_Dunning_Ticket_Store_Insert_Input = {
  accountnumber?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  latestticketactiondate?: InputMaybe<Scalars["date"]["input"]>
  ticketcreated?: InputMaybe<Scalars["date"]["input"]>
  ticketid?: InputMaybe<Scalars["String"]["input"]>
  ticketidentifier?: InputMaybe<Scalars["String"]["input"]>
  ticketprefix?: InputMaybe<Scalars["String"]["input"]>
  ticketstatus?: InputMaybe<Scalars["String"]["input"]>
  ticketstep?: InputMaybe<Scalars["String"]["input"]>
  ticketsummary?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Dunning_Ticket_Store_Max_Fields = {
  __typename?: "tickets_dunning_ticket_store_max_fields"
  accountnumber?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  latestticketactiondate?: Maybe<Scalars["date"]["output"]>
  ticketcreated?: Maybe<Scalars["date"]["output"]>
  ticketid?: Maybe<Scalars["String"]["output"]>
  ticketidentifier?: Maybe<Scalars["String"]["output"]>
  ticketprefix?: Maybe<Scalars["String"]["output"]>
  ticketstatus?: Maybe<Scalars["String"]["output"]>
  ticketstep?: Maybe<Scalars["String"]["output"]>
  ticketsummary?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Dunning_Ticket_Store_Min_Fields = {
  __typename?: "tickets_dunning_ticket_store_min_fields"
  accountnumber?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  latestticketactiondate?: Maybe<Scalars["date"]["output"]>
  ticketcreated?: Maybe<Scalars["date"]["output"]>
  ticketid?: Maybe<Scalars["String"]["output"]>
  ticketidentifier?: Maybe<Scalars["String"]["output"]>
  ticketprefix?: Maybe<Scalars["String"]["output"]>
  ticketstatus?: Maybe<Scalars["String"]["output"]>
  ticketstep?: Maybe<Scalars["String"]["output"]>
  ticketsummary?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "dunning_ticket_store" */
export type Tickets_Dunning_Ticket_Store_Mutation_Response = {
  __typename?: "tickets_dunning_ticket_store_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Dunning_Ticket_Store>
}

/** on_conflict condition type for table "dunning_ticket_store" */
export type Tickets_Dunning_Ticket_Store_On_Conflict = {
  constraint: Tickets_Dunning_Ticket_Store_Constraint
  update_columns?: Array<Tickets_Dunning_Ticket_Store_Update_Column>
  where?: InputMaybe<Tickets_Dunning_Ticket_Store_Bool_Exp>
}

/** Ordering options when selecting data from "dunning_ticket_store". */
export type Tickets_Dunning_Ticket_Store_Order_By = {
  accountnumber?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  dunning_job_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  latestticketactiondate?: InputMaybe<Order_By>
  ticketcreated?: InputMaybe<Order_By>
  ticketid?: InputMaybe<Order_By>
  ticketidentifier?: InputMaybe<Order_By>
  ticketprefix?: InputMaybe<Order_By>
  ticketstatus?: InputMaybe<Order_By>
  ticketstep?: InputMaybe<Order_By>
  ticketsummary?: InputMaybe<Order_By>
}

/** primary key columns input for table: dunning_ticket_store */
export type Tickets_Dunning_Ticket_Store_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "dunning_ticket_store" */
export enum Tickets_Dunning_Ticket_Store_Select_Column {
  /** column name */
  Accountnumber = "accountnumber",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DunningJobId = "dunning_job_id",
  /** column name */
  Id = "id",
  /** column name */
  Latestticketactiondate = "latestticketactiondate",
  /** column name */
  Ticketcreated = "ticketcreated",
  /** column name */
  Ticketid = "ticketid",
  /** column name */
  Ticketidentifier = "ticketidentifier",
  /** column name */
  Ticketprefix = "ticketprefix",
  /** column name */
  Ticketstatus = "ticketstatus",
  /** column name */
  Ticketstep = "ticketstep",
  /** column name */
  Ticketsummary = "ticketsummary",
}

/** input type for updating data in table "dunning_ticket_store" */
export type Tickets_Dunning_Ticket_Store_Set_Input = {
  accountnumber?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  latestticketactiondate?: InputMaybe<Scalars["date"]["input"]>
  ticketcreated?: InputMaybe<Scalars["date"]["input"]>
  ticketid?: InputMaybe<Scalars["String"]["input"]>
  ticketidentifier?: InputMaybe<Scalars["String"]["input"]>
  ticketprefix?: InputMaybe<Scalars["String"]["input"]>
  ticketstatus?: InputMaybe<Scalars["String"]["input"]>
  ticketstep?: InputMaybe<Scalars["String"]["input"]>
  ticketsummary?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Dunning_Ticket_Store_Stddev_Fields = {
  __typename?: "tickets_dunning_ticket_store_stddev_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Dunning_Ticket_Store_Stddev_Pop_Fields = {
  __typename?: "tickets_dunning_ticket_store_stddev_pop_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Dunning_Ticket_Store_Stddev_Samp_Fields = {
  __typename?: "tickets_dunning_ticket_store_stddev_samp_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_dunning_ticket_store" */
export type Tickets_Dunning_Ticket_Store_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Dunning_Ticket_Store_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Dunning_Ticket_Store_Stream_Cursor_Value_Input = {
  accountnumber?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  dunning_job_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  latestticketactiondate?: InputMaybe<Scalars["date"]["input"]>
  ticketcreated?: InputMaybe<Scalars["date"]["input"]>
  ticketid?: InputMaybe<Scalars["String"]["input"]>
  ticketidentifier?: InputMaybe<Scalars["String"]["input"]>
  ticketprefix?: InputMaybe<Scalars["String"]["input"]>
  ticketstatus?: InputMaybe<Scalars["String"]["input"]>
  ticketstep?: InputMaybe<Scalars["String"]["input"]>
  ticketsummary?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_Dunning_Ticket_Store_Sum_Fields = {
  __typename?: "tickets_dunning_ticket_store_sum_fields"
  dunning_job_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "dunning_ticket_store" */
export enum Tickets_Dunning_Ticket_Store_Update_Column {
  /** column name */
  Accountnumber = "accountnumber",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DunningJobId = "dunning_job_id",
  /** column name */
  Id = "id",
  /** column name */
  Latestticketactiondate = "latestticketactiondate",
  /** column name */
  Ticketcreated = "ticketcreated",
  /** column name */
  Ticketid = "ticketid",
  /** column name */
  Ticketidentifier = "ticketidentifier",
  /** column name */
  Ticketprefix = "ticketprefix",
  /** column name */
  Ticketstatus = "ticketstatus",
  /** column name */
  Ticketstep = "ticketstep",
  /** column name */
  Ticketsummary = "ticketsummary",
}

export type Tickets_Dunning_Ticket_Store_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Dunning_Ticket_Store_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Dunning_Ticket_Store_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Dunning_Ticket_Store_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Dunning_Ticket_Store_Var_Pop_Fields = {
  __typename?: "tickets_dunning_ticket_store_var_pop_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Dunning_Ticket_Store_Var_Samp_Fields = {
  __typename?: "tickets_dunning_ticket_store_var_samp_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Dunning_Ticket_Store_Variance_Fields = {
  __typename?: "tickets_dunning_ticket_store_variance_fields"
  dunning_job_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "dunning_workflow" */
export type Tickets_Dunning_Workflow = {
  __typename?: "tickets_dunning_workflow"
  config_addacs_ticket_threshold?: Maybe<Scalars["Int"]["output"]>
  config_addacs_tickets_limit?: Maybe<Scalars["Int"]["output"]>
  config_debt_ticket_limit?: Maybe<Scalars["Int"]["output"]>
  config_enabled: Scalars["Boolean"]["output"]
  config_job_communication_bcc_emails?: Maybe<Scalars["String"]["output"]>
  config_job_communication_email?: Maybe<Scalars["String"]["output"]>
  config_job_communication_name?: Maybe<Scalars["String"]["output"]>
  config_job_communication_template_name?: Maybe<Scalars["String"]["output"]>
  config_legal_known_ticket_limit: Scalars["Int"]["output"]
  config_legal_occupier_ticket_limit: Scalars["Int"]["output"]
  config_occupier_tickets_limit?: Maybe<Scalars["Int"]["output"]>
  config_purge_data_threshold_in_days?: Maybe<Scalars["bigint"]["output"]>
  config_scheduled_cron_expression: Scalars["String"]["output"]
  config_standard_ticket_dd_age_limit: Scalars["Int"]["output"]
  config_standard_ticket_last_payment_date_limit: Scalars["Int"]["output"]
  config_standard_ticket_limit?: Maybe<Scalars["Int"]["output"]>
  config_standard_ticket_minimum_payment_limit: Scalars["numeric"]["output"]
  config_standard_ticket_threshold?: Maybe<Scalars["Int"]["output"]>
  config_terminating_tickets_limit?: Maybe<Scalars["Int"]["output"]>
  config_type: Scalars["dunning_workflow_type_enum"]["output"]
  created_at: Scalars["timestamptz"]["output"]
  id: Scalars["bigint"]["output"]
}

/** aggregated selection of "dunning_workflow" */
export type Tickets_Dunning_Workflow_Aggregate = {
  __typename?: "tickets_dunning_workflow_aggregate"
  aggregate?: Maybe<Tickets_Dunning_Workflow_Aggregate_Fields>
  nodes: Array<Tickets_Dunning_Workflow>
}

/** aggregate fields of "dunning_workflow" */
export type Tickets_Dunning_Workflow_Aggregate_Fields = {
  __typename?: "tickets_dunning_workflow_aggregate_fields"
  avg?: Maybe<Tickets_Dunning_Workflow_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Dunning_Workflow_Max_Fields>
  min?: Maybe<Tickets_Dunning_Workflow_Min_Fields>
  stddev?: Maybe<Tickets_Dunning_Workflow_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Dunning_Workflow_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Dunning_Workflow_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Dunning_Workflow_Sum_Fields>
  var_pop?: Maybe<Tickets_Dunning_Workflow_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Dunning_Workflow_Var_Samp_Fields>
  variance?: Maybe<Tickets_Dunning_Workflow_Variance_Fields>
}

/** aggregate fields of "dunning_workflow" */
export type Tickets_Dunning_Workflow_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Dunning_Workflow_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_Dunning_Workflow_Avg_Fields = {
  __typename?: "tickets_dunning_workflow_avg_fields"
  config_addacs_ticket_threshold?: Maybe<Scalars["Float"]["output"]>
  config_addacs_tickets_limit?: Maybe<Scalars["Float"]["output"]>
  config_debt_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_legal_known_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_legal_occupier_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_occupier_tickets_limit?: Maybe<Scalars["Float"]["output"]>
  config_purge_data_threshold_in_days?: Maybe<Scalars["Float"]["output"]>
  config_standard_ticket_dd_age_limit?: Maybe<Scalars["Float"]["output"]>
  config_standard_ticket_last_payment_date_limit?: Maybe<
    Scalars["Float"]["output"]
  >
  config_standard_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_standard_ticket_minimum_payment_limit?: Maybe<
    Scalars["Float"]["output"]
  >
  config_standard_ticket_threshold?: Maybe<Scalars["Float"]["output"]>
  config_terminating_tickets_limit?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "dunning_workflow". All fields are combined with a logical 'AND'. */
export type Tickets_Dunning_Workflow_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Dunning_Workflow_Bool_Exp>>
  _not?: InputMaybe<Tickets_Dunning_Workflow_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Dunning_Workflow_Bool_Exp>>
  config_addacs_ticket_threshold?: InputMaybe<Int_Comparison_Exp>
  config_addacs_tickets_limit?: InputMaybe<Int_Comparison_Exp>
  config_debt_ticket_limit?: InputMaybe<Int_Comparison_Exp>
  config_enabled?: InputMaybe<Boolean_Comparison_Exp>
  config_job_communication_bcc_emails?: InputMaybe<String_Comparison_Exp>
  config_job_communication_email?: InputMaybe<String_Comparison_Exp>
  config_job_communication_name?: InputMaybe<String_Comparison_Exp>
  config_job_communication_template_name?: InputMaybe<String_Comparison_Exp>
  config_legal_known_ticket_limit?: InputMaybe<Int_Comparison_Exp>
  config_legal_occupier_ticket_limit?: InputMaybe<Int_Comparison_Exp>
  config_occupier_tickets_limit?: InputMaybe<Int_Comparison_Exp>
  config_purge_data_threshold_in_days?: InputMaybe<Bigint_Comparison_Exp>
  config_scheduled_cron_expression?: InputMaybe<String_Comparison_Exp>
  config_standard_ticket_dd_age_limit?: InputMaybe<Int_Comparison_Exp>
  config_standard_ticket_last_payment_date_limit?: InputMaybe<Int_Comparison_Exp>
  config_standard_ticket_limit?: InputMaybe<Int_Comparison_Exp>
  config_standard_ticket_minimum_payment_limit?: InputMaybe<Numeric_Comparison_Exp>
  config_standard_ticket_threshold?: InputMaybe<Int_Comparison_Exp>
  config_terminating_tickets_limit?: InputMaybe<Int_Comparison_Exp>
  config_type?: InputMaybe<Dunning_Workflow_Type_Enum_Comparison_Exp>
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
}

/** unique or primary key constraints on table "dunning_workflow" */
export enum Tickets_Dunning_Workflow_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkDunningWorkflow = "pk_dunning_workflow",
}

/** input type for incrementing numeric columns in table "dunning_workflow" */
export type Tickets_Dunning_Workflow_Inc_Input = {
  config_addacs_ticket_threshold?: InputMaybe<Scalars["Int"]["input"]>
  config_addacs_tickets_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_debt_ticket_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_legal_known_ticket_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_legal_occupier_ticket_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_occupier_tickets_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_purge_data_threshold_in_days?: InputMaybe<Scalars["bigint"]["input"]>
  config_standard_ticket_dd_age_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_standard_ticket_last_payment_date_limit?: InputMaybe<
    Scalars["Int"]["input"]
  >
  config_standard_ticket_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_standard_ticket_minimum_payment_limit?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  config_standard_ticket_threshold?: InputMaybe<Scalars["Int"]["input"]>
  config_terminating_tickets_limit?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "dunning_workflow" */
export type Tickets_Dunning_Workflow_Insert_Input = {
  config_addacs_ticket_threshold?: InputMaybe<Scalars["Int"]["input"]>
  config_addacs_tickets_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_debt_ticket_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  config_job_communication_bcc_emails?: InputMaybe<Scalars["String"]["input"]>
  config_job_communication_email?: InputMaybe<Scalars["String"]["input"]>
  config_job_communication_name?: InputMaybe<Scalars["String"]["input"]>
  config_job_communication_template_name?: InputMaybe<
    Scalars["String"]["input"]
  >
  config_legal_known_ticket_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_legal_occupier_ticket_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_occupier_tickets_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_purge_data_threshold_in_days?: InputMaybe<Scalars["bigint"]["input"]>
  config_scheduled_cron_expression?: InputMaybe<Scalars["String"]["input"]>
  config_standard_ticket_dd_age_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_standard_ticket_last_payment_date_limit?: InputMaybe<
    Scalars["Int"]["input"]
  >
  config_standard_ticket_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_standard_ticket_minimum_payment_limit?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  config_standard_ticket_threshold?: InputMaybe<Scalars["Int"]["input"]>
  config_terminating_tickets_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_type?: InputMaybe<Scalars["dunning_workflow_type_enum"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Dunning_Workflow_Max_Fields = {
  __typename?: "tickets_dunning_workflow_max_fields"
  config_addacs_ticket_threshold?: Maybe<Scalars["Int"]["output"]>
  config_addacs_tickets_limit?: Maybe<Scalars["Int"]["output"]>
  config_debt_ticket_limit?: Maybe<Scalars["Int"]["output"]>
  config_job_communication_bcc_emails?: Maybe<Scalars["String"]["output"]>
  config_job_communication_email?: Maybe<Scalars["String"]["output"]>
  config_job_communication_name?: Maybe<Scalars["String"]["output"]>
  config_job_communication_template_name?: Maybe<Scalars["String"]["output"]>
  config_legal_known_ticket_limit?: Maybe<Scalars["Int"]["output"]>
  config_legal_occupier_ticket_limit?: Maybe<Scalars["Int"]["output"]>
  config_occupier_tickets_limit?: Maybe<Scalars["Int"]["output"]>
  config_purge_data_threshold_in_days?: Maybe<Scalars["bigint"]["output"]>
  config_scheduled_cron_expression?: Maybe<Scalars["String"]["output"]>
  config_standard_ticket_dd_age_limit?: Maybe<Scalars["Int"]["output"]>
  config_standard_ticket_last_payment_date_limit?: Maybe<
    Scalars["Int"]["output"]
  >
  config_standard_ticket_limit?: Maybe<Scalars["Int"]["output"]>
  config_standard_ticket_minimum_payment_limit?: Maybe<
    Scalars["numeric"]["output"]
  >
  config_standard_ticket_threshold?: Maybe<Scalars["Int"]["output"]>
  config_terminating_tickets_limit?: Maybe<Scalars["Int"]["output"]>
  config_type?: Maybe<Scalars["dunning_workflow_type_enum"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Dunning_Workflow_Min_Fields = {
  __typename?: "tickets_dunning_workflow_min_fields"
  config_addacs_ticket_threshold?: Maybe<Scalars["Int"]["output"]>
  config_addacs_tickets_limit?: Maybe<Scalars["Int"]["output"]>
  config_debt_ticket_limit?: Maybe<Scalars["Int"]["output"]>
  config_job_communication_bcc_emails?: Maybe<Scalars["String"]["output"]>
  config_job_communication_email?: Maybe<Scalars["String"]["output"]>
  config_job_communication_name?: Maybe<Scalars["String"]["output"]>
  config_job_communication_template_name?: Maybe<Scalars["String"]["output"]>
  config_legal_known_ticket_limit?: Maybe<Scalars["Int"]["output"]>
  config_legal_occupier_ticket_limit?: Maybe<Scalars["Int"]["output"]>
  config_occupier_tickets_limit?: Maybe<Scalars["Int"]["output"]>
  config_purge_data_threshold_in_days?: Maybe<Scalars["bigint"]["output"]>
  config_scheduled_cron_expression?: Maybe<Scalars["String"]["output"]>
  config_standard_ticket_dd_age_limit?: Maybe<Scalars["Int"]["output"]>
  config_standard_ticket_last_payment_date_limit?: Maybe<
    Scalars["Int"]["output"]
  >
  config_standard_ticket_limit?: Maybe<Scalars["Int"]["output"]>
  config_standard_ticket_minimum_payment_limit?: Maybe<
    Scalars["numeric"]["output"]
  >
  config_standard_ticket_threshold?: Maybe<Scalars["Int"]["output"]>
  config_terminating_tickets_limit?: Maybe<Scalars["Int"]["output"]>
  config_type?: Maybe<Scalars["dunning_workflow_type_enum"]["output"]>
  created_at?: Maybe<Scalars["timestamptz"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** response of any mutation on the table "dunning_workflow" */
export type Tickets_Dunning_Workflow_Mutation_Response = {
  __typename?: "tickets_dunning_workflow_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Dunning_Workflow>
}

/** on_conflict condition type for table "dunning_workflow" */
export type Tickets_Dunning_Workflow_On_Conflict = {
  constraint: Tickets_Dunning_Workflow_Constraint
  update_columns?: Array<Tickets_Dunning_Workflow_Update_Column>
  where?: InputMaybe<Tickets_Dunning_Workflow_Bool_Exp>
}

/** Ordering options when selecting data from "dunning_workflow". */
export type Tickets_Dunning_Workflow_Order_By = {
  config_addacs_ticket_threshold?: InputMaybe<Order_By>
  config_addacs_tickets_limit?: InputMaybe<Order_By>
  config_debt_ticket_limit?: InputMaybe<Order_By>
  config_enabled?: InputMaybe<Order_By>
  config_job_communication_bcc_emails?: InputMaybe<Order_By>
  config_job_communication_email?: InputMaybe<Order_By>
  config_job_communication_name?: InputMaybe<Order_By>
  config_job_communication_template_name?: InputMaybe<Order_By>
  config_legal_known_ticket_limit?: InputMaybe<Order_By>
  config_legal_occupier_ticket_limit?: InputMaybe<Order_By>
  config_occupier_tickets_limit?: InputMaybe<Order_By>
  config_purge_data_threshold_in_days?: InputMaybe<Order_By>
  config_scheduled_cron_expression?: InputMaybe<Order_By>
  config_standard_ticket_dd_age_limit?: InputMaybe<Order_By>
  config_standard_ticket_last_payment_date_limit?: InputMaybe<Order_By>
  config_standard_ticket_limit?: InputMaybe<Order_By>
  config_standard_ticket_minimum_payment_limit?: InputMaybe<Order_By>
  config_standard_ticket_threshold?: InputMaybe<Order_By>
  config_terminating_tickets_limit?: InputMaybe<Order_By>
  config_type?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** primary key columns input for table: dunning_workflow */
export type Tickets_Dunning_Workflow_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "dunning_workflow" */
export enum Tickets_Dunning_Workflow_Select_Column {
  /** column name */
  ConfigAddacsTicketThreshold = "config_addacs_ticket_threshold",
  /** column name */
  ConfigAddacsTicketsLimit = "config_addacs_tickets_limit",
  /** column name */
  ConfigDebtTicketLimit = "config_debt_ticket_limit",
  /** column name */
  ConfigEnabled = "config_enabled",
  /** column name */
  ConfigJobCommunicationBccEmails = "config_job_communication_bcc_emails",
  /** column name */
  ConfigJobCommunicationEmail = "config_job_communication_email",
  /** column name */
  ConfigJobCommunicationName = "config_job_communication_name",
  /** column name */
  ConfigJobCommunicationTemplateName = "config_job_communication_template_name",
  /** column name */
  ConfigLegalKnownTicketLimit = "config_legal_known_ticket_limit",
  /** column name */
  ConfigLegalOccupierTicketLimit = "config_legal_occupier_ticket_limit",
  /** column name */
  ConfigOccupierTicketsLimit = "config_occupier_tickets_limit",
  /** column name */
  ConfigPurgeDataThresholdInDays = "config_purge_data_threshold_in_days",
  /** column name */
  ConfigScheduledCronExpression = "config_scheduled_cron_expression",
  /** column name */
  ConfigStandardTicketDdAgeLimit = "config_standard_ticket_dd_age_limit",
  /** column name */
  ConfigStandardTicketLastPaymentDateLimit = "config_standard_ticket_last_payment_date_limit",
  /** column name */
  ConfigStandardTicketLimit = "config_standard_ticket_limit",
  /** column name */
  ConfigStandardTicketMinimumPaymentLimit = "config_standard_ticket_minimum_payment_limit",
  /** column name */
  ConfigStandardTicketThreshold = "config_standard_ticket_threshold",
  /** column name */
  ConfigTerminatingTicketsLimit = "config_terminating_tickets_limit",
  /** column name */
  ConfigType = "config_type",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
}

/** input type for updating data in table "dunning_workflow" */
export type Tickets_Dunning_Workflow_Set_Input = {
  config_addacs_ticket_threshold?: InputMaybe<Scalars["Int"]["input"]>
  config_addacs_tickets_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_debt_ticket_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  config_job_communication_bcc_emails?: InputMaybe<Scalars["String"]["input"]>
  config_job_communication_email?: InputMaybe<Scalars["String"]["input"]>
  config_job_communication_name?: InputMaybe<Scalars["String"]["input"]>
  config_job_communication_template_name?: InputMaybe<
    Scalars["String"]["input"]
  >
  config_legal_known_ticket_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_legal_occupier_ticket_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_occupier_tickets_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_purge_data_threshold_in_days?: InputMaybe<Scalars["bigint"]["input"]>
  config_scheduled_cron_expression?: InputMaybe<Scalars["String"]["input"]>
  config_standard_ticket_dd_age_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_standard_ticket_last_payment_date_limit?: InputMaybe<
    Scalars["Int"]["input"]
  >
  config_standard_ticket_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_standard_ticket_minimum_payment_limit?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  config_standard_ticket_threshold?: InputMaybe<Scalars["Int"]["input"]>
  config_terminating_tickets_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_type?: InputMaybe<Scalars["dunning_workflow_type_enum"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Dunning_Workflow_Stddev_Fields = {
  __typename?: "tickets_dunning_workflow_stddev_fields"
  config_addacs_ticket_threshold?: Maybe<Scalars["Float"]["output"]>
  config_addacs_tickets_limit?: Maybe<Scalars["Float"]["output"]>
  config_debt_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_legal_known_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_legal_occupier_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_occupier_tickets_limit?: Maybe<Scalars["Float"]["output"]>
  config_purge_data_threshold_in_days?: Maybe<Scalars["Float"]["output"]>
  config_standard_ticket_dd_age_limit?: Maybe<Scalars["Float"]["output"]>
  config_standard_ticket_last_payment_date_limit?: Maybe<
    Scalars["Float"]["output"]
  >
  config_standard_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_standard_ticket_minimum_payment_limit?: Maybe<
    Scalars["Float"]["output"]
  >
  config_standard_ticket_threshold?: Maybe<Scalars["Float"]["output"]>
  config_terminating_tickets_limit?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Dunning_Workflow_Stddev_Pop_Fields = {
  __typename?: "tickets_dunning_workflow_stddev_pop_fields"
  config_addacs_ticket_threshold?: Maybe<Scalars["Float"]["output"]>
  config_addacs_tickets_limit?: Maybe<Scalars["Float"]["output"]>
  config_debt_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_legal_known_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_legal_occupier_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_occupier_tickets_limit?: Maybe<Scalars["Float"]["output"]>
  config_purge_data_threshold_in_days?: Maybe<Scalars["Float"]["output"]>
  config_standard_ticket_dd_age_limit?: Maybe<Scalars["Float"]["output"]>
  config_standard_ticket_last_payment_date_limit?: Maybe<
    Scalars["Float"]["output"]
  >
  config_standard_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_standard_ticket_minimum_payment_limit?: Maybe<
    Scalars["Float"]["output"]
  >
  config_standard_ticket_threshold?: Maybe<Scalars["Float"]["output"]>
  config_terminating_tickets_limit?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Dunning_Workflow_Stddev_Samp_Fields = {
  __typename?: "tickets_dunning_workflow_stddev_samp_fields"
  config_addacs_ticket_threshold?: Maybe<Scalars["Float"]["output"]>
  config_addacs_tickets_limit?: Maybe<Scalars["Float"]["output"]>
  config_debt_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_legal_known_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_legal_occupier_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_occupier_tickets_limit?: Maybe<Scalars["Float"]["output"]>
  config_purge_data_threshold_in_days?: Maybe<Scalars["Float"]["output"]>
  config_standard_ticket_dd_age_limit?: Maybe<Scalars["Float"]["output"]>
  config_standard_ticket_last_payment_date_limit?: Maybe<
    Scalars["Float"]["output"]
  >
  config_standard_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_standard_ticket_minimum_payment_limit?: Maybe<
    Scalars["Float"]["output"]
  >
  config_standard_ticket_threshold?: Maybe<Scalars["Float"]["output"]>
  config_terminating_tickets_limit?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_dunning_workflow" */
export type Tickets_Dunning_Workflow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Dunning_Workflow_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Dunning_Workflow_Stream_Cursor_Value_Input = {
  config_addacs_ticket_threshold?: InputMaybe<Scalars["Int"]["input"]>
  config_addacs_tickets_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_debt_ticket_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  config_job_communication_bcc_emails?: InputMaybe<Scalars["String"]["input"]>
  config_job_communication_email?: InputMaybe<Scalars["String"]["input"]>
  config_job_communication_name?: InputMaybe<Scalars["String"]["input"]>
  config_job_communication_template_name?: InputMaybe<
    Scalars["String"]["input"]
  >
  config_legal_known_ticket_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_legal_occupier_ticket_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_occupier_tickets_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_purge_data_threshold_in_days?: InputMaybe<Scalars["bigint"]["input"]>
  config_scheduled_cron_expression?: InputMaybe<Scalars["String"]["input"]>
  config_standard_ticket_dd_age_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_standard_ticket_last_payment_date_limit?: InputMaybe<
    Scalars["Int"]["input"]
  >
  config_standard_ticket_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_standard_ticket_minimum_payment_limit?: InputMaybe<
    Scalars["numeric"]["input"]
  >
  config_standard_ticket_threshold?: InputMaybe<Scalars["Int"]["input"]>
  config_terminating_tickets_limit?: InputMaybe<Scalars["Int"]["input"]>
  config_type?: InputMaybe<Scalars["dunning_workflow_type_enum"]["input"]>
  created_at?: InputMaybe<Scalars["timestamptz"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_Dunning_Workflow_Sum_Fields = {
  __typename?: "tickets_dunning_workflow_sum_fields"
  config_addacs_ticket_threshold?: Maybe<Scalars["Int"]["output"]>
  config_addacs_tickets_limit?: Maybe<Scalars["Int"]["output"]>
  config_debt_ticket_limit?: Maybe<Scalars["Int"]["output"]>
  config_legal_known_ticket_limit?: Maybe<Scalars["Int"]["output"]>
  config_legal_occupier_ticket_limit?: Maybe<Scalars["Int"]["output"]>
  config_occupier_tickets_limit?: Maybe<Scalars["Int"]["output"]>
  config_purge_data_threshold_in_days?: Maybe<Scalars["bigint"]["output"]>
  config_standard_ticket_dd_age_limit?: Maybe<Scalars["Int"]["output"]>
  config_standard_ticket_last_payment_date_limit?: Maybe<
    Scalars["Int"]["output"]
  >
  config_standard_ticket_limit?: Maybe<Scalars["Int"]["output"]>
  config_standard_ticket_minimum_payment_limit?: Maybe<
    Scalars["numeric"]["output"]
  >
  config_standard_ticket_threshold?: Maybe<Scalars["Int"]["output"]>
  config_terminating_tickets_limit?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "dunning_workflow" */
export enum Tickets_Dunning_Workflow_Update_Column {
  /** column name */
  ConfigAddacsTicketThreshold = "config_addacs_ticket_threshold",
  /** column name */
  ConfigAddacsTicketsLimit = "config_addacs_tickets_limit",
  /** column name */
  ConfigDebtTicketLimit = "config_debt_ticket_limit",
  /** column name */
  ConfigEnabled = "config_enabled",
  /** column name */
  ConfigJobCommunicationBccEmails = "config_job_communication_bcc_emails",
  /** column name */
  ConfigJobCommunicationEmail = "config_job_communication_email",
  /** column name */
  ConfigJobCommunicationName = "config_job_communication_name",
  /** column name */
  ConfigJobCommunicationTemplateName = "config_job_communication_template_name",
  /** column name */
  ConfigLegalKnownTicketLimit = "config_legal_known_ticket_limit",
  /** column name */
  ConfigLegalOccupierTicketLimit = "config_legal_occupier_ticket_limit",
  /** column name */
  ConfigOccupierTicketsLimit = "config_occupier_tickets_limit",
  /** column name */
  ConfigPurgeDataThresholdInDays = "config_purge_data_threshold_in_days",
  /** column name */
  ConfigScheduledCronExpression = "config_scheduled_cron_expression",
  /** column name */
  ConfigStandardTicketDdAgeLimit = "config_standard_ticket_dd_age_limit",
  /** column name */
  ConfigStandardTicketLastPaymentDateLimit = "config_standard_ticket_last_payment_date_limit",
  /** column name */
  ConfigStandardTicketLimit = "config_standard_ticket_limit",
  /** column name */
  ConfigStandardTicketMinimumPaymentLimit = "config_standard_ticket_minimum_payment_limit",
  /** column name */
  ConfigStandardTicketThreshold = "config_standard_ticket_threshold",
  /** column name */
  ConfigTerminatingTicketsLimit = "config_terminating_tickets_limit",
  /** column name */
  ConfigType = "config_type",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
}

export type Tickets_Dunning_Workflow_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Dunning_Workflow_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Dunning_Workflow_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Dunning_Workflow_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Dunning_Workflow_Var_Pop_Fields = {
  __typename?: "tickets_dunning_workflow_var_pop_fields"
  config_addacs_ticket_threshold?: Maybe<Scalars["Float"]["output"]>
  config_addacs_tickets_limit?: Maybe<Scalars["Float"]["output"]>
  config_debt_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_legal_known_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_legal_occupier_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_occupier_tickets_limit?: Maybe<Scalars["Float"]["output"]>
  config_purge_data_threshold_in_days?: Maybe<Scalars["Float"]["output"]>
  config_standard_ticket_dd_age_limit?: Maybe<Scalars["Float"]["output"]>
  config_standard_ticket_last_payment_date_limit?: Maybe<
    Scalars["Float"]["output"]
  >
  config_standard_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_standard_ticket_minimum_payment_limit?: Maybe<
    Scalars["Float"]["output"]
  >
  config_standard_ticket_threshold?: Maybe<Scalars["Float"]["output"]>
  config_terminating_tickets_limit?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Dunning_Workflow_Var_Samp_Fields = {
  __typename?: "tickets_dunning_workflow_var_samp_fields"
  config_addacs_ticket_threshold?: Maybe<Scalars["Float"]["output"]>
  config_addacs_tickets_limit?: Maybe<Scalars["Float"]["output"]>
  config_debt_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_legal_known_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_legal_occupier_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_occupier_tickets_limit?: Maybe<Scalars["Float"]["output"]>
  config_purge_data_threshold_in_days?: Maybe<Scalars["Float"]["output"]>
  config_standard_ticket_dd_age_limit?: Maybe<Scalars["Float"]["output"]>
  config_standard_ticket_last_payment_date_limit?: Maybe<
    Scalars["Float"]["output"]
  >
  config_standard_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_standard_ticket_minimum_payment_limit?: Maybe<
    Scalars["Float"]["output"]
  >
  config_standard_ticket_threshold?: Maybe<Scalars["Float"]["output"]>
  config_terminating_tickets_limit?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Dunning_Workflow_Variance_Fields = {
  __typename?: "tickets_dunning_workflow_variance_fields"
  config_addacs_ticket_threshold?: Maybe<Scalars["Float"]["output"]>
  config_addacs_tickets_limit?: Maybe<Scalars["Float"]["output"]>
  config_debt_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_legal_known_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_legal_occupier_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_occupier_tickets_limit?: Maybe<Scalars["Float"]["output"]>
  config_purge_data_threshold_in_days?: Maybe<Scalars["Float"]["output"]>
  config_standard_ticket_dd_age_limit?: Maybe<Scalars["Float"]["output"]>
  config_standard_ticket_last_payment_date_limit?: Maybe<
    Scalars["Float"]["output"]
  >
  config_standard_ticket_limit?: Maybe<Scalars["Float"]["output"]>
  config_standard_ticket_minimum_payment_limit?: Maybe<
    Scalars["Float"]["output"]
  >
  config_standard_ticket_threshold?: Maybe<Scalars["Float"]["output"]>
  config_terminating_tickets_limit?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "external_event" */
export type Tickets_External_Event = {
  __typename?: "tickets_external_event"
  created_at: Scalars["timestamp"]["output"]
  data?: Maybe<Scalars["json"]["output"]>
  event_type?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  source: Scalars["String"]["output"]
}

/** columns and relationships of "external_event" */
export type Tickets_External_EventDataArgs = {
  path?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregated selection of "external_event" */
export type Tickets_External_Event_Aggregate = {
  __typename?: "tickets_external_event_aggregate"
  aggregate?: Maybe<Tickets_External_Event_Aggregate_Fields>
  nodes: Array<Tickets_External_Event>
}

/** aggregate fields of "external_event" */
export type Tickets_External_Event_Aggregate_Fields = {
  __typename?: "tickets_external_event_aggregate_fields"
  avg?: Maybe<Tickets_External_Event_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_External_Event_Max_Fields>
  min?: Maybe<Tickets_External_Event_Min_Fields>
  stddev?: Maybe<Tickets_External_Event_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_External_Event_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_External_Event_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_External_Event_Sum_Fields>
  var_pop?: Maybe<Tickets_External_Event_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_External_Event_Var_Samp_Fields>
  variance?: Maybe<Tickets_External_Event_Variance_Fields>
}

/** aggregate fields of "external_event" */
export type Tickets_External_Event_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_External_Event_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_External_Event_Avg_Fields = {
  __typename?: "tickets_external_event_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "external_event". All fields are combined with a logical 'AND'. */
export type Tickets_External_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_External_Event_Bool_Exp>>
  _not?: InputMaybe<Tickets_External_Event_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_External_Event_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  data?: InputMaybe<Json_Comparison_Exp>
  event_type?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  source?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "external_event" */
export enum Tickets_External_Event_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkExternalEvents = "pk_external_events",
}

/** input type for incrementing numeric columns in table "external_event" */
export type Tickets_External_Event_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "external_event" */
export type Tickets_External_Event_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  data?: InputMaybe<Scalars["json"]["input"]>
  event_type?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  source?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_External_Event_Max_Fields = {
  __typename?: "tickets_external_event_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  event_type?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  source?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_External_Event_Min_Fields = {
  __typename?: "tickets_external_event_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  event_type?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  source?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "external_event" */
export type Tickets_External_Event_Mutation_Response = {
  __typename?: "tickets_external_event_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_External_Event>
}

/** on_conflict condition type for table "external_event" */
export type Tickets_External_Event_On_Conflict = {
  constraint: Tickets_External_Event_Constraint
  update_columns?: Array<Tickets_External_Event_Update_Column>
  where?: InputMaybe<Tickets_External_Event_Bool_Exp>
}

/** Ordering options when selecting data from "external_event". */
export type Tickets_External_Event_Order_By = {
  created_at?: InputMaybe<Order_By>
  data?: InputMaybe<Order_By>
  event_type?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  source?: InputMaybe<Order_By>
}

/** primary key columns input for table: external_event */
export type Tickets_External_Event_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "external_event" */
export enum Tickets_External_Event_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Data = "data",
  /** column name */
  EventType = "event_type",
  /** column name */
  Id = "id",
  /** column name */
  Source = "source",
}

/** input type for updating data in table "external_event" */
export type Tickets_External_Event_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  data?: InputMaybe<Scalars["json"]["input"]>
  event_type?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  source?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_External_Event_Stddev_Fields = {
  __typename?: "tickets_external_event_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_External_Event_Stddev_Pop_Fields = {
  __typename?: "tickets_external_event_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_External_Event_Stddev_Samp_Fields = {
  __typename?: "tickets_external_event_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_external_event" */
export type Tickets_External_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_External_Event_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_External_Event_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  data?: InputMaybe<Scalars["json"]["input"]>
  event_type?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  source?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_External_Event_Sum_Fields = {
  __typename?: "tickets_external_event_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "external_event" */
export enum Tickets_External_Event_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Data = "data",
  /** column name */
  EventType = "event_type",
  /** column name */
  Id = "id",
  /** column name */
  Source = "source",
}

export type Tickets_External_Event_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_External_Event_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_External_Event_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_External_Event_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_External_Event_Var_Pop_Fields = {
  __typename?: "tickets_external_event_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_External_Event_Var_Samp_Fields = {
  __typename?: "tickets_external_event_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_External_Event_Variance_Fields = {
  __typename?: "tickets_external_event_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "external_tickets" */
export type Tickets_External_Tickets = {
  __typename?: "tickets_external_tickets"
  account_number: Scalars["String"]["output"]
  created_at: Scalars["timestamp"]["output"]
  error_text?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  source: Scalars["String"]["output"]
  status?: Maybe<Scalars["account_event_status"]["output"]>
  ticket_id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregated selection of "external_tickets" */
export type Tickets_External_Tickets_Aggregate = {
  __typename?: "tickets_external_tickets_aggregate"
  aggregate?: Maybe<Tickets_External_Tickets_Aggregate_Fields>
  nodes: Array<Tickets_External_Tickets>
}

/** aggregate fields of "external_tickets" */
export type Tickets_External_Tickets_Aggregate_Fields = {
  __typename?: "tickets_external_tickets_aggregate_fields"
  avg?: Maybe<Tickets_External_Tickets_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_External_Tickets_Max_Fields>
  min?: Maybe<Tickets_External_Tickets_Min_Fields>
  stddev?: Maybe<Tickets_External_Tickets_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_External_Tickets_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_External_Tickets_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_External_Tickets_Sum_Fields>
  var_pop?: Maybe<Tickets_External_Tickets_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_External_Tickets_Var_Samp_Fields>
  variance?: Maybe<Tickets_External_Tickets_Variance_Fields>
}

/** aggregate fields of "external_tickets" */
export type Tickets_External_Tickets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_External_Tickets_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_External_Tickets_Avg_Fields = {
  __typename?: "tickets_external_tickets_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ticket_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "external_tickets". All fields are combined with a logical 'AND'. */
export type Tickets_External_Tickets_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_External_Tickets_Bool_Exp>>
  _not?: InputMaybe<Tickets_External_Tickets_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_External_Tickets_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  error_text?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  source?: InputMaybe<String_Comparison_Exp>
  status?: InputMaybe<Account_Event_Status_Comparison_Exp>
  ticket_id?: InputMaybe<Bigint_Comparison_Exp>
}

/** unique or primary key constraints on table "external_tickets" */
export enum Tickets_External_Tickets_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkExternalTickets = "pk_external_tickets",
}

/** input type for incrementing numeric columns in table "external_tickets" */
export type Tickets_External_Tickets_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  ticket_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "external_tickets" */
export type Tickets_External_Tickets_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  error_text?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  source?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["account_event_status"]["input"]>
  ticket_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate max on columns */
export type Tickets_External_Tickets_Max_Fields = {
  __typename?: "tickets_external_tickets_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  error_text?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  source?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["account_event_status"]["output"]>
  ticket_id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregate min on columns */
export type Tickets_External_Tickets_Min_Fields = {
  __typename?: "tickets_external_tickets_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  error_text?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  source?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["account_event_status"]["output"]>
  ticket_id?: Maybe<Scalars["bigint"]["output"]>
}

/** response of any mutation on the table "external_tickets" */
export type Tickets_External_Tickets_Mutation_Response = {
  __typename?: "tickets_external_tickets_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_External_Tickets>
}

/** on_conflict condition type for table "external_tickets" */
export type Tickets_External_Tickets_On_Conflict = {
  constraint: Tickets_External_Tickets_Constraint
  update_columns?: Array<Tickets_External_Tickets_Update_Column>
  where?: InputMaybe<Tickets_External_Tickets_Bool_Exp>
}

/** Ordering options when selecting data from "external_tickets". */
export type Tickets_External_Tickets_Order_By = {
  account_number?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  error_text?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  source?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  ticket_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: external_tickets */
export type Tickets_External_Tickets_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "external_tickets" */
export enum Tickets_External_Tickets_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  ErrorText = "error_text",
  /** column name */
  Id = "id",
  /** column name */
  Source = "source",
  /** column name */
  Status = "status",
  /** column name */
  TicketId = "ticket_id",
}

/** input type for updating data in table "external_tickets" */
export type Tickets_External_Tickets_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  error_text?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  source?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["account_event_status"]["input"]>
  ticket_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_External_Tickets_Stddev_Fields = {
  __typename?: "tickets_external_tickets_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ticket_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_External_Tickets_Stddev_Pop_Fields = {
  __typename?: "tickets_external_tickets_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ticket_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_External_Tickets_Stddev_Samp_Fields = {
  __typename?: "tickets_external_tickets_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ticket_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_external_tickets" */
export type Tickets_External_Tickets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_External_Tickets_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_External_Tickets_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  error_text?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  source?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["account_event_status"]["input"]>
  ticket_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_External_Tickets_Sum_Fields = {
  __typename?: "tickets_external_tickets_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  ticket_id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "external_tickets" */
export enum Tickets_External_Tickets_Update_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  ErrorText = "error_text",
  /** column name */
  Id = "id",
  /** column name */
  Source = "source",
  /** column name */
  Status = "status",
  /** column name */
  TicketId = "ticket_id",
}

export type Tickets_External_Tickets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_External_Tickets_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_External_Tickets_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_External_Tickets_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_External_Tickets_Var_Pop_Fields = {
  __typename?: "tickets_external_tickets_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ticket_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_External_Tickets_Var_Samp_Fields = {
  __typename?: "tickets_external_tickets_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ticket_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_External_Tickets_Variance_Fields = {
  __typename?: "tickets_external_tickets_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ticket_id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "qrtz_blob_triggers" */
export type Tickets_Qrtz_Blob_Triggers = {
  __typename?: "tickets_qrtz_blob_triggers"
  blob_data?: Maybe<Scalars["String"]["output"]>
  sched_name: Scalars["String"]["output"]
  trigger_group: Scalars["String"]["output"]
  trigger_name: Scalars["String"]["output"]
}

/** aggregated selection of "qrtz_blob_triggers" */
export type Tickets_Qrtz_Blob_Triggers_Aggregate = {
  __typename?: "tickets_qrtz_blob_triggers_aggregate"
  aggregate?: Maybe<Tickets_Qrtz_Blob_Triggers_Aggregate_Fields>
  nodes: Array<Tickets_Qrtz_Blob_Triggers>
}

/** aggregate fields of "qrtz_blob_triggers" */
export type Tickets_Qrtz_Blob_Triggers_Aggregate_Fields = {
  __typename?: "tickets_qrtz_blob_triggers_aggregate_fields"
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Qrtz_Blob_Triggers_Max_Fields>
  min?: Maybe<Tickets_Qrtz_Blob_Triggers_Min_Fields>
}

/** aggregate fields of "qrtz_blob_triggers" */
export type Tickets_Qrtz_Blob_Triggers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Qrtz_Blob_Triggers_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** Boolean expression to filter rows from the table "qrtz_blob_triggers". All fields are combined with a logical 'AND'. */
export type Tickets_Qrtz_Blob_Triggers_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Qrtz_Blob_Triggers_Bool_Exp>>
  _not?: InputMaybe<Tickets_Qrtz_Blob_Triggers_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Qrtz_Blob_Triggers_Bool_Exp>>
  blob_data?: InputMaybe<String_Comparison_Exp>
  sched_name?: InputMaybe<String_Comparison_Exp>
  trigger_group?: InputMaybe<String_Comparison_Exp>
  trigger_name?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "qrtz_blob_triggers" */
export enum Tickets_Qrtz_Blob_Triggers_Constraint {
  /** unique or primary key constraint on columns "sched_name", "trigger_group", "trigger_name" */
  QrtzBlobTriggersPkey = "qrtz_blob_triggers_pkey",
}

/** input type for inserting data into table "qrtz_blob_triggers" */
export type Tickets_Qrtz_Blob_Triggers_Insert_Input = {
  blob_data?: InputMaybe<Scalars["String"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Qrtz_Blob_Triggers_Max_Fields = {
  __typename?: "tickets_qrtz_blob_triggers_max_fields"
  blob_data?: Maybe<Scalars["String"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Qrtz_Blob_Triggers_Min_Fields = {
  __typename?: "tickets_qrtz_blob_triggers_min_fields"
  blob_data?: Maybe<Scalars["String"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "qrtz_blob_triggers" */
export type Tickets_Qrtz_Blob_Triggers_Mutation_Response = {
  __typename?: "tickets_qrtz_blob_triggers_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Qrtz_Blob_Triggers>
}

/** on_conflict condition type for table "qrtz_blob_triggers" */
export type Tickets_Qrtz_Blob_Triggers_On_Conflict = {
  constraint: Tickets_Qrtz_Blob_Triggers_Constraint
  update_columns?: Array<Tickets_Qrtz_Blob_Triggers_Update_Column>
  where?: InputMaybe<Tickets_Qrtz_Blob_Triggers_Bool_Exp>
}

/** Ordering options when selecting data from "qrtz_blob_triggers". */
export type Tickets_Qrtz_Blob_Triggers_Order_By = {
  blob_data?: InputMaybe<Order_By>
  sched_name?: InputMaybe<Order_By>
  trigger_group?: InputMaybe<Order_By>
  trigger_name?: InputMaybe<Order_By>
}

/** primary key columns input for table: qrtz_blob_triggers */
export type Tickets_Qrtz_Blob_Triggers_Pk_Columns_Input = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

/** select columns of table "qrtz_blob_triggers" */
export enum Tickets_Qrtz_Blob_Triggers_Select_Column {
  /** column name */
  BlobData = "blob_data",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
}

/** input type for updating data in table "qrtz_blob_triggers" */
export type Tickets_Qrtz_Blob_Triggers_Set_Input = {
  blob_data?: InputMaybe<Scalars["String"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** Streaming cursor of the table "tickets_qrtz_blob_triggers" */
export type Tickets_Qrtz_Blob_Triggers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Qrtz_Blob_Triggers_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Qrtz_Blob_Triggers_Stream_Cursor_Value_Input = {
  blob_data?: InputMaybe<Scalars["String"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** update columns of table "qrtz_blob_triggers" */
export enum Tickets_Qrtz_Blob_Triggers_Update_Column {
  /** column name */
  BlobData = "blob_data",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
}

export type Tickets_Qrtz_Blob_Triggers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Qrtz_Blob_Triggers_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Qrtz_Blob_Triggers_Bool_Exp
}

/** columns and relationships of "qrtz_calendars" */
export type Tickets_Qrtz_Calendars = {
  __typename?: "tickets_qrtz_calendars"
  calendar: Scalars["String"]["output"]
  calendar_name: Scalars["String"]["output"]
  sched_name: Scalars["String"]["output"]
}

/** aggregated selection of "qrtz_calendars" */
export type Tickets_Qrtz_Calendars_Aggregate = {
  __typename?: "tickets_qrtz_calendars_aggregate"
  aggregate?: Maybe<Tickets_Qrtz_Calendars_Aggregate_Fields>
  nodes: Array<Tickets_Qrtz_Calendars>
}

/** aggregate fields of "qrtz_calendars" */
export type Tickets_Qrtz_Calendars_Aggregate_Fields = {
  __typename?: "tickets_qrtz_calendars_aggregate_fields"
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Qrtz_Calendars_Max_Fields>
  min?: Maybe<Tickets_Qrtz_Calendars_Min_Fields>
}

/** aggregate fields of "qrtz_calendars" */
export type Tickets_Qrtz_Calendars_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Qrtz_Calendars_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** Boolean expression to filter rows from the table "qrtz_calendars". All fields are combined with a logical 'AND'. */
export type Tickets_Qrtz_Calendars_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Qrtz_Calendars_Bool_Exp>>
  _not?: InputMaybe<Tickets_Qrtz_Calendars_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Qrtz_Calendars_Bool_Exp>>
  calendar?: InputMaybe<String_Comparison_Exp>
  calendar_name?: InputMaybe<String_Comparison_Exp>
  sched_name?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "qrtz_calendars" */
export enum Tickets_Qrtz_Calendars_Constraint {
  /** unique or primary key constraint on columns "sched_name", "calendar_name" */
  QrtzCalendarsPkey = "qrtz_calendars_pkey",
}

/** input type for inserting data into table "qrtz_calendars" */
export type Tickets_Qrtz_Calendars_Insert_Input = {
  calendar?: InputMaybe<Scalars["String"]["input"]>
  calendar_name?: InputMaybe<Scalars["String"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Qrtz_Calendars_Max_Fields = {
  __typename?: "tickets_qrtz_calendars_max_fields"
  calendar?: Maybe<Scalars["String"]["output"]>
  calendar_name?: Maybe<Scalars["String"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Qrtz_Calendars_Min_Fields = {
  __typename?: "tickets_qrtz_calendars_min_fields"
  calendar?: Maybe<Scalars["String"]["output"]>
  calendar_name?: Maybe<Scalars["String"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "qrtz_calendars" */
export type Tickets_Qrtz_Calendars_Mutation_Response = {
  __typename?: "tickets_qrtz_calendars_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Qrtz_Calendars>
}

/** on_conflict condition type for table "qrtz_calendars" */
export type Tickets_Qrtz_Calendars_On_Conflict = {
  constraint: Tickets_Qrtz_Calendars_Constraint
  update_columns?: Array<Tickets_Qrtz_Calendars_Update_Column>
  where?: InputMaybe<Tickets_Qrtz_Calendars_Bool_Exp>
}

/** Ordering options when selecting data from "qrtz_calendars". */
export type Tickets_Qrtz_Calendars_Order_By = {
  calendar?: InputMaybe<Order_By>
  calendar_name?: InputMaybe<Order_By>
  sched_name?: InputMaybe<Order_By>
}

/** primary key columns input for table: qrtz_calendars */
export type Tickets_Qrtz_Calendars_Pk_Columns_Input = {
  calendar_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

/** select columns of table "qrtz_calendars" */
export enum Tickets_Qrtz_Calendars_Select_Column {
  /** column name */
  Calendar = "calendar",
  /** column name */
  CalendarName = "calendar_name",
  /** column name */
  SchedName = "sched_name",
}

/** input type for updating data in table "qrtz_calendars" */
export type Tickets_Qrtz_Calendars_Set_Input = {
  calendar?: InputMaybe<Scalars["String"]["input"]>
  calendar_name?: InputMaybe<Scalars["String"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
}

/** Streaming cursor of the table "tickets_qrtz_calendars" */
export type Tickets_Qrtz_Calendars_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Qrtz_Calendars_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Qrtz_Calendars_Stream_Cursor_Value_Input = {
  calendar?: InputMaybe<Scalars["String"]["input"]>
  calendar_name?: InputMaybe<Scalars["String"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
}

/** update columns of table "qrtz_calendars" */
export enum Tickets_Qrtz_Calendars_Update_Column {
  /** column name */
  Calendar = "calendar",
  /** column name */
  CalendarName = "calendar_name",
  /** column name */
  SchedName = "sched_name",
}

export type Tickets_Qrtz_Calendars_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Qrtz_Calendars_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Qrtz_Calendars_Bool_Exp
}

/** columns and relationships of "qrtz_cron_triggers" */
export type Tickets_Qrtz_Cron_Triggers = {
  __typename?: "tickets_qrtz_cron_triggers"
  cron_expression: Scalars["String"]["output"]
  sched_name: Scalars["String"]["output"]
  time_zone_id?: Maybe<Scalars["String"]["output"]>
  trigger_group: Scalars["String"]["output"]
  trigger_name: Scalars["String"]["output"]
}

/** aggregated selection of "qrtz_cron_triggers" */
export type Tickets_Qrtz_Cron_Triggers_Aggregate = {
  __typename?: "tickets_qrtz_cron_triggers_aggregate"
  aggregate?: Maybe<Tickets_Qrtz_Cron_Triggers_Aggregate_Fields>
  nodes: Array<Tickets_Qrtz_Cron_Triggers>
}

/** aggregate fields of "qrtz_cron_triggers" */
export type Tickets_Qrtz_Cron_Triggers_Aggregate_Fields = {
  __typename?: "tickets_qrtz_cron_triggers_aggregate_fields"
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Qrtz_Cron_Triggers_Max_Fields>
  min?: Maybe<Tickets_Qrtz_Cron_Triggers_Min_Fields>
}

/** aggregate fields of "qrtz_cron_triggers" */
export type Tickets_Qrtz_Cron_Triggers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Qrtz_Cron_Triggers_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** Boolean expression to filter rows from the table "qrtz_cron_triggers". All fields are combined with a logical 'AND'. */
export type Tickets_Qrtz_Cron_Triggers_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Qrtz_Cron_Triggers_Bool_Exp>>
  _not?: InputMaybe<Tickets_Qrtz_Cron_Triggers_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Qrtz_Cron_Triggers_Bool_Exp>>
  cron_expression?: InputMaybe<String_Comparison_Exp>
  sched_name?: InputMaybe<String_Comparison_Exp>
  time_zone_id?: InputMaybe<String_Comparison_Exp>
  trigger_group?: InputMaybe<String_Comparison_Exp>
  trigger_name?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "qrtz_cron_triggers" */
export enum Tickets_Qrtz_Cron_Triggers_Constraint {
  /** unique or primary key constraint on columns "sched_name", "trigger_group", "trigger_name" */
  QrtzCronTriggersPkey = "qrtz_cron_triggers_pkey",
}

/** input type for inserting data into table "qrtz_cron_triggers" */
export type Tickets_Qrtz_Cron_Triggers_Insert_Input = {
  cron_expression?: InputMaybe<Scalars["String"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  time_zone_id?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Qrtz_Cron_Triggers_Max_Fields = {
  __typename?: "tickets_qrtz_cron_triggers_max_fields"
  cron_expression?: Maybe<Scalars["String"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  time_zone_id?: Maybe<Scalars["String"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Qrtz_Cron_Triggers_Min_Fields = {
  __typename?: "tickets_qrtz_cron_triggers_min_fields"
  cron_expression?: Maybe<Scalars["String"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  time_zone_id?: Maybe<Scalars["String"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "qrtz_cron_triggers" */
export type Tickets_Qrtz_Cron_Triggers_Mutation_Response = {
  __typename?: "tickets_qrtz_cron_triggers_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Qrtz_Cron_Triggers>
}

/** on_conflict condition type for table "qrtz_cron_triggers" */
export type Tickets_Qrtz_Cron_Triggers_On_Conflict = {
  constraint: Tickets_Qrtz_Cron_Triggers_Constraint
  update_columns?: Array<Tickets_Qrtz_Cron_Triggers_Update_Column>
  where?: InputMaybe<Tickets_Qrtz_Cron_Triggers_Bool_Exp>
}

/** Ordering options when selecting data from "qrtz_cron_triggers". */
export type Tickets_Qrtz_Cron_Triggers_Order_By = {
  cron_expression?: InputMaybe<Order_By>
  sched_name?: InputMaybe<Order_By>
  time_zone_id?: InputMaybe<Order_By>
  trigger_group?: InputMaybe<Order_By>
  trigger_name?: InputMaybe<Order_By>
}

/** primary key columns input for table: qrtz_cron_triggers */
export type Tickets_Qrtz_Cron_Triggers_Pk_Columns_Input = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

/** select columns of table "qrtz_cron_triggers" */
export enum Tickets_Qrtz_Cron_Triggers_Select_Column {
  /** column name */
  CronExpression = "cron_expression",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  TimeZoneId = "time_zone_id",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
}

/** input type for updating data in table "qrtz_cron_triggers" */
export type Tickets_Qrtz_Cron_Triggers_Set_Input = {
  cron_expression?: InputMaybe<Scalars["String"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  time_zone_id?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** Streaming cursor of the table "tickets_qrtz_cron_triggers" */
export type Tickets_Qrtz_Cron_Triggers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Qrtz_Cron_Triggers_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Qrtz_Cron_Triggers_Stream_Cursor_Value_Input = {
  cron_expression?: InputMaybe<Scalars["String"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  time_zone_id?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** update columns of table "qrtz_cron_triggers" */
export enum Tickets_Qrtz_Cron_Triggers_Update_Column {
  /** column name */
  CronExpression = "cron_expression",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  TimeZoneId = "time_zone_id",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
}

export type Tickets_Qrtz_Cron_Triggers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Qrtz_Cron_Triggers_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Qrtz_Cron_Triggers_Bool_Exp
}

/** columns and relationships of "qrtz_fired_triggers" */
export type Tickets_Qrtz_Fired_Triggers = {
  __typename?: "tickets_qrtz_fired_triggers"
  entry_id: Scalars["String"]["output"]
  fired_time: Scalars["bigint"]["output"]
  instance_name: Scalars["String"]["output"]
  is_nonconcurrent?: Maybe<Scalars["Boolean"]["output"]>
  is_update_data?: Maybe<Scalars["Boolean"]["output"]>
  job_group?: Maybe<Scalars["String"]["output"]>
  job_name?: Maybe<Scalars["String"]["output"]>
  priority: Scalars["Int"]["output"]
  requests_recovery?: Maybe<Scalars["Boolean"]["output"]>
  sched_name: Scalars["String"]["output"]
  sched_time: Scalars["bigint"]["output"]
  state: Scalars["String"]["output"]
  trigger_group: Scalars["String"]["output"]
  trigger_name: Scalars["String"]["output"]
}

/** aggregated selection of "qrtz_fired_triggers" */
export type Tickets_Qrtz_Fired_Triggers_Aggregate = {
  __typename?: "tickets_qrtz_fired_triggers_aggregate"
  aggregate?: Maybe<Tickets_Qrtz_Fired_Triggers_Aggregate_Fields>
  nodes: Array<Tickets_Qrtz_Fired_Triggers>
}

/** aggregate fields of "qrtz_fired_triggers" */
export type Tickets_Qrtz_Fired_Triggers_Aggregate_Fields = {
  __typename?: "tickets_qrtz_fired_triggers_aggregate_fields"
  avg?: Maybe<Tickets_Qrtz_Fired_Triggers_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Qrtz_Fired_Triggers_Max_Fields>
  min?: Maybe<Tickets_Qrtz_Fired_Triggers_Min_Fields>
  stddev?: Maybe<Tickets_Qrtz_Fired_Triggers_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Qrtz_Fired_Triggers_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Qrtz_Fired_Triggers_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Qrtz_Fired_Triggers_Sum_Fields>
  var_pop?: Maybe<Tickets_Qrtz_Fired_Triggers_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Qrtz_Fired_Triggers_Var_Samp_Fields>
  variance?: Maybe<Tickets_Qrtz_Fired_Triggers_Variance_Fields>
}

/** aggregate fields of "qrtz_fired_triggers" */
export type Tickets_Qrtz_Fired_Triggers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Qrtz_Fired_Triggers_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_Qrtz_Fired_Triggers_Avg_Fields = {
  __typename?: "tickets_qrtz_fired_triggers_avg_fields"
  fired_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  sched_time?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "qrtz_fired_triggers". All fields are combined with a logical 'AND'. */
export type Tickets_Qrtz_Fired_Triggers_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Qrtz_Fired_Triggers_Bool_Exp>>
  _not?: InputMaybe<Tickets_Qrtz_Fired_Triggers_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Qrtz_Fired_Triggers_Bool_Exp>>
  entry_id?: InputMaybe<String_Comparison_Exp>
  fired_time?: InputMaybe<Bigint_Comparison_Exp>
  instance_name?: InputMaybe<String_Comparison_Exp>
  is_nonconcurrent?: InputMaybe<Boolean_Comparison_Exp>
  is_update_data?: InputMaybe<Boolean_Comparison_Exp>
  job_group?: InputMaybe<String_Comparison_Exp>
  job_name?: InputMaybe<String_Comparison_Exp>
  priority?: InputMaybe<Int_Comparison_Exp>
  requests_recovery?: InputMaybe<Boolean_Comparison_Exp>
  sched_name?: InputMaybe<String_Comparison_Exp>
  sched_time?: InputMaybe<Bigint_Comparison_Exp>
  state?: InputMaybe<String_Comparison_Exp>
  trigger_group?: InputMaybe<String_Comparison_Exp>
  trigger_name?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "qrtz_fired_triggers" */
export enum Tickets_Qrtz_Fired_Triggers_Constraint {
  /** unique or primary key constraint on columns "entry_id", "sched_name" */
  QrtzFiredTriggersPkey = "qrtz_fired_triggers_pkey",
}

/** input type for incrementing numeric columns in table "qrtz_fired_triggers" */
export type Tickets_Qrtz_Fired_Triggers_Inc_Input = {
  fired_time?: InputMaybe<Scalars["bigint"]["input"]>
  priority?: InputMaybe<Scalars["Int"]["input"]>
  sched_time?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "qrtz_fired_triggers" */
export type Tickets_Qrtz_Fired_Triggers_Insert_Input = {
  entry_id?: InputMaybe<Scalars["String"]["input"]>
  fired_time?: InputMaybe<Scalars["bigint"]["input"]>
  instance_name?: InputMaybe<Scalars["String"]["input"]>
  is_nonconcurrent?: InputMaybe<Scalars["Boolean"]["input"]>
  is_update_data?: InputMaybe<Scalars["Boolean"]["input"]>
  job_group?: InputMaybe<Scalars["String"]["input"]>
  job_name?: InputMaybe<Scalars["String"]["input"]>
  priority?: InputMaybe<Scalars["Int"]["input"]>
  requests_recovery?: InputMaybe<Scalars["Boolean"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  sched_time?: InputMaybe<Scalars["bigint"]["input"]>
  state?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Qrtz_Fired_Triggers_Max_Fields = {
  __typename?: "tickets_qrtz_fired_triggers_max_fields"
  entry_id?: Maybe<Scalars["String"]["output"]>
  fired_time?: Maybe<Scalars["bigint"]["output"]>
  instance_name?: Maybe<Scalars["String"]["output"]>
  job_group?: Maybe<Scalars["String"]["output"]>
  job_name?: Maybe<Scalars["String"]["output"]>
  priority?: Maybe<Scalars["Int"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  sched_time?: Maybe<Scalars["bigint"]["output"]>
  state?: Maybe<Scalars["String"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Qrtz_Fired_Triggers_Min_Fields = {
  __typename?: "tickets_qrtz_fired_triggers_min_fields"
  entry_id?: Maybe<Scalars["String"]["output"]>
  fired_time?: Maybe<Scalars["bigint"]["output"]>
  instance_name?: Maybe<Scalars["String"]["output"]>
  job_group?: Maybe<Scalars["String"]["output"]>
  job_name?: Maybe<Scalars["String"]["output"]>
  priority?: Maybe<Scalars["Int"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  sched_time?: Maybe<Scalars["bigint"]["output"]>
  state?: Maybe<Scalars["String"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "qrtz_fired_triggers" */
export type Tickets_Qrtz_Fired_Triggers_Mutation_Response = {
  __typename?: "tickets_qrtz_fired_triggers_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Qrtz_Fired_Triggers>
}

/** on_conflict condition type for table "qrtz_fired_triggers" */
export type Tickets_Qrtz_Fired_Triggers_On_Conflict = {
  constraint: Tickets_Qrtz_Fired_Triggers_Constraint
  update_columns?: Array<Tickets_Qrtz_Fired_Triggers_Update_Column>
  where?: InputMaybe<Tickets_Qrtz_Fired_Triggers_Bool_Exp>
}

/** Ordering options when selecting data from "qrtz_fired_triggers". */
export type Tickets_Qrtz_Fired_Triggers_Order_By = {
  entry_id?: InputMaybe<Order_By>
  fired_time?: InputMaybe<Order_By>
  instance_name?: InputMaybe<Order_By>
  is_nonconcurrent?: InputMaybe<Order_By>
  is_update_data?: InputMaybe<Order_By>
  job_group?: InputMaybe<Order_By>
  job_name?: InputMaybe<Order_By>
  priority?: InputMaybe<Order_By>
  requests_recovery?: InputMaybe<Order_By>
  sched_name?: InputMaybe<Order_By>
  sched_time?: InputMaybe<Order_By>
  state?: InputMaybe<Order_By>
  trigger_group?: InputMaybe<Order_By>
  trigger_name?: InputMaybe<Order_By>
}

/** primary key columns input for table: qrtz_fired_triggers */
export type Tickets_Qrtz_Fired_Triggers_Pk_Columns_Input = {
  entry_id: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

/** select columns of table "qrtz_fired_triggers" */
export enum Tickets_Qrtz_Fired_Triggers_Select_Column {
  /** column name */
  EntryId = "entry_id",
  /** column name */
  FiredTime = "fired_time",
  /** column name */
  InstanceName = "instance_name",
  /** column name */
  IsNonconcurrent = "is_nonconcurrent",
  /** column name */
  IsUpdateData = "is_update_data",
  /** column name */
  JobGroup = "job_group",
  /** column name */
  JobName = "job_name",
  /** column name */
  Priority = "priority",
  /** column name */
  RequestsRecovery = "requests_recovery",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  SchedTime = "sched_time",
  /** column name */
  State = "state",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
}

/** input type for updating data in table "qrtz_fired_triggers" */
export type Tickets_Qrtz_Fired_Triggers_Set_Input = {
  entry_id?: InputMaybe<Scalars["String"]["input"]>
  fired_time?: InputMaybe<Scalars["bigint"]["input"]>
  instance_name?: InputMaybe<Scalars["String"]["input"]>
  is_nonconcurrent?: InputMaybe<Scalars["Boolean"]["input"]>
  is_update_data?: InputMaybe<Scalars["Boolean"]["input"]>
  job_group?: InputMaybe<Scalars["String"]["input"]>
  job_name?: InputMaybe<Scalars["String"]["input"]>
  priority?: InputMaybe<Scalars["Int"]["input"]>
  requests_recovery?: InputMaybe<Scalars["Boolean"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  sched_time?: InputMaybe<Scalars["bigint"]["input"]>
  state?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Qrtz_Fired_Triggers_Stddev_Fields = {
  __typename?: "tickets_qrtz_fired_triggers_stddev_fields"
  fired_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  sched_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Qrtz_Fired_Triggers_Stddev_Pop_Fields = {
  __typename?: "tickets_qrtz_fired_triggers_stddev_pop_fields"
  fired_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  sched_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Qrtz_Fired_Triggers_Stddev_Samp_Fields = {
  __typename?: "tickets_qrtz_fired_triggers_stddev_samp_fields"
  fired_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  sched_time?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_qrtz_fired_triggers" */
export type Tickets_Qrtz_Fired_Triggers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Qrtz_Fired_Triggers_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Qrtz_Fired_Triggers_Stream_Cursor_Value_Input = {
  entry_id?: InputMaybe<Scalars["String"]["input"]>
  fired_time?: InputMaybe<Scalars["bigint"]["input"]>
  instance_name?: InputMaybe<Scalars["String"]["input"]>
  is_nonconcurrent?: InputMaybe<Scalars["Boolean"]["input"]>
  is_update_data?: InputMaybe<Scalars["Boolean"]["input"]>
  job_group?: InputMaybe<Scalars["String"]["input"]>
  job_name?: InputMaybe<Scalars["String"]["input"]>
  priority?: InputMaybe<Scalars["Int"]["input"]>
  requests_recovery?: InputMaybe<Scalars["Boolean"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  sched_time?: InputMaybe<Scalars["bigint"]["input"]>
  state?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_Qrtz_Fired_Triggers_Sum_Fields = {
  __typename?: "tickets_qrtz_fired_triggers_sum_fields"
  fired_time?: Maybe<Scalars["bigint"]["output"]>
  priority?: Maybe<Scalars["Int"]["output"]>
  sched_time?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "qrtz_fired_triggers" */
export enum Tickets_Qrtz_Fired_Triggers_Update_Column {
  /** column name */
  EntryId = "entry_id",
  /** column name */
  FiredTime = "fired_time",
  /** column name */
  InstanceName = "instance_name",
  /** column name */
  IsNonconcurrent = "is_nonconcurrent",
  /** column name */
  IsUpdateData = "is_update_data",
  /** column name */
  JobGroup = "job_group",
  /** column name */
  JobName = "job_name",
  /** column name */
  Priority = "priority",
  /** column name */
  RequestsRecovery = "requests_recovery",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  SchedTime = "sched_time",
  /** column name */
  State = "state",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
}

export type Tickets_Qrtz_Fired_Triggers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Qrtz_Fired_Triggers_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Qrtz_Fired_Triggers_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Qrtz_Fired_Triggers_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Qrtz_Fired_Triggers_Var_Pop_Fields = {
  __typename?: "tickets_qrtz_fired_triggers_var_pop_fields"
  fired_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  sched_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Qrtz_Fired_Triggers_Var_Samp_Fields = {
  __typename?: "tickets_qrtz_fired_triggers_var_samp_fields"
  fired_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  sched_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Qrtz_Fired_Triggers_Variance_Fields = {
  __typename?: "tickets_qrtz_fired_triggers_variance_fields"
  fired_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  sched_time?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "qrtz_job_details" */
export type Tickets_Qrtz_Job_Details = {
  __typename?: "tickets_qrtz_job_details"
  description?: Maybe<Scalars["String"]["output"]>
  is_durable?: Maybe<Scalars["Boolean"]["output"]>
  is_nonconcurrent?: Maybe<Scalars["Boolean"]["output"]>
  is_update_data?: Maybe<Scalars["Boolean"]["output"]>
  job_class_name: Scalars["String"]["output"]
  job_data?: Maybe<Scalars["bytea"]["output"]>
  job_group: Scalars["String"]["output"]
  job_name: Scalars["String"]["output"]
  requests_recovery?: Maybe<Scalars["Boolean"]["output"]>
  sched_name: Scalars["String"]["output"]
}

/** aggregated selection of "qrtz_job_details" */
export type Tickets_Qrtz_Job_Details_Aggregate = {
  __typename?: "tickets_qrtz_job_details_aggregate"
  aggregate?: Maybe<Tickets_Qrtz_Job_Details_Aggregate_Fields>
  nodes: Array<Tickets_Qrtz_Job_Details>
}

/** aggregate fields of "qrtz_job_details" */
export type Tickets_Qrtz_Job_Details_Aggregate_Fields = {
  __typename?: "tickets_qrtz_job_details_aggregate_fields"
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Qrtz_Job_Details_Max_Fields>
  min?: Maybe<Tickets_Qrtz_Job_Details_Min_Fields>
}

/** aggregate fields of "qrtz_job_details" */
export type Tickets_Qrtz_Job_Details_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Qrtz_Job_Details_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** Boolean expression to filter rows from the table "qrtz_job_details". All fields are combined with a logical 'AND'. */
export type Tickets_Qrtz_Job_Details_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Qrtz_Job_Details_Bool_Exp>>
  _not?: InputMaybe<Tickets_Qrtz_Job_Details_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Qrtz_Job_Details_Bool_Exp>>
  description?: InputMaybe<String_Comparison_Exp>
  is_durable?: InputMaybe<Boolean_Comparison_Exp>
  is_nonconcurrent?: InputMaybe<Boolean_Comparison_Exp>
  is_update_data?: InputMaybe<Boolean_Comparison_Exp>
  job_class_name?: InputMaybe<String_Comparison_Exp>
  job_data?: InputMaybe<Bytea_Comparison_Exp>
  job_group?: InputMaybe<String_Comparison_Exp>
  job_name?: InputMaybe<String_Comparison_Exp>
  requests_recovery?: InputMaybe<Boolean_Comparison_Exp>
  sched_name?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "qrtz_job_details" */
export enum Tickets_Qrtz_Job_Details_Constraint {
  /** unique or primary key constraint on columns "job_group", "sched_name", "job_name" */
  QrtzJobDetailsPkey = "qrtz_job_details_pkey",
}

/** input type for inserting data into table "qrtz_job_details" */
export type Tickets_Qrtz_Job_Details_Insert_Input = {
  description?: InputMaybe<Scalars["String"]["input"]>
  is_durable?: InputMaybe<Scalars["Boolean"]["input"]>
  is_nonconcurrent?: InputMaybe<Scalars["Boolean"]["input"]>
  is_update_data?: InputMaybe<Scalars["Boolean"]["input"]>
  job_class_name?: InputMaybe<Scalars["String"]["input"]>
  job_data?: InputMaybe<Scalars["bytea"]["input"]>
  job_group?: InputMaybe<Scalars["String"]["input"]>
  job_name?: InputMaybe<Scalars["String"]["input"]>
  requests_recovery?: InputMaybe<Scalars["Boolean"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Qrtz_Job_Details_Max_Fields = {
  __typename?: "tickets_qrtz_job_details_max_fields"
  description?: Maybe<Scalars["String"]["output"]>
  job_class_name?: Maybe<Scalars["String"]["output"]>
  job_group?: Maybe<Scalars["String"]["output"]>
  job_name?: Maybe<Scalars["String"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Qrtz_Job_Details_Min_Fields = {
  __typename?: "tickets_qrtz_job_details_min_fields"
  description?: Maybe<Scalars["String"]["output"]>
  job_class_name?: Maybe<Scalars["String"]["output"]>
  job_group?: Maybe<Scalars["String"]["output"]>
  job_name?: Maybe<Scalars["String"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "qrtz_job_details" */
export type Tickets_Qrtz_Job_Details_Mutation_Response = {
  __typename?: "tickets_qrtz_job_details_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Qrtz_Job_Details>
}

/** on_conflict condition type for table "qrtz_job_details" */
export type Tickets_Qrtz_Job_Details_On_Conflict = {
  constraint: Tickets_Qrtz_Job_Details_Constraint
  update_columns?: Array<Tickets_Qrtz_Job_Details_Update_Column>
  where?: InputMaybe<Tickets_Qrtz_Job_Details_Bool_Exp>
}

/** Ordering options when selecting data from "qrtz_job_details". */
export type Tickets_Qrtz_Job_Details_Order_By = {
  description?: InputMaybe<Order_By>
  is_durable?: InputMaybe<Order_By>
  is_nonconcurrent?: InputMaybe<Order_By>
  is_update_data?: InputMaybe<Order_By>
  job_class_name?: InputMaybe<Order_By>
  job_data?: InputMaybe<Order_By>
  job_group?: InputMaybe<Order_By>
  job_name?: InputMaybe<Order_By>
  requests_recovery?: InputMaybe<Order_By>
  sched_name?: InputMaybe<Order_By>
}

/** primary key columns input for table: qrtz_job_details */
export type Tickets_Qrtz_Job_Details_Pk_Columns_Input = {
  job_group: Scalars["String"]["input"]
  job_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

/** select columns of table "qrtz_job_details" */
export enum Tickets_Qrtz_Job_Details_Select_Column {
  /** column name */
  Description = "description",
  /** column name */
  IsDurable = "is_durable",
  /** column name */
  IsNonconcurrent = "is_nonconcurrent",
  /** column name */
  IsUpdateData = "is_update_data",
  /** column name */
  JobClassName = "job_class_name",
  /** column name */
  JobData = "job_data",
  /** column name */
  JobGroup = "job_group",
  /** column name */
  JobName = "job_name",
  /** column name */
  RequestsRecovery = "requests_recovery",
  /** column name */
  SchedName = "sched_name",
}

/** input type for updating data in table "qrtz_job_details" */
export type Tickets_Qrtz_Job_Details_Set_Input = {
  description?: InputMaybe<Scalars["String"]["input"]>
  is_durable?: InputMaybe<Scalars["Boolean"]["input"]>
  is_nonconcurrent?: InputMaybe<Scalars["Boolean"]["input"]>
  is_update_data?: InputMaybe<Scalars["Boolean"]["input"]>
  job_class_name?: InputMaybe<Scalars["String"]["input"]>
  job_data?: InputMaybe<Scalars["bytea"]["input"]>
  job_group?: InputMaybe<Scalars["String"]["input"]>
  job_name?: InputMaybe<Scalars["String"]["input"]>
  requests_recovery?: InputMaybe<Scalars["Boolean"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
}

/** Streaming cursor of the table "tickets_qrtz_job_details" */
export type Tickets_Qrtz_Job_Details_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Qrtz_Job_Details_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Qrtz_Job_Details_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars["String"]["input"]>
  is_durable?: InputMaybe<Scalars["Boolean"]["input"]>
  is_nonconcurrent?: InputMaybe<Scalars["Boolean"]["input"]>
  is_update_data?: InputMaybe<Scalars["Boolean"]["input"]>
  job_class_name?: InputMaybe<Scalars["String"]["input"]>
  job_data?: InputMaybe<Scalars["bytea"]["input"]>
  job_group?: InputMaybe<Scalars["String"]["input"]>
  job_name?: InputMaybe<Scalars["String"]["input"]>
  requests_recovery?: InputMaybe<Scalars["Boolean"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
}

/** update columns of table "qrtz_job_details" */
export enum Tickets_Qrtz_Job_Details_Update_Column {
  /** column name */
  Description = "description",
  /** column name */
  IsDurable = "is_durable",
  /** column name */
  IsNonconcurrent = "is_nonconcurrent",
  /** column name */
  IsUpdateData = "is_update_data",
  /** column name */
  JobClassName = "job_class_name",
  /** column name */
  JobData = "job_data",
  /** column name */
  JobGroup = "job_group",
  /** column name */
  JobName = "job_name",
  /** column name */
  RequestsRecovery = "requests_recovery",
  /** column name */
  SchedName = "sched_name",
}

export type Tickets_Qrtz_Job_Details_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Qrtz_Job_Details_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Qrtz_Job_Details_Bool_Exp
}

/** columns and relationships of "qrtz_locks" */
export type Tickets_Qrtz_Locks = {
  __typename?: "tickets_qrtz_locks"
  lock_name: Scalars["String"]["output"]
  sched_name: Scalars["String"]["output"]
}

/** aggregated selection of "qrtz_locks" */
export type Tickets_Qrtz_Locks_Aggregate = {
  __typename?: "tickets_qrtz_locks_aggregate"
  aggregate?: Maybe<Tickets_Qrtz_Locks_Aggregate_Fields>
  nodes: Array<Tickets_Qrtz_Locks>
}

/** aggregate fields of "qrtz_locks" */
export type Tickets_Qrtz_Locks_Aggregate_Fields = {
  __typename?: "tickets_qrtz_locks_aggregate_fields"
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Qrtz_Locks_Max_Fields>
  min?: Maybe<Tickets_Qrtz_Locks_Min_Fields>
}

/** aggregate fields of "qrtz_locks" */
export type Tickets_Qrtz_Locks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Qrtz_Locks_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** Boolean expression to filter rows from the table "qrtz_locks". All fields are combined with a logical 'AND'. */
export type Tickets_Qrtz_Locks_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Qrtz_Locks_Bool_Exp>>
  _not?: InputMaybe<Tickets_Qrtz_Locks_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Qrtz_Locks_Bool_Exp>>
  lock_name?: InputMaybe<String_Comparison_Exp>
  sched_name?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "qrtz_locks" */
export enum Tickets_Qrtz_Locks_Constraint {
  /** unique or primary key constraint on columns "sched_name", "lock_name" */
  QrtzLocksPkey = "qrtz_locks_pkey",
}

/** input type for inserting data into table "qrtz_locks" */
export type Tickets_Qrtz_Locks_Insert_Input = {
  lock_name?: InputMaybe<Scalars["String"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Qrtz_Locks_Max_Fields = {
  __typename?: "tickets_qrtz_locks_max_fields"
  lock_name?: Maybe<Scalars["String"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Qrtz_Locks_Min_Fields = {
  __typename?: "tickets_qrtz_locks_min_fields"
  lock_name?: Maybe<Scalars["String"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "qrtz_locks" */
export type Tickets_Qrtz_Locks_Mutation_Response = {
  __typename?: "tickets_qrtz_locks_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Qrtz_Locks>
}

/** on_conflict condition type for table "qrtz_locks" */
export type Tickets_Qrtz_Locks_On_Conflict = {
  constraint: Tickets_Qrtz_Locks_Constraint
  update_columns?: Array<Tickets_Qrtz_Locks_Update_Column>
  where?: InputMaybe<Tickets_Qrtz_Locks_Bool_Exp>
}

/** Ordering options when selecting data from "qrtz_locks". */
export type Tickets_Qrtz_Locks_Order_By = {
  lock_name?: InputMaybe<Order_By>
  sched_name?: InputMaybe<Order_By>
}

/** primary key columns input for table: qrtz_locks */
export type Tickets_Qrtz_Locks_Pk_Columns_Input = {
  lock_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

/** select columns of table "qrtz_locks" */
export enum Tickets_Qrtz_Locks_Select_Column {
  /** column name */
  LockName = "lock_name",
  /** column name */
  SchedName = "sched_name",
}

/** input type for updating data in table "qrtz_locks" */
export type Tickets_Qrtz_Locks_Set_Input = {
  lock_name?: InputMaybe<Scalars["String"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
}

/** Streaming cursor of the table "tickets_qrtz_locks" */
export type Tickets_Qrtz_Locks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Qrtz_Locks_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Qrtz_Locks_Stream_Cursor_Value_Input = {
  lock_name?: InputMaybe<Scalars["String"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
}

/** update columns of table "qrtz_locks" */
export enum Tickets_Qrtz_Locks_Update_Column {
  /** column name */
  LockName = "lock_name",
  /** column name */
  SchedName = "sched_name",
}

export type Tickets_Qrtz_Locks_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Qrtz_Locks_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Qrtz_Locks_Bool_Exp
}

/** columns and relationships of "qrtz_paused_trigger_grps" */
export type Tickets_Qrtz_Paused_Trigger_Grps = {
  __typename?: "tickets_qrtz_paused_trigger_grps"
  sched_name: Scalars["String"]["output"]
  trigger_group: Scalars["String"]["output"]
}

/** aggregated selection of "qrtz_paused_trigger_grps" */
export type Tickets_Qrtz_Paused_Trigger_Grps_Aggregate = {
  __typename?: "tickets_qrtz_paused_trigger_grps_aggregate"
  aggregate?: Maybe<Tickets_Qrtz_Paused_Trigger_Grps_Aggregate_Fields>
  nodes: Array<Tickets_Qrtz_Paused_Trigger_Grps>
}

/** aggregate fields of "qrtz_paused_trigger_grps" */
export type Tickets_Qrtz_Paused_Trigger_Grps_Aggregate_Fields = {
  __typename?: "tickets_qrtz_paused_trigger_grps_aggregate_fields"
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Qrtz_Paused_Trigger_Grps_Max_Fields>
  min?: Maybe<Tickets_Qrtz_Paused_Trigger_Grps_Min_Fields>
}

/** aggregate fields of "qrtz_paused_trigger_grps" */
export type Tickets_Qrtz_Paused_Trigger_Grps_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Qrtz_Paused_Trigger_Grps_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** Boolean expression to filter rows from the table "qrtz_paused_trigger_grps". All fields are combined with a logical 'AND'. */
export type Tickets_Qrtz_Paused_Trigger_Grps_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Qrtz_Paused_Trigger_Grps_Bool_Exp>>
  _not?: InputMaybe<Tickets_Qrtz_Paused_Trigger_Grps_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Qrtz_Paused_Trigger_Grps_Bool_Exp>>
  sched_name?: InputMaybe<String_Comparison_Exp>
  trigger_group?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "qrtz_paused_trigger_grps" */
export enum Tickets_Qrtz_Paused_Trigger_Grps_Constraint {
  /** unique or primary key constraint on columns "sched_name", "trigger_group" */
  QrtzPausedTriggerGrpsPkey = "qrtz_paused_trigger_grps_pkey",
}

/** input type for inserting data into table "qrtz_paused_trigger_grps" */
export type Tickets_Qrtz_Paused_Trigger_Grps_Insert_Input = {
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Qrtz_Paused_Trigger_Grps_Max_Fields = {
  __typename?: "tickets_qrtz_paused_trigger_grps_max_fields"
  sched_name?: Maybe<Scalars["String"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Qrtz_Paused_Trigger_Grps_Min_Fields = {
  __typename?: "tickets_qrtz_paused_trigger_grps_min_fields"
  sched_name?: Maybe<Scalars["String"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "qrtz_paused_trigger_grps" */
export type Tickets_Qrtz_Paused_Trigger_Grps_Mutation_Response = {
  __typename?: "tickets_qrtz_paused_trigger_grps_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Qrtz_Paused_Trigger_Grps>
}

/** on_conflict condition type for table "qrtz_paused_trigger_grps" */
export type Tickets_Qrtz_Paused_Trigger_Grps_On_Conflict = {
  constraint: Tickets_Qrtz_Paused_Trigger_Grps_Constraint
  update_columns?: Array<Tickets_Qrtz_Paused_Trigger_Grps_Update_Column>
  where?: InputMaybe<Tickets_Qrtz_Paused_Trigger_Grps_Bool_Exp>
}

/** Ordering options when selecting data from "qrtz_paused_trigger_grps". */
export type Tickets_Qrtz_Paused_Trigger_Grps_Order_By = {
  sched_name?: InputMaybe<Order_By>
  trigger_group?: InputMaybe<Order_By>
}

/** primary key columns input for table: qrtz_paused_trigger_grps */
export type Tickets_Qrtz_Paused_Trigger_Grps_Pk_Columns_Input = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
}

/** select columns of table "qrtz_paused_trigger_grps" */
export enum Tickets_Qrtz_Paused_Trigger_Grps_Select_Column {
  /** column name */
  SchedName = "sched_name",
  /** column name */
  TriggerGroup = "trigger_group",
}

/** input type for updating data in table "qrtz_paused_trigger_grps" */
export type Tickets_Qrtz_Paused_Trigger_Grps_Set_Input = {
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
}

/** Streaming cursor of the table "tickets_qrtz_paused_trigger_grps" */
export type Tickets_Qrtz_Paused_Trigger_Grps_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Qrtz_Paused_Trigger_Grps_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Qrtz_Paused_Trigger_Grps_Stream_Cursor_Value_Input = {
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
}

/** update columns of table "qrtz_paused_trigger_grps" */
export enum Tickets_Qrtz_Paused_Trigger_Grps_Update_Column {
  /** column name */
  SchedName = "sched_name",
  /** column name */
  TriggerGroup = "trigger_group",
}

export type Tickets_Qrtz_Paused_Trigger_Grps_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Qrtz_Paused_Trigger_Grps_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Qrtz_Paused_Trigger_Grps_Bool_Exp
}

/** columns and relationships of "qrtz_scheduler_state" */
export type Tickets_Qrtz_Scheduler_State = {
  __typename?: "tickets_qrtz_scheduler_state"
  checkin_interval?: Maybe<Scalars["bigint"]["output"]>
  instance_name: Scalars["String"]["output"]
  last_checkin_time?: Maybe<Scalars["bigint"]["output"]>
  sched_name: Scalars["String"]["output"]
}

/** aggregated selection of "qrtz_scheduler_state" */
export type Tickets_Qrtz_Scheduler_State_Aggregate = {
  __typename?: "tickets_qrtz_scheduler_state_aggregate"
  aggregate?: Maybe<Tickets_Qrtz_Scheduler_State_Aggregate_Fields>
  nodes: Array<Tickets_Qrtz_Scheduler_State>
}

/** aggregate fields of "qrtz_scheduler_state" */
export type Tickets_Qrtz_Scheduler_State_Aggregate_Fields = {
  __typename?: "tickets_qrtz_scheduler_state_aggregate_fields"
  avg?: Maybe<Tickets_Qrtz_Scheduler_State_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Qrtz_Scheduler_State_Max_Fields>
  min?: Maybe<Tickets_Qrtz_Scheduler_State_Min_Fields>
  stddev?: Maybe<Tickets_Qrtz_Scheduler_State_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Qrtz_Scheduler_State_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Qrtz_Scheduler_State_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Qrtz_Scheduler_State_Sum_Fields>
  var_pop?: Maybe<Tickets_Qrtz_Scheduler_State_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Qrtz_Scheduler_State_Var_Samp_Fields>
  variance?: Maybe<Tickets_Qrtz_Scheduler_State_Variance_Fields>
}

/** aggregate fields of "qrtz_scheduler_state" */
export type Tickets_Qrtz_Scheduler_State_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Qrtz_Scheduler_State_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_Qrtz_Scheduler_State_Avg_Fields = {
  __typename?: "tickets_qrtz_scheduler_state_avg_fields"
  checkin_interval?: Maybe<Scalars["Float"]["output"]>
  last_checkin_time?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "qrtz_scheduler_state". All fields are combined with a logical 'AND'. */
export type Tickets_Qrtz_Scheduler_State_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Qrtz_Scheduler_State_Bool_Exp>>
  _not?: InputMaybe<Tickets_Qrtz_Scheduler_State_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Qrtz_Scheduler_State_Bool_Exp>>
  checkin_interval?: InputMaybe<Bigint_Comparison_Exp>
  instance_name?: InputMaybe<String_Comparison_Exp>
  last_checkin_time?: InputMaybe<Bigint_Comparison_Exp>
  sched_name?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "qrtz_scheduler_state" */
export enum Tickets_Qrtz_Scheduler_State_Constraint {
  /** unique or primary key constraint on columns "instance_name", "sched_name" */
  QrtzSchedulerStatePkey = "qrtz_scheduler_state_pkey",
}

/** input type for incrementing numeric columns in table "qrtz_scheduler_state" */
export type Tickets_Qrtz_Scheduler_State_Inc_Input = {
  checkin_interval?: InputMaybe<Scalars["bigint"]["input"]>
  last_checkin_time?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "qrtz_scheduler_state" */
export type Tickets_Qrtz_Scheduler_State_Insert_Input = {
  checkin_interval?: InputMaybe<Scalars["bigint"]["input"]>
  instance_name?: InputMaybe<Scalars["String"]["input"]>
  last_checkin_time?: InputMaybe<Scalars["bigint"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Qrtz_Scheduler_State_Max_Fields = {
  __typename?: "tickets_qrtz_scheduler_state_max_fields"
  checkin_interval?: Maybe<Scalars["bigint"]["output"]>
  instance_name?: Maybe<Scalars["String"]["output"]>
  last_checkin_time?: Maybe<Scalars["bigint"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Qrtz_Scheduler_State_Min_Fields = {
  __typename?: "tickets_qrtz_scheduler_state_min_fields"
  checkin_interval?: Maybe<Scalars["bigint"]["output"]>
  instance_name?: Maybe<Scalars["String"]["output"]>
  last_checkin_time?: Maybe<Scalars["bigint"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "qrtz_scheduler_state" */
export type Tickets_Qrtz_Scheduler_State_Mutation_Response = {
  __typename?: "tickets_qrtz_scheduler_state_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Qrtz_Scheduler_State>
}

/** on_conflict condition type for table "qrtz_scheduler_state" */
export type Tickets_Qrtz_Scheduler_State_On_Conflict = {
  constraint: Tickets_Qrtz_Scheduler_State_Constraint
  update_columns?: Array<Tickets_Qrtz_Scheduler_State_Update_Column>
  where?: InputMaybe<Tickets_Qrtz_Scheduler_State_Bool_Exp>
}

/** Ordering options when selecting data from "qrtz_scheduler_state". */
export type Tickets_Qrtz_Scheduler_State_Order_By = {
  checkin_interval?: InputMaybe<Order_By>
  instance_name?: InputMaybe<Order_By>
  last_checkin_time?: InputMaybe<Order_By>
  sched_name?: InputMaybe<Order_By>
}

/** primary key columns input for table: qrtz_scheduler_state */
export type Tickets_Qrtz_Scheduler_State_Pk_Columns_Input = {
  instance_name: Scalars["String"]["input"]
  sched_name: Scalars["String"]["input"]
}

/** select columns of table "qrtz_scheduler_state" */
export enum Tickets_Qrtz_Scheduler_State_Select_Column {
  /** column name */
  CheckinInterval = "checkin_interval",
  /** column name */
  InstanceName = "instance_name",
  /** column name */
  LastCheckinTime = "last_checkin_time",
  /** column name */
  SchedName = "sched_name",
}

/** input type for updating data in table "qrtz_scheduler_state" */
export type Tickets_Qrtz_Scheduler_State_Set_Input = {
  checkin_interval?: InputMaybe<Scalars["bigint"]["input"]>
  instance_name?: InputMaybe<Scalars["String"]["input"]>
  last_checkin_time?: InputMaybe<Scalars["bigint"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Qrtz_Scheduler_State_Stddev_Fields = {
  __typename?: "tickets_qrtz_scheduler_state_stddev_fields"
  checkin_interval?: Maybe<Scalars["Float"]["output"]>
  last_checkin_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Qrtz_Scheduler_State_Stddev_Pop_Fields = {
  __typename?: "tickets_qrtz_scheduler_state_stddev_pop_fields"
  checkin_interval?: Maybe<Scalars["Float"]["output"]>
  last_checkin_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Qrtz_Scheduler_State_Stddev_Samp_Fields = {
  __typename?: "tickets_qrtz_scheduler_state_stddev_samp_fields"
  checkin_interval?: Maybe<Scalars["Float"]["output"]>
  last_checkin_time?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_qrtz_scheduler_state" */
export type Tickets_Qrtz_Scheduler_State_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Qrtz_Scheduler_State_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Qrtz_Scheduler_State_Stream_Cursor_Value_Input = {
  checkin_interval?: InputMaybe<Scalars["bigint"]["input"]>
  instance_name?: InputMaybe<Scalars["String"]["input"]>
  last_checkin_time?: InputMaybe<Scalars["bigint"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_Qrtz_Scheduler_State_Sum_Fields = {
  __typename?: "tickets_qrtz_scheduler_state_sum_fields"
  checkin_interval?: Maybe<Scalars["bigint"]["output"]>
  last_checkin_time?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "qrtz_scheduler_state" */
export enum Tickets_Qrtz_Scheduler_State_Update_Column {
  /** column name */
  CheckinInterval = "checkin_interval",
  /** column name */
  InstanceName = "instance_name",
  /** column name */
  LastCheckinTime = "last_checkin_time",
  /** column name */
  SchedName = "sched_name",
}

export type Tickets_Qrtz_Scheduler_State_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Qrtz_Scheduler_State_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Qrtz_Scheduler_State_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Qrtz_Scheduler_State_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Qrtz_Scheduler_State_Var_Pop_Fields = {
  __typename?: "tickets_qrtz_scheduler_state_var_pop_fields"
  checkin_interval?: Maybe<Scalars["Float"]["output"]>
  last_checkin_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Qrtz_Scheduler_State_Var_Samp_Fields = {
  __typename?: "tickets_qrtz_scheduler_state_var_samp_fields"
  checkin_interval?: Maybe<Scalars["Float"]["output"]>
  last_checkin_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Qrtz_Scheduler_State_Variance_Fields = {
  __typename?: "tickets_qrtz_scheduler_state_variance_fields"
  checkin_interval?: Maybe<Scalars["Float"]["output"]>
  last_checkin_time?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "qrtz_simple_triggers" */
export type Tickets_Qrtz_Simple_Triggers = {
  __typename?: "tickets_qrtz_simple_triggers"
  repeat_count: Scalars["bigint"]["output"]
  repeat_interval: Scalars["bigint"]["output"]
  sched_name: Scalars["String"]["output"]
  times_triggered: Scalars["bigint"]["output"]
  trigger_group: Scalars["String"]["output"]
  trigger_name: Scalars["String"]["output"]
}

/** aggregated selection of "qrtz_simple_triggers" */
export type Tickets_Qrtz_Simple_Triggers_Aggregate = {
  __typename?: "tickets_qrtz_simple_triggers_aggregate"
  aggregate?: Maybe<Tickets_Qrtz_Simple_Triggers_Aggregate_Fields>
  nodes: Array<Tickets_Qrtz_Simple_Triggers>
}

/** aggregate fields of "qrtz_simple_triggers" */
export type Tickets_Qrtz_Simple_Triggers_Aggregate_Fields = {
  __typename?: "tickets_qrtz_simple_triggers_aggregate_fields"
  avg?: Maybe<Tickets_Qrtz_Simple_Triggers_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Qrtz_Simple_Triggers_Max_Fields>
  min?: Maybe<Tickets_Qrtz_Simple_Triggers_Min_Fields>
  stddev?: Maybe<Tickets_Qrtz_Simple_Triggers_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Qrtz_Simple_Triggers_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Qrtz_Simple_Triggers_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Qrtz_Simple_Triggers_Sum_Fields>
  var_pop?: Maybe<Tickets_Qrtz_Simple_Triggers_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Qrtz_Simple_Triggers_Var_Samp_Fields>
  variance?: Maybe<Tickets_Qrtz_Simple_Triggers_Variance_Fields>
}

/** aggregate fields of "qrtz_simple_triggers" */
export type Tickets_Qrtz_Simple_Triggers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Qrtz_Simple_Triggers_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_Qrtz_Simple_Triggers_Avg_Fields = {
  __typename?: "tickets_qrtz_simple_triggers_avg_fields"
  repeat_count?: Maybe<Scalars["Float"]["output"]>
  repeat_interval?: Maybe<Scalars["Float"]["output"]>
  times_triggered?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "qrtz_simple_triggers". All fields are combined with a logical 'AND'. */
export type Tickets_Qrtz_Simple_Triggers_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Qrtz_Simple_Triggers_Bool_Exp>>
  _not?: InputMaybe<Tickets_Qrtz_Simple_Triggers_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Qrtz_Simple_Triggers_Bool_Exp>>
  repeat_count?: InputMaybe<Bigint_Comparison_Exp>
  repeat_interval?: InputMaybe<Bigint_Comparison_Exp>
  sched_name?: InputMaybe<String_Comparison_Exp>
  times_triggered?: InputMaybe<Bigint_Comparison_Exp>
  trigger_group?: InputMaybe<String_Comparison_Exp>
  trigger_name?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "qrtz_simple_triggers" */
export enum Tickets_Qrtz_Simple_Triggers_Constraint {
  /** unique or primary key constraint on columns "sched_name", "trigger_group", "trigger_name" */
  QrtzSimpleTriggersPkey = "qrtz_simple_triggers_pkey",
}

/** input type for incrementing numeric columns in table "qrtz_simple_triggers" */
export type Tickets_Qrtz_Simple_Triggers_Inc_Input = {
  repeat_count?: InputMaybe<Scalars["bigint"]["input"]>
  repeat_interval?: InputMaybe<Scalars["bigint"]["input"]>
  times_triggered?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "qrtz_simple_triggers" */
export type Tickets_Qrtz_Simple_Triggers_Insert_Input = {
  repeat_count?: InputMaybe<Scalars["bigint"]["input"]>
  repeat_interval?: InputMaybe<Scalars["bigint"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  times_triggered?: InputMaybe<Scalars["bigint"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Qrtz_Simple_Triggers_Max_Fields = {
  __typename?: "tickets_qrtz_simple_triggers_max_fields"
  repeat_count?: Maybe<Scalars["bigint"]["output"]>
  repeat_interval?: Maybe<Scalars["bigint"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  times_triggered?: Maybe<Scalars["bigint"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Qrtz_Simple_Triggers_Min_Fields = {
  __typename?: "tickets_qrtz_simple_triggers_min_fields"
  repeat_count?: Maybe<Scalars["bigint"]["output"]>
  repeat_interval?: Maybe<Scalars["bigint"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  times_triggered?: Maybe<Scalars["bigint"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "qrtz_simple_triggers" */
export type Tickets_Qrtz_Simple_Triggers_Mutation_Response = {
  __typename?: "tickets_qrtz_simple_triggers_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Qrtz_Simple_Triggers>
}

/** on_conflict condition type for table "qrtz_simple_triggers" */
export type Tickets_Qrtz_Simple_Triggers_On_Conflict = {
  constraint: Tickets_Qrtz_Simple_Triggers_Constraint
  update_columns?: Array<Tickets_Qrtz_Simple_Triggers_Update_Column>
  where?: InputMaybe<Tickets_Qrtz_Simple_Triggers_Bool_Exp>
}

/** Ordering options when selecting data from "qrtz_simple_triggers". */
export type Tickets_Qrtz_Simple_Triggers_Order_By = {
  repeat_count?: InputMaybe<Order_By>
  repeat_interval?: InputMaybe<Order_By>
  sched_name?: InputMaybe<Order_By>
  times_triggered?: InputMaybe<Order_By>
  trigger_group?: InputMaybe<Order_By>
  trigger_name?: InputMaybe<Order_By>
}

/** primary key columns input for table: qrtz_simple_triggers */
export type Tickets_Qrtz_Simple_Triggers_Pk_Columns_Input = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

/** select columns of table "qrtz_simple_triggers" */
export enum Tickets_Qrtz_Simple_Triggers_Select_Column {
  /** column name */
  RepeatCount = "repeat_count",
  /** column name */
  RepeatInterval = "repeat_interval",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  TimesTriggered = "times_triggered",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
}

/** input type for updating data in table "qrtz_simple_triggers" */
export type Tickets_Qrtz_Simple_Triggers_Set_Input = {
  repeat_count?: InputMaybe<Scalars["bigint"]["input"]>
  repeat_interval?: InputMaybe<Scalars["bigint"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  times_triggered?: InputMaybe<Scalars["bigint"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Qrtz_Simple_Triggers_Stddev_Fields = {
  __typename?: "tickets_qrtz_simple_triggers_stddev_fields"
  repeat_count?: Maybe<Scalars["Float"]["output"]>
  repeat_interval?: Maybe<Scalars["Float"]["output"]>
  times_triggered?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Qrtz_Simple_Triggers_Stddev_Pop_Fields = {
  __typename?: "tickets_qrtz_simple_triggers_stddev_pop_fields"
  repeat_count?: Maybe<Scalars["Float"]["output"]>
  repeat_interval?: Maybe<Scalars["Float"]["output"]>
  times_triggered?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Qrtz_Simple_Triggers_Stddev_Samp_Fields = {
  __typename?: "tickets_qrtz_simple_triggers_stddev_samp_fields"
  repeat_count?: Maybe<Scalars["Float"]["output"]>
  repeat_interval?: Maybe<Scalars["Float"]["output"]>
  times_triggered?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_qrtz_simple_triggers" */
export type Tickets_Qrtz_Simple_Triggers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Qrtz_Simple_Triggers_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Qrtz_Simple_Triggers_Stream_Cursor_Value_Input = {
  repeat_count?: InputMaybe<Scalars["bigint"]["input"]>
  repeat_interval?: InputMaybe<Scalars["bigint"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  times_triggered?: InputMaybe<Scalars["bigint"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_Qrtz_Simple_Triggers_Sum_Fields = {
  __typename?: "tickets_qrtz_simple_triggers_sum_fields"
  repeat_count?: Maybe<Scalars["bigint"]["output"]>
  repeat_interval?: Maybe<Scalars["bigint"]["output"]>
  times_triggered?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "qrtz_simple_triggers" */
export enum Tickets_Qrtz_Simple_Triggers_Update_Column {
  /** column name */
  RepeatCount = "repeat_count",
  /** column name */
  RepeatInterval = "repeat_interval",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  TimesTriggered = "times_triggered",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
}

export type Tickets_Qrtz_Simple_Triggers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Qrtz_Simple_Triggers_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Qrtz_Simple_Triggers_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Qrtz_Simple_Triggers_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Qrtz_Simple_Triggers_Var_Pop_Fields = {
  __typename?: "tickets_qrtz_simple_triggers_var_pop_fields"
  repeat_count?: Maybe<Scalars["Float"]["output"]>
  repeat_interval?: Maybe<Scalars["Float"]["output"]>
  times_triggered?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Qrtz_Simple_Triggers_Var_Samp_Fields = {
  __typename?: "tickets_qrtz_simple_triggers_var_samp_fields"
  repeat_count?: Maybe<Scalars["Float"]["output"]>
  repeat_interval?: Maybe<Scalars["Float"]["output"]>
  times_triggered?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Qrtz_Simple_Triggers_Variance_Fields = {
  __typename?: "tickets_qrtz_simple_triggers_variance_fields"
  repeat_count?: Maybe<Scalars["Float"]["output"]>
  repeat_interval?: Maybe<Scalars["Float"]["output"]>
  times_triggered?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "qrtz_simprop_triggers" */
export type Tickets_Qrtz_Simprop_Triggers = {
  __typename?: "tickets_qrtz_simprop_triggers"
  bool_prop_1?: Maybe<Scalars["Boolean"]["output"]>
  bool_prop_2?: Maybe<Scalars["Boolean"]["output"]>
  dec_prop_1?: Maybe<Scalars["numeric"]["output"]>
  dec_prop_2?: Maybe<Scalars["numeric"]["output"]>
  int_prop_1?: Maybe<Scalars["Int"]["output"]>
  int_prop_2?: Maybe<Scalars["Int"]["output"]>
  long_prop_1?: Maybe<Scalars["bigint"]["output"]>
  long_prop_2?: Maybe<Scalars["bigint"]["output"]>
  sched_name: Scalars["String"]["output"]
  str_prop_1?: Maybe<Scalars["String"]["output"]>
  str_prop_2?: Maybe<Scalars["String"]["output"]>
  str_prop_3?: Maybe<Scalars["String"]["output"]>
  trigger_group: Scalars["String"]["output"]
  trigger_name: Scalars["String"]["output"]
}

/** aggregated selection of "qrtz_simprop_triggers" */
export type Tickets_Qrtz_Simprop_Triggers_Aggregate = {
  __typename?: "tickets_qrtz_simprop_triggers_aggregate"
  aggregate?: Maybe<Tickets_Qrtz_Simprop_Triggers_Aggregate_Fields>
  nodes: Array<Tickets_Qrtz_Simprop_Triggers>
}

/** aggregate fields of "qrtz_simprop_triggers" */
export type Tickets_Qrtz_Simprop_Triggers_Aggregate_Fields = {
  __typename?: "tickets_qrtz_simprop_triggers_aggregate_fields"
  avg?: Maybe<Tickets_Qrtz_Simprop_Triggers_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Qrtz_Simprop_Triggers_Max_Fields>
  min?: Maybe<Tickets_Qrtz_Simprop_Triggers_Min_Fields>
  stddev?: Maybe<Tickets_Qrtz_Simprop_Triggers_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Qrtz_Simprop_Triggers_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Qrtz_Simprop_Triggers_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Qrtz_Simprop_Triggers_Sum_Fields>
  var_pop?: Maybe<Tickets_Qrtz_Simprop_Triggers_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Qrtz_Simprop_Triggers_Var_Samp_Fields>
  variance?: Maybe<Tickets_Qrtz_Simprop_Triggers_Variance_Fields>
}

/** aggregate fields of "qrtz_simprop_triggers" */
export type Tickets_Qrtz_Simprop_Triggers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Qrtz_Simprop_Triggers_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_Qrtz_Simprop_Triggers_Avg_Fields = {
  __typename?: "tickets_qrtz_simprop_triggers_avg_fields"
  dec_prop_1?: Maybe<Scalars["Float"]["output"]>
  dec_prop_2?: Maybe<Scalars["Float"]["output"]>
  int_prop_1?: Maybe<Scalars["Float"]["output"]>
  int_prop_2?: Maybe<Scalars["Float"]["output"]>
  long_prop_1?: Maybe<Scalars["Float"]["output"]>
  long_prop_2?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "qrtz_simprop_triggers". All fields are combined with a logical 'AND'. */
export type Tickets_Qrtz_Simprop_Triggers_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Qrtz_Simprop_Triggers_Bool_Exp>>
  _not?: InputMaybe<Tickets_Qrtz_Simprop_Triggers_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Qrtz_Simprop_Triggers_Bool_Exp>>
  bool_prop_1?: InputMaybe<Boolean_Comparison_Exp>
  bool_prop_2?: InputMaybe<Boolean_Comparison_Exp>
  dec_prop_1?: InputMaybe<Numeric_Comparison_Exp>
  dec_prop_2?: InputMaybe<Numeric_Comparison_Exp>
  int_prop_1?: InputMaybe<Int_Comparison_Exp>
  int_prop_2?: InputMaybe<Int_Comparison_Exp>
  long_prop_1?: InputMaybe<Bigint_Comparison_Exp>
  long_prop_2?: InputMaybe<Bigint_Comparison_Exp>
  sched_name?: InputMaybe<String_Comparison_Exp>
  str_prop_1?: InputMaybe<String_Comparison_Exp>
  str_prop_2?: InputMaybe<String_Comparison_Exp>
  str_prop_3?: InputMaybe<String_Comparison_Exp>
  trigger_group?: InputMaybe<String_Comparison_Exp>
  trigger_name?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "qrtz_simprop_triggers" */
export enum Tickets_Qrtz_Simprop_Triggers_Constraint {
  /** unique or primary key constraint on columns "sched_name", "trigger_group", "trigger_name" */
  QrtzSimpropTriggersPkey = "qrtz_simprop_triggers_pkey",
}

/** input type for incrementing numeric columns in table "qrtz_simprop_triggers" */
export type Tickets_Qrtz_Simprop_Triggers_Inc_Input = {
  dec_prop_1?: InputMaybe<Scalars["numeric"]["input"]>
  dec_prop_2?: InputMaybe<Scalars["numeric"]["input"]>
  int_prop_1?: InputMaybe<Scalars["Int"]["input"]>
  int_prop_2?: InputMaybe<Scalars["Int"]["input"]>
  long_prop_1?: InputMaybe<Scalars["bigint"]["input"]>
  long_prop_2?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "qrtz_simprop_triggers" */
export type Tickets_Qrtz_Simprop_Triggers_Insert_Input = {
  bool_prop_1?: InputMaybe<Scalars["Boolean"]["input"]>
  bool_prop_2?: InputMaybe<Scalars["Boolean"]["input"]>
  dec_prop_1?: InputMaybe<Scalars["numeric"]["input"]>
  dec_prop_2?: InputMaybe<Scalars["numeric"]["input"]>
  int_prop_1?: InputMaybe<Scalars["Int"]["input"]>
  int_prop_2?: InputMaybe<Scalars["Int"]["input"]>
  long_prop_1?: InputMaybe<Scalars["bigint"]["input"]>
  long_prop_2?: InputMaybe<Scalars["bigint"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  str_prop_1?: InputMaybe<Scalars["String"]["input"]>
  str_prop_2?: InputMaybe<Scalars["String"]["input"]>
  str_prop_3?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Qrtz_Simprop_Triggers_Max_Fields = {
  __typename?: "tickets_qrtz_simprop_triggers_max_fields"
  dec_prop_1?: Maybe<Scalars["numeric"]["output"]>
  dec_prop_2?: Maybe<Scalars["numeric"]["output"]>
  int_prop_1?: Maybe<Scalars["Int"]["output"]>
  int_prop_2?: Maybe<Scalars["Int"]["output"]>
  long_prop_1?: Maybe<Scalars["bigint"]["output"]>
  long_prop_2?: Maybe<Scalars["bigint"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  str_prop_1?: Maybe<Scalars["String"]["output"]>
  str_prop_2?: Maybe<Scalars["String"]["output"]>
  str_prop_3?: Maybe<Scalars["String"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Qrtz_Simprop_Triggers_Min_Fields = {
  __typename?: "tickets_qrtz_simprop_triggers_min_fields"
  dec_prop_1?: Maybe<Scalars["numeric"]["output"]>
  dec_prop_2?: Maybe<Scalars["numeric"]["output"]>
  int_prop_1?: Maybe<Scalars["Int"]["output"]>
  int_prop_2?: Maybe<Scalars["Int"]["output"]>
  long_prop_1?: Maybe<Scalars["bigint"]["output"]>
  long_prop_2?: Maybe<Scalars["bigint"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  str_prop_1?: Maybe<Scalars["String"]["output"]>
  str_prop_2?: Maybe<Scalars["String"]["output"]>
  str_prop_3?: Maybe<Scalars["String"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "qrtz_simprop_triggers" */
export type Tickets_Qrtz_Simprop_Triggers_Mutation_Response = {
  __typename?: "tickets_qrtz_simprop_triggers_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Qrtz_Simprop_Triggers>
}

/** on_conflict condition type for table "qrtz_simprop_triggers" */
export type Tickets_Qrtz_Simprop_Triggers_On_Conflict = {
  constraint: Tickets_Qrtz_Simprop_Triggers_Constraint
  update_columns?: Array<Tickets_Qrtz_Simprop_Triggers_Update_Column>
  where?: InputMaybe<Tickets_Qrtz_Simprop_Triggers_Bool_Exp>
}

/** Ordering options when selecting data from "qrtz_simprop_triggers". */
export type Tickets_Qrtz_Simprop_Triggers_Order_By = {
  bool_prop_1?: InputMaybe<Order_By>
  bool_prop_2?: InputMaybe<Order_By>
  dec_prop_1?: InputMaybe<Order_By>
  dec_prop_2?: InputMaybe<Order_By>
  int_prop_1?: InputMaybe<Order_By>
  int_prop_2?: InputMaybe<Order_By>
  long_prop_1?: InputMaybe<Order_By>
  long_prop_2?: InputMaybe<Order_By>
  sched_name?: InputMaybe<Order_By>
  str_prop_1?: InputMaybe<Order_By>
  str_prop_2?: InputMaybe<Order_By>
  str_prop_3?: InputMaybe<Order_By>
  trigger_group?: InputMaybe<Order_By>
  trigger_name?: InputMaybe<Order_By>
}

/** primary key columns input for table: qrtz_simprop_triggers */
export type Tickets_Qrtz_Simprop_Triggers_Pk_Columns_Input = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

/** select columns of table "qrtz_simprop_triggers" */
export enum Tickets_Qrtz_Simprop_Triggers_Select_Column {
  /** column name */
  BoolProp_1 = "bool_prop_1",
  /** column name */
  BoolProp_2 = "bool_prop_2",
  /** column name */
  DecProp_1 = "dec_prop_1",
  /** column name */
  DecProp_2 = "dec_prop_2",
  /** column name */
  IntProp_1 = "int_prop_1",
  /** column name */
  IntProp_2 = "int_prop_2",
  /** column name */
  LongProp_1 = "long_prop_1",
  /** column name */
  LongProp_2 = "long_prop_2",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  StrProp_1 = "str_prop_1",
  /** column name */
  StrProp_2 = "str_prop_2",
  /** column name */
  StrProp_3 = "str_prop_3",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
}

/** input type for updating data in table "qrtz_simprop_triggers" */
export type Tickets_Qrtz_Simprop_Triggers_Set_Input = {
  bool_prop_1?: InputMaybe<Scalars["Boolean"]["input"]>
  bool_prop_2?: InputMaybe<Scalars["Boolean"]["input"]>
  dec_prop_1?: InputMaybe<Scalars["numeric"]["input"]>
  dec_prop_2?: InputMaybe<Scalars["numeric"]["input"]>
  int_prop_1?: InputMaybe<Scalars["Int"]["input"]>
  int_prop_2?: InputMaybe<Scalars["Int"]["input"]>
  long_prop_1?: InputMaybe<Scalars["bigint"]["input"]>
  long_prop_2?: InputMaybe<Scalars["bigint"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  str_prop_1?: InputMaybe<Scalars["String"]["input"]>
  str_prop_2?: InputMaybe<Scalars["String"]["input"]>
  str_prop_3?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Qrtz_Simprop_Triggers_Stddev_Fields = {
  __typename?: "tickets_qrtz_simprop_triggers_stddev_fields"
  dec_prop_1?: Maybe<Scalars["Float"]["output"]>
  dec_prop_2?: Maybe<Scalars["Float"]["output"]>
  int_prop_1?: Maybe<Scalars["Float"]["output"]>
  int_prop_2?: Maybe<Scalars["Float"]["output"]>
  long_prop_1?: Maybe<Scalars["Float"]["output"]>
  long_prop_2?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Qrtz_Simprop_Triggers_Stddev_Pop_Fields = {
  __typename?: "tickets_qrtz_simprop_triggers_stddev_pop_fields"
  dec_prop_1?: Maybe<Scalars["Float"]["output"]>
  dec_prop_2?: Maybe<Scalars["Float"]["output"]>
  int_prop_1?: Maybe<Scalars["Float"]["output"]>
  int_prop_2?: Maybe<Scalars["Float"]["output"]>
  long_prop_1?: Maybe<Scalars["Float"]["output"]>
  long_prop_2?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Qrtz_Simprop_Triggers_Stddev_Samp_Fields = {
  __typename?: "tickets_qrtz_simprop_triggers_stddev_samp_fields"
  dec_prop_1?: Maybe<Scalars["Float"]["output"]>
  dec_prop_2?: Maybe<Scalars["Float"]["output"]>
  int_prop_1?: Maybe<Scalars["Float"]["output"]>
  int_prop_2?: Maybe<Scalars["Float"]["output"]>
  long_prop_1?: Maybe<Scalars["Float"]["output"]>
  long_prop_2?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_qrtz_simprop_triggers" */
export type Tickets_Qrtz_Simprop_Triggers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Qrtz_Simprop_Triggers_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Qrtz_Simprop_Triggers_Stream_Cursor_Value_Input = {
  bool_prop_1?: InputMaybe<Scalars["Boolean"]["input"]>
  bool_prop_2?: InputMaybe<Scalars["Boolean"]["input"]>
  dec_prop_1?: InputMaybe<Scalars["numeric"]["input"]>
  dec_prop_2?: InputMaybe<Scalars["numeric"]["input"]>
  int_prop_1?: InputMaybe<Scalars["Int"]["input"]>
  int_prop_2?: InputMaybe<Scalars["Int"]["input"]>
  long_prop_1?: InputMaybe<Scalars["bigint"]["input"]>
  long_prop_2?: InputMaybe<Scalars["bigint"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  str_prop_1?: InputMaybe<Scalars["String"]["input"]>
  str_prop_2?: InputMaybe<Scalars["String"]["input"]>
  str_prop_3?: InputMaybe<Scalars["String"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_Qrtz_Simprop_Triggers_Sum_Fields = {
  __typename?: "tickets_qrtz_simprop_triggers_sum_fields"
  dec_prop_1?: Maybe<Scalars["numeric"]["output"]>
  dec_prop_2?: Maybe<Scalars["numeric"]["output"]>
  int_prop_1?: Maybe<Scalars["Int"]["output"]>
  int_prop_2?: Maybe<Scalars["Int"]["output"]>
  long_prop_1?: Maybe<Scalars["bigint"]["output"]>
  long_prop_2?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "qrtz_simprop_triggers" */
export enum Tickets_Qrtz_Simprop_Triggers_Update_Column {
  /** column name */
  BoolProp_1 = "bool_prop_1",
  /** column name */
  BoolProp_2 = "bool_prop_2",
  /** column name */
  DecProp_1 = "dec_prop_1",
  /** column name */
  DecProp_2 = "dec_prop_2",
  /** column name */
  IntProp_1 = "int_prop_1",
  /** column name */
  IntProp_2 = "int_prop_2",
  /** column name */
  LongProp_1 = "long_prop_1",
  /** column name */
  LongProp_2 = "long_prop_2",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  StrProp_1 = "str_prop_1",
  /** column name */
  StrProp_2 = "str_prop_2",
  /** column name */
  StrProp_3 = "str_prop_3",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
}

export type Tickets_Qrtz_Simprop_Triggers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Qrtz_Simprop_Triggers_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Qrtz_Simprop_Triggers_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Qrtz_Simprop_Triggers_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Qrtz_Simprop_Triggers_Var_Pop_Fields = {
  __typename?: "tickets_qrtz_simprop_triggers_var_pop_fields"
  dec_prop_1?: Maybe<Scalars["Float"]["output"]>
  dec_prop_2?: Maybe<Scalars["Float"]["output"]>
  int_prop_1?: Maybe<Scalars["Float"]["output"]>
  int_prop_2?: Maybe<Scalars["Float"]["output"]>
  long_prop_1?: Maybe<Scalars["Float"]["output"]>
  long_prop_2?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Qrtz_Simprop_Triggers_Var_Samp_Fields = {
  __typename?: "tickets_qrtz_simprop_triggers_var_samp_fields"
  dec_prop_1?: Maybe<Scalars["Float"]["output"]>
  dec_prop_2?: Maybe<Scalars["Float"]["output"]>
  int_prop_1?: Maybe<Scalars["Float"]["output"]>
  int_prop_2?: Maybe<Scalars["Float"]["output"]>
  long_prop_1?: Maybe<Scalars["Float"]["output"]>
  long_prop_2?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Qrtz_Simprop_Triggers_Variance_Fields = {
  __typename?: "tickets_qrtz_simprop_triggers_variance_fields"
  dec_prop_1?: Maybe<Scalars["Float"]["output"]>
  dec_prop_2?: Maybe<Scalars["Float"]["output"]>
  int_prop_1?: Maybe<Scalars["Float"]["output"]>
  int_prop_2?: Maybe<Scalars["Float"]["output"]>
  long_prop_1?: Maybe<Scalars["Float"]["output"]>
  long_prop_2?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "qrtz_triggers" */
export type Tickets_Qrtz_Triggers = {
  __typename?: "tickets_qrtz_triggers"
  calendar_name?: Maybe<Scalars["String"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  end_time?: Maybe<Scalars["bigint"]["output"]>
  job_data?: Maybe<Scalars["bytea"]["output"]>
  job_group: Scalars["String"]["output"]
  job_name: Scalars["String"]["output"]
  misfire_instr?: Maybe<Scalars["smallint"]["output"]>
  next_fire_time?: Maybe<Scalars["bigint"]["output"]>
  prev_fire_time?: Maybe<Scalars["bigint"]["output"]>
  priority?: Maybe<Scalars["Int"]["output"]>
  sched_name: Scalars["String"]["output"]
  start_time: Scalars["bigint"]["output"]
  trigger_group: Scalars["String"]["output"]
  trigger_name: Scalars["String"]["output"]
  trigger_state: Scalars["String"]["output"]
  trigger_type: Scalars["String"]["output"]
}

/** aggregated selection of "qrtz_triggers" */
export type Tickets_Qrtz_Triggers_Aggregate = {
  __typename?: "tickets_qrtz_triggers_aggregate"
  aggregate?: Maybe<Tickets_Qrtz_Triggers_Aggregate_Fields>
  nodes: Array<Tickets_Qrtz_Triggers>
}

/** aggregate fields of "qrtz_triggers" */
export type Tickets_Qrtz_Triggers_Aggregate_Fields = {
  __typename?: "tickets_qrtz_triggers_aggregate_fields"
  avg?: Maybe<Tickets_Qrtz_Triggers_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Tickets_Qrtz_Triggers_Max_Fields>
  min?: Maybe<Tickets_Qrtz_Triggers_Min_Fields>
  stddev?: Maybe<Tickets_Qrtz_Triggers_Stddev_Fields>
  stddev_pop?: Maybe<Tickets_Qrtz_Triggers_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Tickets_Qrtz_Triggers_Stddev_Samp_Fields>
  sum?: Maybe<Tickets_Qrtz_Triggers_Sum_Fields>
  var_pop?: Maybe<Tickets_Qrtz_Triggers_Var_Pop_Fields>
  var_samp?: Maybe<Tickets_Qrtz_Triggers_Var_Samp_Fields>
  variance?: Maybe<Tickets_Qrtz_Triggers_Variance_Fields>
}

/** aggregate fields of "qrtz_triggers" */
export type Tickets_Qrtz_Triggers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tickets_Qrtz_Triggers_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Tickets_Qrtz_Triggers_Avg_Fields = {
  __typename?: "tickets_qrtz_triggers_avg_fields"
  end_time?: Maybe<Scalars["Float"]["output"]>
  misfire_instr?: Maybe<Scalars["Float"]["output"]>
  next_fire_time?: Maybe<Scalars["Float"]["output"]>
  prev_fire_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  start_time?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "qrtz_triggers". All fields are combined with a logical 'AND'. */
export type Tickets_Qrtz_Triggers_Bool_Exp = {
  _and?: InputMaybe<Array<Tickets_Qrtz_Triggers_Bool_Exp>>
  _not?: InputMaybe<Tickets_Qrtz_Triggers_Bool_Exp>
  _or?: InputMaybe<Array<Tickets_Qrtz_Triggers_Bool_Exp>>
  calendar_name?: InputMaybe<String_Comparison_Exp>
  description?: InputMaybe<String_Comparison_Exp>
  end_time?: InputMaybe<Bigint_Comparison_Exp>
  job_data?: InputMaybe<Bytea_Comparison_Exp>
  job_group?: InputMaybe<String_Comparison_Exp>
  job_name?: InputMaybe<String_Comparison_Exp>
  misfire_instr?: InputMaybe<Smallint_Comparison_Exp>
  next_fire_time?: InputMaybe<Bigint_Comparison_Exp>
  prev_fire_time?: InputMaybe<Bigint_Comparison_Exp>
  priority?: InputMaybe<Int_Comparison_Exp>
  sched_name?: InputMaybe<String_Comparison_Exp>
  start_time?: InputMaybe<Bigint_Comparison_Exp>
  trigger_group?: InputMaybe<String_Comparison_Exp>
  trigger_name?: InputMaybe<String_Comparison_Exp>
  trigger_state?: InputMaybe<String_Comparison_Exp>
  trigger_type?: InputMaybe<String_Comparison_Exp>
}

/** unique or primary key constraints on table "qrtz_triggers" */
export enum Tickets_Qrtz_Triggers_Constraint {
  /** unique or primary key constraint on columns "sched_name", "trigger_group", "trigger_name" */
  QrtzTriggersPkey = "qrtz_triggers_pkey",
}

/** input type for incrementing numeric columns in table "qrtz_triggers" */
export type Tickets_Qrtz_Triggers_Inc_Input = {
  end_time?: InputMaybe<Scalars["bigint"]["input"]>
  misfire_instr?: InputMaybe<Scalars["smallint"]["input"]>
  next_fire_time?: InputMaybe<Scalars["bigint"]["input"]>
  prev_fire_time?: InputMaybe<Scalars["bigint"]["input"]>
  priority?: InputMaybe<Scalars["Int"]["input"]>
  start_time?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "qrtz_triggers" */
export type Tickets_Qrtz_Triggers_Insert_Input = {
  calendar_name?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  end_time?: InputMaybe<Scalars["bigint"]["input"]>
  job_data?: InputMaybe<Scalars["bytea"]["input"]>
  job_group?: InputMaybe<Scalars["String"]["input"]>
  job_name?: InputMaybe<Scalars["String"]["input"]>
  misfire_instr?: InputMaybe<Scalars["smallint"]["input"]>
  next_fire_time?: InputMaybe<Scalars["bigint"]["input"]>
  prev_fire_time?: InputMaybe<Scalars["bigint"]["input"]>
  priority?: InputMaybe<Scalars["Int"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  start_time?: InputMaybe<Scalars["bigint"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
  trigger_state?: InputMaybe<Scalars["String"]["input"]>
  trigger_type?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate max on columns */
export type Tickets_Qrtz_Triggers_Max_Fields = {
  __typename?: "tickets_qrtz_triggers_max_fields"
  calendar_name?: Maybe<Scalars["String"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  end_time?: Maybe<Scalars["bigint"]["output"]>
  job_group?: Maybe<Scalars["String"]["output"]>
  job_name?: Maybe<Scalars["String"]["output"]>
  misfire_instr?: Maybe<Scalars["smallint"]["output"]>
  next_fire_time?: Maybe<Scalars["bigint"]["output"]>
  prev_fire_time?: Maybe<Scalars["bigint"]["output"]>
  priority?: Maybe<Scalars["Int"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  start_time?: Maybe<Scalars["bigint"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
  trigger_state?: Maybe<Scalars["String"]["output"]>
  trigger_type?: Maybe<Scalars["String"]["output"]>
}

/** aggregate min on columns */
export type Tickets_Qrtz_Triggers_Min_Fields = {
  __typename?: "tickets_qrtz_triggers_min_fields"
  calendar_name?: Maybe<Scalars["String"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  end_time?: Maybe<Scalars["bigint"]["output"]>
  job_group?: Maybe<Scalars["String"]["output"]>
  job_name?: Maybe<Scalars["String"]["output"]>
  misfire_instr?: Maybe<Scalars["smallint"]["output"]>
  next_fire_time?: Maybe<Scalars["bigint"]["output"]>
  prev_fire_time?: Maybe<Scalars["bigint"]["output"]>
  priority?: Maybe<Scalars["Int"]["output"]>
  sched_name?: Maybe<Scalars["String"]["output"]>
  start_time?: Maybe<Scalars["bigint"]["output"]>
  trigger_group?: Maybe<Scalars["String"]["output"]>
  trigger_name?: Maybe<Scalars["String"]["output"]>
  trigger_state?: Maybe<Scalars["String"]["output"]>
  trigger_type?: Maybe<Scalars["String"]["output"]>
}

/** response of any mutation on the table "qrtz_triggers" */
export type Tickets_Qrtz_Triggers_Mutation_Response = {
  __typename?: "tickets_qrtz_triggers_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Tickets_Qrtz_Triggers>
}

/** on_conflict condition type for table "qrtz_triggers" */
export type Tickets_Qrtz_Triggers_On_Conflict = {
  constraint: Tickets_Qrtz_Triggers_Constraint
  update_columns?: Array<Tickets_Qrtz_Triggers_Update_Column>
  where?: InputMaybe<Tickets_Qrtz_Triggers_Bool_Exp>
}

/** Ordering options when selecting data from "qrtz_triggers". */
export type Tickets_Qrtz_Triggers_Order_By = {
  calendar_name?: InputMaybe<Order_By>
  description?: InputMaybe<Order_By>
  end_time?: InputMaybe<Order_By>
  job_data?: InputMaybe<Order_By>
  job_group?: InputMaybe<Order_By>
  job_name?: InputMaybe<Order_By>
  misfire_instr?: InputMaybe<Order_By>
  next_fire_time?: InputMaybe<Order_By>
  prev_fire_time?: InputMaybe<Order_By>
  priority?: InputMaybe<Order_By>
  sched_name?: InputMaybe<Order_By>
  start_time?: InputMaybe<Order_By>
  trigger_group?: InputMaybe<Order_By>
  trigger_name?: InputMaybe<Order_By>
  trigger_state?: InputMaybe<Order_By>
  trigger_type?: InputMaybe<Order_By>
}

/** primary key columns input for table: qrtz_triggers */
export type Tickets_Qrtz_Triggers_Pk_Columns_Input = {
  sched_name: Scalars["String"]["input"]
  trigger_group: Scalars["String"]["input"]
  trigger_name: Scalars["String"]["input"]
}

/** select columns of table "qrtz_triggers" */
export enum Tickets_Qrtz_Triggers_Select_Column {
  /** column name */
  CalendarName = "calendar_name",
  /** column name */
  Description = "description",
  /** column name */
  EndTime = "end_time",
  /** column name */
  JobData = "job_data",
  /** column name */
  JobGroup = "job_group",
  /** column name */
  JobName = "job_name",
  /** column name */
  MisfireInstr = "misfire_instr",
  /** column name */
  NextFireTime = "next_fire_time",
  /** column name */
  PrevFireTime = "prev_fire_time",
  /** column name */
  Priority = "priority",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  StartTime = "start_time",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
  /** column name */
  TriggerState = "trigger_state",
  /** column name */
  TriggerType = "trigger_type",
}

/** input type for updating data in table "qrtz_triggers" */
export type Tickets_Qrtz_Triggers_Set_Input = {
  calendar_name?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  end_time?: InputMaybe<Scalars["bigint"]["input"]>
  job_data?: InputMaybe<Scalars["bytea"]["input"]>
  job_group?: InputMaybe<Scalars["String"]["input"]>
  job_name?: InputMaybe<Scalars["String"]["input"]>
  misfire_instr?: InputMaybe<Scalars["smallint"]["input"]>
  next_fire_time?: InputMaybe<Scalars["bigint"]["input"]>
  prev_fire_time?: InputMaybe<Scalars["bigint"]["input"]>
  priority?: InputMaybe<Scalars["Int"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  start_time?: InputMaybe<Scalars["bigint"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
  trigger_state?: InputMaybe<Scalars["String"]["input"]>
  trigger_type?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate stddev on columns */
export type Tickets_Qrtz_Triggers_Stddev_Fields = {
  __typename?: "tickets_qrtz_triggers_stddev_fields"
  end_time?: Maybe<Scalars["Float"]["output"]>
  misfire_instr?: Maybe<Scalars["Float"]["output"]>
  next_fire_time?: Maybe<Scalars["Float"]["output"]>
  prev_fire_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  start_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Tickets_Qrtz_Triggers_Stddev_Pop_Fields = {
  __typename?: "tickets_qrtz_triggers_stddev_pop_fields"
  end_time?: Maybe<Scalars["Float"]["output"]>
  misfire_instr?: Maybe<Scalars["Float"]["output"]>
  next_fire_time?: Maybe<Scalars["Float"]["output"]>
  prev_fire_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  start_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Tickets_Qrtz_Triggers_Stddev_Samp_Fields = {
  __typename?: "tickets_qrtz_triggers_stddev_samp_fields"
  end_time?: Maybe<Scalars["Float"]["output"]>
  misfire_instr?: Maybe<Scalars["Float"]["output"]>
  next_fire_time?: Maybe<Scalars["Float"]["output"]>
  prev_fire_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  start_time?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "tickets_qrtz_triggers" */
export type Tickets_Qrtz_Triggers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tickets_Qrtz_Triggers_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Tickets_Qrtz_Triggers_Stream_Cursor_Value_Input = {
  calendar_name?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  end_time?: InputMaybe<Scalars["bigint"]["input"]>
  job_data?: InputMaybe<Scalars["bytea"]["input"]>
  job_group?: InputMaybe<Scalars["String"]["input"]>
  job_name?: InputMaybe<Scalars["String"]["input"]>
  misfire_instr?: InputMaybe<Scalars["smallint"]["input"]>
  next_fire_time?: InputMaybe<Scalars["bigint"]["input"]>
  prev_fire_time?: InputMaybe<Scalars["bigint"]["input"]>
  priority?: InputMaybe<Scalars["Int"]["input"]>
  sched_name?: InputMaybe<Scalars["String"]["input"]>
  start_time?: InputMaybe<Scalars["bigint"]["input"]>
  trigger_group?: InputMaybe<Scalars["String"]["input"]>
  trigger_name?: InputMaybe<Scalars["String"]["input"]>
  trigger_state?: InputMaybe<Scalars["String"]["input"]>
  trigger_type?: InputMaybe<Scalars["String"]["input"]>
}

/** aggregate sum on columns */
export type Tickets_Qrtz_Triggers_Sum_Fields = {
  __typename?: "tickets_qrtz_triggers_sum_fields"
  end_time?: Maybe<Scalars["bigint"]["output"]>
  misfire_instr?: Maybe<Scalars["smallint"]["output"]>
  next_fire_time?: Maybe<Scalars["bigint"]["output"]>
  prev_fire_time?: Maybe<Scalars["bigint"]["output"]>
  priority?: Maybe<Scalars["Int"]["output"]>
  start_time?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "qrtz_triggers" */
export enum Tickets_Qrtz_Triggers_Update_Column {
  /** column name */
  CalendarName = "calendar_name",
  /** column name */
  Description = "description",
  /** column name */
  EndTime = "end_time",
  /** column name */
  JobData = "job_data",
  /** column name */
  JobGroup = "job_group",
  /** column name */
  JobName = "job_name",
  /** column name */
  MisfireInstr = "misfire_instr",
  /** column name */
  NextFireTime = "next_fire_time",
  /** column name */
  PrevFireTime = "prev_fire_time",
  /** column name */
  Priority = "priority",
  /** column name */
  SchedName = "sched_name",
  /** column name */
  StartTime = "start_time",
  /** column name */
  TriggerGroup = "trigger_group",
  /** column name */
  TriggerName = "trigger_name",
  /** column name */
  TriggerState = "trigger_state",
  /** column name */
  TriggerType = "trigger_type",
}

export type Tickets_Qrtz_Triggers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tickets_Qrtz_Triggers_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tickets_Qrtz_Triggers_Set_Input>
  /** filter the rows which have to be updated */
  where: Tickets_Qrtz_Triggers_Bool_Exp
}

/** aggregate var_pop on columns */
export type Tickets_Qrtz_Triggers_Var_Pop_Fields = {
  __typename?: "tickets_qrtz_triggers_var_pop_fields"
  end_time?: Maybe<Scalars["Float"]["output"]>
  misfire_instr?: Maybe<Scalars["Float"]["output"]>
  next_fire_time?: Maybe<Scalars["Float"]["output"]>
  prev_fire_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  start_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Tickets_Qrtz_Triggers_Var_Samp_Fields = {
  __typename?: "tickets_qrtz_triggers_var_samp_fields"
  end_time?: Maybe<Scalars["Float"]["output"]>
  misfire_instr?: Maybe<Scalars["Float"]["output"]>
  next_fire_time?: Maybe<Scalars["Float"]["output"]>
  prev_fire_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  start_time?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Tickets_Qrtz_Triggers_Variance_Fields = {
  __typename?: "tickets_qrtz_triggers_variance_fields"
  end_time?: Maybe<Scalars["Float"]["output"]>
  misfire_instr?: Maybe<Scalars["Float"]["output"]>
  next_fire_time?: Maybe<Scalars["Float"]["output"]>
  prev_fire_time?: Maybe<Scalars["Float"]["output"]>
  priority?: Maybe<Scalars["Float"]["output"]>
  start_time?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "time_at_property". All fields are combined with logical 'AND'. */
export type Time_At_Property_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["time_at_property"]["input"]>
  _gt?: InputMaybe<Scalars["time_at_property"]["input"]>
  _gte?: InputMaybe<Scalars["time_at_property"]["input"]>
  _in?: InputMaybe<Array<Scalars["time_at_property"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["time_at_property"]["input"]>
  _lte?: InputMaybe<Scalars["time_at_property"]["input"]>
  _neq?: InputMaybe<Scalars["time_at_property"]["input"]>
  _nin?: InputMaybe<Array<Scalars["time_at_property"]["input"]>>
}

/** Boolean expression to compare columns of type "time_frame". All fields are combined with logical 'AND'. */
export type Time_Frame_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["time_frame"]["input"]>
  _gt?: InputMaybe<Scalars["time_frame"]["input"]>
  _gte?: InputMaybe<Scalars["time_frame"]["input"]>
  _in?: InputMaybe<Array<Scalars["time_frame"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["time_frame"]["input"]>
  _lte?: InputMaybe<Scalars["time_frame"]["input"]>
  _neq?: InputMaybe<Scalars["time_frame"]["input"]>
  _nin?: InputMaybe<Array<Scalars["time_frame"]["input"]>>
}

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["timestamp"]["input"]>
  _gt?: InputMaybe<Scalars["timestamp"]["input"]>
  _gte?: InputMaybe<Scalars["timestamp"]["input"]>
  _in?: InputMaybe<Array<Scalars["timestamp"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["timestamp"]["input"]>
  _lte?: InputMaybe<Scalars["timestamp"]["input"]>
  _neq?: InputMaybe<Scalars["timestamp"]["input"]>
  _nin?: InputMaybe<Array<Scalars["timestamp"]["input"]>>
}

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["timestamptz"]["input"]>
  _gt?: InputMaybe<Scalars["timestamptz"]["input"]>
  _gte?: InputMaybe<Scalars["timestamptz"]["input"]>
  _in?: InputMaybe<Array<Scalars["timestamptz"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["timestamptz"]["input"]>
  _lte?: InputMaybe<Scalars["timestamptz"]["input"]>
  _neq?: InputMaybe<Scalars["timestamptz"]["input"]>
  _nin?: InputMaybe<Array<Scalars["timestamptz"]["input"]>>
}

/** Boolean expression to compare columns of type "title". All fields are combined with logical 'AND'. */
export type Title_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["title"]["input"]>
  _gt?: InputMaybe<Scalars["title"]["input"]>
  _gte?: InputMaybe<Scalars["title"]["input"]>
  _in?: InputMaybe<Array<Scalars["title"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["title"]["input"]>
  _lte?: InputMaybe<Scalars["title"]["input"]>
  _neq?: InputMaybe<Scalars["title"]["input"]>
  _nin?: InputMaybe<Array<Scalars["title"]["input"]>>
}

/** columns and relationships of "trustpilot_invitations" */
export type Trustpilot_Invitations = {
  __typename?: "trustpilot_invitations"
  account_number: Scalars["String"]["output"]
  date_sent: Scalars["timestamp"]["output"]
  id: Scalars["Int"]["output"]
}

/** aggregated selection of "trustpilot_invitations" */
export type Trustpilot_Invitations_Aggregate = {
  __typename?: "trustpilot_invitations_aggregate"
  aggregate?: Maybe<Trustpilot_Invitations_Aggregate_Fields>
  nodes: Array<Trustpilot_Invitations>
}

/** aggregate fields of "trustpilot_invitations" */
export type Trustpilot_Invitations_Aggregate_Fields = {
  __typename?: "trustpilot_invitations_aggregate_fields"
  avg?: Maybe<Trustpilot_Invitations_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Trustpilot_Invitations_Max_Fields>
  min?: Maybe<Trustpilot_Invitations_Min_Fields>
  stddev?: Maybe<Trustpilot_Invitations_Stddev_Fields>
  stddev_pop?: Maybe<Trustpilot_Invitations_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Trustpilot_Invitations_Stddev_Samp_Fields>
  sum?: Maybe<Trustpilot_Invitations_Sum_Fields>
  var_pop?: Maybe<Trustpilot_Invitations_Var_Pop_Fields>
  var_samp?: Maybe<Trustpilot_Invitations_Var_Samp_Fields>
  variance?: Maybe<Trustpilot_Invitations_Variance_Fields>
}

/** aggregate fields of "trustpilot_invitations" */
export type Trustpilot_Invitations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trustpilot_Invitations_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Trustpilot_Invitations_Avg_Fields = {
  __typename?: "trustpilot_invitations_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "trustpilot_invitations". All fields are combined with a logical 'AND'. */
export type Trustpilot_Invitations_Bool_Exp = {
  _and?: InputMaybe<Array<Trustpilot_Invitations_Bool_Exp>>
  _not?: InputMaybe<Trustpilot_Invitations_Bool_Exp>
  _or?: InputMaybe<Array<Trustpilot_Invitations_Bool_Exp>>
  account_number?: InputMaybe<String_Comparison_Exp>
  date_sent?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Int_Comparison_Exp>
}

/** input type for incrementing numeric columns in table "trustpilot_invitations" */
export type Trustpilot_Invitations_Inc_Input = {
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "trustpilot_invitations" */
export type Trustpilot_Invitations_Insert_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  date_sent?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate max on columns */
export type Trustpilot_Invitations_Max_Fields = {
  __typename?: "trustpilot_invitations_max_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  date_sent?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
}

/** aggregate min on columns */
export type Trustpilot_Invitations_Min_Fields = {
  __typename?: "trustpilot_invitations_min_fields"
  account_number?: Maybe<Scalars["String"]["output"]>
  date_sent?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
}

/** response of any mutation on the table "trustpilot_invitations" */
export type Trustpilot_Invitations_Mutation_Response = {
  __typename?: "trustpilot_invitations_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Trustpilot_Invitations>
}

/** Ordering options when selecting data from "trustpilot_invitations". */
export type Trustpilot_Invitations_Order_By = {
  account_number?: InputMaybe<Order_By>
  date_sent?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
}

/** select columns of table "trustpilot_invitations" */
export enum Trustpilot_Invitations_Select_Column {
  /** column name */
  AccountNumber = "account_number",
  /** column name */
  DateSent = "date_sent",
  /** column name */
  Id = "id",
}

/** input type for updating data in table "trustpilot_invitations" */
export type Trustpilot_Invitations_Set_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  date_sent?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate stddev on columns */
export type Trustpilot_Invitations_Stddev_Fields = {
  __typename?: "trustpilot_invitations_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Trustpilot_Invitations_Stddev_Pop_Fields = {
  __typename?: "trustpilot_invitations_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Trustpilot_Invitations_Stddev_Samp_Fields = {
  __typename?: "trustpilot_invitations_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "trustpilot_invitations" */
export type Trustpilot_Invitations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trustpilot_Invitations_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Trustpilot_Invitations_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars["String"]["input"]>
  date_sent?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** aggregate sum on columns */
export type Trustpilot_Invitations_Sum_Fields = {
  __typename?: "trustpilot_invitations_sum_fields"
  id?: Maybe<Scalars["Int"]["output"]>
}

export type Trustpilot_Invitations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Trustpilot_Invitations_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trustpilot_Invitations_Set_Input>
  /** filter the rows which have to be updated */
  where: Trustpilot_Invitations_Bool_Exp
}

/** aggregate var_pop on columns */
export type Trustpilot_Invitations_Var_Pop_Fields = {
  __typename?: "trustpilot_invitations_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Trustpilot_Invitations_Var_Samp_Fields = {
  __typename?: "trustpilot_invitations_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Trustpilot_Invitations_Variance_Fields = {
  __typename?: "trustpilot_invitations_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "uk_profile_class". All fields are combined with logical 'AND'. */
export type Uk_Profile_Class_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["uk_profile_class"]["input"]>
  _gt?: InputMaybe<Scalars["uk_profile_class"]["input"]>
  _gte?: InputMaybe<Scalars["uk_profile_class"]["input"]>
  _in?: InputMaybe<Array<Scalars["uk_profile_class"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["uk_profile_class"]["input"]>
  _lte?: InputMaybe<Scalars["uk_profile_class"]["input"]>
  _neq?: InputMaybe<Scalars["uk_profile_class"]["input"]>
  _nin?: InputMaybe<Array<Scalars["uk_profile_class"]["input"]>>
}

/** columns and relationships of "users" */
export type Users = {
  __typename?: "users"
  /** An array relationship */
  admin_passes: Array<Admin_Passes>
  /** An aggregate relationship */
  admin_passes_aggregate: Admin_Passes_Aggregate
  /** An array relationship */
  admin_roles: Array<Admin_Roles>
  /** An aggregate relationship */
  admin_roles_aggregate: Admin_Roles_Aggregate
  created_at: Scalars["timestamp"]["output"]
  current_account_id?: Maybe<Scalars["bigint"]["output"]>
  current_sign_in_at?: Maybe<Scalars["timestamp"]["output"]>
  current_sign_in_ip?: Maybe<Scalars["String"]["output"]>
  customer_user_rels: Array<Customer_User_Rel>
  customer_user_rels_aggregate: Customer_User_Rel_Aggregate
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  email: Scalars["String"]["output"]
  encrypted_password: Scalars["String"]["output"]
  external_id?: Maybe<Scalars["String"]["output"]>
  failed_attempts: Scalars["Int"]["output"]
  first_name?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  last_name?: Maybe<Scalars["String"]["output"]>
  last_sign_in_at?: Maybe<Scalars["timestamp"]["output"]>
  last_sign_in_ip?: Maybe<Scalars["String"]["output"]>
  locked?: Maybe<Scalars["timestamp"]["output"]>
  /** An array relationship */
  password_reset_tokens: Array<Password_Reset_Tokens>
  /** An aggregate relationship */
  password_reset_tokens_aggregate: Password_Reset_Tokens_Aggregate
  /** An array relationship */
  refresh_tokens: Array<Refresh_Tokens>
  /** An aggregate relationship */
  refresh_tokens_aggregate: Refresh_Tokens_Aggregate
  sign_in_count: Scalars["Int"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** columns and relationships of "users" */
export type UsersAdmin_PassesArgs = {
  distinct_on?: InputMaybe<Array<Admin_Passes_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Admin_Passes_Order_By>>
  where?: InputMaybe<Admin_Passes_Bool_Exp>
}

/** columns and relationships of "users" */
export type UsersAdmin_Passes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Passes_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Admin_Passes_Order_By>>
  where?: InputMaybe<Admin_Passes_Bool_Exp>
}

/** columns and relationships of "users" */
export type UsersAdmin_RolesArgs = {
  distinct_on?: InputMaybe<Array<Admin_Roles_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Admin_Roles_Order_By>>
  where?: InputMaybe<Admin_Roles_Bool_Exp>
}

/** columns and relationships of "users" */
export type UsersAdmin_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Roles_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Admin_Roles_Order_By>>
  where?: InputMaybe<Admin_Roles_Bool_Exp>
}

/** columns and relationships of "users" */
export type UsersCustomer_User_RelsArgs = {
  distinct_on?: InputMaybe<Array<Customer_User_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_User_Rel_Order_By>>
  where?: InputMaybe<Customer_User_Rel_Bool_Exp>
}

/** columns and relationships of "users" */
export type UsersCustomer_User_Rels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_User_Rel_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Customer_User_Rel_Order_By>>
  where?: InputMaybe<Customer_User_Rel_Bool_Exp>
}

/** columns and relationships of "users" */
export type UsersPassword_Reset_TokensArgs = {
  distinct_on?: InputMaybe<Array<Password_Reset_Tokens_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Password_Reset_Tokens_Order_By>>
  where?: InputMaybe<Password_Reset_Tokens_Bool_Exp>
}

/** columns and relationships of "users" */
export type UsersPassword_Reset_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Password_Reset_Tokens_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Password_Reset_Tokens_Order_By>>
  where?: InputMaybe<Password_Reset_Tokens_Bool_Exp>
}

/** columns and relationships of "users" */
export type UsersRefresh_TokensArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Tokens_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Refresh_Tokens_Order_By>>
  where?: InputMaybe<Refresh_Tokens_Bool_Exp>
}

/** columns and relationships of "users" */
export type UsersRefresh_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refresh_Tokens_Select_Column>>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  order_by?: InputMaybe<Array<Refresh_Tokens_Order_By>>
  where?: InputMaybe<Refresh_Tokens_Bool_Exp>
}

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: "users_aggregate"
  aggregate?: Maybe<Users_Aggregate_Fields>
  nodes: Array<Users>
}

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: "users_aggregate_fields"
  avg?: Maybe<Users_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Users_Max_Fields>
  min?: Maybe<Users_Min_Fields>
  stddev?: Maybe<Users_Stddev_Fields>
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>
  sum?: Maybe<Users_Sum_Fields>
  var_pop?: Maybe<Users_Var_Pop_Fields>
  var_samp?: Maybe<Users_Var_Samp_Fields>
  variance?: Maybe<Users_Variance_Fields>
}

/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: "users_avg_fields"
  current_account_id?: Maybe<Scalars["Float"]["output"]>
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  sign_in_count?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>
  _not?: InputMaybe<Users_Bool_Exp>
  _or?: InputMaybe<Array<Users_Bool_Exp>>
  admin_passes?: InputMaybe<Admin_Passes_Bool_Exp>
  admin_passes_aggregate?: InputMaybe<Admin_Passes_Aggregate_Bool_Exp>
  admin_roles?: InputMaybe<Admin_Roles_Bool_Exp>
  admin_roles_aggregate?: InputMaybe<Admin_Roles_Aggregate_Bool_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  current_account_id?: InputMaybe<Bigint_Comparison_Exp>
  current_sign_in_at?: InputMaybe<Timestamp_Comparison_Exp>
  current_sign_in_ip?: InputMaybe<String_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  email?: InputMaybe<String_Comparison_Exp>
  encrypted_password?: InputMaybe<String_Comparison_Exp>
  external_id?: InputMaybe<String_Comparison_Exp>
  failed_attempts?: InputMaybe<Int_Comparison_Exp>
  first_name?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  last_name?: InputMaybe<String_Comparison_Exp>
  last_sign_in_at?: InputMaybe<Timestamp_Comparison_Exp>
  last_sign_in_ip?: InputMaybe<String_Comparison_Exp>
  locked?: InputMaybe<Timestamp_Comparison_Exp>
  password_reset_tokens?: InputMaybe<Password_Reset_Tokens_Bool_Exp>
  password_reset_tokens_aggregate?: InputMaybe<Password_Reset_Tokens_Aggregate_Bool_Exp>
  refresh_tokens?: InputMaybe<Refresh_Tokens_Bool_Exp>
  refresh_tokens_aggregate?: InputMaybe<Refresh_Tokens_Aggregate_Bool_Exp>
  sign_in_count?: InputMaybe<Int_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkUser = "pk_user",
  /** unique or primary key constraint on columns "email" */
  UsersEmailKey = "users_email_key",
}

/** input type for incrementing numeric columns in table "users" */
export type Users_Inc_Input = {
  current_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  failed_attempts?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  sign_in_count?: InputMaybe<Scalars["Int"]["input"]>
}

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  admin_passes?: InputMaybe<Admin_Passes_Arr_Rel_Insert_Input>
  admin_roles?: InputMaybe<Admin_Roles_Arr_Rel_Insert_Input>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  current_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  current_sign_in_at?: InputMaybe<Scalars["timestamp"]["input"]>
  current_sign_in_ip?: InputMaybe<Scalars["String"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  encrypted_password?: InputMaybe<Scalars["String"]["input"]>
  external_id?: InputMaybe<Scalars["String"]["input"]>
  failed_attempts?: InputMaybe<Scalars["Int"]["input"]>
  first_name?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_name?: InputMaybe<Scalars["String"]["input"]>
  last_sign_in_at?: InputMaybe<Scalars["timestamp"]["input"]>
  last_sign_in_ip?: InputMaybe<Scalars["String"]["input"]>
  locked?: InputMaybe<Scalars["timestamp"]["input"]>
  password_reset_tokens?: InputMaybe<Password_Reset_Tokens_Arr_Rel_Insert_Input>
  refresh_tokens?: InputMaybe<Refresh_Tokens_Arr_Rel_Insert_Input>
  sign_in_count?: InputMaybe<Scalars["Int"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: "users_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  current_account_id?: Maybe<Scalars["bigint"]["output"]>
  current_sign_in_at?: Maybe<Scalars["timestamp"]["output"]>
  current_sign_in_ip?: Maybe<Scalars["String"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  encrypted_password?: Maybe<Scalars["String"]["output"]>
  external_id?: Maybe<Scalars["String"]["output"]>
  failed_attempts?: Maybe<Scalars["Int"]["output"]>
  first_name?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_name?: Maybe<Scalars["String"]["output"]>
  last_sign_in_at?: Maybe<Scalars["timestamp"]["output"]>
  last_sign_in_ip?: Maybe<Scalars["String"]["output"]>
  locked?: Maybe<Scalars["timestamp"]["output"]>
  sign_in_count?: Maybe<Scalars["Int"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: "users_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  current_account_id?: Maybe<Scalars["bigint"]["output"]>
  current_sign_in_at?: Maybe<Scalars["timestamp"]["output"]>
  current_sign_in_ip?: Maybe<Scalars["String"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  encrypted_password?: Maybe<Scalars["String"]["output"]>
  external_id?: Maybe<Scalars["String"]["output"]>
  failed_attempts?: Maybe<Scalars["Int"]["output"]>
  first_name?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_name?: Maybe<Scalars["String"]["output"]>
  last_sign_in_at?: Maybe<Scalars["timestamp"]["output"]>
  last_sign_in_ip?: Maybe<Scalars["String"]["output"]>
  locked?: Maybe<Scalars["timestamp"]["output"]>
  sign_in_count?: Maybe<Scalars["Int"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: "users_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Users>
}

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>
}

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint
  update_columns?: Array<Users_Update_Column>
  where?: InputMaybe<Users_Bool_Exp>
}

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  admin_passes_aggregate?: InputMaybe<Admin_Passes_Aggregate_Order_By>
  admin_roles_aggregate?: InputMaybe<Admin_Roles_Aggregate_Order_By>
  created_at?: InputMaybe<Order_By>
  current_account_id?: InputMaybe<Order_By>
  current_sign_in_at?: InputMaybe<Order_By>
  current_sign_in_ip?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  email?: InputMaybe<Order_By>
  encrypted_password?: InputMaybe<Order_By>
  external_id?: InputMaybe<Order_By>
  failed_attempts?: InputMaybe<Order_By>
  first_name?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  last_name?: InputMaybe<Order_By>
  last_sign_in_at?: InputMaybe<Order_By>
  last_sign_in_ip?: InputMaybe<Order_By>
  locked?: InputMaybe<Order_By>
  password_reset_tokens_aggregate?: InputMaybe<Password_Reset_Tokens_Aggregate_Order_By>
  refresh_tokens_aggregate?: InputMaybe<Refresh_Tokens_Aggregate_Order_By>
  sign_in_count?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CurrentAccountId = "current_account_id",
  /** column name */
  CurrentSignInAt = "current_sign_in_at",
  /** column name */
  CurrentSignInIp = "current_sign_in_ip",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Email = "email",
  /** column name */
  EncryptedPassword = "encrypted_password",
  /** column name */
  ExternalId = "external_id",
  /** column name */
  FailedAttempts = "failed_attempts",
  /** column name */
  FirstName = "first_name",
  /** column name */
  Id = "id",
  /** column name */
  LastName = "last_name",
  /** column name */
  LastSignInAt = "last_sign_in_at",
  /** column name */
  LastSignInIp = "last_sign_in_ip",
  /** column name */
  Locked = "locked",
  /** column name */
  SignInCount = "sign_in_count",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  current_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  current_sign_in_at?: InputMaybe<Scalars["timestamp"]["input"]>
  current_sign_in_ip?: InputMaybe<Scalars["String"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  encrypted_password?: InputMaybe<Scalars["String"]["input"]>
  external_id?: InputMaybe<Scalars["String"]["input"]>
  failed_attempts?: InputMaybe<Scalars["Int"]["input"]>
  first_name?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_name?: InputMaybe<Scalars["String"]["input"]>
  last_sign_in_at?: InputMaybe<Scalars["timestamp"]["input"]>
  last_sign_in_ip?: InputMaybe<Scalars["String"]["input"]>
  locked?: InputMaybe<Scalars["timestamp"]["input"]>
  sign_in_count?: InputMaybe<Scalars["Int"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: "users_stddev_fields"
  current_account_id?: Maybe<Scalars["Float"]["output"]>
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  sign_in_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: "users_stddev_pop_fields"
  current_account_id?: Maybe<Scalars["Float"]["output"]>
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  sign_in_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: "users_stddev_samp_fields"
  current_account_id?: Maybe<Scalars["Float"]["output"]>
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  sign_in_count?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  current_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  current_sign_in_at?: InputMaybe<Scalars["timestamp"]["input"]>
  current_sign_in_ip?: InputMaybe<Scalars["String"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  encrypted_password?: InputMaybe<Scalars["String"]["input"]>
  external_id?: InputMaybe<Scalars["String"]["input"]>
  failed_attempts?: InputMaybe<Scalars["Int"]["input"]>
  first_name?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_name?: InputMaybe<Scalars["String"]["input"]>
  last_sign_in_at?: InputMaybe<Scalars["timestamp"]["input"]>
  last_sign_in_ip?: InputMaybe<Scalars["String"]["input"]>
  locked?: InputMaybe<Scalars["timestamp"]["input"]>
  sign_in_count?: InputMaybe<Scalars["Int"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: "users_sum_fields"
  current_account_id?: Maybe<Scalars["bigint"]["output"]>
  failed_attempts?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  sign_in_count?: Maybe<Scalars["Int"]["output"]>
}

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CurrentAccountId = "current_account_id",
  /** column name */
  CurrentSignInAt = "current_sign_in_at",
  /** column name */
  CurrentSignInIp = "current_sign_in_ip",
  /** column name */
  Deleted = "deleted",
  /** column name */
  Email = "email",
  /** column name */
  EncryptedPassword = "encrypted_password",
  /** column name */
  ExternalId = "external_id",
  /** column name */
  FailedAttempts = "failed_attempts",
  /** column name */
  FirstName = "first_name",
  /** column name */
  Id = "id",
  /** column name */
  LastName = "last_name",
  /** column name */
  LastSignInAt = "last_sign_in_at",
  /** column name */
  LastSignInIp = "last_sign_in_ip",
  /** column name */
  Locked = "locked",
  /** column name */
  SignInCount = "sign_in_count",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp
}

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: "users_var_pop_fields"
  current_account_id?: Maybe<Scalars["Float"]["output"]>
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  sign_in_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: "users_var_samp_fields"
  current_account_id?: Maybe<Scalars["Float"]["output"]>
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  sign_in_count?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: "users_variance_fields"
  current_account_id?: Maybe<Scalars["Float"]["output"]>
  failed_attempts?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  sign_in_count?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "uswitch_record" */
export type Uswitch_Record = {
  __typename?: "uswitch_record"
  created_at: Scalars["timestamp"]["output"]
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  /** An object relationship */
  enrolment?: Maybe<Enrolment>
  enrolment_id?: Maybe<Scalars["bigint"]["output"]>
  id: Scalars["bigint"]["output"]
  junifer_customer_id?: Maybe<Scalars["bigint"]["output"]>
  reason?: Maybe<Scalars["String"]["output"]>
  status: Scalars["uswitch_record_status"]["output"]
  switch_ref: Scalars["String"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "uswitch_record" */
export type Uswitch_Record_Aggregate = {
  __typename?: "uswitch_record_aggregate"
  aggregate?: Maybe<Uswitch_Record_Aggregate_Fields>
  nodes: Array<Uswitch_Record>
}

export type Uswitch_Record_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uswitch_Record_Aggregate_Bool_Exp_Count>
}

export type Uswitch_Record_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uswitch_Record_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  filter?: InputMaybe<Uswitch_Record_Bool_Exp>
  predicate: Int_Comparison_Exp
}

/** aggregate fields of "uswitch_record" */
export type Uswitch_Record_Aggregate_Fields = {
  __typename?: "uswitch_record_aggregate_fields"
  avg?: Maybe<Uswitch_Record_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Uswitch_Record_Max_Fields>
  min?: Maybe<Uswitch_Record_Min_Fields>
  stddev?: Maybe<Uswitch_Record_Stddev_Fields>
  stddev_pop?: Maybe<Uswitch_Record_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Uswitch_Record_Stddev_Samp_Fields>
  sum?: Maybe<Uswitch_Record_Sum_Fields>
  var_pop?: Maybe<Uswitch_Record_Var_Pop_Fields>
  var_samp?: Maybe<Uswitch_Record_Var_Samp_Fields>
  variance?: Maybe<Uswitch_Record_Variance_Fields>
}

/** aggregate fields of "uswitch_record" */
export type Uswitch_Record_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uswitch_Record_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** order by aggregate values of table "uswitch_record" */
export type Uswitch_Record_Aggregate_Order_By = {
  avg?: InputMaybe<Uswitch_Record_Avg_Order_By>
  count?: InputMaybe<Order_By>
  max?: InputMaybe<Uswitch_Record_Max_Order_By>
  min?: InputMaybe<Uswitch_Record_Min_Order_By>
  stddev?: InputMaybe<Uswitch_Record_Stddev_Order_By>
  stddev_pop?: InputMaybe<Uswitch_Record_Stddev_Pop_Order_By>
  stddev_samp?: InputMaybe<Uswitch_Record_Stddev_Samp_Order_By>
  sum?: InputMaybe<Uswitch_Record_Sum_Order_By>
  var_pop?: InputMaybe<Uswitch_Record_Var_Pop_Order_By>
  var_samp?: InputMaybe<Uswitch_Record_Var_Samp_Order_By>
  variance?: InputMaybe<Uswitch_Record_Variance_Order_By>
}

/** input type for inserting array relation for remote table "uswitch_record" */
export type Uswitch_Record_Arr_Rel_Insert_Input = {
  data: Array<Uswitch_Record_Insert_Input>
  /** upsert condition */
  on_conflict?: InputMaybe<Uswitch_Record_On_Conflict>
}

/** aggregate avg on columns */
export type Uswitch_Record_Avg_Fields = {
  __typename?: "uswitch_record_avg_fields"
  enrolment_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_customer_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by avg() on columns of table "uswitch_record" */
export type Uswitch_Record_Avg_Order_By = {
  enrolment_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  junifer_customer_id?: InputMaybe<Order_By>
}

/** Boolean expression to filter rows from the table "uswitch_record". All fields are combined with a logical 'AND'. */
export type Uswitch_Record_Bool_Exp = {
  _and?: InputMaybe<Array<Uswitch_Record_Bool_Exp>>
  _not?: InputMaybe<Uswitch_Record_Bool_Exp>
  _or?: InputMaybe<Array<Uswitch_Record_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  deleted?: InputMaybe<Timestamp_Comparison_Exp>
  enrolment?: InputMaybe<Enrolment_Bool_Exp>
  enrolment_id?: InputMaybe<Bigint_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  junifer_customer_id?: InputMaybe<Bigint_Comparison_Exp>
  reason?: InputMaybe<String_Comparison_Exp>
  status?: InputMaybe<Uswitch_Record_Status_Comparison_Exp>
  switch_ref?: InputMaybe<String_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "uswitch_record" */
export enum Uswitch_Record_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkUswitchRecord = "pk_uswitch_record",
  /** unique or primary key constraint on columns "switch_ref" */
  UqSwitchRef = "uq_switch_ref",
}

/** input type for incrementing numeric columns in table "uswitch_record" */
export type Uswitch_Record_Inc_Input = {
  enrolment_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_customer_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "uswitch_record" */
export type Uswitch_Record_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  enrolment?: InputMaybe<Enrolment_Obj_Rel_Insert_Input>
  enrolment_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  reason?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["uswitch_record_status"]["input"]>
  switch_ref?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Uswitch_Record_Max_Fields = {
  __typename?: "uswitch_record_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  enrolment_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_customer_id?: Maybe<Scalars["bigint"]["output"]>
  reason?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["uswitch_record_status"]["output"]>
  switch_ref?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by max() on columns of table "uswitch_record" */
export type Uswitch_Record_Max_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  enrolment_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  junifer_customer_id?: InputMaybe<Order_By>
  reason?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  switch_ref?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** aggregate min on columns */
export type Uswitch_Record_Min_Fields = {
  __typename?: "uswitch_record_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  deleted?: Maybe<Scalars["timestamp"]["output"]>
  enrolment_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_customer_id?: Maybe<Scalars["bigint"]["output"]>
  reason?: Maybe<Scalars["String"]["output"]>
  status?: Maybe<Scalars["uswitch_record_status"]["output"]>
  switch_ref?: Maybe<Scalars["String"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** order by min() on columns of table "uswitch_record" */
export type Uswitch_Record_Min_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  enrolment_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  junifer_customer_id?: InputMaybe<Order_By>
  reason?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  switch_ref?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** response of any mutation on the table "uswitch_record" */
export type Uswitch_Record_Mutation_Response = {
  __typename?: "uswitch_record_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Uswitch_Record>
}

/** on_conflict condition type for table "uswitch_record" */
export type Uswitch_Record_On_Conflict = {
  constraint: Uswitch_Record_Constraint
  update_columns?: Array<Uswitch_Record_Update_Column>
  where?: InputMaybe<Uswitch_Record_Bool_Exp>
}

/** Ordering options when selecting data from "uswitch_record". */
export type Uswitch_Record_Order_By = {
  created_at?: InputMaybe<Order_By>
  deleted?: InputMaybe<Order_By>
  enrolment?: InputMaybe<Enrolment_Order_By>
  enrolment_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  junifer_customer_id?: InputMaybe<Order_By>
  reason?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  switch_ref?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: uswitch_record */
export type Uswitch_Record_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "uswitch_record" */
export enum Uswitch_Record_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  EnrolmentId = "enrolment_id",
  /** column name */
  Id = "id",
  /** column name */
  JuniferCustomerId = "junifer_customer_id",
  /** column name */
  Reason = "reason",
  /** column name */
  Status = "status",
  /** column name */
  SwitchRef = "switch_ref",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "uswitch_record" */
export type Uswitch_Record_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  enrolment_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  reason?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["uswitch_record_status"]["input"]>
  switch_ref?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** Boolean expression to compare columns of type "uswitch_record_status". All fields are combined with logical 'AND'. */
export type Uswitch_Record_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["uswitch_record_status"]["input"]>
  _gt?: InputMaybe<Scalars["uswitch_record_status"]["input"]>
  _gte?: InputMaybe<Scalars["uswitch_record_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["uswitch_record_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["uswitch_record_status"]["input"]>
  _lte?: InputMaybe<Scalars["uswitch_record_status"]["input"]>
  _neq?: InputMaybe<Scalars["uswitch_record_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["uswitch_record_status"]["input"]>>
}

/** aggregate stddev on columns */
export type Uswitch_Record_Stddev_Fields = {
  __typename?: "uswitch_record_stddev_fields"
  enrolment_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_customer_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev() on columns of table "uswitch_record" */
export type Uswitch_Record_Stddev_Order_By = {
  enrolment_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  junifer_customer_id?: InputMaybe<Order_By>
}

/** aggregate stddev_pop on columns */
export type Uswitch_Record_Stddev_Pop_Fields = {
  __typename?: "uswitch_record_stddev_pop_fields"
  enrolment_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_customer_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_pop() on columns of table "uswitch_record" */
export type Uswitch_Record_Stddev_Pop_Order_By = {
  enrolment_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  junifer_customer_id?: InputMaybe<Order_By>
}

/** aggregate stddev_samp on columns */
export type Uswitch_Record_Stddev_Samp_Fields = {
  __typename?: "uswitch_record_stddev_samp_fields"
  enrolment_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_customer_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by stddev_samp() on columns of table "uswitch_record" */
export type Uswitch_Record_Stddev_Samp_Order_By = {
  enrolment_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  junifer_customer_id?: InputMaybe<Order_By>
}

/** Streaming cursor of the table "uswitch_record" */
export type Uswitch_Record_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uswitch_Record_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Uswitch_Record_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  deleted?: InputMaybe<Scalars["timestamp"]["input"]>
  enrolment_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  junifer_customer_id?: InputMaybe<Scalars["bigint"]["input"]>
  reason?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["uswitch_record_status"]["input"]>
  switch_ref?: InputMaybe<Scalars["String"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Uswitch_Record_Sum_Fields = {
  __typename?: "uswitch_record_sum_fields"
  enrolment_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  junifer_customer_id?: Maybe<Scalars["bigint"]["output"]>
}

/** order by sum() on columns of table "uswitch_record" */
export type Uswitch_Record_Sum_Order_By = {
  enrolment_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  junifer_customer_id?: InputMaybe<Order_By>
}

/** update columns of table "uswitch_record" */
export enum Uswitch_Record_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Deleted = "deleted",
  /** column name */
  EnrolmentId = "enrolment_id",
  /** column name */
  Id = "id",
  /** column name */
  JuniferCustomerId = "junifer_customer_id",
  /** column name */
  Reason = "reason",
  /** column name */
  Status = "status",
  /** column name */
  SwitchRef = "switch_ref",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Uswitch_Record_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uswitch_Record_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uswitch_Record_Set_Input>
  /** filter the rows which have to be updated */
  where: Uswitch_Record_Bool_Exp
}

/** aggregate var_pop on columns */
export type Uswitch_Record_Var_Pop_Fields = {
  __typename?: "uswitch_record_var_pop_fields"
  enrolment_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_customer_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_pop() on columns of table "uswitch_record" */
export type Uswitch_Record_Var_Pop_Order_By = {
  enrolment_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  junifer_customer_id?: InputMaybe<Order_By>
}

/** aggregate var_samp on columns */
export type Uswitch_Record_Var_Samp_Fields = {
  __typename?: "uswitch_record_var_samp_fields"
  enrolment_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_customer_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by var_samp() on columns of table "uswitch_record" */
export type Uswitch_Record_Var_Samp_Order_By = {
  enrolment_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  junifer_customer_id?: InputMaybe<Order_By>
}

/** aggregate variance on columns */
export type Uswitch_Record_Variance_Fields = {
  __typename?: "uswitch_record_variance_fields"
  enrolment_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  junifer_customer_id?: Maybe<Scalars["Float"]["output"]>
}

/** order by variance() on columns of table "uswitch_record" */
export type Uswitch_Record_Variance_Order_By = {
  enrolment_id?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  junifer_customer_id?: InputMaybe<Order_By>
}

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["uuid"]["input"]>
  _gt?: InputMaybe<Scalars["uuid"]["input"]>
  _gte?: InputMaybe<Scalars["uuid"]["input"]>
  _in?: InputMaybe<Array<Scalars["uuid"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["uuid"]["input"]>
  _lte?: InputMaybe<Scalars["uuid"]["input"]>
  _neq?: InputMaybe<Scalars["uuid"]["input"]>
  _nin?: InputMaybe<Array<Scalars["uuid"]["input"]>>
}

/** columns and relationships of "warm_home_discount_application" */
export type Warm_Home_Discount_Application = {
  __typename?: "warm_home_discount_application"
  address?: Maybe<Scalars["String"]["output"]>
  application_year: Scalars["String"]["output"]
  assigned_agent?: Maybe<Scalars["String"]["output"]>
  billing_account_id: Scalars["bigint"]["output"]
  billing_account_number?: Maybe<Scalars["String"]["output"]>
  communication_preference: Scalars["String"]["output"]
  created_at: Scalars["timestamp"]["output"]
  date_of_birth?: Maybe<Scalars["date"]["output"]>
  email: Scalars["String"]["output"]
  first_name: Scalars["String"]["output"]
  gsp_group?: Maybe<Scalars["String"]["output"]>
  id: Scalars["bigint"]["output"]
  last_name: Scalars["String"]["output"]
  phone_number?: Maybe<Scalars["String"]["output"]>
  postcode?: Maybe<Scalars["String"]["output"]>
  primary_criteria_id: Scalars["bigint"]["output"]
  secondary_criteria_id: Scalars["bigint"]["output"]
  status: Scalars["warm_home_discount_application_status"]["output"]
  updated_at: Scalars["timestamp"]["output"]
  user_id: Scalars["bigint"]["output"]
}

/** aggregated selection of "warm_home_discount_application" */
export type Warm_Home_Discount_Application_Aggregate = {
  __typename?: "warm_home_discount_application_aggregate"
  aggregate?: Maybe<Warm_Home_Discount_Application_Aggregate_Fields>
  nodes: Array<Warm_Home_Discount_Application>
}

/** aggregate fields of "warm_home_discount_application" */
export type Warm_Home_Discount_Application_Aggregate_Fields = {
  __typename?: "warm_home_discount_application_aggregate_fields"
  avg?: Maybe<Warm_Home_Discount_Application_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Warm_Home_Discount_Application_Max_Fields>
  min?: Maybe<Warm_Home_Discount_Application_Min_Fields>
  stddev?: Maybe<Warm_Home_Discount_Application_Stddev_Fields>
  stddev_pop?: Maybe<Warm_Home_Discount_Application_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Warm_Home_Discount_Application_Stddev_Samp_Fields>
  sum?: Maybe<Warm_Home_Discount_Application_Sum_Fields>
  var_pop?: Maybe<Warm_Home_Discount_Application_Var_Pop_Fields>
  var_samp?: Maybe<Warm_Home_Discount_Application_Var_Samp_Fields>
  variance?: Maybe<Warm_Home_Discount_Application_Variance_Fields>
}

/** aggregate fields of "warm_home_discount_application" */
export type Warm_Home_Discount_Application_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Warm_Home_Discount_Application_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Warm_Home_Discount_Application_Avg_Fields = {
  __typename?: "warm_home_discount_application_avg_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  primary_criteria_id?: Maybe<Scalars["Float"]["output"]>
  secondary_criteria_id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "warm_home_discount_application". All fields are combined with a logical 'AND'. */
export type Warm_Home_Discount_Application_Bool_Exp = {
  _and?: InputMaybe<Array<Warm_Home_Discount_Application_Bool_Exp>>
  _not?: InputMaybe<Warm_Home_Discount_Application_Bool_Exp>
  _or?: InputMaybe<Array<Warm_Home_Discount_Application_Bool_Exp>>
  address?: InputMaybe<String_Comparison_Exp>
  application_year?: InputMaybe<String_Comparison_Exp>
  assigned_agent?: InputMaybe<String_Comparison_Exp>
  billing_account_id?: InputMaybe<Bigint_Comparison_Exp>
  billing_account_number?: InputMaybe<String_Comparison_Exp>
  communication_preference?: InputMaybe<String_Comparison_Exp>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  date_of_birth?: InputMaybe<Date_Comparison_Exp>
  email?: InputMaybe<String_Comparison_Exp>
  first_name?: InputMaybe<String_Comparison_Exp>
  gsp_group?: InputMaybe<String_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  last_name?: InputMaybe<String_Comparison_Exp>
  phone_number?: InputMaybe<String_Comparison_Exp>
  postcode?: InputMaybe<String_Comparison_Exp>
  primary_criteria_id?: InputMaybe<Bigint_Comparison_Exp>
  secondary_criteria_id?: InputMaybe<Bigint_Comparison_Exp>
  status?: InputMaybe<Warm_Home_Discount_Application_Status_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
  user_id?: InputMaybe<Bigint_Comparison_Exp>
}

/** unique or primary key constraints on table "warm_home_discount_application" */
export enum Warm_Home_Discount_Application_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarmHomeDiscountApplicationPkey = "warm_home_discount_application_pkey",
}

/** input type for incrementing numeric columns in table "warm_home_discount_application" */
export type Warm_Home_Discount_Application_Inc_Input = {
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  primary_criteria_id?: InputMaybe<Scalars["bigint"]["input"]>
  secondary_criteria_id?: InputMaybe<Scalars["bigint"]["input"]>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "warm_home_discount_application" */
export type Warm_Home_Discount_Application_Insert_Input = {
  address?: InputMaybe<Scalars["String"]["input"]>
  application_year?: InputMaybe<Scalars["String"]["input"]>
  assigned_agent?: InputMaybe<Scalars["String"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  billing_account_number?: InputMaybe<Scalars["String"]["input"]>
  communication_preference?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  date_of_birth?: InputMaybe<Scalars["date"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  first_name?: InputMaybe<Scalars["String"]["input"]>
  gsp_group?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_name?: InputMaybe<Scalars["String"]["input"]>
  phone_number?: InputMaybe<Scalars["String"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  primary_criteria_id?: InputMaybe<Scalars["bigint"]["input"]>
  secondary_criteria_id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["warm_home_discount_application_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate max on columns */
export type Warm_Home_Discount_Application_Max_Fields = {
  __typename?: "warm_home_discount_application_max_fields"
  address?: Maybe<Scalars["String"]["output"]>
  application_year?: Maybe<Scalars["String"]["output"]>
  assigned_agent?: Maybe<Scalars["String"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  billing_account_number?: Maybe<Scalars["String"]["output"]>
  communication_preference?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  date_of_birth?: Maybe<Scalars["date"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  first_name?: Maybe<Scalars["String"]["output"]>
  gsp_group?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_name?: Maybe<Scalars["String"]["output"]>
  phone_number?: Maybe<Scalars["String"]["output"]>
  postcode?: Maybe<Scalars["String"]["output"]>
  primary_criteria_id?: Maybe<Scalars["bigint"]["output"]>
  secondary_criteria_id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["warm_home_discount_application_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregate min on columns */
export type Warm_Home_Discount_Application_Min_Fields = {
  __typename?: "warm_home_discount_application_min_fields"
  address?: Maybe<Scalars["String"]["output"]>
  application_year?: Maybe<Scalars["String"]["output"]>
  assigned_agent?: Maybe<Scalars["String"]["output"]>
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  billing_account_number?: Maybe<Scalars["String"]["output"]>
  communication_preference?: Maybe<Scalars["String"]["output"]>
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  date_of_birth?: Maybe<Scalars["date"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  first_name?: Maybe<Scalars["String"]["output"]>
  gsp_group?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  last_name?: Maybe<Scalars["String"]["output"]>
  phone_number?: Maybe<Scalars["String"]["output"]>
  postcode?: Maybe<Scalars["String"]["output"]>
  primary_criteria_id?: Maybe<Scalars["bigint"]["output"]>
  secondary_criteria_id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["warm_home_discount_application_status"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** response of any mutation on the table "warm_home_discount_application" */
export type Warm_Home_Discount_Application_Mutation_Response = {
  __typename?: "warm_home_discount_application_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Warm_Home_Discount_Application>
}

/** on_conflict condition type for table "warm_home_discount_application" */
export type Warm_Home_Discount_Application_On_Conflict = {
  constraint: Warm_Home_Discount_Application_Constraint
  update_columns?: Array<Warm_Home_Discount_Application_Update_Column>
  where?: InputMaybe<Warm_Home_Discount_Application_Bool_Exp>
}

/** Ordering options when selecting data from "warm_home_discount_application". */
export type Warm_Home_Discount_Application_Order_By = {
  address?: InputMaybe<Order_By>
  application_year?: InputMaybe<Order_By>
  assigned_agent?: InputMaybe<Order_By>
  billing_account_id?: InputMaybe<Order_By>
  billing_account_number?: InputMaybe<Order_By>
  communication_preference?: InputMaybe<Order_By>
  created_at?: InputMaybe<Order_By>
  date_of_birth?: InputMaybe<Order_By>
  email?: InputMaybe<Order_By>
  first_name?: InputMaybe<Order_By>
  gsp_group?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  last_name?: InputMaybe<Order_By>
  phone_number?: InputMaybe<Order_By>
  postcode?: InputMaybe<Order_By>
  primary_criteria_id?: InputMaybe<Order_By>
  secondary_criteria_id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
  user_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: warm_home_discount_application */
export type Warm_Home_Discount_Application_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "warm_home_discount_application" */
export enum Warm_Home_Discount_Application_Select_Column {
  /** column name */
  Address = "address",
  /** column name */
  ApplicationYear = "application_year",
  /** column name */
  AssignedAgent = "assigned_agent",
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  BillingAccountNumber = "billing_account_number",
  /** column name */
  CommunicationPreference = "communication_preference",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DateOfBirth = "date_of_birth",
  /** column name */
  Email = "email",
  /** column name */
  FirstName = "first_name",
  /** column name */
  GspGroup = "gsp_group",
  /** column name */
  Id = "id",
  /** column name */
  LastName = "last_name",
  /** column name */
  PhoneNumber = "phone_number",
  /** column name */
  Postcode = "postcode",
  /** column name */
  PrimaryCriteriaId = "primary_criteria_id",
  /** column name */
  SecondaryCriteriaId = "secondary_criteria_id",
  /** column name */
  Status = "status",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  UserId = "user_id",
}

/** input type for updating data in table "warm_home_discount_application" */
export type Warm_Home_Discount_Application_Set_Input = {
  address?: InputMaybe<Scalars["String"]["input"]>
  application_year?: InputMaybe<Scalars["String"]["input"]>
  assigned_agent?: InputMaybe<Scalars["String"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  billing_account_number?: InputMaybe<Scalars["String"]["input"]>
  communication_preference?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  date_of_birth?: InputMaybe<Scalars["date"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  first_name?: InputMaybe<Scalars["String"]["input"]>
  gsp_group?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_name?: InputMaybe<Scalars["String"]["input"]>
  phone_number?: InputMaybe<Scalars["String"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  primary_criteria_id?: InputMaybe<Scalars["bigint"]["input"]>
  secondary_criteria_id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["warm_home_discount_application_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** Boolean expression to compare columns of type "warm_home_discount_application_status". All fields are combined with logical 'AND'. */
export type Warm_Home_Discount_Application_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["warm_home_discount_application_status"]["input"]>
  _gt?: InputMaybe<Scalars["warm_home_discount_application_status"]["input"]>
  _gte?: InputMaybe<Scalars["warm_home_discount_application_status"]["input"]>
  _in?: InputMaybe<
    Array<Scalars["warm_home_discount_application_status"]["input"]>
  >
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["warm_home_discount_application_status"]["input"]>
  _lte?: InputMaybe<Scalars["warm_home_discount_application_status"]["input"]>
  _neq?: InputMaybe<Scalars["warm_home_discount_application_status"]["input"]>
  _nin?: InputMaybe<
    Array<Scalars["warm_home_discount_application_status"]["input"]>
  >
}

/** columns and relationships of "warm_home_discount_application_status_history" */
export type Warm_Home_Discount_Application_Status_History = {
  __typename?: "warm_home_discount_application_status_history"
  created_at: Scalars["timestamp"]["output"]
  id: Scalars["bigint"]["output"]
  status: Scalars["warm_home_discount_application_status"]["output"]
  warm_home_discount_application_id: Scalars["bigint"]["output"]
}

/** aggregated selection of "warm_home_discount_application_status_history" */
export type Warm_Home_Discount_Application_Status_History_Aggregate = {
  __typename?: "warm_home_discount_application_status_history_aggregate"
  aggregate?: Maybe<Warm_Home_Discount_Application_Status_History_Aggregate_Fields>
  nodes: Array<Warm_Home_Discount_Application_Status_History>
}

/** aggregate fields of "warm_home_discount_application_status_history" */
export type Warm_Home_Discount_Application_Status_History_Aggregate_Fields = {
  __typename?: "warm_home_discount_application_status_history_aggregate_fields"
  avg?: Maybe<Warm_Home_Discount_Application_Status_History_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Warm_Home_Discount_Application_Status_History_Max_Fields>
  min?: Maybe<Warm_Home_Discount_Application_Status_History_Min_Fields>
  stddev?: Maybe<Warm_Home_Discount_Application_Status_History_Stddev_Fields>
  stddev_pop?: Maybe<Warm_Home_Discount_Application_Status_History_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Warm_Home_Discount_Application_Status_History_Stddev_Samp_Fields>
  sum?: Maybe<Warm_Home_Discount_Application_Status_History_Sum_Fields>
  var_pop?: Maybe<Warm_Home_Discount_Application_Status_History_Var_Pop_Fields>
  var_samp?: Maybe<Warm_Home_Discount_Application_Status_History_Var_Samp_Fields>
  variance?: Maybe<Warm_Home_Discount_Application_Status_History_Variance_Fields>
}

/** aggregate fields of "warm_home_discount_application_status_history" */
export type Warm_Home_Discount_Application_Status_History_Aggregate_FieldsCountArgs =
  {
    columns?: InputMaybe<
      Array<Warm_Home_Discount_Application_Status_History_Select_Column>
    >
    distinct?: InputMaybe<Scalars["Boolean"]["input"]>
  }

/** aggregate avg on columns */
export type Warm_Home_Discount_Application_Status_History_Avg_Fields = {
  __typename?: "warm_home_discount_application_status_history_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  warm_home_discount_application_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "warm_home_discount_application_status_history". All fields are combined with a logical 'AND'. */
export type Warm_Home_Discount_Application_Status_History_Bool_Exp = {
  _and?: InputMaybe<
    Array<Warm_Home_Discount_Application_Status_History_Bool_Exp>
  >
  _not?: InputMaybe<Warm_Home_Discount_Application_Status_History_Bool_Exp>
  _or?: InputMaybe<
    Array<Warm_Home_Discount_Application_Status_History_Bool_Exp>
  >
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  status?: InputMaybe<Warm_Home_Discount_Application_Status_Comparison_Exp>
  warm_home_discount_application_id?: InputMaybe<Bigint_Comparison_Exp>
}

/** unique or primary key constraints on table "warm_home_discount_application_status_history" */
export enum Warm_Home_Discount_Application_Status_History_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarmHomeDiscountApplicationStatusLogsPkey = "warm_home_discount_application_status_logs_pkey",
}

/** input type for incrementing numeric columns in table "warm_home_discount_application_status_history" */
export type Warm_Home_Discount_Application_Status_History_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  warm_home_discount_application_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "warm_home_discount_application_status_history" */
export type Warm_Home_Discount_Application_Status_History_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["warm_home_discount_application_status"]["input"]>
  warm_home_discount_application_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate max on columns */
export type Warm_Home_Discount_Application_Status_History_Max_Fields = {
  __typename?: "warm_home_discount_application_status_history_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["warm_home_discount_application_status"]["output"]>
  warm_home_discount_application_id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregate min on columns */
export type Warm_Home_Discount_Application_Status_History_Min_Fields = {
  __typename?: "warm_home_discount_application_status_history_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  status?: Maybe<Scalars["warm_home_discount_application_status"]["output"]>
  warm_home_discount_application_id?: Maybe<Scalars["bigint"]["output"]>
}

/** response of any mutation on the table "warm_home_discount_application_status_history" */
export type Warm_Home_Discount_Application_Status_History_Mutation_Response = {
  __typename?: "warm_home_discount_application_status_history_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Warm_Home_Discount_Application_Status_History>
}

/** on_conflict condition type for table "warm_home_discount_application_status_history" */
export type Warm_Home_Discount_Application_Status_History_On_Conflict = {
  constraint: Warm_Home_Discount_Application_Status_History_Constraint
  update_columns?: Array<Warm_Home_Discount_Application_Status_History_Update_Column>
  where?: InputMaybe<Warm_Home_Discount_Application_Status_History_Bool_Exp>
}

/** Ordering options when selecting data from "warm_home_discount_application_status_history". */
export type Warm_Home_Discount_Application_Status_History_Order_By = {
  created_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  status?: InputMaybe<Order_By>
  warm_home_discount_application_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: warm_home_discount_application_status_history */
export type Warm_Home_Discount_Application_Status_History_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "warm_home_discount_application_status_history" */
export enum Warm_Home_Discount_Application_Status_History_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  WarmHomeDiscountApplicationId = "warm_home_discount_application_id",
}

/** input type for updating data in table "warm_home_discount_application_status_history" */
export type Warm_Home_Discount_Application_Status_History_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["warm_home_discount_application_status"]["input"]>
  warm_home_discount_application_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate stddev on columns */
export type Warm_Home_Discount_Application_Status_History_Stddev_Fields = {
  __typename?: "warm_home_discount_application_status_history_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  warm_home_discount_application_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Warm_Home_Discount_Application_Status_History_Stddev_Pop_Fields = {
  __typename?: "warm_home_discount_application_status_history_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  warm_home_discount_application_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Warm_Home_Discount_Application_Status_History_Stddev_Samp_Fields = {
  __typename?: "warm_home_discount_application_status_history_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  warm_home_discount_application_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "warm_home_discount_application_status_history" */
export type Warm_Home_Discount_Application_Status_History_Stream_Cursor_Input =
  {
    /** Stream column input with initial value */
    initial_value: Warm_Home_Discount_Application_Status_History_Stream_Cursor_Value_Input
    /** cursor ordering */
    ordering?: InputMaybe<Cursor_Ordering>
  }

/** Initial value of the column from where the streaming should start */
export type Warm_Home_Discount_Application_Status_History_Stream_Cursor_Value_Input =
  {
    created_at?: InputMaybe<Scalars["timestamp"]["input"]>
    id?: InputMaybe<Scalars["bigint"]["input"]>
    status?: InputMaybe<
      Scalars["warm_home_discount_application_status"]["input"]
    >
    warm_home_discount_application_id?: InputMaybe<Scalars["bigint"]["input"]>
  }

/** aggregate sum on columns */
export type Warm_Home_Discount_Application_Status_History_Sum_Fields = {
  __typename?: "warm_home_discount_application_status_history_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  warm_home_discount_application_id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "warm_home_discount_application_status_history" */
export enum Warm_Home_Discount_Application_Status_History_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  Status = "status",
  /** column name */
  WarmHomeDiscountApplicationId = "warm_home_discount_application_id",
}

export type Warm_Home_Discount_Application_Status_History_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Warm_Home_Discount_Application_Status_History_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Warm_Home_Discount_Application_Status_History_Set_Input>
  /** filter the rows which have to be updated */
  where: Warm_Home_Discount_Application_Status_History_Bool_Exp
}

/** aggregate var_pop on columns */
export type Warm_Home_Discount_Application_Status_History_Var_Pop_Fields = {
  __typename?: "warm_home_discount_application_status_history_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  warm_home_discount_application_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Warm_Home_Discount_Application_Status_History_Var_Samp_Fields = {
  __typename?: "warm_home_discount_application_status_history_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  warm_home_discount_application_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Warm_Home_Discount_Application_Status_History_Variance_Fields = {
  __typename?: "warm_home_discount_application_status_history_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  warm_home_discount_application_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev on columns */
export type Warm_Home_Discount_Application_Stddev_Fields = {
  __typename?: "warm_home_discount_application_stddev_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  primary_criteria_id?: Maybe<Scalars["Float"]["output"]>
  secondary_criteria_id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Warm_Home_Discount_Application_Stddev_Pop_Fields = {
  __typename?: "warm_home_discount_application_stddev_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  primary_criteria_id?: Maybe<Scalars["Float"]["output"]>
  secondary_criteria_id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Warm_Home_Discount_Application_Stddev_Samp_Fields = {
  __typename?: "warm_home_discount_application_stddev_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  primary_criteria_id?: Maybe<Scalars["Float"]["output"]>
  secondary_criteria_id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "warm_home_discount_application" */
export type Warm_Home_Discount_Application_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Warm_Home_Discount_Application_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Warm_Home_Discount_Application_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars["String"]["input"]>
  application_year?: InputMaybe<Scalars["String"]["input"]>
  assigned_agent?: InputMaybe<Scalars["String"]["input"]>
  billing_account_id?: InputMaybe<Scalars["bigint"]["input"]>
  billing_account_number?: InputMaybe<Scalars["String"]["input"]>
  communication_preference?: InputMaybe<Scalars["String"]["input"]>
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  date_of_birth?: InputMaybe<Scalars["date"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  first_name?: InputMaybe<Scalars["String"]["input"]>
  gsp_group?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  last_name?: InputMaybe<Scalars["String"]["input"]>
  phone_number?: InputMaybe<Scalars["String"]["input"]>
  postcode?: InputMaybe<Scalars["String"]["input"]>
  primary_criteria_id?: InputMaybe<Scalars["bigint"]["input"]>
  secondary_criteria_id?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<Scalars["warm_home_discount_application_status"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
  user_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate sum on columns */
export type Warm_Home_Discount_Application_Sum_Fields = {
  __typename?: "warm_home_discount_application_sum_fields"
  billing_account_id?: Maybe<Scalars["bigint"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  primary_criteria_id?: Maybe<Scalars["bigint"]["output"]>
  secondary_criteria_id?: Maybe<Scalars["bigint"]["output"]>
  user_id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "warm_home_discount_application" */
export enum Warm_Home_Discount_Application_Update_Column {
  /** column name */
  Address = "address",
  /** column name */
  ApplicationYear = "application_year",
  /** column name */
  AssignedAgent = "assigned_agent",
  /** column name */
  BillingAccountId = "billing_account_id",
  /** column name */
  BillingAccountNumber = "billing_account_number",
  /** column name */
  CommunicationPreference = "communication_preference",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DateOfBirth = "date_of_birth",
  /** column name */
  Email = "email",
  /** column name */
  FirstName = "first_name",
  /** column name */
  GspGroup = "gsp_group",
  /** column name */
  Id = "id",
  /** column name */
  LastName = "last_name",
  /** column name */
  PhoneNumber = "phone_number",
  /** column name */
  Postcode = "postcode",
  /** column name */
  PrimaryCriteriaId = "primary_criteria_id",
  /** column name */
  SecondaryCriteriaId = "secondary_criteria_id",
  /** column name */
  Status = "status",
  /** column name */
  UpdatedAt = "updated_at",
  /** column name */
  UserId = "user_id",
}

export type Warm_Home_Discount_Application_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Warm_Home_Discount_Application_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Warm_Home_Discount_Application_Set_Input>
  /** filter the rows which have to be updated */
  where: Warm_Home_Discount_Application_Bool_Exp
}

/** aggregate var_pop on columns */
export type Warm_Home_Discount_Application_Var_Pop_Fields = {
  __typename?: "warm_home_discount_application_var_pop_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  primary_criteria_id?: Maybe<Scalars["Float"]["output"]>
  secondary_criteria_id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Warm_Home_Discount_Application_Var_Samp_Fields = {
  __typename?: "warm_home_discount_application_var_samp_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  primary_criteria_id?: Maybe<Scalars["Float"]["output"]>
  secondary_criteria_id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Warm_Home_Discount_Application_Variance_Fields = {
  __typename?: "warm_home_discount_application_variance_fields"
  billing_account_id?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Float"]["output"]>
  primary_criteria_id?: Maybe<Scalars["Float"]["output"]>
  secondary_criteria_id?: Maybe<Scalars["Float"]["output"]>
  user_id?: Maybe<Scalars["Float"]["output"]>
}

/** columns and relationships of "warm_home_discount_criteria" */
export type Warm_Home_Discount_Criteria = {
  __typename?: "warm_home_discount_criteria"
  created_at: Scalars["timestamp"]["output"]
  id: Scalars["bigint"]["output"]
  is_enabled?: Maybe<Scalars["Boolean"]["output"]>
  ordinal?: Maybe<Scalars["numeric"]["output"]>
  text: Scalars["String"]["output"]
  type: Scalars["warm_home_discount_criteria_type"]["output"]
  updated_at: Scalars["timestamp"]["output"]
}

/** aggregated selection of "warm_home_discount_criteria" */
export type Warm_Home_Discount_Criteria_Aggregate = {
  __typename?: "warm_home_discount_criteria_aggregate"
  aggregate?: Maybe<Warm_Home_Discount_Criteria_Aggregate_Fields>
  nodes: Array<Warm_Home_Discount_Criteria>
}

/** aggregate fields of "warm_home_discount_criteria" */
export type Warm_Home_Discount_Criteria_Aggregate_Fields = {
  __typename?: "warm_home_discount_criteria_aggregate_fields"
  avg?: Maybe<Warm_Home_Discount_Criteria_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Warm_Home_Discount_Criteria_Max_Fields>
  min?: Maybe<Warm_Home_Discount_Criteria_Min_Fields>
  stddev?: Maybe<Warm_Home_Discount_Criteria_Stddev_Fields>
  stddev_pop?: Maybe<Warm_Home_Discount_Criteria_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Warm_Home_Discount_Criteria_Stddev_Samp_Fields>
  sum?: Maybe<Warm_Home_Discount_Criteria_Sum_Fields>
  var_pop?: Maybe<Warm_Home_Discount_Criteria_Var_Pop_Fields>
  var_samp?: Maybe<Warm_Home_Discount_Criteria_Var_Samp_Fields>
  variance?: Maybe<Warm_Home_Discount_Criteria_Variance_Fields>
}

/** aggregate fields of "warm_home_discount_criteria" */
export type Warm_Home_Discount_Criteria_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Warm_Home_Discount_Criteria_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Warm_Home_Discount_Criteria_Avg_Fields = {
  __typename?: "warm_home_discount_criteria_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ordinal?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "warm_home_discount_criteria". All fields are combined with a logical 'AND'. */
export type Warm_Home_Discount_Criteria_Bool_Exp = {
  _and?: InputMaybe<Array<Warm_Home_Discount_Criteria_Bool_Exp>>
  _not?: InputMaybe<Warm_Home_Discount_Criteria_Bool_Exp>
  _or?: InputMaybe<Array<Warm_Home_Discount_Criteria_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  is_enabled?: InputMaybe<Boolean_Comparison_Exp>
  ordinal?: InputMaybe<Numeric_Comparison_Exp>
  text?: InputMaybe<String_Comparison_Exp>
  type?: InputMaybe<Warm_Home_Discount_Criteria_Type_Comparison_Exp>
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>
}

/** unique or primary key constraints on table "warm_home_discount_criteria" */
export enum Warm_Home_Discount_Criteria_Constraint {
  /** unique or primary key constraint on columns "type", "text" */
  CriteriaUnique = "criteria_unique",
  /** unique or primary key constraint on columns "id" */
  WarmHomeDiscountPrimaryCriteriaPkey = "warm_home_discount_primary_criteria_pkey",
}

/** input type for incrementing numeric columns in table "warm_home_discount_criteria" */
export type Warm_Home_Discount_Criteria_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  ordinal?: InputMaybe<Scalars["numeric"]["input"]>
}

/** input type for inserting data into table "warm_home_discount_criteria" */
export type Warm_Home_Discount_Criteria_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  is_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  ordinal?: InputMaybe<Scalars["numeric"]["input"]>
  text?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["warm_home_discount_criteria_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate max on columns */
export type Warm_Home_Discount_Criteria_Max_Fields = {
  __typename?: "warm_home_discount_criteria_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  ordinal?: Maybe<Scalars["numeric"]["output"]>
  text?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["warm_home_discount_criteria_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** aggregate min on columns */
export type Warm_Home_Discount_Criteria_Min_Fields = {
  __typename?: "warm_home_discount_criteria_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  ordinal?: Maybe<Scalars["numeric"]["output"]>
  text?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["warm_home_discount_criteria_type"]["output"]>
  updated_at?: Maybe<Scalars["timestamp"]["output"]>
}

/** response of any mutation on the table "warm_home_discount_criteria" */
export type Warm_Home_Discount_Criteria_Mutation_Response = {
  __typename?: "warm_home_discount_criteria_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Warm_Home_Discount_Criteria>
}

/** on_conflict condition type for table "warm_home_discount_criteria" */
export type Warm_Home_Discount_Criteria_On_Conflict = {
  constraint: Warm_Home_Discount_Criteria_Constraint
  update_columns?: Array<Warm_Home_Discount_Criteria_Update_Column>
  where?: InputMaybe<Warm_Home_Discount_Criteria_Bool_Exp>
}

/** Ordering options when selecting data from "warm_home_discount_criteria". */
export type Warm_Home_Discount_Criteria_Order_By = {
  created_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  is_enabled?: InputMaybe<Order_By>
  ordinal?: InputMaybe<Order_By>
  text?: InputMaybe<Order_By>
  type?: InputMaybe<Order_By>
  updated_at?: InputMaybe<Order_By>
}

/** primary key columns input for table: warm_home_discount_criteria */
export type Warm_Home_Discount_Criteria_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** columns and relationships of "warm_home_discount_criteria_rel" */
export type Warm_Home_Discount_Criteria_Rel = {
  __typename?: "warm_home_discount_criteria_rel"
  created_at: Scalars["timestamp"]["output"]
  id: Scalars["bigint"]["output"]
  ordinal: Scalars["numeric"]["output"]
  primary_criteria_id: Scalars["bigint"]["output"]
  secondary_criteria_id: Scalars["bigint"]["output"]
}

/** aggregated selection of "warm_home_discount_criteria_rel" */
export type Warm_Home_Discount_Criteria_Rel_Aggregate = {
  __typename?: "warm_home_discount_criteria_rel_aggregate"
  aggregate?: Maybe<Warm_Home_Discount_Criteria_Rel_Aggregate_Fields>
  nodes: Array<Warm_Home_Discount_Criteria_Rel>
}

/** aggregate fields of "warm_home_discount_criteria_rel" */
export type Warm_Home_Discount_Criteria_Rel_Aggregate_Fields = {
  __typename?: "warm_home_discount_criteria_rel_aggregate_fields"
  avg?: Maybe<Warm_Home_Discount_Criteria_Rel_Avg_Fields>
  count: Scalars["Int"]["output"]
  max?: Maybe<Warm_Home_Discount_Criteria_Rel_Max_Fields>
  min?: Maybe<Warm_Home_Discount_Criteria_Rel_Min_Fields>
  stddev?: Maybe<Warm_Home_Discount_Criteria_Rel_Stddev_Fields>
  stddev_pop?: Maybe<Warm_Home_Discount_Criteria_Rel_Stddev_Pop_Fields>
  stddev_samp?: Maybe<Warm_Home_Discount_Criteria_Rel_Stddev_Samp_Fields>
  sum?: Maybe<Warm_Home_Discount_Criteria_Rel_Sum_Fields>
  var_pop?: Maybe<Warm_Home_Discount_Criteria_Rel_Var_Pop_Fields>
  var_samp?: Maybe<Warm_Home_Discount_Criteria_Rel_Var_Samp_Fields>
  variance?: Maybe<Warm_Home_Discount_Criteria_Rel_Variance_Fields>
}

/** aggregate fields of "warm_home_discount_criteria_rel" */
export type Warm_Home_Discount_Criteria_Rel_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Warm_Home_Discount_Criteria_Rel_Select_Column>>
  distinct?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** aggregate avg on columns */
export type Warm_Home_Discount_Criteria_Rel_Avg_Fields = {
  __typename?: "warm_home_discount_criteria_rel_avg_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ordinal?: Maybe<Scalars["Float"]["output"]>
  primary_criteria_id?: Maybe<Scalars["Float"]["output"]>
  secondary_criteria_id?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to filter rows from the table "warm_home_discount_criteria_rel". All fields are combined with a logical 'AND'. */
export type Warm_Home_Discount_Criteria_Rel_Bool_Exp = {
  _and?: InputMaybe<Array<Warm_Home_Discount_Criteria_Rel_Bool_Exp>>
  _not?: InputMaybe<Warm_Home_Discount_Criteria_Rel_Bool_Exp>
  _or?: InputMaybe<Array<Warm_Home_Discount_Criteria_Rel_Bool_Exp>>
  created_at?: InputMaybe<Timestamp_Comparison_Exp>
  id?: InputMaybe<Bigint_Comparison_Exp>
  ordinal?: InputMaybe<Numeric_Comparison_Exp>
  primary_criteria_id?: InputMaybe<Bigint_Comparison_Exp>
  secondary_criteria_id?: InputMaybe<Bigint_Comparison_Exp>
}

/** unique or primary key constraints on table "warm_home_discount_criteria_rel" */
export enum Warm_Home_Discount_Criteria_Rel_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarmHomeDiscountCriteriaRelPkey = "warm_home_discount_criteria_rel_pkey",
}

/** input type for incrementing numeric columns in table "warm_home_discount_criteria_rel" */
export type Warm_Home_Discount_Criteria_Rel_Inc_Input = {
  id?: InputMaybe<Scalars["bigint"]["input"]>
  ordinal?: InputMaybe<Scalars["numeric"]["input"]>
  primary_criteria_id?: InputMaybe<Scalars["bigint"]["input"]>
  secondary_criteria_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** input type for inserting data into table "warm_home_discount_criteria_rel" */
export type Warm_Home_Discount_Criteria_Rel_Insert_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  ordinal?: InputMaybe<Scalars["numeric"]["input"]>
  primary_criteria_id?: InputMaybe<Scalars["bigint"]["input"]>
  secondary_criteria_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate max on columns */
export type Warm_Home_Discount_Criteria_Rel_Max_Fields = {
  __typename?: "warm_home_discount_criteria_rel_max_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  ordinal?: Maybe<Scalars["numeric"]["output"]>
  primary_criteria_id?: Maybe<Scalars["bigint"]["output"]>
  secondary_criteria_id?: Maybe<Scalars["bigint"]["output"]>
}

/** aggregate min on columns */
export type Warm_Home_Discount_Criteria_Rel_Min_Fields = {
  __typename?: "warm_home_discount_criteria_rel_min_fields"
  created_at?: Maybe<Scalars["timestamp"]["output"]>
  id?: Maybe<Scalars["bigint"]["output"]>
  ordinal?: Maybe<Scalars["numeric"]["output"]>
  primary_criteria_id?: Maybe<Scalars["bigint"]["output"]>
  secondary_criteria_id?: Maybe<Scalars["bigint"]["output"]>
}

/** response of any mutation on the table "warm_home_discount_criteria_rel" */
export type Warm_Home_Discount_Criteria_Rel_Mutation_Response = {
  __typename?: "warm_home_discount_criteria_rel_mutation_response"
  /** number of rows affected by the mutation */
  affected_rows: Scalars["Int"]["output"]
  /** data from the rows affected by the mutation */
  returning: Array<Warm_Home_Discount_Criteria_Rel>
}

/** on_conflict condition type for table "warm_home_discount_criteria_rel" */
export type Warm_Home_Discount_Criteria_Rel_On_Conflict = {
  constraint: Warm_Home_Discount_Criteria_Rel_Constraint
  update_columns?: Array<Warm_Home_Discount_Criteria_Rel_Update_Column>
  where?: InputMaybe<Warm_Home_Discount_Criteria_Rel_Bool_Exp>
}

/** Ordering options when selecting data from "warm_home_discount_criteria_rel". */
export type Warm_Home_Discount_Criteria_Rel_Order_By = {
  created_at?: InputMaybe<Order_By>
  id?: InputMaybe<Order_By>
  ordinal?: InputMaybe<Order_By>
  primary_criteria_id?: InputMaybe<Order_By>
  secondary_criteria_id?: InputMaybe<Order_By>
}

/** primary key columns input for table: warm_home_discount_criteria_rel */
export type Warm_Home_Discount_Criteria_Rel_Pk_Columns_Input = {
  id: Scalars["bigint"]["input"]
}

/** select columns of table "warm_home_discount_criteria_rel" */
export enum Warm_Home_Discount_Criteria_Rel_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  Ordinal = "ordinal",
  /** column name */
  PrimaryCriteriaId = "primary_criteria_id",
  /** column name */
  SecondaryCriteriaId = "secondary_criteria_id",
}

/** input type for updating data in table "warm_home_discount_criteria_rel" */
export type Warm_Home_Discount_Criteria_Rel_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  ordinal?: InputMaybe<Scalars["numeric"]["input"]>
  primary_criteria_id?: InputMaybe<Scalars["bigint"]["input"]>
  secondary_criteria_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate stddev on columns */
export type Warm_Home_Discount_Criteria_Rel_Stddev_Fields = {
  __typename?: "warm_home_discount_criteria_rel_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ordinal?: Maybe<Scalars["Float"]["output"]>
  primary_criteria_id?: Maybe<Scalars["Float"]["output"]>
  secondary_criteria_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Warm_Home_Discount_Criteria_Rel_Stddev_Pop_Fields = {
  __typename?: "warm_home_discount_criteria_rel_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ordinal?: Maybe<Scalars["Float"]["output"]>
  primary_criteria_id?: Maybe<Scalars["Float"]["output"]>
  secondary_criteria_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Warm_Home_Discount_Criteria_Rel_Stddev_Samp_Fields = {
  __typename?: "warm_home_discount_criteria_rel_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ordinal?: Maybe<Scalars["Float"]["output"]>
  primary_criteria_id?: Maybe<Scalars["Float"]["output"]>
  secondary_criteria_id?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "warm_home_discount_criteria_rel" */
export type Warm_Home_Discount_Criteria_Rel_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Warm_Home_Discount_Criteria_Rel_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Warm_Home_Discount_Criteria_Rel_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  ordinal?: InputMaybe<Scalars["numeric"]["input"]>
  primary_criteria_id?: InputMaybe<Scalars["bigint"]["input"]>
  secondary_criteria_id?: InputMaybe<Scalars["bigint"]["input"]>
}

/** aggregate sum on columns */
export type Warm_Home_Discount_Criteria_Rel_Sum_Fields = {
  __typename?: "warm_home_discount_criteria_rel_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  ordinal?: Maybe<Scalars["numeric"]["output"]>
  primary_criteria_id?: Maybe<Scalars["bigint"]["output"]>
  secondary_criteria_id?: Maybe<Scalars["bigint"]["output"]>
}

/** update columns of table "warm_home_discount_criteria_rel" */
export enum Warm_Home_Discount_Criteria_Rel_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  Ordinal = "ordinal",
  /** column name */
  PrimaryCriteriaId = "primary_criteria_id",
  /** column name */
  SecondaryCriteriaId = "secondary_criteria_id",
}

export type Warm_Home_Discount_Criteria_Rel_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Warm_Home_Discount_Criteria_Rel_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Warm_Home_Discount_Criteria_Rel_Set_Input>
  /** filter the rows which have to be updated */
  where: Warm_Home_Discount_Criteria_Rel_Bool_Exp
}

/** aggregate var_pop on columns */
export type Warm_Home_Discount_Criteria_Rel_Var_Pop_Fields = {
  __typename?: "warm_home_discount_criteria_rel_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ordinal?: Maybe<Scalars["Float"]["output"]>
  primary_criteria_id?: Maybe<Scalars["Float"]["output"]>
  secondary_criteria_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Warm_Home_Discount_Criteria_Rel_Var_Samp_Fields = {
  __typename?: "warm_home_discount_criteria_rel_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ordinal?: Maybe<Scalars["Float"]["output"]>
  primary_criteria_id?: Maybe<Scalars["Float"]["output"]>
  secondary_criteria_id?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Warm_Home_Discount_Criteria_Rel_Variance_Fields = {
  __typename?: "warm_home_discount_criteria_rel_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ordinal?: Maybe<Scalars["Float"]["output"]>
  primary_criteria_id?: Maybe<Scalars["Float"]["output"]>
  secondary_criteria_id?: Maybe<Scalars["Float"]["output"]>
}

/** select columns of table "warm_home_discount_criteria" */
export enum Warm_Home_Discount_Criteria_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  IsEnabled = "is_enabled",
  /** column name */
  Ordinal = "ordinal",
  /** column name */
  Text = "text",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

/** input type for updating data in table "warm_home_discount_criteria" */
export type Warm_Home_Discount_Criteria_Set_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  is_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  ordinal?: InputMaybe<Scalars["numeric"]["input"]>
  text?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["warm_home_discount_criteria_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate stddev on columns */
export type Warm_Home_Discount_Criteria_Stddev_Fields = {
  __typename?: "warm_home_discount_criteria_stddev_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ordinal?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_pop on columns */
export type Warm_Home_Discount_Criteria_Stddev_Pop_Fields = {
  __typename?: "warm_home_discount_criteria_stddev_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ordinal?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate stddev_samp on columns */
export type Warm_Home_Discount_Criteria_Stddev_Samp_Fields = {
  __typename?: "warm_home_discount_criteria_stddev_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ordinal?: Maybe<Scalars["Float"]["output"]>
}

/** Streaming cursor of the table "warm_home_discount_criteria" */
export type Warm_Home_Discount_Criteria_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Warm_Home_Discount_Criteria_Stream_Cursor_Value_Input
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>
}

/** Initial value of the column from where the streaming should start */
export type Warm_Home_Discount_Criteria_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars["timestamp"]["input"]>
  id?: InputMaybe<Scalars["bigint"]["input"]>
  is_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  ordinal?: InputMaybe<Scalars["numeric"]["input"]>
  text?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["warm_home_discount_criteria_type"]["input"]>
  updated_at?: InputMaybe<Scalars["timestamp"]["input"]>
}

/** aggregate sum on columns */
export type Warm_Home_Discount_Criteria_Sum_Fields = {
  __typename?: "warm_home_discount_criteria_sum_fields"
  id?: Maybe<Scalars["bigint"]["output"]>
  ordinal?: Maybe<Scalars["numeric"]["output"]>
}

/** Boolean expression to compare columns of type "warm_home_discount_criteria_type". All fields are combined with logical 'AND'. */
export type Warm_Home_Discount_Criteria_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["warm_home_discount_criteria_type"]["input"]>
  _gt?: InputMaybe<Scalars["warm_home_discount_criteria_type"]["input"]>
  _gte?: InputMaybe<Scalars["warm_home_discount_criteria_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["warm_home_discount_criteria_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["warm_home_discount_criteria_type"]["input"]>
  _lte?: InputMaybe<Scalars["warm_home_discount_criteria_type"]["input"]>
  _neq?: InputMaybe<Scalars["warm_home_discount_criteria_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["warm_home_discount_criteria_type"]["input"]>>
}

/** update columns of table "warm_home_discount_criteria" */
export enum Warm_Home_Discount_Criteria_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  IsEnabled = "is_enabled",
  /** column name */
  Ordinal = "ordinal",
  /** column name */
  Text = "text",
  /** column name */
  Type = "type",
  /** column name */
  UpdatedAt = "updated_at",
}

export type Warm_Home_Discount_Criteria_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Warm_Home_Discount_Criteria_Inc_Input>
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Warm_Home_Discount_Criteria_Set_Input>
  /** filter the rows which have to be updated */
  where: Warm_Home_Discount_Criteria_Bool_Exp
}

/** aggregate var_pop on columns */
export type Warm_Home_Discount_Criteria_Var_Pop_Fields = {
  __typename?: "warm_home_discount_criteria_var_pop_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ordinal?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate var_samp on columns */
export type Warm_Home_Discount_Criteria_Var_Samp_Fields = {
  __typename?: "warm_home_discount_criteria_var_samp_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ordinal?: Maybe<Scalars["Float"]["output"]>
}

/** aggregate variance on columns */
export type Warm_Home_Discount_Criteria_Variance_Fields = {
  __typename?: "warm_home_discount_criteria_variance_fields"
  id?: Maybe<Scalars["Float"]["output"]>
  ordinal?: Maybe<Scalars["Float"]["output"]>
}

/** Boolean expression to compare columns of type "warrant_communication_delivery_status". All fields are combined with logical 'AND'. */
export type Warrant_Communication_Delivery_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["warrant_communication_delivery_status"]["input"]>
  _gt?: InputMaybe<Scalars["warrant_communication_delivery_status"]["input"]>
  _gte?: InputMaybe<Scalars["warrant_communication_delivery_status"]["input"]>
  _in?: InputMaybe<
    Array<Scalars["warrant_communication_delivery_status"]["input"]>
  >
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["warrant_communication_delivery_status"]["input"]>
  _lte?: InputMaybe<Scalars["warrant_communication_delivery_status"]["input"]>
  _neq?: InputMaybe<Scalars["warrant_communication_delivery_status"]["input"]>
  _nin?: InputMaybe<
    Array<Scalars["warrant_communication_delivery_status"]["input"]>
  >
}

/** Boolean expression to compare columns of type "warrant_communication_group_status". All fields are combined with logical 'AND'. */
export type Warrant_Communication_Group_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["warrant_communication_group_status"]["input"]>
  _gt?: InputMaybe<Scalars["warrant_communication_group_status"]["input"]>
  _gte?: InputMaybe<Scalars["warrant_communication_group_status"]["input"]>
  _in?: InputMaybe<
    Array<Scalars["warrant_communication_group_status"]["input"]>
  >
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["warrant_communication_group_status"]["input"]>
  _lte?: InputMaybe<Scalars["warrant_communication_group_status"]["input"]>
  _neq?: InputMaybe<Scalars["warrant_communication_group_status"]["input"]>
  _nin?: InputMaybe<
    Array<Scalars["warrant_communication_group_status"]["input"]>
  >
}

/** Boolean expression to compare columns of type "warrant_communication_type". All fields are combined with logical 'AND'. */
export type Warrant_Communication_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["warrant_communication_type"]["input"]>
  _gt?: InputMaybe<Scalars["warrant_communication_type"]["input"]>
  _gte?: InputMaybe<Scalars["warrant_communication_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["warrant_communication_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["warrant_communication_type"]["input"]>
  _lte?: InputMaybe<Scalars["warrant_communication_type"]["input"]>
  _neq?: InputMaybe<Scalars["warrant_communication_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["warrant_communication_type"]["input"]>>
}

/** Boolean expression to compare columns of type "warrants_account_history_status". All fields are combined with logical 'AND'. */
export type Warrants_Account_History_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["warrants_account_history_status"]["input"]>
  _gt?: InputMaybe<Scalars["warrants_account_history_status"]["input"]>
  _gte?: InputMaybe<Scalars["warrants_account_history_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["warrants_account_history_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["warrants_account_history_status"]["input"]>
  _lte?: InputMaybe<Scalars["warrants_account_history_status"]["input"]>
  _neq?: InputMaybe<Scalars["warrants_account_history_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["warrants_account_history_status"]["input"]>>
}

/** Boolean expression to compare columns of type "warrants_account_state". All fields are combined with logical 'AND'. */
export type Warrants_Account_State_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["warrants_account_state"]["input"]>
  _gt?: InputMaybe<Scalars["warrants_account_state"]["input"]>
  _gte?: InputMaybe<Scalars["warrants_account_state"]["input"]>
  _in?: InputMaybe<Array<Scalars["warrants_account_state"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["warrants_account_state"]["input"]>
  _lte?: InputMaybe<Scalars["warrants_account_state"]["input"]>
  _neq?: InputMaybe<Scalars["warrants_account_state"]["input"]>
  _nin?: InputMaybe<Array<Scalars["warrants_account_state"]["input"]>>
}

/** Boolean expression to compare columns of type "warrants_dca_tickets_status". All fields are combined with logical 'AND'. */
export type Warrants_Dca_Tickets_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["warrants_dca_tickets_status"]["input"]>
  _gt?: InputMaybe<Scalars["warrants_dca_tickets_status"]["input"]>
  _gte?: InputMaybe<Scalars["warrants_dca_tickets_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["warrants_dca_tickets_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["warrants_dca_tickets_status"]["input"]>
  _lte?: InputMaybe<Scalars["warrants_dca_tickets_status"]["input"]>
  _neq?: InputMaybe<Scalars["warrants_dca_tickets_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["warrants_dca_tickets_status"]["input"]>>
}

/** Boolean expression to compare columns of type "warrants_dca_type". All fields are combined with logical 'AND'. */
export type Warrants_Dca_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["warrants_dca_type"]["input"]>
  _gt?: InputMaybe<Scalars["warrants_dca_type"]["input"]>
  _gte?: InputMaybe<Scalars["warrants_dca_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["warrants_dca_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["warrants_dca_type"]["input"]>
  _lte?: InputMaybe<Scalars["warrants_dca_type"]["input"]>
  _neq?: InputMaybe<Scalars["warrants_dca_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["warrants_dca_type"]["input"]>>
}

/** Boolean expression to compare columns of type "warrants_files_account_status". All fields are combined with logical 'AND'. */
export type Warrants_Files_Account_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["warrants_files_account_status"]["input"]>
  _gt?: InputMaybe<Scalars["warrants_files_account_status"]["input"]>
  _gte?: InputMaybe<Scalars["warrants_files_account_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["warrants_files_account_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["warrants_files_account_status"]["input"]>
  _lte?: InputMaybe<Scalars["warrants_files_account_status"]["input"]>
  _neq?: InputMaybe<Scalars["warrants_files_account_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["warrants_files_account_status"]["input"]>>
}

/** Boolean expression to compare columns of type "warrants_files_dca_type". All fields are combined with logical 'AND'. */
export type Warrants_Files_Dca_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["warrants_files_dca_type"]["input"]>
  _gt?: InputMaybe<Scalars["warrants_files_dca_type"]["input"]>
  _gte?: InputMaybe<Scalars["warrants_files_dca_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["warrants_files_dca_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["warrants_files_dca_type"]["input"]>
  _lte?: InputMaybe<Scalars["warrants_files_dca_type"]["input"]>
  _neq?: InputMaybe<Scalars["warrants_files_dca_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["warrants_files_dca_type"]["input"]>>
}

/** Boolean expression to compare columns of type "warrants_files_job_status". All fields are combined with logical 'AND'. */
export type Warrants_Files_Job_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["warrants_files_job_status"]["input"]>
  _gt?: InputMaybe<Scalars["warrants_files_job_status"]["input"]>
  _gte?: InputMaybe<Scalars["warrants_files_job_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["warrants_files_job_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["warrants_files_job_status"]["input"]>
  _lte?: InputMaybe<Scalars["warrants_files_job_status"]["input"]>
  _neq?: InputMaybe<Scalars["warrants_files_job_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["warrants_files_job_status"]["input"]>>
}

/** Boolean expression to compare columns of type "warrants_files_type". All fields are combined with logical 'AND'. */
export type Warrants_Files_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["warrants_files_type"]["input"]>
  _gt?: InputMaybe<Scalars["warrants_files_type"]["input"]>
  _gte?: InputMaybe<Scalars["warrants_files_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["warrants_files_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["warrants_files_type"]["input"]>
  _lte?: InputMaybe<Scalars["warrants_files_type"]["input"]>
  _neq?: InputMaybe<Scalars["warrants_files_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["warrants_files_type"]["input"]>>
}

/** Boolean expression to compare columns of type "warrants_job_status". All fields are combined with logical 'AND'. */
export type Warrants_Job_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["warrants_job_status"]["input"]>
  _gt?: InputMaybe<Scalars["warrants_job_status"]["input"]>
  _gte?: InputMaybe<Scalars["warrants_job_status"]["input"]>
  _in?: InputMaybe<Array<Scalars["warrants_job_status"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["warrants_job_status"]["input"]>
  _lte?: InputMaybe<Scalars["warrants_job_status"]["input"]>
  _neq?: InputMaybe<Scalars["warrants_job_status"]["input"]>
  _nin?: InputMaybe<Array<Scalars["warrants_job_status"]["input"]>>
}

/** Boolean expression to compare columns of type "warrants_ticket_type". All fields are combined with logical 'AND'. */
export type Warrants_Ticket_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["warrants_ticket_type"]["input"]>
  _gt?: InputMaybe<Scalars["warrants_ticket_type"]["input"]>
  _gte?: InputMaybe<Scalars["warrants_ticket_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["warrants_ticket_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["warrants_ticket_type"]["input"]>
  _lte?: InputMaybe<Scalars["warrants_ticket_type"]["input"]>
  _neq?: InputMaybe<Scalars["warrants_ticket_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["warrants_ticket_type"]["input"]>>
}

/** Boolean expression to compare columns of type "warrants_visit_type". All fields are combined with logical 'AND'. */
export type Warrants_Visit_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars["warrants_visit_type"]["input"]>
  _gt?: InputMaybe<Scalars["warrants_visit_type"]["input"]>
  _gte?: InputMaybe<Scalars["warrants_visit_type"]["input"]>
  _in?: InputMaybe<Array<Scalars["warrants_visit_type"]["input"]>>
  _is_null?: InputMaybe<Scalars["Boolean"]["input"]>
  _lt?: InputMaybe<Scalars["warrants_visit_type"]["input"]>
  _lte?: InputMaybe<Scalars["warrants_visit_type"]["input"]>
  _neq?: InputMaybe<Scalars["warrants_visit_type"]["input"]>
  _nin?: InputMaybe<Array<Scalars["warrants_visit_type"]["input"]>>
}

export type InsertCancellationReasonMutationVariables = Exact<{
  billingAccountId?: InputMaybe<Scalars["bigint"]["input"]>
  channel?: InputMaybe<Scalars["String"]["input"]>
  meterPointId?: InputMaybe<Scalars["numeric"]["input"]>
  details?: InputMaybe<Scalars["String"]["input"]>
}>

export type InsertCancellationReasonMutation = {
  __typename?: "mutation_root"
  insert_cancellation_reasons_one?: {
    __typename?: "cancellation_reasons"
    id: any
  } | null
}

export type UpdateCallTraceAuditsMutationVariables = Exact<{
  updates: Array<Call_Trace_Audit_Updates> | Call_Trace_Audit_Updates
}>

export type UpdateCallTraceAuditsMutation = {
  __typename?: "mutation_root"
  update_call_trace_audit_many?: Array<{
    __typename?: "call_trace_audit_mutation_response"
    returning: Array<{ __typename?: "call_trace_audit"; confirm_status: any }>
  } | null> | null
}

export type UpdateMeterReminderMutationVariables = Exact<{
  accountNumber: Scalars["String"]["input"]
  isActive: Scalars["Boolean"]["input"]
}>

export type UpdateMeterReminderMutation = {
  __typename?: "mutation_root"
  update_reminder?: {
    __typename?: "reminder_mutation_response"
    returning: Array<{ __typename?: "reminder"; active: boolean }>
  } | null
}

export type ConfirmElecTradeMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  ConfirmReceivedDate: Scalars["datetime"]["input"]
  ConfirmSignedBy: Scalars["String"]["input"]
  ConfirmSignedDate: Scalars["datetime"]["input"]
}>

export type ConfirmElecTradeMutation = {
  __typename?: "mutation_root"
  update_ElecTrades_by_pk?: { __typename?: "ElecTrades"; id: number } | null
}

export type ConfirmGasTradeMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  ConfirmReceivedDate: Scalars["datetime"]["input"]
  ConfirmSignedBy: Scalars["String"]["input"]
  ConfirmSignedDate: Scalars["datetime"]["input"]
}>

export type ConfirmGasTradeMutation = {
  __typename?: "mutation_root"
  update_GasTrades_by_pk?: { __typename?: "GasTrades"; id: number } | null
}

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars["bigint"]["input"]
}>

export type DeleteUserMutation = {
  __typename?: "mutation_root"
  delete_admin_roles?: {
    __typename?: "admin_roles_mutation_response"
    affected_rows: number
  } | null
  delete_admin_passes?: {
    __typename?: "admin_passes_mutation_response"
    affected_rows: number
  } | null
  delete_refresh_tokens?: {
    __typename?: "refresh_tokens_mutation_response"
    affected_rows: number
  } | null
  delete_password_reset_tokens?: {
    __typename?: "password_reset_tokens_mutation_response"
    affected_rows: number
  } | null
  delete_users?: {
    __typename?: "users_mutation_response"
    affected_rows: number
  } | null
  delete_customer_user_rel?: {
    __typename?: "customer_user_rel_mutation_response"
    affected_rows: number
  } | null
}

export type InsertElecNominationsMutationVariables = Exact<{
  input: ElecNominations_Insert_Input
}>

export type InsertElecNominationsMutation = {
  __typename?: "mutation_root"
  insert_ElecNominations_one?: {
    __typename?: "ElecNominations"
    Hour_1?: number | null
    Hour_10?: number | null
    Hour_11?: number | null
    Hour_12?: number | null
    Hour_13?: number | null
    Hour_14?: number | null
    Hour_15?: number | null
    Hour_16?: number | null
    Hour_17?: number | null
    Hour_18?: number | null
    Hour_19?: number | null
    Hour_2?: number | null
    Hour_20?: number | null
    Hour_21?: number | null
    Hour_22?: number | null
    Hour_23?: number | null
    Hour_24?: number | null
    Hour_25?: number | null
    Hour_3?: number | null
    Hour_4?: number | null
    Hour_5?: number | null
    Hour_6?: number | null
    Hour_7?: number | null
    Hour_8?: number | null
    Hour_9?: number | null
    created_at?: any | null
    date?: any | null
    updated_at?: any | null
    trader?: string | null
  } | null
}

export type InsertElecTradeMutationVariables = Exact<{
  input: ElecTrades_Insert_Input
}>

export type InsertElecTradeMutation = {
  __typename?: "mutation_root"
  insert_ElecTrades_one?: {
    __typename?: "ElecTrades"
    id: number
    ConfirmSignedBy?: string | null
    ConfirmSignedDate?: any | null
    Counterparty?: string | null
    Date?: any | null
    Invoice_Date_From?: any | null
    Invoice_Date_To?: any | null
    Notes?: string | null
    Period?: string | null
    Price?: number | null
    Product?: string | null
    Trader?: string | null
    Volume?: number | null
    PercentOfBaseload?: number | null
    ConfirmReceivedDate?: any | null
  } | null
}

export type InsertElecTradeHistoryMutationVariables = Exact<{
  input: ElecTradesHistory_Insert_Input
}>

export type InsertElecTradeHistoryMutation = {
  __typename?: "mutation_root"
  insert_ElecTradesHistory_one?: {
    __typename?: "ElecTradesHistory"
    id: number
    elec_trade_id: number
    ConfirmReceivedDate?: any | null
    ConfirmSignedBy?: string | null
    ConfirmSignedDate?: any | null
    Counterparty?: string | null
    Date?: any | null
    Invoice_Date_From?: any | null
    Invoice_Date_To?: any | null
    Notes?: string | null
    Period?: string | null
    Price?: number | null
    Product?: string | null
    Trader?: string | null
    Volume?: number | null
    PercentOfBaseload?: number | null
  } | null
}

export type InsertEmailTemplateMutationVariables = Exact<{
  input: Email_Templates_Insert_Input
}>

export type InsertEmailTemplateMutation = {
  __typename?: "mutation_root"
  insert_email_templates_one?: {
    __typename?: "email_templates"
    id: any
    communication_id: any
    version: number
    is_live: boolean
  } | null
}

export type InsertEmailTemplateAsLiveMutationVariables = Exact<{
  communicationId: Scalars["bigint"]["input"]
  input: Email_Templates_Insert_Input
}>

export type InsertEmailTemplateAsLiveMutation = {
  __typename?: "mutation_root"
  unset?: {
    __typename?: "email_templates_mutation_response"
    affected_rows: number
  } | null
  inserted?: {
    __typename?: "email_templates"
    id: any
    communication_id: any
    version: number
    is_live: boolean
    published_at?: any | null
  } | null
}

export type InsertGasTradeMutationVariables = Exact<{
  input: GasTrades_Insert_Input
}>

export type InsertGasTradeMutation = {
  __typename?: "mutation_root"
  insert_GasTrades_one?: {
    __typename?: "GasTrades"
    ConfirmSignedBy?: string | null
    ConfirmSignedDate?: any | null
    CounterParty?: string | null
    Date?: any | null
    Date_From?: any | null
    Date_To?: any | null
    Index?: string | null
    Notes?: string | null
    Period?: string | null
    Price?: number | null
    Trader?: string | null
    Volume?: number | null
    id: number
    ConfirmReceived?: any | null
  } | null
}

export type InsertGasTradeHistoryMutationVariables = Exact<{
  input: GasTradesHistory_Insert_Input
}>

export type InsertGasTradeHistoryMutation = {
  __typename?: "mutation_root"
  insert_GasTradesHistory_one?: {
    __typename?: "GasTradesHistory"
    ConfirmReceived?: any | null
    ConfirmSignedBy?: string | null
    ConfirmSignedDate?: any | null
    CounterParty?: string | null
    Date?: any | null
    Date_From?: any | null
    Date_To?: any | null
    Index?: string | null
    Notes?: string | null
    Period?: string | null
    Price?: number | null
    Trader?: string | null
    Volume?: number | null
    gas_trade_id: number
    id: number
  } | null
}

export type MarkCreditCheckAsDepositPaidMutationVariables = Exact<{
  id: Scalars["bigint"]["input"]
  depositPaidDate: Scalars["timestamp"]["input"]
  depositAgent: Scalars["String"]["input"]
}>

export type MarkCreditCheckAsDepositPaidMutation = {
  __typename?: "mutation_root"
  update_registration_credit_check?: {
    __typename?: "registration_credit_check_mutation_response"
    affected_rows: number
  } | null
}

export type SetLiveEmailTemplateVersionMutationVariables = Exact<{
  communicationId: Scalars["bigint"]["input"]
  id: Scalars["bigint"]["input"]
  publishedAt: Scalars["timestamptz"]["input"]
}>

export type SetLiveEmailTemplateVersionMutation = {
  __typename?: "mutation_root"
  unset?: {
    __typename?: "email_templates_mutation_response"
    affected_rows: number
  } | null
  setLive?: {
    __typename?: "email_templates"
    id: any
    is_live: boolean
    published_at?: any | null
  } | null
}

export type ToggleReferralSettingMutationVariables = Exact<{
  number: Scalars["String"]["input"]
  isWhitelisted: Scalars["Boolean"]["input"]
}>

export type ToggleReferralSettingMutation = {
  __typename?: "mutation_root"
  update_customer_setting?: {
    __typename?: "customer_setting_mutation_response"
    affected_rows: number
  } | null
}

export type UnlockElecTradeMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type UnlockElecTradeMutation = {
  __typename?: "mutation_root"
  update_ElecTrades_by_pk?: { __typename?: "ElecTrades"; id: number } | null
}

export type UnlockGasTradeMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type UnlockGasTradeMutation = {
  __typename?: "mutation_root"
  update_GasTrades_by_pk?: { __typename?: "GasTrades"; id: number } | null
}

export type UpdateConfigurationsMutationVariables = Exact<{
  updates: Array<Configuration_Updates> | Configuration_Updates
}>

export type UpdateConfigurationsMutation = {
  __typename?: "mutation_root"
  update_configuration_many?: Array<{
    __typename?: "configuration_mutation_response"
    affected_rows: number
  } | null> | null
}

export type UpdateElecTradeMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  Counterparty?: InputMaybe<Scalars["String"]["input"]>
  Invoice_Date_From?: InputMaybe<Scalars["datetime"]["input"]>
  Invoice_Date_To?: InputMaybe<Scalars["datetime"]["input"]>
  Period?: InputMaybe<Scalars["String"]["input"]>
  Price?: InputMaybe<Scalars["Float"]["input"]>
  Product?: InputMaybe<Scalars["String"]["input"]>
  Volume?: InputMaybe<Scalars["Float"]["input"]>
  Notes?: InputMaybe<Scalars["String"]["input"]>
  PercentOfBaseload?: InputMaybe<Scalars["Float"]["input"]>
}>

export type UpdateElecTradeMutation = {
  __typename?: "mutation_root"
  update_ElecTrades_by_pk?: { __typename?: "ElecTrades"; id: number } | null
}

export type UpdateGasTradeMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  CounterParty?: InputMaybe<Scalars["String"]["input"]>
  Date_From?: InputMaybe<Scalars["datetime"]["input"]>
  Date_To?: InputMaybe<Scalars["datetime"]["input"]>
  Index?: InputMaybe<Scalars["String"]["input"]>
  Period?: InputMaybe<Scalars["String"]["input"]>
  Price?: InputMaybe<Scalars["Float"]["input"]>
  Volume?: InputMaybe<Scalars["Int"]["input"]>
  Notes?: InputMaybe<Scalars["String"]["input"]>
}>

export type UpdateGasTradeMutation = {
  __typename?: "mutation_root"
  update_GasTrades_by_pk?: { __typename?: "GasTrades"; id: number } | null
}

export type UpdateProductFlagsMutationVariables = Exact<{
  elec_updates:
    Array<Product_Variant_Elec_Updates> | Product_Variant_Elec_Updates
  gas_updates: Array<Product_Variant_Gas_Updates> | Product_Variant_Gas_Updates
  smart_charging_updates: Array<Product_Elec_Updates> | Product_Elec_Updates
}>

export type UpdateProductFlagsMutation = {
  __typename?: "mutation_root"
  update_product_variant_elec_many?: Array<{
    __typename?: "product_variant_elec_mutation_response"
    affected_rows: number
  } | null> | null
  update_product_variant_gas_many?: Array<{
    __typename?: "product_variant_gas_mutation_response"
    affected_rows: number
  } | null> | null
  update_product_elec_many?: Array<{
    __typename?: "product_elec_mutation_response"
    affected_rows: number
  } | null> | null
}

export type UpdateStatusAndCommentMutationVariables = Exact<{
  submissionId?: InputMaybe<Scalars["bigint"]["input"]>
  status?: InputMaybe<
    Scalars["meter_reading_submission_request_status"]["input"]
  >
  comment?: InputMaybe<Scalars["String"]["input"]>
}>

export type UpdateStatusAndCommentMutation = {
  __typename?: "mutation_root"
  update_meter_reading_submission_request?: {
    __typename?: "meter_reading_submission_request_mutation_response"
    affected_rows: number
  } | null
}

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars["bigint"]["input"]
  email?: InputMaybe<Scalars["String"]["input"]>
  lockedAt?: InputMaybe<Scalars["timestamp"]["input"]>
}>

export type UpdateUserMutation = {
  __typename?: "mutation_root"
  update_users?: {
    __typename?: "users_mutation_response"
    affected_rows: number
  } | null
}

export type UpdateUserPasswordMutationVariables = Exact<{
  userId: Scalars["BigInt"]["input"]
  password: Scalars["String"]["input"]
  passwordConfirmation: Scalars["String"]["input"]
}>

export type UpdateUserPasswordMutation = {
  __typename?: "mutation_root"
  changeUserPassword: string
}

export type DeleteSynchronizedAccountMutationVariables = Exact<{
  id: Scalars["bigint"]["input"]
}>

export type DeleteSynchronizedAccountMutation = {
  __typename?: "mutation_root"
  deleted_synchronized_account?: {
    __typename?: "synchronized_accounts"
    id: any
    accountId?: any | null
    juniferAccountId: any
    locked: boolean
  } | null
}

export type RetryPaymentReviewRecordsByIdsMutationVariables = Exact<{
  ids:
    | Array<InputMaybe<Scalars["BigInt"]["input"]>>
    | InputMaybe<Scalars["BigInt"]["input"]>
  overrideIncreaseThreshold: Scalars["Boolean"]["input"]
  ignoreAccountBalance: Scalars["Boolean"]["input"]
}>

export type RetryPaymentReviewRecordsByIdsMutation = {
  __typename?: "mutation_root"
  retryPaymentReviewRecordsById?: {
    __typename?: "PaymentReviewsOperationResponse"
    result?: string | null
  } | null
}

export type RetryPaymentReviewRecordsByFiltersMutationVariables = Exact<{
  paymentReviewId: Scalars["BigInt"]["input"]
  filters: Filters
  overrideIncreaseThreshold: Scalars["Boolean"]["input"]
  ignoreAccountBalance: Scalars["Boolean"]["input"]
}>

export type RetryPaymentReviewRecordsByFiltersMutation = {
  __typename?: "mutation_root"
  retryPaymentReviewRecordsByFilters?: {
    __typename?: "PaymentReviewsOperationResponse"
    result?: string | null
  } | null
}

export type ActionPaymentReviewRecordsDeleteByIdsMutationVariables = Exact<{
  ids:
    | Array<InputMaybe<Scalars["BigInt"]["input"]>>
    | InputMaybe<Scalars["BigInt"]["input"]>
}>

export type ActionPaymentReviewRecordsDeleteByIdsMutation = {
  __typename?: "mutation_root"
  action_payment_review_records_delete_by_ids?: {
    __typename?: "PaymentReviewRecordsDeleteByIdsResponse"
    result?: string | null
  } | null
}

export type GetAccountCreditQueryVariables = Exact<{
  accountCreditId?: InputMaybe<Scalars["bigint"]["input"]>
}>

export type GetAccountCreditQuery = {
  __typename?: "query_root"
  account_credit: Array<{
    __typename?: "account_credit"
    id: any
    created_user?: string | null
    reference?: string | null
  }>
}

export type GetAccountNumbersByCoreIdsQueryVariables = Exact<{
  coreIds: Array<Scalars["bigint"]["input"]> | Scalars["bigint"]["input"]
}>

export type GetAccountNumbersByCoreIdsQuery = {
  __typename?: "query_root"
  billing_account: Array<{
    __typename?: "billing_account"
    id: any
    number: string
  }>
}

export type GetAccountsByCustomerIdQueryVariables = Exact<{
  customerId: Scalars["bigint"]["input"]
}>

export type GetAccountsByCustomerIdQuery = {
  __typename?: "query_root"
  billing_account: Array<{ __typename?: "billing_account"; number: string }>
}

export type GetActiveDirectDebitAccountsQueryVariables = Exact<{
  billingAccountIds:
    Array<Scalars["bigint"]["input"]> | Scalars["bigint"]["input"]
  now: Scalars["timestamp"]["input"]
}>

export type GetActiveDirectDebitAccountsQuery = {
  __typename?: "query_root"
  payment_method: Array<{
    __typename?: "payment_method"
    billing_account_id?: any | null
  }>
}

export type GetCallTraceAuditQueryVariables = Exact<{
  juniferNumber?: InputMaybe<Scalars["String"]["input"]>
  confirmStatus?: InputMaybe<
    Scalars["call_trace_audit_confirmed_enum"]["input"]
  >
  gdprTypeExclude?: InputMaybe<Scalars["call_trace_audit_gdpr_enum"]["input"]>
}>

export type GetCallTraceAuditQuery = {
  __typename?: "query_root"
  call_trace_audit: Array<{
    __typename?: "call_trace_audit"
    account_number: string
    confirm_status: any
    data_updated: string
    gdpr_type: any
    id: any
  }>
}

export type GetCardPaymentsQueryVariables = Exact<{
  externalId: Scalars["String"]["input"]
}>

export type GetCardPaymentsQuery = {
  __typename?: "query_root"
  card_payments: Array<{
    __typename?: "card_payment_old"
    amount: any
    junifer_payment_status: any
    notification_error?: string | null
    notification_status: any
    reference: string
    status: any
    error_code?: string | null
    error_message?: string | null
  }>
}

export type GetCasesByCoreIdQueryVariables = Exact<{
  coreId: Scalars["bigint"]["input"]
}>

export type GetCasesByCoreIdQuery = {
  __typename?: "query_root"
  cases: Array<{
    __typename?: "cases"
    id: any
    external_id: string
    fields?: any | null
    created_at?: any | null
    updated_at?: any | null
  }>
}

export type GetComplaintsForAccountNumberQueryVariables = Exact<{
  accountNumber: Scalars["String"]["input"]
}>

export type GetComplaintsForAccountNumberQuery = {
  __typename?: "query_root"
  complaint: Array<{
    __typename?: "complaint"
    id: any
    external_identifier?: string | null
    customer_id?: any | null
    type?: string | null
    category1?: string | null
    category2?: string | null
    category3?: string | null
    internal_complaint_category?: string | null
    ofgem_mapped_complaint_category?: string | null
    channel?: string | null
    source?: string | null
    team?: string | null
    agent_name?: string | null
    agent_email?: string | null
    created_at: any
    updated_at: any
    date_raised?: any | null
    closed_at?: any | null
    status?: string | null
    sub_status?: string | null
    deleted?: any | null
    ombudsman_case?: boolean | null
    d1_signposting_comms_sent: boolean
    d56_signposting_comms_sent: boolean
    overdue_signposting_comms_sent: boolean
    recent_signposting_comms_sent: boolean
    deadlock_comms_sent: boolean
    send_date_of_d1_signposting_comms?: any | null
    send_date_of_d56_signposting_comms?: any | null
    send_date_of_overdue_signposting_comms?: any | null
    send_date_of_recent_signposting_comms?: any | null
    details?: any | null
    complaints_goodwill_amount?: any | null
  }>
}

export type GetCoreIdByAccountNumberQueryVariables = Exact<{
  accountNumber?: InputMaybe<Scalars["String"]["input"]>
}>

export type GetCoreIdByAccountNumberQuery = {
  __typename?: "query_root"
  billing_account: Array<{ __typename?: "billing_account"; id: any }>
}

export type GetCustomerIdByAccountNumberQueryVariables = Exact<{
  accountNumber?: InputMaybe<Scalars["String"]["input"]>
}>

export type GetCustomerIdByAccountNumberQuery = {
  __typename?: "query_root"
  billing_account: Array<{ __typename?: "billing_account"; customer_id: any }>
}

export type GetEmailContentQueryVariables = Exact<{
  path: Scalars["String"]["input"]
}>

export type GetEmailContentQuery = {
  __typename?: "query_root"
  getEmailContent?: {
    __typename?: "EmailContentResponse"
    emailBody: string
  } | null
}

export type GetEmailsByEmailAddressQueryVariables = Exact<{
  email?: InputMaybe<Scalars["String"]["input"]>
}>

export type GetEmailsByEmailAddressQuery = {
  __typename?: "query_root"
  recipients: Array<{
    __typename?: "recipients"
    email_message?: {
      __typename?: "email_messages"
      id: any
      subject?: string | null
      processed_at?: any | null
      opened: boolean
      html_content?: string | null
    } | null
  }>
}

export type GetFlexMarketSubscriptionsQueryVariables = Exact<{
  billingAccountId: Scalars["bigint"]["input"]
}>

export type GetFlexMarketSubscriptionsQuery = {
  __typename?: "query_root"
  flex_market_subscription: Array<{
    __typename?: "flex_market_subscription"
    onboarded_at: any
    offboarded_at?: any | null
    meter_point?: { __typename?: "meter_point"; identifier: string } | null
  }>
}

export type GetFreshdeskContactsQueryVariables = Exact<{
  accountNumber: Scalars["String"]["input"]
}>

export type GetFreshdeskContactsQuery = {
  __typename?: "query_root"
  freshdesk_contact: Array<{
    __typename?: "freshdesk_contact"
    id?: any | null
    external_id?: any | null
    type?: string | null
    raw_data?: any | null
    created_at?: any | null
    updated_at?: any | null
  }>
}

export type GetFreshdeskTicketsQueryVariables = Exact<{
  contactId: Scalars["String"]["input"]
}>

export type GetFreshdeskTicketsQuery = {
  __typename?: "query_root"
  freshdesk_ticket: Array<{
    __typename?: "freshdesk_ticket"
    id?: any | null
    external_id?: any | null
    type?: string | null
    raw_data?: any | null
    created_at?: any | null
    updated_at?: any | null
  }>
}

export type GetReminderQueryVariables = Exact<{
  accountNumber: Scalars["String"]["input"]
}>

export type GetReminderQuery = {
  __typename?: "query_root"
  reminder: Array<{ __typename?: "reminder"; active: boolean }>
}

export type GetTariffsQueryVariables = Exact<{
  gsp_group: Scalars["String"]["input"]
}>

export type GetTariffsQuery = {
  __typename?: "query_root"
  current_future_product_details: Array<{
    __typename?: "current_future_product_details"
    id?: any | null
    code?: string | null
    gsp_group?: string | null
    display_name?: string | null
    name?: string | null
    direct_debit?: boolean | null
    duration_value?: number | null
    early_termination_charge?: any | null
    export?: boolean | null
    charge_value?: any | null
    tariff_rates?: any | null
    vat_rate?: any | null
    variant_type?: any | null
    bundle_dfn_group_code?: string | null
    bundle_df_type_name?: string | null
    from_dt?: any | null
    variant_from_dt?: any | null
  }>
}

export type SearchMeterPointsByIdentifierQueryVariables = Exact<{
  identifier: Scalars["String"]["input"]
  limit?: InputMaybe<Scalars["Int"]["input"]>
}>

export type SearchMeterPointsByIdentifierQuery = {
  __typename?: "query_root"
  meter_point: Array<{
    __typename?: "meter_point"
    id: any
    identifier: string
  }>
}

export type GetAdminEmailListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars["Int"]["input"]>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  processedAt?: InputMaybe<Timestamptz_Comparison_Exp>
  communicationName?: InputMaybe<String_Comparison_Exp>
}>

export type GetAdminEmailListQuery = {
  __typename?: "query_root"
  email_messages: Array<{
    __typename?: "email_messages"
    id: any
    status: string
    subject?: string | null
    processed_at?: any | null
    recipient_id?: any | null
    request: { __typename?: "requests"; communication_name: string }
    recipient?: {
      __typename?: "recipients"
      id: any
      email?: string | null
      name?: string | null
      account_id?: number | null
      customer_id?: number | null
    } | null
  }>
  email_messages_aggregate: {
    __typename?: "email_messages_aggregate"
    aggregate?: {
      __typename?: "email_messages_aggregate_fields"
      count: number
    } | null
  }
}

export type GetAdminEmailTotalCountQueryVariables = Exact<{
  processedAt?: InputMaybe<Timestamptz_Comparison_Exp>
  communicationName?: InputMaybe<String_Comparison_Exp>
}>

export type GetAdminEmailTotalCountQuery = {
  __typename?: "query_root"
  email_messages_aggregate: {
    __typename?: "email_messages_aggregate"
    aggregate?: {
      __typename?: "email_messages_aggregate_fields"
      count: number
    } | null
  }
}

export type GetAdminEmailChartDataQueryVariables = Exact<{
  processedAt?: InputMaybe<Timestamptz_Comparison_Exp>
  communicationName?: InputMaybe<String_Comparison_Exp>
}>

export type GetAdminEmailChartDataQuery = {
  __typename?: "query_root"
  email_messages: Array<{
    __typename?: "email_messages"
    status: string
    processed_at?: any | null
    request: { __typename?: "requests"; communication_name: string }
  }>
}

export type GetAdminEmailTemplatesQueryVariables = Exact<{
  [key: string]: never
}>

export type GetAdminEmailTemplatesQuery = {
  __typename?: "query_root"
  requests: Array<{ __typename?: "requests"; communication_name: string }>
}

export type GetAlpsRangeQueryVariables = Exact<{
  from1: Scalars["date"]["input"]
  to1: Scalars["date"]["input"]
  from2: Scalars["date"]["input"]
  to2: Scalars["date"]["input"]
}>

export type GetAlpsRangeQuery = {
  __typename?: "query_root"
  energy_usage_load_factors_aggregate: {
    __typename?: "energy_usage_load_factors_aggregate"
    aggregate?: {
      __typename?: "energy_usage_load_factors_aggregate_fields"
      sum?: {
        __typename?: "energy_usage_load_factors_sum_fields"
        electricity_r1?: any | null
      } | null
    } | null
  }
}

export type GetBeFinancialsConfigHistoryQueryVariables = Exact<{
  name: Scalars["String"]["input"]
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
}>

export type GetBeFinancialsConfigHistoryQuery = {
  __typename?: "query_root"
  financials_configuration: Array<{
    __typename?: "financials_configuration"
    id: any
    name: string
    value: string
    from_dttm?: any | null
    to_dttm?: any | null
    created_at?: any | null
    updated_at?: any | null
    deleted?: any | null
  }>
  financials_configuration_aggregate: {
    __typename?: "financials_configuration_aggregate"
    aggregate?: {
      __typename?: "financials_configuration_aggregate_fields"
      count: number
    } | null
  }
}

export type GetBeFinancialsConfigListQueryVariables = Exact<{
  [key: string]: never
}>

export type GetBeFinancialsConfigListQuery = {
  __typename?: "query_root"
  financials_configuration: Array<{
    __typename?: "financials_configuration"
    id: any
    name: string
    value: string
    from_dttm?: any | null
    to_dttm?: any | null
    created_at?: any | null
    updated_at?: any | null
    deleted?: any | null
  }>
}

export type GetBeFinancialsConfigStatsQueryVariables = Exact<{
  now?: InputMaybe<Scalars["timestamp"]["input"]>
}>

export type GetBeFinancialsConfigStatsQuery = {
  __typename?: "query_root"
  total: {
    __typename?: "financials_configuration_aggregate"
    aggregate?: {
      __typename?: "financials_configuration_aggregate_fields"
      count: number
    } | null
  }
  active: {
    __typename?: "financials_configuration_aggregate"
    aggregate?: {
      __typename?: "financials_configuration_aggregate_fields"
      count: number
    } | null
  }
}

export type GetBlacklistedCustomersQueryVariables = Exact<{
  [key: string]: never
}>

export type GetBlacklistedCustomersQuery = {
  __typename?: "query_root"
  customer: Array<{
    __typename?: "customer"
    number: string
    billing_accounts: Array<{ __typename?: "billing_account"; number: string }>
    customer_user_rels: Array<{
      __typename?: "customer_user_rel"
      user_id: any
      user?: { __typename?: "users"; email: string } | null
    }>
    customer_referrals: Array<{
      __typename?: "customer_referrals"
      created_at: any
    }>
  }>
}

export type GetCancellationsByUserIdQueryVariables = Exact<{
  userId?: InputMaybe<Scalars["bigint"]["input"]>
}>

export type GetCancellationsByUserIdQuery = {
  __typename?: "query_root"
  cancellations: Array<{
    __typename?: "cancellations"
    created_at: any
    id: any
  }>
}

export type GetCommunicationsQueryVariables = Exact<{ [key: string]: never }>

export type GetCommunicationsQuery = {
  __typename?: "query_root"
  communications: Array<{
    __typename?: "communications"
    id: any
    name: string
    communication_type: any
  }>
}

export type GetComplaintsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars["Int"]["input"]>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  orderBy?: InputMaybe<Array<Complaint_Order_By> | Complaint_Order_By>
  dateRaised?: InputMaybe<Timestamp_Comparison_Exp>
  status?: InputMaybe<String_Comparison_Exp>
  channel?: InputMaybe<String_Comparison_Exp>
  type?: InputMaybe<String_Comparison_Exp>
  subStatus?: InputMaybe<String_Comparison_Exp>
  category1?: InputMaybe<String_Comparison_Exp>
  category2?: InputMaybe<String_Comparison_Exp>
  category3?: InputMaybe<String_Comparison_Exp>
  agentName?: InputMaybe<String_Comparison_Exp>
  team?: InputMaybe<String_Comparison_Exp>
  ofgemCategory?: InputMaybe<String_Comparison_Exp>
  internalCategory?: InputMaybe<String_Comparison_Exp>
  orClauses?: InputMaybe<Array<Complaint_Bool_Exp> | Complaint_Bool_Exp>
  andClauses?: InputMaybe<Array<Complaint_Bool_Exp> | Complaint_Bool_Exp>
}>

export type GetComplaintsQuery = {
  __typename?: "query_root"
  complaint: Array<{
    __typename?: "complaint"
    id: any
    deleted?: any | null
    created_at: any
    updated_at: any
    details?: any | null
    external_identifier?: string | null
    customer_id?: any | null
    ombudsman_case?: boolean | null
    team?: string | null
    agent_email?: string | null
    agent_name?: string | null
    channel?: string | null
    type?: string | null
    date_raised?: any | null
    status?: string | null
    sub_status?: string | null
    d1_signposting_comms_sent: boolean
    send_date_of_d1_signposting_comms?: any | null
    d56_signposting_comms_sent: boolean
    send_date_of_d56_signposting_comms?: any | null
    deadlock_comms_sent: boolean
    ofgem_mapped_complaint_category?: string | null
    internal_complaint_category?: string | null
    complaints_goodwill_amount?: any | null
    category1?: string | null
    category2?: string | null
    category3?: string | null
    recent_signposting_comms_sent: boolean
    overdue_signposting_comms_sent: boolean
    send_date_of_recent_signposting_comms?: any | null
    send_date_of_overdue_signposting_comms?: any | null
    closed_at?: any | null
    source?: string | null
  }>
  complaint_aggregate: {
    __typename?: "complaint_aggregate"
    aggregate?: {
      __typename?: "complaint_aggregate_fields"
      count: number
    } | null
  }
}

export type GetComplaintsSummaryQueryVariables = Exact<{ [key: string]: never }>

export type GetComplaintsSummaryQuery = {
  __typename?: "query_root"
  complaint_aggregations: Array<{
    __typename?: "complaint_aggregations"
    open?: any | null
    ombudsman?: any | null
    cab?: any | null
    ehu?: any | null
    exec?: any | null
    newer_than_5_weeks?: any | null
    older_than_5_weeks?: any | null
  }>
}

export type GetComplaintColumnValuesQueryVariables = Exact<{
  [key: string]: never
}>

export type GetComplaintColumnValuesQuery = {
  __typename?: "query_root"
  complaint: Array<{
    __typename?: "complaint"
    channel?: string | null
    type?: string | null
    team?: string | null
    status?: string | null
    sub_status?: string | null
    category1?: string | null
    category2?: string | null
    category3?: string | null
    agent_name?: string | null
    ofgem_mapped_complaint_category?: string | null
    internal_complaint_category?: string | null
  }>
}

export type GetConfigurationQueryVariables = Exact<{
  name: Scalars["configuration_name"]["input"]
  now?: InputMaybe<Scalars["timestamp"]["input"]>
}>

export type GetConfigurationQuery = {
  __typename?: "query_root"
  configuration: Array<{ __typename?: "configuration"; value: string }>
}

export type GetConfigurationsQueryVariables = Exact<{ [key: string]: never }>

export type GetConfigurationsQuery = {
  __typename?: "query_root"
  configuration: Array<{
    __typename?: "configuration"
    id: any
    name: any
    value: string
    editable?: boolean | null
    from_dt: any
    to_dt?: any | null
  }>
}

export type GetCustomerReferralQueryVariables = Exact<{
  customerId: Scalars["bigint"]["input"]
}>

export type GetCustomerReferralQuery = {
  __typename?: "query_root"
  customer_referrals: Array<{
    __typename?: "customer_referrals"
    referee: {
      __typename?: "customer"
      id: any
      customer_user_rels: Array<{
        __typename?: "customer_user_rel"
        customer: {
          __typename?: "customer"
          number: string
          billing_accounts: Array<{
            __typename?: "billing_account"
            number: string
          }>
          customer_referrals: Array<{
            __typename?: "customer_referrals"
            created_at: any
          }>
          customer_user_rels: Array<{
            __typename?: "customer_user_rel"
            user_id: any
          }>
        }
      }>
    }
  }>
}

export type GetCustomerReferralDetailsQueryVariables = Exact<{
  customerNumber: Scalars["String"]["input"]
}>

export type GetCustomerReferralDetailsQuery = {
  __typename?: "query_root"
  customer: Array<{
    __typename?: "customer"
    number: string
    first_name: string
    last_name: string
    customer_user_rels: Array<{
      __typename?: "customer_user_rel"
      user?: { __typename?: "users"; id: any; email: string } | null
    }>
    customer_setting: {
      __typename?: "customer_setting"
      id: any
      referrals_enabled: boolean
    }
    billing_accounts: Array<{
      __typename?: "billing_account"
      billing_account_contacts: Array<{
        __typename?: "billing_account_contact"
        contact: {
          __typename?: "contact"
          address?: {
            __typename?: "customer_address"
            address1?: string | null
            address2?: string | null
            address3?: string | null
            postcode?: string | null
            country_code?: string | null
          } | null
        }
      }>
    }>
    customer_referrals: Array<{
      __typename?: "customer_referrals"
      credit: any
      status: any
      referred: {
        __typename?: "customer"
        first_name: string
        last_name: string
        customer_user_rels: Array<{
          __typename?: "customer_user_rel"
          user_id: any
        }>
      }
    }>
  }>
}

export type GetCustomersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  search?: InputMaybe<Scalars["String"]["input"]>
  orderBy?: InputMaybe<Array<Customer_Order_By> | Customer_Order_By>
}>

export type GetCustomersQuery = {
  __typename?: "query_root"
  customer: Array<{
    __typename?: "customer"
    id: any
    number: string
    first_name: string
    last_name: string
    created_at: any
    customer_contacts: Array<{
      __typename?: "customer_contact"
      primary: boolean
      contact: { __typename?: "contact"; email?: string | null }
    }>
    billing_accounts: Array<{ __typename?: "billing_account"; id: any }>
  }>
  customer_aggregate: {
    __typename?: "customer_aggregate"
    aggregate?: {
      __typename?: "customer_aggregate_fields"
      count: number
    } | null
  }
}

export type GetDcaConfigurationQueryVariables = Exact<{ [key: string]: never }>

export type GetDcaConfigurationQuery = {
  __typename?: "query_root"
  tickets_dca_configuration_v2: Array<{
    __typename?: "tickets_dca_configuration_v2"
    dca: string
    junifer_ticket_definition: string
  }>
}

export type GetElecNominationsQueryVariables = Exact<{ [key: string]: never }>

export type GetElecNominationsQuery = {
  __typename?: "query_root"
  ElecNominations: Array<{
    __typename?: "ElecNominations"
    Hour_1?: number | null
    Hour_10?: number | null
    Hour_11?: number | null
    Hour_12?: number | null
    Hour_13?: number | null
    Hour_14?: number | null
    Hour_15?: number | null
    Hour_16?: number | null
    Hour_17?: number | null
    Hour_18?: number | null
    Hour_19?: number | null
    Hour_2?: number | null
    Hour_20?: number | null
    Hour_21?: number | null
    Hour_22?: number | null
    Hour_23?: number | null
    Hour_24?: number | null
    Hour_25?: number | null
    Hour_3?: number | null
    Hour_4?: number | null
    Hour_5?: number | null
    Hour_6?: number | null
    Hour_7?: number | null
    Hour_8?: number | null
    Hour_9?: number | null
    created_at?: any | null
    date?: any | null
    updated_at?: any | null
    trader?: string | null
  }>
}

export type GetElecTradesQueryVariables = Exact<{ [key: string]: never }>

export type GetElecTradesQuery = {
  __typename?: "query_root"
  ElecTrades: Array<{
    __typename?: "ElecTrades"
    ConfirmSignedBy?: string | null
    ConfirmSignedDate?: any | null
    Counterparty?: string | null
    Date?: any | null
    Invoice_Date_From?: any | null
    Invoice_Date_To?: any | null
    Period?: string | null
    Price?: number | null
    Product?: string | null
    Trader?: string | null
    Notes?: string | null
    Volume?: number | null
    Locked: boolean
    id: number
    PercentOfBaseload?: number | null
    ConfirmReceivedDate?: any | null
  }>
}

export type GetElecTradesHistoryQueryVariables = Exact<{ [key: string]: never }>

export type GetElecTradesHistoryQuery = {
  __typename?: "query_root"
  ElecTradesHistory: Array<{
    __typename?: "ElecTradesHistory"
    ConfirmReceivedDate?: any | null
    ConfirmSignedBy?: string | null
    ConfirmSignedDate?: any | null
    Counterparty?: string | null
    Date?: any | null
    Invoice_Date_From?: any | null
    Invoice_Date_To?: any | null
    Period?: string | null
    Price?: number | null
    Product?: string | null
    Trader?: string | null
    Notes?: string | null
    Volume?: number | null
    elec_trade_id: number
    id: number
    PercentOfBaseload?: number | null
  }>
}

export type GetEmailTemplateSummariesQueryVariables = Exact<{
  [key: string]: never
}>

export type GetEmailTemplateSummariesQuery = {
  __typename?: "query_root"
  email_templates: Array<{
    __typename?: "email_templates"
    id: any
    communication_id: any
    version: number
    is_live: boolean
    subject: string
    created_at: any
    published_at?: any | null
    modified_by?: string | null
    communication: {
      __typename?: "communications"
      id: any
      name: string
      communication_type: any
    }
  }>
}

export type GetEmailTemplatesByCommunicationQueryVariables = Exact<{
  communicationId: Scalars["bigint"]["input"]
}>

export type GetEmailTemplatesByCommunicationQuery = {
  __typename?: "query_root"
  email_templates: Array<{
    __typename?: "email_templates"
    id: any
    communication_id: any
    version: number
    is_live: boolean
    subject: string
    plain_content: string
    html_content: string
    modified_by?: string | null
    modified_reason?: string | null
    created_at: any
    published_at?: any | null
    communication: {
      __typename?: "communications"
      id: any
      name: string
      communication_type: any
    }
  }>
}

export type GetEnrolmentAutomatedCommunicationByIdQueryVariables = Exact<{
  enrolmentId?: InputMaybe<Scalars["bigint"]["input"]>
}>

export type GetEnrolmentAutomatedCommunicationByIdQuery = {
  __typename?: "query_root"
  enrolment_automated_communications: Array<{
    __typename?: "enrolment_automated_communications"
    comms_sent?: string | null
    comms_sent_to?: string | null
    created_at: any
    enrolment_id?: any | null
    paragraph_one?: string | null
    paragraph_two?: string | null
  }>
}

export type GetEnrolmentsQueryVariables = Exact<{
  search?: InputMaybe<Scalars["String"]["input"]>
  orderBy?: InputMaybe<Array<Enrolment_Order_By> | Enrolment_Order_By>
  broker?: InputMaybe<String_Comparison_Exp>
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>
  onboardingStatus?: InputMaybe<String_Comparison_Exp>
  enrolmentFailureMessage?: InputMaybe<String_Comparison_Exp>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
}>

export type GetEnrolmentsQuery = {
  __typename?: "query_root"
  enrolment: Array<{
    __typename?: "enrolment"
    broker?: string | null
    email?: string | null
    created_at: any
    customer_id?: any | null
    enrolment_failure_message?: string | null
    data?: any | null
    id: any
    status?: string | null
    third_party_switch_reference?: string | null
    post_code?: string | null
    communications_sent?: boolean | null
    retry_count?: number | null
    customer?: {
      __typename?: "customer"
      number: string
      first_name: string
      last_name: string
      billing_accounts: Array<{
        __typename?: "billing_account"
        number: string
        id: any
        cancelled?: any | null
        terminated?: any | null
        closed?: any | null
      }>
    } | null
  }>
  enrolment_aggregate: {
    __typename?: "enrolment_aggregate"
    aggregate?: {
      __typename?: "enrolment_aggregate_fields"
      count: number
    } | null
  }
}

export type GetEnrolmentsByBrokerQueryVariables = Exact<{
  createdAtStart: Scalars["timestamp"]["input"]
  createdAtEnd: Scalars["timestamp"]["input"]
  search?: InputMaybe<Scalars["String"]["input"]>
  enrolmentFailureMessageRegex?: InputMaybe<Scalars["String"]["input"]>
  enrolmentFailureMessageNRegex?: InputMaybe<Scalars["String"]["input"]>
  onboardingStatus?: InputMaybe<Scalars["json"]["input"]>
  brokers?: InputMaybe<Scalars["json"]["input"]>
}>

export type GetEnrolmentsByBrokerQuery = {
  __typename?: "query_root"
  enrolments_grouped_by_broker: Array<{
    __typename?: "enrolments_grouped_by_broker_model"
    broker?: string | null
    count?: any | null
  }>
}

export type GetExternalEmailTemplateByIdQueryVariables = Exact<{
  id: Scalars["bigint"]["input"]
}>

export type GetExternalEmailTemplateByIdQuery = {
  __typename?: "query_root"
  email_templates_ext: Array<{
    __typename?: "email_templates_ext"
    id: any
    name: string
    subject: string
    sender: any
    version: number
    reply_to_address?: string | null
    body: string
    created_at: any
    updated_at: any
  }>
}

export type GetExternalEmailTemplatesQueryVariables = Exact<{
  [key: string]: never
}>

export type GetExternalEmailTemplatesQuery = {
  __typename?: "query_root"
  email_templates_ext: Array<{
    __typename?: "email_templates_ext"
    id: any
    name: string
    subject: string
    sender: any
    version: number
    reply_to_address?: string | null
    created_at: any
    updated_at: any
  }>
}

export type GetFindTestAccountsQueryVariables = Exact<{ [key: string]: never }>

export type GetFindTestAccountsQuery = {
  __typename?: "query_root"
  find_test_accounts: Array<{
    __typename?: "find_test_accounts"
    billing_acc_id?: any | null
    inside_renewal_window?: boolean | null
    is_active_agreement?: boolean | null
    is_seasonal?: boolean | null
    multi_meterpoints?: boolean | null
    account_num?: string | null
    fuel_type?: string | null
    latest_status?: string | null
    to_date?: any | null
  }>
}

export type GetGasTradesQueryVariables = Exact<{ [key: string]: never }>

export type GetGasTradesQuery = {
  __typename?: "query_root"
  GasTrades: Array<{
    __typename?: "GasTrades"
    ConfirmSignedBy?: string | null
    ConfirmSignedDate?: any | null
    CounterParty?: string | null
    Date?: any | null
    Date_From?: any | null
    id: number
    Trader?: string | null
    Volume?: number | null
    Price?: number | null
    Period?: string | null
    Index?: string | null
    Date_To?: any | null
    Notes?: string | null
    Locked: boolean
    ConfirmReceived?: any | null
  }>
}

export type GetGasTradesHistoryQueryVariables = Exact<{ [key: string]: never }>

export type GetGasTradesHistoryQuery = {
  __typename?: "query_root"
  GasTradesHistory: Array<{
    __typename?: "GasTradesHistory"
    ConfirmReceived?: any | null
    ConfirmSignedBy?: string | null
    ConfirmSignedDate?: any | null
    CounterParty?: string | null
    Date?: any | null
    Date_From?: any | null
    id: number
    Trader?: string | null
    Volume?: number | null
    Price?: number | null
    Period?: string | null
    Index?: string | null
    Date_To?: any | null
    Notes?: string | null
    gas_trade_id: number
  }>
}

export type GetInstallCodesQueryVariables = Exact<{
  search?: InputMaybe<Scalars["String"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  orderBy?: InputMaybe<Array<Install_Codes_Order_By> | Install_Codes_Order_By>
  asnDate?: InputMaybe<Date_Comparison_Exp>
  asnOutcome?: InputMaybe<String_Comparison_Exp>
  comment?: InputMaybe<String_Comparison_Exp>
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>
  installCode?: InputMaybe<String_Comparison_Exp>
  lastDateChecked?: InputMaybe<Date_Comparison_Exp>
  mapId?: InputMaybe<String_Comparison_Exp>
  mapName?: InputMaybe<String_Comparison_Exp>
  requestedDate?: InputMaybe<Date_Comparison_Exp>
  msn?: InputMaybe<String_Comparison_Exp>
  today?: InputMaybe<Scalars["timestamp"]["input"]>
}>

export type GetInstallCodesQuery = {
  __typename?: "query_root"
  install_codes: Array<{
    __typename?: "install_codes"
    asn_date?: any | null
    asn_outcome?: string | null
    comment?: string | null
    created_at: any
    device_id?: string | null
    id: any
    install_code?: string | null
    last_date_checked?: any | null
    map_id?: string | null
    map_name?: string | null
    msn: string
    requested_date?: any | null
    updated_at: any
    meter?: {
      __typename?: "meter"
      type: any
      meter_meter_point_rels: Array<{
        __typename?: "meter_meter_point_rel"
        meter_point: { __typename?: "meter_point"; identifier: string }
      }>
    } | null
  }>
  install_codes_aggregate: {
    __typename?: "install_codes_aggregate"
    aggregate?: {
      __typename?: "install_codes_aggregate_fields"
      count: number
    } | null
  }
}

export type GetInstallCodesExtraQueryVariables = Exact<{
  search?: InputMaybe<Scalars["String"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  orderBy?: InputMaybe<Array<Install_Codes_Order_By> | Install_Codes_Order_By>
  asnDate?: InputMaybe<Date_Comparison_Exp>
  asnOutcome?: InputMaybe<String_Comparison_Exp>
  comment?: InputMaybe<String_Comparison_Exp>
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>
  installCode?: InputMaybe<String_Comparison_Exp>
  lastDateChecked?: InputMaybe<Date_Comparison_Exp>
  mapId?: InputMaybe<String_Comparison_Exp>
  mapName?: InputMaybe<String_Comparison_Exp>
  requestedDate?: InputMaybe<Date_Comparison_Exp>
  msn?: InputMaybe<String_Comparison_Exp>
  today?: InputMaybe<Scalars["timestamp"]["input"]>
}>

export type GetInstallCodesExtraQuery = {
  __typename?: "query_root"
  install_codes: Array<{
    __typename?: "install_codes"
    asn_date?: any | null
    asn_outcome?: string | null
    comment?: string | null
    created_at: any
    device_id?: string | null
    id: any
    install_code?: string | null
    last_date_checked?: any | null
    map_id?: string | null
    map_name?: string | null
    msn: string
    requested_date?: any | null
    updated_at: any
    meter?: {
      __typename?: "meter"
      type: any
      meter_meter_point_rels: Array<{
        __typename?: "meter_meter_point_rel"
        meter_point: { __typename?: "meter_point"; identifier: string }
      }>
    } | null
    cs_dashboard?: {
      __typename?: "cs__soe_dashboard_total"
      gbcs_version?: string | null
      manufacturer?: string | null
      model?: string | null
      smets_version?: string | null
      firmware_version?: string | null
      mpxn?: string | null
    } | null
  }>
  install_codes_aggregate: {
    __typename?: "install_codes_aggregate"
    aggregate?: {
      __typename?: "install_codes_aggregate_fields"
      count: number
    } | null
  }
}

export type GetInstallCodesSummaryQueryVariables = Exact<{
  asnExpiryDate?: InputMaybe<Scalars["date"]["input"]>
}>

export type GetInstallCodesSummaryQuery = {
  __typename?: "query_root"
  total: {
    __typename?: "install_codes_aggregate"
    aggregate?: {
      __typename?: "install_codes_aggregate_fields"
      count: number
    } | null
  }
  install_codes_count: {
    __typename?: "install_codes_aggregate"
    aggregate?: {
      __typename?: "install_codes_aggregate_fields"
      count: number
    } | null
  }
  missing_asn_count: {
    __typename?: "install_codes_aggregate"
    aggregate?: {
      __typename?: "install_codes_aggregate_fields"
      count: number
    } | null
  }
  expiring_asn_count: {
    __typename?: "install_codes_aggregate"
    aggregate?: {
      __typename?: "install_codes_aggregate_fields"
      count: number
    } | null
  }
  missing_asn_msns: Array<{
    __typename?: "install_codes"
    install_code?: string | null
    asn_outcome?: string | null
    msn: string
  }>
  expiring_asn_msns: Array<{ __typename?: "install_codes"; msn: string }>
}

export type SearchFreshdeskContactsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars["Int"]["input"]>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  search?: InputMaybe<Scalars["String"]["input"]>
}>

export type SearchFreshdeskContactsQuery = {
  __typename?: "query_root"
  freshdesk_contact: Array<{
    __typename?: "freshdesk_contact"
    external_id?: any | null
    account_number?: string | null
    id?: any | null
    raw_data?: any | null
    type?: string | null
  }>
  freshdesk_contact_aggregate: {
    __typename?: "freshdesk_contact_aggregate"
    aggregate?: {
      __typename?: "freshdesk_contact_aggregate_fields"
      count: number
    } | null
  }
}

export type GetFreshdeskContactQueryVariables = Exact<{
  contactId?: InputMaybe<Scalars["bigint"]["input"]>
}>

export type GetFreshdeskContactQuery = {
  __typename?: "query_root"
  freshdesk_contact: Array<{
    __typename?: "freshdesk_contact"
    external_id?: any | null
    account_number?: string | null
    id?: any | null
    raw_data?: any | null
    type?: string | null
  }>
}

export type GetMetersByMpxnMsnQueryVariables = Exact<{
  mpxn?: InputMaybe<Scalars["String"]["input"]>
  msn?: InputMaybe<Scalars["String"]["input"]>
  today?: InputMaybe<Scalars["timestamp"]["input"]>
}>

export type GetMetersByMpxnMsnQuery = {
  __typename?: "query_root"
  meter: Array<{
    __typename?: "meter"
    type: any
    identifier: string
    meter_meter_point_rels: Array<{
      __typename?: "meter_meter_point_rel"
      meter_point: { __typename?: "meter_point"; identifier: string }
    }>
  }>
}

export type GetOutboundPhotoRequestQueryVariables = Exact<{
  accountNumber: Scalars["String"]["input"]
}>

export type GetOutboundPhotoRequestQuery = {
  __typename?: "query_root"
  active_outbound_photo_request: Array<{
    __typename?: "active_outbound_photo_request"
    created_at?: any | null
    freshdesk_ticket_id?: any | null
    fuel?: any | null
    request_reason?: string | null
    freshdesk_group_name?: string | null
    status?: any | null
    last_email_sent_at?: any | null
    id?: any | null
  }>
}

export type GetPaymentReviewIdsQueryVariables = Exact<{ [key: string]: never }>

export type GetPaymentReviewIdsQuery = {
  __typename?: "query_root"
  payment_reviews: Array<{
    __typename?: "payment_reviews"
    type: any
    name: string
    id: any
  }>
}

export type GetPaymentReviewLatestIdQueryVariables = Exact<{
  [key: string]: never
}>

export type GetPaymentReviewLatestIdQuery = {
  __typename?: "query_root"
  payment_reviews_aggregate: {
    __typename?: "payment_reviews_aggregate"
    aggregate?: {
      __typename?: "payment_reviews_aggregate_fields"
      max?: {
        __typename?: "payment_reviews_max_fields"
        id?: any | null
      } | null
    } | null
  }
}

export type GetPaymentReviewRecordQueryVariables = Exact<{
  paymentReviewId: Scalars["bigint"]["input"]
}>

export type GetPaymentReviewRecordQuery = {
  __typename?: "query_root"
  payment_review_records_by_pk?: {
    __typename?: "payment_review_records"
    id: any
    payment_schedule_period_amount?: any | null
    next_payment_date?: any | null
    last_retry_time?: any | null
    payment_review_calculations: Array<{
      __typename?: "payment_review_calculation"
      account_balance_applied?: any | null
      account_balance?: any | null
      estimate_annual_cost?: any | null
      new_monthly_amount: any
      calculation_items: Array<{
        __typename?: "calculation_items"
        gsp_code: string
        product_code?: string | null
        product_rate_1?: any | null
        product_rate_2?: any | null
        product_standing_rate?: any | null
        product_type: any
        rate_type: any
        item_cost?: any | null
        meterpoint_eac_1?: any | null
        meterpoint_eac_2?: any | null
        direct_debit: boolean
      }>
    }>
  } | null
}

export type GetPaymentReviewRecordsDownloadFileQueryVariables = Exact<{
  changed_amount_max?: InputMaybe<Scalars["String"]["input"]>
  changed_amount_min?: InputMaybe<Scalars["String"]["input"]>
  changed_percentage_max?: InputMaybe<Scalars["String"]["input"]>
  to?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  payment_review_id?: InputMaybe<Scalars["BigInt"]["input"]>
  notes_status?: InputMaybe<Scalars["String"]["input"]>
  next_payment_date_to?: InputMaybe<Scalars["String"]["input"]>
  next_payment_date_from?: InputMaybe<Scalars["String"]["input"]>
  from?: InputMaybe<Scalars["String"]["input"]>
  error_codes?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >
  email_status?: InputMaybe<Scalars["String"]["input"]>
  changed_percentage_min?: InputMaybe<Scalars["String"]["input"]>
}>

export type GetPaymentReviewRecordsDownloadFileQuery = {
  __typename?: "query_root"
  action_payment_review_records_download?: {
    __typename?: "PaymentReviewRecordsDownloadResponse"
    file_url: string
  } | null
}

export type GetPaymentReviewRecordsQueryVariables = Exact<{
  limit: Scalars["Int"]["input"]
  offset: Scalars["Int"]["input"]
  paymentReviewId: Scalars["bigint"]["input"]
  orderBy?: InputMaybe<
    | Array<Payment_Review_Records_View_Order_By>
    | Payment_Review_Records_View_Order_By
  >
  status?: InputMaybe<Payment_Review_Record_Status_Comparison_Exp>
  failureErrorCode?: InputMaybe<String_Comparison_Exp>
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>
  nextPaymentDate?: InputMaybe<Date_Comparison_Exp>
  changedAmount?: InputMaybe<Numeric_Comparison_Exp>
  lastRetryDate?: InputMaybe<Timestamptz_Comparison_Exp>
}>

export type GetPaymentReviewRecordsQuery = {
  __typename?: "query_root"
  payment_review_records_view: Array<{
    __typename?: "payment_review_records_view"
    id?: any | null
    account_number?: string | null
    status?: any | null
    failure_error_code?: string | null
    created_at?: any | null
    payment_schedule_period_amount?: any | null
    new_monthly_amount?: any | null
    next_payment_date?: any | null
    changed_amount?: any | null
    change_percentage?: any | null
    account_balance?: any | null
    estimate_annual_cost?: any | null
    last_retry_time?: any | null
  }>
  payment_review_records_view_aggregate: {
    __typename?: "payment_review_records_view_aggregate"
    aggregate?: {
      __typename?: "payment_review_records_view_aggregate_fields"
      count: number
    } | null
  }
  active_failure_reasons: Array<{
    __typename?: "payment_review_records_view"
    failure_error_code?: string | null
  }>
}

export type GetPaymentReviewSummaryQueryVariables = Exact<{
  paymentReviewId: Scalars["bigint"]["input"]
}>

export type GetPaymentReviewSummaryQuery = {
  __typename?: "query_root"
  completed: {
    __typename?: "payment_review_records_view_aggregate"
    aggregate?: {
      __typename?: "payment_review_records_view_aggregate_fields"
      count: number
    } | null
  }
  failed: {
    __typename?: "payment_review_records_view_aggregate"
    aggregate?: {
      __typename?: "payment_review_records_view_aggregate_fields"
      count: number
    } | null
  }
  skipped: {
    __typename?: "payment_review_records_view_aggregate"
    aggregate?: {
      __typename?: "payment_review_records_view_aggregate_fields"
      count: number
    } | null
  }
  total: {
    __typename?: "payment_review_records_view_aggregate"
    aggregate?: {
      __typename?: "payment_review_records_view_aggregate_fields"
      count: number
    } | null
  }
}

export type GetProductsQueryVariables = Exact<{ [key: string]: never }>

export type GetProductsQuery = {
  __typename?: "query_root"
  product_view: Array<{
    __typename?: "product_view"
    id?: any | null
    code?: string | null
    name?: string | null
    display_name?: string | null
    duration_value?: number | null
    direct_debit?: boolean | null
    available_to_public?: boolean | null
    active_for_enrolment?: boolean | null
    active_for_renewal?: boolean | null
    recommend_for_enrolment?: boolean | null
    recommend_for_renewal?: boolean | null
    requires_smart_charging?: boolean | null
  }>
}

export type GetRecentCustomerReferralsQueryVariables = Exact<{
  limit: Scalars["Int"]["input"]
}>

export type GetRecentCustomerReferralsQuery = {
  __typename?: "query_root"
  customer_referrals: Array<{
    __typename?: "customer_referrals"
    created_at: any
    referee: {
      __typename?: "customer"
      number: string
      billing_accounts: Array<{
        __typename?: "billing_account"
        number: string
      }>
      customer_user_rels: Array<{
        __typename?: "customer_user_rel"
        user_id: any
        user?: { __typename?: "users"; email: string } | null
      }>
    }
  }>
}

export type GetCreditCheckStatusQueryVariables = Exact<{
  accountNumber?: InputMaybe<Scalars["String"]["input"]>
}>

export type GetCreditCheckStatusQuery = {
  __typename?: "query_root"
  registration_credit_check: Array<{
    __typename?: "registration_credit_check"
    status: any
    account_number: string
  }>
}

export type GetRegistrationCreditChecksQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  orderBy?: InputMaybe<
    | Array<Registration_Credit_Check_Order_By>
    | Registration_Credit_Check_Order_By
  >
  search?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Credit_Check_Status_Comparison_Exp>
  deadline?: InputMaybe<Timestamp_Comparison_Exp>
}>

export type GetRegistrationCreditChecksQuery = {
  __typename?: "query_root"
  registration_credit_check_aggregate: {
    __typename?: "registration_credit_check_aggregate"
    aggregate?: {
      __typename?: "registration_credit_check_aggregate_fields"
      count: number
    } | null
  }
  registration_credit_check: Array<{
    __typename?: "registration_credit_check"
    id: any
    status: any
    first_name?: string | null
    last_name?: string | null
    account_number: string
    billing_account_id: any
    deposit_deadline_dt?: any | null
    deposit_paid_dt?: any | null
    date_of_birth?: any | null
    deposit_amount?: any | null
    created_dt: any
    registration_credit_check_registraion_credit_check_address: Array<{
      __typename?: "registration_credit_check_address"
      street1?: string | null
      postcode: string
      is_supply_address?: boolean | null
      billing_account_id: any
    }>
    registration_credit_check_billing_account?: {
      __typename?: "billing_account"
      closed?: any | null
      terminated?: any | null
      deleted?: any | null
      to_date?: any | null
      cancelled?: any | null
      id: any
      customer: {
        __typename?: "customer"
        customer_contacts: Array<{
          __typename?: "customer_contact"
          primary: boolean
          contact: { __typename?: "contact"; email?: string | null }
        }>
      }
    } | null
  }>
}

export type GetRegistrationCreditChecksByAccountNumberQueryVariables = Exact<{
  account_number?: InputMaybe<Scalars["String"]["input"]>
}>

export type GetRegistrationCreditChecksByAccountNumberQuery = {
  __typename?: "query_root"
  registration_credit_check: Array<{
    __typename?: "registration_credit_check"
    id: any
    status: any
    first_name?: string | null
    last_name?: string | null
    account_number: string
    deposit_deadline_dt?: any | null
    deposit_amount?: any | null
    deposit_paid_dt?: any | null
    created_dt: any
  }>
}

export type GetRenewalsByUserIdQueryVariables = Exact<{
  userId?: InputMaybe<Scalars["bigint"]["input"]>
}>

export type GetRenewalsByUserIdQuery = {
  __typename?: "query_root"
  renewal: Array<{
    __typename?: "renewal"
    id: any
    created_at: any
    uploaded_at?: any | null
    renewal_agreements: Array<{
      __typename?: "agreement"
      contents?: any | null
    }>
  }>
}

export type GetRtsMetersQueryVariables = Exact<{
  serialNumbers?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >
}>

export type GetRtsMetersQuery = {
  __typename?: "query_root"
  rts_meters_report_aggregate: {
    __typename?: "rts_meters_report_aggregate"
    aggregate?: {
      __typename?: "rts_meters_report_aggregate_fields"
      count: number
    } | null
  }
}

export type GetBeFinancialsJobsListQueryVariables = Exact<{
  [key: string]: never
}>

export type GetBeFinancialsJobsListQuery = {
  __typename?: "query_root"
  financials_qrtz_triggers: Array<{
    __typename?: "financials_qrtz_triggers"
    sched_name: string
    trigger_name: string
    trigger_group: string
  }>
  financials_qrtz_cron_triggers: Array<{
    __typename?: "financials_qrtz_cron_triggers"
    trigger_name: string
    trigger_group: string
    cron_expression: string
  }>
}

export type GetSmartChargingAccountsQueryVariables = Exact<{
  [key: string]: never
}>

export type GetSmartChargingAccountsQuery = {
  __typename?: "query_root"
  smart_charging: Array<{
    __typename?: "smart_charging"
    id: any
    billing_account_id: any
    axle_site_id?: string | null
    meter_point_id: any
    onboarded_at?: any | null
    offboarded_at?: any | null
    created_at: any
  }>
}

export type GetSmartChargingEligibilityChecksQueryVariables = Exact<{
  [key: string]: never
}>

export type GetSmartChargingEligibilityChecksQuery = {
  __typename?: "query_root"
  ev_tariff_eligibility_checks: Array<{
    __typename?: "ev_tariff_eligibility_checks"
    billing_account_id: any
    is_eligible_for_smart_charging?: boolean | null
    axle_charger_name?: string | null
    axle_ev_name?: string | null
  }>
}

export type GetSmartChargingWaitlistQueryVariables = Exact<{
  [key: string]: never
}>

export type GetSmartChargingWaitlistQuery = {
  __typename?: "query_root"
  ev_smart_tariff_waitlist: Array<{
    __typename?: "ev_smart_tariff_waitlist"
    billing_account_id: any
  }>
}

export type GetSmartMetersQueryVariables = Exact<{
  search?: InputMaybe<Scalars["String"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  limit?: InputMaybe<Scalars["Int"]["input"]>
  orderBy?: InputMaybe<
    Array<Cs__Soe_Dashboard_Total_Order_By> | Cs__Soe_Dashboard_Total_Order_By
  >
  lastReadDate?: InputMaybe<String_Comparison_Exp>
  installedDate?: InputMaybe<String_Comparison_Exp>
  deviceStatus?: InputMaybe<String_Comparison_Exp>
  alertDate?: InputMaybe<String_Comparison_Exp>
  alertStatuses?: InputMaybe<String_Comparison_Exp>
  alerts?: InputMaybe<String_Comparison_Exp>
  errorCodes?: InputMaybe<String_Comparison_Exp>
  errorStatuses?: InputMaybe<String_Comparison_Exp>
  lastOrchestrations?: InputMaybe<String_Comparison_Exp>
  orchestrationStatuses?: InputMaybe<String_Comparison_Exp>
  serviceRequests?: InputMaybe<String_Comparison_Exp>
  ssd?: InputMaybe<String_Comparison_Exp>
  firmwareStatuses?: InputMaybe<String_Comparison_Exp>
  firmwareVersions?: InputMaybe<String_Comparison_Exp>
  gbcsVersion?: InputMaybe<String_Comparison_Exp>
  manufacturers?: InputMaybe<String_Comparison_Exp>
  meterType?: InputMaybe<String_Comparison_Exp>
  models?: InputMaybe<String_Comparison_Exp>
  paymentModes?: InputMaybe<String_Comparison_Exp>
  regions?: InputMaybe<String_Comparison_Exp>
  smetsVersion?: InputMaybe<String_Comparison_Exp>
  variants?: InputMaybe<String_Comparison_Exp>
  workstreams?: InputMaybe<String_Comparison_Exp>
}>

export type GetSmartMetersQuery = {
  __typename?: "query_root"
  cs__soe_dashboard_total: Array<{
    __typename?: "cs__soe_dashboard_total"
    dev_status?: string | null
    error?: string | null
    error_status?: string | null
    installation_date?: string | null
    last_orchestration?: string | null
    meter_type?: string | null
    mpxn?: string | null
    msn?: string | null
    pk: any
    srv?: string | null
    latest_alert_code?: string | null
    latest_alert_status?: string | null
    latest_alert_date?: string | null
    last_reading?: string | null
    last_reading_date_time?: string | null
    device_id?: string | null
    firmware_status?: string | null
    firmware_version?: string | null
    gbcs_version?: string | null
    manufacturer?: string | null
    model?: string | null
    payment_mode?: string | null
    orchestration_status?: string | null
    region?: string | null
    smets_version?: string | null
    variant?: string | null
    ssd?: string | null
    workstream?: string | null
    comms_hub_id?: string | null
  }>
  cs__soe_dashboard_total_aggregate: {
    __typename?: "cs__soe_dashboard_total_aggregate"
    aggregate?: {
      __typename?: "cs__soe_dashboard_total_aggregate_fields"
      count: number
    } | null
  }
}

export type GetSmartMetersSummaryQueryVariables = Exact<{
  [key: string]: never
}>

export type GetSmartMetersSummaryQuery = {
  __typename?: "query_root"
  smart_meter_dashboard_workstream_summary: Array<{
    __typename?: "smart_meter_dashboard_order_by_workstream_model"
    workstream?: string | null
    count: any
  }>
}

export type GetSmartMeterColumnValuesQueryVariables = Exact<{
  [key: string]: never
}>

export type GetSmartMeterColumnValuesQuery = {
  __typename?: "query_root"
  cs__soe_dashboard_total: Array<{
    __typename?: "cs__soe_dashboard_total"
    error?: string | null
    error_status?: string | null
    firmware_status?: string | null
    firmware_version?: string | null
    gbcs_version?: string | null
    last_orchestration?: string | null
    latest_alert_code?: string | null
    latest_alert_status?: string | null
    manufacturer?: string | null
    model?: string | null
    orchestration_status?: string | null
    payment_mode?: string | null
    region?: string | null
    smets_version?: string | null
    srv?: string | null
    variant?: string | null
  }>
}

export type GetSmartMeterQueryVariables = Exact<{
  mpxn?: InputMaybe<Scalars["String"]["input"]>
}>

export type GetSmartMeterQuery = {
  __typename?: "query_root"
  cs__soe_dashboard_total: Array<{
    __typename?: "cs__soe_dashboard_total"
    last_reading?: string | null
    last_reading_date_time?: string | null
    installation_date?: string | null
    manufacturer?: string | null
    meter_type?: string | null
    model?: string | null
    firmware_status?: string | null
    ssd?: string | null
    payment_mode?: string | null
    workstream?: string | null
  }>
}

export type GetSmartMetersEligibleForExchangeQueryVariables = Exact<{
  meter_serial_numbers?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >
}>

export type GetSmartMetersEligibleForExchangeQuery = {
  __typename?: "query_root"
  smart_meters_eligible_for_exchange: Array<{
    __typename?: "smart_meters_eligible_for_exchange"
    meter_serial_number: string
    exchange_eligibility_reason?: string | null
  }>
}

export type GetUserQueryVariables = Exact<{
  id: Scalars["bigint"]["input"]
}>

export type GetUserQuery = {
  __typename?: "query_root"
  users_by_pk?: {
    __typename?: "users"
    id: any
    email: string
    first_name?: string | null
    locked?: any | null
    created_at: any
    sign_in_count: number
    current_sign_in_ip?: string | null
    customer_user_rels: Array<{
      __typename?: "customer_user_rel"
      customer_id: any
    }>
  } | null
}

export type GetUsersForAccountQueryVariables = Exact<{
  accountId: Scalars["bigint"]["input"]
}>

export type GetUsersForAccountQuery = {
  __typename?: "query_root"
  billing_account_by_pk?: {
    __typename?: "billing_account"
    customer_user_rels: Array<{
      __typename?: "customer_user_rel"
      user?: {
        __typename?: "users"
        id: any
        email: string
        first_name?: string | null
        locked?: any | null
        created_at: any
        sign_in_count: number
        current_sign_in_ip?: string | null
        deleted?: any | null
        customer_user_rels: Array<{
          __typename?: "customer_user_rel"
          customer_id: any
        }>
      } | null
    }>
  } | null
}

export type GetWarrantsAccountsQueryVariables = Exact<{
  limit: Scalars["Int"]["input"]
  offset: Scalars["Int"]["input"]
  where?: InputMaybe<Financials_Warrants_Accounts_Bool_Exp>
  orderBy?: InputMaybe<
    | Array<Financials_Warrants_Accounts_Order_By>
    | Financials_Warrants_Accounts_Order_By
  >
}>

export type GetWarrantsAccountsQuery = {
  __typename?: "query_root"
  financials_warrants_accounts: Array<{
    __typename?: "financials_warrants_accounts"
    id: any
    account_number: string
    status: any
    pause_start?: any | null
    created_at: any
    updated_at: any
    deleted_at?: any | null
    deleted_by_agent_email?: string | null
  }>
  financials_warrants_accounts_aggregate: {
    __typename?: "financials_warrants_accounts_aggregate"
    aggregate?: {
      __typename?: "financials_warrants_accounts_aggregate_fields"
      count: number
    } | null
  }
}

export type GetWarrantsAccountsHistoryQueryVariables = Exact<{
  limit: Scalars["Int"]["input"]
  offset: Scalars["Int"]["input"]
  where?: InputMaybe<Financials_Warrants_Accounts_History_Bool_Exp>
  orderBy?: InputMaybe<
    | Array<Financials_Warrants_Accounts_History_Order_By>
    | Financials_Warrants_Accounts_History_Order_By
  >
}>

export type GetWarrantsAccountsHistoryQuery = {
  __typename?: "query_root"
  financials_warrants_accounts_history: Array<{
    __typename?: "financials_warrants_accounts_history"
    id: any
    account_number: string
    status: any
    current_status?: any | null
    next_status?: any | null
    message?: string | null
    created_at: any
    updated_at: any
    deleted_at?: any | null
  }>
  financials_warrants_accounts_history_aggregate: {
    __typename?: "financials_warrants_accounts_history_aggregate"
    aggregate?: {
      __typename?: "financials_warrants_accounts_history_aggregate_fields"
      count: number
    } | null
  }
}

export type GetWarrantsAccountsWhitelistQueryVariables = Exact<{
  limit: Scalars["Int"]["input"]
  offset: Scalars["Int"]["input"]
  where?: InputMaybe<Financials_Warrants_Accounts_Whitelist_Bool_Exp>
  orderBy?: InputMaybe<
    | Array<Financials_Warrants_Accounts_Whitelist_Order_By>
    | Financials_Warrants_Accounts_Whitelist_Order_By
  >
}>

export type GetWarrantsAccountsWhitelistQuery = {
  __typename?: "query_root"
  financials_warrants_accounts_whitelist: Array<{
    __typename?: "financials_warrants_accounts_whitelist"
    id: any
    account_number: string
    created_at: any
    deleted_at?: any | null
  }>
  financials_warrants_accounts_whitelist_aggregate: {
    __typename?: "financials_warrants_accounts_whitelist_aggregate"
    aggregate?: {
      __typename?: "financials_warrants_accounts_whitelist_aggregate_fields"
      count: number
    } | null
  }
}

export type GetWarrantsCommunicationGroupsQueryVariables = Exact<{
  limit: Scalars["Int"]["input"]
  offset: Scalars["Int"]["input"]
  where?: InputMaybe<Financials_Warrants_Communication_Group_Bool_Exp>
  orderBy?: InputMaybe<
    | Array<Financials_Warrants_Communication_Group_Order_By>
    | Financials_Warrants_Communication_Group_Order_By
  >
}>

export type GetWarrantsCommunicationGroupsQuery = {
  __typename?: "query_root"
  financials_warrants_communication_group: Array<{
    __typename?: "financials_warrants_communication_group"
    id: any
    account_number: string
    status: any
    parent_status: any
    current_priority_level: number
    error_description?: string | null
    created_at: any
    deleted_at?: any | null
  }>
  financials_warrants_communication_group_aggregate: {
    __typename?: "financials_warrants_communication_group_aggregate"
    aggregate?: {
      __typename?: "financials_warrants_communication_group_aggregate_fields"
      count: number
    } | null
  }
}

export type GetWarrantsCommunicationsQueryVariables = Exact<{
  limit: Scalars["Int"]["input"]
  offset: Scalars["Int"]["input"]
  where?: InputMaybe<Financials_Warrants_Communications_Bool_Exp>
  orderBy?: InputMaybe<
    | Array<Financials_Warrants_Communications_Order_By>
    | Financials_Warrants_Communications_Order_By
  >
}>

export type GetWarrantsCommunicationsQuery = {
  __typename?: "query_root"
  financials_warrants_communications: Array<{
    __typename?: "financials_warrants_communications"
    id: any
    group_id: any
    comms_id?: string | null
    type: any
    delivery_status: any
    delivery_external_status?: string | null
    parent_priority_level: number
    error_description?: string | null
    created_at: any
    deleted_at?: any | null
  }>
  financials_warrants_communications_aggregate: {
    __typename?: "financials_warrants_communications_aggregate"
    aggregate?: {
      __typename?: "financials_warrants_communications_aggregate_fields"
      count: number
    } | null
  }
}

export type GetWarrantsDcaQueueQueryVariables = Exact<{
  limit: Scalars["Int"]["input"]
  offset: Scalars["Int"]["input"]
  where?: InputMaybe<Financials_Warrants_Dca_Queue_Bool_Exp>
  orderBy?: InputMaybe<
    | Array<Financials_Warrants_Dca_Queue_Order_By>
    | Financials_Warrants_Dca_Queue_Order_By
  >
}>

export type GetWarrantsDcaQueueQuery = {
  __typename?: "query_root"
  financials_warrants_dca_queue: Array<{
    __typename?: "financials_warrants_dca_queue"
    id: any
    account_number: string
    created_at: any
    processed_at?: any | null
    deleted_at?: any | null
  }>
  financials_warrants_dca_queue_aggregate: {
    __typename?: "financials_warrants_dca_queue_aggregate"
    aggregate?: {
      __typename?: "financials_warrants_dca_queue_aggregate_fields"
      count: number
    } | null
  }
}

export type GetWarrantsDcaTicketsQueryVariables = Exact<{
  limit: Scalars["Int"]["input"]
  offset: Scalars["Int"]["input"]
  where?: InputMaybe<Financials_Warrants_Dca_Tickets_Bool_Exp>
  orderBy?: InputMaybe<
    | Array<Financials_Warrants_Dca_Tickets_Order_By>
    | Financials_Warrants_Dca_Tickets_Order_By
  >
}>

export type GetWarrantsDcaTicketsQuery = {
  __typename?: "query_root"
  financials_warrants_dca_tickets: Array<{
    __typename?: "financials_warrants_dca_tickets"
    id: any
    account_number: string
    dca_type: any
    status: any
    type: any
    ticket_definition?: string | null
    ticket_id?: string | null
    ticket_step?: string | null
    created_at: any
    deleted_at?: any | null
  }>
  financials_warrants_dca_tickets_aggregate: {
    __typename?: "financials_warrants_dca_tickets_aggregate"
    aggregate?: {
      __typename?: "financials_warrants_dca_tickets_aggregate_fields"
      count: number
    } | null
  }
}

export type GetWarrantsFilesAccountsQueryVariables = Exact<{
  limit: Scalars["Int"]["input"]
  offset: Scalars["Int"]["input"]
  where?: InputMaybe<Financials_Warrants_Files_Account_Bool_Exp>
  orderBy?: InputMaybe<
    | Array<Financials_Warrants_Files_Account_Order_By>
    | Financials_Warrants_Files_Account_Order_By
  >
}>

export type GetWarrantsFilesAccountsQuery = {
  __typename?: "query_root"
  financials_warrants_files_account: Array<{
    __typename?: "financials_warrants_files_account"
    id: any
    account_number: string
    customer_name?: string | null
    dca_type: any
    file_type: any
    created_at: any
    deleted_at?: any | null
    job_id: any
    status: any
    error_message?: string | null
    retry_count: number
  }>
  financials_warrants_files_account_aggregate: {
    __typename?: "financials_warrants_files_account_aggregate"
    aggregate?: {
      __typename?: "financials_warrants_files_account_aggregate_fields"
      count: number
    } | null
  }
}

export type GetWarrantsFilesAccountsSummaryQueryVariables = Exact<{
  pendingWhere?: InputMaybe<Financials_Warrants_Files_Account_Bool_Exp>
  successWhere?: InputMaybe<Financials_Warrants_Files_Account_Bool_Exp>
  failedWhere?: InputMaybe<Financials_Warrants_Files_Account_Bool_Exp>
  returnsWhere?: InputMaybe<Financials_Warrants_Files_Account_Bool_Exp>
  cancellationWhere?: InputMaybe<Financials_Warrants_Files_Account_Bool_Exp>
}>

export type GetWarrantsFilesAccountsSummaryQuery = {
  __typename?: "query_root"
  total: {
    __typename?: "financials_warrants_files_account_aggregate"
    aggregate?: {
      __typename?: "financials_warrants_files_account_aggregate_fields"
      count: number
    } | null
  }
  pending: {
    __typename?: "financials_warrants_files_account_aggregate"
    aggregate?: {
      __typename?: "financials_warrants_files_account_aggregate_fields"
      count: number
    } | null
  }
  success: {
    __typename?: "financials_warrants_files_account_aggregate"
    aggregate?: {
      __typename?: "financials_warrants_files_account_aggregate_fields"
      count: number
    } | null
  }
  failed: {
    __typename?: "financials_warrants_files_account_aggregate"
    aggregate?: {
      __typename?: "financials_warrants_files_account_aggregate_fields"
      count: number
    } | null
  }
  returns: {
    __typename?: "financials_warrants_files_account_aggregate"
    aggregate?: {
      __typename?: "financials_warrants_files_account_aggregate_fields"
      count: number
    } | null
  }
  cancellation: {
    __typename?: "financials_warrants_files_account_aggregate"
    aggregate?: {
      __typename?: "financials_warrants_files_account_aggregate_fields"
      count: number
    } | null
  }
}

export type GetWarrantsFilesJobsQueryVariables = Exact<{
  limit: Scalars["Int"]["input"]
  offset: Scalars["Int"]["input"]
  where?: InputMaybe<Financials_Warrants_Files_Job_Bool_Exp>
  orderBy?: InputMaybe<
    | Array<Financials_Warrants_Files_Job_Order_By>
    | Financials_Warrants_Files_Job_Order_By
  >
}>

export type GetWarrantsFilesJobsQuery = {
  __typename?: "query_root"
  financials_warrants_files_job: Array<{
    __typename?: "financials_warrants_files_job"
    id: any
    status: any
    error_message?: string | null
    started_at: any
    ended_at?: any | null
    created_at: any
  }>
  financials_warrants_files_job_aggregate: {
    __typename?: "financials_warrants_files_job_aggregate"
    aggregate?: {
      __typename?: "financials_warrants_files_job_aggregate_fields"
      count: number
    } | null
  }
}

export type GetWarrantsFilesProcessedQueryVariables = Exact<{
  limit: Scalars["Int"]["input"]
  offset: Scalars["Int"]["input"]
  where?: InputMaybe<Financials_Warrants_Files_Processed_Bool_Exp>
  orderBy?: InputMaybe<
    | Array<Financials_Warrants_Files_Processed_Order_By>
    | Financials_Warrants_Files_Processed_Order_By
  >
}>

export type GetWarrantsFilesProcessedQuery = {
  __typename?: "query_root"
  financials_warrants_files_processed: Array<{
    __typename?: "financials_warrants_files_processed"
    id: any
    dca_type: any
    file_type: any
    folder: string
    file_name: string
    job_id?: any | null
    created_at: any
  }>
  financials_warrants_files_processed_aggregate: {
    __typename?: "financials_warrants_files_processed_aggregate"
    aggregate?: {
      __typename?: "financials_warrants_files_processed_aggregate_fields"
      count: number
    } | null
  }
}

export type GetWarrantsJobsQueryVariables = Exact<{
  limit: Scalars["Int"]["input"]
  offset: Scalars["Int"]["input"]
  where?: InputMaybe<Financials_Warrants_Job_Bool_Exp>
  orderBy?: InputMaybe<
    Array<Financials_Warrants_Job_Order_By> | Financials_Warrants_Job_Order_By
  >
}>

export type GetWarrantsJobsQuery = {
  __typename?: "query_root"
  financials_warrants_job: Array<{
    __typename?: "financials_warrants_job"
    id: any
    status: any
    message?: string | null
    started_at: any
    ended_at?: any | null
    created_at: any
    updated_at: any
    deleted_at?: any | null
  }>
  financials_warrants_job_aggregate: {
    __typename?: "financials_warrants_job_aggregate"
    aggregate?: {
      __typename?: "financials_warrants_job_aggregate_fields"
      count: number
    } | null
  }
}

export type MeterpointsByIdsQueryVariables = Exact<{
  meterpointIds?: InputMaybe<
    Array<Scalars["bigint"]["input"]> | Scalars["bigint"]["input"]
  >
}>

export type MeterpointsByIdsQuery = {
  __typename?: "query_root"
  meter_point: Array<{
    __typename?: "meter_point"
    identifier: string
    id: any
  }>
}

export type GetAccountCreditByCoreIdQueryVariables = Exact<{
  coreId: Scalars["bigint"]["input"]
}>

export type GetAccountCreditByCoreIdQuery = {
  __typename?: "query_root"
  account_credit: Array<{
    __typename?: "account_credit"
    account_credit_reason_name: string
    id: any
    created_user?: string | null
    reference?: string | null
    billing_account_transaction?: {
      __typename?: "billing_account_transaction"
      billing_account_id: any
      accepted_at?: any | null
      created_dttm?: any | null
      description?: string | null
      reference?: string | null
    } | null
  }>
}

export type GetUsersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  search?: InputMaybe<Scalars["String"]["input"]>
  orderBy?: InputMaybe<Array<Users_Order_By> | Users_Order_By>
}>

export type GetUsersQuery = {
  __typename?: "query_root"
  users: Array<{
    __typename?: "users"
    id: any
    email: string
    first_name?: string | null
    locked?: any | null
    created_at: any
    sign_in_count: number
    current_sign_in_ip?: string | null
    customer_user_rels: Array<{
      __typename?: "customer_user_rel"
      customer_id: any
    }>
  }>
  users_aggregate: {
    __typename?: "users_aggregate"
    aggregate?: { __typename?: "users_aggregate_fields"; count: number } | null
  }
}

export type GetMeterReadingsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
  search?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Meter_Reading_Submission_Request_Status_Comparison_Exp>
  from?: InputMaybe<Scalars["timestamp"]["input"]>
  to?: InputMaybe<Scalars["timestamp"]["input"]>
  errorCode?: InputMaybe<String_Comparison_Exp>
}>

export type GetMeterReadingsQuery = {
  __typename?: "query_root"
  nova_submissions: Array<{
    __typename?: "nova_submissions"
    created_at?: any | null
    id?: any | null
    status?: any | null
    submission_values?: any | null
    user_email?: string | null
    account_number?: string | null
    meter_point_identifier?: string | null
    debug_data?: any | null
    comment?: string | null
  }>
  nova_submissions_aggregate: {
    __typename?: "nova_submissions_aggregate"
    aggregate?: {
      __typename?: "nova_submissions_aggregate_fields"
      count: number
    } | null
  }
}

export type GetLastMeterReadingsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>
  offset?: InputMaybe<Scalars["Int"]["input"]>
}>

export type GetLastMeterReadingsQuery = {
  __typename?: "query_root"
  last_errored_submissions: Array<{
    __typename?: "last_errored_submissions"
    created_at?: any | null
    id?: any | null
    status?: any | null
    submission_values?: any | null
    user_email?: string | null
    account_number?: string | null
    meter_point_identifier?: string | null
    debug_data?: any | null
    comment?: string | null
  }>
  last_errored_submissions_aggregate: {
    __typename?: "last_errored_submissions_aggregate"
    aggregate?: {
      __typename?: "last_errored_submissions_aggregate_fields"
      count: number
    } | null
  }
}

export type GetMeterReadingsErrorsQueryVariables = Exact<{
  [key: string]: never
}>

export type GetMeterReadingsErrorsQuery = {
  __typename?: "query_root"
  nova_submissions: Array<{
    __typename?: "nova_submissions"
    error_code_1?: string | null
  }>
}

export type GetAutoSyncedAccountsCountQueryVariables = Exact<{
  [key: string]: never
}>

export type GetAutoSyncedAccountsCountQuery = {
  __typename?: "query_root"
  synchronized_accounts_aggregate: {
    __typename?: "synchronized_accounts_aggregate"
    aggregate?: {
      __typename?: "synchronized_accounts_aggregate_fields"
      count: number
    } | null
  }
}

export type GetJuniferAccountsQueryVariables = Exact<{
  limit: Scalars["Int"]["input"]
  offset: Scalars["Int"]["input"]
  where: Junifer__Account_Bool_Exp
  orderBy: Array<Junifer__Account_Order_By> | Junifer__Account_Order_By
}>

export type GetJuniferAccountsQuery = {
  __typename?: "query_root"
  accounts: Array<{
    __typename?: "junifer__Account"
    id: any
    number?: string | null
    fromDttm?: any | null
    toDttm?: any | null
    cancelledDttm?: any | null
    closedDttm?: any | null
    terminatedDttm?: any | null
    createdDttm?: any | null
    customer?: {
      __typename?: "junifer__Customer"
      number?: string | null
      name?: string | null
    } | null
    last_transaction?: {
      __typename?: "junifer__AccountTransaction"
      accountBalance?: any | null
    } | null
    synchronized_account?: {
      __typename?: "synchronized_accounts"
      id: any
      locked: boolean
    } | null
    billing_account?: {
      __typename?: "billing_account"
      id: any
      customer: {
        __typename?: "customer"
        customer_user_rels: Array<{
          __typename?: "customer_user_rel"
          user?: { __typename?: "users"; email: string; id: any } | null
        }>
      }
    } | null
  }>
  total: {
    __typename?: "junifer__Account_aggregate"
    aggregate?: {
      __typename?: "junifer__Account_aggregate_fields"
      count: number
    } | null
  }
}

export type GetSyncedAccountsNumbersQueryVariables = Exact<{
  where: Billing_Account_Bool_Exp
}>

export type GetSyncedAccountsNumbersQuery = {
  __typename?: "query_root"
  billing_account: Array<{ __typename?: "billing_account"; n: string }>
}

export type GetUserAccountNumbersQueryVariables = Exact<{
  email: Scalars["String"]["input"]
}>

export type GetUserAccountNumbersQuery = {
  __typename?: "query_root"
  users: Array<{
    __typename?: "users"
    r: Array<{
      __typename?: "customer_user_rel"
      c: {
        __typename?: "customer"
        b: Array<{ __typename?: "billing_account"; n: string }>
      }
    }>
  }>
}

export type GetMeterpointSupplyHistoryQueryVariables = Exact<{
  meterpointId: Scalars["bigint"]["input"]
}>

export type GetMeterpointSupplyHistoryQuery = {
  __typename?: "query_root"
  meter_point_history: Array<{
    __typename?: "meter_point_history"
    id: any
    meter_point_id: any
    status: any
    event_type: any
    created_at: any
    updated_at: any
    deleted?: any | null
  }>
}

export type SearchAccountsByMeterPointIdsQueryVariables = Exact<{
  meterPointIds: Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
}>

export type SearchAccountsByMeterPointIdsQuery = {
  __typename?: "query_root"
  billing_account_ids_with_meter_point_ids: Array<{
    __typename?: "billing_account_ids_with_meter_point_ids"
    id?: any | null
    meter_points?: Array<number> | null
  }>
}

export type SearchAccountsByPhoneOrEmailQueryVariables = Exact<{
  searchTerm: Scalars["String"]["input"]
  limit?: InputMaybe<Scalars["Int"]["input"]>
}>

export type SearchAccountsByPhoneOrEmailQuery = {
  __typename?: "query_root"
  contact: Array<{
    __typename?: "contact"
    id: any
    phone_number1?: string | null
    phone_number2?: string | null
    phone_number3?: string | null
    email?: string | null
    billing_account_contacts: Array<{
      __typename?: "billing_account_contact"
      billing_account: {
        __typename?: "billing_account"
        id: any
        number: string
        customer_id: any
      }
    }>
  }>
}

export type SearchAccountsByPostcodeQueryVariables = Exact<{
  postcode: Scalars["String"]["input"]
  limit?: InputMaybe<Scalars["Int"]["input"]>
}>

export type SearchAccountsByPostcodeQuery = {
  __typename?: "query_root"
  contact: Array<{
    __typename?: "contact"
    id: any
    address?: {
      __typename?: "customer_address"
      id: any
      postcode?: string | null
    } | null
    billing_account_contacts: Array<{
      __typename?: "billing_account_contact"
      billing_account: {
        __typename?: "billing_account"
        id: any
        number: string
        customer_id: any
      }
    }>
  }>
}

export type SearchAccountsBySurnameQueryVariables = Exact<{
  surnamePattern: Scalars["String"]["input"]
  limit?: InputMaybe<Scalars["Int"]["input"]>
}>

export type SearchAccountsBySurnameQuery = {
  __typename?: "query_root"
  customer: Array<{
    __typename?: "customer"
    id: any
    first_name: string
    last_name: string
    billing_accounts: Array<{
      __typename?: "billing_account"
      id: any
      number: string
      customer_id: any
    }>
  }>
}

export const InsertCancellationReasonDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InsertCancellationReason" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "billingAccountId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "bigint" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "channel" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "meterPointId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "numeric" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "details" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insert_cancellation_reasons_one" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "object" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "account_number" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "billingAccountId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "channel" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "channel" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "meter_point_id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "meterPointId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "detail" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "details" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InsertCancellationReasonMutation,
  InsertCancellationReasonMutationVariables
>
export const UpdateCallTraceAuditsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateCallTraceAudits" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "updates" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "call_trace_audit_updates" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "update_call_trace_audit_many" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updates" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "updates" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "returning" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "confirm_status" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCallTraceAuditsMutation,
  UpdateCallTraceAuditsMutationVariables
>
export const UpdateMeterReminderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateMeterReminder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accountNumber" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "isActive" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "update_reminder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "billing_account" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "number" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "_eq" },
                                  value: {
                                    kind: "Variable",
                                    name: {
                                      kind: "Name",
                                      value: "accountNumber",
                                    },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "_set" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "active" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "isActive" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "returning" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "active" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateMeterReminderMutation,
  UpdateMeterReminderMutationVariables
>
export const ConfirmElecTradeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ConfirmElecTrade" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "ConfirmReceivedDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "datetime" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "ConfirmSignedBy" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "ConfirmSignedDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "datetime" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "update_ElecTrades_by_pk" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pk_columns" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "_set" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "ConfirmRecievedDate" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ConfirmReceivedDate" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "ConfirmSignedBy" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ConfirmSignedBy" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "ConfirmSignedDate" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ConfirmSignedDate" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmElecTradeMutation,
  ConfirmElecTradeMutationVariables
>
export const ConfirmGasTradeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ConfirmGasTrade" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "ConfirmReceivedDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "datetime" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "ConfirmSignedBy" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "ConfirmSignedDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "datetime" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "update_GasTrades_by_pk" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pk_columns" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "_set" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "ConfirmRecieved" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ConfirmReceivedDate" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "ConfirmSignedBy" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ConfirmSignedBy" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "ConfirmSignedDate" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ConfirmSignedDate" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmGasTradeMutation,
  ConfirmGasTradeMutationVariables
>
export const DeleteUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "bigint" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "delete_admin_roles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "user_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "userId" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "affected_rows" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "delete_admin_passes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "user_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "userId" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "affected_rows" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "delete_refresh_tokens" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "user_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "userId" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "affected_rows" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "delete_password_reset_tokens" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "user_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "userId" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "affected_rows" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "delete_users" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "userId" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "affected_rows" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "delete_customer_user_rel" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "user_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "userId" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "affected_rows" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>
export const InsertElecNominationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InsertElecNominations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ElecNominations_insert_input" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insert_ElecNominations_one" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "object" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "if_matched" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "match_columns" },
                      value: { kind: "EnumValue", value: "date" },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "update_columns" },
                      value: {
                        kind: "ListValue",
                        values: [
                          { kind: "EnumValue", value: "Hour_1" },
                          { kind: "EnumValue", value: "Hour_10" },
                          { kind: "EnumValue", value: "Hour_11" },
                          { kind: "EnumValue", value: "Hour_12" },
                          { kind: "EnumValue", value: "Hour_13" },
                          { kind: "EnumValue", value: "Hour_14" },
                          { kind: "EnumValue", value: "Hour_15" },
                          { kind: "EnumValue", value: "Hour_16" },
                          { kind: "EnumValue", value: "Hour_17" },
                          { kind: "EnumValue", value: "Hour_18" },
                          { kind: "EnumValue", value: "Hour_19" },
                          { kind: "EnumValue", value: "Hour_2" },
                          { kind: "EnumValue", value: "Hour_20" },
                          { kind: "EnumValue", value: "Hour_21" },
                          { kind: "EnumValue", value: "Hour_22" },
                          { kind: "EnumValue", value: "Hour_23" },
                          { kind: "EnumValue", value: "Hour_24" },
                          { kind: "EnumValue", value: "Hour_25" },
                          { kind: "EnumValue", value: "Hour_3" },
                          { kind: "EnumValue", value: "Hour_4" },
                          { kind: "EnumValue", value: "Hour_5" },
                          { kind: "EnumValue", value: "Hour_6" },
                          { kind: "EnumValue", value: "Hour_7" },
                          { kind: "EnumValue", value: "Hour_8" },
                          { kind: "EnumValue", value: "Hour_9" },
                          { kind: "EnumValue", value: "updated_at" },
                          { kind: "EnumValue", value: "trader" },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "Hour_1" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_10" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_11" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_12" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_13" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_14" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_15" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_16" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_17" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_18" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_19" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_2" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_20" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_21" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_22" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_23" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_24" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_25" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_3" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_4" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_5" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_6" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_7" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_8" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_9" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "date" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                { kind: "Field", name: { kind: "Name", value: "trader" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InsertElecNominationsMutation,
  InsertElecNominationsMutationVariables
>
export const InsertElecTradeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InsertElecTrade" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ElecTrades_insert_input" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insert_ElecTrades_one" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "object" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "ConfirmReceivedDate" },
                  name: { kind: "Name", value: "ConfirmRecievedDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ConfirmSignedBy" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ConfirmSignedDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "Counterparty" },
                },
                { kind: "Field", name: { kind: "Name", value: "Date" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "Invoice_Date_From" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "Invoice_Date_To" },
                },
                { kind: "Field", name: { kind: "Name", value: "Notes" } },
                { kind: "Field", name: { kind: "Name", value: "Period" } },
                { kind: "Field", name: { kind: "Name", value: "Price" } },
                { kind: "Field", name: { kind: "Name", value: "Product" } },
                { kind: "Field", name: { kind: "Name", value: "Trader" } },
                { kind: "Field", name: { kind: "Name", value: "Volume" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "PercentOfBaseload" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InsertElecTradeMutation,
  InsertElecTradeMutationVariables
>
export const InsertElecTradeHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InsertElecTradeHistory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ElecTradesHistory_insert_input" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insert_ElecTradesHistory_one" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "object" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "elec_trade_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ConfirmReceivedDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ConfirmSignedBy" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ConfirmSignedDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "Counterparty" },
                },
                { kind: "Field", name: { kind: "Name", value: "Date" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "Invoice_Date_From" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "Invoice_Date_To" },
                },
                { kind: "Field", name: { kind: "Name", value: "Notes" } },
                { kind: "Field", name: { kind: "Name", value: "Period" } },
                { kind: "Field", name: { kind: "Name", value: "Price" } },
                { kind: "Field", name: { kind: "Name", value: "Product" } },
                { kind: "Field", name: { kind: "Name", value: "Trader" } },
                { kind: "Field", name: { kind: "Name", value: "Volume" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "PercentOfBaseload" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InsertElecTradeHistoryMutation,
  InsertElecTradeHistoryMutationVariables
>
export const InsertEmailTemplateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InsertEmailTemplate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "email_templates_insert_input" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insert_email_templates_one" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "object" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "communication_id" },
                },
                { kind: "Field", name: { kind: "Name", value: "version" } },
                { kind: "Field", name: { kind: "Name", value: "is_live" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InsertEmailTemplateMutation,
  InsertEmailTemplateMutationVariables
>
export const InsertEmailTemplateAsLiveDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InsertEmailTemplateAsLive" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "communicationId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "bigint" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "email_templates_insert_input" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "unset" },
            name: { kind: "Name", value: "update_email_templates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "communication_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "communicationId" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "is_live" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "_set" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "is_live" },
                      value: { kind: "BooleanValue", value: false },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "affected_rows" },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "inserted" },
            name: { kind: "Name", value: "insert_email_templates_one" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "object" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "communication_id" },
                },
                { kind: "Field", name: { kind: "Name", value: "version" } },
                { kind: "Field", name: { kind: "Name", value: "is_live" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "published_at" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InsertEmailTemplateAsLiveMutation,
  InsertEmailTemplateAsLiveMutationVariables
>
export const InsertGasTradeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InsertGasTrade" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GasTrades_insert_input" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insert_GasTrades_one" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "object" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "ConfirmReceived" },
                  name: { kind: "Name", value: "ConfirmRecieved" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ConfirmSignedBy" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ConfirmSignedDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "CounterParty" },
                },
                { kind: "Field", name: { kind: "Name", value: "Date" } },
                { kind: "Field", name: { kind: "Name", value: "Date_From" } },
                { kind: "Field", name: { kind: "Name", value: "Date_To" } },
                { kind: "Field", name: { kind: "Name", value: "Index" } },
                { kind: "Field", name: { kind: "Name", value: "Notes" } },
                { kind: "Field", name: { kind: "Name", value: "Period" } },
                { kind: "Field", name: { kind: "Name", value: "Price" } },
                { kind: "Field", name: { kind: "Name", value: "Trader" } },
                { kind: "Field", name: { kind: "Name", value: "Volume" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InsertGasTradeMutation,
  InsertGasTradeMutationVariables
>
export const InsertGasTradeHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InsertGasTradeHistory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GasTradesHistory_insert_input" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insert_GasTradesHistory_one" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "object" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ConfirmReceived" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ConfirmSignedBy" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ConfirmSignedDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "CounterParty" },
                },
                { kind: "Field", name: { kind: "Name", value: "Date" } },
                { kind: "Field", name: { kind: "Name", value: "Date_From" } },
                { kind: "Field", name: { kind: "Name", value: "Date_To" } },
                { kind: "Field", name: { kind: "Name", value: "Index" } },
                { kind: "Field", name: { kind: "Name", value: "Notes" } },
                { kind: "Field", name: { kind: "Name", value: "Period" } },
                { kind: "Field", name: { kind: "Name", value: "Price" } },
                { kind: "Field", name: { kind: "Name", value: "Trader" } },
                { kind: "Field", name: { kind: "Name", value: "Volume" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "gas_trade_id" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InsertGasTradeHistoryMutation,
  InsertGasTradeHistoryMutationVariables
>
export const MarkCreditCheckAsDepositPaidDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MarkCreditCheckAsDepositPaid" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "bigint" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "depositPaidDate" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "timestamp" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "depositAgent" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "update_registration_credit_check" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "_set" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: {
                        kind: "StringValue",
                        value: "DEPOSIT_PAID",
                        block: false,
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "deposit_paid_dt" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "depositPaidDate" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "deposit_agent" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "depositAgent" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "id" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "affected_rows" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkCreditCheckAsDepositPaidMutation,
  MarkCreditCheckAsDepositPaidMutationVariables
>
export const SetLiveEmailTemplateVersionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetLiveEmailTemplateVersion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "communicationId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "bigint" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "bigint" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "publishedAt" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "timestamptz" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "unset" },
            name: { kind: "Name", value: "update_email_templates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "communication_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "communicationId" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "is_live" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "_set" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "is_live" },
                      value: { kind: "BooleanValue", value: false },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "affected_rows" },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "setLive" },
            name: { kind: "Name", value: "update_email_templates_by_pk" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pk_columns" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "_set" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "is_live" },
                      value: { kind: "BooleanValue", value: true },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "published_at" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "publishedAt" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "is_live" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "published_at" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetLiveEmailTemplateVersionMutation,
  SetLiveEmailTemplateVersionMutationVariables
>
export const ToggleReferralSettingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ToggleReferralSetting" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "number" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "isWhitelisted" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "update_customer_setting" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "customers" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "number" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "_eq" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "number" },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "_set" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "referrals_enabled" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "isWhitelisted" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "affected_rows" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ToggleReferralSettingMutation,
  ToggleReferralSettingMutationVariables
>
export const UnlockElecTradeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UnlockElecTrade" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "update_ElecTrades_by_pk" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pk_columns" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "_set" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "Locked" },
                      value: { kind: "BooleanValue", value: false },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UnlockElecTradeMutation,
  UnlockElecTradeMutationVariables
>
export const UnlockGasTradeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UnlockGasTrade" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "update_GasTrades_by_pk" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pk_columns" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "_set" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "Locked" },
                      value: { kind: "BooleanValue", value: false },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UnlockGasTradeMutation,
  UnlockGasTradeMutationVariables
>
export const UpdateConfigurationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateConfigurations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "updates" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "configuration_updates" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "update_configuration_many" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updates" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "updates" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "affected_rows" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateConfigurationsMutation,
  UpdateConfigurationsMutationVariables
>
export const UpdateElecTradeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateElecTrade" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "Counterparty" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "Invoice_Date_From" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "datetime" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "Invoice_Date_To" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "datetime" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "Period" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "Price" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "Product" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "Volume" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "Notes" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "PercentOfBaseload" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "update_ElecTrades_by_pk" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pk_columns" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "_set" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "Counterparty" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "Counterparty" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "Invoice_Date_From" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "Invoice_Date_From" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "Invoice_Date_To" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "Invoice_Date_To" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "Period" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "Period" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "Price" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "Price" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "Product" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "Product" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "Volume" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "Volume" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "Locked" },
                      value: { kind: "BooleanValue", value: true },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "Notes" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "Notes" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "PercentOfBaseload" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "PercentOfBaseload" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateElecTradeMutation,
  UpdateElecTradeMutationVariables
>
export const UpdateGasTradeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateGasTrade" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "CounterParty" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "Date_From" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "datetime" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "Date_To" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "datetime" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "Index" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "Period" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "Price" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "Volume" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "Notes" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "update_GasTrades_by_pk" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "pk_columns" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "_set" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "CounterParty" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "CounterParty" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "Date_From" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "Date_From" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "Date_To" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "Date_To" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "Index" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "Index" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "Period" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "Period" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "Price" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "Price" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "Volume" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "Volume" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "Locked" },
                      value: { kind: "BooleanValue", value: true },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "Notes" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "Notes" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateGasTradeMutation,
  UpdateGasTradeMutationVariables
>
export const UpdateProductFlagsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateProductFlags" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "elec_updates" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "product_variant_elec_updates" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "gas_updates" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "product_variant_gas_updates" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "smart_charging_updates" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "product_elec_updates" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "update_product_variant_elec_many" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updates" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "elec_updates" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "affected_rows" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "update_product_variant_gas_many" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updates" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "gas_updates" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "affected_rows" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "update_product_elec_many" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updates" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "smart_charging_updates" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "affected_rows" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateProductFlagsMutation,
  UpdateProductFlagsMutationVariables
>
export const UpdateStatusAndCommentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateStatusAndComment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "submissionId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "bigint" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "meter_reading_submission_request_status",
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "comment" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "update_meter_reading_submission_request",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "_set" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "status" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "comment" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "comment" },
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "submissionId" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "affected_rows" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateStatusAndCommentMutation,
  UpdateStatusAndCommentMutationVariables
>
export const UpdateUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "bigint" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lockedAt" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "timestamp" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "update_users" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "userId" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "_set" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "email" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "email" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "locked" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "lockedAt" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "affected_rows" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>
export const UpdateUserPasswordDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateUserPassword" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "BigInt" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "password" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "passwordConfirmation" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "changeUserPassword" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "userChangePasswordInput" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "password" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "password" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "password_confirmation" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "passwordConfirmation" },
                      },
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUserPasswordMutation,
  UpdateUserPasswordMutationVariables
>
export const DeleteSynchronizedAccountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteSynchronizedAccount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "bigint" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "deleted_synchronized_account" },
            name: { kind: "Name", value: "delete_synchronized_accounts_by_pk" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "accountId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "juniferAccountId" },
                },
                { kind: "Field", name: { kind: "Name", value: "locked" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteSynchronizedAccountMutation,
  DeleteSynchronizedAccountMutationVariables
>
export const RetryPaymentReviewRecordsByIdsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "retryPaymentReviewRecordsByIds" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "BigInt" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "overrideIncreaseThreshold" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "ignoreAccountBalance" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "retryPaymentReviewRecordsById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "retryConfig" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "ids" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ids" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "overrideIncreaseThreshold",
                      },
                      value: {
                        kind: "Variable",
                        name: {
                          kind: "Name",
                          value: "overrideIncreaseThreshold",
                        },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "ignoreAccountBalance" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ignoreAccountBalance" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "enableDelay" },
                      value: { kind: "BooleanValue", value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "result" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RetryPaymentReviewRecordsByIdsMutation,
  RetryPaymentReviewRecordsByIdsMutationVariables
>
export const RetryPaymentReviewRecordsByFiltersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "retryPaymentReviewRecordsByFilters" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "paymentReviewId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "BigInt" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Filters" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "overrideIncreaseThreshold" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "ignoreAccountBalance" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "retryPaymentReviewRecordsByFilters" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "paymentReviewId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "paymentReviewId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "retryConfig" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "overrideIncreaseThreshold",
                      },
                      value: {
                        kind: "Variable",
                        name: {
                          kind: "Name",
                          value: "overrideIncreaseThreshold",
                        },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "ignoreAccountBalance" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ignoreAccountBalance" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "enableDelay" },
                      value: { kind: "BooleanValue", value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "result" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RetryPaymentReviewRecordsByFiltersMutation,
  RetryPaymentReviewRecordsByFiltersMutationVariables
>
export const ActionPaymentReviewRecordsDeleteByIdsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "actionPaymentReviewRecordsDeleteByIds" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "BigInt" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "action_payment_review_records_delete_by_ids",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "request" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "ids" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ids" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "result" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActionPaymentReviewRecordsDeleteByIdsMutation,
  ActionPaymentReviewRecordsDeleteByIdsMutationVariables
>
export const GetAccountCreditDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAccountCredit" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accountCreditId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "bigint" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "account_credit" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "accountCreditId" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "created_user" },
                },
                { kind: "Field", name: { kind: "Name", value: "reference" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAccountCreditQuery,
  GetAccountCreditQueryVariables
>
export const GetAccountNumbersByCoreIdsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAccountNumbersByCoreIds" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "coreIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "bigint" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "billing_account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_in" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "coreIds" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "number" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAccountNumbersByCoreIdsQuery,
  GetAccountNumbersByCoreIdsQueryVariables
>
export const GetAccountsByCustomerIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAccountsByCustomerId" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "bigint" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "billing_account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "customer_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "customerId" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "number" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAccountsByCustomerIdQuery,
  GetAccountsByCustomerIdQueryVariables
>
export const GetActiveDirectDebitAccountsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetActiveDirectDebitAccounts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "billingAccountIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "bigint" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "now" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "timestamp" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "payment_method" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "billing_account_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_in" },
                            value: {
                              kind: "Variable",
                              name: {
                                kind: "Name",
                                value: "billingAccountIds",
                              },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "type" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_in" },
                            value: {
                              kind: "ListValue",
                              values: [
                                {
                                  kind: "StringValue",
                                  value: "Direct Debit",
                                  block: false,
                                },
                                {
                                  kind: "StringValue",
                                  value: "Go Cardless Direct Debit",
                                  block: false,
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "StringValue",
                              value: "Active",
                              block: false,
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "from_dt" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_lte" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "now" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_and" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "_or" },
                                value: {
                                  kind: "ListValue",
                                  values: [
                                    {
                                      kind: "ObjectValue",
                                      fields: [
                                        {
                                          kind: "ObjectField",
                                          name: {
                                            kind: "Name",
                                            value: "to_dt",
                                          },
                                          value: {
                                            kind: "ObjectValue",
                                            fields: [
                                              {
                                                kind: "ObjectField",
                                                name: {
                                                  kind: "Name",
                                                  value: "_is_null",
                                                },
                                                value: {
                                                  kind: "BooleanValue",
                                                  value: true,
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: "ObjectValue",
                                      fields: [
                                        {
                                          kind: "ObjectField",
                                          name: {
                                            kind: "Name",
                                            value: "to_dt",
                                          },
                                          value: {
                                            kind: "ObjectValue",
                                            fields: [
                                              {
                                                kind: "ObjectField",
                                                name: {
                                                  kind: "Name",
                                                  value: "_gt",
                                                },
                                                value: {
                                                  kind: "Variable",
                                                  name: {
                                                    kind: "Name",
                                                    value: "now",
                                                  },
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "_or" },
                                value: {
                                  kind: "ListValue",
                                  values: [
                                    {
                                      kind: "ObjectValue",
                                      fields: [
                                        {
                                          kind: "ObjectField",
                                          name: {
                                            kind: "Name",
                                            value: "deleted",
                                          },
                                          value: {
                                            kind: "ObjectValue",
                                            fields: [
                                              {
                                                kind: "ObjectField",
                                                name: {
                                                  kind: "Name",
                                                  value: "_is_null",
                                                },
                                                value: {
                                                  kind: "BooleanValue",
                                                  value: true,
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: "ObjectValue",
                                      fields: [
                                        {
                                          kind: "ObjectField",
                                          name: {
                                            kind: "Name",
                                            value: "deleted",
                                          },
                                          value: {
                                            kind: "ObjectValue",
                                            fields: [
                                              {
                                                kind: "ObjectField",
                                                name: {
                                                  kind: "Name",
                                                  value: "_gt",
                                                },
                                                value: {
                                                  kind: "Variable",
                                                  name: {
                                                    kind: "Name",
                                                    value: "now",
                                                  },
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billing_account_id" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetActiveDirectDebitAccountsQuery,
  GetActiveDirectDebitAccountsQueryVariables
>
export const GetCallTraceAuditDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCallTraceAudit" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "juniferNumber" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "confirmStatus" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "call_trace_audit_confirmed_enum" },
          },
          defaultValue: {
            kind: "StringValue",
            value: "UNCONFIRMED",
            block: false,
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "gdprTypeExclude" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "call_trace_audit_gdpr_enum" },
          },
          defaultValue: { kind: "StringValue", value: "OTHER", block: false },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "call_trace_audit" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "account_number" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "juniferNumber" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "confirm_status" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "confirmStatus" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "gdpr_type" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_neq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "gdprTypeExclude" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account_number" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "confirm_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data_updated" },
                },
                { kind: "Field", name: { kind: "Name", value: "gdpr_type" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCallTraceAuditQuery,
  GetCallTraceAuditQueryVariables
>
export const GetCardPaymentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCardPayments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "externalId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "card_payments" },
            name: { kind: "Name", value: "card_payment_old" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "external_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "externalId" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "amount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "junifer_payment_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notification_error" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notification_status" },
                },
                { kind: "Field", name: { kind: "Name", value: "reference" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "error_code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "error_message" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCardPaymentsQuery,
  GetCardPaymentsQueryVariables
>
export const GetCasesByCoreIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCasesByCoreId" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "coreId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "bigint" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cases" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "billing_account_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "coreId" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "deleted_at" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_is_null" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "external_id" } },
                { kind: "Field", name: { kind: "Name", value: "fields" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCasesByCoreIdQuery,
  GetCasesByCoreIdQueryVariables
>
export const GetComplaintsForAccountNumberDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetComplaintsForAccountNumber" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accountNumber" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "complaint" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "details" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_contains" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: {
                                    kind: "Name",
                                    value: "billingAccountNumber",
                                  },
                                  value: {
                                    kind: "Variable",
                                    name: {
                                      kind: "Name",
                                      value: "accountNumber",
                                    },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "external_identifier" },
                },
                { kind: "Field", name: { kind: "Name", value: "customer_id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "category1" } },
                { kind: "Field", name: { kind: "Name", value: "category2" } },
                { kind: "Field", name: { kind: "Name", value: "category3" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internal_complaint_category" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "ofgem_mapped_complaint_category",
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "channel" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "team" } },
                { kind: "Field", name: { kind: "Name", value: "agent_name" } },
                { kind: "Field", name: { kind: "Name", value: "agent_email" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                { kind: "Field", name: { kind: "Name", value: "date_raised" } },
                { kind: "Field", name: { kind: "Name", value: "closed_at" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "sub_status" } },
                { kind: "Field", name: { kind: "Name", value: "deleted" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ombudsman_case" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "d1_signposting_comms_sent" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "d56_signposting_comms_sent" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "overdue_signposting_comms_sent",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "recent_signposting_comms_sent",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deadlock_comms_sent" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "send_date_of_d1_signposting_comms",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "send_date_of_d56_signposting_comms",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "send_date_of_overdue_signposting_comms",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "send_date_of_recent_signposting_comms",
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "details" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "complaints_goodwill_amount" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetComplaintsForAccountNumberQuery,
  GetComplaintsForAccountNumberQueryVariables
>
export const GetCoreIdByAccountNumberDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCoreIdByAccountNumber" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accountNumber" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "billing_account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "number" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "accountNumber" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCoreIdByAccountNumberQuery,
  GetCoreIdByAccountNumberQueryVariables
>
export const GetCustomerIdByAccountNumberDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCustomerIdByAccountNumber" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accountNumber" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "billing_account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "number" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "accountNumber" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "customer_id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCustomerIdByAccountNumberQuery,
  GetCustomerIdByAccountNumberQueryVariables
>
export const GetEmailContentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getEmailContent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "path" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getEmailContent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "path" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "path" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "emailBody" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetEmailContentQuery,
  GetEmailContentQueryVariables
>
export const GetEmailsByEmailAddressDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getEmailsByEmailAddress" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "recipients" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "100" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: { kind: "EnumValue", value: "desc" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "email" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "email" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "email_message" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subject" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "processed_at" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "opened" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "html_content" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetEmailsByEmailAddressQuery,
  GetEmailsByEmailAddressQueryVariables
>
export const GetFlexMarketSubscriptionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFlexMarketSubscriptions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "billingAccountId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "bigint" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "flex_market_subscription" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "billing_account_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "billingAccountId" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "deleted" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_is_null" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "onboarded_at" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meter_point" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifier" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offboarded_at" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFlexMarketSubscriptionsQuery,
  GetFlexMarketSubscriptionsQueryVariables
>
export const GetFreshdeskContactsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFreshdeskContacts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accountNumber" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "freshdesk_contact" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "account_number" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "accountNumber" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "external_id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "raw_data" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFreshdeskContactsQuery,
  GetFreshdeskContactsQueryVariables
>
export const GetFreshdeskTicketsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFreshdeskTickets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contactId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "freshdesk_ticket" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "requester_external_id",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_eq" },
                                      value: {
                                        kind: "Variable",
                                        name: {
                                          kind: "Name",
                                          value: "contactId",
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "responder_external_id",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_eq" },
                                      value: {
                                        kind: "Variable",
                                        name: {
                                          kind: "Name",
                                          value: "contactId",
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "external_id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "raw_data" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFreshdeskTicketsQuery,
  GetFreshdeskTicketsQueryVariables
>
export const GetReminderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetReminder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accountNumber" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reminder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "billing_account" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "number" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "_eq" },
                                  value: {
                                    kind: "Variable",
                                    name: {
                                      kind: "Name",
                                      value: "accountNumber",
                                    },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "active" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetReminderQuery, GetReminderQueryVariables>
export const GetTariffsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTariffs" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "gsp_group" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "current_future_product_details" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "available_to_public" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "gsp_group" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "gsp_group" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "smart_payg" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: { kind: "BooleanValue", value: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "from_dt" },
                          value: { kind: "EnumValue", value: "desc" },
                        },
                      ],
                    },
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "id" },
                          value: { kind: "EnumValue", value: "desc" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "gsp_group" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "display_name" },
                },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "direct_debit" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "duration_value" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "early_termination_charge" },
                },
                { kind: "Field", name: { kind: "Name", value: "export" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "charge_value" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tariff_rates" },
                },
                { kind: "Field", name: { kind: "Name", value: "vat_rate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "variant_type" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "bundle_dfn_group_code" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "bundle_df_type_name" },
                },
                { kind: "Field", name: { kind: "Name", value: "from_dt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "variant_from_dt" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTariffsQuery, GetTariffsQueryVariables>
export const SearchMeterPointsByIdentifierDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchMeterPointsByIdentifier" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "identifier" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          defaultValue: { kind: "IntValue", value: "100" },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meter_point" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "identifier" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_ilike" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "identifier" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchMeterPointsByIdentifierQuery,
  SearchMeterPointsByIdentifierQueryVariables
>
export const GetAdminEmailListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAdminEmailList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "processedAt" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "timestamptz_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "communicationName" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "email_messages" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "processed_at" },
                      value: { kind: "EnumValue", value: "desc" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "processed_at" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "processedAt" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "request" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "communication_name" },
                            value: {
                              kind: "Variable",
                              name: {
                                kind: "Name",
                                value: "communicationName",
                              },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "processed_at" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipient_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "request" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "communication_name" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "account_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customer_id" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "email_messages_aggregate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "processed_at" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "processedAt" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "request" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "communication_name" },
                            value: {
                              kind: "Variable",
                              name: {
                                kind: "Name",
                                value: "communicationName",
                              },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAdminEmailListQuery,
  GetAdminEmailListQueryVariables
>
export const GetAdminEmailTotalCountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAdminEmailTotalCount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "processedAt" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "timestamptz_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "communicationName" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "email_messages_aggregate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "processed_at" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "processedAt" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "request" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "communication_name" },
                            value: {
                              kind: "Variable",
                              name: {
                                kind: "Name",
                                value: "communicationName",
                              },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAdminEmailTotalCountQuery,
  GetAdminEmailTotalCountQueryVariables
>
export const GetAdminEmailChartDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAdminEmailChartData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "processedAt" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "timestamptz_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "communicationName" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "email_messages" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "processed_at" },
                      value: { kind: "EnumValue", value: "asc" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "processed_at" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "processedAt" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "request" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "communication_name" },
                            value: {
                              kind: "Variable",
                              name: {
                                kind: "Name",
                                value: "communicationName",
                              },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "processed_at" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "request" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "communication_name" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAdminEmailChartDataQuery,
  GetAdminEmailChartDataQueryVariables
>
export const GetAdminEmailTemplatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAdminEmailTemplates" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "requests" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "distinct_on" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "EnumValue", value: "communication_name" }],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "communication_name" },
                      value: { kind: "EnumValue", value: "asc" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "communication_name" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAdminEmailTemplatesQuery,
  GetAdminEmailTemplatesQueryVariables
>
export const GetAlpsRangeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAlpsRange" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "from1" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "date" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "to1" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "date" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "from2" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "date" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "to2" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "date" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "energy_usage_load_factors_aggregate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "date" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_gte" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "from1" },
                                      },
                                    },
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_lte" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "to1" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "date" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_gte" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "from2" },
                                      },
                                    },
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_lte" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "to2" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sum" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "electricity_r1" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAlpsRangeQuery, GetAlpsRangeQueryVariables>
export const GetBeFinancialsConfigHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetBeFinancialsConfigHistory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "financials_configuration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "name" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "name" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "created_at" },
                      value: { kind: "EnumValue", value: "desc" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "from_dttm" } },
                { kind: "Field", name: { kind: "Name", value: "to_dttm" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                { kind: "Field", name: { kind: "Name", value: "deleted" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "financials_configuration_aggregate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "name" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "name" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetBeFinancialsConfigHistoryQuery,
  GetBeFinancialsConfigHistoryQueryVariables
>
export const GetBeFinancialsConfigListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetBeFinancialsConfigList" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "financials_configuration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "name" },
                          value: { kind: "EnumValue", value: "asc" },
                        },
                      ],
                    },
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "desc" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "from_dttm" } },
                { kind: "Field", name: { kind: "Name", value: "to_dttm" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                { kind: "Field", name: { kind: "Name", value: "deleted" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetBeFinancialsConfigListQuery,
  GetBeFinancialsConfigListQueryVariables
>
export const GetBeFinancialsConfigStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetBeFinancialsConfigStats" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "now" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "timestamp" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "total" },
            name: { kind: "Name", value: "financials_configuration_aggregate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "active" },
            name: { kind: "Name", value: "financials_configuration_aggregate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "deleted" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_is_null" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "to_dttm" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_is_null" },
                                      value: {
                                        kind: "BooleanValue",
                                        value: true,
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "to_dttm" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_gt" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "now" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetBeFinancialsConfigStatsQuery,
  GetBeFinancialsConfigStatsQueryVariables
>
export const GetBlacklistedCustomersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetBlacklistedCustomers" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "billing_accounts" },
                      value: { kind: "ObjectValue", fields: [] },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "customer_setting" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "referrals_enabled" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "_eq" },
                                  value: { kind: "BooleanValue", value: false },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "customer_user_rels" },
                      value: { kind: "ObjectValue", fields: [] },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "number" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billing_accounts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer_user_rels" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer_referrals" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_at" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetBlacklistedCustomersQuery,
  GetBlacklistedCustomersQueryVariables
>
export const GetCancellationsByUserIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCancellationsByUserId" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "bigint" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancellations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "billing_account" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "customer" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: {
                                    kind: "Name",
                                    value: "customer_user_rels",
                                  },
                                  value: {
                                    kind: "ObjectValue",
                                    fields: [
                                      {
                                        kind: "ObjectField",
                                        name: {
                                          kind: "Name",
                                          value: "user_id",
                                        },
                                        value: {
                                          kind: "ObjectValue",
                                          fields: [
                                            {
                                              kind: "ObjectField",
                                              name: {
                                                kind: "Name",
                                                value: "_eq",
                                              },
                                              value: {
                                                kind: "Variable",
                                                name: {
                                                  kind: "Name",
                                                  value: "userId",
                                                },
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCancellationsByUserIdQuery,
  GetCancellationsByUserIdQueryVariables
>
export const GetCommunicationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCommunications" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "communications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "name" },
                      value: { kind: "EnumValue", value: "asc" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "communication_type" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCommunicationsQuery,
  GetCommunicationsQueryVariables
>
export const GetComplaintsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetComplaints" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "complaint_order_by" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateRaised" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "timestamp_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "channel" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "subStatus" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "category1" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "category2" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "category3" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "agentName" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "team" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "ofgemCategory" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "internalCategory" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orClauses" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "complaint_bool_exp" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "andClauses" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "complaint_bool_exp" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "complaint" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "date_raised" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dateRaised" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "status" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "channel" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "channel" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "type" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "type" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "sub_status" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "subStatus" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "category1" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "category1" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "category2" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "category2" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "category3" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "category3" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "agent_name" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "agentName" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "team" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "team" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "ofgem_mapped_complaint_category",
                      },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ofgemCategory" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "internal_complaint_category",
                      },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "internalCategory" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_and" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "andClauses" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_or" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "orClauses" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "deleted" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                { kind: "Field", name: { kind: "Name", value: "details" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "external_identifier" },
                },
                { kind: "Field", name: { kind: "Name", value: "customer_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ombudsman_case" },
                },
                { kind: "Field", name: { kind: "Name", value: "team" } },
                { kind: "Field", name: { kind: "Name", value: "agent_email" } },
                { kind: "Field", name: { kind: "Name", value: "agent_name" } },
                { kind: "Field", name: { kind: "Name", value: "channel" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "date_raised" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "sub_status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "d1_signposting_comms_sent" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "send_date_of_d1_signposting_comms",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "d56_signposting_comms_sent" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "send_date_of_d56_signposting_comms",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deadlock_comms_sent" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "ofgem_mapped_complaint_category",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internal_complaint_category" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "complaints_goodwill_amount" },
                },
                { kind: "Field", name: { kind: "Name", value: "category1" } },
                { kind: "Field", name: { kind: "Name", value: "category2" } },
                { kind: "Field", name: { kind: "Name", value: "category3" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "recent_signposting_comms_sent",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "overdue_signposting_comms_sent",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "send_date_of_recent_signposting_comms",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "send_date_of_overdue_signposting_comms",
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "closed_at" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "complaint_aggregate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "date_raised" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dateRaised" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "status" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "channel" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "channel" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "type" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "type" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "sub_status" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "subStatus" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "category1" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "category1" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "category2" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "category2" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "category3" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "category3" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "agent_name" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "agentName" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "team" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "team" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "ofgem_mapped_complaint_category",
                      },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ofgemCategory" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "internal_complaint_category",
                      },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "internalCategory" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_and" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "andClauses" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_or" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "orClauses" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetComplaintsQuery, GetComplaintsQueryVariables>
export const GetComplaintsSummaryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetComplaintsSummary" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "complaint_aggregations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "open" } },
                { kind: "Field", name: { kind: "Name", value: "ombudsman" } },
                { kind: "Field", name: { kind: "Name", value: "cab" } },
                { kind: "Field", name: { kind: "Name", value: "ehu" } },
                { kind: "Field", name: { kind: "Name", value: "exec" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "newer_than_5_weeks" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "older_than_5_weeks" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetComplaintsSummaryQuery,
  GetComplaintsSummaryQueryVariables
>
export const GetComplaintColumnValuesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getComplaintColumnValues" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "complaint" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "distinct_on" },
                value: {
                  kind: "ListValue",
                  values: [
                    { kind: "EnumValue", value: "channel" },
                    { kind: "EnumValue", value: "type" },
                    { kind: "EnumValue", value: "team" },
                    { kind: "EnumValue", value: "status" },
                    { kind: "EnumValue", value: "sub_status" },
                    { kind: "EnumValue", value: "category1" },
                    { kind: "EnumValue", value: "category2" },
                    { kind: "EnumValue", value: "category3" },
                    { kind: "EnumValue", value: "agent_name" },
                    {
                      kind: "EnumValue",
                      value: "ofgem_mapped_complaint_category",
                    },
                    { kind: "EnumValue", value: "internal_complaint_category" },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "channel" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "team" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "sub_status" } },
                { kind: "Field", name: { kind: "Name", value: "category1" } },
                { kind: "Field", name: { kind: "Name", value: "category2" } },
                { kind: "Field", name: { kind: "Name", value: "category3" } },
                { kind: "Field", name: { kind: "Name", value: "agent_name" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "ofgem_mapped_complaint_category",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "internal_complaint_category" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetComplaintColumnValuesQuery,
  GetComplaintColumnValuesQueryVariables
>
export const GetConfigurationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetConfiguration" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "configuration_name" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "now" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "timestamp" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "configuration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "name" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "name" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "to_dt" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_is_null" },
                                      value: {
                                        kind: "BooleanValue",
                                        value: true,
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "to_dt" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_gte" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "now" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetConfigurationQuery,
  GetConfigurationQueryVariables
>
export const GetConfigurationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetConfigurations" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "configuration" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "editable" } },
                { kind: "Field", name: { kind: "Name", value: "from_dt" } },
                { kind: "Field", name: { kind: "Name", value: "to_dt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetConfigurationsQuery,
  GetConfigurationsQueryVariables
>
export const GetCustomerReferralDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCustomerReferral" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "bigint" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customer_referrals" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "referred_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "customerId" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "referee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customer_user_rels" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "customer" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "number" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "billing_accounts",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "number",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "customer_referrals",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "created_at",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "customer_user_rels",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "user_id",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCustomerReferralQuery,
  GetCustomerReferralQueryVariables
>
export const GetCustomerReferralDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCustomerReferralDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "customerNumber" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "number" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "customerNumber" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "number" } },
                { kind: "Field", name: { kind: "Name", value: "first_name" } },
                { kind: "Field", name: { kind: "Name", value: "last_name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer_user_rels" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer_setting" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "referrals_enabled" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billing_accounts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "billing_account_contacts",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "contact" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "address" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "address1",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "address2",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "address3",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "postcode",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "country_code",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer_referrals" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "credit" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "referred" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "first_name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last_name" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "customer_user_rels",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "user_id" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCustomerReferralDetailsQuery,
  GetCustomerReferralDetailsQueryVariables
>
export const GetCustomersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCustomers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "search" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "customer_order_by" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_and" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "customer_contacts",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "contact" },
                                      value: {
                                        kind: "ObjectValue",
                                        fields: [
                                          {
                                            kind: "ObjectField",
                                            name: {
                                              kind: "Name",
                                              value: "email",
                                            },
                                            value: {
                                              kind: "ObjectValue",
                                              fields: [
                                                {
                                                  kind: "ObjectField",
                                                  name: {
                                                    kind: "Name",
                                                    value: "_ilike",
                                                  },
                                                  value: {
                                                    kind: "Variable",
                                                    name: {
                                                      kind: "Name",
                                                      value: "search",
                                                    },
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "customer_contacts",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "primary" },
                                      value: {
                                        kind: "ObjectValue",
                                        fields: [
                                          {
                                            kind: "ObjectField",
                                            name: {
                                              kind: "Name",
                                              value: "_eq",
                                            },
                                            value: {
                                              kind: "BooleanValue",
                                              value: true,
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "number" } },
                { kind: "Field", name: { kind: "Name", value: "first_name" } },
                { kind: "Field", name: { kind: "Name", value: "last_name" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer_contacts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "primary" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contact" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billing_accounts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customer_aggregate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_and" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "customer_contacts",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "contact" },
                                      value: {
                                        kind: "ObjectValue",
                                        fields: [
                                          {
                                            kind: "ObjectField",
                                            name: {
                                              kind: "Name",
                                              value: "email",
                                            },
                                            value: {
                                              kind: "ObjectValue",
                                              fields: [
                                                {
                                                  kind: "ObjectField",
                                                  name: {
                                                    kind: "Name",
                                                    value: "_ilike",
                                                  },
                                                  value: {
                                                    kind: "Variable",
                                                    name: {
                                                      kind: "Name",
                                                      value: "search",
                                                    },
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "customer_contacts",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "primary" },
                                      value: {
                                        kind: "ObjectValue",
                                        fields: [
                                          {
                                            kind: "ObjectField",
                                            name: {
                                              kind: "Name",
                                              value: "_eq",
                                            },
                                            value: {
                                              kind: "BooleanValue",
                                              value: true,
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCustomersQuery, GetCustomersQueryVariables>
export const GetDcaConfigurationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDcaConfiguration" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "tickets_dca_configuration_v2" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "dca" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "junifer_ticket_definition" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetDcaConfigurationQuery,
  GetDcaConfigurationQueryVariables
>
export const GetElecNominationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetElecNominations" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ElecNominations" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "Hour_1" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_10" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_11" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_12" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_13" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_14" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_15" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_16" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_17" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_18" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_19" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_2" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_20" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_21" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_22" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_23" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_24" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_25" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_3" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_4" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_5" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_6" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_7" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_8" } },
                { kind: "Field", name: { kind: "Name", value: "Hour_9" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "date" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                { kind: "Field", name: { kind: "Name", value: "trader" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetElecNominationsQuery,
  GetElecNominationsQueryVariables
>
export const GetElecTradesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetElecTrades" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ElecTrades" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "ConfirmReceivedDate" },
                  name: { kind: "Name", value: "ConfirmRecievedDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ConfirmSignedBy" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ConfirmSignedDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "Counterparty" },
                },
                { kind: "Field", name: { kind: "Name", value: "Date" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "Invoice_Date_From" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "Invoice_Date_To" },
                },
                { kind: "Field", name: { kind: "Name", value: "Period" } },
                { kind: "Field", name: { kind: "Name", value: "Price" } },
                { kind: "Field", name: { kind: "Name", value: "Product" } },
                { kind: "Field", name: { kind: "Name", value: "Trader" } },
                { kind: "Field", name: { kind: "Name", value: "Notes" } },
                { kind: "Field", name: { kind: "Name", value: "Volume" } },
                { kind: "Field", name: { kind: "Name", value: "Locked" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "PercentOfBaseload" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetElecTradesQuery, GetElecTradesQueryVariables>
export const GetElecTradesHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetElecTradesHistory" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ElecTradesHistory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ConfirmReceivedDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ConfirmSignedBy" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ConfirmSignedDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "Counterparty" },
                },
                { kind: "Field", name: { kind: "Name", value: "Date" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "Invoice_Date_From" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "Invoice_Date_To" },
                },
                { kind: "Field", name: { kind: "Name", value: "Period" } },
                { kind: "Field", name: { kind: "Name", value: "Price" } },
                { kind: "Field", name: { kind: "Name", value: "Product" } },
                { kind: "Field", name: { kind: "Name", value: "Trader" } },
                { kind: "Field", name: { kind: "Name", value: "Notes" } },
                { kind: "Field", name: { kind: "Name", value: "Volume" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "elec_trade_id" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "PercentOfBaseload" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetElecTradesHistoryQuery,
  GetElecTradesHistoryQueryVariables
>
export const GetEmailTemplateSummariesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEmailTemplateSummaries" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "email_templates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "communication_id" },
                      value: { kind: "EnumValue", value: "asc" },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "version" },
                      value: { kind: "EnumValue", value: "desc" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "communication_id" },
                },
                { kind: "Field", name: { kind: "Name", value: "version" } },
                { kind: "Field", name: { kind: "Name", value: "is_live" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "published_at" },
                },
                { kind: "Field", name: { kind: "Name", value: "modified_by" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "communication" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "communication_type" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetEmailTemplateSummariesQuery,
  GetEmailTemplateSummariesQueryVariables
>
export const GetEmailTemplatesByCommunicationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEmailTemplatesByCommunication" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "communicationId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "bigint" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "email_templates" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "communication_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "communicationId" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "version" },
                      value: { kind: "EnumValue", value: "desc" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "communication_id" },
                },
                { kind: "Field", name: { kind: "Name", value: "version" } },
                { kind: "Field", name: { kind: "Name", value: "is_live" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plain_content" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "html_content" },
                },
                { kind: "Field", name: { kind: "Name", value: "modified_by" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "modified_reason" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "published_at" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "communication" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "communication_type" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetEmailTemplatesByCommunicationQuery,
  GetEmailTemplatesByCommunicationQueryVariables
>
export const GetEnrolmentAutomatedCommunicationByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEnrolmentAutomatedCommunicationById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "enrolmentId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "bigint" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "enrolment_automated_communications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "enrolment_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "enrolmentId" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "comms_sent" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "comms_sent_to" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "enrolment_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paragraph_one" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paragraph_two" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetEnrolmentAutomatedCommunicationByIdQuery,
  GetEnrolmentAutomatedCommunicationByIdQueryVariables
>
export const GetEnrolmentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEnrolments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "search" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "enrolment_order_by" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "broker" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "createdAt" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "timestamp_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "onboardingStatus" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "enrolmentFailureMessage" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "enrolment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_and" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "created_at" },
                                value: {
                                  kind: "Variable",
                                  name: { kind: "Name", value: "createdAt" },
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "broker" },
                                value: {
                                  kind: "Variable",
                                  name: { kind: "Name", value: "broker" },
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "status" },
                                value: {
                                  kind: "Variable",
                                  name: {
                                    kind: "Name",
                                    value: "onboardingStatus",
                                  },
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "enrolment_failure_message",
                                },
                                value: {
                                  kind: "Variable",
                                  name: {
                                    kind: "Name",
                                    value: "enrolmentFailureMessage",
                                  },
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "email" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "enrolment_failure_message",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "third_party_switch_reference",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "customer" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "number" },
                                      value: {
                                        kind: "ObjectValue",
                                        fields: [
                                          {
                                            kind: "ObjectField",
                                            name: {
                                              kind: "Name",
                                              value: "_ilike",
                                            },
                                            value: {
                                              kind: "Variable",
                                              name: {
                                                kind: "Name",
                                                value: "search",
                                              },
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "post_code" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "customer" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: {
                                        kind: "Name",
                                        value: "billing_accounts",
                                      },
                                      value: {
                                        kind: "ObjectValue",
                                        fields: [
                                          {
                                            kind: "ObjectField",
                                            name: {
                                              kind: "Name",
                                              value: "_or",
                                            },
                                            value: {
                                              kind: "ListValue",
                                              values: [
                                                {
                                                  kind: "ObjectValue",
                                                  fields: [
                                                    {
                                                      kind: "ObjectField",
                                                      name: {
                                                        kind: "Name",
                                                        value: "number",
                                                      },
                                                      value: {
                                                        kind: "ObjectValue",
                                                        fields: [
                                                          {
                                                            kind: "ObjectField",
                                                            name: {
                                                              kind: "Name",
                                                              value: "_ilike",
                                                            },
                                                            value: {
                                                              kind: "Variable",
                                                              name: {
                                                                kind: "Name",
                                                                value: "search",
                                                              },
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "broker" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "customer_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "enrolment_failure_message" },
                },
                { kind: "Field", name: { kind: "Name", value: "data" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "third_party_switch_reference" },
                },
                { kind: "Field", name: { kind: "Name", value: "post_code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "communications_sent" },
                },
                { kind: "Field", name: { kind: "Name", value: "retry_count" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "first_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "last_name" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "billing_accounts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "number" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cancelled" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "terminated" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "closed" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "enrolment_aggregate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_and" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "created_at" },
                                value: {
                                  kind: "Variable",
                                  name: { kind: "Name", value: "createdAt" },
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "broker" },
                                value: {
                                  kind: "Variable",
                                  name: { kind: "Name", value: "broker" },
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "status" },
                                value: {
                                  kind: "Variable",
                                  name: {
                                    kind: "Name",
                                    value: "onboardingStatus",
                                  },
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "enrolment_failure_message",
                                },
                                value: {
                                  kind: "Variable",
                                  name: {
                                    kind: "Name",
                                    value: "enrolmentFailureMessage",
                                  },
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "email" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "enrolment_failure_message",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "third_party_switch_reference",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "customer" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "number" },
                                      value: {
                                        kind: "ObjectValue",
                                        fields: [
                                          {
                                            kind: "ObjectField",
                                            name: {
                                              kind: "Name",
                                              value: "_ilike",
                                            },
                                            value: {
                                              kind: "Variable",
                                              name: {
                                                kind: "Name",
                                                value: "search",
                                              },
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "post_code" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "customer" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: {
                                        kind: "Name",
                                        value: "billing_accounts",
                                      },
                                      value: {
                                        kind: "ObjectValue",
                                        fields: [
                                          {
                                            kind: "ObjectField",
                                            name: {
                                              kind: "Name",
                                              value: "_or",
                                            },
                                            value: {
                                              kind: "ListValue",
                                              values: [
                                                {
                                                  kind: "ObjectValue",
                                                  fields: [
                                                    {
                                                      kind: "ObjectField",
                                                      name: {
                                                        kind: "Name",
                                                        value: "number",
                                                      },
                                                      value: {
                                                        kind: "ObjectValue",
                                                        fields: [
                                                          {
                                                            kind: "ObjectField",
                                                            name: {
                                                              kind: "Name",
                                                              value: "_ilike",
                                                            },
                                                            value: {
                                                              kind: "Variable",
                                                              name: {
                                                                kind: "Name",
                                                                value: "search",
                                                              },
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEnrolmentsQuery, GetEnrolmentsQueryVariables>
export const GetEnrolmentsByBrokerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEnrolmentsByBroker" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "createdAtStart" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "timestamp" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "createdAtEnd" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "timestamp" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "search" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "enrolmentFailureMessageRegex" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "enrolmentFailureMessageNRegex" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "onboardingStatus" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "json" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "brokers" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "json" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "enrolments_grouped_by_broker" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "args" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "createdAtStart" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "createdAtStart" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "createdAtEnd" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "createdAtEnd" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "search" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "search" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "enrolmentFailureMessageRegex",
                      },
                      value: {
                        kind: "Variable",
                        name: {
                          kind: "Name",
                          value: "enrolmentFailureMessageRegex",
                        },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "enrolmentFailureMessageNRegex",
                      },
                      value: {
                        kind: "Variable",
                        name: {
                          kind: "Name",
                          value: "enrolmentFailureMessageNRegex",
                        },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "onboardingStatus" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "onboardingStatus" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "brokers" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "brokers" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "broker" } },
                { kind: "Field", name: { kind: "Name", value: "count" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetEnrolmentsByBrokerQuery,
  GetEnrolmentsByBrokerQueryVariables
>
export const GetExternalEmailTemplateByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetExternalEmailTemplateById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "bigint" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "email_templates_ext" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "id" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "deleted" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_is_null" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "sender" } },
                { kind: "Field", name: { kind: "Name", value: "version" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reply_to_address" },
                },
                { kind: "Field", name: { kind: "Name", value: "body" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetExternalEmailTemplateByIdQuery,
  GetExternalEmailTemplateByIdQueryVariables
>
export const GetExternalEmailTemplatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetExternalEmailTemplates" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "email_templates_ext" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "deleted" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_is_null" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "name" },
                      value: { kind: "EnumValue", value: "asc" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "subject" } },
                { kind: "Field", name: { kind: "Name", value: "sender" } },
                { kind: "Field", name: { kind: "Name", value: "version" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reply_to_address" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetExternalEmailTemplatesQuery,
  GetExternalEmailTemplatesQueryVariables
>
export const GetFindTestAccountsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFindTestAccounts" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "find_test_accounts" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billing_acc_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inside_renewal_window" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "is_active_agreement" },
                },
                { kind: "Field", name: { kind: "Name", value: "is_seasonal" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "multi_meterpoints" },
                },
                { kind: "Field", name: { kind: "Name", value: "account_num" } },
                { kind: "Field", name: { kind: "Name", value: "fuel_type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "latest_status" },
                },
                { kind: "Field", name: { kind: "Name", value: "to_date" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFindTestAccountsQuery,
  GetFindTestAccountsQueryVariables
>
export const GetGasTradesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetGasTrades" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "GasTrades" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "ConfirmReceived" },
                  name: { kind: "Name", value: "ConfirmRecieved" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ConfirmSignedBy" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ConfirmSignedDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "CounterParty" },
                },
                { kind: "Field", name: { kind: "Name", value: "Date" } },
                { kind: "Field", name: { kind: "Name", value: "Date_From" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "Trader" } },
                { kind: "Field", name: { kind: "Name", value: "Volume" } },
                { kind: "Field", name: { kind: "Name", value: "Price" } },
                { kind: "Field", name: { kind: "Name", value: "Period" } },
                { kind: "Field", name: { kind: "Name", value: "Index" } },
                { kind: "Field", name: { kind: "Name", value: "Date_To" } },
                { kind: "Field", name: { kind: "Name", value: "Notes" } },
                { kind: "Field", name: { kind: "Name", value: "Locked" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetGasTradesQuery, GetGasTradesQueryVariables>
export const GetGasTradesHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetGasTradesHistory" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "GasTradesHistory" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ConfirmReceived" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ConfirmSignedBy" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ConfirmSignedDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "CounterParty" },
                },
                { kind: "Field", name: { kind: "Name", value: "Date" } },
                { kind: "Field", name: { kind: "Name", value: "Date_From" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "Trader" } },
                { kind: "Field", name: { kind: "Name", value: "Volume" } },
                { kind: "Field", name: { kind: "Name", value: "Price" } },
                { kind: "Field", name: { kind: "Name", value: "Period" } },
                { kind: "Field", name: { kind: "Name", value: "Index" } },
                { kind: "Field", name: { kind: "Name", value: "Date_To" } },
                { kind: "Field", name: { kind: "Name", value: "Notes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "gas_trade_id" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetGasTradesHistoryQuery,
  GetGasTradesHistoryQueryVariables
>
export const GetInstallCodesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetInstallCodes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "search" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "install_codes_order_by" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "asnDate" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "date_comparison_exp" },
          },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "asnOutcome" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "comment" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "createdAt" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "timestamp_comparison_exp" },
          },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "installCode" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lastDateChecked" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "date_comparison_exp" },
          },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "mapId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "mapName" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "requestedDate" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "date_comparison_exp" },
          },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "msn" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "today" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "timestamp" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "install_codes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "asn_date" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "asnDate" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "asn_outcome" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "asnOutcome" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "comment" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "comment" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "created_at" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "install_code" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "installCode" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "last_date_checked" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "lastDateChecked" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "map_id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "mapId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "map_name" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "mapName" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "requested_date" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "requestedDate" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "msn" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "msn" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "msn" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "device_id" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "meter" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: {
                                        kind: "Name",
                                        value: "meter_meter_point_rels",
                                      },
                                      value: {
                                        kind: "ObjectValue",
                                        fields: [
                                          {
                                            kind: "ObjectField",
                                            name: {
                                              kind: "Name",
                                              value: "meter_point",
                                            },
                                            value: {
                                              kind: "ObjectValue",
                                              fields: [
                                                {
                                                  kind: "ObjectField",
                                                  name: {
                                                    kind: "Name",
                                                    value: "identifier",
                                                  },
                                                  value: {
                                                    kind: "ObjectValue",
                                                    fields: [
                                                      {
                                                        kind: "ObjectField",
                                                        name: {
                                                          kind: "Name",
                                                          value: "_ilike",
                                                        },
                                                        value: {
                                                          kind: "Variable",
                                                          name: {
                                                            kind: "Name",
                                                            value: "search",
                                                          },
                                                        },
                                                      },
                                                    ],
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "asn_date" } },
                { kind: "Field", name: { kind: "Name", value: "asn_outcome" } },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "device_id" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "install_code" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "last_date_checked" },
                },
                { kind: "Field", name: { kind: "Name", value: "map_id" } },
                { kind: "Field", name: { kind: "Name", value: "map_name" } },
                { kind: "Field", name: { kind: "Name", value: "msn" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requested_date" },
                },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meter" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "meter_meter_point_rels" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "where" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "_or" },
                                  value: {
                                    kind: "ListValue",
                                    values: [
                                      {
                                        kind: "ObjectValue",
                                        fields: [
                                          {
                                            kind: "ObjectField",
                                            name: {
                                              kind: "Name",
                                              value: "to_dt",
                                            },
                                            value: {
                                              kind: "ObjectValue",
                                              fields: [
                                                {
                                                  kind: "ObjectField",
                                                  name: {
                                                    kind: "Name",
                                                    value: "_is_null",
                                                  },
                                                  value: {
                                                    kind: "BooleanValue",
                                                    value: true,
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                      {
                                        kind: "ObjectValue",
                                        fields: [
                                          {
                                            kind: "ObjectField",
                                            name: {
                                              kind: "Name",
                                              value: "to_dt",
                                            },
                                            value: {
                                              kind: "ObjectValue",
                                              fields: [
                                                {
                                                  kind: "ObjectField",
                                                  name: {
                                                    kind: "Name",
                                                    value: "_gte",
                                                  },
                                                  value: {
                                                    kind: "Variable",
                                                    name: {
                                                      kind: "Name",
                                                      value: "today",
                                                    },
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "meter_point" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "identifier" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "install_codes_aggregate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "asn_date" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "asnDate" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "asn_outcome" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "asnOutcome" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "comment" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "comment" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "created_at" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "install_code" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "installCode" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "last_date_checked" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "lastDateChecked" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "map_id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "mapId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "map_name" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "mapName" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "requested_date" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "requestedDate" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "msn" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "msn" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "msn" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "device_id" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "meter" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: {
                                        kind: "Name",
                                        value: "meter_meter_point_rels",
                                      },
                                      value: {
                                        kind: "ObjectValue",
                                        fields: [
                                          {
                                            kind: "ObjectField",
                                            name: {
                                              kind: "Name",
                                              value: "meter_point",
                                            },
                                            value: {
                                              kind: "ObjectValue",
                                              fields: [
                                                {
                                                  kind: "ObjectField",
                                                  name: {
                                                    kind: "Name",
                                                    value: "identifier",
                                                  },
                                                  value: {
                                                    kind: "ObjectValue",
                                                    fields: [
                                                      {
                                                        kind: "ObjectField",
                                                        name: {
                                                          kind: "Name",
                                                          value: "_ilike",
                                                        },
                                                        value: {
                                                          kind: "Variable",
                                                          name: {
                                                            kind: "Name",
                                                            value: "search",
                                                          },
                                                        },
                                                      },
                                                    ],
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetInstallCodesQuery,
  GetInstallCodesQueryVariables
>
export const GetInstallCodesExtraDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetInstallCodesExtra" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "search" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "install_codes_order_by" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "asnDate" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "date_comparison_exp" },
          },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "asnOutcome" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "comment" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "createdAt" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "timestamp_comparison_exp" },
          },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "installCode" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lastDateChecked" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "date_comparison_exp" },
          },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "mapId" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "mapName" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "requestedDate" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "date_comparison_exp" },
          },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "msn" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "today" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "timestamp" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "install_codes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "asn_date" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "asnDate" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "asn_outcome" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "asnOutcome" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "comment" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "comment" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "created_at" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "install_code" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "installCode" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "last_date_checked" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "lastDateChecked" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "map_id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "mapId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "map_name" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "mapName" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "requested_date" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "requestedDate" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "msn" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "msn" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "msn" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "device_id" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "meter" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: {
                                        kind: "Name",
                                        value: "meter_meter_point_rels",
                                      },
                                      value: {
                                        kind: "ObjectValue",
                                        fields: [
                                          {
                                            kind: "ObjectField",
                                            name: {
                                              kind: "Name",
                                              value: "meter_point",
                                            },
                                            value: {
                                              kind: "ObjectValue",
                                              fields: [
                                                {
                                                  kind: "ObjectField",
                                                  name: {
                                                    kind: "Name",
                                                    value: "identifier",
                                                  },
                                                  value: {
                                                    kind: "ObjectValue",
                                                    fields: [
                                                      {
                                                        kind: "ObjectField",
                                                        name: {
                                                          kind: "Name",
                                                          value: "_ilike",
                                                        },
                                                        value: {
                                                          kind: "Variable",
                                                          name: {
                                                            kind: "Name",
                                                            value: "search",
                                                          },
                                                        },
                                                      },
                                                    ],
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "asn_date" } },
                { kind: "Field", name: { kind: "Name", value: "asn_outcome" } },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "device_id" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "install_code" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "last_date_checked" },
                },
                { kind: "Field", name: { kind: "Name", value: "map_id" } },
                { kind: "Field", name: { kind: "Name", value: "map_name" } },
                { kind: "Field", name: { kind: "Name", value: "msn" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requested_date" },
                },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meter" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "meter_meter_point_rels" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "where" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "_or" },
                                  value: {
                                    kind: "ListValue",
                                    values: [
                                      {
                                        kind: "ObjectValue",
                                        fields: [
                                          {
                                            kind: "ObjectField",
                                            name: {
                                              kind: "Name",
                                              value: "to_dt",
                                            },
                                            value: {
                                              kind: "ObjectValue",
                                              fields: [
                                                {
                                                  kind: "ObjectField",
                                                  name: {
                                                    kind: "Name",
                                                    value: "_is_null",
                                                  },
                                                  value: {
                                                    kind: "BooleanValue",
                                                    value: true,
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                      {
                                        kind: "ObjectValue",
                                        fields: [
                                          {
                                            kind: "ObjectField",
                                            name: {
                                              kind: "Name",
                                              value: "to_dt",
                                            },
                                            value: {
                                              kind: "ObjectValue",
                                              fields: [
                                                {
                                                  kind: "ObjectField",
                                                  name: {
                                                    kind: "Name",
                                                    value: "_gte",
                                                  },
                                                  value: {
                                                    kind: "Variable",
                                                    name: {
                                                      kind: "Name",
                                                      value: "today",
                                                    },
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "meter_point" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "identifier" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cs_dashboard" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gbcs_version" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "manufacturer" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "model" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "smets_version" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firmware_version" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "mpxn" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "install_codes_aggregate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "asn_date" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "asnDate" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "asn_outcome" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "asnOutcome" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "comment" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "comment" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "created_at" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "install_code" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "installCode" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "last_date_checked" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "lastDateChecked" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "map_id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "mapId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "map_name" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "mapName" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "requested_date" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "requestedDate" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "msn" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "msn" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "msn" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "device_id" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "meter" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: {
                                        kind: "Name",
                                        value: "meter_meter_point_rels",
                                      },
                                      value: {
                                        kind: "ObjectValue",
                                        fields: [
                                          {
                                            kind: "ObjectField",
                                            name: {
                                              kind: "Name",
                                              value: "meter_point",
                                            },
                                            value: {
                                              kind: "ObjectValue",
                                              fields: [
                                                {
                                                  kind: "ObjectField",
                                                  name: {
                                                    kind: "Name",
                                                    value: "identifier",
                                                  },
                                                  value: {
                                                    kind: "ObjectValue",
                                                    fields: [
                                                      {
                                                        kind: "ObjectField",
                                                        name: {
                                                          kind: "Name",
                                                          value: "_ilike",
                                                        },
                                                        value: {
                                                          kind: "Variable",
                                                          name: {
                                                            kind: "Name",
                                                            value: "search",
                                                          },
                                                        },
                                                      },
                                                    ],
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetInstallCodesExtraQuery,
  GetInstallCodesExtraQueryVariables
>
export const GetInstallCodesSummaryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetInstallCodesSummary" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "asnExpiryDate" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "date" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "total" },
            name: { kind: "Name", value: "install_codes_aggregate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "install_codes_count" },
            name: { kind: "Name", value: "install_codes_aggregate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "install_code" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_is_null" },
                            value: { kind: "BooleanValue", value: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "missing_asn_count" },
            name: { kind: "Name", value: "install_codes_aggregate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_and" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "install_code" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "_is_null" },
                                  value: { kind: "BooleanValue", value: false },
                                },
                              ],
                            },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "asn_outcome" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "_nilike" },
                                  value: {
                                    kind: "StringValue",
                                    value: "%asn%",
                                    block: false,
                                  },
                                },
                              ],
                            },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_and" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "asn_outcome" },
                                  value: {
                                    kind: "ObjectValue",
                                    fields: [
                                      {
                                        kind: "ObjectField",
                                        name: {
                                          kind: "Name",
                                          value: "_nilike",
                                        },
                                        value: {
                                          kind: "StringValue",
                                          value: "%upload%",
                                          block: false,
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "expiring_asn_count" },
            name: { kind: "Name", value: "install_codes_aggregate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_and" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "install_code" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "_is_null" },
                                  value: { kind: "BooleanValue", value: false },
                                },
                              ],
                            },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "asn_outcome" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "_ilike" },
                                  value: {
                                    kind: "StringValue",
                                    value: "%asn%",
                                    block: false,
                                  },
                                },
                              ],
                            },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "asn_date" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "_lte" },
                                  value: {
                                    kind: "Variable",
                                    name: {
                                      kind: "Name",
                                      value: "asnExpiryDate",
                                    },
                                  },
                                },
                              ],
                            },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_and" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "asn_outcome" },
                                  value: {
                                    kind: "ObjectValue",
                                    fields: [
                                      {
                                        kind: "ObjectField",
                                        name: { kind: "Name", value: "_ilike" },
                                        value: {
                                          kind: "StringValue",
                                          value: "%upload%",
                                          block: false,
                                        },
                                      },
                                    ],
                                  },
                                },
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "_or" },
                                  value: {
                                    kind: "ObjectValue",
                                    fields: [
                                      {
                                        kind: "ObjectField",
                                        name: {
                                          kind: "Name",
                                          value: "asn_outcome",
                                        },
                                        value: {
                                          kind: "ObjectValue",
                                          fields: [
                                            {
                                              kind: "ObjectField",
                                              name: {
                                                kind: "Name",
                                                value: "_ilike",
                                              },
                                              value: {
                                                kind: "StringValue",
                                                value: "%uploaded%",
                                                block: false,
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "missing_asn_msns" },
            name: { kind: "Name", value: "install_codes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_and" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "install_code" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "_is_null" },
                                  value: { kind: "BooleanValue", value: false },
                                },
                              ],
                            },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "asn_outcome" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "_nilike" },
                                  value: {
                                    kind: "StringValue",
                                    value: "%asn%",
                                    block: false,
                                  },
                                },
                              ],
                            },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_and" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "asn_outcome" },
                                  value: {
                                    kind: "ObjectValue",
                                    fields: [
                                      {
                                        kind: "ObjectField",
                                        name: {
                                          kind: "Name",
                                          value: "_nilike",
                                        },
                                        value: {
                                          kind: "StringValue",
                                          value: "%upload%",
                                          block: false,
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "install_code" },
                },
                { kind: "Field", name: { kind: "Name", value: "asn_outcome" } },
                { kind: "Field", name: { kind: "Name", value: "msn" } },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "expiring_asn_msns" },
            name: { kind: "Name", value: "install_codes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_and" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "install_code" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "_is_null" },
                                  value: { kind: "BooleanValue", value: false },
                                },
                              ],
                            },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "asn_outcome" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "_ilike" },
                                  value: {
                                    kind: "StringValue",
                                    value: "%asn%",
                                    block: false,
                                  },
                                },
                              ],
                            },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "asn_date" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "_lte" },
                                  value: {
                                    kind: "Variable",
                                    name: {
                                      kind: "Name",
                                      value: "asnExpiryDate",
                                    },
                                  },
                                },
                              ],
                            },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_and" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "asn_outcome" },
                                  value: {
                                    kind: "ObjectValue",
                                    fields: [
                                      {
                                        kind: "ObjectField",
                                        name: { kind: "Name", value: "_ilike" },
                                        value: {
                                          kind: "StringValue",
                                          value: "%upload%",
                                          block: false,
                                        },
                                      },
                                    ],
                                  },
                                },
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "_or" },
                                  value: {
                                    kind: "ObjectValue",
                                    fields: [
                                      {
                                        kind: "ObjectField",
                                        name: {
                                          kind: "Name",
                                          value: "asn_outcome",
                                        },
                                        value: {
                                          kind: "ObjectValue",
                                          fields: [
                                            {
                                              kind: "ObjectField",
                                              name: {
                                                kind: "Name",
                                                value: "_ilike",
                                              },
                                              value: {
                                                kind: "StringValue",
                                                value: "%uploaded%",
                                                block: false,
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "msn" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetInstallCodesSummaryQuery,
  GetInstallCodesSummaryQueryVariables
>
export const SearchFreshdeskContactsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchFreshdeskContacts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "search" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "freshdesk_contact" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "account_number" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "email" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "phone" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "mobile" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "external_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account_number" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "raw_data" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "freshdesk_contact_aggregate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "account_number" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "email" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "phone" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "mobile" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchFreshdeskContactsQuery,
  SearchFreshdeskContactsQueryVariables
>
export const GetFreshdeskContactDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFreshdeskContact" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "contactId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "bigint" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "freshdesk_contact" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "external_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "contactId" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "external_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account_number" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "raw_data" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFreshdeskContactQuery,
  GetFreshdeskContactQueryVariables
>
export const GetMetersByMpxnMsnDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMetersByMpxnMsn" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "mpxn" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          defaultValue: { kind: "StringValue", value: "", block: false },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "msn" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          defaultValue: { kind: "StringValue", value: "", block: false },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "today" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "timestamp" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meter" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "meter_meter_point_rels",
                                },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: {
                                        kind: "Name",
                                        value: "meter_point",
                                      },
                                      value: {
                                        kind: "ObjectValue",
                                        fields: [
                                          {
                                            kind: "ObjectField",
                                            name: {
                                              kind: "Name",
                                              value: "identifier",
                                            },
                                            value: {
                                              kind: "ObjectValue",
                                              fields: [
                                                {
                                                  kind: "ObjectField",
                                                  name: {
                                                    kind: "Name",
                                                    value: "_eq",
                                                  },
                                                  value: {
                                                    kind: "Variable",
                                                    name: {
                                                      kind: "Name",
                                                      value: "mpxn",
                                                    },
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "identifier" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_eq" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "msn" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "meter_meter_point_rels" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_or" },
                            value: {
                              kind: "ListValue",
                              values: [
                                {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "to_dt" },
                                      value: {
                                        kind: "ObjectValue",
                                        fields: [
                                          {
                                            kind: "ObjectField",
                                            name: {
                                              kind: "Name",
                                              value: "_is_null",
                                            },
                                            value: {
                                              kind: "BooleanValue",
                                              value: true,
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                                {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "to_dt" },
                                      value: {
                                        kind: "ObjectValue",
                                        fields: [
                                          {
                                            kind: "ObjectField",
                                            name: {
                                              kind: "Name",
                                              value: "_gte",
                                            },
                                            value: {
                                              kind: "Variable",
                                              name: {
                                                kind: "Name",
                                                value: "today",
                                              },
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meter_meter_point_rels" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "meter_point" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "identifier" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMetersByMpxnMsnQuery,
  GetMetersByMpxnMsnQueryVariables
>
export const GetOutboundPhotoRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOutboundPhotoRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accountNumber" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "active_outbound_photo_request" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "account_number" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "accountNumber" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "created_at" },
                      value: { kind: "EnumValue", value: "desc" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "freshdesk_ticket_id" },
                },
                { kind: "Field", name: { kind: "Name", value: "fuel" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "request_reason" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "freshdesk_group_name" },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "last_email_sent_at" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOutboundPhotoRequestQuery,
  GetOutboundPhotoRequestQueryVariables
>
export const GetPaymentReviewIdsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaymentReviewIds" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "payment_reviews" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: { kind: "EnumValue", value: "desc" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPaymentReviewIdsQuery,
  GetPaymentReviewIdsQueryVariables
>
export const GetPaymentReviewLatestIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaymentReviewLatestId" },
      directives: [
        { kind: "Directive", name: { kind: "Name", value: "cached" } },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "payment_reviews_aggregate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "max" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPaymentReviewLatestIdQuery,
  GetPaymentReviewLatestIdQueryVariables
>
export const GetPaymentReviewRecordDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaymentReviewRecord" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "paymentReviewId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "bigint" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "payment_review_records_by_pk" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "paymentReviewId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment_review_calculations" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "limit" },
                      value: { kind: "IntValue", value: "1" },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "order_by" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "id" },
                            value: { kind: "EnumValue", value: "desc" },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "calculation_items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gsp_code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "product_code" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "product_rate_1" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "product_rate_2" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "product_standing_rate",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "product_type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rate_type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "item_cost" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "meterpoint_eac_1" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "meterpoint_eac_2" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "direct_debit" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "account_balance_applied",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "account_balance" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "estimate_annual_cost" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "new_monthly_amount" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "payment_schedule_period_amount",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "next_payment_date" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "last_retry_time" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPaymentReviewRecordQuery,
  GetPaymentReviewRecordQueryVariables
>
export const GetPaymentReviewRecordsDownloadFileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaymentReviewRecordsDownloadFile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "changed_amount_max" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "changed_amount_min" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "changed_percentage_max" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "to" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "payment_review_id" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "BigInt" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "notes_status" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "next_payment_date_to" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "next_payment_date_from" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "from" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "error_codes" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email_status" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "changed_percentage_min" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "action_payment_review_records_download",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "changed_amount_max" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "changed_amount_max" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "changed_amount_min" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "changed_amount_min" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "changed_percentage_max" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "changed_percentage_max" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "changed_percentage_min" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "changed_percentage_min" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "email_status" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "email_status" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "error_codes" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "error_codes" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "from" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "from" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "next_payment_date_from" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "next_payment_date_from" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "next_payment_date_to" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "next_payment_date_to" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "notes_status" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "notes_status" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "payment_review_id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "payment_review_id" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "status" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "to" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "to" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "file_url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPaymentReviewRecordsDownloadFileQuery,
  GetPaymentReviewRecordsDownloadFileQueryVariables
>
export const GetPaymentReviewRecordsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaymentReviewRecords" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "paymentReviewId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "bigint" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: {
                  kind: "Name",
                  value: "payment_review_records_view_order_by",
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "payment_review_record_status_comparison_exp",
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "failureErrorCode" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "createdAt" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "timestamptz_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "nextPaymentDate" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "date_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "changedAmount" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "numeric_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lastRetryDate" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "timestamptz_comparison_exp" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "payment_review_records_view" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "payment_review_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "paymentReviewId" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "status" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "failure_error_code" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "failureErrorCode" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "created_at" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "next_payment_date" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "nextPaymentDate" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "changed_amount" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "changedAmount" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "last_retry_time" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "lastRetryDate" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account_number" },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "failure_error_code" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "payment_schedule_period_amount",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "new_monthly_amount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "next_payment_date" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "changed_amount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "change_percentage" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account_balance" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "estimate_annual_cost" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "last_retry_time" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "payment_review_records_view_aggregate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "payment_review_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "paymentReviewId" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "status" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "failure_error_code" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "failureErrorCode" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "created_at" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "next_payment_date" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "nextPaymentDate" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "changed_amount" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "changedAmount" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "last_retry_time" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "lastRetryDate" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "active_failure_reasons" },
            name: { kind: "Name", value: "payment_review_records_view" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "distinct_on" },
                value: { kind: "EnumValue", value: "failure_error_code" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "payment_review_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "paymentReviewId" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "failure_error_code" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPaymentReviewRecordsQuery,
  GetPaymentReviewRecordsQueryVariables
>
export const GetPaymentReviewSummaryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaymentReviewSummary" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "paymentReviewId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "bigint" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "completed" },
            name: {
              kind: "Name",
              value: "payment_review_records_view_aggregate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "payment_review_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "paymentReviewId" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "StringValue",
                              value: "completed",
                              block: false,
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "failed" },
            name: {
              kind: "Name",
              value: "payment_review_records_view_aggregate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "payment_review_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "paymentReviewId" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "StringValue",
                              value: "failed",
                              block: false,
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "skipped" },
            name: {
              kind: "Name",
              value: "payment_review_records_view_aggregate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "payment_review_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "paymentReviewId" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "StringValue",
                              value: "skipped",
                              block: false,
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "total" },
            name: {
              kind: "Name",
              value: "payment_review_records_view_aggregate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "payment_review_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "paymentReviewId" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPaymentReviewSummaryQuery,
  GetPaymentReviewSummaryQueryVariables
>
export const GetProductsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getProducts" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "product_view" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: { kind: "EnumValue", value: "desc" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "direct_debit" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "display_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "duration_value" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "direct_debit" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "available_to_public" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "active_for_enrolment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "active_for_renewal" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recommend_for_enrolment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recommend_for_renewal" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "requires_smart_charging" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProductsQuery, GetProductsQueryVariables>
export const GetRecentCustomerReferralsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRecentCustomerReferrals" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customer_referrals" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "created_at" },
                      value: { kind: "EnumValue", value: "desc" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "referee" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "billing_accounts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "number" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customer_user_rels" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user_id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "email" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetRecentCustomerReferralsQuery,
  GetRecentCustomerReferralsQueryVariables
>
export const GetCreditCheckStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCreditCheckStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accountNumber" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "registration_credit_check" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "account_number" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "accountNumber" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account_number" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCreditCheckStatusQuery,
  GetCreditCheckStatusQueryVariables
>
export const GetRegistrationCreditChecksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRegistrationCreditChecks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: {
                  kind: "Name",
                  value: "registration_credit_check_order_by",
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "search" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "credit_check_status_comparison_exp" },
          },
          defaultValue: {
            kind: "ObjectValue",
            fields: [
              {
                kind: "ObjectField",
                name: { kind: "Name", value: "_in" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "StringValue",
                      value: "SWITCH_NOT_ACTIVE",
                      block: false,
                    },
                    {
                      kind: "StringValue",
                      value: "DEPOSIT_REQUEST_FAILED",
                      block: false,
                    },
                    {
                      kind: "StringValue",
                      value: "DEPOSIT_REQUESTED",
                      block: false,
                    },
                    {
                      kind: "StringValue",
                      value: "DEPOSIT_PAID",
                      block: false,
                    },
                    {
                      kind: "StringValue",
                      value: "DEPOSIT_RECEIVED_EMAIL_FAILED",
                      block: false,
                    },
                    {
                      kind: "StringValue",
                      value: "DEPOSIT_RECEIVED_EMAIL_SENT",
                      block: false,
                    },
                    {
                      kind: "StringValue",
                      value: "FAILED_TO_CANCEL_SWITCH_BY_SOE",
                      block: false,
                    },
                    {
                      kind: "StringValue",
                      value: "SWITCH_CANCELLED_BY_SOE",
                      block: false,
                    },
                    {
                      kind: "StringValue",
                      value: "CANCELLATION_EMAIL_FAILED",
                      block: false,
                    },
                    {
                      kind: "StringValue",
                      value: "CANCELLATION_EMAIL_SENT",
                      block: false,
                    },
                    { kind: "StringValue", value: "SCORED_CA", block: false },
                    {
                      kind: "StringValue",
                      value: "FAILED_TO_SCORE_CA",
                      block: false,
                    },
                    { kind: "StringValue", value: "NO_SCORE_CA", block: false },
                  ],
                },
              },
            ],
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deadline" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "timestamp_comparison_exp" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "registration_credit_check_aggregate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_and" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "status" },
                                value: {
                                  kind: "Variable",
                                  name: { kind: "Name", value: "status" },
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "deposit_deadline_dt",
                                },
                                value: {
                                  kind: "Variable",
                                  name: { kind: "Name", value: "deadline" },
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "last_name" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "first_name" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "account_number" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "registration_credit_check" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_and" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "status" },
                                value: {
                                  kind: "Variable",
                                  name: { kind: "Name", value: "status" },
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: {
                                  kind: "Name",
                                  value: "deposit_deadline_dt",
                                },
                                value: {
                                  kind: "Variable",
                                  name: { kind: "Name", value: "deadline" },
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "last_name" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "first_name" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "account_number" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "first_name" } },
                { kind: "Field", name: { kind: "Name", value: "last_name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account_number" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billing_account_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deposit_deadline_dt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deposit_paid_dt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "date_of_birth" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deposit_amount" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_dt" } },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value:
                      "registration_credit_check_registraion_credit_check_address",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "street1" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postcode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "is_supply_address" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "billing_account_id" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "registration_credit_check_billing_account",
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "closed" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "terminated" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deleted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "to_date" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cancelled" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "customer_contacts",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "contact" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "email",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "primary" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetRegistrationCreditChecksQuery,
  GetRegistrationCreditChecksQueryVariables
>
export const GetRegistrationCreditChecksByAccountNumberDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "GetRegistrationCreditChecksByAccountNumber",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "account_number" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "registration_credit_check" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "account_number" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: {
                                          kind: "Name",
                                          value: "account_number",
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "first_name" } },
                { kind: "Field", name: { kind: "Name", value: "last_name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account_number" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deposit_deadline_dt" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deposit_amount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deposit_paid_dt" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_dt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetRegistrationCreditChecksByAccountNumberQuery,
  GetRegistrationCreditChecksByAccountNumberQueryVariables
>
export const GetRenewalsByUserIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRenewalsByUserId" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "bigint" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "renewal" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "renewal_agreements" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: {
                              kind: "Name",
                              value: "product_account_rels",
                            },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: {
                                    kind: "Name",
                                    value: "product_account",
                                  },
                                  value: {
                                    kind: "ObjectValue",
                                    fields: [
                                      {
                                        kind: "ObjectField",
                                        name: {
                                          kind: "Name",
                                          value: "billing_account",
                                        },
                                        value: {
                                          kind: "ObjectValue",
                                          fields: [
                                            {
                                              kind: "ObjectField",
                                              name: {
                                                kind: "Name",
                                                value: "customer",
                                              },
                                              value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                  {
                                                    kind: "ObjectField",
                                                    name: {
                                                      kind: "Name",
                                                      value:
                                                        "customer_user_rels",
                                                    },
                                                    value: {
                                                      kind: "ObjectValue",
                                                      fields: [
                                                        {
                                                          kind: "ObjectField",
                                                          name: {
                                                            kind: "Name",
                                                            value: "user_id",
                                                          },
                                                          value: {
                                                            kind: "ObjectValue",
                                                            fields: [
                                                              {
                                                                kind: "ObjectField",
                                                                name: {
                                                                  kind: "Name",
                                                                  value: "_eq",
                                                                },
                                                                value: {
                                                                  kind: "Variable",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value:
                                                                      "userId",
                                                                  },
                                                                },
                                                              },
                                                            ],
                                                          },
                                                        },
                                                      ],
                                                    },
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "uploaded_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "renewal_agreements" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contents" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetRenewalsByUserIdQuery,
  GetRenewalsByUserIdQueryVariables
>
export const GetRtsMetersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRtsMeters" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNumbers" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rts_meters_report_aggregate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "msn" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_in" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "serialNumbers" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRtsMetersQuery, GetRtsMetersQueryVariables>
export const GetBeFinancialsJobsListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetBeFinancialsJobsList" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "financials_qrtz_triggers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "sched_name" },
                      value: { kind: "EnumValue", value: "asc" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "sched_name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "trigger_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "trigger_group" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "financials_qrtz_cron_triggers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "trigger_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "trigger_group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cron_expression" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetBeFinancialsJobsListQuery,
  GetBeFinancialsJobsListQueryVariables
>
export const GetSmartChargingAccountsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSmartChargingAccounts" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "smart_charging" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "deleted" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_is_null" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "created_at" },
                      value: { kind: "EnumValue", value: "desc" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billing_account_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "axle_site_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meter_point_id" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "onboarded_at" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offboarded_at" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSmartChargingAccountsQuery,
  GetSmartChargingAccountsQueryVariables
>
export const GetSmartChargingEligibilityChecksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSmartChargingEligibilityChecks" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ev_tariff_eligibility_checks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "deleted" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_is_null" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "distinct_on" },
                value: { kind: "EnumValue", value: "billing_account_id" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "billing_account_id" },
                          value: { kind: "EnumValue", value: "asc" },
                        },
                      ],
                    },
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "desc" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billing_account_id" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "is_eligible_for_smart_charging",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "axle_charger_name" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "axle_ev_name" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSmartChargingEligibilityChecksQuery,
  GetSmartChargingEligibilityChecksQueryVariables
>
export const GetSmartChargingWaitlistDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSmartChargingWaitlist" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ev_smart_tariff_waitlist" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "deleted" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_is_null" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "distinct_on" },
                value: { kind: "EnumValue", value: "billing_account_id" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "billing_account_id" },
                          value: { kind: "EnumValue", value: "asc" },
                        },
                      ],
                    },
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "desc" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billing_account_id" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSmartChargingWaitlistQuery,
  GetSmartChargingWaitlistQueryVariables
>
export const GetSmartMetersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSmartMeters" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "search" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: {
                  kind: "Name",
                  value: "cs__soe_dashboard_total_order_by",
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lastReadDate" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "installedDate" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deviceStatus" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "alertDate" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "alertStatuses" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "alerts" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "errorCodes" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "errorStatuses" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lastOrchestrations" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orchestrationStatuses" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serviceRequests" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ssd" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "firmwareStatuses" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "firmwareVersions" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "gbcsVersion" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "manufacturers" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "meterType" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "models" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "paymentModes" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "regions" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "smetsVersion" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "variants" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "workstreams" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cs__soe_dashboard_total" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "installation_date" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "installedDate" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "dev_status" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "deviceStatus" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "last_reading_date_time" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "lastReadDate" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "latest_alert_date" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "alertDate" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "ssd" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ssd" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "latest_alert_status" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "alertStatuses" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "latest_alert_code" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "alerts" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "error_status" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "errorStatuses" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "error" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "errorCodes" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "last_orchestration" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "lastOrchestrations" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "orchestration_status" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "orchestrationStatuses" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "srv" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "serviceRequests" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "firmware_status" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "firmwareStatuses" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "firmware_version" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "firmwareVersions" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "gbcs_version" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "gbcsVersion" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "manufacturer" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "manufacturers" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "model" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "models" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "meter_type" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "meterType" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "payment_mode" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "paymentModes" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "region" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "regions" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "smets_version" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "smetsVersion" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "variant" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "variants" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "workstream" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "workstreams" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "mpxn" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "msn" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "device_id" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "comms_hub_id" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "dev_status" } },
                { kind: "Field", name: { kind: "Name", value: "error" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "error_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "installation_date" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "last_orchestration" },
                },
                { kind: "Field", name: { kind: "Name", value: "meter_type" } },
                { kind: "Field", name: { kind: "Name", value: "mpxn" } },
                { kind: "Field", name: { kind: "Name", value: "msn" } },
                { kind: "Field", name: { kind: "Name", value: "pk" } },
                { kind: "Field", name: { kind: "Name", value: "srv" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "latest_alert_code" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "latest_alert_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "latest_alert_date" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "last_reading" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "last_reading_date_time" },
                },
                { kind: "Field", name: { kind: "Name", value: "device_id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firmware_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firmware_version" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "gbcs_version" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manufacturer" },
                },
                { kind: "Field", name: { kind: "Name", value: "model" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment_mode" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "orchestration_status" },
                },
                { kind: "Field", name: { kind: "Name", value: "region" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "smets_version" },
                },
                { kind: "Field", name: { kind: "Name", value: "variant" } },
                { kind: "Field", name: { kind: "Name", value: "ssd" } },
                { kind: "Field", name: { kind: "Name", value: "workstream" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "comms_hub_id" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cs__soe_dashboard_total_aggregate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "installation_date" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "installedDate" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "dev_status" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "deviceStatus" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "last_reading_date_time" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "lastReadDate" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "latest_alert_date" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "alertDate" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "ssd" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ssd" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "latest_alert_status" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "alertStatuses" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "latest_alert_code" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "alerts" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "error_status" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "errorStatuses" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "error" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "errorCodes" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "last_orchestration" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "lastOrchestrations" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "orchestration_status" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "orchestrationStatuses" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "srv" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "serviceRequests" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "firmware_status" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "firmwareStatuses" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "firmware_version" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "firmwareVersions" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "gbcs_version" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "gbcsVersion" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "manufacturer" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "manufacturers" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "model" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "models" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "meter_type" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "meterType" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "payment_mode" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "paymentModes" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "region" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "regions" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "smets_version" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "smetsVersion" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "variant" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "variants" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "workstream" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "workstreams" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "mpxn" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "msn" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "device_id" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "comms_hub_id" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSmartMetersQuery, GetSmartMetersQueryVariables>
export const GetSmartMetersSummaryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSmartMetersSummary" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "smart_meter_dashboard_workstream_summary",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "workstream" } },
                { kind: "Field", name: { kind: "Name", value: "count" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSmartMetersSummaryQuery,
  GetSmartMetersSummaryQueryVariables
>
export const GetSmartMeterColumnValuesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSmartMeterColumnValues" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cs__soe_dashboard_total" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "distinct_on" },
                value: {
                  kind: "ListValue",
                  values: [
                    { kind: "EnumValue", value: "error" },
                    { kind: "EnumValue", value: "error_status" },
                    { kind: "EnumValue", value: "firmware_status" },
                    { kind: "EnumValue", value: "firmware_version" },
                    { kind: "EnumValue", value: "gbcs_version" },
                    { kind: "EnumValue", value: "last_orchestration" },
                    { kind: "EnumValue", value: "latest_alert_code" },
                    { kind: "EnumValue", value: "latest_alert_status" },
                    { kind: "EnumValue", value: "manufacturer" },
                    { kind: "EnumValue", value: "model" },
                    { kind: "EnumValue", value: "orchestration_status" },
                    { kind: "EnumValue", value: "payment_mode" },
                    { kind: "EnumValue", value: "region" },
                    { kind: "EnumValue", value: "smets_version" },
                    { kind: "EnumValue", value: "srv" },
                    { kind: "EnumValue", value: "variant" },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "error" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "error_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firmware_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firmware_version" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "gbcs_version" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "last_orchestration" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "latest_alert_code" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "latest_alert_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manufacturer" },
                },
                { kind: "Field", name: { kind: "Name", value: "model" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "orchestration_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment_mode" },
                },
                { kind: "Field", name: { kind: "Name", value: "region" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "smets_version" },
                },
                { kind: "Field", name: { kind: "Name", value: "srv" } },
                { kind: "Field", name: { kind: "Name", value: "variant" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSmartMeterColumnValuesQuery,
  GetSmartMeterColumnValuesQueryVariables
>
export const GetSmartMeterDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSmartMeter" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "mpxn" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cs__soe_dashboard_total" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "mpxn" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_ilike" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "mpxn" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "last_reading" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "last_reading_date_time" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "installation_date" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manufacturer" },
                },
                { kind: "Field", name: { kind: "Name", value: "meter_type" } },
                { kind: "Field", name: { kind: "Name", value: "model" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firmware_status" },
                },
                { kind: "Field", name: { kind: "Name", value: "ssd" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payment_mode" },
                },
                { kind: "Field", name: { kind: "Name", value: "workstream" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSmartMeterQuery, GetSmartMeterQueryVariables>
export const GetSmartMetersEligibleForExchangeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSmartMetersEligibleForExchange" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "meter_serial_numbers" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "smart_meters_eligible_for_exchange" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "meter_serial_number" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_in" },
                            value: {
                              kind: "Variable",
                              name: {
                                kind: "Name",
                                value: "meter_serial_numbers",
                              },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "confirmed_etc_waived" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meter_serial_number" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "exchange_eligibility_reason" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSmartMetersEligibleForExchangeQuery,
  GetSmartMetersEligibleForExchangeQueryVariables
>
export const GetUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "bigint" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "users_by_pk" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "first_name" } },
                { kind: "Field", name: { kind: "Name", value: "locked" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sign_in_count" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "current_sign_in_ip" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer_user_rels" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customer_id" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>
export const GetUsersForAccountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUsersForAccount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accountId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "bigint" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "billing_account_by_pk" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accountId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer_user_rels" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "where" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "deleted" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "_is_null" },
                                  value: { kind: "BooleanValue", value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "first_name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "locked" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "created_at" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sign_in_count" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "current_sign_in_ip",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "customer_user_rels",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "customer_id",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "deleted" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUsersForAccountQuery,
  GetUsersForAccountQueryVariables
>
export const GetWarrantsAccountsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetWarrantsAccounts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "financials_warrants_accounts_bool_exp",
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: {
                  kind: "Name",
                  value: "financials_warrants_accounts_order_by",
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "financials_warrants_accounts" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account_number" },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "pause_start" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deleted_by_agent_email" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "financials_warrants_accounts_aggregate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWarrantsAccountsQuery,
  GetWarrantsAccountsQueryVariables
>
export const GetWarrantsAccountsHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetWarrantsAccountsHistory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "financials_warrants_accounts_history_bool_exp",
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: {
                  kind: "Name",
                  value: "financials_warrants_accounts_history_order_by",
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "financials_warrants_accounts_history",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account_number" },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "current_status" },
                },
                { kind: "Field", name: { kind: "Name", value: "next_status" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
              ],
            },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "financials_warrants_accounts_history_aggregate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWarrantsAccountsHistoryQuery,
  GetWarrantsAccountsHistoryQueryVariables
>
export const GetWarrantsAccountsWhitelistDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetWarrantsAccountsWhitelist" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "financials_warrants_accounts_whitelist_bool_exp",
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: {
                  kind: "Name",
                  value: "financials_warrants_accounts_whitelist_order_by",
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "financials_warrants_accounts_whitelist",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account_number" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
              ],
            },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "financials_warrants_accounts_whitelist_aggregate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWarrantsAccountsWhitelistQuery,
  GetWarrantsAccountsWhitelistQueryVariables
>
export const GetWarrantsCommunicationGroupsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetWarrantsCommunicationGroups" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "financials_warrants_communication_group_bool_exp",
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: {
                  kind: "Name",
                  value: "financials_warrants_communication_group_order_by",
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "financials_warrants_communication_group",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account_number" },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "current_priority_level" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "error_description" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
              ],
            },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "financials_warrants_communication_group_aggregate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWarrantsCommunicationGroupsQuery,
  GetWarrantsCommunicationGroupsQueryVariables
>
export const GetWarrantsCommunicationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetWarrantsCommunications" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "financials_warrants_communications_bool_exp",
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: {
                  kind: "Name",
                  value: "financials_warrants_communications_order_by",
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "financials_warrants_communications" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "group_id" } },
                { kind: "Field", name: { kind: "Name", value: "comms_id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "delivery_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "delivery_external_status" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "parent_priority_level" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "error_description" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
              ],
            },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "financials_warrants_communications_aggregate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWarrantsCommunicationsQuery,
  GetWarrantsCommunicationsQueryVariables
>
export const GetWarrantsDcaQueueDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetWarrantsDcaQueue" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "financials_warrants_dca_queue_bool_exp",
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: {
                  kind: "Name",
                  value: "financials_warrants_dca_queue_order_by",
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "financials_warrants_dca_queue" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account_number" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "processed_at" },
                },
                { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
              ],
            },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "financials_warrants_dca_queue_aggregate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWarrantsDcaQueueQuery,
  GetWarrantsDcaQueueQueryVariables
>
export const GetWarrantsDcaTicketsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetWarrantsDcaTickets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "financials_warrants_dca_tickets_bool_exp",
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: {
                  kind: "Name",
                  value: "financials_warrants_dca_tickets_order_by",
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "financials_warrants_dca_tickets" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account_number" },
                },
                { kind: "Field", name: { kind: "Name", value: "dca_type" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ticket_definition" },
                },
                { kind: "Field", name: { kind: "Name", value: "ticket_id" } },
                { kind: "Field", name: { kind: "Name", value: "ticket_step" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
              ],
            },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "financials_warrants_dca_tickets_aggregate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWarrantsDcaTicketsQuery,
  GetWarrantsDcaTicketsQueryVariables
>
export const GetWarrantsFilesAccountsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetWarrantsFilesAccounts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "financials_warrants_files_account_bool_exp",
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: {
                  kind: "Name",
                  value: "financials_warrants_files_account_order_by",
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "financials_warrants_files_account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account_number" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer_name" },
                },
                { kind: "Field", name: { kind: "Name", value: "dca_type" } },
                { kind: "Field", name: { kind: "Name", value: "file_type" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
                { kind: "Field", name: { kind: "Name", value: "job_id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "error_message" },
                },
                { kind: "Field", name: { kind: "Name", value: "retry_count" } },
              ],
            },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "financials_warrants_files_account_aggregate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWarrantsFilesAccountsQuery,
  GetWarrantsFilesAccountsQueryVariables
>
export const GetWarrantsFilesAccountsSummaryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetWarrantsFilesAccountsSummary" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pendingWhere" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "financials_warrants_files_account_bool_exp",
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "successWhere" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "financials_warrants_files_account_bool_exp",
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "failedWhere" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "financials_warrants_files_account_bool_exp",
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "returnsWhere" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "financials_warrants_files_account_bool_exp",
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cancellationWhere" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "financials_warrants_files_account_bool_exp",
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "total" },
            name: {
              kind: "Name",
              value: "financials_warrants_files_account_aggregate",
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "pending" },
            name: {
              kind: "Name",
              value: "financials_warrants_files_account_aggregate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pendingWhere" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "success" },
            name: {
              kind: "Name",
              value: "financials_warrants_files_account_aggregate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "successWhere" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "failed" },
            name: {
              kind: "Name",
              value: "financials_warrants_files_account_aggregate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "failedWhere" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "returns" },
            name: {
              kind: "Name",
              value: "financials_warrants_files_account_aggregate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "returnsWhere" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "cancellation" },
            name: {
              kind: "Name",
              value: "financials_warrants_files_account_aggregate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cancellationWhere" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWarrantsFilesAccountsSummaryQuery,
  GetWarrantsFilesAccountsSummaryQueryVariables
>
export const GetWarrantsFilesJobsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetWarrantsFilesJobs" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "financials_warrants_files_job_bool_exp",
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: {
                  kind: "Name",
                  value: "financials_warrants_files_job_order_by",
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "financials_warrants_files_job" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "error_message" },
                },
                { kind: "Field", name: { kind: "Name", value: "started_at" } },
                { kind: "Field", name: { kind: "Name", value: "ended_at" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
              ],
            },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "financials_warrants_files_job_aggregate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWarrantsFilesJobsQuery,
  GetWarrantsFilesJobsQueryVariables
>
export const GetWarrantsFilesProcessedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetWarrantsFilesProcessed" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "financials_warrants_files_processed_bool_exp",
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: {
                  kind: "Name",
                  value: "financials_warrants_files_processed_order_by",
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "financials_warrants_files_processed",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "dca_type" } },
                { kind: "Field", name: { kind: "Name", value: "file_type" } },
                { kind: "Field", name: { kind: "Name", value: "folder" } },
                { kind: "Field", name: { kind: "Name", value: "file_name" } },
                { kind: "Field", name: { kind: "Name", value: "job_id" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
              ],
            },
          },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "financials_warrants_files_processed_aggregate",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWarrantsFilesProcessedQuery,
  GetWarrantsFilesProcessedQueryVariables
>
export const GetWarrantsJobsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetWarrantsJobs" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "financials_warrants_job_bool_exp" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: {
                  kind: "Name",
                  value: "financials_warrants_job_order_by",
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "financials_warrants_job" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "started_at" } },
                { kind: "Field", name: { kind: "Name", value: "ended_at" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                { kind: "Field", name: { kind: "Name", value: "deleted_at" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "financials_warrants_job_aggregate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWarrantsJobsQuery,
  GetWarrantsJobsQueryVariables
>
export const MeterpointsByIdsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MeterpointsByIds" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "meterpointIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "bigint" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meter_point" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_in" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "meterpointIds" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "identifier" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MeterpointsByIdsQuery,
  MeterpointsByIdsQueryVariables
>
export const GetAccountCreditByCoreIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAccountCreditByCoreId" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "coreId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "bigint" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "account_credit" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "billing_account_transaction",
                      },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "billing_account_id" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "_eq" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "coreId" },
                                  },
                                },
                              ],
                            },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "type" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "_eq" },
                                  value: {
                                    kind: "StringValue",
                                    value: "AccountCredit",
                                    block: false,
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account_credit_reason_name" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "created_user" },
                },
                { kind: "Field", name: { kind: "Name", value: "reference" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billing_account_transaction" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "billing_account_id" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accepted_at" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created_dttm" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reference" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAccountCreditByCoreIdQuery,
  GetAccountCreditByCoreIdQueryVariables
>
export const GetUsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUsers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "search" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "users_order_by" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "email" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_ilike" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "search" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "first_name" } },
                { kind: "Field", name: { kind: "Name", value: "locked" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sign_in_count" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "current_sign_in_ip" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer_user_rels" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customer_id" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "users_aggregate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "email" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_ilike" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "search" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUsersQuery, GetUsersQueryVariables>
export const GetMeterReadingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMeterReadings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "search" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" },
          },
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "meter_reading_submission_request_status_comparison_exp",
            },
          },
          defaultValue: {
            kind: "ObjectValue",
            fields: [
              {
                kind: "ObjectField",
                name: { kind: "Name", value: "_in" },
                value: {
                  kind: "ListValue",
                  values: [
                    { kind: "StringValue", value: "ERRORED", block: false },
                    {
                      kind: "StringValue",
                      value: "MANUAL_SUBMISSION",
                      block: false,
                    },
                    { kind: "StringValue", value: "CONTACTED", block: false },
                    {
                      kind: "StringValue",
                      value: "NO_ACTION_REQUIRED",
                      block: false,
                    },
                  ],
                },
              },
            ],
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "from" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "timestamp" },
          },
          defaultValue: {
            kind: "StringValue",
            value: "2024-01-01T00:00:00Z",
            block: false,
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "to" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "timestamp" },
          },
          defaultValue: { kind: "StringValue", value: "now()", block: false },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "errorCode" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "String_comparison_exp" },
          },
          defaultValue: { kind: "ObjectValue", fields: [] },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "nova_submissions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_and" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "status" },
                                value: {
                                  kind: "Variable",
                                  name: { kind: "Name", value: "status" },
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "created_at" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_gte" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "from" },
                                      },
                                    },
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_lt" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "to" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "error_code_1" },
                                value: {
                                  kind: "Variable",
                                  name: { kind: "Name", value: "errorCode" },
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "user_email" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "account_number" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "created_at" },
                      value: { kind: "EnumValue", value: "desc" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "submission_values" },
                },
                { kind: "Field", name: { kind: "Name", value: "user_email" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account_number" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meter_point_identifier" },
                },
                { kind: "Field", name: { kind: "Name", value: "debug_data" } },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nova_submissions_aggregate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_and" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "status" },
                                value: {
                                  kind: "Variable",
                                  name: { kind: "Name", value: "status" },
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "created_at" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_gte" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "from" },
                                      },
                                    },
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_lt" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "to" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "error_code_1" },
                                value: {
                                  kind: "Variable",
                                  name: { kind: "Name", value: "errorCode" },
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "user_email" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "account_number" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "search" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMeterReadingsQuery,
  GetMeterReadingsQueryVariables
>
export const GetLastMeterReadingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLastMeterReadings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "last_errored_submissions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "created_at" },
                      value: { kind: "EnumValue", value: "desc" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "submission_values" },
                },
                { kind: "Field", name: { kind: "Name", value: "user_email" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account_number" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meter_point_identifier" },
                },
                { kind: "Field", name: { kind: "Name", value: "debug_data" } },
                { kind: "Field", name: { kind: "Name", value: "comment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "last_errored_submissions_aggregate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetLastMeterReadingsQuery,
  GetLastMeterReadingsQueryVariables
>
export const GetMeterReadingsErrorsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMeterReadingsErrors" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "nova_submissions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "distinct_on" },
                value: { kind: "EnumValue", value: "error_code_1" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_and" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "error_code_1" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_is_null" },
                                      value: {
                                        kind: "BooleanValue",
                                        value: false,
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "error_code_1" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: {
                                        kind: "Name",
                                        value: "_nsimilar",
                                      },
                                      value: {
                                        kind: "StringValue",
                                        value: "(1|9)%",
                                        block: false,
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "error_code_1" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMeterReadingsErrorsQuery,
  GetMeterReadingsErrorsQueryVariables
>
export const GetAutoSyncedAccountsCountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAutoSyncedAccountsCount" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "synchronized_accounts_aggregate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAutoSyncedAccountsCountQuery,
  GetAutoSyncedAccountsCountQueryVariables
>
export const GetJuniferAccountsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetJuniferAccounts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "junifer__Account_bool_exp" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderBy" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "junifer__Account_order_by" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "accounts" },
            name: { kind: "Name", value: "junifer__Account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderBy" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "number" } },
                { kind: "Field", name: { kind: "Name", value: "fromDttm" } },
                { kind: "Field", name: { kind: "Name", value: "toDttm" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cancelledDttm" },
                },
                { kind: "Field", name: { kind: "Name", value: "closedDttm" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "terminatedDttm" },
                },
                { kind: "Field", name: { kind: "Name", value: "createdDttm" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "last_transaction" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accountBalance" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "synchronized_account" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locked" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billing_account" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "customer_user_rels",
                              },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "where" },
                                  value: {
                                    kind: "ObjectValue",
                                    fields: [
                                      {
                                        kind: "ObjectField",
                                        name: {
                                          kind: "Name",
                                          value: "deleted",
                                        },
                                        value: {
                                          kind: "ObjectValue",
                                          fields: [
                                            {
                                              kind: "ObjectField",
                                              name: {
                                                kind: "Name",
                                                value: "_is_null",
                                              },
                                              value: {
                                                kind: "BooleanValue",
                                                value: true,
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "user" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "email",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "total" },
            name: { kind: "Name", value: "junifer__Account_aggregate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aggregate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "count" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetJuniferAccountsQuery,
  GetJuniferAccountsQueryVariables
>
export const GetSyncedAccountsNumbersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSyncedAccountsNumbers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "where" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "billing_account_bool_exp" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "billing_account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "distinct_on" },
                value: { kind: "EnumValue", value: "number" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "where" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "n" },
                  name: { kind: "Name", value: "number" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSyncedAccountsNumbersQuery,
  GetSyncedAccountsNumbersQueryVariables
>
export const GetUserAccountNumbersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserAccountNumbers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "email" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_ilike" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "email" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "deleted" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_is_null" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: { kind: "IntValue", value: "1001" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "r" },
                  name: { kind: "Name", value: "customer_user_rels" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "where" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "deleted" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "_is_null" },
                                  value: { kind: "BooleanValue", value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "c" },
                        name: { kind: "Name", value: "customer" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "b" },
                              name: { kind: "Name", value: "billing_accounts" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "distinct_on" },
                                  value: { kind: "EnumValue", value: "number" },
                                },
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "where" },
                                  value: {
                                    kind: "ObjectValue",
                                    fields: [
                                      {
                                        kind: "ObjectField",
                                        name: {
                                          kind: "Name",
                                          value: "deleted",
                                        },
                                        value: {
                                          kind: "ObjectValue",
                                          fields: [
                                            {
                                              kind: "ObjectField",
                                              name: {
                                                kind: "Name",
                                                value: "_is_null",
                                              },
                                              value: {
                                                kind: "BooleanValue",
                                                value: true,
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    alias: { kind: "Name", value: "n" },
                                    name: { kind: "Name", value: "number" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserAccountNumbersQuery,
  GetUserAccountNumbersQueryVariables
>
export const GetMeterpointSupplyHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMeterpointSupplyHistory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "meterpointId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "bigint" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meter_point_history" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "meter_point_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "meterpointId" },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "deleted" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_is_null" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order_by" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "created_at" },
                      value: { kind: "EnumValue", value: "desc" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meter_point_id" },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "event_type" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                { kind: "Field", name: { kind: "Name", value: "deleted" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMeterpointSupplyHistoryQuery,
  GetMeterpointSupplyHistoryQueryVariables
>
export const SearchAccountsByMeterPointIdsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchAccountsByMeterPointIds" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "meterPointIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "Int" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "billing_account_ids_with_meter_point_ids",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "meter_points" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_contains" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "meterPointIds" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meter_points" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchAccountsByMeterPointIdsQuery,
  SearchAccountsByMeterPointIdsQueryVariables
>
export const SearchAccountsByPhoneOrEmailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchAccountsByPhoneOrEmail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "searchTerm" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          defaultValue: { kind: "IntValue", value: "100" },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "_or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "phone_number1" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: {
                                          kind: "Name",
                                          value: "searchTerm",
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "phone_number2" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: {
                                          kind: "Name",
                                          value: "searchTerm",
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "phone_number3" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: {
                                          kind: "Name",
                                          value: "searchTerm",
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "email" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "_ilike" },
                                      value: {
                                        kind: "Variable",
                                        name: {
                                          kind: "Name",
                                          value: "searchTerm",
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "phone_number1" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "phone_number2" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "phone_number3" },
                },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billing_account_contacts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "billing_account" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "number" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "customer_id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchAccountsByPhoneOrEmailQuery,
  SearchAccountsByPhoneOrEmailQueryVariables
>
export const SearchAccountsByPostcodeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchAccountsByPostcode" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "postcode" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          defaultValue: { kind: "IntValue", value: "100" },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "address" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "postcode" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "_ilike" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "postcode" },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postcode" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billing_account_contacts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "billing_account" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "number" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "customer_id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchAccountsByPostcodeQuery,
  SearchAccountsByPostcodeQueryVariables
>
export const SearchAccountsBySurnameDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchAccountsBySurname" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "surnamePattern" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          defaultValue: { kind: "IntValue", value: "100" },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "where" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "last_name" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "_ilike" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "surnamePattern" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "first_name" } },
                { kind: "Field", name: { kind: "Name", value: "last_name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "billing_accounts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customer_id" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchAccountsBySurnameQuery,
  SearchAccountsBySurnameQueryVariables
>
